"bundle";
System.registerDynamic('core-js/es/object/to-string.js', ['core-js/modules/es.json.to-string-tag.js', 'core-js/modules/es.math.to-string-tag.js', 'core-js/modules/es.object.to-string.js', 'core-js/modules/es.reflect.to-string-tag.js', 'core-js/internals/classof.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  $__require('core-js/modules/es.json.to-string-tag.js');
  $__require('core-js/modules/es.math.to-string-tag.js');
  $__require('core-js/modules/es.object.to-string.js');
  $__require('core-js/modules/es.reflect.to-string-tag.js');
  var classof = $__require('core-js/internals/classof.js');

  module.exports = function (it) {
    return '[object ' + classof(it) + ']';
  };
});
System.registerDynamic('core-js/es/array/concat.js', ['core-js/modules/es.array.concat.js', 'core-js/internals/entry-unbind.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  $__require('core-js/modules/es.array.concat.js');
  var entryUnbind = $__require('core-js/internals/entry-unbind.js');

  module.exports = entryUnbind('Array', 'concat');
});
System.registerDynamic('core-js/modules/es.array.filter.js', ['core-js/internals/export.js', 'core-js/internals/array-iteration.js', 'core-js/internals/array-method-has-species-support.js'], true, function ($__require, exports, module) {
  'use strict';

  var global = this || self,
      GLOBAL = global;
  var $ = $__require('core-js/internals/export.js');
  var $filter = $__require('core-js/internals/array-iteration.js').filter;
  var arrayMethodHasSpeciesSupport = $__require('core-js/internals/array-method-has-species-support.js');

  var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  // with adding support of @@species
  $({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
    filter: function filter(callbackfn /* , thisArg */) {
      return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
  });
});
System.registerDynamic('core-js/es/array/filter.js', ['core-js/modules/es.array.filter.js', 'core-js/internals/entry-unbind.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  $__require('core-js/modules/es.array.filter.js');
  var entryUnbind = $__require('core-js/internals/entry-unbind.js');

  module.exports = entryUnbind('Array', 'filter');
});
System.registerDynamic('core-js/modules/es.array.map.js', ['core-js/internals/export.js', 'core-js/internals/array-iteration.js', 'core-js/internals/array-method-has-species-support.js'], true, function ($__require, exports, module) {
  'use strict';

  var global = this || self,
      GLOBAL = global;
  var $ = $__require('core-js/internals/export.js');
  var $map = $__require('core-js/internals/array-iteration.js').map;
  var arrayMethodHasSpeciesSupport = $__require('core-js/internals/array-method-has-species-support.js');

  var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  // with adding support of @@species
  $({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
    map: function map(callbackfn /* , thisArg */) {
      return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
  });
});
System.registerDynamic('core-js/es/array/map.js', ['core-js/modules/es.array.map.js', 'core-js/internals/entry-unbind.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  $__require('core-js/modules/es.array.map.js');
  var entryUnbind = $__require('core-js/internals/entry-unbind.js');

  module.exports = entryUnbind('Array', 'map');
});
System.registerDynamic('core-js/modules/es.array.slice.js', ['core-js/internals/export.js', 'core-js/internals/is-object.js', 'core-js/internals/is-array.js', 'core-js/internals/to-absolute-index.js', 'core-js/internals/to-length.js', 'core-js/internals/to-indexed-object.js', 'core-js/internals/create-property.js', 'core-js/internals/well-known-symbol.js', 'core-js/internals/array-method-has-species-support.js'], true, function ($__require, exports, module) {
  'use strict';

  var global = this || self,
      GLOBAL = global;
  var $ = $__require('core-js/internals/export.js');
  var isObject = $__require('core-js/internals/is-object.js');
  var isArray = $__require('core-js/internals/is-array.js');
  var toAbsoluteIndex = $__require('core-js/internals/to-absolute-index.js');
  var toLength = $__require('core-js/internals/to-length.js');
  var toIndexedObject = $__require('core-js/internals/to-indexed-object.js');
  var createProperty = $__require('core-js/internals/create-property.js');
  var wellKnownSymbol = $__require('core-js/internals/well-known-symbol.js');
  var arrayMethodHasSpeciesSupport = $__require('core-js/internals/array-method-has-species-support.js');

  var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

  var SPECIES = wellKnownSymbol('species');
  var nativeSlice = [].slice;
  var max = Math.max;

  // `Array.prototype.slice` method
  // https://tc39.es/ecma262/#sec-array.prototype.slice
  // fallback for not array-like ES3 strings and DOM objects
  $({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
    slice: function slice(start, end) {
      var O = toIndexedObject(this);
      var length = toLength(O.length);
      var k = toAbsoluteIndex(start, length);
      var fin = toAbsoluteIndex(end === undefined ? length : end, length);
      // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
      var Constructor, result, n;
      if (isArray(O)) {
        Constructor = O.constructor;
        // cross-realm fallback
        if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
          Constructor = undefined;
        } else if (isObject(Constructor)) {
          Constructor = Constructor[SPECIES];
          if (Constructor === null) Constructor = undefined;
        }
        if (Constructor === Array || Constructor === undefined) {
          return nativeSlice.call(O, k, fin);
        }
      }
      result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
      for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
      result.length = n;
      return result;
    }
  });
});
System.registerDynamic('core-js/es/array/slice.js', ['core-js/modules/es.array.slice.js', 'core-js/internals/entry-unbind.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  $__require('core-js/modules/es.array.slice.js');
  var entryUnbind = $__require('core-js/internals/entry-unbind.js');

  module.exports = entryUnbind('Array', 'slice');
});
System.registerDynamic('core-js/modules/es.array.splice.js', ['core-js/internals/export.js', 'core-js/internals/to-absolute-index.js', 'core-js/internals/to-integer.js', 'core-js/internals/to-length.js', 'core-js/internals/to-object.js', 'core-js/internals/array-species-create.js', 'core-js/internals/create-property.js', 'core-js/internals/array-method-has-species-support.js'], true, function ($__require, exports, module) {
  'use strict';

  var global = this || self,
      GLOBAL = global;
  var $ = $__require('core-js/internals/export.js');
  var toAbsoluteIndex = $__require('core-js/internals/to-absolute-index.js');
  var toInteger = $__require('core-js/internals/to-integer.js');
  var toLength = $__require('core-js/internals/to-length.js');
  var toObject = $__require('core-js/internals/to-object.js');
  var arraySpeciesCreate = $__require('core-js/internals/array-species-create.js');
  var createProperty = $__require('core-js/internals/create-property.js');
  var arrayMethodHasSpeciesSupport = $__require('core-js/internals/array-method-has-species-support.js');

  var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');

  var max = Math.max;
  var min = Math.min;
  var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
  var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

  // `Array.prototype.splice` method
  // https://tc39.es/ecma262/#sec-array.prototype.splice
  // with adding support of @@species
  $({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
    splice: function splice(start, deleteCount /* , ...items */) {
      var O = toObject(this);
      var len = toLength(O.length);
      var actualStart = toAbsoluteIndex(start, len);
      var argumentsLength = arguments.length;
      var insertCount, actualDeleteCount, A, k, from, to;
      if (argumentsLength === 0) {
        insertCount = actualDeleteCount = 0;
      } else if (argumentsLength === 1) {
        insertCount = 0;
        actualDeleteCount = len - actualStart;
      } else {
        insertCount = argumentsLength - 2;
        actualDeleteCount = min(max(toInteger(deleteCount), 0), len - actualStart);
      }
      if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
        throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
      }
      A = arraySpeciesCreate(O, actualDeleteCount);
      for (k = 0; k < actualDeleteCount; k++) {
        from = actualStart + k;
        if (from in O) createProperty(A, k, O[from]);
      }
      A.length = actualDeleteCount;
      if (insertCount < actualDeleteCount) {
        for (k = actualStart; k < len - actualDeleteCount; k++) {
          from = k + actualDeleteCount;
          to = k + insertCount;
          if (from in O) O[to] = O[from];else delete O[to];
        }
        for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
      } else if (insertCount > actualDeleteCount) {
        for (k = len - actualDeleteCount; k > actualStart; k--) {
          from = k + actualDeleteCount - 1;
          to = k + insertCount - 1;
          if (from in O) O[to] = O[from];else delete O[to];
        }
      }
      for (k = 0; k < insertCount; k++) {
        O[k + actualStart] = arguments[k + 2];
      }
      O.length = len - actualDeleteCount + insertCount;
      return A;
    }
  });
});
System.registerDynamic('core-js/es/array/splice.js', ['core-js/modules/es.array.splice.js', 'core-js/internals/entry-unbind.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  $__require('core-js/modules/es.array.splice.js');
  var entryUnbind = $__require('core-js/internals/entry-unbind.js');

  module.exports = entryUnbind('Array', 'splice');
});
System.registerDynamic('core-js/es/symbol/for.js', ['core-js/modules/es.symbol.js', 'core-js/internals/path.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  $__require('core-js/modules/es.symbol.js');
  var path = $__require('core-js/internals/path.js');

  module.exports = path.Symbol['for'];
});
System.registerDynamic('core-js/internals/object-define-properties.js', ['core-js/internals/descriptors.js', 'core-js/internals/object-define-property.js', 'core-js/internals/an-object.js', 'core-js/internals/object-keys.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var DESCRIPTORS = $__require('core-js/internals/descriptors.js');
  var definePropertyModule = $__require('core-js/internals/object-define-property.js');
  var anObject = $__require('core-js/internals/an-object.js');
  var objectKeys = $__require('core-js/internals/object-keys.js');

  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
    anObject(O);
    var keys = objectKeys(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
    return O;
  };
});
System.registerDynamic('core-js/internals/html.js', ['core-js/internals/get-built-in.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var getBuiltIn = $__require('core-js/internals/get-built-in.js');

  module.exports = getBuiltIn('document', 'documentElement');
});
System.registerDynamic('core-js/internals/object-create.js', ['core-js/internals/an-object.js', 'core-js/internals/object-define-properties.js', 'core-js/internals/enum-bug-keys.js', 'core-js/internals/hidden-keys.js', 'core-js/internals/html.js', 'core-js/internals/document-create-element.js', 'core-js/internals/shared-key.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var anObject = $__require('core-js/internals/an-object.js');
  var defineProperties = $__require('core-js/internals/object-define-properties.js');
  var enumBugKeys = $__require('core-js/internals/enum-bug-keys.js');
  var hiddenKeys = $__require('core-js/internals/hidden-keys.js');
  var html = $__require('core-js/internals/html.js');
  var documentCreateElement = $__require('core-js/internals/document-create-element.js');
  var sharedKey = $__require('core-js/internals/shared-key.js');

  var GT = '>';
  var LT = '<';
  var PROTOTYPE = 'prototype';
  var SCRIPT = 'script';
  var IE_PROTO = sharedKey('IE_PROTO');

  var EmptyConstructor = function () {/* empty */};

  var scriptTag = function (content) {
    return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
  };

  // Create object with fake `null` prototype: use ActiveX Object with cleared prototype
  var NullProtoObjectViaActiveX = function (activeXDocument) {
    activeXDocument.write(scriptTag(''));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
  };

  // Create object with fake `null` prototype: use iframe Object with cleared prototype
  var NullProtoObjectViaIFrame = function () {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = documentCreateElement('iframe');
    var JS = 'java' + SCRIPT + ':';
    var iframeDocument;
    iframe.style.display = 'none';
    html.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(scriptTag('document.F=Object'));
    iframeDocument.close();
    return iframeDocument.F;
  };

  // Check for document.domain and active x support
  // No need to use active x approach when document.domain is not set
  // see https://github.com/es-shims/es5-shim/issues/150
  // variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
  // avoid IE GC bug
  var activeXDocument;
  var NullProtoObject = function () {
    try {
      /* global ActiveXObject -- old IE */
      activeXDocument = document.domain && new ActiveXObject('htmlfile');
    } catch (error) {/* ignore */}
    NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
    var length = enumBugKeys.length;
    while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
    return NullProtoObject();
  };

  hiddenKeys[IE_PROTO] = true;

  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
      EmptyConstructor[PROTOTYPE] = anObject(O);
      result = new EmptyConstructor();
      EmptyConstructor[PROTOTYPE] = null;
      // add "__proto__" for Object.getPrototypeOf polyfill
      result[IE_PROTO] = O;
    } else result = NullProtoObject();
    return Properties === undefined ? result : defineProperties(result, Properties);
  };
});
System.registerDynamic('core-js/internals/object-keys.js', ['core-js/internals/object-keys-internal.js', 'core-js/internals/enum-bug-keys.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var internalObjectKeys = $__require('core-js/internals/object-keys-internal.js');
  var enumBugKeys = $__require('core-js/internals/enum-bug-keys.js');

  // `Object.keys` method
  // https://tc39.es/ecma262/#sec-object.keys
  module.exports = Object.keys || function keys(O) {
    return internalObjectKeys(O, enumBugKeys);
  };
});
System.registerDynamic('core-js/internals/object-get-own-property-names-external.js', ['core-js/internals/to-indexed-object.js', 'core-js/internals/object-get-own-property-names.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var toIndexedObject = $__require('core-js/internals/to-indexed-object.js');
  var nativeGetOwnPropertyNames = $__require('core-js/internals/object-get-own-property-names.js').f;

  var toString = {}.toString;

  var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

  var getWindowNames = function (it) {
    try {
      return nativeGetOwnPropertyNames(it);
    } catch (error) {
      return windowNames.slice();
    }
  };

  // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
  module.exports.f = function getOwnPropertyNames(it) {
    return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : nativeGetOwnPropertyNames(toIndexedObject(it));
  };
});
System.registerDynamic('core-js/internals/array-iteration.js', ['core-js/internals/function-bind-context.js', 'core-js/internals/indexed-object.js', 'core-js/internals/to-object.js', 'core-js/internals/to-length.js', 'core-js/internals/array-species-create.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var bind = $__require('core-js/internals/function-bind-context.js');
  var IndexedObject = $__require('core-js/internals/indexed-object.js');
  var toObject = $__require('core-js/internals/to-object.js');
  var toLength = $__require('core-js/internals/to-length.js');
  var arraySpeciesCreate = $__require('core-js/internals/array-species-create.js');

  var push = [].push;

  // `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterOut }` methods implementation
  var createMethod = function (TYPE) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var IS_FILTER_OUT = TYPE == 7;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    return function ($this, callbackfn, that, specificCreate) {
      var O = toObject($this);
      var self = IndexedObject(O);
      var boundFunction = bind(callbackfn, that, 3);
      var length = toLength(self.length);
      var index = 0;
      var create = specificCreate || arraySpeciesCreate;
      var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_OUT ? create($this, 0) : undefined;
      var value, result;
      for (; length > index; index++) if (NO_HOLES || index in self) {
        value = self[index];
        result = boundFunction(value, index, O);
        if (TYPE) {
          if (IS_MAP) target[index] = result; // map
          else if (result) switch (TYPE) {
              case 3:
                return true; // some
              case 5:
                return value; // find
              case 6:
                return index; // findIndex
              case 2:
                push.call(target, value); // filter
            } else switch (TYPE) {
              case 4:
                return false; // every
              case 7:
                push.call(target, value); // filterOut
            }
        }
      }
      return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
  };

  module.exports = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: createMethod(6),
    // `Array.prototype.filterOut` method
    // https://github.com/tc39/proposal-array-filtering
    filterOut: createMethod(7)
  };
});
System.registerDynamic('core-js/modules/es.symbol.js', ['core-js/internals/export.js', 'core-js/internals/global.js', 'core-js/internals/get-built-in.js', 'core-js/internals/is-pure.js', 'core-js/internals/descriptors.js', 'core-js/internals/native-symbol.js', 'core-js/internals/use-symbol-as-uid.js', 'core-js/internals/fails.js', 'core-js/internals/has.js', 'core-js/internals/is-array.js', 'core-js/internals/is-object.js', 'core-js/internals/an-object.js', 'core-js/internals/to-object.js', 'core-js/internals/to-indexed-object.js', 'core-js/internals/to-primitive.js', 'core-js/internals/create-property-descriptor.js', 'core-js/internals/object-create.js', 'core-js/internals/object-keys.js', 'core-js/internals/object-get-own-property-names.js', 'core-js/internals/object-get-own-property-names-external.js', 'core-js/internals/object-get-own-property-symbols.js', 'core-js/internals/object-get-own-property-descriptor.js', 'core-js/internals/object-define-property.js', 'core-js/internals/object-property-is-enumerable.js', 'core-js/internals/create-non-enumerable-property.js', 'core-js/internals/redefine.js', 'core-js/internals/shared.js', 'core-js/internals/shared-key.js', 'core-js/internals/hidden-keys.js', 'core-js/internals/uid.js', 'core-js/internals/well-known-symbol.js', 'core-js/internals/well-known-symbol-wrapped.js', 'core-js/internals/define-well-known-symbol.js', 'core-js/internals/set-to-string-tag.js', 'core-js/internals/internal-state.js', 'core-js/internals/array-iteration.js'], true, function ($__require, exports, module) {
  'use strict';

  var global = this || self,
      GLOBAL = global;
  var $ = $__require('core-js/internals/export.js');
  var global = $__require('core-js/internals/global.js');
  var getBuiltIn = $__require('core-js/internals/get-built-in.js');
  var IS_PURE = $__require('core-js/internals/is-pure.js');
  var DESCRIPTORS = $__require('core-js/internals/descriptors.js');
  var NATIVE_SYMBOL = $__require('core-js/internals/native-symbol.js');
  var USE_SYMBOL_AS_UID = $__require('core-js/internals/use-symbol-as-uid.js');
  var fails = $__require('core-js/internals/fails.js');
  var has = $__require('core-js/internals/has.js');
  var isArray = $__require('core-js/internals/is-array.js');
  var isObject = $__require('core-js/internals/is-object.js');
  var anObject = $__require('core-js/internals/an-object.js');
  var toObject = $__require('core-js/internals/to-object.js');
  var toIndexedObject = $__require('core-js/internals/to-indexed-object.js');
  var toPrimitive = $__require('core-js/internals/to-primitive.js');
  var createPropertyDescriptor = $__require('core-js/internals/create-property-descriptor.js');
  var nativeObjectCreate = $__require('core-js/internals/object-create.js');
  var objectKeys = $__require('core-js/internals/object-keys.js');
  var getOwnPropertyNamesModule = $__require('core-js/internals/object-get-own-property-names.js');
  var getOwnPropertyNamesExternal = $__require('core-js/internals/object-get-own-property-names-external.js');
  var getOwnPropertySymbolsModule = $__require('core-js/internals/object-get-own-property-symbols.js');
  var getOwnPropertyDescriptorModule = $__require('core-js/internals/object-get-own-property-descriptor.js');
  var definePropertyModule = $__require('core-js/internals/object-define-property.js');
  var propertyIsEnumerableModule = $__require('core-js/internals/object-property-is-enumerable.js');
  var createNonEnumerableProperty = $__require('core-js/internals/create-non-enumerable-property.js');
  var redefine = $__require('core-js/internals/redefine.js');
  var shared = $__require('core-js/internals/shared.js');
  var sharedKey = $__require('core-js/internals/shared-key.js');
  var hiddenKeys = $__require('core-js/internals/hidden-keys.js');
  var uid = $__require('core-js/internals/uid.js');
  var wellKnownSymbol = $__require('core-js/internals/well-known-symbol.js');
  var wrappedWellKnownSymbolModule = $__require('core-js/internals/well-known-symbol-wrapped.js');
  var defineWellKnownSymbol = $__require('core-js/internals/define-well-known-symbol.js');
  var setToStringTag = $__require('core-js/internals/set-to-string-tag.js');
  var InternalStateModule = $__require('core-js/internals/internal-state.js');
  var $forEach = $__require('core-js/internals/array-iteration.js').forEach;

  var HIDDEN = sharedKey('hidden');
  var SYMBOL = 'Symbol';
  var PROTOTYPE = 'prototype';
  var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
  var setInternalState = InternalStateModule.set;
  var getInternalState = InternalStateModule.getterFor(SYMBOL);
  var ObjectPrototype = Object[PROTOTYPE];
  var $Symbol = global.Symbol;
  var $stringify = getBuiltIn('JSON', 'stringify');
  var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  var nativeDefineProperty = definePropertyModule.f;
  var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
  var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
  var AllSymbols = shared('symbols');
  var ObjectPrototypeSymbols = shared('op-symbols');
  var StringToSymbolRegistry = shared('string-to-symbol-registry');
  var SymbolToStringRegistry = shared('symbol-to-string-registry');
  var WellKnownSymbolsStore = shared('wks');
  var QObject = global.QObject;
  // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
  var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

  // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
  var setSymbolDescriptor = DESCRIPTORS && fails(function () {
    return nativeObjectCreate(nativeDefineProperty({}, 'a', {
      get: function () {
        return nativeDefineProperty(this, 'a', { value: 7 }).a;
      }
    })).a != 7;
  }) ? function (O, P, Attributes) {
    var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
    if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
    nativeDefineProperty(O, P, Attributes);
    if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
      nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
    }
  } : nativeDefineProperty;

  var wrap = function (tag, description) {
    var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
    setInternalState(symbol, {
      type: SYMBOL,
      tag: tag,
      description: description
    });
    if (!DESCRIPTORS) symbol.description = description;
    return symbol;
  };

  var isSymbol = USE_SYMBOL_AS_UID ? function (it) {
    return typeof it == 'symbol';
  } : function (it) {
    return Object(it) instanceof $Symbol;
  };

  var $defineProperty = function defineProperty(O, P, Attributes) {
    if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
    anObject(O);
    var key = toPrimitive(P, true);
    anObject(Attributes);
    if (has(AllSymbols, key)) {
      if (!Attributes.enumerable) {
        if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
        O[HIDDEN][key] = true;
      } else {
        if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
        Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
      }return setSymbolDescriptor(O, key, Attributes);
    }return nativeDefineProperty(O, key, Attributes);
  };

  var $defineProperties = function defineProperties(O, Properties) {
    anObject(O);
    var properties = toIndexedObject(Properties);
    var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
    $forEach(keys, function (key) {
      if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
    });
    return O;
  };

  var $create = function create(O, Properties) {
    return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
  };

  var $propertyIsEnumerable = function propertyIsEnumerable(V) {
    var P = toPrimitive(V, true);
    var enumerable = nativePropertyIsEnumerable.call(this, P);
    if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
    return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
  };

  var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
    var it = toIndexedObject(O);
    var key = toPrimitive(P, true);
    if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
    var descriptor = nativeGetOwnPropertyDescriptor(it, key);
    if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
      descriptor.enumerable = true;
    }
    return descriptor;
  };

  var $getOwnPropertyNames = function getOwnPropertyNames(O) {
    var names = nativeGetOwnPropertyNames(toIndexedObject(O));
    var result = [];
    $forEach(names, function (key) {
      if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
    });
    return result;
  };

  var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
    var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
    var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
    var result = [];
    $forEach(names, function (key) {
      if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
        result.push(AllSymbols[key]);
      }
    });
    return result;
  };

  // `Symbol` constructor
  // https://tc39.es/ecma262/#sec-symbol-constructor
  if (!NATIVE_SYMBOL) {
    $Symbol = function Symbol() {
      if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
      var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
      var tag = uid(description);
      var setter = function (value) {
        if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
        if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
        setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
      };
      if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
      return wrap(tag, description);
    };

    redefine($Symbol[PROTOTYPE], 'toString', function toString() {
      return getInternalState(this).tag;
    });

    redefine($Symbol, 'withoutSetter', function (description) {
      return wrap(uid(description), description);
    });

    propertyIsEnumerableModule.f = $propertyIsEnumerable;
    definePropertyModule.f = $defineProperty;
    getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
    getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
    getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

    wrappedWellKnownSymbolModule.f = function (name) {
      return wrap(wellKnownSymbol(name), name);
    };

    if (DESCRIPTORS) {
      // https://github.com/tc39/proposal-Symbol-description
      nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
        configurable: true,
        get: function description() {
          return getInternalState(this).description;
        }
      });
      if (!IS_PURE) {
        redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
      }
    }
  }

  $({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
    Symbol: $Symbol
  });

  $forEach(objectKeys(WellKnownSymbolsStore), function (name) {
    defineWellKnownSymbol(name);
  });

  $({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
    // `Symbol.for` method
    // https://tc39.es/ecma262/#sec-symbol.for
    'for': function (key) {
      var string = String(key);
      if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
      var symbol = $Symbol(string);
      StringToSymbolRegistry[string] = symbol;
      SymbolToStringRegistry[symbol] = string;
      return symbol;
    },
    // `Symbol.keyFor` method
    // https://tc39.es/ecma262/#sec-symbol.keyfor
    keyFor: function keyFor(sym) {
      if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
      if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
    },
    useSetter: function () {
      USE_SETTER = true;
    },
    useSimple: function () {
      USE_SETTER = false;
    }
  });

  $({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
    // `Object.create` method
    // https://tc39.es/ecma262/#sec-object.create
    create: $create,
    // `Object.defineProperty` method
    // https://tc39.es/ecma262/#sec-object.defineproperty
    defineProperty: $defineProperty,
    // `Object.defineProperties` method
    // https://tc39.es/ecma262/#sec-object.defineproperties
    defineProperties: $defineProperties,
    // `Object.getOwnPropertyDescriptor` method
    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
    getOwnPropertyDescriptor: $getOwnPropertyDescriptor
  });

  $({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
    // `Object.getOwnPropertyNames` method
    // https://tc39.es/ecma262/#sec-object.getownpropertynames
    getOwnPropertyNames: $getOwnPropertyNames,
    // `Object.getOwnPropertySymbols` method
    // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
    getOwnPropertySymbols: $getOwnPropertySymbols
  });

  // Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
  // https://bugs.chromium.org/p/v8/issues/detail?id=3443
  $({ target: 'Object', stat: true, forced: fails(function () {
      getOwnPropertySymbolsModule.f(1);
    }) }, {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
      return getOwnPropertySymbolsModule.f(toObject(it));
    }
  });

  // `JSON.stringify` method behavior with symbols
  // https://tc39.es/ecma262/#sec-json.stringify
  if ($stringify) {
    var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
      var symbol = $Symbol();
      // MS Edge converts symbol values to JSON as {}
      return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
    });

    $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
      // eslint-disable-next-line no-unused-vars -- required for `.length`
      stringify: function stringify(it, replacer, space) {
        var args = [it];
        var index = 1;
        var $replacer;
        while (arguments.length > index) args.push(arguments[index++]);
        $replacer = replacer;
        if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
        if (!isArray(replacer)) replacer = function (key, value) {
          if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
          if (!isSymbol(value)) return value;
        };
        args[1] = replacer;
        return $stringify.apply(null, args);
      }
    });
  }

  // `Symbol.prototype[@@toPrimitive]` method
  // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
  if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
    createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
  }
  // `Symbol.prototype[@@toStringTag]` property
  // https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
  setToStringTag($Symbol, SYMBOL);

  hiddenKeys[HIDDEN] = true;
});
System.registerDynamic('core-js/es/symbol/key-for.js', ['core-js/modules/es.symbol.js', 'core-js/internals/path.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  $__require('core-js/modules/es.symbol.js');
  var path = $__require('core-js/internals/path.js');

  module.exports = path.Symbol.keyFor;
});
System.registerDynamic("ts-polyfill/lib/es2015-symbol.js", ["core-js/es/object/to-string.js", "core-js/es/array/concat.js", "core-js/es/array/filter.js", "core-js/es/array/map.js", "core-js/es/array/slice.js", "core-js/es/array/splice.js", "core-js/modules/es.symbol.js", "core-js/es/symbol/for.js", "core-js/es/symbol/key-for.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  $__require("core-js/es/object/to-string.js");
  $__require("core-js/es/array/concat.js");
  $__require("core-js/es/array/filter.js");
  $__require("core-js/es/array/map.js");
  $__require("core-js/es/array/slice.js");
  $__require("core-js/es/array/splice.js");
  $__require("core-js/modules/es.symbol.js");
  $__require("core-js/es/symbol/for.js");
  $__require("core-js/es/symbol/key-for.js");
});
System.registerDynamic('core-js/modules/es.symbol.has-instance.js', ['core-js/internals/define-well-known-symbol.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var defineWellKnownSymbol = $__require('core-js/internals/define-well-known-symbol.js');

  // `Symbol.hasInstance` well-known symbol
  // https://tc39.es/ecma262/#sec-symbol.hasinstance
  defineWellKnownSymbol('hasInstance');
});
System.registerDynamic('core-js/es/symbol/has-instance.js', ['core-js/modules/es.symbol.has-instance.js', 'core-js/modules/es.function.has-instance.js', 'core-js/internals/well-known-symbol-wrapped.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  $__require('core-js/modules/es.symbol.has-instance.js');
  $__require('core-js/modules/es.function.has-instance.js');
  var WrappedWellKnownSymbolModule = $__require('core-js/internals/well-known-symbol-wrapped.js');

  module.exports = WrappedWellKnownSymbolModule.f('hasInstance');
});
System.registerDynamic('core-js/modules/es.symbol.is-concat-spreadable.js', ['core-js/internals/define-well-known-symbol.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var defineWellKnownSymbol = $__require('core-js/internals/define-well-known-symbol.js');

  // `Symbol.isConcatSpreadable` well-known symbol
  // https://tc39.es/ecma262/#sec-symbol.isconcatspreadable
  defineWellKnownSymbol('isConcatSpreadable');
});
System.registerDynamic('core-js/internals/create-property.js', ['core-js/internals/to-primitive.js', 'core-js/internals/object-define-property.js', 'core-js/internals/create-property-descriptor.js'], true, function ($__require, exports, module) {
  'use strict';

  var global = this || self,
      GLOBAL = global;
  var toPrimitive = $__require('core-js/internals/to-primitive.js');
  var definePropertyModule = $__require('core-js/internals/object-define-property.js');
  var createPropertyDescriptor = $__require('core-js/internals/create-property-descriptor.js');

  module.exports = function (object, key, value) {
    var propertyKey = toPrimitive(key);
    if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));else object[propertyKey] = value;
  };
});
System.registerDynamic('core-js/internals/is-array.js', ['core-js/internals/classof-raw.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var classof = $__require('core-js/internals/classof-raw.js');

  // `IsArray` abstract operation
  // https://tc39.es/ecma262/#sec-isarray
  module.exports = Array.isArray || function isArray(arg) {
    return classof(arg) == 'Array';
  };
});
System.registerDynamic('core-js/internals/array-species-create.js', ['core-js/internals/is-object.js', 'core-js/internals/is-array.js', 'core-js/internals/well-known-symbol.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var isObject = $__require('core-js/internals/is-object.js');
  var isArray = $__require('core-js/internals/is-array.js');
  var wellKnownSymbol = $__require('core-js/internals/well-known-symbol.js');

  var SPECIES = wellKnownSymbol('species');

  // `ArraySpeciesCreate` abstract operation
  // https://tc39.es/ecma262/#sec-arrayspeciescreate
  module.exports = function (originalArray, length) {
    var C;
    if (isArray(originalArray)) {
      C = originalArray.constructor;
      // cross-realm fallback
      if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;else if (isObject(C)) {
        C = C[SPECIES];
        if (C === null) C = undefined;
      }
    }return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
  };
});
System.registerDynamic('core-js/internals/array-method-has-species-support.js', ['core-js/internals/fails.js', 'core-js/internals/well-known-symbol.js', 'core-js/internals/engine-v8-version.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var fails = $__require('core-js/internals/fails.js');
  var wellKnownSymbol = $__require('core-js/internals/well-known-symbol.js');
  var V8_VERSION = $__require('core-js/internals/engine-v8-version.js');

  var SPECIES = wellKnownSymbol('species');

  module.exports = function (METHOD_NAME) {
    // We can't use this feature detection in V8 since it causes
    // deoptimization and serious performance degradation
    // https://github.com/zloirock/core-js/issues/677
    return V8_VERSION >= 51 || !fails(function () {
      var array = [];
      var constructor = array.constructor = {};
      constructor[SPECIES] = function () {
        return { foo: 1 };
      };
      return array[METHOD_NAME](Boolean).foo !== 1;
    });
  };
});
System.registerDynamic('core-js/modules/es.array.concat.js', ['core-js/internals/export.js', 'core-js/internals/fails.js', 'core-js/internals/is-array.js', 'core-js/internals/is-object.js', 'core-js/internals/to-object.js', 'core-js/internals/to-length.js', 'core-js/internals/create-property.js', 'core-js/internals/array-species-create.js', 'core-js/internals/array-method-has-species-support.js', 'core-js/internals/well-known-symbol.js', 'core-js/internals/engine-v8-version.js'], true, function ($__require, exports, module) {
  'use strict';

  var global = this || self,
      GLOBAL = global;
  var $ = $__require('core-js/internals/export.js');
  var fails = $__require('core-js/internals/fails.js');
  var isArray = $__require('core-js/internals/is-array.js');
  var isObject = $__require('core-js/internals/is-object.js');
  var toObject = $__require('core-js/internals/to-object.js');
  var toLength = $__require('core-js/internals/to-length.js');
  var createProperty = $__require('core-js/internals/create-property.js');
  var arraySpeciesCreate = $__require('core-js/internals/array-species-create.js');
  var arrayMethodHasSpeciesSupport = $__require('core-js/internals/array-method-has-species-support.js');
  var wellKnownSymbol = $__require('core-js/internals/well-known-symbol.js');
  var V8_VERSION = $__require('core-js/internals/engine-v8-version.js');

  var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
  var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
  var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/679
  var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
    var array = [];
    array[IS_CONCAT_SPREADABLE] = false;
    return array.concat()[0] !== array;
  });

  var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

  var isConcatSpreadable = function (O) {
    if (!isObject(O)) return false;
    var spreadable = O[IS_CONCAT_SPREADABLE];
    return spreadable !== undefined ? !!spreadable : isArray(O);
  };

  var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

  // `Array.prototype.concat` method
  // https://tc39.es/ecma262/#sec-array.prototype.concat
  // with adding support of @@isConcatSpreadable and @@species
  $({ target: 'Array', proto: true, forced: FORCED }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    concat: function concat(arg) {
      var O = toObject(this);
      var A = arraySpeciesCreate(O, 0);
      var n = 0;
      var i, k, length, len, E;
      for (i = -1, length = arguments.length; i < length; i++) {
        E = i === -1 ? O : arguments[i];
        if (isConcatSpreadable(E)) {
          len = toLength(E.length);
          if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
          for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
        } else {
          if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
          createProperty(A, n++, E);
        }
      }
      A.length = n;
      return A;
    }
  });
});
System.registerDynamic('core-js/es/symbol/is-concat-spreadable.js', ['core-js/modules/es.symbol.is-concat-spreadable.js', 'core-js/modules/es.array.concat.js', 'core-js/internals/well-known-symbol-wrapped.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  $__require('core-js/modules/es.symbol.is-concat-spreadable.js');
  $__require('core-js/modules/es.array.concat.js');
  var WrappedWellKnownSymbolModule = $__require('core-js/internals/well-known-symbol-wrapped.js');

  module.exports = WrappedWellKnownSymbolModule.f('isConcatSpreadable');
});
System.registerDynamic('core-js/modules/es.symbol.match.js', ['core-js/internals/define-well-known-symbol.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var defineWellKnownSymbol = $__require('core-js/internals/define-well-known-symbol.js');

  // `Symbol.match` well-known symbol
  // https://tc39.es/ecma262/#sec-symbol.match
  defineWellKnownSymbol('match');
});
System.registerDynamic('core-js/es/symbol/match.js', ['core-js/modules/es.symbol.match.js', 'core-js/modules/es.string.match.js', 'core-js/internals/well-known-symbol-wrapped.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  $__require('core-js/modules/es.symbol.match.js');
  $__require('core-js/modules/es.string.match.js');
  var WrappedWellKnownSymbolModule = $__require('core-js/internals/well-known-symbol-wrapped.js');

  module.exports = WrappedWellKnownSymbolModule.f('match');
});
System.registerDynamic('core-js/modules/es.symbol.replace.js', ['core-js/internals/define-well-known-symbol.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var defineWellKnownSymbol = $__require('core-js/internals/define-well-known-symbol.js');

  // `Symbol.replace` well-known symbol
  // https://tc39.es/ecma262/#sec-symbol.replace
  defineWellKnownSymbol('replace');
});
System.registerDynamic('core-js/es/symbol/replace.js', ['core-js/modules/es.symbol.replace.js', 'core-js/modules/es.string.replace.js', 'core-js/internals/well-known-symbol-wrapped.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  $__require('core-js/modules/es.symbol.replace.js');
  $__require('core-js/modules/es.string.replace.js');
  var WrappedWellKnownSymbolModule = $__require('core-js/internals/well-known-symbol-wrapped.js');

  module.exports = WrappedWellKnownSymbolModule.f('replace');
});
System.registerDynamic('core-js/modules/es.symbol.search.js', ['core-js/internals/define-well-known-symbol.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var defineWellKnownSymbol = $__require('core-js/internals/define-well-known-symbol.js');

  // `Symbol.search` well-known symbol
  // https://tc39.es/ecma262/#sec-symbol.search
  defineWellKnownSymbol('search');
});
System.registerDynamic('core-js/es/symbol/search.js', ['core-js/modules/es.symbol.search.js', 'core-js/modules/es.string.search.js', 'core-js/internals/well-known-symbol-wrapped.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  $__require('core-js/modules/es.symbol.search.js');
  $__require('core-js/modules/es.string.search.js');
  var WrappedWellKnownSymbolModule = $__require('core-js/internals/well-known-symbol-wrapped.js');

  module.exports = WrappedWellKnownSymbolModule.f('search');
});
System.registerDynamic('core-js/modules/es.symbol.species.js', ['core-js/internals/define-well-known-symbol.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var defineWellKnownSymbol = $__require('core-js/internals/define-well-known-symbol.js');

  // `Symbol.species` well-known symbol
  // https://tc39.es/ecma262/#sec-symbol.species
  defineWellKnownSymbol('species');
});
System.registerDynamic('core-js/es/symbol/species.js', ['core-js/modules/es.symbol.species.js', 'core-js/internals/well-known-symbol-wrapped.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  $__require('core-js/modules/es.symbol.species.js');
  var WrappedWellKnownSymbolModule = $__require('core-js/internals/well-known-symbol-wrapped.js');

  module.exports = WrappedWellKnownSymbolModule.f('species');
});
System.registerDynamic('core-js/modules/es.symbol.split.js', ['core-js/internals/define-well-known-symbol.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var defineWellKnownSymbol = $__require('core-js/internals/define-well-known-symbol.js');

  // `Symbol.split` well-known symbol
  // https://tc39.es/ecma262/#sec-symbol.split
  defineWellKnownSymbol('split');
});
System.registerDynamic('core-js/es/symbol/split.js', ['core-js/modules/es.symbol.split.js', 'core-js/modules/es.string.split.js', 'core-js/internals/well-known-symbol-wrapped.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  $__require('core-js/modules/es.symbol.split.js');
  $__require('core-js/modules/es.string.split.js');
  var WrappedWellKnownSymbolModule = $__require('core-js/internals/well-known-symbol-wrapped.js');

  module.exports = WrappedWellKnownSymbolModule.f('split');
});
System.registerDynamic('core-js/modules/es.symbol.to-primitive.js', ['core-js/internals/define-well-known-symbol.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var defineWellKnownSymbol = $__require('core-js/internals/define-well-known-symbol.js');

  // `Symbol.toPrimitive` well-known symbol
  // https://tc39.es/ecma262/#sec-symbol.toprimitive
  defineWellKnownSymbol('toPrimitive');
});
System.registerDynamic('core-js/es/symbol/to-primitive.js', ['core-js/modules/es.symbol.to-primitive.js', 'core-js/internals/well-known-symbol-wrapped.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  $__require('core-js/modules/es.symbol.to-primitive.js');
  var WrappedWellKnownSymbolModule = $__require('core-js/internals/well-known-symbol-wrapped.js');

  module.exports = WrappedWellKnownSymbolModule.f('toPrimitive');
});
System.registerDynamic('core-js/modules/es.symbol.to-string-tag.js', ['core-js/internals/define-well-known-symbol.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var defineWellKnownSymbol = $__require('core-js/internals/define-well-known-symbol.js');

  // `Symbol.toStringTag` well-known symbol
  // https://tc39.es/ecma262/#sec-symbol.tostringtag
  defineWellKnownSymbol('toStringTag');
});
System.registerDynamic('core-js/internals/to-string-tag-support.js', ['core-js/internals/well-known-symbol.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var wellKnownSymbol = $__require('core-js/internals/well-known-symbol.js');

  var TO_STRING_TAG = wellKnownSymbol('toStringTag');
  var test = {};

  test[TO_STRING_TAG] = 'z';

  module.exports = String(test) === '[object z]';
});
System.registerDynamic('core-js/internals/classof.js', ['core-js/internals/to-string-tag-support.js', 'core-js/internals/classof-raw.js', 'core-js/internals/well-known-symbol.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var TO_STRING_TAG_SUPPORT = $__require('core-js/internals/to-string-tag-support.js');
  var classofRaw = $__require('core-js/internals/classof-raw.js');
  var wellKnownSymbol = $__require('core-js/internals/well-known-symbol.js');

  var TO_STRING_TAG = wellKnownSymbol('toStringTag');
  // ES3 wrong here
  var CORRECT_ARGUMENTS = classofRaw(function () {
    return arguments;
  }()) == 'Arguments';

  // fallback for IE11 Script Access Denied error
  var tryGet = function (it, key) {
    try {
      return it[key];
    } catch (error) {/* empty */}
  };

  // getting tag from ES6+ `Object.prototype.toString`
  module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
    var O, tag, result;
    return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
  };
});
System.registerDynamic('core-js/internals/object-to-string.js', ['core-js/internals/to-string-tag-support.js', 'core-js/internals/classof.js'], true, function ($__require, exports, module) {
  'use strict';

  var global = this || self,
      GLOBAL = global;
  var TO_STRING_TAG_SUPPORT = $__require('core-js/internals/to-string-tag-support.js');
  var classof = $__require('core-js/internals/classof.js');

  // `Object.prototype.toString` method implementation
  // https://tc39.es/ecma262/#sec-object.prototype.tostring
  module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
    return '[object ' + classof(this) + ']';
  };
});
System.registerDynamic('core-js/modules/es.object.to-string.js', ['core-js/internals/to-string-tag-support.js', 'core-js/internals/redefine.js', 'core-js/internals/object-to-string.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var TO_STRING_TAG_SUPPORT = $__require('core-js/internals/to-string-tag-support.js');
  var redefine = $__require('core-js/internals/redefine.js');
  var toString = $__require('core-js/internals/object-to-string.js');

  // `Object.prototype.toString` method
  // https://tc39.es/ecma262/#sec-object.prototype.tostring
  if (!TO_STRING_TAG_SUPPORT) {
    redefine(Object.prototype, 'toString', toString, { unsafe: true });
  }
});
System.registerDynamic('core-js/modules/es.reflect.to-string-tag.js', ['core-js/internals/export.js', 'core-js/internals/global.js', 'core-js/internals/set-to-string-tag.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var $ = $__require('core-js/internals/export.js');
  var global = $__require('core-js/internals/global.js');
  var setToStringTag = $__require('core-js/internals/set-to-string-tag.js');

  $({ global: true }, { Reflect: {} });

  // Reflect[@@toStringTag] property
  // https://tc39.es/ecma262/#sec-reflect-@@tostringtag
  setToStringTag(global.Reflect, 'Reflect', true);
});
System.registerDynamic('core-js/es/symbol/to-string-tag.js', ['core-js/modules/es.symbol.to-string-tag.js', 'core-js/modules/es.object.to-string.js', 'core-js/modules/es.json.to-string-tag.js', 'core-js/modules/es.math.to-string-tag.js', 'core-js/modules/es.reflect.to-string-tag.js', 'core-js/internals/well-known-symbol-wrapped.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  $__require('core-js/modules/es.symbol.to-string-tag.js');
  $__require('core-js/modules/es.object.to-string.js');
  $__require('core-js/modules/es.json.to-string-tag.js');
  $__require('core-js/modules/es.math.to-string-tag.js');
  $__require('core-js/modules/es.reflect.to-string-tag.js');
  var WrappedWellKnownSymbolModule = $__require('core-js/internals/well-known-symbol-wrapped.js');

  module.exports = WrappedWellKnownSymbolModule.f('toStringTag');
});
System.registerDynamic('core-js/modules/es.json.to-string-tag.js', ['core-js/internals/global.js', 'core-js/internals/set-to-string-tag.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var global = $__require('core-js/internals/global.js');
  var setToStringTag = $__require('core-js/internals/set-to-string-tag.js');

  // JSON[@@toStringTag] property
  // https://tc39.es/ecma262/#sec-json-@@tostringtag
  setToStringTag(global.JSON, 'JSON', true);
});
System.registerDynamic('core-js/es/json/to-string-tag.js', ['core-js/modules/es.json.to-string-tag.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  $__require('core-js/modules/es.json.to-string-tag.js');

  module.exports = 'JSON';
});
System.registerDynamic('core-js/internals/define-well-known-symbol.js', ['core-js/internals/path.js', 'core-js/internals/has.js', 'core-js/internals/well-known-symbol-wrapped.js', 'core-js/internals/object-define-property.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var path = $__require('core-js/internals/path.js');
  var has = $__require('core-js/internals/has.js');
  var wrappedWellKnownSymbolModule = $__require('core-js/internals/well-known-symbol-wrapped.js');
  var defineProperty = $__require('core-js/internals/object-define-property.js').f;

  module.exports = function (NAME) {
    var Symbol = path.Symbol || (path.Symbol = {});
    if (!has(Symbol, NAME)) defineProperty(Symbol, NAME, {
      value: wrappedWellKnownSymbolModule.f(NAME)
    });
  };
});
System.registerDynamic('core-js/modules/es.symbol.unscopables.js', ['core-js/internals/define-well-known-symbol.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var defineWellKnownSymbol = $__require('core-js/internals/define-well-known-symbol.js');

  // `Symbol.unscopables` well-known symbol
  // https://tc39.es/ecma262/#sec-symbol.unscopables
  defineWellKnownSymbol('unscopables');
});
System.registerDynamic('core-js/internals/well-known-symbol-wrapped.js', ['core-js/internals/well-known-symbol.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var wellKnownSymbol = $__require('core-js/internals/well-known-symbol.js');

  exports.f = wellKnownSymbol;
});
System.registerDynamic('core-js/es/symbol/unscopables.js', ['core-js/modules/es.symbol.unscopables.js', 'core-js/internals/well-known-symbol-wrapped.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  $__require('core-js/modules/es.symbol.unscopables.js');
  var WrappedWellKnownSymbolModule = $__require('core-js/internals/well-known-symbol-wrapped.js');

  module.exports = WrappedWellKnownSymbolModule.f('unscopables');
});
System.registerDynamic('core-js/modules/es.date.to-primitive.js', ['core-js/internals/create-non-enumerable-property.js', 'core-js/internals/date-to-primitive.js', 'core-js/internals/well-known-symbol.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var createNonEnumerableProperty = $__require('core-js/internals/create-non-enumerable-property.js');
  var dateToPrimitive = $__require('core-js/internals/date-to-primitive.js');
  var wellKnownSymbol = $__require('core-js/internals/well-known-symbol.js');

  var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
  var DatePrototype = Date.prototype;

  // `Date.prototype[@@toPrimitive]` method
  // https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
  if (!(TO_PRIMITIVE in DatePrototype)) {
    createNonEnumerableProperty(DatePrototype, TO_PRIMITIVE, dateToPrimitive);
  }
});
System.registerDynamic('core-js/internals/date-to-primitive.js', ['core-js/internals/an-object.js', 'core-js/internals/to-primitive.js'], true, function ($__require, exports, module) {
  'use strict';

  var global = this || self,
      GLOBAL = global;
  var anObject = $__require('core-js/internals/an-object.js');
  var toPrimitive = $__require('core-js/internals/to-primitive.js');

  module.exports = function (hint) {
    if (hint !== 'string' && hint !== 'number' && hint !== 'default') {
      throw TypeError('Incorrect hint');
    }return toPrimitive(anObject(this), hint !== 'number');
  };
});
System.registerDynamic('core-js/es/date/to-primitive.js', ['core-js/modules/es.date.to-primitive.js', 'core-js/internals/date-to-primitive.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  $__require('core-js/modules/es.date.to-primitive.js');
  var toPrimitive = $__require('core-js/internals/date-to-primitive.js');

  module.exports = function (it, hint) {
    return toPrimitive.call(it, hint);
  };
});
System.registerDynamic('core-js/internals/correct-prototype-getter.js', ['core-js/internals/fails.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var fails = $__require('core-js/internals/fails.js');

  module.exports = !fails(function () {
    function F() {/* empty */}
    F.prototype.constructor = null;
    return Object.getPrototypeOf(new F()) !== F.prototype;
  });
});
System.registerDynamic('core-js/internals/object-get-prototype-of.js', ['core-js/internals/has.js', 'core-js/internals/to-object.js', 'core-js/internals/shared-key.js', 'core-js/internals/correct-prototype-getter.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var has = $__require('core-js/internals/has.js');
  var toObject = $__require('core-js/internals/to-object.js');
  var sharedKey = $__require('core-js/internals/shared-key.js');
  var CORRECT_PROTOTYPE_GETTER = $__require('core-js/internals/correct-prototype-getter.js');

  var IE_PROTO = sharedKey('IE_PROTO');
  var ObjectPrototype = Object.prototype;

  // `Object.getPrototypeOf` method
  // https://tc39.es/ecma262/#sec-object.getprototypeof
  module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
    O = toObject(O);
    if (has(O, IE_PROTO)) return O[IE_PROTO];
    if (typeof O.constructor == 'function' && O instanceof O.constructor) {
      return O.constructor.prototype;
    }return O instanceof Object ? ObjectPrototype : null;
  };
});
System.registerDynamic('core-js/modules/es.function.has-instance.js', ['core-js/internals/is-object.js', 'core-js/internals/object-define-property.js', 'core-js/internals/object-get-prototype-of.js', 'core-js/internals/well-known-symbol.js'], true, function ($__require, exports, module) {
  'use strict';

  var global = this || self,
      GLOBAL = global;
  var isObject = $__require('core-js/internals/is-object.js');
  var definePropertyModule = $__require('core-js/internals/object-define-property.js');
  var getPrototypeOf = $__require('core-js/internals/object-get-prototype-of.js');
  var wellKnownSymbol = $__require('core-js/internals/well-known-symbol.js');

  var HAS_INSTANCE = wellKnownSymbol('hasInstance');
  var FunctionPrototype = Function.prototype;

  // `Function.prototype[@@hasInstance]` method
  // https://tc39.es/ecma262/#sec-function.prototype-@@hasinstance
  if (!(HAS_INSTANCE in FunctionPrototype)) {
    definePropertyModule.f(FunctionPrototype, HAS_INSTANCE, { value: function (O) {
        if (typeof this != 'function' || !isObject(O)) return false;
        if (!isObject(this.prototype)) return O instanceof this;
        // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
        while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
        return false;
      } });
  }
});
System.registerDynamic('core-js/es/function/has-instance.js', ['core-js/modules/es.function.has-instance.js', 'core-js/internals/well-known-symbol.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  $__require('core-js/modules/es.function.has-instance.js');
  var wellKnownSymbol = $__require('core-js/internals/well-known-symbol.js');

  module.exports = Function[wellKnownSymbol('hasInstance')];
});
System.registerDynamic('core-js/internals/set-to-string-tag.js', ['core-js/internals/object-define-property.js', 'core-js/internals/has.js', 'core-js/internals/well-known-symbol.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var defineProperty = $__require('core-js/internals/object-define-property.js').f;
  var has = $__require('core-js/internals/has.js');
  var wellKnownSymbol = $__require('core-js/internals/well-known-symbol.js');

  var TO_STRING_TAG = wellKnownSymbol('toStringTag');

  module.exports = function (it, TAG, STATIC) {
    if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
      defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
    }
  };
});
System.registerDynamic('core-js/modules/es.math.to-string-tag.js', ['core-js/internals/set-to-string-tag.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var setToStringTag = $__require('core-js/internals/set-to-string-tag.js');

  // Math[@@toStringTag] property
  // https://tc39.es/ecma262/#sec-math-@@tostringtag
  setToStringTag(Math, 'Math', true);
});
System.registerDynamic('core-js/es/math/to-string-tag.js', ['core-js/modules/es.math.to-string-tag.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  $__require('core-js/modules/es.math.to-string-tag.js');

  module.exports = 'Math';
});
System.registerDynamic('core-js/modules/es.string.match.js', ['core-js/internals/fix-regexp-well-known-symbol-logic.js', 'core-js/internals/an-object.js', 'core-js/internals/to-length.js', 'core-js/internals/require-object-coercible.js', 'core-js/internals/advance-string-index.js', 'core-js/internals/regexp-exec-abstract.js'], true, function ($__require, exports, module) {
  'use strict';

  var global = this || self,
      GLOBAL = global;
  var fixRegExpWellKnownSymbolLogic = $__require('core-js/internals/fix-regexp-well-known-symbol-logic.js');
  var anObject = $__require('core-js/internals/an-object.js');
  var toLength = $__require('core-js/internals/to-length.js');
  var requireObjectCoercible = $__require('core-js/internals/require-object-coercible.js');
  var advanceStringIndex = $__require('core-js/internals/advance-string-index.js');
  var regExpExec = $__require('core-js/internals/regexp-exec-abstract.js');

  // @@match logic
  fixRegExpWellKnownSymbolLogic('match', 1, function (MATCH, nativeMatch, maybeCallNative) {
    return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = regexp == undefined ? undefined : regexp[MATCH];
      return matcher !== undefined ? matcher.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative(nativeMatch, regexp, this);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }];
  });
});
System.registerDynamic('core-js/es/string/match.js', ['core-js/modules/es.regexp.exec.js', 'core-js/modules/es.string.match.js', 'core-js/internals/entry-unbind.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  $__require('core-js/modules/es.regexp.exec.js');
  $__require('core-js/modules/es.string.match.js');
  var entryUnbind = $__require('core-js/internals/entry-unbind.js');

  module.exports = entryUnbind('String', 'match');
});
System.registerDynamic('core-js/internals/to-object.js', ['core-js/internals/require-object-coercible.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var requireObjectCoercible = $__require('core-js/internals/require-object-coercible.js');

  // `ToObject` abstract operation
  // https://tc39.es/ecma262/#sec-toobject
  module.exports = function (argument) {
    return Object(requireObjectCoercible(argument));
  };
});
System.registerDynamic('core-js/internals/get-substitution.js', ['core-js/internals/to-object.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var toObject = $__require('core-js/internals/to-object.js');

  var floor = Math.floor;
  var replace = ''.replace;
  var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
  var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

  // https://tc39.es/ecma262/#sec-getsubstitution
  module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$':
          return '$';
        case '&':
          return matched;
        case '`':
          return str.slice(0, position);
        case "'":
          return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default:
          // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  };
});
System.registerDynamic('core-js/modules/es.string.replace.js', ['core-js/internals/fix-regexp-well-known-symbol-logic.js', 'core-js/internals/an-object.js', 'core-js/internals/to-length.js', 'core-js/internals/to-integer.js', 'core-js/internals/require-object-coercible.js', 'core-js/internals/advance-string-index.js', 'core-js/internals/get-substitution.js', 'core-js/internals/regexp-exec-abstract.js'], true, function ($__require, exports, module) {
  'use strict';

  var global = this || self,
      GLOBAL = global;
  var fixRegExpWellKnownSymbolLogic = $__require('core-js/internals/fix-regexp-well-known-symbol-logic.js');
  var anObject = $__require('core-js/internals/an-object.js');
  var toLength = $__require('core-js/internals/to-length.js');
  var toInteger = $__require('core-js/internals/to-integer.js');
  var requireObjectCoercible = $__require('core-js/internals/require-object-coercible.js');
  var advanceStringIndex = $__require('core-js/internals/advance-string-index.js');
  var getSubstitution = $__require('core-js/internals/get-substitution.js');
  var regExpExec = $__require('core-js/internals/regexp-exec-abstract.js');

  var max = Math.max;
  var min = Math.min;

  var maybeToString = function (it) {
    return it === undefined ? it : String(it);
  };

  // @@replace logic
  fixRegExpWellKnownSymbolLogic('replace', 2, function (REPLACE, nativeReplace, maybeCallNative, reason) {
    var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = reason.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE;
    var REPLACE_KEEPS_$0 = reason.REPLACE_KEEPS_$0;
    var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

    return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
      return replacer !== undefined ? replacer.call(searchValue, O, replaceValue) : nativeReplace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      if (!REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE && REPLACE_KEEPS_$0 || typeof replaceValue === 'string' && replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1) {
        var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
        if (res.done) return res.value;
      }

      var rx = anObject(regexp);
      var S = String(this);

      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }];
  });
});
System.registerDynamic('core-js/es/string/replace.js', ['core-js/modules/es.regexp.exec.js', 'core-js/modules/es.string.replace.js', 'core-js/internals/entry-unbind.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  $__require('core-js/modules/es.regexp.exec.js');
  $__require('core-js/modules/es.string.replace.js');
  var entryUnbind = $__require('core-js/internals/entry-unbind.js');

  module.exports = entryUnbind('String', 'replace');
});
System.registerDynamic("core-js/internals/same-value.js", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  // `SameValue` abstract operation
  // https://tc39.es/ecma262/#sec-samevalue
  module.exports = Object.is || function is(x, y) {
    // eslint-disable-next-line no-self-compare -- NaN check
    return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
  };
});
System.registerDynamic('core-js/modules/es.string.search.js', ['core-js/internals/fix-regexp-well-known-symbol-logic.js', 'core-js/internals/an-object.js', 'core-js/internals/require-object-coercible.js', 'core-js/internals/same-value.js', 'core-js/internals/regexp-exec-abstract.js'], true, function ($__require, exports, module) {
  'use strict';

  var global = this || self,
      GLOBAL = global;
  var fixRegExpWellKnownSymbolLogic = $__require('core-js/internals/fix-regexp-well-known-symbol-logic.js');
  var anObject = $__require('core-js/internals/an-object.js');
  var requireObjectCoercible = $__require('core-js/internals/require-object-coercible.js');
  var sameValue = $__require('core-js/internals/same-value.js');
  var regExpExec = $__require('core-js/internals/regexp-exec-abstract.js');

  // @@search logic
  fixRegExpWellKnownSymbolLogic('search', 1, function (SEARCH, nativeSearch, maybeCallNative) {
    return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible(this);
      var searcher = regexp == undefined ? undefined : regexp[SEARCH];
      return searcher !== undefined ? searcher.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative(nativeSearch, regexp, this);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }];
  });
});
System.registerDynamic('core-js/es/string/search.js', ['core-js/modules/es.regexp.exec.js', 'core-js/modules/es.string.search.js', 'core-js/internals/entry-unbind.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  $__require('core-js/modules/es.regexp.exec.js');
  $__require('core-js/modules/es.string.search.js');
  var entryUnbind = $__require('core-js/internals/entry-unbind.js');

  module.exports = entryUnbind('String', 'search');
});
System.registerDynamic('core-js/internals/to-absolute-index.js', ['core-js/internals/to-integer.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var toInteger = $__require('core-js/internals/to-integer.js');

  var max = Math.max;
  var min = Math.min;

  // Helper for a popular repeating case of the spec:
  // Let integer be ? ToInteger(index).
  // If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
  module.exports = function (index, length) {
    var integer = toInteger(index);
    return integer < 0 ? max(integer + length, 0) : min(integer, length);
  };
});
System.registerDynamic('core-js/internals/array-includes.js', ['core-js/internals/to-indexed-object.js', 'core-js/internals/to-length.js', 'core-js/internals/to-absolute-index.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var toIndexedObject = $__require('core-js/internals/to-indexed-object.js');
  var toLength = $__require('core-js/internals/to-length.js');
  var toAbsoluteIndex = $__require('core-js/internals/to-absolute-index.js');

  // `Array.prototype.{ indexOf, includes }` methods implementation
  var createMethod = function (IS_INCLUDES) {
    return function ($this, el, fromIndex) {
      var O = toIndexedObject($this);
      var length = toLength(O.length);
      var index = toAbsoluteIndex(fromIndex, length);
      var value;
      // Array#includes uses SameValueZero equality algorithm
      // eslint-disable-next-line no-self-compare -- NaN check
      if (IS_INCLUDES && el != el) while (length > index) {
        value = O[index++];
        // eslint-disable-next-line no-self-compare -- NaN check
        if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
      } else for (; length > index; index++) {
        if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
      }return !IS_INCLUDES && -1;
    };
  };

  module.exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: createMethod(false)
  };
});
System.registerDynamic('core-js/internals/object-keys-internal.js', ['core-js/internals/has.js', 'core-js/internals/to-indexed-object.js', 'core-js/internals/array-includes.js', 'core-js/internals/hidden-keys.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var has = $__require('core-js/internals/has.js');
  var toIndexedObject = $__require('core-js/internals/to-indexed-object.js');
  var indexOf = $__require('core-js/internals/array-includes.js').indexOf;
  var hiddenKeys = $__require('core-js/internals/hidden-keys.js');

  module.exports = function (object, names) {
    var O = toIndexedObject(object);
    var i = 0;
    var result = [];
    var key;
    for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while (names.length > i) if (has(O, key = names[i++])) {
      ~indexOf(result, key) || result.push(key);
    }
    return result;
  };
});
System.registerDynamic('core-js/internals/enum-bug-keys.js', [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  // IE8- don't enum bug keys
  module.exports = ['constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf'];
});
System.registerDynamic('core-js/internals/object-get-own-property-names.js', ['core-js/internals/object-keys-internal.js', 'core-js/internals/enum-bug-keys.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var internalObjectKeys = $__require('core-js/internals/object-keys-internal.js');
  var enumBugKeys = $__require('core-js/internals/enum-bug-keys.js');

  var hiddenKeys = enumBugKeys.concat('length', 'prototype');

  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return internalObjectKeys(O, hiddenKeys);
  };
});
System.registerDynamic("core-js/internals/object-get-own-property-symbols.js", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  exports.f = Object.getOwnPropertySymbols;
});
System.registerDynamic('core-js/internals/own-keys.js', ['core-js/internals/get-built-in.js', 'core-js/internals/object-get-own-property-names.js', 'core-js/internals/object-get-own-property-symbols.js', 'core-js/internals/an-object.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var getBuiltIn = $__require('core-js/internals/get-built-in.js');
  var getOwnPropertyNamesModule = $__require('core-js/internals/object-get-own-property-names.js');
  var getOwnPropertySymbolsModule = $__require('core-js/internals/object-get-own-property-symbols.js');
  var anObject = $__require('core-js/internals/an-object.js');

  // all object keys, includes non-enumerable and symbols
  module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
    var keys = getOwnPropertyNamesModule.f(anObject(it));
    var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
  };
});
System.registerDynamic('core-js/internals/object-property-is-enumerable.js', [], true, function ($__require, exports, module) {
  'use strict';

  var global = this || self,
      GLOBAL = global;
  var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
  var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

  // Nashorn ~ JDK8 bug
  var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

  // `Object.prototype.propertyIsEnumerable` method implementation
  // https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
  exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
  } : nativePropertyIsEnumerable;
});
System.registerDynamic('core-js/internals/indexed-object.js', ['core-js/internals/fails.js', 'core-js/internals/classof-raw.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var fails = $__require('core-js/internals/fails.js');
  var classof = $__require('core-js/internals/classof-raw.js');

  var split = ''.split;

  // fallback for non-array-like ES3 and non-enumerable old V8 strings
  module.exports = fails(function () {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !Object('z').propertyIsEnumerable(0);
  }) ? function (it) {
    return classof(it) == 'String' ? split.call(it, '') : Object(it);
  } : Object;
});
System.registerDynamic('core-js/internals/to-indexed-object.js', ['core-js/internals/indexed-object.js', 'core-js/internals/require-object-coercible.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  // toObject with fallback for non-array-like ES3 strings
  var IndexedObject = $__require('core-js/internals/indexed-object.js');
  var requireObjectCoercible = $__require('core-js/internals/require-object-coercible.js');

  module.exports = function (it) {
    return IndexedObject(requireObjectCoercible(it));
  };
});
System.registerDynamic('core-js/internals/object-get-own-property-descriptor.js', ['core-js/internals/descriptors.js', 'core-js/internals/object-property-is-enumerable.js', 'core-js/internals/create-property-descriptor.js', 'core-js/internals/to-indexed-object.js', 'core-js/internals/to-primitive.js', 'core-js/internals/has.js', 'core-js/internals/ie8-dom-define.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var DESCRIPTORS = $__require('core-js/internals/descriptors.js');
  var propertyIsEnumerableModule = $__require('core-js/internals/object-property-is-enumerable.js');
  var createPropertyDescriptor = $__require('core-js/internals/create-property-descriptor.js');
  var toIndexedObject = $__require('core-js/internals/to-indexed-object.js');
  var toPrimitive = $__require('core-js/internals/to-primitive.js');
  var has = $__require('core-js/internals/has.js');
  var IE8_DOM_DEFINE = $__require('core-js/internals/ie8-dom-define.js');

  var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
  exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = toIndexedObject(O);
    P = toPrimitive(P, true);
    if (IE8_DOM_DEFINE) try {
      return nativeGetOwnPropertyDescriptor(O, P);
    } catch (error) {/* empty */}
    if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
  };
});
System.registerDynamic('core-js/internals/copy-constructor-properties.js', ['core-js/internals/has.js', 'core-js/internals/own-keys.js', 'core-js/internals/object-get-own-property-descriptor.js', 'core-js/internals/object-define-property.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var has = $__require('core-js/internals/has.js');
  var ownKeys = $__require('core-js/internals/own-keys.js');
  var getOwnPropertyDescriptorModule = $__require('core-js/internals/object-get-own-property-descriptor.js');
  var definePropertyModule = $__require('core-js/internals/object-define-property.js');

  module.exports = function (target, source) {
    var keys = ownKeys(source);
    var defineProperty = definePropertyModule.f;
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  };
});
System.registerDynamic('core-js/internals/is-forced.js', ['core-js/internals/fails.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var fails = $__require('core-js/internals/fails.js');

  var replacement = /#|\.prototype\./;

  var isForced = function (feature, detection) {
    var value = data[normalize(feature)];
    return value == POLYFILL ? true : value == NATIVE ? false : typeof detection == 'function' ? fails(detection) : !!detection;
  };

  var normalize = isForced.normalize = function (string) {
    return String(string).replace(replacement, '.').toLowerCase();
  };

  var data = isForced.data = {};
  var NATIVE = isForced.NATIVE = 'N';
  var POLYFILL = isForced.POLYFILL = 'P';

  module.exports = isForced;
});
System.registerDynamic('core-js/internals/export.js', ['core-js/internals/global.js', 'core-js/internals/object-get-own-property-descriptor.js', 'core-js/internals/create-non-enumerable-property.js', 'core-js/internals/redefine.js', 'core-js/internals/set-global.js', 'core-js/internals/copy-constructor-properties.js', 'core-js/internals/is-forced.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var global = $__require('core-js/internals/global.js');
  var getOwnPropertyDescriptor = $__require('core-js/internals/object-get-own-property-descriptor.js').f;
  var createNonEnumerableProperty = $__require('core-js/internals/create-non-enumerable-property.js');
  var redefine = $__require('core-js/internals/redefine.js');
  var setGlobal = $__require('core-js/internals/set-global.js');
  var copyConstructorProperties = $__require('core-js/internals/copy-constructor-properties.js');
  var isForced = $__require('core-js/internals/is-forced.js');

  /*
    options.target      - name of the target object
    options.global      - target is the global object
    options.stat        - export as static methods of target
    options.proto       - export as prototype methods of target
    options.real        - real prototype method for the `pure` version
    options.forced      - export even if the native feature is available
    options.bind        - bind methods to the target, required for the `pure` version
    options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
    options.unsafe      - use the simple assignment of property instead of delete + defineProperty
    options.sham        - add a flag to not completely full polyfills
    options.enumerable  - export as enumerable property
    options.noTargetGet - prevent calling a getter on target
  */
  module.exports = function (options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) {
      target = global;
    } else if (STATIC) {
      target = global[TARGET] || setGlobal(TARGET, {});
    } else {
      target = (global[TARGET] || {}).prototype;
    }
    if (target) for (key in source) {
      sourceProperty = source[key];
      if (options.noTargetGet) {
        descriptor = getOwnPropertyDescriptor(target, key);
        targetProperty = descriptor && descriptor.value;
      } else targetProperty = target[key];
      FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
      // contained in target
      if (!FORCED && targetProperty !== undefined) {
        if (typeof sourceProperty === typeof targetProperty) continue;
        copyConstructorProperties(sourceProperty, targetProperty);
      }
      // add a flag to not completely full polyfills
      if (options.sham || targetProperty && targetProperty.sham) {
        createNonEnumerableProperty(sourceProperty, 'sham', true);
      }
      // extend global
      redefine(target, key, sourceProperty, options);
    }
  };
});
System.registerDynamic('core-js/modules/es.regexp.exec.js', ['core-js/internals/export.js', 'core-js/internals/regexp-exec.js'], true, function ($__require, exports, module) {
  'use strict';

  var global = this || self,
      GLOBAL = global;
  var $ = $__require('core-js/internals/export.js');
  var exec = $__require('core-js/internals/regexp-exec.js');

  // `RegExp.prototype.exec` method
  // https://tc39.es/ecma262/#sec-regexp.prototype.exec
  $({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
    exec: exec
  });
});
System.registerDynamic('core-js/internals/inspect-source.js', ['core-js/internals/shared-store.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var store = $__require('core-js/internals/shared-store.js');

  var functionToString = Function.toString;

  // this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
  if (typeof store.inspectSource != 'function') {
    store.inspectSource = function (it) {
      return functionToString.call(it);
    };
  }

  module.exports = store.inspectSource;
});
System.registerDynamic('core-js/internals/native-weak-map.js', ['core-js/internals/global.js', 'core-js/internals/inspect-source.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var global = $__require('core-js/internals/global.js');
  var inspectSource = $__require('core-js/internals/inspect-source.js');

  var WeakMap = global.WeakMap;

  module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));
});
System.registerDynamic('core-js/internals/shared-key.js', ['core-js/internals/shared.js', 'core-js/internals/uid.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var shared = $__require('core-js/internals/shared.js');
  var uid = $__require('core-js/internals/uid.js');

  var keys = shared('keys');

  module.exports = function (key) {
    return keys[key] || (keys[key] = uid(key));
  };
});
System.registerDynamic("core-js/internals/hidden-keys.js", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = {};
});
System.registerDynamic('core-js/internals/internal-state.js', ['core-js/internals/native-weak-map.js', 'core-js/internals/global.js', 'core-js/internals/is-object.js', 'core-js/internals/create-non-enumerable-property.js', 'core-js/internals/has.js', 'core-js/internals/shared-store.js', 'core-js/internals/shared-key.js', 'core-js/internals/hidden-keys.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var NATIVE_WEAK_MAP = $__require('core-js/internals/native-weak-map.js');
  var global = $__require('core-js/internals/global.js');
  var isObject = $__require('core-js/internals/is-object.js');
  var createNonEnumerableProperty = $__require('core-js/internals/create-non-enumerable-property.js');
  var objectHas = $__require('core-js/internals/has.js');
  var shared = $__require('core-js/internals/shared-store.js');
  var sharedKey = $__require('core-js/internals/shared-key.js');
  var hiddenKeys = $__require('core-js/internals/hidden-keys.js');

  var WeakMap = global.WeakMap;
  var set, get, has;

  var enforce = function (it) {
    return has(it) ? get(it) : set(it, {});
  };

  var getterFor = function (TYPE) {
    return function (it) {
      var state;
      if (!isObject(it) || (state = get(it)).type !== TYPE) {
        throw TypeError('Incompatible receiver, ' + TYPE + ' required');
      }return state;
    };
  };

  if (NATIVE_WEAK_MAP) {
    var store = shared.state || (shared.state = new WeakMap());
    var wmget = store.get;
    var wmhas = store.has;
    var wmset = store.set;
    set = function (it, metadata) {
      metadata.facade = it;
      wmset.call(store, it, metadata);
      return metadata;
    };
    get = function (it) {
      return wmget.call(store, it) || {};
    };
    has = function (it) {
      return wmhas.call(store, it);
    };
  } else {
    var STATE = sharedKey('state');
    hiddenKeys[STATE] = true;
    set = function (it, metadata) {
      metadata.facade = it;
      createNonEnumerableProperty(it, STATE, metadata);
      return metadata;
    };
    get = function (it) {
      return objectHas(it, STATE) ? it[STATE] : {};
    };
    has = function (it) {
      return objectHas(it, STATE);
    };
  }

  module.exports = {
    set: set,
    get: get,
    has: has,
    enforce: enforce,
    getterFor: getterFor
  };
});
System.registerDynamic('core-js/internals/redefine.js', ['core-js/internals/global.js', 'core-js/internals/create-non-enumerable-property.js', 'core-js/internals/has.js', 'core-js/internals/set-global.js', 'core-js/internals/inspect-source.js', 'core-js/internals/internal-state.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var global = $__require('core-js/internals/global.js');
  var createNonEnumerableProperty = $__require('core-js/internals/create-non-enumerable-property.js');
  var has = $__require('core-js/internals/has.js');
  var setGlobal = $__require('core-js/internals/set-global.js');
  var inspectSource = $__require('core-js/internals/inspect-source.js');
  var InternalStateModule = $__require('core-js/internals/internal-state.js');

  var getInternalState = InternalStateModule.get;
  var enforceInternalState = InternalStateModule.enforce;
  var TEMPLATE = String(String).split('String');

  (module.exports = function (O, key, value, options) {
    var unsafe = options ? !!options.unsafe : false;
    var simple = options ? !!options.enumerable : false;
    var noTargetGet = options ? !!options.noTargetGet : false;
    var state;
    if (typeof value == 'function') {
      if (typeof key == 'string' && !has(value, 'name')) {
        createNonEnumerableProperty(value, 'name', key);
      }
      state = enforceInternalState(value);
      if (!state.source) {
        state.source = TEMPLATE.join(typeof key == 'string' ? key : '');
      }
    }
    if (O === global) {
      if (simple) O[key] = value;else setGlobal(key, value);
      return;
    } else if (!unsafe) {
      delete O[key];
    } else if (!noTargetGet && O[key]) {
      simple = true;
    }
    if (simple) O[key] = value;else createNonEnumerableProperty(O, key, value);
    // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
  })(Function.prototype, 'toString', function toString() {
    return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
  });
});
System.registerDynamic('core-js/internals/fix-regexp-well-known-symbol-logic.js', ['core-js/modules/es.regexp.exec.js', 'core-js/internals/redefine.js', 'core-js/internals/fails.js', 'core-js/internals/well-known-symbol.js', 'core-js/internals/regexp-exec.js', 'core-js/internals/create-non-enumerable-property.js'], true, function ($__require, exports, module) {
  'use strict';
  // TODO: Remove from `core-js@4` since it's moved to entry points

  var global = this || self,
      GLOBAL = global;
  $__require('core-js/modules/es.regexp.exec.js');
  var redefine = $__require('core-js/internals/redefine.js');
  var fails = $__require('core-js/internals/fails.js');
  var wellKnownSymbol = $__require('core-js/internals/well-known-symbol.js');
  var regexpExec = $__require('core-js/internals/regexp-exec.js');
  var createNonEnumerableProperty = $__require('core-js/internals/create-non-enumerable-property.js');

  var SPECIES = wellKnownSymbol('species');

  var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
    // #replace needs built-in support for named groups.
    // #match works fine because it just return the exec results, even if it has
    // a "grops" property.
    var re = /./;
    re.exec = function () {
      var result = [];
      result.groups = { a: '7' };
      return result;
    };
    return ''.replace(re, '$<a>') !== '7';
  });

  // IE <= 11 replaces $0 with the whole match, as if it was $&
  // https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
  var REPLACE_KEEPS_$0 = function () {
    return 'a'.replace(/./, '$0') === '$0';
  }();

  var REPLACE = wellKnownSymbol('replace');
  // Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
  var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function () {
    if (/./[REPLACE]) {
      return (/./[REPLACE]('a', '$0') === ''
      );
    }
    return false;
  }();

  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  // Weex JS has frozen built-in prototypes, so use try / catch wrapper
  var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    var re = /(?:)/;
    var originalExec = re.exec;
    re.exec = function () {
      return originalExec.apply(this, arguments);
    };
    var result = 'ab'.split(re);
    return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
  });

  module.exports = function (KEY, length, exec, sham) {
    var SYMBOL = wellKnownSymbol(KEY);

    var DELEGATES_TO_SYMBOL = !fails(function () {
      // String methods call symbol-named RegEp methods
      var O = {};
      O[SYMBOL] = function () {
        return 7;
      };
      return ''[KEY](O) != 7;
    });

    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
      // Symbol-named RegExp methods call .exec
      var execCalled = false;
      var re = /a/;

      if (KEY === 'split') {
        // We can't use real regex here since it causes deoptimization
        // and serious performance degradation in V8
        // https://github.com/zloirock/core-js/issues/306
        re = {};
        // RegExp[@@split] doesn't call the regex's exec method, but first creates
        // a new one. We need to return the patched regex when creating the new one.
        re.constructor = {};
        re.constructor[SPECIES] = function () {
          return re;
        };
        re.flags = '';
        re[SYMBOL] = /./[SYMBOL];
      }

      re.exec = function () {
        execCalled = true;return null;
      };

      re[SYMBOL]('');
      return !execCalled;
    });

    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || KEY === 'replace' && !(REPLACE_SUPPORTS_NAMED_GROUPS && REPLACE_KEEPS_$0 && !REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE) || KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC) {
      var nativeRegExpMethod = /./[SYMBOL];
      var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }, {
        REPLACE_KEEPS_$0: REPLACE_KEEPS_$0,
        REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
      });
      var stringMethod = methods[0];
      var regexMethod = methods[1];

      redefine(String.prototype, KEY, stringMethod);
      redefine(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) {
        return regexMethod.call(string, this, arg);
      }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) {
        return regexMethod.call(string, this);
      });
    }

    if (sham) createNonEnumerableProperty(RegExp.prototype[SYMBOL], 'sham', true);
  };
});
System.registerDynamic('core-js/internals/is-regexp.js', ['core-js/internals/is-object.js', 'core-js/internals/classof-raw.js', 'core-js/internals/well-known-symbol.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var isObject = $__require('core-js/internals/is-object.js');
  var classof = $__require('core-js/internals/classof-raw.js');
  var wellKnownSymbol = $__require('core-js/internals/well-known-symbol.js');

  var MATCH = wellKnownSymbol('match');

  // `IsRegExp` abstract operation
  // https://tc39.es/ecma262/#sec-isregexp
  module.exports = function (it) {
    var isRegExp;
    return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
  };
});
System.registerDynamic("core-js/internals/is-pure.js", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = false;
});
System.registerDynamic('core-js/internals/descriptors.js', ['core-js/internals/fails.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var fails = $__require('core-js/internals/fails.js');

  // Detect IE8's incomplete defineProperty implementation
  module.exports = !fails(function () {
    return Object.defineProperty({}, 1, { get: function () {
        return 7;
      } })[1] != 7;
  });
});
System.registerDynamic('core-js/internals/document-create-element.js', ['core-js/internals/global.js', 'core-js/internals/is-object.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var global = $__require('core-js/internals/global.js');
  var isObject = $__require('core-js/internals/is-object.js');

  var document = global.document;
  // typeof document.createElement is 'object' in old IE
  var EXISTS = isObject(document) && isObject(document.createElement);

  module.exports = function (it) {
    return EXISTS ? document.createElement(it) : {};
  };
});
System.registerDynamic('core-js/internals/ie8-dom-define.js', ['core-js/internals/descriptors.js', 'core-js/internals/fails.js', 'core-js/internals/document-create-element.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var DESCRIPTORS = $__require('core-js/internals/descriptors.js');
  var fails = $__require('core-js/internals/fails.js');
  var createElement = $__require('core-js/internals/document-create-element.js');

  // Thank's IE8 for his funny defineProperty
  module.exports = !DESCRIPTORS && !fails(function () {
    return Object.defineProperty(createElement('div'), 'a', {
      get: function () {
        return 7;
      }
    }).a != 7;
  });
});
System.registerDynamic('core-js/internals/to-primitive.js', ['core-js/internals/is-object.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var isObject = $__require('core-js/internals/is-object.js');

  // `ToPrimitive` abstract operation
  // https://tc39.es/ecma262/#sec-toprimitive
  // instead of the ES6 spec version, we didn't implement @@toPrimitive case
  // and the second argument - flag - preferred type is a string
  module.exports = function (input, PREFERRED_STRING) {
    if (!isObject(input)) return input;
    var fn, val;
    if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
    if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
    if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
    throw TypeError("Can't convert object to primitive value");
  };
});
System.registerDynamic('core-js/internals/object-define-property.js', ['core-js/internals/descriptors.js', 'core-js/internals/ie8-dom-define.js', 'core-js/internals/an-object.js', 'core-js/internals/to-primitive.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var DESCRIPTORS = $__require('core-js/internals/descriptors.js');
  var IE8_DOM_DEFINE = $__require('core-js/internals/ie8-dom-define.js');
  var anObject = $__require('core-js/internals/an-object.js');
  var toPrimitive = $__require('core-js/internals/to-primitive.js');

  var nativeDefineProperty = Object.defineProperty;

  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
    anObject(O);
    P = toPrimitive(P, true);
    anObject(Attributes);
    if (IE8_DOM_DEFINE) try {
      return nativeDefineProperty(O, P, Attributes);
    } catch (error) {/* empty */}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
  };
});
System.registerDynamic("core-js/internals/create-property-descriptor.js", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = function (bitmap, value) {
    return {
      enumerable: !(bitmap & 1),
      configurable: !(bitmap & 2),
      writable: !(bitmap & 4),
      value: value
    };
  };
});
System.registerDynamic('core-js/internals/create-non-enumerable-property.js', ['core-js/internals/descriptors.js', 'core-js/internals/object-define-property.js', 'core-js/internals/create-property-descriptor.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var DESCRIPTORS = $__require('core-js/internals/descriptors.js');
  var definePropertyModule = $__require('core-js/internals/object-define-property.js');
  var createPropertyDescriptor = $__require('core-js/internals/create-property-descriptor.js');

  module.exports = DESCRIPTORS ? function (object, key, value) {
    return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
  } : function (object, key, value) {
    object[key] = value;
    return object;
  };
});
System.registerDynamic('core-js/internals/set-global.js', ['core-js/internals/global.js', 'core-js/internals/create-non-enumerable-property.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var global = $__require('core-js/internals/global.js');
  var createNonEnumerableProperty = $__require('core-js/internals/create-non-enumerable-property.js');

  module.exports = function (key, value) {
    try {
      createNonEnumerableProperty(global, key, value);
    } catch (error) {
      global[key] = value;
    }return value;
  };
});
System.registerDynamic('core-js/internals/shared-store.js', ['core-js/internals/global.js', 'core-js/internals/set-global.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var global = $__require('core-js/internals/global.js');
  var setGlobal = $__require('core-js/internals/set-global.js');

  var SHARED = '__core-js_shared__';
  var store = global[SHARED] || setGlobal(SHARED, {});

  module.exports = store;
});
System.registerDynamic('core-js/internals/shared.js', ['core-js/internals/is-pure.js', 'core-js/internals/shared-store.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var IS_PURE = $__require('core-js/internals/is-pure.js');
  var store = $__require('core-js/internals/shared-store.js');

  (module.exports = function (key, value) {
    return store[key] || (store[key] = value !== undefined ? value : {});
  })('versions', []).push({
    version: '3.9.1',
    mode: IS_PURE ? 'pure' : 'global',
    copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
  });
});
System.registerDynamic("core-js/internals/has.js", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var hasOwnProperty = {}.hasOwnProperty;

  module.exports = function (it, key) {
    return hasOwnProperty.call(it, key);
  };
});
System.registerDynamic('core-js/internals/uid.js', [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var id = 0;
  var postfix = Math.random();

  module.exports = function (key) {
    return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
  };
});
System.registerDynamic('core-js/internals/engine-is-node.js', ['core-js/internals/classof-raw.js', 'core-js/internals/global.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var classof = $__require('core-js/internals/classof-raw.js');
  var global = $__require('core-js/internals/global.js');

  module.exports = classof(global.process) == 'process';
});
System.registerDynamic('core-js/internals/path.js', ['core-js/internals/global.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var global = $__require('core-js/internals/global.js');

  module.exports = global;
});
System.registerDynamic('core-js/internals/get-built-in.js', ['core-js/internals/path.js', 'core-js/internals/global.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var path = $__require('core-js/internals/path.js');
  var global = $__require('core-js/internals/global.js');

  var aFunction = function (variable) {
    return typeof variable == 'function' ? variable : undefined;
  };

  module.exports = function (namespace, method) {
    return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace]) : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
  };
});
System.registerDynamic('core-js/internals/engine-user-agent.js', ['core-js/internals/get-built-in.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var getBuiltIn = $__require('core-js/internals/get-built-in.js');

  module.exports = getBuiltIn('navigator', 'userAgent') || '';
});
System.registerDynamic('core-js/internals/engine-v8-version.js', ['core-js/internals/global.js', 'core-js/internals/engine-user-agent.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var global = $__require('core-js/internals/global.js');
  var userAgent = $__require('core-js/internals/engine-user-agent.js');

  var process = global.process;
  var versions = process && process.versions;
  var v8 = versions && versions.v8;
  var match, version;

  if (v8) {
    match = v8.split('.');
    version = match[0] + match[1];
  } else if (userAgent) {
    match = userAgent.match(/Edge\/(\d+)/);
    if (!match || match[1] >= 74) {
      match = userAgent.match(/Chrome\/(\d+)/);
      if (match) version = match[1];
    }
  }

  module.exports = version && +version;
});
System.registerDynamic('core-js/internals/native-symbol.js', ['core-js/internals/engine-is-node.js', 'core-js/internals/engine-v8-version.js', 'core-js/internals/fails.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var IS_NODE = $__require('core-js/internals/engine-is-node.js');
  var V8_VERSION = $__require('core-js/internals/engine-v8-version.js');
  var fails = $__require('core-js/internals/fails.js');

  module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
    /* global Symbol -- required for testing */
    return !Symbol.sham && (
    // Chrome 38 Symbol has incorrect toString conversion
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    IS_NODE ? V8_VERSION === 38 : V8_VERSION > 37 && V8_VERSION < 41);
  });
});
System.registerDynamic('core-js/internals/use-symbol-as-uid.js', ['core-js/internals/native-symbol.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var NATIVE_SYMBOL = $__require('core-js/internals/native-symbol.js');

  module.exports = NATIVE_SYMBOL
  /* global Symbol -- safe */
  && !Symbol.sham && typeof Symbol.iterator == 'symbol';
});
System.registerDynamic('core-js/internals/well-known-symbol.js', ['core-js/internals/global.js', 'core-js/internals/shared.js', 'core-js/internals/has.js', 'core-js/internals/uid.js', 'core-js/internals/native-symbol.js', 'core-js/internals/use-symbol-as-uid.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var global = $__require('core-js/internals/global.js');
  var shared = $__require('core-js/internals/shared.js');
  var has = $__require('core-js/internals/has.js');
  var uid = $__require('core-js/internals/uid.js');
  var NATIVE_SYMBOL = $__require('core-js/internals/native-symbol.js');
  var USE_SYMBOL_AS_UID = $__require('core-js/internals/use-symbol-as-uid.js');

  var WellKnownSymbolsStore = shared('wks');
  var Symbol = global.Symbol;
  var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

  module.exports = function (name) {
    if (!has(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
      if (NATIVE_SYMBOL && has(Symbol, name)) {
        WellKnownSymbolsStore[name] = Symbol[name];
      } else {
        WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
      }
    }return WellKnownSymbolsStore[name];
  };
});
System.registerDynamic('core-js/internals/species-constructor.js', ['core-js/internals/an-object.js', 'core-js/internals/a-function.js', 'core-js/internals/well-known-symbol.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var anObject = $__require('core-js/internals/an-object.js');
  var aFunction = $__require('core-js/internals/a-function.js');
  var wellKnownSymbol = $__require('core-js/internals/well-known-symbol.js');

  var SPECIES = wellKnownSymbol('species');

  // `SpeciesConstructor` abstract operation
  // https://tc39.es/ecma262/#sec-speciesconstructor
  module.exports = function (O, defaultConstructor) {
    var C = anObject(O).constructor;
    var S;
    return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
  };
});
System.registerDynamic("core-js/internals/require-object-coercible.js", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  // `RequireObjectCoercible` abstract operation
  // https://tc39.es/ecma262/#sec-requireobjectcoercible
  module.exports = function (it) {
    if (it == undefined) throw TypeError("Can't call method on " + it);
    return it;
  };
});
System.registerDynamic('core-js/internals/string-multibyte.js', ['core-js/internals/to-integer.js', 'core-js/internals/require-object-coercible.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var toInteger = $__require('core-js/internals/to-integer.js');
  var requireObjectCoercible = $__require('core-js/internals/require-object-coercible.js');

  // `String.prototype.{ codePointAt, at }` methods implementation
  var createMethod = function (CONVERT_TO_STRING) {
    return function ($this, pos) {
      var S = String(requireObjectCoercible($this));
      var position = toInteger(pos);
      var size = S.length;
      var first, second;
      if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
      first = S.charCodeAt(position);
      return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? S.charAt(position) : first : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
  };

  module.exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: createMethod(true)
  };
});
System.registerDynamic('core-js/internals/advance-string-index.js', ['core-js/internals/string-multibyte.js'], true, function ($__require, exports, module) {
  'use strict';

  var global = this || self,
      GLOBAL = global;
  var charAt = $__require('core-js/internals/string-multibyte.js').charAt;

  // `AdvanceStringIndex` abstract operation
  // https://tc39.es/ecma262/#sec-advancestringindex
  module.exports = function (S, index, unicode) {
    return index + (unicode ? charAt(S, index).length : 1);
  };
});
System.registerDynamic("core-js/internals/to-integer.js", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var ceil = Math.ceil;
  var floor = Math.floor;

  // `ToInteger` abstract operation
  // https://tc39.es/ecma262/#sec-tointeger
  module.exports = function (argument) {
    return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
  };
});
System.registerDynamic('core-js/internals/to-length.js', ['core-js/internals/to-integer.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var toInteger = $__require('core-js/internals/to-integer.js');

  var min = Math.min;

  // `ToLength` abstract operation
  // https://tc39.es/ecma262/#sec-tolength
  module.exports = function (argument) {
    return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
  };
});
System.registerDynamic("core-js/internals/classof-raw.js", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var toString = {}.toString;

  module.exports = function (it) {
    return toString.call(it).slice(8, -1);
  };
});
System.registerDynamic('core-js/internals/regexp-exec-abstract.js', ['core-js/internals/classof-raw.js', 'core-js/internals/regexp-exec.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var classof = $__require('core-js/internals/classof-raw.js');
  var regexpExec = $__require('core-js/internals/regexp-exec.js');

  // `RegExpExec` abstract operation
  // https://tc39.es/ecma262/#sec-regexpexec
  module.exports = function (R, S) {
    var exec = R.exec;
    if (typeof exec === 'function') {
      var result = exec.call(R, S);
      if (typeof result !== 'object') {
        throw TypeError('RegExp exec method returned something other than an Object or null');
      }
      return result;
    }

    if (classof(R) !== 'RegExp') {
      throw TypeError('RegExp#exec called on incompatible receiver');
    }

    return regexpExec.call(R, S);
  };
});
System.registerDynamic('core-js/internals/is-object.js', [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = function (it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
  };
});
System.registerDynamic('core-js/internals/an-object.js', ['core-js/internals/is-object.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var isObject = $__require('core-js/internals/is-object.js');

  module.exports = function (it) {
    if (!isObject(it)) {
      throw TypeError(String(it) + ' is not an object');
    }return it;
  };
});
System.registerDynamic('core-js/internals/regexp-flags.js', ['core-js/internals/an-object.js'], true, function ($__require, exports, module) {
  'use strict';

  var global = this || self,
      GLOBAL = global;
  var anObject = $__require('core-js/internals/an-object.js');

  // `RegExp.prototype.flags` getter implementation
  // https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
  module.exports = function () {
    var that = anObject(this);
    var result = '';
    if (that.global) result += 'g';
    if (that.ignoreCase) result += 'i';
    if (that.multiline) result += 'm';
    if (that.dotAll) result += 's';
    if (that.unicode) result += 'u';
    if (that.sticky) result += 'y';
    return result;
  };
});
System.registerDynamic('core-js/internals/regexp-sticky-helpers.js', ['core-js/internals/fails.js'], true, function ($__require, exports, module) {
  'use strict';

  var global = this || self,
      GLOBAL = global;
  var fails = $__require('core-js/internals/fails.js');

  // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
  // so we use an intermediate function.
  function RE(s, f) {
    return RegExp(s, f);
  }

  exports.UNSUPPORTED_Y = fails(function () {
    // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
    var re = RE('a', 'y');
    re.lastIndex = 2;
    return re.exec('abcd') != null;
  });

  exports.BROKEN_CARET = fails(function () {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
    var re = RE('^r', 'gy');
    re.lastIndex = 2;
    return re.exec('str') != null;
  });
});
System.registerDynamic('core-js/internals/regexp-exec.js', ['core-js/internals/regexp-flags.js', 'core-js/internals/regexp-sticky-helpers.js'], true, function ($__require, exports, module) {
  'use strict';

  var global = this || self,
      GLOBAL = global;
  var regexpFlags = $__require('core-js/internals/regexp-flags.js');
  var stickyHelpers = $__require('core-js/internals/regexp-sticky-helpers.js');

  var nativeExec = RegExp.prototype.exec;
  // This always refers to the native implementation, because the
  // String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
  // which loads this file before patching the method.
  var nativeReplace = String.prototype.replace;

  var patchedExec = nativeExec;

  var UPDATES_LAST_INDEX_WRONG = function () {
    var re1 = /a/;
    var re2 = /b*/g;
    nativeExec.call(re1, 'a');
    nativeExec.call(re2, 'a');
    return re1.lastIndex !== 0 || re2.lastIndex !== 0;
  }();

  var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;

  // nonparticipating capturing group, copied from es5-shim's String#split patch.
  // eslint-disable-next-line regexp/no-assertion-capturing-group, regexp/no-empty-group -- required for testing
  var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

  var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y;

  if (PATCH) {
    patchedExec = function exec(str) {
      var re = this;
      var lastIndex, reCopy, match, i;
      var sticky = UNSUPPORTED_Y && re.sticky;
      var flags = regexpFlags.call(re);
      var source = re.source;
      var charsAdded = 0;
      var strCopy = str;

      if (sticky) {
        flags = flags.replace('y', '');
        if (flags.indexOf('g') === -1) {
          flags += 'g';
        }

        strCopy = String(str).slice(re.lastIndex);
        // Support anchored sticky behavior.
        if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
          source = '(?: ' + source + ')';
          strCopy = ' ' + strCopy;
          charsAdded++;
        }
        // ^(? + rx + ) is needed, in combination with some str slicing, to
        // simulate the 'y' flag.
        reCopy = new RegExp('^(?:' + source + ')', flags);
      }

      if (NPCG_INCLUDED) {
        reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
      }
      if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

      match = nativeExec.call(sticky ? reCopy : re, strCopy);

      if (sticky) {
        if (match) {
          match.input = match.input.slice(charsAdded);
          match[0] = match[0].slice(charsAdded);
          match.index = re.lastIndex;
          re.lastIndex += match[0].length;
        } else re.lastIndex = 0;
      } else if (UPDATES_LAST_INDEX_WRONG && match) {
        re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
      }
      if (NPCG_INCLUDED && match && match.length > 1) {
        // Fix browsers whose `exec` methods don't consistently return `undefined`
        // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
        nativeReplace.call(match[0], reCopy, function () {
          for (i = 1; i < arguments.length - 2; i++) {
            if (arguments[i] === undefined) match[i] = undefined;
          }
        });
      }

      return match;
    };
  }

  module.exports = patchedExec;
});
System.registerDynamic("core-js/internals/fails.js", [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = function (exec) {
    try {
      return !!exec();
    } catch (error) {
      return true;
    }
  };
});
System.registerDynamic('core-js/modules/es.string.split.js', ['core-js/internals/fix-regexp-well-known-symbol-logic.js', 'core-js/internals/is-regexp.js', 'core-js/internals/an-object.js', 'core-js/internals/require-object-coercible.js', 'core-js/internals/species-constructor.js', 'core-js/internals/advance-string-index.js', 'core-js/internals/to-length.js', 'core-js/internals/regexp-exec-abstract.js', 'core-js/internals/regexp-exec.js', 'core-js/internals/fails.js'], true, function ($__require, exports, module) {
  'use strict';

  var global = this || self,
      GLOBAL = global;
  var fixRegExpWellKnownSymbolLogic = $__require('core-js/internals/fix-regexp-well-known-symbol-logic.js');
  var isRegExp = $__require('core-js/internals/is-regexp.js');
  var anObject = $__require('core-js/internals/an-object.js');
  var requireObjectCoercible = $__require('core-js/internals/require-object-coercible.js');
  var speciesConstructor = $__require('core-js/internals/species-constructor.js');
  var advanceStringIndex = $__require('core-js/internals/advance-string-index.js');
  var toLength = $__require('core-js/internals/to-length.js');
  var callRegExpExec = $__require('core-js/internals/regexp-exec-abstract.js');
  var regexpExec = $__require('core-js/internals/regexp-exec.js');
  var fails = $__require('core-js/internals/fails.js');

  var arrayPush = [].push;
  var min = Math.min;
  var MAX_UINT32 = 0xFFFFFFFF;

  // babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
  var SUPPORTS_Y = !fails(function () {
    return !RegExp(MAX_UINT32, 'y');
  });

  // @@split logic
  fixRegExpWellKnownSymbolLogic('split', 2, function (SPLIT, nativeSplit, maybeCallNative) {
    var internalSplit;
    if ('abbc'.split(/(b)*/)[1] == 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length != 4 || 'ab'.split(/(?:ab)*/).length != 2 || '.'.split(/(.?)(.?)/).length != 4 ||
    // eslint-disable-next-line regexp/no-assertion-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 || ''.split(/.?/).length) {
      // based on es5-shim implementation, need to rework it
      internalSplit = function (separator, limit) {
        var string = String(requireObjectCoercible(this));
        var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
        if (lim === 0) return [];
        if (separator === undefined) return [string];
        // If `separator` is not a regex, use native split
        if (!isRegExp(separator)) {
          return nativeSplit.call(string, separator, lim);
        }
        var output = [];
        var flags = (separator.ignoreCase ? 'i' : '') + (separator.multiline ? 'm' : '') + (separator.unicode ? 'u' : '') + (separator.sticky ? 'y' : '');
        var lastLastIndex = 0;
        // Make `global` and avoid `lastIndex` issues by working with a copy
        var separatorCopy = new RegExp(separator.source, flags + 'g');
        var match, lastIndex, lastLength;
        while (match = regexpExec.call(separatorCopy, string)) {
          lastIndex = separatorCopy.lastIndex;
          if (lastIndex > lastLastIndex) {
            output.push(string.slice(lastLastIndex, match.index));
            if (match.length > 1 && match.index < string.length) arrayPush.apply(output, match.slice(1));
            lastLength = match[0].length;
            lastLastIndex = lastIndex;
            if (output.length >= lim) break;
          }
          if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
        }
        if (lastLastIndex === string.length) {
          if (lastLength || !separatorCopy.test('')) output.push('');
        } else output.push(string.slice(lastLastIndex));
        return output.length > lim ? output.slice(0, lim) : output;
      };
      // Chakra, V8
    } else if ('0'.split(undefined, 0).length) {
      internalSplit = function (separator, limit) {
        return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
      };
    } else internalSplit = nativeSplit;

    return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined ? splitter.call(separator, O, limit) : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== nativeSplit);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') + (rx.multiline ? 'm' : '') + (rx.unicode ? 'u' : '') + (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (z === null || (e = min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }];
  }, !SUPPORTS_Y);
});
System.registerDynamic('core-js/internals/global.js', [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var check = function (it) {
    return it && it.Math == Math && it;
  };

  // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
  module.exports =
  /* global globalThis -- safe */
  check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) || check(typeof self == 'object' && self) || check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  function () {
    return this;
  }() || Function('return this')();
});
System.registerDynamic('core-js/internals/a-function.js', [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  module.exports = function (it) {
    if (typeof it != 'function') {
      throw TypeError(String(it) + ' is not a function');
    }return it;
  };
});
System.registerDynamic('core-js/internals/function-bind-context.js', ['core-js/internals/a-function.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var aFunction = $__require('core-js/internals/a-function.js');

  // optional / simple context binding
  module.exports = function (fn, that, length) {
    aFunction(fn);
    if (that === undefined) return fn;
    switch (length) {
      case 0:
        return function () {
          return fn.call(that);
        };
      case 1:
        return function (a) {
          return fn.call(that, a);
        };
      case 2:
        return function (a, b) {
          return fn.call(that, a, b);
        };
      case 3:
        return function (a, b, c) {
          return fn.call(that, a, b, c);
        };
    }
    return function () /* ...args */{
      return fn.apply(that, arguments);
    };
  };
});
System.registerDynamic('core-js/internals/entry-unbind.js', ['core-js/internals/global.js', 'core-js/internals/function-bind-context.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  var global = $__require('core-js/internals/global.js');
  var bind = $__require('core-js/internals/function-bind-context.js');

  var call = Function.call;

  module.exports = function (CONSTRUCTOR, METHOD, length) {
    return bind(call, global[CONSTRUCTOR].prototype[METHOD], length);
  };
});
System.registerDynamic('core-js/es/string/split.js', ['core-js/modules/es.regexp.exec.js', 'core-js/modules/es.string.split.js', 'core-js/internals/entry-unbind.js'], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  $__require('core-js/modules/es.regexp.exec.js');
  $__require('core-js/modules/es.string.split.js');
  var entryUnbind = $__require('core-js/internals/entry-unbind.js');

  module.exports = entryUnbind('String', 'split');
});
System.registerDynamic("ts-polyfill/lib/es2015-symbol-wellknown.js", ["ts-polyfill/lib/es2015-symbol.js", "core-js/es/symbol/has-instance.js", "core-js/es/symbol/is-concat-spreadable.js", "core-js/es/symbol/match.js", "core-js/es/symbol/replace.js", "core-js/es/symbol/search.js", "core-js/es/symbol/species.js", "core-js/es/symbol/split.js", "core-js/es/symbol/to-primitive.js", "core-js/es/symbol/to-string-tag.js", "core-js/es/json/to-string-tag.js", "core-js/es/symbol/unscopables.js", "core-js/es/date/to-primitive.js", "core-js/es/function/has-instance.js", "core-js/es/math/to-string-tag.js", "core-js/es/string/match.js", "core-js/es/string/replace.js", "core-js/es/string/search.js", "core-js/es/string/split.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  Object.defineProperty(exports, "__esModule", { value: true });
  $__require("ts-polyfill/lib/es2015-symbol.js");
  $__require("core-js/es/symbol/has-instance.js");
  $__require("core-js/es/symbol/is-concat-spreadable.js");
  $__require("core-js/es/symbol/match.js");
  $__require("core-js/es/symbol/replace.js");
  $__require("core-js/es/symbol/search.js");
  $__require("core-js/es/symbol/species.js");
  $__require("core-js/es/symbol/split.js");
  $__require("core-js/es/symbol/to-primitive.js");
  $__require("core-js/es/symbol/to-string-tag.js");
  $__require("core-js/es/json/to-string-tag.js");
  $__require("core-js/es/symbol/unscopables.js");
  $__require("core-js/es/date/to-primitive.js");
  $__require("core-js/es/function/has-instance.js");
  $__require("core-js/es/math/to-string-tag.js");
  $__require("core-js/es/string/match.js");
  $__require("core-js/es/string/replace.js");
  $__require("core-js/es/string/search.js");
  $__require("core-js/es/string/split.js");
});
System.registerDynamic("angular2/src/core/angular_entrypoint.js", ["angular2/src/facade/lang.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var lang_1 = $__require("angular2/src/facade/lang.js");
    /**
     * Marks a function or method as an Angular 2 entrypoint. Only necessary in Dart code.
     *
     * The optional `name` parameter will be reflected in logs when the entry point is processed.
     *
     * See [the wiki][] for detailed documentation.
     * [the wiki]: https://github.com/angular/angular/wiki/Angular-2-Dart-Transformer#entry_points
     *
     * ## Example
     *
     * ```
     * @AngularEntrypoint("name-for-debug")
     * void main() {
     *   bootstrap(MyComponent);
     * }
     * ```
     */
    var AngularEntrypoint = function () {
        function AngularEntrypoint(name) {
            this.name = name;
        }
        AngularEntrypoint = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [String])], AngularEntrypoint);
        return AngularEntrypoint;
    }();
    exports.AngularEntrypoint = AngularEntrypoint;
});
System.registerDynamic("angular2/src/platform/dom/events/key_events.js", ["angular2/src/platform/dom/dom_adapter.js", "angular2/src/facade/lang.js", "angular2/src/facade/collection.js", "angular2/src/platform/dom/events/event_manager.js", "angular2/src/core/di.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var dom_adapter_1 = $__require("angular2/src/platform/dom/dom_adapter.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var event_manager_1 = $__require("angular2/src/platform/dom/events/event_manager.js");
    var di_1 = $__require("angular2/src/core/di.js");
    var modifierKeys = ['alt', 'control', 'meta', 'shift'];
    var modifierKeyGetters = {
        'alt': function (event) {
            return event.altKey;
        },
        'control': function (event) {
            return event.ctrlKey;
        },
        'meta': function (event) {
            return event.metaKey;
        },
        'shift': function (event) {
            return event.shiftKey;
        }
    };
    var KeyEventsPlugin = function (_super) {
        __extends(KeyEventsPlugin, _super);
        function KeyEventsPlugin() {
            _super.call(this);
        }
        KeyEventsPlugin.prototype.supports = function (eventName) {
            return lang_1.isPresent(KeyEventsPlugin.parseEventName(eventName));
        };
        KeyEventsPlugin.prototype.addEventListener = function (element, eventName, handler) {
            var parsedEvent = KeyEventsPlugin.parseEventName(eventName);
            var outsideHandler = KeyEventsPlugin.eventCallback(element, collection_1.StringMapWrapper.get(parsedEvent, 'fullKey'), handler, this.manager.getZone());
            return this.manager.getZone().runOutsideAngular(function () {
                return dom_adapter_1.DOM.onAndCancel(element, collection_1.StringMapWrapper.get(parsedEvent, 'domEventName'), outsideHandler);
            });
        };
        KeyEventsPlugin.parseEventName = function (eventName) {
            var parts = eventName.toLowerCase().split('.');
            var domEventName = parts.shift();
            if (parts.length === 0 || !(lang_1.StringWrapper.equals(domEventName, 'keydown') || lang_1.StringWrapper.equals(domEventName, 'keyup'))) {
                return null;
            }
            var key = KeyEventsPlugin._normalizeKey(parts.pop());
            var fullKey = '';
            modifierKeys.forEach(function (modifierName) {
                if (collection_1.ListWrapper.contains(parts, modifierName)) {
                    collection_1.ListWrapper.remove(parts, modifierName);
                    fullKey += modifierName + '.';
                }
            });
            fullKey += key;
            if (parts.length != 0 || key.length === 0) {
                // returning null instead of throwing to let another plugin process the event
                return null;
            }
            var result = collection_1.StringMapWrapper.create();
            collection_1.StringMapWrapper.set(result, 'domEventName', domEventName);
            collection_1.StringMapWrapper.set(result, 'fullKey', fullKey);
            return result;
        };
        KeyEventsPlugin.getEventFullKey = function (event) {
            var fullKey = '';
            var key = dom_adapter_1.DOM.getEventKey(event);
            key = key.toLowerCase();
            if (lang_1.StringWrapper.equals(key, ' ')) {
                key = 'space'; // for readability
            } else if (lang_1.StringWrapper.equals(key, '.')) {
                key = 'dot'; // because '.' is used as a separator in event names
            }
            modifierKeys.forEach(function (modifierName) {
                if (modifierName != key) {
                    var modifierGetter = collection_1.StringMapWrapper.get(modifierKeyGetters, modifierName);
                    if (modifierGetter(event)) {
                        fullKey += modifierName + '.';
                    }
                }
            });
            fullKey += key;
            return fullKey;
        };
        KeyEventsPlugin.eventCallback = function (element, fullKey, handler, zone) {
            return function (event) {
                if (lang_1.StringWrapper.equals(KeyEventsPlugin.getEventFullKey(event), fullKey)) {
                    zone.run(function () {
                        return handler(event);
                    });
                }
            };
        };
        /** @internal */
        KeyEventsPlugin._normalizeKey = function (keyName) {
            // TODO: switch to a StringMap if the mapping grows too much
            switch (keyName) {
                case 'esc':
                    return 'escape';
                default:
                    return keyName;
            }
        };
        KeyEventsPlugin = __decorate([di_1.Injectable(), __metadata('design:paramtypes', [])], KeyEventsPlugin);
        return KeyEventsPlugin;
    }(event_manager_1.EventManagerPlugin);
    exports.KeyEventsPlugin = KeyEventsPlugin;
});
System.registerDynamic('angular2/src/platform/browser/generic_browser_adapter.js', ['angular2/src/facade/collection.js', 'angular2/src/facade/lang.js', 'angular2/src/platform/dom/dom_adapter.js', 'angular2/src/platform/browser/xhr_impl.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var collection_1 = $__require('angular2/src/facade/collection.js');
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var dom_adapter_1 = $__require('angular2/src/platform/dom/dom_adapter.js');
    var xhr_impl_1 = $__require('angular2/src/platform/browser/xhr_impl.js');
    /**
     * Provides DOM operations in any browser environment.
     */
    var GenericBrowserDomAdapter = function (_super) {
        __extends(GenericBrowserDomAdapter, _super);
        function GenericBrowserDomAdapter() {
            var _this = this;
            _super.call(this);
            this._animationPrefix = null;
            this._transitionEnd = null;
            try {
                var element = this.createElement('div', this.defaultDoc());
                if (lang_1.isPresent(this.getStyle(element, 'animationName'))) {
                    this._animationPrefix = '';
                } else {
                    var domPrefixes = ['Webkit', 'Moz', 'O', 'ms'];
                    for (var i = 0; i < domPrefixes.length; i++) {
                        if (lang_1.isPresent(this.getStyle(element, domPrefixes[i] + 'AnimationName'))) {
                            this._animationPrefix = '-' + domPrefixes[i].toLowerCase() + '-';
                            break;
                        }
                    }
                }
                var transEndEventNames = {
                    WebkitTransition: 'webkitTransitionEnd',
                    MozTransition: 'transitionend',
                    OTransition: 'oTransitionEnd otransitionend',
                    transition: 'transitionend'
                };
                collection_1.StringMapWrapper.forEach(transEndEventNames, function (value, key) {
                    if (lang_1.isPresent(_this.getStyle(element, key))) {
                        _this._transitionEnd = value;
                    }
                });
            } catch (e) {
                this._animationPrefix = null;
                this._transitionEnd = null;
            }
        }
        GenericBrowserDomAdapter.prototype.getXHR = function () {
            return xhr_impl_1.XHRImpl;
        };
        GenericBrowserDomAdapter.prototype.getDistributedNodes = function (el) {
            return el.getDistributedNodes();
        };
        GenericBrowserDomAdapter.prototype.resolveAndSetHref = function (el, baseUrl, href) {
            el.href = href == null ? baseUrl : baseUrl + '/../' + href;
        };
        GenericBrowserDomAdapter.prototype.supportsDOMEvents = function () {
            return true;
        };
        GenericBrowserDomAdapter.prototype.supportsNativeShadowDOM = function () {
            return lang_1.isFunction(this.defaultDoc().body.createShadowRoot);
        };
        GenericBrowserDomAdapter.prototype.getAnimationPrefix = function () {
            return lang_1.isPresent(this._animationPrefix) ? this._animationPrefix : "";
        };
        GenericBrowserDomAdapter.prototype.getTransitionEnd = function () {
            return lang_1.isPresent(this._transitionEnd) ? this._transitionEnd : "";
        };
        GenericBrowserDomAdapter.prototype.supportsAnimation = function () {
            return lang_1.isPresent(this._animationPrefix) && lang_1.isPresent(this._transitionEnd);
        };
        return GenericBrowserDomAdapter;
    }(dom_adapter_1.DomAdapter);
    exports.GenericBrowserDomAdapter = GenericBrowserDomAdapter;
});
System.registerDynamic('angular2/src/platform/browser/browser_adapter.js', ['angular2/src/facade/collection.js', 'angular2/src/facade/lang.js', 'angular2/src/platform/dom/dom_adapter.js', 'angular2/src/platform/browser/generic_browser_adapter.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var collection_1 = $__require('angular2/src/facade/collection.js');
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var dom_adapter_1 = $__require('angular2/src/platform/dom/dom_adapter.js');
    var generic_browser_adapter_1 = $__require('angular2/src/platform/browser/generic_browser_adapter.js');
    var _attrToPropMap = {
        'class': 'className',
        'innerHtml': 'innerHTML',
        'readonly': 'readOnly',
        'tabindex': 'tabIndex'
    };
    var DOM_KEY_LOCATION_NUMPAD = 3;
    // Map to convert some key or keyIdentifier values to what will be returned by getEventKey
    var _keyMap = {
        // The following values are here for cross-browser compatibility and to match the W3C standard
        // cf http://www.w3.org/TR/DOM-Level-3-Events-key/
        '\b': 'Backspace',
        '\t': 'Tab',
        '\x7F': 'Delete',
        '\x1B': 'Escape',
        'Del': 'Delete',
        'Esc': 'Escape',
        'Left': 'ArrowLeft',
        'Right': 'ArrowRight',
        'Up': 'ArrowUp',
        'Down': 'ArrowDown',
        'Menu': 'ContextMenu',
        'Scroll': 'ScrollLock',
        'Win': 'OS'
    };
    // There is a bug in Chrome for numeric keypad keys:
    // https://code.google.com/p/chromium/issues/detail?id=155654
    // 1, 2, 3 ... are reported as A, B, C ...
    var _chromeNumKeyPadMap = {
        'A': '1',
        'B': '2',
        'C': '3',
        'D': '4',
        'E': '5',
        'F': '6',
        'G': '7',
        'H': '8',
        'I': '9',
        'J': '*',
        'K': '+',
        'M': '-',
        'N': '.',
        'O': '/',
        '\x60': '0',
        '\x90': 'NumLock'
    };
    /**
     * A `DomAdapter` powered by full browser DOM APIs.
     */
    /* tslint:disable:requireParameterType */
    var BrowserDomAdapter = function (_super) {
        __extends(BrowserDomAdapter, _super);
        function BrowserDomAdapter() {
            _super.apply(this, arguments);
        }
        BrowserDomAdapter.prototype.parse = function (templateHtml) {
            throw new Error("parse not implemented");
        };
        BrowserDomAdapter.makeCurrent = function () {
            dom_adapter_1.setRootDomAdapter(new BrowserDomAdapter());
        };
        BrowserDomAdapter.prototype.hasProperty = function (element, name) {
            return name in element;
        };
        BrowserDomAdapter.prototype.setProperty = function (el, name, value) {
            el[name] = value;
        };
        BrowserDomAdapter.prototype.getProperty = function (el, name) {
            return el[name];
        };
        BrowserDomAdapter.prototype.invoke = function (el, methodName, args) {
            el[methodName].apply(el, args);
        };
        // TODO(tbosch): move this into a separate environment class once we have it
        BrowserDomAdapter.prototype.logError = function (error) {
            if (window.console.error) {
                window.console.error(error);
            } else {
                window.console.log(error);
            }
        };
        BrowserDomAdapter.prototype.log = function (error) {
            window.console.log(error);
        };
        BrowserDomAdapter.prototype.logGroup = function (error) {
            if (window.console.group) {
                window.console.group(error);
                this.logError(error);
            } else {
                window.console.log(error);
            }
        };
        BrowserDomAdapter.prototype.logGroupEnd = function () {
            if (window.console.groupEnd) {
                window.console.groupEnd();
            }
        };
        Object.defineProperty(BrowserDomAdapter.prototype, "attrToPropMap", {
            get: function () {
                return _attrToPropMap;
            },
            enumerable: true,
            configurable: true
        });
        BrowserDomAdapter.prototype.query = function (selector) {
            return document.querySelector(selector);
        };
        BrowserDomAdapter.prototype.querySelector = function (el, selector) {
            return el.querySelector(selector);
        };
        BrowserDomAdapter.prototype.querySelectorAll = function (el, selector) {
            return el.querySelectorAll(selector);
        };
        BrowserDomAdapter.prototype.on = function (el, evt, listener) {
            el.addEventListener(evt, listener, false);
        };
        BrowserDomAdapter.prototype.onAndCancel = function (el, evt, listener) {
            el.addEventListener(evt, listener, false);
            // Needed to follow Dart's subscription semantic, until fix of
            // https://code.google.com/p/dart/issues/detail?id=17406
            return function () {
                el.removeEventListener(evt, listener, false);
            };
        };
        BrowserDomAdapter.prototype.dispatchEvent = function (el, evt) {
            el.dispatchEvent(evt);
        };
        BrowserDomAdapter.prototype.createMouseEvent = function (eventType) {
            var evt = document.createEvent('MouseEvent');
            evt.initEvent(eventType, true, true);
            return evt;
        };
        BrowserDomAdapter.prototype.createEvent = function (eventType) {
            var evt = document.createEvent('Event');
            evt.initEvent(eventType, true, true);
            return evt;
        };
        BrowserDomAdapter.prototype.preventDefault = function (evt) {
            evt.preventDefault();
            evt.returnValue = false;
        };
        BrowserDomAdapter.prototype.isPrevented = function (evt) {
            return evt.defaultPrevented || lang_1.isPresent(evt.returnValue) && !evt.returnValue;
        };
        BrowserDomAdapter.prototype.getInnerHTML = function (el) {
            return el.innerHTML;
        };
        BrowserDomAdapter.prototype.getOuterHTML = function (el) {
            return el.outerHTML;
        };
        BrowserDomAdapter.prototype.nodeName = function (node) {
            return node.nodeName;
        };
        BrowserDomAdapter.prototype.nodeValue = function (node) {
            return node.nodeValue;
        };
        BrowserDomAdapter.prototype.type = function (node) {
            return node.type;
        };
        BrowserDomAdapter.prototype.content = function (node) {
            if (this.hasProperty(node, "content")) {
                return node.content;
            } else {
                return node;
            }
        };
        BrowserDomAdapter.prototype.firstChild = function (el) {
            return el.firstChild;
        };
        BrowserDomAdapter.prototype.nextSibling = function (el) {
            return el.nextSibling;
        };
        BrowserDomAdapter.prototype.parentElement = function (el) {
            return el.parentNode;
        };
        BrowserDomAdapter.prototype.childNodes = function (el) {
            return el.childNodes;
        };
        BrowserDomAdapter.prototype.childNodesAsList = function (el) {
            var childNodes = el.childNodes;
            var res = collection_1.ListWrapper.createFixedSize(childNodes.length);
            for (var i = 0; i < childNodes.length; i++) {
                res[i] = childNodes[i];
            }
            return res;
        };
        BrowserDomAdapter.prototype.clearNodes = function (el) {
            while (el.firstChild) {
                el.removeChild(el.firstChild);
            }
        };
        BrowserDomAdapter.prototype.appendChild = function (el, node) {
            el.appendChild(node);
        };
        BrowserDomAdapter.prototype.removeChild = function (el, node) {
            el.removeChild(node);
        };
        BrowserDomAdapter.prototype.replaceChild = function (el, newChild, oldChild) {
            el.replaceChild(newChild, oldChild);
        };
        BrowserDomAdapter.prototype.remove = function (node) {
            if (node.parentNode) {
                node.parentNode.removeChild(node);
            }
            return node;
        };
        BrowserDomAdapter.prototype.insertBefore = function (el, node) {
            el.parentNode.insertBefore(node, el);
        };
        BrowserDomAdapter.prototype.insertAllBefore = function (el, nodes) {
            nodes.forEach(function (n) {
                return el.parentNode.insertBefore(n, el);
            });
        };
        BrowserDomAdapter.prototype.insertAfter = function (el, node) {
            el.parentNode.insertBefore(node, el.nextSibling);
        };
        BrowserDomAdapter.prototype.setInnerHTML = function (el, value) {
            el.innerHTML = value;
        };
        BrowserDomAdapter.prototype.getText = function (el) {
            return el.textContent;
        };
        // TODO(vicb): removed Element type because it does not support StyleElement
        BrowserDomAdapter.prototype.setText = function (el, value) {
            el.textContent = value;
        };
        BrowserDomAdapter.prototype.getValue = function (el) {
            return el.value;
        };
        BrowserDomAdapter.prototype.setValue = function (el, value) {
            el.value = value;
        };
        BrowserDomAdapter.prototype.getChecked = function (el) {
            return el.checked;
        };
        BrowserDomAdapter.prototype.setChecked = function (el, value) {
            el.checked = value;
        };
        BrowserDomAdapter.prototype.createComment = function (text) {
            return document.createComment(text);
        };
        BrowserDomAdapter.prototype.createTemplate = function (html) {
            var t = document.createElement('template');
            t.innerHTML = html;
            return t;
        };
        BrowserDomAdapter.prototype.createElement = function (tagName, doc) {
            if (doc === void 0) {
                doc = document;
            }
            return doc.createElement(tagName);
        };
        BrowserDomAdapter.prototype.createElementNS = function (ns, tagName, doc) {
            if (doc === void 0) {
                doc = document;
            }
            return doc.createElementNS(ns, tagName);
        };
        BrowserDomAdapter.prototype.createTextNode = function (text, doc) {
            if (doc === void 0) {
                doc = document;
            }
            return doc.createTextNode(text);
        };
        BrowserDomAdapter.prototype.createScriptTag = function (attrName, attrValue, doc) {
            if (doc === void 0) {
                doc = document;
            }
            var el = doc.createElement('SCRIPT');
            el.setAttribute(attrName, attrValue);
            return el;
        };
        BrowserDomAdapter.prototype.createStyleElement = function (css, doc) {
            if (doc === void 0) {
                doc = document;
            }
            var style = doc.createElement('style');
            this.appendChild(style, this.createTextNode(css));
            return style;
        };
        BrowserDomAdapter.prototype.createShadowRoot = function (el) {
            return el.createShadowRoot();
        };
        BrowserDomAdapter.prototype.getShadowRoot = function (el) {
            return el.shadowRoot;
        };
        BrowserDomAdapter.prototype.getHost = function (el) {
            return el.host;
        };
        BrowserDomAdapter.prototype.clone = function (node) {
            return node.cloneNode(true);
        };
        BrowserDomAdapter.prototype.getElementsByClassName = function (element, name) {
            return element.getElementsByClassName(name);
        };
        BrowserDomAdapter.prototype.getElementsByTagName = function (element, name) {
            return element.getElementsByTagName(name);
        };
        BrowserDomAdapter.prototype.classList = function (element) {
            return Array.prototype.slice.call(element.classList, 0);
        };
        BrowserDomAdapter.prototype.addClass = function (element, className) {
            element.classList.add(className);
        };
        BrowserDomAdapter.prototype.removeClass = function (element, className) {
            element.classList.remove(className);
        };
        BrowserDomAdapter.prototype.hasClass = function (element, className) {
            return element.classList.contains(className);
        };
        BrowserDomAdapter.prototype.setStyle = function (element, styleName, styleValue) {
            element.style[styleName] = styleValue;
        };
        BrowserDomAdapter.prototype.removeStyle = function (element, stylename) {
            element.style[stylename] = null;
        };
        BrowserDomAdapter.prototype.getStyle = function (element, stylename) {
            return element.style[stylename];
        };
        BrowserDomAdapter.prototype.hasStyle = function (element, styleName, styleValue) {
            if (styleValue === void 0) {
                styleValue = null;
            }
            var value = this.getStyle(element, styleName) || '';
            return styleValue ? value == styleValue : value.length > 0;
        };
        BrowserDomAdapter.prototype.tagName = function (element) {
            return element.tagName;
        };
        BrowserDomAdapter.prototype.attributeMap = function (element) {
            var res = new Map();
            var elAttrs = element.attributes;
            for (var i = 0; i < elAttrs.length; i++) {
                var attrib = elAttrs[i];
                res.set(attrib.name, attrib.value);
            }
            return res;
        };
        BrowserDomAdapter.prototype.hasAttribute = function (element, attribute) {
            return element.hasAttribute(attribute);
        };
        BrowserDomAdapter.prototype.hasAttributeNS = function (element, ns, attribute) {
            return element.hasAttributeNS(ns, attribute);
        };
        BrowserDomAdapter.prototype.getAttribute = function (element, attribute) {
            return element.getAttribute(attribute);
        };
        BrowserDomAdapter.prototype.getAttributeNS = function (element, ns, name) {
            return element.getAttributeNS(ns, name);
        };
        BrowserDomAdapter.prototype.setAttribute = function (element, name, value) {
            element.setAttribute(name, value);
        };
        BrowserDomAdapter.prototype.setAttributeNS = function (element, ns, name, value) {
            element.setAttributeNS(ns, name, value);
        };
        BrowserDomAdapter.prototype.removeAttribute = function (element, attribute) {
            element.removeAttribute(attribute);
        };
        BrowserDomAdapter.prototype.removeAttributeNS = function (element, ns, name) {
            element.removeAttributeNS(ns, name);
        };
        BrowserDomAdapter.prototype.templateAwareRoot = function (el) {
            return this.isTemplateElement(el) ? this.content(el) : el;
        };
        BrowserDomAdapter.prototype.createHtmlDocument = function () {
            return document.implementation.createHTMLDocument('fakeTitle');
        };
        BrowserDomAdapter.prototype.defaultDoc = function () {
            return document;
        };
        BrowserDomAdapter.prototype.getBoundingClientRect = function (el) {
            try {
                return el.getBoundingClientRect();
            } catch (e) {
                return { top: 0, bottom: 0, left: 0, right: 0, width: 0, height: 0 };
            }
        };
        BrowserDomAdapter.prototype.getTitle = function () {
            return document.title;
        };
        BrowserDomAdapter.prototype.setTitle = function (newTitle) {
            document.title = newTitle || '';
        };
        BrowserDomAdapter.prototype.elementMatches = function (n, selector) {
            var matches = false;
            if (n instanceof HTMLElement) {
                if (n.matches) {
                    matches = n.matches(selector);
                } else if (n.msMatchesSelector) {
                    matches = n.msMatchesSelector(selector);
                } else if (n.webkitMatchesSelector) {
                    matches = n.webkitMatchesSelector(selector);
                }
            }
            return matches;
        };
        BrowserDomAdapter.prototype.isTemplateElement = function (el) {
            return el instanceof HTMLElement && el.nodeName == "TEMPLATE";
        };
        BrowserDomAdapter.prototype.isTextNode = function (node) {
            return node.nodeType === Node.TEXT_NODE;
        };
        BrowserDomAdapter.prototype.isCommentNode = function (node) {
            return node.nodeType === Node.COMMENT_NODE;
        };
        BrowserDomAdapter.prototype.isElementNode = function (node) {
            return node.nodeType === Node.ELEMENT_NODE;
        };
        BrowserDomAdapter.prototype.hasShadowRoot = function (node) {
            return node instanceof HTMLElement && lang_1.isPresent(node.shadowRoot);
        };
        BrowserDomAdapter.prototype.isShadowRoot = function (node) {
            return node instanceof DocumentFragment;
        };
        BrowserDomAdapter.prototype.importIntoDoc = function (node) {
            var toImport = node;
            if (this.isTemplateElement(node)) {
                toImport = this.content(node);
            }
            return document.importNode(toImport, true);
        };
        BrowserDomAdapter.prototype.adoptNode = function (node) {
            return document.adoptNode(node);
        };
        BrowserDomAdapter.prototype.getHref = function (el) {
            return el.href;
        };
        BrowserDomAdapter.prototype.getEventKey = function (event) {
            var key = event.key;
            if (lang_1.isBlank(key)) {
                key = event.keyIdentifier;
                // keyIdentifier is defined in the old draft of DOM Level 3 Events implemented by Chrome and
                // Safari
                // cf
                // http://www.w3.org/TR/2007/WD-DOM-Level-3-Events-20071221/events.html#Events-KeyboardEvents-Interfaces
                if (lang_1.isBlank(key)) {
                    return 'Unidentified';
                }
                if (key.startsWith('U+')) {
                    key = String.fromCharCode(parseInt(key.substring(2), 16));
                    if (event.location === DOM_KEY_LOCATION_NUMPAD && _chromeNumKeyPadMap.hasOwnProperty(key)) {
                        // There is a bug in Chrome for numeric keypad keys:
                        // https://code.google.com/p/chromium/issues/detail?id=155654
                        // 1, 2, 3 ... are reported as A, B, C ...
                        key = _chromeNumKeyPadMap[key];
                    }
                }
            }
            if (_keyMap.hasOwnProperty(key)) {
                key = _keyMap[key];
            }
            return key;
        };
        BrowserDomAdapter.prototype.getGlobalEventTarget = function (target) {
            if (target == "window") {
                return window;
            } else if (target == "document") {
                return document;
            } else if (target == "body") {
                return document.body;
            }
        };
        BrowserDomAdapter.prototype.getHistory = function () {
            return window.history;
        };
        BrowserDomAdapter.prototype.getLocation = function () {
            return window.location;
        };
        BrowserDomAdapter.prototype.getBaseHref = function () {
            var href = getBaseElementHref();
            if (lang_1.isBlank(href)) {
                return null;
            }
            return relativePath(href);
        };
        BrowserDomAdapter.prototype.resetBaseElement = function () {
            baseElement = null;
        };
        BrowserDomAdapter.prototype.getUserAgent = function () {
            return window.navigator.userAgent;
        };
        BrowserDomAdapter.prototype.setData = function (element, name, value) {
            this.setAttribute(element, 'data-' + name, value);
        };
        BrowserDomAdapter.prototype.getData = function (element, name) {
            return this.getAttribute(element, 'data-' + name);
        };
        BrowserDomAdapter.prototype.getComputedStyle = function (element) {
            return getComputedStyle(element);
        };
        // TODO(tbosch): move this into a separate environment class once we have it
        BrowserDomAdapter.prototype.setGlobalVar = function (path, value) {
            lang_1.setValueOnPath(lang_1.global, path, value);
        };
        BrowserDomAdapter.prototype.requestAnimationFrame = function (callback) {
            return window.requestAnimationFrame(callback);
        };
        BrowserDomAdapter.prototype.cancelAnimationFrame = function (id) {
            window.cancelAnimationFrame(id);
        };
        BrowserDomAdapter.prototype.performanceNow = function () {
            // performance.now() is not available in all browsers, see
            // http://caniuse.com/#search=performance.now
            if (lang_1.isPresent(window.performance) && lang_1.isPresent(window.performance.now)) {
                return window.performance.now();
            } else {
                return lang_1.DateWrapper.toMillis(lang_1.DateWrapper.now());
            }
        };
        return BrowserDomAdapter;
    }(generic_browser_adapter_1.GenericBrowserDomAdapter);
    exports.BrowserDomAdapter = BrowserDomAdapter;
    var baseElement = null;
    function getBaseElementHref() {
        if (lang_1.isBlank(baseElement)) {
            baseElement = document.querySelector('base');
            if (lang_1.isBlank(baseElement)) {
                return null;
            }
        }
        return baseElement.getAttribute('href');
    }
    // based on urlUtils.js in AngularJS 1
    var urlParsingNode = null;
    function relativePath(url) {
        if (lang_1.isBlank(urlParsingNode)) {
            urlParsingNode = document.createElement("a");
        }
        urlParsingNode.setAttribute('href', url);
        return urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname;
    }
});
System.registerDynamic('angular2/src/platform/browser/testability.js', ['angular2/src/facade/collection.js', 'angular2/src/facade/lang.js', 'angular2/src/platform/dom/dom_adapter.js', 'angular2/core.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var collection_1 = $__require('angular2/src/facade/collection.js');
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var dom_adapter_1 = $__require('angular2/src/platform/dom/dom_adapter.js');
    var core_1 = $__require('angular2/core.js');
    var PublicTestability = function () {
        function PublicTestability(testability) {
            this._testability = testability;
        }
        PublicTestability.prototype.isStable = function () {
            return this._testability.isStable();
        };
        PublicTestability.prototype.whenStable = function (callback) {
            this._testability.whenStable(callback);
        };
        PublicTestability.prototype.findBindings = function (using, provider, exactMatch) {
            return this.findProviders(using, provider, exactMatch);
        };
        PublicTestability.prototype.findProviders = function (using, provider, exactMatch) {
            return this._testability.findBindings(using, provider, exactMatch);
        };
        return PublicTestability;
    }();
    var BrowserGetTestability = function () {
        function BrowserGetTestability() {}
        BrowserGetTestability.init = function () {
            core_1.setTestabilityGetter(new BrowserGetTestability());
        };
        BrowserGetTestability.prototype.addToWindow = function (registry) {
            lang_1.global.getAngularTestability = function (elem, findInAncestors) {
                if (findInAncestors === void 0) {
                    findInAncestors = true;
                }
                var testability = registry.findTestabilityInTree(elem, findInAncestors);
                if (testability == null) {
                    throw new Error('Could not find testability for element.');
                }
                return new PublicTestability(testability);
            };
            lang_1.global.getAllAngularTestabilities = function () {
                var testabilities = registry.getAllTestabilities();
                return testabilities.map(function (testability) {
                    return new PublicTestability(testability);
                });
            };
            lang_1.global.getAllAngularRootElements = function () {
                return registry.getAllRootElements();
            };
            var whenAllStable = function (callback) {
                var testabilities = lang_1.global.getAllAngularTestabilities();
                var count = testabilities.length;
                var didWork = false;
                var decrement = function (didWork_) {
                    didWork = didWork || didWork_;
                    count--;
                    if (count == 0) {
                        callback(didWork);
                    }
                };
                testabilities.forEach(function (testability) {
                    testability.whenStable(decrement);
                });
            };
            if (!lang_1.global.frameworkStabilizers) {
                lang_1.global.frameworkStabilizers = collection_1.ListWrapper.createGrowableSize(0);
            }
            lang_1.global.frameworkStabilizers.push(whenAllStable);
        };
        BrowserGetTestability.prototype.findTestabilityInTree = function (registry, elem, findInAncestors) {
            if (elem == null) {
                return null;
            }
            var t = registry.getTestability(elem);
            if (lang_1.isPresent(t)) {
                return t;
            } else if (!findInAncestors) {
                return null;
            }
            if (dom_adapter_1.DOM.isShadowRoot(elem)) {
                return this.findTestabilityInTree(registry, dom_adapter_1.DOM.getHost(elem), true);
            }
            return this.findTestabilityInTree(registry, dom_adapter_1.DOM.parentElement(elem), true);
        };
        return BrowserGetTestability;
    }();
    exports.BrowserGetTestability = BrowserGetTestability;
});
System.registerDynamic('angular2/src/platform/browser/xhr_cache.js', ['angular2/src/compiler/xhr.js', 'angular2/src/facade/exceptions.js', 'angular2/src/facade/lang.js', 'angular2/src/facade/promise.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var xhr_1 = $__require('angular2/src/compiler/xhr.js');
    var exceptions_1 = $__require('angular2/src/facade/exceptions.js');
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var promise_1 = $__require('angular2/src/facade/promise.js');
    /**
     * An implementation of XHR that uses a template cache to avoid doing an actual
     * XHR.
     *
     * The template cache needs to be built and loaded into window.$templateCache
     * via a separate mechanism.
     */
    var CachedXHR = function (_super) {
        __extends(CachedXHR, _super);
        function CachedXHR() {
            _super.call(this);
            this._cache = lang_1.global.$templateCache;
            if (this._cache == null) {
                throw new exceptions_1.BaseException('CachedXHR: Template cache was not found in $templateCache.');
            }
        }
        CachedXHR.prototype.get = function (url) {
            if (this._cache.hasOwnProperty(url)) {
                return promise_1.PromiseWrapper.resolve(this._cache[url]);
            } else {
                return promise_1.PromiseWrapper.reject('CachedXHR: Did not find cached template for ' + url, null);
            }
        };
        return CachedXHR;
    }(xhr_1.XHR);
    exports.CachedXHR = CachedXHR;
});
System.registerDynamic("angular2/src/core/profile/wtf_init.js", [], true, function ($__require, exports, module) {
  'use strict';"use strict";
  /**
   * This is here because DART requires it. It is noop in JS.
   */

  var global = this || self,
      GLOBAL = global;
  function wtfInit() {}
  exports.wtfInit = wtfInit;
});
System.registerDynamic("angular2/src/platform/dom/events/dom_events.js", ["angular2/src/platform/dom/dom_adapter.js", "angular2/core.js", "angular2/src/platform/dom/events/event_manager.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var dom_adapter_1 = $__require("angular2/src/platform/dom/dom_adapter.js");
    var core_1 = $__require("angular2/core.js");
    var event_manager_1 = $__require("angular2/src/platform/dom/events/event_manager.js");
    var DomEventsPlugin = function (_super) {
        __extends(DomEventsPlugin, _super);
        function DomEventsPlugin() {
            _super.apply(this, arguments);
        }
        // This plugin should come last in the list of plugins, because it accepts all
        // events.
        DomEventsPlugin.prototype.supports = function (eventName) {
            return true;
        };
        DomEventsPlugin.prototype.addEventListener = function (element, eventName, handler) {
            var zone = this.manager.getZone();
            var outsideHandler = function (event) {
                return zone.run(function () {
                    return handler(event);
                });
            };
            return this.manager.getZone().runOutsideAngular(function () {
                return dom_adapter_1.DOM.onAndCancel(element, eventName, outsideHandler);
            });
        };
        DomEventsPlugin.prototype.addGlobalEventListener = function (target, eventName, handler) {
            var element = dom_adapter_1.DOM.getGlobalEventTarget(target);
            var zone = this.manager.getZone();
            var outsideHandler = function (event) {
                return zone.run(function () {
                    return handler(event);
                });
            };
            return this.manager.getZone().runOutsideAngular(function () {
                return dom_adapter_1.DOM.onAndCancel(element, eventName, outsideHandler);
            });
        };
        DomEventsPlugin = __decorate([core_1.Injectable(), __metadata('design:paramtypes', [])], DomEventsPlugin);
        return DomEventsPlugin;
    }(event_manager_1.EventManagerPlugin);
    exports.DomEventsPlugin = DomEventsPlugin;
});
System.registerDynamic('angular2/src/platform/dom/debug/by.js', ['angular2/src/facade/lang.js', 'angular2/src/platform/dom/dom_adapter.js'], true, function ($__require, exports, module) {
  'use strict';"use strict";

  var global = this || self,
      GLOBAL = global;
  var lang_1 = $__require('angular2/src/facade/lang.js');
  var dom_adapter_1 = $__require('angular2/src/platform/dom/dom_adapter.js');
  /**
   * Predicates for use with {@link DebugElement}'s query functions.
   */
  var By = function () {
    function By() {}
    /**
     * Match all elements.
     *
     * ## Example
     *
     * {@example platform/dom/debug/ts/by/by.ts region='by_all'}
     */
    By.all = function () {
      return function (debugElement) {
        return true;
      };
    };
    /**
     * Match elements by the given CSS selector.
     *
     * ## Example
     *
     * {@example platform/dom/debug/ts/by/by.ts region='by_css'}
     */
    By.css = function (selector) {
      return function (debugElement) {
        return lang_1.isPresent(debugElement.nativeElement) ? dom_adapter_1.DOM.elementMatches(debugElement.nativeElement, selector) : false;
      };
    };
    /**
     * Match elements that have the given directive present.
     *
     * ## Example
     *
     * {@example platform/dom/debug/ts/by/by.ts region='by_directive'}
     */
    By.directive = function (type) {
      return function (debugElement) {
        return debugElement.providerTokens.indexOf(type) !== -1;
      };
    };
    return By;
  }();
  exports.By = By;
});
System.registerDynamic("angular2/src/animate/css_animation_options.js", [], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var CssAnimationOptions = function () {
        function CssAnimationOptions() {
            /** classes to be added to the element */
            this.classesToAdd = [];
            /** classes to be removed from the element */
            this.classesToRemove = [];
            /** classes to be added for the duration of the animation */
            this.animationClasses = [];
        }
        return CssAnimationOptions;
    }();
    exports.CssAnimationOptions = CssAnimationOptions;
});
System.registerDynamic('angular2/src/animate/animation.js', ['angular2/src/facade/lang.js', 'angular2/src/facade/math.js', 'angular2/src/platform/dom/util.js', 'angular2/src/facade/collection.js', 'angular2/src/platform/dom/dom_adapter.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var math_1 = $__require('angular2/src/facade/math.js');
    var util_1 = $__require('angular2/src/platform/dom/util.js');
    var collection_1 = $__require('angular2/src/facade/collection.js');
    var dom_adapter_1 = $__require('angular2/src/platform/dom/dom_adapter.js');
    var Animation = function () {
        /**
         * Stores the start time and starts the animation
         * @param element
         * @param data
         * @param browserDetails
         */
        function Animation(element, data, browserDetails) {
            var _this = this;
            this.element = element;
            this.data = data;
            this.browserDetails = browserDetails;
            /** functions to be called upon completion */
            this.callbacks = [];
            /** functions for removing event listeners */
            this.eventClearFunctions = [];
            /** flag used to track whether or not the animation has finished */
            this.completed = false;
            this._stringPrefix = '';
            this.startTime = lang_1.DateWrapper.toMillis(lang_1.DateWrapper.now());
            this._stringPrefix = dom_adapter_1.DOM.getAnimationPrefix();
            this.setup();
            this.wait(function (timestamp) {
                return _this.start();
            });
        }
        Object.defineProperty(Animation.prototype, "totalTime", {
            /** total amount of time that the animation should take including delay */
            get: function () {
                var delay = this.computedDelay != null ? this.computedDelay : 0;
                var duration = this.computedDuration != null ? this.computedDuration : 0;
                return delay + duration;
            },
            enumerable: true,
            configurable: true
        });
        Animation.prototype.wait = function (callback) {
            // Firefox requires 2 frames for some reason
            this.browserDetails.raf(callback, 2);
        };
        /**
         * Sets up the initial styles before the animation is started
         */
        Animation.prototype.setup = function () {
            if (this.data.fromStyles != null) this.applyStyles(this.data.fromStyles);
            if (this.data.duration != null) this.applyStyles({ 'transitionDuration': this.data.duration.toString() + 'ms' });
            if (this.data.delay != null) this.applyStyles({ 'transitionDelay': this.data.delay.toString() + 'ms' });
        };
        /**
         * After the initial setup has occurred, this method adds the animation styles
         */
        Animation.prototype.start = function () {
            this.addClasses(this.data.classesToAdd);
            this.addClasses(this.data.animationClasses);
            this.removeClasses(this.data.classesToRemove);
            if (this.data.toStyles != null) this.applyStyles(this.data.toStyles);
            var computedStyles = dom_adapter_1.DOM.getComputedStyle(this.element);
            this.computedDelay = math_1.Math.max(this.parseDurationString(computedStyles.getPropertyValue(this._stringPrefix + 'transition-delay')), this.parseDurationString(this.element.style.getPropertyValue(this._stringPrefix + 'transition-delay')));
            this.computedDuration = math_1.Math.max(this.parseDurationString(computedStyles.getPropertyValue(this._stringPrefix + 'transition-duration')), this.parseDurationString(this.element.style.getPropertyValue(this._stringPrefix + 'transition-duration')));
            this.addEvents();
        };
        /**
         * Applies the provided styles to the element
         * @param styles
         */
        Animation.prototype.applyStyles = function (styles) {
            var _this = this;
            collection_1.StringMapWrapper.forEach(styles, function (value, key) {
                var dashCaseKey = util_1.camelCaseToDashCase(key);
                if (lang_1.isPresent(dom_adapter_1.DOM.getStyle(_this.element, dashCaseKey))) {
                    dom_adapter_1.DOM.setStyle(_this.element, dashCaseKey, value.toString());
                } else {
                    dom_adapter_1.DOM.setStyle(_this.element, _this._stringPrefix + dashCaseKey, value.toString());
                }
            });
        };
        /**
         * Adds the provided classes to the element
         * @param classes
         */
        Animation.prototype.addClasses = function (classes) {
            for (var i = 0, len = classes.length; i < len; i++) dom_adapter_1.DOM.addClass(this.element, classes[i]);
        };
        /**
         * Removes the provided classes from the element
         * @param classes
         */
        Animation.prototype.removeClasses = function (classes) {
            for (var i = 0, len = classes.length; i < len; i++) dom_adapter_1.DOM.removeClass(this.element, classes[i]);
        };
        /**
         * Adds events to track when animations have finished
         */
        Animation.prototype.addEvents = function () {
            var _this = this;
            if (this.totalTime > 0) {
                this.eventClearFunctions.push(dom_adapter_1.DOM.onAndCancel(this.element, dom_adapter_1.DOM.getTransitionEnd(), function (event) {
                    return _this.handleAnimationEvent(event);
                }));
            } else {
                this.handleAnimationCompleted();
            }
        };
        Animation.prototype.handleAnimationEvent = function (event) {
            var elapsedTime = math_1.Math.round(event.elapsedTime * 1000);
            if (!this.browserDetails.elapsedTimeIncludesDelay) elapsedTime += this.computedDelay;
            event.stopPropagation();
            if (elapsedTime >= this.totalTime) this.handleAnimationCompleted();
        };
        /**
         * Runs all animation callbacks and removes temporary classes
         */
        Animation.prototype.handleAnimationCompleted = function () {
            this.removeClasses(this.data.animationClasses);
            this.callbacks.forEach(function (callback) {
                return callback();
            });
            this.callbacks = [];
            this.eventClearFunctions.forEach(function (fn) {
                return fn();
            });
            this.eventClearFunctions = [];
            this.completed = true;
        };
        /**
         * Adds animation callbacks to be called upon completion
         * @param callback
         * @returns {Animation}
         */
        Animation.prototype.onComplete = function (callback) {
            if (this.completed) {
                callback();
            } else {
                this.callbacks.push(callback);
            }
            return this;
        };
        /**
         * Converts the duration string to the number of milliseconds
         * @param duration
         * @returns {number}
         */
        Animation.prototype.parseDurationString = function (duration) {
            var maxValue = 0;
            // duration must have at least 2 characters to be valid. (number + type)
            if (duration == null || duration.length < 2) {
                return maxValue;
            } else if (duration.substring(duration.length - 2) == 'ms') {
                var value = lang_1.NumberWrapper.parseInt(this.stripLetters(duration), 10);
                if (value > maxValue) maxValue = value;
            } else if (duration.substring(duration.length - 1) == 's') {
                var ms = lang_1.NumberWrapper.parseFloat(this.stripLetters(duration)) * 1000;
                var value = math_1.Math.floor(ms);
                if (value > maxValue) maxValue = value;
            }
            return maxValue;
        };
        /**
         * Strips the letters from the duration string
         * @param str
         * @returns {string}
         */
        Animation.prototype.stripLetters = function (str) {
            return lang_1.StringWrapper.replaceAll(str, lang_1.RegExpWrapper.create('[^0-9]+$', ''), '');
        };
        return Animation;
    }();
    exports.Animation = Animation;
});
System.registerDynamic('angular2/src/animate/css_animation_builder.js', ['angular2/src/animate/css_animation_options.js', 'angular2/src/animate/animation.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var css_animation_options_1 = $__require('angular2/src/animate/css_animation_options.js');
    var animation_1 = $__require('angular2/src/animate/animation.js');
    var CssAnimationBuilder = function () {
        /**
         * Accepts public properties for CssAnimationBuilder
         */
        function CssAnimationBuilder(browserDetails) {
            this.browserDetails = browserDetails;
            /** @type {CssAnimationOptions} */
            this.data = new css_animation_options_1.CssAnimationOptions();
        }
        /**
         * Adds a temporary class that will be removed at the end of the animation
         * @param className
         */
        CssAnimationBuilder.prototype.addAnimationClass = function (className) {
            this.data.animationClasses.push(className);
            return this;
        };
        /**
         * Adds a class that will remain on the element after the animation has finished
         * @param className
         */
        CssAnimationBuilder.prototype.addClass = function (className) {
            this.data.classesToAdd.push(className);
            return this;
        };
        /**
         * Removes a class from the element
         * @param className
         */
        CssAnimationBuilder.prototype.removeClass = function (className) {
            this.data.classesToRemove.push(className);
            return this;
        };
        /**
         * Sets the animation duration (and overrides any defined through CSS)
         * @param duration
         */
        CssAnimationBuilder.prototype.setDuration = function (duration) {
            this.data.duration = duration;
            return this;
        };
        /**
         * Sets the animation delay (and overrides any defined through CSS)
         * @param delay
         */
        CssAnimationBuilder.prototype.setDelay = function (delay) {
            this.data.delay = delay;
            return this;
        };
        /**
         * Sets styles for both the initial state and the destination state
         * @param from
         * @param to
         */
        CssAnimationBuilder.prototype.setStyles = function (from, to) {
            return this.setFromStyles(from).setToStyles(to);
        };
        /**
         * Sets the initial styles for the animation
         * @param from
         */
        CssAnimationBuilder.prototype.setFromStyles = function (from) {
            this.data.fromStyles = from;
            return this;
        };
        /**
         * Sets the destination styles for the animation
         * @param to
         */
        CssAnimationBuilder.prototype.setToStyles = function (to) {
            this.data.toStyles = to;
            return this;
        };
        /**
         * Starts the animation and returns a promise
         * @param element
         */
        CssAnimationBuilder.prototype.start = function (element) {
            return new animation_1.Animation(element, this.data, this.browserDetails);
        };
        return CssAnimationBuilder;
    }();
    exports.CssAnimationBuilder = CssAnimationBuilder;
});
System.registerDynamic('angular2/src/facade/math.js', ['angular2/src/facade/lang.js'], true, function ($__require, exports, module) {
  'use strict';"use strict";

  var global = this || self,
      GLOBAL = global;
  var lang_1 = $__require('angular2/src/facade/lang.js');
  exports.Math = lang_1.global.Math;
  exports.NaN = typeof exports.NaN;
});
System.registerDynamic("angular2/src/animate/browser_details.js", ["angular2/src/core/di.js", "angular2/src/facade/math.js", "angular2/src/platform/dom/dom_adapter.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var di_1 = $__require("angular2/src/core/di.js");
    var math_1 = $__require("angular2/src/facade/math.js");
    var dom_adapter_1 = $__require("angular2/src/platform/dom/dom_adapter.js");
    var BrowserDetails = function () {
        function BrowserDetails() {
            this.elapsedTimeIncludesDelay = false;
            this.doesElapsedTimeIncludesDelay();
        }
        /**
         * Determines if `event.elapsedTime` includes transition delay in the current browser.  At this
         * time, Chrome and Opera seem to be the only browsers that include this.
         */
        BrowserDetails.prototype.doesElapsedTimeIncludesDelay = function () {
            var _this = this;
            var div = dom_adapter_1.DOM.createElement('div');
            dom_adapter_1.DOM.setAttribute(div, 'style', "position: absolute; top: -9999px; left: -9999px; width: 1px;\n      height: 1px; transition: all 1ms linear 1ms;");
            // Firefox requires that we wait for 2 frames for some reason
            this.raf(function (timestamp) {
                dom_adapter_1.DOM.on(div, 'transitionend', function (event) {
                    var elapsed = math_1.Math.round(event.elapsedTime * 1000);
                    _this.elapsedTimeIncludesDelay = elapsed == 2;
                    dom_adapter_1.DOM.remove(div);
                });
                dom_adapter_1.DOM.setStyle(div, 'width', '2px');
            }, 2);
        };
        BrowserDetails.prototype.raf = function (callback, frames) {
            if (frames === void 0) {
                frames = 1;
            }
            var queue = new RafQueue(callback, frames);
            return function () {
                return queue.cancel();
            };
        };
        BrowserDetails = __decorate([di_1.Injectable(), __metadata('design:paramtypes', [])], BrowserDetails);
        return BrowserDetails;
    }();
    exports.BrowserDetails = BrowserDetails;
    var RafQueue = function () {
        function RafQueue(callback, frames) {
            this.callback = callback;
            this.frames = frames;
            this._raf();
        }
        RafQueue.prototype._raf = function () {
            var _this = this;
            this.currentFrameId = dom_adapter_1.DOM.requestAnimationFrame(function (timestamp) {
                return _this._nextFrame(timestamp);
            });
        };
        RafQueue.prototype._nextFrame = function (timestamp) {
            this.frames--;
            if (this.frames > 0) {
                this._raf();
            } else {
                this.callback(timestamp);
            }
        };
        RafQueue.prototype.cancel = function () {
            dom_adapter_1.DOM.cancelAnimationFrame(this.currentFrameId);
            this.currentFrameId = null;
        };
        return RafQueue;
    }();
});
System.registerDynamic("angular2/src/animate/animation_builder.js", ["angular2/src/core/di.js", "angular2/src/animate/css_animation_builder.js", "angular2/src/animate/browser_details.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var di_1 = $__require("angular2/src/core/di.js");
    var css_animation_builder_1 = $__require("angular2/src/animate/css_animation_builder.js");
    var browser_details_1 = $__require("angular2/src/animate/browser_details.js");
    var AnimationBuilder = function () {
        /**
         * Used for DI
         * @param browserDetails
         */
        function AnimationBuilder(browserDetails) {
            this.browserDetails = browserDetails;
        }
        /**
         * Creates a new CSS Animation
         * @returns {CssAnimationBuilder}
         */
        AnimationBuilder.prototype.css = function () {
            return new css_animation_builder_1.CssAnimationBuilder(this.browserDetails);
        };
        AnimationBuilder = __decorate([di_1.Injectable(), __metadata('design:paramtypes', [browser_details_1.BrowserDetails])], AnimationBuilder);
        return AnimationBuilder;
    }();
    exports.AnimationBuilder = AnimationBuilder;
});
System.registerDynamic("angular2/src/platform/dom/shared_styles_host.js", ["angular2/src/platform/dom/dom_adapter.js", "angular2/src/core/di.js", "angular2/src/facade/collection.js", "angular2/src/platform/dom/dom_tokens.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var __param = this && this.__param || function (paramIndex, decorator) {
        return function (target, key) {
            decorator(target, key, paramIndex);
        };
    };
    var dom_adapter_1 = $__require("angular2/src/platform/dom/dom_adapter.js");
    var di_1 = $__require("angular2/src/core/di.js");
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var dom_tokens_1 = $__require("angular2/src/platform/dom/dom_tokens.js");
    var SharedStylesHost = function () {
        function SharedStylesHost() {
            /** @internal */
            this._styles = [];
            /** @internal */
            this._stylesSet = new Set();
        }
        SharedStylesHost.prototype.addStyles = function (styles) {
            var _this = this;
            var additions = [];
            styles.forEach(function (style) {
                if (!collection_1.SetWrapper.has(_this._stylesSet, style)) {
                    _this._stylesSet.add(style);
                    _this._styles.push(style);
                    additions.push(style);
                }
            });
            this.onStylesAdded(additions);
        };
        SharedStylesHost.prototype.onStylesAdded = function (additions) {};
        SharedStylesHost.prototype.getAllStyles = function () {
            return this._styles;
        };
        SharedStylesHost = __decorate([di_1.Injectable(), __metadata('design:paramtypes', [])], SharedStylesHost);
        return SharedStylesHost;
    }();
    exports.SharedStylesHost = SharedStylesHost;
    var DomSharedStylesHost = function (_super) {
        __extends(DomSharedStylesHost, _super);
        function DomSharedStylesHost(doc) {
            _super.call(this);
            this._hostNodes = new Set();
            this._hostNodes.add(doc.head);
        }
        /** @internal */
        DomSharedStylesHost.prototype._addStylesToHost = function (styles, host) {
            for (var i = 0; i < styles.length; i++) {
                var style = styles[i];
                dom_adapter_1.DOM.appendChild(host, dom_adapter_1.DOM.createStyleElement(style));
            }
        };
        DomSharedStylesHost.prototype.addHost = function (hostNode) {
            this._addStylesToHost(this._styles, hostNode);
            this._hostNodes.add(hostNode);
        };
        DomSharedStylesHost.prototype.removeHost = function (hostNode) {
            collection_1.SetWrapper.delete(this._hostNodes, hostNode);
        };
        DomSharedStylesHost.prototype.onStylesAdded = function (additions) {
            var _this = this;
            this._hostNodes.forEach(function (hostNode) {
                _this._addStylesToHost(additions, hostNode);
            });
        };
        DomSharedStylesHost = __decorate([di_1.Injectable(), __param(0, di_1.Inject(dom_tokens_1.DOCUMENT)), __metadata('design:paramtypes', [Object])], DomSharedStylesHost);
        return DomSharedStylesHost;
    }(SharedStylesHost);
    exports.DomSharedStylesHost = DomSharedStylesHost;
});
System.registerDynamic('angular2/src/platform/dom/dom_tokens.js', ['angular2/src/core/di.js', 'angular2/src/facade/lang.js'], true, function ($__require, exports, module) {
  'use strict';"use strict";

  var global = this || self,
      GLOBAL = global;
  var di_1 = $__require('angular2/src/core/di.js');
  var lang_1 = $__require('angular2/src/facade/lang.js');
  /**
   * A DI Token representing the main rendering context. In a browser this is the DOM Document.
   *
   * Note: Document might not be available in the Application Context when Application and Rendering
   * Contexts are not the same (e.g. when running the application into a Web Worker).
   */
  exports.DOCUMENT = lang_1.CONST_EXPR(new di_1.OpaqueToken('DocumentToken'));
});
System.registerDynamic('angular2/src/platform/dom/util.js', ['angular2/src/facade/lang.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var CAMEL_CASE_REGEXP = /([A-Z])/g;
    var DASH_CASE_REGEXP = /-([a-z])/g;
    function camelCaseToDashCase(input) {
        return lang_1.StringWrapper.replaceAllMapped(input, CAMEL_CASE_REGEXP, function (m) {
            return '-' + m[1].toLowerCase();
        });
    }
    exports.camelCaseToDashCase = camelCaseToDashCase;
    function dashCaseToCamelCase(input) {
        return lang_1.StringWrapper.replaceAllMapped(input, DASH_CASE_REGEXP, function (m) {
            return m[1].toUpperCase();
        });
    }
    exports.dashCaseToCamelCase = dashCaseToCamelCase;
});
System.registerDynamic("angular2/src/platform/dom/dom_renderer.js", ["angular2/src/core/di.js", "angular2/src/animate/animation_builder.js", "angular2/src/facade/lang.js", "angular2/src/facade/exceptions.js", "angular2/src/platform/dom/shared_styles_host.js", "angular2/src/platform/dom/events/event_manager.js", "angular2/src/platform/dom/dom_tokens.js", "angular2/src/core/metadata.js", "angular2/src/platform/dom/dom_adapter.js", "angular2/src/platform/dom/util.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var __param = this && this.__param || function (paramIndex, decorator) {
        return function (target, key) {
            decorator(target, key, paramIndex);
        };
    };
    var di_1 = $__require("angular2/src/core/di.js");
    var animation_builder_1 = $__require("angular2/src/animate/animation_builder.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var exceptions_1 = $__require("angular2/src/facade/exceptions.js");
    var shared_styles_host_1 = $__require("angular2/src/platform/dom/shared_styles_host.js");
    var event_manager_1 = $__require("angular2/src/platform/dom/events/event_manager.js");
    var dom_tokens_1 = $__require("angular2/src/platform/dom/dom_tokens.js");
    var metadata_1 = $__require("angular2/src/core/metadata.js");
    var dom_adapter_1 = $__require("angular2/src/platform/dom/dom_adapter.js");
    var util_1 = $__require("angular2/src/platform/dom/util.js");
    var NAMESPACE_URIS = lang_1.CONST_EXPR({ 'xlink': 'http://www.w3.org/1999/xlink', 'svg': 'http://www.w3.org/2000/svg' });
    var TEMPLATE_COMMENT_TEXT = 'template bindings={}';
    var TEMPLATE_BINDINGS_EXP = /^template bindings=(.*)$/g;
    var DomRootRenderer = function () {
        function DomRootRenderer(document, eventManager, sharedStylesHost, animate) {
            this.document = document;
            this.eventManager = eventManager;
            this.sharedStylesHost = sharedStylesHost;
            this.animate = animate;
            this._registeredComponents = new Map();
        }
        DomRootRenderer.prototype.renderComponent = function (componentProto) {
            var renderer = this._registeredComponents.get(componentProto.id);
            if (lang_1.isBlank(renderer)) {
                renderer = new DomRenderer(this, componentProto);
                this._registeredComponents.set(componentProto.id, renderer);
            }
            return renderer;
        };
        return DomRootRenderer;
    }();
    exports.DomRootRenderer = DomRootRenderer;
    var DomRootRenderer_ = function (_super) {
        __extends(DomRootRenderer_, _super);
        function DomRootRenderer_(_document, _eventManager, sharedStylesHost, animate) {
            _super.call(this, _document, _eventManager, sharedStylesHost, animate);
        }
        DomRootRenderer_ = __decorate([di_1.Injectable(), __param(0, di_1.Inject(dom_tokens_1.DOCUMENT)), __metadata('design:paramtypes', [Object, event_manager_1.EventManager, shared_styles_host_1.DomSharedStylesHost, animation_builder_1.AnimationBuilder])], DomRootRenderer_);
        return DomRootRenderer_;
    }(DomRootRenderer);
    exports.DomRootRenderer_ = DomRootRenderer_;
    var DomRenderer = function () {
        function DomRenderer(_rootRenderer, componentProto) {
            this._rootRenderer = _rootRenderer;
            this.componentProto = componentProto;
            this._styles = _flattenStyles(componentProto.id, componentProto.styles, []);
            if (componentProto.encapsulation !== metadata_1.ViewEncapsulation.Native) {
                this._rootRenderer.sharedStylesHost.addStyles(this._styles);
            }
            if (this.componentProto.encapsulation === metadata_1.ViewEncapsulation.Emulated) {
                this._contentAttr = _shimContentAttribute(componentProto.id);
                this._hostAttr = _shimHostAttribute(componentProto.id);
            } else {
                this._contentAttr = null;
                this._hostAttr = null;
            }
        }
        DomRenderer.prototype.renderComponent = function (componentProto) {
            return this._rootRenderer.renderComponent(componentProto);
        };
        DomRenderer.prototype.selectRootElement = function (selector) {
            var el = dom_adapter_1.DOM.querySelector(this._rootRenderer.document, selector);
            if (lang_1.isBlank(el)) {
                throw new exceptions_1.BaseException("The selector \"" + selector + "\" did not match any elements");
            }
            dom_adapter_1.DOM.clearNodes(el);
            return el;
        };
        DomRenderer.prototype.createElement = function (parent, name) {
            var nsAndName = splitNamespace(name);
            var el = lang_1.isPresent(nsAndName[0]) ? dom_adapter_1.DOM.createElementNS(NAMESPACE_URIS[nsAndName[0]], nsAndName[1]) : dom_adapter_1.DOM.createElement(nsAndName[1]);
            if (lang_1.isPresent(this._contentAttr)) {
                dom_adapter_1.DOM.setAttribute(el, this._contentAttr, '');
            }
            if (lang_1.isPresent(parent)) {
                dom_adapter_1.DOM.appendChild(parent, el);
            }
            return el;
        };
        DomRenderer.prototype.createViewRoot = function (hostElement) {
            var nodesParent;
            if (this.componentProto.encapsulation === metadata_1.ViewEncapsulation.Native) {
                nodesParent = dom_adapter_1.DOM.createShadowRoot(hostElement);
                this._rootRenderer.sharedStylesHost.addHost(nodesParent);
                for (var i = 0; i < this._styles.length; i++) {
                    dom_adapter_1.DOM.appendChild(nodesParent, dom_adapter_1.DOM.createStyleElement(this._styles[i]));
                }
            } else {
                if (lang_1.isPresent(this._hostAttr)) {
                    dom_adapter_1.DOM.setAttribute(hostElement, this._hostAttr, '');
                }
                nodesParent = hostElement;
            }
            return nodesParent;
        };
        DomRenderer.prototype.createTemplateAnchor = function (parentElement) {
            var comment = dom_adapter_1.DOM.createComment(TEMPLATE_COMMENT_TEXT);
            if (lang_1.isPresent(parentElement)) {
                dom_adapter_1.DOM.appendChild(parentElement, comment);
            }
            return comment;
        };
        DomRenderer.prototype.createText = function (parentElement, value) {
            var node = dom_adapter_1.DOM.createTextNode(value);
            if (lang_1.isPresent(parentElement)) {
                dom_adapter_1.DOM.appendChild(parentElement, node);
            }
            return node;
        };
        DomRenderer.prototype.projectNodes = function (parentElement, nodes) {
            if (lang_1.isBlank(parentElement)) return;
            appendNodes(parentElement, nodes);
        };
        DomRenderer.prototype.attachViewAfter = function (node, viewRootNodes) {
            moveNodesAfterSibling(node, viewRootNodes);
            for (var i = 0; i < viewRootNodes.length; i++) this.animateNodeEnter(viewRootNodes[i]);
        };
        DomRenderer.prototype.detachView = function (viewRootNodes) {
            for (var i = 0; i < viewRootNodes.length; i++) {
                var node = viewRootNodes[i];
                dom_adapter_1.DOM.remove(node);
                this.animateNodeLeave(node);
            }
        };
        DomRenderer.prototype.destroyView = function (hostElement, viewAllNodes) {
            if (this.componentProto.encapsulation === metadata_1.ViewEncapsulation.Native && lang_1.isPresent(hostElement)) {
                this._rootRenderer.sharedStylesHost.removeHost(dom_adapter_1.DOM.getShadowRoot(hostElement));
            }
        };
        DomRenderer.prototype.listen = function (renderElement, name, callback) {
            return this._rootRenderer.eventManager.addEventListener(renderElement, name, decoratePreventDefault(callback));
        };
        DomRenderer.prototype.listenGlobal = function (target, name, callback) {
            return this._rootRenderer.eventManager.addGlobalEventListener(target, name, decoratePreventDefault(callback));
        };
        DomRenderer.prototype.setElementProperty = function (renderElement, propertyName, propertyValue) {
            dom_adapter_1.DOM.setProperty(renderElement, propertyName, propertyValue);
        };
        DomRenderer.prototype.setElementAttribute = function (renderElement, attributeName, attributeValue) {
            var attrNs;
            var nsAndName = splitNamespace(attributeName);
            if (lang_1.isPresent(nsAndName[0])) {
                attributeName = nsAndName[0] + ':' + nsAndName[1];
                attrNs = NAMESPACE_URIS[nsAndName[0]];
            }
            if (lang_1.isPresent(attributeValue)) {
                if (lang_1.isPresent(attrNs)) {
                    dom_adapter_1.DOM.setAttributeNS(renderElement, attrNs, attributeName, attributeValue);
                } else {
                    dom_adapter_1.DOM.setAttribute(renderElement, attributeName, attributeValue);
                }
            } else {
                if (lang_1.isPresent(attrNs)) {
                    dom_adapter_1.DOM.removeAttributeNS(renderElement, attrNs, nsAndName[1]);
                } else {
                    dom_adapter_1.DOM.removeAttribute(renderElement, attributeName);
                }
            }
        };
        DomRenderer.prototype.setBindingDebugInfo = function (renderElement, propertyName, propertyValue) {
            var dashCasedPropertyName = util_1.camelCaseToDashCase(propertyName);
            if (dom_adapter_1.DOM.isCommentNode(renderElement)) {
                var existingBindings = lang_1.RegExpWrapper.firstMatch(TEMPLATE_BINDINGS_EXP, lang_1.StringWrapper.replaceAll(dom_adapter_1.DOM.getText(renderElement), /\n/g, ''));
                var parsedBindings = lang_1.Json.parse(existingBindings[1]);
                parsedBindings[dashCasedPropertyName] = propertyValue;
                dom_adapter_1.DOM.setText(renderElement, lang_1.StringWrapper.replace(TEMPLATE_COMMENT_TEXT, '{}', lang_1.Json.stringify(parsedBindings)));
            } else {
                this.setElementAttribute(renderElement, propertyName, propertyValue);
            }
        };
        DomRenderer.prototype.setElementDebugInfo = function (renderElement, info) {};
        DomRenderer.prototype.setElementClass = function (renderElement, className, isAdd) {
            if (isAdd) {
                dom_adapter_1.DOM.addClass(renderElement, className);
            } else {
                dom_adapter_1.DOM.removeClass(renderElement, className);
            }
        };
        DomRenderer.prototype.setElementStyle = function (renderElement, styleName, styleValue) {
            if (lang_1.isPresent(styleValue)) {
                dom_adapter_1.DOM.setStyle(renderElement, styleName, lang_1.stringify(styleValue));
            } else {
                dom_adapter_1.DOM.removeStyle(renderElement, styleName);
            }
        };
        DomRenderer.prototype.invokeElementMethod = function (renderElement, methodName, args) {
            dom_adapter_1.DOM.invoke(renderElement, methodName, args);
        };
        DomRenderer.prototype.setText = function (renderNode, text) {
            dom_adapter_1.DOM.setText(renderNode, text);
        };
        /**
         * Performs animations if necessary
         * @param node
         */
        DomRenderer.prototype.animateNodeEnter = function (node) {
            if (dom_adapter_1.DOM.isElementNode(node) && dom_adapter_1.DOM.hasClass(node, 'ng-animate')) {
                dom_adapter_1.DOM.addClass(node, 'ng-enter');
                this._rootRenderer.animate.css().addAnimationClass('ng-enter-active').start(node).onComplete(function () {
                    dom_adapter_1.DOM.removeClass(node, 'ng-enter');
                });
            }
        };
        /**
         * If animations are necessary, performs animations then removes the element; otherwise, it just
         * removes the element.
         * @param node
         */
        DomRenderer.prototype.animateNodeLeave = function (node) {
            if (dom_adapter_1.DOM.isElementNode(node) && dom_adapter_1.DOM.hasClass(node, 'ng-animate')) {
                dom_adapter_1.DOM.addClass(node, 'ng-leave');
                this._rootRenderer.animate.css().addAnimationClass('ng-leave-active').start(node).onComplete(function () {
                    dom_adapter_1.DOM.removeClass(node, 'ng-leave');
                    dom_adapter_1.DOM.remove(node);
                });
            } else {
                dom_adapter_1.DOM.remove(node);
            }
        };
        return DomRenderer;
    }();
    exports.DomRenderer = DomRenderer;
    function moveNodesAfterSibling(sibling, nodes) {
        var parent = dom_adapter_1.DOM.parentElement(sibling);
        if (nodes.length > 0 && lang_1.isPresent(parent)) {
            var nextSibling = dom_adapter_1.DOM.nextSibling(sibling);
            if (lang_1.isPresent(nextSibling)) {
                for (var i = 0; i < nodes.length; i++) {
                    dom_adapter_1.DOM.insertBefore(nextSibling, nodes[i]);
                }
            } else {
                for (var i = 0; i < nodes.length; i++) {
                    dom_adapter_1.DOM.appendChild(parent, nodes[i]);
                }
            }
        }
    }
    function appendNodes(parent, nodes) {
        for (var i = 0; i < nodes.length; i++) {
            dom_adapter_1.DOM.appendChild(parent, nodes[i]);
        }
    }
    function decoratePreventDefault(eventHandler) {
        return function (event) {
            var allowDefaultBehavior = eventHandler(event);
            if (allowDefaultBehavior === false) {
                // TODO(tbosch): move preventDefault into event plugins...
                dom_adapter_1.DOM.preventDefault(event);
            }
        };
    }
    var COMPONENT_REGEX = /%COMP%/g;
    exports.COMPONENT_VARIABLE = '%COMP%';
    exports.HOST_ATTR = "_nghost-" + exports.COMPONENT_VARIABLE;
    exports.CONTENT_ATTR = "_ngcontent-" + exports.COMPONENT_VARIABLE;
    function _shimContentAttribute(componentShortId) {
        return lang_1.StringWrapper.replaceAll(exports.CONTENT_ATTR, COMPONENT_REGEX, componentShortId);
    }
    function _shimHostAttribute(componentShortId) {
        return lang_1.StringWrapper.replaceAll(exports.HOST_ATTR, COMPONENT_REGEX, componentShortId);
    }
    function _flattenStyles(compId, styles, target) {
        for (var i = 0; i < styles.length; i++) {
            var style = styles[i];
            if (lang_1.isArray(style)) {
                _flattenStyles(compId, style, target);
            } else {
                style = lang_1.StringWrapper.replaceAll(style, COMPONENT_REGEX, compId);
                target.push(style);
            }
        }
        return target;
    }
    var NS_PREFIX_RE = /^@([^:]+):(.+)/g;
    function splitNamespace(name) {
        if (name[0] != '@') {
            return [null, name];
        }
        var match = lang_1.RegExpWrapper.firstMatch(NS_PREFIX_RE, name);
        return [match[1], match[2]];
    }
});
System.registerDynamic('angular2/src/core/debug/debug_renderer.js', ['angular2/src/facade/lang.js', 'angular2/src/core/debug/debug_node.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var debug_node_1 = $__require('angular2/src/core/debug/debug_node.js');
    var DebugDomRootRenderer = function () {
        function DebugDomRootRenderer(_delegate) {
            this._delegate = _delegate;
        }
        DebugDomRootRenderer.prototype.renderComponent = function (componentProto) {
            return new DebugDomRenderer(this, this._delegate.renderComponent(componentProto));
        };
        return DebugDomRootRenderer;
    }();
    exports.DebugDomRootRenderer = DebugDomRootRenderer;
    var DebugDomRenderer = function () {
        function DebugDomRenderer(_rootRenderer, _delegate) {
            this._rootRenderer = _rootRenderer;
            this._delegate = _delegate;
        }
        DebugDomRenderer.prototype.renderComponent = function (componentType) {
            return this._rootRenderer.renderComponent(componentType);
        };
        DebugDomRenderer.prototype.selectRootElement = function (selector) {
            var nativeEl = this._delegate.selectRootElement(selector);
            var debugEl = new debug_node_1.DebugElement(nativeEl, null);
            debug_node_1.indexDebugNode(debugEl);
            return nativeEl;
        };
        DebugDomRenderer.prototype.createElement = function (parentElement, name) {
            var nativeEl = this._delegate.createElement(parentElement, name);
            var debugEl = new debug_node_1.DebugElement(nativeEl, debug_node_1.getDebugNode(parentElement));
            debugEl.name = name;
            debug_node_1.indexDebugNode(debugEl);
            return nativeEl;
        };
        DebugDomRenderer.prototype.createViewRoot = function (hostElement) {
            return this._delegate.createViewRoot(hostElement);
        };
        DebugDomRenderer.prototype.createTemplateAnchor = function (parentElement) {
            var comment = this._delegate.createTemplateAnchor(parentElement);
            var debugEl = new debug_node_1.DebugNode(comment, debug_node_1.getDebugNode(parentElement));
            debug_node_1.indexDebugNode(debugEl);
            return comment;
        };
        DebugDomRenderer.prototype.createText = function (parentElement, value) {
            var text = this._delegate.createText(parentElement, value);
            var debugEl = new debug_node_1.DebugNode(text, debug_node_1.getDebugNode(parentElement));
            debug_node_1.indexDebugNode(debugEl);
            return text;
        };
        DebugDomRenderer.prototype.projectNodes = function (parentElement, nodes) {
            var debugParent = debug_node_1.getDebugNode(parentElement);
            if (lang_1.isPresent(debugParent) && debugParent instanceof debug_node_1.DebugElement) {
                var debugElement_1 = debugParent;
                nodes.forEach(function (node) {
                    debugElement_1.addChild(debug_node_1.getDebugNode(node));
                });
            }
            this._delegate.projectNodes(parentElement, nodes);
        };
        DebugDomRenderer.prototype.attachViewAfter = function (node, viewRootNodes) {
            var debugNode = debug_node_1.getDebugNode(node);
            if (lang_1.isPresent(debugNode)) {
                var debugParent = debugNode.parent;
                if (viewRootNodes.length > 0 && lang_1.isPresent(debugParent)) {
                    var debugViewRootNodes = [];
                    viewRootNodes.forEach(function (rootNode) {
                        return debugViewRootNodes.push(debug_node_1.getDebugNode(rootNode));
                    });
                    debugParent.insertChildrenAfter(debugNode, debugViewRootNodes);
                }
            }
            this._delegate.attachViewAfter(node, viewRootNodes);
        };
        DebugDomRenderer.prototype.detachView = function (viewRootNodes) {
            viewRootNodes.forEach(function (node) {
                var debugNode = debug_node_1.getDebugNode(node);
                if (lang_1.isPresent(debugNode) && lang_1.isPresent(debugNode.parent)) {
                    debugNode.parent.removeChild(debugNode);
                }
            });
            this._delegate.detachView(viewRootNodes);
        };
        DebugDomRenderer.prototype.destroyView = function (hostElement, viewAllNodes) {
            viewAllNodes.forEach(function (node) {
                debug_node_1.removeDebugNodeFromIndex(debug_node_1.getDebugNode(node));
            });
            this._delegate.destroyView(hostElement, viewAllNodes);
        };
        DebugDomRenderer.prototype.listen = function (renderElement, name, callback) {
            var debugEl = debug_node_1.getDebugNode(renderElement);
            if (lang_1.isPresent(debugEl)) {
                debugEl.listeners.push(new debug_node_1.EventListener(name, callback));
            }
            return this._delegate.listen(renderElement, name, callback);
        };
        DebugDomRenderer.prototype.listenGlobal = function (target, name, callback) {
            return this._delegate.listenGlobal(target, name, callback);
        };
        DebugDomRenderer.prototype.setElementProperty = function (renderElement, propertyName, propertyValue) {
            var debugEl = debug_node_1.getDebugNode(renderElement);
            if (lang_1.isPresent(debugEl) && debugEl instanceof debug_node_1.DebugElement) {
                debugEl.properties.set(propertyName, propertyValue);
            }
            this._delegate.setElementProperty(renderElement, propertyName, propertyValue);
        };
        DebugDomRenderer.prototype.setElementAttribute = function (renderElement, attributeName, attributeValue) {
            var debugEl = debug_node_1.getDebugNode(renderElement);
            if (lang_1.isPresent(debugEl) && debugEl instanceof debug_node_1.DebugElement) {
                debugEl.attributes.set(attributeName, attributeValue);
            }
            this._delegate.setElementAttribute(renderElement, attributeName, attributeValue);
        };
        /**
         * Used only in debug mode to serialize property changes to comment nodes,
         * such as <template> placeholders.
         */
        DebugDomRenderer.prototype.setBindingDebugInfo = function (renderElement, propertyName, propertyValue) {
            this._delegate.setBindingDebugInfo(renderElement, propertyName, propertyValue);
        };
        /**
         * Used only in development mode to set information needed by the DebugNode for this element.
         */
        DebugDomRenderer.prototype.setElementDebugInfo = function (renderElement, info) {
            var debugEl = debug_node_1.getDebugNode(renderElement);
            debugEl.setDebugInfo(info);
            this._delegate.setElementDebugInfo(renderElement, info);
        };
        DebugDomRenderer.prototype.setElementClass = function (renderElement, className, isAdd) {
            this._delegate.setElementClass(renderElement, className, isAdd);
        };
        DebugDomRenderer.prototype.setElementStyle = function (renderElement, styleName, styleValue) {
            this._delegate.setElementStyle(renderElement, styleName, styleValue);
        };
        DebugDomRenderer.prototype.invokeElementMethod = function (renderElement, methodName, args) {
            this._delegate.invokeElementMethod(renderElement, methodName, args);
        };
        DebugDomRenderer.prototype.setText = function (renderNode, text) {
            this._delegate.setText(renderNode, text);
        };
        return DebugDomRenderer;
    }();
    exports.DebugDomRenderer = DebugDomRenderer;
});
System.registerDynamic('angular2/src/platform/dom/debug/ng_probe.js', ['angular2/src/facade/lang.js', 'angular2/src/core/di.js', 'angular2/src/platform/dom/dom_adapter.js', 'angular2/src/core/debug/debug_node.js', 'angular2/src/platform/dom/dom_renderer.js', 'angular2/core.js', 'angular2/src/core/debug/debug_renderer.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var di_1 = $__require('angular2/src/core/di.js');
    var dom_adapter_1 = $__require('angular2/src/platform/dom/dom_adapter.js');
    var debug_node_1 = $__require('angular2/src/core/debug/debug_node.js');
    var dom_renderer_1 = $__require('angular2/src/platform/dom/dom_renderer.js');
    var core_1 = $__require('angular2/core.js');
    var debug_renderer_1 = $__require('angular2/src/core/debug/debug_renderer.js');
    var CORE_TOKENS = lang_1.CONST_EXPR({ 'ApplicationRef': core_1.ApplicationRef, 'NgZone': core_1.NgZone });
    var INSPECT_GLOBAL_NAME = 'ng.probe';
    var CORE_TOKENS_GLOBAL_NAME = 'ng.coreTokens';
    /**
     * Returns a {@link DebugElement} for the given native DOM element, or
     * null if the given native element does not have an Angular view associated
     * with it.
     */
    function inspectNativeElement(element) {
        return debug_node_1.getDebugNode(element);
    }
    exports.inspectNativeElement = inspectNativeElement;
    function _createConditionalRootRenderer(rootRenderer) {
        if (lang_1.assertionsEnabled()) {
            return _createRootRenderer(rootRenderer);
        }
        return rootRenderer;
    }
    function _createRootRenderer(rootRenderer) {
        dom_adapter_1.DOM.setGlobalVar(INSPECT_GLOBAL_NAME, inspectNativeElement);
        dom_adapter_1.DOM.setGlobalVar(CORE_TOKENS_GLOBAL_NAME, CORE_TOKENS);
        return new debug_renderer_1.DebugDomRootRenderer(rootRenderer);
    }
    /**
     * Providers which support debugging Angular applications (e.g. via `ng.probe`).
     */
    exports.ELEMENT_PROBE_PROVIDERS = lang_1.CONST_EXPR([new di_1.Provider(core_1.RootRenderer, { useFactory: _createConditionalRootRenderer, deps: [dom_renderer_1.DomRootRenderer] })]);
    exports.ELEMENT_PROBE_PROVIDERS_PROD_MODE = lang_1.CONST_EXPR([new di_1.Provider(core_1.RootRenderer, { useFactory: _createRootRenderer, deps: [dom_renderer_1.DomRootRenderer] })]);
});
System.registerDynamic('angular2/platform/common_dom.js', ['angular2/src/platform/dom/dom_adapter.js', 'angular2/src/platform/dom/dom_renderer.js', 'angular2/src/platform/dom/dom_tokens.js', 'angular2/src/platform/dom/shared_styles_host.js', 'angular2/src/platform/dom/events/dom_events.js', 'angular2/src/platform/dom/events/event_manager.js', 'angular2/src/platform/dom/debug/by.js', 'angular2/src/platform/dom/debug/ng_probe.js'], true, function ($__require, exports, module) {
  'use strict';"use strict";

  var global = this || self,
      GLOBAL = global;
  function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
  /**
   * This is a set of classes and objects that can be used both in the browser and on the server.
   */
  var dom_adapter_1 = $__require('angular2/src/platform/dom/dom_adapter.js');
  exports.DOM = dom_adapter_1.DOM;
  exports.setRootDomAdapter = dom_adapter_1.setRootDomAdapter;
  exports.DomAdapter = dom_adapter_1.DomAdapter;
  var dom_renderer_1 = $__require('angular2/src/platform/dom/dom_renderer.js');
  exports.DomRenderer = dom_renderer_1.DomRenderer;
  var dom_tokens_1 = $__require('angular2/src/platform/dom/dom_tokens.js');
  exports.DOCUMENT = dom_tokens_1.DOCUMENT;
  var shared_styles_host_1 = $__require('angular2/src/platform/dom/shared_styles_host.js');
  exports.SharedStylesHost = shared_styles_host_1.SharedStylesHost;
  exports.DomSharedStylesHost = shared_styles_host_1.DomSharedStylesHost;
  var dom_events_1 = $__require('angular2/src/platform/dom/events/dom_events.js');
  exports.DomEventsPlugin = dom_events_1.DomEventsPlugin;
  var event_manager_1 = $__require('angular2/src/platform/dom/events/event_manager.js');
  exports.EVENT_MANAGER_PLUGINS = event_manager_1.EVENT_MANAGER_PLUGINS;
  exports.EventManager = event_manager_1.EventManager;
  exports.EventManagerPlugin = event_manager_1.EventManagerPlugin;
  __export($__require('angular2/src/platform/dom/debug/by.js'));
  __export($__require('angular2/src/platform/dom/debug/ng_probe.js'));
});
System.registerDynamic('angular2/src/platform/browser/title.js', ['angular2/src/platform/dom/dom_adapter.js'], true, function ($__require, exports, module) {
  'use strict';"use strict";

  var global = this || self,
      GLOBAL = global;
  var dom_adapter_1 = $__require('angular2/src/platform/dom/dom_adapter.js');
  /**
   * A service that can be used to get and set the title of a current HTML document.
   *
   * Since an Angular 2 application can't be bootstrapped on the entire HTML document (`<html>` tag)
   * it is not possible to bind to the `text` property of the `HTMLTitleElement` elements
   * (representing the `<title>` tag). Instead, this service can be used to set and get the current
   * title value.
   */
  var Title = function () {
    function Title() {}
    /**
     * Get the title of the current HTML document.
     * @returns {string}
     */
    Title.prototype.getTitle = function () {
      return dom_adapter_1.DOM.getTitle();
    };
    /**
     * Set the title of the current HTML document.
     * @param newTitle
     */
    Title.prototype.setTitle = function (newTitle) {
      dom_adapter_1.DOM.setTitle(newTitle);
    };
    return Title;
  }();
  exports.Title = Title;
});
System.registerDynamic('angular2/src/facade/browser.js', [], true, function ($__require, exports, module) {
  'use strict';"use strict";
  /**
   * JS version of browser APIs. This library can only run in the browser.
   */

  var global = this || self,
      GLOBAL = global;
  var win = window;
  exports.window = win;
  exports.document = window.document;
  exports.location = window.location;
  exports.gc = window['gc'] ? function () {
    return window['gc']();
  } : function () {
    return null;
  };
  exports.performance = window['performance'] ? window['performance'] : null;
  exports.Event = window['Event'];
  exports.MouseEvent = window['MouseEvent'];
  exports.KeyboardEvent = window['KeyboardEvent'];
  exports.EventTarget = window['EventTarget'];
  exports.History = window['History'];
  exports.Location = window['Location'];
  exports.EventListener = window['EventListener'];
});
System.registerDynamic('angular2/src/platform/browser/tools/common_tools.js', ['angular2/src/core/application_ref.js', 'angular2/src/facade/lang.js', 'angular2/src/facade/browser.js', 'angular2/src/platform/dom/dom_adapter.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var application_ref_1 = $__require('angular2/src/core/application_ref.js');
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var browser_1 = $__require('angular2/src/facade/browser.js');
    var dom_adapter_1 = $__require('angular2/src/platform/dom/dom_adapter.js');
    /**
     * Entry point for all Angular debug tools. This object corresponds to the `ng`
     * global variable accessible in the dev console.
     */
    var AngularTools = function () {
        function AngularTools(ref) {
            this.profiler = new AngularProfiler(ref);
        }
        return AngularTools;
    }();
    exports.AngularTools = AngularTools;
    /**
     * Entry point for all Angular profiling-related debug tools. This object
     * corresponds to the `ng.profiler` in the dev console.
     */
    var AngularProfiler = function () {
        function AngularProfiler(ref) {
            this.appRef = ref.injector.get(application_ref_1.ApplicationRef);
        }
        /**
         * Exercises change detection in a loop and then prints the average amount of
         * time in milliseconds how long a single round of change detection takes for
         * the current state of the UI. It runs a minimum of 5 rounds for a minimum
         * of 500 milliseconds.
         *
         * Optionally, a user may pass a `config` parameter containing a map of
         * options. Supported options are:
         *
         * `record` (boolean) - causes the profiler to record a CPU profile while
         * it exercises the change detector. Example:
         *
         * ```
         * ng.profiler.timeChangeDetection({record: true})
         * ```
         */
        AngularProfiler.prototype.timeChangeDetection = function (config) {
            var record = lang_1.isPresent(config) && config['record'];
            var profileName = 'Change Detection';
            // Profiler is not available in Android browsers, nor in IE 9 without dev tools opened
            var isProfilerAvailable = lang_1.isPresent(browser_1.window.console.profile);
            if (record && isProfilerAvailable) {
                browser_1.window.console.profile(profileName);
            }
            var start = dom_adapter_1.DOM.performanceNow();
            var numTicks = 0;
            while (numTicks < 5 || dom_adapter_1.DOM.performanceNow() - start < 500) {
                this.appRef.tick();
                numTicks++;
            }
            var end = dom_adapter_1.DOM.performanceNow();
            if (record && isProfilerAvailable) {
                // need to cast to <any> because type checker thinks there's no argument
                // while in fact there is:
                //
                // https://developer.mozilla.org/en-US/docs/Web/API/Console/profileEnd
                browser_1.window.console.profileEnd(profileName);
            }
            var msPerTick = (end - start) / numTicks;
            browser_1.window.console.log("ran " + numTicks + " change detection cycles");
            browser_1.window.console.log(lang_1.NumberWrapper.toFixed(msPerTick, 2) + " ms per check");
        };
        return AngularProfiler;
    }();
    exports.AngularProfiler = AngularProfiler;
});
System.registerDynamic('angular2/src/platform/browser/tools/tools.js', ['angular2/src/facade/lang.js', 'angular2/src/platform/browser/tools/common_tools.js'], true, function ($__require, exports, module) {
  'use strict';"use strict";

  var global = this || self,
      GLOBAL = global;
  var lang_1 = $__require('angular2/src/facade/lang.js');
  var common_tools_1 = $__require('angular2/src/platform/browser/tools/common_tools.js');
  var context = lang_1.global;
  /**
   * Enabled Angular 2 debug tools that are accessible via your browser's
   * developer console.
   *
   * Usage:
   *
   * 1. Open developer console (e.g. in Chrome Ctrl + Shift + j)
   * 1. Type `ng.` (usually the console will show auto-complete suggestion)
   * 1. Try the change detection profiler `ng.profiler.timeChangeDetection()`
   *    then hit Enter.
   */
  function enableDebugTools(ref) {
    context.ng = new common_tools_1.AngularTools(ref);
  }
  exports.enableDebugTools = enableDebugTools;
  /**
   * Disables Angular 2 tools.
   */
  function disableDebugTools() {
    delete context.ng;
  }
  exports.disableDebugTools = disableDebugTools;
});
System.registerDynamic("angular2/src/platform/dom/events/event_manager.js", ["angular2/src/facade/lang.js", "angular2/src/facade/exceptions.js", "angular2/src/core/di.js", "angular2/src/core/zone/ng_zone.js", "angular2/src/facade/collection.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var __param = this && this.__param || function (paramIndex, decorator) {
        return function (target, key) {
            decorator(target, key, paramIndex);
        };
    };
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var exceptions_1 = $__require("angular2/src/facade/exceptions.js");
    var di_1 = $__require("angular2/src/core/di.js");
    var ng_zone_1 = $__require("angular2/src/core/zone/ng_zone.js");
    var collection_1 = $__require("angular2/src/facade/collection.js");
    exports.EVENT_MANAGER_PLUGINS = lang_1.CONST_EXPR(new di_1.OpaqueToken("EventManagerPlugins"));
    var EventManager = function () {
        function EventManager(plugins, _zone) {
            var _this = this;
            this._zone = _zone;
            plugins.forEach(function (p) {
                return p.manager = _this;
            });
            this._plugins = collection_1.ListWrapper.reversed(plugins);
        }
        EventManager.prototype.addEventListener = function (element, eventName, handler) {
            var plugin = this._findPluginFor(eventName);
            return plugin.addEventListener(element, eventName, handler);
        };
        EventManager.prototype.addGlobalEventListener = function (target, eventName, handler) {
            var plugin = this._findPluginFor(eventName);
            return plugin.addGlobalEventListener(target, eventName, handler);
        };
        EventManager.prototype.getZone = function () {
            return this._zone;
        };
        /** @internal */
        EventManager.prototype._findPluginFor = function (eventName) {
            var plugins = this._plugins;
            for (var i = 0; i < plugins.length; i++) {
                var plugin = plugins[i];
                if (plugin.supports(eventName)) {
                    return plugin;
                }
            }
            throw new exceptions_1.BaseException("No event manager plugin found for event " + eventName);
        };
        EventManager = __decorate([di_1.Injectable(), __param(0, di_1.Inject(exports.EVENT_MANAGER_PLUGINS)), __metadata('design:paramtypes', [Array, ng_zone_1.NgZone])], EventManager);
        return EventManager;
    }();
    exports.EventManager = EventManager;
    var EventManagerPlugin = function () {
        function EventManagerPlugin() {}
        // That is equivalent to having supporting $event.target
        EventManagerPlugin.prototype.supports = function (eventName) {
            return false;
        };
        EventManagerPlugin.prototype.addEventListener = function (element, eventName, handler) {
            throw "not implemented";
        };
        EventManagerPlugin.prototype.addGlobalEventListener = function (element, eventName, handler) {
            throw "not implemented";
        };
        return EventManagerPlugin;
    }();
    exports.EventManagerPlugin = EventManagerPlugin;
});
System.registerDynamic('angular2/src/platform/dom/events/hammer_common.js', ['angular2/src/platform/dom/events/event_manager.js', 'angular2/src/facade/collection.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var event_manager_1 = $__require('angular2/src/platform/dom/events/event_manager.js');
    var collection_1 = $__require('angular2/src/facade/collection.js');
    var _eventNames = {
        // pan
        'pan': true,
        'panstart': true,
        'panmove': true,
        'panend': true,
        'pancancel': true,
        'panleft': true,
        'panright': true,
        'panup': true,
        'pandown': true,
        // pinch
        'pinch': true,
        'pinchstart': true,
        'pinchmove': true,
        'pinchend': true,
        'pinchcancel': true,
        'pinchin': true,
        'pinchout': true,
        // press
        'press': true,
        'pressup': true,
        // rotate
        'rotate': true,
        'rotatestart': true,
        'rotatemove': true,
        'rotateend': true,
        'rotatecancel': true,
        // swipe
        'swipe': true,
        'swipeleft': true,
        'swiperight': true,
        'swipeup': true,
        'swipedown': true,
        // tap
        'tap': true
    };
    var HammerGesturesPluginCommon = function (_super) {
        __extends(HammerGesturesPluginCommon, _super);
        function HammerGesturesPluginCommon() {
            _super.call(this);
        }
        HammerGesturesPluginCommon.prototype.supports = function (eventName) {
            eventName = eventName.toLowerCase();
            return collection_1.StringMapWrapper.contains(_eventNames, eventName);
        };
        return HammerGesturesPluginCommon;
    }(event_manager_1.EventManagerPlugin);
    exports.HammerGesturesPluginCommon = HammerGesturesPluginCommon;
});
System.registerDynamic("angular2/src/platform/dom/events/hammer_gestures.js", ["angular2/src/platform/dom/events/hammer_common.js", "angular2/src/facade/lang.js", "angular2/src/facade/exceptions.js", "angular2/core.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var __param = this && this.__param || function (paramIndex, decorator) {
        return function (target, key) {
            decorator(target, key, paramIndex);
        };
    };
    var hammer_common_1 = $__require("angular2/src/platform/dom/events/hammer_common.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var exceptions_1 = $__require("angular2/src/facade/exceptions.js");
    var core_1 = $__require("angular2/core.js");
    exports.HAMMER_GESTURE_CONFIG = lang_1.CONST_EXPR(new core_1.OpaqueToken("HammerGestureConfig"));
    var HammerGestureConfig = function () {
        function HammerGestureConfig() {
            this.events = [];
            this.overrides = {};
        }
        HammerGestureConfig.prototype.buildHammer = function (element) {
            var mc = new Hammer(element);
            mc.get('pinch').set({ enable: true });
            mc.get('rotate').set({ enable: true });
            for (var eventName in this.overrides) {
                mc.get(eventName).set(this.overrides[eventName]);
            }
            return mc;
        };
        HammerGestureConfig = __decorate([core_1.Injectable(), __metadata('design:paramtypes', [])], HammerGestureConfig);
        return HammerGestureConfig;
    }();
    exports.HammerGestureConfig = HammerGestureConfig;
    var HammerGesturesPlugin = function (_super) {
        __extends(HammerGesturesPlugin, _super);
        function HammerGesturesPlugin(_config) {
            _super.call(this);
            this._config = _config;
        }
        HammerGesturesPlugin.prototype.supports = function (eventName) {
            if (!_super.prototype.supports.call(this, eventName) && !this.isCustomEvent(eventName)) return false;
            if (!lang_1.isPresent(window['Hammer'])) {
                throw new exceptions_1.BaseException("Hammer.js is not loaded, can not bind " + eventName + " event");
            }
            return true;
        };
        HammerGesturesPlugin.prototype.addEventListener = function (element, eventName, handler) {
            var _this = this;
            var zone = this.manager.getZone();
            eventName = eventName.toLowerCase();
            return zone.runOutsideAngular(function () {
                // Creating the manager bind events, must be done outside of angular
                var mc = _this._config.buildHammer(element);
                var callback = function (eventObj) {
                    zone.run(function () {
                        handler(eventObj);
                    });
                };
                mc.on(eventName, callback);
                return function () {
                    mc.off(eventName, callback);
                };
            });
        };
        HammerGesturesPlugin.prototype.isCustomEvent = function (eventName) {
            return this._config.events.indexOf(eventName) > -1;
        };
        HammerGesturesPlugin = __decorate([core_1.Injectable(), __param(0, core_1.Inject(exports.HAMMER_GESTURE_CONFIG)), __metadata('design:paramtypes', [HammerGestureConfig])], HammerGesturesPlugin);
        return HammerGesturesPlugin;
    }(hammer_common_1.HammerGesturesPluginCommon);
    exports.HammerGesturesPlugin = HammerGesturesPlugin;
});
System.registerDynamic('angular2/src/platform/browser_common.js', ['angular2/src/facade/lang.js', 'angular2/src/core/di.js', 'angular2/src/compiler/xhr.js', 'angular2/core.js', 'angular2/common.js', 'angular2/src/core/testability/testability.js', 'angular2/src/platform/dom/dom_adapter.js', 'angular2/src/platform/dom/events/dom_events.js', 'angular2/src/platform/dom/events/key_events.js', 'angular2/src/platform/dom/events/hammer_gestures.js', 'angular2/src/platform/dom/dom_tokens.js', 'angular2/src/platform/dom/dom_renderer.js', 'angular2/src/platform/dom/shared_styles_host.js', 'angular2/src/animate/browser_details.js', 'angular2/src/animate/animation_builder.js', 'angular2/src/platform/browser/browser_adapter.js', 'angular2/src/platform/browser/testability.js', 'angular2/src/platform/browser/xhr_cache.js', 'angular2/src/core/profile/wtf_init.js', 'angular2/src/platform/dom/events/event_manager.js', 'angular2/platform/common_dom.js', 'angular2/src/platform/browser/title.js', 'angular2/src/platform/browser/tools/tools.js', 'angular2/src/platform/dom/events/hammer_gestures.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var di_1 = $__require('angular2/src/core/di.js');
    var xhr_1 = $__require('angular2/src/compiler/xhr.js');
    var core_1 = $__require('angular2/core.js');
    var common_1 = $__require('angular2/common.js');
    var testability_1 = $__require('angular2/src/core/testability/testability.js');
    var dom_adapter_1 = $__require('angular2/src/platform/dom/dom_adapter.js');
    var dom_events_1 = $__require('angular2/src/platform/dom/events/dom_events.js');
    var key_events_1 = $__require('angular2/src/platform/dom/events/key_events.js');
    var hammer_gestures_1 = $__require('angular2/src/platform/dom/events/hammer_gestures.js');
    var dom_tokens_1 = $__require('angular2/src/platform/dom/dom_tokens.js');
    var dom_renderer_1 = $__require('angular2/src/platform/dom/dom_renderer.js');
    var shared_styles_host_1 = $__require('angular2/src/platform/dom/shared_styles_host.js');
    var shared_styles_host_2 = $__require('angular2/src/platform/dom/shared_styles_host.js');
    var browser_details_1 = $__require('angular2/src/animate/browser_details.js');
    var animation_builder_1 = $__require('angular2/src/animate/animation_builder.js');
    var browser_adapter_1 = $__require('angular2/src/platform/browser/browser_adapter.js');
    var testability_2 = $__require('angular2/src/platform/browser/testability.js');
    var xhr_cache_1 = $__require('angular2/src/platform/browser/xhr_cache.js');
    var wtf_init_1 = $__require('angular2/src/core/profile/wtf_init.js');
    var event_manager_1 = $__require('angular2/src/platform/dom/events/event_manager.js');
    var hammer_gestures_2 = $__require('angular2/src/platform/dom/events/hammer_gestures.js');
    var common_dom_1 = $__require('angular2/platform/common_dom.js');
    var dom_tokens_2 = $__require('angular2/src/platform/dom/dom_tokens.js');
    exports.DOCUMENT = dom_tokens_2.DOCUMENT;
    var title_1 = $__require('angular2/src/platform/browser/title.js');
    exports.Title = title_1.Title;
    var common_dom_2 = $__require('angular2/platform/common_dom.js');
    exports.ELEMENT_PROBE_PROVIDERS = common_dom_2.ELEMENT_PROBE_PROVIDERS;
    exports.ELEMENT_PROBE_PROVIDERS_PROD_MODE = common_dom_2.ELEMENT_PROBE_PROVIDERS_PROD_MODE;
    exports.inspectNativeElement = common_dom_2.inspectNativeElement;
    exports.By = common_dom_2.By;
    var browser_adapter_2 = $__require('angular2/src/platform/browser/browser_adapter.js');
    exports.BrowserDomAdapter = browser_adapter_2.BrowserDomAdapter;
    var tools_1 = $__require('angular2/src/platform/browser/tools/tools.js');
    exports.enableDebugTools = tools_1.enableDebugTools;
    exports.disableDebugTools = tools_1.disableDebugTools;
    var hammer_gestures_3 = $__require('angular2/src/platform/dom/events/hammer_gestures.js');
    exports.HAMMER_GESTURE_CONFIG = hammer_gestures_3.HAMMER_GESTURE_CONFIG;
    exports.HammerGestureConfig = hammer_gestures_3.HammerGestureConfig;
    /**
     * A set of providers to initialize the Angular platform in a web browser.
     *
     * Used automatically by `bootstrap`, or can be passed to {@link platform}.
     */
    exports.BROWSER_PROVIDERS = lang_1.CONST_EXPR([core_1.PLATFORM_COMMON_PROVIDERS, new di_1.Provider(core_1.PLATFORM_INITIALIZER, { useValue: initDomAdapter, multi: true })]);
    function _exceptionHandler() {
        // !IS_DART is required because we must rethrow exceptions in JS,
        // but must not rethrow exceptions in Dart
        return new core_1.ExceptionHandler(dom_adapter_1.DOM, !lang_1.IS_DART);
    }
    function _document() {
        return dom_adapter_1.DOM.defaultDoc();
    }
    /**
     * A set of providers to initialize an Angular application in a web browser.
     *
     * Used automatically by `bootstrap`, or can be passed to {@link PlatformRef.application}.
     */
    exports.BROWSER_APP_COMMON_PROVIDERS = lang_1.CONST_EXPR([core_1.APPLICATION_COMMON_PROVIDERS, common_1.FORM_PROVIDERS, new di_1.Provider(core_1.PLATFORM_PIPES, { useValue: common_1.COMMON_PIPES, multi: true }), new di_1.Provider(core_1.PLATFORM_DIRECTIVES, { useValue: common_1.COMMON_DIRECTIVES, multi: true }), new di_1.Provider(core_1.ExceptionHandler, { useFactory: _exceptionHandler, deps: [] }), new di_1.Provider(dom_tokens_1.DOCUMENT, { useFactory: _document, deps: [] }), new di_1.Provider(event_manager_1.EVENT_MANAGER_PLUGINS, { useClass: dom_events_1.DomEventsPlugin, multi: true }), new di_1.Provider(event_manager_1.EVENT_MANAGER_PLUGINS, { useClass: key_events_1.KeyEventsPlugin, multi: true }), new di_1.Provider(event_manager_1.EVENT_MANAGER_PLUGINS, { useClass: hammer_gestures_1.HammerGesturesPlugin, multi: true }), new di_1.Provider(hammer_gestures_2.HAMMER_GESTURE_CONFIG, { useClass: hammer_gestures_2.HammerGestureConfig }), new di_1.Provider(dom_renderer_1.DomRootRenderer, { useClass: dom_renderer_1.DomRootRenderer_ }), new di_1.Provider(core_1.RootRenderer, { useExisting: dom_renderer_1.DomRootRenderer }), new di_1.Provider(shared_styles_host_2.SharedStylesHost, { useExisting: shared_styles_host_1.DomSharedStylesHost }), shared_styles_host_1.DomSharedStylesHost, testability_1.Testability, browser_details_1.BrowserDetails, animation_builder_1.AnimationBuilder, event_manager_1.EventManager, common_dom_1.ELEMENT_PROBE_PROVIDERS]);
    exports.CACHED_TEMPLATE_PROVIDER = lang_1.CONST_EXPR([new di_1.Provider(xhr_1.XHR, { useClass: xhr_cache_1.CachedXHR })]);
    function initDomAdapter() {
        browser_adapter_1.BrowserDomAdapter.makeCurrent();
        wtf_init_1.wtfInit();
        testability_2.BrowserGetTestability.init();
    }
    exports.initDomAdapter = initDomAdapter;
});
System.registerDynamic('angular2/src/compiler/change_definition_factory.js', ['angular2/src/facade/collection.js', 'angular2/src/facade/lang.js', 'angular2/src/core/reflection/reflection.js', 'angular2/src/core/change_detection/change_detection.js', 'angular2/src/compiler/template_ast.js', 'angular2/src/core/linker/interfaces.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var collection_1 = $__require('angular2/src/facade/collection.js');
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var reflection_1 = $__require('angular2/src/core/reflection/reflection.js');
    var change_detection_1 = $__require('angular2/src/core/change_detection/change_detection.js');
    var template_ast_1 = $__require('angular2/src/compiler/template_ast.js');
    var interfaces_1 = $__require('angular2/src/core/linker/interfaces.js');
    function createChangeDetectorDefinitions(componentType, componentStrategy, genConfig, parsedTemplate) {
        var pvVisitors = [];
        var visitor = new ProtoViewVisitor(null, pvVisitors, componentStrategy);
        template_ast_1.templateVisitAll(visitor, parsedTemplate);
        return createChangeDefinitions(pvVisitors, componentType, genConfig);
    }
    exports.createChangeDetectorDefinitions = createChangeDetectorDefinitions;
    var ProtoViewVisitor = function () {
        function ProtoViewVisitor(parent, allVisitors, strategy) {
            this.parent = parent;
            this.allVisitors = allVisitors;
            this.strategy = strategy;
            this.nodeCount = 0;
            this.boundElementCount = 0;
            this.variableNames = [];
            this.bindingRecords = [];
            this.eventRecords = [];
            this.directiveRecords = [];
            this.viewIndex = allVisitors.length;
            allVisitors.push(this);
        }
        ProtoViewVisitor.prototype.visitEmbeddedTemplate = function (ast, context) {
            this.nodeCount++;
            this.boundElementCount++;
            template_ast_1.templateVisitAll(this, ast.outputs);
            for (var i = 0; i < ast.directives.length; i++) {
                ast.directives[i].visit(this, i);
            }
            var childVisitor = new ProtoViewVisitor(this, this.allVisitors, change_detection_1.ChangeDetectionStrategy.Default);
            // Attention: variables present on an embedded template count towards
            // the embedded template and not the template anchor!
            template_ast_1.templateVisitAll(childVisitor, ast.vars);
            template_ast_1.templateVisitAll(childVisitor, ast.children);
            return null;
        };
        ProtoViewVisitor.prototype.visitElement = function (ast, context) {
            this.nodeCount++;
            if (ast.isBound()) {
                this.boundElementCount++;
            }
            template_ast_1.templateVisitAll(this, ast.inputs, null);
            template_ast_1.templateVisitAll(this, ast.outputs);
            template_ast_1.templateVisitAll(this, ast.exportAsVars);
            for (var i = 0; i < ast.directives.length; i++) {
                ast.directives[i].visit(this, i);
            }
            template_ast_1.templateVisitAll(this, ast.children);
            return null;
        };
        ProtoViewVisitor.prototype.visitNgContent = function (ast, context) {
            return null;
        };
        ProtoViewVisitor.prototype.visitVariable = function (ast, context) {
            this.variableNames.push(ast.name);
            return null;
        };
        ProtoViewVisitor.prototype.visitEvent = function (ast, directiveRecord) {
            var bindingRecord = lang_1.isPresent(directiveRecord) ? change_detection_1.BindingRecord.createForHostEvent(ast.handler, ast.fullName, directiveRecord) : change_detection_1.BindingRecord.createForEvent(ast.handler, ast.fullName, this.boundElementCount - 1);
            this.eventRecords.push(bindingRecord);
            return null;
        };
        ProtoViewVisitor.prototype.visitElementProperty = function (ast, directiveRecord) {
            var boundElementIndex = this.boundElementCount - 1;
            var dirIndex = lang_1.isPresent(directiveRecord) ? directiveRecord.directiveIndex : null;
            var bindingRecord;
            if (ast.type === template_ast_1.PropertyBindingType.Property) {
                bindingRecord = lang_1.isPresent(dirIndex) ? change_detection_1.BindingRecord.createForHostProperty(dirIndex, ast.value, ast.name) : change_detection_1.BindingRecord.createForElementProperty(ast.value, boundElementIndex, ast.name);
            } else if (ast.type === template_ast_1.PropertyBindingType.Attribute) {
                bindingRecord = lang_1.isPresent(dirIndex) ? change_detection_1.BindingRecord.createForHostAttribute(dirIndex, ast.value, ast.name) : change_detection_1.BindingRecord.createForElementAttribute(ast.value, boundElementIndex, ast.name);
            } else if (ast.type === template_ast_1.PropertyBindingType.Class) {
                bindingRecord = lang_1.isPresent(dirIndex) ? change_detection_1.BindingRecord.createForHostClass(dirIndex, ast.value, ast.name) : change_detection_1.BindingRecord.createForElementClass(ast.value, boundElementIndex, ast.name);
            } else if (ast.type === template_ast_1.PropertyBindingType.Style) {
                bindingRecord = lang_1.isPresent(dirIndex) ? change_detection_1.BindingRecord.createForHostStyle(dirIndex, ast.value, ast.name, ast.unit) : change_detection_1.BindingRecord.createForElementStyle(ast.value, boundElementIndex, ast.name, ast.unit);
            }
            this.bindingRecords.push(bindingRecord);
            return null;
        };
        ProtoViewVisitor.prototype.visitAttr = function (ast, context) {
            return null;
        };
        ProtoViewVisitor.prototype.visitBoundText = function (ast, context) {
            var nodeIndex = this.nodeCount++;
            this.bindingRecords.push(change_detection_1.BindingRecord.createForTextNode(ast.value, nodeIndex));
            return null;
        };
        ProtoViewVisitor.prototype.visitText = function (ast, context) {
            this.nodeCount++;
            return null;
        };
        ProtoViewVisitor.prototype.visitDirective = function (ast, directiveIndexAsNumber) {
            var directiveIndex = new change_detection_1.DirectiveIndex(this.boundElementCount - 1, directiveIndexAsNumber);
            var directiveMetadata = ast.directive;
            var outputsArray = [];
            collection_1.StringMapWrapper.forEach(ast.directive.outputs, function (eventName, dirProperty) {
                return outputsArray.push([dirProperty, eventName]);
            });
            var directiveRecord = new change_detection_1.DirectiveRecord({
                directiveIndex: directiveIndex,
                callAfterContentInit: directiveMetadata.lifecycleHooks.indexOf(interfaces_1.LifecycleHooks.AfterContentInit) !== -1,
                callAfterContentChecked: directiveMetadata.lifecycleHooks.indexOf(interfaces_1.LifecycleHooks.AfterContentChecked) !== -1,
                callAfterViewInit: directiveMetadata.lifecycleHooks.indexOf(interfaces_1.LifecycleHooks.AfterViewInit) !== -1,
                callAfterViewChecked: directiveMetadata.lifecycleHooks.indexOf(interfaces_1.LifecycleHooks.AfterViewChecked) !== -1,
                callOnChanges: directiveMetadata.lifecycleHooks.indexOf(interfaces_1.LifecycleHooks.OnChanges) !== -1,
                callDoCheck: directiveMetadata.lifecycleHooks.indexOf(interfaces_1.LifecycleHooks.DoCheck) !== -1,
                callOnInit: directiveMetadata.lifecycleHooks.indexOf(interfaces_1.LifecycleHooks.OnInit) !== -1,
                callOnDestroy: directiveMetadata.lifecycleHooks.indexOf(interfaces_1.LifecycleHooks.OnDestroy) !== -1,
                changeDetection: directiveMetadata.changeDetection,
                outputs: outputsArray
            });
            this.directiveRecords.push(directiveRecord);
            template_ast_1.templateVisitAll(this, ast.inputs, directiveRecord);
            var bindingRecords = this.bindingRecords;
            if (directiveRecord.callOnChanges) {
                bindingRecords.push(change_detection_1.BindingRecord.createDirectiveOnChanges(directiveRecord));
            }
            if (directiveRecord.callOnInit) {
                bindingRecords.push(change_detection_1.BindingRecord.createDirectiveOnInit(directiveRecord));
            }
            if (directiveRecord.callDoCheck) {
                bindingRecords.push(change_detection_1.BindingRecord.createDirectiveDoCheck(directiveRecord));
            }
            template_ast_1.templateVisitAll(this, ast.hostProperties, directiveRecord);
            template_ast_1.templateVisitAll(this, ast.hostEvents, directiveRecord);
            template_ast_1.templateVisitAll(this, ast.exportAsVars);
            return null;
        };
        ProtoViewVisitor.prototype.visitDirectiveProperty = function (ast, directiveRecord) {
            // TODO: these setters should eventually be created by change detection, to make
            // it monomorphic!
            var setter = reflection_1.reflector.setter(ast.directiveName);
            this.bindingRecords.push(change_detection_1.BindingRecord.createForDirective(ast.value, ast.directiveName, setter, directiveRecord));
            return null;
        };
        return ProtoViewVisitor;
    }();
    function createChangeDefinitions(pvVisitors, componentType, genConfig) {
        var pvVariableNames = _collectNestedProtoViewsVariableNames(pvVisitors);
        return pvVisitors.map(function (pvVisitor) {
            var id = componentType.name + "_" + pvVisitor.viewIndex;
            return new change_detection_1.ChangeDetectorDefinition(id, pvVisitor.strategy, pvVariableNames[pvVisitor.viewIndex], pvVisitor.bindingRecords, pvVisitor.eventRecords, pvVisitor.directiveRecords, genConfig);
        });
    }
    function _collectNestedProtoViewsVariableNames(pvVisitors) {
        var nestedPvVariableNames = collection_1.ListWrapper.createFixedSize(pvVisitors.length);
        pvVisitors.forEach(function (pv) {
            var parentVariableNames = lang_1.isPresent(pv.parent) ? nestedPvVariableNames[pv.parent.viewIndex] : [];
            nestedPvVariableNames[pv.viewIndex] = parentVariableNames.concat(pv.variableNames);
        });
        return nestedPvVariableNames;
    }
});
System.registerDynamic("angular2/src/transform/template_compiler/change_detector_codegen.js", [], true, function ($__require, exports, module) {
    'use strict';"use strict";
    // Note: This class is only here so that we can reference it from TypeScript code.
    // The actual implementation lives under modules_dart.
    // TODO(tbosch): Move the corresponding code into angular2/src/compiler once
    // the new compiler is done.

    var global = this || self,
        GLOBAL = global;
    var Codegen = function () {
        function Codegen(moduleAlias) {}
        Codegen.prototype.generate = function (typeName, changeDetectorTypeName, def) {
            throw "Not implemented in JS";
        };
        Codegen.prototype.toString = function () {
            throw "Not implemented in JS";
        };
        return Codegen;
    }();
    exports.Codegen = Codegen;
});
System.registerDynamic("angular2/src/compiler/change_detector_compiler.js", ["angular2/src/compiler/source_module.js", "angular2/src/core/change_detection/change_detection_jit_generator.js", "angular2/src/core/change_detection/abstract_change_detector.js", "angular2/src/core/change_detection/change_detection_util.js", "angular2/src/core/change_detection/constants.js", "angular2/src/compiler/change_definition_factory.js", "angular2/src/facade/lang.js", "angular2/src/core/change_detection/change_detection.js", "angular2/src/transform/template_compiler/change_detector_codegen.js", "angular2/src/compiler/util.js", "angular2/src/core/di.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var source_module_1 = $__require("angular2/src/compiler/source_module.js");
    var change_detection_jit_generator_1 = $__require("angular2/src/core/change_detection/change_detection_jit_generator.js");
    var abstract_change_detector_1 = $__require("angular2/src/core/change_detection/abstract_change_detector.js");
    var change_detection_util_1 = $__require("angular2/src/core/change_detection/change_detection_util.js");
    var constants_1 = $__require("angular2/src/core/change_detection/constants.js");
    var change_definition_factory_1 = $__require("angular2/src/compiler/change_definition_factory.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var change_detection_1 = $__require("angular2/src/core/change_detection/change_detection.js");
    var change_detector_codegen_1 = $__require("angular2/src/transform/template_compiler/change_detector_codegen.js");
    var util_1 = $__require("angular2/src/compiler/util.js");
    var di_1 = $__require("angular2/src/core/di.js");
    var ABSTRACT_CHANGE_DETECTOR = "AbstractChangeDetector";
    var UTIL = "ChangeDetectionUtil";
    var CHANGE_DETECTOR_STATE = "ChangeDetectorState";
    exports.CHANGE_DETECTION_JIT_IMPORTS = lang_1.CONST_EXPR({
        'AbstractChangeDetector': abstract_change_detector_1.AbstractChangeDetector,
        'ChangeDetectionUtil': change_detection_util_1.ChangeDetectionUtil,
        'ChangeDetectorState': constants_1.ChangeDetectorState
    });
    var ABSTRACT_CHANGE_DETECTOR_MODULE = source_module_1.moduleRef("package:angular2/src/core/change_detection/abstract_change_detector" + util_1.MODULE_SUFFIX);
    var UTIL_MODULE = source_module_1.moduleRef("package:angular2/src/core/change_detection/change_detection_util" + util_1.MODULE_SUFFIX);
    var PREGEN_PROTO_CHANGE_DETECTOR_MODULE = source_module_1.moduleRef("package:angular2/src/core/change_detection/pregen_proto_change_detector" + util_1.MODULE_SUFFIX);
    var CONSTANTS_MODULE = source_module_1.moduleRef("package:angular2/src/core/change_detection/constants" + util_1.MODULE_SUFFIX);
    var ChangeDetectionCompiler = function () {
        function ChangeDetectionCompiler(_genConfig) {
            this._genConfig = _genConfig;
        }
        ChangeDetectionCompiler.prototype.compileComponentRuntime = function (componentType, strategy, parsedTemplate) {
            var _this = this;
            var changeDetectorDefinitions = change_definition_factory_1.createChangeDetectorDefinitions(componentType, strategy, this._genConfig, parsedTemplate);
            return changeDetectorDefinitions.map(function (definition) {
                return _this._createChangeDetectorFactory(definition);
            });
        };
        ChangeDetectionCompiler.prototype._createChangeDetectorFactory = function (definition) {
            var proto = new change_detection_1.DynamicProtoChangeDetector(definition);
            return function () {
                return proto.instantiate();
            };
        };
        ChangeDetectionCompiler.prototype.compileComponentCodeGen = function (componentType, strategy, parsedTemplate) {
            var changeDetectorDefinitions = change_definition_factory_1.createChangeDetectorDefinitions(componentType, strategy, this._genConfig, parsedTemplate);
            var factories = [];
            var index = 0;
            var sourceParts = changeDetectorDefinitions.map(function (definition) {
                var codegen;
                var sourcePart;
                // TODO(tbosch): move the 2 code generators to the same place, one with .dart and one with .ts
                // suffix
                // and have the same API for calling them!
                if (lang_1.IS_DART) {
                    codegen = new change_detector_codegen_1.Codegen(PREGEN_PROTO_CHANGE_DETECTOR_MODULE);
                    var className = "_" + definition.id;
                    var typeRef = index === 0 && componentType.isHost ? 'dynamic' : "" + source_module_1.moduleRef(componentType.moduleUrl) + componentType.name;
                    codegen.generate(typeRef, className, definition);
                    factories.push(className + ".newChangeDetector");
                    sourcePart = codegen.toString();
                } else {
                    codegen = new change_detection_jit_generator_1.ChangeDetectorJITGenerator(definition, "" + UTIL_MODULE + UTIL, "" + ABSTRACT_CHANGE_DETECTOR_MODULE + ABSTRACT_CHANGE_DETECTOR, "" + CONSTANTS_MODULE + CHANGE_DETECTOR_STATE);
                    factories.push("function() { return new " + codegen.typeName + "(); }");
                    sourcePart = codegen.generateSource();
                }
                index++;
                return sourcePart;
            });
            return new source_module_1.SourceExpressions(sourceParts, factories);
        };
        ChangeDetectionCompiler = __decorate([di_1.Injectable(), __metadata('design:paramtypes', [change_detection_1.ChangeDetectorGenConfig])], ChangeDetectionCompiler);
        return ChangeDetectionCompiler;
    }();
    exports.ChangeDetectionCompiler = ChangeDetectionCompiler;
});
System.registerDynamic('angular2/src/compiler/shadow_css.js', ['angular2/src/facade/collection.js', 'angular2/src/facade/lang.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var collection_1 = $__require('angular2/src/facade/collection.js');
    var lang_1 = $__require('angular2/src/facade/lang.js');
    /**
     * This file is a port of shadowCSS from webcomponents.js to TypeScript.
     *
     * Please make sure to keep to edits in sync with the source file.
     *
     * Source:
     * https://github.com/webcomponents/webcomponentsjs/blob/4efecd7e0e/src/ShadowCSS/ShadowCSS.js
     *
     * The original file level comment is reproduced below
     */
    /*
      This is a limited shim for ShadowDOM css styling.
      https://dvcs.w3.org/hg/webcomponents/raw-file/tip/spec/shadow/index.html#styles
    
      The intention here is to support only the styling features which can be
      relatively simply implemented. The goal is to allow users to avoid the
      most obvious pitfalls and do so without compromising performance significantly.
      For ShadowDOM styling that's not covered here, a set of best practices
      can be provided that should allow users to accomplish more complex styling.
    
      The following is a list of specific ShadowDOM styling features and a brief
      discussion of the approach used to shim.
    
      Shimmed features:
    
      * :host, :host-context: ShadowDOM allows styling of the shadowRoot's host
      element using the :host rule. To shim this feature, the :host styles are
      reformatted and prefixed with a given scope name and promoted to a
      document level stylesheet.
      For example, given a scope name of .foo, a rule like this:
    
        :host {
            background: red;
          }
        }
    
      becomes:
    
        .foo {
          background: red;
        }
    
      * encapsultion: Styles defined within ShadowDOM, apply only to
      dom inside the ShadowDOM. Polymer uses one of two techniques to implement
      this feature.
    
      By default, rules are prefixed with the host element tag name
      as a descendant selector. This ensures styling does not leak out of the 'top'
      of the element's ShadowDOM. For example,
    
      div {
          font-weight: bold;
        }
    
      becomes:
    
      x-foo div {
          font-weight: bold;
        }
    
      becomes:
    
    
      Alternatively, if WebComponents.ShadowCSS.strictStyling is set to true then
      selectors are scoped by adding an attribute selector suffix to each
      simple selector that contains the host element tag name. Each element
      in the element's ShadowDOM template is also given the scope attribute.
      Thus, these rules match only elements that have the scope attribute.
      For example, given a scope name of x-foo, a rule like this:
    
        div {
          font-weight: bold;
        }
    
      becomes:
    
        div[x-foo] {
          font-weight: bold;
        }
    
      Note that elements that are dynamically added to a scope must have the scope
      selector added to them manually.
    
      * upper/lower bound encapsulation: Styles which are defined outside a
      shadowRoot should not cross the ShadowDOM boundary and should not apply
      inside a shadowRoot.
    
      This styling behavior is not emulated. Some possible ways to do this that
      were rejected due to complexity and/or performance concerns include: (1) reset
      every possible property for every possible selector for a given scope name;
      (2) re-implement css in javascript.
    
      As an alternative, users should make sure to use selectors
      specific to the scope in which they are working.
    
      * ::distributed: This behavior is not emulated. It's often not necessary
      to style the contents of a specific insertion point and instead, descendants
      of the host element can be styled selectively. Users can also create an
      extra node around an insertion point and style that node's contents
      via descendent selectors. For example, with a shadowRoot like this:
    
        <style>
          ::content(div) {
            background: red;
          }
        </style>
        <content></content>
    
      could become:
    
        <style>
          / *@polyfill .content-container div * /
          ::content(div) {
            background: red;
          }
        </style>
        <div class="content-container">
          <content></content>
        </div>
    
      Note the use of @polyfill in the comment above a ShadowDOM specific style
      declaration. This is a directive to the styling shim to use the selector
      in comments in lieu of the next selector when running under polyfill.
    */
    var ShadowCss = function () {
        function ShadowCss() {
            this.strictStyling = true;
        }
        /*
        * Shim some cssText with the given selector. Returns cssText that can
        * be included in the document via WebComponents.ShadowCSS.addCssToDocument(css).
        *
        * When strictStyling is true:
        * - selector is the attribute added to all elements inside the host,
        * - hostSelector is the attribute added to the host itself.
        */
        ShadowCss.prototype.shimCssText = function (cssText, selector, hostSelector) {
            if (hostSelector === void 0) {
                hostSelector = '';
            }
            cssText = stripComments(cssText);
            cssText = this._insertDirectives(cssText);
            return this._scopeCssText(cssText, selector, hostSelector);
        };
        ShadowCss.prototype._insertDirectives = function (cssText) {
            cssText = this._insertPolyfillDirectivesInCssText(cssText);
            return this._insertPolyfillRulesInCssText(cssText);
        };
        /*
         * Process styles to convert native ShadowDOM rules that will trip
         * up the css parser; we rely on decorating the stylesheet with inert rules.
         *
         * For example, we convert this rule:
         *
         * polyfill-next-selector { content: ':host menu-item'; }
         * ::content menu-item {
         *
         * to this:
         *
         * scopeName menu-item {
         *
        **/
        ShadowCss.prototype._insertPolyfillDirectivesInCssText = function (cssText) {
            // Difference with webcomponents.js: does not handle comments
            return lang_1.StringWrapper.replaceAllMapped(cssText, _cssContentNextSelectorRe, function (m) {
                return m[1] + '{';
            });
        };
        /*
         * Process styles to add rules which will only apply under the polyfill
         *
         * For example, we convert this rule:
         *
         * polyfill-rule {
         *   content: ':host menu-item';
         * ...
         * }
         *
         * to this:
         *
         * scopeName menu-item {...}
         *
        **/
        ShadowCss.prototype._insertPolyfillRulesInCssText = function (cssText) {
            // Difference with webcomponents.js: does not handle comments
            return lang_1.StringWrapper.replaceAllMapped(cssText, _cssContentRuleRe, function (m) {
                var rule = m[0];
                rule = lang_1.StringWrapper.replace(rule, m[1], '');
                rule = lang_1.StringWrapper.replace(rule, m[2], '');
                return m[3] + rule;
            });
        };
        /* Ensure styles are scoped. Pseudo-scoping takes a rule like:
         *
         *  .foo {... }
         *
         *  and converts this to
         *
         *  scopeName .foo { ... }
        */
        ShadowCss.prototype._scopeCssText = function (cssText, scopeSelector, hostSelector) {
            var unscoped = this._extractUnscopedRulesFromCssText(cssText);
            cssText = this._insertPolyfillHostInCssText(cssText);
            cssText = this._convertColonHost(cssText);
            cssText = this._convertColonHostContext(cssText);
            cssText = this._convertShadowDOMSelectors(cssText);
            if (lang_1.isPresent(scopeSelector)) {
                cssText = this._scopeSelectors(cssText, scopeSelector, hostSelector);
            }
            cssText = cssText + '\n' + unscoped;
            return cssText.trim();
        };
        /*
         * Process styles to add rules which will only apply under the polyfill
         * and do not process via CSSOM. (CSSOM is destructive to rules on rare
         * occasions, e.g. -webkit-calc on Safari.)
         * For example, we convert this rule:
         *
         * @polyfill-unscoped-rule {
         *   content: 'menu-item';
         * ... }
         *
         * to this:
         *
         * menu-item {...}
         *
        **/
        ShadowCss.prototype._extractUnscopedRulesFromCssText = function (cssText) {
            // Difference with webcomponents.js: does not handle comments
            var r = '',
                m;
            var matcher = lang_1.RegExpWrapper.matcher(_cssContentUnscopedRuleRe, cssText);
            while (lang_1.isPresent(m = lang_1.RegExpMatcherWrapper.next(matcher))) {
                var rule = m[0];
                rule = lang_1.StringWrapper.replace(rule, m[2], '');
                rule = lang_1.StringWrapper.replace(rule, m[1], m[3]);
                r += rule + '\n\n';
            }
            return r;
        };
        /*
         * convert a rule like :host(.foo) > .bar { }
         *
         * to
         *
         * scopeName.foo > .bar
        */
        ShadowCss.prototype._convertColonHost = function (cssText) {
            return this._convertColonRule(cssText, _cssColonHostRe, this._colonHostPartReplacer);
        };
        /*
         * convert a rule like :host-context(.foo) > .bar { }
         *
         * to
         *
         * scopeName.foo > .bar, .foo scopeName > .bar { }
         *
         * and
         *
         * :host-context(.foo:host) .bar { ... }
         *
         * to
         *
         * scopeName.foo .bar { ... }
        */
        ShadowCss.prototype._convertColonHostContext = function (cssText) {
            return this._convertColonRule(cssText, _cssColonHostContextRe, this._colonHostContextPartReplacer);
        };
        ShadowCss.prototype._convertColonRule = function (cssText, regExp, partReplacer) {
            // p1 = :host, p2 = contents of (), p3 rest of rule
            return lang_1.StringWrapper.replaceAllMapped(cssText, regExp, function (m) {
                if (lang_1.isPresent(m[2])) {
                    var parts = m[2].split(','),
                        r = [];
                    for (var i = 0; i < parts.length; i++) {
                        var p = parts[i];
                        if (lang_1.isBlank(p)) break;
                        p = p.trim();
                        r.push(partReplacer(_polyfillHostNoCombinator, p, m[3]));
                    }
                    return r.join(',');
                } else {
                    return _polyfillHostNoCombinator + m[3];
                }
            });
        };
        ShadowCss.prototype._colonHostContextPartReplacer = function (host, part, suffix) {
            if (lang_1.StringWrapper.contains(part, _polyfillHost)) {
                return this._colonHostPartReplacer(host, part, suffix);
            } else {
                return host + part + suffix + ', ' + part + ' ' + host + suffix;
            }
        };
        ShadowCss.prototype._colonHostPartReplacer = function (host, part, suffix) {
            return host + lang_1.StringWrapper.replace(part, _polyfillHost, '') + suffix;
        };
        /*
         * Convert combinators like ::shadow and pseudo-elements like ::content
         * by replacing with space.
        */
        ShadowCss.prototype._convertShadowDOMSelectors = function (cssText) {
            for (var i = 0; i < _shadowDOMSelectorsRe.length; i++) {
                cssText = lang_1.StringWrapper.replaceAll(cssText, _shadowDOMSelectorsRe[i], ' ');
            }
            return cssText;
        };
        // change a selector like 'div' to 'name div'
        ShadowCss.prototype._scopeSelectors = function (cssText, scopeSelector, hostSelector) {
            var _this = this;
            return processRules(cssText, function (rule) {
                var selector = rule.selector;
                var content = rule.content;
                if (rule.selector[0] != '@' || rule.selector.startsWith('@page')) {
                    selector = _this._scopeSelector(rule.selector, scopeSelector, hostSelector, _this.strictStyling);
                } else if (rule.selector.startsWith('@media')) {
                    content = _this._scopeSelectors(rule.content, scopeSelector, hostSelector);
                }
                return new CssRule(selector, content);
            });
        };
        ShadowCss.prototype._scopeSelector = function (selector, scopeSelector, hostSelector, strict) {
            var r = [],
                parts = selector.split(',');
            for (var i = 0; i < parts.length; i++) {
                var p = parts[i].trim();
                var deepParts = lang_1.StringWrapper.split(p, _shadowDeepSelectors);
                var shallowPart = deepParts[0];
                if (this._selectorNeedsScoping(shallowPart, scopeSelector)) {
                    deepParts[0] = strict && !lang_1.StringWrapper.contains(shallowPart, _polyfillHostNoCombinator) ? this._applyStrictSelectorScope(shallowPart, scopeSelector) : this._applySelectorScope(shallowPart, scopeSelector, hostSelector);
                }
                // replace /deep/ with a space for child selectors
                r.push(deepParts.join(' '));
            }
            return r.join(', ');
        };
        ShadowCss.prototype._selectorNeedsScoping = function (selector, scopeSelector) {
            var re = this._makeScopeMatcher(scopeSelector);
            return !lang_1.isPresent(lang_1.RegExpWrapper.firstMatch(re, selector));
        };
        ShadowCss.prototype._makeScopeMatcher = function (scopeSelector) {
            var lre = /\[/g;
            var rre = /\]/g;
            scopeSelector = lang_1.StringWrapper.replaceAll(scopeSelector, lre, '\\[');
            scopeSelector = lang_1.StringWrapper.replaceAll(scopeSelector, rre, '\\]');
            return lang_1.RegExpWrapper.create('^(' + scopeSelector + ')' + _selectorReSuffix, 'm');
        };
        ShadowCss.prototype._applySelectorScope = function (selector, scopeSelector, hostSelector) {
            // Difference from webcomponentsjs: scopeSelector could not be an array
            return this._applySimpleSelectorScope(selector, scopeSelector, hostSelector);
        };
        // scope via name and [is=name]
        ShadowCss.prototype._applySimpleSelectorScope = function (selector, scopeSelector, hostSelector) {
            if (lang_1.isPresent(lang_1.RegExpWrapper.firstMatch(_polyfillHostRe, selector))) {
                var replaceBy = this.strictStyling ? "[" + hostSelector + "]" : scopeSelector;
                selector = lang_1.StringWrapper.replace(selector, _polyfillHostNoCombinator, replaceBy);
                return lang_1.StringWrapper.replaceAll(selector, _polyfillHostRe, replaceBy + ' ');
            } else {
                return scopeSelector + ' ' + selector;
            }
        };
        // return a selector with [name] suffix on each simple selector
        // e.g. .foo.bar > .zot becomes .foo[name].bar[name] > .zot[name]  /** @internal */
        ShadowCss.prototype._applyStrictSelectorScope = function (selector, scopeSelector) {
            var isRe = /\[is=([^\]]*)\]/g;
            scopeSelector = lang_1.StringWrapper.replaceAllMapped(scopeSelector, isRe, function (m) {
                return m[1];
            });
            var splits = [' ', '>', '+', '~'],
                scoped = selector,
                attrName = '[' + scopeSelector + ']';
            for (var i = 0; i < splits.length; i++) {
                var sep = splits[i];
                var parts = scoped.split(sep);
                scoped = parts.map(function (p) {
                    // remove :host since it should be unnecessary
                    var t = lang_1.StringWrapper.replaceAll(p.trim(), _polyfillHostRe, '');
                    if (t.length > 0 && !collection_1.ListWrapper.contains(splits, t) && !lang_1.StringWrapper.contains(t, attrName)) {
                        var re = /([^:]*)(:*)(.*)/g;
                        var m = lang_1.RegExpWrapper.firstMatch(re, t);
                        if (lang_1.isPresent(m)) {
                            p = m[1] + attrName + m[2] + m[3];
                        }
                    }
                    return p;
                }).join(sep);
            }
            return scoped;
        };
        ShadowCss.prototype._insertPolyfillHostInCssText = function (selector) {
            selector = lang_1.StringWrapper.replaceAll(selector, _colonHostContextRe, _polyfillHostContext);
            selector = lang_1.StringWrapper.replaceAll(selector, _colonHostRe, _polyfillHost);
            return selector;
        };
        return ShadowCss;
    }();
    exports.ShadowCss = ShadowCss;
    var _cssContentNextSelectorRe = /polyfill-next-selector[^}]*content:[\s]*?['"](.*?)['"][;\s]*}([^{]*?){/gim;
    var _cssContentRuleRe = /(polyfill-rule)[^}]*(content:[\s]*['"](.*?)['"])[;\s]*[^}]*}/gim;
    var _cssContentUnscopedRuleRe = /(polyfill-unscoped-rule)[^}]*(content:[\s]*['"](.*?)['"])[;\s]*[^}]*}/gim;
    var _polyfillHost = '-shadowcsshost';
    // note: :host-context pre-processed to -shadowcsshostcontext.
    var _polyfillHostContext = '-shadowcsscontext';
    var _parenSuffix = ')(?:\\((' + '(?:\\([^)(]*\\)|[^)(]*)+?' + ')\\))?([^,{]*)';
    var _cssColonHostRe = lang_1.RegExpWrapper.create('(' + _polyfillHost + _parenSuffix, 'im');
    var _cssColonHostContextRe = lang_1.RegExpWrapper.create('(' + _polyfillHostContext + _parenSuffix, 'im');
    var _polyfillHostNoCombinator = _polyfillHost + '-no-combinator';
    var _shadowDOMSelectorsRe = [/::shadow/g, /::content/g,
    // Deprecated selectors
    // TODO(vicb): see https://github.com/angular/clang-format/issues/16
    // clang-format off
    /\/shadow-deep\//g, /\/shadow\//g];
    var _shadowDeepSelectors = /(?:>>>)|(?:\/deep\/)/g;
    var _selectorReSuffix = '([>\\s~+\[.,{:][\\s\\S]*)?$';
    var _polyfillHostRe = lang_1.RegExpWrapper.create(_polyfillHost, 'im');
    var _colonHostRe = /:host/gim;
    var _colonHostContextRe = /:host-context/gim;
    var _commentRe = /\/\*[\s\S]*?\*\//g;
    function stripComments(input) {
        return lang_1.StringWrapper.replaceAllMapped(input, _commentRe, function (_) {
            return '';
        });
    }
    var _ruleRe = /(\s*)([^;\{\}]+?)(\s*)((?:{%BLOCK%}?\s*;?)|(?:\s*;))/g;
    var _curlyRe = /([{}])/g;
    var OPEN_CURLY = '{';
    var CLOSE_CURLY = '}';
    var BLOCK_PLACEHOLDER = '%BLOCK%';
    var CssRule = function () {
        function CssRule(selector, content) {
            this.selector = selector;
            this.content = content;
        }
        return CssRule;
    }();
    exports.CssRule = CssRule;
    function processRules(input, ruleCallback) {
        var inputWithEscapedBlocks = escapeBlocks(input);
        var nextBlockIndex = 0;
        return lang_1.StringWrapper.replaceAllMapped(inputWithEscapedBlocks.escapedString, _ruleRe, function (m) {
            var selector = m[2];
            var content = '';
            var suffix = m[4];
            var contentPrefix = '';
            if (lang_1.isPresent(m[4]) && m[4].startsWith('{' + BLOCK_PLACEHOLDER)) {
                content = inputWithEscapedBlocks.blocks[nextBlockIndex++];
                suffix = m[4].substring(BLOCK_PLACEHOLDER.length + 1);
                contentPrefix = '{';
            }
            var rule = ruleCallback(new CssRule(selector, content));
            return "" + m[1] + rule.selector + m[3] + contentPrefix + rule.content + suffix;
        });
    }
    exports.processRules = processRules;
    var StringWithEscapedBlocks = function () {
        function StringWithEscapedBlocks(escapedString, blocks) {
            this.escapedString = escapedString;
            this.blocks = blocks;
        }
        return StringWithEscapedBlocks;
    }();
    function escapeBlocks(input) {
        var inputParts = lang_1.StringWrapper.split(input, _curlyRe);
        var resultParts = [];
        var escapedBlocks = [];
        var bracketCount = 0;
        var currentBlockParts = [];
        for (var partIndex = 0; partIndex < inputParts.length; partIndex++) {
            var part = inputParts[partIndex];
            if (part == CLOSE_CURLY) {
                bracketCount--;
            }
            if (bracketCount > 0) {
                currentBlockParts.push(part);
            } else {
                if (currentBlockParts.length > 0) {
                    escapedBlocks.push(currentBlockParts.join(''));
                    resultParts.push(BLOCK_PLACEHOLDER);
                    currentBlockParts = [];
                }
                resultParts.push(part);
            }
            if (part == OPEN_CURLY) {
                bracketCount++;
            }
        }
        if (currentBlockParts.length > 0) {
            escapedBlocks.push(currentBlockParts.join(''));
            resultParts.push(BLOCK_PLACEHOLDER);
        }
        return new StringWithEscapedBlocks(resultParts.join(''), escapedBlocks);
    }
});
System.registerDynamic("angular2/src/compiler/style_compiler.js", ["angular2/src/compiler/source_module.js", "angular2/src/core/metadata/view.js", "angular2/src/compiler/xhr.js", "angular2/src/facade/lang.js", "angular2/src/facade/async.js", "angular2/src/compiler/shadow_css.js", "angular2/src/compiler/url_resolver.js", "angular2/src/compiler/style_url_resolver.js", "angular2/src/compiler/util.js", "angular2/src/core/di.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var source_module_1 = $__require("angular2/src/compiler/source_module.js");
    var view_1 = $__require("angular2/src/core/metadata/view.js");
    var xhr_1 = $__require("angular2/src/compiler/xhr.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var async_1 = $__require("angular2/src/facade/async.js");
    var shadow_css_1 = $__require("angular2/src/compiler/shadow_css.js");
    var url_resolver_1 = $__require("angular2/src/compiler/url_resolver.js");
    var style_url_resolver_1 = $__require("angular2/src/compiler/style_url_resolver.js");
    var util_1 = $__require("angular2/src/compiler/util.js");
    var di_1 = $__require("angular2/src/core/di.js");
    var COMPONENT_VARIABLE = '%COMP%';
    var HOST_ATTR = "_nghost-" + COMPONENT_VARIABLE;
    var CONTENT_ATTR = "_ngcontent-" + COMPONENT_VARIABLE;
    var StyleCompiler = function () {
        function StyleCompiler(_xhr, _urlResolver) {
            this._xhr = _xhr;
            this._urlResolver = _urlResolver;
            this._styleCache = new Map();
            this._shadowCss = new shadow_css_1.ShadowCss();
        }
        StyleCompiler.prototype.compileComponentRuntime = function (template) {
            var styles = template.styles;
            var styleAbsUrls = template.styleUrls;
            return this._loadStyles(styles, styleAbsUrls, template.encapsulation === view_1.ViewEncapsulation.Emulated);
        };
        StyleCompiler.prototype.compileComponentCodeGen = function (template) {
            var shim = template.encapsulation === view_1.ViewEncapsulation.Emulated;
            return this._styleCodeGen(template.styles, template.styleUrls, shim);
        };
        StyleCompiler.prototype.compileStylesheetCodeGen = function (stylesheetUrl, cssText) {
            var styleWithImports = style_url_resolver_1.extractStyleUrls(this._urlResolver, stylesheetUrl, cssText);
            return [this._styleModule(stylesheetUrl, false, this._styleCodeGen([styleWithImports.style], styleWithImports.styleUrls, false)), this._styleModule(stylesheetUrl, true, this._styleCodeGen([styleWithImports.style], styleWithImports.styleUrls, true))];
        };
        StyleCompiler.prototype.clearCache = function () {
            this._styleCache.clear();
        };
        StyleCompiler.prototype._loadStyles = function (plainStyles, absUrls, encapsulate) {
            var _this = this;
            var promises = absUrls.map(function (absUrl) {
                var cacheKey = "" + absUrl + (encapsulate ? '.shim' : '');
                var result = _this._styleCache.get(cacheKey);
                if (lang_1.isBlank(result)) {
                    result = _this._xhr.get(absUrl).then(function (style) {
                        var styleWithImports = style_url_resolver_1.extractStyleUrls(_this._urlResolver, absUrl, style);
                        return _this._loadStyles([styleWithImports.style], styleWithImports.styleUrls, encapsulate);
                    });
                    _this._styleCache.set(cacheKey, result);
                }
                return result;
            });
            return async_1.PromiseWrapper.all(promises).then(function (nestedStyles) {
                var result = plainStyles.map(function (plainStyle) {
                    return _this._shimIfNeeded(plainStyle, encapsulate);
                });
                nestedStyles.forEach(function (styles) {
                    return result.push(styles);
                });
                return result;
            });
        };
        StyleCompiler.prototype._styleCodeGen = function (plainStyles, absUrls, shim) {
            var _this = this;
            var arrayPrefix = lang_1.IS_DART ? "const" : '';
            var styleExpressions = plainStyles.map(function (plainStyle) {
                return util_1.escapeSingleQuoteString(_this._shimIfNeeded(plainStyle, shim));
            });
            for (var i = 0; i < absUrls.length; i++) {
                var moduleUrl = this._createModuleUrl(absUrls[i], shim);
                styleExpressions.push(source_module_1.moduleRef(moduleUrl) + "STYLES");
            }
            var expressionSource = arrayPrefix + " [" + styleExpressions.join(',') + "]";
            return new source_module_1.SourceExpression([], expressionSource);
        };
        StyleCompiler.prototype._styleModule = function (stylesheetUrl, shim, expression) {
            var moduleSource = "\n      " + expression.declarations.join('\n') + "\n      " + util_1.codeGenExportVariable('STYLES') + expression.expression + ";\n    ";
            return new source_module_1.SourceModule(this._createModuleUrl(stylesheetUrl, shim), moduleSource);
        };
        StyleCompiler.prototype._shimIfNeeded = function (style, shim) {
            return shim ? this._shadowCss.shimCssText(style, CONTENT_ATTR, HOST_ATTR) : style;
        };
        StyleCompiler.prototype._createModuleUrl = function (stylesheetUrl, shim) {
            return shim ? stylesheetUrl + ".shim" + util_1.MODULE_SUFFIX : "" + stylesheetUrl + util_1.MODULE_SUFFIX;
        };
        StyleCompiler = __decorate([di_1.Injectable(), __metadata('design:paramtypes', [xhr_1.XHR, url_resolver_1.UrlResolver])], StyleCompiler);
        return StyleCompiler;
    }();
    exports.StyleCompiler = StyleCompiler;
});
System.registerDynamic("angular2/src/compiler/view_compiler.js", ["angular2/src/facade/lang.js", "angular2/src/facade/collection.js", "angular2/src/compiler/template_ast.js", "angular2/src/compiler/source_module.js", "angular2/src/core/linker/view.js", "angular2/src/core/linker/view_type.js", "angular2/src/core/linker/element.js", "angular2/src/core/metadata/view.js", "angular2/src/compiler/util.js", "angular2/src/core/di.js", "angular2/src/compiler/proto_view_compiler.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var template_ast_1 = $__require("angular2/src/compiler/template_ast.js");
    var source_module_1 = $__require("angular2/src/compiler/source_module.js");
    var view_1 = $__require("angular2/src/core/linker/view.js");
    var view_type_1 = $__require("angular2/src/core/linker/view_type.js");
    var element_1 = $__require("angular2/src/core/linker/element.js");
    var view_2 = $__require("angular2/src/core/metadata/view.js");
    var util_1 = $__require("angular2/src/compiler/util.js");
    var di_1 = $__require("angular2/src/core/di.js");
    var proto_view_compiler_1 = $__require("angular2/src/compiler/proto_view_compiler.js");
    exports.VIEW_JIT_IMPORTS = lang_1.CONST_EXPR({
        'AppView': view_1.AppView,
        'AppElement': element_1.AppElement,
        'flattenNestedViewRenderNodes': view_1.flattenNestedViewRenderNodes,
        'checkSlotCount': view_1.checkSlotCount
    });
    var ViewCompiler = function () {
        function ViewCompiler() {}
        ViewCompiler.prototype.compileComponentRuntime = function (component, template, styles, protoViews, changeDetectorFactories, componentViewFactory) {
            var viewFactory = new RuntimeViewFactory(component, styles, protoViews, changeDetectorFactories, componentViewFactory);
            return viewFactory.createViewFactory(template, 0, []);
        };
        ViewCompiler.prototype.compileComponentCodeGen = function (component, template, styles, protoViews, changeDetectorFactoryExpressions, componentViewFactory) {
            var viewFactory = new CodeGenViewFactory(component, styles, protoViews, changeDetectorFactoryExpressions, componentViewFactory);
            var targetStatements = [];
            var viewFactoryExpression = viewFactory.createViewFactory(template, 0, targetStatements);
            return new source_module_1.SourceExpression(targetStatements.map(function (stmt) {
                return stmt.statement;
            }), viewFactoryExpression.expression);
        };
        ViewCompiler = __decorate([di_1.Injectable(), __metadata('design:paramtypes', [])], ViewCompiler);
        return ViewCompiler;
    }();
    exports.ViewCompiler = ViewCompiler;
    var CodeGenViewFactory = function () {
        function CodeGenViewFactory(component, styles, protoViews, changeDetectorExpressions, componentViewFactory) {
            this.component = component;
            this.styles = styles;
            this.protoViews = protoViews;
            this.changeDetectorExpressions = changeDetectorExpressions;
            this.componentViewFactory = componentViewFactory;
            this._nextVarId = 0;
        }
        CodeGenViewFactory.prototype._nextVar = function (prefix) {
            return "" + prefix + this._nextVarId++ + "_" + this.component.type.name;
        };
        CodeGenViewFactory.prototype._nextRenderVar = function () {
            return this._nextVar('render');
        };
        CodeGenViewFactory.prototype._nextAppVar = function () {
            return this._nextVar('app');
        };
        CodeGenViewFactory.prototype._nextDisposableVar = function () {
            return "disposable" + this._nextVarId++ + "_" + this.component.type.name;
        };
        CodeGenViewFactory.prototype.createText = function (renderer, parent, text, targetStatements) {
            var varName = this._nextRenderVar();
            var statement = "var " + varName + " = " + renderer.expression + ".createText(" + (lang_1.isPresent(parent) ? parent.expression : null) + ", " + util_1.escapeSingleQuoteString(text) + ");";
            targetStatements.push(new util_1.Statement(statement));
            return new util_1.Expression(varName);
        };
        CodeGenViewFactory.prototype.createElement = function (renderer, parentRenderNode, name, rootSelector, targetStatements) {
            var varName = this._nextRenderVar();
            var valueExpr;
            if (lang_1.isPresent(rootSelector)) {
                valueExpr = rootSelector.expression + " == null ?\n        " + renderer.expression + ".createElement(" + (lang_1.isPresent(parentRenderNode) ? parentRenderNode.expression : null) + ", " + util_1.escapeSingleQuoteString(name) + ") :\n        " + renderer.expression + ".selectRootElement(" + rootSelector.expression + ");";
            } else {
                valueExpr = renderer.expression + ".createElement(" + (lang_1.isPresent(parentRenderNode) ? parentRenderNode.expression : null) + ", " + util_1.escapeSingleQuoteString(name) + ")";
            }
            var statement = "var " + varName + " = " + valueExpr + ";";
            targetStatements.push(new util_1.Statement(statement));
            return new util_1.Expression(varName);
        };
        CodeGenViewFactory.prototype.createTemplateAnchor = function (renderer, parentRenderNode, targetStatements) {
            var varName = this._nextRenderVar();
            var valueExpr = renderer.expression + ".createTemplateAnchor(" + (lang_1.isPresent(parentRenderNode) ? parentRenderNode.expression : null) + ");";
            targetStatements.push(new util_1.Statement("var " + varName + " = " + valueExpr));
            return new util_1.Expression(varName);
        };
        CodeGenViewFactory.prototype.createGlobalEventListener = function (renderer, appView, boundElementIndex, eventAst, targetStatements) {
            var disposableVar = this._nextDisposableVar();
            var eventHandlerExpr = codeGenEventHandler(appView, boundElementIndex, eventAst.fullName);
            targetStatements.push(new util_1.Statement("var " + disposableVar + " = " + renderer.expression + ".listenGlobal(" + util_1.escapeValue(eventAst.target) + ", " + util_1.escapeValue(eventAst.name) + ", " + eventHandlerExpr + ");"));
            return new util_1.Expression(disposableVar);
        };
        CodeGenViewFactory.prototype.createElementEventListener = function (renderer, appView, boundElementIndex, renderNode, eventAst, targetStatements) {
            var disposableVar = this._nextDisposableVar();
            var eventHandlerExpr = codeGenEventHandler(appView, boundElementIndex, eventAst.fullName);
            targetStatements.push(new util_1.Statement("var " + disposableVar + " = " + renderer.expression + ".listen(" + renderNode.expression + ", " + util_1.escapeValue(eventAst.name) + ", " + eventHandlerExpr + ");"));
            return new util_1.Expression(disposableVar);
        };
        CodeGenViewFactory.prototype.setElementAttribute = function (renderer, renderNode, attrName, attrValue, targetStatements) {
            targetStatements.push(new util_1.Statement(renderer.expression + ".setElementAttribute(" + renderNode.expression + ", " + util_1.escapeSingleQuoteString(attrName) + ", " + util_1.escapeSingleQuoteString(attrValue) + ");"));
        };
        CodeGenViewFactory.prototype.createAppElement = function (appProtoEl, appView, renderNode, parentAppEl, embeddedViewFactory, targetStatements) {
            var appVar = this._nextAppVar();
            var varValue = "new " + proto_view_compiler_1.APP_EL_MODULE_REF + "AppElement(" + appProtoEl.expression + ", " + appView.expression + ",\n      " + (lang_1.isPresent(parentAppEl) ? parentAppEl.expression : null) + ", " + renderNode.expression + ", " + (lang_1.isPresent(embeddedViewFactory) ? embeddedViewFactory.expression : null) + ")";
            targetStatements.push(new util_1.Statement("var " + appVar + " = " + varValue + ";"));
            return new util_1.Expression(appVar);
        };
        CodeGenViewFactory.prototype.createAndSetComponentView = function (renderer, viewManager, view, appEl, component, contentNodesByNgContentIndex, targetStatements) {
            var codeGenContentNodes;
            if (this.component.type.isHost) {
                codeGenContentNodes = view.expression + ".projectableNodes";
            } else {
                codeGenContentNodes = "[" + contentNodesByNgContentIndex.map(function (nodes) {
                    return util_1.codeGenFlatArray(nodes);
                }).join(',') + "]";
            }
            targetStatements.push(new util_1.Statement(this.componentViewFactory(component) + "(" + renderer.expression + ", " + viewManager.expression + ", " + appEl.expression + ", " + codeGenContentNodes + ", null, null, null);"));
        };
        CodeGenViewFactory.prototype.getProjectedNodes = function (projectableNodes, ngContentIndex) {
            return new util_1.Expression(projectableNodes.expression + "[" + ngContentIndex + "]", true);
        };
        CodeGenViewFactory.prototype.appendProjectedNodes = function (renderer, parent, nodes, targetStatements) {
            targetStatements.push(new util_1.Statement(renderer.expression + ".projectNodes(" + parent.expression + ", " + proto_view_compiler_1.APP_VIEW_MODULE_REF + "flattenNestedViewRenderNodes(" + nodes.expression + "));"));
        };
        CodeGenViewFactory.prototype.createViewFactory = function (asts, embeddedTemplateIndex, targetStatements) {
            var compileProtoView = this.protoViews[embeddedTemplateIndex];
            var isHostView = this.component.type.isHost;
            var isComponentView = embeddedTemplateIndex === 0 && !isHostView;
            var visitor = new ViewBuilderVisitor(new util_1.Expression('renderer'), new util_1.Expression('viewManager'), new util_1.Expression('projectableNodes'), isHostView ? new util_1.Expression('rootSelector') : null, new util_1.Expression('view'), compileProtoView, targetStatements, this);
            template_ast_1.templateVisitAll(visitor, asts, new ParentElement(isComponentView ? new util_1.Expression('parentRenderNode') : null, null, null));
            var appProtoView = compileProtoView.protoView.expression;
            var viewFactoryName = codeGenViewFactoryName(this.component, embeddedTemplateIndex);
            var changeDetectorFactory = this.changeDetectorExpressions.expressions[embeddedTemplateIndex];
            var factoryArgs = ['parentRenderer', 'viewManager', 'containerEl', 'projectableNodes', 'rootSelector', 'dynamicallyCreatedProviders', 'rootInjector'];
            var initRendererStmts = [];
            var rendererExpr = "parentRenderer";
            if (embeddedTemplateIndex === 0) {
                var renderCompTypeVar = this._nextVar('renderType');
                targetStatements.push(new util_1.Statement("var " + renderCompTypeVar + " = null;"));
                var stylesVar = this._nextVar('styles');
                targetStatements.push(new util_1.Statement(util_1.CONST_VAR + " " + stylesVar + " = " + this.styles.expression + ";"));
                var encapsulation = this.component.template.encapsulation;
                initRendererStmts.push("if (" + renderCompTypeVar + " == null) {\n        " + renderCompTypeVar + " = viewManager.createRenderComponentType(" + codeGenViewEncapsulation(encapsulation) + ", " + stylesVar + ");\n      }");
                rendererExpr = "parentRenderer.renderComponent(" + renderCompTypeVar + ")";
            }
            var statement = "\n" + util_1.codeGenFnHeader(factoryArgs, viewFactoryName) + "{\n  " + initRendererStmts.join('\n') + "\n  var renderer = " + rendererExpr + ";\n  var view = new " + proto_view_compiler_1.APP_VIEW_MODULE_REF + "AppView(\n    " + appProtoView + ", renderer, viewManager,\n    projectableNodes,\n    containerEl,\n    dynamicallyCreatedProviders, rootInjector,\n    " + changeDetectorFactory + "()\n  );\n  " + proto_view_compiler_1.APP_VIEW_MODULE_REF + "checkSlotCount(" + util_1.escapeValue(this.component.type.name) + ", " + this.component.template.ngContentSelectors.length + ", projectableNodes);\n  " + (isComponentView ? 'var parentRenderNode = renderer.createViewRoot(view.containerAppElement.nativeElement);' : '') + "\n  " + visitor.renderStmts.map(function (stmt) {
                return stmt.statement;
            }).join('\n') + "\n  " + visitor.appStmts.map(function (stmt) {
                return stmt.statement;
            }).join('\n') + "\n\n  view.init(" + util_1.codeGenFlatArray(visitor.rootNodesOrAppElements) + ", " + util_1.codeGenArray(visitor.renderNodes) + ", " + util_1.codeGenArray(visitor.appDisposables) + ",\n            " + util_1.codeGenArray(visitor.appElements) + ");\n  return view;\n}";
            targetStatements.push(new util_1.Statement(statement));
            return new util_1.Expression(viewFactoryName);
        };
        return CodeGenViewFactory;
    }();
    var RuntimeViewFactory = function () {
        function RuntimeViewFactory(component, styles, protoViews, changeDetectorFactories, componentViewFactory) {
            this.component = component;
            this.styles = styles;
            this.protoViews = protoViews;
            this.changeDetectorFactories = changeDetectorFactories;
            this.componentViewFactory = componentViewFactory;
        }
        RuntimeViewFactory.prototype.createText = function (renderer, parent, text, targetStatements) {
            return renderer.createText(parent, text);
        };
        RuntimeViewFactory.prototype.createElement = function (renderer, parent, name, rootSelector, targetStatements) {
            var el;
            if (lang_1.isPresent(rootSelector)) {
                el = renderer.selectRootElement(rootSelector);
            } else {
                el = renderer.createElement(parent, name);
            }
            return el;
        };
        RuntimeViewFactory.prototype.createTemplateAnchor = function (renderer, parent, targetStatements) {
            return renderer.createTemplateAnchor(parent);
        };
        RuntimeViewFactory.prototype.createGlobalEventListener = function (renderer, appView, boundElementIndex, eventAst, targetStatements) {
            return renderer.listenGlobal(eventAst.target, eventAst.name, function (event) {
                return appView.triggerEventHandlers(eventAst.fullName, event, boundElementIndex);
            });
        };
        RuntimeViewFactory.prototype.createElementEventListener = function (renderer, appView, boundElementIndex, renderNode, eventAst, targetStatements) {
            return renderer.listen(renderNode, eventAst.name, function (event) {
                return appView.triggerEventHandlers(eventAst.fullName, event, boundElementIndex);
            });
        };
        RuntimeViewFactory.prototype.setElementAttribute = function (renderer, renderNode, attrName, attrValue, targetStatements) {
            renderer.setElementAttribute(renderNode, attrName, attrValue);
        };
        RuntimeViewFactory.prototype.createAppElement = function (appProtoEl, appView, renderNode, parentAppEl, embeddedViewFactory, targetStatements) {
            return new element_1.AppElement(appProtoEl, appView, parentAppEl, renderNode, embeddedViewFactory);
        };
        RuntimeViewFactory.prototype.createAndSetComponentView = function (renderer, viewManager, appView, appEl, component, contentNodesByNgContentIndex, targetStatements) {
            var flattenedContentNodes;
            if (this.component.type.isHost) {
                flattenedContentNodes = appView.projectableNodes;
            } else {
                flattenedContentNodes = collection_1.ListWrapper.createFixedSize(contentNodesByNgContentIndex.length);
                for (var i = 0; i < contentNodesByNgContentIndex.length; i++) {
                    flattenedContentNodes[i] = util_1.flattenArray(contentNodesByNgContentIndex[i], []);
                }
            }
            this.componentViewFactory(component)(renderer, viewManager, appEl, flattenedContentNodes);
        };
        RuntimeViewFactory.prototype.getProjectedNodes = function (projectableNodes, ngContentIndex) {
            return projectableNodes[ngContentIndex];
        };
        RuntimeViewFactory.prototype.appendProjectedNodes = function (renderer, parent, nodes, targetStatements) {
            renderer.projectNodes(parent, view_1.flattenNestedViewRenderNodes(nodes));
        };
        RuntimeViewFactory.prototype.createViewFactory = function (asts, embeddedTemplateIndex, targetStatements) {
            var _this = this;
            var compileProtoView = this.protoViews[embeddedTemplateIndex];
            var isComponentView = compileProtoView.protoView.type === view_type_1.ViewType.COMPONENT;
            var renderComponentType = null;
            return function (parentRenderer, viewManager, containerEl, projectableNodes, rootSelector, dynamicallyCreatedProviders, rootInjector) {
                if (rootSelector === void 0) {
                    rootSelector = null;
                }
                if (dynamicallyCreatedProviders === void 0) {
                    dynamicallyCreatedProviders = null;
                }
                if (rootInjector === void 0) {
                    rootInjector = null;
                }
                view_1.checkSlotCount(_this.component.type.name, _this.component.template.ngContentSelectors.length, projectableNodes);
                var renderer;
                if (embeddedTemplateIndex === 0) {
                    if (lang_1.isBlank(renderComponentType)) {
                        renderComponentType = viewManager.createRenderComponentType(_this.component.template.encapsulation, _this.styles);
                    }
                    renderer = parentRenderer.renderComponent(renderComponentType);
                } else {
                    renderer = parentRenderer;
                }
                var changeDetector = _this.changeDetectorFactories[embeddedTemplateIndex]();
                var view = new view_1.AppView(compileProtoView.protoView, renderer, viewManager, projectableNodes, containerEl, dynamicallyCreatedProviders, rootInjector, changeDetector);
                var visitor = new ViewBuilderVisitor(renderer, viewManager, projectableNodes, rootSelector, view, compileProtoView, [], _this);
                var parentRenderNode = isComponentView ? renderer.createViewRoot(containerEl.nativeElement) : null;
                template_ast_1.templateVisitAll(visitor, asts, new ParentElement(parentRenderNode, null, null));
                view.init(util_1.flattenArray(visitor.rootNodesOrAppElements, []), visitor.renderNodes, visitor.appDisposables, visitor.appElements);
                return view;
            };
        };
        return RuntimeViewFactory;
    }();
    var ParentElement = function () {
        function ParentElement(renderNode, appEl, component) {
            this.renderNode = renderNode;
            this.appEl = appEl;
            this.component = component;
            if (lang_1.isPresent(component)) {
                this.contentNodesByNgContentIndex = collection_1.ListWrapper.createFixedSize(component.template.ngContentSelectors.length);
                for (var i = 0; i < this.contentNodesByNgContentIndex.length; i++) {
                    this.contentNodesByNgContentIndex[i] = [];
                }
            } else {
                this.contentNodesByNgContentIndex = null;
            }
        }
        ParentElement.prototype.addContentNode = function (ngContentIndex, nodeExpr) {
            this.contentNodesByNgContentIndex[ngContentIndex].push(nodeExpr);
        };
        return ParentElement;
    }();
    var ViewBuilderVisitor = function () {
        function ViewBuilderVisitor(renderer, viewManager, projectableNodes, rootSelector, view, protoView, targetStatements, factory) {
            this.renderer = renderer;
            this.viewManager = viewManager;
            this.projectableNodes = projectableNodes;
            this.rootSelector = rootSelector;
            this.view = view;
            this.protoView = protoView;
            this.targetStatements = targetStatements;
            this.factory = factory;
            this.renderStmts = [];
            this.renderNodes = [];
            this.appStmts = [];
            this.appElements = [];
            this.appDisposables = [];
            this.rootNodesOrAppElements = [];
            this.elementCount = 0;
        }
        ViewBuilderVisitor.prototype._addRenderNode = function (renderNode, appEl, ngContentIndex, parent) {
            this.renderNodes.push(renderNode);
            if (lang_1.isPresent(parent.component)) {
                if (lang_1.isPresent(ngContentIndex)) {
                    parent.addContentNode(ngContentIndex, lang_1.isPresent(appEl) ? appEl : renderNode);
                }
            } else if (lang_1.isBlank(parent.renderNode)) {
                this.rootNodesOrAppElements.push(lang_1.isPresent(appEl) ? appEl : renderNode);
            }
        };
        ViewBuilderVisitor.prototype._getParentRenderNode = function (ngContentIndex, parent) {
            return lang_1.isPresent(parent.component) && parent.component.template.encapsulation !== view_2.ViewEncapsulation.Native ? null : parent.renderNode;
        };
        ViewBuilderVisitor.prototype.visitBoundText = function (ast, parent) {
            return this._visitText('', ast.ngContentIndex, parent);
        };
        ViewBuilderVisitor.prototype.visitText = function (ast, parent) {
            return this._visitText(ast.value, ast.ngContentIndex, parent);
        };
        ViewBuilderVisitor.prototype._visitText = function (value, ngContentIndex, parent) {
            var renderNode = this.factory.createText(this.renderer, this._getParentRenderNode(ngContentIndex, parent), value, this.renderStmts);
            this._addRenderNode(renderNode, null, ngContentIndex, parent);
            return null;
        };
        ViewBuilderVisitor.prototype.visitNgContent = function (ast, parent) {
            var nodesExpression = this.factory.getProjectedNodes(this.projectableNodes, ast.index);
            if (lang_1.isPresent(parent.component)) {
                if (lang_1.isPresent(ast.ngContentIndex)) {
                    parent.addContentNode(ast.ngContentIndex, nodesExpression);
                }
            } else {
                if (lang_1.isPresent(parent.renderNode)) {
                    this.factory.appendProjectedNodes(this.renderer, parent.renderNode, nodesExpression, this.renderStmts);
                } else {
                    this.rootNodesOrAppElements.push(nodesExpression);
                }
            }
            return null;
        };
        ViewBuilderVisitor.prototype.visitElement = function (ast, parent) {
            var _this = this;
            var renderNode = this.factory.createElement(this.renderer, this._getParentRenderNode(ast.ngContentIndex, parent), ast.name, this.rootSelector, this.renderStmts);
            var component = ast.getComponent();
            var elementIndex = this.elementCount++;
            var protoEl = this.protoView.protoElements[elementIndex];
            protoEl.renderEvents.forEach(function (eventAst) {
                var disposable;
                if (lang_1.isPresent(eventAst.target)) {
                    disposable = _this.factory.createGlobalEventListener(_this.renderer, _this.view, protoEl.boundElementIndex, eventAst, _this.renderStmts);
                } else {
                    disposable = _this.factory.createElementEventListener(_this.renderer, _this.view, protoEl.boundElementIndex, renderNode, eventAst, _this.renderStmts);
                }
                _this.appDisposables.push(disposable);
            });
            for (var i = 0; i < protoEl.attrNameAndValues.length; i++) {
                var attrName = protoEl.attrNameAndValues[i][0];
                var attrValue = protoEl.attrNameAndValues[i][1];
                this.factory.setElementAttribute(this.renderer, renderNode, attrName, attrValue, this.renderStmts);
            }
            var appEl = null;
            if (lang_1.isPresent(protoEl.appProtoEl)) {
                appEl = this.factory.createAppElement(protoEl.appProtoEl, this.view, renderNode, parent.appEl, null, this.appStmts);
                this.appElements.push(appEl);
            }
            this._addRenderNode(renderNode, appEl, ast.ngContentIndex, parent);
            var newParent = new ParentElement(renderNode, lang_1.isPresent(appEl) ? appEl : parent.appEl, component);
            template_ast_1.templateVisitAll(this, ast.children, newParent);
            if (lang_1.isPresent(appEl) && lang_1.isPresent(component)) {
                this.factory.createAndSetComponentView(this.renderer, this.viewManager, this.view, appEl, component, newParent.contentNodesByNgContentIndex, this.appStmts);
            }
            return null;
        };
        ViewBuilderVisitor.prototype.visitEmbeddedTemplate = function (ast, parent) {
            var renderNode = this.factory.createTemplateAnchor(this.renderer, this._getParentRenderNode(ast.ngContentIndex, parent), this.renderStmts);
            var elementIndex = this.elementCount++;
            var protoEl = this.protoView.protoElements[elementIndex];
            var embeddedViewFactory = this.factory.createViewFactory(ast.children, protoEl.embeddedTemplateIndex, this.targetStatements);
            var appEl = this.factory.createAppElement(protoEl.appProtoEl, this.view, renderNode, parent.appEl, embeddedViewFactory, this.appStmts);
            this._addRenderNode(renderNode, appEl, ast.ngContentIndex, parent);
            this.appElements.push(appEl);
            return null;
        };
        ViewBuilderVisitor.prototype.visitVariable = function (ast, ctx) {
            return null;
        };
        ViewBuilderVisitor.prototype.visitAttr = function (ast, ctx) {
            return null;
        };
        ViewBuilderVisitor.prototype.visitDirective = function (ast, ctx) {
            return null;
        };
        ViewBuilderVisitor.prototype.visitEvent = function (ast, ctx) {
            return null;
        };
        ViewBuilderVisitor.prototype.visitDirectiveProperty = function (ast, context) {
            return null;
        };
        ViewBuilderVisitor.prototype.visitElementProperty = function (ast, context) {
            return null;
        };
        return ViewBuilderVisitor;
    }();
    function codeGenEventHandler(view, boundElementIndex, eventName) {
        return util_1.codeGenValueFn(['event'], view.expression + ".triggerEventHandlers(" + util_1.escapeValue(eventName) + ", event, " + boundElementIndex + ")");
    }
    function codeGenViewFactoryName(component, embeddedTemplateIndex) {
        return "viewFactory_" + component.type.name + embeddedTemplateIndex;
    }
    function codeGenViewEncapsulation(value) {
        if (lang_1.IS_DART) {
            return "" + proto_view_compiler_1.METADATA_MODULE_REF + value;
        } else {
            return "" + value;
        }
    }
});
System.registerDynamic('angular2/src/compiler/source_module.js', ['angular2/src/facade/lang.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var MODULE_REGEXP = /#MODULE\[([^\]]*)\]/g;
    function moduleRef(moduleUrl) {
        return "#MODULE[" + moduleUrl + "]";
    }
    exports.moduleRef = moduleRef;
    /**
     * Represents generated source code with module references. Internal to the Angular compiler.
     */
    var SourceModule = function () {
        function SourceModule(moduleUrl, sourceWithModuleRefs) {
            this.moduleUrl = moduleUrl;
            this.sourceWithModuleRefs = sourceWithModuleRefs;
        }
        SourceModule.getSourceWithoutImports = function (sourceWithModuleRefs) {
            return lang_1.StringWrapper.replaceAllMapped(sourceWithModuleRefs, MODULE_REGEXP, function (match) {
                return '';
            });
        };
        SourceModule.prototype.getSourceWithImports = function () {
            var _this = this;
            var moduleAliases = {};
            var imports = [];
            var newSource = lang_1.StringWrapper.replaceAllMapped(this.sourceWithModuleRefs, MODULE_REGEXP, function (match) {
                var moduleUrl = match[1];
                var alias = moduleAliases[moduleUrl];
                if (lang_1.isBlank(alias)) {
                    if (moduleUrl == _this.moduleUrl) {
                        alias = '';
                    } else {
                        alias = "import" + imports.length;
                        imports.push([moduleUrl, alias]);
                    }
                    moduleAliases[moduleUrl] = alias;
                }
                return alias.length > 0 ? alias + "." : '';
            });
            return new SourceWithImports(newSource, imports);
        };
        return SourceModule;
    }();
    exports.SourceModule = SourceModule;
    var SourceExpression = function () {
        function SourceExpression(declarations, expression) {
            this.declarations = declarations;
            this.expression = expression;
        }
        return SourceExpression;
    }();
    exports.SourceExpression = SourceExpression;
    var SourceExpressions = function () {
        function SourceExpressions(declarations, expressions) {
            this.declarations = declarations;
            this.expressions = expressions;
        }
        return SourceExpressions;
    }();
    exports.SourceExpressions = SourceExpressions;
    /**
     * Represents generated source code with imports. Internal to the Angular compiler.
     */
    var SourceWithImports = function () {
        function SourceWithImports(source, imports) {
            this.source = source;
            this.imports = imports;
        }
        return SourceWithImports;
    }();
    exports.SourceWithImports = SourceWithImports;
});
System.registerDynamic("angular2/src/compiler/proto_view_compiler.js", ["angular2/src/facade/lang.js", "angular2/src/facade/collection.js", "angular2/src/compiler/template_ast.js", "angular2/src/compiler/source_module.js", "angular2/src/core/linker/view.js", "angular2/src/core/linker/view_type.js", "angular2/src/core/linker/element.js", "angular2/src/compiler/util.js", "angular2/src/core/di.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var template_ast_1 = $__require("angular2/src/compiler/template_ast.js");
    var source_module_1 = $__require("angular2/src/compiler/source_module.js");
    var view_1 = $__require("angular2/src/core/linker/view.js");
    var view_type_1 = $__require("angular2/src/core/linker/view_type.js");
    var element_1 = $__require("angular2/src/core/linker/element.js");
    var util_1 = $__require("angular2/src/compiler/util.js");
    var di_1 = $__require("angular2/src/core/di.js");
    exports.PROTO_VIEW_JIT_IMPORTS = lang_1.CONST_EXPR({ 'AppProtoView': view_1.AppProtoView, 'AppProtoElement': element_1.AppProtoElement, 'ViewType': view_type_1.ViewType });
    // TODO: have a single file that reexports everything needed for
    // codegen explicitly
    // - helps understanding what codegen works against
    // - less imports in codegen code
    exports.APP_VIEW_MODULE_REF = source_module_1.moduleRef('package:angular2/src/core/linker/view' + util_1.MODULE_SUFFIX);
    exports.VIEW_TYPE_MODULE_REF = source_module_1.moduleRef('package:angular2/src/core/linker/view_type' + util_1.MODULE_SUFFIX);
    exports.APP_EL_MODULE_REF = source_module_1.moduleRef('package:angular2/src/core/linker/element' + util_1.MODULE_SUFFIX);
    exports.METADATA_MODULE_REF = source_module_1.moduleRef('package:angular2/src/core/metadata/view' + util_1.MODULE_SUFFIX);
    var IMPLICIT_TEMPLATE_VAR = '\$implicit';
    var CLASS_ATTR = 'class';
    var STYLE_ATTR = 'style';
    var ProtoViewCompiler = function () {
        function ProtoViewCompiler() {}
        ProtoViewCompiler.prototype.compileProtoViewRuntime = function (metadataCache, component, template, pipes) {
            var protoViewFactory = new RuntimeProtoViewFactory(metadataCache, component, pipes);
            var allProtoViews = [];
            protoViewFactory.createCompileProtoView(template, [], [], allProtoViews);
            return new CompileProtoViews([], allProtoViews);
        };
        ProtoViewCompiler.prototype.compileProtoViewCodeGen = function (resolvedMetadataCacheExpr, component, template, pipes) {
            var protoViewFactory = new CodeGenProtoViewFactory(resolvedMetadataCacheExpr, component, pipes);
            var allProtoViews = [];
            var allStatements = [];
            protoViewFactory.createCompileProtoView(template, [], allStatements, allProtoViews);
            return new CompileProtoViews(allStatements.map(function (stmt) {
                return stmt.statement;
            }), allProtoViews);
        };
        ProtoViewCompiler = __decorate([di_1.Injectable(), __metadata('design:paramtypes', [])], ProtoViewCompiler);
        return ProtoViewCompiler;
    }();
    exports.ProtoViewCompiler = ProtoViewCompiler;
    var CompileProtoViews = function () {
        function CompileProtoViews(declarations, protoViews) {
            this.declarations = declarations;
            this.protoViews = protoViews;
        }
        return CompileProtoViews;
    }();
    exports.CompileProtoViews = CompileProtoViews;
    var CompileProtoView = function () {
        function CompileProtoView(embeddedTemplateIndex, protoElements, protoView) {
            this.embeddedTemplateIndex = embeddedTemplateIndex;
            this.protoElements = protoElements;
            this.protoView = protoView;
        }
        return CompileProtoView;
    }();
    exports.CompileProtoView = CompileProtoView;
    var CompileProtoElement = function () {
        function CompileProtoElement(boundElementIndex, attrNameAndValues, variableNameAndValues, renderEvents, directives, embeddedTemplateIndex, appProtoEl) {
            this.boundElementIndex = boundElementIndex;
            this.attrNameAndValues = attrNameAndValues;
            this.variableNameAndValues = variableNameAndValues;
            this.renderEvents = renderEvents;
            this.directives = directives;
            this.embeddedTemplateIndex = embeddedTemplateIndex;
            this.appProtoEl = appProtoEl;
        }
        return CompileProtoElement;
    }();
    exports.CompileProtoElement = CompileProtoElement;
    function visitAndReturnContext(visitor, asts, context) {
        template_ast_1.templateVisitAll(visitor, asts, context);
        return context;
    }
    var ProtoViewFactory = function () {
        function ProtoViewFactory(component) {
            this.component = component;
        }
        ProtoViewFactory.prototype.createCompileProtoView = function (template, templateVariableBindings, targetStatements, targetProtoViews) {
            var embeddedTemplateIndex = targetProtoViews.length;
            // Note: targetProtoViews needs to be in depth first order.
            // So we "reserve" a space here that we fill after the recursion is done
            targetProtoViews.push(null);
            var builder = new ProtoViewBuilderVisitor(this, targetStatements, targetProtoViews);
            template_ast_1.templateVisitAll(builder, template);
            var viewType = getViewType(this.component, embeddedTemplateIndex);
            var appProtoView = this.createAppProtoView(embeddedTemplateIndex, viewType, templateVariableBindings, targetStatements);
            var cpv = new CompileProtoView(embeddedTemplateIndex, builder.protoElements, appProtoView);
            targetProtoViews[embeddedTemplateIndex] = cpv;
            return cpv;
        };
        return ProtoViewFactory;
    }();
    var CodeGenProtoViewFactory = function (_super) {
        __extends(CodeGenProtoViewFactory, _super);
        function CodeGenProtoViewFactory(resolvedMetadataCacheExpr, component, pipes) {
            _super.call(this, component);
            this.resolvedMetadataCacheExpr = resolvedMetadataCacheExpr;
            this.pipes = pipes;
            this._nextVarId = 0;
        }
        CodeGenProtoViewFactory.prototype._nextProtoViewVar = function (embeddedTemplateIndex) {
            return "appProtoView" + this._nextVarId++ + "_" + this.component.type.name + embeddedTemplateIndex;
        };
        CodeGenProtoViewFactory.prototype.createAppProtoView = function (embeddedTemplateIndex, viewType, templateVariableBindings, targetStatements) {
            var protoViewVarName = this._nextProtoViewVar(embeddedTemplateIndex);
            var viewTypeExpr = codeGenViewType(viewType);
            var pipesExpr = embeddedTemplateIndex === 0 ? codeGenTypesArray(this.pipes.map(function (pipeMeta) {
                return pipeMeta.type;
            })) : null;
            var statement = "var " + protoViewVarName + " = " + exports.APP_VIEW_MODULE_REF + "AppProtoView.create(" + this.resolvedMetadataCacheExpr.expression + ", " + viewTypeExpr + ", " + pipesExpr + ", " + util_1.codeGenStringMap(templateVariableBindings) + ");";
            targetStatements.push(new util_1.Statement(statement));
            return new util_1.Expression(protoViewVarName);
        };
        CodeGenProtoViewFactory.prototype.createAppProtoElement = function (boundElementIndex, attrNameAndValues, variableNameAndValues, directives, targetStatements) {
            var varName = "appProtoEl" + this._nextVarId++ + "_" + this.component.type.name;
            var value = exports.APP_EL_MODULE_REF + "AppProtoElement.create(\n        " + this.resolvedMetadataCacheExpr.expression + ",\n        " + boundElementIndex + ",\n        " + util_1.codeGenStringMap(attrNameAndValues) + ",\n        " + codeGenDirectivesArray(directives) + ",\n        " + util_1.codeGenStringMap(variableNameAndValues) + "\n      )";
            var statement = "var " + varName + " = " + value + ";";
            targetStatements.push(new util_1.Statement(statement));
            return new util_1.Expression(varName);
        };
        return CodeGenProtoViewFactory;
    }(ProtoViewFactory);
    var RuntimeProtoViewFactory = function (_super) {
        __extends(RuntimeProtoViewFactory, _super);
        function RuntimeProtoViewFactory(metadataCache, component, pipes) {
            _super.call(this, component);
            this.metadataCache = metadataCache;
            this.pipes = pipes;
        }
        RuntimeProtoViewFactory.prototype.createAppProtoView = function (embeddedTemplateIndex, viewType, templateVariableBindings, targetStatements) {
            var pipes = embeddedTemplateIndex === 0 ? this.pipes.map(function (pipeMeta) {
                return pipeMeta.type.runtime;
            }) : [];
            var templateVars = keyValueArrayToStringMap(templateVariableBindings);
            return view_1.AppProtoView.create(this.metadataCache, viewType, pipes, templateVars);
        };
        RuntimeProtoViewFactory.prototype.createAppProtoElement = function (boundElementIndex, attrNameAndValues, variableNameAndValues, directives, targetStatements) {
            var attrs = keyValueArrayToStringMap(attrNameAndValues);
            return element_1.AppProtoElement.create(this.metadataCache, boundElementIndex, attrs, directives.map(function (dirMeta) {
                return dirMeta.type.runtime;
            }), keyValueArrayToStringMap(variableNameAndValues));
        };
        return RuntimeProtoViewFactory;
    }(ProtoViewFactory);
    var ProtoViewBuilderVisitor = function () {
        function ProtoViewBuilderVisitor(factory, allStatements, allProtoViews) {
            this.factory = factory;
            this.allStatements = allStatements;
            this.allProtoViews = allProtoViews;
            this.protoElements = [];
            this.boundElementCount = 0;
        }
        ProtoViewBuilderVisitor.prototype._readAttrNameAndValues = function (directives, attrAsts) {
            var attrs = visitAndReturnContext(this, attrAsts, {});
            directives.forEach(function (directiveMeta) {
                collection_1.StringMapWrapper.forEach(directiveMeta.hostAttributes, function (value, name) {
                    var prevValue = attrs[name];
                    attrs[name] = lang_1.isPresent(prevValue) ? mergeAttributeValue(name, prevValue, value) : value;
                });
            });
            return mapToKeyValueArray(attrs);
        };
        ProtoViewBuilderVisitor.prototype.visitBoundText = function (ast, context) {
            return null;
        };
        ProtoViewBuilderVisitor.prototype.visitText = function (ast, context) {
            return null;
        };
        ProtoViewBuilderVisitor.prototype.visitNgContent = function (ast, context) {
            return null;
        };
        ProtoViewBuilderVisitor.prototype.visitElement = function (ast, context) {
            var _this = this;
            var boundElementIndex = null;
            if (ast.isBound()) {
                boundElementIndex = this.boundElementCount++;
            }
            var component = ast.getComponent();
            var variableNameAndValues = [];
            if (lang_1.isBlank(component)) {
                ast.exportAsVars.forEach(function (varAst) {
                    variableNameAndValues.push([varAst.name, null]);
                });
            }
            var directives = [];
            var renderEvents = visitAndReturnContext(this, ast.outputs, new Map());
            collection_1.ListWrapper.forEachWithIndex(ast.directives, function (directiveAst, index) {
                directiveAst.visit(_this, new DirectiveContext(index, boundElementIndex, renderEvents, variableNameAndValues, directives));
            });
            var renderEventArray = [];
            renderEvents.forEach(function (eventAst, _) {
                return renderEventArray.push(eventAst);
            });
            var attrNameAndValues = this._readAttrNameAndValues(directives, ast.attrs);
            this._addProtoElement(ast.isBound(), boundElementIndex, attrNameAndValues, variableNameAndValues, renderEventArray, directives, null);
            template_ast_1.templateVisitAll(this, ast.children);
            return null;
        };
        ProtoViewBuilderVisitor.prototype.visitEmbeddedTemplate = function (ast, context) {
            var _this = this;
            var boundElementIndex = this.boundElementCount++;
            var directives = [];
            collection_1.ListWrapper.forEachWithIndex(ast.directives, function (directiveAst, index) {
                directiveAst.visit(_this, new DirectiveContext(index, boundElementIndex, new Map(), [], directives));
            });
            var attrNameAndValues = this._readAttrNameAndValues(directives, ast.attrs);
            var templateVariableBindings = ast.vars.map(function (varAst) {
                return [varAst.value.length > 0 ? varAst.value : IMPLICIT_TEMPLATE_VAR, varAst.name];
            });
            var nestedProtoView = this.factory.createCompileProtoView(ast.children, templateVariableBindings, this.allStatements, this.allProtoViews);
            this._addProtoElement(true, boundElementIndex, attrNameAndValues, [], [], directives, nestedProtoView.embeddedTemplateIndex);
            return null;
        };
        ProtoViewBuilderVisitor.prototype._addProtoElement = function (isBound, boundElementIndex, attrNameAndValues, variableNameAndValues, renderEvents, directives, embeddedTemplateIndex) {
            var appProtoEl = null;
            if (isBound) {
                appProtoEl = this.factory.createAppProtoElement(boundElementIndex, attrNameAndValues, variableNameAndValues, directives, this.allStatements);
            }
            var compileProtoEl = new CompileProtoElement(boundElementIndex, attrNameAndValues, variableNameAndValues, renderEvents, directives, embeddedTemplateIndex, appProtoEl);
            this.protoElements.push(compileProtoEl);
        };
        ProtoViewBuilderVisitor.prototype.visitVariable = function (ast, ctx) {
            return null;
        };
        ProtoViewBuilderVisitor.prototype.visitAttr = function (ast, attrNameAndValues) {
            attrNameAndValues[ast.name] = ast.value;
            return null;
        };
        ProtoViewBuilderVisitor.prototype.visitDirective = function (ast, ctx) {
            ctx.targetDirectives.push(ast.directive);
            template_ast_1.templateVisitAll(this, ast.hostEvents, ctx.hostEventTargetAndNames);
            ast.exportAsVars.forEach(function (varAst) {
                ctx.targetVariableNameAndValues.push([varAst.name, ctx.index]);
            });
            return null;
        };
        ProtoViewBuilderVisitor.prototype.visitEvent = function (ast, eventTargetAndNames) {
            eventTargetAndNames.set(ast.fullName, ast);
            return null;
        };
        ProtoViewBuilderVisitor.prototype.visitDirectiveProperty = function (ast, context) {
            return null;
        };
        ProtoViewBuilderVisitor.prototype.visitElementProperty = function (ast, context) {
            return null;
        };
        return ProtoViewBuilderVisitor;
    }();
    function mapToKeyValueArray(data) {
        var entryArray = [];
        collection_1.StringMapWrapper.forEach(data, function (value, name) {
            entryArray.push([name, value]);
        });
        // We need to sort to get a defined output order
        // for tests and for caching generated artifacts...
        collection_1.ListWrapper.sort(entryArray, function (entry1, entry2) {
            return lang_1.StringWrapper.compare(entry1[0], entry2[0]);
        });
        var keyValueArray = [];
        entryArray.forEach(function (entry) {
            keyValueArray.push([entry[0], entry[1]]);
        });
        return keyValueArray;
    }
    function mergeAttributeValue(attrName, attrValue1, attrValue2) {
        if (attrName == CLASS_ATTR || attrName == STYLE_ATTR) {
            return attrValue1 + " " + attrValue2;
        } else {
            return attrValue2;
        }
    }
    var DirectiveContext = function () {
        function DirectiveContext(index, boundElementIndex, hostEventTargetAndNames, targetVariableNameAndValues, targetDirectives) {
            this.index = index;
            this.boundElementIndex = boundElementIndex;
            this.hostEventTargetAndNames = hostEventTargetAndNames;
            this.targetVariableNameAndValues = targetVariableNameAndValues;
            this.targetDirectives = targetDirectives;
        }
        return DirectiveContext;
    }();
    function keyValueArrayToStringMap(keyValueArray) {
        var stringMap = {};
        for (var i = 0; i < keyValueArray.length; i++) {
            var entry = keyValueArray[i];
            stringMap[entry[0]] = entry[1];
        }
        return stringMap;
    }
    function codeGenDirectivesArray(directives) {
        var expressions = directives.map(function (directiveType) {
            return typeRef(directiveType.type);
        });
        return "[" + expressions.join(',') + "]";
    }
    function codeGenTypesArray(types) {
        var expressions = types.map(typeRef);
        return "[" + expressions.join(',') + "]";
    }
    function codeGenViewType(value) {
        if (lang_1.IS_DART) {
            return "" + exports.VIEW_TYPE_MODULE_REF + value;
        } else {
            return "" + value;
        }
    }
    function typeRef(type) {
        return "" + source_module_1.moduleRef(type.moduleUrl) + type.name;
    }
    function getViewType(component, embeddedTemplateIndex) {
        if (embeddedTemplateIndex > 0) {
            return view_type_1.ViewType.EMBEDDED;
        } else if (component.type.isHost) {
            return view_type_1.ViewType.HOST;
        } else {
            return view_type_1.ViewType.COMPONENT;
        }
    }
});
System.registerDynamic('angular2/src/compiler/template_ast.js', ['angular2/src/facade/lang.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    /**
     * A segment of text within the template.
     */
    var TextAst = function () {
        function TextAst(value, ngContentIndex, sourceSpan) {
            this.value = value;
            this.ngContentIndex = ngContentIndex;
            this.sourceSpan = sourceSpan;
        }
        TextAst.prototype.visit = function (visitor, context) {
            return visitor.visitText(this, context);
        };
        return TextAst;
    }();
    exports.TextAst = TextAst;
    /**
     * A bound expression within the text of a template.
     */
    var BoundTextAst = function () {
        function BoundTextAst(value, ngContentIndex, sourceSpan) {
            this.value = value;
            this.ngContentIndex = ngContentIndex;
            this.sourceSpan = sourceSpan;
        }
        BoundTextAst.prototype.visit = function (visitor, context) {
            return visitor.visitBoundText(this, context);
        };
        return BoundTextAst;
    }();
    exports.BoundTextAst = BoundTextAst;
    /**
     * A plain attribute on an element.
     */
    var AttrAst = function () {
        function AttrAst(name, value, sourceSpan) {
            this.name = name;
            this.value = value;
            this.sourceSpan = sourceSpan;
        }
        AttrAst.prototype.visit = function (visitor, context) {
            return visitor.visitAttr(this, context);
        };
        return AttrAst;
    }();
    exports.AttrAst = AttrAst;
    /**
     * A binding for an element property (e.g. `[property]="expression"`).
     */
    var BoundElementPropertyAst = function () {
        function BoundElementPropertyAst(name, type, value, unit, sourceSpan) {
            this.name = name;
            this.type = type;
            this.value = value;
            this.unit = unit;
            this.sourceSpan = sourceSpan;
        }
        BoundElementPropertyAst.prototype.visit = function (visitor, context) {
            return visitor.visitElementProperty(this, context);
        };
        return BoundElementPropertyAst;
    }();
    exports.BoundElementPropertyAst = BoundElementPropertyAst;
    /**
     * A binding for an element event (e.g. `(event)="handler()"`).
     */
    var BoundEventAst = function () {
        function BoundEventAst(name, target, handler, sourceSpan) {
            this.name = name;
            this.target = target;
            this.handler = handler;
            this.sourceSpan = sourceSpan;
        }
        BoundEventAst.prototype.visit = function (visitor, context) {
            return visitor.visitEvent(this, context);
        };
        Object.defineProperty(BoundEventAst.prototype, "fullName", {
            get: function () {
                if (lang_1.isPresent(this.target)) {
                    return this.target + ":" + this.name;
                } else {
                    return this.name;
                }
            },
            enumerable: true,
            configurable: true
        });
        return BoundEventAst;
    }();
    exports.BoundEventAst = BoundEventAst;
    /**
     * A variable declaration on an element (e.g. `#var="expression"`).
     */
    var VariableAst = function () {
        function VariableAst(name, value, sourceSpan) {
            this.name = name;
            this.value = value;
            this.sourceSpan = sourceSpan;
        }
        VariableAst.prototype.visit = function (visitor, context) {
            return visitor.visitVariable(this, context);
        };
        return VariableAst;
    }();
    exports.VariableAst = VariableAst;
    /**
     * An element declaration in a template.
     */
    var ElementAst = function () {
        function ElementAst(name, attrs, inputs, outputs, exportAsVars, directives, children, ngContentIndex, sourceSpan) {
            this.name = name;
            this.attrs = attrs;
            this.inputs = inputs;
            this.outputs = outputs;
            this.exportAsVars = exportAsVars;
            this.directives = directives;
            this.children = children;
            this.ngContentIndex = ngContentIndex;
            this.sourceSpan = sourceSpan;
        }
        ElementAst.prototype.visit = function (visitor, context) {
            return visitor.visitElement(this, context);
        };
        /**
         * Whether the element has any active bindings (inputs, outputs, vars, or directives).
         */
        ElementAst.prototype.isBound = function () {
            return this.inputs.length > 0 || this.outputs.length > 0 || this.exportAsVars.length > 0 || this.directives.length > 0;
        };
        /**
         * Get the component associated with this element, if any.
         */
        ElementAst.prototype.getComponent = function () {
            return this.directives.length > 0 && this.directives[0].directive.isComponent ? this.directives[0].directive : null;
        };
        return ElementAst;
    }();
    exports.ElementAst = ElementAst;
    /**
     * A `<template>` element included in an Angular template.
     */
    var EmbeddedTemplateAst = function () {
        function EmbeddedTemplateAst(attrs, outputs, vars, directives, children, ngContentIndex, sourceSpan) {
            this.attrs = attrs;
            this.outputs = outputs;
            this.vars = vars;
            this.directives = directives;
            this.children = children;
            this.ngContentIndex = ngContentIndex;
            this.sourceSpan = sourceSpan;
        }
        EmbeddedTemplateAst.prototype.visit = function (visitor, context) {
            return visitor.visitEmbeddedTemplate(this, context);
        };
        return EmbeddedTemplateAst;
    }();
    exports.EmbeddedTemplateAst = EmbeddedTemplateAst;
    /**
     * A directive property with a bound value (e.g. `*ngIf="condition").
     */
    var BoundDirectivePropertyAst = function () {
        function BoundDirectivePropertyAst(directiveName, templateName, value, sourceSpan) {
            this.directiveName = directiveName;
            this.templateName = templateName;
            this.value = value;
            this.sourceSpan = sourceSpan;
        }
        BoundDirectivePropertyAst.prototype.visit = function (visitor, context) {
            return visitor.visitDirectiveProperty(this, context);
        };
        return BoundDirectivePropertyAst;
    }();
    exports.BoundDirectivePropertyAst = BoundDirectivePropertyAst;
    /**
     * A directive declared on an element.
     */
    var DirectiveAst = function () {
        function DirectiveAst(directive, inputs, hostProperties, hostEvents, exportAsVars, sourceSpan) {
            this.directive = directive;
            this.inputs = inputs;
            this.hostProperties = hostProperties;
            this.hostEvents = hostEvents;
            this.exportAsVars = exportAsVars;
            this.sourceSpan = sourceSpan;
        }
        DirectiveAst.prototype.visit = function (visitor, context) {
            return visitor.visitDirective(this, context);
        };
        return DirectiveAst;
    }();
    exports.DirectiveAst = DirectiveAst;
    /**
     * Position where content is to be projected (instance of `<ng-content>` in a template).
     */
    var NgContentAst = function () {
        function NgContentAst(index, ngContentIndex, sourceSpan) {
            this.index = index;
            this.ngContentIndex = ngContentIndex;
            this.sourceSpan = sourceSpan;
        }
        NgContentAst.prototype.visit = function (visitor, context) {
            return visitor.visitNgContent(this, context);
        };
        return NgContentAst;
    }();
    exports.NgContentAst = NgContentAst;
    /**
     * Enumeration of types of property bindings.
     */
    (function (PropertyBindingType) {
        /**
         * A normal binding to a property (e.g. `[property]="expression"`).
         */
        PropertyBindingType[PropertyBindingType["Property"] = 0] = "Property";
        /**
         * A binding to an element attribute (e.g. `[attr.name]="expression"`).
         */
        PropertyBindingType[PropertyBindingType["Attribute"] = 1] = "Attribute";
        /**
         * A binding to a CSS class (e.g. `[class.name]="condition"`).
         */
        PropertyBindingType[PropertyBindingType["Class"] = 2] = "Class";
        /**
         * A binding to a style rule (e.g. `[style.rule]="expression"`).
         */
        PropertyBindingType[PropertyBindingType["Style"] = 3] = "Style";
    })(exports.PropertyBindingType || (exports.PropertyBindingType = {}));
    var PropertyBindingType = exports.PropertyBindingType;
    /**
     * Visit every node in a list of {@link TemplateAst}s with the given {@link TemplateAstVisitor}.
     */
    function templateVisitAll(visitor, asts, context) {
        if (context === void 0) {
            context = null;
        }
        var result = [];
        asts.forEach(function (ast) {
            var astResult = ast.visit(visitor, context);
            if (lang_1.isPresent(astResult)) {
                result.push(astResult);
            }
        });
        return result;
    }
    exports.templateVisitAll = templateVisitAll;
});
System.registerDynamic("angular2/src/compiler/template_parser.js", ["angular2/src/facade/collection.js", "angular2/src/facade/lang.js", "angular2/core.js", "angular2/src/facade/exceptions.js", "angular2/src/core/change_detection/change_detection.js", "angular2/src/compiler/html_parser.js", "angular2/src/compiler/html_tags.js", "angular2/src/compiler/parse_util.js", "angular2/src/core/change_detection/parser/ast.js", "angular2/src/compiler/template_ast.js", "angular2/src/compiler/selector.js", "angular2/src/compiler/schema/element_schema_registry.js", "angular2/src/compiler/template_preparser.js", "angular2/src/compiler/style_url_resolver.js", "angular2/src/compiler/html_ast.js", "angular2/src/compiler/util.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var __param = this && this.__param || function (paramIndex, decorator) {
        return function (target, key) {
            decorator(target, key, paramIndex);
        };
    };
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var core_1 = $__require("angular2/core.js");
    var lang_2 = $__require("angular2/src/facade/lang.js");
    var exceptions_1 = $__require("angular2/src/facade/exceptions.js");
    var change_detection_1 = $__require("angular2/src/core/change_detection/change_detection.js");
    var html_parser_1 = $__require("angular2/src/compiler/html_parser.js");
    var html_tags_1 = $__require("angular2/src/compiler/html_tags.js");
    var parse_util_1 = $__require("angular2/src/compiler/parse_util.js");
    var ast_1 = $__require("angular2/src/core/change_detection/parser/ast.js");
    var template_ast_1 = $__require("angular2/src/compiler/template_ast.js");
    var selector_1 = $__require("angular2/src/compiler/selector.js");
    var element_schema_registry_1 = $__require("angular2/src/compiler/schema/element_schema_registry.js");
    var template_preparser_1 = $__require("angular2/src/compiler/template_preparser.js");
    var style_url_resolver_1 = $__require("angular2/src/compiler/style_url_resolver.js");
    var html_ast_1 = $__require("angular2/src/compiler/html_ast.js");
    var util_1 = $__require("angular2/src/compiler/util.js");
    // Group 1 = "bind-"
    // Group 2 = "var-" or "#"
    // Group 3 = "on-"
    // Group 4 = "bindon-"
    // Group 5 = the identifier after "bind-", "var-/#", or "on-"
    // Group 6 = identifier inside [()]
    // Group 7 = identifier inside []
    // Group 8 = identifier inside ()
    var BIND_NAME_REGEXP = /^(?:(?:(?:(bind-)|(var-|#)|(on-)|(bindon-))(.+))|\[\(([^\)]+)\)\]|\[([^\]]+)\]|\(([^\)]+)\))$/g;
    var TEMPLATE_ELEMENT = 'template';
    var TEMPLATE_ATTR = 'template';
    var TEMPLATE_ATTR_PREFIX = '*';
    var CLASS_ATTR = 'class';
    var PROPERTY_PARTS_SEPARATOR = '.';
    var ATTRIBUTE_PREFIX = 'attr';
    var CLASS_PREFIX = 'class';
    var STYLE_PREFIX = 'style';
    var TEXT_CSS_SELECTOR = selector_1.CssSelector.parse('*')[0];
    /**
     * Provides an array of {@link TemplateAstVisitor}s which will be used to transform
     * parsed templates before compilation is invoked, allowing custom expression syntax
     * and other advanced transformations.
     *
     * This is currently an internal-only feature and not meant for general use.
     */
    exports.TEMPLATE_TRANSFORMS = lang_2.CONST_EXPR(new core_1.OpaqueToken('TemplateTransforms'));
    var TemplateParseError = function (_super) {
        __extends(TemplateParseError, _super);
        function TemplateParseError(message, span) {
            _super.call(this, span, message);
        }
        return TemplateParseError;
    }(parse_util_1.ParseError);
    exports.TemplateParseError = TemplateParseError;
    var TemplateParseResult = function () {
        function TemplateParseResult(templateAst, errors) {
            this.templateAst = templateAst;
            this.errors = errors;
        }
        return TemplateParseResult;
    }();
    exports.TemplateParseResult = TemplateParseResult;
    var TemplateParser = function () {
        function TemplateParser(_exprParser, _schemaRegistry, _htmlParser, transforms) {
            this._exprParser = _exprParser;
            this._schemaRegistry = _schemaRegistry;
            this._htmlParser = _htmlParser;
            this.transforms = transforms;
        }
        TemplateParser.prototype.parse = function (template, directives, pipes, templateUrl) {
            var result = this.tryParse(template, directives, pipes, templateUrl);
            if (lang_1.isPresent(result.errors)) {
                var errorString = result.errors.join('\n');
                throw new exceptions_1.BaseException("Template parse errors:\n" + errorString);
            }
            return result.templateAst;
        };
        TemplateParser.prototype.tryParse = function (template, directives, pipes, templateUrl) {
            var parseVisitor = new TemplateParseVisitor(directives, pipes, this._exprParser, this._schemaRegistry);
            var htmlAstWithErrors = this._htmlParser.parse(template, templateUrl);
            var result = html_ast_1.htmlVisitAll(parseVisitor, htmlAstWithErrors.rootNodes, EMPTY_COMPONENT);
            var errors = htmlAstWithErrors.errors.concat(parseVisitor.errors);
            if (errors.length > 0) {
                return new TemplateParseResult(result, errors);
            }
            if (lang_1.isPresent(this.transforms)) {
                this.transforms.forEach(function (transform) {
                    result = template_ast_1.templateVisitAll(transform, result);
                });
            }
            return new TemplateParseResult(result);
        };
        TemplateParser = __decorate([core_1.Injectable(), __param(3, core_1.Optional()), __param(3, core_1.Inject(exports.TEMPLATE_TRANSFORMS)), __metadata('design:paramtypes', [change_detection_1.Parser, element_schema_registry_1.ElementSchemaRegistry, html_parser_1.HtmlParser, Array])], TemplateParser);
        return TemplateParser;
    }();
    exports.TemplateParser = TemplateParser;
    var TemplateParseVisitor = function () {
        function TemplateParseVisitor(directives, pipes, _exprParser, _schemaRegistry) {
            var _this = this;
            this._exprParser = _exprParser;
            this._schemaRegistry = _schemaRegistry;
            this.errors = [];
            this.directivesIndex = new Map();
            this.ngContentCount = 0;
            this.selectorMatcher = new selector_1.SelectorMatcher();
            collection_1.ListWrapper.forEachWithIndex(directives, function (directive, index) {
                var selector = selector_1.CssSelector.parse(directive.selector);
                _this.selectorMatcher.addSelectables(selector, directive);
                _this.directivesIndex.set(directive, index);
            });
            this.pipesByName = new Map();
            pipes.forEach(function (pipe) {
                return _this.pipesByName.set(pipe.name, pipe);
            });
        }
        TemplateParseVisitor.prototype._reportError = function (message, sourceSpan) {
            this.errors.push(new TemplateParseError(message, sourceSpan));
        };
        TemplateParseVisitor.prototype._parseInterpolation = function (value, sourceSpan) {
            var sourceInfo = sourceSpan.start.toString();
            try {
                var ast = this._exprParser.parseInterpolation(value, sourceInfo);
                this._checkPipes(ast, sourceSpan);
                return ast;
            } catch (e) {
                this._reportError("" + e, sourceSpan);
                return this._exprParser.wrapLiteralPrimitive('ERROR', sourceInfo);
            }
        };
        TemplateParseVisitor.prototype._parseAction = function (value, sourceSpan) {
            var sourceInfo = sourceSpan.start.toString();
            try {
                var ast = this._exprParser.parseAction(value, sourceInfo);
                this._checkPipes(ast, sourceSpan);
                return ast;
            } catch (e) {
                this._reportError("" + e, sourceSpan);
                return this._exprParser.wrapLiteralPrimitive('ERROR', sourceInfo);
            }
        };
        TemplateParseVisitor.prototype._parseBinding = function (value, sourceSpan) {
            var sourceInfo = sourceSpan.start.toString();
            try {
                var ast = this._exprParser.parseBinding(value, sourceInfo);
                this._checkPipes(ast, sourceSpan);
                return ast;
            } catch (e) {
                this._reportError("" + e, sourceSpan);
                return this._exprParser.wrapLiteralPrimitive('ERROR', sourceInfo);
            }
        };
        TemplateParseVisitor.prototype._parseTemplateBindings = function (value, sourceSpan) {
            var _this = this;
            var sourceInfo = sourceSpan.start.toString();
            try {
                var bindings = this._exprParser.parseTemplateBindings(value, sourceInfo);
                bindings.forEach(function (binding) {
                    if (lang_1.isPresent(binding.expression)) {
                        _this._checkPipes(binding.expression, sourceSpan);
                    }
                });
                return bindings;
            } catch (e) {
                this._reportError("" + e, sourceSpan);
                return [];
            }
        };
        TemplateParseVisitor.prototype._checkPipes = function (ast, sourceSpan) {
            var _this = this;
            if (lang_1.isPresent(ast)) {
                var collector = new PipeCollector();
                ast.visit(collector);
                collector.pipes.forEach(function (pipeName) {
                    if (!_this.pipesByName.has(pipeName)) {
                        _this._reportError("The pipe '" + pipeName + "' could not be found", sourceSpan);
                    }
                });
            }
        };
        TemplateParseVisitor.prototype.visitText = function (ast, component) {
            var ngContentIndex = component.findNgContentIndex(TEXT_CSS_SELECTOR);
            var expr = this._parseInterpolation(ast.value, ast.sourceSpan);
            if (lang_1.isPresent(expr)) {
                return new template_ast_1.BoundTextAst(expr, ngContentIndex, ast.sourceSpan);
            } else {
                return new template_ast_1.TextAst(ast.value, ngContentIndex, ast.sourceSpan);
            }
        };
        TemplateParseVisitor.prototype.visitAttr = function (ast, contex) {
            return new template_ast_1.AttrAst(ast.name, ast.value, ast.sourceSpan);
        };
        TemplateParseVisitor.prototype.visitComment = function (ast, context) {
            return null;
        };
        TemplateParseVisitor.prototype.visitElement = function (element, component) {
            var _this = this;
            var nodeName = element.name;
            var preparsedElement = template_preparser_1.preparseElement(element);
            if (preparsedElement.type === template_preparser_1.PreparsedElementType.SCRIPT || preparsedElement.type === template_preparser_1.PreparsedElementType.STYLE) {
                // Skipping <script> for security reasons
                // Skipping <style> as we already processed them
                // in the StyleCompiler
                return null;
            }
            if (preparsedElement.type === template_preparser_1.PreparsedElementType.STYLESHEET && style_url_resolver_1.isStyleUrlResolvable(preparsedElement.hrefAttr)) {
                // Skipping stylesheets with either relative urls or package scheme as we already processed
                // them in the StyleCompiler
                return null;
            }
            var matchableAttrs = [];
            var elementOrDirectiveProps = [];
            var vars = [];
            var events = [];
            var templateElementOrDirectiveProps = [];
            var templateVars = [];
            var templateMatchableAttrs = [];
            var hasInlineTemplates = false;
            var attrs = [];
            element.attrs.forEach(function (attr) {
                var hasBinding = _this._parseAttr(attr, matchableAttrs, elementOrDirectiveProps, events, vars);
                var hasTemplateBinding = _this._parseInlineTemplateBinding(attr, templateMatchableAttrs, templateElementOrDirectiveProps, templateVars);
                if (!hasBinding && !hasTemplateBinding) {
                    // don't include the bindings as attributes as well in the AST
                    attrs.push(_this.visitAttr(attr, null));
                    matchableAttrs.push([attr.name, attr.value]);
                }
                if (hasTemplateBinding) {
                    hasInlineTemplates = true;
                }
            });
            var lcElName = html_tags_1.splitNsName(nodeName.toLowerCase())[1];
            var isTemplateElement = lcElName == TEMPLATE_ELEMENT;
            var elementCssSelector = createElementCssSelector(nodeName, matchableAttrs);
            var directives = this._createDirectiveAsts(element.name, this._parseDirectives(this.selectorMatcher, elementCssSelector), elementOrDirectiveProps, isTemplateElement ? [] : vars, element.sourceSpan);
            var elementProps = this._createElementPropertyAsts(element.name, elementOrDirectiveProps, directives);
            var children = html_ast_1.htmlVisitAll(preparsedElement.nonBindable ? NON_BINDABLE_VISITOR : this, element.children, Component.create(directives));
            // Override the actual selector when the `ngProjectAs` attribute is provided
            var projectionSelector = lang_1.isPresent(preparsedElement.projectAs) ? selector_1.CssSelector.parse(preparsedElement.projectAs)[0] : elementCssSelector;
            var ngContentIndex = component.findNgContentIndex(projectionSelector);
            var parsedElement;
            if (preparsedElement.type === template_preparser_1.PreparsedElementType.NG_CONTENT) {
                if (lang_1.isPresent(element.children) && element.children.length > 0) {
                    this._reportError("<ng-content> element cannot have content. <ng-content> must be immediately followed by </ng-content>", element.sourceSpan);
                }
                parsedElement = new template_ast_1.NgContentAst(this.ngContentCount++, hasInlineTemplates ? null : ngContentIndex, element.sourceSpan);
            } else if (isTemplateElement) {
                this._assertAllEventsPublishedByDirectives(directives, events);
                this._assertNoComponentsNorElementBindingsOnTemplate(directives, elementProps, element.sourceSpan);
                parsedElement = new template_ast_1.EmbeddedTemplateAst(attrs, events, vars, directives, children, hasInlineTemplates ? null : ngContentIndex, element.sourceSpan);
            } else {
                this._assertOnlyOneComponent(directives, element.sourceSpan);
                var elementExportAsVars = vars.filter(function (varAst) {
                    return varAst.value.length === 0;
                });
                var ngContentIndex_1 = hasInlineTemplates ? null : component.findNgContentIndex(projectionSelector);
                parsedElement = new template_ast_1.ElementAst(nodeName, attrs, elementProps, events, elementExportAsVars, directives, children, hasInlineTemplates ? null : ngContentIndex_1, element.sourceSpan);
            }
            if (hasInlineTemplates) {
                var templateCssSelector = createElementCssSelector(TEMPLATE_ELEMENT, templateMatchableAttrs);
                var templateDirectives = this._createDirectiveAsts(element.name, this._parseDirectives(this.selectorMatcher, templateCssSelector), templateElementOrDirectiveProps, [], element.sourceSpan);
                var templateElementProps = this._createElementPropertyAsts(element.name, templateElementOrDirectiveProps, templateDirectives);
                this._assertNoComponentsNorElementBindingsOnTemplate(templateDirectives, templateElementProps, element.sourceSpan);
                parsedElement = new template_ast_1.EmbeddedTemplateAst([], [], templateVars, templateDirectives, [parsedElement], ngContentIndex, element.sourceSpan);
            }
            return parsedElement;
        };
        TemplateParseVisitor.prototype._parseInlineTemplateBinding = function (attr, targetMatchableAttrs, targetProps, targetVars) {
            var templateBindingsSource = null;
            if (attr.name == TEMPLATE_ATTR) {
                templateBindingsSource = attr.value;
            } else if (attr.name.startsWith(TEMPLATE_ATTR_PREFIX)) {
                var key = attr.name.substring(TEMPLATE_ATTR_PREFIX.length); // remove the star
                templateBindingsSource = attr.value.length == 0 ? key : key + ' ' + attr.value;
            }
            if (lang_1.isPresent(templateBindingsSource)) {
                var bindings = this._parseTemplateBindings(templateBindingsSource, attr.sourceSpan);
                for (var i = 0; i < bindings.length; i++) {
                    var binding = bindings[i];
                    if (binding.keyIsVar) {
                        targetVars.push(new template_ast_1.VariableAst(binding.key, binding.name, attr.sourceSpan));
                        targetMatchableAttrs.push([binding.key, binding.name]);
                    } else if (lang_1.isPresent(binding.expression)) {
                        this._parsePropertyAst(binding.key, binding.expression, attr.sourceSpan, targetMatchableAttrs, targetProps);
                    } else {
                        targetMatchableAttrs.push([binding.key, '']);
                        this._parseLiteralAttr(binding.key, null, attr.sourceSpan, targetProps);
                    }
                }
                return true;
            }
            return false;
        };
        TemplateParseVisitor.prototype._parseAttr = function (attr, targetMatchableAttrs, targetProps, targetEvents, targetVars) {
            var attrName = this._normalizeAttributeName(attr.name);
            var attrValue = attr.value;
            var bindParts = lang_1.RegExpWrapper.firstMatch(BIND_NAME_REGEXP, attrName);
            var hasBinding = false;
            if (lang_1.isPresent(bindParts)) {
                hasBinding = true;
                if (lang_1.isPresent(bindParts[1])) {
                    this._parseProperty(bindParts[5], attrValue, attr.sourceSpan, targetMatchableAttrs, targetProps);
                } else if (lang_1.isPresent(bindParts[2])) {
                    var identifier = bindParts[5];
                    this._parseVariable(identifier, attrValue, attr.sourceSpan, targetVars);
                } else if (lang_1.isPresent(bindParts[3])) {
                    this._parseEvent(bindParts[5], attrValue, attr.sourceSpan, targetMatchableAttrs, targetEvents);
                } else if (lang_1.isPresent(bindParts[4])) {
                    this._parseProperty(bindParts[5], attrValue, attr.sourceSpan, targetMatchableAttrs, targetProps);
                    this._parseAssignmentEvent(bindParts[5], attrValue, attr.sourceSpan, targetMatchableAttrs, targetEvents);
                } else if (lang_1.isPresent(bindParts[6])) {
                    this._parseProperty(bindParts[6], attrValue, attr.sourceSpan, targetMatchableAttrs, targetProps);
                    this._parseAssignmentEvent(bindParts[6], attrValue, attr.sourceSpan, targetMatchableAttrs, targetEvents);
                } else if (lang_1.isPresent(bindParts[7])) {
                    this._parseProperty(bindParts[7], attrValue, attr.sourceSpan, targetMatchableAttrs, targetProps);
                } else if (lang_1.isPresent(bindParts[8])) {
                    this._parseEvent(bindParts[8], attrValue, attr.sourceSpan, targetMatchableAttrs, targetEvents);
                }
            } else {
                hasBinding = this._parsePropertyInterpolation(attrName, attrValue, attr.sourceSpan, targetMatchableAttrs, targetProps);
            }
            if (!hasBinding) {
                this._parseLiteralAttr(attrName, attrValue, attr.sourceSpan, targetProps);
            }
            return hasBinding;
        };
        TemplateParseVisitor.prototype._normalizeAttributeName = function (attrName) {
            return attrName.toLowerCase().startsWith('data-') ? attrName.substring(5) : attrName;
        };
        TemplateParseVisitor.prototype._parseVariable = function (identifier, value, sourceSpan, targetVars) {
            if (identifier.indexOf('-') > -1) {
                this._reportError("\"-\" is not allowed in variable names", sourceSpan);
            }
            targetVars.push(new template_ast_1.VariableAst(identifier, value, sourceSpan));
        };
        TemplateParseVisitor.prototype._parseProperty = function (name, expression, sourceSpan, targetMatchableAttrs, targetProps) {
            this._parsePropertyAst(name, this._parseBinding(expression, sourceSpan), sourceSpan, targetMatchableAttrs, targetProps);
        };
        TemplateParseVisitor.prototype._parsePropertyInterpolation = function (name, value, sourceSpan, targetMatchableAttrs, targetProps) {
            var expr = this._parseInterpolation(value, sourceSpan);
            if (lang_1.isPresent(expr)) {
                this._parsePropertyAst(name, expr, sourceSpan, targetMatchableAttrs, targetProps);
                return true;
            }
            return false;
        };
        TemplateParseVisitor.prototype._parsePropertyAst = function (name, ast, sourceSpan, targetMatchableAttrs, targetProps) {
            targetMatchableAttrs.push([name, ast.source]);
            targetProps.push(new BoundElementOrDirectiveProperty(name, ast, false, sourceSpan));
        };
        TemplateParseVisitor.prototype._parseAssignmentEvent = function (name, expression, sourceSpan, targetMatchableAttrs, targetEvents) {
            this._parseEvent(name + "Change", expression + "=$event", sourceSpan, targetMatchableAttrs, targetEvents);
        };
        TemplateParseVisitor.prototype._parseEvent = function (name, expression, sourceSpan, targetMatchableAttrs, targetEvents) {
            // long format: 'target: eventName'
            var parts = util_1.splitAtColon(name, [null, name]);
            var target = parts[0];
            var eventName = parts[1];
            var ast = this._parseAction(expression, sourceSpan);
            targetMatchableAttrs.push([name, ast.source]);
            targetEvents.push(new template_ast_1.BoundEventAst(eventName, target, ast, sourceSpan));
            // Don't detect directives for event names for now,
            // so don't add the event name to the matchableAttrs
        };
        TemplateParseVisitor.prototype._parseLiteralAttr = function (name, value, sourceSpan, targetProps) {
            targetProps.push(new BoundElementOrDirectiveProperty(name, this._exprParser.wrapLiteralPrimitive(value, ''), true, sourceSpan));
        };
        TemplateParseVisitor.prototype._parseDirectives = function (selectorMatcher, elementCssSelector) {
            var _this = this;
            var directives = [];
            selectorMatcher.match(elementCssSelector, function (selector, directive) {
                directives.push(directive);
            });
            // Need to sort the directives so that we get consistent results throughout,
            // as selectorMatcher uses Maps inside.
            // Also need to make components the first directive in the array
            collection_1.ListWrapper.sort(directives, function (dir1, dir2) {
                var dir1Comp = dir1.isComponent;
                var dir2Comp = dir2.isComponent;
                if (dir1Comp && !dir2Comp) {
                    return -1;
                } else if (!dir1Comp && dir2Comp) {
                    return 1;
                } else {
                    return _this.directivesIndex.get(dir1) - _this.directivesIndex.get(dir2);
                }
            });
            return directives;
        };
        TemplateParseVisitor.prototype._createDirectiveAsts = function (elementName, directives, props, possibleExportAsVars, sourceSpan) {
            var _this = this;
            var matchedVariables = new Set();
            var directiveAsts = directives.map(function (directive) {
                var hostProperties = [];
                var hostEvents = [];
                var directiveProperties = [];
                _this._createDirectiveHostPropertyAsts(elementName, directive.hostProperties, sourceSpan, hostProperties);
                _this._createDirectiveHostEventAsts(directive.hostListeners, sourceSpan, hostEvents);
                _this._createDirectivePropertyAsts(directive.inputs, props, directiveProperties);
                var exportAsVars = [];
                possibleExportAsVars.forEach(function (varAst) {
                    if (varAst.value.length === 0 && directive.isComponent || directive.exportAs == varAst.value) {
                        exportAsVars.push(varAst);
                        matchedVariables.add(varAst.name);
                    }
                });
                return new template_ast_1.DirectiveAst(directive, directiveProperties, hostProperties, hostEvents, exportAsVars, sourceSpan);
            });
            possibleExportAsVars.forEach(function (varAst) {
                if (varAst.value.length > 0 && !collection_1.SetWrapper.has(matchedVariables, varAst.name)) {
                    _this._reportError("There is no directive with \"exportAs\" set to \"" + varAst.value + "\"", varAst.sourceSpan);
                }
            });
            return directiveAsts;
        };
        TemplateParseVisitor.prototype._createDirectiveHostPropertyAsts = function (elementName, hostProps, sourceSpan, targetPropertyAsts) {
            var _this = this;
            if (lang_1.isPresent(hostProps)) {
                collection_1.StringMapWrapper.forEach(hostProps, function (expression, propName) {
                    var exprAst = _this._parseBinding(expression, sourceSpan);
                    targetPropertyAsts.push(_this._createElementPropertyAst(elementName, propName, exprAst, sourceSpan));
                });
            }
        };
        TemplateParseVisitor.prototype._createDirectiveHostEventAsts = function (hostListeners, sourceSpan, targetEventAsts) {
            var _this = this;
            if (lang_1.isPresent(hostListeners)) {
                collection_1.StringMapWrapper.forEach(hostListeners, function (expression, propName) {
                    _this._parseEvent(propName, expression, sourceSpan, [], targetEventAsts);
                });
            }
        };
        TemplateParseVisitor.prototype._createDirectivePropertyAsts = function (directiveProperties, boundProps, targetBoundDirectiveProps) {
            if (lang_1.isPresent(directiveProperties)) {
                var boundPropsByName = new Map();
                boundProps.forEach(function (boundProp) {
                    var prevValue = boundPropsByName.get(boundProp.name);
                    if (lang_1.isBlank(prevValue) || prevValue.isLiteral) {
                        // give [a]="b" a higher precedence than a="b" on the same element
                        boundPropsByName.set(boundProp.name, boundProp);
                    }
                });
                collection_1.StringMapWrapper.forEach(directiveProperties, function (elProp, dirProp) {
                    var boundProp = boundPropsByName.get(elProp);
                    // Bindings are optional, so this binding only needs to be set up if an expression is given.
                    if (lang_1.isPresent(boundProp)) {
                        targetBoundDirectiveProps.push(new template_ast_1.BoundDirectivePropertyAst(dirProp, boundProp.name, boundProp.expression, boundProp.sourceSpan));
                    }
                });
            }
        };
        TemplateParseVisitor.prototype._createElementPropertyAsts = function (elementName, props, directives) {
            var _this = this;
            var boundElementProps = [];
            var boundDirectivePropsIndex = new Map();
            directives.forEach(function (directive) {
                directive.inputs.forEach(function (prop) {
                    boundDirectivePropsIndex.set(prop.templateName, prop);
                });
            });
            props.forEach(function (prop) {
                if (!prop.isLiteral && lang_1.isBlank(boundDirectivePropsIndex.get(prop.name))) {
                    boundElementProps.push(_this._createElementPropertyAst(elementName, prop.name, prop.expression, prop.sourceSpan));
                }
            });
            return boundElementProps;
        };
        TemplateParseVisitor.prototype._createElementPropertyAst = function (elementName, name, ast, sourceSpan) {
            var unit = null;
            var bindingType;
            var boundPropertyName;
            var parts = name.split(PROPERTY_PARTS_SEPARATOR);
            if (parts.length === 1) {
                boundPropertyName = this._schemaRegistry.getMappedPropName(parts[0]);
                bindingType = template_ast_1.PropertyBindingType.Property;
                if (!this._schemaRegistry.hasProperty(elementName, boundPropertyName)) {
                    this._reportError("Can't bind to '" + boundPropertyName + "' since it isn't a known native property", sourceSpan);
                }
            } else {
                if (parts[0] == ATTRIBUTE_PREFIX) {
                    boundPropertyName = parts[1];
                    var nsSeparatorIdx = boundPropertyName.indexOf(':');
                    if (nsSeparatorIdx > -1) {
                        var ns = boundPropertyName.substring(0, nsSeparatorIdx);
                        var name_1 = boundPropertyName.substring(nsSeparatorIdx + 1);
                        boundPropertyName = html_tags_1.mergeNsAndName(ns, name_1);
                    }
                    bindingType = template_ast_1.PropertyBindingType.Attribute;
                } else if (parts[0] == CLASS_PREFIX) {
                    boundPropertyName = parts[1];
                    bindingType = template_ast_1.PropertyBindingType.Class;
                } else if (parts[0] == STYLE_PREFIX) {
                    unit = parts.length > 2 ? parts[2] : null;
                    boundPropertyName = parts[1];
                    bindingType = template_ast_1.PropertyBindingType.Style;
                } else {
                    this._reportError("Invalid property name '" + name + "'", sourceSpan);
                    bindingType = null;
                }
            }
            return new template_ast_1.BoundElementPropertyAst(boundPropertyName, bindingType, ast, unit, sourceSpan);
        };
        TemplateParseVisitor.prototype._findComponentDirectiveNames = function (directives) {
            var componentTypeNames = [];
            directives.forEach(function (directive) {
                var typeName = directive.directive.type.name;
                if (directive.directive.isComponent) {
                    componentTypeNames.push(typeName);
                }
            });
            return componentTypeNames;
        };
        TemplateParseVisitor.prototype._assertOnlyOneComponent = function (directives, sourceSpan) {
            var componentTypeNames = this._findComponentDirectiveNames(directives);
            if (componentTypeNames.length > 1) {
                this._reportError("More than one component: " + componentTypeNames.join(','), sourceSpan);
            }
        };
        TemplateParseVisitor.prototype._assertNoComponentsNorElementBindingsOnTemplate = function (directives, elementProps, sourceSpan) {
            var _this = this;
            var componentTypeNames = this._findComponentDirectiveNames(directives);
            if (componentTypeNames.length > 0) {
                this._reportError("Components on an embedded template: " + componentTypeNames.join(','), sourceSpan);
            }
            elementProps.forEach(function (prop) {
                _this._reportError("Property binding " + prop.name + " not used by any directive on an embedded template", sourceSpan);
            });
        };
        TemplateParseVisitor.prototype._assertAllEventsPublishedByDirectives = function (directives, events) {
            var _this = this;
            var allDirectiveEvents = new Set();
            directives.forEach(function (directive) {
                collection_1.StringMapWrapper.forEach(directive.directive.outputs, function (eventName, _) {
                    allDirectiveEvents.add(eventName);
                });
            });
            events.forEach(function (event) {
                if (lang_1.isPresent(event.target) || !collection_1.SetWrapper.has(allDirectiveEvents, event.name)) {
                    _this._reportError("Event binding " + event.fullName + " not emitted by any directive on an embedded template", event.sourceSpan);
                }
            });
        };
        return TemplateParseVisitor;
    }();
    var NonBindableVisitor = function () {
        function NonBindableVisitor() {}
        NonBindableVisitor.prototype.visitElement = function (ast, component) {
            var preparsedElement = template_preparser_1.preparseElement(ast);
            if (preparsedElement.type === template_preparser_1.PreparsedElementType.SCRIPT || preparsedElement.type === template_preparser_1.PreparsedElementType.STYLE || preparsedElement.type === template_preparser_1.PreparsedElementType.STYLESHEET) {
                // Skipping <script> for security reasons
                // Skipping <style> and stylesheets as we already processed them
                // in the StyleCompiler
                return null;
            }
            var attrNameAndValues = ast.attrs.map(function (attrAst) {
                return [attrAst.name, attrAst.value];
            });
            var selector = createElementCssSelector(ast.name, attrNameAndValues);
            var ngContentIndex = component.findNgContentIndex(selector);
            var children = html_ast_1.htmlVisitAll(this, ast.children, EMPTY_COMPONENT);
            return new template_ast_1.ElementAst(ast.name, html_ast_1.htmlVisitAll(this, ast.attrs), [], [], [], [], children, ngContentIndex, ast.sourceSpan);
        };
        NonBindableVisitor.prototype.visitComment = function (ast, context) {
            return null;
        };
        NonBindableVisitor.prototype.visitAttr = function (ast, context) {
            return new template_ast_1.AttrAst(ast.name, ast.value, ast.sourceSpan);
        };
        NonBindableVisitor.prototype.visitText = function (ast, component) {
            var ngContentIndex = component.findNgContentIndex(TEXT_CSS_SELECTOR);
            return new template_ast_1.TextAst(ast.value, ngContentIndex, ast.sourceSpan);
        };
        return NonBindableVisitor;
    }();
    var BoundElementOrDirectiveProperty = function () {
        function BoundElementOrDirectiveProperty(name, expression, isLiteral, sourceSpan) {
            this.name = name;
            this.expression = expression;
            this.isLiteral = isLiteral;
            this.sourceSpan = sourceSpan;
        }
        return BoundElementOrDirectiveProperty;
    }();
    function splitClasses(classAttrValue) {
        return lang_1.StringWrapper.split(classAttrValue.trim(), /\s+/g);
    }
    exports.splitClasses = splitClasses;
    var Component = function () {
        function Component(ngContentIndexMatcher, wildcardNgContentIndex) {
            this.ngContentIndexMatcher = ngContentIndexMatcher;
            this.wildcardNgContentIndex = wildcardNgContentIndex;
        }
        Component.create = function (directives) {
            if (directives.length === 0 || !directives[0].directive.isComponent) {
                return EMPTY_COMPONENT;
            }
            var matcher = new selector_1.SelectorMatcher();
            var ngContentSelectors = directives[0].directive.template.ngContentSelectors;
            var wildcardNgContentIndex = null;
            for (var i = 0; i < ngContentSelectors.length; i++) {
                var selector = ngContentSelectors[i];
                if (lang_1.StringWrapper.equals(selector, '*')) {
                    wildcardNgContentIndex = i;
                } else {
                    matcher.addSelectables(selector_1.CssSelector.parse(ngContentSelectors[i]), i);
                }
            }
            return new Component(matcher, wildcardNgContentIndex);
        };
        Component.prototype.findNgContentIndex = function (selector) {
            var ngContentIndices = [];
            this.ngContentIndexMatcher.match(selector, function (selector, ngContentIndex) {
                ngContentIndices.push(ngContentIndex);
            });
            collection_1.ListWrapper.sort(ngContentIndices);
            if (lang_1.isPresent(this.wildcardNgContentIndex)) {
                ngContentIndices.push(this.wildcardNgContentIndex);
            }
            return ngContentIndices.length > 0 ? ngContentIndices[0] : null;
        };
        return Component;
    }();
    function createElementCssSelector(elementName, matchableAttrs) {
        var cssSelector = new selector_1.CssSelector();
        var elNameNoNs = html_tags_1.splitNsName(elementName)[1];
        cssSelector.setElement(elNameNoNs);
        for (var i = 0; i < matchableAttrs.length; i++) {
            var attrName = matchableAttrs[i][0];
            var attrNameNoNs = html_tags_1.splitNsName(attrName)[1];
            var attrValue = matchableAttrs[i][1];
            cssSelector.addAttribute(attrNameNoNs, attrValue);
            if (attrName.toLowerCase() == CLASS_ATTR) {
                var classes = splitClasses(attrValue);
                classes.forEach(function (className) {
                    return cssSelector.addClassName(className);
                });
            }
        }
        return cssSelector;
    }
    var EMPTY_COMPONENT = new Component(new selector_1.SelectorMatcher(), null);
    var NON_BINDABLE_VISITOR = new NonBindableVisitor();
    var PipeCollector = function (_super) {
        __extends(PipeCollector, _super);
        function PipeCollector() {
            _super.apply(this, arguments);
            this.pipes = new Set();
        }
        PipeCollector.prototype.visitPipe = function (ast) {
            this.pipes.add(ast.name);
            ast.exp.visit(this);
            this.visitAll(ast.args);
            return null;
        };
        return PipeCollector;
    }(ast_1.RecursiveAstVisitor);
    exports.PipeCollector = PipeCollector;
});
System.registerDynamic('angular2/src/compiler/style_url_resolver.js', ['angular2/src/facade/lang.js'], true, function ($__require, exports, module) {
    'use strict'; // Some of the code comes from WebComponents.JS
    // https://github.com/webcomponents/webcomponentsjs/blob/master/src/HTMLImports/path.js
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var StyleWithImports = function () {
        function StyleWithImports(style, styleUrls) {
            this.style = style;
            this.styleUrls = styleUrls;
        }
        return StyleWithImports;
    }();
    exports.StyleWithImports = StyleWithImports;
    function isStyleUrlResolvable(url) {
        if (lang_1.isBlank(url) || url.length === 0 || url[0] == '/') return false;
        var schemeMatch = lang_1.RegExpWrapper.firstMatch(_urlWithSchemaRe, url);
        return lang_1.isBlank(schemeMatch) || schemeMatch[1] == 'package' || schemeMatch[1] == 'asset';
    }
    exports.isStyleUrlResolvable = isStyleUrlResolvable;
    /**
     * Rewrites stylesheets by resolving and removing the @import urls that
     * are either relative or don't have a `package:` scheme
     */
    function extractStyleUrls(resolver, baseUrl, cssText) {
        var foundUrls = [];
        var modifiedCssText = lang_1.StringWrapper.replaceAllMapped(cssText, _cssImportRe, function (m) {
            var url = lang_1.isPresent(m[1]) ? m[1] : m[2];
            if (!isStyleUrlResolvable(url)) {
                // Do not attempt to resolve non-package absolute URLs with URI scheme
                return m[0];
            }
            foundUrls.push(resolver.resolve(baseUrl, url));
            return '';
        });
        return new StyleWithImports(modifiedCssText, foundUrls);
    }
    exports.extractStyleUrls = extractStyleUrls;
    var _cssImportRe = /@import\s+(?:url\()?\s*(?:(?:['"]([^'"]*))|([^;\)\s]*))[^;]*;?/g;
    // TODO: can't use /^[^:/?#.]+:/g due to clang-format bug:
    //       https://github.com/angular/angular/issues/4596
    var _urlWithSchemaRe = /^([a-zA-Z\-\+\.]+):/g;
});
System.registerDynamic('angular2/src/compiler/html_ast.js', ['angular2/src/facade/lang.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var HtmlTextAst = function () {
        function HtmlTextAst(value, sourceSpan) {
            this.value = value;
            this.sourceSpan = sourceSpan;
        }
        HtmlTextAst.prototype.visit = function (visitor, context) {
            return visitor.visitText(this, context);
        };
        return HtmlTextAst;
    }();
    exports.HtmlTextAst = HtmlTextAst;
    var HtmlAttrAst = function () {
        function HtmlAttrAst(name, value, sourceSpan) {
            this.name = name;
            this.value = value;
            this.sourceSpan = sourceSpan;
        }
        HtmlAttrAst.prototype.visit = function (visitor, context) {
            return visitor.visitAttr(this, context);
        };
        return HtmlAttrAst;
    }();
    exports.HtmlAttrAst = HtmlAttrAst;
    var HtmlElementAst = function () {
        function HtmlElementAst(name, attrs, children, sourceSpan, startSourceSpan, endSourceSpan) {
            this.name = name;
            this.attrs = attrs;
            this.children = children;
            this.sourceSpan = sourceSpan;
            this.startSourceSpan = startSourceSpan;
            this.endSourceSpan = endSourceSpan;
        }
        HtmlElementAst.prototype.visit = function (visitor, context) {
            return visitor.visitElement(this, context);
        };
        return HtmlElementAst;
    }();
    exports.HtmlElementAst = HtmlElementAst;
    var HtmlCommentAst = function () {
        function HtmlCommentAst(value, sourceSpan) {
            this.value = value;
            this.sourceSpan = sourceSpan;
        }
        HtmlCommentAst.prototype.visit = function (visitor, context) {
            return visitor.visitComment(this, context);
        };
        return HtmlCommentAst;
    }();
    exports.HtmlCommentAst = HtmlCommentAst;
    function htmlVisitAll(visitor, asts, context) {
        if (context === void 0) {
            context = null;
        }
        var result = [];
        asts.forEach(function (ast) {
            var astResult = ast.visit(visitor, context);
            if (lang_1.isPresent(astResult)) {
                result.push(astResult);
            }
        });
        return result;
    }
    exports.htmlVisitAll = htmlVisitAll;
});
System.registerDynamic('angular2/src/compiler/html_lexer.js', ['angular2/src/facade/lang.js', 'angular2/src/facade/collection.js', 'angular2/src/compiler/parse_util.js', 'angular2/src/compiler/html_tags.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var collection_1 = $__require('angular2/src/facade/collection.js');
    var parse_util_1 = $__require('angular2/src/compiler/parse_util.js');
    var html_tags_1 = $__require('angular2/src/compiler/html_tags.js');
    (function (HtmlTokenType) {
        HtmlTokenType[HtmlTokenType["TAG_OPEN_START"] = 0] = "TAG_OPEN_START";
        HtmlTokenType[HtmlTokenType["TAG_OPEN_END"] = 1] = "TAG_OPEN_END";
        HtmlTokenType[HtmlTokenType["TAG_OPEN_END_VOID"] = 2] = "TAG_OPEN_END_VOID";
        HtmlTokenType[HtmlTokenType["TAG_CLOSE"] = 3] = "TAG_CLOSE";
        HtmlTokenType[HtmlTokenType["TEXT"] = 4] = "TEXT";
        HtmlTokenType[HtmlTokenType["ESCAPABLE_RAW_TEXT"] = 5] = "ESCAPABLE_RAW_TEXT";
        HtmlTokenType[HtmlTokenType["RAW_TEXT"] = 6] = "RAW_TEXT";
        HtmlTokenType[HtmlTokenType["COMMENT_START"] = 7] = "COMMENT_START";
        HtmlTokenType[HtmlTokenType["COMMENT_END"] = 8] = "COMMENT_END";
        HtmlTokenType[HtmlTokenType["CDATA_START"] = 9] = "CDATA_START";
        HtmlTokenType[HtmlTokenType["CDATA_END"] = 10] = "CDATA_END";
        HtmlTokenType[HtmlTokenType["ATTR_NAME"] = 11] = "ATTR_NAME";
        HtmlTokenType[HtmlTokenType["ATTR_VALUE"] = 12] = "ATTR_VALUE";
        HtmlTokenType[HtmlTokenType["DOC_TYPE"] = 13] = "DOC_TYPE";
        HtmlTokenType[HtmlTokenType["EOF"] = 14] = "EOF";
    })(exports.HtmlTokenType || (exports.HtmlTokenType = {}));
    var HtmlTokenType = exports.HtmlTokenType;
    var HtmlToken = function () {
        function HtmlToken(type, parts, sourceSpan) {
            this.type = type;
            this.parts = parts;
            this.sourceSpan = sourceSpan;
        }
        return HtmlToken;
    }();
    exports.HtmlToken = HtmlToken;
    var HtmlTokenError = function (_super) {
        __extends(HtmlTokenError, _super);
        function HtmlTokenError(errorMsg, tokenType, span) {
            _super.call(this, span, errorMsg);
            this.tokenType = tokenType;
        }
        return HtmlTokenError;
    }(parse_util_1.ParseError);
    exports.HtmlTokenError = HtmlTokenError;
    var HtmlTokenizeResult = function () {
        function HtmlTokenizeResult(tokens, errors) {
            this.tokens = tokens;
            this.errors = errors;
        }
        return HtmlTokenizeResult;
    }();
    exports.HtmlTokenizeResult = HtmlTokenizeResult;
    function tokenizeHtml(sourceContent, sourceUrl) {
        return new _HtmlTokenizer(new parse_util_1.ParseSourceFile(sourceContent, sourceUrl)).tokenize();
    }
    exports.tokenizeHtml = tokenizeHtml;
    var $EOF = 0;
    var $TAB = 9;
    var $LF = 10;
    var $FF = 12;
    var $CR = 13;
    var $SPACE = 32;
    var $BANG = 33;
    var $DQ = 34;
    var $HASH = 35;
    var $$ = 36;
    var $AMPERSAND = 38;
    var $SQ = 39;
    var $MINUS = 45;
    var $SLASH = 47;
    var $0 = 48;
    var $SEMICOLON = 59;
    var $9 = 57;
    var $COLON = 58;
    var $LT = 60;
    var $EQ = 61;
    var $GT = 62;
    var $QUESTION = 63;
    var $LBRACKET = 91;
    var $RBRACKET = 93;
    var $A = 65;
    var $F = 70;
    var $X = 88;
    var $Z = 90;
    var $a = 97;
    var $f = 102;
    var $z = 122;
    var $x = 120;
    var $NBSP = 160;
    var CR_OR_CRLF_REGEXP = /\r\n?/g;
    function unexpectedCharacterErrorMsg(charCode) {
        var char = charCode === $EOF ? 'EOF' : lang_1.StringWrapper.fromCharCode(charCode);
        return "Unexpected character \"" + char + "\"";
    }
    function unknownEntityErrorMsg(entitySrc) {
        return "Unknown entity \"" + entitySrc + "\" - use the \"&#<decimal>;\" or  \"&#x<hex>;\" syntax";
    }
    var ControlFlowError = function () {
        function ControlFlowError(error) {
            this.error = error;
        }
        return ControlFlowError;
    }();
    // See http://www.w3.org/TR/html51/syntax.html#writing
    var _HtmlTokenizer = function () {
        function _HtmlTokenizer(file) {
            this.file = file;
            // Note: this is always lowercase!
            this.peek = -1;
            this.index = -1;
            this.line = 0;
            this.column = -1;
            this.tokens = [];
            this.errors = [];
            this.input = file.content;
            this.length = file.content.length;
            this._advance();
        }
        _HtmlTokenizer.prototype._processCarriageReturns = function (content) {
            // http://www.w3.org/TR/html5/syntax.html#preprocessing-the-input-stream
            // In order to keep the original position in the source, we can not
            // pre-process it.
            // Instead CRs are processed right before instantiating the tokens.
            return lang_1.StringWrapper.replaceAll(content, CR_OR_CRLF_REGEXP, '\n');
        };
        _HtmlTokenizer.prototype.tokenize = function () {
            while (this.peek !== $EOF) {
                var start = this._getLocation();
                try {
                    if (this._attemptCharCode($LT)) {
                        if (this._attemptCharCode($BANG)) {
                            if (this._attemptCharCode($LBRACKET)) {
                                this._consumeCdata(start);
                            } else if (this._attemptCharCode($MINUS)) {
                                this._consumeComment(start);
                            } else {
                                this._consumeDocType(start);
                            }
                        } else if (this._attemptCharCode($SLASH)) {
                            this._consumeTagClose(start);
                        } else {
                            this._consumeTagOpen(start);
                        }
                    } else {
                        this._consumeText();
                    }
                } catch (e) {
                    if (e instanceof ControlFlowError) {
                        this.errors.push(e.error);
                    } else {
                        throw e;
                    }
                }
            }
            this._beginToken(HtmlTokenType.EOF);
            this._endToken([]);
            return new HtmlTokenizeResult(mergeTextTokens(this.tokens), this.errors);
        };
        _HtmlTokenizer.prototype._getLocation = function () {
            return new parse_util_1.ParseLocation(this.file, this.index, this.line, this.column);
        };
        _HtmlTokenizer.prototype._getSpan = function (start, end) {
            if (lang_1.isBlank(start)) {
                start = this._getLocation();
            }
            if (lang_1.isBlank(end)) {
                end = this._getLocation();
            }
            return new parse_util_1.ParseSourceSpan(start, end);
        };
        _HtmlTokenizer.prototype._beginToken = function (type, start) {
            if (start === void 0) {
                start = null;
            }
            if (lang_1.isBlank(start)) {
                start = this._getLocation();
            }
            this.currentTokenStart = start;
            this.currentTokenType = type;
        };
        _HtmlTokenizer.prototype._endToken = function (parts, end) {
            if (end === void 0) {
                end = null;
            }
            if (lang_1.isBlank(end)) {
                end = this._getLocation();
            }
            var token = new HtmlToken(this.currentTokenType, parts, new parse_util_1.ParseSourceSpan(this.currentTokenStart, end));
            this.tokens.push(token);
            this.currentTokenStart = null;
            this.currentTokenType = null;
            return token;
        };
        _HtmlTokenizer.prototype._createError = function (msg, span) {
            var error = new HtmlTokenError(msg, this.currentTokenType, span);
            this.currentTokenStart = null;
            this.currentTokenType = null;
            return new ControlFlowError(error);
        };
        _HtmlTokenizer.prototype._advance = function () {
            if (this.index >= this.length) {
                throw this._createError(unexpectedCharacterErrorMsg($EOF), this._getSpan());
            }
            if (this.peek === $LF) {
                this.line++;
                this.column = 0;
            } else if (this.peek !== $LF && this.peek !== $CR) {
                this.column++;
            }
            this.index++;
            this.peek = this.index >= this.length ? $EOF : lang_1.StringWrapper.charCodeAt(this.input, this.index);
        };
        _HtmlTokenizer.prototype._attemptCharCode = function (charCode) {
            if (this.peek === charCode) {
                this._advance();
                return true;
            }
            return false;
        };
        _HtmlTokenizer.prototype._attemptCharCodeCaseInsensitive = function (charCode) {
            if (compareCharCodeCaseInsensitive(this.peek, charCode)) {
                this._advance();
                return true;
            }
            return false;
        };
        _HtmlTokenizer.prototype._requireCharCode = function (charCode) {
            var location = this._getLocation();
            if (!this._attemptCharCode(charCode)) {
                throw this._createError(unexpectedCharacterErrorMsg(this.peek), this._getSpan(location, location));
            }
        };
        _HtmlTokenizer.prototype._attemptStr = function (chars) {
            for (var i = 0; i < chars.length; i++) {
                if (!this._attemptCharCode(lang_1.StringWrapper.charCodeAt(chars, i))) {
                    return false;
                }
            }
            return true;
        };
        _HtmlTokenizer.prototype._attemptStrCaseInsensitive = function (chars) {
            for (var i = 0; i < chars.length; i++) {
                if (!this._attemptCharCodeCaseInsensitive(lang_1.StringWrapper.charCodeAt(chars, i))) {
                    return false;
                }
            }
            return true;
        };
        _HtmlTokenizer.prototype._requireStr = function (chars) {
            var location = this._getLocation();
            if (!this._attemptStr(chars)) {
                throw this._createError(unexpectedCharacterErrorMsg(this.peek), this._getSpan(location));
            }
        };
        _HtmlTokenizer.prototype._attemptCharCodeUntilFn = function (predicate) {
            while (!predicate(this.peek)) {
                this._advance();
            }
        };
        _HtmlTokenizer.prototype._requireCharCodeUntilFn = function (predicate, len) {
            var start = this._getLocation();
            this._attemptCharCodeUntilFn(predicate);
            if (this.index - start.offset < len) {
                throw this._createError(unexpectedCharacterErrorMsg(this.peek), this._getSpan(start, start));
            }
        };
        _HtmlTokenizer.prototype._attemptUntilChar = function (char) {
            while (this.peek !== char) {
                this._advance();
            }
        };
        _HtmlTokenizer.prototype._readChar = function (decodeEntities) {
            if (decodeEntities && this.peek === $AMPERSAND) {
                return this._decodeEntity();
            } else {
                var index = this.index;
                this._advance();
                return this.input[index];
            }
        };
        _HtmlTokenizer.prototype._decodeEntity = function () {
            var start = this._getLocation();
            this._advance();
            if (this._attemptCharCode($HASH)) {
                var isHex = this._attemptCharCode($x) || this._attemptCharCode($X);
                var numberStart = this._getLocation().offset;
                this._attemptCharCodeUntilFn(isDigitEntityEnd);
                if (this.peek != $SEMICOLON) {
                    throw this._createError(unexpectedCharacterErrorMsg(this.peek), this._getSpan());
                }
                this._advance();
                var strNum = this.input.substring(numberStart, this.index - 1);
                try {
                    var charCode = lang_1.NumberWrapper.parseInt(strNum, isHex ? 16 : 10);
                    return lang_1.StringWrapper.fromCharCode(charCode);
                } catch (e) {
                    var entity = this.input.substring(start.offset + 1, this.index - 1);
                    throw this._createError(unknownEntityErrorMsg(entity), this._getSpan(start));
                }
            } else {
                var startPosition = this._savePosition();
                this._attemptCharCodeUntilFn(isNamedEntityEnd);
                if (this.peek != $SEMICOLON) {
                    this._restorePosition(startPosition);
                    return '&';
                }
                this._advance();
                var name_1 = this.input.substring(start.offset + 1, this.index - 1);
                var char = html_tags_1.NAMED_ENTITIES[name_1];
                if (lang_1.isBlank(char)) {
                    throw this._createError(unknownEntityErrorMsg(name_1), this._getSpan(start));
                }
                return char;
            }
        };
        _HtmlTokenizer.prototype._consumeRawText = function (decodeEntities, firstCharOfEnd, attemptEndRest) {
            var tagCloseStart;
            var textStart = this._getLocation();
            this._beginToken(decodeEntities ? HtmlTokenType.ESCAPABLE_RAW_TEXT : HtmlTokenType.RAW_TEXT, textStart);
            var parts = [];
            while (true) {
                tagCloseStart = this._getLocation();
                if (this._attemptCharCode(firstCharOfEnd) && attemptEndRest()) {
                    break;
                }
                if (this.index > tagCloseStart.offset) {
                    parts.push(this.input.substring(tagCloseStart.offset, this.index));
                }
                while (this.peek !== firstCharOfEnd) {
                    parts.push(this._readChar(decodeEntities));
                }
            }
            return this._endToken([this._processCarriageReturns(parts.join(''))], tagCloseStart);
        };
        _HtmlTokenizer.prototype._consumeComment = function (start) {
            var _this = this;
            this._beginToken(HtmlTokenType.COMMENT_START, start);
            this._requireCharCode($MINUS);
            this._endToken([]);
            var textToken = this._consumeRawText(false, $MINUS, function () {
                return _this._attemptStr('->');
            });
            this._beginToken(HtmlTokenType.COMMENT_END, textToken.sourceSpan.end);
            this._endToken([]);
        };
        _HtmlTokenizer.prototype._consumeCdata = function (start) {
            var _this = this;
            this._beginToken(HtmlTokenType.CDATA_START, start);
            this._requireStr('CDATA[');
            this._endToken([]);
            var textToken = this._consumeRawText(false, $RBRACKET, function () {
                return _this._attemptStr(']>');
            });
            this._beginToken(HtmlTokenType.CDATA_END, textToken.sourceSpan.end);
            this._endToken([]);
        };
        _HtmlTokenizer.prototype._consumeDocType = function (start) {
            this._beginToken(HtmlTokenType.DOC_TYPE, start);
            this._attemptUntilChar($GT);
            this._advance();
            this._endToken([this.input.substring(start.offset + 2, this.index - 1)]);
        };
        _HtmlTokenizer.prototype._consumePrefixAndName = function () {
            var nameOrPrefixStart = this.index;
            var prefix = null;
            while (this.peek !== $COLON && !isPrefixEnd(this.peek)) {
                this._advance();
            }
            var nameStart;
            if (this.peek === $COLON) {
                this._advance();
                prefix = this.input.substring(nameOrPrefixStart, this.index - 1);
                nameStart = this.index;
            } else {
                nameStart = nameOrPrefixStart;
            }
            this._requireCharCodeUntilFn(isNameEnd, this.index === nameStart ? 1 : 0);
            var name = this.input.substring(nameStart, this.index);
            return [prefix, name];
        };
        _HtmlTokenizer.prototype._consumeTagOpen = function (start) {
            var savedPos = this._savePosition();
            var lowercaseTagName;
            try {
                if (!isAsciiLetter(this.peek)) {
                    throw this._createError(unexpectedCharacterErrorMsg(this.peek), this._getSpan());
                }
                var nameStart = this.index;
                this._consumeTagOpenStart(start);
                lowercaseTagName = this.input.substring(nameStart, this.index).toLowerCase();
                this._attemptCharCodeUntilFn(isNotWhitespace);
                while (this.peek !== $SLASH && this.peek !== $GT) {
                    this._consumeAttributeName();
                    this._attemptCharCodeUntilFn(isNotWhitespace);
                    if (this._attemptCharCode($EQ)) {
                        this._attemptCharCodeUntilFn(isNotWhitespace);
                        this._consumeAttributeValue();
                    }
                    this._attemptCharCodeUntilFn(isNotWhitespace);
                }
                this._consumeTagOpenEnd();
            } catch (e) {
                if (e instanceof ControlFlowError) {
                    // When the start tag is invalid, assume we want a "<"
                    this._restorePosition(savedPos);
                    // Back to back text tokens are merged at the end
                    this._beginToken(HtmlTokenType.TEXT, start);
                    this._endToken(['<']);
                    return;
                }
                throw e;
            }
            var contentTokenType = html_tags_1.getHtmlTagDefinition(lowercaseTagName).contentType;
            if (contentTokenType === html_tags_1.HtmlTagContentType.RAW_TEXT) {
                this._consumeRawTextWithTagClose(lowercaseTagName, false);
            } else if (contentTokenType === html_tags_1.HtmlTagContentType.ESCAPABLE_RAW_TEXT) {
                this._consumeRawTextWithTagClose(lowercaseTagName, true);
            }
        };
        _HtmlTokenizer.prototype._consumeRawTextWithTagClose = function (lowercaseTagName, decodeEntities) {
            var _this = this;
            var textToken = this._consumeRawText(decodeEntities, $LT, function () {
                if (!_this._attemptCharCode($SLASH)) return false;
                _this._attemptCharCodeUntilFn(isNotWhitespace);
                if (!_this._attemptStrCaseInsensitive(lowercaseTagName)) return false;
                _this._attemptCharCodeUntilFn(isNotWhitespace);
                if (!_this._attemptCharCode($GT)) return false;
                return true;
            });
            this._beginToken(HtmlTokenType.TAG_CLOSE, textToken.sourceSpan.end);
            this._endToken([null, lowercaseTagName]);
        };
        _HtmlTokenizer.prototype._consumeTagOpenStart = function (start) {
            this._beginToken(HtmlTokenType.TAG_OPEN_START, start);
            var parts = this._consumePrefixAndName();
            this._endToken(parts);
        };
        _HtmlTokenizer.prototype._consumeAttributeName = function () {
            this._beginToken(HtmlTokenType.ATTR_NAME);
            var prefixAndName = this._consumePrefixAndName();
            this._endToken(prefixAndName);
        };
        _HtmlTokenizer.prototype._consumeAttributeValue = function () {
            this._beginToken(HtmlTokenType.ATTR_VALUE);
            var value;
            if (this.peek === $SQ || this.peek === $DQ) {
                var quoteChar = this.peek;
                this._advance();
                var parts = [];
                while (this.peek !== quoteChar) {
                    parts.push(this._readChar(true));
                }
                value = parts.join('');
                this._advance();
            } else {
                var valueStart = this.index;
                this._requireCharCodeUntilFn(isNameEnd, 1);
                value = this.input.substring(valueStart, this.index);
            }
            this._endToken([this._processCarriageReturns(value)]);
        };
        _HtmlTokenizer.prototype._consumeTagOpenEnd = function () {
            var tokenType = this._attemptCharCode($SLASH) ? HtmlTokenType.TAG_OPEN_END_VOID : HtmlTokenType.TAG_OPEN_END;
            this._beginToken(tokenType);
            this._requireCharCode($GT);
            this._endToken([]);
        };
        _HtmlTokenizer.prototype._consumeTagClose = function (start) {
            this._beginToken(HtmlTokenType.TAG_CLOSE, start);
            this._attemptCharCodeUntilFn(isNotWhitespace);
            var prefixAndName;
            prefixAndName = this._consumePrefixAndName();
            this._attemptCharCodeUntilFn(isNotWhitespace);
            this._requireCharCode($GT);
            this._endToken(prefixAndName);
        };
        _HtmlTokenizer.prototype._consumeText = function () {
            var start = this._getLocation();
            this._beginToken(HtmlTokenType.TEXT, start);
            var parts = [this._readChar(true)];
            while (!isTextEnd(this.peek)) {
                parts.push(this._readChar(true));
            }
            this._endToken([this._processCarriageReturns(parts.join(''))]);
        };
        _HtmlTokenizer.prototype._savePosition = function () {
            return [this.peek, this.index, this.column, this.line, this.tokens.length];
        };
        _HtmlTokenizer.prototype._restorePosition = function (position) {
            this.peek = position[0];
            this.index = position[1];
            this.column = position[2];
            this.line = position[3];
            var nbTokens = position[4];
            if (nbTokens < this.tokens.length) {
                // remove any extra tokens
                this.tokens = collection_1.ListWrapper.slice(this.tokens, 0, nbTokens);
            }
        };
        return _HtmlTokenizer;
    }();
    function isNotWhitespace(code) {
        return !isWhitespace(code) || code === $EOF;
    }
    function isWhitespace(code) {
        return code >= $TAB && code <= $SPACE || code === $NBSP;
    }
    function isNameEnd(code) {
        return isWhitespace(code) || code === $GT || code === $SLASH || code === $SQ || code === $DQ || code === $EQ;
    }
    function isPrefixEnd(code) {
        return (code < $a || $z < code) && (code < $A || $Z < code) && (code < $0 || code > $9);
    }
    function isDigitEntityEnd(code) {
        return code == $SEMICOLON || code == $EOF || !isAsciiHexDigit(code);
    }
    function isNamedEntityEnd(code) {
        return code == $SEMICOLON || code == $EOF || !isAsciiLetter(code);
    }
    function isTextEnd(code) {
        return code === $LT || code === $EOF;
    }
    function isAsciiLetter(code) {
        return code >= $a && code <= $z || code >= $A && code <= $Z;
    }
    function isAsciiHexDigit(code) {
        return code >= $a && code <= $f || code >= $A && code <= $F || code >= $0 && code <= $9;
    }
    function compareCharCodeCaseInsensitive(code1, code2) {
        return toUpperCaseCharCode(code1) == toUpperCaseCharCode(code2);
    }
    function toUpperCaseCharCode(code) {
        return code >= $a && code <= $z ? code - $a + $A : code;
    }
    function mergeTextTokens(srcTokens) {
        var dstTokens = [];
        var lastDstToken;
        for (var i = 0; i < srcTokens.length; i++) {
            var token = srcTokens[i];
            if (lang_1.isPresent(lastDstToken) && lastDstToken.type == HtmlTokenType.TEXT && token.type == HtmlTokenType.TEXT) {
                lastDstToken.parts[0] += token.parts[0];
                lastDstToken.sourceSpan.end = token.sourceSpan.end;
            } else {
                lastDstToken = token;
                dstTokens.push(lastDstToken);
            }
        }
        return dstTokens;
    }
});
System.registerDynamic("angular2/src/compiler/parse_util.js", [], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var ParseLocation = function () {
        function ParseLocation(file, offset, line, col) {
            this.file = file;
            this.offset = offset;
            this.line = line;
            this.col = col;
        }
        ParseLocation.prototype.toString = function () {
            return this.file.url + "@" + this.line + ":" + this.col;
        };
        return ParseLocation;
    }();
    exports.ParseLocation = ParseLocation;
    var ParseSourceFile = function () {
        function ParseSourceFile(content, url) {
            this.content = content;
            this.url = url;
        }
        return ParseSourceFile;
    }();
    exports.ParseSourceFile = ParseSourceFile;
    var ParseSourceSpan = function () {
        function ParseSourceSpan(start, end) {
            this.start = start;
            this.end = end;
        }
        ParseSourceSpan.prototype.toString = function () {
            return this.start.file.content.substring(this.start.offset, this.end.offset);
        };
        return ParseSourceSpan;
    }();
    exports.ParseSourceSpan = ParseSourceSpan;
    var ParseError = function () {
        function ParseError(span, msg) {
            this.span = span;
            this.msg = msg;
        }
        ParseError.prototype.toString = function () {
            var source = this.span.start.file.content;
            var ctxStart = this.span.start.offset;
            if (ctxStart > source.length - 1) {
                ctxStart = source.length - 1;
            }
            var ctxEnd = ctxStart;
            var ctxLen = 0;
            var ctxLines = 0;
            while (ctxLen < 100 && ctxStart > 0) {
                ctxStart--;
                ctxLen++;
                if (source[ctxStart] == "\n") {
                    if (++ctxLines == 3) {
                        break;
                    }
                }
            }
            ctxLen = 0;
            ctxLines = 0;
            while (ctxLen < 100 && ctxEnd < source.length - 1) {
                ctxEnd++;
                ctxLen++;
                if (source[ctxEnd] == "\n") {
                    if (++ctxLines == 3) {
                        break;
                    }
                }
            }
            var context = source.substring(ctxStart, this.span.start.offset) + '[ERROR ->]' + source.substring(this.span.start.offset, ctxEnd + 1);
            return this.msg + " (\"" + context + "\"): " + this.span.start;
        };
        return ParseError;
    }();
    exports.ParseError = ParseError;
});
System.registerDynamic("angular2/src/compiler/html_parser.js", ["angular2/src/facade/lang.js", "angular2/src/facade/collection.js", "angular2/src/compiler/html_ast.js", "angular2/src/core/di.js", "angular2/src/compiler/html_lexer.js", "angular2/src/compiler/parse_util.js", "angular2/src/compiler/html_tags.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var html_ast_1 = $__require("angular2/src/compiler/html_ast.js");
    var di_1 = $__require("angular2/src/core/di.js");
    var html_lexer_1 = $__require("angular2/src/compiler/html_lexer.js");
    var parse_util_1 = $__require("angular2/src/compiler/parse_util.js");
    var html_tags_1 = $__require("angular2/src/compiler/html_tags.js");
    var HtmlTreeError = function (_super) {
        __extends(HtmlTreeError, _super);
        function HtmlTreeError(elementName, span, msg) {
            _super.call(this, span, msg);
            this.elementName = elementName;
        }
        HtmlTreeError.create = function (elementName, span, msg) {
            return new HtmlTreeError(elementName, span, msg);
        };
        return HtmlTreeError;
    }(parse_util_1.ParseError);
    exports.HtmlTreeError = HtmlTreeError;
    var HtmlParseTreeResult = function () {
        function HtmlParseTreeResult(rootNodes, errors) {
            this.rootNodes = rootNodes;
            this.errors = errors;
        }
        return HtmlParseTreeResult;
    }();
    exports.HtmlParseTreeResult = HtmlParseTreeResult;
    var HtmlParser = function () {
        function HtmlParser() {}
        HtmlParser.prototype.parse = function (sourceContent, sourceUrl) {
            var tokensAndErrors = html_lexer_1.tokenizeHtml(sourceContent, sourceUrl);
            var treeAndErrors = new TreeBuilder(tokensAndErrors.tokens).build();
            return new HtmlParseTreeResult(treeAndErrors.rootNodes, tokensAndErrors.errors.concat(treeAndErrors.errors));
        };
        HtmlParser = __decorate([di_1.Injectable(), __metadata('design:paramtypes', [])], HtmlParser);
        return HtmlParser;
    }();
    exports.HtmlParser = HtmlParser;
    var TreeBuilder = function () {
        function TreeBuilder(tokens) {
            this.tokens = tokens;
            this.index = -1;
            this.rootNodes = [];
            this.errors = [];
            this.elementStack = [];
            this._advance();
        }
        TreeBuilder.prototype.build = function () {
            while (this.peek.type !== html_lexer_1.HtmlTokenType.EOF) {
                if (this.peek.type === html_lexer_1.HtmlTokenType.TAG_OPEN_START) {
                    this._consumeStartTag(this._advance());
                } else if (this.peek.type === html_lexer_1.HtmlTokenType.TAG_CLOSE) {
                    this._consumeEndTag(this._advance());
                } else if (this.peek.type === html_lexer_1.HtmlTokenType.CDATA_START) {
                    this._closeVoidElement();
                    this._consumeCdata(this._advance());
                } else if (this.peek.type === html_lexer_1.HtmlTokenType.COMMENT_START) {
                    this._closeVoidElement();
                    this._consumeComment(this._advance());
                } else if (this.peek.type === html_lexer_1.HtmlTokenType.TEXT || this.peek.type === html_lexer_1.HtmlTokenType.RAW_TEXT || this.peek.type === html_lexer_1.HtmlTokenType.ESCAPABLE_RAW_TEXT) {
                    this._closeVoidElement();
                    this._consumeText(this._advance());
                } else {
                    // Skip all other tokens...
                    this._advance();
                }
            }
            return new HtmlParseTreeResult(this.rootNodes, this.errors);
        };
        TreeBuilder.prototype._advance = function () {
            var prev = this.peek;
            if (this.index < this.tokens.length - 1) {
                // Note: there is always an EOF token at the end
                this.index++;
            }
            this.peek = this.tokens[this.index];
            return prev;
        };
        TreeBuilder.prototype._advanceIf = function (type) {
            if (this.peek.type === type) {
                return this._advance();
            }
            return null;
        };
        TreeBuilder.prototype._consumeCdata = function (startToken) {
            this._consumeText(this._advance());
            this._advanceIf(html_lexer_1.HtmlTokenType.CDATA_END);
        };
        TreeBuilder.prototype._consumeComment = function (token) {
            var text = this._advanceIf(html_lexer_1.HtmlTokenType.RAW_TEXT);
            this._advanceIf(html_lexer_1.HtmlTokenType.COMMENT_END);
            var value = lang_1.isPresent(text) ? text.parts[0].trim() : null;
            this._addToParent(new html_ast_1.HtmlCommentAst(value, token.sourceSpan));
        };
        TreeBuilder.prototype._consumeText = function (token) {
            var text = token.parts[0];
            if (text.length > 0 && text[0] == '\n') {
                var parent_1 = this._getParentElement();
                if (lang_1.isPresent(parent_1) && parent_1.children.length == 0 && html_tags_1.getHtmlTagDefinition(parent_1.name).ignoreFirstLf) {
                    text = text.substring(1);
                }
            }
            if (text.length > 0) {
                this._addToParent(new html_ast_1.HtmlTextAst(text, token.sourceSpan));
            }
        };
        TreeBuilder.prototype._closeVoidElement = function () {
            if (this.elementStack.length > 0) {
                var el = collection_1.ListWrapper.last(this.elementStack);
                if (html_tags_1.getHtmlTagDefinition(el.name).isVoid) {
                    this.elementStack.pop();
                }
            }
        };
        TreeBuilder.prototype._consumeStartTag = function (startTagToken) {
            var prefix = startTagToken.parts[0];
            var name = startTagToken.parts[1];
            var attrs = [];
            while (this.peek.type === html_lexer_1.HtmlTokenType.ATTR_NAME) {
                attrs.push(this._consumeAttr(this._advance()));
            }
            var fullName = getElementFullName(prefix, name, this._getParentElement());
            var selfClosing = false;
            // Note: There could have been a tokenizer error
            // so that we don't get a token for the end tag...
            if (this.peek.type === html_lexer_1.HtmlTokenType.TAG_OPEN_END_VOID) {
                this._advance();
                selfClosing = true;
                if (html_tags_1.getNsPrefix(fullName) == null && !html_tags_1.getHtmlTagDefinition(fullName).isVoid) {
                    this.errors.push(HtmlTreeError.create(fullName, startTagToken.sourceSpan, "Only void and foreign elements can be self closed \"" + startTagToken.parts[1] + "\""));
                }
            } else if (this.peek.type === html_lexer_1.HtmlTokenType.TAG_OPEN_END) {
                this._advance();
                selfClosing = false;
            }
            var end = this.peek.sourceSpan.start;
            var span = new parse_util_1.ParseSourceSpan(startTagToken.sourceSpan.start, end);
            var el = new html_ast_1.HtmlElementAst(fullName, attrs, [], span, span, null);
            this._pushElement(el);
            if (selfClosing) {
                this._popElement(fullName);
                el.endSourceSpan = span;
            }
        };
        TreeBuilder.prototype._pushElement = function (el) {
            if (this.elementStack.length > 0) {
                var parentEl = collection_1.ListWrapper.last(this.elementStack);
                if (html_tags_1.getHtmlTagDefinition(parentEl.name).isClosedByChild(el.name)) {
                    this.elementStack.pop();
                }
            }
            var tagDef = html_tags_1.getHtmlTagDefinition(el.name);
            var parentEl = this._getParentElement();
            if (tagDef.requireExtraParent(lang_1.isPresent(parentEl) ? parentEl.name : null)) {
                var newParent = new html_ast_1.HtmlElementAst(tagDef.parentToAdd, [], [el], el.sourceSpan, el.startSourceSpan, el.endSourceSpan);
                this._addToParent(newParent);
                this.elementStack.push(newParent);
                this.elementStack.push(el);
            } else {
                this._addToParent(el);
                this.elementStack.push(el);
            }
        };
        TreeBuilder.prototype._consumeEndTag = function (endTagToken) {
            var fullName = getElementFullName(endTagToken.parts[0], endTagToken.parts[1], this._getParentElement());
            this._getParentElement().endSourceSpan = endTagToken.sourceSpan;
            if (html_tags_1.getHtmlTagDefinition(fullName).isVoid) {
                this.errors.push(HtmlTreeError.create(fullName, endTagToken.sourceSpan, "Void elements do not have end tags \"" + endTagToken.parts[1] + "\""));
            } else if (!this._popElement(fullName)) {
                this.errors.push(HtmlTreeError.create(fullName, endTagToken.sourceSpan, "Unexpected closing tag \"" + endTagToken.parts[1] + "\""));
            }
        };
        TreeBuilder.prototype._popElement = function (fullName) {
            for (var stackIndex = this.elementStack.length - 1; stackIndex >= 0; stackIndex--) {
                var el = this.elementStack[stackIndex];
                if (el.name == fullName) {
                    collection_1.ListWrapper.splice(this.elementStack, stackIndex, this.elementStack.length - stackIndex);
                    return true;
                }
                if (!html_tags_1.getHtmlTagDefinition(el.name).closedByParent) {
                    return false;
                }
            }
            return false;
        };
        TreeBuilder.prototype._consumeAttr = function (attrName) {
            var fullName = html_tags_1.mergeNsAndName(attrName.parts[0], attrName.parts[1]);
            var end = attrName.sourceSpan.end;
            var value = '';
            if (this.peek.type === html_lexer_1.HtmlTokenType.ATTR_VALUE) {
                var valueToken = this._advance();
                value = valueToken.parts[0];
                end = valueToken.sourceSpan.end;
            }
            return new html_ast_1.HtmlAttrAst(fullName, value, new parse_util_1.ParseSourceSpan(attrName.sourceSpan.start, end));
        };
        TreeBuilder.prototype._getParentElement = function () {
            return this.elementStack.length > 0 ? collection_1.ListWrapper.last(this.elementStack) : null;
        };
        TreeBuilder.prototype._addToParent = function (node) {
            var parent = this._getParentElement();
            if (lang_1.isPresent(parent)) {
                parent.children.push(node);
            } else {
                this.rootNodes.push(node);
            }
        };
        return TreeBuilder;
    }();
    function getElementFullName(prefix, localName, parentElement) {
        if (lang_1.isBlank(prefix)) {
            prefix = html_tags_1.getHtmlTagDefinition(localName).implicitNamespacePrefix;
            if (lang_1.isBlank(prefix) && lang_1.isPresent(parentElement)) {
                prefix = html_tags_1.getNsPrefix(parentElement.name);
            }
        }
        return html_tags_1.mergeNsAndName(prefix, localName);
    }
});
System.registerDynamic('angular2/src/compiler/template_preparser.js', ['angular2/src/facade/lang.js', 'angular2/src/compiler/html_tags.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var html_tags_1 = $__require('angular2/src/compiler/html_tags.js');
    var NG_CONTENT_SELECT_ATTR = 'select';
    var NG_CONTENT_ELEMENT = 'ng-content';
    var LINK_ELEMENT = 'link';
    var LINK_STYLE_REL_ATTR = 'rel';
    var LINK_STYLE_HREF_ATTR = 'href';
    var LINK_STYLE_REL_VALUE = 'stylesheet';
    var STYLE_ELEMENT = 'style';
    var SCRIPT_ELEMENT = 'script';
    var NG_NON_BINDABLE_ATTR = 'ngNonBindable';
    var NG_PROJECT_AS = 'ngProjectAs';
    function preparseElement(ast) {
        var selectAttr = null;
        var hrefAttr = null;
        var relAttr = null;
        var nonBindable = false;
        var projectAs = null;
        ast.attrs.forEach(function (attr) {
            var lcAttrName = attr.name.toLowerCase();
            if (lcAttrName == NG_CONTENT_SELECT_ATTR) {
                selectAttr = attr.value;
            } else if (lcAttrName == LINK_STYLE_HREF_ATTR) {
                hrefAttr = attr.value;
            } else if (lcAttrName == LINK_STYLE_REL_ATTR) {
                relAttr = attr.value;
            } else if (attr.name == NG_NON_BINDABLE_ATTR) {
                nonBindable = true;
            } else if (attr.name == NG_PROJECT_AS) {
                if (attr.value.length > 0) {
                    projectAs = attr.value;
                }
            }
        });
        selectAttr = normalizeNgContentSelect(selectAttr);
        var nodeName = ast.name.toLowerCase();
        var type = PreparsedElementType.OTHER;
        if (html_tags_1.splitNsName(nodeName)[1] == NG_CONTENT_ELEMENT) {
            type = PreparsedElementType.NG_CONTENT;
        } else if (nodeName == STYLE_ELEMENT) {
            type = PreparsedElementType.STYLE;
        } else if (nodeName == SCRIPT_ELEMENT) {
            type = PreparsedElementType.SCRIPT;
        } else if (nodeName == LINK_ELEMENT && relAttr == LINK_STYLE_REL_VALUE) {
            type = PreparsedElementType.STYLESHEET;
        }
        return new PreparsedElement(type, selectAttr, hrefAttr, nonBindable, projectAs);
    }
    exports.preparseElement = preparseElement;
    (function (PreparsedElementType) {
        PreparsedElementType[PreparsedElementType["NG_CONTENT"] = 0] = "NG_CONTENT";
        PreparsedElementType[PreparsedElementType["STYLE"] = 1] = "STYLE";
        PreparsedElementType[PreparsedElementType["STYLESHEET"] = 2] = "STYLESHEET";
        PreparsedElementType[PreparsedElementType["SCRIPT"] = 3] = "SCRIPT";
        PreparsedElementType[PreparsedElementType["OTHER"] = 4] = "OTHER";
    })(exports.PreparsedElementType || (exports.PreparsedElementType = {}));
    var PreparsedElementType = exports.PreparsedElementType;
    var PreparsedElement = function () {
        function PreparsedElement(type, selectAttr, hrefAttr, nonBindable, projectAs) {
            this.type = type;
            this.selectAttr = selectAttr;
            this.hrefAttr = hrefAttr;
            this.nonBindable = nonBindable;
            this.projectAs = projectAs;
        }
        return PreparsedElement;
    }();
    exports.PreparsedElement = PreparsedElement;
    function normalizeNgContentSelect(selectAttr) {
        if (lang_1.isBlank(selectAttr) || selectAttr.length === 0) {
            return '*';
        }
        return selectAttr;
    }
});
System.registerDynamic("angular2/src/compiler/template_normalizer.js", ["angular2/src/compiler/directive_metadata.js", "angular2/src/facade/lang.js", "angular2/src/facade/exceptions.js", "angular2/src/facade/async.js", "angular2/src/compiler/xhr.js", "angular2/src/compiler/url_resolver.js", "angular2/src/compiler/style_url_resolver.js", "angular2/src/core/di.js", "angular2/src/core/metadata/view.js", "angular2/src/compiler/html_ast.js", "angular2/src/compiler/html_parser.js", "angular2/src/compiler/template_preparser.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var directive_metadata_1 = $__require("angular2/src/compiler/directive_metadata.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var exceptions_1 = $__require("angular2/src/facade/exceptions.js");
    var async_1 = $__require("angular2/src/facade/async.js");
    var xhr_1 = $__require("angular2/src/compiler/xhr.js");
    var url_resolver_1 = $__require("angular2/src/compiler/url_resolver.js");
    var style_url_resolver_1 = $__require("angular2/src/compiler/style_url_resolver.js");
    var di_1 = $__require("angular2/src/core/di.js");
    var view_1 = $__require("angular2/src/core/metadata/view.js");
    var html_ast_1 = $__require("angular2/src/compiler/html_ast.js");
    var html_parser_1 = $__require("angular2/src/compiler/html_parser.js");
    var template_preparser_1 = $__require("angular2/src/compiler/template_preparser.js");
    var TemplateNormalizer = function () {
        function TemplateNormalizer(_xhr, _urlResolver, _htmlParser) {
            this._xhr = _xhr;
            this._urlResolver = _urlResolver;
            this._htmlParser = _htmlParser;
        }
        TemplateNormalizer.prototype.normalizeTemplate = function (directiveType, template) {
            var _this = this;
            if (lang_1.isPresent(template.template)) {
                return async_1.PromiseWrapper.resolve(this.normalizeLoadedTemplate(directiveType, template, template.template, directiveType.moduleUrl));
            } else if (lang_1.isPresent(template.templateUrl)) {
                var sourceAbsUrl = this._urlResolver.resolve(directiveType.moduleUrl, template.templateUrl);
                return this._xhr.get(sourceAbsUrl).then(function (templateContent) {
                    return _this.normalizeLoadedTemplate(directiveType, template, templateContent, sourceAbsUrl);
                });
            } else {
                throw new exceptions_1.BaseException("No template specified for component " + directiveType.name);
            }
        };
        TemplateNormalizer.prototype.normalizeLoadedTemplate = function (directiveType, templateMeta, template, templateAbsUrl) {
            var _this = this;
            var rootNodesAndErrors = this._htmlParser.parse(template, directiveType.name);
            if (rootNodesAndErrors.errors.length > 0) {
                var errorString = rootNodesAndErrors.errors.join('\n');
                throw new exceptions_1.BaseException("Template parse errors:\n" + errorString);
            }
            var visitor = new TemplatePreparseVisitor();
            html_ast_1.htmlVisitAll(visitor, rootNodesAndErrors.rootNodes);
            var allStyles = templateMeta.styles.concat(visitor.styles);
            var allStyleAbsUrls = visitor.styleUrls.filter(style_url_resolver_1.isStyleUrlResolvable).map(function (url) {
                return _this._urlResolver.resolve(templateAbsUrl, url);
            }).concat(templateMeta.styleUrls.filter(style_url_resolver_1.isStyleUrlResolvable).map(function (url) {
                return _this._urlResolver.resolve(directiveType.moduleUrl, url);
            }));
            var allResolvedStyles = allStyles.map(function (style) {
                var styleWithImports = style_url_resolver_1.extractStyleUrls(_this._urlResolver, templateAbsUrl, style);
                styleWithImports.styleUrls.forEach(function (styleUrl) {
                    return allStyleAbsUrls.push(styleUrl);
                });
                return styleWithImports.style;
            });
            var encapsulation = templateMeta.encapsulation;
            if (encapsulation === view_1.ViewEncapsulation.Emulated && allResolvedStyles.length === 0 && allStyleAbsUrls.length === 0) {
                encapsulation = view_1.ViewEncapsulation.None;
            }
            return new directive_metadata_1.CompileTemplateMetadata({
                encapsulation: encapsulation,
                template: template,
                templateUrl: templateAbsUrl,
                styles: allResolvedStyles,
                styleUrls: allStyleAbsUrls,
                ngContentSelectors: visitor.ngContentSelectors
            });
        };
        TemplateNormalizer = __decorate([di_1.Injectable(), __metadata('design:paramtypes', [xhr_1.XHR, url_resolver_1.UrlResolver, html_parser_1.HtmlParser])], TemplateNormalizer);
        return TemplateNormalizer;
    }();
    exports.TemplateNormalizer = TemplateNormalizer;
    var TemplatePreparseVisitor = function () {
        function TemplatePreparseVisitor() {
            this.ngContentSelectors = [];
            this.styles = [];
            this.styleUrls = [];
            this.ngNonBindableStackCount = 0;
        }
        TemplatePreparseVisitor.prototype.visitElement = function (ast, context) {
            var preparsedElement = template_preparser_1.preparseElement(ast);
            switch (preparsedElement.type) {
                case template_preparser_1.PreparsedElementType.NG_CONTENT:
                    if (this.ngNonBindableStackCount === 0) {
                        this.ngContentSelectors.push(preparsedElement.selectAttr);
                    }
                    break;
                case template_preparser_1.PreparsedElementType.STYLE:
                    var textContent = '';
                    ast.children.forEach(function (child) {
                        if (child instanceof html_ast_1.HtmlTextAst) {
                            textContent += child.value;
                        }
                    });
                    this.styles.push(textContent);
                    break;
                case template_preparser_1.PreparsedElementType.STYLESHEET:
                    this.styleUrls.push(preparsedElement.hrefAttr);
                    break;
                default:
                    // DDC reports this as error. See:
                    // https://github.com/dart-lang/dev_compiler/issues/428
                    break;
            }
            if (preparsedElement.nonBindable) {
                this.ngNonBindableStackCount++;
            }
            html_ast_1.htmlVisitAll(this, ast.children);
            if (preparsedElement.nonBindable) {
                this.ngNonBindableStackCount--;
            }
            return null;
        };
        TemplatePreparseVisitor.prototype.visitComment = function (ast, context) {
            return null;
        };
        TemplatePreparseVisitor.prototype.visitAttr = function (ast, context) {
            return null;
        };
        TemplatePreparseVisitor.prototype.visitText = function (ast, context) {
            return null;
        };
        return TemplatePreparseVisitor;
    }();
});
System.registerDynamic('angular2/src/compiler/selector.js', ['angular2/src/facade/collection.js', 'angular2/src/facade/lang.js', 'angular2/src/facade/exceptions.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var collection_1 = $__require('angular2/src/facade/collection.js');
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var exceptions_1 = $__require('angular2/src/facade/exceptions.js');
    var _EMPTY_ATTR_VALUE = '';
    // TODO: Can't use `const` here as
    // in Dart this is not transpiled into `final` yet...
    var _SELECTOR_REGEXP = lang_1.RegExpWrapper.create('(\\:not\\()|' + '([-\\w]+)|' + '(?:\\.([-\\w]+))|' + '(?:\\[([-\\w*]+)(?:=([^\\]]*))?\\])|' + '(\\))|' + '(\\s*,\\s*)'); // ","
    /**
     * A css selector contains an element name,
     * css classes and attribute/value pairs with the purpose
     * of selecting subsets out of them.
     */
    var CssSelector = function () {
        function CssSelector() {
            this.element = null;
            this.classNames = [];
            this.attrs = [];
            this.notSelectors = [];
        }
        CssSelector.parse = function (selector) {
            var results = [];
            var _addResult = function (res, cssSel) {
                if (cssSel.notSelectors.length > 0 && lang_1.isBlank(cssSel.element) && collection_1.ListWrapper.isEmpty(cssSel.classNames) && collection_1.ListWrapper.isEmpty(cssSel.attrs)) {
                    cssSel.element = "*";
                }
                res.push(cssSel);
            };
            var cssSelector = new CssSelector();
            var matcher = lang_1.RegExpWrapper.matcher(_SELECTOR_REGEXP, selector);
            var match;
            var current = cssSelector;
            var inNot = false;
            while (lang_1.isPresent(match = lang_1.RegExpMatcherWrapper.next(matcher))) {
                if (lang_1.isPresent(match[1])) {
                    if (inNot) {
                        throw new exceptions_1.BaseException('Nesting :not is not allowed in a selector');
                    }
                    inNot = true;
                    current = new CssSelector();
                    cssSelector.notSelectors.push(current);
                }
                if (lang_1.isPresent(match[2])) {
                    current.setElement(match[2]);
                }
                if (lang_1.isPresent(match[3])) {
                    current.addClassName(match[3]);
                }
                if (lang_1.isPresent(match[4])) {
                    current.addAttribute(match[4], match[5]);
                }
                if (lang_1.isPresent(match[6])) {
                    inNot = false;
                    current = cssSelector;
                }
                if (lang_1.isPresent(match[7])) {
                    if (inNot) {
                        throw new exceptions_1.BaseException('Multiple selectors in :not are not supported');
                    }
                    _addResult(results, cssSelector);
                    cssSelector = current = new CssSelector();
                }
            }
            _addResult(results, cssSelector);
            return results;
        };
        CssSelector.prototype.isElementSelector = function () {
            return lang_1.isPresent(this.element) && collection_1.ListWrapper.isEmpty(this.classNames) && collection_1.ListWrapper.isEmpty(this.attrs) && this.notSelectors.length === 0;
        };
        CssSelector.prototype.setElement = function (element) {
            if (element === void 0) {
                element = null;
            }
            this.element = element;
        };
        /** Gets a template string for an element that matches the selector. */
        CssSelector.prototype.getMatchingElementTemplate = function () {
            var tagName = lang_1.isPresent(this.element) ? this.element : 'div';
            var classAttr = this.classNames.length > 0 ? " class=\"" + this.classNames.join(' ') + "\"" : '';
            var attrs = '';
            for (var i = 0; i < this.attrs.length; i += 2) {
                var attrName = this.attrs[i];
                var attrValue = this.attrs[i + 1] !== '' ? "=\"" + this.attrs[i + 1] + "\"" : '';
                attrs += " " + attrName + attrValue;
            }
            return "<" + tagName + classAttr + attrs + "></" + tagName + ">";
        };
        CssSelector.prototype.addAttribute = function (name, value) {
            if (value === void 0) {
                value = _EMPTY_ATTR_VALUE;
            }
            this.attrs.push(name);
            if (lang_1.isPresent(value)) {
                value = value.toLowerCase();
            } else {
                value = _EMPTY_ATTR_VALUE;
            }
            this.attrs.push(value);
        };
        CssSelector.prototype.addClassName = function (name) {
            this.classNames.push(name.toLowerCase());
        };
        CssSelector.prototype.toString = function () {
            var res = '';
            if (lang_1.isPresent(this.element)) {
                res += this.element;
            }
            if (lang_1.isPresent(this.classNames)) {
                for (var i = 0; i < this.classNames.length; i++) {
                    res += '.' + this.classNames[i];
                }
            }
            if (lang_1.isPresent(this.attrs)) {
                for (var i = 0; i < this.attrs.length;) {
                    var attrName = this.attrs[i++];
                    var attrValue = this.attrs[i++];
                    res += '[' + attrName;
                    if (attrValue.length > 0) {
                        res += '=' + attrValue;
                    }
                    res += ']';
                }
            }
            this.notSelectors.forEach(function (notSelector) {
                return res += ":not(" + notSelector + ")";
            });
            return res;
        };
        return CssSelector;
    }();
    exports.CssSelector = CssSelector;
    /**
     * Reads a list of CssSelectors and allows to calculate which ones
     * are contained in a given CssSelector.
     */
    var SelectorMatcher = function () {
        function SelectorMatcher() {
            this._elementMap = new collection_1.Map();
            this._elementPartialMap = new collection_1.Map();
            this._classMap = new collection_1.Map();
            this._classPartialMap = new collection_1.Map();
            this._attrValueMap = new collection_1.Map();
            this._attrValuePartialMap = new collection_1.Map();
            this._listContexts = [];
        }
        SelectorMatcher.createNotMatcher = function (notSelectors) {
            var notMatcher = new SelectorMatcher();
            notMatcher.addSelectables(notSelectors, null);
            return notMatcher;
        };
        SelectorMatcher.prototype.addSelectables = function (cssSelectors, callbackCtxt) {
            var listContext = null;
            if (cssSelectors.length > 1) {
                listContext = new SelectorListContext(cssSelectors);
                this._listContexts.push(listContext);
            }
            for (var i = 0; i < cssSelectors.length; i++) {
                this._addSelectable(cssSelectors[i], callbackCtxt, listContext);
            }
        };
        /**
         * Add an object that can be found later on by calling `match`.
         * @param cssSelector A css selector
         * @param callbackCtxt An opaque object that will be given to the callback of the `match` function
         */
        SelectorMatcher.prototype._addSelectable = function (cssSelector, callbackCtxt, listContext) {
            var matcher = this;
            var element = cssSelector.element;
            var classNames = cssSelector.classNames;
            var attrs = cssSelector.attrs;
            var selectable = new SelectorContext(cssSelector, callbackCtxt, listContext);
            if (lang_1.isPresent(element)) {
                var isTerminal = attrs.length === 0 && classNames.length === 0;
                if (isTerminal) {
                    this._addTerminal(matcher._elementMap, element, selectable);
                } else {
                    matcher = this._addPartial(matcher._elementPartialMap, element);
                }
            }
            if (lang_1.isPresent(classNames)) {
                for (var index = 0; index < classNames.length; index++) {
                    var isTerminal = attrs.length === 0 && index === classNames.length - 1;
                    var className = classNames[index];
                    if (isTerminal) {
                        this._addTerminal(matcher._classMap, className, selectable);
                    } else {
                        matcher = this._addPartial(matcher._classPartialMap, className);
                    }
                }
            }
            if (lang_1.isPresent(attrs)) {
                for (var index = 0; index < attrs.length;) {
                    var isTerminal = index === attrs.length - 2;
                    var attrName = attrs[index++];
                    var attrValue = attrs[index++];
                    if (isTerminal) {
                        var terminalMap = matcher._attrValueMap;
                        var terminalValuesMap = terminalMap.get(attrName);
                        if (lang_1.isBlank(terminalValuesMap)) {
                            terminalValuesMap = new collection_1.Map();
                            terminalMap.set(attrName, terminalValuesMap);
                        }
                        this._addTerminal(terminalValuesMap, attrValue, selectable);
                    } else {
                        var parttialMap = matcher._attrValuePartialMap;
                        var partialValuesMap = parttialMap.get(attrName);
                        if (lang_1.isBlank(partialValuesMap)) {
                            partialValuesMap = new collection_1.Map();
                            parttialMap.set(attrName, partialValuesMap);
                        }
                        matcher = this._addPartial(partialValuesMap, attrValue);
                    }
                }
            }
        };
        SelectorMatcher.prototype._addTerminal = function (map, name, selectable) {
            var terminalList = map.get(name);
            if (lang_1.isBlank(terminalList)) {
                terminalList = [];
                map.set(name, terminalList);
            }
            terminalList.push(selectable);
        };
        SelectorMatcher.prototype._addPartial = function (map, name) {
            var matcher = map.get(name);
            if (lang_1.isBlank(matcher)) {
                matcher = new SelectorMatcher();
                map.set(name, matcher);
            }
            return matcher;
        };
        /**
         * Find the objects that have been added via `addSelectable`
         * whose css selector is contained in the given css selector.
         * @param cssSelector A css selector
         * @param matchedCallback This callback will be called with the object handed into `addSelectable`
         * @return boolean true if a match was found
        */
        SelectorMatcher.prototype.match = function (cssSelector, matchedCallback) {
            var result = false;
            var element = cssSelector.element;
            var classNames = cssSelector.classNames;
            var attrs = cssSelector.attrs;
            for (var i = 0; i < this._listContexts.length; i++) {
                this._listContexts[i].alreadyMatched = false;
            }
            result = this._matchTerminal(this._elementMap, element, cssSelector, matchedCallback) || result;
            result = this._matchPartial(this._elementPartialMap, element, cssSelector, matchedCallback) || result;
            if (lang_1.isPresent(classNames)) {
                for (var index = 0; index < classNames.length; index++) {
                    var className = classNames[index];
                    result = this._matchTerminal(this._classMap, className, cssSelector, matchedCallback) || result;
                    result = this._matchPartial(this._classPartialMap, className, cssSelector, matchedCallback) || result;
                }
            }
            if (lang_1.isPresent(attrs)) {
                for (var index = 0; index < attrs.length;) {
                    var attrName = attrs[index++];
                    var attrValue = attrs[index++];
                    var terminalValuesMap = this._attrValueMap.get(attrName);
                    if (!lang_1.StringWrapper.equals(attrValue, _EMPTY_ATTR_VALUE)) {
                        result = this._matchTerminal(terminalValuesMap, _EMPTY_ATTR_VALUE, cssSelector, matchedCallback) || result;
                    }
                    result = this._matchTerminal(terminalValuesMap, attrValue, cssSelector, matchedCallback) || result;
                    var partialValuesMap = this._attrValuePartialMap.get(attrName);
                    if (!lang_1.StringWrapper.equals(attrValue, _EMPTY_ATTR_VALUE)) {
                        result = this._matchPartial(partialValuesMap, _EMPTY_ATTR_VALUE, cssSelector, matchedCallback) || result;
                    }
                    result = this._matchPartial(partialValuesMap, attrValue, cssSelector, matchedCallback) || result;
                }
            }
            return result;
        };
        /** @internal */
        SelectorMatcher.prototype._matchTerminal = function (map, name, cssSelector, matchedCallback) {
            if (lang_1.isBlank(map) || lang_1.isBlank(name)) {
                return false;
            }
            var selectables = map.get(name);
            var starSelectables = map.get("*");
            if (lang_1.isPresent(starSelectables)) {
                selectables = selectables.concat(starSelectables);
            }
            if (lang_1.isBlank(selectables)) {
                return false;
            }
            var selectable;
            var result = false;
            for (var index = 0; index < selectables.length; index++) {
                selectable = selectables[index];
                result = selectable.finalize(cssSelector, matchedCallback) || result;
            }
            return result;
        };
        /** @internal */
        SelectorMatcher.prototype._matchPartial = function (map, name, cssSelector, matchedCallback /*: (c: CssSelector, a: any) => void*/) {
            if (lang_1.isBlank(map) || lang_1.isBlank(name)) {
                return false;
            }
            var nestedSelector = map.get(name);
            if (lang_1.isBlank(nestedSelector)) {
                return false;
            }
            // TODO(perf): get rid of recursion and measure again
            // TODO(perf): don't pass the whole selector into the recursion,
            // but only the not processed parts
            return nestedSelector.match(cssSelector, matchedCallback);
        };
        return SelectorMatcher;
    }();
    exports.SelectorMatcher = SelectorMatcher;
    var SelectorListContext = function () {
        function SelectorListContext(selectors) {
            this.selectors = selectors;
            this.alreadyMatched = false;
        }
        return SelectorListContext;
    }();
    exports.SelectorListContext = SelectorListContext;
    // Store context to pass back selector and context when a selector is matched
    var SelectorContext = function () {
        function SelectorContext(selector, cbContext, listContext) {
            this.selector = selector;
            this.cbContext = cbContext;
            this.listContext = listContext;
            this.notSelectors = selector.notSelectors;
        }
        SelectorContext.prototype.finalize = function (cssSelector, callback) {
            var result = true;
            if (this.notSelectors.length > 0 && (lang_1.isBlank(this.listContext) || !this.listContext.alreadyMatched)) {
                var notMatcher = SelectorMatcher.createNotMatcher(this.notSelectors);
                result = !notMatcher.match(cssSelector, null);
            }
            if (result && lang_1.isPresent(callback) && (lang_1.isBlank(this.listContext) || !this.listContext.alreadyMatched)) {
                if (lang_1.isPresent(this.listContext)) {
                    this.listContext.alreadyMatched = true;
                }
                callback(this.selector, this.cbContext);
            }
            return result;
        };
        return SelectorContext;
    }();
    exports.SelectorContext = SelectorContext;
});
System.registerDynamic('angular2/src/compiler/directive_metadata.js', ['angular2/src/facade/lang.js', 'angular2/src/facade/exceptions.js', 'angular2/src/facade/collection.js', 'angular2/src/core/change_detection/change_detection.js', 'angular2/src/core/metadata/view.js', 'angular2/src/compiler/selector.js', 'angular2/src/compiler/util.js', 'angular2/src/core/linker/interfaces.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var exceptions_1 = $__require('angular2/src/facade/exceptions.js');
    var collection_1 = $__require('angular2/src/facade/collection.js');
    var change_detection_1 = $__require('angular2/src/core/change_detection/change_detection.js');
    var view_1 = $__require('angular2/src/core/metadata/view.js');
    var selector_1 = $__require('angular2/src/compiler/selector.js');
    var util_1 = $__require('angular2/src/compiler/util.js');
    var interfaces_1 = $__require('angular2/src/core/linker/interfaces.js');
    // group 1: "property" from "[property]"
    // group 2: "event" from "(event)"
    var HOST_REG_EXP = /^(?:(?:\[([^\]]+)\])|(?:\(([^\)]+)\)))$/g;
    var CompileMetadataWithIdentifier = function () {
        function CompileMetadataWithIdentifier() {}
        Object.defineProperty(CompileMetadataWithIdentifier.prototype, "identifier", {
            get: function () {
                return exceptions_1.unimplemented();
            },
            enumerable: true,
            configurable: true
        });
        return CompileMetadataWithIdentifier;
    }();
    exports.CompileMetadataWithIdentifier = CompileMetadataWithIdentifier;
    var CompileMetadataWithType = function (_super) {
        __extends(CompileMetadataWithType, _super);
        function CompileMetadataWithType() {
            _super.apply(this, arguments);
        }
        Object.defineProperty(CompileMetadataWithType.prototype, "type", {
            get: function () {
                return exceptions_1.unimplemented();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CompileMetadataWithType.prototype, "identifier", {
            get: function () {
                return exceptions_1.unimplemented();
            },
            enumerable: true,
            configurable: true
        });
        return CompileMetadataWithType;
    }(CompileMetadataWithIdentifier);
    exports.CompileMetadataWithType = CompileMetadataWithType;
    function metadataFromJson(data) {
        return _COMPILE_METADATA_FROM_JSON[data['class']](data);
    }
    exports.metadataFromJson = metadataFromJson;
    var CompileIdentifierMetadata = function () {
        function CompileIdentifierMetadata(_a) {
            var _b = _a === void 0 ? {} : _a,
                runtime = _b.runtime,
                name = _b.name,
                moduleUrl = _b.moduleUrl,
                prefix = _b.prefix,
                constConstructor = _b.constConstructor,
                value = _b.value;
            this.runtime = runtime;
            this.name = name;
            this.prefix = prefix;
            this.moduleUrl = moduleUrl;
            this.constConstructor = constConstructor;
            this.value = value;
        }
        CompileIdentifierMetadata.fromJson = function (data) {
            var value = lang_1.isArray(data['value']) ? arrayFromJson(data['value'], metadataFromJson) : objFromJson(data['value'], metadataFromJson);
            return new CompileIdentifierMetadata({
                name: data['name'],
                prefix: data['prefix'],
                moduleUrl: data['moduleUrl'],
                constConstructor: data['constConstructor'],
                value: value
            });
        };
        CompileIdentifierMetadata.prototype.toJson = function () {
            var value = lang_1.isArray(this.value) ? arrayToJson(this.value) : objToJson(this.value);
            return {
                // Note: Runtime type can't be serialized...
                'class': 'Identifier',
                'name': this.name,
                'moduleUrl': this.moduleUrl,
                'prefix': this.prefix,
                'constConstructor': this.constConstructor,
                'value': value
            };
        };
        Object.defineProperty(CompileIdentifierMetadata.prototype, "identifier", {
            get: function () {
                return this;
            },
            enumerable: true,
            configurable: true
        });
        return CompileIdentifierMetadata;
    }();
    exports.CompileIdentifierMetadata = CompileIdentifierMetadata;
    var CompileDiDependencyMetadata = function () {
        function CompileDiDependencyMetadata(_a) {
            var _b = _a === void 0 ? {} : _a,
                isAttribute = _b.isAttribute,
                isSelf = _b.isSelf,
                isHost = _b.isHost,
                isSkipSelf = _b.isSkipSelf,
                isOptional = _b.isOptional,
                query = _b.query,
                viewQuery = _b.viewQuery,
                token = _b.token;
            this.isAttribute = lang_1.normalizeBool(isAttribute);
            this.isSelf = lang_1.normalizeBool(isSelf);
            this.isHost = lang_1.normalizeBool(isHost);
            this.isSkipSelf = lang_1.normalizeBool(isSkipSelf);
            this.isOptional = lang_1.normalizeBool(isOptional);
            this.query = query;
            this.viewQuery = viewQuery;
            this.token = token;
        }
        CompileDiDependencyMetadata.fromJson = function (data) {
            return new CompileDiDependencyMetadata({
                token: objFromJson(data['token'], CompileIdentifierMetadata.fromJson),
                query: objFromJson(data['query'], CompileQueryMetadata.fromJson),
                viewQuery: objFromJson(data['viewQuery'], CompileQueryMetadata.fromJson),
                isAttribute: data['isAttribute'],
                isSelf: data['isSelf'],
                isHost: data['isHost'],
                isSkipSelf: data['isSkipSelf'],
                isOptional: data['isOptional']
            });
        };
        CompileDiDependencyMetadata.prototype.toJson = function () {
            return {
                // Note: Runtime type can't be serialized...
                'token': objToJson(this.token),
                'query': objToJson(this.query),
                'viewQuery': objToJson(this.viewQuery),
                'isAttribute': this.isAttribute,
                'isSelf': this.isSelf,
                'isHost': this.isHost,
                'isSkipSelf': this.isSkipSelf,
                'isOptional': this.isOptional
            };
        };
        return CompileDiDependencyMetadata;
    }();
    exports.CompileDiDependencyMetadata = CompileDiDependencyMetadata;
    var CompileProviderMetadata = function () {
        function CompileProviderMetadata(_a) {
            var token = _a.token,
                useClass = _a.useClass,
                useValue = _a.useValue,
                useExisting = _a.useExisting,
                useFactory = _a.useFactory,
                deps = _a.deps,
                multi = _a.multi;
            this.token = token;
            this.useClass = useClass;
            this.useValue = useValue;
            this.useExisting = useExisting;
            this.useFactory = useFactory;
            this.deps = deps;
            this.multi = multi;
        }
        CompileProviderMetadata.fromJson = function (data) {
            return new CompileProviderMetadata({
                token: objFromJson(data['token'], CompileIdentifierMetadata.fromJson),
                useClass: objFromJson(data['useClass'], CompileTypeMetadata.fromJson),
                useExisting: objFromJson(data['useExisting'], CompileIdentifierMetadata.fromJson),
                useValue: objFromJson(data['useValue'], CompileIdentifierMetadata.fromJson),
                useFactory: objFromJson(data['useFactory'], CompileFactoryMetadata.fromJson)
            });
        };
        CompileProviderMetadata.prototype.toJson = function () {
            return {
                // Note: Runtime type can't be serialized...
                'class': 'Provider',
                'token': objToJson(this.token),
                'useClass': objToJson(this.useClass),
                'useExisting': objToJson(this.useExisting),
                'useValue': objToJson(this.useValue),
                'useFactory': objToJson(this.useFactory)
            };
        };
        return CompileProviderMetadata;
    }();
    exports.CompileProviderMetadata = CompileProviderMetadata;
    var CompileFactoryMetadata = function () {
        function CompileFactoryMetadata(_a) {
            var runtime = _a.runtime,
                name = _a.name,
                moduleUrl = _a.moduleUrl,
                prefix = _a.prefix,
                constConstructor = _a.constConstructor,
                diDeps = _a.diDeps,
                value = _a.value;
            this.runtime = runtime;
            this.name = name;
            this.prefix = prefix;
            this.moduleUrl = moduleUrl;
            this.diDeps = diDeps;
            this.constConstructor = constConstructor;
            this.value = value;
        }
        Object.defineProperty(CompileFactoryMetadata.prototype, "identifier", {
            get: function () {
                return this;
            },
            enumerable: true,
            configurable: true
        });
        CompileFactoryMetadata.fromJson = function (data) {
            return new CompileFactoryMetadata({
                name: data['name'],
                prefix: data['prefix'],
                moduleUrl: data['moduleUrl'],
                constConstructor: data['constConstructor'],
                value: data['value'],
                diDeps: arrayFromJson(data['diDeps'], CompileDiDependencyMetadata.fromJson)
            });
        };
        CompileFactoryMetadata.prototype.toJson = function () {
            return {
                'class': 'Factory',
                'name': this.name,
                'prefix': this.prefix,
                'moduleUrl': this.moduleUrl,
                'constConstructor': this.constConstructor,
                'value': this.value,
                'diDeps': arrayToJson(this.diDeps)
            };
        };
        return CompileFactoryMetadata;
    }();
    exports.CompileFactoryMetadata = CompileFactoryMetadata;
    /**
     * Metadata regarding compilation of a type.
     */
    var CompileTypeMetadata = function () {
        function CompileTypeMetadata(_a) {
            var _b = _a === void 0 ? {} : _a,
                runtime = _b.runtime,
                name = _b.name,
                moduleUrl = _b.moduleUrl,
                prefix = _b.prefix,
                isHost = _b.isHost,
                constConstructor = _b.constConstructor,
                value = _b.value,
                diDeps = _b.diDeps;
            this.runtime = runtime;
            this.name = name;
            this.moduleUrl = moduleUrl;
            this.prefix = prefix;
            this.isHost = lang_1.normalizeBool(isHost);
            this.constConstructor = constConstructor;
            this.value = value;
            this.diDeps = lang_1.normalizeBlank(diDeps);
        }
        CompileTypeMetadata.fromJson = function (data) {
            return new CompileTypeMetadata({
                name: data['name'],
                moduleUrl: data['moduleUrl'],
                prefix: data['prefix'],
                isHost: data['isHost'],
                constConstructor: data['constConstructor'],
                value: data['value'],
                diDeps: arrayFromJson(data['diDeps'], CompileDiDependencyMetadata.fromJson)
            });
        };
        Object.defineProperty(CompileTypeMetadata.prototype, "identifier", {
            get: function () {
                return this;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CompileTypeMetadata.prototype, "type", {
            get: function () {
                return this;
            },
            enumerable: true,
            configurable: true
        });
        CompileTypeMetadata.prototype.toJson = function () {
            return {
                // Note: Runtime type can't be serialized...
                'class': 'Type',
                'name': this.name,
                'moduleUrl': this.moduleUrl,
                'prefix': this.prefix,
                'isHost': this.isHost,
                'constConstructor': this.constConstructor,
                'value': this.value,
                'diDeps': arrayToJson(this.diDeps)
            };
        };
        return CompileTypeMetadata;
    }();
    exports.CompileTypeMetadata = CompileTypeMetadata;
    var CompileQueryMetadata = function () {
        function CompileQueryMetadata(_a) {
            var _b = _a === void 0 ? {} : _a,
                selectors = _b.selectors,
                descendants = _b.descendants,
                first = _b.first,
                propertyName = _b.propertyName;
            this.selectors = selectors;
            this.descendants = descendants;
            this.first = lang_1.normalizeBool(first);
            this.propertyName = propertyName;
        }
        CompileQueryMetadata.fromJson = function (data) {
            return new CompileQueryMetadata({
                selectors: arrayFromJson(data['selectors'], CompileIdentifierMetadata.fromJson),
                descendants: data['descendants'],
                first: data['first'],
                propertyName: data['propertyName']
            });
        };
        CompileQueryMetadata.prototype.toJson = function () {
            return {
                // Note: Runtime type can't be serialized...
                'selectors': arrayToJson(this.selectors),
                'descendants': this.descendants,
                'first': this.first,
                'propertyName': this.propertyName
            };
        };
        return CompileQueryMetadata;
    }();
    exports.CompileQueryMetadata = CompileQueryMetadata;
    /**
     * Metadata regarding compilation of a template.
     */
    var CompileTemplateMetadata = function () {
        function CompileTemplateMetadata(_a) {
            var _b = _a === void 0 ? {} : _a,
                encapsulation = _b.encapsulation,
                template = _b.template,
                templateUrl = _b.templateUrl,
                styles = _b.styles,
                styleUrls = _b.styleUrls,
                ngContentSelectors = _b.ngContentSelectors;
            this.encapsulation = lang_1.isPresent(encapsulation) ? encapsulation : view_1.ViewEncapsulation.Emulated;
            this.template = template;
            this.templateUrl = templateUrl;
            this.styles = lang_1.isPresent(styles) ? styles : [];
            this.styleUrls = lang_1.isPresent(styleUrls) ? styleUrls : [];
            this.ngContentSelectors = lang_1.isPresent(ngContentSelectors) ? ngContentSelectors : [];
        }
        CompileTemplateMetadata.fromJson = function (data) {
            return new CompileTemplateMetadata({
                encapsulation: lang_1.isPresent(data['encapsulation']) ? view_1.VIEW_ENCAPSULATION_VALUES[data['encapsulation']] : data['encapsulation'],
                template: data['template'],
                templateUrl: data['templateUrl'],
                styles: data['styles'],
                styleUrls: data['styleUrls'],
                ngContentSelectors: data['ngContentSelectors']
            });
        };
        CompileTemplateMetadata.prototype.toJson = function () {
            return {
                'encapsulation': lang_1.isPresent(this.encapsulation) ? lang_1.serializeEnum(this.encapsulation) : this.encapsulation,
                'template': this.template,
                'templateUrl': this.templateUrl,
                'styles': this.styles,
                'styleUrls': this.styleUrls,
                'ngContentSelectors': this.ngContentSelectors
            };
        };
        return CompileTemplateMetadata;
    }();
    exports.CompileTemplateMetadata = CompileTemplateMetadata;
    /**
     * Metadata regarding compilation of a directive.
     */
    var CompileDirectiveMetadata = function () {
        function CompileDirectiveMetadata(_a) {
            var _b = _a === void 0 ? {} : _a,
                type = _b.type,
                isComponent = _b.isComponent,
                dynamicLoadable = _b.dynamicLoadable,
                selector = _b.selector,
                exportAs = _b.exportAs,
                changeDetection = _b.changeDetection,
                inputs = _b.inputs,
                outputs = _b.outputs,
                hostListeners = _b.hostListeners,
                hostProperties = _b.hostProperties,
                hostAttributes = _b.hostAttributes,
                lifecycleHooks = _b.lifecycleHooks,
                providers = _b.providers,
                viewProviders = _b.viewProviders,
                queries = _b.queries,
                viewQueries = _b.viewQueries,
                template = _b.template;
            this.type = type;
            this.isComponent = isComponent;
            this.dynamicLoadable = dynamicLoadable;
            this.selector = selector;
            this.exportAs = exportAs;
            this.changeDetection = changeDetection;
            this.inputs = inputs;
            this.outputs = outputs;
            this.hostListeners = hostListeners;
            this.hostProperties = hostProperties;
            this.hostAttributes = hostAttributes;
            this.lifecycleHooks = lifecycleHooks;
            this.providers = lang_1.normalizeBlank(providers);
            this.viewProviders = lang_1.normalizeBlank(viewProviders);
            this.queries = lang_1.normalizeBlank(queries);
            this.viewQueries = lang_1.normalizeBlank(viewQueries);
            this.template = template;
        }
        CompileDirectiveMetadata.create = function (_a) {
            var _b = _a === void 0 ? {} : _a,
                type = _b.type,
                isComponent = _b.isComponent,
                dynamicLoadable = _b.dynamicLoadable,
                selector = _b.selector,
                exportAs = _b.exportAs,
                changeDetection = _b.changeDetection,
                inputs = _b.inputs,
                outputs = _b.outputs,
                host = _b.host,
                lifecycleHooks = _b.lifecycleHooks,
                providers = _b.providers,
                viewProviders = _b.viewProviders,
                queries = _b.queries,
                viewQueries = _b.viewQueries,
                template = _b.template;
            var hostListeners = {};
            var hostProperties = {};
            var hostAttributes = {};
            if (lang_1.isPresent(host)) {
                collection_1.StringMapWrapper.forEach(host, function (value, key) {
                    var matches = lang_1.RegExpWrapper.firstMatch(HOST_REG_EXP, key);
                    if (lang_1.isBlank(matches)) {
                        hostAttributes[key] = value;
                    } else if (lang_1.isPresent(matches[1])) {
                        hostProperties[matches[1]] = value;
                    } else if (lang_1.isPresent(matches[2])) {
                        hostListeners[matches[2]] = value;
                    }
                });
            }
            var inputsMap = {};
            if (lang_1.isPresent(inputs)) {
                inputs.forEach(function (bindConfig) {
                    // canonical syntax: `dirProp: elProp`
                    // if there is no `:`, use dirProp = elProp
                    var parts = util_1.splitAtColon(bindConfig, [bindConfig, bindConfig]);
                    inputsMap[parts[0]] = parts[1];
                });
            }
            var outputsMap = {};
            if (lang_1.isPresent(outputs)) {
                outputs.forEach(function (bindConfig) {
                    // canonical syntax: `dirProp: elProp`
                    // if there is no `:`, use dirProp = elProp
                    var parts = util_1.splitAtColon(bindConfig, [bindConfig, bindConfig]);
                    outputsMap[parts[0]] = parts[1];
                });
            }
            return new CompileDirectiveMetadata({
                type: type,
                isComponent: lang_1.normalizeBool(isComponent),
                dynamicLoadable: lang_1.normalizeBool(dynamicLoadable),
                selector: selector,
                exportAs: exportAs,
                changeDetection: changeDetection,
                inputs: inputsMap,
                outputs: outputsMap,
                hostListeners: hostListeners,
                hostProperties: hostProperties,
                hostAttributes: hostAttributes,
                lifecycleHooks: lang_1.isPresent(lifecycleHooks) ? lifecycleHooks : [],
                providers: providers,
                viewProviders: viewProviders,
                queries: queries,
                viewQueries: viewQueries,
                template: template
            });
        };
        Object.defineProperty(CompileDirectiveMetadata.prototype, "identifier", {
            get: function () {
                return this.type;
            },
            enumerable: true,
            configurable: true
        });
        CompileDirectiveMetadata.fromJson = function (data) {
            return new CompileDirectiveMetadata({
                isComponent: data['isComponent'],
                dynamicLoadable: data['dynamicLoadable'],
                selector: data['selector'],
                exportAs: data['exportAs'],
                type: lang_1.isPresent(data['type']) ? CompileTypeMetadata.fromJson(data['type']) : data['type'],
                changeDetection: lang_1.isPresent(data['changeDetection']) ? change_detection_1.CHANGE_DETECTION_STRATEGY_VALUES[data['changeDetection']] : data['changeDetection'],
                inputs: data['inputs'],
                outputs: data['outputs'],
                hostListeners: data['hostListeners'],
                hostProperties: data['hostProperties'],
                hostAttributes: data['hostAttributes'],
                lifecycleHooks: data['lifecycleHooks'].map(function (hookValue) {
                    return interfaces_1.LIFECYCLE_HOOKS_VALUES[hookValue];
                }),
                template: lang_1.isPresent(data['template']) ? CompileTemplateMetadata.fromJson(data['template']) : data['template'],
                providers: arrayFromJson(data['providers'], metadataFromJson),
                viewProviders: arrayFromJson(data['viewProviders'], metadataFromJson),
                queries: arrayFromJson(data['queries'], CompileQueryMetadata.fromJson),
                viewQueries: arrayFromJson(data['viewQueries'], CompileQueryMetadata.fromJson)
            });
        };
        CompileDirectiveMetadata.prototype.toJson = function () {
            return {
                'class': 'Directive',
                'isComponent': this.isComponent,
                'dynamicLoadable': this.dynamicLoadable,
                'selector': this.selector,
                'exportAs': this.exportAs,
                'type': lang_1.isPresent(this.type) ? this.type.toJson() : this.type,
                'changeDetection': lang_1.isPresent(this.changeDetection) ? lang_1.serializeEnum(this.changeDetection) : this.changeDetection,
                'inputs': this.inputs,
                'outputs': this.outputs,
                'hostListeners': this.hostListeners,
                'hostProperties': this.hostProperties,
                'hostAttributes': this.hostAttributes,
                'lifecycleHooks': this.lifecycleHooks.map(function (hook) {
                    return lang_1.serializeEnum(hook);
                }),
                'template': lang_1.isPresent(this.template) ? this.template.toJson() : this.template,
                'providers': arrayToJson(this.providers),
                'viewProviders': arrayToJson(this.viewProviders),
                'queries': arrayToJson(this.queries),
                'viewQueries': arrayToJson(this.viewQueries)
            };
        };
        return CompileDirectiveMetadata;
    }();
    exports.CompileDirectiveMetadata = CompileDirectiveMetadata;
    /**
     * Construct {@link CompileDirectiveMetadata} from {@link ComponentTypeMetadata} and a selector.
     */
    function createHostComponentMeta(componentType, componentSelector) {
        var template = selector_1.CssSelector.parse(componentSelector)[0].getMatchingElementTemplate();
        return CompileDirectiveMetadata.create({
            type: new CompileTypeMetadata({
                runtime: Object,
                name: "Host" + componentType.name,
                moduleUrl: componentType.moduleUrl,
                isHost: true
            }),
            template: new CompileTemplateMetadata({ template: template, templateUrl: '', styles: [], styleUrls: [], ngContentSelectors: [] }),
            changeDetection: change_detection_1.ChangeDetectionStrategy.Default,
            inputs: [],
            outputs: [],
            host: {},
            lifecycleHooks: [],
            isComponent: true,
            dynamicLoadable: false,
            selector: '*',
            providers: [],
            viewProviders: [],
            queries: [],
            viewQueries: []
        });
    }
    exports.createHostComponentMeta = createHostComponentMeta;
    var CompilePipeMetadata = function () {
        function CompilePipeMetadata(_a) {
            var _b = _a === void 0 ? {} : _a,
                type = _b.type,
                name = _b.name,
                pure = _b.pure;
            this.type = type;
            this.name = name;
            this.pure = lang_1.normalizeBool(pure);
        }
        Object.defineProperty(CompilePipeMetadata.prototype, "identifier", {
            get: function () {
                return this.type;
            },
            enumerable: true,
            configurable: true
        });
        CompilePipeMetadata.fromJson = function (data) {
            return new CompilePipeMetadata({
                type: lang_1.isPresent(data['type']) ? CompileTypeMetadata.fromJson(data['type']) : data['type'],
                name: data['name'],
                pure: data['pure']
            });
        };
        CompilePipeMetadata.prototype.toJson = function () {
            return {
                'class': 'Pipe',
                'type': lang_1.isPresent(this.type) ? this.type.toJson() : null,
                'name': this.name,
                'pure': this.pure
            };
        };
        return CompilePipeMetadata;
    }();
    exports.CompilePipeMetadata = CompilePipeMetadata;
    var _COMPILE_METADATA_FROM_JSON = {
        'Directive': CompileDirectiveMetadata.fromJson,
        'Pipe': CompilePipeMetadata.fromJson,
        'Type': CompileTypeMetadata.fromJson,
        'Provider': CompileProviderMetadata.fromJson,
        'Identifier': CompileIdentifierMetadata.fromJson,
        'Factory': CompileFactoryMetadata.fromJson
    };
    function arrayFromJson(obj, fn) {
        return lang_1.isBlank(obj) ? null : obj.map(function (o) {
            return objFromJson(o, fn);
        });
    }
    function arrayToJson(obj) {
        return lang_1.isBlank(obj) ? null : obj.map(objToJson);
    }
    function objFromJson(obj, fn) {
        if (lang_1.isArray(obj)) return arrayFromJson(obj, fn);
        if (lang_1.isString(obj) || lang_1.isBlank(obj) || lang_1.isBoolean(obj) || lang_1.isNumber(obj)) return obj;
        return fn(obj);
    }
    function objToJson(obj) {
        if (lang_1.isArray(obj)) return arrayToJson(obj);
        if (lang_1.isString(obj) || lang_1.isBlank(obj) || lang_1.isBoolean(obj) || lang_1.isNumber(obj)) return obj;
        return obj.toJson();
    }
});
System.registerDynamic('angular2/src/core/linker/directive_lifecycle_reflector.js', ['angular2/src/facade/lang.js', 'angular2/src/core/linker/interfaces.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var interfaces_1 = $__require('angular2/src/core/linker/interfaces.js');
    function hasLifecycleHook(lcInterface, token) {
        if (!(token instanceof lang_1.Type)) return false;
        var proto = token.prototype;
        switch (lcInterface) {
            case interfaces_1.LifecycleHooks.AfterContentInit:
                return !!proto.ngAfterContentInit;
            case interfaces_1.LifecycleHooks.AfterContentChecked:
                return !!proto.ngAfterContentChecked;
            case interfaces_1.LifecycleHooks.AfterViewInit:
                return !!proto.ngAfterViewInit;
            case interfaces_1.LifecycleHooks.AfterViewChecked:
                return !!proto.ngAfterViewChecked;
            case interfaces_1.LifecycleHooks.OnChanges:
                return !!proto.ngOnChanges;
            case interfaces_1.LifecycleHooks.DoCheck:
                return !!proto.ngDoCheck;
            case interfaces_1.LifecycleHooks.OnDestroy:
                return !!proto.ngOnDestroy;
            case interfaces_1.LifecycleHooks.OnInit:
                return !!proto.ngOnInit;
            default:
                return false;
        }
    }
    exports.hasLifecycleHook = hasLifecycleHook;
});
System.registerDynamic("angular2/src/core/linker/interfaces.js", [], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    (function (LifecycleHooks) {
        LifecycleHooks[LifecycleHooks["OnInit"] = 0] = "OnInit";
        LifecycleHooks[LifecycleHooks["OnDestroy"] = 1] = "OnDestroy";
        LifecycleHooks[LifecycleHooks["DoCheck"] = 2] = "DoCheck";
        LifecycleHooks[LifecycleHooks["OnChanges"] = 3] = "OnChanges";
        LifecycleHooks[LifecycleHooks["AfterContentInit"] = 4] = "AfterContentInit";
        LifecycleHooks[LifecycleHooks["AfterContentChecked"] = 5] = "AfterContentChecked";
        LifecycleHooks[LifecycleHooks["AfterViewInit"] = 6] = "AfterViewInit";
        LifecycleHooks[LifecycleHooks["AfterViewChecked"] = 7] = "AfterViewChecked";
    })(exports.LifecycleHooks || (exports.LifecycleHooks = {}));
    var LifecycleHooks = exports.LifecycleHooks;
    /**
     * @internal
     */
    exports.LIFECYCLE_HOOKS_VALUES = [LifecycleHooks.OnInit, LifecycleHooks.OnDestroy, LifecycleHooks.DoCheck, LifecycleHooks.OnChanges, LifecycleHooks.AfterContentInit, LifecycleHooks.AfterContentChecked, LifecycleHooks.AfterViewInit, LifecycleHooks.AfterViewChecked];
});
System.registerDynamic('angular2/src/compiler/assertions.js', ['angular2/src/facade/lang.js', 'angular2/src/facade/exceptions.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var exceptions_1 = $__require('angular2/src/facade/exceptions.js');
    function assertArrayOfStrings(identifier, value) {
        if (!lang_1.assertionsEnabled() || lang_1.isBlank(value)) {
            return;
        }
        if (!lang_1.isArray(value)) {
            throw new exceptions_1.BaseException("Expected '" + identifier + "' to be an array of strings.");
        }
        for (var i = 0; i < value.length; i += 1) {
            if (!lang_1.isString(value[i])) {
                throw new exceptions_1.BaseException("Expected '" + identifier + "' to be an array of strings.");
            }
        }
    }
    exports.assertArrayOfStrings = assertArrayOfStrings;
});
System.registerDynamic("angular2/src/compiler/runtime_metadata.js", ["angular2/src/core/di.js", "angular2/src/facade/lang.js", "angular2/src/facade/exceptions.js", "angular2/src/compiler/directive_metadata.js", "angular2/src/core/metadata/directives.js", "angular2/src/core/linker/directive_resolver.js", "angular2/src/core/linker/pipe_resolver.js", "angular2/src/core/linker/view_resolver.js", "angular2/src/core/linker/directive_lifecycle_reflector.js", "angular2/src/core/linker/interfaces.js", "angular2/src/core/reflection/reflection.js", "angular2/src/core/platform_directives_and_pipes.js", "angular2/src/compiler/util.js", "angular2/src/compiler/assertions.js", "angular2/src/compiler/url_resolver.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var __param = this && this.__param || function (paramIndex, decorator) {
        return function (target, key) {
            decorator(target, key, paramIndex);
        };
    };
    var di_1 = $__require("angular2/src/core/di.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var exceptions_1 = $__require("angular2/src/facade/exceptions.js");
    var cpl = $__require("angular2/src/compiler/directive_metadata.js");
    var md = $__require("angular2/src/core/metadata/directives.js");
    var directive_resolver_1 = $__require("angular2/src/core/linker/directive_resolver.js");
    var pipe_resolver_1 = $__require("angular2/src/core/linker/pipe_resolver.js");
    var view_resolver_1 = $__require("angular2/src/core/linker/view_resolver.js");
    var directive_lifecycle_reflector_1 = $__require("angular2/src/core/linker/directive_lifecycle_reflector.js");
    var interfaces_1 = $__require("angular2/src/core/linker/interfaces.js");
    var reflection_1 = $__require("angular2/src/core/reflection/reflection.js");
    var di_2 = $__require("angular2/src/core/di.js");
    var platform_directives_and_pipes_1 = $__require("angular2/src/core/platform_directives_and_pipes.js");
    var util_1 = $__require("angular2/src/compiler/util.js");
    var assertions_1 = $__require("angular2/src/compiler/assertions.js");
    var url_resolver_1 = $__require("angular2/src/compiler/url_resolver.js");
    var RuntimeMetadataResolver = function () {
        function RuntimeMetadataResolver(_directiveResolver, _pipeResolver, _viewResolver, _platformDirectives, _platformPipes) {
            this._directiveResolver = _directiveResolver;
            this._pipeResolver = _pipeResolver;
            this._viewResolver = _viewResolver;
            this._platformDirectives = _platformDirectives;
            this._platformPipes = _platformPipes;
            this._directiveCache = new Map();
            this._pipeCache = new Map();
            this._anonymousTypes = new Map();
            this._anonymousTypeIndex = 0;
        }
        /**
         * Wrap the stringify method to avoid naming things `function (arg1...) {`
         */
        RuntimeMetadataResolver.prototype.sanitizeName = function (obj) {
            var result = lang_1.stringify(obj);
            if (result.indexOf('(') < 0) {
                return result;
            }
            var found = this._anonymousTypes.get(obj);
            if (!found) {
                this._anonymousTypes.set(obj, this._anonymousTypeIndex++);
                found = this._anonymousTypes.get(obj);
            }
            return "anonymous_type_" + found + "_";
        };
        RuntimeMetadataResolver.prototype.getDirectiveMetadata = function (directiveType) {
            var meta = this._directiveCache.get(directiveType);
            if (lang_1.isBlank(meta)) {
                var dirMeta = this._directiveResolver.resolve(directiveType);
                var moduleUrl = null;
                var templateMeta = null;
                var changeDetectionStrategy = null;
                if (dirMeta instanceof md.ComponentMetadata) {
                    assertions_1.assertArrayOfStrings('styles', dirMeta.styles);
                    var cmpMeta = dirMeta;
                    moduleUrl = calcModuleUrl(directiveType, cmpMeta);
                    var viewMeta = this._viewResolver.resolve(directiveType);
                    assertions_1.assertArrayOfStrings('styles', viewMeta.styles);
                    templateMeta = new cpl.CompileTemplateMetadata({
                        encapsulation: viewMeta.encapsulation,
                        template: viewMeta.template,
                        templateUrl: viewMeta.templateUrl,
                        styles: viewMeta.styles,
                        styleUrls: viewMeta.styleUrls
                    });
                    changeDetectionStrategy = cmpMeta.changeDetection;
                }
                meta = cpl.CompileDirectiveMetadata.create({
                    selector: dirMeta.selector,
                    exportAs: dirMeta.exportAs,
                    isComponent: lang_1.isPresent(templateMeta),
                    dynamicLoadable: true,
                    type: new cpl.CompileTypeMetadata({ name: this.sanitizeName(directiveType), moduleUrl: moduleUrl, runtime: directiveType }),
                    template: templateMeta,
                    changeDetection: changeDetectionStrategy,
                    inputs: dirMeta.inputs,
                    outputs: dirMeta.outputs,
                    host: dirMeta.host,
                    lifecycleHooks: interfaces_1.LIFECYCLE_HOOKS_VALUES.filter(function (hook) {
                        return directive_lifecycle_reflector_1.hasLifecycleHook(hook, directiveType);
                    })
                });
                this._directiveCache.set(directiveType, meta);
            }
            return meta;
        };
        RuntimeMetadataResolver.prototype.getPipeMetadata = function (pipeType) {
            var meta = this._pipeCache.get(pipeType);
            if (lang_1.isBlank(meta)) {
                var pipeMeta = this._pipeResolver.resolve(pipeType);
                var moduleUrl = reflection_1.reflector.importUri(pipeType);
                meta = new cpl.CompilePipeMetadata({
                    type: new cpl.CompileTypeMetadata({ name: this.sanitizeName(pipeType), moduleUrl: moduleUrl, runtime: pipeType }),
                    name: pipeMeta.name,
                    pure: pipeMeta.pure
                });
                this._pipeCache.set(pipeType, meta);
            }
            return meta;
        };
        RuntimeMetadataResolver.prototype.getViewDirectivesMetadata = function (component) {
            var _this = this;
            var view = this._viewResolver.resolve(component);
            var directives = flattenDirectives(view, this._platformDirectives);
            for (var i = 0; i < directives.length; i++) {
                if (!isValidType(directives[i])) {
                    throw new exceptions_1.BaseException("Unexpected directive value '" + lang_1.stringify(directives[i]) + "' on the View of component '" + lang_1.stringify(component) + "'");
                }
            }
            return directives.map(function (type) {
                return _this.getDirectiveMetadata(type);
            });
        };
        RuntimeMetadataResolver.prototype.getViewPipesMetadata = function (component) {
            var _this = this;
            var view = this._viewResolver.resolve(component);
            var pipes = flattenPipes(view, this._platformPipes);
            for (var i = 0; i < pipes.length; i++) {
                if (!isValidType(pipes[i])) {
                    throw new exceptions_1.BaseException("Unexpected piped value '" + lang_1.stringify(pipes[i]) + "' on the View of component '" + lang_1.stringify(component) + "'");
                }
            }
            return pipes.map(function (type) {
                return _this.getPipeMetadata(type);
            });
        };
        RuntimeMetadataResolver = __decorate([di_2.Injectable(), __param(3, di_2.Optional()), __param(3, di_2.Inject(platform_directives_and_pipes_1.PLATFORM_DIRECTIVES)), __param(4, di_2.Optional()), __param(4, di_2.Inject(platform_directives_and_pipes_1.PLATFORM_PIPES)), __metadata('design:paramtypes', [directive_resolver_1.DirectiveResolver, pipe_resolver_1.PipeResolver, view_resolver_1.ViewResolver, Array, Array])], RuntimeMetadataResolver);
        return RuntimeMetadataResolver;
    }();
    exports.RuntimeMetadataResolver = RuntimeMetadataResolver;
    function flattenDirectives(view, platformDirectives) {
        var directives = [];
        if (lang_1.isPresent(platformDirectives)) {
            flattenArray(platformDirectives, directives);
        }
        if (lang_1.isPresent(view.directives)) {
            flattenArray(view.directives, directives);
        }
        return directives;
    }
    function flattenPipes(view, platformPipes) {
        var pipes = [];
        if (lang_1.isPresent(platformPipes)) {
            flattenArray(platformPipes, pipes);
        }
        if (lang_1.isPresent(view.pipes)) {
            flattenArray(view.pipes, pipes);
        }
        return pipes;
    }
    function flattenArray(tree, out) {
        for (var i = 0; i < tree.length; i++) {
            var item = di_1.resolveForwardRef(tree[i]);
            if (lang_1.isArray(item)) {
                flattenArray(item, out);
            } else {
                out.push(item);
            }
        }
    }
    function isValidType(value) {
        return lang_1.isPresent(value) && value instanceof lang_1.Type;
    }
    function calcModuleUrl(type, cmpMetadata) {
        var moduleId = cmpMetadata.moduleId;
        if (lang_1.isPresent(moduleId)) {
            var scheme = url_resolver_1.getUrlScheme(moduleId);
            return lang_1.isPresent(scheme) && scheme.length > 0 ? moduleId : "package:" + moduleId + util_1.MODULE_SUFFIX;
        } else {
            return reflection_1.reflector.importUri(type);
        }
    }
});
System.registerDynamic('angular2/src/compiler/util.js', ['angular2/src/facade/lang.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var CAMEL_CASE_REGEXP = /([A-Z])/g;
    var DASH_CASE_REGEXP = /-([a-z])/g;
    var SINGLE_QUOTE_ESCAPE_STRING_RE = /'|\\|\n|\r|\$/g;
    var DOUBLE_QUOTE_ESCAPE_STRING_RE = /"|\\|\n|\r|\$/g;
    exports.MODULE_SUFFIX = lang_1.IS_DART ? '.dart' : '.js';
    exports.CONST_VAR = lang_1.IS_DART ? 'const' : 'var';
    function camelCaseToDashCase(input) {
        return lang_1.StringWrapper.replaceAllMapped(input, CAMEL_CASE_REGEXP, function (m) {
            return '-' + m[1].toLowerCase();
        });
    }
    exports.camelCaseToDashCase = camelCaseToDashCase;
    function dashCaseToCamelCase(input) {
        return lang_1.StringWrapper.replaceAllMapped(input, DASH_CASE_REGEXP, function (m) {
            return m[1].toUpperCase();
        });
    }
    exports.dashCaseToCamelCase = dashCaseToCamelCase;
    function escapeSingleQuoteString(input) {
        if (lang_1.isBlank(input)) {
            return null;
        }
        return "'" + escapeString(input, SINGLE_QUOTE_ESCAPE_STRING_RE) + "'";
    }
    exports.escapeSingleQuoteString = escapeSingleQuoteString;
    function escapeDoubleQuoteString(input) {
        if (lang_1.isBlank(input)) {
            return null;
        }
        return "\"" + escapeString(input, DOUBLE_QUOTE_ESCAPE_STRING_RE) + "\"";
    }
    exports.escapeDoubleQuoteString = escapeDoubleQuoteString;
    function escapeString(input, re) {
        return lang_1.StringWrapper.replaceAllMapped(input, re, function (match) {
            if (match[0] == '$') {
                return lang_1.IS_DART ? '\\$' : '$';
            } else if (match[0] == '\n') {
                return '\\n';
            } else if (match[0] == '\r') {
                return '\\r';
            } else {
                return "\\" + match[0];
            }
        });
    }
    function codeGenExportVariable(name) {
        if (lang_1.IS_DART) {
            return "const " + name + " = ";
        } else {
            return "var " + name + " = exports['" + name + "'] = ";
        }
    }
    exports.codeGenExportVariable = codeGenExportVariable;
    function codeGenConstConstructorCall(name) {
        if (lang_1.IS_DART) {
            return "const " + name;
        } else {
            return "new " + name;
        }
    }
    exports.codeGenConstConstructorCall = codeGenConstConstructorCall;
    function codeGenValueFn(params, value, fnName) {
        if (fnName === void 0) {
            fnName = '';
        }
        if (lang_1.IS_DART) {
            return codeGenFnHeader(params, fnName) + " => " + value;
        } else {
            return codeGenFnHeader(params, fnName) + " { return " + value + "; }";
        }
    }
    exports.codeGenValueFn = codeGenValueFn;
    function codeGenFnHeader(params, fnName) {
        if (fnName === void 0) {
            fnName = '';
        }
        if (lang_1.IS_DART) {
            return fnName + "(" + params.join(',') + ")";
        } else {
            return "function " + fnName + "(" + params.join(',') + ")";
        }
    }
    exports.codeGenFnHeader = codeGenFnHeader;
    function codeGenToString(expr) {
        if (lang_1.IS_DART) {
            return "'${" + expr + "}'";
        } else {
            // JS automatically converts to string...
            return expr;
        }
    }
    exports.codeGenToString = codeGenToString;
    function splitAtColon(input, defaultValues) {
        var parts = lang_1.StringWrapper.split(input.trim(), /\s*:\s*/g);
        if (parts.length > 1) {
            return parts;
        } else {
            return defaultValues;
        }
    }
    exports.splitAtColon = splitAtColon;
    var Statement = function () {
        function Statement(statement) {
            this.statement = statement;
        }
        return Statement;
    }();
    exports.Statement = Statement;
    var Expression = function () {
        function Expression(expression, isArray) {
            if (isArray === void 0) {
                isArray = false;
            }
            this.expression = expression;
            this.isArray = isArray;
        }
        return Expression;
    }();
    exports.Expression = Expression;
    function escapeValue(value) {
        if (value instanceof Expression) {
            return value.expression;
        } else if (lang_1.isString(value)) {
            return escapeSingleQuoteString(value);
        } else if (lang_1.isBlank(value)) {
            return 'null';
        } else {
            return "" + value;
        }
    }
    exports.escapeValue = escapeValue;
    function codeGenArray(data) {
        return "[" + data.map(escapeValue).join(',') + "]";
    }
    exports.codeGenArray = codeGenArray;
    function codeGenFlatArray(values) {
        var result = '([';
        var isFirstArrayEntry = true;
        var concatFn = lang_1.IS_DART ? '.addAll' : 'concat';
        for (var i = 0; i < values.length; i++) {
            var value = values[i];
            if (value instanceof Expression && value.isArray) {
                result += "])." + concatFn + "(" + value.expression + ")." + concatFn + "([";
                isFirstArrayEntry = true;
            } else {
                if (!isFirstArrayEntry) {
                    result += ',';
                }
                isFirstArrayEntry = false;
                result += escapeValue(value);
            }
        }
        result += '])';
        return result;
    }
    exports.codeGenFlatArray = codeGenFlatArray;
    function codeGenStringMap(keyValueArray) {
        return "{" + keyValueArray.map(codeGenKeyValue).join(',') + "}";
    }
    exports.codeGenStringMap = codeGenStringMap;
    function codeGenKeyValue(keyValue) {
        return escapeValue(keyValue[0]) + ":" + escapeValue(keyValue[1]);
    }
    function addAll(source, target) {
        for (var i = 0; i < source.length; i++) {
            target.push(source[i]);
        }
    }
    exports.addAll = addAll;
    function flattenArray(source, target) {
        if (lang_1.isPresent(source)) {
            for (var i = 0; i < source.length; i++) {
                var item = source[i];
                if (lang_1.isArray(item)) {
                    flattenArray(item, target);
                } else {
                    target.push(item);
                }
            }
        }
        return target;
    }
    exports.flattenArray = flattenArray;
});
System.registerDynamic("angular2/src/compiler/template_compiler.js", ["angular2/src/facade/lang.js", "angular2/src/facade/exceptions.js", "angular2/src/facade/collection.js", "angular2/src/facade/async.js", "angular2/src/compiler/directive_metadata.js", "angular2/src/compiler/template_ast.js", "angular2/src/core/di.js", "angular2/src/compiler/source_module.js", "angular2/src/compiler/change_detector_compiler.js", "angular2/src/compiler/style_compiler.js", "angular2/src/compiler/view_compiler.js", "angular2/src/compiler/proto_view_compiler.js", "angular2/src/compiler/template_parser.js", "angular2/src/compiler/template_normalizer.js", "angular2/src/compiler/runtime_metadata.js", "angular2/src/core/linker/view.js", "angular2/src/core/change_detection/change_detection.js", "angular2/src/core/linker/resolved_metadata_cache.js", "angular2/src/compiler/util.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var exceptions_1 = $__require("angular2/src/facade/exceptions.js");
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var async_1 = $__require("angular2/src/facade/async.js");
    var directive_metadata_1 = $__require("angular2/src/compiler/directive_metadata.js");
    var template_ast_1 = $__require("angular2/src/compiler/template_ast.js");
    var di_1 = $__require("angular2/src/core/di.js");
    var source_module_1 = $__require("angular2/src/compiler/source_module.js");
    var change_detector_compiler_1 = $__require("angular2/src/compiler/change_detector_compiler.js");
    var style_compiler_1 = $__require("angular2/src/compiler/style_compiler.js");
    var view_compiler_1 = $__require("angular2/src/compiler/view_compiler.js");
    var proto_view_compiler_1 = $__require("angular2/src/compiler/proto_view_compiler.js");
    var template_parser_1 = $__require("angular2/src/compiler/template_parser.js");
    var template_normalizer_1 = $__require("angular2/src/compiler/template_normalizer.js");
    var runtime_metadata_1 = $__require("angular2/src/compiler/runtime_metadata.js");
    var view_1 = $__require("angular2/src/core/linker/view.js");
    var change_detection_1 = $__require("angular2/src/core/change_detection/change_detection.js");
    var resolved_metadata_cache_1 = $__require("angular2/src/core/linker/resolved_metadata_cache.js");
    var util_1 = $__require("angular2/src/compiler/util.js");
    exports.METADATA_CACHE_MODULE_REF = source_module_1.moduleRef('package:angular2/src/core/linker/resolved_metadata_cache' + util_1.MODULE_SUFFIX);
    /**
     * An internal module of the Angular compiler that begins with component types,
     * extracts templates, and eventually produces a compiled version of the component
     * ready for linking into an application.
     */
    var TemplateCompiler = function () {
        function TemplateCompiler(_runtimeMetadataResolver, _templateNormalizer, _templateParser, _styleCompiler, _cdCompiler, _protoViewCompiler, _viewCompiler, _resolvedMetadataCache, _genConfig) {
            this._runtimeMetadataResolver = _runtimeMetadataResolver;
            this._templateNormalizer = _templateNormalizer;
            this._templateParser = _templateParser;
            this._styleCompiler = _styleCompiler;
            this._cdCompiler = _cdCompiler;
            this._protoViewCompiler = _protoViewCompiler;
            this._viewCompiler = _viewCompiler;
            this._resolvedMetadataCache = _resolvedMetadataCache;
            this._genConfig = _genConfig;
            this._hostCacheKeys = new Map();
            this._compiledTemplateCache = new Map();
            this._compiledTemplateDone = new Map();
        }
        TemplateCompiler.prototype.normalizeDirectiveMetadata = function (directive) {
            if (!directive.isComponent) {
                // For non components there is nothing to be normalized yet.
                return async_1.PromiseWrapper.resolve(directive);
            }
            return this._templateNormalizer.normalizeTemplate(directive.type, directive.template).then(function (normalizedTemplate) {
                return new directive_metadata_1.CompileDirectiveMetadata({
                    type: directive.type,
                    isComponent: directive.isComponent,
                    dynamicLoadable: directive.dynamicLoadable,
                    selector: directive.selector,
                    exportAs: directive.exportAs,
                    changeDetection: directive.changeDetection,
                    inputs: directive.inputs,
                    outputs: directive.outputs,
                    hostListeners: directive.hostListeners,
                    hostProperties: directive.hostProperties,
                    hostAttributes: directive.hostAttributes,
                    lifecycleHooks: directive.lifecycleHooks,
                    providers: directive.providers,
                    viewProviders: directive.viewProviders,
                    queries: directive.queries,
                    viewQueries: directive.viewQueries,
                    template: normalizedTemplate
                });
            });
        };
        TemplateCompiler.prototype.compileHostComponentRuntime = function (type) {
            var compMeta = this._runtimeMetadataResolver.getDirectiveMetadata(type);
            var hostCacheKey = this._hostCacheKeys.get(type);
            if (lang_1.isBlank(hostCacheKey)) {
                hostCacheKey = new Object();
                this._hostCacheKeys.set(type, hostCacheKey);
                assertComponent(compMeta);
                var hostMeta = directive_metadata_1.createHostComponentMeta(compMeta.type, compMeta.selector);
                this._compileComponentRuntime(hostCacheKey, hostMeta, [compMeta], [], []);
            }
            return this._compiledTemplateDone.get(hostCacheKey).then(function (compiledTemplate) {
                return new view_1.HostViewFactory(compMeta.selector, compiledTemplate.viewFactory);
            });
        };
        TemplateCompiler.prototype.clearCache = function () {
            this._styleCompiler.clearCache();
            this._compiledTemplateCache.clear();
            this._compiledTemplateDone.clear();
            this._hostCacheKeys.clear();
        };
        TemplateCompiler.prototype.compileTemplatesCodeGen = function (components) {
            var _this = this;
            if (components.length === 0) {
                throw new exceptions_1.BaseException('No components given');
            }
            var declarations = [];
            components.forEach(function (componentWithDirs) {
                var compMeta = componentWithDirs.component;
                assertComponent(compMeta);
                _this._compileComponentCodeGen(compMeta, componentWithDirs.directives, componentWithDirs.pipes, declarations);
                if (compMeta.dynamicLoadable) {
                    var hostMeta = directive_metadata_1.createHostComponentMeta(compMeta.type, compMeta.selector);
                    var viewFactoryExpression = _this._compileComponentCodeGen(hostMeta, [compMeta], [], declarations);
                    var constructionKeyword = lang_1.IS_DART ? 'const' : 'new';
                    var compiledTemplateExpr = constructionKeyword + " " + proto_view_compiler_1.APP_VIEW_MODULE_REF + "HostViewFactory('" + compMeta.selector + "'," + viewFactoryExpression + ")";
                    var varName = codeGenHostViewFactoryName(compMeta.type);
                    declarations.push("" + util_1.codeGenExportVariable(varName) + compiledTemplateExpr + ";");
                }
            });
            var moduleUrl = components[0].component.type.moduleUrl;
            return new source_module_1.SourceModule("" + templateModuleUrl(moduleUrl), declarations.join('\n'));
        };
        TemplateCompiler.prototype.compileStylesheetCodeGen = function (stylesheetUrl, cssText) {
            return this._styleCompiler.compileStylesheetCodeGen(stylesheetUrl, cssText);
        };
        TemplateCompiler.prototype._compileComponentRuntime = function (cacheKey, compMeta, viewDirectives, pipes, compilingComponentsPath) {
            var _this = this;
            var uniqViewDirectives = removeDuplicates(viewDirectives);
            var uniqViewPipes = removeDuplicates(pipes);
            var compiledTemplate = this._compiledTemplateCache.get(cacheKey);
            var done = this._compiledTemplateDone.get(cacheKey);
            if (lang_1.isBlank(compiledTemplate)) {
                compiledTemplate = new CompiledTemplate();
                this._compiledTemplateCache.set(cacheKey, compiledTemplate);
                done = async_1.PromiseWrapper.all([this._styleCompiler.compileComponentRuntime(compMeta.template)].concat(uniqViewDirectives.map(function (dirMeta) {
                    return _this.normalizeDirectiveMetadata(dirMeta);
                }))).then(function (stylesAndNormalizedViewDirMetas) {
                    var normalizedViewDirMetas = stylesAndNormalizedViewDirMetas.slice(1);
                    var styles = stylesAndNormalizedViewDirMetas[0];
                    var parsedTemplate = _this._templateParser.parse(compMeta.template.template, normalizedViewDirMetas, uniqViewPipes, compMeta.type.name);
                    var childPromises = [];
                    var usedDirectives = DirectiveCollector.findUsedDirectives(parsedTemplate);
                    usedDirectives.components.forEach(function (component) {
                        return _this._compileNestedComponentRuntime(component, compilingComponentsPath, childPromises);
                    });
                    return async_1.PromiseWrapper.all(childPromises).then(function (_) {
                        var filteredPipes = filterPipes(parsedTemplate, uniqViewPipes);
                        compiledTemplate.init(_this._createViewFactoryRuntime(compMeta, parsedTemplate, usedDirectives.directives, styles, filteredPipes));
                        return compiledTemplate;
                    });
                });
                this._compiledTemplateDone.set(cacheKey, done);
            }
            return compiledTemplate;
        };
        TemplateCompiler.prototype._compileNestedComponentRuntime = function (childComponentDir, parentCompilingComponentsPath, childPromises) {
            var compilingComponentsPath = collection_1.ListWrapper.clone(parentCompilingComponentsPath);
            var childCacheKey = childComponentDir.type.runtime;
            var childViewDirectives = this._runtimeMetadataResolver.getViewDirectivesMetadata(childComponentDir.type.runtime);
            var childViewPipes = this._runtimeMetadataResolver.getViewPipesMetadata(childComponentDir.type.runtime);
            var childIsRecursive = collection_1.ListWrapper.contains(compilingComponentsPath, childCacheKey);
            compilingComponentsPath.push(childCacheKey);
            this._compileComponentRuntime(childCacheKey, childComponentDir, childViewDirectives, childViewPipes, compilingComponentsPath);
            if (!childIsRecursive) {
                // Only wait for a child if it is not a cycle
                childPromises.push(this._compiledTemplateDone.get(childCacheKey));
            }
        };
        TemplateCompiler.prototype._createViewFactoryRuntime = function (compMeta, parsedTemplate, directives, styles, pipes) {
            var _this = this;
            if (lang_1.IS_DART || !this._genConfig.useJit) {
                var changeDetectorFactories = this._cdCompiler.compileComponentRuntime(compMeta.type, compMeta.changeDetection, parsedTemplate);
                var protoViews = this._protoViewCompiler.compileProtoViewRuntime(this._resolvedMetadataCache, compMeta, parsedTemplate, pipes);
                return this._viewCompiler.compileComponentRuntime(compMeta, parsedTemplate, styles, protoViews.protoViews, changeDetectorFactories, function (compMeta) {
                    return _this._getNestedComponentViewFactory(compMeta);
                });
            } else {
                var declarations = [];
                var viewFactoryExpr = this._createViewFactoryCodeGen('resolvedMetadataCache', compMeta, new source_module_1.SourceExpression([], 'styles'), parsedTemplate, pipes, declarations);
                var vars = { 'exports': {}, 'styles': styles, 'resolvedMetadataCache': this._resolvedMetadataCache };
                directives.forEach(function (dirMeta) {
                    vars[dirMeta.type.name] = dirMeta.type.runtime;
                    if (dirMeta.isComponent && dirMeta.type.runtime !== compMeta.type.runtime) {
                        vars["viewFactory_" + dirMeta.type.name + "0"] = _this._getNestedComponentViewFactory(dirMeta);
                    }
                });
                pipes.forEach(function (pipeMeta) {
                    return vars[pipeMeta.type.name] = pipeMeta.type.runtime;
                });
                var declarationsWithoutImports = source_module_1.SourceModule.getSourceWithoutImports(declarations.join('\n'));
                return lang_1.evalExpression("viewFactory_" + compMeta.type.name, viewFactoryExpr, declarationsWithoutImports, mergeStringMaps([vars, change_detector_compiler_1.CHANGE_DETECTION_JIT_IMPORTS, proto_view_compiler_1.PROTO_VIEW_JIT_IMPORTS, view_compiler_1.VIEW_JIT_IMPORTS]));
            }
        };
        TemplateCompiler.prototype._getNestedComponentViewFactory = function (compMeta) {
            return this._compiledTemplateCache.get(compMeta.type.runtime).viewFactory;
        };
        TemplateCompiler.prototype._compileComponentCodeGen = function (compMeta, directives, pipes, targetDeclarations) {
            var uniqueDirectives = removeDuplicates(directives);
            var uniqPipes = removeDuplicates(pipes);
            var styleExpr = this._styleCompiler.compileComponentCodeGen(compMeta.template);
            var parsedTemplate = this._templateParser.parse(compMeta.template.template, uniqueDirectives, uniqPipes, compMeta.type.name);
            var filteredPipes = filterPipes(parsedTemplate, uniqPipes);
            return this._createViewFactoryCodeGen(exports.METADATA_CACHE_MODULE_REF + "CODEGEN_RESOLVED_METADATA_CACHE", compMeta, styleExpr, parsedTemplate, filteredPipes, targetDeclarations);
        };
        TemplateCompiler.prototype._createViewFactoryCodeGen = function (resolvedMetadataCacheExpr, compMeta, styleExpr, parsedTemplate, pipes, targetDeclarations) {
            var changeDetectorsExprs = this._cdCompiler.compileComponentCodeGen(compMeta.type, compMeta.changeDetection, parsedTemplate);
            var protoViewExprs = this._protoViewCompiler.compileProtoViewCodeGen(new util_1.Expression(resolvedMetadataCacheExpr), compMeta, parsedTemplate, pipes);
            var viewFactoryExpr = this._viewCompiler.compileComponentCodeGen(compMeta, parsedTemplate, styleExpr, protoViewExprs.protoViews, changeDetectorsExprs, codeGenComponentViewFactoryName);
            util_1.addAll(changeDetectorsExprs.declarations, targetDeclarations);
            util_1.addAll(protoViewExprs.declarations, targetDeclarations);
            util_1.addAll(viewFactoryExpr.declarations, targetDeclarations);
            return viewFactoryExpr.expression;
        };
        TemplateCompiler = __decorate([di_1.Injectable(), __metadata('design:paramtypes', [runtime_metadata_1.RuntimeMetadataResolver, template_normalizer_1.TemplateNormalizer, template_parser_1.TemplateParser, style_compiler_1.StyleCompiler, change_detector_compiler_1.ChangeDetectionCompiler, proto_view_compiler_1.ProtoViewCompiler, view_compiler_1.ViewCompiler, resolved_metadata_cache_1.ResolvedMetadataCache, change_detection_1.ChangeDetectorGenConfig])], TemplateCompiler);
        return TemplateCompiler;
    }();
    exports.TemplateCompiler = TemplateCompiler;
    var NormalizedComponentWithViewDirectives = function () {
        function NormalizedComponentWithViewDirectives(component, directives, pipes) {
            this.component = component;
            this.directives = directives;
            this.pipes = pipes;
        }
        return NormalizedComponentWithViewDirectives;
    }();
    exports.NormalizedComponentWithViewDirectives = NormalizedComponentWithViewDirectives;
    var CompiledTemplate = function () {
        function CompiledTemplate() {
            this.viewFactory = null;
        }
        CompiledTemplate.prototype.init = function (viewFactory) {
            this.viewFactory = viewFactory;
        };
        return CompiledTemplate;
    }();
    function assertComponent(meta) {
        if (!meta.isComponent) {
            throw new exceptions_1.BaseException("Could not compile '" + meta.type.name + "' because it is not a component.");
        }
    }
    function templateModuleUrl(moduleUrl) {
        var urlWithoutSuffix = moduleUrl.substring(0, moduleUrl.length - util_1.MODULE_SUFFIX.length);
        return urlWithoutSuffix + ".template" + util_1.MODULE_SUFFIX;
    }
    function codeGenHostViewFactoryName(type) {
        return "hostViewFactory_" + type.name;
    }
    function codeGenComponentViewFactoryName(nestedCompType) {
        return source_module_1.moduleRef(templateModuleUrl(nestedCompType.type.moduleUrl)) + "viewFactory_" + nestedCompType.type.name + "0";
    }
    function mergeStringMaps(maps) {
        var result = {};
        maps.forEach(function (map) {
            collection_1.StringMapWrapper.forEach(map, function (value, key) {
                result[key] = value;
            });
        });
        return result;
    }
    function removeDuplicates(items) {
        var res = [];
        items.forEach(function (item) {
            var hasMatch = res.filter(function (r) {
                return r.type.name == item.type.name && r.type.moduleUrl == item.type.moduleUrl && r.type.runtime == item.type.runtime;
            }).length > 0;
            if (!hasMatch) {
                res.push(item);
            }
        });
        return res;
    }
    var DirectiveCollector = function () {
        function DirectiveCollector() {
            this.directives = [];
            this.components = [];
        }
        DirectiveCollector.findUsedDirectives = function (parsedTemplate) {
            var collector = new DirectiveCollector();
            template_ast_1.templateVisitAll(collector, parsedTemplate);
            return collector;
        };
        DirectiveCollector.prototype.visitBoundText = function (ast, context) {
            return null;
        };
        DirectiveCollector.prototype.visitText = function (ast, context) {
            return null;
        };
        DirectiveCollector.prototype.visitNgContent = function (ast, context) {
            return null;
        };
        DirectiveCollector.prototype.visitElement = function (ast, context) {
            template_ast_1.templateVisitAll(this, ast.directives);
            template_ast_1.templateVisitAll(this, ast.children);
            return null;
        };
        DirectiveCollector.prototype.visitEmbeddedTemplate = function (ast, context) {
            template_ast_1.templateVisitAll(this, ast.directives);
            template_ast_1.templateVisitAll(this, ast.children);
            return null;
        };
        DirectiveCollector.prototype.visitVariable = function (ast, ctx) {
            return null;
        };
        DirectiveCollector.prototype.visitAttr = function (ast, attrNameAndValues) {
            return null;
        };
        DirectiveCollector.prototype.visitDirective = function (ast, ctx) {
            if (ast.directive.isComponent) {
                this.components.push(ast.directive);
            }
            this.directives.push(ast.directive);
            return null;
        };
        DirectiveCollector.prototype.visitEvent = function (ast, eventTargetAndNames) {
            return null;
        };
        DirectiveCollector.prototype.visitDirectiveProperty = function (ast, context) {
            return null;
        };
        DirectiveCollector.prototype.visitElementProperty = function (ast, context) {
            return null;
        };
        return DirectiveCollector;
    }();
    function filterPipes(template, allPipes) {
        var visitor = new PipeVisitor();
        template_ast_1.templateVisitAll(visitor, template);
        return allPipes.filter(function (pipeMeta) {
            return collection_1.SetWrapper.has(visitor.collector.pipes, pipeMeta.name);
        });
    }
    var PipeVisitor = function () {
        function PipeVisitor() {
            this.collector = new template_parser_1.PipeCollector();
        }
        PipeVisitor.prototype.visitBoundText = function (ast, context) {
            ast.value.visit(this.collector);
            return null;
        };
        PipeVisitor.prototype.visitText = function (ast, context) {
            return null;
        };
        PipeVisitor.prototype.visitNgContent = function (ast, context) {
            return null;
        };
        PipeVisitor.prototype.visitElement = function (ast, context) {
            template_ast_1.templateVisitAll(this, ast.inputs);
            template_ast_1.templateVisitAll(this, ast.outputs);
            template_ast_1.templateVisitAll(this, ast.directives);
            template_ast_1.templateVisitAll(this, ast.children);
            return null;
        };
        PipeVisitor.prototype.visitEmbeddedTemplate = function (ast, context) {
            template_ast_1.templateVisitAll(this, ast.outputs);
            template_ast_1.templateVisitAll(this, ast.directives);
            template_ast_1.templateVisitAll(this, ast.children);
            return null;
        };
        PipeVisitor.prototype.visitVariable = function (ast, ctx) {
            return null;
        };
        PipeVisitor.prototype.visitAttr = function (ast, attrNameAndValues) {
            return null;
        };
        PipeVisitor.prototype.visitDirective = function (ast, ctx) {
            template_ast_1.templateVisitAll(this, ast.inputs);
            template_ast_1.templateVisitAll(this, ast.hostEvents);
            template_ast_1.templateVisitAll(this, ast.hostProperties);
            return null;
        };
        PipeVisitor.prototype.visitEvent = function (ast, eventTargetAndNames) {
            ast.handler.visit(this.collector);
            return null;
        };
        PipeVisitor.prototype.visitDirectiveProperty = function (ast, context) {
            ast.value.visit(this.collector);
            return null;
        };
        PipeVisitor.prototype.visitElementProperty = function (ast, context) {
            ast.value.visit(this.collector);
            return null;
        };
        return PipeVisitor;
    }();
});
System.registerDynamic("angular2/src/compiler/runtime_compiler.js", ["angular2/src/core/linker/compiler.js", "angular2/src/core/linker/view_ref.js", "angular2/src/compiler/template_compiler.js", "angular2/src/core/di.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var compiler_1 = $__require("angular2/src/core/linker/compiler.js");
    var view_ref_1 = $__require("angular2/src/core/linker/view_ref.js");
    var template_compiler_1 = $__require("angular2/src/compiler/template_compiler.js");
    var di_1 = $__require("angular2/src/core/di.js");
    var RuntimeCompiler = function (_super) {
        __extends(RuntimeCompiler, _super);
        function RuntimeCompiler() {
            _super.apply(this, arguments);
        }
        return RuntimeCompiler;
    }(compiler_1.Compiler);
    exports.RuntimeCompiler = RuntimeCompiler;
    var RuntimeCompiler_ = function (_super) {
        __extends(RuntimeCompiler_, _super);
        function RuntimeCompiler_(_templateCompiler) {
            _super.call(this);
            this._templateCompiler = _templateCompiler;
        }
        RuntimeCompiler_.prototype.compileInHost = function (componentType) {
            return this._templateCompiler.compileHostComponentRuntime(componentType).then(function (hostViewFactory) {
                return new view_ref_1.HostViewFactoryRef_(hostViewFactory);
            });
        };
        RuntimeCompiler_.prototype.clearCache = function () {
            _super.prototype.clearCache.call(this);
            this._templateCompiler.clearCache();
        };
        RuntimeCompiler_ = __decorate([di_1.Injectable(), __metadata('design:paramtypes', [template_compiler_1.TemplateCompiler])], RuntimeCompiler_);
        return RuntimeCompiler_;
    }(compiler_1.Compiler_);
    exports.RuntimeCompiler_ = RuntimeCompiler_;
});
System.registerDynamic('angular2/src/compiler/html_tags.js', ['angular2/src/facade/lang.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    // see http://www.w3.org/TR/html51/syntax.html#named-character-references
    // see https://html.spec.whatwg.org/multipage/entities.json
    // This list is not exhaustive to keep the compiler footprint low.
    // The `&#123;` / `&#x1ab;` syntax should be used when the named character reference does not exist.
    exports.NAMED_ENTITIES = lang_1.CONST_EXPR({
        'Aacute': '\u00C1',
        'aacute': '\u00E1',
        'Acirc': '\u00C2',
        'acirc': '\u00E2',
        'acute': '\u00B4',
        'AElig': '\u00C6',
        'aelig': '\u00E6',
        'Agrave': '\u00C0',
        'agrave': '\u00E0',
        'alefsym': '\u2135',
        'Alpha': '\u0391',
        'alpha': '\u03B1',
        'amp': '&',
        'and': '\u2227',
        'ang': '\u2220',
        'apos': '\u0027',
        'Aring': '\u00C5',
        'aring': '\u00E5',
        'asymp': '\u2248',
        'Atilde': '\u00C3',
        'atilde': '\u00E3',
        'Auml': '\u00C4',
        'auml': '\u00E4',
        'bdquo': '\u201E',
        'Beta': '\u0392',
        'beta': '\u03B2',
        'brvbar': '\u00A6',
        'bull': '\u2022',
        'cap': '\u2229',
        'Ccedil': '\u00C7',
        'ccedil': '\u00E7',
        'cedil': '\u00B8',
        'cent': '\u00A2',
        'Chi': '\u03A7',
        'chi': '\u03C7',
        'circ': '\u02C6',
        'clubs': '\u2663',
        'cong': '\u2245',
        'copy': '\u00A9',
        'crarr': '\u21B5',
        'cup': '\u222A',
        'curren': '\u00A4',
        'dagger': '\u2020',
        'Dagger': '\u2021',
        'darr': '\u2193',
        'dArr': '\u21D3',
        'deg': '\u00B0',
        'Delta': '\u0394',
        'delta': '\u03B4',
        'diams': '\u2666',
        'divide': '\u00F7',
        'Eacute': '\u00C9',
        'eacute': '\u00E9',
        'Ecirc': '\u00CA',
        'ecirc': '\u00EA',
        'Egrave': '\u00C8',
        'egrave': '\u00E8',
        'empty': '\u2205',
        'emsp': '\u2003',
        'ensp': '\u2002',
        'Epsilon': '\u0395',
        'epsilon': '\u03B5',
        'equiv': '\u2261',
        'Eta': '\u0397',
        'eta': '\u03B7',
        'ETH': '\u00D0',
        'eth': '\u00F0',
        'Euml': '\u00CB',
        'euml': '\u00EB',
        'euro': '\u20AC',
        'exist': '\u2203',
        'fnof': '\u0192',
        'forall': '\u2200',
        'frac12': '\u00BD',
        'frac14': '\u00BC',
        'frac34': '\u00BE',
        'frasl': '\u2044',
        'Gamma': '\u0393',
        'gamma': '\u03B3',
        'ge': '\u2265',
        'gt': '>',
        'harr': '\u2194',
        'hArr': '\u21D4',
        'hearts': '\u2665',
        'hellip': '\u2026',
        'Iacute': '\u00CD',
        'iacute': '\u00ED',
        'Icirc': '\u00CE',
        'icirc': '\u00EE',
        'iexcl': '\u00A1',
        'Igrave': '\u00CC',
        'igrave': '\u00EC',
        'image': '\u2111',
        'infin': '\u221E',
        'int': '\u222B',
        'Iota': '\u0399',
        'iota': '\u03B9',
        'iquest': '\u00BF',
        'isin': '\u2208',
        'Iuml': '\u00CF',
        'iuml': '\u00EF',
        'Kappa': '\u039A',
        'kappa': '\u03BA',
        'Lambda': '\u039B',
        'lambda': '\u03BB',
        'lang': '\u27E8',
        'laquo': '\u00AB',
        'larr': '\u2190',
        'lArr': '\u21D0',
        'lceil': '\u2308',
        'ldquo': '\u201C',
        'le': '\u2264',
        'lfloor': '\u230A',
        'lowast': '\u2217',
        'loz': '\u25CA',
        'lrm': '\u200E',
        'lsaquo': '\u2039',
        'lsquo': '\u2018',
        'lt': '<',
        'macr': '\u00AF',
        'mdash': '\u2014',
        'micro': '\u00B5',
        'middot': '\u00B7',
        'minus': '\u2212',
        'Mu': '\u039C',
        'mu': '\u03BC',
        'nabla': '\u2207',
        'nbsp': '\u00A0',
        'ndash': '\u2013',
        'ne': '\u2260',
        'ni': '\u220B',
        'not': '\u00AC',
        'notin': '\u2209',
        'nsub': '\u2284',
        'Ntilde': '\u00D1',
        'ntilde': '\u00F1',
        'Nu': '\u039D',
        'nu': '\u03BD',
        'Oacute': '\u00D3',
        'oacute': '\u00F3',
        'Ocirc': '\u00D4',
        'ocirc': '\u00F4',
        'OElig': '\u0152',
        'oelig': '\u0153',
        'Ograve': '\u00D2',
        'ograve': '\u00F2',
        'oline': '\u203E',
        'Omega': '\u03A9',
        'omega': '\u03C9',
        'Omicron': '\u039F',
        'omicron': '\u03BF',
        'oplus': '\u2295',
        'or': '\u2228',
        'ordf': '\u00AA',
        'ordm': '\u00BA',
        'Oslash': '\u00D8',
        'oslash': '\u00F8',
        'Otilde': '\u00D5',
        'otilde': '\u00F5',
        'otimes': '\u2297',
        'Ouml': '\u00D6',
        'ouml': '\u00F6',
        'para': '\u00B6',
        'permil': '\u2030',
        'perp': '\u22A5',
        'Phi': '\u03A6',
        'phi': '\u03C6',
        'Pi': '\u03A0',
        'pi': '\u03C0',
        'piv': '\u03D6',
        'plusmn': '\u00B1',
        'pound': '\u00A3',
        'prime': '\u2032',
        'Prime': '\u2033',
        'prod': '\u220F',
        'prop': '\u221D',
        'Psi': '\u03A8',
        'psi': '\u03C8',
        'quot': '\u0022',
        'radic': '\u221A',
        'rang': '\u27E9',
        'raquo': '\u00BB',
        'rarr': '\u2192',
        'rArr': '\u21D2',
        'rceil': '\u2309',
        'rdquo': '\u201D',
        'real': '\u211C',
        'reg': '\u00AE',
        'rfloor': '\u230B',
        'Rho': '\u03A1',
        'rho': '\u03C1',
        'rlm': '\u200F',
        'rsaquo': '\u203A',
        'rsquo': '\u2019',
        'sbquo': '\u201A',
        'Scaron': '\u0160',
        'scaron': '\u0161',
        'sdot': '\u22C5',
        'sect': '\u00A7',
        'shy': '\u00AD',
        'Sigma': '\u03A3',
        'sigma': '\u03C3',
        'sigmaf': '\u03C2',
        'sim': '\u223C',
        'spades': '\u2660',
        'sub': '\u2282',
        'sube': '\u2286',
        'sum': '\u2211',
        'sup': '\u2283',
        'sup1': '\u00B9',
        'sup2': '\u00B2',
        'sup3': '\u00B3',
        'supe': '\u2287',
        'szlig': '\u00DF',
        'Tau': '\u03A4',
        'tau': '\u03C4',
        'there4': '\u2234',
        'Theta': '\u0398',
        'theta': '\u03B8',
        'thetasym': '\u03D1',
        'thinsp': '\u2009',
        'THORN': '\u00DE',
        'thorn': '\u00FE',
        'tilde': '\u02DC',
        'times': '\u00D7',
        'trade': '\u2122',
        'Uacute': '\u00DA',
        'uacute': '\u00FA',
        'uarr': '\u2191',
        'uArr': '\u21D1',
        'Ucirc': '\u00DB',
        'ucirc': '\u00FB',
        'Ugrave': '\u00D9',
        'ugrave': '\u00F9',
        'uml': '\u00A8',
        'upsih': '\u03D2',
        'Upsilon': '\u03A5',
        'upsilon': '\u03C5',
        'Uuml': '\u00DC',
        'uuml': '\u00FC',
        'weierp': '\u2118',
        'Xi': '\u039E',
        'xi': '\u03BE',
        'Yacute': '\u00DD',
        'yacute': '\u00FD',
        'yen': '\u00A5',
        'yuml': '\u00FF',
        'Yuml': '\u0178',
        'Zeta': '\u0396',
        'zeta': '\u03B6',
        'zwj': '\u200D',
        'zwnj': '\u200C'
    });
    (function (HtmlTagContentType) {
        HtmlTagContentType[HtmlTagContentType["RAW_TEXT"] = 0] = "RAW_TEXT";
        HtmlTagContentType[HtmlTagContentType["ESCAPABLE_RAW_TEXT"] = 1] = "ESCAPABLE_RAW_TEXT";
        HtmlTagContentType[HtmlTagContentType["PARSABLE_DATA"] = 2] = "PARSABLE_DATA";
    })(exports.HtmlTagContentType || (exports.HtmlTagContentType = {}));
    var HtmlTagContentType = exports.HtmlTagContentType;
    var HtmlTagDefinition = function () {
        function HtmlTagDefinition(_a) {
            var _this = this;
            var _b = _a === void 0 ? {} : _a,
                closedByChildren = _b.closedByChildren,
                requiredParents = _b.requiredParents,
                implicitNamespacePrefix = _b.implicitNamespacePrefix,
                contentType = _b.contentType,
                closedByParent = _b.closedByParent,
                isVoid = _b.isVoid,
                ignoreFirstLf = _b.ignoreFirstLf;
            this.closedByChildren = {};
            this.closedByParent = false;
            if (lang_1.isPresent(closedByChildren) && closedByChildren.length > 0) {
                closedByChildren.forEach(function (tagName) {
                    return _this.closedByChildren[tagName] = true;
                });
            }
            this.isVoid = lang_1.normalizeBool(isVoid);
            this.closedByParent = lang_1.normalizeBool(closedByParent) || this.isVoid;
            if (lang_1.isPresent(requiredParents) && requiredParents.length > 0) {
                this.requiredParents = {};
                this.parentToAdd = requiredParents[0];
                requiredParents.forEach(function (tagName) {
                    return _this.requiredParents[tagName] = true;
                });
            }
            this.implicitNamespacePrefix = implicitNamespacePrefix;
            this.contentType = lang_1.isPresent(contentType) ? contentType : HtmlTagContentType.PARSABLE_DATA;
            this.ignoreFirstLf = lang_1.normalizeBool(ignoreFirstLf);
        }
        HtmlTagDefinition.prototype.requireExtraParent = function (currentParent) {
            if (lang_1.isBlank(this.requiredParents)) {
                return false;
            }
            if (lang_1.isBlank(currentParent)) {
                return true;
            }
            var lcParent = currentParent.toLowerCase();
            return this.requiredParents[lcParent] != true && lcParent != 'template';
        };
        HtmlTagDefinition.prototype.isClosedByChild = function (name) {
            return this.isVoid || lang_1.normalizeBool(this.closedByChildren[name.toLowerCase()]);
        };
        return HtmlTagDefinition;
    }();
    exports.HtmlTagDefinition = HtmlTagDefinition;
    // see http://www.w3.org/TR/html51/syntax.html#optional-tags
    // This implementation does not fully conform to the HTML5 spec.
    var TAG_DEFINITIONS = {
        'base': new HtmlTagDefinition({ isVoid: true }),
        'meta': new HtmlTagDefinition({ isVoid: true }),
        'area': new HtmlTagDefinition({ isVoid: true }),
        'embed': new HtmlTagDefinition({ isVoid: true }),
        'link': new HtmlTagDefinition({ isVoid: true }),
        'img': new HtmlTagDefinition({ isVoid: true }),
        'input': new HtmlTagDefinition({ isVoid: true }),
        'param': new HtmlTagDefinition({ isVoid: true }),
        'hr': new HtmlTagDefinition({ isVoid: true }),
        'br': new HtmlTagDefinition({ isVoid: true }),
        'source': new HtmlTagDefinition({ isVoid: true }),
        'track': new HtmlTagDefinition({ isVoid: true }),
        'wbr': new HtmlTagDefinition({ isVoid: true }),
        'p': new HtmlTagDefinition({
            closedByChildren: ['address', 'article', 'aside', 'blockquote', 'div', 'dl', 'fieldset', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'main', 'nav', 'ol', 'p', 'pre', 'section', 'table', 'ul'],
            closedByParent: true
        }),
        'thead': new HtmlTagDefinition({ closedByChildren: ['tbody', 'tfoot'] }),
        'tbody': new HtmlTagDefinition({ closedByChildren: ['tbody', 'tfoot'], closedByParent: true }),
        'tfoot': new HtmlTagDefinition({ closedByChildren: ['tbody'], closedByParent: true }),
        'tr': new HtmlTagDefinition({
            closedByChildren: ['tr'],
            requiredParents: ['tbody', 'tfoot', 'thead'],
            closedByParent: true
        }),
        'td': new HtmlTagDefinition({ closedByChildren: ['td', 'th'], closedByParent: true }),
        'th': new HtmlTagDefinition({ closedByChildren: ['td', 'th'], closedByParent: true }),
        'col': new HtmlTagDefinition({ requiredParents: ['colgroup'], isVoid: true }),
        'svg': new HtmlTagDefinition({ implicitNamespacePrefix: 'svg' }),
        'math': new HtmlTagDefinition({ implicitNamespacePrefix: 'math' }),
        'li': new HtmlTagDefinition({ closedByChildren: ['li'], closedByParent: true }),
        'dt': new HtmlTagDefinition({ closedByChildren: ['dt', 'dd'] }),
        'dd': new HtmlTagDefinition({ closedByChildren: ['dt', 'dd'], closedByParent: true }),
        'rb': new HtmlTagDefinition({ closedByChildren: ['rb', 'rt', 'rtc', 'rp'], closedByParent: true }),
        'rt': new HtmlTagDefinition({ closedByChildren: ['rb', 'rt', 'rtc', 'rp'], closedByParent: true }),
        'rtc': new HtmlTagDefinition({ closedByChildren: ['rb', 'rtc', 'rp'], closedByParent: true }),
        'rp': new HtmlTagDefinition({ closedByChildren: ['rb', 'rt', 'rtc', 'rp'], closedByParent: true }),
        'optgroup': new HtmlTagDefinition({ closedByChildren: ['optgroup'], closedByParent: true }),
        'option': new HtmlTagDefinition({ closedByChildren: ['option', 'optgroup'], closedByParent: true }),
        'pre': new HtmlTagDefinition({ ignoreFirstLf: true }),
        'listing': new HtmlTagDefinition({ ignoreFirstLf: true }),
        'style': new HtmlTagDefinition({ contentType: HtmlTagContentType.RAW_TEXT }),
        'script': new HtmlTagDefinition({ contentType: HtmlTagContentType.RAW_TEXT }),
        'title': new HtmlTagDefinition({ contentType: HtmlTagContentType.ESCAPABLE_RAW_TEXT }),
        'textarea': new HtmlTagDefinition({ contentType: HtmlTagContentType.ESCAPABLE_RAW_TEXT, ignoreFirstLf: true })
    };
    var DEFAULT_TAG_DEFINITION = new HtmlTagDefinition();
    function getHtmlTagDefinition(tagName) {
        var result = TAG_DEFINITIONS[tagName.toLowerCase()];
        return lang_1.isPresent(result) ? result : DEFAULT_TAG_DEFINITION;
    }
    exports.getHtmlTagDefinition = getHtmlTagDefinition;
    var NS_PREFIX_RE = /^@([^:]+):(.+)/g;
    function splitNsName(elementName) {
        if (elementName[0] != '@') {
            return [null, elementName];
        }
        var match = lang_1.RegExpWrapper.firstMatch(NS_PREFIX_RE, elementName);
        return [match[1], match[2]];
    }
    exports.splitNsName = splitNsName;
    function getNsPrefix(elementName) {
        return splitNsName(elementName)[0];
    }
    exports.getNsPrefix = getNsPrefix;
    function mergeNsAndName(prefix, localName) {
        return lang_1.isPresent(prefix) ? "@" + prefix + ":" + localName : localName;
    }
    exports.mergeNsAndName = mergeNsAndName;
});
System.registerDynamic("angular2/src/compiler/schema/element_schema_registry.js", [], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var ElementSchemaRegistry = function () {
        function ElementSchemaRegistry() {}
        ElementSchemaRegistry.prototype.hasProperty = function (tagName, propName) {
            return true;
        };
        ElementSchemaRegistry.prototype.getMappedPropName = function (propName) {
            return propName;
        };
        return ElementSchemaRegistry;
    }();
    exports.ElementSchemaRegistry = ElementSchemaRegistry;
});
System.registerDynamic("angular2/src/compiler/schema/dom_element_schema_registry.js", ["angular2/src/core/di.js", "angular2/src/facade/lang.js", "angular2/src/facade/collection.js", "angular2/src/platform/dom/dom_adapter.js", "angular2/src/compiler/html_tags.js", "angular2/src/compiler/schema/element_schema_registry.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var di_1 = $__require("angular2/src/core/di.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var dom_adapter_1 = $__require("angular2/src/platform/dom/dom_adapter.js");
    var html_tags_1 = $__require("angular2/src/compiler/html_tags.js");
    var element_schema_registry_1 = $__require("angular2/src/compiler/schema/element_schema_registry.js");
    var NAMESPACE_URIS = lang_1.CONST_EXPR({ 'xlink': 'http://www.w3.org/1999/xlink', 'svg': 'http://www.w3.org/2000/svg' });
    var DomElementSchemaRegistry = function (_super) {
        __extends(DomElementSchemaRegistry, _super);
        function DomElementSchemaRegistry() {
            _super.apply(this, arguments);
            this._protoElements = new Map();
        }
        DomElementSchemaRegistry.prototype._getProtoElement = function (tagName) {
            var element = this._protoElements.get(tagName);
            if (lang_1.isBlank(element)) {
                var nsAndName = html_tags_1.splitNsName(tagName);
                element = lang_1.isPresent(nsAndName[0]) ? dom_adapter_1.DOM.createElementNS(NAMESPACE_URIS[nsAndName[0]], nsAndName[1]) : dom_adapter_1.DOM.createElement(nsAndName[1]);
                this._protoElements.set(tagName, element);
            }
            return element;
        };
        DomElementSchemaRegistry.prototype.hasProperty = function (tagName, propName) {
            if (tagName.indexOf('-') !== -1) {
                // can't tell now as we don't know which properties a custom element will get
                // once it is instantiated
                return true;
            } else {
                var elm = this._getProtoElement(tagName);
                return dom_adapter_1.DOM.hasProperty(elm, propName);
            }
        };
        DomElementSchemaRegistry.prototype.getMappedPropName = function (propName) {
            var mappedPropName = collection_1.StringMapWrapper.get(dom_adapter_1.DOM.attrToPropMap, propName);
            return lang_1.isPresent(mappedPropName) ? mappedPropName : propName;
        };
        DomElementSchemaRegistry = __decorate([di_1.Injectable(), __metadata('design:paramtypes', [])], DomElementSchemaRegistry);
        return DomElementSchemaRegistry;
    }(element_schema_registry_1.ElementSchemaRegistry);
    exports.DomElementSchemaRegistry = DomElementSchemaRegistry;
});
System.registerDynamic("angular2/src/compiler/url_resolver.js", ["angular2/src/core/di.js", "angular2/src/facade/lang.js", "angular2/src/core/application_tokens.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var __param = this && this.__param || function (paramIndex, decorator) {
        return function (target, key) {
            decorator(target, key, paramIndex);
        };
    };
    var di_1 = $__require("angular2/src/core/di.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var application_tokens_1 = $__require("angular2/src/core/application_tokens.js");
    var di_2 = $__require("angular2/src/core/di.js");
    /**
     * Create a {@link UrlResolver} with no package prefix.
     */
    function createWithoutPackagePrefix() {
        return new UrlResolver();
    }
    exports.createWithoutPackagePrefix = createWithoutPackagePrefix;
    /**
     * A default provider for {@link PACKAGE_ROOT_URL} that maps to '/'.
     */
    exports.DEFAULT_PACKAGE_URL_PROVIDER = new di_2.Provider(application_tokens_1.PACKAGE_ROOT_URL, { useValue: "/" });
    /**
     * Used by the {@link Compiler} when resolving HTML and CSS template URLs.
     *
     * This class can be overridden by the application developer to create custom behavior.
     *
     * See {@link Compiler}
     *
     * ## Example
     *
     * {@example compiler/ts/url_resolver/url_resolver.ts region='url_resolver'}
     */
    var UrlResolver = function () {
        function UrlResolver(packagePrefix) {
            if (packagePrefix === void 0) {
                packagePrefix = null;
            }
            if (lang_1.isPresent(packagePrefix)) {
                this._packagePrefix = lang_1.StringWrapper.stripRight(packagePrefix, "/") + "/";
            }
        }
        /**
         * Resolves the `url` given the `baseUrl`:
         * - when the `url` is null, the `baseUrl` is returned,
         * - if `url` is relative ('path/to/here', './path/to/here'), the resolved url is a combination of
         * `baseUrl` and `url`,
         * - if `url` is absolute (it has a scheme: 'http://', 'https://' or start with '/'), the `url` is
         * returned as is (ignoring the `baseUrl`)
         *
         * @param {string} baseUrl
         * @param {string} url
         * @returns {string} the resolved URL
         */
        UrlResolver.prototype.resolve = function (baseUrl, url) {
            var resolvedUrl = url;
            if (lang_1.isPresent(baseUrl) && baseUrl.length > 0) {
                resolvedUrl = _resolveUrl(baseUrl, resolvedUrl);
            }
            if (lang_1.isPresent(this._packagePrefix) && getUrlScheme(resolvedUrl) == "package") {
                resolvedUrl = resolvedUrl.replace("package:", this._packagePrefix);
            }
            return resolvedUrl;
        };
        UrlResolver = __decorate([di_1.Injectable(), __param(0, di_1.Inject(application_tokens_1.PACKAGE_ROOT_URL)), __metadata('design:paramtypes', [String])], UrlResolver);
        return UrlResolver;
    }();
    exports.UrlResolver = UrlResolver;
    /**
     * Extract the scheme of a URL.
     */
    function getUrlScheme(url) {
        var match = _split(url);
        return match && match[_ComponentIndex.Scheme] || "";
    }
    exports.getUrlScheme = getUrlScheme;
    // The code below is adapted from Traceur:
    // https://github.com/google/traceur-compiler/blob/9511c1dafa972bf0de1202a8a863bad02f0f95a8/src/runtime/url.js
    /**
     * Builds a URI string from already-encoded parts.
     *
     * No encoding is performed.  Any component may be omitted as either null or
     * undefined.
     *
     * @param {?string=} opt_scheme The scheme such as 'http'.
     * @param {?string=} opt_userInfo The user name before the '@'.
     * @param {?string=} opt_domain The domain such as 'www.google.com', already
     *     URI-encoded.
     * @param {(string|null)=} opt_port The port number.
     * @param {?string=} opt_path The path, already URI-encoded.  If it is not
     *     empty, it must begin with a slash.
     * @param {?string=} opt_queryData The URI-encoded query data.
     * @param {?string=} opt_fragment The URI-encoded fragment identifier.
     * @return {string} The fully combined URI.
     */
    function _buildFromEncodedParts(opt_scheme, opt_userInfo, opt_domain, opt_port, opt_path, opt_queryData, opt_fragment) {
        var out = [];
        if (lang_1.isPresent(opt_scheme)) {
            out.push(opt_scheme + ':');
        }
        if (lang_1.isPresent(opt_domain)) {
            out.push('//');
            if (lang_1.isPresent(opt_userInfo)) {
                out.push(opt_userInfo + '@');
            }
            out.push(opt_domain);
            if (lang_1.isPresent(opt_port)) {
                out.push(':' + opt_port);
            }
        }
        if (lang_1.isPresent(opt_path)) {
            out.push(opt_path);
        }
        if (lang_1.isPresent(opt_queryData)) {
            out.push('?' + opt_queryData);
        }
        if (lang_1.isPresent(opt_fragment)) {
            out.push('#' + opt_fragment);
        }
        return out.join('');
    }
    /**
     * A regular expression for breaking a URI into its component parts.
     *
     * {@link http://www.gbiv.com/protocols/uri/rfc/rfc3986.html#RFC2234} says
     * As the "first-match-wins" algorithm is identical to the "greedy"
     * disambiguation method used by POSIX regular expressions, it is natural and
     * commonplace to use a regular expression for parsing the potential five
     * components of a URI reference.
     *
     * The following line is the regular expression for breaking-down a
     * well-formed URI reference into its components.
     *
     * <pre>
     * ^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?
     *  12            3  4          5       6  7        8 9
     * </pre>
     *
     * The numbers in the second line above are only to assist readability; they
     * indicate the reference points for each subexpression (i.e., each paired
     * parenthesis). We refer to the value matched for subexpression <n> as $<n>.
     * For example, matching the above expression to
     * <pre>
     *     http://www.ics.uci.edu/pub/ietf/uri/#Related
     * </pre>
     * results in the following subexpression matches:
     * <pre>
     *    $1 = http:
     *    $2 = http
     *    $3 = //www.ics.uci.edu
     *    $4 = www.ics.uci.edu
     *    $5 = /pub/ietf/uri/
     *    $6 = <undefined>
     *    $7 = <undefined>
     *    $8 = #Related
     *    $9 = Related
     * </pre>
     * where <undefined> indicates that the component is not present, as is the
     * case for the query component in the above example. Therefore, we can
     * determine the value of the five components as
     * <pre>
     *    scheme    = $2
     *    authority = $4
     *    path      = $5
     *    query     = $7
     *    fragment  = $9
     * </pre>
     *
     * The regular expression has been modified slightly to expose the
     * userInfo, domain, and port separately from the authority.
     * The modified version yields
     * <pre>
     *    $1 = http              scheme
     *    $2 = <undefined>       userInfo -\
     *    $3 = www.ics.uci.edu   domain     | authority
     *    $4 = <undefined>       port     -/
     *    $5 = /pub/ietf/uri/    path
     *    $6 = <undefined>       query without ?
     *    $7 = Related           fragment without #
     * </pre>
     * @type {!RegExp}
     * @internal
     */
    var _splitRe = lang_1.RegExpWrapper.create('^' + '(?:' + '([^:/?#.]+)' +
    // used by other URL parts such as :,
    // ?, /, #, and .
    ':)?' + '(?://' + '(?:([^/?#]*)@)?' + '([\\w\\d\\-\\u0100-\\uffff.%]*)' +
    // digits, dashes, dots, percent
    // escapes, and unicode characters.
    '(?::([0-9]+))?' + ')?' + '([^?#]+)?' + '(?:\\?([^#]*))?' + '(?:#(.*))?' + '$');
    /**
     * The index of each URI component in the return value of goog.uri.utils.split.
     * @enum {number}
     */
    var _ComponentIndex;
    (function (_ComponentIndex) {
        _ComponentIndex[_ComponentIndex["Scheme"] = 1] = "Scheme";
        _ComponentIndex[_ComponentIndex["UserInfo"] = 2] = "UserInfo";
        _ComponentIndex[_ComponentIndex["Domain"] = 3] = "Domain";
        _ComponentIndex[_ComponentIndex["Port"] = 4] = "Port";
        _ComponentIndex[_ComponentIndex["Path"] = 5] = "Path";
        _ComponentIndex[_ComponentIndex["QueryData"] = 6] = "QueryData";
        _ComponentIndex[_ComponentIndex["Fragment"] = 7] = "Fragment";
    })(_ComponentIndex || (_ComponentIndex = {}));
    /**
     * Splits a URI into its component parts.
     *
     * Each component can be accessed via the component indices; for example:
     * <pre>
     * goog.uri.utils.split(someStr)[goog.uri.utils.CompontentIndex.QUERY_DATA];
     * </pre>
     *
     * @param {string} uri The URI string to examine.
     * @return {!Array.<string|undefined>} Each component still URI-encoded.
     *     Each component that is present will contain the encoded value, whereas
     *     components that are not present will be undefined or empty, depending
     *     on the browser's regular expression implementation.  Never null, since
     *     arbitrary strings may still look like path names.
     */
    function _split(uri) {
        return lang_1.RegExpWrapper.firstMatch(_splitRe, uri);
    }
    /**
      * Removes dot segments in given path component, as described in
      * RFC 3986, section 5.2.4.
      *
      * @param {string} path A non-empty path component.
      * @return {string} Path component with removed dot segments.
      */
    function _removeDotSegments(path) {
        if (path == '/') return '/';
        var leadingSlash = path[0] == '/' ? '/' : '';
        var trailingSlash = path[path.length - 1] === '/' ? '/' : '';
        var segments = path.split('/');
        var out = [];
        var up = 0;
        for (var pos = 0; pos < segments.length; pos++) {
            var segment = segments[pos];
            switch (segment) {
                case '':
                case '.':
                    break;
                case '..':
                    if (out.length > 0) {
                        out.pop();
                    } else {
                        up++;
                    }
                    break;
                default:
                    out.push(segment);
            }
        }
        if (leadingSlash == '') {
            while (up-- > 0) {
                out.unshift('..');
            }
            if (out.length === 0) out.push('.');
        }
        return leadingSlash + out.join('/') + trailingSlash;
    }
    /**
     * Takes an array of the parts from split and canonicalizes the path part
     * and then joins all the parts.
     * @param {Array.<string?>} parts
     * @return {string}
     */
    function _joinAndCanonicalizePath(parts) {
        var path = parts[_ComponentIndex.Path];
        path = lang_1.isBlank(path) ? '' : _removeDotSegments(path);
        parts[_ComponentIndex.Path] = path;
        return _buildFromEncodedParts(parts[_ComponentIndex.Scheme], parts[_ComponentIndex.UserInfo], parts[_ComponentIndex.Domain], parts[_ComponentIndex.Port], path, parts[_ComponentIndex.QueryData], parts[_ComponentIndex.Fragment]);
    }
    /**
     * Resolves a URL.
     * @param {string} base The URL acting as the base URL.
     * @param {string} to The URL to resolve.
     * @return {string}
     */
    function _resolveUrl(base, url) {
        var parts = _split(encodeURI(url));
        var baseParts = _split(base);
        if (lang_1.isPresent(parts[_ComponentIndex.Scheme])) {
            return _joinAndCanonicalizePath(parts);
        } else {
            parts[_ComponentIndex.Scheme] = baseParts[_ComponentIndex.Scheme];
        }
        for (var i = _ComponentIndex.Scheme; i <= _ComponentIndex.Port; i++) {
            if (lang_1.isBlank(parts[i])) {
                parts[i] = baseParts[i];
            }
        }
        if (parts[_ComponentIndex.Path][0] == '/') {
            return _joinAndCanonicalizePath(parts);
        }
        var path = baseParts[_ComponentIndex.Path];
        if (lang_1.isBlank(path)) path = '/';
        var index = path.lastIndexOf('/');
        path = path.substring(0, index + 1) + parts[_ComponentIndex.Path];
        parts[_ComponentIndex.Path] = path;
        return _joinAndCanonicalizePath(parts);
    }
});
System.registerDynamic("angular2/src/compiler/compiler.js", ["angular2/src/compiler/runtime_compiler.js", "angular2/src/compiler/template_compiler.js", "angular2/src/compiler/directive_metadata.js", "angular2/src/compiler/source_module.js", "angular2/src/core/platform_directives_and_pipes.js", "angular2/src/compiler/template_ast.js", "angular2/src/compiler/template_parser.js", "angular2/src/facade/lang.js", "angular2/src/core/di.js", "angular2/src/compiler/html_parser.js", "angular2/src/compiler/template_normalizer.js", "angular2/src/compiler/runtime_metadata.js", "angular2/src/compiler/change_detector_compiler.js", "angular2/src/compiler/style_compiler.js", "angular2/src/compiler/view_compiler.js", "angular2/src/compiler/proto_view_compiler.js", "angular2/src/compiler/template_compiler.js", "angular2/src/core/change_detection/change_detection.js", "angular2/src/core/linker/compiler.js", "angular2/src/compiler/runtime_compiler.js", "angular2/src/compiler/schema/element_schema_registry.js", "angular2/src/compiler/schema/dom_element_schema_registry.js", "angular2/src/compiler/url_resolver.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    function __export(m) {
        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }
    var runtime_compiler_1 = $__require("angular2/src/compiler/runtime_compiler.js");
    var template_compiler_1 = $__require("angular2/src/compiler/template_compiler.js");
    exports.TemplateCompiler = template_compiler_1.TemplateCompiler;
    var directive_metadata_1 = $__require("angular2/src/compiler/directive_metadata.js");
    exports.CompileDirectiveMetadata = directive_metadata_1.CompileDirectiveMetadata;
    exports.CompileTypeMetadata = directive_metadata_1.CompileTypeMetadata;
    exports.CompileTemplateMetadata = directive_metadata_1.CompileTemplateMetadata;
    var source_module_1 = $__require("angular2/src/compiler/source_module.js");
    exports.SourceModule = source_module_1.SourceModule;
    exports.SourceWithImports = source_module_1.SourceWithImports;
    var platform_directives_and_pipes_1 = $__require("angular2/src/core/platform_directives_and_pipes.js");
    exports.PLATFORM_DIRECTIVES = platform_directives_and_pipes_1.PLATFORM_DIRECTIVES;
    exports.PLATFORM_PIPES = platform_directives_and_pipes_1.PLATFORM_PIPES;
    __export($__require("angular2/src/compiler/template_ast.js"));
    var template_parser_1 = $__require("angular2/src/compiler/template_parser.js");
    exports.TEMPLATE_TRANSFORMS = template_parser_1.TEMPLATE_TRANSFORMS;
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var di_1 = $__require("angular2/src/core/di.js");
    var template_parser_2 = $__require("angular2/src/compiler/template_parser.js");
    var html_parser_1 = $__require("angular2/src/compiler/html_parser.js");
    var template_normalizer_1 = $__require("angular2/src/compiler/template_normalizer.js");
    var runtime_metadata_1 = $__require("angular2/src/compiler/runtime_metadata.js");
    var change_detector_compiler_1 = $__require("angular2/src/compiler/change_detector_compiler.js");
    var style_compiler_1 = $__require("angular2/src/compiler/style_compiler.js");
    var view_compiler_1 = $__require("angular2/src/compiler/view_compiler.js");
    var proto_view_compiler_1 = $__require("angular2/src/compiler/proto_view_compiler.js");
    var template_compiler_2 = $__require("angular2/src/compiler/template_compiler.js");
    var change_detection_1 = $__require("angular2/src/core/change_detection/change_detection.js");
    var compiler_1 = $__require("angular2/src/core/linker/compiler.js");
    var runtime_compiler_2 = $__require("angular2/src/compiler/runtime_compiler.js");
    var element_schema_registry_1 = $__require("angular2/src/compiler/schema/element_schema_registry.js");
    var dom_element_schema_registry_1 = $__require("angular2/src/compiler/schema/dom_element_schema_registry.js");
    var url_resolver_1 = $__require("angular2/src/compiler/url_resolver.js");
    var change_detection_2 = $__require("angular2/src/core/change_detection/change_detection.js");
    function _createChangeDetectorGenConfig() {
        return new change_detection_1.ChangeDetectorGenConfig(lang_1.assertionsEnabled(), false, true);
    }
    /**
     * A set of providers that provide `RuntimeCompiler` and its dependencies to use for
     * template compilation.
     */
    exports.COMPILER_PROVIDERS = lang_1.CONST_EXPR([change_detection_2.Lexer, change_detection_2.Parser, html_parser_1.HtmlParser, template_parser_2.TemplateParser, template_normalizer_1.TemplateNormalizer, runtime_metadata_1.RuntimeMetadataResolver, url_resolver_1.DEFAULT_PACKAGE_URL_PROVIDER, style_compiler_1.StyleCompiler, proto_view_compiler_1.ProtoViewCompiler, view_compiler_1.ViewCompiler, change_detector_compiler_1.ChangeDetectionCompiler, new di_1.Provider(change_detection_1.ChangeDetectorGenConfig, { useFactory: _createChangeDetectorGenConfig, deps: [] }), template_compiler_2.TemplateCompiler, new di_1.Provider(runtime_compiler_2.RuntimeCompiler, { useClass: runtime_compiler_1.RuntimeCompiler_ }), new di_1.Provider(compiler_1.Compiler, { useExisting: runtime_compiler_2.RuntimeCompiler }), dom_element_schema_registry_1.DomElementSchemaRegistry, new di_1.Provider(element_schema_registry_1.ElementSchemaRegistry, { useExisting: dom_element_schema_registry_1.DomElementSchemaRegistry }), url_resolver_1.UrlResolver]);
});
System.registerDynamic('angular2/compiler.js', ['angular2/src/compiler/url_resolver.js', 'angular2/src/compiler/xhr.js', 'angular2/src/compiler/compiler.js'], true, function ($__require, exports, module) {
  'use strict';"use strict";

  var global = this || self,
      GLOBAL = global;
  function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
  /**
   * @module
   * @description
   * Starting point to import all compiler APIs.
   */
  __export($__require('angular2/src/compiler/url_resolver.js'));
  __export($__require('angular2/src/compiler/xhr.js'));
  __export($__require('angular2/src/compiler/compiler.js'));
});
System.registerDynamic("angular2/src/compiler/xhr.js", [], true, function ($__require, exports, module) {
    'use strict';"use strict";
    // TODO: vsavkin rename it into TemplateLoader
    /**
     * An interface for retrieving documents by URL that the compiler uses
     * to load templates.
     */

    var global = this || self,
        GLOBAL = global;
    var XHR = function () {
        function XHR() {}
        XHR.prototype.get = function (url) {
            return null;
        };
        return XHR;
    }();
    exports.XHR = XHR;
});
System.registerDynamic('angular2/src/platform/browser/xhr_impl.js', ['angular2/src/facade/promise.js', 'angular2/src/facade/lang.js', 'angular2/src/compiler/xhr.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var promise_1 = $__require('angular2/src/facade/promise.js');
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var xhr_1 = $__require('angular2/src/compiler/xhr.js');
    var XHRImpl = function (_super) {
        __extends(XHRImpl, _super);
        function XHRImpl() {
            _super.apply(this, arguments);
        }
        XHRImpl.prototype.get = function (url) {
            var completer = promise_1.PromiseWrapper.completer();
            var xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.responseType = 'text';
            xhr.onload = function () {
                // responseText is the old-school way of retrieving response (supported by IE8 & 9)
                // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
                var response = lang_1.isPresent(xhr.response) ? xhr.response : xhr.responseText;
                // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
                var status = xhr.status === 1223 ? 204 : xhr.status;
                // fix status code when it is 0 (0 status is undocumented).
                // Occurs when accessing file resources or on Android 4.1 stock browser
                // while retrieving files from application cache.
                if (status === 0) {
                    status = response ? 200 : 0;
                }
                if (200 <= status && status <= 300) {
                    completer.resolve(response);
                } else {
                    completer.reject("Failed to load " + url, null);
                }
            };
            xhr.onerror = function () {
                completer.reject("Failed to load " + url, null);
            };
            xhr.send();
            return completer.promise;
        };
        return XHRImpl;
    }(xhr_1.XHR);
    exports.XHRImpl = XHRImpl;
});
System.registerDynamic('angular2/platform/browser.js', ['angular2/src/core/angular_entrypoint.js', 'angular2/src/platform/browser_common.js', 'angular2/src/facade/lang.js', 'angular2/compiler.js', 'angular2/core.js', 'angular2/src/core/reflection/reflection_capabilities.js', 'angular2/src/platform/browser/xhr_impl.js', 'angular2/src/core/di.js'], true, function ($__require, exports, module) {
  'use strict';"use strict";

  var global = this || self,
      GLOBAL = global;
  var angular_entrypoint_1 = $__require('angular2/src/core/angular_entrypoint.js');
  exports.AngularEntrypoint = angular_entrypoint_1.AngularEntrypoint;
  var browser_common_1 = $__require('angular2/src/platform/browser_common.js');
  exports.BROWSER_PROVIDERS = browser_common_1.BROWSER_PROVIDERS;
  exports.CACHED_TEMPLATE_PROVIDER = browser_common_1.CACHED_TEMPLATE_PROVIDER;
  exports.ELEMENT_PROBE_PROVIDERS = browser_common_1.ELEMENT_PROBE_PROVIDERS;
  exports.ELEMENT_PROBE_PROVIDERS_PROD_MODE = browser_common_1.ELEMENT_PROBE_PROVIDERS_PROD_MODE;
  exports.inspectNativeElement = browser_common_1.inspectNativeElement;
  exports.BrowserDomAdapter = browser_common_1.BrowserDomAdapter;
  exports.By = browser_common_1.By;
  exports.Title = browser_common_1.Title;
  exports.DOCUMENT = browser_common_1.DOCUMENT;
  exports.enableDebugTools = browser_common_1.enableDebugTools;
  exports.disableDebugTools = browser_common_1.disableDebugTools;
  var lang_1 = $__require('angular2/src/facade/lang.js');
  var browser_common_2 = $__require('angular2/src/platform/browser_common.js');
  var compiler_1 = $__require('angular2/compiler.js');
  var core_1 = $__require('angular2/core.js');
  var reflection_capabilities_1 = $__require('angular2/src/core/reflection/reflection_capabilities.js');
  var xhr_impl_1 = $__require('angular2/src/platform/browser/xhr_impl.js');
  var compiler_2 = $__require('angular2/compiler.js');
  var di_1 = $__require('angular2/src/core/di.js');
  /**
   * An array of providers that should be passed into `application()` when bootstrapping a component.
   */
  exports.BROWSER_APP_PROVIDERS = lang_1.CONST_EXPR([browser_common_2.BROWSER_APP_COMMON_PROVIDERS, compiler_1.COMPILER_PROVIDERS, new di_1.Provider(compiler_2.XHR, { useClass: xhr_impl_1.XHRImpl })]);
  /**
   * Bootstrapping for Angular applications.
   *
   * You instantiate an Angular application by explicitly specifying a component to use
   * as the root component for your application via the `bootstrap()` method.
   *
   * ## Simple Example
   *
   * Assuming this `index.html`:
   *
   * ```html
   * <html>
   *   <!-- load Angular script tags here. -->
   *   <body>
   *     <my-app>loading...</my-app>
   *   </body>
   * </html>
   * ```
   *
   * An application is bootstrapped inside an existing browser DOM, typically `index.html`.
   * Unlike Angular 1, Angular 2 does not compile/process providers in `index.html`. This is
   * mainly for security reasons, as well as architectural changes in Angular 2. This means
   * that `index.html` can safely be processed using server-side technologies such as
   * providers. Bindings can thus use double-curly `{{ syntax }}` without collision from
   * Angular 2 component double-curly `{{ syntax }}`.
   *
   * We can use this script code:
   *
   * {@example core/ts/bootstrap/bootstrap.ts region='bootstrap'}
   *
   * When the app developer invokes `bootstrap()` with the root component `MyApp` as its
   * argument, Angular performs the following tasks:
   *
   *  1. It uses the component's `selector` property to locate the DOM element which needs
   *     to be upgraded into the angular component.
   *  2. It creates a new child injector (from the platform injector). Optionally, you can
   *     also override the injector configuration for an app by invoking `bootstrap` with the
   *     `componentInjectableBindings` argument.
   *  3. It creates a new `Zone` and connects it to the angular application's change detection
   *     domain instance.
   *  4. It creates an emulated or shadow DOM on the selected component's host element and loads the
   *     template into it.
   *  5. It instantiates the specified component.
   *  6. Finally, Angular performs change detection to apply the initial data providers for the
   *     application.
   *
   *
   * ## Bootstrapping Multiple Applications
   *
   * When working within a browser window, there are many singleton resources: cookies, title,
   * location, and others. Angular services that represent these resources must likewise be
   * shared across all Angular applications that occupy the same browser window. For this
   * reason, Angular creates exactly one global platform object which stores all shared
   * services, and each angular application injector has the platform injector as its parent.
   *
   * Each application has its own private injector as well. When there are multiple
   * applications on a page, Angular treats each application injector's services as private
   * to that application.
   *
   * ## API
   *
   * - `appComponentType`: The root component which should act as the application. This is
   *   a reference to a `Type` which is annotated with `@Component(...)`.
   * - `customProviders`: An additional set of providers that can be added to the
   *   app injector to override default injection behavior.
   *
   * Returns a `Promise` of {@link ComponentRef}.
   */
  function bootstrap(appComponentType, customProviders) {
    core_1.reflector.reflectionCapabilities = new reflection_capabilities_1.ReflectionCapabilities();
    var appProviders = lang_1.isPresent(customProviders) ? [exports.BROWSER_APP_PROVIDERS, customProviders] : exports.BROWSER_APP_PROVIDERS;
    return core_1.platform(browser_common_2.BROWSER_PROVIDERS).application(appProviders).bootstrap(appComponentType);
  }
  exports.bootstrap = bootstrap;
});
System.register("ict-external-client/app/views/account_view.js", ["angular2/core.js", "angular2/router.js", "ags-client/ags-client.js", "ict-external-client/gen/views.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, router_1, ags_client_1, ags_client_2, ags_client_3, ags_client_4, ags_client_5, ags_client_6, views_1, AccountView;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (router_1_1) {
            router_1 = router_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
            ags_client_5 = ags_client_1_1;
            ags_client_6 = ags_client_1_1;
        }, function (views_1_1) {
            views_1 = views_1_1;
        }],
        execute: function () {
            AccountView = /** @class */function (_super) {
                __extends(AccountView, _super);
                function AccountView(navigationService, router, _alertService, _translationService, _authenticationService) {
                    var _this = _super.call(this, navigationService, router) || this;
                    _this._alertService = _alertService;
                    _this._translationService = _translationService;
                    _this._authenticationService = _authenticationService;
                    return _this;
                }
                AccountView.prototype.init = function () {
                    var _this = this;
                    this.changePasswordForm.first.passwordChanged.subscribe(function () {
                        _this._alertService.info(_this._translationService.translate(ags_client_6.TranslationConstants.INFO_SAVED));
                    });
                };
                Object.defineProperty(AccountView.prototype, "login", {
                    get: function () {
                        return this._authenticationService.userSession.login;
                    },
                    enumerable: false,
                    configurable: true
                });
                __decorate([core_1.ViewChildren(ags_client_5.AccountFormComponent), __metadata("design:type", core_1.QueryList)], AccountView.prototype, "accountForm", void 0);
                __decorate([core_1.ViewChildren(ags_client_4.ChangePasswordFormComponent), __metadata("design:type", core_1.QueryList)], AccountView.prototype, "changePasswordForm", void 0);
                AccountView = __decorate([core_1.Component({
                    selector: 'account-view',
                    directives: [ags_client_1.AGS_DIRECTIVES, ags_client_4.ChangePasswordFormComponent, ags_client_5.AccountFormComponent],
                    pipes: [ags_client_1.AGS_PIPES],
                    templateUrl: 'ict-external-client/app/views/account_view.html'
                }), router_1.CanActivate(function () {
                    return ags_client_1.AuthenticationService.checkViewSecurity(views_1.VIEW_SECURITY[views_1.ACCOUNT_VIEW]);
                }), __metadata("design:paramtypes", [ags_client_2.NavigationService, router_1.Router, ags_client_2.AlertService, ags_client_2.TranslationService, ags_client_1.AuthenticationService])], AccountView);
                return AccountView;
            }(ags_client_3.AbstractView);
            exports_1("AccountView", AccountView);
        }
    };
});

System.register("ict-external-client/gen/viewsearch/earning_declare_search_criteria.js", ["ags-client/ags-client.js", "ict-core-client/ict-core-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var ags_client_1, ags_client_2, ags_client_3, ict_core_client_1, EarningDeclareSearchCriteria;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
        }, function (ict_core_client_1_1) {
            ict_core_client_1 = ict_core_client_1_1;
        }],
        execute: function () {
            EarningDeclareSearchCriteria = /** @class */function (_super) {
                __extends(EarningDeclareSearchCriteria, _super);
                function EarningDeclareSearchCriteria(from, size) {
                    return _super.call(this, from, size) || this;
                }
                EarningDeclareSearchCriteria.create = function (from, size) {
                    return new EarningDeclareSearchCriteria(from, size);
                };
                Object.defineProperty(EarningDeclareSearchCriteria.prototype, "entryDate", {
                    get: function () {
                        return this._entryDate;
                    },
                    set: function (entryDate) {
                        if (this._entryDate !== entryDate) {
                            this._entryDate = entryDate;
                            this.attributeChanged(EarningDeclareSearchCriteria.ENTRY_DATE, entryDate);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(EarningDeclareSearchCriteria.prototype, "declareUser", {
                    get: function () {
                        return this._declareUser;
                    },
                    set: function (declareUser) {
                        if (this._declareUser !== declareUser) {
                            this._declareUser = declareUser;
                            this.attributeChanged(EarningDeclareSearchCriteria.DECLARE_USER, declareUser);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(EarningDeclareSearchCriteria.prototype, "email", {
                    get: function () {
                        return this._email;
                    },
                    set: function (email) {
                        if (this._email !== email) {
                            this._email = email;
                            this.attributeChanged(EarningDeclareSearchCriteria.EMAIL, email);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(EarningDeclareSearchCriteria.prototype, "id", {
                    get: function () {
                        return this._id;
                    },
                    set: function (id) {
                        if (this._id !== id) {
                            this._id = id;
                            this.attributeChanged(EarningDeclareSearchCriteria.ID, id);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(EarningDeclareSearchCriteria.prototype, "year", {
                    get: function () {
                        return this._year;
                    },
                    set: function (year) {
                        if (this._year !== year) {
                            this._year = year;
                            this.attributeChanged(EarningDeclareSearchCriteria.YEAR, year);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(EarningDeclareSearchCriteria.prototype, "earningDeclareStatus", {
                    get: function () {
                        return this._earningDeclareStatus;
                    },
                    set: function (earningDeclareStatus) {
                        if (this._earningDeclareStatus !== earningDeclareStatus) {
                            this._earningDeclareStatus = earningDeclareStatus;
                            this.attributeChanged(EarningDeclareSearchCriteria.EARNING_DECLARE_STATUS, earningDeclareStatus);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                EarningDeclareSearchCriteria.prototype.reset = function () {
                    _super.prototype.reset.call(this);
                    this._entryDate = null;
                    this._declareUser = null;
                    this._email = null;
                    this._id = null;
                    this._year = null;
                    this._earningDeclareStatus = null;
                };
                EarningDeclareSearchCriteria.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (ags_client_2.isPresent(this.entryDate)) {
                        object['entryDate'] = ags_client_3.serializeDate(this.entryDate);
                    }
                    if (ags_client_2.isPresent(this.declareUser)) {
                        object['declareUser'] = this.declareUser;
                    }
                    if (ags_client_2.isPresent(this.email)) {
                        object['email'] = this.email;
                    }
                    if (ags_client_2.isPresent(this.id)) {
                        object['id'] = this.id;
                    }
                    if (ags_client_2.isPresent(this.year)) {
                        object['year'] = this.year;
                    }
                    if (ags_client_2.isPresent(this.earningDeclareStatus)) {
                        object['earningDeclareStatus'] = ict_core_client_1.EarningDeclareStatus[this.earningDeclareStatus];
                    }
                    return object;
                };
                EarningDeclareSearchCriteria.ENTRY_DATE = 'entryDate';
                EarningDeclareSearchCriteria.DECLARE_USER = 'declareUser';
                EarningDeclareSearchCriteria.EMAIL = 'email';
                EarningDeclareSearchCriteria.ID = 'id';
                EarningDeclareSearchCriteria.YEAR = 'year';
                EarningDeclareSearchCriteria.EARNING_DECLARE_STATUS = 'earningDeclareStatus';
                return EarningDeclareSearchCriteria;
            }(ags_client_1.SearchCriteria);
            exports_1("EarningDeclareSearchCriteria", EarningDeclareSearchCriteria);
        }
    };
});

System.register("ict-external-client/app/components/earning_declare_table_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/ags-client.js", "ict-external-client/gen/viewsearch/earning_declare_search_criteria.js", "ict-external-client/app/services/earning_declares_service.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, ags_client_1, ags_client_2, ags_client_3, ags_client_4, earning_declare_search_criteria_1, ags_client_5, ags_client_6, earning_declares_service_1, EarningDeclareTableComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
            ags_client_5 = ags_client_1_1;
            ags_client_6 = ags_client_1_1;
        }, function (earning_declare_search_criteria_1_1) {
            earning_declare_search_criteria_1 = earning_declare_search_criteria_1_1;
        }, function (earning_declares_service_1_1) {
            earning_declares_service_1 = earning_declares_service_1_1;
        }],
        execute: function () {
            EarningDeclareTableComponent = /** @class */function (_super) {
                __extends(EarningDeclareTableComponent, _super);
                function EarningDeclareTableComponent(alertService, translationService, _earningDeclaresService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._earningDeclaresService = _earningDeclaresService;
                    _this.selected = new core_1.EventEmitter();
                    return _this;
                }
                EarningDeclareTableComponent.prototype.initSearchCriteria = function () {
                    var _this = this;
                    if (!ags_client_2.isPresent(this.earningDeclareSearchCriteria)) {
                        this.earningDeclareSearchCriteria = new earning_declare_search_criteria_1.EarningDeclareSearchCriteria(0, 10);
                        this.earningDeclareSearchCriteria.sort = new ags_client_4.SearchSort(earning_declare_search_criteria_1.EarningDeclareSearchCriteria.ENTRY_DATE, ags_client_4.SortDirection.DESCENDING);
                        this.earningDeclareSearchCriteria.subscribeSearch(function () {
                            _this.search();
                        });
                    }
                    this.search();
                };
                EarningDeclareTableComponent.prototype.buildFilterForm = function () {
                    this.filterForm = new common_1.ControlGroup({
                        'entryDate': new common_1.Control(''),
                        'declareUser': new common_1.Control(''),
                        'email': new common_1.Control(''),
                        'id': new common_1.Control(''),
                        'year': new common_1.Control(''),
                        'earningDeclareStatus': new common_1.Control('')
                    });
                };
                EarningDeclareTableComponent.prototype.reset = function () {
                    this.earningDeclareSearchCriteria.reset();
                    this.earningDeclareSearchCriteria.sort = new ags_client_4.SearchSort(earning_declare_search_criteria_1.EarningDeclareSearchCriteria.ENTRY_DATE, ags_client_4.SortDirection.DESCENDING);
                    this.search();
                };
                EarningDeclareTableComponent.prototype.search = function () {
                    var _this = this;
                    if (this.filterForm.valid) {
                        this.loading = true;
                        this._earningDeclaresService.search(this.earningDeclareSearchCriteria).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.earningDeclareSearchCriteria.total = response.totalItems;
                                _this.earningDeclareSearchResults = response.data;
                            }
                            _this.loading = false;
                        });
                    }
                };
                EarningDeclareTableComponent.prototype.select = function (earning) {
                    this.selected.emit(earning);
                };
                __decorate([core_1.Input(), __metadata("design:type", String)], EarningDeclareTableComponent.prototype, "id", void 0);
                __decorate([ags_client_2.PageFlow('EarningDeclareTable'), __metadata("design:type", earning_declare_search_criteria_1.EarningDeclareSearchCriteria)], EarningDeclareTableComponent.prototype, "earningDeclareSearchCriteria", void 0);
                __decorate([ags_client_2.PageFlow('EarningDeclareTable'), __metadata("design:type", Array)], EarningDeclareTableComponent.prototype, "earningDeclareSearchResults", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], EarningDeclareTableComponent.prototype, "selected", void 0);
                EarningDeclareTableComponent = __decorate([core_1.Component({
                    directives: [ags_client_1.AGS_FORM_DIRECTIVES],
                    pipes: [ags_client_1.AGS_PIPES],
                    selector: 'earning-declare-table',
                    templateUrl: 'ict-external-client/app/components/earning_declare_table_component.html'
                }), __metadata("design:paramtypes", [ags_client_6.AlertService, ags_client_3.TranslationService, earning_declares_service_1.EarningDeclaresService, core_1.ElementRef])], EarningDeclareTableComponent);
                return EarningDeclareTableComponent;
            }(ags_client_5.AbstractTableComponent);
            exports_1("EarningDeclareTableComponent", EarningDeclareTableComponent);
        }
    };
});

System.register("ict-external-client/app/views/earning_view.js", ["angular2/core.js", "angular2/router.js", "ags-client/ags-client.js", "ict-external-client/app/components/earning_declare_table_component.js", "ict-external-client/gen/views.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, router_1, ags_client_1, ags_client_2, ags_client_3, earning_declare_table_component_1, views_1, EarningView;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (router_1_1) {
            router_1 = router_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
        }, function (earning_declare_table_component_1_1) {
            earning_declare_table_component_1 = earning_declare_table_component_1_1;
        }, function (views_1_1) {
            views_1 = views_1_1;
        }],
        execute: function () {
            EarningView = /** @class */function (_super) {
                __extends(EarningView, _super);
                function EarningView(navigationService, router) {
                    return _super.call(this, navigationService, router) || this;
                }
                EarningView.prototype.refresh = function () {
                    this.earningTable.first.search();
                };
                EarningView.prototype.reset = function () {
                    this.earningTable.first.reset();
                };
                EarningView.prototype.create = function () {
                    this.router.navigate([views_1.EARNING_CREATE_VIEW]);
                };
                EarningView.prototype.edit = function (earning) {
                    this.router.navigate([views_1.EARNING_ID_VIEW, { id: earning.id }]);
                };
                __decorate([core_1.ViewChildren(earning_declare_table_component_1.EarningDeclareTableComponent), __metadata("design:type", core_1.QueryList)], EarningView.prototype, "earningTable", void 0);
                EarningView = __decorate([core_1.Component({
                    selector: 'earning-view',
                    directives: [ags_client_1.AGS_DIRECTIVES, earning_declare_table_component_1.EarningDeclareTableComponent],
                    pipes: [ags_client_1.AGS_PIPES],
                    templateUrl: 'ict-external-client/app/views/earning_view.html'
                }), router_1.CanActivate(function () {
                    return ags_client_1.AuthenticationService.checkViewSecurity(views_1.VIEW_SECURITY[views_1.EARNING_VIEW]);
                }), __metadata("design:paramtypes", [ags_client_2.NavigationService, router_1.Router])], EarningView);
                return EarningView;
            }(ags_client_3.AbstractView);
            exports_1("EarningView", EarningView);
        }
    };
});

System.register("ict-external-client/gen/viewmodels/earning_declare_create_view_model.js", ["ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, Validators, ags_client_2, ags_client_3, EarningDeclareCreateViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            Validators = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
        }],
        execute: function () {
            EarningDeclareCreateViewModel = /** @class */function () {
                function EarningDeclareCreateViewModel() {}
                EarningDeclareCreateViewModel.deserialize = function (object) {
                    var _result = new EarningDeclareCreateViewModel();
                    return _result._deserialize(object);
                };
                EarningDeclareCreateViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (ags_client_1.isPresent(object['year'])) {
                            this.year = object['year'];
                        }
                        if (ags_client_1.isPresent(object['instrumentGroup'])) {
                            this.instrumentGroup = ags_client_3.enumNumberValue(ags_client_2.InstrumentGroup, object['instrumentGroup']);
                        }
                        if (ags_client_1.isPresent(object['attachSubsequently'])) {
                            this.attachSubsequently = object['attachSubsequently'];
                        }
                        if (ags_client_1.isPresent(object['emailResponseDesired'])) {
                            this.emailResponseDesired = object['emailResponseDesired'];
                        }
                        if (ags_client_1.isPresent(object['message'])) {
                            this.message = object['message'];
                        }
                    }
                    return this;
                };
                EarningDeclareCreateViewModel.prototype.serialize = function () {
                    var object = {};
                    if (ags_client_1.isPresent(this.year)) {
                        object['year'] = this.year;
                    }
                    if (ags_client_1.isPresent(this.instrumentGroup)) {
                        object['instrumentGroup'] = ags_client_2.InstrumentGroup[this.instrumentGroup];
                    }
                    if (ags_client_1.isPresent(this.attachSubsequently)) {
                        object['attachSubsequently'] = this.attachSubsequently;
                    }
                    if (ags_client_1.isPresent(this.emailResponseDesired)) {
                        object['emailResponseDesired'] = this.emailResponseDesired;
                    }
                    if (ags_client_1.isPresent(this.message)) {
                        object['message'] = this.message;
                    }
                    return object;
                };
                EarningDeclareCreateViewModel.YEAR_VALIDATORS = [Validators.required(), Validators.year()];
                EarningDeclareCreateViewModel.INSTRUMENT_GROUP_VALIDATORS = [Validators.required()];
                EarningDeclareCreateViewModel.ATTACH_SUBSEQUENTLY_VALIDATORS = [];
                EarningDeclareCreateViewModel.EMAIL_RESPONSE_DESIRED_VALIDATORS = [];
                EarningDeclareCreateViewModel.MESSAGE_VALIDATORS = [Validators.required()];
                return EarningDeclareCreateViewModel;
            }();
            exports_1("EarningDeclareCreateViewModel", EarningDeclareCreateViewModel);
        }
    };
});

System.register("ict-external-client/app/components/earning_declare_form_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/ags-client.js", "ict-external-client/gen/viewmodels/earning_declare_create_view_model.js", "ict-external-client/app/services/application_service.js", "ict-external-client/app/services/earning_declares_service.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, ags_client_1, ags_client_2, earning_declare_create_view_model_1, ags_client_3, ags_client_4, ags_client_5, ags_client_6, application_service_1, earning_declares_service_1, EarningDeclareFormComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
            ags_client_5 = ags_client_1_1;
            ags_client_6 = ags_client_1_1;
        }, function (earning_declare_create_view_model_1_1) {
            earning_declare_create_view_model_1 = earning_declare_create_view_model_1_1;
        }, function (application_service_1_1) {
            application_service_1 = application_service_1_1;
        }, function (earning_declares_service_1_1) {
            earning_declares_service_1 = earning_declares_service_1_1;
        }],
        execute: function () {
            EarningDeclareFormComponent = /** @class */function (_super) {
                __extends(EarningDeclareFormComponent, _super);
                function EarningDeclareFormComponent(alertService, translationService, _applicationService, _earningDeclaresService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._applicationService = _applicationService;
                    _this._earningDeclaresService = _earningDeclaresService;
                    _this.canceled = new core_1.EventEmitter();
                    _this.submitted = new core_1.EventEmitter();
                    _this.earningDeclare = new earning_declare_create_view_model_1.EarningDeclareCreateViewModel();
                    _this.minYear = new Date().getFullYear();
                    _this.maxYear = new Date().getFullYear();
                    return _this;
                }
                EarningDeclareFormComponent.prototype.initData = function () {
                    var _this = this;
                    this.earningDeclare = new earning_declare_create_view_model_1.EarningDeclareCreateViewModel();
                    this.earningDeclare.attachSubsequently = false;
                    this.earningDeclare.emailResponseDesired = true;
                    this._applicationService.cachedSystemParameters().then(function (systemParameters) {
                        _this.maxYear = new Date().getFullYear() + 1;
                        _this.minYear = systemParameters.firstTaxYear;
                        _this.earningDeclare.year = systemParameters.taxYearExtern;
                    });
                };
                EarningDeclareFormComponent.prototype.initKeyStrokes = function () {
                    var _this = this;
                    ags_client_3.KeyStrokeManager.register(ags_client_3.KeyStroke.CANCEL, function () {
                        return _this.cancel();
                    });
                    ags_client_3.KeyStrokeManager.register(ags_client_3.KeyStroke.SAVE, function () {
                        return _this.submit();
                    });
                };
                EarningDeclareFormComponent.prototype.buildForm = function () {
                    this.form = new common_1.ControlGroup({
                        'year': new common_1.Control('', ags_client_4.validators(earning_declare_create_view_model_1.EarningDeclareCreateViewModel.YEAR_VALIDATORS)),
                        'instrumentGroup': new common_1.Control('', ags_client_4.validators(earning_declare_create_view_model_1.EarningDeclareCreateViewModel.INSTRUMENT_GROUP_VALIDATORS)),
                        'attachSubsequently': new common_1.Control(''),
                        'emailResponseDesired': new common_1.Control(''),
                        'message': new common_1.Control('', ags_client_4.validators(earning_declare_create_view_model_1.EarningDeclareCreateViewModel.MESSAGE_VALIDATORS))
                    });
                };
                EarningDeclareFormComponent.prototype.filesSelected = function (attachments) {
                    this.attachments = attachments;
                };
                EarningDeclareFormComponent.prototype.cancel = function () {
                    this.canceled.emit(this.earningDeclare);
                };
                EarningDeclareFormComponent.prototype.submit = function () {
                    var _this = this;
                    this.alertService.reset();
                    if (this.validate()) {
                        this.loading = true;
                        this._earningDeclaresService.store(this.earningDeclare).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                if (_this.attachments && _this.attachments.length > 0) {
                                    _this._earningDeclaresService.uploadAttachments(response.data, _this.attachments).subscribe(function (response2) {
                                        if (!_this.handleErrors(response2)) {
                                            _this.submitted.emit(null);
                                        }
                                        _this.loading = false;
                                    });
                                } else {
                                    _this.loading = false;
                                    _this.submitted.emit(null);
                                }
                            } else {
                                _this.loading = false;
                            }
                        });
                    }
                };
                __decorate([core_1.Input(), __metadata("design:type", String)], EarningDeclareFormComponent.prototype, "id", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Number)], EarningDeclareFormComponent.prototype, "earningDeclareId", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], EarningDeclareFormComponent.prototype, "canceled", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], EarningDeclareFormComponent.prototype, "submitted", void 0);
                EarningDeclareFormComponent = __decorate([core_1.Component({
                    directives: [ags_client_1.AGS_FORM_DIRECTIVES, ags_client_5.AttachmentsComponent],
                    pipes: [ags_client_1.AGS_PIPES],
                    selector: 'earning-declare-form',
                    templateUrl: 'ict-external-client/app/components/earning_declare_form_component.html'
                }), __metadata("design:paramtypes", [ags_client_6.AlertService, ags_client_2.TranslationService, application_service_1.ApplicationService, earning_declares_service_1.EarningDeclaresService, core_1.ElementRef])], EarningDeclareFormComponent);
                return EarningDeclareFormComponent;
            }(ags_client_5.AbstractFormComponent);
            exports_1("EarningDeclareFormComponent", EarningDeclareFormComponent);
        }
    };
});

System.register("ict-external-client/app/views/earning_create_view.js", ["angular2/core.js", "angular2/router.js", "ags-client/ags-client.js", "ict-external-client/app/components/earning_declare_form_component.js", "ict-external-client/gen/views.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, router_1, ags_client_1, ags_client_2, ags_client_3, earning_declare_form_component_1, views_1, EarningCreateView;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (router_1_1) {
            router_1 = router_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
        }, function (earning_declare_form_component_1_1) {
            earning_declare_form_component_1 = earning_declare_form_component_1_1;
        }, function (views_1_1) {
            views_1 = views_1_1;
        }],
        execute: function () {
            EarningCreateView = /** @class */function (_super) {
                __extends(EarningCreateView, _super);
                function EarningCreateView(navigationService, router) {
                    return _super.call(this, navigationService, router) || this;
                }
                EarningCreateView.prototype.goBack = function () {
                    this.router.navigate([views_1.EARNING_VIEW]);
                };
                __decorate([core_1.ViewChildren(earning_declare_form_component_1.EarningDeclareFormComponent), __metadata("design:type", core_1.QueryList)], EarningCreateView.prototype, "earningForm", void 0);
                EarningCreateView = __decorate([core_1.Component({
                    selector: 'earning-create-view',
                    directives: [ags_client_1.AGS_DIRECTIVES, earning_declare_form_component_1.EarningDeclareFormComponent],
                    pipes: [ags_client_1.AGS_PIPES],
                    templateUrl: 'ict-external-client/app/views/earning_create_view.html'
                }), router_1.CanActivate(function () {
                    return ags_client_1.AuthenticationService.checkViewSecurity(views_1.VIEW_SECURITY[views_1.EARNING_CREATE_VIEW]);
                }), __metadata("design:paramtypes", [ags_client_2.NavigationService, router_1.Router])], EarningCreateView);
                return EarningCreateView;
            }(ags_client_3.AbstractView);
            exports_1("EarningCreateView", EarningCreateView);
        }
    };
});

System.register("ict-external-client/gen/viewmodels/earning_declare_search_result_view_model.js", ["ags-client/ags-client.js", "ict-core-client/ict-core-client.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, Validators, ags_client_2, ags_client_3, ict_core_client_1, ags_client_4, EarningDeclareSearchResultViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            Validators = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
        }, function (ict_core_client_1_1) {
            ict_core_client_1 = ict_core_client_1_1;
        }],
        execute: function () {
            EarningDeclareSearchResultViewModel = /** @class */function () {
                function EarningDeclareSearchResultViewModel() {}
                EarningDeclareSearchResultViewModel.deserialize = function (object) {
                    var _result = new EarningDeclareSearchResultViewModel();
                    return _result._deserialize(object);
                };
                EarningDeclareSearchResultViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (ags_client_1.isPresent(object['entryDate'])) {
                            this.entryDate = ags_client_3.deserializeDate(object['entryDate']);
                        }
                        if (ags_client_1.isPresent(object['declareUser'])) {
                            this.declareUser = object['declareUser'];
                        }
                        if (ags_client_1.isPresent(object['email'])) {
                            this.email = object['email'];
                        }
                        if (ags_client_1.isPresent(object['id'])) {
                            this.id = object['id'];
                        }
                        if (ags_client_1.isPresent(object['year'])) {
                            this.year = object['year'];
                        }
                        if (ags_client_1.isPresent(object['earningDeclareStatus'])) {
                            this.earningDeclareStatus = ags_client_4.enumNumberValue(ict_core_client_1.EarningDeclareStatus, object['earningDeclareStatus']);
                        }
                    }
                    return this;
                };
                EarningDeclareSearchResultViewModel.prototype.serialize = function () {
                    var object = {};
                    if (ags_client_1.isPresent(this.entryDate)) {
                        object['entryDate'] = ags_client_2.serializeDate(this.entryDate);
                    }
                    if (ags_client_1.isPresent(this.declareUser)) {
                        object['declareUser'] = this.declareUser;
                    }
                    if (ags_client_1.isPresent(this.email)) {
                        object['email'] = this.email;
                    }
                    if (ags_client_1.isPresent(this.id)) {
                        object['id'] = this.id;
                    }
                    if (ags_client_1.isPresent(this.year)) {
                        object['year'] = this.year;
                    }
                    if (ags_client_1.isPresent(this.earningDeclareStatus)) {
                        object['earningDeclareStatus'] = ict_core_client_1.EarningDeclareStatus[this.earningDeclareStatus];
                    }
                    return object;
                };
                EarningDeclareSearchResultViewModel.ENTRY_DATE_VALIDATORS = [Validators.date, Validators.required(), Validators.dateTime()];
                EarningDeclareSearchResultViewModel.DECLARE_USER_VALIDATORS = [Validators.required()];
                EarningDeclareSearchResultViewModel.EMAIL_VALIDATORS = [];
                EarningDeclareSearchResultViewModel.ID_VALIDATORS = [];
                EarningDeclareSearchResultViewModel.YEAR_VALIDATORS = [Validators.required(), Validators.year()];
                EarningDeclareSearchResultViewModel.EARNING_DECLARE_STATUS_VALIDATORS = [Validators.required()];
                return EarningDeclareSearchResultViewModel;
            }();
            exports_1("EarningDeclareSearchResultViewModel", EarningDeclareSearchResultViewModel);
        }
    };
});

System.register("ict-external-client/gen/viewmodels/earning_security_view_model.js", ["ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, EarningSecurityViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }],
        execute: function () {
            EarningSecurityViewModel = /** @class */function () {
                function EarningSecurityViewModel() {}
                EarningSecurityViewModel.deserialize = function (object) {
                    var _result = new EarningSecurityViewModel();
                    return _result._deserialize(object);
                };
                EarningSecurityViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (ags_client_1.isPresent(object['valorNumber'])) {
                            this.valorNumber = object['valorNumber'];
                        }
                        if (ags_client_1.isPresent(object['isin'])) {
                            this.isin = object['isin'];
                        }
                        if (ags_client_1.isPresent(object['appendix'])) {
                            this.appendix = object['appendix'];
                        }
                        if (ags_client_1.isPresent(object['titleType'])) {
                            this.titleType = object['titleType'];
                        }
                        if (ags_client_1.isPresent(object['currency'])) {
                            this.currency = object['currency'];
                        }
                        if (ags_client_1.isPresent(object['value'])) {
                            this.value = object['value'];
                        }
                        if (ags_client_1.isPresent(object['exchangeRate'])) {
                            this.exchangeRate = object['exchangeRate'];
                        }
                        if (ags_client_1.isPresent(object['valueChf'])) {
                            this.valueChf = object['valueChf'];
                        }
                        if (ags_client_1.isPresent(object['remarks'])) {
                            this.remarks = object['remarks'];
                        }
                    }
                    return this;
                };
                EarningSecurityViewModel.prototype.serialize = function () {
                    var object = {};
                    if (ags_client_1.isPresent(this.valorNumber)) {
                        object['valorNumber'] = this.valorNumber;
                    }
                    if (ags_client_1.isPresent(this.isin)) {
                        object['isin'] = this.isin;
                    }
                    if (ags_client_1.isPresent(this.appendix)) {
                        object['appendix'] = this.appendix;
                    }
                    if (ags_client_1.isPresent(this.titleType)) {
                        object['titleType'] = this.titleType;
                    }
                    if (ags_client_1.isPresent(this.currency)) {
                        object['currency'] = this.currency;
                    }
                    if (ags_client_1.isPresent(this.value)) {
                        object['value'] = this.value;
                    }
                    if (ags_client_1.isPresent(this.exchangeRate)) {
                        object['exchangeRate'] = this.exchangeRate;
                    }
                    if (ags_client_1.isPresent(this.valueChf)) {
                        object['valueChf'] = this.valueChf;
                    }
                    if (ags_client_1.isPresent(this.remarks)) {
                        object['remarks'] = this.remarks;
                    }
                    return object;
                };
                EarningSecurityViewModel.VALOR_NUMBER_VALIDATORS = [];
                EarningSecurityViewModel.ISIN_VALIDATORS = [];
                EarningSecurityViewModel.APPENDIX_VALIDATORS = [];
                EarningSecurityViewModel.TITLE_TYPE_VALIDATORS = [];
                EarningSecurityViewModel.CURRENCY_VALIDATORS = [];
                EarningSecurityViewModel.VALUE_VALIDATORS = [];
                EarningSecurityViewModel.EXCHANGE_RATE_VALIDATORS = [];
                EarningSecurityViewModel.VALUE_CHF_VALIDATORS = [];
                EarningSecurityViewModel.REMARKS_VALIDATORS = [];
                return EarningSecurityViewModel;
            }();
            exports_1("EarningSecurityViewModel", EarningSecurityViewModel);
        }
    };
});

System.register("ict-external-client/gen/viewmodels/earning_view_model.js", ["ags-client/ags-client.js", "ict-external-client/gen/viewmodels/earning_security_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, earning_security_view_model_1, EarningViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }, function (earning_security_view_model_1_1) {
            earning_security_view_model_1 = earning_security_view_model_1_1;
        }],
        execute: function () {
            EarningViewModel = /** @class */function () {
                function EarningViewModel() {}
                EarningViewModel.deserialize = function (object) {
                    var _result = new EarningViewModel();
                    return _result._deserialize(object);
                };
                EarningViewModel.prototype._deserialize = function (object) {
                    var _this = this;
                    if (object) {
                        if (ags_client_1.isPresent(object['institution'])) {
                            this.institution = object['institution'];
                        }
                        if (ags_client_1.isPresent(object['balanceSheetDate'])) {
                            this.balanceSheetDate = object['balanceSheetDate'];
                        }
                        if (ags_client_1.isPresent(object['year'])) {
                            this.year = object['year'];
                        }
                        if (ags_client_1.isPresent(object['processingStatus'])) {
                            this.processingStatus = object['processingStatus'];
                        }
                        if (ags_client_1.isPresent(object['remarks'])) {
                            this.remarks = object['remarks'];
                        }
                        if (ags_client_1.isPresent(object['securities'])) {
                            this.securities = [];
                            object['securities'].forEach(function (item) {
                                _this.securities.push(earning_security_view_model_1.EarningSecurityViewModel.deserialize(item));
                            });
                        }
                    }
                    return this;
                };
                EarningViewModel.prototype.serialize = function () {
                    var object = {};
                    if (ags_client_1.isPresent(this.institution)) {
                        object['institution'] = this.institution;
                    }
                    if (ags_client_1.isPresent(this.balanceSheetDate)) {
                        object['balanceSheetDate'] = this.balanceSheetDate;
                    }
                    if (ags_client_1.isPresent(this.year)) {
                        object['year'] = this.year;
                    }
                    if (ags_client_1.isPresent(this.processingStatus)) {
                        object['processingStatus'] = this.processingStatus;
                    }
                    if (ags_client_1.isPresent(this.remarks)) {
                        object['remarks'] = this.remarks;
                    }
                    if (ags_client_1.isPresent(this.securities)) {
                        object['securities'] = [];
                        this.securities.forEach(function (item) {
                            object['securities'].push(item.serialize());
                        });
                    }
                    return object;
                };
                EarningViewModel.INSTITUTION_VALIDATORS = [];
                EarningViewModel.BALANCE_SHEET_DATE_VALIDATORS = [];
                EarningViewModel.YEAR_VALIDATORS = [];
                EarningViewModel.PROCESSING_STATUS_VALIDATORS = [];
                EarningViewModel.REMARKS_VALIDATORS = [];
                EarningViewModel.SECURITIES_VALIDATORS = [];
                return EarningViewModel;
            }();
            exports_1("EarningViewModel", EarningViewModel);
        }
    };
});

System.register("ict-external-client/gen/services/abstract_earning_declares_service.js", ["ags-client/ags-client.js", "ict-external-client/gen/viewmodels/earning_declare_search_result_view_model.js", "ict-external-client/gen/viewmodels/earning_declare_view_model.js", "ict-external-client/gen/viewmodels/earning_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, earning_declare_search_result_view_model_1, earning_declare_view_model_1, earning_view_model_1, AbstractEarningDeclaresService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }, function (earning_declare_search_result_view_model_1_1) {
            earning_declare_search_result_view_model_1 = earning_declare_search_result_view_model_1_1;
        }, function (earning_declare_view_model_1_1) {
            earning_declare_view_model_1 = earning_declare_view_model_1_1;
        }, function (earning_view_model_1_1) {
            earning_view_model_1 = earning_view_model_1_1;
        }],
        execute: function () {
            AbstractEarningDeclaresService = /** @class */function () {
                function AbstractEarningDeclaresService(backendService) {
                    this.backendService = backendService;
                }
                AbstractEarningDeclaresService.prototype.search = function (request) {
                    return this.backendService.postJson('/earningDeclares/search.json', request.serialize(), function (response) {
                        var data = Array();
                        response.data.forEach(function (item) {
                            data.push(earning_declare_search_result_view_model_1.EarningDeclareSearchResultViewModel.deserialize(item));
                        });
                        return ags_client_1.JsonResponse.deserialize(response, data);
                    });
                };
                AbstractEarningDeclaresService.prototype.earningDeclare = function (request) {
                    return this.backendService.getJson('/earningDeclares/earningDeclare/' + request + '.json', function (response) {
                        return ags_client_1.JsonResponse.deserialize(response, earning_declare_view_model_1.EarningDeclareViewModel.deserialize(response.data));
                    });
                };
                AbstractEarningDeclaresService.prototype.earnings = function (request) {
                    return this.backendService.getJson('/earningDeclares/earnings/' + request + '.json', function (response) {
                        var data = Array();
                        response.data.forEach(function (item) {
                            data.push(earning_view_model_1.EarningViewModel.deserialize(item));
                        });
                        return ags_client_1.JsonResponse.deserialize(response, data);
                    });
                };
                AbstractEarningDeclaresService.prototype.sendMessage = function (request) {
                    return this.backendService.postJson('/earningDeclares/sendMessage.json', request.serialize(), function (response) {
                        return ags_client_1.JsonResponse.deserialize(response, earning_declare_view_model_1.EarningDeclareViewModel.deserialize(response.data));
                    });
                };
                AbstractEarningDeclaresService.prototype.store = function (request) {
                    return this.backendService.postJson('/earningDeclares/store.json', request.serialize(), function (response) {
                        return ags_client_1.JsonResponse.deserialize(response, response.data);
                    });
                };
                return AbstractEarningDeclaresService;
            }();
            exports_1("AbstractEarningDeclaresService", AbstractEarningDeclaresService);
        }
    };
});

System.register("ict-external-client/app/services/earning_declares_service.js", ["angular2/core.js", "ict-external-client/gen/services/abstract_earning_declares_service.js", "ags-client/ags-client.js", "rxjs/Rx.js", "rxjs/add/operator/do.js", "rxjs/add/operator/concatMap.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, abstract_earning_declares_service_1, ags_client_1, ags_client_2, Rx_1, EarningDeclaresService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (abstract_earning_declares_service_1_1) {
            abstract_earning_declares_service_1 = abstract_earning_declares_service_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
        }, function (Rx_1_1) {
            Rx_1 = Rx_1_1;
        }, function (_1) {}, function (_2) {}],
        execute: function () {
            EarningDeclaresService = /** @class */function (_super) {
                __extends(EarningDeclaresService, _super);
                function EarningDeclaresService(backendService) {
                    var _this = _super.call(this, backendService) || this;
                    _this._backendService = backendService;
                    return _this;
                }
                EarningDeclaresService.prototype.uploadAttachments = function (earningDeclareId, attachments) {
                    var _this = this;
                    return new Rx_1.Observable(function (subscriber) {
                        var responses = new ags_client_2.JsonResponseList();
                        Rx_1.Observable.from(attachments).concatMap(function (file) {
                            return _this._backendService.uploadFile('/earningDeclares/addAttachment/' + earningDeclareId, file);
                        }).do(function (response) {
                            responses.responses.push(response);
                        }).subscribe(null, null, function () {
                            subscriber.next(responses);
                            subscriber.complete();
                        });
                    });
                };
                EarningDeclaresService = __decorate([core_1.Injectable(), core_1.Inject(ags_client_1.BackendService), __metadata("design:paramtypes", [ags_client_1.BackendService])], EarningDeclaresService);
                return EarningDeclaresService;
            }(abstract_earning_declares_service_1.AbstractEarningDeclaresService);
            exports_1("EarningDeclaresService", EarningDeclaresService);
        }
    };
});

System.register("ict-external-client/gen/viewmodels/earning_declare_view_model.js", ["ags-client/ags-client.js", "ict-core-client/ict-core-client.js", "ict-external-client/gen/viewmodels/message_view_model.js", "ict-external-client/gen/viewmodels/attachment_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var ags_client_1, ags_client_2, Validators, ags_client_3, ags_client_4, ict_core_client_1, ags_client_5, ags_client_6, message_view_model_1, attachment_view_model_1, EarningDeclareViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            Validators = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
            ags_client_5 = ags_client_1_1;
            ags_client_6 = ags_client_1_1;
        }, function (ict_core_client_1_1) {
            ict_core_client_1 = ict_core_client_1_1;
        }, function (message_view_model_1_1) {
            message_view_model_1 = message_view_model_1_1;
        }, function (attachment_view_model_1_1) {
            attachment_view_model_1 = attachment_view_model_1_1;
        }],
        execute: function () {
            EarningDeclareViewModel = /** @class */function (_super) {
                __extends(EarningDeclareViewModel, _super);
                function EarningDeclareViewModel() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                EarningDeclareViewModel.deserialize = function (object) {
                    var _result = new EarningDeclareViewModel();
                    return _result._deserialize(object);
                };
                EarningDeclareViewModel.prototype._deserialize = function (object) {
                    var _this = this;
                    if (object) {
                        _super.prototype._deserialize.call(this, object);
                        if (ags_client_1.isPresent(object['entryDate'])) {
                            this.entryDate = ags_client_4.deserializeDate(object['entryDate']);
                        }
                        if (ags_client_1.isPresent(object['declareUser'])) {
                            this.declareUser = object['declareUser'];
                        }
                        if (ags_client_1.isPresent(object['email'])) {
                            this.email = object['email'];
                        }
                        if (ags_client_1.isPresent(object['year'])) {
                            this.year = object['year'];
                        }
                        if (ags_client_1.isPresent(object['earningDeclareStatus'])) {
                            this.earningDeclareStatus = ags_client_5.enumNumberValue(ict_core_client_1.EarningDeclareStatus, object['earningDeclareStatus']);
                        }
                        if (ags_client_1.isPresent(object['instrumentGroup'])) {
                            this.instrumentGroup = ags_client_5.enumNumberValue(ags_client_6.InstrumentGroup, object['instrumentGroup']);
                        }
                        if (ags_client_1.isPresent(object['emailResponseDesired'])) {
                            this.emailResponseDesired = object['emailResponseDesired'];
                        }
                        if (ags_client_1.isPresent(object['attachSubsequently'])) {
                            this.attachSubsequently = object['attachSubsequently'];
                        }
                        if (ags_client_1.isPresent(object['messages'])) {
                            this.messages = [];
                            object['messages'].forEach(function (item) {
                                _this.messages.push(message_view_model_1.MessageViewModel.deserialize(item));
                            });
                        }
                        if (ags_client_1.isPresent(object['attachments'])) {
                            this.attachments = [];
                            object['attachments'].forEach(function (item) {
                                _this.attachments.push(attachment_view_model_1.AttachmentViewModel.deserialize(item));
                            });
                        }
                    }
                    return this;
                };
                EarningDeclareViewModel.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (ags_client_1.isPresent(this.entryDate)) {
                        object['entryDate'] = ags_client_3.serializeDate(this.entryDate);
                    }
                    if (ags_client_1.isPresent(this.declareUser)) {
                        object['declareUser'] = this.declareUser;
                    }
                    if (ags_client_1.isPresent(this.email)) {
                        object['email'] = this.email;
                    }
                    if (ags_client_1.isPresent(this.year)) {
                        object['year'] = this.year;
                    }
                    if (ags_client_1.isPresent(this.earningDeclareStatus)) {
                        object['earningDeclareStatus'] = ict_core_client_1.EarningDeclareStatus[this.earningDeclareStatus];
                    }
                    if (ags_client_1.isPresent(this.instrumentGroup)) {
                        object['instrumentGroup'] = ags_client_6.InstrumentGroup[this.instrumentGroup];
                    }
                    if (ags_client_1.isPresent(this.emailResponseDesired)) {
                        object['emailResponseDesired'] = this.emailResponseDesired;
                    }
                    if (ags_client_1.isPresent(this.attachSubsequently)) {
                        object['attachSubsequently'] = this.attachSubsequently;
                    }
                    if (ags_client_1.isPresent(this.messages)) {
                        object['messages'] = [];
                        this.messages.forEach(function (item) {
                            object['messages'].push(item.serialize());
                        });
                    }
                    if (ags_client_1.isPresent(this.attachments)) {
                        object['attachments'] = [];
                        this.attachments.forEach(function (item) {
                            object['attachments'].push(item.serialize());
                        });
                    }
                    return object;
                };
                EarningDeclareViewModel.ENTRY_DATE_VALIDATORS = [Validators.date, Validators.required(), Validators.dateTime()];
                EarningDeclareViewModel.DECLARE_USER_VALIDATORS = [Validators.required()];
                EarningDeclareViewModel.EMAIL_VALIDATORS = [];
                EarningDeclareViewModel.YEAR_VALIDATORS = [Validators.required(), Validators.year()];
                EarningDeclareViewModel.EARNING_DECLARE_STATUS_VALIDATORS = [Validators.required()];
                EarningDeclareViewModel.INSTRUMENT_GROUP_VALIDATORS = [Validators.required()];
                EarningDeclareViewModel.EMAIL_RESPONSE_DESIRED_VALIDATORS = [];
                EarningDeclareViewModel.ATTACH_SUBSEQUENTLY_VALIDATORS = [];
                EarningDeclareViewModel.MESSAGES_VALIDATORS = [];
                EarningDeclareViewModel.ATTACHMENTS_VALIDATORS = [];
                return EarningDeclareViewModel;
            }(ags_client_2.EntityViewModel);
            exports_1("EarningDeclareViewModel", EarningDeclareViewModel);
        }
    };
});

System.register("ict-external-client/app/components/earning_declare_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/ags-client.js", "ict-external-client/app/services/earning_declares_service.js", "ict-external-client/gen/viewmodels/earning_declare_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, ags_client_1, ags_client_2, ags_client_3, earning_declares_service_1, earning_declare_view_model_1, ags_client_4, ags_client_5, ags_client_6, EarningDeclareComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
            ags_client_5 = ags_client_1_1;
            ags_client_6 = ags_client_1_1;
        }, function (earning_declares_service_1_1) {
            earning_declares_service_1 = earning_declares_service_1_1;
        }, function (earning_declare_view_model_1_1) {
            earning_declare_view_model_1 = earning_declare_view_model_1_1;
        }],
        execute: function () {
            EarningDeclareComponent = /** @class */function (_super) {
                __extends(EarningDeclareComponent, _super);
                function EarningDeclareComponent(alertService, translationService, _earningDeclaresService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._earningDeclaresService = _earningDeclaresService;
                    _this.earningDeclare = new earning_declare_view_model_1.EarningDeclareViewModel();
                    _this.earningsTab = false;
                    return _this;
                }
                EarningDeclareComponent.prototype.initData = function () {
                    this.refresh();
                };
                EarningDeclareComponent.prototype.buildForm = function () {
                    this.form = new common_1.ControlGroup({
                        'message': new common_1.Control('', ags_client_4.validators([ags_client_4.required()]))
                    });
                };
                EarningDeclareComponent.prototype.refresh = function () {
                    var _this = this;
                    if (ags_client_2.isPresent(this.earningDeclareId)) {
                        this.loading = true;
                        this._earningDeclaresService.earningDeclare(this.earningDeclareId).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.earningDeclare = response.data;
                                _this.refreshEarnings();
                            }
                            _this.loading = false;
                        });
                    }
                };
                EarningDeclareComponent.prototype.refreshEarnings = function () {
                    var _this = this;
                    this._earningDeclaresService.earnings(this.earningDeclareId).subscribe(function (response) {
                        if (!_this.handleError(response)) {
                            _this.earnings = response.data;
                        }
                    });
                };
                EarningDeclareComponent.prototype.sendMessage = function () {
                    var _this = this;
                    this.alertService.reset();
                    if (this.validate()) {
                        this.loading = true;
                        var message = new ags_client_5.MessageViewModel();
                        message.referenceId = this.earningDeclareId;
                        message.text = this.newMessage;
                        this._earningDeclaresService.sendMessage(message).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.newMessage = null;
                                _this.reset();
                                _this.refresh();
                            }
                            _this.loading = false;
                        });
                    }
                };
                EarningDeclareComponent.prototype.filesSelected = function (attachments) {
                    var _this = this;
                    if (attachments && attachments.length > 0) {
                        this.loading = true;
                        this._earningDeclaresService.uploadAttachments(this.earningDeclareId, attachments).subscribe(function (response2) {
                            if (!_this.handleErrors(response2)) {
                                _this.refresh();
                            } else {
                                _this.loading = false;
                            }
                        });
                    }
                };
                EarningDeclareComponent.prototype.select = function (earning) {
                    this.selectedEarning = earning;
                    this.earningDialog.first.show();
                };
                EarningDeclareComponent.prototype.toggleEarningsTab = function () {
                    this.earningsTab = !this.earningsTab;
                };
                __decorate([core_1.ViewChildren(ags_client_6.ModalComponent), __metadata("design:type", core_1.QueryList)], EarningDeclareComponent.prototype, "earningDialog", void 0);
                __decorate([core_1.Input(), __metadata("design:type", String)], EarningDeclareComponent.prototype, "id", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Number)], EarningDeclareComponent.prototype, "earningDeclareId", void 0);
                EarningDeclareComponent = __decorate([core_1.Component({
                    directives: [ags_client_1.AGS_FORM_DIRECTIVES, ags_client_5.AttachmentsComponent, ags_client_6.ModalComponent],
                    pipes: [ags_client_1.AGS_PIPES],
                    selector: 'earning-declare',
                    templateUrl: 'ict-external-client/app/components/earning_declare_component.html'
                }), __metadata("design:paramtypes", [ags_client_3.AlertService, ags_client_3.TranslationService, earning_declares_service_1.EarningDeclaresService, core_1.ElementRef])], EarningDeclareComponent);
                return EarningDeclareComponent;
            }(ags_client_3.AbstractFormComponent);
            exports_1("EarningDeclareComponent", EarningDeclareComponent);
        }
    };
});

System.register("ict-external-client/app/views/earning_id_view.js", ["angular2/core.js", "angular2/router.js", "ags-client/ags-client.js", "ict-external-client/app/components/earning_declare_component.js", "ict-external-client/gen/views.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, router_1, ags_client_1, ags_client_2, ags_client_3, earning_declare_component_1, views_1, router_2, EarningIdView;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (router_1_1) {
            router_1 = router_1_1;
            router_2 = router_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
        }, function (earning_declare_component_1_1) {
            earning_declare_component_1 = earning_declare_component_1_1;
        }, function (views_1_1) {
            views_1 = views_1_1;
        }],
        execute: function () {
            EarningIdView = /** @class */function (_super) {
                __extends(EarningIdView, _super);
                function EarningIdView(navigationService, router, routeParams) {
                    var _this = _super.call(this, navigationService, router) || this;
                    _this.earningDeclareId = parseInt(routeParams.get('id'));
                    return _this;
                }
                EarningIdView.prototype.refresh = function () {
                    this.earning.first.refresh();
                };
                __decorate([core_1.ViewChildren(earning_declare_component_1.EarningDeclareComponent), __metadata("design:type", core_1.QueryList)], EarningIdView.prototype, "earning", void 0);
                EarningIdView = __decorate([core_1.Component({
                    selector: 'earning-id-view',
                    directives: [ags_client_1.AGS_DIRECTIVES, earning_declare_component_1.EarningDeclareComponent],
                    pipes: [ags_client_1.AGS_PIPES],
                    templateUrl: 'ict-external-client/app/views/earning_id_view.html'
                }), router_1.CanActivate(function () {
                    return ags_client_1.AuthenticationService.checkViewSecurity(views_1.VIEW_SECURITY[views_1.EARNING_ID_VIEW]);
                }), __metadata("design:paramtypes", [ags_client_2.NavigationService, router_1.Router, router_2.RouteParams])], EarningIdView);
                return EarningIdView;
            }(ags_client_3.AbstractView);
            exports_1("EarningIdView", EarningIdView);
        }
    };
});

System.register("ict-external-client/gen/viewmodels/encode_password_view_model.js", ["ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, Validators, EncodePasswordViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            Validators = ags_client_1_1;
        }],
        execute: function () {
            EncodePasswordViewModel = /** @class */function () {
                function EncodePasswordViewModel() {}
                EncodePasswordViewModel.deserialize = function (object) {
                    var _result = new EncodePasswordViewModel();
                    return _result._deserialize(object);
                };
                EncodePasswordViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (ags_client_1.isPresent(object['password'])) {
                            this.password = object['password'];
                        }
                        if (ags_client_1.isPresent(object['encoded'])) {
                            this.encoded = object['encoded'];
                        }
                        if (ags_client_1.isPresent(object['md5Hash'])) {
                            this.md5Hash = object['md5Hash'];
                        }
                    }
                    return this;
                };
                EncodePasswordViewModel.prototype.serialize = function () {
                    var object = {};
                    if (ags_client_1.isPresent(this.password)) {
                        object['password'] = this.password;
                    }
                    if (ags_client_1.isPresent(this.encoded)) {
                        object['encoded'] = this.encoded;
                    }
                    if (ags_client_1.isPresent(this.md5Hash)) {
                        object['md5Hash'] = this.md5Hash;
                    }
                    return object;
                };
                EncodePasswordViewModel.PASSWORD_VALIDATORS = [Validators.required()];
                EncodePasswordViewModel.ENCODED_VALIDATORS = [];
                EncodePasswordViewModel.MD5_HASH_VALIDATORS = [];
                return EncodePasswordViewModel;
            }();
            exports_1("EncodePasswordViewModel", EncodePasswordViewModel);
        }
    };
});

System.register("ict-external-client/gen/services/abstract_encode_password_service.js", ["ags-client/ags-client.js", "ict-external-client/gen/viewmodels/encode_password_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, encode_password_view_model_1, AbstractEncodePasswordService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }, function (encode_password_view_model_1_1) {
            encode_password_view_model_1 = encode_password_view_model_1_1;
        }],
        execute: function () {
            AbstractEncodePasswordService = /** @class */function () {
                function AbstractEncodePasswordService(backendService) {
                    this.backendService = backendService;
                }
                AbstractEncodePasswordService.prototype.encode = function (request) {
                    return this.backendService.postJson('/encodePassword/encode.json', request.serialize(), function (response) {
                        return ags_client_1.JsonResponse.deserialize(response, encode_password_view_model_1.EncodePasswordViewModel.deserialize(response.data));
                    });
                };
                return AbstractEncodePasswordService;
            }();
            exports_1("AbstractEncodePasswordService", AbstractEncodePasswordService);
        }
    };
});

System.register("ict-external-client/app/services/encode_password_service.js", ["angular2/core.js", "ict-external-client/gen/services/abstract_encode_password_service.js", "ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, abstract_encode_password_service_1, ags_client_1, EncodePasswordService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (abstract_encode_password_service_1_1) {
            abstract_encode_password_service_1 = abstract_encode_password_service_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }],
        execute: function () {
            EncodePasswordService = /** @class */function (_super) {
                __extends(EncodePasswordService, _super);
                function EncodePasswordService(backendService) {
                    return _super.call(this, backendService) || this;
                }
                EncodePasswordService = __decorate([core_1.Injectable(), core_1.Inject(ags_client_1.BackendService), __metadata("design:paramtypes", [ags_client_1.BackendService])], EncodePasswordService);
                return EncodePasswordService;
            }(abstract_encode_password_service_1.AbstractEncodePasswordService);
            exports_1("EncodePasswordService", EncodePasswordService);
        }
    };
});

System.register("ict-external-client/app/components/encode_password_form_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/ags-client.js", "ict-external-client/gen/viewmodels/encode_password_view_model.js", "ict-external-client/app/services/encode_password_service.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, ags_client_1, encode_password_view_model_1, ags_client_2, ags_client_3, ags_client_4, ags_client_5, encode_password_service_1, EncodePasswordFormComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
            ags_client_5 = ags_client_1_1;
        }, function (encode_password_view_model_1_1) {
            encode_password_view_model_1 = encode_password_view_model_1_1;
        }, function (encode_password_service_1_1) {
            encode_password_service_1 = encode_password_service_1_1;
        }],
        execute: function () {
            EncodePasswordFormComponent = /** @class */function (_super) {
                __extends(EncodePasswordFormComponent, _super);
                function EncodePasswordFormComponent(alertService, translationService, _encodePasswordService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._encodePasswordService = _encodePasswordService;
                    _this.canceled = new core_1.EventEmitter();
                    _this.submitted = new core_1.EventEmitter();
                    _this.encodePassword = new encode_password_view_model_1.EncodePasswordViewModel();
                    return _this;
                }
                EncodePasswordFormComponent.prototype.initData = function () {
                    this.encodePassword = new encode_password_view_model_1.EncodePasswordViewModel();
                };
                EncodePasswordFormComponent.prototype.buildForm = function () {
                    this.form = new common_1.ControlGroup({
                        'password': new common_1.Control('', ags_client_3.validators(encode_password_view_model_1.EncodePasswordViewModel.PASSWORD_VALIDATORS.concat([ags_client_3.password()]))),
                        'encoded': new common_1.Control(''),
                        'md5Hash': new common_1.Control('')
                    });
                };
                EncodePasswordFormComponent.prototype.cancel = function () {
                    this.canceled.emit(this.encodePassword);
                };
                EncodePasswordFormComponent.prototype.generate = function () {
                    var _this = this;
                    this.alertService.reset();
                    if (this.validate()) {
                        this.loading = true;
                        this._encodePasswordService.encode(this.encodePassword).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.encodePassword = response.data;
                                _this._reset(_this.form);
                            }
                            _this.loading = false;
                        });
                    }
                };
                __decorate([core_1.Input(), __metadata("design:type", String)], EncodePasswordFormComponent.prototype, "id", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Number)], EncodePasswordFormComponent.prototype, "EncodePasswordId", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], EncodePasswordFormComponent.prototype, "canceled", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], EncodePasswordFormComponent.prototype, "submitted", void 0);
                EncodePasswordFormComponent = __decorate([core_1.Component({
                    directives: [ags_client_1.AGS_FORM_DIRECTIVES],
                    pipes: [ags_client_1.AGS_PIPES],
                    selector: 'encode-password-form',
                    templateUrl: 'ict-external-client/app/components/encode_password_form_component.html'
                }), __metadata("design:paramtypes", [ags_client_5.AlertService, ags_client_2.TranslationService, encode_password_service_1.EncodePasswordService, core_1.ElementRef])], EncodePasswordFormComponent);
                return EncodePasswordFormComponent;
            }(ags_client_4.AbstractFormComponent);
            exports_1("EncodePasswordFormComponent", EncodePasswordFormComponent);
        }
    };
});

System.register("ict-external-client/app/views/encode_password_view.js", ["angular2/core.js", "angular2/router.js", "ags-client/ags-client.js", "ict-external-client/app/components/encode_password_form_component.js", "ict-external-client/gen/views.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, router_1, ags_client_1, ags_client_2, ags_client_3, encode_password_form_component_1, views_1, EncodePasswordView;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (router_1_1) {
            router_1 = router_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
        }, function (encode_password_form_component_1_1) {
            encode_password_form_component_1 = encode_password_form_component_1_1;
        }, function (views_1_1) {
            views_1 = views_1_1;
        }],
        execute: function () {
            EncodePasswordView = /** @class */function (_super) {
                __extends(EncodePasswordView, _super);
                function EncodePasswordView(navigationService, router) {
                    return _super.call(this, navigationService, router) || this;
                }
                __decorate([core_1.ViewChildren(encode_password_form_component_1.EncodePasswordFormComponent), __metadata("design:type", core_1.QueryList)], EncodePasswordView.prototype, "encodePasswordForm", void 0);
                EncodePasswordView = __decorate([core_1.Component({
                    selector: 'encode-password-view',
                    directives: [ags_client_1.AGS_DIRECTIVES, encode_password_form_component_1.EncodePasswordFormComponent],
                    pipes: [ags_client_1.AGS_PIPES],
                    templateUrl: 'ict-external-client/app/views/encode_password_view.html'
                }), router_1.CanActivate(function () {
                    return ags_client_1.AuthenticationService.checkViewSecurity(views_1.VIEW_SECURITY[views_1.ENCODE_PASSWORD_VIEW]);
                }), __metadata("design:paramtypes", [ags_client_2.NavigationService, router_1.Router])], EncodePasswordView);
                return EncodePasswordView;
            }(ags_client_3.AbstractView);
            exports_1("EncodePasswordView", EncodePasswordView);
        }
    };
});

System.register("ict-external-client/app/views/login_view.js", ["angular2/core.js", "angular2/router.js", "ags-client/ags-client.js", "ict-external-client/gen/views.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, router_1, ags_client_1, ags_client_2, ags_client_3, ags_client_4, ags_client_5, views_1, LoginView;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (router_1_1) {
            router_1 = router_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
            ags_client_5 = ags_client_1_1;
        }, function (views_1_1) {
            views_1 = views_1_1;
        }],
        execute: function () {
            LoginView = /** @class */function (_super) {
                __extends(LoginView, _super);
                function LoginView(navigationService, router, _translationService, routeParams) {
                    var _this = _super.call(this, navigationService, router) || this;
                    _this._translationService = _translationService;
                    _this.passwordExpired = false;
                    _this._activationLogin = routeParams.get('login');
                    _this._activationCode = routeParams.get('code');
                    return _this;
                }
                LoginView.prototype.init = function () {
                    var _this = this;
                    this.authenticationForm.first.passwordExpired.subscribe(function (authentication) {
                        _this.passwordExpired = true;
                        _this.changePasswordForm.first.login = authentication.login;
                        _this.changePasswordForm.first.focus();
                    });
                    this.changePasswordForm.first.passwordChanged.subscribe(function (changePassword) {
                        _this.passwordExpired = false;
                        var authentication = new ags_client_5.AuthenticationViewModel();
                        authentication.login = changePassword.login;
                        authentication.password = changePassword.newPassword;
                        _this.authenticationForm.first.authentication = authentication;
                        _this.authenticationForm.first.needsCaptcha = false;
                        _this.authenticationForm.first.submit();
                    });
                    var urlPath = this.router.root.currentInstruction.urlPath;
                    if (urlPath.indexOf('activate/') === 0) {
                        this.authenticationForm.first.activateAccount(this._activationLogin, this._activationCode);
                    } else if (urlPath.indexOf('lost/') === 0) {
                        this.authenticationForm.first.resetPassword(this._activationLogin, this._activationCode);
                    }
                };
                Object.defineProperty(LoginView.prototype, "language", {
                    get: function () {
                        return this._translationService.language;
                    },
                    enumerable: false,
                    configurable: true
                });
                __decorate([core_1.ViewChildren(ags_client_5.AuthenticationFormComponent), __metadata("design:type", core_1.QueryList)], LoginView.prototype, "authenticationForm", void 0);
                __decorate([core_1.ViewChildren(ags_client_4.ChangePasswordFormComponent), __metadata("design:type", core_1.QueryList)], LoginView.prototype, "changePasswordForm", void 0);
                LoginView = __decorate([core_1.Component({
                    selector: 'login-view',
                    directives: [ags_client_1.AGS_DIRECTIVES, ags_client_5.AuthenticationFormComponent, ags_client_4.ChangePasswordFormComponent],
                    pipes: [ags_client_1.AGS_PIPES],
                    templateUrl: 'ict-external-client/app/views/login_view.html'
                }), router_1.CanActivate(function () {
                    return ags_client_1.AuthenticationService.checkViewSecurity(views_1.VIEW_SECURITY[views_1.LOGIN_VIEW]);
                }), __metadata("design:paramtypes", [ags_client_3.NavigationService, router_1.Router, ags_client_3.TranslationService, router_1.RouteParams])], LoginView);
                return LoginView;
            }(ags_client_2.AbstractView);
            exports_1("LoginView", LoginView);
        }
    };
});

System.register("ict-external-client/app/views/lost_view.js", ["angular2/core.js", "angular2/router.js", "ags-client/ags-client.js", "ict-external-client/gen/views.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, router_1, ags_client_1, ags_client_2, ags_client_3, ags_client_4, views_1, LostView;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (router_1_1) {
            router_1 = router_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
        }, function (views_1_1) {
            views_1 = views_1_1;
        }],
        execute: function () {
            LostView = /** @class */function (_super) {
                __extends(LostView, _super);
                function LostView(navigationService, router) {
                    return _super.call(this, navigationService, router) || this;
                }
                __decorate([core_1.ViewChildren(ags_client_4.LostPasswordFormComponent), __metadata("design:type", core_1.QueryList)], LostView.prototype, "lostPasswordForm", void 0);
                LostView = __decorate([core_1.Component({
                    selector: 'lost-view',
                    directives: [ags_client_1.AGS_DIRECTIVES, ags_client_4.LostPasswordFormComponent],
                    pipes: [ags_client_1.AGS_PIPES],
                    templateUrl: 'ict-external-client/app/views/lost_view.html'
                }), router_1.CanActivate(function () {
                    return ags_client_1.AuthenticationService.checkViewSecurity(views_1.VIEW_SECURITY[views_1.LOST_VIEW]);
                }), __metadata("design:paramtypes", [ags_client_2.NavigationService, router_1.Router])], LostView);
                return LostView;
            }(ags_client_3.AbstractView);
            exports_1("LostView", LostView);
        }
    };
});

System.register("ict-external-client/gen/viewmodels/newsletter_view_model.js", ["ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, ags_client_2, ags_client_3, ags_client_4, NewsletterViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
        }],
        execute: function () {
            NewsletterViewModel = /** @class */function () {
                function NewsletterViewModel() {}
                NewsletterViewModel.deserialize = function (object) {
                    var _result = new NewsletterViewModel();
                    return _result._deserialize(object);
                };
                NewsletterViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (ags_client_1.isPresent(object['date'])) {
                            this.date = ags_client_3.deserializeDate(object['date']);
                        }
                        if (ags_client_1.isPresent(object['subject'])) {
                            this.subject = object['subject'];
                        }
                        if (ags_client_1.isPresent(object['text'])) {
                            this.text = object['text'];
                        }
                        if (ags_client_1.isPresent(object['file'])) {
                            this.file = ags_client_4.FileViewModel.deserialize(object['file']);
                        }
                    }
                    return this;
                };
                NewsletterViewModel.prototype.serialize = function () {
                    var object = {};
                    if (ags_client_1.isPresent(this.date)) {
                        object['date'] = ags_client_2.serializeDate(this.date);
                    }
                    if (ags_client_1.isPresent(this.subject)) {
                        object['subject'] = this.subject;
                    }
                    if (ags_client_1.isPresent(this.text)) {
                        object['text'] = this.text;
                    }
                    if (ags_client_1.isPresent(this.file)) {
                        object['file'] = this.file.serialize();
                    }
                    return object;
                };
                NewsletterViewModel.DATE_VALIDATORS = [];
                NewsletterViewModel.SUBJECT_VALIDATORS = [];
                NewsletterViewModel.TEXT_VALIDATORS = [];
                NewsletterViewModel.FILE_VALIDATORS = [];
                return NewsletterViewModel;
            }();
            exports_1("NewsletterViewModel", NewsletterViewModel);
        }
    };
});

System.register("ict-external-client/gen/services/abstract_newsletter_service.js", ["ags-client/ags-client.js", "ict-external-client/gen/viewmodels/newsletter_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, newsletter_view_model_1, AbstractNewsletterService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }, function (newsletter_view_model_1_1) {
            newsletter_view_model_1 = newsletter_view_model_1_1;
        }],
        execute: function () {
            AbstractNewsletterService = /** @class */function () {
                function AbstractNewsletterService(backendService) {
                    this.backendService = backendService;
                }
                AbstractNewsletterService.prototype.newsletters = function (request) {
                    return this.backendService.getJson('/newsletter/newsletters/' + request + '.json', function (response) {
                        var data = Array();
                        response.data.forEach(function (item) {
                            data.push(newsletter_view_model_1.NewsletterViewModel.deserialize(item));
                        });
                        return ags_client_1.JsonResponse.deserialize(response, data);
                    });
                };
                return AbstractNewsletterService;
            }();
            exports_1("AbstractNewsletterService", AbstractNewsletterService);
        }
    };
});

System.register("ict-external-client/app/services/newsletter_service.js", ["angular2/core.js", "ict-external-client/gen/services/abstract_newsletter_service.js", "ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, abstract_newsletter_service_1, ags_client_1, NewsletterService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (abstract_newsletter_service_1_1) {
            abstract_newsletter_service_1 = abstract_newsletter_service_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }],
        execute: function () {
            NewsletterService = /** @class */function (_super) {
                __extends(NewsletterService, _super);
                function NewsletterService(backendService) {
                    return _super.call(this, backendService) || this;
                }
                NewsletterService = __decorate([core_1.Injectable(), core_1.Inject(ags_client_1.BackendService), __metadata("design:paramtypes", [ags_client_1.BackendService])], NewsletterService);
                return NewsletterService;
            }(abstract_newsletter_service_1.AbstractNewsletterService);
            exports_1("NewsletterService", NewsletterService);
        }
    };
});

System.register("ict-external-client/app/components/newsletters_component.js", ["angular2/core.js", "ags-client/ags-client.js", "ict-external-client/app/services/newsletter_service.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, ags_client_1, ags_client_2, ags_client_3, ags_client_4, newsletter_service_1, NewslettersComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
        }, function (newsletter_service_1_1) {
            newsletter_service_1 = newsletter_service_1_1;
        }],
        execute: function () {
            NewslettersComponent = /** @class */function (_super) {
                __extends(NewslettersComponent, _super);
                function NewslettersComponent(alertService, translationService, _newsletterService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._newsletterService = _newsletterService;
                    return _this;
                }
                NewslettersComponent.prototype.initData = function () {
                    var _this = this;
                    this._newsletterService.newsletters(this.translationService.language).subscribe(function (response) {
                        if (!_this.handleError(response)) {
                            _this.newsletters = response.data;
                        }
                    });
                };
                __decorate([core_1.Input(), __metadata("design:type", String)], NewslettersComponent.prototype, "id", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Number)], NewslettersComponent.prototype, "year", void 0);
                NewslettersComponent = __decorate([core_1.Component({
                    directives: [ags_client_1.AGS_DIRECTIVES],
                    pipes: [ags_client_1.AGS_PIPES],
                    selector: 'newsletters',
                    templateUrl: 'ict-external-client/app/components/newsletters_component.html'
                }), __metadata("design:paramtypes", [ags_client_3.AlertService, ags_client_2.TranslationService, newsletter_service_1.NewsletterService, core_1.ElementRef])], NewslettersComponent);
                return NewslettersComponent;
            }(ags_client_4.AbstractComponent);
            exports_1("NewslettersComponent", NewslettersComponent);
        }
    };
});

System.register("ict-external-client/app/views/newsletter_view.js", ["angular2/core.js", "angular2/router.js", "ags-client/ags-client.js", "ict-external-client/app/components/newsletters_component.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, router_1, ags_client_1, ags_client_2, ags_client_3, newsletters_component_1, NewsletterView;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (router_1_1) {
            router_1 = router_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
        }, function (newsletters_component_1_1) {
            newsletters_component_1 = newsletters_component_1_1;
        }],
        execute: function () {
            NewsletterView = /** @class */function (_super) {
                __extends(NewsletterView, _super);
                function NewsletterView(navigationService, router) {
                    return _super.call(this, navigationService, router) || this;
                }
                __decorate([core_1.ViewChildren(newsletters_component_1.NewslettersComponent), __metadata("design:type", core_1.QueryList)], NewsletterView.prototype, "newsletters", void 0);
                NewsletterView = __decorate([core_1.Component({
                    selector: 'newsletter-view',
                    directives: [ags_client_1.AGS_DIRECTIVES, newsletters_component_1.NewslettersComponent],
                    pipes: [ags_client_1.AGS_PIPES],
                    templateUrl: 'ict-external-client/app/views/newsletter_view.html'
                }), __metadata("design:paramtypes", [ags_client_2.NavigationService, router_1.Router])], NewsletterView);
                return NewsletterView;
            }(ags_client_3.AbstractView);
            exports_1("NewsletterView", NewsletterView);
        }
    };
});

System.register("ict-external-client/app/views/ratelist_view.js", ["angular2/core.js", "angular2/router.js", "ags-client/ags-client.js", "ict-external-client/gen/views.js", "ict-external-client/app/services/application_service.js", "ict-external-client/gen/viewmodels/online_messages_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, router_1, ags_client_1, ags_client_2, ags_client_3, views_1, application_service_1, online_messages_view_model_1, RatelistView;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (router_1_1) {
            router_1 = router_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
        }, function (views_1_1) {
            views_1 = views_1_1;
        }, function (application_service_1_1) {
            application_service_1 = application_service_1_1;
        }, function (online_messages_view_model_1_1) {
            online_messages_view_model_1 = online_messages_view_model_1_1;
        }],
        execute: function () {
            RatelistView = /** @class */function (_super) {
                __extends(RatelistView, _super);
                function RatelistView(navigationService, router, _translationService, _applicationService) {
                    var _this = _super.call(this, navigationService, router) || this;
                    _this._translationService = _translationService;
                    _this._applicationService = _applicationService;
                    _this.onlineMessages = new online_messages_view_model_1.OnlineMessagesViewModel();
                    return _this;
                }
                RatelistView.prototype.init = function () {
                    var _this = this;
                    this._applicationService.onlineMessages(this.language).subscribe(function (response) {
                        _this.onlineMessages = response.data;
                    });
                };
                Object.defineProperty(RatelistView.prototype, "language", {
                    get: function () {
                        return this._translationService.language;
                    },
                    enumerable: false,
                    configurable: true
                });
                RatelistView = __decorate([core_1.Component({
                    selector: 'ratelist-view',
                    directives: [ags_client_1.AGS_DIRECTIVES],
                    pipes: [ags_client_1.AGS_PIPES],
                    templateUrl: 'ict-external-client/app/views/ratelist_view.html'
                }), router_1.CanActivate(function () {
                    return ags_client_2.AuthenticationService.checkViewSecurity(views_1.VIEW_SECURITY[views_1.RATELIST_VIEW]);
                }), __metadata("design:paramtypes", [ags_client_2.NavigationService, router_1.Router, ags_client_1.TranslationService, application_service_1.ApplicationService])], RatelistView);
                return RatelistView;
            }(ags_client_3.AbstractView);
            exports_1("RatelistView", RatelistView);
        }
    };
});

System.register("ict-external-client/app/components/coin_bullions_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/ags-client.js", "ict-core-client/ict-core-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, ags_client_1, ags_client_2, ags_client_3, ict_core_client_1, CoinBullionsComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
        }, function (ict_core_client_1_1) {
            ict_core_client_1 = ict_core_client_1_1;
        }],
        execute: function () {
            CoinBullionsComponent = /** @class */function (_super) {
                __extends(CoinBullionsComponent, _super);
                function CoinBullionsComponent(alertService, translationService, _coreGadgetService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._coreGadgetService = _coreGadgetService;
                    _this.filterForm = new common_1.ControlGroup({
                        'valueDate': new common_1.Control('')
                    });
                    return _this;
                }
                CoinBullionsComponent.prototype.initData = function () {
                    var _this = this;
                    this._coreGadgetService.getLastWorkingDay(this.year).subscribe(function (response) {
                        if (!_this.handleError(response)) {
                            _this.valueDate = response.data.valueDate;
                            _this.loadCoinBullionsRates();
                        }
                    });
                };
                CoinBullionsComponent.prototype.loadCoinBullionsRates = function () {
                    var _this = this;
                    this.dateClass = this.valueDate.isWeekend() ? "weekend" : null;
                    this._coreGadgetService.coinBullionsDaily(ags_client_2.formatDateForLink(this.valueDate)).subscribe(function (response) {
                        if (!_this.handleError(response)) {
                            _this.gadget = response.data;
                        }
                    });
                };
                CoinBullionsComponent.prototype.valid = function () {
                    return ags_client_2.isPresent(this.valueDate);
                };
                __decorate([core_1.Input(), __metadata("design:type", String)], CoinBullionsComponent.prototype, "id", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Number)], CoinBullionsComponent.prototype, "year", void 0);
                CoinBullionsComponent = __decorate([core_1.Component({
                    directives: [ags_client_1.AGS_DIRECTIVES, ags_client_1.AGS_FORM_DIRECTIVES],
                    pipes: [ags_client_1.AGS_PIPES],
                    selector: 'coin-bullions',
                    templateUrl: 'ict-external-client/app/components/coin_bullions_component.html'
                }), __metadata("design:paramtypes", [ags_client_3.AlertService, ags_client_3.TranslationService, ict_core_client_1.CoreGadgetService, core_1.ElementRef])], CoinBullionsComponent);
                return CoinBullionsComponent;
            }(ags_client_3.AbstractComponent);
            exports_1("CoinBullionsComponent", CoinBullionsComponent);
        }
    };
});

System.register("ict-external-client/app/components/capitalization_rates_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/ags-client.js", "ict-core-client/ict-core-client.js", "ict-external-client/app/services/application_service.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, ags_client_1, ags_client_2, ags_client_3, ict_core_client_1, ict_core_client_2, application_service_1, CapitalizationRatesComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
        }, function (ict_core_client_1_1) {
            ict_core_client_1 = ict_core_client_1_1;
            ict_core_client_2 = ict_core_client_1_1;
        }, function (application_service_1_1) {
            application_service_1 = application_service_1_1;
        }],
        execute: function () {
            CapitalizationRatesComponent = /** @class */function (_super) {
                __extends(CapitalizationRatesComponent, _super);
                function CapitalizationRatesComponent(alertService, translationService, _applicationService, _coreGadgetService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._applicationService = _applicationService;
                    _this._coreGadgetService = _coreGadgetService;
                    _this.maxYear = new Date().getFullYear();
                    _this.filterForm = new common_1.ControlGroup({
                        'referenceDate': new common_1.Control(''),
                        'currency': new common_1.Control('')
                    });
                    return _this;
                }
                CapitalizationRatesComponent.prototype.initData = function () {
                    var _this = this;
                    this.minYear = this.year;
                    this._applicationService.cachedSystemParameters().then(function (systemParameters) {
                        _this.minYear = systemParameters.firstTaxYear;
                    });
                    this._coreGadgetService.capitalizationRateCurrencies().subscribe(function (response) {
                        var _currencyOptions = new Array();
                        if (!_this.handleError(response)) {
                            response.data.sort(function (a, b) {
                                return a.currency.shortName.localeCompare(b.currency.shortName);
                            });
                            response.data.forEach(function (cvm) {
                                _currencyOptions.push(_this.createSelectOption(cvm.currency.shortName));
                            });
                        }
                        _this.currencyOptions = _currencyOptions;
                    });
                    this.searchCriteria = new ict_core_client_2.CapitalizationRateGadgetSearchCriteria(0, 10);
                    this.searchCriteria.currencies = new Array();
                    this.searchCriteria.referenceDate = new Date(this.year, 11, 31);
                    this.loadCapitalizationRates();
                };
                CapitalizationRatesComponent.prototype.createSelectOption = function (currencyCode) {
                    var text = currencyCode + ' ' + this.translationService.translate('Currency:' + currencyCode);
                    return new ags_client_2.SelectOption(currencyCode, text, currencyCode);
                };
                CapitalizationRatesComponent.prototype.updateCurrencyAndLoadRates = function () {
                    if (ags_client_2.isPresent(this.selectedCurrency)) {
                        this.searchCriteria.currencies = [this.selectedCurrency];
                    } else {
                        this.searchCriteria.currencies = [];
                    }
                    this.loadCapitalizationRates();
                };
                CapitalizationRatesComponent.prototype.loadCapitalizationRates = function () {
                    var _this = this;
                    if (this.valid()) {
                        this._coreGadgetService.capitalizationRates(this.searchCriteria).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.capitalizationRate = response.data;
                            }
                        });
                    }
                };
                CapitalizationRatesComponent.prototype.valid = function () {
                    return ags_client_2.isPresent(this.searchCriteria.referenceDate);
                };
                __decorate([core_1.Input(), __metadata("design:type", String)], CapitalizationRatesComponent.prototype, "id", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Number)], CapitalizationRatesComponent.prototype, "year", void 0);
                CapitalizationRatesComponent = __decorate([core_1.Component({
                    directives: [ags_client_1.AGS_DIRECTIVES, ags_client_1.AGS_FORM_DIRECTIVES, ags_client_2.SelectYearEndDirective],
                    pipes: [ags_client_1.AGS_PIPES],
                    selector: 'capitalization-rates',
                    templateUrl: 'ict-external-client/app/components/capitalization_rates_component.html'
                }), __metadata("design:paramtypes", [ags_client_3.AlertService, ags_client_3.TranslationService, application_service_1.ApplicationService, ict_core_client_1.CoreGadgetService, core_1.ElementRef])], CapitalizationRatesComponent);
                return CapitalizationRatesComponent;
            }(ags_client_3.AbstractComponent);
            exports_1("CapitalizationRatesComponent", CapitalizationRatesComponent);
        }
    };
});

System.register("ict-external-client/app/components/exchange_rates_component.js", ["ags-client/ags-client.js", "angular2/common.js", "angular2/core.js", "ict-core-client/ict-core-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var ags_client_1, common_1, core_1, ict_core_client_1, ExchangeRatesComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (core_1_1) {
            core_1 = core_1_1;
        }, function (ict_core_client_1_1) {
            ict_core_client_1 = ict_core_client_1_1;
        }],
        execute: function () {
            ExchangeRatesComponent = /** @class */function (_super) {
                __extends(ExchangeRatesComponent, _super);
                function ExchangeRatesComponent(alertService, translationService, _coreGadgetService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._coreGadgetService = _coreGadgetService;
                    _this.filterForm = new common_1.ControlGroup({
                        'referenceDate': new common_1.Control(''),
                        'currency': new common_1.Control('')
                    });
                    return _this;
                }
                ExchangeRatesComponent.prototype.initData = function () {
                    var _this = this;
                    this.searchCriteria = new ict_core_client_1.CurrencynoteGadgetSearchCriteria(0, 10);
                    this.searchCriteria.currencies = new Array();
                    this._coreGadgetService.getLastWorkingDay(this.year).subscribe(function (response) {
                        if (!_this.handleError(response)) {
                            _this.searchCriteria.referenceDate = response.data.valueDate;
                            _this.loadExchangeRates();
                        }
                    });
                };
                ExchangeRatesComponent.prototype.updateCurrencyAndLoadExchangeRates = function () {
                    if (ags_client_1.isPresent(this.selectedCurrency)) {
                        this.searchCriteria.currencies = [this.selectedCurrency];
                    } else {
                        this.searchCriteria.currencies = [];
                    }
                    this.loadExchangeRates();
                };
                ExchangeRatesComponent.prototype.loadExchangeRates = function () {
                    var _this = this;
                    if (this.valid()) {
                        this.dateClass = this.searchCriteria.referenceDate.isWeekend() ? "weekend" : null;
                        this._coreGadgetService.exchangeRates(this.searchCriteria).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.exchangeRate = response.data;
                            }
                        });
                    }
                };
                ExchangeRatesComponent.prototype.valid = function () {
                    return ags_client_1.isPresent(this.searchCriteria.referenceDate);
                };
                __decorate([core_1.Input(), __metadata("design:type", String)], ExchangeRatesComponent.prototype, "id", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Number)], ExchangeRatesComponent.prototype, "year", void 0);
                ExchangeRatesComponent = __decorate([core_1.Component({
                    directives: [ags_client_1.AGS_DIRECTIVES, ags_client_1.AGS_FORM_DIRECTIVES, ict_core_client_1.ICT_CORE_DIRECTIVES],
                    pipes: [ags_client_1.AGS_PIPES],
                    selector: 'exchange-rates',
                    templateUrl: 'ict-external-client/app/components/exchange_rates_component.html'
                }), __metadata("design:paramtypes", [ags_client_1.AlertService, ags_client_1.TranslationService, ict_core_client_1.CoreGadgetService, core_1.ElementRef])], ExchangeRatesComponent);
                return ExchangeRatesComponent;
            }(ags_client_1.AbstractComponent);
            exports_1("ExchangeRatesComponent", ExchangeRatesComponent);
        }
    };
});

System.register("ict-external-client/gen/viewmodels/publication_view_model.js", ["ags-client/ags-client.js", "ict-core-client/ict-core-client.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, ags_client_2, ags_client_3, ags_client_4, ict_core_client_1, ags_client_5, PublicationViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
            ags_client_5 = ags_client_1_1;
        }, function (ict_core_client_1_1) {
            ict_core_client_1 = ict_core_client_1_1;
        }],
        execute: function () {
            PublicationViewModel = /** @class */function () {
                function PublicationViewModel() {}
                PublicationViewModel.deserialize = function (object) {
                    var _result = new PublicationViewModel();
                    return _result._deserialize(object);
                };
                PublicationViewModel.prototype._deserialize = function (object) {
                    var _this = this;
                    if (object) {
                        if (ags_client_1.isPresent(object['creationDate'])) {
                            this.creationDate = ags_client_3.deserializeDate(object['creationDate']);
                        }
                        if (ags_client_1.isPresent(object['publicationFile'])) {
                            this.publicationFile = ags_client_4.FileViewModel.deserialize(object['publicationFile']);
                        }
                        if (ags_client_1.isPresent(object['publicationType'])) {
                            this.publicationType = ags_client_5.enumNumberValue(ict_core_client_1.PublicationType, object['publicationType']);
                        }
                        if (ags_client_1.isPresent(object['childs'])) {
                            this.childs = [];
                            object['childs'].forEach(function (item) {
                                _this.childs.push(PublicationViewModel.deserialize(item));
                            });
                        }
                    }
                    return this;
                };
                PublicationViewModel.prototype.serialize = function () {
                    var object = {};
                    if (ags_client_1.isPresent(this.creationDate)) {
                        object['creationDate'] = ags_client_2.serializeDate(this.creationDate);
                    }
                    if (ags_client_1.isPresent(this.publicationFile)) {
                        object['publicationFile'] = this.publicationFile.serialize();
                    }
                    if (ags_client_1.isPresent(this.publicationType)) {
                        object['publicationType'] = ict_core_client_1.PublicationType[this.publicationType];
                    }
                    if (ags_client_1.isPresent(this.childs)) {
                        object['childs'] = [];
                        this.childs.forEach(function (item) {
                            object['childs'].push(item.serialize());
                        });
                    }
                    return object;
                };
                PublicationViewModel.CREATION_DATE_VALIDATORS = [];
                PublicationViewModel.PUBLICATION_FILE_VALIDATORS = [];
                PublicationViewModel.PUBLICATION_TYPE_VALIDATORS = [];
                PublicationViewModel.CHILDS_VALIDATORS = [];
                return PublicationViewModel;
            }();
            exports_1("PublicationViewModel", PublicationViewModel);
        }
    };
});

System.register("ict-external-client/gen/viewmodels/publication_category_view_model.js", ["ags-client/ags-client.js", "ict-core-client/ict-core-client.js", "ict-external-client/gen/viewmodels/publication_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, ict_core_client_1, ags_client_2, publication_view_model_1, PublicationCategoryViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
        }, function (ict_core_client_1_1) {
            ict_core_client_1 = ict_core_client_1_1;
        }, function (publication_view_model_1_1) {
            publication_view_model_1 = publication_view_model_1_1;
        }],
        execute: function () {
            PublicationCategoryViewModel = /** @class */function () {
                function PublicationCategoryViewModel() {}
                PublicationCategoryViewModel.deserialize = function (object) {
                    var _result = new PublicationCategoryViewModel();
                    return _result._deserialize(object);
                };
                PublicationCategoryViewModel.prototype._deserialize = function (object) {
                    var _this = this;
                    if (object) {
                        if (ags_client_1.isPresent(object['publicationCategory'])) {
                            this.publicationCategory = ags_client_2.enumNumberValue(ict_core_client_1.PublicationCategory, object['publicationCategory']);
                        }
                        if (ags_client_1.isPresent(object['publications'])) {
                            this.publications = [];
                            object['publications'].forEach(function (item) {
                                _this.publications.push(publication_view_model_1.PublicationViewModel.deserialize(item));
                            });
                        }
                    }
                    return this;
                };
                PublicationCategoryViewModel.prototype.serialize = function () {
                    var object = {};
                    if (ags_client_1.isPresent(this.publicationCategory)) {
                        object['publicationCategory'] = ict_core_client_1.PublicationCategory[this.publicationCategory];
                    }
                    if (ags_client_1.isPresent(this.publications)) {
                        object['publications'] = [];
                        this.publications.forEach(function (item) {
                            object['publications'].push(item.serialize());
                        });
                    }
                    return object;
                };
                PublicationCategoryViewModel.PUBLICATION_CATEGORY_VALIDATORS = [];
                PublicationCategoryViewModel.PUBLICATIONS_VALIDATORS = [];
                return PublicationCategoryViewModel;
            }();
            exports_1("PublicationCategoryViewModel", PublicationCategoryViewModel);
        }
    };
});

System.register("ict-external-client/gen/services/abstract_publication_service.js", ["ags-client/ags-client.js", "ict-core-client/ict-core-client.js", "ict-external-client/gen/viewmodels/publication_category_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, ict_core_client_1, ict_core_client_2, publication_category_view_model_1, AbstractPublicationService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }, function (ict_core_client_1_1) {
            ict_core_client_1 = ict_core_client_1_1;
            ict_core_client_2 = ict_core_client_1_1;
        }, function (publication_category_view_model_1_1) {
            publication_category_view_model_1 = publication_category_view_model_1_1;
        }],
        execute: function () {
            AbstractPublicationService = /** @class */function () {
                function AbstractPublicationService(backendService) {
                    this.backendService = backendService;
                }
                AbstractPublicationService.prototype.years = function () {
                    return this.backendService.getJson('/publication/years.json', function (response) {
                        return ags_client_1.JsonResponse.deserialize(response, response.data);
                    });
                };
                AbstractPublicationService.prototype.exchangeRates = function (request) {
                    return this.backendService.getJson('/publication/exchangeRates/' + request + '.json', function (response) {
                        var data = Array();
                        response.data.forEach(function (item) {
                            data.push(ict_core_client_1.CurrencyExchangeRateViewModel.deserialize(item));
                        });
                        return ags_client_1.JsonResponse.deserialize(response, data);
                    });
                };
                AbstractPublicationService.prototype.exchangeRatesDaily = function (request) {
                    return this.backendService.getJson('/publication/exchangeRatesDaily/' + request + '.json', function (response) {
                        var data = Array();
                        response.data.forEach(function (item) {
                            data.push(ict_core_client_1.CurrencyExchangeRateViewModel.deserialize(item));
                        });
                        return ags_client_1.JsonResponse.deserialize(response, data);
                    });
                };
                AbstractPublicationService.prototype.coinBullions = function (request) {
                    return this.backendService.getJson('/publication/coinBullions/' + request + '.json', function (response) {
                        var data = Array();
                        response.data.forEach(function (item) {
                            data.push(ict_core_client_2.CoinBullionViewModel.deserialize(item));
                        });
                        return ags_client_1.JsonResponse.deserialize(response, data);
                    });
                };
                AbstractPublicationService.prototype.coinBullionsDaily = function (request) {
                    return this.backendService.getJson('/publication/coinBullionsDaily/' + request + '.json', function (response) {
                        var data = Array();
                        response.data.forEach(function (item) {
                            data.push(ict_core_client_2.CoinBullionViewModel.deserialize(item));
                        });
                        return ags_client_1.JsonResponse.deserialize(response, data);
                    });
                };
                AbstractPublicationService.prototype.publicationCategories = function (request) {
                    return this.backendService.getJson('/publication/publicationCategories/' + request + '.json', function (response) {
                        var data = Array();
                        response.data.forEach(function (item) {
                            data.push(publication_category_view_model_1.PublicationCategoryViewModel.deserialize(item));
                        });
                        return ags_client_1.JsonResponse.deserialize(response, data);
                    });
                };
                return AbstractPublicationService;
            }();
            exports_1("AbstractPublicationService", AbstractPublicationService);
        }
    };
});

System.register("ict-external-client/app/services/publication_service.js", ["angular2/core.js", "ict-external-client/gen/services/abstract_publication_service.js", "ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, abstract_publication_service_1, ags_client_1, PublicationService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (abstract_publication_service_1_1) {
            abstract_publication_service_1 = abstract_publication_service_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }],
        execute: function () {
            PublicationService = /** @class */function (_super) {
                __extends(PublicationService, _super);
                function PublicationService(backendService) {
                    return _super.call(this, backendService) || this;
                }
                PublicationService = __decorate([core_1.Injectable(), core_1.Inject(ags_client_1.BackendService), __metadata("design:paramtypes", [ags_client_1.BackendService])], PublicationService);
                return PublicationService;
            }(abstract_publication_service_1.AbstractPublicationService);
            exports_1("PublicationService", PublicationService);
        }
    };
});

System.register("ict-external-client/app/components/publications_component.js", ["angular2/core.js", "ags-client/ags-client.js", "ict-external-client/app/services/publication_service.js", "ict-core-client/gen/enums.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, ags_client_1, ags_client_2, ags_client_3, ags_client_4, publication_service_1, enums_1, PublicationsComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
        }, function (publication_service_1_1) {
            publication_service_1 = publication_service_1_1;
        }, function (enums_1_1) {
            enums_1 = enums_1_1;
        }],
        execute: function () {
            PublicationsComponent = /** @class */function (_super) {
                __extends(PublicationsComponent, _super);
                function PublicationsComponent(alertService, translationService, _publicationService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._publicationService = _publicationService;
                    return _this;
                }
                PublicationsComponent.prototype.initData = function () {
                    var _this = this;
                    this._publicationService.publicationCategories(this.year).subscribe(function (response) {
                        if (!_this.handleError(response)) {
                            _this.publicationCategories = response.data;
                            _this.suppressHeading();
                        }
                    });
                };
                // Remove specific category code to suppress outputting its heading
                PublicationsComponent.prototype.suppressHeading = function () {
                    if (this.year >= 2022) {
                        for (var _i = 0, _a = this.publicationCategories; _i < _a.length; _i++) {
                            var pc = _a[_i];
                            if (pc.publicationCategory == enums_1.PublicationCategory.KURSLISTE) {
                                pc.publicationCategory = null;
                            }
                        }
                    }
                };
                __decorate([core_1.Input(), __metadata("design:type", String)], PublicationsComponent.prototype, "id", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Number)], PublicationsComponent.prototype, "year", void 0);
                PublicationsComponent = __decorate([core_1.Component({
                    directives: [ags_client_1.AGS_DIRECTIVES],
                    pipes: [ags_client_1.AGS_PIPES],
                    selector: 'publications',
                    templateUrl: 'ict-external-client/app/components/publications_component.html'
                }), __metadata("design:paramtypes", [ags_client_3.AlertService, ags_client_2.TranslationService, publication_service_1.PublicationService, core_1.ElementRef])], PublicationsComponent);
                return PublicationsComponent;
            }(ags_client_4.AbstractComponent);
            exports_1("PublicationsComponent", PublicationsComponent);
        }
    };
});

System.register("ict-external-client/app/components/token_gadget_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/ags-client.js", "ict-core-client/ict-core-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, ags_client_1, ags_client_2, ags_client_3, ict_core_client_1, ict_core_client_2, TokenGadgetComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
        }, function (ict_core_client_1_1) {
            ict_core_client_1 = ict_core_client_1_1;
            ict_core_client_2 = ict_core_client_1_1;
        }],
        execute: function () {
            TokenGadgetComponent = /** @class */function (_super) {
                __extends(TokenGadgetComponent, _super);
                function TokenGadgetComponent(alertService, translationService, _coreGadgetService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._coreGadgetService = _coreGadgetService;
                    _this.filterForm = new common_1.ControlGroup({
                        'referenceDate': new common_1.Control(''),
                        'token': new common_1.Control('')
                    });
                    return _this;
                }
                TokenGadgetComponent.prototype.initData = function () {
                    var _this = this;
                    this.searchCriteria = new ict_core_client_2.CurrencytokenGadgetSearchCriteria(0, 10);
                    this.searchCriteria.tokens = new Array();
                    this._coreGadgetService.tokens().subscribe(function (response) {
                        var _options = new Array();
                        if (!_this.handleError(response)) {
                            response.data.sort(function (a, b) {
                                return a.token.shortName.localeCompare(b.token.shortName);
                            });
                            response.data.forEach(function (tvm) {
                                _options.push(_this.createSelectOption(tvm.token.shortName));
                            });
                        }
                        _this.tokenOptions = _options;
                    });
                    this._coreGadgetService.getLastWorkingDay(this.year).subscribe(function (response) {
                        if (!_this.handleError(response)) {
                            _this.searchCriteria.referenceDate = response.data.valueDate;
                            _this.loadTokens();
                        }
                    });
                };
                TokenGadgetComponent.prototype.updateCriteriaAndLoadTokens = function () {
                    if (ags_client_2.isPresent(this.selectedToken)) {
                        this.searchCriteria.tokens = [this.selectedToken];
                    } else {
                        this.searchCriteria.tokens = [];
                    }
                    this.loadTokens();
                };
                TokenGadgetComponent.prototype.loadTokens = function () {
                    var _this = this;
                    if (this.valid()) {
                        this.dateClass = this.searchCriteria.referenceDate.isWeekend() ? "weekend" : null;
                        this._coreGadgetService.tokenGadget(this.searchCriteria).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.model = response.data;
                            }
                        });
                    }
                };
                TokenGadgetComponent.prototype.createSelectOption = function (tokenCode) {
                    var text = tokenCode + ' ' + this.translationService.translate('Token:' + tokenCode);
                    return new ags_client_2.SelectOption(tokenCode, text, tokenCode);
                };
                TokenGadgetComponent.prototype.valid = function () {
                    return ags_client_2.isPresent(this.searchCriteria.referenceDate);
                };
                __decorate([core_1.Input(), __metadata("design:type", String)], TokenGadgetComponent.prototype, "id", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Number)], TokenGadgetComponent.prototype, "year", void 0);
                TokenGadgetComponent = __decorate([core_1.Component({
                    directives: [ags_client_1.AGS_DIRECTIVES, ags_client_1.AGS_FORM_DIRECTIVES],
                    pipes: [ags_client_1.AGS_PIPES],
                    selector: 'token-gadget',
                    templateUrl: 'ict-external-client/app/components/token_gadget_component.html'
                }), __metadata("design:paramtypes", [ags_client_3.AlertService, ags_client_3.TranslationService, ict_core_client_1.CoreGadgetService, core_1.ElementRef])], TokenGadgetComponent);
                return TokenGadgetComponent;
            }(ags_client_3.AbstractComponent);
            exports_1("TokenGadgetComponent", TokenGadgetComponent);
        }
    };
});

System.register("ict-external-client/app/views/ratelist_year_view.js", ["angular2/core.js", "angular2/router.js", "ags-client/ags-client.js", "ict-external-client/app/components/coin_bullions_component.js", "ict-external-client/app/components/capitalization_rates_component.js", "ict-external-client/app/components/exchange_rates_component.js", "ict-external-client/app/components/publications_component.js", "ict-external-client/app/components/security_table_component.js", "ict-external-client/gen/i18n/translation_constants.js", "ict-external-client/gen/views.js", "ict-external-client/app/components/token_gadget_component.js", "ict-external-client/app/services/application_service.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, router_1, ags_client_1, ags_client_2, ags_client_3, coin_bullions_component_1, capitalization_rates_component_1, exchange_rates_component_1, publications_component_1, security_table_component_1, ags_client_4, translation_constants_1, ags_client_5, views_1, token_gadget_component_1, application_service_1, RatelistYearView;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (router_1_1) {
            router_1 = router_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
            ags_client_5 = ags_client_1_1;
        }, function (coin_bullions_component_1_1) {
            coin_bullions_component_1 = coin_bullions_component_1_1;
        }, function (capitalization_rates_component_1_1) {
            capitalization_rates_component_1 = capitalization_rates_component_1_1;
        }, function (exchange_rates_component_1_1) {
            exchange_rates_component_1 = exchange_rates_component_1_1;
        }, function (publications_component_1_1) {
            publications_component_1 = publications_component_1_1;
        }, function (security_table_component_1_1) {
            security_table_component_1 = security_table_component_1_1;
        }, function (translation_constants_1_1) {
            translation_constants_1 = translation_constants_1_1;
        }, function (views_1_1) {
            views_1 = views_1_1;
        }, function (token_gadget_component_1_1) {
            token_gadget_component_1 = token_gadget_component_1_1;
        }, function (application_service_1_1) {
            application_service_1 = application_service_1_1;
        }],
        execute: function () {
            RatelistYearView = /** @class */function (_super) {
                __extends(RatelistYearView, _super);
                function RatelistYearView(alertService, translationService, applicationService, navigationService, router, routeParams) {
                    var _this = _super.call(this, navigationService, router) || this;
                    _this.alertService = alertService;
                    _this.translationService = translationService;
                    _this.applicationService = applicationService;
                    _this.year = parseInt(routeParams.get('year'));
                    _this.applicationService.cachedSystemParameters().then(function (systemParameters) {
                        var _a, _b, _c, _d;
                        _this.showExchangeRates = (_a = systemParameters.gadgetCurrencyNotes) !== null && _a !== void 0 ? _a : true;
                        _this.showToken = (_b = systemParameters.gadgetToken) !== null && _b !== void 0 ? _b : true;
                        _this.showCoinBullions = (_c = systemParameters.gadgetCoinBullions) !== null && _c !== void 0 ? _c : true;
                        _this.showCapitalizationRates = (_d = systemParameters.gadgetCapitalizationRate) !== null && _d !== void 0 ? _d : true;
                    });
                    return _this;
                }
                RatelistYearView.prototype.focus = function () {
                    return;
                };
                RatelistYearView.prototype.open = function (securityReference) {
                    if (securityReference && ags_client_4.isSomething(securityReference.id)) {
                        this.router.navigate([views_1.SECURITY_ID_DATE_VIEW, {
                            id: securityReference.id,
                            date: this.year.toString() + '1231'
                        }]);
                    } else {
                        this.alertService.warning(this.translationService.translate(translation_constants_1.TranslationConstants.ERROR_UNKNOWN));
                    }
                };
                RatelistYearView.prototype.searchResultAvailible = function () {
                    return this.securityTable && this.securityTable.first && this.securityTable.first.securitySearchResults && this.securityTable.first.securitySearchResults.length > 0;
                };
                __decorate([core_1.ViewChildren(exchange_rates_component_1.ExchangeRatesComponent), __metadata("design:type", core_1.QueryList)], RatelistYearView.prototype, "exchangeRates", void 0);
                __decorate([core_1.ViewChildren(token_gadget_component_1.TokenGadgetComponent), __metadata("design:type", core_1.QueryList)], RatelistYearView.prototype, "tokenGadget", void 0);
                __decorate([core_1.ViewChildren(coin_bullions_component_1.CoinBullionsComponent), __metadata("design:type", core_1.QueryList)], RatelistYearView.prototype, "coinBullions", void 0);
                __decorate([core_1.ViewChildren(publications_component_1.PublicationsComponent), __metadata("design:type", core_1.QueryList)], RatelistYearView.prototype, "publications", void 0);
                __decorate([core_1.ViewChildren(security_table_component_1.SecurityTableComponent), __metadata("design:type", core_1.QueryList)], RatelistYearView.prototype, "securityTable", void 0);
                __decorate([core_1.ViewChildren(capitalization_rates_component_1.CapitalizationRatesComponent), __metadata("design:type", core_1.QueryList)], RatelistYearView.prototype, "capitalizationRates", void 0);
                RatelistYearView = __decorate([core_1.Component({
                    selector: 'ratelist-year-view',
                    directives: [ags_client_1.AGS_DIRECTIVES, exchange_rates_component_1.ExchangeRatesComponent, token_gadget_component_1.TokenGadgetComponent, coin_bullions_component_1.CoinBullionsComponent, publications_component_1.PublicationsComponent, security_table_component_1.SecurityTableComponent, capitalization_rates_component_1.CapitalizationRatesComponent],
                    pipes: [ags_client_1.AGS_PIPES],
                    templateUrl: 'ict-external-client/app/views/ratelist_year_view.html'
                }), router_1.CanActivate(function () {
                    return ags_client_1.AuthenticationService.checkViewSecurity(views_1.VIEW_SECURITY[views_1.RATELIST_YEAR_VIEW]);
                }), __metadata("design:paramtypes", [ags_client_5.AlertService, ags_client_5.TranslationService, application_service_1.ApplicationService, ags_client_2.NavigationService, router_1.Router, router_1.RouteParams])], RatelistYearView);
                return RatelistYearView;
            }(ags_client_3.AbstractView);
            exports_1("RatelistYearView", RatelistYearView);
        }
    };
});

System.register("ict-external-client/app/views/register_view.js", ["angular2/core.js", "angular2/router.js", "ags-client/ags-client.js", "ict-external-client/gen/views.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, router_1, ags_client_1, ags_client_2, ags_client_3, ags_client_4, views_1, RegisterView;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (router_1_1) {
            router_1 = router_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
        }, function (views_1_1) {
            views_1 = views_1_1;
        }],
        execute: function () {
            RegisterView = /** @class */function (_super) {
                __extends(RegisterView, _super);
                function RegisterView(navigationService, router) {
                    return _super.call(this, navigationService, router) || this;
                }
                __decorate([core_1.ViewChildren(ags_client_4.RegistrationFormComponent), __metadata("design:type", core_1.QueryList)], RegisterView.prototype, "registrationForm", void 0);
                RegisterView = __decorate([core_1.Component({
                    selector: 'register-view',
                    directives: [ags_client_1.AGS_DIRECTIVES, ags_client_4.RegistrationFormComponent],
                    pipes: [ags_client_1.AGS_PIPES],
                    templateUrl: 'ict-external-client/app/views/register_view.html'
                }), router_1.CanActivate(function () {
                    return ags_client_1.AuthenticationService.checkViewSecurity(views_1.VIEW_SECURITY[views_1.REGISTER_VIEW]);
                }), __metadata("design:paramtypes", [ags_client_2.NavigationService, router_1.Router])], RegisterView);
                return RegisterView;
            }(ags_client_3.AbstractView);
            exports_1("RegisterView", RegisterView);
        }
    };
});

System.register("ict-external-client/gen/viewmodels/export_type_view_model.js", ["ags-client/ags-client.js", "ict-core-client/ict-core-client.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, ict_core_client_1, ExportTypeViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }, function (ict_core_client_1_1) {
            ict_core_client_1 = ict_core_client_1_1;
        }],
        execute: function () {
            ExportTypeViewModel = /** @class */function () {
                function ExportTypeViewModel() {}
                ExportTypeViewModel.deserialize = function (object) {
                    var _result = new ExportTypeViewModel();
                    return _result._deserialize(object);
                };
                ExportTypeViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (ags_client_1.isPresent(object['exportType'])) {
                            this.exportType = new ict_core_client_1.ExportType(object['exportType']['shortName']);
                        }
                    }
                    return this;
                };
                ExportTypeViewModel.prototype.serialize = function () {
                    var object = {};
                    if (ags_client_1.isPresent(this.exportType)) {
                        object['exportType'] = this.exportType;
                    }
                    return object;
                };
                ExportTypeViewModel.EXPORT_TYPE_VALIDATORS = [];
                return ExportTypeViewModel;
            }();
            exports_1("ExportTypeViewModel", ExportTypeViewModel);
        }
    };
});

System.register("ict-external-client/gen/services/abstract_report_service.js", ["ags-client/ags-client.js", "ict-external-client/gen/viewmodels/export_view_model.js", "ict-external-client/gen/viewmodels/export_type_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, export_view_model_1, ags_client_2, export_type_view_model_1, AbstractReportService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
        }, function (export_view_model_1_1) {
            export_view_model_1 = export_view_model_1_1;
        }, function (export_type_view_model_1_1) {
            export_type_view_model_1 = export_type_view_model_1_1;
        }],
        execute: function () {
            AbstractReportService = /** @class */function () {
                function AbstractReportService(backendService) {
                    this.backendService = backendService;
                }
                AbstractReportService.prototype.reports = function (request) {
                    return this.backendService.postJson('/report/reports.json', request.serialize(), function (response) {
                        var data = Array();
                        response.data.forEach(function (item) {
                            data.push(export_view_model_1.ExportViewModel.deserialize(item));
                        });
                        return ags_client_1.JsonResponse.deserialize(response, data);
                    });
                };
                AbstractReportService.prototype.create = function (request) {
                    return this.backendService.postJson('/report/create.json', request.serialize(), function (response) {
                        return ags_client_1.JsonResponse.deserialize(response);
                    });
                };
                AbstractReportService.prototype.running = function () {
                    return this.backendService.getJson('/report/running.json', function (response) {
                        return ags_client_1.JsonResponse.deserialize(response, response.data);
                    });
                };
                AbstractReportService.prototype.domains = function () {
                    return this.backendService.getJson('/report/domains.json', function (response) {
                        var data = Array();
                        response.data.forEach(function (item) {
                            data.push(ags_client_2.DomainViewModel.deserialize(item));
                        });
                        return ags_client_1.JsonResponse.deserialize(response, data);
                    });
                };
                AbstractReportService.prototype.exportTypes = function () {
                    return this.backendService.getJson('/report/exportTypes.json', function (response) {
                        var data = Array();
                        response.data.forEach(function (item) {
                            data.push(export_type_view_model_1.ExportTypeViewModel.deserialize(item));
                        });
                        return ags_client_1.JsonResponse.deserialize(response, data);
                    });
                };
                AbstractReportService.prototype.canCreate = function () {
                    return this.backendService.getJson('/report/canCreate.json', function (response) {
                        return ags_client_1.JsonResponse.deserialize(response, response.data);
                    });
                };
                return AbstractReportService;
            }();
            exports_1("AbstractReportService", AbstractReportService);
        }
    };
});

System.register("ict-external-client/app/services/report_service.js", ["angular2/core.js", "ict-external-client/gen/services/abstract_report_service.js", "ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, abstract_report_service_1, ags_client_1, ReportService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (abstract_report_service_1_1) {
            abstract_report_service_1 = abstract_report_service_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }],
        execute: function () {
            ReportService = /** @class */function (_super) {
                __extends(ReportService, _super);
                function ReportService(backendService) {
                    return _super.call(this, backendService) || this;
                }
                ReportService = __decorate([core_1.Injectable(), core_1.Inject(ags_client_1.BackendService), __metadata("design:paramtypes", [ags_client_1.BackendService])], ReportService);
                return ReportService;
            }(abstract_report_service_1.AbstractReportService);
            exports_1("ReportService", ReportService);
        }
    };
});

System.register("ict-external-client/app/components/report_table_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/ags-client.js", "ict-external-client/gen/viewsearch/export_search_criteria.js", "ict-external-client/app/services/application_service.js", "ict-external-client/app/services/report_service.js", "ict-external-client/gen/i18n/translation_constants.js", "ict-external-client/gen/permissions.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, ags_client_1, ags_client_2, export_search_criteria_1, ags_client_3, ags_client_4, ags_client_5, application_service_1, report_service_1, ags_client_6, ags_client_7, translation_constants_1, permissions_1, ReportCreationState, ReportTableComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
            ags_client_5 = ags_client_1_1;
            ags_client_6 = ags_client_1_1;
            ags_client_7 = ags_client_1_1;
        }, function (export_search_criteria_1_1) {
            export_search_criteria_1 = export_search_criteria_1_1;
        }, function (application_service_1_1) {
            application_service_1 = application_service_1_1;
        }, function (report_service_1_1) {
            report_service_1 = report_service_1_1;
        }, function (translation_constants_1_1) {
            translation_constants_1 = translation_constants_1_1;
        }, function (permissions_1_1) {
            permissions_1 = permissions_1_1;
        }],
        execute: function () {
            (function (ReportCreationState) {
                ReportCreationState[ReportCreationState["RUNNING"] = 0] = "RUNNING";
                ReportCreationState[ReportCreationState["EXISTS"] = 1] = "EXISTS";
            })(ReportCreationState || exports_1("ReportCreationState", ReportCreationState = {}));
            ReportTableComponent = /** @class */function (_super) {
                __extends(ReportTableComponent, _super);
                function ReportTableComponent(alertService, translationService, _authenticationService, _applicationService, _reportService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._authenticationService = _authenticationService;
                    _this._applicationService = _applicationService;
                    _this._reportService = _reportService;
                    _this.minYear = new Date().getFullYear();
                    _this.maxYear = new Date().getFullYear();
                    _this.referingToDateOptions = new Array();
                    _this.exportTypeOptions = new Array();
                    _this.domainOptions = new Array();
                    _this._applicationService.cachedSystemParameters().then(function (systemParameters) {
                        _this.minYear = systemParameters.firstTaxYear;
                    });
                    return _this;
                }
                ReportTableComponent.prototype.initSearchCriteria = function () {
                    if (!ags_client_7.isPresent(this.exportSearchCriteria)) {
                        this.reset();
                    } else {
                        this.search();
                    }
                };
                ReportTableComponent.prototype.reset = function () {
                    var _this = this;
                    this._applicationService.cachedSystemParameters().then(function (systemParameters) {
                        _this.exportSearchCriteria = new export_search_criteria_1.ExportSearchCriteria(0, 10);
                        if (_this._authenticationService.authenticated()) {
                            _this.exportSearchCriteria.year = systemParameters.taxYearExtern;
                        } else {
                            _this.exportSearchCriteria.year = systemParameters.taxYearOnline;
                        }
                        _this.exportSearchCriteria.xsdType = null;
                        _this.exportSearchCriteria.subscribeSearch(function () {
                            _this.search();
                        });
                    });
                };
                ReportTableComponent.prototype.initData = function () {
                    var _this = this;
                    this._reportService.domains().subscribe(function (response) {
                        var domainOptions = new Array();
                        if (!_this.handleError(response)) {
                            response.data.forEach(function (domain) {
                                domainOptions.push(new ags_client_6.SelectOption(domain.id.toString(), domain.name, domain));
                            });
                        }
                        _this.domainOptions = domainOptions;
                    });
                    this._reportService.exportTypes().subscribe(function (response) {
                        var exportTypeOptions = new Array();
                        if (!_this.handleError(response)) {
                            response.data.forEach(function (exportType) {
                                var code = exportType.exportType.shortName;
                                var text = _this.translationService.translate('ExportType:' + code);
                                exportTypeOptions.push(new ags_client_6.SelectOption(code, text, code));
                            });
                        }
                        _this.exportTypeOptions = exportTypeOptions;
                    });
                };
                ReportTableComponent.prototype.buildFilterForm = function () {
                    this.filterForm = new common_1.ControlGroup({
                        'year': new common_1.Control(''),
                        'domain': new common_1.Control(''),
                        'referingToDate': new common_1.Control(''),
                        'exportType': new common_1.Control('')
                    });
                };
                ReportTableComponent.prototype.search = function () {
                    var _this = this;
                    if (this.filterForm.valid) {
                        this.loading = true;
                        this._reportService.reports(this.exportSearchCriteria).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.exportSearchCriteria.total = response.totalItems;
                                _this.exports = response.data;
                            }
                            _this._refreshReferingToDateOptions();
                            _this.loading = false;
                        });
                    }
                };
                ReportTableComponent.prototype.resetReferingDate = function () {
                    this.exportSearchCriteria.referingToDate = null;
                };
                ReportTableComponent.prototype._refreshReferingToDateOptions = function () {
                    if (!ags_client_7.isPresent(this.exportSearchCriteria.referingToDate)) {
                        var options = new Array();
                        var exports = this.exports;
                        var dates = new Array();
                        if (ags_client_7.isPresent(exports)) {
                            exports.forEach(function (exportItem) {
                                if (dates.indexOf(exportItem.exportDate.getTime()) < 0) {
                                    dates.push(exportItem.exportDate.getTime());
                                }
                                if (exportItem.referingToDate && dates.indexOf(exportItem.referingToDate.getTime()) < 0) {
                                    dates.push(exportItem.referingToDate.getTime());
                                }
                            });
                        }
                        // sort descending
                        dates.sort(function (a, b) {
                            if (a < b) {
                                return 1;
                            } else if (a > b) {
                                return -1;
                            } else {
                                return 0;
                            }
                        });
                        dates.forEach(function (timestamp) {
                            var date = new Date(timestamp);
                            var formattedDate = ags_client_7.formatDateTime(date);
                            options.push(new ags_client_6.SelectOption(formattedDate, formattedDate, date));
                        });
                        this.referingToDateOptions = options;
                    }
                };
                ReportTableComponent.prototype.canCreate = function () {
                    return this._authenticationService.hasPermission([permissions_1.REPORT_VIEW]);
                };
                ReportTableComponent.prototype.valid = function () {
                    return this.canCreate() && ags_client_7.isPresent(this.exportSearchCriteria.year) && ags_client_7.isPresent(this.exportSearchCriteria.exportType);
                };
                ReportTableComponent.prototype.create = function () {
                    var _this = this;
                    if (this.valid()) {
                        if (!ags_client_7.isPresent(this.creationState) && this._exportExists()) {
                            this.alertService.warning(this.translationService.translate(translation_constants_1.TranslationConstants.REPORT_CREATION_EXISTS));
                            this.creationState = ReportCreationState.EXISTS;
                        } else {
                            this._reportService.running().subscribe(function (response) {
                                if (!_this.handleError(response)) {
                                    if (response.data) {
                                        _this.creationState = ReportCreationState.RUNNING;
                                        _this.alertService.warning(_this.translationService.translate(translation_constants_1.TranslationConstants.REPORT_CREATION_RUNNING));
                                        _this.refreshCreationState();
                                    } else {
                                        _this._reportService.create(_this.exportSearchCriteria).subscribe(function (response2) {
                                            if (!_this.handleError(response2)) {
                                                _this.creationState = ReportCreationState.RUNNING;
                                                _this.alertService.info(_this.translationService.translate(translation_constants_1.TranslationConstants.REPORT_CREATION_STARTED));
                                                _this.refreshCreationState();
                                            }
                                        });
                                    }
                                }
                            });
                        }
                    }
                };
                ReportTableComponent.prototype.refreshCreationState = function () {
                    var _this = this;
                    ags_client_4.Timer.later(10000, function () {
                        _this._reportService.running().subscribe(function (response) {
                            if (!response.data) {
                                _this.creationState = null;
                                _this.search();
                            } else {
                                _this.refreshCreationState();
                            }
                        });
                    });
                };
                ReportTableComponent.prototype._exportExists = function () {
                    if (ags_client_7.isPresent(this.exports)) {
                        var today = ags_client_7.formatDate(new Date());
                        return this.exports.filter(function (exportItem) {
                            return today === ags_client_7.formatDate(exportItem.exportDate);
                        }).length > 0;
                    }
                    return false;
                };
                __decorate([core_1.Input(), __metadata("design:type", String)], ReportTableComponent.prototype, "id", void 0);
                __decorate([ags_client_6.PageFlow('ReportTableComponent'), __metadata("design:type", export_search_criteria_1.ExportSearchCriteria)], ReportTableComponent.prototype, "exportSearchCriteria", void 0);
                __decorate([ags_client_6.PageFlow('ReportTableComponent'), __metadata("design:type", Array)], ReportTableComponent.prototype, "exports", void 0);
                ReportTableComponent = __decorate([core_1.Component({
                    directives: [ags_client_1.AGS_FORM_DIRECTIVES],
                    pipes: [ags_client_1.AGS_PIPES],
                    selector: 'report-table',
                    templateUrl: 'ict-external-client/app/components/report_table_component.html'
                }), __metadata("design:paramtypes", [ags_client_4.AlertService, ags_client_2.TranslationService, ags_client_5.AuthenticationService, application_service_1.ApplicationService, report_service_1.ReportService, core_1.ElementRef])], ReportTableComponent);
                return ReportTableComponent;
            }(ags_client_3.AbstractTableComponent);
            exports_1("ReportTableComponent", ReportTableComponent);
        }
    };
});

System.register("ict-external-client/app/views/report_view.js", ["angular2/core.js", "angular2/router.js", "ags-client/ags-client.js", "ict-external-client/app/components/report_table_component.js", "ict-external-client/gen/views.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, router_1, ags_client_1, ags_client_2, ags_client_3, report_table_component_1, views_1, ReportView;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (router_1_1) {
            router_1 = router_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
        }, function (report_table_component_1_1) {
            report_table_component_1 = report_table_component_1_1;
        }, function (views_1_1) {
            views_1 = views_1_1;
        }],
        execute: function () {
            ReportView = /** @class */function (_super) {
                __extends(ReportView, _super);
                function ReportView(navigationService, router) {
                    return _super.call(this, navigationService, router) || this;
                }
                ReportView.prototype.refresh = function () {
                    this.reportTable.first.search();
                };
                __decorate([core_1.ViewChildren(report_table_component_1.ReportTableComponent), __metadata("design:type", core_1.QueryList)], ReportView.prototype, "reportTable", void 0);
                ReportView = __decorate([core_1.Component({
                    selector: 'report-view',
                    directives: [ags_client_1.AGS_DIRECTIVES, report_table_component_1.ReportTableComponent],
                    pipes: [ags_client_1.AGS_PIPES],
                    templateUrl: 'ict-external-client/app/views/report_view.html'
                }), router_1.CanActivate(function () {
                    return ags_client_1.AuthenticationService.checkViewSecurity(views_1.VIEW_SECURITY[views_1.REPORT_VIEW]);
                }), __metadata("design:paramtypes", [ags_client_2.NavigationService, router_1.Router])], ReportView);
                return ReportView;
            }(ags_client_3.AbstractView);
            exports_1("ReportView", ReportView);
        }
    };
});

System.register("ict-external-client/gen/viewsearch/request_search_criteria.js", ["ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var ags_client_1, ags_client_2, ags_client_3, ags_client_4, ags_client_5, RequestSearchCriteria;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
            ags_client_5 = ags_client_1_1;
        }],
        execute: function () {
            RequestSearchCriteria = /** @class */function (_super) {
                __extends(RequestSearchCriteria, _super);
                function RequestSearchCriteria(from, size) {
                    return _super.call(this, from, size) || this;
                }
                RequestSearchCriteria.create = function (from, size) {
                    return new RequestSearchCriteria(from, size);
                };
                Object.defineProperty(RequestSearchCriteria.prototype, "id", {
                    get: function () {
                        return this._id;
                    },
                    set: function (id) {
                        if (this._id !== id) {
                            this._id = id;
                            this.attributeChanged(RequestSearchCriteria.ID, id);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(RequestSearchCriteria.prototype, "year", {
                    get: function () {
                        return this._year;
                    },
                    set: function (year) {
                        if (this._year !== year) {
                            this._year = year;
                            this.attributeChanged(RequestSearchCriteria.YEAR, year);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(RequestSearchCriteria.prototype, "entryDate", {
                    get: function () {
                        return this._entryDate;
                    },
                    set: function (entryDate) {
                        if (this._entryDate !== entryDate) {
                            this._entryDate = entryDate;
                            this.attributeChanged(RequestSearchCriteria.ENTRY_DATE, entryDate);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(RequestSearchCriteria.prototype, "valorNumber", {
                    get: function () {
                        return this._valorNumber;
                    },
                    set: function (valorNumber) {
                        if (this._valorNumber !== valorNumber) {
                            this._valorNumber = valorNumber;
                            this.attributeChanged(RequestSearchCriteria.VALOR_NUMBER, valorNumber);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(RequestSearchCriteria.prototype, "isin", {
                    get: function () {
                        return this._isin;
                    },
                    set: function (isin) {
                        if (this._isin !== isin) {
                            this._isin = isin;
                            this.attributeChanged(RequestSearchCriteria.ISIN, isin);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(RequestSearchCriteria.prototype, "dossierNumber", {
                    get: function () {
                        return this._dossierNumber;
                    },
                    set: function (dossierNumber) {
                        if (this._dossierNumber !== dossierNumber) {
                            this._dossierNumber = dossierNumber;
                            this.attributeChanged(RequestSearchCriteria.DOSSIER_NUMBER, dossierNumber);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(RequestSearchCriteria.prototype, "requestReason", {
                    get: function () {
                        return this._requestReason;
                    },
                    set: function (requestReason) {
                        if (this._requestReason !== requestReason) {
                            this._requestReason = requestReason;
                            this.attributeChanged(RequestSearchCriteria.REQUEST_REASON, requestReason);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(RequestSearchCriteria.prototype, "institutionInstrumentName", {
                    get: function () {
                        return this._institutionInstrumentName;
                    },
                    set: function (institutionInstrumentName) {
                        if (this._institutionInstrumentName !== institutionInstrumentName) {
                            this._institutionInstrumentName = institutionInstrumentName;
                            this.attributeChanged(RequestSearchCriteria.INSTITUTION_INSTRUMENT_NAME, institutionInstrumentName);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(RequestSearchCriteria.prototype, "requestUser", {
                    get: function () {
                        return this._requestUser;
                    },
                    set: function (requestUser) {
                        if (this._requestUser !== requestUser) {
                            this._requestUser = requestUser;
                            this.attributeChanged(RequestSearchCriteria.REQUEST_USER, requestUser);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(RequestSearchCriteria.prototype, "email", {
                    get: function () {
                        return this._email;
                    },
                    set: function (email) {
                        if (this._email !== email) {
                            this._email = email;
                            this.attributeChanged(RequestSearchCriteria.EMAIL, email);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(RequestSearchCriteria.prototype, "requestStatus", {
                    get: function () {
                        return this._requestStatus;
                    },
                    set: function (requestStatus) {
                        if (this._requestStatus !== requestStatus) {
                            this._requestStatus = requestStatus;
                            this.attributeChanged(RequestSearchCriteria.REQUEST_STATUS, requestStatus);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                RequestSearchCriteria.prototype.reset = function () {
                    _super.prototype.reset.call(this);
                    this._id = null;
                    this._year = null;
                    this._entryDate = null;
                    this._valorNumber = null;
                    this._isin = null;
                    this._dossierNumber = null;
                    this._requestReason = null;
                    this._institutionInstrumentName = null;
                    this._requestUser = null;
                    this._email = null;
                    this._requestStatus = null;
                };
                RequestSearchCriteria.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (ags_client_2.isPresent(this.id)) {
                        object['id'] = this.id;
                    }
                    if (ags_client_2.isPresent(this.year)) {
                        object['year'] = this.year;
                    }
                    if (ags_client_2.isPresent(this.entryDate)) {
                        object['entryDate'] = ags_client_3.serializeDate(this.entryDate);
                    }
                    if (ags_client_2.isPresent(this.valorNumber)) {
                        object['valorNumber'] = this.valorNumber;
                    }
                    if (ags_client_2.isPresent(this.isin)) {
                        object['isin'] = this.isin;
                    }
                    if (ags_client_2.isPresent(this.dossierNumber)) {
                        object['dossierNumber'] = this.dossierNumber;
                    }
                    if (ags_client_2.isPresent(this.requestReason)) {
                        object['requestReason'] = ags_client_4.RequestReason[this.requestReason];
                    }
                    if (ags_client_2.isPresent(this.institutionInstrumentName)) {
                        object['institutionInstrumentName'] = this.institutionInstrumentName;
                    }
                    if (ags_client_2.isPresent(this.requestUser)) {
                        object['requestUser'] = this.requestUser;
                    }
                    if (ags_client_2.isPresent(this.email)) {
                        object['email'] = this.email;
                    }
                    if (ags_client_2.isPresent(this.requestStatus)) {
                        object['requestStatus'] = ags_client_5.RequestStatus[this.requestStatus];
                    }
                    return object;
                };
                RequestSearchCriteria.ID = 'id';
                RequestSearchCriteria.YEAR = 'year';
                RequestSearchCriteria.ENTRY_DATE = 'entryDate';
                RequestSearchCriteria.VALOR_NUMBER = 'valorNumber';
                RequestSearchCriteria.ISIN = 'isin';
                RequestSearchCriteria.DOSSIER_NUMBER = 'dossierNumber';
                RequestSearchCriteria.REQUEST_REASON = 'requestReason';
                RequestSearchCriteria.INSTITUTION_INSTRUMENT_NAME = 'institutionInstrumentName';
                RequestSearchCriteria.REQUEST_USER = 'requestUser';
                RequestSearchCriteria.EMAIL = 'email';
                RequestSearchCriteria.REQUEST_STATUS = 'requestStatus';
                return RequestSearchCriteria;
            }(ags_client_1.SearchCriteria);
            exports_1("RequestSearchCriteria", RequestSearchCriteria);
        }
    };
});

System.register("ict-external-client/app/components/request_table_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/ags-client.js", "ict-external-client/gen/viewsearch/request_search_criteria.js", "ict-external-client/app/services/request_service.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, ags_client_1, request_search_criteria_1, ags_client_2, ags_client_3, ags_client_4, ags_client_5, ags_client_6, request_service_1, ags_client_7, RequestTableComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
            ags_client_5 = ags_client_1_1;
            ags_client_6 = ags_client_1_1;
            ags_client_7 = ags_client_1_1;
        }, function (request_search_criteria_1_1) {
            request_search_criteria_1 = request_search_criteria_1_1;
        }, function (request_service_1_1) {
            request_service_1 = request_service_1_1;
        }],
        execute: function () {
            RequestTableComponent = /** @class */function (_super) {
                __extends(RequestTableComponent, _super);
                function RequestTableComponent(alertService, translationService, _requestService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._requestService = _requestService;
                    _this.selected = new core_1.EventEmitter();
                    return _this;
                }
                RequestTableComponent.prototype.initSearchCriteria = function () {
                    var _this = this;
                    if (!ags_client_2.isPresent(this.requestSearchCriteria)) {
                        this.requestSearchCriteria = new request_search_criteria_1.RequestSearchCriteria(0, 10);
                        this.requestSearchCriteria.sort = new ags_client_4.SearchSort(request_search_criteria_1.RequestSearchCriteria.ENTRY_DATE, ags_client_4.SortDirection.DESCENDING);
                        this.requestSearchCriteria.subscribeSearch(function () {
                            _this.search();
                        });
                    }
                    this.search();
                };
                RequestTableComponent.prototype.buildFilterForm = function () {
                    this.filterForm = new common_1.ControlGroup({
                        'year': new common_1.Control(''),
                        'entryDate': new common_1.Control(''),
                        'valorNumber': new common_1.Control('', ags_client_7.validators([ags_client_7.vn()])),
                        'isin': new common_1.Control('', ags_client_7.validators([ags_client_7.isin()])),
                        'dossierNumber': new common_1.Control(''),
                        'id': new common_1.Control(''),
                        'requestReason': new common_1.Control(''),
                        'institutionInstrumentName': new common_1.Control(''),
                        'requestUser': new common_1.Control(''),
                        'email': new common_1.Control(''),
                        'requestStatus': new common_1.Control(''),
                        'language': new common_1.Control('')
                    });
                };
                RequestTableComponent.prototype.reset = function () {
                    this.requestSearchCriteria.reset();
                    this.requestSearchCriteria.sort = new ags_client_4.SearchSort(request_search_criteria_1.RequestSearchCriteria.ENTRY_DATE, ags_client_4.SortDirection.DESCENDING);
                    this.search();
                };
                RequestTableComponent.prototype.search = function () {
                    var _this = this;
                    if (this.filterForm.valid) {
                        this.loading = true;
                        this._requestService.search(this.requestSearchCriteria).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.requestSearchCriteria.total = response.totalItems;
                                _this.requestSearchResults = response.data;
                            }
                            _this.loading = false;
                        });
                    }
                };
                RequestTableComponent.prototype.select = function (request) {
                    this.selected.emit(request);
                };
                __decorate([core_1.Input(), __metadata("design:type", String)], RequestTableComponent.prototype, "id", void 0);
                __decorate([ags_client_2.PageFlow('RequestTable'), __metadata("design:type", request_search_criteria_1.RequestSearchCriteria)], RequestTableComponent.prototype, "requestSearchCriteria", void 0);
                __decorate([ags_client_2.PageFlow('RequestTable'), __metadata("design:type", Array)], RequestTableComponent.prototype, "requestSearchResults", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], RequestTableComponent.prototype, "selected", void 0);
                RequestTableComponent = __decorate([core_1.Component({
                    directives: [ags_client_1.AGS_FORM_DIRECTIVES],
                    pipes: [ags_client_1.AGS_PIPES],
                    selector: 'request-table',
                    templateUrl: 'ict-external-client/app/components/request_table_component.html'
                }), __metadata("design:paramtypes", [ags_client_6.AlertService, ags_client_3.TranslationService, request_service_1.RequestService, core_1.ElementRef])], RequestTableComponent);
                return RequestTableComponent;
            }(ags_client_5.AbstractTableComponent);
            exports_1("RequestTableComponent", RequestTableComponent);
        }
    };
});

System.register("ict-external-client/app/views/request_view.js", ["angular2/core.js", "angular2/router.js", "ags-client/ags-client.js", "ict-external-client/app/components/request_table_component.js", "ict-external-client/gen/views.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, router_1, ags_client_1, ags_client_2, ags_client_3, request_table_component_1, views_1, RequestView;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (router_1_1) {
            router_1 = router_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
        }, function (request_table_component_1_1) {
            request_table_component_1 = request_table_component_1_1;
        }, function (views_1_1) {
            views_1 = views_1_1;
        }],
        execute: function () {
            RequestView = /** @class */function (_super) {
                __extends(RequestView, _super);
                function RequestView(navigationService, router) {
                    return _super.call(this, navigationService, router) || this;
                }
                RequestView.prototype.refresh = function () {
                    this.requestTable.first.search();
                };
                RequestView.prototype.reset = function () {
                    this.requestTable.first.reset();
                };
                RequestView.prototype.create = function () {
                    this.router.navigate([views_1.REQUEST_CREATE_VIEW]);
                };
                RequestView.prototype.edit = function (request) {
                    this.router.navigate([views_1.REQUEST_ID_VIEW, { id: request.id }]);
                };
                __decorate([core_1.ViewChildren(request_table_component_1.RequestTableComponent), __metadata("design:type", core_1.QueryList)], RequestView.prototype, "requestTable", void 0);
                RequestView = __decorate([core_1.Component({
                    selector: 'request-view',
                    directives: [ags_client_1.AGS_DIRECTIVES, request_table_component_1.RequestTableComponent],
                    pipes: [ags_client_1.AGS_PIPES],
                    templateUrl: 'ict-external-client/app/views/request_view.html'
                }), router_1.CanActivate(function () {
                    return ags_client_1.AuthenticationService.checkViewSecurity(views_1.VIEW_SECURITY[views_1.REQUEST_VIEW]);
                }), __metadata("design:paramtypes", [ags_client_2.NavigationService, router_1.Router])], RequestView);
                return RequestView;
            }(ags_client_3.AbstractView);
            exports_1("RequestView", RequestView);
        }
    };
});

System.register("ict-external-client/gen/viewmodels/request_create_view_model.js", ["ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, Validators, ags_client_2, ags_client_3, ags_client_4, RequestCreateViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            Validators = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
        }],
        execute: function () {
            RequestCreateViewModel = /** @class */function () {
                function RequestCreateViewModel() {}
                RequestCreateViewModel.deserialize = function (object) {
                    var _result = new RequestCreateViewModel();
                    return _result._deserialize(object);
                };
                RequestCreateViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (ags_client_1.isPresent(object['valorNumber'])) {
                            this.valorNumber = object['valorNumber'];
                        }
                        if (ags_client_1.isPresent(object['isin'])) {
                            this.isin = object['isin'];
                        }
                        if (ags_client_1.isPresent(object['dossierNumber'])) {
                            this.dossierNumber = object['dossierNumber'];
                        }
                        if (ags_client_1.isPresent(object['year'])) {
                            this.year = object['year'];
                        }
                        if (ags_client_1.isPresent(object['institutionInstrumentName'])) {
                            this.institutionInstrumentName = object['institutionInstrumentName'];
                        }
                        if (ags_client_1.isPresent(object['instrumentGroup'])) {
                            this.instrumentGroup = ags_client_3.enumNumberValue(ags_client_2.InstrumentGroup, object['instrumentGroup']);
                        }
                        if (ags_client_1.isPresent(object['requestReason'])) {
                            this.requestReason = ags_client_3.enumNumberValue(ags_client_4.RequestReason, object['requestReason']);
                        }
                        if (ags_client_1.isPresent(object['emailResponseDesired'])) {
                            this.emailResponseDesired = object['emailResponseDesired'];
                        }
                        if (ags_client_1.isPresent(object['emailResponseNoPublication'])) {
                            this.emailResponseNoPublication = object['emailResponseNoPublication'];
                        }
                        if (ags_client_1.isPresent(object['attachSubsequently'])) {
                            this.attachSubsequently = object['attachSubsequently'];
                        }
                        if (ags_client_1.isPresent(object['message'])) {
                            this.message = object['message'];
                        }
                    }
                    return this;
                };
                RequestCreateViewModel.prototype.serialize = function () {
                    var object = {};
                    if (ags_client_1.isPresent(this.valorNumber)) {
                        object['valorNumber'] = this.valorNumber;
                    }
                    if (ags_client_1.isPresent(this.isin)) {
                        object['isin'] = this.isin;
                    }
                    if (ags_client_1.isPresent(this.dossierNumber)) {
                        object['dossierNumber'] = this.dossierNumber;
                    }
                    if (ags_client_1.isPresent(this.year)) {
                        object['year'] = this.year;
                    }
                    if (ags_client_1.isPresent(this.institutionInstrumentName)) {
                        object['institutionInstrumentName'] = this.institutionInstrumentName;
                    }
                    if (ags_client_1.isPresent(this.instrumentGroup)) {
                        object['instrumentGroup'] = ags_client_2.InstrumentGroup[this.instrumentGroup];
                    }
                    if (ags_client_1.isPresent(this.requestReason)) {
                        object['requestReason'] = ags_client_4.RequestReason[this.requestReason];
                    }
                    if (ags_client_1.isPresent(this.emailResponseDesired)) {
                        object['emailResponseDesired'] = this.emailResponseDesired;
                    }
                    if (ags_client_1.isPresent(this.emailResponseNoPublication)) {
                        object['emailResponseNoPublication'] = this.emailResponseNoPublication;
                    }
                    if (ags_client_1.isPresent(this.attachSubsequently)) {
                        object['attachSubsequently'] = this.attachSubsequently;
                    }
                    if (ags_client_1.isPresent(this.message)) {
                        object['message'] = this.message;
                    }
                    return object;
                };
                RequestCreateViewModel.VALOR_NUMBER_VALIDATORS = [Validators.vn()];
                RequestCreateViewModel.ISIN_VALIDATORS = [Validators.isin()];
                RequestCreateViewModel.DOSSIER_NUMBER_VALIDATORS = [Validators.max(40)];
                RequestCreateViewModel.YEAR_VALIDATORS = [Validators.required(), Validators.digits(4, 0)];
                RequestCreateViewModel.INSTITUTION_INSTRUMENT_NAME_VALIDATORS = [Validators.max(120)];
                RequestCreateViewModel.INSTRUMENT_GROUP_VALIDATORS = [Validators.required()];
                RequestCreateViewModel.REQUEST_REASON_VALIDATORS = [Validators.required()];
                RequestCreateViewModel.EMAIL_RESPONSE_DESIRED_VALIDATORS = [];
                RequestCreateViewModel.EMAIL_RESPONSE_NO_PUBLICATION_VALIDATORS = [];
                RequestCreateViewModel.ATTACH_SUBSEQUENTLY_VALIDATORS = [];
                RequestCreateViewModel.MESSAGE_VALIDATORS = [Validators.required()];
                return RequestCreateViewModel;
            }();
            exports_1("RequestCreateViewModel", RequestCreateViewModel);
        }
    };
});

System.register("ict-external-client/app/components/request_form_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/ags-client.js", "ict-external-client/gen/viewmodels/request_create_view_model.js", "ict-external-client/app/services/application_service.js", "ict-external-client/gen/i18n/translation_constants.js", "ict-external-client/app/services/request_service.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, ags_client_1, request_create_view_model_1, ags_client_2, ags_client_3, ags_client_4, ags_client_5, ags_client_6, ags_client_7, application_service_1, translation_constants_1, request_service_1, ags_client_8, RequestFormComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
            ags_client_5 = ags_client_1_1;
            ags_client_6 = ags_client_1_1;
            ags_client_7 = ags_client_1_1;
            ags_client_8 = ags_client_1_1;
        }, function (request_create_view_model_1_1) {
            request_create_view_model_1 = request_create_view_model_1_1;
        }, function (application_service_1_1) {
            application_service_1 = application_service_1_1;
        }, function (translation_constants_1_1) {
            translation_constants_1 = translation_constants_1_1;
        }, function (request_service_1_1) {
            request_service_1 = request_service_1_1;
        }],
        execute: function () {
            RequestFormComponent = /** @class */function (_super) {
                __extends(RequestFormComponent, _super);
                function RequestFormComponent(alertService, translationService, _applicationService, _requestService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._applicationService = _applicationService;
                    _this._requestService = _requestService;
                    _this.canceled = new core_1.EventEmitter();
                    _this.submitted = new core_1.EventEmitter();
                    _this.request = new request_create_view_model_1.RequestCreateViewModel();
                    _this.minYear = new Date().getFullYear();
                    _this.maxYear = new Date().getFullYear();
                    return _this;
                }
                RequestFormComponent.prototype.initData = function () {
                    var _this = this;
                    this.request = new request_create_view_model_1.RequestCreateViewModel();
                    this.request.attachSubsequently = false;
                    this.request.emailResponseDesired = true;
                    this.request.emailResponseNoPublication = true;
                    this._applicationService.cachedSystemParameters().then(function (systemParameters) {
                        _this.maxYear = new Date().getFullYear() + 1;
                        _this.minYear = systemParameters.firstTaxYear;
                        _this.request.year = systemParameters.taxYearExtern;
                    });
                };
                RequestFormComponent.prototype.initKeyStrokes = function () {
                    var _this = this;
                    ags_client_3.KeyStrokeManager.register(ags_client_3.KeyStroke.CANCEL, function () {
                        return _this.cancel();
                    });
                    ags_client_3.KeyStrokeManager.register(ags_client_3.KeyStroke.SAVE, function () {
                        return _this.submit();
                    });
                };
                RequestFormComponent.prototype.buildForm = function () {
                    this.form = new common_1.ControlGroup({
                        'valorNumber': new common_1.Control('', ags_client_4.validators(request_create_view_model_1.RequestCreateViewModel.VALOR_NUMBER_VALIDATORS)),
                        'isin': new common_1.Control('', ags_client_4.validators(request_create_view_model_1.RequestCreateViewModel.ISIN_VALIDATORS)),
                        'dossierNumber': new common_1.Control('', ags_client_4.validators(request_create_view_model_1.RequestCreateViewModel.DOSSIER_NUMBER_VALIDATORS)),
                        'year': new common_1.Control('', ags_client_4.validators(request_create_view_model_1.RequestCreateViewModel.YEAR_VALIDATORS)),
                        'institutionInstrumentName': new common_1.Control('', ags_client_4.validators(request_create_view_model_1.RequestCreateViewModel.INSTITUTION_INSTRUMENT_NAME_VALIDATORS)),
                        'instrumentGroup': new common_1.Control('', ags_client_4.validators(request_create_view_model_1.RequestCreateViewModel.INSTRUMENT_GROUP_VALIDATORS)),
                        'requestReason': new common_1.Control('', ags_client_4.validators(request_create_view_model_1.RequestCreateViewModel.REQUEST_REASON_VALIDATORS)),
                        'emailResponseDesired': new common_1.Control(''),
                        'emailResponseNoPublication': new common_1.Control(''),
                        'attachSubsequently': new common_1.Control(''),
                        'message': new common_1.Control('', ags_client_4.validators(request_create_view_model_1.RequestCreateViewModel.MESSAGE_VALIDATORS))
                    });
                };
                RequestFormComponent.prototype.filesSelected = function (attachments) {
                    this.attachments = attachments;
                };
                RequestFormComponent.prototype.cancel = function () {
                    this.canceled.emit(null);
                };
                RequestFormComponent.prototype.validate = function () {
                    var result = _super.prototype.validate.call(this);
                    if (!ags_client_7.isPresent(this.request.valorNumber) && !ags_client_7.isSomething(this.request.isin) && !ags_client_7.isSomething(this.request.institutionInstrumentName)) {
                        this.alertService.error(this.translationService.translate(translation_constants_1.TranslationConstants.REQUEST_REQUIRED_MESSAGE));
                        return false;
                    }
                    return result;
                };
                RequestFormComponent.prototype.submit = function () {
                    var _this = this;
                    this.alertService.reset();
                    if (this.validate()) {
                        this.loading = true;
                        this._requestService.store(this.request).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                if (_this.attachments && _this.attachments.length > 0) {
                                    _this._requestService.uploadAttachments(response.data, _this.attachments).subscribe(function (response2) {
                                        if (!_this.handleErrors(response2)) {
                                            _this.submitted.emit(null);
                                        }
                                        _this.loading = false;
                                    });
                                } else {
                                    _this.loading = false;
                                    _this.submitted.emit(null);
                                }
                            } else {
                                _this.loading = false;
                            }
                        });
                    }
                };
                __decorate([core_1.Input(), __metadata("design:type", String)], RequestFormComponent.prototype, "id", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Number)], RequestFormComponent.prototype, "requestId", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], RequestFormComponent.prototype, "canceled", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], RequestFormComponent.prototype, "submitted", void 0);
                RequestFormComponent = __decorate([core_1.Component({
                    directives: [ags_client_1.AGS_FORM_DIRECTIVES, ags_client_8.AttachmentsComponent],
                    pipes: [ags_client_1.AGS_PIPES],
                    selector: 'request-form',
                    templateUrl: 'ict-external-client/app/components/request_form_component.html'
                }), __metadata("design:paramtypes", [ags_client_6.AlertService, ags_client_2.TranslationService, application_service_1.ApplicationService, request_service_1.RequestService, core_1.ElementRef])], RequestFormComponent);
                return RequestFormComponent;
            }(ags_client_5.AbstractFormComponent);
            exports_1("RequestFormComponent", RequestFormComponent);
        }
    };
});

System.register("ict-external-client/app/views/request_create_view.js", ["angular2/core.js", "angular2/router.js", "ags-client/ags-client.js", "ict-external-client/app/components/request_form_component.js", "ict-external-client/gen/views.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, router_1, ags_client_1, ags_client_2, ags_client_3, request_form_component_1, views_1, RequestCreateView;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (router_1_1) {
            router_1 = router_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
        }, function (request_form_component_1_1) {
            request_form_component_1 = request_form_component_1_1;
        }, function (views_1_1) {
            views_1 = views_1_1;
        }],
        execute: function () {
            RequestCreateView = /** @class */function (_super) {
                __extends(RequestCreateView, _super);
                function RequestCreateView(navigationService, router) {
                    return _super.call(this, navigationService, router) || this;
                }
                RequestCreateView.prototype.goBack = function () {
                    this.router.navigate([views_1.REQUEST_VIEW]);
                };
                __decorate([core_1.ViewChildren(request_form_component_1.RequestFormComponent), __metadata("design:type", core_1.QueryList)], RequestCreateView.prototype, "requestForm", void 0);
                RequestCreateView = __decorate([core_1.Component({
                    selector: 'request-create-view',
                    directives: [ags_client_1.AGS_DIRECTIVES, request_form_component_1.RequestFormComponent],
                    pipes: [ags_client_1.AGS_PIPES],
                    templateUrl: 'ict-external-client/app/views/request_create_view.html'
                }), router_1.CanActivate(function () {
                    return ags_client_1.AuthenticationService.checkViewSecurity(views_1.VIEW_SECURITY[views_1.REQUEST_CREATE_VIEW]);
                }), __metadata("design:paramtypes", [ags_client_2.NavigationService, router_1.Router])], RequestCreateView);
                return RequestCreateView;
            }(ags_client_3.AbstractView);
            exports_1("RequestCreateView", RequestCreateView);
        }
    };
});

System.register("ict-external-client/app/components/request_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/ags-client.js", "ict-external-client/app/services/request_service.js", "ict-external-client/gen/i18n/translation_constants.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, ags_client_1, ags_client_2, request_service_1, ags_client_3, ags_client_4, translation_constants_1, ags_client_5, ags_client_6, RequestComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
            ags_client_5 = ags_client_1_1;
            ags_client_6 = ags_client_1_1;
        }, function (request_service_1_1) {
            request_service_1 = request_service_1_1;
        }, function (translation_constants_1_1) {
            translation_constants_1 = translation_constants_1_1;
        }],
        execute: function () {
            RequestComponent = /** @class */function (_super) {
                __extends(RequestComponent, _super);
                function RequestComponent(alertService, translationService, _confirmationService, _requestService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._confirmationService = _confirmationService;
                    _this._requestService = _requestService;
                    _this.withdrawed = new core_1.EventEmitter();
                    return _this;
                }
                RequestComponent.prototype.initData = function () {
                    this.refresh();
                };
                RequestComponent.prototype.buildForm = function () {
                    this.form = new common_1.ControlGroup({
                        'message': new common_1.Control('', ags_client_5.validators([ags_client_5.required()]))
                    });
                };
                RequestComponent.prototype.refresh = function () {
                    var _this = this;
                    if (ags_client_4.isPresent(this.requestId)) {
                        this.loading = true;
                        this._requestService.request(this.requestId).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.request = response.data;
                            }
                            _this.loading = false;
                        });
                    }
                };
                RequestComponent.prototype.withdraw = function () {
                    var _this = this;
                    var message = this.translationService.translate(translation_constants_1.TranslationConstants.REQUEST_WITHDRAW_CONFIRMATION);
                    this._confirmationService.confirm(message, function () {
                        _this.loading = true;
                        _this._requestService.withdraw(_this.requestId).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.withdrawed.emit(null);
                            }
                            _this.loading = false;
                        });
                    });
                };
                RequestComponent.prototype.sendMessage = function () {
                    var _this = this;
                    this.alertService.reset();
                    if (this.validate()) {
                        this.loading = true;
                        var message = new ags_client_6.MessageViewModel();
                        message.referenceId = this.requestId;
                        message.text = this.newMessage;
                        this._requestService.sendMessage(message).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.newMessage = null;
                                _this.reset();
                                _this.refresh();
                            }
                            _this.loading = false;
                        });
                    }
                };
                RequestComponent.prototype.filesSelected = function (attachments) {
                    var _this = this;
                    if (attachments && attachments.length > 0) {
                        this.loading = true;
                        this._requestService.uploadAttachments(this.requestId, attachments).subscribe(function (response2) {
                            if (!_this.handleErrors(response2)) {
                                _this.refresh();
                            } else {
                                _this.loading = false;
                            }
                        });
                    }
                };
                __decorate([core_1.Input(), __metadata("design:type", String)], RequestComponent.prototype, "id", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Number)], RequestComponent.prototype, "requestId", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], RequestComponent.prototype, "withdrawed", void 0);
                RequestComponent = __decorate([core_1.Component({
                    directives: [ags_client_1.AGS_FORM_DIRECTIVES, ags_client_6.AttachmentsComponent],
                    pipes: [ags_client_1.AGS_PIPES],
                    selector: 'request',
                    templateUrl: 'ict-external-client/app/components/request_component.html'
                }), __metadata("design:paramtypes", [ags_client_2.AlertService, ags_client_2.TranslationService, ags_client_3.ConfirmationService, request_service_1.RequestService, core_1.ElementRef])], RequestComponent);
                return RequestComponent;
            }(ags_client_2.AbstractFormComponent);
            exports_1("RequestComponent", RequestComponent);
        }
    };
});

System.register("ict-external-client/gen/viewmodels/request_search_result_view_model.js", ["ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var ags_client_1, ags_client_2, Validators, ags_client_3, ags_client_4, ags_client_5, ags_client_6, ags_client_7, RequestSearchResultViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            Validators = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
            ags_client_5 = ags_client_1_1;
            ags_client_6 = ags_client_1_1;
            ags_client_7 = ags_client_1_1;
        }],
        execute: function () {
            RequestSearchResultViewModel = /** @class */function (_super) {
                __extends(RequestSearchResultViewModel, _super);
                function RequestSearchResultViewModel() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                RequestSearchResultViewModel.deserialize = function (object) {
                    var _result = new RequestSearchResultViewModel();
                    return _result._deserialize(object);
                };
                RequestSearchResultViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        _super.prototype._deserialize.call(this, object);
                        if (ags_client_1.isPresent(object['year'])) {
                            this.year = object['year'];
                        }
                        if (ags_client_1.isPresent(object['entryDate'])) {
                            this.entryDate = ags_client_4.deserializeDate(object['entryDate']);
                        }
                        if (ags_client_1.isPresent(object['valorNumber'])) {
                            this.valorNumber = object['valorNumber'];
                        }
                        if (ags_client_1.isPresent(object['isin'])) {
                            this.isin = object['isin'];
                        }
                        if (ags_client_1.isPresent(object['dossierNumber'])) {
                            this.dossierNumber = object['dossierNumber'];
                        }
                        if (ags_client_1.isPresent(object['requestReason'])) {
                            this.requestReason = ags_client_6.enumNumberValue(ags_client_5.RequestReason, object['requestReason']);
                        }
                        if (ags_client_1.isPresent(object['institutionInstrumentName'])) {
                            this.institutionInstrumentName = object['institutionInstrumentName'];
                        }
                        if (ags_client_1.isPresent(object['requestUser'])) {
                            this.requestUser = object['requestUser'];
                        }
                        if (ags_client_1.isPresent(object['email'])) {
                            this.email = object['email'];
                        }
                        if (ags_client_1.isPresent(object['requestStatus'])) {
                            this.requestStatus = ags_client_6.enumNumberValue(ags_client_7.RequestStatus, object['requestStatus']);
                        }
                    }
                    return this;
                };
                RequestSearchResultViewModel.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (ags_client_1.isPresent(this.year)) {
                        object['year'] = this.year;
                    }
                    if (ags_client_1.isPresent(this.entryDate)) {
                        object['entryDate'] = ags_client_3.serializeDate(this.entryDate);
                    }
                    if (ags_client_1.isPresent(this.valorNumber)) {
                        object['valorNumber'] = this.valorNumber;
                    }
                    if (ags_client_1.isPresent(this.isin)) {
                        object['isin'] = this.isin;
                    }
                    if (ags_client_1.isPresent(this.dossierNumber)) {
                        object['dossierNumber'] = this.dossierNumber;
                    }
                    if (ags_client_1.isPresent(this.requestReason)) {
                        object['requestReason'] = ags_client_5.RequestReason[this.requestReason];
                    }
                    if (ags_client_1.isPresent(this.institutionInstrumentName)) {
                        object['institutionInstrumentName'] = this.institutionInstrumentName;
                    }
                    if (ags_client_1.isPresent(this.requestUser)) {
                        object['requestUser'] = this.requestUser;
                    }
                    if (ags_client_1.isPresent(this.email)) {
                        object['email'] = this.email;
                    }
                    if (ags_client_1.isPresent(this.requestStatus)) {
                        object['requestStatus'] = ags_client_7.RequestStatus[this.requestStatus];
                    }
                    return object;
                };
                RequestSearchResultViewModel.YEAR_VALIDATORS = [Validators.required(), Validators.digits(4, 0)];
                RequestSearchResultViewModel.ENTRY_DATE_VALIDATORS = [Validators.date, Validators.required(), Validators.dateTime()];
                RequestSearchResultViewModel.VALOR_NUMBER_VALIDATORS = [Validators.vn()];
                RequestSearchResultViewModel.ISIN_VALIDATORS = [Validators.isin()];
                RequestSearchResultViewModel.DOSSIER_NUMBER_VALIDATORS = [Validators.max(40)];
                RequestSearchResultViewModel.REQUEST_REASON_VALIDATORS = [];
                RequestSearchResultViewModel.INSTITUTION_INSTRUMENT_NAME_VALIDATORS = [Validators.max(120)];
                RequestSearchResultViewModel.REQUEST_USER_VALIDATORS = [Validators.required()];
                RequestSearchResultViewModel.EMAIL_VALIDATORS = [];
                RequestSearchResultViewModel.REQUEST_STATUS_VALIDATORS = [Validators.required()];
                return RequestSearchResultViewModel;
            }(ags_client_2.EntityViewModel);
            exports_1("RequestSearchResultViewModel", RequestSearchResultViewModel);
        }
    };
});

System.register("ict-external-client/gen/viewmodels/message_view_model.js", ["ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var ags_client_1, ags_client_2, Validators, ags_client_3, ags_client_4, MessageViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            Validators = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
        }],
        execute: function () {
            MessageViewModel = /** @class */function (_super) {
                __extends(MessageViewModel, _super);
                function MessageViewModel() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MessageViewModel.deserialize = function (object) {
                    var _result = new MessageViewModel();
                    return _result._deserialize(object);
                };
                MessageViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        _super.prototype._deserialize.call(this, object);
                        if (ags_client_1.isPresent(object['messageUser'])) {
                            this.messageUser = object['messageUser'];
                        }
                        if (ags_client_1.isPresent(object['messageDate'])) {
                            this.messageDate = ags_client_4.deserializeDate(object['messageDate']);
                        }
                        if (ags_client_1.isPresent(object['messageText'])) {
                            this.messageText = object['messageText'];
                        }
                    }
                    return this;
                };
                MessageViewModel.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (ags_client_1.isPresent(this.messageUser)) {
                        object['messageUser'] = this.messageUser;
                    }
                    if (ags_client_1.isPresent(this.messageDate)) {
                        object['messageDate'] = ags_client_3.serializeDate(this.messageDate);
                    }
                    if (ags_client_1.isPresent(this.messageText)) {
                        object['messageText'] = this.messageText;
                    }
                    return object;
                };
                MessageViewModel.MESSAGE_USER_VALIDATORS = [Validators.required()];
                MessageViewModel.MESSAGE_DATE_VALIDATORS = [Validators.date, Validators.required(), Validators.dateTime()];
                MessageViewModel.MESSAGE_TEXT_VALIDATORS = [Validators.required(), Validators.max(4000)];
                return MessageViewModel;
            }(ags_client_2.EntityViewModel);
            exports_1("MessageViewModel", MessageViewModel);
        }
    };
});

System.register("ict-external-client/gen/viewmodels/attachment_view_model.js", ["ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var ags_client_1, ags_client_2, Validators, ags_client_3, AttachmentViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            Validators = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
        }],
        execute: function () {
            AttachmentViewModel = /** @class */function (_super) {
                __extends(AttachmentViewModel, _super);
                function AttachmentViewModel() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                AttachmentViewModel.deserialize = function (object) {
                    var _result = new AttachmentViewModel();
                    return _result._deserialize(object);
                };
                AttachmentViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        _super.prototype._deserialize.call(this, object);
                        if (ags_client_1.isPresent(object['attachFile'])) {
                            this.attachFile = ags_client_3.FileViewModel.deserialize(object['attachFile']);
                        }
                    }
                    return this;
                };
                AttachmentViewModel.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (ags_client_1.isPresent(this.attachFile)) {
                        object['attachFile'] = this.attachFile.serialize();
                    }
                    return object;
                };
                AttachmentViewModel.ATTACH_FILE_VALIDATORS = [Validators.required()];
                return AttachmentViewModel;
            }(ags_client_2.EntityViewModel);
            exports_1("AttachmentViewModel", AttachmentViewModel);
        }
    };
});

System.register("ict-external-client/gen/viewmodels/request_view_model.js", ["ags-client/ags-client.js", "ict-external-client/gen/viewmodels/message_view_model.js", "ict-external-client/gen/viewmodels/attachment_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var ags_client_1, ags_client_2, Validators, ags_client_3, ags_client_4, ags_client_5, ags_client_6, ags_client_7, ags_client_8, ags_client_9, message_view_model_1, attachment_view_model_1, RequestViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            Validators = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
            ags_client_5 = ags_client_1_1;
            ags_client_6 = ags_client_1_1;
            ags_client_7 = ags_client_1_1;
            ags_client_8 = ags_client_1_1;
            ags_client_9 = ags_client_1_1;
        }, function (message_view_model_1_1) {
            message_view_model_1 = message_view_model_1_1;
        }, function (attachment_view_model_1_1) {
            attachment_view_model_1 = attachment_view_model_1_1;
        }],
        execute: function () {
            RequestViewModel = /** @class */function (_super) {
                __extends(RequestViewModel, _super);
                function RequestViewModel() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                RequestViewModel.deserialize = function (object) {
                    var _result = new RequestViewModel();
                    return _result._deserialize(object);
                };
                RequestViewModel.prototype._deserialize = function (object) {
                    var _this = this;
                    if (object) {
                        _super.prototype._deserialize.call(this, object);
                        if (ags_client_1.isPresent(object['entryDate'])) {
                            this.entryDate = ags_client_4.deserializeDate(object['entryDate']);
                        }
                        if (ags_client_1.isPresent(object['year'])) {
                            this.year = object['year'];
                        }
                        if (ags_client_1.isPresent(object['requestReason'])) {
                            this.requestReason = ags_client_6.enumNumberValue(ags_client_5.RequestReason, object['requestReason']);
                        }
                        if (ags_client_1.isPresent(object['requestStatus'])) {
                            this.requestStatus = ags_client_6.enumNumberValue(ags_client_7.RequestStatus, object['requestStatus']);
                        }
                        if (ags_client_1.isPresent(object['requestUser'])) {
                            this.requestUser = object['requestUser'];
                        }
                        if (ags_client_1.isPresent(object['email'])) {
                            this.email = object['email'];
                        }
                        if (ags_client_1.isPresent(object['dossierNumber'])) {
                            this.dossierNumber = object['dossierNumber'];
                        }
                        if (ags_client_1.isPresent(object['emailResponseDesired'])) {
                            this.emailResponseDesired = object['emailResponseDesired'];
                        }
                        if (ags_client_1.isPresent(object['emailResponseNoPublication'])) {
                            this.emailResponseNoPublication = object['emailResponseNoPublication'];
                        }
                        if (ags_client_1.isPresent(object['attachSubsequently'])) {
                            this.attachSubsequently = object['attachSubsequently'];
                        }
                        if (ags_client_1.isPresent(object['valorNumber'])) {
                            this.valorNumber = object['valorNumber'];
                        }
                        if (ags_client_1.isPresent(object['isin'])) {
                            this.isin = object['isin'];
                        }
                        if (ags_client_1.isPresent(object['instrumentGroup'])) {
                            this.instrumentGroup = ags_client_6.enumNumberValue(ags_client_8.InstrumentGroup, object['instrumentGroup']);
                        }
                        if (ags_client_1.isPresent(object['institutionInstrumentName'])) {
                            this.institutionInstrumentName = object['institutionInstrumentName'];
                        }
                        if (ags_client_1.isPresent(object['annualReportRequested'])) {
                            this.annualReportRequested = ags_client_6.enumNumberValue(ags_client_9.AnnualReportRequested, object['annualReportRequested']);
                        }
                        if (ags_client_1.isPresent(object['messages'])) {
                            this.messages = [];
                            object['messages'].forEach(function (item) {
                                _this.messages.push(message_view_model_1.MessageViewModel.deserialize(item));
                            });
                        }
                        if (ags_client_1.isPresent(object['attachments'])) {
                            this.attachments = [];
                            object['attachments'].forEach(function (item) {
                                _this.attachments.push(attachment_view_model_1.AttachmentViewModel.deserialize(item));
                            });
                        }
                    }
                    return this;
                };
                RequestViewModel.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (ags_client_1.isPresent(this.entryDate)) {
                        object['entryDate'] = ags_client_3.serializeDate(this.entryDate);
                    }
                    if (ags_client_1.isPresent(this.year)) {
                        object['year'] = this.year;
                    }
                    if (ags_client_1.isPresent(this.requestReason)) {
                        object['requestReason'] = ags_client_5.RequestReason[this.requestReason];
                    }
                    if (ags_client_1.isPresent(this.requestStatus)) {
                        object['requestStatus'] = ags_client_7.RequestStatus[this.requestStatus];
                    }
                    if (ags_client_1.isPresent(this.requestUser)) {
                        object['requestUser'] = this.requestUser;
                    }
                    if (ags_client_1.isPresent(this.email)) {
                        object['email'] = this.email;
                    }
                    if (ags_client_1.isPresent(this.dossierNumber)) {
                        object['dossierNumber'] = this.dossierNumber;
                    }
                    if (ags_client_1.isPresent(this.emailResponseDesired)) {
                        object['emailResponseDesired'] = this.emailResponseDesired;
                    }
                    if (ags_client_1.isPresent(this.emailResponseNoPublication)) {
                        object['emailResponseNoPublication'] = this.emailResponseNoPublication;
                    }
                    if (ags_client_1.isPresent(this.attachSubsequently)) {
                        object['attachSubsequently'] = this.attachSubsequently;
                    }
                    if (ags_client_1.isPresent(this.valorNumber)) {
                        object['valorNumber'] = this.valorNumber;
                    }
                    if (ags_client_1.isPresent(this.isin)) {
                        object['isin'] = this.isin;
                    }
                    if (ags_client_1.isPresent(this.instrumentGroup)) {
                        object['instrumentGroup'] = ags_client_8.InstrumentGroup[this.instrumentGroup];
                    }
                    if (ags_client_1.isPresent(this.institutionInstrumentName)) {
                        object['institutionInstrumentName'] = this.institutionInstrumentName;
                    }
                    if (ags_client_1.isPresent(this.annualReportRequested)) {
                        object['annualReportRequested'] = ags_client_9.AnnualReportRequested[this.annualReportRequested];
                    }
                    if (ags_client_1.isPresent(this.messages)) {
                        object['messages'] = [];
                        this.messages.forEach(function (item) {
                            object['messages'].push(item.serialize());
                        });
                    }
                    if (ags_client_1.isPresent(this.attachments)) {
                        object['attachments'] = [];
                        this.attachments.forEach(function (item) {
                            object['attachments'].push(item.serialize());
                        });
                    }
                    return object;
                };
                RequestViewModel.ENTRY_DATE_VALIDATORS = [Validators.date, Validators.required(), Validators.dateTime()];
                RequestViewModel.YEAR_VALIDATORS = [Validators.required(), Validators.digits(4, 0)];
                RequestViewModel.REQUEST_REASON_VALIDATORS = [];
                RequestViewModel.REQUEST_STATUS_VALIDATORS = [Validators.required()];
                RequestViewModel.REQUEST_USER_VALIDATORS = [Validators.required()];
                RequestViewModel.EMAIL_VALIDATORS = [];
                RequestViewModel.DOSSIER_NUMBER_VALIDATORS = [Validators.max(40)];
                RequestViewModel.EMAIL_RESPONSE_DESIRED_VALIDATORS = [];
                RequestViewModel.EMAIL_RESPONSE_NO_PUBLICATION_VALIDATORS = [];
                RequestViewModel.ATTACH_SUBSEQUENTLY_VALIDATORS = [];
                RequestViewModel.VALOR_NUMBER_VALIDATORS = [Validators.vn()];
                RequestViewModel.ISIN_VALIDATORS = [Validators.isin()];
                RequestViewModel.INSTRUMENT_GROUP_VALIDATORS = [Validators.required()];
                RequestViewModel.INSTITUTION_INSTRUMENT_NAME_VALIDATORS = [Validators.max(120)];
                RequestViewModel.ANNUAL_REPORT_REQUESTED_VALIDATORS = [];
                RequestViewModel.MESSAGES_VALIDATORS = [];
                RequestViewModel.ATTACHMENTS_VALIDATORS = [];
                return RequestViewModel;
            }(ags_client_2.EntityViewModel);
            exports_1("RequestViewModel", RequestViewModel);
        }
    };
});

System.register("ict-external-client/gen/viewmodels/request_information_view_model.js", ["ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, ags_client_2, ags_client_3, RequestInformationViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
        }],
        execute: function () {
            RequestInformationViewModel = /** @class */function () {
                function RequestInformationViewModel() {}
                RequestInformationViewModel.deserialize = function (object) {
                    var _result = new RequestInformationViewModel();
                    return _result._deserialize(object);
                };
                RequestInformationViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (ags_client_1.isPresent(object['instrumentGroup'])) {
                            this.instrumentGroup = ags_client_3.enumNumberValue(ags_client_2.InstrumentGroup, object['instrumentGroup']);
                        }
                    }
                    return this;
                };
                RequestInformationViewModel.prototype.serialize = function () {
                    var object = {};
                    if (ags_client_1.isPresent(this.instrumentGroup)) {
                        object['instrumentGroup'] = ags_client_2.InstrumentGroup[this.instrumentGroup];
                    }
                    return object;
                };
                RequestInformationViewModel.INSTRUMENT_GROUP_VALIDATORS = [];
                return RequestInformationViewModel;
            }();
            exports_1("RequestInformationViewModel", RequestInformationViewModel);
        }
    };
});

System.register("ict-external-client/gen/services/abstract_request_service.js", ["ags-client/ags-client.js", "ict-external-client/gen/viewmodels/request_search_result_view_model.js", "ict-external-client/gen/viewmodels/request_view_model.js", "ict-external-client/gen/viewmodels/request_information_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, request_search_result_view_model_1, request_view_model_1, request_information_view_model_1, AbstractRequestService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }, function (request_search_result_view_model_1_1) {
            request_search_result_view_model_1 = request_search_result_view_model_1_1;
        }, function (request_view_model_1_1) {
            request_view_model_1 = request_view_model_1_1;
        }, function (request_information_view_model_1_1) {
            request_information_view_model_1 = request_information_view_model_1_1;
        }],
        execute: function () {
            AbstractRequestService = /** @class */function () {
                function AbstractRequestService(backendService) {
                    this.backendService = backendService;
                }
                AbstractRequestService.prototype.search = function (request) {
                    return this.backendService.postJson('/request/search.json', request.serialize(), function (response) {
                        var data = Array();
                        response.data.forEach(function (item) {
                            data.push(request_search_result_view_model_1.RequestSearchResultViewModel.deserialize(item));
                        });
                        return ags_client_1.JsonResponse.deserialize(response, data);
                    });
                };
                AbstractRequestService.prototype.request = function (request) {
                    return this.backendService.getJson('/request/request/' + request + '.json', function (response) {
                        return ags_client_1.JsonResponse.deserialize(response, request_view_model_1.RequestViewModel.deserialize(response.data));
                    });
                };
                AbstractRequestService.prototype.withdraw = function (request) {
                    return this.backendService.getJson('/request/withdraw/' + request + '.json', function (response) {
                        return ags_client_1.JsonResponse.deserialize(response);
                    });
                };
                AbstractRequestService.prototype.sendMessage = function (request) {
                    return this.backendService.postJson('/request/sendMessage.json', request.serialize(), function (response) {
                        return ags_client_1.JsonResponse.deserialize(response);
                    });
                };
                AbstractRequestService.prototype.information = function (request) {
                    return this.backendService.postJson('/request/information.json', request.serialize(), function (response) {
                        return ags_client_1.JsonResponse.deserialize(response, request_information_view_model_1.RequestInformationViewModel.deserialize(response.data));
                    });
                };
                AbstractRequestService.prototype.store = function (request) {
                    return this.backendService.postJson('/request/store.json', request.serialize(), function (response) {
                        return ags_client_1.JsonResponse.deserialize(response, response.data);
                    });
                };
                return AbstractRequestService;
            }();
            exports_1("AbstractRequestService", AbstractRequestService);
        }
    };
});

System.register("ict-external-client/app/services/request_service.js", ["angular2/core.js", "ict-external-client/gen/services/abstract_request_service.js", "ags-client/ags-client.js", "rxjs/Rx.js", "rxjs/add/operator/do.js", "rxjs/add/operator/concatMap.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, abstract_request_service_1, ags_client_1, ags_client_2, Rx_1, RequestService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (abstract_request_service_1_1) {
            abstract_request_service_1 = abstract_request_service_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
        }, function (Rx_1_1) {
            Rx_1 = Rx_1_1;
        }, function (_1) {}, function (_2) {}],
        execute: function () {
            RequestService = /** @class */function (_super) {
                __extends(RequestService, _super);
                function RequestService(backendService) {
                    var _this = _super.call(this, backendService) || this;
                    _this._backendService = backendService;
                    return _this;
                }
                RequestService.prototype.uploadAttachments = function (requestId, attachments) {
                    var _this = this;
                    return new Rx_1.Observable(function (subscriber) {
                        var responses = new ags_client_2.JsonResponseList();
                        Rx_1.Observable.from(attachments).concatMap(function (file) {
                            return _this._backendService.uploadFile('/request/addAttachment/' + requestId, file);
                        }).do(function (response) {
                            responses.responses.push(response);
                        }).subscribe(null, null, function () {
                            subscriber.next(responses);
                            subscriber.complete();
                        });
                    });
                };
                RequestService = __decorate([core_1.Injectable(), core_1.Inject(ags_client_1.BackendService), __metadata("design:paramtypes", [ags_client_1.BackendService])], RequestService);
                return RequestService;
            }(abstract_request_service_1.AbstractRequestService);
            exports_1("RequestService", RequestService);
        }
    };
});

System.register("ict-external-client/app/views/request_id_view.js", ["angular2/core.js", "angular2/router.js", "ags-client/ags-client.js", "ict-external-client/app/components/request_component.js", "ict-external-client/gen/views.js", "ict-external-client/app/services/request_service.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, router_1, ags_client_1, ags_client_2, ags_client_3, ags_client_4, ags_client_5, request_component_1, views_1, router_2, request_service_1, RequestIdView;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (router_1_1) {
            router_1 = router_1_1;
            router_2 = router_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
            ags_client_5 = ags_client_1_1;
        }, function (request_component_1_1) {
            request_component_1 = request_component_1_1;
        }, function (views_1_1) {
            views_1 = views_1_1;
        }, function (request_service_1_1) {
            request_service_1 = request_service_1_1;
        }],
        execute: function () {
            RequestIdView = /** @class */function (_super) {
                __extends(RequestIdView, _super);
                function RequestIdView(navigationService, router, routeParams, _requestService, _translationService, _confirmationService) {
                    var _this = _super.call(this, navigationService, router) || this;
                    _this._requestService = _requestService;
                    _this._translationService = _translationService;
                    _this._confirmationService = _confirmationService;
                    _this.requestId = parseInt(routeParams.get('id'));
                    return _this;
                }
                RequestIdView.prototype.refresh = function () {
                    this.request.first.refresh();
                };
                RequestIdView.prototype.withdraw = function () {
                    this.request.first.withdraw();
                };
                __decorate([core_1.ViewChildren(request_component_1.RequestComponent), __metadata("design:type", core_1.QueryList)], RequestIdView.prototype, "request", void 0);
                RequestIdView = __decorate([core_1.Component({
                    selector: 'request-id-view',
                    directives: [ags_client_1.AGS_DIRECTIVES, request_component_1.RequestComponent],
                    pipes: [ags_client_1.AGS_PIPES],
                    templateUrl: 'ict-external-client/app/views/request_id_view.html'
                }), router_1.CanActivate(function () {
                    return ags_client_1.AuthenticationService.checkViewSecurity(views_1.VIEW_SECURITY[views_1.REQUEST_ID_VIEW]);
                }), __metadata("design:paramtypes", [ags_client_2.NavigationService, router_1.Router, router_2.RouteParams, request_service_1.RequestService, ags_client_4.TranslationService, ags_client_3.ConfirmationService])], RequestIdView);
                return RequestIdView;
            }(ags_client_5.AbstractView);
            exports_1("RequestIdView", RequestIdView);
        }
    };
});

System.register("ict-external-client/gen/viewsearch/request_dump_log_search_criteria.js", ["ags-client/ags-client.js", "ict-core-client/ict-core-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var ags_client_1, ags_client_2, ags_client_3, ict_core_client_1, RequestDumpLogSearchCriteria;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
        }, function (ict_core_client_1_1) {
            ict_core_client_1 = ict_core_client_1_1;
        }],
        execute: function () {
            RequestDumpLogSearchCriteria = /** @class */function (_super) {
                __extends(RequestDumpLogSearchCriteria, _super);
                function RequestDumpLogSearchCriteria(from, size) {
                    return _super.call(this, from, size) || this;
                }
                RequestDumpLogSearchCriteria.create = function (from, size) {
                    return new RequestDumpLogSearchCriteria(from, size);
                };
                Object.defineProperty(RequestDumpLogSearchCriteria.prototype, "requestTime", {
                    get: function () {
                        return this._requestTime;
                    },
                    set: function (requestTime) {
                        if (this._requestTime !== requestTime) {
                            this._requestTime = requestTime;
                            this.attributeChanged(RequestDumpLogSearchCriteria.REQUEST_TIME, requestTime);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(RequestDumpLogSearchCriteria.prototype, "login", {
                    get: function () {
                        return this._login;
                    },
                    set: function (login) {
                        if (this._login !== login) {
                            this._login = login;
                            this.attributeChanged(RequestDumpLogSearchCriteria.LOGIN, login);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(RequestDumpLogSearchCriteria.prototype, "requestedUrl", {
                    get: function () {
                        return this._requestedUrl;
                    },
                    set: function (requestedUrl) {
                        if (this._requestedUrl !== requestedUrl) {
                            this._requestedUrl = requestedUrl;
                            this.attributeChanged(RequestDumpLogSearchCriteria.REQUESTED_URL, requestedUrl);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(RequestDumpLogSearchCriteria.prototype, "remoteIp", {
                    get: function () {
                        return this._remoteIp;
                    },
                    set: function (remoteIp) {
                        if (this._remoteIp !== remoteIp) {
                            this._remoteIp = remoteIp;
                            this.attributeChanged(RequestDumpLogSearchCriteria.REMOTE_IP, remoteIp);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(RequestDumpLogSearchCriteria.prototype, "logLevel", {
                    get: function () {
                        return this._logLevel;
                    },
                    set: function (logLevel) {
                        if (this._logLevel !== logLevel) {
                            this._logLevel = logLevel;
                            this.attributeChanged(RequestDumpLogSearchCriteria.LOG_LEVEL, logLevel);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(RequestDumpLogSearchCriteria.prototype, "statusCode", {
                    get: function () {
                        return this._statusCode;
                    },
                    set: function (statusCode) {
                        if (this._statusCode !== statusCode) {
                            this._statusCode = statusCode;
                            this.attributeChanged(RequestDumpLogSearchCriteria.STATUS_CODE, statusCode);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(RequestDumpLogSearchCriteria.prototype, "requestHeader", {
                    get: function () {
                        return this._requestHeader;
                    },
                    set: function (requestHeader) {
                        if (this._requestHeader !== requestHeader) {
                            this._requestHeader = requestHeader;
                            this.attributeChanged(RequestDumpLogSearchCriteria.REQUEST_HEADER, requestHeader);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(RequestDumpLogSearchCriteria.prototype, "requestPreview", {
                    get: function () {
                        return this._requestPreview;
                    },
                    set: function (requestPreview) {
                        if (this._requestPreview !== requestPreview) {
                            this._requestPreview = requestPreview;
                            this.attributeChanged(RequestDumpLogSearchCriteria.REQUEST_PREVIEW, requestPreview);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(RequestDumpLogSearchCriteria.prototype, "responsePreview", {
                    get: function () {
                        return this._responsePreview;
                    },
                    set: function (responsePreview) {
                        if (this._responsePreview !== responsePreview) {
                            this._responsePreview = responsePreview;
                            this.attributeChanged(RequestDumpLogSearchCriteria.RESPONSE_PREVIEW, responsePreview);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                RequestDumpLogSearchCriteria.prototype.reset = function () {
                    _super.prototype.reset.call(this);
                    this._requestTime = null;
                    this._login = null;
                    this._requestedUrl = null;
                    this._remoteIp = null;
                    this._logLevel = null;
                    this._statusCode = null;
                    this._requestHeader = null;
                    this._requestPreview = null;
                    this._responsePreview = null;
                };
                RequestDumpLogSearchCriteria.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (ags_client_2.isPresent(this.requestTime)) {
                        object['requestTime'] = ags_client_3.serializeDate(this.requestTime);
                    }
                    if (ags_client_2.isPresent(this.login)) {
                        object['login'] = this.login;
                    }
                    if (ags_client_2.isPresent(this.requestedUrl)) {
                        object['requestedUrl'] = this.requestedUrl;
                    }
                    if (ags_client_2.isPresent(this.remoteIp)) {
                        object['remoteIp'] = this.remoteIp;
                    }
                    if (ags_client_2.isPresent(this.logLevel)) {
                        object['logLevel'] = ict_core_client_1.LogLevel[this.logLevel];
                    }
                    if (ags_client_2.isPresent(this.statusCode)) {
                        object['statusCode'] = this.statusCode;
                    }
                    if (ags_client_2.isPresent(this.requestHeader)) {
                        object['requestHeader'] = this.requestHeader;
                    }
                    if (ags_client_2.isPresent(this.requestPreview)) {
                        object['requestPreview'] = this.requestPreview;
                    }
                    if (ags_client_2.isPresent(this.responsePreview)) {
                        object['responsePreview'] = this.responsePreview;
                    }
                    return object;
                };
                RequestDumpLogSearchCriteria.REQUEST_TIME = 'requestTime';
                RequestDumpLogSearchCriteria.LOGIN = 'login';
                RequestDumpLogSearchCriteria.REQUESTED_URL = 'requestedUrl';
                RequestDumpLogSearchCriteria.REMOTE_IP = 'remoteIp';
                RequestDumpLogSearchCriteria.LOG_LEVEL = 'logLevel';
                RequestDumpLogSearchCriteria.STATUS_CODE = 'statusCode';
                RequestDumpLogSearchCriteria.REQUEST_HEADER = 'requestHeader';
                RequestDumpLogSearchCriteria.REQUEST_PREVIEW = 'requestPreview';
                RequestDumpLogSearchCriteria.RESPONSE_PREVIEW = 'responsePreview';
                return RequestDumpLogSearchCriteria;
            }(ags_client_1.SearchCriteria);
            exports_1("RequestDumpLogSearchCriteria", RequestDumpLogSearchCriteria);
        }
    };
});

System.register("ict-external-client/app/components/request_dump_table_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/ags-client.js", "ict-external-client/gen/viewsearch/request_dump_log_search_criteria.js", "ict-external-client/app/services/request_dump_service.js", "ict-core-client/ict-core-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, ags_client_1, ags_client_2, request_dump_log_search_criteria_1, ags_client_3, ags_client_4, ags_client_5, request_dump_service_1, ags_client_6, ict_core_client_1, RequestDumpTableComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
            ags_client_5 = ags_client_1_1;
            ags_client_6 = ags_client_1_1;
        }, function (request_dump_log_search_criteria_1_1) {
            request_dump_log_search_criteria_1 = request_dump_log_search_criteria_1_1;
        }, function (request_dump_service_1_1) {
            request_dump_service_1 = request_dump_service_1_1;
        }, function (ict_core_client_1_1) {
            ict_core_client_1 = ict_core_client_1_1;
        }],
        execute: function () {
            RequestDumpTableComponent = /** @class */function (_super) {
                __extends(RequestDumpTableComponent, _super);
                function RequestDumpTableComponent(alertService, translationService, _requestDumpLogService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._requestDumpLogService = _requestDumpLogService;
                    _this.LogLevel = ict_core_client_1.LogLevel;
                    _this.selected = new core_1.EventEmitter();
                    return _this;
                }
                RequestDumpTableComponent.prototype.initSearchCriteria = function () {
                    var _this = this;
                    this.requestDumpLogSearchCriteria = new request_dump_log_search_criteria_1.RequestDumpLogSearchCriteria(0, 30);
                    this.requestDumpLogSearchCriteria.sort = new ags_client_6.SearchSort('requestTime', ags_client_6.SortDirection.DESCENDING);
                    this.requestDumpLogSearchCriteria.subscribeSearch(function () {
                        _this.search();
                    });
                    this.search();
                };
                RequestDumpTableComponent.prototype.buildFilterForm = function () {
                    this.filterForm = new common_1.ControlGroup({
                        'requestTime': new common_1.Control(''),
                        'login': new common_1.Control(''),
                        'requestedUrl': new common_1.Control(''),
                        'remoteIp': new common_1.Control(''),
                        'logLevel': new common_1.Control(''),
                        'statusCode': new common_1.Control(''),
                        'requestHeader': new common_1.Control(''),
                        'requestPreview': new common_1.Control(''),
                        'responsePreview': new common_1.Control('')
                    });
                };
                RequestDumpTableComponent.prototype.select = function (dump) {
                    this.selected.emit(dump);
                };
                RequestDumpTableComponent.prototype.search = function () {
                    var _this = this;
                    if (this.filterForm.valid) {
                        this.loading = true;
                        this._requestDumpLogService.search(this.requestDumpLogSearchCriteria).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.requestDumpLogSearchCriteria.total = response.totalItems;
                                _this.requestDumpLogs = response.data;
                            }
                            _this.loading = false;
                        });
                    }
                };
                __decorate([core_1.Input(), __metadata("design:type", String)], RequestDumpTableComponent.prototype, "id", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], RequestDumpTableComponent.prototype, "selected", void 0);
                __decorate([ags_client_2.PageFlow('RequestDumpTable'), __metadata("design:type", request_dump_log_search_criteria_1.RequestDumpLogSearchCriteria)], RequestDumpTableComponent.prototype, "requestDumpLogSearchCriteria", void 0);
                __decorate([ags_client_2.PageFlow('RequestDumpTable'), __metadata("design:type", Array)], RequestDumpTableComponent.prototype, "requestDumpLogs", void 0);
                RequestDumpTableComponent = __decorate([core_1.Component({
                    directives: [ags_client_1.AGS_FORM_DIRECTIVES],
                    pipes: [ags_client_1.AGS_PIPES],
                    selector: 'request-dump-table',
                    templateUrl: 'ict-external-client/app/components/request_dump_table_component.html'
                }), __metadata("design:paramtypes", [ags_client_5.AlertService, ags_client_3.TranslationService, request_dump_service_1.RequestDumpService, core_1.ElementRef])], RequestDumpTableComponent);
                return RequestDumpTableComponent;
            }(ags_client_4.AbstractTableComponent);
            exports_1("RequestDumpTableComponent", RequestDumpTableComponent);
        }
    };
});

System.register("ict-external-client/app/views/request_dump_view.js", ["angular2/core.js", "angular2/router.js", "ags-client/ags-client.js", "ict-external-client/app/components/request_dump_table_component.js", "ict-external-client/gen/views.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, router_1, ags_client_1, ags_client_2, ags_client_3, request_dump_table_component_1, views_1, RequestDumpView;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (router_1_1) {
            router_1 = router_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
        }, function (request_dump_table_component_1_1) {
            request_dump_table_component_1 = request_dump_table_component_1_1;
        }, function (views_1_1) {
            views_1 = views_1_1;
        }],
        execute: function () {
            RequestDumpView = /** @class */function (_super) {
                __extends(RequestDumpView, _super);
                function RequestDumpView(navigationService, router) {
                    return _super.call(this, navigationService, router) || this;
                }
                RequestDumpView.prototype.reset = function () {
                    this.requestDumpTable.first.requestDumpLogSearchCriteria.reset();
                };
                RequestDumpView.prototype.refresh = function () {
                    this.requestDumpTable.first.search();
                };
                RequestDumpView.prototype.open = function (dump) {
                    this.router.navigate([views_1.REQUEST_DUMP_ID_VIEW, { id: dump.id }]);
                };
                __decorate([core_1.ViewChildren(request_dump_table_component_1.RequestDumpTableComponent), __metadata("design:type", core_1.QueryList)], RequestDumpView.prototype, "requestDumpTable", void 0);
                RequestDumpView = __decorate([core_1.Component({
                    selector: 'request-dump-view',
                    directives: [ags_client_1.AGS_DIRECTIVES, request_dump_table_component_1.RequestDumpTableComponent],
                    pipes: [ags_client_1.AGS_PIPES],
                    templateUrl: 'ict-external-client/app/views/request_dump_view.html'
                }), router_1.CanActivate(function () {
                    return ags_client_1.AuthenticationService.checkViewSecurity(views_1.VIEW_SECURITY[views_1.REQUEST_DUMP_VIEW]);
                }), __metadata("design:paramtypes", [ags_client_2.NavigationService, router_1.Router])], RequestDumpView);
                return RequestDumpView;
            }(ags_client_3.AbstractView);
            exports_1("RequestDumpView", RequestDumpView);
        }
    };
});

System.register("ict-external-client/gen/viewmodels/request_dump_log_search_result_view_model.js", ["ags-client/ags-client.js", "ict-core-client/ict-core-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var ags_client_1, ags_client_2, Validators, ags_client_3, ags_client_4, ict_core_client_1, ags_client_5, RequestDumpLogSearchResultViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            Validators = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
            ags_client_5 = ags_client_1_1;
        }, function (ict_core_client_1_1) {
            ict_core_client_1 = ict_core_client_1_1;
        }],
        execute: function () {
            RequestDumpLogSearchResultViewModel = /** @class */function (_super) {
                __extends(RequestDumpLogSearchResultViewModel, _super);
                function RequestDumpLogSearchResultViewModel() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                RequestDumpLogSearchResultViewModel.deserialize = function (object) {
                    var _result = new RequestDumpLogSearchResultViewModel();
                    return _result._deserialize(object);
                };
                RequestDumpLogSearchResultViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        _super.prototype._deserialize.call(this, object);
                        if (ags_client_1.isPresent(object['requestTime'])) {
                            this.requestTime = ags_client_4.deserializeDate(object['requestTime']);
                        }
                        if (ags_client_1.isPresent(object['login'])) {
                            this.login = object['login'];
                        }
                        if (ags_client_1.isPresent(object['version'])) {
                            this.version = object['version'];
                        }
                        if (ags_client_1.isPresent(object['remoteIp'])) {
                            this.remoteIp = object['remoteIp'];
                        }
                        if (ags_client_1.isPresent(object['logLevel'])) {
                            this.logLevel = ags_client_5.enumNumberValue(ict_core_client_1.LogLevel, object['logLevel']);
                        }
                        if (ags_client_1.isPresent(object['statusCode'])) {
                            this.statusCode = object['statusCode'];
                        }
                    }
                    return this;
                };
                RequestDumpLogSearchResultViewModel.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (ags_client_1.isPresent(this.requestTime)) {
                        object['requestTime'] = ags_client_3.serializeDate(this.requestTime);
                    }
                    if (ags_client_1.isPresent(this.login)) {
                        object['login'] = this.login;
                    }
                    if (ags_client_1.isPresent(this.version)) {
                        object['version'] = this.version;
                    }
                    if (ags_client_1.isPresent(this.remoteIp)) {
                        object['remoteIp'] = this.remoteIp;
                    }
                    if (ags_client_1.isPresent(this.logLevel)) {
                        object['logLevel'] = ict_core_client_1.LogLevel[this.logLevel];
                    }
                    if (ags_client_1.isPresent(this.statusCode)) {
                        object['statusCode'] = this.statusCode;
                    }
                    return object;
                };
                RequestDumpLogSearchResultViewModel.REQUEST_TIME_VALIDATORS = [Validators.date, Validators.required(), Validators.dateTime()];
                RequestDumpLogSearchResultViewModel.LOGIN_VALIDATORS = [Validators.email()];
                RequestDumpLogSearchResultViewModel.VERSION_VALIDATORS = [];
                RequestDumpLogSearchResultViewModel.REMOTE_IP_VALIDATORS = [Validators.max(39)];
                RequestDumpLogSearchResultViewModel.LOG_LEVEL_VALIDATORS = [Validators.required()];
                RequestDumpLogSearchResultViewModel.STATUS_CODE_VALIDATORS = [];
                return RequestDumpLogSearchResultViewModel;
            }(ags_client_2.EntityViewModel);
            exports_1("RequestDumpLogSearchResultViewModel", RequestDumpLogSearchResultViewModel);
        }
    };
});

System.register("ict-external-client/gen/viewmodels/request_dump_log_view_model.js", ["ags-client/ags-client.js", "ict-core-client/ict-core-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var ags_client_1, ags_client_2, Validators, ags_client_3, ags_client_4, ict_core_client_1, ags_client_5, RequestDumpLogViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            Validators = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
            ags_client_5 = ags_client_1_1;
        }, function (ict_core_client_1_1) {
            ict_core_client_1 = ict_core_client_1_1;
        }],
        execute: function () {
            RequestDumpLogViewModel = /** @class */function (_super) {
                __extends(RequestDumpLogViewModel, _super);
                function RequestDumpLogViewModel() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                RequestDumpLogViewModel.deserialize = function (object) {
                    var _result = new RequestDumpLogViewModel();
                    return _result._deserialize(object);
                };
                RequestDumpLogViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        _super.prototype._deserialize.call(this, object);
                        if (ags_client_1.isPresent(object['requestTime'])) {
                            this.requestTime = ags_client_4.deserializeDate(object['requestTime']);
                        }
                        if (ags_client_1.isPresent(object['login'])) {
                            this.login = object['login'];
                        }
                        if (ags_client_1.isPresent(object['version'])) {
                            this.version = object['version'];
                        }
                        if (ags_client_1.isPresent(object['requestedUrl'])) {
                            this.requestedUrl = object['requestedUrl'];
                        }
                        if (ags_client_1.isPresent(object['remoteIp'])) {
                            this.remoteIp = object['remoteIp'];
                        }
                        if (ags_client_1.isPresent(object['logLevel'])) {
                            this.logLevel = ags_client_5.enumNumberValue(ict_core_client_1.LogLevel, object['logLevel']);
                        }
                        if (ags_client_1.isPresent(object['statusCode'])) {
                            this.statusCode = object['statusCode'];
                        }
                        if (ags_client_1.isPresent(object['requestHeader'])) {
                            this.requestHeader = object['requestHeader'];
                        }
                        if (ags_client_1.isPresent(object['errors'])) {
                            this.errors = object['errors'];
                        }
                        if (ags_client_1.isPresent(object['request'])) {
                            this.request = object['request'];
                        }
                        if (ags_client_1.isPresent(object['response'])) {
                            this.response = object['response'];
                        }
                    }
                    return this;
                };
                RequestDumpLogViewModel.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (ags_client_1.isPresent(this.requestTime)) {
                        object['requestTime'] = ags_client_3.serializeDate(this.requestTime);
                    }
                    if (ags_client_1.isPresent(this.login)) {
                        object['login'] = this.login;
                    }
                    if (ags_client_1.isPresent(this.version)) {
                        object['version'] = this.version;
                    }
                    if (ags_client_1.isPresent(this.requestedUrl)) {
                        object['requestedUrl'] = this.requestedUrl;
                    }
                    if (ags_client_1.isPresent(this.remoteIp)) {
                        object['remoteIp'] = this.remoteIp;
                    }
                    if (ags_client_1.isPresent(this.logLevel)) {
                        object['logLevel'] = ict_core_client_1.LogLevel[this.logLevel];
                    }
                    if (ags_client_1.isPresent(this.statusCode)) {
                        object['statusCode'] = this.statusCode;
                    }
                    if (ags_client_1.isPresent(this.requestHeader)) {
                        object['requestHeader'] = this.requestHeader;
                    }
                    if (ags_client_1.isPresent(this.errors)) {
                        object['errors'] = this.errors;
                    }
                    if (ags_client_1.isPresent(this.request)) {
                        object['request'] = this.request;
                    }
                    if (ags_client_1.isPresent(this.response)) {
                        object['response'] = this.response;
                    }
                    return object;
                };
                RequestDumpLogViewModel.REQUEST_TIME_VALIDATORS = [Validators.date, Validators.required(), Validators.dateTime()];
                RequestDumpLogViewModel.LOGIN_VALIDATORS = [Validators.email()];
                RequestDumpLogViewModel.VERSION_VALIDATORS = [];
                RequestDumpLogViewModel.REQUESTED_URL_VALIDATORS = [Validators.max(200)];
                RequestDumpLogViewModel.REMOTE_IP_VALIDATORS = [Validators.max(39)];
                RequestDumpLogViewModel.LOG_LEVEL_VALIDATORS = [Validators.required()];
                RequestDumpLogViewModel.STATUS_CODE_VALIDATORS = [];
                RequestDumpLogViewModel.REQUEST_HEADER_VALIDATORS = [Validators.max(4000)];
                RequestDumpLogViewModel.ERRORS_VALIDATORS = [Validators.max(4000)];
                RequestDumpLogViewModel.REQUEST_VALIDATORS = [];
                RequestDumpLogViewModel.RESPONSE_VALIDATORS = [];
                return RequestDumpLogViewModel;
            }(ags_client_2.EntityViewModel);
            exports_1("RequestDumpLogViewModel", RequestDumpLogViewModel);
        }
    };
});

System.register("ict-external-client/gen/services/abstract_request_dump_service.js", ["ags-client/ags-client.js", "ict-external-client/gen/viewmodels/request_dump_log_search_result_view_model.js", "ict-external-client/gen/viewmodels/request_dump_log_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, request_dump_log_search_result_view_model_1, request_dump_log_view_model_1, AbstractRequestDumpService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }, function (request_dump_log_search_result_view_model_1_1) {
            request_dump_log_search_result_view_model_1 = request_dump_log_search_result_view_model_1_1;
        }, function (request_dump_log_view_model_1_1) {
            request_dump_log_view_model_1 = request_dump_log_view_model_1_1;
        }],
        execute: function () {
            AbstractRequestDumpService = /** @class */function () {
                function AbstractRequestDumpService(backendService) {
                    this.backendService = backendService;
                }
                AbstractRequestDumpService.prototype.search = function (request) {
                    return this.backendService.postJson('/requestDump/search.json', request.serialize(), function (response) {
                        var data = Array();
                        response.data.forEach(function (item) {
                            data.push(request_dump_log_search_result_view_model_1.RequestDumpLogSearchResultViewModel.deserialize(item));
                        });
                        return ags_client_1.JsonResponse.deserialize(response, data);
                    });
                };
                AbstractRequestDumpService.prototype.get = function (request) {
                    return this.backendService.getJson('/requestDump/get/' + request + '.json', function (response) {
                        return ags_client_1.JsonResponse.deserialize(response, request_dump_log_view_model_1.RequestDumpLogViewModel.deserialize(response.data));
                    });
                };
                return AbstractRequestDumpService;
            }();
            exports_1("AbstractRequestDumpService", AbstractRequestDumpService);
        }
    };
});

System.register("ict-external-client/app/services/request_dump_service.js", ["angular2/core.js", "ict-external-client/gen/services/abstract_request_dump_service.js", "ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, abstract_request_dump_service_1, ags_client_1, RequestDumpService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (abstract_request_dump_service_1_1) {
            abstract_request_dump_service_1 = abstract_request_dump_service_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }],
        execute: function () {
            RequestDumpService = /** @class */function (_super) {
                __extends(RequestDumpService, _super);
                function RequestDumpService(backendService) {
                    return _super.call(this, backendService) || this;
                }
                RequestDumpService = __decorate([core_1.Injectable(), core_1.Inject(ags_client_1.BackendService), __metadata("design:paramtypes", [ags_client_1.BackendService])], RequestDumpService);
                return RequestDumpService;
            }(abstract_request_dump_service_1.AbstractRequestDumpService);
            exports_1("RequestDumpService", RequestDumpService);
        }
    };
});

System.register("ict-external-client/app/components/request_dump_component.js", ["ags-client/ags-client.js", "angular2/core.js", "ict-external-client/gen/viewmodels/request_dump_log_view_model.js", "ict-external-client/app/services/request_dump_service.js", "ict-core-client/ict-core-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var ags_client_1, ags_client_2, core_1, ags_client_3, request_dump_log_view_model_1, request_dump_service_1, ict_core_client_1, RequestDumpComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
        }, function (core_1_1) {
            core_1 = core_1_1;
        }, function (request_dump_log_view_model_1_1) {
            request_dump_log_view_model_1 = request_dump_log_view_model_1_1;
        }, function (request_dump_service_1_1) {
            request_dump_service_1 = request_dump_service_1_1;
        }, function (ict_core_client_1_1) {
            ict_core_client_1 = ict_core_client_1_1;
        }],
        execute: function () {
            RequestDumpComponent = /** @class */function (_super) {
                __extends(RequestDumpComponent, _super);
                function RequestDumpComponent(alertService, translationService, _requestDumpLogService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._requestDumpLogService = _requestDumpLogService;
                    _this.LogLevel = ict_core_client_1.LogLevel;
                    _this.dump = new request_dump_log_view_model_1.RequestDumpLogViewModel();
                    return _this;
                }
                RequestDumpComponent.prototype.initData = function () {
                    var _this = this;
                    if (ags_client_2.isPresent(this.dumpId)) {
                        this.loading = true;
                        this._requestDumpLogService.get(this.dumpId).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.dump = response.data;
                            }
                            _this.loading = false;
                        });
                    }
                };
                __decorate([core_1.Input(), __metadata("design:type", String)], RequestDumpComponent.prototype, "id", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Number)], RequestDumpComponent.prototype, "dumpId", void 0);
                RequestDumpComponent = __decorate([core_1.Component({
                    directives: [ags_client_3.AGS_DIRECTIVES],
                    pipes: [ags_client_3.AGS_PIPES],
                    selector: 'request-dump',
                    templateUrl: 'ict-external-client/app/components/request_dump_component.html'
                }), __metadata("design:paramtypes", [ags_client_1.AlertService, ags_client_1.TranslationService, request_dump_service_1.RequestDumpService, core_1.ElementRef])], RequestDumpComponent);
                return RequestDumpComponent;
            }(ags_client_2.AbstractComponent);
            exports_1("RequestDumpComponent", RequestDumpComponent);
        }
    };
});

System.register("ict-external-client/app/views/request_dump_id_view.js", ["angular2/core.js", "angular2/router.js", "ags-client/ags-client.js", "ict-external-client/app/components/request_dump_component.js", "ict-external-client/gen/views.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, router_1, ags_client_1, ags_client_2, ags_client_3, request_dump_component_1, views_1, router_2, RequestDumpIdView;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (router_1_1) {
            router_1 = router_1_1;
            router_2 = router_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
        }, function (request_dump_component_1_1) {
            request_dump_component_1 = request_dump_component_1_1;
        }, function (views_1_1) {
            views_1 = views_1_1;
        }],
        execute: function () {
            RequestDumpIdView = /** @class */function (_super) {
                __extends(RequestDumpIdView, _super);
                function RequestDumpIdView(navigationService, router, routeParams) {
                    var _this = _super.call(this, navigationService, router) || this;
                    _this.dumpId = parseInt(routeParams.get('id'));
                    return _this;
                }
                RequestDumpIdView.prototype.beforeInit = function () {
                    this.hideNavigation();
                };
                __decorate([core_1.ViewChildren(request_dump_component_1.RequestDumpComponent), __metadata("design:type", core_1.QueryList)], RequestDumpIdView.prototype, "requestDump", void 0);
                RequestDumpIdView = __decorate([core_1.Component({
                    selector: 'request-dump-id-view',
                    directives: [ags_client_1.AGS_DIRECTIVES, request_dump_component_1.RequestDumpComponent],
                    pipes: [ags_client_1.AGS_PIPES],
                    templateUrl: 'ict-external-client/app/views/request_dump_id_view.html'
                }), router_1.CanActivate(function () {
                    return ags_client_1.AuthenticationService.checkViewSecurity(views_1.VIEW_SECURITY[views_1.REQUEST_DUMP_ID_VIEW]);
                }), __metadata("design:paramtypes", [ags_client_2.NavigationService, router_1.Router, router_2.RouteParams])], RequestDumpIdView);
                return RequestDumpIdView;
            }(ags_client_3.AbstractView);
            exports_1("RequestDumpIdView", RequestDumpIdView);
        }
    };
});

System.register("ict-external-client/gen/viewsearch/search_security_search_criteria.js", ["ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var ags_client_1, ags_client_2, ags_client_3, ags_client_4, ags_client_5, SearchSecuritySearchCriteria;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
            ags_client_5 = ags_client_1_1;
        }],
        execute: function () {
            SearchSecuritySearchCriteria = /** @class */function (_super) {
                __extends(SearchSecuritySearchCriteria, _super);
                function SearchSecuritySearchCriteria(from, size) {
                    return _super.call(this, from, size) || this;
                }
                SearchSecuritySearchCriteria.create = function (from, size) {
                    return new SearchSecuritySearchCriteria(from, size);
                };
                Object.defineProperty(SearchSecuritySearchCriteria.prototype, "valorNumber", {
                    get: function () {
                        return this._valorNumber;
                    },
                    set: function (valorNumber) {
                        if (this._valorNumber !== valorNumber) {
                            this._valorNumber = valorNumber;
                            this.attributeChanged(SearchSecuritySearchCriteria.VALOR_NUMBER, valorNumber);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecuritySearchCriteria.prototype, "isin", {
                    get: function () {
                        return this._isin;
                    },
                    set: function (isin) {
                        if (this._isin !== isin) {
                            this._isin = isin;
                            this.attributeChanged(SearchSecuritySearchCriteria.ISIN, isin);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecuritySearchCriteria.prototype, "nsin", {
                    get: function () {
                        return this._nsin;
                    },
                    set: function (nsin) {
                        if (this._nsin !== nsin) {
                            this._nsin = nsin;
                            this.attributeChanged(SearchSecuritySearchCriteria.NSIN, nsin);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecuritySearchCriteria.prototype, "name", {
                    get: function () {
                        return this._name;
                    },
                    set: function (name) {
                        if (this._name !== name) {
                            this._name = name;
                            this.attributeChanged(SearchSecuritySearchCriteria.NAME, name);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecuritySearchCriteria.prototype, "institution", {
                    get: function () {
                        return this._institution;
                    },
                    set: function (institution) {
                        if (this._institution !== institution) {
                            this._institution = institution;
                            this.attributeChanged(SearchSecuritySearchCriteria.INSTITUTION, institution);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecuritySearchCriteria.prototype, "instrument", {
                    get: function () {
                        return this._instrument;
                    },
                    set: function (instrument) {
                        if (this._instrument !== instrument) {
                            this._instrument = instrument;
                            this.attributeChanged(SearchSecuritySearchCriteria.INSTRUMENT, instrument);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecuritySearchCriteria.prototype, "instrumentGroup", {
                    get: function () {
                        return this._instrumentGroup;
                    },
                    set: function (instrumentGroup) {
                        if (this._instrumentGroup !== instrumentGroup) {
                            this._instrumentGroup = instrumentGroup;
                            this.attributeChanged(SearchSecuritySearchCriteria.INSTRUMENT_GROUP, instrumentGroup);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecuritySearchCriteria.prototype, "instrumentType", {
                    get: function () {
                        return this._instrumentType;
                    },
                    set: function (instrumentType) {
                        if (this._instrumentType !== instrumentType) {
                            this._instrumentType = instrumentType;
                            this.attributeChanged(SearchSecuritySearchCriteria.INSTRUMENT_TYPE, instrumentType);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecuritySearchCriteria.prototype, "country", {
                    get: function () {
                        return this._country;
                    },
                    set: function (country) {
                        if (this._country !== country) {
                            this._country = country;
                            this.attributeChanged(SearchSecuritySearchCriteria.COUNTRY, country);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecuritySearchCriteria.prototype, "currency", {
                    get: function () {
                        return this._currency;
                    },
                    set: function (currency) {
                        if (this._currency !== currency) {
                            this._currency = currency;
                            this.attributeChanged(SearchSecuritySearchCriteria.CURRENCY, currency);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecuritySearchCriteria.prototype, "issueYear", {
                    get: function () {
                        return this._issueYear;
                    },
                    set: function (issueYear) {
                        if (this._issueYear !== issueYear) {
                            this._issueYear = issueYear;
                            this.attributeChanged(SearchSecuritySearchCriteria.ISSUE_YEAR, issueYear);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecuritySearchCriteria.prototype, "interestRate", {
                    get: function () {
                        return this._interestRate;
                    },
                    set: function (interestRate) {
                        if (this._interestRate !== interestRate) {
                            this._interestRate = interestRate;
                            this.attributeChanged(SearchSecuritySearchCriteria.INTEREST_RATE, interestRate);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecuritySearchCriteria.prototype, "redemptionYear", {
                    get: function () {
                        return this._redemptionYear;
                    },
                    set: function (redemptionYear) {
                        if (this._redemptionYear !== redemptionYear) {
                            this._redemptionYear = redemptionYear;
                            this.attributeChanged(SearchSecuritySearchCriteria.REDEMPTION_YEAR, redemptionYear);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecuritySearchCriteria.prototype, "iup", {
                    get: function () {
                        return this._iup;
                    },
                    set: function (iup) {
                        if (this._iup !== iup) {
                            this._iup = iup;
                            this.attributeChanged(SearchSecuritySearchCriteria.IUP, iup);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecuritySearchCriteria.prototype, "bfp", {
                    get: function () {
                        return this._bfp;
                    },
                    set: function (bfp) {
                        if (this._bfp !== bfp) {
                            this._bfp = bfp;
                            this.attributeChanged(SearchSecuritySearchCriteria.BFP, bfp);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecuritySearchCriteria.prototype, "variableInterestRate", {
                    get: function () {
                        return this._variableInterestRate;
                    },
                    set: function (variableInterestRate) {
                        if (this._variableInterestRate !== variableInterestRate) {
                            this._variableInterestRate = variableInterestRate;
                            this.attributeChanged(SearchSecuritySearchCriteria.VARIABLE_INTEREST_RATE, variableInterestRate);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecuritySearchCriteria.prototype, "year", {
                    get: function () {
                        return this._year;
                    },
                    set: function (year) {
                        if (this._year !== year) {
                            this._year = year;
                            this.attributeChanged(SearchSecuritySearchCriteria.YEAR, year);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecuritySearchCriteria.prototype, "referenceDate", {
                    get: function () {
                        return this._referenceDate;
                    },
                    set: function (referenceDate) {
                        if (this._referenceDate !== referenceDate) {
                            this._referenceDate = referenceDate;
                            this.attributeChanged(SearchSecuritySearchCriteria.REFERENCE_DATE, referenceDate);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecuritySearchCriteria.prototype, "language", {
                    get: function () {
                        return this._language;
                    },
                    set: function (language) {
                        if (this._language !== language) {
                            this._language = language;
                            this.attributeChanged(SearchSecuritySearchCriteria.LANGUAGE, language);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                SearchSecuritySearchCriteria.prototype.reset = function () {
                    _super.prototype.reset.call(this);
                    this._valorNumber = null;
                    this._isin = null;
                    this._nsin = null;
                    this._name = null;
                    this._institution = null;
                    this._instrument = null;
                    this._instrumentGroup = null;
                    this._instrumentType = null;
                    this._country = null;
                    this._currency = null;
                    this._issueYear = null;
                    this._interestRate = null;
                    this._redemptionYear = null;
                    this._iup = null;
                    this._bfp = null;
                    this._variableInterestRate = null;
                    this._year = null;
                    this._referenceDate = null;
                    this._language = null;
                };
                SearchSecuritySearchCriteria.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (ags_client_2.isPresent(this.valorNumber)) {
                        object['valorNumber'] = this.valorNumber;
                    }
                    if (ags_client_2.isPresent(this.isin)) {
                        object['isin'] = this.isin;
                    }
                    if (ags_client_2.isPresent(this.nsin)) {
                        object['nsin'] = this.nsin;
                    }
                    if (ags_client_2.isPresent(this.name)) {
                        object['name'] = this.name;
                    }
                    if (ags_client_2.isPresent(this.institution)) {
                        object['institution'] = this.institution;
                    }
                    if (ags_client_2.isPresent(this.instrument)) {
                        object['instrument'] = this.instrument;
                    }
                    if (ags_client_2.isPresent(this.instrumentGroup)) {
                        object['instrumentGroup'] = ags_client_3.InstrumentGroup[this.instrumentGroup];
                    }
                    if (ags_client_2.isPresent(this.instrumentType)) {
                        object['instrumentType'] = ags_client_4.InstrumentType[this.instrumentType];
                    }
                    if (ags_client_2.isPresent(this.country)) {
                        object['country'] = this.country;
                    }
                    if (ags_client_2.isPresent(this.currency)) {
                        object['currency'] = this.currency;
                    }
                    if (ags_client_2.isPresent(this.issueYear)) {
                        object['issueYear'] = this.issueYear;
                    }
                    if (ags_client_2.isPresent(this.interestRate)) {
                        object['interestRate'] = this.interestRate;
                    }
                    if (ags_client_2.isPresent(this.redemptionYear)) {
                        object['redemptionYear'] = this.redemptionYear;
                    }
                    if (ags_client_2.isPresent(this.iup)) {
                        object['iup'] = this.iup;
                    }
                    if (ags_client_2.isPresent(this.bfp)) {
                        object['bfp'] = this.bfp;
                    }
                    if (ags_client_2.isPresent(this.variableInterestRate)) {
                        object['variableInterestRate'] = this.variableInterestRate;
                    }
                    if (ags_client_2.isPresent(this.year)) {
                        object['year'] = this.year;
                    }
                    if (ags_client_2.isPresent(this.referenceDate)) {
                        object['referenceDate'] = ags_client_5.serializeDate(this.referenceDate);
                    }
                    if (ags_client_2.isPresent(this.language)) {
                        object['language'] = this.language;
                    }
                    return object;
                };
                SearchSecuritySearchCriteria.VALOR_NUMBER = 'valorNumber';
                SearchSecuritySearchCriteria.ISIN = 'isin';
                SearchSecuritySearchCriteria.NSIN = 'nsin';
                SearchSecuritySearchCriteria.NAME = 'name';
                SearchSecuritySearchCriteria.INSTITUTION = 'institution';
                SearchSecuritySearchCriteria.INSTRUMENT = 'instrument';
                SearchSecuritySearchCriteria.INSTRUMENT_GROUP = 'instrumentGroup';
                SearchSecuritySearchCriteria.INSTRUMENT_TYPE = 'instrumentType';
                SearchSecuritySearchCriteria.COUNTRY = 'country';
                SearchSecuritySearchCriteria.CURRENCY = 'currency';
                SearchSecuritySearchCriteria.ISSUE_YEAR = 'issueYear';
                SearchSecuritySearchCriteria.INTEREST_RATE = 'interestRate';
                SearchSecuritySearchCriteria.REDEMPTION_YEAR = 'redemptionYear';
                SearchSecuritySearchCriteria.IUP = 'iup';
                SearchSecuritySearchCriteria.BFP = 'bfp';
                SearchSecuritySearchCriteria.VARIABLE_INTEREST_RATE = 'variableInterestRate';
                SearchSecuritySearchCriteria.YEAR = 'year';
                SearchSecuritySearchCriteria.REFERENCE_DATE = 'referenceDate';
                SearchSecuritySearchCriteria.LANGUAGE = 'language';
                return SearchSecuritySearchCriteria;
            }(ags_client_1.SearchCriteria);
            exports_1("SearchSecuritySearchCriteria", SearchSecuritySearchCriteria);
        }
    };
});

System.register("ict-external-client/app/components/security_table_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/ags-client.js", "ict-core-client/ict-core-client.js", "ict-external-client/gen/viewsearch/search_security_search_criteria.js", "ict-external-client/app/services/security_service.js", "ict-external-client/app/services/application_service.js", "ict-external-client/gen/i18n/translation_constants.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, ags_client_1, ags_client_2, ags_client_3, ags_client_4, ags_client_5, ict_core_client_1, search_security_search_criteria_1, security_service_1, application_service_1, translation_constants_1, SecurityTableComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
            ags_client_5 = ags_client_1_1;
        }, function (ict_core_client_1_1) {
            ict_core_client_1 = ict_core_client_1_1;
        }, function (search_security_search_criteria_1_1) {
            search_security_search_criteria_1 = search_security_search_criteria_1_1;
        }, function (security_service_1_1) {
            security_service_1 = security_service_1_1;
        }, function (application_service_1_1) {
            application_service_1 = application_service_1_1;
        }, function (translation_constants_1_1) {
            translation_constants_1 = translation_constants_1_1;
        }],
        execute: function () {
            SecurityTableComponent = /** @class */function (_super) {
                __extends(SecurityTableComponent, _super);
                function SecurityTableComponent(alertService, translationService, _securityService, _authenticationService, _applicationService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._securityService = _securityService;
                    _this._authenticationService = _authenticationService;
                    _this._applicationService = _applicationService;
                    _this.selected = new core_1.EventEmitter();
                    _this.minYear = new Date().getFullYear();
                    _this.maxYear = new Date().getFullYear();
                    _this._applicationService.cachedSystemParameters().then(function (systemParameters) {
                        _this.minYear = new Date().getFullYear() - systemParameters.archiveYearsInactive;
                    });
                    setTimeout(function () {
                        if (ags_client_1.isPresent(_this.year)) {
                            _this.focus('security_name');
                        } else if (_this.extendedSearch) {
                            _this.focus('security_name_extended');
                        } else {
                            _this.focus('security_name_simple');
                        }
                    }, 150);
                    return _this;
                }
                SecurityTableComponent.prototype.initSearchCriteria = function () {
                    var _this = this;
                    this._applicationService.cachedSystemParameters().then(function (systemParameters) {
                        if (!ags_client_1.isPresent(_this.searchSecuritySearchCriteria)) {
                            _this.securitySearchResults = [];
                            _this.searchSecuritySearchCriteria = new search_security_search_criteria_1.SearchSecuritySearchCriteria(0, 10);
                            if (_this._authenticationService.authenticated()) {
                                _this.searchSecuritySearchCriteria.year = systemParameters.taxYearExtern;
                            } else {
                                _this.searchSecuritySearchCriteria.year = systemParameters.taxYearOnline;
                            }
                            _this.searchSecuritySearchCriteria.language = _this.translationService.language;
                            _this.referenceDate = ags_client_1.createDate(_this.searchSecuritySearchCriteria.year, 12, 31);
                            _this.searchSecuritySearchCriteria.subscribeSearch(function () {
                                _this._search();
                            });
                        }
                        if (ags_client_1.isPresent(_this.year) && ags_client_1.isPresent(_this.searchSecuritySearchCriteria)) {
                            _this.searchSecuritySearchCriteria.year = _this.year;
                        }
                    });
                };
                SecurityTableComponent.prototype.toggleExtended = function () {
                    this.extendedSearch = !this.extendedSearch;
                    if (this.extendedSearch) {
                        this.focus('security_name_extended');
                    } else {
                        this.focus('security_name_simple');
                    }
                };
                SecurityTableComponent.prototype.buildFilterForm = function () {
                    this.filterForm = new common_1.ControlGroup({
                        'valorNumber': new common_1.Control('', ags_client_5.validators([ags_client_5.vn()])),
                        'simpleValorNumber': new common_1.Control('', ags_client_5.validators([ags_client_5.vn()])),
                        'isin': new common_1.Control('', ags_client_5.validators([ags_client_5.isin()])),
                        'simpleIsin': new common_1.Control('', ags_client_5.validators([ags_client_5.isin()])),
                        'nsin': new common_1.Control(''),
                        'simpleNsin': new common_1.Control(''),
                        'name': new common_1.Control(''),
                        'simpleName': new common_1.Control(''),
                        'instrumentGroup': new common_1.Control(''),
                        'instrumentType': new common_1.Control(''),
                        'country': new common_1.Control(''),
                        'currency': new common_1.Control(''),
                        'issueYear': new common_1.Control('', ags_client_5.validators([ags_client_5.year()])),
                        'interestRate': new common_1.Control(''),
                        'redemptionYear': new common_1.Control('', ags_client_5.validators([ags_client_5.year()])),
                        'iup': new common_1.Control(''),
                        'bfp': new common_1.Control(''),
                        'variableInterestRate': new common_1.Control(''),
                        'year': new common_1.Control(''),
                        'language': new common_1.Control(''),
                        'referenceDate2': new common_1.Control('')
                    });
                };
                SecurityTableComponent.prototype.reset = function () {
                    var referenceDate = this.searchSecuritySearchCriteria.referenceDate;
                    var year = this.searchSecuritySearchCriteria.year;
                    this.searchSecuritySearchCriteria.reset();
                    this.searchSecuritySearchCriteria.referenceDate = referenceDate;
                    this.searchSecuritySearchCriteria.year = year;
                    this.securitySearchResults = [];
                    this.alertService.reset();
                };
                SecurityTableComponent.prototype.valid = function () {
                    return ags_client_1.isPresent(this.searchSecuritySearchCriteria) && (ags_client_1.isPresent(this.searchSecuritySearchCriteria.valorNumber) || this.searchSecuritySearchCriteria.instrumentGroup === ags_client_3.InstrumentGroup.COINBULL || this.searchSecuritySearchCriteria.instrumentGroup === ags_client_3.InstrumentGroup.CURRNOTE || ags_client_1.isPresent(this.searchSecuritySearchCriteria.isin) && ags_client_5.isValidIsin(this.searchSecuritySearchCriteria.isin) || ags_client_1.isPresent(this.searchSecuritySearchCriteria.nsin) && this.searchSecuritySearchCriteria.nsin.length > 2 || ags_client_1.isSomething(this.searchSecuritySearchCriteria.name) && this.searchSecuritySearchCriteria.name.length > 2);
                };
                SecurityTableComponent.prototype.search = function () {
                    this._search(true);
                };
                SecurityTableComponent.prototype._search = function (open) {
                    var _this = this;
                    if (open === void 0) {
                        open = false;
                    }
                    if (this.extendedSearch) {
                        this.searchSecuritySearchCriteria.year = this.referenceDate.getFullYear();
                        this.searchSecuritySearchCriteria.referenceDate = this.referenceDate;
                    } else {
                        this.referenceDate = ags_client_1.createDate(this.searchSecuritySearchCriteria.year, 12, 31);
                    }
                    if (this.valid()) {
                        this.loading = true;
                        this.alertService.reset();
                        this._securityService.search(this.searchSecuritySearchCriteria).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.searchSecuritySearchCriteria.total = response.totalItems;
                                _this.securitySearchResults = response.data;
                                if (_this.securitySearchResults.length === 0 && open) {
                                    _this.alertService.warning(_this.translationService.translate(translation_constants_1.TranslationConstants.SEARCH_NO_RESULT));
                                } else if (_this.securitySearchResults.length === 1 && open) {
                                    _this.select(_this.securitySearchResults[0]);
                                }
                            }
                            _this.loading = false;
                        });
                    }
                };
                SecurityTableComponent.prototype.select = function (security) {
                    var referenceDate = this.referenceDate;
                    var id = security.valorNumber.toString();
                    if (ags_client_1.isPresent(this.searchSecuritySearchCriteria.isin)) {
                        id = this.searchSecuritySearchCriteria.isin;
                    }
                    if (!ags_client_1.isPresent(referenceDate)) {
                        referenceDate = ags_client_1.createDate(this.searchSecuritySearchCriteria.year, 12, 31);
                    }
                    this.selected.emit({ id: id, referenceDate: referenceDate });
                };
                __decorate([core_1.Input(), __metadata("design:type", String)], SecurityTableComponent.prototype, "id", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Number)], SecurityTableComponent.prototype, "year", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], SecurityTableComponent.prototype, "selected", void 0);
                __decorate([ags_client_3.PageFlow('SecurityTable'), __metadata("design:type", Date)], SecurityTableComponent.prototype, "referenceDate", void 0);
                __decorate([ags_client_3.PageFlow('SecurityTable'), __metadata("design:type", Boolean)], SecurityTableComponent.prototype, "extendedSearch", void 0);
                __decorate([ags_client_3.PageFlow('SecurityTable'), __metadata("design:type", search_security_search_criteria_1.SearchSecuritySearchCriteria)], SecurityTableComponent.prototype, "searchSecuritySearchCriteria", void 0);
                __decorate([ags_client_3.PageFlow('SecurityTable'), __metadata("design:type", Array)], SecurityTableComponent.prototype, "securitySearchResults", void 0);
                SecurityTableComponent = __decorate([core_1.Component({
                    directives: [ags_client_1.AGS_FORM_DIRECTIVES, ict_core_client_1.ICT_CORE_DIRECTIVES, common_1.NgClass],
                    pipes: [ags_client_1.AGS_PIPES],
                    selector: 'security-table',
                    templateUrl: 'ict-external-client/app/components/security_table_component.html'
                }), __metadata("design:paramtypes", [ags_client_2.AlertService, ags_client_2.TranslationService, security_service_1.SecurityService, ags_client_2.AuthenticationService, application_service_1.ApplicationService, core_1.ElementRef])], SecurityTableComponent);
                return SecurityTableComponent;
            }(ags_client_4.AbstractTableComponent);
            exports_1("SecurityTableComponent", SecurityTableComponent);
        }
    };
});

System.register("ict-external-client/app/views/search_view.js", ["angular2/core.js", "angular2/router.js", "ags-client/ags-client.js", "ict-external-client/app/components/security_table_component.js", "ict-external-client/gen/views.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, router_1, ags_client_1, ags_client_2, ags_client_3, ags_client_4, security_table_component_1, views_1, SearchView;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (router_1_1) {
            router_1 = router_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
        }, function (security_table_component_1_1) {
            security_table_component_1 = security_table_component_1_1;
        }, function (views_1_1) {
            views_1 = views_1_1;
        }],
        execute: function () {
            SearchView = /** @class */function (_super) {
                __extends(SearchView, _super);
                function SearchView(navigationService, router) {
                    return _super.call(this, navigationService, router) || this;
                }
                SearchView.prototype.focus = function () {
                    return;
                };
                SearchView.prototype.open = function (securityReference) {
                    this.router.navigate([views_1.SECURITY_ID_DATE_VIEW, {
                        id: securityReference.id,
                        date: ags_client_4.formatDateForLink(securityReference.referenceDate)
                    }]);
                };
                __decorate([core_1.ViewChildren(security_table_component_1.SecurityTableComponent), __metadata("design:type", core_1.QueryList)], SearchView.prototype, "securityTable", void 0);
                SearchView = __decorate([core_1.Component({
                    selector: 'search-view',
                    directives: [ags_client_1.AGS_DIRECTIVES, security_table_component_1.SecurityTableComponent],
                    pipes: [ags_client_1.AGS_PIPES],
                    templateUrl: 'ict-external-client/app/views/search_view.html'
                }), router_1.CanActivate(function () {
                    return ags_client_1.AuthenticationService.checkViewSecurity(views_1.VIEW_SECURITY[views_1.SEARCH_VIEW]);
                }), __metadata("design:paramtypes", [ags_client_2.NavigationService, router_1.Router])], SearchView);
                return SearchView;
            }(ags_client_3.AbstractView);
            exports_1("SearchView", SearchView);
        }
    };
});

System.register("ict-external-client/gen/viewmodels/security_calculation_view_model.js", ["ags-client/ags-client.js", "ict-core-client/ict-core-client.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, ags_client_2, ags_client_3, ags_client_4, ags_client_5, ags_client_6, ict_core_client_1, ags_client_7, ags_client_8, SecurityCalculationViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
            ags_client_5 = ags_client_1_1;
            ags_client_6 = ags_client_1_1;
            ags_client_7 = ags_client_1_1;
            ags_client_8 = ags_client_1_1;
        }, function (ict_core_client_1_1) {
            ict_core_client_1 = ict_core_client_1_1;
        }],
        execute: function () {
            SecurityCalculationViewModel = /** @class */function () {
                function SecurityCalculationViewModel() {}
                SecurityCalculationViewModel.deserialize = function (object) {
                    var _result = new SecurityCalculationViewModel();
                    return _result._deserialize(object);
                };
                SecurityCalculationViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (ags_client_1.isPresent(object['referenceDate'])) {
                            this.referenceDate = ags_client_3.deserializeDate(object['referenceDate']);
                        }
                        if (ags_client_1.isPresent(object['issueDate'])) {
                            this.issueDate = ags_client_3.deserializeDate(object['issueDate']);
                        }
                        if (ags_client_1.isPresent(object['conversionDate'])) {
                            this.conversionDate = ags_client_3.deserializeDate(object['conversionDate']);
                        }
                        if (ags_client_1.isPresent(object['conversionExchangeRate'])) {
                            this.conversionExchangeRate = object['conversionExchangeRate'];
                        }
                        if (ags_client_1.isPresent(object['currency'])) {
                            this.currency = new ags_client_4.Currency(object['currency']['shortName']);
                        }
                        if (ags_client_1.isPresent(object['dispositionDate'])) {
                            this.dispositionDate = ags_client_3.deserializeDate(object['dispositionDate']);
                        }
                        if (ags_client_1.isPresent(object['dispositionExchangeRate'])) {
                            this.dispositionExchangeRate = object['dispositionExchangeRate'];
                        }
                        if (ags_client_1.isPresent(object['dispositionRateTotal'])) {
                            this.dispositionRateTotal = object['dispositionRateTotal'];
                        }
                        if (ags_client_1.isPresent(object['dispositionRateTotalChf'])) {
                            this.dispositionRateTotalChf = object['dispositionRateTotalChf'];
                        }
                        if (ags_client_1.isPresent(object['securityId'])) {
                            this.securityId = object['securityId'];
                        }
                        if (ags_client_1.isPresent(object['internalNumber'])) {
                            this.internalNumber = object['internalNumber'];
                        }
                        if (ags_client_1.isPresent(object['isin'])) {
                            this.isin = object['isin'];
                        }
                        if (ags_client_1.isPresent(object['name'])) {
                            this.name = object['name'];
                        }
                        if (ags_client_1.isPresent(object['paymentValueTotalChfWithHoldingTax'])) {
                            this.paymentValueTotalChfWithHoldingTax = object['paymentValueTotalChfWithHoldingTax'];
                        }
                        if (ags_client_1.isPresent(object['paymentValueTotalChfWithoutHoldingTax'])) {
                            this.paymentValueTotalChfWithoutHoldingTax = object['paymentValueTotalChfWithoutHoldingTax'];
                        }
                        if (ags_client_1.isPresent(object['purchaseDate'])) {
                            this.purchaseDate = ags_client_3.deserializeDate(object['purchaseDate']);
                        }
                        if (ags_client_1.isPresent(object['purchaseExchangeRate'])) {
                            this.purchaseExchangeRate = object['purchaseExchangeRate'];
                        }
                        if (ags_client_1.isPresent(object['purchaseRateTotal'])) {
                            this.purchaseRateTotal = object['purchaseRateTotal'];
                        }
                        if (ags_client_1.isPresent(object['purchaseRateTotalChf'])) {
                            this.purchaseRateTotalChf = object['purchaseRateTotalChf'];
                        }
                        if (ags_client_1.isPresent(object['quantity'])) {
                            this.quantity = object['quantity'];
                        }
                        if (ags_client_1.isPresent(object['quotationType'])) {
                            this.quotationType = ags_client_6.enumNumberValue(ags_client_5.QuotationType, object['quotationType']);
                        }
                        if (ags_client_1.isPresent(object['taxValueTotalChf'])) {
                            this.taxValueTotalChf = object['taxValueTotalChf'];
                        }
                        if (ags_client_1.isPresent(object['uId'])) {
                            this.uId = object['uId'];
                        }
                        if (ags_client_1.isPresent(object['valorNumber'])) {
                            this.valorNumber = object['valorNumber'];
                        }
                        if (ags_client_1.isPresent(object['securityCalculationType'])) {
                            this.securityCalculationType = ags_client_6.enumNumberValue(ict_core_client_1.SecurityCalculationType, object['securityCalculationType']);
                        }
                        if (ags_client_1.isPresent(object['conversionSelection'])) {
                            this.conversionSelection = object['conversionSelection'];
                        }
                        if (ags_client_1.isPresent(object['conversion'])) {
                            this.conversion = object['conversion'];
                        }
                        if (ags_client_1.isPresent(object['modifiedDifferentialTaxation'])) {
                            this.modifiedDifferentialTaxation = object['modifiedDifferentialTaxation'];
                        }
                        if (ags_client_1.isPresent(object['pureDifferentialTaxation'])) {
                            this.pureDifferentialTaxation = object['pureDifferentialTaxation'];
                        }
                        if (ags_client_1.isPresent(object['language'])) {
                            this.language = object['language'];
                        }
                        if (ags_client_1.isPresent(object['instrumentGroup'])) {
                            this.instrumentGroup = ags_client_6.enumNumberValue(ags_client_7.InstrumentGroup, object['instrumentGroup']);
                        }
                        if (ags_client_1.isPresent(object['calculationCanton'])) {
                            this.calculationCanton = ags_client_6.enumNumberValue(ags_client_8.Canton, object['calculationCanton']);
                        }
                    }
                    return this;
                };
                SecurityCalculationViewModel.prototype.serialize = function () {
                    var object = {};
                    if (ags_client_1.isPresent(this.referenceDate)) {
                        object['referenceDate'] = ags_client_2.serializeDate(this.referenceDate);
                    }
                    if (ags_client_1.isPresent(this.issueDate)) {
                        object['issueDate'] = ags_client_2.serializeDate(this.issueDate);
                    }
                    if (ags_client_1.isPresent(this.conversionDate)) {
                        object['conversionDate'] = ags_client_2.serializeDate(this.conversionDate);
                    }
                    if (ags_client_1.isPresent(this.conversionExchangeRate)) {
                        object['conversionExchangeRate'] = this.conversionExchangeRate;
                    }
                    if (ags_client_1.isPresent(this.currency)) {
                        object['currency'] = this.currency;
                    }
                    if (ags_client_1.isPresent(this.dispositionDate)) {
                        object['dispositionDate'] = ags_client_2.serializeDate(this.dispositionDate);
                    }
                    if (ags_client_1.isPresent(this.dispositionExchangeRate)) {
                        object['dispositionExchangeRate'] = this.dispositionExchangeRate;
                    }
                    if (ags_client_1.isPresent(this.dispositionRateTotal)) {
                        object['dispositionRateTotal'] = this.dispositionRateTotal;
                    }
                    if (ags_client_1.isPresent(this.dispositionRateTotalChf)) {
                        object['dispositionRateTotalChf'] = this.dispositionRateTotalChf;
                    }
                    if (ags_client_1.isPresent(this.securityId)) {
                        object['securityId'] = this.securityId;
                    }
                    if (ags_client_1.isPresent(this.internalNumber)) {
                        object['internalNumber'] = this.internalNumber;
                    }
                    if (ags_client_1.isPresent(this.isin)) {
                        object['isin'] = this.isin;
                    }
                    if (ags_client_1.isPresent(this.name)) {
                        object['name'] = this.name;
                    }
                    if (ags_client_1.isPresent(this.paymentValueTotalChfWithHoldingTax)) {
                        object['paymentValueTotalChfWithHoldingTax'] = this.paymentValueTotalChfWithHoldingTax;
                    }
                    if (ags_client_1.isPresent(this.paymentValueTotalChfWithoutHoldingTax)) {
                        object['paymentValueTotalChfWithoutHoldingTax'] = this.paymentValueTotalChfWithoutHoldingTax;
                    }
                    if (ags_client_1.isPresent(this.purchaseDate)) {
                        object['purchaseDate'] = ags_client_2.serializeDate(this.purchaseDate);
                    }
                    if (ags_client_1.isPresent(this.purchaseExchangeRate)) {
                        object['purchaseExchangeRate'] = this.purchaseExchangeRate;
                    }
                    if (ags_client_1.isPresent(this.purchaseRateTotal)) {
                        object['purchaseRateTotal'] = this.purchaseRateTotal;
                    }
                    if (ags_client_1.isPresent(this.purchaseRateTotalChf)) {
                        object['purchaseRateTotalChf'] = this.purchaseRateTotalChf;
                    }
                    if (ags_client_1.isPresent(this.quantity)) {
                        object['quantity'] = this.quantity;
                    }
                    if (ags_client_1.isPresent(this.quotationType)) {
                        object['quotationType'] = ags_client_5.QuotationType[this.quotationType];
                    }
                    if (ags_client_1.isPresent(this.taxValueTotalChf)) {
                        object['taxValueTotalChf'] = this.taxValueTotalChf;
                    }
                    if (ags_client_1.isPresent(this.uId)) {
                        object['uId'] = this.uId;
                    }
                    if (ags_client_1.isPresent(this.valorNumber)) {
                        object['valorNumber'] = this.valorNumber;
                    }
                    if (ags_client_1.isPresent(this.securityCalculationType)) {
                        object['securityCalculationType'] = ict_core_client_1.SecurityCalculationType[this.securityCalculationType];
                    }
                    if (ags_client_1.isPresent(this.conversionSelection)) {
                        object['conversionSelection'] = this.conversionSelection;
                    }
                    if (ags_client_1.isPresent(this.conversion)) {
                        object['conversion'] = this.conversion;
                    }
                    if (ags_client_1.isPresent(this.modifiedDifferentialTaxation)) {
                        object['modifiedDifferentialTaxation'] = this.modifiedDifferentialTaxation;
                    }
                    if (ags_client_1.isPresent(this.pureDifferentialTaxation)) {
                        object['pureDifferentialTaxation'] = this.pureDifferentialTaxation;
                    }
                    if (ags_client_1.isPresent(this.language)) {
                        object['language'] = this.language;
                    }
                    if (ags_client_1.isPresent(this.instrumentGroup)) {
                        object['instrumentGroup'] = ags_client_7.InstrumentGroup[this.instrumentGroup];
                    }
                    if (ags_client_1.isPresent(this.calculationCanton)) {
                        object['calculationCanton'] = ags_client_8.Canton[this.calculationCanton];
                    }
                    return object;
                };
                SecurityCalculationViewModel.REFERENCE_DATE_VALIDATORS = [];
                SecurityCalculationViewModel.ISSUE_DATE_VALIDATORS = [];
                SecurityCalculationViewModel.CONVERSION_DATE_VALIDATORS = [];
                SecurityCalculationViewModel.CONVERSION_EXCHANGE_RATE_VALIDATORS = [];
                SecurityCalculationViewModel.CURRENCY_VALIDATORS = [];
                SecurityCalculationViewModel.DISPOSITION_DATE_VALIDATORS = [];
                SecurityCalculationViewModel.DISPOSITION_EXCHANGE_RATE_VALIDATORS = [];
                SecurityCalculationViewModel.DISPOSITION_RATE_TOTAL_VALIDATORS = [];
                SecurityCalculationViewModel.DISPOSITION_RATE_TOTAL_CHF_VALIDATORS = [];
                SecurityCalculationViewModel.SECURITY_ID_VALIDATORS = [];
                SecurityCalculationViewModel.INTERNAL_NUMBER_VALIDATORS = [];
                SecurityCalculationViewModel.ISIN_VALIDATORS = [];
                SecurityCalculationViewModel.NAME_VALIDATORS = [];
                SecurityCalculationViewModel.PAYMENT_VALUE_TOTAL_CHF_WITH_HOLDING_TAX_VALIDATORS = [];
                SecurityCalculationViewModel.PAYMENT_VALUE_TOTAL_CHF_WITHOUT_HOLDING_TAX_VALIDATORS = [];
                SecurityCalculationViewModel.PURCHASE_DATE_VALIDATORS = [];
                SecurityCalculationViewModel.PURCHASE_EXCHANGE_RATE_VALIDATORS = [];
                SecurityCalculationViewModel.PURCHASE_RATE_TOTAL_VALIDATORS = [];
                SecurityCalculationViewModel.PURCHASE_RATE_TOTAL_CHF_VALIDATORS = [];
                SecurityCalculationViewModel.QUANTITY_VALIDATORS = [];
                SecurityCalculationViewModel.QUOTATION_TYPE_VALIDATORS = [];
                SecurityCalculationViewModel.TAX_VALUE_TOTAL_CHF_VALIDATORS = [];
                SecurityCalculationViewModel.U_ID_VALIDATORS = [];
                SecurityCalculationViewModel.VALOR_NUMBER_VALIDATORS = [];
                SecurityCalculationViewModel.SECURITY_CALCULATION_TYPE_VALIDATORS = [];
                SecurityCalculationViewModel.CONVERSION_SELECTION_VALIDATORS = [];
                SecurityCalculationViewModel.CONVERSION_VALIDATORS = [];
                SecurityCalculationViewModel.MODIFIED_DIFFERENTIAL_TAXATION_VALIDATORS = [];
                SecurityCalculationViewModel.PURE_DIFFERENTIAL_TAXATION_VALIDATORS = [];
                SecurityCalculationViewModel.LANGUAGE_VALIDATORS = [];
                SecurityCalculationViewModel.INSTRUMENT_GROUP_VALIDATORS = [];
                SecurityCalculationViewModel.CALCULATION_CANTON_VALIDATORS = [];
                return SecurityCalculationViewModel;
            }();
            exports_1("SecurityCalculationViewModel", SecurityCalculationViewModel);
        }
    };
});

System.register("ict-external-client/gen/enums.js", [], function (exports_1, context_1) {
    "use strict";

    var SecurityCalculationDetailsEntryType;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [],
        execute: function () {
            /**
             * generated by AGS
             */
            (function (SecurityCalculationDetailsEntryType) {
                SecurityCalculationDetailsEntryType[SecurityCalculationDetailsEntryType["ORIGINAL_DISCONT"] = 0] = "ORIGINAL_DISCONT";
                SecurityCalculationDetailsEntryType[SecurityCalculationDetailsEntryType["PAYMENT"] = 1] = "PAYMENT";
                SecurityCalculationDetailsEntryType[SecurityCalculationDetailsEntryType["TAX_VALUE"] = 2] = "TAX_VALUE";
                SecurityCalculationDetailsEntryType[SecurityCalculationDetailsEntryType["MODIFIED_DIFFERENTIAL_TAXATION_DISPOSITION"] = 3] = "MODIFIED_DIFFERENTIAL_TAXATION_DISPOSITION";
                SecurityCalculationDetailsEntryType[SecurityCalculationDetailsEntryType["MODIFIED_DIFFERENTIAL_TAXATION_PURCHASE"] = 4] = "MODIFIED_DIFFERENTIAL_TAXATION_PURCHASE";
                SecurityCalculationDetailsEntryType[SecurityCalculationDetailsEntryType["CONVERTIBLE"] = 5] = "CONVERTIBLE";
                SecurityCalculationDetailsEntryType[SecurityCalculationDetailsEntryType["ISSUE"] = 6] = "ISSUE";
                SecurityCalculationDetailsEntryType[SecurityCalculationDetailsEntryType["ACCRUED_INTEREST"] = 7] = "ACCRUED_INTEREST";
                SecurityCalculationDetailsEntryType[SecurityCalculationDetailsEntryType["PURE_DIFFERENTIAL_TAXATION_DISPOSITION"] = 8] = "PURE_DIFFERENTIAL_TAXATION_DISPOSITION";
                SecurityCalculationDetailsEntryType[SecurityCalculationDetailsEntryType["PURE_DIFFERENTIAL_TAXATION_PURCHASE"] = 9] = "PURE_DIFFERENTIAL_TAXATION_PURCHASE";
            })(SecurityCalculationDetailsEntryType || exports_1("SecurityCalculationDetailsEntryType", SecurityCalculationDetailsEntryType = {}));
        }
    };
});

System.register("ict-external-client/gen/viewmodels/security_calculation_details_entry_view_model.js", ["ags-client/ags-client.js", "ict-external-client/gen/enums.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, enums_1, ags_client_2, ags_client_3, ags_client_4, ags_client_5, SecurityCalculationDetailsEntryViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
            ags_client_5 = ags_client_1_1;
        }, function (enums_1_1) {
            enums_1 = enums_1_1;
        }],
        execute: function () {
            SecurityCalculationDetailsEntryViewModel = /** @class */function () {
                function SecurityCalculationDetailsEntryViewModel() {}
                SecurityCalculationDetailsEntryViewModel.deserialize = function (object) {
                    var _result = new SecurityCalculationDetailsEntryViewModel();
                    return _result._deserialize(object);
                };
                SecurityCalculationDetailsEntryViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (ags_client_1.isPresent(object['type'])) {
                            this.type = ags_client_2.enumNumberValue(enums_1.SecurityCalculationDetailsEntryType, object['type']);
                        }
                        if (ags_client_1.isPresent(object['name'])) {
                            this.name = object['name'];
                        }
                        if (ags_client_1.isPresent(object['currency'])) {
                            this.currency = new ags_client_3.Currency(object['currency']['shortName']);
                        }
                        if (ags_client_1.isPresent(object['nominalQuantity'])) {
                            this.nominalQuantity = object['nominalQuantity'];
                        }
                        if (ags_client_1.isPresent(object['date'])) {
                            this.date = ags_client_5.deserializeDate(object['date']);
                        }
                        if (ags_client_1.isPresent(object['exDate'])) {
                            this.exDate = ags_client_5.deserializeDate(object['exDate']);
                        }
                        if (ags_client_1.isPresent(object['paymentDate'])) {
                            this.paymentDate = ags_client_5.deserializeDate(object['paymentDate']);
                        }
                        if (ags_client_1.isPresent(object['variant'])) {
                            this.variant = object['variant'];
                        }
                        if (ags_client_1.isPresent(object['percent'])) {
                            this.percent = object['percent'];
                        }
                        if (ags_client_1.isPresent(object['value'])) {
                            this.value = object['value'];
                        }
                        if (ags_client_1.isPresent(object['valueTotal'])) {
                            this.valueTotal = object['valueTotal'];
                        }
                        if (ags_client_1.isPresent(object['exchangeRate'])) {
                            this.exchangeRate = object['exchangeRate'];
                        }
                        if (ags_client_1.isPresent(object['valueChf'])) {
                            this.valueChf = object['valueChf'];
                        }
                        if (ags_client_1.isPresent(object['valueTotalChf'])) {
                            this.valueTotalChf = object['valueTotalChf'];
                        }
                        if (ags_client_1.isPresent(object['taxValueChf'])) {
                            this.taxValueChf = object['taxValueChf'];
                        }
                        if (ags_client_1.isPresent(object['withHoldingTax'])) {
                            this.withHoldingTax = object['withHoldingTax'];
                        }
                        if (ags_client_1.isPresent(object['paymentValueTotalChfWithHoldingTax'])) {
                            this.paymentValueTotalChfWithHoldingTax = object['paymentValueTotalChfWithHoldingTax'];
                        }
                        if (ags_client_1.isPresent(object['valuePrefix'])) {
                            this.valuePrefix = object['valuePrefix'];
                        }
                        if (ags_client_1.isPresent(object['paymentValueTotalChfWithoutHoldingTax'])) {
                            this.paymentValueTotalChfWithoutHoldingTax = object['paymentValueTotalChfWithoutHoldingTax'];
                        }
                        if (ags_client_1.isPresent(object['remark'])) {
                            this.remark = object['remark'];
                        }
                        if (ags_client_1.isPresent(object['sign'])) {
                            this.sign = object['sign'];
                        }
                    }
                    return this;
                };
                SecurityCalculationDetailsEntryViewModel.prototype.serialize = function () {
                    var object = {};
                    if (ags_client_1.isPresent(this.type)) {
                        object['type'] = enums_1.SecurityCalculationDetailsEntryType[this.type];
                    }
                    if (ags_client_1.isPresent(this.name)) {
                        object['name'] = this.name;
                    }
                    if (ags_client_1.isPresent(this.currency)) {
                        object['currency'] = this.currency;
                    }
                    if (ags_client_1.isPresent(this.nominalQuantity)) {
                        object['nominalQuantity'] = this.nominalQuantity;
                    }
                    if (ags_client_1.isPresent(this.date)) {
                        object['date'] = ags_client_4.serializeDate(this.date);
                    }
                    if (ags_client_1.isPresent(this.exDate)) {
                        object['exDate'] = ags_client_4.serializeDate(this.exDate);
                    }
                    if (ags_client_1.isPresent(this.paymentDate)) {
                        object['paymentDate'] = ags_client_4.serializeDate(this.paymentDate);
                    }
                    if (ags_client_1.isPresent(this.variant)) {
                        object['variant'] = this.variant;
                    }
                    if (ags_client_1.isPresent(this.percent)) {
                        object['percent'] = this.percent;
                    }
                    if (ags_client_1.isPresent(this.value)) {
                        object['value'] = this.value;
                    }
                    if (ags_client_1.isPresent(this.valueTotal)) {
                        object['valueTotal'] = this.valueTotal;
                    }
                    if (ags_client_1.isPresent(this.exchangeRate)) {
                        object['exchangeRate'] = this.exchangeRate;
                    }
                    if (ags_client_1.isPresent(this.valueChf)) {
                        object['valueChf'] = this.valueChf;
                    }
                    if (ags_client_1.isPresent(this.valueTotalChf)) {
                        object['valueTotalChf'] = this.valueTotalChf;
                    }
                    if (ags_client_1.isPresent(this.taxValueChf)) {
                        object['taxValueChf'] = this.taxValueChf;
                    }
                    if (ags_client_1.isPresent(this.withHoldingTax)) {
                        object['withHoldingTax'] = this.withHoldingTax;
                    }
                    if (ags_client_1.isPresent(this.paymentValueTotalChfWithHoldingTax)) {
                        object['paymentValueTotalChfWithHoldingTax'] = this.paymentValueTotalChfWithHoldingTax;
                    }
                    if (ags_client_1.isPresent(this.valuePrefix)) {
                        object['valuePrefix'] = this.valuePrefix;
                    }
                    if (ags_client_1.isPresent(this.paymentValueTotalChfWithoutHoldingTax)) {
                        object['paymentValueTotalChfWithoutHoldingTax'] = this.paymentValueTotalChfWithoutHoldingTax;
                    }
                    if (ags_client_1.isPresent(this.remark)) {
                        object['remark'] = this.remark;
                    }
                    if (ags_client_1.isPresent(this.sign)) {
                        object['sign'] = this.sign;
                    }
                    return object;
                };
                SecurityCalculationDetailsEntryViewModel.TYPE_VALIDATORS = [];
                SecurityCalculationDetailsEntryViewModel.NAME_VALIDATORS = [];
                SecurityCalculationDetailsEntryViewModel.CURRENCY_VALIDATORS = [];
                SecurityCalculationDetailsEntryViewModel.NOMINAL_QUANTITY_VALIDATORS = [];
                SecurityCalculationDetailsEntryViewModel.DATE_VALIDATORS = [];
                SecurityCalculationDetailsEntryViewModel.EX_DATE_VALIDATORS = [];
                SecurityCalculationDetailsEntryViewModel.PAYMENT_DATE_VALIDATORS = [];
                SecurityCalculationDetailsEntryViewModel.VARIANT_VALIDATORS = [];
                SecurityCalculationDetailsEntryViewModel.PERCENT_VALIDATORS = [];
                SecurityCalculationDetailsEntryViewModel.VALUE_VALIDATORS = [];
                SecurityCalculationDetailsEntryViewModel.VALUE_TOTAL_VALIDATORS = [];
                SecurityCalculationDetailsEntryViewModel.EXCHANGE_RATE_VALIDATORS = [];
                SecurityCalculationDetailsEntryViewModel.VALUE_CHF_VALIDATORS = [];
                SecurityCalculationDetailsEntryViewModel.VALUE_TOTAL_CHF_VALIDATORS = [];
                SecurityCalculationDetailsEntryViewModel.TAX_VALUE_CHF_VALIDATORS = [];
                SecurityCalculationDetailsEntryViewModel.WITH_HOLDING_TAX_VALIDATORS = [];
                SecurityCalculationDetailsEntryViewModel.PAYMENT_VALUE_TOTAL_CHF_WITH_HOLDING_TAX_VALIDATORS = [];
                SecurityCalculationDetailsEntryViewModel.VALUE_PREFIX_VALIDATORS = [];
                SecurityCalculationDetailsEntryViewModel.PAYMENT_VALUE_TOTAL_CHF_WITHOUT_HOLDING_TAX_VALIDATORS = [];
                SecurityCalculationDetailsEntryViewModel.REMARK_VALIDATORS = [];
                SecurityCalculationDetailsEntryViewModel.SIGN_VALIDATORS = [];
                return SecurityCalculationDetailsEntryViewModel;
            }();
            exports_1("SecurityCalculationDetailsEntryViewModel", SecurityCalculationDetailsEntryViewModel);
        }
    };
});

System.register("ict-external-client/gen/viewmodels/security_calculation_details_view_model.js", ["ags-client/ags-client.js", "ict-external-client/gen/viewmodels/security_calculation_details_entry_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, security_calculation_details_entry_view_model_1, SecurityCalculationDetailsViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }, function (security_calculation_details_entry_view_model_1_1) {
            security_calculation_details_entry_view_model_1 = security_calculation_details_entry_view_model_1_1;
        }],
        execute: function () {
            SecurityCalculationDetailsViewModel = /** @class */function () {
                function SecurityCalculationDetailsViewModel() {}
                SecurityCalculationDetailsViewModel.deserialize = function (object) {
                    var _result = new SecurityCalculationDetailsViewModel();
                    return _result._deserialize(object);
                };
                SecurityCalculationDetailsViewModel.prototype._deserialize = function (object) {
                    var _this = this;
                    if (object) {
                        if (ags_client_1.isPresent(object['remarks'])) {
                            this.remarks = [];
                            object['remarks'].forEach(function (item) {
                                _this.remarks.push(item);
                            });
                        }
                        if (ags_client_1.isPresent(object['entries'])) {
                            this.entries = [];
                            object['entries'].forEach(function (item) {
                                _this.entries.push(security_calculation_details_entry_view_model_1.SecurityCalculationDetailsEntryViewModel.deserialize(item));
                            });
                        }
                    }
                    return this;
                };
                SecurityCalculationDetailsViewModel.prototype.serialize = function () {
                    var object = {};
                    if (ags_client_1.isPresent(this.remarks)) {
                        object['remarks'] = [];
                        this.remarks.forEach(function (item) {
                            object['remarks'].push(item);
                        });
                    }
                    if (ags_client_1.isPresent(this.entries)) {
                        object['entries'] = [];
                        this.entries.forEach(function (item) {
                            object['entries'].push(item.serialize());
                        });
                    }
                    return object;
                };
                SecurityCalculationDetailsViewModel.REMARKS_VALIDATORS = [];
                SecurityCalculationDetailsViewModel.ENTRIES_VALIDATORS = [];
                return SecurityCalculationDetailsViewModel;
            }();
            exports_1("SecurityCalculationDetailsViewModel", SecurityCalculationDetailsViewModel);
        }
    };
});

System.register("ict-external-client/gen/viewmodels/security_view_model.js", ["ags-client/ags-client.js", "ict-external-client/gen/viewmodels/security_calculation_view_model.js", "ict-external-client/gen/viewmodels/security_calculation_details_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, security_calculation_view_model_1, security_calculation_details_view_model_1, SecurityViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }, function (security_calculation_view_model_1_1) {
            security_calculation_view_model_1 = security_calculation_view_model_1_1;
        }, function (security_calculation_details_view_model_1_1) {
            security_calculation_details_view_model_1 = security_calculation_details_view_model_1_1;
        }],
        execute: function () {
            SecurityViewModel = /** @class */function () {
                function SecurityViewModel() {}
                SecurityViewModel.deserialize = function (object) {
                    var _result = new SecurityViewModel();
                    return _result._deserialize(object);
                };
                SecurityViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (ags_client_1.isPresent(object['calculation'])) {
                            this.calculation = security_calculation_view_model_1.SecurityCalculationViewModel.deserialize(object['calculation']);
                        }
                        if (ags_client_1.isPresent(object['calculationDetails'])) {
                            this.calculationDetails = security_calculation_details_view_model_1.SecurityCalculationDetailsViewModel.deserialize(object['calculationDetails']);
                        }
                    }
                    return this;
                };
                SecurityViewModel.prototype.serialize = function () {
                    var object = {};
                    if (ags_client_1.isPresent(this.calculation)) {
                        object['calculation'] = this.calculation.serialize();
                    }
                    if (ags_client_1.isPresent(this.calculationDetails)) {
                        object['calculationDetails'] = this.calculationDetails.serialize();
                    }
                    return object;
                };
                SecurityViewModel.CALCULATION_VALIDATORS = [];
                SecurityViewModel.CALCULATION_DETAILS_VALIDATORS = [];
                return SecurityViewModel;
            }();
            exports_1("SecurityViewModel", SecurityViewModel);
        }
    };
});

System.register("ict-external-client/gen/viewmodels/security_html_view_model.js", ["ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, SecurityHtmlViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }],
        execute: function () {
            SecurityHtmlViewModel = /** @class */function () {
                function SecurityHtmlViewModel() {}
                SecurityHtmlViewModel.deserialize = function (object) {
                    var _result = new SecurityHtmlViewModel();
                    return _result._deserialize(object);
                };
                SecurityHtmlViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (ags_client_1.isPresent(object['html'])) {
                            this.html = object['html'];
                        }
                        if (ags_client_1.isPresent(object['showCantonBL'])) {
                            this.showCantonBL = object['showCantonBL'];
                        }
                    }
                    return this;
                };
                SecurityHtmlViewModel.prototype.serialize = function () {
                    var object = {};
                    if (ags_client_1.isPresent(this.html)) {
                        object['html'] = this.html;
                    }
                    if (ags_client_1.isPresent(this.showCantonBL)) {
                        object['showCantonBL'] = this.showCantonBL;
                    }
                    return object;
                };
                SecurityHtmlViewModel.HTML_VALIDATORS = [];
                SecurityHtmlViewModel.SHOW_CANTON_B_L_VALIDATORS = [];
                return SecurityHtmlViewModel;
            }();
            exports_1("SecurityHtmlViewModel", SecurityHtmlViewModel);
        }
    };
});

System.register("ict-external-client/gen/services/abstract_security_service.js", ["ags-client/ags-client.js", "ict-external-client/gen/viewmodels/security_search_result_view_model.js", "ict-external-client/gen/viewmodels/security_view_model.js", "ict-external-client/gen/viewmodels/security_html_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, security_search_result_view_model_1, security_view_model_1, security_html_view_model_1, AbstractSecurityService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }, function (security_search_result_view_model_1_1) {
            security_search_result_view_model_1 = security_search_result_view_model_1_1;
        }, function (security_view_model_1_1) {
            security_view_model_1 = security_view_model_1_1;
        }, function (security_html_view_model_1_1) {
            security_html_view_model_1 = security_html_view_model_1_1;
        }],
        execute: function () {
            AbstractSecurityService = /** @class */function () {
                function AbstractSecurityService(backendService) {
                    this.backendService = backendService;
                }
                AbstractSecurityService.prototype.search = function (request) {
                    return this.backendService.postJson('/security/search.json', request.serialize(), function (response) {
                        var data = Array();
                        response.data.forEach(function (item) {
                            data.push(security_search_result_view_model_1.SecuritySearchResultViewModel.deserialize(item));
                        });
                        return ags_client_1.JsonResponse.deserialize(response, data);
                    });
                };
                AbstractSecurityService.prototype.security = function (request) {
                    return this.backendService.postJson('/security/security.json', request.serialize(), function (response) {
                        return ags_client_1.JsonResponse.deserialize(response, security_view_model_1.SecurityViewModel.deserialize(response.data));
                    });
                };
                AbstractSecurityService.prototype.securityHtml = function (request) {
                    return this.backendService.postJson('/security/securityHtml.json', request.serialize(), function (response) {
                        return ags_client_1.JsonResponse.deserialize(response, security_html_view_model_1.SecurityHtmlViewModel.deserialize(response.data));
                    });
                };
                AbstractSecurityService.prototype.calculate = function (request) {
                    return this.backendService.postJson('/security/calculate.json', request.serialize(), function (response) {
                        return ags_client_1.JsonResponse.deserialize(response, security_view_model_1.SecurityViewModel.deserialize(response.data));
                    });
                };
                return AbstractSecurityService;
            }();
            exports_1("AbstractSecurityService", AbstractSecurityService);
        }
    };
});

System.register("ict-external-client/app/services/security_service.js", ["angular2/core.js", "ags-client/ags-client.js", "ict-external-client/gen/services/abstract_security_service.js", "ict-external-client/app/services/security_search_service.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, ags_client_1, abstract_security_service_1, security_search_service_1, SecurityService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }, function (abstract_security_service_1_1) {
            abstract_security_service_1 = abstract_security_service_1_1;
        }, function (security_search_service_1_1) {
            security_search_service_1 = security_search_service_1_1;
        }],
        execute: function () {
            SecurityService = /** @class */function (_super) {
                __extends(SecurityService, _super);
                function SecurityService(backendService, securitySearchService) {
                    var _this = _super.call(this, backendService) || this;
                    _this.securitySearchService = securitySearchService;
                    return _this;
                }
                SecurityService.prototype.search = function (request) {
                    // return super.search(request);
                    return this.securitySearchService.search(request);
                };
                SecurityService = __decorate([core_1.Injectable(), core_1.Inject(ags_client_1.BackendService), core_1.Inject(security_search_service_1.SecuritySearchService), __metadata("design:paramtypes", [ags_client_1.BackendService, security_search_service_1.SecuritySearchService])], SecurityService);
                return SecurityService;
            }(abstract_security_service_1.AbstractSecurityService);
            exports_1("SecurityService", SecurityService);
        }
    };
});

System.register("ict-external-client/gen/viewmodels/security_request_view_model.js", ["ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, ags_client_2, ags_client_3, SecurityRequestViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
        }],
        execute: function () {
            SecurityRequestViewModel = /** @class */function () {
                function SecurityRequestViewModel() {}
                SecurityRequestViewModel.deserialize = function (object) {
                    var _result = new SecurityRequestViewModel();
                    return _result._deserialize(object);
                };
                SecurityRequestViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (ags_client_1.isPresent(object['valorNumber'])) {
                            this.valorNumber = object['valorNumber'];
                        }
                        if (ags_client_1.isPresent(object['isin'])) {
                            this.isin = object['isin'];
                        }
                        if (ags_client_1.isPresent(object['nsin'])) {
                            this.nsin = object['nsin'];
                        }
                        if (ags_client_1.isPresent(object['referenceDate'])) {
                            this.referenceDate = ags_client_3.deserializeDate(object['referenceDate']);
                        }
                        if (ags_client_1.isPresent(object['language'])) {
                            this.language = object['language'];
                        }
                        if (ags_client_1.isPresent(object['isCantonBL'])) {
                            this.isCantonBL = object['isCantonBL'];
                        }
                    }
                    return this;
                };
                SecurityRequestViewModel.prototype.serialize = function () {
                    var object = {};
                    if (ags_client_1.isPresent(this.valorNumber)) {
                        object['valorNumber'] = this.valorNumber;
                    }
                    if (ags_client_1.isPresent(this.isin)) {
                        object['isin'] = this.isin;
                    }
                    if (ags_client_1.isPresent(this.nsin)) {
                        object['nsin'] = this.nsin;
                    }
                    if (ags_client_1.isPresent(this.referenceDate)) {
                        object['referenceDate'] = ags_client_2.serializeDate(this.referenceDate);
                    }
                    if (ags_client_1.isPresent(this.language)) {
                        object['language'] = this.language;
                    }
                    if (ags_client_1.isPresent(this.isCantonBL)) {
                        object['isCantonBL'] = this.isCantonBL;
                    }
                    return object;
                };
                SecurityRequestViewModel.VALOR_NUMBER_VALIDATORS = [];
                SecurityRequestViewModel.ISIN_VALIDATORS = [];
                SecurityRequestViewModel.NSIN_VALIDATORS = [];
                SecurityRequestViewModel.REFERENCE_DATE_VALIDATORS = [];
                SecurityRequestViewModel.LANGUAGE_VALIDATORS = [];
                SecurityRequestViewModel.IS_CANTON_B_L_VALIDATORS = [];
                return SecurityRequestViewModel;
            }();
            exports_1("SecurityRequestViewModel", SecurityRequestViewModel);
        }
    };
});

System.register("ict-external-client/app/components/security_component.js", ["angular2/core.js", "ags-client/ags-client.js", "ict-external-client/app/services/security_service.js", "ict-external-client/gen/viewmodels/security_request_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, ags_client_1, ags_client_2, security_service_1, security_request_view_model_1, SecurityComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
        }, function (security_service_1_1) {
            security_service_1 = security_service_1_1;
        }, function (security_request_view_model_1_1) {
            security_request_view_model_1 = security_request_view_model_1_1;
        }],
        execute: function () {
            SecurityComponent = /** @class */function (_super) {
                __extends(SecurityComponent, _super);
                function SecurityComponent(alertService, translationService, _securityService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._securityService = _securityService;
                    _this.isCantonBL = false;
                    _this.showCantonBL = new core_1.EventEmitter();
                    _this.securitiesLoaded = new core_1.EventEmitter();
                    _this.loading = true;
                    return _this;
                }
                SecurityComponent.prototype.initData = function () {
                    this.loadData();
                };
                SecurityComponent.prototype.click = function () {
                    this.isCantonBL = !this.isCantonBL;
                    this.loadData();
                };
                SecurityComponent.prototype.loadData = function () {
                    var _this = this;
                    var request = new security_request_view_model_1.SecurityRequestViewModel();
                    request.isin = this.isin;
                    request.nsin = this.nsin;
                    request.valorNumber = this.valorNumber;
                    request.language = this.translationService.language;
                    request.referenceDate = this.referenceDate;
                    request.isCantonBL = this.isCantonBL;
                    this._securityService.securityHtml(request).subscribe(function (response) {
                        if (!_this.handleError(response)) {
                            _this.loading = false;
                            var div = document.createElement('div');
                            div.setAttribute('id', 'instrument_preview_table');
                            var oldChild = document.getElementById('instrument_preview_table');
                            if (oldChild != null) {
                                _this.element.nativeElement.removeChild(oldChild);
                            }
                            div.innerHTML = response.data.html;
                            _this.showCantonBL.emit(response.data.showCantonBL);
                            _this.element.nativeElement.appendChild(div);
                            _this.securitiesLoaded.emit(true);
                        }
                    });
                };
                __decorate([core_1.Input(), __metadata("design:type", String)], SecurityComponent.prototype, "id", void 0);
                __decorate([core_1.Input(), __metadata("design:type", String)], SecurityComponent.prototype, "isin", void 0);
                __decorate([core_1.Input(), __metadata("design:type", String)], SecurityComponent.prototype, "nsin", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Number)], SecurityComponent.prototype, "valorNumber", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Date)], SecurityComponent.prototype, "referenceDate", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Boolean)], SecurityComponent.prototype, "isCantonBL", void 0);
                __decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], SecurityComponent.prototype, "showCantonBL", void 0);
                __decorate([core_1.Output(), __metadata("design:type", core_1.EventEmitter)], SecurityComponent.prototype, "securitiesLoaded", void 0);
                SecurityComponent = __decorate([core_1.Component({
                    directives: [ags_client_1.AGS_DIRECTIVES],
                    pipes: [ags_client_1.AGS_PIPES],
                    selector: 'security',
                    templateUrl: 'ict-external-client/app/components/security_component.html'
                }), __metadata("design:paramtypes", [ags_client_2.AlertService, ags_client_2.TranslationService, security_service_1.SecurityService, core_1.ElementRef])], SecurityComponent);
                return SecurityComponent;
            }(ags_client_2.AbstractComponent);
            exports_1("SecurityComponent", SecurityComponent);
        }
    };
});

System.register("ict-external-client/app/components/security_calculation_form_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/ags-client.js", "ict-external-client/app/services/security_service.js", "ict-external-client/gen/viewmodels/security_request_view_model.js", "ict-external-client/gen/enums.js", "ict-external-client/app/components/security_component.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, ags_client_1, ags_client_2, ags_client_3, ags_client_4, ags_client_5, ags_client_6, ags_client_7, security_service_1, security_request_view_model_1, enums_1, security_component_1, ags_client_8, SecurityCalculationFormComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
            ags_client_5 = ags_client_1_1;
            ags_client_6 = ags_client_1_1;
            ags_client_7 = ags_client_1_1;
            ags_client_8 = ags_client_1_1;
        }, function (security_service_1_1) {
            security_service_1 = security_service_1_1;
        }, function (security_request_view_model_1_1) {
            security_request_view_model_1 = security_request_view_model_1_1;
        }, function (enums_1_1) {
            enums_1 = enums_1_1;
        }, function (security_component_1_1) {
            security_component_1 = security_component_1_1;
        }],
        execute: function () {
            SecurityCalculationFormComponent = /** @class */function (_super) {
                __extends(SecurityCalculationFormComponent, _super);
                function SecurityCalculationFormComponent(alertService, translationService, _securityService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._securityService = _securityService;
                    _this.isCantonBL = false;
                    _this.loadOnInit = true;
                    _this.canceled = new core_1.EventEmitter();
                    _this.submitted = new core_1.EventEmitter();
                    _this._validateConversionDate = function (control) {
                        return !ags_client_7.isPresent(control.value) || _this._validateDate(control.value) && _this.isConversionDateValid(control.value) ? null : { 'date': true };
                    };
                    _this._validateDispositionDate = function (control) {
                        return !ags_client_7.isPresent(control.value) || _this._validateDate(control.value) && _this.isDispositionDateValid(control.value) ? null : { 'date': true };
                    };
                    _this._validatePurchaseDate = function (control) {
                        return !ags_client_7.isPresent(control.value) || _this._validateDate(control.value) && _this.isPurchaseDateValid(control.value) ? null : { 'date': true };
                    };
                    return _this;
                }
                SecurityCalculationFormComponent.prototype.initData = function () {
                    if (this.loadOnInit) {
                        this.loadData();
                    }
                };
                SecurityCalculationFormComponent.prototype.loadData = function () {
                    var _this = this;
                    this.showDetails = false;
                    this.year = this.referenceDate.getFullYear();
                    this.initDispositionConversionDate = this.referenceDate;
                    this.firstDayOfYear = ags_client_7.createDate(this.referenceDate.getFullYear(), 1, 1);
                    var request = new security_request_view_model_1.SecurityRequestViewModel();
                    request.isin = this.isin;
                    request.valorNumber = this.valorNumber;
                    request.language = this.translationService.language;
                    request.referenceDate = this.referenceDate;
                    request.isCantonBL = this.isCantonBL;
                    this._securityService.security(request).subscribe(function (response) {
                        if (!_this.handleError(response)) {
                            if (ags_client_7.isPresent(response.data.calculation)) {
                                _this.security = response.data;
                                _this.calculation = response.data.calculation;
                                _this.calculationDetails = response.data.calculationDetails;
                                _this._completeValuesAfterCalculate();
                                if (ags_client_7.isPresent(_this.calculation.issueDate)) {
                                    if (_this.calculation.issueDate.getTime() < _this.firstDayOfYear.getTime()) {
                                        _this.initPurchaseDate = _this.firstDayOfYear;
                                    } else {
                                        _this.initPurchaseDate = _this.calculation.issueDate;
                                    }
                                }
                            }
                        }
                    });
                    return;
                };
                SecurityCalculationFormComponent.prototype.toggleDetails = function () {
                    this.showDetails = !this.showDetails;
                };
                SecurityCalculationFormComponent.prototype.initKeyStrokes = function () {
                    var _this = this;
                    ags_client_4.KeyStrokeManager.register(ags_client_4.KeyStroke.CANCEL, function () {
                        return _this.cancel();
                    });
                    ags_client_4.KeyStrokeManager.register(ags_client_4.KeyStroke.SAVE, function () {
                        return _this.submit();
                    });
                };
                SecurityCalculationFormComponent.prototype._validateDate = function (value) {
                    return value.toString() !== 'Invalid Date';
                };
                SecurityCalculationFormComponent.prototype.buildForm = function () {
                    this.form = new common_1.ControlGroup({
                        'referenceDate': new common_1.Control(''),
                        'issueDate': new common_1.Control(''),
                        'conversionDate': new common_1.Control('', ags_client_7.validators([ags_client_7.date, this._validateConversionDate])),
                        'conversionExchangeRate': new common_1.Control(''),
                        'currency': new common_1.Control(''),
                        'dispositionDate': new common_1.Control('', ags_client_7.validators([ags_client_7.date, this._validateDispositionDate])),
                        'dispositionExchangeRate': new common_1.Control(''),
                        'dispositionRateTotal': new common_1.Control(''),
                        'dispositionRateTotalChf': new common_1.Control(''),
                        'instrumentId': new common_1.Control(''),
                        'internalNumber': new common_1.Control(''),
                        'isin': new common_1.Control(''),
                        'name': new common_1.Control(''),
                        'paymentValueTotalChfWithHoldingTax': new common_1.Control(''),
                        'paymentValueTotalChfWithoutHoldingTax': new common_1.Control(''),
                        'purchaseDate': new common_1.Control('', ags_client_7.validators([ags_client_7.date, this._validatePurchaseDate])),
                        'purchaseExchangeRate': new common_1.Control(''),
                        'purchaseRateTotal': new common_1.Control(''),
                        'purchaseRateTotalChf': new common_1.Control(''),
                        'quantity': new common_1.Control(''),
                        'quotationType': new common_1.Control(''),
                        'taxValueTotalChf': new common_1.Control(''),
                        'uId': new common_1.Control(''),
                        'valorNumber': new common_1.Control(''),
                        'calculationType': new common_1.Control(''),
                        'conversionSelection': new common_1.Control(''),
                        'conversion': new common_1.Control(''),
                        'modifiedDifferentialTaxation': new common_1.Control(''),
                        'pureDifferentialTaxation': new common_1.Control(''),
                        'language': new common_1.Control('')
                    });
                };
                SecurityCalculationFormComponent.prototype.calculate = function () {
                    var _this = this;
                    this.alertService.reset();
                    if (this.canCalculate() && this.validate()) {
                        this.loading = true;
                        var activeElementId = ags_client_7.isPresent(document.activeElement) ? document.activeElement.getAttribute('id') : null;
                        if (this.isCantonBL) {
                            this.calculation.calculationCanton = ags_client_8.Canton.BL;
                        }
                        this._securityService.calculate(this.security).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                if (ags_client_7.isPresent(response.data.calculation)) {
                                    _this.security = response.data;
                                    _this.calculation = response.data.calculation;
                                    _this.calculationDetails = response.data.calculationDetails;
                                    _this._completeValuesAfterCalculate();
                                    if (ags_client_7.isPresent(activeElementId)) {
                                        _this.focus('#' + activeElementId);
                                    }
                                }
                            }
                            _this.loading = false;
                        });
                    }
                };
                SecurityCalculationFormComponent.prototype._completeValuesAfterCalculate = function () {
                    if (ags_client_7.isPresent(this.calculationDetails) && ags_client_7.isPresent(this.calculationDetails.entries) && this.calculationDetails.entries.length > 0) {
                        this.foreignCurrencyExistsInDetails = this.calculationDetails.entries.filter(function (entry) {
                            return entry.currency.shortName !== 'CHF';
                        }).length > 0;
                    }
                };
                SecurityCalculationFormComponent.prototype.canCalculate = function () {
                    return !this.loading && ags_client_7.isPresent(this.calculation) && this.isPurchaseDateValid(this.calculation.purchaseDate) && this.isDispositionDateValid(this.calculation.dispositionDate) && this.isConversionDateValid(this.calculation.conversionDate) && this.form.valid;
                };
                SecurityCalculationFormComponent.prototype.canEditExchangeRate = function (entry) {
                    switch (entry.type) {
                        case enums_1.SecurityCalculationDetailsEntryType.CONVERTIBLE:
                            return true;
                        case enums_1.SecurityCalculationDetailsEntryType.MODIFIED_DIFFERENTIAL_TAXATION_DISPOSITION:
                            return true;
                        case enums_1.SecurityCalculationDetailsEntryType.MODIFIED_DIFFERENTIAL_TAXATION_PURCHASE:
                            return true;
                        case enums_1.SecurityCalculationDetailsEntryType.PURE_DIFFERENTIAL_TAXATION_DISPOSITION:
                            return true;
                        case enums_1.SecurityCalculationDetailsEntryType.PURE_DIFFERENTIAL_TAXATION_PURCHASE:
                            return true;
                        default:
                            return false;
                    }
                };
                SecurityCalculationFormComponent.prototype.isPurchaseDateValid = function (purchaseDate) {
                    if (ags_client_7.isPresent(this.calculation)) {
                        if (!ags_client_7.isDate(purchaseDate)) {
                            return true;
                        } else if (ags_client_7.isPresent(this.calculation.issueDate) && purchaseDate.getTime() < this.calculation.issueDate.getTime()) {
                            return false;
                        } else if (ags_client_7.isPresent(this.calculation.dispositionDate) && purchaseDate.getTime() > this.calculation.dispositionDate.getTime()) {
                            return false;
                        } else if (ags_client_7.isPresent(this.calculation.conversionDate) && purchaseDate.getTime() > this.calculation.conversionDate.getTime()) {
                            return false;
                        }
                    }
                    return true;
                };
                SecurityCalculationFormComponent.prototype.isDispositionDateValid = function (dispositionDate) {
                    if (ags_client_7.isPresent(this.calculation)) {
                        if (!ags_client_7.isDate(dispositionDate)) {
                            return true;
                        } else if (ags_client_7.isPresent(this.calculation.issueDate) && dispositionDate.getTime() < this.calculation.issueDate.getTime()) {
                            return false;
                        } else if (ags_client_7.isPresent(this.calculation.purchaseDate) && dispositionDate.getTime() < this.calculation.purchaseDate.getTime()) {
                            return false;
                        }
                    }
                    return true;
                };
                SecurityCalculationFormComponent.prototype.isConversionDateValid = function (conversionDate) {
                    if (ags_client_7.isPresent(this.calculation)) {
                        if (!ags_client_7.isDate(conversionDate)) return true;
                        if (ags_client_7.isPresent(this.calculation.issueDate) && conversionDate.getTime() < this.calculation.issueDate.getTime()) return false;
                        if (ags_client_7.isPresent(this.calculation.purchaseDate) && conversionDate.getTime() < this.calculation.purchaseDate.getTime()) return false;
                    }
                    return true;
                };
                SecurityCalculationFormComponent.prototype.minPurchaseDate = function () {
                    return this.calculation.issueDate;
                };
                SecurityCalculationFormComponent.prototype.maxPurchaseDate = function () {
                    return this.calculation.conversion ? this.calculation.conversionDate : this.calculation.dispositionDate;
                };
                SecurityCalculationFormComponent.prototype.minDispositionDate = function () {
                    return this.calculation.purchaseDate;
                };
                SecurityCalculationFormComponent.prototype.maxDispositionDate = function () {
                    return null;
                };
                SecurityCalculationFormComponent.prototype.minConversionDate = function () {
                    return this.calculation.purchaseDate;
                };
                SecurityCalculationFormComponent.prototype.maxConversionDate = function () {
                    return null;
                };
                SecurityCalculationFormComponent.prototype.isConvertible = function (entry) {
                    return entry.type === enums_1.SecurityCalculationDetailsEntryType.CONVERTIBLE;
                };
                SecurityCalculationFormComponent.prototype.isOriginalDiscont = function (entry) {
                    return entry.type === enums_1.SecurityCalculationDetailsEntryType.ORIGINAL_DISCONT;
                };
                SecurityCalculationFormComponent.prototype.isPayment = function (entry) {
                    return entry.type === enums_1.SecurityCalculationDetailsEntryType.PAYMENT;
                };
                SecurityCalculationFormComponent.prototype.isTaxValue = function (entry) {
                    return entry.type === enums_1.SecurityCalculationDetailsEntryType.TAX_VALUE;
                };
                SecurityCalculationFormComponent.prototype.isModifiedDifferentialTaxationDisposition = function (entry) {
                    return entry.type === enums_1.SecurityCalculationDetailsEntryType.MODIFIED_DIFFERENTIAL_TAXATION_DISPOSITION;
                };
                SecurityCalculationFormComponent.prototype.isModifiedDifferentialTaxationPurchase = function (entry) {
                    return entry.type === enums_1.SecurityCalculationDetailsEntryType.MODIFIED_DIFFERENTIAL_TAXATION_PURCHASE;
                };
                SecurityCalculationFormComponent.prototype.isIssue = function (entry) {
                    return entry.type === enums_1.SecurityCalculationDetailsEntryType.ISSUE;
                };
                SecurityCalculationFormComponent.prototype.isAccruedInterest = function (entry) {
                    return entry.type === enums_1.SecurityCalculationDetailsEntryType.ACCRUED_INTEREST;
                };
                SecurityCalculationFormComponent.prototype.isPureDifferentialTaxationDisposition = function (entry) {
                    return entry.type === enums_1.SecurityCalculationDetailsEntryType.PURE_DIFFERENTIAL_TAXATION_DISPOSITION;
                };
                SecurityCalculationFormComponent.prototype.isPureDifferentialTaxationPurchase = function (entry) {
                    return entry.type === enums_1.SecurityCalculationDetailsEntryType.PURE_DIFFERENTIAL_TAXATION_PURCHASE;
                };
                SecurityCalculationFormComponent.prototype.isWithholdingTax = function (entry) {
                    return entry.withHoldingTax;
                };
                SecurityCalculationFormComponent.prototype.calculateLater = function () {
                    var _this = this;
                    if (this.calculationTimer) {
                        this.calculationTimer.cancel();
                    }
                    if (this.canCalculate()) {
                        this.calculationTimer = ags_client_2.Timer.later(2000, function () {
                            return _this.calculate();
                        });
                    }
                };
                SecurityCalculationFormComponent.prototype.resetAndCalculateLater = function () {
                    this.resetDetails();
                    this._resetExchangeRates();
                    this._resetRates();
                    this.calculateLater();
                };
                SecurityCalculationFormComponent.prototype._resetExchangeRates = function () {
                    if (this.canCalculate()) {
                        this.calculation.conversionExchangeRate = null;
                        this.calculation.purchaseExchangeRate = null;
                        this.calculation.dispositionExchangeRate = null;
                    }
                };
                SecurityCalculationFormComponent.prototype._resetRates = function () {
                    if (this.canCalculate()) {
                        this.calculation.purchaseRateTotal = null;
                        this.calculation.purchaseRateTotalChf = null;
                        this.calculation.dispositionRateTotal = null;
                        this.calculation.dispositionRateTotalChf = null;
                    }
                };
                SecurityCalculationFormComponent.prototype.canDisplayDispositionDate = function () {
                    return ags_client_7.isPresent(this.calculation.dispositionDate) || this.calculation.instrumentGroup === ags_client_8.InstrumentGroup.SHARE || this.calculation.instrumentGroup === ags_client_8.InstrumentGroup.FUND || this.calculation.instrumentGroup === ags_client_8.InstrumentGroup.DEVT || this.calculation.instrumentGroup === ags_client_8.InstrumentGroup.BOND && !this.calculation.conversion || this.calculation.instrumentGroup === ags_client_8.InstrumentGroup.COINBULL || this.calculation.instrumentGroup === ags_client_8.InstrumentGroup.CURRNOTE;
                };
                SecurityCalculationFormComponent.prototype.resetDetails = function () {
                    var _this = this;
                    if (this.canCalculate()) {
                        this.calculationDetails.entries.forEach(function (entry) {
                            entry.nominalQuantity = _this.calculation.quantity;
                        });
                    }
                };
                SecurityCalculationFormComponent.prototype.canEditNominalQuantity = function (entry) {
                    return !(this.isConvertible(entry) || this.isOriginalDiscont(entry) || this.isIssue(entry) || this.isPureDifferentialTaxationDisposition(entry) || this.isPureDifferentialTaxationPurchase(entry) || this.isModifiedDifferentialTaxationDisposition(entry) || this.isModifiedDifferentialTaxationPurchase(entry));
                };
                SecurityCalculationFormComponent.prototype.hasMultiColumnDate = function () {
                    return this.calculation.instrumentGroup !== ags_client_8.InstrumentGroup.BOND && this.calculation.instrumentGroup !== ags_client_8.InstrumentGroup.DEVT && this.calculation.instrumentGroup !== ags_client_8.InstrumentGroup.CURRNOTE;
                };
                SecurityCalculationFormComponent.prototype.hasVariantColumn = function () {
                    return this.calculation.instrumentGroup === ags_client_8.InstrumentGroup.SHARE && this.calculationDetails.entries.some(function (e) {
                        return e.variant;
                    });
                };
                __decorate([core_1.Input(), __metadata("design:type", String)], SecurityCalculationFormComponent.prototype, "id", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Number)], SecurityCalculationFormComponent.prototype, "SecurityCalculationId", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Boolean)], SecurityCalculationFormComponent.prototype, "isCantonBL", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Boolean)], SecurityCalculationFormComponent.prototype, "loadOnInit", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], SecurityCalculationFormComponent.prototype, "canceled", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], SecurityCalculationFormComponent.prototype, "submitted", void 0);
                __decorate([core_1.Input(), __metadata("design:type", String)], SecurityCalculationFormComponent.prototype, "isin", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Number)], SecurityCalculationFormComponent.prototype, "valorNumber", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Date)], SecurityCalculationFormComponent.prototype, "referenceDate", void 0);
                SecurityCalculationFormComponent = __decorate([core_1.Component({
                    directives: [ags_client_1.AGS_FORM_DIRECTIVES, security_component_1.SecurityComponent],
                    pipes: [ags_client_1.AGS_PIPES],
                    selector: 'security-calculation-form',
                    templateUrl: 'ict-external-client/app/components/security_calculation_form_component.html'
                }), __metadata("design:paramtypes", [ags_client_6.AlertService, ags_client_3.TranslationService, security_service_1.SecurityService, core_1.ElementRef])], SecurityCalculationFormComponent);
                return SecurityCalculationFormComponent;
            }(ags_client_5.AbstractFormComponent);
            exports_1("SecurityCalculationFormComponent", SecurityCalculationFormComponent);
        }
    };
});

System.register("ict-external-client/app/views/security_id_date_view.js", ["angular2/core.js", "angular2/router.js", "ags-client/ags-client.js", "ict-external-client/app/components/security_component.js", "ict-external-client/app/components/security_calculation_form_component.js", "ict-external-client/gen/views.js", "ict-external-client/gen/i18n/translation_constants.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, router_1, ags_client_1, ags_client_2, ags_client_3, security_component_1, security_calculation_form_component_1, views_1, ags_client_4, translation_constants_1, SecurityIdDateView;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (router_1_1) {
            router_1 = router_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
        }, function (security_component_1_1) {
            security_component_1 = security_component_1_1;
        }, function (security_calculation_form_component_1_1) {
            security_calculation_form_component_1 = security_calculation_form_component_1_1;
        }, function (views_1_1) {
            views_1 = views_1_1;
        }, function (translation_constants_1_1) {
            translation_constants_1 = translation_constants_1_1;
        }],
        execute: function () {
            SecurityIdDateView = /** @class */function (_super) {
                __extends(SecurityIdDateView, _super);
                function SecurityIdDateView(translationService, alertService, navigationService, router, routeParams) {
                    var _this = _super.call(this, navigationService, router) || this;
                    _this.translationService = translationService;
                    _this.alertService = alertService;
                    _this.showCantonBL = false;
                    _this.isCantonBL = false;
                    var id = routeParams.get('id');
                    if (ags_client_4.isSomething(id) && id != '') {
                        if (id.length === 12 && ags_client_4.isValidIsin(id)) {
                            _this.isin = id;
                        } else {
                            _this.valorNumber = parseInt(id);
                        }
                    } else {
                        _this.alertService.warning(_this.translationService.translate(translation_constants_1.TranslationConstants.ERROR_UNKNOWN));
                    }
                    _this.referenceDate = ags_client_3.parseDate(routeParams.get('date'));
                    return _this;
                }
                SecurityIdDateView.prototype.beforeInit = function () {
                    this.hideNavigation();
                };
                SecurityIdDateView.prototype.goBack = function () {
                    this.router.navigate([views_1.SEARCH_VIEW]);
                };
                SecurityIdDateView.prototype.loadInstrument = function (loaded) {
                    var _this = this;
                    this.security.toArray().forEach(function (child) {
                        child.isCantonBL = _this.isCantonBL;
                        child.loadData();
                    });
                };
                SecurityIdDateView.prototype.loadCalculation = function (loaded) {
                    var _this = this;
                    this.securityCalculationForm.toArray().forEach(function (child) {
                        child.isCantonBL = _this.isCantonBL;
                        child.loadData();
                    });
                };
                SecurityIdDateView.prototype.setShowCantonBL = function (flag) {
                    // #1767
                    if (this.referenceDate.getMonth() === 11 && this.referenceDate.getDate() === 31) {
                        this.showCantonBL = flag;
                    }
                };
                SecurityIdDateView.prototype.click = function () {
                    this.isCantonBL = !this.isCantonBL;
                    this.loadInstrument(this.isCantonBL);
                    this.loadCalculation(this.isCantonBL);
                };
                __decorate([core_1.ViewChildren(security_component_1.SecurityComponent), __metadata("design:type", core_1.QueryList)], SecurityIdDateView.prototype, "security", void 0);
                __decorate([core_1.ViewChildren(security_calculation_form_component_1.SecurityCalculationFormComponent), __metadata("design:type", core_1.QueryList)], SecurityIdDateView.prototype, "securityCalculationForm", void 0);
                SecurityIdDateView = __decorate([core_1.Component({
                    selector: 'security-id-date-view',
                    directives: [ags_client_1.AGS_DIRECTIVES, security_calculation_form_component_1.SecurityCalculationFormComponent, security_component_1.SecurityComponent],
                    pipes: [ags_client_1.AGS_PIPES],
                    templateUrl: 'ict-external-client/app/views/security_id_date_view.html'
                }), router_1.CanActivate(function () {
                    return ags_client_1.AuthenticationService.checkViewSecurity(views_1.VIEW_SECURITY[views_1.SECURITY_ID_DATE_VIEW]);
                }), __metadata("design:paramtypes", [ags_client_2.TranslationService, ags_client_2.AlertService, ags_client_2.NavigationService, router_1.Router, router_1.RouteParams])], SecurityIdDateView);
                return SecurityIdDateView;
            }(ags_client_3.AbstractView);
            exports_1("SecurityIdDateView", SecurityIdDateView);
        }
    };
});

System.register("ict-external-client/gen/viewsearch/export_search_criteria.js", ["ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var ags_client_1, ags_client_2, ags_client_3, ExportSearchCriteria;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
        }],
        execute: function () {
            ExportSearchCriteria = /** @class */function (_super) {
                __extends(ExportSearchCriteria, _super);
                function ExportSearchCriteria(from, size) {
                    return _super.call(this, from, size) || this;
                }
                ExportSearchCriteria.create = function (from, size) {
                    return new ExportSearchCriteria(from, size);
                };
                Object.defineProperty(ExportSearchCriteria.prototype, "year", {
                    get: function () {
                        return this._year;
                    },
                    set: function (year) {
                        if (this._year !== year) {
                            this._year = year;
                            this.attributeChanged(ExportSearchCriteria.YEAR, year);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ExportSearchCriteria.prototype, "domain", {
                    get: function () {
                        return this._domain;
                    },
                    set: function (domain) {
                        if (this._domain !== domain) {
                            this._domain = domain;
                            this.attributeChanged(ExportSearchCriteria.DOMAIN, domain);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ExportSearchCriteria.prototype, "referingToDate", {
                    get: function () {
                        return this._referingToDate;
                    },
                    set: function (referingToDate) {
                        if (this._referingToDate !== referingToDate) {
                            this._referingToDate = referingToDate;
                            this.attributeChanged(ExportSearchCriteria.REFERING_TO_DATE, referingToDate);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ExportSearchCriteria.prototype, "xsdType", {
                    get: function () {
                        return this._xsdType;
                    },
                    set: function (xsdType) {
                        if (this._xsdType !== xsdType) {
                            this._xsdType = xsdType;
                            this.attributeChanged(ExportSearchCriteria.XSD_TYPE, xsdType);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ExportSearchCriteria.prototype, "exportType", {
                    get: function () {
                        return this._exportType;
                    },
                    set: function (exportType) {
                        if (this._exportType !== exportType) {
                            this._exportType = exportType;
                            this.attributeChanged(ExportSearchCriteria.EXPORT_TYPE, exportType);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                ExportSearchCriteria.prototype.reset = function () {
                    _super.prototype.reset.call(this);
                    this._year = null;
                    this._domain = null;
                    this._referingToDate = null;
                    this._xsdType = null;
                    this._exportType = null;
                };
                ExportSearchCriteria.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (ags_client_2.isPresent(this.year)) {
                        object['year'] = this.year;
                    }
                    if (ags_client_2.isPresent(this.domain)) {
                        object['domain'] = this.domain.serialize();
                    }
                    if (ags_client_2.isPresent(this.referingToDate)) {
                        object['referingToDate'] = ags_client_3.serializeDate(this.referingToDate);
                    }
                    if (ags_client_2.isPresent(this.xsdType)) {
                        object['xsdType'] = this.xsdType;
                    }
                    if (ags_client_2.isPresent(this.exportType)) {
                        object['exportType'] = this.exportType;
                    }
                    return object;
                };
                ExportSearchCriteria.YEAR = 'year';
                ExportSearchCriteria.DOMAIN = 'domain';
                ExportSearchCriteria.REFERING_TO_DATE = 'referingToDate';
                ExportSearchCriteria.XSD_TYPE = 'xsdType';
                ExportSearchCriteria.EXPORT_TYPE = 'exportType';
                return ExportSearchCriteria;
            }(ags_client_1.SearchCriteria);
            exports_1("ExportSearchCriteria", ExportSearchCriteria);
        }
    };
});

System.register("ict-external-client/gen/viewmodels/export_view_model.js", ["ags-client/ags-client.js", "ict-core-client/ict-core-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var ags_client_1, ags_client_2, Validators, ags_client_3, ags_client_4, ags_client_5, ict_core_client_1, ExportViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            Validators = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
            ags_client_5 = ags_client_1_1;
        }, function (ict_core_client_1_1) {
            ict_core_client_1 = ict_core_client_1_1;
        }],
        execute: function () {
            ExportViewModel = /** @class */function (_super) {
                __extends(ExportViewModel, _super);
                function ExportViewModel() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                ExportViewModel.deserialize = function (object) {
                    var _result = new ExportViewModel();
                    return _result._deserialize(object);
                };
                ExportViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        _super.prototype._deserialize.call(this, object);
                        if (ags_client_1.isPresent(object['exportDate'])) {
                            this.exportDate = ags_client_4.deserializeDate(object['exportDate']);
                        }
                        if (ags_client_1.isPresent(object['exportFile'])) {
                            this.exportFile = ags_client_5.FileViewModel.deserialize(object['exportFile']);
                        }
                        if (ags_client_1.isPresent(object['exportType'])) {
                            this.exportType = new ict_core_client_1.ExportType(object['exportType']['shortName']);
                        }
                        if (ags_client_1.isPresent(object['referingToDate'])) {
                            this.referingToDate = ags_client_4.deserializeDate(object['referingToDate']);
                        }
                    }
                    return this;
                };
                ExportViewModel.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (ags_client_1.isPresent(this.exportDate)) {
                        object['exportDate'] = ags_client_3.serializeDate(this.exportDate);
                    }
                    if (ags_client_1.isPresent(this.exportFile)) {
                        object['exportFile'] = this.exportFile.serialize();
                    }
                    if (ags_client_1.isPresent(this.exportType)) {
                        object['exportType'] = this.exportType;
                    }
                    if (ags_client_1.isPresent(this.referingToDate)) {
                        object['referingToDate'] = ags_client_3.serializeDate(this.referingToDate);
                    }
                    return object;
                };
                ExportViewModel.EXPORT_DATE_VALIDATORS = [Validators.date, Validators.dateTime()];
                ExportViewModel.EXPORT_FILE_VALIDATORS = [];
                ExportViewModel.EXPORT_TYPE_VALIDATORS = [];
                ExportViewModel.REFERING_TO_DATE_VALIDATORS = [Validators.date, Validators.dateTime()];
                return ExportViewModel;
            }(ags_client_2.EntityViewModel);
            exports_1("ExportViewModel", ExportViewModel);
        }
    };
});

System.register("ict-external-client/gen/services/abstract_xml_service.js", ["ags-client/ags-client.js", "ict-external-client/gen/viewmodels/export_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, export_view_model_1, ags_client_2, AbstractXmlService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
        }, function (export_view_model_1_1) {
            export_view_model_1 = export_view_model_1_1;
        }],
        execute: function () {
            AbstractXmlService = /** @class */function () {
                function AbstractXmlService(backendService) {
                    this.backendService = backendService;
                }
                AbstractXmlService.prototype.xmls = function (request) {
                    return this.backendService.postJson('/xml/xmls.json', request.serialize(), function (response) {
                        var data = Array();
                        response.data.forEach(function (item) {
                            data.push(export_view_model_1.ExportViewModel.deserialize(item));
                        });
                        return ags_client_1.JsonResponse.deserialize(response, data);
                    });
                };
                AbstractXmlService.prototype.create = function (request) {
                    return this.backendService.postJson('/xml/create.json', request.serialize(), function (response) {
                        return ags_client_1.JsonResponse.deserialize(response);
                    });
                };
                AbstractXmlService.prototype.running = function () {
                    return this.backendService.getJson('/xml/running.json', function (response) {
                        return ags_client_1.JsonResponse.deserialize(response, response.data);
                    });
                };
                AbstractXmlService.prototype.domains = function () {
                    return this.backendService.getJson('/xml/domains.json', function (response) {
                        var data = Array();
                        response.data.forEach(function (item) {
                            data.push(ags_client_2.DomainViewModel.deserialize(item));
                        });
                        return ags_client_1.JsonResponse.deserialize(response, data);
                    });
                };
                return AbstractXmlService;
            }();
            exports_1("AbstractXmlService", AbstractXmlService);
        }
    };
});

System.register("ict-external-client/app/services/xml_service.js", ["angular2/core.js", "ict-external-client/gen/services/abstract_xml_service.js", "ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, abstract_xml_service_1, ags_client_1, XmlService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (abstract_xml_service_1_1) {
            abstract_xml_service_1 = abstract_xml_service_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }],
        execute: function () {
            XmlService = /** @class */function (_super) {
                __extends(XmlService, _super);
                function XmlService(backendService) {
                    return _super.call(this, backendService) || this;
                }
                XmlService = __decorate([core_1.Injectable(), core_1.Inject(ags_client_1.BackendService), __metadata("design:paramtypes", [ags_client_1.BackendService])], XmlService);
                return XmlService;
            }(abstract_xml_service_1.AbstractXmlService);
            exports_1("XmlService", XmlService);
        }
    };
});

System.register("ict-external-client/gen/permissions.js", [], function (exports_1, context_1) {
    "use strict";

    var ACCOUNT_VIEW, DEBUG_ADMIN, EARNING_DECLARE_EDIT, EARNING_DECLARE_SEARCH, REPORT_VIEW, REQUEST_EDIT, REQUEST_SEARCH, XML_NEW;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [],
        execute: function () {
            /**
             * generated by AGS
             */
            exports_1("ACCOUNT_VIEW", ACCOUNT_VIEW = 'PERM_ACCOUNT_VIEW');
            exports_1("DEBUG_ADMIN", DEBUG_ADMIN = 'PERM_DEBUG_ADMIN');
            exports_1("EARNING_DECLARE_EDIT", EARNING_DECLARE_EDIT = 'PERM_EARNING_DECLARE_EDIT');
            exports_1("EARNING_DECLARE_SEARCH", EARNING_DECLARE_SEARCH = 'PERM_EARNING_DECLARE_SEARCH');
            exports_1("REPORT_VIEW", REPORT_VIEW = 'PERM_REPORT_VIEW');
            exports_1("REQUEST_EDIT", REQUEST_EDIT = 'PERM_REQUEST_EDIT');
            exports_1("REQUEST_SEARCH", REQUEST_SEARCH = 'PERM_REQUEST_SEARCH');
            exports_1("XML_NEW", XML_NEW = 'PERM_XML_NEW');
        }
    };
});

/* tslint:disable */
System.register('ict-external-client/gen/i18n/translation_constants.js', [], function (exports_1, context_1) {
    "use strict";

    var TranslationConstants;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [],
        execute: function () {
            /* tslint:disable */
            TranslationConstants = /** @class */function () {
                function TranslationConstants() {}
                TranslationConstants.CALCULATION_ACCRUED_INTERESTS_TITLE = 'calculation:accrued_interests_title';
                TranslationConstants.CALCULATION_CONVERSION = 'calculation:conversion';
                TranslationConstants.CALCULATION_CONVERSION_DATE = 'calculation:conversion_date';
                TranslationConstants.CALCULATION_CONVERSION_TABLE_TITLE = 'calculation:conversion_table_title';
                TranslationConstants.CALCULATION_CURRENCY = 'calculation:currency';
                TranslationConstants.CALCULATION_DATE = 'calculation:date';
                TranslationConstants.CALCULATION_DETAILS_TITLE = 'calculation:details_title';
                TranslationConstants.CALCULATION_DIFFERENT_REDEMPTION_DATE = 'calculation:different_redemption_date';
                TranslationConstants.CALCULATION_DIFFERENT_REDEMPTION_DATE_EARLY = 'calculation:different_redemption_date_early';
                TranslationConstants.CALCULATION_DISPOSITION_DATE = 'calculation:disposition_date';
                TranslationConstants.CALCULATION_EXCHANGE_RATE = 'calculation:exchange_rate';
                TranslationConstants.CALCULATION_INSTITUTION_NAME = 'calculation:institution_name';
                TranslationConstants.CALCULATION_INSTRUMENT_NAME = 'calculation:instrument_name';
                TranslationConstants.CALCULATION_ISSUE_TITLE = 'calculation:issue_title';
                TranslationConstants.CALCULATION_LEGEND = 'calculation:legend';
                TranslationConstants.CALCULATION_NOMINAL_QUANTITY = 'calculation:nominal_quantity';
                TranslationConstants.CALCULATION_ORIGINAL_DISCONT_TITLE = 'calculation:original_discont_title';
                TranslationConstants.CALCULATION_PAYMENT_VALUE_TOTAL_CHF_WITH_HOLDING_TAX = 'calculation:payment_value_total_chf_with_holding_tax';
                TranslationConstants.CALCULATION_PAYMENT_VALUE_TOTAL_CHF_WITHOUT_HOLDING_TAX = 'calculation:payment_value_total_chf_without_holding_tax';
                TranslationConstants.CALCULATION_PERCENT = 'calculation:percent';
                TranslationConstants.CALCULATION_PURCHASE_DATE = 'calculation:purchase_date';
                TranslationConstants.CALCULATION_PURE_DIFFERENTIAL_TAXATION_DISPOSITION_TITLE = 'calculation:pure_differential_taxation_disposition_title';
                TranslationConstants.CALCULATION_PURE_DIFFERENTIAL_TAXATION_PURCHASE_TITLE = 'calculation:pure_differential_taxation_purchase_title';
                TranslationConstants.CALCULATION_TAX_VALUE_CHF_PREFIX = 'calculation:tax_value_chf_prefix';
                TranslationConstants.CALCULATION_TAX_VALUE_CHF_SUFIX = 'calculation:tax_value_chf_sufix';
                TranslationConstants.CALCULATION_TAX_VALUE_CHF_YEAR_SUFIX = 'calculation:tax_value_chf_year_sufix';
                TranslationConstants.CALCULATION_TAX_VALUE_TITLE = 'calculation:tax_value_title';
                TranslationConstants.CALCULATION_TAX_VALUE_TOTAL_CHF_PREFIX = 'calculation:tax_value_total_chf_prefix';
                TranslationConstants.CALCULATION_TAX_VALUE_TOTAL_CHF_SUFIX = 'calculation:tax_value_total_chf_sufix';
                TranslationConstants.CALCULATION_VALORNUMBER = 'calculation:valornumber';
                TranslationConstants.CALCULATION_VALUE = 'calculation:value';
                TranslationConstants.CALCULATION_VALUE_TOTAL = 'calculation:value_total';
                TranslationConstants.CALCULATION_VALUE_CHF = 'calculation:value_chf';
                TranslationConstants.CALCULATION_VALUE_TOTAL_CHF = 'calculation:value_total_chf';
                TranslationConstants.CALCULATION_TAX_VALUE_CHF_YEAR_PREFIX = 'calculation:tax_value_chf_year_prefix';
                TranslationConstants.CALCULATION_PAYMENT_TITLE = 'calculation:payment_title';
                TranslationConstants.CALCULATION_EX_DATE = 'calculation:ex_date';
                TranslationConstants.CALCULATION_PAYMENT_DATE = 'calculation:payment_date';
                TranslationConstants.CALCULATION_MODIFIED_DIFFERENTIAL_TAXATION_DISPOSITION_TITLE = 'calculation:modified_differential_taxation_disposition_title';
                TranslationConstants.CALCULATION_MODIFIED_DIFFERENTIAL_TAXATION_PURCHASE_TITLE = 'calculation:modified_differential_taxation_purchase_title';
                TranslationConstants.NEWSLETTER_TITLE = 'newsletter:title';
                TranslationConstants.IMPORT_IMPORT_DATE = 'import:import_date';
                TranslationConstants.IMPORT_IMPORT_FILE = 'import:import_file';
                TranslationConstants.IMPORT_IMPORT_SOURCE = 'import:import_source';
                TranslationConstants.IMPORT_IMPORT_STATUS = 'import:import_status';
                TranslationConstants.IMPORT_IMPORT_TYPE = 'import:import_type';
                TranslationConstants.IMPORT_LOG_FILE = 'import:log_file';
                TranslationConstants.IMPORT_SELECT_FILE = 'import:select_file';
                TranslationConstants.IMPORT_TITLE = 'import:title';
                TranslationConstants.IMPORT_CREATION_RUNNING = 'import:creation_running';
                TranslationConstants.IMPORT_CREATION_STARTED = 'import:creation_started';
                TranslationConstants.RATELIST_EXCHANGE_RATES = 'ratelist:exchange_rates';
                TranslationConstants.RATELIST_DISCLAIMER = 'ratelist:disclaimer';
                TranslationConstants.RATELIST_SEARCH_TITLE = 'ratelist:search_title';
                TranslationConstants.RATELIST_COIN_BULLIONS = 'ratelist:coin_bullions';
                TranslationConstants.RATELIST_TITLE = 'ratelist:title';
                TranslationConstants.REQUESTS_TITLE = 'requests:title';
                TranslationConstants.XML_TITLE = 'xml:title';
                TranslationConstants.XML_XSD_TYPE = 'xml:xsd_type';
                TranslationConstants.XML_REFERING_TO_DATE = 'xml:refering_to_date';
                TranslationConstants.XML_YEAR = 'xml:year';
                TranslationConstants.XML_DOMAIN = 'xml:domain';
                TranslationConstants.XML_CREATION_RUNNING = 'xml:creation_running';
                TranslationConstants.XML_CREATION_STARTED = 'xml:creation_started';
                TranslationConstants.XML_CREATION_EXISTS = 'xml:creation_exists';
                TranslationConstants.ENCODE_PASSWORD_HASH = 'encode_password:hash';
                TranslationConstants.ENCODE_PASSWORD_MD5_HASH = 'encode_password:md5_hash';
                TranslationConstants.ENCODE_PASSWORD_PASSWORD = 'encode_password:password';
                TranslationConstants.ENCODE_PASSWORD_TITLE = 'encode_password:title';
                TranslationConstants.REQUEST_DUMP_LOGS_TITLE = 'request_dump_logs:title';
                TranslationConstants.MENU_ACCOUNT = 'menu:account';
                TranslationConstants.MENU_LOGOUT = 'menu:logout';
                TranslationConstants.MENU_BFP = 'menu:bfp';
                TranslationConstants.MENU_EARNING = 'menu:earning';
                TranslationConstants.MENU_EARNINGS = 'menu:earnings';
                TranslationConstants.MENU_EXPORT = 'menu:export';
                TranslationConstants.MENU_HELP = 'menu:help';
                TranslationConstants.MENU_NEWSLETTER = 'menu:newsletter';
                TranslationConstants.MENU_REQUEST = 'menu:request';
                TranslationConstants.MENU_REQUESTS = 'menu:requests';
                TranslationConstants.MENU_SEARCH = 'menu:search';
                TranslationConstants.MENU_XML = 'menu:xml';
                TranslationConstants.MENU_RATELIST = 'menu:ratelist';
                TranslationConstants.MENU_RATELIST_YEAR = 'menu:ratelist_year';
                TranslationConstants.MENU_REPORT = 'menu:report';
                TranslationConstants.MENU_IMPORT = 'menu:import';
                TranslationConstants.MENU_EWS_REQUEST_DUMP = 'menu:ews_request_dump';
                TranslationConstants.EARNINGS_TITLE = 'earnings:title';
                TranslationConstants.REPORT_YEAR = 'report:year';
                TranslationConstants.REPORT_REFERING_TO_DATE = 'report:refering_to_date';
                TranslationConstants.REPORT_EXPORT_TYPE = 'report:export_type';
                TranslationConstants.REPORT_DOMAIN = 'report:domain';
                TranslationConstants.REPORT_TITLE = 'report:title';
                TranslationConstants.REPORT_CREATION_EXISTS = 'report:creation_exists';
                TranslationConstants.REPORT_CREATION_RUNNING = 'report:creation_running';
                TranslationConstants.REPORT_CREATION_STARTED = 'report:creation_started';
                TranslationConstants.SECURITY_SEARCH_TITLE = 'security_search:title';
                TranslationConstants.SECURITY_SEARCH_VALUE_BL = 'security_search:value_bl';
                TranslationConstants.REQUEST_DUMP_LOG_REQUEST_TIME = 'request_dump_log:request_time';
                TranslationConstants.REQUEST_DUMP_LOG_LOGIN = 'request_dump_log:login';
                TranslationConstants.REQUEST_DUMP_LOG_REQUESTED_URL = 'request_dump_log:requested_url';
                TranslationConstants.REQUEST_DUMP_LOG_REMOTE_IP = 'request_dump_log:remote_ip';
                TranslationConstants.REQUEST_DUMP_LOG_LOG_LEVEL = 'request_dump_log:log_level';
                TranslationConstants.REQUEST_DUMP_LOG_STATUS_CODE = 'request_dump_log:status_code';
                TranslationConstants.REQUEST_DUMP_LOG_VERSION = 'request_dump_log:version';
                TranslationConstants.REQUEST_DUMP_LOG_TITLE = 'request_dump_log:title';
                TranslationConstants.REQUEST_DUMP_LOG_HEADER = 'request_dump_log:header';
                TranslationConstants.REQUEST_DUMP_LOG_ERRORS = 'request_dump_log:errors';
                TranslationConstants.REQUEST_DUMP_LOG_REQUEST = 'request_dump_log:request';
                TranslationConstants.REQUEST_DUMP_LOG_RESPONSE = 'request_dump_log:response';
                TranslationConstants.REQUEST_YEAR = 'request:year';
                TranslationConstants.REQUEST_ENTRY_DATE = 'request:entry_date';
                TranslationConstants.REQUEST_VALOR_NUMBER = 'request:valor_number';
                TranslationConstants.REQUEST_ISIN = 'request:isin';
                TranslationConstants.REQUEST_DOSSIER_NUMBER = 'request:dossier_number';
                TranslationConstants.REQUEST_REQUEST_REASON = 'request:request_reason';
                TranslationConstants.REQUEST_EMAIL = 'request:email';
                TranslationConstants.REQUEST_REQUEST_STATUS = 'request:request_status';
                TranslationConstants.REQUEST_INSTITUTION_INSTRUMENT_NAME = 'request:institution_instrument_name';
                TranslationConstants.REQUEST_REQUEST_USER = 'request:request_user';
                TranslationConstants.REQUEST_LASTNAME = 'request:lastname';
                TranslationConstants.REQUEST_TITLE_CREATE = 'request:title_create';
                TranslationConstants.REQUEST_INSTRUMENT_GROUP = 'request:instrument_group';
                TranslationConstants.REQUEST_MESSAGE = 'request:message';
                TranslationConstants.REQUEST_ATTACH_SUBSEQUENTLY = 'request:attach_subsequently';
                TranslationConstants.REQUEST_EMAIL_RESPONSE_NO_PUBLICATION = 'request:email_response_no_publication';
                TranslationConstants.REQUEST_EMAIL_RESPONSE_DESIRED = 'request:email_response_desired';
                TranslationConstants.REQUEST_REQUIRED_MESSAGE = 'request:required_message';
                TranslationConstants.REQUEST_ID = 'request:id';
                TranslationConstants.REQUEST_TITLE_MESSAGES = 'request:title_messages';
                TranslationConstants.REQUEST_ANNUALREPORTREQUESTED = 'request:annualReportRequested';
                TranslationConstants.REQUEST_TITLE_EDIT = 'request:title_edit';
                TranslationConstants.REQUEST_WITHDRAW = 'request:withdraw';
                TranslationConstants.REQUEST_WITHDRAW_CONFIRMATION = 'request:withdraw_confirmation';
                TranslationConstants.MAIL_ACCOUNT_ALREADY_REGISTERED = 'mail:account_already_registered';
                TranslationConstants.MAIL_ACCOUNT_CONFIRMATION = 'mail:account_confirmation';
                TranslationConstants.MAIL_NEW_PASSWORD = 'mail:new_password';
                TranslationConstants.MAIL_PASSWORD_REQUEST = 'mail:password_request';
                TranslationConstants.MAIL_STATUS_CHANGED_SUBJECT = 'mail:status_changed_subject';
                TranslationConstants.MAIL_REQUEST_CREATED_SUBJECT = 'mail:request_created_subject';
                TranslationConstants.MAIL_REQUEST_MESSAGE_ADDED = 'mail:request_message_added';
                TranslationConstants.MAIL_KURSLISTE_GENERATION = 'mail:kursliste_generation';
                TranslationConstants.INSTRUMENT_REQUEST_EXISTS_MESSAGE = 'instrument:request_exists_message';
                TranslationConstants.INSTRUMENT_LEGEND_BFP = 'instrument:legend_bfp';
                TranslationConstants.INSTRUMENT_LEGEND_RDB = 'instrument:legend_rdb';
                TranslationConstants.SECURITY_YEAR = 'security:year';
                TranslationConstants.SECURITY_INSTRUMENT_TYPE = 'security:instrument_type';
                TranslationConstants.SECURITY_INSTRUMENT_GROUP = 'security:instrument_group';
                TranslationConstants.SECURITY_COUNTRY = 'security:country';
                TranslationConstants.SECURITY_CURRENCY = 'security:currency';
                TranslationConstants.SECURITY_IUP = 'security:iup';
                TranslationConstants.SECURITY_BFP = 'security:bfp';
                TranslationConstants.SECURITY_INTEREST_RATE = 'security:interest_rate';
                TranslationConstants.SECURITY_ISSUE_YEAR = 'security:issue_year';
                TranslationConstants.SECURITY_VARIABLE_INTEREST_RATE = 'security:variable_interest_rate';
                TranslationConstants.SECURITY_REDEMPTION_YEAR = 'security:redemption_year';
                TranslationConstants.SECURITY_INSTITUTION = 'security:institution';
                TranslationConstants.SECURITY_INSTRUMENT = 'security:instrument';
                TranslationConstants.SECURITY_VALOR_NUMBER = 'security:valor_number';
                TranslationConstants.SECURITY_NSIN = 'security:nsin';
                TranslationConstants.SECURITY_ISIN = 'security:isin';
                TranslationConstants.SECURITY_NAME = 'security:name';
                TranslationConstants.EARNING_DECLARE_ENTRY_DATE = 'earning_declare:entry_date';
                TranslationConstants.EARNING_DECLARE_DECLARE_USER = 'earning_declare:declare_user';
                TranslationConstants.EARNING_DECLARE_EMAIL = 'earning_declare:email';
                TranslationConstants.EARNING_DECLARE_ID = 'earning_declare:id';
                TranslationConstants.EARNING_DECLARE_YEAR = 'earning_declare:year';
                TranslationConstants.EARNING_DECLARE_STATUS = 'earning_declare:status';
                TranslationConstants.EARNING_DECLARE_TITLE_CREATE = 'earning_declare:title_create';
                TranslationConstants.EARNING_DECLARE_LASTNAME = 'earning_declare:lastname';
                TranslationConstants.EARNING_DECLARE_INSTRUMENT_GROUP = 'earning_declare:instrument_group';
                TranslationConstants.EARNING_DECLARE_MESSAGE = 'earning_declare:message';
                TranslationConstants.EARNING_DECLARE_EMAIL_RESPONSE_DESIRED = 'earning_declare:email_response_desired';
                TranslationConstants.EARNING_DECLARE_ATTACH_SUBSEQUENTLY = 'earning_declare:attach_subsequently';
                TranslationConstants.EARNING_DECLARE_TITLE_EDIT = 'earning_declare:title_edit';
                TranslationConstants.EARNING_DECLARE_TITLE_MESSAGES = 'earning_declare:title_messages';
                TranslationConstants.EARNING_DECLARE_DECLARATION = 'earning_declare:declaration';
                TranslationConstants.EARNING_DECLARE_TAXABLE_EARNINGS = 'earning_declare:taxable_earnings';
                TranslationConstants.EARNING_INSTITUTION = 'earning:institution';
                TranslationConstants.EARNING_BALANCE_SHEET_DATE = 'earning:balance_sheet_date';
                TranslationConstants.EARNING_YEAR = 'earning:year';
                TranslationConstants.EARNING_STATUS = 'earning:status';
                TranslationConstants.EARNING_REMARKS = 'earning:remarks';
                TranslationConstants.PRINT_BOND_CONVERTABLE_SUBTITLE = 'print:bond_convertable_subtitle';
                TranslationConstants.PRINT_BOND_OPTION_SUBTITLE = 'print:bond_option_subtitle';
                TranslationConstants.PRINT_BOND_TITLE_CH = 'print:bond_title_ch';
                TranslationConstants.PRINT_BOND_TITLE_FC = 'print:bond_title_fc';
                TranslationConstants.PRINT_DERIVATIVE_COMBINEDPRODUCT_SUBTITLE_CH = 'print:derivative_combinedproduct_subtitle_ch';
                TranslationConstants.PRINT_DERIVATIVE_COMBINEDPRODUCT_SUBTITLE_FC = 'print:derivative_combinedproduct_subtitle_fc';
                TranslationConstants.PRINT_DERIVATIVE_FUNDSIMILARASSET_SUBTITLE_CH = 'print:derivative_fundsimilarasset_subtitle_ch';
                TranslationConstants.PRINT_DERIVATIVE_FUNDSIMILARASSET_SUBTITLE_FC = 'print:derivative_fundsimilarasset_subtitle_fc';
                TranslationConstants.PRINT_DERIVATIVE_INDEXBASKET_SUBTITLE_CH = 'print:derivative_indexbasket_subtitle_ch';
                TranslationConstants.PRINT_DERIVATIVE_INDEXBASKET_SUBTITLE_FC = 'print:derivative_indexbasket_subtitle_fc';
                TranslationConstants.PRINT_DERIVATIVE_TITLE = 'print:derivative_title';
                TranslationConstants.PRINT_FOREIGN = 'print:foreign';
                TranslationConstants.PRINT_FUND_TITLE_CH = 'print:fund_title_ch';
                TranslationConstants.PRINT_FUND_TITLE_FC = 'print:fund_title_fc';
                TranslationConstants.PRINT_SHARE_TITLE_CH = 'print:share_title_ch';
                TranslationConstants.PRINT_SHARE_TITLE_FC = 'print:share_title_fc';
                TranslationConstants.PRINT_SUISSE = 'print:suisse';
                TranslationConstants.EARNING_SECURITY_VALOR_NUMBER = 'earning_security:valor_number';
                TranslationConstants.EARNING_SECURITY_ISIN = 'earning_security:isin';
                TranslationConstants.EARNING_SECURITY_APPENDIX = 'earning_security:appendix';
                TranslationConstants.EARNING_SECURITY_SECURITY_TYPE = 'earning_security:security_type';
                TranslationConstants.EARNING_SECURITY_CURRENCY = 'earning_security:currency';
                TranslationConstants.EARNING_SECURITY_VALUE = 'earning_security:value';
                TranslationConstants.EARNING_SECURITY_EXCHANGE_RATE = 'earning_security:exchange_rate';
                TranslationConstants.EARNING_SECURITY_REMARKS = 'earning_security:remarks';
                TranslationConstants.EARNING_SECURITY_VALUE_CHF = 'earning_security:value_chf';
                TranslationConstants.GADGETS_REFERENCE_DATE = 'gadgets:reference_date';
                TranslationConstants.GADGETS_CURRENCY = 'gadgets:currency';
                TranslationConstants.GADGETS_EXCHANGE_RATE = 'gadgets:exchange_rate';
                TranslationConstants.GADGETS_COIN_BULLIONS = 'gadgets:coin_bullions';
                TranslationConstants.GADGETS_EXCHANGE_RATES = 'gadgets:exchange_rates';
                TranslationConstants.GADGETS_CAPITALIZATION_RATES = 'gadgets:capitalization_rates';
                TranslationConstants.GADGETS_INSTRUMENT_GROUP = 'gadgets:instrument_group';
                TranslationConstants.GADGETS_INSTRUMENT = 'gadgets:instrument';
                TranslationConstants.GADGETS_CALCULATOR = 'gadgets:calculator';
                TranslationConstants.GADGETS_INTEREST_RATE = 'gadgets:interest_rate';
                TranslationConstants.GADGETS_VALUE = 'gadgets:value';
                TranslationConstants.GADGETS_VALUE_IN_CHF = 'gadgets:value_in_chf';
                TranslationConstants.GADGETS_RECHERCHE = 'gadgets:recherche';
                TranslationConstants.GADGETS_START_DATE = 'gadgets:start_date';
                TranslationConstants.GADGETS_END_DATE = 'gadgets:end_date';
                TranslationConstants.GADGETS_DAY_COUNT_CONVENTION = 'gadgets:day_count_convention';
                TranslationConstants.GADGETS_DAY_COUNT = 'gadgets:day_count';
                TranslationConstants.GADGETS_LIBORSWAP = 'gadgets:liborswap';
                TranslationConstants.GADGETS_NOMINAL_VALUE = 'gadgets:nominal_value';
                TranslationConstants.GADGETS_PERIOD = 'gadgets:period';
                TranslationConstants.GADGETS_TOKEN = 'gadgets:token';
                TranslationConstants.GADGETS_TOKENS = 'gadgets:tokens';
                TranslationConstants.GADGETS_TOTAL_WORK_ORDER_COUNT = 'gadgets:total_work_order_count';
                TranslationConstants.GADGETS_WORK_ORDER_TYPE = 'gadgets:work_order_type';
                TranslationConstants.GADGETS_WORKORDERGADGET = 'gadgets:workordergadget';
                TranslationConstants.CODE_CODE_EXISTS = 'code:code_exists';
                TranslationConstants.ATTACHMENTS_MESSAGE = 'attachments:message';
                TranslationConstants.LOST_PASSWORD_TITLE = 'lost_password:title';
                TranslationConstants.LOST_PASSWORD_EMAIL = 'lost_password:email';
                TranslationConstants.LOST_PASSWORD_DESCRIPTION = 'lost_password:description';
                TranslationConstants.LOST_PASSWORD_CAPTCHA = 'lost_password:captcha';
                TranslationConstants.LOST_PASSWORD_SUCCESS_MESSAGE = 'lost_password:success_message';
                TranslationConstants.CONFIRMATION_DELETE_MESSAGE = 'confirmation:delete_message';
                TranslationConstants.CONFIRMATION_CANCEL_MESSAGE = 'confirmation:cancel_message';
                TranslationConstants.ERROR_FORBIDDEN = 'error:forbidden';
                TranslationConstants.ERROR_NOTFOUND = 'error:notfound';
                TranslationConstants.ERROR_INVALID_ACTIVATION_CODE = 'error:invalid_activation_code';
                TranslationConstants.ERROR_UNKNOWN = 'error:unknown';
                TranslationConstants.ERROR_FILE_TOO_LARGE = 'error:file_too_large';
                TranslationConstants.ERROR_MALWARE_FOUND = 'error:malware_found';
                TranslationConstants.ERROR_TOO_MANY_FILES = 'error:too_many_files';
                TranslationConstants.ERROR_UNSUPPORTED_MIMETYPE = 'error:unsupported_mimetype';
                TranslationConstants.LOGIN_DISABLED = 'login:disabled';
                TranslationConstants.LOGIN_ERROR = 'login:error';
                TranslationConstants.LOGIN_EXPIRED = 'login:expired';
                TranslationConstants.LOGIN_REGISTER = 'login:register';
                TranslationConstants.LOGIN_LOST_PASSWORD = 'login:lost_password';
                TranslationConstants.LOGIN_HELP = 'login:help';
                TranslationConstants.COMMONS_VALID_FROM = 'commons:valid_from';
                TranslationConstants.COMMONS_VALID_TO = 'commons:valid_to';
                TranslationConstants.COMMONS_YES = 'commons:yes';
                TranslationConstants.COMMONS_NO = 'commons:no';
                TranslationConstants.COMMONS_BACK = 'commons:back';
                TranslationConstants.COMMONS_DEFINITION = 'commons:definition';
                TranslationConstants.COMMONS_SEARCH = 'commons:search';
                TranslationConstants.COMMONS_EXTENDED_SEARCH = 'commons:extended_search';
                TranslationConstants.COMMONS_REFERENCE_DATE = 'commons:reference_date';
                TranslationConstants.COMMONS_PRINT = 'commons:print';
                TranslationConstants.COMMONS_RESET = 'commons:reset';
                TranslationConstants.COMMONS_REFRESH = 'commons:refresh';
                TranslationConstants.COMMONS_ATTACHMENTS = 'commons:attachments';
                TranslationConstants.COMMONS_ATTACHMENTS_INFO = 'commons:attachments_info';
                TranslationConstants.COMMONS_DELETED = 'commons:deleted';
                TranslationConstants.CHANGE_PASSWORD_OLD_PASSWORD = 'change_password:old_password';
                TranslationConstants.CHANGE_PASSWORD_PASSWORD_REPEAT = 'change_password:password_repeat';
                TranslationConstants.CHANGE_PASSWORD_DESCRIPTION = 'change_password:description';
                TranslationConstants.CHANGE_PASSWORD_NEW_PASSWORD = 'change_password:new_password';
                TranslationConstants.CHANGE_PASSWORD_ERROR_WRONG_PASSWORD = 'change_password:error_wrong_password';
                TranslationConstants.CHANGE_PASSWORD_ERROR_PASSWORD_REUSE = 'change_password:error_password_reuse';
                TranslationConstants.CHANGE_PASSWORD_TITLE = 'change_password:title';
                TranslationConstants.BUTTON_ACCEPT = 'button:accept';
                TranslationConstants.BUTTON_ADD = 'button:add';
                TranslationConstants.BUTTON_ADD_FILE = 'button:add_file';
                TranslationConstants.BUTTON_BACK = 'button:back';
                TranslationConstants.BUTTON_CALC = 'button:calc';
                TranslationConstants.BUTTON_CANCEL = 'button:cancel';
                TranslationConstants.BUTTON_CLOSE = 'button:close';
                TranslationConstants.BUTTON_DELETE = 'button:delete';
                TranslationConstants.BUTTON_DETAILS_OFF = 'button:details_off';
                TranslationConstants.BUTTON_DETAILS_ON = 'button:details_on';
                TranslationConstants.BUTTON_EDIT = 'button:edit';
                TranslationConstants.BUTTON_DISPLAY = 'button:display';
                TranslationConstants.BUTTON_HELP = 'button:help';
                TranslationConstants.BUTTON_LOGOUT = 'button:logout';
                TranslationConstants.BUTTON_NEXT = 'button:next';
                TranslationConstants.BUTTON_PRINT = 'button:print';
                TranslationConstants.BUTTON_SAVE = 'button:save';
                TranslationConstants.BUTTON_SEARCH = 'button:search';
                TranslationConstants.BUTTON_SEND = 'button:send';
                TranslationConstants.BUTTON_STATUS = 'button:status';
                TranslationConstants.BUTTON_LOGIN = 'button:login';
                TranslationConstants.BUTTON_CALCULATE = 'button:calculate';
                TranslationConstants.BUTTON_CREATE = 'button:create';
                TranslationConstants.BUTTON_REQUEST = 'button:request';
                TranslationConstants.BUTTON_GENERATE = 'button:generate';
                TranslationConstants.BUTTON_RESET = 'button:reset';
                TranslationConstants.BUTTON_IMPORT = 'button:import';
                TranslationConstants.FILEUPLOAD_MESSAGE = 'fileupload:message';
                TranslationConstants.SEARCH_NO_RESULT = 'search:no_result';
                TranslationConstants.MULTI_SELECT_UNSELECTED = 'multi_select:unselected';
                TranslationConstants.MULTI_SELECT_SELECTED = 'multi_select:selected';
                TranslationConstants.MULTI_SELECT_UNSELECT_ALL = 'multi_select:unselect_all';
                TranslationConstants.MULTI_SELECT_SELECT_ALL = 'multi_select:select_all';
                TranslationConstants.MULTI_SELECT_ALL = 'multi_select:all';
                TranslationConstants.MULTI_SELECT_NONE = 'multi_select:none';
                TranslationConstants.MULTI_SELECT_CLOSE = 'multi_select:close';
                TranslationConstants.MULTI_SELECT_PLACEHOLDER = 'multi_select:placeholder';
                TranslationConstants.MULTI_SELECT_STORED = 'multi_select:stored';
                TranslationConstants.FILE_SIZE = 'file:size';
                TranslationConstants.FILE_TYPE = 'file:type';
                TranslationConstants.FILE_CREATED = 'file:created';
                TranslationConstants.CAPTCHA_INVALID = 'captcha:invalid';
                TranslationConstants.CAPTCHA_DESCRIPTION = 'captcha:description';
                TranslationConstants.DOMAIN_DOMAIN_EXISTS = 'domain:domain_exists';
                TranslationConstants.VALIDATION_ERRORS_REQUIRED = 'validation_errors:required';
                TranslationConstants.VALIDATION_ERRORS_PASSWORD = 'validation_errors:password';
                TranslationConstants.VALIDATION_ERRORS_PASSWORD_REPEAT = 'validation_errors:password_repeat';
                TranslationConstants.VALIDATION_ERRORS_SAME_PASSWORD = 'validation_errors:same_password';
                TranslationConstants.VALIDATION_ERRORS_EMAIL_DOMAIN = 'validation_errors:email_domain';
                TranslationConstants.VALIDATION_ERRORS_EMAIL = 'validation_errors:email';
                TranslationConstants.VALIDATION_ERRORS_DOMAIN = 'validation_errors:domain';
                TranslationConstants.VALIDATION_ERRORS_DATE = 'validation_errors:date';
                TranslationConstants.VALIDATION_ERRORS_ISIN = 'validation_errors:isin';
                TranslationConstants.VALIDATION_ERRORS_VALOR = 'validation_errors:valor';
                TranslationConstants.VALIDATION_ERRORS_FILE_SIZE = 'validation_errors:file_size';
                TranslationConstants.VALIDATION_ERRORS_MINLENGTH = 'validation_errors:minlength';
                TranslationConstants.VALIDATION_ERRORS_MAXLENGTH = 'validation_errors:maxlength';
                TranslationConstants.REGISTRATION_ACCOUNT_CREATED = 'registration:account_created';
                TranslationConstants.REGISTRATION_CAPTCHA = 'registration:captcha';
                TranslationConstants.REGISTRATION_CITY = 'registration:city';
                TranslationConstants.REGISTRATION_COUNTRY = 'registration:country';
                TranslationConstants.REGISTRATION_DOMAIN_NOT_ALLOWED = 'registration:domain_not_allowed';
                TranslationConstants.REGISTRATION_EMAIL = 'registration:email';
                TranslationConstants.REGISTRATION_ERROR_MAIL_EXISTS = 'registration:error_mail_exists';
                TranslationConstants.REGISTRATION_FIRSTNAME = 'registration:firstname';
                TranslationConstants.REGISTRATION_INSTITUTION = 'registration:institution';
                TranslationConstants.REGISTRATION_LANGUAGE = 'registration:language';
                TranslationConstants.REGISTRATION_LASTNAME = 'registration:lastname';
                TranslationConstants.REGISTRATION_MAIL_DESCRIPTION = 'registration:mail_description';
                TranslationConstants.REGISTRATION_PASSWORD = 'registration:password';
                TranslationConstants.REGISTRATION_PASSWORD_REPEAT = 'registration:password_repeat';
                TranslationConstants.REGISTRATION_PHONE = 'registration:phone';
                TranslationConstants.REGISTRATION_SALUTATION = 'registration:salutation';
                TranslationConstants.REGISTRATION_ACCOUNT_ACTIVATED = 'registration:account_activated';
                TranslationConstants.REGISTRATION_MOBILE = 'registration:mobile';
                TranslationConstants.USER_NOT_FOUND = 'user:not_found';
                TranslationConstants.USER_DOMAIN_UNKNOWN = 'user:domain_unknown';
                TranslationConstants.USER_DUPLICATE_EMAIL = 'user:duplicate_email';
                TranslationConstants.USER_DUPLICATE_LOGIN_NAME = 'user:duplicate_login_name';
                TranslationConstants.USER_NEW_PASSWORD = 'user:new_password';
                TranslationConstants.USER_PASSWORD_REPEAT = 'user:password_repeat';
                TranslationConstants.USER_PASSWORD_HASH = 'user:password_hash';
                TranslationConstants.ACCOUNT_PASSWORD_ERROR = 'account:password_error';
                TranslationConstants.ACCOUNT_TITLE = 'account:title';
                TranslationConstants.ACCOUNT_CITY = 'account:city';
                TranslationConstants.ACCOUNT_CONTACT_TITLE = 'account:contact_title';
                TranslationConstants.ACCOUNT_COUNTRY = 'account:country';
                TranslationConstants.ACCOUNT_EMAIL = 'account:email';
                TranslationConstants.ACCOUNT_FAX = 'account:fax';
                TranslationConstants.ACCOUNT_FIRST_NAME = 'account:first_name';
                TranslationConstants.ACCOUNT_INSTITUTION = 'account:institution';
                TranslationConstants.ACCOUNT_LANGUAGE = 'account:language';
                TranslationConstants.ACCOUNT_LAST_NAME = 'account:last_name';
                TranslationConstants.ACCOUNT_NEWSLETTER = 'account:newsletter';
                TranslationConstants.ACCOUNT_PHONE = 'account:phone';
                TranslationConstants.ACCOUNT_RECEIVE_EMAIL = 'account:receive_email';
                TranslationConstants.ACCOUNT_RECEIVE_EMAIL_NO_PUBLICATION = 'account:receive_email_no_publication';
                TranslationConstants.ACCOUNT_SALUTATION = 'account:salutation';
                TranslationConstants.ACCOUNT_STREET = 'account:street';
                TranslationConstants.ACCOUNT_USER_TITLE = 'account:user_title';
                TranslationConstants.ACCOUNT_ZIP = 'account:zip';
                TranslationConstants.ACCOUNT_MOBILE = 'account:mobile';
                TranslationConstants.REGISTER_TITLE = 'register:title';
                TranslationConstants.INFO_SAVED = 'info:saved';
                TranslationConstants.AUTHENTICATION_TITLE = 'authentication:title';
                TranslationConstants.AUTHENTICATION_SESSION_EXPIRED = 'authentication:session_expired';
                TranslationConstants.AUTHENTICATION_PASSWORD = 'authentication:password';
                TranslationConstants.AUTHENTICATION_CAPTCHA = 'authentication:captcha';
                TranslationConstants.AUTHENTICATION_LOGIN = 'authentication:login';
                return TranslationConstants;
            }();
            exports_1("TranslationConstants", TranslationConstants);
        }
    };
});

System.register("ict-external-client/app/components/xml_table_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/ags-client.js", "ict-external-client/gen/viewsearch/export_search_criteria.js", "ict-external-client/app/services/application_service.js", "ict-external-client/app/services/xml_service.js", "ict-external-client/gen/permissions.js", "ict-external-client/gen/i18n/translation_constants.js", "ict-core-client/ict-core-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, ags_client_1, ags_client_2, ags_client_3, export_search_criteria_1, ags_client_4, ags_client_5, ags_client_6, application_service_1, xml_service_1, ags_client_7, ags_client_8, permissions_1, translation_constants_1, ict_core_client_1, XmlCreationState, XmlTableComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
            ags_client_5 = ags_client_1_1;
            ags_client_6 = ags_client_1_1;
            ags_client_7 = ags_client_1_1;
            ags_client_8 = ags_client_1_1;
        }, function (export_search_criteria_1_1) {
            export_search_criteria_1 = export_search_criteria_1_1;
        }, function (application_service_1_1) {
            application_service_1 = application_service_1_1;
        }, function (xml_service_1_1) {
            xml_service_1 = xml_service_1_1;
        }, function (permissions_1_1) {
            permissions_1 = permissions_1_1;
        }, function (translation_constants_1_1) {
            translation_constants_1 = translation_constants_1_1;
        }, function (ict_core_client_1_1) {
            ict_core_client_1 = ict_core_client_1_1;
        }],
        execute: function () {
            (function (XmlCreationState) {
                XmlCreationState[XmlCreationState["RUNNING"] = 0] = "RUNNING";
                XmlCreationState[XmlCreationState["EXISTS"] = 1] = "EXISTS";
            })(XmlCreationState || exports_1("XmlCreationState", XmlCreationState = {}));
            XmlTableComponent = /** @class */function (_super) {
                __extends(XmlTableComponent, _super);
                function XmlTableComponent(alertService, translationService, _authenticationService, _applicationService, _xmlService, _codeService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._authenticationService = _authenticationService;
                    _this._applicationService = _applicationService;
                    _this._xmlService = _xmlService;
                    _this._codeService = _codeService;
                    _this.minYear = new Date().getFullYear();
                    _this.maxYear = new Date().getFullYear();
                    _this.xsdTypeOptions = new Array();
                    _this.domainOptions = new Array();
                    _this.referingToDateOptions = new Array();
                    _this._applicationService.cachedSystemParameters().then(function (systemParameters) {
                        _this.minYear = systemParameters.firstTaxYear;
                    });
                    return _this;
                }
                XmlTableComponent.prototype.initSearchCriteria = function () {
                    if (!ags_client_8.isPresent(this.exportSearchCriteria)) {
                        this.reset();
                    } else {
                        this.search();
                    }
                };
                XmlTableComponent.prototype.reset = function () {
                    var _this = this;
                    this._applicationService.cachedSystemParameters().then(function (systemParameters) {
                        _this.exportSearchCriteria = new export_search_criteria_1.ExportSearchCriteria(0, 10);
                        if (_this._authenticationService.authenticated()) {
                            _this.exportSearchCriteria.year = systemParameters.taxYearExtern;
                        } else {
                            _this.exportSearchCriteria.year = systemParameters.taxYearOnline;
                        }
                        _this.exportSearchCriteria.subscribeSearch(function () {
                            _this.search();
                        });
                    });
                };
                XmlTableComponent.prototype.initData = function () {
                    var _this = this;
                    if (this.canCreate()) {
                        this._xmlService.domains().subscribe(function (response) {
                            var domainOptions = new Array();
                            if (!_this.handleError(response)) {
                                response.data.forEach(function (domain) {
                                    domainOptions.push(new ags_client_7.SelectOption(domain.id.toString(), domain.name, domain));
                                });
                            }
                            _this.domainOptions = domainOptions;
                        });
                    }
                    this.loadXsdTypeOptions();
                };
                XmlTableComponent.prototype.loadXsdTypeOptions = function () {
                    var _this = this;
                    this._codeService.codesFromCache('XSDType').then(function (codes) {
                        var options = new Array();
                        codes.forEach(function (code) {
                            if (_this.canCreate() || !code.endsWith('.EXCHANGERATE')) {
                                var text = null;
                                text = _this.translationService.translate('XSDType' + ':' + code);
                                options.push(new ags_client_7.SelectOption(code, text, ict_core_client_1.XSDType.create(code)));
                            }
                        });
                        _this.xsdTypeOptions = options;
                    });
                };
                XmlTableComponent.prototype.buildFilterForm = function () {
                    this.filterForm = new common_1.ControlGroup({
                        'year': new common_1.Control(''),
                        'domain': new common_1.Control(''),
                        'referingToDate': new common_1.Control(''),
                        'xsdType': new common_1.Control('')
                    });
                };
                XmlTableComponent.prototype.search = function () {
                    var _this = this;
                    if (this.filterForm.valid) {
                        this.loading = true;
                        this._xmlService.xmls(this.exportSearchCriteria).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.exportSearchCriteria.total = response.totalItems;
                                _this.exports = response.data;
                            }
                            _this._refreshReferingToDateOptions();
                            _this.loading = false;
                        });
                    }
                };
                XmlTableComponent.prototype.resetReferingDate = function () {
                    this.exportSearchCriteria.referingToDate = null;
                };
                XmlTableComponent.prototype._refreshReferingToDateOptions = function () {
                    if (!ags_client_8.isPresent(this.exportSearchCriteria.referingToDate)) {
                        var options = new Array();
                        var exports = this.exports;
                        var dates = new Array();
                        if (ags_client_8.isPresent(exports)) {
                            exports.forEach(function (exportItem) {
                                if (dates.indexOf(exportItem.exportDate.getTime()) < 0) {
                                    dates.push(exportItem.exportDate.getTime());
                                }
                                if (exportItem.referingToDate && dates.indexOf(exportItem.referingToDate.getTime()) < 0) {
                                    dates.push(exportItem.referingToDate.getTime());
                                }
                            });
                        }
                        // sort descending
                        dates.sort(function (a, b) {
                            if (a < b) {
                                return 1;
                            } else if (a > b) {
                                return -1;
                            } else {
                                return 0;
                            }
                        });
                        dates.forEach(function (timestamp) {
                            var date = new Date(timestamp);
                            options.push(new ags_client_7.SelectOption(ags_client_8.formatDateTime(date), ags_client_8.formatDateTime(date), date));
                        });
                        this.referingToDateOptions = options;
                    }
                };
                XmlTableComponent.prototype.canCreate = function () {
                    return this._authenticationService.hasPermission([permissions_1.XML_NEW]);
                };
                XmlTableComponent.prototype.valid = function () {
                    return this.canCreate() && ags_client_8.isPresent(this.exportSearchCriteria.year) && ags_client_8.isPresent(this.exportSearchCriteria.xsdType);
                };
                XmlTableComponent.prototype.create = function () {
                    var _this = this;
                    if (this.valid()) {
                        if (!ags_client_8.isPresent(this.creationState) && this._exportExists()) {
                            this.alertService.warning(this.translationService.translate(translation_constants_1.TranslationConstants.XML_CREATION_EXISTS));
                            this.creationState = XmlCreationState.EXISTS;
                        } else {
                            this._xmlService.running().subscribe(function (response) {
                                if (!_this.handleError(response)) {
                                    if (response.data) {
                                        _this.creationState = XmlCreationState.RUNNING;
                                        _this.alertService.warning(_this.translationService.translate(translation_constants_1.TranslationConstants.XML_CREATION_RUNNING));
                                        _this.refreshCreationState();
                                    } else {
                                        _this._xmlService.create(_this.exportSearchCriteria).subscribe(function (response2) {
                                            if (!_this.handleError(response)) {
                                                _this.creationState = XmlCreationState.RUNNING;
                                                _this.alertService.info(_this.translationService.translate(translation_constants_1.TranslationConstants.XML_CREATION_STARTED));
                                                _this.refreshCreationState();
                                            }
                                        });
                                    }
                                }
                            });
                        }
                    }
                };
                XmlTableComponent.prototype.refreshCreationState = function () {
                    var _this = this;
                    ags_client_5.Timer.later(10000, function () {
                        _this._xmlService.running().subscribe(function (response) {
                            if (!response.data) {
                                _this.creationState = null;
                                _this.search();
                            } else {
                                _this.refreshCreationState();
                            }
                        });
                    });
                };
                XmlTableComponent.prototype._exportExists = function () {
                    if (ags_client_8.isPresent(this.exports)) {
                        var today = ags_client_8.formatDate(new Date());
                        return this.exports.filter(function (exportItem) {
                            return today === ags_client_8.formatDate(exportItem.exportDate);
                        }).length > 0;
                    }
                    return false;
                };
                __decorate([core_1.Input(), __metadata("design:type", String)], XmlTableComponent.prototype, "id", void 0);
                __decorate([ags_client_7.PageFlow('XmlTableComponent'), __metadata("design:type", export_search_criteria_1.ExportSearchCriteria)], XmlTableComponent.prototype, "exportSearchCriteria", void 0);
                __decorate([ags_client_7.PageFlow('XmlTableComponent'), __metadata("design:type", Array)], XmlTableComponent.prototype, "exports", void 0);
                XmlTableComponent = __decorate([core_1.Component({
                    directives: [ags_client_1.AGS_FORM_DIRECTIVES],
                    pipes: [ags_client_1.AGS_PIPES],
                    selector: 'xml-table',
                    templateUrl: 'ict-external-client/app/components/xml_table_component.html'
                }), __metadata("design:paramtypes", [ags_client_5.AlertService, ags_client_2.TranslationService, ags_client_6.AuthenticationService, application_service_1.ApplicationService, xml_service_1.XmlService, ags_client_3.CodeService, core_1.ElementRef])], XmlTableComponent);
                return XmlTableComponent;
            }(ags_client_4.AbstractTableComponent);
            exports_1("XmlTableComponent", XmlTableComponent);
        }
    };
});

System.register("ict-external-client/app/views/xml_view.js", ["angular2/core.js", "angular2/router.js", "ags-client/ags-client.js", "ict-external-client/app/components/xml_table_component.js", "ict-external-client/gen/views.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, router_1, ags_client_1, ags_client_2, ags_client_3, xml_table_component_1, views_1, XmlView;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (router_1_1) {
            router_1 = router_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
        }, function (xml_table_component_1_1) {
            xml_table_component_1 = xml_table_component_1_1;
        }, function (views_1_1) {
            views_1 = views_1_1;
        }],
        execute: function () {
            XmlView = /** @class */function (_super) {
                __extends(XmlView, _super);
                function XmlView(navigationService, router) {
                    return _super.call(this, navigationService, router) || this;
                }
                XmlView.prototype.refresh = function () {
                    this.xmlTable.first.search();
                };
                __decorate([core_1.ViewChildren(xml_table_component_1.XmlTableComponent), __metadata("design:type", core_1.QueryList)], XmlView.prototype, "xmlTable", void 0);
                XmlView = __decorate([core_1.Component({
                    selector: 'xml-view',
                    directives: [ags_client_1.AGS_DIRECTIVES, xml_table_component_1.XmlTableComponent],
                    pipes: [ags_client_1.AGS_PIPES],
                    templateUrl: 'ict-external-client/app/views/xml_view.html'
                }), router_1.CanActivate(function () {
                    return ags_client_1.AuthenticationService.checkViewSecurity(views_1.VIEW_SECURITY[views_1.XML_VIEW]);
                }), __metadata("design:paramtypes", [ags_client_2.NavigationService, router_1.Router])], XmlView);
                return XmlView;
            }(ags_client_3.AbstractView);
            exports_1("XmlView", XmlView);
        }
    };
});

System.register("ict-external-client/gen/views.js", ["ict-external-client/gen/permissions.js", "ict-external-client/app/views/account_view.js", "ict-external-client/app/views/earning_view.js", "ict-external-client/app/views/earning_create_view.js", "ict-external-client/app/views/earning_id_view.js", "ict-external-client/app/views/encode_password_view.js", "ict-external-client/app/views/login_view.js", "ict-external-client/app/views/lost_view.js", "ict-external-client/app/views/newsletter_view.js", "ict-external-client/app/views/ratelist_view.js", "ict-external-client/app/views/ratelist_year_view.js", "ict-external-client/app/views/register_view.js", "ict-external-client/app/views/report_view.js", "ict-external-client/app/views/request_view.js", "ict-external-client/app/views/request_create_view.js", "ict-external-client/app/views/request_id_view.js", "ict-external-client/app/views/request_dump_view.js", "ict-external-client/app/views/request_dump_id_view.js", "ict-external-client/app/views/search_view.js", "ict-external-client/app/views/security_id_date_view.js", "ict-external-client/app/views/xml_view.js"], function (exports_1, context_1) {
    "use strict";

    var Permissions, account_view_1, earning_view_1, earning_create_view_1, earning_id_view_1, encode_password_view_1, login_view_1, lost_view_1, newsletter_view_1, ratelist_view_1, ratelist_year_view_1, register_view_1, report_view_1, request_view_1, request_create_view_1, request_id_view_1, request_dump_view_1, request_dump_id_view_1, search_view_1, security_id_date_view_1, xml_view_1, ACCOUNT_VIEW, EARNING_VIEW, EARNING_CREATE_VIEW, EARNING_ID_VIEW, ENCODE_PASSWORD_VIEW, LOGIN_VIEW, LOST_VIEW, NEWSLETTER_VIEW, RATELIST_VIEW, RATELIST_YEAR_VIEW, REGISTER_VIEW, REPORT_VIEW, REQUEST_VIEW, REQUEST_CREATE_VIEW, REQUEST_ID_VIEW, REQUEST_DUMP_VIEW, REQUEST_DUMP_ID_VIEW, SEARCH_VIEW, SECURITY_ID_DATE_VIEW, XML_VIEW, VIEW_SECURITY, ROUTES;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (Permissions_1) {
            Permissions = Permissions_1;
        }, function (account_view_1_1) {
            account_view_1 = account_view_1_1;
            exports_1({
                "AccountView": account_view_1_1["AccountView"]
            });
        }, function (earning_view_1_1) {
            earning_view_1 = earning_view_1_1;
            exports_1({
                "EarningView": earning_view_1_1["EarningView"]
            });
        }, function (earning_create_view_1_1) {
            earning_create_view_1 = earning_create_view_1_1;
            exports_1({
                "EarningCreateView": earning_create_view_1_1["EarningCreateView"]
            });
        }, function (earning_id_view_1_1) {
            earning_id_view_1 = earning_id_view_1_1;
            exports_1({
                "EarningIdView": earning_id_view_1_1["EarningIdView"]
            });
        }, function (encode_password_view_1_1) {
            encode_password_view_1 = encode_password_view_1_1;
            exports_1({
                "EncodePasswordView": encode_password_view_1_1["EncodePasswordView"]
            });
        }, function (login_view_1_1) {
            login_view_1 = login_view_1_1;
            exports_1({
                "LoginView": login_view_1_1["LoginView"]
            });
        }, function (lost_view_1_1) {
            lost_view_1 = lost_view_1_1;
            exports_1({
                "LostView": lost_view_1_1["LostView"]
            });
        }, function (newsletter_view_1_1) {
            newsletter_view_1 = newsletter_view_1_1;
            exports_1({
                "NewsletterView": newsletter_view_1_1["NewsletterView"]
            });
        }, function (ratelist_view_1_1) {
            ratelist_view_1 = ratelist_view_1_1;
            exports_1({
                "RatelistView": ratelist_view_1_1["RatelistView"]
            });
        }, function (ratelist_year_view_1_1) {
            ratelist_year_view_1 = ratelist_year_view_1_1;
            exports_1({
                "RatelistYearView": ratelist_year_view_1_1["RatelistYearView"]
            });
        }, function (register_view_1_1) {
            register_view_1 = register_view_1_1;
            exports_1({
                "RegisterView": register_view_1_1["RegisterView"]
            });
        }, function (report_view_1_1) {
            report_view_1 = report_view_1_1;
            exports_1({
                "ReportView": report_view_1_1["ReportView"]
            });
        }, function (request_view_1_1) {
            request_view_1 = request_view_1_1;
            exports_1({
                "RequestView": request_view_1_1["RequestView"]
            });
        }, function (request_create_view_1_1) {
            request_create_view_1 = request_create_view_1_1;
            exports_1({
                "RequestCreateView": request_create_view_1_1["RequestCreateView"]
            });
        }, function (request_id_view_1_1) {
            request_id_view_1 = request_id_view_1_1;
            exports_1({
                "RequestIdView": request_id_view_1_1["RequestIdView"]
            });
        }, function (request_dump_view_1_1) {
            request_dump_view_1 = request_dump_view_1_1;
            exports_1({
                "RequestDumpView": request_dump_view_1_1["RequestDumpView"]
            });
        }, function (request_dump_id_view_1_1) {
            request_dump_id_view_1 = request_dump_id_view_1_1;
            exports_1({
                "RequestDumpIdView": request_dump_id_view_1_1["RequestDumpIdView"]
            });
        }, function (search_view_1_1) {
            search_view_1 = search_view_1_1;
            exports_1({
                "SearchView": search_view_1_1["SearchView"]
            });
        }, function (security_id_date_view_1_1) {
            security_id_date_view_1 = security_id_date_view_1_1;
            exports_1({
                "SecurityIdDateView": security_id_date_view_1_1["SecurityIdDateView"]
            });
        }, function (xml_view_1_1) {
            xml_view_1 = xml_view_1_1;
            exports_1({
                "XmlView": xml_view_1_1["XmlView"]
            });
        }],
        execute: function () {
            exports_1("ACCOUNT_VIEW", ACCOUNT_VIEW = 'AccountView');
            exports_1("EARNING_VIEW", EARNING_VIEW = 'EarningView');
            exports_1("EARNING_CREATE_VIEW", EARNING_CREATE_VIEW = 'EarningCreateView');
            exports_1("EARNING_ID_VIEW", EARNING_ID_VIEW = 'EarningIdView');
            exports_1("ENCODE_PASSWORD_VIEW", ENCODE_PASSWORD_VIEW = 'EncodePasswordView');
            exports_1("LOGIN_VIEW", LOGIN_VIEW = 'LoginView');
            exports_1("LOST_VIEW", LOST_VIEW = 'LostView');
            exports_1("NEWSLETTER_VIEW", NEWSLETTER_VIEW = 'NewsletterView');
            exports_1("RATELIST_VIEW", RATELIST_VIEW = 'RatelistView');
            exports_1("RATELIST_YEAR_VIEW", RATELIST_YEAR_VIEW = 'RatelistYearView');
            exports_1("REGISTER_VIEW", REGISTER_VIEW = 'RegisterView');
            exports_1("REPORT_VIEW", REPORT_VIEW = 'ReportView');
            exports_1("REQUEST_VIEW", REQUEST_VIEW = 'RequestView');
            exports_1("REQUEST_CREATE_VIEW", REQUEST_CREATE_VIEW = 'RequestCreateView');
            exports_1("REQUEST_ID_VIEW", REQUEST_ID_VIEW = 'RequestIdView');
            exports_1("REQUEST_DUMP_VIEW", REQUEST_DUMP_VIEW = 'RequestDumpView');
            exports_1("REQUEST_DUMP_ID_VIEW", REQUEST_DUMP_ID_VIEW = 'RequestDumpIdView');
            exports_1("SEARCH_VIEW", SEARCH_VIEW = 'SearchView');
            exports_1("SECURITY_ID_DATE_VIEW", SECURITY_ID_DATE_VIEW = 'SecurityIdDateView');
            exports_1("XML_VIEW", XML_VIEW = 'XmlView');
            exports_1("VIEW_SECURITY", VIEW_SECURITY = {});
            VIEW_SECURITY[ACCOUNT_VIEW] = [Permissions.ACCOUNT_VIEW];
            VIEW_SECURITY[EARNING_VIEW] = [Permissions.EARNING_DECLARE_SEARCH];
            VIEW_SECURITY[EARNING_CREATE_VIEW] = [Permissions.EARNING_DECLARE_EDIT];
            VIEW_SECURITY[EARNING_ID_VIEW] = [Permissions.EARNING_DECLARE_EDIT];
            VIEW_SECURITY[ENCODE_PASSWORD_VIEW] = [];
            VIEW_SECURITY[LOGIN_VIEW] = [];
            VIEW_SECURITY[LOST_VIEW] = [];
            VIEW_SECURITY[NEWSLETTER_VIEW] = [];
            VIEW_SECURITY[RATELIST_VIEW] = [];
            VIEW_SECURITY[RATELIST_YEAR_VIEW] = [];
            VIEW_SECURITY[REGISTER_VIEW] = [];
            VIEW_SECURITY[REPORT_VIEW] = [Permissions.REPORT_VIEW];
            VIEW_SECURITY[REQUEST_VIEW] = [Permissions.REQUEST_SEARCH];
            VIEW_SECURITY[REQUEST_CREATE_VIEW] = [Permissions.REQUEST_EDIT];
            VIEW_SECURITY[REQUEST_ID_VIEW] = [Permissions.REQUEST_EDIT];
            VIEW_SECURITY[REQUEST_DUMP_VIEW] = [Permissions.DEBUG_ADMIN];
            VIEW_SECURITY[REQUEST_DUMP_ID_VIEW] = [Permissions.DEBUG_ADMIN];
            VIEW_SECURITY[SEARCH_VIEW] = [];
            VIEW_SECURITY[SECURITY_ID_DATE_VIEW] = [];
            VIEW_SECURITY[XML_VIEW] = [];
            exports_1("ROUTES", ROUTES = [{ path: 'account', component: account_view_1.AccountView, as: ACCOUNT_VIEW }, { path: 'earning', component: earning_view_1.EarningView, as: EARNING_VIEW }, { path: 'earning/create', component: earning_create_view_1.EarningCreateView, as: EARNING_CREATE_VIEW }, { path: 'earning/:id', component: earning_id_view_1.EarningIdView, as: EARNING_ID_VIEW }, { path: 'encode-password', component: encode_password_view_1.EncodePasswordView, as: ENCODE_PASSWORD_VIEW }, { path: 'login', component: login_view_1.LoginView, as: LOGIN_VIEW }, { path: 'lost', component: lost_view_1.LostView, as: LOST_VIEW }, { path: 'newsletter', component: newsletter_view_1.NewsletterView, as: NEWSLETTER_VIEW }, { path: '/', redirectTo: [RATELIST_VIEW] }, { path: 'ratelist', component: ratelist_view_1.RatelistView, as: RATELIST_VIEW }, { path: 'ratelist/:year', component: ratelist_year_view_1.RatelistYearView, as: RATELIST_YEAR_VIEW }, { path: 'register', component: register_view_1.RegisterView, as: REGISTER_VIEW }, { path: 'report', component: report_view_1.ReportView, as: REPORT_VIEW }, { path: 'request', component: request_view_1.RequestView, as: REQUEST_VIEW }, { path: 'request/create', component: request_create_view_1.RequestCreateView, as: REQUEST_CREATE_VIEW }, { path: 'request/:id', component: request_id_view_1.RequestIdView, as: REQUEST_ID_VIEW }, { path: 'request-dump', component: request_dump_view_1.RequestDumpView, as: REQUEST_DUMP_VIEW }, { path: 'request-dump/:id', component: request_dump_id_view_1.RequestDumpIdView, as: REQUEST_DUMP_ID_VIEW }, { path: 'search', component: search_view_1.SearchView, as: SEARCH_VIEW }, { path: 'security/:id/:date', component: security_id_date_view_1.SecurityIdDateView, as: SECURITY_ID_DATE_VIEW }, { path: 'xml', component: xml_view_1.XmlView, as: XML_VIEW }]);
        }
    };
});

System.register("ict-external-client/gen/viewmodels/security_search_result_view_model.js", ["ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var ags_client_1, ags_client_2, ags_client_3, ags_client_4, ags_client_5, ags_client_6, ags_client_7, SecuritySearchResultViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
            ags_client_5 = ags_client_1_1;
            ags_client_6 = ags_client_1_1;
            ags_client_7 = ags_client_1_1;
        }],
        execute: function () {
            SecuritySearchResultViewModel = /** @class */function (_super) {
                __extends(SecuritySearchResultViewModel, _super);
                function SecuritySearchResultViewModel() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                SecuritySearchResultViewModel.deserialize = function (object) {
                    var _result = new SecuritySearchResultViewModel();
                    return _result._deserialize(object);
                };
                SecuritySearchResultViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        _super.prototype._deserialize.call(this, object);
                        if (ags_client_1.isPresent(object['valorNumber'])) {
                            this.valorNumber = object['valorNumber'];
                        }
                        if (ags_client_1.isPresent(object['isin'])) {
                            this.isin = object['isin'];
                        }
                        if (ags_client_1.isPresent(object['nsin'])) {
                            this.nsin = object['nsin'];
                        }
                        if (ags_client_1.isPresent(object['institution'])) {
                            this.institution = object['institution'];
                        }
                        if (ags_client_1.isPresent(object['instrument'])) {
                            this.instrument = object['instrument'];
                        }
                        if (ags_client_1.isPresent(object['instrumentGroup'])) {
                            this.instrumentGroup = ags_client_4.enumNumberValue(ags_client_3.InstrumentGroup, object['instrumentGroup']);
                        }
                        if (ags_client_1.isPresent(object['instrumentType'])) {
                            this.instrumentType = ags_client_4.enumNumberValue(ags_client_5.InstrumentType, object['instrumentType']);
                        }
                        if (ags_client_1.isPresent(object['country'])) {
                            this.country = new ags_client_6.Country(object['country']['shortName']);
                        }
                        if (ags_client_1.isPresent(object['currency'])) {
                            this.currency = new ags_client_7.Currency(object['currency']['shortName']);
                        }
                    }
                    return this;
                };
                SecuritySearchResultViewModel.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (ags_client_1.isPresent(this.valorNumber)) {
                        object['valorNumber'] = this.valorNumber;
                    }
                    if (ags_client_1.isPresent(this.isin)) {
                        object['isin'] = this.isin;
                    }
                    if (ags_client_1.isPresent(this.nsin)) {
                        object['nsin'] = this.nsin;
                    }
                    if (ags_client_1.isPresent(this.institution)) {
                        object['institution'] = this.institution;
                    }
                    if (ags_client_1.isPresent(this.instrument)) {
                        object['instrument'] = this.instrument;
                    }
                    if (ags_client_1.isPresent(this.instrumentGroup)) {
                        object['instrumentGroup'] = ags_client_3.InstrumentGroup[this.instrumentGroup];
                    }
                    if (ags_client_1.isPresent(this.instrumentType)) {
                        object['instrumentType'] = ags_client_5.InstrumentType[this.instrumentType];
                    }
                    if (ags_client_1.isPresent(this.country)) {
                        object['country'] = this.country;
                    }
                    if (ags_client_1.isPresent(this.currency)) {
                        object['currency'] = this.currency;
                    }
                    return object;
                };
                SecuritySearchResultViewModel.VALOR_NUMBER_VALIDATORS = [];
                SecuritySearchResultViewModel.ISIN_VALIDATORS = [];
                SecuritySearchResultViewModel.NSIN_VALIDATORS = [];
                SecuritySearchResultViewModel.INSTITUTION_VALIDATORS = [];
                SecuritySearchResultViewModel.INSTRUMENT_VALIDATORS = [];
                SecuritySearchResultViewModel.INSTRUMENT_GROUP_VALIDATORS = [];
                SecuritySearchResultViewModel.INSTRUMENT_TYPE_VALIDATORS = [];
                SecuritySearchResultViewModel.COUNTRY_VALIDATORS = [];
                SecuritySearchResultViewModel.CURRENCY_VALIDATORS = [];
                return SecuritySearchResultViewModel;
            }(ags_client_2.SearchEntityViewModel);
            exports_1("SecuritySearchResultViewModel", SecuritySearchResultViewModel);
        }
    };
});

System.register("ict-core-client/gen/services/abstract_system_parameter_service.js", ["ags-client/ags-client.js", "ict-core-client/gen/viewmodels/system_parameters_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, system_parameters_view_model_1, AbstractSystemParameterService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }, function (system_parameters_view_model_1_1) {
            system_parameters_view_model_1 = system_parameters_view_model_1_1;
        }],
        execute: function () {
            AbstractSystemParameterService = /** @class */function () {
                function AbstractSystemParameterService(backendService) {
                    this.backendService = backendService;
                }
                AbstractSystemParameterService.prototype.systemParameters = function () {
                    return this.backendService.getJson('/systemParameter/systemParameters.json', function (response) {
                        return ags_client_1.JsonResponse.deserialize(response, system_parameters_view_model_1.SystemParametersViewModel.deserialize(response.data));
                    });
                };
                return AbstractSystemParameterService;
            }();
            exports_1("AbstractSystemParameterService", AbstractSystemParameterService);
        }
    };
});

System.register("ict-core-client/app/services/system_parameter_service.js", ["angular2/core.js", "ict-core-client/gen/services/abstract_system_parameter_service.js", "ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, abstract_system_parameter_service_1, ags_client_1, SystemParameterService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (abstract_system_parameter_service_1_1) {
            abstract_system_parameter_service_1 = abstract_system_parameter_service_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }],
        execute: function () {
            SystemParameterService = /** @class */function (_super) {
                __extends(SystemParameterService, _super);
                function SystemParameterService(backendService) {
                    return _super.call(this, backendService) || this;
                }
                SystemParameterService = __decorate([core_1.Injectable(), core_1.Inject(ags_client_1.BackendService), __metadata("design:paramtypes", [ags_client_1.BackendService])], SystemParameterService);
                return SystemParameterService;
            }(abstract_system_parameter_service_1.AbstractSystemParameterService);
            exports_1("SystemParameterService", SystemParameterService);
        }
    };
});

System.register("ict-core-client/app/services.js", ["ict-core-client/app/services/core_gadget_service.js", "ict-core-client/app/services/system_parameter_service.js"], function (exports_1, context_1) {
    "use strict";

    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_gadget_service_1_1) {
            exports_1({
                "CoreGadgetService": core_gadget_service_1_1["CoreGadgetService"]
            });
        }, function (system_parameter_service_1_1) {
            exports_1({
                "SystemParameterService": system_parameter_service_1_1["SystemParameterService"]
            });
        }],
        execute: function () {}
    };
});

System.register("ict-core-client/gen/services/abstract_core_gadget_service.js", ["ags-client/ags-client.js", "ict-core-client/gen/viewmodels/value_date_view_model.js", "ict-core-client/gen/viewmodels/currency_view_model.js", "ict-core-client/gen/viewmodels/token_view_model.js", "ict-core-client/gen/viewmodels/capitalization_rate_gadget_view_model.js", "ict-core-client/gen/viewmodels/coinbullion_gadget_view_model.js", "ict-core-client/gen/viewmodels/currencynote_gadget_view_model.js", "ict-core-client/gen/viewmodels/currencytoken_gadget_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, value_date_view_model_1, currency_view_model_1, token_view_model_1, capitalization_rate_gadget_view_model_1, coinbullion_gadget_view_model_1, currencynote_gadget_view_model_1, currencytoken_gadget_view_model_1, AbstractCoreGadgetService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }, function (value_date_view_model_1_1) {
            value_date_view_model_1 = value_date_view_model_1_1;
        }, function (currency_view_model_1_1) {
            currency_view_model_1 = currency_view_model_1_1;
        }, function (token_view_model_1_1) {
            token_view_model_1 = token_view_model_1_1;
        }, function (capitalization_rate_gadget_view_model_1_1) {
            capitalization_rate_gadget_view_model_1 = capitalization_rate_gadget_view_model_1_1;
        }, function (coinbullion_gadget_view_model_1_1) {
            coinbullion_gadget_view_model_1 = coinbullion_gadget_view_model_1_1;
        }, function (currencynote_gadget_view_model_1_1) {
            currencynote_gadget_view_model_1 = currencynote_gadget_view_model_1_1;
        }, function (currencytoken_gadget_view_model_1_1) {
            currencytoken_gadget_view_model_1 = currencytoken_gadget_view_model_1_1;
        }],
        execute: function () {
            AbstractCoreGadgetService = /** @class */function () {
                function AbstractCoreGadgetService(backendService) {
                    this.backendService = backendService;
                }
                AbstractCoreGadgetService.prototype.getLastWorkingDay = function (request) {
                    return this.backendService.getJson('/coreGadget/getLastWorkingDay/' + request + '.json', function (response) {
                        return ags_client_1.JsonResponse.deserialize(response, value_date_view_model_1.ValueDateViewModel.deserialize(response.data));
                    });
                };
                AbstractCoreGadgetService.prototype.years = function () {
                    return this.backendService.getJson('/coreGadget/years.json', function (response) {
                        return ags_client_1.JsonResponse.deserialize(response, response.data);
                    });
                };
                AbstractCoreGadgetService.prototype.currencies = function () {
                    return this.backendService.getJson('/coreGadget/currencies.json', function (response) {
                        var data = Array();
                        response.data.forEach(function (item) {
                            data.push(currency_view_model_1.CurrencyViewModel.deserialize(item));
                        });
                        return ags_client_1.JsonResponse.deserialize(response, data);
                    });
                };
                AbstractCoreGadgetService.prototype.capitalizationRateCurrencies = function () {
                    return this.backendService.getJson('/coreGadget/capitalizationRateCurrencies.json', function (response) {
                        var data = Array();
                        response.data.forEach(function (item) {
                            data.push(currency_view_model_1.CurrencyViewModel.deserialize(item));
                        });
                        return ags_client_1.JsonResponse.deserialize(response, data);
                    });
                };
                AbstractCoreGadgetService.prototype.tokens = function () {
                    return this.backendService.getJson('/coreGadget/tokens.json', function (response) {
                        var data = Array();
                        response.data.forEach(function (item) {
                            data.push(token_view_model_1.TokenViewModel.deserialize(item));
                        });
                        return ags_client_1.JsonResponse.deserialize(response, data);
                    });
                };
                AbstractCoreGadgetService.prototype.capitalizationRates = function (request) {
                    return this.backendService.postJson('/coreGadget/capitalizationRates.json', request.serialize(), function (response) {
                        return ags_client_1.JsonResponse.deserialize(response, capitalization_rate_gadget_view_model_1.CapitalizationRateGadgetViewModel.deserialize(response.data));
                    });
                };
                AbstractCoreGadgetService.prototype.coinBullionsDaily = function (request) {
                    return this.backendService.getJson('/coreGadget/coinBullionsDaily/' + request + '.json', function (response) {
                        return ags_client_1.JsonResponse.deserialize(response, coinbullion_gadget_view_model_1.CoinbullionGadgetViewModel.deserialize(response.data));
                    });
                };
                AbstractCoreGadgetService.prototype.exchangeRates = function (request) {
                    return this.backendService.postJson('/coreGadget/exchangeRates.json', request.serialize(), function (response) {
                        return ags_client_1.JsonResponse.deserialize(response, currencynote_gadget_view_model_1.CurrencynoteGadgetViewModel.deserialize(response.data));
                    });
                };
                AbstractCoreGadgetService.prototype.tokenGadget = function (request) {
                    return this.backendService.postJson('/coreGadget/tokenGadget.json', request.serialize(), function (response) {
                        return ags_client_1.JsonResponse.deserialize(response, currencytoken_gadget_view_model_1.CurrencytokenGadgetViewModel.deserialize(response.data));
                    });
                };
                return AbstractCoreGadgetService;
            }();
            exports_1("AbstractCoreGadgetService", AbstractCoreGadgetService);
        }
    };
});

System.register("ict-core-client/app/services/core_gadget_service.js", ["angular2/core.js", "ict-core-client/gen/services/abstract_core_gadget_service.js", "ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, abstract_core_gadget_service_1, ags_client_1, CoreGadgetService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (abstract_core_gadget_service_1_1) {
            abstract_core_gadget_service_1 = abstract_core_gadget_service_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }],
        execute: function () {
            CoreGadgetService = /** @class */function (_super) {
                __extends(CoreGadgetService, _super);
                function CoreGadgetService(backendService) {
                    return _super.call(this, backendService) || this;
                }
                CoreGadgetService = __decorate([core_1.Injectable(), core_1.Inject(ags_client_1.BackendService), __metadata("design:paramtypes", [ags_client_1.BackendService])], CoreGadgetService);
                return CoreGadgetService;
            }(abstract_core_gadget_service_1.AbstractCoreGadgetService);
            exports_1("CoreGadgetService", CoreGadgetService);
        }
    };
});

System.register("ict-core-client/app/directives/select_currency_directive.js", ["ags-client/ags-client.js", "angular2/common.js", "angular2/core.js", "ict-core-client/app/services/core_gadget_service.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var ags_client_1, common_1, core_1, core_gadget_service_1, SelectCurrencyDirective;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (core_1_1) {
            core_1 = core_1_1;
        }, function (core_gadget_service_1_1) {
            core_gadget_service_1 = core_gadget_service_1_1;
        }],
        execute: function () {
            SelectCurrencyDirective = /** @class */function (_super) {
                __extends(SelectCurrencyDirective, _super);
                function SelectCurrencyDirective(element, control, _alertService, _translationService, _coreGadgetService) {
                    var _this = _super.call(this, element, control) || this;
                    _this._alertService = _alertService;
                    _this._translationService = _translationService;
                    _this._coreGadgetService = _coreGadgetService;
                    _this.excludeChf = false;
                    _this._ORDER_FIRST = ['AUD', 'CAD', 'CHF', 'EUR', 'GBP', 'HKD', 'JPY', 'USD'];
                    control.valueAccessor = _this;
                    _this.setIsSorted(false);
                    return _this;
                }
                SelectCurrencyDirective.prototype._createSelectOption = function (currencyCode) {
                    var text = currencyCode + ' ' + this._translationService.translate('Currency:' + currencyCode);
                    return new ags_client_1.SelectOption(currencyCode, text, currencyCode);
                };
                SelectCurrencyDirective.prototype.loadOptions = function (callback) {
                    var _this = this;
                    var options = new Array();
                    this._coreGadgetService.currencies().subscribe(function (response) {
                        if (!_this.handleError(response)) {
                            response.data.sort(function (a, b) {
                                var ia = _this._ORDER_FIRST.indexOf(a.currency.shortName);
                                var ib = _this._ORDER_FIRST.indexOf(b.currency.shortName);
                                if (ia < 0) ia = 9999;
                                if (ib < 0) ib = 9999;
                                var crit1 = ia - ib;
                                return crit1 !== 0 ? crit1 : a.currency.shortName.localeCompare(b.currency.shortName);
                            });
                            response.data.forEach(function (cvm) {
                                if (!_this.excludeChf || cvm.currency.shortName !== 'CHF') {
                                    options.push(_this._createSelectOption(cvm.currency.shortName));
                                }
                            });
                        }
                        callback(options);
                    });
                };
                SelectCurrencyDirective.prototype.handleError = function (response, resetMessage) {
                    if (resetMessage === void 0) {
                        resetMessage = true;
                    }
                    if (resetMessage) {
                        this._alertService.reset();
                    }
                    if (response.status === ags_client_1.JsonResponseStatus.ERROR || response.status === ags_client_1.JsonResponseStatus.NOT_FOUND || response.status === ags_client_1.JsonResponseStatus.FORBIDDEN) {
                        this._alertService.error(this._translationService.translate(response.error));
                        return true;
                    } else {
                        return false;
                    }
                };
                SelectCurrencyDirective.prototype.convertFromValue = function (value) {
                    if (value) {
                        return value.shortName;
                    }
                    return null;
                };
                SelectCurrencyDirective.prototype.convertToValue = function (stringValue) {
                    if (stringValue) {
                        var category = ags_client_1.CodeRegistry.code('Currency');
                        return category.create(stringValue);
                    }
                    return null;
                };
                SelectCurrencyDirective.prototype.onInputChange = function (stringValue) {
                    _super.prototype.onInputChange.call(this, stringValue);
                };
                SelectCurrencyDirective.prototype.onBlur = function () {
                    _super.prototype.onBlur.call(this);
                };
                __decorate([core_1.Input(), __metadata("design:type", Object)], SelectCurrencyDirective.prototype, "excludeChf", void 0);
                __decorate([core_1.HostListener('change', ['$event.target.value']), __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", void 0)], SelectCurrencyDirective.prototype, "onInputChange", null);
                __decorate([core_1.HostListener('blur', ['$event']), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], SelectCurrencyDirective.prototype, "onBlur", null);
                SelectCurrencyDirective = __decorate([core_1.Directive({
                    selector: 'select[type=currency]'
                }), core_1.Inject(core_1.ElementRef), core_1.Inject(common_1.NgControl), __metadata("design:paramtypes", [core_1.ElementRef, common_1.NgControl, ags_client_1.AlertService, ags_client_1.TranslationService, core_gadget_service_1.CoreGadgetService])], SelectCurrencyDirective);
                return SelectCurrencyDirective;
            }(ags_client_1.AbstractSelectDirective);
            exports_1("SelectCurrencyDirective", SelectCurrencyDirective);
        }
    };
});

System.register("ict-core-client/app/constants.js", ["ict-core-client/app/directives/select_currency_directive.js"], function (exports_1, context_1) {
    "use strict";

    var select_currency_directive_1, ICT_CORE_DIRECTIVES;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (select_currency_directive_1_1) {
            select_currency_directive_1 = select_currency_directive_1_1;
        }],
        execute: function () {
            exports_1("ICT_CORE_DIRECTIVES", ICT_CORE_DIRECTIVES = [select_currency_directive_1.SelectCurrencyDirective]);
        }
    };
});

/* tslint:disable */
System.register('ict-core-client/gen/i18n/translation_constants.js', [], function (exports_1, context_1) {
    "use strict";

    var TranslationConstants;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [],
        execute: function () {
            /* tslint:disable */
            TranslationConstants = /** @class */function () {
                function TranslationConstants() {}
                TranslationConstants.REQUEST_YEAR = 'request:year';
                TranslationConstants.REQUEST_ENTRY_DATE = 'request:entry_date';
                TranslationConstants.REQUEST_VALOR_NUMBER = 'request:valor_number';
                TranslationConstants.REQUEST_ISIN = 'request:isin';
                TranslationConstants.REQUEST_DOSSIER_NUMBER = 'request:dossier_number';
                TranslationConstants.REQUEST_REQUEST_REASON = 'request:request_reason';
                TranslationConstants.REQUEST_EMAIL = 'request:email';
                TranslationConstants.REQUEST_REQUEST_STATUS = 'request:request_status';
                TranslationConstants.REQUEST_INSTITUTION_INSTRUMENT_NAME = 'request:institution_instrument_name';
                TranslationConstants.REQUEST_REQUEST_USER = 'request:request_user';
                TranslationConstants.REQUEST_LASTNAME = 'request:lastname';
                TranslationConstants.REQUEST_TITLE_CREATE = 'request:title_create';
                TranslationConstants.REQUEST_INSTRUMENT_GROUP = 'request:instrument_group';
                TranslationConstants.REQUEST_MESSAGE = 'request:message';
                TranslationConstants.REQUEST_ATTACH_SUBSEQUENTLY = 'request:attach_subsequently';
                TranslationConstants.REQUEST_EMAIL_RESPONSE_NO_PUBLICATION = 'request:email_response_no_publication';
                TranslationConstants.REQUEST_EMAIL_RESPONSE_DESIRED = 'request:email_response_desired';
                TranslationConstants.REQUEST_REQUIRED_MESSAGE = 'request:required_message';
                TranslationConstants.REQUEST_ID = 'request:id';
                TranslationConstants.REQUEST_TITLE_MESSAGES = 'request:title_messages';
                TranslationConstants.REQUEST_ANNUALREPORTREQUESTED = 'request:annualReportRequested';
                TranslationConstants.REQUEST_TITLE_EDIT = 'request:title_edit';
                TranslationConstants.REQUEST_WITHDRAW = 'request:withdraw';
                TranslationConstants.REQUEST_WITHDRAW_CONFIRMATION = 'request:withdraw_confirmation';
                TranslationConstants.MAIL_STATUS_CHANGED_SUBJECT = 'mail:status_changed_subject';
                TranslationConstants.MAIL_REQUEST_CREATED_SUBJECT = 'mail:request_created_subject';
                TranslationConstants.MAIL_REQUEST_MESSAGE_ADDED = 'mail:request_message_added';
                TranslationConstants.MAIL_KURSLISTE_GENERATION = 'mail:kursliste_generation';
                TranslationConstants.INSTRUMENT_REQUEST_EXISTS_MESSAGE = 'instrument:request_exists_message';
                TranslationConstants.INSTRUMENT_LEGEND_BFP = 'instrument:legend_bfp';
                TranslationConstants.INSTRUMENT_LEGEND_RDB = 'instrument:legend_rdb';
                TranslationConstants.SECURITY_YEAR = 'security:year';
                TranslationConstants.SECURITY_INSTRUMENT_TYPE = 'security:instrument_type';
                TranslationConstants.SECURITY_INSTRUMENT_GROUP = 'security:instrument_group';
                TranslationConstants.SECURITY_COUNTRY = 'security:country';
                TranslationConstants.SECURITY_CURRENCY = 'security:currency';
                TranslationConstants.SECURITY_IUP = 'security:iup';
                TranslationConstants.SECURITY_BFP = 'security:bfp';
                TranslationConstants.SECURITY_INTEREST_RATE = 'security:interest_rate';
                TranslationConstants.SECURITY_ISSUE_YEAR = 'security:issue_year';
                TranslationConstants.SECURITY_VARIABLE_INTEREST_RATE = 'security:variable_interest_rate';
                TranslationConstants.SECURITY_REDEMPTION_YEAR = 'security:redemption_year';
                TranslationConstants.SECURITY_INSTITUTION = 'security:institution';
                TranslationConstants.SECURITY_INSTRUMENT = 'security:instrument';
                TranslationConstants.SECURITY_VALOR_NUMBER = 'security:valor_number';
                TranslationConstants.SECURITY_NSIN = 'security:nsin';
                TranslationConstants.SECURITY_ISIN = 'security:isin';
                TranslationConstants.SECURITY_NAME = 'security:name';
                TranslationConstants.EARNING_DECLARE_ENTRY_DATE = 'earning_declare:entry_date';
                TranslationConstants.EARNING_DECLARE_DECLARE_USER = 'earning_declare:declare_user';
                TranslationConstants.EARNING_DECLARE_EMAIL = 'earning_declare:email';
                TranslationConstants.EARNING_DECLARE_ID = 'earning_declare:id';
                TranslationConstants.EARNING_DECLARE_YEAR = 'earning_declare:year';
                TranslationConstants.EARNING_DECLARE_STATUS = 'earning_declare:status';
                TranslationConstants.EARNING_DECLARE_TITLE_CREATE = 'earning_declare:title_create';
                TranslationConstants.EARNING_DECLARE_LASTNAME = 'earning_declare:lastname';
                TranslationConstants.EARNING_DECLARE_INSTRUMENT_GROUP = 'earning_declare:instrument_group';
                TranslationConstants.EARNING_DECLARE_MESSAGE = 'earning_declare:message';
                TranslationConstants.EARNING_DECLARE_EMAIL_RESPONSE_DESIRED = 'earning_declare:email_response_desired';
                TranslationConstants.EARNING_DECLARE_ATTACH_SUBSEQUENTLY = 'earning_declare:attach_subsequently';
                TranslationConstants.EARNING_DECLARE_TITLE_EDIT = 'earning_declare:title_edit';
                TranslationConstants.EARNING_DECLARE_TITLE_MESSAGES = 'earning_declare:title_messages';
                TranslationConstants.EARNING_DECLARE_DECLARATION = 'earning_declare:declaration';
                TranslationConstants.EARNING_DECLARE_TAXABLE_EARNINGS = 'earning_declare:taxable_earnings';
                TranslationConstants.EARNING_INSTITUTION = 'earning:institution';
                TranslationConstants.EARNING_BALANCE_SHEET_DATE = 'earning:balance_sheet_date';
                TranslationConstants.EARNING_YEAR = 'earning:year';
                TranslationConstants.EARNING_STATUS = 'earning:status';
                TranslationConstants.EARNING_REMARKS = 'earning:remarks';
                TranslationConstants.PRINT_BOND_CONVERTABLE_SUBTITLE = 'print:bond_convertable_subtitle';
                TranslationConstants.PRINT_BOND_OPTION_SUBTITLE = 'print:bond_option_subtitle';
                TranslationConstants.PRINT_BOND_TITLE_CH = 'print:bond_title_ch';
                TranslationConstants.PRINT_BOND_TITLE_FC = 'print:bond_title_fc';
                TranslationConstants.PRINT_DERIVATIVE_COMBINEDPRODUCT_SUBTITLE_CH = 'print:derivative_combinedproduct_subtitle_ch';
                TranslationConstants.PRINT_DERIVATIVE_COMBINEDPRODUCT_SUBTITLE_FC = 'print:derivative_combinedproduct_subtitle_fc';
                TranslationConstants.PRINT_DERIVATIVE_FUNDSIMILARASSET_SUBTITLE_CH = 'print:derivative_fundsimilarasset_subtitle_ch';
                TranslationConstants.PRINT_DERIVATIVE_FUNDSIMILARASSET_SUBTITLE_FC = 'print:derivative_fundsimilarasset_subtitle_fc';
                TranslationConstants.PRINT_DERIVATIVE_INDEXBASKET_SUBTITLE_CH = 'print:derivative_indexbasket_subtitle_ch';
                TranslationConstants.PRINT_DERIVATIVE_INDEXBASKET_SUBTITLE_FC = 'print:derivative_indexbasket_subtitle_fc';
                TranslationConstants.PRINT_DERIVATIVE_TITLE = 'print:derivative_title';
                TranslationConstants.PRINT_FOREIGN = 'print:foreign';
                TranslationConstants.PRINT_FUND_TITLE_CH = 'print:fund_title_ch';
                TranslationConstants.PRINT_FUND_TITLE_FC = 'print:fund_title_fc';
                TranslationConstants.PRINT_SHARE_TITLE_CH = 'print:share_title_ch';
                TranslationConstants.PRINT_SHARE_TITLE_FC = 'print:share_title_fc';
                TranslationConstants.PRINT_SUISSE = 'print:suisse';
                TranslationConstants.EARNING_SECURITY_VALOR_NUMBER = 'earning_security:valor_number';
                TranslationConstants.EARNING_SECURITY_ISIN = 'earning_security:isin';
                TranslationConstants.EARNING_SECURITY_APPENDIX = 'earning_security:appendix';
                TranslationConstants.EARNING_SECURITY_SECURITY_TYPE = 'earning_security:security_type';
                TranslationConstants.EARNING_SECURITY_CURRENCY = 'earning_security:currency';
                TranslationConstants.EARNING_SECURITY_VALUE = 'earning_security:value';
                TranslationConstants.EARNING_SECURITY_EXCHANGE_RATE = 'earning_security:exchange_rate';
                TranslationConstants.EARNING_SECURITY_REMARKS = 'earning_security:remarks';
                TranslationConstants.EARNING_SECURITY_VALUE_CHF = 'earning_security:value_chf';
                TranslationConstants.GADGETS_REFERENCE_DATE = 'gadgets:reference_date';
                TranslationConstants.GADGETS_CURRENCY = 'gadgets:currency';
                TranslationConstants.GADGETS_EXCHANGE_RATE = 'gadgets:exchange_rate';
                TranslationConstants.GADGETS_COIN_BULLIONS = 'gadgets:coin_bullions';
                TranslationConstants.GADGETS_EXCHANGE_RATES = 'gadgets:exchange_rates';
                TranslationConstants.GADGETS_CAPITALIZATION_RATES = 'gadgets:capitalization_rates';
                TranslationConstants.GADGETS_INSTRUMENT_GROUP = 'gadgets:instrument_group';
                TranslationConstants.GADGETS_INSTRUMENT = 'gadgets:instrument';
                TranslationConstants.GADGETS_CALCULATOR = 'gadgets:calculator';
                TranslationConstants.GADGETS_INTEREST_RATE = 'gadgets:interest_rate';
                TranslationConstants.GADGETS_VALUE = 'gadgets:value';
                TranslationConstants.GADGETS_VALUE_IN_CHF = 'gadgets:value_in_chf';
                TranslationConstants.GADGETS_RECHERCHE = 'gadgets:recherche';
                TranslationConstants.GADGETS_START_DATE = 'gadgets:start_date';
                TranslationConstants.GADGETS_END_DATE = 'gadgets:end_date';
                TranslationConstants.GADGETS_DAY_COUNT_CONVENTION = 'gadgets:day_count_convention';
                TranslationConstants.GADGETS_DAY_COUNT = 'gadgets:day_count';
                TranslationConstants.GADGETS_LIBORSWAP = 'gadgets:liborswap';
                TranslationConstants.GADGETS_NOMINAL_VALUE = 'gadgets:nominal_value';
                TranslationConstants.GADGETS_PERIOD = 'gadgets:period';
                TranslationConstants.GADGETS_TOKEN = 'gadgets:token';
                TranslationConstants.GADGETS_TOKENS = 'gadgets:tokens';
                TranslationConstants.GADGETS_TOTAL_WORK_ORDER_COUNT = 'gadgets:total_work_order_count';
                TranslationConstants.GADGETS_WORK_ORDER_TYPE = 'gadgets:work_order_type';
                TranslationConstants.GADGETS_WORKORDERGADGET = 'gadgets:workordergadget';
                return TranslationConstants;
            }();
            exports_1("TranslationConstants", TranslationConstants);
        }
    };
});

System.register("ict-core-client/gen/viewmodels/capitalization_rate_gadget_view_model.js", ["ags-client/ags-client.js", "ict-core-client/gen/viewmodels/capitalization_rate_gadget_currency_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, ags_client_2, ags_client_3, capitalization_rate_gadget_currency_view_model_1, CapitalizationRateGadgetViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
        }, function (capitalization_rate_gadget_currency_view_model_1_1) {
            capitalization_rate_gadget_currency_view_model_1 = capitalization_rate_gadget_currency_view_model_1_1;
        }],
        execute: function () {
            CapitalizationRateGadgetViewModel = /** @class */function () {
                function CapitalizationRateGadgetViewModel() {}
                CapitalizationRateGadgetViewModel.deserialize = function (object) {
                    var _result = new CapitalizationRateGadgetViewModel();
                    return _result._deserialize(object);
                };
                CapitalizationRateGadgetViewModel.prototype._deserialize = function (object) {
                    var _this = this;
                    if (object) {
                        if (ags_client_1.isPresent(object['referenceDate'])) {
                            this.referenceDate = ags_client_3.deserializeDate(object['referenceDate']);
                        }
                        if (ags_client_1.isPresent(object['currencies'])) {
                            this.currencies = [];
                            object['currencies'].forEach(function (item) {
                                _this.currencies.push(capitalization_rate_gadget_currency_view_model_1.CapitalizationRateGadgetCurrencyViewModel.deserialize(item));
                            });
                        }
                    }
                    return this;
                };
                CapitalizationRateGadgetViewModel.prototype.serialize = function () {
                    var object = {};
                    if (ags_client_1.isPresent(this.referenceDate)) {
                        object['referenceDate'] = ags_client_2.serializeDate(this.referenceDate);
                    }
                    if (ags_client_1.isPresent(this.currencies)) {
                        object['currencies'] = [];
                        this.currencies.forEach(function (item) {
                            object['currencies'].push(item.serialize());
                        });
                    }
                    return object;
                };
                CapitalizationRateGadgetViewModel.REFERENCE_DATE_VALIDATORS = [];
                CapitalizationRateGadgetViewModel.CURRENCIES_VALIDATORS = [];
                return CapitalizationRateGadgetViewModel;
            }();
            exports_1("CapitalizationRateGadgetViewModel", CapitalizationRateGadgetViewModel);
        }
    };
});

System.register("ict-core-client/gen/viewmodels/capitalization_rate_gadget_currency_view_model.js", ["ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, ags_client_2, CapitalizationRateGadgetCurrencyViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
        }],
        execute: function () {
            CapitalizationRateGadgetCurrencyViewModel = /** @class */function () {
                function CapitalizationRateGadgetCurrencyViewModel() {}
                CapitalizationRateGadgetCurrencyViewModel.deserialize = function (object) {
                    var _result = new CapitalizationRateGadgetCurrencyViewModel();
                    return _result._deserialize(object);
                };
                CapitalizationRateGadgetCurrencyViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (ags_client_1.isPresent(object['currency'])) {
                            this.currency = new ags_client_2.Currency(object['currency']['shortName']);
                        }
                        if (ags_client_1.isPresent(object['value'])) {
                            this.value = object['value'];
                        }
                    }
                    return this;
                };
                CapitalizationRateGadgetCurrencyViewModel.prototype.serialize = function () {
                    var object = {};
                    if (ags_client_1.isPresent(this.currency)) {
                        object['currency'] = this.currency;
                    }
                    if (ags_client_1.isPresent(this.value)) {
                        object['value'] = this.value;
                    }
                    return object;
                };
                CapitalizationRateGadgetCurrencyViewModel.CURRENCY_VALIDATORS = [];
                CapitalizationRateGadgetCurrencyViewModel.VALUE_VALIDATORS = [];
                return CapitalizationRateGadgetCurrencyViewModel;
            }();
            exports_1("CapitalizationRateGadgetCurrencyViewModel", CapitalizationRateGadgetCurrencyViewModel);
        }
    };
});

System.register("ict-core-client/gen/viewmodels/coin_bullion_view_model.js", ["ags-client/ags-client.js", "ict-core-client/gen/viewmodels/language_string_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, language_string_view_model_1, ags_client_2, CoinBullionViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
        }, function (language_string_view_model_1_1) {
            language_string_view_model_1 = language_string_view_model_1_1;
        }],
        execute: function () {
            CoinBullionViewModel = /** @class */function () {
                function CoinBullionViewModel() {}
                CoinBullionViewModel.deserialize = function (object) {
                    var _result = new CoinBullionViewModel();
                    return _result._deserialize(object);
                };
                CoinBullionViewModel.prototype._deserialize = function (object) {
                    var _this = this;
                    if (object) {
                        if (ags_client_1.isPresent(object['name'])) {
                            this.name = [];
                            object['name'].forEach(function (item) {
                                _this.name.push(language_string_view_model_1.LanguageStringViewModel.deserialize(item));
                            });
                        }
                        if (ags_client_1.isPresent(object['unit'])) {
                            this.unit = [];
                            object['unit'].forEach(function (item) {
                                _this.unit.push(language_string_view_model_1.LanguageStringViewModel.deserialize(item));
                            });
                        }
                        if (ags_client_1.isPresent(object['value'])) {
                            this.value = object['value'];
                        }
                        if (ags_client_1.isPresent(object['currency'])) {
                            this.currency = new ags_client_2.Currency(object['currency']['shortName']);
                        }
                    }
                    return this;
                };
                CoinBullionViewModel.prototype.serialize = function () {
                    var object = {};
                    if (ags_client_1.isPresent(this.name)) {
                        object['name'] = [];
                        this.name.forEach(function (item) {
                            object['name'].push(item.serialize());
                        });
                    }
                    if (ags_client_1.isPresent(this.unit)) {
                        object['unit'] = [];
                        this.unit.forEach(function (item) {
                            object['unit'].push(item.serialize());
                        });
                    }
                    if (ags_client_1.isPresent(this.value)) {
                        object['value'] = this.value;
                    }
                    if (ags_client_1.isPresent(this.currency)) {
                        object['currency'] = this.currency;
                    }
                    return object;
                };
                CoinBullionViewModel.NAME_VALIDATORS = [];
                CoinBullionViewModel.UNIT_VALIDATORS = [];
                CoinBullionViewModel.VALUE_VALIDATORS = [];
                CoinBullionViewModel.CURRENCY_VALIDATORS = [];
                return CoinBullionViewModel;
            }();
            exports_1("CoinBullionViewModel", CoinBullionViewModel);
        }
    };
});

System.register("ict-core-client/gen/viewmodels/coinbullion_gadget_view_model.js", ["ags-client/ags-client.js", "ict-core-client/gen/viewmodels/coinbullion_gadget_instrument_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, ags_client_2, ags_client_3, coinbullion_gadget_instrument_view_model_1, CoinbullionGadgetViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
        }, function (coinbullion_gadget_instrument_view_model_1_1) {
            coinbullion_gadget_instrument_view_model_1 = coinbullion_gadget_instrument_view_model_1_1;
        }],
        execute: function () {
            CoinbullionGadgetViewModel = /** @class */function () {
                function CoinbullionGadgetViewModel() {}
                CoinbullionGadgetViewModel.deserialize = function (object) {
                    var _result = new CoinbullionGadgetViewModel();
                    return _result._deserialize(object);
                };
                CoinbullionGadgetViewModel.prototype._deserialize = function (object) {
                    var _this = this;
                    if (object) {
                        if (ags_client_1.isPresent(object['referenceDate'])) {
                            this.referenceDate = ags_client_3.deserializeDate(object['referenceDate']);
                        }
                        if (ags_client_1.isPresent(object['instruments'])) {
                            this.instruments = [];
                            object['instruments'].forEach(function (item) {
                                _this.instruments.push(coinbullion_gadget_instrument_view_model_1.CoinbullionGadgetInstrumentViewModel.deserialize(item));
                            });
                        }
                    }
                    return this;
                };
                CoinbullionGadgetViewModel.prototype.serialize = function () {
                    var object = {};
                    if (ags_client_1.isPresent(this.referenceDate)) {
                        object['referenceDate'] = ags_client_2.serializeDate(this.referenceDate);
                    }
                    if (ags_client_1.isPresent(this.instruments)) {
                        object['instruments'] = [];
                        this.instruments.forEach(function (item) {
                            object['instruments'].push(item.serialize());
                        });
                    }
                    return object;
                };
                CoinbullionGadgetViewModel.REFERENCE_DATE_VALIDATORS = [];
                CoinbullionGadgetViewModel.INSTRUMENTS_VALIDATORS = [];
                return CoinbullionGadgetViewModel;
            }();
            exports_1("CoinbullionGadgetViewModel", CoinbullionGadgetViewModel);
        }
    };
});

System.register("ict-core-client/gen/enums.js", [], function (exports_1, context_1) {
    "use strict";

    var SecurityCalculationType, InstrumentGadgetSearchTab, AccessAuthorizationType, AnnualReportRequested, BLOBMimeTypeSuffix, CalculationStatus, CapitalKey, CLOBMimeTypeSuffix, Continent, DARateType, DayCountConvention, DeliveryType, EarningDeclareStatus, EntityType, ExportStatus, Gadget, InstitutionMessageType, InstitutionPurpose, InstitutionRole, PredefinedInstitutionSearch, InstitutionStatus, InstrumentMessageType, PredefinedInstrumentSearch, InstrumentStatus, ImportStatus, IncomeType, IncreaseType, InstitutionRequestReason, InstitutionRequestStatus, InstrumentOrderReason, InstrumentOrderStatus, IrregularCoupon, LabelApplication, LabelCategory, LegalForm, LiborSwapPeriod, LogLevel, MimeTypeSuffix, Month, MessageType, MutationTarget, NotificationReason, NotificationStatus, NotificationType, OpenIssueType, OnlineMessage, PaymentFrequency, PaymentMessageType, PaymentStatus, PaymentType, PriorityType, PublicationCategory, PublicationDescription, PublicationType, QuotationType, Remark, RequestReason, RequestStatus, Schema, Sector, ServiceType, ShareholderType, STOLISPaymentType, StockExchangeRuleType, SystemMessageType, TargetGroup, TaxValueType, TaxEventType, TemplateType, ValuationStatus, ValuationOrderStatus, WeekDay, WeightUnit, WorkOrderMessageType, WorkOrderReason, WorkOrderType, WeekShortCutDay, Holder, Marketability, Maturity, Priority, SecuritySubType, SecurityType;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [],
        execute: function () {
            /**
             * generated by AGS
             */
            (function (SecurityCalculationType) {
                SecurityCalculationType[SecurityCalculationType["MODIFIED_DIFFERENTIAL_TAXATION"] = 0] = "MODIFIED_DIFFERENTIAL_TAXATION";
                SecurityCalculationType[SecurityCalculationType["PURE_DIFFERENTIAL_TAXATION"] = 1] = "PURE_DIFFERENTIAL_TAXATION";
                SecurityCalculationType[SecurityCalculationType["CONVERSION"] = 2] = "CONVERSION";
                SecurityCalculationType[SecurityCalculationType["NONE"] = 3] = "NONE";
            })(SecurityCalculationType || exports_1("SecurityCalculationType", SecurityCalculationType = {}));
            (function (InstrumentGadgetSearchTab) {
                InstrumentGadgetSearchTab[InstrumentGadgetSearchTab["SIMPLE_SEARCH"] = 0] = "SIMPLE_SEARCH";
                InstrumentGadgetSearchTab[InstrumentGadgetSearchTab["EXTENDED_SEARCH"] = 1] = "EXTENDED_SEARCH";
                InstrumentGadgetSearchTab[InstrumentGadgetSearchTab["RECHERCHE"] = 2] = "RECHERCHE";
            })(InstrumentGadgetSearchTab || exports_1("InstrumentGadgetSearchTab", InstrumentGadgetSearchTab = {}));
            (function (AccessAuthorizationType) {
                AccessAuthorizationType[AccessAuthorizationType["DOMAIN"] = 0] = "DOMAIN";
                AccessAuthorizationType[AccessAuthorizationType["GROUP"] = 1] = "GROUP";
                AccessAuthorizationType[AccessAuthorizationType["OWN"] = 2] = "OWN";
            })(AccessAuthorizationType || exports_1("AccessAuthorizationType", AccessAuthorizationType = {}));
            (function (AnnualReportRequested) {
                AnnualReportRequested[AnnualReportRequested["ESTV"] = 0] = "ESTV";
                AnnualReportRequested[AnnualReportRequested["REQUESTER"] = 1] = "REQUESTER";
            })(AnnualReportRequested || exports_1("AnnualReportRequested", AnnualReportRequested = {}));
            (function (BLOBMimeTypeSuffix) {
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["_WILDCARD"] = 0] = "_WILDCARD";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["ACX"] = 1] = "ACX";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["AI"] = 2] = "AI";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["AIF"] = 3] = "AIF";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["AIFC"] = 4] = "AIFC";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["AIFF"] = 5] = "AIFF";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["ASF"] = 6] = "ASF";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["ASR"] = 7] = "ASR";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["ASX"] = 8] = "ASX";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["AU"] = 9] = "AU";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["AVI"] = 10] = "AVI";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["AXS"] = 11] = "AXS";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["BCPIO"] = 12] = "BCPIO";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["BIN"] = 13] = "BIN";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["BMP"] = 14] = "BMP";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["CAT"] = 15] = "CAT";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["CDF"] = 16] = "CDF";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["CER"] = 17] = "CER";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["CLASS"] = 18] = "CLASS";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["CLP"] = 19] = "CLP";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["CMX"] = 20] = "CMX";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["COD"] = 21] = "COD";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["CPIO"] = 22] = "CPIO";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["CRD"] = 23] = "CRD";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["CRL"] = 24] = "CRL";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["CRT"] = 25] = "CRT";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["CSH"] = 26] = "CSH";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["DCR"] = 27] = "DCR";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["DER"] = 28] = "DER";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["DIR"] = 29] = "DIR";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["DLL"] = 30] = "DLL";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["DMS"] = 31] = "DMS";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["DOC"] = 32] = "DOC";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["DOCM"] = 33] = "DOCM";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["DOCX"] = 34] = "DOCX";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["DOT"] = 35] = "DOT";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["DOTX"] = 36] = "DOTX";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["DVI"] = 37] = "DVI";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["DXR"] = 38] = "DXR";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["EPS"] = 39] = "EPS";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["EVY"] = 40] = "EVY";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["EXE"] = 41] = "EXE";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["FIF"] = 42] = "FIF";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["FLR"] = 43] = "FLR";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["GIF"] = 44] = "GIF";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["GTAR"] = 45] = "GTAR";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["GZ"] = 46] = "GZ";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["HDF"] = 47] = "HDF";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["HLP"] = 48] = "HLP";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["HQX"] = 49] = "HQX";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["HTA"] = 50] = "HTA";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["ICO"] = 51] = "ICO";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["IEF"] = 52] = "IEF";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["III"] = 53] = "III";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["INS"] = 54] = "INS";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["ISP"] = 55] = "ISP";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["JFIF"] = 56] = "JFIF";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["JPE"] = 57] = "JPE";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["JPEG"] = 58] = "JPEG";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["JPG"] = 59] = "JPG";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["JS"] = 60] = "JS";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["LATEX"] = 61] = "LATEX";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["LHA"] = 62] = "LHA";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["LSF"] = 63] = "LSF";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["LSX"] = 64] = "LSX";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["LZH"] = 65] = "LZH";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["M13"] = 66] = "M13";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["M14"] = 67] = "M14";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["M3U"] = 68] = "M3U";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["MAN"] = 69] = "MAN";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["MDB"] = 70] = "MDB";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["ME"] = 71] = "ME";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["MHT"] = 72] = "MHT";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["MHTML"] = 73] = "MHTML";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["MID"] = 74] = "MID";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["MNY"] = 75] = "MNY";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["MOV"] = 76] = "MOV";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["MOVIE"] = 77] = "MOVIE";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["MP2"] = 78] = "MP2";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["MP3"] = 79] = "MP3";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["MPA"] = 80] = "MPA";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["MPE"] = 81] = "MPE";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["MPEG"] = 82] = "MPEG";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["MPG"] = 83] = "MPG";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["MPP"] = 84] = "MPP";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["MPV2"] = 85] = "MPV2";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["MS"] = 86] = "MS";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["MSG"] = 87] = "MSG";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["MVB"] = 88] = "MVB";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["NWS"] = 89] = "NWS";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["ODA"] = 90] = "ODA";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["P10"] = 91] = "P10";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["P12"] = 92] = "P12";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["P7B"] = 93] = "P7B";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["P7C"] = 94] = "P7C";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["P7M"] = 95] = "P7M";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["P7R"] = 96] = "P7R";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["P7S"] = 97] = "P7S";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["PBM"] = 98] = "PBM";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["PDF"] = 99] = "PDF";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["PFX"] = 100] = "PFX";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["PGM"] = 101] = "PGM";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["PKO"] = 102] = "PKO";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["PMA"] = 103] = "PMA";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["PMC"] = 104] = "PMC";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["PML"] = 105] = "PML";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["PMR"] = 106] = "PMR";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["PMW"] = 107] = "PMW";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["PNG"] = 108] = "PNG";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["PNM"] = 109] = "PNM";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["POT"] = 110] = "POT";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["POTM"] = 111] = "POTM";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["POTX"] = 112] = "POTX";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["PPAM"] = 113] = "PPAM";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["PPM"] = 114] = "PPM";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["PPS"] = 115] = "PPS";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["PPSM"] = 116] = "PPSM";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["PPSX"] = 117] = "PPSX";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["PPT"] = 118] = "PPT";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["PPTM"] = 119] = "PPTM";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["PPTX"] = 120] = "PPTX";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["PRF"] = 121] = "PRF";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["PS"] = 122] = "PS";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["PUB"] = 123] = "PUB";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["QDF"] = 124] = "QDF";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["QT"] = 125] = "QT";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["RA"] = 126] = "RA";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["RAM"] = 127] = "RAM";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["RAS"] = 128] = "RAS";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["RGB"] = 129] = "RGB";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["RMI"] = 130] = "RMI";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["ROFF"] = 131] = "ROFF";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["RTF"] = 132] = "RTF";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["SCD"] = 133] = "SCD";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["SETPAY"] = 134] = "SETPAY";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["SETREG"] = 135] = "SETREG";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["SH"] = 136] = "SH";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["SHAR"] = 137] = "SHAR";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["SIT"] = 138] = "SIT";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["SND"] = 139] = "SND";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["SPC"] = 140] = "SPC";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["SPL"] = 141] = "SPL";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["SRC"] = 142] = "SRC";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["SST"] = 143] = "SST";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["STL"] = 144] = "STL";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["SV4CPIO"] = 145] = "SV4CPIO";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["SV4CRC"] = 146] = "SV4CRC";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["T"] = 147] = "T";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["TAR"] = 148] = "TAR";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["TCL"] = 149] = "TCL";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["TEX"] = 150] = "TEX";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["TEXI"] = 151] = "TEXI";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["TEXINFO"] = 152] = "TEXINFO";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["TGZ"] = 153] = "TGZ";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["TIF"] = 154] = "TIF";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["TIFF"] = 155] = "TIFF";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["TR"] = 156] = "TR";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["TRM"] = 157] = "TRM";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["USTAR"] = 158] = "USTAR";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["VRML"] = 159] = "VRML";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["WAV"] = 160] = "WAV";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["WCM"] = 161] = "WCM";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["WDB"] = 162] = "WDB";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["WKS"] = 163] = "WKS";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["WMF"] = 164] = "WMF";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["WPS"] = 165] = "WPS";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["WRI"] = 166] = "WRI";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["WRL"] = 167] = "WRL";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["WRZ"] = 168] = "WRZ";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["XAF"] = 169] = "XAF";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["XBM"] = 170] = "XBM";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["XLA"] = 171] = "XLA";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["XLAM"] = 172] = "XLAM";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["XLC"] = 173] = "XLC";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["XLM"] = 174] = "XLM";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["XLS"] = 175] = "XLS";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["XLSB"] = 176] = "XLSB";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["XLSM"] = 177] = "XLSM";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["XLSX"] = 178] = "XLSX";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["XLT"] = 179] = "XLT";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["XLTM"] = 180] = "XLTM";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["XLTX"] = 181] = "XLTX";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["XLW"] = 182] = "XLW";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["XOF"] = 183] = "XOF";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["XPM"] = 184] = "XPM";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["XWD"] = 185] = "XWD";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["Z"] = 186] = "Z";
                BLOBMimeTypeSuffix[BLOBMimeTypeSuffix["ZIP"] = 187] = "ZIP";
            })(BLOBMimeTypeSuffix || exports_1("BLOBMimeTypeSuffix", BLOBMimeTypeSuffix = {}));
            (function (CalculationStatus) {
                CalculationStatus[CalculationStatus["APPROVED"] = 0] = "APPROVED";
                CalculationStatus[CalculationStatus["ASSIGNED"] = 1] = "ASSIGNED";
                CalculationStatus[CalculationStatus["CLOSED"] = 2] = "CLOSED";
                CalculationStatus[CalculationStatus["DEFERRED"] = 3] = "DEFERRED";
                CalculationStatus[CalculationStatus["DENIED"] = 4] = "DENIED";
                CalculationStatus[CalculationStatus["INQUIRY"] = 5] = "INQUIRY";
                CalculationStatus[CalculationStatus["OPEN"] = 6] = "OPEN";
                CalculationStatus[CalculationStatus["PROCESS"] = 7] = "PROCESS";
            })(CalculationStatus || exports_1("CalculationStatus", CalculationStatus = {}));
            (function (CapitalKey) {
                CapitalKey[CapitalKey["_1110"] = 0] = "_1110";
                CapitalKey[CapitalKey["_1111"] = 1] = "_1111";
                CapitalKey[CapitalKey["_1112"] = 2] = "_1112";
                CapitalKey[CapitalKey["_1113"] = 3] = "_1113";
                CapitalKey[CapitalKey["_1114"] = 4] = "_1114";
                CapitalKey[CapitalKey["_1120"] = 5] = "_1120";
                CapitalKey[CapitalKey["_1121"] = 6] = "_1121";
                CapitalKey[CapitalKey["_1122"] = 7] = "_1122";
                CapitalKey[CapitalKey["_1123"] = 8] = "_1123";
                CapitalKey[CapitalKey["_1124"] = 9] = "_1124";
                CapitalKey[CapitalKey["_1130"] = 10] = "_1130";
                CapitalKey[CapitalKey["_1140"] = 11] = "_1140";
                CapitalKey[CapitalKey["_1150"] = 12] = "_1150";
                CapitalKey[CapitalKey["_1210"] = 13] = "_1210";
                CapitalKey[CapitalKey["_1220"] = 14] = "_1220";
                CapitalKey[CapitalKey["_1230"] = 15] = "_1230";
                CapitalKey[CapitalKey["_1240"] = 16] = "_1240";
                CapitalKey[CapitalKey["_1250"] = 17] = "_1250";
                CapitalKey[CapitalKey["_1310"] = 18] = "_1310";
                CapitalKey[CapitalKey["_1320"] = 19] = "_1320";
                CapitalKey[CapitalKey["_1330"] = 20] = "_1330";
                CapitalKey[CapitalKey["_1340"] = 21] = "_1340";
                CapitalKey[CapitalKey["_1350"] = 22] = "_1350";
                CapitalKey[CapitalKey["_1410"] = 23] = "_1410";
                CapitalKey[CapitalKey["_1420"] = 24] = "_1420";
                CapitalKey[CapitalKey["_1430"] = 25] = "_1430";
                CapitalKey[CapitalKey["_1440"] = 26] = "_1440";
                CapitalKey[CapitalKey["_1510"] = 27] = "_1510";
                CapitalKey[CapitalKey["_1520"] = 28] = "_1520";
                CapitalKey[CapitalKey["_1530"] = 29] = "_1530";
                CapitalKey[CapitalKey["_1540"] = 30] = "_1540";
                CapitalKey[CapitalKey["_1610"] = 31] = "_1610";
                CapitalKey[CapitalKey["_1620"] = 32] = "_1620";
                CapitalKey[CapitalKey["_1630"] = 33] = "_1630";
                CapitalKey[CapitalKey["_1640"] = 34] = "_1640";
                CapitalKey[CapitalKey["_1710"] = 35] = "_1710";
                CapitalKey[CapitalKey["_1720"] = 36] = "_1720";
                CapitalKey[CapitalKey["_1730"] = 37] = "_1730";
                CapitalKey[CapitalKey["_1740"] = 38] = "_1740";
                CapitalKey[CapitalKey["_1750"] = 39] = "_1750";
                CapitalKey[CapitalKey["_1810"] = 40] = "_1810";
                CapitalKey[CapitalKey["_1820"] = 41] = "_1820";
                CapitalKey[CapitalKey["_1830"] = 42] = "_1830";
                CapitalKey[CapitalKey["_1840"] = 43] = "_1840";
                CapitalKey[CapitalKey["_1850"] = 44] = "_1850";
                CapitalKey[CapitalKey["_2110"] = 45] = "_2110";
                CapitalKey[CapitalKey["_2120"] = 46] = "_2120";
                CapitalKey[CapitalKey["_2130"] = 47] = "_2130";
                CapitalKey[CapitalKey["_2140"] = 48] = "_2140";
                CapitalKey[CapitalKey["_2150"] = 49] = "_2150";
                CapitalKey[CapitalKey["_2210"] = 50] = "_2210";
                CapitalKey[CapitalKey["_2220"] = 51] = "_2220";
                CapitalKey[CapitalKey["_2230"] = 52] = "_2230";
                CapitalKey[CapitalKey["_2240"] = 53] = "_2240";
                CapitalKey[CapitalKey["_2250"] = 54] = "_2250";
                CapitalKey[CapitalKey["_2310"] = 55] = "_2310";
                CapitalKey[CapitalKey["_2320"] = 56] = "_2320";
                CapitalKey[CapitalKey["_2330"] = 57] = "_2330";
                CapitalKey[CapitalKey["_2340"] = 58] = "_2340";
                CapitalKey[CapitalKey["_2350"] = 59] = "_2350";
                CapitalKey[CapitalKey["_2410"] = 60] = "_2410";
                CapitalKey[CapitalKey["_2420"] = 61] = "_2420";
                CapitalKey[CapitalKey["_2430"] = 62] = "_2430";
                CapitalKey[CapitalKey["_2440"] = 63] = "_2440";
                CapitalKey[CapitalKey["_2450"] = 64] = "_2450";
                CapitalKey[CapitalKey["_2520"] = 65] = "_2520";
                CapitalKey[CapitalKey["_2710"] = 66] = "_2710";
                CapitalKey[CapitalKey["_2720"] = 67] = "_2720";
                CapitalKey[CapitalKey["_2730"] = 68] = "_2730";
                CapitalKey[CapitalKey["_2740"] = 69] = "_2740";
                CapitalKey[CapitalKey["_2750"] = 70] = "_2750";
                CapitalKey[CapitalKey["_2810"] = 71] = "_2810";
                CapitalKey[CapitalKey["_2820"] = 72] = "_2820";
                CapitalKey[CapitalKey["_2830"] = 73] = "_2830";
                CapitalKey[CapitalKey["_2840"] = 74] = "_2840";
                CapitalKey[CapitalKey["_2850"] = 75] = "_2850";
                CapitalKey[CapitalKey["_3110"] = 76] = "_3110";
                CapitalKey[CapitalKey["_3120"] = 77] = "_3120";
                CapitalKey[CapitalKey["_3150"] = 78] = "_3150";
                CapitalKey[CapitalKey["_3750"] = 79] = "_3750";
                CapitalKey[CapitalKey["_4110"] = 80] = "_4110";
                CapitalKey[CapitalKey["_4120"] = 81] = "_4120";
                CapitalKey[CapitalKey["_4130"] = 82] = "_4130";
                CapitalKey[CapitalKey["_4140"] = 83] = "_4140";
                CapitalKey[CapitalKey["_4150"] = 84] = "_4150";
                CapitalKey[CapitalKey["_4210"] = 85] = "_4210";
                CapitalKey[CapitalKey["_4220"] = 86] = "_4220";
                CapitalKey[CapitalKey["_4230"] = 87] = "_4230";
                CapitalKey[CapitalKey["_4240"] = 88] = "_4240";
                CapitalKey[CapitalKey["_4250"] = 89] = "_4250";
                CapitalKey[CapitalKey["_4410"] = 90] = "_4410";
                CapitalKey[CapitalKey["_4420"] = 91] = "_4420";
                CapitalKey[CapitalKey["_4430"] = 92] = "_4430";
                CapitalKey[CapitalKey["_4440"] = 93] = "_4440";
                CapitalKey[CapitalKey["_4450"] = 94] = "_4450";
                CapitalKey[CapitalKey["_4510"] = 95] = "_4510";
                CapitalKey[CapitalKey["_4520"] = 96] = "_4520";
                CapitalKey[CapitalKey["_4530"] = 97] = "_4530";
                CapitalKey[CapitalKey["_4540"] = 98] = "_4540";
                CapitalKey[CapitalKey["_4550"] = 99] = "_4550";
                CapitalKey[CapitalKey["_5110"] = 100] = "_5110";
                CapitalKey[CapitalKey["_5111"] = 101] = "_5111";
                CapitalKey[CapitalKey["_5112"] = 102] = "_5112";
                CapitalKey[CapitalKey["_5113"] = 103] = "_5113";
                CapitalKey[CapitalKey["_5114"] = 104] = "_5114";
                CapitalKey[CapitalKey["_5120"] = 105] = "_5120";
                CapitalKey[CapitalKey["_5121"] = 106] = "_5121";
                CapitalKey[CapitalKey["_5122"] = 107] = "_5122";
                CapitalKey[CapitalKey["_5123"] = 108] = "_5123";
                CapitalKey[CapitalKey["_5124"] = 109] = "_5124";
                CapitalKey[CapitalKey["_5130"] = 110] = "_5130";
                CapitalKey[CapitalKey["_5140"] = 111] = "_5140";
                CapitalKey[CapitalKey["_5150"] = 112] = "_5150";
                CapitalKey[CapitalKey["_5410"] = 113] = "_5410";
                CapitalKey[CapitalKey["_5420"] = 114] = "_5420";
                CapitalKey[CapitalKey["_5430"] = 115] = "_5430";
                CapitalKey[CapitalKey["_5440"] = 116] = "_5440";
                CapitalKey[CapitalKey["_5450"] = 117] = "_5450";
                CapitalKey[CapitalKey["_5520"] = 118] = "_5520";
                CapitalKey[CapitalKey["_6110"] = 119] = "_6110";
                CapitalKey[CapitalKey["_6120"] = 120] = "_6120";
                CapitalKey[CapitalKey["_8110"] = 121] = "_8110";
                CapitalKey[CapitalKey["_8120"] = 122] = "_8120";
                CapitalKey[CapitalKey["_8150"] = 123] = "_8150";
            })(CapitalKey || exports_1("CapitalKey", CapitalKey = {}));
            (function (CLOBMimeTypeSuffix) {
                CLOBMimeTypeSuffix[CLOBMimeTypeSuffix["_323"] = 0] = "_323";
                CLOBMimeTypeSuffix[CLOBMimeTypeSuffix["BAS"] = 1] = "BAS";
                CLOBMimeTypeSuffix[CLOBMimeTypeSuffix["C"] = 2] = "C";
                CLOBMimeTypeSuffix[CLOBMimeTypeSuffix["CSS"] = 3] = "CSS";
                CLOBMimeTypeSuffix[CLOBMimeTypeSuffix["CSV"] = 4] = "CSV";
                CLOBMimeTypeSuffix[CLOBMimeTypeSuffix["ETX"] = 5] = "ETX";
                CLOBMimeTypeSuffix[CLOBMimeTypeSuffix["H"] = 6] = "H";
                CLOBMimeTypeSuffix[CLOBMimeTypeSuffix["HTC"] = 7] = "HTC";
                CLOBMimeTypeSuffix[CLOBMimeTypeSuffix["HTM"] = 8] = "HTM";
                CLOBMimeTypeSuffix[CLOBMimeTypeSuffix["HTML"] = 9] = "HTML";
                CLOBMimeTypeSuffix[CLOBMimeTypeSuffix["HTT"] = 10] = "HTT";
                CLOBMimeTypeSuffix[CLOBMimeTypeSuffix["RTX"] = 11] = "RTX";
                CLOBMimeTypeSuffix[CLOBMimeTypeSuffix["SCT"] = 12] = "SCT";
                CLOBMimeTypeSuffix[CLOBMimeTypeSuffix["STM"] = 13] = "STM";
                CLOBMimeTypeSuffix[CLOBMimeTypeSuffix["TSV"] = 14] = "TSV";
                CLOBMimeTypeSuffix[CLOBMimeTypeSuffix["TXT"] = 15] = "TXT";
                CLOBMimeTypeSuffix[CLOBMimeTypeSuffix["ULS"] = 16] = "ULS";
                CLOBMimeTypeSuffix[CLOBMimeTypeSuffix["VCF"] = 17] = "VCF";
                CLOBMimeTypeSuffix[CLOBMimeTypeSuffix["XML"] = 18] = "XML";
                CLOBMimeTypeSuffix[CLOBMimeTypeSuffix["XSD"] = 19] = "XSD";
            })(CLOBMimeTypeSuffix || exports_1("CLOBMimeTypeSuffix", CLOBMimeTypeSuffix = {}));
            (function (Continent) {
                Continent[Continent["AF"] = 0] = "AF";
                Continent[Continent["AN"] = 1] = "AN";
                Continent[Continent["AS"] = 2] = "AS";
                Continent[Continent["EU"] = 3] = "EU";
                Continent[Continent["NA"] = 4] = "NA";
                Continent[Continent["OC"] = 5] = "OC";
                Continent[Continent["SA"] = 6] = "SA";
            })(Continent || exports_1("Continent", Continent = {}));
            (function (DARateType) {
                DARateType[DARateType["_10_PERCENT_POS"] = 0] = "_10_PERCENT_POS";
                DARateType[DARateType["_10_PERCENT_POS_1Y"] = 1] = "_10_PERCENT_POS_1Y";
                DARateType[DARateType["_10_PERCENT_POS_2Y"] = 2] = "_10_PERCENT_POS_2Y";
                DARateType[DARateType["_20_PERCENT_POS"] = 3] = "_20_PERCENT_POS";
                DARateType[DARateType["_20_PERCENT_POS_1Y"] = 4] = "_20_PERCENT_POS_1Y";
                DARateType[DARateType["_20_PERCENT_POS_2Y"] = 5] = "_20_PERCENT_POS_2Y";
                DARateType[DARateType["_25_PERCENT_POS"] = 6] = "_25_PERCENT_POS";
                DARateType[DARateType["_25_PERCENT_POS_1Y"] = 7] = "_25_PERCENT_POS_1Y";
                DARateType[DARateType["_25_PERCENT_POS_2Y"] = 8] = "_25_PERCENT_POS_2Y";
                DARateType[DARateType["_50_PERCENT_POS"] = 9] = "_50_PERCENT_POS";
                DARateType[DARateType["_50_PERCENT_POS_1Y"] = 10] = "_50_PERCENT_POS_1Y";
                DARateType[DARateType["_50_PERCENT_POS_2Y"] = 11] = "_50_PERCENT_POS_2Y";
                DARateType[DARateType["LP"] = 12] = "LP";
                DARateType[DARateType["LP_10_PERCENT_POS"] = 13] = "LP_10_PERCENT_POS";
                DARateType[DARateType["LP_20_PERCENT_POS"] = 14] = "LP_20_PERCENT_POS";
                DARateType[DARateType["LP_25_PERCENT_POS"] = 15] = "LP_25_PERCENT_POS";
                DARateType[DARateType["LP_50_PERCENT_POS"] = 16] = "LP_50_PERCENT_POS";
                DARateType[DARateType["OTHER"] = 17] = "OTHER";
                DARateType[DARateType["RPF"] = 18] = "RPF";
                DARateType[DARateType["RPF_10_PERCENT_POS"] = 19] = "RPF_10_PERCENT_POS";
                DARateType[DARateType["RPF_20_PERCENT_POS"] = 20] = "RPF_20_PERCENT_POS";
                DARateType[DARateType["RPF_25_PERCENT_POS"] = 21] = "RPF_25_PERCENT_POS";
                DARateType[DARateType["RPF_50_PERCENT_POS"] = 22] = "RPF_50_PERCENT_POS";
            })(DARateType || exports_1("DARateType", DARateType = {}));
            (function (DayCountConvention) {
                DayCountConvention[DayCountConvention["_30_360"] = 0] = "_30_360";
                DayCountConvention[DayCountConvention["_30E_360"] = 1] = "_30E_360";
                DayCountConvention[DayCountConvention["ACT_360"] = 2] = "ACT_360";
                DayCountConvention[DayCountConvention["ACT_365"] = 3] = "ACT_365";
                DayCountConvention[DayCountConvention["ACT_365L"] = 4] = "ACT_365L";
                DayCountConvention[DayCountConvention["ACT_ACT"] = 5] = "ACT_ACT";
            })(DayCountConvention || exports_1("DayCountConvention", DayCountConvention = {}));
            (function (DeliveryType) {
                DeliveryType[DeliveryType["ONCE"] = 0] = "ONCE";
                DeliveryType[DeliveryType["REGULAR"] = 1] = "REGULAR";
            })(DeliveryType || exports_1("DeliveryType", DeliveryType = {}));
            (function (EarningDeclareStatus) {
                EarningDeclareStatus[EarningDeclareStatus["CLOSED"] = 0] = "CLOSED";
                EarningDeclareStatus[EarningDeclareStatus["DENIED"] = 1] = "DENIED";
                EarningDeclareStatus[EarningDeclareStatus["OPEN"] = 2] = "OPEN";
            })(EarningDeclareStatus || exports_1("EarningDeclareStatus", EarningDeclareStatus = {}));
            (function (EntityType) {
                EntityType[EntityType["INSTITUTION"] = 0] = "INSTITUTION";
                EntityType[EntityType["INSTRUMENT"] = 1] = "INSTRUMENT";
            })(EntityType || exports_1("EntityType", EntityType = {}));
            (function (ExportStatus) {
                ExportStatus[ExportStatus["CLOSED"] = 0] = "CLOSED";
                ExportStatus[ExportStatus["ERROR"] = 1] = "ERROR";
                ExportStatus[ExportStatus["OPEN"] = 2] = "OPEN";
                ExportStatus[ExportStatus["PROCESS"] = 3] = "PROCESS";
                ExportStatus[ExportStatus["VALIDATE"] = 4] = "VALIDATE";
            })(ExportStatus || exports_1("ExportStatus", ExportStatus = {}));
            (function (Gadget) {
                Gadget[Gadget["CALCULATOR"] = 0] = "CALCULATOR";
                Gadget[Gadget["COINBULLION"] = 1] = "COINBULLION";
                Gadget[Gadget["CURRENCYNOTE"] = 2] = "CURRENCYNOTE";
                Gadget[Gadget["INSTRUMENT"] = 3] = "INSTRUMENT";
                Gadget[Gadget["LIBORSWAP"] = 4] = "LIBORSWAP";
                Gadget[Gadget["OPENISSUE"] = 5] = "OPENISSUE";
                Gadget[Gadget["WORKORDER"] = 6] = "WORKORDER";
            })(Gadget || exports_1("Gadget", Gadget = {}));
            (function (InstitutionMessageType) {
                InstitutionMessageType[InstitutionMessageType["_400"] = 0] = "_400";
                InstitutionMessageType[InstitutionMessageType["_481"] = 1] = "_481";
            })(InstitutionMessageType || exports_1("InstitutionMessageType", InstitutionMessageType = {}));
            (function (InstitutionPurpose) {
                InstitutionPurpose[InstitutionPurpose["COOPERATIVE"] = 0] = "COOPERATIVE";
                InstitutionPurpose[InstitutionPurpose["CORPORATION"] = 1] = "CORPORATION";
                InstitutionPurpose[InstitutionPurpose["DOMICILIARY"] = 2] = "DOMICILIARY";
                InstitutionPurpose[InstitutionPurpose["HOLDING"] = 3] = "HOLDING";
                InstitutionPurpose[InstitutionPurpose["REALESTATE"] = 4] = "REALESTATE";
                InstitutionPurpose[InstitutionPurpose["REALESTATEINCOME"] = 5] = "REALESTATEINCOME";
                InstitutionPurpose[InstitutionPurpose["TRADING"] = 6] = "TRADING";
            })(InstitutionPurpose || exports_1("InstitutionPurpose", InstitutionPurpose = {}));
            (function (InstitutionRole) {
                InstitutionRole[InstitutionRole["ADMINISTRATOR"] = 0] = "ADMINISTRATOR";
                InstitutionRole[InstitutionRole["AUDITOR"] = 1] = "AUDITOR";
                InstitutionRole[InstitutionRole["DEPOSITARYBANK"] = 2] = "DEPOSITARYBANK";
                InstitutionRole[InstitutionRole["FUNDMANAGEMENT"] = 3] = "FUNDMANAGEMENT";
                InstitutionRole[InstitutionRole["UMBRELLA"] = 4] = "UMBRELLA";
            })(InstitutionRole || exports_1("InstitutionRole", InstitutionRole = {}));
            (function (PredefinedInstitutionSearch) {
                PredefinedInstitutionSearch[PredefinedInstitutionSearch["_1"] = 0] = "_1";
                PredefinedInstitutionSearch[PredefinedInstitutionSearch["_2"] = 1] = "_2";
                PredefinedInstitutionSearch[PredefinedInstitutionSearch["_3"] = 2] = "_3";
                PredefinedInstitutionSearch[PredefinedInstitutionSearch["_4"] = 3] = "_4";
            })(PredefinedInstitutionSearch || exports_1("PredefinedInstitutionSearch", PredefinedInstitutionSearch = {}));
            (function (InstitutionStatus) {
                InstitutionStatus[InstitutionStatus["ACTIVE"] = 0] = "ACTIVE";
                InstitutionStatus[InstitutionStatus["INACTIVE"] = 1] = "INACTIVE";
                InstitutionStatus[InstitutionStatus["INFOUNDATION"] = 2] = "INFOUNDATION";
                InstitutionStatus[InstitutionStatus["INLIQUIDATION"] = 3] = "INLIQUIDATION";
                InstitutionStatus[InstitutionStatus["NEWFOUNDATIONBYCONVERSION"] = 4] = "NEWFOUNDATIONBYCONVERSION";
            })(InstitutionStatus || exports_1("InstitutionStatus", InstitutionStatus = {}));
            (function (InstrumentMessageType) {
                InstrumentMessageType[InstrumentMessageType["_230"] = 0] = "_230";
                InstrumentMessageType[InstrumentMessageType["_237"] = 1] = "_237";
                InstrumentMessageType[InstrumentMessageType["_238"] = 2] = "_238";
                InstrumentMessageType[InstrumentMessageType["_242"] = 3] = "_242";
                InstrumentMessageType[InstrumentMessageType["_252"] = 4] = "_252";
                InstrumentMessageType[InstrumentMessageType["_278"] = 5] = "_278";
                InstrumentMessageType[InstrumentMessageType["_297"] = 6] = "_297";
                InstrumentMessageType[InstrumentMessageType["_298"] = 7] = "_298";
                InstrumentMessageType[InstrumentMessageType["_379"] = 8] = "_379";
                InstrumentMessageType[InstrumentMessageType["_380"] = 9] = "_380";
                InstrumentMessageType[InstrumentMessageType["_381"] = 10] = "_381";
                InstrumentMessageType[InstrumentMessageType["_383"] = 11] = "_383";
                InstrumentMessageType[InstrumentMessageType["_387"] = 12] = "_387";
                InstrumentMessageType[InstrumentMessageType["_388"] = 13] = "_388";
                InstrumentMessageType[InstrumentMessageType["_400"] = 14] = "_400";
                InstrumentMessageType[InstrumentMessageType["_401"] = 15] = "_401";
                InstrumentMessageType[InstrumentMessageType["_403"] = 16] = "_403";
                InstrumentMessageType[InstrumentMessageType["_413"] = 17] = "_413";
                InstrumentMessageType[InstrumentMessageType["_414"] = 18] = "_414";
                InstrumentMessageType[InstrumentMessageType["_440"] = 19] = "_440";
                InstrumentMessageType[InstrumentMessageType["_451"] = 20] = "_451";
                InstrumentMessageType[InstrumentMessageType["_461"] = 21] = "_461";
                InstrumentMessageType[InstrumentMessageType["_462"] = 22] = "_462";
                InstrumentMessageType[InstrumentMessageType["_488"] = 23] = "_488";
                InstrumentMessageType[InstrumentMessageType["_490"] = 24] = "_490";
                InstrumentMessageType[InstrumentMessageType["_495"] = 25] = "_495";
                InstrumentMessageType[InstrumentMessageType["_550"] = 26] = "_550";
                InstrumentMessageType[InstrumentMessageType["_598"] = 27] = "_598";
                InstrumentMessageType[InstrumentMessageType["_650"] = 28] = "_650";
                InstrumentMessageType[InstrumentMessageType["_670"] = 29] = "_670";
            })(InstrumentMessageType || exports_1("InstrumentMessageType", InstrumentMessageType = {}));
            (function (PredefinedInstrumentSearch) {
                PredefinedInstrumentSearch[PredefinedInstrumentSearch["_1"] = 0] = "_1";
                PredefinedInstrumentSearch[PredefinedInstrumentSearch["_10"] = 1] = "_10";
                PredefinedInstrumentSearch[PredefinedInstrumentSearch["_11"] = 2] = "_11";
                PredefinedInstrumentSearch[PredefinedInstrumentSearch["_12"] = 3] = "_12";
                PredefinedInstrumentSearch[PredefinedInstrumentSearch["_13"] = 4] = "_13";
                PredefinedInstrumentSearch[PredefinedInstrumentSearch["_14"] = 5] = "_14";
                PredefinedInstrumentSearch[PredefinedInstrumentSearch["_15"] = 6] = "_15";
                PredefinedInstrumentSearch[PredefinedInstrumentSearch["_16"] = 7] = "_16";
                PredefinedInstrumentSearch[PredefinedInstrumentSearch["_17"] = 8] = "_17";
                PredefinedInstrumentSearch[PredefinedInstrumentSearch["_18"] = 9] = "_18";
                PredefinedInstrumentSearch[PredefinedInstrumentSearch["_19"] = 10] = "_19";
                PredefinedInstrumentSearch[PredefinedInstrumentSearch["_2"] = 11] = "_2";
                PredefinedInstrumentSearch[PredefinedInstrumentSearch["_20"] = 12] = "_20";
                PredefinedInstrumentSearch[PredefinedInstrumentSearch["_21"] = 13] = "_21";
                PredefinedInstrumentSearch[PredefinedInstrumentSearch["_22"] = 14] = "_22";
                PredefinedInstrumentSearch[PredefinedInstrumentSearch["_23"] = 15] = "_23";
                PredefinedInstrumentSearch[PredefinedInstrumentSearch["_3"] = 16] = "_3";
                PredefinedInstrumentSearch[PredefinedInstrumentSearch["_4"] = 17] = "_4";
                PredefinedInstrumentSearch[PredefinedInstrumentSearch["_5"] = 18] = "_5";
                PredefinedInstrumentSearch[PredefinedInstrumentSearch["_6"] = 19] = "_6";
                PredefinedInstrumentSearch[PredefinedInstrumentSearch["_7"] = 20] = "_7";
                PredefinedInstrumentSearch[PredefinedInstrumentSearch["_8"] = 21] = "_8";
                PredefinedInstrumentSearch[PredefinedInstrumentSearch["_9"] = 22] = "_9";
            })(PredefinedInstrumentSearch || exports_1("PredefinedInstrumentSearch", PredefinedInstrumentSearch = {}));
            (function (InstrumentStatus) {
                InstrumentStatus[InstrumentStatus["ACTIVE"] = 0] = "ACTIVE";
                InstrumentStatus[InstrumentStatus["INACTIVE"] = 1] = "INACTIVE";
                InstrumentStatus[InstrumentStatus["INDEFAULT"] = 2] = "INDEFAULT";
                InstrumentStatus[InstrumentStatus["INLIQUIDATION"] = 3] = "INLIQUIDATION";
            })(InstrumentStatus || exports_1("InstrumentStatus", InstrumentStatus = {}));
            (function (ImportStatus) {
                ImportStatus[ImportStatus["CLOSED"] = 0] = "CLOSED";
                ImportStatus[ImportStatus["ERROR"] = 1] = "ERROR";
                ImportStatus[ImportStatus["OPEN"] = 2] = "OPEN";
                ImportStatus[ImportStatus["PROCESS"] = 3] = "PROCESS";
            })(ImportStatus || exports_1("ImportStatus", ImportStatus = {}));
            (function (IncomeType) {
                IncomeType[IncomeType["DIVIDEND"] = 0] = "DIVIDEND";
                IncomeType[IncomeType["INTEREST"] = 1] = "INTEREST";
                IncomeType[IncomeType["MIXED"] = 2] = "MIXED";
            })(IncomeType || exports_1("IncomeType", IncomeType = {}));
            (function (IncreaseType) {
                IncreaseType[IncreaseType["BASIS"] = 0] = "BASIS";
                IncreaseType[IncreaseType["INCREASE"] = 1] = "INCREASE";
            })(IncreaseType || exports_1("IncreaseType", IncreaseType = {}));
            (function (InstitutionRequestReason) {
                InstitutionRequestReason[InstitutionRequestReason["ADDRESS"] = 0] = "ADDRESS";
                InstitutionRequestReason[InstitutionRequestReason["CAPITAL"] = 1] = "CAPITAL";
                InstitutionRequestReason[InstitutionRequestReason["NAME"] = 2] = "NAME";
                InstitutionRequestReason[InstitutionRequestReason["OTHER"] = 3] = "OTHER";
                InstitutionRequestReason[InstitutionRequestReason["PAYMENT"] = 4] = "PAYMENT";
                InstitutionRequestReason[InstitutionRequestReason["PUBLICATION"] = 5] = "PUBLICATION";
            })(InstitutionRequestReason || exports_1("InstitutionRequestReason", InstitutionRequestReason = {}));
            (function (InstitutionRequestStatus) {
                InstitutionRequestStatus[InstitutionRequestStatus["APPROVED"] = 0] = "APPROVED";
                InstitutionRequestStatus[InstitutionRequestStatus["ASSIGNED"] = 1] = "ASSIGNED";
                InstitutionRequestStatus[InstitutionRequestStatus["CLOSED"] = 2] = "CLOSED";
                InstitutionRequestStatus[InstitutionRequestStatus["DEFERRED"] = 3] = "DEFERRED";
                InstitutionRequestStatus[InstitutionRequestStatus["DENIED"] = 4] = "DENIED";
                InstitutionRequestStatus[InstitutionRequestStatus["INQUIRY"] = 5] = "INQUIRY";
                InstitutionRequestStatus[InstitutionRequestStatus["OPEN"] = 6] = "OPEN";
                InstitutionRequestStatus[InstitutionRequestStatus["PROCESS"] = 7] = "PROCESS";
            })(InstitutionRequestStatus || exports_1("InstitutionRequestStatus", InstitutionRequestStatus = {}));
            (function (InstrumentOrderReason) {
                InstrumentOrderReason[InstrumentOrderReason["BFP"] = 0] = "BFP";
                InstrumentOrderReason[InstrumentOrderReason["FLASH"] = 1] = "FLASH";
                InstrumentOrderReason[InstrumentOrderReason["FUND"] = 2] = "FUND";
                InstrumentOrderReason[InstrumentOrderReason["IMPORT"] = 3] = "IMPORT";
                InstrumentOrderReason[InstrumentOrderReason["MANUAL"] = 4] = "MANUAL";
                InstrumentOrderReason[InstrumentOrderReason["NONQUOTED"] = 5] = "NONQUOTED";
                InstrumentOrderReason[InstrumentOrderReason["OTHERQUOTED"] = 6] = "OTHERQUOTED";
                InstrumentOrderReason[InstrumentOrderReason["PUBREQ"] = 7] = "PUBREQ";
            })(InstrumentOrderReason || exports_1("InstrumentOrderReason", InstrumentOrderReason = {}));
            (function (InstrumentOrderStatus) {
                InstrumentOrderStatus[InstrumentOrderStatus["CLOSED"] = 0] = "CLOSED";
                InstrumentOrderStatus[InstrumentOrderStatus["DEFERRED"] = 1] = "DEFERRED";
                InstrumentOrderStatus[InstrumentOrderStatus["DENIED"] = 2] = "DENIED";
                InstrumentOrderStatus[InstrumentOrderStatus["OPEN"] = 3] = "OPEN";
            })(InstrumentOrderStatus || exports_1("InstrumentOrderStatus", InstrumentOrderStatus = {}));
            (function (IrregularCoupon) {
                IrregularCoupon[IrregularCoupon["LONG"] = 0] = "LONG";
                IrregularCoupon[IrregularCoupon["SHORT"] = 1] = "SHORT";
            })(IrregularCoupon || exports_1("IrregularCoupon", IrregularCoupon = {}));
            (function (LabelApplication) {
                LabelApplication[LabelApplication["AGS"] = 0] = "AGS";
                LabelApplication[LabelApplication["EWS"] = 1] = "EWS";
                LabelApplication[LabelApplication["EWS_MAILS"] = 2] = "EWS_MAILS";
                LabelApplication[LabelApplication["ICT_CORE"] = 3] = "ICT_CORE";
                LabelApplication[LabelApplication["ICT_EXTERN"] = 4] = "ICT_EXTERN";
                LabelApplication[LabelApplication["ICT_INTERN"] = 5] = "ICT_INTERN";
                LabelApplication[LabelApplication["ICT_MAILS"] = 6] = "ICT_MAILS";
            })(LabelApplication || exports_1("LabelApplication", LabelApplication = {}));
            (function (LabelCategory) {
                LabelCategory[LabelCategory["ACCOUNT"] = 0] = "ACCOUNT";
                LabelCategory[LabelCategory["ATTACHMENTS"] = 1] = "ATTACHMENTS";
                LabelCategory[LabelCategory["AUTHENTICATION"] = 2] = "AUTHENTICATION";
                LabelCategory[LabelCategory["BUTTON"] = 3] = "BUTTON";
                LabelCategory[LabelCategory["CALCULATION"] = 4] = "CALCULATION";
                LabelCategory[LabelCategory["CAPTCHA"] = 5] = "CAPTCHA";
                LabelCategory[LabelCategory["CHANGE_PASSWORD"] = 6] = "CHANGE_PASSWORD";
                LabelCategory[LabelCategory["CODE"] = 7] = "CODE";
                LabelCategory[LabelCategory["CODES"] = 8] = "CODES";
                LabelCategory[LabelCategory["COMMONS"] = 9] = "COMMONS";
                LabelCategory[LabelCategory["CONFIRMATION"] = 10] = "CONFIRMATION";
                LabelCategory[LabelCategory["DASHBOARD"] = 11] = "DASHBOARD";
                LabelCategory[LabelCategory["DOMAIN"] = 12] = "DOMAIN";
                LabelCategory[LabelCategory["DOMAINS"] = 13] = "DOMAINS";
                LabelCategory[LabelCategory["EARNING"] = 14] = "EARNING";
                LabelCategory[LabelCategory["EARNING_DECLARE"] = 15] = "EARNING_DECLARE";
                LabelCategory[LabelCategory["EARNING_SECURITY"] = 16] = "EARNING_SECURITY";
                LabelCategory[LabelCategory["EARNINGS"] = 17] = "EARNINGS";
                LabelCategory[LabelCategory["EDIT_ONLINE_MESSAGES"] = 18] = "EDIT_ONLINE_MESSAGES";
                LabelCategory[LabelCategory["ENCODE_PASSWORD"] = 19] = "ENCODE_PASSWORD";
                LabelCategory[LabelCategory["ERROR"] = 20] = "ERROR";
                LabelCategory[LabelCategory["EXPORT"] = 21] = "EXPORT";
                LabelCategory[LabelCategory["FILE"] = 22] = "FILE";
                LabelCategory[LabelCategory["FILEUPLOAD"] = 23] = "FILEUPLOAD";
                LabelCategory[LabelCategory["GADGETS"] = 24] = "GADGETS";
                LabelCategory[LabelCategory["IMPORT"] = 25] = "IMPORT";
                LabelCategory[LabelCategory["INFO"] = 26] = "INFO";
                LabelCategory[LabelCategory["INSTRUMENT"] = 27] = "INSTRUMENT";
                LabelCategory[LabelCategory["LABEL"] = 28] = "LABEL";
                LabelCategory[LabelCategory["LOGIN"] = 29] = "LOGIN";
                LabelCategory[LabelCategory["LOST_PASSWORD"] = 30] = "LOST_PASSWORD";
                LabelCategory[LabelCategory["MAIL"] = 31] = "MAIL";
                LabelCategory[LabelCategory["MENU"] = 32] = "MENU";
                LabelCategory[LabelCategory["MULTI_SELECT"] = 33] = "MULTI_SELECT";
                LabelCategory[LabelCategory["NEWSLETTER"] = 34] = "NEWSLETTER";
                LabelCategory[LabelCategory["PRINT"] = 35] = "PRINT";
                LabelCategory[LabelCategory["RATELIST"] = 36] = "RATELIST";
                LabelCategory[LabelCategory["REGISTER"] = 37] = "REGISTER";
                LabelCategory[LabelCategory["REGISTRATION"] = 38] = "REGISTRATION";
                LabelCategory[LabelCategory["REPORT"] = 39] = "REPORT";
                LabelCategory[LabelCategory["REQUEST"] = 40] = "REQUEST";
                LabelCategory[LabelCategory["REQUEST_DUMP_LOG"] = 41] = "REQUEST_DUMP_LOG";
                LabelCategory[LabelCategory["REQUEST_DUMP_LOGS"] = 42] = "REQUEST_DUMP_LOGS";
                LabelCategory[LabelCategory["REQUESTS"] = 43] = "REQUESTS";
                LabelCategory[LabelCategory["ROLE"] = 44] = "ROLE";
                LabelCategory[LabelCategory["ROLES"] = 45] = "ROLES";
                LabelCategory[LabelCategory["SEARCH"] = 46] = "SEARCH";
                LabelCategory[LabelCategory["SECURITY"] = 47] = "SECURITY";
                LabelCategory[LabelCategory["SECURITY_SEARCH"] = 48] = "SECURITY_SEARCH";
                LabelCategory[LabelCategory["SYSTEM"] = 49] = "SYSTEM";
                LabelCategory[LabelCategory["SYSTEMS"] = 50] = "SYSTEMS";
                LabelCategory[LabelCategory["UNDER_CONSTRUCTION"] = 51] = "UNDER_CONSTRUCTION";
                LabelCategory[LabelCategory["USER"] = 52] = "USER";
                LabelCategory[LabelCategory["USERS"] = 53] = "USERS";
                LabelCategory[LabelCategory["VALIDATION_ERRORS"] = 54] = "VALIDATION_ERRORS";
                LabelCategory[LabelCategory["WORK_ORDER"] = 55] = "WORK_ORDER";
                LabelCategory[LabelCategory["XML"] = 56] = "XML";
            })(LabelCategory || exports_1("LabelCategory", LabelCategory = {}));
            (function (LegalForm) {
                LegalForm[LegalForm["_01"] = 0] = "_01";
                LegalForm[LegalForm["_02"] = 1] = "_02";
                LegalForm[LegalForm["_03"] = 2] = "_03";
                LegalForm[LegalForm["_04"] = 3] = "_04";
                LegalForm[LegalForm["_05"] = 4] = "_05";
                LegalForm[LegalForm["_06"] = 5] = "_06";
                LegalForm[LegalForm["_07"] = 6] = "_07";
                LegalForm[LegalForm["_08"] = 7] = "_08";
                LegalForm[LegalForm["_09"] = 8] = "_09";
                LegalForm[LegalForm["_10"] = 9] = "_10";
                LegalForm[LegalForm["_11"] = 10] = "_11";
                LegalForm[LegalForm["_12"] = 11] = "_12";
                LegalForm[LegalForm["_13"] = 12] = "_13";
                LegalForm[LegalForm["_20"] = 13] = "_20";
                LegalForm[LegalForm["_21"] = 14] = "_21";
                LegalForm[LegalForm["_22"] = 15] = "_22";
                LegalForm[LegalForm["_23"] = 16] = "_23";
                LegalForm[LegalForm["_24"] = 17] = "_24";
                LegalForm[LegalForm["_25"] = 18] = "_25";
                LegalForm[LegalForm["_27"] = 19] = "_27";
                LegalForm[LegalForm["_28"] = 20] = "_28";
                LegalForm[LegalForm["_29"] = 21] = "_29";
                LegalForm[LegalForm["_30"] = 22] = "_30";
                LegalForm[LegalForm["_31"] = 23] = "_31";
                LegalForm[LegalForm["_32"] = 24] = "_32";
                LegalForm[LegalForm["_33"] = 25] = "_33";
                LegalForm[LegalForm["_34"] = 26] = "_34";
            })(LegalForm || exports_1("LegalForm", LegalForm = {}));
            (function (LiborSwapPeriod) {
                LiborSwapPeriod[LiborSwapPeriod["LIBO_10M"] = 0] = "LIBO_10M";
                LiborSwapPeriod[LiborSwapPeriod["LIBO_11M"] = 1] = "LIBO_11M";
                LiborSwapPeriod[LiborSwapPeriod["LIBO_12M"] = 2] = "LIBO_12M";
                LiborSwapPeriod[LiborSwapPeriod["LIBO_1M"] = 3] = "LIBO_1M";
                LiborSwapPeriod[LiborSwapPeriod["LIBO_1W"] = 4] = "LIBO_1W";
                LiborSwapPeriod[LiborSwapPeriod["LIBO_2M"] = 5] = "LIBO_2M";
                LiborSwapPeriod[LiborSwapPeriod["LIBO_2W"] = 6] = "LIBO_2W";
                LiborSwapPeriod[LiborSwapPeriod["LIBO_3M"] = 7] = "LIBO_3M";
                LiborSwapPeriod[LiborSwapPeriod["LIBO_3W"] = 8] = "LIBO_3W";
                LiborSwapPeriod[LiborSwapPeriod["LIBO_4M"] = 9] = "LIBO_4M";
                LiborSwapPeriod[LiborSwapPeriod["LIBO_5M"] = 10] = "LIBO_5M";
                LiborSwapPeriod[LiborSwapPeriod["LIBO_6M"] = 11] = "LIBO_6M";
                LiborSwapPeriod[LiborSwapPeriod["LIBO_7M"] = 12] = "LIBO_7M";
                LiborSwapPeriod[LiborSwapPeriod["LIBO_8M"] = 13] = "LIBO_8M";
                LiborSwapPeriod[LiborSwapPeriod["LIBO_9M"] = 14] = "LIBO_9M";
                LiborSwapPeriod[LiborSwapPeriod["SWAP_10Y"] = 15] = "SWAP_10Y";
                LiborSwapPeriod[LiborSwapPeriod["SWAP_11Y"] = 16] = "SWAP_11Y";
                LiborSwapPeriod[LiborSwapPeriod["SWAP_12Y"] = 17] = "SWAP_12Y";
                LiborSwapPeriod[LiborSwapPeriod["SWAP_13Y"] = 18] = "SWAP_13Y";
                LiborSwapPeriod[LiborSwapPeriod["SWAP_14Y"] = 19] = "SWAP_14Y";
                LiborSwapPeriod[LiborSwapPeriod["SWAP_15M"] = 20] = "SWAP_15M";
                LiborSwapPeriod[LiborSwapPeriod["SWAP_15Y"] = 21] = "SWAP_15Y";
                LiborSwapPeriod[LiborSwapPeriod["SWAP_18M"] = 22] = "SWAP_18M";
                LiborSwapPeriod[LiborSwapPeriod["SWAP_1Y"] = 23] = "SWAP_1Y";
                LiborSwapPeriod[LiborSwapPeriod["SWAP_20Y"] = 24] = "SWAP_20Y";
                LiborSwapPeriod[LiborSwapPeriod["SWAP_21M"] = 25] = "SWAP_21M";
                LiborSwapPeriod[LiborSwapPeriod["SWAP_25Y"] = 26] = "SWAP_25Y";
                LiborSwapPeriod[LiborSwapPeriod["SWAP_2Y"] = 27] = "SWAP_2Y";
                LiborSwapPeriod[LiborSwapPeriod["SWAP_30Y"] = 28] = "SWAP_30Y";
                LiborSwapPeriod[LiborSwapPeriod["SWAP_35Y"] = 29] = "SWAP_35Y";
                LiborSwapPeriod[LiborSwapPeriod["SWAP_3Y"] = 30] = "SWAP_3Y";
                LiborSwapPeriod[LiborSwapPeriod["SWAP_40Y"] = 31] = "SWAP_40Y";
                LiborSwapPeriod[LiborSwapPeriod["SWAP_45Y"] = 32] = "SWAP_45Y";
                LiborSwapPeriod[LiborSwapPeriod["SWAP_4Y"] = 33] = "SWAP_4Y";
                LiborSwapPeriod[LiborSwapPeriod["SWAP_50Y"] = 34] = "SWAP_50Y";
                LiborSwapPeriod[LiborSwapPeriod["SWAP_5Y"] = 35] = "SWAP_5Y";
                LiborSwapPeriod[LiborSwapPeriod["SWAP_60Y"] = 36] = "SWAP_60Y";
                LiborSwapPeriod[LiborSwapPeriod["SWAP_6Y"] = 37] = "SWAP_6Y";
                LiborSwapPeriod[LiborSwapPeriod["SWAP_70Y"] = 38] = "SWAP_70Y";
                LiborSwapPeriod[LiborSwapPeriod["SWAP_7Y"] = 39] = "SWAP_7Y";
                LiborSwapPeriod[LiborSwapPeriod["SWAP_8Y"] = 40] = "SWAP_8Y";
                LiborSwapPeriod[LiborSwapPeriod["SWAP_9Y"] = 41] = "SWAP_9Y";
            })(LiborSwapPeriod || exports_1("LiborSwapPeriod", LiborSwapPeriod = {}));
            (function (LogLevel) {
                LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
                LogLevel[LogLevel["ERROR"] = 1] = "ERROR";
            })(LogLevel || exports_1("LogLevel", LogLevel = {}));
            (function (MimeTypeSuffix) {
                MimeTypeSuffix[MimeTypeSuffix["_WILDCARD"] = 0] = "_WILDCARD";
                MimeTypeSuffix[MimeTypeSuffix["_323"] = 1] = "_323";
                MimeTypeSuffix[MimeTypeSuffix["ACX"] = 2] = "ACX";
                MimeTypeSuffix[MimeTypeSuffix["AI"] = 3] = "AI";
                MimeTypeSuffix[MimeTypeSuffix["AIF"] = 4] = "AIF";
                MimeTypeSuffix[MimeTypeSuffix["AIFC"] = 5] = "AIFC";
                MimeTypeSuffix[MimeTypeSuffix["AIFF"] = 6] = "AIFF";
                MimeTypeSuffix[MimeTypeSuffix["ASF"] = 7] = "ASF";
                MimeTypeSuffix[MimeTypeSuffix["ASR"] = 8] = "ASR";
                MimeTypeSuffix[MimeTypeSuffix["ASX"] = 9] = "ASX";
                MimeTypeSuffix[MimeTypeSuffix["AU"] = 10] = "AU";
                MimeTypeSuffix[MimeTypeSuffix["AVI"] = 11] = "AVI";
                MimeTypeSuffix[MimeTypeSuffix["AXS"] = 12] = "AXS";
                MimeTypeSuffix[MimeTypeSuffix["BAS"] = 13] = "BAS";
                MimeTypeSuffix[MimeTypeSuffix["BCPIO"] = 14] = "BCPIO";
                MimeTypeSuffix[MimeTypeSuffix["BIN"] = 15] = "BIN";
                MimeTypeSuffix[MimeTypeSuffix["BMP"] = 16] = "BMP";
                MimeTypeSuffix[MimeTypeSuffix["C"] = 17] = "C";
                MimeTypeSuffix[MimeTypeSuffix["CAT"] = 18] = "CAT";
                MimeTypeSuffix[MimeTypeSuffix["CDF"] = 19] = "CDF";
                MimeTypeSuffix[MimeTypeSuffix["CER"] = 20] = "CER";
                MimeTypeSuffix[MimeTypeSuffix["CLASS"] = 21] = "CLASS";
                MimeTypeSuffix[MimeTypeSuffix["CLP"] = 22] = "CLP";
                MimeTypeSuffix[MimeTypeSuffix["CMX"] = 23] = "CMX";
                MimeTypeSuffix[MimeTypeSuffix["COD"] = 24] = "COD";
                MimeTypeSuffix[MimeTypeSuffix["CPIO"] = 25] = "CPIO";
                MimeTypeSuffix[MimeTypeSuffix["CRD"] = 26] = "CRD";
                MimeTypeSuffix[MimeTypeSuffix["CRL"] = 27] = "CRL";
                MimeTypeSuffix[MimeTypeSuffix["CRT"] = 28] = "CRT";
                MimeTypeSuffix[MimeTypeSuffix["CSH"] = 29] = "CSH";
                MimeTypeSuffix[MimeTypeSuffix["CSS"] = 30] = "CSS";
                MimeTypeSuffix[MimeTypeSuffix["CSV"] = 31] = "CSV";
                MimeTypeSuffix[MimeTypeSuffix["DCR"] = 32] = "DCR";
                MimeTypeSuffix[MimeTypeSuffix["DER"] = 33] = "DER";
                MimeTypeSuffix[MimeTypeSuffix["DIR"] = 34] = "DIR";
                MimeTypeSuffix[MimeTypeSuffix["DLL"] = 35] = "DLL";
                MimeTypeSuffix[MimeTypeSuffix["DMS"] = 36] = "DMS";
                MimeTypeSuffix[MimeTypeSuffix["DOC"] = 37] = "DOC";
                MimeTypeSuffix[MimeTypeSuffix["DOCM"] = 38] = "DOCM";
                MimeTypeSuffix[MimeTypeSuffix["DOCX"] = 39] = "DOCX";
                MimeTypeSuffix[MimeTypeSuffix["DOT"] = 40] = "DOT";
                MimeTypeSuffix[MimeTypeSuffix["DOTX"] = 41] = "DOTX";
                MimeTypeSuffix[MimeTypeSuffix["DVI"] = 42] = "DVI";
                MimeTypeSuffix[MimeTypeSuffix["DXR"] = 43] = "DXR";
                MimeTypeSuffix[MimeTypeSuffix["EPS"] = 44] = "EPS";
                MimeTypeSuffix[MimeTypeSuffix["ETX"] = 45] = "ETX";
                MimeTypeSuffix[MimeTypeSuffix["EVY"] = 46] = "EVY";
                MimeTypeSuffix[MimeTypeSuffix["EXE"] = 47] = "EXE";
                MimeTypeSuffix[MimeTypeSuffix["FIF"] = 48] = "FIF";
                MimeTypeSuffix[MimeTypeSuffix["FLR"] = 49] = "FLR";
                MimeTypeSuffix[MimeTypeSuffix["GIF"] = 50] = "GIF";
                MimeTypeSuffix[MimeTypeSuffix["GTAR"] = 51] = "GTAR";
                MimeTypeSuffix[MimeTypeSuffix["GZ"] = 52] = "GZ";
                MimeTypeSuffix[MimeTypeSuffix["H"] = 53] = "H";
                MimeTypeSuffix[MimeTypeSuffix["HDF"] = 54] = "HDF";
                MimeTypeSuffix[MimeTypeSuffix["HLP"] = 55] = "HLP";
                MimeTypeSuffix[MimeTypeSuffix["HQX"] = 56] = "HQX";
                MimeTypeSuffix[MimeTypeSuffix["HTA"] = 57] = "HTA";
                MimeTypeSuffix[MimeTypeSuffix["HTC"] = 58] = "HTC";
                MimeTypeSuffix[MimeTypeSuffix["HTM"] = 59] = "HTM";
                MimeTypeSuffix[MimeTypeSuffix["HTML"] = 60] = "HTML";
                MimeTypeSuffix[MimeTypeSuffix["HTT"] = 61] = "HTT";
                MimeTypeSuffix[MimeTypeSuffix["ICO"] = 62] = "ICO";
                MimeTypeSuffix[MimeTypeSuffix["IEF"] = 63] = "IEF";
                MimeTypeSuffix[MimeTypeSuffix["III"] = 64] = "III";
                MimeTypeSuffix[MimeTypeSuffix["INS"] = 65] = "INS";
                MimeTypeSuffix[MimeTypeSuffix["ISP"] = 66] = "ISP";
                MimeTypeSuffix[MimeTypeSuffix["JFIF"] = 67] = "JFIF";
                MimeTypeSuffix[MimeTypeSuffix["JPE"] = 68] = "JPE";
                MimeTypeSuffix[MimeTypeSuffix["JPEG"] = 69] = "JPEG";
                MimeTypeSuffix[MimeTypeSuffix["JPG"] = 70] = "JPG";
                MimeTypeSuffix[MimeTypeSuffix["JS"] = 71] = "JS";
                MimeTypeSuffix[MimeTypeSuffix["LATEX"] = 72] = "LATEX";
                MimeTypeSuffix[MimeTypeSuffix["LHA"] = 73] = "LHA";
                MimeTypeSuffix[MimeTypeSuffix["LSF"] = 74] = "LSF";
                MimeTypeSuffix[MimeTypeSuffix["LSX"] = 75] = "LSX";
                MimeTypeSuffix[MimeTypeSuffix["LZH"] = 76] = "LZH";
                MimeTypeSuffix[MimeTypeSuffix["M13"] = 77] = "M13";
                MimeTypeSuffix[MimeTypeSuffix["M14"] = 78] = "M14";
                MimeTypeSuffix[MimeTypeSuffix["M3U"] = 79] = "M3U";
                MimeTypeSuffix[MimeTypeSuffix["MAN"] = 80] = "MAN";
                MimeTypeSuffix[MimeTypeSuffix["MDB"] = 81] = "MDB";
                MimeTypeSuffix[MimeTypeSuffix["ME"] = 82] = "ME";
                MimeTypeSuffix[MimeTypeSuffix["MHT"] = 83] = "MHT";
                MimeTypeSuffix[MimeTypeSuffix["MHTML"] = 84] = "MHTML";
                MimeTypeSuffix[MimeTypeSuffix["MID"] = 85] = "MID";
                MimeTypeSuffix[MimeTypeSuffix["MNY"] = 86] = "MNY";
                MimeTypeSuffix[MimeTypeSuffix["MOV"] = 87] = "MOV";
                MimeTypeSuffix[MimeTypeSuffix["MOVIE"] = 88] = "MOVIE";
                MimeTypeSuffix[MimeTypeSuffix["MP2"] = 89] = "MP2";
                MimeTypeSuffix[MimeTypeSuffix["MP3"] = 90] = "MP3";
                MimeTypeSuffix[MimeTypeSuffix["MPA"] = 91] = "MPA";
                MimeTypeSuffix[MimeTypeSuffix["MPE"] = 92] = "MPE";
                MimeTypeSuffix[MimeTypeSuffix["MPEG"] = 93] = "MPEG";
                MimeTypeSuffix[MimeTypeSuffix["MPG"] = 94] = "MPG";
                MimeTypeSuffix[MimeTypeSuffix["MPP"] = 95] = "MPP";
                MimeTypeSuffix[MimeTypeSuffix["MPV2"] = 96] = "MPV2";
                MimeTypeSuffix[MimeTypeSuffix["MS"] = 97] = "MS";
                MimeTypeSuffix[MimeTypeSuffix["MSG"] = 98] = "MSG";
                MimeTypeSuffix[MimeTypeSuffix["MVB"] = 99] = "MVB";
                MimeTypeSuffix[MimeTypeSuffix["NWS"] = 100] = "NWS";
                MimeTypeSuffix[MimeTypeSuffix["ODA"] = 101] = "ODA";
                MimeTypeSuffix[MimeTypeSuffix["P10"] = 102] = "P10";
                MimeTypeSuffix[MimeTypeSuffix["P12"] = 103] = "P12";
                MimeTypeSuffix[MimeTypeSuffix["P7B"] = 104] = "P7B";
                MimeTypeSuffix[MimeTypeSuffix["P7C"] = 105] = "P7C";
                MimeTypeSuffix[MimeTypeSuffix["P7M"] = 106] = "P7M";
                MimeTypeSuffix[MimeTypeSuffix["P7R"] = 107] = "P7R";
                MimeTypeSuffix[MimeTypeSuffix["P7S"] = 108] = "P7S";
                MimeTypeSuffix[MimeTypeSuffix["PBM"] = 109] = "PBM";
                MimeTypeSuffix[MimeTypeSuffix["PDF"] = 110] = "PDF";
                MimeTypeSuffix[MimeTypeSuffix["PFX"] = 111] = "PFX";
                MimeTypeSuffix[MimeTypeSuffix["PGM"] = 112] = "PGM";
                MimeTypeSuffix[MimeTypeSuffix["PKO"] = 113] = "PKO";
                MimeTypeSuffix[MimeTypeSuffix["PMA"] = 114] = "PMA";
                MimeTypeSuffix[MimeTypeSuffix["PMC"] = 115] = "PMC";
                MimeTypeSuffix[MimeTypeSuffix["PML"] = 116] = "PML";
                MimeTypeSuffix[MimeTypeSuffix["PMR"] = 117] = "PMR";
                MimeTypeSuffix[MimeTypeSuffix["PMW"] = 118] = "PMW";
                MimeTypeSuffix[MimeTypeSuffix["PNG"] = 119] = "PNG";
                MimeTypeSuffix[MimeTypeSuffix["PNM"] = 120] = "PNM";
                MimeTypeSuffix[MimeTypeSuffix["POT"] = 121] = "POT";
                MimeTypeSuffix[MimeTypeSuffix["POTM"] = 122] = "POTM";
                MimeTypeSuffix[MimeTypeSuffix["POTX"] = 123] = "POTX";
                MimeTypeSuffix[MimeTypeSuffix["PPAM"] = 124] = "PPAM";
                MimeTypeSuffix[MimeTypeSuffix["PPM"] = 125] = "PPM";
                MimeTypeSuffix[MimeTypeSuffix["PPS"] = 126] = "PPS";
                MimeTypeSuffix[MimeTypeSuffix["PPSM"] = 127] = "PPSM";
                MimeTypeSuffix[MimeTypeSuffix["PPSX"] = 128] = "PPSX";
                MimeTypeSuffix[MimeTypeSuffix["PPT"] = 129] = "PPT";
                MimeTypeSuffix[MimeTypeSuffix["PPTM"] = 130] = "PPTM";
                MimeTypeSuffix[MimeTypeSuffix["PPTX"] = 131] = "PPTX";
                MimeTypeSuffix[MimeTypeSuffix["PRF"] = 132] = "PRF";
                MimeTypeSuffix[MimeTypeSuffix["PS"] = 133] = "PS";
                MimeTypeSuffix[MimeTypeSuffix["PUB"] = 134] = "PUB";
                MimeTypeSuffix[MimeTypeSuffix["QDF"] = 135] = "QDF";
                MimeTypeSuffix[MimeTypeSuffix["QT"] = 136] = "QT";
                MimeTypeSuffix[MimeTypeSuffix["RA"] = 137] = "RA";
                MimeTypeSuffix[MimeTypeSuffix["RAM"] = 138] = "RAM";
                MimeTypeSuffix[MimeTypeSuffix["RAS"] = 139] = "RAS";
                MimeTypeSuffix[MimeTypeSuffix["RGB"] = 140] = "RGB";
                MimeTypeSuffix[MimeTypeSuffix["RMI"] = 141] = "RMI";
                MimeTypeSuffix[MimeTypeSuffix["ROFF"] = 142] = "ROFF";
                MimeTypeSuffix[MimeTypeSuffix["RTF"] = 143] = "RTF";
                MimeTypeSuffix[MimeTypeSuffix["RTX"] = 144] = "RTX";
                MimeTypeSuffix[MimeTypeSuffix["SCD"] = 145] = "SCD";
                MimeTypeSuffix[MimeTypeSuffix["SCT"] = 146] = "SCT";
                MimeTypeSuffix[MimeTypeSuffix["SETPAY"] = 147] = "SETPAY";
                MimeTypeSuffix[MimeTypeSuffix["SETREG"] = 148] = "SETREG";
                MimeTypeSuffix[MimeTypeSuffix["SH"] = 149] = "SH";
                MimeTypeSuffix[MimeTypeSuffix["SHAR"] = 150] = "SHAR";
                MimeTypeSuffix[MimeTypeSuffix["SIT"] = 151] = "SIT";
                MimeTypeSuffix[MimeTypeSuffix["SND"] = 152] = "SND";
                MimeTypeSuffix[MimeTypeSuffix["SPC"] = 153] = "SPC";
                MimeTypeSuffix[MimeTypeSuffix["SPL"] = 154] = "SPL";
                MimeTypeSuffix[MimeTypeSuffix["SRC"] = 155] = "SRC";
                MimeTypeSuffix[MimeTypeSuffix["SST"] = 156] = "SST";
                MimeTypeSuffix[MimeTypeSuffix["STL"] = 157] = "STL";
                MimeTypeSuffix[MimeTypeSuffix["STM"] = 158] = "STM";
                MimeTypeSuffix[MimeTypeSuffix["SV4CPIO"] = 159] = "SV4CPIO";
                MimeTypeSuffix[MimeTypeSuffix["SV4CRC"] = 160] = "SV4CRC";
                MimeTypeSuffix[MimeTypeSuffix["T"] = 161] = "T";
                MimeTypeSuffix[MimeTypeSuffix["TAR"] = 162] = "TAR";
                MimeTypeSuffix[MimeTypeSuffix["TCL"] = 163] = "TCL";
                MimeTypeSuffix[MimeTypeSuffix["TEX"] = 164] = "TEX";
                MimeTypeSuffix[MimeTypeSuffix["TEXI"] = 165] = "TEXI";
                MimeTypeSuffix[MimeTypeSuffix["TEXINFO"] = 166] = "TEXINFO";
                MimeTypeSuffix[MimeTypeSuffix["TGZ"] = 167] = "TGZ";
                MimeTypeSuffix[MimeTypeSuffix["TIF"] = 168] = "TIF";
                MimeTypeSuffix[MimeTypeSuffix["TIFF"] = 169] = "TIFF";
                MimeTypeSuffix[MimeTypeSuffix["TR"] = 170] = "TR";
                MimeTypeSuffix[MimeTypeSuffix["TRM"] = 171] = "TRM";
                MimeTypeSuffix[MimeTypeSuffix["TSV"] = 172] = "TSV";
                MimeTypeSuffix[MimeTypeSuffix["TXT"] = 173] = "TXT";
                MimeTypeSuffix[MimeTypeSuffix["ULS"] = 174] = "ULS";
                MimeTypeSuffix[MimeTypeSuffix["USTAR"] = 175] = "USTAR";
                MimeTypeSuffix[MimeTypeSuffix["VCF"] = 176] = "VCF";
                MimeTypeSuffix[MimeTypeSuffix["VRML"] = 177] = "VRML";
                MimeTypeSuffix[MimeTypeSuffix["WAV"] = 178] = "WAV";
                MimeTypeSuffix[MimeTypeSuffix["WCM"] = 179] = "WCM";
                MimeTypeSuffix[MimeTypeSuffix["WDB"] = 180] = "WDB";
                MimeTypeSuffix[MimeTypeSuffix["WKS"] = 181] = "WKS";
                MimeTypeSuffix[MimeTypeSuffix["WMF"] = 182] = "WMF";
                MimeTypeSuffix[MimeTypeSuffix["WPS"] = 183] = "WPS";
                MimeTypeSuffix[MimeTypeSuffix["WRI"] = 184] = "WRI";
                MimeTypeSuffix[MimeTypeSuffix["WRL"] = 185] = "WRL";
                MimeTypeSuffix[MimeTypeSuffix["WRZ"] = 186] = "WRZ";
                MimeTypeSuffix[MimeTypeSuffix["XAF"] = 187] = "XAF";
                MimeTypeSuffix[MimeTypeSuffix["XBM"] = 188] = "XBM";
                MimeTypeSuffix[MimeTypeSuffix["XLA"] = 189] = "XLA";
                MimeTypeSuffix[MimeTypeSuffix["XLAM"] = 190] = "XLAM";
                MimeTypeSuffix[MimeTypeSuffix["XLC"] = 191] = "XLC";
                MimeTypeSuffix[MimeTypeSuffix["XLM"] = 192] = "XLM";
                MimeTypeSuffix[MimeTypeSuffix["XLS"] = 193] = "XLS";
                MimeTypeSuffix[MimeTypeSuffix["XLSB"] = 194] = "XLSB";
                MimeTypeSuffix[MimeTypeSuffix["XLSM"] = 195] = "XLSM";
                MimeTypeSuffix[MimeTypeSuffix["XLSX"] = 196] = "XLSX";
                MimeTypeSuffix[MimeTypeSuffix["XLT"] = 197] = "XLT";
                MimeTypeSuffix[MimeTypeSuffix["XLTM"] = 198] = "XLTM";
                MimeTypeSuffix[MimeTypeSuffix["XLTX"] = 199] = "XLTX";
                MimeTypeSuffix[MimeTypeSuffix["XLW"] = 200] = "XLW";
                MimeTypeSuffix[MimeTypeSuffix["XML"] = 201] = "XML";
                MimeTypeSuffix[MimeTypeSuffix["XOF"] = 202] = "XOF";
                MimeTypeSuffix[MimeTypeSuffix["XPM"] = 203] = "XPM";
                MimeTypeSuffix[MimeTypeSuffix["XSD"] = 204] = "XSD";
                MimeTypeSuffix[MimeTypeSuffix["XWD"] = 205] = "XWD";
                MimeTypeSuffix[MimeTypeSuffix["Z"] = 206] = "Z";
                MimeTypeSuffix[MimeTypeSuffix["ZIP"] = 207] = "ZIP";
            })(MimeTypeSuffix || exports_1("MimeTypeSuffix", MimeTypeSuffix = {}));
            (function (Month) {
                Month[Month["_01"] = 0] = "_01";
                Month[Month["_02"] = 1] = "_02";
                Month[Month["_03"] = 2] = "_03";
                Month[Month["_04"] = 3] = "_04";
                Month[Month["_05"] = 4] = "_05";
                Month[Month["_06"] = 5] = "_06";
                Month[Month["_07"] = 6] = "_07";
                Month[Month["_08"] = 7] = "_08";
                Month[Month["_09"] = 8] = "_09";
                Month[Month["_10"] = 9] = "_10";
                Month[Month["_11"] = 10] = "_11";
                Month[Month["_12"] = 11] = "_12";
            })(Month || exports_1("Month", Month = {}));
            (function (MessageType) {
                MessageType[MessageType["ERROR"] = 0] = "ERROR";
                MessageType[MessageType["REMARK"] = 1] = "REMARK";
                MessageType[MessageType["REQUEST"] = 2] = "REQUEST";
                MessageType[MessageType["RESPONSE"] = 3] = "RESPONSE";
                MessageType[MessageType["WARNING"] = 4] = "WARNING";
            })(MessageType || exports_1("MessageType", MessageType = {}));
            (function (MutationTarget) {
                MutationTarget[MutationTarget["CORRECTION"] = 0] = "CORRECTION";
                MutationTarget[MutationTarget["EXTENSION"] = 1] = "EXTENSION";
                MutationTarget[MutationTarget["THIRDPARTY"] = 2] = "THIRDPARTY";
                MutationTarget[MutationTarget["WVK"] = 3] = "WVK";
            })(MutationTarget || exports_1("MutationTarget", MutationTarget = {}));
            (function (NotificationReason) {
                NotificationReason[NotificationReason["CAPITALCHANGE"] = 0] = "CAPITALCHANGE";
                NotificationReason[NotificationReason["CAPITALINCREASE"] = 1] = "CAPITALINCREASE";
                NotificationReason[NotificationReason["CAPITALNEW"] = 2] = "CAPITALNEW";
                NotificationReason[NotificationReason["CAPITALREDUCTION"] = 3] = "CAPITALREDUCTION";
                NotificationReason[NotificationReason["CAPITALSTRUCTURE"] = 4] = "CAPITALSTRUCTURE";
                NotificationReason[NotificationReason["DELETE"] = 5] = "DELETE";
                NotificationReason[NotificationReason["HOLDER"] = 6] = "HOLDER";
                NotificationReason[NotificationReason["HOLDERATTACHMENT"] = 7] = "HOLDERATTACHMENT";
                NotificationReason[NotificationReason["INSTITUTION"] = 8] = "INSTITUTION";
                NotificationReason[NotificationReason["INSTITUTIONNOTFORESTV"] = 9] = "INSTITUTIONNOTFORESTV";
                NotificationReason[NotificationReason["MONETARYBENEFITNEW"] = 10] = "MONETARYBENEFITNEW";
                NotificationReason[NotificationReason["MONETARYBENEFITWRONG"] = 11] = "MONETARYBENEFITWRONG";
                NotificationReason[NotificationReason["OTHER"] = 12] = "OTHER";
                NotificationReason[NotificationReason["PAYMENTDOUBLE"] = 13] = "PAYMENTDOUBLE";
                NotificationReason[NotificationReason["PAYMENTNEW"] = 14] = "PAYMENTNEW";
                NotificationReason[NotificationReason["PAYMENTWRONG"] = 15] = "PAYMENTWRONG";
                NotificationReason[NotificationReason["REORGANISATION"] = 16] = "REORGANISATION";
            })(NotificationReason || exports_1("NotificationReason", NotificationReason = {}));
            (function (NotificationStatus) {
                NotificationStatus[NotificationStatus["APPROVED"] = 0] = "APPROVED";
                NotificationStatus[NotificationStatus["CLOSED"] = 1] = "CLOSED";
                NotificationStatus[NotificationStatus["DENIED"] = 2] = "DENIED";
                NotificationStatus[NotificationStatus["INQUIRY"] = 3] = "INQUIRY";
                NotificationStatus[NotificationStatus["OPEN"] = 4] = "OPEN";
                NotificationStatus[NotificationStatus["PROCESS"] = 5] = "PROCESS";
            })(NotificationStatus || exports_1("NotificationStatus", NotificationStatus = {}));
            (function (NotificationType) {
                NotificationType[NotificationType["EXTRACTSERIES"] = 0] = "EXTRACTSERIES";
                NotificationType[NotificationType["INSTITUTION"] = 1] = "INSTITUTION";
                NotificationType[NotificationType["INSTITUTIONREMARK"] = 2] = "INSTITUTIONREMARK";
                NotificationType[NotificationType["PAYMENTDISTRIBUTION"] = 3] = "PAYMENTDISTRIBUTION";
                NotificationType[NotificationType["REALESTATE"] = 4] = "REALESTATE";
                NotificationType[NotificationType["SECURITY"] = 5] = "SECURITY";
                NotificationType[NotificationType["SECURITYPAYMENT"] = 6] = "SECURITYPAYMENT";
                NotificationType[NotificationType["SECURITYPAYMENTREMARK"] = 7] = "SECURITYPAYMENTREMARK";
                NotificationType[NotificationType["SECURITYREMARK"] = 8] = "SECURITYREMARK";
                NotificationType[NotificationType["SECURITYYEAREND"] = 9] = "SECURITYYEAREND";
                NotificationType[NotificationType["SECURITYYEARENDREMARK"] = 10] = "SECURITYYEARENDREMARK";
            })(NotificationType || exports_1("NotificationType", NotificationType = {}));
            (function (OpenIssueType) {
                OpenIssueType[OpenIssueType["REQUEST_DENIED"] = 0] = "REQUEST_DENIED";
                OpenIssueType[OpenIssueType["REQUEST_INQUIRY"] = 1] = "REQUEST_INQUIRY";
            })(OpenIssueType || exports_1("OpenIssueType", OpenIssueType = {}));
            (function (OnlineMessage) {
                OnlineMessage[OnlineMessage["ERROR"] = 0] = "ERROR";
                OnlineMessage[OnlineMessage["INFO"] = 1] = "INFO";
                OnlineMessage[OnlineMessage["SCRIPT"] = 2] = "SCRIPT";
                OnlineMessage[OnlineMessage["WARNING"] = 3] = "WARNING";
            })(OnlineMessage || exports_1("OnlineMessage", OnlineMessage = {}));
            (function (PaymentFrequency) {
                PaymentFrequency[PaymentFrequency["BIMONTHLY"] = 0] = "BIMONTHLY";
                PaymentFrequency[PaymentFrequency["BIWEEKLY"] = 1] = "BIWEEKLY";
                PaymentFrequency[PaymentFrequency["HALFYEAR"] = 2] = "HALFYEAR";
                PaymentFrequency[PaymentFrequency["MONTHLY"] = 3] = "MONTHLY";
                PaymentFrequency[PaymentFrequency["QUARTERYEAR"] = 4] = "QUARTERYEAR";
                PaymentFrequency[PaymentFrequency["WEEKLY"] = 5] = "WEEKLY";
                PaymentFrequency[PaymentFrequency["YEAR"] = 6] = "YEAR";
            })(PaymentFrequency || exports_1("PaymentFrequency", PaymentFrequency = {}));
            (function (PaymentMessageType) {
                PaymentMessageType[PaymentMessageType["_230"] = 0] = "_230";
                PaymentMessageType[PaymentMessageType["_276"] = 1] = "_276";
                PaymentMessageType[PaymentMessageType["_278"] = 2] = "_278";
                PaymentMessageType[PaymentMessageType["_279"] = 3] = "_279";
                PaymentMessageType[PaymentMessageType["_281"] = 4] = "_281";
                PaymentMessageType[PaymentMessageType["_297"] = 5] = "_297";
                PaymentMessageType[PaymentMessageType["_298"] = 6] = "_298";
                PaymentMessageType[PaymentMessageType["_488"] = 7] = "_488";
            })(PaymentMessageType || exports_1("PaymentMessageType", PaymentMessageType = {}));
            (function (PaymentStatus) {
                PaymentStatus[PaymentStatus["ANNOUNCED"] = 0] = "ANNOUNCED";
                PaymentStatus[PaymentStatus["FULLSETTLED"] = 1] = "FULLSETTLED";
                PaymentStatus[PaymentStatus["INDEFAULT"] = 2] = "INDEFAULT";
                PaymentStatus[PaymentStatus["INDICATIVE"] = 3] = "INDICATIVE";
                PaymentStatus[PaymentStatus["IRRELEVANT"] = 4] = "IRRELEVANT";
                PaymentStatus[PaymentStatus["NOINFO"] = 5] = "NOINFO";
                PaymentStatus[PaymentStatus["NOINFOREC"] = 6] = "NOINFOREC";
                PaymentStatus[PaymentStatus["OMITTED"] = 7] = "OMITTED";
                PaymentStatus[PaymentStatus["OPTNOTUSED"] = 8] = "OPTNOTUSED";
                PaymentStatus[PaymentStatus["PAID"] = 9] = "PAID";
                PaymentStatus[PaymentStatus["PARTOMITTED"] = 10] = "PARTOMITTED";
                PaymentStatus[PaymentStatus["PARTSETTLED"] = 11] = "PARTSETTLED";
                PaymentStatus[PaymentStatus["PLANNED"] = 12] = "PLANNED";
                PaymentStatus[PaymentStatus["POSSIBLE"] = 13] = "POSSIBLE";
                PaymentStatus[PaymentStatus["REPLACED"] = 14] = "REPLACED";
            })(PaymentStatus || exports_1("PaymentStatus", PaymentStatus = {}));
            (function (PaymentType) {
                PaymentType[PaymentType["BONUS"] = 0] = "BONUS";
                PaymentType[PaymentType["CAPITALDIST"] = 1] = "CAPITALDIST";
                PaymentType[PaymentType["CAPITALGAIN"] = 2] = "CAPITALGAIN";
                PaymentType[PaymentType["DAYACCRUALFUND"] = 3] = "DAYACCRUALFUND";
                PaymentType[PaymentType["EXTRA"] = 4] = "EXTRA";
                PaymentType[PaymentType["FOREIGNINCOME"] = 5] = "FOREIGNINCOME";
                PaymentType[PaymentType["GUARANTY"] = 6] = "GUARANTY";
                PaymentType[PaymentType["LONGTERM"] = 7] = "LONGTERM";
                PaymentType[PaymentType["MEDCAPITALGAIN"] = 8] = "MEDCAPITALGAIN";
                PaymentType[PaymentType["NODIVIDEND"] = 9] = "NODIVIDEND";
                PaymentType[PaymentType["ORDINARY"] = 10] = "ORDINARY";
                PaymentType[PaymentType["ORDINARYEXTRA"] = 11] = "ORDINARYEXTRA";
                PaymentType[PaymentType["OTHER"] = 12] = "OTHER";
                PaymentType[PaymentType["RETURNCAPITAL"] = 13] = "RETURNCAPITAL";
                PaymentType[PaymentType["SHORTTERM"] = 14] = "SHORTTERM";
                PaymentType[PaymentType["TAXDIVIDEND"] = 15] = "TAXDIVIDEND";
            })(PaymentType || exports_1("PaymentType", PaymentType = {}));
            (function (PriorityType) {
                PriorityType[PriorityType["NEVER"] = 0] = "NEVER";
                PriorityType[PriorityType["PRIMARY"] = 1] = "PRIMARY";
                PriorityType[PriorityType["SECONDARY"] = 2] = "SECONDARY";
            })(PriorityType || exports_1("PriorityType", PriorityType = {}));
            (function (PublicationCategory) {
                PublicationCategory[PublicationCategory["GA_FILES"] = 0] = "GA_FILES";
                PublicationCategory[PublicationCategory["KURSLISTE"] = 1] = "KURSLISTE";
                PublicationCategory[PublicationCategory["KURSLISTE_HB"] = 2] = "KURSLISTE_HB";
                PublicationCategory[PublicationCategory["MISCELLANEOUS"] = 3] = "MISCELLANEOUS";
                PublicationCategory[PublicationCategory["SEARCH"] = 4] = "SEARCH";
                PublicationCategory[PublicationCategory["XML_FILES"] = 5] = "XML_FILES";
            })(PublicationCategory || exports_1("PublicationCategory", PublicationCategory = {}));
            (function (PublicationDescription) {
                PublicationDescription[PublicationDescription["HB"] = 0] = "HB";
                PublicationDescription[PublicationDescription["HB_1"] = 1] = "HB_1";
                PublicationDescription[PublicationDescription["HB_2"] = 2] = "HB_2";
                PublicationDescription[PublicationDescription["KL"] = 3] = "KL";
                PublicationDescription[PublicationDescription["KL_1"] = 4] = "KL_1";
                PublicationDescription[PublicationDescription["KL_2"] = 5] = "KL_2";
            })(PublicationDescription || exports_1("PublicationDescription", PublicationDescription = {}));
            (function (PublicationType) {
                PublicationType[PublicationType["ACCESS_DB"] = 0] = "ACCESS_DB";
                PublicationType[PublicationType["CHANGES_OF_NAME"] = 1] = "CHANGES_OF_NAME";
                PublicationType[PublicationType["CHANGE_ASSESMENT"] = 2] = "CHANGE_ASSESMENT";
                PublicationType[PublicationType["COIN_BULLIONS"] = 3] = "COIN_BULLIONS";
                PublicationType[PublicationType["CORRECTIONS"] = 4] = "CORRECTIONS";
                PublicationType[PublicationType["CORRECTIONS_1"] = 5] = "CORRECTIONS_1";
                PublicationType[PublicationType["CORRECTIONS_2"] = 6] = "CORRECTIONS_2";
                PublicationType[PublicationType["CORRECTIONS_HB"] = 7] = "CORRECTIONS_HB";
                PublicationType[PublicationType["CORRECTIONS_HB_1"] = 8] = "CORRECTIONS_HB_1";
                PublicationType[PublicationType["CORRECTIONS_HB_2"] = 9] = "CORRECTIONS_HB_2";
                PublicationType[PublicationType["COVER"] = 10] = "COVER";
                PublicationType[PublicationType["COVERHB"] = 11] = "COVERHB";
                PublicationType[PublicationType["COVERHB_1"] = 12] = "COVERHB_1";
                PublicationType[PublicationType["COVERHB_2"] = 13] = "COVERHB_2";
                PublicationType[PublicationType["COVER_1"] = 14] = "COVER_1";
                PublicationType[PublicationType["COVER_2"] = 15] = "COVER_2";
                PublicationType[PublicationType["CURRENCY_MIDDLES"] = 16] = "CURRENCY_MIDDLES";
                PublicationType[PublicationType["CURRENCY_NOTES"] = 17] = "CURRENCY_NOTES";
                PublicationType[PublicationType["DA1"] = 18] = "DA1";
                PublicationType[PublicationType["DEVT_FOND_FC"] = 19] = "DEVT_FOND_FC";
                PublicationType[PublicationType["DOUBLE_TAX_AGREEMENT"] = 20] = "DOUBLE_TAX_AGREEMENT";
                PublicationType[PublicationType["EXCEL_DB"] = 21] = "EXCEL_DB";
                PublicationType[PublicationType["EXTENSIONS"] = 22] = "EXTENSIONS";
                PublicationType[PublicationType["EXTENSIONS_1"] = 23] = "EXTENSIONS_1";
                PublicationType[PublicationType["EXTENSIONS_2"] = 24] = "EXTENSIONS_2";
                PublicationType[PublicationType["EXTENSIONS_HB"] = 25] = "EXTENSIONS_HB";
                PublicationType[PublicationType["EXTENSIONS_HB_1"] = 26] = "EXTENSIONS_HB_1";
                PublicationType[PublicationType["EXTENSIONS_HB_2"] = 27] = "EXTENSIONS_HB_2";
                PublicationType[PublicationType["FORM_25_A"] = 28] = "FORM_25_A";
                PublicationType[PublicationType["FORM_80_98_60"] = 29] = "FORM_80_98_60";
                PublicationType[PublicationType["FREE_SHARES"] = 30] = "FREE_SHARES";
                PublicationType[PublicationType["FREE_SHARES_DELTA"] = 31] = "FREE_SHARES_DELTA";
                PublicationType[PublicationType["GUIDANCE"] = 32] = "GUIDANCE";
                PublicationType[PublicationType["KURSLISTE"] = 33] = "KURSLISTE";
                PublicationType[PublicationType["KURSLISTE_1"] = 34] = "KURSLISTE_1";
                PublicationType[PublicationType["KURSLISTE_2"] = 35] = "KURSLISTE_2";
                PublicationType[PublicationType["KURSLISTE_HB"] = 36] = "KURSLISTE_HB";
                PublicationType[PublicationType["KURSLISTE_HB_1"] = 37] = "KURSLISTE_HB_1";
                PublicationType[PublicationType["KURSLISTE_HB_2"] = 38] = "KURSLISTE_HB_2";
                PublicationType[PublicationType["MEDTERMS"] = 39] = "MEDTERMS";
                PublicationType[PublicationType["OPTIONS_CH"] = 40] = "OPTIONS_CH";
                PublicationType[PublicationType["OPTIONS_FC"] = 41] = "OPTIONS_FC";
                PublicationType[PublicationType["REMARKS"] = 42] = "REMARKS";
                PublicationType[PublicationType["REMARKS_HB"] = 43] = "REMARKS_HB";
                PublicationType[PublicationType["REORGANISATION"] = 44] = "REORGANISATION";
                PublicationType[PublicationType["REVERSE"] = 45] = "REVERSE";
                PublicationType[PublicationType["REVERSEHB"] = 46] = "REVERSEHB";
                PublicationType[PublicationType["REVERSEHB_1"] = 47] = "REVERSEHB_1";
                PublicationType[PublicationType["REVERSEHB_2"] = 48] = "REVERSEHB_2";
                PublicationType[PublicationType["REVERSE_1"] = 49] = "REVERSE_1";
                PublicationType[PublicationType["REVERSE_2"] = 50] = "REVERSE_2";
                PublicationType[PublicationType["SHARES_FC_SWX_SPONSORD"] = 51] = "SHARES_FC_SWX_SPONSORD";
                PublicationType[PublicationType["SHORTCUTS"] = 52] = "SHORTCUTS";
                PublicationType[PublicationType["SIGNSYMBOLS"] = 53] = "SIGNSYMBOLS";
                PublicationType[PublicationType["TOKENS"] = 54] = "TOKENS";
                PublicationType[PublicationType["UNPUBLISHED_FUND_CH"] = 55] = "UNPUBLISHED_FUND_CH";
                PublicationType[PublicationType["UNPUBLISHED_FUND_FC"] = 56] = "UNPUBLISHED_FUND_FC";
                PublicationType[PublicationType["XML_FILES_DELTA_101"] = 57] = "XML_FILES_DELTA_101";
                PublicationType[PublicationType["XML_FILES_DELTA_110"] = 58] = "XML_FILES_DELTA_110";
                PublicationType[PublicationType["XML_FILES_DELTA_120"] = 59] = "XML_FILES_DELTA_120";
                PublicationType[PublicationType["XML_FILES_EXCEL"] = 60] = "XML_FILES_EXCEL";
                PublicationType[PublicationType["XML_FILES_EXCEL_DELTA"] = 61] = "XML_FILES_EXCEL_DELTA";
                PublicationType[PublicationType["XML_FILES_INIT_101"] = 62] = "XML_FILES_INIT_101";
                PublicationType[PublicationType["XML_FILES_INIT_110"] = 63] = "XML_FILES_INIT_110";
                PublicationType[PublicationType["XML_FILES_INIT_120"] = 64] = "XML_FILES_INIT_120";
                PublicationType[PublicationType["XML_FILES_TUTORIAL"] = 65] = "XML_FILES_TUTORIAL";
                PublicationType[PublicationType["XML_FILES_XSD_101"] = 66] = "XML_FILES_XSD_101";
                PublicationType[PublicationType["XML_FILES_XSD_110"] = 67] = "XML_FILES_XSD_110";
                PublicationType[PublicationType["XML_FILES_XSD_120"] = 68] = "XML_FILES_XSD_120";
            })(PublicationType || exports_1("PublicationType", PublicationType = {}));
            (function (QuotationType) {
                QuotationType[QuotationType["PERCENT"] = 0] = "PERCENT";
                QuotationType[QuotationType["PIECE"] = 1] = "PIECE";
            })(QuotationType || exports_1("QuotationType", QuotationType = {}));
            (function (Remark) {
                Remark[Remark["DAILY_PREVIOUS"] = 0] = "DAILY_PREVIOUS";
                Remark[Remark["EVENT_IM"] = 1] = "EVENT_IM";
                Remark[Remark["PAYMENT_BEFORE"] = 2] = "PAYMENT_BEFORE";
                Remark[Remark["PAYMENT_CHANGE"] = 3] = "PAYMENT_CHANGE";
                Remark[Remark["PAYMENT_CHANGE_EX_DATE"] = 4] = "PAYMENT_CHANGE_EX_DATE";
                Remark[Remark["PAYMENT_CHANGE_GRATIS_NO"] = 5] = "PAYMENT_CHANGE_GRATIS_NO";
                Remark[Remark["PAYMENT_CHANGE_GRATIS_YES"] = 6] = "PAYMENT_CHANGE_GRATIS_YES";
                Remark[Remark["PAYMENT_CHANGE_PAYMENT_DATE"] = 7] = "PAYMENT_CHANGE_PAYMENT_DATE";
                Remark[Remark["PAYMENT_CHANGE_PORTEFEUILLE_NO"] = 8] = "PAYMENT_CHANGE_PORTEFEUILLE_NO";
                Remark[Remark["PAYMENT_CHANGE_PORTEFEUILLE_YES"] = 9] = "PAYMENT_CHANGE_PORTEFEUILLE_YES";
                Remark[Remark["PAYMENT_CHANGE_SIGN_SYMBOL"] = 10] = "PAYMENT_CHANGE_SIGN_SYMBOL";
                Remark[Remark["PAYMENT_CHANGE_WITHHOLDING_TAX_NO"] = 11] = "PAYMENT_CHANGE_WITHHOLDING_TAX_NO";
                Remark[Remark["PAYMENT_CHANGE_WITHHOLDING_TAX_YES"] = 12] = "PAYMENT_CHANGE_WITHHOLDING_TAX_YES";
                Remark[Remark["PAYMENT_DELETE_SIGN_SYMBOL"] = 13] = "PAYMENT_DELETE_SIGN_SYMBOL";
                Remark[Remark["PAYMENT_DELETED"] = 14] = "PAYMENT_DELETED";
                Remark[Remark["PAYMENT_DELETED_EXDATE"] = 15] = "PAYMENT_DELETED_EXDATE";
                Remark[Remark["PAYMENT_INTEREST"] = 16] = "PAYMENT_INTEREST";
                Remark[Remark["PAYMENT_NEW"] = 17] = "PAYMENT_NEW";
                Remark[Remark["PAYMENT_NEW_I"] = 18] = "PAYMENT_NEW_I";
                Remark[Remark["PAYMENT_NEW_SIGN_SYMBOL"] = 19] = "PAYMENT_NEW_SIGN_SYMBOL";
                Remark[Remark["PAYMENT_REPORTING_MIXED"] = 20] = "PAYMENT_REPORTING_MIXED";
                Remark[Remark["REQUEST_PUBLISHED"] = 21] = "REQUEST_PUBLISHED";
                Remark[Remark["YEAREND_BEFORE"] = 22] = "YEAREND_BEFORE";
                Remark[Remark["YEAREND_CHANGE"] = 23] = "YEAREND_CHANGE";
                Remark[Remark["YEAREND_DELETED"] = 24] = "YEAREND_DELETED";
                Remark[Remark["YEAREND_TAXRELEVANTCHANGE"] = 25] = "YEAREND_TAXRELEVANTCHANGE";
                Remark[Remark["YEAREND_TAXRELEVANTCHANGE_BASHDA"] = 26] = "YEAREND_TAXRELEVANTCHANGE_BASHDA";
                Remark[Remark["YEAREND_TAXRELEVANTCHANGE_CAPITAL"] = 27] = "YEAREND_TAXRELEVANTCHANGE_CAPITAL";
                Remark[Remark["YEAREND_TAXRELEVANTCHANGE_CAPKEY"] = 28] = "YEAREND_TAXRELEVANTCHANGE_CAPKEY";
                Remark[Remark["YEAREND_TAXRELEVANTCHANGE_CHANGEOFOWNERSHIP"] = 29] = "YEAREND_TAXRELEVANTCHANGE_CHANGEOFOWNERSHIP";
                Remark[Remark["YEAREND_TAXRELEVANTCHANGE_HOLDER"] = 30] = "YEAREND_TAXRELEVANTCHANGE_HOLDER";
                Remark[Remark["YEAREND_TAXRELEVANTCHANGE_HOLDERATTACHMENT"] = 31] = "YEAREND_TAXRELEVANTCHANGE_HOLDERATTACHMENT";
                Remark[Remark["YEAREND_TAXRELEVANTCHANGE_IIIPUR"] = 32] = "YEAREND_TAXRELEVANTCHANGE_IIIPUR";
                Remark[Remark["YEAREND_TAXRELEVANTCHANGE_IIISTA"] = 33] = "YEAREND_TAXRELEVANTCHANGE_IIISTA";
                Remark[Remark["YEAREND_TAXRELEVANTCHANGE_IIISTA_INFOUNDATION"] = 34] = "YEAREND_TAXRELEVANTCHANGE_IIISTA_INFOUNDATION";
                Remark[Remark["YEAREND_TAXRELEVANTCHANGE_IIRSTA"] = 35] = "YEAREND_TAXRELEVANTCHANGE_IIRSTA";
                Remark[Remark["YEAREND_TAXRELEVANTCHANGE_LEGFOR"] = 36] = "YEAREND_TAXRELEVANTCHANGE_LEGFOR";
                Remark[Remark["YEAREND_TAXRELEVANTCHANGE_LIBERALIZED"] = 37] = "YEAREND_TAXRELEVANTCHANGE_LIBERALIZED";
                Remark[Remark["YEAREND_TAXRELEVANTCHANGE_NOMINALAMOUNT"] = 38] = "YEAREND_TAXRELEVANTCHANGE_NOMINALAMOUNT";
                Remark[Remark["YEAREND_TAXRELEVANTCHANGE_OTHER"] = 39] = "YEAREND_TAXRELEVANTCHANGE_OTHER";
                Remark[Remark["YEAREND_TAXRELEVANTCHANGE_QUANTITY"] = 40] = "YEAREND_TAXRELEVANTCHANGE_QUANTITY";
                Remark[Remark["YEAREND_TAXRELEVANTCHANGE_REORGANISATION"] = 41] = "YEAREND_TAXRELEVANTCHANGE_REORGANISATION";
                Remark[Remark["YEAREND_TAXRELEVANTCHANGE_VALSTA"] = 42] = "YEAREND_TAXRELEVANTCHANGE_VALSTA";
            })(Remark || exports_1("Remark", Remark = {}));
            (function (RequestReason) {
                RequestReason[RequestReason["DAILY"] = 0] = "DAILY";
                RequestReason[RequestReason["EARNING"] = 1] = "EARNING";
                RequestReason[RequestReason["EARNINGWITHDOC"] = 2] = "EARNINGWITHDOC";
                RequestReason[RequestReason["OTHER"] = 3] = "OTHER";
                RequestReason[RequestReason["PUBLICATION"] = 4] = "PUBLICATION";
                RequestReason[RequestReason["REORGANIZATION"] = 5] = "REORGANIZATION";
            })(RequestReason || exports_1("RequestReason", RequestReason = {}));
            (function (RequestStatus) {
                RequestStatus[RequestStatus["CLOSED"] = 0] = "CLOSED";
                RequestStatus[RequestStatus["DENIED"] = 1] = "DENIED";
                RequestStatus[RequestStatus["INQUIRY"] = 2] = "INQUIRY";
                RequestStatus[RequestStatus["OPEN"] = 3] = "OPEN";
            })(RequestStatus || exports_1("RequestStatus", RequestStatus = {}));
            (function (Schema) {
                Schema[Schema["ICT"] = 0] = "ICT";
                Schema[Schema["INQ"] = 1] = "INQ";
                Schema[Schema["IOQ"] = 2] = "IOQ";
            })(Schema || exports_1("Schema", Schema = {}));
            (function (Sector) {
                Sector[Sector["A"] = 0] = "A";
                Sector[Sector["B"] = 1] = "B";
                Sector[Sector["C"] = 2] = "C";
                Sector[Sector["D"] = 3] = "D";
                Sector[Sector["E"] = 4] = "E";
                Sector[Sector["F"] = 5] = "F";
                Sector[Sector["G"] = 6] = "G";
                Sector[Sector["H"] = 7] = "H";
                Sector[Sector["I"] = 8] = "I";
                Sector[Sector["J"] = 9] = "J";
            })(Sector || exports_1("Sector", Sector = {}));
            (function (ServiceType) {
                ServiceType[ServiceType["CALC_CONVERTIBLE"] = 0] = "CALC_CONVERTIBLE";
                ServiceType[ServiceType["CALC_INSTRUMENT"] = 1] = "CALC_INSTRUMENT";
                ServiceType[ServiceType["CALC_IUP"] = 2] = "CALC_IUP";
                ServiceType[ServiceType["CALC_LISTOFSECURITIES"] = 3] = "CALC_LISTOFSECURITIES";
                ServiceType[ServiceType["CALC_SECURITY"] = 4] = "CALC_SECURITY";
                ServiceType[ServiceType["CALC_SECURITY220"] = 5] = "CALC_SECURITY220";
                ServiceType[ServiceType["CALC_SECURITYLIST220"] = 6] = "CALC_SECURITYLIST220";
                ServiceType[ServiceType["EXISTS_INSTRUMENT"] = 7] = "EXISTS_INSTRUMENT";
                ServiceType[ServiceType["EXISTS_REQUEST"] = 8] = "EXISTS_REQUEST";
                ServiceType[ServiceType["EXISTS_SECURITY"] = 9] = "EXISTS_SECURITY";
                ServiceType[ServiceType["EXISTS_SECURITY220"] = 10] = "EXISTS_SECURITY220";
                ServiceType[ServiceType["EXISTS_SECURITYREQUEST"] = 11] = "EXISTS_SECURITYREQUEST";
                ServiceType[ServiceType["EXISTS_SECURITYREQUEST220"] = 12] = "EXISTS_SECURITYREQUEST220";
                ServiceType[ServiceType["GDC"] = 13] = "GDC";
                ServiceType[ServiceType["PROCESS_GDC"] = 14] = "PROCESS_GDC";
                ServiceType[ServiceType["SEARCH_ATTACHMENT"] = 15] = "SEARCH_ATTACHMENT";
                ServiceType[ServiceType["SEARCH_CAPITALISATIONRATE"] = 16] = "SEARCH_CAPITALISATIONRATE";
                ServiceType[ServiceType["SEARCH_CAPITALISATIONRATE220"] = 17] = "SEARCH_CAPITALISATIONRATE220";
                ServiceType[ServiceType["SEARCH_COUNTRY"] = 18] = "SEARCH_COUNTRY";
                ServiceType[ServiceType["SEARCH_COUNTRY220"] = 19] = "SEARCH_COUNTRY220";
                ServiceType[ServiceType["SEARCH_CURRENCY"] = 20] = "SEARCH_CURRENCY";
                ServiceType[ServiceType["SEARCH_CURRENCY220"] = 21] = "SEARCH_CURRENCY220";
                ServiceType[ServiceType["SEARCH_DARATE"] = 22] = "SEARCH_DARATE";
                ServiceType[ServiceType["SEARCH_DARATE220"] = 23] = "SEARCH_DARATE220";
                ServiceType[ServiceType["SEARCH_EXCHANGERATE"] = 24] = "SEARCH_EXCHANGERATE";
                ServiceType[ServiceType["SEARCH_EXCHANGERATE220"] = 25] = "SEARCH_EXCHANGERATE220";
                ServiceType[ServiceType["SEARCH_EXCHANGERATEMONTHLY"] = 26] = "SEARCH_EXCHANGERATEMONTHLY";
                ServiceType[ServiceType["SEARCH_EXCHANGERATEMONTHLY220"] = 27] = "SEARCH_EXCHANGERATEMONTHLY220";
                ServiceType[ServiceType["SEARCH_EXCHANGERATEYEAREND"] = 28] = "SEARCH_EXCHANGERATEYEAREND";
                ServiceType[ServiceType["SEARCH_EXCHANGERATEYEAREND220"] = 29] = "SEARCH_EXCHANGERATEYEAREND220";
                ServiceType[ServiceType["SEARCH_INSTITUTION"] = 30] = "SEARCH_INSTITUTION";
                ServiceType[ServiceType["SEARCH_INSTITUTIONALLSCOPES"] = 31] = "SEARCH_INSTITUTIONALLSCOPES";
                ServiceType[ServiceType["SEARCH_INSTITUTIONREQUEST"] = 32] = "SEARCH_INSTITUTIONREQUEST";
                ServiceType[ServiceType["SEARCH_INSTRUMENT"] = 33] = "SEARCH_INSTRUMENT";
                ServiceType[ServiceType["SEARCH_MANDATORYREGISTRATION"] = 34] = "SEARCH_MANDATORYREGISTRATION";
                ServiceType[ServiceType["SEARCH_NOTIFICATION"] = 35] = "SEARCH_NOTIFICATION";
                ServiceType[ServiceType["SEARCH_REQUEST"] = 36] = "SEARCH_REQUEST";
                ServiceType[ServiceType["SEARCH_SECURITY"] = 37] = "SEARCH_SECURITY";
                ServiceType[ServiceType["SEARCH_SECURITY220"] = 38] = "SEARCH_SECURITY220";
                ServiceType[ServiceType["SEARCH_SECURITYALLSCOPES"] = 39] = "SEARCH_SECURITYALLSCOPES";
                ServiceType[ServiceType["SEARCH_SECURITYINSTANT"] = 40] = "SEARCH_SECURITYINSTANT";
                ServiceType[ServiceType["SEARCH_SECURITYREQUEST"] = 41] = "SEARCH_SECURITYREQUEST";
                ServiceType[ServiceType["SEARCH_SECURITYREQUEST220"] = 42] = "SEARCH_SECURITYREQUEST220";
                ServiceType[ServiceType["SEARCH_VALUATIONORDER"] = 43] = "SEARCH_VALUATIONORDER";
                ServiceType[ServiceType["SET_INSTITUTION"] = 44] = "SET_INSTITUTION";
                ServiceType[ServiceType["SET_INSTITUTIONREQUEST"] = 45] = "SET_INSTITUTIONREQUEST";
                ServiceType[ServiceType["SET_NOTIFICATION"] = 46] = "SET_NOTIFICATION";
                ServiceType[ServiceType["SET_REQUEST"] = 47] = "SET_REQUEST";
                ServiceType[ServiceType["SET_SECURITY"] = 48] = "SET_SECURITY";
                ServiceType[ServiceType["SET_SECURITYREQUEST"] = 49] = "SET_SECURITYREQUEST";
                ServiceType[ServiceType["SET_SECURITYREQUEST220"] = 50] = "SET_SECURITYREQUEST220";
                ServiceType[ServiceType["SET_TAXVALUE"] = 51] = "SET_TAXVALUE";
                ServiceType[ServiceType["SET_VALUATIONORDER"] = 52] = "SET_VALUATIONORDER";
            })(ServiceType || exports_1("ServiceType", ServiceType = {}));
            (function (ShareholderType) {
                ShareholderType[ShareholderType["LEGAL"] = 0] = "LEGAL";
                ShareholderType[ShareholderType["NATURAL"] = 1] = "NATURAL";
            })(ShareholderType || exports_1("ShareholderType", ShareholderType = {}));
            (function (STOLISPaymentType) {
                STOLISPaymentType[STOLISPaymentType["AO_PERCENT"] = 0] = "AO_PERCENT";
                STOLISPaymentType[STOLISPaymentType["BON"] = 1] = "BON";
                STOLISPaymentType[STOLISPaymentType["DIV"] = 2] = "DIV";
                STOLISPaymentType[STOLISPaymentType["GA"] = 3] = "GA";
                STOLISPaymentType[STOLISPaymentType["INT"] = 4] = "INT";
                STOLISPaymentType[STOLISPaymentType["KEP"] = 5] = "KEP";
                STOLISPaymentType[STOLISPaymentType["LIQ"] = 6] = "LIQ";
                STOLISPaymentType[STOLISPaymentType["NAT"] = 7] = "NAT";
                STOLISPaymentType[STOLISPaymentType["PRO"] = 8] = "PRO";
                STOLISPaymentType[STOLISPaymentType["TLQ"] = 9] = "TLQ";
                STOLISPaymentType[STOLISPaymentType["W15"] = 10] = "W15";
            })(STOLISPaymentType || exports_1("STOLISPaymentType", STOLISPaymentType = {}));
            (function (StockExchangeRuleType) {
                StockExchangeRuleType[StockExchangeRuleType["ADR"] = 0] = "ADR";
                StockExchangeRuleType[StockExchangeRuleType["ALTERNATIVE"] = 1] = "ALTERNATIVE";
                StockExchangeRuleType[StockExchangeRuleType["DOMICILE"] = 2] = "DOMICILE";
                StockExchangeRuleType[StockExchangeRuleType["EXCLUDE_UNUSEABLE"] = 3] = "EXCLUDE_UNUSEABLE";
                StockExchangeRuleType[StockExchangeRuleType["EXCLUDE_WITHCOSTS"] = 4] = "EXCLUDE_WITHCOSTS";
                StockExchangeRuleType[StockExchangeRuleType["GLOBAL"] = 5] = "GLOBAL";
                StockExchangeRuleType[StockExchangeRuleType["ISSUER"] = 6] = "ISSUER";
                StockExchangeRuleType[StockExchangeRuleType["MOSTLIQUID"] = 7] = "MOSTLIQUID";
                StockExchangeRuleType[StockExchangeRuleType["ORIGINAL"] = 8] = "ORIGINAL";
            })(StockExchangeRuleType || exports_1("StockExchangeRuleType", StockExchangeRuleType = {}));
            (function (SystemMessageType) {
                SystemMessageType[SystemMessageType["NOTPUBLISHED"] = 0] = "NOTPUBLISHED";
            })(SystemMessageType || exports_1("SystemMessageType", SystemMessageType = {}));
            (function (TargetGroup) {
                TargetGroup[TargetGroup["KURSLISTE"] = 0] = "KURSLISTE";
                TargetGroup[TargetGroup["KURSLISTE_1"] = 1] = "KURSLISTE_1";
                TargetGroup[TargetGroup["KURSLISTE_2"] = 2] = "KURSLISTE_2";
                TargetGroup[TargetGroup["KURSLISTE_CORRECTION"] = 3] = "KURSLISTE_CORRECTION";
                TargetGroup[TargetGroup["KURSLISTE_CORRECTION_1"] = 4] = "KURSLISTE_CORRECTION_1";
                TargetGroup[TargetGroup["KURSLISTE_CORRECTION_2"] = 5] = "KURSLISTE_CORRECTION_2";
                TargetGroup[TargetGroup["KURSLISTE_CORRECTION_HB"] = 6] = "KURSLISTE_CORRECTION_HB";
                TargetGroup[TargetGroup["KURSLISTE_CORRECTION_HB_1"] = 7] = "KURSLISTE_CORRECTION_HB_1";
                TargetGroup[TargetGroup["KURSLISTE_CORRECTION_HB_2"] = 8] = "KURSLISTE_CORRECTION_HB_2";
                TargetGroup[TargetGroup["KURSLISTE_EXTENSION"] = 9] = "KURSLISTE_EXTENSION";
                TargetGroup[TargetGroup["KURSLISTE_EXTENSION_1"] = 10] = "KURSLISTE_EXTENSION_1";
                TargetGroup[TargetGroup["KURSLISTE_EXTENSION_2"] = 11] = "KURSLISTE_EXTENSION_2";
                TargetGroup[TargetGroup["KURSLISTE_EXTENSION_HB"] = 12] = "KURSLISTE_EXTENSION_HB";
                TargetGroup[TargetGroup["KURSLISTE_EXTENSION_HB_1"] = 13] = "KURSLISTE_EXTENSION_HB_1";
                TargetGroup[TargetGroup["KURSLISTE_EXTENSION_HB_2"] = 14] = "KURSLISTE_EXTENSION_HB_2";
                TargetGroup[TargetGroup["KURSLISTE_HB"] = 15] = "KURSLISTE_HB";
                TargetGroup[TargetGroup["KURSLISTE_HB_1"] = 16] = "KURSLISTE_HB_1";
                TargetGroup[TargetGroup["KURSLISTE_HB_2"] = 17] = "KURSLISTE_HB_2";
            })(TargetGroup || exports_1("TargetGroup", TargetGroup = {}));
            (function (TaxValueType) {
                TaxValueType[TaxValueType["CANTON"] = 0] = "CANTON";
                TaxValueType[TaxValueType["CH"] = 1] = "CH";
                TaxValueType[TaxValueType["SHAREHOLDER"] = 2] = "SHAREHOLDER";
            })(TaxValueType || exports_1("TaxValueType", TaxValueType = {}));
            (function (TaxEventType) {
                TaxEventType[TaxEventType["BOND_BONDFLOORONCE"] = 0] = "BOND_BONDFLOORONCE";
                TaxEventType[TaxEventType["BOND_CHBINTERESTWITHOUT"] = 1] = "BOND_CHBINTERESTWITHOUT";
                TaxEventType[TaxEventType["BOND_ISSUEDISAGIO"] = 2] = "BOND_ISSUEDISAGIO";
                TaxEventType[TaxEventType["BOND_REDEMPTIONAGIO"] = 3] = "BOND_REDEMPTIONAGIO";
                TaxEventType[TaxEventType["DEVT_BONDFLOORONCE"] = 4] = "DEVT_BONDFLOORONCE";
                TaxEventType[TaxEventType["DEVT_FUNDSIMILARASSET"] = 5] = "DEVT_FUNDSIMILARASSET";
                TaxEventType[TaxEventType["DEVT_INDEXBASKET"] = 6] = "DEVT_INDEXBASKET";
                TaxEventType[TaxEventType["FUND_ACCUMULATION"] = 7] = "FUND_ACCUMULATION";
                TaxEventType[TaxEventType["FUND_INSTITUTION"] = 8] = "FUND_INSTITUTION";
                TaxEventType[TaxEventType["SHARE_GRATIS"] = 9] = "SHARE_GRATIS";
                TaxEventType[TaxEventType["SHARE_OTHER"] = 10] = "SHARE_OTHER";
                TaxEventType[TaxEventType["SHARE_PORTFOLIO"] = 11] = "SHARE_PORTFOLIO";
            })(TaxEventType || exports_1("TaxEventType", TaxEventType = {}));
            (function (TemplateType) {
                TemplateType[TemplateType["KURSLISTE_FOOTER"] = 0] = "KURSLISTE_FOOTER";
                TemplateType[TemplateType["KURSLISTE_GENERATION"] = 1] = "KURSLISTE_GENERATION";
                TemplateType[TemplateType["KURSLISTE_HEADER"] = 2] = "KURSLISTE_HEADER";
                TemplateType[TemplateType["KURSLISTE_HOME"] = 3] = "KURSLISTE_HOME";
                TemplateType[TemplateType["KURSLISTE_INDEX"] = 4] = "KURSLISTE_INDEX";
                TemplateType[TemplateType["KURSLISTE_ONLINE"] = 5] = "KURSLISTE_ONLINE";
                TemplateType[TemplateType["MAIL_ACCOUNT_CONFIRMATION"] = 6] = "MAIL_ACCOUNT_CONFIRMATION";
                TemplateType[TemplateType["MAIL_EARNING_DECLARE_CREATED"] = 7] = "MAIL_EARNING_DECLARE_CREATED";
                TemplateType[TemplateType["MAIL_EARNING_DECLARE_MESSAGE_ADDED"] = 8] = "MAIL_EARNING_DECLARE_MESSAGE_ADDED";
                TemplateType[TemplateType["MAIL_EARNING_DECLARE_STATUS_CHANGED"] = 9] = "MAIL_EARNING_DECLARE_STATUS_CHANGED";
                TemplateType[TemplateType["MAIL_EXPORT"] = 10] = "MAIL_EXPORT";
                TemplateType[TemplateType["MAIL_LOST_PASSWORD"] = 11] = "MAIL_LOST_PASSWORD";
                TemplateType[TemplateType["MAIL_NEW_PASSWORD"] = 12] = "MAIL_NEW_PASSWORD";
                TemplateType[TemplateType["MAIL_REQUEST_CREATED"] = 13] = "MAIL_REQUEST_CREATED";
                TemplateType[TemplateType["MAIL_REQUEST_MESSAGE_ADDED"] = 14] = "MAIL_REQUEST_MESSAGE_ADDED";
                TemplateType[TemplateType["MAIL_STATUS_CHANGED"] = 15] = "MAIL_STATUS_CHANGED";
                TemplateType[TemplateType["MAIL_VALOR"] = 16] = "MAIL_VALOR";
                TemplateType[TemplateType["NEWSLETTER"] = 17] = "NEWSLETTER";
            })(TemplateType || exports_1("TemplateType", TemplateType = {}));
            (function (ValuationStatus) {
                ValuationStatus[ValuationStatus["ACTIVE"] = 0] = "ACTIVE";
                ValuationStatus[ValuationStatus["INACTIVE"] = 1] = "INACTIVE";
                ValuationStatus[ValuationStatus["INCONVERSION"] = 2] = "INCONVERSION";
                ValuationStatus[ValuationStatus["INFOUNDATION"] = 3] = "INFOUNDATION";
                ValuationStatus[ValuationStatus["INLIQUIDATION"] = 4] = "INLIQUIDATION";
                ValuationStatus[ValuationStatus["NONOPERATIONAL"] = 5] = "NONOPERATIONAL";
            })(ValuationStatus || exports_1("ValuationStatus", ValuationStatus = {}));
            (function (ValuationOrderStatus) {
                ValuationOrderStatus[ValuationOrderStatus["APPROVED"] = 0] = "APPROVED";
                ValuationOrderStatus[ValuationOrderStatus["ASSIGNED"] = 1] = "ASSIGNED";
                ValuationOrderStatus[ValuationOrderStatus["CLOSED"] = 2] = "CLOSED";
                ValuationOrderStatus[ValuationOrderStatus["DEFERRED"] = 3] = "DEFERRED";
                ValuationOrderStatus[ValuationOrderStatus["DENIED"] = 4] = "DENIED";
                ValuationOrderStatus[ValuationOrderStatus["INQUIRY"] = 5] = "INQUIRY";
                ValuationOrderStatus[ValuationOrderStatus["OPEN"] = 6] = "OPEN";
                ValuationOrderStatus[ValuationOrderStatus["PROCESS"] = 7] = "PROCESS";
            })(ValuationOrderStatus || exports_1("ValuationOrderStatus", ValuationOrderStatus = {}));
            (function (WeekDay) {
                WeekDay[WeekDay["_1"] = 0] = "_1";
                WeekDay[WeekDay["_2"] = 1] = "_2";
                WeekDay[WeekDay["_3"] = 2] = "_3";
                WeekDay[WeekDay["_4"] = 3] = "_4";
                WeekDay[WeekDay["_5"] = 4] = "_5";
                WeekDay[WeekDay["_6"] = 5] = "_6";
                WeekDay[WeekDay["_7"] = 6] = "_7";
            })(WeekDay || exports_1("WeekDay", WeekDay = {}));
            (function (WeightUnit) {
                WeightUnit[WeightUnit["GRAM"] = 0] = "GRAM";
                WeightUnit[WeightUnit["OUNCE"] = 1] = "OUNCE";
                WeightUnit[WeightUnit["TOLA"] = 2] = "TOLA";
            })(WeightUnit || exports_1("WeightUnit", WeightUnit = {}));
            (function (WorkOrderMessageType) {
                WorkOrderMessageType[WorkOrderMessageType["_230"] = 0] = "_230";
                WorkOrderMessageType[WorkOrderMessageType["_237"] = 1] = "_237";
                WorkOrderMessageType[WorkOrderMessageType["_238"] = 2] = "_238";
                WorkOrderMessageType[WorkOrderMessageType["_242"] = 3] = "_242";
                WorkOrderMessageType[WorkOrderMessageType["_252"] = 4] = "_252";
                WorkOrderMessageType[WorkOrderMessageType["_276"] = 5] = "_276";
                WorkOrderMessageType[WorkOrderMessageType["_278"] = 6] = "_278";
                WorkOrderMessageType[WorkOrderMessageType["_279"] = 7] = "_279";
                WorkOrderMessageType[WorkOrderMessageType["_281"] = 8] = "_281";
                WorkOrderMessageType[WorkOrderMessageType["_297"] = 9] = "_297";
                WorkOrderMessageType[WorkOrderMessageType["_298"] = 10] = "_298";
                WorkOrderMessageType[WorkOrderMessageType["_379"] = 11] = "_379";
                WorkOrderMessageType[WorkOrderMessageType["_380"] = 12] = "_380";
                WorkOrderMessageType[WorkOrderMessageType["_381"] = 13] = "_381";
                WorkOrderMessageType[WorkOrderMessageType["_383"] = 14] = "_383";
                WorkOrderMessageType[WorkOrderMessageType["_387"] = 15] = "_387";
                WorkOrderMessageType[WorkOrderMessageType["_388"] = 16] = "_388";
                WorkOrderMessageType[WorkOrderMessageType["_400"] = 17] = "_400";
                WorkOrderMessageType[WorkOrderMessageType["_401"] = 18] = "_401";
                WorkOrderMessageType[WorkOrderMessageType["_413"] = 19] = "_413";
                WorkOrderMessageType[WorkOrderMessageType["_414"] = 20] = "_414";
                WorkOrderMessageType[WorkOrderMessageType["_440"] = 21] = "_440";
                WorkOrderMessageType[WorkOrderMessageType["_451"] = 22] = "_451";
                WorkOrderMessageType[WorkOrderMessageType["_461"] = 23] = "_461";
                WorkOrderMessageType[WorkOrderMessageType["_462"] = 24] = "_462";
                WorkOrderMessageType[WorkOrderMessageType["_481"] = 25] = "_481";
                WorkOrderMessageType[WorkOrderMessageType["_488"] = 26] = "_488";
                WorkOrderMessageType[WorkOrderMessageType["_490"] = 27] = "_490";
                WorkOrderMessageType[WorkOrderMessageType["_495"] = 28] = "_495";
                WorkOrderMessageType[WorkOrderMessageType["_550"] = 29] = "_550";
                WorkOrderMessageType[WorkOrderMessageType["_598"] = 30] = "_598";
                WorkOrderMessageType[WorkOrderMessageType["_650"] = 31] = "_650";
                WorkOrderMessageType[WorkOrderMessageType["_670"] = 32] = "_670";
            })(WorkOrderMessageType || exports_1("WorkOrderMessageType", WorkOrderMessageType = {}));
            (function (WorkOrderReason) {
                WorkOrderReason[WorkOrderReason["BALANCESHEETDATE"] = 0] = "BALANCESHEETDATE";
                WorkOrderReason[WorkOrderReason["BCN_CORR"] = 1] = "BCN_CORR";
                WorkOrderReason[WorkOrderReason["BCN_NEW"] = 2] = "BCN_NEW";
                WorkOrderReason[WorkOrderReason["CANCELLATION"] = 3] = "CANCELLATION";
                WorkOrderReason[WorkOrderReason["CAPCONRESERVE"] = 4] = "CAPCONRESERVE";
                WorkOrderReason[WorkOrderReason["COUNTRY"] = 5] = "COUNTRY";
                WorkOrderReason[WorkOrderReason["CURRENCY"] = 6] = "CURRENCY";
                WorkOrderReason[WorkOrderReason["DAILY"] = 7] = "DAILY";
                WorkOrderReason[WorkOrderReason["DELETE"] = 8] = "DELETE";
                WorkOrderReason[WorkOrderReason["DOCUMENT"] = 9] = "DOCUMENT";
                WorkOrderReason[WorkOrderReason["EARNING"] = 10] = "EARNING";
                WorkOrderReason[WorkOrderReason["IIRTYP"] = 11] = "IIRTYP";
                WorkOrderReason[WorkOrderReason["INACTIVE"] = 12] = "INACTIVE";
                WorkOrderReason[WorkOrderReason["INCREASE"] = 13] = "INCREASE";
                WorkOrderReason[WorkOrderReason["INSTITUTION"] = 14] = "INSTITUTION";
                WorkOrderReason[WorkOrderReason["INSTRUMENT"] = 15] = "INSTRUMENT";
                WorkOrderReason[WorkOrderReason["ISSUE"] = 16] = "ISSUE";
                WorkOrderReason[WorkOrderReason["ISSUEPRICE"] = 17] = "ISSUEPRICE";
                WorkOrderReason[WorkOrderReason["ISSUEWITHDRAWN"] = 18] = "ISSUEWITHDRAWN";
                WorkOrderReason[WorkOrderReason["LIQUIDATION"] = 19] = "LIQUIDATION";
                WorkOrderReason[WorkOrderReason["MUTATION"] = 20] = "MUTATION";
                WorkOrderReason[WorkOrderReason["NEW"] = 21] = "NEW";
                WorkOrderReason[WorkOrderReason["NOMINAL"] = 22] = "NOMINAL";
                WorkOrderReason[WorkOrderReason["PUBREQ"] = 23] = "PUBREQ";
                WorkOrderReason[WorkOrderReason["REDEMPTION"] = 24] = "REDEMPTION";
                WorkOrderReason[WorkOrderReason["REDEMPTIONEARLY"] = 25] = "REDEMPTIONEARLY";
                WorkOrderReason[WorkOrderReason["REDEMPTIONPRICE"] = 26] = "REDEMPTIONPRICE";
                WorkOrderReason[WorkOrderReason["REQUEST"] = 27] = "REQUEST";
                WorkOrderReason[WorkOrderReason["YEAREND"] = 28] = "YEAREND";
            })(WorkOrderReason || exports_1("WorkOrderReason", WorkOrderReason = {}));
            (function (WorkOrderType) {
                WorkOrderType[WorkOrderType["DOCUMENT"] = 0] = "DOCUMENT";
                WorkOrderType[WorkOrderType["EARNING"] = 1] = "EARNING";
                WorkOrderType[WorkOrderType["INSTITUTION"] = 2] = "INSTITUTION";
                WorkOrderType[WorkOrderType["INSTITUTION_EVENT"] = 3] = "INSTITUTION_EVENT";
                WorkOrderType[WorkOrderType["INSTRUMENT"] = 4] = "INSTRUMENT";
                WorkOrderType[WorkOrderType["INSTRUMENT_EVENT"] = 5] = "INSTRUMENT_EVENT";
                WorkOrderType[WorkOrderType["REQUEST"] = 6] = "REQUEST";
            })(WorkOrderType || exports_1("WorkOrderType", WorkOrderType = {}));
            (function (WeekShortCutDay) {
                WeekShortCutDay[WeekShortCutDay["_1"] = 0] = "_1";
                WeekShortCutDay[WeekShortCutDay["_2"] = 1] = "_2";
                WeekShortCutDay[WeekShortCutDay["_3"] = 2] = "_3";
                WeekShortCutDay[WeekShortCutDay["_4"] = 3] = "_4";
                WeekShortCutDay[WeekShortCutDay["_5"] = 4] = "_5";
                WeekShortCutDay[WeekShortCutDay["_6"] = 5] = "_6";
                WeekShortCutDay[WeekShortCutDay["_7"] = 6] = "_7";
            })(WeekShortCutDay || exports_1("WeekShortCutDay", WeekShortCutDay = {}));
            (function (Holder) {
                Holder[Holder["EMHO"] = 0] = "EMHO";
                Holder[Holder["EMNA"] = 1] = "EMNA";
                Holder[Holder["HOLD"] = 2] = "HOLD";
                Holder[Holder["NAME"] = 3] = "NAME";
                Holder[Holder["OWHO"] = 4] = "OWHO";
                Holder[Holder["OWNA"] = 5] = "OWNA";
            })(Holder || exports_1("Holder", Holder = {}));
            (function (Marketability) {
                Marketability[Marketability["BLOC"] = 0] = "BLOC";
                Marketability[Marketability["CDBC"] = 1] = "CDBC";
                Marketability[Marketability["COND"] = 2] = "COND";
                Marketability[Marketability["FREE"] = 3] = "FREE";
                Marketability[Marketability["VINK"] = 4] = "VINK";
            })(Marketability || exports_1("Marketability", Marketability = {}));
            (function (Maturity) {
                Maturity[Maturity["LONG"] = 0] = "LONG";
                Maturity[Maturity["SHOR"] = 1] = "SHOR";
            })(Maturity || exports_1("Maturity", Maturity = {}));
            (function (Priority) {
                Priority[Priority["PRIOLIQU"] = 0] = "PRIOLIQU";
                Priority[Priority["PRIOPRLI"] = 1] = "PRIOPRLI";
                Priority[Priority["PRIOPROF"] = 2] = "PRIOPROF";
            })(Priority || exports_1("Priority", Priority = {}));
            (function (SecuritySubType) {
                SecuritySubType[SecuritySubType["BONDCANT"] = 0] = "BONDCANT";
                SecuritySubType[SecuritySubType["BONDCOBD"] = 1] = "BONDCOBD";
                SecuritySubType[SecuritySubType["BONDFEDL"] = 2] = "BONDFEDL";
                SecuritySubType[SecuritySubType["BONDMUNL"] = 3] = "BONDMUNL";
                SecuritySubType[SecuritySubType["BONDOPBD"] = 4] = "BONDOPBD";
                SecuritySubType[SecuritySubType["BONDOTHR"] = 5] = "BONDOTHR";
                SecuritySubType[SecuritySubType["BONDSTAT"] = 6] = "BONDSTAT";
                SecuritySubType[SecuritySubType["COBUCNGO"] = 7] = "COBUCNGO";
                SecuritySubType[SecuritySubType["COBUPALL"] = 8] = "COBUPALL";
                SecuritySubType[SecuritySubType["COBUPLAT"] = 9] = "COBUPLAT";
                SecuritySubType[SecuritySubType["COBUSILV"] = 10] = "COBUSILV";
                SecuritySubType[SecuritySubType["COOPCOMM"] = 11] = "COOPCOMM";
                SecuritySubType[SecuritySubType["DEVTCAPL"] = 12] = "DEVTCAPL";
                SecuritySubType[SecuritySubType["DEVTCECH"] = 13] = "DEVTCECH";
                SecuritySubType[SecuritySubType["DEVTCEFO"] = 14] = "DEVTCEFO";
                SecuritySubType[SecuritySubType["DEVTCOMB"] = 15] = "DEVTCOMB";
                SecuritySubType[SecuritySubType["DEVTIPCH"] = 16] = "DEVTIPCH";
                SecuritySubType[SecuritySubType["DEVTIPFO"] = 17] = "DEVTIPFO";
                SecuritySubType[SecuritySubType["FODNCOMM"] = 18] = "FODNCOMM";
                SecuritySubType[SecuritySubType["FUNDCHTH"] = 19] = "FUNDCHTH";
                SecuritySubType[SecuritySubType["FUNDFOCY"] = 20] = "FUNDFOCY";
                SecuritySubType[SecuritySubType["FUNDFOPT"] = 21] = "FUNDFOPT";
                SecuritySubType[SecuritySubType["FUNDFOTH"] = 22] = "FUNDFOTH";
                SecuritySubType[SecuritySubType["FUNDIMMO"] = 23] = "FUNDIMMO";
                SecuritySubType[SecuritySubType["FUNDSITH"] = 24] = "FUNDSITH";
                SecuritySubType[SecuritySubType["FUNDSUIS"] = 25] = "FUNDSUIS";
                SecuritySubType[SecuritySubType["FUNDUSAF"] = 26] = "FUNDUSAF";
                SecuritySubType[SecuritySubType["GSAKCOMM"] = 27] = "GSAKCOMM";
                SecuritySubType[SecuritySubType["GSPAPRIO"] = 28] = "GSPAPRIO";
                SecuritySubType[SecuritySubType["GSSHPRIO"] = 29] = "GSSHPRIO";
                SecuritySubType[SecuritySubType["GSSNPRIO"] = 30] = "GSSNPRIO";
                SecuritySubType[SecuritySubType["GSSNPRLI"] = 31] = "GSSNPRLI";
                SecuritySubType[SecuritySubType["GSSNPROF"] = 32] = "GSSNPROF";
                SecuritySubType[SecuritySubType["PA08COMM"] = 33] = "PA08COMM";
                SecuritySubType[SecuritySubType["PA08PRIO"] = 34] = "PA08PRIO";
                SecuritySubType[SecuritySubType["PAGSCOMM"] = 35] = "PAGSCOMM";
                SecuritySubType[SecuritySubType["PAGSPRIO"] = 36] = "PAGSPRIO";
                SecuritySubType[SecuritySubType["PARTCOMM"] = 37] = "PARTCOMM";
                SecuritySubType[SecuritySubType["PARTPRIO"] = 38] = "PARTPRIO";
                SecuritySubType[SecuritySubType["PTCTCOMM"] = 39] = "PTCTCOMM";
                SecuritySubType[SecuritySubType["PTCTPRIO"] = 40] = "PTCTPRIO";
                SecuritySubType[SecuritySubType["SHARCOMM"] = 41] = "SHARCOMM";
                SecuritySubType[SecuritySubType["SHARPRIO"] = 42] = "SHARPRIO";
                SecuritySubType[SecuritySubType["SHGSCOMM"] = 43] = "SHGSCOMM";
                SecuritySubType[SecuritySubType["SHGSPRIO"] = 44] = "SHGSPRIO";
                SecuritySubType[SecuritySubType["TWINCOMM"] = 45] = "TWINCOMM";
                SecuritySubType[SecuritySubType["TWINPRIO"] = 46] = "TWINPRIO";
            })(SecuritySubType || exports_1("SecuritySubType", SecuritySubType = {}));
            (function (SecurityType) {
                SecurityType[SecurityType["BOND"] = 0] = "BOND";
                SecurityType[SecurityType["COBU"] = 1] = "COBU";
                SecurityType[SecurityType["COOP"] = 2] = "COOP";
                SecurityType[SecurityType["DEVT"] = 3] = "DEVT";
                SecurityType[SecurityType["FODN"] = 4] = "FODN";
                SecurityType[SecurityType["FUND"] = 5] = "FUND";
                SecurityType[SecurityType["GSAK"] = 6] = "GSAK";
                SecurityType[SecurityType["GSPA"] = 7] = "GSPA";
                SecurityType[SecurityType["GSSH"] = 8] = "GSSH";
                SecurityType[SecurityType["GSSN"] = 9] = "GSSN";
                SecurityType[SecurityType["OPTN"] = 10] = "OPTN";
                SecurityType[SecurityType["OTH"] = 11] = "OTH";
                SecurityType[SecurityType["PA08"] = 12] = "PA08";
                SecurityType[SecurityType["PAGS"] = 13] = "PAGS";
                SecurityType[SecurityType["PART"] = 14] = "PART";
                SecurityType[SecurityType["PTCT"] = 15] = "PTCT";
                SecurityType[SecurityType["SHAR"] = 16] = "SHAR";
                SecurityType[SecurityType["SHGS"] = 17] = "SHGS";
                SecurityType[SecurityType["TWIN"] = 18] = "TWIN";
            })(SecurityType || exports_1("SecurityType", SecurityType = {}));
        }
    };
});

System.register("ict-core-client/gen/viewmodels/coinbullion_gadget_instrument_view_model.js", ["ags-client/ags-client.js", "ict-core-client/gen/viewmodels/language_string_view_model.js", "ict-core-client/gen/enums.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, language_string_view_model_1, ags_client_2, ags_client_3, enums_1, ags_client_4, CoinbullionGadgetInstrumentViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
        }, function (language_string_view_model_1_1) {
            language_string_view_model_1 = language_string_view_model_1_1;
        }, function (enums_1_1) {
            enums_1 = enums_1_1;
        }],
        execute: function () {
            CoinbullionGadgetInstrumentViewModel = /** @class */function () {
                function CoinbullionGadgetInstrumentViewModel() {}
                CoinbullionGadgetInstrumentViewModel.deserialize = function (object) {
                    var _result = new CoinbullionGadgetInstrumentViewModel();
                    return _result._deserialize(object);
                };
                CoinbullionGadgetInstrumentViewModel.prototype._deserialize = function (object) {
                    var _this = this;
                    if (object) {
                        if (ags_client_1.isPresent(object['valorNumber'])) {
                            this.valorNumber = object['valorNumber'];
                        }
                        if (ags_client_1.isPresent(object['name'])) {
                            this.name = [];
                            object['name'].forEach(function (item) {
                                _this.name.push(language_string_view_model_1.LanguageStringViewModel.deserialize(item));
                            });
                        }
                        if (ags_client_1.isPresent(object['appendix'])) {
                            this.appendix = [];
                            object['appendix'].forEach(function (item) {
                                _this.appendix.push(language_string_view_model_1.LanguageStringViewModel.deserialize(item));
                            });
                        }
                        if (ags_client_1.isPresent(object['instrumentType'])) {
                            this.instrumentType = ags_client_3.enumNumberValue(ags_client_2.InstrumentType, object['instrumentType']);
                        }
                        if (ags_client_1.isPresent(object['weight'])) {
                            this.weight = object['weight'];
                        }
                        if (ags_client_1.isPresent(object['weightUnit'])) {
                            this.weightUnit = ags_client_3.enumNumberValue(enums_1.WeightUnit, object['weightUnit']);
                        }
                        if (ags_client_1.isPresent(object['currency'])) {
                            this.currency = new ags_client_4.Currency(object['currency']['shortName']);
                        }
                        if (ags_client_1.isPresent(object['value'])) {
                            this.value = object['value'];
                        }
                    }
                    return this;
                };
                CoinbullionGadgetInstrumentViewModel.prototype.serialize = function () {
                    var object = {};
                    if (ags_client_1.isPresent(this.valorNumber)) {
                        object['valorNumber'] = this.valorNumber;
                    }
                    if (ags_client_1.isPresent(this.name)) {
                        object['name'] = [];
                        this.name.forEach(function (item) {
                            object['name'].push(item.serialize());
                        });
                    }
                    if (ags_client_1.isPresent(this.appendix)) {
                        object['appendix'] = [];
                        this.appendix.forEach(function (item) {
                            object['appendix'].push(item.serialize());
                        });
                    }
                    if (ags_client_1.isPresent(this.instrumentType)) {
                        object['instrumentType'] = ags_client_2.InstrumentType[this.instrumentType];
                    }
                    if (ags_client_1.isPresent(this.weight)) {
                        object['weight'] = this.weight;
                    }
                    if (ags_client_1.isPresent(this.weightUnit)) {
                        object['weightUnit'] = enums_1.WeightUnit[this.weightUnit];
                    }
                    if (ags_client_1.isPresent(this.currency)) {
                        object['currency'] = this.currency;
                    }
                    if (ags_client_1.isPresent(this.value)) {
                        object['value'] = this.value;
                    }
                    return object;
                };
                CoinbullionGadgetInstrumentViewModel.VALOR_NUMBER_VALIDATORS = [];
                CoinbullionGadgetInstrumentViewModel.NAME_VALIDATORS = [];
                CoinbullionGadgetInstrumentViewModel.APPENDIX_VALIDATORS = [];
                CoinbullionGadgetInstrumentViewModel.INSTRUMENT_TYPE_VALIDATORS = [];
                CoinbullionGadgetInstrumentViewModel.WEIGHT_VALIDATORS = [];
                CoinbullionGadgetInstrumentViewModel.WEIGHT_UNIT_VALIDATORS = [];
                CoinbullionGadgetInstrumentViewModel.CURRENCY_VALIDATORS = [];
                CoinbullionGadgetInstrumentViewModel.VALUE_VALIDATORS = [];
                return CoinbullionGadgetInstrumentViewModel;
            }();
            exports_1("CoinbullionGadgetInstrumentViewModel", CoinbullionGadgetInstrumentViewModel);
        }
    };
});

System.register("ict-core-client/gen/viewmodels/currency_view_model.js", ["ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, ags_client_2, CurrencyViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
        }],
        execute: function () {
            CurrencyViewModel = /** @class */function () {
                function CurrencyViewModel() {}
                CurrencyViewModel.deserialize = function (object) {
                    var _result = new CurrencyViewModel();
                    return _result._deserialize(object);
                };
                CurrencyViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (ags_client_1.isPresent(object['currency'])) {
                            this.currency = new ags_client_2.Currency(object['currency']['shortName']);
                        }
                    }
                    return this;
                };
                CurrencyViewModel.prototype.serialize = function () {
                    var object = {};
                    if (ags_client_1.isPresent(this.currency)) {
                        object['currency'] = this.currency;
                    }
                    return object;
                };
                CurrencyViewModel.CURRENCY_VALIDATORS = [];
                return CurrencyViewModel;
            }();
            exports_1("CurrencyViewModel", CurrencyViewModel);
        }
    };
});

System.register("ict-core-client/gen/viewmodels/currency_exchange_rate_view_model.js", ["ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, CurrencyExchangeRateViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }],
        execute: function () {
            CurrencyExchangeRateViewModel = /** @class */function () {
                function CurrencyExchangeRateViewModel() {}
                CurrencyExchangeRateViewModel.deserialize = function (object) {
                    var _result = new CurrencyExchangeRateViewModel();
                    return _result._deserialize(object);
                };
                CurrencyExchangeRateViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (ags_client_1.isPresent(object['currency'])) {
                            this.currency = object['currency'];
                        }
                        if (ags_client_1.isPresent(object['denomination'])) {
                            this.denomination = object['denomination'];
                        }
                        if (ags_client_1.isPresent(object['value'])) {
                            this.value = object['value'];
                        }
                    }
                    return this;
                };
                CurrencyExchangeRateViewModel.prototype.serialize = function () {
                    var object = {};
                    if (ags_client_1.isPresent(this.currency)) {
                        object['currency'] = this.currency;
                    }
                    if (ags_client_1.isPresent(this.denomination)) {
                        object['denomination'] = this.denomination;
                    }
                    if (ags_client_1.isPresent(this.value)) {
                        object['value'] = this.value;
                    }
                    return object;
                };
                CurrencyExchangeRateViewModel.CURRENCY_VALIDATORS = [];
                CurrencyExchangeRateViewModel.DENOMINATION_VALIDATORS = [];
                CurrencyExchangeRateViewModel.VALUE_VALIDATORS = [];
                return CurrencyExchangeRateViewModel;
            }();
            exports_1("CurrencyExchangeRateViewModel", CurrencyExchangeRateViewModel);
        }
    };
});

System.register("ict-core-client/gen/viewmodels/currency_exchange_rate_request_view_model.js", ["ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, ags_client_2, ags_client_3, CurrencyExchangeRateRequestViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
        }],
        execute: function () {
            CurrencyExchangeRateRequestViewModel = /** @class */function () {
                function CurrencyExchangeRateRequestViewModel() {}
                CurrencyExchangeRateRequestViewModel.deserialize = function (object) {
                    var _result = new CurrencyExchangeRateRequestViewModel();
                    return _result._deserialize(object);
                };
                CurrencyExchangeRateRequestViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (ags_client_1.isPresent(object['currency'])) {
                            this.currency = object['currency'];
                        }
                        if (ags_client_1.isPresent(object['valueDate'])) {
                            this.valueDate = ags_client_3.deserializeDate(object['valueDate']);
                        }
                    }
                    return this;
                };
                CurrencyExchangeRateRequestViewModel.prototype.serialize = function () {
                    var object = {};
                    if (ags_client_1.isPresent(this.currency)) {
                        object['currency'] = this.currency;
                    }
                    if (ags_client_1.isPresent(this.valueDate)) {
                        object['valueDate'] = ags_client_2.serializeDate(this.valueDate);
                    }
                    return object;
                };
                CurrencyExchangeRateRequestViewModel.CURRENCY_VALIDATORS = [];
                CurrencyExchangeRateRequestViewModel.VALUE_DATE_VALIDATORS = [];
                return CurrencyExchangeRateRequestViewModel;
            }();
            exports_1("CurrencyExchangeRateRequestViewModel", CurrencyExchangeRateRequestViewModel);
        }
    };
});

System.register("ict-core-client/gen/viewmodels/currencynote_gadget_view_model.js", ["ags-client/ags-client.js", "ict-core-client/gen/viewmodels/currencynote_gadget_currency_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, ags_client_2, ags_client_3, currencynote_gadget_currency_view_model_1, CurrencynoteGadgetViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
        }, function (currencynote_gadget_currency_view_model_1_1) {
            currencynote_gadget_currency_view_model_1 = currencynote_gadget_currency_view_model_1_1;
        }],
        execute: function () {
            CurrencynoteGadgetViewModel = /** @class */function () {
                function CurrencynoteGadgetViewModel() {}
                CurrencynoteGadgetViewModel.deserialize = function (object) {
                    var _result = new CurrencynoteGadgetViewModel();
                    return _result._deserialize(object);
                };
                CurrencynoteGadgetViewModel.prototype._deserialize = function (object) {
                    var _this = this;
                    if (object) {
                        if (ags_client_1.isPresent(object['referenceDate'])) {
                            this.referenceDate = ags_client_3.deserializeDate(object['referenceDate']);
                        }
                        if (ags_client_1.isPresent(object['currencies'])) {
                            this.currencies = [];
                            object['currencies'].forEach(function (item) {
                                _this.currencies.push(currencynote_gadget_currency_view_model_1.CurrencynoteGadgetCurrencyViewModel.deserialize(item));
                            });
                        }
                    }
                    return this;
                };
                CurrencynoteGadgetViewModel.prototype.serialize = function () {
                    var object = {};
                    if (ags_client_1.isPresent(this.referenceDate)) {
                        object['referenceDate'] = ags_client_2.serializeDate(this.referenceDate);
                    }
                    if (ags_client_1.isPresent(this.currencies)) {
                        object['currencies'] = [];
                        this.currencies.forEach(function (item) {
                            object['currencies'].push(item.serialize());
                        });
                    }
                    return object;
                };
                CurrencynoteGadgetViewModel.REFERENCE_DATE_VALIDATORS = [];
                CurrencynoteGadgetViewModel.CURRENCIES_VALIDATORS = [];
                return CurrencynoteGadgetViewModel;
            }();
            exports_1("CurrencynoteGadgetViewModel", CurrencynoteGadgetViewModel);
        }
    };
});

System.register("ict-core-client/gen/viewmodels/currencynote_gadget_currency_view_model.js", ["ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, ags_client_2, ags_client_3, CurrencynoteGadgetCurrencyViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
        }],
        execute: function () {
            CurrencynoteGadgetCurrencyViewModel = /** @class */function () {
                function CurrencynoteGadgetCurrencyViewModel() {}
                CurrencynoteGadgetCurrencyViewModel.deserialize = function (object) {
                    var _result = new CurrencynoteGadgetCurrencyViewModel();
                    return _result._deserialize(object);
                };
                CurrencynoteGadgetCurrencyViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (ags_client_1.isPresent(object['currency'])) {
                            this.currency = new ags_client_2.Currency(object['currency']['shortName']);
                        }
                        if (ags_client_1.isPresent(object['country'])) {
                            this.country = new ags_client_3.Country(object['country']['shortName']);
                        }
                        if (ags_client_1.isPresent(object['value'])) {
                            this.value = object['value'];
                        }
                        if (ags_client_1.isPresent(object['valueNote'])) {
                            this.valueNote = object['valueNote'];
                        }
                        if (ags_client_1.isPresent(object['valueMiddle'])) {
                            this.valueMiddle = object['valueMiddle'];
                        }
                        if (ags_client_1.isPresent(object['denomination'])) {
                            this.denomination = object['denomination'];
                        }
                        if (ags_client_1.isPresent(object['valorNumber'])) {
                            this.valorNumber = object['valorNumber'];
                        }
                    }
                    return this;
                };
                CurrencynoteGadgetCurrencyViewModel.prototype.serialize = function () {
                    var object = {};
                    if (ags_client_1.isPresent(this.currency)) {
                        object['currency'] = this.currency;
                    }
                    if (ags_client_1.isPresent(this.country)) {
                        object['country'] = this.country;
                    }
                    if (ags_client_1.isPresent(this.value)) {
                        object['value'] = this.value;
                    }
                    if (ags_client_1.isPresent(this.valueNote)) {
                        object['valueNote'] = this.valueNote;
                    }
                    if (ags_client_1.isPresent(this.valueMiddle)) {
                        object['valueMiddle'] = this.valueMiddle;
                    }
                    if (ags_client_1.isPresent(this.denomination)) {
                        object['denomination'] = this.denomination;
                    }
                    if (ags_client_1.isPresent(this.valorNumber)) {
                        object['valorNumber'] = this.valorNumber;
                    }
                    return object;
                };
                CurrencynoteGadgetCurrencyViewModel.CURRENCY_VALIDATORS = [];
                CurrencynoteGadgetCurrencyViewModel.COUNTRY_VALIDATORS = [];
                CurrencynoteGadgetCurrencyViewModel.VALUE_VALIDATORS = [];
                CurrencynoteGadgetCurrencyViewModel.VALUE_NOTE_VALIDATORS = [];
                CurrencynoteGadgetCurrencyViewModel.VALUE_MIDDLE_VALIDATORS = [];
                CurrencynoteGadgetCurrencyViewModel.DENOMINATION_VALIDATORS = [];
                CurrencynoteGadgetCurrencyViewModel.VALOR_NUMBER_VALIDATORS = [];
                return CurrencynoteGadgetCurrencyViewModel;
            }();
            exports_1("CurrencynoteGadgetCurrencyViewModel", CurrencynoteGadgetCurrencyViewModel);
        }
    };
});

System.register("ict-core-client/gen/viewmodels/currencytoken_gadget_view_model.js", ["ags-client/ags-client.js", "ict-core-client/gen/viewmodels/currencytoken_gadget_token_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, ags_client_2, ags_client_3, currencytoken_gadget_token_view_model_1, CurrencytokenGadgetViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
        }, function (currencytoken_gadget_token_view_model_1_1) {
            currencytoken_gadget_token_view_model_1 = currencytoken_gadget_token_view_model_1_1;
        }],
        execute: function () {
            CurrencytokenGadgetViewModel = /** @class */function () {
                function CurrencytokenGadgetViewModel() {}
                CurrencytokenGadgetViewModel.deserialize = function (object) {
                    var _result = new CurrencytokenGadgetViewModel();
                    return _result._deserialize(object);
                };
                CurrencytokenGadgetViewModel.prototype._deserialize = function (object) {
                    var _this = this;
                    if (object) {
                        if (ags_client_1.isPresent(object['referenceDate'])) {
                            this.referenceDate = ags_client_3.deserializeDate(object['referenceDate']);
                        }
                        if (ags_client_1.isPresent(object['tokens'])) {
                            this.tokens = [];
                            object['tokens'].forEach(function (item) {
                                _this.tokens.push(currencytoken_gadget_token_view_model_1.CurrencytokenGadgetTokenViewModel.deserialize(item));
                            });
                        }
                    }
                    return this;
                };
                CurrencytokenGadgetViewModel.prototype.serialize = function () {
                    var object = {};
                    if (ags_client_1.isPresent(this.referenceDate)) {
                        object['referenceDate'] = ags_client_2.serializeDate(this.referenceDate);
                    }
                    if (ags_client_1.isPresent(this.tokens)) {
                        object['tokens'] = [];
                        this.tokens.forEach(function (item) {
                            object['tokens'].push(item.serialize());
                        });
                    }
                    return object;
                };
                CurrencytokenGadgetViewModel.REFERENCE_DATE_VALIDATORS = [];
                CurrencytokenGadgetViewModel.TOKENS_VALIDATORS = [];
                return CurrencytokenGadgetViewModel;
            }();
            exports_1("CurrencytokenGadgetViewModel", CurrencytokenGadgetViewModel);
        }
    };
});

System.register("ict-core-client/gen/viewmodels/currencytoken_gadget_token_view_model.js", ["ags-client/ags-client.js", "ict-core-client/gen/codes.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, codes_1, CurrencytokenGadgetTokenViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }, function (codes_1_1) {
            codes_1 = codes_1_1;
        }],
        execute: function () {
            CurrencytokenGadgetTokenViewModel = /** @class */function () {
                function CurrencytokenGadgetTokenViewModel() {}
                CurrencytokenGadgetTokenViewModel.deserialize = function (object) {
                    var _result = new CurrencytokenGadgetTokenViewModel();
                    return _result._deserialize(object);
                };
                CurrencytokenGadgetTokenViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (ags_client_1.isPresent(object['token'])) {
                            this.token = new codes_1.Token(object['token']['shortName']);
                        }
                        if (ags_client_1.isPresent(object['value'])) {
                            this.value = object['value'];
                        }
                        if (ags_client_1.isPresent(object['denomination'])) {
                            this.denomination = object['denomination'];
                        }
                    }
                    return this;
                };
                CurrencytokenGadgetTokenViewModel.prototype.serialize = function () {
                    var object = {};
                    if (ags_client_1.isPresent(this.token)) {
                        object['token'] = this.token;
                    }
                    if (ags_client_1.isPresent(this.value)) {
                        object['value'] = this.value;
                    }
                    if (ags_client_1.isPresent(this.denomination)) {
                        object['denomination'] = this.denomination;
                    }
                    return object;
                };
                CurrencytokenGadgetTokenViewModel.TOKEN_VALIDATORS = [];
                CurrencytokenGadgetTokenViewModel.VALUE_VALIDATORS = [];
                CurrencytokenGadgetTokenViewModel.DENOMINATION_VALIDATORS = [];
                return CurrencytokenGadgetTokenViewModel;
            }();
            exports_1("CurrencytokenGadgetTokenViewModel", CurrencytokenGadgetTokenViewModel);
        }
    };
});

System.register("ict-core-client/gen/viewmodels/language_string_view_model.js", ["ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, Validators, ags_client_2, LanguageStringViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            Validators = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
        }],
        execute: function () {
            LanguageStringViewModel = /** @class */function () {
                function LanguageStringViewModel() {}
                LanguageStringViewModel.deserialize = function (object) {
                    var _result = new LanguageStringViewModel();
                    return _result._deserialize(object);
                };
                LanguageStringViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (ags_client_1.isPresent(object['language'])) {
                            this.language = new ags_client_2.Language(object['language']['shortName']);
                        }
                        if (ags_client_1.isPresent(object['value'])) {
                            this.value = object['value'];
                        }
                    }
                    return this;
                };
                LanguageStringViewModel.prototype.serialize = function () {
                    var object = {};
                    if (ags_client_1.isPresent(this.language)) {
                        object['language'] = this.language;
                    }
                    if (ags_client_1.isPresent(this.value)) {
                        object['value'] = this.value;
                    }
                    return object;
                };
                LanguageStringViewModel.LANGUAGE_VALIDATORS = [Validators.required()];
                LanguageStringViewModel.VALUE_VALIDATORS = [Validators.max(4000)];
                return LanguageStringViewModel;
            }();
            exports_1("LanguageStringViewModel", LanguageStringViewModel);
        }
    };
});

System.register("ict-core-client/gen/viewmodels/system_parameters_view_model.js", ["ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, SystemParametersViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }],
        execute: function () {
            SystemParametersViewModel = /** @class */function () {
                function SystemParametersViewModel() {}
                SystemParametersViewModel.deserialize = function (object) {
                    var _result = new SystemParametersViewModel();
                    return _result._deserialize(object);
                };
                SystemParametersViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (ags_client_1.isPresent(object['firstTaxYear'])) {
                            this.firstTaxYear = object['firstTaxYear'];
                        }
                        if (ags_client_1.isPresent(object['taxYearOnline'])) {
                            this.taxYearOnline = object['taxYearOnline'];
                        }
                        if (ags_client_1.isPresent(object['taxYearExtern'])) {
                            this.taxYearExtern = object['taxYearExtern'];
                        }
                        if (ags_client_1.isPresent(object['archiveYearsInactive'])) {
                            this.archiveYearsInactive = object['archiveYearsInactive'];
                        }
                        if (ags_client_1.isPresent(object['maxSearchResults'])) {
                            this.maxSearchResults = object['maxSearchResults'];
                        }
                        if (ags_client_1.isPresent(object['gadgetCapitalizationRate'])) {
                            this.gadgetCapitalizationRate = object['gadgetCapitalizationRate'];
                        }
                        if (ags_client_1.isPresent(object['gadgetCoinBullions'])) {
                            this.gadgetCoinBullions = object['gadgetCoinBullions'];
                        }
                        if (ags_client_1.isPresent(object['gadgetCurrencyNotes'])) {
                            this.gadgetCurrencyNotes = object['gadgetCurrencyNotes'];
                        }
                        if (ags_client_1.isPresent(object['gadgetToken'])) {
                            this.gadgetToken = object['gadgetToken'];
                        }
                    }
                    return this;
                };
                SystemParametersViewModel.prototype.serialize = function () {
                    var object = {};
                    if (ags_client_1.isPresent(this.firstTaxYear)) {
                        object['firstTaxYear'] = this.firstTaxYear;
                    }
                    if (ags_client_1.isPresent(this.taxYearOnline)) {
                        object['taxYearOnline'] = this.taxYearOnline;
                    }
                    if (ags_client_1.isPresent(this.taxYearExtern)) {
                        object['taxYearExtern'] = this.taxYearExtern;
                    }
                    if (ags_client_1.isPresent(this.archiveYearsInactive)) {
                        object['archiveYearsInactive'] = this.archiveYearsInactive;
                    }
                    if (ags_client_1.isPresent(this.maxSearchResults)) {
                        object['maxSearchResults'] = this.maxSearchResults;
                    }
                    if (ags_client_1.isPresent(this.gadgetCapitalizationRate)) {
                        object['gadgetCapitalizationRate'] = this.gadgetCapitalizationRate;
                    }
                    if (ags_client_1.isPresent(this.gadgetCoinBullions)) {
                        object['gadgetCoinBullions'] = this.gadgetCoinBullions;
                    }
                    if (ags_client_1.isPresent(this.gadgetCurrencyNotes)) {
                        object['gadgetCurrencyNotes'] = this.gadgetCurrencyNotes;
                    }
                    if (ags_client_1.isPresent(this.gadgetToken)) {
                        object['gadgetToken'] = this.gadgetToken;
                    }
                    return object;
                };
                SystemParametersViewModel.FIRST_TAX_YEAR_VALIDATORS = [];
                SystemParametersViewModel.TAX_YEAR_ONLINE_VALIDATORS = [];
                SystemParametersViewModel.TAX_YEAR_EXTERN_VALIDATORS = [];
                SystemParametersViewModel.ARCHIVE_YEARS_INACTIVE_VALIDATORS = [];
                SystemParametersViewModel.MAX_SEARCH_RESULTS_VALIDATORS = [];
                SystemParametersViewModel.GADGET_CAPITALIZATION_RATE_VALIDATORS = [];
                SystemParametersViewModel.GADGET_COIN_BULLIONS_VALIDATORS = [];
                SystemParametersViewModel.GADGET_CURRENCY_NOTES_VALIDATORS = [];
                SystemParametersViewModel.GADGET_TOKEN_VALIDATORS = [];
                return SystemParametersViewModel;
            }();
            exports_1("SystemParametersViewModel", SystemParametersViewModel);
        }
    };
});

System.register("ict-core-client/gen/codes.js", ["ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var ags_client_1, ExportPart, ExportTarget, ExportType, ExternalLinks, ImportPart, ImportSource, ImportType, PublicationStatus, RemarkGroup, RemarkType, Source, StatisticType, StockExchange, Token, Identification, XSDType;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }],
        execute: function () {
            ExportPart = /** @class */function (_super) {
                __extends(ExportPart, _super);
                function ExportPart(name) {
                    return _super.call(this, 'EXPPAR', name) || this;
                }
                ExportPart.create = function (name) {
                    return new ExportPart(name);
                };
                return ExportPart;
            }(ags_client_1.Code);
            exports_1("ExportPart", ExportPart);
            ExportTarget = /** @class */function (_super) {
                __extends(ExportTarget, _super);
                function ExportTarget(name) {
                    return _super.call(this, 'EXPTAR', name) || this;
                }
                ExportTarget.create = function (name) {
                    return new ExportTarget(name);
                };
                return ExportTarget;
            }(ags_client_1.Code);
            exports_1("ExportTarget", ExportTarget);
            ExportType = /** @class */function (_super) {
                __extends(ExportType, _super);
                function ExportType(name) {
                    return _super.call(this, 'EXPTYP', name) || this;
                }
                ExportType.create = function (name) {
                    return new ExportType(name);
                };
                return ExportType;
            }(ags_client_1.Code);
            exports_1("ExportType", ExportType);
            ExternalLinks = /** @class */function (_super) {
                __extends(ExternalLinks, _super);
                function ExternalLinks(name) {
                    return _super.call(this, 'EXTLNK', name) || this;
                }
                ExternalLinks.create = function (name) {
                    return new ExternalLinks(name);
                };
                return ExternalLinks;
            }(ags_client_1.Code);
            exports_1("ExternalLinks", ExternalLinks);
            ImportPart = /** @class */function (_super) {
                __extends(ImportPart, _super);
                function ImportPart(name) {
                    return _super.call(this, 'IMPPAR', name) || this;
                }
                ImportPart.create = function (name) {
                    return new ImportPart(name);
                };
                return ImportPart;
            }(ags_client_1.Code);
            exports_1("ImportPart", ImportPart);
            ImportSource = /** @class */function (_super) {
                __extends(ImportSource, _super);
                function ImportSource(name) {
                    return _super.call(this, 'IMPSRC', name) || this;
                }
                ImportSource.create = function (name) {
                    return new ImportSource(name);
                };
                return ImportSource;
            }(ags_client_1.Code);
            exports_1("ImportSource", ImportSource);
            ImportType = /** @class */function (_super) {
                __extends(ImportType, _super);
                function ImportType(name) {
                    return _super.call(this, 'IMPTYP', name) || this;
                }
                ImportType.create = function (name) {
                    return new ImportType(name);
                };
                return ImportType;
            }(ags_client_1.Code);
            exports_1("ImportType", ImportType);
            PublicationStatus = /** @class */function (_super) {
                __extends(PublicationStatus, _super);
                function PublicationStatus(name) {
                    return _super.call(this, 'PUBSTA', name) || this;
                }
                PublicationStatus.create = function (name) {
                    return new PublicationStatus(name);
                };
                return PublicationStatus;
            }(ags_client_1.Code);
            exports_1("PublicationStatus", PublicationStatus);
            RemarkGroup = /** @class */function (_super) {
                __extends(RemarkGroup, _super);
                function RemarkGroup(name) {
                    return _super.call(this, 'REMGRP', name) || this;
                }
                RemarkGroup.create = function (name) {
                    return new RemarkGroup(name);
                };
                return RemarkGroup;
            }(ags_client_1.Code);
            exports_1("RemarkGroup", RemarkGroup);
            RemarkType = /** @class */function (_super) {
                __extends(RemarkType, _super);
                function RemarkType(name) {
                    return _super.call(this, 'REMTYP', name) || this;
                }
                RemarkType.create = function (name) {
                    return new RemarkType(name);
                };
                return RemarkType;
            }(ags_client_1.Code);
            exports_1("RemarkType", RemarkType);
            Source = /** @class */function (_super) {
                __extends(Source, _super);
                function Source(name) {
                    return _super.call(this, 'SOURCE', name) || this;
                }
                Source.create = function (name) {
                    return new Source(name);
                };
                return Source;
            }(ags_client_1.Code);
            exports_1("Source", Source);
            StatisticType = /** @class */function (_super) {
                __extends(StatisticType, _super);
                function StatisticType(name) {
                    return _super.call(this, 'STATYP', name) || this;
                }
                StatisticType.create = function (name) {
                    return new StatisticType(name);
                };
                return StatisticType;
            }(ags_client_1.Code);
            exports_1("StatisticType", StatisticType);
            StockExchange = /** @class */function (_super) {
                __extends(StockExchange, _super);
                function StockExchange(name) {
                    return _super.call(this, 'STOEXG', name) || this;
                }
                StockExchange.create = function (name) {
                    return new StockExchange(name);
                };
                return StockExchange;
            }(ags_client_1.Code);
            exports_1("StockExchange", StockExchange);
            Token = /** @class */function (_super) {
                __extends(Token, _super);
                function Token(name) {
                    return _super.call(this, 'TOKEN', name) || this;
                }
                Token.create = function (name) {
                    return new Token(name);
                };
                return Token;
            }(ags_client_1.Code);
            exports_1("Token", Token);
            Identification = /** @class */function (_super) {
                __extends(Identification, _super);
                function Identification(name) {
                    return _super.call(this, 'WVKIDE', name) || this;
                }
                Identification.create = function (name) {
                    return new Identification(name);
                };
                return Identification;
            }(ags_client_1.Code);
            exports_1("Identification", Identification);
            XSDType = /** @class */function (_super) {
                __extends(XSDType, _super);
                function XSDType(name) {
                    return _super.call(this, 'XSDTYP', name) || this;
                }
                XSDType.create = function (name) {
                    return new XSDType(name);
                };
                return XSDType;
            }(ags_client_1.Code);
            exports_1("XSDType", XSDType);
        }
    };
});

System.register("ict-core-client/gen/viewmodels/token_view_model.js", ["ags-client/ags-client.js", "ict-core-client/gen/codes.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, codes_1, TokenViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }, function (codes_1_1) {
            codes_1 = codes_1_1;
        }],
        execute: function () {
            TokenViewModel = /** @class */function () {
                function TokenViewModel() {}
                TokenViewModel.deserialize = function (object) {
                    var _result = new TokenViewModel();
                    return _result._deserialize(object);
                };
                TokenViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (ags_client_1.isPresent(object['token'])) {
                            this.token = new codes_1.Token(object['token']['shortName']);
                        }
                    }
                    return this;
                };
                TokenViewModel.prototype.serialize = function () {
                    var object = {};
                    if (ags_client_1.isPresent(this.token)) {
                        object['token'] = this.token;
                    }
                    return object;
                };
                TokenViewModel.TOKEN_VALIDATORS = [];
                return TokenViewModel;
            }();
            exports_1("TokenViewModel", TokenViewModel);
        }
    };
});

System.register("ict-core-client/gen/viewmodels/value_date_view_model.js", ["ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, ags_client_2, ags_client_3, ValueDateViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
        }],
        execute: function () {
            ValueDateViewModel = /** @class */function () {
                function ValueDateViewModel() {}
                ValueDateViewModel.deserialize = function (object) {
                    var _result = new ValueDateViewModel();
                    return _result._deserialize(object);
                };
                ValueDateViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (ags_client_1.isPresent(object['valueDate'])) {
                            this.valueDate = ags_client_3.deserializeDate(object['valueDate']);
                        }
                    }
                    return this;
                };
                ValueDateViewModel.prototype.serialize = function () {
                    var object = {};
                    if (ags_client_1.isPresent(this.valueDate)) {
                        object['valueDate'] = ags_client_2.serializeDate(this.valueDate);
                    }
                    return object;
                };
                ValueDateViewModel.VALUE_DATE_VALIDATORS = [];
                return ValueDateViewModel;
            }();
            exports_1("ValueDateViewModel", ValueDateViewModel);
        }
    };
});

System.register("ict-core-client/gen/viewmodels.js", ["ict-core-client/gen/viewmodels/capitalization_rate_gadget_view_model.js", "ict-core-client/gen/viewmodels/capitalization_rate_gadget_currency_view_model.js", "ict-core-client/gen/viewmodels/coin_bullion_view_model.js", "ict-core-client/gen/viewmodels/coinbullion_gadget_view_model.js", "ict-core-client/gen/viewmodels/coinbullion_gadget_instrument_view_model.js", "ict-core-client/gen/viewmodels/currency_view_model.js", "ict-core-client/gen/viewmodels/currency_exchange_rate_view_model.js", "ict-core-client/gen/viewmodels/currency_exchange_rate_request_view_model.js", "ict-core-client/gen/viewmodels/currencynote_gadget_view_model.js", "ict-core-client/gen/viewmodels/currencynote_gadget_currency_view_model.js", "ict-core-client/gen/viewmodels/currencytoken_gadget_view_model.js", "ict-core-client/gen/viewmodels/currencytoken_gadget_token_view_model.js", "ict-core-client/gen/viewmodels/language_string_view_model.js", "ict-core-client/gen/viewmodels/system_parameters_view_model.js", "ict-core-client/gen/viewmodels/token_view_model.js", "ict-core-client/gen/viewmodels/value_date_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (capitalization_rate_gadget_view_model_1_1) {
            exports_1({
                "CapitalizationRateGadgetViewModel": capitalization_rate_gadget_view_model_1_1["CapitalizationRateGadgetViewModel"]
            });
        }, function (capitalization_rate_gadget_currency_view_model_1_1) {
            exports_1({
                "CapitalizationRateGadgetCurrencyViewModel": capitalization_rate_gadget_currency_view_model_1_1["CapitalizationRateGadgetCurrencyViewModel"]
            });
        }, function (coin_bullion_view_model_1_1) {
            exports_1({
                "CoinBullionViewModel": coin_bullion_view_model_1_1["CoinBullionViewModel"]
            });
        }, function (coinbullion_gadget_view_model_1_1) {
            exports_1({
                "CoinbullionGadgetViewModel": coinbullion_gadget_view_model_1_1["CoinbullionGadgetViewModel"]
            });
        }, function (coinbullion_gadget_instrument_view_model_1_1) {
            exports_1({
                "CoinbullionGadgetInstrumentViewModel": coinbullion_gadget_instrument_view_model_1_1["CoinbullionGadgetInstrumentViewModel"]
            });
        }, function (currency_view_model_1_1) {
            exports_1({
                "CurrencyViewModel": currency_view_model_1_1["CurrencyViewModel"]
            });
        }, function (currency_exchange_rate_view_model_1_1) {
            exports_1({
                "CurrencyExchangeRateViewModel": currency_exchange_rate_view_model_1_1["CurrencyExchangeRateViewModel"]
            });
        }, function (currency_exchange_rate_request_view_model_1_1) {
            exports_1({
                "CurrencyExchangeRateRequestViewModel": currency_exchange_rate_request_view_model_1_1["CurrencyExchangeRateRequestViewModel"]
            });
        }, function (currencynote_gadget_view_model_1_1) {
            exports_1({
                "CurrencynoteGadgetViewModel": currencynote_gadget_view_model_1_1["CurrencynoteGadgetViewModel"]
            });
        }, function (currencynote_gadget_currency_view_model_1_1) {
            exports_1({
                "CurrencynoteGadgetCurrencyViewModel": currencynote_gadget_currency_view_model_1_1["CurrencynoteGadgetCurrencyViewModel"]
            });
        }, function (currencytoken_gadget_view_model_1_1) {
            exports_1({
                "CurrencytokenGadgetViewModel": currencytoken_gadget_view_model_1_1["CurrencytokenGadgetViewModel"]
            });
        }, function (currencytoken_gadget_token_view_model_1_1) {
            exports_1({
                "CurrencytokenGadgetTokenViewModel": currencytoken_gadget_token_view_model_1_1["CurrencytokenGadgetTokenViewModel"]
            });
        }, function (language_string_view_model_1_1) {
            exports_1({
                "LanguageStringViewModel": language_string_view_model_1_1["LanguageStringViewModel"]
            });
        }, function (system_parameters_view_model_1_1) {
            exports_1({
                "SystemParametersViewModel": system_parameters_view_model_1_1["SystemParametersViewModel"]
            });
        }, function (token_view_model_1_1) {
            exports_1({
                "TokenViewModel": token_view_model_1_1["TokenViewModel"]
            });
        }, function (value_date_view_model_1_1) {
            exports_1({
                "ValueDateViewModel": value_date_view_model_1_1["ValueDateViewModel"]
            });
        }],
        execute: function () {}
    };
});

System.register("ict-core-client/gen/viewsearch/capitalization_rate_gadget_search_criteria.js", ["ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var ags_client_1, ags_client_2, ags_client_3, CapitalizationRateGadgetSearchCriteria;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
        }],
        execute: function () {
            CapitalizationRateGadgetSearchCriteria = /** @class */function (_super) {
                __extends(CapitalizationRateGadgetSearchCriteria, _super);
                function CapitalizationRateGadgetSearchCriteria(from, size) {
                    return _super.call(this, from, size) || this;
                }
                CapitalizationRateGadgetSearchCriteria.create = function (from, size) {
                    return new CapitalizationRateGadgetSearchCriteria(from, size);
                };
                Object.defineProperty(CapitalizationRateGadgetSearchCriteria.prototype, "referenceDate", {
                    get: function () {
                        return this._referenceDate;
                    },
                    set: function (referenceDate) {
                        if (this._referenceDate !== referenceDate) {
                            this._referenceDate = referenceDate;
                            this.attributeChanged(CapitalizationRateGadgetSearchCriteria.REFERENCE_DATE, referenceDate);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(CapitalizationRateGadgetSearchCriteria.prototype, "currencies", {
                    get: function () {
                        return this._currencies;
                    },
                    set: function (currencies) {
                        if (this._currencies !== currencies) {
                            this._currencies = currencies;
                            this.attributeChanged(CapitalizationRateGadgetSearchCriteria.CURRENCIES, currencies);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                CapitalizationRateGadgetSearchCriteria.prototype.reset = function () {
                    _super.prototype.reset.call(this);
                    this._referenceDate = null;
                    this._currencies = null;
                };
                CapitalizationRateGadgetSearchCriteria.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (ags_client_2.isPresent(this.referenceDate)) {
                        object['referenceDate'] = ags_client_3.serializeDate(this.referenceDate);
                    }
                    if (ags_client_2.isPresent(this.currencies)) {
                        object['currencies'] = [];
                        this.currencies.forEach(function (item) {
                            object['currencies'].push(item);
                        });
                    }
                    return object;
                };
                CapitalizationRateGadgetSearchCriteria.REFERENCE_DATE = 'referenceDate';
                CapitalizationRateGadgetSearchCriteria.CURRENCIES = 'currencies';
                return CapitalizationRateGadgetSearchCriteria;
            }(ags_client_1.SearchCriteria);
            exports_1("CapitalizationRateGadgetSearchCriteria", CapitalizationRateGadgetSearchCriteria);
        }
    };
});

System.register("ict-core-client/gen/viewsearch/currencynote_gadget_search_criteria.js", ["ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var ags_client_1, ags_client_2, ags_client_3, CurrencynoteGadgetSearchCriteria;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
        }],
        execute: function () {
            CurrencynoteGadgetSearchCriteria = /** @class */function (_super) {
                __extends(CurrencynoteGadgetSearchCriteria, _super);
                function CurrencynoteGadgetSearchCriteria(from, size) {
                    return _super.call(this, from, size) || this;
                }
                CurrencynoteGadgetSearchCriteria.create = function (from, size) {
                    return new CurrencynoteGadgetSearchCriteria(from, size);
                };
                Object.defineProperty(CurrencynoteGadgetSearchCriteria.prototype, "referenceDate", {
                    get: function () {
                        return this._referenceDate;
                    },
                    set: function (referenceDate) {
                        if (this._referenceDate !== referenceDate) {
                            this._referenceDate = referenceDate;
                            this.attributeChanged(CurrencynoteGadgetSearchCriteria.REFERENCE_DATE, referenceDate);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(CurrencynoteGadgetSearchCriteria.prototype, "currencies", {
                    get: function () {
                        return this._currencies;
                    },
                    set: function (currencies) {
                        if (this._currencies !== currencies) {
                            this._currencies = currencies;
                            this.attributeChanged(CurrencynoteGadgetSearchCriteria.CURRENCIES, currencies);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                CurrencynoteGadgetSearchCriteria.prototype.reset = function () {
                    _super.prototype.reset.call(this);
                    this._referenceDate = null;
                    this._currencies = null;
                };
                CurrencynoteGadgetSearchCriteria.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (ags_client_2.isPresent(this.referenceDate)) {
                        object['referenceDate'] = ags_client_3.serializeDate(this.referenceDate);
                    }
                    if (ags_client_2.isPresent(this.currencies)) {
                        object['currencies'] = [];
                        this.currencies.forEach(function (item) {
                            object['currencies'].push(item);
                        });
                    }
                    return object;
                };
                CurrencynoteGadgetSearchCriteria.REFERENCE_DATE = 'referenceDate';
                CurrencynoteGadgetSearchCriteria.CURRENCIES = 'currencies';
                return CurrencynoteGadgetSearchCriteria;
            }(ags_client_1.SearchCriteria);
            exports_1("CurrencynoteGadgetSearchCriteria", CurrencynoteGadgetSearchCriteria);
        }
    };
});

System.register("ict-core-client/gen/viewsearch/currencytoken_gadget_search_criteria.js", ["ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var ags_client_1, ags_client_2, ags_client_3, CurrencytokenGadgetSearchCriteria;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
        }],
        execute: function () {
            CurrencytokenGadgetSearchCriteria = /** @class */function (_super) {
                __extends(CurrencytokenGadgetSearchCriteria, _super);
                function CurrencytokenGadgetSearchCriteria(from, size) {
                    return _super.call(this, from, size) || this;
                }
                CurrencytokenGadgetSearchCriteria.create = function (from, size) {
                    return new CurrencytokenGadgetSearchCriteria(from, size);
                };
                Object.defineProperty(CurrencytokenGadgetSearchCriteria.prototype, "referenceDate", {
                    get: function () {
                        return this._referenceDate;
                    },
                    set: function (referenceDate) {
                        if (this._referenceDate !== referenceDate) {
                            this._referenceDate = referenceDate;
                            this.attributeChanged(CurrencytokenGadgetSearchCriteria.REFERENCE_DATE, referenceDate);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(CurrencytokenGadgetSearchCriteria.prototype, "tokens", {
                    get: function () {
                        return this._tokens;
                    },
                    set: function (tokens) {
                        if (this._tokens !== tokens) {
                            this._tokens = tokens;
                            this.attributeChanged(CurrencytokenGadgetSearchCriteria.TOKENS, tokens);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                CurrencytokenGadgetSearchCriteria.prototype.reset = function () {
                    _super.prototype.reset.call(this);
                    this._referenceDate = null;
                    this._tokens = null;
                };
                CurrencytokenGadgetSearchCriteria.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (ags_client_2.isPresent(this.referenceDate)) {
                        object['referenceDate'] = ags_client_3.serializeDate(this.referenceDate);
                    }
                    if (ags_client_2.isPresent(this.tokens)) {
                        object['tokens'] = [];
                        this.tokens.forEach(function (item) {
                            object['tokens'].push(item);
                        });
                    }
                    return object;
                };
                CurrencytokenGadgetSearchCriteria.REFERENCE_DATE = 'referenceDate';
                CurrencytokenGadgetSearchCriteria.TOKENS = 'tokens';
                return CurrencytokenGadgetSearchCriteria;
            }(ags_client_1.SearchCriteria);
            exports_1("CurrencytokenGadgetSearchCriteria", CurrencytokenGadgetSearchCriteria);
        }
    };
});

System.register("ict-core-client/gen/viewsearch/search_security_gadget_search_criteria.js", ["ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var ags_client_1, ags_client_2, ags_client_3, ags_client_4, ags_client_5, SearchSecurityGadgetSearchCriteria;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
            ags_client_3 = ags_client_1_1;
            ags_client_4 = ags_client_1_1;
            ags_client_5 = ags_client_1_1;
        }],
        execute: function () {
            SearchSecurityGadgetSearchCriteria = /** @class */function (_super) {
                __extends(SearchSecurityGadgetSearchCriteria, _super);
                function SearchSecurityGadgetSearchCriteria(from, size) {
                    return _super.call(this, from, size) || this;
                }
                SearchSecurityGadgetSearchCriteria.create = function (from, size) {
                    return new SearchSecurityGadgetSearchCriteria(from, size);
                };
                Object.defineProperty(SearchSecurityGadgetSearchCriteria.prototype, "valorNumber", {
                    get: function () {
                        return this._valorNumber;
                    },
                    set: function (valorNumber) {
                        if (this._valorNumber !== valorNumber) {
                            this._valorNumber = valorNumber;
                            this.attributeChanged(SearchSecurityGadgetSearchCriteria.VALOR_NUMBER, valorNumber);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecurityGadgetSearchCriteria.prototype, "isin", {
                    get: function () {
                        return this._isin;
                    },
                    set: function (isin) {
                        if (this._isin !== isin) {
                            this._isin = isin;
                            this.attributeChanged(SearchSecurityGadgetSearchCriteria.ISIN, isin);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecurityGadgetSearchCriteria.prototype, "nsin", {
                    get: function () {
                        return this._nsin;
                    },
                    set: function (nsin) {
                        if (this._nsin !== nsin) {
                            this._nsin = nsin;
                            this.attributeChanged(SearchSecurityGadgetSearchCriteria.NSIN, nsin);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecurityGadgetSearchCriteria.prototype, "name", {
                    get: function () {
                        return this._name;
                    },
                    set: function (name) {
                        if (this._name !== name) {
                            this._name = name;
                            this.attributeChanged(SearchSecurityGadgetSearchCriteria.NAME, name);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecurityGadgetSearchCriteria.prototype, "institution", {
                    get: function () {
                        return this._institution;
                    },
                    set: function (institution) {
                        if (this._institution !== institution) {
                            this._institution = institution;
                            this.attributeChanged(SearchSecurityGadgetSearchCriteria.INSTITUTION, institution);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecurityGadgetSearchCriteria.prototype, "instrument", {
                    get: function () {
                        return this._instrument;
                    },
                    set: function (instrument) {
                        if (this._instrument !== instrument) {
                            this._instrument = instrument;
                            this.attributeChanged(SearchSecurityGadgetSearchCriteria.INSTRUMENT, instrument);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecurityGadgetSearchCriteria.prototype, "instrumentGroup", {
                    get: function () {
                        return this._instrumentGroup;
                    },
                    set: function (instrumentGroup) {
                        if (this._instrumentGroup !== instrumentGroup) {
                            this._instrumentGroup = instrumentGroup;
                            this.attributeChanged(SearchSecurityGadgetSearchCriteria.INSTRUMENT_GROUP, instrumentGroup);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecurityGadgetSearchCriteria.prototype, "instrumentType", {
                    get: function () {
                        return this._instrumentType;
                    },
                    set: function (instrumentType) {
                        if (this._instrumentType !== instrumentType) {
                            this._instrumentType = instrumentType;
                            this.attributeChanged(SearchSecurityGadgetSearchCriteria.INSTRUMENT_TYPE, instrumentType);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecurityGadgetSearchCriteria.prototype, "country", {
                    get: function () {
                        return this._country;
                    },
                    set: function (country) {
                        if (this._country !== country) {
                            this._country = country;
                            this.attributeChanged(SearchSecurityGadgetSearchCriteria.COUNTRY, country);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecurityGadgetSearchCriteria.prototype, "currency", {
                    get: function () {
                        return this._currency;
                    },
                    set: function (currency) {
                        if (this._currency !== currency) {
                            this._currency = currency;
                            this.attributeChanged(SearchSecurityGadgetSearchCriteria.CURRENCY, currency);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecurityGadgetSearchCriteria.prototype, "issueYear", {
                    get: function () {
                        return this._issueYear;
                    },
                    set: function (issueYear) {
                        if (this._issueYear !== issueYear) {
                            this._issueYear = issueYear;
                            this.attributeChanged(SearchSecurityGadgetSearchCriteria.ISSUE_YEAR, issueYear);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecurityGadgetSearchCriteria.prototype, "interestRate", {
                    get: function () {
                        return this._interestRate;
                    },
                    set: function (interestRate) {
                        if (this._interestRate !== interestRate) {
                            this._interestRate = interestRate;
                            this.attributeChanged(SearchSecurityGadgetSearchCriteria.INTEREST_RATE, interestRate);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecurityGadgetSearchCriteria.prototype, "redemptionYear", {
                    get: function () {
                        return this._redemptionYear;
                    },
                    set: function (redemptionYear) {
                        if (this._redemptionYear !== redemptionYear) {
                            this._redemptionYear = redemptionYear;
                            this.attributeChanged(SearchSecurityGadgetSearchCriteria.REDEMPTION_YEAR, redemptionYear);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecurityGadgetSearchCriteria.prototype, "iup", {
                    get: function () {
                        return this._iup;
                    },
                    set: function (iup) {
                        if (this._iup !== iup) {
                            this._iup = iup;
                            this.attributeChanged(SearchSecurityGadgetSearchCriteria.IUP, iup);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecurityGadgetSearchCriteria.prototype, "bfp", {
                    get: function () {
                        return this._bfp;
                    },
                    set: function (bfp) {
                        if (this._bfp !== bfp) {
                            this._bfp = bfp;
                            this.attributeChanged(SearchSecurityGadgetSearchCriteria.BFP, bfp);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecurityGadgetSearchCriteria.prototype, "variableInterestRate", {
                    get: function () {
                        return this._variableInterestRate;
                    },
                    set: function (variableInterestRate) {
                        if (this._variableInterestRate !== variableInterestRate) {
                            this._variableInterestRate = variableInterestRate;
                            this.attributeChanged(SearchSecurityGadgetSearchCriteria.VARIABLE_INTEREST_RATE, variableInterestRate);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecurityGadgetSearchCriteria.prototype, "year", {
                    get: function () {
                        return this._year;
                    },
                    set: function (year) {
                        if (this._year !== year) {
                            this._year = year;
                            this.attributeChanged(SearchSecurityGadgetSearchCriteria.YEAR, year);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecurityGadgetSearchCriteria.prototype, "referenceDate", {
                    get: function () {
                        return this._referenceDate;
                    },
                    set: function (referenceDate) {
                        if (this._referenceDate !== referenceDate) {
                            this._referenceDate = referenceDate;
                            this.attributeChanged(SearchSecurityGadgetSearchCriteria.REFERENCE_DATE, referenceDate);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchSecurityGadgetSearchCriteria.prototype, "language", {
                    get: function () {
                        return this._language;
                    },
                    set: function (language) {
                        if (this._language !== language) {
                            this._language = language;
                            this.attributeChanged(SearchSecurityGadgetSearchCriteria.LANGUAGE, language);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                SearchSecurityGadgetSearchCriteria.prototype.reset = function () {
                    _super.prototype.reset.call(this);
                    this._valorNumber = null;
                    this._isin = null;
                    this._nsin = null;
                    this._name = null;
                    this._institution = null;
                    this._instrument = null;
                    this._instrumentGroup = null;
                    this._instrumentType = null;
                    this._country = null;
                    this._currency = null;
                    this._issueYear = null;
                    this._interestRate = null;
                    this._redemptionYear = null;
                    this._iup = null;
                    this._bfp = null;
                    this._variableInterestRate = null;
                    this._year = null;
                    this._referenceDate = null;
                    this._language = null;
                };
                SearchSecurityGadgetSearchCriteria.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (ags_client_2.isPresent(this.valorNumber)) {
                        object['valorNumber'] = this.valorNumber;
                    }
                    if (ags_client_2.isPresent(this.isin)) {
                        object['isin'] = this.isin;
                    }
                    if (ags_client_2.isPresent(this.nsin)) {
                        object['nsin'] = this.nsin;
                    }
                    if (ags_client_2.isPresent(this.name)) {
                        object['name'] = this.name;
                    }
                    if (ags_client_2.isPresent(this.institution)) {
                        object['institution'] = this.institution;
                    }
                    if (ags_client_2.isPresent(this.instrument)) {
                        object['instrument'] = this.instrument;
                    }
                    if (ags_client_2.isPresent(this.instrumentGroup)) {
                        object['instrumentGroup'] = ags_client_3.InstrumentGroup[this.instrumentGroup];
                    }
                    if (ags_client_2.isPresent(this.instrumentType)) {
                        object['instrumentType'] = ags_client_4.InstrumentType[this.instrumentType];
                    }
                    if (ags_client_2.isPresent(this.country)) {
                        object['country'] = this.country;
                    }
                    if (ags_client_2.isPresent(this.currency)) {
                        object['currency'] = this.currency;
                    }
                    if (ags_client_2.isPresent(this.issueYear)) {
                        object['issueYear'] = this.issueYear;
                    }
                    if (ags_client_2.isPresent(this.interestRate)) {
                        object['interestRate'] = this.interestRate;
                    }
                    if (ags_client_2.isPresent(this.redemptionYear)) {
                        object['redemptionYear'] = this.redemptionYear;
                    }
                    if (ags_client_2.isPresent(this.iup)) {
                        object['iup'] = this.iup;
                    }
                    if (ags_client_2.isPresent(this.bfp)) {
                        object['bfp'] = this.bfp;
                    }
                    if (ags_client_2.isPresent(this.variableInterestRate)) {
                        object['variableInterestRate'] = this.variableInterestRate;
                    }
                    if (ags_client_2.isPresent(this.year)) {
                        object['year'] = this.year;
                    }
                    if (ags_client_2.isPresent(this.referenceDate)) {
                        object['referenceDate'] = ags_client_5.serializeDate(this.referenceDate);
                    }
                    if (ags_client_2.isPresent(this.language)) {
                        object['language'] = this.language;
                    }
                    return object;
                };
                SearchSecurityGadgetSearchCriteria.VALOR_NUMBER = 'valorNumber';
                SearchSecurityGadgetSearchCriteria.ISIN = 'isin';
                SearchSecurityGadgetSearchCriteria.NSIN = 'nsin';
                SearchSecurityGadgetSearchCriteria.NAME = 'name';
                SearchSecurityGadgetSearchCriteria.INSTITUTION = 'institution';
                SearchSecurityGadgetSearchCriteria.INSTRUMENT = 'instrument';
                SearchSecurityGadgetSearchCriteria.INSTRUMENT_GROUP = 'instrumentGroup';
                SearchSecurityGadgetSearchCriteria.INSTRUMENT_TYPE = 'instrumentType';
                SearchSecurityGadgetSearchCriteria.COUNTRY = 'country';
                SearchSecurityGadgetSearchCriteria.CURRENCY = 'currency';
                SearchSecurityGadgetSearchCriteria.ISSUE_YEAR = 'issueYear';
                SearchSecurityGadgetSearchCriteria.INTEREST_RATE = 'interestRate';
                SearchSecurityGadgetSearchCriteria.REDEMPTION_YEAR = 'redemptionYear';
                SearchSecurityGadgetSearchCriteria.IUP = 'iup';
                SearchSecurityGadgetSearchCriteria.BFP = 'bfp';
                SearchSecurityGadgetSearchCriteria.VARIABLE_INTEREST_RATE = 'variableInterestRate';
                SearchSecurityGadgetSearchCriteria.YEAR = 'year';
                SearchSecurityGadgetSearchCriteria.REFERENCE_DATE = 'referenceDate';
                SearchSecurityGadgetSearchCriteria.LANGUAGE = 'language';
                return SearchSecurityGadgetSearchCriteria;
            }(ags_client_1.SearchCriteria);
            exports_1("SearchSecurityGadgetSearchCriteria", SearchSecurityGadgetSearchCriteria);
        }
    };
});

System.register("ict-core-client/gen/viewsearch.js", ["ict-core-client/gen/viewsearch/capitalization_rate_gadget_search_criteria.js", "ict-core-client/gen/viewsearch/currencynote_gadget_search_criteria.js", "ict-core-client/gen/viewsearch/currencytoken_gadget_search_criteria.js", "ict-core-client/gen/viewsearch/search_security_gadget_search_criteria.js"], function (exports_1, context_1) {
    "use strict";

    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (capitalization_rate_gadget_search_criteria_1_1) {
            exports_1({
                "CapitalizationRateGadgetSearchCriteria": capitalization_rate_gadget_search_criteria_1_1["CapitalizationRateGadgetSearchCriteria"]
            });
        }, function (currencynote_gadget_search_criteria_1_1) {
            exports_1({
                "CurrencynoteGadgetSearchCriteria": currencynote_gadget_search_criteria_1_1["CurrencynoteGadgetSearchCriteria"]
            });
        }, function (currencytoken_gadget_search_criteria_1_1) {
            exports_1({
                "CurrencytokenGadgetSearchCriteria": currencytoken_gadget_search_criteria_1_1["CurrencytokenGadgetSearchCriteria"]
            });
        }, function (search_security_gadget_search_criteria_1_1) {
            exports_1({
                "SearchSecurityGadgetSearchCriteria": search_security_gadget_search_criteria_1_1["SearchSecurityGadgetSearchCriteria"]
            });
        }],
        execute: function () {}
    };
});

System.register("ict-core-client/ict-core-client.js", ["ict-core-client/app/services.js", "ict-core-client/app/constants.js", "ict-core-client/gen/i18n/translation_constants.js", "ict-core-client/gen/codes.js", "ict-core-client/gen/enums.js", "ict-core-client/gen/viewmodels.js", "ict-core-client/gen/viewsearch.js"], function (exports_1, context_1) {
    "use strict";

    var __moduleName = context_1 && context_1.id;
    function exportStar_1(m) {
        var exports = {};
        for (var n in m) {
            if (n !== "default") exports[n] = m[n];
        }
        exports_1(exports);
    }
    return {
        setters: [function (services_1_1) {
            exportStar_1(services_1_1);
        }, function (constants_1_1) {
            exportStar_1(constants_1_1);
        }, function (translation_constants_1_1) {
            exportStar_1(translation_constants_1_1);
        }, function (codes_1_1) {
            exportStar_1(codes_1_1);
        }, function (enums_1_1) {
            exportStar_1(enums_1_1);
        }, function (viewmodels_1_1) {
            exportStar_1(viewmodels_1_1);
        }, function (viewsearch_1_1) {
            exportStar_1(viewsearch_1_1);
        }],
        execute: function () {}
    };
});

System.register("ict-external-client/gen/viewmodels/online_messages_view_model.js", ["ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, OnlineMessagesViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }],
        execute: function () {
            OnlineMessagesViewModel = /** @class */function () {
                function OnlineMessagesViewModel() {}
                OnlineMessagesViewModel.deserialize = function (object) {
                    var _result = new OnlineMessagesViewModel();
                    return _result._deserialize(object);
                };
                OnlineMessagesViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (ags_client_1.isPresent(object['info'])) {
                            this.info = object['info'];
                        }
                        if (ags_client_1.isPresent(object['warning'])) {
                            this.warning = object['warning'];
                        }
                        if (ags_client_1.isPresent(object['error'])) {
                            this.error = object['error'];
                        }
                    }
                    return this;
                };
                OnlineMessagesViewModel.prototype.serialize = function () {
                    var object = {};
                    if (ags_client_1.isPresent(this.info)) {
                        object['info'] = this.info;
                    }
                    if (ags_client_1.isPresent(this.warning)) {
                        object['warning'] = this.warning;
                    }
                    if (ags_client_1.isPresent(this.error)) {
                        object['error'] = this.error;
                    }
                    return object;
                };
                OnlineMessagesViewModel.INFO_VALIDATORS = [];
                OnlineMessagesViewModel.WARNING_VALIDATORS = [];
                OnlineMessagesViewModel.ERROR_VALIDATORS = [];
                return OnlineMessagesViewModel;
            }();
            exports_1("OnlineMessagesViewModel", OnlineMessagesViewModel);
        }
    };
});

System.register("ict-external-client/gen/services/abstract_application_service.js", ["ags-client/ags-client.js", "ict-core-client/ict-core-client.js", "ict-external-client/gen/viewmodels/online_messages_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var ags_client_1, ict_core_client_1, online_messages_view_model_1, ags_client_2, AbstractApplicationService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
        }, function (ict_core_client_1_1) {
            ict_core_client_1 = ict_core_client_1_1;
        }, function (online_messages_view_model_1_1) {
            online_messages_view_model_1 = online_messages_view_model_1_1;
        }],
        execute: function () {
            AbstractApplicationService = /** @class */function () {
                function AbstractApplicationService(backendService) {
                    this.backendService = backendService;
                }
                AbstractApplicationService.prototype.systemParameters = function () {
                    return this.backendService.getJson('/application/systemParameters.json', function (response) {
                        return ags_client_1.JsonResponse.deserialize(response, ict_core_client_1.SystemParametersViewModel.deserialize(response.data));
                    });
                };
                AbstractApplicationService.prototype.onlineMessages = function (request) {
                    return this.backendService.getJson('/application/onlineMessages/' + request + '.json', function (response) {
                        return ags_client_1.JsonResponse.deserialize(response, online_messages_view_model_1.OnlineMessagesViewModel.deserialize(response.data));
                    });
                };
                AbstractApplicationService.prototype.info = function () {
                    return this.backendService.getJson('/application/info.json', function (response) {
                        return ags_client_1.JsonResponse.deserialize(response, ags_client_2.ApplicationInformationViewModel.deserialize(response.data));
                    });
                };
                return AbstractApplicationService;
            }();
            exports_1("AbstractApplicationService", AbstractApplicationService);
        }
    };
});

System.register("ags-client/app/components/navigation_component.js", ["angular2/router.js", "angular2/core.js", "ags-client/app/constants.js", "ags-client/app/services/authentication_service.js", "ags-client/app/services/navigation_service.js", "ags-client/app/commons/lang.js", "ags-client/app/commons/html.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var router_1, core_1, constants_1, authentication_service_1, navigation_service_1, lang_1, html_1, NavigationComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (router_1_1) {
            router_1 = router_1_1;
        }, function (core_1_1) {
            core_1 = core_1_1;
        }, function (constants_1_1) {
            constants_1 = constants_1_1;
        }, function (authentication_service_1_1) {
            authentication_service_1 = authentication_service_1_1;
        }, function (navigation_service_1_1) {
            navigation_service_1 = navigation_service_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }, function (html_1_1) {
            html_1 = html_1_1;
        }],
        execute: function () {
            NavigationComponent = /** @class */function () {
                function NavigationComponent(router, _navigationService, _authenticationService) {
                    var _this = this;
                    this._navigationService = _navigationService;
                    this._authenticationService = _authenticationService;
                    this._router = router;
                    this._router.subscribe(function () {
                        if (_this._current && !_this.active(_this._current, true)) {
                            var activeEntry = _this._findActiveEntry();
                            if (activeEntry) {
                                _this._current = activeEntry;
                            }
                        }
                    });
                }
                NavigationComponent.prototype._findActiveEntry = function () {
                    for (var i = 0; i < this._navigationService.model.entries.length; i++) {
                        if (this._navigationService.model.entries[i].childs) {
                            for (var j = 0; j < this._navigationService.model.entries[i].childs.length; j++) {
                                if (this.active(this._navigationService.model.entries[i].childs[j], true)) {
                                    return this._navigationService.model.entries[i].childs[j];
                                }
                            }
                        }
                        if (this.active(this._navigationService.model.entries[i], true)) {
                            return this._navigationService.model.entries[i];
                        }
                    }
                };
                Object.defineProperty(NavigationComponent.prototype, "authenticated", {
                    get: function () {
                        return this._authenticationService.userSession && this._authenticationService.userSession.authenticated;
                    },
                    enumerable: false,
                    configurable: true
                });
                NavigationComponent.prototype.visible = function (entry) {
                    if (entry && (!entry.security || entry.security.length === 0)) {
                        if (entry.childs && entry.childs.length > 0) {
                            for (var i = 0; i < entry.childs.length; i++) {
                                if (this.visible(entry.childs[i])) {
                                    return true;
                                }
                            }
                            return false;
                        } else {
                            return true;
                        }
                    } else {
                        return entry && this._authenticationService.hasPermission(entry.security);
                    }
                };
                NavigationComponent.prototype._linkParams = function (entry) {
                    if (lang_1.isPresent(entry.params)) {
                        return [entry.target, entry.params];
                    } else {
                        return [entry.target];
                    }
                };
                NavigationComponent.prototype.active = function (entry, enforce) {
                    if (enforce === void 0) {
                        enforce = false;
                    }
                    if (!enforce && entry === this._current) {
                        return true;
                    }
                    if ((enforce || !lang_1.isPresent(this._current)) && lang_1.isPresent(entry.target) && !entry.external) {
                        return this._router.isRouteActive(this._router.generate(this._linkParams(entry)));
                    } else {
                        return false;
                    }
                };
                NavigationComponent.prototype.childsVisible = function (entry) {
                    if (this.active(entry)) {
                        return true;
                    }
                    if (entry.childs != null) {
                        for (var i = 0; i < entry.childs.length; i++) {
                            if (this.active(entry.childs[i])) {
                                return true;
                            }
                        }
                    }
                    return false;
                };
                NavigationComponent.prototype.open = function (entry) {
                    if (entry.external) {
                        window.open(entry.target, '_self');
                    } else {
                        this._current = entry;
                        this._router.navigate(this._linkParams(entry));
                        this._navigationService.showIf(html_1.screenWidth());
                    }
                };
                NavigationComponent.prototype.logout = function () {
                    var _this = this;
                    this._authenticationService.logout().subscribe(function () {
                        _this._navigationService.showIf(html_1.screenWidth());
                        _this._router.navigate([_this._authenticationService.afterLogoutView]);
                    });
                };
                Object.defineProperty(NavigationComponent.prototype, "model", {
                    get: function () {
                        return this._navigationService.model;
                    },
                    set: function (model) {
                        this._navigationService.model = model;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(NavigationComponent.prototype, "authenticationService", {
                    get: function () {
                        return this._authenticationService;
                    },
                    enumerable: false,
                    configurable: true
                });
                NavigationComponent = __decorate([core_1.Component({
                    directives: [constants_1.AGS_DIRECTIVES, router_1.ROUTER_DIRECTIVES],
                    pipes: [constants_1.AGS_PIPES],
                    selector: 'navigation',
                    templateUrl: 'ags-client/app/components/navigation_component.html'
                }), core_1.Inject(router_1.Router), __metadata("design:paramtypes", [router_1.Router, navigation_service_1.NavigationService, authentication_service_1.AuthenticationService])], NavigationComponent);
                return NavigationComponent;
            }();
            exports_1("NavigationComponent", NavigationComponent);
        }
    };
});

System.register("ags-client/app/components/confirmation_dialog_component.js", ["angular2/core.js", "ags-client/app/pipes/translation_pipe.js", "ags-client/app/services/confirmation_service.js", "ags-client/app/components/abstract_modal_component.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, translation_pipe_1, confirmation_service_1, abstract_modal_component_1, ConfirmationDialogComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (translation_pipe_1_1) {
            translation_pipe_1 = translation_pipe_1_1;
        }, function (confirmation_service_1_1) {
            confirmation_service_1 = confirmation_service_1_1;
        }, function (abstract_modal_component_1_1) {
            abstract_modal_component_1 = abstract_modal_component_1_1;
        }],
        execute: function () {
            ConfirmationDialogComponent = /** @class */function (_super) {
                __extends(ConfirmationDialogComponent, _super);
                function ConfirmationDialogComponent(_confirmationService) {
                    var _this = _super.call(this, 'confirmation-dialog') || this;
                    _this._confirmationService = _confirmationService;
                    _this.confirmation = new confirmation_service_1.Confirmation();
                    _this._confirmationService.subscribe(function (confirmation) {
                        _this.confirmation = confirmation;
                        _this.show();
                    });
                    return _this;
                }
                ConfirmationDialogComponent.prototype.confirmed = function () {
                    if (this.confirmation && this.confirmation.callback) {
                        this.confirmation.callback();
                    }
                    this.hide();
                };
                ConfirmationDialogComponent = __decorate([core_1.Component({
                    selector: 'confirmation-dialog',
                    pipes: [translation_pipe_1.TranslationPipe],
                    template: "\n<div id=\"confirmation-dialog\" class=\"modal\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-body\">\n                <h5>{{confirmation.message}}</h5>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-danger\" (click)=\"confirmed()\">{{'commons:yes'|translate}}</button>\n                <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">{{'commons:no'|translate}}</button>\n            </div>\n        </div>\n    </div>\n</div>"
                }), __metadata("design:paramtypes", [confirmation_service_1.ConfirmationService])], ConfirmationDialogComponent);
                return ConfirmationDialogComponent;
            }(abstract_modal_component_1.AbstractModalComponent);
            exports_1("ConfirmationDialogComponent", ConfirmationDialogComponent);
        }
    };
});

System.register('ags-client/app/components/abstract_modal_component.js', [], function (exports_1, context_1) {
    "use strict";

    var AbstractModalComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [],
        execute: function () {
            AbstractModalComponent = /** @class */function () {
                function AbstractModalComponent(id) {
                    this.dialogId = id;
                    this.visible = false;
                }
                AbstractModalComponent.prototype.cancel = function () {
                    this.hide();
                };
                AbstractModalComponent.prototype.close = function () {
                    this.hide();
                };
                AbstractModalComponent.prototype.open = function () {
                    this.show();
                };
                AbstractModalComponent.prototype.show = function () {
                    var _this = this;
                    this.visible = true;
                    setTimeout(function () {
                        eval('$("#' + _this.dialogId + '" ).modal("show");');
                    }, 100);
                };
                AbstractModalComponent.prototype.hide = function () {
                    eval('$("#' + this.dialogId + '" ).modal("hide");');
                    this.visible = false;
                };
                return AbstractModalComponent;
            }();
            exports_1("AbstractModalComponent", AbstractModalComponent);
        }
    };
});

System.register("ags-client/app/components/modal_component.js", ["angular2/core.js", "ags-client/app/components/abstract_modal_component.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, abstract_modal_component_1, ModalComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (abstract_modal_component_1_1) {
            abstract_modal_component_1 = abstract_modal_component_1_1;
        }],
        execute: function () {
            ModalComponent = /** @class */function (_super) {
                __extends(ModalComponent, _super);
                function ModalComponent() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                ModalComponent.prototype.show = function () {
                    var _this = this;
                    this.visible = true;
                    setTimeout(function () {
                        eval('$("#' + _this.id + ' div" ).modal("show");');
                    }, 100);
                };
                ModalComponent.prototype.hide = function () {
                    eval('$("#' + this.id + ' div" ).modal("hide");');
                    this.visible = false;
                };
                __decorate([core_1.Input(), __metadata("design:type", String)], ModalComponent.prototype, "title", void 0);
                __decorate([core_1.Input(), __metadata("design:type", String)], ModalComponent.prototype, "id", void 0);
                ModalComponent = __decorate([core_1.Component({
                    selector: 'modal',
                    templateUrl: 'ags-client/app/components/modal_component.html',
                    exportAs: 'modal'
                })], ModalComponent);
                return ModalComponent;
            }(abstract_modal_component_1.AbstractModalComponent);
            exports_1("ModalComponent", ModalComponent);
        }
    };
});

System.register("ags-client/app/components.js", ["ags-client/app/components/abstract_component.js", "ags-client/app/components/abstract_form_component.js", "ags-client/app/components/abstract_table_component.js", "ags-client/app/components/alert_component.js", "ags-client/app/components/navigation_component.js", "ags-client/app/components/button_spinner_component.js", "ags-client/app/components/input_errors_component.js", "ags-client/app/components/confirmation_dialog_component.js", "ags-client/app/components/modal_component.js"], function (exports_1, context_1) {
    "use strict";

    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (abstract_component_1_1) {
            exports_1({
                "AbstractComponent": abstract_component_1_1["AbstractComponent"]
            });
        }, function (abstract_form_component_1_1) {
            exports_1({
                "AbstractFormComponent": abstract_form_component_1_1["AbstractFormComponent"]
            });
        }, function (abstract_table_component_1_1) {
            exports_1({
                "AbstractTableComponent": abstract_table_component_1_1["AbstractTableComponent"]
            });
        }, function (alert_component_1_1) {
            exports_1({
                "AlertComponent": alert_component_1_1["AlertComponent"]
            });
        }, function (navigation_component_1_1) {
            exports_1({
                "NavigationComponent": navigation_component_1_1["NavigationComponent"]
            });
        }, function (button_spinner_component_1_1) {
            exports_1({
                "ButtonSpinnerComponent": button_spinner_component_1_1["ButtonSpinnerComponent"]
            });
        }, function (input_errors_component_1_1) {
            exports_1({
                "InputErrorsComponent": input_errors_component_1_1["InputErrorsComponent"]
            });
        }, function (confirmation_dialog_component_1_1) {
            exports_1({
                "ConfirmationDialogComponent": confirmation_dialog_component_1_1["ConfirmationDialogComponent"]
            });
        }, function (modal_component_1_1) {
            exports_1({
                "ModalComponent": modal_component_1_1["ModalComponent"]
            });
        }],
        execute: function () {}
    };
});

System.register("ags-client/app/directives/select_yearend_directive.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/directives/select_year_directive.js", "ags-client/app/models/select_option.js", "ags-client/app/commons/lang.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, select_year_directive_1, select_option_1, lang_1, SelectYearEndDirective;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (select_year_directive_1_1) {
            select_year_directive_1 = select_year_directive_1_1;
        }, function (select_option_1_1) {
            select_option_1 = select_option_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }],
        execute: function () {
            SelectYearEndDirective = /** @class */function (_super) {
                __extends(SelectYearEndDirective, _super);
                function SelectYearEndDirective(element, control) {
                    return _super.call(this, element, control) || this;
                }
                SelectYearEndDirective.prototype.loadOptions = function (callback) {
                    var options = new Array();
                    for (var i = this.max; i >= this.min; i--) {
                        var val = new Date(i, 11, 31);
                        var text = lang_1.formatDate(val);
                        options.push(new select_option_1.SelectOption(i.toString(), text, val, val.isWeekend() ? "weekend" : null));
                    }
                    callback(options);
                };
                SelectYearEndDirective.prototype.convertFromValue = function (value) {
                    if (this.options) {
                        for (var i = 0; i < this.options.length; i++) {
                            // Date comparison with ==, !=, ===, and !== require use of date.getTime()
                            if (this.options[i].value.getTime() === value.getTime()) {
                                return this.options[i].key;
                            }
                        }
                    }
                    return null;
                };
                SelectYearEndDirective = __decorate([core_1.Directive({
                    selector: 'select[type=yearend]'
                }), core_1.Inject(core_1.ElementRef), core_1.Inject(common_1.NgControl), __metadata("design:paramtypes", [core_1.ElementRef, common_1.NgControl])], SelectYearEndDirective);
                return SelectYearEndDirective;
            }(select_year_directive_1.SelectYearDirective);
            exports_1("SelectYearEndDirective", SelectYearEndDirective);
        }
    };
});

System.register("ags-client/app/directives.js", ["ags-client/app/directives/abstract_select_directive.js", "ags-client/app/directives/form_id_directive.js", "ags-client/app/directives/form_loading_directive.js", "ags-client/app/directives/input_date_directive.js", "ags-client/app/directives/input_decimal_directive.js", "ags-client/app/directives/input_integer_directive.js", "ags-client/app/directives/input_long_directive.js", "ags-client/app/directives/input_text_directive.js", "ags-client/app/directives/select_code_directive.js", "ags-client/app/directives/select_enum_directive.js", "ags-client/app/directives/select_year_directive.js", "ags-client/app/directives/select_month_directive.js", "ags-client/app/directives/select_day_directive.js", "ags-client/app/directives/select_yearend_directive.js"], function (exports_1, context_1) {
    "use strict";

    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (abstract_select_directive_1_1) {
            exports_1({
                "AbstractSelectDirective": abstract_select_directive_1_1["AbstractSelectDirective"]
            });
        }, function (form_id_directive_1_1) {
            exports_1({
                "FormIdDirective": form_id_directive_1_1["FormIdDirective"]
            });
        }, function (form_loading_directive_1_1) {
            exports_1({
                "FormLoadingDirective": form_loading_directive_1_1["FormLoadingDirective"]
            });
        }, function (input_date_directive_1_1) {
            exports_1({
                "InputDateDirective": input_date_directive_1_1["InputDateDirective"]
            });
        }, function (input_decimal_directive_1_1) {
            exports_1({
                "InputDecimalDirective": input_decimal_directive_1_1["InputDecimalDirective"]
            });
        }, function (input_integer_directive_1_1) {
            exports_1({
                "InputIntegerDirective": input_integer_directive_1_1["InputIntegerDirective"]
            });
        }, function (input_long_directive_1_1) {
            exports_1({
                "InputLongDirective": input_long_directive_1_1["InputLongDirective"]
            });
        }, function (input_text_directive_1_1) {
            exports_1({
                "InputTextDirective": input_text_directive_1_1["InputTextDirective"]
            });
        }, function (select_code_directive_1_1) {
            exports_1({
                "SelectCodeDirective": select_code_directive_1_1["SelectCodeDirective"]
            });
        }, function (select_enum_directive_1_1) {
            exports_1({
                "SelectEnumDirective": select_enum_directive_1_1["SelectEnumDirective"]
            });
        }, function (select_year_directive_1_1) {
            exports_1({
                "SelectYearDirective": select_year_directive_1_1["SelectYearDirective"]
            });
        }, function (select_month_directive_1_1) {
            exports_1({
                "SelectMonthDirective": select_month_directive_1_1["SelectMonthDirective"]
            });
        }, function (select_day_directive_1_1) {
            exports_1({
                "SelectDayDirective": select_day_directive_1_1["SelectDayDirective"]
            });
        }, function (select_yearend_directive_1_1) {
            exports_1({
                "SelectYearEndDirective": select_yearend_directive_1_1["SelectYearEndDirective"]
            });
        }],
        execute: function () {}
    };
});

System.register("ags-client/app/services/navigation_service.js", [], function (exports_1, context_1) {
    "use strict";

    var NavigationService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [],
        execute: function () {
            NavigationService = /** @class */function () {
                function NavigationService() {
                    var _this = this;
                    this.hidden = true;
                    this.keepHidden = false;
                    this._initialized = new Promise(function (resolve) {
                        _this._initializedResolve = resolve;
                    });
                }
                NavigationService.prototype.hide = function () {
                    this.hidden = true;
                    this.keepHidden = true;
                };
                NavigationService.prototype.show = function () {
                    this.hidden = false;
                    this.keepHidden = false;
                };
                NavigationService.prototype.showIf = function (width) {
                    this.keepHidden = false;
                    this.widthChanged(width);
                };
                NavigationService.prototype.widthChanged = function (width) {
                    this.hidden = this.keepHidden || width < 768;
                };
                Object.defineProperty(NavigationService.prototype, "model", {
                    get: function () {
                        return this._model;
                    },
                    set: function (model) {
                        this._model = model;
                        this._initializedResolve();
                    },
                    enumerable: false,
                    configurable: true
                });
                NavigationService.prototype.initialized = function () {
                    return this._initialized;
                };
                return NavigationService;
            }();
            exports_1("NavigationService", NavigationService);
        }
    };
});

System.register("ags-client/app/services.js", ["ags-client/app/services/alert_service.js", "ags-client/app/services/backend_service.js", "ags-client/app/services/navigation_service.js", "ags-client/app/services/confirmation_service.js"], function (exports_1, context_1) {
    "use strict";

    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (alert_service_1_1) {
            exports_1({
                "AlertService": alert_service_1_1["AlertService"]
            });
        }, function (backend_service_1_1) {
            exports_1({
                "BackendService": backend_service_1_1["BackendService"]
            });
        }, function (navigation_service_1_1) {
            exports_1({
                "NavigationService": navigation_service_1_1["NavigationService"]
            });
        }, function (confirmation_service_1_1) {
            exports_1({
                "ConfirmationService": confirmation_service_1_1["ConfirmationService"]
            });
        }],
        execute: function () {}
    };
});

System.register("ags-client/app/views/abstract_view.js", ["ags-client/app/services/alert_service.js", "ags-client/app/commons/html.js", "ags-client/app/commons/lang.js"], function (exports_1, context_1) {
    "use strict";

    var alert_service_1, html_1, lang_1, AbstractView;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (alert_service_1_1) {
            alert_service_1 = alert_service_1_1;
        }, function (html_1_1) {
            html_1 = html_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }],
        execute: function () {
            AbstractView = /** @class */function () {
                function AbstractView(_navigationService, _router) {
                    this._navigationService = _navigationService;
                    this._router = _router;
                }
                AbstractView.prototype.init = function () {
                    return;
                };
                AbstractView.prototype.beforeInit = function () {
                    this._navigationService.showIf(html_1.screenWidth());
                };
                AbstractView.prototype.initKeyStrokes = function () {
                    return;
                };
                AbstractView.prototype.ngAfterViewInit = function () {
                    this.focus();
                    this.init();
                    return this.initKeyStrokes();
                };
                AbstractView.prototype.routerOnActivate = function (nextInstruction, prevInstruction) {
                    return this.beforeInit();
                };
                AbstractView.prototype.hideNavigation = function () {
                    this._navigationService.hide();
                };
                AbstractView.prototype.focus = function (id) {
                    setTimeout(function () {
                        if (lang_1.isPresent(id)) {
                            eval('$(\'#' + id + '\').focus();');
                        } else {
                            eval('$(\'.view\').find(\'input[type=text],textarea\').filter(\':visible:first\').focus();');
                        }
                    }, 100);
                };
                AbstractView.prototype.ngOnDestroy = function () {
                    if (alert_service_1.AlertService.instance) {
                        alert_service_1.AlertService.instance.reset();
                    }
                };
                Object.defineProperty(AbstractView.prototype, "router", {
                    get: function () {
                        return this._router;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AbstractView.prototype, "navigationService", {
                    get: function () {
                        return this._navigationService;
                    },
                    enumerable: false,
                    configurable: true
                });
                AbstractView.prototype.goBack = function () {
                    window.history.back();
                };
                return AbstractView;
            }();
            exports_1("AbstractView", AbstractView);
        }
    };
});

System.register("ags-client/app/views.js", ["ags-client/app/views/abstract_view.js"], function (exports_1, context_1) {
    "use strict";

    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (abstract_view_1_1) {
            exports_1({
                "AbstractView": abstract_view_1_1["AbstractView"]
            });
        }],
        execute: function () {}
    };
});

System.register("ags-client/gen/services.js", ["ags-client/app/services/authentication_service.js", "ags-client/app/services/translation_service.js", "ags-client/app/services/category_service.js", "ags-client/app/services/code_service.js", "ags-client/app/services/registration_service.js", "ags-client/app/services/lost_password_service.js", "ags-client/app/services/account_service.js", "ags-client/app/services/darate_service.js", "ags-client/app/services/domain_service.js", "ags-client/app/services/system_service.js", "ags-client/app/services/role_service.js"], function (exports_1, context_1) {
    "use strict";

    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (authentication_service_1_1) {
            exports_1({
                "AuthenticationService": authentication_service_1_1["AuthenticationService"]
            });
        }, function (translation_service_1_1) {
            exports_1({
                "TranslationService": translation_service_1_1["TranslationService"]
            });
        }, function (category_service_1_1) {
            exports_1({
                "CategoryService": category_service_1_1["CategoryService"]
            });
        }, function (code_service_1_1) {
            exports_1({
                "CodeService": code_service_1_1["CodeService"]
            });
        }, function (registration_service_1_1) {
            exports_1({
                "RegistrationService": registration_service_1_1["RegistrationService"]
            });
        }, function (lost_password_service_1_1) {
            exports_1({
                "LostPasswordService": lost_password_service_1_1["LostPasswordService"]
            });
        }, function (account_service_1_1) {
            exports_1({
                "AccountService": account_service_1_1["AccountService"]
            });
        }, function (darate_service_1_1) {
            exports_1({
                "DarateService": darate_service_1_1["DarateService"]
            });
        }, function (domain_service_1_1) {
            exports_1({
                "DomainService": domain_service_1_1["DomainService"]
            });
        }, function (system_service_1_1) {
            exports_1({
                "SystemService": system_service_1_1["SystemService"]
            });
        }, function (role_service_1_1) {
            exports_1({
                "RoleService": role_service_1_1["RoleService"]
            });
        }],
        execute: function () {}
    };
});

System.register("ags-client/gen/services/abstract_account_service.js", ["ags-client/app/models/json_response.js", "ags-client/gen/viewmodels/account_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var json_response_1, account_view_model_1, AbstractAccountService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (json_response_1_1) {
            json_response_1 = json_response_1_1;
        }, function (account_view_model_1_1) {
            account_view_model_1 = account_view_model_1_1;
        }],
        execute: function () {
            AbstractAccountService = /** @class */function () {
                function AbstractAccountService(backendService) {
                    this.backendService = backendService;
                }
                AbstractAccountService.prototype.account = function () {
                    return this.backendService.getJson('/account/account.json', function (response) {
                        return json_response_1.JsonResponse.deserialize(response, account_view_model_1.AccountViewModel.deserialize(response.data));
                    });
                };
                AbstractAccountService.prototype.store = function (request) {
                    return this.backendService.postJson('/account/store.json', request.serialize(), function (response) {
                        return json_response_1.JsonResponse.deserialize(response);
                    });
                };
                return AbstractAccountService;
            }();
            exports_1("AbstractAccountService", AbstractAccountService);
        }
    };
});

System.register("ags-client/app/services/account_service.js", ["angular2/core.js", "ags-client/gen/services/abstract_account_service.js", "ags-client/app/services/backend_service.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, abstract_account_service_1, backend_service_1, AccountService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (abstract_account_service_1_1) {
            abstract_account_service_1 = abstract_account_service_1_1;
        }, function (backend_service_1_1) {
            backend_service_1 = backend_service_1_1;
        }],
        execute: function () {
            AccountService = /** @class */function (_super) {
                __extends(AccountService, _super);
                function AccountService(backendService) {
                    return _super.call(this, backendService) || this;
                }
                AccountService = __decorate([core_1.Injectable(), core_1.Inject(backend_service_1.BackendService), __metadata("design:paramtypes", [backend_service_1.BackendService])], AccountService);
                return AccountService;
            }(abstract_account_service_1.AbstractAccountService);
            exports_1("AccountService", AccountService);
        }
    };
});

System.register("ags-client/app/components/account_form_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/constants.js", "ags-client/gen/viewmodels/account_view_model.js", "ags-client/app/services/alert_service.js", "ags-client/app/services/translation_service.js", "ags-client/app/components/abstract_form_component.js", "ags-client/app/validators.js", "ags-client/app/services/account_service.js", "ags-client/gen/i18n/translation_constants.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, constants_1, account_view_model_1, alert_service_1, translation_service_1, abstract_form_component_1, validators_1, account_service_1, translation_constants_1, AccountFormComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (constants_1_1) {
            constants_1 = constants_1_1;
        }, function (account_view_model_1_1) {
            account_view_model_1 = account_view_model_1_1;
        }, function (alert_service_1_1) {
            alert_service_1 = alert_service_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }, function (abstract_form_component_1_1) {
            abstract_form_component_1 = abstract_form_component_1_1;
        }, function (validators_1_1) {
            validators_1 = validators_1_1;
        }, function (account_service_1_1) {
            account_service_1 = account_service_1_1;
        }, function (translation_constants_1_1) {
            translation_constants_1 = translation_constants_1_1;
        }],
        execute: function () {
            AccountFormComponent = /** @class */function (_super) {
                __extends(AccountFormComponent, _super);
                function AccountFormComponent(alertService, translationService, element, _accountService) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._accountService = _accountService;
                    _this.account = new account_view_model_1.AccountViewModel();
                    return _this;
                }
                AccountFormComponent.prototype.buildForm = function () {
                    this.form = new common_1.ControlGroup({
                        'salutation': new common_1.Control(''),
                        'institution': new common_1.Control('', validators_1.validators(account_view_model_1.AccountViewModel.INSTITUTION_VALIDATORS)),
                        'firstName': new common_1.Control('', validators_1.validators(account_view_model_1.AccountViewModel.FIRST_NAME_VALIDATORS)),
                        'lastName': new common_1.Control('', validators_1.validators(account_view_model_1.AccountViewModel.LAST_NAME_VALIDATORS)),
                        'language': new common_1.Control('', validators_1.validators(account_view_model_1.AccountViewModel.LANGUAGE_VALIDATORS)),
                        'receiveEmail': new common_1.Control('', validators_1.validators(account_view_model_1.AccountViewModel.RECEIVE_EMAIL_VALIDATORS)),
                        'receiveEmailNoPublication': new common_1.Control('', validators_1.validators(account_view_model_1.AccountViewModel.RECEIVE_EMAIL_NO_PUBLICATION_VALIDATORS)),
                        'newsletter': new common_1.Control('', validators_1.validators(account_view_model_1.AccountViewModel.NEWSLETTER_VALIDATORS)),
                        'street': new common_1.Control('', validators_1.validators(account_view_model_1.AccountViewModel.STREET_VALIDATORS)),
                        'zip': new common_1.Control('', validators_1.validators(account_view_model_1.AccountViewModel.ZIP_VALIDATORS)),
                        'country': new common_1.Control('', validators_1.validators(account_view_model_1.AccountViewModel.COUNTRY_VALIDATORS)),
                        'city': new common_1.Control('', validators_1.validators(account_view_model_1.AccountViewModel.CITY_VALIDATORS)),
                        'phone': new common_1.Control('', validators_1.validators(account_view_model_1.AccountViewModel.PHONE_VALIDATORS)),
                        'mobile': new common_1.Control('', validators_1.validators(account_view_model_1.AccountViewModel.MOBILE_VALIDATORS)),
                        'fax': new common_1.Control('', validators_1.validators(account_view_model_1.AccountViewModel.FAX_VALIDATORS))
                    });
                };
                AccountFormComponent.prototype.initData = function () {
                    var _this = this;
                    this.loading = true;
                    this._accountService.account().subscribe(function (response) {
                        if (!_this.handleError(response)) {
                            _this.account = response.data;
                        }
                        _this.loading = false;
                    });
                };
                AccountFormComponent.prototype.submit = function () {
                    var _this = this;
                    if (this.validate()) {
                        this.loading = true;
                        this._accountService.store(this.account).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.alertService.info(_this.translationService.translate(translation_constants_1.TranslationConstants.INFO_SAVED));
                            }
                            _this.loading = false;
                        });
                    }
                };
                __decorate([core_1.Input(), __metadata("design:type", String)], AccountFormComponent.prototype, "id", void 0);
                AccountFormComponent = __decorate([core_1.Component({
                    directives: [constants_1.AGS_FORM_DIRECTIVES],
                    pipes: [constants_1.AGS_PIPES],
                    selector: 'account-form',
                    templateUrl: 'ags-client/app/components/account_form_component.html'
                }), __metadata("design:paramtypes", [alert_service_1.AlertService, translation_service_1.TranslationService, core_1.ElementRef, account_service_1.AccountService])], AccountFormComponent);
                return AccountFormComponent;
            }(abstract_form_component_1.AbstractFormComponent);
            exports_1("AccountFormComponent", AccountFormComponent);
        }
    };
});

System.register("ags-client/app/components/authentication_form_component.js", ["angular2/common.js", "angular2/core.js", "angular2/router.js", "ags-client/app/validators.js", "ags-client/gen/i18n/translation_constants.js", "ags-client/gen/viewmodels/authentication_view_model.js", "ags-client/gen/viewmodels/lost_password_activation_view_model.js", "ags-client/gen/viewmodels/registration_activation_view_model.js", "ags-client/app/commons/lang.js", "ags-client/app/commons/timer.js", "ags-client/app/constants.js", "ags-client/app/services/alert_service.js", "ags-client/app/services/authentication_service.js", "ags-client/app/services/lost_password_service.js", "ags-client/app/services/registration_service.js", "ags-client/app/services/translation_service.js", "ags-client/app/components/abstract_form_component.js", "ags-client/app/components/captcha_component.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var common_1, core_1, router_1, validators_1, translation_constants_1, authentication_view_model_1, lost_password_activation_view_model_1, registration_activation_view_model_1, lang_1, timer_1, constants_1, alert_service_1, authentication_service_1, lost_password_service_1, registration_service_1, translation_service_1, abstract_form_component_1, captcha_component_1, AuthenticationFormComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (common_1_1) {
            common_1 = common_1_1;
        }, function (core_1_1) {
            core_1 = core_1_1;
        }, function (router_1_1) {
            router_1 = router_1_1;
        }, function (validators_1_1) {
            validators_1 = validators_1_1;
        }, function (translation_constants_1_1) {
            translation_constants_1 = translation_constants_1_1;
        }, function (authentication_view_model_1_1) {
            authentication_view_model_1 = authentication_view_model_1_1;
        }, function (lost_password_activation_view_model_1_1) {
            lost_password_activation_view_model_1 = lost_password_activation_view_model_1_1;
        }, function (registration_activation_view_model_1_1) {
            registration_activation_view_model_1 = registration_activation_view_model_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }, function (timer_1_1) {
            timer_1 = timer_1_1;
        }, function (constants_1_1) {
            constants_1 = constants_1_1;
        }, function (alert_service_1_1) {
            alert_service_1 = alert_service_1_1;
        }, function (authentication_service_1_1) {
            authentication_service_1 = authentication_service_1_1;
        }, function (lost_password_service_1_1) {
            lost_password_service_1 = lost_password_service_1_1;
        }, function (registration_service_1_1) {
            registration_service_1 = registration_service_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }, function (abstract_form_component_1_1) {
            abstract_form_component_1 = abstract_form_component_1_1;
        }, function (captcha_component_1_1) {
            captcha_component_1 = captcha_component_1_1;
        }],
        execute: function () {
            AuthenticationFormComponent = /** @class */function (_super) {
                __extends(AuthenticationFormComponent, _super);
                function AuthenticationFormComponent(_authenticationService, _registrationService, _lostPasswordService, alertService, translationService, element, _router) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._authenticationService = _authenticationService;
                    _this._registrationService = _registrationService;
                    _this._lostPasswordService = _lostPasswordService;
                    _this._router = _router;
                    _this.loading = false;
                    _this.authentication = new authentication_view_model_1.AuthenticationViewModel();
                    _this.needsCaptcha = false;
                    _this.passwordExpired = new core_1.EventEmitter();
                    return _this;
                }
                AuthenticationFormComponent.prototype.buildForm = function () {
                    this.form = new common_1.ControlGroup({
                        'login': new common_1.Control('', validators_1.validators(authentication_view_model_1.AuthenticationViewModel.LOGIN_VALIDATORS)),
                        'password': new common_1.Control('', validators_1.validators(authentication_view_model_1.AuthenticationViewModel.PASSWORD_VALIDATORS)),
                        'captcha': new common_1.Control('', validators_1.validators([]))
                    });
                };
                AuthenticationFormComponent.prototype.initData = function () {
                    this.authentication = new authentication_view_model_1.AuthenticationViewModel();
                    this.needsCaptcha = false;
                };
                AuthenticationFormComponent.prototype.checkCaptcha = function () {
                    var _this = this;
                    if (this.form.controls['login'].valid) {
                        // the 'blur' event comes before autofill on tab, so we set a timer
                        if (this._checkCaptchaTimer) {
                            this._checkCaptchaTimer.cancel();
                        }
                        this._checkCaptchaTimer = timer_1.Timer.later(100, function () {
                            _this._checkCaptcha();
                        });
                    }
                };
                AuthenticationFormComponent.prototype._checkCaptcha = function (complete) {
                    var _this = this;
                    if (this.form.controls['login'].valid) {
                        this._checkCaptchaDoneFor = this.authentication.login;
                        this._authenticationService.captcha(this._checkCaptchaDoneFor).subscribe({
                            next: function (response) {
                                if (!_this.handleError(response)) {
                                    _this.needsCaptcha = response.data;
                                    if (_this.needsCaptcha) {
                                        _this.form.controls['captcha'].validator = validators_1.validators(authentication_view_model_1.AuthenticationViewModel.CAPTCHA_VALIDATORS);
                                    } else {
                                        _this.form.controls['captcha'].validator = validators_1.validators([]);
                                        _this._reset(_this.form.controls['captcha']);
                                    }
                                }
                            },
                            complete: complete
                        });
                    }
                };
                AuthenticationFormComponent.prototype.submit = function () {
                    var _this = this;
                    // Detect missing call to checkCaptcha(), which can happen when fields are autofilled
                    // by a password manager.
                    if (this._checkCaptchaDoneFor !== this.authentication.login) {
                        if (this._checkCaptchaTimer) {
                            this._checkCaptchaTimer.cancel();
                        }
                        this._checkCaptcha(function () {
                            _this._innerSubmit();
                        });
                    } else {
                        this._innerSubmit();
                    }
                };
                AuthenticationFormComponent.prototype._innerSubmit = function () {
                    var _this = this;
                    if (this.validate()) {
                        this.alertService.reset();
                        this.loading = true;
                        this._authenticationService.login(this.authentication).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                if (_this._resolveLanguage() !== response.data.language) {
                                    window.location.href = response.data.language + '.html';
                                }
                                _this._router.navigate([_this._authenticationService.afterLoginView]);
                            } else {
                                if (response.error === translation_constants_1.TranslationConstants.LOGIN_EXPIRED) {
                                    _this.passwordExpired.emit(_this.authentication);
                                } else {
                                    if (_this.captcha.first) {
                                        _this.captcha.first.reload();
                                    }
                                    _this.reset();
                                }
                            }
                            _this.loading = false;
                        });
                    }
                };
                AuthenticationFormComponent.prototype._resolveLanguage = function () {
                    var location = window.location.href;
                    return location.match(/\/(de|fr|it|en)\.html/)[1];
                };
                AuthenticationFormComponent.prototype.activateAccount = function (login, code) {
                    var _this = this;
                    if (lang_1.isSomething(login) && lang_1.isSomething(code)) {
                        var activation = new registration_activation_view_model_1.RegistrationActivationViewModel();
                        activation.login = login;
                        activation.activationCode = code;
                        this._registrationService.activate(activation).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.authentication.login = login;
                                _this.alertService.info(_this.translationService.translate(translation_constants_1.TranslationConstants.REGISTRATION_ACCOUNT_ACTIVATED));
                                _this.focus('#' + _this.id + '_authentication_password');
                            }
                        });
                    }
                };
                AuthenticationFormComponent.prototype.resetPassword = function (email, code) {
                    var _this = this;
                    if (lang_1.isSomething(email) && lang_1.isSomething(code)) {
                        var lost = new lost_password_activation_view_model_1.LostPasswordActivationViewModel();
                        lost.email = email;
                        lost.activationCode = code;
                        this._lostPasswordService.resetPassword(lost).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.authentication.login = email;
                                _this.alertService.info(_this.translationService.translate(translation_constants_1.TranslationConstants.LOST_PASSWORD_SUCCESS_MESSAGE));
                                _this.focus('#' + _this.id + '_authentication_password');
                            }
                        });
                    }
                };
                __decorate([core_1.Input(), __metadata("design:type", String)], AuthenticationFormComponent.prototype, "id", void 0);
                __decorate([core_1.ViewChildren(captcha_component_1.CaptchaComponent), __metadata("design:type", core_1.QueryList)], AuthenticationFormComponent.prototype, "captcha", void 0);
                AuthenticationFormComponent = __decorate([core_1.Component({
                    directives: [constants_1.AGS_FORM_DIRECTIVES, captcha_component_1.CaptchaComponent],
                    pipes: [constants_1.AGS_PIPES],
                    selector: 'authentication-form',
                    templateUrl: 'ags-client/app/components/authentication_form_component.html'
                }), __metadata("design:paramtypes", [authentication_service_1.AuthenticationService, registration_service_1.RegistrationService, lost_password_service_1.LostPasswordService, alert_service_1.AlertService, translation_service_1.TranslationService, core_1.ElementRef, router_1.Router])], AuthenticationFormComponent);
                return AuthenticationFormComponent;
            }(abstract_form_component_1.AbstractFormComponent);
            exports_1("AuthenticationFormComponent", AuthenticationFormComponent);
        }
    };
});

System.register("ags-client/gen/services/abstract_authentication_service.js", ["ags-client/app/models/json_response.js", "ags-client/gen/viewmodels/session_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var json_response_1, session_view_model_1, AbstractAuthenticationService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (json_response_1_1) {
            json_response_1 = json_response_1_1;
        }, function (session_view_model_1_1) {
            session_view_model_1 = session_view_model_1_1;
        }],
        execute: function () {
            AbstractAuthenticationService = /** @class */function () {
                function AbstractAuthenticationService(backendService) {
                    this.backendService = backendService;
                }
                AbstractAuthenticationService.prototype.login = function (request) {
                    return this.backendService.postJson('/authentication/login.json', request.serialize(), function (response) {
                        return json_response_1.JsonResponse.deserialize(response, session_view_model_1.SessionViewModel.deserialize(response.data));
                    });
                };
                AbstractAuthenticationService.prototype.session = function () {
                    return this.backendService.getJson('/authentication/session.json', function (response) {
                        return json_response_1.JsonResponse.deserialize(response, session_view_model_1.SessionViewModel.deserialize(response.data));
                    });
                };
                AbstractAuthenticationService.prototype.logout = function () {
                    return this.backendService.getJson('/authentication/logout.json', function (response) {
                        return json_response_1.JsonResponse.deserialize(response, session_view_model_1.SessionViewModel.deserialize(response.data));
                    });
                };
                AbstractAuthenticationService.prototype.changePassword = function (request) {
                    return this.backendService.postJson('/authentication/changePassword.json', request.serialize(), function (response) {
                        return json_response_1.JsonResponse.deserialize(response);
                    });
                };
                AbstractAuthenticationService.prototype.captcha = function (request) {
                    return this.backendService.getJson('/authentication/captcha/' + request + '.json', function (response) {
                        return json_response_1.JsonResponse.deserialize(response, response.data);
                    });
                };
                return AbstractAuthenticationService;
            }();
            exports_1("AbstractAuthenticationService", AbstractAuthenticationService);
        }
    };
});

System.register("ags-client/app/services/authentication_service.js", ["angular2/core.js", "angular2/router.js", "ags-client/gen/services/abstract_authentication_service.js", "ags-client/app/services/backend_service.js", "ags-client/app/models/json_response.js", "ags-client/app/commons/timer.js", "ags-client/app/services/alert_service.js", "ags-client/app/services/translation_service.js", "ags-client/gen/i18n/translation_constants.js", "rxjs/add/operator/do.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, router_1, abstract_authentication_service_1, backend_service_1, json_response_1, timer_1, alert_service_1, translation_service_1, translation_constants_1, AuthenticationService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (router_1_1) {
            router_1 = router_1_1;
        }, function (abstract_authentication_service_1_1) {
            abstract_authentication_service_1 = abstract_authentication_service_1_1;
        }, function (backend_service_1_1) {
            backend_service_1 = backend_service_1_1;
        }, function (json_response_1_1) {
            json_response_1 = json_response_1_1;
        }, function (timer_1_1) {
            timer_1 = timer_1_1;
        }, function (alert_service_1_1) {
            alert_service_1 = alert_service_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }, function (translation_constants_1_1) {
            translation_constants_1 = translation_constants_1_1;
        }, function (_1) {}],
        execute: function () {
            AuthenticationService = /** @class */function (_super) {
                __extends(AuthenticationService, _super);
                function AuthenticationService(backendService, _router, _alertService, _translationService) {
                    var _this = _super.call(this, backendService) || this;
                    _this._router = _router;
                    _this._alertService = _alertService;
                    _this._translationService = _translationService;
                    return _this;
                }
                AuthenticationService_1 = AuthenticationService;
                AuthenticationService.prototype.initialize = function () {
                    var _this = this;
                    if (!this._initialization) {
                        this._initialization = new Promise(function (resolve) {
                            _super.prototype.session.call(_this).subscribe(function (response) {
                                if (response.status === json_response_1.JsonResponseStatus.SUCCESS) {
                                    _this._userSession = response.data;
                                    backend_service_1.BackendService.csrfToken = _this._userSession.csrfToken;
                                    _this.checkSession();
                                    resolve(_this);
                                    AuthenticationService_1._instancePromiseResolve(_this);
                                }
                            });
                        });
                    }
                    return this._initialization;
                };
                AuthenticationService.prototype.checkSession = function () {
                    var self = this;
                    if (this._sessionCheckTimer) {
                        this._sessionCheckTimer.cancel();
                    }
                    if (this.authenticated()) {
                        this._sessionCheckTimer = timer_1.Timer.later(this.userSession.timeout + 1000, function () {
                            self.session().subscribe(function (response) {
                                if (response.status === json_response_1.JsonResponseStatus.SUCCESS) {
                                    self._userSession = response.data;
                                    backend_service_1.BackendService.csrfToken = self._userSession.csrfToken;
                                    if (!self.authenticated()) {
                                        self._alertService.warning(self._translationService.translate(translation_constants_1.TranslationConstants.AUTHENTICATION_SESSION_EXPIRED));
                                        self._router.navigate([self.afterLogoutView]);
                                    } else {
                                        self.checkSession();
                                    }
                                }
                            });
                        });
                    } else {
                        this._sessionCheckTimer = timer_1.Timer.later(this.userSession.timeout - 10000, function () {
                            self.session().subscribe(function (response) {
                                if (response.status === json_response_1.JsonResponseStatus.SUCCESS) {
                                    self._userSession = response.data;
                                    backend_service_1.BackendService.csrfToken = self._userSession.csrfToken;
                                    self.checkSession();
                                }
                            });
                        });
                    }
                };
                AuthenticationService.prototype.authenticated = function () {
                    return this._userSession && this._userSession.authenticated;
                };
                AuthenticationService.prototype.hasPermission = function (permissions) {
                    if (this.authenticated()) {
                        for (var i = 0; i < permissions.length; i++) {
                            for (var j = 0; j < this._userSession.permissions.length; j++) {
                                if (permissions[i] === this._userSession.permissions[j]) {
                                    return true;
                                }
                            }
                        }
                    }
                    return false;
                };
                AuthenticationService.checkViewSecurity = function (permissions) {
                    return new Promise(function (resolve) {
                        if (permissions && permissions.length > 0) {
                            AuthenticationService_1._instance.then(function (authenticationService) {
                                if (authenticationService.hasPermission(permissions)) {
                                    resolve(true);
                                } else {
                                    resolve(false);
                                    authenticationService._router.navigate([authenticationService.afterLogoutView]);
                                }
                            });
                        } else {
                            resolve(true);
                        }
                    });
                };
                AuthenticationService.csrfToken = function () {
                    return new Promise(function (callback) {
                        AuthenticationService_1._instance.then(function (authenticationService) {
                            callback(authenticationService.userSession ? authenticationService.userSession.csrfToken : null);
                        });
                    });
                };
                AuthenticationService.prototype.login = function (request) {
                    var _this = this;
                    return _super.prototype.login.call(this, request).do(function (response) {
                        if (response.status === json_response_1.JsonResponseStatus.SUCCESS) {
                            _this._userSession = response.data;
                            backend_service_1.BackendService.csrfToken = _this._userSession.csrfToken;
                            _this.checkSession();
                        }
                    });
                };
                AuthenticationService.prototype.logout = function () {
                    var _this = this;
                    return _super.prototype.logout.call(this).do(function (response) {
                        if (response.status === json_response_1.JsonResponseStatus.SUCCESS) {
                            _this._userSession = response.data;
                            backend_service_1.BackendService.csrfToken = _this._userSession.csrfToken;
                            _this.checkSession();
                        }
                    });
                };
                Object.defineProperty(AuthenticationService.prototype, "userSession", {
                    get: function () {
                        return this._userSession;
                    },
                    enumerable: false,
                    configurable: true
                });
                var AuthenticationService_1;
                AuthenticationService._instance = new Promise(function (resolve) {
                    AuthenticationService_1._instancePromiseResolve = resolve;
                });
                AuthenticationService = AuthenticationService_1 = __decorate([core_1.Injectable(), core_1.Inject(backend_service_1.BackendService), __metadata("design:paramtypes", [backend_service_1.BackendService, router_1.Router, alert_service_1.AlertService, translation_service_1.TranslationService])], AuthenticationService);
                return AuthenticationService;
            }(abstract_authentication_service_1.AbstractAuthenticationService);
            exports_1("AuthenticationService", AuthenticationService);
        }
    };
});

System.register("ags-client/app/components/change_password_form_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/constants.js", "ags-client/app/commons.js", "ags-client/app/services/alert_service.js", "ags-client/app/services/authentication_service.js", "ags-client/gen/viewmodels/change_password_view_model.js", "ags-client/app/services/translation_service.js", "ags-client/app/components/abstract_form_component.js", "ags-client/app/validators.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, constants_1, commons_1, alert_service_1, authentication_service_1, change_password_view_model_1, translation_service_1, abstract_form_component_1, validators_1, ChangePasswordFormComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (constants_1_1) {
            constants_1 = constants_1_1;
        }, function (commons_1_1) {
            commons_1 = commons_1_1;
        }, function (alert_service_1_1) {
            alert_service_1 = alert_service_1_1;
        }, function (authentication_service_1_1) {
            authentication_service_1 = authentication_service_1_1;
        }, function (change_password_view_model_1_1) {
            change_password_view_model_1 = change_password_view_model_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }, function (abstract_form_component_1_1) {
            abstract_form_component_1 = abstract_form_component_1_1;
        }, function (validators_1_1) {
            validators_1 = validators_1_1;
        }],
        execute: function () {
            ChangePasswordFormComponent = /** @class */function (_super) {
                __extends(ChangePasswordFormComponent, _super);
                function ChangePasswordFormComponent(_authenticationService, alertService, translationService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._authenticationService = _authenticationService;
                    _this.needsOldPassword = true;
                    _this.passwordChanged = new core_1.EventEmitter();
                    return _this;
                }
                ChangePasswordFormComponent.prototype.buildForm = function () {
                    this.form = new common_1.ControlGroup({
                        'newPassword': new common_1.Control('', validators_1.validators(change_password_view_model_1.ChangePasswordViewModel.NEW_PASSWORD_VALIDATORS.concat([validators_1.password(), this.validateNewPassword()]))),
                        'passwordRepeat': new common_1.Control('', validators_1.validators(change_password_view_model_1.ChangePasswordViewModel.PASSWORD_REPEAT_VALIDATORS.concat([this.validatePasswordRepeat()])))
                    });
                    if (this.needsOldPassword) {
                        this.form.addControl('oldPassword', new common_1.Control('', validators_1.validators(change_password_view_model_1.ChangePasswordViewModel.OLD_PASSWORD_VALIDATORS)));
                    }
                };
                ChangePasswordFormComponent.prototype.initData = function () {
                    this.changePassword = new change_password_view_model_1.ChangePasswordViewModel();
                };
                ChangePasswordFormComponent.prototype.validateNewPassword = function () {
                    var self = this;
                    return function (control) {
                        if (commons_1.isPresent(control.value) && self.changePassword) {
                            if (control.value === self.changePassword.oldPassword) {
                                return { 'same_password': true };
                            }
                        }
                        return null;
                    };
                };
                ChangePasswordFormComponent.prototype.validatePasswordRepeat = function () {
                    var self = this;
                    return function (control) {
                        if (commons_1.isPresent(control.value) && self.changePassword) {
                            if (control.value !== self.changePassword.newPassword) {
                                return { 'password_repeat': true };
                            }
                        }
                        return null;
                    };
                };
                ChangePasswordFormComponent.prototype.newPasswordChanged = function () {
                    this.form.controls['passwordRepeat'].updateValueAndValidity();
                };
                ChangePasswordFormComponent.prototype.submit = function () {
                    var _this = this;
                    this.changePassword.login = this.login;
                    if (this.validate()) {
                        this.alertService.reset();
                        this.loading = true;
                        this._authenticationService.changePassword(this.changePassword).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.passwordChanged.emit(_this.changePassword);
                            }
                            _this._reset(_this.form);
                            _this.loading = false;
                        });
                    }
                };
                __decorate([core_1.Input(), __metadata("design:type", String)], ChangePasswordFormComponent.prototype, "id", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Object)], ChangePasswordFormComponent.prototype, "needsOldPassword", void 0);
                __decorate([core_1.Input(), __metadata("design:type", String)], ChangePasswordFormComponent.prototype, "login", void 0);
                ChangePasswordFormComponent = __decorate([core_1.Component({
                    directives: [constants_1.AGS_FORM_DIRECTIVES],
                    pipes: [constants_1.AGS_PIPES],
                    selector: 'change-password-form',
                    templateUrl: 'ags-client/app/components/change_password_form_component.html'
                }), __metadata("design:paramtypes", [authentication_service_1.AuthenticationService, alert_service_1.AlertService, translation_service_1.TranslationService, core_1.ElementRef])], ChangePasswordFormComponent);
                return ChangePasswordFormComponent;
            }(abstract_form_component_1.AbstractFormComponent);
            exports_1("ChangePasswordFormComponent", ChangePasswordFormComponent);
        }
    };
});

System.register("ags-client/gen/services/abstract_lost_password_service.js", ["ags-client/app/models/json_response.js"], function (exports_1, context_1) {
    "use strict";

    var json_response_1, AbstractLostPasswordService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (json_response_1_1) {
            json_response_1 = json_response_1_1;
        }],
        execute: function () {
            AbstractLostPasswordService = /** @class */function () {
                function AbstractLostPasswordService(backendService) {
                    this.backendService = backendService;
                }
                AbstractLostPasswordService.prototype.requestPassword = function (request) {
                    return this.backendService.postJson('/lostPassword/requestPassword.json', request.serialize(), function (response) {
                        return json_response_1.JsonResponse.deserialize(response);
                    });
                };
                AbstractLostPasswordService.prototype.resetPassword = function (request) {
                    return this.backendService.postJson('/lostPassword/resetPassword.json', request.serialize(), function (response) {
                        return json_response_1.JsonResponse.deserialize(response);
                    });
                };
                return AbstractLostPasswordService;
            }();
            exports_1("AbstractLostPasswordService", AbstractLostPasswordService);
        }
    };
});

System.register("ags-client/app/services/lost_password_service.js", ["angular2/core.js", "ags-client/gen/services/abstract_lost_password_service.js", "ags-client/app/services/backend_service.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, abstract_lost_password_service_1, backend_service_1, LostPasswordService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (abstract_lost_password_service_1_1) {
            abstract_lost_password_service_1 = abstract_lost_password_service_1_1;
        }, function (backend_service_1_1) {
            backend_service_1 = backend_service_1_1;
        }],
        execute: function () {
            LostPasswordService = /** @class */function (_super) {
                __extends(LostPasswordService, _super);
                function LostPasswordService(backendService) {
                    return _super.call(this, backendService) || this;
                }
                LostPasswordService = __decorate([core_1.Injectable(), core_1.Inject(backend_service_1.BackendService), __metadata("design:paramtypes", [backend_service_1.BackendService])], LostPasswordService);
                return LostPasswordService;
            }(abstract_lost_password_service_1.AbstractLostPasswordService);
            exports_1("LostPasswordService", LostPasswordService);
        }
    };
});

System.register("ags-client/app/components/lost_password_form_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/constants.js", "ags-client/app/services/alert_service.js", "ags-client/app/services/translation_service.js", "ags-client/app/components/abstract_form_component.js", "ags-client/gen/viewmodels/lost_password_view_model.js", "ags-client/app/validators.js", "ags-client/app/components/captcha_component.js", "ags-client/app/services/lost_password_service.js", "ags-client/gen/i18n/translation_constants.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, constants_1, alert_service_1, translation_service_1, abstract_form_component_1, lost_password_view_model_1, validators_1, captcha_component_1, lost_password_service_1, translation_constants_1, LostPasswordFormComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (constants_1_1) {
            constants_1 = constants_1_1;
        }, function (alert_service_1_1) {
            alert_service_1 = alert_service_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }, function (abstract_form_component_1_1) {
            abstract_form_component_1 = abstract_form_component_1_1;
        }, function (lost_password_view_model_1_1) {
            lost_password_view_model_1 = lost_password_view_model_1_1;
        }, function (validators_1_1) {
            validators_1 = validators_1_1;
        }, function (captcha_component_1_1) {
            captcha_component_1 = captcha_component_1_1;
        }, function (lost_password_service_1_1) {
            lost_password_service_1 = lost_password_service_1_1;
        }, function (translation_constants_1_1) {
            translation_constants_1 = translation_constants_1_1;
        }],
        execute: function () {
            LostPasswordFormComponent = /** @class */function (_super) {
                __extends(LostPasswordFormComponent, _super);
                function LostPasswordFormComponent(alertService, _lostPasswordService, translationService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._lostPasswordService = _lostPasswordService;
                    _this.success = false;
                    return _this;
                }
                LostPasswordFormComponent.prototype.buildForm = function () {
                    this.form = new common_1.ControlGroup({
                        'email': new common_1.Control('', validators_1.validators([validators_1.email(), validators_1.required()])),
                        'captcha': new common_1.Control('', validators_1.validators([validators_1.required()]))
                    });
                };
                LostPasswordFormComponent.prototype.initData = function () {
                    this.lostPassword = new lost_password_view_model_1.LostPasswordViewModel();
                };
                LostPasswordFormComponent.prototype.submit = function () {
                    var _this = this;
                    if (this.validate()) {
                        this.alertService.reset();
                        this.loading = true;
                        this._lostPasswordService.requestPassword(this.lostPassword).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.alertService.info(_this.translationService.translate(translation_constants_1.TranslationConstants.LOST_PASSWORD_SUCCESS_MESSAGE));
                                _this.success = true;
                            } else {
                                _this.captcha.first.reload();
                                _this.initData();
                                _this.reset();
                            }
                            _this.loading = false;
                        });
                    }
                };
                __decorate([core_1.ViewChildren(captcha_component_1.CaptchaComponent), __metadata("design:type", core_1.QueryList)], LostPasswordFormComponent.prototype, "captcha", void 0);
                __decorate([core_1.Input(), __metadata("design:type", String)], LostPasswordFormComponent.prototype, "id", void 0);
                LostPasswordFormComponent = __decorate([core_1.Component({
                    directives: [constants_1.AGS_FORM_DIRECTIVES, captcha_component_1.CaptchaComponent],
                    pipes: [constants_1.AGS_PIPES],
                    selector: 'lost-password-form',
                    templateUrl: 'ags-client/app/components/lost_password_form_component.html'
                }), __metadata("design:paramtypes", [alert_service_1.AlertService, lost_password_service_1.LostPasswordService, translation_service_1.TranslationService, core_1.ElementRef])], LostPasswordFormComponent);
                return LostPasswordFormComponent;
            }(abstract_form_component_1.AbstractFormComponent);
            exports_1("LostPasswordFormComponent", LostPasswordFormComponent);
        }
    };
});

System.register("ags-client/app/components/captcha_component.js", ["angular2/core.js", "ags-client/app/pipes/translation_pipe.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var core_1, translation_pipe_1, CaptchaComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (translation_pipe_1_1) {
            translation_pipe_1 = translation_pipe_1_1;
        }],
        execute: function () {
            CaptchaComponent = /** @class */function () {
                function CaptchaComponent() {
                    this.url = 'api/authentication/captcha.jpg?t=' + Date.now().toString();
                }
                CaptchaComponent.prototype.reload = function () {
                    this.url = 'api/authentication/captcha.jpg?t=' + Date.now().toString();
                };
                CaptchaComponent = __decorate([core_1.Component({
                    selector: 'captcha',
                    pipes: [translation_pipe_1.TranslationPipe],
                    templateUrl: 'ags-client/app/components/captcha_component.html'
                })], CaptchaComponent);
                return CaptchaComponent;
            }();
            exports_1("CaptchaComponent", CaptchaComponent);
        }
    };
});

System.register("ags-client/gen/services/abstract_registration_service.js", ["ags-client/app/models/json_response.js"], function (exports_1, context_1) {
    "use strict";

    var json_response_1, AbstractRegistrationService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (json_response_1_1) {
            json_response_1 = json_response_1_1;
        }],
        execute: function () {
            AbstractRegistrationService = /** @class */function () {
                function AbstractRegistrationService(backendService) {
                    this.backendService = backendService;
                }
                AbstractRegistrationService.prototype.checkMail = function (request) {
                    return this.backendService.getJson('/registration/checkMail/' + request + '.json', function (response) {
                        return json_response_1.JsonResponse.deserialize(response);
                    });
                };
                AbstractRegistrationService.prototype.register = function (request) {
                    return this.backendService.postJson('/registration/register.json', request.serialize(), function (response) {
                        return json_response_1.JsonResponse.deserialize(response);
                    });
                };
                AbstractRegistrationService.prototype.activate = function (request) {
                    return this.backendService.postJson('/registration/activate.json', request.serialize(), function (response) {
                        return json_response_1.JsonResponse.deserialize(response);
                    });
                };
                return AbstractRegistrationService;
            }();
            exports_1("AbstractRegistrationService", AbstractRegistrationService);
        }
    };
});

System.register("ags-client/app/services/registration_service.js", ["angular2/core.js", "ags-client/gen/services/abstract_registration_service.js", "ags-client/app/services/backend_service.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, abstract_registration_service_1, backend_service_1, RegistrationService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (abstract_registration_service_1_1) {
            abstract_registration_service_1 = abstract_registration_service_1_1;
        }, function (backend_service_1_1) {
            backend_service_1 = backend_service_1_1;
        }],
        execute: function () {
            RegistrationService = /** @class */function (_super) {
                __extends(RegistrationService, _super);
                function RegistrationService(backendService) {
                    return _super.call(this, backendService) || this;
                }
                RegistrationService = __decorate([core_1.Injectable(), core_1.Inject(backend_service_1.BackendService), __metadata("design:paramtypes", [backend_service_1.BackendService])], RegistrationService);
                return RegistrationService;
            }(abstract_registration_service_1.AbstractRegistrationService);
            exports_1("RegistrationService", RegistrationService);
        }
    };
});

System.register("ags-client/app/components/registration_form_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/constants.js", "ags-client/app/services/alert_service.js", "ags-client/gen/viewmodels/registration_view_model.js", "ags-client/app/services/translation_service.js", "ags-client/app/components/abstract_form_component.js", "ags-client/app/components/captcha_component.js", "ags-client/app/services/registration_service.js", "ags-client/app/commons/timer.js", "ags-client/app/commons/lang.js", "ags-client/app/validators.js", "ags-client/gen/codes.js", "ags-client/gen/i18n/translation_constants.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, constants_1, alert_service_1, registration_view_model_1, translation_service_1, abstract_form_component_1, captcha_component_1, registration_service_1, timer_1, lang_1, validators_1, codes_1, translation_constants_1, RegistrationFormComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (constants_1_1) {
            constants_1 = constants_1_1;
        }, function (alert_service_1_1) {
            alert_service_1 = alert_service_1_1;
        }, function (registration_view_model_1_1) {
            registration_view_model_1 = registration_view_model_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }, function (abstract_form_component_1_1) {
            abstract_form_component_1 = abstract_form_component_1_1;
        }, function (captcha_component_1_1) {
            captcha_component_1 = captcha_component_1_1;
        }, function (registration_service_1_1) {
            registration_service_1 = registration_service_1_1;
        }, function (timer_1_1) {
            timer_1 = timer_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }, function (validators_1_1) {
            validators_1 = validators_1_1;
        }, function (codes_1_1) {
            codes_1 = codes_1_1;
        }, function (translation_constants_1_1) {
            translation_constants_1 = translation_constants_1_1;
        }],
        execute: function () {
            RegistrationFormComponent = /** @class */function (_super) {
                __extends(RegistrationFormComponent, _super);
                function RegistrationFormComponent(alertService, translationService, _registrationService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._registrationService = _registrationService;
                    _this.canceled = new core_1.EventEmitter();
                    _this.submitted = new core_1.EventEmitter();
                    _this.registration = new registration_view_model_1.RegistrationViewModel();
                    _this.verified = false;
                    _this.success = false;
                    return _this;
                }
                RegistrationFormComponent.prototype.initData = function () {
                    this.registration = new registration_view_model_1.RegistrationViewModel();
                    this.registration.language = new codes_1.Language(this.translationService.language);
                    this.registration.country = new codes_1.Country('CH');
                    this.success = false;
                    this.verified = false;
                };
                RegistrationFormComponent.prototype.buildForm = function () {
                    this.form = new common_1.ControlGroup({
                        'email': new common_1.Control('', validators_1.validators(registration_view_model_1.RegistrationViewModel.EMAIL_VALIDATORS)),
                        'password': new common_1.Control('', validators_1.validators(registration_view_model_1.RegistrationViewModel.PASSWORD_VALIDATORS.concat([validators_1.password()]))),
                        'passwordRepeat': new common_1.Control('', validators_1.validators(registration_view_model_1.RegistrationViewModel.PASSWORD_REPEAT_VALIDATORS.concat([this.validatePasswordRepeat()]))),
                        'captcha': new common_1.Control('', validators_1.validators(registration_view_model_1.RegistrationViewModel.CAPTCHA_VALIDATORS)),
                        'institution': new common_1.Control('', validators_1.validators(registration_view_model_1.RegistrationViewModel.INSTITUTION_VALIDATORS)),
                        'salutation': new common_1.Control('', validators_1.validators(registration_view_model_1.RegistrationViewModel.SALUTATION_VALIDATORS)),
                        'firstname': new common_1.Control('', validators_1.validators(registration_view_model_1.RegistrationViewModel.FIRSTNAME_VALIDATORS)),
                        'lastname': new common_1.Control('', validators_1.validators(registration_view_model_1.RegistrationViewModel.LASTNAME_VALIDATORS)),
                        'phone': new common_1.Control('', validators_1.validators(registration_view_model_1.RegistrationViewModel.PHONE_VALIDATORS)),
                        'mobile': new common_1.Control('', validators_1.validators(registration_view_model_1.RegistrationViewModel.MOBILE_VALIDATORS)),
                        'city': new common_1.Control('', validators_1.validators(registration_view_model_1.RegistrationViewModel.CITY_VALIDATORS)),
                        'language': new common_1.Control('', validators_1.validators(registration_view_model_1.RegistrationViewModel.LANGUAGE_VALIDATORS)),
                        'country': new common_1.Control('', validators_1.validators(registration_view_model_1.RegistrationViewModel.COUNTRY_VALIDATORS))
                    });
                };
                RegistrationFormComponent.prototype.verifyMail = function () {
                    var _this = this;
                    if (lang_1.isPresent(this.emailCheckTimer)) {
                        this.emailCheckTimer.cancel();
                    }
                    this.emailCheckTimer = timer_1.Timer.later(500, function () {
                        if (_this.form.controls['email'].valid) {
                            _this._registrationService.checkMail(_this.registration.email).subscribe(function (response) {
                                if (!_this.handleError(response)) {
                                    _this.verified = true;
                                    _this.focus('#registrationForm_registration_password');
                                } else {
                                    _this.verified = false;
                                }
                            });
                        }
                    });
                };
                RegistrationFormComponent.prototype.validatePasswordRepeat = function () {
                    var self = this;
                    return function (control) {
                        if (lang_1.isPresent(control.value)) {
                            if (control.value !== self.registration.password) {
                                return { 'password_repeat': true };
                            }
                        }
                        return null;
                    };
                };
                RegistrationFormComponent.prototype.passwordChanged = function () {
                    this.form.controls['passwordRepeat'].updateValueAndValidity();
                };
                RegistrationFormComponent.prototype.submit = function () {
                    var _this = this;
                    if (this.validate()) {
                        this.loading = true;
                        this._registrationService.register(this.registration).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.alertService.info(_this.translationService.translate(translation_constants_1.TranslationConstants.REGISTRATION_ACCOUNT_CREATED));
                                _this.success = true;
                            } else {
                                _this.registration.captcha = null;
                                _this.captcha.first.reload();
                                _this._reset(_this.form);
                                _this.focus('#registrationForm_registration_captcha');
                            }
                            _this.loading = false;
                        });
                    }
                };
                __decorate([core_1.ViewChildren(captcha_component_1.CaptchaComponent), __metadata("design:type", core_1.QueryList)], RegistrationFormComponent.prototype, "captcha", void 0);
                __decorate([core_1.Input(), __metadata("design:type", String)], RegistrationFormComponent.prototype, "id", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Number)], RegistrationFormComponent.prototype, "userId", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], RegistrationFormComponent.prototype, "canceled", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], RegistrationFormComponent.prototype, "submitted", void 0);
                RegistrationFormComponent = __decorate([core_1.Component({
                    directives: [constants_1.AGS_FORM_DIRECTIVES, captcha_component_1.CaptchaComponent],
                    pipes: [constants_1.AGS_PIPES],
                    selector: 'registration-form',
                    templateUrl: 'ags-client/app/components/registration_form_component.html'
                }), __metadata("design:paramtypes", [alert_service_1.AlertService, translation_service_1.TranslationService, registration_service_1.RegistrationService, core_1.ElementRef])], RegistrationFormComponent);
                return RegistrationFormComponent;
            }(abstract_form_component_1.AbstractFormComponent);
            exports_1("RegistrationFormComponent", RegistrationFormComponent);
        }
    };
});

System.register("ags-client/app/components/category_form_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/constants.js", "ags-client/app/services/alert_service.js", "ags-client/app/services/translation_service.js", "ags-client/app/components/abstract_form_component.js", "ags-client/app/commons/lang.js", "ags-client/gen/viewmodels/category_view_model.js", "ags-client/app/validators.js", "ags-client/app/commons/key_stroke_manager.js", "ags-client/app/services/category_service.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, constants_1, alert_service_1, translation_service_1, abstract_form_component_1, lang_1, category_view_model_1, validators_1, key_stroke_manager_1, category_service_1, CategoryFormComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (constants_1_1) {
            constants_1 = constants_1_1;
        }, function (alert_service_1_1) {
            alert_service_1 = alert_service_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }, function (abstract_form_component_1_1) {
            abstract_form_component_1 = abstract_form_component_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }, function (category_view_model_1_1) {
            category_view_model_1 = category_view_model_1_1;
        }, function (validators_1_1) {
            validators_1 = validators_1_1;
        }, function (key_stroke_manager_1_1) {
            key_stroke_manager_1 = key_stroke_manager_1_1;
        }, function (category_service_1_1) {
            category_service_1 = category_service_1_1;
        }],
        execute: function () {
            CategoryFormComponent = /** @class */function (_super) {
                __extends(CategoryFormComponent, _super);
                function CategoryFormComponent(alertService, translationService, _categoryService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._categoryService = _categoryService;
                    _this.canceled = new core_1.EventEmitter();
                    _this.submitted = new core_1.EventEmitter();
                    _this.category = new category_view_model_1.CategoryViewModel();
                    return _this;
                }
                CategoryFormComponent.prototype.initData = function () {
                    var _this = this;
                    if (lang_1.isPresent(this.categoryId)) {
                        this.loading = true;
                        this._categoryService.get(this.categoryId).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.category = response.data;
                            }
                            _this.loading = false;
                        });
                    } else {
                        this.category.statical = false;
                        this.category.deleted = false;
                    }
                };
                CategoryFormComponent.prototype.initKeyStrokes = function () {
                    var _this = this;
                    key_stroke_manager_1.KeyStrokeManager.register(key_stroke_manager_1.KeyStroke.CANCEL, function () {
                        return _this.cancel();
                    });
                    key_stroke_manager_1.KeyStrokeManager.register(key_stroke_manager_1.KeyStroke.SAVE, function () {
                        return _this.submit();
                    });
                };
                CategoryFormComponent.prototype.buildForm = function () {
                    this.form = new common_1.ControlGroup({
                        'shortName': new common_1.Control('', validators_1.validators(category_view_model_1.CategoryViewModel.SHORT_NAME_VALIDATORS)),
                        'name': new common_1.Control('', validators_1.validators(category_view_model_1.CategoryViewModel.NAME_VALIDATORS)),
                        'description': new common_1.Control('', validators_1.validators(category_view_model_1.CategoryViewModel.DESCRIPTION_VALIDATORS)),
                        'statical': new common_1.Control(''),
                        'deleted': new common_1.Control('')
                    });
                };
                CategoryFormComponent.prototype.cancel = function () {
                    this.canceled.emit(this.category);
                };
                CategoryFormComponent.prototype.submit = function () {
                    var _this = this;
                    this.alertService.reset();
                    if (this.validate()) {
                        this.loading = true;
                        this._categoryService.store(this.category).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.submitted.emit(_this.category);
                            }
                            _this.loading = false;
                        });
                    }
                };
                __decorate([core_1.Input(), __metadata("design:type", String)], CategoryFormComponent.prototype, "id", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Number)], CategoryFormComponent.prototype, "categoryId", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], CategoryFormComponent.prototype, "canceled", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], CategoryFormComponent.prototype, "submitted", void 0);
                CategoryFormComponent = __decorate([core_1.Component({
                    directives: [constants_1.AGS_FORM_DIRECTIVES],
                    pipes: [constants_1.AGS_PIPES],
                    selector: 'category-form',
                    templateUrl: 'ags-client/app/components/category_form_component.html'
                }), __metadata("design:paramtypes", [alert_service_1.AlertService, translation_service_1.TranslationService, category_service_1.CategoryService, core_1.ElementRef])], CategoryFormComponent);
                return CategoryFormComponent;
            }(abstract_form_component_1.AbstractFormComponent);
            exports_1("CategoryFormComponent", CategoryFormComponent);
        }
    };
});

System.register("ags-client/app/components/category_table_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/services/alert_service.js", "ags-client/app/constants.js", "ags-client/app/services/translation_service.js", "ags-client/app/components/abstract_table_component.js", "ags-client/gen/viewsearch/category_search_criteria.js", "ags-client/app/services/category_service.js", "ags-client/app/services/confirmation_service.js", "ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, alert_service_1, constants_1, translation_service_1, abstract_table_component_1, category_search_criteria_1, category_service_1, confirmation_service_1, ags_client_1, CategoryTableComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (alert_service_1_1) {
            alert_service_1 = alert_service_1_1;
        }, function (constants_1_1) {
            constants_1 = constants_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }, function (abstract_table_component_1_1) {
            abstract_table_component_1 = abstract_table_component_1_1;
        }, function (category_search_criteria_1_1) {
            category_search_criteria_1 = category_search_criteria_1_1;
        }, function (category_service_1_1) {
            category_service_1 = category_service_1_1;
        }, function (confirmation_service_1_1) {
            confirmation_service_1 = confirmation_service_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }],
        execute: function () {
            CategoryTableComponent = /** @class */function (_super) {
                __extends(CategoryTableComponent, _super);
                function CategoryTableComponent(alertService, translationService, _categoryService, _confirmationService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._categoryService = _categoryService;
                    _this._confirmationService = _confirmationService;
                    _this.checked = false;
                    _this.selected = new core_1.EventEmitter();
                    return _this;
                }
                CategoryTableComponent.prototype.initSearchCriteria = function () {
                    var _this = this;
                    if (!this.categorySearchCriteria) {
                        this.categorySearchCriteria = new category_search_criteria_1.CategorySearchCriteria(0, 10);
                    }
                    this.categorySearchCriteria.subscribeSearch(function () {
                        _this.search();
                    });
                    this.search();
                };
                CategoryTableComponent.prototype.buildFilterForm = function () {
                    this.filterForm = new common_1.ControlGroup({
                        'shortName': new common_1.Control(''),
                        'name': new common_1.Control(''),
                        'description': new common_1.Control(''),
                        'statical': new common_1.Control(''),
                        'deleted': new common_1.Control('')
                    });
                };
                CategoryTableComponent.prototype.search = function () {
                    var _this = this;
                    if (this.filterForm.valid) {
                        this.loading = true;
                        this._categoryService.search(this.categorySearchCriteria).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.categorySearchCriteria.total = response.totalItems;
                                _this.categories = response.data;
                            }
                            _this.loading = false;
                        });
                    }
                };
                CategoryTableComponent.prototype.check = function (category) {
                    category.checked = !category.checked;
                };
                CategoryTableComponent.prototype.checkAll = function () {
                    this.checked = !this.checked;
                    if (this.categories != null) {
                        for (var _i = 0, _a = this.categories; _i < _a.length; _i++) {
                            var category = _a[_i];
                            category.checked = this.checked;
                        }
                    }
                };
                CategoryTableComponent.prototype.delete = function (category) {
                    var _this = this;
                    if (category.deleted) {
                        this.loading = true;
                        this._categoryService.undelete(category.id).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                category.deleted = false;
                            }
                            _this.loading = false;
                        });
                    } else {
                        this._confirmationService.confirmDelete(function () {
                            _this.loading = true;
                            _this._categoryService.delete(category.id).subscribe(function (response) {
                                if (!_this.handleError(response)) {
                                    category.deleted = true;
                                }
                                _this.loading = false;
                            });
                        });
                    }
                };
                CategoryTableComponent.prototype.edit = function (category) {
                    this.selected.emit(category);
                };
                CategoryTableComponent.prototype.select = function (category) {
                    this.selected.emit(category);
                };
                __decorate([core_1.Input(), __metadata("design:type", String)], CategoryTableComponent.prototype, "id", void 0);
                __decorate([ags_client_1.PageFlow('CategoryTable'), __metadata("design:type", category_search_criteria_1.CategorySearchCriteria)], CategoryTableComponent.prototype, "categorySearchCriteria", void 0);
                __decorate([ags_client_1.PageFlow('CategoryTable'), __metadata("design:type", Array)], CategoryTableComponent.prototype, "categories", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], CategoryTableComponent.prototype, "selected", void 0);
                CategoryTableComponent = __decorate([core_1.Component({
                    directives: [constants_1.AGS_FORM_DIRECTIVES],
                    pipes: [constants_1.AGS_PIPES],
                    selector: 'category-table',
                    templateUrl: 'ags-client/app/components/category_table_component.html'
                }), __metadata("design:paramtypes", [alert_service_1.AlertService, translation_service_1.TranslationService, category_service_1.CategoryService, confirmation_service_1.ConfirmationService, core_1.ElementRef])], CategoryTableComponent);
                return CategoryTableComponent;
            }(abstract_table_component_1.AbstractTableComponent);
            exports_1("CategoryTableComponent", CategoryTableComponent);
        }
    };
});

System.register("ags-client/app/components/code_table_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/constants.js", "ags-client/app/services/alert_service.js", "ags-client/app/services/code_service.js", "ags-client/app/services/translation_service.js", "ags-client/app/components/abstract_table_component.js", "ags-client/gen/viewsearch/code_search_criteria.js", "ags-client/app/validators.js", "ags-client/app/services/confirmation_service.js", "ags-client/app/viewsearch/search_criteria.js", "ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, constants_1, alert_service_1, code_service_1, translation_service_1, abstract_table_component_1, code_search_criteria_1, Validators, confirmation_service_1, search_criteria_1, ags_client_1, CodeTableComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (constants_1_1) {
            constants_1 = constants_1_1;
        }, function (alert_service_1_1) {
            alert_service_1 = alert_service_1_1;
        }, function (code_service_1_1) {
            code_service_1 = code_service_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }, function (abstract_table_component_1_1) {
            abstract_table_component_1 = abstract_table_component_1_1;
        }, function (code_search_criteria_1_1) {
            code_search_criteria_1 = code_search_criteria_1_1;
        }, function (Validators_1) {
            Validators = Validators_1;
        }, function (confirmation_service_1_1) {
            confirmation_service_1 = confirmation_service_1_1;
        }, function (search_criteria_1_1) {
            search_criteria_1 = search_criteria_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }],
        execute: function () {
            CodeTableComponent = /** @class */function (_super) {
                __extends(CodeTableComponent, _super);
                function CodeTableComponent(alertService, translationService, element, _codeService, _confirmationService) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._codeService = _codeService;
                    _this._confirmationService = _confirmationService;
                    _this.selected = new core_1.EventEmitter();
                    return _this;
                }
                CodeTableComponent.prototype.initSearchCriteria = function () {
                    var _this = this;
                    if (!this.codeSearchCriteria) {
                        this.codeSearchCriteria = new code_search_criteria_1.CodeSearchCriteria(0, 10);
                        this.codeSearchCriteria.sortLanguage = this.translationService.language;
                        this.codeSearchCriteria.deleted = false;
                        this.codeSearchCriteria.sort = new search_criteria_1.SearchSort('category', search_criteria_1.SortDirection.ASCENDING);
                    }
                    this.codeSearchCriteria.subscribeSearch(function () {
                        _this.search();
                    });
                    this.search();
                };
                CodeTableComponent.prototype.buildFilterForm = function () {
                    this.filterForm = new common_1.ControlGroup({
                        'category': new common_1.Control(''),
                        'name': new common_1.Control(''),
                        'description': new common_1.Control(''),
                        'validFrom': new common_1.Control('', Validators.date),
                        'validTo': new common_1.Control(''),
                        'deleted': new common_1.Control('')
                    });
                };
                CodeTableComponent.prototype.search = function () {
                    var _this = this;
                    if (this.filterForm.valid) {
                        this.loading = true;
                        this._codeService.search(this.codeSearchCriteria).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.codeSearchCriteria.total = response.totalItems;
                                _this.codeSearchResults = response.data;
                            }
                            _this.loading = false;
                        });
                    }
                };
                CodeTableComponent.prototype.delete = function (code) {
                    var _this = this;
                    if (code.deleted) {
                        this.loading = true;
                        this._codeService.undelete(code.id).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                code.deleted = false;
                            }
                            _this.loading = false;
                        });
                    } else {
                        this._confirmationService.confirmDelete(function () {
                            _this.loading = true;
                            _this._codeService.delete(code.id).subscribe(function (response) {
                                if (!_this.handleError(response)) {
                                    code.deleted = true;
                                }
                                _this.loading = false;
                            });
                        });
                    }
                };
                CodeTableComponent.prototype.select = function (code) {
                    this.selected.emit(code);
                };
                __decorate([core_1.Input(), __metadata("design:type", String)], CodeTableComponent.prototype, "id", void 0);
                __decorate([ags_client_1.PageFlow('CodeTableComponent'), __metadata("design:type", code_search_criteria_1.CodeSearchCriteria)], CodeTableComponent.prototype, "codeSearchCriteria", void 0);
                __decorate([ags_client_1.PageFlow('CodeTableComponent'), __metadata("design:type", Array)], CodeTableComponent.prototype, "codeSearchResults", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], CodeTableComponent.prototype, "selected", void 0);
                CodeTableComponent = __decorate([core_1.Component({
                    directives: [constants_1.AGS_FORM_DIRECTIVES],
                    pipes: [constants_1.AGS_PIPES],
                    selector: 'code-table',
                    templateUrl: 'ags-client/app/components/code_table_component.html'
                }), __metadata("design:paramtypes", [alert_service_1.AlertService, translation_service_1.TranslationService, core_1.ElementRef, code_service_1.CodeService, confirmation_service_1.ConfirmationService])], CodeTableComponent);
                return CodeTableComponent;
            }(abstract_table_component_1.AbstractTableComponent);
            exports_1("CodeTableComponent", CodeTableComponent);
        }
    };
});

System.register("ags-client/app/components/code_description_form_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/constants.js", "ags-client/app/validators.js", "ags-client/app/models/code_language.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, constants_1, validators_1, code_language_1, CodeDescriptionFormComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (constants_1_1) {
            constants_1 = constants_1_1;
        }, function (validators_1_1) {
            validators_1 = validators_1_1;
        }, function (code_language_1_1) {
            code_language_1 = code_language_1_1;
        }],
        execute: function () {
            CodeDescriptionFormComponent = /** @class */function () {
                function CodeDescriptionFormComponent() {
                    this.form = new common_1.ControlGroup({
                        "description": new common_1.Control(),
                        "remark": new common_1.Control()
                    });
                }
                CodeDescriptionFormComponent.prototype.ngAfterViewInit = function () {
                    this.form.find("description").validator = validators_1.validators(this.codeLanguage.getDescriptionValidators());
                    this.form.find("remark").validator = validators_1.validators(this.codeLanguage.getRemarkValidators());
                };
                __decorate([core_1.Input(), __metadata("design:type", code_language_1.CodeLanguage)], CodeDescriptionFormComponent.prototype, "codeLanguage", void 0);
                CodeDescriptionFormComponent = __decorate([core_1.Component({
                    directives: [constants_1.AGS_FORM_DIRECTIVES],
                    pipes: [constants_1.AGS_PIPES],
                    selector: 'code-description-form',
                    templateUrl: 'ags-client/app/components/code_description_form_component.html'
                }), __metadata("design:paramtypes", [])], CodeDescriptionFormComponent);
                return CodeDescriptionFormComponent;
            }();
            exports_1("CodeDescriptionFormComponent", CodeDescriptionFormComponent);
        }
    };
});

System.register("ags-client/app/models/code_language.js", ["ags-client/app/constants.js", "ags-client/gen/viewmodels/code_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var constants_1, code_view_model_1, CodeLanguage;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (constants_1_1) {
            constants_1 = constants_1_1;
        }, function (code_view_model_1_1) {
            code_view_model_1 = code_view_model_1_1;
        }],
        execute: function () {
            CodeLanguage = /** @class */function () {
                function CodeLanguage(code, language) {
                    this.code = code;
                    this.language = language;
                }
                Object.defineProperty(CodeLanguage.prototype, "description", {
                    get: function () {
                        switch (this.language) {
                            case constants_1.Constants.Language.de:
                                return this.code.descriptionDe;
                            case constants_1.Constants.Language.en:
                                return this.code.descriptionEn;
                            case constants_1.Constants.Language.fr:
                                return this.code.descriptionFr;
                            case constants_1.Constants.Language.it:
                                return this.code.descriptionIt;
                            default:
                                return null;
                        }
                    },
                    set: function (description) {
                        switch (this.language) {
                            case constants_1.Constants.Language.de:
                                this.code.descriptionDe = description;
                                break;
                            case constants_1.Constants.Language.en:
                                this.code.descriptionEn = description;
                                break;
                            case constants_1.Constants.Language.fr:
                                this.code.descriptionFr = description;
                                break;
                            case constants_1.Constants.Language.it:
                                this.code.descriptionIt = description;
                                break;
                            default:
                                break;
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(CodeLanguage.prototype, "remark", {
                    get: function () {
                        switch (this.language) {
                            case constants_1.Constants.Language.de:
                                return this.code.remarkDe;
                            case constants_1.Constants.Language.en:
                                return this.code.remarkEn;
                            case constants_1.Constants.Language.fr:
                                return this.code.remarkFr;
                            case constants_1.Constants.Language.it:
                                return this.code.remarkIt;
                            default:
                                return null;
                        }
                    },
                    set: function (remark) {
                        switch (this.language) {
                            case constants_1.Constants.Language.de:
                                this.code.remarkDe = remark;
                                break;
                            case constants_1.Constants.Language.en:
                                this.code.remarkEn = remark;
                                break;
                            case constants_1.Constants.Language.fr:
                                this.code.remarkFr = remark;
                                break;
                            case constants_1.Constants.Language.it:
                                this.code.remarkIt = remark;
                                break;
                            default:
                                break;
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                CodeLanguage.prototype.getDescriptionValidators = function () {
                    switch (this.language) {
                        case constants_1.Constants.Language.de:
                            return code_view_model_1.CodeViewModel.DESCRIPTION_DE_VALIDATORS;
                        case constants_1.Constants.Language.en:
                            return code_view_model_1.CodeViewModel.DESCRIPTION_EN_VALIDATORS;
                        case constants_1.Constants.Language.fr:
                            return code_view_model_1.CodeViewModel.DESCRIPTION_FR_VALIDATORS;
                        case constants_1.Constants.Language.it:
                            return code_view_model_1.CodeViewModel.DESCRIPTION_IT_VALIDATORS;
                        default:
                            return null;
                    }
                };
                CodeLanguage.prototype.getRemarkValidators = function () {
                    switch (this.language) {
                        case constants_1.Constants.Language.de:
                            return code_view_model_1.CodeViewModel.REMARK_DE_VALIDATORS;
                        case constants_1.Constants.Language.en:
                            return code_view_model_1.CodeViewModel.REMARK_EN_VALIDATORS;
                        case constants_1.Constants.Language.fr:
                            return code_view_model_1.CodeViewModel.REMARK_FR_VALIDATORS;
                        case constants_1.Constants.Language.it:
                            return code_view_model_1.CodeViewModel.REMARK_IT_VALIDATORS;
                        default:
                            return null;
                    }
                };
                return CodeLanguage;
            }();
            exports_1("CodeLanguage", CodeLanguage);
        }
    };
});

System.register("ags-client/app/components/code_form_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/constants.js", "ags-client/app/services/code_service.js", "ags-client/app/services/alert_service.js", "ags-client/app/services/translation_service.js", "ags-client/gen/viewmodels/code_view_model.js", "ags-client/app/components/abstract_form_component.js", "ags-client/app/commons/key_stroke_manager.js", "ags-client/app/components/code_description_form_component.js", "ags-client/app/models/code_language.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, constants_1, code_service_1, alert_service_1, translation_service_1, code_view_model_1, abstract_form_component_1, key_stroke_manager_1, code_description_form_component_1, code_language_1, CodeFormComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (constants_1_1) {
            constants_1 = constants_1_1;
        }, function (code_service_1_1) {
            code_service_1 = code_service_1_1;
        }, function (alert_service_1_1) {
            alert_service_1 = alert_service_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }, function (code_view_model_1_1) {
            code_view_model_1 = code_view_model_1_1;
        }, function (abstract_form_component_1_1) {
            abstract_form_component_1 = abstract_form_component_1_1;
        }, function (key_stroke_manager_1_1) {
            key_stroke_manager_1 = key_stroke_manager_1_1;
        }, function (code_description_form_component_1_1) {
            code_description_form_component_1 = code_description_form_component_1_1;
        }, function (code_language_1_1) {
            code_language_1 = code_language_1_1;
        }],
        execute: function () {
            CodeFormComponent = /** @class */function (_super) {
                __extends(CodeFormComponent, _super);
                function CodeFormComponent(alertService, translationService, _codeService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._codeService = _codeService;
                    _this.canceled = new core_1.EventEmitter();
                    _this.submitted = new core_1.EventEmitter();
                    _this.code = new code_view_model_1.CodeViewModel();
                    return _this;
                }
                CodeFormComponent.prototype.initData = function () {
                    var _this = this;
                    this.loading = true;
                    this._codeService.get(this.codeId).subscribe(function (response) {
                        if (!_this.handleError(response)) {
                            _this.code = response.data;
                            _this.codeLanguages = [];
                            for (var _i = 0, _a = constants_1.Constants.Language.codeLanguages; _i < _a.length; _i++) {
                                var l = _a[_i];
                                _this.codeLanguages.add(new code_language_1.CodeLanguage(_this.code, l));
                            }
                        }
                        _this.loading = false;
                    });
                };
                CodeFormComponent.prototype.completeForm = function () {
                    var _this = this;
                    this.codeDescriptions.changes.subscribe(function (event) {
                        _this.codeDescriptions.toArray().forEach(function (descriptionComponent) {
                            _this.form.addControl(descriptionComponent.codeLanguage.language, descriptionComponent.form);
                        });
                    });
                };
                CodeFormComponent.prototype.initKeyStrokes = function () {
                    var _this = this;
                    key_stroke_manager_1.KeyStrokeManager.register(key_stroke_manager_1.KeyStroke.CANCEL, function () {
                        return _this.cancel();
                    });
                    key_stroke_manager_1.KeyStrokeManager.register(key_stroke_manager_1.KeyStroke.SAVE, function () {
                        return _this.submit();
                    });
                };
                CodeFormComponent.prototype.buildForm = function () {
                    this.form = new common_1.ControlGroup({});
                };
                CodeFormComponent.prototype.cancel = function () {
                    this.canceled.emit(this.code);
                };
                CodeFormComponent.prototype.submit = function () {
                    var _this = this;
                    this.alertService.reset();
                    if (this.validate()) {
                        this.loading = true;
                        this._codeService.store(this.code).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.submitted.emit(_this.code);
                            }
                            _this.loading = false;
                        });
                    }
                };
                __decorate([core_1.ViewChildren(code_description_form_component_1.CodeDescriptionFormComponent), __metadata("design:type", core_1.QueryList)], CodeFormComponent.prototype, "codeDescriptions", void 0);
                __decorate([core_1.Input(), __metadata("design:type", String)], CodeFormComponent.prototype, "id", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Number)], CodeFormComponent.prototype, "codeId", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], CodeFormComponent.prototype, "canceled", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], CodeFormComponent.prototype, "submitted", void 0);
                CodeFormComponent = __decorate([core_1.Component({
                    directives: [constants_1.AGS_FORM_DIRECTIVES, code_description_form_component_1.CodeDescriptionFormComponent],
                    pipes: [constants_1.AGS_PIPES],
                    selector: 'code-form',
                    templateUrl: 'ags-client/app/components/code_form_component.html'
                }), __metadata("design:paramtypes", [alert_service_1.AlertService, translation_service_1.TranslationService, code_service_1.CodeService, core_1.ElementRef])], CodeFormComponent);
                return CodeFormComponent;
            }(abstract_form_component_1.AbstractFormComponent);
            exports_1("CodeFormComponent", CodeFormComponent);
        }
    };
});

System.register("ags-client/app/components/darate_table_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/constants.js", "ags-client/app/services/alert_service.js", "ags-client/app/services/translation_service.js", "ags-client/app/components/abstract_table_component.js", "ags-client/gen/viewsearch/darate_search_criteria.js", "ags-client/app/services/darate_service.js", "ags-client/app/services/confirmation_service.js", "ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, constants_1, alert_service_1, translation_service_1, abstract_table_component_1, darate_search_criteria_1, darate_service_1, confirmation_service_1, ags_client_1, DarateTableComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (constants_1_1) {
            constants_1 = constants_1_1;
        }, function (alert_service_1_1) {
            alert_service_1 = alert_service_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }, function (abstract_table_component_1_1) {
            abstract_table_component_1 = abstract_table_component_1_1;
        }, function (darate_search_criteria_1_1) {
            darate_search_criteria_1 = darate_search_criteria_1_1;
        }, function (darate_service_1_1) {
            darate_service_1 = darate_service_1_1;
        }, function (confirmation_service_1_1) {
            confirmation_service_1 = confirmation_service_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }],
        execute: function () {
            DarateTableComponent = /** @class */function (_super) {
                __extends(DarateTableComponent, _super);
                function DarateTableComponent(alertService, translationService, _darateService, _confirmationService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._darateService = _darateService;
                    _this._confirmationService = _confirmationService;
                    _this.checked = false;
                    _this.selected = new core_1.EventEmitter();
                    return _this;
                }
                DarateTableComponent.prototype.initSearchCriteria = function () {
                    var _this = this;
                    if (!this.darateSearchCriteria) {
                        this.darateSearchCriteria = new darate_search_criteria_1.DarateSearchCriteria(0, 10);
                    }
                    this.darateSearchCriteria.subscribeSearch(function () {
                        _this.search();
                    });
                    this.search();
                };
                DarateTableComponent.prototype.buildFilterForm = function () {
                    this.filterForm = new common_1.ControlGroup({
                        'country': new common_1.Control(''),
                        'instrumentGroup': new common_1.Control(''),
                        'instrumentType': new common_1.Control(''),
                        'darateType': new common_1.Control(''),
                        'active': new common_1.Control(''),
                        'deleted': new common_1.Control('')
                    });
                };
                DarateTableComponent.prototype.search = function () {
                    var _this = this;
                    if (this.filterForm.valid) {
                        this.loading = true;
                        this._darateService.search(this.darateSearchCriteria).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.darateSearchCriteria.total = response.totalItems;
                                _this.darates = response.data;
                            }
                            _this.loading = false;
                        });
                    }
                };
                DarateTableComponent.prototype.check = function (darate) {
                    darate.checked = !darate.checked;
                };
                DarateTableComponent.prototype.checkAll = function () {
                    this.checked = !this.checked;
                    if (this.darates != null) {
                        for (var _i = 0, _a = this.darates; _i < _a.length; _i++) {
                            var darate = _a[_i];
                            darate.checked = this.checked;
                        }
                    }
                };
                DarateTableComponent.prototype.delete = function (darate) {
                    var _this = this;
                    if (darate.deleted) {
                        this.loading = true;
                        this._darateService.undelete(darate.id).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                darate.deleted = false;
                            }
                            _this.loading = false;
                        });
                    } else {
                        this._confirmationService.confirmDelete(function () {
                            _this.loading = true;
                            _this._darateService.delete(darate.id).subscribe(function (response) {
                                if (!_this.handleError(response)) {
                                    darate.deleted = true;
                                }
                                _this.loading = false;
                            });
                        });
                    }
                };
                DarateTableComponent.prototype.edit = function (darate) {
                    this.selected.emit(darate);
                };
                DarateTableComponent.prototype.select = function (darate) {
                    this.selected.emit(darate);
                };
                __decorate([core_1.Input(), __metadata("design:type", String)], DarateTableComponent.prototype, "id", void 0);
                __decorate([ags_client_1.PageFlow('DarateTable'), __metadata("design:type", darate_search_criteria_1.DarateSearchCriteria)], DarateTableComponent.prototype, "darateSearchCriteria", void 0);
                __decorate([ags_client_1.PageFlow('DarateTable'), __metadata("design:type", Array)], DarateTableComponent.prototype, "darates", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], DarateTableComponent.prototype, "selected", void 0);
                DarateTableComponent = __decorate([core_1.Component({
                    directives: [constants_1.AGS_FORM_DIRECTIVES],
                    pipes: [constants_1.AGS_PIPES],
                    selector: 'darate-table',
                    templateUrl: 'ags-client/app/components/darate_table_component.html'
                }), __metadata("design:paramtypes", [alert_service_1.AlertService, translation_service_1.TranslationService, darate_service_1.DarateService, confirmation_service_1.ConfirmationService, core_1.ElementRef])], DarateTableComponent);
                return DarateTableComponent;
            }(abstract_table_component_1.AbstractTableComponent);
            exports_1("DarateTableComponent", DarateTableComponent);
        }
    };
});

System.register("ags-client/gen/services/abstract_darate_service.js", ["ags-client/app/models/json_response.js", "ags-client/gen/viewmodels/darate_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var json_response_1, darate_view_model_1, AbstractDarateService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (json_response_1_1) {
            json_response_1 = json_response_1_1;
        }, function (darate_view_model_1_1) {
            darate_view_model_1 = darate_view_model_1_1;
        }],
        execute: function () {
            AbstractDarateService = /** @class */function () {
                function AbstractDarateService(backendService) {
                    this.backendService = backendService;
                }
                AbstractDarateService.prototype.search = function (request) {
                    return this.backendService.postJson('/darate/search.json', request.serialize(), function (response) {
                        var data = Array();
                        response.data.forEach(function (item) {
                            data.push(darate_view_model_1.DarateViewModel.deserialize(item));
                        });
                        return json_response_1.JsonResponse.deserialize(response, data);
                    });
                };
                AbstractDarateService.prototype.get = function (request) {
                    return this.backendService.getJson('/darate/get/' + request + '.json', function (response) {
                        return json_response_1.JsonResponse.deserialize(response, darate_view_model_1.DarateViewModel.deserialize(response.data));
                    });
                };
                AbstractDarateService.prototype.store = function (request) {
                    return this.backendService.postJson('/darate/store.json', request.serialize(), function (response) {
                        return json_response_1.JsonResponse.deserialize(response, darate_view_model_1.DarateViewModel.deserialize(response.data));
                    });
                };
                AbstractDarateService.prototype.delete = function (request) {
                    return this.backendService.getJson('/darate/delete/' + request + '.json', function (response) {
                        return json_response_1.JsonResponse.deserialize(response);
                    });
                };
                AbstractDarateService.prototype.undelete = function (request) {
                    return this.backendService.getJson('/darate/undelete/' + request + '.json', function (response) {
                        return json_response_1.JsonResponse.deserialize(response);
                    });
                };
                return AbstractDarateService;
            }();
            exports_1("AbstractDarateService", AbstractDarateService);
        }
    };
});

System.register("ags-client/app/services/darate_service.js", ["angular2/core.js", "ags-client/gen/services/abstract_darate_service.js", "ags-client/app/services/backend_service.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, abstract_darate_service_1, backend_service_1, DarateService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (abstract_darate_service_1_1) {
            abstract_darate_service_1 = abstract_darate_service_1_1;
        }, function (backend_service_1_1) {
            backend_service_1 = backend_service_1_1;
        }],
        execute: function () {
            DarateService = /** @class */function (_super) {
                __extends(DarateService, _super);
                function DarateService(backendService) {
                    return _super.call(this, backendService) || this;
                }
                DarateService = __decorate([core_1.Injectable(), core_1.Inject(backend_service_1.BackendService), __metadata("design:paramtypes", [backend_service_1.BackendService])], DarateService);
                return DarateService;
            }(abstract_darate_service_1.AbstractDarateService);
            exports_1("DarateService", DarateService);
        }
    };
});

System.register("ags-client/app/components/darate_form_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/constants.js", "ags-client/app/services/alert_service.js", "ags-client/app/services/translation_service.js", "ags-client/app/components/abstract_form_component.js", "ags-client/app/commons/lang.js", "ags-client/gen/viewmodels/darate_view_model.js", "ags-client/app/validators.js", "ags-client/app/commons/key_stroke_manager.js", "ags-client/app/services/darate_service.js", "ags-client/app/components/darate_scope_form_component.js", "ags-client/gen/viewmodels/scope_view_model.js", "ags-client/gen/viewmodels/darate_scope_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, constants_1, alert_service_1, translation_service_1, abstract_form_component_1, lang_1, darate_view_model_1, validators_1, key_stroke_manager_1, darate_service_1, darate_scope_form_component_1, scope_view_model_1, darate_scope_view_model_1, DarateFormComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (constants_1_1) {
            constants_1 = constants_1_1;
        }, function (alert_service_1_1) {
            alert_service_1 = alert_service_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }, function (abstract_form_component_1_1) {
            abstract_form_component_1 = abstract_form_component_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }, function (darate_view_model_1_1) {
            darate_view_model_1 = darate_view_model_1_1;
        }, function (validators_1_1) {
            validators_1 = validators_1_1;
        }, function (key_stroke_manager_1_1) {
            key_stroke_manager_1 = key_stroke_manager_1_1;
        }, function (darate_service_1_1) {
            darate_service_1 = darate_service_1_1;
        }, function (darate_scope_form_component_1_1) {
            darate_scope_form_component_1 = darate_scope_form_component_1_1;
        }, function (scope_view_model_1_1) {
            scope_view_model_1 = scope_view_model_1_1;
        }, function (darate_scope_view_model_1_1) {
            darate_scope_view_model_1 = darate_scope_view_model_1_1;
        }],
        execute: function () {
            DarateFormComponent = /** @class */function (_super) {
                __extends(DarateFormComponent, _super);
                function DarateFormComponent(alertService, translationService, _darateService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._darateService = _darateService;
                    _this.canceled = new core_1.EventEmitter();
                    _this.submitted = new core_1.EventEmitter();
                    _this.darate = new darate_view_model_1.DarateViewModel();
                    return _this;
                }
                DarateFormComponent.prototype.initData = function () {
                    var _this = this;
                    if (lang_1.isPresent(this.darateId)) {
                        this.loading = true;
                        this._darateService.get(this.darateId).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.darate = response.data;
                            }
                            _this.loading = false;
                        });
                    } else {
                        this.darate.deleted = false;
                    }
                };
                DarateFormComponent.prototype.initKeyStrokes = function () {
                    var _this = this;
                    key_stroke_manager_1.KeyStrokeManager.register(key_stroke_manager_1.KeyStroke.CANCEL, function () {
                        return _this.cancel();
                    });
                    key_stroke_manager_1.KeyStrokeManager.register(key_stroke_manager_1.KeyStroke.SAVE, function () {
                        return _this.submit();
                    });
                };
                DarateFormComponent.prototype.buildForm = function () {
                    this.form = new common_1.ControlGroup({
                        'country': new common_1.Control('', validators_1.validators(darate_view_model_1.DarateViewModel.COUNTRY_VALIDATORS)),
                        'instrumentGroup': new common_1.Control('', validators_1.validators(darate_view_model_1.DarateViewModel.INSTRUMENT_GROUP_VALIDATORS)),
                        'instrumentType': new common_1.Control(''),
                        'active': new common_1.Control(''),
                        'darateType': new common_1.Control('', validators_1.validators(darate_view_model_1.DarateViewModel.DARATE_TYPE_VALIDATORS)),
                        'deleted': new common_1.Control(''),
                        'validFrom': new common_1.Control('', validators_1.validators(scope_view_model_1.ScopeViewModel.VALID_FROM_VALIDATORS)),
                        'validTo': new common_1.Control(''),
                        'rate': new common_1.Control('', validators_1.validators(darate_scope_view_model_1.DarateScopeViewModel.RATE_VALIDATORS)),
                        'release': new common_1.Control(''),
                        'nonRecoverable': new common_1.Control('')
                    });
                };
                DarateFormComponent.prototype.cancel = function () {
                    this.canceled.emit(this.darate);
                };
                DarateFormComponent.prototype.submit = function () {
                    var _this = this;
                    this.alertService.reset();
                    if (this.validate()) {
                        this.loading = true;
                        this._darateService.store(this.darate).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.submitted.emit(_this.darate);
                            }
                            _this.loading = false;
                        });
                    }
                };
                __decorate([core_1.ViewChildren(darate_scope_form_component_1.DarateScopeFormComponent), __metadata("design:type", core_1.QueryList)], DarateFormComponent.prototype, "darateScopes", void 0);
                __decorate([core_1.Input(), __metadata("design:type", String)], DarateFormComponent.prototype, "id", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Number)], DarateFormComponent.prototype, "darateId", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], DarateFormComponent.prototype, "canceled", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], DarateFormComponent.prototype, "submitted", void 0);
                DarateFormComponent = __decorate([core_1.Component({
                    directives: [constants_1.AGS_FORM_DIRECTIVES],
                    pipes: [constants_1.AGS_PIPES],
                    selector: 'darate-form',
                    templateUrl: 'ags-client/app/components/darate_form_component.html'
                }), __metadata("design:paramtypes", [alert_service_1.AlertService, translation_service_1.TranslationService, darate_service_1.DarateService, core_1.ElementRef])], DarateFormComponent);
                return DarateFormComponent;
            }(abstract_form_component_1.AbstractFormComponent);
            exports_1("DarateFormComponent", DarateFormComponent);
        }
    };
});

System.register("ags-client/app/components/darate_scope_form_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/constants.js", "ags-client/app/validators.js", "ags-client/gen/viewmodels/scope_view_model.js", "ags-client/gen/viewmodels/darate_scope_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, constants_1, validators_1, scope_view_model_1, darate_scope_view_model_1, DarateScopeFormComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (constants_1_1) {
            constants_1 = constants_1_1;
        }, function (validators_1_1) {
            validators_1 = validators_1_1;
        }, function (scope_view_model_1_1) {
            scope_view_model_1 = scope_view_model_1_1;
        }, function (darate_scope_view_model_1_1) {
            darate_scope_view_model_1 = darate_scope_view_model_1_1;
        }],
        execute: function () {
            DarateScopeFormComponent = /** @class */function () {
                function DarateScopeFormComponent() {
                    this.form = new common_1.ControlGroup({
                        'validFrom': new common_1.Control('', validators_1.validators(scope_view_model_1.ScopeViewModel.VALID_FROM_VALIDATORS)),
                        'validTo': new common_1.Control(''),
                        'rate': new common_1.Control('', validators_1.validators(darate_scope_view_model_1.DarateScopeViewModel.RATE_VALIDATORS)),
                        'release': new common_1.Control(''),
                        'nonRecoverable': new common_1.Control('')
                    });
                }
                __decorate([core_1.Input(), __metadata("design:type", darate_scope_view_model_1.DarateScopeViewModel)], DarateScopeFormComponent.prototype, "darateScope", void 0);
                DarateScopeFormComponent = __decorate([core_1.Component({
                    directives: [constants_1.AGS_FORM_DIRECTIVES],
                    pipes: [constants_1.AGS_PIPES],
                    selector: 'darate-scope-form',
                    templateUrl: 'ags-client/app/components/darate_scope_form_component.html'
                }), __metadata("design:paramtypes", [])], DarateScopeFormComponent);
                return DarateScopeFormComponent;
            }();
            exports_1("DarateScopeFormComponent", DarateScopeFormComponent);
        }
    };
});

System.register("ags-client/app/components/domain_form_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/constants.js", "ags-client/app/services/alert_service.js", "ags-client/app/services/translation_service.js", "ags-client/app/components/abstract_form_component.js", "ags-client/app/commons/lang.js", "ags-client/gen/viewmodels/domain_view_model.js", "ags-client/app/validators.js", "ags-client/app/commons/key_stroke_manager.js", "ags-client/app/services/domain_service.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, constants_1, alert_service_1, translation_service_1, abstract_form_component_1, lang_1, domain_view_model_1, validators_1, key_stroke_manager_1, domain_service_1, DomainFormComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (constants_1_1) {
            constants_1 = constants_1_1;
        }, function (alert_service_1_1) {
            alert_service_1 = alert_service_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }, function (abstract_form_component_1_1) {
            abstract_form_component_1 = abstract_form_component_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }, function (domain_view_model_1_1) {
            domain_view_model_1 = domain_view_model_1_1;
        }, function (validators_1_1) {
            validators_1 = validators_1_1;
        }, function (key_stroke_manager_1_1) {
            key_stroke_manager_1 = key_stroke_manager_1_1;
        }, function (domain_service_1_1) {
            domain_service_1 = domain_service_1_1;
        }],
        execute: function () {
            DomainFormComponent = /** @class */function (_super) {
                __extends(DomainFormComponent, _super);
                function DomainFormComponent(alertService, translationService, _domainService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._domainService = _domainService;
                    _this.canceled = new core_1.EventEmitter();
                    _this.submitted = new core_1.EventEmitter();
                    _this.domain = new domain_view_model_1.DomainViewModel();
                    return _this;
                }
                DomainFormComponent.prototype.initData = function () {
                    var _this = this;
                    if (lang_1.isPresent(this.domainId)) {
                        this.loading = true;
                        this._domainService.get(this.domainId).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.domain = response.data;
                            }
                            _this.loading = false;
                        });
                    } else {
                        this.domain.active = true;
                        this.domain.blocked = false;
                        this.domain.deleted = false;
                        this.domain.generalRegistration = false;
                        this.domain.requestAllowed = true;
                    }
                };
                DomainFormComponent.prototype.initKeyStrokes = function () {
                    var _this = this;
                    key_stroke_manager_1.KeyStrokeManager.register(key_stroke_manager_1.KeyStroke.CANCEL, function () {
                        return _this.cancel();
                    });
                    key_stroke_manager_1.KeyStrokeManager.register(key_stroke_manager_1.KeyStroke.SAVE, function () {
                        return _this.submit();
                    });
                };
                DomainFormComponent.prototype.buildForm = function () {
                    this.form = new common_1.ControlGroup({
                        'institution': new common_1.Control('', validators_1.validators(domain_view_model_1.DomainViewModel.INSTITUTION_VALIDATORS)),
                        'name': new common_1.Control('', validators_1.validators(domain_view_model_1.DomainViewModel.NAME_VALIDATORS.concat([validators_1.domain]))),
                        'canton': new common_1.Control(''),
                        'active': new common_1.Control(''),
                        'blocked': new common_1.Control(''),
                        'generalRegistration': new common_1.Control(''),
                        'requestAllowed': new common_1.Control(''),
                        'deleted': new common_1.Control('')
                    });
                };
                DomainFormComponent.prototype.cancel = function () {
                    this.canceled.emit(this.domain);
                };
                DomainFormComponent.prototype.submit = function () {
                    var _this = this;
                    this.alertService.reset();
                    if (this.validate()) {
                        this.loading = true;
                        this._domainService.store(this.domain).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.submitted.emit(_this.domain);
                            }
                            _this.loading = false;
                        });
                    }
                };
                __decorate([core_1.Input(), __metadata("design:type", String)], DomainFormComponent.prototype, "id", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Number)], DomainFormComponent.prototype, "domainId", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], DomainFormComponent.prototype, "canceled", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], DomainFormComponent.prototype, "submitted", void 0);
                DomainFormComponent = __decorate([core_1.Component({
                    directives: [constants_1.AGS_FORM_DIRECTIVES],
                    pipes: [constants_1.AGS_PIPES],
                    selector: 'domain-form',
                    templateUrl: 'ags-client/app/components/domain_form_component.html'
                }), __metadata("design:paramtypes", [alert_service_1.AlertService, translation_service_1.TranslationService, domain_service_1.DomainService, core_1.ElementRef])], DomainFormComponent);
                return DomainFormComponent;
            }(abstract_form_component_1.AbstractFormComponent);
            exports_1("DomainFormComponent", DomainFormComponent);
        }
    };
});

System.register("ags-client/app/components/domain_table_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/constants.js", "ags-client/app/services/alert_service.js", "ags-client/app/services/translation_service.js", "ags-client/app/components/abstract_table_component.js", "ags-client/gen/viewsearch/domain_search_criteria.js", "ags-client/app/services/domain_service.js", "ags-client/app/services/confirmation_service.js", "ags-client/app/viewsearch/search_criteria.js", "ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, constants_1, alert_service_1, translation_service_1, abstract_table_component_1, domain_search_criteria_1, domain_service_1, confirmation_service_1, search_criteria_1, ags_client_1, DomainTableComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (constants_1_1) {
            constants_1 = constants_1_1;
        }, function (alert_service_1_1) {
            alert_service_1 = alert_service_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }, function (abstract_table_component_1_1) {
            abstract_table_component_1 = abstract_table_component_1_1;
        }, function (domain_search_criteria_1_1) {
            domain_search_criteria_1 = domain_search_criteria_1_1;
        }, function (domain_service_1_1) {
            domain_service_1 = domain_service_1_1;
        }, function (confirmation_service_1_1) {
            confirmation_service_1 = confirmation_service_1_1;
        }, function (search_criteria_1_1) {
            search_criteria_1 = search_criteria_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }],
        execute: function () {
            DomainTableComponent = /** @class */function (_super) {
                __extends(DomainTableComponent, _super);
                function DomainTableComponent(alertService, translationService, _domainService, _confirmationService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._domainService = _domainService;
                    _this._confirmationService = _confirmationService;
                    _this.checked = false;
                    _this.selected = new core_1.EventEmitter();
                    return _this;
                }
                DomainTableComponent.prototype.initSearchCriteria = function () {
                    var _this = this;
                    if (!this.domainSearchCriteria) {
                        this.domainSearchCriteria = new domain_search_criteria_1.DomainSearchCriteria(0, 10);
                        this.domainSearchCriteria.sortLanguage = this.translationService.language;
                        this.domainSearchCriteria.deleted = false;
                        this.domainSearchCriteria.sort = new search_criteria_1.SearchSort('institution', search_criteria_1.SortDirection.ASCENDING);
                    }
                    this.domainSearchCriteria.subscribeSearch(function () {
                        _this.search();
                    });
                    this.search();
                };
                DomainTableComponent.prototype.buildFilterForm = function () {
                    this.filterForm = new common_1.ControlGroup({
                        'institution': new common_1.Control(''),
                        'name': new common_1.Control(''),
                        'canton': new common_1.Control(''),
                        'active': new common_1.Control(''),
                        'blocked': new common_1.Control(''),
                        'generalRegistration': new common_1.Control(''),
                        'requestAllowed': new common_1.Control(''),
                        'deleted': new common_1.Control('')
                    });
                };
                DomainTableComponent.prototype.search = function () {
                    var _this = this;
                    if (this.filterForm.valid) {
                        this.loading = true;
                        this._domainService.search(this.domainSearchCriteria).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.domainSearchCriteria.total = response.totalItems;
                                _this.domains = response.data;
                            }
                            _this.loading = false;
                        });
                    }
                };
                DomainTableComponent.prototype.check = function (domain) {
                    domain.checked = !domain.checked;
                };
                DomainTableComponent.prototype.checkAll = function () {
                    this.checked = !this.checked;
                    if (this.domains != null) {
                        for (var _i = 0, _a = this.domains; _i < _a.length; _i++) {
                            var domain = _a[_i];
                            domain.checked = this.checked;
                        }
                    }
                };
                DomainTableComponent.prototype.delete = function (domain) {
                    var _this = this;
                    if (domain.deleted) {
                        this.loading = true;
                        this._domainService.undelete(domain.id).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                domain.deleted = false;
                            }
                            _this.loading = false;
                        });
                    } else {
                        this._confirmationService.confirmDelete(function () {
                            _this.loading = true;
                            _this._domainService.delete(domain.id).subscribe(function (response) {
                                if (!_this.handleError(response)) {
                                    domain.deleted = true;
                                }
                                _this.loading = false;
                            });
                        });
                    }
                };
                DomainTableComponent.prototype.edit = function (domain) {
                    this.selected.emit(domain);
                };
                DomainTableComponent.prototype.select = function (domain) {
                    this.selected.emit(domain);
                };
                __decorate([core_1.Input(), __metadata("design:type", String)], DomainTableComponent.prototype, "id", void 0);
                __decorate([ags_client_1.PageFlow('DomainTableComponent'), __metadata("design:type", domain_search_criteria_1.DomainSearchCriteria)], DomainTableComponent.prototype, "domainSearchCriteria", void 0);
                __decorate([ags_client_1.PageFlow('DomainTableComponent'), __metadata("design:type", Array)], DomainTableComponent.prototype, "domains", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], DomainTableComponent.prototype, "selected", void 0);
                DomainTableComponent = __decorate([core_1.Component({
                    directives: [constants_1.AGS_FORM_DIRECTIVES],
                    pipes: [constants_1.AGS_PIPES],
                    selector: 'domain-table',
                    templateUrl: 'ags-client/app/components/domain_table_component.html'
                }), __metadata("design:paramtypes", [alert_service_1.AlertService, translation_service_1.TranslationService, domain_service_1.DomainService, confirmation_service_1.ConfirmationService, core_1.ElementRef])], DomainTableComponent);
                return DomainTableComponent;
            }(abstract_table_component_1.AbstractTableComponent);
            exports_1("DomainTableComponent", DomainTableComponent);
        }
    };
});

System.register("ags-client/app/components/system_parameter_form_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/constants.js", "ags-client/app/services/alert_service.js", "ags-client/app/services/translation_service.js", "ags-client/app/components/abstract_form_component.js", "ags-client/app/commons/lang.js", "ags-client/gen/viewmodels/system_view_model.js", "ags-client/app/validators.js", "ags-client/app/commons/key_stroke_manager.js", "ags-client/app/services/system_service.js", "ags-client/gen/enums.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, constants_1, alert_service_1, translation_service_1, abstract_form_component_1, lang_1, system_view_model_1, validators_1, key_stroke_manager_1, system_service_1, enums_1, SystemParameterFormComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (constants_1_1) {
            constants_1 = constants_1_1;
        }, function (alert_service_1_1) {
            alert_service_1 = alert_service_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }, function (abstract_form_component_1_1) {
            abstract_form_component_1 = abstract_form_component_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }, function (system_view_model_1_1) {
            system_view_model_1 = system_view_model_1_1;
        }, function (validators_1_1) {
            validators_1 = validators_1_1;
        }, function (key_stroke_manager_1_1) {
            key_stroke_manager_1 = key_stroke_manager_1_1;
        }, function (system_service_1_1) {
            system_service_1 = system_service_1_1;
        }, function (enums_1_1) {
            enums_1 = enums_1_1;
        }],
        execute: function () {
            SystemParameterFormComponent = /** @class */function (_super) {
                __extends(SystemParameterFormComponent, _super);
                function SystemParameterFormComponent(alertService, translationService, _systemService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._systemService = _systemService;
                    _this.canceled = new core_1.EventEmitter();
                    _this.submitted = new core_1.EventEmitter();
                    _this.system = new system_view_model_1.SystemViewModel();
                    return _this;
                }
                SystemParameterFormComponent.prototype.initData = function () {
                    var _this = this;
                    if (lang_1.isPresent(this.systemId)) {
                        this.loading = true;
                        this._systemService.get(this.systemId).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.system = response.data;
                                _this._parseValue();
                            }
                            _this.loading = false;
                        });
                    } else {
                        this.system.valueType = enums_1.ValueType.STRING;
                        this.system.deleted = false;
                    }
                };
                SystemParameterFormComponent.prototype._parseValue = function () {
                    switch (this.system.valueType) {
                        case enums_1.ValueType.BOOLEAN:
                            this.valueBoolean = this.system.value === 'true' || this.system.value === '1';
                            break;
                        case enums_1.ValueType.DATE:
                        case enums_1.ValueType.DATETIME:
                            this.valueDate = lang_1.parseDate(this.system.value);
                            break;
                        case enums_1.ValueType.DOUBLE:
                        case enums_1.ValueType.PERCENT:
                            this.valueDecimal = parseFloat(this.system.value);
                            break;
                        case enums_1.ValueType.INTEGER:
                        case enums_1.ValueType.LONG:
                            this.valueNumber = parseInt(this.system.value);
                            break;
                        case enums_1.ValueType.ARRAY:
                        case enums_1.ValueType.PASSWORD:
                        case enums_1.ValueType.STRING:
                            this.valueString = this.system.value;
                    }
                };
                SystemParameterFormComponent.prototype._serializeValue = function () {
                    switch (this.system.valueType) {
                        case enums_1.ValueType.BOOLEAN:
                            this.system.value = this.valueBoolean ? 'true' : 'false';
                            break;
                        case enums_1.ValueType.DATE:
                        case enums_1.ValueType.DATETIME:
                            this.system.value = lang_1.formatDate(this.valueDate);
                            break;
                        case enums_1.ValueType.DOUBLE:
                        case enums_1.ValueType.PERCENT:
                            this.system.value = lang_1.isPresent(this.valueDecimal) ? this.valueDecimal.toString() : null;
                            break;
                        case enums_1.ValueType.INTEGER:
                        case enums_1.ValueType.LONG:
                            this.system.value = lang_1.isPresent(this.valueNumber) ? this.valueNumber.toString() : null;
                            break;
                        case enums_1.ValueType.ARRAY:
                        case enums_1.ValueType.PASSWORD:
                        case enums_1.ValueType.STRING:
                            this.system.value = this.valueString;
                    }
                };
                SystemParameterFormComponent.prototype.initKeyStrokes = function () {
                    var _this = this;
                    key_stroke_manager_1.KeyStrokeManager.register(key_stroke_manager_1.KeyStroke.CANCEL, function () {
                        return _this.cancel();
                    });
                    key_stroke_manager_1.KeyStrokeManager.register(key_stroke_manager_1.KeyStroke.SAVE, function () {
                        return _this.submit();
                    });
                };
                SystemParameterFormComponent.prototype.buildForm = function () {
                    this.form = new common_1.ControlGroup({
                        'name': new common_1.Control('', validators_1.validators(system_view_model_1.SystemViewModel.NAME_VALIDATORS)),
                        'valueType': new common_1.Control('', validators_1.validators(system_view_model_1.SystemViewModel.VALUE_TYPE_VALIDATORS)),
                        'value': new common_1.Control(''),
                        'description': new common_1.Control('', validators_1.validators(system_view_model_1.SystemViewModel.DESCRIPTION_VALIDATORS)),
                        'deleted': new common_1.Control('')
                    });
                };
                SystemParameterFormComponent.prototype.cancel = function () {
                    this.canceled.emit(this.system);
                };
                SystemParameterFormComponent.prototype.submit = function () {
                    var _this = this;
                    this.alertService.reset();
                    this._serializeValue();
                    if (this.validate()) {
                        this.loading = true;
                        this._systemService.store(this.system).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.submitted.emit(_this.system);
                            }
                            _this.loading = false;
                        });
                    }
                };
                __decorate([core_1.Input(), __metadata("design:type", String)], SystemParameterFormComponent.prototype, "id", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Number)], SystemParameterFormComponent.prototype, "systemId", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], SystemParameterFormComponent.prototype, "canceled", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], SystemParameterFormComponent.prototype, "submitted", void 0);
                SystemParameterFormComponent = __decorate([core_1.Component({
                    directives: [constants_1.AGS_FORM_DIRECTIVES],
                    pipes: [constants_1.AGS_PIPES],
                    selector: 'system-parameter-form',
                    templateUrl: 'ags-client/app/components/system_parameter_form_component.html'
                }), __metadata("design:paramtypes", [alert_service_1.AlertService, translation_service_1.TranslationService, system_service_1.SystemService, core_1.ElementRef])], SystemParameterFormComponent);
                return SystemParameterFormComponent;
            }(abstract_form_component_1.AbstractFormComponent);
            exports_1("SystemParameterFormComponent", SystemParameterFormComponent);
        }
    };
});

System.register("ags-client/gen/services/abstract_system_service.js", ["ags-client/app/models/json_response.js", "ags-client/gen/viewmodels/system_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var json_response_1, system_view_model_1, AbstractSystemService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (json_response_1_1) {
            json_response_1 = json_response_1_1;
        }, function (system_view_model_1_1) {
            system_view_model_1 = system_view_model_1_1;
        }],
        execute: function () {
            AbstractSystemService = /** @class */function () {
                function AbstractSystemService(backendService) {
                    this.backendService = backendService;
                }
                AbstractSystemService.prototype.system = function (request) {
                    return this.backendService.getJson('/system/system/' + request + '.json', function (response) {
                        return json_response_1.JsonResponse.deserialize(response, system_view_model_1.SystemViewModel.deserialize(response.data));
                    });
                };
                AbstractSystemService.prototype.search = function (request) {
                    return this.backendService.postJson('/system/search.json', request.serialize(), function (response) {
                        var data = Array();
                        response.data.forEach(function (item) {
                            data.push(system_view_model_1.SystemViewModel.deserialize(item));
                        });
                        return json_response_1.JsonResponse.deserialize(response, data);
                    });
                };
                AbstractSystemService.prototype.get = function (request) {
                    return this.backendService.getJson('/system/get/' + request + '.json', function (response) {
                        return json_response_1.JsonResponse.deserialize(response, system_view_model_1.SystemViewModel.deserialize(response.data));
                    });
                };
                AbstractSystemService.prototype.store = function (request) {
                    return this.backendService.postJson('/system/store.json', request.serialize(), function (response) {
                        return json_response_1.JsonResponse.deserialize(response, system_view_model_1.SystemViewModel.deserialize(response.data));
                    });
                };
                AbstractSystemService.prototype.delete = function (request) {
                    return this.backendService.getJson('/system/delete/' + request + '.json', function (response) {
                        return json_response_1.JsonResponse.deserialize(response);
                    });
                };
                AbstractSystemService.prototype.undelete = function (request) {
                    return this.backendService.getJson('/system/undelete/' + request + '.json', function (response) {
                        return json_response_1.JsonResponse.deserialize(response);
                    });
                };
                return AbstractSystemService;
            }();
            exports_1("AbstractSystemService", AbstractSystemService);
        }
    };
});

System.register("ags-client/app/services/system_service.js", ["angular2/core.js", "ags-client/gen/services/abstract_system_service.js", "ags-client/app/services/backend_service.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, abstract_system_service_1, backend_service_1, SystemService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (abstract_system_service_1_1) {
            abstract_system_service_1 = abstract_system_service_1_1;
        }, function (backend_service_1_1) {
            backend_service_1 = backend_service_1_1;
        }],
        execute: function () {
            SystemService = /** @class */function (_super) {
                __extends(SystemService, _super);
                function SystemService(backendService) {
                    return _super.call(this, backendService) || this;
                }
                SystemService = __decorate([core_1.Injectable(), core_1.Inject(backend_service_1.BackendService), __metadata("design:paramtypes", [backend_service_1.BackendService])], SystemService);
                return SystemService;
            }(abstract_system_service_1.AbstractSystemService);
            exports_1("SystemService", SystemService);
        }
    };
});

System.register("ags-client/app/components/system_parameter_table_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/constants.js", "ags-client/app/services/alert_service.js", "ags-client/app/services/translation_service.js", "ags-client/app/components/abstract_table_component.js", "ags-client/gen/viewsearch/system_search_criteria.js", "ags-client/app/services/system_service.js", "ags-client/app/services/confirmation_service.js", "ags-client/app/viewsearch/search_criteria.js", "ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, constants_1, alert_service_1, translation_service_1, abstract_table_component_1, system_search_criteria_1, system_service_1, confirmation_service_1, search_criteria_1, ags_client_1, SystemParameterTableComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (constants_1_1) {
            constants_1 = constants_1_1;
        }, function (alert_service_1_1) {
            alert_service_1 = alert_service_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }, function (abstract_table_component_1_1) {
            abstract_table_component_1 = abstract_table_component_1_1;
        }, function (system_search_criteria_1_1) {
            system_search_criteria_1 = system_search_criteria_1_1;
        }, function (system_service_1_1) {
            system_service_1 = system_service_1_1;
        }, function (confirmation_service_1_1) {
            confirmation_service_1 = confirmation_service_1_1;
        }, function (search_criteria_1_1) {
            search_criteria_1 = search_criteria_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }],
        execute: function () {
            SystemParameterTableComponent = /** @class */function (_super) {
                __extends(SystemParameterTableComponent, _super);
                function SystemParameterTableComponent(alertService, translationService, _systemService, _confirmationService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._systemService = _systemService;
                    _this._confirmationService = _confirmationService;
                    _this.checked = false;
                    _this.selected = new core_1.EventEmitter();
                    return _this;
                }
                SystemParameterTableComponent.prototype.initSearchCriteria = function () {
                    var _this = this;
                    if (!this.systemSearchCriteria) {
                        this.systemSearchCriteria = new system_search_criteria_1.SystemSearchCriteria(0, 10);
                        this.systemSearchCriteria.sortLanguage = this.translationService.language;
                        this.systemSearchCriteria.deleted = false;
                        this.systemSearchCriteria.sort = new search_criteria_1.SearchSort('name', search_criteria_1.SortDirection.ASCENDING);
                    }
                    this.systemSearchCriteria.subscribeSearch(function () {
                        _this.search();
                    });
                    this.search();
                };
                SystemParameterTableComponent.prototype.buildFilterForm = function () {
                    this.filterForm = new common_1.ControlGroup({
                        'name': new common_1.Control(''),
                        'description': new common_1.Control(''),
                        'valueType': new common_1.Control(''),
                        'value': new common_1.Control(''),
                        'deleted': new common_1.Control('')
                    });
                };
                SystemParameterTableComponent.prototype.search = function () {
                    var _this = this;
                    if (this.filterForm.valid) {
                        this.loading = true;
                        this._systemService.search(this.systemSearchCriteria).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.systemSearchCriteria.total = response.totalItems;
                                _this.systems = response.data;
                            }
                            _this.loading = false;
                        });
                    }
                };
                SystemParameterTableComponent.prototype.check = function (system) {
                    system.checked = !system.checked;
                };
                SystemParameterTableComponent.prototype.checkAll = function () {
                    this.checked = !this.checked;
                    if (this.systems != null) {
                        for (var _i = 0, _a = this.systems; _i < _a.length; _i++) {
                            var system = _a[_i];
                            system.checked = this.checked;
                        }
                    }
                };
                SystemParameterTableComponent.prototype.delete = function (system) {
                    var _this = this;
                    if (system.deleted) {
                        this.loading = true;
                        this._systemService.undelete(system.id).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                system.deleted = false;
                            }
                            _this.loading = false;
                        });
                    } else {
                        this._confirmationService.confirmDelete(function () {
                            _this.loading = true;
                            _this._systemService.delete(system.id).subscribe(function (response) {
                                if (!_this.handleError(response)) {
                                    system.deleted = true;
                                }
                                _this.loading = false;
                            });
                        });
                    }
                };
                SystemParameterTableComponent.prototype.edit = function (system) {
                    this.selected.emit(system);
                };
                SystemParameterTableComponent.prototype.select = function (system) {
                    this.selected.emit(system);
                };
                __decorate([core_1.Input(), __metadata("design:type", String)], SystemParameterTableComponent.prototype, "id", void 0);
                __decorate([ags_client_1.PageFlow('SystemParameterTableComponent'), __metadata("design:type", system_search_criteria_1.SystemSearchCriteria)], SystemParameterTableComponent.prototype, "systemSearchCriteria", void 0);
                __decorate([ags_client_1.PageFlow('SystemParameterTableComponent'), __metadata("design:type", Array)], SystemParameterTableComponent.prototype, "systems", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], SystemParameterTableComponent.prototype, "selected", void 0);
                SystemParameterTableComponent = __decorate([core_1.Component({
                    directives: [constants_1.AGS_FORM_DIRECTIVES],
                    pipes: [constants_1.AGS_PIPES],
                    selector: 'system-parameter-table',
                    templateUrl: 'ags-client/app/components/system_parameter_table_component.html'
                }), __metadata("design:paramtypes", [alert_service_1.AlertService, translation_service_1.TranslationService, system_service_1.SystemService, confirmation_service_1.ConfirmationService, core_1.ElementRef])], SystemParameterTableComponent);
                return SystemParameterTableComponent;
            }(abstract_table_component_1.AbstractTableComponent);
            exports_1("SystemParameterTableComponent", SystemParameterTableComponent);
        }
    };
});

System.register("ags-client/app/components/abstract_table_component.js", ["ags-client/app/components/abstract_component.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var abstract_component_1, AbstractTableComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (abstract_component_1_1) {
            abstract_component_1 = abstract_component_1_1;
        }],
        execute: function () {
            AbstractTableComponent = /** @class */function (_super) {
                __extends(AbstractTableComponent, _super);
                function AbstractTableComponent(alertService, translationService, element) {
                    return _super.call(this, alertService, translationService, element) || this;
                }
                AbstractTableComponent.prototype.ngAfterContentInit = function () {
                    this.buildFilterForm();
                    this.initSearchCriteria();
                    this.initData();
                };
                AbstractTableComponent.prototype.ngAfterViewInit = function () {
                    return;
                };
                AbstractTableComponent.prototype.initData = function () {
                    return;
                };
                AbstractTableComponent.prototype.initSearchCriteria = function () {
                    return;
                };
                AbstractTableComponent.prototype.buildFilterForm = function () {
                    return;
                };
                return AbstractTableComponent;
            }(abstract_component_1.AbstractComponent);
            exports_1("AbstractTableComponent", AbstractTableComponent);
        }
    };
});

System.register("ags-client/app/components/role_table_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/constants.js", "ags-client/gen/viewsearch/role_search_criteria.js", "ags-client/app/services/alert_service.js", "ags-client/app/services/translation_service.js", "ags-client/app/components/abstract_table_component.js", "ags-client/app/services/role_service.js", "ags-client/app/services/confirmation_service.js", "ags-client/app/viewsearch/search_criteria.js", "ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, constants_1, role_search_criteria_1, alert_service_1, translation_service_1, abstract_table_component_1, role_service_1, confirmation_service_1, search_criteria_1, ags_client_1, RoleTableComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (constants_1_1) {
            constants_1 = constants_1_1;
        }, function (role_search_criteria_1_1) {
            role_search_criteria_1 = role_search_criteria_1_1;
        }, function (alert_service_1_1) {
            alert_service_1 = alert_service_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }, function (abstract_table_component_1_1) {
            abstract_table_component_1 = abstract_table_component_1_1;
        }, function (role_service_1_1) {
            role_service_1 = role_service_1_1;
        }, function (confirmation_service_1_1) {
            confirmation_service_1 = confirmation_service_1_1;
        }, function (search_criteria_1_1) {
            search_criteria_1 = search_criteria_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }],
        execute: function () {
            RoleTableComponent = /** @class */function (_super) {
                __extends(RoleTableComponent, _super);
                function RoleTableComponent(alertService, translationService, _roleService, _confirmationService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._roleService = _roleService;
                    _this._confirmationService = _confirmationService;
                    _this.selected = new core_1.EventEmitter();
                    return _this;
                }
                RoleTableComponent.prototype.initSearchCriteria = function () {
                    var _this = this;
                    if (!this.roleSearchCriteria) {
                        this.roleSearchCriteria = new role_search_criteria_1.RoleSearchCriteria(0, 10);
                        this.roleSearchCriteria.sortLanguage = this.translationService.language;
                        this.roleSearchCriteria.deleted = false;
                        this.roleSearchCriteria.sort = new search_criteria_1.SearchSort('role', search_criteria_1.SortDirection.ASCENDING);
                    }
                    this.roleSearchCriteria.subscribeSearch(function () {
                        _this.search();
                    });
                    this.search();
                };
                RoleTableComponent.prototype.buildFilterForm = function () {
                    this.filterForm = new common_1.ControlGroup({
                        'roleName': new common_1.Control(''),
                        'roleDescription': new common_1.Control(''),
                        'roleAssigned': new common_1.Control(''),
                        'rule': new common_1.Control(''),
                        'deleted': new common_1.Control('')
                    });
                };
                RoleTableComponent.prototype.search = function () {
                    var _this = this;
                    if (this.filterForm.valid) {
                        this.loading = true;
                        this._roleService.search(this.roleSearchCriteria).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.roleSearchCriteria.total = response.totalItems;
                                _this.roleSearchResults = response.data;
                            }
                            _this.loading = false;
                        });
                    }
                };
                RoleTableComponent.prototype.delete = function (role) {
                    var _this = this;
                    if (role.deleted) {
                        this._roleService.undelete(role.id).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                role.deleted = false;
                            }
                            _this.loading = false;
                        });
                    } else {
                        this._confirmationService.confirmDelete(function () {
                            _this.loading = true;
                            _this._roleService.delete(role.id).subscribe(function (response) {
                                if (!_this.handleError(response)) {
                                    role.deleted = true;
                                }
                                _this.loading = false;
                            });
                        });
                    }
                };
                RoleTableComponent.prototype.select = function (role) {
                    this.selected.emit(role);
                };
                __decorate([core_1.Input(), __metadata("design:type", String)], RoleTableComponent.prototype, "id", void 0);
                __decorate([ags_client_1.PageFlow('RoleTableComponent'), __metadata("design:type", role_search_criteria_1.RoleSearchCriteria)], RoleTableComponent.prototype, "roleSearchCriteria", void 0);
                __decorate([ags_client_1.PageFlow('RoleTableComponent'), __metadata("design:type", Array)], RoleTableComponent.prototype, "roleSearchResults", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], RoleTableComponent.prototype, "selected", void 0);
                RoleTableComponent = __decorate([core_1.Component({
                    directives: [constants_1.AGS_FORM_DIRECTIVES],
                    pipes: [constants_1.AGS_PIPES],
                    selector: 'role-table',
                    templateUrl: 'ags-client/app/components/role_table_component.html'
                }), __metadata("design:paramtypes", [alert_service_1.AlertService, translation_service_1.TranslationService, role_service_1.RoleService, confirmation_service_1.ConfirmationService, core_1.ElementRef])], RoleTableComponent);
                return RoleTableComponent;
            }(abstract_table_component_1.AbstractTableComponent);
            exports_1("RoleTableComponent", RoleTableComponent);
        }
    };
});

System.register("ags-client/app/components/abstract_form_component.js", ["ags-client/app/components/abstract_component.js", "angular2/common.js", "ags-client/app/commons/lang.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var abstract_component_1, common_1, lang_1, AbstractFormComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (abstract_component_1_1) {
            abstract_component_1 = abstract_component_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }],
        execute: function () {
            AbstractFormComponent = /** @class */function (_super) {
                __extends(AbstractFormComponent, _super);
                function AbstractFormComponent(alertService, translationService, element) {
                    return _super.call(this, alertService, translationService, element) || this;
                }
                AbstractFormComponent.prototype.initData = function () {
                    return;
                };
                AbstractFormComponent.prototype.buildForm = function () {
                    return;
                };
                AbstractFormComponent.prototype.ngAfterContentInit = function () {
                    this.initKeyStrokes();
                    this.buildForm();
                    this.initData();
                };
                AbstractFormComponent.prototype.ngAfterViewInit = function () {
                    this.completeForm();
                };
                AbstractFormComponent.prototype.completeForm = function () {
                    return;
                };
                AbstractFormComponent.prototype.initKeyStrokes = function () {
                    return;
                };
                AbstractFormComponent.prototype.cancel = function () {
                    return;
                };
                AbstractFormComponent.prototype.submit = function () {
                    return;
                };
                AbstractFormComponent.prototype.back = function () {
                    window.history.back();
                };
                AbstractFormComponent.prototype.reset = function () {
                    this.initData();
                    if (this.form) {
                        this._reset(this.form);
                    }
                    this.focus();
                };
                AbstractFormComponent.prototype._reset = function (control) {
                    if (control instanceof common_1.ControlGroup) {
                        var controlGroup = control;
                        if (controlGroup.controls) {
                            for (var key in controlGroup.controls) {
                                if (controlGroup.controls[key]) {
                                    this._reset(controlGroup.controls[key]);
                                }
                            }
                        }
                    }
                    control['_pristine'] = true;
                    control['_statusChanges'].emit();
                };
                AbstractFormComponent.prototype.validate = function () {
                    if (this.form) {
                        this._validate(this.form);
                        return this.form.valid;
                    }
                    return false;
                };
                AbstractFormComponent.prototype._validate = function (control) {
                    control.markAsDirty();
                    control['_pristine'] = false;
                    control.updateValueAndValidity();
                    if (control instanceof common_1.ControlGroup) {
                        var controlGroup = control;
                        if (controlGroup.controls) {
                            for (var key in controlGroup.controls) {
                                if (controlGroup.controls[key]) {
                                    this._validate(controlGroup.controls[key]);
                                }
                            }
                        }
                    }
                };
                AbstractFormComponent.prototype.focus = function (selector) {
                    var _this = this;
                    setTimeout(function () {
                        var firstInput = _this.element.nativeElement.querySelector('input');
                        if (lang_1.isSomething(selector)) {
                            firstInput = _this.element.nativeElement.querySelector(selector);
                        }
                        if (firstInput) {
                            firstInput.focus();
                        }
                    }, 100);
                };
                AbstractFormComponent.prototype.ngOnDestroy = function () {
                    this.onDestroy();
                };
                AbstractFormComponent.prototype.onDestroy = function () {
                    return;
                };
                return AbstractFormComponent;
            }(abstract_component_1.AbstractComponent);
            exports_1("AbstractFormComponent", AbstractFormComponent);
        }
    };
});

System.register("ags-client/gen/services/abstract_role_service.js", ["ags-client/app/models/json_response.js", "ags-client/gen/viewmodels/role_search_result_view_model.js", "ags-client/gen/viewmodels/role_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var json_response_1, role_search_result_view_model_1, role_view_model_1, AbstractRoleService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (json_response_1_1) {
            json_response_1 = json_response_1_1;
        }, function (role_search_result_view_model_1_1) {
            role_search_result_view_model_1 = role_search_result_view_model_1_1;
        }, function (role_view_model_1_1) {
            role_view_model_1 = role_view_model_1_1;
        }],
        execute: function () {
            AbstractRoleService = /** @class */function () {
                function AbstractRoleService(backendService) {
                    this.backendService = backendService;
                }
                AbstractRoleService.prototype.search = function (request) {
                    return this.backendService.postJson('/role/search.json', request.serialize(), function (response) {
                        var data = Array();
                        response.data.forEach(function (item) {
                            data.push(role_search_result_view_model_1.RoleSearchResultViewModel.deserialize(item));
                        });
                        return json_response_1.JsonResponse.deserialize(response, data);
                    });
                };
                AbstractRoleService.prototype.get = function (request) {
                    return this.backendService.getJson('/role/get/' + request + '.json', function (response) {
                        return json_response_1.JsonResponse.deserialize(response, role_view_model_1.RoleViewModel.deserialize(response.data));
                    });
                };
                AbstractRoleService.prototype.store = function (request) {
                    return this.backendService.postJson('/role/store.json', request.serialize(), function (response) {
                        return json_response_1.JsonResponse.deserialize(response);
                    });
                };
                AbstractRoleService.prototype.delete = function (request) {
                    return this.backendService.getJson('/role/delete/' + request + '.json', function (response) {
                        return json_response_1.JsonResponse.deserialize(response);
                    });
                };
                AbstractRoleService.prototype.undelete = function (request) {
                    return this.backendService.getJson('/role/undelete/' + request + '.json', function (response) {
                        return json_response_1.JsonResponse.deserialize(response);
                    });
                };
                return AbstractRoleService;
            }();
            exports_1("AbstractRoleService", AbstractRoleService);
        }
    };
});

System.register("ags-client/app/services/role_service.js", ["angular2/core.js", "ags-client/gen/services/abstract_role_service.js", "ags-client/app/services/backend_service.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, abstract_role_service_1, backend_service_1, RoleService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (abstract_role_service_1_1) {
            abstract_role_service_1 = abstract_role_service_1_1;
        }, function (backend_service_1_1) {
            backend_service_1 = backend_service_1_1;
        }],
        execute: function () {
            RoleService = /** @class */function (_super) {
                __extends(RoleService, _super);
                function RoleService(backendService) {
                    return _super.call(this, backendService) || this;
                }
                RoleService = __decorate([core_1.Injectable(), core_1.Inject(backend_service_1.BackendService), __metadata("design:paramtypes", [backend_service_1.BackendService])], RoleService);
                return RoleService;
            }(abstract_role_service_1.AbstractRoleService);
            exports_1("RoleService", RoleService);
        }
    };
});

System.register("ags-client/app/components/role_form_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/constants.js", "ags-client/gen/viewmodels/role_view_model.js", "ags-client/app/services/alert_service.js", "ags-client/app/services/code_service.js", "ags-client/app/services/translation_service.js", "ags-client/app/components/abstract_form_component.js", "ags-client/app/commons/lang.js", "ags-client/app/services/role_service.js", "ags-client/app/commons/key_stroke_manager.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, constants_1, role_view_model_1, alert_service_1, code_service_1, translation_service_1, abstract_form_component_1, lang_1, role_service_1, key_stroke_manager_1, RoleFormComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (constants_1_1) {
            constants_1 = constants_1_1;
        }, function (role_view_model_1_1) {
            role_view_model_1 = role_view_model_1_1;
        }, function (alert_service_1_1) {
            alert_service_1 = alert_service_1_1;
        }, function (code_service_1_1) {
            code_service_1 = code_service_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }, function (abstract_form_component_1_1) {
            abstract_form_component_1 = abstract_form_component_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }, function (role_service_1_1) {
            role_service_1 = role_service_1_1;
        }, function (key_stroke_manager_1_1) {
            key_stroke_manager_1 = key_stroke_manager_1_1;
        }],
        execute: function () {
            RoleFormComponent = /** @class */function (_super) {
                __extends(RoleFormComponent, _super);
                function RoleFormComponent(alertService, translationService, _roleService, _codeService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this._roleService = _roleService;
                    _this._codeService = _codeService;
                    _this.canceled = new core_1.EventEmitter();
                    _this.submitted = new core_1.EventEmitter();
                    _this.role = new role_view_model_1.RoleViewModel();
                    return _this;
                }
                RoleFormComponent.prototype.initData = function () {
                    var _this = this;
                    if (lang_1.isPresent(this.roleId)) {
                        this.loading = true;
                        this._roleService.get(this.roleId).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.role = response.data;
                                _this._codeService.sortCodesByDescription('Role', _this.role.rolesAssigned);
                                _this._codeService.sortCodesByDescription('Rule', _this.role.rulesAssigned);
                            }
                            _this.loading = false;
                        });
                    } else {
                        return;
                    }
                };
                RoleFormComponent.prototype.initKeyStrokes = function () {
                    var _this = this;
                    key_stroke_manager_1.KeyStrokeManager.register(key_stroke_manager_1.KeyStroke.CANCEL, function () {
                        return _this.cancel();
                    });
                    key_stroke_manager_1.KeyStrokeManager.register(key_stroke_manager_1.KeyStroke.SAVE, function () {
                        return _this.submit();
                    });
                };
                RoleFormComponent.prototype.buildForm = function () {
                    this.form = new common_1.ControlGroup({
                        'roles': new common_1.Control(''),
                        'rules': new common_1.Control('')
                    });
                };
                RoleFormComponent.prototype.cancel = function () {
                    this.canceled.emit(this.role);
                };
                RoleFormComponent.prototype.submit = function () {
                    var _this = this;
                    this.alertService.reset();
                    if (this.validate()) {
                        this.loading = true;
                        this._roleService.store(this.role).subscribe(function (response) {
                            if (!_this.handleError(response)) {
                                _this.submitted.emit(_this.role);
                            }
                            _this.loading = false;
                        });
                    }
                };
                __decorate([core_1.Input(), __metadata("design:type", String)], RoleFormComponent.prototype, "id", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Number)], RoleFormComponent.prototype, "roleId", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], RoleFormComponent.prototype, "canceled", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], RoleFormComponent.prototype, "submitted", void 0);
                RoleFormComponent = __decorate([core_1.Component({
                    directives: [constants_1.AGS_FORM_DIRECTIVES],
                    pipes: [constants_1.AGS_PIPES],
                    selector: 'role-form',
                    templateUrl: 'ags-client/app/components/role_form_component.html'
                }), __metadata("design:paramtypes", [alert_service_1.AlertService, translation_service_1.TranslationService, role_service_1.RoleService, code_service_1.CodeService, core_1.ElementRef])], RoleFormComponent);
                return RoleFormComponent;
            }(abstract_form_component_1.AbstractFormComponent);
            exports_1("RoleFormComponent", RoleFormComponent);
        }
    };
});

System.register("ags-client/app/components/abstract_component.js", ["ags-client/app/models/json_response.js"], function (exports_1, context_1) {
    "use strict";

    var json_response_1, AbstractComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (json_response_1_1) {
            json_response_1 = json_response_1_1;
        }],
        execute: function () {
            AbstractComponent = /** @class */function () {
                function AbstractComponent(_alertService, _translationService, _element) {
                    this._alertService = _alertService;
                    this._translationService = _translationService;
                    this._element = _element;
                }
                AbstractComponent.prototype.handleError = function (response, resetMessage) {
                    if (resetMessage === void 0) {
                        resetMessage = true;
                    }
                    if (resetMessage) {
                        this._alertService.reset();
                    }
                    if (response.status === json_response_1.JsonResponseStatus.ERROR || response.status === json_response_1.JsonResponseStatus.NOT_FOUND || response.status === json_response_1.JsonResponseStatus.FORBIDDEN) {
                        this._alertService.error(this._translationService.translate(response.error));
                        return true;
                    } else {
                        return false;
                    }
                };
                AbstractComponent.prototype.handleErrors = function (responses) {
                    var _this = this;
                    if (responses.responses.filter(function (response) {
                        return _this.handleError(response);
                    }).length > 0) {
                        return true;
                    }
                    return false;
                };
                Object.defineProperty(AbstractComponent.prototype, "alertService", {
                    get: function () {
                        return this._alertService;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AbstractComponent.prototype, "translationService", {
                    get: function () {
                        return this._translationService;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AbstractComponent.prototype, "element", {
                    get: function () {
                        return this._element;
                    },
                    enumerable: false,
                    configurable: true
                });
                AbstractComponent.prototype.ngAfterContentInit = function () {
                    return this.initData();
                };
                AbstractComponent.prototype.ngAfterViewInit = function () {};
                AbstractComponent.prototype.ngOnDestroy = function () {
                    this.onDestroy();
                };
                AbstractComponent.prototype.initData = function () {
                    return;
                };
                AbstractComponent.prototype.onDestroy = function () {
                    return;
                };
                AbstractComponent.prototype.focus = function (id) {
                    setTimeout(function () {
                        eval('$(\'#' + id + '\').focus();');
                    }, 100);
                };
                return AbstractComponent;
            }();
            exports_1("AbstractComponent", AbstractComponent);
        }
    };
});

System.register("ags-client/app/components/attachments_component.js", ["angular2/core.js", "ags-client/app/constants.js", "ags-client/app/services/alert_service.js", "ags-client/app/services/translation_service.js", "ags-client/app/components/abstract_component.js", "ags-client/app/commons/html.js", "ags-client/gen/viewmodels/file_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, constants_1, alert_service_1, translation_service_1, abstract_component_1, html_1, file_view_model_1, constants_2, AttachmentFile, AttachmentsComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (constants_1_1) {
            constants_1 = constants_1_1;
            constants_2 = constants_1_1;
        }, function (alert_service_1_1) {
            alert_service_1 = alert_service_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }, function (abstract_component_1_1) {
            abstract_component_1 = abstract_component_1_1;
        }, function (html_1_1) {
            html_1 = html_1_1;
        }, function (file_view_model_1_1) {
            file_view_model_1 = file_view_model_1_1;
        }],
        execute: function () {
            AttachmentFile = /** @class */function (_super) {
                __extends(AttachmentFile, _super);
                function AttachmentFile() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                Object.defineProperty(AttachmentFile.prototype, "sizeError", {
                    get: function () {
                        return this.fileSize > constants_2.MAX_UPLOAD_SIZE;
                    },
                    enumerable: false,
                    configurable: true
                });
                return AttachmentFile;
            }(file_view_model_1.FileViewModel);
            exports_1("AttachmentFile", AttachmentFile);
            AttachmentsComponent = /** @class */function (_super) {
                __extends(AttachmentsComponent, _super);
                function AttachmentsComponent(alertService, translationService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this.directUpload = false;
                    _this.filesSelected = new core_1.EventEmitter();
                    _this.attachmentFiles = new Array();
                    _this.dragover = function (event) {
                        html_1.appendClass(_this.dropzone, 'attachment-dropzone-hover');
                        event.stopPropagation();
                        event.preventDefault();
                        event.dataTransfer.dropEffect = 'copy';
                    };
                    _this.dragenter = function (event) {
                        event.stopPropagation();
                        event.preventDefault();
                    };
                    _this.dragleave = function (event) {
                        html_1.removeClass(_this.dropzone, 'attachment-dropzone-hover');
                        event.stopPropagation();
                        event.preventDefault();
                    };
                    _this.drop = function (event) {
                        html_1.removeClass(_this.dropzone, 'attachment-dropzone-hover');
                        _this._updateFiles(event.dataTransfer.files);
                        event.stopPropagation();
                        event.preventDefault();
                    };
                    _this.selected = function () {
                        _this._updateFiles(_this.fileSelect.files);
                    };
                    return _this;
                }
                AttachmentsComponent.prototype.ngAfterViewInit = function () {
                    this.dropzone = this.element.nativeElement.querySelector('.attachment-dropzone');
                    this.dropzone.addEventListener('dragover', this.dragover);
                    this.dropzone.addEventListener('dragenter', this.dragenter);
                    this.dropzone.addEventListener('dragleave', this.dragleave);
                    this.dropzone.addEventListener('drop', this.drop);
                    this.dropzone.querySelector('input').addEventListener('change', this.selected);
                };
                AttachmentsComponent.prototype.browse = function () {
                    this.fileSelect.click();
                };
                Object.defineProperty(AttachmentsComponent.prototype, "fileSelect", {
                    get: function () {
                        return this.dropzone.querySelector('input');
                    },
                    enumerable: false,
                    configurable: true
                });
                AttachmentsComponent.prototype._updateFiles = function (fileList) {
                    if (fileList) {
                        for (var i = 0; i < fileList.length; i++) {
                            var file = fileList.item(i);
                            if (this.attachmentFiles.filter(function (_file) {
                                return _file.fileName === file.name;
                            }).length === 0) {
                                var attachmentFile = new AttachmentFile();
                                attachmentFile.file = file;
                                attachmentFile.fileName = file.name;
                                attachmentFile.fileSize = file.size;
                                this.attachmentFiles.push(attachmentFile);
                            }
                        }
                        var selectedFiles = this.attachmentFiles.filter(function (_file) {
                            return !_file.sizeError;
                        }).map(function (_file) {
                            return _file.file;
                        });
                        this.filesSelected.emit(selectedFiles);
                        if (this.directUpload) {
                            this.attachmentFiles = new Array();
                        }
                    }
                };
                AttachmentsComponent.prototype.remove = function (file) {
                    this.attachmentFiles = this.attachmentFiles.filter(function (_file) {
                        return _file !== file;
                    });
                };
                Object.defineProperty(AttachmentsComponent.prototype, "disabled", {
                    get: function () {
                        return this.element.nativeElement.getAttribute('disabled') === 'disabled';
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AttachmentsComponent.prototype, "showAttachmentList", {
                    get: function () {
                        return !this.directUpload && this.attachmentFiles.length > 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                __decorate([core_1.Input(), __metadata("design:type", String)], AttachmentsComponent.prototype, "id", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Object)], AttachmentsComponent.prototype, "directUpload", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], AttachmentsComponent.prototype, "filesSelected", void 0);
                AttachmentsComponent = __decorate([core_1.Component({
                    directives: [constants_1.AGS_DIRECTIVES],
                    pipes: [constants_1.AGS_PIPES],
                    selector: 'attachments',
                    templateUrl: 'ags-client/app/components/attachments_component.html'
                }), __metadata("design:paramtypes", [alert_service_1.AlertService, translation_service_1.TranslationService, core_1.ElementRef])], AttachmentsComponent);
                return AttachmentsComponent;
            }(abstract_component_1.AbstractComponent);
            exports_1("AttachmentsComponent", AttachmentsComponent);
        }
    };
});

System.register("ags-client/app/components/fileupload_component.js", ["angular2/core.js", "ags-client/app/constants.js", "ags-client/app/services/alert_service.js", "ags-client/app/services/translation_service.js", "ags-client/app/components/abstract_component.js", "ags-client/app/commons/html.js", "ags-client/app/components/attachments_component.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, constants_1, alert_service_1, translation_service_1, abstract_component_1, html_1, attachments_component_1, FileuploadComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (constants_1_1) {
            constants_1 = constants_1_1;
        }, function (alert_service_1_1) {
            alert_service_1 = alert_service_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }, function (abstract_component_1_1) {
            abstract_component_1 = abstract_component_1_1;
        }, function (html_1_1) {
            html_1 = html_1_1;
        }, function (attachments_component_1_1) {
            attachments_component_1 = attachments_component_1_1;
        }],
        execute: function () {
            FileuploadComponent = /** @class */function (_super) {
                __extends(FileuploadComponent, _super);
                function FileuploadComponent(alertService, translationService, element) {
                    var _this = _super.call(this, alertService, translationService, element) || this;
                    _this.directUpload = false;
                    _this.fileSelected = new core_1.EventEmitter();
                    _this.dragover = function (event) {
                        html_1.appendClass(_this.dropzone, 'attachment-dropzone-hover');
                        event.stopPropagation();
                        event.preventDefault();
                        event.dataTransfer.dropEffect = 'copy';
                    };
                    _this.dragenter = function (event) {
                        event.stopPropagation();
                        event.preventDefault();
                    };
                    _this.dragleave = function (event) {
                        html_1.removeClass(_this.dropzone, 'attachment-dropzone-hover');
                        event.stopPropagation();
                        event.preventDefault();
                    };
                    _this.drop = function (event) {
                        html_1.removeClass(_this.dropzone, 'attachment-dropzone-hover');
                        _this._updateFile(event.dataTransfer.files.item(0));
                        event.stopPropagation();
                        event.preventDefault();
                    };
                    _this.selected = function () {
                        _this._updateFile(_this.fileSelect.files.item(0));
                    };
                    return _this;
                }
                FileuploadComponent.prototype.ngAfterViewInit = function () {
                    this.dropzone = this.element.nativeElement.querySelector('.attachment-dropzone');
                    this.dropzone.addEventListener('dragover', this.dragover);
                    this.dropzone.addEventListener('dragenter', this.dragenter);
                    this.dropzone.addEventListener('dragleave', this.dragleave);
                    this.dropzone.addEventListener('drop', this.drop);
                    this.dropzone.querySelector('input').addEventListener('change', this.selected);
                };
                FileuploadComponent.prototype.browse = function () {
                    this.fileSelect.click();
                };
                Object.defineProperty(FileuploadComponent.prototype, "fileSelect", {
                    get: function () {
                        return this.dropzone.querySelector('input');
                    },
                    enumerable: false,
                    configurable: true
                });
                FileuploadComponent.prototype._updateFile = function (file) {
                    if (file) {
                        var attachmentFile = new attachments_component_1.AttachmentFile();
                        attachmentFile.file = file;
                        attachmentFile.fileName = file.name;
                        attachmentFile.fileSize = file.size;
                        this.uploadedFile = attachmentFile;
                        this.fileSelected.emit(this.uploadedFile.file);
                        if (this.directUpload) {
                            this.uploadedFile = null;
                        }
                    }
                };
                FileuploadComponent.prototype.remove = function (file) {
                    this.uploadedFile = null;
                };
                Object.defineProperty(FileuploadComponent.prototype, "disabled", {
                    get: function () {
                        return this.element.nativeElement.getAttribute('disabled') === 'disabled';
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(FileuploadComponent.prototype, "showUploadedFile", {
                    get: function () {
                        return !this.directUpload && this.uploadedFile != null;
                    },
                    enumerable: false,
                    configurable: true
                });
                __decorate([core_1.Input(), __metadata("design:type", String)], FileuploadComponent.prototype, "id", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Object)], FileuploadComponent.prototype, "directUpload", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], FileuploadComponent.prototype, "fileSelected", void 0);
                FileuploadComponent = __decorate([core_1.Component({
                    directives: [constants_1.AGS_DIRECTIVES],
                    pipes: [constants_1.AGS_PIPES],
                    selector: 'fileupload',
                    templateUrl: 'ags-client/app/components/fileupload_component.html'
                }), __metadata("design:paramtypes", [alert_service_1.AlertService, translation_service_1.TranslationService, core_1.ElementRef])], FileuploadComponent);
                return FileuploadComponent;
            }(abstract_component_1.AbstractComponent);
            exports_1("FileuploadComponent", FileuploadComponent);
        }
    };
});

System.register("ags-client/gen/components.js", ["ags-client/app/components/account_form_component.js", "ags-client/app/components/authentication_form_component.js", "ags-client/app/components/change_password_form_component.js", "ags-client/app/components/lost_password_form_component.js", "ags-client/app/components/registration_form_component.js", "ags-client/app/components/category_form_component.js", "ags-client/app/components/category_table_component.js", "ags-client/app/components/code_table_component.js", "ags-client/app/components/code_form_component.js", "ags-client/app/components/darate_table_component.js", "ags-client/app/components/darate_form_component.js", "ags-client/app/components/darate_scope_form_component.js", "ags-client/app/components/domain_form_component.js", "ags-client/app/components/domain_table_component.js", "ags-client/app/components/system_parameter_form_component.js", "ags-client/app/components/system_parameter_table_component.js", "ags-client/app/components/role_table_component.js", "ags-client/app/components/role_form_component.js", "ags-client/app/components/file_component.js", "ags-client/app/components/attachments_component.js", "ags-client/app/components/fileupload_component.js"], function (exports_1, context_1) {
    "use strict";

    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (account_form_component_1_1) {
            exports_1({
                "AccountFormComponent": account_form_component_1_1["AccountFormComponent"]
            });
        }, function (authentication_form_component_1_1) {
            exports_1({
                "AuthenticationFormComponent": authentication_form_component_1_1["AuthenticationFormComponent"]
            });
        }, function (change_password_form_component_1_1) {
            exports_1({
                "ChangePasswordFormComponent": change_password_form_component_1_1["ChangePasswordFormComponent"]
            });
        }, function (lost_password_form_component_1_1) {
            exports_1({
                "LostPasswordFormComponent": lost_password_form_component_1_1["LostPasswordFormComponent"]
            });
        }, function (registration_form_component_1_1) {
            exports_1({
                "RegistrationFormComponent": registration_form_component_1_1["RegistrationFormComponent"]
            });
        }, function (category_form_component_1_1) {
            exports_1({
                "CategoryFormComponent": category_form_component_1_1["CategoryFormComponent"]
            });
        }, function (category_table_component_1_1) {
            exports_1({
                "CategoryTableComponent": category_table_component_1_1["CategoryTableComponent"]
            });
        }, function (code_table_component_1_1) {
            exports_1({
                "CodeTableComponent": code_table_component_1_1["CodeTableComponent"]
            });
        }, function (code_form_component_1_1) {
            exports_1({
                "CodeFormComponent": code_form_component_1_1["CodeFormComponent"]
            });
        }, function (darate_table_component_1_1) {
            exports_1({
                "DarateTableComponent": darate_table_component_1_1["DarateTableComponent"]
            });
        }, function (darate_form_component_1_1) {
            exports_1({
                "DarateFormComponent": darate_form_component_1_1["DarateFormComponent"]
            });
        }, function (darate_scope_form_component_1_1) {
            exports_1({
                "DarateScopeFormComponent": darate_scope_form_component_1_1["DarateScopeFormComponent"]
            });
        }, function (domain_form_component_1_1) {
            exports_1({
                "DomainFormComponent": domain_form_component_1_1["DomainFormComponent"]
            });
        }, function (domain_table_component_1_1) {
            exports_1({
                "DomainTableComponent": domain_table_component_1_1["DomainTableComponent"]
            });
        }, function (system_parameter_form_component_1_1) {
            exports_1({
                "SystemParameterFormComponent": system_parameter_form_component_1_1["SystemParameterFormComponent"]
            });
        }, function (system_parameter_table_component_1_1) {
            exports_1({
                "SystemParameterTableComponent": system_parameter_table_component_1_1["SystemParameterTableComponent"]
            });
        }, function (role_table_component_1_1) {
            exports_1({
                "RoleTableComponent": role_table_component_1_1["RoleTableComponent"]
            });
        }, function (role_form_component_1_1) {
            exports_1({
                "RoleFormComponent": role_form_component_1_1["RoleFormComponent"]
            });
        }, function (file_component_1_1) {
            exports_1({
                "FileComponent": file_component_1_1["FileComponent"]
            });
        }, function (attachments_component_1_1) {
            exports_1({
                "AttachmentsComponent": attachments_component_1_1["AttachmentsComponent"]
            });
        }, function (fileupload_component_1_1) {
            exports_1({
                "FileuploadComponent": fileupload_component_1_1["FileuploadComponent"]
            });
        }],
        execute: function () {}
    };
});

System.register("ags-client/gen/viewmodels/search_entity_view_model.js", ["ags-client/app/commons/lang.js"], function (exports_1, context_1) {
    "use strict";

    var lang_1, SearchEntityViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (lang_1_1) {
            lang_1 = lang_1_1;
        }],
        execute: function () {
            SearchEntityViewModel = /** @class */function () {
                function SearchEntityViewModel() {}
                SearchEntityViewModel.deserialize = function (object) {
                    var _result = new SearchEntityViewModel();
                    return _result._deserialize(object);
                };
                SearchEntityViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (lang_1.isPresent(object['id'])) {
                            this.id = object['id'];
                        }
                    }
                    return this;
                };
                SearchEntityViewModel.prototype.serialize = function () {
                    var object = {};
                    if (lang_1.isPresent(this.id)) {
                        object['id'] = this.id;
                    }
                    return object;
                };
                SearchEntityViewModel.ID_VALIDATORS = [];
                return SearchEntityViewModel;
            }();
            exports_1("SearchEntityViewModel", SearchEntityViewModel);
        }
    };
});

System.register("ags-client/gen/viewmodels/application_information_view_model.js", ["ags-client/app/commons/lang.js"], function (exports_1, context_1) {
    "use strict";

    var lang_1, ApplicationInformationViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (lang_1_1) {
            lang_1 = lang_1_1;
        }],
        execute: function () {
            ApplicationInformationViewModel = /** @class */function () {
                function ApplicationInformationViewModel() {}
                ApplicationInformationViewModel.deserialize = function (object) {
                    var _result = new ApplicationInformationViewModel();
                    return _result._deserialize(object);
                };
                ApplicationInformationViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (lang_1.isPresent(object['version'])) {
                            this.version = object['version'];
                        }
                    }
                    return this;
                };
                ApplicationInformationViewModel.prototype.serialize = function () {
                    var object = {};
                    if (lang_1.isPresent(this.version)) {
                        object['version'] = this.version;
                    }
                    return object;
                };
                ApplicationInformationViewModel.VERSION_VALIDATORS = [];
                return ApplicationInformationViewModel;
            }();
            exports_1("ApplicationInformationViewModel", ApplicationInformationViewModel);
        }
    };
});

System.register("ags-client/gen/viewmodels/extended_application_information_view_model.js", ["ags-client/app/commons/lang.js", "ags-client/gen/viewmodels/application_information_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var lang_1, application_information_view_model_1, ExtendedApplicationInformationViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (lang_1_1) {
            lang_1 = lang_1_1;
        }, function (application_information_view_model_1_1) {
            application_information_view_model_1 = application_information_view_model_1_1;
        }],
        execute: function () {
            ExtendedApplicationInformationViewModel = /** @class */function (_super) {
                __extends(ExtendedApplicationInformationViewModel, _super);
                function ExtendedApplicationInformationViewModel() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                ExtendedApplicationInformationViewModel.deserialize = function (object) {
                    var _result = new ExtendedApplicationInformationViewModel();
                    return _result._deserialize(object);
                };
                ExtendedApplicationInformationViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        _super.prototype._deserialize.call(this, object);
                        if (lang_1.isPresent(object['buildTime'])) {
                            this.buildTime = object['buildTime'];
                        }
                        if (lang_1.isPresent(object['database'])) {
                            this.database = object['database'];
                        }
                        if (lang_1.isPresent(object['runnerOS'])) {
                            this.runnerOS = object['runnerOS'];
                        }
                        if (lang_1.isPresent(object['jdkVersion'])) {
                            this.jdkVersion = object['jdkVersion'];
                        }
                        if (lang_1.isPresent(object['tomcatVersion'])) {
                            this.tomcatVersion = object['tomcatVersion'];
                        }
                    }
                    return this;
                };
                ExtendedApplicationInformationViewModel.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (lang_1.isPresent(this.buildTime)) {
                        object['buildTime'] = this.buildTime;
                    }
                    if (lang_1.isPresent(this.database)) {
                        object['database'] = this.database;
                    }
                    if (lang_1.isPresent(this.runnerOS)) {
                        object['runnerOS'] = this.runnerOS;
                    }
                    if (lang_1.isPresent(this.jdkVersion)) {
                        object['jdkVersion'] = this.jdkVersion;
                    }
                    if (lang_1.isPresent(this.tomcatVersion)) {
                        object['tomcatVersion'] = this.tomcatVersion;
                    }
                    return object;
                };
                ExtendedApplicationInformationViewModel.BUILD_TIME_VALIDATORS = [];
                ExtendedApplicationInformationViewModel.DATABASE_VALIDATORS = [];
                ExtendedApplicationInformationViewModel.RUNNER_O_S_VALIDATORS = [];
                ExtendedApplicationInformationViewModel.JDK_VERSION_VALIDATORS = [];
                ExtendedApplicationInformationViewModel.TOMCAT_VERSION_VALIDATORS = [];
                return ExtendedApplicationInformationViewModel;
            }(application_information_view_model_1.ApplicationInformationViewModel);
            exports_1("ExtendedApplicationInformationViewModel", ExtendedApplicationInformationViewModel);
        }
    };
});

System.register("ags-client/gen/viewmodels/account_view_model.js", ["ags-client/app/commons/lang.js", "ags-client/gen/viewmodels/entity_view_model.js", "ags-client/app/validators.js", "ags-client/gen/enums.js", "ags-client/app/commons.js", "ags-client/gen/codes.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var lang_1, entity_view_model_1, Validators, enums_1, commons_1, codes_1, codes_2, AccountViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (lang_1_1) {
            lang_1 = lang_1_1;
        }, function (entity_view_model_1_1) {
            entity_view_model_1 = entity_view_model_1_1;
        }, function (Validators_1) {
            Validators = Validators_1;
        }, function (enums_1_1) {
            enums_1 = enums_1_1;
        }, function (commons_1_1) {
            commons_1 = commons_1_1;
        }, function (codes_1_1) {
            codes_1 = codes_1_1;
            codes_2 = codes_1_1;
        }],
        execute: function () {
            AccountViewModel = /** @class */function (_super) {
                __extends(AccountViewModel, _super);
                function AccountViewModel() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                AccountViewModel.deserialize = function (object) {
                    var _result = new AccountViewModel();
                    return _result._deserialize(object);
                };
                AccountViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        _super.prototype._deserialize.call(this, object);
                        if (lang_1.isPresent(object['salutation'])) {
                            this.salutation = commons_1.enumNumberValue(enums_1.Salutation, object['salutation']);
                        }
                        if (lang_1.isPresent(object['institution'])) {
                            this.institution = object['institution'];
                        }
                        if (lang_1.isPresent(object['firstName'])) {
                            this.firstName = object['firstName'];
                        }
                        if (lang_1.isPresent(object['lastName'])) {
                            this.lastName = object['lastName'];
                        }
                        if (lang_1.isPresent(object['language'])) {
                            this.language = new codes_1.Language(object['language']['shortName']);
                        }
                        if (lang_1.isPresent(object['receiveEmail'])) {
                            this.receiveEmail = object['receiveEmail'];
                        }
                        if (lang_1.isPresent(object['receiveEmailNoPublication'])) {
                            this.receiveEmailNoPublication = object['receiveEmailNoPublication'];
                        }
                        if (lang_1.isPresent(object['newsletter'])) {
                            this.newsletter = object['newsletter'];
                        }
                        if (lang_1.isPresent(object['street'])) {
                            this.street = object['street'];
                        }
                        if (lang_1.isPresent(object['zip'])) {
                            this.zip = object['zip'];
                        }
                        if (lang_1.isPresent(object['country'])) {
                            this.country = new codes_2.Country(object['country']['shortName']);
                        }
                        if (lang_1.isPresent(object['city'])) {
                            this.city = object['city'];
                        }
                        if (lang_1.isPresent(object['phone'])) {
                            this.phone = object['phone'];
                        }
                        if (lang_1.isPresent(object['mobile'])) {
                            this.mobile = object['mobile'];
                        }
                        if (lang_1.isPresent(object['fax'])) {
                            this.fax = object['fax'];
                        }
                        if (lang_1.isPresent(object['email'])) {
                            this.email = object['email'];
                        }
                    }
                    return this;
                };
                AccountViewModel.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (lang_1.isPresent(this.salutation)) {
                        object['salutation'] = enums_1.Salutation[this.salutation];
                    }
                    if (lang_1.isPresent(this.institution)) {
                        object['institution'] = this.institution;
                    }
                    if (lang_1.isPresent(this.firstName)) {
                        object['firstName'] = this.firstName;
                    }
                    if (lang_1.isPresent(this.lastName)) {
                        object['lastName'] = this.lastName;
                    }
                    if (lang_1.isPresent(this.language)) {
                        object['language'] = this.language;
                    }
                    if (lang_1.isPresent(this.receiveEmail)) {
                        object['receiveEmail'] = this.receiveEmail;
                    }
                    if (lang_1.isPresent(this.receiveEmailNoPublication)) {
                        object['receiveEmailNoPublication'] = this.receiveEmailNoPublication;
                    }
                    if (lang_1.isPresent(this.newsletter)) {
                        object['newsletter'] = this.newsletter;
                    }
                    if (lang_1.isPresent(this.street)) {
                        object['street'] = this.street;
                    }
                    if (lang_1.isPresent(this.zip)) {
                        object['zip'] = this.zip;
                    }
                    if (lang_1.isPresent(this.country)) {
                        object['country'] = this.country;
                    }
                    if (lang_1.isPresent(this.city)) {
                        object['city'] = this.city;
                    }
                    if (lang_1.isPresent(this.phone)) {
                        object['phone'] = this.phone;
                    }
                    if (lang_1.isPresent(this.mobile)) {
                        object['mobile'] = this.mobile;
                    }
                    if (lang_1.isPresent(this.fax)) {
                        object['fax'] = this.fax;
                    }
                    if (lang_1.isPresent(this.email)) {
                        object['email'] = this.email;
                    }
                    return object;
                };
                AccountViewModel.SALUTATION_VALIDATORS = [];
                AccountViewModel.INSTITUTION_VALIDATORS = [Validators.max(120)];
                AccountViewModel.FIRST_NAME_VALIDATORS = [Validators.max(40)];
                AccountViewModel.LAST_NAME_VALIDATORS = [Validators.max(40)];
                AccountViewModel.LANGUAGE_VALIDATORS = [Validators.required()];
                AccountViewModel.RECEIVE_EMAIL_VALIDATORS = [];
                AccountViewModel.RECEIVE_EMAIL_NO_PUBLICATION_VALIDATORS = [];
                AccountViewModel.NEWSLETTER_VALIDATORS = [];
                AccountViewModel.STREET_VALIDATORS = [Validators.max(40)];
                AccountViewModel.ZIP_VALIDATORS = [Validators.max(12)];
                AccountViewModel.COUNTRY_VALIDATORS = [Validators.required()];
                AccountViewModel.CITY_VALIDATORS = [Validators.max(40)];
                AccountViewModel.PHONE_VALIDATORS = [Validators.max(20)];
                AccountViewModel.MOBILE_VALIDATORS = [Validators.max(20)];
                AccountViewModel.FAX_VALIDATORS = [Validators.max(20)];
                AccountViewModel.EMAIL_VALIDATORS = [Validators.required(), Validators.email()];
                return AccountViewModel;
            }(entity_view_model_1.EntityViewModel);
            exports_1("AccountViewModel", AccountViewModel);
        }
    };
});

System.register("ags-client/gen/viewmodels/authentication_view_model.js", ["ags-client/app/commons/lang.js", "ags-client/app/validators.js"], function (exports_1, context_1) {
    "use strict";

    var lang_1, Validators, AuthenticationViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (lang_1_1) {
            lang_1 = lang_1_1;
        }, function (Validators_1) {
            Validators = Validators_1;
        }],
        execute: function () {
            AuthenticationViewModel = /** @class */function () {
                function AuthenticationViewModel() {}
                AuthenticationViewModel.deserialize = function (object) {
                    var _result = new AuthenticationViewModel();
                    return _result._deserialize(object);
                };
                AuthenticationViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (lang_1.isPresent(object['login'])) {
                            this.login = object['login'];
                        }
                        if (lang_1.isPresent(object['password'])) {
                            this.password = object['password'];
                        }
                        if (lang_1.isPresent(object['captcha'])) {
                            this.captcha = object['captcha'];
                        }
                    }
                    return this;
                };
                AuthenticationViewModel.prototype.serialize = function () {
                    var object = {};
                    if (lang_1.isPresent(this.login)) {
                        object['login'] = this.login;
                    }
                    if (lang_1.isPresent(this.password)) {
                        object['password'] = this.password;
                    }
                    if (lang_1.isPresent(this.captcha)) {
                        object['captcha'] = this.captcha;
                    }
                    return object;
                };
                AuthenticationViewModel.LOGIN_VALIDATORS = [Validators.max(64), Validators.required()];
                AuthenticationViewModel.PASSWORD_VALIDATORS = [Validators.max(256), Validators.required()];
                AuthenticationViewModel.CAPTCHA_VALIDATORS = [Validators.required()];
                return AuthenticationViewModel;
            }();
            exports_1("AuthenticationViewModel", AuthenticationViewModel);
        }
    };
});

System.register("ags-client/gen/viewmodels/change_password_view_model.js", ["ags-client/app/commons/lang.js", "ags-client/app/validators.js"], function (exports_1, context_1) {
    "use strict";

    var lang_1, Validators, ChangePasswordViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (lang_1_1) {
            lang_1 = lang_1_1;
        }, function (Validators_1) {
            Validators = Validators_1;
        }],
        execute: function () {
            ChangePasswordViewModel = /** @class */function () {
                function ChangePasswordViewModel() {}
                ChangePasswordViewModel.deserialize = function (object) {
                    var _result = new ChangePasswordViewModel();
                    return _result._deserialize(object);
                };
                ChangePasswordViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (lang_1.isPresent(object['login'])) {
                            this.login = object['login'];
                        }
                        if (lang_1.isPresent(object['oldPassword'])) {
                            this.oldPassword = object['oldPassword'];
                        }
                        if (lang_1.isPresent(object['newPassword'])) {
                            this.newPassword = object['newPassword'];
                        }
                        if (lang_1.isPresent(object['passwordRepeat'])) {
                            this.passwordRepeat = object['passwordRepeat'];
                        }
                    }
                    return this;
                };
                ChangePasswordViewModel.prototype.serialize = function () {
                    var object = {};
                    if (lang_1.isPresent(this.login)) {
                        object['login'] = this.login;
                    }
                    if (lang_1.isPresent(this.oldPassword)) {
                        object['oldPassword'] = this.oldPassword;
                    }
                    if (lang_1.isPresent(this.newPassword)) {
                        object['newPassword'] = this.newPassword;
                    }
                    if (lang_1.isPresent(this.passwordRepeat)) {
                        object['passwordRepeat'] = this.passwordRepeat;
                    }
                    return object;
                };
                ChangePasswordViewModel.LOGIN_VALIDATORS = [Validators.max(64), Validators.required()];
                ChangePasswordViewModel.OLD_PASSWORD_VALIDATORS = [Validators.max(256), Validators.required()];
                ChangePasswordViewModel.NEW_PASSWORD_VALIDATORS = [Validators.max(256), Validators.required()];
                ChangePasswordViewModel.PASSWORD_REPEAT_VALIDATORS = [Validators.max(256), Validators.required()];
                return ChangePasswordViewModel;
            }();
            exports_1("ChangePasswordViewModel", ChangePasswordViewModel);
        }
    };
});

System.register("ags-client/gen/viewmodels/session_view_model.js", ["ags-client/app/commons/lang.js"], function (exports_1, context_1) {
    "use strict";

    var lang_1, SessionViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (lang_1_1) {
            lang_1 = lang_1_1;
        }],
        execute: function () {
            SessionViewModel = /** @class */function () {
                function SessionViewModel() {}
                SessionViewModel.deserialize = function (object) {
                    var _result = new SessionViewModel();
                    return _result._deserialize(object);
                };
                SessionViewModel.prototype._deserialize = function (object) {
                    var _this = this;
                    if (object) {
                        if (lang_1.isPresent(object['timeout'])) {
                            this.timeout = object['timeout'];
                        }
                        if (lang_1.isPresent(object['sessionId'])) {
                            this.sessionId = object['sessionId'];
                        }
                        if (lang_1.isPresent(object['login'])) {
                            this.login = object['login'];
                        }
                        if (lang_1.isPresent(object['name'])) {
                            this.name = object['name'];
                        }
                        if (lang_1.isPresent(object['permissions'])) {
                            this.permissions = [];
                            object['permissions'].forEach(function (item) {
                                _this.permissions.push(item);
                            });
                        }
                        if (lang_1.isPresent(object['authenticated'])) {
                            this.authenticated = object['authenticated'];
                        }
                        if (lang_1.isPresent(object['language'])) {
                            this.language = object['language'];
                        }
                        if (lang_1.isPresent(object['csrfToken'])) {
                            this.csrfToken = object['csrfToken'];
                        }
                        if (lang_1.isPresent(object['role'])) {
                            this.role = object['role'];
                        }
                    }
                    return this;
                };
                SessionViewModel.prototype.serialize = function () {
                    var object = {};
                    if (lang_1.isPresent(this.timeout)) {
                        object['timeout'] = this.timeout;
                    }
                    if (lang_1.isPresent(this.sessionId)) {
                        object['sessionId'] = this.sessionId;
                    }
                    if (lang_1.isPresent(this.login)) {
                        object['login'] = this.login;
                    }
                    if (lang_1.isPresent(this.name)) {
                        object['name'] = this.name;
                    }
                    if (lang_1.isPresent(this.permissions)) {
                        object['permissions'] = [];
                        this.permissions.forEach(function (item) {
                            object['permissions'].push(item);
                        });
                    }
                    if (lang_1.isPresent(this.authenticated)) {
                        object['authenticated'] = this.authenticated;
                    }
                    if (lang_1.isPresent(this.language)) {
                        object['language'] = this.language;
                    }
                    if (lang_1.isPresent(this.csrfToken)) {
                        object['csrfToken'] = this.csrfToken;
                    }
                    if (lang_1.isPresent(this.role)) {
                        object['role'] = this.role;
                    }
                    return object;
                };
                SessionViewModel.TIMEOUT_VALIDATORS = [];
                SessionViewModel.SESSION_ID_VALIDATORS = [];
                SessionViewModel.LOGIN_VALIDATORS = [];
                SessionViewModel.NAME_VALIDATORS = [];
                SessionViewModel.PERMISSIONS_VALIDATORS = [];
                SessionViewModel.AUTHENTICATED_VALIDATORS = [];
                SessionViewModel.LANGUAGE_VALIDATORS = [];
                SessionViewModel.CSRF_TOKEN_VALIDATORS = [];
                SessionViewModel.ROLE_VALIDATORS = [];
                return SessionViewModel;
            }();
            exports_1("SessionViewModel", SessionViewModel);
        }
    };
});

System.register("ags-client/gen/viewmodels/darate_view_model.js", ["ags-client/app/commons/lang.js", "ags-client/gen/viewmodels/entity_view_model.js", "ags-client/app/validators.js", "ags-client/gen/codes.js", "ags-client/gen/enums.js", "ags-client/app/commons.js", "ags-client/gen/viewmodels/darate_scope_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var lang_1, entity_view_model_1, Validators, codes_1, enums_1, commons_1, enums_2, enums_3, darate_scope_view_model_1, DarateViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (lang_1_1) {
            lang_1 = lang_1_1;
        }, function (entity_view_model_1_1) {
            entity_view_model_1 = entity_view_model_1_1;
        }, function (Validators_1) {
            Validators = Validators_1;
        }, function (codes_1_1) {
            codes_1 = codes_1_1;
        }, function (enums_1_1) {
            enums_1 = enums_1_1;
            enums_2 = enums_1_1;
            enums_3 = enums_1_1;
        }, function (commons_1_1) {
            commons_1 = commons_1_1;
        }, function (darate_scope_view_model_1_1) {
            darate_scope_view_model_1 = darate_scope_view_model_1_1;
        }],
        execute: function () {
            DarateViewModel = /** @class */function (_super) {
                __extends(DarateViewModel, _super);
                function DarateViewModel() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                DarateViewModel.deserialize = function (object) {
                    var _result = new DarateViewModel();
                    return _result._deserialize(object);
                };
                DarateViewModel.prototype._deserialize = function (object) {
                    var _this = this;
                    if (object) {
                        _super.prototype._deserialize.call(this, object);
                        if (lang_1.isPresent(object['country'])) {
                            this.country = new codes_1.Country(object['country']['shortName']);
                        }
                        if (lang_1.isPresent(object['instrumentGroup'])) {
                            this.instrumentGroup = commons_1.enumNumberValue(enums_1.InstrumentGroup, object['instrumentGroup']);
                        }
                        if (lang_1.isPresent(object['instrumentType'])) {
                            this.instrumentType = commons_1.enumNumberValue(enums_2.InstrumentType, object['instrumentType']);
                        }
                        if (lang_1.isPresent(object['active'])) {
                            this.active = object['active'];
                        }
                        if (lang_1.isPresent(object['darateType'])) {
                            this.darateType = commons_1.enumNumberValue(enums_3.DARateType, object['darateType']);
                        }
                        if (lang_1.isPresent(object['scopes'])) {
                            this.scopes = [];
                            object['scopes'].forEach(function (item) {
                                _this.scopes.push(darate_scope_view_model_1.DarateScopeViewModel.deserialize(item));
                            });
                        }
                    }
                    return this;
                };
                DarateViewModel.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (lang_1.isPresent(this.country)) {
                        object['country'] = this.country;
                    }
                    if (lang_1.isPresent(this.instrumentGroup)) {
                        object['instrumentGroup'] = enums_1.InstrumentGroup[this.instrumentGroup];
                    }
                    if (lang_1.isPresent(this.instrumentType)) {
                        object['instrumentType'] = enums_2.InstrumentType[this.instrumentType];
                    }
                    if (lang_1.isPresent(this.active)) {
                        object['active'] = this.active;
                    }
                    if (lang_1.isPresent(this.darateType)) {
                        object['darateType'] = enums_3.DARateType[this.darateType];
                    }
                    if (lang_1.isPresent(this.scopes)) {
                        object['scopes'] = [];
                        this.scopes.forEach(function (item) {
                            object['scopes'].push(item.serialize());
                        });
                    }
                    return object;
                };
                DarateViewModel.COUNTRY_VALIDATORS = [Validators.required()];
                DarateViewModel.INSTRUMENT_GROUP_VALIDATORS = [Validators.required()];
                DarateViewModel.INSTRUMENT_TYPE_VALIDATORS = [];
                DarateViewModel.ACTIVE_VALIDATORS = [];
                DarateViewModel.DARATE_TYPE_VALIDATORS = [Validators.required()];
                DarateViewModel.SCOPES_VALIDATORS = [];
                return DarateViewModel;
            }(entity_view_model_1.EntityViewModel);
            exports_1("DarateViewModel", DarateViewModel);
        }
    };
});

System.register("ags-client/gen/viewmodels/scope_view_model.js", ["ags-client/app/commons/lang.js", "ags-client/app/validators.js"], function (exports_1, context_1) {
    "use strict";

    var lang_1, Validators, lang_2, lang_3, ScopeViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (lang_1_1) {
            lang_1 = lang_1_1;
            lang_2 = lang_1_1;
            lang_3 = lang_1_1;
        }, function (Validators_1) {
            Validators = Validators_1;
        }],
        execute: function () {
            ScopeViewModel = /** @class */function () {
                function ScopeViewModel() {}
                ScopeViewModel.deserialize = function (object) {
                    var _result = new ScopeViewModel();
                    return _result._deserialize(object);
                };
                ScopeViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (lang_1.isPresent(object['validFrom'])) {
                            this.validFrom = lang_3.deserializeDate(object['validFrom']);
                        }
                        if (lang_1.isPresent(object['validTo'])) {
                            this.validTo = lang_3.deserializeDate(object['validTo']);
                        }
                    }
                    return this;
                };
                ScopeViewModel.prototype.serialize = function () {
                    var object = {};
                    if (lang_1.isPresent(this.validFrom)) {
                        object['validFrom'] = lang_2.serializeDate(this.validFrom);
                    }
                    if (lang_1.isPresent(this.validTo)) {
                        object['validTo'] = lang_2.serializeDate(this.validTo);
                    }
                    return object;
                };
                ScopeViewModel.VALID_FROM_VALIDATORS = [Validators.date, Validators.required()];
                ScopeViewModel.VALID_TO_VALIDATORS = [];
                return ScopeViewModel;
            }();
            exports_1("ScopeViewModel", ScopeViewModel);
        }
    };
});

System.register("ags-client/gen/viewmodels/darate_scope_view_model.js", ["ags-client/app/commons/lang.js", "ags-client/gen/viewmodels/scope_view_model.js", "ags-client/app/validators.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var lang_1, scope_view_model_1, Validators, DarateScopeViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (lang_1_1) {
            lang_1 = lang_1_1;
        }, function (scope_view_model_1_1) {
            scope_view_model_1 = scope_view_model_1_1;
        }, function (Validators_1) {
            Validators = Validators_1;
        }],
        execute: function () {
            DarateScopeViewModel = /** @class */function (_super) {
                __extends(DarateScopeViewModel, _super);
                function DarateScopeViewModel() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                DarateScopeViewModel.deserialize = function (object) {
                    var _result = new DarateScopeViewModel();
                    return _result._deserialize(object);
                };
                DarateScopeViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        _super.prototype._deserialize.call(this, object);
                        if (lang_1.isPresent(object['rate'])) {
                            this.rate = object['rate'];
                        }
                        if (lang_1.isPresent(object['release'])) {
                            this.release = object['release'];
                        }
                        if (lang_1.isPresent(object['nonRecoverable'])) {
                            this.nonRecoverable = object['nonRecoverable'];
                        }
                    }
                    return this;
                };
                DarateScopeViewModel.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (lang_1.isPresent(this.rate)) {
                        object['rate'] = this.rate;
                    }
                    if (lang_1.isPresent(this.release)) {
                        object['release'] = this.release;
                    }
                    if (lang_1.isPresent(this.nonRecoverable)) {
                        object['nonRecoverable'] = this.nonRecoverable;
                    }
                    return object;
                };
                DarateScopeViewModel.RATE_VALIDATORS = [Validators.required()];
                DarateScopeViewModel.RELEASE_VALIDATORS = [];
                DarateScopeViewModel.NON_RECOVERABLE_VALIDATORS = [];
                return DarateScopeViewModel;
            }(scope_view_model_1.ScopeViewModel);
            exports_1("DarateScopeViewModel", DarateScopeViewModel);
        }
    };
});

System.register("ags-client/gen/viewmodels/registration_view_model.js", ["ags-client/app/commons/lang.js", "ags-client/app/validators.js", "ags-client/gen/enums.js", "ags-client/app/commons.js", "ags-client/gen/codes.js"], function (exports_1, context_1) {
    "use strict";

    var lang_1, Validators, enums_1, commons_1, codes_1, codes_2, RegistrationViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (lang_1_1) {
            lang_1 = lang_1_1;
        }, function (Validators_1) {
            Validators = Validators_1;
        }, function (enums_1_1) {
            enums_1 = enums_1_1;
        }, function (commons_1_1) {
            commons_1 = commons_1_1;
        }, function (codes_1_1) {
            codes_1 = codes_1_1;
            codes_2 = codes_1_1;
        }],
        execute: function () {
            RegistrationViewModel = /** @class */function () {
                function RegistrationViewModel() {}
                RegistrationViewModel.deserialize = function (object) {
                    var _result = new RegistrationViewModel();
                    return _result._deserialize(object);
                };
                RegistrationViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (lang_1.isPresent(object['email'])) {
                            this.email = object['email'];
                        }
                        if (lang_1.isPresent(object['password'])) {
                            this.password = object['password'];
                        }
                        if (lang_1.isPresent(object['passwordRepeat'])) {
                            this.passwordRepeat = object['passwordRepeat'];
                        }
                        if (lang_1.isPresent(object['captcha'])) {
                            this.captcha = object['captcha'];
                        }
                        if (lang_1.isPresent(object['institution'])) {
                            this.institution = object['institution'];
                        }
                        if (lang_1.isPresent(object['salutation'])) {
                            this.salutation = commons_1.enumNumberValue(enums_1.Salutation, object['salutation']);
                        }
                        if (lang_1.isPresent(object['firstname'])) {
                            this.firstname = object['firstname'];
                        }
                        if (lang_1.isPresent(object['lastname'])) {
                            this.lastname = object['lastname'];
                        }
                        if (lang_1.isPresent(object['phone'])) {
                            this.phone = object['phone'];
                        }
                        if (lang_1.isPresent(object['mobile'])) {
                            this.mobile = object['mobile'];
                        }
                        if (lang_1.isPresent(object['city'])) {
                            this.city = object['city'];
                        }
                        if (lang_1.isPresent(object['language'])) {
                            this.language = new codes_1.Language(object['language']['shortName']);
                        }
                        if (lang_1.isPresent(object['country'])) {
                            this.country = new codes_2.Country(object['country']['shortName']);
                        }
                    }
                    return this;
                };
                RegistrationViewModel.prototype.serialize = function () {
                    var object = {};
                    if (lang_1.isPresent(this.email)) {
                        object['email'] = this.email;
                    }
                    if (lang_1.isPresent(this.password)) {
                        object['password'] = this.password;
                    }
                    if (lang_1.isPresent(this.passwordRepeat)) {
                        object['passwordRepeat'] = this.passwordRepeat;
                    }
                    if (lang_1.isPresent(this.captcha)) {
                        object['captcha'] = this.captcha;
                    }
                    if (lang_1.isPresent(this.institution)) {
                        object['institution'] = this.institution;
                    }
                    if (lang_1.isPresent(this.salutation)) {
                        object['salutation'] = enums_1.Salutation[this.salutation];
                    }
                    if (lang_1.isPresent(this.firstname)) {
                        object['firstname'] = this.firstname;
                    }
                    if (lang_1.isPresent(this.lastname)) {
                        object['lastname'] = this.lastname;
                    }
                    if (lang_1.isPresent(this.phone)) {
                        object['phone'] = this.phone;
                    }
                    if (lang_1.isPresent(this.mobile)) {
                        object['mobile'] = this.mobile;
                    }
                    if (lang_1.isPresent(this.city)) {
                        object['city'] = this.city;
                    }
                    if (lang_1.isPresent(this.language)) {
                        object['language'] = this.language;
                    }
                    if (lang_1.isPresent(this.country)) {
                        object['country'] = this.country;
                    }
                    return object;
                };
                RegistrationViewModel.EMAIL_VALIDATORS = [Validators.required(), Validators.email()];
                RegistrationViewModel.PASSWORD_VALIDATORS = [Validators.max(256), Validators.required()];
                RegistrationViewModel.PASSWORD_REPEAT_VALIDATORS = [Validators.max(256), Validators.required()];
                RegistrationViewModel.CAPTCHA_VALIDATORS = [Validators.required()];
                RegistrationViewModel.INSTITUTION_VALIDATORS = [Validators.max(120)];
                RegistrationViewModel.SALUTATION_VALIDATORS = [Validators.required()];
                RegistrationViewModel.FIRSTNAME_VALIDATORS = [Validators.required()];
                RegistrationViewModel.LASTNAME_VALIDATORS = [Validators.required()];
                RegistrationViewModel.PHONE_VALIDATORS = [Validators.max(20)];
                RegistrationViewModel.MOBILE_VALIDATORS = [Validators.max(20)];
                RegistrationViewModel.CITY_VALIDATORS = [Validators.max(40)];
                RegistrationViewModel.LANGUAGE_VALIDATORS = [Validators.required()];
                RegistrationViewModel.COUNTRY_VALIDATORS = [Validators.required()];
                return RegistrationViewModel;
            }();
            exports_1("RegistrationViewModel", RegistrationViewModel);
        }
    };
});

System.register("ags-client/gen/viewmodels/registration_activation_view_model.js", ["ags-client/app/commons/lang.js"], function (exports_1, context_1) {
    "use strict";

    var lang_1, RegistrationActivationViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (lang_1_1) {
            lang_1 = lang_1_1;
        }],
        execute: function () {
            RegistrationActivationViewModel = /** @class */function () {
                function RegistrationActivationViewModel() {}
                RegistrationActivationViewModel.deserialize = function (object) {
                    var _result = new RegistrationActivationViewModel();
                    return _result._deserialize(object);
                };
                RegistrationActivationViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (lang_1.isPresent(object['login'])) {
                            this.login = object['login'];
                        }
                        if (lang_1.isPresent(object['activationCode'])) {
                            this.activationCode = object['activationCode'];
                        }
                    }
                    return this;
                };
                RegistrationActivationViewModel.prototype.serialize = function () {
                    var object = {};
                    if (lang_1.isPresent(this.login)) {
                        object['login'] = this.login;
                    }
                    if (lang_1.isPresent(this.activationCode)) {
                        object['activationCode'] = this.activationCode;
                    }
                    return object;
                };
                RegistrationActivationViewModel.LOGIN_VALIDATORS = [];
                RegistrationActivationViewModel.ACTIVATION_CODE_VALIDATORS = [];
                return RegistrationActivationViewModel;
            }();
            exports_1("RegistrationActivationViewModel", RegistrationActivationViewModel);
        }
    };
});

System.register("ags-client/gen/viewmodels/lost_password_view_model.js", ["ags-client/app/commons/lang.js"], function (exports_1, context_1) {
    "use strict";

    var lang_1, LostPasswordViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (lang_1_1) {
            lang_1 = lang_1_1;
        }],
        execute: function () {
            LostPasswordViewModel = /** @class */function () {
                function LostPasswordViewModel() {}
                LostPasswordViewModel.deserialize = function (object) {
                    var _result = new LostPasswordViewModel();
                    return _result._deserialize(object);
                };
                LostPasswordViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (lang_1.isPresent(object['email'])) {
                            this.email = object['email'];
                        }
                        if (lang_1.isPresent(object['captcha'])) {
                            this.captcha = object['captcha'];
                        }
                    }
                    return this;
                };
                LostPasswordViewModel.prototype.serialize = function () {
                    var object = {};
                    if (lang_1.isPresent(this.email)) {
                        object['email'] = this.email;
                    }
                    if (lang_1.isPresent(this.captcha)) {
                        object['captcha'] = this.captcha;
                    }
                    return object;
                };
                LostPasswordViewModel.EMAIL_VALIDATORS = [];
                LostPasswordViewModel.CAPTCHA_VALIDATORS = [];
                return LostPasswordViewModel;
            }();
            exports_1("LostPasswordViewModel", LostPasswordViewModel);
        }
    };
});

System.register("ags-client/gen/viewmodels/lost_password_activation_view_model.js", ["ags-client/app/commons/lang.js"], function (exports_1, context_1) {
    "use strict";

    var lang_1, LostPasswordActivationViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (lang_1_1) {
            lang_1 = lang_1_1;
        }],
        execute: function () {
            LostPasswordActivationViewModel = /** @class */function () {
                function LostPasswordActivationViewModel() {}
                LostPasswordActivationViewModel.deserialize = function (object) {
                    var _result = new LostPasswordActivationViewModel();
                    return _result._deserialize(object);
                };
                LostPasswordActivationViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (lang_1.isPresent(object['email'])) {
                            this.email = object['email'];
                        }
                        if (lang_1.isPresent(object['activationCode'])) {
                            this.activationCode = object['activationCode'];
                        }
                    }
                    return this;
                };
                LostPasswordActivationViewModel.prototype.serialize = function () {
                    var object = {};
                    if (lang_1.isPresent(this.email)) {
                        object['email'] = this.email;
                    }
                    if (lang_1.isPresent(this.activationCode)) {
                        object['activationCode'] = this.activationCode;
                    }
                    return object;
                };
                LostPasswordActivationViewModel.EMAIL_VALIDATORS = [];
                LostPasswordActivationViewModel.ACTIVATION_CODE_VALIDATORS = [];
                return LostPasswordActivationViewModel;
            }();
            exports_1("LostPasswordActivationViewModel", LostPasswordActivationViewModel);
        }
    };
});

System.register("ags-client/gen/viewmodels/message_view_model.js", ["ags-client/app/commons/lang.js"], function (exports_1, context_1) {
    "use strict";

    var lang_1, MessageViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (lang_1_1) {
            lang_1 = lang_1_1;
        }],
        execute: function () {
            MessageViewModel = /** @class */function () {
                function MessageViewModel() {}
                MessageViewModel.deserialize = function (object) {
                    var _result = new MessageViewModel();
                    return _result._deserialize(object);
                };
                MessageViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (lang_1.isPresent(object['referenceId'])) {
                            this.referenceId = object['referenceId'];
                        }
                        if (lang_1.isPresent(object['text'])) {
                            this.text = object['text'];
                        }
                    }
                    return this;
                };
                MessageViewModel.prototype.serialize = function () {
                    var object = {};
                    if (lang_1.isPresent(this.referenceId)) {
                        object['referenceId'] = this.referenceId;
                    }
                    if (lang_1.isPresent(this.text)) {
                        object['text'] = this.text;
                    }
                    return object;
                };
                MessageViewModel.REFERENCE_ID_VALIDATORS = [];
                MessageViewModel.TEXT_VALIDATORS = [];
                return MessageViewModel;
            }();
            exports_1("MessageViewModel", MessageViewModel);
        }
    };
});

System.register("ags-client/gen/viewmodels/system_view_model.js", ["ags-client/app/commons/lang.js", "ags-client/gen/viewmodels/entity_view_model.js", "ags-client/app/validators.js", "ags-client/gen/enums.js", "ags-client/app/commons.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var lang_1, entity_view_model_1, Validators, enums_1, commons_1, SystemViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (lang_1_1) {
            lang_1 = lang_1_1;
        }, function (entity_view_model_1_1) {
            entity_view_model_1 = entity_view_model_1_1;
        }, function (Validators_1) {
            Validators = Validators_1;
        }, function (enums_1_1) {
            enums_1 = enums_1_1;
        }, function (commons_1_1) {
            commons_1 = commons_1_1;
        }],
        execute: function () {
            SystemViewModel = /** @class */function (_super) {
                __extends(SystemViewModel, _super);
                function SystemViewModel() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                SystemViewModel.deserialize = function (object) {
                    var _result = new SystemViewModel();
                    return _result._deserialize(object);
                };
                SystemViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        _super.prototype._deserialize.call(this, object);
                        if (lang_1.isPresent(object['name'])) {
                            this.name = object['name'];
                        }
                        if (lang_1.isPresent(object['description'])) {
                            this.description = object['description'];
                        }
                        if (lang_1.isPresent(object['valueType'])) {
                            this.valueType = commons_1.enumNumberValue(enums_1.ValueType, object['valueType']);
                        }
                        if (lang_1.isPresent(object['value'])) {
                            this.value = object['value'];
                        }
                    }
                    return this;
                };
                SystemViewModel.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (lang_1.isPresent(this.name)) {
                        object['name'] = this.name;
                    }
                    if (lang_1.isPresent(this.description)) {
                        object['description'] = this.description;
                    }
                    if (lang_1.isPresent(this.valueType)) {
                        object['valueType'] = enums_1.ValueType[this.valueType];
                    }
                    if (lang_1.isPresent(this.value)) {
                        object['value'] = this.value;
                    }
                    return object;
                };
                SystemViewModel.NAME_VALIDATORS = [Validators.required(), Validators.max(100)];
                SystemViewModel.DESCRIPTION_VALIDATORS = [Validators.max(4000)];
                SystemViewModel.VALUE_TYPE_VALIDATORS = [Validators.required()];
                SystemViewModel.VALUE_VALIDATORS = [Validators.max(4000)];
                return SystemViewModel;
            }(entity_view_model_1.EntityViewModel);
            exports_1("SystemViewModel", SystemViewModel);
        }
    };
});

System.register("ags-client/gen/viewmodels/role_search_result_view_model.js", ["ags-client/app/commons/lang.js", "ags-client/gen/viewmodels/entity_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var lang_1, entity_view_model_1, RoleSearchResultViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (lang_1_1) {
            lang_1 = lang_1_1;
        }, function (entity_view_model_1_1) {
            entity_view_model_1 = entity_view_model_1_1;
        }],
        execute: function () {
            RoleSearchResultViewModel = /** @class */function (_super) {
                __extends(RoleSearchResultViewModel, _super);
                function RoleSearchResultViewModel() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                RoleSearchResultViewModel.deserialize = function (object) {
                    var _result = new RoleSearchResultViewModel();
                    return _result._deserialize(object);
                };
                RoleSearchResultViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        _super.prototype._deserialize.call(this, object);
                        if (lang_1.isPresent(object['name'])) {
                            this.name = object['name'];
                        }
                        if (lang_1.isPresent(object['deleted'])) {
                            this.deleted = object['deleted'];
                        }
                    }
                    return this;
                };
                RoleSearchResultViewModel.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (lang_1.isPresent(this.name)) {
                        object['name'] = this.name;
                    }
                    if (lang_1.isPresent(this.deleted)) {
                        object['deleted'] = this.deleted;
                    }
                    return object;
                };
                RoleSearchResultViewModel.NAME_VALIDATORS = [];
                RoleSearchResultViewModel.DELETED_VALIDATORS = [];
                return RoleSearchResultViewModel;
            }(entity_view_model_1.EntityViewModel);
            exports_1("RoleSearchResultViewModel", RoleSearchResultViewModel);
        }
    };
});

System.register("ags-client/gen/viewmodels/role_view_model.js", ["ags-client/app/commons/lang.js", "ags-client/gen/viewmodels/entity_view_model.js", "ags-client/app/validators.js", "ags-client/gen/codes.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var lang_1, entity_view_model_1, Validators, codes_1, RoleViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (lang_1_1) {
            lang_1 = lang_1_1;
        }, function (entity_view_model_1_1) {
            entity_view_model_1 = entity_view_model_1_1;
        }, function (Validators_1) {
            Validators = Validators_1;
        }, function (codes_1_1) {
            codes_1 = codes_1_1;
        }],
        execute: function () {
            RoleViewModel = /** @class */function (_super) {
                __extends(RoleViewModel, _super);
                function RoleViewModel() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                RoleViewModel.deserialize = function (object) {
                    var _result = new RoleViewModel();
                    return _result._deserialize(object);
                };
                RoleViewModel.prototype._deserialize = function (object) {
                    var _this = this;
                    if (object) {
                        _super.prototype._deserialize.call(this, object);
                        if (lang_1.isPresent(object['role'])) {
                            this.role = new codes_1.Role(object['role']['shortName']);
                        }
                        if (lang_1.isPresent(object['roles'])) {
                            this.roles = [];
                            object['roles'].forEach(function (item) {
                                _this.roles.push(item);
                            });
                        }
                        if (lang_1.isPresent(object['rolesAssigned'])) {
                            this.rolesAssigned = [];
                            object['rolesAssigned'].forEach(function (item) {
                                _this.rolesAssigned.push(item);
                            });
                        }
                        if (lang_1.isPresent(object['rules'])) {
                            this.rules = [];
                            object['rules'].forEach(function (item) {
                                _this.rules.push(item);
                            });
                        }
                        if (lang_1.isPresent(object['rulesAssigned'])) {
                            this.rulesAssigned = [];
                            object['rulesAssigned'].forEach(function (item) {
                                _this.rulesAssigned.push(item);
                            });
                        }
                    }
                    return this;
                };
                RoleViewModel.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (lang_1.isPresent(this.role)) {
                        object['role'] = this.role;
                    }
                    if (lang_1.isPresent(this.roles)) {
                        object['roles'] = [];
                        this.roles.forEach(function (item) {
                            object['roles'].push(item);
                        });
                    }
                    if (lang_1.isPresent(this.rolesAssigned)) {
                        object['rolesAssigned'] = [];
                        this.rolesAssigned.forEach(function (item) {
                            object['rolesAssigned'].push(item);
                        });
                    }
                    if (lang_1.isPresent(this.rules)) {
                        object['rules'] = [];
                        this.rules.forEach(function (item) {
                            object['rules'].push(item);
                        });
                    }
                    if (lang_1.isPresent(this.rulesAssigned)) {
                        object['rulesAssigned'] = [];
                        this.rulesAssigned.forEach(function (item) {
                            object['rulesAssigned'].push(item);
                        });
                    }
                    return object;
                };
                RoleViewModel.ROLE_VALIDATORS = [Validators.required()];
                RoleViewModel.ROLES_VALIDATORS = [];
                RoleViewModel.ROLES_ASSIGNED_VALIDATORS = [];
                RoleViewModel.RULES_VALIDATORS = [];
                RoleViewModel.RULES_ASSIGNED_VALIDATORS = [];
                return RoleViewModel;
            }(entity_view_model_1.EntityViewModel);
            exports_1("RoleViewModel", RoleViewModel);
        }
    };
});

System.register("ags-client/app/pipes/date_pipe.js", ["angular2/core.js", "ags-client/app/commons/lang.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var core_1, lang_1, DatePipe;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }],
        execute: function () {
            DatePipe = /** @class */function () {
                function DatePipe() {}
                DatePipe.prototype.transform = function (key) {
                    if (key) {
                        return lang_1.formatDate(key);
                    } else {
                        return null;
                    }
                };
                DatePipe = __decorate([core_1.Pipe({
                    name: 'date'
                })], DatePipe);
                return DatePipe;
            }();
            exports_1("DatePipe", DatePipe);
        }
    };
});

System.register("ags-client/app/pipes/datetime_pipe.js", ["angular2/core.js", "ags-client/app/commons/lang.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var core_1, lang_1, DateTimePipe;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }],
        execute: function () {
            DateTimePipe = /** @class */function () {
                function DateTimePipe() {}
                DateTimePipe.prototype.transform = function (key) {
                    if (key) {
                        return lang_1.formatDateTime(key);
                    } else {
                        return null;
                    }
                };
                DateTimePipe = __decorate([core_1.Pipe({
                    name: 'datetime'
                })], DateTimePipe);
                return DateTimePipe;
            }();
            exports_1("DateTimePipe", DateTimePipe);
        }
    };
});

System.register("ags-client/app/pipes/decimal_pipe.js", ["angular2/core.js", "ags-client/app/commons/lang.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var core_1, lang_1, DecimalPipe;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }],
        execute: function () {
            DecimalPipe = /** @class */function () {
                function DecimalPipe() {}
                // arg[0]: min fraction digits. default 2
                // arg[1]: max fraction digits. default equal to min fraction digits
                // arg[2]: text for null value. default '-'
                DecimalPipe.prototype.transform = function (key, args) {
                    if (lang_1.isNumber(key)) {
                        var minFractions = 2;
                        var maxFractions = minFractions;
                        if (args) {
                            if (args.length > 0) {
                                minFractions = parseInt(args[0]);
                            }
                            if (args.length > 1) {
                                maxFractions = parseInt(args[1]);
                            } else {
                                maxFractions = minFractions;
                            }
                        }
                        var numberFormatter = new Intl.NumberFormat('de-CH', {
                            'useGrouping': true,
                            'minimumFractionDigits': minFractions,
                            'maximumFractionDigits': maxFractions
                        });
                        return numberFormatter.format(key);
                    } else {
                        if (args && args.length > 2) return args[2];else return '-';
                    }
                };
                DecimalPipe = __decorate([core_1.Pipe({
                    name: 'decimal'
                })], DecimalPipe);
                return DecimalPipe;
            }();
            exports_1("DecimalPipe", DecimalPipe);
        }
    };
});

System.register("ags-client/app/pipes/percent_pipe.js", ["angular2/core.js", "ags-client/app/commons/lang.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var core_1, lang_1, PercentPipe;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }],
        execute: function () {
            PercentPipe = /** @class */function () {
                function PercentPipe() {}
                PercentPipe.prototype.transform = function (key, args) {
                    if (lang_1.isNumber(key)) {
                        var fractions = 2;
                        if (args && args.length > 0) {
                            fractions = parseInt(args[0]);
                        }
                        var numberFormatter = new Intl.NumberFormat('de-CH', {
                            'useGrouping': false,
                            'minimumFractionDigits': fractions,
                            'maximumFractionDigits': fractions
                        });
                        return numberFormatter.format(key) + '\u00a0%';
                    } else {
                        return 'n.v.';
                    }
                };
                PercentPipe = __decorate([core_1.Pipe({
                    name: 'percent'
                })], PercentPipe);
                return PercentPipe;
            }();
            exports_1("PercentPipe", PercentPipe);
        }
    };
});

System.register("ags-client/app/pipes/filetype_pipe.js", ["angular2/core.js", "ags-client/app/commons/lang.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var core_1, lang_1, FileTypePipe;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }],
        execute: function () {
            FileTypePipe = /** @class */function () {
                function FileTypePipe() {}
                FileTypePipe.prototype.transform = function (filename) {
                    if (lang_1.isPresent(filename)) {
                        return lang_1.fileExtension(filename);
                    } else {
                        return null;
                    }
                };
                FileTypePipe = __decorate([core_1.Pipe({
                    name: 'filetype'
                })], FileTypePipe);
                return FileTypePipe;
            }();
            exports_1("FileTypePipe", FileTypePipe);
        }
    };
});

System.register("ags-client/app/pipes/ls_pipe.js", ["angular2/core.js", "ags-client/app/services/translation_service.js", "ags-client/app/commons.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, translation_service_1, commons_1, LsPipe;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }, function (commons_1_1) {
            commons_1 = commons_1_1;
        }],
        execute: function () {
            LsPipe = /** @class */function () {
                function LsPipe(_translationService) {
                    this._translationService = _translationService;
                }
                LsPipe.prototype.transform = function (value) {
                    var _this = this;
                    if (commons_1.isPresent(value)) {
                        var translation = value.filter(function (ls) {
                            return ls.language.shortName === _this._translationService.language;
                        }).map(function (ls) {
                            return ls.value;
                        });
                        if (translation.length === 1) {
                            return translation[0];
                        }
                        if (value.length > 0) {
                            return value[0].value;
                        }
                        return null;
                    } else {
                        return null;
                    }
                };
                LsPipe = __decorate([core_1.Pipe({
                    name: 'ls'
                }), __metadata("design:paramtypes", [translation_service_1.TranslationService])], LsPipe);
                return LsPipe;
            }();
            exports_1("LsPipe", LsPipe);
        }
    };
});

System.register("ags-client/app/pipes/valor_pipe.js", ["angular2/core.js", "ags-client/app/commons/lang.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var core_1, lang_1, ValorPipe;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }],
        execute: function () {
            ValorPipe = /** @class */function () {
                function ValorPipe() {}
                ValorPipe.prototype.transform = function (value) {
                    if (lang_1.isPresent(value) && value > 0) {
                        var source = value.toString();
                        var result = '';
                        var y = 1;
                        for (var i = source.length - 1; i >= 0; i--) {
                            result = source.substring(i, i + 1) + result;
                            if (y % 3 === 0) {
                                result = ' ' + result;
                            }
                            y++;
                        }
                        return result;
                    }
                    return null;
                };
                ValorPipe = __decorate([core_1.Pipe({
                    name: 'valor',
                    pure: false
                })], ValorPipe);
                return ValorPipe;
            }();
            exports_1("ValorPipe", ValorPipe);
        }
    };
});

System.register("ags-client/app/pipes/truncate_pipe.js", ["angular2/core.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var core_1, TruncatePipe;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }],
        execute: function () {
            TruncatePipe = /** @class */function () {
                function TruncatePipe() {}
                TruncatePipe.prototype.transform = function (value, args) {
                    if (value != null) {
                        var limit = args.length > 0 ? parseInt(args[0], 10) : 10;
                        var trail = args.length > 1 ? args[1] : '...';
                        return value.length > limit ? value.substring(0, limit) + trail : value;
                    } else {
                        return null;
                    }
                };
                TruncatePipe = __decorate([core_1.Pipe({
                    name: 'truncate'
                })], TruncatePipe);
                return TruncatePipe;
            }();
            exports_1("TruncatePipe", TruncatePipe);
        }
    };
});

System.register("ags-client/app/services/alert_service.js", ["angular2/core.js", "ags-client/app/models/alert_model.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, alert_model_1, AlertService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (alert_model_1_1) {
            alert_model_1 = alert_model_1_1;
        }],
        execute: function () {
            AlertService = /** @class */function () {
                function AlertService() {
                    this._emitter = new core_1.EventEmitter();
                    AlertService_1._instance = this;
                }
                AlertService_1 = AlertService;
                AlertService.prototype.subscribe = function (subscriber) {
                    this._emitter.subscribe(subscriber);
                };
                AlertService.prototype.error = function (message) {
                    this.alert = new alert_model_1.AlertModel(alert_model_1.AlertType.ERROR, message);
                    this._emitter.emit(this.alert);
                };
                AlertService.prototype.warning = function (message) {
                    this.alert = new alert_model_1.AlertModel(alert_model_1.AlertType.WARNING, message);
                    this._emitter.emit(this.alert);
                };
                AlertService.prototype.info = function (message) {
                    this.alert = new alert_model_1.AlertModel(alert_model_1.AlertType.INFO, message);
                    this._emitter.emit(this.alert);
                };
                AlertService.prototype.reset = function () {
                    this.alert = null;
                    this._emitter.emit(null);
                };
                Object.defineProperty(AlertService, "instance", {
                    get: function () {
                        return AlertService_1._instance;
                    },
                    enumerable: false,
                    configurable: true
                });
                var AlertService_1;
                AlertService = AlertService_1 = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [])], AlertService);
                return AlertService;
            }();
            exports_1("AlertService", AlertService);
        }
    };
});

System.register("ags-client/app/components/alert_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/services/alert_service.js", "ags-client/app/commons/lang.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, alert_service_1, lang_1, AlertComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (alert_service_1_1) {
            alert_service_1 = alert_service_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }],
        execute: function () {
            AlertComponent = /** @class */function () {
                function AlertComponent(alertService, _element) {
                    var _this = this;
                    this._element = _element;
                    this.alert = alertService.alert;
                    alertService.subscribe(function (alert) {
                        _this.alert = alert;
                        if (alert && lang_1.isSomething(alert.message)) {
                            window.scrollTo(0, 0);
                        }
                    });
                }
                AlertComponent = __decorate([core_1.Component({
                    directives: [common_1.CORE_DIRECTIVES],
                    selector: 'alert',
                    template: "\n<div *ngIf=\"alert\"\n     class=\"alert\"\n     [class.alert-danger]=\"alert.error()\"\n     [class.alert-warning]=\"alert.warning()\"\n     [class.alert-success]=\"alert.info()\"\n     role = \"alert\">\n    <p>{{alert.message}}</p>\n</div>"
                }), core_1.Inject(alert_service_1.AlertService), __metadata("design:paramtypes", [alert_service_1.AlertService, core_1.ElementRef])], AlertComponent);
                return AlertComponent;
            }();
            exports_1("AlertComponent", AlertComponent);
        }
    };
});

System.register("ags-client/app/components/input_errors_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/services/translation_service.js", "ags-client/app/commons/html.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, translation_service_1, html_1, InputErrorsComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }, function (html_1_1) {
            html_1 = html_1_1;
        }],
        execute: function () {
            InputErrorsComponent = /** @class */function () {
                function InputErrorsComponent(_element, _translationService) {
                    this._element = _element;
                    this._translationService = _translationService;
                }
                Object.defineProperty(InputErrorsComponent.prototype, "control", {
                    get: function () {
                        return this._control;
                    },
                    set: function (control) {
                        this._control = control;
                    },
                    enumerable: false,
                    configurable: true
                });
                InputErrorsComponent.prototype.ngAfterContentInit = function () {
                    var _this = this;
                    if (this.control) {
                        this.control.formDirective.ngSubmit.subscribe(function () {
                            _this._updateErrors();
                        });
                        this.control.control.statusChanges.subscribe(function (status) {
                            _this._updateErrors();
                        });
                    }
                };
                InputErrorsComponent.prototype._updateErrors = function () {
                    var _this = this;
                    this.errors = [];
                    if (!this.control.pristine) {
                        if (this.control.errors) {
                            for (var error in this.control.errors) {
                                var errorMessage = this._translationService.translate('validation_errors:' + error, this.control.errors[error]);
                                this.errors.push(errorMessage);
                            }
                        }
                    }
                    var element = this._element.nativeElement;
                    setTimeout(function () {
                        var formGroup = html_1.findParentElementByClassName(element, 'form-group');
                        if (formGroup) {
                            if (_this.control.valid || _this.control.pristine) {
                                html_1.removeClass(formGroup, 'has-error');
                            } else {
                                html_1.appendClass(formGroup, 'has-error');
                            }
                        }
                    }, 10);
                };
                __decorate([core_1.Input(), __metadata("design:type", common_1.NgControlName), __metadata("design:paramtypes", [common_1.NgControlName])], InputErrorsComponent.prototype, "control", null);
                InputErrorsComponent = __decorate([core_1.Component({
                    selector: 'input-errors',
                    template: '<small *ngFor="#error of errors" class="text-danger error">{{error}}</small>'
                }), core_1.Inject(translation_service_1.TranslationService), __metadata("design:paramtypes", [core_1.ElementRef, translation_service_1.TranslationService])], InputErrorsComponent);
                return InputErrorsComponent;
            }();
            exports_1("InputErrorsComponent", InputErrorsComponent);
        }
    };
});

System.register("ags-client/app/components/pagination_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/viewsearch/search_criteria.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, search_criteria_1, PaginationComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (search_criteria_1_1) {
            search_criteria_1 = search_criteria_1_1;
        }],
        execute: function () {
            PaginationComponent = /** @class */function () {
                function PaginationComponent() {
                    this.currentPage = 1;
                    this.maxSize = 10;
                    this.pages = new Array();
                    this.pageable = false;
                    this._from = 0;
                }
                PaginationComponent.prototype.reset = function () {
                    this.currentPage = 1;
                };
                PaginationComponent.prototype.update = function () {
                    if (this._criteria.from !== this._from) {
                        this.currentPage = 1;
                    }
                    this.pageable = false;
                    var first = Math.ceil(this.currentPage - this.maxSize / 2);
                    if (first < 1) {
                        first = 1;
                    }
                    var last = first + this.maxSize - 1;
                    while (last > this.numberOfPages()) {
                        last--;
                        if (first > 1) {
                            first--;
                        }
                    }
                    if (last > this.numberOfPages()) {
                        last = this.numberOfPages();
                    }
                    this.pages.splice(0, this.pages.length);
                    for (var i = first; i <= last; i++) {
                        this.pages.push(i);
                    }
                    this.pageable = this._criteria.total > this._criteria.size;
                };
                PaginationComponent.prototype.numberOfPages = function () {
                    return Math.ceil(this._criteria.total / this._criteria.size);
                };
                PaginationComponent.prototype.select = function (page) {
                    if (this.currentPage !== page) {
                        this.currentPage = page;
                        this._from = (this.currentPage - 1) * this._criteria.size;
                        this._criteria.from = this._from;
                    }
                };
                PaginationComponent.prototype.previous = function () {
                    if (this.currentPage > 1) {
                        this.select(this.currentPage - 1);
                    }
                };
                PaginationComponent.prototype.next = function () {
                    if (this.currentPage < this.numberOfPages()) {
                        this.select(this.currentPage + 1);
                    }
                };
                PaginationComponent.prototype.last = function () {
                    this.select(this.numberOfPages());
                };
                PaginationComponent.prototype.first = function () {
                    this.select(1);
                };
                PaginationComponent.prototype.isFirstPage = function () {
                    return this.currentPage === 1;
                };
                PaginationComponent.prototype.isLastPage = function () {
                    return this.currentPage === this.numberOfPages();
                };
                PaginationComponent.prototype.isCurrent = function (page) {
                    return page === this.currentPage;
                };
                Object.defineProperty(PaginationComponent.prototype, "criteria", {
                    set: function (criteria) {
                        var _this = this;
                        this._criteria = criteria;
                        if (criteria) {
                            criteria.subscribeResult(function () {
                                _this.update();
                            });
                            this._from = criteria.from;
                            this.currentPage = Math.ceil(criteria.from / criteria.size) + 1;
                            this.update();
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                __decorate([core_1.Input(), __metadata("design:type", search_criteria_1.SearchCriteria), __metadata("design:paramtypes", [search_criteria_1.SearchCriteria])], PaginationComponent.prototype, "criteria", null);
                PaginationComponent = __decorate([core_1.Component({
                    directives: [common_1.NgFor, common_1.NgClass],
                    selector: 'pagination',
                    template: "\n<div *ngIf=\"pageable\" class=\"pagination\">\n<nav>\n  <ul class=\"pagination\">\n    <li [ngClass]=\"{'disabled': isFirstPage()}\"><a (click)=\"first()\"><span>&laquo;</span></a></li>\n    <li [ngClass]=\"{'disabled': isFirstPage()}\"><a (click)=\"previous()\"><span>&lsaquo;</span></a></li>\n    <li *ngFor=\"#page of pages\" (click)=\"select(page)\" [ngClass]=\"{'active': isCurrent(page)}\"><a>{{page}}</a></li>\n    <li [ngClass]=\"{'disabled': isLastPage()}\"><a (click)=\"next()\"><span>&rsaquo;</span></a></li>\n    <li [ngClass]=\"{'disabled': isLastPage()}\"><a (click)=\"last()\"><span>&raquo;</span></a></li>\n  </ul>\n</nav>\n</div>"
                })], PaginationComponent);
                return PaginationComponent;
            }();
            exports_1("PaginationComponent", PaginationComponent);
        }
    };
});

System.register("ags-client/app/components/table_sort_component.js", ["angular2/core.js", "ags-client/app/viewsearch/search_criteria.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, search_criteria_1, TableSortComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (search_criteria_1_1) {
            search_criteria_1 = search_criteria_1_1;
        }],
        execute: function () {
            TableSortComponent = /** @class */function () {
                function TableSortComponent() {}
                TableSortComponent.prototype.sort = function () {
                    this.criteria.sortBy(this.attribute);
                };
                TableSortComponent.prototype.showSort = function () {
                    return this.criteria && this.criteria.sort && this.criteria.sort.attribute === this.attribute;
                };
                TableSortComponent.prototype.ascending = function () {
                    if (this.showSort()) {
                        return this.criteria.sort.direction === search_criteria_1.SortDirection.ASCENDING;
                    }
                    return false;
                };
                TableSortComponent.prototype.descending = function () {
                    if (this.showSort()) {
                        return this.criteria.sort.direction === search_criteria_1.SortDirection.DESCENDING;
                    }
                    return false;
                };
                __decorate([core_1.Input(), __metadata("design:type", String)], TableSortComponent.prototype, "attribute", void 0);
                __decorate([core_1.Input(), __metadata("design:type", search_criteria_1.SearchCriteria)], TableSortComponent.prototype, "criteria", void 0);
                TableSortComponent = __decorate([core_1.Component({
                    selector: 'table-sort',
                    template: "\n        <div (click)=\"sort()\" class=\"link\">\n            <ng-content></ng-content>\n            <i *ngIf=\"showSort()\"\n                class=\"fa\" [ngClass]=\"{'fa-angle-up': ascending(), 'fa-angle-down': descending()}\">\n            </i>\n        </div>\n    "
                })], TableSortComponent);
                return TableSortComponent;
            }();
            exports_1("TableSortComponent", TableSortComponent);
        }
    };
});

System.register("ags-client/app/components/boolean_component.js", ["angular2/core.js", "angular2/common.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, BooleanComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }],
        execute: function () {
            BooleanComponent = /** @class */function () {
                function BooleanComponent() {}
                __decorate([core_1.Input(), __metadata("design:type", Boolean)], BooleanComponent.prototype, "model", void 0);
                BooleanComponent = __decorate([core_1.Component({
                    directives: [common_1.NgClass],
                    selector: 'boolean',
                    template: "\n<i class=\"fa\"\n   [class.fa-square-o]=\"!model\"\n   [class.fa-check-square-o]=\"model\">\n</i>"
                })], BooleanComponent);
                return BooleanComponent;
            }();
            exports_1("BooleanComponent", BooleanComponent);
        }
    };
});

System.register("ags-client/app/components/check_component.js", ["angular2/core.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, CheckComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }],
        execute: function () {
            CheckComponent = /** @class */function () {
                function CheckComponent() {
                    this.action = new core_1.EventEmitter();
                }
                CheckComponent.prototype.check = function () {
                    this.action.emit(this.model);
                };
                __decorate([core_1.Input(), __metadata("design:type", Object)], CheckComponent.prototype, "model", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Boolean)], CheckComponent.prototype, "checked", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], CheckComponent.prototype, "action", void 0);
                CheckComponent = __decorate([core_1.Component({
                    selector: 'check',
                    template: "<a (click)=\"check()\"><i class=\"fa\" [class.fa-square-o]=\"!checked\" [class.fa-check-square-o]=\"checked\"></i></a>"
                })], CheckComponent);
                return CheckComponent;
            }();
            exports_1("CheckComponent", CheckComponent);
        }
    };
});

System.register("ags-client/app/components/check_all_component.js", ["angular2/core.js", "angular2/common.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, CheckAllComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }],
        execute: function () {
            CheckAllComponent = /** @class */function () {
                function CheckAllComponent() {
                    this.checked = false;
                    this.action = new core_1.EventEmitter();
                }
                CheckAllComponent.prototype.checkAll = function () {
                    this.action.emit(null);
                };
                __decorate([core_1.Input(), __metadata("design:type", Object)], CheckAllComponent.prototype, "model", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Object)], CheckAllComponent.prototype, "checked", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], CheckAllComponent.prototype, "action", void 0);
                CheckAllComponent = __decorate([core_1.Component({
                    directives: [common_1.NgClass],
                    selector: 'check-all',
                    template: "<a (click)=\"checkAll()\"><i class=\"fa\" [class.fa-square-o]=\"!checked\" [class.fa-check-square-o]=\"checked\"></i></a>"
                })], CheckAllComponent);
                return CheckAllComponent;
            }();
            exports_1("CheckAllComponent", CheckAllComponent);
        }
    };
});

System.register("ags-client/app/components/delete_component.js", ["angular2/core.js", "angular2/common.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, DeleteComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }],
        execute: function () {
            DeleteComponent = /** @class */function () {
                function DeleteComponent() {
                    this.deleted = false;
                    this.action = new core_1.EventEmitter();
                }
                DeleteComponent.prototype.execute = function () {
                    this.action.emit(this.model);
                };
                __decorate([core_1.Input(), __metadata("design:type", Object)], DeleteComponent.prototype, "model", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Object)], DeleteComponent.prototype, "deleted", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], DeleteComponent.prototype, "action", void 0);
                DeleteComponent = __decorate([core_1.Component({
                    directives: [common_1.NgClass],
                    selector: 'delete',
                    template: "\n    <a (click)=\"execute()\">\n<i class=\"fa\"\n   [class.fa-trash-o]=\"!deleted\"\n   [class.fa-undo]=\"deleted\">\n</i>\n</a>"
                })], DeleteComponent);
                return DeleteComponent;
            }();
            exports_1("DeleteComponent", DeleteComponent);
        }
    };
});

System.register("ags-client/app/components/edit_component.js", ["angular2/core.js", "angular2/common.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, EditComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }],
        execute: function () {
            EditComponent = /** @class */function () {
                function EditComponent() {
                    this.action = new core_1.EventEmitter();
                }
                EditComponent.prototype.edit = function () {
                    this.action.emit(this.model);
                };
                __decorate([core_1.Input(), __metadata("design:type", Object)], EditComponent.prototype, "model", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], EditComponent.prototype, "action", void 0);
                EditComponent = __decorate([core_1.Component({
                    directives: [common_1.NgClass],
                    selector: 'edit',
                    template: "<a (click)=\"edit()\"><i class=\"fa fa-pencil fa-fw\"></i></a>"
                })], EditComponent);
                return EditComponent;
            }();
            exports_1("EditComponent", EditComponent);
        }
    };
});

System.register("ags-client/app/components/refresh_component.js", ["angular2/core.js", "angular2/router.js", "ags-client/app/pipes/translation_pipe.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, router_1, translation_pipe_1, RefreshComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (router_1_1) {
            router_1 = router_1_1;
        }, function (translation_pipe_1_1) {
            translation_pipe_1 = translation_pipe_1_1;
        }],
        execute: function () {
            RefreshComponent = /** @class */function () {
                function RefreshComponent(_router) {
                    this._router = _router;
                    this.refresh = new core_1.EventEmitter();
                }
                RefreshComponent.prototype._refresh = function () {
                    this.refresh.emit(null);
                };
                __decorate([core_1.Output(), __metadata("design:type", Object)], RefreshComponent.prototype, "refresh", void 0);
                RefreshComponent = __decorate([core_1.Component({
                    selector: 'refresh',
                    pipes: [translation_pipe_1.TranslationPipe],
                    template: "<a (click)=\"_refresh()\"><i class=\"fa fa-refresh\"></i>{{'commons:refresh'|translate}}</a>"
                }), __metadata("design:paramtypes", [router_1.Router])], RefreshComponent);
                return RefreshComponent;
            }();
            exports_1("RefreshComponent", RefreshComponent);
        }
    };
});

System.registerDynamic("angular2/src/router/directives/router_outlet.js", ["angular2/src/facade/async.js", "angular2/src/facade/collection.js", "angular2/src/facade/lang.js", "angular2/core.js", "angular2/src/router/router.js", "angular2/src/router/instruction.js", "angular2/src/router/lifecycle/lifecycle_annotations.js", "angular2/src/router/lifecycle/route_lifecycle_reflector.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var __param = this && this.__param || function (paramIndex, decorator) {
        return function (target, key) {
            decorator(target, key, paramIndex);
        };
    };
    var async_1 = $__require("angular2/src/facade/async.js");
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var core_1 = $__require("angular2/core.js");
    var routerMod = $__require("angular2/src/router/router.js");
    var instruction_1 = $__require("angular2/src/router/instruction.js");
    var hookMod = $__require("angular2/src/router/lifecycle/lifecycle_annotations.js");
    var route_lifecycle_reflector_1 = $__require("angular2/src/router/lifecycle/route_lifecycle_reflector.js");
    var _resolveToTrue = async_1.PromiseWrapper.resolve(true);
    /**
     * A router outlet is a placeholder that Angular dynamically fills based on the application's route.
     *
     * ## Use
     *
     * ```
     * <router-outlet></router-outlet>
     * ```
     */
    var RouterOutlet = function () {
        function RouterOutlet(_elementRef, _loader, _parentRouter, nameAttr) {
            this._elementRef = _elementRef;
            this._loader = _loader;
            this._parentRouter = _parentRouter;
            this.name = null;
            this._componentRef = null;
            this._currentInstruction = null;
            if (lang_1.isPresent(nameAttr)) {
                this.name = nameAttr;
                this._parentRouter.registerAuxOutlet(this);
            } else {
                this._parentRouter.registerPrimaryOutlet(this);
            }
        }
        /**
         * Called by the Router to instantiate a new component during the commit phase of a navigation.
         * This method in turn is responsible for calling the `routerOnActivate` hook of its child.
         */
        RouterOutlet.prototype.activate = function (nextInstruction) {
            var _this = this;
            var previousInstruction = this._currentInstruction;
            this._currentInstruction = nextInstruction;
            var componentType = nextInstruction.componentType;
            var childRouter = this._parentRouter.childRouter(componentType);
            var providers = core_1.Injector.resolve([core_1.provide(instruction_1.RouteData, { useValue: nextInstruction.routeData }), core_1.provide(instruction_1.RouteParams, { useValue: new instruction_1.RouteParams(nextInstruction.params) }), core_1.provide(routerMod.Router, { useValue: childRouter })]);
            this._componentRef = this._loader.loadNextToLocation(componentType, this._elementRef, providers);
            return this._componentRef.then(function (componentRef) {
                if (route_lifecycle_reflector_1.hasLifecycleHook(hookMod.routerOnActivate, componentType)) {
                    return _this._componentRef.then(function (ref) {
                        return ref.instance.routerOnActivate(nextInstruction, previousInstruction);
                    });
                } else {
                    return componentRef;
                }
            });
        };
        /**
         * Called by the {@link Router} during the commit phase of a navigation when an outlet
         * reuses a component between different routes.
         * This method in turn is responsible for calling the `routerOnReuse` hook of its child.
         */
        RouterOutlet.prototype.reuse = function (nextInstruction) {
            var previousInstruction = this._currentInstruction;
            this._currentInstruction = nextInstruction;
            // it's possible the component is removed before it can be reactivated (if nested withing
            // another dynamically loaded component, for instance). In that case, we simply activate
            // a new one.
            if (lang_1.isBlank(this._componentRef)) {
                return this.activate(nextInstruction);
            } else {
                return async_1.PromiseWrapper.resolve(route_lifecycle_reflector_1.hasLifecycleHook(hookMod.routerOnReuse, this._currentInstruction.componentType) ? this._componentRef.then(function (ref) {
                    return ref.instance.routerOnReuse(nextInstruction, previousInstruction);
                }) : true);
            }
        };
        /**
         * Called by the {@link Router} when an outlet disposes of a component's contents.
         * This method in turn is responsible for calling the `routerOnDeactivate` hook of its child.
         */
        RouterOutlet.prototype.deactivate = function (nextInstruction) {
            var _this = this;
            var next = _resolveToTrue;
            if (lang_1.isPresent(this._componentRef) && lang_1.isPresent(this._currentInstruction) && route_lifecycle_reflector_1.hasLifecycleHook(hookMod.routerOnDeactivate, this._currentInstruction.componentType)) {
                next = this._componentRef.then(function (ref) {
                    return ref.instance.routerOnDeactivate(nextInstruction, _this._currentInstruction);
                });
            }
            return next.then(function (_) {
                if (lang_1.isPresent(_this._componentRef)) {
                    var onDispose = _this._componentRef.then(function (ref) {
                        return ref.dispose();
                    });
                    _this._componentRef = null;
                    return onDispose;
                }
            });
        };
        /**
         * Called by the {@link Router} during recognition phase of a navigation.
         *
         * If this resolves to `false`, the given navigation is cancelled.
         *
         * This method delegates to the child component's `routerCanDeactivate` hook if it exists,
         * and otherwise resolves to true.
         */
        RouterOutlet.prototype.routerCanDeactivate = function (nextInstruction) {
            var _this = this;
            if (lang_1.isBlank(this._currentInstruction)) {
                return _resolveToTrue;
            }
            if (route_lifecycle_reflector_1.hasLifecycleHook(hookMod.routerCanDeactivate, this._currentInstruction.componentType)) {
                return this._componentRef.then(function (ref) {
                    return ref.instance.routerCanDeactivate(nextInstruction, _this._currentInstruction);
                });
            } else {
                return _resolveToTrue;
            }
        };
        /**
         * Called by the {@link Router} during recognition phase of a navigation.
         *
         * If the new child component has a different Type than the existing child component,
         * this will resolve to `false`. You can't reuse an old component when the new component
         * is of a different Type.
         *
         * Otherwise, this method delegates to the child component's `routerCanReuse` hook if it exists,
         * or resolves to true if the hook is not present.
         */
        RouterOutlet.prototype.routerCanReuse = function (nextInstruction) {
            var _this = this;
            var result;
            if (lang_1.isBlank(this._currentInstruction) || this._currentInstruction.componentType != nextInstruction.componentType) {
                result = false;
            } else if (route_lifecycle_reflector_1.hasLifecycleHook(hookMod.routerCanReuse, this._currentInstruction.componentType)) {
                result = this._componentRef.then(function (ref) {
                    return ref.instance.routerCanReuse(nextInstruction, _this._currentInstruction);
                });
            } else {
                result = nextInstruction == this._currentInstruction || lang_1.isPresent(nextInstruction.params) && lang_1.isPresent(this._currentInstruction.params) && collection_1.StringMapWrapper.equals(nextInstruction.params, this._currentInstruction.params);
            }
            return async_1.PromiseWrapper.resolve(result);
        };
        RouterOutlet.prototype.ngOnDestroy = function () {
            this._parentRouter.unregisterPrimaryOutlet(this);
        };
        RouterOutlet = __decorate([core_1.Directive({ selector: 'router-outlet' }), __param(3, core_1.Attribute('name')), __metadata('design:paramtypes', [core_1.ElementRef, core_1.DynamicComponentLoader, routerMod.Router, String])], RouterOutlet);
        return RouterOutlet;
    }();
    exports.RouterOutlet = RouterOutlet;
});
System.registerDynamic("angular2/src/router/directives/router_link.js", ["angular2/core.js", "angular2/src/facade/lang.js", "angular2/src/router/router.js", "angular2/src/router/location/location.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1 = $__require("angular2/core.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var router_1 = $__require("angular2/src/router/router.js");
    var location_1 = $__require("angular2/src/router/location/location.js");
    /**
     * The RouterLink directive lets you link to specific parts of your app.
     *
     * Consider the following route configuration:
    
     * ```
     * @RouteConfig([
     *   { path: '/user', component: UserCmp, as: 'User' }
     * ]);
     * class MyComp {}
     * ```
     *
     * When linking to this `User` route, you can write:
     *
     * ```
     * <a [routerLink]="['./User']">link to user component</a>
     * ```
     *
     * RouterLink expects the value to be an array of route names, followed by the params
     * for that level of routing. For instance `['/Team', {teamId: 1}, 'User', {userId: 2}]`
     * means that we want to generate a link for the `Team` route with params `{teamId: 1}`,
     * and with a child route `User` with params `{userId: 2}`.
     *
     * The first route name should be prepended with `/`, `./`, or `../`.
     * If the route begins with `/`, the router will look up the route from the root of the app.
     * If the route begins with `./`, the router will instead look in the current component's
     * children for the route. And if the route begins with `../`, the router will look at the
     * current component's parent.
     */
    var RouterLink = function () {
        function RouterLink(_router, _location) {
            var _this = this;
            this._router = _router;
            this._location = _location;
            // we need to update the link whenever a route changes to account for aux routes
            this._router.subscribe(function (_) {
                return _this._updateLink();
            });
        }
        // because auxiliary links take existing primary and auxiliary routes into account,
        // we need to update the link whenever params or other routes change.
        RouterLink.prototype._updateLink = function () {
            this._navigationInstruction = this._router.generate(this._routeParams);
            var navigationHref = this._navigationInstruction.toLinkUrl();
            this.visibleHref = this._location.prepareExternalUrl(navigationHref);
        };
        Object.defineProperty(RouterLink.prototype, "isRouteActive", {
            get: function () {
                return this._router.isRouteActive(this._navigationInstruction);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(RouterLink.prototype, "routeParams", {
            set: function (changes) {
                this._routeParams = changes;
                this._updateLink();
            },
            enumerable: true,
            configurable: true
        });
        RouterLink.prototype.onClick = function () {
            // If no target, or if target is _self, prevent default browser behavior
            if (!lang_1.isString(this.target) || this.target == '_self') {
                this._router.navigateByInstruction(this._navigationInstruction);
                return false;
            }
            return true;
        };
        RouterLink = __decorate([core_1.Directive({
            selector: '[routerLink]',
            inputs: ['routeParams: routerLink', 'target: target'],
            host: {
                '(click)': 'onClick()',
                '[attr.href]': 'visibleHref',
                '[class.router-link-active]': 'isRouteActive'
            }
        }), __metadata('design:paramtypes', [router_1.Router, location_1.Location])], RouterLink);
        return RouterLink;
    }();
    exports.RouterLink = RouterLink;
});
System.registerDynamic("angular2/src/router/location/hash_location_strategy.js", ["angular2/core.js", "angular2/src/router/location/location_strategy.js", "angular2/src/facade/lang.js", "angular2/src/router/location/platform_location.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var __param = this && this.__param || function (paramIndex, decorator) {
        return function (target, key) {
            decorator(target, key, paramIndex);
        };
    };
    var core_1 = $__require("angular2/core.js");
    var location_strategy_1 = $__require("angular2/src/router/location/location_strategy.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var platform_location_1 = $__require("angular2/src/router/location/platform_location.js");
    /**
     * `HashLocationStrategy` is a {@link LocationStrategy} used to configure the
     * {@link Location} service to represent its state in the
     * [hash fragment](https://en.wikipedia.org/wiki/Uniform_Resource_Locator#Syntax)
     * of the browser's URL.
     *
     * For instance, if you call `location.go('/foo')`, the browser's URL will become
     * `example.com#/foo`.
     *
     * ### Example
     *
     * ```
     * import {Component, provide} from 'angular2/core';
     * import {
     *   ROUTER_DIRECTIVES,
     *   ROUTER_PROVIDERS,
     *   RouteConfig,
     *   Location,
     *   LocationStrategy,
     *   HashLocationStrategy
     * } from 'angular2/router';
     *
     * @Component({directives: [ROUTER_DIRECTIVES]})
     * @RouteConfig([
     *  {...},
     * ])
     * class AppCmp {
     *   constructor(location: Location) {
     *     location.go('/foo');
     *   }
     * }
     *
     * bootstrap(AppCmp, [
     *   ROUTER_PROVIDERS,
     *   provide(LocationStrategy, {useClass: HashLocationStrategy})
     * ]);
     * ```
     */
    var HashLocationStrategy = function (_super) {
        __extends(HashLocationStrategy, _super);
        function HashLocationStrategy(_platformLocation, _baseHref) {
            _super.call(this);
            this._platformLocation = _platformLocation;
            this._baseHref = '';
            if (lang_1.isPresent(_baseHref)) {
                this._baseHref = _baseHref;
            }
        }
        HashLocationStrategy.prototype.onPopState = function (fn) {
            this._platformLocation.onPopState(fn);
            this._platformLocation.onHashChange(fn);
        };
        HashLocationStrategy.prototype.getBaseHref = function () {
            return this._baseHref;
        };
        HashLocationStrategy.prototype.path = function () {
            // the hash value is always prefixed with a `#`
            // and if it is empty then it will stay empty
            var path = this._platformLocation.hash;
            if (!lang_1.isPresent(path)) path = '#';
            // Dart will complain if a call to substring is
            // executed with a position value that extends the
            // length of string.
            return path.length > 0 ? path.substring(1) : path;
        };
        HashLocationStrategy.prototype.prepareExternalUrl = function (internal) {
            var url = location_strategy_1.joinWithSlash(this._baseHref, internal);
            return url.length > 0 ? '#' + url : url;
        };
        HashLocationStrategy.prototype.pushState = function (state, title, path, queryParams) {
            var url = this.prepareExternalUrl(path + location_strategy_1.normalizeQueryParams(queryParams));
            if (url.length == 0) {
                url = this._platformLocation.pathname;
            }
            this._platformLocation.pushState(state, title, url);
        };
        HashLocationStrategy.prototype.replaceState = function (state, title, path, queryParams) {
            var url = this.prepareExternalUrl(path + location_strategy_1.normalizeQueryParams(queryParams));
            if (url.length == 0) {
                url = this._platformLocation.pathname;
            }
            this._platformLocation.replaceState(state, title, url);
        };
        HashLocationStrategy.prototype.forward = function () {
            this._platformLocation.forward();
        };
        HashLocationStrategy.prototype.back = function () {
            this._platformLocation.back();
        };
        HashLocationStrategy = __decorate([core_1.Injectable(), __param(1, core_1.Optional()), __param(1, core_1.Inject(location_strategy_1.APP_BASE_HREF)), __metadata('design:paramtypes', [platform_location_1.PlatformLocation, String])], HashLocationStrategy);
        return HashLocationStrategy;
    }(location_strategy_1.LocationStrategy);
    exports.HashLocationStrategy = HashLocationStrategy;
});
System.registerDynamic('angular2/src/router/lifecycle/lifecycle_annotations.js', ['angular2/src/core/util/decorators.js', 'angular2/src/router/lifecycle/lifecycle_annotations_impl.js'], true, function ($__require, exports, module) {
  'use strict'; /**
                * This indirection is needed to free up Component, etc symbols in the public API
                * to be used by the decorator versions of these annotations.
                */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var decorators_1 = $__require('angular2/src/core/util/decorators.js');
  var lifecycle_annotations_impl_1 = $__require('angular2/src/router/lifecycle/lifecycle_annotations_impl.js');
  var lifecycle_annotations_impl_2 = $__require('angular2/src/router/lifecycle/lifecycle_annotations_impl.js');
  exports.routerCanReuse = lifecycle_annotations_impl_2.routerCanReuse;
  exports.routerCanDeactivate = lifecycle_annotations_impl_2.routerCanDeactivate;
  exports.routerOnActivate = lifecycle_annotations_impl_2.routerOnActivate;
  exports.routerOnReuse = lifecycle_annotations_impl_2.routerOnReuse;
  exports.routerOnDeactivate = lifecycle_annotations_impl_2.routerOnDeactivate;
  /**
   * Defines route lifecycle hook `CanActivate`, which is called by the router to determine
   * if a component can be instantiated as part of a navigation.
   *
   * <aside class="is-right">
   * Note that unlike other lifecycle hooks, this one uses an annotation rather than an interface.
   * This is because the `CanActivate` function is called before the component is instantiated.
   * </aside>
   *
   * The `CanActivate` hook is called with two {@link ComponentInstruction}s as parameters, the first
   * representing the current route being navigated to, and the second parameter representing the
   * previous route or `null`.
   *
   * ```typescript
   * @CanActivate((next, prev) => boolean | Promise<boolean>)
   * ```
   *
   * If `CanActivate` returns or resolves to `false`, the navigation is cancelled.
   * If `CanActivate` throws or rejects, the navigation is also cancelled.
   * If `CanActivate` returns or resolves to `true`, navigation continues, the component is
   * instantiated, and the {@link OnActivate} hook of that component is called if implemented.
   *
   * ### Example
   *
   * {@example router/ts/can_activate/can_activate_example.ts region='canActivate' }
   */
  exports.CanActivate = decorators_1.makeDecorator(lifecycle_annotations_impl_1.CanActivate);
});
System.registerDynamic("angular2/src/router/location/path_location_strategy.js", ["angular2/core.js", "angular2/src/facade/lang.js", "angular2/src/facade/exceptions.js", "angular2/src/router/location/location_strategy.js", "angular2/src/router/location/platform_location.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var __param = this && this.__param || function (paramIndex, decorator) {
        return function (target, key) {
            decorator(target, key, paramIndex);
        };
    };
    var core_1 = $__require("angular2/core.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var exceptions_1 = $__require("angular2/src/facade/exceptions.js");
    var location_strategy_1 = $__require("angular2/src/router/location/location_strategy.js");
    var platform_location_1 = $__require("angular2/src/router/location/platform_location.js");
    /**
     * `PathLocationStrategy` is a {@link LocationStrategy} used to configure the
     * {@link Location} service to represent its state in the
     * [path](https://en.wikipedia.org/wiki/Uniform_Resource_Locator#Syntax) of the
     * browser's URL.
     *
     * `PathLocationStrategy` is the default binding for {@link LocationStrategy}
     * provided in {@link ROUTER_PROVIDERS}.
     *
     * If you're using `PathLocationStrategy`, you must provide a provider for
     * {@link APP_BASE_HREF} to a string representing the URL prefix that should
     * be preserved when generating and recognizing URLs.
     *
     * For instance, if you provide an `APP_BASE_HREF` of `'/my/app'` and call
     * `location.go('/foo')`, the browser's URL will become
     * `example.com/my/app/foo`.
     *
     * ### Example
     *
     * ```
     * import {Component, provide} from 'angular2/core';
     * import {
     *   APP_BASE_HREF
     *   ROUTER_DIRECTIVES,
     *   ROUTER_PROVIDERS,
     *   RouteConfig,
     *   Location
     * } from 'angular2/router';
     *
     * @Component({directives: [ROUTER_DIRECTIVES]})
     * @RouteConfig([
     *  {...},
     * ])
     * class AppCmp {
     *   constructor(location: Location) {
     *     location.go('/foo');
     *   }
     * }
     *
     * bootstrap(AppCmp, [
     *   ROUTER_PROVIDERS, // includes binding to PathLocationStrategy
     *   provide(APP_BASE_HREF, {useValue: '/my/app'})
     * ]);
     * ```
     */
    var PathLocationStrategy = function (_super) {
        __extends(PathLocationStrategy, _super);
        function PathLocationStrategy(_platformLocation, href) {
            _super.call(this);
            this._platformLocation = _platformLocation;
            if (lang_1.isBlank(href)) {
                href = this._platformLocation.getBaseHrefFromDOM();
            }
            if (lang_1.isBlank(href)) {
                throw new exceptions_1.BaseException("No base href set. Please provide a value for the APP_BASE_HREF token or add a base element to the document.");
            }
            this._baseHref = href;
        }
        PathLocationStrategy.prototype.onPopState = function (fn) {
            this._platformLocation.onPopState(fn);
            this._platformLocation.onHashChange(fn);
        };
        PathLocationStrategy.prototype.getBaseHref = function () {
            return this._baseHref;
        };
        PathLocationStrategy.prototype.prepareExternalUrl = function (internal) {
            return location_strategy_1.joinWithSlash(this._baseHref, internal);
        };
        PathLocationStrategy.prototype.path = function () {
            return this._platformLocation.pathname + location_strategy_1.normalizeQueryParams(this._platformLocation.search);
        };
        PathLocationStrategy.prototype.pushState = function (state, title, url, queryParams) {
            var externalUrl = this.prepareExternalUrl(url + location_strategy_1.normalizeQueryParams(queryParams));
            this._platformLocation.pushState(state, title, externalUrl);
        };
        PathLocationStrategy.prototype.replaceState = function (state, title, url, queryParams) {
            var externalUrl = this.prepareExternalUrl(url + location_strategy_1.normalizeQueryParams(queryParams));
            this._platformLocation.replaceState(state, title, externalUrl);
        };
        PathLocationStrategy.prototype.forward = function () {
            this._platformLocation.forward();
        };
        PathLocationStrategy.prototype.back = function () {
            this._platformLocation.back();
        };
        PathLocationStrategy = __decorate([core_1.Injectable(), __param(1, core_1.Optional()), __param(1, core_1.Inject(location_strategy_1.APP_BASE_HREF)), __metadata('design:paramtypes', [platform_location_1.PlatformLocation, String])], PathLocationStrategy);
        return PathLocationStrategy;
    }(location_strategy_1.LocationStrategy);
    exports.PathLocationStrategy = PathLocationStrategy;
});
System.registerDynamic("angular2/src/router/lifecycle/lifecycle_annotations_impl.js", ["angular2/src/facade/lang.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var RouteLifecycleHook = function () {
        function RouteLifecycleHook(name) {
            this.name = name;
        }
        RouteLifecycleHook = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [String])], RouteLifecycleHook);
        return RouteLifecycleHook;
    }();
    exports.RouteLifecycleHook = RouteLifecycleHook;
    var CanActivate = function () {
        function CanActivate(fn) {
            this.fn = fn;
        }
        CanActivate = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [Function])], CanActivate);
        return CanActivate;
    }();
    exports.CanActivate = CanActivate;
    exports.routerCanReuse = lang_1.CONST_EXPR(new RouteLifecycleHook("routerCanReuse"));
    exports.routerCanDeactivate = lang_1.CONST_EXPR(new RouteLifecycleHook("routerCanDeactivate"));
    exports.routerOnActivate = lang_1.CONST_EXPR(new RouteLifecycleHook("routerOnActivate"));
    exports.routerOnReuse = lang_1.CONST_EXPR(new RouteLifecycleHook("routerOnReuse"));
    exports.routerOnDeactivate = lang_1.CONST_EXPR(new RouteLifecycleHook("routerOnDeactivate"));
});
System.registerDynamic('angular2/src/router/lifecycle/route_lifecycle_reflector.js', ['angular2/src/facade/lang.js', 'angular2/src/router/lifecycle/lifecycle_annotations_impl.js', 'angular2/src/core/reflection/reflection.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var lifecycle_annotations_impl_1 = $__require('angular2/src/router/lifecycle/lifecycle_annotations_impl.js');
    var reflection_1 = $__require('angular2/src/core/reflection/reflection.js');
    function hasLifecycleHook(e, type) {
        if (!(type instanceof lang_1.Type)) return false;
        return e.name in type.prototype;
    }
    exports.hasLifecycleHook = hasLifecycleHook;
    function getCanActivateHook(type) {
        var annotations = reflection_1.reflector.annotations(type);
        for (var i = 0; i < annotations.length; i += 1) {
            var annotation = annotations[i];
            if (annotation instanceof lifecycle_annotations_impl_1.CanActivate) {
                return annotation.fn;
            }
        }
        return null;
    }
    exports.getCanActivateHook = getCanActivateHook;
});
System.registerDynamic("angular2/src/router/router.js", ["angular2/src/facade/async.js", "angular2/src/facade/collection.js", "angular2/src/facade/lang.js", "angular2/src/facade/exceptions.js", "angular2/core.js", "angular2/src/router/route_registry.js", "angular2/src/router/location/location.js", "angular2/src/router/lifecycle/route_lifecycle_reflector.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var __param = this && this.__param || function (paramIndex, decorator) {
        return function (target, key) {
            decorator(target, key, paramIndex);
        };
    };
    var async_1 = $__require("angular2/src/facade/async.js");
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var exceptions_1 = $__require("angular2/src/facade/exceptions.js");
    var core_1 = $__require("angular2/core.js");
    var route_registry_1 = $__require("angular2/src/router/route_registry.js");
    var location_1 = $__require("angular2/src/router/location/location.js");
    var route_lifecycle_reflector_1 = $__require("angular2/src/router/lifecycle/route_lifecycle_reflector.js");
    var _resolveToTrue = async_1.PromiseWrapper.resolve(true);
    var _resolveToFalse = async_1.PromiseWrapper.resolve(false);
    /**
     * The `Router` is responsible for mapping URLs to components.
     *
     * You can see the state of the router by inspecting the read-only field `router.navigating`.
     * This may be useful for showing a spinner, for instance.
     *
     * ## Concepts
     *
     * Routers and component instances have a 1:1 correspondence.
     *
     * The router holds reference to a number of {@link RouterOutlet}.
     * An outlet is a placeholder that the router dynamically fills in depending on the current URL.
     *
     * When the router navigates from a URL, it must first recognize it and serialize it into an
     * `Instruction`.
     * The router uses the `RouteRegistry` to get an `Instruction`.
     */
    var Router = function () {
        function Router(registry, parent, hostComponent, root) {
            this.registry = registry;
            this.parent = parent;
            this.hostComponent = hostComponent;
            this.root = root;
            this.navigating = false;
            /**
             * The current `Instruction` for the router
             */
            this.currentInstruction = null;
            this._currentNavigation = _resolveToTrue;
            this._outlet = null;
            this._auxRouters = new collection_1.Map();
            this._subject = new async_1.EventEmitter();
        }
        /**
         * Constructs a child router. You probably don't need to use this unless you're writing a reusable
         * component.
         */
        Router.prototype.childRouter = function (hostComponent) {
            return this._childRouter = new ChildRouter(this, hostComponent);
        };
        /**
         * Constructs a child router. You probably don't need to use this unless you're writing a reusable
         * component.
         */
        Router.prototype.auxRouter = function (hostComponent) {
            return new ChildRouter(this, hostComponent);
        };
        /**
         * Register an outlet to be notified of primary route changes.
         *
         * You probably don't need to use this unless you're writing a reusable component.
         */
        Router.prototype.registerPrimaryOutlet = function (outlet) {
            if (lang_1.isPresent(outlet.name)) {
                throw new exceptions_1.BaseException("registerPrimaryOutlet expects to be called with an unnamed outlet.");
            }
            if (lang_1.isPresent(this._outlet)) {
                throw new exceptions_1.BaseException("Primary outlet is already registered.");
            }
            this._outlet = outlet;
            if (lang_1.isPresent(this.currentInstruction)) {
                return this.commit(this.currentInstruction, false);
            }
            return _resolveToTrue;
        };
        /**
         * Unregister an outlet (because it was destroyed, etc).
         *
         * You probably don't need to use this unless you're writing a custom outlet implementation.
         */
        Router.prototype.unregisterPrimaryOutlet = function (outlet) {
            if (lang_1.isPresent(outlet.name)) {
                throw new exceptions_1.BaseException("registerPrimaryOutlet expects to be called with an unnamed outlet.");
            }
            this._outlet = null;
        };
        /**
         * Register an outlet to notified of auxiliary route changes.
         *
         * You probably don't need to use this unless you're writing a reusable component.
         */
        Router.prototype.registerAuxOutlet = function (outlet) {
            var outletName = outlet.name;
            if (lang_1.isBlank(outletName)) {
                throw new exceptions_1.BaseException("registerAuxOutlet expects to be called with an outlet with a name.");
            }
            var router = this.auxRouter(this.hostComponent);
            this._auxRouters.set(outletName, router);
            router._outlet = outlet;
            var auxInstruction;
            if (lang_1.isPresent(this.currentInstruction) && lang_1.isPresent(auxInstruction = this.currentInstruction.auxInstruction[outletName])) {
                return router.commit(auxInstruction);
            }
            return _resolveToTrue;
        };
        /**
         * Given an instruction, returns `true` if the instruction is currently active,
         * otherwise `false`.
         */
        Router.prototype.isRouteActive = function (instruction) {
            var _this = this;
            var router = this;
            if (lang_1.isBlank(this.currentInstruction)) {
                return false;
            }
            // `instruction` corresponds to the root router
            while (lang_1.isPresent(router.parent) && lang_1.isPresent(instruction.child)) {
                router = router.parent;
                instruction = instruction.child;
            }
            if (lang_1.isBlank(instruction.component) || lang_1.isBlank(this.currentInstruction.component) || this.currentInstruction.component.routeName != instruction.component.routeName) {
                return false;
            }
            var paramEquals = true;
            if (lang_1.isPresent(this.currentInstruction.component.params)) {
                collection_1.StringMapWrapper.forEach(instruction.component.params, function (value, key) {
                    if (_this.currentInstruction.component.params[key] !== value) {
                        paramEquals = false;
                    }
                });
            }
            return paramEquals;
        };
        /**
         * Dynamically update the routing configuration and trigger a navigation.
         *
         * ### Usage
         *
         * ```
         * router.config([
         *   { 'path': '/', 'component': IndexComp },
         *   { 'path': '/user/:id', 'component': UserComp },
         * ]);
         * ```
         */
        Router.prototype.config = function (definitions) {
            var _this = this;
            definitions.forEach(function (routeDefinition) {
                _this.registry.config(_this.hostComponent, routeDefinition);
            });
            return this.renavigate();
        };
        /**
         * Navigate based on the provided Route Link DSL. It's preferred to navigate with this method
         * over `navigateByUrl`.
         *
         * ### Usage
         *
         * This method takes an array representing the Route Link DSL:
         * ```
         * ['./MyCmp', {param: 3}]
         * ```
         * See the {@link RouterLink} directive for more.
         */
        Router.prototype.navigate = function (linkParams) {
            var instruction = this.generate(linkParams);
            return this.navigateByInstruction(instruction, false);
        };
        /**
         * Navigate to a URL. Returns a promise that resolves when navigation is complete.
         * It's preferred to navigate with `navigate` instead of this method, since URLs are more brittle.
         *
         * If the given URL begins with a `/`, router will navigate absolutely.
         * If the given URL does not begin with `/`, the router will navigate relative to this component.
         */
        Router.prototype.navigateByUrl = function (url, _skipLocationChange) {
            var _this = this;
            if (_skipLocationChange === void 0) {
                _skipLocationChange = false;
            }
            return this._currentNavigation = this._currentNavigation.then(function (_) {
                _this.lastNavigationAttempt = url;
                _this._startNavigating();
                return _this._afterPromiseFinishNavigating(_this.recognize(url).then(function (instruction) {
                    if (lang_1.isBlank(instruction)) {
                        return false;
                    }
                    return _this._navigate(instruction, _skipLocationChange);
                }));
            });
        };
        /**
         * Navigate via the provided instruction. Returns a promise that resolves when navigation is
         * complete.
         */
        Router.prototype.navigateByInstruction = function (instruction, _skipLocationChange) {
            var _this = this;
            if (_skipLocationChange === void 0) {
                _skipLocationChange = false;
            }
            if (lang_1.isBlank(instruction)) {
                return _resolveToFalse;
            }
            return this._currentNavigation = this._currentNavigation.then(function (_) {
                _this._startNavigating();
                return _this._afterPromiseFinishNavigating(_this._navigate(instruction, _skipLocationChange));
            });
        };
        /** @internal */
        Router.prototype._settleInstruction = function (instruction) {
            var _this = this;
            return instruction.resolveComponent().then(function (_) {
                var unsettledInstructions = [];
                if (lang_1.isPresent(instruction.component)) {
                    instruction.component.reuse = false;
                }
                if (lang_1.isPresent(instruction.child)) {
                    unsettledInstructions.push(_this._settleInstruction(instruction.child));
                }
                collection_1.StringMapWrapper.forEach(instruction.auxInstruction, function (instruction, _) {
                    unsettledInstructions.push(_this._settleInstruction(instruction));
                });
                return async_1.PromiseWrapper.all(unsettledInstructions);
            });
        };
        /** @internal */
        Router.prototype._navigate = function (instruction, _skipLocationChange) {
            var _this = this;
            return this._settleInstruction(instruction).then(function (_) {
                return _this._routerCanReuse(instruction);
            }).then(function (_) {
                return _this._canActivate(instruction);
            }).then(function (result) {
                if (!result) {
                    return false;
                }
                return _this._routerCanDeactivate(instruction).then(function (result) {
                    if (result) {
                        return _this.commit(instruction, _skipLocationChange).then(function (_) {
                            _this._emitNavigationFinish(instruction.toRootUrl());
                            return true;
                        });
                    }
                });
            });
        };
        Router.prototype._emitNavigationFinish = function (url) {
            async_1.ObservableWrapper.callEmit(this._subject, url);
        };
        /** @internal */
        Router.prototype._emitNavigationFail = function (url) {
            async_1.ObservableWrapper.callError(this._subject, url);
        };
        Router.prototype._afterPromiseFinishNavigating = function (promise) {
            var _this = this;
            return async_1.PromiseWrapper.catchError(promise.then(function (_) {
                return _this._finishNavigating();
            }), function (err) {
                _this._finishNavigating();
                throw err;
            });
        };
        /*
         * Recursively set reuse flags
         */
        /** @internal */
        Router.prototype._routerCanReuse = function (instruction) {
            var _this = this;
            if (lang_1.isBlank(this._outlet)) {
                return _resolveToFalse;
            }
            if (lang_1.isBlank(instruction.component)) {
                return _resolveToTrue;
            }
            return this._outlet.routerCanReuse(instruction.component).then(function (result) {
                instruction.component.reuse = result;
                if (result && lang_1.isPresent(_this._childRouter) && lang_1.isPresent(instruction.child)) {
                    return _this._childRouter._routerCanReuse(instruction.child);
                }
            });
        };
        Router.prototype._canActivate = function (nextInstruction) {
            return canActivateOne(nextInstruction, this.currentInstruction);
        };
        Router.prototype._routerCanDeactivate = function (instruction) {
            var _this = this;
            if (lang_1.isBlank(this._outlet)) {
                return _resolveToTrue;
            }
            var next;
            var childInstruction = null;
            var reuse = false;
            var componentInstruction = null;
            if (lang_1.isPresent(instruction)) {
                childInstruction = instruction.child;
                componentInstruction = instruction.component;
                reuse = lang_1.isBlank(instruction.component) || instruction.component.reuse;
            }
            if (reuse) {
                next = _resolveToTrue;
            } else {
                next = this._outlet.routerCanDeactivate(componentInstruction);
            }
            // TODO: aux route lifecycle hooks
            return next.then(function (result) {
                if (result == false) {
                    return false;
                }
                if (lang_1.isPresent(_this._childRouter)) {
                    // TODO: ideally, this closure would map to async-await in Dart.
                    // For now, casting to any to suppress an error.
                    return _this._childRouter._routerCanDeactivate(childInstruction);
                }
                return true;
            });
        };
        /**
         * Updates this router and all descendant routers according to the given instruction
         */
        Router.prototype.commit = function (instruction, _skipLocationChange) {
            var _this = this;
            if (_skipLocationChange === void 0) {
                _skipLocationChange = false;
            }
            this.currentInstruction = instruction;
            var next = _resolveToTrue;
            if (lang_1.isPresent(this._outlet) && lang_1.isPresent(instruction.component)) {
                var componentInstruction = instruction.component;
                if (componentInstruction.reuse) {
                    next = this._outlet.reuse(componentInstruction);
                } else {
                    next = this.deactivate(instruction).then(function (_) {
                        return _this._outlet.activate(componentInstruction);
                    });
                }
                if (lang_1.isPresent(instruction.child)) {
                    next = next.then(function (_) {
                        if (lang_1.isPresent(_this._childRouter)) {
                            return _this._childRouter.commit(instruction.child);
                        }
                    });
                }
            }
            var promises = [];
            this._auxRouters.forEach(function (router, name) {
                if (lang_1.isPresent(instruction.auxInstruction[name])) {
                    promises.push(router.commit(instruction.auxInstruction[name]));
                }
            });
            return next.then(function (_) {
                return async_1.PromiseWrapper.all(promises);
            });
        };
        /** @internal */
        Router.prototype._startNavigating = function () {
            this.navigating = true;
        };
        /** @internal */
        Router.prototype._finishNavigating = function () {
            this.navigating = false;
        };
        /**
         * Subscribe to URL updates from the router
         */
        Router.prototype.subscribe = function (onNext, onError) {
            return async_1.ObservableWrapper.subscribe(this._subject, onNext, onError);
        };
        /**
         * Removes the contents of this router's outlet and all descendant outlets
         */
        Router.prototype.deactivate = function (instruction) {
            var _this = this;
            var childInstruction = null;
            var componentInstruction = null;
            if (lang_1.isPresent(instruction)) {
                childInstruction = instruction.child;
                componentInstruction = instruction.component;
            }
            var next = _resolveToTrue;
            if (lang_1.isPresent(this._childRouter)) {
                next = this._childRouter.deactivate(childInstruction);
            }
            if (lang_1.isPresent(this._outlet)) {
                next = next.then(function (_) {
                    return _this._outlet.deactivate(componentInstruction);
                });
            }
            // TODO: handle aux routes
            return next;
        };
        /**
         * Given a URL, returns an instruction representing the component graph
         */
        Router.prototype.recognize = function (url) {
            var ancestorComponents = this._getAncestorInstructions();
            return this.registry.recognize(url, ancestorComponents);
        };
        Router.prototype._getAncestorInstructions = function () {
            var ancestorInstructions = [this.currentInstruction];
            var ancestorRouter = this;
            while (lang_1.isPresent(ancestorRouter = ancestorRouter.parent)) {
                ancestorInstructions.unshift(ancestorRouter.currentInstruction);
            }
            return ancestorInstructions;
        };
        /**
         * Navigates to either the last URL successfully navigated to, or the last URL requested if the
         * router has yet to successfully navigate.
         */
        Router.prototype.renavigate = function () {
            if (lang_1.isBlank(this.lastNavigationAttempt)) {
                return this._currentNavigation;
            }
            return this.navigateByUrl(this.lastNavigationAttempt);
        };
        /**
         * Generate an `Instruction` based on the provided Route Link DSL.
         */
        Router.prototype.generate = function (linkParams) {
            var ancestorInstructions = this._getAncestorInstructions();
            return this.registry.generate(linkParams, ancestorInstructions);
        };
        Router = __decorate([core_1.Injectable(), __metadata('design:paramtypes', [route_registry_1.RouteRegistry, Router, Object, Router])], Router);
        return Router;
    }();
    exports.Router = Router;
    var RootRouter = function (_super) {
        __extends(RootRouter, _super);
        function RootRouter(registry, location, primaryComponent) {
            var _this = this;
            _super.call(this, registry, null, primaryComponent);
            this.root = this;
            this._location = location;
            this._locationSub = this._location.subscribe(function (change) {
                // we call recognize ourselves
                _this.recognize(change['url']).then(function (instruction) {
                    if (lang_1.isPresent(instruction)) {
                        _this.navigateByInstruction(instruction, lang_1.isPresent(change['pop'])).then(function (_) {
                            // this is a popstate event; no need to change the URL
                            if (lang_1.isPresent(change['pop']) && change['type'] != 'hashchange') {
                                return;
                            }
                            var emitPath = instruction.toUrlPath();
                            var emitQuery = instruction.toUrlQuery();
                            if (emitPath.length > 0 && emitPath[0] != '/') {
                                emitPath = '/' + emitPath;
                            }
                            // We've opted to use pushstate and popState APIs regardless of whether you
                            // an app uses HashLocationStrategy or PathLocationStrategy.
                            // However, apps that are migrating might have hash links that operate outside
                            // angular to which routing must respond.
                            // Therefore we know that all hashchange events occur outside Angular.
                            // To support these cases where we respond to hashchanges and redirect as a
                            // result, we need to replace the top item on the stack.
                            if (change['type'] == 'hashchange') {
                                if (instruction.toRootUrl() != _this._location.path()) {
                                    _this._location.replaceState(emitPath, emitQuery);
                                }
                            } else {
                                _this._location.go(emitPath, emitQuery);
                            }
                        });
                    } else {
                        _this._emitNavigationFail(change['url']);
                    }
                });
            });
            this.registry.configFromComponent(primaryComponent);
            this.navigateByUrl(location.path());
        }
        RootRouter.prototype.commit = function (instruction, _skipLocationChange) {
            var _this = this;
            if (_skipLocationChange === void 0) {
                _skipLocationChange = false;
            }
            var emitPath = instruction.toUrlPath();
            var emitQuery = instruction.toUrlQuery();
            if (emitPath.length > 0 && emitPath[0] != '/') {
                emitPath = '/' + emitPath;
            }
            var promise = _super.prototype.commit.call(this, instruction);
            if (!_skipLocationChange) {
                promise = promise.then(function (_) {
                    _this._location.go(emitPath, emitQuery);
                });
            }
            return promise;
        };
        RootRouter.prototype.dispose = function () {
            if (lang_1.isPresent(this._locationSub)) {
                async_1.ObservableWrapper.dispose(this._locationSub);
                this._locationSub = null;
            }
        };
        RootRouter = __decorate([core_1.Injectable(), __param(2, core_1.Inject(route_registry_1.ROUTER_PRIMARY_COMPONENT)), __metadata('design:paramtypes', [route_registry_1.RouteRegistry, location_1.Location, lang_1.Type])], RootRouter);
        return RootRouter;
    }(Router);
    exports.RootRouter = RootRouter;
    var ChildRouter = function (_super) {
        __extends(ChildRouter, _super);
        function ChildRouter(parent, hostComponent) {
            _super.call(this, parent.registry, parent, hostComponent, parent.root);
            this.parent = parent;
        }
        ChildRouter.prototype.navigateByUrl = function (url, _skipLocationChange) {
            if (_skipLocationChange === void 0) {
                _skipLocationChange = false;
            }
            // Delegate navigation to the root router
            return this.parent.navigateByUrl(url, _skipLocationChange);
        };
        ChildRouter.prototype.navigateByInstruction = function (instruction, _skipLocationChange) {
            if (_skipLocationChange === void 0) {
                _skipLocationChange = false;
            }
            // Delegate navigation to the root router
            return this.parent.navigateByInstruction(instruction, _skipLocationChange);
        };
        return ChildRouter;
    }(Router);
    function canActivateOne(nextInstruction, prevInstruction) {
        var next = _resolveToTrue;
        if (lang_1.isBlank(nextInstruction.component)) {
            return next;
        }
        if (lang_1.isPresent(nextInstruction.child)) {
            next = canActivateOne(nextInstruction.child, lang_1.isPresent(prevInstruction) ? prevInstruction.child : null);
        }
        return next.then(function (result) {
            if (result == false) {
                return false;
            }
            if (nextInstruction.component.reuse) {
                return true;
            }
            var hook = route_lifecycle_reflector_1.getCanActivateHook(nextInstruction.component.componentType);
            if (lang_1.isPresent(hook)) {
                return hook(nextInstruction.component, lang_1.isPresent(prevInstruction) ? prevInstruction.component : null);
            }
            return true;
        });
    }
});
System.registerDynamic('angular2/src/router/rules/rules.js', ['angular2/src/facade/lang.js', 'angular2/src/facade/exceptions.js', 'angular2/src/facade/promise.js', 'angular2/src/facade/collection.js', 'angular2/src/router/url_parser.js', 'angular2/src/router/instruction.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var exceptions_1 = $__require('angular2/src/facade/exceptions.js');
    var promise_1 = $__require('angular2/src/facade/promise.js');
    var collection_1 = $__require('angular2/src/facade/collection.js');
    var url_parser_1 = $__require('angular2/src/router/url_parser.js');
    var instruction_1 = $__require('angular2/src/router/instruction.js');
    // RouteMatch objects hold information about a match between a rule and a URL
    var RouteMatch = function () {
        function RouteMatch() {}
        return RouteMatch;
    }();
    exports.RouteMatch = RouteMatch;
    var PathMatch = function (_super) {
        __extends(PathMatch, _super);
        function PathMatch(instruction, remaining, remainingAux) {
            _super.call(this);
            this.instruction = instruction;
            this.remaining = remaining;
            this.remainingAux = remainingAux;
        }
        return PathMatch;
    }(RouteMatch);
    exports.PathMatch = PathMatch;
    var RedirectMatch = function (_super) {
        __extends(RedirectMatch, _super);
        function RedirectMatch(redirectTo, specificity) {
            _super.call(this);
            this.redirectTo = redirectTo;
            this.specificity = specificity;
        }
        return RedirectMatch;
    }(RouteMatch);
    exports.RedirectMatch = RedirectMatch;
    var RedirectRule = function () {
        function RedirectRule(_pathRecognizer, redirectTo) {
            this._pathRecognizer = _pathRecognizer;
            this.redirectTo = redirectTo;
            this.hash = this._pathRecognizer.hash;
        }
        Object.defineProperty(RedirectRule.prototype, "path", {
            get: function () {
                return this._pathRecognizer.toString();
            },
            set: function (val) {
                throw new exceptions_1.BaseException('you cannot set the path of a RedirectRule directly');
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Returns `null` or a `ParsedUrl` representing the new path to match
         */
        RedirectRule.prototype.recognize = function (beginningSegment) {
            var match = null;
            if (lang_1.isPresent(this._pathRecognizer.matchUrl(beginningSegment))) {
                match = new RedirectMatch(this.redirectTo, this._pathRecognizer.specificity);
            }
            return promise_1.PromiseWrapper.resolve(match);
        };
        RedirectRule.prototype.generate = function (params) {
            throw new exceptions_1.BaseException("Tried to generate a redirect.");
        };
        return RedirectRule;
    }();
    exports.RedirectRule = RedirectRule;
    // represents something like '/foo/:bar'
    var RouteRule = function () {
        // TODO: cache component instruction instances by params and by ParsedUrl instance
        function RouteRule(_routePath, handler, _routeName) {
            this._routePath = _routePath;
            this.handler = handler;
            this._routeName = _routeName;
            this._cache = new collection_1.Map();
            this.specificity = this._routePath.specificity;
            this.hash = this._routePath.hash;
            this.terminal = this._routePath.terminal;
        }
        Object.defineProperty(RouteRule.prototype, "path", {
            get: function () {
                return this._routePath.toString();
            },
            set: function (val) {
                throw new exceptions_1.BaseException('you cannot set the path of a RouteRule directly');
            },
            enumerable: true,
            configurable: true
        });
        RouteRule.prototype.recognize = function (beginningSegment) {
            var _this = this;
            var res = this._routePath.matchUrl(beginningSegment);
            if (lang_1.isBlank(res)) {
                return null;
            }
            return this.handler.resolveComponentType().then(function (_) {
                var componentInstruction = _this._getInstruction(res.urlPath, res.urlParams, res.allParams);
                return new PathMatch(componentInstruction, res.rest, res.auxiliary);
            });
        };
        RouteRule.prototype.generate = function (params) {
            var generated = this._routePath.generateUrl(params);
            var urlPath = generated.urlPath;
            var urlParams = generated.urlParams;
            return this._getInstruction(urlPath, url_parser_1.convertUrlParamsToArray(urlParams), params);
        };
        RouteRule.prototype.generateComponentPathValues = function (params) {
            return this._routePath.generateUrl(params);
        };
        RouteRule.prototype._getInstruction = function (urlPath, urlParams, params) {
            if (lang_1.isBlank(this.handler.componentType)) {
                throw new exceptions_1.BaseException("Tried to get instruction before the type was loaded.");
            }
            var hashKey = urlPath + '?' + urlParams.join('&');
            if (this._cache.has(hashKey)) {
                return this._cache.get(hashKey);
            }
            var instruction = new instruction_1.ComponentInstruction(urlPath, urlParams, this.handler.data, this.handler.componentType, this.terminal, this.specificity, params, this._routeName);
            this._cache.set(hashKey, instruction);
            return instruction;
        };
        return RouteRule;
    }();
    exports.RouteRule = RouteRule;
});
System.registerDynamic('angular2/src/router/rules/route_handlers/async_route_handler.js', ['angular2/src/facade/lang.js', 'angular2/src/router/instruction.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var instruction_1 = $__require('angular2/src/router/instruction.js');
    var AsyncRouteHandler = function () {
        function AsyncRouteHandler(_loader, data) {
            if (data === void 0) {
                data = null;
            }
            this._loader = _loader;
            /** @internal */
            this._resolvedComponent = null;
            this.data = lang_1.isPresent(data) ? new instruction_1.RouteData(data) : instruction_1.BLANK_ROUTE_DATA;
        }
        AsyncRouteHandler.prototype.resolveComponentType = function () {
            var _this = this;
            if (lang_1.isPresent(this._resolvedComponent)) {
                return this._resolvedComponent;
            }
            return this._resolvedComponent = this._loader().then(function (componentType) {
                _this.componentType = componentType;
                return componentType;
            });
        };
        return AsyncRouteHandler;
    }();
    exports.AsyncRouteHandler = AsyncRouteHandler;
});
System.registerDynamic('angular2/src/router/rules/route_handlers/sync_route_handler.js', ['angular2/src/facade/async.js', 'angular2/src/facade/lang.js', 'angular2/src/router/instruction.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var async_1 = $__require('angular2/src/facade/async.js');
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var instruction_1 = $__require('angular2/src/router/instruction.js');
    var SyncRouteHandler = function () {
        function SyncRouteHandler(componentType, data) {
            this.componentType = componentType;
            /** @internal */
            this._resolvedComponent = null;
            this._resolvedComponent = async_1.PromiseWrapper.resolve(componentType);
            this.data = lang_1.isPresent(data) ? new instruction_1.RouteData(data) : instruction_1.BLANK_ROUTE_DATA;
        }
        SyncRouteHandler.prototype.resolveComponentType = function () {
            return this._resolvedComponent;
        };
        return SyncRouteHandler;
    }();
    exports.SyncRouteHandler = SyncRouteHandler;
});
System.registerDynamic('angular2/src/router/utils.js', ['angular2/src/facade/lang.js', 'angular2/src/facade/collection.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var collection_1 = $__require('angular2/src/facade/collection.js');
    var TouchMap = function () {
        function TouchMap(map) {
            var _this = this;
            this.map = {};
            this.keys = {};
            if (lang_1.isPresent(map)) {
                collection_1.StringMapWrapper.forEach(map, function (value, key) {
                    _this.map[key] = lang_1.isPresent(value) ? value.toString() : null;
                    _this.keys[key] = true;
                });
            }
        }
        TouchMap.prototype.get = function (key) {
            collection_1.StringMapWrapper.delete(this.keys, key);
            return this.map[key];
        };
        TouchMap.prototype.getUnused = function () {
            var _this = this;
            var unused = {};
            var keys = collection_1.StringMapWrapper.keys(this.keys);
            keys.forEach(function (key) {
                return unused[key] = collection_1.StringMapWrapper.get(_this.map, key);
            });
            return unused;
        };
        return TouchMap;
    }();
    exports.TouchMap = TouchMap;
    function normalizeString(obj) {
        if (lang_1.isBlank(obj)) {
            return null;
        } else {
            return obj.toString();
        }
    }
    exports.normalizeString = normalizeString;
});
System.registerDynamic('angular2/src/router/rules/route_paths/param_route_path.js', ['angular2/src/facade/lang.js', 'angular2/src/facade/exceptions.js', 'angular2/src/facade/collection.js', 'angular2/src/router/utils.js', 'angular2/src/router/url_parser.js', 'angular2/src/router/rules/route_paths/route_path.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var exceptions_1 = $__require('angular2/src/facade/exceptions.js');
    var collection_1 = $__require('angular2/src/facade/collection.js');
    var utils_1 = $__require('angular2/src/router/utils.js');
    var url_parser_1 = $__require('angular2/src/router/url_parser.js');
    var route_path_1 = $__require('angular2/src/router/rules/route_paths/route_path.js');
    /**
     * Identified by a `...` URL segment. This indicates that the
     * Route will continue to be matched by child `Router`s.
     */
    var ContinuationPathSegment = function () {
        function ContinuationPathSegment() {
            this.name = '';
            this.specificity = '';
            this.hash = '...';
        }
        ContinuationPathSegment.prototype.generate = function (params) {
            return '';
        };
        ContinuationPathSegment.prototype.match = function (path) {
            return true;
        };
        return ContinuationPathSegment;
    }();
    /**
     * Identified by a string not starting with a `:` or `*`.
     * Only matches the URL segments that equal the segment path
     */
    var StaticPathSegment = function () {
        function StaticPathSegment(path) {
            this.path = path;
            this.name = '';
            this.specificity = '2';
            this.hash = path;
        }
        StaticPathSegment.prototype.match = function (path) {
            return path == this.path;
        };
        StaticPathSegment.prototype.generate = function (params) {
            return this.path;
        };
        return StaticPathSegment;
    }();
    /**
     * Identified by a string starting with `:`. Indicates a segment
     * that can contain a value that will be extracted and provided to
     * a matching `Instruction`.
     */
    var DynamicPathSegment = function () {
        function DynamicPathSegment(name) {
            this.name = name;
            this.specificity = '1';
            this.hash = ':';
        }
        DynamicPathSegment.prototype.match = function (path) {
            return path.length > 0;
        };
        DynamicPathSegment.prototype.generate = function (params) {
            if (!collection_1.StringMapWrapper.contains(params.map, this.name)) {
                throw new exceptions_1.BaseException("Route generator for '" + this.name + "' was not included in parameters passed.");
            }
            return encodeDynamicSegment(utils_1.normalizeString(params.get(this.name)));
        };
        DynamicPathSegment.paramMatcher = /^:([^\/]+)$/g;
        return DynamicPathSegment;
    }();
    /**
     * Identified by a string starting with `*` Indicates that all the following
     * segments match this route and that the value of these segments should
     * be provided to a matching `Instruction`.
     */
    var StarPathSegment = function () {
        function StarPathSegment(name) {
            this.name = name;
            this.specificity = '0';
            this.hash = '*';
        }
        StarPathSegment.prototype.match = function (path) {
            return true;
        };
        StarPathSegment.prototype.generate = function (params) {
            return utils_1.normalizeString(params.get(this.name));
        };
        StarPathSegment.wildcardMatcher = /^\*([^\/]+)$/g;
        return StarPathSegment;
    }();
    /**
     * Parses a URL string using a given matcher DSL, and generates URLs from param maps
     */
    var ParamRoutePath = function () {
        /**
         * Takes a string representing the matcher DSL
         */
        function ParamRoutePath(routePath) {
            this.routePath = routePath;
            this.terminal = true;
            this._assertValidPath(routePath);
            this._parsePathString(routePath);
            this.specificity = this._calculateSpecificity();
            this.hash = this._calculateHash();
            var lastSegment = this._segments[this._segments.length - 1];
            this.terminal = !(lastSegment instanceof ContinuationPathSegment);
        }
        ParamRoutePath.prototype.matchUrl = function (url) {
            var nextUrlSegment = url;
            var currentUrlSegment;
            var positionalParams = {};
            var captured = [];
            for (var i = 0; i < this._segments.length; i += 1) {
                var pathSegment = this._segments[i];
                currentUrlSegment = nextUrlSegment;
                if (pathSegment instanceof ContinuationPathSegment) {
                    break;
                }
                if (lang_1.isPresent(currentUrlSegment)) {
                    // the star segment consumes all of the remaining URL, including matrix params
                    if (pathSegment instanceof StarPathSegment) {
                        positionalParams[pathSegment.name] = currentUrlSegment.toString();
                        captured.push(currentUrlSegment.toString());
                        nextUrlSegment = null;
                        break;
                    }
                    captured.push(currentUrlSegment.path);
                    if (pathSegment instanceof DynamicPathSegment) {
                        positionalParams[pathSegment.name] = decodeDynamicSegment(currentUrlSegment.path);
                    } else if (!pathSegment.match(currentUrlSegment.path)) {
                        return null;
                    }
                    nextUrlSegment = currentUrlSegment.child;
                } else if (!pathSegment.match('')) {
                    return null;
                }
            }
            if (this.terminal && lang_1.isPresent(nextUrlSegment)) {
                return null;
            }
            var urlPath = captured.join('/');
            var auxiliary = [];
            var urlParams = [];
            var allParams = positionalParams;
            if (lang_1.isPresent(currentUrlSegment)) {
                // If this is the root component, read query params. Otherwise, read matrix params.
                var paramsSegment = url instanceof url_parser_1.RootUrl ? url : currentUrlSegment;
                if (lang_1.isPresent(paramsSegment.params)) {
                    allParams = collection_1.StringMapWrapper.merge(paramsSegment.params, positionalParams);
                    urlParams = url_parser_1.convertUrlParamsToArray(paramsSegment.params);
                } else {
                    allParams = positionalParams;
                }
                auxiliary = currentUrlSegment.auxiliary;
            }
            return new route_path_1.MatchedUrl(urlPath, urlParams, allParams, auxiliary, nextUrlSegment);
        };
        ParamRoutePath.prototype.generateUrl = function (params) {
            var paramTokens = new utils_1.TouchMap(params);
            var path = [];
            for (var i = 0; i < this._segments.length; i++) {
                var segment = this._segments[i];
                if (!(segment instanceof ContinuationPathSegment)) {
                    path.push(segment.generate(paramTokens));
                }
            }
            var urlPath = path.join('/');
            var nonPositionalParams = paramTokens.getUnused();
            var urlParams = nonPositionalParams;
            return new route_path_1.GeneratedUrl(urlPath, urlParams);
        };
        ParamRoutePath.prototype.toString = function () {
            return this.routePath;
        };
        ParamRoutePath.prototype._parsePathString = function (routePath) {
            // normalize route as not starting with a "/". Recognition will
            // also normalize.
            if (routePath.startsWith("/")) {
                routePath = routePath.substring(1);
            }
            var segmentStrings = routePath.split('/');
            this._segments = [];
            var limit = segmentStrings.length - 1;
            for (var i = 0; i <= limit; i++) {
                var segment = segmentStrings[i],
                    match;
                if (lang_1.isPresent(match = lang_1.RegExpWrapper.firstMatch(DynamicPathSegment.paramMatcher, segment))) {
                    this._segments.push(new DynamicPathSegment(match[1]));
                } else if (lang_1.isPresent(match = lang_1.RegExpWrapper.firstMatch(StarPathSegment.wildcardMatcher, segment))) {
                    this._segments.push(new StarPathSegment(match[1]));
                } else if (segment == '...') {
                    if (i < limit) {
                        throw new exceptions_1.BaseException("Unexpected \"...\" before the end of the path for \"" + routePath + "\".");
                    }
                    this._segments.push(new ContinuationPathSegment());
                } else {
                    this._segments.push(new StaticPathSegment(segment));
                }
            }
        };
        ParamRoutePath.prototype._calculateSpecificity = function () {
            // The "specificity" of a path is used to determine which route is used when multiple routes
            // match
            // a URL. Static segments (like "/foo") are the most specific, followed by dynamic segments
            // (like
            // "/:id"). Star segments add no specificity. Segments at the start of the path are more
            // specific
            // than proceeding ones.
            //
            // The code below uses place values to combine the different types of segments into a single
            // string that we can sort later. Each static segment is marked as a specificity of "2," each
            // dynamic segment is worth "1" specificity, and stars are worth "0" specificity.
            var i,
                length = this._segments.length,
                specificity;
            if (length == 0) {
                // a single slash (or "empty segment" is as specific as a static segment
                specificity += '2';
            } else {
                specificity = '';
                for (i = 0; i < length; i++) {
                    specificity += this._segments[i].specificity;
                }
            }
            return specificity;
        };
        ParamRoutePath.prototype._calculateHash = function () {
            // this function is used to determine whether a route config path like `/foo/:id` collides with
            // `/foo/:name`
            var i,
                length = this._segments.length;
            var hashParts = [];
            for (i = 0; i < length; i++) {
                hashParts.push(this._segments[i].hash);
            }
            return hashParts.join('/');
        };
        ParamRoutePath.prototype._assertValidPath = function (path) {
            if (lang_1.StringWrapper.contains(path, '#')) {
                throw new exceptions_1.BaseException("Path \"" + path + "\" should not include \"#\". Use \"HashLocationStrategy\" instead.");
            }
            var illegalCharacter = lang_1.RegExpWrapper.firstMatch(ParamRoutePath.RESERVED_CHARS, path);
            if (lang_1.isPresent(illegalCharacter)) {
                throw new exceptions_1.BaseException("Path \"" + path + "\" contains \"" + illegalCharacter[0] + "\" which is not allowed in a route config.");
            }
        };
        ParamRoutePath.RESERVED_CHARS = lang_1.RegExpWrapper.create('//|\\(|\\)|;|\\?|=');
        return ParamRoutePath;
    }();
    exports.ParamRoutePath = ParamRoutePath;
    var REGEXP_PERCENT = /%/g;
    var REGEXP_SLASH = /\//g;
    var REGEXP_OPEN_PARENT = /\(/g;
    var REGEXP_CLOSE_PARENT = /\)/g;
    var REGEXP_SEMICOLON = /;/g;
    function encodeDynamicSegment(value) {
        if (lang_1.isBlank(value)) {
            return null;
        }
        value = lang_1.StringWrapper.replaceAll(value, REGEXP_PERCENT, '%25');
        value = lang_1.StringWrapper.replaceAll(value, REGEXP_SLASH, '%2F');
        value = lang_1.StringWrapper.replaceAll(value, REGEXP_OPEN_PARENT, '%28');
        value = lang_1.StringWrapper.replaceAll(value, REGEXP_CLOSE_PARENT, '%29');
        value = lang_1.StringWrapper.replaceAll(value, REGEXP_SEMICOLON, '%3B');
        return value;
    }
    var REGEXP_ENC_SEMICOLON = /%3B/ig;
    var REGEXP_ENC_CLOSE_PARENT = /%29/ig;
    var REGEXP_ENC_OPEN_PARENT = /%28/ig;
    var REGEXP_ENC_SLASH = /%2F/ig;
    var REGEXP_ENC_PERCENT = /%25/ig;
    function decodeDynamicSegment(value) {
        if (lang_1.isBlank(value)) {
            return null;
        }
        value = lang_1.StringWrapper.replaceAll(value, REGEXP_ENC_SEMICOLON, ';');
        value = lang_1.StringWrapper.replaceAll(value, REGEXP_ENC_CLOSE_PARENT, ')');
        value = lang_1.StringWrapper.replaceAll(value, REGEXP_ENC_OPEN_PARENT, '(');
        value = lang_1.StringWrapper.replaceAll(value, REGEXP_ENC_SLASH, '/');
        value = lang_1.StringWrapper.replaceAll(value, REGEXP_ENC_PERCENT, '%');
        return value;
    }
});
System.registerDynamic("angular2/src/router/rules/route_paths/route_path.js", [], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var MatchedUrl = function () {
        function MatchedUrl(urlPath, urlParams, allParams, auxiliary, rest) {
            this.urlPath = urlPath;
            this.urlParams = urlParams;
            this.allParams = allParams;
            this.auxiliary = auxiliary;
            this.rest = rest;
        }
        return MatchedUrl;
    }();
    exports.MatchedUrl = MatchedUrl;
    var GeneratedUrl = function () {
        function GeneratedUrl(urlPath, urlParams) {
            this.urlPath = urlPath;
            this.urlParams = urlParams;
        }
        return GeneratedUrl;
    }();
    exports.GeneratedUrl = GeneratedUrl;
});
System.registerDynamic('angular2/src/router/rules/route_paths/regex_route_path.js', ['angular2/src/facade/lang.js', 'angular2/src/router/rules/route_paths/route_path.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var route_path_1 = $__require('angular2/src/router/rules/route_paths/route_path.js');
    var RegexRoutePath = function () {
        function RegexRoutePath(_reString, _serializer) {
            this._reString = _reString;
            this._serializer = _serializer;
            this.terminal = true;
            this.specificity = '2';
            this.hash = this._reString;
            this._regex = lang_1.RegExpWrapper.create(this._reString);
        }
        RegexRoutePath.prototype.matchUrl = function (url) {
            var urlPath = url.toString();
            var params = {};
            var matcher = lang_1.RegExpWrapper.matcher(this._regex, urlPath);
            var match = lang_1.RegExpMatcherWrapper.next(matcher);
            if (lang_1.isBlank(match)) {
                return null;
            }
            for (var i = 0; i < match.length; i += 1) {
                params[i.toString()] = match[i];
            }
            return new route_path_1.MatchedUrl(urlPath, [], params, [], null);
        };
        RegexRoutePath.prototype.generateUrl = function (params) {
            return this._serializer(params);
        };
        RegexRoutePath.prototype.toString = function () {
            return this._reString;
        };
        return RegexRoutePath;
    }();
    exports.RegexRoutePath = RegexRoutePath;
});
System.registerDynamic('angular2/src/router/rules/rule_set.js', ['angular2/src/facade/lang.js', 'angular2/src/facade/exceptions.js', 'angular2/src/facade/collection.js', 'angular2/src/facade/async.js', 'angular2/src/router/rules/rules.js', 'angular2/src/router/route_config/route_config_impl.js', 'angular2/src/router/rules/route_handlers/async_route_handler.js', 'angular2/src/router/rules/route_handlers/sync_route_handler.js', 'angular2/src/router/rules/route_paths/param_route_path.js', 'angular2/src/router/rules/route_paths/regex_route_path.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var exceptions_1 = $__require('angular2/src/facade/exceptions.js');
    var collection_1 = $__require('angular2/src/facade/collection.js');
    var async_1 = $__require('angular2/src/facade/async.js');
    var rules_1 = $__require('angular2/src/router/rules/rules.js');
    var route_config_impl_1 = $__require('angular2/src/router/route_config/route_config_impl.js');
    var async_route_handler_1 = $__require('angular2/src/router/rules/route_handlers/async_route_handler.js');
    var sync_route_handler_1 = $__require('angular2/src/router/rules/route_handlers/sync_route_handler.js');
    var param_route_path_1 = $__require('angular2/src/router/rules/route_paths/param_route_path.js');
    var regex_route_path_1 = $__require('angular2/src/router/rules/route_paths/regex_route_path.js');
    /**
     * A `RuleSet` is responsible for recognizing routes for a particular component.
     * It is consumed by `RouteRegistry`, which knows how to recognize an entire hierarchy of
     * components.
     */
    var RuleSet = function () {
        function RuleSet() {
            this.rulesByName = new collection_1.Map();
            // map from name to rule
            this.auxRulesByName = new collection_1.Map();
            // map from starting path to rule
            this.auxRulesByPath = new collection_1.Map();
            // TODO: optimize this into a trie
            this.rules = [];
            // the rule to use automatically when recognizing or generating from this rule set
            this.defaultRule = null;
        }
        /**
         * Configure additional rules in this rule set from a route definition
         * @returns {boolean} true if the config is terminal
         */
        RuleSet.prototype.config = function (config) {
            var handler;
            if (lang_1.isPresent(config.name) && config.name[0].toUpperCase() != config.name[0]) {
                var suggestedName = config.name[0].toUpperCase() + config.name.substring(1);
                throw new exceptions_1.BaseException("Route \"" + config.path + "\" with name \"" + config.name + "\" does not begin with an uppercase letter. Route names should be CamelCase like \"" + suggestedName + "\".");
            }
            if (config instanceof route_config_impl_1.AuxRoute) {
                handler = new sync_route_handler_1.SyncRouteHandler(config.component, config.data);
                var routePath_1 = this._getRoutePath(config);
                var auxRule = new rules_1.RouteRule(routePath_1, handler, config.name);
                this.auxRulesByPath.set(routePath_1.toString(), auxRule);
                if (lang_1.isPresent(config.name)) {
                    this.auxRulesByName.set(config.name, auxRule);
                }
                return auxRule.terminal;
            }
            var useAsDefault = false;
            if (config instanceof route_config_impl_1.Redirect) {
                var routePath_2 = this._getRoutePath(config);
                var redirector = new rules_1.RedirectRule(routePath_2, config.redirectTo);
                this._assertNoHashCollision(redirector.hash, config.path);
                this.rules.push(redirector);
                return true;
            }
            if (config instanceof route_config_impl_1.Route) {
                handler = new sync_route_handler_1.SyncRouteHandler(config.component, config.data);
                useAsDefault = lang_1.isPresent(config.useAsDefault) && config.useAsDefault;
            } else if (config instanceof route_config_impl_1.AsyncRoute) {
                handler = new async_route_handler_1.AsyncRouteHandler(config.loader, config.data);
                useAsDefault = lang_1.isPresent(config.useAsDefault) && config.useAsDefault;
            }
            var routePath = this._getRoutePath(config);
            var newRule = new rules_1.RouteRule(routePath, handler, config.name);
            this._assertNoHashCollision(newRule.hash, config.path);
            if (useAsDefault) {
                if (lang_1.isPresent(this.defaultRule)) {
                    throw new exceptions_1.BaseException("Only one route can be default");
                }
                this.defaultRule = newRule;
            }
            this.rules.push(newRule);
            if (lang_1.isPresent(config.name)) {
                this.rulesByName.set(config.name, newRule);
            }
            return newRule.terminal;
        };
        /**
         * Given a URL, returns a list of `RouteMatch`es, which are partial recognitions for some route.
         */
        RuleSet.prototype.recognize = function (urlParse) {
            var solutions = [];
            this.rules.forEach(function (routeRecognizer) {
                var pathMatch = routeRecognizer.recognize(urlParse);
                if (lang_1.isPresent(pathMatch)) {
                    solutions.push(pathMatch);
                }
            });
            // handle cases where we are routing just to an aux route
            if (solutions.length == 0 && lang_1.isPresent(urlParse) && urlParse.auxiliary.length > 0) {
                return [async_1.PromiseWrapper.resolve(new rules_1.PathMatch(null, null, urlParse.auxiliary))];
            }
            return solutions;
        };
        RuleSet.prototype.recognizeAuxiliary = function (urlParse) {
            var routeRecognizer = this.auxRulesByPath.get(urlParse.path);
            if (lang_1.isPresent(routeRecognizer)) {
                return [routeRecognizer.recognize(urlParse)];
            }
            return [async_1.PromiseWrapper.resolve(null)];
        };
        RuleSet.prototype.hasRoute = function (name) {
            return this.rulesByName.has(name);
        };
        RuleSet.prototype.componentLoaded = function (name) {
            return this.hasRoute(name) && lang_1.isPresent(this.rulesByName.get(name).handler.componentType);
        };
        RuleSet.prototype.loadComponent = function (name) {
            return this.rulesByName.get(name).handler.resolveComponentType();
        };
        RuleSet.prototype.generate = function (name, params) {
            var rule = this.rulesByName.get(name);
            if (lang_1.isBlank(rule)) {
                return null;
            }
            return rule.generate(params);
        };
        RuleSet.prototype.generateAuxiliary = function (name, params) {
            var rule = this.auxRulesByName.get(name);
            if (lang_1.isBlank(rule)) {
                return null;
            }
            return rule.generate(params);
        };
        RuleSet.prototype._assertNoHashCollision = function (hash, path) {
            this.rules.forEach(function (rule) {
                if (hash == rule.hash) {
                    throw new exceptions_1.BaseException("Configuration '" + path + "' conflicts with existing route '" + rule.path + "'");
                }
            });
        };
        RuleSet.prototype._getRoutePath = function (config) {
            if (lang_1.isPresent(config.regex)) {
                if (lang_1.isFunction(config.serializer)) {
                    return new regex_route_path_1.RegexRoutePath(config.regex, config.serializer);
                } else {
                    throw new exceptions_1.BaseException("Route provides a regex property, '" + config.regex + "', but no serializer property");
                }
            }
            if (lang_1.isPresent(config.path)) {
                // Auxiliary routes do not have a slash at the start
                var path = config instanceof route_config_impl_1.AuxRoute && config.path.startsWith('/') ? config.path.substring(1) : config.path;
                return new param_route_path_1.ParamRoutePath(path);
            }
            throw new exceptions_1.BaseException('Route must provide either a path or regex property');
        };
        return RuleSet;
    }();
    exports.RuleSet = RuleSet;
});
System.registerDynamic('angular2/src/router/instruction.js', ['angular2/src/facade/collection.js', 'angular2/src/facade/lang.js', 'angular2/src/facade/async.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var collection_1 = $__require('angular2/src/facade/collection.js');
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var async_1 = $__require('angular2/src/facade/async.js');
    /**
     * `RouteParams` is an immutable map of parameters for the given route
     * based on the url matcher and optional parameters for that route.
     *
     * You can inject `RouteParams` into the constructor of a component to use it.
     *
     * ### Example
     *
     * ```
     * import {Component} from 'angular2/core';
     * import {bootstrap} from 'angular2/platform/browser';
     * import {Router, ROUTER_DIRECTIVES, ROUTER_PROVIDERS, RouteConfig, RouteParams} from
     * 'angular2/router';
     *
     * @Component({directives: [ROUTER_DIRECTIVES]})
     * @RouteConfig([
     *  {path: '/user/:id', component: UserCmp, name: 'UserCmp'},
     * ])
     * class AppCmp {}
     *
     * @Component({ template: 'user: {{id}}' })
     * class UserCmp {
     *   id: string;
     *   constructor(params: RouteParams) {
     *     this.id = params.get('id');
     *   }
     * }
     *
     * bootstrap(AppCmp, ROUTER_PROVIDERS);
     * ```
     */
    var RouteParams = function () {
        function RouteParams(params) {
            this.params = params;
        }
        RouteParams.prototype.get = function (param) {
            return lang_1.normalizeBlank(collection_1.StringMapWrapper.get(this.params, param));
        };
        return RouteParams;
    }();
    exports.RouteParams = RouteParams;
    /**
     * `RouteData` is an immutable map of additional data you can configure in your {@link Route}.
     *
     * You can inject `RouteData` into the constructor of a component to use it.
     *
     * ### Example
     *
     * ```
     * import {Component} from 'angular2/core';
     * import {bootstrap} from 'angular2/platform/browser';
     * import {Router, ROUTER_DIRECTIVES, ROUTER_PROVIDERS, RouteConfig, RouteData} from
     * 'angular2/router';
     *
     * @Component({directives: [ROUTER_DIRECTIVES]})
     * @RouteConfig([
     *  {path: '/user/:id', component: UserCmp, name: 'UserCmp', data: {isAdmin: true}},
     * ])
     * class AppCmp {}
     *
     * @Component({
     *   ...,
     *   template: 'user: {{isAdmin}}'
     * })
     * class UserCmp {
     *   string: isAdmin;
     *   constructor(data: RouteData) {
     *     this.isAdmin = data.get('isAdmin');
     *   }
     * }
     *
     * bootstrap(AppCmp, ROUTER_PROVIDERS);
     * ```
     */
    var RouteData = function () {
        function RouteData(data) {
            if (data === void 0) {
                data = lang_1.CONST_EXPR({});
            }
            this.data = data;
        }
        RouteData.prototype.get = function (key) {
            return lang_1.normalizeBlank(collection_1.StringMapWrapper.get(this.data, key));
        };
        return RouteData;
    }();
    exports.RouteData = RouteData;
    exports.BLANK_ROUTE_DATA = new RouteData();
    /**
     * `Instruction` is a tree of {@link ComponentInstruction}s with all the information needed
     * to transition each component in the app to a given route, including all auxiliary routes.
     *
     * `Instruction`s can be created using {@link Router#generate}, and can be used to
     * perform route changes with {@link Router#navigateByInstruction}.
     *
     * ### Example
     *
     * ```
     * import {Component} from 'angular2/core';
     * import {bootstrap} from 'angular2/platform/browser';
     * import {Router, ROUTER_DIRECTIVES, ROUTER_PROVIDERS, RouteConfig} from 'angular2/router';
     *
     * @Component({directives: [ROUTER_DIRECTIVES]})
     * @RouteConfig([
     *  {...},
     * ])
     * class AppCmp {
     *   constructor(router: Router) {
     *     var instruction = router.generate(['/MyRoute']);
     *     router.navigateByInstruction(instruction);
     *   }
     * }
     *
     * bootstrap(AppCmp, ROUTER_PROVIDERS);
     * ```
     */
    var Instruction = function () {
        function Instruction(component, child, auxInstruction) {
            this.component = component;
            this.child = child;
            this.auxInstruction = auxInstruction;
        }
        Object.defineProperty(Instruction.prototype, "urlPath", {
            get: function () {
                return lang_1.isPresent(this.component) ? this.component.urlPath : '';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Instruction.prototype, "urlParams", {
            get: function () {
                return lang_1.isPresent(this.component) ? this.component.urlParams : [];
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Instruction.prototype, "specificity", {
            get: function () {
                var total = '';
                if (lang_1.isPresent(this.component)) {
                    total += this.component.specificity;
                }
                if (lang_1.isPresent(this.child)) {
                    total += this.child.specificity;
                }
                return total;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * converts the instruction into a URL string
         */
        Instruction.prototype.toRootUrl = function () {
            return this.toUrlPath() + this.toUrlQuery();
        };
        /** @internal */
        Instruction.prototype._toNonRootUrl = function () {
            return this._stringifyPathMatrixAuxPrefixed() + (lang_1.isPresent(this.child) ? this.child._toNonRootUrl() : '');
        };
        Instruction.prototype.toUrlQuery = function () {
            return this.urlParams.length > 0 ? '?' + this.urlParams.join('&') : '';
        };
        /**
         * Returns a new instruction that shares the state of the existing instruction, but with
         * the given child {@link Instruction} replacing the existing child.
         */
        Instruction.prototype.replaceChild = function (child) {
            return new ResolvedInstruction(this.component, child, this.auxInstruction);
        };
        /**
         * If the final URL for the instruction is ``
         */
        Instruction.prototype.toUrlPath = function () {
            return this.urlPath + this._stringifyAux() + (lang_1.isPresent(this.child) ? this.child._toNonRootUrl() : '');
        };
        // default instructions override these
        Instruction.prototype.toLinkUrl = function () {
            return this.urlPath + this._stringifyAux() + (lang_1.isPresent(this.child) ? this.child._toLinkUrl() : '') + this.toUrlQuery();
        };
        // this is the non-root version (called recursively)
        /** @internal */
        Instruction.prototype._toLinkUrl = function () {
            return this._stringifyPathMatrixAuxPrefixed() + (lang_1.isPresent(this.child) ? this.child._toLinkUrl() : '');
        };
        /** @internal */
        Instruction.prototype._stringifyPathMatrixAuxPrefixed = function () {
            var primary = this._stringifyPathMatrixAux();
            if (primary.length > 0) {
                primary = '/' + primary;
            }
            return primary;
        };
        /** @internal */
        Instruction.prototype._stringifyMatrixParams = function () {
            return this.urlParams.length > 0 ? ';' + this.urlParams.join(';') : '';
        };
        /** @internal */
        Instruction.prototype._stringifyPathMatrixAux = function () {
            if (lang_1.isBlank(this.component)) {
                return '';
            }
            return this.urlPath + this._stringifyMatrixParams() + this._stringifyAux();
        };
        /** @internal */
        Instruction.prototype._stringifyAux = function () {
            var routes = [];
            collection_1.StringMapWrapper.forEach(this.auxInstruction, function (auxInstruction, _) {
                routes.push(auxInstruction._stringifyPathMatrixAux());
            });
            if (routes.length > 0) {
                return '(' + routes.join('//') + ')';
            }
            return '';
        };
        return Instruction;
    }();
    exports.Instruction = Instruction;
    /**
     * a resolved instruction has an outlet instruction for itself, but maybe not for...
     */
    var ResolvedInstruction = function (_super) {
        __extends(ResolvedInstruction, _super);
        function ResolvedInstruction(component, child, auxInstruction) {
            _super.call(this, component, child, auxInstruction);
        }
        ResolvedInstruction.prototype.resolveComponent = function () {
            return async_1.PromiseWrapper.resolve(this.component);
        };
        return ResolvedInstruction;
    }(Instruction);
    exports.ResolvedInstruction = ResolvedInstruction;
    /**
     * Represents a resolved default route
     */
    var DefaultInstruction = function (_super) {
        __extends(DefaultInstruction, _super);
        function DefaultInstruction(component, child) {
            _super.call(this, component, child, {});
        }
        DefaultInstruction.prototype.toLinkUrl = function () {
            return '';
        };
        /** @internal */
        DefaultInstruction.prototype._toLinkUrl = function () {
            return '';
        };
        return DefaultInstruction;
    }(ResolvedInstruction);
    exports.DefaultInstruction = DefaultInstruction;
    /**
     * Represents a component that may need to do some redirection or lazy loading at a later time.
     */
    var UnresolvedInstruction = function (_super) {
        __extends(UnresolvedInstruction, _super);
        function UnresolvedInstruction(_resolver, _urlPath, _urlParams) {
            if (_urlPath === void 0) {
                _urlPath = '';
            }
            if (_urlParams === void 0) {
                _urlParams = lang_1.CONST_EXPR([]);
            }
            _super.call(this, null, null, {});
            this._resolver = _resolver;
            this._urlPath = _urlPath;
            this._urlParams = _urlParams;
        }
        Object.defineProperty(UnresolvedInstruction.prototype, "urlPath", {
            get: function () {
                if (lang_1.isPresent(this.component)) {
                    return this.component.urlPath;
                }
                if (lang_1.isPresent(this._urlPath)) {
                    return this._urlPath;
                }
                return '';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(UnresolvedInstruction.prototype, "urlParams", {
            get: function () {
                if (lang_1.isPresent(this.component)) {
                    return this.component.urlParams;
                }
                if (lang_1.isPresent(this._urlParams)) {
                    return this._urlParams;
                }
                return [];
            },
            enumerable: true,
            configurable: true
        });
        UnresolvedInstruction.prototype.resolveComponent = function () {
            var _this = this;
            if (lang_1.isPresent(this.component)) {
                return async_1.PromiseWrapper.resolve(this.component);
            }
            return this._resolver().then(function (instruction) {
                _this.child = lang_1.isPresent(instruction) ? instruction.child : null;
                return _this.component = lang_1.isPresent(instruction) ? instruction.component : null;
            });
        };
        return UnresolvedInstruction;
    }(Instruction);
    exports.UnresolvedInstruction = UnresolvedInstruction;
    var RedirectInstruction = function (_super) {
        __extends(RedirectInstruction, _super);
        function RedirectInstruction(component, child, auxInstruction, _specificity) {
            _super.call(this, component, child, auxInstruction);
            this._specificity = _specificity;
        }
        Object.defineProperty(RedirectInstruction.prototype, "specificity", {
            get: function () {
                return this._specificity;
            },
            enumerable: true,
            configurable: true
        });
        return RedirectInstruction;
    }(ResolvedInstruction);
    exports.RedirectInstruction = RedirectInstruction;
    /**
     * A `ComponentInstruction` represents the route state for a single component.
     *
     * `ComponentInstructions` is a public API. Instances of `ComponentInstruction` are passed
     * to route lifecycle hooks, like {@link CanActivate}.
     *
     * `ComponentInstruction`s are [hash consed](https://en.wikipedia.org/wiki/Hash_consing). You should
     * never construct one yourself with "new." Instead, rely on {@link Router/RouteRecognizer} to
     * construct `ComponentInstruction`s.
     *
     * You should not modify this object. It should be treated as immutable.
     */
    var ComponentInstruction = function () {
        /**
         * @internal
         */
        function ComponentInstruction(urlPath, urlParams, data, componentType, terminal, specificity, params, routeName) {
            if (params === void 0) {
                params = null;
            }
            this.urlPath = urlPath;
            this.urlParams = urlParams;
            this.componentType = componentType;
            this.terminal = terminal;
            this.specificity = specificity;
            this.params = params;
            this.routeName = routeName;
            this.reuse = false;
            this.routeData = lang_1.isPresent(data) ? data : exports.BLANK_ROUTE_DATA;
        }
        return ComponentInstruction;
    }();
    exports.ComponentInstruction = ComponentInstruction;
});
System.registerDynamic("angular2/src/router/route_config/route_config_impl.js", ["angular2/src/facade/lang.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var __make_dart_analyzer_happy = null;
    /**
     * The `RouteConfig` decorator defines routes for a given component.
     *
     * It takes an array of {@link RouteDefinition}s.
     */
    var RouteConfig = function () {
        function RouteConfig(configs) {
            this.configs = configs;
        }
        RouteConfig = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [Array])], RouteConfig);
        return RouteConfig;
    }();
    exports.RouteConfig = RouteConfig;
    var AbstractRoute = function () {
        function AbstractRoute(_a) {
            var name = _a.name,
                useAsDefault = _a.useAsDefault,
                path = _a.path,
                regex = _a.regex,
                serializer = _a.serializer,
                data = _a.data;
            this.name = name;
            this.useAsDefault = useAsDefault;
            this.path = path;
            this.regex = regex;
            this.serializer = serializer;
            this.data = data;
        }
        AbstractRoute = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [Object])], AbstractRoute);
        return AbstractRoute;
    }();
    exports.AbstractRoute = AbstractRoute;
    /**
     * `Route` is a type of {@link RouteDefinition} used to route a path to a component.
     *
     * It has the following properties:
     * - `path` is a string that uses the route matcher DSL.
     * - `component` a component type.
     * - `name` is an optional `CamelCase` string representing the name of the route.
     * - `data` is an optional property of any type representing arbitrary route metadata for the given
     * route. It is injectable via {@link RouteData}.
     * - `useAsDefault` is a boolean value. If `true`, the child route will be navigated to if no child
     * route is specified during the navigation.
     *
     * ### Example
     * ```
     * import {RouteConfig, Route} from 'angular2/router';
     *
     * @RouteConfig([
     *   new Route({path: '/home', component: HomeCmp, name: 'HomeCmp' })
     * ])
     * class MyApp {}
     * ```
     */
    var Route = function (_super) {
        __extends(Route, _super);
        function Route(_a) {
            var name = _a.name,
                useAsDefault = _a.useAsDefault,
                path = _a.path,
                regex = _a.regex,
                serializer = _a.serializer,
                data = _a.data,
                component = _a.component;
            _super.call(this, {
                name: name,
                useAsDefault: useAsDefault,
                path: path,
                regex: regex,
                serializer: serializer,
                data: data
            });
            this.aux = null;
            this.component = component;
        }
        Route = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [Object])], Route);
        return Route;
    }(AbstractRoute);
    exports.Route = Route;
    /**
     * `AuxRoute` is a type of {@link RouteDefinition} used to define an auxiliary route.
     *
     * It takes an object with the following properties:
     * - `path` is a string that uses the route matcher DSL.
     * - `component` a component type.
     * - `name` is an optional `CamelCase` string representing the name of the route.
     * - `data` is an optional property of any type representing arbitrary route metadata for the given
     * route. It is injectable via {@link RouteData}.
     *
     * ### Example
     * ```
     * import {RouteConfig, AuxRoute} from 'angular2/router';
     *
     * @RouteConfig([
     *   new AuxRoute({path: '/home', component: HomeCmp})
     * ])
     * class MyApp {}
     * ```
     */
    var AuxRoute = function (_super) {
        __extends(AuxRoute, _super);
        function AuxRoute(_a) {
            var name = _a.name,
                useAsDefault = _a.useAsDefault,
                path = _a.path,
                regex = _a.regex,
                serializer = _a.serializer,
                data = _a.data,
                component = _a.component;
            _super.call(this, {
                name: name,
                useAsDefault: useAsDefault,
                path: path,
                regex: regex,
                serializer: serializer,
                data: data
            });
            this.component = component;
        }
        AuxRoute = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [Object])], AuxRoute);
        return AuxRoute;
    }(AbstractRoute);
    exports.AuxRoute = AuxRoute;
    /**
     * `AsyncRoute` is a type of {@link RouteDefinition} used to route a path to an asynchronously
     * loaded component.
     *
     * It has the following properties:
     * - `path` is a string that uses the route matcher DSL.
     * - `loader` is a function that returns a promise that resolves to a component.
     * - `name` is an optional `CamelCase` string representing the name of the route.
     * - `data` is an optional property of any type representing arbitrary route metadata for the given
     * route. It is injectable via {@link RouteData}.
     * - `useAsDefault` is a boolean value. If `true`, the child route will be navigated to if no child
     * route is specified during the navigation.
     *
     * ### Example
     * ```
     * import {RouteConfig, AsyncRoute} from 'angular2/router';
     *
     * @RouteConfig([
     *   new AsyncRoute({path: '/home', loader: () => Promise.resolve(MyLoadedCmp), name:
     * 'MyLoadedCmp'})
     * ])
     * class MyApp {}
     * ```
     */
    var AsyncRoute = function (_super) {
        __extends(AsyncRoute, _super);
        function AsyncRoute(_a) {
            var name = _a.name,
                useAsDefault = _a.useAsDefault,
                path = _a.path,
                regex = _a.regex,
                serializer = _a.serializer,
                data = _a.data,
                loader = _a.loader;
            _super.call(this, {
                name: name,
                useAsDefault: useAsDefault,
                path: path,
                regex: regex,
                serializer: serializer,
                data: data
            });
            this.aux = null;
            this.loader = loader;
        }
        AsyncRoute = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [Object])], AsyncRoute);
        return AsyncRoute;
    }(AbstractRoute);
    exports.AsyncRoute = AsyncRoute;
    /**
     * `Redirect` is a type of {@link RouteDefinition} used to route a path to a canonical route.
     *
     * It has the following properties:
     * - `path` is a string that uses the route matcher DSL.
     * - `redirectTo` is an array representing the link DSL.
     *
     * Note that redirects **do not** affect how links are generated. For that, see the `useAsDefault`
     * option.
     *
     * ### Example
     * ```
     * import {RouteConfig, Route, Redirect} from 'angular2/router';
     *
     * @RouteConfig([
     *   new Redirect({path: '/', redirectTo: ['/Home'] }),
     *   new Route({path: '/home', component: HomeCmp, name: 'Home'})
     * ])
     * class MyApp {}
     * ```
     */
    var Redirect = function (_super) {
        __extends(Redirect, _super);
        function Redirect(_a) {
            var name = _a.name,
                useAsDefault = _a.useAsDefault,
                path = _a.path,
                regex = _a.regex,
                serializer = _a.serializer,
                data = _a.data,
                redirectTo = _a.redirectTo;
            _super.call(this, {
                name: name,
                useAsDefault: useAsDefault,
                path: path,
                regex: regex,
                serializer: serializer,
                data: data
            });
            this.redirectTo = redirectTo;
        }
        Redirect = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [Object])], Redirect);
        return Redirect;
    }(AbstractRoute);
    exports.Redirect = Redirect;
});
System.registerDynamic('angular2/src/router/route_config/route_config_decorator.js', ['angular2/src/router/route_config/route_config_impl.js', 'angular2/src/core/util/decorators.js'], true, function ($__require, exports, module) {
  'use strict';"use strict";

  var global = this || self,
      GLOBAL = global;
  var route_config_impl_1 = $__require('angular2/src/router/route_config/route_config_impl.js');
  var decorators_1 = $__require('angular2/src/core/util/decorators.js');
  var route_config_impl_2 = $__require('angular2/src/router/route_config/route_config_impl.js');
  exports.Route = route_config_impl_2.Route;
  exports.Redirect = route_config_impl_2.Redirect;
  exports.AuxRoute = route_config_impl_2.AuxRoute;
  exports.AsyncRoute = route_config_impl_2.AsyncRoute;
  // Copied from RouteConfig in route_config_impl.
  /**
   * The `RouteConfig` decorator defines routes for a given component.
   *
   * It takes an array of {@link RouteDefinition}s.
   */
  exports.RouteConfig = decorators_1.makeDecorator(route_config_impl_1.RouteConfig);
});
System.registerDynamic('angular2/src/router/route_config/route_config_normalizer.js', ['angular2/src/router/route_config/route_config_decorator.js', 'angular2/src/facade/lang.js', 'angular2/src/facade/exceptions.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var route_config_decorator_1 = $__require('angular2/src/router/route_config/route_config_decorator.js');
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var exceptions_1 = $__require('angular2/src/facade/exceptions.js');
    /**
     * Given a JS Object that represents a route config, returns a corresponding Route, AsyncRoute,
     * AuxRoute or Redirect object.
     *
     * Also wraps an AsyncRoute's loader function to add the loaded component's route config to the
     * `RouteRegistry`.
     */
    function normalizeRouteConfig(config, registry) {
        if (config instanceof route_config_decorator_1.AsyncRoute) {
            var wrappedLoader = wrapLoaderToReconfigureRegistry(config.loader, registry);
            return new route_config_decorator_1.AsyncRoute({
                path: config.path,
                loader: wrappedLoader,
                name: config.name,
                data: config.data,
                useAsDefault: config.useAsDefault
            });
        }
        if (config instanceof route_config_decorator_1.Route || config instanceof route_config_decorator_1.Redirect || config instanceof route_config_decorator_1.AuxRoute) {
            return config;
        }
        if (+!!config.component + +!!config.redirectTo + +!!config.loader != 1) {
            throw new exceptions_1.BaseException("Route config should contain exactly one \"component\", \"loader\", or \"redirectTo\" property.");
        }
        if (config.as && config.name) {
            throw new exceptions_1.BaseException("Route config should contain exactly one \"as\" or \"name\" property.");
        }
        if (config.as) {
            config.name = config.as;
        }
        if (config.loader) {
            var wrappedLoader = wrapLoaderToReconfigureRegistry(config.loader, registry);
            return new route_config_decorator_1.AsyncRoute({
                path: config.path,
                loader: wrappedLoader,
                name: config.name,
                data: config.data,
                useAsDefault: config.useAsDefault
            });
        }
        if (config.aux) {
            return new route_config_decorator_1.AuxRoute({ path: config.aux, component: config.component, name: config.name });
        }
        if (config.component) {
            if (typeof config.component == 'object') {
                var componentDefinitionObject = config.component;
                if (componentDefinitionObject.type == 'constructor') {
                    return new route_config_decorator_1.Route({
                        path: config.path,
                        component: componentDefinitionObject.constructor,
                        name: config.name,
                        data: config.data,
                        useAsDefault: config.useAsDefault
                    });
                } else if (componentDefinitionObject.type == 'loader') {
                    return new route_config_decorator_1.AsyncRoute({
                        path: config.path,
                        loader: componentDefinitionObject.loader,
                        name: config.name,
                        data: config.data,
                        useAsDefault: config.useAsDefault
                    });
                } else {
                    throw new exceptions_1.BaseException("Invalid component type \"" + componentDefinitionObject.type + "\". Valid types are \"constructor\" and \"loader\".");
                }
            }
            return new route_config_decorator_1.Route(config);
        }
        if (config.redirectTo) {
            return new route_config_decorator_1.Redirect({ path: config.path, redirectTo: config.redirectTo });
        }
        return config;
    }
    exports.normalizeRouteConfig = normalizeRouteConfig;
    function wrapLoaderToReconfigureRegistry(loader, registry) {
        return function () {
            return loader().then(function (componentType) {
                registry.configFromComponent(componentType);
                return componentType;
            });
        };
    }
    function assertComponentExists(component, path) {
        if (!lang_1.isType(component)) {
            throw new exceptions_1.BaseException("Component for route \"" + path + "\" is not defined, or is not a class.");
        }
    }
    exports.assertComponentExists = assertComponentExists;
});
System.registerDynamic('angular2/src/router/url_parser.js', ['angular2/src/facade/collection.js', 'angular2/src/facade/lang.js', 'angular2/src/facade/exceptions.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var collection_1 = $__require('angular2/src/facade/collection.js');
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var exceptions_1 = $__require('angular2/src/facade/exceptions.js');
    function convertUrlParamsToArray(urlParams) {
        var paramsArray = [];
        if (lang_1.isBlank(urlParams)) {
            return [];
        }
        collection_1.StringMapWrapper.forEach(urlParams, function (value, key) {
            paramsArray.push(value === true ? key : key + '=' + value);
        });
        return paramsArray;
    }
    exports.convertUrlParamsToArray = convertUrlParamsToArray;
    // Convert an object of url parameters into a string that can be used in an URL
    function serializeParams(urlParams, joiner) {
        if (joiner === void 0) {
            joiner = '&';
        }
        return convertUrlParamsToArray(urlParams).join(joiner);
    }
    exports.serializeParams = serializeParams;
    /**
     * This class represents a parsed URL
     */
    var Url = function () {
        function Url(path, child, auxiliary, params) {
            if (child === void 0) {
                child = null;
            }
            if (auxiliary === void 0) {
                auxiliary = lang_1.CONST_EXPR([]);
            }
            if (params === void 0) {
                params = lang_1.CONST_EXPR({});
            }
            this.path = path;
            this.child = child;
            this.auxiliary = auxiliary;
            this.params = params;
        }
        Url.prototype.toString = function () {
            return this.path + this._matrixParamsToString() + this._auxToString() + this._childString();
        };
        Url.prototype.segmentToString = function () {
            return this.path + this._matrixParamsToString();
        };
        /** @internal */
        Url.prototype._auxToString = function () {
            return this.auxiliary.length > 0 ? '(' + this.auxiliary.map(function (sibling) {
                return sibling.toString();
            }).join('//') + ')' : '';
        };
        Url.prototype._matrixParamsToString = function () {
            var paramString = serializeParams(this.params, ';');
            if (paramString.length > 0) {
                return ';' + paramString;
            }
            return '';
        };
        /** @internal */
        Url.prototype._childString = function () {
            return lang_1.isPresent(this.child) ? '/' + this.child.toString() : '';
        };
        return Url;
    }();
    exports.Url = Url;
    var RootUrl = function (_super) {
        __extends(RootUrl, _super);
        function RootUrl(path, child, auxiliary, params) {
            if (child === void 0) {
                child = null;
            }
            if (auxiliary === void 0) {
                auxiliary = lang_1.CONST_EXPR([]);
            }
            if (params === void 0) {
                params = null;
            }
            _super.call(this, path, child, auxiliary, params);
        }
        RootUrl.prototype.toString = function () {
            return this.path + this._auxToString() + this._childString() + this._queryParamsToString();
        };
        RootUrl.prototype.segmentToString = function () {
            return this.path + this._queryParamsToString();
        };
        RootUrl.prototype._queryParamsToString = function () {
            if (lang_1.isBlank(this.params)) {
                return '';
            }
            return '?' + serializeParams(this.params);
        };
        return RootUrl;
    }(Url);
    exports.RootUrl = RootUrl;
    function pathSegmentsToUrl(pathSegments) {
        var url = new Url(pathSegments[pathSegments.length - 1]);
        for (var i = pathSegments.length - 2; i >= 0; i -= 1) {
            url = new Url(pathSegments[i], url);
        }
        return url;
    }
    exports.pathSegmentsToUrl = pathSegmentsToUrl;
    var SEGMENT_RE = lang_1.RegExpWrapper.create('^[^\\/\\(\\)\\?;=&#]+');
    function matchUrlSegment(str) {
        var match = lang_1.RegExpWrapper.firstMatch(SEGMENT_RE, str);
        return lang_1.isPresent(match) ? match[0] : '';
    }
    var QUERY_PARAM_VALUE_RE = lang_1.RegExpWrapper.create('^[^\\(\\)\\?;&#]+');
    function matchUrlQueryParamValue(str) {
        var match = lang_1.RegExpWrapper.firstMatch(QUERY_PARAM_VALUE_RE, str);
        return lang_1.isPresent(match) ? match[0] : '';
    }
    var UrlParser = function () {
        function UrlParser() {}
        UrlParser.prototype.peekStartsWith = function (str) {
            return this._remaining.startsWith(str);
        };
        UrlParser.prototype.capture = function (str) {
            if (!this._remaining.startsWith(str)) {
                throw new exceptions_1.BaseException("Expected \"" + str + "\".");
            }
            this._remaining = this._remaining.substring(str.length);
        };
        UrlParser.prototype.parse = function (url) {
            this._remaining = url;
            if (url == '' || url == '/') {
                return new Url('');
            }
            return this.parseRoot();
        };
        // segment + (aux segments) + (query params)
        UrlParser.prototype.parseRoot = function () {
            if (this.peekStartsWith('/')) {
                this.capture('/');
            }
            var path = matchUrlSegment(this._remaining);
            this.capture(path);
            var aux = [];
            if (this.peekStartsWith('(')) {
                aux = this.parseAuxiliaryRoutes();
            }
            if (this.peekStartsWith(';')) {
                // TODO: should these params just be dropped?
                this.parseMatrixParams();
            }
            var child = null;
            if (this.peekStartsWith('/') && !this.peekStartsWith('//')) {
                this.capture('/');
                child = this.parseSegment();
            }
            var queryParams = null;
            if (this.peekStartsWith('?')) {
                queryParams = this.parseQueryParams();
            }
            return new RootUrl(path, child, aux, queryParams);
        };
        // segment + (matrix params) + (aux segments)
        UrlParser.prototype.parseSegment = function () {
            if (this._remaining.length == 0) {
                return null;
            }
            if (this.peekStartsWith('/')) {
                this.capture('/');
            }
            var path = matchUrlSegment(this._remaining);
            this.capture(path);
            var matrixParams = null;
            if (this.peekStartsWith(';')) {
                matrixParams = this.parseMatrixParams();
            }
            var aux = [];
            if (this.peekStartsWith('(')) {
                aux = this.parseAuxiliaryRoutes();
            }
            var child = null;
            if (this.peekStartsWith('/') && !this.peekStartsWith('//')) {
                this.capture('/');
                child = this.parseSegment();
            }
            return new Url(path, child, aux, matrixParams);
        };
        UrlParser.prototype.parseQueryParams = function () {
            var params = {};
            this.capture('?');
            this.parseQueryParam(params);
            while (this._remaining.length > 0 && this.peekStartsWith('&')) {
                this.capture('&');
                this.parseQueryParam(params);
            }
            return params;
        };
        UrlParser.prototype.parseMatrixParams = function () {
            var params = {};
            while (this._remaining.length > 0 && this.peekStartsWith(';')) {
                this.capture(';');
                this.parseParam(params);
            }
            return params;
        };
        UrlParser.prototype.parseParam = function (params) {
            var key = matchUrlSegment(this._remaining);
            if (lang_1.isBlank(key)) {
                return;
            }
            this.capture(key);
            var value = true;
            if (this.peekStartsWith('=')) {
                this.capture('=');
                var valueMatch = matchUrlSegment(this._remaining);
                if (lang_1.isPresent(valueMatch)) {
                    value = valueMatch;
                    this.capture(value);
                }
            }
            params[key] = value;
        };
        UrlParser.prototype.parseQueryParam = function (params) {
            var key = matchUrlSegment(this._remaining);
            if (lang_1.isBlank(key)) {
                return;
            }
            this.capture(key);
            var value = true;
            if (this.peekStartsWith('=')) {
                this.capture('=');
                var valueMatch = matchUrlQueryParamValue(this._remaining);
                if (lang_1.isPresent(valueMatch)) {
                    value = valueMatch;
                    this.capture(value);
                }
            }
            params[key] = value;
        };
        UrlParser.prototype.parseAuxiliaryRoutes = function () {
            var routes = [];
            this.capture('(');
            while (!this.peekStartsWith(')') && this._remaining.length > 0) {
                routes.push(this.parseSegment());
                if (this.peekStartsWith('//')) {
                    this.capture('//');
                }
            }
            this.capture(')');
            return routes;
        };
        return UrlParser;
    }();
    exports.UrlParser = UrlParser;
    exports.parser = new UrlParser();
});
System.registerDynamic("angular2/src/router/route_registry.js", ["angular2/src/facade/collection.js", "angular2/src/facade/async.js", "angular2/src/facade/lang.js", "angular2/src/facade/exceptions.js", "angular2/src/core/reflection/reflection.js", "angular2/core.js", "angular2/src/router/route_config/route_config_impl.js", "angular2/src/router/rules/rules.js", "angular2/src/router/rules/rule_set.js", "angular2/src/router/instruction.js", "angular2/src/router/route_config/route_config_normalizer.js", "angular2/src/router/url_parser.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var __param = this && this.__param || function (paramIndex, decorator) {
        return function (target, key) {
            decorator(target, key, paramIndex);
        };
    };
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var async_1 = $__require("angular2/src/facade/async.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var exceptions_1 = $__require("angular2/src/facade/exceptions.js");
    var reflection_1 = $__require("angular2/src/core/reflection/reflection.js");
    var core_1 = $__require("angular2/core.js");
    var route_config_impl_1 = $__require("angular2/src/router/route_config/route_config_impl.js");
    var rules_1 = $__require("angular2/src/router/rules/rules.js");
    var rule_set_1 = $__require("angular2/src/router/rules/rule_set.js");
    var instruction_1 = $__require("angular2/src/router/instruction.js");
    var route_config_normalizer_1 = $__require("angular2/src/router/route_config/route_config_normalizer.js");
    var url_parser_1 = $__require("angular2/src/router/url_parser.js");
    var _resolveToNull = async_1.PromiseWrapper.resolve(null);
    // A LinkItemArray is an array, which describes a set of routes
    // The items in the array are found in groups:
    // - the first item is the name of the route
    // - the next items are:
    //   - an object containing parameters
    //   - or an array describing an aux route
    // export type LinkRouteItem = string | Object;
    // export type LinkItem = LinkRouteItem | Array<LinkRouteItem>;
    // export type LinkItemArray = Array<LinkItem>;
    /**
     * Token used to bind the component with the top-level {@link RouteConfig}s for the
     * application.
     *
     * ### Example ([live demo](http://plnkr.co/edit/iRUP8B5OUbxCWQ3AcIDm))
     *
     * ```
     * import {Component} from 'angular2/core';
     * import {
     *   ROUTER_DIRECTIVES,
     *   ROUTER_PROVIDERS,
     *   RouteConfig
     * } from 'angular2/router';
     *
     * @Component({directives: [ROUTER_DIRECTIVES]})
     * @RouteConfig([
     *  {...},
     * ])
     * class AppCmp {
     *   // ...
     * }
     *
     * bootstrap(AppCmp, [ROUTER_PROVIDERS]);
     * ```
     */
    exports.ROUTER_PRIMARY_COMPONENT = lang_1.CONST_EXPR(new core_1.OpaqueToken('RouterPrimaryComponent'));
    /**
     * The RouteRegistry holds route configurations for each component in an Angular app.
     * It is responsible for creating Instructions from URLs, and generating URLs based on route and
     * parameters.
     */
    var RouteRegistry = function () {
        function RouteRegistry(_rootComponent) {
            this._rootComponent = _rootComponent;
            this._rules = new collection_1.Map();
        }
        /**
         * Given a component and a configuration object, add the route to this registry
         */
        RouteRegistry.prototype.config = function (parentComponent, config) {
            config = route_config_normalizer_1.normalizeRouteConfig(config, this);
            // this is here because Dart type guard reasons
            if (config instanceof route_config_impl_1.Route) {
                route_config_normalizer_1.assertComponentExists(config.component, config.path);
            } else if (config instanceof route_config_impl_1.AuxRoute) {
                route_config_normalizer_1.assertComponentExists(config.component, config.path);
            }
            var rules = this._rules.get(parentComponent);
            if (lang_1.isBlank(rules)) {
                rules = new rule_set_1.RuleSet();
                this._rules.set(parentComponent, rules);
            }
            var terminal = rules.config(config);
            if (config instanceof route_config_impl_1.Route) {
                if (terminal) {
                    assertTerminalComponent(config.component, config.path);
                } else {
                    this.configFromComponent(config.component);
                }
            }
        };
        /**
         * Reads the annotations of a component and configures the registry based on them
         */
        RouteRegistry.prototype.configFromComponent = function (component) {
            var _this = this;
            if (!lang_1.isType(component)) {
                return;
            }
            // Don't read the annotations from a type more than once –
            // this prevents an infinite loop if a component routes recursively.
            if (this._rules.has(component)) {
                return;
            }
            var annotations = reflection_1.reflector.annotations(component);
            if (lang_1.isPresent(annotations)) {
                for (var i = 0; i < annotations.length; i++) {
                    var annotation = annotations[i];
                    if (annotation instanceof route_config_impl_1.RouteConfig) {
                        var routeCfgs = annotation.configs;
                        routeCfgs.forEach(function (config) {
                            return _this.config(component, config);
                        });
                    }
                }
            }
        };
        /**
         * Given a URL and a parent component, return the most specific instruction for navigating
         * the application into the state specified by the url
         */
        RouteRegistry.prototype.recognize = function (url, ancestorInstructions) {
            var parsedUrl = url_parser_1.parser.parse(url);
            return this._recognize(parsedUrl, []);
        };
        /**
         * Recognizes all parent-child routes, but creates unresolved auxiliary routes
         */
        RouteRegistry.prototype._recognize = function (parsedUrl, ancestorInstructions, _aux) {
            var _this = this;
            if (_aux === void 0) {
                _aux = false;
            }
            var parentInstruction = collection_1.ListWrapper.last(ancestorInstructions);
            var parentComponent = lang_1.isPresent(parentInstruction) ? parentInstruction.component.componentType : this._rootComponent;
            var rules = this._rules.get(parentComponent);
            if (lang_1.isBlank(rules)) {
                return _resolveToNull;
            }
            // Matches some beginning part of the given URL
            var possibleMatches = _aux ? rules.recognizeAuxiliary(parsedUrl) : rules.recognize(parsedUrl);
            var matchPromises = possibleMatches.map(function (candidate) {
                return candidate.then(function (candidate) {
                    if (candidate instanceof rules_1.PathMatch) {
                        var auxParentInstructions = ancestorInstructions.length > 0 ? [collection_1.ListWrapper.last(ancestorInstructions)] : [];
                        var auxInstructions = _this._auxRoutesToUnresolved(candidate.remainingAux, auxParentInstructions);
                        var instruction = new instruction_1.ResolvedInstruction(candidate.instruction, null, auxInstructions);
                        if (lang_1.isBlank(candidate.instruction) || candidate.instruction.terminal) {
                            return instruction;
                        }
                        var newAncestorInstructions = ancestorInstructions.concat([instruction]);
                        return _this._recognize(candidate.remaining, newAncestorInstructions).then(function (childInstruction) {
                            if (lang_1.isBlank(childInstruction)) {
                                return null;
                            }
                            // redirect instructions are already absolute
                            if (childInstruction instanceof instruction_1.RedirectInstruction) {
                                return childInstruction;
                            }
                            instruction.child = childInstruction;
                            return instruction;
                        });
                    }
                    if (candidate instanceof rules_1.RedirectMatch) {
                        var instruction = _this.generate(candidate.redirectTo, ancestorInstructions.concat([null]));
                        return new instruction_1.RedirectInstruction(instruction.component, instruction.child, instruction.auxInstruction, candidate.specificity);
                    }
                });
            });
            if ((lang_1.isBlank(parsedUrl) || parsedUrl.path == '') && possibleMatches.length == 0) {
                return async_1.PromiseWrapper.resolve(this.generateDefault(parentComponent));
            }
            return async_1.PromiseWrapper.all(matchPromises).then(mostSpecific);
        };
        RouteRegistry.prototype._auxRoutesToUnresolved = function (auxRoutes, parentInstructions) {
            var _this = this;
            var unresolvedAuxInstructions = {};
            auxRoutes.forEach(function (auxUrl) {
                unresolvedAuxInstructions[auxUrl.path] = new instruction_1.UnresolvedInstruction(function () {
                    return _this._recognize(auxUrl, parentInstructions, true);
                });
            });
            return unresolvedAuxInstructions;
        };
        /**
         * Given a normalized list with component names and params like: `['user', {id: 3 }]`
         * generates a url with a leading slash relative to the provided `parentComponent`.
         *
         * If the optional param `_aux` is `true`, then we generate starting at an auxiliary
         * route boundary.
         */
        RouteRegistry.prototype.generate = function (linkParams, ancestorInstructions, _aux) {
            if (_aux === void 0) {
                _aux = false;
            }
            var params = splitAndFlattenLinkParams(linkParams);
            var prevInstruction;
            // The first segment should be either '.' (generate from parent) or '' (generate from root).
            // When we normalize above, we strip all the slashes, './' becomes '.' and '/' becomes ''.
            if (collection_1.ListWrapper.first(params) == '') {
                params.shift();
                prevInstruction = collection_1.ListWrapper.first(ancestorInstructions);
                ancestorInstructions = [];
            } else {
                prevInstruction = ancestorInstructions.length > 0 ? ancestorInstructions.pop() : null;
                if (collection_1.ListWrapper.first(params) == '.') {
                    params.shift();
                } else if (collection_1.ListWrapper.first(params) == '..') {
                    while (collection_1.ListWrapper.first(params) == '..') {
                        if (ancestorInstructions.length <= 0) {
                            throw new exceptions_1.BaseException("Link \"" + collection_1.ListWrapper.toJSON(linkParams) + "\" has too many \"../\" segments.");
                        }
                        prevInstruction = ancestorInstructions.pop();
                        params = collection_1.ListWrapper.slice(params, 1);
                    }
                } else {
                    // we must only peak at the link param, and not consume it
                    var routeName = collection_1.ListWrapper.first(params);
                    var parentComponentType = this._rootComponent;
                    var grandparentComponentType = null;
                    if (ancestorInstructions.length > 1) {
                        var parentComponentInstruction = ancestorInstructions[ancestorInstructions.length - 1];
                        var grandComponentInstruction = ancestorInstructions[ancestorInstructions.length - 2];
                        parentComponentType = parentComponentInstruction.component.componentType;
                        grandparentComponentType = grandComponentInstruction.component.componentType;
                    } else if (ancestorInstructions.length == 1) {
                        parentComponentType = ancestorInstructions[0].component.componentType;
                        grandparentComponentType = this._rootComponent;
                    }
                    // For a link with no leading `./`, `/`, or `../`, we look for a sibling and child.
                    // If both exist, we throw. Otherwise, we prefer whichever exists.
                    var childRouteExists = this.hasRoute(routeName, parentComponentType);
                    var parentRouteExists = lang_1.isPresent(grandparentComponentType) && this.hasRoute(routeName, grandparentComponentType);
                    if (parentRouteExists && childRouteExists) {
                        var msg = "Link \"" + collection_1.ListWrapper.toJSON(linkParams) + "\" is ambiguous, use \"./\" or \"../\" to disambiguate.";
                        throw new exceptions_1.BaseException(msg);
                    }
                    if (parentRouteExists) {
                        prevInstruction = ancestorInstructions.pop();
                    }
                }
            }
            if (params[params.length - 1] == '') {
                params.pop();
            }
            if (params.length > 0 && params[0] == '') {
                params.shift();
            }
            if (params.length < 1) {
                var msg = "Link \"" + collection_1.ListWrapper.toJSON(linkParams) + "\" must include a route name.";
                throw new exceptions_1.BaseException(msg);
            }
            var generatedInstruction = this._generate(params, ancestorInstructions, prevInstruction, _aux, linkParams);
            // we don't clone the first (root) element
            for (var i = ancestorInstructions.length - 1; i >= 0; i--) {
                var ancestorInstruction = ancestorInstructions[i];
                if (lang_1.isBlank(ancestorInstruction)) {
                    break;
                }
                generatedInstruction = ancestorInstruction.replaceChild(generatedInstruction);
            }
            return generatedInstruction;
        };
        /*
         * Internal helper that does not make any assertions about the beginning of the link DSL.
         * `ancestorInstructions` are parents that will be cloned.
         * `prevInstruction` is the existing instruction that would be replaced, but which might have
         * aux routes that need to be cloned.
         */
        RouteRegistry.prototype._generate = function (linkParams, ancestorInstructions, prevInstruction, _aux, _originalLink) {
            var _this = this;
            if (_aux === void 0) {
                _aux = false;
            }
            var parentComponentType = this._rootComponent;
            var componentInstruction = null;
            var auxInstructions = {};
            var parentInstruction = collection_1.ListWrapper.last(ancestorInstructions);
            if (lang_1.isPresent(parentInstruction) && lang_1.isPresent(parentInstruction.component)) {
                parentComponentType = parentInstruction.component.componentType;
            }
            if (linkParams.length == 0) {
                var defaultInstruction = this.generateDefault(parentComponentType);
                if (lang_1.isBlank(defaultInstruction)) {
                    throw new exceptions_1.BaseException("Link \"" + collection_1.ListWrapper.toJSON(_originalLink) + "\" does not resolve to a terminal instruction.");
                }
                return defaultInstruction;
            }
            // for non-aux routes, we want to reuse the predecessor's existing primary and aux routes
            // and only override routes for which the given link DSL provides
            if (lang_1.isPresent(prevInstruction) && !_aux) {
                auxInstructions = collection_1.StringMapWrapper.merge(prevInstruction.auxInstruction, auxInstructions);
                componentInstruction = prevInstruction.component;
            }
            var rules = this._rules.get(parentComponentType);
            if (lang_1.isBlank(rules)) {
                throw new exceptions_1.BaseException("Component \"" + lang_1.getTypeNameForDebugging(parentComponentType) + "\" has no route config.");
            }
            var linkParamIndex = 0;
            var routeParams = {};
            // first, recognize the primary route if one is provided
            if (linkParamIndex < linkParams.length && lang_1.isString(linkParams[linkParamIndex])) {
                var routeName = linkParams[linkParamIndex];
                if (routeName == '' || routeName == '.' || routeName == '..') {
                    throw new exceptions_1.BaseException("\"" + routeName + "/\" is only allowed at the beginning of a link DSL.");
                }
                linkParamIndex += 1;
                if (linkParamIndex < linkParams.length) {
                    var linkParam = linkParams[linkParamIndex];
                    if (lang_1.isStringMap(linkParam) && !lang_1.isArray(linkParam)) {
                        routeParams = linkParam;
                        linkParamIndex += 1;
                    }
                }
                var routeRecognizer = (_aux ? rules.auxRulesByName : rules.rulesByName).get(routeName);
                if (lang_1.isBlank(routeRecognizer)) {
                    throw new exceptions_1.BaseException("Component \"" + lang_1.getTypeNameForDebugging(parentComponentType) + "\" has no route named \"" + routeName + "\".");
                }
                // Create an "unresolved instruction" for async routes
                // we'll figure out the rest of the route when we resolve the instruction and
                // perform a navigation
                if (lang_1.isBlank(routeRecognizer.handler.componentType)) {
                    var generatedUrl = routeRecognizer.generateComponentPathValues(routeParams);
                    return new instruction_1.UnresolvedInstruction(function () {
                        return routeRecognizer.handler.resolveComponentType().then(function (_) {
                            return _this._generate(linkParams, ancestorInstructions, prevInstruction, _aux, _originalLink);
                        });
                    }, generatedUrl.urlPath, url_parser_1.convertUrlParamsToArray(generatedUrl.urlParams));
                }
                componentInstruction = _aux ? rules.generateAuxiliary(routeName, routeParams) : rules.generate(routeName, routeParams);
            }
            // Next, recognize auxiliary instructions.
            // If we have an ancestor instruction, we preserve whatever aux routes are active from it.
            while (linkParamIndex < linkParams.length && lang_1.isArray(linkParams[linkParamIndex])) {
                var auxParentInstruction = [parentInstruction];
                var auxInstruction = this._generate(linkParams[linkParamIndex], auxParentInstruction, null, true, _originalLink);
                // TODO: this will not work for aux routes with parameters or multiple segments
                auxInstructions[auxInstruction.component.urlPath] = auxInstruction;
                linkParamIndex += 1;
            }
            var instruction = new instruction_1.ResolvedInstruction(componentInstruction, null, auxInstructions);
            // If the component is sync, we can generate resolved child route instructions
            // If not, we'll resolve the instructions at navigation time
            if (lang_1.isPresent(componentInstruction) && lang_1.isPresent(componentInstruction.componentType)) {
                var childInstruction = null;
                if (componentInstruction.terminal) {
                    if (linkParamIndex >= linkParams.length) {}
                } else {
                    var childAncestorComponents = ancestorInstructions.concat([instruction]);
                    var remainingLinkParams = linkParams.slice(linkParamIndex);
                    childInstruction = this._generate(remainingLinkParams, childAncestorComponents, null, false, _originalLink);
                }
                instruction.child = childInstruction;
            }
            return instruction;
        };
        RouteRegistry.prototype.hasRoute = function (name, parentComponent) {
            var rules = this._rules.get(parentComponent);
            if (lang_1.isBlank(rules)) {
                return false;
            }
            return rules.hasRoute(name);
        };
        RouteRegistry.prototype.generateDefault = function (componentCursor) {
            var _this = this;
            if (lang_1.isBlank(componentCursor)) {
                return null;
            }
            var rules = this._rules.get(componentCursor);
            if (lang_1.isBlank(rules) || lang_1.isBlank(rules.defaultRule)) {
                return null;
            }
            var defaultChild = null;
            if (lang_1.isPresent(rules.defaultRule.handler.componentType)) {
                var componentInstruction = rules.defaultRule.generate({});
                if (!rules.defaultRule.terminal) {
                    defaultChild = this.generateDefault(rules.defaultRule.handler.componentType);
                }
                return new instruction_1.DefaultInstruction(componentInstruction, defaultChild);
            }
            return new instruction_1.UnresolvedInstruction(function () {
                return rules.defaultRule.handler.resolveComponentType().then(function (_) {
                    return _this.generateDefault(componentCursor);
                });
            });
        };
        RouteRegistry = __decorate([core_1.Injectable(), __param(0, core_1.Inject(exports.ROUTER_PRIMARY_COMPONENT)), __metadata('design:paramtypes', [lang_1.Type])], RouteRegistry);
        return RouteRegistry;
    }();
    exports.RouteRegistry = RouteRegistry;
    /*
     * Given: ['/a/b', {c: 2}]
     * Returns: ['', 'a', 'b', {c: 2}]
     */
    function splitAndFlattenLinkParams(linkParams) {
        var accumulation = [];
        linkParams.forEach(function (item) {
            if (lang_1.isString(item)) {
                var strItem = item;
                accumulation = accumulation.concat(strItem.split('/'));
            } else {
                accumulation.push(item);
            }
        });
        return accumulation;
    }
    /*
     * Given a list of instructions, returns the most specific instruction
     */
    function mostSpecific(instructions) {
        instructions = instructions.filter(function (instruction) {
            return lang_1.isPresent(instruction);
        });
        if (instructions.length == 0) {
            return null;
        }
        if (instructions.length == 1) {
            return instructions[0];
        }
        var first = instructions[0];
        var rest = instructions.slice(1);
        return rest.reduce(function (instruction, contender) {
            if (compareSpecificityStrings(contender.specificity, instruction.specificity) == -1) {
                return contender;
            }
            return instruction;
        }, first);
    }
    /*
     * Expects strings to be in the form of "[0-2]+"
     * Returns -1 if string A should be sorted above string B, 1 if it should be sorted after,
     * or 0 if they are the same.
     */
    function compareSpecificityStrings(a, b) {
        var l = lang_1.Math.min(a.length, b.length);
        for (var i = 0; i < l; i += 1) {
            var ai = lang_1.StringWrapper.charCodeAt(a, i);
            var bi = lang_1.StringWrapper.charCodeAt(b, i);
            var difference = bi - ai;
            if (difference != 0) {
                return difference;
            }
        }
        return a.length - b.length;
    }
    function assertTerminalComponent(component, path) {
        if (!lang_1.isType(component)) {
            return;
        }
        var annotations = reflection_1.reflector.annotations(component);
        if (lang_1.isPresent(annotations)) {
            for (var i = 0; i < annotations.length; i++) {
                var annotation = annotations[i];
                if (annotation instanceof route_config_impl_1.RouteConfig) {
                    throw new exceptions_1.BaseException("Child routes are not allowed for \"" + path + "\". Use \"...\" on the parent's route path.");
                }
            }
        }
    }
});
System.registerDynamic('angular2/src/router/location/location_strategy.js', ['angular2/src/facade/lang.js', 'angular2/core.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var core_1 = $__require('angular2/core.js');
    /**
     * `LocationStrategy` is responsible for representing and reading route state
     * from the browser's URL. Angular provides two strategies:
     * {@link HashLocationStrategy} and {@link PathLocationStrategy} (default).
     *
     * This is used under the hood of the {@link Location} service.
     *
     * Applications should use the {@link Router} or {@link Location} services to
     * interact with application route state.
     *
     * For instance, {@link HashLocationStrategy} produces URLs like
     * `http://example.com#/foo`, and {@link PathLocationStrategy} produces
     * `http://example.com/foo` as an equivalent URL.
     *
     * See these two classes for more.
     */
    var LocationStrategy = function () {
        function LocationStrategy() {}
        return LocationStrategy;
    }();
    exports.LocationStrategy = LocationStrategy;
    /**
     * The `APP_BASE_HREF` token represents the base href to be used with the
     * {@link PathLocationStrategy}.
     *
     * If you're using {@link PathLocationStrategy}, you must provide a provider to a string
     * representing the URL prefix that should be preserved when generating and recognizing
     * URLs.
     *
     * ### Example
     *
     * ```
     * import {Component} from 'angular2/core';
     * import {ROUTER_DIRECTIVES, ROUTER_PROVIDERS, RouteConfig} from 'angular2/router';
     *
     * @Component({directives: [ROUTER_DIRECTIVES]})
     * @RouteConfig([
     *  {...},
     * ])
     * class AppCmp {
     *   // ...
     * }
     *
     * bootstrap(AppCmp, [
     *   ROUTER_PROVIDERS,
     *   provide(APP_BASE_HREF, {useValue: '/my/app'})
     * ]);
     * ```
     */
    exports.APP_BASE_HREF = lang_1.CONST_EXPR(new core_1.OpaqueToken('appBaseHref'));
    function normalizeQueryParams(params) {
        return params.length > 0 && params.substring(0, 1) != '?' ? '?' + params : params;
    }
    exports.normalizeQueryParams = normalizeQueryParams;
    function joinWithSlash(start, end) {
        if (start.length == 0) {
            return end;
        }
        if (end.length == 0) {
            return start;
        }
        var slashes = 0;
        if (start.endsWith('/')) {
            slashes++;
        }
        if (end.startsWith('/')) {
            slashes++;
        }
        if (slashes == 2) {
            return start + end.substring(1);
        }
        if (slashes == 1) {
            return start + end;
        }
        return start + '/' + end;
    }
    exports.joinWithSlash = joinWithSlash;
});
System.registerDynamic("angular2/src/router/location/location.js", ["angular2/src/router/location/location_strategy.js", "angular2/src/facade/async.js", "angular2/core.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var location_strategy_1 = $__require("angular2/src/router/location/location_strategy.js");
    var async_1 = $__require("angular2/src/facade/async.js");
    var core_1 = $__require("angular2/core.js");
    /**
     * `Location` is a service that applications can use to interact with a browser's URL.
     * Depending on which {@link LocationStrategy} is used, `Location` will either persist
     * to the URL's path or the URL's hash segment.
     *
     * Note: it's better to use {@link Router#navigate} service to trigger route changes. Use
     * `Location` only if you need to interact with or create normalized URLs outside of
     * routing.
     *
     * `Location` is responsible for normalizing the URL against the application's base href.
     * A normalized URL is absolute from the URL host, includes the application's base href, and has no
     * trailing slash:
     * - `/my/app/user/123` is normalized
     * - `my/app/user/123` **is not** normalized
     * - `/my/app/user/123/` **is not** normalized
     *
     * ### Example
     *
     * ```
     * import {Component} from 'angular2/core';
     * import {
     *   ROUTER_DIRECTIVES,
     *   ROUTER_PROVIDERS,
     *   RouteConfig,
     *   Location
     * } from 'angular2/router';
     *
     * @Component({directives: [ROUTER_DIRECTIVES]})
     * @RouteConfig([
     *  {...},
     * ])
     * class AppCmp {
     *   constructor(location: Location) {
     *     location.go('/foo');
     *   }
     * }
     *
     * bootstrap(AppCmp, [ROUTER_PROVIDERS]);
     * ```
     */
    var Location = function () {
        function Location(platformStrategy) {
            var _this = this;
            this.platformStrategy = platformStrategy;
            /** @internal */
            this._subject = new async_1.EventEmitter();
            var browserBaseHref = this.platformStrategy.getBaseHref();
            this._baseHref = stripTrailingSlash(stripIndexHtml(browserBaseHref));
            this.platformStrategy.onPopState(function (ev) {
                async_1.ObservableWrapper.callEmit(_this._subject, { 'url': _this.path(), 'pop': true, 'type': ev.type });
            });
        }
        /**
         * Returns the normalized URL path.
         */
        Location.prototype.path = function () {
            return this.normalize(this.platformStrategy.path());
        };
        /**
         * Given a string representing a URL, returns the normalized URL path without leading or
         * trailing slashes
         */
        Location.prototype.normalize = function (url) {
            return stripTrailingSlash(_stripBaseHref(this._baseHref, stripIndexHtml(url)));
        };
        /**
         * Given a string representing a URL, returns the platform-specific external URL path.
         * If the given URL doesn't begin with a leading slash (`'/'`), this method adds one
         * before normalizing. This method will also add a hash if `HashLocationStrategy` is
         * used, or the `APP_BASE_HREF` if the `PathLocationStrategy` is in use.
         */
        Location.prototype.prepareExternalUrl = function (url) {
            if (url.length > 0 && !url.startsWith('/')) {
                url = '/' + url;
            }
            return this.platformStrategy.prepareExternalUrl(url);
        };
        // TODO: rename this method to pushState
        /**
         * Changes the browsers URL to the normalized version of the given URL, and pushes a
         * new item onto the platform's history.
         */
        Location.prototype.go = function (path, query) {
            if (query === void 0) {
                query = '';
            }
            this.platformStrategy.pushState(null, '', path, query);
        };
        /**
         * Changes the browsers URL to the normalized version of the given URL, and replaces
         * the top item on the platform's history stack.
         */
        Location.prototype.replaceState = function (path, query) {
            if (query === void 0) {
                query = '';
            }
            this.platformStrategy.replaceState(null, '', path, query);
        };
        /**
         * Navigates forward in the platform's history.
         */
        Location.prototype.forward = function () {
            this.platformStrategy.forward();
        };
        /**
         * Navigates back in the platform's history.
         */
        Location.prototype.back = function () {
            this.platformStrategy.back();
        };
        /**
         * Subscribe to the platform's `popState` events.
         */
        Location.prototype.subscribe = function (onNext, onThrow, onReturn) {
            if (onThrow === void 0) {
                onThrow = null;
            }
            if (onReturn === void 0) {
                onReturn = null;
            }
            return async_1.ObservableWrapper.subscribe(this._subject, onNext, onThrow, onReturn);
        };
        Location = __decorate([core_1.Injectable(), __metadata('design:paramtypes', [location_strategy_1.LocationStrategy])], Location);
        return Location;
    }();
    exports.Location = Location;
    function _stripBaseHref(baseHref, url) {
        if (baseHref.length > 0 && url.startsWith(baseHref)) {
            return url.substring(baseHref.length);
        }
        return url;
    }
    function stripIndexHtml(url) {
        if (/\/index.html$/g.test(url)) {
            // '/index.html'.length == 11
            return url.substring(0, url.length - 11);
        }
        return url;
    }
    function stripTrailingSlash(url) {
        if (/\/$/g.test(url)) {
            url = url.substring(0, url.length - 1);
        }
        return url;
    }
});
System.registerDynamic('angular2/src/router/router_providers_common.js', ['angular2/src/router/location/location_strategy.js', 'angular2/src/router/location/path_location_strategy.js', 'angular2/src/router/router.js', 'angular2/src/router/route_registry.js', 'angular2/src/router/location/location.js', 'angular2/src/facade/lang.js', 'angular2/core.js', 'angular2/src/facade/exceptions.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var location_strategy_1 = $__require('angular2/src/router/location/location_strategy.js');
    var path_location_strategy_1 = $__require('angular2/src/router/location/path_location_strategy.js');
    var router_1 = $__require('angular2/src/router/router.js');
    var route_registry_1 = $__require('angular2/src/router/route_registry.js');
    var location_1 = $__require('angular2/src/router/location/location.js');
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var core_1 = $__require('angular2/core.js');
    var exceptions_1 = $__require('angular2/src/facade/exceptions.js');
    /**
     * The Platform agnostic ROUTER PROVIDERS
     */
    exports.ROUTER_PROVIDERS_COMMON = lang_1.CONST_EXPR([route_registry_1.RouteRegistry, lang_1.CONST_EXPR(new core_1.Provider(location_strategy_1.LocationStrategy, { useClass: path_location_strategy_1.PathLocationStrategy })), location_1.Location, lang_1.CONST_EXPR(new core_1.Provider(router_1.Router, {
        useFactory: routerFactory,
        deps: lang_1.CONST_EXPR([route_registry_1.RouteRegistry, location_1.Location, route_registry_1.ROUTER_PRIMARY_COMPONENT, core_1.ApplicationRef])
    })), lang_1.CONST_EXPR(new core_1.Provider(route_registry_1.ROUTER_PRIMARY_COMPONENT, { useFactory: routerPrimaryComponentFactory, deps: lang_1.CONST_EXPR([core_1.ApplicationRef]) }))]);
    function routerFactory(registry, location, primaryComponent, appRef) {
        var rootRouter = new router_1.RootRouter(registry, location, primaryComponent);
        appRef.registerDisposeListener(function () {
            return rootRouter.dispose();
        });
        return rootRouter;
    }
    function routerPrimaryComponentFactory(app) {
        if (app.componentTypes.length == 0) {
            throw new exceptions_1.BaseException("Bootstrap at least one component before injecting Router.");
        }
        return app.componentTypes[0];
    }
});
System.registerDynamic('angular2/src/platform/dom/dom_adapter.js', ['angular2/src/facade/lang.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    exports.DOM = null;
    function setRootDomAdapter(adapter) {
        if (lang_1.isBlank(exports.DOM)) {
            exports.DOM = adapter;
        }
    }
    exports.setRootDomAdapter = setRootDomAdapter;
    /* tslint:disable:requireParameterType */
    /**
     * Provides DOM operations in an environment-agnostic way.
     */
    var DomAdapter = function () {
        function DomAdapter() {}
        Object.defineProperty(DomAdapter.prototype, "attrToPropMap", {
            /**
             * Maps attribute names to their corresponding property names for cases
             * where attribute name doesn't match property name.
             */
            get: function () {
                return this._attrToPropMap;
            },
            set: function (value) {
                this._attrToPropMap = value;
            },
            enumerable: true,
            configurable: true
        });
        ;
        ;
        return DomAdapter;
    }();
    exports.DomAdapter = DomAdapter;
});
System.registerDynamic("angular2/src/router/location/browser_platform_location.js", ["angular2/core.js", "angular2/src/router/location/platform_location.js", "angular2/src/platform/dom/dom_adapter.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1 = $__require("angular2/core.js");
    var platform_location_1 = $__require("angular2/src/router/location/platform_location.js");
    var dom_adapter_1 = $__require("angular2/src/platform/dom/dom_adapter.js");
    /**
     * `PlatformLocation` encapsulates all of the direct calls to platform APIs.
     * This class should not be used directly by an application developer. Instead, use
     * {@link Location}.
     */
    var BrowserPlatformLocation = function (_super) {
        __extends(BrowserPlatformLocation, _super);
        function BrowserPlatformLocation() {
            _super.call(this);
            this._init();
        }
        // This is moved to its own method so that `MockPlatformLocationStrategy` can overwrite it
        /** @internal */
        BrowserPlatformLocation.prototype._init = function () {
            this._location = dom_adapter_1.DOM.getLocation();
            this._history = dom_adapter_1.DOM.getHistory();
        };
        Object.defineProperty(BrowserPlatformLocation.prototype, "location", {
            /** @internal */
            get: function () {
                return this._location;
            },
            enumerable: true,
            configurable: true
        });
        BrowserPlatformLocation.prototype.getBaseHrefFromDOM = function () {
            return dom_adapter_1.DOM.getBaseHref();
        };
        BrowserPlatformLocation.prototype.onPopState = function (fn) {
            dom_adapter_1.DOM.getGlobalEventTarget('window').addEventListener('popstate', fn, false);
        };
        BrowserPlatformLocation.prototype.onHashChange = function (fn) {
            dom_adapter_1.DOM.getGlobalEventTarget('window').addEventListener('hashchange', fn, false);
        };
        Object.defineProperty(BrowserPlatformLocation.prototype, "pathname", {
            get: function () {
                return this._location.pathname;
            },
            set: function (newPath) {
                this._location.pathname = newPath;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BrowserPlatformLocation.prototype, "search", {
            get: function () {
                return this._location.search;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BrowserPlatformLocation.prototype, "hash", {
            get: function () {
                return this._location.hash;
            },
            enumerable: true,
            configurable: true
        });
        BrowserPlatformLocation.prototype.pushState = function (state, title, url) {
            this._history.pushState(state, title, url);
        };
        BrowserPlatformLocation.prototype.replaceState = function (state, title, url) {
            this._history.replaceState(state, title, url);
        };
        BrowserPlatformLocation.prototype.forward = function () {
            this._history.forward();
        };
        BrowserPlatformLocation.prototype.back = function () {
            this._history.back();
        };
        BrowserPlatformLocation = __decorate([core_1.Injectable(), __metadata('design:paramtypes', [])], BrowserPlatformLocation);
        return BrowserPlatformLocation;
    }(platform_location_1.PlatformLocation);
    exports.BrowserPlatformLocation = BrowserPlatformLocation;
});
System.registerDynamic("angular2/src/router/location/platform_location.js", [], true, function ($__require, exports, module) {
    'use strict';"use strict";
    /**
     * This class should not be used directly by an application developer. Instead, use
     * {@link Location}.
     *
     * `PlatformLocation` encapsulates all calls to DOM apis, which allows the Router to be platform
     * agnostic.
     * This means that we can have different implementation of `PlatformLocation` for the different
     * platforms
     * that angular supports. For example, the default `PlatformLocation` is {@link
     * BrowserPlatformLocation},
     * however when you run your app in a WebWorker you use {@link WebWorkerPlatformLocation}.
     *
     * The `PlatformLocation` class is used directly by all implementations of {@link LocationStrategy}
     * when
     * they need to interact with the DOM apis like pushState, popState, etc...
     *
     * {@link LocationStrategy} in turn is used by the {@link Location} service which is used directly
     * by
     * the {@link Router} in order to navigate between routes. Since all interactions between {@link
     * Router} /
     * {@link Location} / {@link LocationStrategy} and DOM apis flow through the `PlatformLocation`
     * class
     * they are all platform independent.
     */

    var global = this || self,
        GLOBAL = global;
    var PlatformLocation = function () {
        function PlatformLocation() {}
        Object.defineProperty(PlatformLocation.prototype, "pathname", {
            /* abstract */get: function () {
                return null;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PlatformLocation.prototype, "search", {
            /* abstract */get: function () {
                return null;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PlatformLocation.prototype, "hash", {
            /* abstract */get: function () {
                return null;
            },
            enumerable: true,
            configurable: true
        });
        return PlatformLocation;
    }();
    exports.PlatformLocation = PlatformLocation;
});
System.registerDynamic('angular2/src/router/router_providers.js', ['angular2/src/router/router_providers_common.js', 'angular2/core.js', 'angular2/src/facade/lang.js', 'angular2/src/router/location/browser_platform_location.js', 'angular2/src/router/location/platform_location.js'], true, function ($__require, exports, module) {
  'use strict';"use strict";

  var global = this || self,
      GLOBAL = global;
  var router_providers_common_1 = $__require('angular2/src/router/router_providers_common.js');
  var core_1 = $__require('angular2/core.js');
  var lang_1 = $__require('angular2/src/facade/lang.js');
  var browser_platform_location_1 = $__require('angular2/src/router/location/browser_platform_location.js');
  var platform_location_1 = $__require('angular2/src/router/location/platform_location.js');
  /**
   * A list of {@link Provider}s. To use the router, you must add this to your application.
   *
   * ### Example ([live demo](http://plnkr.co/edit/iRUP8B5OUbxCWQ3AcIDm))
   *
   * ```
   * import {Component} from 'angular2/core';
   * import {
   *   ROUTER_DIRECTIVES,
   *   ROUTER_PROVIDERS,
   *   RouteConfig
   * } from 'angular2/router';
   *
   * @Component({directives: [ROUTER_DIRECTIVES]})
   * @RouteConfig([
   *  {...},
   * ])
   * class AppCmp {
   *   // ...
   * }
   *
   * bootstrap(AppCmp, [ROUTER_PROVIDERS]);
   * ```
   */
  exports.ROUTER_PROVIDERS = lang_1.CONST_EXPR([router_providers_common_1.ROUTER_PROVIDERS_COMMON, lang_1.CONST_EXPR(new core_1.Provider(platform_location_1.PlatformLocation, { useClass: browser_platform_location_1.BrowserPlatformLocation }))]);
  /**
   * Use {@link ROUTER_PROVIDERS} instead.
   *
   * @deprecated
   */
  exports.ROUTER_BINDINGS = exports.ROUTER_PROVIDERS;
});
System.registerDynamic('angular2/router.js', ['angular2/src/router/router.js', 'angular2/src/router/directives/router_outlet.js', 'angular2/src/router/directives/router_link.js', 'angular2/src/router/instruction.js', 'angular2/src/router/location/platform_location.js', 'angular2/src/router/route_registry.js', 'angular2/src/router/location/location_strategy.js', 'angular2/src/router/location/hash_location_strategy.js', 'angular2/src/router/location/path_location_strategy.js', 'angular2/src/router/location/location.js', 'angular2/src/router/route_config/route_config_decorator.js', 'angular2/src/router/lifecycle/lifecycle_annotations.js', 'angular2/core.js', 'angular2/src/router/router_providers_common.js', 'angular2/src/router/router_providers.js', 'angular2/src/facade/lang.js'], true, function ($__require, exports, module) {
  'use strict'; /**
                * @module
                * @description
                * Maps application URLs into application states, to support deep-linking and navigation.
                */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
  var router_1 = $__require('angular2/src/router/router.js');
  exports.Router = router_1.Router;
  var router_outlet_1 = $__require('angular2/src/router/directives/router_outlet.js');
  exports.RouterOutlet = router_outlet_1.RouterOutlet;
  var router_link_1 = $__require('angular2/src/router/directives/router_link.js');
  exports.RouterLink = router_link_1.RouterLink;
  var instruction_1 = $__require('angular2/src/router/instruction.js');
  exports.RouteParams = instruction_1.RouteParams;
  exports.RouteData = instruction_1.RouteData;
  var platform_location_1 = $__require('angular2/src/router/location/platform_location.js');
  exports.PlatformLocation = platform_location_1.PlatformLocation;
  var route_registry_1 = $__require('angular2/src/router/route_registry.js');
  exports.RouteRegistry = route_registry_1.RouteRegistry;
  exports.ROUTER_PRIMARY_COMPONENT = route_registry_1.ROUTER_PRIMARY_COMPONENT;
  var location_strategy_1 = $__require('angular2/src/router/location/location_strategy.js');
  exports.LocationStrategy = location_strategy_1.LocationStrategy;
  exports.APP_BASE_HREF = location_strategy_1.APP_BASE_HREF;
  var hash_location_strategy_1 = $__require('angular2/src/router/location/hash_location_strategy.js');
  exports.HashLocationStrategy = hash_location_strategy_1.HashLocationStrategy;
  var path_location_strategy_1 = $__require('angular2/src/router/location/path_location_strategy.js');
  exports.PathLocationStrategy = path_location_strategy_1.PathLocationStrategy;
  var location_1 = $__require('angular2/src/router/location/location.js');
  exports.Location = location_1.Location;
  __export($__require('angular2/src/router/route_config/route_config_decorator.js'));
  var lifecycle_annotations_1 = $__require('angular2/src/router/lifecycle/lifecycle_annotations.js');
  exports.CanActivate = lifecycle_annotations_1.CanActivate;
  var instruction_2 = $__require('angular2/src/router/instruction.js');
  exports.Instruction = instruction_2.Instruction;
  exports.ComponentInstruction = instruction_2.ComponentInstruction;
  var core_1 = $__require('angular2/core.js');
  exports.OpaqueToken = core_1.OpaqueToken;
  var router_providers_common_1 = $__require('angular2/src/router/router_providers_common.js');
  exports.ROUTER_PROVIDERS_COMMON = router_providers_common_1.ROUTER_PROVIDERS_COMMON;
  var router_providers_1 = $__require('angular2/src/router/router_providers.js');
  exports.ROUTER_PROVIDERS = router_providers_1.ROUTER_PROVIDERS;
  exports.ROUTER_BINDINGS = router_providers_1.ROUTER_BINDINGS;
  var router_outlet_2 = $__require('angular2/src/router/directives/router_outlet.js');
  var router_link_2 = $__require('angular2/src/router/directives/router_link.js');
  var lang_1 = $__require('angular2/src/facade/lang.js');
  /**
   * A list of directives. To use the router directives like {@link RouterOutlet} and
   * {@link RouterLink}, add this to your `directives` array in the {@link View} decorator of your
   * component.
   *
   * ### Example ([live demo](http://plnkr.co/edit/iRUP8B5OUbxCWQ3AcIDm))
   *
   * ```
   * import {Component} from 'angular2/core';
   * import {ROUTER_DIRECTIVES, ROUTER_PROVIDERS, RouteConfig} from 'angular2/router';
   *
   * @Component({directives: [ROUTER_DIRECTIVES]})
   * @RouteConfig([
   *  {...},
   * ])
   * class AppCmp {
   *    // ...
   * }
   *
   * bootstrap(AppCmp, [ROUTER_PROVIDERS]);
   * ```
   */
  exports.ROUTER_DIRECTIVES = lang_1.CONST_EXPR([router_outlet_2.RouterOutlet, router_link_2.RouterLink]);
});
System.register("ags-client/app/components/back_component.js", ["angular2/core.js", "angular2/router.js", "ags-client/app/pipes/translation_pipe.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, router_1, translation_pipe_1, BackComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (router_1_1) {
            router_1 = router_1_1;
        }, function (translation_pipe_1_1) {
            translation_pipe_1 = translation_pipe_1_1;
        }],
        execute: function () {
            BackComponent = /** @class */function () {
                function BackComponent(_router) {
                    this._router = _router;
                }
                BackComponent.prototype.back = function () {
                    this._router.navigate([this.target]);
                };
                __decorate([core_1.Input(), __metadata("design:type", String)], BackComponent.prototype, "target", void 0);
                __decorate([core_1.Input(), __metadata("design:type", String)], BackComponent.prototype, "targetNoHistory", void 0);
                BackComponent = __decorate([core_1.Component({
                    selector: 'back',
                    pipes: [translation_pipe_1.TranslationPipe],
                    template: "<a (click)=\"back()\"><i class=\"fa fa-arrow-left\"></i>{{'commons:back'|translate}}</a>"
                }), __metadata("design:paramtypes", [router_1.Router])], BackComponent);
                return BackComponent;
            }();
            exports_1("BackComponent", BackComponent);
        }
    };
});

System.register("ags-client/app/components/multi_select_enum_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/commons.js", "ags-client/app/services/translation_service.js", "ags-client/app/models/select_option.js", "ags-client/app/components/multi_select_component.js", "ags-client/app/pipes/translation_pipe.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, commons_1, translation_service_1, select_option_1, multi_select_component_1, translation_pipe_1, MultiSelectEnumComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (commons_1_1) {
            commons_1 = commons_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }, function (select_option_1_1) {
            select_option_1 = select_option_1_1;
        }, function (multi_select_component_1_1) {
            multi_select_component_1 = multi_select_component_1_1;
        }, function (translation_pipe_1_1) {
            translation_pipe_1 = translation_pipe_1_1;
        }],
        execute: function () {
            MultiSelectEnumComponent = /** @class */function (_super) {
                __extends(MultiSelectEnumComponent, _super);
                function MultiSelectEnumComponent(elementRef, _translationService) {
                    var _this = _super.call(this, elementRef) || this;
                    _this._translationService = _translationService;
                    return _this;
                }
                MultiSelectEnumComponent.prototype.ngAfterViewInit = function () {
                    var _this = this;
                    setTimeout(function () {
                        var options = new Array();
                        if (commons_1.EnumRegistry.enum(_this.enumCategory)) {
                            commons_1.enumStringValues(commons_1.EnumRegistry.enum(_this.enumCategory)).forEach(function (key) {
                                options.push(new select_option_1.SelectOption(key, _this._translationService.translate(_this.enumCategory + ':' + key), commons_1.enumNumberValue(commons_1.EnumRegistry.enum(_this.enumCategory), key)));
                            });
                        }
                        _this.options = _this.options = commons_1.sortBy(options, 'text');
                    }, 100);
                };
                Object.defineProperty(MultiSelectEnumComponent.prototype, "model", {
                    set: function (model) {
                        this._model = model;
                    },
                    enumerable: false,
                    configurable: true
                });
                __decorate([core_1.Input('enumCategory'), __metadata("design:type", Object)], MultiSelectEnumComponent.prototype, "enumCategory", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Array), __metadata("design:paramtypes", [Array])], MultiSelectEnumComponent.prototype, "model", null);
                MultiSelectEnumComponent = __decorate([core_1.Component({
                    directives: [common_1.NgFor, common_1.NgClass],
                    pipes: [translation_pipe_1.TranslationPipe],
                    selector: 'multi-select[enumCategory]',
                    templateUrl: 'ags-client/app/components/multi_select_component.html'
                }), __metadata("design:paramtypes", [core_1.ElementRef, translation_service_1.TranslationService])], MultiSelectEnumComponent);
                return MultiSelectEnumComponent;
            }(multi_select_component_1.MultiSelectComponent);
            exports_1("MultiSelectEnumComponent", MultiSelectEnumComponent);
        }
    };
});

System.register("ags-client/app/components/multi_select_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/models/select_option.js", "ags-client/app/commons/lang.js", "ags-client/app/pipes/translation_pipe.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, select_option_1, lang_1, translation_pipe_1, MultiSelectComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (select_option_1_1) {
            select_option_1 = select_option_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }, function (translation_pipe_1_1) {
            translation_pipe_1 = translation_pipe_1_1;
        }],
        execute: function () {
            MultiSelectComponent = /** @class */function () {
                function MultiSelectComponent(_elementRef) {
                    this._elementRef = _elementRef;
                    this._options = new Array();
                    this._model = new Array();
                }
                Object.defineProperty(MultiSelectComponent.prototype, "selectedOptions", {
                    get: function () {
                        var _this = this;
                        if (this._model && this._options.length > 0) {
                            var selectedOptions = this._model.map(function (model) {
                                var matchingOption = _this._options.filter(function (option) {
                                    return lang_1.areEqual(option.value, model);
                                })[0];
                                if (!matchingOption) {
                                    return _this.createMissingOption(model);
                                }
                                return matchingOption;
                            });
                            return lang_1.sortBy(selectedOptions, 'text');
                        } else {
                            return new Array();
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                MultiSelectComponent.prototype.createMissingOption = function (modelItem) {
                    return new select_option_1.SelectOption('UNKNOWN', 'UNKNOWN');
                };
                Object.defineProperty(MultiSelectComponent.prototype, "unselectedOptions", {
                    get: function () {
                        var _this = this;
                        return this._options.filter(function (option) {
                            return !_this.filtered(option) && (!_this._model || _this._model.filter(function (modelItem) {
                                return lang_1.areEqual(modelItem, option.value);
                            }).length === 0);
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                MultiSelectComponent.prototype.filtered = function (option) {
                    return false;
                };
                MultiSelectComponent.prototype.select = function (option) {
                    this._model.push(option.value);
                };
                MultiSelectComponent.prototype.unselect = function (option) {
                    var value = this._model.filter(function (modelItem) {
                        return lang_1.areEqual(option.value, modelItem);
                    })[0];
                    ;
                    this._model.splice(this._model.indexOf(value), 1);
                };
                MultiSelectComponent.prototype.selectAll = function () {
                    var _this = this;
                    this.unselectedOptions.forEach(function (option) {
                        _this.select(option);
                    });
                };
                MultiSelectComponent.prototype.unselectAll = function () {
                    while (this._model.length > 0) {
                        this._model.splice(0);
                    }
                };
                Object.defineProperty(MultiSelectComponent.prototype, "options", {
                    set: function (options) {
                        this._options = options;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MultiSelectComponent.prototype, "model", {
                    set: function (model) {
                        this._model = model;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MultiSelectComponent.prototype, "disabled", {
                    get: function () {
                        return this._elementRef.nativeElement.getAttribute('disabled') === 'disabled';
                    },
                    enumerable: false,
                    configurable: true
                });
                __decorate([core_1.Input(), __metadata("design:type", Array), __metadata("design:paramtypes", [Array])], MultiSelectComponent.prototype, "options", null);
                __decorate([core_1.Input(), __metadata("design:type", Array), __metadata("design:paramtypes", [Array])], MultiSelectComponent.prototype, "model", null);
                MultiSelectComponent = __decorate([core_1.Component({
                    directives: [common_1.NgFor, common_1.NgClass],
                    pipes: [translation_pipe_1.TranslationPipe],
                    selector: 'multi-select[options]',
                    templateUrl: 'ags-client/app/components/multi_select_component.html'
                }), __metadata("design:paramtypes", [core_1.ElementRef])], MultiSelectComponent);
                return MultiSelectComponent;
            }();
            exports_1("MultiSelectComponent", MultiSelectComponent);
        }
    };
});

System.register("ags-client/app/components/multi_select_code_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/commons/lang.js", "ags-client/app/commons/code_registry.js", "ags-client/app/services/translation_service.js", "ags-client/app/models/select_option.js", "ags-client/app/components/multi_select_component.js", "ags-client/app/pipes/translation_pipe.js", "ags-client/app/services/code_service.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, lang_1, code_registry_1, translation_service_1, select_option_1, multi_select_component_1, translation_pipe_1, code_service_1, MultiSelectCodeComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }, function (code_registry_1_1) {
            code_registry_1 = code_registry_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }, function (select_option_1_1) {
            select_option_1 = select_option_1_1;
        }, function (multi_select_component_1_1) {
            multi_select_component_1 = multi_select_component_1_1;
        }, function (translation_pipe_1_1) {
            translation_pipe_1 = translation_pipe_1_1;
        }, function (code_service_1_1) {
            code_service_1 = code_service_1_1;
        }],
        execute: function () {
            MultiSelectCodeComponent = /** @class */function (_super) {
                __extends(MultiSelectCodeComponent, _super);
                function MultiSelectCodeComponent(elementRef, _translationService, _codeService) {
                    var _this = _super.call(this, elementRef) || this;
                    _this._translationService = _translationService;
                    _this._codeService = _codeService;
                    _this.onChange = new core_1.EventEmitter();
                    return _this;
                }
                MultiSelectCodeComponent.prototype.ngAfterViewInit = function () {
                    var _this = this;
                    setTimeout(function () {
                        var options = new Array();
                        var category = code_registry_1.CodeRegistry.code(_this.codeCategory);
                        _this._codeService.codesFromCache(_this.codeCategory).then(function (codes) {
                            codes.forEach(function (code) {
                                var text = null;
                                if (lang_1.isPresent(_this.type) && _this.type === 'key') {
                                    text = code;
                                } else if (lang_1.isPresent(_this.type) && _this.type === 'keyValue') {
                                    text = code + ' - ' + _this._translationService.translate(_this.codeCategory + ':' + code);
                                } else {
                                    text = _this._translationService.translate(_this.codeCategory + ':' + code);
                                }
                                options.push(new select_option_1.SelectOption(code, text, category.create(code)));
                            });
                            _this.options = lang_1.sortBy(options, 'text');
                        });
                    }, 100);
                };
                MultiSelectCodeComponent.prototype.filtered = function (option) {
                    return this.filter && this.filter.indexOf(option.key) >= 0;
                };
                MultiSelectCodeComponent.prototype.createMissingOption = function (modelItem) {
                    return new select_option_1.SelectOption(modelItem.shortName, modelItem.shortName);
                };
                Object.defineProperty(MultiSelectCodeComponent.prototype, "model", {
                    set: function (model) {
                        this._model = model;
                    },
                    enumerable: false,
                    configurable: true
                });
                __decorate([core_1.Input('codeCategory'), __metadata("design:type", Object)], MultiSelectCodeComponent.prototype, "codeCategory", void 0);
                __decorate([core_1.Input('type'), __metadata("design:type", String)], MultiSelectCodeComponent.prototype, "type", void 0);
                __decorate([core_1.Input('filter'), __metadata("design:type", Array)], MultiSelectCodeComponent.prototype, "filter", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], MultiSelectCodeComponent.prototype, "onChange", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Array), __metadata("design:paramtypes", [Array])], MultiSelectCodeComponent.prototype, "model", null);
                MultiSelectCodeComponent = __decorate([core_1.Component({
                    directives: [common_1.NgFor, common_1.NgClass],
                    pipes: [translation_pipe_1.TranslationPipe],
                    selector: 'multi-select[codeCategory]',
                    templateUrl: 'ags-client/app/components/multi_select_component.html'
                }), __metadata("design:paramtypes", [core_1.ElementRef, translation_service_1.TranslationService, code_service_1.CodeService])], MultiSelectCodeComponent);
                return MultiSelectCodeComponent;
            }(multi_select_component_1.MultiSelectComponent);
            exports_1("MultiSelectCodeComponent", MultiSelectCodeComponent);
        }
    };
});

System.register("ags-client/app/components/button_spinner_component.js", ["angular2/core.js", "angular2/common.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, ButtonSpinnerComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }],
        execute: function () {
            ButtonSpinnerComponent = /** @class */function () {
                function ButtonSpinnerComponent() {}
                __decorate([core_1.Input('spinner'), __metadata("design:type", Boolean)], ButtonSpinnerComponent.prototype, "visible", void 0);
                ButtonSpinnerComponent = __decorate([core_1.Component({
                    directives: [common_1.NgIf],
                    selector: 'button[spinner]',
                    template: '<ng-content></ng-content><li *ngIf="visible" class="fa fa-spinner fa-spin"></li>'
                })], ButtonSpinnerComponent);
                return ButtonSpinnerComponent;
            }();
            exports_1("ButtonSpinnerComponent", ButtonSpinnerComponent);
        }
    };
});

System.register("ags-client/app/services/confirmation_service.js", ["angular2/core.js", "ags-client/app/services/translation_service.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, translation_service_1, Confirmation, ConfirmationService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }],
        execute: function () {
            Confirmation = /** @class */function () {
                function Confirmation() {}
                return Confirmation;
            }();
            exports_1("Confirmation", Confirmation);
            ConfirmationService = /** @class */function () {
                function ConfirmationService(_translationService) {
                    this._translationService = _translationService;
                    this._emitter = new core_1.EventEmitter();
                }
                ConfirmationService.prototype.subscribe = function (subscriber) {
                    this._emitter.subscribe(subscriber);
                };
                ConfirmationService.prototype.confirm = function (message, callback) {
                    this._emitter.emit({ message: message, callback: callback });
                };
                ConfirmationService.prototype.confirmDelete = function (callback) {
                    this.confirm(this._translationService.translate('confirmation:delete_message'), callback);
                };
                ConfirmationService.prototype.confirmCancel = function (callback) {
                    this.confirm(this._translationService.translate('confirmation:cancel_message'), callback);
                };
                ConfirmationService = __decorate([core_1.Injectable(), __metadata("design:paramtypes", [translation_service_1.TranslationService])], ConfirmationService);
                return ConfirmationService;
            }();
            exports_1("ConfirmationService", ConfirmationService);
        }
    };
});

System.register("ags-client/app/components/form_button_panel_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/components/button_spinner_component.js", "ags-client/app/pipes/translation_pipe.js", "ags-client/app/services/confirmation_service.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, button_spinner_component_1, translation_pipe_1, confirmation_service_1, FormButtonPanelComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (button_spinner_component_1_1) {
            button_spinner_component_1 = button_spinner_component_1_1;
        }, function (translation_pipe_1_1) {
            translation_pipe_1 = translation_pipe_1_1;
        }, function (confirmation_service_1_1) {
            confirmation_service_1 = confirmation_service_1_1;
        }],
        execute: function () {
            FormButtonPanelComponent = /** @class */function () {
                function FormButtonPanelComponent(_confirmationService) {
                    this._confirmationService = _confirmationService;
                    this.buttons = ['reset', 'cancel', 'submit'];
                    this.cancel = new core_1.EventEmitter();
                    this.reset = new core_1.EventEmitter();
                    this.submit = new core_1.EventEmitter();
                    this.test = new core_1.EventEmitter();
                }
                FormButtonPanelComponent.prototype.showCancel = function () {
                    return this.buttons.indexOf('cancel') >= 0;
                };
                FormButtonPanelComponent.prototype.showReset = function () {
                    return this.buttons.indexOf('reset') >= 0;
                };
                FormButtonPanelComponent.prototype.showSubmit = function () {
                    return this.buttons.indexOf('submit') >= 0;
                };
                FormButtonPanelComponent.prototype.doCancel = function () {
                    var _this = this;
                    if (!this.form || this.form.pristine) {
                        this.cancel.emit(null);
                    } else {
                        this._confirmationService.confirmCancel(function () {
                            _this.cancel.emit(null);
                        });
                    }
                };
                FormButtonPanelComponent.prototype.doReset = function () {
                    this.reset.emit(null);
                };
                FormButtonPanelComponent.prototype.doSubmit = function () {
                    this.submit.emit(null);
                };
                __decorate([core_1.Input(), __metadata("design:type", Boolean)], FormButtonPanelComponent.prototype, "loading", void 0);
                __decorate([core_1.Input(), __metadata("design:type", common_1.ControlGroup)], FormButtonPanelComponent.prototype, "form", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Object)], FormButtonPanelComponent.prototype, "buttons", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], FormButtonPanelComponent.prototype, "cancel", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], FormButtonPanelComponent.prototype, "reset", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], FormButtonPanelComponent.prototype, "submit", void 0);
                FormButtonPanelComponent = __decorate([core_1.Component({
                    directives: [button_spinner_component_1.ButtonSpinnerComponent],
                    pipes: [translation_pipe_1.TranslationPipe],
                    selector: 'form-button-panel',
                    templateUrl: 'ags-client/app/components/form_button_panel_component.html'
                }), __metadata("design:paramtypes", [confirmation_service_1.ConfirmationService])], FormButtonPanelComponent);
                return FormButtonPanelComponent;
            }();
            exports_1("FormButtonPanelComponent", FormButtonPanelComponent);
        }
    };
});

System.register("ags-client/gen/viewmodels/file_view_model.js", ["ags-client/app/commons/lang.js", "ags-client/gen/viewmodels/entity_view_model.js", "ags-client/app/validators.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var lang_1, entity_view_model_1, Validators, FileViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (lang_1_1) {
            lang_1 = lang_1_1;
        }, function (entity_view_model_1_1) {
            entity_view_model_1 = entity_view_model_1_1;
        }, function (Validators_1) {
            Validators = Validators_1;
        }],
        execute: function () {
            FileViewModel = /** @class */function (_super) {
                __extends(FileViewModel, _super);
                function FileViewModel() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                FileViewModel.deserialize = function (object) {
                    var _result = new FileViewModel();
                    return _result._deserialize(object);
                };
                FileViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        _super.prototype._deserialize.call(this, object);
                        if (lang_1.isPresent(object['fileName'])) {
                            this.fileName = object['fileName'];
                        }
                        if (lang_1.isPresent(object['fileSize'])) {
                            this.fileSize = object['fileSize'];
                        }
                        if (lang_1.isPresent(object['fileHash'])) {
                            this.fileHash = object['fileHash'];
                        }
                    }
                    return this;
                };
                FileViewModel.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (lang_1.isPresent(this.fileName)) {
                        object['fileName'] = this.fileName;
                    }
                    if (lang_1.isPresent(this.fileSize)) {
                        object['fileSize'] = this.fileSize;
                    }
                    if (lang_1.isPresent(this.fileHash)) {
                        object['fileHash'] = this.fileHash;
                    }
                    return object;
                };
                FileViewModel.FILE_NAME_VALIDATORS = [Validators.max(200)];
                FileViewModel.FILE_SIZE_VALIDATORS = [];
                FileViewModel.FILE_HASH_VALIDATORS = [Validators.required(), Validators.max(32)];
                return FileViewModel;
            }(entity_view_model_1.EntityViewModel);
            exports_1("FileViewModel", FileViewModel);
        }
    };
});

System.register("ags-client/app/pipes/filesize_pipe.js", ["angular2/core.js", "ags-client/app/commons/lang.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var core_1, lang_1, FileSizePipe;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }],
        execute: function () {
            FileSizePipe = /** @class */function () {
                function FileSizePipe() {}
                FileSizePipe.prototype.transform = function (size) {
                    if (lang_1.isPresent(size)) {
                        return lang_1.formatFileSize(size);
                    } else {
                        return null;
                    }
                };
                FileSizePipe = __decorate([core_1.Pipe({
                    name: 'filesize'
                })], FileSizePipe);
                return FileSizePipe;
            }();
            exports_1("FileSizePipe", FileSizePipe);
        }
    };
});

System.register("ags-client/app/components/file_component.js", ["angular2/core.js", "ags-client/gen/viewmodels/file_view_model.js", "ags-client/app/commons/enum_registry.js", "ags-client/app/commons/lang.js", "ags-client/app/constants.js", "ags-client/app/models/code.js", "ags-client/app/pipes/filesize_pipe.js", "ags-client/app/services/translation_service.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, file_view_model_1, enum_registry_1, lang_1, constants_1, code_1, filesize_pipe_1, translation_service_1, FileComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (file_view_model_1_1) {
            file_view_model_1 = file_view_model_1_1;
        }, function (enum_registry_1_1) {
            enum_registry_1 = enum_registry_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }, function (constants_1_1) {
            constants_1 = constants_1_1;
        }, function (code_1_1) {
            code_1 = code_1_1;
        }, function (filesize_pipe_1_1) {
            filesize_pipe_1 = filesize_pipe_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }],
        execute: function () {
            FileComponent = /** @class */function () {
                function FileComponent(_translationService) {
                    this._translationService = _translationService;
                    this.showFileIcon = true;
                    this.showFileName = true;
                    this.showFileSize = true;
                }
                Object.defineProperty(FileComponent.prototype, "imageUrl", {
                    get: function () {
                        if (lang_1.isPresent(this.file)) {
                            var r = new RegExp(constants_1.FILE_EXTENSIONS);
                            var fileName = this.file.fileName;
                            var extension = lang_1.fileExtension(fileName);
                            if (!lang_1.isPresent(extension) || !extension.match(r)) {
                                extension = 'file';
                            }
                            return 'ags-client/images/filetypes/' + extension + '.gif';
                        }
                        return null;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(FileComponent.prototype, "downloadUrl", {
                    get: function () {
                        if (lang_1.isPresent(this.file) && lang_1.isSomething(this.file.fileHash)) {
                            return 'api/download/' + this.file.id.toString() + '/' + this.file.fileHash + '/' + encodeURIComponent(this.file.fileName);
                        }
                        return null;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(FileComponent.prototype, "displayFilename", {
                    get: function () {
                        if (lang_1.isPresent(this.filenameEnum) && lang_1.isPresent(this.filenameEnumCategory)) {
                            return this._translationService.translate(this.filenameEnumCategory + ':' + lang_1.enumStringValue(enum_registry_1.EnumRegistry.enum(this.filenameEnumCategory), this.filenameEnum));
                        } else if (lang_1.isPresent(this.filenameCode) && lang_1.isPresent(this.filenameCodeCategory)) {
                            return this._translationService.translate(this.filenameCodeCategory + ':' + this.filenameCode.shortName);
                        } else if (lang_1.isPresent(this.customFileName)) {
                            return this.customFileName;
                        } else if (lang_1.isPresent(this.file)) {
                            return this.file.fileName;
                        }
                        return null;
                    },
                    enumerable: false,
                    configurable: true
                });
                __decorate([core_1.Input(), __metadata("design:type", file_view_model_1.FileViewModel)], FileComponent.prototype, "file", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Number)], FileComponent.prototype, "filenameEnum", void 0);
                __decorate([core_1.Input(), __metadata("design:type", String)], FileComponent.prototype, "filenameEnumCategory", void 0);
                __decorate([core_1.Input(), __metadata("design:type", code_1.Code)], FileComponent.prototype, "filenameCode", void 0);
                __decorate([core_1.Input(), __metadata("design:type", String)], FileComponent.prototype, "filenameCodeCategory", void 0);
                __decorate([core_1.Input(), __metadata("design:type", String)], FileComponent.prototype, "customFileName", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Object)], FileComponent.prototype, "showFileIcon", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Object)], FileComponent.prototype, "showFileName", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Object)], FileComponent.prototype, "showFileSize", void 0);
                FileComponent = __decorate([core_1.Component({
                    selector: 'file',
                    pipes: [filesize_pipe_1.FileSizePipe],
                    templateUrl: 'ags-client/app/components/file_component.html'
                }), __metadata("design:paramtypes", [translation_service_1.TranslationService])], FileComponent);
                return FileComponent;
            }();
            exports_1("FileComponent", FileComponent);
        }
    };
});

System.register("ags-client/app/components/translation_component.js", ["angular2/core.js", "ags-client/app/commons/html.js", "ags-client/app/commons/lang.js", "ags-client/app/services/translation_service.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, html_1, lang_1, translation_service_1, TranslateComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (html_1_1) {
            html_1 = html_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }],
        execute: function () {
            TranslateComponent = /** @class */function () {
                function TranslateComponent(_translationService, _element) {
                    this._translationService = _translationService;
                    this._element = _element;
                }
                TranslateComponent.prototype.update = function () {
                    var span = this._element.nativeElement.querySelector('span');
                    html_1.removeChilds(span);
                    if (lang_1.isSomething(this._value)) {
                        span.innerHTML = this._translationService.translate(this._value);
                    }
                };
                Object.defineProperty(TranslateComponent.prototype, "value", {
                    set: function (value) {
                        this._value = value;
                        this.update();
                    },
                    enumerable: false,
                    configurable: true
                });
                __decorate([core_1.Input(), __metadata("design:type", String), __metadata("design:paramtypes", [String])], TranslateComponent.prototype, "value", null);
                TranslateComponent = __decorate([core_1.Component({
                    selector: 'translate',
                    template: "<span></span>"
                }), __metadata("design:paramtypes", [translation_service_1.TranslationService, core_1.ElementRef])], TranslateComponent);
                return TranslateComponent;
            }();
            exports_1("TranslateComponent", TranslateComponent);
        }
    };
});

System.register("ags-client/app/components/print_component.js", ["angular2/core.js", "ags-client/app/pipes/translation_pipe.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var core_1, translation_pipe_1, PrintComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (translation_pipe_1_1) {
            translation_pipe_1 = translation_pipe_1_1;
        }],
        execute: function () {
            PrintComponent = /** @class */function () {
                function PrintComponent() {}
                PrintComponent.prototype.print = function () {
                    window.print();
                };
                PrintComponent = __decorate([core_1.Component({
                    selector: 'print',
                    pipes: [translation_pipe_1.TranslationPipe],
                    template: "<a (click)=\"print()\"><i class=\"fa fa-print\"></i>{{'commons:print'|translate}}</a>"
                })], PrintComponent);
                return PrintComponent;
            }();
            exports_1("PrintComponent", PrintComponent);
        }
    };
});

System.register("ags-client/app/components/create_component.js", ["angular2/core.js", "ags-client/app/pipes/translation_pipe.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, translation_pipe_1, CreateComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (translation_pipe_1_1) {
            translation_pipe_1 = translation_pipe_1_1;
        }],
        execute: function () {
            CreateComponent = /** @class */function () {
                function CreateComponent() {
                    this.create = new core_1.EventEmitter();
                    this.title = new core_1.EventEmitter();
                }
                CreateComponent.prototype._create = function () {
                    this.create.emit(null);
                };
                __decorate([core_1.Output(), __metadata("design:type", Object)], CreateComponent.prototype, "create", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Object)], CreateComponent.prototype, "title", void 0);
                CreateComponent = __decorate([core_1.Component({
                    selector: 'create',
                    pipes: [translation_pipe_1.TranslationPipe],
                    template: "<a (click)=\"_create()\"><i class=\"fa fa-plus\"></i>{{title}}</a>"
                })], CreateComponent);
                return CreateComponent;
            }();
            exports_1("CreateComponent", CreateComponent);
        }
    };
});

System.register("ags-client/app/components/reset_component.js", ["angular2/core.js", "ags-client/app/pipes/translation_pipe.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, translation_pipe_1, ResetComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (translation_pipe_1_1) {
            translation_pipe_1 = translation_pipe_1_1;
        }],
        execute: function () {
            ResetComponent = /** @class */function () {
                function ResetComponent() {
                    this.reset = new core_1.EventEmitter();
                }
                ResetComponent.prototype._reset = function () {
                    this.reset.emit(null);
                };
                __decorate([core_1.Output(), __metadata("design:type", Object)], ResetComponent.prototype, "reset", void 0);
                ResetComponent = __decorate([core_1.Component({
                    selector: 'reset',
                    pipes: [translation_pipe_1.TranslationPipe],
                    template: "<a (click)=\"_reset()\"><i class=\"fa fa-times\"></i>{{'commons:reset'|translate}}</a>"
                })], ResetComponent);
                return ResetComponent;
            }();
            exports_1("ResetComponent", ResetComponent);
        }
    };
});

System.register("ags-client/app/components/multiselect_dropdown_enum_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/commons.js", "ags-client/app/services/translation_service.js", "ags-client/app/models/select_option.js", "ags-client/app/components/multiselect_dropdown_component.js", "ags-client/app/pipes.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, commons_1, translation_service_1, select_option_1, multiselect_dropdown_component_1, pipes_1, MultiselectDropdownEnumComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (commons_1_1) {
            commons_1 = commons_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }, function (select_option_1_1) {
            select_option_1 = select_option_1_1;
        }, function (multiselect_dropdown_component_1_1) {
            multiselect_dropdown_component_1 = multiselect_dropdown_component_1_1;
        }, function (pipes_1_1) {
            pipes_1 = pipes_1_1;
        }],
        execute: function () {
            MultiselectDropdownEnumComponent = /** @class */function (_super) {
                __extends(MultiselectDropdownEnumComponent, _super);
                function MultiselectDropdownEnumComponent(elementRef, translationService) {
                    var _this = _super.call(this, elementRef, translationService) || this;
                    _this.type = 'text';
                    _this.onChange = new core_1.EventEmitter();
                    return _this;
                }
                MultiselectDropdownEnumComponent.prototype.ngAfterViewInit = function () {
                    var _this = this;
                    setTimeout(function () {
                        var options = new Array();
                        if (commons_1.EnumRegistry.enum(_this.enumCategory)) {
                            commons_1.enumStringValues(commons_1.EnumRegistry.enum(_this.enumCategory)).forEach(function (key) {
                                options.push(new select_option_1.SelectOption(key, _this._translationService.translate(_this.enumCategory + ':' + key), commons_1.enumNumberValue(commons_1.EnumRegistry.enum(_this.enumCategory), key)));
                            });
                        }
                        _this.options = commons_1.sortBy(options, 'text');
                    }, 100);
                };
                Object.defineProperty(MultiselectDropdownEnumComponent.prototype, "model", {
                    set: function (model) {
                        this._model = model;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MultiselectDropdownEnumComponent.prototype, "defaultModel", {
                    set: function (defaultModel) {
                        this._defaultModel = defaultModel;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MultiselectDropdownEnumComponent.prototype, "maxTextWidth", {
                    set: function (maxTextWidth) {
                        this._maxTextWidth = maxTextWidth;
                    },
                    enumerable: false,
                    configurable: true
                });
                __decorate([core_1.Input('enumCategory'), __metadata("design:type", Object)], MultiselectDropdownEnumComponent.prototype, "enumCategory", void 0);
                __decorate([core_1.Input(), __metadata("design:type", String)], MultiselectDropdownEnumComponent.prototype, "type", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], MultiselectDropdownEnumComponent.prototype, "onChange", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Array), __metadata("design:paramtypes", [Array])], MultiselectDropdownEnumComponent.prototype, "model", null);
                __decorate([core_1.Input(), __metadata("design:type", Array), __metadata("design:paramtypes", [Array])], MultiselectDropdownEnumComponent.prototype, "defaultModel", null);
                __decorate([core_1.Input(), __metadata("design:type", Number), __metadata("design:paramtypes", [Number])], MultiselectDropdownEnumComponent.prototype, "maxTextWidth", null);
                MultiselectDropdownEnumComponent = __decorate([core_1.Component({
                    directives: [common_1.NgFor, common_1.NgClass],
                    pipes: [pipes_1.TranslationPipe, pipes_1.SearchFilterPipe],
                    selector: 'multiselect-dropdown[enumCategory]',
                    templateUrl: 'ags-client/app/components/multiselect_dropdown_component.html'
                }), __metadata("design:paramtypes", [core_1.ElementRef, translation_service_1.TranslationService])], MultiselectDropdownEnumComponent);
                return MultiselectDropdownEnumComponent;
            }(multiselect_dropdown_component_1.MultiselectDropdownComponent);
            exports_1("MultiselectDropdownEnumComponent", MultiselectDropdownEnumComponent);
        }
    };
});

System.register("ags-client/app/models/alert_model.js", [], function (exports_1, context_1) {
    "use strict";

    var AlertType, AlertModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [],
        execute: function () {
            (function (AlertType) {
                AlertType[AlertType["ERROR"] = 0] = "ERROR";
                AlertType[AlertType["WARNING"] = 1] = "WARNING";
                AlertType[AlertType["INFO"] = 2] = "INFO";
            })(AlertType || exports_1("AlertType", AlertType = {}));
            AlertModel = /** @class */function () {
                function AlertModel(type, message) {
                    this.type = type;
                    this.message = message;
                }
                AlertModel.prototype.error = function () {
                    return this.type === AlertType.ERROR;
                };
                AlertModel.prototype.warning = function () {
                    return this.type === AlertType.WARNING;
                };
                AlertModel.prototype.info = function () {
                    return this.type === AlertType.INFO;
                };
                return AlertModel;
            }();
            exports_1("AlertModel", AlertModel);
        }
    };
});

System.register("ags-client/app/models/navigation_model.js", [], function (exports_1, context_1) {
    "use strict";

    var NavigationEntryModel, NavigationModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [],
        execute: function () {
            NavigationEntryModel = /** @class */function () {
                function NavigationEntryModel() {}
                return NavigationEntryModel;
            }();
            exports_1("NavigationEntryModel", NavigationEntryModel);
            NavigationModel = /** @class */function () {
                function NavigationModel() {}
                return NavigationModel;
            }();
            exports_1("NavigationModel", NavigationModel);
        }
    };
});

System.register("ags-client/app/models/multi_select_settings.js", [], function (exports_1, context_1) {
    "use strict";

    var MultiSelectSettings;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [],
        execute: function () {
            MultiSelectSettings = /** @class */function () {
                function MultiSelectSettings() {}
                Object.defineProperty(MultiSelectSettings, "defaultSettings", {
                    get: function () {
                        return MultiSelectSettings._defaultSettings;
                    },
                    enumerable: false,
                    configurable: true
                });
                MultiSelectSettings._defaultSettings = {
                    pullRight: false,
                    enableSearch: true,
                    checkedStyle: 'glyphicon',
                    buttonClasses: 'btn btn-default',
                    selectionLimit: 0,
                    closeOnSelect: false,
                    showCheckAll: false,
                    showUncheckAll: true,
                    dynamicTitleMaxItems: 5,
                    maxHeight: '300px'
                };
                return MultiSelectSettings;
            }();
            exports_1("MultiSelectSettings", MultiSelectSettings);
        }
    };
});

System.register("ags-client/app/models.js", ["ags-client/app/models/alert_model.js", "ags-client/app/models/code.js", "ags-client/app/models/json_response.js", "ags-client/app/models/navigation_model.js", "ags-client/app/models/select_option.js", "ags-client/app/models/multi_select_settings.js"], function (exports_1, context_1) {
    "use strict";

    var __moduleName = context_1 && context_1.id;
    var exportedNames_1 = {
        "AlertType": true,
        "AlertModel": true,
        "Code": true,
        "SelectOption": true,
        "MultiSelectSettings": true
    };
    function exportStar_1(m) {
        var exports = {};
        for (var n in m) {
            if (n !== "default" && !exportedNames_1.hasOwnProperty(n)) exports[n] = m[n];
        }
        exports_1(exports);
    }
    return {
        setters: [function (alert_model_1_1) {
            exports_1({
                "AlertType": alert_model_1_1["AlertType"],
                "AlertModel": alert_model_1_1["AlertModel"]
            });
        }, function (code_1_1) {
            exports_1({
                "Code": code_1_1["Code"]
            });
        }, function (json_response_1_1) {
            exportStar_1(json_response_1_1);
        }, function (navigation_model_1_1) {
            exportStar_1(navigation_model_1_1);
        }, function (select_option_1_1) {
            exports_1({
                "SelectOption": select_option_1_1["SelectOption"]
            });
        }, function (multi_select_settings_1_1) {
            exports_1({
                "MultiSelectSettings": multi_select_settings_1_1["MultiSelectSettings"]
            });
        }],
        execute: function () {}
    };
});

System.register("ags-client/app/components/multiselect_dropdown_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/services/translation_service.js", "ags-client/app/commons.js", "ags-client/app/pipes.js", "ags-client/app/models.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, translation_service_1, commons_1, pipes_1, models_1, MultiselectDropdownComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }, function (commons_1_1) {
            commons_1 = commons_1_1;
        }, function (pipes_1_1) {
            pipes_1 = pipes_1_1;
        }, function (models_1_1) {
            models_1 = models_1_1;
        }],
        execute: function () {
            MultiselectDropdownComponent = /** @class */function () {
                function MultiselectDropdownComponent(element, _translationService) {
                    this.element = element;
                    this._translationService = _translationService;
                    this.type = 'text';
                    this.selectionLimitReached = new core_1.EventEmitter();
                    this.onChange = new core_1.EventEmitter();
                    this._options = new Array();
                    this._model = new Array();
                    this._defaultModel = [];
                    this._maxTextWidth = 30;
                    this.numSelected = 0;
                    this.isVisible = false;
                    this.search = new common_1.Control();
                    this.searchFilterText = '';
                }
                MultiselectDropdownComponent.prototype.onClick = function (target) {
                    var parentFound = false;
                    while (target !== null && !parentFound) {
                        if (target === this.element.nativeElement) {
                            parentFound = true;
                        }
                        target = target.parentElement;
                    }
                    if (!parentFound) {
                        this.isVisible = false;
                    }
                };
                MultiselectDropdownComponent.prototype.ngOnInit = function () {
                    var _this = this;
                    this.settings = models_1.MultiSelectSettings.defaultSettings;
                    this.resetToDefaultModel();
                    this.updateNumSelected();
                    this.search.valueChanges.subscribe(function (text) {
                        _this.searchFilterText = text;
                    });
                    if (this._model.length > 0) {
                        this.updateNumSelected();
                    }
                };
                MultiselectDropdownComponent.prototype.clearSearch = function () {
                    this.search.updateValue('');
                };
                MultiselectDropdownComponent.prototype.toggleDropdown = function () {
                    this.isVisible = !this.isVisible;
                };
                MultiselectDropdownComponent.prototype.modelChanged = function () {
                    this.updateNumSelected();
                    this.onChange.emit(this._model);
                };
                MultiselectDropdownComponent.prototype.isSelected = function (option) {
                    return this._model.indexOf(option.key) > -1;
                };
                MultiselectDropdownComponent.prototype.setSelected = function (event, option) {
                    var index = this._model.indexOf(option.key);
                    if (index > -1) {
                        this._model.splice(index, 1);
                    } else {
                        if (this.settings.selectionLimit === 0 || this._model.length < this.settings.selectionLimit) {
                            this._model.push(option.key);
                        } else {
                            this.selectionLimitReached.emit(this._model.length);
                            return;
                        }
                    }
                    if (this.settings.closeOnSelect) {
                        this.toggleDropdown();
                    }
                    this.modelChanged();
                };
                MultiselectDropdownComponent.prototype.getTitle = function (showFull) {
                    var _this = this;
                    if (this.numSelected === 0 || !commons_1.isPresent(this._options) || this._options.length === 0) {
                        return '';
                    }
                    if (showFull) {
                        return this._options.filter(function (option) {
                            return _this._model.indexOf(option.key) > -1;
                        }).map(function (option) {
                            return option.text;
                        }).join(', ');
                    } else {
                        var titleText = this._options.filter(function (option) {
                            return _this._model.indexOf(option.key) > -1;
                        }).map(function (option) {
                            return option[_this.type];
                        }).join(', ');
                        if (titleText.length <= this._maxTextWidth) {
                            return titleText;
                        } else {
                            return titleText.substring(0, this._maxTextWidth) + '...';
                        }
                    }
                };
                MultiselectDropdownComponent.prototype.updateNumSelected = function () {
                    this.numSelected = this._model.length;
                };
                MultiselectDropdownComponent.prototype.checkAll = function () {
                    this._model = this._options.map(function (option) {
                        return option.key;
                    });
                    this.modelChanged();
                };
                MultiselectDropdownComponent.prototype.uncheckAll = function () {
                    this._model = [];
                    this.modelChanged();
                };
                MultiselectDropdownComponent.prototype.resetToDefaultModel = function () {
                    var _this = this;
                    this._model = new Array();
                    this._defaultModel.forEach(function (option) {
                        _this._model.push(option);
                    });
                    this.modelChanged();
                };
                Object.defineProperty(MultiselectDropdownComponent.prototype, "options", {
                    set: function (options) {
                        this._options = options;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MultiselectDropdownComponent.prototype, "model", {
                    set: function (model) {
                        this._model = model;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MultiselectDropdownComponent.prototype, "defaultModel", {
                    set: function (defaultModel) {
                        this._defaultModel = defaultModel;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MultiselectDropdownComponent.prototype, "maxTextWidth", {
                    set: function (maxTextWidth) {
                        this._maxTextWidth = maxTextWidth;
                    },
                    enumerable: false,
                    configurable: true
                });
                __decorate([core_1.Input('id'), __metadata("design:type", String)], MultiselectDropdownComponent.prototype, "id", void 0);
                __decorate([core_1.Input(), __metadata("design:type", String)], MultiselectDropdownComponent.prototype, "type", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], MultiselectDropdownComponent.prototype, "selectionLimitReached", void 0);
                __decorate([core_1.Output(), __metadata("design:type", Object)], MultiselectDropdownComponent.prototype, "onChange", void 0);
                __decorate([core_1.HostListener('document: click', ['$event.target']), __metadata("design:type", Function), __metadata("design:paramtypes", [HTMLElement]), __metadata("design:returntype", void 0)], MultiselectDropdownComponent.prototype, "onClick", null);
                __decorate([core_1.Input(), __metadata("design:type", Array), __metadata("design:paramtypes", [Array])], MultiselectDropdownComponent.prototype, "options", null);
                __decorate([core_1.Input(), __metadata("design:type", Array), __metadata("design:paramtypes", [Array])], MultiselectDropdownComponent.prototype, "model", null);
                __decorate([core_1.Input(), __metadata("design:type", Array), __metadata("design:paramtypes", [Array])], MultiselectDropdownComponent.prototype, "defaultModel", null);
                __decorate([core_1.Input(), __metadata("design:type", Number), __metadata("design:paramtypes", [Number])], MultiselectDropdownComponent.prototype, "maxTextWidth", null);
                MultiselectDropdownComponent = __decorate([core_1.Component({
                    directives: [common_1.NgFor, common_1.NgClass],
                    pipes: [pipes_1.TranslationPipe, pipes_1.SearchFilterPipe],
                    selector: 'multiselect-dropdown[options]',
                    templateUrl: 'ags-client/app/components/multiselect_dropdown_component.html'
                }), __metadata("design:paramtypes", [core_1.ElementRef, translation_service_1.TranslationService])], MultiselectDropdownComponent);
                return MultiselectDropdownComponent;
            }();
            exports_1("MultiselectDropdownComponent", MultiselectDropdownComponent);
        }
    };
});

System.register("ags-client/app/pipes/translation_pipe.js", ["angular2/core.js", "ags-client/app/services/translation_service.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, translation_service_1, TranslationPipe;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }],
        execute: function () {
            TranslationPipe = /** @class */function () {
                function TranslationPipe(_translationService) {
                    this._translationService = _translationService;
                }
                TranslationPipe.prototype.transform = function (key) {
                    var _this = this;
                    if (!this.promise) {
                        this.promise = this._translationService.translateAsync(key);
                        this.promise.then(function (result) {
                            _this.translation = result;
                        });
                    }
                    return this.translation;
                };
                TranslationPipe = __decorate([core_1.Pipe({
                    name: 'translate',
                    pure: false
                }), __metadata("design:paramtypes", [translation_service_1.TranslationService])], TranslationPipe);
                return TranslationPipe;
            }();
            exports_1("TranslationPipe", TranslationPipe);
        }
    };
});

System.register("ags-client/app/pipes/code_pipe.js", ["angular2/core.js", "ags-client/app/services/translation_service.js", "ags-client/app/commons/lang.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, translation_service_1, lang_1, CodePipe;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }],
        execute: function () {
            CodePipe = /** @class */function () {
                function CodePipe(_translationService) {
                    this._translationService = _translationService;
                }
                CodePipe.prototype.transform = function (code, args) {
                    if (lang_1.isPresent(code)) {
                        if (lang_1.isString(code)) {
                            return this._translationService.translate(args[0] + ':' + code);
                        } else {
                            return this._translationService.translate(args[0] + ':' + code.shortName);
                        }
                    } else {
                        return null;
                    }
                };
                CodePipe = __decorate([core_1.Pipe({
                    name: 'code'
                }), __metadata("design:paramtypes", [translation_service_1.TranslationService])], CodePipe);
                return CodePipe;
            }();
            exports_1("CodePipe", CodePipe);
        }
    };
});

System.register("ags-client/app/pipes/enum_pipe.js", ["angular2/core.js", "ags-client/app/services/translation_service.js", "ags-client/app/commons.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, translation_service_1, commons_1, EnumPipe;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }, function (commons_1_1) {
            commons_1 = commons_1_1;
        }],
        execute: function () {
            EnumPipe = /** @class */function () {
                function EnumPipe(_translationService) {
                    this._translationService = _translationService;
                }
                EnumPipe.prototype.transform = function (value, args) {
                    if (commons_1.isPresent(value)) {
                        return this._translationService.translate(args[0] + ':' + commons_1.enumStringValue(commons_1.EnumRegistry.enum(args[0]), value));
                    } else {
                        return null;
                    }
                };
                EnumPipe = __decorate([core_1.Pipe({
                    name: 'enum'
                }), __metadata("design:paramtypes", [translation_service_1.TranslationService])], EnumPipe);
                return EnumPipe;
            }();
            exports_1("EnumPipe", EnumPipe);
        }
    };
});

System.register("ags-client/app/pipes/search_filter_pipe.js", ["angular2/core.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var core_1, SearchFilterPipe;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }],
        execute: function () {
            SearchFilterPipe = /** @class */function () {
                function SearchFilterPipe() {}
                SearchFilterPipe.prototype.transform = function (options, args) {
                    return options.filter(function (option) {
                        return option.text.toLowerCase().indexOf(args[0].toLowerCase()) > -1;
                    });
                };
                SearchFilterPipe = __decorate([core_1.Pipe({
                    name: 'searchFilter'
                })], SearchFilterPipe);
                return SearchFilterPipe;
            }();
            exports_1("SearchFilterPipe", SearchFilterPipe);
        }
    };
});

System.register("ags-client/app/pipes.js", ["ags-client/app/pipes/translation_pipe.js", "ags-client/app/pipes/code_pipe.js", "ags-client/app/pipes/enum_pipe.js", "ags-client/app/pipes/search_filter_pipe.js"], function (exports_1, context_1) {
    "use strict";

    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (translation_pipe_1_1) {
            exports_1({
                "TranslationPipe": translation_pipe_1_1["TranslationPipe"]
            });
        }, function (code_pipe_1_1) {
            exports_1({
                "CodePipe": code_pipe_1_1["CodePipe"]
            });
        }, function (enum_pipe_1_1) {
            exports_1({
                "EnumPipe": enum_pipe_1_1["EnumPipe"]
            });
        }, function (search_filter_pipe_1_1) {
            exports_1({
                "SearchFilterPipe": search_filter_pipe_1_1["SearchFilterPipe"]
            });
        }],
        execute: function () {}
    };
});

System.register("ags-client/app/components/multiselect_dropdown_code_component.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/commons/lang.js", "ags-client/app/commons/code_registry.js", "ags-client/app/services/translation_service.js", "ags-client/app/models/select_option.js", "ags-client/app/components/multiselect_dropdown_component.js", "ags-client/app/pipes.js", "ags-client/app/services/code_service.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, lang_1, code_registry_1, translation_service_1, select_option_1, multiselect_dropdown_component_1, pipes_1, code_service_1, MultiselectDropdownCodeComponent;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }, function (code_registry_1_1) {
            code_registry_1 = code_registry_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }, function (select_option_1_1) {
            select_option_1 = select_option_1_1;
        }, function (multiselect_dropdown_component_1_1) {
            multiselect_dropdown_component_1 = multiselect_dropdown_component_1_1;
        }, function (pipes_1_1) {
            pipes_1 = pipes_1_1;
        }, function (code_service_1_1) {
            code_service_1 = code_service_1_1;
        }],
        execute: function () {
            MultiselectDropdownCodeComponent = /** @class */function (_super) {
                __extends(MultiselectDropdownCodeComponent, _super);
                function MultiselectDropdownCodeComponent(elementRef, translationService, _codeService) {
                    var _this = _super.call(this, elementRef, translationService) || this;
                    _this._codeService = _codeService;
                    return _this;
                }
                MultiselectDropdownCodeComponent.prototype.ngAfterViewInit = function () {
                    var _this = this;
                    setTimeout(function () {
                        var options = new Array();
                        var category = code_registry_1.CodeRegistry.code(_this.codeCategory);
                        _this._codeService.codesFromCache(_this.codeCategory).then(function (codes) {
                            codes.forEach(function (code) {
                                var text = null;
                                if (lang_1.isPresent(_this.type) && _this.type === 'key') {
                                    text = code;
                                } else if (lang_1.isPresent(_this.type) && _this.type === 'keyValue') {
                                    text = code + ' - ' + _this._translationService.translate(_this.codeCategory + ':' + code);
                                } else {
                                    text = _this._translationService.translate(_this.codeCategory + ':' + code);
                                }
                                options.push(new select_option_1.SelectOption(code, text, category.create(code)));
                            });
                            _this.options = lang_1.sortBy(options, 'text');
                        });
                    }, 100);
                };
                MultiselectDropdownCodeComponent.prototype.filtered = function (option) {
                    return this.filter && this.filter.indexOf(option.key) >= 0;
                };
                MultiselectDropdownCodeComponent.prototype.createMissingOption = function (modelItem) {
                    return new select_option_1.SelectOption(modelItem.shortName, modelItem.shortName);
                };
                Object.defineProperty(MultiselectDropdownCodeComponent.prototype, "model", {
                    set: function (model) {
                        this._model = model;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MultiselectDropdownCodeComponent.prototype, "defaultModel", {
                    set: function (defaultModel) {
                        this._defaultModel = defaultModel;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MultiselectDropdownCodeComponent.prototype, "maxTextWidth", {
                    set: function (maxTextWidth) {
                        this._maxTextWidth = maxTextWidth;
                    },
                    enumerable: false,
                    configurable: true
                });
                __decorate([core_1.Input('codeCategory'), __metadata("design:type", Object)], MultiselectDropdownCodeComponent.prototype, "codeCategory", void 0);
                __decorate([core_1.Input('type'), __metadata("design:type", String)], MultiselectDropdownCodeComponent.prototype, "type", void 0);
                __decorate([core_1.Input('filter'), __metadata("design:type", Array)], MultiselectDropdownCodeComponent.prototype, "filter", void 0);
                __decorate([core_1.Input(), __metadata("design:type", Array), __metadata("design:paramtypes", [Array])], MultiselectDropdownCodeComponent.prototype, "model", null);
                __decorate([core_1.Input(), __metadata("design:type", Array), __metadata("design:paramtypes", [Array])], MultiselectDropdownCodeComponent.prototype, "defaultModel", null);
                __decorate([core_1.Input(), __metadata("design:type", Number), __metadata("design:paramtypes", [Number])], MultiselectDropdownCodeComponent.prototype, "maxTextWidth", null);
                MultiselectDropdownCodeComponent = __decorate([core_1.Component({
                    directives: [common_1.NgFor, common_1.NgClass],
                    pipes: [pipes_1.TranslationPipe, pipes_1.SearchFilterPipe],
                    selector: 'multiselect-dropdown[codeCategory]',
                    templateUrl: 'ags-client/app/components/multiselect_dropdown_component.html'
                }), __metadata("design:paramtypes", [core_1.ElementRef, translation_service_1.TranslationService, code_service_1.CodeService])], MultiselectDropdownCodeComponent);
                return MultiselectDropdownCodeComponent;
            }(multiselect_dropdown_component_1.MultiselectDropdownComponent);
            exports_1("MultiselectDropdownCodeComponent", MultiselectDropdownCodeComponent);
        }
    };
});

System.register("ags-client/app/directives/form_id_directive.js", ["angular2/core.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, FormIdDirective;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }],
        execute: function () {
            FormIdDirective = /** @class */function () {
                function FormIdDirective(form) {
                    this._form = form.nativeElement;
                }
                FormIdDirective.prototype.ngAfterViewChecked = function () {
                    if (this._form.getAttribute('id')) {
                        this._updateChildIds(this._form);
                    }
                };
                FormIdDirective.prototype._updateChildIds = function (element) {
                    if (element.children) {
                        for (var i = 0; i < element.children.length; i++) {
                            if (element.children.item(i) instanceof HTMLElement) {
                                var child = element.children.item(i);
                                this._updateChildIds(child);
                                var formId = this._form.getAttribute('id');
                                switch (child.tagName.toLowerCase()) {
                                    case 'label':
                                        {
                                            if (child.getAttribute('for') && child.getAttribute('for').indexOf(formId) != 0) {
                                                child.setAttribute('for', formId + '_' + child.getAttribute('for'));
                                            }
                                        }
                                    case 'input':
                                    case 'select':
                                    case 'button':
                                        {
                                            if (child.getAttribute('id') && child.getAttribute('id').indexOf(formId) != 0) {
                                                child.setAttribute('id', formId + '_' + child.getAttribute('id'));
                                            }
                                        }
                                }
                            }
                        }
                    }
                };
                FormIdDirective = __decorate([core_1.Directive({
                    selector: 'form'
                }), core_1.Inject(core_1.ElementRef), __metadata("design:paramtypes", [core_1.ElementRef])], FormIdDirective);
                return FormIdDirective;
            }();
            exports_1("FormIdDirective", FormIdDirective);
        }
    };
});

System.register("ags-client/app/directives/form_loading_directive.js", ["angular2/core.js", "ags-client/app/commons/html.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, html_1, FormLoadingDirective;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (html_1_1) {
            html_1 = html_1_1;
        }],
        execute: function () {
            FormLoadingDirective = /** @class */function () {
                function FormLoadingDirective(form) {
                    this._form = form.nativeElement;
                }
                FormLoadingDirective.prototype.ngOnChanges = function (changes) {
                    this._updateChildElements(this._form);
                };
                FormLoadingDirective.prototype._updateChildElements = function (element) {
                    if (element.children) {
                        for (var i = 0; i < element.children.length; i++) {
                            if (element.children.item(i) instanceof HTMLElement) {
                                var child = element.children.item(i);
                                if (this.loading || html_1.hasClass(child, 'disabled')) {
                                    child.setAttribute('disabled', 'disabled');
                                } else {
                                    child.removeAttribute('disabled');
                                }
                                this._updateChildElements(child);
                            }
                        }
                    }
                };
                __decorate([core_1.Input('loading'), __metadata("design:type", Boolean)], FormLoadingDirective.prototype, "loading", void 0);
                FormLoadingDirective = __decorate([core_1.Directive({
                    selector: 'form[loading]'
                }), core_1.Inject(core_1.ElementRef), __metadata("design:paramtypes", [core_1.ElementRef])], FormLoadingDirective);
                return FormLoadingDirective;
            }();
            exports_1("FormLoadingDirective", FormLoadingDirective);
        }
    };
});

System.register("ags-client/app/directives/input_date_directive.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/directives/abstract_input_directive.js", "ags-client/app/validators.js", "ags-client/app/constants.js", "ags-client/app/commons/html.js", "ags-client/app/commons/lang.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, abstract_input_directive_1, Validators, constants_1, html_1, lang_1, InputDateDirective;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (abstract_input_directive_1_1) {
            abstract_input_directive_1 = abstract_input_directive_1_1;
        }, function (Validators_1) {
            Validators = Validators_1;
        }, function (constants_1_1) {
            constants_1 = constants_1_1;
        }, function (html_1_1) {
            html_1 = html_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }],
        execute: function () {
            InputDateDirective = /** @class */function (_super) {
                __extends(InputDateDirective, _super);
                function InputDateDirective(elementRef, control, renderer) {
                    var _this = _super.call(this, elementRef, control, renderer, 10, /[0-9\.]/g, new RegExp(constants_1.DATE_REGEX)) || this;
                    _this.onChange = function (_) {
                        return;
                    };
                    _this.onTouched = function () {
                        return;
                    };
                    html_1.setAttribute(_this.input, 'placeholder', 'dd.mm.yyyy', false);
                    control.valueAccessor = _this;
                    return _this;
                }
                InputDateDirective.prototype.isKeyAllowed = function (keyCode) {
                    if (_super.prototype.isKeyAllowed.call(this, keyCode)) {
                        return String.fromCharCode(keyCode) !== '.' || this.input.value.match(/\./g) == null || this.input.value.match(/\./g).length < 2;
                    }
                    return false;
                };
                InputDateDirective.prototype.isInputValid = function (data) {
                    if (_super.prototype.isInputValid.call(this, data)) {
                        return Validators.isValidDate(data);
                    }
                };
                InputDateDirective.prototype.writeValue = function (value) {
                    _super.prototype.writeValue.call(this, lang_1.formatDate(value));
                };
                InputDateDirective.prototype.onKeyPress = function (event) {
                    _super.prototype.onKeyPress.call(this, event);
                };
                InputDateDirective.prototype.onPaste = function (event) {
                    _super.prototype.onPaste.call(this, event);
                };
                InputDateDirective.prototype.onInputChange = function (value) {
                    if (value != null && value.length === 10) {
                        var date = lang_1.parseDate(value);
                        if (value && value.length > 0 && (!date || lang_1.formatDate(date) !== value)) {
                            this.onChange(new Date('INVALID'));
                        } else {
                            this.onChange(date);
                        }
                    }
                };
                InputDateDirective.prototype.onBlur = function () {
                    this.onTouched();
                };
                InputDateDirective.prototype.registerOnChange = function (fn) {
                    this.onChange = fn;
                };
                InputDateDirective.prototype.registerOnTouched = function (fn) {
                    this.onTouched = fn;
                };
                __decorate([core_1.HostListener('keypress', ['$event']), __metadata("design:type", Function), __metadata("design:paramtypes", [KeyboardEvent]), __metadata("design:returntype", void 0)], InputDateDirective.prototype, "onKeyPress", null);
                __decorate([core_1.HostListener('paste', ['$event']), __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", void 0)], InputDateDirective.prototype, "onPaste", null);
                __decorate([core_1.HostListener('input', ['$event.target.value']), core_1.HostListener('change', ['$event.target.value']), __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", void 0)], InputDateDirective.prototype, "onInputChange", null);
                __decorate([core_1.HostListener('blur', ['$event']), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], InputDateDirective.prototype, "onBlur", null);
                InputDateDirective = __decorate([core_1.Directive({
                    selector: 'input[type=date][ngModel],input[type=date][ngControl]'
                }), core_1.Inject(core_1.ElementRef), core_1.Inject(common_1.NgControl), core_1.Inject(core_1.Renderer), __metadata("design:paramtypes", [core_1.ElementRef, common_1.NgControl, core_1.Renderer])], InputDateDirective);
                return InputDateDirective;
            }(abstract_input_directive_1.AbstractInputDirective);
            exports_1("InputDateDirective", InputDateDirective);
        }
    };
});

System.register("ags-client/app/directives/input_decimal_directive.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/directives/abstract_input_directive.js", "ags-client/app/commons.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, abstract_input_directive_1, commons_1, InputDecimalDirective;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (abstract_input_directive_1_1) {
            abstract_input_directive_1 = abstract_input_directive_1_1;
        }, function (commons_1_1) {
            commons_1 = commons_1_1;
        }],
        execute: function () {
            InputDecimalDirective = /** @class */function (_super) {
                __extends(InputDecimalDirective, _super);
                function InputDecimalDirective(element, control, renderer) {
                    var _this = _super.call(this, element, control, renderer, 36, /[0-9\.]/g, /[0-9]+(\.[0-9]+)?/g) || this;
                    _this.onChange = function (_) {
                        return;
                    };
                    _this.onTouched = function () {
                        return;
                    };
                    control.valueAccessor = _this;
                    return _this;
                }
                InputDecimalDirective.prototype.isKeyAllowed = function (keyCode) {
                    if (_super.prototype.isKeyAllowed.call(this, keyCode)) {
                        return String.fromCharCode(keyCode) !== '.' || this.input.value.indexOf('.') < 0;
                    }
                    return false;
                };
                InputDecimalDirective.prototype.onKeyPress = function (event) {
                    _super.prototype.onKeyPress.call(this, event);
                };
                InputDecimalDirective.prototype.onPaste = function (event) {
                    _super.prototype.onPaste.call(this, event);
                };
                InputDecimalDirective.prototype.onInputChange = function (value) {
                    if (commons_1.isSomething(value)) {
                        this.onChange(parseFloat(value));
                    } else {
                        this.onChange(null);
                    }
                };
                InputDecimalDirective.prototype.onBlur = function () {
                    this.onTouched();
                };
                InputDecimalDirective.prototype.registerOnChange = function (fn) {
                    this.onChange = fn;
                };
                InputDecimalDirective.prototype.registerOnTouched = function (fn) {
                    this.onTouched = fn;
                };
                __decorate([core_1.HostListener('keypress', ['$event']), __metadata("design:type", Function), __metadata("design:paramtypes", [KeyboardEvent]), __metadata("design:returntype", void 0)], InputDecimalDirective.prototype, "onKeyPress", null);
                __decorate([core_1.HostListener('paste', ['$event']), __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", void 0)], InputDecimalDirective.prototype, "onPaste", null);
                __decorate([core_1.HostListener('input', ['$event.target.value']), core_1.HostListener('change', ['$event.target.value']), __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", void 0)], InputDecimalDirective.prototype, "onInputChange", null);
                __decorate([core_1.HostListener('blur', ['$event']), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], InputDecimalDirective.prototype, "onBlur", null);
                InputDecimalDirective = __decorate([core_1.Directive({
                    selector: 'input[type=decimal][ngModel],input[type=decimal][ngControl]'
                }), core_1.Inject(core_1.ElementRef), core_1.Inject(common_1.NgControl), __metadata("design:paramtypes", [core_1.ElementRef, common_1.NgControl, core_1.Renderer])], InputDecimalDirective);
                return InputDecimalDirective;
            }(abstract_input_directive_1.AbstractInputDirective);
            exports_1("InputDecimalDirective", InputDecimalDirective);
        }
    };
});

System.register("ags-client/app/directives/input_integer_directive.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/directives/abstract_input_directive.js", "ags-client/app/commons.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, abstract_input_directive_1, commons_1, InputIntegerDirective;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (abstract_input_directive_1_1) {
            abstract_input_directive_1 = abstract_input_directive_1_1;
        }, function (commons_1_1) {
            commons_1 = commons_1_1;
        }],
        execute: function () {
            InputIntegerDirective = /** @class */function (_super) {
                __extends(InputIntegerDirective, _super);
                function InputIntegerDirective(element, control, renderer) {
                    var _this = _super.call(this, element, control, renderer, 10, /[0-9]/g, /[0-9]+/g) || this;
                    _this.renderer = renderer;
                    _this.onChange = function (_) {
                        return;
                    };
                    _this.onTouched = function () {
                        return;
                    };
                    control.valueAccessor = _this;
                    return _this;
                }
                InputIntegerDirective.prototype.onKeyPress = function (event) {
                    _super.prototype.onKeyPress.call(this, event);
                };
                InputIntegerDirective.prototype.onPaste = function (event) {
                    _super.prototype.onPaste.call(this, event);
                };
                InputIntegerDirective.prototype.onInputChange = function (value) {
                    if (commons_1.isSomething(value)) {
                        this.onChange(parseInt(value));
                    } else {
                        this.onChange(null);
                    }
                };
                InputIntegerDirective.prototype.onBlur = function () {
                    this.onTouched();
                };
                InputIntegerDirective.prototype.registerOnChange = function (fn) {
                    this.onChange = fn;
                };
                InputIntegerDirective.prototype.registerOnTouched = function (fn) {
                    this.onTouched = fn;
                };
                __decorate([core_1.HostListener('keypress', ['$event']), __metadata("design:type", Function), __metadata("design:paramtypes", [KeyboardEvent]), __metadata("design:returntype", void 0)], InputIntegerDirective.prototype, "onKeyPress", null);
                __decorate([core_1.HostListener('paste', ['$event']), __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", void 0)], InputIntegerDirective.prototype, "onPaste", null);
                __decorate([core_1.HostListener('input', ['$event.target.value']), core_1.HostListener('change', ['$event.target.value']), __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", void 0)], InputIntegerDirective.prototype, "onInputChange", null);
                __decorate([core_1.HostListener('blur', ['$event']), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], InputIntegerDirective.prototype, "onBlur", null);
                InputIntegerDirective = __decorate([core_1.Directive({
                    selector: 'input[type=integer][ngModel],input[type=integer][ngControl]'
                }), core_1.Inject(core_1.ElementRef), core_1.Inject(common_1.NgControl), __metadata("design:paramtypes", [core_1.ElementRef, common_1.NgControl, core_1.Renderer])], InputIntegerDirective);
                return InputIntegerDirective;
            }(abstract_input_directive_1.AbstractInputDirective);
            exports_1("InputIntegerDirective", InputIntegerDirective);
        }
    };
});

System.register("ags-client/app/directives/input_long_directive.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/directives/abstract_input_directive.js", "ags-client/app/commons.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, abstract_input_directive_1, commons_1, InputLongDirective;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (abstract_input_directive_1_1) {
            abstract_input_directive_1 = abstract_input_directive_1_1;
        }, function (commons_1_1) {
            commons_1 = commons_1_1;
        }],
        execute: function () {
            InputLongDirective = /** @class */function (_super) {
                __extends(InputLongDirective, _super);
                function InputLongDirective(element, control, renderer) {
                    var _this = _super.call(this, element, control, renderer, 20, /[0-9]/g, /[0-9]+/g) || this;
                    _this.onChange = function (_) {
                        return;
                    };
                    _this.onTouched = function () {
                        return;
                    };
                    control.valueAccessor = _this;
                    return _this;
                }
                InputLongDirective.prototype.onKeyPress = function (event) {
                    _super.prototype.onKeyPress.call(this, event);
                };
                InputLongDirective.prototype.onPaste = function (event) {
                    _super.prototype.onPaste.call(this, event);
                };
                InputLongDirective.prototype.onInputChange = function (value) {
                    if (commons_1.isSomething(value)) {
                        this.onChange(parseInt(value));
                    } else {
                        this.onChange(null);
                    }
                };
                InputLongDirective.prototype.onBlur = function () {
                    this.onTouched();
                };
                InputLongDirective.prototype.registerOnChange = function (fn) {
                    this.onChange = fn;
                };
                InputLongDirective.prototype.registerOnTouched = function (fn) {
                    this.onTouched = fn;
                };
                __decorate([core_1.HostListener('keypress', ['$event']), __metadata("design:type", Function), __metadata("design:paramtypes", [KeyboardEvent]), __metadata("design:returntype", void 0)], InputLongDirective.prototype, "onKeyPress", null);
                __decorate([core_1.HostListener('paste', ['$event']), __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", void 0)], InputLongDirective.prototype, "onPaste", null);
                __decorate([core_1.HostListener('input', ['$event.target.value']), core_1.HostListener('change', ['$event.target.value']), __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", void 0)], InputLongDirective.prototype, "onInputChange", null);
                __decorate([core_1.HostListener('blur', ['$event']), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], InputLongDirective.prototype, "onBlur", null);
                InputLongDirective = __decorate([core_1.Directive({
                    selector: 'input[type=long][ngModel],input[type=long][ngControl]'
                }), core_1.Inject(core_1.ElementRef), core_1.Inject(common_1.NgControl), __metadata("design:paramtypes", [core_1.ElementRef, common_1.NgControl, core_1.Renderer])], InputLongDirective);
                return InputLongDirective;
            }(abstract_input_directive_1.AbstractInputDirective);
            exports_1("InputLongDirective", InputLongDirective);
        }
    };
});

System.register("ags-client/app/directives/abstract_input_directive.js", ["angular2/core.js", "ags-client/app/commons/html.js", "ags-client/app/commons/lang.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, html_1, lang_1, AbstractInputDirective;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (html_1_1) {
            html_1 = html_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }],
        execute: function () {
            AbstractInputDirective = /** @class */function () {
                function AbstractInputDirective(_elementRef, _control, _renderer, maxlength, _allowed, _validation) {
                    this._elementRef = _elementRef;
                    this._control = _control;
                    this._renderer = _renderer;
                    this._allowed = _allowed;
                    this._validation = _validation;
                    this._input = _elementRef.nativeElement;
                    this._input.setAttribute('type', 'text');
                    if (maxlength) {
                        html_1.setAttribute(this._input, 'maxlength', maxlength.toString(), false);
                    }
                }
                AbstractInputDirective.prototype.writeValue = function (value) {
                    this._renderer.setElementProperty(this.element.nativeElement, 'value', value ? value.toString() : null);
                };
                AbstractInputDirective.prototype.onKeyPress = function (event) {
                    if (!event.altKey) {
                        if (!event.ctrlKey) {
                            if (!event.metaKey) {
                                if (event.charCode > 31) {
                                    if (!this.isKeyAllowed(event.charCode)) {
                                        event.preventDefault();
                                    }
                                }
                            }
                        }
                    }
                };
                AbstractInputDirective.prototype.onPaste = function (event) {
                    if (ClipboardEvent && event.clipboardData && lang_1.isPresent(this._validation)) {
                        var data = event.clipboardData.getData('text/plain');
                        if (data != null) {
                            var modifiedData = this.modifyPasteData(data);
                            if (this.isInputValid(modifiedData)) {
                                this._input.value = modifiedData;
                                if (this._control) {
                                    this._control.viewToModelUpdate(modifiedData);
                                }
                            }
                            event.preventDefault();
                        }
                    }
                };
                AbstractInputDirective.prototype.isInputValid = function (data) {
                    if (lang_1.isPresent(this._validation) && data !== null && data !== '') {
                        return data.match(this._validation) !== null;
                    }
                    return true;
                };
                AbstractInputDirective.prototype.modifyPasteData = function (data) {
                    var _this = this;
                    if (data !== null && lang_1.isPresent(this._allowed)) {
                        var chars = data.split('');
                        var result = '';
                        chars.forEach(function (char) {
                            if (char.match(_this._allowed) != null) {
                                result = result.concat(char);
                            }
                        });
                        return result;
                    }
                    return data;
                };
                AbstractInputDirective.prototype.isKeyAllowed = function (charCode) {
                    if (lang_1.isPresent(this._allowed)) {
                        return String.fromCharCode(charCode).match(this._allowed) != null;
                    } else {
                        return true;
                    }
                };
                Object.defineProperty(AbstractInputDirective.prototype, "input", {
                    get: function () {
                        return this._input;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AbstractInputDirective.prototype, "element", {
                    get: function () {
                        return this._elementRef;
                    },
                    enumerable: false,
                    configurable: true
                });
                __decorate([core_1.HostListener('keypress', ['$event']), __metadata("design:type", Function), __metadata("design:paramtypes", [KeyboardEvent]), __metadata("design:returntype", void 0)], AbstractInputDirective.prototype, "onKeyPress", null);
                __decorate([core_1.HostListener('paste', ['$event']), __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", void 0)], AbstractInputDirective.prototype, "onPaste", null);
                return AbstractInputDirective;
            }();
            exports_1("AbstractInputDirective", AbstractInputDirective);
        }
    };
});

System.register("ags-client/app/directives/input_text_directive.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/directives/abstract_input_directive.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, abstract_input_directive_1, InputTextDirective;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (abstract_input_directive_1_1) {
            abstract_input_directive_1 = abstract_input_directive_1_1;
        }],
        execute: function () {
            InputTextDirective = /** @class */function (_super) {
                __extends(InputTextDirective, _super);
                function InputTextDirective(element, control, renderer) {
                    return _super.call(this, element, control, renderer, 120) || this;
                }
                InputTextDirective = __decorate([core_1.Directive({
                    selector: 'input[type=text][ngModel],input[type=text][ngControl]'
                }), core_1.Inject(core_1.ElementRef), core_1.Inject(common_1.NgControl), __metadata("design:paramtypes", [core_1.ElementRef, common_1.NgControl, core_1.Renderer])], InputTextDirective);
                return InputTextDirective;
            }(abstract_input_directive_1.AbstractInputDirective);
            exports_1("InputTextDirective", InputTextDirective);
        }
    };
});

System.register("ags-client/app/directives/select_code_directive.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/commons.js", "ags-client/app/services/translation_service.js", "ags-client/app/services/code_service.js", "ags-client/app/directives/abstract_select_directive.js", "ags-client/app/models/code.js", "ags-client/app/models/select_option.js", "ags-client/app/commons/lang.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, commons_1, translation_service_1, code_service_1, abstract_select_directive_1, code_1, select_option_1, lang_1, SelectCodeDirective;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (commons_1_1) {
            commons_1 = commons_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }, function (code_service_1_1) {
            code_service_1 = code_service_1_1;
        }, function (abstract_select_directive_1_1) {
            abstract_select_directive_1 = abstract_select_directive_1_1;
        }, function (code_1_1) {
            code_1 = code_1_1;
        }, function (select_option_1_1) {
            select_option_1 = select_option_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }],
        execute: function () {
            SelectCodeDirective = /** @class */function (_super) {
                __extends(SelectCodeDirective, _super);
                function SelectCodeDirective(element, control, _translationService, _codeService) {
                    var _this = _super.call(this, element, control) || this;
                    _this._translationService = _translationService;
                    _this._codeService = _codeService;
                    control.valueAccessor = _this;
                    return _this;
                }
                SelectCodeDirective.prototype.loadOptions = function (callback) {
                    var _this = this;
                    this._codeService.codesFromCache(this.codeCategory).then(function (codes) {
                        var options = new Array();
                        codes.forEach(function (code) {
                            var text = null;
                            if (lang_1.isPresent(_this.type) && _this.type === 'key') {
                                text = code;
                            } else if (lang_1.isPresent(_this.type) && _this.type === 'keyValue') {
                                text = code + ' - ' + _this._translationService.translate(_this.codeCategory + ':' + code);
                            } else {
                                text = _this._translationService.translate(_this.codeCategory + ':' + code);
                            }
                            if (!lang_1.isPresent(_this.parentCategory) || lang_1.isPresent(_this._parentValue) && code.indexOf(_this._parentValue.shortName + '.') === 0) {
                                if (!lang_1.isPresent(_this._include) || _this._include.indexOf(code) >= 0) {
                                    options.push(new select_option_1.SelectOption(code, text));
                                }
                            }
                        });
                        callback(options);
                    });
                };
                SelectCodeDirective.prototype.convertFromValue = function (value) {
                    if (value) {
                        return value.shortName;
                    }
                    return null;
                };
                SelectCodeDirective.prototype.convertToValue = function (stringValue) {
                    if (stringValue) {
                        var category = commons_1.CodeRegistry.code(this.codeCategory);
                        return category.create(stringValue);
                    }
                    return null;
                };
                SelectCodeDirective.prototype.onInputChange = function (stringValue) {
                    _super.prototype.onInputChange.call(this, stringValue);
                };
                SelectCodeDirective.prototype.onBlur = function () {
                    _super.prototype.onBlur.call(this);
                };
                Object.defineProperty(SelectCodeDirective.prototype, "parentValue", {
                    set: function (parentValue) {
                        var _this = this;
                        setTimeout(function () {
                            _this.onInputChange(null);
                        }, 100);
                        this._parentValue = parentValue;
                        this.refreshOptions();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SelectCodeDirective.prototype, "include", {
                    set: function (include) {
                        var _this = this;
                        setTimeout(function () {
                            _this.onInputChange(null);
                        }, 100);
                        this._include = include;
                        this.refreshOptions();
                    },
                    enumerable: false,
                    configurable: true
                });
                __decorate([core_1.Input('codeCategory'), __metadata("design:type", Object)], SelectCodeDirective.prototype, "codeCategory", void 0);
                __decorate([core_1.Input('parentCategory'), __metadata("design:type", Object)], SelectCodeDirective.prototype, "parentCategory", void 0);
                __decorate([core_1.Input('type'), __metadata("design:type", String)], SelectCodeDirective.prototype, "type", void 0);
                __decorate([core_1.HostListener('change', ['$event.target.value']), __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", void 0)], SelectCodeDirective.prototype, "onInputChange", null);
                __decorate([core_1.HostListener('blur', ['$event']), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], SelectCodeDirective.prototype, "onBlur", null);
                __decorate([core_1.Input('parentValue'), __metadata("design:type", code_1.Code), __metadata("design:paramtypes", [code_1.Code])], SelectCodeDirective.prototype, "parentValue", null);
                __decorate([core_1.Input('include'), __metadata("design:type", Array), __metadata("design:paramtypes", [Array])], SelectCodeDirective.prototype, "include", null);
                SelectCodeDirective = __decorate([core_1.Directive({
                    selector: 'select[codeCategory]'
                }), core_1.Inject(core_1.ElementRef), core_1.Inject(common_1.NgControl), __metadata("design:paramtypes", [core_1.ElementRef, common_1.NgControl, translation_service_1.TranslationService, code_service_1.CodeService])], SelectCodeDirective);
                return SelectCodeDirective;
            }(abstract_select_directive_1.AbstractSelectDirective);
            exports_1("SelectCodeDirective", SelectCodeDirective);
        }
    };
});

System.register("ags-client/app/directives/select_enum_directive.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/commons.js", "ags-client/app/services/translation_service.js", "ags-client/app/directives/abstract_select_directive.js", "ags-client/app/models/select_option.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, commons_1, translation_service_1, abstract_select_directive_1, select_option_1, SelectEnumDirective;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (commons_1_1) {
            commons_1 = commons_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }, function (abstract_select_directive_1_1) {
            abstract_select_directive_1 = abstract_select_directive_1_1;
        }, function (select_option_1_1) {
            select_option_1 = select_option_1_1;
        }],
        execute: function () {
            SelectEnumDirective = /** @class */function (_super) {
                __extends(SelectEnumDirective, _super);
                function SelectEnumDirective(element, control, _translationService) {
                    var _this = _super.call(this, element, control) || this;
                    _this._translationService = _translationService;
                    _this.control = control;
                    control.valueAccessor = _this;
                    return _this;
                }
                SelectEnumDirective.prototype.loadOptions = function (callback) {
                    var _this = this;
                    setTimeout(function () {
                        var options = new Array();
                        if (commons_1.EnumRegistry.enum(_this.enumCategory)) {
                            commons_1.enumStringValues(commons_1.EnumRegistry.enum(_this.enumCategory)).forEach(function (key) {
                                var parentKey = null;
                                if (commons_1.isPresent(_this.parentCategory) && commons_1.isPresent(_this._parentValue)) {
                                    parentKey = commons_1.enumStringValue(commons_1.EnumRegistry.enum(_this.parentCategory), _this._parentValue);
                                }
                                if ((!commons_1.isPresent(_this.parentCategory) || key.indexOf(parentKey) === 0) && (!commons_1.isPresent(_this.include) || _this.include.indexOf(key) >= 0) && (!commons_1.isPresent(_this.exclude) || _this.exclude.indexOf(key) < 0)) {
                                    options.push(new select_option_1.SelectOption(key, _this._translationService.translate(_this.enumCategory + ':' + key)));
                                }
                            });
                        }
                        callback(options);
                    }, 100);
                };
                SelectEnumDirective.prototype.convertFromValue = function (value) {
                    if (commons_1.isPresent(value) && commons_1.EnumRegistry.enum(this.enumCategory)) {
                        return commons_1.enumStringValue(commons_1.EnumRegistry.enum(this.enumCategory), value);
                    }
                    return null;
                };
                SelectEnumDirective.prototype.convertToValue = function (stringValue) {
                    if (commons_1.isPresent(stringValue)) {
                        return commons_1.enumNumberValue(commons_1.EnumRegistry.enum(this.enumCategory), stringValue);
                    }
                    return null;
                };
                SelectEnumDirective.prototype.onInputChange = function (stringValue) {
                    _super.prototype.onInputChange.call(this, stringValue);
                };
                SelectEnumDirective.prototype.onBlur = function () {
                    _super.prototype.onBlur.call(this);
                };
                Object.defineProperty(SelectEnumDirective.prototype, "parentValue", {
                    set: function (parentValue) {
                        var _this = this;
                        setTimeout(function () {
                            _this.onInputChange(null);
                        }, 100);
                        this._parentValue = parentValue;
                        this.refreshOptions();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SelectEnumDirective.prototype, "sorted", {
                    set: function (isSorted) {
                        _super.prototype.setIsSorted.call(this, isSorted);
                    },
                    enumerable: false,
                    configurable: true
                });
                __decorate([core_1.Input('enumCategory'), __metadata("design:type", Object)], SelectEnumDirective.prototype, "enumCategory", void 0);
                __decorate([core_1.Input('parentCategory'), __metadata("design:type", Object)], SelectEnumDirective.prototype, "parentCategory", void 0);
                __decorate([core_1.Input('include'), __metadata("design:type", Array)], SelectEnumDirective.prototype, "include", void 0);
                __decorate([core_1.Input('exclude'), __metadata("design:type", Array)], SelectEnumDirective.prototype, "exclude", void 0);
                __decorate([core_1.HostListener('change', ['$event.target.value']), __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", void 0)], SelectEnumDirective.prototype, "onInputChange", null);
                __decorate([core_1.HostListener('blur', ['$event']), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], SelectEnumDirective.prototype, "onBlur", null);
                __decorate([core_1.Input('parentValue'), __metadata("design:type", Number), __metadata("design:paramtypes", [Number])], SelectEnumDirective.prototype, "parentValue", null);
                __decorate([core_1.Input('sort'), __metadata("design:type", Boolean), __metadata("design:paramtypes", [Boolean])], SelectEnumDirective.prototype, "sorted", null);
                SelectEnumDirective = __decorate([core_1.Directive({
                    selector: 'select[enumCategory]'
                }), core_1.Inject(core_1.ElementRef), core_1.Inject(common_1.NgControl), core_1.Inject(common_1.Control), __metadata("design:paramtypes", [core_1.ElementRef, common_1.NgControl, translation_service_1.TranslationService])], SelectEnumDirective);
                return SelectEnumDirective;
            }(abstract_select_directive_1.AbstractSelectDirective);
            exports_1("SelectEnumDirective", SelectEnumDirective);
        }
    };
});

System.register("ags-client/app/directives/select_boolean_directive.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/services/translation_service.js", "ags-client/app/directives/abstract_select_directive.js", "ags-client/gen/i18n/translation_constants.js", "ags-client/app/commons/lang.js", "ags-client/app/models/select_option.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, translation_service_1, abstract_select_directive_1, translation_constants_1, lang_1, select_option_1, SelectBooleanDirective;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }, function (abstract_select_directive_1_1) {
            abstract_select_directive_1 = abstract_select_directive_1_1;
        }, function (translation_constants_1_1) {
            translation_constants_1 = translation_constants_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }, function (select_option_1_1) {
            select_option_1 = select_option_1_1;
        }],
        execute: function () {
            SelectBooleanDirective = /** @class */function (_super) {
                __extends(SelectBooleanDirective, _super);
                function SelectBooleanDirective(element, control, _translationService) {
                    var _this = _super.call(this, element, control) || this;
                    _this._translationService = _translationService;
                    control.valueAccessor = _this;
                    return _this;
                }
                SelectBooleanDirective.prototype.loadOptions = function (callback) {
                    callback([new select_option_1.SelectOption('true', this._translationService.translate(translation_constants_1.TranslationConstants.COMMONS_YES)), new select_option_1.SelectOption('false', this._translationService.translate(translation_constants_1.TranslationConstants.COMMONS_NO))]);
                };
                SelectBooleanDirective.prototype.convertFromValue = function (value) {
                    if (lang_1.isPresent(value)) {
                        return value ? 'true' : 'false';
                    }
                    return null;
                };
                SelectBooleanDirective.prototype.convertToValue = function (stringValue) {
                    if (lang_1.isSomething(stringValue)) {
                        return stringValue === 'true';
                    }
                    return null;
                };
                SelectBooleanDirective.prototype.onInputChange = function (stringValue) {
                    _super.prototype.onInputChange.call(this, stringValue);
                };
                SelectBooleanDirective.prototype.onBlur = function () {
                    _super.prototype.onBlur.call(this);
                };
                __decorate([core_1.HostListener('change', ['$event.target.value']), __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", void 0)], SelectBooleanDirective.prototype, "onInputChange", null);
                __decorate([core_1.HostListener('blur', ['$event']), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], SelectBooleanDirective.prototype, "onBlur", null);
                SelectBooleanDirective = __decorate([core_1.Directive({
                    selector: 'select[type=boolean]'
                }), core_1.Inject(core_1.ElementRef), core_1.Inject(common_1.NgControl), __metadata("design:paramtypes", [core_1.ElementRef, common_1.NgControl, translation_service_1.TranslationService])], SelectBooleanDirective);
                return SelectBooleanDirective;
            }(abstract_select_directive_1.AbstractSelectDirective);
            exports_1("SelectBooleanDirective", SelectBooleanDirective);
        }
    };
});

System.register("ags-client/gen/viewmodels/code_search_result_view_model.js", ["ags-client/app/commons/lang.js", "ags-client/gen/viewmodels/entity_view_model.js", "ags-client/app/validators.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var lang_1, entity_view_model_1, Validators, lang_2, lang_3, CodeSearchResultViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (lang_1_1) {
            lang_1 = lang_1_1;
            lang_2 = lang_1_1;
            lang_3 = lang_1_1;
        }, function (entity_view_model_1_1) {
            entity_view_model_1 = entity_view_model_1_1;
        }, function (Validators_1) {
            Validators = Validators_1;
        }],
        execute: function () {
            CodeSearchResultViewModel = /** @class */function (_super) {
                __extends(CodeSearchResultViewModel, _super);
                function CodeSearchResultViewModel() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                CodeSearchResultViewModel.deserialize = function (object) {
                    var _result = new CodeSearchResultViewModel();
                    return _result._deserialize(object);
                };
                CodeSearchResultViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        _super.prototype._deserialize.call(this, object);
                        if (lang_1.isPresent(object['categoryKey'])) {
                            this.categoryKey = object['categoryKey'];
                        }
                        if (lang_1.isPresent(object['categoryDescription'])) {
                            this.categoryDescription = object['categoryDescription'];
                        }
                        if (lang_1.isPresent(object['name'])) {
                            this.name = object['name'];
                        }
                        if (lang_1.isPresent(object['description'])) {
                            this.description = object['description'];
                        }
                        if (lang_1.isPresent(object['validFrom'])) {
                            this.validFrom = lang_3.deserializeDate(object['validFrom']);
                        }
                        if (lang_1.isPresent(object['validTo'])) {
                            this.validTo = lang_3.deserializeDate(object['validTo']);
                        }
                        if (lang_1.isPresent(object['deleted'])) {
                            this.deleted = object['deleted'];
                        }
                    }
                    return this;
                };
                CodeSearchResultViewModel.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (lang_1.isPresent(this.categoryKey)) {
                        object['categoryKey'] = this.categoryKey;
                    }
                    if (lang_1.isPresent(this.categoryDescription)) {
                        object['categoryDescription'] = this.categoryDescription;
                    }
                    if (lang_1.isPresent(this.name)) {
                        object['name'] = this.name;
                    }
                    if (lang_1.isPresent(this.description)) {
                        object['description'] = this.description;
                    }
                    if (lang_1.isPresent(this.validFrom)) {
                        object['validFrom'] = lang_2.serializeDate(this.validFrom);
                    }
                    if (lang_1.isPresent(this.validTo)) {
                        object['validTo'] = lang_2.serializeDate(this.validTo);
                    }
                    if (lang_1.isPresent(this.deleted)) {
                        object['deleted'] = this.deleted;
                    }
                    return object;
                };
                CodeSearchResultViewModel.CATEGORY_KEY_VALIDATORS = [];
                CodeSearchResultViewModel.CATEGORY_DESCRIPTION_VALIDATORS = [];
                CodeSearchResultViewModel.NAME_VALIDATORS = [Validators.required(), Validators.max(80)];
                CodeSearchResultViewModel.DESCRIPTION_VALIDATORS = [];
                CodeSearchResultViewModel.VALID_FROM_VALIDATORS = [Validators.date, Validators.required()];
                CodeSearchResultViewModel.VALID_TO_VALIDATORS = [];
                CodeSearchResultViewModel.DELETED_VALIDATORS = [];
                return CodeSearchResultViewModel;
            }(entity_view_model_1.EntityViewModel);
            exports_1("CodeSearchResultViewModel", CodeSearchResultViewModel);
        }
    };
});

System.register("ags-client/gen/viewmodels/code_view_model.js", ["ags-client/app/commons/lang.js", "ags-client/gen/viewmodels/entity_view_model.js", "ags-client/app/validators.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var lang_1, entity_view_model_1, Validators, lang_2, lang_3, CodeViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (lang_1_1) {
            lang_1 = lang_1_1;
            lang_2 = lang_1_1;
            lang_3 = lang_1_1;
        }, function (entity_view_model_1_1) {
            entity_view_model_1 = entity_view_model_1_1;
        }, function (Validators_1) {
            Validators = Validators_1;
        }],
        execute: function () {
            CodeViewModel = /** @class */function (_super) {
                __extends(CodeViewModel, _super);
                function CodeViewModel() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                CodeViewModel.deserialize = function (object) {
                    var _result = new CodeViewModel();
                    return _result._deserialize(object);
                };
                CodeViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        _super.prototype._deserialize.call(this, object);
                        if (lang_1.isPresent(object['name'])) {
                            this.name = object['name'];
                        }
                        if (lang_1.isPresent(object['categoryKey'])) {
                            this.categoryKey = object['categoryKey'];
                        }
                        if (lang_1.isPresent(object['categoryDescription'])) {
                            this.categoryDescription = object['categoryDescription'];
                        }
                        if (lang_1.isPresent(object['validFrom'])) {
                            this.validFrom = lang_3.deserializeDate(object['validFrom']);
                        }
                        if (lang_1.isPresent(object['validTo'])) {
                            this.validTo = lang_3.deserializeDate(object['validTo']);
                        }
                        if (lang_1.isPresent(object['descriptionDe'])) {
                            this.descriptionDe = object['descriptionDe'];
                        }
                        if (lang_1.isPresent(object['descriptionEn'])) {
                            this.descriptionEn = object['descriptionEn'];
                        }
                        if (lang_1.isPresent(object['descriptionFr'])) {
                            this.descriptionFr = object['descriptionFr'];
                        }
                        if (lang_1.isPresent(object['descriptionIt'])) {
                            this.descriptionIt = object['descriptionIt'];
                        }
                        if (lang_1.isPresent(object['remarkDe'])) {
                            this.remarkDe = object['remarkDe'];
                        }
                        if (lang_1.isPresent(object['remarkEn'])) {
                            this.remarkEn = object['remarkEn'];
                        }
                        if (lang_1.isPresent(object['remarkFr'])) {
                            this.remarkFr = object['remarkFr'];
                        }
                        if (lang_1.isPresent(object['remarkIt'])) {
                            this.remarkIt = object['remarkIt'];
                        }
                    }
                    return this;
                };
                CodeViewModel.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (lang_1.isPresent(this.name)) {
                        object['name'] = this.name;
                    }
                    if (lang_1.isPresent(this.categoryKey)) {
                        object['categoryKey'] = this.categoryKey;
                    }
                    if (lang_1.isPresent(this.categoryDescription)) {
                        object['categoryDescription'] = this.categoryDescription;
                    }
                    if (lang_1.isPresent(this.validFrom)) {
                        object['validFrom'] = lang_2.serializeDate(this.validFrom);
                    }
                    if (lang_1.isPresent(this.validTo)) {
                        object['validTo'] = lang_2.serializeDate(this.validTo);
                    }
                    if (lang_1.isPresent(this.descriptionDe)) {
                        object['descriptionDe'] = this.descriptionDe;
                    }
                    if (lang_1.isPresent(this.descriptionEn)) {
                        object['descriptionEn'] = this.descriptionEn;
                    }
                    if (lang_1.isPresent(this.descriptionFr)) {
                        object['descriptionFr'] = this.descriptionFr;
                    }
                    if (lang_1.isPresent(this.descriptionIt)) {
                        object['descriptionIt'] = this.descriptionIt;
                    }
                    if (lang_1.isPresent(this.remarkDe)) {
                        object['remarkDe'] = this.remarkDe;
                    }
                    if (lang_1.isPresent(this.remarkEn)) {
                        object['remarkEn'] = this.remarkEn;
                    }
                    if (lang_1.isPresent(this.remarkFr)) {
                        object['remarkFr'] = this.remarkFr;
                    }
                    if (lang_1.isPresent(this.remarkIt)) {
                        object['remarkIt'] = this.remarkIt;
                    }
                    return object;
                };
                CodeViewModel.NAME_VALIDATORS = [Validators.required(), Validators.max(80)];
                CodeViewModel.CATEGORY_KEY_VALIDATORS = [];
                CodeViewModel.CATEGORY_DESCRIPTION_VALIDATORS = [];
                CodeViewModel.VALID_FROM_VALIDATORS = [Validators.date, Validators.required()];
                CodeViewModel.VALID_TO_VALIDATORS = [];
                CodeViewModel.DESCRIPTION_DE_VALIDATORS = [Validators.max(4000)];
                CodeViewModel.DESCRIPTION_EN_VALIDATORS = [Validators.max(4000)];
                CodeViewModel.DESCRIPTION_FR_VALIDATORS = [Validators.max(4000)];
                CodeViewModel.DESCRIPTION_IT_VALIDATORS = [Validators.max(4000)];
                CodeViewModel.REMARK_DE_VALIDATORS = [Validators.max(4000)];
                CodeViewModel.REMARK_EN_VALIDATORS = [Validators.max(4000)];
                CodeViewModel.REMARK_FR_VALIDATORS = [Validators.max(4000)];
                CodeViewModel.REMARK_IT_VALIDATORS = [Validators.max(4000)];
                return CodeViewModel;
            }(entity_view_model_1.EntityViewModel);
            exports_1("CodeViewModel", CodeViewModel);
        }
    };
});

System.register("ags-client/gen/services/abstract_code_service.js", ["ags-client/app/models/json_response.js", "ags-client/gen/viewmodels/code_search_result_view_model.js", "ags-client/gen/viewmodels/code_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var json_response_1, code_search_result_view_model_1, code_view_model_1, AbstractCodeService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (json_response_1_1) {
            json_response_1 = json_response_1_1;
        }, function (code_search_result_view_model_1_1) {
            code_search_result_view_model_1 = code_search_result_view_model_1_1;
        }, function (code_view_model_1_1) {
            code_view_model_1 = code_view_model_1_1;
        }],
        execute: function () {
            AbstractCodeService = /** @class */function () {
                function AbstractCodeService(backendService) {
                    this.backendService = backendService;
                }
                AbstractCodeService.prototype.codes = function (request) {
                    return this.backendService.getJson('/code/codes/' + request + '.json', function (response) {
                        return json_response_1.JsonResponse.deserialize(response, response.data);
                    });
                };
                AbstractCodeService.prototype.search = function (request) {
                    return this.backendService.postJson('/code/search.json', request.serialize(), function (response) {
                        var data = Array();
                        response.data.forEach(function (item) {
                            data.push(code_search_result_view_model_1.CodeSearchResultViewModel.deserialize(item));
                        });
                        return json_response_1.JsonResponse.deserialize(response, data);
                    });
                };
                AbstractCodeService.prototype.get = function (request) {
                    return this.backendService.getJson('/code/get/' + request + '.json', function (response) {
                        return json_response_1.JsonResponse.deserialize(response, code_view_model_1.CodeViewModel.deserialize(response.data));
                    });
                };
                AbstractCodeService.prototype.store = function (request) {
                    return this.backendService.postJson('/code/store.json', request.serialize(), function (response) {
                        return json_response_1.JsonResponse.deserialize(response, code_view_model_1.CodeViewModel.deserialize(response.data));
                    });
                };
                AbstractCodeService.prototype.delete = function (request) {
                    return this.backendService.getJson('/code/delete/' + request + '.json', function (response) {
                        return json_response_1.JsonResponse.deserialize(response);
                    });
                };
                AbstractCodeService.prototype.undelete = function (request) {
                    return this.backendService.getJson('/code/undelete/' + request + '.json', function (response) {
                        return json_response_1.JsonResponse.deserialize(response);
                    });
                };
                return AbstractCodeService;
            }();
            exports_1("AbstractCodeService", AbstractCodeService);
        }
    };
});

System.register("ags-client/app/services/code_service.js", ["angular2/core.js", "ags-client/gen/services/abstract_code_service.js", "ags-client/app/services/backend_service.js", "ags-client/app/services/translation_service.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, abstract_code_service_1, backend_service_1, translation_service_1, CodeService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (abstract_code_service_1_1) {
            abstract_code_service_1 = abstract_code_service_1_1;
        }, function (backend_service_1_1) {
            backend_service_1 = backend_service_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }],
        execute: function () {
            CodeService = /** @class */function (_super) {
                __extends(CodeService, _super);
                function CodeService(backendService, _translationService) {
                    var _this = _super.call(this, backendService) || this;
                    _this._translationService = _translationService;
                    _this._categoryCodesCache = {};
                    return _this;
                }
                CodeService.prototype.codesFromCache = function (category) {
                    var _this = this;
                    if (!this._categoryCodesCache[category]) {
                        this._categoryCodesCache[category] = new Promise(function (resolve) {
                            _this.codes(category).subscribe(function (codes) {
                                resolve(codes.data);
                            });
                        });
                    }
                    return this._categoryCodesCache[category];
                };
                CodeService.prototype.sortCodesByDescription = function (category, codes) {
                    var _this = this;
                    if (codes) {
                        codes.sort(function (a, b) {
                            var at = _this._translationService.translate(category + ':' + a.shortName);
                            var bt = _this._translationService.translate(category + ':' + b.shortName);
                            return at.localeCompare(bt);
                        });
                    }
                    return codes;
                };
                CodeService = __decorate([core_1.Injectable(), core_1.Inject(backend_service_1.BackendService), __metadata("design:paramtypes", [backend_service_1.BackendService, translation_service_1.TranslationService])], CodeService);
                return CodeService;
            }(abstract_code_service_1.AbstractCodeService);
            exports_1("CodeService", CodeService);
        }
    };
});

System.register("ags-client/app/directives/select_directive.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/services/translation_service.js", "ags-client/app/services/code_service.js", "ags-client/app/directives/abstract_select_directive.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, translation_service_1, code_service_1, abstract_select_directive_1, SelectDirective;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }, function (code_service_1_1) {
            code_service_1 = code_service_1_1;
        }, function (abstract_select_directive_1_1) {
            abstract_select_directive_1 = abstract_select_directive_1_1;
        }],
        execute: function () {
            SelectDirective = /** @class */function (_super) {
                __extends(SelectDirective, _super);
                function SelectDirective(element, control, _translationService, _codeService) {
                    var _this = _super.call(this, element, control) || this;
                    _this._translationService = _translationService;
                    _this._codeService = _codeService;
                    control.valueAccessor = _this;
                    return _this;
                }
                SelectDirective.prototype.loadOptions = function (callback) {
                    callback(this._options);
                };
                SelectDirective.prototype.onInputChange = function (stringValue) {
                    _super.prototype.onInputChange.call(this, stringValue);
                };
                SelectDirective.prototype.onBlur = function () {
                    _super.prototype.onBlur.call(this);
                };
                Object.defineProperty(SelectDirective.prototype, "selectionOptions", {
                    set: function (options) {
                        this._options = options;
                        this.refreshOptions();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SelectDirective.prototype, "sorted", {
                    set: function (isSorted) {
                        _super.prototype.setIsSorted.call(this, isSorted);
                    },
                    enumerable: false,
                    configurable: true
                });
                __decorate([core_1.HostListener('change', ['$event.target.value']), __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", void 0)], SelectDirective.prototype, "onInputChange", null);
                __decorate([core_1.HostListener('blur', ['$event']), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], SelectDirective.prototype, "onBlur", null);
                __decorate([core_1.Input('options'), __metadata("design:type", Array), __metadata("design:paramtypes", [Array])], SelectDirective.prototype, "selectionOptions", null);
                __decorate([core_1.Input('sort'), __metadata("design:type", Boolean), __metadata("design:paramtypes", [Boolean])], SelectDirective.prototype, "sorted", null);
                SelectDirective = __decorate([core_1.Directive({
                    selector: 'select[options]'
                }), core_1.Inject(core_1.ElementRef), core_1.Inject(common_1.NgControl), __metadata("design:paramtypes", [core_1.ElementRef, common_1.NgControl, translation_service_1.TranslationService, code_service_1.CodeService])], SelectDirective);
                return SelectDirective;
            }(abstract_select_directive_1.AbstractSelectDirective);
            exports_1("SelectDirective", SelectDirective);
        }
    };
});

System.register("ags-client/gen/viewmodels/category_view_model.js", ["ags-client/app/commons/lang.js", "ags-client/gen/viewmodels/entity_view_model.js", "ags-client/app/validators.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var lang_1, entity_view_model_1, Validators, CategoryViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (lang_1_1) {
            lang_1 = lang_1_1;
        }, function (entity_view_model_1_1) {
            entity_view_model_1 = entity_view_model_1_1;
        }, function (Validators_1) {
            Validators = Validators_1;
        }],
        execute: function () {
            CategoryViewModel = /** @class */function (_super) {
                __extends(CategoryViewModel, _super);
                function CategoryViewModel() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                CategoryViewModel.deserialize = function (object) {
                    var _result = new CategoryViewModel();
                    return _result._deserialize(object);
                };
                CategoryViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        _super.prototype._deserialize.call(this, object);
                        if (lang_1.isPresent(object['shortName'])) {
                            this.shortName = object['shortName'];
                        }
                        if (lang_1.isPresent(object['name'])) {
                            this.name = object['name'];
                        }
                        if (lang_1.isPresent(object['description'])) {
                            this.description = object['description'];
                        }
                        if (lang_1.isPresent(object['statical'])) {
                            this.statical = object['statical'];
                        }
                    }
                    return this;
                };
                CategoryViewModel.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (lang_1.isPresent(this.shortName)) {
                        object['shortName'] = this.shortName;
                    }
                    if (lang_1.isPresent(this.name)) {
                        object['name'] = this.name;
                    }
                    if (lang_1.isPresent(this.description)) {
                        object['description'] = this.description;
                    }
                    if (lang_1.isPresent(this.statical)) {
                        object['statical'] = this.statical;
                    }
                    return object;
                };
                CategoryViewModel.SHORT_NAME_VALIDATORS = [Validators.required(), Validators.max(30)];
                CategoryViewModel.NAME_VALIDATORS = [Validators.required(), Validators.max(30)];
                CategoryViewModel.DESCRIPTION_VALIDATORS = [Validators.required(), Validators.max(4000)];
                CategoryViewModel.STATICAL_VALIDATORS = [];
                return CategoryViewModel;
            }(entity_view_model_1.EntityViewModel);
            exports_1("CategoryViewModel", CategoryViewModel);
        }
    };
});

System.register("ags-client/gen/services/abstract_category_service.js", ["ags-client/app/models/json_response.js", "ags-client/gen/viewmodels/category_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var json_response_1, category_view_model_1, AbstractCategoryService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (json_response_1_1) {
            json_response_1 = json_response_1_1;
        }, function (category_view_model_1_1) {
            category_view_model_1 = category_view_model_1_1;
        }],
        execute: function () {
            AbstractCategoryService = /** @class */function () {
                function AbstractCategoryService(backendService) {
                    this.backendService = backendService;
                }
                AbstractCategoryService.prototype.categories = function () {
                    return this.backendService.getJson('/category/categories.json', function (response) {
                        var data = Array();
                        response.data.forEach(function (item) {
                            data.push(category_view_model_1.CategoryViewModel.deserialize(item));
                        });
                        return json_response_1.JsonResponse.deserialize(response, data);
                    });
                };
                AbstractCategoryService.prototype.search = function (request) {
                    return this.backendService.postJson('/category/search.json', request.serialize(), function (response) {
                        var data = Array();
                        response.data.forEach(function (item) {
                            data.push(category_view_model_1.CategoryViewModel.deserialize(item));
                        });
                        return json_response_1.JsonResponse.deserialize(response, data);
                    });
                };
                AbstractCategoryService.prototype.get = function (request) {
                    return this.backendService.getJson('/category/get/' + request + '.json', function (response) {
                        return json_response_1.JsonResponse.deserialize(response, category_view_model_1.CategoryViewModel.deserialize(response.data));
                    });
                };
                AbstractCategoryService.prototype.store = function (request) {
                    return this.backendService.postJson('/category/store.json', request.serialize(), function (response) {
                        return json_response_1.JsonResponse.deserialize(response, category_view_model_1.CategoryViewModel.deserialize(response.data));
                    });
                };
                AbstractCategoryService.prototype.delete = function (request) {
                    return this.backendService.getJson('/category/delete/' + request + '.json', function (response) {
                        return json_response_1.JsonResponse.deserialize(response);
                    });
                };
                AbstractCategoryService.prototype.undelete = function (request) {
                    return this.backendService.getJson('/category/undelete/' + request + '.json', function (response) {
                        return json_response_1.JsonResponse.deserialize(response);
                    });
                };
                return AbstractCategoryService;
            }();
            exports_1("AbstractCategoryService", AbstractCategoryService);
        }
    };
});

System.register("ags-client/app/services/category_service.js", ["angular2/core.js", "ags-client/gen/services/abstract_category_service.js", "ags-client/app/services/backend_service.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, abstract_category_service_1, backend_service_1, CategoryService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (abstract_category_service_1_1) {
            abstract_category_service_1 = abstract_category_service_1_1;
        }, function (backend_service_1_1) {
            backend_service_1 = backend_service_1_1;
        }],
        execute: function () {
            CategoryService = /** @class */function (_super) {
                __extends(CategoryService, _super);
                function CategoryService(backendService) {
                    return _super.call(this, backendService) || this;
                }
                CategoryService = __decorate([core_1.Injectable(), core_1.Inject(backend_service_1.BackendService), __metadata("design:paramtypes", [backend_service_1.BackendService])], CategoryService);
                return CategoryService;
            }(abstract_category_service_1.AbstractCategoryService);
            exports_1("CategoryService", CategoryService);
        }
    };
});

System.register("ags-client/app/directives/select_category_directive.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/services/category_service.js", "ags-client/app/directives/abstract_select_directive.js", "ags-client/app/models/select_option.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, category_service_1, abstract_select_directive_1, select_option_1, SelectCategoryDirective;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (category_service_1_1) {
            category_service_1 = category_service_1_1;
        }, function (abstract_select_directive_1_1) {
            abstract_select_directive_1 = abstract_select_directive_1_1;
        }, function (select_option_1_1) {
            select_option_1 = select_option_1_1;
        }],
        execute: function () {
            SelectCategoryDirective = /** @class */function (_super) {
                __extends(SelectCategoryDirective, _super);
                function SelectCategoryDirective(element, control, _categoryService) {
                    var _this = _super.call(this, element, control) || this;
                    _this._categoryService = _categoryService;
                    control.valueAccessor = _this;
                    return _this;
                }
                SelectCategoryDirective.prototype.loadOptions = function (callback) {
                    this._categoryService.categories().subscribe(function (response) {
                        var options = new Array();
                        response.data.forEach(function (category) {
                            options.push(new select_option_1.SelectOption(category.shortName, category.description, category));
                        });
                        callback(options);
                    });
                };
                SelectCategoryDirective.prototype.onInputChange = function (stringValue) {
                    _super.prototype.onInputChange.call(this, stringValue);
                };
                SelectCategoryDirective.prototype.onBlur = function () {
                    _super.prototype.onBlur.call(this);
                };
                __decorate([core_1.HostListener('change', ['$event.target.value']), __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", void 0)], SelectCategoryDirective.prototype, "onInputChange", null);
                __decorate([core_1.HostListener('blur', ['$event']), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], SelectCategoryDirective.prototype, "onBlur", null);
                SelectCategoryDirective = __decorate([core_1.Directive({
                    selector: 'select[type=category]'
                }), core_1.Inject(core_1.ElementRef), core_1.Inject(common_1.NgControl), __metadata("design:paramtypes", [core_1.ElementRef, common_1.NgControl, category_service_1.CategoryService])], SelectCategoryDirective);
                return SelectCategoryDirective;
            }(abstract_select_directive_1.AbstractSelectDirective);
            exports_1("SelectCategoryDirective", SelectCategoryDirective);
        }
    };
});

System.register("ags-client/app/directives/select_year_directive.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/directives/abstract_select_directive.js", "ags-client/app/models/select_option.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, abstract_select_directive_1, select_option_1, SelectYearDirective;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (abstract_select_directive_1_1) {
            abstract_select_directive_1 = abstract_select_directive_1_1;
        }, function (select_option_1_1) {
            select_option_1 = select_option_1_1;
        }],
        execute: function () {
            SelectYearDirective = /** @class */function (_super) {
                __extends(SelectYearDirective, _super);
                function SelectYearDirective(element, control) {
                    var _this = _super.call(this, element, control) || this;
                    _this._min = new Date().getFullYear() - 10;
                    _this._max = new Date().getFullYear() + 10;
                    control.valueAccessor = _this;
                    _super.prototype.setIsSorted.call(_this, false);
                    return _this;
                }
                SelectYearDirective.prototype.loadOptions = function (callback) {
                    var options = new Array();
                    for (var i = this._max; i >= this._min; i--) {
                        options.push(new select_option_1.SelectOption(i.toString(), i.toString(), i));
                    }
                    callback(options);
                };
                SelectYearDirective.prototype.onInputChange = function (stringValue) {
                    _super.prototype.onInputChange.call(this, stringValue);
                };
                SelectYearDirective.prototype.onBlur = function () {
                    _super.prototype.onBlur.call(this);
                };
                Object.defineProperty(SelectYearDirective.prototype, "min", {
                    get: function () {
                        return this._min;
                    },
                    set: function (min) {
                        this._min = min;
                        this.refreshOptions();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SelectYearDirective.prototype, "max", {
                    get: function () {
                        return this._max;
                    },
                    set: function (max) {
                        this._max = max;
                        this.refreshOptions();
                    },
                    enumerable: false,
                    configurable: true
                });
                __decorate([core_1.HostListener('change', ['$event.target.value']), __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", void 0)], SelectYearDirective.prototype, "onInputChange", null);
                __decorate([core_1.HostListener('blur', ['$event']), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], SelectYearDirective.prototype, "onBlur", null);
                __decorate([core_1.Input(), __metadata("design:type", Number), __metadata("design:paramtypes", [Number])], SelectYearDirective.prototype, "min", null);
                __decorate([core_1.Input(), __metadata("design:type", Number), __metadata("design:paramtypes", [Number])], SelectYearDirective.prototype, "max", null);
                SelectYearDirective = __decorate([core_1.Directive({
                    selector: 'select[type=year]'
                }), core_1.Inject(core_1.ElementRef), core_1.Inject(common_1.NgControl), __metadata("design:paramtypes", [core_1.ElementRef, common_1.NgControl])], SelectYearDirective);
                return SelectYearDirective;
            }(abstract_select_directive_1.AbstractSelectDirective);
            exports_1("SelectYearDirective", SelectYearDirective);
        }
    };
});

System.register("ags-client/app/directives/select_month_directive.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/directives/abstract_select_directive.js", "ags-client/app/models/select_option.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, abstract_select_directive_1, select_option_1, SelectMonthDirective;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (abstract_select_directive_1_1) {
            abstract_select_directive_1 = abstract_select_directive_1_1;
        }, function (select_option_1_1) {
            select_option_1 = select_option_1_1;
        }],
        execute: function () {
            SelectMonthDirective = /** @class */function (_super) {
                __extends(SelectMonthDirective, _super);
                function SelectMonthDirective(element, control) {
                    var _this = _super.call(this, element, control) || this;
                    _this._min = 1;
                    _this._max = 12;
                    control.valueAccessor = _this;
                    _super.prototype.setIsSorted.call(_this, false);
                    return _this;
                }
                SelectMonthDirective.prototype.loadOptions = function (callback) {
                    var options = new Array();
                    for (var i = this._min; i <= this._max; i++) {
                        options.push(new select_option_1.SelectOption(i.toString(), i.toString(), i));
                    }
                    callback(options);
                };
                SelectMonthDirective.prototype.onInputChange = function (stringValue) {
                    _super.prototype.onInputChange.call(this, stringValue);
                };
                SelectMonthDirective.prototype.onBlur = function () {
                    _super.prototype.onBlur.call(this);
                };
                Object.defineProperty(SelectMonthDirective.prototype, "min", {
                    set: function (min) {
                        this._min = min;
                        this.refreshOptions();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SelectMonthDirective.prototype, "max", {
                    set: function (max) {
                        this._max = max;
                        this.refreshOptions();
                    },
                    enumerable: false,
                    configurable: true
                });
                __decorate([core_1.HostListener('change', ['$event.target.value']), __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", void 0)], SelectMonthDirective.prototype, "onInputChange", null);
                __decorate([core_1.HostListener('blur', ['$event']), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], SelectMonthDirective.prototype, "onBlur", null);
                __decorate([core_1.Input(), __metadata("design:type", Number), __metadata("design:paramtypes", [Number])], SelectMonthDirective.prototype, "min", null);
                __decorate([core_1.Input(), __metadata("design:type", Number), __metadata("design:paramtypes", [Number])], SelectMonthDirective.prototype, "max", null);
                SelectMonthDirective = __decorate([core_1.Directive({
                    selector: 'select[type=month]'
                }), core_1.Inject(core_1.ElementRef), core_1.Inject(common_1.NgControl), __metadata("design:paramtypes", [core_1.ElementRef, common_1.NgControl])], SelectMonthDirective);
                return SelectMonthDirective;
            }(abstract_select_directive_1.AbstractSelectDirective);
            exports_1("SelectMonthDirective", SelectMonthDirective);
        }
    };
});

System.register("ags-client/app/directives/abstract_select_directive.js", ["ags-client/app/commons/lang.js", "ags-client/app/commons/html.js"], function (exports_1, context_1) {
    "use strict";

    var lang_1, html_1, AbstractSelectDirective;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (lang_1_1) {
            lang_1 = lang_1_1;
        }, function (html_1_1) {
            html_1 = html_1_1;
        }],
        execute: function () {
            AbstractSelectDirective = /** @class */function () {
                function AbstractSelectDirective(_element, _control) {
                    this._element = _element;
                    this._control = _control;
                    this.isSorted = true;
                    this.onChange = function (_) {
                        return;
                    };
                    this.onTouched = function () {
                        return;
                    };
                }
                AbstractSelectDirective.prototype.ngAfterViewInit = function () {
                    var _this = this;
                    setTimeout(function () {
                        _this.refreshOptions();
                    }, 200);
                };
                AbstractSelectDirective.prototype.refreshOptions = function () {
                    var _this = this;
                    this.loadOptions(function (options) {
                        html_1.removeChilds(_this._element.nativeElement);
                        _this.allOptionCssClasses = new Set();
                        if (!_this._element.nativeElement.hasAttribute('required')) {
                            _this._element.nativeElement.appendChild(document.createElement('option'));
                        }
                        if (lang_1.isPresent(options) && options.length > 0) {
                            if (_this.isSorted) {
                                _this.options = _this.sortOptions(options);
                            } else {
                                _this.options = options;
                            }
                            _this.options.forEach(function (option) {
                                _this._element.nativeElement.appendChild(_this._create(option.key, option.text, option.cssclass));
                                _this.allOptionCssClasses.add(option.cssclass);
                            });
                            if (lang_1.isPresent(_this.value)) {
                                _this.selectValue(_this.value);
                            } else {
                                if (_this._element.nativeElement.querySelector('option')) {
                                    _this._element.nativeElement.querySelector('option').setAttribute('selected', 'selected');
                                }
                            }
                        }
                    });
                };
                AbstractSelectDirective.prototype.sortOptions = function (options) {
                    return options.sort(function (a, b) {
                        return a.text.localeCompare(b.text);
                    });
                };
                AbstractSelectDirective.prototype.writeValue = function (value) {
                    if (lang_1.isPresent(value)) {
                        this.selectValue(value);
                    } else {
                        this.selectValue(null);
                    }
                };
                AbstractSelectDirective.prototype.onInputChange = function (stringValue) {
                    this.setElementClass(this.cssclassFromStringValue(stringValue));
                    this.onChange(this.convertToValue(stringValue));
                };
                AbstractSelectDirective.prototype.onBlur = function () {
                    this.onTouched();
                };
                AbstractSelectDirective.prototype.convertFromValue = function (value) {
                    if (this.options) {
                        for (var i = 0; i < this.options.length; i++) {
                            if (this.options[i].value === value) {
                                return this.options[i].key;
                            }
                        }
                    }
                    return null;
                };
                AbstractSelectDirective.prototype.convertToValue = function (stringValue) {
                    if (this.options) {
                        for (var i = 0; i < this.options.length; i++) {
                            if (this.options[i].key === stringValue) {
                                return this.options[i].value;
                            }
                        }
                    }
                    return null;
                };
                AbstractSelectDirective.prototype.cssclassFromStringValue = function (stringValue) {
                    if (this.allOptionCssClasses && this.allOptionCssClasses.size > 0) {
                        for (var i = 0; i < this.options.length; i++) {
                            if (this.options[i].key === stringValue) {
                                return this.options[i].cssclass;
                            }
                        }
                    }
                    return null;
                };
                AbstractSelectDirective.prototype.selectValue = function (value) {
                    this.value = value;
                    var element = this._element.nativeElement.querySelector('option');
                    var cssclass = null;
                    if (lang_1.isPresent(value)) {
                        var stringValue = this.convertFromValue(value);
                        var index = 0;
                        cssclass = this.cssclassFromStringValue(stringValue);
                        while (element) {
                            if (element.tagName === 'OPTION') {
                                var option = element;
                                if (option.value === stringValue) {
                                    option.setAttribute('selected', 'true');
                                    var selectElement = option.parentElement;
                                    selectElement.selectedIndex = index;
                                } else {
                                    option.removeAttribute('selected');
                                }
                            }
                            element = element.nextElementSibling;
                            index++;
                        }
                    } else {
                        while (element) {
                            if (element.tagName === 'OPTION') {
                                var option = element;
                                option.removeAttribute('selected');
                            }
                            element = element.nextElementSibling;
                        }
                        if (this._element.nativeElement.querySelector('option')) {
                            this._element.nativeElement.querySelector('option').setAttribute('selected', 'selected');
                        }
                    }
                    this.setElementClass(cssclass);
                };
                AbstractSelectDirective.prototype.setElementClass = function (cssclass) {
                    var _this = this;
                    if (this.allOptionCssClasses) {
                        this.allOptionCssClasses.forEach(function (x) {
                            return _this._element.nativeElement.classList.remove(x);
                        });
                        if (cssclass) this._element.nativeElement.classList.add(cssclass);
                    }
                };
                AbstractSelectDirective.prototype._create = function (value, translation, cssclass) {
                    var option = document.createElement('option');
                    option.value = value;
                    option.text = translation;
                    option.className = cssclass;
                    return option;
                };
                AbstractSelectDirective.prototype.registerOnChange = function (fn) {
                    this.onChange = fn;
                };
                AbstractSelectDirective.prototype.registerOnTouched = function (fn) {
                    this.onTouched = fn;
                };
                AbstractSelectDirective.prototype.setIsSorted = function (isSorted) {
                    this.isSorted = isSorted;
                };
                return AbstractSelectDirective;
            }();
            exports_1("AbstractSelectDirective", AbstractSelectDirective);
        }
    };
});

System.register("ags-client/app/models/select_option.js", [], function (exports_1, context_1) {
    "use strict";

    var SelectOption;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [],
        execute: function () {
            SelectOption = /** @class */function () {
                function SelectOption(key, text, value, cssclass) {
                    this.key = key;
                    this.text = text;
                    this.value = value;
                    this.cssclass = cssclass;
                }
                return SelectOption;
            }();
            exports_1("SelectOption", SelectOption);
        }
    };
});

System.register("ags-client/app/directives/select_day_directive.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/directives/abstract_select_directive.js", "ags-client/app/models/select_option.js", "ags-client/app/commons/lang.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, abstract_select_directive_1, select_option_1, lang_1, SelectDayDirective;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (abstract_select_directive_1_1) {
            abstract_select_directive_1 = abstract_select_directive_1_1;
        }, function (select_option_1_1) {
            select_option_1 = select_option_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }],
        execute: function () {
            SelectDayDirective = /** @class */function (_super) {
                __extends(SelectDayDirective, _super);
                function SelectDayDirective(element, control) {
                    var _this = _super.call(this, element, control) || this;
                    _this._min = 1;
                    _this._max = 31;
                    control.valueAccessor = _this;
                    _super.prototype.setIsSorted.call(_this, false);
                    return _this;
                }
                SelectDayDirective.prototype.loadOptions = function (callback) {
                    if (this._year > 0 && this._month > 0) {
                        this._max = lang_1.lastDayOfMonth(this._year, this._month);
                    }
                    var options = new Array();
                    for (var i = this._min; i <= this._max; i++) {
                        options.push(new select_option_1.SelectOption(i.toString(), i.toString(), i));
                    }
                    callback(options);
                };
                SelectDayDirective.prototype.onInputChange = function (stringValue) {
                    _super.prototype.onInputChange.call(this, stringValue);
                };
                SelectDayDirective.prototype.onBlur = function () {
                    _super.prototype.onBlur.call(this);
                };
                Object.defineProperty(SelectDayDirective.prototype, "min", {
                    set: function (min) {
                        this._min = min;
                        this.refreshOptions();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SelectDayDirective.prototype, "max", {
                    set: function (max) {
                        this._max = max;
                        this.refreshOptions();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SelectDayDirective.prototype, "year", {
                    set: function (year) {
                        this._year = year;
                        this.refreshOptions();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SelectDayDirective.prototype, "month", {
                    set: function (month) {
                        this._month = month;
                        this.refreshOptions();
                    },
                    enumerable: false,
                    configurable: true
                });
                __decorate([core_1.HostListener('change', ['$event.target.value']), __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", void 0)], SelectDayDirective.prototype, "onInputChange", null);
                __decorate([core_1.HostListener('blur', ['$event']), __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], SelectDayDirective.prototype, "onBlur", null);
                __decorate([core_1.Input(), __metadata("design:type", Number), __metadata("design:paramtypes", [Number])], SelectDayDirective.prototype, "min", null);
                __decorate([core_1.Input(), __metadata("design:type", Number), __metadata("design:paramtypes", [Number])], SelectDayDirective.prototype, "max", null);
                __decorate([core_1.Input(), __metadata("design:type", Number), __metadata("design:paramtypes", [Number])], SelectDayDirective.prototype, "year", null);
                __decorate([core_1.Input(), __metadata("design:type", Number), __metadata("design:paramtypes", [Number])], SelectDayDirective.prototype, "month", null);
                SelectDayDirective = __decorate([core_1.Directive({
                    selector: 'select[type=day]'
                }), core_1.Inject(core_1.ElementRef), core_1.Inject(common_1.NgControl), __metadata("design:paramtypes", [core_1.ElementRef, common_1.NgControl])], SelectDayDirective);
                return SelectDayDirective;
            }(abstract_select_directive_1.AbstractSelectDirective);
            exports_1("SelectDayDirective", SelectDayDirective);
        }
    };
});

System.register("ags-client/app/directives/table_loading_directive.js", ["angular2/core.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, TableLoadingDirective;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }],
        execute: function () {
            TableLoadingDirective = /** @class */function () {
                function TableLoadingDirective(table) {
                    this._table = table.nativeElement;
                }
                TableLoadingDirective.prototype.ngOnChanges = function (changes) {
                    var _this = this;
                    if (!this._overlay) {
                        this._overlay = document.createElement('div');
                        this._overlay.setAttribute('class', 'table-loading-overlay');
                        var spinner = document.createElement('img');
                        spinner.setAttribute('src', 'ags-client/images/spinner.gif');
                        this._overlay.appendChild(spinner);
                        this._overlay.setAttribute('style', 'display: none;');
                        this._table.parentElement.appendChild(this._overlay);
                    }
                    if (this.loading) {
                        setTimeout(function () {
                            if (_this.loading) {
                                var tableHead = _this._table.querySelector('thead');
                                var top = tableHead.clientHeight + (tableHead.getBoundingClientRect().top - _this._table.parentElement.parentElement.getBoundingClientRect().top);
                                var width = tableHead.clientWidth;
                                var height = _this._table.querySelector('tbody').scrollHeight;
                                _this._overlay.setAttribute('style', 'top: ' + top + 'px; width: ' + width + 'px; height: ' + height + 'px;');
                            } else {
                                _this._overlay.setAttribute('style', 'display: none;');
                            }
                        }, 100);
                    } else {
                        this._overlay.setAttribute('style', 'display: none;');
                    }
                };
                __decorate([core_1.Input('loading'), __metadata("design:type", Boolean)], TableLoadingDirective.prototype, "loading", void 0);
                TableLoadingDirective = __decorate([core_1.Directive({
                    selector: 'table[loading]'
                }), core_1.Inject(core_1.ElementRef), __metadata("design:paramtypes", [core_1.ElementRef])], TableLoadingDirective);
                return TableLoadingDirective;
            }();
            exports_1("TableLoadingDirective", TableLoadingDirective);
        }
    };
});

System.registerDynamic("angular2/src/common/pipes/async_pipe.js", ["angular2/src/facade/lang.js", "angular2/src/facade/async.js", "angular2/core.js", "angular2/src/common/pipes/invalid_pipe_argument_exception.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var async_1 = $__require("angular2/src/facade/async.js");
    var core_1 = $__require("angular2/core.js");
    var invalid_pipe_argument_exception_1 = $__require("angular2/src/common/pipes/invalid_pipe_argument_exception.js");
    var ObservableStrategy = function () {
        function ObservableStrategy() {}
        ObservableStrategy.prototype.createSubscription = function (async, updateLatestValue) {
            return async_1.ObservableWrapper.subscribe(async, updateLatestValue, function (e) {
                throw e;
            });
        };
        ObservableStrategy.prototype.dispose = function (subscription) {
            async_1.ObservableWrapper.dispose(subscription);
        };
        ObservableStrategy.prototype.onDestroy = function (subscription) {
            async_1.ObservableWrapper.dispose(subscription);
        };
        return ObservableStrategy;
    }();
    var PromiseStrategy = function () {
        function PromiseStrategy() {}
        PromiseStrategy.prototype.createSubscription = function (async, updateLatestValue) {
            return async.then(updateLatestValue);
        };
        PromiseStrategy.prototype.dispose = function (subscription) {};
        PromiseStrategy.prototype.onDestroy = function (subscription) {};
        return PromiseStrategy;
    }();
    var _promiseStrategy = new PromiseStrategy();
    var _observableStrategy = new ObservableStrategy();
    var __unused; // avoid unused import when Promise union types are erased
    /**
     * The `async` pipe subscribes to an Observable or Promise and returns the latest value it has
     * emitted.
     * When a new value is emitted, the `async` pipe marks the component to be checked for changes.
     *
     * ### Example
     *
     * This example binds a `Promise` to the view. Clicking the `Resolve` button resolves the
     * promise.
     *
     * {@example core/pipes/ts/async_pipe/async_pipe_example.ts region='AsyncPipe'}
     *
     * It's also possible to use `async` with Observables. The example below binds the `time` Observable
     * to the view. Every 500ms, the `time` Observable updates the view with the current time.
     *
     * ```typescript
     * ```
     */
    var AsyncPipe = function () {
        function AsyncPipe(_ref) {
            /** @internal */
            this._latestValue = null;
            /** @internal */
            this._latestReturnedValue = null;
            /** @internal */
            this._subscription = null;
            /** @internal */
            this._obj = null;
            this._strategy = null;
            this._ref = _ref;
        }
        AsyncPipe.prototype.ngOnDestroy = function () {
            if (lang_1.isPresent(this._subscription)) {
                this._dispose();
            }
        };
        AsyncPipe.prototype.transform = function (obj, args) {
            if (lang_1.isBlank(this._obj)) {
                if (lang_1.isPresent(obj)) {
                    this._subscribe(obj);
                }
                this._latestReturnedValue = this._latestValue;
                return this._latestValue;
            }
            if (obj !== this._obj) {
                this._dispose();
                return this.transform(obj);
            }
            if (this._latestValue === this._latestReturnedValue) {
                return this._latestReturnedValue;
            } else {
                this._latestReturnedValue = this._latestValue;
                return core_1.WrappedValue.wrap(this._latestValue);
            }
        };
        /** @internal */
        AsyncPipe.prototype._subscribe = function (obj) {
            var _this = this;
            this._obj = obj;
            this._strategy = this._selectStrategy(obj);
            this._subscription = this._strategy.createSubscription(obj, function (value) {
                return _this._updateLatestValue(obj, value);
            });
        };
        /** @internal */
        AsyncPipe.prototype._selectStrategy = function (obj) {
            if (lang_1.isPromise(obj)) {
                return _promiseStrategy;
            } else if (async_1.ObservableWrapper.isObservable(obj)) {
                return _observableStrategy;
            } else {
                throw new invalid_pipe_argument_exception_1.InvalidPipeArgumentException(AsyncPipe, obj);
            }
        };
        /** @internal */
        AsyncPipe.prototype._dispose = function () {
            this._strategy.dispose(this._subscription);
            this._latestValue = null;
            this._latestReturnedValue = null;
            this._subscription = null;
            this._obj = null;
        };
        /** @internal */
        AsyncPipe.prototype._updateLatestValue = function (async, value) {
            if (async === this._obj) {
                this._latestValue = value;
                this._ref.markForCheck();
            }
        };
        AsyncPipe = __decorate([
        // avoid unused import when Promise union types are erased
        core_1.Pipe({ name: 'async', pure: false }), core_1.Injectable(), __metadata('design:paramtypes', [core_1.ChangeDetectorRef])], AsyncPipe);
        return AsyncPipe;
    }();
    exports.AsyncPipe = AsyncPipe;
});
System.registerDynamic("angular2/src/common/pipes/uppercase_pipe.js", ["angular2/src/facade/lang.js", "angular2/core.js", "angular2/src/common/pipes/invalid_pipe_argument_exception.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var core_1 = $__require("angular2/core.js");
    var invalid_pipe_argument_exception_1 = $__require("angular2/src/common/pipes/invalid_pipe_argument_exception.js");
    /**
     * Implements uppercase transforms to text.
     *
     * ### Example
     *
     * {@example core/pipes/ts/lowerupper_pipe/lowerupper_pipe_example.ts region='LowerUpperPipe'}
     */
    var UpperCasePipe = function () {
        function UpperCasePipe() {}
        UpperCasePipe.prototype.transform = function (value, args) {
            if (args === void 0) {
                args = null;
            }
            if (lang_1.isBlank(value)) return value;
            if (!lang_1.isString(value)) {
                throw new invalid_pipe_argument_exception_1.InvalidPipeArgumentException(UpperCasePipe, value);
            }
            return value.toUpperCase();
        };
        UpperCasePipe = __decorate([lang_1.CONST(), core_1.Pipe({ name: 'uppercase' }), core_1.Injectable(), __metadata('design:paramtypes', [])], UpperCasePipe);
        return UpperCasePipe;
    }();
    exports.UpperCasePipe = UpperCasePipe;
});
System.registerDynamic("angular2/src/common/pipes/lowercase_pipe.js", ["angular2/src/facade/lang.js", "angular2/core.js", "angular2/src/common/pipes/invalid_pipe_argument_exception.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var core_1 = $__require("angular2/core.js");
    var invalid_pipe_argument_exception_1 = $__require("angular2/src/common/pipes/invalid_pipe_argument_exception.js");
    /**
     * Transforms text to lowercase.
     *
     * ### Example
     *
     * {@example core/pipes/ts/lowerupper_pipe/lowerupper_pipe_example.ts region='LowerUpperPipe'}
     */
    var LowerCasePipe = function () {
        function LowerCasePipe() {}
        LowerCasePipe.prototype.transform = function (value, args) {
            if (args === void 0) {
                args = null;
            }
            if (lang_1.isBlank(value)) return value;
            if (!lang_1.isString(value)) {
                throw new invalid_pipe_argument_exception_1.InvalidPipeArgumentException(LowerCasePipe, value);
            }
            return value.toLowerCase();
        };
        LowerCasePipe = __decorate([lang_1.CONST(), core_1.Pipe({ name: 'lowercase' }), core_1.Injectable(), __metadata('design:paramtypes', [])], LowerCasePipe);
        return LowerCasePipe;
    }();
    exports.LowerCasePipe = LowerCasePipe;
});
System.registerDynamic("angular2/src/common/pipes/json_pipe.js", ["angular2/src/facade/lang.js", "angular2/core.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var core_1 = $__require("angular2/core.js");
    /**
     * Transforms any input value using `JSON.stringify`. Useful for debugging.
     *
     * ### Example
     * {@example core/pipes/ts/json_pipe/json_pipe_example.ts region='JsonPipe'}
     */
    var JsonPipe = function () {
        function JsonPipe() {}
        JsonPipe.prototype.transform = function (value, args) {
            if (args === void 0) {
                args = null;
            }
            return lang_1.Json.stringify(value);
        };
        JsonPipe = __decorate([lang_1.CONST(), core_1.Pipe({ name: 'json', pure: false }), core_1.Injectable(), __metadata('design:paramtypes', [])], JsonPipe);
        return JsonPipe;
    }();
    exports.JsonPipe = JsonPipe;
});
System.registerDynamic("angular2/src/common/pipes/slice_pipe.js", ["angular2/src/facade/lang.js", "angular2/src/facade/exceptions.js", "angular2/src/facade/collection.js", "angular2/core.js", "angular2/src/common/pipes/invalid_pipe_argument_exception.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var exceptions_1 = $__require("angular2/src/facade/exceptions.js");
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var core_1 = $__require("angular2/core.js");
    var invalid_pipe_argument_exception_1 = $__require("angular2/src/common/pipes/invalid_pipe_argument_exception.js");
    /**
     * Creates a new List or String containing only a subset (slice) of the
     * elements.
     *
     * The starting index of the subset to return is specified by the `start` parameter.
     *
     * The ending index of the subset to return is specified by the optional `end` parameter.
     *
     * ### Usage
     *
     *     expression | slice:start[:end]
     *
     * All behavior is based on the expected behavior of the JavaScript API
     * Array.prototype.slice() and String.prototype.slice()
     *
     * Where the input expression is a [List] or [String], and `start` is:
     *
     * - **a positive integer**: return the item at _start_ index and all items after
     * in the list or string expression.
     * - **a negative integer**: return the item at _start_ index from the end and all items after
     * in the list or string expression.
     * - **`|start|` greater than the size of the expression**: return an empty list or string.
     * - **`|start|` negative greater than the size of the expression**: return entire list or
     * string expression.
     *
     * and where `end` is:
     *
     * - **omitted**: return all items until the end of the input
     * - **a positive integer**: return all items before _end_ index of the list or string
     * expression.
     * - **a negative integer**: return all items before _end_ index from the end of the list
     * or string expression.
     *
     * When operating on a [List], the returned list is always a copy even when all
     * the elements are being returned.
     *
     * ## List Example
     *
     * This `ngFor` example:
     *
     * {@example core/pipes/ts/slice_pipe/slice_pipe_example.ts region='SlicePipe_list'}
     *
     * produces the following:
     *
     *     <li>b</li>
     *     <li>c</li>
     *
     * ## String Examples
     *
     * {@example core/pipes/ts/slice_pipe/slice_pipe_example.ts region='SlicePipe_string'}
     */
    var SlicePipe = function () {
        function SlicePipe() {}
        SlicePipe.prototype.transform = function (value, args) {
            if (args === void 0) {
                args = null;
            }
            if (lang_1.isBlank(args) || args.length == 0) {
                throw new exceptions_1.BaseException('Slice pipe requires one argument');
            }
            if (!this.supports(value)) {
                throw new invalid_pipe_argument_exception_1.InvalidPipeArgumentException(SlicePipe, value);
            }
            if (lang_1.isBlank(value)) return value;
            var start = args[0];
            var end = args.length > 1 ? args[1] : null;
            if (lang_1.isString(value)) {
                return lang_1.StringWrapper.slice(value, start, end);
            }
            return collection_1.ListWrapper.slice(value, start, end);
        };
        SlicePipe.prototype.supports = function (obj) {
            return lang_1.isString(obj) || lang_1.isArray(obj);
        };
        SlicePipe = __decorate([core_1.Pipe({ name: 'slice', pure: false }), core_1.Injectable(), __metadata('design:paramtypes', [])], SlicePipe);
        return SlicePipe;
    }();
    exports.SlicePipe = SlicePipe;
});
System.registerDynamic("angular2/src/common/pipes/date_pipe.js", ["angular2/src/facade/lang.js", "angular2/src/facade/intl.js", "angular2/core.js", "angular2/src/facade/collection.js", "angular2/src/common/pipes/invalid_pipe_argument_exception.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var intl_1 = $__require("angular2/src/facade/intl.js");
    var core_1 = $__require("angular2/core.js");
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var invalid_pipe_argument_exception_1 = $__require("angular2/src/common/pipes/invalid_pipe_argument_exception.js");
    // TODO: move to a global configurable location along with other i18n components.
    var defaultLocale = 'en-US';
    /**
     * Formats a date value to a string based on the requested format.
     *
     * WARNINGS:
     * - this pipe is marked as pure hence it will not be re-evaluated when the input is mutated.
     *   Instead users should treat the date as an immutable object and change the reference when the
     *   pipe needs to re-run (this is to avoid reformatting the date on every change detection run
     *   which would be an expensive operation).
     * - this pipe uses the Internationalization API. Therefore it is only reliable in Chrome and Opera
     *   browsers.
     *
     * ## Usage
     *
     *     expression | date[:format]
     *
     * where `expression` is a date object or a number (milliseconds since UTC epoch) and
     * `format` indicates which date/time components to include:
     *
     *  | Component | Symbol | Short Form   | Long Form         | Numeric   | 2-digit   |
     *  |-----------|:------:|--------------|-------------------|-----------|-----------|
     *  | era       |   G    | G (AD)       | GGGG (Anno Domini)| -         | -         |
     *  | year      |   y    | -            | -                 | y (2015)  | yy (15)   |
     *  | month     |   M    | MMM (Sep)    | MMMM (September)  | M (9)     | MM (09)   |
     *  | day       |   d    | -            | -                 | d (3)     | dd (03)   |
     *  | weekday   |   E    | EEE (Sun)    | EEEE (Sunday)     | -         | -         |
     *  | hour      |   j    | -            | -                 | j (13)    | jj (13)   |
     *  | hour12    |   h    | -            | -                 | h (1 PM)  | hh (01 PM)|
     *  | hour24    |   H    | -            | -                 | H (13)    | HH (13)   |
     *  | minute    |   m    | -            | -                 | m (5)     | mm (05)   |
     *  | second    |   s    | -            | -                 | s (9)     | ss (09)   |
     *  | timezone  |   z    | -            | z (Pacific Standard Time)| -  | -         |
     *  | timezone  |   Z    | Z (GMT-8:00) | -                 | -         | -         |
     *
     * In javascript, only the components specified will be respected (not the ordering,
     * punctuations, ...) and details of the formatting will be dependent on the locale.
     * On the other hand in Dart version, you can also include quoted text as well as some extra
     * date/time components such as quarter. For more information see:
     * https://api.dartlang.org/apidocs/channels/stable/dartdoc-viewer/intl/intl.DateFormat.
     *
     * `format` can also be one of the following predefined formats:
     *
     *  - `'medium'`: equivalent to `'yMMMdjms'` (e.g. Sep 3, 2010, 12:05:08 PM for en-US)
     *  - `'short'`: equivalent to `'yMdjm'` (e.g. 9/3/2010, 12:05 PM for en-US)
     *  - `'fullDate'`: equivalent to `'yMMMMEEEEd'` (e.g. Friday, September 3, 2010 for en-US)
     *  - `'longDate'`: equivalent to `'yMMMMd'` (e.g. September 3, 2010)
     *  - `'mediumDate'`: equivalent to `'yMMMd'` (e.g. Sep 3, 2010 for en-US)
     *  - `'shortDate'`: equivalent to `'yMd'` (e.g. 9/3/2010 for en-US)
     *  - `'mediumTime'`: equivalent to `'jms'` (e.g. 12:05:08 PM for en-US)
     *  - `'shortTime'`: equivalent to `'jm'` (e.g. 12:05 PM for en-US)
     *
     * Timezone of the formatted text will be the local system timezone of the end-users machine.
     *
     * ### Examples
     *
     * Assuming `dateObj` is (year: 2015, month: 6, day: 15, hour: 21, minute: 43, second: 11)
     * in the _local_ time and locale is 'en-US':
     *
     * ```
     *     {{ dateObj | date }}               // output is 'Jun 15, 2015'
     *     {{ dateObj | date:'medium' }}      // output is 'Jun 15, 2015, 9:43:11 PM'
     *     {{ dateObj | date:'shortTime' }}   // output is '9:43 PM'
     *     {{ dateObj | date:'mmss' }}        // output is '43:11'
     * ```
     *
     * {@example core/pipes/ts/date_pipe/date_pipe_example.ts region='DatePipe'}
     */
    var DatePipe = function () {
        function DatePipe() {}
        DatePipe.prototype.transform = function (value, args) {
            if (lang_1.isBlank(value)) return null;
            if (!this.supports(value)) {
                throw new invalid_pipe_argument_exception_1.InvalidPipeArgumentException(DatePipe, value);
            }
            var pattern = lang_1.isPresent(args) && args.length > 0 ? args[0] : 'mediumDate';
            if (lang_1.isNumber(value)) {
                value = lang_1.DateWrapper.fromMillis(value);
            }
            if (collection_1.StringMapWrapper.contains(DatePipe._ALIASES, pattern)) {
                pattern = collection_1.StringMapWrapper.get(DatePipe._ALIASES, pattern);
            }
            return intl_1.DateFormatter.format(value, defaultLocale, pattern);
        };
        DatePipe.prototype.supports = function (obj) {
            return lang_1.isDate(obj) || lang_1.isNumber(obj);
        };
        /** @internal */
        DatePipe._ALIASES = {
            'medium': 'yMMMdjms',
            'short': 'yMdjm',
            'fullDate': 'yMMMMEEEEd',
            'longDate': 'yMMMMd',
            'mediumDate': 'yMMMd',
            'shortDate': 'yMd',
            'mediumTime': 'jms',
            'shortTime': 'jm'
        };
        DatePipe = __decorate([lang_1.CONST(), core_1.Pipe({ name: 'date', pure: true }), core_1.Injectable(), __metadata('design:paramtypes', [])], DatePipe);
        return DatePipe;
    }();
    exports.DatePipe = DatePipe;
});
System.registerDynamic("angular2/src/facade/intl.js", [], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    (function (NumberFormatStyle) {
        NumberFormatStyle[NumberFormatStyle["Decimal"] = 0] = "Decimal";
        NumberFormatStyle[NumberFormatStyle["Percent"] = 1] = "Percent";
        NumberFormatStyle[NumberFormatStyle["Currency"] = 2] = "Currency";
    })(exports.NumberFormatStyle || (exports.NumberFormatStyle = {}));
    var NumberFormatStyle = exports.NumberFormatStyle;
    var NumberFormatter = function () {
        function NumberFormatter() {}
        NumberFormatter.format = function (num, locale, style, _a) {
            var _b = _a === void 0 ? {} : _a,
                _c = _b.minimumIntegerDigits,
                minimumIntegerDigits = _c === void 0 ? 1 : _c,
                _d = _b.minimumFractionDigits,
                minimumFractionDigits = _d === void 0 ? 0 : _d,
                _e = _b.maximumFractionDigits,
                maximumFractionDigits = _e === void 0 ? 3 : _e,
                currency = _b.currency,
                _f = _b.currencyAsSymbol,
                currencyAsSymbol = _f === void 0 ? false : _f;
            var intlOptions = {
                minimumIntegerDigits: minimumIntegerDigits,
                minimumFractionDigits: minimumFractionDigits,
                maximumFractionDigits: maximumFractionDigits
            };
            intlOptions.style = NumberFormatStyle[style].toLowerCase();
            if (style == NumberFormatStyle.Currency) {
                intlOptions.currency = currency;
                intlOptions.currencyDisplay = currencyAsSymbol ? 'symbol' : 'code';
            }
            return new Intl.NumberFormat(locale, intlOptions).format(num);
        };
        return NumberFormatter;
    }();
    exports.NumberFormatter = NumberFormatter;
    function digitCondition(len) {
        return len == 2 ? '2-digit' : 'numeric';
    }
    function nameCondition(len) {
        return len < 4 ? 'short' : 'long';
    }
    function extractComponents(pattern) {
        var ret = {};
        var i = 0,
            j;
        while (i < pattern.length) {
            j = i;
            while (j < pattern.length && pattern[j] == pattern[i]) j++;
            var len = j - i;
            switch (pattern[i]) {
                case 'G':
                    ret.era = nameCondition(len);
                    break;
                case 'y':
                    ret.year = digitCondition(len);
                    break;
                case 'M':
                    if (len >= 3) ret.month = nameCondition(len);else ret.month = digitCondition(len);
                    break;
                case 'd':
                    ret.day = digitCondition(len);
                    break;
                case 'E':
                    ret.weekday = nameCondition(len);
                    break;
                case 'j':
                    ret.hour = digitCondition(len);
                    break;
                case 'h':
                    ret.hour = digitCondition(len);
                    ret.hour12 = true;
                    break;
                case 'H':
                    ret.hour = digitCondition(len);
                    ret.hour12 = false;
                    break;
                case 'm':
                    ret.minute = digitCondition(len);
                    break;
                case 's':
                    ret.second = digitCondition(len);
                    break;
                case 'z':
                    ret.timeZoneName = 'long';
                    break;
                case 'Z':
                    ret.timeZoneName = 'short';
                    break;
            }
            i = j;
        }
        return ret;
    }
    var dateFormatterCache = new Map();
    var DateFormatter = function () {
        function DateFormatter() {}
        DateFormatter.format = function (date, locale, pattern) {
            var key = locale + pattern;
            if (dateFormatterCache.has(key)) {
                return dateFormatterCache.get(key).format(date);
            }
            var formatter = new Intl.DateTimeFormat(locale, extractComponents(pattern));
            dateFormatterCache.set(key, formatter);
            return formatter.format(date);
        };
        return DateFormatter;
    }();
    exports.DateFormatter = DateFormatter;
});
System.registerDynamic("angular2/src/common/pipes/number_pipe.js", ["angular2/src/facade/lang.js", "angular2/src/facade/exceptions.js", "angular2/src/facade/intl.js", "angular2/core.js", "angular2/src/facade/collection.js", "angular2/src/common/pipes/invalid_pipe_argument_exception.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var exceptions_1 = $__require("angular2/src/facade/exceptions.js");
    var intl_1 = $__require("angular2/src/facade/intl.js");
    var core_1 = $__require("angular2/core.js");
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var invalid_pipe_argument_exception_1 = $__require("angular2/src/common/pipes/invalid_pipe_argument_exception.js");
    var defaultLocale = 'en-US';
    var _re = lang_1.RegExpWrapper.create('^(\\d+)?\\.((\\d+)(\\-(\\d+))?)?$');
    /**
     * Internal base class for numeric pipes.
     */
    var NumberPipe = function () {
        function NumberPipe() {}
        /** @internal */
        NumberPipe._format = function (value, style, digits, currency, currencyAsSymbol) {
            if (currency === void 0) {
                currency = null;
            }
            if (currencyAsSymbol === void 0) {
                currencyAsSymbol = false;
            }
            if (lang_1.isBlank(value)) return null;
            if (!lang_1.isNumber(value)) {
                throw new invalid_pipe_argument_exception_1.InvalidPipeArgumentException(NumberPipe, value);
            }
            var minInt = 1,
                minFraction = 0,
                maxFraction = 3;
            if (lang_1.isPresent(digits)) {
                var parts = lang_1.RegExpWrapper.firstMatch(_re, digits);
                if (lang_1.isBlank(parts)) {
                    throw new exceptions_1.BaseException(digits + " is not a valid digit info for number pipes");
                }
                if (lang_1.isPresent(parts[1])) {
                    minInt = lang_1.NumberWrapper.parseIntAutoRadix(parts[1]);
                }
                if (lang_1.isPresent(parts[3])) {
                    minFraction = lang_1.NumberWrapper.parseIntAutoRadix(parts[3]);
                }
                if (lang_1.isPresent(parts[5])) {
                    maxFraction = lang_1.NumberWrapper.parseIntAutoRadix(parts[5]);
                }
            }
            return intl_1.NumberFormatter.format(value, defaultLocale, style, {
                minimumIntegerDigits: minInt,
                minimumFractionDigits: minFraction,
                maximumFractionDigits: maxFraction,
                currency: currency,
                currencyAsSymbol: currencyAsSymbol
            });
        };
        NumberPipe = __decorate([lang_1.CONST(), core_1.Injectable(), __metadata('design:paramtypes', [])], NumberPipe);
        return NumberPipe;
    }();
    exports.NumberPipe = NumberPipe;
    /**
     * WARNING: this pipe uses the Internationalization API.
     * Therefore it is only reliable in Chrome and Opera browsers.
     *
     * Formats a number as local text. i.e. group sizing and separator and other locale-specific
     * configurations are based on the active locale.
     *
     * ### Usage
     *
     *     expression | number[:digitInfo]
     *
     * where `expression` is a number and `digitInfo` has the following format:
     *
     *     {minIntegerDigits}.{minFractionDigits}-{maxFractionDigits}
     *
     * - minIntegerDigits is the minimum number of integer digits to use. Defaults to 1.
     * - minFractionDigits is the minimum number of digits after fraction. Defaults to 0.
     * - maxFractionDigits is the maximum number of digits after fraction. Defaults to 3.
     *
     * For more information on the acceptable range for each of these numbers and other
     * details see your native internationalization library.
     *
     * ### Example
     *
     * {@example core/pipes/ts/number_pipe/number_pipe_example.ts region='NumberPipe'}
     */
    var DecimalPipe = function (_super) {
        __extends(DecimalPipe, _super);
        function DecimalPipe() {
            _super.apply(this, arguments);
        }
        DecimalPipe.prototype.transform = function (value, args) {
            var digits = collection_1.ListWrapper.first(args);
            return NumberPipe._format(value, intl_1.NumberFormatStyle.Decimal, digits);
        };
        DecimalPipe = __decorate([lang_1.CONST(), core_1.Pipe({ name: 'number' }), core_1.Injectable(), __metadata('design:paramtypes', [])], DecimalPipe);
        return DecimalPipe;
    }(NumberPipe);
    exports.DecimalPipe = DecimalPipe;
    /**
     * WARNING: this pipe uses the Internationalization API.
     * Therefore it is only reliable in Chrome and Opera browsers.
     *
     * Formats a number as local percent.
     *
     * ### Usage
     *
     *     expression | percent[:digitInfo]
     *
     * For more information about `digitInfo` see {@link DecimalPipe}
     *
     * ### Example
     *
     * {@example core/pipes/ts/number_pipe/number_pipe_example.ts region='PercentPipe'}
     */
    var PercentPipe = function (_super) {
        __extends(PercentPipe, _super);
        function PercentPipe() {
            _super.apply(this, arguments);
        }
        PercentPipe.prototype.transform = function (value, args) {
            var digits = collection_1.ListWrapper.first(args);
            return NumberPipe._format(value, intl_1.NumberFormatStyle.Percent, digits);
        };
        PercentPipe = __decorate([lang_1.CONST(), core_1.Pipe({ name: 'percent' }), core_1.Injectable(), __metadata('design:paramtypes', [])], PercentPipe);
        return PercentPipe;
    }(NumberPipe);
    exports.PercentPipe = PercentPipe;
    /**
     * WARNING: this pipe uses the Internationalization API.
     * Therefore it is only reliable in Chrome and Opera browsers.
     *
     * Formats a number as local currency.
     *
     * ### Usage
     *
     *     expression | currency[:currencyCode[:symbolDisplay[:digitInfo]]]
     *
     * where `currencyCode` is the ISO 4217 currency code, such as "USD" for the US dollar and
     * "EUR" for the euro. `symbolDisplay` is a boolean indicating whether to use the currency
     * symbol (e.g. $) or the currency code (e.g. USD) in the output. The default for this value
     * is `false`.
     * For more information about `digitInfo` see {@link DecimalPipe}
     *
     * ### Example
     *
     * {@example core/pipes/ts/number_pipe/number_pipe_example.ts region='CurrencyPipe'}
     */
    var CurrencyPipe = function (_super) {
        __extends(CurrencyPipe, _super);
        function CurrencyPipe() {
            _super.apply(this, arguments);
        }
        CurrencyPipe.prototype.transform = function (value, args) {
            var currencyCode = lang_1.isPresent(args) && args.length > 0 ? args[0] : 'USD';
            var symbolDisplay = lang_1.isPresent(args) && args.length > 1 ? args[1] : false;
            var digits = lang_1.isPresent(args) && args.length > 2 ? args[2] : null;
            return NumberPipe._format(value, intl_1.NumberFormatStyle.Currency, digits, currencyCode, symbolDisplay);
        };
        CurrencyPipe = __decorate([lang_1.CONST(), core_1.Pipe({ name: 'currency' }), core_1.Injectable(), __metadata('design:paramtypes', [])], CurrencyPipe);
        return CurrencyPipe;
    }(NumberPipe);
    exports.CurrencyPipe = CurrencyPipe;
});
System.registerDynamic("angular2/src/common/pipes/replace_pipe.js", ["angular2/src/facade/lang.js", "angular2/src/facade/exceptions.js", "angular2/core.js", "angular2/src/common/pipes/invalid_pipe_argument_exception.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var exceptions_1 = $__require("angular2/src/facade/exceptions.js");
    var core_1 = $__require("angular2/core.js");
    var invalid_pipe_argument_exception_1 = $__require("angular2/src/common/pipes/invalid_pipe_argument_exception.js");
    /**
     * Creates a new String with some or all of the matches of a pattern replaced by
     * a replacement.
     *
     * The pattern to be matched is specified by the 'pattern' parameter.
     *
     * The replacement to be set is specified by the 'replacement' parameter.
     *
     * An optional 'flags' parameter can be set.
     *
     * ### Usage
     *
     *     expression | replace:pattern:replacement
     *
     * All behavior is based on the expected behavior of the JavaScript API
     * String.prototype.replace() function.
     *
     * Where the input expression is a [String] or [Number] (to be treated as a string),
     * the `pattern` is a [String] or [RegExp],
     * the 'replacement' is a [String] or [Function].
     *
     * --Note--: The 'pattern' parameter will be converted to a RegExp instance. Make sure to escape the
     * string properly if you are matching for regular expression special characters like parenthesis,
     * brackets etc.
     */
    var ReplacePipe = function () {
        function ReplacePipe() {}
        ReplacePipe.prototype.transform = function (value, args) {
            if (lang_1.isBlank(args) || args.length !== 2) {
                throw new exceptions_1.BaseException('ReplacePipe requires two arguments');
            }
            if (lang_1.isBlank(value)) {
                return value;
            }
            if (!this._supportedInput(value)) {
                throw new invalid_pipe_argument_exception_1.InvalidPipeArgumentException(ReplacePipe, value);
            }
            var input = value.toString();
            var pattern = args[0];
            var replacement = args[1];
            if (!this._supportedPattern(pattern)) {
                throw new invalid_pipe_argument_exception_1.InvalidPipeArgumentException(ReplacePipe, pattern);
            }
            if (!this._supportedReplacement(replacement)) {
                throw new invalid_pipe_argument_exception_1.InvalidPipeArgumentException(ReplacePipe, replacement);
            }
            // template fails with literal RegExp e.g /pattern/igm
            // var rgx = pattern instanceof RegExp ? pattern : RegExpWrapper.create(pattern);
            if (lang_1.isFunction(replacement)) {
                var rgxPattern = lang_1.isString(pattern) ? lang_1.RegExpWrapper.create(pattern) : pattern;
                return lang_1.StringWrapper.replaceAllMapped(input, rgxPattern, replacement);
            }
            if (pattern instanceof RegExp) {
                // use the replaceAll variant
                return lang_1.StringWrapper.replaceAll(input, pattern, replacement);
            }
            return lang_1.StringWrapper.replace(input, pattern, replacement);
        };
        ReplacePipe.prototype._supportedInput = function (input) {
            return lang_1.isString(input) || lang_1.isNumber(input);
        };
        ReplacePipe.prototype._supportedPattern = function (pattern) {
            return lang_1.isString(pattern) || pattern instanceof RegExp;
        };
        ReplacePipe.prototype._supportedReplacement = function (replacement) {
            return lang_1.isString(replacement) || lang_1.isFunction(replacement);
        };
        ReplacePipe = __decorate([core_1.Pipe({ name: 'replace' }), core_1.Injectable(), __metadata('design:paramtypes', [])], ReplacePipe);
        return ReplacePipe;
    }();
    exports.ReplacePipe = ReplacePipe;
});
System.registerDynamic("angular2/src/common/pipes/i18n_plural_pipe.js", ["angular2/src/facade/lang.js", "angular2/core.js", "angular2/src/common/pipes/invalid_pipe_argument_exception.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var core_1 = $__require("angular2/core.js");
    var invalid_pipe_argument_exception_1 = $__require("angular2/src/common/pipes/invalid_pipe_argument_exception.js");
    var interpolationExp = lang_1.RegExpWrapper.create('#');
    /**
     *
     *  Maps a value to a string that pluralizes the value properly.
     *
     *  ## Usage
     *
     *  expression | i18nPlural:mapping
     *
     *  where `expression` is a number and `mapping` is an object that indicates the proper text for
     *  when the `expression` evaluates to 0, 1, or some other number.  You can interpolate the actual
     *  value into the text using the `#` sign.
     *
     *  ## Example
     *
     *  ```
     *  <div>
     *    {{ messages.length | i18nPlural: messageMapping }}
     *  </div>
     *
     *  class MyApp {
     *    messages: any[];
     *    messageMapping: any = {
     *      '=0': 'No messages.',
     *      '=1': 'One message.',
     *      'other': '# messages.'
     *    }
     *    ...
     *  }
     *  ```
     *
     */
    var I18nPluralPipe = function () {
        function I18nPluralPipe() {}
        I18nPluralPipe.prototype.transform = function (value, args) {
            if (args === void 0) {
                args = null;
            }
            var key;
            var valueStr;
            var pluralMap = args[0];
            if (!lang_1.isStringMap(pluralMap)) {
                throw new invalid_pipe_argument_exception_1.InvalidPipeArgumentException(I18nPluralPipe, pluralMap);
            }
            key = value === 0 || value === 1 ? "=" + value : 'other';
            valueStr = lang_1.isPresent(value) ? value.toString() : '';
            return lang_1.StringWrapper.replaceAll(pluralMap[key], interpolationExp, valueStr);
        };
        I18nPluralPipe = __decorate([lang_1.CONST(), core_1.Pipe({ name: 'i18nPlural', pure: true }), core_1.Injectable(), __metadata('design:paramtypes', [])], I18nPluralPipe);
        return I18nPluralPipe;
    }();
    exports.I18nPluralPipe = I18nPluralPipe;
});
System.registerDynamic('angular2/src/common/pipes/invalid_pipe_argument_exception.js', ['angular2/src/facade/lang.js', 'angular2/src/facade/exceptions.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var exceptions_1 = $__require('angular2/src/facade/exceptions.js');
    var InvalidPipeArgumentException = function (_super) {
        __extends(InvalidPipeArgumentException, _super);
        function InvalidPipeArgumentException(type, value) {
            _super.call(this, "Invalid argument '" + value + "' for pipe '" + lang_1.stringify(type) + "'");
        }
        return InvalidPipeArgumentException;
    }(exceptions_1.BaseException);
    exports.InvalidPipeArgumentException = InvalidPipeArgumentException;
});
System.registerDynamic("angular2/src/common/pipes/i18n_select_pipe.js", ["angular2/src/facade/lang.js", "angular2/src/facade/collection.js", "angular2/core.js", "angular2/src/common/pipes/invalid_pipe_argument_exception.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var core_1 = $__require("angular2/core.js");
    var invalid_pipe_argument_exception_1 = $__require("angular2/src/common/pipes/invalid_pipe_argument_exception.js");
    /**
     *
     *  Generic selector that displays the string that matches the current value.
     *
     *  ## Usage
     *
     *  expression | i18nSelect:mapping
     *
     *  where `mapping` is an object that indicates the text that should be displayed
     *  for different values of the provided `expression`.
     *
     *  ## Example
     *
     *  ```
     *  <div>
     *    {{ gender | i18nSelect: inviteMap }}
     *  </div>
     *
     *  class MyApp {
     *    gender: string = 'male';
     *    inviteMap: any = {
     *      'male': 'Invite her.',
     *      'female': 'Invite him.',
     *      'other': 'Invite them.'
     *    }
     *    ...
     *  }
     *  ```
     */
    var I18nSelectPipe = function () {
        function I18nSelectPipe() {}
        I18nSelectPipe.prototype.transform = function (value, args) {
            if (args === void 0) {
                args = null;
            }
            var mapping = args[0];
            if (!lang_1.isStringMap(mapping)) {
                throw new invalid_pipe_argument_exception_1.InvalidPipeArgumentException(I18nSelectPipe, mapping);
            }
            return collection_1.StringMapWrapper.contains(mapping, value) ? mapping[value] : mapping['other'];
        };
        I18nSelectPipe = __decorate([lang_1.CONST(), core_1.Pipe({ name: 'i18nSelect', pure: true }), core_1.Injectable(), __metadata('design:paramtypes', [])], I18nSelectPipe);
        return I18nSelectPipe;
    }();
    exports.I18nSelectPipe = I18nSelectPipe;
});
System.registerDynamic('angular2/src/common/pipes/common_pipes.js', ['angular2/src/common/pipes/async_pipe.js', 'angular2/src/common/pipes/uppercase_pipe.js', 'angular2/src/common/pipes/lowercase_pipe.js', 'angular2/src/common/pipes/json_pipe.js', 'angular2/src/common/pipes/slice_pipe.js', 'angular2/src/common/pipes/date_pipe.js', 'angular2/src/common/pipes/number_pipe.js', 'angular2/src/common/pipes/replace_pipe.js', 'angular2/src/common/pipes/i18n_plural_pipe.js', 'angular2/src/common/pipes/i18n_select_pipe.js', 'angular2/src/facade/lang.js'], true, function ($__require, exports, module) {
  'use strict';"use strict";
  /**
   * @module
   * @description
   * This module provides a set of common Pipes.
   */

  var global = this || self,
      GLOBAL = global;
  var async_pipe_1 = $__require('angular2/src/common/pipes/async_pipe.js');
  var uppercase_pipe_1 = $__require('angular2/src/common/pipes/uppercase_pipe.js');
  var lowercase_pipe_1 = $__require('angular2/src/common/pipes/lowercase_pipe.js');
  var json_pipe_1 = $__require('angular2/src/common/pipes/json_pipe.js');
  var slice_pipe_1 = $__require('angular2/src/common/pipes/slice_pipe.js');
  var date_pipe_1 = $__require('angular2/src/common/pipes/date_pipe.js');
  var number_pipe_1 = $__require('angular2/src/common/pipes/number_pipe.js');
  var replace_pipe_1 = $__require('angular2/src/common/pipes/replace_pipe.js');
  var i18n_plural_pipe_1 = $__require('angular2/src/common/pipes/i18n_plural_pipe.js');
  var i18n_select_pipe_1 = $__require('angular2/src/common/pipes/i18n_select_pipe.js');
  var lang_1 = $__require('angular2/src/facade/lang.js');
  /**
   * A collection of Angular core pipes that are likely to be used in each and every
   * application.
   *
   * This collection can be used to quickly enumerate all the built-in pipes in the `pipes`
   * property of the `@Component` decorator.
   */
  exports.COMMON_PIPES = lang_1.CONST_EXPR([async_pipe_1.AsyncPipe, uppercase_pipe_1.UpperCasePipe, lowercase_pipe_1.LowerCasePipe, json_pipe_1.JsonPipe, slice_pipe_1.SlicePipe, number_pipe_1.DecimalPipe, number_pipe_1.PercentPipe, number_pipe_1.CurrencyPipe, date_pipe_1.DatePipe, replace_pipe_1.ReplacePipe, i18n_plural_pipe_1.I18nPluralPipe, i18n_select_pipe_1.I18nSelectPipe]);
});
System.registerDynamic('angular2/src/common/pipes.js', ['angular2/src/common/pipes/async_pipe.js', 'angular2/src/common/pipes/date_pipe.js', 'angular2/src/common/pipes/json_pipe.js', 'angular2/src/common/pipes/slice_pipe.js', 'angular2/src/common/pipes/lowercase_pipe.js', 'angular2/src/common/pipes/number_pipe.js', 'angular2/src/common/pipes/uppercase_pipe.js', 'angular2/src/common/pipes/replace_pipe.js', 'angular2/src/common/pipes/i18n_plural_pipe.js', 'angular2/src/common/pipes/i18n_select_pipe.js', 'angular2/src/common/pipes/common_pipes.js'], true, function ($__require, exports, module) {
  'use strict'; /**
                * @module
                * @description
                * This module provides a set of common Pipes.
                */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var async_pipe_1 = $__require('angular2/src/common/pipes/async_pipe.js');
  exports.AsyncPipe = async_pipe_1.AsyncPipe;
  var date_pipe_1 = $__require('angular2/src/common/pipes/date_pipe.js');
  exports.DatePipe = date_pipe_1.DatePipe;
  var json_pipe_1 = $__require('angular2/src/common/pipes/json_pipe.js');
  exports.JsonPipe = json_pipe_1.JsonPipe;
  var slice_pipe_1 = $__require('angular2/src/common/pipes/slice_pipe.js');
  exports.SlicePipe = slice_pipe_1.SlicePipe;
  var lowercase_pipe_1 = $__require('angular2/src/common/pipes/lowercase_pipe.js');
  exports.LowerCasePipe = lowercase_pipe_1.LowerCasePipe;
  var number_pipe_1 = $__require('angular2/src/common/pipes/number_pipe.js');
  exports.NumberPipe = number_pipe_1.NumberPipe;
  exports.DecimalPipe = number_pipe_1.DecimalPipe;
  exports.PercentPipe = number_pipe_1.PercentPipe;
  exports.CurrencyPipe = number_pipe_1.CurrencyPipe;
  var uppercase_pipe_1 = $__require('angular2/src/common/pipes/uppercase_pipe.js');
  exports.UpperCasePipe = uppercase_pipe_1.UpperCasePipe;
  var replace_pipe_1 = $__require('angular2/src/common/pipes/replace_pipe.js');
  exports.ReplacePipe = replace_pipe_1.ReplacePipe;
  var i18n_plural_pipe_1 = $__require('angular2/src/common/pipes/i18n_plural_pipe.js');
  exports.I18nPluralPipe = i18n_plural_pipe_1.I18nPluralPipe;
  var i18n_select_pipe_1 = $__require('angular2/src/common/pipes/i18n_select_pipe.js');
  exports.I18nSelectPipe = i18n_select_pipe_1.I18nSelectPipe;
  var common_pipes_1 = $__require('angular2/src/common/pipes/common_pipes.js');
  exports.COMMON_PIPES = common_pipes_1.COMMON_PIPES;
});
System.registerDynamic("angular2/src/common/forms/directives/ng_control_name.js", ["angular2/src/facade/lang.js", "angular2/src/facade/async.js", "angular2/core.js", "angular2/src/common/forms/directives/control_container.js", "angular2/src/common/forms/directives/ng_control.js", "angular2/src/common/forms/directives/control_value_accessor.js", "angular2/src/common/forms/directives/shared.js", "angular2/src/common/forms/validators.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var __param = this && this.__param || function (paramIndex, decorator) {
        return function (target, key) {
            decorator(target, key, paramIndex);
        };
    };
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var async_1 = $__require("angular2/src/facade/async.js");
    var core_1 = $__require("angular2/core.js");
    var control_container_1 = $__require("angular2/src/common/forms/directives/control_container.js");
    var ng_control_1 = $__require("angular2/src/common/forms/directives/ng_control.js");
    var control_value_accessor_1 = $__require("angular2/src/common/forms/directives/control_value_accessor.js");
    var shared_1 = $__require("angular2/src/common/forms/directives/shared.js");
    var validators_1 = $__require("angular2/src/common/forms/validators.js");
    var controlNameBinding = lang_1.CONST_EXPR(new core_1.Provider(ng_control_1.NgControl, { useExisting: core_1.forwardRef(function () {
            return NgControlName;
        }) }));
    /**
     * Creates and binds a control with a specified name to a DOM element.
     *
     * This directive can only be used as a child of {@link NgForm} or {@link NgFormModel}.
    
     * ### Example
     *
     * In this example, we create the login and password controls.
     * We can work with each control separately: check its validity, get its value, listen to its
     * changes.
     *
     *  ```
     * @Component({
     *      selector: "login-comp",
     *      directives: [FORM_DIRECTIVES],
     *      template: `
     *        <form #f="ngForm" (submit)='onLogIn(f.value)'>
     *          Login <input type='text' ngControl='login' #l="form">
     *          <div *ngIf="!l.valid">Login is invalid</div>
     *
     *          Password <input type='password' ngControl='password'>
     *          <button type='submit'>Log in!</button>
     *        </form>
     *      `})
     * class LoginComp {
     *  onLogIn(value): void {
     *    // value === {login: 'some login', password: 'some password'}
     *  }
     * }
     *  ```
     *
     * We can also use ngModel to bind a domain model to the form.
     *
     *  ```
     * @Component({
     *      selector: "login-comp",
     *      directives: [FORM_DIRECTIVES],
     *      template: `
     *        <form (submit)='onLogIn()'>
     *          Login <input type='text' ngControl='login' [(ngModel)]="credentials.login">
     *          Password <input type='password' ngControl='password'
     *                          [(ngModel)]="credentials.password">
     *          <button type='submit'>Log in!</button>
     *        </form>
     *      `})
     * class LoginComp {
     *  credentials: {login:string, password:string};
     *
     *  onLogIn(): void {
     *    // this.credentials.login === "some login"
     *    // this.credentials.password === "some password"
     *  }
     * }
     *  ```
     */
    var NgControlName = function (_super) {
        __extends(NgControlName, _super);
        function NgControlName(_parent, _validators, _asyncValidators, valueAccessors) {
            _super.call(this);
            this._parent = _parent;
            this._validators = _validators;
            this._asyncValidators = _asyncValidators;
            /** @internal */
            this.update = new async_1.EventEmitter();
            this._added = false;
            this.valueAccessor = shared_1.selectValueAccessor(this, valueAccessors);
        }
        NgControlName.prototype.ngOnChanges = function (changes) {
            if (!this._added) {
                this.formDirective.addControl(this);
                this._added = true;
            }
            if (shared_1.isPropertyUpdated(changes, this.viewModel)) {
                this.viewModel = this.model;
                this.formDirective.updateModel(this, this.model);
            }
        };
        NgControlName.prototype.ngOnDestroy = function () {
            this.formDirective.removeControl(this);
        };
        NgControlName.prototype.viewToModelUpdate = function (newValue) {
            this.viewModel = newValue;
            async_1.ObservableWrapper.callEmit(this.update, newValue);
        };
        Object.defineProperty(NgControlName.prototype, "path", {
            get: function () {
                return shared_1.controlPath(this.name, this._parent);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgControlName.prototype, "formDirective", {
            get: function () {
                return this._parent.formDirective;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgControlName.prototype, "validator", {
            get: function () {
                return shared_1.composeValidators(this._validators);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgControlName.prototype, "asyncValidator", {
            get: function () {
                return shared_1.composeAsyncValidators(this._asyncValidators);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgControlName.prototype, "control", {
            get: function () {
                return this.formDirective.getControl(this);
            },
            enumerable: true,
            configurable: true
        });
        NgControlName = __decorate([core_1.Directive({
            selector: '[ngControl]',
            bindings: [controlNameBinding],
            inputs: ['name: ngControl', 'model: ngModel'],
            outputs: ['update: ngModelChange'],
            exportAs: 'ngForm'
        }), __param(0, core_1.Host()), __param(0, core_1.SkipSelf()), __param(1, core_1.Optional()), __param(1, core_1.Self()), __param(1, core_1.Inject(validators_1.NG_VALIDATORS)), __param(2, core_1.Optional()), __param(2, core_1.Self()), __param(2, core_1.Inject(validators_1.NG_ASYNC_VALIDATORS)), __param(3, core_1.Optional()), __param(3, core_1.Self()), __param(3, core_1.Inject(control_value_accessor_1.NG_VALUE_ACCESSOR)), __metadata('design:paramtypes', [control_container_1.ControlContainer, Array, Array, Array])], NgControlName);
        return NgControlName;
    }(ng_control_1.NgControl);
    exports.NgControlName = NgControlName;
});
System.registerDynamic("angular2/src/common/forms/directives/ng_form_control.js", ["angular2/src/facade/lang.js", "angular2/src/facade/collection.js", "angular2/src/facade/async.js", "angular2/core.js", "angular2/src/common/forms/directives/ng_control.js", "angular2/src/common/forms/validators.js", "angular2/src/common/forms/directives/control_value_accessor.js", "angular2/src/common/forms/directives/shared.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var __param = this && this.__param || function (paramIndex, decorator) {
        return function (target, key) {
            decorator(target, key, paramIndex);
        };
    };
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var async_1 = $__require("angular2/src/facade/async.js");
    var core_1 = $__require("angular2/core.js");
    var ng_control_1 = $__require("angular2/src/common/forms/directives/ng_control.js");
    var validators_1 = $__require("angular2/src/common/forms/validators.js");
    var control_value_accessor_1 = $__require("angular2/src/common/forms/directives/control_value_accessor.js");
    var shared_1 = $__require("angular2/src/common/forms/directives/shared.js");
    var formControlBinding = lang_1.CONST_EXPR(new core_1.Provider(ng_control_1.NgControl, { useExisting: core_1.forwardRef(function () {
            return NgFormControl;
        }) }));
    /**
     * Binds an existing {@link Control} to a DOM element.
     *
     * ### Example ([live demo](http://plnkr.co/edit/jcQlZ2tTh22BZZ2ucNAT?p=preview))
     *
     * In this example, we bind the control to an input element. When the value of the input element
     * changes, the value of the control will reflect that change. Likewise, if the value of the
     * control changes, the input element reflects that change.
     *
     *  ```typescript
     * @Component({
     *   selector: 'my-app',
     *   template: `
     *     <div>
     *       <h2>NgFormControl Example</h2>
     *       <form>
     *         <p>Element with existing control: <input type="text"
     * [ngFormControl]="loginControl"></p>
     *         <p>Value of existing control: {{loginControl.value}}</p>
     *       </form>
     *     </div>
     *   `,
     *   directives: [CORE_DIRECTIVES, FORM_DIRECTIVES]
     * })
     * export class App {
     *   loginControl: Control = new Control('');
     * }
     *  ```
     *
     * ###ngModel
     *
     * We can also use `ngModel` to bind a domain model to the form.
     *
     * ### Example ([live demo](http://plnkr.co/edit/yHMLuHO7DNgT8XvtjTDH?p=preview))
     *
     *  ```typescript
     * @Component({
     *      selector: "login-comp",
     *      directives: [FORM_DIRECTIVES],
     *      template: "<input type='text' [ngFormControl]='loginControl' [(ngModel)]='login'>"
     *      })
     * class LoginComp {
     *  loginControl: Control = new Control('');
     *  login:string;
     * }
     *  ```
     */
    var NgFormControl = function (_super) {
        __extends(NgFormControl, _super);
        function NgFormControl(_validators, _asyncValidators, valueAccessors) {
            _super.call(this);
            this._validators = _validators;
            this._asyncValidators = _asyncValidators;
            this.update = new async_1.EventEmitter();
            this.valueAccessor = shared_1.selectValueAccessor(this, valueAccessors);
        }
        NgFormControl.prototype.ngOnChanges = function (changes) {
            if (this._isControlChanged(changes)) {
                shared_1.setUpControl(this.form, this);
                this.form.updateValueAndValidity({ emitEvent: false });
            }
            if (shared_1.isPropertyUpdated(changes, this.viewModel)) {
                this.form.updateValue(this.model);
                this.viewModel = this.model;
            }
        };
        Object.defineProperty(NgFormControl.prototype, "path", {
            get: function () {
                return [];
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgFormControl.prototype, "validator", {
            get: function () {
                return shared_1.composeValidators(this._validators);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgFormControl.prototype, "asyncValidator", {
            get: function () {
                return shared_1.composeAsyncValidators(this._asyncValidators);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgFormControl.prototype, "control", {
            get: function () {
                return this.form;
            },
            enumerable: true,
            configurable: true
        });
        NgFormControl.prototype.viewToModelUpdate = function (newValue) {
            this.viewModel = newValue;
            async_1.ObservableWrapper.callEmit(this.update, newValue);
        };
        NgFormControl.prototype._isControlChanged = function (changes) {
            return collection_1.StringMapWrapper.contains(changes, "form");
        };
        NgFormControl = __decorate([core_1.Directive({
            selector: '[ngFormControl]',
            bindings: [formControlBinding],
            inputs: ['form: ngFormControl', 'model: ngModel'],
            outputs: ['update: ngModelChange'],
            exportAs: 'ngForm'
        }), __param(0, core_1.Optional()), __param(0, core_1.Self()), __param(0, core_1.Inject(validators_1.NG_VALIDATORS)), __param(1, core_1.Optional()), __param(1, core_1.Self()), __param(1, core_1.Inject(validators_1.NG_ASYNC_VALIDATORS)), __param(2, core_1.Optional()), __param(2, core_1.Self()), __param(2, core_1.Inject(control_value_accessor_1.NG_VALUE_ACCESSOR)), __metadata('design:paramtypes', [Array, Array, Array])], NgFormControl);
        return NgFormControl;
    }(ng_control_1.NgControl);
    exports.NgFormControl = NgFormControl;
});
System.registerDynamic("angular2/src/common/forms/directives/ng_model.js", ["angular2/src/facade/lang.js", "angular2/src/facade/async.js", "angular2/core.js", "angular2/src/common/forms/directives/control_value_accessor.js", "angular2/src/common/forms/directives/ng_control.js", "angular2/src/common/forms/model.js", "angular2/src/common/forms/validators.js", "angular2/src/common/forms/directives/shared.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var __param = this && this.__param || function (paramIndex, decorator) {
        return function (target, key) {
            decorator(target, key, paramIndex);
        };
    };
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var async_1 = $__require("angular2/src/facade/async.js");
    var core_1 = $__require("angular2/core.js");
    var control_value_accessor_1 = $__require("angular2/src/common/forms/directives/control_value_accessor.js");
    var ng_control_1 = $__require("angular2/src/common/forms/directives/ng_control.js");
    var model_1 = $__require("angular2/src/common/forms/model.js");
    var validators_1 = $__require("angular2/src/common/forms/validators.js");
    var shared_1 = $__require("angular2/src/common/forms/directives/shared.js");
    var formControlBinding = lang_1.CONST_EXPR(new core_1.Provider(ng_control_1.NgControl, { useExisting: core_1.forwardRef(function () {
            return NgModel;
        }) }));
    /**
     * Binds a domain model to a form control.
     *
     * ### Usage
     *
     * `ngModel` binds an existing domain model to a form control. For a
     * two-way binding, use `[(ngModel)]` to ensure the model updates in
     * both directions.
     *
     * ### Example ([live demo](http://plnkr.co/edit/R3UX5qDaUqFO2VYR0UzH?p=preview))
     *  ```typescript
     * @Component({
     *      selector: "search-comp",
     *      directives: [FORM_DIRECTIVES],
     *      template: `<input type='text' [(ngModel)]="searchQuery">`
     *      })
     * class SearchComp {
     *  searchQuery: string;
     * }
     *  ```
     */
    var NgModel = function (_super) {
        __extends(NgModel, _super);
        function NgModel(_validators, _asyncValidators, valueAccessors) {
            _super.call(this);
            this._validators = _validators;
            this._asyncValidators = _asyncValidators;
            /** @internal */
            this._control = new model_1.Control();
            /** @internal */
            this._added = false;
            this.update = new async_1.EventEmitter();
            this.valueAccessor = shared_1.selectValueAccessor(this, valueAccessors);
        }
        NgModel.prototype.ngOnChanges = function (changes) {
            if (!this._added) {
                shared_1.setUpControl(this._control, this);
                this._control.updateValueAndValidity({ emitEvent: false });
                this._added = true;
            }
            if (shared_1.isPropertyUpdated(changes, this.viewModel)) {
                this._control.updateValue(this.model);
                this.viewModel = this.model;
            }
        };
        Object.defineProperty(NgModel.prototype, "control", {
            get: function () {
                return this._control;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgModel.prototype, "path", {
            get: function () {
                return [];
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgModel.prototype, "validator", {
            get: function () {
                return shared_1.composeValidators(this._validators);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgModel.prototype, "asyncValidator", {
            get: function () {
                return shared_1.composeAsyncValidators(this._asyncValidators);
            },
            enumerable: true,
            configurable: true
        });
        NgModel.prototype.viewToModelUpdate = function (newValue) {
            this.viewModel = newValue;
            async_1.ObservableWrapper.callEmit(this.update, newValue);
        };
        NgModel = __decorate([core_1.Directive({
            selector: '[ngModel]:not([ngControl]):not([ngFormControl])',
            bindings: [formControlBinding],
            inputs: ['model: ngModel'],
            outputs: ['update: ngModelChange'],
            exportAs: 'ngForm'
        }), __param(0, core_1.Optional()), __param(0, core_1.Self()), __param(0, core_1.Inject(validators_1.NG_VALIDATORS)), __param(1, core_1.Optional()), __param(1, core_1.Self()), __param(1, core_1.Inject(validators_1.NG_ASYNC_VALIDATORS)), __param(2, core_1.Optional()), __param(2, core_1.Self()), __param(2, core_1.Inject(control_value_accessor_1.NG_VALUE_ACCESSOR)), __metadata('design:paramtypes', [Array, Array, Array])], NgModel);
        return NgModel;
    }(ng_control_1.NgControl);
    exports.NgModel = NgModel;
});
System.registerDynamic("angular2/src/common/forms/directives/ng_control_group.js", ["angular2/core.js", "angular2/src/facade/lang.js", "angular2/src/common/forms/directives/control_container.js", "angular2/src/common/forms/directives/shared.js", "angular2/src/common/forms/validators.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var __param = this && this.__param || function (paramIndex, decorator) {
        return function (target, key) {
            decorator(target, key, paramIndex);
        };
    };
    var core_1 = $__require("angular2/core.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var control_container_1 = $__require("angular2/src/common/forms/directives/control_container.js");
    var shared_1 = $__require("angular2/src/common/forms/directives/shared.js");
    var validators_1 = $__require("angular2/src/common/forms/validators.js");
    var controlGroupProvider = lang_1.CONST_EXPR(new core_1.Provider(control_container_1.ControlContainer, { useExisting: core_1.forwardRef(function () {
            return NgControlGroup;
        }) }));
    /**
     * Creates and binds a control group to a DOM element.
     *
     * This directive can only be used as a child of {@link NgForm} or {@link NgFormModel}.
     *
     * ### Example ([live demo](http://plnkr.co/edit/7EJ11uGeaggViYM6T5nq?p=preview))
     *
     * ```typescript
     * @Component({
     *   selector: 'my-app',
     *   directives: [FORM_DIRECTIVES],
     *   template: `
     *     <div>
     *       <h2>Angular2 Control &amp; ControlGroup Example</h2>
     *       <form #f="ngForm">
     *         <div ngControlGroup="name" #cg-name="form">
     *           <h3>Enter your name:</h3>
     *           <p>First: <input ngControl="first" required></p>
     *           <p>Middle: <input ngControl="middle"></p>
     *           <p>Last: <input ngControl="last" required></p>
     *         </div>
     *         <h3>Name value:</h3>
     *         <pre>{{valueOf(cgName)}}</pre>
     *         <p>Name is {{cgName?.control?.valid ? "valid" : "invalid"}}</p>
     *         <h3>What's your favorite food?</h3>
     *         <p><input ngControl="food"></p>
     *         <h3>Form value</h3>
     *         <pre>{{valueOf(f)}}</pre>
     *       </form>
     *     </div>
     *   `
     * })
     * export class App {
     *   valueOf(cg: NgControlGroup): string {
     *     if (cg.control == null) {
     *       return null;
     *     }
     *     return JSON.stringify(cg.control.value, null, 2);
     *   }
     * }
     * ```
     *
     * This example declares a control group for a user's name. The value and validation state of
     * this group can be accessed separately from the overall form.
     */
    var NgControlGroup = function (_super) {
        __extends(NgControlGroup, _super);
        function NgControlGroup(parent, _validators, _asyncValidators) {
            _super.call(this);
            this._validators = _validators;
            this._asyncValidators = _asyncValidators;
            this._parent = parent;
        }
        NgControlGroup.prototype.ngOnInit = function () {
            this.formDirective.addControlGroup(this);
        };
        NgControlGroup.prototype.ngOnDestroy = function () {
            this.formDirective.removeControlGroup(this);
        };
        Object.defineProperty(NgControlGroup.prototype, "control", {
            /**
             * Get the {@link ControlGroup} backing this binding.
             */
            get: function () {
                return this.formDirective.getControlGroup(this);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgControlGroup.prototype, "path", {
            /**
             * Get the path to this control group.
             */
            get: function () {
                return shared_1.controlPath(this.name, this._parent);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgControlGroup.prototype, "formDirective", {
            /**
             * Get the {@link Form} to which this group belongs.
             */
            get: function () {
                return this._parent.formDirective;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgControlGroup.prototype, "validator", {
            get: function () {
                return shared_1.composeValidators(this._validators);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgControlGroup.prototype, "asyncValidator", {
            get: function () {
                return shared_1.composeAsyncValidators(this._asyncValidators);
            },
            enumerable: true,
            configurable: true
        });
        NgControlGroup = __decorate([core_1.Directive({
            selector: '[ngControlGroup]',
            providers: [controlGroupProvider],
            inputs: ['name: ngControlGroup'],
            exportAs: 'ngForm'
        }), __param(0, core_1.Host()), __param(0, core_1.SkipSelf()), __param(1, core_1.Optional()), __param(1, core_1.Self()), __param(1, core_1.Inject(validators_1.NG_VALIDATORS)), __param(2, core_1.Optional()), __param(2, core_1.Self()), __param(2, core_1.Inject(validators_1.NG_ASYNC_VALIDATORS)), __metadata('design:paramtypes', [control_container_1.ControlContainer, Array, Array])], NgControlGroup);
        return NgControlGroup;
    }(control_container_1.ControlContainer);
    exports.NgControlGroup = NgControlGroup;
});
System.registerDynamic("angular2/src/common/forms/directives/ng_form_model.js", ["angular2/src/facade/lang.js", "angular2/src/facade/collection.js", "angular2/src/facade/async.js", "angular2/core.js", "angular2/src/common/forms/directives/control_container.js", "angular2/src/common/forms/directives/shared.js", "angular2/src/common/forms/validators.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var __param = this && this.__param || function (paramIndex, decorator) {
        return function (target, key) {
            decorator(target, key, paramIndex);
        };
    };
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var async_1 = $__require("angular2/src/facade/async.js");
    var core_1 = $__require("angular2/core.js");
    var control_container_1 = $__require("angular2/src/common/forms/directives/control_container.js");
    var shared_1 = $__require("angular2/src/common/forms/directives/shared.js");
    var validators_1 = $__require("angular2/src/common/forms/validators.js");
    var formDirectiveProvider = lang_1.CONST_EXPR(new core_1.Provider(control_container_1.ControlContainer, { useExisting: core_1.forwardRef(function () {
            return NgFormModel;
        }) }));
    /**
     * Binds an existing control group to a DOM element.
     *
     * ### Example ([live demo](http://plnkr.co/edit/jqrVirudY8anJxTMUjTP?p=preview))
     *
     * In this example, we bind the control group to the form element, and we bind the login and
     * password controls to the login and password elements.
     *
     *  ```typescript
     * @Component({
     *   selector: 'my-app',
     *   template: `
     *     <div>
     *       <h2>NgFormModel Example</h2>
     *       <form [ngFormModel]="loginForm">
     *         <p>Login: <input type="text" ngControl="login"></p>
     *         <p>Password: <input type="password" ngControl="password"></p>
     *       </form>
     *       <p>Value:</p>
     *       <pre>{{value}}</pre>
     *     </div>
     *   `,
     *   directives: [FORM_DIRECTIVES]
     * })
     * export class App {
     *   loginForm: ControlGroup;
     *
     *   constructor() {
     *     this.loginForm = new ControlGroup({
     *       login: new Control(""),
     *       password: new Control("")
     *     });
     *   }
     *
     *   get value(): string {
     *     return JSON.stringify(this.loginForm.value, null, 2);
     *   }
     * }
     *  ```
     *
     * We can also use ngModel to bind a domain model to the form.
     *
     *  ```typescript
     * @Component({
     *      selector: "login-comp",
     *      directives: [FORM_DIRECTIVES],
     *      template: `
     *        <form [ngFormModel]='loginForm'>
     *          Login <input type='text' ngControl='login' [(ngModel)]='credentials.login'>
     *          Password <input type='password' ngControl='password'
     *                          [(ngModel)]='credentials.password'>
     *          <button (click)="onLogin()">Login</button>
     *        </form>`
     *      })
     * class LoginComp {
     *  credentials: {login: string, password: string};
     *  loginForm: ControlGroup;
     *
     *  constructor() {
     *    this.loginForm = new ControlGroup({
     *      login: new Control(""),
     *      password: new Control("")
     *    });
     *  }
     *
     *  onLogin(): void {
     *    // this.credentials.login === 'some login'
     *    // this.credentials.password === 'some password'
     *  }
     * }
     *  ```
     */
    var NgFormModel = function (_super) {
        __extends(NgFormModel, _super);
        function NgFormModel(_validators, _asyncValidators) {
            _super.call(this);
            this._validators = _validators;
            this._asyncValidators = _asyncValidators;
            this.form = null;
            this.directives = [];
            this.ngSubmit = new async_1.EventEmitter();
        }
        NgFormModel.prototype.ngOnChanges = function (changes) {
            if (collection_1.StringMapWrapper.contains(changes, "form")) {
                var sync = shared_1.composeValidators(this._validators);
                this.form.validator = validators_1.Validators.compose([this.form.validator, sync]);
                var async = shared_1.composeAsyncValidators(this._asyncValidators);
                this.form.asyncValidator = validators_1.Validators.composeAsync([this.form.asyncValidator, async]);
                this.form.updateValueAndValidity({ onlySelf: true, emitEvent: false });
            }
            this._updateDomValue();
        };
        Object.defineProperty(NgFormModel.prototype, "formDirective", {
            get: function () {
                return this;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgFormModel.prototype, "control", {
            get: function () {
                return this.form;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgFormModel.prototype, "path", {
            get: function () {
                return [];
            },
            enumerable: true,
            configurable: true
        });
        NgFormModel.prototype.addControl = function (dir) {
            var ctrl = this.form.find(dir.path);
            shared_1.setUpControl(ctrl, dir);
            ctrl.updateValueAndValidity({ emitEvent: false });
            this.directives.push(dir);
        };
        NgFormModel.prototype.getControl = function (dir) {
            return this.form.find(dir.path);
        };
        NgFormModel.prototype.removeControl = function (dir) {
            collection_1.ListWrapper.remove(this.directives, dir);
        };
        NgFormModel.prototype.addControlGroup = function (dir) {
            var ctrl = this.form.find(dir.path);
            shared_1.setUpControlGroup(ctrl, dir);
            ctrl.updateValueAndValidity({ emitEvent: false });
        };
        NgFormModel.prototype.removeControlGroup = function (dir) {};
        NgFormModel.prototype.getControlGroup = function (dir) {
            return this.form.find(dir.path);
        };
        NgFormModel.prototype.updateModel = function (dir, value) {
            var ctrl = this.form.find(dir.path);
            ctrl.updateValue(value);
        };
        NgFormModel.prototype.onSubmit = function () {
            async_1.ObservableWrapper.callEmit(this.ngSubmit, null);
            return false;
        };
        /** @internal */
        NgFormModel.prototype._updateDomValue = function () {
            var _this = this;
            this.directives.forEach(function (dir) {
                var ctrl = _this.form.find(dir.path);
                dir.valueAccessor.writeValue(ctrl.value);
            });
        };
        NgFormModel = __decorate([core_1.Directive({
            selector: '[ngFormModel]',
            bindings: [formDirectiveProvider],
            inputs: ['form: ngFormModel'],
            host: { '(submit)': 'onSubmit()' },
            outputs: ['ngSubmit'],
            exportAs: 'ngForm'
        }), __param(0, core_1.Optional()), __param(0, core_1.Self()), __param(0, core_1.Inject(validators_1.NG_VALIDATORS)), __param(1, core_1.Optional()), __param(1, core_1.Self()), __param(1, core_1.Inject(validators_1.NG_ASYNC_VALIDATORS)), __metadata('design:paramtypes', [Array, Array])], NgFormModel);
        return NgFormModel;
    }(control_container_1.ControlContainer);
    exports.NgFormModel = NgFormModel;
});
System.registerDynamic('angular2/src/common/forms/directives/control_container.js', ['angular2/src/common/forms/directives/abstract_control_directive.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var abstract_control_directive_1 = $__require('angular2/src/common/forms/directives/abstract_control_directive.js');
    /**
     * A directive that contains multiple {@link NgControl}s.
     *
     * Only used by the forms module.
     */
    var ControlContainer = function (_super) {
        __extends(ControlContainer, _super);
        function ControlContainer() {
            _super.apply(this, arguments);
        }
        Object.defineProperty(ControlContainer.prototype, "formDirective", {
            /**
             * Get the form to which this container belongs.
             */
            get: function () {
                return null;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ControlContainer.prototype, "path", {
            /**
             * Get the path to this container.
             */
            get: function () {
                return null;
            },
            enumerable: true,
            configurable: true
        });
        return ControlContainer;
    }(abstract_control_directive_1.AbstractControlDirective);
    exports.ControlContainer = ControlContainer;
});
System.registerDynamic("angular2/src/common/forms/directives/normalize_validator.js", [], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    function normalizeValidator(validator) {
        if (validator.validate !== undefined) {
            return function (c) {
                return validator.validate(c);
            };
        } else {
            return validator;
        }
    }
    exports.normalizeValidator = normalizeValidator;
    function normalizeAsyncValidator(validator) {
        if (validator.validate !== undefined) {
            return function (c) {
                return Promise.resolve(validator.validate(c));
            };
        } else {
            return validator;
        }
    }
    exports.normalizeAsyncValidator = normalizeAsyncValidator;
});
System.registerDynamic('angular2/src/common/forms/directives/shared.js', ['angular2/src/facade/collection.js', 'angular2/src/facade/lang.js', 'angular2/src/facade/exceptions.js', 'angular2/src/common/forms/validators.js', 'angular2/src/common/forms/directives/default_value_accessor.js', 'angular2/src/common/forms/directives/number_value_accessor.js', 'angular2/src/common/forms/directives/checkbox_value_accessor.js', 'angular2/src/common/forms/directives/select_control_value_accessor.js', 'angular2/src/common/forms/directives/radio_control_value_accessor.js', 'angular2/src/common/forms/directives/normalize_validator.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var collection_1 = $__require('angular2/src/facade/collection.js');
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var exceptions_1 = $__require('angular2/src/facade/exceptions.js');
    var validators_1 = $__require('angular2/src/common/forms/validators.js');
    var default_value_accessor_1 = $__require('angular2/src/common/forms/directives/default_value_accessor.js');
    var number_value_accessor_1 = $__require('angular2/src/common/forms/directives/number_value_accessor.js');
    var checkbox_value_accessor_1 = $__require('angular2/src/common/forms/directives/checkbox_value_accessor.js');
    var select_control_value_accessor_1 = $__require('angular2/src/common/forms/directives/select_control_value_accessor.js');
    var radio_control_value_accessor_1 = $__require('angular2/src/common/forms/directives/radio_control_value_accessor.js');
    var normalize_validator_1 = $__require('angular2/src/common/forms/directives/normalize_validator.js');
    function controlPath(name, parent) {
        var p = collection_1.ListWrapper.clone(parent.path);
        p.push(name);
        return p;
    }
    exports.controlPath = controlPath;
    function setUpControl(control, dir) {
        if (lang_1.isBlank(control)) _throwError(dir, "Cannot find control");
        if (lang_1.isBlank(dir.valueAccessor)) _throwError(dir, "No value accessor for");
        control.validator = validators_1.Validators.compose([control.validator, dir.validator]);
        control.asyncValidator = validators_1.Validators.composeAsync([control.asyncValidator, dir.asyncValidator]);
        dir.valueAccessor.writeValue(control.value);
        // view -> model
        dir.valueAccessor.registerOnChange(function (newValue) {
            dir.viewToModelUpdate(newValue);
            control.updateValue(newValue, { emitModelToViewChange: false });
            control.markAsDirty();
        });
        // model -> view
        control.registerOnChange(function (newValue) {
            return dir.valueAccessor.writeValue(newValue);
        });
        // touched
        dir.valueAccessor.registerOnTouched(function () {
            return control.markAsTouched();
        });
    }
    exports.setUpControl = setUpControl;
    function setUpControlGroup(control, dir) {
        if (lang_1.isBlank(control)) _throwError(dir, "Cannot find control");
        control.validator = validators_1.Validators.compose([control.validator, dir.validator]);
        control.asyncValidator = validators_1.Validators.composeAsync([control.asyncValidator, dir.asyncValidator]);
    }
    exports.setUpControlGroup = setUpControlGroup;
    function _throwError(dir, message) {
        var path = dir.path.join(" -> ");
        throw new exceptions_1.BaseException(message + " '" + path + "'");
    }
    function composeValidators(validators) {
        return lang_1.isPresent(validators) ? validators_1.Validators.compose(validators.map(normalize_validator_1.normalizeValidator)) : null;
    }
    exports.composeValidators = composeValidators;
    function composeAsyncValidators(validators) {
        return lang_1.isPresent(validators) ? validators_1.Validators.composeAsync(validators.map(normalize_validator_1.normalizeAsyncValidator)) : null;
    }
    exports.composeAsyncValidators = composeAsyncValidators;
    function isPropertyUpdated(changes, viewModel) {
        if (!collection_1.StringMapWrapper.contains(changes, "model")) return false;
        var change = changes["model"];
        if (change.isFirstChange()) return true;
        return !lang_1.looseIdentical(viewModel, change.currentValue);
    }
    exports.isPropertyUpdated = isPropertyUpdated;
    // TODO: vsavkin remove it once https://github.com/angular/angular/issues/3011 is implemented
    function selectValueAccessor(dir, valueAccessors) {
        if (lang_1.isBlank(valueAccessors)) return null;
        var defaultAccessor;
        var builtinAccessor;
        var customAccessor;
        valueAccessors.forEach(function (v) {
            if (lang_1.hasConstructor(v, default_value_accessor_1.DefaultValueAccessor)) {
                defaultAccessor = v;
            } else if (lang_1.hasConstructor(v, checkbox_value_accessor_1.CheckboxControlValueAccessor) || lang_1.hasConstructor(v, number_value_accessor_1.NumberValueAccessor) || lang_1.hasConstructor(v, select_control_value_accessor_1.SelectControlValueAccessor) || lang_1.hasConstructor(v, radio_control_value_accessor_1.RadioControlValueAccessor)) {
                if (lang_1.isPresent(builtinAccessor)) _throwError(dir, "More than one built-in value accessor matches");
                builtinAccessor = v;
            } else {
                if (lang_1.isPresent(customAccessor)) _throwError(dir, "More than one custom value accessor matches");
                customAccessor = v;
            }
        });
        if (lang_1.isPresent(customAccessor)) return customAccessor;
        if (lang_1.isPresent(builtinAccessor)) return builtinAccessor;
        if (lang_1.isPresent(defaultAccessor)) return defaultAccessor;
        _throwError(dir, "No valid value accessor for");
        return null;
    }
    exports.selectValueAccessor = selectValueAccessor;
});
System.registerDynamic("angular2/src/common/forms/directives/ng_form.js", ["angular2/src/facade/async.js", "angular2/src/facade/collection.js", "angular2/src/facade/lang.js", "angular2/core.js", "angular2/src/common/forms/directives/control_container.js", "angular2/src/common/forms/model.js", "angular2/src/common/forms/directives/shared.js", "angular2/src/common/forms/validators.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var __param = this && this.__param || function (paramIndex, decorator) {
        return function (target, key) {
            decorator(target, key, paramIndex);
        };
    };
    var async_1 = $__require("angular2/src/facade/async.js");
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var core_1 = $__require("angular2/core.js");
    var control_container_1 = $__require("angular2/src/common/forms/directives/control_container.js");
    var model_1 = $__require("angular2/src/common/forms/model.js");
    var shared_1 = $__require("angular2/src/common/forms/directives/shared.js");
    var validators_1 = $__require("angular2/src/common/forms/validators.js");
    var formDirectiveProvider = lang_1.CONST_EXPR(new core_1.Provider(control_container_1.ControlContainer, { useExisting: core_1.forwardRef(function () {
            return NgForm;
        }) }));
    /**
     * If `NgForm` is bound in a component, `<form>` elements in that component will be
     * upgraded to use the Angular form system.
     *
     * ### Typical Use
     *
     * Include `FORM_DIRECTIVES` in the `directives` section of a {@link View} annotation
     * to use `NgForm` and its associated controls.
     *
     * ### Structure
     *
     * An Angular form is a collection of `Control`s in some hierarchy.
     * `Control`s can be at the top level or can be organized in `ControlGroup`s
     * or `ControlArray`s. This hierarchy is reflected in the form's `value`, a
     * JSON object that mirrors the form structure.
     *
     * ### Submission
     *
     * The `ngSubmit` event signals when the user triggers a form submission.
     *
     * ### Example ([live demo](http://plnkr.co/edit/ltdgYj4P0iY64AR71EpL?p=preview))
     *
     *  ```typescript
     * @Component({
     *   selector: 'my-app',
     *   template: `
     *     <div>
     *       <p>Submit the form to see the data object Angular builds</p>
     *       <h2>NgForm demo</h2>
     *       <form #f="ngForm" (ngSubmit)="onSubmit(f.value)">
     *         <h3>Control group: credentials</h3>
     *         <div ngControlGroup="credentials">
     *           <p>Login: <input type="text" ngControl="login"></p>
     *           <p>Password: <input type="password" ngControl="password"></p>
     *         </div>
     *         <h3>Control group: person</h3>
     *         <div ngControlGroup="person">
     *           <p>First name: <input type="text" ngControl="firstName"></p>
     *           <p>Last name: <input type="text" ngControl="lastName"></p>
     *         </div>
     *         <button type="submit">Submit Form</button>
     *       <p>Form data submitted:</p>
     *       </form>
     *       <pre>{{data}}</pre>
     *     </div>
     * `,
     *   directives: [CORE_DIRECTIVES, FORM_DIRECTIVES]
     * })
     * export class App {
     *   constructor() {}
     *
     *   data: string;
     *
     *   onSubmit(data) {
     *     this.data = JSON.stringify(data, null, 2);
     *   }
     * }
     *  ```
     */
    var NgForm = function (_super) {
        __extends(NgForm, _super);
        function NgForm(validators, asyncValidators) {
            _super.call(this);
            this.ngSubmit = new async_1.EventEmitter();
            this.form = new model_1.ControlGroup({}, null, shared_1.composeValidators(validators), shared_1.composeAsyncValidators(asyncValidators));
        }
        Object.defineProperty(NgForm.prototype, "formDirective", {
            get: function () {
                return this;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgForm.prototype, "control", {
            get: function () {
                return this.form;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgForm.prototype, "path", {
            get: function () {
                return [];
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgForm.prototype, "controls", {
            get: function () {
                return this.form.controls;
            },
            enumerable: true,
            configurable: true
        });
        NgForm.prototype.addControl = function (dir) {
            var _this = this;
            async_1.PromiseWrapper.scheduleMicrotask(function () {
                var container = _this._findContainer(dir.path);
                var ctrl = new model_1.Control();
                shared_1.setUpControl(ctrl, dir);
                container.addControl(dir.name, ctrl);
                ctrl.updateValueAndValidity({ emitEvent: false });
            });
        };
        NgForm.prototype.getControl = function (dir) {
            return this.form.find(dir.path);
        };
        NgForm.prototype.removeControl = function (dir) {
            var _this = this;
            async_1.PromiseWrapper.scheduleMicrotask(function () {
                var container = _this._findContainer(dir.path);
                if (lang_1.isPresent(container)) {
                    container.removeControl(dir.name);
                    container.updateValueAndValidity({ emitEvent: false });
                }
            });
        };
        NgForm.prototype.addControlGroup = function (dir) {
            var _this = this;
            async_1.PromiseWrapper.scheduleMicrotask(function () {
                var container = _this._findContainer(dir.path);
                var group = new model_1.ControlGroup({});
                shared_1.setUpControlGroup(group, dir);
                container.addControl(dir.name, group);
                group.updateValueAndValidity({ emitEvent: false });
            });
        };
        NgForm.prototype.removeControlGroup = function (dir) {
            var _this = this;
            async_1.PromiseWrapper.scheduleMicrotask(function () {
                var container = _this._findContainer(dir.path);
                if (lang_1.isPresent(container)) {
                    container.removeControl(dir.name);
                    container.updateValueAndValidity({ emitEvent: false });
                }
            });
        };
        NgForm.prototype.getControlGroup = function (dir) {
            return this.form.find(dir.path);
        };
        NgForm.prototype.updateModel = function (dir, value) {
            var _this = this;
            async_1.PromiseWrapper.scheduleMicrotask(function () {
                var ctrl = _this.form.find(dir.path);
                ctrl.updateValue(value);
            });
        };
        NgForm.prototype.onSubmit = function () {
            async_1.ObservableWrapper.callEmit(this.ngSubmit, null);
            return false;
        };
        /** @internal */
        NgForm.prototype._findContainer = function (path) {
            path.pop();
            return collection_1.ListWrapper.isEmpty(path) ? this.form : this.form.find(path);
        };
        NgForm = __decorate([core_1.Directive({
            selector: 'form:not([ngNoForm]):not([ngFormModel]),ngForm,[ngForm]',
            bindings: [formDirectiveProvider],
            host: {
                '(submit)': 'onSubmit()'
            },
            outputs: ['ngSubmit'],
            exportAs: 'ngForm'
        }), __param(0, core_1.Optional()), __param(0, core_1.Self()), __param(0, core_1.Inject(validators_1.NG_VALIDATORS)), __param(1, core_1.Optional()), __param(1, core_1.Self()), __param(1, core_1.Inject(validators_1.NG_ASYNC_VALIDATORS)), __metadata('design:paramtypes', [Array, Array])], NgForm);
        return NgForm;
    }(control_container_1.ControlContainer);
    exports.NgForm = NgForm;
});
System.registerDynamic("angular2/src/common/forms/directives/default_value_accessor.js", ["angular2/core.js", "angular2/src/common/forms/directives/control_value_accessor.js", "angular2/src/facade/lang.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1 = $__require("angular2/core.js");
    var control_value_accessor_1 = $__require("angular2/src/common/forms/directives/control_value_accessor.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var DEFAULT_VALUE_ACCESSOR = lang_1.CONST_EXPR(new core_1.Provider(control_value_accessor_1.NG_VALUE_ACCESSOR, { useExisting: core_1.forwardRef(function () {
            return DefaultValueAccessor;
        }), multi: true }));
    /**
     * The default accessor for writing a value and listening to changes that is used by the
     * {@link NgModel}, {@link NgFormControl}, and {@link NgControlName} directives.
     *
     *  ### Example
     *  ```
     *  <input type="text" ngControl="searchQuery">
     *  ```
     */
    var DefaultValueAccessor = function () {
        function DefaultValueAccessor(_renderer, _elementRef) {
            this._renderer = _renderer;
            this._elementRef = _elementRef;
            this.onChange = function (_) {};
            this.onTouched = function () {};
        }
        DefaultValueAccessor.prototype.writeValue = function (value) {
            var normalizedValue = lang_1.isBlank(value) ? '' : value;
            this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', normalizedValue);
        };
        DefaultValueAccessor.prototype.registerOnChange = function (fn) {
            this.onChange = fn;
        };
        DefaultValueAccessor.prototype.registerOnTouched = function (fn) {
            this.onTouched = fn;
        };
        DefaultValueAccessor = __decorate([core_1.Directive({
            selector: 'input:not([type=checkbox])[ngControl],textarea[ngControl],input:not([type=checkbox])[ngFormControl],textarea[ngFormControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]',
            // TODO: vsavkin replace the above selector with the one below it once
            // https://github.com/angular/angular/issues/3011 is implemented
            // selector: '[ngControl],[ngModel],[ngFormControl]',
            host: { '(input)': 'onChange($event.target.value)', '(blur)': 'onTouched()' },
            bindings: [DEFAULT_VALUE_ACCESSOR]
        }), __metadata('design:paramtypes', [core_1.Renderer, core_1.ElementRef])], DefaultValueAccessor);
        return DefaultValueAccessor;
    }();
    exports.DefaultValueAccessor = DefaultValueAccessor;
});
System.registerDynamic("angular2/src/common/forms/directives/checkbox_value_accessor.js", ["angular2/core.js", "angular2/src/common/forms/directives/control_value_accessor.js", "angular2/src/facade/lang.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1 = $__require("angular2/core.js");
    var control_value_accessor_1 = $__require("angular2/src/common/forms/directives/control_value_accessor.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var CHECKBOX_VALUE_ACCESSOR = lang_1.CONST_EXPR(new core_1.Provider(control_value_accessor_1.NG_VALUE_ACCESSOR, { useExisting: core_1.forwardRef(function () {
            return CheckboxControlValueAccessor;
        }), multi: true }));
    /**
     * The accessor for writing a value and listening to changes on a checkbox input element.
     *
     *  ### Example
     *  ```
     *  <input type="checkbox" ngControl="rememberLogin">
     *  ```
     */
    var CheckboxControlValueAccessor = function () {
        function CheckboxControlValueAccessor(_renderer, _elementRef) {
            this._renderer = _renderer;
            this._elementRef = _elementRef;
            this.onChange = function (_) {};
            this.onTouched = function () {};
        }
        CheckboxControlValueAccessor.prototype.writeValue = function (value) {
            this._renderer.setElementProperty(this._elementRef.nativeElement, 'checked', value);
        };
        CheckboxControlValueAccessor.prototype.registerOnChange = function (fn) {
            this.onChange = fn;
        };
        CheckboxControlValueAccessor.prototype.registerOnTouched = function (fn) {
            this.onTouched = fn;
        };
        CheckboxControlValueAccessor = __decorate([core_1.Directive({
            selector: 'input[type=checkbox][ngControl],input[type=checkbox][ngFormControl],input[type=checkbox][ngModel]',
            host: { '(change)': 'onChange($event.target.checked)', '(blur)': 'onTouched()' },
            providers: [CHECKBOX_VALUE_ACCESSOR]
        }), __metadata('design:paramtypes', [core_1.Renderer, core_1.ElementRef])], CheckboxControlValueAccessor);
        return CheckboxControlValueAccessor;
    }();
    exports.CheckboxControlValueAccessor = CheckboxControlValueAccessor;
});
System.registerDynamic("angular2/src/common/forms/directives/number_value_accessor.js", ["angular2/core.js", "angular2/src/common/forms/directives/control_value_accessor.js", "angular2/src/facade/lang.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1 = $__require("angular2/core.js");
    var control_value_accessor_1 = $__require("angular2/src/common/forms/directives/control_value_accessor.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var NUMBER_VALUE_ACCESSOR = lang_1.CONST_EXPR(new core_1.Provider(control_value_accessor_1.NG_VALUE_ACCESSOR, { useExisting: core_1.forwardRef(function () {
            return NumberValueAccessor;
        }), multi: true }));
    /**
     * The accessor for writing a number value and listening to changes that is used by the
     * {@link NgModel}, {@link NgFormControl}, and {@link NgControlName} directives.
     *
     *  ### Example
     *  ```
     *  <input type="number" [(ngModel)]="age">
     *  ```
     */
    var NumberValueAccessor = function () {
        function NumberValueAccessor(_renderer, _elementRef) {
            this._renderer = _renderer;
            this._elementRef = _elementRef;
            this.onChange = function (_) {};
            this.onTouched = function () {};
        }
        NumberValueAccessor.prototype.writeValue = function (value) {
            this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', value);
        };
        NumberValueAccessor.prototype.registerOnChange = function (fn) {
            this.onChange = function (value) {
                fn(lang_1.NumberWrapper.parseFloat(value));
            };
        };
        NumberValueAccessor.prototype.registerOnTouched = function (fn) {
            this.onTouched = fn;
        };
        NumberValueAccessor = __decorate([core_1.Directive({
            selector: 'input[type=number][ngControl],input[type=number][ngFormControl],input[type=number][ngModel]',
            host: {
                '(change)': 'onChange($event.target.value)',
                '(input)': 'onChange($event.target.value)',
                '(blur)': 'onTouched()'
            },
            bindings: [NUMBER_VALUE_ACCESSOR]
        }), __metadata('design:paramtypes', [core_1.Renderer, core_1.ElementRef])], NumberValueAccessor);
        return NumberValueAccessor;
    }();
    exports.NumberValueAccessor = NumberValueAccessor;
});
System.registerDynamic("angular2/src/common/forms/directives/ng_control_status.js", ["angular2/core.js", "angular2/src/common/forms/directives/ng_control.js", "angular2/src/facade/lang.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var __param = this && this.__param || function (paramIndex, decorator) {
        return function (target, key) {
            decorator(target, key, paramIndex);
        };
    };
    var core_1 = $__require("angular2/core.js");
    var ng_control_1 = $__require("angular2/src/common/forms/directives/ng_control.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    /**
     * Directive automatically applied to Angular forms that sets CSS classes
     * based on control status (valid/invalid/dirty/etc).
     */
    var NgControlStatus = function () {
        function NgControlStatus(cd) {
            this._cd = cd;
        }
        Object.defineProperty(NgControlStatus.prototype, "ngClassUntouched", {
            get: function () {
                return lang_1.isPresent(this._cd.control) ? this._cd.control.untouched : false;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgControlStatus.prototype, "ngClassTouched", {
            get: function () {
                return lang_1.isPresent(this._cd.control) ? this._cd.control.touched : false;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgControlStatus.prototype, "ngClassPristine", {
            get: function () {
                return lang_1.isPresent(this._cd.control) ? this._cd.control.pristine : false;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgControlStatus.prototype, "ngClassDirty", {
            get: function () {
                return lang_1.isPresent(this._cd.control) ? this._cd.control.dirty : false;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgControlStatus.prototype, "ngClassValid", {
            get: function () {
                return lang_1.isPresent(this._cd.control) ? this._cd.control.valid : false;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgControlStatus.prototype, "ngClassInvalid", {
            get: function () {
                return lang_1.isPresent(this._cd.control) ? !this._cd.control.valid : false;
            },
            enumerable: true,
            configurable: true
        });
        NgControlStatus = __decorate([core_1.Directive({
            selector: '[ngControl],[ngModel],[ngFormControl]',
            host: {
                '[class.ng-untouched]': 'ngClassUntouched',
                '[class.ng-touched]': 'ngClassTouched',
                '[class.ng-pristine]': 'ngClassPristine',
                '[class.ng-dirty]': 'ngClassDirty',
                '[class.ng-valid]': 'ngClassValid',
                '[class.ng-invalid]': 'ngClassInvalid'
            }
        }), __param(0, core_1.Self()), __metadata('design:paramtypes', [ng_control_1.NgControl])], NgControlStatus);
        return NgControlStatus;
    }();
    exports.NgControlStatus = NgControlStatus;
});
System.registerDynamic("angular2/src/common/forms/directives/select_control_value_accessor.js", ["angular2/core.js", "angular2/src/common/forms/directives/control_value_accessor.js", "angular2/src/facade/lang.js", "angular2/src/facade/collection.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var __param = this && this.__param || function (paramIndex, decorator) {
        return function (target, key) {
            decorator(target, key, paramIndex);
        };
    };
    var core_1 = $__require("angular2/core.js");
    var control_value_accessor_1 = $__require("angular2/src/common/forms/directives/control_value_accessor.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var SELECT_VALUE_ACCESSOR = lang_1.CONST_EXPR(new core_1.Provider(control_value_accessor_1.NG_VALUE_ACCESSOR, { useExisting: core_1.forwardRef(function () {
            return SelectControlValueAccessor;
        }), multi: true }));
    function _buildValueString(id, value) {
        if (lang_1.isBlank(id)) return "" + value;
        if (!lang_1.isPrimitive(value)) value = "Object";
        return lang_1.StringWrapper.slice(id + ": " + value, 0, 50);
    }
    function _extractId(valueString) {
        return valueString.split(":")[0];
    }
    /**
     * The accessor for writing a value and listening to changes on a select element.
     */
    var SelectControlValueAccessor = function () {
        function SelectControlValueAccessor(_renderer, _elementRef) {
            this._renderer = _renderer;
            this._elementRef = _elementRef;
            /** @internal */
            this._optionMap = new Map();
            /** @internal */
            this._idCounter = 0;
            this.onChange = function (_) {};
            this.onTouched = function () {};
        }
        SelectControlValueAccessor.prototype.writeValue = function (value) {
            this.value = value;
            var valueString = _buildValueString(this._getOptionId(value), value);
            this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', valueString);
        };
        SelectControlValueAccessor.prototype.registerOnChange = function (fn) {
            var _this = this;
            this.onChange = function (valueString) {
                fn(_this._getOptionValue(valueString));
            };
        };
        SelectControlValueAccessor.prototype.registerOnTouched = function (fn) {
            this.onTouched = fn;
        };
        /** @internal */
        SelectControlValueAccessor.prototype._registerOption = function () {
            return (this._idCounter++).toString();
        };
        /** @internal */
        SelectControlValueAccessor.prototype._getOptionId = function (value) {
            for (var _i = 0, _a = collection_1.MapWrapper.keys(this._optionMap); _i < _a.length; _i++) {
                var id = _a[_i];
                if (lang_1.looseIdentical(this._optionMap.get(id), value)) return id;
            }
            return null;
        };
        /** @internal */
        SelectControlValueAccessor.prototype._getOptionValue = function (valueString) {
            var value = this._optionMap.get(_extractId(valueString));
            return lang_1.isPresent(value) ? value : valueString;
        };
        SelectControlValueAccessor = __decorate([core_1.Directive({
            selector: 'select[ngControl],select[ngFormControl],select[ngModel]',
            host: { '(input)': 'onChange($event.target.value)', '(blur)': 'onTouched()' },
            providers: [SELECT_VALUE_ACCESSOR]
        }), __metadata('design:paramtypes', [core_1.Renderer, core_1.ElementRef])], SelectControlValueAccessor);
        return SelectControlValueAccessor;
    }();
    exports.SelectControlValueAccessor = SelectControlValueAccessor;
    /**
     * Marks `<option>` as dynamic, so Angular can be notified when options change.
     *
     * ### Example
     *
     * ```
     * <select ngControl="city">
     *   <option *ngFor="#c of cities" [value]="c"></option>
     * </select>
     * ```
     */
    var NgSelectOption = function () {
        function NgSelectOption(_element, _renderer, _select) {
            this._element = _element;
            this._renderer = _renderer;
            this._select = _select;
            if (lang_1.isPresent(this._select)) this.id = this._select._registerOption();
        }
        Object.defineProperty(NgSelectOption.prototype, "ngValue", {
            set: function (value) {
                if (this._select == null) return;
                this._select._optionMap.set(this.id, value);
                this._setElementValue(_buildValueString(this.id, value));
                this._select.writeValue(this._select.value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgSelectOption.prototype, "value", {
            set: function (value) {
                this._setElementValue(value);
                if (lang_1.isPresent(this._select)) this._select.writeValue(this._select.value);
            },
            enumerable: true,
            configurable: true
        });
        /** @internal */
        NgSelectOption.prototype._setElementValue = function (value) {
            this._renderer.setElementProperty(this._element.nativeElement, 'value', value);
        };
        NgSelectOption.prototype.ngOnDestroy = function () {
            if (lang_1.isPresent(this._select)) {
                this._select._optionMap.delete(this.id);
                this._select.writeValue(this._select.value);
            }
        };
        __decorate([core_1.Input('ngValue'), __metadata('design:type', Object), __metadata('design:paramtypes', [Object])], NgSelectOption.prototype, "ngValue", null);
        __decorate([core_1.Input('value'), __metadata('design:type', Object), __metadata('design:paramtypes', [Object])], NgSelectOption.prototype, "value", null);
        NgSelectOption = __decorate([core_1.Directive({ selector: 'option' }), __param(2, core_1.Optional()), __param(2, core_1.Host()), __metadata('design:paramtypes', [core_1.ElementRef, core_1.Renderer, SelectControlValueAccessor])], NgSelectOption);
        return NgSelectOption;
    }();
    exports.NgSelectOption = NgSelectOption;
});
System.registerDynamic('angular2/src/common/forms/directives.js', ['angular2/src/facade/lang.js', 'angular2/src/common/forms/directives/ng_control_name.js', 'angular2/src/common/forms/directives/ng_form_control.js', 'angular2/src/common/forms/directives/ng_model.js', 'angular2/src/common/forms/directives/ng_control_group.js', 'angular2/src/common/forms/directives/ng_form_model.js', 'angular2/src/common/forms/directives/ng_form.js', 'angular2/src/common/forms/directives/default_value_accessor.js', 'angular2/src/common/forms/directives/checkbox_value_accessor.js', 'angular2/src/common/forms/directives/number_value_accessor.js', 'angular2/src/common/forms/directives/radio_control_value_accessor.js', 'angular2/src/common/forms/directives/ng_control_status.js', 'angular2/src/common/forms/directives/select_control_value_accessor.js', 'angular2/src/common/forms/directives/validators.js', 'angular2/src/common/forms/directives/ng_control.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var ng_control_name_1 = $__require('angular2/src/common/forms/directives/ng_control_name.js');
    var ng_form_control_1 = $__require('angular2/src/common/forms/directives/ng_form_control.js');
    var ng_model_1 = $__require('angular2/src/common/forms/directives/ng_model.js');
    var ng_control_group_1 = $__require('angular2/src/common/forms/directives/ng_control_group.js');
    var ng_form_model_1 = $__require('angular2/src/common/forms/directives/ng_form_model.js');
    var ng_form_1 = $__require('angular2/src/common/forms/directives/ng_form.js');
    var default_value_accessor_1 = $__require('angular2/src/common/forms/directives/default_value_accessor.js');
    var checkbox_value_accessor_1 = $__require('angular2/src/common/forms/directives/checkbox_value_accessor.js');
    var number_value_accessor_1 = $__require('angular2/src/common/forms/directives/number_value_accessor.js');
    var radio_control_value_accessor_1 = $__require('angular2/src/common/forms/directives/radio_control_value_accessor.js');
    var ng_control_status_1 = $__require('angular2/src/common/forms/directives/ng_control_status.js');
    var select_control_value_accessor_1 = $__require('angular2/src/common/forms/directives/select_control_value_accessor.js');
    var validators_1 = $__require('angular2/src/common/forms/directives/validators.js');
    var ng_control_name_2 = $__require('angular2/src/common/forms/directives/ng_control_name.js');
    exports.NgControlName = ng_control_name_2.NgControlName;
    var ng_form_control_2 = $__require('angular2/src/common/forms/directives/ng_form_control.js');
    exports.NgFormControl = ng_form_control_2.NgFormControl;
    var ng_model_2 = $__require('angular2/src/common/forms/directives/ng_model.js');
    exports.NgModel = ng_model_2.NgModel;
    var ng_control_group_2 = $__require('angular2/src/common/forms/directives/ng_control_group.js');
    exports.NgControlGroup = ng_control_group_2.NgControlGroup;
    var ng_form_model_2 = $__require('angular2/src/common/forms/directives/ng_form_model.js');
    exports.NgFormModel = ng_form_model_2.NgFormModel;
    var ng_form_2 = $__require('angular2/src/common/forms/directives/ng_form.js');
    exports.NgForm = ng_form_2.NgForm;
    var default_value_accessor_2 = $__require('angular2/src/common/forms/directives/default_value_accessor.js');
    exports.DefaultValueAccessor = default_value_accessor_2.DefaultValueAccessor;
    var checkbox_value_accessor_2 = $__require('angular2/src/common/forms/directives/checkbox_value_accessor.js');
    exports.CheckboxControlValueAccessor = checkbox_value_accessor_2.CheckboxControlValueAccessor;
    var radio_control_value_accessor_2 = $__require('angular2/src/common/forms/directives/radio_control_value_accessor.js');
    exports.RadioControlValueAccessor = radio_control_value_accessor_2.RadioControlValueAccessor;
    exports.RadioButtonState = radio_control_value_accessor_2.RadioButtonState;
    var number_value_accessor_2 = $__require('angular2/src/common/forms/directives/number_value_accessor.js');
    exports.NumberValueAccessor = number_value_accessor_2.NumberValueAccessor;
    var ng_control_status_2 = $__require('angular2/src/common/forms/directives/ng_control_status.js');
    exports.NgControlStatus = ng_control_status_2.NgControlStatus;
    var select_control_value_accessor_2 = $__require('angular2/src/common/forms/directives/select_control_value_accessor.js');
    exports.SelectControlValueAccessor = select_control_value_accessor_2.SelectControlValueAccessor;
    exports.NgSelectOption = select_control_value_accessor_2.NgSelectOption;
    var validators_2 = $__require('angular2/src/common/forms/directives/validators.js');
    exports.RequiredValidator = validators_2.RequiredValidator;
    exports.MinLengthValidator = validators_2.MinLengthValidator;
    exports.MaxLengthValidator = validators_2.MaxLengthValidator;
    exports.PatternValidator = validators_2.PatternValidator;
    var ng_control_1 = $__require('angular2/src/common/forms/directives/ng_control.js');
    exports.NgControl = ng_control_1.NgControl;
    /**
     *
     * A list of all the form directives used as part of a `@Component` annotation.
     *
     *  This is a shorthand for importing them each individually.
     *
     * ### Example
     *
     * ```typescript
     * @Component({
     *   selector: 'my-app',
     *   directives: [FORM_DIRECTIVES]
     * })
     * class MyApp {}
     * ```
     */
    exports.FORM_DIRECTIVES = lang_1.CONST_EXPR([ng_control_name_1.NgControlName, ng_control_group_1.NgControlGroup, ng_form_control_1.NgFormControl, ng_model_1.NgModel, ng_form_model_1.NgFormModel, ng_form_1.NgForm, select_control_value_accessor_1.NgSelectOption, default_value_accessor_1.DefaultValueAccessor, number_value_accessor_1.NumberValueAccessor, checkbox_value_accessor_1.CheckboxControlValueAccessor, select_control_value_accessor_1.SelectControlValueAccessor, radio_control_value_accessor_1.RadioControlValueAccessor, ng_control_status_1.NgControlStatus, validators_1.RequiredValidator, validators_1.MinLengthValidator, validators_1.MaxLengthValidator, validators_1.PatternValidator]);
});
System.registerDynamic('angular2/src/common/forms/validators.js', ['angular2/src/facade/lang.js', 'angular2/src/facade/promise.js', 'angular2/src/facade/async.js', 'angular2/src/facade/collection.js', 'angular2/core.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var promise_1 = $__require('angular2/src/facade/promise.js');
    var async_1 = $__require('angular2/src/facade/async.js');
    var collection_1 = $__require('angular2/src/facade/collection.js');
    var core_1 = $__require('angular2/core.js');
    /**
     * Providers for validators to be used for {@link Control}s in a form.
     *
     * Provide this using `multi: true` to add validators.
     *
     * ### Example
     *
     * {@example core/forms/ts/ng_validators/ng_validators.ts region='ng_validators'}
     */
    exports.NG_VALIDATORS = lang_1.CONST_EXPR(new core_1.OpaqueToken("NgValidators"));
    /**
     * Providers for asynchronous validators to be used for {@link Control}s
     * in a form.
     *
     * Provide this using `multi: true` to add validators.
     *
     * See {@link NG_VALIDATORS} for more details.
     */
    exports.NG_ASYNC_VALIDATORS = lang_1.CONST_EXPR(new core_1.OpaqueToken("NgAsyncValidators"));
    /**
     * Provides a set of validators used by form controls.
     *
     * A validator is a function that processes a {@link Control} or collection of
     * controls and returns a map of errors. A null map means that validation has passed.
     *
     * ### Example
     *
     * ```typescript
     * var loginControl = new Control("", Validators.required)
     * ```
     */
    var Validators = function () {
        function Validators() {}
        /**
         * Validator that requires controls to have a non-empty value.
         */
        Validators.required = function (control) {
            return lang_1.isBlank(control.value) || lang_1.isString(control.value) && control.value == "" ? { "required": true } : null;
        };
        /**
         * Validator that requires controls to have a value of a minimum length.
         */
        Validators.minLength = function (minLength) {
            return function (control) {
                if (lang_1.isPresent(Validators.required(control))) return null;
                var v = control.value;
                return v.length < minLength ? { "minlength": { "requiredLength": minLength, "actualLength": v.length } } : null;
            };
        };
        /**
         * Validator that requires controls to have a value of a maximum length.
         */
        Validators.maxLength = function (maxLength) {
            return function (control) {
                if (lang_1.isPresent(Validators.required(control))) return null;
                var v = control.value;
                return v.length > maxLength ? { "maxlength": { "requiredLength": maxLength, "actualLength": v.length } } : null;
            };
        };
        /**
         * Validator that requires a control to match a regex to its value.
         */
        Validators.pattern = function (pattern) {
            return function (control) {
                if (lang_1.isPresent(Validators.required(control))) return null;
                var regex = new RegExp("^" + pattern + "$");
                var v = control.value;
                return regex.test(v) ? null : { "pattern": { "requiredPattern": "^" + pattern + "$", "actualValue": v } };
            };
        };
        /**
         * No-op validator.
         */
        Validators.nullValidator = function (c) {
            return null;
        };
        /**
         * Compose multiple validators into a single function that returns the union
         * of the individual error maps.
         */
        Validators.compose = function (validators) {
            if (lang_1.isBlank(validators)) return null;
            var presentValidators = validators.filter(lang_1.isPresent);
            if (presentValidators.length == 0) return null;
            return function (control) {
                return _mergeErrors(_executeValidators(control, presentValidators));
            };
        };
        Validators.composeAsync = function (validators) {
            if (lang_1.isBlank(validators)) return null;
            var presentValidators = validators.filter(lang_1.isPresent);
            if (presentValidators.length == 0) return null;
            return function (control) {
                var promises = _executeAsyncValidators(control, presentValidators).map(_convertToPromise);
                return promise_1.PromiseWrapper.all(promises).then(_mergeErrors);
            };
        };
        return Validators;
    }();
    exports.Validators = Validators;
    function _convertToPromise(obj) {
        return promise_1.PromiseWrapper.isPromise(obj) ? obj : async_1.ObservableWrapper.toPromise(obj);
    }
    function _executeValidators(control, validators) {
        return validators.map(function (v) {
            return v(control);
        });
    }
    function _executeAsyncValidators(control, validators) {
        return validators.map(function (v) {
            return v(control);
        });
    }
    function _mergeErrors(arrayOfErrors) {
        var res = arrayOfErrors.reduce(function (res, errors) {
            return lang_1.isPresent(errors) ? collection_1.StringMapWrapper.merge(res, errors) : res;
        }, {});
        return collection_1.StringMapWrapper.isEmpty(res) ? null : res;
    }
});
System.registerDynamic("angular2/src/common/forms/directives/validators.js", ["angular2/core.js", "angular2/src/facade/lang.js", "angular2/src/common/forms/validators.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var __param = this && this.__param || function (paramIndex, decorator) {
        return function (target, key) {
            decorator(target, key, paramIndex);
        };
    };
    var core_1 = $__require("angular2/core.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var validators_1 = $__require("angular2/src/common/forms/validators.js");
    var lang_2 = $__require("angular2/src/facade/lang.js");
    var REQUIRED = validators_1.Validators.required;
    var REQUIRED_VALIDATOR = lang_1.CONST_EXPR(new core_1.Provider(validators_1.NG_VALIDATORS, { useValue: REQUIRED, multi: true }));
    /**
     * A Directive that adds the `required` validator to any controls marked with the
     * `required` attribute, via the {@link NG_VALIDATORS} binding.
     *
     * ### Example
     *
     * ```
     * <input ngControl="fullName" required>
     * ```
     */
    var RequiredValidator = function () {
        function RequiredValidator() {}
        RequiredValidator = __decorate([core_1.Directive({
            selector: '[required][ngControl],[required][ngFormControl],[required][ngModel]',
            providers: [REQUIRED_VALIDATOR]
        }), __metadata('design:paramtypes', [])], RequiredValidator);
        return RequiredValidator;
    }();
    exports.RequiredValidator = RequiredValidator;
    /**
     * Provivder which adds {@link MinLengthValidator} to {@link NG_VALIDATORS}.
     *
     * ## Example:
     *
     * {@example common/forms/ts/validators/validators.ts region='min'}
     */
    var MIN_LENGTH_VALIDATOR = lang_1.CONST_EXPR(new core_1.Provider(validators_1.NG_VALIDATORS, { useExisting: core_1.forwardRef(function () {
            return MinLengthValidator;
        }), multi: true }));
    /**
     * A directive which installs the {@link MinLengthValidator} for any `ngControl`,
     * `ngFormControl`, or control with `ngModel` that also has a `minlength` attribute.
     */
    var MinLengthValidator = function () {
        function MinLengthValidator(minLength) {
            this._validator = validators_1.Validators.minLength(lang_2.NumberWrapper.parseInt(minLength, 10));
        }
        MinLengthValidator.prototype.validate = function (c) {
            return this._validator(c);
        };
        MinLengthValidator = __decorate([core_1.Directive({
            selector: '[minlength][ngControl],[minlength][ngFormControl],[minlength][ngModel]',
            providers: [MIN_LENGTH_VALIDATOR]
        }), __param(0, core_1.Attribute("minlength")), __metadata('design:paramtypes', [String])], MinLengthValidator);
        return MinLengthValidator;
    }();
    exports.MinLengthValidator = MinLengthValidator;
    /**
     * Provider which adds {@link MaxLengthValidator} to {@link NG_VALIDATORS}.
     *
     * ## Example:
     *
     * {@example common/forms/ts/validators/validators.ts region='max'}
     */
    var MAX_LENGTH_VALIDATOR = lang_1.CONST_EXPR(new core_1.Provider(validators_1.NG_VALIDATORS, { useExisting: core_1.forwardRef(function () {
            return MaxLengthValidator;
        }), multi: true }));
    /**
     * A directive which installs the {@link MaxLengthValidator} for any `ngControl, `ngFormControl`,
     * or control with `ngModel` that also has a `maxlength` attribute.
     */
    var MaxLengthValidator = function () {
        function MaxLengthValidator(maxLength) {
            this._validator = validators_1.Validators.maxLength(lang_2.NumberWrapper.parseInt(maxLength, 10));
        }
        MaxLengthValidator.prototype.validate = function (c) {
            return this._validator(c);
        };
        MaxLengthValidator = __decorate([core_1.Directive({
            selector: '[maxlength][ngControl],[maxlength][ngFormControl],[maxlength][ngModel]',
            providers: [MAX_LENGTH_VALIDATOR]
        }), __param(0, core_1.Attribute("maxlength")), __metadata('design:paramtypes', [String])], MaxLengthValidator);
        return MaxLengthValidator;
    }();
    exports.MaxLengthValidator = MaxLengthValidator;
    /**
     * A Directive that adds the `pattern` validator to any controls marked with the
     * `pattern` attribute, via the {@link NG_VALIDATORS} binding. Uses attribute value
     * as the regex to validate Control value against.  Follows pattern attribute
     * semantics; i.e. regex must match entire Control value.
     *
     * ### Example
     *
     * ```
     * <input [ngControl]="fullName" pattern="[a-zA-Z ]*">
     * ```
     */
    var PATTERN_VALIDATOR = lang_1.CONST_EXPR(new core_1.Provider(validators_1.NG_VALIDATORS, { useExisting: core_1.forwardRef(function () {
            return PatternValidator;
        }), multi: true }));
    var PatternValidator = function () {
        function PatternValidator(pattern) {
            this._validator = validators_1.Validators.pattern(pattern);
        }
        PatternValidator.prototype.validate = function (c) {
            return this._validator(c);
        };
        PatternValidator = __decorate([core_1.Directive({
            selector: '[pattern][ngControl],[pattern][ngFormControl],[pattern][ngModel]',
            providers: [PATTERN_VALIDATOR]
        }), __param(0, core_1.Attribute("pattern")), __metadata('design:paramtypes', [String])], PatternValidator);
        return PatternValidator;
    }();
    exports.PatternValidator = PatternValidator;
});
System.registerDynamic('angular2/src/common/forms/model.js', ['angular2/src/facade/lang.js', 'angular2/src/facade/async.js', 'angular2/src/facade/promise.js', 'angular2/src/facade/collection.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var async_1 = $__require('angular2/src/facade/async.js');
    var promise_1 = $__require('angular2/src/facade/promise.js');
    var collection_1 = $__require('angular2/src/facade/collection.js');
    /**
     * Indicates that a Control is valid, i.e. that no errors exist in the input value.
     */
    exports.VALID = "VALID";
    /**
     * Indicates that a Control is invalid, i.e. that an error exists in the input value.
     */
    exports.INVALID = "INVALID";
    /**
     * Indicates that a Control is pending, i.e. that async validation is occurring and
     * errors are not yet available for the input value.
     */
    exports.PENDING = "PENDING";
    function isControl(control) {
        return control instanceof AbstractControl;
    }
    exports.isControl = isControl;
    function _find(control, path) {
        if (lang_1.isBlank(path)) return null;
        if (!(path instanceof Array)) {
            path = path.split("/");
        }
        if (path instanceof Array && collection_1.ListWrapper.isEmpty(path)) return null;
        return path.reduce(function (v, name) {
            if (v instanceof ControlGroup) {
                return lang_1.isPresent(v.controls[name]) ? v.controls[name] : null;
            } else if (v instanceof ControlArray) {
                var index = name;
                return lang_1.isPresent(v.at(index)) ? v.at(index) : null;
            } else {
                return null;
            }
        }, control);
    }
    function toObservable(r) {
        return promise_1.PromiseWrapper.isPromise(r) ? async_1.ObservableWrapper.fromPromise(r) : r;
    }
    /**
     *
     */
    var AbstractControl = function () {
        function AbstractControl(validator, asyncValidator) {
            this.validator = validator;
            this.asyncValidator = asyncValidator;
            this._pristine = true;
            this._touched = false;
        }
        Object.defineProperty(AbstractControl.prototype, "value", {
            get: function () {
                return this._value;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControl.prototype, "status", {
            get: function () {
                return this._status;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControl.prototype, "valid", {
            get: function () {
                return this._status === exports.VALID;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControl.prototype, "errors", {
            /**
             * Returns the errors of this control.
             */
            get: function () {
                return this._errors;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControl.prototype, "pristine", {
            get: function () {
                return this._pristine;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControl.prototype, "dirty", {
            get: function () {
                return !this.pristine;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControl.prototype, "touched", {
            get: function () {
                return this._touched;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControl.prototype, "untouched", {
            get: function () {
                return !this._touched;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControl.prototype, "valueChanges", {
            get: function () {
                return this._valueChanges;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControl.prototype, "statusChanges", {
            get: function () {
                return this._statusChanges;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControl.prototype, "pending", {
            get: function () {
                return this._status == exports.PENDING;
            },
            enumerable: true,
            configurable: true
        });
        AbstractControl.prototype.markAsTouched = function () {
            this._touched = true;
        };
        AbstractControl.prototype.markAsDirty = function (_a) {
            var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
            onlySelf = lang_1.normalizeBool(onlySelf);
            this._pristine = false;
            if (lang_1.isPresent(this._parent) && !onlySelf) {
                this._parent.markAsDirty({ onlySelf: onlySelf });
            }
        };
        AbstractControl.prototype.markAsPending = function (_a) {
            var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
            onlySelf = lang_1.normalizeBool(onlySelf);
            this._status = exports.PENDING;
            if (lang_1.isPresent(this._parent) && !onlySelf) {
                this._parent.markAsPending({ onlySelf: onlySelf });
            }
        };
        AbstractControl.prototype.setParent = function (parent) {
            this._parent = parent;
        };
        AbstractControl.prototype.updateValueAndValidity = function (_a) {
            var _b = _a === void 0 ? {} : _a,
                onlySelf = _b.onlySelf,
                emitEvent = _b.emitEvent;
            onlySelf = lang_1.normalizeBool(onlySelf);
            emitEvent = lang_1.isPresent(emitEvent) ? emitEvent : true;
            this._updateValue();
            this._errors = this._runValidator();
            this._status = this._calculateStatus();
            if (this._status == exports.VALID || this._status == exports.PENDING) {
                this._runAsyncValidator(emitEvent);
            }
            if (emitEvent) {
                async_1.ObservableWrapper.callEmit(this._valueChanges, this._value);
                async_1.ObservableWrapper.callEmit(this._statusChanges, this._status);
            }
            if (lang_1.isPresent(this._parent) && !onlySelf) {
                this._parent.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
            }
        };
        AbstractControl.prototype._runValidator = function () {
            return lang_1.isPresent(this.validator) ? this.validator(this) : null;
        };
        AbstractControl.prototype._runAsyncValidator = function (emitEvent) {
            var _this = this;
            if (lang_1.isPresent(this.asyncValidator)) {
                this._status = exports.PENDING;
                this._cancelExistingSubscription();
                var obs = toObservable(this.asyncValidator(this));
                this._asyncValidationSubscription = async_1.ObservableWrapper.subscribe(obs, function (res) {
                    return _this.setErrors(res, { emitEvent: emitEvent });
                });
            }
        };
        AbstractControl.prototype._cancelExistingSubscription = function () {
            if (lang_1.isPresent(this._asyncValidationSubscription)) {
                async_1.ObservableWrapper.dispose(this._asyncValidationSubscription);
            }
        };
        /**
         * Sets errors on a control.
         *
         * This is used when validations are run not automatically, but manually by the user.
         *
         * Calling `setErrors` will also update the validity of the parent control.
         *
         * ## Usage
         *
         * ```
         * var login = new Control("someLogin");
         * login.setErrors({
         *   "notUnique": true
         * });
         *
         * expect(login.valid).toEqual(false);
         * expect(login.errors).toEqual({"notUnique": true});
         *
         * login.updateValue("someOtherLogin");
         *
         * expect(login.valid).toEqual(true);
         * ```
         */
        AbstractControl.prototype.setErrors = function (errors, _a) {
            var emitEvent = (_a === void 0 ? {} : _a).emitEvent;
            emitEvent = lang_1.isPresent(emitEvent) ? emitEvent : true;
            this._errors = errors;
            this._status = this._calculateStatus();
            if (emitEvent) {
                async_1.ObservableWrapper.callEmit(this._statusChanges, this._status);
            }
            if (lang_1.isPresent(this._parent)) {
                this._parent._updateControlsErrors();
            }
        };
        AbstractControl.prototype.find = function (path) {
            return _find(this, path);
        };
        AbstractControl.prototype.getError = function (errorCode, path) {
            if (path === void 0) {
                path = null;
            }
            var control = lang_1.isPresent(path) && !collection_1.ListWrapper.isEmpty(path) ? this.find(path) : this;
            if (lang_1.isPresent(control) && lang_1.isPresent(control._errors)) {
                return collection_1.StringMapWrapper.get(control._errors, errorCode);
            } else {
                return null;
            }
        };
        AbstractControl.prototype.hasError = function (errorCode, path) {
            if (path === void 0) {
                path = null;
            }
            return lang_1.isPresent(this.getError(errorCode, path));
        };
        Object.defineProperty(AbstractControl.prototype, "root", {
            get: function () {
                var x = this;
                while (lang_1.isPresent(x._parent)) {
                    x = x._parent;
                }
                return x;
            },
            enumerable: true,
            configurable: true
        });
        /** @internal */
        AbstractControl.prototype._updateControlsErrors = function () {
            this._status = this._calculateStatus();
            if (lang_1.isPresent(this._parent)) {
                this._parent._updateControlsErrors();
            }
        };
        /** @internal */
        AbstractControl.prototype._initObservables = function () {
            this._valueChanges = new async_1.EventEmitter();
            this._statusChanges = new async_1.EventEmitter();
        };
        AbstractControl.prototype._calculateStatus = function () {
            if (lang_1.isPresent(this._errors)) return exports.INVALID;
            if (this._anyControlsHaveStatus(exports.PENDING)) return exports.PENDING;
            if (this._anyControlsHaveStatus(exports.INVALID)) return exports.INVALID;
            return exports.VALID;
        };
        return AbstractControl;
    }();
    exports.AbstractControl = AbstractControl;
    /**
     * Defines a part of a form that cannot be divided into other controls. `Control`s have values and
     * validation state, which is determined by an optional validation function.
     *
     * `Control` is one of the three fundamental building blocks used to define forms in Angular, along
     * with {@link ControlGroup} and {@link ControlArray}.
     *
     * ## Usage
     *
     * By default, a `Control` is created for every `<input>` or other form component.
     * With {@link NgFormControl} or {@link NgFormModel} an existing {@link Control} can be
     * bound to a DOM element instead. This `Control` can be configured with a custom
     * validation function.
     *
     * ### Example ([live demo](http://plnkr.co/edit/23DESOpbNnBpBHZt1BR4?p=preview))
     */
    var Control = function (_super) {
        __extends(Control, _super);
        function Control(value, validator, asyncValidator) {
            if (value === void 0) {
                value = null;
            }
            if (validator === void 0) {
                validator = null;
            }
            if (asyncValidator === void 0) {
                asyncValidator = null;
            }
            _super.call(this, validator, asyncValidator);
            this._value = value;
            this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
            this._initObservables();
        }
        /**
         * Set the value of the control to `value`.
         *
         * If `onlySelf` is `true`, this change will only affect the validation of this `Control`
         * and not its parent component. If `emitEvent` is `true`, this change will cause a
         * `valueChanges` event on the `Control` to be emitted. Both of these options default to
         * `false`.
         *
         * If `emitModelToViewChange` is `true`, the view will be notified about the new value
         * via an `onChange` event. This is the default behavior if `emitModelToViewChange` is not
         * specified.
         */
        Control.prototype.updateValue = function (value, _a) {
            var _b = _a === void 0 ? {} : _a,
                onlySelf = _b.onlySelf,
                emitEvent = _b.emitEvent,
                emitModelToViewChange = _b.emitModelToViewChange;
            emitModelToViewChange = lang_1.isPresent(emitModelToViewChange) ? emitModelToViewChange : true;
            this._value = value;
            if (lang_1.isPresent(this._onChange) && emitModelToViewChange) this._onChange(this._value);
            this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
        };
        /**
         * @internal
         */
        Control.prototype._updateValue = function () {};
        /**
         * @internal
         */
        Control.prototype._anyControlsHaveStatus = function (status) {
            return false;
        };
        /**
         * Register a listener for change events.
         */
        Control.prototype.registerOnChange = function (fn) {
            this._onChange = fn;
        };
        return Control;
    }(AbstractControl);
    exports.Control = Control;
    /**
     * Defines a part of a form, of fixed length, that can contain other controls.
     *
     * A `ControlGroup` aggregates the values of each {@link Control} in the group.
     * The status of a `ControlGroup` depends on the status of its children.
     * If one of the controls in a group is invalid, the entire group is invalid.
     * Similarly, if a control changes its value, the entire group changes as well.
     *
     * `ControlGroup` is one of the three fundamental building blocks used to define forms in Angular,
     * along with {@link Control} and {@link ControlArray}. {@link ControlArray} can also contain other
     * controls, but is of variable length.
     *
     * ### Example ([live demo](http://plnkr.co/edit/23DESOpbNnBpBHZt1BR4?p=preview))
     */
    var ControlGroup = function (_super) {
        __extends(ControlGroup, _super);
        function ControlGroup(controls, optionals, validator, asyncValidator) {
            if (optionals === void 0) {
                optionals = null;
            }
            if (validator === void 0) {
                validator = null;
            }
            if (asyncValidator === void 0) {
                asyncValidator = null;
            }
            _super.call(this, validator, asyncValidator);
            this.controls = controls;
            this._optionals = lang_1.isPresent(optionals) ? optionals : {};
            this._initObservables();
            this._setParentForControls();
            this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        }
        /**
         * Add a control to this group.
         */
        ControlGroup.prototype.addControl = function (name, control) {
            this.controls[name] = control;
            control.setParent(this);
        };
        /**
         * Remove a control from this group.
         */
        ControlGroup.prototype.removeControl = function (name) {
            collection_1.StringMapWrapper.delete(this.controls, name);
        };
        /**
         * Mark the named control as non-optional.
         */
        ControlGroup.prototype.include = function (controlName) {
            collection_1.StringMapWrapper.set(this._optionals, controlName, true);
            this.updateValueAndValidity();
        };
        /**
         * Mark the named control as optional.
         */
        ControlGroup.prototype.exclude = function (controlName) {
            collection_1.StringMapWrapper.set(this._optionals, controlName, false);
            this.updateValueAndValidity();
        };
        /**
         * Check whether there is a control with the given name in the group.
         */
        ControlGroup.prototype.contains = function (controlName) {
            var c = collection_1.StringMapWrapper.contains(this.controls, controlName);
            return c && this._included(controlName);
        };
        /** @internal */
        ControlGroup.prototype._setParentForControls = function () {
            var _this = this;
            collection_1.StringMapWrapper.forEach(this.controls, function (control, name) {
                control.setParent(_this);
            });
        };
        /** @internal */
        ControlGroup.prototype._updateValue = function () {
            this._value = this._reduceValue();
        };
        /** @internal */
        ControlGroup.prototype._anyControlsHaveStatus = function (status) {
            var _this = this;
            var res = false;
            collection_1.StringMapWrapper.forEach(this.controls, function (control, name) {
                res = res || _this.contains(name) && control.status == status;
            });
            return res;
        };
        /** @internal */
        ControlGroup.prototype._reduceValue = function () {
            return this._reduceChildren({}, function (acc, control, name) {
                acc[name] = control.value;
                return acc;
            });
        };
        /** @internal */
        ControlGroup.prototype._reduceChildren = function (initValue, fn) {
            var _this = this;
            var res = initValue;
            collection_1.StringMapWrapper.forEach(this.controls, function (control, name) {
                if (_this._included(name)) {
                    res = fn(res, control, name);
                }
            });
            return res;
        };
        /** @internal */
        ControlGroup.prototype._included = function (controlName) {
            var isOptional = collection_1.StringMapWrapper.contains(this._optionals, controlName);
            return !isOptional || collection_1.StringMapWrapper.get(this._optionals, controlName);
        };
        return ControlGroup;
    }(AbstractControl);
    exports.ControlGroup = ControlGroup;
    /**
     * Defines a part of a form, of variable length, that can contain other controls.
     *
     * A `ControlArray` aggregates the values of each {@link Control} in the group.
     * The status of a `ControlArray` depends on the status of its children.
     * If one of the controls in a group is invalid, the entire array is invalid.
     * Similarly, if a control changes its value, the entire array changes as well.
     *
     * `ControlArray` is one of the three fundamental building blocks used to define forms in Angular,
     * along with {@link Control} and {@link ControlGroup}. {@link ControlGroup} can also contain
     * other controls, but is of fixed length.
     *
     * ## Adding or removing controls
     *
     * To change the controls in the array, use the `push`, `insert`, or `removeAt` methods
     * in `ControlArray` itself. These methods ensure the controls are properly tracked in the
     * form's hierarchy. Do not modify the array of `AbstractControl`s used to instantiate
     * the `ControlArray` directly, as that will result in strange and unexpected behavior such
     * as broken change detection.
     *
     * ### Example ([live demo](http://plnkr.co/edit/23DESOpbNnBpBHZt1BR4?p=preview))
     */
    var ControlArray = function (_super) {
        __extends(ControlArray, _super);
        function ControlArray(controls, validator, asyncValidator) {
            if (validator === void 0) {
                validator = null;
            }
            if (asyncValidator === void 0) {
                asyncValidator = null;
            }
            _super.call(this, validator, asyncValidator);
            this.controls = controls;
            this._initObservables();
            this._setParentForControls();
            this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        }
        /**
         * Get the {@link AbstractControl} at the given `index` in the array.
         */
        ControlArray.prototype.at = function (index) {
            return this.controls[index];
        };
        /**
         * Insert a new {@link AbstractControl} at the end of the array.
         */
        ControlArray.prototype.push = function (control) {
            this.controls.push(control);
            control.setParent(this);
            this.updateValueAndValidity();
        };
        /**
         * Insert a new {@link AbstractControl} at the given `index` in the array.
         */
        ControlArray.prototype.insert = function (index, control) {
            collection_1.ListWrapper.insert(this.controls, index, control);
            control.setParent(this);
            this.updateValueAndValidity();
        };
        /**
         * Remove the control at the given `index` in the array.
         */
        ControlArray.prototype.removeAt = function (index) {
            collection_1.ListWrapper.removeAt(this.controls, index);
            this.updateValueAndValidity();
        };
        Object.defineProperty(ControlArray.prototype, "length", {
            /**
             * Length of the control array.
             */
            get: function () {
                return this.controls.length;
            },
            enumerable: true,
            configurable: true
        });
        /** @internal */
        ControlArray.prototype._updateValue = function () {
            this._value = this.controls.map(function (control) {
                return control.value;
            });
        };
        /** @internal */
        ControlArray.prototype._anyControlsHaveStatus = function (status) {
            return this.controls.some(function (c) {
                return c.status == status;
            });
        };
        /** @internal */
        ControlArray.prototype._setParentForControls = function () {
            var _this = this;
            this.controls.forEach(function (control) {
                control.setParent(_this);
            });
        };
        return ControlArray;
    }(AbstractControl);
    exports.ControlArray = ControlArray;
});
System.registerDynamic("angular2/src/common/forms/form_builder.js", ["angular2/core.js", "angular2/src/facade/collection.js", "angular2/src/facade/lang.js", "angular2/src/common/forms/model.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1 = $__require("angular2/core.js");
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var modelModule = $__require("angular2/src/common/forms/model.js");
    /**
     * Creates a form object from a user-specified configuration.
     *
     * ### Example ([live demo](http://plnkr.co/edit/ENgZo8EuIECZNensZCVr?p=preview))
     *
     * ```typescript
     * @Component({
     *   selector: 'my-app',
     *   viewBindings: [FORM_BINDINGS]
     *   template: `
     *     <form [ngFormModel]="loginForm">
     *       <p>Login <input ngControl="login"></p>
     *       <div ngControlGroup="passwordRetry">
     *         <p>Password <input type="password" ngControl="password"></p>
     *         <p>Confirm password <input type="password" ngControl="passwordConfirmation"></p>
     *       </div>
     *     </form>
     *     <h3>Form value:</h3>
     *     <pre>{{value}}</pre>
     *   `,
     *   directives: [FORM_DIRECTIVES]
     * })
     * export class App {
     *   loginForm: ControlGroup;
     *
     *   constructor(builder: FormBuilder) {
     *     this.loginForm = builder.group({
     *       login: ["", Validators.required],
     *       passwordRetry: builder.group({
     *         password: ["", Validators.required],
     *         passwordConfirmation: ["", Validators.required, asyncValidator]
     *       })
     *     });
     *   }
     *
     *   get value(): string {
     *     return JSON.stringify(this.loginForm.value, null, 2);
     *   }
     * }
     * ```
     */
    var FormBuilder = function () {
        function FormBuilder() {}
        /**
         * Construct a new {@link ControlGroup} with the given map of configuration.
         * Valid keys for the `extra` parameter map are `optionals` and `validator`.
         *
         * See the {@link ControlGroup} constructor for more details.
         */
        FormBuilder.prototype.group = function (controlsConfig, extra) {
            if (extra === void 0) {
                extra = null;
            }
            var controls = this._reduceControls(controlsConfig);
            var optionals = lang_1.isPresent(extra) ? collection_1.StringMapWrapper.get(extra, "optionals") : null;
            var validator = lang_1.isPresent(extra) ? collection_1.StringMapWrapper.get(extra, "validator") : null;
            var asyncValidator = lang_1.isPresent(extra) ? collection_1.StringMapWrapper.get(extra, "asyncValidator") : null;
            return new modelModule.ControlGroup(controls, optionals, validator, asyncValidator);
        };
        /**
         * Construct a new {@link Control} with the given `value`,`validator`, and `asyncValidator`.
         */
        FormBuilder.prototype.control = function (value, validator, asyncValidator) {
            if (validator === void 0) {
                validator = null;
            }
            if (asyncValidator === void 0) {
                asyncValidator = null;
            }
            return new modelModule.Control(value, validator, asyncValidator);
        };
        /**
         * Construct an array of {@link Control}s from the given `controlsConfig` array of
         * configuration, with the given optional `validator` and `asyncValidator`.
         */
        FormBuilder.prototype.array = function (controlsConfig, validator, asyncValidator) {
            var _this = this;
            if (validator === void 0) {
                validator = null;
            }
            if (asyncValidator === void 0) {
                asyncValidator = null;
            }
            var controls = controlsConfig.map(function (c) {
                return _this._createControl(c);
            });
            return new modelModule.ControlArray(controls, validator, asyncValidator);
        };
        /** @internal */
        FormBuilder.prototype._reduceControls = function (controlsConfig) {
            var _this = this;
            var controls = {};
            collection_1.StringMapWrapper.forEach(controlsConfig, function (controlConfig, controlName) {
                controls[controlName] = _this._createControl(controlConfig);
            });
            return controls;
        };
        /** @internal */
        FormBuilder.prototype._createControl = function (controlConfig) {
            if (controlConfig instanceof modelModule.Control || controlConfig instanceof modelModule.ControlGroup || controlConfig instanceof modelModule.ControlArray) {
                return controlConfig;
            } else if (lang_1.isArray(controlConfig)) {
                var value = controlConfig[0];
                var validator = controlConfig.length > 1 ? controlConfig[1] : null;
                var asyncValidator = controlConfig.length > 2 ? controlConfig[2] : null;
                return this.control(value, validator, asyncValidator);
            } else {
                return this.control(controlConfig);
            }
        };
        FormBuilder = __decorate([core_1.Injectable(), __metadata('design:paramtypes', [])], FormBuilder);
        return FormBuilder;
    }();
    exports.FormBuilder = FormBuilder;
});
System.registerDynamic('angular2/src/common/forms/directives/control_value_accessor.js', ['angular2/core.js', 'angular2/src/facade/lang.js'], true, function ($__require, exports, module) {
  'use strict';"use strict";

  var global = this || self,
      GLOBAL = global;
  var core_1 = $__require('angular2/core.js');
  var lang_1 = $__require('angular2/src/facade/lang.js');
  /**
   * Used to provide a {@link ControlValueAccessor} for form controls.
   *
   * See {@link DefaultValueAccessor} for how to implement one.
   */
  exports.NG_VALUE_ACCESSOR = lang_1.CONST_EXPR(new core_1.OpaqueToken("NgValueAccessor"));
});
System.registerDynamic('angular2/src/common/forms/directives/abstract_control_directive.js', ['angular2/src/facade/lang.js', 'angular2/src/facade/exceptions.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var exceptions_1 = $__require('angular2/src/facade/exceptions.js');
    /**
     * Base class for control directives.
     *
     * Only used internally in the forms module.
     */
    var AbstractControlDirective = function () {
        function AbstractControlDirective() {}
        Object.defineProperty(AbstractControlDirective.prototype, "control", {
            get: function () {
                return exceptions_1.unimplemented();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControlDirective.prototype, "value", {
            get: function () {
                return lang_1.isPresent(this.control) ? this.control.value : null;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControlDirective.prototype, "valid", {
            get: function () {
                return lang_1.isPresent(this.control) ? this.control.valid : null;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControlDirective.prototype, "errors", {
            get: function () {
                return lang_1.isPresent(this.control) ? this.control.errors : null;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControlDirective.prototype, "pristine", {
            get: function () {
                return lang_1.isPresent(this.control) ? this.control.pristine : null;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControlDirective.prototype, "dirty", {
            get: function () {
                return lang_1.isPresent(this.control) ? this.control.dirty : null;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControlDirective.prototype, "touched", {
            get: function () {
                return lang_1.isPresent(this.control) ? this.control.touched : null;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControlDirective.prototype, "untouched", {
            get: function () {
                return lang_1.isPresent(this.control) ? this.control.untouched : null;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AbstractControlDirective.prototype, "path", {
            get: function () {
                return null;
            },
            enumerable: true,
            configurable: true
        });
        return AbstractControlDirective;
    }();
    exports.AbstractControlDirective = AbstractControlDirective;
});
System.registerDynamic('angular2/src/common/forms/directives/ng_control.js', ['angular2/src/common/forms/directives/abstract_control_directive.js', 'angular2/src/facade/exceptions.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var abstract_control_directive_1 = $__require('angular2/src/common/forms/directives/abstract_control_directive.js');
    var exceptions_1 = $__require('angular2/src/facade/exceptions.js');
    /**
     * A base class that all control directive extend.
     * It binds a {@link Control} object to a DOM element.
     *
     * Used internally by Angular forms.
     */
    var NgControl = function (_super) {
        __extends(NgControl, _super);
        function NgControl() {
            _super.apply(this, arguments);
            this.name = null;
            this.valueAccessor = null;
        }
        Object.defineProperty(NgControl.prototype, "validator", {
            get: function () {
                return exceptions_1.unimplemented();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgControl.prototype, "asyncValidator", {
            get: function () {
                return exceptions_1.unimplemented();
            },
            enumerable: true,
            configurable: true
        });
        return NgControl;
    }(abstract_control_directive_1.AbstractControlDirective);
    exports.NgControl = NgControl;
});
System.registerDynamic("angular2/src/common/forms/directives/radio_control_value_accessor.js", ["angular2/core.js", "angular2/src/common/forms/directives/control_value_accessor.js", "angular2/src/common/forms/directives/ng_control.js", "angular2/src/facade/lang.js", "angular2/src/facade/collection.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1 = $__require("angular2/core.js");
    var control_value_accessor_1 = $__require("angular2/src/common/forms/directives/control_value_accessor.js");
    var ng_control_1 = $__require("angular2/src/common/forms/directives/ng_control.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var RADIO_VALUE_ACCESSOR = lang_1.CONST_EXPR(new core_1.Provider(control_value_accessor_1.NG_VALUE_ACCESSOR, { useExisting: core_1.forwardRef(function () {
            return RadioControlValueAccessor;
        }), multi: true }));
    /**
     * Internal class used by Angular to uncheck radio buttons with the matching name.
     */
    var RadioControlRegistry = function () {
        function RadioControlRegistry() {
            this._accessors = [];
        }
        RadioControlRegistry.prototype.add = function (control, accessor) {
            this._accessors.push([control, accessor]);
        };
        RadioControlRegistry.prototype.remove = function (accessor) {
            var indexToRemove = -1;
            for (var i = 0; i < this._accessors.length; ++i) {
                if (this._accessors[i][1] === accessor) {
                    indexToRemove = i;
                }
            }
            collection_1.ListWrapper.removeAt(this._accessors, indexToRemove);
        };
        RadioControlRegistry.prototype.select = function (accessor) {
            this._accessors.forEach(function (c) {
                if (c[0].control.root === accessor._control.control.root && c[1] !== accessor) {
                    c[1].fireUncheck();
                }
            });
        };
        RadioControlRegistry = __decorate([core_1.Injectable(), __metadata('design:paramtypes', [])], RadioControlRegistry);
        return RadioControlRegistry;
    }();
    exports.RadioControlRegistry = RadioControlRegistry;
    /**
     * The value provided by the forms API for radio buttons.
     */
    var RadioButtonState = function () {
        function RadioButtonState(checked, value) {
            this.checked = checked;
            this.value = value;
        }
        return RadioButtonState;
    }();
    exports.RadioButtonState = RadioButtonState;
    /**
     * The accessor for writing a radio control value and listening to changes that is used by the
     * {@link NgModel}, {@link NgFormControl}, and {@link NgControlName} directives.
     *
     *  ### Example
     *  ```
     *  @Component({
     *    template: `
     *      <input type="radio" name="food" [(ngModel)]="foodChicken">
     *      <input type="radio" name="food" [(ngModel)]="foodFish">
     *    `
     *  })
     *  class FoodCmp {
     *    foodChicken = new RadioButtonState(true, "chicken");
     *    foodFish = new RadioButtonState(false, "fish");
     *  }
     *  ```
     */
    var RadioControlValueAccessor = function () {
        function RadioControlValueAccessor(_renderer, _elementRef, _registry, _injector) {
            this._renderer = _renderer;
            this._elementRef = _elementRef;
            this._registry = _registry;
            this._injector = _injector;
            this.onChange = function () {};
            this.onTouched = function () {};
        }
        RadioControlValueAccessor.prototype.ngOnInit = function () {
            this._control = this._injector.get(ng_control_1.NgControl);
            this._registry.add(this._control, this);
        };
        RadioControlValueAccessor.prototype.ngOnDestroy = function () {
            this._registry.remove(this);
        };
        RadioControlValueAccessor.prototype.writeValue = function (value) {
            this._state = value;
            if (lang_1.isPresent(value) && value.checked) {
                this._renderer.setElementProperty(this._elementRef.nativeElement, 'checked', true);
            }
        };
        RadioControlValueAccessor.prototype.registerOnChange = function (fn) {
            var _this = this;
            this._fn = fn;
            this.onChange = function () {
                fn(new RadioButtonState(true, _this._state.value));
                _this._registry.select(_this);
            };
        };
        RadioControlValueAccessor.prototype.fireUncheck = function () {
            this._fn(new RadioButtonState(false, this._state.value));
        };
        RadioControlValueAccessor.prototype.registerOnTouched = function (fn) {
            this.onTouched = fn;
        };
        __decorate([core_1.Input(), __metadata('design:type', String)], RadioControlValueAccessor.prototype, "name", void 0);
        RadioControlValueAccessor = __decorate([core_1.Directive({
            selector: 'input[type=radio][ngControl],input[type=radio][ngFormControl],input[type=radio][ngModel]',
            host: { '(change)': 'onChange()', '(blur)': 'onTouched()' },
            providers: [RADIO_VALUE_ACCESSOR]
        }), __metadata('design:paramtypes', [core_1.Renderer, core_1.ElementRef, RadioControlRegistry, core_1.Injector])], RadioControlValueAccessor);
        return RadioControlValueAccessor;
    }();
    exports.RadioControlValueAccessor = RadioControlValueAccessor;
});
System.registerDynamic('angular2/src/common/forms.js', ['angular2/src/common/forms/model.js', 'angular2/src/common/forms/directives/abstract_control_directive.js', 'angular2/src/common/forms/directives/control_container.js', 'angular2/src/common/forms/directives/ng_control_name.js', 'angular2/src/common/forms/directives/ng_form_control.js', 'angular2/src/common/forms/directives/ng_model.js', 'angular2/src/common/forms/directives/ng_control.js', 'angular2/src/common/forms/directives/ng_control_group.js', 'angular2/src/common/forms/directives/ng_form_model.js', 'angular2/src/common/forms/directives/ng_form.js', 'angular2/src/common/forms/directives/control_value_accessor.js', 'angular2/src/common/forms/directives/default_value_accessor.js', 'angular2/src/common/forms/directives/ng_control_status.js', 'angular2/src/common/forms/directives/checkbox_value_accessor.js', 'angular2/src/common/forms/directives/select_control_value_accessor.js', 'angular2/src/common/forms/directives.js', 'angular2/src/common/forms/validators.js', 'angular2/src/common/forms/directives/validators.js', 'angular2/src/common/forms/form_builder.js', 'angular2/src/common/forms/directives/radio_control_value_accessor.js', 'angular2/src/facade/lang.js'], true, function ($__require, exports, module) {
  'use strict';"use strict";
  /**
   * @module
   * @description
   * This module is used for handling user input, by defining and building a {@link ControlGroup} that
   * consists of
   * {@link Control} objects, and mapping them onto the DOM. {@link Control} objects can then be used
   * to read information
   * from the form DOM elements.
   *
   * This module is not included in the `angular2` module; you must import the forms module
   * explicitly.
   *
   */

  var global = this || self,
      GLOBAL = global;
  var model_1 = $__require('angular2/src/common/forms/model.js');
  exports.AbstractControl = model_1.AbstractControl;
  exports.Control = model_1.Control;
  exports.ControlGroup = model_1.ControlGroup;
  exports.ControlArray = model_1.ControlArray;
  var abstract_control_directive_1 = $__require('angular2/src/common/forms/directives/abstract_control_directive.js');
  exports.AbstractControlDirective = abstract_control_directive_1.AbstractControlDirective;
  var control_container_1 = $__require('angular2/src/common/forms/directives/control_container.js');
  exports.ControlContainer = control_container_1.ControlContainer;
  var ng_control_name_1 = $__require('angular2/src/common/forms/directives/ng_control_name.js');
  exports.NgControlName = ng_control_name_1.NgControlName;
  var ng_form_control_1 = $__require('angular2/src/common/forms/directives/ng_form_control.js');
  exports.NgFormControl = ng_form_control_1.NgFormControl;
  var ng_model_1 = $__require('angular2/src/common/forms/directives/ng_model.js');
  exports.NgModel = ng_model_1.NgModel;
  var ng_control_1 = $__require('angular2/src/common/forms/directives/ng_control.js');
  exports.NgControl = ng_control_1.NgControl;
  var ng_control_group_1 = $__require('angular2/src/common/forms/directives/ng_control_group.js');
  exports.NgControlGroup = ng_control_group_1.NgControlGroup;
  var ng_form_model_1 = $__require('angular2/src/common/forms/directives/ng_form_model.js');
  exports.NgFormModel = ng_form_model_1.NgFormModel;
  var ng_form_1 = $__require('angular2/src/common/forms/directives/ng_form.js');
  exports.NgForm = ng_form_1.NgForm;
  var control_value_accessor_1 = $__require('angular2/src/common/forms/directives/control_value_accessor.js');
  exports.NG_VALUE_ACCESSOR = control_value_accessor_1.NG_VALUE_ACCESSOR;
  var default_value_accessor_1 = $__require('angular2/src/common/forms/directives/default_value_accessor.js');
  exports.DefaultValueAccessor = default_value_accessor_1.DefaultValueAccessor;
  var ng_control_status_1 = $__require('angular2/src/common/forms/directives/ng_control_status.js');
  exports.NgControlStatus = ng_control_status_1.NgControlStatus;
  var checkbox_value_accessor_1 = $__require('angular2/src/common/forms/directives/checkbox_value_accessor.js');
  exports.CheckboxControlValueAccessor = checkbox_value_accessor_1.CheckboxControlValueAccessor;
  var select_control_value_accessor_1 = $__require('angular2/src/common/forms/directives/select_control_value_accessor.js');
  exports.NgSelectOption = select_control_value_accessor_1.NgSelectOption;
  exports.SelectControlValueAccessor = select_control_value_accessor_1.SelectControlValueAccessor;
  var directives_1 = $__require('angular2/src/common/forms/directives.js');
  exports.FORM_DIRECTIVES = directives_1.FORM_DIRECTIVES;
  exports.RadioButtonState = directives_1.RadioButtonState;
  var validators_1 = $__require('angular2/src/common/forms/validators.js');
  exports.NG_VALIDATORS = validators_1.NG_VALIDATORS;
  exports.NG_ASYNC_VALIDATORS = validators_1.NG_ASYNC_VALIDATORS;
  exports.Validators = validators_1.Validators;
  var validators_2 = $__require('angular2/src/common/forms/directives/validators.js');
  exports.RequiredValidator = validators_2.RequiredValidator;
  exports.MinLengthValidator = validators_2.MinLengthValidator;
  exports.MaxLengthValidator = validators_2.MaxLengthValidator;
  exports.PatternValidator = validators_2.PatternValidator;
  var form_builder_1 = $__require('angular2/src/common/forms/form_builder.js');
  exports.FormBuilder = form_builder_1.FormBuilder;
  var form_builder_2 = $__require('angular2/src/common/forms/form_builder.js');
  var radio_control_value_accessor_1 = $__require('angular2/src/common/forms/directives/radio_control_value_accessor.js');
  var lang_1 = $__require('angular2/src/facade/lang.js');
  /**
   * Shorthand set of providers used for building Angular forms.
   *
   * ### Example
   *
   * ```typescript
   * bootstrap(MyApp, [FORM_PROVIDERS]);
   * ```
   */
  exports.FORM_PROVIDERS = lang_1.CONST_EXPR([form_builder_2.FormBuilder, radio_control_value_accessor_1.RadioControlRegistry]);
  /**
   * See {@link FORM_PROVIDERS} instead.
   *
   * @deprecated
   */
  exports.FORM_BINDINGS = exports.FORM_PROVIDERS;
});
System.registerDynamic("angular2/src/common/directives/observable_list_diff.js", [], false, function ($__require, $__exports, $__module) {
  var _retrieveGlobal = System.get("@@global-helpers").prepareGlobal($__module.id, null, null);

  (function ($__global) {
    'use strict'; // TS does not have Observables
    "use strict";
  })(this);

  return _retrieveGlobal();
});
System.registerDynamic("angular2/src/common/directives/ng_class.js", ["angular2/src/facade/lang.js", "angular2/core.js", "angular2/src/facade/collection.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var core_1 = $__require("angular2/core.js");
    var collection_1 = $__require("angular2/src/facade/collection.js");
    /**
     * The `NgClass` directive conditionally adds and removes CSS classes on an HTML element based on
     * an expression's evaluation result.
     *
     * The result of an expression evaluation is interpreted differently depending on type of
     * the expression evaluation result:
     * - `string` - all the CSS classes listed in a string (space delimited) are added
     * - `Array` - all the CSS classes (Array elements) are added
     * - `Object` - each key corresponds to a CSS class name while values are interpreted as expressions
     * evaluating to `Boolean`. If a given expression evaluates to `true` a corresponding CSS class
     * is added - otherwise it is removed.
     *
     * While the `NgClass` directive can interpret expressions evaluating to `string`, `Array`
     * or `Object`, the `Object`-based version is the most often used and has an advantage of keeping
     * all the CSS class names in a template.
     *
     * ### Example ([live demo](http://plnkr.co/edit/a4YdtmWywhJ33uqfpPPn?p=preview)):
     *
     * ```
     * import {Component} from 'angular2/core';
     * import {NgClass} from 'angular2/common';
     *
     * @Component({
     *   selector: 'toggle-button',
     *   inputs: ['isDisabled'],
     *   template: `
     *      <div class="button" [ngClass]="{active: isOn, disabled: isDisabled}"
     *          (click)="toggle(!isOn)">
     *          Click me!
     *      </div>`,
     *   styles: [`
     *     .button {
     *       width: 120px;
     *       border: medium solid black;
     *     }
     *
     *     .active {
     *       background-color: red;
     *    }
     *
     *     .disabled {
     *       color: gray;
     *       border: medium solid gray;
     *     }
     *   `]
     *   directives: [NgClass]
     * })
     * class ToggleButton {
     *   isOn = false;
     *   isDisabled = false;
     *
     *   toggle(newState) {
     *     if (!this.isDisabled) {
     *       this.isOn = newState;
     *     }
     *   }
     * }
     * ```
     */
    var NgClass = function () {
        function NgClass(_iterableDiffers, _keyValueDiffers, _ngEl, _renderer) {
            this._iterableDiffers = _iterableDiffers;
            this._keyValueDiffers = _keyValueDiffers;
            this._ngEl = _ngEl;
            this._renderer = _renderer;
            this._initialClasses = [];
        }
        Object.defineProperty(NgClass.prototype, "initialClasses", {
            set: function (v) {
                this._applyInitialClasses(true);
                this._initialClasses = lang_1.isPresent(v) && lang_1.isString(v) ? v.split(' ') : [];
                this._applyInitialClasses(false);
                this._applyClasses(this._rawClass, false);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgClass.prototype, "rawClass", {
            set: function (v) {
                this._cleanupClasses(this._rawClass);
                if (lang_1.isString(v)) {
                    v = v.split(' ');
                }
                this._rawClass = v;
                this._iterableDiffer = null;
                this._keyValueDiffer = null;
                if (lang_1.isPresent(v)) {
                    if (collection_1.isListLikeIterable(v)) {
                        this._iterableDiffer = this._iterableDiffers.find(v).create(null);
                    } else {
                        this._keyValueDiffer = this._keyValueDiffers.find(v).create(null);
                    }
                }
            },
            enumerable: true,
            configurable: true
        });
        NgClass.prototype.ngDoCheck = function () {
            if (lang_1.isPresent(this._iterableDiffer)) {
                var changes = this._iterableDiffer.diff(this._rawClass);
                if (lang_1.isPresent(changes)) {
                    this._applyIterableChanges(changes);
                }
            }
            if (lang_1.isPresent(this._keyValueDiffer)) {
                var changes = this._keyValueDiffer.diff(this._rawClass);
                if (lang_1.isPresent(changes)) {
                    this._applyKeyValueChanges(changes);
                }
            }
        };
        NgClass.prototype.ngOnDestroy = function () {
            this._cleanupClasses(this._rawClass);
        };
        NgClass.prototype._cleanupClasses = function (rawClassVal) {
            this._applyClasses(rawClassVal, true);
            this._applyInitialClasses(false);
        };
        NgClass.prototype._applyKeyValueChanges = function (changes) {
            var _this = this;
            changes.forEachAddedItem(function (record) {
                _this._toggleClass(record.key, record.currentValue);
            });
            changes.forEachChangedItem(function (record) {
                _this._toggleClass(record.key, record.currentValue);
            });
            changes.forEachRemovedItem(function (record) {
                if (record.previousValue) {
                    _this._toggleClass(record.key, false);
                }
            });
        };
        NgClass.prototype._applyIterableChanges = function (changes) {
            var _this = this;
            changes.forEachAddedItem(function (record) {
                _this._toggleClass(record.item, true);
            });
            changes.forEachRemovedItem(function (record) {
                _this._toggleClass(record.item, false);
            });
        };
        NgClass.prototype._applyInitialClasses = function (isCleanup) {
            var _this = this;
            this._initialClasses.forEach(function (className) {
                return _this._toggleClass(className, !isCleanup);
            });
        };
        NgClass.prototype._applyClasses = function (rawClassVal, isCleanup) {
            var _this = this;
            if (lang_1.isPresent(rawClassVal)) {
                if (lang_1.isArray(rawClassVal)) {
                    rawClassVal.forEach(function (className) {
                        return _this._toggleClass(className, !isCleanup);
                    });
                } else if (rawClassVal instanceof Set) {
                    rawClassVal.forEach(function (className) {
                        return _this._toggleClass(className, !isCleanup);
                    });
                } else {
                    collection_1.StringMapWrapper.forEach(rawClassVal, function (expVal, className) {
                        if (lang_1.isPresent(expVal)) _this._toggleClass(className, !isCleanup);
                    });
                }
            }
        };
        NgClass.prototype._toggleClass = function (className, enabled) {
            className = className.trim();
            if (className.length > 0) {
                if (className.indexOf(' ') > -1) {
                    var classes = className.split(/\s+/g);
                    for (var i = 0, len = classes.length; i < len; i++) {
                        this._renderer.setElementClass(this._ngEl.nativeElement, classes[i], enabled);
                    }
                } else {
                    this._renderer.setElementClass(this._ngEl.nativeElement, className, enabled);
                }
            }
        };
        NgClass = __decorate([core_1.Directive({ selector: '[ngClass]', inputs: ['rawClass: ngClass', 'initialClasses: class'] }), __metadata('design:paramtypes', [core_1.IterableDiffers, core_1.KeyValueDiffers, core_1.ElementRef, core_1.Renderer])], NgClass);
        return NgClass;
    }();
    exports.NgClass = NgClass;
});
System.registerDynamic("angular2/src/common/directives/ng_for.js", ["angular2/core.js", "angular2/src/facade/lang.js", "angular2/src/facade/exceptions.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1 = $__require("angular2/core.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var exceptions_1 = $__require("angular2/src/facade/exceptions.js");
    /**
     * The `NgFor` directive instantiates a template once per item from an iterable. The context for
     * each instantiated template inherits from the outer context with the given loop variable set
     * to the current item from the iterable.
     *
     * # Local Variables
     *
     * `NgFor` provides several exported values that can be aliased to local variables:
     *
     * * `index` will be set to the current loop iteration for each template context.
     * * `first` will be set to a boolean value indicating whether the item is the first one in the
     *   iteration.
     * * `last` will be set to a boolean value indicating whether the item is the last one in the
     *   iteration.
     * * `even` will be set to a boolean value indicating whether this item has an even index.
     * * `odd` will be set to a boolean value indicating whether this item has an odd index.
     *
     * # Change Propagation
     *
     * When the contents of the iterator changes, `NgFor` makes the corresponding changes to the DOM:
     *
     * * When an item is added, a new instance of the template is added to the DOM.
     * * When an item is removed, its template instance is removed from the DOM.
     * * When items are reordered, their respective templates are reordered in the DOM.
     * * Otherwise, the DOM element for that item will remain the same.
     *
     * Angular uses object identity to track insertions and deletions within the iterator and reproduce
     * those changes in the DOM. This has important implications for animations and any stateful
     * controls
     * (such as `<input>` elements which accept user input) that are present. Inserted rows can be
     * animated in, deleted rows can be animated out, and unchanged rows retain any unsaved state such
     * as user input.
     *
     * It is possible for the identities of elements in the iterator to change while the data does not.
     * This can happen, for example, if the iterator produced from an RPC to the server, and that
     * RPC is re-run. Even if the data hasn't changed, the second response will produce objects with
     * different identities, and Angular will tear down the entire DOM and rebuild it (as if all old
     * elements were deleted and all new elements inserted). This is an expensive operation and should
     * be avoided if possible.
     *
     * # Syntax
     *
     * - `<li *ngFor="#item of items; #i = index">...</li>`
     * - `<li template="ngFor #item of items; #i = index">...</li>`
     * - `<template ngFor #item [ngForOf]="items" #i="index"><li>...</li></template>`
     *
     * ### Example
     *
     * See a [live demo](http://plnkr.co/edit/KVuXxDp0qinGDyo307QW?p=preview) for a more detailed
     * example.
     */
    var NgFor = function () {
        function NgFor(_viewContainer, _templateRef, _iterableDiffers, _cdr) {
            this._viewContainer = _viewContainer;
            this._templateRef = _templateRef;
            this._iterableDiffers = _iterableDiffers;
            this._cdr = _cdr;
        }
        Object.defineProperty(NgFor.prototype, "ngForOf", {
            set: function (value) {
                this._ngForOf = value;
                if (lang_1.isBlank(this._differ) && lang_1.isPresent(value)) {
                    try {
                        this._differ = this._iterableDiffers.find(value).create(this._cdr, this._ngForTrackBy);
                    } catch (e) {
                        throw new exceptions_1.BaseException("Cannot find a differ supporting object '" + value + "' of type '" + lang_1.getTypeNameForDebugging(value) + "'. NgFor only supports binding to Iterables such as Arrays.");
                    }
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgFor.prototype, "ngForTemplate", {
            set: function (value) {
                if (lang_1.isPresent(value)) {
                    this._templateRef = value;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgFor.prototype, "ngForTrackBy", {
            set: function (value) {
                this._ngForTrackBy = value;
            },
            enumerable: true,
            configurable: true
        });
        NgFor.prototype.ngDoCheck = function () {
            if (lang_1.isPresent(this._differ)) {
                var changes = this._differ.diff(this._ngForOf);
                if (lang_1.isPresent(changes)) this._applyChanges(changes);
            }
        };
        NgFor.prototype._applyChanges = function (changes) {
            var _this = this;
            // TODO(rado): check if change detection can produce a change record that is
            // easier to consume than current.
            var recordViewTuples = [];
            changes.forEachRemovedItem(function (removedRecord) {
                return recordViewTuples.push(new RecordViewTuple(removedRecord, null));
            });
            changes.forEachMovedItem(function (movedRecord) {
                return recordViewTuples.push(new RecordViewTuple(movedRecord, null));
            });
            var insertTuples = this._bulkRemove(recordViewTuples);
            changes.forEachAddedItem(function (addedRecord) {
                return insertTuples.push(new RecordViewTuple(addedRecord, null));
            });
            this._bulkInsert(insertTuples);
            for (var i = 0; i < insertTuples.length; i++) {
                this._perViewChange(insertTuples[i].view, insertTuples[i].record);
            }
            for (var i = 0, ilen = this._viewContainer.length; i < ilen; i++) {
                var viewRef = this._viewContainer.get(i);
                viewRef.setLocal('first', i === 0);
                viewRef.setLocal('last', i === ilen - 1);
            }
            changes.forEachIdentityChange(function (record) {
                var viewRef = _this._viewContainer.get(record.currentIndex);
                viewRef.setLocal('\$implicit', record.item);
            });
        };
        NgFor.prototype._perViewChange = function (view, record) {
            view.setLocal('\$implicit', record.item);
            view.setLocal('index', record.currentIndex);
            view.setLocal('even', record.currentIndex % 2 == 0);
            view.setLocal('odd', record.currentIndex % 2 == 1);
        };
        NgFor.prototype._bulkRemove = function (tuples) {
            tuples.sort(function (a, b) {
                return a.record.previousIndex - b.record.previousIndex;
            });
            var movedTuples = [];
            for (var i = tuples.length - 1; i >= 0; i--) {
                var tuple = tuples[i];
                // separate moved views from removed views.
                if (lang_1.isPresent(tuple.record.currentIndex)) {
                    tuple.view = this._viewContainer.detach(tuple.record.previousIndex);
                    movedTuples.push(tuple);
                } else {
                    this._viewContainer.remove(tuple.record.previousIndex);
                }
            }
            return movedTuples;
        };
        NgFor.prototype._bulkInsert = function (tuples) {
            tuples.sort(function (a, b) {
                return a.record.currentIndex - b.record.currentIndex;
            });
            for (var i = 0; i < tuples.length; i++) {
                var tuple = tuples[i];
                if (lang_1.isPresent(tuple.view)) {
                    this._viewContainer.insert(tuple.view, tuple.record.currentIndex);
                } else {
                    tuple.view = this._viewContainer.createEmbeddedView(this._templateRef, tuple.record.currentIndex);
                }
            }
            return tuples;
        };
        NgFor = __decorate([core_1.Directive({ selector: '[ngFor][ngForOf]', inputs: ['ngForTrackBy', 'ngForOf', 'ngForTemplate'] }), __metadata('design:paramtypes', [core_1.ViewContainerRef, core_1.TemplateRef, core_1.IterableDiffers, core_1.ChangeDetectorRef])], NgFor);
        return NgFor;
    }();
    exports.NgFor = NgFor;
    var RecordViewTuple = function () {
        function RecordViewTuple(record, view) {
            this.record = record;
            this.view = view;
        }
        return RecordViewTuple;
    }();
});
System.registerDynamic("angular2/src/common/directives/ng_if.js", ["angular2/core.js", "angular2/src/facade/lang.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1 = $__require("angular2/core.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    /**
     * Removes or recreates a portion of the DOM tree based on an {expression}.
     *
     * If the expression assigned to `ngIf` evaluates to a false value then the element
     * is removed from the DOM, otherwise a clone of the element is reinserted into the DOM.
     *
     * ### Example ([live demo](http://plnkr.co/edit/fe0kgemFBtmQOY31b4tw?p=preview)):
     *
     * ```
     * <div *ngIf="errorCount > 0" class="error">
     *   <!-- Error message displayed when the errorCount property on the current context is greater
     * than 0. -->
     *   {{errorCount}} errors detected
     * </div>
     * ```
     *
     * ### Syntax
     *
     * - `<div *ngIf="condition">...</div>`
     * - `<div template="ngIf condition">...</div>`
     * - `<template [ngIf]="condition"><div>...</div></template>`
     */
    var NgIf = function () {
        function NgIf(_viewContainer, _templateRef) {
            this._viewContainer = _viewContainer;
            this._templateRef = _templateRef;
            this._prevCondition = null;
        }
        Object.defineProperty(NgIf.prototype, "ngIf", {
            set: function (newCondition /* boolean */) {
                if (newCondition && (lang_1.isBlank(this._prevCondition) || !this._prevCondition)) {
                    this._prevCondition = true;
                    this._viewContainer.createEmbeddedView(this._templateRef);
                } else if (!newCondition && (lang_1.isBlank(this._prevCondition) || this._prevCondition)) {
                    this._prevCondition = false;
                    this._viewContainer.clear();
                }
            },
            enumerable: true,
            configurable: true
        });
        NgIf = __decorate([core_1.Directive({ selector: '[ngIf]', inputs: ['ngIf'] }), __metadata('design:paramtypes', [core_1.ViewContainerRef, core_1.TemplateRef])], NgIf);
        return NgIf;
    }();
    exports.NgIf = NgIf;
});
System.registerDynamic("angular2/src/common/directives/ng_style.js", ["angular2/core.js", "angular2/src/facade/lang.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1 = $__require("angular2/core.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    /**
     * The `NgStyle` directive changes styles based on a result of expression evaluation.
     *
     * An expression assigned to the `ngStyle` property must evaluate to an object and the
     * corresponding element styles are updated based on changes to this object. Style names to update
     * are taken from the object's keys, and values - from the corresponding object's values.
     *
     * ### Syntax
     *
     * - `<div [ngStyle]="{'font-style': style}"></div>`
     * - `<div [ngStyle]="styleExp"></div>` - here the `styleExp` must evaluate to an object
     *
     * ### Example ([live demo](http://plnkr.co/edit/YamGS6GkUh9GqWNQhCyM?p=preview)):
     *
     * ```
     * import {Component} from 'angular2/core';
     * import {NgStyle} from 'angular2/common';
     *
     * @Component({
     *  selector: 'ngStyle-example',
     *  template: `
     *    <h1 [ngStyle]="{'font-style': style, 'font-size': size, 'font-weight': weight}">
     *      Change style of this text!
     *    </h1>
     *
     *    <hr>
     *
     *    <label>Italic: <input type="checkbox" (change)="changeStyle($event)"></label>
     *    <label>Bold: <input type="checkbox" (change)="changeWeight($event)"></label>
     *    <label>Size: <input type="text" [value]="size" (change)="size = $event.target.value"></label>
     *  `,
     *  directives: [NgStyle]
     * })
     * export class NgStyleExample {
     *    style = 'normal';
     *    weight = 'normal';
     *    size = '20px';
     *
     *    changeStyle($event: any) {
     *      this.style = $event.target.checked ? 'italic' : 'normal';
     *    }
     *
     *    changeWeight($event: any) {
     *      this.weight = $event.target.checked ? 'bold' : 'normal';
     *    }
     * }
     * ```
     *
     * In this example the `font-style`, `font-size` and `font-weight` styles will be updated
     * based on the `style` property's value changes.
     */
    var NgStyle = function () {
        function NgStyle(_differs, _ngEl, _renderer) {
            this._differs = _differs;
            this._ngEl = _ngEl;
            this._renderer = _renderer;
        }
        Object.defineProperty(NgStyle.prototype, "rawStyle", {
            set: function (v) {
                this._rawStyle = v;
                if (lang_1.isBlank(this._differ) && lang_1.isPresent(v)) {
                    this._differ = this._differs.find(this._rawStyle).create(null);
                }
            },
            enumerable: true,
            configurable: true
        });
        NgStyle.prototype.ngDoCheck = function () {
            if (lang_1.isPresent(this._differ)) {
                var changes = this._differ.diff(this._rawStyle);
                if (lang_1.isPresent(changes)) {
                    this._applyChanges(changes);
                }
            }
        };
        NgStyle.prototype._applyChanges = function (changes) {
            var _this = this;
            changes.forEachAddedItem(function (record) {
                _this._setStyle(record.key, record.currentValue);
            });
            changes.forEachChangedItem(function (record) {
                _this._setStyle(record.key, record.currentValue);
            });
            changes.forEachRemovedItem(function (record) {
                _this._setStyle(record.key, null);
            });
        };
        NgStyle.prototype._setStyle = function (name, val) {
            this._renderer.setElementStyle(this._ngEl.nativeElement, name, val);
        };
        NgStyle = __decorate([core_1.Directive({ selector: '[ngStyle]', inputs: ['rawStyle: ngStyle'] }), __metadata('design:paramtypes', [core_1.KeyValueDiffers, core_1.ElementRef, core_1.Renderer])], NgStyle);
        return NgStyle;
    }();
    exports.NgStyle = NgStyle;
});
System.registerDynamic("angular2/src/common/directives/ng_switch.js", ["angular2/core.js", "angular2/src/facade/lang.js", "angular2/src/facade/collection.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var __param = this && this.__param || function (paramIndex, decorator) {
        return function (target, key) {
            decorator(target, key, paramIndex);
        };
    };
    var core_1 = $__require("angular2/core.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var _WHEN_DEFAULT = lang_1.CONST_EXPR(new Object());
    var SwitchView = function () {
        function SwitchView(_viewContainerRef, _templateRef) {
            this._viewContainerRef = _viewContainerRef;
            this._templateRef = _templateRef;
        }
        SwitchView.prototype.create = function () {
            this._viewContainerRef.createEmbeddedView(this._templateRef);
        };
        SwitchView.prototype.destroy = function () {
            this._viewContainerRef.clear();
        };
        return SwitchView;
    }();
    exports.SwitchView = SwitchView;
    /**
     * Adds or removes DOM sub-trees when their match expressions match the switch expression.
     *
     * Elements within `NgSwitch` but without `NgSwitchWhen` or `NgSwitchDefault` directives will be
     * preserved at the location as specified in the template.
     *
     * `NgSwitch` simply inserts nested elements based on which match expression matches the value
     * obtained from the evaluated switch expression. In other words, you define a container element
     * (where you place the directive with a switch expression on the
     * **`[ngSwitch]="..."` attribute**), define any inner elements inside of the directive and
     * place a `[ngSwitchWhen]` attribute per element.
     *
     * The `ngSwitchWhen` property is used to inform `NgSwitch` which element to display when the
     * expression is evaluated. If a matching expression is not found via a `ngSwitchWhen` property
     * then an element with the `ngSwitchDefault` attribute is displayed.
     *
     * ### Example ([live demo](http://plnkr.co/edit/DQMTII95CbuqWrl3lYAs?p=preview))
     *
     * ```typescript
     * @Component({
     *   selector: 'app',
     *   template: `
     *     <p>Value = {{value}}</p>
     *     <button (click)="inc()">Increment</button>
     *
     *     <div [ngSwitch]="value">
     *       <p *ngSwitchWhen="'init'">increment to start</p>
     *       <p *ngSwitchWhen="0">0, increment again</p>
     *       <p *ngSwitchWhen="1">1, increment again</p>
     *       <p *ngSwitchWhen="2">2, stop incrementing</p>
     *       <p *ngSwitchDefault>&gt; 2, STOP!</p>
     *     </div>
     *
     *     <!-- alternate syntax -->
     *
     *     <p [ngSwitch]="value">
     *       <template ngSwitchWhen="init">increment to start</template>
     *       <template [ngSwitchWhen]="0">0, increment again</template>
     *       <template [ngSwitchWhen]="1">1, increment again</template>
     *       <template [ngSwitchWhen]="2">2, stop incrementing</template>
     *       <template ngSwitchDefault>&gt; 2, STOP!</template>
     *     </p>
     *   `,
     *   directives: [NgSwitch, NgSwitchWhen, NgSwitchDefault]
     * })
     * export class App {
     *   value = 'init';
     *
     *   inc() {
     *     this.value = this.value === 'init' ? 0 : this.value + 1;
     *   }
     * }
     *
     * bootstrap(App).catch(err => console.error(err));
     * ```
     */
    var NgSwitch = function () {
        function NgSwitch() {
            this._useDefault = false;
            this._valueViews = new collection_1.Map();
            this._activeViews = [];
        }
        Object.defineProperty(NgSwitch.prototype, "ngSwitch", {
            set: function (value) {
                // Empty the currently active ViewContainers
                this._emptyAllActiveViews();
                // Add the ViewContainers matching the value (with a fallback to default)
                this._useDefault = false;
                var views = this._valueViews.get(value);
                if (lang_1.isBlank(views)) {
                    this._useDefault = true;
                    views = lang_1.normalizeBlank(this._valueViews.get(_WHEN_DEFAULT));
                }
                this._activateViews(views);
                this._switchValue = value;
            },
            enumerable: true,
            configurable: true
        });
        /** @internal */
        NgSwitch.prototype._onWhenValueChanged = function (oldWhen, newWhen, view) {
            this._deregisterView(oldWhen, view);
            this._registerView(newWhen, view);
            if (oldWhen === this._switchValue) {
                view.destroy();
                collection_1.ListWrapper.remove(this._activeViews, view);
            } else if (newWhen === this._switchValue) {
                if (this._useDefault) {
                    this._useDefault = false;
                    this._emptyAllActiveViews();
                }
                view.create();
                this._activeViews.push(view);
            }
            // Switch to default when there is no more active ViewContainers
            if (this._activeViews.length === 0 && !this._useDefault) {
                this._useDefault = true;
                this._activateViews(this._valueViews.get(_WHEN_DEFAULT));
            }
        };
        /** @internal */
        NgSwitch.prototype._emptyAllActiveViews = function () {
            var activeContainers = this._activeViews;
            for (var i = 0; i < activeContainers.length; i++) {
                activeContainers[i].destroy();
            }
            this._activeViews = [];
        };
        /** @internal */
        NgSwitch.prototype._activateViews = function (views) {
            // TODO(vicb): assert(this._activeViews.length === 0);
            if (lang_1.isPresent(views)) {
                for (var i = 0; i < views.length; i++) {
                    views[i].create();
                }
                this._activeViews = views;
            }
        };
        /** @internal */
        NgSwitch.prototype._registerView = function (value, view) {
            var views = this._valueViews.get(value);
            if (lang_1.isBlank(views)) {
                views = [];
                this._valueViews.set(value, views);
            }
            views.push(view);
        };
        /** @internal */
        NgSwitch.prototype._deregisterView = function (value, view) {
            // `_WHEN_DEFAULT` is used a marker for non-registered whens
            if (value === _WHEN_DEFAULT) return;
            var views = this._valueViews.get(value);
            if (views.length == 1) {
                this._valueViews.delete(value);
            } else {
                collection_1.ListWrapper.remove(views, view);
            }
        };
        NgSwitch = __decorate([core_1.Directive({ selector: '[ngSwitch]', inputs: ['ngSwitch'] }), __metadata('design:paramtypes', [])], NgSwitch);
        return NgSwitch;
    }();
    exports.NgSwitch = NgSwitch;
    /**
     * Insert the sub-tree when the `ngSwitchWhen` expression evaluates to the same value as the
     * enclosing switch expression.
     *
     * If multiple match expression match the switch expression value, all of them are displayed.
     *
     * See {@link NgSwitch} for more details and example.
     */
    var NgSwitchWhen = function () {
        function NgSwitchWhen(viewContainer, templateRef, ngSwitch) {
            // `_WHEN_DEFAULT` is used as a marker for a not yet initialized value
            /** @internal */
            this._value = _WHEN_DEFAULT;
            this._switch = ngSwitch;
            this._view = new SwitchView(viewContainer, templateRef);
        }
        Object.defineProperty(NgSwitchWhen.prototype, "ngSwitchWhen", {
            set: function (value) {
                this._switch._onWhenValueChanged(this._value, value, this._view);
                this._value = value;
            },
            enumerable: true,
            configurable: true
        });
        NgSwitchWhen = __decorate([core_1.Directive({ selector: '[ngSwitchWhen]', inputs: ['ngSwitchWhen'] }), __param(2, core_1.Host()), __metadata('design:paramtypes', [core_1.ViewContainerRef, core_1.TemplateRef, NgSwitch])], NgSwitchWhen);
        return NgSwitchWhen;
    }();
    exports.NgSwitchWhen = NgSwitchWhen;
    /**
     * Default case statements are displayed when no match expression matches the switch expression
     * value.
     *
     * See {@link NgSwitch} for more details and example.
     */
    var NgSwitchDefault = function () {
        function NgSwitchDefault(viewContainer, templateRef, sswitch) {
            sswitch._registerView(_WHEN_DEFAULT, new SwitchView(viewContainer, templateRef));
        }
        NgSwitchDefault = __decorate([core_1.Directive({ selector: '[ngSwitchDefault]' }), __param(2, core_1.Host()), __metadata('design:paramtypes', [core_1.ViewContainerRef, core_1.TemplateRef, NgSwitch])], NgSwitchDefault);
        return NgSwitchDefault;
    }();
    exports.NgSwitchDefault = NgSwitchDefault;
});
System.registerDynamic("angular2/src/common/directives/ng_plural.js", ["angular2/core.js", "angular2/src/facade/lang.js", "angular2/src/facade/collection.js", "angular2/src/common/directives/ng_switch.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var __param = this && this.__param || function (paramIndex, decorator) {
        return function (target, key) {
            decorator(target, key, paramIndex);
        };
    };
    var core_1 = $__require("angular2/core.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var ng_switch_1 = $__require("angular2/src/common/directives/ng_switch.js");
    var _CATEGORY_DEFAULT = 'other';
    var NgLocalization = function () {
        function NgLocalization() {}
        return NgLocalization;
    }();
    exports.NgLocalization = NgLocalization;
    /**
     * `ngPlural` is an i18n directive that displays DOM sub-trees that match the switch expression
     * value, or failing that, DOM sub-trees that match the switch expression's pluralization category.
     *
     * To use this directive, you must provide an extension of `NgLocalization` that maps values to
     * category names. You then define a container element that sets the `[ngPlural]` attribute to a
     * switch expression.
     *    - Inner elements defined with an `[ngPluralCase]` attribute will display based on their
     * expression.
     *    - If `[ngPluralCase]` is set to a value starting with `=`, it will only display if the value
     * matches the switch expression exactly.
     *    - Otherwise, the view will be treated as a "category match", and will only display if exact
     * value matches aren't found and the value maps to its category using the `getPluralCategory`
     * function provided.
     *
     * If no matching views are found for a switch expression, inner elements marked
     * `[ngPluralCase]="other"` will be displayed.
     *
     * ```typescript
     * class MyLocalization extends NgLocalization {
     *    getPluralCategory(value: any) {
     *       if(value < 5) {
     *          return 'few';
     *       }
     *    }
     * }
     *
     * @Component({
     *    selector: 'app',
     *    providers: [provide(NgLocalization, {useClass: MyLocalization})]
     * })
     * @View({
     *   template: `
     *     <p>Value = {{value}}</p>
     *     <button (click)="inc()">Increment</button>
     *
     *     <div [ngPlural]="value">
     *       <template ngPluralCase="=0">there is nothing</template>
     *       <template ngPluralCase="=1">there is one</template>
     *       <template ngPluralCase="few">there are a few</template>
     *       <template ngPluralCase="other">there is some number</template>
     *     </div>
     *   `,
     *   directives: [NgPlural, NgPluralCase]
     * })
     * export class App {
     *   value = 'init';
     *
     *   inc() {
     *     this.value = this.value === 'init' ? 0 : this.value + 1;
     *   }
     * }
     *
     * ```
     */
    var NgPluralCase = function () {
        function NgPluralCase(value, template, viewContainer) {
            this.value = value;
            this._view = new ng_switch_1.SwitchView(viewContainer, template);
        }
        NgPluralCase = __decorate([core_1.Directive({ selector: '[ngPluralCase]' }), __param(0, core_1.Attribute('ngPluralCase')), __metadata('design:paramtypes', [String, core_1.TemplateRef, core_1.ViewContainerRef])], NgPluralCase);
        return NgPluralCase;
    }();
    exports.NgPluralCase = NgPluralCase;
    var NgPlural = function () {
        function NgPlural(_localization) {
            this._localization = _localization;
            this._caseViews = new collection_1.Map();
            this.cases = null;
        }
        Object.defineProperty(NgPlural.prototype, "ngPlural", {
            set: function (value) {
                this._switchValue = value;
                this._updateView();
            },
            enumerable: true,
            configurable: true
        });
        NgPlural.prototype.ngAfterContentInit = function () {
            var _this = this;
            this.cases.forEach(function (pluralCase) {
                _this._caseViews.set(_this._formatValue(pluralCase), pluralCase._view);
            });
            this._updateView();
        };
        /** @internal */
        NgPlural.prototype._updateView = function () {
            this._clearViews();
            var view = this._caseViews.get(this._switchValue);
            if (!lang_1.isPresent(view)) view = this._getCategoryView(this._switchValue);
            this._activateView(view);
        };
        /** @internal */
        NgPlural.prototype._clearViews = function () {
            if (lang_1.isPresent(this._activeView)) this._activeView.destroy();
        };
        /** @internal */
        NgPlural.prototype._activateView = function (view) {
            if (!lang_1.isPresent(view)) return;
            this._activeView = view;
            this._activeView.create();
        };
        /** @internal */
        NgPlural.prototype._getCategoryView = function (value) {
            var category = this._localization.getPluralCategory(value);
            var categoryView = this._caseViews.get(category);
            return lang_1.isPresent(categoryView) ? categoryView : this._caseViews.get(_CATEGORY_DEFAULT);
        };
        /** @internal */
        NgPlural.prototype._isValueView = function (pluralCase) {
            return pluralCase.value[0] === "=";
        };
        /** @internal */
        NgPlural.prototype._formatValue = function (pluralCase) {
            return this._isValueView(pluralCase) ? this._stripValue(pluralCase.value) : pluralCase.value;
        };
        /** @internal */
        NgPlural.prototype._stripValue = function (value) {
            return lang_1.NumberWrapper.parseInt(value.substring(1), 10);
        };
        __decorate([core_1.ContentChildren(NgPluralCase), __metadata('design:type', core_1.QueryList)], NgPlural.prototype, "cases", void 0);
        __decorate([core_1.Input(), __metadata('design:type', Number), __metadata('design:paramtypes', [Number])], NgPlural.prototype, "ngPlural", null);
        NgPlural = __decorate([core_1.Directive({ selector: '[ngPlural]' }), __metadata('design:paramtypes', [NgLocalization])], NgPlural);
        return NgPlural;
    }();
    exports.NgPlural = NgPlural;
});
System.registerDynamic('angular2/src/common/directives/core_directives.js', ['angular2/src/facade/lang.js', 'angular2/src/common/directives/ng_class.js', 'angular2/src/common/directives/ng_for.js', 'angular2/src/common/directives/ng_if.js', 'angular2/src/common/directives/ng_style.js', 'angular2/src/common/directives/ng_switch.js', 'angular2/src/common/directives/ng_plural.js'], true, function ($__require, exports, module) {
  'use strict';"use strict";

  var global = this || self,
      GLOBAL = global;
  var lang_1 = $__require('angular2/src/facade/lang.js');
  var ng_class_1 = $__require('angular2/src/common/directives/ng_class.js');
  var ng_for_1 = $__require('angular2/src/common/directives/ng_for.js');
  var ng_if_1 = $__require('angular2/src/common/directives/ng_if.js');
  var ng_style_1 = $__require('angular2/src/common/directives/ng_style.js');
  var ng_switch_1 = $__require('angular2/src/common/directives/ng_switch.js');
  var ng_plural_1 = $__require('angular2/src/common/directives/ng_plural.js');
  /**
   * A collection of Angular core directives that are likely to be used in each and every Angular
   * application.
   *
   * This collection can be used to quickly enumerate all the built-in directives in the `directives`
   * property of the `@Component` annotation.
   *
   * ### Example ([live demo](http://plnkr.co/edit/yakGwpCdUkg0qfzX5m8g?p=preview))
   *
   * Instead of writing:
   *
   * ```typescript
   * import {NgClass, NgIf, NgFor, NgSwitch, NgSwitchWhen, NgSwitchDefault} from 'angular2/common';
   * import {OtherDirective} from './myDirectives';
   *
   * @Component({
   *   selector: 'my-component',
   *   templateUrl: 'myComponent.html',
   *   directives: [NgClass, NgIf, NgFor, NgSwitch, NgSwitchWhen, NgSwitchDefault, OtherDirective]
   * })
   * export class MyComponent {
   *   ...
   * }
   * ```
   * one could import all the core directives at once:
   *
   * ```typescript
   * import {CORE_DIRECTIVES} from 'angular2/common';
   * import {OtherDirective} from './myDirectives';
   *
   * @Component({
   *   selector: 'my-component',
   *   templateUrl: 'myComponent.html',
   *   directives: [CORE_DIRECTIVES, OtherDirective]
   * })
   * export class MyComponent {
   *   ...
   * }
   * ```
   */
  exports.CORE_DIRECTIVES = lang_1.CONST_EXPR([ng_class_1.NgClass, ng_for_1.NgFor, ng_if_1.NgIf, ng_style_1.NgStyle, ng_switch_1.NgSwitch, ng_switch_1.NgSwitchWhen, ng_switch_1.NgSwitchDefault, ng_plural_1.NgPlural, ng_plural_1.NgPluralCase]);
});
System.registerDynamic('angular2/src/common/directives.js', ['angular2/src/common/directives/ng_class.js', 'angular2/src/common/directives/ng_for.js', 'angular2/src/common/directives/ng_if.js', 'angular2/src/common/directives/ng_style.js', 'angular2/src/common/directives/ng_switch.js', 'angular2/src/common/directives/ng_plural.js', 'angular2/src/common/directives/observable_list_diff.js', 'angular2/src/common/directives/core_directives.js'], true, function ($__require, exports, module) {
  'use strict';"use strict";

  var global = this || self,
      GLOBAL = global;
  function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
  /**
   * @module
   * @description
   * Common directives shipped with Angular.
   */
  var ng_class_1 = $__require('angular2/src/common/directives/ng_class.js');
  exports.NgClass = ng_class_1.NgClass;
  var ng_for_1 = $__require('angular2/src/common/directives/ng_for.js');
  exports.NgFor = ng_for_1.NgFor;
  var ng_if_1 = $__require('angular2/src/common/directives/ng_if.js');
  exports.NgIf = ng_if_1.NgIf;
  var ng_style_1 = $__require('angular2/src/common/directives/ng_style.js');
  exports.NgStyle = ng_style_1.NgStyle;
  var ng_switch_1 = $__require('angular2/src/common/directives/ng_switch.js');
  exports.NgSwitch = ng_switch_1.NgSwitch;
  exports.NgSwitchWhen = ng_switch_1.NgSwitchWhen;
  exports.NgSwitchDefault = ng_switch_1.NgSwitchDefault;
  var ng_plural_1 = $__require('angular2/src/common/directives/ng_plural.js');
  exports.NgPlural = ng_plural_1.NgPlural;
  exports.NgPluralCase = ng_plural_1.NgPluralCase;
  exports.NgLocalization = ng_plural_1.NgLocalization;
  __export($__require('angular2/src/common/directives/observable_list_diff.js'));
  var core_directives_1 = $__require('angular2/src/common/directives/core_directives.js');
  exports.CORE_DIRECTIVES = core_directives_1.CORE_DIRECTIVES;
});
System.registerDynamic('angular2/src/common/common_directives.js', ['angular2/src/facade/lang.js', 'angular2/src/common/forms.js', 'angular2/src/common/directives.js'], true, function ($__require, exports, module) {
  'use strict';"use strict";

  var global = this || self,
      GLOBAL = global;
  var lang_1 = $__require('angular2/src/facade/lang.js');
  var forms_1 = $__require('angular2/src/common/forms.js');
  var directives_1 = $__require('angular2/src/common/directives.js');
  /**
   * A collection of Angular core directives that are likely to be used in each and every Angular
   * application. This includes core directives (e.g., NgIf and NgFor), and forms directives (e.g.,
   * NgModel).
   *
   * This collection can be used to quickly enumerate all the built-in directives in the `directives`
   * property of the `@Component` decorator.
   *
   * ### Example
   *
   * Instead of writing:
   *
   * ```typescript
   * import {NgClass, NgIf, NgFor, NgSwitch, NgSwitchWhen, NgSwitchDefault, NgModel, NgForm} from
   * 'angular2/common';
   * import {OtherDirective} from './myDirectives';
   *
   * @Component({
   *   selector: 'my-component',
   *   templateUrl: 'myComponent.html',
   *   directives: [NgClass, NgIf, NgFor, NgSwitch, NgSwitchWhen, NgSwitchDefault, NgModel, NgForm,
   * OtherDirective]
   * })
   * export class MyComponent {
   *   ...
   * }
   * ```
   * one could import all the common directives at once:
   *
   * ```typescript
   * import {COMMON_DIRECTIVES} from 'angular2/common';
   * import {OtherDirective} from './myDirectives';
   *
   * @Component({
   *   selector: 'my-component',
   *   templateUrl: 'myComponent.html',
   *   directives: [COMMON_DIRECTIVES, OtherDirective]
   * })
   * export class MyComponent {
   *   ...
   * }
   * ```
   */
  exports.COMMON_DIRECTIVES = lang_1.CONST_EXPR([directives_1.CORE_DIRECTIVES, forms_1.FORM_DIRECTIVES]);
});
System.registerDynamic('angular2/common.js', ['angular2/src/common/pipes.js', 'angular2/src/common/directives.js', 'angular2/src/common/forms.js', 'angular2/src/common/common_directives.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    function __export(m) {
        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }
    __export($__require('angular2/src/common/pipes.js'));
    __export($__require('angular2/src/common/directives.js'));
    __export($__require('angular2/src/common/forms.js'));
    __export($__require('angular2/src/common/common_directives.js'));
});
(function() {
var define = System.amdDefine;
(function defineMustache(global, factory) {
  if (typeof exports === 'object' && exports && typeof exports.nodeName !== 'string') {
    factory(exports);
  } else if (typeof define === 'function' && define.amd) {
    define("mustache/mustache.js", ["exports"], factory);
  } else {
    global.Mustache = {};
    factory(global.Mustache);
  }
}(this, function mustacheFactory(mustache) {
  var objectToString = Object.prototype.toString;
  var isArray = Array.isArray || function isArrayPolyfill(object) {
    return objectToString.call(object) === '[object Array]';
  };
  function isFunction(object) {
    return typeof object === 'function';
  }
  function typeStr(obj) {
    return isArray(obj) ? 'array' : typeof obj;
  }
  function escapeRegExp(string) {
    return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&');
  }
  function hasProperty(obj, propName) {
    return obj != null && typeof obj === 'object' && (propName in obj);
  }
  var regExpTest = RegExp.prototype.test;
  function testRegExp(re, string) {
    return regExpTest.call(re, string);
  }
  var nonSpaceRe = /\S/;
  function isWhitespace(string) {
    return !testRegExp(nonSpaceRe, string);
  }
  var entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;',
    '`': '&#x60;',
    '=': '&#x3D;'
  };
  function escapeHtml(string) {
    return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap(s) {
      return entityMap[s];
    });
  }
  var whiteRe = /\s*/;
  var spaceRe = /\s+/;
  var equalsRe = /\s*=/;
  var curlyRe = /\s*\}/;
  var tagRe = /#|\^|\/|>|\{|&|=|!/;
  function parseTemplate(template, tags) {
    if (!template)
      return [];
    var sections = [];
    var tokens = [];
    var spaces = [];
    var hasTag = false;
    var nonSpace = false;
    function stripSpace() {
      if (hasTag && !nonSpace) {
        while (spaces.length)
          delete tokens[spaces.pop()];
      } else {
        spaces = [];
      }
      hasTag = false;
      nonSpace = false;
    }
    var openingTagRe,
        closingTagRe,
        closingCurlyRe;
    function compileTags(tagsToCompile) {
      if (typeof tagsToCompile === 'string')
        tagsToCompile = tagsToCompile.split(spaceRe, 2);
      if (!isArray(tagsToCompile) || tagsToCompile.length !== 2)
        throw new Error('Invalid tags: ' + tagsToCompile);
      openingTagRe = new RegExp(escapeRegExp(tagsToCompile[0]) + '\\s*');
      closingTagRe = new RegExp('\\s*' + escapeRegExp(tagsToCompile[1]));
      closingCurlyRe = new RegExp('\\s*' + escapeRegExp('}' + tagsToCompile[1]));
    }
    compileTags(tags || mustache.tags);
    var scanner = new Scanner(template);
    var start,
        type,
        value,
        chr,
        token,
        openSection;
    while (!scanner.eos()) {
      start = scanner.pos;
      value = scanner.scanUntil(openingTagRe);
      if (value) {
        for (var i = 0,
            valueLength = value.length; i < valueLength; ++i) {
          chr = value.charAt(i);
          if (isWhitespace(chr)) {
            spaces.push(tokens.length);
          } else {
            nonSpace = true;
          }
          tokens.push(['text', chr, start, start + 1]);
          start += 1;
          if (chr === '\n')
            stripSpace();
        }
      }
      if (!scanner.scan(openingTagRe))
        break;
      hasTag = true;
      type = scanner.scan(tagRe) || 'name';
      scanner.scan(whiteRe);
      if (type === '=') {
        value = scanner.scanUntil(equalsRe);
        scanner.scan(equalsRe);
        scanner.scanUntil(closingTagRe);
      } else if (type === '{') {
        value = scanner.scanUntil(closingCurlyRe);
        scanner.scan(curlyRe);
        scanner.scanUntil(closingTagRe);
        type = '&';
      } else {
        value = scanner.scanUntil(closingTagRe);
      }
      if (!scanner.scan(closingTagRe))
        throw new Error('Unclosed tag at ' + scanner.pos);
      token = [type, value, start, scanner.pos];
      tokens.push(token);
      if (type === '#' || type === '^') {
        sections.push(token);
      } else if (type === '/') {
        openSection = sections.pop();
        if (!openSection)
          throw new Error('Unopened section "' + value + '" at ' + start);
        if (openSection[1] !== value)
          throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
      } else if (type === 'name' || type === '{' || type === '&') {
        nonSpace = true;
      } else if (type === '=') {
        compileTags(value);
      }
    }
    openSection = sections.pop();
    if (openSection)
      throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);
    return nestTokens(squashTokens(tokens));
  }
  function squashTokens(tokens) {
    var squashedTokens = [];
    var token,
        lastToken;
    for (var i = 0,
        numTokens = tokens.length; i < numTokens; ++i) {
      token = tokens[i];
      if (token) {
        if (token[0] === 'text' && lastToken && lastToken[0] === 'text') {
          lastToken[1] += token[1];
          lastToken[3] = token[3];
        } else {
          squashedTokens.push(token);
          lastToken = token;
        }
      }
    }
    return squashedTokens;
  }
  function nestTokens(tokens) {
    var nestedTokens = [];
    var collector = nestedTokens;
    var sections = [];
    var token,
        section;
    for (var i = 0,
        numTokens = tokens.length; i < numTokens; ++i) {
      token = tokens[i];
      switch (token[0]) {
        case '#':
        case '^':
          collector.push(token);
          sections.push(token);
          collector = token[4] = [];
          break;
        case '/':
          section = sections.pop();
          section[5] = token[2];
          collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
          break;
        default:
          collector.push(token);
      }
    }
    return nestedTokens;
  }
  function Scanner(string) {
    this.string = string;
    this.tail = string;
    this.pos = 0;
  }
  Scanner.prototype.eos = function eos() {
    return this.tail === '';
  };
  Scanner.prototype.scan = function scan(re) {
    var match = this.tail.match(re);
    if (!match || match.index !== 0)
      return '';
    var string = match[0];
    this.tail = this.tail.substring(string.length);
    this.pos += string.length;
    return string;
  };
  Scanner.prototype.scanUntil = function scanUntil(re) {
    var index = this.tail.search(re),
        match;
    switch (index) {
      case -1:
        match = this.tail;
        this.tail = '';
        break;
      case 0:
        match = '';
        break;
      default:
        match = this.tail.substring(0, index);
        this.tail = this.tail.substring(index);
    }
    this.pos += match.length;
    return match;
  };
  function Context(view, parentContext) {
    this.view = view;
    this.cache = {'.': this.view};
    this.parent = parentContext;
  }
  Context.prototype.push = function push(view) {
    return new Context(view, this);
  };
  Context.prototype.lookup = function lookup(name) {
    var cache = this.cache;
    var value;
    if (cache.hasOwnProperty(name)) {
      value = cache[name];
    } else {
      var context = this,
          names,
          index,
          lookupHit = false;
      while (context) {
        if (name.indexOf('.') > 0) {
          value = context.view;
          names = name.split('.');
          index = 0;
          while (value != null && index < names.length) {
            if (index === names.length - 1)
              lookupHit = hasProperty(value, names[index]);
            value = value[names[index++]];
          }
        } else {
          value = context.view[name];
          lookupHit = hasProperty(context.view, name);
        }
        if (lookupHit)
          break;
        context = context.parent;
      }
      cache[name] = value;
    }
    if (isFunction(value))
      value = value.call(this.view);
    return value;
  };
  function Writer() {
    this.cache = {};
  }
  Writer.prototype.clearCache = function clearCache() {
    this.cache = {};
  };
  Writer.prototype.parse = function parse(template, tags) {
    var cache = this.cache;
    var tokens = cache[template];
    if (tokens == null)
      tokens = cache[template] = parseTemplate(template, tags);
    return tokens;
  };
  Writer.prototype.render = function render(template, view, partials) {
    var tokens = this.parse(template);
    var context = (view instanceof Context) ? view : new Context(view);
    return this.renderTokens(tokens, context, partials, template);
  };
  Writer.prototype.renderTokens = function renderTokens(tokens, context, partials, originalTemplate) {
    var buffer = '';
    var token,
        symbol,
        value;
    for (var i = 0,
        numTokens = tokens.length; i < numTokens; ++i) {
      value = undefined;
      token = tokens[i];
      symbol = token[0];
      if (symbol === '#')
        value = this.renderSection(token, context, partials, originalTemplate);
      else if (symbol === '^')
        value = this.renderInverted(token, context, partials, originalTemplate);
      else if (symbol === '>')
        value = this.renderPartial(token, context, partials, originalTemplate);
      else if (symbol === '&')
        value = this.unescapedValue(token, context);
      else if (symbol === 'name')
        value = this.escapedValue(token, context);
      else if (symbol === 'text')
        value = this.rawValue(token);
      if (value !== undefined)
        buffer += value;
    }
    return buffer;
  };
  Writer.prototype.renderSection = function renderSection(token, context, partials, originalTemplate) {
    var self = this;
    var buffer = '';
    var value = context.lookup(token[1]);
    function subRender(template) {
      return self.render(template, context, partials);
    }
    if (!value)
      return;
    if (isArray(value)) {
      for (var j = 0,
          valueLength = value.length; j < valueLength; ++j) {
        buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate);
      }
    } else if (typeof value === 'object' || typeof value === 'string' || typeof value === 'number') {
      buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate);
    } else if (isFunction(value)) {
      if (typeof originalTemplate !== 'string')
        throw new Error('Cannot use higher-order sections without the original template');
      value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);
      if (value != null)
        buffer += value;
    } else {
      buffer += this.renderTokens(token[4], context, partials, originalTemplate);
    }
    return buffer;
  };
  Writer.prototype.renderInverted = function renderInverted(token, context, partials, originalTemplate) {
    var value = context.lookup(token[1]);
    if (!value || (isArray(value) && value.length === 0))
      return this.renderTokens(token[4], context, partials, originalTemplate);
  };
  Writer.prototype.renderPartial = function renderPartial(token, context, partials) {
    if (!partials)
      return;
    var value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
    if (value != null)
      return this.renderTokens(this.parse(value), context, partials, value);
  };
  Writer.prototype.unescapedValue = function unescapedValue(token, context) {
    var value = context.lookup(token[1]);
    if (value != null)
      return value;
  };
  Writer.prototype.escapedValue = function escapedValue(token, context) {
    var value = context.lookup(token[1]);
    if (value != null)
      return mustache.escape(value);
  };
  Writer.prototype.rawValue = function rawValue(token) {
    return token[1];
  };
  mustache.name = 'mustache.js';
  mustache.version = '2.2.1';
  mustache.tags = ['{{', '}}'];
  var defaultWriter = new Writer();
  mustache.clearCache = function clearCache() {
    return defaultWriter.clearCache();
  };
  mustache.parse = function parse(template, tags) {
    return defaultWriter.parse(template, tags);
  };
  mustache.render = function render(template, view, partials) {
    if (typeof template !== 'string') {
      throw new TypeError('Invalid template! Template should be a "string" ' + 'but "' + typeStr(template) + '" was given as the first ' + 'argument for mustache#render(template, view, partials)');
    }
    return defaultWriter.render(template, view, partials);
  };
  mustache.to_html = function to_html(template, view, partials, send) {
    var result = mustache.render(template, view, partials);
    if (isFunction(send)) {
      send(result);
    } else {
      return result;
    }
  };
  mustache.escape = escapeHtml;
  mustache.Scanner = Scanner;
  mustache.Context = Context;
  mustache.Writer = Writer;
}));

})();
System.register("ags-client/gen/viewmodels/remote_translation_view_model.js", ["ags-client/app/commons/lang.js"], function (exports_1, context_1) {
    "use strict";

    var lang_1, RemoteTranslationViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (lang_1_1) {
            lang_1 = lang_1_1;
        }],
        execute: function () {
            RemoteTranslationViewModel = /** @class */function () {
                function RemoteTranslationViewModel() {}
                RemoteTranslationViewModel.deserialize = function (object) {
                    var _result = new RemoteTranslationViewModel();
                    return _result._deserialize(object);
                };
                RemoteTranslationViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (lang_1.isPresent(object['key'])) {
                            this.key = object['key'];
                        }
                        if (lang_1.isPresent(object['value'])) {
                            this.value = object['value'];
                        }
                    }
                    return this;
                };
                RemoteTranslationViewModel.prototype.serialize = function () {
                    var object = {};
                    if (lang_1.isPresent(this.key)) {
                        object['key'] = this.key;
                    }
                    if (lang_1.isPresent(this.value)) {
                        object['value'] = this.value;
                    }
                    return object;
                };
                RemoteTranslationViewModel.KEY_VALIDATORS = [];
                RemoteTranslationViewModel.VALUE_VALIDATORS = [];
                return RemoteTranslationViewModel;
            }();
            exports_1("RemoteTranslationViewModel", RemoteTranslationViewModel);
        }
    };
});

System.register("ags-client/gen/services/abstract_translation_service.js", ["ags-client/app/models/json_response.js", "ags-client/gen/viewmodels/remote_translation_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var json_response_1, remote_translation_view_model_1, AbstractTranslationService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (json_response_1_1) {
            json_response_1 = json_response_1_1;
        }, function (remote_translation_view_model_1_1) {
            remote_translation_view_model_1 = remote_translation_view_model_1_1;
        }],
        execute: function () {
            AbstractTranslationService = /** @class */function () {
                function AbstractTranslationService(backendService) {
                    this.backendService = backendService;
                }
                AbstractTranslationService.prototype.translations = function (request) {
                    return this.backendService.postJson('/translation/translations.json', request.serialize(), function (response) {
                        var data = Array();
                        response.data.forEach(function (item) {
                            data.push(remote_translation_view_model_1.RemoteTranslationViewModel.deserialize(item));
                        });
                        return json_response_1.JsonResponse.deserialize(response, data);
                    });
                };
                return AbstractTranslationService;
            }();
            exports_1("AbstractTranslationService", AbstractTranslationService);
        }
    };
});

System.registerDynamic('rxjs/observable/BoundCallbackObservable.js', ['rxjs/Observable.js', 'rxjs/util/tryCatch.js', 'rxjs/util/errorObject.js', 'rxjs/AsyncSubject.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Observable_1 = $__require('rxjs/Observable.js');
    var tryCatch_1 = $__require('rxjs/util/tryCatch.js');
    var errorObject_1 = $__require('rxjs/util/errorObject.js');
    var AsyncSubject_1 = $__require('rxjs/AsyncSubject.js');
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @extends {Ignored}
     * @hide true
     */
    var BoundCallbackObservable = function (_super) {
        __extends(BoundCallbackObservable, _super);
        function BoundCallbackObservable(callbackFunc, selector, args, context, scheduler) {
            _super.call(this);
            this.callbackFunc = callbackFunc;
            this.selector = selector;
            this.args = args;
            this.context = context;
            this.scheduler = scheduler;
        }
        /* tslint:enable:max-line-length */
        /**
         * Converts a callback API to a function that returns an Observable.
         *
         * <span class="informal">Give it a function `f` of type `f(x, callback)` and
         * it will return a function `g` that when called as `g(x)` will output an
         * Observable.</span>
         *
         * `bindCallback` is not an operator because its input and output are not
         * Observables. The input is a function `func` with some parameters, the
         * last parameter must be a callback function that `func` calls when it is
         * done.
         *
         * The output of `bindCallback` is a function that takes the same parameters
         * as `func`, except the last one (the callback). When the output function
         * is called with arguments it will return an Observable. If function `func`
         * calls its callback with one argument the Observable will emit that value.
         * If on the other hand the callback is called with multiple values the resulting
         * Observable will emit an array with said values as arguments.
         *
         * It is very important to remember that input function `func` is not called
         * when the output function is, but rather when the Observable returned by the output
         * function is subscribed. This means if `func` makes an AJAX request, that request
         * will be made every time someone subscribes to the resulting Observable, but not before.
         *
         * Optionally, a selector function can be passed to `bindObservable`. The selector function
         * takes the same arguments as the callback and returns the value that will be emitted by the Observable.
         * Even though by default multiple arguments passed to callback appear in the stream as an array
         * the selector function will be called with arguments directly, just as the callback would.
         * This means you can imagine the default selector (when one is not provided explicitly)
         * as a function that aggregates all its arguments into an array, or simply returns first argument
         * if there is only one.
         *
         * The last optional parameter - {@link Scheduler} - can be used to control when the call
         * to `func` happens after someone subscribes to Observable, as well as when results
         * passed to callback will be emitted. By default, the subscription to  an Observable calls `func`
         * synchronously, but using `Scheduler.async` as the last parameter will defer the call to `func`,
         * just like wrapping the call in `setTimeout` with a timeout of `0` would. If you use the async Scheduler
         * and call `subscribe` on the output Observable all function calls that are currently executing
         * will end before `func` is invoked.
         *
         * By default results passed to the callback are emitted immediately after `func` invokes the callback.
         * In particular, if the callback is called synchronously the subscription of the resulting Observable
         * will call the `next` function synchronously as well.  If you want to defer that call,
         * you may use `Scheduler.async` just as before.  This means that by using `Scheduler.async` you can
         * ensure that `func` always calls its callback asynchronously, thus avoiding terrifying Zalgo.
         *
         * Note that the Observable created by the output function will always emit a single value
         * and then complete immediately. If `func` calls the callback multiple times, values from subsequent
         * calls will not appear in the stream. If you need to listen for multiple calls,
         *  you probably want to use {@link fromEvent} or {@link fromEventPattern} instead.
         *
         * If `func` depends on some context (`this` property) and is not already bound the context of `func`
         * will be the context that the output function has at call time. In particular, if `func`
         * is called as a method of some objec and if `func` is not already bound, in order to preserve the context
         * it is recommended that the context of the output function is set to that object as well.
         *
         * If the input function calls its callback in the "node style" (i.e. first argument to callback is
         * optional error parameter signaling whether the call failed or not), {@link bindNodeCallback}
         * provides convenient error handling and probably is a better choice.
         * `bindCallback` will treat such functions the same as any other and error parameters
         * (whether passed or not) will always be interpreted as regular callback argument.
         *
         *
         * @example <caption>Convert jQuery's getJSON to an Observable API</caption>
         * // Suppose we have jQuery.getJSON('/my/url', callback)
         * var getJSONAsObservable = Rx.Observable.bindCallback(jQuery.getJSON);
         * var result = getJSONAsObservable('/my/url');
         * result.subscribe(x => console.log(x), e => console.error(e));
         *
         *
         * @example <caption>Receive an array of arguments passed to a callback</caption>
         * someFunction((a, b, c) => {
         *   console.log(a); // 5
         *   console.log(b); // 'some string'
         *   console.log(c); // {someProperty: 'someValue'}
         * });
         *
         * const boundSomeFunction = Rx.Observable.bindCallback(someFunction);
         * boundSomeFunction().subscribe(values => {
         *   console.log(values) // [5, 'some string', {someProperty: 'someValue'}]
         * });
         *
         *
         * @example <caption>Use bindCallback with a selector function</caption>
         * someFunction((a, b, c) => {
         *   console.log(a); // 'a'
         *   console.log(b); // 'b'
         *   console.log(c); // 'c'
         * });
         *
         * const boundSomeFunction = Rx.Observable.bindCallback(someFunction, (a, b, c) => a + b + c);
         * boundSomeFunction().subscribe(value => {
         *   console.log(value) // 'abc'
         * });
         *
         *
         * @example <caption>Compare behaviour with and without async Scheduler</caption>
         * function iCallMyCallbackSynchronously(cb) {
         *   cb();
         * }
         *
         * const boundSyncFn = Rx.Observable.bindCallback(iCallMyCallbackSynchronously);
         * const boundAsyncFn = Rx.Observable.bindCallback(iCallMyCallbackSynchronously, null, Rx.Scheduler.async);
         *
         * boundSyncFn().subscribe(() => console.log('I was sync!'));
         * boundAsyncFn().subscribe(() => console.log('I was async!'));
         * console.log('This happened...');
         *
         * // Logs:
         * // I was sync!
         * // This happened...
         * // I was async!
         *
         *
         * @example <caption>Use bindCallback on an object method</caption>
         * const boundMethod = Rx.Observable.bindCallback(someObject.methodWithCallback);
         * boundMethod.call(someObject) // make sure methodWithCallback has access to someObject
         * .subscribe(subscriber);
         *
         *
         * @see {@link bindNodeCallback}
         * @see {@link from}
         * @see {@link fromPromise}
         *
         * @param {function} func A function with a callback as the last parameter.
         * @param {function} [selector] A function which takes the arguments from the
         * callback and maps them to a value that is emitted on the output Observable.
         * @param {Scheduler} [scheduler] The scheduler on which to schedule the
         * callbacks.
         * @return {function(...params: *): Observable} A function which returns the
         * Observable that delivers the same values the callback would deliver.
         * @static true
         * @name bindCallback
         * @owner Observable
         */
        BoundCallbackObservable.create = function (func, selector, scheduler) {
            if (selector === void 0) {
                selector = undefined;
            }
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i - 0] = arguments[_i];
                }
                return new BoundCallbackObservable(func, selector, args, this, scheduler);
            };
        };
        /** @deprecated internal use only */BoundCallbackObservable.prototype._subscribe = function (subscriber) {
            var callbackFunc = this.callbackFunc;
            var args = this.args;
            var scheduler = this.scheduler;
            var subject = this.subject;
            if (!scheduler) {
                if (!subject) {
                    subject = this.subject = new AsyncSubject_1.AsyncSubject();
                    var handler = function handlerFn() {
                        var innerArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            innerArgs[_i - 0] = arguments[_i];
                        }
                        var source = handlerFn.source;
                        var selector = source.selector,
                            subject = source.subject;
                        if (selector) {
                            var result_1 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
                            if (result_1 === errorObject_1.errorObject) {
                                subject.error(errorObject_1.errorObject.e);
                            } else {
                                subject.next(result_1);
                                subject.complete();
                            }
                        } else {
                            subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                            subject.complete();
                        }
                    };
                    // use named function instance to avoid closure.
                    handler.source = this;
                    var result = tryCatch_1.tryCatch(callbackFunc).apply(this.context, args.concat(handler));
                    if (result === errorObject_1.errorObject) {
                        subject.error(errorObject_1.errorObject.e);
                    }
                }
                return subject.subscribe(subscriber);
            } else {
                return scheduler.schedule(BoundCallbackObservable.dispatch, 0, { source: this, subscriber: subscriber, context: this.context });
            }
        };
        BoundCallbackObservable.dispatch = function (state) {
            var self = this;
            var source = state.source,
                subscriber = state.subscriber,
                context = state.context;
            var callbackFunc = source.callbackFunc,
                args = source.args,
                scheduler = source.scheduler;
            var subject = source.subject;
            if (!subject) {
                subject = source.subject = new AsyncSubject_1.AsyncSubject();
                var handler = function handlerFn() {
                    var innerArgs = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        innerArgs[_i - 0] = arguments[_i];
                    }
                    var source = handlerFn.source;
                    var selector = source.selector,
                        subject = source.subject;
                    if (selector) {
                        var result_2 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
                        if (result_2 === errorObject_1.errorObject) {
                            self.add(scheduler.schedule(dispatchError, 0, { err: errorObject_1.errorObject.e, subject: subject }));
                        } else {
                            self.add(scheduler.schedule(dispatchNext, 0, { value: result_2, subject: subject }));
                        }
                    } else {
                        var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
                        self.add(scheduler.schedule(dispatchNext, 0, { value: value, subject: subject }));
                    }
                };
                // use named function to pass values in without closure
                handler.source = source;
                var result = tryCatch_1.tryCatch(callbackFunc).apply(context, args.concat(handler));
                if (result === errorObject_1.errorObject) {
                    subject.error(errorObject_1.errorObject.e);
                }
            }
            self.add(subject.subscribe(subscriber));
        };
        return BoundCallbackObservable;
    }(Observable_1.Observable);
    exports.BoundCallbackObservable = BoundCallbackObservable;
    function dispatchNext(arg) {
        var value = arg.value,
            subject = arg.subject;
        subject.next(value);
        subject.complete();
    }
    function dispatchError(arg) {
        var err = arg.err,
            subject = arg.subject;
        subject.error(err);
    }
    
});
System.registerDynamic("rxjs/observable/bindCallback.js", ["rxjs/observable/BoundCallbackObservable.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var BoundCallbackObservable_1 = $__require("rxjs/observable/BoundCallbackObservable.js");
  exports.bindCallback = BoundCallbackObservable_1.BoundCallbackObservable.create;
  
});
System.registerDynamic('rxjs/add/observable/bindCallback.js', ['rxjs/Observable.js', 'rxjs/observable/bindCallback.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var bindCallback_1 = $__require('rxjs/observable/bindCallback.js');
  Observable_1.Observable.bindCallback = bindCallback_1.bindCallback;
  
});
System.registerDynamic('rxjs/observable/BoundNodeCallbackObservable.js', ['rxjs/Observable.js', 'rxjs/util/tryCatch.js', 'rxjs/util/errorObject.js', 'rxjs/AsyncSubject.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Observable_1 = $__require('rxjs/Observable.js');
    var tryCatch_1 = $__require('rxjs/util/tryCatch.js');
    var errorObject_1 = $__require('rxjs/util/errorObject.js');
    var AsyncSubject_1 = $__require('rxjs/AsyncSubject.js');
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @extends {Ignored}
     * @hide true
     */
    var BoundNodeCallbackObservable = function (_super) {
        __extends(BoundNodeCallbackObservable, _super);
        function BoundNodeCallbackObservable(callbackFunc, selector, args, context, scheduler) {
            _super.call(this);
            this.callbackFunc = callbackFunc;
            this.selector = selector;
            this.args = args;
            this.context = context;
            this.scheduler = scheduler;
        }
        /* tslint:enable:max-line-length */
        /**
         * Converts a Node.js-style callback API to a function that returns an
         * Observable.
         *
         * <span class="informal">It's just like {@link bindCallback}, but the
         * callback is expected to be of type `callback(error, result)`.</span>
         *
         * `bindNodeCallback` is not an operator because its input and output are not
         * Observables. The input is a function `func` with some parameters, but the
         * last parameter must be a callback function that `func` calls when it is
         * done. The callback function is expected to follow Node.js conventions,
         * where the first argument to the callback is an error object, signaling
         * whether call was successful. If that object is passed to callback, it means
         * something went wrong.
         *
         * The output of `bindNodeCallback` is a function that takes the same
         * parameters as `func`, except the last one (the callback). When the output
         * function is called with arguments, it will return an Observable.
         * If `func` calls its callback with error parameter present, Observable will
         * error with that value as well. If error parameter is not passed, Observable will emit
         * second parameter. If there are more parameters (third and so on),
         * Observable will emit an array with all arguments, except first error argument.
         *
         * Optionally `bindNodeCallback` accepts selector function, which allows you to
         * make resulting Observable emit value computed by selector, instead of regular
         * callback arguments. It works similarly to {@link bindCallback} selector, but
         * Node.js-style error argument will never be passed to that function.
         *
         * Note that `func` will not be called at the same time output function is,
         * but rather whenever resulting Observable is subscribed. By default call to
         * `func` will happen synchronously after subscription, but that can be changed
         * with proper {@link Scheduler} provided as optional third parameter. Scheduler
         * can also control when values from callback will be emitted by Observable.
         * To find out more, check out documentation for {@link bindCallback}, where
         * Scheduler works exactly the same.
         *
         * As in {@link bindCallback}, context (`this` property) of input function will be set to context
         * of returned function, when it is called.
         *
         * After Observable emits value, it will complete immediately. This means
         * even if `func` calls callback again, values from second and consecutive
         * calls will never appear on the stream. If you need to handle functions
         * that call callbacks multiple times, check out {@link fromEvent} or
         * {@link fromEventPattern} instead.
         *
         * Note that `bindNodeCallback` can be used in non-Node.js environments as well.
         * "Node.js-style" callbacks are just a convention, so if you write for
         * browsers or any other environment and API you use implements that callback style,
         * `bindNodeCallback` can be safely used on that API functions as well.
         *
         * Remember that Error object passed to callback does not have to be an instance
         * of JavaScript built-in `Error` object. In fact, it does not even have to an object.
         * Error parameter of callback function is interpreted as "present", when value
         * of that parameter is truthy. It could be, for example, non-zero number, non-empty
         * string or boolean `true`. In all of these cases resulting Observable would error
         * with that value. This means usually regular style callbacks will fail very often when
         * `bindNodeCallback` is used. If your Observable errors much more often then you
         * would expect, check if callback really is called in Node.js-style and, if not,
         * switch to {@link bindCallback} instead.
         *
         * Note that even if error parameter is technically present in callback, but its value
         * is falsy, it still won't appear in array emitted by Observable or in selector function.
         *
         *
         * @example <caption>Read a file from the filesystem and get the data as an Observable</caption>
         * import * as fs from 'fs';
         * var readFileAsObservable = Rx.Observable.bindNodeCallback(fs.readFile);
         * var result = readFileAsObservable('./roadNames.txt', 'utf8');
         * result.subscribe(x => console.log(x), e => console.error(e));
         *
         *
         * @example <caption>Use on function calling callback with multiple arguments</caption>
         * someFunction((err, a, b) => {
         *   console.log(err); // null
         *   console.log(a); // 5
         *   console.log(b); // "some string"
         * });
         * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction);
         * boundSomeFunction()
         * .subscribe(value => {
         *   console.log(value); // [5, "some string"]
         * });
         *
         *
         * @example <caption>Use with selector function</caption>
         * someFunction((err, a, b) => {
         *   console.log(err); // undefined
         *   console.log(a); // "abc"
         *   console.log(b); // "DEF"
         * });
         * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction, (a, b) => a + b);
         * boundSomeFunction()
         * .subscribe(value => {
         *   console.log(value); // "abcDEF"
         * });
         *
         *
         * @example <caption>Use on function calling callback in regular style</caption>
         * someFunction(a => {
         *   console.log(a); // 5
         * });
         * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction);
         * boundSomeFunction()
         * .subscribe(
         *   value => {}             // never gets called
         *   err => console.log(err) // 5
         *);
         *
         *
         * @see {@link bindCallback}
         * @see {@link from}
         * @see {@link fromPromise}
         *
         * @param {function} func Function with a Node.js-style callback as the last parameter.
         * @param {function} [selector] A function which takes the arguments from the
         * callback and maps those to a value to emit on the output Observable.
         * @param {Scheduler} [scheduler] The scheduler on which to schedule the
         * callbacks.
         * @return {function(...params: *): Observable} A function which returns the
         * Observable that delivers the same values the Node.js callback would
         * deliver.
         * @static true
         * @name bindNodeCallback
         * @owner Observable
         */
        BoundNodeCallbackObservable.create = function (func, selector, scheduler) {
            if (selector === void 0) {
                selector = undefined;
            }
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i - 0] = arguments[_i];
                }
                return new BoundNodeCallbackObservable(func, selector, args, this, scheduler);
            };
        };
        /** @deprecated internal use only */BoundNodeCallbackObservable.prototype._subscribe = function (subscriber) {
            var callbackFunc = this.callbackFunc;
            var args = this.args;
            var scheduler = this.scheduler;
            var subject = this.subject;
            if (!scheduler) {
                if (!subject) {
                    subject = this.subject = new AsyncSubject_1.AsyncSubject();
                    var handler = function handlerFn() {
                        var innerArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            innerArgs[_i - 0] = arguments[_i];
                        }
                        var source = handlerFn.source;
                        var selector = source.selector,
                            subject = source.subject;
                        var err = innerArgs.shift();
                        if (err) {
                            subject.error(err);
                        } else if (selector) {
                            var result_1 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
                            if (result_1 === errorObject_1.errorObject) {
                                subject.error(errorObject_1.errorObject.e);
                            } else {
                                subject.next(result_1);
                                subject.complete();
                            }
                        } else {
                            subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                            subject.complete();
                        }
                    };
                    // use named function instance to avoid closure.
                    handler.source = this;
                    var result = tryCatch_1.tryCatch(callbackFunc).apply(this.context, args.concat(handler));
                    if (result === errorObject_1.errorObject) {
                        subject.error(errorObject_1.errorObject.e);
                    }
                }
                return subject.subscribe(subscriber);
            } else {
                return scheduler.schedule(dispatch, 0, { source: this, subscriber: subscriber, context: this.context });
            }
        };
        return BoundNodeCallbackObservable;
    }(Observable_1.Observable);
    exports.BoundNodeCallbackObservable = BoundNodeCallbackObservable;
    function dispatch(state) {
        var self = this;
        var source = state.source,
            subscriber = state.subscriber,
            context = state.context;
        // XXX: cast to `any` to access to the private field in `source`.
        var _a = source,
            callbackFunc = _a.callbackFunc,
            args = _a.args,
            scheduler = _a.scheduler;
        var subject = source.subject;
        if (!subject) {
            subject = source.subject = new AsyncSubject_1.AsyncSubject();
            var handler = function handlerFn() {
                var innerArgs = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    innerArgs[_i - 0] = arguments[_i];
                }
                var source = handlerFn.source;
                var selector = source.selector,
                    subject = source.subject;
                var err = innerArgs.shift();
                if (err) {
                    self.add(scheduler.schedule(dispatchError, 0, { err: err, subject: subject }));
                } else if (selector) {
                    var result_2 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
                    if (result_2 === errorObject_1.errorObject) {
                        self.add(scheduler.schedule(dispatchError, 0, { err: errorObject_1.errorObject.e, subject: subject }));
                    } else {
                        self.add(scheduler.schedule(dispatchNext, 0, { value: result_2, subject: subject }));
                    }
                } else {
                    var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
                    self.add(scheduler.schedule(dispatchNext, 0, { value: value, subject: subject }));
                }
            };
            // use named function to pass values in without closure
            handler.source = source;
            var result = tryCatch_1.tryCatch(callbackFunc).apply(context, args.concat(handler));
            if (result === errorObject_1.errorObject) {
                self.add(scheduler.schedule(dispatchError, 0, { err: errorObject_1.errorObject.e, subject: subject }));
            }
        }
        self.add(subject.subscribe(subscriber));
    }
    function dispatchNext(arg) {
        var value = arg.value,
            subject = arg.subject;
        subject.next(value);
        subject.complete();
    }
    function dispatchError(arg) {
        var err = arg.err,
            subject = arg.subject;
        subject.error(err);
    }
    
});
System.registerDynamic("rxjs/observable/bindNodeCallback.js", ["rxjs/observable/BoundNodeCallbackObservable.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var BoundNodeCallbackObservable_1 = $__require("rxjs/observable/BoundNodeCallbackObservable.js");
  exports.bindNodeCallback = BoundNodeCallbackObservable_1.BoundNodeCallbackObservable.create;
  
});
System.registerDynamic('rxjs/add/observable/bindNodeCallback.js', ['rxjs/Observable.js', 'rxjs/observable/bindNodeCallback.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var bindNodeCallback_1 = $__require('rxjs/observable/bindNodeCallback.js');
  Observable_1.Observable.bindNodeCallback = bindNodeCallback_1.bindNodeCallback;
  
});
System.registerDynamic('rxjs/observable/combineLatest.js', ['rxjs/util/isScheduler.js', 'rxjs/util/isArray.js', 'rxjs/observable/ArrayObservable.js', 'rxjs/operators/combineLatest.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var isScheduler_1 = $__require('rxjs/util/isScheduler.js');
    var isArray_1 = $__require('rxjs/util/isArray.js');
    var ArrayObservable_1 = $__require('rxjs/observable/ArrayObservable.js');
    var combineLatest_1 = $__require('rxjs/operators/combineLatest.js');
    /* tslint:enable:max-line-length */
    /**
     * Combines multiple Observables to create an Observable whose values are
     * calculated from the latest values of each of its input Observables.
     *
     * <span class="informal">Whenever any input Observable emits a value, it
     * computes a formula using the latest values from all the inputs, then emits
     * the output of that formula.</span>
     *
     * <img src="./img/combineLatest.png" width="100%">
     *
     * `combineLatest` combines the values from all the Observables passed as
     * arguments. This is done by subscribing to each Observable in order and,
     * whenever any Observable emits, collecting an array of the most recent
     * values from each Observable. So if you pass `n` Observables to operator,
     * returned Observable will always emit an array of `n` values, in order
     * corresponding to order of passed Observables (value from the first Observable
     * on the first place and so on).
     *
     * Static version of `combineLatest` accepts either an array of Observables
     * or each Observable can be put directly as an argument. Note that array of
     * Observables is good choice, if you don't know beforehand how many Observables
     * you will combine. Passing empty array will result in Observable that
     * completes immediately.
     *
     * To ensure output array has always the same length, `combineLatest` will
     * actually wait for all input Observables to emit at least once,
     * before it starts emitting results. This means if some Observable emits
     * values before other Observables started emitting, all that values but last
     * will be lost. On the other hand, is some Observable does not emit value but
     * completes, resulting Observable will complete at the same moment without
     * emitting anything, since it will be now impossible to include value from
     * completed Observable in resulting array. Also, if some input Observable does
     * not emit any value and never completes, `combineLatest` will also never emit
     * and never complete, since, again, it will wait for all streams to emit some
     * value.
     *
     * If at least one Observable was passed to `combineLatest` and all passed Observables
     * emitted something, resulting Observable will complete when all combined
     * streams complete. So even if some Observable completes, result of
     * `combineLatest` will still emit values when other Observables do. In case
     * of completed Observable, its value from now on will always be the last
     * emitted value. On the other hand, if any Observable errors, `combineLatest`
     * will error immediately as well, and all other Observables will be unsubscribed.
     *
     * `combineLatest` accepts as optional parameter `project` function, which takes
     * as arguments all values that would normally be emitted by resulting Observable.
     * `project` can return any kind of value, which will be then emitted by Observable
     * instead of default array. Note that `project` does not take as argument that array
     * of values, but values themselves. That means default `project` can be imagined
     * as function that takes all its arguments and puts them into an array.
     *
     *
     * @example <caption>Combine two timer Observables</caption>
     * const firstTimer = Rx.Observable.timer(0, 1000); // emit 0, 1, 2... after every second, starting from now
     * const secondTimer = Rx.Observable.timer(500, 1000); // emit 0, 1, 2... after every second, starting 0,5s from now
     * const combinedTimers = Rx.Observable.combineLatest(firstTimer, secondTimer);
     * combinedTimers.subscribe(value => console.log(value));
     * // Logs
     * // [0, 0] after 0.5s
     * // [1, 0] after 1s
     * // [1, 1] after 1.5s
     * // [2, 1] after 2s
     *
     *
     * @example <caption>Combine an array of Observables</caption>
     * const observables = [1, 5, 10].map(
     *   n => Rx.Observable.of(n).delay(n * 1000).startWith(0) // emit 0 and then emit n after n seconds
     * );
     * const combined = Rx.Observable.combineLatest(observables);
     * combined.subscribe(value => console.log(value));
     * // Logs
     * // [0, 0, 0] immediately
     * // [1, 0, 0] after 1s
     * // [1, 5, 0] after 5s
     * // [1, 5, 10] after 10s
     *
     *
     * @example <caption>Use project function to dynamically calculate the Body-Mass Index</caption>
     * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
     * var height = Rx.Observable.of(1.76, 1.77, 1.78);
     * var bmi = Rx.Observable.combineLatest(weight, height, (w, h) => w / (h * h));
     * bmi.subscribe(x => console.log('BMI is ' + x));
     *
     * // With output to console:
     * // BMI is 24.212293388429753
     * // BMI is 23.93948099205209
     * // BMI is 23.671253629592222
     *
     *
     * @see {@link combineAll}
     * @see {@link merge}
     * @see {@link withLatestFrom}
     *
     * @param {ObservableInput} observable1 An input Observable to combine with other Observables.
     * @param {ObservableInput} observable2 An input Observable to combine with other Observables.
     * More than one input Observables may be given as arguments
     * or an array of Observables may be given as the first argument.
     * @param {function} [project] An optional function to project the values from
     * the combined latest values into a new value on the output Observable.
     * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
     * each input Observable.
     * @return {Observable} An Observable of projected values from the most recent
     * values from each input Observable, or an array of the most recent values from
     * each input Observable.
     * @static true
     * @name combineLatest
     * @owner Observable
     */
    function combineLatest() {
        var observables = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            observables[_i - 0] = arguments[_i];
        }
        var project = null;
        var scheduler = null;
        if (isScheduler_1.isScheduler(observables[observables.length - 1])) {
            scheduler = observables.pop();
        }
        if (typeof observables[observables.length - 1] === 'function') {
            project = observables.pop();
        }
        // if the first and only other argument besides the resultSelector is an array
        // assume it's been called with `combineLatest([obs1, obs2, obs3], project)`
        if (observables.length === 1 && isArray_1.isArray(observables[0])) {
            observables = observables[0];
        }
        return new ArrayObservable_1.ArrayObservable(observables, scheduler).lift(new combineLatest_1.CombineLatestOperator(project));
    }
    exports.combineLatest = combineLatest;
    
});
System.registerDynamic('rxjs/add/observable/combineLatest.js', ['rxjs/Observable.js', 'rxjs/observable/combineLatest.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var combineLatest_1 = $__require('rxjs/observable/combineLatest.js');
  Observable_1.Observable.combineLatest = combineLatest_1.combineLatest;
  
});
System.registerDynamic('rxjs/add/observable/concat.js', ['rxjs/Observable.js', 'rxjs/observable/concat.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var concat_1 = $__require('rxjs/observable/concat.js');
  Observable_1.Observable.concat = concat_1.concat;
  
});
System.registerDynamic('rxjs/observable/DeferObservable.js', ['rxjs/Observable.js', 'rxjs/util/subscribeToResult.js', 'rxjs/OuterSubscriber.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Observable_1 = $__require('rxjs/Observable.js');
    var subscribeToResult_1 = $__require('rxjs/util/subscribeToResult.js');
    var OuterSubscriber_1 = $__require('rxjs/OuterSubscriber.js');
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @extends {Ignored}
     * @hide true
     */
    var DeferObservable = function (_super) {
        __extends(DeferObservable, _super);
        function DeferObservable(observableFactory) {
            _super.call(this);
            this.observableFactory = observableFactory;
        }
        /**
         * Creates an Observable that, on subscribe, calls an Observable factory to
         * make an Observable for each new Observer.
         *
         * <span class="informal">Creates the Observable lazily, that is, only when it
         * is subscribed.
         * </span>
         *
         * <img src="./img/defer.png" width="100%">
         *
         * `defer` allows you to create the Observable only when the Observer
         * subscribes, and create a fresh Observable for each Observer. It waits until
         * an Observer subscribes to it, and then it generates an Observable,
         * typically with an Observable factory function. It does this afresh for each
         * subscriber, so although each subscriber may think it is subscribing to the
         * same Observable, in fact each subscriber gets its own individual
         * Observable.
         *
         * @example <caption>Subscribe to either an Observable of clicks or an Observable of interval, at random</caption>
         * var clicksOrInterval = Rx.Observable.defer(function () {
         *   if (Math.random() > 0.5) {
         *     return Rx.Observable.fromEvent(document, 'click');
         *   } else {
         *     return Rx.Observable.interval(1000);
         *   }
         * });
         * clicksOrInterval.subscribe(x => console.log(x));
         *
         * // Results in the following behavior:
         * // If the result of Math.random() is greater than 0.5 it will listen
         * // for clicks anywhere on the "document"; when document is clicked it
         * // will log a MouseEvent object to the console. If the result is less
         * // than 0.5 it will emit ascending numbers, one every second(1000ms).
         *
         * @see {@link create}
         *
         * @param {function(): SubscribableOrPromise} observableFactory The Observable
         * factory function to invoke for each Observer that subscribes to the output
         * Observable. May also return a Promise, which will be converted on the fly
         * to an Observable.
         * @return {Observable} An Observable whose Observers' subscriptions trigger
         * an invocation of the given Observable factory function.
         * @static true
         * @name defer
         * @owner Observable
         */
        DeferObservable.create = function (observableFactory) {
            return new DeferObservable(observableFactory);
        };
        /** @deprecated internal use only */DeferObservable.prototype._subscribe = function (subscriber) {
            return new DeferSubscriber(subscriber, this.observableFactory);
        };
        return DeferObservable;
    }(Observable_1.Observable);
    exports.DeferObservable = DeferObservable;
    var DeferSubscriber = function (_super) {
        __extends(DeferSubscriber, _super);
        function DeferSubscriber(destination, factory) {
            _super.call(this, destination);
            this.factory = factory;
            this.tryDefer();
        }
        DeferSubscriber.prototype.tryDefer = function () {
            try {
                this._callFactory();
            } catch (err) {
                this._error(err);
            }
        };
        DeferSubscriber.prototype._callFactory = function () {
            var result = this.factory();
            if (result) {
                this.add(subscribeToResult_1.subscribeToResult(this, result));
            }
        };
        return DeferSubscriber;
    }(OuterSubscriber_1.OuterSubscriber);
    
});
System.registerDynamic("rxjs/observable/defer.js", ["rxjs/observable/DeferObservable.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var DeferObservable_1 = $__require("rxjs/observable/DeferObservable.js");
  exports.defer = DeferObservable_1.DeferObservable.create;
  
});
System.registerDynamic('rxjs/add/observable/defer.js', ['rxjs/Observable.js', 'rxjs/observable/defer.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var defer_1 = $__require('rxjs/observable/defer.js');
  Observable_1.Observable.defer = defer_1.defer;
  
});
System.registerDynamic("rxjs/observable/empty.js", ["rxjs/observable/EmptyObservable.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var EmptyObservable_1 = $__require("rxjs/observable/EmptyObservable.js");
  exports.empty = EmptyObservable_1.EmptyObservable.create;
  
});
System.registerDynamic('rxjs/add/observable/empty.js', ['rxjs/Observable.js', 'rxjs/observable/empty.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var empty_1 = $__require('rxjs/observable/empty.js');
  Observable_1.Observable.empty = empty_1.empty;
  
});
System.registerDynamic('rxjs/observable/ForkJoinObservable.js', ['rxjs/Observable.js', 'rxjs/observable/EmptyObservable.js', 'rxjs/util/isArray.js', 'rxjs/util/subscribeToResult.js', 'rxjs/OuterSubscriber.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Observable_1 = $__require('rxjs/Observable.js');
    var EmptyObservable_1 = $__require('rxjs/observable/EmptyObservable.js');
    var isArray_1 = $__require('rxjs/util/isArray.js');
    var subscribeToResult_1 = $__require('rxjs/util/subscribeToResult.js');
    var OuterSubscriber_1 = $__require('rxjs/OuterSubscriber.js');
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @extends {Ignored}
     * @hide true
     */
    var ForkJoinObservable = function (_super) {
        __extends(ForkJoinObservable, _super);
        function ForkJoinObservable(sources, resultSelector) {
            _super.call(this);
            this.sources = sources;
            this.resultSelector = resultSelector;
        }
        /* tslint:enable:max-line-length */
        /**
         * Joins last values emitted by passed Observables.
         *
         * <span class="informal">Wait for Observables to complete and then combine last values they emitted.</span>
         *
         * <img src="./img/forkJoin.png" width="100%">
         *
         * `forkJoin` is an operator that takes any number of Observables which can be passed either as an array
         * or directly as arguments. If no input Observables are provided, resulting stream will complete
         * immediately.
         *
         * `forkJoin` will wait for all passed Observables to complete and then it will emit an array with last
         * values from corresponding Observables. So if you pass `n` Observables to the operator, resulting
         * array will have `n` values, where first value is the last thing emitted by the first Observable,
         * second value is the last thing emitted by the second Observable and so on. That means `forkJoin` will
         * not emit more than once and it will complete after that. If you need to emit combined values not only
         * at the end of lifecycle of passed Observables, but also throughout it, try out {@link combineLatest}
         * or {@link zip} instead.
         *
         * In order for resulting array to have the same length as the number of input Observables, whenever any of
         * that Observables completes without emitting any value, `forkJoin` will complete at that moment as well
         * and it will not emit anything either, even if it already has some last values from other Observables.
         * Conversely, if there is an Observable that never completes, `forkJoin` will never complete as well,
         * unless at any point some other Observable completes without emitting value, which brings us back to
         * the previous case. Overall, in order for `forkJoin` to emit a value, all Observables passed as arguments
         * have to emit something at least once and complete.
         *
         * If any input Observable errors at some point, `forkJoin` will error as well and all other Observables
         * will be immediately unsubscribed.
         *
         * Optionally `forkJoin` accepts project function, that will be called with values which normally
         * would land in emitted array. Whatever is returned by project function, will appear in output
         * Observable instead. This means that default project can be thought of as a function that takes
         * all its arguments and puts them into an array. Note that project function will be called only
         * when output Observable is supposed to emit a result.
         *
         * @example <caption>Use forkJoin with operator emitting immediately</caption>
         * const observable = Rx.Observable.forkJoin(
         *   Rx.Observable.of(1, 2, 3, 4),
         *   Rx.Observable.of(5, 6, 7, 8)
         * );
         * observable.subscribe(
         *   value => console.log(value),
         *   err => {},
         *   () => console.log('This is how it ends!')
         * );
         *
         * // Logs:
         * // [4, 8]
         * // "This is how it ends!"
         *
         *
         * @example <caption>Use forkJoin with operator emitting after some time</caption>
         * const observable = Rx.Observable.forkJoin(
         *   Rx.Observable.interval(1000).take(3), // emit 0, 1, 2 every second and complete
         *   Rx.Observable.interval(500).take(4) // emit 0, 1, 2, 3 every half a second and complete
         * );
         * observable.subscribe(
         *   value => console.log(value),
         *   err => {},
         *   () => console.log('This is how it ends!')
         * );
         *
         * // Logs:
         * // [2, 3] after 3 seconds
         * // "This is how it ends!" immediately after
         *
         *
         * @example <caption>Use forkJoin with project function</caption>
         * const observable = Rx.Observable.forkJoin(
         *   Rx.Observable.interval(1000).take(3), // emit 0, 1, 2 every second and complete
         *   Rx.Observable.interval(500).take(4), // emit 0, 1, 2, 3 every half a second and complete
         *   (n, m) => n + m
         * );
         * observable.subscribe(
         *   value => console.log(value),
         *   err => {},
         *   () => console.log('This is how it ends!')
         * );
         *
         * // Logs:
         * // 5 after 3 seconds
         * // "This is how it ends!" immediately after
         *
         * @see {@link combineLatest}
         * @see {@link zip}
         *
         * @param {...SubscribableOrPromise} sources Any number of Observables provided either as an array or as an arguments
         * passed directly to the operator.
         * @param {function} [project] Function that takes values emitted by input Observables and returns value
         * that will appear in resulting Observable instead of default array.
         * @return {Observable} Observable emitting either an array of last values emitted by passed Observables
         * or value from project function.
         * @static true
         * @name forkJoin
         * @owner Observable
         */
        ForkJoinObservable.create = function () {
            var sources = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                sources[_i - 0] = arguments[_i];
            }
            if (sources === null || arguments.length === 0) {
                return new EmptyObservable_1.EmptyObservable();
            }
            var resultSelector = null;
            if (typeof sources[sources.length - 1] === 'function') {
                resultSelector = sources.pop();
            }
            // if the first and only other argument besides the resultSelector is an array
            // assume it's been called with `forkJoin([obs1, obs2, obs3], resultSelector)`
            if (sources.length === 1 && isArray_1.isArray(sources[0])) {
                sources = sources[0];
            }
            if (sources.length === 0) {
                return new EmptyObservable_1.EmptyObservable();
            }
            return new ForkJoinObservable(sources, resultSelector);
        };
        /** @deprecated internal use only */ForkJoinObservable.prototype._subscribe = function (subscriber) {
            return new ForkJoinSubscriber(subscriber, this.sources, this.resultSelector);
        };
        return ForkJoinObservable;
    }(Observable_1.Observable);
    exports.ForkJoinObservable = ForkJoinObservable;
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var ForkJoinSubscriber = function (_super) {
        __extends(ForkJoinSubscriber, _super);
        function ForkJoinSubscriber(destination, sources, resultSelector) {
            _super.call(this, destination);
            this.sources = sources;
            this.resultSelector = resultSelector;
            this.completed = 0;
            this.haveValues = 0;
            var len = sources.length;
            this.total = len;
            this.values = new Array(len);
            for (var i = 0; i < len; i++) {
                var source = sources[i];
                var innerSubscription = subscribeToResult_1.subscribeToResult(this, source, null, i);
                if (innerSubscription) {
                    innerSubscription.outerIndex = i;
                    this.add(innerSubscription);
                }
            }
        }
        ForkJoinSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this.values[outerIndex] = innerValue;
            if (!innerSub._hasValue) {
                innerSub._hasValue = true;
                this.haveValues++;
            }
        };
        ForkJoinSubscriber.prototype.notifyComplete = function (innerSub) {
            var destination = this.destination;
            var _a = this,
                haveValues = _a.haveValues,
                resultSelector = _a.resultSelector,
                values = _a.values;
            var len = values.length;
            if (!innerSub._hasValue) {
                destination.complete();
                return;
            }
            this.completed++;
            if (this.completed !== len) {
                return;
            }
            if (haveValues === len) {
                var value = resultSelector ? resultSelector.apply(this, values) : values;
                destination.next(value);
            }
            destination.complete();
        };
        return ForkJoinSubscriber;
    }(OuterSubscriber_1.OuterSubscriber);
    
});
System.registerDynamic("rxjs/observable/forkJoin.js", ["rxjs/observable/ForkJoinObservable.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var ForkJoinObservable_1 = $__require("rxjs/observable/ForkJoinObservable.js");
  exports.forkJoin = ForkJoinObservable_1.ForkJoinObservable.create;
  
});
System.registerDynamic('rxjs/add/observable/forkJoin.js', ['rxjs/Observable.js', 'rxjs/observable/forkJoin.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var forkJoin_1 = $__require('rxjs/observable/forkJoin.js');
  Observable_1.Observable.forkJoin = forkJoin_1.forkJoin;
  
});
System.registerDynamic('rxjs/observable/FromEventObservable.js', ['rxjs/Observable.js', 'rxjs/util/tryCatch.js', 'rxjs/util/isFunction.js', 'rxjs/util/errorObject.js', 'rxjs/Subscription.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Observable_1 = $__require('rxjs/Observable.js');
    var tryCatch_1 = $__require('rxjs/util/tryCatch.js');
    var isFunction_1 = $__require('rxjs/util/isFunction.js');
    var errorObject_1 = $__require('rxjs/util/errorObject.js');
    var Subscription_1 = $__require('rxjs/Subscription.js');
    var toString = Object.prototype.toString;
    function isNodeStyleEventEmitter(sourceObj) {
        return !!sourceObj && typeof sourceObj.addListener === 'function' && typeof sourceObj.removeListener === 'function';
    }
    function isJQueryStyleEventEmitter(sourceObj) {
        return !!sourceObj && typeof sourceObj.on === 'function' && typeof sourceObj.off === 'function';
    }
    function isNodeList(sourceObj) {
        return !!sourceObj && toString.call(sourceObj) === '[object NodeList]';
    }
    function isHTMLCollection(sourceObj) {
        return !!sourceObj && toString.call(sourceObj) === '[object HTMLCollection]';
    }
    function isEventTarget(sourceObj) {
        return !!sourceObj && typeof sourceObj.addEventListener === 'function' && typeof sourceObj.removeEventListener === 'function';
    }
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @extends {Ignored}
     * @hide true
     */
    var FromEventObservable = function (_super) {
        __extends(FromEventObservable, _super);
        function FromEventObservable(sourceObj, eventName, selector, options) {
            _super.call(this);
            this.sourceObj = sourceObj;
            this.eventName = eventName;
            this.selector = selector;
            this.options = options;
        }
        /* tslint:enable:max-line-length */
        /**
         * Creates an Observable that emits events of a specific type coming from the
         * given event target.
         *
         * <span class="informal">Creates an Observable from DOM events, or Node.js
         * EventEmitter events or others.</span>
         *
         * <img src="./img/fromEvent.png" width="100%">
         *
         * `fromEvent` accepts as a first argument event target, which is an object with methods
         * for registering event handler functions. As a second argument it takes string that indicates
         * type of event we want to listen for. `fromEvent` supports selected types of event targets,
         * which are described in detail below. If your event target does not match any of the ones listed,
         * you should use {@link fromEventPattern}, which can be used on arbitrary APIs.
         * When it comes to APIs supported by `fromEvent`, their methods for adding and removing event
         * handler functions have different names, but they all accept a string describing event type
         * and function itself, which will be called whenever said event happens.
         *
         * Every time resulting Observable is subscribed, event handler function will be registered
         * to event target on given event type. When that event fires, value
         * passed as a first argument to registered function will be emitted by output Observable.
         * When Observable is unsubscribed, function will be unregistered from event target.
         *
         * Note that if event target calls registered function with more than one argument, second
         * and following arguments will not appear in resulting stream. In order to get access to them,
         * you can pass to `fromEvent` optional project function, which will be called with all arguments
         * passed to event handler. Output Observable will then emit value returned by project function,
         * instead of the usual value.
         *
         * Remember that event targets listed below are checked via duck typing. It means that
         * no matter what kind of object you have and no matter what environment you work in,
         * you can safely use `fromEvent` on that object if it exposes described methods (provided
         * of course they behave as was described above). So for example if Node.js library exposes
         * event target which has the same method names as DOM EventTarget, `fromEvent` is still
         * a good choice.
         *
         * If the API you use is more callback then event handler oriented (subscribed
         * callback function fires only once and thus there is no need to manually
         * unregister it), you should use {@link bindCallback} or {@link bindNodeCallback}
         * instead.
         *
         * `fromEvent` supports following types of event targets:
         *
         * **DOM EventTarget**
         *
         * This is an object with `addEventListener` and `removeEventListener` methods.
         *
         * In the browser, `addEventListener` accepts - apart from event type string and event
         * handler function arguments - optional third parameter, which is either an object or boolean,
         * both used for additional configuration how and when passed function will be called. When
         * `fromEvent` is used with event target of that type, you can provide this values
         * as third parameter as well.
         *
         * **Node.js EventEmitter**
         *
         * An object with `addListener` and `removeListener` methods.
         *
         * **JQuery-style event target**
         *
         * An object with `on` and `off` methods
         *
         * **DOM NodeList**
         *
         * List of DOM Nodes, returned for example by `document.querySelectorAll` or `Node.childNodes`.
         *
         * Although this collection is not event target in itself, `fromEvent` will iterate over all Nodes
         * it contains and install event handler function in every of them. When returned Observable
         * is unsubscribed, function will be removed from all Nodes.
         *
         * **DOM HtmlCollection**
         *
         * Just as in case of NodeList it is a collection of DOM nodes. Here as well event handler function is
         * installed and removed in each of elements.
         *
         *
         * @example <caption>Emits clicks happening on the DOM document</caption>
         * var clicks = Rx.Observable.fromEvent(document, 'click');
         * clicks.subscribe(x => console.log(x));
         *
         * // Results in:
         * // MouseEvent object logged to console every time a click
         * // occurs on the document.
         *
         *
         * @example <caption>Use addEventListener with capture option</caption>
         * var clicksInDocument = Rx.Observable.fromEvent(document, 'click', true); // note optional configuration parameter
         *                                                                          // which will be passed to addEventListener
         * var clicksInDiv = Rx.Observable.fromEvent(someDivInDocument, 'click');
         *
         * clicksInDocument.subscribe(() => console.log('document'));
         * clicksInDiv.subscribe(() => console.log('div'));
         *
         * // By default events bubble UP in DOM tree, so normally
         * // when we would click on div in document
         * // "div" would be logged first and then "document".
         * // Since we specified optional `capture` option, document
         * // will catch event when it goes DOWN DOM tree, so console
         * // will log "document" and then "div".
         *
         * @see {@link bindCallback}
         * @see {@link bindNodeCallback}
         * @see {@link fromEventPattern}
         *
         * @param {EventTargetLike} target The DOM EventTarget, Node.js
         * EventEmitter, JQuery-like event target, NodeList or HTMLCollection to attach the event handler to.
         * @param {string} eventName The event name of interest, being emitted by the
         * `target`.
         * @param {EventListenerOptions} [options] Options to pass through to addEventListener
         * @param {SelectorMethodSignature<T>} [selector] An optional function to
         * post-process results. It takes the arguments from the event handler and
         * should return a single value.
         * @return {Observable<T>}
         * @static true
         * @name fromEvent
         * @owner Observable
         */
        FromEventObservable.create = function (target, eventName, options, selector) {
            if (isFunction_1.isFunction(options)) {
                selector = options;
                options = undefined;
            }
            return new FromEventObservable(target, eventName, selector, options);
        };
        FromEventObservable.setupSubscription = function (sourceObj, eventName, handler, subscriber, options) {
            var unsubscribe;
            if (isNodeList(sourceObj) || isHTMLCollection(sourceObj)) {
                for (var i = 0, len = sourceObj.length; i < len; i++) {
                    FromEventObservable.setupSubscription(sourceObj[i], eventName, handler, subscriber, options);
                }
            } else if (isEventTarget(sourceObj)) {
                var source_1 = sourceObj;
                sourceObj.addEventListener(eventName, handler, options);
                unsubscribe = function () {
                    return source_1.removeEventListener(eventName, handler, options);
                };
            } else if (isJQueryStyleEventEmitter(sourceObj)) {
                var source_2 = sourceObj;
                sourceObj.on(eventName, handler);
                unsubscribe = function () {
                    return source_2.off(eventName, handler);
                };
            } else if (isNodeStyleEventEmitter(sourceObj)) {
                var source_3 = sourceObj;
                sourceObj.addListener(eventName, handler);
                unsubscribe = function () {
                    return source_3.removeListener(eventName, handler);
                };
            } else {
                throw new TypeError('Invalid event target');
            }
            subscriber.add(new Subscription_1.Subscription(unsubscribe));
        };
        /** @deprecated internal use only */FromEventObservable.prototype._subscribe = function (subscriber) {
            var sourceObj = this.sourceObj;
            var eventName = this.eventName;
            var options = this.options;
            var selector = this.selector;
            var handler = selector ? function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i - 0] = arguments[_i];
                }
                var result = tryCatch_1.tryCatch(selector).apply(void 0, args);
                if (result === errorObject_1.errorObject) {
                    subscriber.error(errorObject_1.errorObject.e);
                } else {
                    subscriber.next(result);
                }
            } : function (e) {
                return subscriber.next(e);
            };
            FromEventObservable.setupSubscription(sourceObj, eventName, handler, subscriber, options);
        };
        return FromEventObservable;
    }(Observable_1.Observable);
    exports.FromEventObservable = FromEventObservable;
    
});
System.registerDynamic("rxjs/observable/fromEvent.js", ["rxjs/observable/FromEventObservable.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var FromEventObservable_1 = $__require("rxjs/observable/FromEventObservable.js");
  exports.fromEvent = FromEventObservable_1.FromEventObservable.create;
  
});
System.registerDynamic('rxjs/add/observable/fromEvent.js', ['rxjs/Observable.js', 'rxjs/observable/fromEvent.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var fromEvent_1 = $__require('rxjs/observable/fromEvent.js');
  Observable_1.Observable.fromEvent = fromEvent_1.fromEvent;
  
});
System.registerDynamic('rxjs/observable/FromEventPatternObservable.js', ['rxjs/util/isFunction.js', 'rxjs/Observable.js', 'rxjs/Subscription.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var isFunction_1 = $__require('rxjs/util/isFunction.js');
    var Observable_1 = $__require('rxjs/Observable.js');
    var Subscription_1 = $__require('rxjs/Subscription.js');
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @extends {Ignored}
     * @hide true
     */
    var FromEventPatternObservable = function (_super) {
        __extends(FromEventPatternObservable, _super);
        function FromEventPatternObservable(addHandler, removeHandler, selector) {
            _super.call(this);
            this.addHandler = addHandler;
            this.removeHandler = removeHandler;
            this.selector = selector;
        }
        /**
         * Creates an Observable from an API based on addHandler/removeHandler
         * functions.
         *
         * <span class="informal">Converts any addHandler/removeHandler API to an
         * Observable.</span>
         *
         * <img src="./img/fromEventPattern.png" width="100%">
         *
         * Creates an Observable by using the `addHandler` and `removeHandler`
         * functions to add and remove the handlers, with an optional selector
         * function to project the event arguments to a result. The `addHandler` is
         * called when the output Observable is subscribed, and `removeHandler` is
         * called when the Subscription is unsubscribed.
         *
         * @example <caption>Emits clicks happening on the DOM document</caption>
         * function addClickHandler(handler) {
         *   document.addEventListener('click', handler);
         * }
         *
         * function removeClickHandler(handler) {
         *   document.removeEventListener('click', handler);
         * }
         *
         * var clicks = Rx.Observable.fromEventPattern(
         *   addClickHandler,
         *   removeClickHandler
         * );
         * clicks.subscribe(x => console.log(x));
         *
         * @see {@link from}
         * @see {@link fromEvent}
         *
         * @param {function(handler: Function): any} addHandler A function that takes
         * a `handler` function as argument and attaches it somehow to the actual
         * source of events.
         * @param {function(handler: Function, signal?: any): void} [removeHandler] An optional function that
         * takes a `handler` function as argument and removes it in case it was
         * previously attached using `addHandler`. if addHandler returns signal to teardown when remove,
         * removeHandler function will forward it.
         * @param {function(...args: any): T} [selector] An optional function to
         * post-process results. It takes the arguments from the event handler and
         * should return a single value.
         * @return {Observable<T>}
         * @static true
         * @name fromEventPattern
         * @owner Observable
         */
        FromEventPatternObservable.create = function (addHandler, removeHandler, selector) {
            return new FromEventPatternObservable(addHandler, removeHandler, selector);
        };
        /** @deprecated internal use only */FromEventPatternObservable.prototype._subscribe = function (subscriber) {
            var _this = this;
            var removeHandler = this.removeHandler;
            var handler = !!this.selector ? function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i - 0] = arguments[_i];
                }
                _this._callSelector(subscriber, args);
            } : function (e) {
                subscriber.next(e);
            };
            var retValue = this._callAddHandler(handler, subscriber);
            if (!isFunction_1.isFunction(removeHandler)) {
                return;
            }
            subscriber.add(new Subscription_1.Subscription(function () {
                //TODO: determine whether or not to forward to error handler
                removeHandler(handler, retValue);
            }));
        };
        FromEventPatternObservable.prototype._callSelector = function (subscriber, args) {
            try {
                var result = this.selector.apply(this, args);
                subscriber.next(result);
            } catch (e) {
                subscriber.error(e);
            }
        };
        FromEventPatternObservable.prototype._callAddHandler = function (handler, errorSubscriber) {
            try {
                return this.addHandler(handler) || null;
            } catch (e) {
                errorSubscriber.error(e);
            }
        };
        return FromEventPatternObservable;
    }(Observable_1.Observable);
    exports.FromEventPatternObservable = FromEventPatternObservable;
    
});
System.registerDynamic("rxjs/observable/fromEventPattern.js", ["rxjs/observable/FromEventPatternObservable.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var FromEventPatternObservable_1 = $__require("rxjs/observable/FromEventPatternObservable.js");
  exports.fromEventPattern = FromEventPatternObservable_1.FromEventPatternObservable.create;
  
});
System.registerDynamic('rxjs/add/observable/fromEventPattern.js', ['rxjs/Observable.js', 'rxjs/observable/fromEventPattern.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var fromEventPattern_1 = $__require('rxjs/observable/fromEventPattern.js');
  Observable_1.Observable.fromEventPattern = fromEventPattern_1.fromEventPattern;
  
});
System.registerDynamic("rxjs/observable/fromPromise.js", ["rxjs/observable/PromiseObservable.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var PromiseObservable_1 = $__require("rxjs/observable/PromiseObservable.js");
  exports.fromPromise = PromiseObservable_1.PromiseObservable.create;
  
});
System.registerDynamic('rxjs/add/observable/fromPromise.js', ['rxjs/Observable.js', 'rxjs/observable/fromPromise.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var fromPromise_1 = $__require('rxjs/observable/fromPromise.js');
  Observable_1.Observable.fromPromise = fromPromise_1.fromPromise;
  
});
System.registerDynamic('rxjs/observable/GenerateObservable.js', ['rxjs/Observable.js', 'rxjs/util/isScheduler.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Observable_1 = $__require('rxjs/Observable.js');
    var isScheduler_1 = $__require('rxjs/util/isScheduler.js');
    var selfSelector = function (value) {
        return value;
    };
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @extends {Ignored}
     * @hide true
     */
    var GenerateObservable = function (_super) {
        __extends(GenerateObservable, _super);
        function GenerateObservable(initialState, condition, iterate, resultSelector, scheduler) {
            _super.call(this);
            this.initialState = initialState;
            this.condition = condition;
            this.iterate = iterate;
            this.resultSelector = resultSelector;
            this.scheduler = scheduler;
        }
        GenerateObservable.create = function (initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler) {
            if (arguments.length == 1) {
                return new GenerateObservable(initialStateOrOptions.initialState, initialStateOrOptions.condition, initialStateOrOptions.iterate, initialStateOrOptions.resultSelector || selfSelector, initialStateOrOptions.scheduler);
            }
            if (resultSelectorOrObservable === undefined || isScheduler_1.isScheduler(resultSelectorOrObservable)) {
                return new GenerateObservable(initialStateOrOptions, condition, iterate, selfSelector, resultSelectorOrObservable);
            }
            return new GenerateObservable(initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler);
        };
        /** @deprecated internal use only */GenerateObservable.prototype._subscribe = function (subscriber) {
            var state = this.initialState;
            if (this.scheduler) {
                return this.scheduler.schedule(GenerateObservable.dispatch, 0, {
                    subscriber: subscriber,
                    iterate: this.iterate,
                    condition: this.condition,
                    resultSelector: this.resultSelector,
                    state: state });
            }
            var _a = this,
                condition = _a.condition,
                resultSelector = _a.resultSelector,
                iterate = _a.iterate;
            do {
                if (condition) {
                    var conditionResult = void 0;
                    try {
                        conditionResult = condition(state);
                    } catch (err) {
                        subscriber.error(err);
                        return;
                    }
                    if (!conditionResult) {
                        subscriber.complete();
                        break;
                    }
                }
                var value = void 0;
                try {
                    value = resultSelector(state);
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                subscriber.next(value);
                if (subscriber.closed) {
                    break;
                }
                try {
                    state = iterate(state);
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
            } while (true);
        };
        GenerateObservable.dispatch = function (state) {
            var subscriber = state.subscriber,
                condition = state.condition;
            if (subscriber.closed) {
                return;
            }
            if (state.needIterate) {
                try {
                    state.state = state.iterate(state.state);
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
            } else {
                state.needIterate = true;
            }
            if (condition) {
                var conditionResult = void 0;
                try {
                    conditionResult = condition(state.state);
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (!conditionResult) {
                    subscriber.complete();
                    return;
                }
                if (subscriber.closed) {
                    return;
                }
            }
            var value;
            try {
                value = state.resultSelector(state.state);
            } catch (err) {
                subscriber.error(err);
                return;
            }
            if (subscriber.closed) {
                return;
            }
            subscriber.next(value);
            if (subscriber.closed) {
                return;
            }
            return this.schedule(state);
        };
        return GenerateObservable;
    }(Observable_1.Observable);
    exports.GenerateObservable = GenerateObservable;
    
});
System.registerDynamic("rxjs/observable/generate.js", ["rxjs/observable/GenerateObservable.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var GenerateObservable_1 = $__require("rxjs/observable/GenerateObservable.js");
  exports.generate = GenerateObservable_1.GenerateObservable.create;
  
});
System.registerDynamic('rxjs/add/observable/generate.js', ['rxjs/Observable.js', 'rxjs/observable/generate.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var generate_1 = $__require('rxjs/observable/generate.js');
  Observable_1.Observable.generate = generate_1.generate;
  
});
System.registerDynamic('rxjs/observable/IfObservable.js', ['rxjs/Observable.js', 'rxjs/util/subscribeToResult.js', 'rxjs/OuterSubscriber.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Observable_1 = $__require('rxjs/Observable.js');
    var subscribeToResult_1 = $__require('rxjs/util/subscribeToResult.js');
    var OuterSubscriber_1 = $__require('rxjs/OuterSubscriber.js');
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @extends {Ignored}
     * @hide true
     */
    var IfObservable = function (_super) {
        __extends(IfObservable, _super);
        function IfObservable(condition, thenSource, elseSource) {
            _super.call(this);
            this.condition = condition;
            this.thenSource = thenSource;
            this.elseSource = elseSource;
        }
        IfObservable.create = function (condition, thenSource, elseSource) {
            return new IfObservable(condition, thenSource, elseSource);
        };
        /** @deprecated internal use only */IfObservable.prototype._subscribe = function (subscriber) {
            var _a = this,
                condition = _a.condition,
                thenSource = _a.thenSource,
                elseSource = _a.elseSource;
            return new IfSubscriber(subscriber, condition, thenSource, elseSource);
        };
        return IfObservable;
    }(Observable_1.Observable);
    exports.IfObservable = IfObservable;
    var IfSubscriber = function (_super) {
        __extends(IfSubscriber, _super);
        function IfSubscriber(destination, condition, thenSource, elseSource) {
            _super.call(this, destination);
            this.condition = condition;
            this.thenSource = thenSource;
            this.elseSource = elseSource;
            this.tryIf();
        }
        IfSubscriber.prototype.tryIf = function () {
            var _a = this,
                condition = _a.condition,
                thenSource = _a.thenSource,
                elseSource = _a.elseSource;
            var result;
            try {
                result = condition();
                var source = result ? thenSource : elseSource;
                if (source) {
                    this.add(subscribeToResult_1.subscribeToResult(this, source));
                } else {
                    this._complete();
                }
            } catch (err) {
                this._error(err);
            }
        };
        return IfSubscriber;
    }(OuterSubscriber_1.OuterSubscriber);
    
});
System.registerDynamic("rxjs/observable/if.js", ["rxjs/observable/IfObservable.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var IfObservable_1 = $__require("rxjs/observable/IfObservable.js");
  exports._if = IfObservable_1.IfObservable.create;
  
});
System.registerDynamic('rxjs/add/observable/if.js', ['rxjs/Observable.js', 'rxjs/observable/if.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var if_1 = $__require('rxjs/observable/if.js');
  Observable_1.Observable.if = if_1._if;
  
});
System.registerDynamic('rxjs/observable/IntervalObservable.js', ['rxjs/util/isNumeric.js', 'rxjs/Observable.js', 'rxjs/scheduler/async.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var isNumeric_1 = $__require('rxjs/util/isNumeric.js');
    var Observable_1 = $__require('rxjs/Observable.js');
    var async_1 = $__require('rxjs/scheduler/async.js');
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @extends {Ignored}
     * @hide true
     */
    var IntervalObservable = function (_super) {
        __extends(IntervalObservable, _super);
        function IntervalObservable(period, scheduler) {
            if (period === void 0) {
                period = 0;
            }
            if (scheduler === void 0) {
                scheduler = async_1.async;
            }
            _super.call(this);
            this.period = period;
            this.scheduler = scheduler;
            if (!isNumeric_1.isNumeric(period) || period < 0) {
                this.period = 0;
            }
            if (!scheduler || typeof scheduler.schedule !== 'function') {
                this.scheduler = async_1.async;
            }
        }
        /**
         * Creates an Observable that emits sequential numbers every specified
         * interval of time, on a specified IScheduler.
         *
         * <span class="informal">Emits incremental numbers periodically in time.
         * </span>
         *
         * <img src="./img/interval.png" width="100%">
         *
         * `interval` returns an Observable that emits an infinite sequence of
         * ascending integers, with a constant interval of time of your choosing
         * between those emissions. The first emission is not sent immediately, but
         * only after the first period has passed. By default, this operator uses the
         * `async` IScheduler to provide a notion of time, but you may pass any
         * IScheduler to it.
         *
         * @example <caption>Emits ascending numbers, one every second (1000ms)</caption>
         * var numbers = Rx.Observable.interval(1000);
         * numbers.subscribe(x => console.log(x));
         *
         * @see {@link timer}
         * @see {@link delay}
         *
         * @param {number} [period=0] The interval size in milliseconds (by default)
         * or the time unit determined by the scheduler's clock.
         * @param {Scheduler} [scheduler=async] The IScheduler to use for scheduling
         * the emission of values, and providing a notion of "time".
         * @return {Observable} An Observable that emits a sequential number each time
         * interval.
         * @static true
         * @name interval
         * @owner Observable
         */
        IntervalObservable.create = function (period, scheduler) {
            if (period === void 0) {
                period = 0;
            }
            if (scheduler === void 0) {
                scheduler = async_1.async;
            }
            return new IntervalObservable(period, scheduler);
        };
        IntervalObservable.dispatch = function (state) {
            var index = state.index,
                subscriber = state.subscriber,
                period = state.period;
            subscriber.next(index);
            if (subscriber.closed) {
                return;
            }
            state.index += 1;
            this.schedule(state, period);
        };
        /** @deprecated internal use only */IntervalObservable.prototype._subscribe = function (subscriber) {
            var index = 0;
            var period = this.period;
            var scheduler = this.scheduler;
            subscriber.add(scheduler.schedule(IntervalObservable.dispatch, period, {
                index: index, subscriber: subscriber, period: period
            }));
        };
        return IntervalObservable;
    }(Observable_1.Observable);
    exports.IntervalObservable = IntervalObservable;
    
});
System.registerDynamic("rxjs/observable/interval.js", ["rxjs/observable/IntervalObservable.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var IntervalObservable_1 = $__require("rxjs/observable/IntervalObservable.js");
  exports.interval = IntervalObservable_1.IntervalObservable.create;
  
});
System.registerDynamic('rxjs/add/observable/interval.js', ['rxjs/Observable.js', 'rxjs/observable/interval.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var interval_1 = $__require('rxjs/observable/interval.js');
  Observable_1.Observable.interval = interval_1.interval;
  
});
System.registerDynamic('rxjs/add/observable/merge.js', ['rxjs/Observable.js', 'rxjs/observable/merge.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var merge_1 = $__require('rxjs/observable/merge.js');
  Observable_1.Observable.merge = merge_1.merge;
  
});
System.registerDynamic('rxjs/add/observable/race.js', ['rxjs/Observable.js', 'rxjs/observable/race.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var race_1 = $__require('rxjs/observable/race.js');
  Observable_1.Observable.race = race_1.race;
  
});
System.registerDynamic('rxjs/observable/NeverObservable.js', ['rxjs/Observable.js', 'rxjs/util/noop.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Observable_1 = $__require('rxjs/Observable.js');
    var noop_1 = $__require('rxjs/util/noop.js');
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @extends {Ignored}
     * @hide true
     */
    var NeverObservable = function (_super) {
        __extends(NeverObservable, _super);
        function NeverObservable() {
            _super.call(this);
        }
        /**
         * Creates an Observable that emits no items to the Observer.
         *
         * <span class="informal">An Observable that never emits anything.</span>
         *
         * <img src="./img/never.png" width="100%">
         *
         * This static operator is useful for creating a simple Observable that emits
         * neither values nor errors nor the completion notification. It can be used
         * for testing purposes or for composing with other Observables. Please note
         * that by never emitting a complete notification, this Observable keeps the
         * subscription from being disposed automatically. Subscriptions need to be
         * manually disposed.
         *
         * @example <caption>Emit the number 7, then never emit anything else (not even complete).</caption>
         * function info() {
         *   console.log('Will not be called');
         * }
         * var result = Rx.Observable.never().startWith(7);
         * result.subscribe(x => console.log(x), info, info);
         *
         * @see {@link create}
         * @see {@link empty}
         * @see {@link of}
         * @see {@link throw}
         *
         * @return {Observable} A "never" Observable: never emits anything.
         * @static true
         * @name never
         * @owner Observable
         */
        NeverObservable.create = function () {
            return new NeverObservable();
        };
        /** @deprecated internal use only */NeverObservable.prototype._subscribe = function (subscriber) {
            noop_1.noop();
        };
        return NeverObservable;
    }(Observable_1.Observable);
    exports.NeverObservable = NeverObservable;
    
});
System.registerDynamic("rxjs/observable/never.js", ["rxjs/observable/NeverObservable.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var NeverObservable_1 = $__require("rxjs/observable/NeverObservable.js");
  exports.never = NeverObservable_1.NeverObservable.create;
  
});
System.registerDynamic('rxjs/add/observable/never.js', ['rxjs/Observable.js', 'rxjs/observable/never.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var never_1 = $__require('rxjs/observable/never.js');
  Observable_1.Observable.never = never_1.never;
  
});
System.registerDynamic('rxjs/add/observable/of.js', ['rxjs/Observable.js', 'rxjs/observable/of.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var of_1 = $__require('rxjs/observable/of.js');
  Observable_1.Observable.of = of_1.of;
  
});
System.registerDynamic("rxjs/observable/onErrorResumeNext.js", ["rxjs/operators/onErrorResumeNext.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var onErrorResumeNext_1 = $__require("rxjs/operators/onErrorResumeNext.js");
  exports.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNextStatic;
  
});
System.registerDynamic('rxjs/add/observable/onErrorResumeNext.js', ['rxjs/Observable.js', 'rxjs/observable/onErrorResumeNext.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var onErrorResumeNext_1 = $__require('rxjs/observable/onErrorResumeNext.js');
  Observable_1.Observable.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNext;
  
});
System.registerDynamic("rxjs/observable/PairsObservable.js", ["rxjs/Observable.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Observable_1 = $__require("rxjs/Observable.js");
    function dispatch(state) {
        var obj = state.obj,
            keys = state.keys,
            length = state.length,
            index = state.index,
            subscriber = state.subscriber;
        if (index === length) {
            subscriber.complete();
            return;
        }
        var key = keys[index];
        subscriber.next([key, obj[key]]);
        state.index = index + 1;
        this.schedule(state);
    }
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @extends {Ignored}
     * @hide true
     */
    var PairsObservable = function (_super) {
        __extends(PairsObservable, _super);
        function PairsObservable(obj, scheduler) {
            _super.call(this);
            this.obj = obj;
            this.scheduler = scheduler;
            this.keys = Object.keys(obj);
        }
        /**
         * Convert an object into an observable sequence of [key, value] pairs
         * using an optional IScheduler to enumerate the object.
         *
         * @example <caption>Converts a javascript object to an Observable</caption>
         * var obj = {
         *   foo: 42,
         *   bar: 56,
         *   baz: 78
         * };
         *
         * var source = Rx.Observable.pairs(obj);
         *
         * var subscription = source.subscribe(
         *   function (x) {
         *     console.log('Next: %s', x);
         *   },
         *   function (err) {
         *     console.log('Error: %s', err);
         *   },
         *   function () {
         *     console.log('Completed');
         *   });
         *
         * @param {Object} obj The object to inspect and turn into an
         * Observable sequence.
         * @param {Scheduler} [scheduler] An optional IScheduler to run the
         * enumeration of the input sequence on.
         * @returns {(Observable<Array<string | T>>)} An observable sequence of
         * [key, value] pairs from the object.
         */
        PairsObservable.create = function (obj, scheduler) {
            return new PairsObservable(obj, scheduler);
        };
        /** @deprecated internal use only */PairsObservable.prototype._subscribe = function (subscriber) {
            var _a = this,
                keys = _a.keys,
                scheduler = _a.scheduler;
            var length = keys.length;
            if (scheduler) {
                return scheduler.schedule(dispatch, 0, {
                    obj: this.obj, keys: keys, length: length, index: 0, subscriber: subscriber
                });
            } else {
                for (var idx = 0; idx < length; idx++) {
                    var key = keys[idx];
                    subscriber.next([key, this.obj[key]]);
                }
                subscriber.complete();
            }
        };
        return PairsObservable;
    }(Observable_1.Observable);
    exports.PairsObservable = PairsObservable;
    
});
System.registerDynamic("rxjs/observable/pairs.js", ["rxjs/observable/PairsObservable.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var PairsObservable_1 = $__require("rxjs/observable/PairsObservable.js");
  exports.pairs = PairsObservable_1.PairsObservable.create;
  
});
System.registerDynamic('rxjs/add/observable/pairs.js', ['rxjs/Observable.js', 'rxjs/observable/pairs.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var pairs_1 = $__require('rxjs/observable/pairs.js');
  Observable_1.Observable.pairs = pairs_1.pairs;
  
});
System.registerDynamic("rxjs/observable/RangeObservable.js", ["rxjs/Observable.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Observable_1 = $__require("rxjs/Observable.js");
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @extends {Ignored}
     * @hide true
     */
    var RangeObservable = function (_super) {
        __extends(RangeObservable, _super);
        function RangeObservable(start, count, scheduler) {
            _super.call(this);
            this.start = start;
            this._count = count;
            this.scheduler = scheduler;
        }
        /**
         * Creates an Observable that emits a sequence of numbers within a specified
         * range.
         *
         * <span class="informal">Emits a sequence of numbers in a range.</span>
         *
         * <img src="./img/range.png" width="100%">
         *
         * `range` operator emits a range of sequential integers, in order, where you
         * select the `start` of the range and its `length`. By default, uses no
         * IScheduler and just delivers the notifications synchronously, but may use
         * an optional IScheduler to regulate those deliveries.
         *
         * @example <caption>Emits the numbers 1 to 10</caption>
         * var numbers = Rx.Observable.range(1, 10);
         * numbers.subscribe(x => console.log(x));
         *
         * @see {@link timer}
         * @see {@link interval}
         *
         * @param {number} [start=0] The value of the first integer in the sequence.
         * @param {number} [count=0] The number of sequential integers to generate.
         * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
         * the emissions of the notifications.
         * @return {Observable} An Observable of numbers that emits a finite range of
         * sequential integers.
         * @static true
         * @name range
         * @owner Observable
         */
        RangeObservable.create = function (start, count, scheduler) {
            if (start === void 0) {
                start = 0;
            }
            if (count === void 0) {
                count = 0;
            }
            return new RangeObservable(start, count, scheduler);
        };
        RangeObservable.dispatch = function (state) {
            var start = state.start,
                index = state.index,
                count = state.count,
                subscriber = state.subscriber;
            if (index >= count) {
                subscriber.complete();
                return;
            }
            subscriber.next(start);
            if (subscriber.closed) {
                return;
            }
            state.index = index + 1;
            state.start = start + 1;
            this.schedule(state);
        };
        /** @deprecated internal use only */RangeObservable.prototype._subscribe = function (subscriber) {
            var index = 0;
            var start = this.start;
            var count = this._count;
            var scheduler = this.scheduler;
            if (scheduler) {
                return scheduler.schedule(RangeObservable.dispatch, 0, {
                    index: index, count: count, start: start, subscriber: subscriber
                });
            } else {
                do {
                    if (index++ >= count) {
                        subscriber.complete();
                        break;
                    }
                    subscriber.next(start++);
                    if (subscriber.closed) {
                        break;
                    }
                } while (true);
            }
        };
        return RangeObservable;
    }(Observable_1.Observable);
    exports.RangeObservable = RangeObservable;
    
});
System.registerDynamic("rxjs/observable/range.js", ["rxjs/observable/RangeObservable.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var RangeObservable_1 = $__require("rxjs/observable/RangeObservable.js");
  exports.range = RangeObservable_1.RangeObservable.create;
  
});
System.registerDynamic('rxjs/add/observable/range.js', ['rxjs/Observable.js', 'rxjs/observable/range.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var range_1 = $__require('rxjs/observable/range.js');
  Observable_1.Observable.range = range_1.range;
  
});
System.registerDynamic('rxjs/observable/UsingObservable.js', ['rxjs/Observable.js', 'rxjs/util/subscribeToResult.js', 'rxjs/OuterSubscriber.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Observable_1 = $__require('rxjs/Observable.js');
    var subscribeToResult_1 = $__require('rxjs/util/subscribeToResult.js');
    var OuterSubscriber_1 = $__require('rxjs/OuterSubscriber.js');
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @extends {Ignored}
     * @hide true
     */
    var UsingObservable = function (_super) {
        __extends(UsingObservable, _super);
        function UsingObservable(resourceFactory, observableFactory) {
            _super.call(this);
            this.resourceFactory = resourceFactory;
            this.observableFactory = observableFactory;
        }
        UsingObservable.create = function (resourceFactory, observableFactory) {
            return new UsingObservable(resourceFactory, observableFactory);
        };
        /** @deprecated internal use only */UsingObservable.prototype._subscribe = function (subscriber) {
            var _a = this,
                resourceFactory = _a.resourceFactory,
                observableFactory = _a.observableFactory;
            var resource;
            try {
                resource = resourceFactory();
                return new UsingSubscriber(subscriber, resource, observableFactory);
            } catch (err) {
                subscriber.error(err);
            }
        };
        return UsingObservable;
    }(Observable_1.Observable);
    exports.UsingObservable = UsingObservable;
    var UsingSubscriber = function (_super) {
        __extends(UsingSubscriber, _super);
        function UsingSubscriber(destination, resource, observableFactory) {
            _super.call(this, destination);
            this.resource = resource;
            this.observableFactory = observableFactory;
            destination.add(resource);
            this.tryUse();
        }
        UsingSubscriber.prototype.tryUse = function () {
            try {
                var source = this.observableFactory.call(this, this.resource);
                if (source) {
                    this.add(subscribeToResult_1.subscribeToResult(this, source));
                }
            } catch (err) {
                this._error(err);
            }
        };
        return UsingSubscriber;
    }(OuterSubscriber_1.OuterSubscriber);
    
});
System.registerDynamic("rxjs/observable/using.js", ["rxjs/observable/UsingObservable.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var UsingObservable_1 = $__require("rxjs/observable/UsingObservable.js");
  exports.using = UsingObservable_1.UsingObservable.create;
  
});
System.registerDynamic('rxjs/add/observable/using.js', ['rxjs/Observable.js', 'rxjs/observable/using.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var using_1 = $__require('rxjs/observable/using.js');
  Observable_1.Observable.using = using_1.using;
  
});
System.registerDynamic("rxjs/observable/ErrorObservable.js", ["rxjs/Observable.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Observable_1 = $__require("rxjs/Observable.js");
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @extends {Ignored}
     * @hide true
     */
    var ErrorObservable = function (_super) {
        __extends(ErrorObservable, _super);
        function ErrorObservable(error, scheduler) {
            _super.call(this);
            this.error = error;
            this.scheduler = scheduler;
        }
        /**
         * Creates an Observable that emits no items to the Observer and immediately
         * emits an error notification.
         *
         * <span class="informal">Just emits 'error', and nothing else.
         * </span>
         *
         * <img src="./img/throw.png" width="100%">
         *
         * This static operator is useful for creating a simple Observable that only
         * emits the error notification. It can be used for composing with other
         * Observables, such as in a {@link mergeMap}.
         *
         * @example <caption>Emit the number 7, then emit an error.</caption>
         * var result = Rx.Observable.throw(new Error('oops!')).startWith(7);
         * result.subscribe(x => console.log(x), e => console.error(e));
         *
         * @example <caption>Map and flatten numbers to the sequence 'a', 'b', 'c', but throw an error for 13</caption>
         * var interval = Rx.Observable.interval(1000);
         * var result = interval.mergeMap(x =>
         *   x === 13 ?
         *     Rx.Observable.throw('Thirteens are bad') :
         *     Rx.Observable.of('a', 'b', 'c')
         * );
         * result.subscribe(x => console.log(x), e => console.error(e));
         *
         * @see {@link create}
         * @see {@link empty}
         * @see {@link never}
         * @see {@link of}
         *
         * @param {any} error The particular Error to pass to the error notification.
         * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
         * the emission of the error notification.
         * @return {Observable} An error Observable: emits only the error notification
         * using the given error argument.
         * @static true
         * @name throw
         * @owner Observable
         */
        ErrorObservable.create = function (error, scheduler) {
            return new ErrorObservable(error, scheduler);
        };
        ErrorObservable.dispatch = function (arg) {
            var error = arg.error,
                subscriber = arg.subscriber;
            subscriber.error(error);
        };
        /** @deprecated internal use only */ErrorObservable.prototype._subscribe = function (subscriber) {
            var error = this.error;
            var scheduler = this.scheduler;
            subscriber.syncErrorThrowable = true;
            if (scheduler) {
                return scheduler.schedule(ErrorObservable.dispatch, 0, {
                    error: error, subscriber: subscriber
                });
            } else {
                subscriber.error(error);
            }
        };
        return ErrorObservable;
    }(Observable_1.Observable);
    exports.ErrorObservable = ErrorObservable;
    
});
System.registerDynamic("rxjs/observable/throw.js", ["rxjs/observable/ErrorObservable.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var ErrorObservable_1 = $__require("rxjs/observable/ErrorObservable.js");
  exports._throw = ErrorObservable_1.ErrorObservable.create;
  
});
System.registerDynamic('rxjs/add/observable/throw.js', ['rxjs/Observable.js', 'rxjs/observable/throw.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var throw_1 = $__require('rxjs/observable/throw.js');
  Observable_1.Observable.throw = throw_1._throw;
  
});
System.registerDynamic('rxjs/add/observable/timer.js', ['rxjs/Observable.js', 'rxjs/observable/timer.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var timer_1 = $__require('rxjs/observable/timer.js');
  Observable_1.Observable.timer = timer_1.timer;
  
});
System.registerDynamic("rxjs/observable/zip.js", ["rxjs/operators/zip.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var zip_1 = $__require("rxjs/operators/zip.js");
  exports.zip = zip_1.zipStatic;
  
});
System.registerDynamic('rxjs/add/observable/zip.js', ['rxjs/Observable.js', 'rxjs/observable/zip.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var zip_1 = $__require('rxjs/observable/zip.js');
  Observable_1.Observable.zip = zip_1.zip;
  
});
System.registerDynamic("rxjs/observable/dom/ajax.js", ["rxjs/observable/dom/AjaxObservable.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var AjaxObservable_1 = $__require("rxjs/observable/dom/AjaxObservable.js");
  exports.ajax = AjaxObservable_1.AjaxObservable.create;
  
});
System.registerDynamic('rxjs/add/observable/dom/ajax.js', ['rxjs/Observable.js', 'rxjs/observable/dom/ajax.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var ajax_1 = $__require('rxjs/observable/dom/ajax.js');
  Observable_1.Observable.ajax = ajax_1.ajax;
  
});
System.registerDynamic("rxjs/util/assign.js", ["rxjs/util/root.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var root_1 = $__require("rxjs/util/root.js");
    function assignImpl(target) {
        var sources = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            sources[_i - 1] = arguments[_i];
        }
        var len = sources.length;
        for (var i = 0; i < len; i++) {
            var source = sources[i];
            for (var k in source) {
                if (source.hasOwnProperty(k)) {
                    target[k] = source[k];
                }
            }
        }
        return target;
    }
    exports.assignImpl = assignImpl;
    ;
    function getAssign(root) {
        return root.Object.assign || assignImpl;
    }
    exports.getAssign = getAssign;
    exports.assign = getAssign(root_1.root);
    
});
System.registerDynamic('rxjs/observable/dom/WebSocketSubject.js', ['rxjs/Subject.js', 'rxjs/Subscriber.js', 'rxjs/Observable.js', 'rxjs/Subscription.js', 'rxjs/util/root.js', 'rxjs/ReplaySubject.js', 'rxjs/util/tryCatch.js', 'rxjs/util/errorObject.js', 'rxjs/util/assign.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subject_1 = $__require('rxjs/Subject.js');
    var Subscriber_1 = $__require('rxjs/Subscriber.js');
    var Observable_1 = $__require('rxjs/Observable.js');
    var Subscription_1 = $__require('rxjs/Subscription.js');
    var root_1 = $__require('rxjs/util/root.js');
    var ReplaySubject_1 = $__require('rxjs/ReplaySubject.js');
    var tryCatch_1 = $__require('rxjs/util/tryCatch.js');
    var errorObject_1 = $__require('rxjs/util/errorObject.js');
    var assign_1 = $__require('rxjs/util/assign.js');
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @extends {Ignored}
     * @hide true
     */
    var WebSocketSubject = function (_super) {
        __extends(WebSocketSubject, _super);
        function WebSocketSubject(urlConfigOrSource, destination) {
            if (urlConfigOrSource instanceof Observable_1.Observable) {
                _super.call(this, destination, urlConfigOrSource);
            } else {
                _super.call(this);
                this.WebSocketCtor = root_1.root.WebSocket;
                this._output = new Subject_1.Subject();
                if (typeof urlConfigOrSource === 'string') {
                    this.url = urlConfigOrSource;
                } else {
                    // WARNING: config object could override important members here.
                    assign_1.assign(this, urlConfigOrSource);
                }
                if (!this.WebSocketCtor) {
                    throw new Error('no WebSocket constructor can be found');
                }
                this.destination = new ReplaySubject_1.ReplaySubject();
            }
        }
        WebSocketSubject.prototype.resultSelector = function (e) {
            return JSON.parse(e.data);
        };
        /**
         * Wrapper around the w3c-compatible WebSocket object provided by the browser.
         *
         * @example <caption>Wraps browser WebSocket</caption>
         *
         * let socket$ = Observable.webSocket('ws://localhost:8081');
         *
         * socket$.subscribe(
         *    (msg) => console.log('message received: ' + msg),
         *    (err) => console.log(err),
         *    () => console.log('complete')
         *  );
         *
         * socket$.next(JSON.stringify({ op: 'hello' }));
         *
         * @example <caption>Wraps WebSocket from nodejs-websocket (using node.js)</caption>
         *
         * import { w3cwebsocket } from 'websocket';
         *
         * let socket$ = Observable.webSocket({
         *   url: 'ws://localhost:8081',
         *   WebSocketCtor: w3cwebsocket
         * });
         *
         * socket$.subscribe(
         *    (msg) => console.log('message received: ' + msg),
         *    (err) => console.log(err),
         *    () => console.log('complete')
         *  );
         *
         * socket$.next(JSON.stringify({ op: 'hello' }));
         *
         * @param {string | WebSocketSubjectConfig} urlConfigOrSource the source of the websocket as an url or a structure defining the websocket object
         * @return {WebSocketSubject}
         * @static true
         * @name webSocket
         * @owner Observable
         */
        WebSocketSubject.create = function (urlConfigOrSource) {
            return new WebSocketSubject(urlConfigOrSource);
        };
        WebSocketSubject.prototype.lift = function (operator) {
            var sock = new WebSocketSubject(this, this.destination);
            sock.operator = operator;
            return sock;
        };
        WebSocketSubject.prototype._resetState = function () {
            this.socket = null;
            if (!this.source) {
                this.destination = new ReplaySubject_1.ReplaySubject();
            }
            this._output = new Subject_1.Subject();
        };
        // TODO: factor this out to be a proper Operator/Subscriber implementation and eliminate closures
        WebSocketSubject.prototype.multiplex = function (subMsg, unsubMsg, messageFilter) {
            var self = this;
            return new Observable_1.Observable(function (observer) {
                var result = tryCatch_1.tryCatch(subMsg)();
                if (result === errorObject_1.errorObject) {
                    observer.error(errorObject_1.errorObject.e);
                } else {
                    self.next(result);
                }
                var subscription = self.subscribe(function (x) {
                    var result = tryCatch_1.tryCatch(messageFilter)(x);
                    if (result === errorObject_1.errorObject) {
                        observer.error(errorObject_1.errorObject.e);
                    } else if (result) {
                        observer.next(x);
                    }
                }, function (err) {
                    return observer.error(err);
                }, function () {
                    return observer.complete();
                });
                return function () {
                    var result = tryCatch_1.tryCatch(unsubMsg)();
                    if (result === errorObject_1.errorObject) {
                        observer.error(errorObject_1.errorObject.e);
                    } else {
                        self.next(result);
                    }
                    subscription.unsubscribe();
                };
            });
        };
        WebSocketSubject.prototype._connectSocket = function () {
            var _this = this;
            var WebSocketCtor = this.WebSocketCtor;
            var observer = this._output;
            var socket = null;
            try {
                socket = this.protocol ? new WebSocketCtor(this.url, this.protocol) : new WebSocketCtor(this.url);
                this.socket = socket;
                if (this.binaryType) {
                    this.socket.binaryType = this.binaryType;
                }
            } catch (e) {
                observer.error(e);
                return;
            }
            var subscription = new Subscription_1.Subscription(function () {
                _this.socket = null;
                if (socket && socket.readyState === 1) {
                    socket.close();
                }
            });
            socket.onopen = function (e) {
                var openObserver = _this.openObserver;
                if (openObserver) {
                    openObserver.next(e);
                }
                var queue = _this.destination;
                _this.destination = Subscriber_1.Subscriber.create(function (x) {
                    return socket.readyState === 1 && socket.send(x);
                }, function (e) {
                    var closingObserver = _this.closingObserver;
                    if (closingObserver) {
                        closingObserver.next(undefined);
                    }
                    if (e && e.code) {
                        socket.close(e.code, e.reason);
                    } else {
                        observer.error(new TypeError('WebSocketSubject.error must be called with an object with an error code, ' + 'and an optional reason: { code: number, reason: string }'));
                    }
                    _this._resetState();
                }, function () {
                    var closingObserver = _this.closingObserver;
                    if (closingObserver) {
                        closingObserver.next(undefined);
                    }
                    socket.close();
                    _this._resetState();
                });
                if (queue && queue instanceof ReplaySubject_1.ReplaySubject) {
                    subscription.add(queue.subscribe(_this.destination));
                }
            };
            socket.onerror = function (e) {
                _this._resetState();
                observer.error(e);
            };
            socket.onclose = function (e) {
                _this._resetState();
                var closeObserver = _this.closeObserver;
                if (closeObserver) {
                    closeObserver.next(e);
                }
                if (e.wasClean) {
                    observer.complete();
                } else {
                    observer.error(e);
                }
            };
            socket.onmessage = function (e) {
                var result = tryCatch_1.tryCatch(_this.resultSelector)(e);
                if (result === errorObject_1.errorObject) {
                    observer.error(errorObject_1.errorObject.e);
                } else {
                    observer.next(result);
                }
            };
        };
        /** @deprecated internal use only */WebSocketSubject.prototype._subscribe = function (subscriber) {
            var _this = this;
            var source = this.source;
            if (source) {
                return source.subscribe(subscriber);
            }
            if (!this.socket) {
                this._connectSocket();
            }
            var subscription = new Subscription_1.Subscription();
            subscription.add(this._output.subscribe(subscriber));
            subscription.add(function () {
                var socket = _this.socket;
                if (_this._output.observers.length === 0) {
                    if (socket && socket.readyState === 1) {
                        socket.close();
                    }
                    _this._resetState();
                }
            });
            return subscription;
        };
        WebSocketSubject.prototype.unsubscribe = function () {
            var _a = this,
                source = _a.source,
                socket = _a.socket;
            if (socket && socket.readyState === 1) {
                socket.close();
                this._resetState();
            }
            _super.prototype.unsubscribe.call(this);
            if (!source) {
                this.destination = new ReplaySubject_1.ReplaySubject();
            }
        };
        return WebSocketSubject;
    }(Subject_1.AnonymousSubject);
    exports.WebSocketSubject = WebSocketSubject;
    
});
System.registerDynamic("rxjs/observable/dom/webSocket.js", ["rxjs/observable/dom/WebSocketSubject.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var WebSocketSubject_1 = $__require("rxjs/observable/dom/WebSocketSubject.js");
  exports.webSocket = WebSocketSubject_1.WebSocketSubject.create;
  
});
System.registerDynamic('rxjs/add/observable/dom/webSocket.js', ['rxjs/Observable.js', 'rxjs/observable/dom/webSocket.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var webSocket_1 = $__require('rxjs/observable/dom/webSocket.js');
  Observable_1.Observable.webSocket = webSocket_1.webSocket;
  
});
System.registerDynamic("rxjs/operator/buffer.js", ["rxjs/operators/buffer.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var buffer_1 = $__require("rxjs/operators/buffer.js");
  /**
   * Buffers the source Observable values until `closingNotifier` emits.
   *
   * <span class="informal">Collects values from the past as an array, and emits
   * that array only when another Observable emits.</span>
   *
   * <img src="./img/buffer.png" width="100%">
   *
   * Buffers the incoming Observable values until the given `closingNotifier`
   * Observable emits a value, at which point it emits the buffer on the output
   * Observable and starts a new buffer internally, awaiting the next time
   * `closingNotifier` emits.
   *
   * @example <caption>On every click, emit array of most recent interval events</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var interval = Rx.Observable.interval(1000);
   * var buffered = interval.buffer(clicks);
   * buffered.subscribe(x => console.log(x));
   *
   * @see {@link bufferCount}
   * @see {@link bufferTime}
   * @see {@link bufferToggle}
   * @see {@link bufferWhen}
   * @see {@link window}
   *
   * @param {Observable<any>} closingNotifier An Observable that signals the
   * buffer to be emitted on the output Observable.
   * @return {Observable<T[]>} An Observable of buffers, which are arrays of
   * values.
   * @method buffer
   * @owner Observable
   */
  function buffer(closingNotifier) {
    return buffer_1.buffer(closingNotifier)(this);
  }
  exports.buffer = buffer;
  
});
System.registerDynamic('rxjs/add/operator/buffer.js', ['rxjs/Observable.js', 'rxjs/operator/buffer.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var buffer_1 = $__require('rxjs/operator/buffer.js');
  Observable_1.Observable.prototype.buffer = buffer_1.buffer;
  
});
System.registerDynamic("rxjs/operator/bufferCount.js", ["rxjs/operators/bufferCount.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var bufferCount_1 = $__require("rxjs/operators/bufferCount.js");
  /**
   * Buffers the source Observable values until the size hits the maximum
   * `bufferSize` given.
   *
   * <span class="informal">Collects values from the past as an array, and emits
   * that array only when its size reaches `bufferSize`.</span>
   *
   * <img src="./img/bufferCount.png" width="100%">
   *
   * Buffers a number of values from the source Observable by `bufferSize` then
   * emits the buffer and clears it, and starts a new buffer each
   * `startBufferEvery` values. If `startBufferEvery` is not provided or is
   * `null`, then new buffers are started immediately at the start of the source
   * and when each buffer closes and is emitted.
   *
   * @example <caption>Emit the last two click events as an array</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var buffered = clicks.bufferCount(2);
   * buffered.subscribe(x => console.log(x));
   *
   * @example <caption>On every click, emit the last two click events as an array</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var buffered = clicks.bufferCount(2, 1);
   * buffered.subscribe(x => console.log(x));
   *
   * @see {@link buffer}
   * @see {@link bufferTime}
   * @see {@link bufferToggle}
   * @see {@link bufferWhen}
   * @see {@link pairwise}
   * @see {@link windowCount}
   *
   * @param {number} bufferSize The maximum size of the buffer emitted.
   * @param {number} [startBufferEvery] Interval at which to start a new buffer.
   * For example if `startBufferEvery` is `2`, then a new buffer will be started
   * on every other value from the source. A new buffer is started at the
   * beginning of the source by default.
   * @return {Observable<T[]>} An Observable of arrays of buffered values.
   * @method bufferCount
   * @owner Observable
   */
  function bufferCount(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) {
      startBufferEvery = null;
    }
    return bufferCount_1.bufferCount(bufferSize, startBufferEvery)(this);
  }
  exports.bufferCount = bufferCount;
  
});
System.registerDynamic('rxjs/add/operator/bufferCount.js', ['rxjs/Observable.js', 'rxjs/operator/bufferCount.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var bufferCount_1 = $__require('rxjs/operator/bufferCount.js');
  Observable_1.Observable.prototype.bufferCount = bufferCount_1.bufferCount;
  
});
System.registerDynamic('rxjs/operator/bufferTime.js', ['rxjs/scheduler/async.js', 'rxjs/util/isScheduler.js', 'rxjs/operators/bufferTime.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var async_1 = $__require('rxjs/scheduler/async.js');
    var isScheduler_1 = $__require('rxjs/util/isScheduler.js');
    var bufferTime_1 = $__require('rxjs/operators/bufferTime.js');
    /* tslint:enable:max-line-length */
    /**
     * Buffers the source Observable values for a specific time period.
     *
     * <span class="informal">Collects values from the past as an array, and emits
     * those arrays periodically in time.</span>
     *
     * <img src="./img/bufferTime.png" width="100%">
     *
     * Buffers values from the source for a specific time duration `bufferTimeSpan`.
     * Unless the optional argument `bufferCreationInterval` is given, it emits and
     * resets the buffer every `bufferTimeSpan` milliseconds. If
     * `bufferCreationInterval` is given, this operator opens the buffer every
     * `bufferCreationInterval` milliseconds and closes (emits and resets) the
     * buffer every `bufferTimeSpan` milliseconds. When the optional argument
     * `maxBufferSize` is specified, the buffer will be closed either after
     * `bufferTimeSpan` milliseconds or when it contains `maxBufferSize` elements.
     *
     * @example <caption>Every second, emit an array of the recent click events</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var buffered = clicks.bufferTime(1000);
     * buffered.subscribe(x => console.log(x));
     *
     * @example <caption>Every 5 seconds, emit the click events from the next 2 seconds</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var buffered = clicks.bufferTime(2000, 5000);
     * buffered.subscribe(x => console.log(x));
     *
     * @see {@link buffer}
     * @see {@link bufferCount}
     * @see {@link bufferToggle}
     * @see {@link bufferWhen}
     * @see {@link windowTime}
     *
     * @param {number} bufferTimeSpan The amount of time to fill each buffer array.
     * @param {number} [bufferCreationInterval] The interval at which to start new
     * buffers.
     * @param {number} [maxBufferSize] The maximum buffer size.
     * @param {Scheduler} [scheduler=async] The scheduler on which to schedule the
     * intervals that determine buffer boundaries.
     * @return {Observable<T[]>} An observable of arrays of buffered values.
     * @method bufferTime
     * @owner Observable
     */
    function bufferTime(bufferTimeSpan) {
        var length = arguments.length;
        var scheduler = async_1.async;
        if (isScheduler_1.isScheduler(arguments[arguments.length - 1])) {
            scheduler = arguments[arguments.length - 1];
            length--;
        }
        var bufferCreationInterval = null;
        if (length >= 2) {
            bufferCreationInterval = arguments[1];
        }
        var maxBufferSize = Number.POSITIVE_INFINITY;
        if (length >= 3) {
            maxBufferSize = arguments[2];
        }
        return bufferTime_1.bufferTime(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler)(this);
    }
    exports.bufferTime = bufferTime;
    
});
System.registerDynamic('rxjs/add/operator/bufferTime.js', ['rxjs/Observable.js', 'rxjs/operator/bufferTime.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var bufferTime_1 = $__require('rxjs/operator/bufferTime.js');
  Observable_1.Observable.prototype.bufferTime = bufferTime_1.bufferTime;
  
});
System.registerDynamic("rxjs/operator/bufferToggle.js", ["rxjs/operators/bufferToggle.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var bufferToggle_1 = $__require("rxjs/operators/bufferToggle.js");
  /**
   * Buffers the source Observable values starting from an emission from
   * `openings` and ending when the output of `closingSelector` emits.
   *
   * <span class="informal">Collects values from the past as an array. Starts
   * collecting only when `opening` emits, and calls the `closingSelector`
   * function to get an Observable that tells when to close the buffer.</span>
   *
   * <img src="./img/bufferToggle.png" width="100%">
   *
   * Buffers values from the source by opening the buffer via signals from an
   * Observable provided to `openings`, and closing and sending the buffers when
   * a Subscribable or Promise returned by the `closingSelector` function emits.
   *
   * @example <caption>Every other second, emit the click events from the next 500ms</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var openings = Rx.Observable.interval(1000);
   * var buffered = clicks.bufferToggle(openings, i =>
   *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
   * );
   * buffered.subscribe(x => console.log(x));
   *
   * @see {@link buffer}
   * @see {@link bufferCount}
   * @see {@link bufferTime}
   * @see {@link bufferWhen}
   * @see {@link windowToggle}
   *
   * @param {SubscribableOrPromise<O>} openings A Subscribable or Promise of notifications to start new
   * buffers.
   * @param {function(value: O): SubscribableOrPromise} closingSelector A function that takes
   * the value emitted by the `openings` observable and returns a Subscribable or Promise,
   * which, when it emits, signals that the associated buffer should be emitted
   * and cleared.
   * @return {Observable<T[]>} An observable of arrays of buffered values.
   * @method bufferToggle
   * @owner Observable
   */
  function bufferToggle(openings, closingSelector) {
    return bufferToggle_1.bufferToggle(openings, closingSelector)(this);
  }
  exports.bufferToggle = bufferToggle;
  
});
System.registerDynamic('rxjs/add/operator/bufferToggle.js', ['rxjs/Observable.js', 'rxjs/operator/bufferToggle.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var bufferToggle_1 = $__require('rxjs/operator/bufferToggle.js');
  Observable_1.Observable.prototype.bufferToggle = bufferToggle_1.bufferToggle;
  
});
System.registerDynamic("rxjs/operator/bufferWhen.js", ["rxjs/operators/bufferWhen.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var bufferWhen_1 = $__require("rxjs/operators/bufferWhen.js");
  /**
   * Buffers the source Observable values, using a factory function of closing
   * Observables to determine when to close, emit, and reset the buffer.
   *
   * <span class="informal">Collects values from the past as an array. When it
   * starts collecting values, it calls a function that returns an Observable that
   * tells when to close the buffer and restart collecting.</span>
   *
   * <img src="./img/bufferWhen.png" width="100%">
   *
   * Opens a buffer immediately, then closes the buffer when the observable
   * returned by calling `closingSelector` function emits a value. When it closes
   * the buffer, it immediately opens a new buffer and repeats the process.
   *
   * @example <caption>Emit an array of the last clicks every [1-5] random seconds</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var buffered = clicks.bufferWhen(() =>
   *   Rx.Observable.interval(1000 + Math.random() * 4000)
   * );
   * buffered.subscribe(x => console.log(x));
   *
   * @see {@link buffer}
   * @see {@link bufferCount}
   * @see {@link bufferTime}
   * @see {@link bufferToggle}
   * @see {@link windowWhen}
   *
   * @param {function(): Observable} closingSelector A function that takes no
   * arguments and returns an Observable that signals buffer closure.
   * @return {Observable<T[]>} An observable of arrays of buffered values.
   * @method bufferWhen
   * @owner Observable
   */
  function bufferWhen(closingSelector) {
    return bufferWhen_1.bufferWhen(closingSelector)(this);
  }
  exports.bufferWhen = bufferWhen;
  
});
System.registerDynamic('rxjs/add/operator/bufferWhen.js', ['rxjs/Observable.js', 'rxjs/operator/bufferWhen.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var bufferWhen_1 = $__require('rxjs/operator/bufferWhen.js');
  Observable_1.Observable.prototype.bufferWhen = bufferWhen_1.bufferWhen;
  
});
System.registerDynamic("rxjs/operator/catch.js", ["rxjs/operators/catchError.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var catchError_1 = $__require("rxjs/operators/catchError.js");
  /**
   * Catches errors on the observable to be handled by returning a new observable or throwing an error.
   *
   * <img src="./img/catch.png" width="100%">
   *
   * @example <caption>Continues with a different Observable when there's an error</caption>
   *
   * Observable.of(1, 2, 3, 4, 5)
   *   .map(n => {
   * 	   if (n == 4) {
   * 	     throw 'four!';
   *     }
   *	   return n;
   *   })
   *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
   *   .subscribe(x => console.log(x));
   *   // 1, 2, 3, I, II, III, IV, V
   *
   * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
   *
   * Observable.of(1, 2, 3, 4, 5)
   *   .map(n => {
   * 	   if (n === 4) {
   * 	     throw 'four!';
   *     }
   * 	   return n;
   *   })
   *   .catch((err, caught) => caught)
   *   .take(30)
   *   .subscribe(x => console.log(x));
   *   // 1, 2, 3, 1, 2, 3, ...
   *
   * @example <caption>Throws a new error when the source Observable throws an error</caption>
   *
   * Observable.of(1, 2, 3, 4, 5)
   *   .map(n => {
   *     if (n == 4) {
   *       throw 'four!';
   *     }
   *     return n;
   *   })
   *   .catch(err => {
   *     throw 'error in source. Details: ' + err;
   *   })
   *   .subscribe(
   *     x => console.log(x),
   *     err => console.log(err)
   *   );
   *   // 1, 2, 3, error in source. Details: four!
   *
   * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
   *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
   *  is returned by the `selector` will be used to continue the observable chain.
   * @return {Observable} An observable that originates from either the source or the observable returned by the
   *  catch `selector` function.
   * @method catch
   * @name catch
   * @owner Observable
   */
  function _catch(selector) {
    return catchError_1.catchError(selector)(this);
  }
  exports._catch = _catch;
  
});
System.registerDynamic('rxjs/add/operator/catch.js', ['rxjs/Observable.js', 'rxjs/operator/catch.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var catch_1 = $__require('rxjs/operator/catch.js');
  Observable_1.Observable.prototype.catch = catch_1._catch;
  Observable_1.Observable.prototype._catch = catch_1._catch;
  
});
System.registerDynamic("rxjs/operator/combineAll.js", ["rxjs/operators/combineAll.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var combineAll_1 = $__require("rxjs/operators/combineAll.js");
  /**
   * Converts a higher-order Observable into a first-order Observable by waiting
   * for the outer Observable to complete, then applying {@link combineLatest}.
   *
   * <span class="informal">Flattens an Observable-of-Observables by applying
   * {@link combineLatest} when the Observable-of-Observables completes.</span>
   *
   * <img src="./img/combineAll.png" width="100%">
   *
   * Takes an Observable of Observables, and collects all Observables from it.
   * Once the outer Observable completes, it subscribes to all collected
   * Observables and combines their values using the {@link combineLatest}
   * strategy, such that:
   * - Every time an inner Observable emits, the output Observable emits.
   * - When the returned observable emits, it emits all of the latest values by:
   *   - If a `project` function is provided, it is called with each recent value
   *     from each inner Observable in whatever order they arrived, and the result
   *     of the `project` function is what is emitted by the output Observable.
   *   - If there is no `project` function, an array of all of the most recent
   *     values is emitted by the output Observable.
   *
   * @example <caption>Map two click events to a finite interval Observable, then apply combineAll</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var higherOrder = clicks.map(ev =>
   *   Rx.Observable.interval(Math.random()*2000).take(3)
   * ).take(2);
   * var result = higherOrder.combineAll();
   * result.subscribe(x => console.log(x));
   *
   * @see {@link combineLatest}
   * @see {@link mergeAll}
   *
   * @param {function} [project] An optional function to map the most recent
   * values from each inner Observable into a new result. Takes each of the most
   * recent values from each collected inner Observable as arguments, in order.
   * @return {Observable} An Observable of projected results or arrays of recent
   * values.
   * @method combineAll
   * @owner Observable
   */
  function combineAll(project) {
    return combineAll_1.combineAll(project)(this);
  }
  exports.combineAll = combineAll;
  
});
System.registerDynamic('rxjs/add/operator/combineAll.js', ['rxjs/Observable.js', 'rxjs/operator/combineAll.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var combineAll_1 = $__require('rxjs/operator/combineAll.js');
  Observable_1.Observable.prototype.combineAll = combineAll_1.combineAll;
  
});
System.registerDynamic("rxjs/operator/combineLatest.js", ["rxjs/operators/combineLatest.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var combineLatest_1 = $__require("rxjs/operators/combineLatest.js");
    /* tslint:enable:max-line-length */
    /**
     * Combines multiple Observables to create an Observable whose values are
     * calculated from the latest values of each of its input Observables.
     *
     * <span class="informal">Whenever any input Observable emits a value, it
     * computes a formula using the latest values from all the inputs, then emits
     * the output of that formula.</span>
     *
     * <img src="./img/combineLatest.png" width="100%">
     *
     * `combineLatest` combines the values from this Observable with values from
     * Observables passed as arguments. This is done by subscribing to each
     * Observable, in order, and collecting an array of each of the most recent
     * values any time any of the input Observables emits, then either taking that
     * array and passing it as arguments to an optional `project` function and
     * emitting the return value of that, or just emitting the array of recent
     * values directly if there is no `project` function.
     *
     * @example <caption>Dynamically calculate the Body-Mass Index from an Observable of weight and one for height</caption>
     * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
     * var height = Rx.Observable.of(1.76, 1.77, 1.78);
     * var bmi = weight.combineLatest(height, (w, h) => w / (h * h));
     * bmi.subscribe(x => console.log('BMI is ' + x));
     *
     * // With output to console:
     * // BMI is 24.212293388429753
     * // BMI is 23.93948099205209
     * // BMI is 23.671253629592222
     *
     * @see {@link combineAll}
     * @see {@link merge}
     * @see {@link withLatestFrom}
     *
     * @param {ObservableInput} other An input Observable to combine with the source
     * Observable. More than one input Observables may be given as argument.
     * @param {function} [project] An optional function to project the values from
     * the combined latest values into a new value on the output Observable.
     * @return {Observable} An Observable of projected values from the most recent
     * values from each input Observable, or an array of the most recent values from
     * each input Observable.
     * @method combineLatest
     * @owner Observable
     */
    function combineLatest() {
        var observables = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            observables[_i - 0] = arguments[_i];
        }
        return combineLatest_1.combineLatest.apply(void 0, observables)(this);
    }
    exports.combineLatest = combineLatest;
    
});
System.registerDynamic('rxjs/add/operator/combineLatest.js', ['rxjs/Observable.js', 'rxjs/operator/combineLatest.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var combineLatest_1 = $__require('rxjs/operator/combineLatest.js');
  Observable_1.Observable.prototype.combineLatest = combineLatest_1.combineLatest;
  
});
System.registerDynamic('rxjs/operator/concat.js', ['rxjs/operators/concat.js', 'rxjs/observable/concat.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var concat_1 = $__require('rxjs/operators/concat.js');
    var concat_2 = $__require('rxjs/observable/concat.js');
    exports.concatStatic = concat_2.concat;
    /* tslint:enable:max-line-length */
    /**
     * Creates an output Observable which sequentially emits all values from every
     * given input Observable after the current Observable.
     *
     * <span class="informal">Concatenates multiple Observables together by
     * sequentially emitting their values, one Observable after the other.</span>
     *
     * <img src="./img/concat.png" width="100%">
     *
     * Joins this Observable with multiple other Observables by subscribing to them
     * one at a time, starting with the source, and merging their results into the
     * output Observable. Will wait for each Observable to complete before moving
     * on to the next.
     *
     * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
     * var timer = Rx.Observable.interval(1000).take(4);
     * var sequence = Rx.Observable.range(1, 10);
     * var result = timer.concat(sequence);
     * result.subscribe(x => console.log(x));
     *
     * // results in:
     * // 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
     *
     * @example <caption>Concatenate 3 Observables</caption>
     * var timer1 = Rx.Observable.interval(1000).take(10);
     * var timer2 = Rx.Observable.interval(2000).take(6);
     * var timer3 = Rx.Observable.interval(500).take(10);
     * var result = timer1.concat(timer2, timer3);
     * result.subscribe(x => console.log(x));
     *
     * // results in the following:
     * // (Prints to console sequentially)
     * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
     * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
     * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
     *
     * @see {@link concatAll}
     * @see {@link concatMap}
     * @see {@link concatMapTo}
     *
     * @param {ObservableInput} other An input Observable to concatenate after the source
     * Observable. More than one input Observables may be given as argument.
     * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
     * Observable subscription on.
     * @return {Observable} All values of each passed Observable merged into a
     * single Observable, in order, in serial fashion.
     * @method concat
     * @owner Observable
     */
    function concat() {
        var observables = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            observables[_i - 0] = arguments[_i];
        }
        return concat_1.concat.apply(void 0, observables)(this);
    }
    exports.concat = concat;
    
});
System.registerDynamic('rxjs/add/operator/concat.js', ['rxjs/Observable.js', 'rxjs/operator/concat.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var concat_1 = $__require('rxjs/operator/concat.js');
  Observable_1.Observable.prototype.concat = concat_1.concat;
  
});
System.registerDynamic("rxjs/operator/concatAll.js", ["rxjs/operators/concatAll.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var concatAll_1 = $__require("rxjs/operators/concatAll.js");
  /* tslint:enable:max-line-length */
  /**
   * Converts a higher-order Observable into a first-order Observable by
   * concatenating the inner Observables in order.
   *
   * <span class="informal">Flattens an Observable-of-Observables by putting one
   * inner Observable after the other.</span>
   *
   * <img src="./img/concatAll.png" width="100%">
   *
   * Joins every Observable emitted by the source (a higher-order Observable), in
   * a serial fashion. It subscribes to each inner Observable only after the
   * previous inner Observable has completed, and merges all of their values into
   * the returned observable.
   *
   * __Warning:__ If the source Observable emits Observables quickly and
   * endlessly, and the inner Observables it emits generally complete slower than
   * the source emits, you can run into memory issues as the incoming Observables
   * collect in an unbounded buffer.
   *
   * Note: `concatAll` is equivalent to `mergeAll` with concurrency parameter set
   * to `1`.
   *
   * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var higherOrder = clicks.map(ev => Rx.Observable.interval(1000).take(4));
   * var firstOrder = higherOrder.concatAll();
   * firstOrder.subscribe(x => console.log(x));
   *
   * // Results in the following:
   * // (results are not concurrent)
   * // For every click on the "document" it will emit values 0 to 3 spaced
   * // on a 1000ms interval
   * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
   *
   * @see {@link combineAll}
   * @see {@link concat}
   * @see {@link concatMap}
   * @see {@link concatMapTo}
   * @see {@link exhaust}
   * @see {@link mergeAll}
   * @see {@link switch}
   * @see {@link zipAll}
   *
   * @return {Observable} An Observable emitting values from all the inner
   * Observables concatenated.
   * @method concatAll
   * @owner Observable
   */
  function concatAll() {
    return concatAll_1.concatAll()(this);
  }
  exports.concatAll = concatAll;
  
});
System.registerDynamic('rxjs/add/operator/concatAll.js', ['rxjs/Observable.js', 'rxjs/operator/concatAll.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var concatAll_1 = $__require('rxjs/operator/concatAll.js');
  Observable_1.Observable.prototype.concatAll = concatAll_1.concatAll;
  
});
System.registerDynamic("rxjs/operator/concatMapTo.js", ["rxjs/operators/concatMapTo.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var concatMapTo_1 = $__require("rxjs/operators/concatMapTo.js");
  /* tslint:enable:max-line-length */
  /**
   * Projects each source value to the same Observable which is merged multiple
   * times in a serialized fashion on the output Observable.
   *
   * <span class="informal">It's like {@link concatMap}, but maps each value
   * always to the same inner Observable.</span>
   *
   * <img src="./img/concatMapTo.png" width="100%">
   *
   * Maps each source value to the given Observable `innerObservable` regardless
   * of the source value, and then flattens those resulting Observables into one
   * single Observable, which is the output Observable. Each new `innerObservable`
   * instance emitted on the output Observable is concatenated with the previous
   * `innerObservable` instance.
   *
   * __Warning:__ if source values arrive endlessly and faster than their
   * corresponding inner Observables can complete, it will result in memory issues
   * as inner Observables amass in an unbounded buffer waiting for their turn to
   * be subscribed to.
   *
   * Note: `concatMapTo` is equivalent to `mergeMapTo` with concurrency parameter
   * set to `1`.
   *
   * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var result = clicks.concatMapTo(Rx.Observable.interval(1000).take(4));
   * result.subscribe(x => console.log(x));
   *
   * // Results in the following:
   * // (results are not concurrent)
   * // For every click on the "document" it will emit values 0 to 3 spaced
   * // on a 1000ms interval
   * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
   *
   * @see {@link concat}
   * @see {@link concatAll}
   * @see {@link concatMap}
   * @see {@link mergeMapTo}
   * @see {@link switchMapTo}
   *
   * @param {ObservableInput} innerObservable An Observable to replace each value from
   * the source Observable.
   * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
   * A function to produce the value on the output Observable based on the values
   * and the indices of the source (outer) emission and the inner Observable
   * emission. The arguments passed to this function are:
   * - `outerValue`: the value that came from the source
   * - `innerValue`: the value that came from the projected Observable
   * - `outerIndex`: the "index" of the value that came from the source
   * - `innerIndex`: the "index" of the value from the projected Observable
   * @return {Observable} An observable of values merged together by joining the
   * passed observable with itself, one after the other, for each value emitted
   * from the source.
   * @method concatMapTo
   * @owner Observable
   */
  function concatMapTo(innerObservable, resultSelector) {
    return concatMapTo_1.concatMapTo(innerObservable, resultSelector)(this);
  }
  exports.concatMapTo = concatMapTo;
  
});
System.registerDynamic('rxjs/add/operator/concatMapTo.js', ['rxjs/Observable.js', 'rxjs/operator/concatMapTo.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var concatMapTo_1 = $__require('rxjs/operator/concatMapTo.js');
  Observable_1.Observable.prototype.concatMapTo = concatMapTo_1.concatMapTo;
  
});
System.registerDynamic("rxjs/operator/count.js", ["rxjs/operators/count.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var count_1 = $__require("rxjs/operators/count.js");
  /**
   * Counts the number of emissions on the source and emits that number when the
   * source completes.
   *
   * <span class="informal">Tells how many values were emitted, when the source
   * completes.</span>
   *
   * <img src="./img/count.png" width="100%">
   *
   * `count` transforms an Observable that emits values into an Observable that
   * emits a single value that represents the number of values emitted by the
   * source Observable. If the source Observable terminates with an error, `count`
   * will pass this error notification along without emitting a value first. If
   * the source Observable does not terminate at all, `count` will neither emit
   * a value nor terminate. This operator takes an optional `predicate` function
   * as argument, in which case the output emission will represent the number of
   * source values that matched `true` with the `predicate`.
   *
   * @example <caption>Counts how many seconds have passed before the first click happened</caption>
   * var seconds = Rx.Observable.interval(1000);
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var secondsBeforeClick = seconds.takeUntil(clicks);
   * var result = secondsBeforeClick.count();
   * result.subscribe(x => console.log(x));
   *
   * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
   * var numbers = Rx.Observable.range(1, 7);
   * var result = numbers.count(i => i % 2 === 1);
   * result.subscribe(x => console.log(x));
   *
   * // Results in:
   * // 4
   *
   * @see {@link max}
   * @see {@link min}
   * @see {@link reduce}
   *
   * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
   * boolean function to select what values are to be counted. It is provided with
   * arguments of:
   * - `value`: the value from the source Observable.
   * - `index`: the (zero-based) "index" of the value from the source Observable.
   * - `source`: the source Observable instance itself.
   * @return {Observable} An Observable of one number that represents the count as
   * described above.
   * @method count
   * @owner Observable
   */
  function count(predicate) {
    return count_1.count(predicate)(this);
  }
  exports.count = count;
  
});
System.registerDynamic('rxjs/add/operator/count.js', ['rxjs/Observable.js', 'rxjs/operator/count.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var count_1 = $__require('rxjs/operator/count.js');
  Observable_1.Observable.prototype.count = count_1.count;
  
});
System.registerDynamic("rxjs/operator/dematerialize.js", ["rxjs/operators/dematerialize.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var dematerialize_1 = $__require("rxjs/operators/dematerialize.js");
  /**
   * Converts an Observable of {@link Notification} objects into the emissions
   * that they represent.
   *
   * <span class="informal">Unwraps {@link Notification} objects as actual `next`,
   * `error` and `complete` emissions. The opposite of {@link materialize}.</span>
   *
   * <img src="./img/dematerialize.png" width="100%">
   *
   * `dematerialize` is assumed to operate an Observable that only emits
   * {@link Notification} objects as `next` emissions, and does not emit any
   * `error`. Such Observable is the output of a `materialize` operation. Those
   * notifications are then unwrapped using the metadata they contain, and emitted
   * as `next`, `error`, and `complete` on the output Observable.
   *
   * Use this operator in conjunction with {@link materialize}.
   *
   * @example <caption>Convert an Observable of Notifications to an actual Observable</caption>
   * var notifA = new Rx.Notification('N', 'A');
   * var notifB = new Rx.Notification('N', 'B');
   * var notifE = new Rx.Notification('E', void 0,
   *   new TypeError('x.toUpperCase is not a function')
   * );
   * var materialized = Rx.Observable.of(notifA, notifB, notifE);
   * var upperCase = materialized.dematerialize();
   * upperCase.subscribe(x => console.log(x), e => console.error(e));
   *
   * // Results in:
   * // A
   * // B
   * // TypeError: x.toUpperCase is not a function
   *
   * @see {@link Notification}
   * @see {@link materialize}
   *
   * @return {Observable} An Observable that emits items and notifications
   * embedded in Notification objects emitted by the source Observable.
   * @method dematerialize
   * @owner Observable
   */
  function dematerialize() {
    return dematerialize_1.dematerialize()(this);
  }
  exports.dematerialize = dematerialize;
  
});
System.registerDynamic('rxjs/add/operator/dematerialize.js', ['rxjs/Observable.js', 'rxjs/operator/dematerialize.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var dematerialize_1 = $__require('rxjs/operator/dematerialize.js');
  Observable_1.Observable.prototype.dematerialize = dematerialize_1.dematerialize;
  
});
System.registerDynamic("rxjs/operator/debounce.js", ["rxjs/operators/debounce.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var debounce_1 = $__require("rxjs/operators/debounce.js");
  /**
   * Emits a value from the source Observable only after a particular time span
   * determined by another Observable has passed without another source emission.
   *
   * <span class="informal">It's like {@link debounceTime}, but the time span of
   * emission silence is determined by a second Observable.</span>
   *
   * <img src="./img/debounce.png" width="100%">
   *
   * `debounce` delays values emitted by the source Observable, but drops previous
   * pending delayed emissions if a new value arrives on the source Observable.
   * This operator keeps track of the most recent value from the source
   * Observable, and spawns a duration Observable by calling the
   * `durationSelector` function. The value is emitted only when the duration
   * Observable emits a value or completes, and if no other value was emitted on
   * the source Observable since the duration Observable was spawned. If a new
   * value appears before the duration Observable emits, the previous value will
   * be dropped and will not be emitted on the output Observable.
   *
   * Like {@link debounceTime}, this is a rate-limiting operator, and also a
   * delay-like operator since output emissions do not necessarily occur at the
   * same time as they did on the source Observable.
   *
   * @example <caption>Emit the most recent click after a burst of clicks</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var result = clicks.debounce(() => Rx.Observable.interval(1000));
   * result.subscribe(x => console.log(x));
   *
   * @see {@link audit}
   * @see {@link debounceTime}
   * @see {@link delayWhen}
   * @see {@link throttle}
   *
   * @param {function(value: T): SubscribableOrPromise} durationSelector A function
   * that receives a value from the source Observable, for computing the timeout
   * duration for each source value, returned as an Observable or a Promise.
   * @return {Observable} An Observable that delays the emissions of the source
   * Observable by the specified duration Observable returned by
   * `durationSelector`, and may drop some values if they occur too frequently.
   * @method debounce
   * @owner Observable
   */
  function debounce(durationSelector) {
    return debounce_1.debounce(durationSelector)(this);
  }
  exports.debounce = debounce;
  
});
System.registerDynamic('rxjs/add/operator/debounce.js', ['rxjs/Observable.js', 'rxjs/operator/debounce.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var debounce_1 = $__require('rxjs/operator/debounce.js');
  Observable_1.Observable.prototype.debounce = debounce_1.debounce;
  
});
System.registerDynamic('rxjs/operator/debounceTime.js', ['rxjs/scheduler/async.js', 'rxjs/operators/debounceTime.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var async_1 = $__require('rxjs/scheduler/async.js');
  var debounceTime_1 = $__require('rxjs/operators/debounceTime.js');
  /**
   * Emits a value from the source Observable only after a particular time span
   * has passed without another source emission.
   *
   * <span class="informal">It's like {@link delay}, but passes only the most
   * recent value from each burst of emissions.</span>
   *
   * <img src="./img/debounceTime.png" width="100%">
   *
   * `debounceTime` delays values emitted by the source Observable, but drops
   * previous pending delayed emissions if a new value arrives on the source
   * Observable. This operator keeps track of the most recent value from the
   * source Observable, and emits that only when `dueTime` enough time has passed
   * without any other value appearing on the source Observable. If a new value
   * appears before `dueTime` silence occurs, the previous value will be dropped
   * and will not be emitted on the output Observable.
   *
   * This is a rate-limiting operator, because it is impossible for more than one
   * value to be emitted in any time window of duration `dueTime`, but it is also
   * a delay-like operator since output emissions do not occur at the same time as
   * they did on the source Observable. Optionally takes a {@link IScheduler} for
   * managing timers.
   *
   * @example <caption>Emit the most recent click after a burst of clicks</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var result = clicks.debounceTime(1000);
   * result.subscribe(x => console.log(x));
   *
   * @see {@link auditTime}
   * @see {@link debounce}
   * @see {@link delay}
   * @see {@link sampleTime}
   * @see {@link throttleTime}
   *
   * @param {number} dueTime The timeout duration in milliseconds (or the time
   * unit determined internally by the optional `scheduler`) for the window of
   * time required to wait for emission silence before emitting the most recent
   * source value.
   * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
   * managing the timers that handle the timeout for each value.
   * @return {Observable} An Observable that delays the emissions of the source
   * Observable by the specified `dueTime`, and may drop some values if they occur
   * too frequently.
   * @method debounceTime
   * @owner Observable
   */
  function debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) {
      scheduler = async_1.async;
    }
    return debounceTime_1.debounceTime(dueTime, scheduler)(this);
  }
  exports.debounceTime = debounceTime;
  
});
System.registerDynamic('rxjs/add/operator/debounceTime.js', ['rxjs/Observable.js', 'rxjs/operator/debounceTime.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var debounceTime_1 = $__require('rxjs/operator/debounceTime.js');
  Observable_1.Observable.prototype.debounceTime = debounceTime_1.debounceTime;
  
});
System.registerDynamic("rxjs/operator/defaultIfEmpty.js", ["rxjs/operators/defaultIfEmpty.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var defaultIfEmpty_1 = $__require("rxjs/operators/defaultIfEmpty.js");
  /* tslint:enable:max-line-length */
  /**
   * Emits a given value if the source Observable completes without emitting any
   * `next` value, otherwise mirrors the source Observable.
   *
   * <span class="informal">If the source Observable turns out to be empty, then
   * this operator will emit a default value.</span>
   *
   * <img src="./img/defaultIfEmpty.png" width="100%">
   *
   * `defaultIfEmpty` emits the values emitted by the source Observable or a
   * specified default value if the source Observable is empty (completes without
   * having emitted any `next` value).
   *
   * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
   * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
   * result.subscribe(x => console.log(x));
   *
   * @see {@link empty}
   * @see {@link last}
   *
   * @param {any} [defaultValue=null] The default value used if the source
   * Observable is empty.
   * @return {Observable} An Observable that emits either the specified
   * `defaultValue` if the source Observable emits no items, or the values emitted
   * by the source Observable.
   * @method defaultIfEmpty
   * @owner Observable
   */
  function defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) {
      defaultValue = null;
    }
    return defaultIfEmpty_1.defaultIfEmpty(defaultValue)(this);
  }
  exports.defaultIfEmpty = defaultIfEmpty;
  
});
System.registerDynamic('rxjs/add/operator/defaultIfEmpty.js', ['rxjs/Observable.js', 'rxjs/operator/defaultIfEmpty.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var defaultIfEmpty_1 = $__require('rxjs/operator/defaultIfEmpty.js');
  Observable_1.Observable.prototype.defaultIfEmpty = defaultIfEmpty_1.defaultIfEmpty;
  
});
System.registerDynamic('rxjs/operator/delay.js', ['rxjs/scheduler/async.js', 'rxjs/operators/delay.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var async_1 = $__require('rxjs/scheduler/async.js');
  var delay_1 = $__require('rxjs/operators/delay.js');
  /**
   * Delays the emission of items from the source Observable by a given timeout or
   * until a given Date.
   *
   * <span class="informal">Time shifts each item by some specified amount of
   * milliseconds.</span>
   *
   * <img src="./img/delay.png" width="100%">
   *
   * If the delay argument is a Number, this operator time shifts the source
   * Observable by that amount of time expressed in milliseconds. The relative
   * time intervals between the values are preserved.
   *
   * If the delay argument is a Date, this operator time shifts the start of the
   * Observable execution until the given date occurs.
   *
   * @example <caption>Delay each click by one second</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
   * delayedClicks.subscribe(x => console.log(x));
   *
   * @example <caption>Delay all clicks until a future date happens</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var date = new Date('March 15, 2050 12:00:00'); // in the future
   * var delayedClicks = clicks.delay(date); // click emitted only after that date
   * delayedClicks.subscribe(x => console.log(x));
   *
   * @see {@link debounceTime}
   * @see {@link delayWhen}
   *
   * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
   * a `Date` until which the emission of the source items is delayed.
   * @param {Scheduler} [scheduler=async] The IScheduler to use for
   * managing the timers that handle the time-shift for each item.
   * @return {Observable} An Observable that delays the emissions of the source
   * Observable by the specified timeout or Date.
   * @method delay
   * @owner Observable
   */
  function delay(delay, scheduler) {
    if (scheduler === void 0) {
      scheduler = async_1.async;
    }
    return delay_1.delay(delay, scheduler)(this);
  }
  exports.delay = delay;
  
});
System.registerDynamic('rxjs/add/operator/delay.js', ['rxjs/Observable.js', 'rxjs/operator/delay.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var delay_1 = $__require('rxjs/operator/delay.js');
  Observable_1.Observable.prototype.delay = delay_1.delay;
  
});
System.registerDynamic("rxjs/operator/delayWhen.js", ["rxjs/operators/delayWhen.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var delayWhen_1 = $__require("rxjs/operators/delayWhen.js");
  /**
   * Delays the emission of items from the source Observable by a given time span
   * determined by the emissions of another Observable.
   *
   * <span class="informal">It's like {@link delay}, but the time span of the
   * delay duration is determined by a second Observable.</span>
   *
   * <img src="./img/delayWhen.png" width="100%">
   *
   * `delayWhen` time shifts each emitted value from the source Observable by a
   * time span determined by another Observable. When the source emits a value,
   * the `delayDurationSelector` function is called with the source value as
   * argument, and should return an Observable, called the "duration" Observable.
   * The source value is emitted on the output Observable only when the duration
   * Observable emits a value or completes.
   *
   * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
   * is an Observable. When `subscriptionDelay` emits its first value or
   * completes, the source Observable is subscribed to and starts behaving like
   * described in the previous paragraph. If `subscriptionDelay` is not provided,
   * `delayWhen` will subscribe to the source Observable as soon as the output
   * Observable is subscribed.
   *
   * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var delayedClicks = clicks.delayWhen(event =>
   *   Rx.Observable.interval(Math.random() * 5000)
   * );
   * delayedClicks.subscribe(x => console.log(x));
   *
   * @see {@link debounce}
   * @see {@link delay}
   *
   * @param {function(value: T): Observable} delayDurationSelector A function that
   * returns an Observable for each value emitted by the source Observable, which
   * is then used to delay the emission of that item on the output Observable
   * until the Observable returned from this function emits a value.
   * @param {Observable} subscriptionDelay An Observable that triggers the
   * subscription to the source Observable once it emits any value.
   * @return {Observable} An Observable that delays the emissions of the source
   * Observable by an amount of time specified by the Observable returned by
   * `delayDurationSelector`.
   * @method delayWhen
   * @owner Observable
   */
  function delayWhen(delayDurationSelector, subscriptionDelay) {
    return delayWhen_1.delayWhen(delayDurationSelector, subscriptionDelay)(this);
  }
  exports.delayWhen = delayWhen;
  
});
System.registerDynamic('rxjs/add/operator/delayWhen.js', ['rxjs/Observable.js', 'rxjs/operator/delayWhen.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var delayWhen_1 = $__require('rxjs/operator/delayWhen.js');
  Observable_1.Observable.prototype.delayWhen = delayWhen_1.delayWhen;
  
});
System.registerDynamic("rxjs/operator/distinct.js", ["rxjs/operators/distinct.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var distinct_1 = $__require("rxjs/operators/distinct.js");
  /**
   * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from previous items.
   *
   * If a keySelector function is provided, then it will project each value from the source observable into a new value that it will
   * check for equality with previously projected values. If a keySelector function is not provided, it will use each value from the
   * source observable directly with an equality check against previous values.
   *
   * In JavaScript runtimes that support `Set`, this operator will use a `Set` to improve performance of the distinct value checking.
   *
   * In other runtimes, this operator will use a minimal implementation of `Set` that relies on an `Array` and `indexOf` under the
   * hood, so performance will degrade as more values are checked for distinction. Even in newer browsers, a long-running `distinct`
   * use might result in memory leaks. To help alleviate this in some scenarios, an optional `flushes` parameter is also provided so
   * that the internal `Set` can be "flushed", basically clearing it of values.
   *
   * @example <caption>A simple example with numbers</caption>
   * Observable.of(1, 1, 2, 2, 2, 1, 2, 3, 4, 3, 2, 1)
   *   .distinct()
   *   .subscribe(x => console.log(x)); // 1, 2, 3, 4
   *
   * @example <caption>An example using a keySelector function</caption>
   * interface Person {
   *    age: number,
   *    name: string
   * }
   *
   * Observable.of<Person>(
   *     { age: 4, name: 'Foo'},
   *     { age: 7, name: 'Bar'},
   *     { age: 5, name: 'Foo'})
   *     .distinct((p: Person) => p.name)
   *     .subscribe(x => console.log(x));
   *
   * // displays:
   * // { age: 4, name: 'Foo' }
   * // { age: 7, name: 'Bar' }
   *
   * @see {@link distinctUntilChanged}
   * @see {@link distinctUntilKeyChanged}
   *
   * @param {function} [keySelector] Optional function to select which value you want to check as distinct.
   * @param {Observable} [flushes] Optional Observable for flushing the internal HashSet of the operator.
   * @return {Observable} An Observable that emits items from the source Observable with distinct values.
   * @method distinct
   * @owner Observable
   */
  function distinct(keySelector, flushes) {
    return distinct_1.distinct(keySelector, flushes)(this);
  }
  exports.distinct = distinct;
  
});
System.registerDynamic('rxjs/add/operator/distinct.js', ['rxjs/Observable.js', 'rxjs/operator/distinct.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var distinct_1 = $__require('rxjs/operator/distinct.js');
  Observable_1.Observable.prototype.distinct = distinct_1.distinct;
  
});
System.registerDynamic("rxjs/operator/distinctUntilChanged.js", ["rxjs/operators/distinctUntilChanged.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var distinctUntilChanged_1 = $__require("rxjs/operators/distinctUntilChanged.js");
  /* tslint:enable:max-line-length */
  /**
   * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
   *
   * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
   *
   * If a comparator function is not provided, an equality check is used by default.
   *
   * @example <caption>A simple example with numbers</caption>
   * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
   *   .distinctUntilChanged()
   *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
   *
   * @example <caption>An example using a compare function</caption>
   * interface Person {
   *    age: number,
   *    name: string
   * }
   *
   * Observable.of<Person>(
   *     { age: 4, name: 'Foo'},
   *     { age: 7, name: 'Bar'},
   *     { age: 5, name: 'Foo'})
   *     { age: 6, name: 'Foo'})
   *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
   *     .subscribe(x => console.log(x));
   *
   * // displays:
   * // { age: 4, name: 'Foo' }
   * // { age: 7, name: 'Bar' }
   * // { age: 5, name: 'Foo' }
   *
   * @see {@link distinct}
   * @see {@link distinctUntilKeyChanged}
   *
   * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
   * @return {Observable} An Observable that emits items from the source Observable with distinct values.
   * @method distinctUntilChanged
   * @owner Observable
   */
  function distinctUntilChanged(compare, keySelector) {
    return distinctUntilChanged_1.distinctUntilChanged(compare, keySelector)(this);
  }
  exports.distinctUntilChanged = distinctUntilChanged;
  
});
System.registerDynamic('rxjs/add/operator/distinctUntilChanged.js', ['rxjs/Observable.js', 'rxjs/operator/distinctUntilChanged.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var distinctUntilChanged_1 = $__require('rxjs/operator/distinctUntilChanged.js');
  Observable_1.Observable.prototype.distinctUntilChanged = distinctUntilChanged_1.distinctUntilChanged;
  
});
System.registerDynamic("rxjs/operator/distinctUntilKeyChanged.js", ["rxjs/operators/distinctUntilKeyChanged.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var distinctUntilKeyChanged_1 = $__require("rxjs/operators/distinctUntilKeyChanged.js");
  /* tslint:enable:max-line-length */
  /**
   * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item,
   * using a property accessed by using the key provided to check if the two items are distinct.
   *
   * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
   *
   * If a comparator function is not provided, an equality check is used by default.
   *
   * @example <caption>An example comparing the name of persons</caption>
   *
   *  interface Person {
   *     age: number,
   *     name: string
   *  }
   *
   * Observable.of<Person>(
   *     { age: 4, name: 'Foo'},
   *     { age: 7, name: 'Bar'},
   *     { age: 5, name: 'Foo'},
   *     { age: 6, name: 'Foo'})
   *     .distinctUntilKeyChanged('name')
   *     .subscribe(x => console.log(x));
   *
   * // displays:
   * // { age: 4, name: 'Foo' }
   * // { age: 7, name: 'Bar' }
   * // { age: 5, name: 'Foo' }
   *
   * @example <caption>An example comparing the first letters of the name</caption>
   *
   * interface Person {
   *     age: number,
   *     name: string
   *  }
   *
   * Observable.of<Person>(
   *     { age: 4, name: 'Foo1'},
   *     { age: 7, name: 'Bar'},
   *     { age: 5, name: 'Foo2'},
   *     { age: 6, name: 'Foo3'})
   *     .distinctUntilKeyChanged('name', (x: string, y: string) => x.substring(0, 3) === y.substring(0, 3))
   *     .subscribe(x => console.log(x));
   *
   * // displays:
   * // { age: 4, name: 'Foo1' }
   * // { age: 7, name: 'Bar' }
   * // { age: 5, name: 'Foo2' }
   *
   * @see {@link distinct}
   * @see {@link distinctUntilChanged}
   *
   * @param {string} key String key for object property lookup on each item.
   * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
   * @return {Observable} An Observable that emits items from the source Observable with distinct values based on the key specified.
   * @method distinctUntilKeyChanged
   * @owner Observable
   */
  function distinctUntilKeyChanged(key, compare) {
    return distinctUntilKeyChanged_1.distinctUntilKeyChanged(key, compare)(this);
  }
  exports.distinctUntilKeyChanged = distinctUntilKeyChanged;
  
});
System.registerDynamic('rxjs/add/operator/distinctUntilKeyChanged.js', ['rxjs/Observable.js', 'rxjs/operator/distinctUntilKeyChanged.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var distinctUntilKeyChanged_1 = $__require('rxjs/operator/distinctUntilKeyChanged.js');
  Observable_1.Observable.prototype.distinctUntilKeyChanged = distinctUntilKeyChanged_1.distinctUntilKeyChanged;
  
});
System.registerDynamic("rxjs/operator/exhaust.js", ["rxjs/operators/exhaust.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var exhaust_1 = $__require("rxjs/operators/exhaust.js");
  /**
   * Converts a higher-order Observable into a first-order Observable by dropping
   * inner Observables while the previous inner Observable has not yet completed.
   *
   * <span class="informal">Flattens an Observable-of-Observables by dropping the
   * next inner Observables while the current inner is still executing.</span>
   *
   * <img src="./img/exhaust.png" width="100%">
   *
   * `exhaust` subscribes to an Observable that emits Observables, also known as a
   * higher-order Observable. Each time it observes one of these emitted inner
   * Observables, the output Observable begins emitting the items emitted by that
   * inner Observable. So far, it behaves like {@link mergeAll}. However,
   * `exhaust` ignores every new inner Observable if the previous Observable has
   * not yet completed. Once that one completes, it will accept and flatten the
   * next inner Observable and repeat this process.
   *
   * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(5));
   * var result = higherOrder.exhaust();
   * result.subscribe(x => console.log(x));
   *
   * @see {@link combineAll}
   * @see {@link concatAll}
   * @see {@link switch}
   * @see {@link mergeAll}
   * @see {@link exhaustMap}
   * @see {@link zipAll}
   *
   * @return {Observable} An Observable that takes a source of Observables and propagates the first observable
   * exclusively until it completes before subscribing to the next.
   * @method exhaust
   * @owner Observable
   */
  function exhaust() {
    return exhaust_1.exhaust()(this);
  }
  exports.exhaust = exhaust;
  
});
System.registerDynamic('rxjs/add/operator/exhaust.js', ['rxjs/Observable.js', 'rxjs/operator/exhaust.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var exhaust_1 = $__require('rxjs/operator/exhaust.js');
  Observable_1.Observable.prototype.exhaust = exhaust_1.exhaust;
  
});
System.registerDynamic("rxjs/operator/exhaustMap.js", ["rxjs/operators/exhaustMap.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var exhaustMap_1 = $__require("rxjs/operators/exhaustMap.js");
  /* tslint:enable:max-line-length */
  /**
   * Projects each source value to an Observable which is merged in the output
   * Observable only if the previous projected Observable has completed.
   *
   * <span class="informal">Maps each value to an Observable, then flattens all of
   * these inner Observables using {@link exhaust}.</span>
   *
   * <img src="./img/exhaustMap.png" width="100%">
   *
   * Returns an Observable that emits items based on applying a function that you
   * supply to each item emitted by the source Observable, where that function
   * returns an (so-called "inner") Observable. When it projects a source value to
   * an Observable, the output Observable begins emitting the items emitted by
   * that projected Observable. However, `exhaustMap` ignores every new projected
   * Observable if the previous projected Observable has not yet completed. Once
   * that one completes, it will accept and flatten the next projected Observable
   * and repeat this process.
   *
   * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var result = clicks.exhaustMap((ev) => Rx.Observable.interval(1000).take(5));
   * result.subscribe(x => console.log(x));
   *
   * @see {@link concatMap}
   * @see {@link exhaust}
   * @see {@link mergeMap}
   * @see {@link switchMap}
   *
   * @param {function(value: T, ?index: number): ObservableInput} project A function
   * that, when applied to an item emitted by the source Observable, returns an
   * Observable.
   * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
   * A function to produce the value on the output Observable based on the values
   * and the indices of the source (outer) emission and the inner Observable
   * emission. The arguments passed to this function are:
   * - `outerValue`: the value that came from the source
   * - `innerValue`: the value that came from the projected Observable
   * - `outerIndex`: the "index" of the value that came from the source
   * - `innerIndex`: the "index" of the value from the projected Observable
   * @return {Observable} An Observable containing projected Observables
   * of each item of the source, ignoring projected Observables that start before
   * their preceding Observable has completed.
   * @method exhaustMap
   * @owner Observable
   */
  function exhaustMap(project, resultSelector) {
    return exhaustMap_1.exhaustMap(project, resultSelector)(this);
  }
  exports.exhaustMap = exhaustMap;
  
});
System.registerDynamic('rxjs/add/operator/exhaustMap.js', ['rxjs/Observable.js', 'rxjs/operator/exhaustMap.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var exhaustMap_1 = $__require('rxjs/operator/exhaustMap.js');
  Observable_1.Observable.prototype.exhaustMap = exhaustMap_1.exhaustMap;
  
});
System.registerDynamic("rxjs/operator/expand.js", ["rxjs/operators/expand.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var expand_1 = $__require("rxjs/operators/expand.js");
  /* tslint:enable:max-line-length */
  /**
   * Recursively projects each source value to an Observable which is merged in
   * the output Observable.
   *
   * <span class="informal">It's similar to {@link mergeMap}, but applies the
   * projection function to every source value as well as every output value.
   * It's recursive.</span>
   *
   * <img src="./img/expand.png" width="100%">
   *
   * Returns an Observable that emits items based on applying a function that you
   * supply to each item emitted by the source Observable, where that function
   * returns an Observable, and then merging those resulting Observables and
   * emitting the results of this merger. *Expand* will re-emit on the output
   * Observable every source value. Then, each output value is given to the
   * `project` function which returns an inner Observable to be merged on the
   * output Observable. Those output values resulting from the projection are also
   * given to the `project` function to produce new output values. This is how
   * *expand* behaves recursively.
   *
   * @example <caption>Start emitting the powers of two on every click, at most 10 of them</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var powersOfTwo = clicks
   *   .mapTo(1)
   *   .expand(x => Rx.Observable.of(2 * x).delay(1000))
   *   .take(10);
   * powersOfTwo.subscribe(x => console.log(x));
   *
   * @see {@link mergeMap}
   * @see {@link mergeScan}
   *
   * @param {function(value: T, index: number) => Observable} project A function
   * that, when applied to an item emitted by the source or the output Observable,
   * returns an Observable.
   * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
   * Observables being subscribed to concurrently.
   * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
   * each projected inner Observable.
   * @return {Observable} An Observable that emits the source values and also
   * result of applying the projection function to each value emitted on the
   * output Observable and and merging the results of the Observables obtained
   * from this transformation.
   * @method expand
   * @owner Observable
   */
  function expand(project, concurrent, scheduler) {
    if (concurrent === void 0) {
      concurrent = Number.POSITIVE_INFINITY;
    }
    if (scheduler === void 0) {
      scheduler = undefined;
    }
    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
    return expand_1.expand(project, concurrent, scheduler)(this);
  }
  exports.expand = expand;
  
});
System.registerDynamic('rxjs/add/operator/expand.js', ['rxjs/Observable.js', 'rxjs/operator/expand.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var expand_1 = $__require('rxjs/operator/expand.js');
  Observable_1.Observable.prototype.expand = expand_1.expand;
  
});
System.registerDynamic("rxjs/operator/elementAt.js", ["rxjs/operators/elementAt.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var elementAt_1 = $__require("rxjs/operators/elementAt.js");
  /**
   * Emits the single value at the specified `index` in a sequence of emissions
   * from the source Observable.
   *
   * <span class="informal">Emits only the i-th value, then completes.</span>
   *
   * <img src="./img/elementAt.png" width="100%">
   *
   * `elementAt` returns an Observable that emits the item at the specified
   * `index` in the source Observable, or a default value if that `index` is out
   * of range and the `default` argument is provided. If the `default` argument is
   * not given and the `index` is out of range, the output Observable will emit an
   * `ArgumentOutOfRangeError` error.
   *
   * @example <caption>Emit only the third click event</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var result = clicks.elementAt(2);
   * result.subscribe(x => console.log(x));
   *
   * // Results in:
   * // click 1 = nothing
   * // click 2 = nothing
   * // click 3 = MouseEvent object logged to console
   *
   * @see {@link first}
   * @see {@link last}
   * @see {@link skip}
   * @see {@link single}
   * @see {@link take}
   *
   * @throws {ArgumentOutOfRangeError} When using `elementAt(i)`, it delivers an
   * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0` or the
   * Observable has completed before emitting the i-th `next` notification.
   *
   * @param {number} index Is the number `i` for the i-th source emission that has
   * happened since the subscription, starting from the number `0`.
   * @param {T} [defaultValue] The default value returned for missing indices.
   * @return {Observable} An Observable that emits a single item, if it is found.
   * Otherwise, will emit the default value if given. If not, then emits an error.
   * @method elementAt
   * @owner Observable
   */
  function elementAt(index, defaultValue) {
    return elementAt_1.elementAt(index, defaultValue)(this);
  }
  exports.elementAt = elementAt;
  
});
System.registerDynamic('rxjs/add/operator/elementAt.js', ['rxjs/Observable.js', 'rxjs/operator/elementAt.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var elementAt_1 = $__require('rxjs/operator/elementAt.js');
  Observable_1.Observable.prototype.elementAt = elementAt_1.elementAt;
  
});
System.registerDynamic("rxjs/operator/filter.js", ["rxjs/operators/filter.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var filter_1 = $__require("rxjs/operators/filter.js");
  /* tslint:enable:max-line-length */
  /**
   * Filter items emitted by the source Observable by only emitting those that
   * satisfy a specified predicate.
   *
   * <span class="informal">Like
   * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
   * it only emits a value from the source if it passes a criterion function.</span>
   *
   * <img src="./img/filter.png" width="100%">
   *
   * Similar to the well-known `Array.prototype.filter` method, this operator
   * takes values from the source Observable, passes them through a `predicate`
   * function and only emits those values that yielded `true`.
   *
   * @example <caption>Emit only click events whose target was a DIV element</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
   * clicksOnDivs.subscribe(x => console.log(x));
   *
   * @see {@link distinct}
   * @see {@link distinctUntilChanged}
   * @see {@link distinctUntilKeyChanged}
   * @see {@link ignoreElements}
   * @see {@link partition}
   * @see {@link skip}
   *
   * @param {function(value: T, index: number): boolean} predicate A function that
   * evaluates each value emitted by the source Observable. If it returns `true`,
   * the value is emitted, if `false` the value is not passed to the output
   * Observable. The `index` parameter is the number `i` for the i-th source
   * emission that has happened since the subscription, starting from the number
   * `0`.
   * @param {any} [thisArg] An optional argument to determine the value of `this`
   * in the `predicate` function.
   * @return {Observable} An Observable of values from the source that were
   * allowed by the `predicate` function.
   * @method filter
   * @owner Observable
   */
  function filter(predicate, thisArg) {
    return filter_1.filter(predicate, thisArg)(this);
  }
  exports.filter = filter;
  
});
System.registerDynamic('rxjs/add/operator/filter.js', ['rxjs/Observable.js', 'rxjs/operator/filter.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var filter_1 = $__require('rxjs/operator/filter.js');
  Observable_1.Observable.prototype.filter = filter_1.filter;
  
});
System.registerDynamic("rxjs/operator/finally.js", ["rxjs/operators/finalize.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var finalize_1 = $__require("rxjs/operators/finalize.js");
  /**
   * Returns an Observable that mirrors the source Observable, but will call a specified function when
   * the source terminates on complete or error.
   * @param {function} callback Function to be called when source terminates.
   * @return {Observable} An Observable that mirrors the source, but will call the specified function on termination.
   * @method finally
   * @owner Observable
   */
  function _finally(callback) {
    return finalize_1.finalize(callback)(this);
  }
  exports._finally = _finally;
  
});
System.registerDynamic('rxjs/add/operator/finally.js', ['rxjs/Observable.js', 'rxjs/operator/finally.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var finally_1 = $__require('rxjs/operator/finally.js');
  Observable_1.Observable.prototype.finally = finally_1._finally;
  Observable_1.Observable.prototype._finally = finally_1._finally;
  
});
System.registerDynamic("rxjs/operator/find.js", ["rxjs/operators/find.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var find_1 = $__require("rxjs/operators/find.js");
  /* tslint:enable:max-line-length */
  /**
   * Emits only the first value emitted by the source Observable that meets some
   * condition.
   *
   * <span class="informal">Finds the first value that passes some test and emits
   * that.</span>
   *
   * <img src="./img/find.png" width="100%">
   *
   * `find` searches for the first item in the source Observable that matches the
   * specified condition embodied by the `predicate`, and returns the first
   * occurrence in the source. Unlike {@link first}, the `predicate` is required
   * in `find`, and does not emit an error if a valid value is not found.
   *
   * @example <caption>Find and emit the first click that happens on a DIV element</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var result = clicks.find(ev => ev.target.tagName === 'DIV');
   * result.subscribe(x => console.log(x));
   *
   * @see {@link filter}
   * @see {@link first}
   * @see {@link findIndex}
   * @see {@link take}
   *
   * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
   * A function called with each item to test for condition matching.
   * @param {any} [thisArg] An optional argument to determine the value of `this`
   * in the `predicate` function.
   * @return {Observable<T>} An Observable of the first item that matches the
   * condition.
   * @method find
   * @owner Observable
   */
  function find(predicate, thisArg) {
    return find_1.find(predicate, thisArg)(this);
  }
  exports.find = find;
  
});
System.registerDynamic('rxjs/add/operator/find.js', ['rxjs/Observable.js', 'rxjs/operator/find.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var find_1 = $__require('rxjs/operator/find.js');
  Observable_1.Observable.prototype.find = find_1.find;
  
});
System.registerDynamic("rxjs/operator/findIndex.js", ["rxjs/operators/findIndex.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var findIndex_1 = $__require("rxjs/operators/findIndex.js");
  /**
   * Emits only the index of the first value emitted by the source Observable that
   * meets some condition.
   *
   * <span class="informal">It's like {@link find}, but emits the index of the
   * found value, not the value itself.</span>
   *
   * <img src="./img/findIndex.png" width="100%">
   *
   * `findIndex` searches for the first item in the source Observable that matches
   * the specified condition embodied by the `predicate`, and returns the
   * (zero-based) index of the first occurrence in the source. Unlike
   * {@link first}, the `predicate` is required in `findIndex`, and does not emit
   * an error if a valid value is not found.
   *
   * @example <caption>Emit the index of first click that happens on a DIV element</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var result = clicks.findIndex(ev => ev.target.tagName === 'DIV');
   * result.subscribe(x => console.log(x));
   *
   * @see {@link filter}
   * @see {@link find}
   * @see {@link first}
   * @see {@link take}
   *
   * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
   * A function called with each item to test for condition matching.
   * @param {any} [thisArg] An optional argument to determine the value of `this`
   * in the `predicate` function.
   * @return {Observable} An Observable of the index of the first item that
   * matches the condition.
   * @method find
   * @owner Observable
   */
  function findIndex(predicate, thisArg) {
    return findIndex_1.findIndex(predicate, thisArg)(this);
  }
  exports.findIndex = findIndex;
  
});
System.registerDynamic('rxjs/add/operator/findIndex.js', ['rxjs/Observable.js', 'rxjs/operator/findIndex.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var findIndex_1 = $__require('rxjs/operator/findIndex.js');
  Observable_1.Observable.prototype.findIndex = findIndex_1.findIndex;
  
});
System.registerDynamic("rxjs/operator/first.js", ["rxjs/operators/first.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var first_1 = $__require("rxjs/operators/first.js");
  /**
   * Emits only the first value (or the first value that meets some condition)
   * emitted by the source Observable.
   *
   * <span class="informal">Emits only the first value. Or emits only the first
   * value that passes some test.</span>
   *
   * <img src="./img/first.png" width="100%">
   *
   * If called with no arguments, `first` emits the first value of the source
   * Observable, then completes. If called with a `predicate` function, `first`
   * emits the first value of the source that matches the specified condition. It
   * may also take a `resultSelector` function to produce the output value from
   * the input value, and a `defaultValue` to emit in case the source completes
   * before it is able to emit a valid value. Throws an error if `defaultValue`
   * was not provided and a matching element is not found.
   *
   * @example <caption>Emit only the first click that happens on the DOM</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var result = clicks.first();
   * result.subscribe(x => console.log(x));
   *
   * @example <caption>Emits the first click that happens on a DIV</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var result = clicks.first(ev => ev.target.tagName === 'DIV');
   * result.subscribe(x => console.log(x));
   *
   * @see {@link filter}
   * @see {@link find}
   * @see {@link take}
   *
   * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
   * callback if the Observable completes before any `next` notification was sent.
   *
   * @param {function(value: T, index: number, source: Observable<T>): boolean} [predicate]
   * An optional function called with each item to test for condition matching.
   * @param {function(value: T, index: number): R} [resultSelector] A function to
   * produce the value on the output Observable based on the values
   * and the indices of the source Observable. The arguments passed to this
   * function are:
   * - `value`: the value that was emitted on the source.
   * - `index`: the "index" of the value from the source.
   * @param {R} [defaultValue] The default value emitted in case no valid value
   * was found on the source.
   * @return {Observable<T|R>} An Observable of the first item that matches the
   * condition.
   * @method first
   * @owner Observable
   */
  function first(predicate, resultSelector, defaultValue) {
    return first_1.first(predicate, resultSelector, defaultValue)(this);
  }
  exports.first = first;
  
});
System.registerDynamic('rxjs/add/operator/first.js', ['rxjs/Observable.js', 'rxjs/operator/first.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var first_1 = $__require('rxjs/operator/first.js');
  Observable_1.Observable.prototype.first = first_1.first;
  
});
System.registerDynamic("rxjs/operator/groupBy.js", ["rxjs/operators/groupBy.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var groupBy_1 = $__require("rxjs/operators/groupBy.js");
  exports.GroupedObservable = groupBy_1.GroupedObservable;
  /* tslint:enable:max-line-length */
  /**
   * Groups the items emitted by an Observable according to a specified criterion,
   * and emits these grouped items as `GroupedObservables`, one
   * {@link GroupedObservable} per group.
   *
   * <img src="./img/groupBy.png" width="100%">
   *
   * @example <caption>Group objects by id and return as array</caption>
   * Observable.of<Obj>({id: 1, name: 'aze1'},
   *                    {id: 2, name: 'sf2'},
   *                    {id: 2, name: 'dg2'},
   *                    {id: 1, name: 'erg1'},
   *                    {id: 1, name: 'df1'},
   *                    {id: 2, name: 'sfqfb2'},
   *                    {id: 3, name: 'qfs3'},
   *                    {id: 2, name: 'qsgqsfg2'}
   *     )
   *     .groupBy(p => p.id)
   *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], []))
   *     .subscribe(p => console.log(p));
   *
   * // displays:
   * // [ { id: 1, name: 'aze1' },
   * //   { id: 1, name: 'erg1' },
   * //   { id: 1, name: 'df1' } ]
   * //
   * // [ { id: 2, name: 'sf2' },
   * //   { id: 2, name: 'dg2' },
   * //   { id: 2, name: 'sfqfb2' },
   * //   { id: 2, name: 'qsgqsfg2' } ]
   * //
   * // [ { id: 3, name: 'qfs3' } ]
   *
   * @example <caption>Pivot data on the id field</caption>
   * Observable.of<Obj>({id: 1, name: 'aze1'},
   *                    {id: 2, name: 'sf2'},
   *                    {id: 2, name: 'dg2'},
   *                    {id: 1, name: 'erg1'},
   *                    {id: 1, name: 'df1'},
   *                    {id: 2, name: 'sfqfb2'},
   *                    {id: 3, name: 'qfs1'},
   *                    {id: 2, name: 'qsgqsfg2'}
   *                   )
   *     .groupBy(p => p.id, p => p.name)
   *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], ["" + group$.key]))
   *     .map(arr => ({'id': parseInt(arr[0]), 'values': arr.slice(1)}))
   *     .subscribe(p => console.log(p));
   *
   * // displays:
   * // { id: 1, values: [ 'aze1', 'erg1', 'df1' ] }
   * // { id: 2, values: [ 'sf2', 'dg2', 'sfqfb2', 'qsgqsfg2' ] }
   * // { id: 3, values: [ 'qfs1' ] }
   *
   * @param {function(value: T): K} keySelector A function that extracts the key
   * for each item.
   * @param {function(value: T): R} [elementSelector] A function that extracts the
   * return element for each item.
   * @param {function(grouped: GroupedObservable<K,R>): Observable<any>} [durationSelector]
   * A function that returns an Observable to determine how long each group should
   * exist.
   * @return {Observable<GroupedObservable<K,R>>} An Observable that emits
   * GroupedObservables, each of which corresponds to a unique key value and each
   * of which emits those items from the source Observable that share that key
   * value.
   * @method groupBy
   * @owner Observable
   */
  function groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
    return groupBy_1.groupBy(keySelector, elementSelector, durationSelector, subjectSelector)(this);
  }
  exports.groupBy = groupBy;
  
});
System.registerDynamic('rxjs/add/operator/groupBy.js', ['rxjs/Observable.js', 'rxjs/operator/groupBy.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var groupBy_1 = $__require('rxjs/operator/groupBy.js');
  Observable_1.Observable.prototype.groupBy = groupBy_1.groupBy;
  
});
System.registerDynamic("rxjs/operator/ignoreElements.js", ["rxjs/operators/ignoreElements.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var ignoreElements_1 = $__require("rxjs/operators/ignoreElements.js");
  /**
   * Ignores all items emitted by the source Observable and only passes calls of `complete` or `error`.
   *
   * <img src="./img/ignoreElements.png" width="100%">
   *
   * @return {Observable} An empty Observable that only calls `complete`
   * or `error`, based on which one is called by the source Observable.
   * @method ignoreElements
   * @owner Observable
   */
  function ignoreElements() {
    return ignoreElements_1.ignoreElements()(this);
  }
  exports.ignoreElements = ignoreElements;
  ;
  
});
System.registerDynamic('rxjs/add/operator/ignoreElements.js', ['rxjs/Observable.js', 'rxjs/operator/ignoreElements.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var ignoreElements_1 = $__require('rxjs/operator/ignoreElements.js');
  Observable_1.Observable.prototype.ignoreElements = ignoreElements_1.ignoreElements;
  
});
System.registerDynamic("rxjs/operator/isEmpty.js", ["rxjs/operators/isEmpty.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var isEmpty_1 = $__require("rxjs/operators/isEmpty.js");
  /**
   * If the source Observable is empty it returns an Observable that emits true, otherwise it emits false.
   *
   * <img src="./img/isEmpty.png" width="100%">
   *
   * @return {Observable} An Observable that emits a Boolean.
   * @method isEmpty
   * @owner Observable
   */
  function isEmpty() {
    return isEmpty_1.isEmpty()(this);
  }
  exports.isEmpty = isEmpty;
  
});
System.registerDynamic('rxjs/add/operator/isEmpty.js', ['rxjs/Observable.js', 'rxjs/operator/isEmpty.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var isEmpty_1 = $__require('rxjs/operator/isEmpty.js');
  Observable_1.Observable.prototype.isEmpty = isEmpty_1.isEmpty;
  
});
System.registerDynamic("rxjs/operator/audit.js", ["rxjs/operators/audit.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var audit_1 = $__require("rxjs/operators/audit.js");
  /**
   * Ignores source values for a duration determined by another Observable, then
   * emits the most recent value from the source Observable, then repeats this
   * process.
   *
   * <span class="informal">It's like {@link auditTime}, but the silencing
   * duration is determined by a second Observable.</span>
   *
   * <img src="./img/audit.png" width="100%">
   *
   * `audit` is similar to `throttle`, but emits the last value from the silenced
   * time window, instead of the first value. `audit` emits the most recent value
   * from the source Observable on the output Observable as soon as its internal
   * timer becomes disabled, and ignores source values while the timer is enabled.
   * Initially, the timer is disabled. As soon as the first source value arrives,
   * the timer is enabled by calling the `durationSelector` function with the
   * source value, which returns the "duration" Observable. When the duration
   * Observable emits a value or completes, the timer is disabled, then the most
   * recent source value is emitted on the output Observable, and this process
   * repeats for the next source value.
   *
   * @example <caption>Emit clicks at a rate of at most one click per second</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var result = clicks.audit(ev => Rx.Observable.interval(1000));
   * result.subscribe(x => console.log(x));
   *
   * @see {@link auditTime}
   * @see {@link debounce}
   * @see {@link delayWhen}
   * @see {@link sample}
   * @see {@link throttle}
   *
   * @param {function(value: T): SubscribableOrPromise} durationSelector A function
   * that receives a value from the source Observable, for computing the silencing
   * duration, returned as an Observable or a Promise.
   * @return {Observable<T>} An Observable that performs rate-limiting of
   * emissions from the source Observable.
   * @method audit
   * @owner Observable
   */
  function audit(durationSelector) {
    return audit_1.audit(durationSelector)(this);
  }
  exports.audit = audit;
  
});
System.registerDynamic('rxjs/add/operator/audit.js', ['rxjs/Observable.js', 'rxjs/operator/audit.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var audit_1 = $__require('rxjs/operator/audit.js');
  Observable_1.Observable.prototype.audit = audit_1.audit;
  
});
System.registerDynamic('rxjs/operator/auditTime.js', ['rxjs/scheduler/async.js', 'rxjs/operators/auditTime.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var async_1 = $__require('rxjs/scheduler/async.js');
  var auditTime_1 = $__require('rxjs/operators/auditTime.js');
  /**
   * Ignores source values for `duration` milliseconds, then emits the most recent
   * value from the source Observable, then repeats this process.
   *
   * <span class="informal">When it sees a source values, it ignores that plus
   * the next ones for `duration` milliseconds, and then it emits the most recent
   * value from the source.</span>
   *
   * <img src="./img/auditTime.png" width="100%">
   *
   * `auditTime` is similar to `throttleTime`, but emits the last value from the
   * silenced time window, instead of the first value. `auditTime` emits the most
   * recent value from the source Observable on the output Observable as soon as
   * its internal timer becomes disabled, and ignores source values while the
   * timer is enabled. Initially, the timer is disabled. As soon as the first
   * source value arrives, the timer is enabled. After `duration` milliseconds (or
   * the time unit determined internally by the optional `scheduler`) has passed,
   * the timer is disabled, then the most recent source value is emitted on the
   * output Observable, and this process repeats for the next source value.
   * Optionally takes a {@link IScheduler} for managing timers.
   *
   * @example <caption>Emit clicks at a rate of at most one click per second</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var result = clicks.auditTime(1000);
   * result.subscribe(x => console.log(x));
   *
   * @see {@link audit}
   * @see {@link debounceTime}
   * @see {@link delay}
   * @see {@link sampleTime}
   * @see {@link throttleTime}
   *
   * @param {number} duration Time to wait before emitting the most recent source
   * value, measured in milliseconds or the time unit determined internally
   * by the optional `scheduler`.
   * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
   * managing the timers that handle the rate-limiting behavior.
   * @return {Observable<T>} An Observable that performs rate-limiting of
   * emissions from the source Observable.
   * @method auditTime
   * @owner Observable
   */
  function auditTime(duration, scheduler) {
    if (scheduler === void 0) {
      scheduler = async_1.async;
    }
    return auditTime_1.auditTime(duration, scheduler)(this);
  }
  exports.auditTime = auditTime;
  
});
System.registerDynamic('rxjs/add/operator/auditTime.js', ['rxjs/Observable.js', 'rxjs/operator/auditTime.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var auditTime_1 = $__require('rxjs/operator/auditTime.js');
  Observable_1.Observable.prototype.auditTime = auditTime_1.auditTime;
  
});
System.registerDynamic("rxjs/operator/last.js", ["rxjs/operators/last.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var last_1 = $__require("rxjs/operators/last.js");
  /* tslint:enable:max-line-length */
  /**
   * Returns an Observable that emits only the last item emitted by the source Observable.
   * It optionally takes a predicate function as a parameter, in which case, rather than emitting
   * the last item from the source Observable, the resulting Observable will emit the last item
   * from the source Observable that satisfies the predicate.
   *
   * <img src="./img/last.png" width="100%">
   *
   * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
   * callback if the Observable completes before any `next` notification was sent.
   * @param {function} predicate - The condition any source emitted item has to satisfy.
   * @return {Observable} An Observable that emits only the last item satisfying the given condition
   * from the source, or an NoSuchElementException if no such items are emitted.
   * @throws - Throws if no items that match the predicate are emitted by the source Observable.
   * @method last
   * @owner Observable
   */
  function last(predicate, resultSelector, defaultValue) {
    return last_1.last(predicate, resultSelector, defaultValue)(this);
  }
  exports.last = last;
  
});
System.registerDynamic('rxjs/add/operator/last.js', ['rxjs/Observable.js', 'rxjs/operator/last.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var last_1 = $__require('rxjs/operator/last.js');
  Observable_1.Observable.prototype.last = last_1.last;
  
});
System.registerDynamic("rxjs/operator/let.js", [], true, function ($__require, exports, module) {
  "use strict";
  /**
   * @param func
   * @return {Observable<R>}
   * @method let
   * @owner Observable
   */

  var global = this || self,
      GLOBAL = global;
  function letProto(func) {
    return func(this);
  }
  exports.letProto = letProto;
  
});
System.registerDynamic('rxjs/add/operator/let.js', ['rxjs/Observable.js', 'rxjs/operator/let.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var let_1 = $__require('rxjs/operator/let.js');
  Observable_1.Observable.prototype.let = let_1.letProto;
  Observable_1.Observable.prototype.letBind = let_1.letProto;
  
});
System.registerDynamic("rxjs/operator/every.js", ["rxjs/operators/every.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var every_1 = $__require("rxjs/operators/every.js");
  /**
   * Returns an Observable that emits whether or not every item of the source satisfies the condition specified.
   *
   * @example <caption>A simple example emitting true if all elements are less than 5, false otherwise</caption>
   *  Observable.of(1, 2, 3, 4, 5, 6)
   *     .every(x => x < 5)
   *     .subscribe(x => console.log(x)); // -> false
   *
   * @param {function} predicate A function for determining if an item meets a specified condition.
   * @param {any} [thisArg] Optional object to use for `this` in the callback.
   * @return {Observable} An Observable of booleans that determines if all items of the source Observable meet the condition specified.
   * @method every
   * @owner Observable
   */
  function every(predicate, thisArg) {
    return every_1.every(predicate, thisArg)(this);
  }
  exports.every = every;
  
});
System.registerDynamic('rxjs/add/operator/every.js', ['rxjs/Observable.js', 'rxjs/operator/every.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var every_1 = $__require('rxjs/operator/every.js');
  Observable_1.Observable.prototype.every = every_1.every;
  
});
System.registerDynamic("rxjs/operator/map.js", ["rxjs/operators/map.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var map_1 = $__require("rxjs/operators/map.js");
  /**
   * Applies a given `project` function to each value emitted by the source
   * Observable, and emits the resulting values as an Observable.
   *
   * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
   * it passes each source value through a transformation function to get
   * corresponding output values.</span>
   *
   * <img src="./img/map.png" width="100%">
   *
   * Similar to the well known `Array.prototype.map` function, this operator
   * applies a projection to each value and emits that projection in the output
   * Observable.
   *
   * @example <caption>Map every click to the clientX position of that click</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var positions = clicks.map(ev => ev.clientX);
   * positions.subscribe(x => console.log(x));
   *
   * @see {@link mapTo}
   * @see {@link pluck}
   *
   * @param {function(value: T, index: number): R} project The function to apply
   * to each `value` emitted by the source Observable. The `index` parameter is
   * the number `i` for the i-th emission that has happened since the
   * subscription, starting from the number `0`.
   * @param {any} [thisArg] An optional argument to define what `this` is in the
   * `project` function.
   * @return {Observable<R>} An Observable that emits the values from the source
   * Observable transformed by the given `project` function.
   * @method map
   * @owner Observable
   */
  function map(project, thisArg) {
    return map_1.map(project, thisArg)(this);
  }
  exports.map = map;
  
});
System.registerDynamic('rxjs/add/operator/map.js', ['rxjs/Observable.js', 'rxjs/operator/map.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var map_1 = $__require('rxjs/operator/map.js');
  Observable_1.Observable.prototype.map = map_1.map;
  
});
System.registerDynamic("rxjs/operator/mapTo.js", ["rxjs/operators/mapTo.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var mapTo_1 = $__require("rxjs/operators/mapTo.js");
  /**
   * Emits the given constant value on the output Observable every time the source
   * Observable emits a value.
   *
   * <span class="informal">Like {@link map}, but it maps every source value to
   * the same output value every time.</span>
   *
   * <img src="./img/mapTo.png" width="100%">
   *
   * Takes a constant `value` as argument, and emits that whenever the source
   * Observable emits a value. In other words, ignores the actual source value,
   * and simply uses the emission moment to know when to emit the given `value`.
   *
   * @example <caption>Map every click to the string 'Hi'</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var greetings = clicks.mapTo('Hi');
   * greetings.subscribe(x => console.log(x));
   *
   * @see {@link map}
   *
   * @param {any} value The value to map each source value to.
   * @return {Observable} An Observable that emits the given `value` every time
   * the source Observable emits something.
   * @method mapTo
   * @owner Observable
   */
  function mapTo(value) {
    return mapTo_1.mapTo(value)(this);
  }
  exports.mapTo = mapTo;
  
});
System.registerDynamic('rxjs/add/operator/mapTo.js', ['rxjs/Observable.js', 'rxjs/operator/mapTo.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var mapTo_1 = $__require('rxjs/operator/mapTo.js');
  Observable_1.Observable.prototype.mapTo = mapTo_1.mapTo;
  
});
System.registerDynamic("rxjs/operator/materialize.js", ["rxjs/operators/materialize.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var materialize_1 = $__require("rxjs/operators/materialize.js");
  /**
   * Represents all of the notifications from the source Observable as `next`
   * emissions marked with their original types within {@link Notification}
   * objects.
   *
   * <span class="informal">Wraps `next`, `error` and `complete` emissions in
   * {@link Notification} objects, emitted as `next` on the output Observable.
   * </span>
   *
   * <img src="./img/materialize.png" width="100%">
   *
   * `materialize` returns an Observable that emits a `next` notification for each
   * `next`, `error`, or `complete` emission of the source Observable. When the
   * source Observable emits `complete`, the output Observable will emit `next` as
   * a Notification of type "complete", and then it will emit `complete` as well.
   * When the source Observable emits `error`, the output will emit `next` as a
   * Notification of type "error", and then `complete`.
   *
   * This operator is useful for producing metadata of the source Observable, to
   * be consumed as `next` emissions. Use it in conjunction with
   * {@link dematerialize}.
   *
   * @example <caption>Convert a faulty Observable to an Observable of Notifications</caption>
   * var letters = Rx.Observable.of('a', 'b', 13, 'd');
   * var upperCase = letters.map(x => x.toUpperCase());
   * var materialized = upperCase.materialize();
   * materialized.subscribe(x => console.log(x));
   *
   * // Results in the following:
   * // - Notification {kind: "N", value: "A", error: undefined, hasValue: true}
   * // - Notification {kind: "N", value: "B", error: undefined, hasValue: true}
   * // - Notification {kind: "E", value: undefined, error: TypeError:
   * //   x.toUpperCase is not a function at MapSubscriber.letters.map.x
   * //   [as project] (http://1…, hasValue: false}
   *
   * @see {@link Notification}
   * @see {@link dematerialize}
   *
   * @return {Observable<Notification<T>>} An Observable that emits
   * {@link Notification} objects that wrap the original emissions from the source
   * Observable with metadata.
   * @method materialize
   * @owner Observable
   */
  function materialize() {
    return materialize_1.materialize()(this);
  }
  exports.materialize = materialize;
  
});
System.registerDynamic('rxjs/add/operator/materialize.js', ['rxjs/Observable.js', 'rxjs/operator/materialize.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var materialize_1 = $__require('rxjs/operator/materialize.js');
  Observable_1.Observable.prototype.materialize = materialize_1.materialize;
  
});
System.registerDynamic("rxjs/operator/max.js", ["rxjs/operators/max.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var max_1 = $__require("rxjs/operators/max.js");
  /**
   * The Max operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
   * and when source Observable completes it emits a single item: the item with the largest value.
   *
   * <img src="./img/max.png" width="100%">
   *
   * @example <caption>Get the maximal value of a series of numbers</caption>
   * Rx.Observable.of(5, 4, 7, 2, 8)
   *   .max()
   *   .subscribe(x => console.log(x)); // -> 8
   *
   * @example <caption>Use a comparer function to get the maximal item</caption>
   * interface Person {
   *   age: number,
   *   name: string
   * }
   * Observable.of<Person>({age: 7, name: 'Foo'},
   *                       {age: 5, name: 'Bar'},
   *                       {age: 9, name: 'Beer'})
   *           .max<Person>((a: Person, b: Person) => a.age < b.age ? -1 : 1)
   *           .subscribe((x: Person) => console.log(x.name)); // -> 'Beer'
   * }
   *
   * @see {@link min}
   *
   * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
   * value of two items.
   * @return {Observable} An Observable that emits item with the largest value.
   * @method max
   * @owner Observable
   */
  function max(comparer) {
    return max_1.max(comparer)(this);
  }
  exports.max = max;
  
});
System.registerDynamic('rxjs/add/operator/max.js', ['rxjs/Observable.js', 'rxjs/operator/max.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var max_1 = $__require('rxjs/operator/max.js');
  Observable_1.Observable.prototype.max = max_1.max;
  
});
System.registerDynamic("rxjs/operator/mergeAll.js", ["rxjs/operators/mergeAll.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var mergeAll_1 = $__require("rxjs/operators/mergeAll.js");
  /**
   * Converts a higher-order Observable into a first-order Observable which
   * concurrently delivers all values that are emitted on the inner Observables.
   *
   * <span class="informal">Flattens an Observable-of-Observables.</span>
   *
   * <img src="./img/mergeAll.png" width="100%">
   *
   * `mergeAll` subscribes to an Observable that emits Observables, also known as
   * a higher-order Observable. Each time it observes one of these emitted inner
   * Observables, it subscribes to that and delivers all the values from the
   * inner Observable on the output Observable. The output Observable only
   * completes once all inner Observables have completed. Any error delivered by
   * a inner Observable will be immediately emitted on the output Observable.
   *
   * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
   * var firstOrder = higherOrder.mergeAll();
   * firstOrder.subscribe(x => console.log(x));
   *
   * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
   * var firstOrder = higherOrder.mergeAll(2);
   * firstOrder.subscribe(x => console.log(x));
   *
   * @see {@link combineAll}
   * @see {@link concatAll}
   * @see {@link exhaust}
   * @see {@link merge}
   * @see {@link mergeMap}
   * @see {@link mergeMapTo}
   * @see {@link mergeScan}
   * @see {@link switch}
   * @see {@link zipAll}
   *
   * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
   * Observables being subscribed to concurrently.
   * @return {Observable} An Observable that emits values coming from all the
   * inner Observables emitted by the source Observable.
   * @method mergeAll
   * @owner Observable
   */
  function mergeAll(concurrent) {
    if (concurrent === void 0) {
      concurrent = Number.POSITIVE_INFINITY;
    }
    return mergeAll_1.mergeAll(concurrent)(this);
  }
  exports.mergeAll = mergeAll;
  
});
System.registerDynamic('rxjs/add/operator/mergeAll.js', ['rxjs/Observable.js', 'rxjs/operator/mergeAll.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var mergeAll_1 = $__require('rxjs/operator/mergeAll.js');
  Observable_1.Observable.prototype.mergeAll = mergeAll_1.mergeAll;
  
});
System.registerDynamic("rxjs/operator/mergeMap.js", ["rxjs/operators/mergeMap.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var mergeMap_1 = $__require("rxjs/operators/mergeMap.js");
  /* tslint:enable:max-line-length */
  /**
   * Projects each source value to an Observable which is merged in the output
   * Observable.
   *
   * <span class="informal">Maps each value to an Observable, then flattens all of
   * these inner Observables using {@link mergeAll}.</span>
   *
   * <img src="./img/mergeMap.png" width="100%">
   *
   * Returns an Observable that emits items based on applying a function that you
   * supply to each item emitted by the source Observable, where that function
   * returns an Observable, and then merging those resulting Observables and
   * emitting the results of this merger.
   *
   * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
   * var letters = Rx.Observable.of('a', 'b', 'c');
   * var result = letters.mergeMap(x =>
   *   Rx.Observable.interval(1000).map(i => x+i)
   * );
   * result.subscribe(x => console.log(x));
   *
   * // Results in the following:
   * // a0
   * // b0
   * // c0
   * // a1
   * // b1
   * // c1
   * // continues to list a,b,c with respective ascending integers
   *
   * @see {@link concatMap}
   * @see {@link exhaustMap}
   * @see {@link merge}
   * @see {@link mergeAll}
   * @see {@link mergeMapTo}
   * @see {@link mergeScan}
   * @see {@link switchMap}
   *
   * @param {function(value: T, ?index: number): ObservableInput} project A function
   * that, when applied to an item emitted by the source Observable, returns an
   * Observable.
   * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
   * A function to produce the value on the output Observable based on the values
   * and the indices of the source (outer) emission and the inner Observable
   * emission. The arguments passed to this function are:
   * - `outerValue`: the value that came from the source
   * - `innerValue`: the value that came from the projected Observable
   * - `outerIndex`: the "index" of the value that came from the source
   * - `innerIndex`: the "index" of the value from the projected Observable
   * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
   * Observables being subscribed to concurrently.
   * @return {Observable} An Observable that emits the result of applying the
   * projection function (and the optional `resultSelector`) to each item emitted
   * by the source Observable and merging the results of the Observables obtained
   * from this transformation.
   * @method mergeMap
   * @owner Observable
   */
  function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) {
      concurrent = Number.POSITIVE_INFINITY;
    }
    return mergeMap_1.mergeMap(project, resultSelector, concurrent)(this);
  }
  exports.mergeMap = mergeMap;
  
});
System.registerDynamic('rxjs/add/operator/mergeMap.js', ['rxjs/Observable.js', 'rxjs/operator/mergeMap.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var mergeMap_1 = $__require('rxjs/operator/mergeMap.js');
  Observable_1.Observable.prototype.mergeMap = mergeMap_1.mergeMap;
  Observable_1.Observable.prototype.flatMap = mergeMap_1.mergeMap;
  
});
System.registerDynamic("rxjs/operator/mergeMapTo.js", ["rxjs/operators/mergeMapTo.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var mergeMapTo_1 = $__require("rxjs/operators/mergeMapTo.js");
  /* tslint:enable:max-line-length */
  /**
   * Projects each source value to the same Observable which is merged multiple
   * times in the output Observable.
   *
   * <span class="informal">It's like {@link mergeMap}, but maps each value always
   * to the same inner Observable.</span>
   *
   * <img src="./img/mergeMapTo.png" width="100%">
   *
   * Maps each source value to the given Observable `innerObservable` regardless
   * of the source value, and then merges those resulting Observables into one
   * single Observable, which is the output Observable.
   *
   * @example <caption>For each click event, start an interval Observable ticking every 1 second</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var result = clicks.mergeMapTo(Rx.Observable.interval(1000));
   * result.subscribe(x => console.log(x));
   *
   * @see {@link concatMapTo}
   * @see {@link merge}
   * @see {@link mergeAll}
   * @see {@link mergeMap}
   * @see {@link mergeScan}
   * @see {@link switchMapTo}
   *
   * @param {ObservableInput} innerObservable An Observable to replace each value from
   * the source Observable.
   * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
   * A function to produce the value on the output Observable based on the values
   * and the indices of the source (outer) emission and the inner Observable
   * emission. The arguments passed to this function are:
   * - `outerValue`: the value that came from the source
   * - `innerValue`: the value that came from the projected Observable
   * - `outerIndex`: the "index" of the value that came from the source
   * - `innerIndex`: the "index" of the value from the projected Observable
   * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
   * Observables being subscribed to concurrently.
   * @return {Observable} An Observable that emits items from the given
   * `innerObservable` (and optionally transformed through `resultSelector`) every
   * time a value is emitted on the source Observable.
   * @method mergeMapTo
   * @owner Observable
   */
  function mergeMapTo(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) {
      concurrent = Number.POSITIVE_INFINITY;
    }
    return mergeMapTo_1.mergeMapTo(innerObservable, resultSelector, concurrent)(this);
  }
  exports.mergeMapTo = mergeMapTo;
  
});
System.registerDynamic('rxjs/add/operator/mergeMapTo.js', ['rxjs/Observable.js', 'rxjs/operator/mergeMapTo.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var mergeMapTo_1 = $__require('rxjs/operator/mergeMapTo.js');
  Observable_1.Observable.prototype.flatMapTo = mergeMapTo_1.mergeMapTo;
  Observable_1.Observable.prototype.mergeMapTo = mergeMapTo_1.mergeMapTo;
  
});
System.registerDynamic("rxjs/operator/mergeScan.js", ["rxjs/operators/mergeScan.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var mergeScan_1 = $__require("rxjs/operators/mergeScan.js");
  /**
   * Applies an accumulator function over the source Observable where the
   * accumulator function itself returns an Observable, then each intermediate
   * Observable returned is merged into the output Observable.
   *
   * <span class="informal">It's like {@link scan}, but the Observables returned
   * by the accumulator are merged into the outer Observable.</span>
   *
   * @example <caption>Count the number of click events</caption>
   * const click$ = Rx.Observable.fromEvent(document, 'click');
   * const one$ = click$.mapTo(1);
   * const seed = 0;
   * const count$ = one$.mergeScan((acc, one) => Rx.Observable.of(acc + one), seed);
   * count$.subscribe(x => console.log(x));
   *
   * // Results:
   * 1
   * 2
   * 3
   * 4
   * // ...and so on for each click
   *
   * @param {function(acc: R, value: T): Observable<R>} accumulator
   * The accumulator function called on each source value.
   * @param seed The initial accumulation value.
   * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of
   * input Observables being subscribed to concurrently.
   * @return {Observable<R>} An observable of the accumulated values.
   * @method mergeScan
   * @owner Observable
   */
  function mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) {
      concurrent = Number.POSITIVE_INFINITY;
    }
    return mergeScan_1.mergeScan(accumulator, seed, concurrent)(this);
  }
  exports.mergeScan = mergeScan;
  
});
System.registerDynamic('rxjs/add/operator/mergeScan.js', ['rxjs/Observable.js', 'rxjs/operator/mergeScan.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var mergeScan_1 = $__require('rxjs/operator/mergeScan.js');
  Observable_1.Observable.prototype.mergeScan = mergeScan_1.mergeScan;
  
});
System.registerDynamic("rxjs/operator/min.js", ["rxjs/operators/min.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var min_1 = $__require("rxjs/operators/min.js");
  /**
   * The Min operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
   * and when source Observable completes it emits a single item: the item with the smallest value.
   *
   * <img src="./img/min.png" width="100%">
   *
   * @example <caption>Get the minimal value of a series of numbers</caption>
   * Rx.Observable.of(5, 4, 7, 2, 8)
   *   .min()
   *   .subscribe(x => console.log(x)); // -> 2
   *
   * @example <caption>Use a comparer function to get the minimal item</caption>
   * interface Person {
   *   age: number,
   *   name: string
   * }
   * Observable.of<Person>({age: 7, name: 'Foo'},
   *                       {age: 5, name: 'Bar'},
   *                       {age: 9, name: 'Beer'})
   *           .min<Person>( (a: Person, b: Person) => a.age < b.age ? -1 : 1)
   *           .subscribe((x: Person) => console.log(x.name)); // -> 'Bar'
   * }
   *
   * @see {@link max}
   *
   * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
   * value of two items.
   * @return {Observable<R>} An Observable that emits item with the smallest value.
   * @method min
   * @owner Observable
   */
  function min(comparer) {
    return min_1.min(comparer)(this);
  }
  exports.min = min;
  
});
System.registerDynamic('rxjs/add/operator/min.js', ['rxjs/Observable.js', 'rxjs/operator/min.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var min_1 = $__require('rxjs/operator/min.js');
  Observable_1.Observable.prototype.min = min_1.min;
  
});
System.registerDynamic("rxjs/operator/multicast.js", ["rxjs/operators/multicast.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var multicast_1 = $__require("rxjs/operators/multicast.js");
  /* tslint:enable:max-line-length */
  /**
   * Allows source Observable to be subscribed only once with a Subject of choice,
   * while still sharing its values between multiple subscribers.
   *
   * <span class="informal">Subscribe to Observable once, but send its values to multiple subscribers.</span>
   *
   * <img src="./img/multicast.png" width="100%">
   *
   * `multicast` is an operator that works in two modes.
   *
   * In the first mode you provide a single argument to it, which can be either an initialized Subject or a Subject
   * factory. As a result you will get a special kind of an Observable - a {@link ConnectableObservable}. It can be
   * subscribed multiple times, just as regular Observable, but it won't subscribe to the source Observable at that
   * moment. It will do it only if you call its `connect` method. This means you can essentially control by hand, when
   * source Observable will be actually subscribed. What is more, ConnectableObservable will share this one subscription
   * between all of its subscribers. This means that, for example, `ajax` Observable will only send a request once,
   * even though usually it would send a request per every subscriber. Since it sends a request at the moment of
   * subscription, here request would be sent when the `connect` method of a ConnectableObservable is called.
   *
   * The most common pattern of using ConnectableObservable is calling `connect` when the first consumer subscribes,
   * keeping the subscription alive while several consumers come and go and finally unsubscribing from the source
   * Observable, when the last consumer unsubscribes. To not implement that logic over and over again,
   * ConnectableObservable has a special operator, `refCount`. When called, it returns an Observable, which will count
   * the number of consumers subscribed to it and keep ConnectableObservable connected as long as there is at least
   * one consumer. So if you don't actually need to decide yourself when to connect and disconnect a
   * ConnectableObservable, use `refCount`.
   *
   * The second mode is invoked by calling `multicast` with an additional, second argument - selector function.
   * This function accepts an Observable - which basically mirrors the source Observable - and returns Observable
   * as well, which should be the input stream modified by any operators you want. Note that in this
   * mode you cannot provide initialized Subject as a first argument - it has to be a Subject factory. If
   * you provide selector function, `multicast` returns just a regular Observable, instead of ConnectableObservable.
   * Thus, as usual, each subscription to this stream triggers subscription to the source Observable. However,
   * if inside the selector function you subscribe to the input Observable multiple times, actual source stream
   * will be subscribed only once. So if you have a chain of operators that use some Observable many times,
   * but you want to subscribe to that Observable only once, this is the mode you would use.
   *
   * Subject provided as a first parameter of `multicast` is used as a proxy for the single subscription to the
   * source Observable. It means that all values from the source stream go through that Subject. Thus, if a Subject
   * has some special properties, Observable returned by `multicast` will have them as well. If you want to use
   * `multicast` with a Subject that is one of the ones included in RxJS by default - {@link Subject},
   * {@link AsyncSubject}, {@link BehaviorSubject}, or {@link ReplaySubject} - simply use {@link publish},
   * {@link publishLast}, {@link publishBehavior} or {@link publishReplay} respectively. These are actually
   * just wrappers around `multicast`, with a specific Subject hardcoded inside.
   *
   * Also, if you use {@link publish} or {@link publishReplay} with a ConnectableObservables `refCount` operator,
   * you can simply use {@link share} and {@link shareReplay} respectively, which chain these two.
   *
   * @example <caption>Use ConnectableObservable</caption>
   * const seconds = Rx.Observable.interval(1000);
   * const connectableSeconds = seconds.multicast(new Subject());
   *
   * connectableSeconds.subscribe(value => console.log('first: ' + value));
   * connectableSeconds.subscribe(value => console.log('second: ' + value));
   *
   * // At this point still nothing happens, even though we subscribed twice.
   *
   * connectableSeconds.connect();
   *
   * // From now on `seconds` are being logged to the console,
   * // twice per every second. `seconds` Observable was however only subscribed once,
   * // so under the hood Observable.interval had only one clock started.
   *
   * @example <caption>Use selector</caption>
   * const seconds = Rx.Observable.interval(1000);
   *
   * seconds
   *     .multicast(
   *         () => new Subject(),
   *         seconds => seconds.zip(seconds) // Usually zip would subscribe to `seconds` twice.
   *                                         // Because we are inside selector, `seconds` is subscribed once,
   *     )                                   // thus starting only one clock used internally by Observable.interval.
   *     .subscribe();
   *
   * @see {@link publish}
   * @see {@link publishLast}
   * @see {@link publishBehavior}
   * @see {@link publishReplay}
   * @see {@link share}
   * @see {@link shareReplay}
   *
   * @param {Function|Subject} subjectOrSubjectFactory - Factory function to create an intermediate Subject through
   * which the source sequence's elements will be multicast to the selector function input Observable or
   * ConnectableObservable returned by the operator.
   * @param {Function} [selector] - Optional selector function that can use the input stream
   * as many times as needed, without causing multiple subscriptions to the source stream.
   * Subscribers to the input source will receive all notifications of the source from the
   * time of the subscription forward.
   * @return {Observable<T>|ConnectableObservable<T>} An Observable that emits the results of invoking the selector
   * on the source stream or a special {@link ConnectableObservable}, if selector was not provided.
   *
   * @method multicast
   * @owner Observable
   */
  function multicast(subjectOrSubjectFactory, selector) {
    return multicast_1.multicast(subjectOrSubjectFactory, selector)(this);
  }
  exports.multicast = multicast;
  
});
System.registerDynamic('rxjs/add/operator/multicast.js', ['rxjs/Observable.js', 'rxjs/operator/multicast.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var multicast_1 = $__require('rxjs/operator/multicast.js');
  Observable_1.Observable.prototype.multicast = multicast_1.multicast;
  
});
System.registerDynamic("rxjs/operator/observeOn.js", ["rxjs/operators/observeOn.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var observeOn_1 = $__require("rxjs/operators/observeOn.js");
  /**
   *
   * Re-emits all notifications from source Observable with specified scheduler.
   *
   * <span class="informal">Ensure a specific scheduler is used, from outside of an Observable.</span>
   *
   * `observeOn` is an operator that accepts a scheduler as a first parameter, which will be used to reschedule
   * notifications emitted by the source Observable. It might be useful, if you do not have control over
   * internal scheduler of a given Observable, but want to control when its values are emitted nevertheless.
   *
   * Returned Observable emits the same notifications (nexted values, complete and error events) as the source Observable,
   * but rescheduled with provided scheduler. Note that this doesn't mean that source Observables internal
   * scheduler will be replaced in any way. Original scheduler still will be used, but when the source Observable emits
   * notification, it will be immediately scheduled again - this time with scheduler passed to `observeOn`.
   * An anti-pattern would be calling `observeOn` on Observable that emits lots of values synchronously, to split
   * that emissions into asynchronous chunks. For this to happen, scheduler would have to be passed into the source
   * Observable directly (usually into the operator that creates it). `observeOn` simply delays notifications a
   * little bit more, to ensure that they are emitted at expected moments.
   *
   * As a matter of fact, `observeOn` accepts second parameter, which specifies in milliseconds with what delay notifications
   * will be emitted. The main difference between {@link delay} operator and `observeOn` is that `observeOn`
   * will delay all notifications - including error notifications - while `delay` will pass through error
   * from source Observable immediately when it is emitted. In general it is highly recommended to use `delay` operator
   * for any kind of delaying of values in the stream, while using `observeOn` to specify which scheduler should be used
   * for notification emissions in general.
   *
   * @example <caption>Ensure values in subscribe are called just before browser repaint.</caption>
   * const intervals = Rx.Observable.interval(10); // Intervals are scheduled
   *                                               // with async scheduler by default...
   *
   * intervals
   * .observeOn(Rx.Scheduler.animationFrame)       // ...but we will observe on animationFrame
   * .subscribe(val => {                           // scheduler to ensure smooth animation.
   *   someDiv.style.height = val + 'px';
   * });
   *
   * @see {@link delay}
   *
   * @param {IScheduler} scheduler Scheduler that will be used to reschedule notifications from source Observable.
   * @param {number} [delay] Number of milliseconds that states with what delay every notification should be rescheduled.
   * @return {Observable<T>} Observable that emits the same notifications as the source Observable,
   * but with provided scheduler.
   *
   * @method observeOn
   * @owner Observable
   */
  function observeOn(scheduler, delay) {
    if (delay === void 0) {
      delay = 0;
    }
    return observeOn_1.observeOn(scheduler, delay)(this);
  }
  exports.observeOn = observeOn;
  
});
System.registerDynamic('rxjs/add/operator/observeOn.js', ['rxjs/Observable.js', 'rxjs/operator/observeOn.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var observeOn_1 = $__require('rxjs/operator/observeOn.js');
  Observable_1.Observable.prototype.observeOn = observeOn_1.observeOn;
  
});
System.registerDynamic("rxjs/operator/onErrorResumeNext.js", ["rxjs/operators/onErrorResumeNext.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var onErrorResumeNext_1 = $__require("rxjs/operators/onErrorResumeNext.js");
    /* tslint:enable:max-line-length */
    /**
     * When any of the provided Observable emits an complete or error notification, it immediately subscribes to the next one
     * that was passed.
     *
     * <span class="informal">Execute series of Observables no matter what, even if it means swallowing errors.</span>
     *
     * <img src="./img/onErrorResumeNext.png" width="100%">
     *
     * `onErrorResumeNext` is an operator that accepts a series of Observables, provided either directly as
     * arguments or as an array. If no single Observable is provided, returned Observable will simply behave the same
     * as the source.
     *
     * `onErrorResumeNext` returns an Observable that starts by subscribing and re-emitting values from the source Observable.
     * When its stream of values ends - no matter if Observable completed or emitted an error - `onErrorResumeNext`
     * will subscribe to the first Observable that was passed as an argument to the method. It will start re-emitting
     * its values as well and - again - when that stream ends, `onErrorResumeNext` will proceed to subscribing yet another
     * Observable in provided series, no matter if previous Observable completed or ended with an error. This will
     * be happening until there is no more Observables left in the series, at which point returned Observable will
     * complete - even if the last subscribed stream ended with an error.
     *
     * `onErrorResumeNext` can be therefore thought of as version of {@link concat} operator, which is more permissive
     * when it comes to the errors emitted by its input Observables. While `concat` subscribes to the next Observable
     * in series only if previous one successfully completed, `onErrorResumeNext` subscribes even if it ended with
     * an error.
     *
     * Note that you do not get any access to errors emitted by the Observables. In particular do not
     * expect these errors to appear in error callback passed to {@link subscribe}. If you want to take
     * specific actions based on what error was emitted by an Observable, you should try out {@link catch} instead.
     *
     *
     * @example <caption>Subscribe to the next Observable after map fails</caption>
     * Rx.Observable.of(1, 2, 3, 0)
     *   .map(x => {
     *       if (x === 0) { throw Error(); }
             return 10 / x;
     *   })
     *   .onErrorResumeNext(Rx.Observable.of(1, 2, 3))
     *   .subscribe(
     *     val => console.log(val),
     *     err => console.log(err),          // Will never be called.
     *     () => console.log('that\'s it!')
     *   );
     *
     * // Logs:
     * // 10
     * // 5
     * // 3.3333333333333335
     * // 1
     * // 2
     * // 3
     * // "that's it!"
     *
     * @see {@link concat}
     * @see {@link catch}
     *
     * @param {...ObservableInput} observables Observables passed either directly or as an array.
     * @return {Observable} An Observable that emits values from source Observable, but - if it errors - subscribes
     * to the next passed Observable and so on, until it completes or runs out of Observables.
     * @method onErrorResumeNext
     * @owner Observable
     */
    function onErrorResumeNext() {
        var nextSources = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            nextSources[_i - 0] = arguments[_i];
        }
        return onErrorResumeNext_1.onErrorResumeNext.apply(void 0, nextSources)(this);
    }
    exports.onErrorResumeNext = onErrorResumeNext;
    
});
System.registerDynamic('rxjs/add/operator/onErrorResumeNext.js', ['rxjs/Observable.js', 'rxjs/operator/onErrorResumeNext.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var onErrorResumeNext_1 = $__require('rxjs/operator/onErrorResumeNext.js');
  Observable_1.Observable.prototype.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNext;
  
});
System.registerDynamic("rxjs/operator/pairwise.js", ["rxjs/operators/pairwise.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var pairwise_1 = $__require("rxjs/operators/pairwise.js");
  /**
   * Groups pairs of consecutive emissions together and emits them as an array of
   * two values.
   *
   * <span class="informal">Puts the current value and previous value together as
   * an array, and emits that.</span>
   *
   * <img src="./img/pairwise.png" width="100%">
   *
   * The Nth emission from the source Observable will cause the output Observable
   * to emit an array [(N-1)th, Nth] of the previous and the current value, as a
   * pair. For this reason, `pairwise` emits on the second and subsequent
   * emissions from the source Observable, but not on the first emission, because
   * there is no previous value in that case.
   *
   * @example <caption>On every click (starting from the second), emit the relative distance to the previous click</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var pairs = clicks.pairwise();
   * var distance = pairs.map(pair => {
   *   var x0 = pair[0].clientX;
   *   var y0 = pair[0].clientY;
   *   var x1 = pair[1].clientX;
   *   var y1 = pair[1].clientY;
   *   return Math.sqrt(Math.pow(x0 - x1, 2) + Math.pow(y0 - y1, 2));
   * });
   * distance.subscribe(x => console.log(x));
   *
   * @see {@link buffer}
   * @see {@link bufferCount}
   *
   * @return {Observable<Array<T>>} An Observable of pairs (as arrays) of
   * consecutive values from the source Observable.
   * @method pairwise
   * @owner Observable
   */
  function pairwise() {
    return pairwise_1.pairwise()(this);
  }
  exports.pairwise = pairwise;
  
});
System.registerDynamic('rxjs/add/operator/pairwise.js', ['rxjs/Observable.js', 'rxjs/operator/pairwise.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var pairwise_1 = $__require('rxjs/operator/pairwise.js');
  Observable_1.Observable.prototype.pairwise = pairwise_1.pairwise;
  
});
System.registerDynamic("rxjs/operator/partition.js", ["rxjs/operators/partition.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var partition_1 = $__require("rxjs/operators/partition.js");
  /**
   * Splits the source Observable into two, one with values that satisfy a
   * predicate, and another with values that don't satisfy the predicate.
   *
   * <span class="informal">It's like {@link filter}, but returns two Observables:
   * one like the output of {@link filter}, and the other with values that did not
   * pass the condition.</span>
   *
   * <img src="./img/partition.png" width="100%">
   *
   * `partition` outputs an array with two Observables that partition the values
   * from the source Observable through the given `predicate` function. The first
   * Observable in that array emits source values for which the predicate argument
   * returns true. The second Observable emits source values for which the
   * predicate returns false. The first behaves like {@link filter} and the second
   * behaves like {@link filter} with the predicate negated.
   *
   * @example <caption>Partition click events into those on DIV elements and those elsewhere</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var parts = clicks.partition(ev => ev.target.tagName === 'DIV');
   * var clicksOnDivs = parts[0];
   * var clicksElsewhere = parts[1];
   * clicksOnDivs.subscribe(x => console.log('DIV clicked: ', x));
   * clicksElsewhere.subscribe(x => console.log('Other clicked: ', x));
   *
   * @see {@link filter}
   *
   * @param {function(value: T, index: number): boolean} predicate A function that
   * evaluates each value emitted by the source Observable. If it returns `true`,
   * the value is emitted on the first Observable in the returned array, if
   * `false` the value is emitted on the second Observable in the array. The
   * `index` parameter is the number `i` for the i-th source emission that has
   * happened since the subscription, starting from the number `0`.
   * @param {any} [thisArg] An optional argument to determine the value of `this`
   * in the `predicate` function.
   * @return {[Observable<T>, Observable<T>]} An array with two Observables: one
   * with values that passed the predicate, and another with values that did not
   * pass the predicate.
   * @method partition
   * @owner Observable
   */
  function partition(predicate, thisArg) {
    return partition_1.partition(predicate, thisArg)(this);
  }
  exports.partition = partition;
  
});
System.registerDynamic('rxjs/add/operator/partition.js', ['rxjs/Observable.js', 'rxjs/operator/partition.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var partition_1 = $__require('rxjs/operator/partition.js');
  Observable_1.Observable.prototype.partition = partition_1.partition;
  
});
System.registerDynamic("rxjs/operator/pluck.js", ["rxjs/operators/pluck.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var pluck_1 = $__require("rxjs/operators/pluck.js");
    /**
     * Maps each source value (an object) to its specified nested property.
     *
     * <span class="informal">Like {@link map}, but meant only for picking one of
     * the nested properties of every emitted object.</span>
     *
     * <img src="./img/pluck.png" width="100%">
     *
     * Given a list of strings describing a path to an object property, retrieves
     * the value of a specified nested property from all values in the source
     * Observable. If a property can't be resolved, it will return `undefined` for
     * that value.
     *
     * @example <caption>Map every click to the tagName of the clicked target element</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var tagNames = clicks.pluck('target', 'tagName');
     * tagNames.subscribe(x => console.log(x));
     *
     * @see {@link map}
     *
     * @param {...string} properties The nested properties to pluck from each source
     * value (an object).
     * @return {Observable} A new Observable of property values from the source values.
     * @method pluck
     * @owner Observable
     */
    function pluck() {
        var properties = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            properties[_i - 0] = arguments[_i];
        }
        return pluck_1.pluck.apply(void 0, properties)(this);
    }
    exports.pluck = pluck;
    
});
System.registerDynamic('rxjs/add/operator/pluck.js', ['rxjs/Observable.js', 'rxjs/operator/pluck.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var pluck_1 = $__require('rxjs/operator/pluck.js');
  Observable_1.Observable.prototype.pluck = pluck_1.pluck;
  
});
System.registerDynamic("rxjs/operator/publish.js", ["rxjs/operators/publish.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var publish_1 = $__require("rxjs/operators/publish.js");
  /* tslint:enable:max-line-length */
  /**
   * Returns a ConnectableObservable, which is a variety of Observable that waits until its connect method is called
   * before it begins emitting items to those Observers that have subscribed to it.
   *
   * <img src="./img/publish.png" width="100%">
   *
   * @param {Function} [selector] - Optional selector function which can use the multicasted source sequence as many times
   * as needed, without causing multiple subscriptions to the source sequence.
   * Subscribers to the given source will receive all notifications of the source from the time of the subscription on.
   * @return A ConnectableObservable that upon connection causes the source Observable to emit items to its Observers.
   * @method publish
   * @owner Observable
   */
  function publish(selector) {
    return publish_1.publish(selector)(this);
  }
  exports.publish = publish;
  
});
System.registerDynamic('rxjs/add/operator/publish.js', ['rxjs/Observable.js', 'rxjs/operator/publish.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var publish_1 = $__require('rxjs/operator/publish.js');
  Observable_1.Observable.prototype.publish = publish_1.publish;
  
});
System.registerDynamic("rxjs/operator/publishBehavior.js", ["rxjs/operators/publishBehavior.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var publishBehavior_1 = $__require("rxjs/operators/publishBehavior.js");
  /**
   * @param value
   * @return {ConnectableObservable<T>}
   * @method publishBehavior
   * @owner Observable
   */
  function publishBehavior(value) {
    return publishBehavior_1.publishBehavior(value)(this);
  }
  exports.publishBehavior = publishBehavior;
  
});
System.registerDynamic('rxjs/add/operator/publishBehavior.js', ['rxjs/Observable.js', 'rxjs/operator/publishBehavior.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var publishBehavior_1 = $__require('rxjs/operator/publishBehavior.js');
  Observable_1.Observable.prototype.publishBehavior = publishBehavior_1.publishBehavior;
  
});
System.registerDynamic("rxjs/operator/publishReplay.js", ["rxjs/operators/publishReplay.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var publishReplay_1 = $__require("rxjs/operators/publishReplay.js");
  /* tslint:enable:max-line-length */
  /**
   * @param bufferSize
   * @param windowTime
   * @param selectorOrScheduler
   * @param scheduler
   * @return {Observable<T> | ConnectableObservable<T>}
   * @method publishReplay
   * @owner Observable
   */
  function publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
    return publishReplay_1.publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler)(this);
  }
  exports.publishReplay = publishReplay;
  
});
System.registerDynamic('rxjs/add/operator/publishReplay.js', ['rxjs/Observable.js', 'rxjs/operator/publishReplay.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var publishReplay_1 = $__require('rxjs/operator/publishReplay.js');
  Observable_1.Observable.prototype.publishReplay = publishReplay_1.publishReplay;
  
});
System.registerDynamic("rxjs/operator/publishLast.js", ["rxjs/operators/publishLast.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var publishLast_1 = $__require("rxjs/operators/publishLast.js");
  /**
   * @return {ConnectableObservable<T>}
   * @method publishLast
   * @owner Observable
   */
  function publishLast() {
    //TODO(benlesh): correct type-flow through here.
    return publishLast_1.publishLast()(this);
  }
  exports.publishLast = publishLast;
  
});
System.registerDynamic('rxjs/add/operator/publishLast.js', ['rxjs/Observable.js', 'rxjs/operator/publishLast.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var publishLast_1 = $__require('rxjs/operator/publishLast.js');
  Observable_1.Observable.prototype.publishLast = publishLast_1.publishLast;
  
});
System.registerDynamic('rxjs/operator/race.js', ['rxjs/operators/race.js', 'rxjs/observable/race.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var race_1 = $__require('rxjs/operators/race.js');
    // NOTE: to support backwards compatability with 5.4.* and lower
    var race_2 = $__require('rxjs/observable/race.js');
    exports.raceStatic = race_2.race;
    /* tslint:enable:max-line-length */
    /**
     * Returns an Observable that mirrors the first source Observable to emit an item
     * from the combination of this Observable and supplied Observables.
     * @param {...Observables} ...observables Sources used to race for which Observable emits first.
     * @return {Observable} An Observable that mirrors the output of the first Observable to emit an item.
     * @method race
     * @owner Observable
     */
    function race() {
        var observables = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            observables[_i - 0] = arguments[_i];
        }
        return race_1.race.apply(void 0, observables)(this);
    }
    exports.race = race;
    
});
System.registerDynamic('rxjs/add/operator/race.js', ['rxjs/Observable.js', 'rxjs/operator/race.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var race_1 = $__require('rxjs/operator/race.js');
  Observable_1.Observable.prototype.race = race_1.race;
  
});
System.registerDynamic("rxjs/operator/reduce.js", ["rxjs/operators/reduce.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var reduce_1 = $__require("rxjs/operators/reduce.js");
    /* tslint:enable:max-line-length */
    /**
     * Applies an accumulator function over the source Observable, and returns the
     * accumulated result when the source completes, given an optional seed value.
     *
     * <span class="informal">Combines together all values emitted on the source,
     * using an accumulator function that knows how to join a new source value into
     * the accumulation from the past.</span>
     *
     * <img src="./img/reduce.png" width="100%">
     *
     * Like
     * [Array.prototype.reduce()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce),
     * `reduce` applies an `accumulator` function against an accumulation and each
     * value of the source Observable (from the past) to reduce it to a single
     * value, emitted on the output Observable. Note that `reduce` will only emit
     * one value, only when the source Observable completes. It is equivalent to
     * applying operator {@link scan} followed by operator {@link last}.
     *
     * Returns an Observable that applies a specified `accumulator` function to each
     * item emitted by the source Observable. If a `seed` value is specified, then
     * that value will be used as the initial value for the accumulator. If no seed
     * value is specified, the first item of the source is used as the seed.
     *
     * @example <caption>Count the number of click events that happened in 5 seconds</caption>
     * var clicksInFiveSeconds = Rx.Observable.fromEvent(document, 'click')
     *   .takeUntil(Rx.Observable.interval(5000));
     * var ones = clicksInFiveSeconds.mapTo(1);
     * var seed = 0;
     * var count = ones.reduce((acc, one) => acc + one, seed);
     * count.subscribe(x => console.log(x));
     *
     * @see {@link count}
     * @see {@link expand}
     * @see {@link mergeScan}
     * @see {@link scan}
     *
     * @param {function(acc: R, value: T, index: number): R} accumulator The accumulator function
     * called on each source value.
     * @param {R} [seed] The initial accumulation value.
     * @return {Observable<R>} An Observable that emits a single value that is the
     * result of accumulating the values emitted by the source Observable.
     * @method reduce
     * @owner Observable
     */
    function reduce(accumulator, seed) {
        // providing a seed of `undefined` *should* be valid and trigger
        // hasSeed! so don't use `seed !== undefined` checks!
        // For this reason, we have to check it here at the original call site
        // otherwise inside Operator/Subscriber we won't know if `undefined`
        // means they didn't provide anything or if they literally provided `undefined`
        if (arguments.length >= 2) {
            return reduce_1.reduce(accumulator, seed)(this);
        }
        return reduce_1.reduce(accumulator)(this);
    }
    exports.reduce = reduce;
    
});
System.registerDynamic('rxjs/add/operator/reduce.js', ['rxjs/Observable.js', 'rxjs/operator/reduce.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var reduce_1 = $__require('rxjs/operator/reduce.js');
  Observable_1.Observable.prototype.reduce = reduce_1.reduce;
  
});
System.registerDynamic("rxjs/operator/repeat.js", ["rxjs/operators/repeat.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var repeat_1 = $__require("rxjs/operators/repeat.js");
  /**
   * Returns an Observable that repeats the stream of items emitted by the source Observable at most count times.
   *
   * <img src="./img/repeat.png" width="100%">
   *
   * @param {number} [count] The number of times the source Observable items are repeated, a count of 0 will yield
   * an empty Observable.
   * @return {Observable} An Observable that repeats the stream of items emitted by the source Observable at most
   * count times.
   * @method repeat
   * @owner Observable
   */
  function repeat(count) {
    if (count === void 0) {
      count = -1;
    }
    return repeat_1.repeat(count)(this);
  }
  exports.repeat = repeat;
  
});
System.registerDynamic('rxjs/add/operator/repeat.js', ['rxjs/Observable.js', 'rxjs/operator/repeat.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var repeat_1 = $__require('rxjs/operator/repeat.js');
  Observable_1.Observable.prototype.repeat = repeat_1.repeat;
  
});
System.registerDynamic("rxjs/operator/repeatWhen.js", ["rxjs/operators/repeatWhen.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var repeatWhen_1 = $__require("rxjs/operators/repeatWhen.js");
  /**
   * Returns an Observable that mirrors the source Observable with the exception of a `complete`. If the source
   * Observable calls `complete`, this method will emit to the Observable returned from `notifier`. If that Observable
   * calls `complete` or `error`, then this method will call `complete` or `error` on the child subscription. Otherwise
   * this method will resubscribe to the source Observable.
   *
   * <img src="./img/repeatWhen.png" width="100%">
   *
   * @param {function(notifications: Observable): Observable} notifier - Receives an Observable of notifications with
   * which a user can `complete` or `error`, aborting the repetition.
   * @return {Observable} The source Observable modified with repeat logic.
   * @method repeatWhen
   * @owner Observable
   */
  function repeatWhen(notifier) {
    return repeatWhen_1.repeatWhen(notifier)(this);
  }
  exports.repeatWhen = repeatWhen;
  
});
System.registerDynamic('rxjs/add/operator/repeatWhen.js', ['rxjs/Observable.js', 'rxjs/operator/repeatWhen.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var repeatWhen_1 = $__require('rxjs/operator/repeatWhen.js');
  Observable_1.Observable.prototype.repeatWhen = repeatWhen_1.repeatWhen;
  
});
System.registerDynamic("rxjs/operator/retry.js", ["rxjs/operators/retry.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var retry_1 = $__require("rxjs/operators/retry.js");
  /**
   * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
   * calls `error`, this method will resubscribe to the source Observable for a maximum of `count` resubscriptions (given
   * as a number parameter) rather than propagating the `error` call.
   *
   * <img src="./img/retry.png" width="100%">
   *
   * Any and all items emitted by the source Observable will be emitted by the resulting Observable, even those emitted
   * during failed subscriptions. For example, if an Observable fails at first but emits [1, 2] then succeeds the second
   * time and emits: [1, 2, 3, 4, 5] then the complete stream of emissions and notifications
   * would be: [1, 2, 1, 2, 3, 4, 5, `complete`].
   * @param {number} count - Number of retry attempts before failing.
   * @return {Observable} The source Observable modified with the retry logic.
   * @method retry
   * @owner Observable
   */
  function retry(count) {
    if (count === void 0) {
      count = -1;
    }
    return retry_1.retry(count)(this);
  }
  exports.retry = retry;
  
});
System.registerDynamic('rxjs/add/operator/retry.js', ['rxjs/Observable.js', 'rxjs/operator/retry.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var retry_1 = $__require('rxjs/operator/retry.js');
  Observable_1.Observable.prototype.retry = retry_1.retry;
  
});
System.registerDynamic("rxjs/operator/retryWhen.js", ["rxjs/operators/retryWhen.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var retryWhen_1 = $__require("rxjs/operators/retryWhen.js");
  /**
   * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
   * calls `error`, this method will emit the Throwable that caused the error to the Observable returned from `notifier`.
   * If that Observable calls `complete` or `error` then this method will call `complete` or `error` on the child
   * subscription. Otherwise this method will resubscribe to the source Observable.
   *
   * <img src="./img/retryWhen.png" width="100%">
   *
   * @param {function(errors: Observable): Observable} notifier - Receives an Observable of notifications with which a
   * user can `complete` or `error`, aborting the retry.
   * @return {Observable} The source Observable modified with retry logic.
   * @method retryWhen
   * @owner Observable
   */
  function retryWhen(notifier) {
    return retryWhen_1.retryWhen(notifier)(this);
  }
  exports.retryWhen = retryWhen;
  
});
System.registerDynamic('rxjs/add/operator/retryWhen.js', ['rxjs/Observable.js', 'rxjs/operator/retryWhen.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var retryWhen_1 = $__require('rxjs/operator/retryWhen.js');
  Observable_1.Observable.prototype.retryWhen = retryWhen_1.retryWhen;
  
});
System.registerDynamic("rxjs/operator/sample.js", ["rxjs/operators/sample.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var sample_1 = $__require("rxjs/operators/sample.js");
  /**
   * Emits the most recently emitted value from the source Observable whenever
   * another Observable, the `notifier`, emits.
   *
   * <span class="informal">It's like {@link sampleTime}, but samples whenever
   * the `notifier` Observable emits something.</span>
   *
   * <img src="./img/sample.png" width="100%">
   *
   * Whenever the `notifier` Observable emits a value or completes, `sample`
   * looks at the source Observable and emits whichever value it has most recently
   * emitted since the previous sampling, unless the source has not emitted
   * anything since the previous sampling. The `notifier` is subscribed to as soon
   * as the output Observable is subscribed.
   *
   * @example <caption>On every click, sample the most recent "seconds" timer</caption>
   * var seconds = Rx.Observable.interval(1000);
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var result = seconds.sample(clicks);
   * result.subscribe(x => console.log(x));
   *
   * @see {@link audit}
   * @see {@link debounce}
   * @see {@link sampleTime}
   * @see {@link throttle}
   *
   * @param {Observable<any>} notifier The Observable to use for sampling the
   * source Observable.
   * @return {Observable<T>} An Observable that emits the results of sampling the
   * values emitted by the source Observable whenever the notifier Observable
   * emits value or completes.
   * @method sample
   * @owner Observable
   */
  function sample(notifier) {
    return sample_1.sample(notifier)(this);
  }
  exports.sample = sample;
  
});
System.registerDynamic('rxjs/add/operator/sample.js', ['rxjs/Observable.js', 'rxjs/operator/sample.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var sample_1 = $__require('rxjs/operator/sample.js');
  Observable_1.Observable.prototype.sample = sample_1.sample;
  
});
System.registerDynamic('rxjs/operator/sampleTime.js', ['rxjs/scheduler/async.js', 'rxjs/operators/sampleTime.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var async_1 = $__require('rxjs/scheduler/async.js');
  var sampleTime_1 = $__require('rxjs/operators/sampleTime.js');
  /**
   * Emits the most recently emitted value from the source Observable within
   * periodic time intervals.
   *
   * <span class="informal">Samples the source Observable at periodic time
   * intervals, emitting what it samples.</span>
   *
   * <img src="./img/sampleTime.png" width="100%">
   *
   * `sampleTime` periodically looks at the source Observable and emits whichever
   * value it has most recently emitted since the previous sampling, unless the
   * source has not emitted anything since the previous sampling. The sampling
   * happens periodically in time every `period` milliseconds (or the time unit
   * defined by the optional `scheduler` argument). The sampling starts as soon as
   * the output Observable is subscribed.
   *
   * @example <caption>Every second, emit the most recent click at most once</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var result = clicks.sampleTime(1000);
   * result.subscribe(x => console.log(x));
   *
   * @see {@link auditTime}
   * @see {@link debounceTime}
   * @see {@link delay}
   * @see {@link sample}
   * @see {@link throttleTime}
   *
   * @param {number} period The sampling period expressed in milliseconds or the
   * time unit determined internally by the optional `scheduler`.
   * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
   * managing the timers that handle the sampling.
   * @return {Observable<T>} An Observable that emits the results of sampling the
   * values emitted by the source Observable at the specified time interval.
   * @method sampleTime
   * @owner Observable
   */
  function sampleTime(period, scheduler) {
    if (scheduler === void 0) {
      scheduler = async_1.async;
    }
    return sampleTime_1.sampleTime(period, scheduler)(this);
  }
  exports.sampleTime = sampleTime;
  
});
System.registerDynamic('rxjs/add/operator/sampleTime.js', ['rxjs/Observable.js', 'rxjs/operator/sampleTime.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var sampleTime_1 = $__require('rxjs/operator/sampleTime.js');
  Observable_1.Observable.prototype.sampleTime = sampleTime_1.sampleTime;
  
});
System.registerDynamic("rxjs/operator/scan.js", ["rxjs/operators/scan.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var scan_1 = $__require("rxjs/operators/scan.js");
    /* tslint:enable:max-line-length */
    /**
     * Applies an accumulator function over the source Observable, and returns each
     * intermediate result, with an optional seed value.
     *
     * <span class="informal">It's like {@link reduce}, but emits the current
     * accumulation whenever the source emits a value.</span>
     *
     * <img src="./img/scan.png" width="100%">
     *
     * Combines together all values emitted on the source, using an accumulator
     * function that knows how to join a new source value into the accumulation from
     * the past. Is similar to {@link reduce}, but emits the intermediate
     * accumulations.
     *
     * Returns an Observable that applies a specified `accumulator` function to each
     * item emitted by the source Observable. If a `seed` value is specified, then
     * that value will be used as the initial value for the accumulator. If no seed
     * value is specified, the first item of the source is used as the seed.
     *
     * @example <caption>Count the number of click events</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var ones = clicks.mapTo(1);
     * var seed = 0;
     * var count = ones.scan((acc, one) => acc + one, seed);
     * count.subscribe(x => console.log(x));
     *
     * @see {@link expand}
     * @see {@link mergeScan}
     * @see {@link reduce}
     *
     * @param {function(acc: R, value: T, index: number): R} accumulator
     * The accumulator function called on each source value.
     * @param {T|R} [seed] The initial accumulation value.
     * @return {Observable<R>} An observable of the accumulated values.
     * @method scan
     * @owner Observable
     */
    function scan(accumulator, seed) {
        if (arguments.length >= 2) {
            return scan_1.scan(accumulator, seed)(this);
        }
        return scan_1.scan(accumulator)(this);
    }
    exports.scan = scan;
    
});
System.registerDynamic('rxjs/add/operator/scan.js', ['rxjs/Observable.js', 'rxjs/operator/scan.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var scan_1 = $__require('rxjs/operator/scan.js');
  Observable_1.Observable.prototype.scan = scan_1.scan;
  
});
System.registerDynamic("rxjs/operator/sequenceEqual.js", ["rxjs/operators/sequenceEqual.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var sequenceEqual_1 = $__require("rxjs/operators/sequenceEqual.js");
  /**
   * Compares all values of two observables in sequence using an optional comparor function
   * and returns an observable of a single boolean value representing whether or not the two sequences
   * are equal.
   *
   * <span class="informal">Checks to see of all values emitted by both observables are equal, in order.</span>
   *
   * <img src="./img/sequenceEqual.png" width="100%">
   *
   * `sequenceEqual` subscribes to two observables and buffers incoming values from each observable. Whenever either
   * observable emits a value, the value is buffered and the buffers are shifted and compared from the bottom
   * up; If any value pair doesn't match, the returned observable will emit `false` and complete. If one of the
   * observables completes, the operator will wait for the other observable to complete; If the other
   * observable emits before completing, the returned observable will emit `false` and complete. If one observable never
   * completes or emits after the other complets, the returned observable will never complete.
   *
   * @example <caption>figure out if the Konami code matches</caption>
   * var code = Rx.Observable.from([
   *  "ArrowUp",
   *  "ArrowUp",
   *  "ArrowDown",
   *  "ArrowDown",
   *  "ArrowLeft",
   *  "ArrowRight",
   *  "ArrowLeft",
   *  "ArrowRight",
   *  "KeyB",
   *  "KeyA",
   *  "Enter" // no start key, clearly.
   * ]);
   *
   * var keys = Rx.Observable.fromEvent(document, 'keyup')
   *  .map(e => e.code);
   * var matches = keys.bufferCount(11, 1)
   *  .mergeMap(
   *    last11 =>
   *      Rx.Observable.from(last11)
   *        .sequenceEqual(code)
   *   );
   * matches.subscribe(matched => console.log('Successful cheat at Contra? ', matched));
   *
   * @see {@link combineLatest}
   * @see {@link zip}
   * @see {@link withLatestFrom}
   *
   * @param {Observable} compareTo The observable sequence to compare the source sequence to.
   * @param {function} [comparor] An optional function to compare each value pair
   * @return {Observable} An Observable of a single boolean value representing whether or not
   * the values emitted by both observables were equal in sequence.
   * @method sequenceEqual
   * @owner Observable
   */
  function sequenceEqual(compareTo, comparor) {
    return sequenceEqual_1.sequenceEqual(compareTo, comparor)(this);
  }
  exports.sequenceEqual = sequenceEqual;
  
});
System.registerDynamic('rxjs/add/operator/sequenceEqual.js', ['rxjs/Observable.js', 'rxjs/operator/sequenceEqual.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var sequenceEqual_1 = $__require('rxjs/operator/sequenceEqual.js');
  Observable_1.Observable.prototype.sequenceEqual = sequenceEqual_1.sequenceEqual;
  
});
System.registerDynamic("rxjs/operator/share.js", ["rxjs/operators/share.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var share_1 = $__require("rxjs/operators/share.js");
  /**
   * Returns a new Observable that multicasts (shares) the original Observable. As long as there is at least one
   * Subscriber this Observable will be subscribed and emitting data. When all subscribers have unsubscribed it will
   * unsubscribe from the source Observable. Because the Observable is multicasting it makes the stream `hot`.
   *
   * This behaves similarly to .publish().refCount(), with a behavior difference when the source observable emits complete.
   * .publish().refCount() will not resubscribe to the original source, however .share() will resubscribe to the original source.
   * Observable.of("test").publish().refCount() will not re-emit "test" on new subscriptions, Observable.of("test").share() will
   * re-emit "test" to new subscriptions.
   *
   * <img src="./img/share.png" width="100%">
   *
   * @return {Observable<T>} An Observable that upon connection causes the source Observable to emit items to its Observers.
   * @method share
   * @owner Observable
   */
  function share() {
    return share_1.share()(this);
  }
  exports.share = share;
  ;
  
});
System.registerDynamic('rxjs/add/operator/share.js', ['rxjs/Observable.js', 'rxjs/operator/share.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var share_1 = $__require('rxjs/operator/share.js');
  Observable_1.Observable.prototype.share = share_1.share;
  
});
System.registerDynamic("rxjs/operator/shareReplay.js", ["rxjs/operators/shareReplay.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var shareReplay_1 = $__require("rxjs/operators/shareReplay.js");
  /**
   * @method shareReplay
   * @owner Observable
   */
  function shareReplay(bufferSize, windowTime, scheduler) {
    return shareReplay_1.shareReplay(bufferSize, windowTime, scheduler)(this);
  }
  exports.shareReplay = shareReplay;
  ;
  
});
System.registerDynamic('rxjs/add/operator/shareReplay.js', ['rxjs/Observable.js', 'rxjs/operator/shareReplay.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var shareReplay_1 = $__require('rxjs/operator/shareReplay.js');
  Observable_1.Observable.prototype.shareReplay = shareReplay_1.shareReplay;
  
});
System.registerDynamic("rxjs/operator/single.js", ["rxjs/operators/single.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var single_1 = $__require("rxjs/operators/single.js");
  /**
   * Returns an Observable that emits the single item emitted by the source Observable that matches a specified
   * predicate, if that Observable emits one such item. If the source Observable emits more than one such item or no
   * such items, notify of an IllegalArgumentException or NoSuchElementException respectively.
   *
   * <img src="./img/single.png" width="100%">
   *
   * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
   * callback if the Observable completes before any `next` notification was sent.
   * @param {Function} predicate - A predicate function to evaluate items emitted by the source Observable.
   * @return {Observable<T>} An Observable that emits the single item emitted by the source Observable that matches
   * the predicate.
   .
   * @method single
   * @owner Observable
   */
  function single(predicate) {
    return single_1.single(predicate)(this);
  }
  exports.single = single;
  
});
System.registerDynamic('rxjs/add/operator/single.js', ['rxjs/Observable.js', 'rxjs/operator/single.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var single_1 = $__require('rxjs/operator/single.js');
  Observable_1.Observable.prototype.single = single_1.single;
  
});
System.registerDynamic("rxjs/operator/skip.js", ["rxjs/operators/skip.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var skip_1 = $__require("rxjs/operators/skip.js");
  /**
   * Returns an Observable that skips the first `count` items emitted by the source Observable.
   *
   * <img src="./img/skip.png" width="100%">
   *
   * @param {Number} count - The number of times, items emitted by source Observable should be skipped.
   * @return {Observable} An Observable that skips values emitted by the source Observable.
   *
   * @method skip
   * @owner Observable
   */
  function skip(count) {
    return skip_1.skip(count)(this);
  }
  exports.skip = skip;
  
});
System.registerDynamic('rxjs/add/operator/skip.js', ['rxjs/Observable.js', 'rxjs/operator/skip.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var skip_1 = $__require('rxjs/operator/skip.js');
  Observable_1.Observable.prototype.skip = skip_1.skip;
  
});
System.registerDynamic("rxjs/operator/skipLast.js", ["rxjs/operators/skipLast.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var skipLast_1 = $__require("rxjs/operators/skipLast.js");
  /**
   * Skip the last `count` values emitted by the source Observable.
   *
   * <img src="./img/skipLast.png" width="100%">
   *
   * `skipLast` returns an Observable that accumulates a queue with a length
   * enough to store the first `count` values. As more values are received,
   * values are taken from the front of the queue and produced on the result
   * sequence. This causes values to be delayed.
   *
   * @example <caption>Skip the last 2 values of an Observable with many values</caption>
   * var many = Rx.Observable.range(1, 5);
   * var skipLastTwo = many.skipLast(2);
   * skipLastTwo.subscribe(x => console.log(x));
   *
   * // Results in:
   * // 1 2 3
   *
   * @see {@link skip}
   * @see {@link skipUntil}
   * @see {@link skipWhile}
   * @see {@link take}
   *
   * @throws {ArgumentOutOfRangeError} When using `skipLast(i)`, it throws
   * ArgumentOutOrRangeError if `i < 0`.
   *
   * @param {number} count Number of elements to skip from the end of the source Observable.
   * @returns {Observable<T>} An Observable that skips the last count values
   * emitted by the source Observable.
   * @method skipLast
   * @owner Observable
   */
  function skipLast(count) {
    return skipLast_1.skipLast(count)(this);
  }
  exports.skipLast = skipLast;
  
});
System.registerDynamic('rxjs/add/operator/skipLast.js', ['rxjs/Observable.js', 'rxjs/operator/skipLast.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var skipLast_1 = $__require('rxjs/operator/skipLast.js');
  Observable_1.Observable.prototype.skipLast = skipLast_1.skipLast;
  
});
System.registerDynamic("rxjs/operator/skipUntil.js", ["rxjs/operators/skipUntil.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var skipUntil_1 = $__require("rxjs/operators/skipUntil.js");
  /**
   * Returns an Observable that skips items emitted by the source Observable until a second Observable emits an item.
   *
   * <img src="./img/skipUntil.png" width="100%">
   *
   * @param {Observable} notifier - The second Observable that has to emit an item before the source Observable's elements begin to
   * be mirrored by the resulting Observable.
   * @return {Observable<T>} An Observable that skips items from the source Observable until the second Observable emits
   * an item, then emits the remaining items.
   * @method skipUntil
   * @owner Observable
   */
  function skipUntil(notifier) {
    return skipUntil_1.skipUntil(notifier)(this);
  }
  exports.skipUntil = skipUntil;
  
});
System.registerDynamic('rxjs/add/operator/skipUntil.js', ['rxjs/Observable.js', 'rxjs/operator/skipUntil.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var skipUntil_1 = $__require('rxjs/operator/skipUntil.js');
  Observable_1.Observable.prototype.skipUntil = skipUntil_1.skipUntil;
  
});
System.registerDynamic("rxjs/operator/skipWhile.js", ["rxjs/operators/skipWhile.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var skipWhile_1 = $__require("rxjs/operators/skipWhile.js");
  /**
   * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
   * true, but emits all further source items as soon as the condition becomes false.
   *
   * <img src="./img/skipWhile.png" width="100%">
   *
   * @param {Function} predicate - A function to test each item emitted from the source Observable.
   * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
   * specified predicate becomes false.
   * @method skipWhile
   * @owner Observable
   */
  function skipWhile(predicate) {
    return skipWhile_1.skipWhile(predicate)(this);
  }
  exports.skipWhile = skipWhile;
  
});
System.registerDynamic('rxjs/add/operator/skipWhile.js', ['rxjs/Observable.js', 'rxjs/operator/skipWhile.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var skipWhile_1 = $__require('rxjs/operator/skipWhile.js');
  Observable_1.Observable.prototype.skipWhile = skipWhile_1.skipWhile;
  
});
System.registerDynamic("rxjs/operator/startWith.js", ["rxjs/operators/startWith.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var startWith_1 = $__require("rxjs/operators/startWith.js");
    /* tslint:enable:max-line-length */
    /**
     * Returns an Observable that emits the items you specify as arguments before it begins to emit
     * items emitted by the source Observable.
     *
     * <img src="./img/startWith.png" width="100%">
     *
     * @param {...T} values - Items you want the modified Observable to emit first.
     * @param {Scheduler} [scheduler] - A {@link IScheduler} to use for scheduling
     * the emissions of the `next` notifications.
     * @return {Observable} An Observable that emits the items in the specified Iterable and then emits the items
     * emitted by the source Observable.
     * @method startWith
     * @owner Observable
     */
    function startWith() {
        var array = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            array[_i - 0] = arguments[_i];
        }
        return startWith_1.startWith.apply(void 0, array)(this);
    }
    exports.startWith = startWith;
    
});
System.registerDynamic('rxjs/add/operator/startWith.js', ['rxjs/Observable.js', 'rxjs/operator/startWith.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var startWith_1 = $__require('rxjs/operator/startWith.js');
  Observable_1.Observable.prototype.startWith = startWith_1.startWith;
  
});
System.registerDynamic('rxjs/observable/SubscribeOnObservable.js', ['rxjs/Observable.js', 'rxjs/scheduler/asap.js', 'rxjs/util/isNumeric.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Observable_1 = $__require('rxjs/Observable.js');
    var asap_1 = $__require('rxjs/scheduler/asap.js');
    var isNumeric_1 = $__require('rxjs/util/isNumeric.js');
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @extends {Ignored}
     * @hide true
     */
    var SubscribeOnObservable = function (_super) {
        __extends(SubscribeOnObservable, _super);
        function SubscribeOnObservable(source, delayTime, scheduler) {
            if (delayTime === void 0) {
                delayTime = 0;
            }
            if (scheduler === void 0) {
                scheduler = asap_1.asap;
            }
            _super.call(this);
            this.source = source;
            this.delayTime = delayTime;
            this.scheduler = scheduler;
            if (!isNumeric_1.isNumeric(delayTime) || delayTime < 0) {
                this.delayTime = 0;
            }
            if (!scheduler || typeof scheduler.schedule !== 'function') {
                this.scheduler = asap_1.asap;
            }
        }
        SubscribeOnObservable.create = function (source, delay, scheduler) {
            if (delay === void 0) {
                delay = 0;
            }
            if (scheduler === void 0) {
                scheduler = asap_1.asap;
            }
            return new SubscribeOnObservable(source, delay, scheduler);
        };
        SubscribeOnObservable.dispatch = function (arg) {
            var source = arg.source,
                subscriber = arg.subscriber;
            return this.add(source.subscribe(subscriber));
        };
        /** @deprecated internal use only */SubscribeOnObservable.prototype._subscribe = function (subscriber) {
            var delay = this.delayTime;
            var source = this.source;
            var scheduler = this.scheduler;
            return scheduler.schedule(SubscribeOnObservable.dispatch, delay, {
                source: source, subscriber: subscriber
            });
        };
        return SubscribeOnObservable;
    }(Observable_1.Observable);
    exports.SubscribeOnObservable = SubscribeOnObservable;
    
});
System.registerDynamic("rxjs/operators/subscribeOn.js", ["rxjs/observable/SubscribeOnObservable.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var SubscribeOnObservable_1 = $__require("rxjs/observable/SubscribeOnObservable.js");
    /**
     * Asynchronously subscribes Observers to this Observable on the specified IScheduler.
     *
     * <img src="./img/subscribeOn.png" width="100%">
     *
     * @param {Scheduler} scheduler - The IScheduler to perform subscription actions on.
     * @return {Observable<T>} The source Observable modified so that its subscriptions happen on the specified IScheduler.
     .
     * @method subscribeOn
     * @owner Observable
     */
    function subscribeOn(scheduler, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        return function subscribeOnOperatorFunction(source) {
            return source.lift(new SubscribeOnOperator(scheduler, delay));
        };
    }
    exports.subscribeOn = subscribeOn;
    var SubscribeOnOperator = function () {
        function SubscribeOnOperator(scheduler, delay) {
            this.scheduler = scheduler;
            this.delay = delay;
        }
        SubscribeOnOperator.prototype.call = function (subscriber, source) {
            return new SubscribeOnObservable_1.SubscribeOnObservable(source, this.delay, this.scheduler).subscribe(subscriber);
        };
        return SubscribeOnOperator;
    }();
    
});
System.registerDynamic("rxjs/operator/subscribeOn.js", ["rxjs/operators/subscribeOn.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var subscribeOn_1 = $__require("rxjs/operators/subscribeOn.js");
  /**
   * Asynchronously subscribes Observers to this Observable on the specified IScheduler.
   *
   * <img src="./img/subscribeOn.png" width="100%">
   *
   * @param {Scheduler} scheduler - The IScheduler to perform subscription actions on.
   * @return {Observable<T>} The source Observable modified so that its subscriptions happen on the specified IScheduler.
   .
   * @method subscribeOn
   * @owner Observable
   */
  function subscribeOn(scheduler, delay) {
    if (delay === void 0) {
      delay = 0;
    }
    return subscribeOn_1.subscribeOn(scheduler, delay)(this);
  }
  exports.subscribeOn = subscribeOn;
  
});
System.registerDynamic('rxjs/add/operator/subscribeOn.js', ['rxjs/Observable.js', 'rxjs/operator/subscribeOn.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var subscribeOn_1 = $__require('rxjs/operator/subscribeOn.js');
  Observable_1.Observable.prototype.subscribeOn = subscribeOn_1.subscribeOn;
  
});
System.registerDynamic("rxjs/operator/switch.js", ["rxjs/operators/switchAll.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var switchAll_1 = $__require("rxjs/operators/switchAll.js");
  /**
   * Converts a higher-order Observable into a first-order Observable by
   * subscribing to only the most recently emitted of those inner Observables.
   *
   * <span class="informal">Flattens an Observable-of-Observables by dropping the
   * previous inner Observable once a new one appears.</span>
   *
   * <img src="./img/switch.png" width="100%">
   *
   * `switch` subscribes to an Observable that emits Observables, also known as a
   * higher-order Observable. Each time it observes one of these emitted inner
   * Observables, the output Observable subscribes to the inner Observable and
   * begins emitting the items emitted by that. So far, it behaves
   * like {@link mergeAll}. However, when a new inner Observable is emitted,
   * `switch` unsubscribes from the earlier-emitted inner Observable and
   * subscribes to the new inner Observable and begins emitting items from it. It
   * continues to behave like this for subsequent inner Observables.
   *
   * @example <caption>Rerun an interval Observable on every click event</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * // Each click event is mapped to an Observable that ticks every second
   * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
   * var switched = higherOrder.switch();
   * // The outcome is that `switched` is essentially a timer that restarts
   * // on every click. The interval Observables from older clicks do not merge
   * // with the current interval Observable.
   * switched.subscribe(x => console.log(x));
   *
   * @see {@link combineAll}
   * @see {@link concatAll}
   * @see {@link exhaust}
   * @see {@link mergeAll}
   * @see {@link switchMap}
   * @see {@link switchMapTo}
   * @see {@link zipAll}
   *
   * @return {Observable<T>} An Observable that emits the items emitted by the
   * Observable most recently emitted by the source Observable.
   * @method switch
   * @name switch
   * @owner Observable
   */
  function _switch() {
    return switchAll_1.switchAll()(this);
  }
  exports._switch = _switch;
  
});
System.registerDynamic('rxjs/add/operator/switch.js', ['rxjs/Observable.js', 'rxjs/operator/switch.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var switch_1 = $__require('rxjs/operator/switch.js');
  Observable_1.Observable.prototype.switch = switch_1._switch;
  Observable_1.Observable.prototype._switch = switch_1._switch;
  
});
System.registerDynamic("rxjs/operator/switchMap.js", ["rxjs/operators/switchMap.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var switchMap_1 = $__require("rxjs/operators/switchMap.js");
  /* tslint:enable:max-line-length */
  /**
   * Projects each source value to an Observable which is merged in the output
   * Observable, emitting values only from the most recently projected Observable.
   *
   * <span class="informal">Maps each value to an Observable, then flattens all of
   * these inner Observables using {@link switch}.</span>
   *
   * <img src="./img/switchMap.png" width="100%">
   *
   * Returns an Observable that emits items based on applying a function that you
   * supply to each item emitted by the source Observable, where that function
   * returns an (so-called "inner") Observable. Each time it observes one of these
   * inner Observables, the output Observable begins emitting the items emitted by
   * that inner Observable. When a new inner Observable is emitted, `switchMap`
   * stops emitting items from the earlier-emitted inner Observable and begins
   * emitting items from the new one. It continues to behave like this for
   * subsequent inner Observables.
   *
   * @example <caption>Rerun an interval Observable on every click event</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
   * result.subscribe(x => console.log(x));
   *
   * @see {@link concatMap}
   * @see {@link exhaustMap}
   * @see {@link mergeMap}
   * @see {@link switch}
   * @see {@link switchMapTo}
   *
   * @param {function(value: T, ?index: number): ObservableInput} project A function
   * that, when applied to an item emitted by the source Observable, returns an
   * Observable.
   * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
   * A function to produce the value on the output Observable based on the values
   * and the indices of the source (outer) emission and the inner Observable
   * emission. The arguments passed to this function are:
   * - `outerValue`: the value that came from the source
   * - `innerValue`: the value that came from the projected Observable
   * - `outerIndex`: the "index" of the value that came from the source
   * - `innerIndex`: the "index" of the value from the projected Observable
   * @return {Observable} An Observable that emits the result of applying the
   * projection function (and the optional `resultSelector`) to each item emitted
   * by the source Observable and taking only the values from the most recently
   * projected inner Observable.
   * @method switchMap
   * @owner Observable
   */
  function switchMap(project, resultSelector) {
    return switchMap_1.switchMap(project, resultSelector)(this);
  }
  exports.switchMap = switchMap;
  
});
System.registerDynamic('rxjs/add/operator/switchMap.js', ['rxjs/Observable.js', 'rxjs/operator/switchMap.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var switchMap_1 = $__require('rxjs/operator/switchMap.js');
  Observable_1.Observable.prototype.switchMap = switchMap_1.switchMap;
  
});
System.registerDynamic("rxjs/operator/switchMapTo.js", ["rxjs/operators/switchMapTo.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var switchMapTo_1 = $__require("rxjs/operators/switchMapTo.js");
  /* tslint:enable:max-line-length */
  /**
   * Projects each source value to the same Observable which is flattened multiple
   * times with {@link switch} in the output Observable.
   *
   * <span class="informal">It's like {@link switchMap}, but maps each value
   * always to the same inner Observable.</span>
   *
   * <img src="./img/switchMapTo.png" width="100%">
   *
   * Maps each source value to the given Observable `innerObservable` regardless
   * of the source value, and then flattens those resulting Observables into one
   * single Observable, which is the output Observable. The output Observables
   * emits values only from the most recently emitted instance of
   * `innerObservable`.
   *
   * @example <caption>Rerun an interval Observable on every click event</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var result = clicks.switchMapTo(Rx.Observable.interval(1000));
   * result.subscribe(x => console.log(x));
   *
   * @see {@link concatMapTo}
   * @see {@link switch}
   * @see {@link switchMap}
   * @see {@link mergeMapTo}
   *
   * @param {ObservableInput} innerObservable An Observable to replace each value from
   * the source Observable.
   * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
   * A function to produce the value on the output Observable based on the values
   * and the indices of the source (outer) emission and the inner Observable
   * emission. The arguments passed to this function are:
   * - `outerValue`: the value that came from the source
   * - `innerValue`: the value that came from the projected Observable
   * - `outerIndex`: the "index" of the value that came from the source
   * - `innerIndex`: the "index" of the value from the projected Observable
   * @return {Observable} An Observable that emits items from the given
   * `innerObservable` (and optionally transformed through `resultSelector`) every
   * time a value is emitted on the source Observable, and taking only the values
   * from the most recently projected inner Observable.
   * @method switchMapTo
   * @owner Observable
   */
  function switchMapTo(innerObservable, resultSelector) {
    return switchMapTo_1.switchMapTo(innerObservable, resultSelector)(this);
  }
  exports.switchMapTo = switchMapTo;
  
});
System.registerDynamic('rxjs/add/operator/switchMapTo.js', ['rxjs/Observable.js', 'rxjs/operator/switchMapTo.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var switchMapTo_1 = $__require('rxjs/operator/switchMapTo.js');
  Observable_1.Observable.prototype.switchMapTo = switchMapTo_1.switchMapTo;
  
});
System.registerDynamic("rxjs/operator/take.js", ["rxjs/operators/take.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var take_1 = $__require("rxjs/operators/take.js");
  /**
   * Emits only the first `count` values emitted by the source Observable.
   *
   * <span class="informal">Takes the first `count` values from the source, then
   * completes.</span>
   *
   * <img src="./img/take.png" width="100%">
   *
   * `take` returns an Observable that emits only the first `count` values emitted
   * by the source Observable. If the source emits fewer than `count` values then
   * all of its values are emitted. After that, it completes, regardless if the
   * source completes.
   *
   * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
   * var interval = Rx.Observable.interval(1000);
   * var five = interval.take(5);
   * five.subscribe(x => console.log(x));
   *
   * @see {@link takeLast}
   * @see {@link takeUntil}
   * @see {@link takeWhile}
   * @see {@link skip}
   *
   * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
   * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
   *
   * @param {number} count The maximum number of `next` values to emit.
   * @return {Observable<T>} An Observable that emits only the first `count`
   * values emitted by the source Observable, or all of the values from the source
   * if the source emits fewer than `count` values.
   * @method take
   * @owner Observable
   */
  function take(count) {
    return take_1.take(count)(this);
  }
  exports.take = take;
  
});
System.registerDynamic('rxjs/add/operator/take.js', ['rxjs/Observable.js', 'rxjs/operator/take.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var take_1 = $__require('rxjs/operator/take.js');
  Observable_1.Observable.prototype.take = take_1.take;
  
});
System.registerDynamic("rxjs/operator/takeLast.js", ["rxjs/operators/takeLast.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var takeLast_1 = $__require("rxjs/operators/takeLast.js");
  /**
   * Emits only the last `count` values emitted by the source Observable.
   *
   * <span class="informal">Remembers the latest `count` values, then emits those
   * only when the source completes.</span>
   *
   * <img src="./img/takeLast.png" width="100%">
   *
   * `takeLast` returns an Observable that emits at most the last `count` values
   * emitted by the source Observable. If the source emits fewer than `count`
   * values then all of its values are emitted. This operator must wait until the
   * `complete` notification emission from the source in order to emit the `next`
   * values on the output Observable, because otherwise it is impossible to know
   * whether or not more values will be emitted on the source. For this reason,
   * all values are emitted synchronously, followed by the complete notification.
   *
   * @example <caption>Take the last 3 values of an Observable with many values</caption>
   * var many = Rx.Observable.range(1, 100);
   * var lastThree = many.takeLast(3);
   * lastThree.subscribe(x => console.log(x));
   *
   * @see {@link take}
   * @see {@link takeUntil}
   * @see {@link takeWhile}
   * @see {@link skip}
   *
   * @throws {ArgumentOutOfRangeError} When using `takeLast(i)`, it delivers an
   * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
   *
   * @param {number} count The maximum number of values to emit from the end of
   * the sequence of values emitted by the source Observable.
   * @return {Observable<T>} An Observable that emits at most the last count
   * values emitted by the source Observable.
   * @method takeLast
   * @owner Observable
   */
  function takeLast(count) {
    return takeLast_1.takeLast(count)(this);
  }
  exports.takeLast = takeLast;
  
});
System.registerDynamic('rxjs/add/operator/takeLast.js', ['rxjs/Observable.js', 'rxjs/operator/takeLast.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var takeLast_1 = $__require('rxjs/operator/takeLast.js');
  Observable_1.Observable.prototype.takeLast = takeLast_1.takeLast;
  
});
System.registerDynamic("rxjs/operator/takeUntil.js", ["rxjs/operators/takeUntil.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var takeUntil_1 = $__require("rxjs/operators/takeUntil.js");
  /**
   * Emits the values emitted by the source Observable until a `notifier`
   * Observable emits a value.
   *
   * <span class="informal">Lets values pass until a second Observable,
   * `notifier`, emits something. Then, it completes.</span>
   *
   * <img src="./img/takeUntil.png" width="100%">
   *
   * `takeUntil` subscribes and begins mirroring the source Observable. It also
   * monitors a second Observable, `notifier` that you provide. If the `notifier`
   * emits a value, the output Observable stops mirroring the source Observable
   * and completes.
   *
   * @example <caption>Tick every second until the first click happens</caption>
   * var interval = Rx.Observable.interval(1000);
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var result = interval.takeUntil(clicks);
   * result.subscribe(x => console.log(x));
   *
   * @see {@link take}
   * @see {@link takeLast}
   * @see {@link takeWhile}
   * @see {@link skip}
   *
   * @param {Observable} notifier The Observable whose first emitted value will
   * cause the output Observable of `takeUntil` to stop emitting values from the
   * source Observable.
   * @return {Observable<T>} An Observable that emits the values from the source
   * Observable until such time as `notifier` emits its first value.
   * @method takeUntil
   * @owner Observable
   */
  function takeUntil(notifier) {
    return takeUntil_1.takeUntil(notifier)(this);
  }
  exports.takeUntil = takeUntil;
  
});
System.registerDynamic('rxjs/add/operator/takeUntil.js', ['rxjs/Observable.js', 'rxjs/operator/takeUntil.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var takeUntil_1 = $__require('rxjs/operator/takeUntil.js');
  Observable_1.Observable.prototype.takeUntil = takeUntil_1.takeUntil;
  
});
System.registerDynamic("rxjs/operator/takeWhile.js", ["rxjs/operators/takeWhile.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var takeWhile_1 = $__require("rxjs/operators/takeWhile.js");
  /**
   * Emits values emitted by the source Observable so long as each value satisfies
   * the given `predicate`, and then completes as soon as this `predicate` is not
   * satisfied.
   *
   * <span class="informal">Takes values from the source only while they pass the
   * condition given. When the first value does not satisfy, it completes.</span>
   *
   * <img src="./img/takeWhile.png" width="100%">
   *
   * `takeWhile` subscribes and begins mirroring the source Observable. Each value
   * emitted on the source is given to the `predicate` function which returns a
   * boolean, representing a condition to be satisfied by the source values. The
   * output Observable emits the source values until such time as the `predicate`
   * returns false, at which point `takeWhile` stops mirroring the source
   * Observable and completes the output Observable.
   *
   * @example <caption>Emit click events only while the clientX property is greater than 200</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var result = clicks.takeWhile(ev => ev.clientX > 200);
   * result.subscribe(x => console.log(x));
   *
   * @see {@link take}
   * @see {@link takeLast}
   * @see {@link takeUntil}
   * @see {@link skip}
   *
   * @param {function(value: T, index: number): boolean} predicate A function that
   * evaluates a value emitted by the source Observable and returns a boolean.
   * Also takes the (zero-based) index as the second argument.
   * @return {Observable<T>} An Observable that emits the values from the source
   * Observable so long as each value satisfies the condition defined by the
   * `predicate`, then completes.
   * @method takeWhile
   * @owner Observable
   */
  function takeWhile(predicate) {
    return takeWhile_1.takeWhile(predicate)(this);
  }
  exports.takeWhile = takeWhile;
  
});
System.registerDynamic('rxjs/add/operator/takeWhile.js', ['rxjs/Observable.js', 'rxjs/operator/takeWhile.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var takeWhile_1 = $__require('rxjs/operator/takeWhile.js');
  Observable_1.Observable.prototype.takeWhile = takeWhile_1.takeWhile;
  
});
System.registerDynamic("rxjs/operator/throttle.js", ["rxjs/operators/throttle.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var throttle_1 = $__require("rxjs/operators/throttle.js");
  /**
   * Emits a value from the source Observable, then ignores subsequent source
   * values for a duration determined by another Observable, then repeats this
   * process.
   *
   * <span class="informal">It's like {@link throttleTime}, but the silencing
   * duration is determined by a second Observable.</span>
   *
   * <img src="./img/throttle.png" width="100%">
   *
   * `throttle` emits the source Observable values on the output Observable
   * when its internal timer is disabled, and ignores source values when the timer
   * is enabled. Initially, the timer is disabled. As soon as the first source
   * value arrives, it is forwarded to the output Observable, and then the timer
   * is enabled by calling the `durationSelector` function with the source value,
   * which returns the "duration" Observable. When the duration Observable emits a
   * value or completes, the timer is disabled, and this process repeats for the
   * next source value.
   *
   * @example <caption>Emit clicks at a rate of at most one click per second</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var result = clicks.throttle(ev => Rx.Observable.interval(1000));
   * result.subscribe(x => console.log(x));
   *
   * @see {@link audit}
   * @see {@link debounce}
   * @see {@link delayWhen}
   * @see {@link sample}
   * @see {@link throttleTime}
   *
   * @param {function(value: T): SubscribableOrPromise} durationSelector A function
   * that receives a value from the source Observable, for computing the silencing
   * duration for each source value, returned as an Observable or a Promise.
   * @param {Object} config a configuration object to define `leading` and `trailing` behavior. Defaults
   * to `{ leading: true, trailing: false }`.
   * @return {Observable<T>} An Observable that performs the throttle operation to
   * limit the rate of emissions from the source.
   * @method throttle
   * @owner Observable
   */
  function throttle(durationSelector, config) {
    if (config === void 0) {
      config = throttle_1.defaultThrottleConfig;
    }
    return throttle_1.throttle(durationSelector, config)(this);
  }
  exports.throttle = throttle;
  
});
System.registerDynamic('rxjs/add/operator/throttle.js', ['rxjs/Observable.js', 'rxjs/operator/throttle.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var throttle_1 = $__require('rxjs/operator/throttle.js');
  Observable_1.Observable.prototype.throttle = throttle_1.throttle;
  
});
System.registerDynamic('rxjs/operator/throttleTime.js', ['rxjs/scheduler/async.js', 'rxjs/operators/throttle.js', 'rxjs/operators/throttleTime.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var async_1 = $__require('rxjs/scheduler/async.js');
  var throttle_1 = $__require('rxjs/operators/throttle.js');
  var throttleTime_1 = $__require('rxjs/operators/throttleTime.js');
  /**
   * Emits a value from the source Observable, then ignores subsequent source
   * values for `duration` milliseconds, then repeats this process.
   *
   * <span class="informal">Lets a value pass, then ignores source values for the
   * next `duration` milliseconds.</span>
   *
   * <img src="./img/throttleTime.png" width="100%">
   *
   * `throttleTime` emits the source Observable values on the output Observable
   * when its internal timer is disabled, and ignores source values when the timer
   * is enabled. Initially, the timer is disabled. As soon as the first source
   * value arrives, it is forwarded to the output Observable, and then the timer
   * is enabled. After `duration` milliseconds (or the time unit determined
   * internally by the optional `scheduler`) has passed, the timer is disabled,
   * and this process repeats for the next source value. Optionally takes a
   * {@link IScheduler} for managing timers.
   *
   * @example <caption>Emit clicks at a rate of at most one click per second</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var result = clicks.throttleTime(1000);
   * result.subscribe(x => console.log(x));
   *
   * @see {@link auditTime}
   * @see {@link debounceTime}
   * @see {@link delay}
   * @see {@link sampleTime}
   * @see {@link throttle}
   *
   * @param {number} duration Time to wait before emitting another value after
   * emitting the last value, measured in milliseconds or the time unit determined
   * internally by the optional `scheduler`.
   * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
   * managing the timers that handle the throttling.
   * @return {Observable<T>} An Observable that performs the throttle operation to
   * limit the rate of emissions from the source.
   * @method throttleTime
   * @owner Observable
   */
  function throttleTime(duration, scheduler, config) {
    if (scheduler === void 0) {
      scheduler = async_1.async;
    }
    if (config === void 0) {
      config = throttle_1.defaultThrottleConfig;
    }
    return throttleTime_1.throttleTime(duration, scheduler, config)(this);
  }
  exports.throttleTime = throttleTime;
  
});
System.registerDynamic('rxjs/add/operator/throttleTime.js', ['rxjs/Observable.js', 'rxjs/operator/throttleTime.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var throttleTime_1 = $__require('rxjs/operator/throttleTime.js');
  Observable_1.Observable.prototype.throttleTime = throttleTime_1.throttleTime;
  
});
System.registerDynamic('rxjs/add/operator/timeInterval.js', ['rxjs/Observable.js', 'rxjs/operator/timeInterval.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var timeInterval_1 = $__require('rxjs/operator/timeInterval.js');
  Observable_1.Observable.prototype.timeInterval = timeInterval_1.timeInterval;
  
});
System.registerDynamic('rxjs/operator/timeout.js', ['rxjs/scheduler/async.js', 'rxjs/operators/timeout.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var async_1 = $__require('rxjs/scheduler/async.js');
  var timeout_1 = $__require('rxjs/operators/timeout.js');
  /**
   *
   * Errors if Observable does not emit a value in given time span.
   *
   * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
   *
   * <img src="./img/timeout.png" width="100%">
   *
   * `timeout` operator accepts as an argument either a number or a Date.
   *
   * If number was provided, it returns an Observable that behaves like a source
   * Observable, unless there is a period of time where there is no value emitted.
   * So if you provide `100` as argument and first value comes after 50ms from
   * the moment of subscription, this value will be simply re-emitted by the resulting
   * Observable. If however after that 100ms passes without a second value being emitted,
   * stream will end with an error and source Observable will be unsubscribed.
   * These checks are performed throughout whole lifecycle of Observable - from the moment
   * it was subscribed to, until it completes or errors itself. Thus every value must be
   * emitted within specified period since previous value.
   *
   * If provided argument was Date, returned Observable behaves differently. It throws
   * if Observable did not complete before provided Date. This means that periods between
   * emission of particular values do not matter in this case. If Observable did not complete
   * before provided Date, source Observable will be unsubscribed. Other than that, resulting
   * stream behaves just as source Observable.
   *
   * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
   * when returned Observable will check if source stream emitted value or completed.
   *
   * @example <caption>Check if ticks are emitted within certain timespan</caption>
   * const seconds = Rx.Observable.interval(1000);
   *
   * seconds.timeout(1100) // Let's use bigger timespan to be safe,
   *                       // since `interval` might fire a bit later then scheduled.
   * .subscribe(
   *     value => console.log(value), // Will emit numbers just as regular `interval` would.
   *     err => console.log(err) // Will never be called.
   * );
   *
   * seconds.timeout(900).subscribe(
   *     value => console.log(value), // Will never be called.
   *     err => console.log(err) // Will emit error before even first value is emitted,
   *                             // since it did not arrive within 900ms period.
   * );
   *
   * @example <caption>Use Date to check if Observable completed</caption>
   * const seconds = Rx.Observable.interval(1000);
   *
   * seconds.timeout(new Date("December 17, 2020 03:24:00"))
   * .subscribe(
   *     value => console.log(value), // Will emit values as regular `interval` would
   *                                  // until December 17, 2020 at 03:24:00.
   *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
   *                             // since Observable did not complete by then.
   * );
   *
   * @see {@link timeoutWith}
   *
   * @param {number|Date} due Number specifying period within which Observable must emit values
   *                          or Date specifying before when Observable should complete
   * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
   * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
   * @method timeout
   * @owner Observable
   */
  function timeout(due, scheduler) {
    if (scheduler === void 0) {
      scheduler = async_1.async;
    }
    return timeout_1.timeout(due, scheduler)(this);
  }
  exports.timeout = timeout;
  
});
System.registerDynamic('rxjs/add/operator/timeout.js', ['rxjs/Observable.js', 'rxjs/operator/timeout.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var timeout_1 = $__require('rxjs/operator/timeout.js');
  Observable_1.Observable.prototype.timeout = timeout_1.timeout;
  
});
System.registerDynamic('rxjs/operator/timeoutWith.js', ['rxjs/scheduler/async.js', 'rxjs/operators/timeoutWith.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var async_1 = $__require('rxjs/scheduler/async.js');
  var timeoutWith_1 = $__require('rxjs/operators/timeoutWith.js');
  /* tslint:enable:max-line-length */
  /**
   *
   * Errors if Observable does not emit a value in given time span, in case of which
   * subscribes to the second Observable.
   *
   * <span class="informal">It's a version of `timeout` operator that let's you specify fallback Observable.</span>
   *
   * <img src="./img/timeoutWith.png" width="100%">
   *
   * `timeoutWith` is a variation of `timeout` operator. It behaves exactly the same,
   * still accepting as a first argument either a number or a Date, which control - respectively -
   * when values of source Observable should be emitted or when it should complete.
   *
   * The only difference is that it accepts a second, required parameter. This parameter
   * should be an Observable which will be subscribed when source Observable fails any timeout check.
   * So whenever regular `timeout` would emit an error, `timeoutWith` will instead start re-emitting
   * values from second Observable. Note that this fallback Observable is not checked for timeouts
   * itself, so it can emit values and complete at arbitrary points in time. From the moment of a second
   * subscription, Observable returned from `timeoutWith` simply mirrors fallback stream. When that
   * stream completes, it completes as well.
   *
   * Scheduler, which in case of `timeout` is provided as as second argument, can be still provided
   * here - as a third, optional parameter. It still is used to schedule timeout checks and -
   * as a consequence - when second Observable will be subscribed, since subscription happens
   * immediately after failing check.
   *
   * @example <caption>Add fallback observable</caption>
   * const seconds = Rx.Observable.interval(1000);
   * const minutes = Rx.Observable.interval(60 * 1000);
   *
   * seconds.timeoutWith(900, minutes)
   *     .subscribe(
   *         value => console.log(value), // After 900ms, will start emitting `minutes`,
   *                                      // since first value of `seconds` will not arrive fast enough.
   *         err => console.log(err) // Would be called after 900ms in case of `timeout`,
   *                                 // but here will never be called.
   *     );
   *
   * @param {number|Date} due Number specifying period within which Observable must emit values
   *                          or Date specifying before when Observable should complete
   * @param {Observable<T>} withObservable Observable which will be subscribed if source fails timeout check.
   * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
   * @return {Observable<T>} Observable that mirrors behaviour of source or, when timeout check fails, of an Observable
   *                          passed as a second parameter.
   * @method timeoutWith
   * @owner Observable
   */
  function timeoutWith(due, withObservable, scheduler) {
    if (scheduler === void 0) {
      scheduler = async_1.async;
    }
    return timeoutWith_1.timeoutWith(due, withObservable, scheduler)(this);
  }
  exports.timeoutWith = timeoutWith;
  
});
System.registerDynamic('rxjs/add/operator/timeoutWith.js', ['rxjs/Observable.js', 'rxjs/operator/timeoutWith.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var timeoutWith_1 = $__require('rxjs/operator/timeoutWith.js');
  Observable_1.Observable.prototype.timeoutWith = timeoutWith_1.timeoutWith;
  
});
System.registerDynamic('rxjs/operator/timestamp.js', ['rxjs/scheduler/async.js', 'rxjs/operators/timestamp.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var async_1 = $__require('rxjs/scheduler/async.js');
  var timestamp_1 = $__require('rxjs/operators/timestamp.js');
  /**
   * @param scheduler
   * @return {Observable<Timestamp<any>>|WebSocketSubject<T>|Observable<T>}
   * @method timestamp
   * @owner Observable
   */
  function timestamp(scheduler) {
    if (scheduler === void 0) {
      scheduler = async_1.async;
    }
    return timestamp_1.timestamp(scheduler)(this);
  }
  exports.timestamp = timestamp;
  
});
System.registerDynamic('rxjs/add/operator/timestamp.js', ['rxjs/Observable.js', 'rxjs/operator/timestamp.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var timestamp_1 = $__require('rxjs/operator/timestamp.js');
  Observable_1.Observable.prototype.timestamp = timestamp_1.timestamp;
  
});
System.registerDynamic("rxjs/operator/toArray.js", ["rxjs/operators/toArray.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var toArray_1 = $__require("rxjs/operators/toArray.js");
  /**
   * Collects all source emissions and emits them as an array when the source completes.
   *
   * <span class="informal">Get all values inside an array when the source completes</span>
   *
   * <img src="./img/toArray.png" width="100%">
   *
   * `toArray` will wait until the source Observable completes
   * before emitting the array containing all emissions.
   * When the source Observable errors no array will be emitted.
   *
   * @example <caption>Create array from input</caption>
   * const input = Rx.Observable.interval(100).take(4);
   *
   * input.toArray()
   *   .subscribe(arr => console.log(arr)); // [0,1,2,3]
   *
   * @see {@link buffer}
   *
   * @return {Observable<any[]>|WebSocketSubject<T>|Observable<T>}
   * @method toArray
   * @owner Observable
   */
  function toArray() {
    return toArray_1.toArray()(this);
  }
  exports.toArray = toArray;
  
});
System.registerDynamic('rxjs/add/operator/toArray.js', ['rxjs/Observable.js', 'rxjs/operator/toArray.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var toArray_1 = $__require('rxjs/operator/toArray.js');
  Observable_1.Observable.prototype.toArray = toArray_1.toArray;
  
});
System.registerDynamic("rxjs/operator/window.js", ["rxjs/operators/window.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var window_1 = $__require("rxjs/operators/window.js");
  /**
   * Branch out the source Observable values as a nested Observable whenever
   * `windowBoundaries` emits.
   *
   * <span class="informal">It's like {@link buffer}, but emits a nested Observable
   * instead of an array.</span>
   *
   * <img src="./img/window.png" width="100%">
   *
   * Returns an Observable that emits windows of items it collects from the source
   * Observable. The output Observable emits connected, non-overlapping
   * windows. It emits the current window and opens a new one whenever the
   * Observable `windowBoundaries` emits an item. Because each window is an
   * Observable, the output is a higher-order Observable.
   *
   * @example <caption>In every window of 1 second each, emit at most 2 click events</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var interval = Rx.Observable.interval(1000);
   * var result = clicks.window(interval)
   *   .map(win => win.take(2)) // each window has at most 2 emissions
   *   .mergeAll(); // flatten the Observable-of-Observables
   * result.subscribe(x => console.log(x));
   *
   * @see {@link windowCount}
   * @see {@link windowTime}
   * @see {@link windowToggle}
   * @see {@link windowWhen}
   * @see {@link buffer}
   *
   * @param {Observable<any>} windowBoundaries An Observable that completes the
   * previous window and starts a new window.
   * @return {Observable<Observable<T>>} An Observable of windows, which are
   * Observables emitting values of the source Observable.
   * @method window
   * @owner Observable
   */
  function window(windowBoundaries) {
    return window_1.window(windowBoundaries)(this);
  }
  exports.window = window;
  
});
System.registerDynamic('rxjs/add/operator/window.js', ['rxjs/Observable.js', 'rxjs/operator/window.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var window_1 = $__require('rxjs/operator/window.js');
  Observable_1.Observable.prototype.window = window_1.window;
  
});
System.registerDynamic("rxjs/operator/windowCount.js", ["rxjs/operators/windowCount.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var windowCount_1 = $__require("rxjs/operators/windowCount.js");
  /**
   * Branch out the source Observable values as a nested Observable with each
   * nested Observable emitting at most `windowSize` values.
   *
   * <span class="informal">It's like {@link bufferCount}, but emits a nested
   * Observable instead of an array.</span>
   *
   * <img src="./img/windowCount.png" width="100%">
   *
   * Returns an Observable that emits windows of items it collects from the source
   * Observable. The output Observable emits windows every `startWindowEvery`
   * items, each containing no more than `windowSize` items. When the source
   * Observable completes or encounters an error, the output Observable emits
   * the current window and propagates the notification from the source
   * Observable. If `startWindowEvery` is not provided, then new windows are
   * started immediately at the start of the source and when each window completes
   * with size `windowSize`.
   *
   * @example <caption>Ignore every 3rd click event, starting from the first one</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var result = clicks.windowCount(3)
   *   .map(win => win.skip(1)) // skip first of every 3 clicks
   *   .mergeAll(); // flatten the Observable-of-Observables
   * result.subscribe(x => console.log(x));
   *
   * @example <caption>Ignore every 3rd click event, starting from the third one</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var result = clicks.windowCount(2, 3)
   *   .mergeAll(); // flatten the Observable-of-Observables
   * result.subscribe(x => console.log(x));
   *
   * @see {@link window}
   * @see {@link windowTime}
   * @see {@link windowToggle}
   * @see {@link windowWhen}
   * @see {@link bufferCount}
   *
   * @param {number} windowSize The maximum number of values emitted by each
   * window.
   * @param {number} [startWindowEvery] Interval at which to start a new window.
   * For example if `startWindowEvery` is `2`, then a new window will be started
   * on every other value from the source. A new window is started at the
   * beginning of the source by default.
   * @return {Observable<Observable<T>>} An Observable of windows, which in turn
   * are Observable of values.
   * @method windowCount
   * @owner Observable
   */
  function windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) {
      startWindowEvery = 0;
    }
    return windowCount_1.windowCount(windowSize, startWindowEvery)(this);
  }
  exports.windowCount = windowCount;
  
});
System.registerDynamic('rxjs/add/operator/windowCount.js', ['rxjs/Observable.js', 'rxjs/operator/windowCount.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var windowCount_1 = $__require('rxjs/operator/windowCount.js');
  Observable_1.Observable.prototype.windowCount = windowCount_1.windowCount;
  
});
System.registerDynamic('rxjs/operator/windowTime.js', ['rxjs/scheduler/async.js', 'rxjs/util/isNumeric.js', 'rxjs/util/isScheduler.js', 'rxjs/operators/windowTime.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var async_1 = $__require('rxjs/scheduler/async.js');
    var isNumeric_1 = $__require('rxjs/util/isNumeric.js');
    var isScheduler_1 = $__require('rxjs/util/isScheduler.js');
    var windowTime_1 = $__require('rxjs/operators/windowTime.js');
    function windowTime(windowTimeSpan) {
        var scheduler = async_1.async;
        var windowCreationInterval = null;
        var maxWindowSize = Number.POSITIVE_INFINITY;
        if (isScheduler_1.isScheduler(arguments[3])) {
            scheduler = arguments[3];
        }
        if (isScheduler_1.isScheduler(arguments[2])) {
            scheduler = arguments[2];
        } else if (isNumeric_1.isNumeric(arguments[2])) {
            maxWindowSize = arguments[2];
        }
        if (isScheduler_1.isScheduler(arguments[1])) {
            scheduler = arguments[1];
        } else if (isNumeric_1.isNumeric(arguments[1])) {
            windowCreationInterval = arguments[1];
        }
        return windowTime_1.windowTime(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler)(this);
    }
    exports.windowTime = windowTime;
    
});
System.registerDynamic('rxjs/add/operator/windowTime.js', ['rxjs/Observable.js', 'rxjs/operator/windowTime.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var windowTime_1 = $__require('rxjs/operator/windowTime.js');
  Observable_1.Observable.prototype.windowTime = windowTime_1.windowTime;
  
});
System.registerDynamic("rxjs/operator/windowToggle.js", ["rxjs/operators/windowToggle.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var windowToggle_1 = $__require("rxjs/operators/windowToggle.js");
  /**
   * Branch out the source Observable values as a nested Observable starting from
   * an emission from `openings` and ending when the output of `closingSelector`
   * emits.
   *
   * <span class="informal">It's like {@link bufferToggle}, but emits a nested
   * Observable instead of an array.</span>
   *
   * <img src="./img/windowToggle.png" width="100%">
   *
   * Returns an Observable that emits windows of items it collects from the source
   * Observable. The output Observable emits windows that contain those items
   * emitted by the source Observable between the time when the `openings`
   * Observable emits an item and when the Observable returned by
   * `closingSelector` emits an item.
   *
   * @example <caption>Every other second, emit the click events from the next 500ms</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var openings = Rx.Observable.interval(1000);
   * var result = clicks.windowToggle(openings, i =>
   *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
   * ).mergeAll();
   * result.subscribe(x => console.log(x));
   *
   * @see {@link window}
   * @see {@link windowCount}
   * @see {@link windowTime}
   * @see {@link windowWhen}
   * @see {@link bufferToggle}
   *
   * @param {Observable<O>} openings An observable of notifications to start new
   * windows.
   * @param {function(value: O): Observable} closingSelector A function that takes
   * the value emitted by the `openings` observable and returns an Observable,
   * which, when it emits (either `next` or `complete`), signals that the
   * associated window should complete.
   * @return {Observable<Observable<T>>} An observable of windows, which in turn
   * are Observables.
   * @method windowToggle
   * @owner Observable
   */
  function windowToggle(openings, closingSelector) {
    return windowToggle_1.windowToggle(openings, closingSelector)(this);
  }
  exports.windowToggle = windowToggle;
  
});
System.registerDynamic('rxjs/add/operator/windowToggle.js', ['rxjs/Observable.js', 'rxjs/operator/windowToggle.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var windowToggle_1 = $__require('rxjs/operator/windowToggle.js');
  Observable_1.Observable.prototype.windowToggle = windowToggle_1.windowToggle;
  
});
System.registerDynamic("rxjs/operator/windowWhen.js", ["rxjs/operators/windowWhen.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var windowWhen_1 = $__require("rxjs/operators/windowWhen.js");
  /**
   * Branch out the source Observable values as a nested Observable using a
   * factory function of closing Observables to determine when to start a new
   * window.
   *
   * <span class="informal">It's like {@link bufferWhen}, but emits a nested
   * Observable instead of an array.</span>
   *
   * <img src="./img/windowWhen.png" width="100%">
   *
   * Returns an Observable that emits windows of items it collects from the source
   * Observable. The output Observable emits connected, non-overlapping windows.
   * It emits the current window and opens a new one whenever the Observable
   * produced by the specified `closingSelector` function emits an item. The first
   * window is opened immediately when subscribing to the output Observable.
   *
   * @example <caption>Emit only the first two clicks events in every window of [1-5] random seconds</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var result = clicks
   *   .windowWhen(() => Rx.Observable.interval(1000 + Math.random() * 4000))
   *   .map(win => win.take(2)) // each window has at most 2 emissions
   *   .mergeAll(); // flatten the Observable-of-Observables
   * result.subscribe(x => console.log(x));
   *
   * @see {@link window}
   * @see {@link windowCount}
   * @see {@link windowTime}
   * @see {@link windowToggle}
   * @see {@link bufferWhen}
   *
   * @param {function(): Observable} closingSelector A function that takes no
   * arguments and returns an Observable that signals (on either `next` or
   * `complete`) when to close the previous window and start a new one.
   * @return {Observable<Observable<T>>} An observable of windows, which in turn
   * are Observables.
   * @method windowWhen
   * @owner Observable
   */
  function windowWhen(closingSelector) {
    return windowWhen_1.windowWhen(closingSelector)(this);
  }
  exports.windowWhen = windowWhen;
  
});
System.registerDynamic('rxjs/add/operator/windowWhen.js', ['rxjs/Observable.js', 'rxjs/operator/windowWhen.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var windowWhen_1 = $__require('rxjs/operator/windowWhen.js');
  Observable_1.Observable.prototype.windowWhen = windowWhen_1.windowWhen;
  
});
System.registerDynamic("rxjs/operator/withLatestFrom.js", ["rxjs/operators/withLatestFrom.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var withLatestFrom_1 = $__require("rxjs/operators/withLatestFrom.js");
    /* tslint:enable:max-line-length */
    /**
     * Combines the source Observable with other Observables to create an Observable
     * whose values are calculated from the latest values of each, only when the
     * source emits.
     *
     * <span class="informal">Whenever the source Observable emits a value, it
     * computes a formula using that value plus the latest values from other input
     * Observables, then emits the output of that formula.</span>
     *
     * <img src="./img/withLatestFrom.png" width="100%">
     *
     * `withLatestFrom` combines each value from the source Observable (the
     * instance) with the latest values from the other input Observables only when
     * the source emits a value, optionally using a `project` function to determine
     * the value to be emitted on the output Observable. All input Observables must
     * emit at least one value before the output Observable will emit a value.
     *
     * @example <caption>On every click event, emit an array with the latest timer event plus the click event</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var timer = Rx.Observable.interval(1000);
     * var result = clicks.withLatestFrom(timer);
     * result.subscribe(x => console.log(x));
     *
     * @see {@link combineLatest}
     *
     * @param {ObservableInput} other An input Observable to combine with the source
     * Observable. More than one input Observables may be given as argument.
     * @param {Function} [project] Projection function for combining values
     * together. Receives all values in order of the Observables passed, where the
     * first parameter is a value from the source Observable. (e.g.
     * `a.withLatestFrom(b, c, (a1, b1, c1) => a1 + b1 + c1)`). If this is not
     * passed, arrays will be emitted on the output Observable.
     * @return {Observable} An Observable of projected values from the most recent
     * values from each input Observable, or an array of the most recent values from
     * each input Observable.
     * @method withLatestFrom
     * @owner Observable
     */
    function withLatestFrom() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i - 0] = arguments[_i];
        }
        return withLatestFrom_1.withLatestFrom.apply(void 0, args)(this);
    }
    exports.withLatestFrom = withLatestFrom;
    
});
System.registerDynamic('rxjs/add/operator/withLatestFrom.js', ['rxjs/Observable.js', 'rxjs/operator/withLatestFrom.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var withLatestFrom_1 = $__require('rxjs/operator/withLatestFrom.js');
  Observable_1.Observable.prototype.withLatestFrom = withLatestFrom_1.withLatestFrom;
  
});
System.registerDynamic("rxjs/operator/zip.js", ["rxjs/operators/zip.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var zip_1 = $__require("rxjs/operators/zip.js");
    /* tslint:enable:max-line-length */
    /**
     * @param observables
     * @return {Observable<R>}
     * @method zip
     * @owner Observable
     */
    function zipProto() {
        var observables = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            observables[_i - 0] = arguments[_i];
        }
        return zip_1.zip.apply(void 0, observables)(this);
    }
    exports.zipProto = zipProto;
    
});
System.registerDynamic('rxjs/add/operator/zip.js', ['rxjs/Observable.js', 'rxjs/operator/zip.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var zip_1 = $__require('rxjs/operator/zip.js');
  Observable_1.Observable.prototype.zip = zip_1.zipProto;
  
});
System.registerDynamic("rxjs/operator/zipAll.js", ["rxjs/operators/zipAll.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var zipAll_1 = $__require("rxjs/operators/zipAll.js");
  /**
   * @param project
   * @return {Observable<R>|WebSocketSubject<T>|Observable<T>}
   * @method zipAll
   * @owner Observable
   */
  function zipAll(project) {
    return zipAll_1.zipAll(project)(this);
  }
  exports.zipAll = zipAll;
  
});
System.registerDynamic('rxjs/add/operator/zipAll.js', ['rxjs/Observable.js', 'rxjs/operator/zipAll.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var zipAll_1 = $__require('rxjs/operator/zipAll.js');
  Observable_1.Observable.prototype.zipAll = zipAll_1.zipAll;
  
});
System.registerDynamic('rxjs/operator/timeInterval.js', ['rxjs/scheduler/async.js', 'rxjs/operators/timeInterval.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var async_1 = $__require('rxjs/scheduler/async.js');
  var timeInterval_1 = $__require('rxjs/operators/timeInterval.js');
  exports.TimeInterval = timeInterval_1.TimeInterval;
  /**
   * @param scheduler
   * @return {Observable<TimeInterval<any>>|WebSocketSubject<T>|Observable<T>}
   * @method timeInterval
   * @owner Observable
   */
  function timeInterval(scheduler) {
    if (scheduler === void 0) {
      scheduler = async_1.async;
    }
    return timeInterval_1.timeInterval(scheduler)(this);
  }
  exports.timeInterval = timeInterval;
  
});
System.registerDynamic('rxjs/testing/ColdObservable.js', ['rxjs/Observable.js', 'rxjs/Subscription.js', 'rxjs/testing/SubscriptionLoggable.js', 'rxjs/util/applyMixins.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Observable_1 = $__require('rxjs/Observable.js');
    var Subscription_1 = $__require('rxjs/Subscription.js');
    var SubscriptionLoggable_1 = $__require('rxjs/testing/SubscriptionLoggable.js');
    var applyMixins_1 = $__require('rxjs/util/applyMixins.js');
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var ColdObservable = function (_super) {
        __extends(ColdObservable, _super);
        function ColdObservable(messages, scheduler) {
            _super.call(this, function (subscriber) {
                var observable = this;
                var index = observable.logSubscribedFrame();
                subscriber.add(new Subscription_1.Subscription(function () {
                    observable.logUnsubscribedFrame(index);
                }));
                observable.scheduleMessages(subscriber);
                return subscriber;
            });
            this.messages = messages;
            this.subscriptions = [];
            this.scheduler = scheduler;
        }
        ColdObservable.prototype.scheduleMessages = function (subscriber) {
            var messagesLength = this.messages.length;
            for (var i = 0; i < messagesLength; i++) {
                var message = this.messages[i];
                subscriber.add(this.scheduler.schedule(function (_a) {
                    var message = _a.message,
                        subscriber = _a.subscriber;
                    message.notification.observe(subscriber);
                }, message.frame, { message: message, subscriber: subscriber }));
            }
        };
        return ColdObservable;
    }(Observable_1.Observable);
    exports.ColdObservable = ColdObservable;
    applyMixins_1.applyMixins(ColdObservable, [SubscriptionLoggable_1.SubscriptionLoggable]);
    
});
System.registerDynamic("rxjs/testing/SubscriptionLoggable.js", ["rxjs/testing/SubscriptionLog.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var SubscriptionLog_1 = $__require("rxjs/testing/SubscriptionLog.js");
    var SubscriptionLoggable = function () {
        function SubscriptionLoggable() {
            this.subscriptions = [];
        }
        SubscriptionLoggable.prototype.logSubscribedFrame = function () {
            this.subscriptions.push(new SubscriptionLog_1.SubscriptionLog(this.scheduler.now()));
            return this.subscriptions.length - 1;
        };
        SubscriptionLoggable.prototype.logUnsubscribedFrame = function (index) {
            var subscriptionLogs = this.subscriptions;
            var oldSubscriptionLog = subscriptionLogs[index];
            subscriptionLogs[index] = new SubscriptionLog_1.SubscriptionLog(oldSubscriptionLog.subscribedFrame, this.scheduler.now());
        };
        return SubscriptionLoggable;
    }();
    exports.SubscriptionLoggable = SubscriptionLoggable;
    
});
System.registerDynamic("rxjs/util/applyMixins.js", [], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    function applyMixins(derivedCtor, baseCtors) {
        for (var i = 0, len = baseCtors.length; i < len; i++) {
            var baseCtor = baseCtors[i];
            var propertyKeys = Object.getOwnPropertyNames(baseCtor.prototype);
            for (var j = 0, len2 = propertyKeys.length; j < len2; j++) {
                var name_1 = propertyKeys[j];
                derivedCtor.prototype[name_1] = baseCtor.prototype[name_1];
            }
        }
    }
    exports.applyMixins = applyMixins;
    
});
System.registerDynamic('rxjs/testing/HotObservable.js', ['rxjs/Subject.js', 'rxjs/Subscription.js', 'rxjs/testing/SubscriptionLoggable.js', 'rxjs/util/applyMixins.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subject_1 = $__require('rxjs/Subject.js');
    var Subscription_1 = $__require('rxjs/Subscription.js');
    var SubscriptionLoggable_1 = $__require('rxjs/testing/SubscriptionLoggable.js');
    var applyMixins_1 = $__require('rxjs/util/applyMixins.js');
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var HotObservable = function (_super) {
        __extends(HotObservable, _super);
        function HotObservable(messages, scheduler) {
            _super.call(this);
            this.messages = messages;
            this.subscriptions = [];
            this.scheduler = scheduler;
        }
        /** @deprecated internal use only */HotObservable.prototype._subscribe = function (subscriber) {
            var subject = this;
            var index = subject.logSubscribedFrame();
            subscriber.add(new Subscription_1.Subscription(function () {
                subject.logUnsubscribedFrame(index);
            }));
            return _super.prototype._subscribe.call(this, subscriber);
        };
        HotObservable.prototype.setup = function () {
            var subject = this;
            var messagesLength = subject.messages.length;
            /* tslint:disable:no-var-keyword */
            for (var i = 0; i < messagesLength; i++) {
                (function () {
                    var message = subject.messages[i];
                    /* tslint:enable */
                    subject.scheduler.schedule(function () {
                        message.notification.observe(subject);
                    }, message.frame);
                })();
            }
        };
        return HotObservable;
    }(Subject_1.Subject);
    exports.HotObservable = HotObservable;
    applyMixins_1.applyMixins(HotObservable, [SubscriptionLoggable_1.SubscriptionLoggable]);
    
});
System.registerDynamic("rxjs/testing/SubscriptionLog.js", [], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var SubscriptionLog = function () {
        function SubscriptionLog(subscribedFrame, unsubscribedFrame) {
            if (unsubscribedFrame === void 0) {
                unsubscribedFrame = Number.POSITIVE_INFINITY;
            }
            this.subscribedFrame = subscribedFrame;
            this.unsubscribedFrame = unsubscribedFrame;
        }
        return SubscriptionLog;
    }();
    exports.SubscriptionLog = SubscriptionLog;
    
});
System.registerDynamic('rxjs/testing/TestScheduler.js', ['rxjs/Observable.js', 'rxjs/Notification.js', 'rxjs/testing/ColdObservable.js', 'rxjs/testing/HotObservable.js', 'rxjs/testing/SubscriptionLog.js', 'rxjs/scheduler/VirtualTimeScheduler.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Observable_1 = $__require('rxjs/Observable.js');
    var Notification_1 = $__require('rxjs/Notification.js');
    var ColdObservable_1 = $__require('rxjs/testing/ColdObservable.js');
    var HotObservable_1 = $__require('rxjs/testing/HotObservable.js');
    var SubscriptionLog_1 = $__require('rxjs/testing/SubscriptionLog.js');
    var VirtualTimeScheduler_1 = $__require('rxjs/scheduler/VirtualTimeScheduler.js');
    var defaultMaxFrame = 750;
    var TestScheduler = function (_super) {
        __extends(TestScheduler, _super);
        function TestScheduler(assertDeepEqual) {
            _super.call(this, VirtualTimeScheduler_1.VirtualAction, defaultMaxFrame);
            this.assertDeepEqual = assertDeepEqual;
            this.hotObservables = [];
            this.coldObservables = [];
            this.flushTests = [];
        }
        TestScheduler.prototype.createTime = function (marbles) {
            var indexOf = marbles.indexOf('|');
            if (indexOf === -1) {
                throw new Error('marble diagram for time should have a completion marker "|"');
            }
            return indexOf * TestScheduler.frameTimeFactor;
        };
        TestScheduler.prototype.createColdObservable = function (marbles, values, error) {
            if (marbles.indexOf('^') !== -1) {
                throw new Error('cold observable cannot have subscription offset "^"');
            }
            if (marbles.indexOf('!') !== -1) {
                throw new Error('cold observable cannot have unsubscription marker "!"');
            }
            var messages = TestScheduler.parseMarbles(marbles, values, error);
            var cold = new ColdObservable_1.ColdObservable(messages, this);
            this.coldObservables.push(cold);
            return cold;
        };
        TestScheduler.prototype.createHotObservable = function (marbles, values, error) {
            if (marbles.indexOf('!') !== -1) {
                throw new Error('hot observable cannot have unsubscription marker "!"');
            }
            var messages = TestScheduler.parseMarbles(marbles, values, error);
            var subject = new HotObservable_1.HotObservable(messages, this);
            this.hotObservables.push(subject);
            return subject;
        };
        TestScheduler.prototype.materializeInnerObservable = function (observable, outerFrame) {
            var _this = this;
            var messages = [];
            observable.subscribe(function (value) {
                messages.push({ frame: _this.frame - outerFrame, notification: Notification_1.Notification.createNext(value) });
            }, function (err) {
                messages.push({ frame: _this.frame - outerFrame, notification: Notification_1.Notification.createError(err) });
            }, function () {
                messages.push({ frame: _this.frame - outerFrame, notification: Notification_1.Notification.createComplete() });
            });
            return messages;
        };
        TestScheduler.prototype.expectObservable = function (observable, unsubscriptionMarbles) {
            var _this = this;
            if (unsubscriptionMarbles === void 0) {
                unsubscriptionMarbles = null;
            }
            var actual = [];
            var flushTest = { actual: actual, ready: false };
            var unsubscriptionFrame = TestScheduler.parseMarblesAsSubscriptions(unsubscriptionMarbles).unsubscribedFrame;
            var subscription;
            this.schedule(function () {
                subscription = observable.subscribe(function (x) {
                    var value = x;
                    // Support Observable-of-Observables
                    if (x instanceof Observable_1.Observable) {
                        value = _this.materializeInnerObservable(value, _this.frame);
                    }
                    actual.push({ frame: _this.frame, notification: Notification_1.Notification.createNext(value) });
                }, function (err) {
                    actual.push({ frame: _this.frame, notification: Notification_1.Notification.createError(err) });
                }, function () {
                    actual.push({ frame: _this.frame, notification: Notification_1.Notification.createComplete() });
                });
            }, 0);
            if (unsubscriptionFrame !== Number.POSITIVE_INFINITY) {
                this.schedule(function () {
                    return subscription.unsubscribe();
                }, unsubscriptionFrame);
            }
            this.flushTests.push(flushTest);
            return {
                toBe: function (marbles, values, errorValue) {
                    flushTest.ready = true;
                    flushTest.expected = TestScheduler.parseMarbles(marbles, values, errorValue, true);
                }
            };
        };
        TestScheduler.prototype.expectSubscriptions = function (actualSubscriptionLogs) {
            var flushTest = { actual: actualSubscriptionLogs, ready: false };
            this.flushTests.push(flushTest);
            return {
                toBe: function (marbles) {
                    var marblesArray = typeof marbles === 'string' ? [marbles] : marbles;
                    flushTest.ready = true;
                    flushTest.expected = marblesArray.map(function (marbles) {
                        return TestScheduler.parseMarblesAsSubscriptions(marbles);
                    });
                }
            };
        };
        TestScheduler.prototype.flush = function () {
            var hotObservables = this.hotObservables;
            while (hotObservables.length > 0) {
                hotObservables.shift().setup();
            }
            _super.prototype.flush.call(this);
            var readyFlushTests = this.flushTests.filter(function (test) {
                return test.ready;
            });
            while (readyFlushTests.length > 0) {
                var test = readyFlushTests.shift();
                this.assertDeepEqual(test.actual, test.expected);
            }
        };
        TestScheduler.parseMarblesAsSubscriptions = function (marbles) {
            if (typeof marbles !== 'string') {
                return new SubscriptionLog_1.SubscriptionLog(Number.POSITIVE_INFINITY);
            }
            var len = marbles.length;
            var groupStart = -1;
            var subscriptionFrame = Number.POSITIVE_INFINITY;
            var unsubscriptionFrame = Number.POSITIVE_INFINITY;
            for (var i = 0; i < len; i++) {
                var frame = i * this.frameTimeFactor;
                var c = marbles[i];
                switch (c) {
                    case '-':
                    case ' ':
                        break;
                    case '(':
                        groupStart = frame;
                        break;
                    case ')':
                        groupStart = -1;
                        break;
                    case '^':
                        if (subscriptionFrame !== Number.POSITIVE_INFINITY) {
                            throw new Error('found a second subscription point \'^\' in a ' + 'subscription marble diagram. There can only be one.');
                        }
                        subscriptionFrame = groupStart > -1 ? groupStart : frame;
                        break;
                    case '!':
                        if (unsubscriptionFrame !== Number.POSITIVE_INFINITY) {
                            throw new Error('found a second subscription point \'^\' in a ' + 'subscription marble diagram. There can only be one.');
                        }
                        unsubscriptionFrame = groupStart > -1 ? groupStart : frame;
                        break;
                    default:
                        throw new Error('there can only be \'^\' and \'!\' markers in a ' + 'subscription marble diagram. Found instead \'' + c + '\'.');
                }
            }
            if (unsubscriptionFrame < 0) {
                return new SubscriptionLog_1.SubscriptionLog(subscriptionFrame);
            } else {
                return new SubscriptionLog_1.SubscriptionLog(subscriptionFrame, unsubscriptionFrame);
            }
        };
        TestScheduler.parseMarbles = function (marbles, values, errorValue, materializeInnerObservables) {
            if (materializeInnerObservables === void 0) {
                materializeInnerObservables = false;
            }
            if (marbles.indexOf('!') !== -1) {
                throw new Error('conventional marble diagrams cannot have the ' + 'unsubscription marker "!"');
            }
            var len = marbles.length;
            var testMessages = [];
            var subIndex = marbles.indexOf('^');
            var frameOffset = subIndex === -1 ? 0 : subIndex * -this.frameTimeFactor;
            var getValue = typeof values !== 'object' ? function (x) {
                return x;
            } : function (x) {
                // Support Observable-of-Observables
                if (materializeInnerObservables && values[x] instanceof ColdObservable_1.ColdObservable) {
                    return values[x].messages;
                }
                return values[x];
            };
            var groupStart = -1;
            for (var i = 0; i < len; i++) {
                var frame = i * this.frameTimeFactor + frameOffset;
                var notification = void 0;
                var c = marbles[i];
                switch (c) {
                    case '-':
                    case ' ':
                        break;
                    case '(':
                        groupStart = frame;
                        break;
                    case ')':
                        groupStart = -1;
                        break;
                    case '|':
                        notification = Notification_1.Notification.createComplete();
                        break;
                    case '^':
                        break;
                    case '#':
                        notification = Notification_1.Notification.createError(errorValue || 'error');
                        break;
                    default:
                        notification = Notification_1.Notification.createNext(getValue(c));
                        break;
                }
                if (notification) {
                    testMessages.push({ frame: groupStart > -1 ? groupStart : frame, notification: notification });
                }
            }
            return testMessages;
        };
        return TestScheduler;
    }(VirtualTimeScheduler_1.VirtualTimeScheduler);
    exports.TestScheduler = TestScheduler;
    
});
System.registerDynamic('rxjs/scheduler/VirtualTimeScheduler.js', ['rxjs/scheduler/AsyncAction.js', 'rxjs/scheduler/AsyncScheduler.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var AsyncAction_1 = $__require('rxjs/scheduler/AsyncAction.js');
    var AsyncScheduler_1 = $__require('rxjs/scheduler/AsyncScheduler.js');
    var VirtualTimeScheduler = function (_super) {
        __extends(VirtualTimeScheduler, _super);
        function VirtualTimeScheduler(SchedulerAction, maxFrames) {
            var _this = this;
            if (SchedulerAction === void 0) {
                SchedulerAction = VirtualAction;
            }
            if (maxFrames === void 0) {
                maxFrames = Number.POSITIVE_INFINITY;
            }
            _super.call(this, SchedulerAction, function () {
                return _this.frame;
            });
            this.maxFrames = maxFrames;
            this.frame = 0;
            this.index = -1;
        }
        /**
         * Prompt the Scheduler to execute all of its queued actions, therefore
         * clearing its queue.
         * @return {void}
         */
        VirtualTimeScheduler.prototype.flush = function () {
            var _a = this,
                actions = _a.actions,
                maxFrames = _a.maxFrames;
            var error, action;
            while ((action = actions.shift()) && (this.frame = action.delay) <= maxFrames) {
                if (error = action.execute(action.state, action.delay)) {
                    break;
                }
            }
            if (error) {
                while (action = actions.shift()) {
                    action.unsubscribe();
                }
                throw error;
            }
        };
        VirtualTimeScheduler.frameTimeFactor = 10;
        return VirtualTimeScheduler;
    }(AsyncScheduler_1.AsyncScheduler);
    exports.VirtualTimeScheduler = VirtualTimeScheduler;
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var VirtualAction = function (_super) {
        __extends(VirtualAction, _super);
        function VirtualAction(scheduler, work, index) {
            if (index === void 0) {
                index = scheduler.index += 1;
            }
            _super.call(this, scheduler, work);
            this.scheduler = scheduler;
            this.work = work;
            this.index = index;
            this.active = true;
            this.index = scheduler.index = index;
        }
        VirtualAction.prototype.schedule = function (state, delay) {
            if (delay === void 0) {
                delay = 0;
            }
            if (!this.id) {
                return _super.prototype.schedule.call(this, state, delay);
            }
            this.active = false;
            // If an action is rescheduled, we save allocations by mutating its state,
            // pushing it to the end of the scheduler queue, and recycling the action.
            // But since the VirtualTimeScheduler is used for testing, VirtualActions
            // must be immutable so they can be inspected later.
            var action = new VirtualAction(this.scheduler, this.work);
            this.add(action);
            return action.schedule(state, delay);
        };
        VirtualAction.prototype.requestAsyncId = function (scheduler, id, delay) {
            if (delay === void 0) {
                delay = 0;
            }
            this.delay = scheduler.frame + delay;
            var actions = scheduler.actions;
            actions.push(this);
            actions.sort(VirtualAction.sortActions);
            return true;
        };
        VirtualAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
            if (delay === void 0) {
                delay = 0;
            }
            return undefined;
        };
        VirtualAction.prototype._execute = function (state, delay) {
            if (this.active === true) {
                return _super.prototype._execute.call(this, state, delay);
            }
        };
        VirtualAction.sortActions = function (a, b) {
            if (a.delay === b.delay) {
                if (a.index === b.index) {
                    return 0;
                } else if (a.index > b.index) {
                    return 1;
                } else {
                    return -1;
                }
            } else if (a.delay > b.delay) {
                return 1;
            } else {
                return -1;
            }
        };
        return VirtualAction;
    }(AsyncAction_1.AsyncAction);
    exports.VirtualAction = VirtualAction;
    
});
System.registerDynamic('rxjs/observable/dom/AjaxObservable.js', ['rxjs/util/root.js', 'rxjs/util/tryCatch.js', 'rxjs/util/errorObject.js', 'rxjs/Observable.js', 'rxjs/Subscriber.js', 'rxjs/operators/map.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var root_1 = $__require('rxjs/util/root.js');
    var tryCatch_1 = $__require('rxjs/util/tryCatch.js');
    var errorObject_1 = $__require('rxjs/util/errorObject.js');
    var Observable_1 = $__require('rxjs/Observable.js');
    var Subscriber_1 = $__require('rxjs/Subscriber.js');
    var map_1 = $__require('rxjs/operators/map.js');
    function getCORSRequest() {
        if (root_1.root.XMLHttpRequest) {
            return new root_1.root.XMLHttpRequest();
        } else if (!!root_1.root.XDomainRequest) {
            return new root_1.root.XDomainRequest();
        } else {
            throw new Error('CORS is not supported by your browser');
        }
    }
    function getXMLHttpRequest() {
        if (root_1.root.XMLHttpRequest) {
            return new root_1.root.XMLHttpRequest();
        } else {
            var progId = void 0;
            try {
                var progIds = ['Msxml2.XMLHTTP', 'Microsoft.XMLHTTP', 'Msxml2.XMLHTTP.4.0'];
                for (var i = 0; i < 3; i++) {
                    try {
                        progId = progIds[i];
                        if (new root_1.root.ActiveXObject(progId)) {
                            break;
                        }
                    } catch (e) {}
                }
                return new root_1.root.ActiveXObject(progId);
            } catch (e) {
                throw new Error('XMLHttpRequest is not supported by your browser');
            }
        }
    }
    function ajaxGet(url, headers) {
        if (headers === void 0) {
            headers = null;
        }
        return new AjaxObservable({ method: 'GET', url: url, headers: headers });
    }
    exports.ajaxGet = ajaxGet;
    ;
    function ajaxPost(url, body, headers) {
        return new AjaxObservable({ method: 'POST', url: url, body: body, headers: headers });
    }
    exports.ajaxPost = ajaxPost;
    ;
    function ajaxDelete(url, headers) {
        return new AjaxObservable({ method: 'DELETE', url: url, headers: headers });
    }
    exports.ajaxDelete = ajaxDelete;
    ;
    function ajaxPut(url, body, headers) {
        return new AjaxObservable({ method: 'PUT', url: url, body: body, headers: headers });
    }
    exports.ajaxPut = ajaxPut;
    ;
    function ajaxPatch(url, body, headers) {
        return new AjaxObservable({ method: 'PATCH', url: url, body: body, headers: headers });
    }
    exports.ajaxPatch = ajaxPatch;
    ;
    var mapResponse = map_1.map(function (x, index) {
        return x.response;
    });
    function ajaxGetJSON(url, headers) {
        return mapResponse(new AjaxObservable({
            method: 'GET',
            url: url,
            responseType: 'json',
            headers: headers
        }));
    }
    exports.ajaxGetJSON = ajaxGetJSON;
    ;
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @extends {Ignored}
     * @hide true
     */
    var AjaxObservable = function (_super) {
        __extends(AjaxObservable, _super);
        function AjaxObservable(urlOrRequest) {
            _super.call(this);
            var request = {
                async: true,
                createXHR: function () {
                    return this.crossDomain ? getCORSRequest.call(this) : getXMLHttpRequest();
                },
                crossDomain: false,
                withCredentials: false,
                headers: {},
                method: 'GET',
                responseType: 'json',
                timeout: 0
            };
            if (typeof urlOrRequest === 'string') {
                request.url = urlOrRequest;
            } else {
                for (var prop in urlOrRequest) {
                    if (urlOrRequest.hasOwnProperty(prop)) {
                        request[prop] = urlOrRequest[prop];
                    }
                }
            }
            this.request = request;
        }
        /** @deprecated internal use only */AjaxObservable.prototype._subscribe = function (subscriber) {
            return new AjaxSubscriber(subscriber, this.request);
        };
        /**
         * Creates an observable for an Ajax request with either a request object with
         * url, headers, etc or a string for a URL.
         *
         * @example
         * source = Rx.Observable.ajax('/products');
         * source = Rx.Observable.ajax({ url: 'products', method: 'GET' });
         *
         * @param {string|Object} request Can be one of the following:
         *   A string of the URL to make the Ajax call.
         *   An object with the following properties
         *   - url: URL of the request
         *   - body: The body of the request
         *   - method: Method of the request, such as GET, POST, PUT, PATCH, DELETE
         *   - async: Whether the request is async
         *   - headers: Optional headers
         *   - crossDomain: true if a cross domain request, else false
         *   - createXHR: a function to override if you need to use an alternate
         *   XMLHttpRequest implementation.
         *   - resultSelector: a function to use to alter the output value type of
         *   the Observable. Gets {@link AjaxResponse} as an argument.
         * @return {Observable} An observable sequence containing the XMLHttpRequest.
         * @static true
         * @name ajax
         * @owner Observable
        */
        AjaxObservable.create = function () {
            var create = function (urlOrRequest) {
                return new AjaxObservable(urlOrRequest);
            };
            create.get = ajaxGet;
            create.post = ajaxPost;
            create.delete = ajaxDelete;
            create.put = ajaxPut;
            create.patch = ajaxPatch;
            create.getJSON = ajaxGetJSON;
            return create;
        }();
        return AjaxObservable;
    }(Observable_1.Observable);
    exports.AjaxObservable = AjaxObservable;
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var AjaxSubscriber = function (_super) {
        __extends(AjaxSubscriber, _super);
        function AjaxSubscriber(destination, request) {
            _super.call(this, destination);
            this.request = request;
            this.done = false;
            var headers = request.headers = request.headers || {};
            // force CORS if requested
            if (!request.crossDomain && !headers['X-Requested-With']) {
                headers['X-Requested-With'] = 'XMLHttpRequest';
            }
            // ensure content type is set
            if (!('Content-Type' in headers) && !(root_1.root.FormData && request.body instanceof root_1.root.FormData) && typeof request.body !== 'undefined') {
                headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
            }
            // properly serialize body
            request.body = this.serializeBody(request.body, request.headers['Content-Type']);
            this.send();
        }
        AjaxSubscriber.prototype.next = function (e) {
            this.done = true;
            var _a = this,
                xhr = _a.xhr,
                request = _a.request,
                destination = _a.destination;
            var response = new AjaxResponse(e, xhr, request);
            destination.next(response);
        };
        AjaxSubscriber.prototype.send = function () {
            var _a = this,
                request = _a.request,
                _b = _a.request,
                user = _b.user,
                method = _b.method,
                url = _b.url,
                async = _b.async,
                password = _b.password,
                headers = _b.headers,
                body = _b.body;
            var createXHR = request.createXHR;
            var xhr = tryCatch_1.tryCatch(createXHR).call(request);
            if (xhr === errorObject_1.errorObject) {
                this.error(errorObject_1.errorObject.e);
            } else {
                this.xhr = xhr;
                // set up the events before open XHR
                // https://developer.mozilla.org/en/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest
                // You need to add the event listeners before calling open() on the request.
                // Otherwise the progress events will not fire.
                this.setupEvents(xhr, request);
                // open XHR
                var result = void 0;
                if (user) {
                    result = tryCatch_1.tryCatch(xhr.open).call(xhr, method, url, async, user, password);
                } else {
                    result = tryCatch_1.tryCatch(xhr.open).call(xhr, method, url, async);
                }
                if (result === errorObject_1.errorObject) {
                    this.error(errorObject_1.errorObject.e);
                    return null;
                }
                // timeout, responseType and withCredentials can be set once the XHR is open
                if (async) {
                    xhr.timeout = request.timeout;
                    xhr.responseType = request.responseType;
                }
                if ('withCredentials' in xhr) {
                    xhr.withCredentials = !!request.withCredentials;
                }
                // set headers
                this.setHeaders(xhr, headers);
                // finally send the request
                result = body ? tryCatch_1.tryCatch(xhr.send).call(xhr, body) : tryCatch_1.tryCatch(xhr.send).call(xhr);
                if (result === errorObject_1.errorObject) {
                    this.error(errorObject_1.errorObject.e);
                    return null;
                }
            }
            return xhr;
        };
        AjaxSubscriber.prototype.serializeBody = function (body, contentType) {
            if (!body || typeof body === 'string') {
                return body;
            } else if (root_1.root.FormData && body instanceof root_1.root.FormData) {
                return body;
            }
            if (contentType) {
                var splitIndex = contentType.indexOf(';');
                if (splitIndex !== -1) {
                    contentType = contentType.substring(0, splitIndex);
                }
            }
            switch (contentType) {
                case 'application/x-www-form-urlencoded':
                    return Object.keys(body).map(function (key) {
                        return encodeURIComponent(key) + "=" + encodeURIComponent(body[key]);
                    }).join('&');
                case 'application/json':
                    return JSON.stringify(body);
                default:
                    return body;
            }
        };
        AjaxSubscriber.prototype.setHeaders = function (xhr, headers) {
            for (var key in headers) {
                if (headers.hasOwnProperty(key)) {
                    xhr.setRequestHeader(key, headers[key]);
                }
            }
        };
        AjaxSubscriber.prototype.setupEvents = function (xhr, request) {
            var progressSubscriber = request.progressSubscriber;
            function xhrTimeout(e) {
                var _a = xhrTimeout,
                    subscriber = _a.subscriber,
                    progressSubscriber = _a.progressSubscriber,
                    request = _a.request;
                if (progressSubscriber) {
                    progressSubscriber.error(e);
                }
                subscriber.error(new AjaxTimeoutError(this, request)); //TODO: Make betterer.
            }
            ;
            xhr.ontimeout = xhrTimeout;
            xhrTimeout.request = request;
            xhrTimeout.subscriber = this;
            xhrTimeout.progressSubscriber = progressSubscriber;
            if (xhr.upload && 'withCredentials' in xhr) {
                if (progressSubscriber) {
                    var xhrProgress_1;
                    xhrProgress_1 = function (e) {
                        var progressSubscriber = xhrProgress_1.progressSubscriber;
                        progressSubscriber.next(e);
                    };
                    if (root_1.root.XDomainRequest) {
                        xhr.onprogress = xhrProgress_1;
                    } else {
                        xhr.upload.onprogress = xhrProgress_1;
                    }
                    xhrProgress_1.progressSubscriber = progressSubscriber;
                }
                var xhrError_1;
                xhrError_1 = function (e) {
                    var _a = xhrError_1,
                        progressSubscriber = _a.progressSubscriber,
                        subscriber = _a.subscriber,
                        request = _a.request;
                    if (progressSubscriber) {
                        progressSubscriber.error(e);
                    }
                    subscriber.error(new AjaxError('ajax error', this, request));
                };
                xhr.onerror = xhrError_1;
                xhrError_1.request = request;
                xhrError_1.subscriber = this;
                xhrError_1.progressSubscriber = progressSubscriber;
            }
            function xhrReadyStateChange(e) {
                var _a = xhrReadyStateChange,
                    subscriber = _a.subscriber,
                    progressSubscriber = _a.progressSubscriber,
                    request = _a.request;
                if (this.readyState === 4) {
                    // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
                    var status_1 = this.status === 1223 ? 204 : this.status;
                    var response = this.responseType === 'text' ? this.response || this.responseText : this.response;
                    // fix status code when it is 0 (0 status is undocumented).
                    // Occurs when accessing file resources or on Android 4.1 stock browser
                    // while retrieving files from application cache.
                    if (status_1 === 0) {
                        status_1 = response ? 200 : 0;
                    }
                    if (200 <= status_1 && status_1 < 300) {
                        if (progressSubscriber) {
                            progressSubscriber.complete();
                        }
                        subscriber.next(e);
                        subscriber.complete();
                    } else {
                        if (progressSubscriber) {
                            progressSubscriber.error(e);
                        }
                        subscriber.error(new AjaxError('ajax error ' + status_1, this, request));
                    }
                }
            }
            ;
            xhr.onreadystatechange = xhrReadyStateChange;
            xhrReadyStateChange.subscriber = this;
            xhrReadyStateChange.progressSubscriber = progressSubscriber;
            xhrReadyStateChange.request = request;
        };
        AjaxSubscriber.prototype.unsubscribe = function () {
            var _a = this,
                done = _a.done,
                xhr = _a.xhr;
            if (!done && xhr && xhr.readyState !== 4 && typeof xhr.abort === 'function') {
                xhr.abort();
            }
            _super.prototype.unsubscribe.call(this);
        };
        return AjaxSubscriber;
    }(Subscriber_1.Subscriber);
    exports.AjaxSubscriber = AjaxSubscriber;
    /**
     * A normalized AJAX response.
     *
     * @see {@link ajax}
     *
     * @class AjaxResponse
     */
    var AjaxResponse = function () {
        function AjaxResponse(originalEvent, xhr, request) {
            this.originalEvent = originalEvent;
            this.xhr = xhr;
            this.request = request;
            this.status = xhr.status;
            this.responseType = xhr.responseType || request.responseType;
            this.response = parseXhrResponse(this.responseType, xhr);
        }
        return AjaxResponse;
    }();
    exports.AjaxResponse = AjaxResponse;
    /**
     * A normalized AJAX error.
     *
     * @see {@link ajax}
     *
     * @class AjaxError
     */
    var AjaxError = function (_super) {
        __extends(AjaxError, _super);
        function AjaxError(message, xhr, request) {
            _super.call(this, message);
            this.message = message;
            this.xhr = xhr;
            this.request = request;
            this.status = xhr.status;
            this.responseType = xhr.responseType || request.responseType;
            this.response = parseXhrResponse(this.responseType, xhr);
        }
        return AjaxError;
    }(Error);
    exports.AjaxError = AjaxError;
    function parseXhrResponse(responseType, xhr) {
        switch (responseType) {
            case 'json':
                if ('response' in xhr) {
                    //IE does not support json as responseType, parse it internally
                    return xhr.responseType ? xhr.response : JSON.parse(xhr.response || xhr.responseText || 'null');
                } else {
                    // HACK(benlesh): TypeScript shennanigans
                    // tslint:disable-next-line:no-any latest TS seems to think xhr is "never" here.
                    return JSON.parse(xhr.responseText || 'null');
                }
            case 'xml':
                return xhr.responseXML;
            case 'text':
            default:
                // HACK(benlesh): TypeScript shennanigans
                // tslint:disable-next-line:no-any latest TS seems to think xhr is "never" here.
                return 'response' in xhr ? xhr.response : xhr.responseText;
        }
    }
    /**
     * @see {@link ajax}
     *
     * @class AjaxTimeoutError
     */
    var AjaxTimeoutError = function (_super) {
        __extends(AjaxTimeoutError, _super);
        function AjaxTimeoutError(xhr, request) {
            _super.call(this, 'ajax timeout', xhr, request);
        }
        return AjaxTimeoutError;
    }(AjaxError);
    exports.AjaxTimeoutError = AjaxTimeoutError;
    
});
System.registerDynamic('rxjs/util/Immediate.js', ['rxjs/util/root.js'], true, function ($__require, exports, module) {
    /**
    Some credit for this helper goes to http://github.com/YuzuJS/setImmediate
    */
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var root_1 = $__require('rxjs/util/root.js');
    var ImmediateDefinition = function () {
        function ImmediateDefinition(root) {
            this.root = root;
            if (root.setImmediate && typeof root.setImmediate === 'function') {
                this.setImmediate = root.setImmediate.bind(root);
                this.clearImmediate = root.clearImmediate.bind(root);
            } else {
                this.nextHandle = 1;
                this.tasksByHandle = {};
                this.currentlyRunningATask = false;
                // Don't get fooled by e.g. browserify environments.
                if (this.canUseProcessNextTick()) {
                    // For Node.js before 0.9
                    this.setImmediate = this.createProcessNextTickSetImmediate();
                } else if (this.canUsePostMessage()) {
                    // For non-IE10 modern browsers
                    this.setImmediate = this.createPostMessageSetImmediate();
                } else if (this.canUseMessageChannel()) {
                    // For web workers, where supported
                    this.setImmediate = this.createMessageChannelSetImmediate();
                } else if (this.canUseReadyStateChange()) {
                    // For IE 6–8
                    this.setImmediate = this.createReadyStateChangeSetImmediate();
                } else {
                    // For older browsers
                    this.setImmediate = this.createSetTimeoutSetImmediate();
                }
                var ci = function clearImmediate(handle) {
                    delete clearImmediate.instance.tasksByHandle[handle];
                };
                ci.instance = this;
                this.clearImmediate = ci;
            }
        }
        ImmediateDefinition.prototype.identify = function (o) {
            return this.root.Object.prototype.toString.call(o);
        };
        ImmediateDefinition.prototype.canUseProcessNextTick = function () {
            return this.identify(this.root.process) === '[object process]';
        };
        ImmediateDefinition.prototype.canUseMessageChannel = function () {
            return Boolean(this.root.MessageChannel);
        };
        ImmediateDefinition.prototype.canUseReadyStateChange = function () {
            var document = this.root.document;
            return Boolean(document && 'onreadystatechange' in document.createElement('script'));
        };
        ImmediateDefinition.prototype.canUsePostMessage = function () {
            var root = this.root;
            // The test against `importScripts` prevents this implementation from being installed inside a web worker,
            // where `root.postMessage` means something completely different and can't be used for this purpose.
            if (root.postMessage && !root.importScripts) {
                var postMessageIsAsynchronous_1 = true;
                var oldOnMessage = root.onmessage;
                root.onmessage = function () {
                    postMessageIsAsynchronous_1 = false;
                };
                root.postMessage('', '*');
                root.onmessage = oldOnMessage;
                return postMessageIsAsynchronous_1;
            }
            return false;
        };
        // This function accepts the same arguments as setImmediate, but
        // returns a function that requires no arguments.
        ImmediateDefinition.prototype.partiallyApplied = function (handler) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            var fn = function result() {
                var _a = result,
                    handler = _a.handler,
                    args = _a.args;
                if (typeof handler === 'function') {
                    handler.apply(undefined, args);
                } else {
                    new Function('' + handler)();
                }
            };
            fn.handler = handler;
            fn.args = args;
            return fn;
        };
        ImmediateDefinition.prototype.addFromSetImmediateArguments = function (args) {
            this.tasksByHandle[this.nextHandle] = this.partiallyApplied.apply(undefined, args);
            return this.nextHandle++;
        };
        ImmediateDefinition.prototype.createProcessNextTickSetImmediate = function () {
            var fn = function setImmediate() {
                var instance = setImmediate.instance;
                var handle = instance.addFromSetImmediateArguments(arguments);
                instance.root.process.nextTick(instance.partiallyApplied(instance.runIfPresent, handle));
                return handle;
            };
            fn.instance = this;
            return fn;
        };
        ImmediateDefinition.prototype.createPostMessageSetImmediate = function () {
            // Installs an event handler on `global` for the `message` event: see
            // * https://developer.mozilla.org/en/DOM/window.postMessage
            // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
            var root = this.root;
            var messagePrefix = 'setImmediate$' + root.Math.random() + '$';
            var onGlobalMessage = function globalMessageHandler(event) {
                var instance = globalMessageHandler.instance;
                if (event.source === root && typeof event.data === 'string' && event.data.indexOf(messagePrefix) === 0) {
                    instance.runIfPresent(+event.data.slice(messagePrefix.length));
                }
            };
            onGlobalMessage.instance = this;
            root.addEventListener('message', onGlobalMessage, false);
            var fn = function setImmediate() {
                var _a = setImmediate,
                    messagePrefix = _a.messagePrefix,
                    instance = _a.instance;
                var handle = instance.addFromSetImmediateArguments(arguments);
                instance.root.postMessage(messagePrefix + handle, '*');
                return handle;
            };
            fn.instance = this;
            fn.messagePrefix = messagePrefix;
            return fn;
        };
        ImmediateDefinition.prototype.runIfPresent = function (handle) {
            // From the spec: 'Wait until any invocations of this algorithm started before this one have completed.'
            // So if we're currently running a task, we'll need to delay this invocation.
            if (this.currentlyRunningATask) {
                // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
                // 'too much recursion' error.
                this.root.setTimeout(this.partiallyApplied(this.runIfPresent, handle), 0);
            } else {
                var task = this.tasksByHandle[handle];
                if (task) {
                    this.currentlyRunningATask = true;
                    try {
                        task();
                    } finally {
                        this.clearImmediate(handle);
                        this.currentlyRunningATask = false;
                    }
                }
            }
        };
        ImmediateDefinition.prototype.createMessageChannelSetImmediate = function () {
            var _this = this;
            var channel = new this.root.MessageChannel();
            channel.port1.onmessage = function (event) {
                var handle = event.data;
                _this.runIfPresent(handle);
            };
            var fn = function setImmediate() {
                var _a = setImmediate,
                    channel = _a.channel,
                    instance = _a.instance;
                var handle = instance.addFromSetImmediateArguments(arguments);
                channel.port2.postMessage(handle);
                return handle;
            };
            fn.channel = channel;
            fn.instance = this;
            return fn;
        };
        ImmediateDefinition.prototype.createReadyStateChangeSetImmediate = function () {
            var fn = function setImmediate() {
                var instance = setImmediate.instance;
                var root = instance.root;
                var doc = root.document;
                var html = doc.documentElement;
                var handle = instance.addFromSetImmediateArguments(arguments);
                // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
                // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
                var script = doc.createElement('script');
                script.onreadystatechange = function () {
                    instance.runIfPresent(handle);
                    script.onreadystatechange = null;
                    html.removeChild(script);
                    script = null;
                };
                html.appendChild(script);
                return handle;
            };
            fn.instance = this;
            return fn;
        };
        ImmediateDefinition.prototype.createSetTimeoutSetImmediate = function () {
            var fn = function setImmediate() {
                var instance = setImmediate.instance;
                var handle = instance.addFromSetImmediateArguments(arguments);
                instance.root.setTimeout(instance.partiallyApplied(instance.runIfPresent, handle), 0);
                return handle;
            };
            fn.instance = this;
            return fn;
        };
        return ImmediateDefinition;
    }();
    exports.ImmediateDefinition = ImmediateDefinition;
    exports.Immediate = new ImmediateDefinition(root_1.root);
    
});
System.registerDynamic('rxjs/scheduler/AsapAction.js', ['rxjs/util/Immediate.js', 'rxjs/scheduler/AsyncAction.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Immediate_1 = $__require('rxjs/util/Immediate.js');
    var AsyncAction_1 = $__require('rxjs/scheduler/AsyncAction.js');
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var AsapAction = function (_super) {
        __extends(AsapAction, _super);
        function AsapAction(scheduler, work) {
            _super.call(this, scheduler, work);
            this.scheduler = scheduler;
            this.work = work;
        }
        AsapAction.prototype.requestAsyncId = function (scheduler, id, delay) {
            if (delay === void 0) {
                delay = 0;
            }
            // If delay is greater than 0, request as an async action.
            if (delay !== null && delay > 0) {
                return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
            }
            // Push the action to the end of the scheduler queue.
            scheduler.actions.push(this);
            // If a microtask has already been scheduled, don't schedule another
            // one. If a microtask hasn't been scheduled yet, schedule one now. Return
            // the current scheduled microtask id.
            return scheduler.scheduled || (scheduler.scheduled = Immediate_1.Immediate.setImmediate(scheduler.flush.bind(scheduler, null)));
        };
        AsapAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
            if (delay === void 0) {
                delay = 0;
            }
            // If delay exists and is greater than 0, or if the delay is null (the
            // action wasn't rescheduled) but was originally scheduled as an async
            // action, then recycle as an async action.
            if (delay !== null && delay > 0 || delay === null && this.delay > 0) {
                return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
            }
            // If the scheduler queue is empty, cancel the requested microtask and
            // set the scheduled flag to undefined so the next AsapAction will schedule
            // its own.
            if (scheduler.actions.length === 0) {
                Immediate_1.Immediate.clearImmediate(id);
                scheduler.scheduled = undefined;
            }
            // Return undefined so the action knows to request a new async id if it's rescheduled.
            return undefined;
        };
        return AsapAction;
    }(AsyncAction_1.AsyncAction);
    exports.AsapAction = AsapAction;
    
});
System.registerDynamic("rxjs/scheduler/AsapScheduler.js", ["rxjs/scheduler/AsyncScheduler.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var AsyncScheduler_1 = $__require("rxjs/scheduler/AsyncScheduler.js");
    var AsapScheduler = function (_super) {
        __extends(AsapScheduler, _super);
        function AsapScheduler() {
            _super.apply(this, arguments);
        }
        AsapScheduler.prototype.flush = function (action) {
            this.active = true;
            this.scheduled = undefined;
            var actions = this.actions;
            var error;
            var index = -1;
            var count = actions.length;
            action = action || actions.shift();
            do {
                if (error = action.execute(action.state, action.delay)) {
                    break;
                }
            } while (++index < count && (action = actions.shift()));
            this.active = false;
            if (error) {
                while (++index < count && (action = actions.shift())) {
                    action.unsubscribe();
                }
                throw error;
            }
        };
        return AsapScheduler;
    }(AsyncScheduler_1.AsyncScheduler);
    exports.AsapScheduler = AsapScheduler;
    
});
System.registerDynamic('rxjs/scheduler/asap.js', ['rxjs/scheduler/AsapAction.js', 'rxjs/scheduler/AsapScheduler.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var AsapAction_1 = $__require('rxjs/scheduler/AsapAction.js');
  var AsapScheduler_1 = $__require('rxjs/scheduler/AsapScheduler.js');
  /**
   *
   * Asap Scheduler
   *
   * <span class="informal">Perform task as fast as it can be performed asynchronously</span>
   *
   * `asap` scheduler behaves the same as {@link async} scheduler when you use it to delay task
   * in time. If however you set delay to `0`, `asap` will wait for current synchronously executing
   * code to end and then it will try to execute given task as fast as possible.
   *
   * `asap` scheduler will do its best to minimize time between end of currently executing code
   * and start of scheduled task. This makes it best candidate for performing so called "deferring".
   * Traditionally this was achieved by calling `setTimeout(deferredTask, 0)`, but that technique involves
   * some (although minimal) unwanted delay.
   *
   * Note that using `asap` scheduler does not necessarily mean that your task will be first to process
   * after currently executing code. In particular, if some task was also scheduled with `asap` before,
   * that task will execute first. That being said, if you need to schedule task asynchronously, but
   * as soon as possible, `asap` scheduler is your best bet.
   *
   * @example <caption>Compare async and asap scheduler</caption>
   *
   * Rx.Scheduler.async.schedule(() => console.log('async')); // scheduling 'async' first...
   * Rx.Scheduler.asap.schedule(() => console.log('asap'));
   *
   * // Logs:
   * // "asap"
   * // "async"
   * // ... but 'asap' goes first!
   *
   * @static true
   * @name asap
   * @owner Scheduler
   */
  exports.asap = new AsapScheduler_1.AsapScheduler(AsapAction_1.AsapAction);
  
});
System.registerDynamic("rxjs/util/AnimationFrame.js", ["rxjs/util/root.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var root_1 = $__require("rxjs/util/root.js");
    var RequestAnimationFrameDefinition = function () {
        function RequestAnimationFrameDefinition(root) {
            if (root.requestAnimationFrame) {
                this.cancelAnimationFrame = root.cancelAnimationFrame.bind(root);
                this.requestAnimationFrame = root.requestAnimationFrame.bind(root);
            } else if (root.mozRequestAnimationFrame) {
                this.cancelAnimationFrame = root.mozCancelAnimationFrame.bind(root);
                this.requestAnimationFrame = root.mozRequestAnimationFrame.bind(root);
            } else if (root.webkitRequestAnimationFrame) {
                this.cancelAnimationFrame = root.webkitCancelAnimationFrame.bind(root);
                this.requestAnimationFrame = root.webkitRequestAnimationFrame.bind(root);
            } else if (root.msRequestAnimationFrame) {
                this.cancelAnimationFrame = root.msCancelAnimationFrame.bind(root);
                this.requestAnimationFrame = root.msRequestAnimationFrame.bind(root);
            } else if (root.oRequestAnimationFrame) {
                this.cancelAnimationFrame = root.oCancelAnimationFrame.bind(root);
                this.requestAnimationFrame = root.oRequestAnimationFrame.bind(root);
            } else {
                this.cancelAnimationFrame = root.clearTimeout.bind(root);
                this.requestAnimationFrame = function (cb) {
                    return root.setTimeout(cb, 1000 / 60);
                };
            }
        }
        return RequestAnimationFrameDefinition;
    }();
    exports.RequestAnimationFrameDefinition = RequestAnimationFrameDefinition;
    exports.AnimationFrame = new RequestAnimationFrameDefinition(root_1.root);
    
});
System.registerDynamic('rxjs/scheduler/AnimationFrameAction.js', ['rxjs/scheduler/AsyncAction.js', 'rxjs/util/AnimationFrame.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var AsyncAction_1 = $__require('rxjs/scheduler/AsyncAction.js');
    var AnimationFrame_1 = $__require('rxjs/util/AnimationFrame.js');
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var AnimationFrameAction = function (_super) {
        __extends(AnimationFrameAction, _super);
        function AnimationFrameAction(scheduler, work) {
            _super.call(this, scheduler, work);
            this.scheduler = scheduler;
            this.work = work;
        }
        AnimationFrameAction.prototype.requestAsyncId = function (scheduler, id, delay) {
            if (delay === void 0) {
                delay = 0;
            }
            // If delay is greater than 0, request as an async action.
            if (delay !== null && delay > 0) {
                return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
            }
            // Push the action to the end of the scheduler queue.
            scheduler.actions.push(this);
            // If an animation frame has already been requested, don't request another
            // one. If an animation frame hasn't been requested yet, request one. Return
            // the current animation frame request id.
            return scheduler.scheduled || (scheduler.scheduled = AnimationFrame_1.AnimationFrame.requestAnimationFrame(scheduler.flush.bind(scheduler, null)));
        };
        AnimationFrameAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
            if (delay === void 0) {
                delay = 0;
            }
            // If delay exists and is greater than 0, or if the delay is null (the
            // action wasn't rescheduled) but was originally scheduled as an async
            // action, then recycle as an async action.
            if (delay !== null && delay > 0 || delay === null && this.delay > 0) {
                return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
            }
            // If the scheduler queue is empty, cancel the requested animation frame and
            // set the scheduled flag to undefined so the next AnimationFrameAction will
            // request its own.
            if (scheduler.actions.length === 0) {
                AnimationFrame_1.AnimationFrame.cancelAnimationFrame(id);
                scheduler.scheduled = undefined;
            }
            // Return undefined so the action knows to request a new async id if it's rescheduled.
            return undefined;
        };
        return AnimationFrameAction;
    }(AsyncAction_1.AsyncAction);
    exports.AnimationFrameAction = AnimationFrameAction;
    
});
System.registerDynamic("rxjs/scheduler/AnimationFrameScheduler.js", ["rxjs/scheduler/AsyncScheduler.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var AsyncScheduler_1 = $__require("rxjs/scheduler/AsyncScheduler.js");
    var AnimationFrameScheduler = function (_super) {
        __extends(AnimationFrameScheduler, _super);
        function AnimationFrameScheduler() {
            _super.apply(this, arguments);
        }
        AnimationFrameScheduler.prototype.flush = function (action) {
            this.active = true;
            this.scheduled = undefined;
            var actions = this.actions;
            var error;
            var index = -1;
            var count = actions.length;
            action = action || actions.shift();
            do {
                if (error = action.execute(action.state, action.delay)) {
                    break;
                }
            } while (++index < count && (action = actions.shift()));
            this.active = false;
            if (error) {
                while (++index < count && (action = actions.shift())) {
                    action.unsubscribe();
                }
                throw error;
            }
        };
        return AnimationFrameScheduler;
    }(AsyncScheduler_1.AsyncScheduler);
    exports.AnimationFrameScheduler = AnimationFrameScheduler;
    
});
System.registerDynamic('rxjs/scheduler/animationFrame.js', ['rxjs/scheduler/AnimationFrameAction.js', 'rxjs/scheduler/AnimationFrameScheduler.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var AnimationFrameAction_1 = $__require('rxjs/scheduler/AnimationFrameAction.js');
  var AnimationFrameScheduler_1 = $__require('rxjs/scheduler/AnimationFrameScheduler.js');
  /**
   *
   * Animation Frame Scheduler
   *
   * <span class="informal">Perform task when `window.requestAnimationFrame` would fire</span>
   *
   * When `animationFrame` scheduler is used with delay, it will fall back to {@link async} scheduler
   * behaviour.
   *
   * Without delay, `animationFrame` scheduler can be used to create smooth browser animations.
   * It makes sure scheduled task will happen just before next browser content repaint,
   * thus performing animations as efficiently as possible.
   *
   * @example <caption>Schedule div height animation</caption>
   * const div = document.querySelector('.some-div');
   *
   * Rx.Scheduler.schedule(function(height) {
   *   div.style.height = height + "px";
   *
   *   this.schedule(height + 1);  // `this` references currently executing Action,
   *                               // which we reschedule with new state
   * }, 0, 0);
   *
   * // You will see .some-div element growing in height
   *
   *
   * @static true
   * @name animationFrame
   * @owner Scheduler
   */
  exports.animationFrame = new AnimationFrameScheduler_1.AnimationFrameScheduler(AnimationFrameAction_1.AnimationFrameAction);
  
});
System.registerDynamic('rxjs/operators/audit.js', ['rxjs/util/tryCatch.js', 'rxjs/util/errorObject.js', 'rxjs/OuterSubscriber.js', 'rxjs/util/subscribeToResult.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var tryCatch_1 = $__require('rxjs/util/tryCatch.js');
    var errorObject_1 = $__require('rxjs/util/errorObject.js');
    var OuterSubscriber_1 = $__require('rxjs/OuterSubscriber.js');
    var subscribeToResult_1 = $__require('rxjs/util/subscribeToResult.js');
    /**
     * Ignores source values for a duration determined by another Observable, then
     * emits the most recent value from the source Observable, then repeats this
     * process.
     *
     * <span class="informal">It's like {@link auditTime}, but the silencing
     * duration is determined by a second Observable.</span>
     *
     * <img src="./img/audit.png" width="100%">
     *
     * `audit` is similar to `throttle`, but emits the last value from the silenced
     * time window, instead of the first value. `audit` emits the most recent value
     * from the source Observable on the output Observable as soon as its internal
     * timer becomes disabled, and ignores source values while the timer is enabled.
     * Initially, the timer is disabled. As soon as the first source value arrives,
     * the timer is enabled by calling the `durationSelector` function with the
     * source value, which returns the "duration" Observable. When the duration
     * Observable emits a value or completes, the timer is disabled, then the most
     * recent source value is emitted on the output Observable, and this process
     * repeats for the next source value.
     *
     * @example <caption>Emit clicks at a rate of at most one click per second</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var result = clicks.audit(ev => Rx.Observable.interval(1000));
     * result.subscribe(x => console.log(x));
     *
     * @see {@link auditTime}
     * @see {@link debounce}
     * @see {@link delayWhen}
     * @see {@link sample}
     * @see {@link throttle}
     *
     * @param {function(value: T): SubscribableOrPromise} durationSelector A function
     * that receives a value from the source Observable, for computing the silencing
     * duration, returned as an Observable or a Promise.
     * @return {Observable<T>} An Observable that performs rate-limiting of
     * emissions from the source Observable.
     * @method audit
     * @owner Observable
     */
    function audit(durationSelector) {
        return function auditOperatorFunction(source) {
            return source.lift(new AuditOperator(durationSelector));
        };
    }
    exports.audit = audit;
    var AuditOperator = function () {
        function AuditOperator(durationSelector) {
            this.durationSelector = durationSelector;
        }
        AuditOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new AuditSubscriber(subscriber, this.durationSelector));
        };
        return AuditOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var AuditSubscriber = function (_super) {
        __extends(AuditSubscriber, _super);
        function AuditSubscriber(destination, durationSelector) {
            _super.call(this, destination);
            this.durationSelector = durationSelector;
            this.hasValue = false;
        }
        AuditSubscriber.prototype._next = function (value) {
            this.value = value;
            this.hasValue = true;
            if (!this.throttled) {
                var duration = tryCatch_1.tryCatch(this.durationSelector)(value);
                if (duration === errorObject_1.errorObject) {
                    this.destination.error(errorObject_1.errorObject.e);
                } else {
                    var innerSubscription = subscribeToResult_1.subscribeToResult(this, duration);
                    if (innerSubscription.closed) {
                        this.clearThrottle();
                    } else {
                        this.add(this.throttled = innerSubscription);
                    }
                }
            }
        };
        AuditSubscriber.prototype.clearThrottle = function () {
            var _a = this,
                value = _a.value,
                hasValue = _a.hasValue,
                throttled = _a.throttled;
            if (throttled) {
                this.remove(throttled);
                this.throttled = null;
                throttled.unsubscribe();
            }
            if (hasValue) {
                this.value = null;
                this.hasValue = false;
                this.destination.next(value);
            }
        };
        AuditSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex) {
            this.clearThrottle();
        };
        AuditSubscriber.prototype.notifyComplete = function () {
            this.clearThrottle();
        };
        return AuditSubscriber;
    }(OuterSubscriber_1.OuterSubscriber);
    
});
System.registerDynamic('rxjs/observable/TimerObservable.js', ['rxjs/util/isNumeric.js', 'rxjs/Observable.js', 'rxjs/scheduler/async.js', 'rxjs/util/isScheduler.js', 'rxjs/util/isDate.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var isNumeric_1 = $__require('rxjs/util/isNumeric.js');
    var Observable_1 = $__require('rxjs/Observable.js');
    var async_1 = $__require('rxjs/scheduler/async.js');
    var isScheduler_1 = $__require('rxjs/util/isScheduler.js');
    var isDate_1 = $__require('rxjs/util/isDate.js');
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @extends {Ignored}
     * @hide true
     */
    var TimerObservable = function (_super) {
        __extends(TimerObservable, _super);
        function TimerObservable(dueTime, period, scheduler) {
            if (dueTime === void 0) {
                dueTime = 0;
            }
            _super.call(this);
            this.period = -1;
            this.dueTime = 0;
            if (isNumeric_1.isNumeric(period)) {
                this.period = Number(period) < 1 && 1 || Number(period);
            } else if (isScheduler_1.isScheduler(period)) {
                scheduler = period;
            }
            if (!isScheduler_1.isScheduler(scheduler)) {
                scheduler = async_1.async;
            }
            this.scheduler = scheduler;
            this.dueTime = isDate_1.isDate(dueTime) ? +dueTime - this.scheduler.now() : dueTime;
        }
        /**
         * Creates an Observable that starts emitting after an `initialDelay` and
         * emits ever increasing numbers after each `period` of time thereafter.
         *
         * <span class="informal">Its like {@link interval}, but you can specify when
         * should the emissions start.</span>
         *
         * <img src="./img/timer.png" width="100%">
         *
         * `timer` returns an Observable that emits an infinite sequence of ascending
         * integers, with a constant interval of time, `period` of your choosing
         * between those emissions. The first emission happens after the specified
         * `initialDelay`. The initial delay may be a {@link Date}. By default, this
         * operator uses the `async` IScheduler to provide a notion of time, but you
         * may pass any IScheduler to it. If `period` is not specified, the output
         * Observable emits only one value, `0`. Otherwise, it emits an infinite
         * sequence.
         *
         * @example <caption>Emits ascending numbers, one every second (1000ms), starting after 3 seconds</caption>
         * var numbers = Rx.Observable.timer(3000, 1000);
         * numbers.subscribe(x => console.log(x));
         *
         * @example <caption>Emits one number after five seconds</caption>
         * var numbers = Rx.Observable.timer(5000);
         * numbers.subscribe(x => console.log(x));
         *
         * @see {@link interval}
         * @see {@link delay}
         *
         * @param {number|Date} initialDelay The initial delay time to wait before
         * emitting the first value of `0`.
         * @param {number} [period] The period of time between emissions of the
         * subsequent numbers.
         * @param {Scheduler} [scheduler=async] The IScheduler to use for scheduling
         * the emission of values, and providing a notion of "time".
         * @return {Observable} An Observable that emits a `0` after the
         * `initialDelay` and ever increasing numbers after each `period` of time
         * thereafter.
         * @static true
         * @name timer
         * @owner Observable
         */
        TimerObservable.create = function (initialDelay, period, scheduler) {
            if (initialDelay === void 0) {
                initialDelay = 0;
            }
            return new TimerObservable(initialDelay, period, scheduler);
        };
        TimerObservable.dispatch = function (state) {
            var index = state.index,
                period = state.period,
                subscriber = state.subscriber;
            var action = this;
            subscriber.next(index);
            if (subscriber.closed) {
                return;
            } else if (period === -1) {
                return subscriber.complete();
            }
            state.index = index + 1;
            action.schedule(state, period);
        };
        /** @deprecated internal use only */TimerObservable.prototype._subscribe = function (subscriber) {
            var index = 0;
            var _a = this,
                period = _a.period,
                dueTime = _a.dueTime,
                scheduler = _a.scheduler;
            return scheduler.schedule(TimerObservable.dispatch, dueTime, {
                index: index, period: period, subscriber: subscriber
            });
        };
        return TimerObservable;
    }(Observable_1.Observable);
    exports.TimerObservable = TimerObservable;
    
});
System.registerDynamic("rxjs/observable/timer.js", ["rxjs/observable/TimerObservable.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var TimerObservable_1 = $__require("rxjs/observable/TimerObservable.js");
  exports.timer = TimerObservable_1.TimerObservable.create;
  
});
System.registerDynamic('rxjs/operators/auditTime.js', ['rxjs/scheduler/async.js', 'rxjs/operators/audit.js', 'rxjs/observable/timer.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var async_1 = $__require('rxjs/scheduler/async.js');
  var audit_1 = $__require('rxjs/operators/audit.js');
  var timer_1 = $__require('rxjs/observable/timer.js');
  /**
   * Ignores source values for `duration` milliseconds, then emits the most recent
   * value from the source Observable, then repeats this process.
   *
   * <span class="informal">When it sees a source values, it ignores that plus
   * the next ones for `duration` milliseconds, and then it emits the most recent
   * value from the source.</span>
   *
   * <img src="./img/auditTime.png" width="100%">
   *
   * `auditTime` is similar to `throttleTime`, but emits the last value from the
   * silenced time window, instead of the first value. `auditTime` emits the most
   * recent value from the source Observable on the output Observable as soon as
   * its internal timer becomes disabled, and ignores source values while the
   * timer is enabled. Initially, the timer is disabled. As soon as the first
   * source value arrives, the timer is enabled. After `duration` milliseconds (or
   * the time unit determined internally by the optional `scheduler`) has passed,
   * the timer is disabled, then the most recent source value is emitted on the
   * output Observable, and this process repeats for the next source value.
   * Optionally takes a {@link IScheduler} for managing timers.
   *
   * @example <caption>Emit clicks at a rate of at most one click per second</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var result = clicks.auditTime(1000);
   * result.subscribe(x => console.log(x));
   *
   * @see {@link audit}
   * @see {@link debounceTime}
   * @see {@link delay}
   * @see {@link sampleTime}
   * @see {@link throttleTime}
   *
   * @param {number} duration Time to wait before emitting the most recent source
   * value, measured in milliseconds or the time unit determined internally
   * by the optional `scheduler`.
   * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
   * managing the timers that handle the rate-limiting behavior.
   * @return {Observable<T>} An Observable that performs rate-limiting of
   * emissions from the source Observable.
   * @method auditTime
   * @owner Observable
   */
  function auditTime(duration, scheduler) {
    if (scheduler === void 0) {
      scheduler = async_1.async;
    }
    return audit_1.audit(function () {
      return timer_1.timer(duration, scheduler);
    });
  }
  exports.auditTime = auditTime;
  
});
System.registerDynamic('rxjs/operators/buffer.js', ['rxjs/OuterSubscriber.js', 'rxjs/util/subscribeToResult.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var OuterSubscriber_1 = $__require('rxjs/OuterSubscriber.js');
    var subscribeToResult_1 = $__require('rxjs/util/subscribeToResult.js');
    /**
     * Buffers the source Observable values until `closingNotifier` emits.
     *
     * <span class="informal">Collects values from the past as an array, and emits
     * that array only when another Observable emits.</span>
     *
     * <img src="./img/buffer.png" width="100%">
     *
     * Buffers the incoming Observable values until the given `closingNotifier`
     * Observable emits a value, at which point it emits the buffer on the output
     * Observable and starts a new buffer internally, awaiting the next time
     * `closingNotifier` emits.
     *
     * @example <caption>On every click, emit array of most recent interval events</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var interval = Rx.Observable.interval(1000);
     * var buffered = interval.buffer(clicks);
     * buffered.subscribe(x => console.log(x));
     *
     * @see {@link bufferCount}
     * @see {@link bufferTime}
     * @see {@link bufferToggle}
     * @see {@link bufferWhen}
     * @see {@link window}
     *
     * @param {Observable<any>} closingNotifier An Observable that signals the
     * buffer to be emitted on the output Observable.
     * @return {Observable<T[]>} An Observable of buffers, which are arrays of
     * values.
     * @method buffer
     * @owner Observable
     */
    function buffer(closingNotifier) {
        return function bufferOperatorFunction(source) {
            return source.lift(new BufferOperator(closingNotifier));
        };
    }
    exports.buffer = buffer;
    var BufferOperator = function () {
        function BufferOperator(closingNotifier) {
            this.closingNotifier = closingNotifier;
        }
        BufferOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new BufferSubscriber(subscriber, this.closingNotifier));
        };
        return BufferOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var BufferSubscriber = function (_super) {
        __extends(BufferSubscriber, _super);
        function BufferSubscriber(destination, closingNotifier) {
            _super.call(this, destination);
            this.buffer = [];
            this.add(subscribeToResult_1.subscribeToResult(this, closingNotifier));
        }
        BufferSubscriber.prototype._next = function (value) {
            this.buffer.push(value);
        };
        BufferSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            var buffer = this.buffer;
            this.buffer = [];
            this.destination.next(buffer);
        };
        return BufferSubscriber;
    }(OuterSubscriber_1.OuterSubscriber);
    
});
System.registerDynamic("rxjs/operators/bufferCount.js", ["rxjs/Subscriber.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require("rxjs/Subscriber.js");
    /**
     * Buffers the source Observable values until the size hits the maximum
     * `bufferSize` given.
     *
     * <span class="informal">Collects values from the past as an array, and emits
     * that array only when its size reaches `bufferSize`.</span>
     *
     * <img src="./img/bufferCount.png" width="100%">
     *
     * Buffers a number of values from the source Observable by `bufferSize` then
     * emits the buffer and clears it, and starts a new buffer each
     * `startBufferEvery` values. If `startBufferEvery` is not provided or is
     * `null`, then new buffers are started immediately at the start of the source
     * and when each buffer closes and is emitted.
     *
     * @example <caption>Emit the last two click events as an array</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var buffered = clicks.bufferCount(2);
     * buffered.subscribe(x => console.log(x));
     *
     * @example <caption>On every click, emit the last two click events as an array</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var buffered = clicks.bufferCount(2, 1);
     * buffered.subscribe(x => console.log(x));
     *
     * @see {@link buffer}
     * @see {@link bufferTime}
     * @see {@link bufferToggle}
     * @see {@link bufferWhen}
     * @see {@link pairwise}
     * @see {@link windowCount}
     *
     * @param {number} bufferSize The maximum size of the buffer emitted.
     * @param {number} [startBufferEvery] Interval at which to start a new buffer.
     * For example if `startBufferEvery` is `2`, then a new buffer will be started
     * on every other value from the source. A new buffer is started at the
     * beginning of the source by default.
     * @return {Observable<T[]>} An Observable of arrays of buffered values.
     * @method bufferCount
     * @owner Observable
     */
    function bufferCount(bufferSize, startBufferEvery) {
        if (startBufferEvery === void 0) {
            startBufferEvery = null;
        }
        return function bufferCountOperatorFunction(source) {
            return source.lift(new BufferCountOperator(bufferSize, startBufferEvery));
        };
    }
    exports.bufferCount = bufferCount;
    var BufferCountOperator = function () {
        function BufferCountOperator(bufferSize, startBufferEvery) {
            this.bufferSize = bufferSize;
            this.startBufferEvery = startBufferEvery;
            if (!startBufferEvery || bufferSize === startBufferEvery) {
                this.subscriberClass = BufferCountSubscriber;
            } else {
                this.subscriberClass = BufferSkipCountSubscriber;
            }
        }
        BufferCountOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new this.subscriberClass(subscriber, this.bufferSize, this.startBufferEvery));
        };
        return BufferCountOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var BufferCountSubscriber = function (_super) {
        __extends(BufferCountSubscriber, _super);
        function BufferCountSubscriber(destination, bufferSize) {
            _super.call(this, destination);
            this.bufferSize = bufferSize;
            this.buffer = [];
        }
        BufferCountSubscriber.prototype._next = function (value) {
            var buffer = this.buffer;
            buffer.push(value);
            if (buffer.length == this.bufferSize) {
                this.destination.next(buffer);
                this.buffer = [];
            }
        };
        BufferCountSubscriber.prototype._complete = function () {
            var buffer = this.buffer;
            if (buffer.length > 0) {
                this.destination.next(buffer);
            }
            _super.prototype._complete.call(this);
        };
        return BufferCountSubscriber;
    }(Subscriber_1.Subscriber);
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var BufferSkipCountSubscriber = function (_super) {
        __extends(BufferSkipCountSubscriber, _super);
        function BufferSkipCountSubscriber(destination, bufferSize, startBufferEvery) {
            _super.call(this, destination);
            this.bufferSize = bufferSize;
            this.startBufferEvery = startBufferEvery;
            this.buffers = [];
            this.count = 0;
        }
        BufferSkipCountSubscriber.prototype._next = function (value) {
            var _a = this,
                bufferSize = _a.bufferSize,
                startBufferEvery = _a.startBufferEvery,
                buffers = _a.buffers,
                count = _a.count;
            this.count++;
            if (count % startBufferEvery === 0) {
                buffers.push([]);
            }
            for (var i = buffers.length; i--;) {
                var buffer = buffers[i];
                buffer.push(value);
                if (buffer.length === bufferSize) {
                    buffers.splice(i, 1);
                    this.destination.next(buffer);
                }
            }
        };
        BufferSkipCountSubscriber.prototype._complete = function () {
            var _a = this,
                buffers = _a.buffers,
                destination = _a.destination;
            while (buffers.length > 0) {
                var buffer = buffers.shift();
                if (buffer.length > 0) {
                    destination.next(buffer);
                }
            }
            _super.prototype._complete.call(this);
        };
        return BufferSkipCountSubscriber;
    }(Subscriber_1.Subscriber);
    
});
System.registerDynamic('rxjs/operators/bufferTime.js', ['rxjs/scheduler/async.js', 'rxjs/Subscriber.js', 'rxjs/util/isScheduler.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var async_1 = $__require('rxjs/scheduler/async.js');
    var Subscriber_1 = $__require('rxjs/Subscriber.js');
    var isScheduler_1 = $__require('rxjs/util/isScheduler.js');
    /* tslint:enable:max-line-length */
    /**
     * Buffers the source Observable values for a specific time period.
     *
     * <span class="informal">Collects values from the past as an array, and emits
     * those arrays periodically in time.</span>
     *
     * <img src="./img/bufferTime.png" width="100%">
     *
     * Buffers values from the source for a specific time duration `bufferTimeSpan`.
     * Unless the optional argument `bufferCreationInterval` is given, it emits and
     * resets the buffer every `bufferTimeSpan` milliseconds. If
     * `bufferCreationInterval` is given, this operator opens the buffer every
     * `bufferCreationInterval` milliseconds and closes (emits and resets) the
     * buffer every `bufferTimeSpan` milliseconds. When the optional argument
     * `maxBufferSize` is specified, the buffer will be closed either after
     * `bufferTimeSpan` milliseconds or when it contains `maxBufferSize` elements.
     *
     * @example <caption>Every second, emit an array of the recent click events</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var buffered = clicks.bufferTime(1000);
     * buffered.subscribe(x => console.log(x));
     *
     * @example <caption>Every 5 seconds, emit the click events from the next 2 seconds</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var buffered = clicks.bufferTime(2000, 5000);
     * buffered.subscribe(x => console.log(x));
     *
     * @see {@link buffer}
     * @see {@link bufferCount}
     * @see {@link bufferToggle}
     * @see {@link bufferWhen}
     * @see {@link windowTime}
     *
     * @param {number} bufferTimeSpan The amount of time to fill each buffer array.
     * @param {number} [bufferCreationInterval] The interval at which to start new
     * buffers.
     * @param {number} [maxBufferSize] The maximum buffer size.
     * @param {Scheduler} [scheduler=async] The scheduler on which to schedule the
     * intervals that determine buffer boundaries.
     * @return {Observable<T[]>} An observable of arrays of buffered values.
     * @method bufferTime
     * @owner Observable
     */
    function bufferTime(bufferTimeSpan) {
        var length = arguments.length;
        var scheduler = async_1.async;
        if (isScheduler_1.isScheduler(arguments[arguments.length - 1])) {
            scheduler = arguments[arguments.length - 1];
            length--;
        }
        var bufferCreationInterval = null;
        if (length >= 2) {
            bufferCreationInterval = arguments[1];
        }
        var maxBufferSize = Number.POSITIVE_INFINITY;
        if (length >= 3) {
            maxBufferSize = arguments[2];
        }
        return function bufferTimeOperatorFunction(source) {
            return source.lift(new BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler));
        };
    }
    exports.bufferTime = bufferTime;
    var BufferTimeOperator = function () {
        function BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
            this.bufferTimeSpan = bufferTimeSpan;
            this.bufferCreationInterval = bufferCreationInterval;
            this.maxBufferSize = maxBufferSize;
            this.scheduler = scheduler;
        }
        BufferTimeOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new BufferTimeSubscriber(subscriber, this.bufferTimeSpan, this.bufferCreationInterval, this.maxBufferSize, this.scheduler));
        };
        return BufferTimeOperator;
    }();
    var Context = function () {
        function Context() {
            this.buffer = [];
        }
        return Context;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var BufferTimeSubscriber = function (_super) {
        __extends(BufferTimeSubscriber, _super);
        function BufferTimeSubscriber(destination, bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
            _super.call(this, destination);
            this.bufferTimeSpan = bufferTimeSpan;
            this.bufferCreationInterval = bufferCreationInterval;
            this.maxBufferSize = maxBufferSize;
            this.scheduler = scheduler;
            this.contexts = [];
            var context = this.openContext();
            this.timespanOnly = bufferCreationInterval == null || bufferCreationInterval < 0;
            if (this.timespanOnly) {
                var timeSpanOnlyState = { subscriber: this, context: context, bufferTimeSpan: bufferTimeSpan };
                this.add(context.closeAction = scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
            } else {
                var closeState = { subscriber: this, context: context };
                var creationState = { bufferTimeSpan: bufferTimeSpan, bufferCreationInterval: bufferCreationInterval, subscriber: this, scheduler: scheduler };
                this.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, closeState));
                this.add(scheduler.schedule(dispatchBufferCreation, bufferCreationInterval, creationState));
            }
        }
        BufferTimeSubscriber.prototype._next = function (value) {
            var contexts = this.contexts;
            var len = contexts.length;
            var filledBufferContext;
            for (var i = 0; i < len; i++) {
                var context = contexts[i];
                var buffer = context.buffer;
                buffer.push(value);
                if (buffer.length == this.maxBufferSize) {
                    filledBufferContext = context;
                }
            }
            if (filledBufferContext) {
                this.onBufferFull(filledBufferContext);
            }
        };
        BufferTimeSubscriber.prototype._error = function (err) {
            this.contexts.length = 0;
            _super.prototype._error.call(this, err);
        };
        BufferTimeSubscriber.prototype._complete = function () {
            var _a = this,
                contexts = _a.contexts,
                destination = _a.destination;
            while (contexts.length > 0) {
                var context = contexts.shift();
                destination.next(context.buffer);
            }
            _super.prototype._complete.call(this);
        };
        /** @deprecated internal use only */BufferTimeSubscriber.prototype._unsubscribe = function () {
            this.contexts = null;
        };
        BufferTimeSubscriber.prototype.onBufferFull = function (context) {
            this.closeContext(context);
            var closeAction = context.closeAction;
            closeAction.unsubscribe();
            this.remove(closeAction);
            if (!this.closed && this.timespanOnly) {
                context = this.openContext();
                var bufferTimeSpan = this.bufferTimeSpan;
                var timeSpanOnlyState = { subscriber: this, context: context, bufferTimeSpan: bufferTimeSpan };
                this.add(context.closeAction = this.scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
            }
        };
        BufferTimeSubscriber.prototype.openContext = function () {
            var context = new Context();
            this.contexts.push(context);
            return context;
        };
        BufferTimeSubscriber.prototype.closeContext = function (context) {
            this.destination.next(context.buffer);
            var contexts = this.contexts;
            var spliceIndex = contexts ? contexts.indexOf(context) : -1;
            if (spliceIndex >= 0) {
                contexts.splice(contexts.indexOf(context), 1);
            }
        };
        return BufferTimeSubscriber;
    }(Subscriber_1.Subscriber);
    function dispatchBufferTimeSpanOnly(state) {
        var subscriber = state.subscriber;
        var prevContext = state.context;
        if (prevContext) {
            subscriber.closeContext(prevContext);
        }
        if (!subscriber.closed) {
            state.context = subscriber.openContext();
            state.context.closeAction = this.schedule(state, state.bufferTimeSpan);
        }
    }
    function dispatchBufferCreation(state) {
        var bufferCreationInterval = state.bufferCreationInterval,
            bufferTimeSpan = state.bufferTimeSpan,
            subscriber = state.subscriber,
            scheduler = state.scheduler;
        var context = subscriber.openContext();
        var action = this;
        if (!subscriber.closed) {
            subscriber.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, { subscriber: subscriber, context: context }));
            action.schedule(state, bufferCreationInterval);
        }
    }
    function dispatchBufferClose(arg) {
        var subscriber = arg.subscriber,
            context = arg.context;
        subscriber.closeContext(context);
    }
    
});
System.registerDynamic('rxjs/operators/bufferToggle.js', ['rxjs/Subscription.js', 'rxjs/util/subscribeToResult.js', 'rxjs/OuterSubscriber.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscription_1 = $__require('rxjs/Subscription.js');
    var subscribeToResult_1 = $__require('rxjs/util/subscribeToResult.js');
    var OuterSubscriber_1 = $__require('rxjs/OuterSubscriber.js');
    /**
     * Buffers the source Observable values starting from an emission from
     * `openings` and ending when the output of `closingSelector` emits.
     *
     * <span class="informal">Collects values from the past as an array. Starts
     * collecting only when `opening` emits, and calls the `closingSelector`
     * function to get an Observable that tells when to close the buffer.</span>
     *
     * <img src="./img/bufferToggle.png" width="100%">
     *
     * Buffers values from the source by opening the buffer via signals from an
     * Observable provided to `openings`, and closing and sending the buffers when
     * a Subscribable or Promise returned by the `closingSelector` function emits.
     *
     * @example <caption>Every other second, emit the click events from the next 500ms</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var openings = Rx.Observable.interval(1000);
     * var buffered = clicks.bufferToggle(openings, i =>
     *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
     * );
     * buffered.subscribe(x => console.log(x));
     *
     * @see {@link buffer}
     * @see {@link bufferCount}
     * @see {@link bufferTime}
     * @see {@link bufferWhen}
     * @see {@link windowToggle}
     *
     * @param {SubscribableOrPromise<O>} openings A Subscribable or Promise of notifications to start new
     * buffers.
     * @param {function(value: O): SubscribableOrPromise} closingSelector A function that takes
     * the value emitted by the `openings` observable and returns a Subscribable or Promise,
     * which, when it emits, signals that the associated buffer should be emitted
     * and cleared.
     * @return {Observable<T[]>} An observable of arrays of buffered values.
     * @method bufferToggle
     * @owner Observable
     */
    function bufferToggle(openings, closingSelector) {
        return function bufferToggleOperatorFunction(source) {
            return source.lift(new BufferToggleOperator(openings, closingSelector));
        };
    }
    exports.bufferToggle = bufferToggle;
    var BufferToggleOperator = function () {
        function BufferToggleOperator(openings, closingSelector) {
            this.openings = openings;
            this.closingSelector = closingSelector;
        }
        BufferToggleOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new BufferToggleSubscriber(subscriber, this.openings, this.closingSelector));
        };
        return BufferToggleOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var BufferToggleSubscriber = function (_super) {
        __extends(BufferToggleSubscriber, _super);
        function BufferToggleSubscriber(destination, openings, closingSelector) {
            _super.call(this, destination);
            this.openings = openings;
            this.closingSelector = closingSelector;
            this.contexts = [];
            this.add(subscribeToResult_1.subscribeToResult(this, openings));
        }
        BufferToggleSubscriber.prototype._next = function (value) {
            var contexts = this.contexts;
            var len = contexts.length;
            for (var i = 0; i < len; i++) {
                contexts[i].buffer.push(value);
            }
        };
        BufferToggleSubscriber.prototype._error = function (err) {
            var contexts = this.contexts;
            while (contexts.length > 0) {
                var context = contexts.shift();
                context.subscription.unsubscribe();
                context.buffer = null;
                context.subscription = null;
            }
            this.contexts = null;
            _super.prototype._error.call(this, err);
        };
        BufferToggleSubscriber.prototype._complete = function () {
            var contexts = this.contexts;
            while (contexts.length > 0) {
                var context = contexts.shift();
                this.destination.next(context.buffer);
                context.subscription.unsubscribe();
                context.buffer = null;
                context.subscription = null;
            }
            this.contexts = null;
            _super.prototype._complete.call(this);
        };
        BufferToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            outerValue ? this.closeBuffer(outerValue) : this.openBuffer(innerValue);
        };
        BufferToggleSubscriber.prototype.notifyComplete = function (innerSub) {
            this.closeBuffer(innerSub.context);
        };
        BufferToggleSubscriber.prototype.openBuffer = function (value) {
            try {
                var closingSelector = this.closingSelector;
                var closingNotifier = closingSelector.call(this, value);
                if (closingNotifier) {
                    this.trySubscribe(closingNotifier);
                }
            } catch (err) {
                this._error(err);
            }
        };
        BufferToggleSubscriber.prototype.closeBuffer = function (context) {
            var contexts = this.contexts;
            if (contexts && context) {
                var buffer = context.buffer,
                    subscription = context.subscription;
                this.destination.next(buffer);
                contexts.splice(contexts.indexOf(context), 1);
                this.remove(subscription);
                subscription.unsubscribe();
            }
        };
        BufferToggleSubscriber.prototype.trySubscribe = function (closingNotifier) {
            var contexts = this.contexts;
            var buffer = [];
            var subscription = new Subscription_1.Subscription();
            var context = { buffer: buffer, subscription: subscription };
            contexts.push(context);
            var innerSubscription = subscribeToResult_1.subscribeToResult(this, closingNotifier, context);
            if (!innerSubscription || innerSubscription.closed) {
                this.closeBuffer(context);
            } else {
                innerSubscription.context = context;
                this.add(innerSubscription);
                subscription.add(innerSubscription);
            }
        };
        return BufferToggleSubscriber;
    }(OuterSubscriber_1.OuterSubscriber);
    
});
System.registerDynamic('rxjs/operators/bufferWhen.js', ['rxjs/Subscription.js', 'rxjs/util/tryCatch.js', 'rxjs/util/errorObject.js', 'rxjs/OuterSubscriber.js', 'rxjs/util/subscribeToResult.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscription_1 = $__require('rxjs/Subscription.js');
    var tryCatch_1 = $__require('rxjs/util/tryCatch.js');
    var errorObject_1 = $__require('rxjs/util/errorObject.js');
    var OuterSubscriber_1 = $__require('rxjs/OuterSubscriber.js');
    var subscribeToResult_1 = $__require('rxjs/util/subscribeToResult.js');
    /**
     * Buffers the source Observable values, using a factory function of closing
     * Observables to determine when to close, emit, and reset the buffer.
     *
     * <span class="informal">Collects values from the past as an array. When it
     * starts collecting values, it calls a function that returns an Observable that
     * tells when to close the buffer and restart collecting.</span>
     *
     * <img src="./img/bufferWhen.png" width="100%">
     *
     * Opens a buffer immediately, then closes the buffer when the observable
     * returned by calling `closingSelector` function emits a value. When it closes
     * the buffer, it immediately opens a new buffer and repeats the process.
     *
     * @example <caption>Emit an array of the last clicks every [1-5] random seconds</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var buffered = clicks.bufferWhen(() =>
     *   Rx.Observable.interval(1000 + Math.random() * 4000)
     * );
     * buffered.subscribe(x => console.log(x));
     *
     * @see {@link buffer}
     * @see {@link bufferCount}
     * @see {@link bufferTime}
     * @see {@link bufferToggle}
     * @see {@link windowWhen}
     *
     * @param {function(): Observable} closingSelector A function that takes no
     * arguments and returns an Observable that signals buffer closure.
     * @return {Observable<T[]>} An observable of arrays of buffered values.
     * @method bufferWhen
     * @owner Observable
     */
    function bufferWhen(closingSelector) {
        return function (source) {
            return source.lift(new BufferWhenOperator(closingSelector));
        };
    }
    exports.bufferWhen = bufferWhen;
    var BufferWhenOperator = function () {
        function BufferWhenOperator(closingSelector) {
            this.closingSelector = closingSelector;
        }
        BufferWhenOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new BufferWhenSubscriber(subscriber, this.closingSelector));
        };
        return BufferWhenOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var BufferWhenSubscriber = function (_super) {
        __extends(BufferWhenSubscriber, _super);
        function BufferWhenSubscriber(destination, closingSelector) {
            _super.call(this, destination);
            this.closingSelector = closingSelector;
            this.subscribing = false;
            this.openBuffer();
        }
        BufferWhenSubscriber.prototype._next = function (value) {
            this.buffer.push(value);
        };
        BufferWhenSubscriber.prototype._complete = function () {
            var buffer = this.buffer;
            if (buffer) {
                this.destination.next(buffer);
            }
            _super.prototype._complete.call(this);
        };
        /** @deprecated internal use only */BufferWhenSubscriber.prototype._unsubscribe = function () {
            this.buffer = null;
            this.subscribing = false;
        };
        BufferWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this.openBuffer();
        };
        BufferWhenSubscriber.prototype.notifyComplete = function () {
            if (this.subscribing) {
                this.complete();
            } else {
                this.openBuffer();
            }
        };
        BufferWhenSubscriber.prototype.openBuffer = function () {
            var closingSubscription = this.closingSubscription;
            if (closingSubscription) {
                this.remove(closingSubscription);
                closingSubscription.unsubscribe();
            }
            var buffer = this.buffer;
            if (this.buffer) {
                this.destination.next(buffer);
            }
            this.buffer = [];
            var closingNotifier = tryCatch_1.tryCatch(this.closingSelector)();
            if (closingNotifier === errorObject_1.errorObject) {
                this.error(errorObject_1.errorObject.e);
            } else {
                closingSubscription = new Subscription_1.Subscription();
                this.closingSubscription = closingSubscription;
                this.add(closingSubscription);
                this.subscribing = true;
                closingSubscription.add(subscribeToResult_1.subscribeToResult(this, closingNotifier));
                this.subscribing = false;
            }
        };
        return BufferWhenSubscriber;
    }(OuterSubscriber_1.OuterSubscriber);
    
});
System.registerDynamic('rxjs/operators/catchError.js', ['rxjs/OuterSubscriber.js', 'rxjs/util/subscribeToResult.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var OuterSubscriber_1 = $__require('rxjs/OuterSubscriber.js');
    var subscribeToResult_1 = $__require('rxjs/util/subscribeToResult.js');
    /**
     * Catches errors on the observable to be handled by returning a new observable or throwing an error.
     *
     * <img src="./img/catch.png" width="100%">
     *
     * @example <caption>Continues with a different Observable when there's an error</caption>
     *
     * Observable.of(1, 2, 3, 4, 5)
     *   .map(n => {
     * 	   if (n == 4) {
     * 	     throw 'four!';
     *     }
     *	   return n;
     *   })
     *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
     *   .subscribe(x => console.log(x));
     *   // 1, 2, 3, I, II, III, IV, V
     *
     * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
     *
     * Observable.of(1, 2, 3, 4, 5)
     *   .map(n => {
     * 	   if (n === 4) {
     * 	     throw 'four!';
     *     }
     * 	   return n;
     *   })
     *   .catch((err, caught) => caught)
     *   .take(30)
     *   .subscribe(x => console.log(x));
     *   // 1, 2, 3, 1, 2, 3, ...
     *
     * @example <caption>Throws a new error when the source Observable throws an error</caption>
     *
     * Observable.of(1, 2, 3, 4, 5)
     *   .map(n => {
     *     if (n == 4) {
     *       throw 'four!';
     *     }
     *     return n;
     *   })
     *   .catch(err => {
     *     throw 'error in source. Details: ' + err;
     *   })
     *   .subscribe(
     *     x => console.log(x),
     *     err => console.log(err)
     *   );
     *   // 1, 2, 3, error in source. Details: four!
     *
     * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
     *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
     *  is returned by the `selector` will be used to continue the observable chain.
     * @return {Observable} An observable that originates from either the source or the observable returned by the
     *  catch `selector` function.
     * @name catchError
     */
    function catchError(selector) {
        return function catchErrorOperatorFunction(source) {
            var operator = new CatchOperator(selector);
            var caught = source.lift(operator);
            return operator.caught = caught;
        };
    }
    exports.catchError = catchError;
    var CatchOperator = function () {
        function CatchOperator(selector) {
            this.selector = selector;
        }
        CatchOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new CatchSubscriber(subscriber, this.selector, this.caught));
        };
        return CatchOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var CatchSubscriber = function (_super) {
        __extends(CatchSubscriber, _super);
        function CatchSubscriber(destination, selector, caught) {
            _super.call(this, destination);
            this.selector = selector;
            this.caught = caught;
        }
        // NOTE: overriding `error` instead of `_error` because we don't want
        // to have this flag this subscriber as `isStopped`. We can mimic the
        // behavior of the RetrySubscriber (from the `retry` operator), where
        // we unsubscribe from our source chain, reset our Subscriber flags,
        // then subscribe to the selector result.
        CatchSubscriber.prototype.error = function (err) {
            if (!this.isStopped) {
                var result = void 0;
                try {
                    result = this.selector(err, this.caught);
                } catch (err2) {
                    _super.prototype.error.call(this, err2);
                    return;
                }
                this._unsubscribeAndRecycle();
                this.add(subscribeToResult_1.subscribeToResult(this, result));
            }
        };
        return CatchSubscriber;
    }(OuterSubscriber_1.OuterSubscriber);
    
});
System.registerDynamic("rxjs/operators/combineAll.js", ["rxjs/operators/combineLatest.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var combineLatest_1 = $__require("rxjs/operators/combineLatest.js");
    function combineAll(project) {
        return function (source) {
            return source.lift(new combineLatest_1.CombineLatestOperator(project));
        };
    }
    exports.combineAll = combineAll;
    
});
System.registerDynamic('rxjs/operators/combineLatest.js', ['rxjs/observable/ArrayObservable.js', 'rxjs/util/isArray.js', 'rxjs/OuterSubscriber.js', 'rxjs/util/subscribeToResult.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var ArrayObservable_1 = $__require('rxjs/observable/ArrayObservable.js');
    var isArray_1 = $__require('rxjs/util/isArray.js');
    var OuterSubscriber_1 = $__require('rxjs/OuterSubscriber.js');
    var subscribeToResult_1 = $__require('rxjs/util/subscribeToResult.js');
    var none = {};
    /* tslint:enable:max-line-length */
    /**
     * Combines multiple Observables to create an Observable whose values are
     * calculated from the latest values of each of its input Observables.
     *
     * <span class="informal">Whenever any input Observable emits a value, it
     * computes a formula using the latest values from all the inputs, then emits
     * the output of that formula.</span>
     *
     * <img src="./img/combineLatest.png" width="100%">
     *
     * `combineLatest` combines the values from this Observable with values from
     * Observables passed as arguments. This is done by subscribing to each
     * Observable, in order, and collecting an array of each of the most recent
     * values any time any of the input Observables emits, then either taking that
     * array and passing it as arguments to an optional `project` function and
     * emitting the return value of that, or just emitting the array of recent
     * values directly if there is no `project` function.
     *
     * @example <caption>Dynamically calculate the Body-Mass Index from an Observable of weight and one for height</caption>
     * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
     * var height = Rx.Observable.of(1.76, 1.77, 1.78);
     * var bmi = weight.combineLatest(height, (w, h) => w / (h * h));
     * bmi.subscribe(x => console.log('BMI is ' + x));
     *
     * // With output to console:
     * // BMI is 24.212293388429753
     * // BMI is 23.93948099205209
     * // BMI is 23.671253629592222
     *
     * @see {@link combineAll}
     * @see {@link merge}
     * @see {@link withLatestFrom}
     *
     * @param {ObservableInput} other An input Observable to combine with the source
     * Observable. More than one input Observables may be given as argument.
     * @param {function} [project] An optional function to project the values from
     * the combined latest values into a new value on the output Observable.
     * @return {Observable} An Observable of projected values from the most recent
     * values from each input Observable, or an array of the most recent values from
     * each input Observable.
     * @method combineLatest
     * @owner Observable
     */
    function combineLatest() {
        var observables = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            observables[_i - 0] = arguments[_i];
        }
        var project = null;
        if (typeof observables[observables.length - 1] === 'function') {
            project = observables.pop();
        }
        // if the first and only other argument besides the resultSelector is an array
        // assume it's been called with `combineLatest([obs1, obs2, obs3], project)`
        if (observables.length === 1 && isArray_1.isArray(observables[0])) {
            observables = observables[0].slice();
        }
        return function (source) {
            return source.lift.call(new ArrayObservable_1.ArrayObservable([source].concat(observables)), new CombineLatestOperator(project));
        };
    }
    exports.combineLatest = combineLatest;
    var CombineLatestOperator = function () {
        function CombineLatestOperator(project) {
            this.project = project;
        }
        CombineLatestOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new CombineLatestSubscriber(subscriber, this.project));
        };
        return CombineLatestOperator;
    }();
    exports.CombineLatestOperator = CombineLatestOperator;
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var CombineLatestSubscriber = function (_super) {
        __extends(CombineLatestSubscriber, _super);
        function CombineLatestSubscriber(destination, project) {
            _super.call(this, destination);
            this.project = project;
            this.active = 0;
            this.values = [];
            this.observables = [];
        }
        CombineLatestSubscriber.prototype._next = function (observable) {
            this.values.push(none);
            this.observables.push(observable);
        };
        CombineLatestSubscriber.prototype._complete = function () {
            var observables = this.observables;
            var len = observables.length;
            if (len === 0) {
                this.destination.complete();
            } else {
                this.active = len;
                this.toRespond = len;
                for (var i = 0; i < len; i++) {
                    var observable = observables[i];
                    this.add(subscribeToResult_1.subscribeToResult(this, observable, observable, i));
                }
            }
        };
        CombineLatestSubscriber.prototype.notifyComplete = function (unused) {
            if ((this.active -= 1) === 0) {
                this.destination.complete();
            }
        };
        CombineLatestSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            var values = this.values;
            var oldVal = values[outerIndex];
            var toRespond = !this.toRespond ? 0 : oldVal === none ? --this.toRespond : this.toRespond;
            values[outerIndex] = innerValue;
            if (toRespond === 0) {
                if (this.project) {
                    this._tryProject(values);
                } else {
                    this.destination.next(values.slice());
                }
            }
        };
        CombineLatestSubscriber.prototype._tryProject = function (values) {
            var result;
            try {
                result = this.project.apply(this, values);
            } catch (err) {
                this.destination.error(err);
                return;
            }
            this.destination.next(result);
        };
        return CombineLatestSubscriber;
    }(OuterSubscriber_1.OuterSubscriber);
    exports.CombineLatestSubscriber = CombineLatestSubscriber;
    
});
System.registerDynamic('rxjs/operators/concat.js', ['rxjs/observable/concat.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var concat_1 = $__require('rxjs/observable/concat.js');
    var concat_2 = $__require('rxjs/observable/concat.js');
    exports.concatStatic = concat_2.concat;
    /* tslint:enable:max-line-length */
    /**
     * Creates an output Observable which sequentially emits all values from every
     * given input Observable after the current Observable.
     *
     * <span class="informal">Concatenates multiple Observables together by
     * sequentially emitting their values, one Observable after the other.</span>
     *
     * <img src="./img/concat.png" width="100%">
     *
     * Joins this Observable with multiple other Observables by subscribing to them
     * one at a time, starting with the source, and merging their results into the
     * output Observable. Will wait for each Observable to complete before moving
     * on to the next.
     *
     * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
     * var timer = Rx.Observable.interval(1000).take(4);
     * var sequence = Rx.Observable.range(1, 10);
     * var result = timer.concat(sequence);
     * result.subscribe(x => console.log(x));
     *
     * // results in:
     * // 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
     *
     * @example <caption>Concatenate 3 Observables</caption>
     * var timer1 = Rx.Observable.interval(1000).take(10);
     * var timer2 = Rx.Observable.interval(2000).take(6);
     * var timer3 = Rx.Observable.interval(500).take(10);
     * var result = timer1.concat(timer2, timer3);
     * result.subscribe(x => console.log(x));
     *
     * // results in the following:
     * // (Prints to console sequentially)
     * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
     * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
     * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
     *
     * @see {@link concatAll}
     * @see {@link concatMap}
     * @see {@link concatMapTo}
     *
     * @param {ObservableInput} other An input Observable to concatenate after the source
     * Observable. More than one input Observables may be given as argument.
     * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
     * Observable subscription on.
     * @return {Observable} All values of each passed Observable merged into a
     * single Observable, in order, in serial fashion.
     * @method concat
     * @owner Observable
     */
    function concat() {
        var observables = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            observables[_i - 0] = arguments[_i];
        }
        return function (source) {
            return source.lift.call(concat_1.concat.apply(void 0, [source].concat(observables)));
        };
    }
    exports.concat = concat;
    
});
System.registerDynamic("rxjs/operators/concatMapTo.js", ["rxjs/operators/concatMap.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var concatMap_1 = $__require("rxjs/operators/concatMap.js");
  /* tslint:enable:max-line-length */
  /**
   * Projects each source value to the same Observable which is merged multiple
   * times in a serialized fashion on the output Observable.
   *
   * <span class="informal">It's like {@link concatMap}, but maps each value
   * always to the same inner Observable.</span>
   *
   * <img src="./img/concatMapTo.png" width="100%">
   *
   * Maps each source value to the given Observable `innerObservable` regardless
   * of the source value, and then flattens those resulting Observables into one
   * single Observable, which is the output Observable. Each new `innerObservable`
   * instance emitted on the output Observable is concatenated with the previous
   * `innerObservable` instance.
   *
   * __Warning:__ if source values arrive endlessly and faster than their
   * corresponding inner Observables can complete, it will result in memory issues
   * as inner Observables amass in an unbounded buffer waiting for their turn to
   * be subscribed to.
   *
   * Note: `concatMapTo` is equivalent to `mergeMapTo` with concurrency parameter
   * set to `1`.
   *
   * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var result = clicks.concatMapTo(Rx.Observable.interval(1000).take(4));
   * result.subscribe(x => console.log(x));
   *
   * // Results in the following:
   * // (results are not concurrent)
   * // For every click on the "document" it will emit values 0 to 3 spaced
   * // on a 1000ms interval
   * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
   *
   * @see {@link concat}
   * @see {@link concatAll}
   * @see {@link concatMap}
   * @see {@link mergeMapTo}
   * @see {@link switchMapTo}
   *
   * @param {ObservableInput} innerObservable An Observable to replace each value from
   * the source Observable.
   * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
   * A function to produce the value on the output Observable based on the values
   * and the indices of the source (outer) emission and the inner Observable
   * emission. The arguments passed to this function are:
   * - `outerValue`: the value that came from the source
   * - `innerValue`: the value that came from the projected Observable
   * - `outerIndex`: the "index" of the value that came from the source
   * - `innerIndex`: the "index" of the value from the projected Observable
   * @return {Observable} An observable of values merged together by joining the
   * passed observable with itself, one after the other, for each value emitted
   * from the source.
   * @method concatMapTo
   * @owner Observable
   */
  function concatMapTo(innerObservable, resultSelector) {
    return concatMap_1.concatMap(function () {
      return innerObservable;
    }, resultSelector);
  }
  exports.concatMapTo = concatMapTo;
  
});
System.registerDynamic("rxjs/operators/count.js", ["rxjs/Subscriber.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require("rxjs/Subscriber.js");
    /**
     * Counts the number of emissions on the source and emits that number when the
     * source completes.
     *
     * <span class="informal">Tells how many values were emitted, when the source
     * completes.</span>
     *
     * <img src="./img/count.png" width="100%">
     *
     * `count` transforms an Observable that emits values into an Observable that
     * emits a single value that represents the number of values emitted by the
     * source Observable. If the source Observable terminates with an error, `count`
     * will pass this error notification along without emitting a value first. If
     * the source Observable does not terminate at all, `count` will neither emit
     * a value nor terminate. This operator takes an optional `predicate` function
     * as argument, in which case the output emission will represent the number of
     * source values that matched `true` with the `predicate`.
     *
     * @example <caption>Counts how many seconds have passed before the first click happened</caption>
     * var seconds = Rx.Observable.interval(1000);
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var secondsBeforeClick = seconds.takeUntil(clicks);
     * var result = secondsBeforeClick.count();
     * result.subscribe(x => console.log(x));
     *
     * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
     * var numbers = Rx.Observable.range(1, 7);
     * var result = numbers.count(i => i % 2 === 1);
     * result.subscribe(x => console.log(x));
     *
     * // Results in:
     * // 4
     *
     * @see {@link max}
     * @see {@link min}
     * @see {@link reduce}
     *
     * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
     * boolean function to select what values are to be counted. It is provided with
     * arguments of:
     * - `value`: the value from the source Observable.
     * - `index`: the (zero-based) "index" of the value from the source Observable.
     * - `source`: the source Observable instance itself.
     * @return {Observable} An Observable of one number that represents the count as
     * described above.
     * @method count
     * @owner Observable
     */
    function count(predicate) {
        return function (source) {
            return source.lift(new CountOperator(predicate, source));
        };
    }
    exports.count = count;
    var CountOperator = function () {
        function CountOperator(predicate, source) {
            this.predicate = predicate;
            this.source = source;
        }
        CountOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new CountSubscriber(subscriber, this.predicate, this.source));
        };
        return CountOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var CountSubscriber = function (_super) {
        __extends(CountSubscriber, _super);
        function CountSubscriber(destination, predicate, source) {
            _super.call(this, destination);
            this.predicate = predicate;
            this.source = source;
            this.count = 0;
            this.index = 0;
        }
        CountSubscriber.prototype._next = function (value) {
            if (this.predicate) {
                this._tryPredicate(value);
            } else {
                this.count++;
            }
        };
        CountSubscriber.prototype._tryPredicate = function (value) {
            var result;
            try {
                result = this.predicate(value, this.index++, this.source);
            } catch (err) {
                this.destination.error(err);
                return;
            }
            if (result) {
                this.count++;
            }
        };
        CountSubscriber.prototype._complete = function () {
            this.destination.next(this.count);
            this.destination.complete();
        };
        return CountSubscriber;
    }(Subscriber_1.Subscriber);
    
});
System.registerDynamic('rxjs/operators/debounce.js', ['rxjs/OuterSubscriber.js', 'rxjs/util/subscribeToResult.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var OuterSubscriber_1 = $__require('rxjs/OuterSubscriber.js');
    var subscribeToResult_1 = $__require('rxjs/util/subscribeToResult.js');
    /**
     * Emits a value from the source Observable only after a particular time span
     * determined by another Observable has passed without another source emission.
     *
     * <span class="informal">It's like {@link debounceTime}, but the time span of
     * emission silence is determined by a second Observable.</span>
     *
     * <img src="./img/debounce.png" width="100%">
     *
     * `debounce` delays values emitted by the source Observable, but drops previous
     * pending delayed emissions if a new value arrives on the source Observable.
     * This operator keeps track of the most recent value from the source
     * Observable, and spawns a duration Observable by calling the
     * `durationSelector` function. The value is emitted only when the duration
     * Observable emits a value or completes, and if no other value was emitted on
     * the source Observable since the duration Observable was spawned. If a new
     * value appears before the duration Observable emits, the previous value will
     * be dropped and will not be emitted on the output Observable.
     *
     * Like {@link debounceTime}, this is a rate-limiting operator, and also a
     * delay-like operator since output emissions do not necessarily occur at the
     * same time as they did on the source Observable.
     *
     * @example <caption>Emit the most recent click after a burst of clicks</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var result = clicks.debounce(() => Rx.Observable.interval(1000));
     * result.subscribe(x => console.log(x));
     *
     * @see {@link audit}
     * @see {@link debounceTime}
     * @see {@link delayWhen}
     * @see {@link throttle}
     *
     * @param {function(value: T): SubscribableOrPromise} durationSelector A function
     * that receives a value from the source Observable, for computing the timeout
     * duration for each source value, returned as an Observable or a Promise.
     * @return {Observable} An Observable that delays the emissions of the source
     * Observable by the specified duration Observable returned by
     * `durationSelector`, and may drop some values if they occur too frequently.
     * @method debounce
     * @owner Observable
     */
    function debounce(durationSelector) {
        return function (source) {
            return source.lift(new DebounceOperator(durationSelector));
        };
    }
    exports.debounce = debounce;
    var DebounceOperator = function () {
        function DebounceOperator(durationSelector) {
            this.durationSelector = durationSelector;
        }
        DebounceOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new DebounceSubscriber(subscriber, this.durationSelector));
        };
        return DebounceOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var DebounceSubscriber = function (_super) {
        __extends(DebounceSubscriber, _super);
        function DebounceSubscriber(destination, durationSelector) {
            _super.call(this, destination);
            this.durationSelector = durationSelector;
            this.hasValue = false;
            this.durationSubscription = null;
        }
        DebounceSubscriber.prototype._next = function (value) {
            try {
                var result = this.durationSelector.call(this, value);
                if (result) {
                    this._tryNext(value, result);
                }
            } catch (err) {
                this.destination.error(err);
            }
        };
        DebounceSubscriber.prototype._complete = function () {
            this.emitValue();
            this.destination.complete();
        };
        DebounceSubscriber.prototype._tryNext = function (value, duration) {
            var subscription = this.durationSubscription;
            this.value = value;
            this.hasValue = true;
            if (subscription) {
                subscription.unsubscribe();
                this.remove(subscription);
            }
            subscription = subscribeToResult_1.subscribeToResult(this, duration);
            if (!subscription.closed) {
                this.add(this.durationSubscription = subscription);
            }
        };
        DebounceSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this.emitValue();
        };
        DebounceSubscriber.prototype.notifyComplete = function () {
            this.emitValue();
        };
        DebounceSubscriber.prototype.emitValue = function () {
            if (this.hasValue) {
                var value = this.value;
                var subscription = this.durationSubscription;
                if (subscription) {
                    this.durationSubscription = null;
                    subscription.unsubscribe();
                    this.remove(subscription);
                }
                this.value = null;
                this.hasValue = false;
                _super.prototype._next.call(this, value);
            }
        };
        return DebounceSubscriber;
    }(OuterSubscriber_1.OuterSubscriber);
    
});
System.registerDynamic('rxjs/operators/debounceTime.js', ['rxjs/Subscriber.js', 'rxjs/scheduler/async.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require('rxjs/Subscriber.js');
    var async_1 = $__require('rxjs/scheduler/async.js');
    /**
     * Emits a value from the source Observable only after a particular time span
     * has passed without another source emission.
     *
     * <span class="informal">It's like {@link delay}, but passes only the most
     * recent value from each burst of emissions.</span>
     *
     * <img src="./img/debounceTime.png" width="100%">
     *
     * `debounceTime` delays values emitted by the source Observable, but drops
     * previous pending delayed emissions if a new value arrives on the source
     * Observable. This operator keeps track of the most recent value from the
     * source Observable, and emits that only when `dueTime` enough time has passed
     * without any other value appearing on the source Observable. If a new value
     * appears before `dueTime` silence occurs, the previous value will be dropped
     * and will not be emitted on the output Observable.
     *
     * This is a rate-limiting operator, because it is impossible for more than one
     * value to be emitted in any time window of duration `dueTime`, but it is also
     * a delay-like operator since output emissions do not occur at the same time as
     * they did on the source Observable. Optionally takes a {@link IScheduler} for
     * managing timers.
     *
     * @example <caption>Emit the most recent click after a burst of clicks</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var result = clicks.debounceTime(1000);
     * result.subscribe(x => console.log(x));
     *
     * @see {@link auditTime}
     * @see {@link debounce}
     * @see {@link delay}
     * @see {@link sampleTime}
     * @see {@link throttleTime}
     *
     * @param {number} dueTime The timeout duration in milliseconds (or the time
     * unit determined internally by the optional `scheduler`) for the window of
     * time required to wait for emission silence before emitting the most recent
     * source value.
     * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
     * managing the timers that handle the timeout for each value.
     * @return {Observable} An Observable that delays the emissions of the source
     * Observable by the specified `dueTime`, and may drop some values if they occur
     * too frequently.
     * @method debounceTime
     * @owner Observable
     */
    function debounceTime(dueTime, scheduler) {
        if (scheduler === void 0) {
            scheduler = async_1.async;
        }
        return function (source) {
            return source.lift(new DebounceTimeOperator(dueTime, scheduler));
        };
    }
    exports.debounceTime = debounceTime;
    var DebounceTimeOperator = function () {
        function DebounceTimeOperator(dueTime, scheduler) {
            this.dueTime = dueTime;
            this.scheduler = scheduler;
        }
        DebounceTimeOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
        };
        return DebounceTimeOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var DebounceTimeSubscriber = function (_super) {
        __extends(DebounceTimeSubscriber, _super);
        function DebounceTimeSubscriber(destination, dueTime, scheduler) {
            _super.call(this, destination);
            this.dueTime = dueTime;
            this.scheduler = scheduler;
            this.debouncedSubscription = null;
            this.lastValue = null;
            this.hasValue = false;
        }
        DebounceTimeSubscriber.prototype._next = function (value) {
            this.clearDebounce();
            this.lastValue = value;
            this.hasValue = true;
            this.add(this.debouncedSubscription = this.scheduler.schedule(dispatchNext, this.dueTime, this));
        };
        DebounceTimeSubscriber.prototype._complete = function () {
            this.debouncedNext();
            this.destination.complete();
        };
        DebounceTimeSubscriber.prototype.debouncedNext = function () {
            this.clearDebounce();
            if (this.hasValue) {
                this.destination.next(this.lastValue);
                this.lastValue = null;
                this.hasValue = false;
            }
        };
        DebounceTimeSubscriber.prototype.clearDebounce = function () {
            var debouncedSubscription = this.debouncedSubscription;
            if (debouncedSubscription !== null) {
                this.remove(debouncedSubscription);
                debouncedSubscription.unsubscribe();
                this.debouncedSubscription = null;
            }
        };
        return DebounceTimeSubscriber;
    }(Subscriber_1.Subscriber);
    function dispatchNext(subscriber) {
        subscriber.debouncedNext();
    }
    
});
System.registerDynamic('rxjs/operators/delay.js', ['rxjs/scheduler/async.js', 'rxjs/util/isDate.js', 'rxjs/Subscriber.js', 'rxjs/Notification.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var async_1 = $__require('rxjs/scheduler/async.js');
    var isDate_1 = $__require('rxjs/util/isDate.js');
    var Subscriber_1 = $__require('rxjs/Subscriber.js');
    var Notification_1 = $__require('rxjs/Notification.js');
    /**
     * Delays the emission of items from the source Observable by a given timeout or
     * until a given Date.
     *
     * <span class="informal">Time shifts each item by some specified amount of
     * milliseconds.</span>
     *
     * <img src="./img/delay.png" width="100%">
     *
     * If the delay argument is a Number, this operator time shifts the source
     * Observable by that amount of time expressed in milliseconds. The relative
     * time intervals between the values are preserved.
     *
     * If the delay argument is a Date, this operator time shifts the start of the
     * Observable execution until the given date occurs.
     *
     * @example <caption>Delay each click by one second</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
     * delayedClicks.subscribe(x => console.log(x));
     *
     * @example <caption>Delay all clicks until a future date happens</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var date = new Date('March 15, 2050 12:00:00'); // in the future
     * var delayedClicks = clicks.delay(date); // click emitted only after that date
     * delayedClicks.subscribe(x => console.log(x));
     *
     * @see {@link debounceTime}
     * @see {@link delayWhen}
     *
     * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
     * a `Date` until which the emission of the source items is delayed.
     * @param {Scheduler} [scheduler=async] The IScheduler to use for
     * managing the timers that handle the time-shift for each item.
     * @return {Observable} An Observable that delays the emissions of the source
     * Observable by the specified timeout or Date.
     * @method delay
     * @owner Observable
     */
    function delay(delay, scheduler) {
        if (scheduler === void 0) {
            scheduler = async_1.async;
        }
        var absoluteDelay = isDate_1.isDate(delay);
        var delayFor = absoluteDelay ? +delay - scheduler.now() : Math.abs(delay);
        return function (source) {
            return source.lift(new DelayOperator(delayFor, scheduler));
        };
    }
    exports.delay = delay;
    var DelayOperator = function () {
        function DelayOperator(delay, scheduler) {
            this.delay = delay;
            this.scheduler = scheduler;
        }
        DelayOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
        };
        return DelayOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var DelaySubscriber = function (_super) {
        __extends(DelaySubscriber, _super);
        function DelaySubscriber(destination, delay, scheduler) {
            _super.call(this, destination);
            this.delay = delay;
            this.scheduler = scheduler;
            this.queue = [];
            this.active = false;
            this.errored = false;
        }
        DelaySubscriber.dispatch = function (state) {
            var source = state.source;
            var queue = source.queue;
            var scheduler = state.scheduler;
            var destination = state.destination;
            while (queue.length > 0 && queue[0].time - scheduler.now() <= 0) {
                queue.shift().notification.observe(destination);
            }
            if (queue.length > 0) {
                var delay_1 = Math.max(0, queue[0].time - scheduler.now());
                this.schedule(state, delay_1);
            } else {
                this.unsubscribe();
                source.active = false;
            }
        };
        DelaySubscriber.prototype._schedule = function (scheduler) {
            this.active = true;
            this.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
                source: this, destination: this.destination, scheduler: scheduler
            }));
        };
        DelaySubscriber.prototype.scheduleNotification = function (notification) {
            if (this.errored === true) {
                return;
            }
            var scheduler = this.scheduler;
            var message = new DelayMessage(scheduler.now() + this.delay, notification);
            this.queue.push(message);
            if (this.active === false) {
                this._schedule(scheduler);
            }
        };
        DelaySubscriber.prototype._next = function (value) {
            this.scheduleNotification(Notification_1.Notification.createNext(value));
        };
        DelaySubscriber.prototype._error = function (err) {
            this.errored = true;
            this.queue = [];
            this.destination.error(err);
        };
        DelaySubscriber.prototype._complete = function () {
            this.scheduleNotification(Notification_1.Notification.createComplete());
        };
        return DelaySubscriber;
    }(Subscriber_1.Subscriber);
    var DelayMessage = function () {
        function DelayMessage(time, notification) {
            this.time = time;
            this.notification = notification;
        }
        return DelayMessage;
    }();
    
});
System.registerDynamic('rxjs/operators/delayWhen.js', ['rxjs/Subscriber.js', 'rxjs/Observable.js', 'rxjs/OuterSubscriber.js', 'rxjs/util/subscribeToResult.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require('rxjs/Subscriber.js');
    var Observable_1 = $__require('rxjs/Observable.js');
    var OuterSubscriber_1 = $__require('rxjs/OuterSubscriber.js');
    var subscribeToResult_1 = $__require('rxjs/util/subscribeToResult.js');
    /**
     * Delays the emission of items from the source Observable by a given time span
     * determined by the emissions of another Observable.
     *
     * <span class="informal">It's like {@link delay}, but the time span of the
     * delay duration is determined by a second Observable.</span>
     *
     * <img src="./img/delayWhen.png" width="100%">
     *
     * `delayWhen` time shifts each emitted value from the source Observable by a
     * time span determined by another Observable. When the source emits a value,
     * the `delayDurationSelector` function is called with the source value as
     * argument, and should return an Observable, called the "duration" Observable.
     * The source value is emitted on the output Observable only when the duration
     * Observable emits a value or completes.
     *
     * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
     * is an Observable. When `subscriptionDelay` emits its first value or
     * completes, the source Observable is subscribed to and starts behaving like
     * described in the previous paragraph. If `subscriptionDelay` is not provided,
     * `delayWhen` will subscribe to the source Observable as soon as the output
     * Observable is subscribed.
     *
     * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var delayedClicks = clicks.delayWhen(event =>
     *   Rx.Observable.interval(Math.random() * 5000)
     * );
     * delayedClicks.subscribe(x => console.log(x));
     *
     * @see {@link debounce}
     * @see {@link delay}
     *
     * @param {function(value: T): Observable} delayDurationSelector A function that
     * returns an Observable for each value emitted by the source Observable, which
     * is then used to delay the emission of that item on the output Observable
     * until the Observable returned from this function emits a value.
     * @param {Observable} subscriptionDelay An Observable that triggers the
     * subscription to the source Observable once it emits any value.
     * @return {Observable} An Observable that delays the emissions of the source
     * Observable by an amount of time specified by the Observable returned by
     * `delayDurationSelector`.
     * @method delayWhen
     * @owner Observable
     */
    function delayWhen(delayDurationSelector, subscriptionDelay) {
        if (subscriptionDelay) {
            return function (source) {
                return new SubscriptionDelayObservable(source, subscriptionDelay).lift(new DelayWhenOperator(delayDurationSelector));
            };
        }
        return function (source) {
            return source.lift(new DelayWhenOperator(delayDurationSelector));
        };
    }
    exports.delayWhen = delayWhen;
    var DelayWhenOperator = function () {
        function DelayWhenOperator(delayDurationSelector) {
            this.delayDurationSelector = delayDurationSelector;
        }
        DelayWhenOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new DelayWhenSubscriber(subscriber, this.delayDurationSelector));
        };
        return DelayWhenOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var DelayWhenSubscriber = function (_super) {
        __extends(DelayWhenSubscriber, _super);
        function DelayWhenSubscriber(destination, delayDurationSelector) {
            _super.call(this, destination);
            this.delayDurationSelector = delayDurationSelector;
            this.completed = false;
            this.delayNotifierSubscriptions = [];
            this.values = [];
        }
        DelayWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this.destination.next(outerValue);
            this.removeSubscription(innerSub);
            this.tryComplete();
        };
        DelayWhenSubscriber.prototype.notifyError = function (error, innerSub) {
            this._error(error);
        };
        DelayWhenSubscriber.prototype.notifyComplete = function (innerSub) {
            var value = this.removeSubscription(innerSub);
            if (value) {
                this.destination.next(value);
            }
            this.tryComplete();
        };
        DelayWhenSubscriber.prototype._next = function (value) {
            try {
                var delayNotifier = this.delayDurationSelector(value);
                if (delayNotifier) {
                    this.tryDelay(delayNotifier, value);
                }
            } catch (err) {
                this.destination.error(err);
            }
        };
        DelayWhenSubscriber.prototype._complete = function () {
            this.completed = true;
            this.tryComplete();
        };
        DelayWhenSubscriber.prototype.removeSubscription = function (subscription) {
            subscription.unsubscribe();
            var subscriptionIdx = this.delayNotifierSubscriptions.indexOf(subscription);
            var value = null;
            if (subscriptionIdx !== -1) {
                value = this.values[subscriptionIdx];
                this.delayNotifierSubscriptions.splice(subscriptionIdx, 1);
                this.values.splice(subscriptionIdx, 1);
            }
            return value;
        };
        DelayWhenSubscriber.prototype.tryDelay = function (delayNotifier, value) {
            var notifierSubscription = subscribeToResult_1.subscribeToResult(this, delayNotifier, value);
            if (notifierSubscription && !notifierSubscription.closed) {
                this.add(notifierSubscription);
                this.delayNotifierSubscriptions.push(notifierSubscription);
            }
            this.values.push(value);
        };
        DelayWhenSubscriber.prototype.tryComplete = function () {
            if (this.completed && this.delayNotifierSubscriptions.length === 0) {
                this.destination.complete();
            }
        };
        return DelayWhenSubscriber;
    }(OuterSubscriber_1.OuterSubscriber);
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var SubscriptionDelayObservable = function (_super) {
        __extends(SubscriptionDelayObservable, _super);
        function SubscriptionDelayObservable( /** @deprecated internal use only */source, subscriptionDelay) {
            _super.call(this);
            this.source = source;
            this.subscriptionDelay = subscriptionDelay;
        }
        /** @deprecated internal use only */SubscriptionDelayObservable.prototype._subscribe = function (subscriber) {
            this.subscriptionDelay.subscribe(new SubscriptionDelaySubscriber(subscriber, this.source));
        };
        return SubscriptionDelayObservable;
    }(Observable_1.Observable);
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var SubscriptionDelaySubscriber = function (_super) {
        __extends(SubscriptionDelaySubscriber, _super);
        function SubscriptionDelaySubscriber(parent, source) {
            _super.call(this);
            this.parent = parent;
            this.source = source;
            this.sourceSubscribed = false;
        }
        SubscriptionDelaySubscriber.prototype._next = function (unused) {
            this.subscribeToSource();
        };
        SubscriptionDelaySubscriber.prototype._error = function (err) {
            this.unsubscribe();
            this.parent.error(err);
        };
        SubscriptionDelaySubscriber.prototype._complete = function () {
            this.subscribeToSource();
        };
        SubscriptionDelaySubscriber.prototype.subscribeToSource = function () {
            if (!this.sourceSubscribed) {
                this.sourceSubscribed = true;
                this.unsubscribe();
                this.source.subscribe(this.parent);
            }
        };
        return SubscriptionDelaySubscriber;
    }(Subscriber_1.Subscriber);
    
});
System.registerDynamic("rxjs/operators/dematerialize.js", ["rxjs/Subscriber.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require("rxjs/Subscriber.js");
    /**
     * Converts an Observable of {@link Notification} objects into the emissions
     * that they represent.
     *
     * <span class="informal">Unwraps {@link Notification} objects as actual `next`,
     * `error` and `complete` emissions. The opposite of {@link materialize}.</span>
     *
     * <img src="./img/dematerialize.png" width="100%">
     *
     * `dematerialize` is assumed to operate an Observable that only emits
     * {@link Notification} objects as `next` emissions, and does not emit any
     * `error`. Such Observable is the output of a `materialize` operation. Those
     * notifications are then unwrapped using the metadata they contain, and emitted
     * as `next`, `error`, and `complete` on the output Observable.
     *
     * Use this operator in conjunction with {@link materialize}.
     *
     * @example <caption>Convert an Observable of Notifications to an actual Observable</caption>
     * var notifA = new Rx.Notification('N', 'A');
     * var notifB = new Rx.Notification('N', 'B');
     * var notifE = new Rx.Notification('E', void 0,
     *   new TypeError('x.toUpperCase is not a function')
     * );
     * var materialized = Rx.Observable.of(notifA, notifB, notifE);
     * var upperCase = materialized.dematerialize();
     * upperCase.subscribe(x => console.log(x), e => console.error(e));
     *
     * // Results in:
     * // A
     * // B
     * // TypeError: x.toUpperCase is not a function
     *
     * @see {@link Notification}
     * @see {@link materialize}
     *
     * @return {Observable} An Observable that emits items and notifications
     * embedded in Notification objects emitted by the source Observable.
     * @method dematerialize
     * @owner Observable
     */
    function dematerialize() {
        return function dematerializeOperatorFunction(source) {
            return source.lift(new DeMaterializeOperator());
        };
    }
    exports.dematerialize = dematerialize;
    var DeMaterializeOperator = function () {
        function DeMaterializeOperator() {}
        DeMaterializeOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new DeMaterializeSubscriber(subscriber));
        };
        return DeMaterializeOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var DeMaterializeSubscriber = function (_super) {
        __extends(DeMaterializeSubscriber, _super);
        function DeMaterializeSubscriber(destination) {
            _super.call(this, destination);
        }
        DeMaterializeSubscriber.prototype._next = function (value) {
            value.observe(this.destination);
        };
        return DeMaterializeSubscriber;
    }(Subscriber_1.Subscriber);
    
});
System.registerDynamic("rxjs/util/Set.js", ["rxjs/util/root.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var root_1 = $__require("rxjs/util/root.js");
    function minimalSetImpl() {
        // THIS IS NOT a full impl of Set, this is just the minimum
        // bits of functionality we need for this library.
        return function () {
            function MinimalSet() {
                this._values = [];
            }
            MinimalSet.prototype.add = function (value) {
                if (!this.has(value)) {
                    this._values.push(value);
                }
            };
            MinimalSet.prototype.has = function (value) {
                return this._values.indexOf(value) !== -1;
            };
            Object.defineProperty(MinimalSet.prototype, "size", {
                get: function () {
                    return this._values.length;
                },
                enumerable: true,
                configurable: true
            });
            MinimalSet.prototype.clear = function () {
                this._values.length = 0;
            };
            return MinimalSet;
        }();
    }
    exports.minimalSetImpl = minimalSetImpl;
    exports.Set = root_1.root.Set || minimalSetImpl();
    
});
System.registerDynamic('rxjs/operators/distinct.js', ['rxjs/OuterSubscriber.js', 'rxjs/util/subscribeToResult.js', 'rxjs/util/Set.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var OuterSubscriber_1 = $__require('rxjs/OuterSubscriber.js');
    var subscribeToResult_1 = $__require('rxjs/util/subscribeToResult.js');
    var Set_1 = $__require('rxjs/util/Set.js');
    /**
     * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from previous items.
     *
     * If a keySelector function is provided, then it will project each value from the source observable into a new value that it will
     * check for equality with previously projected values. If a keySelector function is not provided, it will use each value from the
     * source observable directly with an equality check against previous values.
     *
     * In JavaScript runtimes that support `Set`, this operator will use a `Set` to improve performance of the distinct value checking.
     *
     * In other runtimes, this operator will use a minimal implementation of `Set` that relies on an `Array` and `indexOf` under the
     * hood, so performance will degrade as more values are checked for distinction. Even in newer browsers, a long-running `distinct`
     * use might result in memory leaks. To help alleviate this in some scenarios, an optional `flushes` parameter is also provided so
     * that the internal `Set` can be "flushed", basically clearing it of values.
     *
     * @example <caption>A simple example with numbers</caption>
     * Observable.of(1, 1, 2, 2, 2, 1, 2, 3, 4, 3, 2, 1)
     *   .distinct()
     *   .subscribe(x => console.log(x)); // 1, 2, 3, 4
     *
     * @example <caption>An example using a keySelector function</caption>
     * interface Person {
     *    age: number,
     *    name: string
     * }
     *
     * Observable.of<Person>(
     *     { age: 4, name: 'Foo'},
     *     { age: 7, name: 'Bar'},
     *     { age: 5, name: 'Foo'})
     *     .distinct((p: Person) => p.name)
     *     .subscribe(x => console.log(x));
     *
     * // displays:
     * // { age: 4, name: 'Foo' }
     * // { age: 7, name: 'Bar' }
     *
     * @see {@link distinctUntilChanged}
     * @see {@link distinctUntilKeyChanged}
     *
     * @param {function} [keySelector] Optional function to select which value you want to check as distinct.
     * @param {Observable} [flushes] Optional Observable for flushing the internal HashSet of the operator.
     * @return {Observable} An Observable that emits items from the source Observable with distinct values.
     * @method distinct
     * @owner Observable
     */
    function distinct(keySelector, flushes) {
        return function (source) {
            return source.lift(new DistinctOperator(keySelector, flushes));
        };
    }
    exports.distinct = distinct;
    var DistinctOperator = function () {
        function DistinctOperator(keySelector, flushes) {
            this.keySelector = keySelector;
            this.flushes = flushes;
        }
        DistinctOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new DistinctSubscriber(subscriber, this.keySelector, this.flushes));
        };
        return DistinctOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var DistinctSubscriber = function (_super) {
        __extends(DistinctSubscriber, _super);
        function DistinctSubscriber(destination, keySelector, flushes) {
            _super.call(this, destination);
            this.keySelector = keySelector;
            this.values = new Set_1.Set();
            if (flushes) {
                this.add(subscribeToResult_1.subscribeToResult(this, flushes));
            }
        }
        DistinctSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this.values.clear();
        };
        DistinctSubscriber.prototype.notifyError = function (error, innerSub) {
            this._error(error);
        };
        DistinctSubscriber.prototype._next = function (value) {
            if (this.keySelector) {
                this._useKeySelector(value);
            } else {
                this._finalizeNext(value, value);
            }
        };
        DistinctSubscriber.prototype._useKeySelector = function (value) {
            var key;
            var destination = this.destination;
            try {
                key = this.keySelector(value);
            } catch (err) {
                destination.error(err);
                return;
            }
            this._finalizeNext(key, value);
        };
        DistinctSubscriber.prototype._finalizeNext = function (key, value) {
            var values = this.values;
            if (!values.has(key)) {
                values.add(key);
                this.destination.next(value);
            }
        };
        return DistinctSubscriber;
    }(OuterSubscriber_1.OuterSubscriber);
    exports.DistinctSubscriber = DistinctSubscriber;
    
});
System.registerDynamic('rxjs/operators/distinctUntilChanged.js', ['rxjs/Subscriber.js', 'rxjs/util/tryCatch.js', 'rxjs/util/errorObject.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require('rxjs/Subscriber.js');
    var tryCatch_1 = $__require('rxjs/util/tryCatch.js');
    var errorObject_1 = $__require('rxjs/util/errorObject.js');
    /* tslint:enable:max-line-length */
    /**
     * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
     *
     * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
     *
     * If a comparator function is not provided, an equality check is used by default.
     *
     * @example <caption>A simple example with numbers</caption>
     * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
     *   .distinctUntilChanged()
     *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
     *
     * @example <caption>An example using a compare function</caption>
     * interface Person {
     *    age: number,
     *    name: string
     * }
     *
     * Observable.of<Person>(
     *     { age: 4, name: 'Foo'},
     *     { age: 7, name: 'Bar'},
     *     { age: 5, name: 'Foo'})
     *     { age: 6, name: 'Foo'})
     *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
     *     .subscribe(x => console.log(x));
     *
     * // displays:
     * // { age: 4, name: 'Foo' }
     * // { age: 7, name: 'Bar' }
     * // { age: 5, name: 'Foo' }
     *
     * @see {@link distinct}
     * @see {@link distinctUntilKeyChanged}
     *
     * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
     * @return {Observable} An Observable that emits items from the source Observable with distinct values.
     * @method distinctUntilChanged
     * @owner Observable
     */
    function distinctUntilChanged(compare, keySelector) {
        return function (source) {
            return source.lift(new DistinctUntilChangedOperator(compare, keySelector));
        };
    }
    exports.distinctUntilChanged = distinctUntilChanged;
    var DistinctUntilChangedOperator = function () {
        function DistinctUntilChangedOperator(compare, keySelector) {
            this.compare = compare;
            this.keySelector = keySelector;
        }
        DistinctUntilChangedOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
        };
        return DistinctUntilChangedOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var DistinctUntilChangedSubscriber = function (_super) {
        __extends(DistinctUntilChangedSubscriber, _super);
        function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
            _super.call(this, destination);
            this.keySelector = keySelector;
            this.hasKey = false;
            if (typeof compare === 'function') {
                this.compare = compare;
            }
        }
        DistinctUntilChangedSubscriber.prototype.compare = function (x, y) {
            return x === y;
        };
        DistinctUntilChangedSubscriber.prototype._next = function (value) {
            var keySelector = this.keySelector;
            var key = value;
            if (keySelector) {
                key = tryCatch_1.tryCatch(this.keySelector)(value);
                if (key === errorObject_1.errorObject) {
                    return this.destination.error(errorObject_1.errorObject.e);
                }
            }
            var result = false;
            if (this.hasKey) {
                result = tryCatch_1.tryCatch(this.compare)(this.key, key);
                if (result === errorObject_1.errorObject) {
                    return this.destination.error(errorObject_1.errorObject.e);
                }
            } else {
                this.hasKey = true;
            }
            if (Boolean(result) === false) {
                this.key = key;
                this.destination.next(value);
            }
        };
        return DistinctUntilChangedSubscriber;
    }(Subscriber_1.Subscriber);
    
});
System.registerDynamic("rxjs/operators/distinctUntilKeyChanged.js", ["rxjs/operators/distinctUntilChanged.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var distinctUntilChanged_1 = $__require("rxjs/operators/distinctUntilChanged.js");
  /* tslint:enable:max-line-length */
  /**
   * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item,
   * using a property accessed by using the key provided to check if the two items are distinct.
   *
   * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
   *
   * If a comparator function is not provided, an equality check is used by default.
   *
   * @example <caption>An example comparing the name of persons</caption>
   *
   *  interface Person {
   *     age: number,
   *     name: string
   *  }
   *
   * Observable.of<Person>(
   *     { age: 4, name: 'Foo'},
   *     { age: 7, name: 'Bar'},
   *     { age: 5, name: 'Foo'},
   *     { age: 6, name: 'Foo'})
   *     .distinctUntilKeyChanged('name')
   *     .subscribe(x => console.log(x));
   *
   * // displays:
   * // { age: 4, name: 'Foo' }
   * // { age: 7, name: 'Bar' }
   * // { age: 5, name: 'Foo' }
   *
   * @example <caption>An example comparing the first letters of the name</caption>
   *
   * interface Person {
   *     age: number,
   *     name: string
   *  }
   *
   * Observable.of<Person>(
   *     { age: 4, name: 'Foo1'},
   *     { age: 7, name: 'Bar'},
   *     { age: 5, name: 'Foo2'},
   *     { age: 6, name: 'Foo3'})
   *     .distinctUntilKeyChanged('name', (x: string, y: string) => x.substring(0, 3) === y.substring(0, 3))
   *     .subscribe(x => console.log(x));
   *
   * // displays:
   * // { age: 4, name: 'Foo1' }
   * // { age: 7, name: 'Bar' }
   * // { age: 5, name: 'Foo2' }
   *
   * @see {@link distinct}
   * @see {@link distinctUntilChanged}
   *
   * @param {string} key String key for object property lookup on each item.
   * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
   * @return {Observable} An Observable that emits items from the source Observable with distinct values based on the key specified.
   * @method distinctUntilKeyChanged
   * @owner Observable
   */
  function distinctUntilKeyChanged(key, compare) {
    return distinctUntilChanged_1.distinctUntilChanged(function (x, y) {
      return compare ? compare(x[key], y[key]) : x[key] === y[key];
    });
  }
  exports.distinctUntilKeyChanged = distinctUntilKeyChanged;
  
});
System.registerDynamic('rxjs/operators/elementAt.js', ['rxjs/Subscriber.js', 'rxjs/util/ArgumentOutOfRangeError.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require('rxjs/Subscriber.js');
    var ArgumentOutOfRangeError_1 = $__require('rxjs/util/ArgumentOutOfRangeError.js');
    /**
     * Emits the single value at the specified `index` in a sequence of emissions
     * from the source Observable.
     *
     * <span class="informal">Emits only the i-th value, then completes.</span>
     *
     * <img src="./img/elementAt.png" width="100%">
     *
     * `elementAt` returns an Observable that emits the item at the specified
     * `index` in the source Observable, or a default value if that `index` is out
     * of range and the `default` argument is provided. If the `default` argument is
     * not given and the `index` is out of range, the output Observable will emit an
     * `ArgumentOutOfRangeError` error.
     *
     * @example <caption>Emit only the third click event</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var result = clicks.elementAt(2);
     * result.subscribe(x => console.log(x));
     *
     * // Results in:
     * // click 1 = nothing
     * // click 2 = nothing
     * // click 3 = MouseEvent object logged to console
     *
     * @see {@link first}
     * @see {@link last}
     * @see {@link skip}
     * @see {@link single}
     * @see {@link take}
     *
     * @throws {ArgumentOutOfRangeError} When using `elementAt(i)`, it delivers an
     * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0` or the
     * Observable has completed before emitting the i-th `next` notification.
     *
     * @param {number} index Is the number `i` for the i-th source emission that has
     * happened since the subscription, starting from the number `0`.
     * @param {T} [defaultValue] The default value returned for missing indices.
     * @return {Observable} An Observable that emits a single item, if it is found.
     * Otherwise, will emit the default value if given. If not, then emits an error.
     * @method elementAt
     * @owner Observable
     */
    function elementAt(index, defaultValue) {
        return function (source) {
            return source.lift(new ElementAtOperator(index, defaultValue));
        };
    }
    exports.elementAt = elementAt;
    var ElementAtOperator = function () {
        function ElementAtOperator(index, defaultValue) {
            this.index = index;
            this.defaultValue = defaultValue;
            if (index < 0) {
                throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError();
            }
        }
        ElementAtOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new ElementAtSubscriber(subscriber, this.index, this.defaultValue));
        };
        return ElementAtOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var ElementAtSubscriber = function (_super) {
        __extends(ElementAtSubscriber, _super);
        function ElementAtSubscriber(destination, index, defaultValue) {
            _super.call(this, destination);
            this.index = index;
            this.defaultValue = defaultValue;
        }
        ElementAtSubscriber.prototype._next = function (x) {
            if (this.index-- === 0) {
                this.destination.next(x);
                this.destination.complete();
            }
        };
        ElementAtSubscriber.prototype._complete = function () {
            var destination = this.destination;
            if (this.index >= 0) {
                if (typeof this.defaultValue !== 'undefined') {
                    destination.next(this.defaultValue);
                } else {
                    destination.error(new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError());
                }
            }
            destination.complete();
        };
        return ElementAtSubscriber;
    }(Subscriber_1.Subscriber);
    
});
System.registerDynamic("rxjs/operators/every.js", ["rxjs/Subscriber.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require("rxjs/Subscriber.js");
    /**
     * Returns an Observable that emits whether or not every item of the source satisfies the condition specified.
     *
     * @example <caption>A simple example emitting true if all elements are less than 5, false otherwise</caption>
     *  Observable.of(1, 2, 3, 4, 5, 6)
     *     .every(x => x < 5)
     *     .subscribe(x => console.log(x)); // -> false
     *
     * @param {function} predicate A function for determining if an item meets a specified condition.
     * @param {any} [thisArg] Optional object to use for `this` in the callback.
     * @return {Observable} An Observable of booleans that determines if all items of the source Observable meet the condition specified.
     * @method every
     * @owner Observable
     */
    function every(predicate, thisArg) {
        return function (source) {
            return source.lift(new EveryOperator(predicate, thisArg, source));
        };
    }
    exports.every = every;
    var EveryOperator = function () {
        function EveryOperator(predicate, thisArg, source) {
            this.predicate = predicate;
            this.thisArg = thisArg;
            this.source = source;
        }
        EveryOperator.prototype.call = function (observer, source) {
            return source.subscribe(new EverySubscriber(observer, this.predicate, this.thisArg, this.source));
        };
        return EveryOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var EverySubscriber = function (_super) {
        __extends(EverySubscriber, _super);
        function EverySubscriber(destination, predicate, thisArg, source) {
            _super.call(this, destination);
            this.predicate = predicate;
            this.thisArg = thisArg;
            this.source = source;
            this.index = 0;
            this.thisArg = thisArg || this;
        }
        EverySubscriber.prototype.notifyComplete = function (everyValueMatch) {
            this.destination.next(everyValueMatch);
            this.destination.complete();
        };
        EverySubscriber.prototype._next = function (value) {
            var result = false;
            try {
                result = this.predicate.call(this.thisArg, value, this.index++, this.source);
            } catch (err) {
                this.destination.error(err);
                return;
            }
            if (!result) {
                this.notifyComplete(false);
            }
        };
        EverySubscriber.prototype._complete = function () {
            this.notifyComplete(true);
        };
        return EverySubscriber;
    }(Subscriber_1.Subscriber);
    
});
System.registerDynamic('rxjs/operators/exhaust.js', ['rxjs/OuterSubscriber.js', 'rxjs/util/subscribeToResult.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var OuterSubscriber_1 = $__require('rxjs/OuterSubscriber.js');
    var subscribeToResult_1 = $__require('rxjs/util/subscribeToResult.js');
    /**
     * Converts a higher-order Observable into a first-order Observable by dropping
     * inner Observables while the previous inner Observable has not yet completed.
     *
     * <span class="informal">Flattens an Observable-of-Observables by dropping the
     * next inner Observables while the current inner is still executing.</span>
     *
     * <img src="./img/exhaust.png" width="100%">
     *
     * `exhaust` subscribes to an Observable that emits Observables, also known as a
     * higher-order Observable. Each time it observes one of these emitted inner
     * Observables, the output Observable begins emitting the items emitted by that
     * inner Observable. So far, it behaves like {@link mergeAll}. However,
     * `exhaust` ignores every new inner Observable if the previous Observable has
     * not yet completed. Once that one completes, it will accept and flatten the
     * next inner Observable and repeat this process.
     *
     * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(5));
     * var result = higherOrder.exhaust();
     * result.subscribe(x => console.log(x));
     *
     * @see {@link combineAll}
     * @see {@link concatAll}
     * @see {@link switch}
     * @see {@link mergeAll}
     * @see {@link exhaustMap}
     * @see {@link zipAll}
     *
     * @return {Observable} An Observable that takes a source of Observables and propagates the first observable
     * exclusively until it completes before subscribing to the next.
     * @method exhaust
     * @owner Observable
     */
    function exhaust() {
        return function (source) {
            return source.lift(new SwitchFirstOperator());
        };
    }
    exports.exhaust = exhaust;
    var SwitchFirstOperator = function () {
        function SwitchFirstOperator() {}
        SwitchFirstOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new SwitchFirstSubscriber(subscriber));
        };
        return SwitchFirstOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var SwitchFirstSubscriber = function (_super) {
        __extends(SwitchFirstSubscriber, _super);
        function SwitchFirstSubscriber(destination) {
            _super.call(this, destination);
            this.hasCompleted = false;
            this.hasSubscription = false;
        }
        SwitchFirstSubscriber.prototype._next = function (value) {
            if (!this.hasSubscription) {
                this.hasSubscription = true;
                this.add(subscribeToResult_1.subscribeToResult(this, value));
            }
        };
        SwitchFirstSubscriber.prototype._complete = function () {
            this.hasCompleted = true;
            if (!this.hasSubscription) {
                this.destination.complete();
            }
        };
        SwitchFirstSubscriber.prototype.notifyComplete = function (innerSub) {
            this.remove(innerSub);
            this.hasSubscription = false;
            if (this.hasCompleted) {
                this.destination.complete();
            }
        };
        return SwitchFirstSubscriber;
    }(OuterSubscriber_1.OuterSubscriber);
    
});
System.registerDynamic('rxjs/operators/exhaustMap.js', ['rxjs/OuterSubscriber.js', 'rxjs/util/subscribeToResult.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var OuterSubscriber_1 = $__require('rxjs/OuterSubscriber.js');
    var subscribeToResult_1 = $__require('rxjs/util/subscribeToResult.js');
    /* tslint:enable:max-line-length */
    /**
     * Projects each source value to an Observable which is merged in the output
     * Observable only if the previous projected Observable has completed.
     *
     * <span class="informal">Maps each value to an Observable, then flattens all of
     * these inner Observables using {@link exhaust}.</span>
     *
     * <img src="./img/exhaustMap.png" width="100%">
     *
     * Returns an Observable that emits items based on applying a function that you
     * supply to each item emitted by the source Observable, where that function
     * returns an (so-called "inner") Observable. When it projects a source value to
     * an Observable, the output Observable begins emitting the items emitted by
     * that projected Observable. However, `exhaustMap` ignores every new projected
     * Observable if the previous projected Observable has not yet completed. Once
     * that one completes, it will accept and flatten the next projected Observable
     * and repeat this process.
     *
     * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var result = clicks.exhaustMap((ev) => Rx.Observable.interval(1000).take(5));
     * result.subscribe(x => console.log(x));
     *
     * @see {@link concatMap}
     * @see {@link exhaust}
     * @see {@link mergeMap}
     * @see {@link switchMap}
     *
     * @param {function(value: T, ?index: number): ObservableInput} project A function
     * that, when applied to an item emitted by the source Observable, returns an
     * Observable.
     * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
     * A function to produce the value on the output Observable based on the values
     * and the indices of the source (outer) emission and the inner Observable
     * emission. The arguments passed to this function are:
     * - `outerValue`: the value that came from the source
     * - `innerValue`: the value that came from the projected Observable
     * - `outerIndex`: the "index" of the value that came from the source
     * - `innerIndex`: the "index" of the value from the projected Observable
     * @return {Observable} An Observable containing projected Observables
     * of each item of the source, ignoring projected Observables that start before
     * their preceding Observable has completed.
     * @method exhaustMap
     * @owner Observable
     */
    function exhaustMap(project, resultSelector) {
        return function (source) {
            return source.lift(new SwitchFirstMapOperator(project, resultSelector));
        };
    }
    exports.exhaustMap = exhaustMap;
    var SwitchFirstMapOperator = function () {
        function SwitchFirstMapOperator(project, resultSelector) {
            this.project = project;
            this.resultSelector = resultSelector;
        }
        SwitchFirstMapOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new SwitchFirstMapSubscriber(subscriber, this.project, this.resultSelector));
        };
        return SwitchFirstMapOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var SwitchFirstMapSubscriber = function (_super) {
        __extends(SwitchFirstMapSubscriber, _super);
        function SwitchFirstMapSubscriber(destination, project, resultSelector) {
            _super.call(this, destination);
            this.project = project;
            this.resultSelector = resultSelector;
            this.hasSubscription = false;
            this.hasCompleted = false;
            this.index = 0;
        }
        SwitchFirstMapSubscriber.prototype._next = function (value) {
            if (!this.hasSubscription) {
                this.tryNext(value);
            }
        };
        SwitchFirstMapSubscriber.prototype.tryNext = function (value) {
            var index = this.index++;
            var destination = this.destination;
            try {
                var result = this.project(value, index);
                this.hasSubscription = true;
                this.add(subscribeToResult_1.subscribeToResult(this, result, value, index));
            } catch (err) {
                destination.error(err);
            }
        };
        SwitchFirstMapSubscriber.prototype._complete = function () {
            this.hasCompleted = true;
            if (!this.hasSubscription) {
                this.destination.complete();
            }
        };
        SwitchFirstMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            var _a = this,
                resultSelector = _a.resultSelector,
                destination = _a.destination;
            if (resultSelector) {
                this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
            } else {
                destination.next(innerValue);
            }
        };
        SwitchFirstMapSubscriber.prototype.trySelectResult = function (outerValue, innerValue, outerIndex, innerIndex) {
            var _a = this,
                resultSelector = _a.resultSelector,
                destination = _a.destination;
            try {
                var result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
                destination.next(result);
            } catch (err) {
                destination.error(err);
            }
        };
        SwitchFirstMapSubscriber.prototype.notifyError = function (err) {
            this.destination.error(err);
        };
        SwitchFirstMapSubscriber.prototype.notifyComplete = function (innerSub) {
            this.remove(innerSub);
            this.hasSubscription = false;
            if (this.hasCompleted) {
                this.destination.complete();
            }
        };
        return SwitchFirstMapSubscriber;
    }(OuterSubscriber_1.OuterSubscriber);
    
});
System.registerDynamic('rxjs/operators/expand.js', ['rxjs/util/tryCatch.js', 'rxjs/util/errorObject.js', 'rxjs/OuterSubscriber.js', 'rxjs/util/subscribeToResult.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var tryCatch_1 = $__require('rxjs/util/tryCatch.js');
    var errorObject_1 = $__require('rxjs/util/errorObject.js');
    var OuterSubscriber_1 = $__require('rxjs/OuterSubscriber.js');
    var subscribeToResult_1 = $__require('rxjs/util/subscribeToResult.js');
    /* tslint:enable:max-line-length */
    /**
     * Recursively projects each source value to an Observable which is merged in
     * the output Observable.
     *
     * <span class="informal">It's similar to {@link mergeMap}, but applies the
     * projection function to every source value as well as every output value.
     * It's recursive.</span>
     *
     * <img src="./img/expand.png" width="100%">
     *
     * Returns an Observable that emits items based on applying a function that you
     * supply to each item emitted by the source Observable, where that function
     * returns an Observable, and then merging those resulting Observables and
     * emitting the results of this merger. *Expand* will re-emit on the output
     * Observable every source value. Then, each output value is given to the
     * `project` function which returns an inner Observable to be merged on the
     * output Observable. Those output values resulting from the projection are also
     * given to the `project` function to produce new output values. This is how
     * *expand* behaves recursively.
     *
     * @example <caption>Start emitting the powers of two on every click, at most 10 of them</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var powersOfTwo = clicks
     *   .mapTo(1)
     *   .expand(x => Rx.Observable.of(2 * x).delay(1000))
     *   .take(10);
     * powersOfTwo.subscribe(x => console.log(x));
     *
     * @see {@link mergeMap}
     * @see {@link mergeScan}
     *
     * @param {function(value: T, index: number) => Observable} project A function
     * that, when applied to an item emitted by the source or the output Observable,
     * returns an Observable.
     * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
     * Observables being subscribed to concurrently.
     * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
     * each projected inner Observable.
     * @return {Observable} An Observable that emits the source values and also
     * result of applying the projection function to each value emitted on the
     * output Observable and and merging the results of the Observables obtained
     * from this transformation.
     * @method expand
     * @owner Observable
     */
    function expand(project, concurrent, scheduler) {
        if (concurrent === void 0) {
            concurrent = Number.POSITIVE_INFINITY;
        }
        if (scheduler === void 0) {
            scheduler = undefined;
        }
        concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
        return function (source) {
            return source.lift(new ExpandOperator(project, concurrent, scheduler));
        };
    }
    exports.expand = expand;
    var ExpandOperator = function () {
        function ExpandOperator(project, concurrent, scheduler) {
            this.project = project;
            this.concurrent = concurrent;
            this.scheduler = scheduler;
        }
        ExpandOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new ExpandSubscriber(subscriber, this.project, this.concurrent, this.scheduler));
        };
        return ExpandOperator;
    }();
    exports.ExpandOperator = ExpandOperator;
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var ExpandSubscriber = function (_super) {
        __extends(ExpandSubscriber, _super);
        function ExpandSubscriber(destination, project, concurrent, scheduler) {
            _super.call(this, destination);
            this.project = project;
            this.concurrent = concurrent;
            this.scheduler = scheduler;
            this.index = 0;
            this.active = 0;
            this.hasCompleted = false;
            if (concurrent < Number.POSITIVE_INFINITY) {
                this.buffer = [];
            }
        }
        ExpandSubscriber.dispatch = function (arg) {
            var subscriber = arg.subscriber,
                result = arg.result,
                value = arg.value,
                index = arg.index;
            subscriber.subscribeToProjection(result, value, index);
        };
        ExpandSubscriber.prototype._next = function (value) {
            var destination = this.destination;
            if (destination.closed) {
                this._complete();
                return;
            }
            var index = this.index++;
            if (this.active < this.concurrent) {
                destination.next(value);
                var result = tryCatch_1.tryCatch(this.project)(value, index);
                if (result === errorObject_1.errorObject) {
                    destination.error(errorObject_1.errorObject.e);
                } else if (!this.scheduler) {
                    this.subscribeToProjection(result, value, index);
                } else {
                    var state = { subscriber: this, result: result, value: value, index: index };
                    this.add(this.scheduler.schedule(ExpandSubscriber.dispatch, 0, state));
                }
            } else {
                this.buffer.push(value);
            }
        };
        ExpandSubscriber.prototype.subscribeToProjection = function (result, value, index) {
            this.active++;
            this.add(subscribeToResult_1.subscribeToResult(this, result, value, index));
        };
        ExpandSubscriber.prototype._complete = function () {
            this.hasCompleted = true;
            if (this.hasCompleted && this.active === 0) {
                this.destination.complete();
            }
        };
        ExpandSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this._next(innerValue);
        };
        ExpandSubscriber.prototype.notifyComplete = function (innerSub) {
            var buffer = this.buffer;
            this.remove(innerSub);
            this.active--;
            if (buffer && buffer.length > 0) {
                this._next(buffer.shift());
            }
            if (this.hasCompleted && this.active === 0) {
                this.destination.complete();
            }
        };
        return ExpandSubscriber;
    }(OuterSubscriber_1.OuterSubscriber);
    exports.ExpandSubscriber = ExpandSubscriber;
    
});
System.registerDynamic('rxjs/operators/finalize.js', ['rxjs/Subscriber.js', 'rxjs/Subscription.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require('rxjs/Subscriber.js');
    var Subscription_1 = $__require('rxjs/Subscription.js');
    /**
     * Returns an Observable that mirrors the source Observable, but will call a specified function when
     * the source terminates on complete or error.
     * @param {function} callback Function to be called when source terminates.
     * @return {Observable} An Observable that mirrors the source, but will call the specified function on termination.
     * @method finally
     * @owner Observable
     */
    function finalize(callback) {
        return function (source) {
            return source.lift(new FinallyOperator(callback));
        };
    }
    exports.finalize = finalize;
    var FinallyOperator = function () {
        function FinallyOperator(callback) {
            this.callback = callback;
        }
        FinallyOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new FinallySubscriber(subscriber, this.callback));
        };
        return FinallyOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var FinallySubscriber = function (_super) {
        __extends(FinallySubscriber, _super);
        function FinallySubscriber(destination, callback) {
            _super.call(this, destination);
            this.add(new Subscription_1.Subscription(callback));
        }
        return FinallySubscriber;
    }(Subscriber_1.Subscriber);
    
});
System.registerDynamic('rxjs/operators/find.js', ['rxjs/Subscriber.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require('rxjs/Subscriber.js');
    /**
     * Emits only the first value emitted by the source Observable that meets some
     * condition.
     *
     * <span class="informal">Finds the first value that passes some test and emits
     * that.</span>
     *
     * <img src="./img/find.png" width="100%">
     *
     * `find` searches for the first item in the source Observable that matches the
     * specified condition embodied by the `predicate`, and returns the first
     * occurrence in the source. Unlike {@link first}, the `predicate` is required
     * in `find`, and does not emit an error if a valid value is not found.
     *
     * @example <caption>Find and emit the first click that happens on a DIV element</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var result = clicks.find(ev => ev.target.tagName === 'DIV');
     * result.subscribe(x => console.log(x));
     *
     * @see {@link filter}
     * @see {@link first}
     * @see {@link findIndex}
     * @see {@link take}
     *
     * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
     * A function called with each item to test for condition matching.
     * @param {any} [thisArg] An optional argument to determine the value of `this`
     * in the `predicate` function.
     * @return {Observable<T>} An Observable of the first item that matches the
     * condition.
     * @method find
     * @owner Observable
     */
    function find(predicate, thisArg) {
        if (typeof predicate !== 'function') {
            throw new TypeError('predicate is not a function');
        }
        return function (source) {
            return source.lift(new FindValueOperator(predicate, source, false, thisArg));
        };
    }
    exports.find = find;
    var FindValueOperator = function () {
        function FindValueOperator(predicate, source, yieldIndex, thisArg) {
            this.predicate = predicate;
            this.source = source;
            this.yieldIndex = yieldIndex;
            this.thisArg = thisArg;
        }
        FindValueOperator.prototype.call = function (observer, source) {
            return source.subscribe(new FindValueSubscriber(observer, this.predicate, this.source, this.yieldIndex, this.thisArg));
        };
        return FindValueOperator;
    }();
    exports.FindValueOperator = FindValueOperator;
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var FindValueSubscriber = function (_super) {
        __extends(FindValueSubscriber, _super);
        function FindValueSubscriber(destination, predicate, source, yieldIndex, thisArg) {
            _super.call(this, destination);
            this.predicate = predicate;
            this.source = source;
            this.yieldIndex = yieldIndex;
            this.thisArg = thisArg;
            this.index = 0;
        }
        FindValueSubscriber.prototype.notifyComplete = function (value) {
            var destination = this.destination;
            destination.next(value);
            destination.complete();
        };
        FindValueSubscriber.prototype._next = function (value) {
            var _a = this,
                predicate = _a.predicate,
                thisArg = _a.thisArg;
            var index = this.index++;
            try {
                var result = predicate.call(thisArg || this, value, index, this.source);
                if (result) {
                    this.notifyComplete(this.yieldIndex ? index : value);
                }
            } catch (err) {
                this.destination.error(err);
            }
        };
        FindValueSubscriber.prototype._complete = function () {
            this.notifyComplete(this.yieldIndex ? -1 : undefined);
        };
        return FindValueSubscriber;
    }(Subscriber_1.Subscriber);
    exports.FindValueSubscriber = FindValueSubscriber;
    
});
System.registerDynamic("rxjs/operators/findIndex.js", ["rxjs/operators/find.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var find_1 = $__require("rxjs/operators/find.js");
  /**
   * Emits only the index of the first value emitted by the source Observable that
   * meets some condition.
   *
   * <span class="informal">It's like {@link find}, but emits the index of the
   * found value, not the value itself.</span>
   *
   * <img src="./img/findIndex.png" width="100%">
   *
   * `findIndex` searches for the first item in the source Observable that matches
   * the specified condition embodied by the `predicate`, and returns the
   * (zero-based) index of the first occurrence in the source. Unlike
   * {@link first}, the `predicate` is required in `findIndex`, and does not emit
   * an error if a valid value is not found.
   *
   * @example <caption>Emit the index of first click that happens on a DIV element</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var result = clicks.findIndex(ev => ev.target.tagName === 'DIV');
   * result.subscribe(x => console.log(x));
   *
   * @see {@link filter}
   * @see {@link find}
   * @see {@link first}
   * @see {@link take}
   *
   * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
   * A function called with each item to test for condition matching.
   * @param {any} [thisArg] An optional argument to determine the value of `this`
   * in the `predicate` function.
   * @return {Observable} An Observable of the index of the first item that
   * matches the condition.
   * @method find
   * @owner Observable
   */
  function findIndex(predicate, thisArg) {
    return function (source) {
      return source.lift(new find_1.FindValueOperator(predicate, source, true, thisArg));
    };
  }
  exports.findIndex = findIndex;
  
});
System.registerDynamic('rxjs/operators/first.js', ['rxjs/Subscriber.js', 'rxjs/util/EmptyError.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require('rxjs/Subscriber.js');
    var EmptyError_1 = $__require('rxjs/util/EmptyError.js');
    /**
     * Emits only the first value (or the first value that meets some condition)
     * emitted by the source Observable.
     *
     * <span class="informal">Emits only the first value. Or emits only the first
     * value that passes some test.</span>
     *
     * <img src="./img/first.png" width="100%">
     *
     * If called with no arguments, `first` emits the first value of the source
     * Observable, then completes. If called with a `predicate` function, `first`
     * emits the first value of the source that matches the specified condition. It
     * may also take a `resultSelector` function to produce the output value from
     * the input value, and a `defaultValue` to emit in case the source completes
     * before it is able to emit a valid value. Throws an error if `defaultValue`
     * was not provided and a matching element is not found.
     *
     * @example <caption>Emit only the first click that happens on the DOM</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var result = clicks.first();
     * result.subscribe(x => console.log(x));
     *
     * @example <caption>Emits the first click that happens on a DIV</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var result = clicks.first(ev => ev.target.tagName === 'DIV');
     * result.subscribe(x => console.log(x));
     *
     * @see {@link filter}
     * @see {@link find}
     * @see {@link take}
     *
     * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
     * callback if the Observable completes before any `next` notification was sent.
     *
     * @param {function(value: T, index: number, source: Observable<T>): boolean} [predicate]
     * An optional function called with each item to test for condition matching.
     * @param {function(value: T, index: number): R} [resultSelector] A function to
     * produce the value on the output Observable based on the values
     * and the indices of the source Observable. The arguments passed to this
     * function are:
     * - `value`: the value that was emitted on the source.
     * - `index`: the "index" of the value from the source.
     * @param {R} [defaultValue] The default value emitted in case no valid value
     * was found on the source.
     * @return {Observable<T|R>} An Observable of the first item that matches the
     * condition.
     * @method first
     * @owner Observable
     */
    function first(predicate, resultSelector, defaultValue) {
        return function (source) {
            return source.lift(new FirstOperator(predicate, resultSelector, defaultValue, source));
        };
    }
    exports.first = first;
    var FirstOperator = function () {
        function FirstOperator(predicate, resultSelector, defaultValue, source) {
            this.predicate = predicate;
            this.resultSelector = resultSelector;
            this.defaultValue = defaultValue;
            this.source = source;
        }
        FirstOperator.prototype.call = function (observer, source) {
            return source.subscribe(new FirstSubscriber(observer, this.predicate, this.resultSelector, this.defaultValue, this.source));
        };
        return FirstOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var FirstSubscriber = function (_super) {
        __extends(FirstSubscriber, _super);
        function FirstSubscriber(destination, predicate, resultSelector, defaultValue, source) {
            _super.call(this, destination);
            this.predicate = predicate;
            this.resultSelector = resultSelector;
            this.defaultValue = defaultValue;
            this.source = source;
            this.index = 0;
            this.hasCompleted = false;
            this._emitted = false;
        }
        FirstSubscriber.prototype._next = function (value) {
            var index = this.index++;
            if (this.predicate) {
                this._tryPredicate(value, index);
            } else {
                this._emit(value, index);
            }
        };
        FirstSubscriber.prototype._tryPredicate = function (value, index) {
            var result;
            try {
                result = this.predicate(value, index, this.source);
            } catch (err) {
                this.destination.error(err);
                return;
            }
            if (result) {
                this._emit(value, index);
            }
        };
        FirstSubscriber.prototype._emit = function (value, index) {
            if (this.resultSelector) {
                this._tryResultSelector(value, index);
                return;
            }
            this._emitFinal(value);
        };
        FirstSubscriber.prototype._tryResultSelector = function (value, index) {
            var result;
            try {
                result = this.resultSelector(value, index);
            } catch (err) {
                this.destination.error(err);
                return;
            }
            this._emitFinal(result);
        };
        FirstSubscriber.prototype._emitFinal = function (value) {
            var destination = this.destination;
            if (!this._emitted) {
                this._emitted = true;
                destination.next(value);
                destination.complete();
                this.hasCompleted = true;
            }
        };
        FirstSubscriber.prototype._complete = function () {
            var destination = this.destination;
            if (!this.hasCompleted && typeof this.defaultValue !== 'undefined') {
                destination.next(this.defaultValue);
                destination.complete();
            } else if (!this.hasCompleted) {
                destination.error(new EmptyError_1.EmptyError());
            }
        };
        return FirstSubscriber;
    }(Subscriber_1.Subscriber);
    
});
System.registerDynamic("rxjs/util/MapPolyfill.js", [], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var MapPolyfill = function () {
        function MapPolyfill() {
            this.size = 0;
            this._values = [];
            this._keys = [];
        }
        MapPolyfill.prototype.get = function (key) {
            var i = this._keys.indexOf(key);
            return i === -1 ? undefined : this._values[i];
        };
        MapPolyfill.prototype.set = function (key, value) {
            var i = this._keys.indexOf(key);
            if (i === -1) {
                this._keys.push(key);
                this._values.push(value);
                this.size++;
            } else {
                this._values[i] = value;
            }
            return this;
        };
        MapPolyfill.prototype.delete = function (key) {
            var i = this._keys.indexOf(key);
            if (i === -1) {
                return false;
            }
            this._values.splice(i, 1);
            this._keys.splice(i, 1);
            this.size--;
            return true;
        };
        MapPolyfill.prototype.clear = function () {
            this._keys.length = 0;
            this._values.length = 0;
            this.size = 0;
        };
        MapPolyfill.prototype.forEach = function (cb, thisArg) {
            for (var i = 0; i < this.size; i++) {
                cb.call(thisArg, this._values[i], this._keys[i]);
            }
        };
        return MapPolyfill;
    }();
    exports.MapPolyfill = MapPolyfill;
    
});
System.registerDynamic('rxjs/util/Map.js', ['rxjs/util/root.js', 'rxjs/util/MapPolyfill.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var root_1 = $__require('rxjs/util/root.js');
  var MapPolyfill_1 = $__require('rxjs/util/MapPolyfill.js');
  exports.Map = root_1.root.Map || function () {
    return MapPolyfill_1.MapPolyfill;
  }();
  
});
System.registerDynamic("rxjs/util/FastMap.js", [], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var FastMap = function () {
        function FastMap() {
            this.values = {};
        }
        FastMap.prototype.delete = function (key) {
            this.values[key] = null;
            return true;
        };
        FastMap.prototype.set = function (key, value) {
            this.values[key] = value;
            return this;
        };
        FastMap.prototype.get = function (key) {
            return this.values[key];
        };
        FastMap.prototype.forEach = function (cb, thisArg) {
            var values = this.values;
            for (var key in values) {
                if (values.hasOwnProperty(key) && values[key] !== null) {
                    cb.call(thisArg, values[key], key);
                }
            }
        };
        FastMap.prototype.clear = function () {
            this.values = {};
        };
        return FastMap;
    }();
    exports.FastMap = FastMap;
    
});
System.registerDynamic('rxjs/operators/groupBy.js', ['rxjs/Subscriber.js', 'rxjs/Subscription.js', 'rxjs/Observable.js', 'rxjs/Subject.js', 'rxjs/util/Map.js', 'rxjs/util/FastMap.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require('rxjs/Subscriber.js');
    var Subscription_1 = $__require('rxjs/Subscription.js');
    var Observable_1 = $__require('rxjs/Observable.js');
    var Subject_1 = $__require('rxjs/Subject.js');
    var Map_1 = $__require('rxjs/util/Map.js');
    var FastMap_1 = $__require('rxjs/util/FastMap.js');
    /* tslint:enable:max-line-length */
    /**
     * Groups the items emitted by an Observable according to a specified criterion,
     * and emits these grouped items as `GroupedObservables`, one
     * {@link GroupedObservable} per group.
     *
     * <img src="./img/groupBy.png" width="100%">
     *
     * @example <caption>Group objects by id and return as array</caption>
     * Observable.of<Obj>({id: 1, name: 'aze1'},
     *                    {id: 2, name: 'sf2'},
     *                    {id: 2, name: 'dg2'},
     *                    {id: 1, name: 'erg1'},
     *                    {id: 1, name: 'df1'},
     *                    {id: 2, name: 'sfqfb2'},
     *                    {id: 3, name: 'qfs3'},
     *                    {id: 2, name: 'qsgqsfg2'}
     *     )
     *     .groupBy(p => p.id)
     *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], []))
     *     .subscribe(p => console.log(p));
     *
     * // displays:
     * // [ { id: 1, name: 'aze1' },
     * //   { id: 1, name: 'erg1' },
     * //   { id: 1, name: 'df1' } ]
     * //
     * // [ { id: 2, name: 'sf2' },
     * //   { id: 2, name: 'dg2' },
     * //   { id: 2, name: 'sfqfb2' },
     * //   { id: 2, name: 'qsgqsfg2' } ]
     * //
     * // [ { id: 3, name: 'qfs3' } ]
     *
     * @example <caption>Pivot data on the id field</caption>
     * Observable.of<Obj>({id: 1, name: 'aze1'},
     *                    {id: 2, name: 'sf2'},
     *                    {id: 2, name: 'dg2'},
     *                    {id: 1, name: 'erg1'},
     *                    {id: 1, name: 'df1'},
     *                    {id: 2, name: 'sfqfb2'},
     *                    {id: 3, name: 'qfs1'},
     *                    {id: 2, name: 'qsgqsfg2'}
     *                   )
     *     .groupBy(p => p.id, p => p.name)
     *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], ["" + group$.key]))
     *     .map(arr => ({'id': parseInt(arr[0]), 'values': arr.slice(1)}))
     *     .subscribe(p => console.log(p));
     *
     * // displays:
     * // { id: 1, values: [ 'aze1', 'erg1', 'df1' ] }
     * // { id: 2, values: [ 'sf2', 'dg2', 'sfqfb2', 'qsgqsfg2' ] }
     * // { id: 3, values: [ 'qfs1' ] }
     *
     * @param {function(value: T): K} keySelector A function that extracts the key
     * for each item.
     * @param {function(value: T): R} [elementSelector] A function that extracts the
     * return element for each item.
     * @param {function(grouped: GroupedObservable<K,R>): Observable<any>} [durationSelector]
     * A function that returns an Observable to determine how long each group should
     * exist.
     * @return {Observable<GroupedObservable<K,R>>} An Observable that emits
     * GroupedObservables, each of which corresponds to a unique key value and each
     * of which emits those items from the source Observable that share that key
     * value.
     * @method groupBy
     * @owner Observable
     */
    function groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
        return function (source) {
            return source.lift(new GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector));
        };
    }
    exports.groupBy = groupBy;
    var GroupByOperator = function () {
        function GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector) {
            this.keySelector = keySelector;
            this.elementSelector = elementSelector;
            this.durationSelector = durationSelector;
            this.subjectSelector = subjectSelector;
        }
        GroupByOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new GroupBySubscriber(subscriber, this.keySelector, this.elementSelector, this.durationSelector, this.subjectSelector));
        };
        return GroupByOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var GroupBySubscriber = function (_super) {
        __extends(GroupBySubscriber, _super);
        function GroupBySubscriber(destination, keySelector, elementSelector, durationSelector, subjectSelector) {
            _super.call(this, destination);
            this.keySelector = keySelector;
            this.elementSelector = elementSelector;
            this.durationSelector = durationSelector;
            this.subjectSelector = subjectSelector;
            this.groups = null;
            this.attemptedToUnsubscribe = false;
            this.count = 0;
        }
        GroupBySubscriber.prototype._next = function (value) {
            var key;
            try {
                key = this.keySelector(value);
            } catch (err) {
                this.error(err);
                return;
            }
            this._group(value, key);
        };
        GroupBySubscriber.prototype._group = function (value, key) {
            var groups = this.groups;
            if (!groups) {
                groups = this.groups = typeof key === 'string' ? new FastMap_1.FastMap() : new Map_1.Map();
            }
            var group = groups.get(key);
            var element;
            if (this.elementSelector) {
                try {
                    element = this.elementSelector(value);
                } catch (err) {
                    this.error(err);
                }
            } else {
                element = value;
            }
            if (!group) {
                group = this.subjectSelector ? this.subjectSelector() : new Subject_1.Subject();
                groups.set(key, group);
                var groupedObservable = new GroupedObservable(key, group, this);
                this.destination.next(groupedObservable);
                if (this.durationSelector) {
                    var duration = void 0;
                    try {
                        duration = this.durationSelector(new GroupedObservable(key, group));
                    } catch (err) {
                        this.error(err);
                        return;
                    }
                    this.add(duration.subscribe(new GroupDurationSubscriber(key, group, this)));
                }
            }
            if (!group.closed) {
                group.next(element);
            }
        };
        GroupBySubscriber.prototype._error = function (err) {
            var groups = this.groups;
            if (groups) {
                groups.forEach(function (group, key) {
                    group.error(err);
                });
                groups.clear();
            }
            this.destination.error(err);
        };
        GroupBySubscriber.prototype._complete = function () {
            var groups = this.groups;
            if (groups) {
                groups.forEach(function (group, key) {
                    group.complete();
                });
                groups.clear();
            }
            this.destination.complete();
        };
        GroupBySubscriber.prototype.removeGroup = function (key) {
            this.groups.delete(key);
        };
        GroupBySubscriber.prototype.unsubscribe = function () {
            if (!this.closed) {
                this.attemptedToUnsubscribe = true;
                if (this.count === 0) {
                    _super.prototype.unsubscribe.call(this);
                }
            }
        };
        return GroupBySubscriber;
    }(Subscriber_1.Subscriber);
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var GroupDurationSubscriber = function (_super) {
        __extends(GroupDurationSubscriber, _super);
        function GroupDurationSubscriber(key, group, parent) {
            _super.call(this, group);
            this.key = key;
            this.group = group;
            this.parent = parent;
        }
        GroupDurationSubscriber.prototype._next = function (value) {
            this.complete();
        };
        /** @deprecated internal use only */GroupDurationSubscriber.prototype._unsubscribe = function () {
            var _a = this,
                parent = _a.parent,
                key = _a.key;
            this.key = this.parent = null;
            if (parent) {
                parent.removeGroup(key);
            }
        };
        return GroupDurationSubscriber;
    }(Subscriber_1.Subscriber);
    /**
     * An Observable representing values belonging to the same group represented by
     * a common key. The values emitted by a GroupedObservable come from the source
     * Observable. The common key is available as the field `key` on a
     * GroupedObservable instance.
     *
     * @class GroupedObservable<K, T>
     */
    var GroupedObservable = function (_super) {
        __extends(GroupedObservable, _super);
        function GroupedObservable(key, groupSubject, refCountSubscription) {
            _super.call(this);
            this.key = key;
            this.groupSubject = groupSubject;
            this.refCountSubscription = refCountSubscription;
        }
        /** @deprecated internal use only */GroupedObservable.prototype._subscribe = function (subscriber) {
            var subscription = new Subscription_1.Subscription();
            var _a = this,
                refCountSubscription = _a.refCountSubscription,
                groupSubject = _a.groupSubject;
            if (refCountSubscription && !refCountSubscription.closed) {
                subscription.add(new InnerRefCountSubscription(refCountSubscription));
            }
            subscription.add(groupSubject.subscribe(subscriber));
            return subscription;
        };
        return GroupedObservable;
    }(Observable_1.Observable);
    exports.GroupedObservable = GroupedObservable;
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var InnerRefCountSubscription = function (_super) {
        __extends(InnerRefCountSubscription, _super);
        function InnerRefCountSubscription(parent) {
            _super.call(this);
            this.parent = parent;
            parent.count++;
        }
        InnerRefCountSubscription.prototype.unsubscribe = function () {
            var parent = this.parent;
            if (!parent.closed && !this.closed) {
                _super.prototype.unsubscribe.call(this);
                parent.count -= 1;
                if (parent.count === 0 && parent.attemptedToUnsubscribe) {
                    parent.unsubscribe();
                }
            }
        };
        return InnerRefCountSubscription;
    }(Subscription_1.Subscription);
    
});
System.registerDynamic('rxjs/operators/ignoreElements.js', ['rxjs/Subscriber.js', 'rxjs/util/noop.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require('rxjs/Subscriber.js');
    var noop_1 = $__require('rxjs/util/noop.js');
    /**
     * Ignores all items emitted by the source Observable and only passes calls of `complete` or `error`.
     *
     * <img src="./img/ignoreElements.png" width="100%">
     *
     * @return {Observable} An empty Observable that only calls `complete`
     * or `error`, based on which one is called by the source Observable.
     * @method ignoreElements
     * @owner Observable
     */
    function ignoreElements() {
        return function ignoreElementsOperatorFunction(source) {
            return source.lift(new IgnoreElementsOperator());
        };
    }
    exports.ignoreElements = ignoreElements;
    var IgnoreElementsOperator = function () {
        function IgnoreElementsOperator() {}
        IgnoreElementsOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new IgnoreElementsSubscriber(subscriber));
        };
        return IgnoreElementsOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var IgnoreElementsSubscriber = function (_super) {
        __extends(IgnoreElementsSubscriber, _super);
        function IgnoreElementsSubscriber() {
            _super.apply(this, arguments);
        }
        IgnoreElementsSubscriber.prototype._next = function (unused) {
            noop_1.noop();
        };
        return IgnoreElementsSubscriber;
    }(Subscriber_1.Subscriber);
    
});
System.registerDynamic("rxjs/operators/isEmpty.js", ["rxjs/Subscriber.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require("rxjs/Subscriber.js");
    function isEmpty() {
        return function (source) {
            return source.lift(new IsEmptyOperator());
        };
    }
    exports.isEmpty = isEmpty;
    var IsEmptyOperator = function () {
        function IsEmptyOperator() {}
        IsEmptyOperator.prototype.call = function (observer, source) {
            return source.subscribe(new IsEmptySubscriber(observer));
        };
        return IsEmptyOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var IsEmptySubscriber = function (_super) {
        __extends(IsEmptySubscriber, _super);
        function IsEmptySubscriber(destination) {
            _super.call(this, destination);
        }
        IsEmptySubscriber.prototype.notifyComplete = function (isEmpty) {
            var destination = this.destination;
            destination.next(isEmpty);
            destination.complete();
        };
        IsEmptySubscriber.prototype._next = function (value) {
            this.notifyComplete(false);
        };
        IsEmptySubscriber.prototype._complete = function () {
            this.notifyComplete(true);
        };
        return IsEmptySubscriber;
    }(Subscriber_1.Subscriber);
    
});
System.registerDynamic('rxjs/operators/last.js', ['rxjs/Subscriber.js', 'rxjs/util/EmptyError.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require('rxjs/Subscriber.js');
    var EmptyError_1 = $__require('rxjs/util/EmptyError.js');
    /* tslint:enable:max-line-length */
    /**
     * Returns an Observable that emits only the last item emitted by the source Observable.
     * It optionally takes a predicate function as a parameter, in which case, rather than emitting
     * the last item from the source Observable, the resulting Observable will emit the last item
     * from the source Observable that satisfies the predicate.
     *
     * <img src="./img/last.png" width="100%">
     *
     * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
     * callback if the Observable completes before any `next` notification was sent.
     * @param {function} predicate - The condition any source emitted item has to satisfy.
     * @return {Observable} An Observable that emits only the last item satisfying the given condition
     * from the source, or an NoSuchElementException if no such items are emitted.
     * @throws - Throws if no items that match the predicate are emitted by the source Observable.
     * @method last
     * @owner Observable
     */
    function last(predicate, resultSelector, defaultValue) {
        return function (source) {
            return source.lift(new LastOperator(predicate, resultSelector, defaultValue, source));
        };
    }
    exports.last = last;
    var LastOperator = function () {
        function LastOperator(predicate, resultSelector, defaultValue, source) {
            this.predicate = predicate;
            this.resultSelector = resultSelector;
            this.defaultValue = defaultValue;
            this.source = source;
        }
        LastOperator.prototype.call = function (observer, source) {
            return source.subscribe(new LastSubscriber(observer, this.predicate, this.resultSelector, this.defaultValue, this.source));
        };
        return LastOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var LastSubscriber = function (_super) {
        __extends(LastSubscriber, _super);
        function LastSubscriber(destination, predicate, resultSelector, defaultValue, source) {
            _super.call(this, destination);
            this.predicate = predicate;
            this.resultSelector = resultSelector;
            this.defaultValue = defaultValue;
            this.source = source;
            this.hasValue = false;
            this.index = 0;
            if (typeof defaultValue !== 'undefined') {
                this.lastValue = defaultValue;
                this.hasValue = true;
            }
        }
        LastSubscriber.prototype._next = function (value) {
            var index = this.index++;
            if (this.predicate) {
                this._tryPredicate(value, index);
            } else {
                if (this.resultSelector) {
                    this._tryResultSelector(value, index);
                    return;
                }
                this.lastValue = value;
                this.hasValue = true;
            }
        };
        LastSubscriber.prototype._tryPredicate = function (value, index) {
            var result;
            try {
                result = this.predicate(value, index, this.source);
            } catch (err) {
                this.destination.error(err);
                return;
            }
            if (result) {
                if (this.resultSelector) {
                    this._tryResultSelector(value, index);
                    return;
                }
                this.lastValue = value;
                this.hasValue = true;
            }
        };
        LastSubscriber.prototype._tryResultSelector = function (value, index) {
            var result;
            try {
                result = this.resultSelector(value, index);
            } catch (err) {
                this.destination.error(err);
                return;
            }
            this.lastValue = result;
            this.hasValue = true;
        };
        LastSubscriber.prototype._complete = function () {
            var destination = this.destination;
            if (this.hasValue) {
                destination.next(this.lastValue);
                destination.complete();
            } else {
                destination.error(new EmptyError_1.EmptyError());
            }
        };
        return LastSubscriber;
    }(Subscriber_1.Subscriber);
    
});
System.registerDynamic("rxjs/operators/mapTo.js", ["rxjs/Subscriber.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require("rxjs/Subscriber.js");
    /**
     * Emits the given constant value on the output Observable every time the source
     * Observable emits a value.
     *
     * <span class="informal">Like {@link map}, but it maps every source value to
     * the same output value every time.</span>
     *
     * <img src="./img/mapTo.png" width="100%">
     *
     * Takes a constant `value` as argument, and emits that whenever the source
     * Observable emits a value. In other words, ignores the actual source value,
     * and simply uses the emission moment to know when to emit the given `value`.
     *
     * @example <caption>Map every click to the string 'Hi'</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var greetings = clicks.mapTo('Hi');
     * greetings.subscribe(x => console.log(x));
     *
     * @see {@link map}
     *
     * @param {any} value The value to map each source value to.
     * @return {Observable} An Observable that emits the given `value` every time
     * the source Observable emits something.
     * @method mapTo
     * @owner Observable
     */
    function mapTo(value) {
        return function (source) {
            return source.lift(new MapToOperator(value));
        };
    }
    exports.mapTo = mapTo;
    var MapToOperator = function () {
        function MapToOperator(value) {
            this.value = value;
        }
        MapToOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new MapToSubscriber(subscriber, this.value));
        };
        return MapToOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var MapToSubscriber = function (_super) {
        __extends(MapToSubscriber, _super);
        function MapToSubscriber(destination, value) {
            _super.call(this, destination);
            this.value = value;
        }
        MapToSubscriber.prototype._next = function (x) {
            this.destination.next(this.value);
        };
        return MapToSubscriber;
    }(Subscriber_1.Subscriber);
    
});
System.registerDynamic('rxjs/operators/materialize.js', ['rxjs/Subscriber.js', 'rxjs/Notification.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require('rxjs/Subscriber.js');
    var Notification_1 = $__require('rxjs/Notification.js');
    /**
     * Represents all of the notifications from the source Observable as `next`
     * emissions marked with their original types within {@link Notification}
     * objects.
     *
     * <span class="informal">Wraps `next`, `error` and `complete` emissions in
     * {@link Notification} objects, emitted as `next` on the output Observable.
     * </span>
     *
     * <img src="./img/materialize.png" width="100%">
     *
     * `materialize` returns an Observable that emits a `next` notification for each
     * `next`, `error`, or `complete` emission of the source Observable. When the
     * source Observable emits `complete`, the output Observable will emit `next` as
     * a Notification of type "complete", and then it will emit `complete` as well.
     * When the source Observable emits `error`, the output will emit `next` as a
     * Notification of type "error", and then `complete`.
     *
     * This operator is useful for producing metadata of the source Observable, to
     * be consumed as `next` emissions. Use it in conjunction with
     * {@link dematerialize}.
     *
     * @example <caption>Convert a faulty Observable to an Observable of Notifications</caption>
     * var letters = Rx.Observable.of('a', 'b', 13, 'd');
     * var upperCase = letters.map(x => x.toUpperCase());
     * var materialized = upperCase.materialize();
     * materialized.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // - Notification {kind: "N", value: "A", error: undefined, hasValue: true}
     * // - Notification {kind: "N", value: "B", error: undefined, hasValue: true}
     * // - Notification {kind: "E", value: undefined, error: TypeError:
     * //   x.toUpperCase is not a function at MapSubscriber.letters.map.x
     * //   [as project] (http://1…, hasValue: false}
     *
     * @see {@link Notification}
     * @see {@link dematerialize}
     *
     * @return {Observable<Notification<T>>} An Observable that emits
     * {@link Notification} objects that wrap the original emissions from the source
     * Observable with metadata.
     * @method materialize
     * @owner Observable
     */
    function materialize() {
        return function materializeOperatorFunction(source) {
            return source.lift(new MaterializeOperator());
        };
    }
    exports.materialize = materialize;
    var MaterializeOperator = function () {
        function MaterializeOperator() {}
        MaterializeOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new MaterializeSubscriber(subscriber));
        };
        return MaterializeOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var MaterializeSubscriber = function (_super) {
        __extends(MaterializeSubscriber, _super);
        function MaterializeSubscriber(destination) {
            _super.call(this, destination);
        }
        MaterializeSubscriber.prototype._next = function (value) {
            this.destination.next(Notification_1.Notification.createNext(value));
        };
        MaterializeSubscriber.prototype._error = function (err) {
            var destination = this.destination;
            destination.next(Notification_1.Notification.createError(err));
            destination.complete();
        };
        MaterializeSubscriber.prototype._complete = function () {
            var destination = this.destination;
            destination.next(Notification_1.Notification.createComplete());
            destination.complete();
        };
        return MaterializeSubscriber;
    }(Subscriber_1.Subscriber);
    
});
System.registerDynamic('rxjs/operators/max.js', ['rxjs/operators/reduce.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var reduce_1 = $__require('rxjs/operators/reduce.js');
    /**
     * The Max operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
     * and when source Observable completes it emits a single item: the item with the largest value.
     *
     * <img src="./img/max.png" width="100%">
     *
     * @example <caption>Get the maximal value of a series of numbers</caption>
     * Rx.Observable.of(5, 4, 7, 2, 8)
     *   .max()
     *   .subscribe(x => console.log(x)); // -> 8
     *
     * @example <caption>Use a comparer function to get the maximal item</caption>
     * interface Person {
     *   age: number,
     *   name: string
     * }
     * Observable.of<Person>({age: 7, name: 'Foo'},
     *                       {age: 5, name: 'Bar'},
     *                       {age: 9, name: 'Beer'})
     *           .max<Person>((a: Person, b: Person) => a.age < b.age ? -1 : 1)
     *           .subscribe((x: Person) => console.log(x.name)); // -> 'Beer'
     * }
     *
     * @see {@link min}
     *
     * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
     * value of two items.
     * @return {Observable} An Observable that emits item with the largest value.
     * @method max
     * @owner Observable
     */
    function max(comparer) {
        var max = typeof comparer === 'function' ? function (x, y) {
            return comparer(x, y) > 0 ? x : y;
        } : function (x, y) {
            return x > y ? x : y;
        };
        return reduce_1.reduce(max);
    }
    exports.max = max;
    
});
System.registerDynamic('rxjs/operators/mergeMapTo.js', ['rxjs/OuterSubscriber.js', 'rxjs/util/subscribeToResult.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var OuterSubscriber_1 = $__require('rxjs/OuterSubscriber.js');
    var subscribeToResult_1 = $__require('rxjs/util/subscribeToResult.js');
    /* tslint:enable:max-line-length */
    /**
     * Projects each source value to the same Observable which is merged multiple
     * times in the output Observable.
     *
     * <span class="informal">It's like {@link mergeMap}, but maps each value always
     * to the same inner Observable.</span>
     *
     * <img src="./img/mergeMapTo.png" width="100%">
     *
     * Maps each source value to the given Observable `innerObservable` regardless
     * of the source value, and then merges those resulting Observables into one
     * single Observable, which is the output Observable.
     *
     * @example <caption>For each click event, start an interval Observable ticking every 1 second</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var result = clicks.mergeMapTo(Rx.Observable.interval(1000));
     * result.subscribe(x => console.log(x));
     *
     * @see {@link concatMapTo}
     * @see {@link merge}
     * @see {@link mergeAll}
     * @see {@link mergeMap}
     * @see {@link mergeScan}
     * @see {@link switchMapTo}
     *
     * @param {ObservableInput} innerObservable An Observable to replace each value from
     * the source Observable.
     * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
     * A function to produce the value on the output Observable based on the values
     * and the indices of the source (outer) emission and the inner Observable
     * emission. The arguments passed to this function are:
     * - `outerValue`: the value that came from the source
     * - `innerValue`: the value that came from the projected Observable
     * - `outerIndex`: the "index" of the value that came from the source
     * - `innerIndex`: the "index" of the value from the projected Observable
     * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
     * Observables being subscribed to concurrently.
     * @return {Observable} An Observable that emits items from the given
     * `innerObservable` (and optionally transformed through `resultSelector`) every
     * time a value is emitted on the source Observable.
     * @method mergeMapTo
     * @owner Observable
     */
    function mergeMapTo(innerObservable, resultSelector, concurrent) {
        if (concurrent === void 0) {
            concurrent = Number.POSITIVE_INFINITY;
        }
        if (typeof resultSelector === 'number') {
            concurrent = resultSelector;
            resultSelector = null;
        }
        return function (source) {
            return source.lift(new MergeMapToOperator(innerObservable, resultSelector, concurrent));
        };
    }
    exports.mergeMapTo = mergeMapTo;
    // TODO: Figure out correct signature here: an Operator<Observable<T>, R>
    //       needs to implement call(observer: Subscriber<R>): Subscriber<Observable<T>>
    var MergeMapToOperator = function () {
        function MergeMapToOperator(ish, resultSelector, concurrent) {
            if (concurrent === void 0) {
                concurrent = Number.POSITIVE_INFINITY;
            }
            this.ish = ish;
            this.resultSelector = resultSelector;
            this.concurrent = concurrent;
        }
        MergeMapToOperator.prototype.call = function (observer, source) {
            return source.subscribe(new MergeMapToSubscriber(observer, this.ish, this.resultSelector, this.concurrent));
        };
        return MergeMapToOperator;
    }();
    exports.MergeMapToOperator = MergeMapToOperator;
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var MergeMapToSubscriber = function (_super) {
        __extends(MergeMapToSubscriber, _super);
        function MergeMapToSubscriber(destination, ish, resultSelector, concurrent) {
            if (concurrent === void 0) {
                concurrent = Number.POSITIVE_INFINITY;
            }
            _super.call(this, destination);
            this.ish = ish;
            this.resultSelector = resultSelector;
            this.concurrent = concurrent;
            this.hasCompleted = false;
            this.buffer = [];
            this.active = 0;
            this.index = 0;
        }
        MergeMapToSubscriber.prototype._next = function (value) {
            if (this.active < this.concurrent) {
                var resultSelector = this.resultSelector;
                var index = this.index++;
                var ish = this.ish;
                var destination = this.destination;
                this.active++;
                this._innerSub(ish, destination, resultSelector, value, index);
            } else {
                this.buffer.push(value);
            }
        };
        MergeMapToSubscriber.prototype._innerSub = function (ish, destination, resultSelector, value, index) {
            this.add(subscribeToResult_1.subscribeToResult(this, ish, value, index));
        };
        MergeMapToSubscriber.prototype._complete = function () {
            this.hasCompleted = true;
            if (this.active === 0 && this.buffer.length === 0) {
                this.destination.complete();
            }
        };
        MergeMapToSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            var _a = this,
                resultSelector = _a.resultSelector,
                destination = _a.destination;
            if (resultSelector) {
                this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
            } else {
                destination.next(innerValue);
            }
        };
        MergeMapToSubscriber.prototype.trySelectResult = function (outerValue, innerValue, outerIndex, innerIndex) {
            var _a = this,
                resultSelector = _a.resultSelector,
                destination = _a.destination;
            var result;
            try {
                result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
            } catch (err) {
                destination.error(err);
                return;
            }
            destination.next(result);
        };
        MergeMapToSubscriber.prototype.notifyError = function (err) {
            this.destination.error(err);
        };
        MergeMapToSubscriber.prototype.notifyComplete = function (innerSub) {
            var buffer = this.buffer;
            this.remove(innerSub);
            this.active--;
            if (buffer.length > 0) {
                this._next(buffer.shift());
            } else if (this.active === 0 && this.hasCompleted) {
                this.destination.complete();
            }
        };
        return MergeMapToSubscriber;
    }(OuterSubscriber_1.OuterSubscriber);
    exports.MergeMapToSubscriber = MergeMapToSubscriber;
    
});
System.registerDynamic('rxjs/operators/mergeScan.js', ['rxjs/util/tryCatch.js', 'rxjs/util/errorObject.js', 'rxjs/util/subscribeToResult.js', 'rxjs/OuterSubscriber.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var tryCatch_1 = $__require('rxjs/util/tryCatch.js');
    var errorObject_1 = $__require('rxjs/util/errorObject.js');
    var subscribeToResult_1 = $__require('rxjs/util/subscribeToResult.js');
    var OuterSubscriber_1 = $__require('rxjs/OuterSubscriber.js');
    /**
     * Applies an accumulator function over the source Observable where the
     * accumulator function itself returns an Observable, then each intermediate
     * Observable returned is merged into the output Observable.
     *
     * <span class="informal">It's like {@link scan}, but the Observables returned
     * by the accumulator are merged into the outer Observable.</span>
     *
     * @example <caption>Count the number of click events</caption>
     * const click$ = Rx.Observable.fromEvent(document, 'click');
     * const one$ = click$.mapTo(1);
     * const seed = 0;
     * const count$ = one$.mergeScan((acc, one) => Rx.Observable.of(acc + one), seed);
     * count$.subscribe(x => console.log(x));
     *
     * // Results:
     * 1
     * 2
     * 3
     * 4
     * // ...and so on for each click
     *
     * @param {function(acc: R, value: T): Observable<R>} accumulator
     * The accumulator function called on each source value.
     * @param seed The initial accumulation value.
     * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of
     * input Observables being subscribed to concurrently.
     * @return {Observable<R>} An observable of the accumulated values.
     * @method mergeScan
     * @owner Observable
     */
    function mergeScan(accumulator, seed, concurrent) {
        if (concurrent === void 0) {
            concurrent = Number.POSITIVE_INFINITY;
        }
        return function (source) {
            return source.lift(new MergeScanOperator(accumulator, seed, concurrent));
        };
    }
    exports.mergeScan = mergeScan;
    var MergeScanOperator = function () {
        function MergeScanOperator(accumulator, seed, concurrent) {
            this.accumulator = accumulator;
            this.seed = seed;
            this.concurrent = concurrent;
        }
        MergeScanOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new MergeScanSubscriber(subscriber, this.accumulator, this.seed, this.concurrent));
        };
        return MergeScanOperator;
    }();
    exports.MergeScanOperator = MergeScanOperator;
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var MergeScanSubscriber = function (_super) {
        __extends(MergeScanSubscriber, _super);
        function MergeScanSubscriber(destination, accumulator, acc, concurrent) {
            _super.call(this, destination);
            this.accumulator = accumulator;
            this.acc = acc;
            this.concurrent = concurrent;
            this.hasValue = false;
            this.hasCompleted = false;
            this.buffer = [];
            this.active = 0;
            this.index = 0;
        }
        MergeScanSubscriber.prototype._next = function (value) {
            if (this.active < this.concurrent) {
                var index = this.index++;
                var ish = tryCatch_1.tryCatch(this.accumulator)(this.acc, value);
                var destination = this.destination;
                if (ish === errorObject_1.errorObject) {
                    destination.error(errorObject_1.errorObject.e);
                } else {
                    this.active++;
                    this._innerSub(ish, value, index);
                }
            } else {
                this.buffer.push(value);
            }
        };
        MergeScanSubscriber.prototype._innerSub = function (ish, value, index) {
            this.add(subscribeToResult_1.subscribeToResult(this, ish, value, index));
        };
        MergeScanSubscriber.prototype._complete = function () {
            this.hasCompleted = true;
            if (this.active === 0 && this.buffer.length === 0) {
                if (this.hasValue === false) {
                    this.destination.next(this.acc);
                }
                this.destination.complete();
            }
        };
        MergeScanSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            var destination = this.destination;
            this.acc = innerValue;
            this.hasValue = true;
            destination.next(innerValue);
        };
        MergeScanSubscriber.prototype.notifyComplete = function (innerSub) {
            var buffer = this.buffer;
            this.remove(innerSub);
            this.active--;
            if (buffer.length > 0) {
                this._next(buffer.shift());
            } else if (this.active === 0 && this.hasCompleted) {
                if (this.hasValue === false) {
                    this.destination.next(this.acc);
                }
                this.destination.complete();
            }
        };
        return MergeScanSubscriber;
    }(OuterSubscriber_1.OuterSubscriber);
    exports.MergeScanSubscriber = MergeScanSubscriber;
    
});
System.registerDynamic('rxjs/operators/min.js', ['rxjs/operators/reduce.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var reduce_1 = $__require('rxjs/operators/reduce.js');
    /**
     * The Min operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
     * and when source Observable completes it emits a single item: the item with the smallest value.
     *
     * <img src="./img/min.png" width="100%">
     *
     * @example <caption>Get the minimal value of a series of numbers</caption>
     * Rx.Observable.of(5, 4, 7, 2, 8)
     *   .min()
     *   .subscribe(x => console.log(x)); // -> 2
     *
     * @example <caption>Use a comparer function to get the minimal item</caption>
     * interface Person {
     *   age: number,
     *   name: string
     * }
     * Observable.of<Person>({age: 7, name: 'Foo'},
     *                       {age: 5, name: 'Bar'},
     *                       {age: 9, name: 'Beer'})
     *           .min<Person>( (a: Person, b: Person) => a.age < b.age ? -1 : 1)
     *           .subscribe((x: Person) => console.log(x.name)); // -> 'Bar'
     * }
     *
     * @see {@link max}
     *
     * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
     * value of two items.
     * @return {Observable<R>} An Observable that emits item with the smallest value.
     * @method min
     * @owner Observable
     */
    function min(comparer) {
        var min = typeof comparer === 'function' ? function (x, y) {
            return comparer(x, y) < 0 ? x : y;
        } : function (x, y) {
            return x < y ? x : y;
        };
        return reduce_1.reduce(min);
    }
    exports.min = min;
    
});
System.registerDynamic('rxjs/operators/onErrorResumeNext.js', ['rxjs/observable/FromObservable.js', 'rxjs/util/isArray.js', 'rxjs/OuterSubscriber.js', 'rxjs/util/subscribeToResult.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var FromObservable_1 = $__require('rxjs/observable/FromObservable.js');
    var isArray_1 = $__require('rxjs/util/isArray.js');
    var OuterSubscriber_1 = $__require('rxjs/OuterSubscriber.js');
    var subscribeToResult_1 = $__require('rxjs/util/subscribeToResult.js');
    /* tslint:enable:max-line-length */
    /**
     * When any of the provided Observable emits an complete or error notification, it immediately subscribes to the next one
     * that was passed.
     *
     * <span class="informal">Execute series of Observables no matter what, even if it means swallowing errors.</span>
     *
     * <img src="./img/onErrorResumeNext.png" width="100%">
     *
     * `onErrorResumeNext` is an operator that accepts a series of Observables, provided either directly as
     * arguments or as an array. If no single Observable is provided, returned Observable will simply behave the same
     * as the source.
     *
     * `onErrorResumeNext` returns an Observable that starts by subscribing and re-emitting values from the source Observable.
     * When its stream of values ends - no matter if Observable completed or emitted an error - `onErrorResumeNext`
     * will subscribe to the first Observable that was passed as an argument to the method. It will start re-emitting
     * its values as well and - again - when that stream ends, `onErrorResumeNext` will proceed to subscribing yet another
     * Observable in provided series, no matter if previous Observable completed or ended with an error. This will
     * be happening until there is no more Observables left in the series, at which point returned Observable will
     * complete - even if the last subscribed stream ended with an error.
     *
     * `onErrorResumeNext` can be therefore thought of as version of {@link concat} operator, which is more permissive
     * when it comes to the errors emitted by its input Observables. While `concat` subscribes to the next Observable
     * in series only if previous one successfully completed, `onErrorResumeNext` subscribes even if it ended with
     * an error.
     *
     * Note that you do not get any access to errors emitted by the Observables. In particular do not
     * expect these errors to appear in error callback passed to {@link subscribe}. If you want to take
     * specific actions based on what error was emitted by an Observable, you should try out {@link catch} instead.
     *
     *
     * @example <caption>Subscribe to the next Observable after map fails</caption>
     * Rx.Observable.of(1, 2, 3, 0)
     *   .map(x => {
     *       if (x === 0) { throw Error(); }
             return 10 / x;
     *   })
     *   .onErrorResumeNext(Rx.Observable.of(1, 2, 3))
     *   .subscribe(
     *     val => console.log(val),
     *     err => console.log(err),          // Will never be called.
     *     () => console.log('that\'s it!')
     *   );
     *
     * // Logs:
     * // 10
     * // 5
     * // 3.3333333333333335
     * // 1
     * // 2
     * // 3
     * // "that's it!"
     *
     * @see {@link concat}
     * @see {@link catch}
     *
     * @param {...ObservableInput} observables Observables passed either directly or as an array.
     * @return {Observable} An Observable that emits values from source Observable, but - if it errors - subscribes
     * to the next passed Observable and so on, until it completes or runs out of Observables.
     * @method onErrorResumeNext
     * @owner Observable
     */
    function onErrorResumeNext() {
        var nextSources = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            nextSources[_i - 0] = arguments[_i];
        }
        if (nextSources.length === 1 && isArray_1.isArray(nextSources[0])) {
            nextSources = nextSources[0];
        }
        return function (source) {
            return source.lift(new OnErrorResumeNextOperator(nextSources));
        };
    }
    exports.onErrorResumeNext = onErrorResumeNext;
    /* tslint:enable:max-line-length */
    function onErrorResumeNextStatic() {
        var nextSources = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            nextSources[_i - 0] = arguments[_i];
        }
        var source = null;
        if (nextSources.length === 1 && isArray_1.isArray(nextSources[0])) {
            nextSources = nextSources[0];
        }
        source = nextSources.shift();
        return new FromObservable_1.FromObservable(source, null).lift(new OnErrorResumeNextOperator(nextSources));
    }
    exports.onErrorResumeNextStatic = onErrorResumeNextStatic;
    var OnErrorResumeNextOperator = function () {
        function OnErrorResumeNextOperator(nextSources) {
            this.nextSources = nextSources;
        }
        OnErrorResumeNextOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new OnErrorResumeNextSubscriber(subscriber, this.nextSources));
        };
        return OnErrorResumeNextOperator;
    }();
    var OnErrorResumeNextSubscriber = function (_super) {
        __extends(OnErrorResumeNextSubscriber, _super);
        function OnErrorResumeNextSubscriber(destination, nextSources) {
            _super.call(this, destination);
            this.destination = destination;
            this.nextSources = nextSources;
        }
        OnErrorResumeNextSubscriber.prototype.notifyError = function (error, innerSub) {
            this.subscribeToNextSource();
        };
        OnErrorResumeNextSubscriber.prototype.notifyComplete = function (innerSub) {
            this.subscribeToNextSource();
        };
        OnErrorResumeNextSubscriber.prototype._error = function (err) {
            this.subscribeToNextSource();
        };
        OnErrorResumeNextSubscriber.prototype._complete = function () {
            this.subscribeToNextSource();
        };
        OnErrorResumeNextSubscriber.prototype.subscribeToNextSource = function () {
            var next = this.nextSources.shift();
            if (next) {
                this.add(subscribeToResult_1.subscribeToResult(this, next));
            } else {
                this.destination.complete();
            }
        };
        return OnErrorResumeNextSubscriber;
    }(OuterSubscriber_1.OuterSubscriber);
    
});
System.registerDynamic("rxjs/operators/pairwise.js", ["rxjs/Subscriber.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require("rxjs/Subscriber.js");
    /**
     * Groups pairs of consecutive emissions together and emits them as an array of
     * two values.
     *
     * <span class="informal">Puts the current value and previous value together as
     * an array, and emits that.</span>
     *
     * <img src="./img/pairwise.png" width="100%">
     *
     * The Nth emission from the source Observable will cause the output Observable
     * to emit an array [(N-1)th, Nth] of the previous and the current value, as a
     * pair. For this reason, `pairwise` emits on the second and subsequent
     * emissions from the source Observable, but not on the first emission, because
     * there is no previous value in that case.
     *
     * @example <caption>On every click (starting from the second), emit the relative distance to the previous click</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var pairs = clicks.pairwise();
     * var distance = pairs.map(pair => {
     *   var x0 = pair[0].clientX;
     *   var y0 = pair[0].clientY;
     *   var x1 = pair[1].clientX;
     *   var y1 = pair[1].clientY;
     *   return Math.sqrt(Math.pow(x0 - x1, 2) + Math.pow(y0 - y1, 2));
     * });
     * distance.subscribe(x => console.log(x));
     *
     * @see {@link buffer}
     * @see {@link bufferCount}
     *
     * @return {Observable<Array<T>>} An Observable of pairs (as arrays) of
     * consecutive values from the source Observable.
     * @method pairwise
     * @owner Observable
     */
    function pairwise() {
        return function (source) {
            return source.lift(new PairwiseOperator());
        };
    }
    exports.pairwise = pairwise;
    var PairwiseOperator = function () {
        function PairwiseOperator() {}
        PairwiseOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new PairwiseSubscriber(subscriber));
        };
        return PairwiseOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var PairwiseSubscriber = function (_super) {
        __extends(PairwiseSubscriber, _super);
        function PairwiseSubscriber(destination) {
            _super.call(this, destination);
            this.hasPrev = false;
        }
        PairwiseSubscriber.prototype._next = function (value) {
            if (this.hasPrev) {
                this.destination.next([this.prev, value]);
            } else {
                this.hasPrev = true;
            }
            this.prev = value;
        };
        return PairwiseSubscriber;
    }(Subscriber_1.Subscriber);
    
});
System.registerDynamic("rxjs/util/not.js", [], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    function not(pred, thisArg) {
        function notPred() {
            return !notPred.pred.apply(notPred.thisArg, arguments);
        }
        notPred.pred = pred;
        notPred.thisArg = thisArg;
        return notPred;
    }
    exports.not = not;
    
});
System.registerDynamic("rxjs/operators/filter.js", ["rxjs/Subscriber.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require("rxjs/Subscriber.js");
    /* tslint:enable:max-line-length */
    /**
     * Filter items emitted by the source Observable by only emitting those that
     * satisfy a specified predicate.
     *
     * <span class="informal">Like
     * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
     * it only emits a value from the source if it passes a criterion function.</span>
     *
     * <img src="./img/filter.png" width="100%">
     *
     * Similar to the well-known `Array.prototype.filter` method, this operator
     * takes values from the source Observable, passes them through a `predicate`
     * function and only emits those values that yielded `true`.
     *
     * @example <caption>Emit only click events whose target was a DIV element</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
     * clicksOnDivs.subscribe(x => console.log(x));
     *
     * @see {@link distinct}
     * @see {@link distinctUntilChanged}
     * @see {@link distinctUntilKeyChanged}
     * @see {@link ignoreElements}
     * @see {@link partition}
     * @see {@link skip}
     *
     * @param {function(value: T, index: number): boolean} predicate A function that
     * evaluates each value emitted by the source Observable. If it returns `true`,
     * the value is emitted, if `false` the value is not passed to the output
     * Observable. The `index` parameter is the number `i` for the i-th source
     * emission that has happened since the subscription, starting from the number
     * `0`.
     * @param {any} [thisArg] An optional argument to determine the value of `this`
     * in the `predicate` function.
     * @return {Observable} An Observable of values from the source that were
     * allowed by the `predicate` function.
     * @method filter
     * @owner Observable
     */
    function filter(predicate, thisArg) {
        return function filterOperatorFunction(source) {
            return source.lift(new FilterOperator(predicate, thisArg));
        };
    }
    exports.filter = filter;
    var FilterOperator = function () {
        function FilterOperator(predicate, thisArg) {
            this.predicate = predicate;
            this.thisArg = thisArg;
        }
        FilterOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new FilterSubscriber(subscriber, this.predicate, this.thisArg));
        };
        return FilterOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var FilterSubscriber = function (_super) {
        __extends(FilterSubscriber, _super);
        function FilterSubscriber(destination, predicate, thisArg) {
            _super.call(this, destination);
            this.predicate = predicate;
            this.thisArg = thisArg;
            this.count = 0;
        }
        // the try catch block below is left specifically for
        // optimization and perf reasons. a tryCatcher is not necessary here.
        FilterSubscriber.prototype._next = function (value) {
            var result;
            try {
                result = this.predicate.call(this.thisArg, value, this.count++);
            } catch (err) {
                this.destination.error(err);
                return;
            }
            if (result) {
                this.destination.next(value);
            }
        };
        return FilterSubscriber;
    }(Subscriber_1.Subscriber);
    
});
System.registerDynamic('rxjs/operators/partition.js', ['rxjs/util/not.js', 'rxjs/operators/filter.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var not_1 = $__require('rxjs/util/not.js');
    var filter_1 = $__require('rxjs/operators/filter.js');
    /**
     * Splits the source Observable into two, one with values that satisfy a
     * predicate, and another with values that don't satisfy the predicate.
     *
     * <span class="informal">It's like {@link filter}, but returns two Observables:
     * one like the output of {@link filter}, and the other with values that did not
     * pass the condition.</span>
     *
     * <img src="./img/partition.png" width="100%">
     *
     * `partition` outputs an array with two Observables that partition the values
     * from the source Observable through the given `predicate` function. The first
     * Observable in that array emits source values for which the predicate argument
     * returns true. The second Observable emits source values for which the
     * predicate returns false. The first behaves like {@link filter} and the second
     * behaves like {@link filter} with the predicate negated.
     *
     * @example <caption>Partition click events into those on DIV elements and those elsewhere</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var parts = clicks.partition(ev => ev.target.tagName === 'DIV');
     * var clicksOnDivs = parts[0];
     * var clicksElsewhere = parts[1];
     * clicksOnDivs.subscribe(x => console.log('DIV clicked: ', x));
     * clicksElsewhere.subscribe(x => console.log('Other clicked: ', x));
     *
     * @see {@link filter}
     *
     * @param {function(value: T, index: number): boolean} predicate A function that
     * evaluates each value emitted by the source Observable. If it returns `true`,
     * the value is emitted on the first Observable in the returned array, if
     * `false` the value is emitted on the second Observable in the array. The
     * `index` parameter is the number `i` for the i-th source emission that has
     * happened since the subscription, starting from the number `0`.
     * @param {any} [thisArg] An optional argument to determine the value of `this`
     * in the `predicate` function.
     * @return {[Observable<T>, Observable<T>]} An array with two Observables: one
     * with values that passed the predicate, and another with values that did not
     * pass the predicate.
     * @method partition
     * @owner Observable
     */
    function partition(predicate, thisArg) {
        return function (source) {
            return [filter_1.filter(predicate, thisArg)(source), filter_1.filter(not_1.not(predicate, thisArg))(source)];
        };
    }
    exports.partition = partition;
    
});
System.registerDynamic('rxjs/operators/pluck.js', ['rxjs/operators/map.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var map_1 = $__require('rxjs/operators/map.js');
    /**
     * Maps each source value (an object) to its specified nested property.
     *
     * <span class="informal">Like {@link map}, but meant only for picking one of
     * the nested properties of every emitted object.</span>
     *
     * <img src="./img/pluck.png" width="100%">
     *
     * Given a list of strings describing a path to an object property, retrieves
     * the value of a specified nested property from all values in the source
     * Observable. If a property can't be resolved, it will return `undefined` for
     * that value.
     *
     * @example <caption>Map every click to the tagName of the clicked target element</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var tagNames = clicks.pluck('target', 'tagName');
     * tagNames.subscribe(x => console.log(x));
     *
     * @see {@link map}
     *
     * @param {...string} properties The nested properties to pluck from each source
     * value (an object).
     * @return {Observable} A new Observable of property values from the source values.
     * @method pluck
     * @owner Observable
     */
    function pluck() {
        var properties = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            properties[_i - 0] = arguments[_i];
        }
        var length = properties.length;
        if (length === 0) {
            throw new Error('list of properties cannot be empty.');
        }
        return function (source) {
            return map_1.map(plucker(properties, length))(source);
        };
    }
    exports.pluck = pluck;
    function plucker(props, length) {
        var mapper = function (x) {
            var currentProp = x;
            for (var i = 0; i < length; i++) {
                var p = currentProp[props[i]];
                if (typeof p !== 'undefined') {
                    currentProp = p;
                } else {
                    return undefined;
                }
            }
            return currentProp;
        };
        return mapper;
    }
    
});
System.registerDynamic('rxjs/operators/publish.js', ['rxjs/Subject.js', 'rxjs/operators/multicast.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Subject_1 = $__require('rxjs/Subject.js');
  var multicast_1 = $__require('rxjs/operators/multicast.js');
  /* tslint:enable:max-line-length */
  /**
   * Returns a ConnectableObservable, which is a variety of Observable that waits until its connect method is called
   * before it begins emitting items to those Observers that have subscribed to it.
   *
   * <img src="./img/publish.png" width="100%">
   *
   * @param {Function} [selector] - Optional selector function which can use the multicasted source sequence as many times
   * as needed, without causing multiple subscriptions to the source sequence.
   * Subscribers to the given source will receive all notifications of the source from the time of the subscription on.
   * @return A ConnectableObservable that upon connection causes the source Observable to emit items to its Observers.
   * @method publish
   * @owner Observable
   */
  function publish(selector) {
    return selector ? multicast_1.multicast(function () {
      return new Subject_1.Subject();
    }, selector) : multicast_1.multicast(new Subject_1.Subject());
  }
  exports.publish = publish;
  
});
System.registerDynamic('rxjs/BehaviorSubject.js', ['rxjs/Subject.js', 'rxjs/util/ObjectUnsubscribedError.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subject_1 = $__require('rxjs/Subject.js');
    var ObjectUnsubscribedError_1 = $__require('rxjs/util/ObjectUnsubscribedError.js');
    /**
     * @class BehaviorSubject<T>
     */
    var BehaviorSubject = function (_super) {
        __extends(BehaviorSubject, _super);
        function BehaviorSubject(_value) {
            _super.call(this);
            this._value = _value;
        }
        Object.defineProperty(BehaviorSubject.prototype, "value", {
            get: function () {
                return this.getValue();
            },
            enumerable: true,
            configurable: true
        });
        /** @deprecated internal use only */BehaviorSubject.prototype._subscribe = function (subscriber) {
            var subscription = _super.prototype._subscribe.call(this, subscriber);
            if (subscription && !subscription.closed) {
                subscriber.next(this._value);
            }
            return subscription;
        };
        BehaviorSubject.prototype.getValue = function () {
            if (this.hasError) {
                throw this.thrownError;
            } else if (this.closed) {
                throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
            } else {
                return this._value;
            }
        };
        BehaviorSubject.prototype.next = function (value) {
            _super.prototype.next.call(this, this._value = value);
        };
        return BehaviorSubject;
    }(Subject_1.Subject);
    exports.BehaviorSubject = BehaviorSubject;
    
});
System.registerDynamic('rxjs/operators/publishBehavior.js', ['rxjs/BehaviorSubject.js', 'rxjs/operators/multicast.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var BehaviorSubject_1 = $__require('rxjs/BehaviorSubject.js');
  var multicast_1 = $__require('rxjs/operators/multicast.js');
  /**
   * @param value
   * @return {ConnectableObservable<T>}
   * @method publishBehavior
   * @owner Observable
   */
  function publishBehavior(value) {
    return function (source) {
      return multicast_1.multicast(new BehaviorSubject_1.BehaviorSubject(value))(source);
    };
  }
  exports.publishBehavior = publishBehavior;
  
});
System.registerDynamic('rxjs/AsyncSubject.js', ['rxjs/Subject.js', 'rxjs/Subscription.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subject_1 = $__require('rxjs/Subject.js');
    var Subscription_1 = $__require('rxjs/Subscription.js');
    /**
     * @class AsyncSubject<T>
     */
    var AsyncSubject = function (_super) {
        __extends(AsyncSubject, _super);
        function AsyncSubject() {
            _super.apply(this, arguments);
            this.value = null;
            this.hasNext = false;
            this.hasCompleted = false;
        }
        /** @deprecated internal use only */AsyncSubject.prototype._subscribe = function (subscriber) {
            if (this.hasError) {
                subscriber.error(this.thrownError);
                return Subscription_1.Subscription.EMPTY;
            } else if (this.hasCompleted && this.hasNext) {
                subscriber.next(this.value);
                subscriber.complete();
                return Subscription_1.Subscription.EMPTY;
            }
            return _super.prototype._subscribe.call(this, subscriber);
        };
        AsyncSubject.prototype.next = function (value) {
            if (!this.hasCompleted) {
                this.value = value;
                this.hasNext = true;
            }
        };
        AsyncSubject.prototype.error = function (error) {
            if (!this.hasCompleted) {
                _super.prototype.error.call(this, error);
            }
        };
        AsyncSubject.prototype.complete = function () {
            this.hasCompleted = true;
            if (this.hasNext) {
                _super.prototype.next.call(this, this.value);
            }
            _super.prototype.complete.call(this);
        };
        return AsyncSubject;
    }(Subject_1.Subject);
    exports.AsyncSubject = AsyncSubject;
    
});
System.registerDynamic('rxjs/operators/publishLast.js', ['rxjs/AsyncSubject.js', 'rxjs/operators/multicast.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var AsyncSubject_1 = $__require('rxjs/AsyncSubject.js');
    var multicast_1 = $__require('rxjs/operators/multicast.js');
    function publishLast() {
        return function (source) {
            return multicast_1.multicast(new AsyncSubject_1.AsyncSubject())(source);
        };
    }
    exports.publishLast = publishLast;
    
});
System.registerDynamic('rxjs/operators/publishReplay.js', ['rxjs/ReplaySubject.js', 'rxjs/operators/multicast.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var ReplaySubject_1 = $__require('rxjs/ReplaySubject.js');
    var multicast_1 = $__require('rxjs/operators/multicast.js');
    /* tslint:enable:max-line-length */
    function publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
        if (selectorOrScheduler && typeof selectorOrScheduler !== 'function') {
            scheduler = selectorOrScheduler;
        }
        var selector = typeof selectorOrScheduler === 'function' ? selectorOrScheduler : undefined;
        var subject = new ReplaySubject_1.ReplaySubject(bufferSize, windowTime, scheduler);
        return function (source) {
            return multicast_1.multicast(function () {
                return subject;
            }, selector)(source);
        };
    }
    exports.publishReplay = publishReplay;
    
});
System.registerDynamic('rxjs/observable/race.js', ['rxjs/util/isArray.js', 'rxjs/observable/ArrayObservable.js', 'rxjs/OuterSubscriber.js', 'rxjs/util/subscribeToResult.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var isArray_1 = $__require('rxjs/util/isArray.js');
    var ArrayObservable_1 = $__require('rxjs/observable/ArrayObservable.js');
    var OuterSubscriber_1 = $__require('rxjs/OuterSubscriber.js');
    var subscribeToResult_1 = $__require('rxjs/util/subscribeToResult.js');
    function race() {
        var observables = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            observables[_i - 0] = arguments[_i];
        }
        // if the only argument is an array, it was most likely called with
        // `race([obs1, obs2, ...])`
        if (observables.length === 1) {
            if (isArray_1.isArray(observables[0])) {
                observables = observables[0];
            } else {
                return observables[0];
            }
        }
        return new ArrayObservable_1.ArrayObservable(observables).lift(new RaceOperator());
    }
    exports.race = race;
    var RaceOperator = function () {
        function RaceOperator() {}
        RaceOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new RaceSubscriber(subscriber));
        };
        return RaceOperator;
    }();
    exports.RaceOperator = RaceOperator;
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var RaceSubscriber = function (_super) {
        __extends(RaceSubscriber, _super);
        function RaceSubscriber(destination) {
            _super.call(this, destination);
            this.hasFirst = false;
            this.observables = [];
            this.subscriptions = [];
        }
        RaceSubscriber.prototype._next = function (observable) {
            this.observables.push(observable);
        };
        RaceSubscriber.prototype._complete = function () {
            var observables = this.observables;
            var len = observables.length;
            if (len === 0) {
                this.destination.complete();
            } else {
                for (var i = 0; i < len && !this.hasFirst; i++) {
                    var observable = observables[i];
                    var subscription = subscribeToResult_1.subscribeToResult(this, observable, observable, i);
                    if (this.subscriptions) {
                        this.subscriptions.push(subscription);
                    }
                    this.add(subscription);
                }
                this.observables = null;
            }
        };
        RaceSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            if (!this.hasFirst) {
                this.hasFirst = true;
                for (var i = 0; i < this.subscriptions.length; i++) {
                    if (i !== outerIndex) {
                        var subscription = this.subscriptions[i];
                        subscription.unsubscribe();
                        this.remove(subscription);
                    }
                }
                this.subscriptions = null;
            }
            this.destination.next(innerValue);
        };
        return RaceSubscriber;
    }(OuterSubscriber_1.OuterSubscriber);
    exports.RaceSubscriber = RaceSubscriber;
    
});
System.registerDynamic('rxjs/operators/race.js', ['rxjs/util/isArray.js', 'rxjs/observable/race.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var isArray_1 = $__require('rxjs/util/isArray.js');
    var race_1 = $__require('rxjs/observable/race.js');
    /* tslint:enable:max-line-length */
    /**
     * Returns an Observable that mirrors the first source Observable to emit an item
     * from the combination of this Observable and supplied Observables.
     * @param {...Observables} ...observables Sources used to race for which Observable emits first.
     * @return {Observable} An Observable that mirrors the output of the first Observable to emit an item.
     * @method race
     * @owner Observable
     */
    function race() {
        var observables = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            observables[_i - 0] = arguments[_i];
        }
        return function raceOperatorFunction(source) {
            // if the only argument is an array, it was most likely called with
            // `pair([obs1, obs2, ...])`
            if (observables.length === 1 && isArray_1.isArray(observables[0])) {
                observables = observables[0];
            }
            return source.lift.call(race_1.race.apply(void 0, [source].concat(observables)));
        };
    }
    exports.race = race;
    
});
System.registerDynamic('rxjs/operators/repeat.js', ['rxjs/Subscriber.js', 'rxjs/observable/EmptyObservable.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require('rxjs/Subscriber.js');
    var EmptyObservable_1 = $__require('rxjs/observable/EmptyObservable.js');
    /**
     * Returns an Observable that repeats the stream of items emitted by the source Observable at most count times.
     *
     * <img src="./img/repeat.png" width="100%">
     *
     * @param {number} [count] The number of times the source Observable items are repeated, a count of 0 will yield
     * an empty Observable.
     * @return {Observable} An Observable that repeats the stream of items emitted by the source Observable at most
     * count times.
     * @method repeat
     * @owner Observable
     */
    function repeat(count) {
        if (count === void 0) {
            count = -1;
        }
        return function (source) {
            if (count === 0) {
                return new EmptyObservable_1.EmptyObservable();
            } else if (count < 0) {
                return source.lift(new RepeatOperator(-1, source));
            } else {
                return source.lift(new RepeatOperator(count - 1, source));
            }
        };
    }
    exports.repeat = repeat;
    var RepeatOperator = function () {
        function RepeatOperator(count, source) {
            this.count = count;
            this.source = source;
        }
        RepeatOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new RepeatSubscriber(subscriber, this.count, this.source));
        };
        return RepeatOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var RepeatSubscriber = function (_super) {
        __extends(RepeatSubscriber, _super);
        function RepeatSubscriber(destination, count, source) {
            _super.call(this, destination);
            this.count = count;
            this.source = source;
        }
        RepeatSubscriber.prototype.complete = function () {
            if (!this.isStopped) {
                var _a = this,
                    source = _a.source,
                    count = _a.count;
                if (count === 0) {
                    return _super.prototype.complete.call(this);
                } else if (count > -1) {
                    this.count = count - 1;
                }
                source.subscribe(this._unsubscribeAndRecycle());
            }
        };
        return RepeatSubscriber;
    }(Subscriber_1.Subscriber);
    
});
System.registerDynamic('rxjs/operators/repeatWhen.js', ['rxjs/Subject.js', 'rxjs/util/tryCatch.js', 'rxjs/util/errorObject.js', 'rxjs/OuterSubscriber.js', 'rxjs/util/subscribeToResult.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subject_1 = $__require('rxjs/Subject.js');
    var tryCatch_1 = $__require('rxjs/util/tryCatch.js');
    var errorObject_1 = $__require('rxjs/util/errorObject.js');
    var OuterSubscriber_1 = $__require('rxjs/OuterSubscriber.js');
    var subscribeToResult_1 = $__require('rxjs/util/subscribeToResult.js');
    /**
     * Returns an Observable that mirrors the source Observable with the exception of a `complete`. If the source
     * Observable calls `complete`, this method will emit to the Observable returned from `notifier`. If that Observable
     * calls `complete` or `error`, then this method will call `complete` or `error` on the child subscription. Otherwise
     * this method will resubscribe to the source Observable.
     *
     * <img src="./img/repeatWhen.png" width="100%">
     *
     * @param {function(notifications: Observable): Observable} notifier - Receives an Observable of notifications with
     * which a user can `complete` or `error`, aborting the repetition.
     * @return {Observable} The source Observable modified with repeat logic.
     * @method repeatWhen
     * @owner Observable
     */
    function repeatWhen(notifier) {
        return function (source) {
            return source.lift(new RepeatWhenOperator(notifier));
        };
    }
    exports.repeatWhen = repeatWhen;
    var RepeatWhenOperator = function () {
        function RepeatWhenOperator(notifier) {
            this.notifier = notifier;
        }
        RepeatWhenOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new RepeatWhenSubscriber(subscriber, this.notifier, source));
        };
        return RepeatWhenOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var RepeatWhenSubscriber = function (_super) {
        __extends(RepeatWhenSubscriber, _super);
        function RepeatWhenSubscriber(destination, notifier, source) {
            _super.call(this, destination);
            this.notifier = notifier;
            this.source = source;
            this.sourceIsBeingSubscribedTo = true;
        }
        RepeatWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this.sourceIsBeingSubscribedTo = true;
            this.source.subscribe(this);
        };
        RepeatWhenSubscriber.prototype.notifyComplete = function (innerSub) {
            if (this.sourceIsBeingSubscribedTo === false) {
                return _super.prototype.complete.call(this);
            }
        };
        RepeatWhenSubscriber.prototype.complete = function () {
            this.sourceIsBeingSubscribedTo = false;
            if (!this.isStopped) {
                if (!this.retries) {
                    this.subscribeToRetries();
                }
                if (!this.retriesSubscription || this.retriesSubscription.closed) {
                    return _super.prototype.complete.call(this);
                }
                this._unsubscribeAndRecycle();
                this.notifications.next();
            }
        };
        /** @deprecated internal use only */RepeatWhenSubscriber.prototype._unsubscribe = function () {
            var _a = this,
                notifications = _a.notifications,
                retriesSubscription = _a.retriesSubscription;
            if (notifications) {
                notifications.unsubscribe();
                this.notifications = null;
            }
            if (retriesSubscription) {
                retriesSubscription.unsubscribe();
                this.retriesSubscription = null;
            }
            this.retries = null;
        };
        /** @deprecated internal use only */RepeatWhenSubscriber.prototype._unsubscribeAndRecycle = function () {
            var _a = this,
                notifications = _a.notifications,
                retries = _a.retries,
                retriesSubscription = _a.retriesSubscription;
            this.notifications = null;
            this.retries = null;
            this.retriesSubscription = null;
            _super.prototype._unsubscribeAndRecycle.call(this);
            this.notifications = notifications;
            this.retries = retries;
            this.retriesSubscription = retriesSubscription;
            return this;
        };
        RepeatWhenSubscriber.prototype.subscribeToRetries = function () {
            this.notifications = new Subject_1.Subject();
            var retries = tryCatch_1.tryCatch(this.notifier)(this.notifications);
            if (retries === errorObject_1.errorObject) {
                return _super.prototype.complete.call(this);
            }
            this.retries = retries;
            this.retriesSubscription = subscribeToResult_1.subscribeToResult(this, retries);
        };
        return RepeatWhenSubscriber;
    }(OuterSubscriber_1.OuterSubscriber);
    
});
System.registerDynamic("rxjs/operators/retry.js", ["rxjs/Subscriber.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require("rxjs/Subscriber.js");
    /**
     * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
     * calls `error`, this method will resubscribe to the source Observable for a maximum of `count` resubscriptions (given
     * as a number parameter) rather than propagating the `error` call.
     *
     * <img src="./img/retry.png" width="100%">
     *
     * Any and all items emitted by the source Observable will be emitted by the resulting Observable, even those emitted
     * during failed subscriptions. For example, if an Observable fails at first but emits [1, 2] then succeeds the second
     * time and emits: [1, 2, 3, 4, 5] then the complete stream of emissions and notifications
     * would be: [1, 2, 1, 2, 3, 4, 5, `complete`].
     * @param {number} count - Number of retry attempts before failing.
     * @return {Observable} The source Observable modified with the retry logic.
     * @method retry
     * @owner Observable
     */
    function retry(count) {
        if (count === void 0) {
            count = -1;
        }
        return function (source) {
            return source.lift(new RetryOperator(count, source));
        };
    }
    exports.retry = retry;
    var RetryOperator = function () {
        function RetryOperator(count, source) {
            this.count = count;
            this.source = source;
        }
        RetryOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new RetrySubscriber(subscriber, this.count, this.source));
        };
        return RetryOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var RetrySubscriber = function (_super) {
        __extends(RetrySubscriber, _super);
        function RetrySubscriber(destination, count, source) {
            _super.call(this, destination);
            this.count = count;
            this.source = source;
        }
        RetrySubscriber.prototype.error = function (err) {
            if (!this.isStopped) {
                var _a = this,
                    source = _a.source,
                    count = _a.count;
                if (count === 0) {
                    return _super.prototype.error.call(this, err);
                } else if (count > -1) {
                    this.count = count - 1;
                }
                source.subscribe(this._unsubscribeAndRecycle());
            }
        };
        return RetrySubscriber;
    }(Subscriber_1.Subscriber);
    
});
System.registerDynamic('rxjs/operators/retryWhen.js', ['rxjs/Subject.js', 'rxjs/util/tryCatch.js', 'rxjs/util/errorObject.js', 'rxjs/OuterSubscriber.js', 'rxjs/util/subscribeToResult.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subject_1 = $__require('rxjs/Subject.js');
    var tryCatch_1 = $__require('rxjs/util/tryCatch.js');
    var errorObject_1 = $__require('rxjs/util/errorObject.js');
    var OuterSubscriber_1 = $__require('rxjs/OuterSubscriber.js');
    var subscribeToResult_1 = $__require('rxjs/util/subscribeToResult.js');
    /**
     * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
     * calls `error`, this method will emit the Throwable that caused the error to the Observable returned from `notifier`.
     * If that Observable calls `complete` or `error` then this method will call `complete` or `error` on the child
     * subscription. Otherwise this method will resubscribe to the source Observable.
     *
     * <img src="./img/retryWhen.png" width="100%">
     *
     * @param {function(errors: Observable): Observable} notifier - Receives an Observable of notifications with which a
     * user can `complete` or `error`, aborting the retry.
     * @return {Observable} The source Observable modified with retry logic.
     * @method retryWhen
     * @owner Observable
     */
    function retryWhen(notifier) {
        return function (source) {
            return source.lift(new RetryWhenOperator(notifier, source));
        };
    }
    exports.retryWhen = retryWhen;
    var RetryWhenOperator = function () {
        function RetryWhenOperator(notifier, source) {
            this.notifier = notifier;
            this.source = source;
        }
        RetryWhenOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new RetryWhenSubscriber(subscriber, this.notifier, this.source));
        };
        return RetryWhenOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var RetryWhenSubscriber = function (_super) {
        __extends(RetryWhenSubscriber, _super);
        function RetryWhenSubscriber(destination, notifier, source) {
            _super.call(this, destination);
            this.notifier = notifier;
            this.source = source;
        }
        RetryWhenSubscriber.prototype.error = function (err) {
            if (!this.isStopped) {
                var errors = this.errors;
                var retries = this.retries;
                var retriesSubscription = this.retriesSubscription;
                if (!retries) {
                    errors = new Subject_1.Subject();
                    retries = tryCatch_1.tryCatch(this.notifier)(errors);
                    if (retries === errorObject_1.errorObject) {
                        return _super.prototype.error.call(this, errorObject_1.errorObject.e);
                    }
                    retriesSubscription = subscribeToResult_1.subscribeToResult(this, retries);
                } else {
                    this.errors = null;
                    this.retriesSubscription = null;
                }
                this._unsubscribeAndRecycle();
                this.errors = errors;
                this.retries = retries;
                this.retriesSubscription = retriesSubscription;
                errors.next(err);
            }
        };
        /** @deprecated internal use only */RetryWhenSubscriber.prototype._unsubscribe = function () {
            var _a = this,
                errors = _a.errors,
                retriesSubscription = _a.retriesSubscription;
            if (errors) {
                errors.unsubscribe();
                this.errors = null;
            }
            if (retriesSubscription) {
                retriesSubscription.unsubscribe();
                this.retriesSubscription = null;
            }
            this.retries = null;
        };
        RetryWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            var _a = this,
                errors = _a.errors,
                retries = _a.retries,
                retriesSubscription = _a.retriesSubscription;
            this.errors = null;
            this.retries = null;
            this.retriesSubscription = null;
            this._unsubscribeAndRecycle();
            this.errors = errors;
            this.retries = retries;
            this.retriesSubscription = retriesSubscription;
            this.source.subscribe(this);
        };
        return RetryWhenSubscriber;
    }(OuterSubscriber_1.OuterSubscriber);
    
});
System.registerDynamic('rxjs/operators/sample.js', ['rxjs/OuterSubscriber.js', 'rxjs/util/subscribeToResult.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var OuterSubscriber_1 = $__require('rxjs/OuterSubscriber.js');
    var subscribeToResult_1 = $__require('rxjs/util/subscribeToResult.js');
    /**
     * Emits the most recently emitted value from the source Observable whenever
     * another Observable, the `notifier`, emits.
     *
     * <span class="informal">It's like {@link sampleTime}, but samples whenever
     * the `notifier` Observable emits something.</span>
     *
     * <img src="./img/sample.png" width="100%">
     *
     * Whenever the `notifier` Observable emits a value or completes, `sample`
     * looks at the source Observable and emits whichever value it has most recently
     * emitted since the previous sampling, unless the source has not emitted
     * anything since the previous sampling. The `notifier` is subscribed to as soon
     * as the output Observable is subscribed.
     *
     * @example <caption>On every click, sample the most recent "seconds" timer</caption>
     * var seconds = Rx.Observable.interval(1000);
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var result = seconds.sample(clicks);
     * result.subscribe(x => console.log(x));
     *
     * @see {@link audit}
     * @see {@link debounce}
     * @see {@link sampleTime}
     * @see {@link throttle}
     *
     * @param {Observable<any>} notifier The Observable to use for sampling the
     * source Observable.
     * @return {Observable<T>} An Observable that emits the results of sampling the
     * values emitted by the source Observable whenever the notifier Observable
     * emits value or completes.
     * @method sample
     * @owner Observable
     */
    function sample(notifier) {
        return function (source) {
            return source.lift(new SampleOperator(notifier));
        };
    }
    exports.sample = sample;
    var SampleOperator = function () {
        function SampleOperator(notifier) {
            this.notifier = notifier;
        }
        SampleOperator.prototype.call = function (subscriber, source) {
            var sampleSubscriber = new SampleSubscriber(subscriber);
            var subscription = source.subscribe(sampleSubscriber);
            subscription.add(subscribeToResult_1.subscribeToResult(sampleSubscriber, this.notifier));
            return subscription;
        };
        return SampleOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var SampleSubscriber = function (_super) {
        __extends(SampleSubscriber, _super);
        function SampleSubscriber() {
            _super.apply(this, arguments);
            this.hasValue = false;
        }
        SampleSubscriber.prototype._next = function (value) {
            this.value = value;
            this.hasValue = true;
        };
        SampleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this.emitValue();
        };
        SampleSubscriber.prototype.notifyComplete = function () {
            this.emitValue();
        };
        SampleSubscriber.prototype.emitValue = function () {
            if (this.hasValue) {
                this.hasValue = false;
                this.destination.next(this.value);
            }
        };
        return SampleSubscriber;
    }(OuterSubscriber_1.OuterSubscriber);
    
});
System.registerDynamic('rxjs/operators/sampleTime.js', ['rxjs/Subscriber.js', 'rxjs/scheduler/async.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require('rxjs/Subscriber.js');
    var async_1 = $__require('rxjs/scheduler/async.js');
    /**
     * Emits the most recently emitted value from the source Observable within
     * periodic time intervals.
     *
     * <span class="informal">Samples the source Observable at periodic time
     * intervals, emitting what it samples.</span>
     *
     * <img src="./img/sampleTime.png" width="100%">
     *
     * `sampleTime` periodically looks at the source Observable and emits whichever
     * value it has most recently emitted since the previous sampling, unless the
     * source has not emitted anything since the previous sampling. The sampling
     * happens periodically in time every `period` milliseconds (or the time unit
     * defined by the optional `scheduler` argument). The sampling starts as soon as
     * the output Observable is subscribed.
     *
     * @example <caption>Every second, emit the most recent click at most once</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var result = clicks.sampleTime(1000);
     * result.subscribe(x => console.log(x));
     *
     * @see {@link auditTime}
     * @see {@link debounceTime}
     * @see {@link delay}
     * @see {@link sample}
     * @see {@link throttleTime}
     *
     * @param {number} period The sampling period expressed in milliseconds or the
     * time unit determined internally by the optional `scheduler`.
     * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
     * managing the timers that handle the sampling.
     * @return {Observable<T>} An Observable that emits the results of sampling the
     * values emitted by the source Observable at the specified time interval.
     * @method sampleTime
     * @owner Observable
     */
    function sampleTime(period, scheduler) {
        if (scheduler === void 0) {
            scheduler = async_1.async;
        }
        return function (source) {
            return source.lift(new SampleTimeOperator(period, scheduler));
        };
    }
    exports.sampleTime = sampleTime;
    var SampleTimeOperator = function () {
        function SampleTimeOperator(period, scheduler) {
            this.period = period;
            this.scheduler = scheduler;
        }
        SampleTimeOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new SampleTimeSubscriber(subscriber, this.period, this.scheduler));
        };
        return SampleTimeOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var SampleTimeSubscriber = function (_super) {
        __extends(SampleTimeSubscriber, _super);
        function SampleTimeSubscriber(destination, period, scheduler) {
            _super.call(this, destination);
            this.period = period;
            this.scheduler = scheduler;
            this.hasValue = false;
            this.add(scheduler.schedule(dispatchNotification, period, { subscriber: this, period: period }));
        }
        SampleTimeSubscriber.prototype._next = function (value) {
            this.lastValue = value;
            this.hasValue = true;
        };
        SampleTimeSubscriber.prototype.notifyNext = function () {
            if (this.hasValue) {
                this.hasValue = false;
                this.destination.next(this.lastValue);
            }
        };
        return SampleTimeSubscriber;
    }(Subscriber_1.Subscriber);
    function dispatchNotification(state) {
        var subscriber = state.subscriber,
            period = state.period;
        subscriber.notifyNext();
        this.schedule(state, period);
    }
    
});
System.registerDynamic('rxjs/operators/sequenceEqual.js', ['rxjs/Subscriber.js', 'rxjs/util/tryCatch.js', 'rxjs/util/errorObject.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require('rxjs/Subscriber.js');
    var tryCatch_1 = $__require('rxjs/util/tryCatch.js');
    var errorObject_1 = $__require('rxjs/util/errorObject.js');
    /**
     * Compares all values of two observables in sequence using an optional comparor function
     * and returns an observable of a single boolean value representing whether or not the two sequences
     * are equal.
     *
     * <span class="informal">Checks to see of all values emitted by both observables are equal, in order.</span>
     *
     * <img src="./img/sequenceEqual.png" width="100%">
     *
     * `sequenceEqual` subscribes to two observables and buffers incoming values from each observable. Whenever either
     * observable emits a value, the value is buffered and the buffers are shifted and compared from the bottom
     * up; If any value pair doesn't match, the returned observable will emit `false` and complete. If one of the
     * observables completes, the operator will wait for the other observable to complete; If the other
     * observable emits before completing, the returned observable will emit `false` and complete. If one observable never
     * completes or emits after the other complets, the returned observable will never complete.
     *
     * @example <caption>figure out if the Konami code matches</caption>
     * var code = Rx.Observable.from([
     *  "ArrowUp",
     *  "ArrowUp",
     *  "ArrowDown",
     *  "ArrowDown",
     *  "ArrowLeft",
     *  "ArrowRight",
     *  "ArrowLeft",
     *  "ArrowRight",
     *  "KeyB",
     *  "KeyA",
     *  "Enter" // no start key, clearly.
     * ]);
     *
     * var keys = Rx.Observable.fromEvent(document, 'keyup')
     *  .map(e => e.code);
     * var matches = keys.bufferCount(11, 1)
     *  .mergeMap(
     *    last11 =>
     *      Rx.Observable.from(last11)
     *        .sequenceEqual(code)
     *   );
     * matches.subscribe(matched => console.log('Successful cheat at Contra? ', matched));
     *
     * @see {@link combineLatest}
     * @see {@link zip}
     * @see {@link withLatestFrom}
     *
     * @param {Observable} compareTo The observable sequence to compare the source sequence to.
     * @param {function} [comparor] An optional function to compare each value pair
     * @return {Observable} An Observable of a single boolean value representing whether or not
     * the values emitted by both observables were equal in sequence.
     * @method sequenceEqual
     * @owner Observable
     */
    function sequenceEqual(compareTo, comparor) {
        return function (source) {
            return source.lift(new SequenceEqualOperator(compareTo, comparor));
        };
    }
    exports.sequenceEqual = sequenceEqual;
    var SequenceEqualOperator = function () {
        function SequenceEqualOperator(compareTo, comparor) {
            this.compareTo = compareTo;
            this.comparor = comparor;
        }
        SequenceEqualOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new SequenceEqualSubscriber(subscriber, this.compareTo, this.comparor));
        };
        return SequenceEqualOperator;
    }();
    exports.SequenceEqualOperator = SequenceEqualOperator;
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var SequenceEqualSubscriber = function (_super) {
        __extends(SequenceEqualSubscriber, _super);
        function SequenceEqualSubscriber(destination, compareTo, comparor) {
            _super.call(this, destination);
            this.compareTo = compareTo;
            this.comparor = comparor;
            this._a = [];
            this._b = [];
            this._oneComplete = false;
            this.add(compareTo.subscribe(new SequenceEqualCompareToSubscriber(destination, this)));
        }
        SequenceEqualSubscriber.prototype._next = function (value) {
            if (this._oneComplete && this._b.length === 0) {
                this.emit(false);
            } else {
                this._a.push(value);
                this.checkValues();
            }
        };
        SequenceEqualSubscriber.prototype._complete = function () {
            if (this._oneComplete) {
                this.emit(this._a.length === 0 && this._b.length === 0);
            } else {
                this._oneComplete = true;
            }
        };
        SequenceEqualSubscriber.prototype.checkValues = function () {
            var _c = this,
                _a = _c._a,
                _b = _c._b,
                comparor = _c.comparor;
            while (_a.length > 0 && _b.length > 0) {
                var a = _a.shift();
                var b = _b.shift();
                var areEqual = false;
                if (comparor) {
                    areEqual = tryCatch_1.tryCatch(comparor)(a, b);
                    if (areEqual === errorObject_1.errorObject) {
                        this.destination.error(errorObject_1.errorObject.e);
                    }
                } else {
                    areEqual = a === b;
                }
                if (!areEqual) {
                    this.emit(false);
                }
            }
        };
        SequenceEqualSubscriber.prototype.emit = function (value) {
            var destination = this.destination;
            destination.next(value);
            destination.complete();
        };
        SequenceEqualSubscriber.prototype.nextB = function (value) {
            if (this._oneComplete && this._a.length === 0) {
                this.emit(false);
            } else {
                this._b.push(value);
                this.checkValues();
            }
        };
        return SequenceEqualSubscriber;
    }(Subscriber_1.Subscriber);
    exports.SequenceEqualSubscriber = SequenceEqualSubscriber;
    var SequenceEqualCompareToSubscriber = function (_super) {
        __extends(SequenceEqualCompareToSubscriber, _super);
        function SequenceEqualCompareToSubscriber(destination, parent) {
            _super.call(this, destination);
            this.parent = parent;
        }
        SequenceEqualCompareToSubscriber.prototype._next = function (value) {
            this.parent.nextB(value);
        };
        SequenceEqualCompareToSubscriber.prototype._error = function (err) {
            this.parent.error(err);
        };
        SequenceEqualCompareToSubscriber.prototype._complete = function () {
            this.parent._complete();
        };
        return SequenceEqualCompareToSubscriber;
    }(Subscriber_1.Subscriber);
    
});
System.registerDynamic('rxjs/observable/ConnectableObservable.js', ['rxjs/Subject.js', 'rxjs/Observable.js', 'rxjs/Subscriber.js', 'rxjs/Subscription.js', 'rxjs/operators/refCount.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subject_1 = $__require('rxjs/Subject.js');
    var Observable_1 = $__require('rxjs/Observable.js');
    var Subscriber_1 = $__require('rxjs/Subscriber.js');
    var Subscription_1 = $__require('rxjs/Subscription.js');
    var refCount_1 = $__require('rxjs/operators/refCount.js');
    /**
     * @class ConnectableObservable<T>
     */
    var ConnectableObservable = function (_super) {
        __extends(ConnectableObservable, _super);
        function ConnectableObservable( /** @deprecated internal use only */source,
        /** @deprecated internal use only */subjectFactory) {
            _super.call(this);
            this.source = source;
            this.subjectFactory = subjectFactory;
            /** @deprecated internal use only */this._refCount = 0;
            this._isComplete = false;
        }
        /** @deprecated internal use only */ConnectableObservable.prototype._subscribe = function (subscriber) {
            return this.getSubject().subscribe(subscriber);
        };
        /** @deprecated internal use only */ConnectableObservable.prototype.getSubject = function () {
            var subject = this._subject;
            if (!subject || subject.isStopped) {
                this._subject = this.subjectFactory();
            }
            return this._subject;
        };
        ConnectableObservable.prototype.connect = function () {
            var connection = this._connection;
            if (!connection) {
                this._isComplete = false;
                connection = this._connection = new Subscription_1.Subscription();
                connection.add(this.source.subscribe(new ConnectableSubscriber(this.getSubject(), this)));
                if (connection.closed) {
                    this._connection = null;
                    connection = Subscription_1.Subscription.EMPTY;
                } else {
                    this._connection = connection;
                }
            }
            return connection;
        };
        ConnectableObservable.prototype.refCount = function () {
            return refCount_1.refCount()(this);
        };
        return ConnectableObservable;
    }(Observable_1.Observable);
    exports.ConnectableObservable = ConnectableObservable;
    var connectableProto = ConnectableObservable.prototype;
    exports.connectableObservableDescriptor = {
        operator: { value: null },
        _refCount: { value: 0, writable: true },
        _subject: { value: null, writable: true },
        _connection: { value: null, writable: true },
        _subscribe: { value: connectableProto._subscribe },
        _isComplete: { value: connectableProto._isComplete, writable: true },
        getSubject: { value: connectableProto.getSubject },
        connect: { value: connectableProto.connect },
        refCount: { value: connectableProto.refCount }
    };
    var ConnectableSubscriber = function (_super) {
        __extends(ConnectableSubscriber, _super);
        function ConnectableSubscriber(destination, connectable) {
            _super.call(this, destination);
            this.connectable = connectable;
        }
        ConnectableSubscriber.prototype._error = function (err) {
            this._unsubscribe();
            _super.prototype._error.call(this, err);
        };
        ConnectableSubscriber.prototype._complete = function () {
            this.connectable._isComplete = true;
            this._unsubscribe();
            _super.prototype._complete.call(this);
        };
        /** @deprecated internal use only */ConnectableSubscriber.prototype._unsubscribe = function () {
            var connectable = this.connectable;
            if (connectable) {
                this.connectable = null;
                var connection = connectable._connection;
                connectable._refCount = 0;
                connectable._subject = null;
                connectable._connection = null;
                if (connection) {
                    connection.unsubscribe();
                }
            }
        };
        return ConnectableSubscriber;
    }(Subject_1.SubjectSubscriber);
    var RefCountOperator = function () {
        function RefCountOperator(connectable) {
            this.connectable = connectable;
        }
        RefCountOperator.prototype.call = function (subscriber, source) {
            var connectable = this.connectable;
            connectable._refCount++;
            var refCounter = new RefCountSubscriber(subscriber, connectable);
            var subscription = source.subscribe(refCounter);
            if (!refCounter.closed) {
                refCounter.connection = connectable.connect();
            }
            return subscription;
        };
        return RefCountOperator;
    }();
    var RefCountSubscriber = function (_super) {
        __extends(RefCountSubscriber, _super);
        function RefCountSubscriber(destination, connectable) {
            _super.call(this, destination);
            this.connectable = connectable;
        }
        /** @deprecated internal use only */RefCountSubscriber.prototype._unsubscribe = function () {
            var connectable = this.connectable;
            if (!connectable) {
                this.connection = null;
                return;
            }
            this.connectable = null;
            var refCount = connectable._refCount;
            if (refCount <= 0) {
                this.connection = null;
                return;
            }
            connectable._refCount = refCount - 1;
            if (refCount > 1) {
                this.connection = null;
                return;
            }
            ///
            // Compare the local RefCountSubscriber's connection Subscription to the
            // connection Subscription on the shared ConnectableObservable. In cases
            // where the ConnectableObservable source synchronously emits values, and
            // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
            // execution continues to here before the RefCountOperator has a chance to
            // supply the RefCountSubscriber with the shared connection Subscription.
            // For example:
            // ```
            // Observable.range(0, 10)
            //   .publish()
            //   .refCount()
            //   .take(5)
            //   .subscribe();
            // ```
            // In order to account for this case, RefCountSubscriber should only dispose
            // the ConnectableObservable's shared connection Subscription if the
            // connection Subscription exists, *and* either:
            //   a. RefCountSubscriber doesn't have a reference to the shared connection
            //      Subscription yet, or,
            //   b. RefCountSubscriber's connection Subscription reference is identical
            //      to the shared connection Subscription
            ///
            var connection = this.connection;
            var sharedConnection = connectable._connection;
            this.connection = null;
            if (sharedConnection && (!connection || sharedConnection === connection)) {
                sharedConnection.unsubscribe();
            }
        };
        return RefCountSubscriber;
    }(Subscriber_1.Subscriber);
    
});
System.registerDynamic('rxjs/operators/multicast.js', ['rxjs/observable/ConnectableObservable.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var ConnectableObservable_1 = $__require('rxjs/observable/ConnectableObservable.js');
    /* tslint:enable:max-line-length */
    /**
     * Returns an Observable that emits the results of invoking a specified selector on items
     * emitted by a ConnectableObservable that shares a single subscription to the underlying stream.
     *
     * <img src="./img/multicast.png" width="100%">
     *
     * @param {Function|Subject} subjectOrSubjectFactory - Factory function to create an intermediate subject through
     * which the source sequence's elements will be multicast to the selector function
     * or Subject to push source elements into.
     * @param {Function} [selector] - Optional selector function that can use the multicasted source stream
     * as many times as needed, without causing multiple subscriptions to the source stream.
     * Subscribers to the given source will receive all notifications of the source from the
     * time of the subscription forward.
     * @return {Observable} An Observable that emits the results of invoking the selector
     * on the items emitted by a `ConnectableObservable` that shares a single subscription to
     * the underlying stream.
     * @method multicast
     * @owner Observable
     */
    function multicast(subjectOrSubjectFactory, selector) {
        return function multicastOperatorFunction(source) {
            var subjectFactory;
            if (typeof subjectOrSubjectFactory === 'function') {
                subjectFactory = subjectOrSubjectFactory;
            } else {
                subjectFactory = function subjectFactory() {
                    return subjectOrSubjectFactory;
                };
            }
            if (typeof selector === 'function') {
                return source.lift(new MulticastOperator(subjectFactory, selector));
            }
            var connectable = Object.create(source, ConnectableObservable_1.connectableObservableDescriptor);
            connectable.source = source;
            connectable.subjectFactory = subjectFactory;
            return connectable;
        };
    }
    exports.multicast = multicast;
    var MulticastOperator = function () {
        function MulticastOperator(subjectFactory, selector) {
            this.subjectFactory = subjectFactory;
            this.selector = selector;
        }
        MulticastOperator.prototype.call = function (subscriber, source) {
            var selector = this.selector;
            var subject = this.subjectFactory();
            var subscription = selector(subject).subscribe(subscriber);
            subscription.add(source.subscribe(subject));
            return subscription;
        };
        return MulticastOperator;
    }();
    exports.MulticastOperator = MulticastOperator;
    
});
System.registerDynamic("rxjs/operators/refCount.js", ["rxjs/Subscriber.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require("rxjs/Subscriber.js");
    function refCount() {
        return function refCountOperatorFunction(source) {
            return source.lift(new RefCountOperator(source));
        };
    }
    exports.refCount = refCount;
    var RefCountOperator = function () {
        function RefCountOperator(connectable) {
            this.connectable = connectable;
        }
        RefCountOperator.prototype.call = function (subscriber, source) {
            var connectable = this.connectable;
            connectable._refCount++;
            var refCounter = new RefCountSubscriber(subscriber, connectable);
            var subscription = source.subscribe(refCounter);
            if (!refCounter.closed) {
                refCounter.connection = connectable.connect();
            }
            return subscription;
        };
        return RefCountOperator;
    }();
    var RefCountSubscriber = function (_super) {
        __extends(RefCountSubscriber, _super);
        function RefCountSubscriber(destination, connectable) {
            _super.call(this, destination);
            this.connectable = connectable;
        }
        /** @deprecated internal use only */RefCountSubscriber.prototype._unsubscribe = function () {
            var connectable = this.connectable;
            if (!connectable) {
                this.connection = null;
                return;
            }
            this.connectable = null;
            var refCount = connectable._refCount;
            if (refCount <= 0) {
                this.connection = null;
                return;
            }
            connectable._refCount = refCount - 1;
            if (refCount > 1) {
                this.connection = null;
                return;
            }
            ///
            // Compare the local RefCountSubscriber's connection Subscription to the
            // connection Subscription on the shared ConnectableObservable. In cases
            // where the ConnectableObservable source synchronously emits values, and
            // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
            // execution continues to here before the RefCountOperator has a chance to
            // supply the RefCountSubscriber with the shared connection Subscription.
            // For example:
            // ```
            // Observable.range(0, 10)
            //   .publish()
            //   .refCount()
            //   .take(5)
            //   .subscribe();
            // ```
            // In order to account for this case, RefCountSubscriber should only dispose
            // the ConnectableObservable's shared connection Subscription if the
            // connection Subscription exists, *and* either:
            //   a. RefCountSubscriber doesn't have a reference to the shared connection
            //      Subscription yet, or,
            //   b. RefCountSubscriber's connection Subscription reference is identical
            //      to the shared connection Subscription
            ///
            var connection = this.connection;
            var sharedConnection = connectable._connection;
            this.connection = null;
            if (sharedConnection && (!connection || sharedConnection === connection)) {
                sharedConnection.unsubscribe();
            }
        };
        return RefCountSubscriber;
    }(Subscriber_1.Subscriber);
    
});
System.registerDynamic('rxjs/operators/share.js', ['rxjs/operators/multicast.js', 'rxjs/operators/refCount.js', 'rxjs/Subject.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var multicast_1 = $__require('rxjs/operators/multicast.js');
    var refCount_1 = $__require('rxjs/operators/refCount.js');
    var Subject_1 = $__require('rxjs/Subject.js');
    function shareSubjectFactory() {
        return new Subject_1.Subject();
    }
    /**
     * Returns a new Observable that multicasts (shares) the original Observable. As long as there is at least one
     * Subscriber this Observable will be subscribed and emitting data. When all subscribers have unsubscribed it will
     * unsubscribe from the source Observable. Because the Observable is multicasting it makes the stream `hot`.
     * This is an alias for .multicast(() => new Subject()).refCount().
     *
     * <img src="./img/share.png" width="100%">
     *
     * @return {Observable<T>} An Observable that upon connection causes the source Observable to emit items to its Observers.
     * @method share
     * @owner Observable
     */
    function share() {
        return function (source) {
            return refCount_1.refCount()(multicast_1.multicast(shareSubjectFactory)(source));
        };
    }
    exports.share = share;
    ;
    
});
System.registerDynamic("rxjs/scheduler/QueueAction.js", ["rxjs/scheduler/AsyncAction.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var AsyncAction_1 = $__require("rxjs/scheduler/AsyncAction.js");
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var QueueAction = function (_super) {
        __extends(QueueAction, _super);
        function QueueAction(scheduler, work) {
            _super.call(this, scheduler, work);
            this.scheduler = scheduler;
            this.work = work;
        }
        QueueAction.prototype.schedule = function (state, delay) {
            if (delay === void 0) {
                delay = 0;
            }
            if (delay > 0) {
                return _super.prototype.schedule.call(this, state, delay);
            }
            this.delay = delay;
            this.state = state;
            this.scheduler.flush(this);
            return this;
        };
        QueueAction.prototype.execute = function (state, delay) {
            return delay > 0 || this.closed ? _super.prototype.execute.call(this, state, delay) : this._execute(state, delay);
        };
        QueueAction.prototype.requestAsyncId = function (scheduler, id, delay) {
            if (delay === void 0) {
                delay = 0;
            }
            // If delay exists and is greater than 0, or if the delay is null (the
            // action wasn't rescheduled) but was originally scheduled as an async
            // action, then recycle as an async action.
            if (delay !== null && delay > 0 || delay === null && this.delay > 0) {
                return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
            }
            // Otherwise flush the scheduler starting with this action.
            return scheduler.flush(this);
        };
        return QueueAction;
    }(AsyncAction_1.AsyncAction);
    exports.QueueAction = QueueAction;
    
});
System.registerDynamic("rxjs/scheduler/QueueScheduler.js", ["rxjs/scheduler/AsyncScheduler.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var AsyncScheduler_1 = $__require("rxjs/scheduler/AsyncScheduler.js");
    var QueueScheduler = function (_super) {
        __extends(QueueScheduler, _super);
        function QueueScheduler() {
            _super.apply(this, arguments);
        }
        return QueueScheduler;
    }(AsyncScheduler_1.AsyncScheduler);
    exports.QueueScheduler = QueueScheduler;
    
});
System.registerDynamic('rxjs/scheduler/queue.js', ['rxjs/scheduler/QueueAction.js', 'rxjs/scheduler/QueueScheduler.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var QueueAction_1 = $__require('rxjs/scheduler/QueueAction.js');
  var QueueScheduler_1 = $__require('rxjs/scheduler/QueueScheduler.js');
  /**
   *
   * Queue Scheduler
   *
   * <span class="informal">Put every next task on a queue, instead of executing it immediately</span>
   *
   * `queue` scheduler, when used with delay, behaves the same as {@link async} scheduler.
   *
   * When used without delay, it schedules given task synchronously - executes it right when
   * it is scheduled. However when called recursively, that is when inside the scheduled task,
   * another task is scheduled with queue scheduler, instead of executing immediately as well,
   * that task will be put on a queue and wait for current one to finish.
   *
   * This means that when you execute task with `queue` scheduler, you are sure it will end
   * before any other task scheduled with that scheduler will start.
   *
   * @examples <caption>Schedule recursively first, then do something</caption>
   *
   * Rx.Scheduler.queue.schedule(() => {
   *   Rx.Scheduler.queue.schedule(() => console.log('second')); // will not happen now, but will be put on a queue
   *
   *   console.log('first');
   * });
   *
   * // Logs:
   * // "first"
   * // "second"
   *
   *
   * @example <caption>Reschedule itself recursively</caption>
   *
   * Rx.Scheduler.queue.schedule(function(state) {
   *   if (state !== 0) {
   *     console.log('before', state);
   *     this.schedule(state - 1); // `this` references currently executing Action,
   *                               // which we reschedule with new state
   *     console.log('after', state);
   *   }
   * }, 0, 3);
   *
   * // In scheduler that runs recursively, you would expect:
   * // "before", 3
   * // "before", 2
   * // "before", 1
   * // "after", 1
   * // "after", 2
   * // "after", 3
   *
   * // But with queue it logs:
   * // "before", 3
   * // "after", 3
   * // "before", 2
   * // "after", 2
   * // "before", 1
   * // "after", 1
   *
   *
   * @static true
   * @name queue
   * @owner Scheduler
   */
  exports.queue = new QueueScheduler_1.QueueScheduler(QueueAction_1.QueueAction);
  
});
System.registerDynamic('rxjs/ReplaySubject.js', ['rxjs/Subject.js', 'rxjs/scheduler/queue.js', 'rxjs/Subscription.js', 'rxjs/operators/observeOn.js', 'rxjs/util/ObjectUnsubscribedError.js', 'rxjs/SubjectSubscription.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subject_1 = $__require('rxjs/Subject.js');
    var queue_1 = $__require('rxjs/scheduler/queue.js');
    var Subscription_1 = $__require('rxjs/Subscription.js');
    var observeOn_1 = $__require('rxjs/operators/observeOn.js');
    var ObjectUnsubscribedError_1 = $__require('rxjs/util/ObjectUnsubscribedError.js');
    var SubjectSubscription_1 = $__require('rxjs/SubjectSubscription.js');
    /**
     * @class ReplaySubject<T>
     */
    var ReplaySubject = function (_super) {
        __extends(ReplaySubject, _super);
        function ReplaySubject(bufferSize, windowTime, scheduler) {
            if (bufferSize === void 0) {
                bufferSize = Number.POSITIVE_INFINITY;
            }
            if (windowTime === void 0) {
                windowTime = Number.POSITIVE_INFINITY;
            }
            _super.call(this);
            this.scheduler = scheduler;
            this._events = [];
            this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
            this._windowTime = windowTime < 1 ? 1 : windowTime;
        }
        ReplaySubject.prototype.next = function (value) {
            var now = this._getNow();
            this._events.push(new ReplayEvent(now, value));
            this._trimBufferThenGetEvents();
            _super.prototype.next.call(this, value);
        };
        /** @deprecated internal use only */ReplaySubject.prototype._subscribe = function (subscriber) {
            var _events = this._trimBufferThenGetEvents();
            var scheduler = this.scheduler;
            var subscription;
            if (this.closed) {
                throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
            } else if (this.hasError) {
                subscription = Subscription_1.Subscription.EMPTY;
            } else if (this.isStopped) {
                subscription = Subscription_1.Subscription.EMPTY;
            } else {
                this.observers.push(subscriber);
                subscription = new SubjectSubscription_1.SubjectSubscription(this, subscriber);
            }
            if (scheduler) {
                subscriber.add(subscriber = new observeOn_1.ObserveOnSubscriber(subscriber, scheduler));
            }
            var len = _events.length;
            for (var i = 0; i < len && !subscriber.closed; i++) {
                subscriber.next(_events[i].value);
            }
            if (this.hasError) {
                subscriber.error(this.thrownError);
            } else if (this.isStopped) {
                subscriber.complete();
            }
            return subscription;
        };
        ReplaySubject.prototype._getNow = function () {
            return (this.scheduler || queue_1.queue).now();
        };
        ReplaySubject.prototype._trimBufferThenGetEvents = function () {
            var now = this._getNow();
            var _bufferSize = this._bufferSize;
            var _windowTime = this._windowTime;
            var _events = this._events;
            var eventsCount = _events.length;
            var spliceCount = 0;
            // Trim events that fall out of the time window.
            // Start at the front of the list. Break early once
            // we encounter an event that falls within the window.
            while (spliceCount < eventsCount) {
                if (now - _events[spliceCount].time < _windowTime) {
                    break;
                }
                spliceCount++;
            }
            if (eventsCount > _bufferSize) {
                spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
            }
            if (spliceCount > 0) {
                _events.splice(0, spliceCount);
            }
            return _events;
        };
        return ReplaySubject;
    }(Subject_1.Subject);
    exports.ReplaySubject = ReplaySubject;
    var ReplayEvent = function () {
        function ReplayEvent(time, value) {
            this.time = time;
            this.value = value;
        }
        return ReplayEvent;
    }();
    
});
System.registerDynamic("rxjs/operators/shareReplay.js", ["rxjs/ReplaySubject.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var ReplaySubject_1 = $__require("rxjs/ReplaySubject.js");
    /**
     * @method shareReplay
     * @owner Observable
     */
    function shareReplay(bufferSize, windowTime, scheduler) {
        return function (source) {
            return source.lift(shareReplayOperator(bufferSize, windowTime, scheduler));
        };
    }
    exports.shareReplay = shareReplay;
    function shareReplayOperator(bufferSize, windowTime, scheduler) {
        var subject;
        var refCount = 0;
        var subscription;
        var hasError = false;
        var isComplete = false;
        return function shareReplayOperation(source) {
            refCount++;
            if (!subject || hasError) {
                hasError = false;
                subject = new ReplaySubject_1.ReplaySubject(bufferSize, windowTime, scheduler);
                subscription = source.subscribe({
                    next: function (value) {
                        subject.next(value);
                    },
                    error: function (err) {
                        hasError = true;
                        subject.error(err);
                    },
                    complete: function () {
                        isComplete = true;
                        subject.complete();
                    }
                });
            }
            var innerSub = subject.subscribe(this);
            return function () {
                refCount--;
                innerSub.unsubscribe();
                if (subscription && refCount === 0 && isComplete) {
                    subscription.unsubscribe();
                }
            };
        };
    }
    ;
    
});
System.registerDynamic('rxjs/util/EmptyError.js', [], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    /**
     * An error thrown when an Observable or a sequence was queried but has no
     * elements.
     *
     * @see {@link first}
     * @see {@link last}
     * @see {@link single}
     *
     * @class EmptyError
     */
    var EmptyError = function (_super) {
        __extends(EmptyError, _super);
        function EmptyError() {
            var err = _super.call(this, 'no elements in sequence');
            this.name = err.name = 'EmptyError';
            this.stack = err.stack;
            this.message = err.message;
        }
        return EmptyError;
    }(Error);
    exports.EmptyError = EmptyError;
    
});
System.registerDynamic('rxjs/operators/single.js', ['rxjs/Subscriber.js', 'rxjs/util/EmptyError.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require('rxjs/Subscriber.js');
    var EmptyError_1 = $__require('rxjs/util/EmptyError.js');
    /**
     * Returns an Observable that emits the single item emitted by the source Observable that matches a specified
     * predicate, if that Observable emits one such item. If the source Observable emits more than one such item or no
     * such items, notify of an IllegalArgumentException or NoSuchElementException respectively.
     *
     * <img src="./img/single.png" width="100%">
     *
     * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
     * callback if the Observable completes before any `next` notification was sent.
     * @param {Function} predicate - A predicate function to evaluate items emitted by the source Observable.
     * @return {Observable<T>} An Observable that emits the single item emitted by the source Observable that matches
     * the predicate.
     .
     * @method single
     * @owner Observable
     */
    function single(predicate) {
        return function (source) {
            return source.lift(new SingleOperator(predicate, source));
        };
    }
    exports.single = single;
    var SingleOperator = function () {
        function SingleOperator(predicate, source) {
            this.predicate = predicate;
            this.source = source;
        }
        SingleOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new SingleSubscriber(subscriber, this.predicate, this.source));
        };
        return SingleOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var SingleSubscriber = function (_super) {
        __extends(SingleSubscriber, _super);
        function SingleSubscriber(destination, predicate, source) {
            _super.call(this, destination);
            this.predicate = predicate;
            this.source = source;
            this.seenValue = false;
            this.index = 0;
        }
        SingleSubscriber.prototype.applySingleValue = function (value) {
            if (this.seenValue) {
                this.destination.error('Sequence contains more than one element');
            } else {
                this.seenValue = true;
                this.singleValue = value;
            }
        };
        SingleSubscriber.prototype._next = function (value) {
            var index = this.index++;
            if (this.predicate) {
                this.tryNext(value, index);
            } else {
                this.applySingleValue(value);
            }
        };
        SingleSubscriber.prototype.tryNext = function (value, index) {
            try {
                if (this.predicate(value, index, this.source)) {
                    this.applySingleValue(value);
                }
            } catch (err) {
                this.destination.error(err);
            }
        };
        SingleSubscriber.prototype._complete = function () {
            var destination = this.destination;
            if (this.index > 0) {
                destination.next(this.seenValue ? this.singleValue : undefined);
                destination.complete();
            } else {
                destination.error(new EmptyError_1.EmptyError());
            }
        };
        return SingleSubscriber;
    }(Subscriber_1.Subscriber);
    
});
System.registerDynamic("rxjs/operators/skip.js", ["rxjs/Subscriber.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require("rxjs/Subscriber.js");
    /**
     * Returns an Observable that skips the first `count` items emitted by the source Observable.
     *
     * <img src="./img/skip.png" width="100%">
     *
     * @param {Number} count - The number of times, items emitted by source Observable should be skipped.
     * @return {Observable} An Observable that skips values emitted by the source Observable.
     *
     * @method skip
     * @owner Observable
     */
    function skip(count) {
        return function (source) {
            return source.lift(new SkipOperator(count));
        };
    }
    exports.skip = skip;
    var SkipOperator = function () {
        function SkipOperator(total) {
            this.total = total;
        }
        SkipOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new SkipSubscriber(subscriber, this.total));
        };
        return SkipOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var SkipSubscriber = function (_super) {
        __extends(SkipSubscriber, _super);
        function SkipSubscriber(destination, total) {
            _super.call(this, destination);
            this.total = total;
            this.count = 0;
        }
        SkipSubscriber.prototype._next = function (x) {
            if (++this.count > this.total) {
                this.destination.next(x);
            }
        };
        return SkipSubscriber;
    }(Subscriber_1.Subscriber);
    
});
System.registerDynamic('rxjs/operators/skipLast.js', ['rxjs/Subscriber.js', 'rxjs/util/ArgumentOutOfRangeError.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require('rxjs/Subscriber.js');
    var ArgumentOutOfRangeError_1 = $__require('rxjs/util/ArgumentOutOfRangeError.js');
    /**
     * Skip the last `count` values emitted by the source Observable.
     *
     * <img src="./img/skipLast.png" width="100%">
     *
     * `skipLast` returns an Observable that accumulates a queue with a length
     * enough to store the first `count` values. As more values are received,
     * values are taken from the front of the queue and produced on the result
     * sequence. This causes values to be delayed.
     *
     * @example <caption>Skip the last 2 values of an Observable with many values</caption>
     * var many = Rx.Observable.range(1, 5);
     * var skipLastTwo = many.skipLast(2);
     * skipLastTwo.subscribe(x => console.log(x));
     *
     * // Results in:
     * // 1 2 3
     *
     * @see {@link skip}
     * @see {@link skipUntil}
     * @see {@link skipWhile}
     * @see {@link take}
     *
     * @throws {ArgumentOutOfRangeError} When using `skipLast(i)`, it throws
     * ArgumentOutOrRangeError if `i < 0`.
     *
     * @param {number} count Number of elements to skip from the end of the source Observable.
     * @returns {Observable<T>} An Observable that skips the last count values
     * emitted by the source Observable.
     * @method skipLast
     * @owner Observable
     */
    function skipLast(count) {
        return function (source) {
            return source.lift(new SkipLastOperator(count));
        };
    }
    exports.skipLast = skipLast;
    var SkipLastOperator = function () {
        function SkipLastOperator(_skipCount) {
            this._skipCount = _skipCount;
            if (this._skipCount < 0) {
                throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError();
            }
        }
        SkipLastOperator.prototype.call = function (subscriber, source) {
            if (this._skipCount === 0) {
                // If we don't want to skip any values then just subscribe
                // to Subscriber without any further logic.
                return source.subscribe(new Subscriber_1.Subscriber(subscriber));
            } else {
                return source.subscribe(new SkipLastSubscriber(subscriber, this._skipCount));
            }
        };
        return SkipLastOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var SkipLastSubscriber = function (_super) {
        __extends(SkipLastSubscriber, _super);
        function SkipLastSubscriber(destination, _skipCount) {
            _super.call(this, destination);
            this._skipCount = _skipCount;
            this._count = 0;
            this._ring = new Array(_skipCount);
        }
        SkipLastSubscriber.prototype._next = function (value) {
            var skipCount = this._skipCount;
            var count = this._count++;
            if (count < skipCount) {
                this._ring[count] = value;
            } else {
                var currentIndex = count % skipCount;
                var ring = this._ring;
                var oldValue = ring[currentIndex];
                ring[currentIndex] = value;
                this.destination.next(oldValue);
            }
        };
        return SkipLastSubscriber;
    }(Subscriber_1.Subscriber);
    
});
System.registerDynamic('rxjs/operators/skipUntil.js', ['rxjs/OuterSubscriber.js', 'rxjs/util/subscribeToResult.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var OuterSubscriber_1 = $__require('rxjs/OuterSubscriber.js');
    var subscribeToResult_1 = $__require('rxjs/util/subscribeToResult.js');
    /**
     * Returns an Observable that skips items emitted by the source Observable until a second Observable emits an item.
     *
     * <img src="./img/skipUntil.png" width="100%">
     *
     * @param {Observable} notifier - The second Observable that has to emit an item before the source Observable's elements begin to
     * be mirrored by the resulting Observable.
     * @return {Observable<T>} An Observable that skips items from the source Observable until the second Observable emits
     * an item, then emits the remaining items.
     * @method skipUntil
     * @owner Observable
     */
    function skipUntil(notifier) {
        return function (source) {
            return source.lift(new SkipUntilOperator(notifier));
        };
    }
    exports.skipUntil = skipUntil;
    var SkipUntilOperator = function () {
        function SkipUntilOperator(notifier) {
            this.notifier = notifier;
        }
        SkipUntilOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new SkipUntilSubscriber(subscriber, this.notifier));
        };
        return SkipUntilOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var SkipUntilSubscriber = function (_super) {
        __extends(SkipUntilSubscriber, _super);
        function SkipUntilSubscriber(destination, notifier) {
            _super.call(this, destination);
            this.hasValue = false;
            this.isInnerStopped = false;
            this.add(subscribeToResult_1.subscribeToResult(this, notifier));
        }
        SkipUntilSubscriber.prototype._next = function (value) {
            if (this.hasValue) {
                _super.prototype._next.call(this, value);
            }
        };
        SkipUntilSubscriber.prototype._complete = function () {
            if (this.isInnerStopped) {
                _super.prototype._complete.call(this);
            } else {
                this.unsubscribe();
            }
        };
        SkipUntilSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this.hasValue = true;
        };
        SkipUntilSubscriber.prototype.notifyComplete = function () {
            this.isInnerStopped = true;
            if (this.isStopped) {
                _super.prototype._complete.call(this);
            }
        };
        return SkipUntilSubscriber;
    }(OuterSubscriber_1.OuterSubscriber);
    
});
System.registerDynamic("rxjs/operators/skipWhile.js", ["rxjs/Subscriber.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require("rxjs/Subscriber.js");
    /**
     * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
     * true, but emits all further source items as soon as the condition becomes false.
     *
     * <img src="./img/skipWhile.png" width="100%">
     *
     * @param {Function} predicate - A function to test each item emitted from the source Observable.
     * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
     * specified predicate becomes false.
     * @method skipWhile
     * @owner Observable
     */
    function skipWhile(predicate) {
        return function (source) {
            return source.lift(new SkipWhileOperator(predicate));
        };
    }
    exports.skipWhile = skipWhile;
    var SkipWhileOperator = function () {
        function SkipWhileOperator(predicate) {
            this.predicate = predicate;
        }
        SkipWhileOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new SkipWhileSubscriber(subscriber, this.predicate));
        };
        return SkipWhileOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var SkipWhileSubscriber = function (_super) {
        __extends(SkipWhileSubscriber, _super);
        function SkipWhileSubscriber(destination, predicate) {
            _super.call(this, destination);
            this.predicate = predicate;
            this.skipping = true;
            this.index = 0;
        }
        SkipWhileSubscriber.prototype._next = function (value) {
            var destination = this.destination;
            if (this.skipping) {
                this.tryCallPredicate(value);
            }
            if (!this.skipping) {
                destination.next(value);
            }
        };
        SkipWhileSubscriber.prototype.tryCallPredicate = function (value) {
            try {
                var result = this.predicate(value, this.index++);
                this.skipping = Boolean(result);
            } catch (err) {
                this.destination.error(err);
            }
        };
        return SkipWhileSubscriber;
    }(Subscriber_1.Subscriber);
    
});
System.registerDynamic("rxjs/observable/of.js", ["rxjs/observable/ArrayObservable.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var ArrayObservable_1 = $__require("rxjs/observable/ArrayObservable.js");
  exports.of = ArrayObservable_1.ArrayObservable.of;
  
});
System.registerDynamic("rxjs/operators/concatAll.js", ["rxjs/operators/mergeAll.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var mergeAll_1 = $__require("rxjs/operators/mergeAll.js");
  /**
   * Converts a higher-order Observable into a first-order Observable by
   * concatenating the inner Observables in order.
   *
   * <span class="informal">Flattens an Observable-of-Observables by putting one
   * inner Observable after the other.</span>
   *
   * <img src="./img/concatAll.png" width="100%">
   *
   * Joins every Observable emitted by the source (a higher-order Observable), in
   * a serial fashion. It subscribes to each inner Observable only after the
   * previous inner Observable has completed, and merges all of their values into
   * the returned observable.
   *
   * __Warning:__ If the source Observable emits Observables quickly and
   * endlessly, and the inner Observables it emits generally complete slower than
   * the source emits, you can run into memory issues as the incoming Observables
   * collect in an unbounded buffer.
   *
   * Note: `concatAll` is equivalent to `mergeAll` with concurrency parameter set
   * to `1`.
   *
   * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var higherOrder = clicks.map(ev => Rx.Observable.interval(1000).take(4));
   * var firstOrder = higherOrder.concatAll();
   * firstOrder.subscribe(x => console.log(x));
   *
   * // Results in the following:
   * // (results are not concurrent)
   * // For every click on the "document" it will emit values 0 to 3 spaced
   * // on a 1000ms interval
   * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
   *
   * @see {@link combineAll}
   * @see {@link concat}
   * @see {@link concatMap}
   * @see {@link concatMapTo}
   * @see {@link exhaust}
   * @see {@link mergeAll}
   * @see {@link switch}
   * @see {@link zipAll}
   *
   * @return {Observable} An Observable emitting values from all the inner
   * Observables concatenated.
   * @method concatAll
   * @owner Observable
   */
  function concatAll() {
    return mergeAll_1.mergeAll(1);
  }
  exports.concatAll = concatAll;
  
});
System.registerDynamic('rxjs/observable/concat.js', ['rxjs/util/isScheduler.js', 'rxjs/observable/of.js', 'rxjs/observable/from.js', 'rxjs/operators/concatAll.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var isScheduler_1 = $__require('rxjs/util/isScheduler.js');
    var of_1 = $__require('rxjs/observable/of.js');
    var from_1 = $__require('rxjs/observable/from.js');
    var concatAll_1 = $__require('rxjs/operators/concatAll.js');
    /* tslint:enable:max-line-length */
    /**
     * Creates an output Observable which sequentially emits all values from given
     * Observable and then moves on to the next.
     *
     * <span class="informal">Concatenates multiple Observables together by
     * sequentially emitting their values, one Observable after the other.</span>
     *
     * <img src="./img/concat.png" width="100%">
     *
     * `concat` joins multiple Observables together, by subscribing to them one at a time and
     * merging their results into the output Observable. You can pass either an array of
     * Observables, or put them directly as arguments. Passing an empty array will result
     * in Observable that completes immediately.
     *
     * `concat` will subscribe to first input Observable and emit all its values, without
     * changing or affecting them in any way. When that Observable completes, it will
     * subscribe to then next Observable passed and, again, emit its values. This will be
     * repeated, until the operator runs out of Observables. When last input Observable completes,
     * `concat` will complete as well. At any given moment only one Observable passed to operator
     * emits values. If you would like to emit values from passed Observables concurrently, check out
     * {@link merge} instead, especially with optional `concurrent` parameter. As a matter of fact,
     * `concat` is an equivalent of `merge` operator with `concurrent` parameter set to `1`.
     *
     * Note that if some input Observable never completes, `concat` will also never complete
     * and Observables following the one that did not complete will never be subscribed. On the other
     * hand, if some Observable simply completes immediately after it is subscribed, it will be
     * invisible for `concat`, which will just move on to the next Observable.
     *
     * If any Observable in chain errors, instead of passing control to the next Observable,
     * `concat` will error immediately as well. Observables that would be subscribed after
     * the one that emitted error, never will.
     *
     * If you pass to `concat` the same Observable many times, its stream of values
     * will be "replayed" on every subscription, which means you can repeat given Observable
     * as many times as you like. If passing the same Observable to `concat` 1000 times becomes tedious,
     * you can always use {@link repeat}.
     *
     * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
     * var timer = Rx.Observable.interval(1000).take(4);
     * var sequence = Rx.Observable.range(1, 10);
     * var result = Rx.Observable.concat(timer, sequence);
     * result.subscribe(x => console.log(x));
     *
     * // results in:
     * // 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
     *
     *
     * @example <caption>Concatenate an array of 3 Observables</caption>
     * var timer1 = Rx.Observable.interval(1000).take(10);
     * var timer2 = Rx.Observable.interval(2000).take(6);
     * var timer3 = Rx.Observable.interval(500).take(10);
     * var result = Rx.Observable.concat([timer1, timer2, timer3]); // note that array is passed
     * result.subscribe(x => console.log(x));
     *
     * // results in the following:
     * // (Prints to console sequentially)
     * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
     * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
     * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
     *
     *
     * @example <caption>Concatenate the same Observable to repeat it</caption>
     * const timer = Rx.Observable.interval(1000).take(2);
     *
     * Rx.Observable.concat(timer, timer) // concating the same Observable!
     * .subscribe(
     *   value => console.log(value),
     *   err => {},
     *   () => console.log('...and it is done!')
     * );
     *
     * // Logs:
     * // 0 after 1s
     * // 1 after 2s
     * // 0 after 3s
     * // 1 after 4s
     * // "...and it is done!" also after 4s
     *
     * @see {@link concatAll}
     * @see {@link concatMap}
     * @see {@link concatMapTo}
     *
     * @param {ObservableInput} input1 An input Observable to concatenate with others.
     * @param {ObservableInput} input2 An input Observable to concatenate with others.
     * More than one input Observables may be given as argument.
     * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
     * Observable subscription on.
     * @return {Observable} All values of each passed Observable merged into a
     * single Observable, in order, in serial fashion.
     * @static true
     * @name concat
     * @owner Observable
     */
    function concat() {
        var observables = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            observables[_i - 0] = arguments[_i];
        }
        if (observables.length === 1 || observables.length === 2 && isScheduler_1.isScheduler(observables[1])) {
            return from_1.from(observables[0]);
        }
        return concatAll_1.concatAll()(of_1.of.apply(void 0, observables));
    }
    exports.concat = concat;
    
});
System.registerDynamic('rxjs/operators/startWith.js', ['rxjs/observable/ArrayObservable.js', 'rxjs/observable/ScalarObservable.js', 'rxjs/observable/EmptyObservable.js', 'rxjs/observable/concat.js', 'rxjs/util/isScheduler.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var ArrayObservable_1 = $__require('rxjs/observable/ArrayObservable.js');
    var ScalarObservable_1 = $__require('rxjs/observable/ScalarObservable.js');
    var EmptyObservable_1 = $__require('rxjs/observable/EmptyObservable.js');
    var concat_1 = $__require('rxjs/observable/concat.js');
    var isScheduler_1 = $__require('rxjs/util/isScheduler.js');
    /* tslint:enable:max-line-length */
    /**
     * Returns an Observable that emits the items you specify as arguments before it begins to emit
     * items emitted by the source Observable.
     *
     * <img src="./img/startWith.png" width="100%">
     *
     * @param {...T} values - Items you want the modified Observable to emit first.
     * @param {Scheduler} [scheduler] - A {@link IScheduler} to use for scheduling
     * the emissions of the `next` notifications.
     * @return {Observable} An Observable that emits the items in the specified Iterable and then emits the items
     * emitted by the source Observable.
     * @method startWith
     * @owner Observable
     */
    function startWith() {
        var array = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            array[_i - 0] = arguments[_i];
        }
        return function (source) {
            var scheduler = array[array.length - 1];
            if (isScheduler_1.isScheduler(scheduler)) {
                array.pop();
            } else {
                scheduler = null;
            }
            var len = array.length;
            if (len === 1) {
                return concat_1.concat(new ScalarObservable_1.ScalarObservable(array[0], scheduler), source);
            } else if (len > 1) {
                return concat_1.concat(new ArrayObservable_1.ArrayObservable(array, scheduler), source);
            } else {
                return concat_1.concat(new EmptyObservable_1.EmptyObservable(scheduler), source);
            }
        };
    }
    exports.startWith = startWith;
    
});
System.registerDynamic('rxjs/operators/switchAll.js', ['rxjs/operators/switchMap.js', 'rxjs/util/identity.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var switchMap_1 = $__require('rxjs/operators/switchMap.js');
    var identity_1 = $__require('rxjs/util/identity.js');
    function switchAll() {
        return switchMap_1.switchMap(identity_1.identity);
    }
    exports.switchAll = switchAll;
    
});
System.registerDynamic('rxjs/operators/switchMap.js', ['rxjs/OuterSubscriber.js', 'rxjs/util/subscribeToResult.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var OuterSubscriber_1 = $__require('rxjs/OuterSubscriber.js');
    var subscribeToResult_1 = $__require('rxjs/util/subscribeToResult.js');
    /* tslint:enable:max-line-length */
    /**
     * Projects each source value to an Observable which is merged in the output
     * Observable, emitting values only from the most recently projected Observable.
     *
     * <span class="informal">Maps each value to an Observable, then flattens all of
     * these inner Observables using {@link switch}.</span>
     *
     * <img src="./img/switchMap.png" width="100%">
     *
     * Returns an Observable that emits items based on applying a function that you
     * supply to each item emitted by the source Observable, where that function
     * returns an (so-called "inner") Observable. Each time it observes one of these
     * inner Observables, the output Observable begins emitting the items emitted by
     * that inner Observable. When a new inner Observable is emitted, `switchMap`
     * stops emitting items from the earlier-emitted inner Observable and begins
     * emitting items from the new one. It continues to behave like this for
     * subsequent inner Observables.
     *
     * @example <caption>Rerun an interval Observable on every click event</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
     * result.subscribe(x => console.log(x));
     *
     * @see {@link concatMap}
     * @see {@link exhaustMap}
     * @see {@link mergeMap}
     * @see {@link switch}
     * @see {@link switchMapTo}
     *
     * @param {function(value: T, ?index: number): ObservableInput} project A function
     * that, when applied to an item emitted by the source Observable, returns an
     * Observable.
     * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
     * A function to produce the value on the output Observable based on the values
     * and the indices of the source (outer) emission and the inner Observable
     * emission. The arguments passed to this function are:
     * - `outerValue`: the value that came from the source
     * - `innerValue`: the value that came from the projected Observable
     * - `outerIndex`: the "index" of the value that came from the source
     * - `innerIndex`: the "index" of the value from the projected Observable
     * @return {Observable} An Observable that emits the result of applying the
     * projection function (and the optional `resultSelector`) to each item emitted
     * by the source Observable and taking only the values from the most recently
     * projected inner Observable.
     * @method switchMap
     * @owner Observable
     */
    function switchMap(project, resultSelector) {
        return function switchMapOperatorFunction(source) {
            return source.lift(new SwitchMapOperator(project, resultSelector));
        };
    }
    exports.switchMap = switchMap;
    var SwitchMapOperator = function () {
        function SwitchMapOperator(project, resultSelector) {
            this.project = project;
            this.resultSelector = resultSelector;
        }
        SwitchMapOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new SwitchMapSubscriber(subscriber, this.project, this.resultSelector));
        };
        return SwitchMapOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var SwitchMapSubscriber = function (_super) {
        __extends(SwitchMapSubscriber, _super);
        function SwitchMapSubscriber(destination, project, resultSelector) {
            _super.call(this, destination);
            this.project = project;
            this.resultSelector = resultSelector;
            this.index = 0;
        }
        SwitchMapSubscriber.prototype._next = function (value) {
            var result;
            var index = this.index++;
            try {
                result = this.project(value, index);
            } catch (error) {
                this.destination.error(error);
                return;
            }
            this._innerSub(result, value, index);
        };
        SwitchMapSubscriber.prototype._innerSub = function (result, value, index) {
            var innerSubscription = this.innerSubscription;
            if (innerSubscription) {
                innerSubscription.unsubscribe();
            }
            this.add(this.innerSubscription = subscribeToResult_1.subscribeToResult(this, result, value, index));
        };
        SwitchMapSubscriber.prototype._complete = function () {
            var innerSubscription = this.innerSubscription;
            if (!innerSubscription || innerSubscription.closed) {
                _super.prototype._complete.call(this);
            }
        };
        /** @deprecated internal use only */SwitchMapSubscriber.prototype._unsubscribe = function () {
            this.innerSubscription = null;
        };
        SwitchMapSubscriber.prototype.notifyComplete = function (innerSub) {
            this.remove(innerSub);
            this.innerSubscription = null;
            if (this.isStopped) {
                _super.prototype._complete.call(this);
            }
        };
        SwitchMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            if (this.resultSelector) {
                this._tryNotifyNext(outerValue, innerValue, outerIndex, innerIndex);
            } else {
                this.destination.next(innerValue);
            }
        };
        SwitchMapSubscriber.prototype._tryNotifyNext = function (outerValue, innerValue, outerIndex, innerIndex) {
            var result;
            try {
                result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
            } catch (err) {
                this.destination.error(err);
                return;
            }
            this.destination.next(result);
        };
        return SwitchMapSubscriber;
    }(OuterSubscriber_1.OuterSubscriber);
    
});
System.registerDynamic('rxjs/operators/switchMapTo.js', ['rxjs/OuterSubscriber.js', 'rxjs/util/subscribeToResult.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var OuterSubscriber_1 = $__require('rxjs/OuterSubscriber.js');
    var subscribeToResult_1 = $__require('rxjs/util/subscribeToResult.js');
    /* tslint:enable:max-line-length */
    /**
     * Projects each source value to the same Observable which is flattened multiple
     * times with {@link switch} in the output Observable.
     *
     * <span class="informal">It's like {@link switchMap}, but maps each value
     * always to the same inner Observable.</span>
     *
     * <img src="./img/switchMapTo.png" width="100%">
     *
     * Maps each source value to the given Observable `innerObservable` regardless
     * of the source value, and then flattens those resulting Observables into one
     * single Observable, which is the output Observable. The output Observables
     * emits values only from the most recently emitted instance of
     * `innerObservable`.
     *
     * @example <caption>Rerun an interval Observable on every click event</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var result = clicks.switchMapTo(Rx.Observable.interval(1000));
     * result.subscribe(x => console.log(x));
     *
     * @see {@link concatMapTo}
     * @see {@link switch}
     * @see {@link switchMap}
     * @see {@link mergeMapTo}
     *
     * @param {ObservableInput} innerObservable An Observable to replace each value from
     * the source Observable.
     * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
     * A function to produce the value on the output Observable based on the values
     * and the indices of the source (outer) emission and the inner Observable
     * emission. The arguments passed to this function are:
     * - `outerValue`: the value that came from the source
     * - `innerValue`: the value that came from the projected Observable
     * - `outerIndex`: the "index" of the value that came from the source
     * - `innerIndex`: the "index" of the value from the projected Observable
     * @return {Observable} An Observable that emits items from the given
     * `innerObservable` (and optionally transformed through `resultSelector`) every
     * time a value is emitted on the source Observable, and taking only the values
     * from the most recently projected inner Observable.
     * @method switchMapTo
     * @owner Observable
     */
    function switchMapTo(innerObservable, resultSelector) {
        return function (source) {
            return source.lift(new SwitchMapToOperator(innerObservable, resultSelector));
        };
    }
    exports.switchMapTo = switchMapTo;
    var SwitchMapToOperator = function () {
        function SwitchMapToOperator(observable, resultSelector) {
            this.observable = observable;
            this.resultSelector = resultSelector;
        }
        SwitchMapToOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new SwitchMapToSubscriber(subscriber, this.observable, this.resultSelector));
        };
        return SwitchMapToOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var SwitchMapToSubscriber = function (_super) {
        __extends(SwitchMapToSubscriber, _super);
        function SwitchMapToSubscriber(destination, inner, resultSelector) {
            _super.call(this, destination);
            this.inner = inner;
            this.resultSelector = resultSelector;
            this.index = 0;
        }
        SwitchMapToSubscriber.prototype._next = function (value) {
            var innerSubscription = this.innerSubscription;
            if (innerSubscription) {
                innerSubscription.unsubscribe();
            }
            this.add(this.innerSubscription = subscribeToResult_1.subscribeToResult(this, this.inner, value, this.index++));
        };
        SwitchMapToSubscriber.prototype._complete = function () {
            var innerSubscription = this.innerSubscription;
            if (!innerSubscription || innerSubscription.closed) {
                _super.prototype._complete.call(this);
            }
        };
        /** @deprecated internal use only */SwitchMapToSubscriber.prototype._unsubscribe = function () {
            this.innerSubscription = null;
        };
        SwitchMapToSubscriber.prototype.notifyComplete = function (innerSub) {
            this.remove(innerSub);
            this.innerSubscription = null;
            if (this.isStopped) {
                _super.prototype._complete.call(this);
            }
        };
        SwitchMapToSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            var _a = this,
                resultSelector = _a.resultSelector,
                destination = _a.destination;
            if (resultSelector) {
                this.tryResultSelector(outerValue, innerValue, outerIndex, innerIndex);
            } else {
                destination.next(innerValue);
            }
        };
        SwitchMapToSubscriber.prototype.tryResultSelector = function (outerValue, innerValue, outerIndex, innerIndex) {
            var _a = this,
                resultSelector = _a.resultSelector,
                destination = _a.destination;
            var result;
            try {
                result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
            } catch (err) {
                destination.error(err);
                return;
            }
            destination.next(result);
        };
        return SwitchMapToSubscriber;
    }(OuterSubscriber_1.OuterSubscriber);
    
});
System.registerDynamic('rxjs/operators/take.js', ['rxjs/Subscriber.js', 'rxjs/util/ArgumentOutOfRangeError.js', 'rxjs/observable/EmptyObservable.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require('rxjs/Subscriber.js');
    var ArgumentOutOfRangeError_1 = $__require('rxjs/util/ArgumentOutOfRangeError.js');
    var EmptyObservable_1 = $__require('rxjs/observable/EmptyObservable.js');
    /**
     * Emits only the first `count` values emitted by the source Observable.
     *
     * <span class="informal">Takes the first `count` values from the source, then
     * completes.</span>
     *
     * <img src="./img/take.png" width="100%">
     *
     * `take` returns an Observable that emits only the first `count` values emitted
     * by the source Observable. If the source emits fewer than `count` values then
     * all of its values are emitted. After that, it completes, regardless if the
     * source completes.
     *
     * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
     * var interval = Rx.Observable.interval(1000);
     * var five = interval.take(5);
     * five.subscribe(x => console.log(x));
     *
     * @see {@link takeLast}
     * @see {@link takeUntil}
     * @see {@link takeWhile}
     * @see {@link skip}
     *
     * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
     * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
     *
     * @param {number} count The maximum number of `next` values to emit.
     * @return {Observable<T>} An Observable that emits only the first `count`
     * values emitted by the source Observable, or all of the values from the source
     * if the source emits fewer than `count` values.
     * @method take
     * @owner Observable
     */
    function take(count) {
        return function (source) {
            if (count === 0) {
                return new EmptyObservable_1.EmptyObservable();
            } else {
                return source.lift(new TakeOperator(count));
            }
        };
    }
    exports.take = take;
    var TakeOperator = function () {
        function TakeOperator(total) {
            this.total = total;
            if (this.total < 0) {
                throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError();
            }
        }
        TakeOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new TakeSubscriber(subscriber, this.total));
        };
        return TakeOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var TakeSubscriber = function (_super) {
        __extends(TakeSubscriber, _super);
        function TakeSubscriber(destination, total) {
            _super.call(this, destination);
            this.total = total;
            this.count = 0;
        }
        TakeSubscriber.prototype._next = function (value) {
            var total = this.total;
            var count = ++this.count;
            if (count <= total) {
                this.destination.next(value);
                if (count === total) {
                    this.destination.complete();
                    this.unsubscribe();
                }
            }
        };
        return TakeSubscriber;
    }(Subscriber_1.Subscriber);
    
});
System.registerDynamic('rxjs/operators/takeUntil.js', ['rxjs/OuterSubscriber.js', 'rxjs/util/subscribeToResult.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var OuterSubscriber_1 = $__require('rxjs/OuterSubscriber.js');
    var subscribeToResult_1 = $__require('rxjs/util/subscribeToResult.js');
    /**
     * Emits the values emitted by the source Observable until a `notifier`
     * Observable emits a value.
     *
     * <span class="informal">Lets values pass until a second Observable,
     * `notifier`, emits something. Then, it completes.</span>
     *
     * <img src="./img/takeUntil.png" width="100%">
     *
     * `takeUntil` subscribes and begins mirroring the source Observable. It also
     * monitors a second Observable, `notifier` that you provide. If the `notifier`
     * emits a value or a complete notification, the output Observable stops
     * mirroring the source Observable and completes.
     *
     * @example <caption>Tick every second until the first click happens</caption>
     * var interval = Rx.Observable.interval(1000);
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var result = interval.takeUntil(clicks);
     * result.subscribe(x => console.log(x));
     *
     * @see {@link take}
     * @see {@link takeLast}
     * @see {@link takeWhile}
     * @see {@link skip}
     *
     * @param {Observable} notifier The Observable whose first emitted value will
     * cause the output Observable of `takeUntil` to stop emitting values from the
     * source Observable.
     * @return {Observable<T>} An Observable that emits the values from the source
     * Observable until such time as `notifier` emits its first value.
     * @method takeUntil
     * @owner Observable
     */
    function takeUntil(notifier) {
        return function (source) {
            return source.lift(new TakeUntilOperator(notifier));
        };
    }
    exports.takeUntil = takeUntil;
    var TakeUntilOperator = function () {
        function TakeUntilOperator(notifier) {
            this.notifier = notifier;
        }
        TakeUntilOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new TakeUntilSubscriber(subscriber, this.notifier));
        };
        return TakeUntilOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var TakeUntilSubscriber = function (_super) {
        __extends(TakeUntilSubscriber, _super);
        function TakeUntilSubscriber(destination, notifier) {
            _super.call(this, destination);
            this.notifier = notifier;
            this.add(subscribeToResult_1.subscribeToResult(this, notifier));
        }
        TakeUntilSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this.complete();
        };
        TakeUntilSubscriber.prototype.notifyComplete = function () {
            // noop
        };
        return TakeUntilSubscriber;
    }(OuterSubscriber_1.OuterSubscriber);
    
});
System.registerDynamic("rxjs/operators/takeWhile.js", ["rxjs/Subscriber.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require("rxjs/Subscriber.js");
    /**
     * Emits values emitted by the source Observable so long as each value satisfies
     * the given `predicate`, and then completes as soon as this `predicate` is not
     * satisfied.
     *
     * <span class="informal">Takes values from the source only while they pass the
     * condition given. When the first value does not satisfy, it completes.</span>
     *
     * <img src="./img/takeWhile.png" width="100%">
     *
     * `takeWhile` subscribes and begins mirroring the source Observable. Each value
     * emitted on the source is given to the `predicate` function which returns a
     * boolean, representing a condition to be satisfied by the source values. The
     * output Observable emits the source values until such time as the `predicate`
     * returns false, at which point `takeWhile` stops mirroring the source
     * Observable and completes the output Observable.
     *
     * @example <caption>Emit click events only while the clientX property is greater than 200</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var result = clicks.takeWhile(ev => ev.clientX > 200);
     * result.subscribe(x => console.log(x));
     *
     * @see {@link take}
     * @see {@link takeLast}
     * @see {@link takeUntil}
     * @see {@link skip}
     *
     * @param {function(value: T, index: number): boolean} predicate A function that
     * evaluates a value emitted by the source Observable and returns a boolean.
     * Also takes the (zero-based) index as the second argument.
     * @return {Observable<T>} An Observable that emits the values from the source
     * Observable so long as each value satisfies the condition defined by the
     * `predicate`, then completes.
     * @method takeWhile
     * @owner Observable
     */
    function takeWhile(predicate) {
        return function (source) {
            return source.lift(new TakeWhileOperator(predicate));
        };
    }
    exports.takeWhile = takeWhile;
    var TakeWhileOperator = function () {
        function TakeWhileOperator(predicate) {
            this.predicate = predicate;
        }
        TakeWhileOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new TakeWhileSubscriber(subscriber, this.predicate));
        };
        return TakeWhileOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var TakeWhileSubscriber = function (_super) {
        __extends(TakeWhileSubscriber, _super);
        function TakeWhileSubscriber(destination, predicate) {
            _super.call(this, destination);
            this.predicate = predicate;
            this.index = 0;
        }
        TakeWhileSubscriber.prototype._next = function (value) {
            var destination = this.destination;
            var result;
            try {
                result = this.predicate(value, this.index++);
            } catch (err) {
                destination.error(err);
                return;
            }
            this.nextOrComplete(value, result);
        };
        TakeWhileSubscriber.prototype.nextOrComplete = function (value, predicateResult) {
            var destination = this.destination;
            if (Boolean(predicateResult)) {
                destination.next(value);
            } else {
                destination.complete();
            }
        };
        return TakeWhileSubscriber;
    }(Subscriber_1.Subscriber);
    
});
System.registerDynamic('rxjs/operators/throttle.js', ['rxjs/OuterSubscriber.js', 'rxjs/util/subscribeToResult.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var OuterSubscriber_1 = $__require('rxjs/OuterSubscriber.js');
    var subscribeToResult_1 = $__require('rxjs/util/subscribeToResult.js');
    exports.defaultThrottleConfig = {
        leading: true,
        trailing: false
    };
    /**
     * Emits a value from the source Observable, then ignores subsequent source
     * values for a duration determined by another Observable, then repeats this
     * process.
     *
     * <span class="informal">It's like {@link throttleTime}, but the silencing
     * duration is determined by a second Observable.</span>
     *
     * <img src="./img/throttle.png" width="100%">
     *
     * `throttle` emits the source Observable values on the output Observable
     * when its internal timer is disabled, and ignores source values when the timer
     * is enabled. Initially, the timer is disabled. As soon as the first source
     * value arrives, it is forwarded to the output Observable, and then the timer
     * is enabled by calling the `durationSelector` function with the source value,
     * which returns the "duration" Observable. When the duration Observable emits a
     * value or completes, the timer is disabled, and this process repeats for the
     * next source value.
     *
     * @example <caption>Emit clicks at a rate of at most one click per second</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var result = clicks.throttle(ev => Rx.Observable.interval(1000));
     * result.subscribe(x => console.log(x));
     *
     * @see {@link audit}
     * @see {@link debounce}
     * @see {@link delayWhen}
     * @see {@link sample}
     * @see {@link throttleTime}
     *
     * @param {function(value: T): SubscribableOrPromise} durationSelector A function
     * that receives a value from the source Observable, for computing the silencing
     * duration for each source value, returned as an Observable or a Promise.
     * @param {Object} config a configuration object to define `leading` and `trailing` behavior. Defaults
     * to `{ leading: true, trailing: false }`.
     * @return {Observable<T>} An Observable that performs the throttle operation to
     * limit the rate of emissions from the source.
     * @method throttle
     * @owner Observable
     */
    function throttle(durationSelector, config) {
        if (config === void 0) {
            config = exports.defaultThrottleConfig;
        }
        return function (source) {
            return source.lift(new ThrottleOperator(durationSelector, config.leading, config.trailing));
        };
    }
    exports.throttle = throttle;
    var ThrottleOperator = function () {
        function ThrottleOperator(durationSelector, leading, trailing) {
            this.durationSelector = durationSelector;
            this.leading = leading;
            this.trailing = trailing;
        }
        ThrottleOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new ThrottleSubscriber(subscriber, this.durationSelector, this.leading, this.trailing));
        };
        return ThrottleOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc
     * @ignore
     * @extends {Ignored}
     */
    var ThrottleSubscriber = function (_super) {
        __extends(ThrottleSubscriber, _super);
        function ThrottleSubscriber(destination, durationSelector, _leading, _trailing) {
            _super.call(this, destination);
            this.destination = destination;
            this.durationSelector = durationSelector;
            this._leading = _leading;
            this._trailing = _trailing;
            this._hasTrailingValue = false;
        }
        ThrottleSubscriber.prototype._next = function (value) {
            if (this.throttled) {
                if (this._trailing) {
                    this._hasTrailingValue = true;
                    this._trailingValue = value;
                }
            } else {
                var duration = this.tryDurationSelector(value);
                if (duration) {
                    this.add(this.throttled = subscribeToResult_1.subscribeToResult(this, duration));
                }
                if (this._leading) {
                    this.destination.next(value);
                    if (this._trailing) {
                        this._hasTrailingValue = true;
                        this._trailingValue = value;
                    }
                }
            }
        };
        ThrottleSubscriber.prototype.tryDurationSelector = function (value) {
            try {
                return this.durationSelector(value);
            } catch (err) {
                this.destination.error(err);
                return null;
            }
        };
        /** @deprecated internal use only */ThrottleSubscriber.prototype._unsubscribe = function () {
            var _a = this,
                throttled = _a.throttled,
                _trailingValue = _a._trailingValue,
                _hasTrailingValue = _a._hasTrailingValue,
                _trailing = _a._trailing;
            this._trailingValue = null;
            this._hasTrailingValue = false;
            if (throttled) {
                this.remove(throttled);
                this.throttled = null;
                throttled.unsubscribe();
            }
        };
        ThrottleSubscriber.prototype._sendTrailing = function () {
            var _a = this,
                destination = _a.destination,
                throttled = _a.throttled,
                _trailing = _a._trailing,
                _trailingValue = _a._trailingValue,
                _hasTrailingValue = _a._hasTrailingValue;
            if (throttled && _trailing && _hasTrailingValue) {
                destination.next(_trailingValue);
                this._trailingValue = null;
                this._hasTrailingValue = false;
            }
        };
        ThrottleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this._sendTrailing();
            this._unsubscribe();
        };
        ThrottleSubscriber.prototype.notifyComplete = function () {
            this._sendTrailing();
            this._unsubscribe();
        };
        return ThrottleSubscriber;
    }(OuterSubscriber_1.OuterSubscriber);
    
});
System.registerDynamic('rxjs/operators/throttleTime.js', ['rxjs/Subscriber.js', 'rxjs/scheduler/async.js', 'rxjs/operators/throttle.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require('rxjs/Subscriber.js');
    var async_1 = $__require('rxjs/scheduler/async.js');
    var throttle_1 = $__require('rxjs/operators/throttle.js');
    /**
     * Emits a value from the source Observable, then ignores subsequent source
     * values for `duration` milliseconds, then repeats this process.
     *
     * <span class="informal">Lets a value pass, then ignores source values for the
     * next `duration` milliseconds.</span>
     *
     * <img src="./img/throttleTime.png" width="100%">
     *
     * `throttleTime` emits the source Observable values on the output Observable
     * when its internal timer is disabled, and ignores source values when the timer
     * is enabled. Initially, the timer is disabled. As soon as the first source
     * value arrives, it is forwarded to the output Observable, and then the timer
     * is enabled. After `duration` milliseconds (or the time unit determined
     * internally by the optional `scheduler`) has passed, the timer is disabled,
     * and this process repeats for the next source value. Optionally takes a
     * {@link IScheduler} for managing timers.
     *
     * @example <caption>Emit clicks at a rate of at most one click per second</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var result = clicks.throttleTime(1000);
     * result.subscribe(x => console.log(x));
     *
     * @see {@link auditTime}
     * @see {@link debounceTime}
     * @see {@link delay}
     * @see {@link sampleTime}
     * @see {@link throttle}
     *
     * @param {number} duration Time to wait before emitting another value after
     * emitting the last value, measured in milliseconds or the time unit determined
     * internally by the optional `scheduler`.
     * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
     * managing the timers that handle the throttling.
     * @return {Observable<T>} An Observable that performs the throttle operation to
     * limit the rate of emissions from the source.
     * @method throttleTime
     * @owner Observable
     */
    function throttleTime(duration, scheduler, config) {
        if (scheduler === void 0) {
            scheduler = async_1.async;
        }
        if (config === void 0) {
            config = throttle_1.defaultThrottleConfig;
        }
        return function (source) {
            return source.lift(new ThrottleTimeOperator(duration, scheduler, config.leading, config.trailing));
        };
    }
    exports.throttleTime = throttleTime;
    var ThrottleTimeOperator = function () {
        function ThrottleTimeOperator(duration, scheduler, leading, trailing) {
            this.duration = duration;
            this.scheduler = scheduler;
            this.leading = leading;
            this.trailing = trailing;
        }
        ThrottleTimeOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new ThrottleTimeSubscriber(subscriber, this.duration, this.scheduler, this.leading, this.trailing));
        };
        return ThrottleTimeOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var ThrottleTimeSubscriber = function (_super) {
        __extends(ThrottleTimeSubscriber, _super);
        function ThrottleTimeSubscriber(destination, duration, scheduler, leading, trailing) {
            _super.call(this, destination);
            this.duration = duration;
            this.scheduler = scheduler;
            this.leading = leading;
            this.trailing = trailing;
            this._hasTrailingValue = false;
            this._trailingValue = null;
        }
        ThrottleTimeSubscriber.prototype._next = function (value) {
            if (this.throttled) {
                if (this.trailing) {
                    this._trailingValue = value;
                    this._hasTrailingValue = true;
                }
            } else {
                this.add(this.throttled = this.scheduler.schedule(dispatchNext, this.duration, { subscriber: this }));
                if (this.leading) {
                    this.destination.next(value);
                }
            }
        };
        ThrottleTimeSubscriber.prototype.clearThrottle = function () {
            var throttled = this.throttled;
            if (throttled) {
                if (this.trailing && this._hasTrailingValue) {
                    this.destination.next(this._trailingValue);
                    this._trailingValue = null;
                    this._hasTrailingValue = false;
                }
                throttled.unsubscribe();
                this.remove(throttled);
                this.throttled = null;
            }
        };
        return ThrottleTimeSubscriber;
    }(Subscriber_1.Subscriber);
    function dispatchNext(arg) {
        var subscriber = arg.subscriber;
        subscriber.clearThrottle();
    }
    
});
System.registerDynamic('rxjs/operators/timeInterval.js', ['rxjs/Subscriber.js', 'rxjs/scheduler/async.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require('rxjs/Subscriber.js');
    var async_1 = $__require('rxjs/scheduler/async.js');
    function timeInterval(scheduler) {
        if (scheduler === void 0) {
            scheduler = async_1.async;
        }
        return function (source) {
            return source.lift(new TimeIntervalOperator(scheduler));
        };
    }
    exports.timeInterval = timeInterval;
    var TimeInterval = function () {
        function TimeInterval(value, interval) {
            this.value = value;
            this.interval = interval;
        }
        return TimeInterval;
    }();
    exports.TimeInterval = TimeInterval;
    ;
    var TimeIntervalOperator = function () {
        function TimeIntervalOperator(scheduler) {
            this.scheduler = scheduler;
        }
        TimeIntervalOperator.prototype.call = function (observer, source) {
            return source.subscribe(new TimeIntervalSubscriber(observer, this.scheduler));
        };
        return TimeIntervalOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var TimeIntervalSubscriber = function (_super) {
        __extends(TimeIntervalSubscriber, _super);
        function TimeIntervalSubscriber(destination, scheduler) {
            _super.call(this, destination);
            this.scheduler = scheduler;
            this.lastTime = 0;
            this.lastTime = scheduler.now();
        }
        TimeIntervalSubscriber.prototype._next = function (value) {
            var now = this.scheduler.now();
            var span = now - this.lastTime;
            this.lastTime = now;
            this.destination.next(new TimeInterval(value, span));
        };
        return TimeIntervalSubscriber;
    }(Subscriber_1.Subscriber);
    
});
System.registerDynamic('rxjs/util/TimeoutError.js', [], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    /**
     * An error thrown when duetime elapses.
     *
     * @see {@link timeout}
     *
     * @class TimeoutError
     */
    var TimeoutError = function (_super) {
        __extends(TimeoutError, _super);
        function TimeoutError() {
            var err = _super.call(this, 'Timeout has occurred');
            this.name = err.name = 'TimeoutError';
            this.stack = err.stack;
            this.message = err.message;
        }
        return TimeoutError;
    }(Error);
    exports.TimeoutError = TimeoutError;
    
});
System.registerDynamic('rxjs/operators/timeout.js', ['rxjs/scheduler/async.js', 'rxjs/util/isDate.js', 'rxjs/Subscriber.js', 'rxjs/util/TimeoutError.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var async_1 = $__require('rxjs/scheduler/async.js');
    var isDate_1 = $__require('rxjs/util/isDate.js');
    var Subscriber_1 = $__require('rxjs/Subscriber.js');
    var TimeoutError_1 = $__require('rxjs/util/TimeoutError.js');
    /**
     *
     * Errors if Observable does not emit a value in given time span.
     *
     * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
     *
     * <img src="./img/timeout.png" width="100%">
     *
     * `timeout` operator accepts as an argument either a number or a Date.
     *
     * If number was provided, it returns an Observable that behaves like a source
     * Observable, unless there is a period of time where there is no value emitted.
     * So if you provide `100` as argument and first value comes after 50ms from
     * the moment of subscription, this value will be simply re-emitted by the resulting
     * Observable. If however after that 100ms passes without a second value being emitted,
     * stream will end with an error and source Observable will be unsubscribed.
     * These checks are performed throughout whole lifecycle of Observable - from the moment
     * it was subscribed to, until it completes or errors itself. Thus every value must be
     * emitted within specified period since previous value.
     *
     * If provided argument was Date, returned Observable behaves differently. It throws
     * if Observable did not complete before provided Date. This means that periods between
     * emission of particular values do not matter in this case. If Observable did not complete
     * before provided Date, source Observable will be unsubscribed. Other than that, resulting
     * stream behaves just as source Observable.
     *
     * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
     * when returned Observable will check if source stream emitted value or completed.
     *
     * @example <caption>Check if ticks are emitted within certain timespan</caption>
     * const seconds = Rx.Observable.interval(1000);
     *
     * seconds.timeout(1100) // Let's use bigger timespan to be safe,
     *                       // since `interval` might fire a bit later then scheduled.
     * .subscribe(
     *     value => console.log(value), // Will emit numbers just as regular `interval` would.
     *     err => console.log(err) // Will never be called.
     * );
     *
     * seconds.timeout(900).subscribe(
     *     value => console.log(value), // Will never be called.
     *     err => console.log(err) // Will emit error before even first value is emitted,
     *                             // since it did not arrive within 900ms period.
     * );
     *
     * @example <caption>Use Date to check if Observable completed</caption>
     * const seconds = Rx.Observable.interval(1000);
     *
     * seconds.timeout(new Date("December 17, 2020 03:24:00"))
     * .subscribe(
     *     value => console.log(value), // Will emit values as regular `interval` would
     *                                  // until December 17, 2020 at 03:24:00.
     *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
     *                             // since Observable did not complete by then.
     * );
     *
     * @see {@link timeoutWith}
     *
     * @param {number|Date} due Number specifying period within which Observable must emit values
     *                          or Date specifying before when Observable should complete
     * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
     * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
     * @method timeout
     * @owner Observable
     */
    function timeout(due, scheduler) {
        if (scheduler === void 0) {
            scheduler = async_1.async;
        }
        var absoluteTimeout = isDate_1.isDate(due);
        var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
        return function (source) {
            return source.lift(new TimeoutOperator(waitFor, absoluteTimeout, scheduler, new TimeoutError_1.TimeoutError()));
        };
    }
    exports.timeout = timeout;
    var TimeoutOperator = function () {
        function TimeoutOperator(waitFor, absoluteTimeout, scheduler, errorInstance) {
            this.waitFor = waitFor;
            this.absoluteTimeout = absoluteTimeout;
            this.scheduler = scheduler;
            this.errorInstance = errorInstance;
        }
        TimeoutOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new TimeoutSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.scheduler, this.errorInstance));
        };
        return TimeoutOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var TimeoutSubscriber = function (_super) {
        __extends(TimeoutSubscriber, _super);
        function TimeoutSubscriber(destination, absoluteTimeout, waitFor, scheduler, errorInstance) {
            _super.call(this, destination);
            this.absoluteTimeout = absoluteTimeout;
            this.waitFor = waitFor;
            this.scheduler = scheduler;
            this.errorInstance = errorInstance;
            this.action = null;
            this.scheduleTimeout();
        }
        TimeoutSubscriber.dispatchTimeout = function (subscriber) {
            subscriber.error(subscriber.errorInstance);
        };
        TimeoutSubscriber.prototype.scheduleTimeout = function () {
            var action = this.action;
            if (action) {
                // Recycle the action if we've already scheduled one. All the production
                // Scheduler Actions mutate their state/delay time and return themeselves.
                // VirtualActions are immutable, so they create and return a clone. In this
                // case, we need to set the action reference to the most recent VirtualAction,
                // to ensure that's the one we clone from next time.
                this.action = action.schedule(this, this.waitFor);
            } else {
                this.add(this.action = this.scheduler.schedule(TimeoutSubscriber.dispatchTimeout, this.waitFor, this));
            }
        };
        TimeoutSubscriber.prototype._next = function (value) {
            if (!this.absoluteTimeout) {
                this.scheduleTimeout();
            }
            _super.prototype._next.call(this, value);
        };
        /** @deprecated internal use only */TimeoutSubscriber.prototype._unsubscribe = function () {
            this.action = null;
            this.scheduler = null;
            this.errorInstance = null;
        };
        return TimeoutSubscriber;
    }(Subscriber_1.Subscriber);
    
});
System.registerDynamic("rxjs/util/isDate.js", [], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    function isDate(value) {
        return value instanceof Date && !isNaN(+value);
    }
    exports.isDate = isDate;
    
});
System.registerDynamic('rxjs/operators/timeoutWith.js', ['rxjs/scheduler/async.js', 'rxjs/util/isDate.js', 'rxjs/OuterSubscriber.js', 'rxjs/util/subscribeToResult.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var async_1 = $__require('rxjs/scheduler/async.js');
    var isDate_1 = $__require('rxjs/util/isDate.js');
    var OuterSubscriber_1 = $__require('rxjs/OuterSubscriber.js');
    var subscribeToResult_1 = $__require('rxjs/util/subscribeToResult.js');
    /* tslint:enable:max-line-length */
    /**
     *
     * Errors if Observable does not emit a value in given time span, in case of which
     * subscribes to the second Observable.
     *
     * <span class="informal">It's a version of `timeout` operator that let's you specify fallback Observable.</span>
     *
     * <img src="./img/timeoutWith.png" width="100%">
     *
     * `timeoutWith` is a variation of `timeout` operator. It behaves exactly the same,
     * still accepting as a first argument either a number or a Date, which control - respectively -
     * when values of source Observable should be emitted or when it should complete.
     *
     * The only difference is that it accepts a second, required parameter. This parameter
     * should be an Observable which will be subscribed when source Observable fails any timeout check.
     * So whenever regular `timeout` would emit an error, `timeoutWith` will instead start re-emitting
     * values from second Observable. Note that this fallback Observable is not checked for timeouts
     * itself, so it can emit values and complete at arbitrary points in time. From the moment of a second
     * subscription, Observable returned from `timeoutWith` simply mirrors fallback stream. When that
     * stream completes, it completes as well.
     *
     * Scheduler, which in case of `timeout` is provided as as second argument, can be still provided
     * here - as a third, optional parameter. It still is used to schedule timeout checks and -
     * as a consequence - when second Observable will be subscribed, since subscription happens
     * immediately after failing check.
     *
     * @example <caption>Add fallback observable</caption>
     * const seconds = Rx.Observable.interval(1000);
     * const minutes = Rx.Observable.interval(60 * 1000);
     *
     * seconds.timeoutWith(900, minutes)
     *     .subscribe(
     *         value => console.log(value), // After 900ms, will start emitting `minutes`,
     *                                      // since first value of `seconds` will not arrive fast enough.
     *         err => console.log(err) // Would be called after 900ms in case of `timeout`,
     *                                 // but here will never be called.
     *     );
     *
     * @param {number|Date} due Number specifying period within which Observable must emit values
     *                          or Date specifying before when Observable should complete
     * @param {Observable<T>} withObservable Observable which will be subscribed if source fails timeout check.
     * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
     * @return {Observable<T>} Observable that mirrors behaviour of source or, when timeout check fails, of an Observable
     *                          passed as a second parameter.
     * @method timeoutWith
     * @owner Observable
     */
    function timeoutWith(due, withObservable, scheduler) {
        if (scheduler === void 0) {
            scheduler = async_1.async;
        }
        return function (source) {
            var absoluteTimeout = isDate_1.isDate(due);
            var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
            return source.lift(new TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler));
        };
    }
    exports.timeoutWith = timeoutWith;
    var TimeoutWithOperator = function () {
        function TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler) {
            this.waitFor = waitFor;
            this.absoluteTimeout = absoluteTimeout;
            this.withObservable = withObservable;
            this.scheduler = scheduler;
        }
        TimeoutWithOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new TimeoutWithSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.withObservable, this.scheduler));
        };
        return TimeoutWithOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var TimeoutWithSubscriber = function (_super) {
        __extends(TimeoutWithSubscriber, _super);
        function TimeoutWithSubscriber(destination, absoluteTimeout, waitFor, withObservable, scheduler) {
            _super.call(this, destination);
            this.absoluteTimeout = absoluteTimeout;
            this.waitFor = waitFor;
            this.withObservable = withObservable;
            this.scheduler = scheduler;
            this.action = null;
            this.scheduleTimeout();
        }
        TimeoutWithSubscriber.dispatchTimeout = function (subscriber) {
            var withObservable = subscriber.withObservable;
            subscriber._unsubscribeAndRecycle();
            subscriber.add(subscribeToResult_1.subscribeToResult(subscriber, withObservable));
        };
        TimeoutWithSubscriber.prototype.scheduleTimeout = function () {
            var action = this.action;
            if (action) {
                // Recycle the action if we've already scheduled one. All the production
                // Scheduler Actions mutate their state/delay time and return themeselves.
                // VirtualActions are immutable, so they create and return a clone. In this
                // case, we need to set the action reference to the most recent VirtualAction,
                // to ensure that's the one we clone from next time.
                this.action = action.schedule(this, this.waitFor);
            } else {
                this.add(this.action = this.scheduler.schedule(TimeoutWithSubscriber.dispatchTimeout, this.waitFor, this));
            }
        };
        TimeoutWithSubscriber.prototype._next = function (value) {
            if (!this.absoluteTimeout) {
                this.scheduleTimeout();
            }
            _super.prototype._next.call(this, value);
        };
        /** @deprecated internal use only */TimeoutWithSubscriber.prototype._unsubscribe = function () {
            this.action = null;
            this.scheduler = null;
            this.withObservable = null;
        };
        return TimeoutWithSubscriber;
    }(OuterSubscriber_1.OuterSubscriber);
    
});
System.registerDynamic('rxjs/operators/map.js', ['rxjs/Subscriber.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require('rxjs/Subscriber.js');
    /**
     * Applies a given `project` function to each value emitted by the source
     * Observable, and emits the resulting values as an Observable.
     *
     * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
     * it passes each source value through a transformation function to get
     * corresponding output values.</span>
     *
     * <img src="./img/map.png" width="100%">
     *
     * Similar to the well known `Array.prototype.map` function, this operator
     * applies a projection to each value and emits that projection in the output
     * Observable.
     *
     * @example <caption>Map every click to the clientX position of that click</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var positions = clicks.map(ev => ev.clientX);
     * positions.subscribe(x => console.log(x));
     *
     * @see {@link mapTo}
     * @see {@link pluck}
     *
     * @param {function(value: T, index: number): R} project The function to apply
     * to each `value` emitted by the source Observable. The `index` parameter is
     * the number `i` for the i-th emission that has happened since the
     * subscription, starting from the number `0`.
     * @param {any} [thisArg] An optional argument to define what `this` is in the
     * `project` function.
     * @return {Observable<R>} An Observable that emits the values from the source
     * Observable transformed by the given `project` function.
     * @method map
     * @owner Observable
     */
    function map(project, thisArg) {
        return function mapOperation(source) {
            if (typeof project !== 'function') {
                throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
            }
            return source.lift(new MapOperator(project, thisArg));
        };
    }
    exports.map = map;
    var MapOperator = function () {
        function MapOperator(project, thisArg) {
            this.project = project;
            this.thisArg = thisArg;
        }
        MapOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
        };
        return MapOperator;
    }();
    exports.MapOperator = MapOperator;
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var MapSubscriber = function (_super) {
        __extends(MapSubscriber, _super);
        function MapSubscriber(destination, project, thisArg) {
            _super.call(this, destination);
            this.project = project;
            this.count = 0;
            this.thisArg = thisArg || this;
        }
        // NOTE: This looks unoptimized, but it's actually purposefully NOT
        // using try/catch optimizations.
        MapSubscriber.prototype._next = function (value) {
            var result;
            try {
                result = this.project.call(this.thisArg, value, this.count++);
            } catch (err) {
                this.destination.error(err);
                return;
            }
            this.destination.next(result);
        };
        return MapSubscriber;
    }(Subscriber_1.Subscriber);
    
});
System.registerDynamic('rxjs/operators/timestamp.js', ['rxjs/scheduler/async.js', 'rxjs/operators/map.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var async_1 = $__require('rxjs/scheduler/async.js');
    var map_1 = $__require('rxjs/operators/map.js');
    /**
     * @param scheduler
     * @return {Observable<Timestamp<any>>|WebSocketSubject<T>|Observable<T>}
     * @method timestamp
     * @owner Observable
     */
    function timestamp(scheduler) {
        if (scheduler === void 0) {
            scheduler = async_1.async;
        }
        return map_1.map(function (value) {
            return new Timestamp(value, scheduler.now());
        });
        // return (source: Observable<T>) => source.lift(new TimestampOperator(scheduler));
    }
    exports.timestamp = timestamp;
    var Timestamp = function () {
        function Timestamp(value, timestamp) {
            this.value = value;
            this.timestamp = timestamp;
        }
        return Timestamp;
    }();
    exports.Timestamp = Timestamp;
    ;
    
});
System.registerDynamic("rxjs/operators/scan.js", ["rxjs/Subscriber.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require("rxjs/Subscriber.js");
    /* tslint:enable:max-line-length */
    /**
     * Applies an accumulator function over the source Observable, and returns each
     * intermediate result, with an optional seed value.
     *
     * <span class="informal">It's like {@link reduce}, but emits the current
     * accumulation whenever the source emits a value.</span>
     *
     * <img src="./img/scan.png" width="100%">
     *
     * Combines together all values emitted on the source, using an accumulator
     * function that knows how to join a new source value into the accumulation from
     * the past. Is similar to {@link reduce}, but emits the intermediate
     * accumulations.
     *
     * Returns an Observable that applies a specified `accumulator` function to each
     * item emitted by the source Observable. If a `seed` value is specified, then
     * that value will be used as the initial value for the accumulator. If no seed
     * value is specified, the first item of the source is used as the seed.
     *
     * @example <caption>Count the number of click events</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var ones = clicks.mapTo(1);
     * var seed = 0;
     * var count = ones.scan((acc, one) => acc + one, seed);
     * count.subscribe(x => console.log(x));
     *
     * @see {@link expand}
     * @see {@link mergeScan}
     * @see {@link reduce}
     *
     * @param {function(acc: R, value: T, index: number): R} accumulator
     * The accumulator function called on each source value.
     * @param {T|R} [seed] The initial accumulation value.
     * @return {Observable<R>} An observable of the accumulated values.
     * @method scan
     * @owner Observable
     */
    function scan(accumulator, seed) {
        var hasSeed = false;
        // providing a seed of `undefined` *should* be valid and trigger
        // hasSeed! so don't use `seed !== undefined` checks!
        // For this reason, we have to check it here at the original call site
        // otherwise inside Operator/Subscriber we won't know if `undefined`
        // means they didn't provide anything or if they literally provided `undefined`
        if (arguments.length >= 2) {
            hasSeed = true;
        }
        return function scanOperatorFunction(source) {
            return source.lift(new ScanOperator(accumulator, seed, hasSeed));
        };
    }
    exports.scan = scan;
    var ScanOperator = function () {
        function ScanOperator(accumulator, seed, hasSeed) {
            if (hasSeed === void 0) {
                hasSeed = false;
            }
            this.accumulator = accumulator;
            this.seed = seed;
            this.hasSeed = hasSeed;
        }
        ScanOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new ScanSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
        };
        return ScanOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var ScanSubscriber = function (_super) {
        __extends(ScanSubscriber, _super);
        function ScanSubscriber(destination, accumulator, _seed, hasSeed) {
            _super.call(this, destination);
            this.accumulator = accumulator;
            this._seed = _seed;
            this.hasSeed = hasSeed;
            this.index = 0;
        }
        Object.defineProperty(ScanSubscriber.prototype, "seed", {
            get: function () {
                return this._seed;
            },
            set: function (value) {
                this.hasSeed = true;
                this._seed = value;
            },
            enumerable: true,
            configurable: true
        });
        ScanSubscriber.prototype._next = function (value) {
            if (!this.hasSeed) {
                this.seed = value;
                this.destination.next(value);
            } else {
                return this._tryNext(value);
            }
        };
        ScanSubscriber.prototype._tryNext = function (value) {
            var index = this.index++;
            var result;
            try {
                result = this.accumulator(this.seed, value, index);
            } catch (err) {
                this.destination.error(err);
            }
            this.seed = result;
            this.destination.next(result);
        };
        return ScanSubscriber;
    }(Subscriber_1.Subscriber);
    
});
System.registerDynamic('rxjs/util/ArgumentOutOfRangeError.js', [], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    /**
     * An error thrown when an element was queried at a certain index of an
     * Observable, but no such index or position exists in that sequence.
     *
     * @see {@link elementAt}
     * @see {@link take}
     * @see {@link takeLast}
     *
     * @class ArgumentOutOfRangeError
     */
    var ArgumentOutOfRangeError = function (_super) {
        __extends(ArgumentOutOfRangeError, _super);
        function ArgumentOutOfRangeError() {
            var err = _super.call(this, 'argument out of range');
            this.name = err.name = 'ArgumentOutOfRangeError';
            this.stack = err.stack;
            this.message = err.message;
        }
        return ArgumentOutOfRangeError;
    }(Error);
    exports.ArgumentOutOfRangeError = ArgumentOutOfRangeError;
    
});
System.registerDynamic('rxjs/operators/takeLast.js', ['rxjs/Subscriber.js', 'rxjs/util/ArgumentOutOfRangeError.js', 'rxjs/observable/EmptyObservable.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require('rxjs/Subscriber.js');
    var ArgumentOutOfRangeError_1 = $__require('rxjs/util/ArgumentOutOfRangeError.js');
    var EmptyObservable_1 = $__require('rxjs/observable/EmptyObservable.js');
    /**
     * Emits only the last `count` values emitted by the source Observable.
     *
     * <span class="informal">Remembers the latest `count` values, then emits those
     * only when the source completes.</span>
     *
     * <img src="./img/takeLast.png" width="100%">
     *
     * `takeLast` returns an Observable that emits at most the last `count` values
     * emitted by the source Observable. If the source emits fewer than `count`
     * values then all of its values are emitted. This operator must wait until the
     * `complete` notification emission from the source in order to emit the `next`
     * values on the output Observable, because otherwise it is impossible to know
     * whether or not more values will be emitted on the source. For this reason,
     * all values are emitted synchronously, followed by the complete notification.
     *
     * @example <caption>Take the last 3 values of an Observable with many values</caption>
     * var many = Rx.Observable.range(1, 100);
     * var lastThree = many.takeLast(3);
     * lastThree.subscribe(x => console.log(x));
     *
     * @see {@link take}
     * @see {@link takeUntil}
     * @see {@link takeWhile}
     * @see {@link skip}
     *
     * @throws {ArgumentOutOfRangeError} When using `takeLast(i)`, it delivers an
     * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
     *
     * @param {number} count The maximum number of values to emit from the end of
     * the sequence of values emitted by the source Observable.
     * @return {Observable<T>} An Observable that emits at most the last count
     * values emitted by the source Observable.
     * @method takeLast
     * @owner Observable
     */
    function takeLast(count) {
        return function takeLastOperatorFunction(source) {
            if (count === 0) {
                return new EmptyObservable_1.EmptyObservable();
            } else {
                return source.lift(new TakeLastOperator(count));
            }
        };
    }
    exports.takeLast = takeLast;
    var TakeLastOperator = function () {
        function TakeLastOperator(total) {
            this.total = total;
            if (this.total < 0) {
                throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError();
            }
        }
        TakeLastOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new TakeLastSubscriber(subscriber, this.total));
        };
        return TakeLastOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var TakeLastSubscriber = function (_super) {
        __extends(TakeLastSubscriber, _super);
        function TakeLastSubscriber(destination, total) {
            _super.call(this, destination);
            this.total = total;
            this.ring = new Array();
            this.count = 0;
        }
        TakeLastSubscriber.prototype._next = function (value) {
            var ring = this.ring;
            var total = this.total;
            var count = this.count++;
            if (ring.length < total) {
                ring.push(value);
            } else {
                var index = count % total;
                ring[index] = value;
            }
        };
        TakeLastSubscriber.prototype._complete = function () {
            var destination = this.destination;
            var count = this.count;
            if (count > 0) {
                var total = this.count >= this.total ? this.total : this.count;
                var ring = this.ring;
                for (var i = 0; i < total; i++) {
                    var idx = count++ % total;
                    destination.next(ring[idx]);
                }
            }
            destination.complete();
        };
        return TakeLastSubscriber;
    }(Subscriber_1.Subscriber);
    
});
System.registerDynamic("rxjs/operators/defaultIfEmpty.js", ["rxjs/Subscriber.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require("rxjs/Subscriber.js");
    /* tslint:enable:max-line-length */
    /**
     * Emits a given value if the source Observable completes without emitting any
     * `next` value, otherwise mirrors the source Observable.
     *
     * <span class="informal">If the source Observable turns out to be empty, then
     * this operator will emit a default value.</span>
     *
     * <img src="./img/defaultIfEmpty.png" width="100%">
     *
     * `defaultIfEmpty` emits the values emitted by the source Observable or a
     * specified default value if the source Observable is empty (completes without
     * having emitted any `next` value).
     *
     * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
     * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
     * result.subscribe(x => console.log(x));
     *
     * @see {@link empty}
     * @see {@link last}
     *
     * @param {any} [defaultValue=null] The default value used if the source
     * Observable is empty.
     * @return {Observable} An Observable that emits either the specified
     * `defaultValue` if the source Observable emits no items, or the values emitted
     * by the source Observable.
     * @method defaultIfEmpty
     * @owner Observable
     */
    function defaultIfEmpty(defaultValue) {
        if (defaultValue === void 0) {
            defaultValue = null;
        }
        return function (source) {
            return source.lift(new DefaultIfEmptyOperator(defaultValue));
        };
    }
    exports.defaultIfEmpty = defaultIfEmpty;
    var DefaultIfEmptyOperator = function () {
        function DefaultIfEmptyOperator(defaultValue) {
            this.defaultValue = defaultValue;
        }
        DefaultIfEmptyOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new DefaultIfEmptySubscriber(subscriber, this.defaultValue));
        };
        return DefaultIfEmptyOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var DefaultIfEmptySubscriber = function (_super) {
        __extends(DefaultIfEmptySubscriber, _super);
        function DefaultIfEmptySubscriber(destination, defaultValue) {
            _super.call(this, destination);
            this.defaultValue = defaultValue;
            this.isEmpty = true;
        }
        DefaultIfEmptySubscriber.prototype._next = function (value) {
            this.isEmpty = false;
            this.destination.next(value);
        };
        DefaultIfEmptySubscriber.prototype._complete = function () {
            if (this.isEmpty) {
                this.destination.next(this.defaultValue);
            }
            this.destination.complete();
        };
        return DefaultIfEmptySubscriber;
    }(Subscriber_1.Subscriber);
    
});
System.registerDynamic('rxjs/operators/reduce.js', ['rxjs/operators/scan.js', 'rxjs/operators/takeLast.js', 'rxjs/operators/defaultIfEmpty.js', 'rxjs/util/pipe.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var scan_1 = $__require('rxjs/operators/scan.js');
    var takeLast_1 = $__require('rxjs/operators/takeLast.js');
    var defaultIfEmpty_1 = $__require('rxjs/operators/defaultIfEmpty.js');
    var pipe_1 = $__require('rxjs/util/pipe.js');
    /* tslint:enable:max-line-length */
    /**
     * Applies an accumulator function over the source Observable, and returns the
     * accumulated result when the source completes, given an optional seed value.
     *
     * <span class="informal">Combines together all values emitted on the source,
     * using an accumulator function that knows how to join a new source value into
     * the accumulation from the past.</span>
     *
     * <img src="./img/reduce.png" width="100%">
     *
     * Like
     * [Array.prototype.reduce()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce),
     * `reduce` applies an `accumulator` function against an accumulation and each
     * value of the source Observable (from the past) to reduce it to a single
     * value, emitted on the output Observable. Note that `reduce` will only emit
     * one value, only when the source Observable completes. It is equivalent to
     * applying operator {@link scan} followed by operator {@link last}.
     *
     * Returns an Observable that applies a specified `accumulator` function to each
     * item emitted by the source Observable. If a `seed` value is specified, then
     * that value will be used as the initial value for the accumulator. If no seed
     * value is specified, the first item of the source is used as the seed.
     *
     * @example <caption>Count the number of click events that happened in 5 seconds</caption>
     * var clicksInFiveSeconds = Rx.Observable.fromEvent(document, 'click')
     *   .takeUntil(Rx.Observable.interval(5000));
     * var ones = clicksInFiveSeconds.mapTo(1);
     * var seed = 0;
     * var count = ones.reduce((acc, one) => acc + one, seed);
     * count.subscribe(x => console.log(x));
     *
     * @see {@link count}
     * @see {@link expand}
     * @see {@link mergeScan}
     * @see {@link scan}
     *
     * @param {function(acc: R, value: T, index: number): R} accumulator The accumulator function
     * called on each source value.
     * @param {R} [seed] The initial accumulation value.
     * @return {Observable<R>} An Observable that emits a single value that is the
     * result of accumulating the values emitted by the source Observable.
     * @method reduce
     * @owner Observable
     */
    function reduce(accumulator, seed) {
        // providing a seed of `undefined` *should* be valid and trigger
        // hasSeed! so don't use `seed !== undefined` checks!
        // For this reason, we have to check it here at the original call site
        // otherwise inside Operator/Subscriber we won't know if `undefined`
        // means they didn't provide anything or if they literally provided `undefined`
        if (arguments.length >= 2) {
            return function reduceOperatorFunctionWithSeed(source) {
                return pipe_1.pipe(scan_1.scan(accumulator, seed), takeLast_1.takeLast(1), defaultIfEmpty_1.defaultIfEmpty(seed))(source);
            };
        }
        return function reduceOperatorFunction(source) {
            return pipe_1.pipe(scan_1.scan(function (acc, value, index) {
                return accumulator(acc, value, index + 1);
            }), takeLast_1.takeLast(1))(source);
        };
    }
    exports.reduce = reduce;
    
});
System.registerDynamic("rxjs/operators/toArray.js", ["rxjs/operators/reduce.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var reduce_1 = $__require("rxjs/operators/reduce.js");
    function toArrayReducer(arr, item, index) {
        if (index === 0) {
            return [item];
        }
        arr.push(item);
        return arr;
    }
    function toArray() {
        return reduce_1.reduce(toArrayReducer, []);
    }
    exports.toArray = toArray;
    
});
System.registerDynamic('rxjs/operators/window.js', ['rxjs/Subject.js', 'rxjs/OuterSubscriber.js', 'rxjs/util/subscribeToResult.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subject_1 = $__require('rxjs/Subject.js');
    var OuterSubscriber_1 = $__require('rxjs/OuterSubscriber.js');
    var subscribeToResult_1 = $__require('rxjs/util/subscribeToResult.js');
    /**
     * Branch out the source Observable values as a nested Observable whenever
     * `windowBoundaries` emits.
     *
     * <span class="informal">It's like {@link buffer}, but emits a nested Observable
     * instead of an array.</span>
     *
     * <img src="./img/window.png" width="100%">
     *
     * Returns an Observable that emits windows of items it collects from the source
     * Observable. The output Observable emits connected, non-overlapping
     * windows. It emits the current window and opens a new one whenever the
     * Observable `windowBoundaries` emits an item. Because each window is an
     * Observable, the output is a higher-order Observable.
     *
     * @example <caption>In every window of 1 second each, emit at most 2 click events</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var interval = Rx.Observable.interval(1000);
     * var result = clicks.window(interval)
     *   .map(win => win.take(2)) // each window has at most 2 emissions
     *   .mergeAll(); // flatten the Observable-of-Observables
     * result.subscribe(x => console.log(x));
     *
     * @see {@link windowCount}
     * @see {@link windowTime}
     * @see {@link windowToggle}
     * @see {@link windowWhen}
     * @see {@link buffer}
     *
     * @param {Observable<any>} windowBoundaries An Observable that completes the
     * previous window and starts a new window.
     * @return {Observable<Observable<T>>} An Observable of windows, which are
     * Observables emitting values of the source Observable.
     * @method window
     * @owner Observable
     */
    function window(windowBoundaries) {
        return function windowOperatorFunction(source) {
            return source.lift(new WindowOperator(windowBoundaries));
        };
    }
    exports.window = window;
    var WindowOperator = function () {
        function WindowOperator(windowBoundaries) {
            this.windowBoundaries = windowBoundaries;
        }
        WindowOperator.prototype.call = function (subscriber, source) {
            var windowSubscriber = new WindowSubscriber(subscriber);
            var sourceSubscription = source.subscribe(windowSubscriber);
            if (!sourceSubscription.closed) {
                windowSubscriber.add(subscribeToResult_1.subscribeToResult(windowSubscriber, this.windowBoundaries));
            }
            return sourceSubscription;
        };
        return WindowOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var WindowSubscriber = function (_super) {
        __extends(WindowSubscriber, _super);
        function WindowSubscriber(destination) {
            _super.call(this, destination);
            this.window = new Subject_1.Subject();
            destination.next(this.window);
        }
        WindowSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this.openWindow();
        };
        WindowSubscriber.prototype.notifyError = function (error, innerSub) {
            this._error(error);
        };
        WindowSubscriber.prototype.notifyComplete = function (innerSub) {
            this._complete();
        };
        WindowSubscriber.prototype._next = function (value) {
            this.window.next(value);
        };
        WindowSubscriber.prototype._error = function (err) {
            this.window.error(err);
            this.destination.error(err);
        };
        WindowSubscriber.prototype._complete = function () {
            this.window.complete();
            this.destination.complete();
        };
        /** @deprecated internal use only */WindowSubscriber.prototype._unsubscribe = function () {
            this.window = null;
        };
        WindowSubscriber.prototype.openWindow = function () {
            var prevWindow = this.window;
            if (prevWindow) {
                prevWindow.complete();
            }
            var destination = this.destination;
            var newWindow = this.window = new Subject_1.Subject();
            destination.next(newWindow);
        };
        return WindowSubscriber;
    }(OuterSubscriber_1.OuterSubscriber);
    
});
System.registerDynamic('rxjs/operators/windowCount.js', ['rxjs/Subscriber.js', 'rxjs/Subject.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require('rxjs/Subscriber.js');
    var Subject_1 = $__require('rxjs/Subject.js');
    /**
     * Branch out the source Observable values as a nested Observable with each
     * nested Observable emitting at most `windowSize` values.
     *
     * <span class="informal">It's like {@link bufferCount}, but emits a nested
     * Observable instead of an array.</span>
     *
     * <img src="./img/windowCount.png" width="100%">
     *
     * Returns an Observable that emits windows of items it collects from the source
     * Observable. The output Observable emits windows every `startWindowEvery`
     * items, each containing no more than `windowSize` items. When the source
     * Observable completes or encounters an error, the output Observable emits
     * the current window and propagates the notification from the source
     * Observable. If `startWindowEvery` is not provided, then new windows are
     * started immediately at the start of the source and when each window completes
     * with size `windowSize`.
     *
     * @example <caption>Ignore every 3rd click event, starting from the first one</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var result = clicks.windowCount(3)
     *   .map(win => win.skip(1)) // skip first of every 3 clicks
     *   .mergeAll(); // flatten the Observable-of-Observables
     * result.subscribe(x => console.log(x));
     *
     * @example <caption>Ignore every 3rd click event, starting from the third one</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var result = clicks.windowCount(2, 3)
     *   .mergeAll(); // flatten the Observable-of-Observables
     * result.subscribe(x => console.log(x));
     *
     * @see {@link window}
     * @see {@link windowTime}
     * @see {@link windowToggle}
     * @see {@link windowWhen}
     * @see {@link bufferCount}
     *
     * @param {number} windowSize The maximum number of values emitted by each
     * window.
     * @param {number} [startWindowEvery] Interval at which to start a new window.
     * For example if `startWindowEvery` is `2`, then a new window will be started
     * on every other value from the source. A new window is started at the
     * beginning of the source by default.
     * @return {Observable<Observable<T>>} An Observable of windows, which in turn
     * are Observable of values.
     * @method windowCount
     * @owner Observable
     */
    function windowCount(windowSize, startWindowEvery) {
        if (startWindowEvery === void 0) {
            startWindowEvery = 0;
        }
        return function windowCountOperatorFunction(source) {
            return source.lift(new WindowCountOperator(windowSize, startWindowEvery));
        };
    }
    exports.windowCount = windowCount;
    var WindowCountOperator = function () {
        function WindowCountOperator(windowSize, startWindowEvery) {
            this.windowSize = windowSize;
            this.startWindowEvery = startWindowEvery;
        }
        WindowCountOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new WindowCountSubscriber(subscriber, this.windowSize, this.startWindowEvery));
        };
        return WindowCountOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var WindowCountSubscriber = function (_super) {
        __extends(WindowCountSubscriber, _super);
        function WindowCountSubscriber(destination, windowSize, startWindowEvery) {
            _super.call(this, destination);
            this.destination = destination;
            this.windowSize = windowSize;
            this.startWindowEvery = startWindowEvery;
            this.windows = [new Subject_1.Subject()];
            this.count = 0;
            destination.next(this.windows[0]);
        }
        WindowCountSubscriber.prototype._next = function (value) {
            var startWindowEvery = this.startWindowEvery > 0 ? this.startWindowEvery : this.windowSize;
            var destination = this.destination;
            var windowSize = this.windowSize;
            var windows = this.windows;
            var len = windows.length;
            for (var i = 0; i < len && !this.closed; i++) {
                windows[i].next(value);
            }
            var c = this.count - windowSize + 1;
            if (c >= 0 && c % startWindowEvery === 0 && !this.closed) {
                windows.shift().complete();
            }
            if (++this.count % startWindowEvery === 0 && !this.closed) {
                var window_1 = new Subject_1.Subject();
                windows.push(window_1);
                destination.next(window_1);
            }
        };
        WindowCountSubscriber.prototype._error = function (err) {
            var windows = this.windows;
            if (windows) {
                while (windows.length > 0 && !this.closed) {
                    windows.shift().error(err);
                }
            }
            this.destination.error(err);
        };
        WindowCountSubscriber.prototype._complete = function () {
            var windows = this.windows;
            if (windows) {
                while (windows.length > 0 && !this.closed) {
                    windows.shift().complete();
                }
            }
            this.destination.complete();
        };
        /** @deprecated internal use only */WindowCountSubscriber.prototype._unsubscribe = function () {
            this.count = 0;
            this.windows = null;
        };
        return WindowCountSubscriber;
    }(Subscriber_1.Subscriber);
    
});
System.registerDynamic("rxjs/scheduler/Action.js", ["rxjs/Subscription.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscription_1 = $__require("rxjs/Subscription.js");
    /**
     * A unit of work to be executed in a {@link Scheduler}. An action is typically
     * created from within a Scheduler and an RxJS user does not need to concern
     * themselves about creating and manipulating an Action.
     *
     * ```ts
     * class Action<T> extends Subscription {
     *   new (scheduler: Scheduler, work: (state?: T) => void);
     *   schedule(state?: T, delay: number = 0): Subscription;
     * }
     * ```
     *
     * @class Action<T>
     */
    var Action = function (_super) {
        __extends(Action, _super);
        function Action(scheduler, work) {
            _super.call(this);
        }
        /**
         * Schedules this action on its parent Scheduler for execution. May be passed
         * some context object, `state`. May happen at some point in the future,
         * according to the `delay` parameter, if specified.
         * @param {T} [state] Some contextual data that the `work` function uses when
         * called by the Scheduler.
         * @param {number} [delay] Time to wait before executing the work, where the
         * time unit is implicit and defined by the Scheduler.
         * @return {void}
         */
        Action.prototype.schedule = function (state, delay) {
            if (delay === void 0) {
                delay = 0;
            }
            return this;
        };
        return Action;
    }(Subscription_1.Subscription);
    exports.Action = Action;
    
});
System.registerDynamic('rxjs/scheduler/AsyncAction.js', ['rxjs/util/root.js', 'rxjs/scheduler/Action.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var root_1 = $__require('rxjs/util/root.js');
    var Action_1 = $__require('rxjs/scheduler/Action.js');
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var AsyncAction = function (_super) {
        __extends(AsyncAction, _super);
        function AsyncAction(scheduler, work) {
            _super.call(this, scheduler, work);
            this.scheduler = scheduler;
            this.pending = false;
            this.work = work;
        }
        AsyncAction.prototype.schedule = function (state, delay) {
            if (delay === void 0) {
                delay = 0;
            }
            if (this.closed) {
                return this;
            }
            // Always replace the current state with the new state.
            this.state = state;
            // Set the pending flag indicating that this action has been scheduled, or
            // has recursively rescheduled itself.
            this.pending = true;
            var id = this.id;
            var scheduler = this.scheduler;
            //
            // Important implementation note:
            //
            // Actions only execute once by default, unless rescheduled from within the
            // scheduled callback. This allows us to implement single and repeat
            // actions via the same code path, without adding API surface area, as well
            // as mimic traditional recursion but across asynchronous boundaries.
            //
            // However, JS runtimes and timers distinguish between intervals achieved by
            // serial `setTimeout` calls vs. a single `setInterval` call. An interval of
            // serial `setTimeout` calls can be individually delayed, which delays
            // scheduling the next `setTimeout`, and so on. `setInterval` attempts to
            // guarantee the interval callback will be invoked more precisely to the
            // interval period, regardless of load.
            //
            // Therefore, we use `setInterval` to schedule single and repeat actions.
            // If the action reschedules itself with the same delay, the interval is not
            // canceled. If the action doesn't reschedule, or reschedules with a
            // different delay, the interval will be canceled after scheduled callback
            // execution.
            //
            if (id != null) {
                this.id = this.recycleAsyncId(scheduler, id, delay);
            }
            this.delay = delay;
            // If this action has already an async Id, don't request a new one.
            this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
            return this;
        };
        AsyncAction.prototype.requestAsyncId = function (scheduler, id, delay) {
            if (delay === void 0) {
                delay = 0;
            }
            return root_1.root.setInterval(scheduler.flush.bind(scheduler, this), delay);
        };
        AsyncAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
            if (delay === void 0) {
                delay = 0;
            }
            // If this action is rescheduled with the same delay time, don't clear the interval id.
            if (delay !== null && this.delay === delay && this.pending === false) {
                return id;
            }
            // Otherwise, if the action's delay time is different from the current delay,
            // or the action has been rescheduled before it's executed, clear the interval id
            return root_1.root.clearInterval(id) && undefined || undefined;
        };
        /**
         * Immediately executes this action and the `work` it contains.
         * @return {any}
         */
        AsyncAction.prototype.execute = function (state, delay) {
            if (this.closed) {
                return new Error('executing a cancelled action');
            }
            this.pending = false;
            var error = this._execute(state, delay);
            if (error) {
                return error;
            } else if (this.pending === false && this.id != null) {
                // Dequeue if the action didn't reschedule itself. Don't call
                // unsubscribe(), because the action could reschedule later.
                // For example:
                // ```
                // scheduler.schedule(function doWork(counter) {
                //   /* ... I'm a busy worker bee ... */
                //   var originalAction = this;
                //   /* wait 100ms before rescheduling the action */
                //   setTimeout(function () {
                //     originalAction.schedule(counter + 1);
                //   }, 100);
                // }, 1000);
                // ```
                this.id = this.recycleAsyncId(this.scheduler, this.id, null);
            }
        };
        AsyncAction.prototype._execute = function (state, delay) {
            var errored = false;
            var errorValue = undefined;
            try {
                this.work(state);
            } catch (e) {
                errored = true;
                errorValue = !!e && e || new Error(e);
            }
            if (errored) {
                this.unsubscribe();
                return errorValue;
            }
        };
        /** @deprecated internal use only */AsyncAction.prototype._unsubscribe = function () {
            var id = this.id;
            var scheduler = this.scheduler;
            var actions = scheduler.actions;
            var index = actions.indexOf(this);
            this.work = null;
            this.state = null;
            this.pending = false;
            this.scheduler = null;
            if (index !== -1) {
                actions.splice(index, 1);
            }
            if (id != null) {
                this.id = this.recycleAsyncId(scheduler, id, null);
            }
            this.delay = null;
        };
        return AsyncAction;
    }(Action_1.Action);
    exports.AsyncAction = AsyncAction;
    
});
System.registerDynamic("rxjs/Scheduler.js", [], true, function ($__require, exports, module) {
    "use strict";
    /**
     * An execution context and a data structure to order tasks and schedule their
     * execution. Provides a notion of (potentially virtual) time, through the
     * `now()` getter method.
     *
     * Each unit of work in a Scheduler is called an {@link Action}.
     *
     * ```ts
     * class Scheduler {
     *   now(): number;
     *   schedule(work, delay?, state?): Subscription;
     * }
     * ```
     *
     * @class Scheduler
     */

    var global = this || self,
        GLOBAL = global;
    var Scheduler = function () {
        function Scheduler(SchedulerAction, now) {
            if (now === void 0) {
                now = Scheduler.now;
            }
            this.SchedulerAction = SchedulerAction;
            this.now = now;
        }
        /**
         * Schedules a function, `work`, for execution. May happen at some point in
         * the future, according to the `delay` parameter, if specified. May be passed
         * some context object, `state`, which will be passed to the `work` function.
         *
         * The given arguments will be processed an stored as an Action object in a
         * queue of actions.
         *
         * @param {function(state: ?T): ?Subscription} work A function representing a
         * task, or some unit of work to be executed by the Scheduler.
         * @param {number} [delay] Time to wait before executing the work, where the
         * time unit is implicit and defined by the Scheduler itself.
         * @param {T} [state] Some contextual data that the `work` function uses when
         * called by the Scheduler.
         * @return {Subscription} A subscription in order to be able to unsubscribe
         * the scheduled work.
         */
        Scheduler.prototype.schedule = function (work, delay, state) {
            if (delay === void 0) {
                delay = 0;
            }
            return new this.SchedulerAction(this, work).schedule(state, delay);
        };
        Scheduler.now = Date.now ? Date.now : function () {
            return +new Date();
        };
        return Scheduler;
    }();
    exports.Scheduler = Scheduler;
    
});
System.registerDynamic("rxjs/scheduler/AsyncScheduler.js", ["rxjs/Scheduler.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Scheduler_1 = $__require("rxjs/Scheduler.js");
    var AsyncScheduler = function (_super) {
        __extends(AsyncScheduler, _super);
        function AsyncScheduler() {
            _super.apply(this, arguments);
            this.actions = [];
            /**
             * A flag to indicate whether the Scheduler is currently executing a batch of
             * queued actions.
             * @type {boolean}
             */
            this.active = false;
            /**
             * An internal ID used to track the latest asynchronous task such as those
             * coming from `setTimeout`, `setInterval`, `requestAnimationFrame`, and
             * others.
             * @type {any}
             */
            this.scheduled = undefined;
        }
        AsyncScheduler.prototype.flush = function (action) {
            var actions = this.actions;
            if (this.active) {
                actions.push(action);
                return;
            }
            var error;
            this.active = true;
            do {
                if (error = action.execute(action.state, action.delay)) {
                    break;
                }
            } while (action = actions.shift()); // exhaust the scheduler queue
            this.active = false;
            if (error) {
                while (action = actions.shift()) {
                    action.unsubscribe();
                }
                throw error;
            }
        };
        return AsyncScheduler;
    }(Scheduler_1.Scheduler);
    exports.AsyncScheduler = AsyncScheduler;
    
});
System.registerDynamic('rxjs/scheduler/async.js', ['rxjs/scheduler/AsyncAction.js', 'rxjs/scheduler/AsyncScheduler.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var AsyncAction_1 = $__require('rxjs/scheduler/AsyncAction.js');
  var AsyncScheduler_1 = $__require('rxjs/scheduler/AsyncScheduler.js');
  /**
   *
   * Async Scheduler
   *
   * <span class="informal">Schedule task as if you used setTimeout(task, duration)</span>
   *
   * `async` scheduler schedules tasks asynchronously, by putting them on the JavaScript
   * event loop queue. It is best used to delay tasks in time or to schedule tasks repeating
   * in intervals.
   *
   * If you just want to "defer" task, that is to perform it right after currently
   * executing synchronous code ends (commonly achieved by `setTimeout(deferredTask, 0)`),
   * better choice will be the {@link asap} scheduler.
   *
   * @example <caption>Use async scheduler to delay task</caption>
   * const task = () => console.log('it works!');
   *
   * Rx.Scheduler.async.schedule(task, 2000);
   *
   * // After 2 seconds logs:
   * // "it works!"
   *
   *
   * @example <caption>Use async scheduler to repeat task in intervals</caption>
   * function task(state) {
   *   console.log(state);
   *   this.schedule(state + 1, 1000); // `this` references currently executing Action,
   *                                   // which we reschedule with new state and delay
   * }
   *
   * Rx.Scheduler.async.schedule(task, 3000, 0);
   *
   * // Logs:
   * // 0 after 3s
   * // 1 after 4s
   * // 2 after 5s
   * // 3 after 6s
   *
   * @static true
   * @name async
   * @owner Scheduler
   */
  exports.async = new AsyncScheduler_1.AsyncScheduler(AsyncAction_1.AsyncAction);
  
});
System.registerDynamic("rxjs/util/isNumeric.js", ["rxjs/util/isArray.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var isArray_1 = $__require("rxjs/util/isArray.js");
    function isNumeric(val) {
        // parseFloat NaNs numeric-cast false positives (null|true|false|"")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        // adding 1 corrects loss of precision from parseFloat (#15100)
        return !isArray_1.isArray(val) && val - parseFloat(val) + 1 >= 0;
    }
    exports.isNumeric = isNumeric;
    ;
    
});
System.registerDynamic('rxjs/operators/windowTime.js', ['rxjs/Subject.js', 'rxjs/scheduler/async.js', 'rxjs/Subscriber.js', 'rxjs/util/isNumeric.js', 'rxjs/util/isScheduler.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subject_1 = $__require('rxjs/Subject.js');
    var async_1 = $__require('rxjs/scheduler/async.js');
    var Subscriber_1 = $__require('rxjs/Subscriber.js');
    var isNumeric_1 = $__require('rxjs/util/isNumeric.js');
    var isScheduler_1 = $__require('rxjs/util/isScheduler.js');
    function windowTime(windowTimeSpan) {
        var scheduler = async_1.async;
        var windowCreationInterval = null;
        var maxWindowSize = Number.POSITIVE_INFINITY;
        if (isScheduler_1.isScheduler(arguments[3])) {
            scheduler = arguments[3];
        }
        if (isScheduler_1.isScheduler(arguments[2])) {
            scheduler = arguments[2];
        } else if (isNumeric_1.isNumeric(arguments[2])) {
            maxWindowSize = arguments[2];
        }
        if (isScheduler_1.isScheduler(arguments[1])) {
            scheduler = arguments[1];
        } else if (isNumeric_1.isNumeric(arguments[1])) {
            windowCreationInterval = arguments[1];
        }
        return function windowTimeOperatorFunction(source) {
            return source.lift(new WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler));
        };
    }
    exports.windowTime = windowTime;
    var WindowTimeOperator = function () {
        function WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
            this.windowTimeSpan = windowTimeSpan;
            this.windowCreationInterval = windowCreationInterval;
            this.maxWindowSize = maxWindowSize;
            this.scheduler = scheduler;
        }
        WindowTimeOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new WindowTimeSubscriber(subscriber, this.windowTimeSpan, this.windowCreationInterval, this.maxWindowSize, this.scheduler));
        };
        return WindowTimeOperator;
    }();
    var CountedSubject = function (_super) {
        __extends(CountedSubject, _super);
        function CountedSubject() {
            _super.apply(this, arguments);
            this._numberOfNextedValues = 0;
        }
        CountedSubject.prototype.next = function (value) {
            this._numberOfNextedValues++;
            _super.prototype.next.call(this, value);
        };
        Object.defineProperty(CountedSubject.prototype, "numberOfNextedValues", {
            get: function () {
                return this._numberOfNextedValues;
            },
            enumerable: true,
            configurable: true
        });
        return CountedSubject;
    }(Subject_1.Subject);
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var WindowTimeSubscriber = function (_super) {
        __extends(WindowTimeSubscriber, _super);
        function WindowTimeSubscriber(destination, windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
            _super.call(this, destination);
            this.destination = destination;
            this.windowTimeSpan = windowTimeSpan;
            this.windowCreationInterval = windowCreationInterval;
            this.maxWindowSize = maxWindowSize;
            this.scheduler = scheduler;
            this.windows = [];
            var window = this.openWindow();
            if (windowCreationInterval !== null && windowCreationInterval >= 0) {
                var closeState = { subscriber: this, window: window, context: null };
                var creationState = { windowTimeSpan: windowTimeSpan, windowCreationInterval: windowCreationInterval, subscriber: this, scheduler: scheduler };
                this.add(scheduler.schedule(dispatchWindowClose, windowTimeSpan, closeState));
                this.add(scheduler.schedule(dispatchWindowCreation, windowCreationInterval, creationState));
            } else {
                var timeSpanOnlyState = { subscriber: this, window: window, windowTimeSpan: windowTimeSpan };
                this.add(scheduler.schedule(dispatchWindowTimeSpanOnly, windowTimeSpan, timeSpanOnlyState));
            }
        }
        WindowTimeSubscriber.prototype._next = function (value) {
            var windows = this.windows;
            var len = windows.length;
            for (var i = 0; i < len; i++) {
                var window_1 = windows[i];
                if (!window_1.closed) {
                    window_1.next(value);
                    if (window_1.numberOfNextedValues >= this.maxWindowSize) {
                        this.closeWindow(window_1);
                    }
                }
            }
        };
        WindowTimeSubscriber.prototype._error = function (err) {
            var windows = this.windows;
            while (windows.length > 0) {
                windows.shift().error(err);
            }
            this.destination.error(err);
        };
        WindowTimeSubscriber.prototype._complete = function () {
            var windows = this.windows;
            while (windows.length > 0) {
                var window_2 = windows.shift();
                if (!window_2.closed) {
                    window_2.complete();
                }
            }
            this.destination.complete();
        };
        WindowTimeSubscriber.prototype.openWindow = function () {
            var window = new CountedSubject();
            this.windows.push(window);
            var destination = this.destination;
            destination.next(window);
            return window;
        };
        WindowTimeSubscriber.prototype.closeWindow = function (window) {
            window.complete();
            var windows = this.windows;
            windows.splice(windows.indexOf(window), 1);
        };
        return WindowTimeSubscriber;
    }(Subscriber_1.Subscriber);
    function dispatchWindowTimeSpanOnly(state) {
        var subscriber = state.subscriber,
            windowTimeSpan = state.windowTimeSpan,
            window = state.window;
        if (window) {
            subscriber.closeWindow(window);
        }
        state.window = subscriber.openWindow();
        this.schedule(state, windowTimeSpan);
    }
    function dispatchWindowCreation(state) {
        var windowTimeSpan = state.windowTimeSpan,
            subscriber = state.subscriber,
            scheduler = state.scheduler,
            windowCreationInterval = state.windowCreationInterval;
        var window = subscriber.openWindow();
        var action = this;
        var context = { action: action, subscription: null };
        var timeSpanState = { subscriber: subscriber, window: window, context: context };
        context.subscription = scheduler.schedule(dispatchWindowClose, windowTimeSpan, timeSpanState);
        action.add(context.subscription);
        action.schedule(state, windowCreationInterval);
    }
    function dispatchWindowClose(state) {
        var subscriber = state.subscriber,
            window = state.window,
            context = state.context;
        if (context && context.action && context.subscription) {
            context.action.remove(context.subscription);
        }
        subscriber.closeWindow(window);
    }
    
});
System.registerDynamic('rxjs/operators/windowToggle.js', ['rxjs/Subject.js', 'rxjs/Subscription.js', 'rxjs/util/tryCatch.js', 'rxjs/util/errorObject.js', 'rxjs/OuterSubscriber.js', 'rxjs/util/subscribeToResult.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subject_1 = $__require('rxjs/Subject.js');
    var Subscription_1 = $__require('rxjs/Subscription.js');
    var tryCatch_1 = $__require('rxjs/util/tryCatch.js');
    var errorObject_1 = $__require('rxjs/util/errorObject.js');
    var OuterSubscriber_1 = $__require('rxjs/OuterSubscriber.js');
    var subscribeToResult_1 = $__require('rxjs/util/subscribeToResult.js');
    /**
     * Branch out the source Observable values as a nested Observable starting from
     * an emission from `openings` and ending when the output of `closingSelector`
     * emits.
     *
     * <span class="informal">It's like {@link bufferToggle}, but emits a nested
     * Observable instead of an array.</span>
     *
     * <img src="./img/windowToggle.png" width="100%">
     *
     * Returns an Observable that emits windows of items it collects from the source
     * Observable. The output Observable emits windows that contain those items
     * emitted by the source Observable between the time when the `openings`
     * Observable emits an item and when the Observable returned by
     * `closingSelector` emits an item.
     *
     * @example <caption>Every other second, emit the click events from the next 500ms</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var openings = Rx.Observable.interval(1000);
     * var result = clicks.windowToggle(openings, i =>
     *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
     * ).mergeAll();
     * result.subscribe(x => console.log(x));
     *
     * @see {@link window}
     * @see {@link windowCount}
     * @see {@link windowTime}
     * @see {@link windowWhen}
     * @see {@link bufferToggle}
     *
     * @param {Observable<O>} openings An observable of notifications to start new
     * windows.
     * @param {function(value: O): Observable} closingSelector A function that takes
     * the value emitted by the `openings` observable and returns an Observable,
     * which, when it emits (either `next` or `complete`), signals that the
     * associated window should complete.
     * @return {Observable<Observable<T>>} An observable of windows, which in turn
     * are Observables.
     * @method windowToggle
     * @owner Observable
     */
    function windowToggle(openings, closingSelector) {
        return function (source) {
            return source.lift(new WindowToggleOperator(openings, closingSelector));
        };
    }
    exports.windowToggle = windowToggle;
    var WindowToggleOperator = function () {
        function WindowToggleOperator(openings, closingSelector) {
            this.openings = openings;
            this.closingSelector = closingSelector;
        }
        WindowToggleOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new WindowToggleSubscriber(subscriber, this.openings, this.closingSelector));
        };
        return WindowToggleOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var WindowToggleSubscriber = function (_super) {
        __extends(WindowToggleSubscriber, _super);
        function WindowToggleSubscriber(destination, openings, closingSelector) {
            _super.call(this, destination);
            this.openings = openings;
            this.closingSelector = closingSelector;
            this.contexts = [];
            this.add(this.openSubscription = subscribeToResult_1.subscribeToResult(this, openings, openings));
        }
        WindowToggleSubscriber.prototype._next = function (value) {
            var contexts = this.contexts;
            if (contexts) {
                var len = contexts.length;
                for (var i = 0; i < len; i++) {
                    contexts[i].window.next(value);
                }
            }
        };
        WindowToggleSubscriber.prototype._error = function (err) {
            var contexts = this.contexts;
            this.contexts = null;
            if (contexts) {
                var len = contexts.length;
                var index = -1;
                while (++index < len) {
                    var context = contexts[index];
                    context.window.error(err);
                    context.subscription.unsubscribe();
                }
            }
            _super.prototype._error.call(this, err);
        };
        WindowToggleSubscriber.prototype._complete = function () {
            var contexts = this.contexts;
            this.contexts = null;
            if (contexts) {
                var len = contexts.length;
                var index = -1;
                while (++index < len) {
                    var context = contexts[index];
                    context.window.complete();
                    context.subscription.unsubscribe();
                }
            }
            _super.prototype._complete.call(this);
        };
        /** @deprecated internal use only */WindowToggleSubscriber.prototype._unsubscribe = function () {
            var contexts = this.contexts;
            this.contexts = null;
            if (contexts) {
                var len = contexts.length;
                var index = -1;
                while (++index < len) {
                    var context = contexts[index];
                    context.window.unsubscribe();
                    context.subscription.unsubscribe();
                }
            }
        };
        WindowToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            if (outerValue === this.openings) {
                var closingSelector = this.closingSelector;
                var closingNotifier = tryCatch_1.tryCatch(closingSelector)(innerValue);
                if (closingNotifier === errorObject_1.errorObject) {
                    return this.error(errorObject_1.errorObject.e);
                } else {
                    var window_1 = new Subject_1.Subject();
                    var subscription = new Subscription_1.Subscription();
                    var context = { window: window_1, subscription: subscription };
                    this.contexts.push(context);
                    var innerSubscription = subscribeToResult_1.subscribeToResult(this, closingNotifier, context);
                    if (innerSubscription.closed) {
                        this.closeWindow(this.contexts.length - 1);
                    } else {
                        innerSubscription.context = context;
                        subscription.add(innerSubscription);
                    }
                    this.destination.next(window_1);
                }
            } else {
                this.closeWindow(this.contexts.indexOf(outerValue));
            }
        };
        WindowToggleSubscriber.prototype.notifyError = function (err) {
            this.error(err);
        };
        WindowToggleSubscriber.prototype.notifyComplete = function (inner) {
            if (inner !== this.openSubscription) {
                this.closeWindow(this.contexts.indexOf(inner.context));
            }
        };
        WindowToggleSubscriber.prototype.closeWindow = function (index) {
            if (index === -1) {
                return;
            }
            var contexts = this.contexts;
            var context = contexts[index];
            var window = context.window,
                subscription = context.subscription;
            contexts.splice(index, 1);
            window.complete();
            subscription.unsubscribe();
        };
        return WindowToggleSubscriber;
    }(OuterSubscriber_1.OuterSubscriber);
    
});
System.registerDynamic('rxjs/operators/windowWhen.js', ['rxjs/Subject.js', 'rxjs/util/tryCatch.js', 'rxjs/util/errorObject.js', 'rxjs/OuterSubscriber.js', 'rxjs/util/subscribeToResult.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subject_1 = $__require('rxjs/Subject.js');
    var tryCatch_1 = $__require('rxjs/util/tryCatch.js');
    var errorObject_1 = $__require('rxjs/util/errorObject.js');
    var OuterSubscriber_1 = $__require('rxjs/OuterSubscriber.js');
    var subscribeToResult_1 = $__require('rxjs/util/subscribeToResult.js');
    /**
     * Branch out the source Observable values as a nested Observable using a
     * factory function of closing Observables to determine when to start a new
     * window.
     *
     * <span class="informal">It's like {@link bufferWhen}, but emits a nested
     * Observable instead of an array.</span>
     *
     * <img src="./img/windowWhen.png" width="100%">
     *
     * Returns an Observable that emits windows of items it collects from the source
     * Observable. The output Observable emits connected, non-overlapping windows.
     * It emits the current window and opens a new one whenever the Observable
     * produced by the specified `closingSelector` function emits an item. The first
     * window is opened immediately when subscribing to the output Observable.
     *
     * @example <caption>Emit only the first two clicks events in every window of [1-5] random seconds</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var result = clicks
     *   .windowWhen(() => Rx.Observable.interval(1000 + Math.random() * 4000))
     *   .map(win => win.take(2)) // each window has at most 2 emissions
     *   .mergeAll(); // flatten the Observable-of-Observables
     * result.subscribe(x => console.log(x));
     *
     * @see {@link window}
     * @see {@link windowCount}
     * @see {@link windowTime}
     * @see {@link windowToggle}
     * @see {@link bufferWhen}
     *
     * @param {function(): Observable} closingSelector A function that takes no
     * arguments and returns an Observable that signals (on either `next` or
     * `complete`) when to close the previous window and start a new one.
     * @return {Observable<Observable<T>>} An observable of windows, which in turn
     * are Observables.
     * @method windowWhen
     * @owner Observable
     */
    function windowWhen(closingSelector) {
        return function windowWhenOperatorFunction(source) {
            return source.lift(new WindowOperator(closingSelector));
        };
    }
    exports.windowWhen = windowWhen;
    var WindowOperator = function () {
        function WindowOperator(closingSelector) {
            this.closingSelector = closingSelector;
        }
        WindowOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new WindowSubscriber(subscriber, this.closingSelector));
        };
        return WindowOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var WindowSubscriber = function (_super) {
        __extends(WindowSubscriber, _super);
        function WindowSubscriber(destination, closingSelector) {
            _super.call(this, destination);
            this.destination = destination;
            this.closingSelector = closingSelector;
            this.openWindow();
        }
        WindowSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this.openWindow(innerSub);
        };
        WindowSubscriber.prototype.notifyError = function (error, innerSub) {
            this._error(error);
        };
        WindowSubscriber.prototype.notifyComplete = function (innerSub) {
            this.openWindow(innerSub);
        };
        WindowSubscriber.prototype._next = function (value) {
            this.window.next(value);
        };
        WindowSubscriber.prototype._error = function (err) {
            this.window.error(err);
            this.destination.error(err);
            this.unsubscribeClosingNotification();
        };
        WindowSubscriber.prototype._complete = function () {
            this.window.complete();
            this.destination.complete();
            this.unsubscribeClosingNotification();
        };
        WindowSubscriber.prototype.unsubscribeClosingNotification = function () {
            if (this.closingNotification) {
                this.closingNotification.unsubscribe();
            }
        };
        WindowSubscriber.prototype.openWindow = function (innerSub) {
            if (innerSub === void 0) {
                innerSub = null;
            }
            if (innerSub) {
                this.remove(innerSub);
                innerSub.unsubscribe();
            }
            var prevWindow = this.window;
            if (prevWindow) {
                prevWindow.complete();
            }
            var window = this.window = new Subject_1.Subject();
            this.destination.next(window);
            var closingNotifier = tryCatch_1.tryCatch(this.closingSelector)();
            if (closingNotifier === errorObject_1.errorObject) {
                var err = errorObject_1.errorObject.e;
                this.destination.error(err);
                this.window.error(err);
            } else {
                this.add(this.closingNotification = subscribeToResult_1.subscribeToResult(this, closingNotifier));
            }
        };
        return WindowSubscriber;
    }(OuterSubscriber_1.OuterSubscriber);
    
});
System.registerDynamic('rxjs/operators/withLatestFrom.js', ['rxjs/OuterSubscriber.js', 'rxjs/util/subscribeToResult.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var OuterSubscriber_1 = $__require('rxjs/OuterSubscriber.js');
    var subscribeToResult_1 = $__require('rxjs/util/subscribeToResult.js');
    /* tslint:enable:max-line-length */
    /**
     * Combines the source Observable with other Observables to create an Observable
     * whose values are calculated from the latest values of each, only when the
     * source emits.
     *
     * <span class="informal">Whenever the source Observable emits a value, it
     * computes a formula using that value plus the latest values from other input
     * Observables, then emits the output of that formula.</span>
     *
     * <img src="./img/withLatestFrom.png" width="100%">
     *
     * `withLatestFrom` combines each value from the source Observable (the
     * instance) with the latest values from the other input Observables only when
     * the source emits a value, optionally using a `project` function to determine
     * the value to be emitted on the output Observable. All input Observables must
     * emit at least one value before the output Observable will emit a value.
     *
     * @example <caption>On every click event, emit an array with the latest timer event plus the click event</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var timer = Rx.Observable.interval(1000);
     * var result = clicks.withLatestFrom(timer);
     * result.subscribe(x => console.log(x));
     *
     * @see {@link combineLatest}
     *
     * @param {ObservableInput} other An input Observable to combine with the source
     * Observable. More than one input Observables may be given as argument.
     * @param {Function} [project] Projection function for combining values
     * together. Receives all values in order of the Observables passed, where the
     * first parameter is a value from the source Observable. (e.g.
     * `a.withLatestFrom(b, c, (a1, b1, c1) => a1 + b1 + c1)`). If this is not
     * passed, arrays will be emitted on the output Observable.
     * @return {Observable} An Observable of projected values from the most recent
     * values from each input Observable, or an array of the most recent values from
     * each input Observable.
     * @method withLatestFrom
     * @owner Observable
     */
    function withLatestFrom() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i - 0] = arguments[_i];
        }
        return function (source) {
            var project;
            if (typeof args[args.length - 1] === 'function') {
                project = args.pop();
            }
            var observables = args;
            return source.lift(new WithLatestFromOperator(observables, project));
        };
    }
    exports.withLatestFrom = withLatestFrom;
    var WithLatestFromOperator = function () {
        function WithLatestFromOperator(observables, project) {
            this.observables = observables;
            this.project = project;
        }
        WithLatestFromOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new WithLatestFromSubscriber(subscriber, this.observables, this.project));
        };
        return WithLatestFromOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var WithLatestFromSubscriber = function (_super) {
        __extends(WithLatestFromSubscriber, _super);
        function WithLatestFromSubscriber(destination, observables, project) {
            _super.call(this, destination);
            this.observables = observables;
            this.project = project;
            this.toRespond = [];
            var len = observables.length;
            this.values = new Array(len);
            for (var i = 0; i < len; i++) {
                this.toRespond.push(i);
            }
            for (var i = 0; i < len; i++) {
                var observable = observables[i];
                this.add(subscribeToResult_1.subscribeToResult(this, observable, observable, i));
            }
        }
        WithLatestFromSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this.values[outerIndex] = innerValue;
            var toRespond = this.toRespond;
            if (toRespond.length > 0) {
                var found = toRespond.indexOf(outerIndex);
                if (found !== -1) {
                    toRespond.splice(found, 1);
                }
            }
        };
        WithLatestFromSubscriber.prototype.notifyComplete = function () {
            // noop
        };
        WithLatestFromSubscriber.prototype._next = function (value) {
            if (this.toRespond.length === 0) {
                var args = [value].concat(this.values);
                if (this.project) {
                    this._tryProject(args);
                } else {
                    this.destination.next(args);
                }
            }
        };
        WithLatestFromSubscriber.prototype._tryProject = function (args) {
            var result;
            try {
                result = this.project.apply(this, args);
            } catch (err) {
                this.destination.error(err);
                return;
            }
            this.destination.next(result);
        };
        return WithLatestFromSubscriber;
    }(OuterSubscriber_1.OuterSubscriber);
    
});
System.registerDynamic('rxjs/operators/zip.js', ['rxjs/observable/ArrayObservable.js', 'rxjs/util/isArray.js', 'rxjs/Subscriber.js', 'rxjs/OuterSubscriber.js', 'rxjs/util/subscribeToResult.js', 'rxjs/symbol/iterator.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var ArrayObservable_1 = $__require('rxjs/observable/ArrayObservable.js');
    var isArray_1 = $__require('rxjs/util/isArray.js');
    var Subscriber_1 = $__require('rxjs/Subscriber.js');
    var OuterSubscriber_1 = $__require('rxjs/OuterSubscriber.js');
    var subscribeToResult_1 = $__require('rxjs/util/subscribeToResult.js');
    var iterator_1 = $__require('rxjs/symbol/iterator.js');
    /* tslint:enable:max-line-length */
    /**
     * @param observables
     * @return {Observable<R>}
     * @method zip
     * @owner Observable
     */
    function zip() {
        var observables = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            observables[_i - 0] = arguments[_i];
        }
        return function zipOperatorFunction(source) {
            return source.lift.call(zipStatic.apply(void 0, [source].concat(observables)));
        };
    }
    exports.zip = zip;
    /* tslint:enable:max-line-length */
    /**
     * Combines multiple Observables to create an Observable whose values are calculated from the values, in order, of each
     * of its input Observables.
     *
     * If the latest parameter is a function, this function is used to compute the created value from the input values.
     * Otherwise, an array of the input values is returned.
     *
     * @example <caption>Combine age and name from different sources</caption>
     *
     * let age$ = Observable.of<number>(27, 25, 29);
     * let name$ = Observable.of<string>('Foo', 'Bar', 'Beer');
     * let isDev$ = Observable.of<boolean>(true, true, false);
     *
     * Observable
     *     .zip(age$,
     *          name$,
     *          isDev$,
     *          (age: number, name: string, isDev: boolean) => ({ age, name, isDev }))
     *     .subscribe(x => console.log(x));
     *
     * // outputs
     * // { age: 27, name: 'Foo', isDev: true }
     * // { age: 25, name: 'Bar', isDev: true }
     * // { age: 29, name: 'Beer', isDev: false }
     *
     * @param observables
     * @return {Observable<R>}
     * @static true
     * @name zip
     * @owner Observable
     */
    function zipStatic() {
        var observables = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            observables[_i - 0] = arguments[_i];
        }
        var project = observables[observables.length - 1];
        if (typeof project === 'function') {
            observables.pop();
        }
        return new ArrayObservable_1.ArrayObservable(observables).lift(new ZipOperator(project));
    }
    exports.zipStatic = zipStatic;
    var ZipOperator = function () {
        function ZipOperator(project) {
            this.project = project;
        }
        ZipOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new ZipSubscriber(subscriber, this.project));
        };
        return ZipOperator;
    }();
    exports.ZipOperator = ZipOperator;
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var ZipSubscriber = function (_super) {
        __extends(ZipSubscriber, _super);
        function ZipSubscriber(destination, project, values) {
            if (values === void 0) {
                values = Object.create(null);
            }
            _super.call(this, destination);
            this.iterators = [];
            this.active = 0;
            this.project = typeof project === 'function' ? project : null;
            this.values = values;
        }
        ZipSubscriber.prototype._next = function (value) {
            var iterators = this.iterators;
            if (isArray_1.isArray(value)) {
                iterators.push(new StaticArrayIterator(value));
            } else if (typeof value[iterator_1.iterator] === 'function') {
                iterators.push(new StaticIterator(value[iterator_1.iterator]()));
            } else {
                iterators.push(new ZipBufferIterator(this.destination, this, value));
            }
        };
        ZipSubscriber.prototype._complete = function () {
            var iterators = this.iterators;
            var len = iterators.length;
            if (len === 0) {
                this.destination.complete();
                return;
            }
            this.active = len;
            for (var i = 0; i < len; i++) {
                var iterator = iterators[i];
                if (iterator.stillUnsubscribed) {
                    this.add(iterator.subscribe(iterator, i));
                } else {
                    this.active--; // not an observable
                }
            }
        };
        ZipSubscriber.prototype.notifyInactive = function () {
            this.active--;
            if (this.active === 0) {
                this.destination.complete();
            }
        };
        ZipSubscriber.prototype.checkIterators = function () {
            var iterators = this.iterators;
            var len = iterators.length;
            var destination = this.destination;
            // abort if not all of them have values
            for (var i = 0; i < len; i++) {
                var iterator = iterators[i];
                if (typeof iterator.hasValue === 'function' && !iterator.hasValue()) {
                    return;
                }
            }
            var shouldComplete = false;
            var args = [];
            for (var i = 0; i < len; i++) {
                var iterator = iterators[i];
                var result = iterator.next();
                // check to see if it's completed now that you've gotten
                // the next value.
                if (iterator.hasCompleted()) {
                    shouldComplete = true;
                }
                if (result.done) {
                    destination.complete();
                    return;
                }
                args.push(result.value);
            }
            if (this.project) {
                this._tryProject(args);
            } else {
                destination.next(args);
            }
            if (shouldComplete) {
                destination.complete();
            }
        };
        ZipSubscriber.prototype._tryProject = function (args) {
            var result;
            try {
                result = this.project.apply(this, args);
            } catch (err) {
                this.destination.error(err);
                return;
            }
            this.destination.next(result);
        };
        return ZipSubscriber;
    }(Subscriber_1.Subscriber);
    exports.ZipSubscriber = ZipSubscriber;
    var StaticIterator = function () {
        function StaticIterator(iterator) {
            this.iterator = iterator;
            this.nextResult = iterator.next();
        }
        StaticIterator.prototype.hasValue = function () {
            return true;
        };
        StaticIterator.prototype.next = function () {
            var result = this.nextResult;
            this.nextResult = this.iterator.next();
            return result;
        };
        StaticIterator.prototype.hasCompleted = function () {
            var nextResult = this.nextResult;
            return nextResult && nextResult.done;
        };
        return StaticIterator;
    }();
    var StaticArrayIterator = function () {
        function StaticArrayIterator(array) {
            this.array = array;
            this.index = 0;
            this.length = 0;
            this.length = array.length;
        }
        StaticArrayIterator.prototype[iterator_1.iterator] = function () {
            return this;
        };
        StaticArrayIterator.prototype.next = function (value) {
            var i = this.index++;
            var array = this.array;
            return i < this.length ? { value: array[i], done: false } : { value: null, done: true };
        };
        StaticArrayIterator.prototype.hasValue = function () {
            return this.array.length > this.index;
        };
        StaticArrayIterator.prototype.hasCompleted = function () {
            return this.array.length === this.index;
        };
        return StaticArrayIterator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var ZipBufferIterator = function (_super) {
        __extends(ZipBufferIterator, _super);
        function ZipBufferIterator(destination, parent, observable) {
            _super.call(this, destination);
            this.parent = parent;
            this.observable = observable;
            this.stillUnsubscribed = true;
            this.buffer = [];
            this.isComplete = false;
        }
        ZipBufferIterator.prototype[iterator_1.iterator] = function () {
            return this;
        };
        // NOTE: there is actually a name collision here with Subscriber.next and Iterator.next
        //    this is legit because `next()` will never be called by a subscription in this case.
        ZipBufferIterator.prototype.next = function () {
            var buffer = this.buffer;
            if (buffer.length === 0 && this.isComplete) {
                return { value: null, done: true };
            } else {
                return { value: buffer.shift(), done: false };
            }
        };
        ZipBufferIterator.prototype.hasValue = function () {
            return this.buffer.length > 0;
        };
        ZipBufferIterator.prototype.hasCompleted = function () {
            return this.buffer.length === 0 && this.isComplete;
        };
        ZipBufferIterator.prototype.notifyComplete = function () {
            if (this.buffer.length > 0) {
                this.isComplete = true;
                this.parent.notifyInactive();
            } else {
                this.destination.complete();
            }
        };
        ZipBufferIterator.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this.buffer.push(innerValue);
            this.parent.checkIterators();
        };
        ZipBufferIterator.prototype.subscribe = function (value, index) {
            return subscribeToResult_1.subscribeToResult(this, this.observable, this, index);
        };
        return ZipBufferIterator;
    }(OuterSubscriber_1.OuterSubscriber);
    
});
System.registerDynamic("rxjs/operators/zipAll.js", ["rxjs/operators/zip.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var zip_1 = $__require("rxjs/operators/zip.js");
    function zipAll(project) {
        return function (source) {
            return source.lift(new zip_1.ZipOperator(project));
        };
    }
    exports.zipAll = zipAll;
    
});
System.registerDynamic('rxjs/operators.js', ['rxjs/operators/audit.js', 'rxjs/operators/auditTime.js', 'rxjs/operators/buffer.js', 'rxjs/operators/bufferCount.js', 'rxjs/operators/bufferTime.js', 'rxjs/operators/bufferToggle.js', 'rxjs/operators/bufferWhen.js', 'rxjs/operators/catchError.js', 'rxjs/operators/combineAll.js', 'rxjs/operators/combineLatest.js', 'rxjs/operators/concat.js', 'rxjs/operators/concatAll.js', 'rxjs/operators/concatMap.js', 'rxjs/operators/concatMapTo.js', 'rxjs/operators/count.js', 'rxjs/operators/debounce.js', 'rxjs/operators/debounceTime.js', 'rxjs/operators/defaultIfEmpty.js', 'rxjs/operators/delay.js', 'rxjs/operators/delayWhen.js', 'rxjs/operators/dematerialize.js', 'rxjs/operators/distinct.js', 'rxjs/operators/distinctUntilChanged.js', 'rxjs/operators/distinctUntilKeyChanged.js', 'rxjs/operators/elementAt.js', 'rxjs/operators/every.js', 'rxjs/operators/exhaust.js', 'rxjs/operators/exhaustMap.js', 'rxjs/operators/expand.js', 'rxjs/operators/filter.js', 'rxjs/operators/finalize.js', 'rxjs/operators/find.js', 'rxjs/operators/findIndex.js', 'rxjs/operators/first.js', 'rxjs/operators/groupBy.js', 'rxjs/operators/ignoreElements.js', 'rxjs/operators/isEmpty.js', 'rxjs/operators/last.js', 'rxjs/operators/map.js', 'rxjs/operators/mapTo.js', 'rxjs/operators/materialize.js', 'rxjs/operators/max.js', 'rxjs/operators/merge.js', 'rxjs/operators/mergeAll.js', 'rxjs/operators/mergeMap.js', 'rxjs/operators/mergeMapTo.js', 'rxjs/operators/mergeScan.js', 'rxjs/operators/min.js', 'rxjs/operators/multicast.js', 'rxjs/operators/observeOn.js', 'rxjs/operators/onErrorResumeNext.js', 'rxjs/operators/pairwise.js', 'rxjs/operators/partition.js', 'rxjs/operators/pluck.js', 'rxjs/operators/publish.js', 'rxjs/operators/publishBehavior.js', 'rxjs/operators/publishLast.js', 'rxjs/operators/publishReplay.js', 'rxjs/operators/race.js', 'rxjs/operators/reduce.js', 'rxjs/operators/repeat.js', 'rxjs/operators/repeatWhen.js', 'rxjs/operators/retry.js', 'rxjs/operators/retryWhen.js', 'rxjs/operators/refCount.js', 'rxjs/operators/sample.js', 'rxjs/operators/sampleTime.js', 'rxjs/operators/scan.js', 'rxjs/operators/sequenceEqual.js', 'rxjs/operators/share.js', 'rxjs/operators/shareReplay.js', 'rxjs/operators/single.js', 'rxjs/operators/skip.js', 'rxjs/operators/skipLast.js', 'rxjs/operators/skipUntil.js', 'rxjs/operators/skipWhile.js', 'rxjs/operators/startWith.js', 'rxjs/operators/switchAll.js', 'rxjs/operators/switchMap.js', 'rxjs/operators/switchMapTo.js', 'rxjs/operators/take.js', 'rxjs/operators/takeLast.js', 'rxjs/operators/takeUntil.js', 'rxjs/operators/takeWhile.js', 'rxjs/operators/tap.js', 'rxjs/operators/throttle.js', 'rxjs/operators/throttleTime.js', 'rxjs/operators/timeInterval.js', 'rxjs/operators/timeout.js', 'rxjs/operators/timeoutWith.js', 'rxjs/operators/timestamp.js', 'rxjs/operators/toArray.js', 'rxjs/operators/window.js', 'rxjs/operators/windowCount.js', 'rxjs/operators/windowTime.js', 'rxjs/operators/windowToggle.js', 'rxjs/operators/windowWhen.js', 'rxjs/operators/withLatestFrom.js', 'rxjs/operators/zip.js', 'rxjs/operators/zipAll.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var audit_1 = $__require('rxjs/operators/audit.js');
  exports.audit = audit_1.audit;
  var auditTime_1 = $__require('rxjs/operators/auditTime.js');
  exports.auditTime = auditTime_1.auditTime;
  var buffer_1 = $__require('rxjs/operators/buffer.js');
  exports.buffer = buffer_1.buffer;
  var bufferCount_1 = $__require('rxjs/operators/bufferCount.js');
  exports.bufferCount = bufferCount_1.bufferCount;
  var bufferTime_1 = $__require('rxjs/operators/bufferTime.js');
  exports.bufferTime = bufferTime_1.bufferTime;
  var bufferToggle_1 = $__require('rxjs/operators/bufferToggle.js');
  exports.bufferToggle = bufferToggle_1.bufferToggle;
  var bufferWhen_1 = $__require('rxjs/operators/bufferWhen.js');
  exports.bufferWhen = bufferWhen_1.bufferWhen;
  var catchError_1 = $__require('rxjs/operators/catchError.js');
  exports.catchError = catchError_1.catchError;
  var combineAll_1 = $__require('rxjs/operators/combineAll.js');
  exports.combineAll = combineAll_1.combineAll;
  var combineLatest_1 = $__require('rxjs/operators/combineLatest.js');
  exports.combineLatest = combineLatest_1.combineLatest;
  var concat_1 = $__require('rxjs/operators/concat.js');
  exports.concat = concat_1.concat;
  var concatAll_1 = $__require('rxjs/operators/concatAll.js');
  exports.concatAll = concatAll_1.concatAll;
  var concatMap_1 = $__require('rxjs/operators/concatMap.js');
  exports.concatMap = concatMap_1.concatMap;
  var concatMapTo_1 = $__require('rxjs/operators/concatMapTo.js');
  exports.concatMapTo = concatMapTo_1.concatMapTo;
  var count_1 = $__require('rxjs/operators/count.js');
  exports.count = count_1.count;
  var debounce_1 = $__require('rxjs/operators/debounce.js');
  exports.debounce = debounce_1.debounce;
  var debounceTime_1 = $__require('rxjs/operators/debounceTime.js');
  exports.debounceTime = debounceTime_1.debounceTime;
  var defaultIfEmpty_1 = $__require('rxjs/operators/defaultIfEmpty.js');
  exports.defaultIfEmpty = defaultIfEmpty_1.defaultIfEmpty;
  var delay_1 = $__require('rxjs/operators/delay.js');
  exports.delay = delay_1.delay;
  var delayWhen_1 = $__require('rxjs/operators/delayWhen.js');
  exports.delayWhen = delayWhen_1.delayWhen;
  var dematerialize_1 = $__require('rxjs/operators/dematerialize.js');
  exports.dematerialize = dematerialize_1.dematerialize;
  var distinct_1 = $__require('rxjs/operators/distinct.js');
  exports.distinct = distinct_1.distinct;
  var distinctUntilChanged_1 = $__require('rxjs/operators/distinctUntilChanged.js');
  exports.distinctUntilChanged = distinctUntilChanged_1.distinctUntilChanged;
  var distinctUntilKeyChanged_1 = $__require('rxjs/operators/distinctUntilKeyChanged.js');
  exports.distinctUntilKeyChanged = distinctUntilKeyChanged_1.distinctUntilKeyChanged;
  var elementAt_1 = $__require('rxjs/operators/elementAt.js');
  exports.elementAt = elementAt_1.elementAt;
  var every_1 = $__require('rxjs/operators/every.js');
  exports.every = every_1.every;
  var exhaust_1 = $__require('rxjs/operators/exhaust.js');
  exports.exhaust = exhaust_1.exhaust;
  var exhaustMap_1 = $__require('rxjs/operators/exhaustMap.js');
  exports.exhaustMap = exhaustMap_1.exhaustMap;
  var expand_1 = $__require('rxjs/operators/expand.js');
  exports.expand = expand_1.expand;
  var filter_1 = $__require('rxjs/operators/filter.js');
  exports.filter = filter_1.filter;
  var finalize_1 = $__require('rxjs/operators/finalize.js');
  exports.finalize = finalize_1.finalize;
  var find_1 = $__require('rxjs/operators/find.js');
  exports.find = find_1.find;
  var findIndex_1 = $__require('rxjs/operators/findIndex.js');
  exports.findIndex = findIndex_1.findIndex;
  var first_1 = $__require('rxjs/operators/first.js');
  exports.first = first_1.first;
  var groupBy_1 = $__require('rxjs/operators/groupBy.js');
  exports.groupBy = groupBy_1.groupBy;
  var ignoreElements_1 = $__require('rxjs/operators/ignoreElements.js');
  exports.ignoreElements = ignoreElements_1.ignoreElements;
  var isEmpty_1 = $__require('rxjs/operators/isEmpty.js');
  exports.isEmpty = isEmpty_1.isEmpty;
  var last_1 = $__require('rxjs/operators/last.js');
  exports.last = last_1.last;
  var map_1 = $__require('rxjs/operators/map.js');
  exports.map = map_1.map;
  var mapTo_1 = $__require('rxjs/operators/mapTo.js');
  exports.mapTo = mapTo_1.mapTo;
  var materialize_1 = $__require('rxjs/operators/materialize.js');
  exports.materialize = materialize_1.materialize;
  var max_1 = $__require('rxjs/operators/max.js');
  exports.max = max_1.max;
  var merge_1 = $__require('rxjs/operators/merge.js');
  exports.merge = merge_1.merge;
  var mergeAll_1 = $__require('rxjs/operators/mergeAll.js');
  exports.mergeAll = mergeAll_1.mergeAll;
  var mergeMap_1 = $__require('rxjs/operators/mergeMap.js');
  exports.mergeMap = mergeMap_1.mergeMap;
  var mergeMap_2 = $__require('rxjs/operators/mergeMap.js');
  exports.flatMap = mergeMap_2.mergeMap;
  var mergeMapTo_1 = $__require('rxjs/operators/mergeMapTo.js');
  exports.mergeMapTo = mergeMapTo_1.mergeMapTo;
  var mergeScan_1 = $__require('rxjs/operators/mergeScan.js');
  exports.mergeScan = mergeScan_1.mergeScan;
  var min_1 = $__require('rxjs/operators/min.js');
  exports.min = min_1.min;
  var multicast_1 = $__require('rxjs/operators/multicast.js');
  exports.multicast = multicast_1.multicast;
  var observeOn_1 = $__require('rxjs/operators/observeOn.js');
  exports.observeOn = observeOn_1.observeOn;
  var onErrorResumeNext_1 = $__require('rxjs/operators/onErrorResumeNext.js');
  exports.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNext;
  var pairwise_1 = $__require('rxjs/operators/pairwise.js');
  exports.pairwise = pairwise_1.pairwise;
  var partition_1 = $__require('rxjs/operators/partition.js');
  exports.partition = partition_1.partition;
  var pluck_1 = $__require('rxjs/operators/pluck.js');
  exports.pluck = pluck_1.pluck;
  var publish_1 = $__require('rxjs/operators/publish.js');
  exports.publish = publish_1.publish;
  var publishBehavior_1 = $__require('rxjs/operators/publishBehavior.js');
  exports.publishBehavior = publishBehavior_1.publishBehavior;
  var publishLast_1 = $__require('rxjs/operators/publishLast.js');
  exports.publishLast = publishLast_1.publishLast;
  var publishReplay_1 = $__require('rxjs/operators/publishReplay.js');
  exports.publishReplay = publishReplay_1.publishReplay;
  var race_1 = $__require('rxjs/operators/race.js');
  exports.race = race_1.race;
  var reduce_1 = $__require('rxjs/operators/reduce.js');
  exports.reduce = reduce_1.reduce;
  var repeat_1 = $__require('rxjs/operators/repeat.js');
  exports.repeat = repeat_1.repeat;
  var repeatWhen_1 = $__require('rxjs/operators/repeatWhen.js');
  exports.repeatWhen = repeatWhen_1.repeatWhen;
  var retry_1 = $__require('rxjs/operators/retry.js');
  exports.retry = retry_1.retry;
  var retryWhen_1 = $__require('rxjs/operators/retryWhen.js');
  exports.retryWhen = retryWhen_1.retryWhen;
  var refCount_1 = $__require('rxjs/operators/refCount.js');
  exports.refCount = refCount_1.refCount;
  var sample_1 = $__require('rxjs/operators/sample.js');
  exports.sample = sample_1.sample;
  var sampleTime_1 = $__require('rxjs/operators/sampleTime.js');
  exports.sampleTime = sampleTime_1.sampleTime;
  var scan_1 = $__require('rxjs/operators/scan.js');
  exports.scan = scan_1.scan;
  var sequenceEqual_1 = $__require('rxjs/operators/sequenceEqual.js');
  exports.sequenceEqual = sequenceEqual_1.sequenceEqual;
  var share_1 = $__require('rxjs/operators/share.js');
  exports.share = share_1.share;
  var shareReplay_1 = $__require('rxjs/operators/shareReplay.js');
  exports.shareReplay = shareReplay_1.shareReplay;
  var single_1 = $__require('rxjs/operators/single.js');
  exports.single = single_1.single;
  var skip_1 = $__require('rxjs/operators/skip.js');
  exports.skip = skip_1.skip;
  var skipLast_1 = $__require('rxjs/operators/skipLast.js');
  exports.skipLast = skipLast_1.skipLast;
  var skipUntil_1 = $__require('rxjs/operators/skipUntil.js');
  exports.skipUntil = skipUntil_1.skipUntil;
  var skipWhile_1 = $__require('rxjs/operators/skipWhile.js');
  exports.skipWhile = skipWhile_1.skipWhile;
  var startWith_1 = $__require('rxjs/operators/startWith.js');
  exports.startWith = startWith_1.startWith;
  /**
   * TODO(https://github.com/ReactiveX/rxjs/issues/2900): Add back subscribeOn once it can be
   * treeshaken. Currently if this export is added back, it
   * forces apps to bring in asap scheduler along with
   * Immediate, root, and other supporting code.
   */
  // export { subscribeOn } from './operators/subscribeOn';
  var switchAll_1 = $__require('rxjs/operators/switchAll.js');
  exports.switchAll = switchAll_1.switchAll;
  var switchMap_1 = $__require('rxjs/operators/switchMap.js');
  exports.switchMap = switchMap_1.switchMap;
  var switchMapTo_1 = $__require('rxjs/operators/switchMapTo.js');
  exports.switchMapTo = switchMapTo_1.switchMapTo;
  var take_1 = $__require('rxjs/operators/take.js');
  exports.take = take_1.take;
  var takeLast_1 = $__require('rxjs/operators/takeLast.js');
  exports.takeLast = takeLast_1.takeLast;
  var takeUntil_1 = $__require('rxjs/operators/takeUntil.js');
  exports.takeUntil = takeUntil_1.takeUntil;
  var takeWhile_1 = $__require('rxjs/operators/takeWhile.js');
  exports.takeWhile = takeWhile_1.takeWhile;
  var tap_1 = $__require('rxjs/operators/tap.js');
  exports.tap = tap_1.tap;
  var throttle_1 = $__require('rxjs/operators/throttle.js');
  exports.throttle = throttle_1.throttle;
  var throttleTime_1 = $__require('rxjs/operators/throttleTime.js');
  exports.throttleTime = throttleTime_1.throttleTime;
  var timeInterval_1 = $__require('rxjs/operators/timeInterval.js');
  exports.timeInterval = timeInterval_1.timeInterval;
  var timeout_1 = $__require('rxjs/operators/timeout.js');
  exports.timeout = timeout_1.timeout;
  var timeoutWith_1 = $__require('rxjs/operators/timeoutWith.js');
  exports.timeoutWith = timeoutWith_1.timeoutWith;
  var timestamp_1 = $__require('rxjs/operators/timestamp.js');
  exports.timestamp = timestamp_1.timestamp;
  var toArray_1 = $__require('rxjs/operators/toArray.js');
  exports.toArray = toArray_1.toArray;
  var window_1 = $__require('rxjs/operators/window.js');
  exports.window = window_1.window;
  var windowCount_1 = $__require('rxjs/operators/windowCount.js');
  exports.windowCount = windowCount_1.windowCount;
  var windowTime_1 = $__require('rxjs/operators/windowTime.js');
  exports.windowTime = windowTime_1.windowTime;
  var windowToggle_1 = $__require('rxjs/operators/windowToggle.js');
  exports.windowToggle = windowToggle_1.windowToggle;
  var windowWhen_1 = $__require('rxjs/operators/windowWhen.js');
  exports.windowWhen = windowWhen_1.windowWhen;
  var withLatestFrom_1 = $__require('rxjs/operators/withLatestFrom.js');
  exports.withLatestFrom = withLatestFrom_1.withLatestFrom;
  var zip_1 = $__require('rxjs/operators/zip.js');
  exports.zip = zip_1.zip;
  var zipAll_1 = $__require('rxjs/operators/zipAll.js');
  exports.zipAll = zipAll_1.zipAll;
  
});
System.registerDynamic('rxjs/Rx.js', ['rxjs/Subject.js', 'rxjs/Observable.js', 'rxjs/add/observable/bindCallback.js', 'rxjs/add/observable/bindNodeCallback.js', 'rxjs/add/observable/combineLatest.js', 'rxjs/add/observable/concat.js', 'rxjs/add/observable/defer.js', 'rxjs/add/observable/empty.js', 'rxjs/add/observable/forkJoin.js', 'rxjs/add/observable/from.js', 'rxjs/add/observable/fromEvent.js', 'rxjs/add/observable/fromEventPattern.js', 'rxjs/add/observable/fromPromise.js', 'rxjs/add/observable/generate.js', 'rxjs/add/observable/if.js', 'rxjs/add/observable/interval.js', 'rxjs/add/observable/merge.js', 'rxjs/add/observable/race.js', 'rxjs/add/observable/never.js', 'rxjs/add/observable/of.js', 'rxjs/add/observable/onErrorResumeNext.js', 'rxjs/add/observable/pairs.js', 'rxjs/add/observable/range.js', 'rxjs/add/observable/using.js', 'rxjs/add/observable/throw.js', 'rxjs/add/observable/timer.js', 'rxjs/add/observable/zip.js', 'rxjs/add/observable/dom/ajax.js', 'rxjs/add/observable/dom/webSocket.js', 'rxjs/add/operator/buffer.js', 'rxjs/add/operator/bufferCount.js', 'rxjs/add/operator/bufferTime.js', 'rxjs/add/operator/bufferToggle.js', 'rxjs/add/operator/bufferWhen.js', 'rxjs/add/operator/catch.js', 'rxjs/add/operator/combineAll.js', 'rxjs/add/operator/combineLatest.js', 'rxjs/add/operator/concat.js', 'rxjs/add/operator/concatAll.js', 'rxjs/add/operator/concatMap.js', 'rxjs/add/operator/concatMapTo.js', 'rxjs/add/operator/count.js', 'rxjs/add/operator/dematerialize.js', 'rxjs/add/operator/debounce.js', 'rxjs/add/operator/debounceTime.js', 'rxjs/add/operator/defaultIfEmpty.js', 'rxjs/add/operator/delay.js', 'rxjs/add/operator/delayWhen.js', 'rxjs/add/operator/distinct.js', 'rxjs/add/operator/distinctUntilChanged.js', 'rxjs/add/operator/distinctUntilKeyChanged.js', 'rxjs/add/operator/do.js', 'rxjs/add/operator/exhaust.js', 'rxjs/add/operator/exhaustMap.js', 'rxjs/add/operator/expand.js', 'rxjs/add/operator/elementAt.js', 'rxjs/add/operator/filter.js', 'rxjs/add/operator/finally.js', 'rxjs/add/operator/find.js', 'rxjs/add/operator/findIndex.js', 'rxjs/add/operator/first.js', 'rxjs/add/operator/groupBy.js', 'rxjs/add/operator/ignoreElements.js', 'rxjs/add/operator/isEmpty.js', 'rxjs/add/operator/audit.js', 'rxjs/add/operator/auditTime.js', 'rxjs/add/operator/last.js', 'rxjs/add/operator/let.js', 'rxjs/add/operator/every.js', 'rxjs/add/operator/map.js', 'rxjs/add/operator/mapTo.js', 'rxjs/add/operator/materialize.js', 'rxjs/add/operator/max.js', 'rxjs/add/operator/merge.js', 'rxjs/add/operator/mergeAll.js', 'rxjs/add/operator/mergeMap.js', 'rxjs/add/operator/mergeMapTo.js', 'rxjs/add/operator/mergeScan.js', 'rxjs/add/operator/min.js', 'rxjs/add/operator/multicast.js', 'rxjs/add/operator/observeOn.js', 'rxjs/add/operator/onErrorResumeNext.js', 'rxjs/add/operator/pairwise.js', 'rxjs/add/operator/partition.js', 'rxjs/add/operator/pluck.js', 'rxjs/add/operator/publish.js', 'rxjs/add/operator/publishBehavior.js', 'rxjs/add/operator/publishReplay.js', 'rxjs/add/operator/publishLast.js', 'rxjs/add/operator/race.js', 'rxjs/add/operator/reduce.js', 'rxjs/add/operator/repeat.js', 'rxjs/add/operator/repeatWhen.js', 'rxjs/add/operator/retry.js', 'rxjs/add/operator/retryWhen.js', 'rxjs/add/operator/sample.js', 'rxjs/add/operator/sampleTime.js', 'rxjs/add/operator/scan.js', 'rxjs/add/operator/sequenceEqual.js', 'rxjs/add/operator/share.js', 'rxjs/add/operator/shareReplay.js', 'rxjs/add/operator/single.js', 'rxjs/add/operator/skip.js', 'rxjs/add/operator/skipLast.js', 'rxjs/add/operator/skipUntil.js', 'rxjs/add/operator/skipWhile.js', 'rxjs/add/operator/startWith.js', 'rxjs/add/operator/subscribeOn.js', 'rxjs/add/operator/switch.js', 'rxjs/add/operator/switchMap.js', 'rxjs/add/operator/switchMapTo.js', 'rxjs/add/operator/take.js', 'rxjs/add/operator/takeLast.js', 'rxjs/add/operator/takeUntil.js', 'rxjs/add/operator/takeWhile.js', 'rxjs/add/operator/throttle.js', 'rxjs/add/operator/throttleTime.js', 'rxjs/add/operator/timeInterval.js', 'rxjs/add/operator/timeout.js', 'rxjs/add/operator/timeoutWith.js', 'rxjs/add/operator/timestamp.js', 'rxjs/add/operator/toArray.js', 'rxjs/add/operator/toPromise.js', 'rxjs/add/operator/window.js', 'rxjs/add/operator/windowCount.js', 'rxjs/add/operator/windowTime.js', 'rxjs/add/operator/windowToggle.js', 'rxjs/add/operator/windowWhen.js', 'rxjs/add/operator/withLatestFrom.js', 'rxjs/add/operator/zip.js', 'rxjs/add/operator/zipAll.js', 'rxjs/Subscription.js', 'rxjs/Subscriber.js', 'rxjs/AsyncSubject.js', 'rxjs/ReplaySubject.js', 'rxjs/BehaviorSubject.js', 'rxjs/observable/ConnectableObservable.js', 'rxjs/Notification.js', 'rxjs/util/EmptyError.js', 'rxjs/util/ArgumentOutOfRangeError.js', 'rxjs/util/ObjectUnsubscribedError.js', 'rxjs/util/TimeoutError.js', 'rxjs/util/UnsubscriptionError.js', 'rxjs/operator/timeInterval.js', 'rxjs/operators/timestamp.js', 'rxjs/testing/TestScheduler.js', 'rxjs/scheduler/VirtualTimeScheduler.js', 'rxjs/observable/dom/AjaxObservable.js', 'rxjs/util/pipe.js', 'rxjs/scheduler/asap.js', 'rxjs/scheduler/async.js', 'rxjs/scheduler/queue.js', 'rxjs/scheduler/animationFrame.js', 'rxjs/symbol/rxSubscriber.js', 'rxjs/symbol/iterator.js', 'rxjs/symbol/observable.js', 'rxjs/operators.js'], true, function ($__require, exports, module) {
  "use strict";
  /* tslint:disable:no-unused-variable */
  // Subject imported before Observable to bypass circular dependency issue since
  // Subject extends Observable and Observable references Subject in it's
  // definition

  var global = this || self,
      GLOBAL = global;
  var Subject_1 = $__require('rxjs/Subject.js');
  exports.Subject = Subject_1.Subject;
  exports.AnonymousSubject = Subject_1.AnonymousSubject;
  /* tslint:enable:no-unused-variable */
  var Observable_1 = $__require('rxjs/Observable.js');
  exports.Observable = Observable_1.Observable;
  // statics
  /* tslint:disable:no-use-before-declare */
  $__require('rxjs/add/observable/bindCallback.js');
  $__require('rxjs/add/observable/bindNodeCallback.js');
  $__require('rxjs/add/observable/combineLatest.js');
  $__require('rxjs/add/observable/concat.js');
  $__require('rxjs/add/observable/defer.js');
  $__require('rxjs/add/observable/empty.js');
  $__require('rxjs/add/observable/forkJoin.js');
  $__require('rxjs/add/observable/from.js');
  $__require('rxjs/add/observable/fromEvent.js');
  $__require('rxjs/add/observable/fromEventPattern.js');
  $__require('rxjs/add/observable/fromPromise.js');
  $__require('rxjs/add/observable/generate.js');
  $__require('rxjs/add/observable/if.js');
  $__require('rxjs/add/observable/interval.js');
  $__require('rxjs/add/observable/merge.js');
  $__require('rxjs/add/observable/race.js');
  $__require('rxjs/add/observable/never.js');
  $__require('rxjs/add/observable/of.js');
  $__require('rxjs/add/observable/onErrorResumeNext.js');
  $__require('rxjs/add/observable/pairs.js');
  $__require('rxjs/add/observable/range.js');
  $__require('rxjs/add/observable/using.js');
  $__require('rxjs/add/observable/throw.js');
  $__require('rxjs/add/observable/timer.js');
  $__require('rxjs/add/observable/zip.js');
  //dom
  $__require('rxjs/add/observable/dom/ajax.js');
  $__require('rxjs/add/observable/dom/webSocket.js');
  //operators
  $__require('rxjs/add/operator/buffer.js');
  $__require('rxjs/add/operator/bufferCount.js');
  $__require('rxjs/add/operator/bufferTime.js');
  $__require('rxjs/add/operator/bufferToggle.js');
  $__require('rxjs/add/operator/bufferWhen.js');
  $__require('rxjs/add/operator/catch.js');
  $__require('rxjs/add/operator/combineAll.js');
  $__require('rxjs/add/operator/combineLatest.js');
  $__require('rxjs/add/operator/concat.js');
  $__require('rxjs/add/operator/concatAll.js');
  $__require('rxjs/add/operator/concatMap.js');
  $__require('rxjs/add/operator/concatMapTo.js');
  $__require('rxjs/add/operator/count.js');
  $__require('rxjs/add/operator/dematerialize.js');
  $__require('rxjs/add/operator/debounce.js');
  $__require('rxjs/add/operator/debounceTime.js');
  $__require('rxjs/add/operator/defaultIfEmpty.js');
  $__require('rxjs/add/operator/delay.js');
  $__require('rxjs/add/operator/delayWhen.js');
  $__require('rxjs/add/operator/distinct.js');
  $__require('rxjs/add/operator/distinctUntilChanged.js');
  $__require('rxjs/add/operator/distinctUntilKeyChanged.js');
  $__require('rxjs/add/operator/do.js');
  $__require('rxjs/add/operator/exhaust.js');
  $__require('rxjs/add/operator/exhaustMap.js');
  $__require('rxjs/add/operator/expand.js');
  $__require('rxjs/add/operator/elementAt.js');
  $__require('rxjs/add/operator/filter.js');
  $__require('rxjs/add/operator/finally.js');
  $__require('rxjs/add/operator/find.js');
  $__require('rxjs/add/operator/findIndex.js');
  $__require('rxjs/add/operator/first.js');
  $__require('rxjs/add/operator/groupBy.js');
  $__require('rxjs/add/operator/ignoreElements.js');
  $__require('rxjs/add/operator/isEmpty.js');
  $__require('rxjs/add/operator/audit.js');
  $__require('rxjs/add/operator/auditTime.js');
  $__require('rxjs/add/operator/last.js');
  $__require('rxjs/add/operator/let.js');
  $__require('rxjs/add/operator/every.js');
  $__require('rxjs/add/operator/map.js');
  $__require('rxjs/add/operator/mapTo.js');
  $__require('rxjs/add/operator/materialize.js');
  $__require('rxjs/add/operator/max.js');
  $__require('rxjs/add/operator/merge.js');
  $__require('rxjs/add/operator/mergeAll.js');
  $__require('rxjs/add/operator/mergeMap.js');
  $__require('rxjs/add/operator/mergeMapTo.js');
  $__require('rxjs/add/operator/mergeScan.js');
  $__require('rxjs/add/operator/min.js');
  $__require('rxjs/add/operator/multicast.js');
  $__require('rxjs/add/operator/observeOn.js');
  $__require('rxjs/add/operator/onErrorResumeNext.js');
  $__require('rxjs/add/operator/pairwise.js');
  $__require('rxjs/add/operator/partition.js');
  $__require('rxjs/add/operator/pluck.js');
  $__require('rxjs/add/operator/publish.js');
  $__require('rxjs/add/operator/publishBehavior.js');
  $__require('rxjs/add/operator/publishReplay.js');
  $__require('rxjs/add/operator/publishLast.js');
  $__require('rxjs/add/operator/race.js');
  $__require('rxjs/add/operator/reduce.js');
  $__require('rxjs/add/operator/repeat.js');
  $__require('rxjs/add/operator/repeatWhen.js');
  $__require('rxjs/add/operator/retry.js');
  $__require('rxjs/add/operator/retryWhen.js');
  $__require('rxjs/add/operator/sample.js');
  $__require('rxjs/add/operator/sampleTime.js');
  $__require('rxjs/add/operator/scan.js');
  $__require('rxjs/add/operator/sequenceEqual.js');
  $__require('rxjs/add/operator/share.js');
  $__require('rxjs/add/operator/shareReplay.js');
  $__require('rxjs/add/operator/single.js');
  $__require('rxjs/add/operator/skip.js');
  $__require('rxjs/add/operator/skipLast.js');
  $__require('rxjs/add/operator/skipUntil.js');
  $__require('rxjs/add/operator/skipWhile.js');
  $__require('rxjs/add/operator/startWith.js');
  $__require('rxjs/add/operator/subscribeOn.js');
  $__require('rxjs/add/operator/switch.js');
  $__require('rxjs/add/operator/switchMap.js');
  $__require('rxjs/add/operator/switchMapTo.js');
  $__require('rxjs/add/operator/take.js');
  $__require('rxjs/add/operator/takeLast.js');
  $__require('rxjs/add/operator/takeUntil.js');
  $__require('rxjs/add/operator/takeWhile.js');
  $__require('rxjs/add/operator/throttle.js');
  $__require('rxjs/add/operator/throttleTime.js');
  $__require('rxjs/add/operator/timeInterval.js');
  $__require('rxjs/add/operator/timeout.js');
  $__require('rxjs/add/operator/timeoutWith.js');
  $__require('rxjs/add/operator/timestamp.js');
  $__require('rxjs/add/operator/toArray.js');
  $__require('rxjs/add/operator/toPromise.js');
  $__require('rxjs/add/operator/window.js');
  $__require('rxjs/add/operator/windowCount.js');
  $__require('rxjs/add/operator/windowTime.js');
  $__require('rxjs/add/operator/windowToggle.js');
  $__require('rxjs/add/operator/windowWhen.js');
  $__require('rxjs/add/operator/withLatestFrom.js');
  $__require('rxjs/add/operator/zip.js');
  $__require('rxjs/add/operator/zipAll.js');
  /* tslint:disable:no-unused-variable */
  var Subscription_1 = $__require('rxjs/Subscription.js');
  exports.Subscription = Subscription_1.Subscription;
  var Subscriber_1 = $__require('rxjs/Subscriber.js');
  exports.Subscriber = Subscriber_1.Subscriber;
  var AsyncSubject_1 = $__require('rxjs/AsyncSubject.js');
  exports.AsyncSubject = AsyncSubject_1.AsyncSubject;
  var ReplaySubject_1 = $__require('rxjs/ReplaySubject.js');
  exports.ReplaySubject = ReplaySubject_1.ReplaySubject;
  var BehaviorSubject_1 = $__require('rxjs/BehaviorSubject.js');
  exports.BehaviorSubject = BehaviorSubject_1.BehaviorSubject;
  var ConnectableObservable_1 = $__require('rxjs/observable/ConnectableObservable.js');
  exports.ConnectableObservable = ConnectableObservable_1.ConnectableObservable;
  var Notification_1 = $__require('rxjs/Notification.js');
  exports.Notification = Notification_1.Notification;
  var EmptyError_1 = $__require('rxjs/util/EmptyError.js');
  exports.EmptyError = EmptyError_1.EmptyError;
  var ArgumentOutOfRangeError_1 = $__require('rxjs/util/ArgumentOutOfRangeError.js');
  exports.ArgumentOutOfRangeError = ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
  var ObjectUnsubscribedError_1 = $__require('rxjs/util/ObjectUnsubscribedError.js');
  exports.ObjectUnsubscribedError = ObjectUnsubscribedError_1.ObjectUnsubscribedError;
  var TimeoutError_1 = $__require('rxjs/util/TimeoutError.js');
  exports.TimeoutError = TimeoutError_1.TimeoutError;
  var UnsubscriptionError_1 = $__require('rxjs/util/UnsubscriptionError.js');
  exports.UnsubscriptionError = UnsubscriptionError_1.UnsubscriptionError;
  var timeInterval_1 = $__require('rxjs/operator/timeInterval.js');
  exports.TimeInterval = timeInterval_1.TimeInterval;
  var timestamp_1 = $__require('rxjs/operators/timestamp.js');
  exports.Timestamp = timestamp_1.Timestamp;
  var TestScheduler_1 = $__require('rxjs/testing/TestScheduler.js');
  exports.TestScheduler = TestScheduler_1.TestScheduler;
  var VirtualTimeScheduler_1 = $__require('rxjs/scheduler/VirtualTimeScheduler.js');
  exports.VirtualTimeScheduler = VirtualTimeScheduler_1.VirtualTimeScheduler;
  var AjaxObservable_1 = $__require('rxjs/observable/dom/AjaxObservable.js');
  exports.AjaxResponse = AjaxObservable_1.AjaxResponse;
  exports.AjaxError = AjaxObservable_1.AjaxError;
  exports.AjaxTimeoutError = AjaxObservable_1.AjaxTimeoutError;
  var pipe_1 = $__require('rxjs/util/pipe.js');
  exports.pipe = pipe_1.pipe;
  var asap_1 = $__require('rxjs/scheduler/asap.js');
  var async_1 = $__require('rxjs/scheduler/async.js');
  var queue_1 = $__require('rxjs/scheduler/queue.js');
  var animationFrame_1 = $__require('rxjs/scheduler/animationFrame.js');
  var rxSubscriber_1 = $__require('rxjs/symbol/rxSubscriber.js');
  var iterator_1 = $__require('rxjs/symbol/iterator.js');
  var observable_1 = $__require('rxjs/symbol/observable.js');
  var _operators = $__require('rxjs/operators.js');
  exports.operators = _operators;
  /* tslint:enable:no-unused-variable */
  /**
   * @typedef {Object} Rx.Scheduler
   * @property {Scheduler} queue Schedules on a queue in the current event frame
   * (trampoline scheduler). Use this for iteration operations.
   * @property {Scheduler} asap Schedules on the micro task queue, which uses the
   * fastest transport mechanism available, either Node.js' `process.nextTick()`
   * or Web Worker MessageChannel or setTimeout or others. Use this for
   * asynchronous conversions.
   * @property {Scheduler} async Schedules work with `setInterval`. Use this for
   * time-based operations.
   * @property {Scheduler} animationFrame Schedules work with `requestAnimationFrame`.
   * Use this for synchronizing with the platform's painting
   */
  var Scheduler = {
    asap: asap_1.asap,
    queue: queue_1.queue,
    animationFrame: animationFrame_1.animationFrame,
    async: async_1.async
  };
  exports.Scheduler = Scheduler;
  /**
   * @typedef {Object} Rx.Symbol
   * @property {Symbol|string} rxSubscriber A symbol to use as a property name to
   * retrieve an "Rx safe" Observer from an object. "Rx safety" can be defined as
   * an object that has all of the traits of an Rx Subscriber, including the
   * ability to add and remove subscriptions to the subscription chain and
   * guarantees involving event triggering (can't "next" after unsubscription,
   * etc).
   * @property {Symbol|string} observable A symbol to use as a property name to
   * retrieve an Observable as defined by the [ECMAScript "Observable" spec](https://github.com/zenparsing/es-observable).
   * @property {Symbol|string} iterator The ES6 symbol to use as a property name
   * to retrieve an iterator from an object.
   */
  var Symbol = {
    rxSubscriber: rxSubscriber_1.rxSubscriber,
    observable: observable_1.observable,
    iterator: iterator_1.iterator
  };
  exports.Symbol = Symbol;
  
});
// HACK: does nothing, because `toPromise` now lives on the `Observable` itself.
// leaving this module here to prevent breakage.

System.registerDynamic("rxjs/add/operator/toPromise.js", [], false, function ($__require, $__exports, $__module) {
  var _retrieveGlobal = System.get("@@global-helpers").prepareGlobal($__module.id, null, null);

  (function ($__global) {})(this);

  return _retrieveGlobal();
});
System.registerDynamic("rxjs/operators/tap.js", ["rxjs/Subscriber.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require("rxjs/Subscriber.js");
    /* tslint:enable:max-line-length */
    /**
     * Perform a side effect for every emission on the source Observable, but return
     * an Observable that is identical to the source.
     *
     * <span class="informal">Intercepts each emission on the source and runs a
     * function, but returns an output which is identical to the source as long as errors don't occur.</span>
     *
     * <img src="./img/do.png" width="100%">
     *
     * Returns a mirrored Observable of the source Observable, but modified so that
     * the provided Observer is called to perform a side effect for every value,
     * error, and completion emitted by the source. Any errors that are thrown in
     * the aforementioned Observer or handlers are safely sent down the error path
     * of the output Observable.
     *
     * This operator is useful for debugging your Observables for the correct values
     * or performing other side effects.
     *
     * Note: this is different to a `subscribe` on the Observable. If the Observable
     * returned by `do` is not subscribed, the side effects specified by the
     * Observer will never happen. `do` therefore simply spies on existing
     * execution, it does not trigger an execution to happen like `subscribe` does.
     *
     * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var positions = clicks
     *   .do(ev => console.log(ev))
     *   .map(ev => ev.clientX);
     * positions.subscribe(x => console.log(x));
     *
     * @see {@link map}
     * @see {@link subscribe}
     *
     * @param {Observer|function} [nextOrObserver] A normal Observer object or a
     * callback for `next`.
     * @param {function} [error] Callback for errors in the source.
     * @param {function} [complete] Callback for the completion of the source.
     * @return {Observable} An Observable identical to the source, but runs the
     * specified Observer or callback(s) for each item.
     * @name tap
     */
    function tap(nextOrObserver, error, complete) {
        return function tapOperatorFunction(source) {
            return source.lift(new DoOperator(nextOrObserver, error, complete));
        };
    }
    exports.tap = tap;
    var DoOperator = function () {
        function DoOperator(nextOrObserver, error, complete) {
            this.nextOrObserver = nextOrObserver;
            this.error = error;
            this.complete = complete;
        }
        DoOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new DoSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
        };
        return DoOperator;
    }();
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var DoSubscriber = function (_super) {
        __extends(DoSubscriber, _super);
        function DoSubscriber(destination, nextOrObserver, error, complete) {
            _super.call(this, destination);
            var safeSubscriber = new Subscriber_1.Subscriber(nextOrObserver, error, complete);
            safeSubscriber.syncErrorThrowable = true;
            this.add(safeSubscriber);
            this.safeSubscriber = safeSubscriber;
        }
        DoSubscriber.prototype._next = function (value) {
            var safeSubscriber = this.safeSubscriber;
            safeSubscriber.next(value);
            if (safeSubscriber.syncErrorThrown) {
                this.destination.error(safeSubscriber.syncErrorValue);
            } else {
                this.destination.next(value);
            }
        };
        DoSubscriber.prototype._error = function (err) {
            var safeSubscriber = this.safeSubscriber;
            safeSubscriber.error(err);
            if (safeSubscriber.syncErrorThrown) {
                this.destination.error(safeSubscriber.syncErrorValue);
            } else {
                this.destination.error(err);
            }
        };
        DoSubscriber.prototype._complete = function () {
            var safeSubscriber = this.safeSubscriber;
            safeSubscriber.complete();
            if (safeSubscriber.syncErrorThrown) {
                this.destination.error(safeSubscriber.syncErrorValue);
            } else {
                this.destination.complete();
            }
        };
        return DoSubscriber;
    }(Subscriber_1.Subscriber);
    
});
System.registerDynamic("rxjs/operator/do.js", ["rxjs/operators/tap.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var tap_1 = $__require("rxjs/operators/tap.js");
  /* tslint:enable:max-line-length */
  /**
   * Perform a side effect for every emission on the source Observable, but return
   * an Observable that is identical to the source.
   *
   * <span class="informal">Intercepts each emission on the source and runs a
   * function, but returns an output which is identical to the source as long as errors don't occur.</span>
   *
   * <img src="./img/do.png" width="100%">
   *
   * Returns a mirrored Observable of the source Observable, but modified so that
   * the provided Observer is called to perform a side effect for every value,
   * error, and completion emitted by the source. Any errors that are thrown in
   * the aforementioned Observer or handlers are safely sent down the error path
   * of the output Observable.
   *
   * This operator is useful for debugging your Observables for the correct values
   * or performing other side effects.
   *
   * Note: this is different to a `subscribe` on the Observable. If the Observable
   * returned by `do` is not subscribed, the side effects specified by the
   * Observer will never happen. `do` therefore simply spies on existing
   * execution, it does not trigger an execution to happen like `subscribe` does.
   *
   * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var positions = clicks
   *   .do(ev => console.log(ev))
   *   .map(ev => ev.clientX);
   * positions.subscribe(x => console.log(x));
   *
   * @see {@link map}
   * @see {@link subscribe}
   *
   * @param {Observer|function} [nextOrObserver] A normal Observer object or a
   * callback for `next`.
   * @param {function} [error] Callback for errors in the source.
   * @param {function} [complete] Callback for the completion of the source.
   * @return {Observable} An Observable identical to the source, but runs the
   * specified Observer or callback(s) for each item.
   * @method do
   * @name do
   * @owner Observable
   */
  function _do(nextOrObserver, error, complete) {
    return tap_1.tap(nextOrObserver, error, complete)(this);
  }
  exports._do = _do;
  
});
System.registerDynamic('rxjs/add/operator/do.js', ['rxjs/Observable.js', 'rxjs/operator/do.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var do_1 = $__require('rxjs/operator/do.js');
  Observable_1.Observable.prototype.do = do_1._do;
  Observable_1.Observable.prototype._do = do_1._do;
  
});
System.registerDynamic("rxjs/operators/concatMap.js", ["rxjs/operators/mergeMap.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var mergeMap_1 = $__require("rxjs/operators/mergeMap.js");
  /* tslint:enable:max-line-length */
  /**
   * Projects each source value to an Observable which is merged in the output
   * Observable, in a serialized fashion waiting for each one to complete before
   * merging the next.
   *
   * <span class="informal">Maps each value to an Observable, then flattens all of
   * these inner Observables using {@link concatAll}.</span>
   *
   * <img src="./img/concatMap.png" width="100%">
   *
   * Returns an Observable that emits items based on applying a function that you
   * supply to each item emitted by the source Observable, where that function
   * returns an (so-called "inner") Observable. Each new inner Observable is
   * concatenated with the previous inner Observable.
   *
   * __Warning:__ if source values arrive endlessly and faster than their
   * corresponding inner Observables can complete, it will result in memory issues
   * as inner Observables amass in an unbounded buffer waiting for their turn to
   * be subscribed to.
   *
   * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
   * to `1`.
   *
   * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
   * result.subscribe(x => console.log(x));
   *
   * // Results in the following:
   * // (results are not concurrent)
   * // For every click on the "document" it will emit values 0 to 3 spaced
   * // on a 1000ms interval
   * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
   *
   * @see {@link concat}
   * @see {@link concatAll}
   * @see {@link concatMapTo}
   * @see {@link exhaustMap}
   * @see {@link mergeMap}
   * @see {@link switchMap}
   *
   * @param {function(value: T, ?index: number): ObservableInput} project A function
   * that, when applied to an item emitted by the source Observable, returns an
   * Observable.
   * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
   * A function to produce the value on the output Observable based on the values
   * and the indices of the source (outer) emission and the inner Observable
   * emission. The arguments passed to this function are:
   * - `outerValue`: the value that came from the source
   * - `innerValue`: the value that came from the projected Observable
   * - `outerIndex`: the "index" of the value that came from the source
   * - `innerIndex`: the "index" of the value from the projected Observable
   * @return {Observable} An Observable that emits the result of applying the
   * projection function (and the optional `resultSelector`) to each item emitted
   * by the source Observable and taking values from each projected inner
   * Observable sequentially.
   * @method concatMap
   * @owner Observable
   */
  function concatMap(project, resultSelector) {
    return mergeMap_1.mergeMap(project, resultSelector, 1);
  }
  exports.concatMap = concatMap;
  
});
System.registerDynamic("rxjs/operator/concatMap.js", ["rxjs/operators/concatMap.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var concatMap_1 = $__require("rxjs/operators/concatMap.js");
  /* tslint:enable:max-line-length */
  /**
   * Projects each source value to an Observable which is merged in the output
   * Observable, in a serialized fashion waiting for each one to complete before
   * merging the next.
   *
   * <span class="informal">Maps each value to an Observable, then flattens all of
   * these inner Observables using {@link concatAll}.</span>
   *
   * <img src="./img/concatMap.png" width="100%">
   *
   * Returns an Observable that emits items based on applying a function that you
   * supply to each item emitted by the source Observable, where that function
   * returns an (so-called "inner") Observable. Each new inner Observable is
   * concatenated with the previous inner Observable.
   *
   * __Warning:__ if source values arrive endlessly and faster than their
   * corresponding inner Observables can complete, it will result in memory issues
   * as inner Observables amass in an unbounded buffer waiting for their turn to
   * be subscribed to.
   *
   * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
   * to `1`.
   *
   * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
   * result.subscribe(x => console.log(x));
   *
   * // Results in the following:
   * // (results are not concurrent)
   * // For every click on the "document" it will emit values 0 to 3 spaced
   * // on a 1000ms interval
   * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
   *
   * @see {@link concat}
   * @see {@link concatAll}
   * @see {@link concatMapTo}
   * @see {@link exhaustMap}
   * @see {@link mergeMap}
   * @see {@link switchMap}
   *
   * @param {function(value: T, ?index: number): ObservableInput} project A function
   * that, when applied to an item emitted by the source Observable, returns an
   * Observable.
   * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
   * A function to produce the value on the output Observable based on the values
   * and the indices of the source (outer) emission and the inner Observable
   * emission. The arguments passed to this function are:
   * - `outerValue`: the value that came from the source
   * - `innerValue`: the value that came from the projected Observable
   * - `outerIndex`: the "index" of the value that came from the source
   * - `innerIndex`: the "index" of the value from the projected Observable
   * @return {Observable} An Observable that emits the result of applying the
   * projection function (and the optional `resultSelector`) to each item emitted
   * by the source Observable and taking values from each projected inner
   * Observable sequentially.
   * @method concatMap
   * @owner Observable
   */
  function concatMap(project, resultSelector) {
    return concatMap_1.concatMap(project, resultSelector)(this);
  }
  exports.concatMap = concatMap;
  
});
System.registerDynamic('rxjs/add/operator/concatMap.js', ['rxjs/Observable.js', 'rxjs/operator/concatMap.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var concatMap_1 = $__require('rxjs/operator/concatMap.js');
  Observable_1.Observable.prototype.concatMap = concatMap_1.concatMap;
  
});
System.registerDynamic('rxjs/operators/merge.js', ['rxjs/observable/merge.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var merge_1 = $__require('rxjs/observable/merge.js');
    var merge_2 = $__require('rxjs/observable/merge.js');
    exports.mergeStatic = merge_2.merge;
    /* tslint:enable:max-line-length */
    /**
     * Creates an output Observable which concurrently emits all values from every
     * given input Observable.
     *
     * <span class="informal">Flattens multiple Observables together by blending
     * their values into one Observable.</span>
     *
     * <img src="./img/merge.png" width="100%">
     *
     * `merge` subscribes to each given input Observable (either the source or an
     * Observable given as argument), and simply forwards (without doing any
     * transformation) all the values from all the input Observables to the output
     * Observable. The output Observable only completes once all input Observables
     * have completed. Any error delivered by an input Observable will be immediately
     * emitted on the output Observable.
     *
     * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var timer = Rx.Observable.interval(1000);
     * var clicksOrTimer = clicks.merge(timer);
     * clicksOrTimer.subscribe(x => console.log(x));
     *
     * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
     * var timer1 = Rx.Observable.interval(1000).take(10);
     * var timer2 = Rx.Observable.interval(2000).take(6);
     * var timer3 = Rx.Observable.interval(500).take(10);
     * var concurrent = 2; // the argument
     * var merged = timer1.merge(timer2, timer3, concurrent);
     * merged.subscribe(x => console.log(x));
     *
     * @see {@link mergeAll}
     * @see {@link mergeMap}
     * @see {@link mergeMapTo}
     * @see {@link mergeScan}
     *
     * @param {ObservableInput} other An input Observable to merge with the source
     * Observable. More than one input Observables may be given as argument.
     * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
     * Observables being subscribed to concurrently.
     * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
     * concurrency of input Observables.
     * @return {Observable} An Observable that emits items that are the result of
     * every input Observable.
     * @method merge
     * @owner Observable
     */
    function merge() {
        var observables = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            observables[_i - 0] = arguments[_i];
        }
        return function (source) {
            return source.lift.call(merge_1.merge.apply(void 0, [source].concat(observables)));
        };
    }
    exports.merge = merge;
    
});
System.registerDynamic("rxjs/InnerSubscriber.js", ["rxjs/Subscriber.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require("rxjs/Subscriber.js");
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var InnerSubscriber = function (_super) {
        __extends(InnerSubscriber, _super);
        function InnerSubscriber(parent, outerValue, outerIndex) {
            _super.call(this);
            this.parent = parent;
            this.outerValue = outerValue;
            this.outerIndex = outerIndex;
            this.index = 0;
        }
        InnerSubscriber.prototype._next = function (value) {
            this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
        };
        InnerSubscriber.prototype._error = function (error) {
            this.parent.notifyError(error, this);
            this.unsubscribe();
        };
        InnerSubscriber.prototype._complete = function () {
            this.parent.notifyComplete(this);
            this.unsubscribe();
        };
        return InnerSubscriber;
    }(Subscriber_1.Subscriber);
    exports.InnerSubscriber = InnerSubscriber;
    
});
System.registerDynamic('rxjs/util/subscribeToResult.js', ['rxjs/util/root.js', 'rxjs/util/isArrayLike.js', 'rxjs/util/isPromise.js', 'rxjs/util/isObject.js', 'rxjs/Observable.js', 'rxjs/symbol/iterator.js', 'rxjs/InnerSubscriber.js', 'rxjs/symbol/observable.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var root_1 = $__require('rxjs/util/root.js');
    var isArrayLike_1 = $__require('rxjs/util/isArrayLike.js');
    var isPromise_1 = $__require('rxjs/util/isPromise.js');
    var isObject_1 = $__require('rxjs/util/isObject.js');
    var Observable_1 = $__require('rxjs/Observable.js');
    var iterator_1 = $__require('rxjs/symbol/iterator.js');
    var InnerSubscriber_1 = $__require('rxjs/InnerSubscriber.js');
    var observable_1 = $__require('rxjs/symbol/observable.js');
    function subscribeToResult(outerSubscriber, result, outerValue, outerIndex) {
        var destination = new InnerSubscriber_1.InnerSubscriber(outerSubscriber, outerValue, outerIndex);
        if (destination.closed) {
            return null;
        }
        if (result instanceof Observable_1.Observable) {
            if (result._isScalar) {
                destination.next(result.value);
                destination.complete();
                return null;
            } else {
                destination.syncErrorThrowable = true;
                return result.subscribe(destination);
            }
        } else if (isArrayLike_1.isArrayLike(result)) {
            for (var i = 0, len = result.length; i < len && !destination.closed; i++) {
                destination.next(result[i]);
            }
            if (!destination.closed) {
                destination.complete();
            }
        } else if (isPromise_1.isPromise(result)) {
            result.then(function (value) {
                if (!destination.closed) {
                    destination.next(value);
                    destination.complete();
                }
            }, function (err) {
                return destination.error(err);
            }).then(null, function (err) {
                // Escaping the Promise trap: globally throw unhandled errors
                root_1.root.setTimeout(function () {
                    throw err;
                });
            });
            return destination;
        } else if (result && typeof result[iterator_1.iterator] === 'function') {
            var iterator = result[iterator_1.iterator]();
            do {
                var item = iterator.next();
                if (item.done) {
                    destination.complete();
                    break;
                }
                destination.next(item.value);
                if (destination.closed) {
                    break;
                }
            } while (true);
        } else if (result && typeof result[observable_1.observable] === 'function') {
            var obs = result[observable_1.observable]();
            if (typeof obs.subscribe !== 'function') {
                destination.error(new TypeError('Provided object does not correctly implement Symbol.observable'));
            } else {
                return obs.subscribe(new InnerSubscriber_1.InnerSubscriber(outerSubscriber, outerValue, outerIndex));
            }
        } else {
            var value = isObject_1.isObject(result) ? 'an invalid object' : "'" + result + "'";
            var msg = "You provided " + value + " where a stream was expected." + ' You can provide an Observable, Promise, Array, or Iterable.';
            destination.error(new TypeError(msg));
        }
        return null;
    }
    exports.subscribeToResult = subscribeToResult;
    
});
System.registerDynamic("rxjs/OuterSubscriber.js", ["rxjs/Subscriber.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require("rxjs/Subscriber.js");
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var OuterSubscriber = function (_super) {
        __extends(OuterSubscriber, _super);
        function OuterSubscriber() {
            _super.apply(this, arguments);
        }
        OuterSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            this.destination.next(innerValue);
        };
        OuterSubscriber.prototype.notifyError = function (error, innerSub) {
            this.destination.error(error);
        };
        OuterSubscriber.prototype.notifyComplete = function (innerSub) {
            this.destination.complete();
        };
        return OuterSubscriber;
    }(Subscriber_1.Subscriber);
    exports.OuterSubscriber = OuterSubscriber;
    
});
System.registerDynamic('rxjs/operators/mergeMap.js', ['rxjs/util/subscribeToResult.js', 'rxjs/OuterSubscriber.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var subscribeToResult_1 = $__require('rxjs/util/subscribeToResult.js');
    var OuterSubscriber_1 = $__require('rxjs/OuterSubscriber.js');
    /* tslint:enable:max-line-length */
    /**
     * Projects each source value to an Observable which is merged in the output
     * Observable.
     *
     * <span class="informal">Maps each value to an Observable, then flattens all of
     * these inner Observables using {@link mergeAll}.</span>
     *
     * <img src="./img/mergeMap.png" width="100%">
     *
     * Returns an Observable that emits items based on applying a function that you
     * supply to each item emitted by the source Observable, where that function
     * returns an Observable, and then merging those resulting Observables and
     * emitting the results of this merger.
     *
     * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
     * var letters = Rx.Observable.of('a', 'b', 'c');
     * var result = letters.mergeMap(x =>
     *   Rx.Observable.interval(1000).map(i => x+i)
     * );
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // a0
     * // b0
     * // c0
     * // a1
     * // b1
     * // c1
     * // continues to list a,b,c with respective ascending integers
     *
     * @see {@link concatMap}
     * @see {@link exhaustMap}
     * @see {@link merge}
     * @see {@link mergeAll}
     * @see {@link mergeMapTo}
     * @see {@link mergeScan}
     * @see {@link switchMap}
     *
     * @param {function(value: T, ?index: number): ObservableInput} project A function
     * that, when applied to an item emitted by the source Observable, returns an
     * Observable.
     * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
     * A function to produce the value on the output Observable based on the values
     * and the indices of the source (outer) emission and the inner Observable
     * emission. The arguments passed to this function are:
     * - `outerValue`: the value that came from the source
     * - `innerValue`: the value that came from the projected Observable
     * - `outerIndex`: the "index" of the value that came from the source
     * - `innerIndex`: the "index" of the value from the projected Observable
     * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
     * Observables being subscribed to concurrently.
     * @return {Observable} An Observable that emits the result of applying the
     * projection function (and the optional `resultSelector`) to each item emitted
     * by the source Observable and merging the results of the Observables obtained
     * from this transformation.
     * @method mergeMap
     * @owner Observable
     */
    function mergeMap(project, resultSelector, concurrent) {
        if (concurrent === void 0) {
            concurrent = Number.POSITIVE_INFINITY;
        }
        return function mergeMapOperatorFunction(source) {
            if (typeof resultSelector === 'number') {
                concurrent = resultSelector;
                resultSelector = null;
            }
            return source.lift(new MergeMapOperator(project, resultSelector, concurrent));
        };
    }
    exports.mergeMap = mergeMap;
    var MergeMapOperator = function () {
        function MergeMapOperator(project, resultSelector, concurrent) {
            if (concurrent === void 0) {
                concurrent = Number.POSITIVE_INFINITY;
            }
            this.project = project;
            this.resultSelector = resultSelector;
            this.concurrent = concurrent;
        }
        MergeMapOperator.prototype.call = function (observer, source) {
            return source.subscribe(new MergeMapSubscriber(observer, this.project, this.resultSelector, this.concurrent));
        };
        return MergeMapOperator;
    }();
    exports.MergeMapOperator = MergeMapOperator;
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var MergeMapSubscriber = function (_super) {
        __extends(MergeMapSubscriber, _super);
        function MergeMapSubscriber(destination, project, resultSelector, concurrent) {
            if (concurrent === void 0) {
                concurrent = Number.POSITIVE_INFINITY;
            }
            _super.call(this, destination);
            this.project = project;
            this.resultSelector = resultSelector;
            this.concurrent = concurrent;
            this.hasCompleted = false;
            this.buffer = [];
            this.active = 0;
            this.index = 0;
        }
        MergeMapSubscriber.prototype._next = function (value) {
            if (this.active < this.concurrent) {
                this._tryNext(value);
            } else {
                this.buffer.push(value);
            }
        };
        MergeMapSubscriber.prototype._tryNext = function (value) {
            var result;
            var index = this.index++;
            try {
                result = this.project(value, index);
            } catch (err) {
                this.destination.error(err);
                return;
            }
            this.active++;
            this._innerSub(result, value, index);
        };
        MergeMapSubscriber.prototype._innerSub = function (ish, value, index) {
            this.add(subscribeToResult_1.subscribeToResult(this, ish, value, index));
        };
        MergeMapSubscriber.prototype._complete = function () {
            this.hasCompleted = true;
            if (this.active === 0 && this.buffer.length === 0) {
                this.destination.complete();
            }
        };
        MergeMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
            if (this.resultSelector) {
                this._notifyResultSelector(outerValue, innerValue, outerIndex, innerIndex);
            } else {
                this.destination.next(innerValue);
            }
        };
        MergeMapSubscriber.prototype._notifyResultSelector = function (outerValue, innerValue, outerIndex, innerIndex) {
            var result;
            try {
                result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
            } catch (err) {
                this.destination.error(err);
                return;
            }
            this.destination.next(result);
        };
        MergeMapSubscriber.prototype.notifyComplete = function (innerSub) {
            var buffer = this.buffer;
            this.remove(innerSub);
            this.active--;
            if (buffer.length > 0) {
                this._next(buffer.shift());
            } else if (this.active === 0 && this.hasCompleted) {
                this.destination.complete();
            }
        };
        return MergeMapSubscriber;
    }(OuterSubscriber_1.OuterSubscriber);
    exports.MergeMapSubscriber = MergeMapSubscriber;
    
});
System.registerDynamic("rxjs/util/identity.js", [], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    function identity(x) {
        return x;
    }
    exports.identity = identity;
    
});
System.registerDynamic('rxjs/operators/mergeAll.js', ['rxjs/operators/mergeMap.js', 'rxjs/util/identity.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var mergeMap_1 = $__require('rxjs/operators/mergeMap.js');
  var identity_1 = $__require('rxjs/util/identity.js');
  /**
   * Converts a higher-order Observable into a first-order Observable which
   * concurrently delivers all values that are emitted on the inner Observables.
   *
   * <span class="informal">Flattens an Observable-of-Observables.</span>
   *
   * <img src="./img/mergeAll.png" width="100%">
   *
   * `mergeAll` subscribes to an Observable that emits Observables, also known as
   * a higher-order Observable. Each time it observes one of these emitted inner
   * Observables, it subscribes to that and delivers all the values from the
   * inner Observable on the output Observable. The output Observable only
   * completes once all inner Observables have completed. Any error delivered by
   * a inner Observable will be immediately emitted on the output Observable.
   *
   * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
   * var firstOrder = higherOrder.mergeAll();
   * firstOrder.subscribe(x => console.log(x));
   *
   * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
   * var clicks = Rx.Observable.fromEvent(document, 'click');
   * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
   * var firstOrder = higherOrder.mergeAll(2);
   * firstOrder.subscribe(x => console.log(x));
   *
   * @see {@link combineAll}
   * @see {@link concatAll}
   * @see {@link exhaust}
   * @see {@link merge}
   * @see {@link mergeMap}
   * @see {@link mergeMapTo}
   * @see {@link mergeScan}
   * @see {@link switch}
   * @see {@link zipAll}
   *
   * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
   * Observables being subscribed to concurrently.
   * @return {Observable} An Observable that emits values coming from all the
   * inner Observables emitted by the source Observable.
   * @method mergeAll
   * @owner Observable
   */
  function mergeAll(concurrent) {
    if (concurrent === void 0) {
      concurrent = Number.POSITIVE_INFINITY;
    }
    return mergeMap_1.mergeMap(identity_1.identity, null, concurrent);
  }
  exports.mergeAll = mergeAll;
  
});
System.registerDynamic('rxjs/observable/merge.js', ['rxjs/Observable.js', 'rxjs/observable/ArrayObservable.js', 'rxjs/util/isScheduler.js', 'rxjs/operators/mergeAll.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var Observable_1 = $__require('rxjs/Observable.js');
    var ArrayObservable_1 = $__require('rxjs/observable/ArrayObservable.js');
    var isScheduler_1 = $__require('rxjs/util/isScheduler.js');
    var mergeAll_1 = $__require('rxjs/operators/mergeAll.js');
    /* tslint:enable:max-line-length */
    /**
     * Creates an output Observable which concurrently emits all values from every
     * given input Observable.
     *
     * <span class="informal">Flattens multiple Observables together by blending
     * their values into one Observable.</span>
     *
     * <img src="./img/merge.png" width="100%">
     *
     * `merge` subscribes to each given input Observable (as arguments), and simply
     * forwards (without doing any transformation) all the values from all the input
     * Observables to the output Observable. The output Observable only completes
     * once all input Observables have completed. Any error delivered by an input
     * Observable will be immediately emitted on the output Observable.
     *
     * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var timer = Rx.Observable.interval(1000);
     * var clicksOrTimer = Rx.Observable.merge(clicks, timer);
     * clicksOrTimer.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // timer will emit ascending values, one every second(1000ms) to console
     * // clicks logs MouseEvents to console everytime the "document" is clicked
     * // Since the two streams are merged you see these happening
     * // as they occur.
     *
     * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
     * var timer1 = Rx.Observable.interval(1000).take(10);
     * var timer2 = Rx.Observable.interval(2000).take(6);
     * var timer3 = Rx.Observable.interval(500).take(10);
     * var concurrent = 2; // the argument
     * var merged = Rx.Observable.merge(timer1, timer2, timer3, concurrent);
     * merged.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // - First timer1 and timer2 will run concurrently
     * // - timer1 will emit a value every 1000ms for 10 iterations
     * // - timer2 will emit a value every 2000ms for 6 iterations
     * // - after timer1 hits it's max iteration, timer2 will
     * //   continue, and timer3 will start to run concurrently with timer2
     * // - when timer2 hits it's max iteration it terminates, and
     * //   timer3 will continue to emit a value every 500ms until it is complete
     *
     * @see {@link mergeAll}
     * @see {@link mergeMap}
     * @see {@link mergeMapTo}
     * @see {@link mergeScan}
     *
     * @param {...ObservableInput} observables Input Observables to merge together.
     * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
     * Observables being subscribed to concurrently.
     * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
     * concurrency of input Observables.
     * @return {Observable} an Observable that emits items that are the result of
     * every input Observable.
     * @static true
     * @name merge
     * @owner Observable
     */
    function merge() {
        var observables = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            observables[_i - 0] = arguments[_i];
        }
        var concurrent = Number.POSITIVE_INFINITY;
        var scheduler = null;
        var last = observables[observables.length - 1];
        if (isScheduler_1.isScheduler(last)) {
            scheduler = observables.pop();
            if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') {
                concurrent = observables.pop();
            }
        } else if (typeof last === 'number') {
            concurrent = observables.pop();
        }
        if (scheduler === null && observables.length === 1 && observables[0] instanceof Observable_1.Observable) {
            return observables[0];
        }
        return mergeAll_1.mergeAll(concurrent)(new ArrayObservable_1.ArrayObservable(observables, scheduler));
    }
    exports.merge = merge;
    
});
System.registerDynamic('rxjs/operator/merge.js', ['rxjs/operators/merge.js', 'rxjs/observable/merge.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var merge_1 = $__require('rxjs/operators/merge.js');
    var merge_2 = $__require('rxjs/observable/merge.js');
    exports.mergeStatic = merge_2.merge;
    /* tslint:enable:max-line-length */
    /**
     * Creates an output Observable which concurrently emits all values from every
     * given input Observable.
     *
     * <span class="informal">Flattens multiple Observables together by blending
     * their values into one Observable.</span>
     *
     * <img src="./img/merge.png" width="100%">
     *
     * `merge` subscribes to each given input Observable (either the source or an
     * Observable given as argument), and simply forwards (without doing any
     * transformation) all the values from all the input Observables to the output
     * Observable. The output Observable only completes once all input Observables
     * have completed. Any error delivered by an input Observable will be immediately
     * emitted on the output Observable.
     *
     * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * var timer = Rx.Observable.interval(1000);
     * var clicksOrTimer = clicks.merge(timer);
     * clicksOrTimer.subscribe(x => console.log(x));
     *
     * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
     * var timer1 = Rx.Observable.interval(1000).take(10);
     * var timer2 = Rx.Observable.interval(2000).take(6);
     * var timer3 = Rx.Observable.interval(500).take(10);
     * var concurrent = 2; // the argument
     * var merged = timer1.merge(timer2, timer3, concurrent);
     * merged.subscribe(x => console.log(x));
     *
     * @see {@link mergeAll}
     * @see {@link mergeMap}
     * @see {@link mergeMapTo}
     * @see {@link mergeScan}
     *
     * @param {ObservableInput} other An input Observable to merge with the source
     * Observable. More than one input Observables may be given as argument.
     * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
     * Observables being subscribed to concurrently.
     * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
     * concurrency of input Observables.
     * @return {Observable} An Observable that emits items that are the result of
     * every input Observable.
     * @method merge
     * @owner Observable
     */
    function merge() {
        var observables = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            observables[_i - 0] = arguments[_i];
        }
        return merge_1.merge.apply(void 0, observables)(this);
    }
    exports.merge = merge;
    
});
System.registerDynamic('rxjs/add/operator/merge.js', ['rxjs/Observable.js', 'rxjs/operator/merge.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var merge_1 = $__require('rxjs/operator/merge.js');
  Observable_1.Observable.prototype.merge = merge_1.merge;
  
});
System.registerDynamic("rxjs/util/isArrayLike.js", [], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  exports.isArrayLike = function (x) {
    return x && typeof x.length === 'number';
  };
  
});
System.registerDynamic('rxjs/util/isPromise.js', [], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    function isPromise(value) {
        return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
    }
    exports.isPromise = isPromise;
    
});
System.registerDynamic('rxjs/observable/IteratorObservable.js', ['rxjs/util/root.js', 'rxjs/Observable.js', 'rxjs/symbol/iterator.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var root_1 = $__require('rxjs/util/root.js');
    var Observable_1 = $__require('rxjs/Observable.js');
    var iterator_1 = $__require('rxjs/symbol/iterator.js');
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @extends {Ignored}
     * @hide true
     */
    var IteratorObservable = function (_super) {
        __extends(IteratorObservable, _super);
        function IteratorObservable(iterator, scheduler) {
            _super.call(this);
            this.scheduler = scheduler;
            if (iterator == null) {
                throw new Error('iterator cannot be null.');
            }
            this.iterator = getIterator(iterator);
        }
        IteratorObservable.create = function (iterator, scheduler) {
            return new IteratorObservable(iterator, scheduler);
        };
        IteratorObservable.dispatch = function (state) {
            var index = state.index,
                hasError = state.hasError,
                iterator = state.iterator,
                subscriber = state.subscriber;
            if (hasError) {
                subscriber.error(state.error);
                return;
            }
            var result = iterator.next();
            if (result.done) {
                subscriber.complete();
                return;
            }
            subscriber.next(result.value);
            state.index = index + 1;
            if (subscriber.closed) {
                if (typeof iterator.return === 'function') {
                    iterator.return();
                }
                return;
            }
            this.schedule(state);
        };
        /** @deprecated internal use only */IteratorObservable.prototype._subscribe = function (subscriber) {
            var index = 0;
            var _a = this,
                iterator = _a.iterator,
                scheduler = _a.scheduler;
            if (scheduler) {
                return scheduler.schedule(IteratorObservable.dispatch, 0, {
                    index: index, iterator: iterator, subscriber: subscriber
                });
            } else {
                do {
                    var result = iterator.next();
                    if (result.done) {
                        subscriber.complete();
                        break;
                    } else {
                        subscriber.next(result.value);
                    }
                    if (subscriber.closed) {
                        if (typeof iterator.return === 'function') {
                            iterator.return();
                        }
                        break;
                    }
                } while (true);
            }
        };
        return IteratorObservable;
    }(Observable_1.Observable);
    exports.IteratorObservable = IteratorObservable;
    var StringIterator = function () {
        function StringIterator(str, idx, len) {
            if (idx === void 0) {
                idx = 0;
            }
            if (len === void 0) {
                len = str.length;
            }
            this.str = str;
            this.idx = idx;
            this.len = len;
        }
        StringIterator.prototype[iterator_1.iterator] = function () {
            return this;
        };
        StringIterator.prototype.next = function () {
            return this.idx < this.len ? {
                done: false,
                value: this.str.charAt(this.idx++)
            } : {
                done: true,
                value: undefined
            };
        };
        return StringIterator;
    }();
    var ArrayIterator = function () {
        function ArrayIterator(arr, idx, len) {
            if (idx === void 0) {
                idx = 0;
            }
            if (len === void 0) {
                len = toLength(arr);
            }
            this.arr = arr;
            this.idx = idx;
            this.len = len;
        }
        ArrayIterator.prototype[iterator_1.iterator] = function () {
            return this;
        };
        ArrayIterator.prototype.next = function () {
            return this.idx < this.len ? {
                done: false,
                value: this.arr[this.idx++]
            } : {
                done: true,
                value: undefined
            };
        };
        return ArrayIterator;
    }();
    function getIterator(obj) {
        var i = obj[iterator_1.iterator];
        if (!i && typeof obj === 'string') {
            return new StringIterator(obj);
        }
        if (!i && obj.length !== undefined) {
            return new ArrayIterator(obj);
        }
        if (!i) {
            throw new TypeError('object is not iterable');
        }
        return obj[iterator_1.iterator]();
    }
    var maxSafeInteger = Math.pow(2, 53) - 1;
    function toLength(o) {
        var len = +o.length;
        if (isNaN(len)) {
            return 0;
        }
        if (len === 0 || !numberIsFinite(len)) {
            return len;
        }
        len = sign(len) * Math.floor(Math.abs(len));
        if (len <= 0) {
            return 0;
        }
        if (len > maxSafeInteger) {
            return maxSafeInteger;
        }
        return len;
    }
    function numberIsFinite(value) {
        return typeof value === 'number' && root_1.root.isFinite(value);
    }
    function sign(value) {
        var valueAsNumber = +value;
        if (valueAsNumber === 0) {
            return valueAsNumber;
        }
        if (isNaN(valueAsNumber)) {
            return valueAsNumber;
        }
        return valueAsNumber < 0 ? -1 : 1;
    }
    
});
System.registerDynamic("rxjs/util/isScheduler.js", [], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    function isScheduler(value) {
        return value && typeof value.schedule === 'function';
    }
    exports.isScheduler = isScheduler;
    
});
System.registerDynamic('rxjs/observable/ArrayObservable.js', ['rxjs/Observable.js', 'rxjs/observable/ScalarObservable.js', 'rxjs/observable/EmptyObservable.js', 'rxjs/util/isScheduler.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Observable_1 = $__require('rxjs/Observable.js');
    var ScalarObservable_1 = $__require('rxjs/observable/ScalarObservable.js');
    var EmptyObservable_1 = $__require('rxjs/observable/EmptyObservable.js');
    var isScheduler_1 = $__require('rxjs/util/isScheduler.js');
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @extends {Ignored}
     * @hide true
     */
    var ArrayObservable = function (_super) {
        __extends(ArrayObservable, _super);
        function ArrayObservable(array, scheduler) {
            _super.call(this);
            this.array = array;
            this.scheduler = scheduler;
            if (!scheduler && array.length === 1) {
                this._isScalar = true;
                this.value = array[0];
            }
        }
        ArrayObservable.create = function (array, scheduler) {
            return new ArrayObservable(array, scheduler);
        };
        /**
         * Creates an Observable that emits some values you specify as arguments,
         * immediately one after the other, and then emits a complete notification.
         *
         * <span class="informal">Emits the arguments you provide, then completes.
         * </span>
         *
         * <img src="./img/of.png" width="100%">
         *
         * This static operator is useful for creating a simple Observable that only
         * emits the arguments given, and the complete notification thereafter. It can
         * be used for composing with other Observables, such as with {@link concat}.
         * By default, it uses a `null` IScheduler, which means the `next`
         * notifications are sent synchronously, although with a different IScheduler
         * it is possible to determine when those notifications will be delivered.
         *
         * @example <caption>Emit 10, 20, 30, then 'a', 'b', 'c', then start ticking every second.</caption>
         * var numbers = Rx.Observable.of(10, 20, 30);
         * var letters = Rx.Observable.of('a', 'b', 'c');
         * var interval = Rx.Observable.interval(1000);
         * var result = numbers.concat(letters).concat(interval);
         * result.subscribe(x => console.log(x));
         *
         * @see {@link create}
         * @see {@link empty}
         * @see {@link never}
         * @see {@link throw}
         *
         * @param {...T} values Arguments that represent `next` values to be emitted.
         * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
         * the emissions of the `next` notifications.
         * @return {Observable<T>} An Observable that emits each given input value.
         * @static true
         * @name of
         * @owner Observable
         */
        ArrayObservable.of = function () {
            var array = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                array[_i - 0] = arguments[_i];
            }
            var scheduler = array[array.length - 1];
            if (isScheduler_1.isScheduler(scheduler)) {
                array.pop();
            } else {
                scheduler = null;
            }
            var len = array.length;
            if (len > 1) {
                return new ArrayObservable(array, scheduler);
            } else if (len === 1) {
                return new ScalarObservable_1.ScalarObservable(array[0], scheduler);
            } else {
                return new EmptyObservable_1.EmptyObservable(scheduler);
            }
        };
        ArrayObservable.dispatch = function (state) {
            var array = state.array,
                index = state.index,
                count = state.count,
                subscriber = state.subscriber;
            if (index >= count) {
                subscriber.complete();
                return;
            }
            subscriber.next(array[index]);
            if (subscriber.closed) {
                return;
            }
            state.index = index + 1;
            this.schedule(state);
        };
        /** @deprecated internal use only */ArrayObservable.prototype._subscribe = function (subscriber) {
            var index = 0;
            var array = this.array;
            var count = array.length;
            var scheduler = this.scheduler;
            if (scheduler) {
                return scheduler.schedule(ArrayObservable.dispatch, 0, {
                    array: array, index: index, count: count, subscriber: subscriber
                });
            } else {
                for (var i = 0; i < count && !subscriber.closed; i++) {
                    subscriber.next(array[i]);
                }
                subscriber.complete();
            }
        };
        return ArrayObservable;
    }(Observable_1.Observable);
    exports.ArrayObservable = ArrayObservable;
    
});
System.registerDynamic("rxjs/observable/ScalarObservable.js", ["rxjs/Observable.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Observable_1 = $__require("rxjs/Observable.js");
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @extends {Ignored}
     * @hide true
     */
    var ScalarObservable = function (_super) {
        __extends(ScalarObservable, _super);
        function ScalarObservable(value, scheduler) {
            _super.call(this);
            this.value = value;
            this.scheduler = scheduler;
            this._isScalar = true;
            if (scheduler) {
                this._isScalar = false;
            }
        }
        ScalarObservable.create = function (value, scheduler) {
            return new ScalarObservable(value, scheduler);
        };
        ScalarObservable.dispatch = function (state) {
            var done = state.done,
                value = state.value,
                subscriber = state.subscriber;
            if (done) {
                subscriber.complete();
                return;
            }
            subscriber.next(value);
            if (subscriber.closed) {
                return;
            }
            state.done = true;
            this.schedule(state);
        };
        /** @deprecated internal use only */ScalarObservable.prototype._subscribe = function (subscriber) {
            var value = this.value;
            var scheduler = this.scheduler;
            if (scheduler) {
                return scheduler.schedule(ScalarObservable.dispatch, 0, {
                    done: false, value: value, subscriber: subscriber
                });
            } else {
                subscriber.next(value);
                if (!subscriber.closed) {
                    subscriber.complete();
                }
            }
        };
        return ScalarObservable;
    }(Observable_1.Observable);
    exports.ScalarObservable = ScalarObservable;
    
});
System.registerDynamic("rxjs/observable/EmptyObservable.js", ["rxjs/Observable.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Observable_1 = $__require("rxjs/Observable.js");
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @extends {Ignored}
     * @hide true
     */
    var EmptyObservable = function (_super) {
        __extends(EmptyObservable, _super);
        function EmptyObservable(scheduler) {
            _super.call(this);
            this.scheduler = scheduler;
        }
        /**
         * Creates an Observable that emits no items to the Observer and immediately
         * emits a complete notification.
         *
         * <span class="informal">Just emits 'complete', and nothing else.
         * </span>
         *
         * <img src="./img/empty.png" width="100%">
         *
         * This static operator is useful for creating a simple Observable that only
         * emits the complete notification. It can be used for composing with other
         * Observables, such as in a {@link mergeMap}.
         *
         * @example <caption>Emit the number 7, then complete.</caption>
         * var result = Rx.Observable.empty().startWith(7);
         * result.subscribe(x => console.log(x));
         *
         * @example <caption>Map and flatten only odd numbers to the sequence 'a', 'b', 'c'</caption>
         * var interval = Rx.Observable.interval(1000);
         * var result = interval.mergeMap(x =>
         *   x % 2 === 1 ? Rx.Observable.of('a', 'b', 'c') : Rx.Observable.empty()
         * );
         * result.subscribe(x => console.log(x));
         *
         * // Results in the following to the console:
         * // x is equal to the count on the interval eg(0,1,2,3,...)
         * // x will occur every 1000ms
         * // if x % 2 is equal to 1 print abc
         * // if x % 2 is not equal to 1 nothing will be output
         *
         * @see {@link create}
         * @see {@link never}
         * @see {@link of}
         * @see {@link throw}
         *
         * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
         * the emission of the complete notification.
         * @return {Observable} An "empty" Observable: emits only the complete
         * notification.
         * @static true
         * @name empty
         * @owner Observable
         */
        EmptyObservable.create = function (scheduler) {
            return new EmptyObservable(scheduler);
        };
        EmptyObservable.dispatch = function (arg) {
            var subscriber = arg.subscriber;
            subscriber.complete();
        };
        /** @deprecated internal use only */EmptyObservable.prototype._subscribe = function (subscriber) {
            var scheduler = this.scheduler;
            if (scheduler) {
                return scheduler.schedule(EmptyObservable.dispatch, 0, { subscriber: subscriber });
            } else {
                subscriber.complete();
            }
        };
        return EmptyObservable;
    }(Observable_1.Observable);
    exports.EmptyObservable = EmptyObservable;
    
});
System.registerDynamic('rxjs/observable/ArrayLikeObservable.js', ['rxjs/Observable.js', 'rxjs/observable/ScalarObservable.js', 'rxjs/observable/EmptyObservable.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Observable_1 = $__require('rxjs/Observable.js');
    var ScalarObservable_1 = $__require('rxjs/observable/ScalarObservable.js');
    var EmptyObservable_1 = $__require('rxjs/observable/EmptyObservable.js');
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @extends {Ignored}
     * @hide true
     */
    var ArrayLikeObservable = function (_super) {
        __extends(ArrayLikeObservable, _super);
        function ArrayLikeObservable(arrayLike, scheduler) {
            _super.call(this);
            this.arrayLike = arrayLike;
            this.scheduler = scheduler;
            if (!scheduler && arrayLike.length === 1) {
                this._isScalar = true;
                this.value = arrayLike[0];
            }
        }
        ArrayLikeObservable.create = function (arrayLike, scheduler) {
            var length = arrayLike.length;
            if (length === 0) {
                return new EmptyObservable_1.EmptyObservable();
            } else if (length === 1) {
                return new ScalarObservable_1.ScalarObservable(arrayLike[0], scheduler);
            } else {
                return new ArrayLikeObservable(arrayLike, scheduler);
            }
        };
        ArrayLikeObservable.dispatch = function (state) {
            var arrayLike = state.arrayLike,
                index = state.index,
                length = state.length,
                subscriber = state.subscriber;
            if (subscriber.closed) {
                return;
            }
            if (index >= length) {
                subscriber.complete();
                return;
            }
            subscriber.next(arrayLike[index]);
            state.index = index + 1;
            this.schedule(state);
        };
        /** @deprecated internal use only */ArrayLikeObservable.prototype._subscribe = function (subscriber) {
            var index = 0;
            var _a = this,
                arrayLike = _a.arrayLike,
                scheduler = _a.scheduler;
            var length = arrayLike.length;
            if (scheduler) {
                return scheduler.schedule(ArrayLikeObservable.dispatch, 0, {
                    arrayLike: arrayLike, index: index, length: length, subscriber: subscriber
                });
            } else {
                for (var i = 0; i < length && !subscriber.closed; i++) {
                    subscriber.next(arrayLike[i]);
                }
                subscriber.complete();
            }
        };
        return ArrayLikeObservable;
    }(Observable_1.Observable);
    exports.ArrayLikeObservable = ArrayLikeObservable;
    
});
System.registerDynamic('rxjs/symbol/iterator.js', ['rxjs/util/root.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var root_1 = $__require('rxjs/util/root.js');
    function symbolIteratorPonyfill(root) {
        var Symbol = root.Symbol;
        if (typeof Symbol === 'function') {
            if (!Symbol.iterator) {
                Symbol.iterator = Symbol('iterator polyfill');
            }
            return Symbol.iterator;
        } else {
            // [for Mozilla Gecko 27-35:](https://mzl.la/2ewE1zC)
            var Set_1 = root.Set;
            if (Set_1 && typeof new Set_1()['@@iterator'] === 'function') {
                return '@@iterator';
            }
            var Map_1 = root.Map;
            // required for compatability with es6-shim
            if (Map_1) {
                var keys = Object.getOwnPropertyNames(Map_1.prototype);
                for (var i = 0; i < keys.length; ++i) {
                    var key = keys[i];
                    // according to spec, Map.prototype[@@iterator] and Map.orototype.entries must be equal.
                    if (key !== 'entries' && key !== 'size' && Map_1.prototype[key] === Map_1.prototype['entries']) {
                        return key;
                    }
                }
            }
            return '@@iterator';
        }
    }
    exports.symbolIteratorPonyfill = symbolIteratorPonyfill;
    exports.iterator = symbolIteratorPonyfill(root_1.root);
    /**
     * @deprecated use iterator instead
     */
    exports.$$iterator = exports.iterator;
    
});
System.registerDynamic('rxjs/Notification.js', ['rxjs/Observable.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var Observable_1 = $__require('rxjs/Observable.js');
    /**
     * Represents a push-based event or value that an {@link Observable} can emit.
     * This class is particularly useful for operators that manage notifications,
     * like {@link materialize}, {@link dematerialize}, {@link observeOn}, and
     * others. Besides wrapping the actual delivered value, it also annotates it
     * with metadata of, for instance, what type of push message it is (`next`,
     * `error`, or `complete`).
     *
     * @see {@link materialize}
     * @see {@link dematerialize}
     * @see {@link observeOn}
     *
     * @class Notification<T>
     */
    var Notification = function () {
        function Notification(kind, value, error) {
            this.kind = kind;
            this.value = value;
            this.error = error;
            this.hasValue = kind === 'N';
        }
        /**
         * Delivers to the given `observer` the value wrapped by this Notification.
         * @param {Observer} observer
         * @return
         */
        Notification.prototype.observe = function (observer) {
            switch (this.kind) {
                case 'N':
                    return observer.next && observer.next(this.value);
                case 'E':
                    return observer.error && observer.error(this.error);
                case 'C':
                    return observer.complete && observer.complete();
            }
        };
        /**
         * Given some {@link Observer} callbacks, deliver the value represented by the
         * current Notification to the correctly corresponding callback.
         * @param {function(value: T): void} next An Observer `next` callback.
         * @param {function(err: any): void} [error] An Observer `error` callback.
         * @param {function(): void} [complete] An Observer `complete` callback.
         * @return {any}
         */
        Notification.prototype.do = function (next, error, complete) {
            var kind = this.kind;
            switch (kind) {
                case 'N':
                    return next && next(this.value);
                case 'E':
                    return error && error(this.error);
                case 'C':
                    return complete && complete();
            }
        };
        /**
         * Takes an Observer or its individual callback functions, and calls `observe`
         * or `do` methods accordingly.
         * @param {Observer|function(value: T): void} nextOrObserver An Observer or
         * the `next` callback.
         * @param {function(err: any): void} [error] An Observer `error` callback.
         * @param {function(): void} [complete] An Observer `complete` callback.
         * @return {any}
         */
        Notification.prototype.accept = function (nextOrObserver, error, complete) {
            if (nextOrObserver && typeof nextOrObserver.next === 'function') {
                return this.observe(nextOrObserver);
            } else {
                return this.do(nextOrObserver, error, complete);
            }
        };
        /**
         * Returns a simple Observable that just delivers the notification represented
         * by this Notification instance.
         * @return {any}
         */
        Notification.prototype.toObservable = function () {
            var kind = this.kind;
            switch (kind) {
                case 'N':
                    return Observable_1.Observable.of(this.value);
                case 'E':
                    return Observable_1.Observable.throw(this.error);
                case 'C':
                    return Observable_1.Observable.empty();
            }
            throw new Error('unexpected notification kind value');
        };
        /**
         * A shortcut to create a Notification instance of the type `next` from a
         * given value.
         * @param {T} value The `next` value.
         * @return {Notification<T>} The "next" Notification representing the
         * argument.
         */
        Notification.createNext = function (value) {
            if (typeof value !== 'undefined') {
                return new Notification('N', value);
            }
            return Notification.undefinedValueNotification;
        };
        /**
         * A shortcut to create a Notification instance of the type `error` from a
         * given error.
         * @param {any} [err] The `error` error.
         * @return {Notification<T>} The "error" Notification representing the
         * argument.
         */
        Notification.createError = function (err) {
            return new Notification('E', undefined, err);
        };
        /**
         * A shortcut to create a Notification instance of the type `complete`.
         * @return {Notification<any>} The valueless "complete" Notification.
         */
        Notification.createComplete = function () {
            return Notification.completeNotification;
        };
        Notification.completeNotification = new Notification('C');
        Notification.undefinedValueNotification = new Notification('N', undefined);
        return Notification;
    }();
    exports.Notification = Notification;
    
});
System.registerDynamic('rxjs/operators/observeOn.js', ['rxjs/Subscriber.js', 'rxjs/Notification.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscriber_1 = $__require('rxjs/Subscriber.js');
    var Notification_1 = $__require('rxjs/Notification.js');
    /**
     *
     * Re-emits all notifications from source Observable with specified scheduler.
     *
     * <span class="informal">Ensure a specific scheduler is used, from outside of an Observable.</span>
     *
     * `observeOn` is an operator that accepts a scheduler as a first parameter, which will be used to reschedule
     * notifications emitted by the source Observable. It might be useful, if you do not have control over
     * internal scheduler of a given Observable, but want to control when its values are emitted nevertheless.
     *
     * Returned Observable emits the same notifications (nexted values, complete and error events) as the source Observable,
     * but rescheduled with provided scheduler. Note that this doesn't mean that source Observables internal
     * scheduler will be replaced in any way. Original scheduler still will be used, but when the source Observable emits
     * notification, it will be immediately scheduled again - this time with scheduler passed to `observeOn`.
     * An anti-pattern would be calling `observeOn` on Observable that emits lots of values synchronously, to split
     * that emissions into asynchronous chunks. For this to happen, scheduler would have to be passed into the source
     * Observable directly (usually into the operator that creates it). `observeOn` simply delays notifications a
     * little bit more, to ensure that they are emitted at expected moments.
     *
     * As a matter of fact, `observeOn` accepts second parameter, which specifies in milliseconds with what delay notifications
     * will be emitted. The main difference between {@link delay} operator and `observeOn` is that `observeOn`
     * will delay all notifications - including error notifications - while `delay` will pass through error
     * from source Observable immediately when it is emitted. In general it is highly recommended to use `delay` operator
     * for any kind of delaying of values in the stream, while using `observeOn` to specify which scheduler should be used
     * for notification emissions in general.
     *
     * @example <caption>Ensure values in subscribe are called just before browser repaint.</caption>
     * const intervals = Rx.Observable.interval(10); // Intervals are scheduled
     *                                               // with async scheduler by default...
     *
     * intervals
     * .observeOn(Rx.Scheduler.animationFrame)       // ...but we will observe on animationFrame
     * .subscribe(val => {                           // scheduler to ensure smooth animation.
     *   someDiv.style.height = val + 'px';
     * });
     *
     * @see {@link delay}
     *
     * @param {IScheduler} scheduler Scheduler that will be used to reschedule notifications from source Observable.
     * @param {number} [delay] Number of milliseconds that states with what delay every notification should be rescheduled.
     * @return {Observable<T>} Observable that emits the same notifications as the source Observable,
     * but with provided scheduler.
     *
     * @method observeOn
     * @owner Observable
     */
    function observeOn(scheduler, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        return function observeOnOperatorFunction(source) {
            return source.lift(new ObserveOnOperator(scheduler, delay));
        };
    }
    exports.observeOn = observeOn;
    var ObserveOnOperator = function () {
        function ObserveOnOperator(scheduler, delay) {
            if (delay === void 0) {
                delay = 0;
            }
            this.scheduler = scheduler;
            this.delay = delay;
        }
        ObserveOnOperator.prototype.call = function (subscriber, source) {
            return source.subscribe(new ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
        };
        return ObserveOnOperator;
    }();
    exports.ObserveOnOperator = ObserveOnOperator;
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var ObserveOnSubscriber = function (_super) {
        __extends(ObserveOnSubscriber, _super);
        function ObserveOnSubscriber(destination, scheduler, delay) {
            if (delay === void 0) {
                delay = 0;
            }
            _super.call(this, destination);
            this.scheduler = scheduler;
            this.delay = delay;
        }
        ObserveOnSubscriber.dispatch = function (arg) {
            var notification = arg.notification,
                destination = arg.destination;
            notification.observe(destination);
            this.unsubscribe();
        };
        ObserveOnSubscriber.prototype.scheduleMessage = function (notification) {
            this.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
        };
        ObserveOnSubscriber.prototype._next = function (value) {
            this.scheduleMessage(Notification_1.Notification.createNext(value));
        };
        ObserveOnSubscriber.prototype._error = function (err) {
            this.scheduleMessage(Notification_1.Notification.createError(err));
        };
        ObserveOnSubscriber.prototype._complete = function () {
            this.scheduleMessage(Notification_1.Notification.createComplete());
        };
        return ObserveOnSubscriber;
    }(Subscriber_1.Subscriber);
    exports.ObserveOnSubscriber = ObserveOnSubscriber;
    var ObserveOnMessage = function () {
        function ObserveOnMessage(notification, destination) {
            this.notification = notification;
            this.destination = destination;
        }
        return ObserveOnMessage;
    }();
    exports.ObserveOnMessage = ObserveOnMessage;
    
});
System.registerDynamic('rxjs/observable/FromObservable.js', ['rxjs/util/isArray.js', 'rxjs/util/isArrayLike.js', 'rxjs/util/isPromise.js', 'rxjs/observable/PromiseObservable.js', 'rxjs/observable/IteratorObservable.js', 'rxjs/observable/ArrayObservable.js', 'rxjs/observable/ArrayLikeObservable.js', 'rxjs/symbol/iterator.js', 'rxjs/Observable.js', 'rxjs/operators/observeOn.js', 'rxjs/symbol/observable.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var isArray_1 = $__require('rxjs/util/isArray.js');
    var isArrayLike_1 = $__require('rxjs/util/isArrayLike.js');
    var isPromise_1 = $__require('rxjs/util/isPromise.js');
    var PromiseObservable_1 = $__require('rxjs/observable/PromiseObservable.js');
    var IteratorObservable_1 = $__require('rxjs/observable/IteratorObservable.js');
    var ArrayObservable_1 = $__require('rxjs/observable/ArrayObservable.js');
    var ArrayLikeObservable_1 = $__require('rxjs/observable/ArrayLikeObservable.js');
    var iterator_1 = $__require('rxjs/symbol/iterator.js');
    var Observable_1 = $__require('rxjs/Observable.js');
    var observeOn_1 = $__require('rxjs/operators/observeOn.js');
    var observable_1 = $__require('rxjs/symbol/observable.js');
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @extends {Ignored}
     * @hide true
     */
    var FromObservable = function (_super) {
        __extends(FromObservable, _super);
        function FromObservable(ish, scheduler) {
            _super.call(this, null);
            this.ish = ish;
            this.scheduler = scheduler;
        }
        /**
         * Creates an Observable from an Array, an array-like object, a Promise, an
         * iterable object, or an Observable-like object.
         *
         * <span class="informal">Converts almost anything to an Observable.</span>
         *
         * <img src="./img/from.png" width="100%">
         *
         * Convert various other objects and data types into Observables. `from`
         * converts a Promise or an array-like or an
         * [iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
         * object into an Observable that emits the items in that promise or array or
         * iterable. A String, in this context, is treated as an array of characters.
         * Observable-like objects (contains a function named with the ES2015 Symbol
         * for Observable) can also be converted through this operator.
         *
         * @example <caption>Converts an array to an Observable</caption>
         * var array = [10, 20, 30];
         * var result = Rx.Observable.from(array);
         * result.subscribe(x => console.log(x));
         *
         * // Results in the following:
         * // 10 20 30
         *
         * @example <caption>Convert an infinite iterable (from a generator) to an Observable</caption>
         * function* generateDoubles(seed) {
         *   var i = seed;
         *   while (true) {
         *     yield i;
         *     i = 2 * i; // double it
         *   }
         * }
         *
         * var iterator = generateDoubles(3);
         * var result = Rx.Observable.from(iterator).take(10);
         * result.subscribe(x => console.log(x));
         *
         * // Results in the following:
         * // 3 6 12 24 48 96 192 384 768 1536
         *
         * @see {@link create}
         * @see {@link fromEvent}
         * @see {@link fromEventPattern}
         * @see {@link fromPromise}
         *
         * @param {ObservableInput<T>} ish A subscribable object, a Promise, an
         * Observable-like, an Array, an iterable or an array-like object to be
         * converted.
         * @param {Scheduler} [scheduler] The scheduler on which to schedule the
         * emissions of values.
         * @return {Observable<T>} The Observable whose values are originally from the
         * input object that was converted.
         * @static true
         * @name from
         * @owner Observable
         */
        FromObservable.create = function (ish, scheduler) {
            if (ish != null) {
                if (typeof ish[observable_1.observable] === 'function') {
                    if (ish instanceof Observable_1.Observable && !scheduler) {
                        return ish;
                    }
                    return new FromObservable(ish, scheduler);
                } else if (isArray_1.isArray(ish)) {
                    return new ArrayObservable_1.ArrayObservable(ish, scheduler);
                } else if (isPromise_1.isPromise(ish)) {
                    return new PromiseObservable_1.PromiseObservable(ish, scheduler);
                } else if (typeof ish[iterator_1.iterator] === 'function' || typeof ish === 'string') {
                    return new IteratorObservable_1.IteratorObservable(ish, scheduler);
                } else if (isArrayLike_1.isArrayLike(ish)) {
                    return new ArrayLikeObservable_1.ArrayLikeObservable(ish, scheduler);
                }
            }
            throw new TypeError((ish !== null && typeof ish || ish) + ' is not observable');
        };
        /** @deprecated internal use only */FromObservable.prototype._subscribe = function (subscriber) {
            var ish = this.ish;
            var scheduler = this.scheduler;
            if (scheduler == null) {
                return ish[observable_1.observable]().subscribe(subscriber);
            } else {
                return ish[observable_1.observable]().subscribe(new observeOn_1.ObserveOnSubscriber(subscriber, scheduler, 0));
            }
        };
        return FromObservable;
    }(Observable_1.Observable);
    exports.FromObservable = FromObservable;
    
});
System.registerDynamic("rxjs/observable/from.js", ["rxjs/observable/FromObservable.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var FromObservable_1 = $__require("rxjs/observable/FromObservable.js");
  exports.from = FromObservable_1.FromObservable.create;
  
});
System.registerDynamic('rxjs/add/observable/from.js', ['rxjs/Observable.js', 'rxjs/observable/from.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require('rxjs/Observable.js');
  var from_1 = $__require('rxjs/observable/from.js');
  Observable_1.Observable.from = from_1.from;
  
});
System.register("ags-client/gen/viewmodels/remote_translation_request_view_model.js", ["ags-client/app/commons/lang.js"], function (exports_1, context_1) {
    "use strict";

    var lang_1, RemoteTranslationRequestViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (lang_1_1) {
            lang_1 = lang_1_1;
        }],
        execute: function () {
            RemoteTranslationRequestViewModel = /** @class */function () {
                function RemoteTranslationRequestViewModel() {}
                RemoteTranslationRequestViewModel.deserialize = function (object) {
                    var _result = new RemoteTranslationRequestViewModel();
                    return _result._deserialize(object);
                };
                RemoteTranslationRequestViewModel.prototype._deserialize = function (object) {
                    var _this = this;
                    if (object) {
                        if (lang_1.isPresent(object['categories'])) {
                            this.categories = [];
                            object['categories'].forEach(function (item) {
                                _this.categories.push(item);
                            });
                        }
                        if (lang_1.isPresent(object['language'])) {
                            this.language = object['language'];
                        }
                    }
                    return this;
                };
                RemoteTranslationRequestViewModel.prototype.serialize = function () {
                    var object = {};
                    if (lang_1.isPresent(this.categories)) {
                        object['categories'] = [];
                        this.categories.forEach(function (item) {
                            object['categories'].push(item);
                        });
                    }
                    if (lang_1.isPresent(this.language)) {
                        object['language'] = this.language;
                    }
                    return object;
                };
                RemoteTranslationRequestViewModel.CATEGORIES_VALIDATORS = [];
                RemoteTranslationRequestViewModel.LANGUAGE_VALIDATORS = [];
                return RemoteTranslationRequestViewModel;
            }();
            exports_1("RemoteTranslationRequestViewModel", RemoteTranslationRequestViewModel);
        }
    };
});

System.register("ags-client/app/services/translation_service.js", ["mustache/mustache.js", "angular2/core.js", "angular2/http.js", "ags-client/gen/services/abstract_translation_service.js", "ags-client/app/services/backend_service.js", "ags-client/app/commons.js", "rxjs/Rx.js", "rxjs/add/operator/toPromise.js", "rxjs/add/operator/do.js", "rxjs/add/operator/concatMap.js", "rxjs/add/operator/merge.js", "rxjs/add/observable/from.js", "ags-client/gen/viewmodels/remote_translation_request_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var mustache_1, core_1, http_1, abstract_translation_service_1, backend_service_1, commons_1, commons_2, Rx_1, remote_translation_request_view_model_1, TranslationService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (mustache_1_1) {
            mustache_1 = mustache_1_1;
        }, function (core_1_1) {
            core_1 = core_1_1;
        }, function (http_1_1) {
            http_1 = http_1_1;
        }, function (abstract_translation_service_1_1) {
            abstract_translation_service_1 = abstract_translation_service_1_1;
        }, function (backend_service_1_1) {
            backend_service_1 = backend_service_1_1;
        }, function (commons_1_1) {
            commons_1 = commons_1_1;
            commons_2 = commons_1_1;
        }, function (Rx_1_1) {
            Rx_1 = Rx_1_1;
        }, function (_1) {}, function (_2) {}, function (_3) {}, function (_4) {}, function (_5) {}, function (remote_translation_request_view_model_1_1) {
            remote_translation_request_view_model_1 = remote_translation_request_view_model_1_1;
        }],
        execute: function () {
            TranslationService = /** @class */function (_super) {
                __extends(TranslationService, _super);
                function TranslationService(backendService, http) {
                    var _this = _super.call(this, backendService) || this;
                    _this._translations = {};
                    _this._http = http;
                    _this._promise = new Promise(function (resolve) {
                        _this._promiseResolve = resolve;
                    });
                    return _this;
                }
                TranslationService.prototype.initialize = function (language, bundles) {
                    var _this = this;
                    this._language = language;
                    Rx_1.Observable.merge(this._loadLocalTranslations(bundles), this._loadRemoteTranslations(language)).subscribe(function (value) {
                        return;
                    }, function (error) {
                        console.log(error);
                    }, function () {
                        _this._promiseResolve();
                    });
                    return this._promise;
                };
                TranslationService.prototype._loadLocalTranslations = function (bundles) {
                    var _this = this;
                    return Rx_1.Observable.from(bundles).concatMap(function (bundle) {
                        return _this._http.get(bundle, backend_service_1.BackendService.jsonRequestOptions());
                    }).do(function (response) {
                        var translations = response.json();
                        for (var key in translations) {
                            _this._translations[key] = translations[key];
                        }
                    });
                };
                TranslationService.prototype._loadRemoteTranslations = function (language) {
                    var _this = this;
                    var request = new remote_translation_request_view_model_1.RemoteTranslationRequestViewModel();
                    request.language = language;
                    request.categories = Object.keys(commons_1.EnumRegistry.enums).concat(Object.keys(commons_2.CodeRegistry.codes));
                    return this.translations(request).do(function (response) {
                        response.data.forEach(function (translation) {
                            _this._translations[translation.key] = translation.value;
                        });
                    });
                };
                Object.defineProperty(TranslationService.prototype, "language", {
                    get: function () {
                        return this._language;
                    },
                    enumerable: false,
                    configurable: true
                });
                TranslationService.prototype.translateAsync = function (key, properties) {
                    var _this = this;
                    return new Promise(function (resolve) {
                        if (_this._translations[key]) {
                            resolve(_this.translate(key, properties));
                        } else {
                            _this._promise.then(function () {
                                resolve(_this.translate(key, properties));
                            });
                        }
                    });
                };
                TranslationService.prototype.translate = function (key, properties) {
                    if (this._translations[key]) {
                        var translation = this._translations[key];
                        if (properties) {
                            translation = mustache_1.default.render(translation, properties);
                        }
                        return translation;
                    } else {
                        return '[' + key + ']';
                    }
                };
                TranslationService = __decorate([core_1.Injectable(), core_1.Inject(backend_service_1.BackendService), core_1.Inject(http_1.Http), __metadata("design:paramtypes", [backend_service_1.BackendService, http_1.Http])], TranslationService);
                return TranslationService;
            }(abstract_translation_service_1.AbstractTranslationService);
            exports_1("TranslationService", TranslationService);
        }
    };
});

System.register("ags-client/app/directives/datepicker_directive.js", ["angular2/core.js", "angular2/common.js", "ags-client/app/services/translation_service.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, common_1, translation_service_1, DatepickerDirective;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (common_1_1) {
            common_1 = common_1_1;
        }, function (translation_service_1_1) {
            translation_service_1 = translation_service_1_1;
        }],
        execute: function () {
            DatepickerDirective = /** @class */function () {
                function DatepickerDirective(_inputElement, _control, _translationService) {
                    this._inputElement = _inputElement;
                    this._control = _control;
                    this._translationService = _translationService;
                }
                DatepickerDirective.prototype.ngAfterViewInit = function () {
                    var input = this._inputElement.nativeElement;
                    var div = document.createElement('div');
                    div.setAttribute('class', 'input-group date');
                    input.parentNode.insertBefore(div, input);
                    div.appendChild(input);
                    var self = this;
                    var buttonWrapper = document.createElement('div');
                    buttonWrapper.onclick = function () {
                        self.showDatePicker();
                    };
                    buttonWrapper.setAttribute('class', 'input-group-addon');
                    div.appendChild(buttonWrapper);
                    var button = document.createElement('span');
                    button.setAttribute('class', 'fa fa-calendar');
                    buttonWrapper.appendChild(button);
                };
                DatepickerDirective.prototype.showDatePicker = function () {
                    var _this = this;
                    if (!this._datepicker) {
                        var options = {
                            autoclose: true,
                            format: 'dd.mm.yyyy',
                            showOnFocus: false,
                            language: this._translationService.language
                        };
                        this._datepicker = $(this._inputElement.nativeElement).datepicker(options);
                        this._datepicker.on('hide', function (event) {
                            var evt = document.createEvent('HTMLEvents');
                            evt.initEvent('change', false, true);
                            _this._inputElement.nativeElement.dispatchEvent(evt);
                        });
                    }
                    this._datepicker.datepicker('show');
                };
                DatepickerDirective = __decorate([core_1.Directive({
                    selector: 'input[datepicker]'
                }), __metadata("design:paramtypes", [core_1.ElementRef, common_1.NgControl, translation_service_1.TranslationService])], DatepickerDirective);
                return DatepickerDirective;
            }();
            exports_1("DatepickerDirective", DatepickerDirective);
        }
    };
});

System.register("ags-client/app/directives/clipboard_directive.js", ["angular2/core.js", "ags-client/app/commons/lang.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, lang_1, ClipboardDirective;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }],
        execute: function () {
            ClipboardDirective = /** @class */function () {
                function ClipboardDirective(_element) {
                    this._element = _element;
                }
                ClipboardDirective.prototype.ngAfterViewInit = function () {
                    if (this._element.nativeElement.tagName === 'INPUT') {
                        var input = this._element.nativeElement;
                        var div = document.createElement('div');
                        div.setAttribute('class', 'input-group');
                        input.parentNode.insertBefore(div, input);
                        div.appendChild(input);
                        var buttonWrapper = document.createElement('div');
                        buttonWrapper.setAttribute('class', 'input-group-addon');
                        div.appendChild(buttonWrapper);
                        this._clipboardElement = document.createElement('span');
                        this._clipboardElement.setAttribute('class', 'fa fa-clipboard clipboard');
                        buttonWrapper.appendChild(this._clipboardElement);
                    } else {
                        this._clipboardElement = this._element.nativeElement;
                        this._clipboardElement.setAttribute('class', 'clipboard');
                    }
                    this._clipboardElement.setAttribute('data-clipboard-text', this._clipboardText);
                };
                Object.defineProperty(ClipboardDirective.prototype, "clipboard", {
                    set: function (clipboardText) {
                        if (lang_1.isSomething(clipboardText)) {
                            this._clipboardText = clipboardText;
                        } else {
                            this._clipboardText = '-';
                        }
                        if (this._clipboardElement) {
                            this._clipboardElement.setAttribute('data-clipboard-text', this._clipboardText);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                __decorate([core_1.Input(), __metadata("design:type", String), __metadata("design:paramtypes", [String])], ClipboardDirective.prototype, "clipboard", null);
                ClipboardDirective = __decorate([core_1.Directive({
                    selector: '[clipboard]'
                }), __metadata("design:paramtypes", [core_1.ElementRef])], ClipboardDirective);
                return ClipboardDirective;
            }();
            exports_1("ClipboardDirective", ClipboardDirective);
        }
    };
});

System.register("ags-client/app/constants.js", ["angular2/common.js", "angular2/router.js", "ags-client/app/pipes/translation_pipe.js", "ags-client/app/pipes/code_pipe.js", "ags-client/app/pipes/enum_pipe.js", "ags-client/app/pipes/date_pipe.js", "ags-client/app/pipes/datetime_pipe.js", "ags-client/app/pipes/decimal_pipe.js", "ags-client/app/pipes/percent_pipe.js", "ags-client/app/pipes/filesize_pipe.js", "ags-client/app/pipes/filetype_pipe.js", "ags-client/app/pipes/ls_pipe.js", "ags-client/app/pipes/valor_pipe.js", "ags-client/app/pipes/truncate_pipe.js", "ags-client/app/components/alert_component.js", "ags-client/app/components/button_spinner_component.js", "ags-client/app/components/input_errors_component.js", "ags-client/app/components/pagination_component.js", "ags-client/app/components/table_sort_component.js", "ags-client/app/components/boolean_component.js", "ags-client/app/components/check_component.js", "ags-client/app/components/check_all_component.js", "ags-client/app/components/delete_component.js", "ags-client/app/components/edit_component.js", "ags-client/app/components/refresh_component.js", "ags-client/app/components/back_component.js", "ags-client/app/components/multi_select_component.js", "ags-client/app/components/multi_select_enum_component.js", "ags-client/app/components/multi_select_code_component.js", "ags-client/app/components/form_button_panel_component.js", "ags-client/app/components/file_component.js", "ags-client/app/components/translation_component.js", "ags-client/app/components/print_component.js", "ags-client/app/components/create_component.js", "ags-client/app/components/reset_component.js", "ags-client/app/components/multiselect_dropdown_component.js", "ags-client/app/components/multiselect_dropdown_enum_component.js", "ags-client/app/components/multiselect_dropdown_code_component.js", "ags-client/app/directives/form_id_directive.js", "ags-client/app/directives/form_loading_directive.js", "ags-client/app/directives/input_date_directive.js", "ags-client/app/directives/input_decimal_directive.js", "ags-client/app/directives/input_integer_directive.js", "ags-client/app/directives/input_long_directive.js", "ags-client/app/directives/input_text_directive.js", "ags-client/app/directives/select_code_directive.js", "ags-client/app/directives/select_enum_directive.js", "ags-client/app/directives/select_boolean_directive.js", "ags-client/app/directives/select_directive.js", "ags-client/app/directives/select_category_directive.js", "ags-client/app/directives/select_year_directive.js", "ags-client/app/directives/select_month_directive.js", "ags-client/app/directives/select_day_directive.js", "ags-client/app/directives/table_loading_directive.js", "ags-client/app/directives/datepicker_directive.js", "ags-client/app/directives/clipboard_directive.js"], function (exports_1, context_1) {
    "use strict";

    var common_1, router_1, MAX_UPLOAD_SIZE, translation_pipe_1, code_pipe_1, enum_pipe_1, date_pipe_1, datetime_pipe_1, decimal_pipe_1, percent_pipe_1, filesize_pipe_1, filetype_pipe_1, ls_pipe_1, valor_pipe_1, truncate_pipe_1, AGS_PIPES, alert_component_1, button_spinner_component_1, input_errors_component_1, pagination_component_1, table_sort_component_1, boolean_component_1, check_component_1, check_all_component_1, delete_component_1, edit_component_1, refresh_component_1, back_component_1, multi_select_component_1, multi_select_enum_component_1, multi_select_code_component_1, form_button_panel_component_1, file_component_1, translation_component_1, print_component_1, create_component_1, reset_component_1, multiselect_dropdown_component_1, multiselect_dropdown_enum_component_1, multiselect_dropdown_code_component_1, form_id_directive_1, form_loading_directive_1, input_date_directive_1, input_decimal_directive_1, input_integer_directive_1, input_long_directive_1, input_text_directive_1, select_code_directive_1, select_enum_directive_1, select_boolean_directive_1, select_directive_1, select_category_directive_1, select_year_directive_1, select_month_directive_1, select_day_directive_1, table_loading_directive_1, datepicker_directive_1, clipboard_directive_1, AGS_DIRECTIVES, AGS_FORM_DIRECTIVES, DATE_FORMAT, DATE_REGEX, EMAIL_REGEX, DOMAIN_REGEX, ISIN_REGEX, FILE_EXTENSIONS, MIN_PASSWORD_LEN, Constants;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (common_1_1) {
            common_1 = common_1_1;
        }, function (router_1_1) {
            router_1 = router_1_1;
        }, function (translation_pipe_1_1) {
            translation_pipe_1 = translation_pipe_1_1;
        }, function (code_pipe_1_1) {
            code_pipe_1 = code_pipe_1_1;
        }, function (enum_pipe_1_1) {
            enum_pipe_1 = enum_pipe_1_1;
        }, function (date_pipe_1_1) {
            date_pipe_1 = date_pipe_1_1;
        }, function (datetime_pipe_1_1) {
            datetime_pipe_1 = datetime_pipe_1_1;
        }, function (decimal_pipe_1_1) {
            decimal_pipe_1 = decimal_pipe_1_1;
        }, function (percent_pipe_1_1) {
            percent_pipe_1 = percent_pipe_1_1;
        }, function (filesize_pipe_1_1) {
            filesize_pipe_1 = filesize_pipe_1_1;
        }, function (filetype_pipe_1_1) {
            filetype_pipe_1 = filetype_pipe_1_1;
        }, function (ls_pipe_1_1) {
            ls_pipe_1 = ls_pipe_1_1;
        }, function (valor_pipe_1_1) {
            valor_pipe_1 = valor_pipe_1_1;
        }, function (truncate_pipe_1_1) {
            truncate_pipe_1 = truncate_pipe_1_1;
        }, function (alert_component_1_1) {
            alert_component_1 = alert_component_1_1;
        }, function (button_spinner_component_1_1) {
            button_spinner_component_1 = button_spinner_component_1_1;
        }, function (input_errors_component_1_1) {
            input_errors_component_1 = input_errors_component_1_1;
        }, function (pagination_component_1_1) {
            pagination_component_1 = pagination_component_1_1;
        }, function (table_sort_component_1_1) {
            table_sort_component_1 = table_sort_component_1_1;
        }, function (boolean_component_1_1) {
            boolean_component_1 = boolean_component_1_1;
        }, function (check_component_1_1) {
            check_component_1 = check_component_1_1;
        }, function (check_all_component_1_1) {
            check_all_component_1 = check_all_component_1_1;
        }, function (delete_component_1_1) {
            delete_component_1 = delete_component_1_1;
        }, function (edit_component_1_1) {
            edit_component_1 = edit_component_1_1;
        }, function (refresh_component_1_1) {
            refresh_component_1 = refresh_component_1_1;
        }, function (back_component_1_1) {
            back_component_1 = back_component_1_1;
        }, function (multi_select_component_1_1) {
            multi_select_component_1 = multi_select_component_1_1;
        }, function (multi_select_enum_component_1_1) {
            multi_select_enum_component_1 = multi_select_enum_component_1_1;
        }, function (multi_select_code_component_1_1) {
            multi_select_code_component_1 = multi_select_code_component_1_1;
        }, function (form_button_panel_component_1_1) {
            form_button_panel_component_1 = form_button_panel_component_1_1;
        }, function (file_component_1_1) {
            file_component_1 = file_component_1_1;
        }, function (translation_component_1_1) {
            translation_component_1 = translation_component_1_1;
        }, function (print_component_1_1) {
            print_component_1 = print_component_1_1;
        }, function (create_component_1_1) {
            create_component_1 = create_component_1_1;
        }, function (reset_component_1_1) {
            reset_component_1 = reset_component_1_1;
        }, function (multiselect_dropdown_component_1_1) {
            multiselect_dropdown_component_1 = multiselect_dropdown_component_1_1;
        }, function (multiselect_dropdown_enum_component_1_1) {
            multiselect_dropdown_enum_component_1 = multiselect_dropdown_enum_component_1_1;
        }, function (multiselect_dropdown_code_component_1_1) {
            multiselect_dropdown_code_component_1 = multiselect_dropdown_code_component_1_1;
        }, function (form_id_directive_1_1) {
            form_id_directive_1 = form_id_directive_1_1;
        }, function (form_loading_directive_1_1) {
            form_loading_directive_1 = form_loading_directive_1_1;
        }, function (input_date_directive_1_1) {
            input_date_directive_1 = input_date_directive_1_1;
        }, function (input_decimal_directive_1_1) {
            input_decimal_directive_1 = input_decimal_directive_1_1;
        }, function (input_integer_directive_1_1) {
            input_integer_directive_1 = input_integer_directive_1_1;
        }, function (input_long_directive_1_1) {
            input_long_directive_1 = input_long_directive_1_1;
        }, function (input_text_directive_1_1) {
            input_text_directive_1 = input_text_directive_1_1;
        }, function (select_code_directive_1_1) {
            select_code_directive_1 = select_code_directive_1_1;
        }, function (select_enum_directive_1_1) {
            select_enum_directive_1 = select_enum_directive_1_1;
        }, function (select_boolean_directive_1_1) {
            select_boolean_directive_1 = select_boolean_directive_1_1;
        }, function (select_directive_1_1) {
            select_directive_1 = select_directive_1_1;
        }, function (select_category_directive_1_1) {
            select_category_directive_1 = select_category_directive_1_1;
        }, function (select_year_directive_1_1) {
            select_year_directive_1 = select_year_directive_1_1;
        }, function (select_month_directive_1_1) {
            select_month_directive_1 = select_month_directive_1_1;
        }, function (select_day_directive_1_1) {
            select_day_directive_1 = select_day_directive_1_1;
        }, function (table_loading_directive_1_1) {
            table_loading_directive_1 = table_loading_directive_1_1;
        }, function (datepicker_directive_1_1) {
            datepicker_directive_1 = datepicker_directive_1_1;
        }, function (clipboard_directive_1_1) {
            clipboard_directive_1 = clipboard_directive_1_1;
        }],
        execute: function () {
            exports_1("MAX_UPLOAD_SIZE", MAX_UPLOAD_SIZE = 20971520); // 20MB
            exports_1("AGS_PIPES", AGS_PIPES = [translation_pipe_1.TranslationPipe, code_pipe_1.CodePipe, enum_pipe_1.EnumPipe, date_pipe_1.DatePipe, datetime_pipe_1.DateTimePipe, decimal_pipe_1.DecimalPipe, percent_pipe_1.PercentPipe, filesize_pipe_1.FileSizePipe, filetype_pipe_1.FileTypePipe, ls_pipe_1.LsPipe, valor_pipe_1.ValorPipe, truncate_pipe_1.TruncatePipe]);
            exports_1("AGS_DIRECTIVES", AGS_DIRECTIVES = [common_1.NgClass, common_1.NgFor, common_1.NgIf, common_1.NgStyle, common_1.NgSwitch, common_1.NgSwitchWhen, common_1.NgSwitchDefault, router_1.RouterLink, alert_component_1.AlertComponent, back_component_1.BackComponent, table_loading_directive_1.TableLoadingDirective, file_component_1.FileComponent, translation_component_1.TranslateComponent, print_component_1.PrintComponent, refresh_component_1.RefreshComponent, create_component_1.CreateComponent, reset_component_1.ResetComponent, delete_component_1.DeleteComponent]);
            exports_1("AGS_FORM_DIRECTIVES", AGS_FORM_DIRECTIVES = [common_1.NgControlName, common_1.NgControlGroup, common_1.NgFormControl, common_1.NgModel, common_1.NgFormModel, common_1.NgForm, common_1.NgSelectOption, common_1.DefaultValueAccessor, common_1.CheckboxControlValueAccessor, common_1.SelectControlValueAccessor, common_1.NgControlStatus, common_1.RequiredValidator, router_1.RouterLink, form_id_directive_1.FormIdDirective, form_loading_directive_1.FormLoadingDirective, input_decimal_directive_1.InputDecimalDirective, input_date_directive_1.InputDateDirective, input_integer_directive_1.InputIntegerDirective, input_long_directive_1.InputLongDirective, input_text_directive_1.InputTextDirective, select_directive_1.SelectDirective, select_code_directive_1.SelectCodeDirective, select_enum_directive_1.SelectEnumDirective, select_boolean_directive_1.SelectBooleanDirective, select_year_directive_1.SelectYearDirective, select_month_directive_1.SelectMonthDirective, select_day_directive_1.SelectDayDirective, select_category_directive_1.SelectCategoryDirective, input_errors_component_1.InputErrorsComponent, button_spinner_component_1.ButtonSpinnerComponent, datepicker_directive_1.DatepickerDirective, table_sort_component_1.TableSortComponent, pagination_component_1.PaginationComponent, boolean_component_1.BooleanComponent, check_all_component_1.CheckAllComponent, check_component_1.CheckComponent, delete_component_1.DeleteComponent, edit_component_1.EditComponent, back_component_1.BackComponent, multi_select_component_1.MultiSelectComponent, multi_select_enum_component_1.MultiSelectEnumComponent, multi_select_code_component_1.MultiSelectCodeComponent, form_button_panel_component_1.FormButtonPanelComponent, refresh_component_1.RefreshComponent, create_component_1.CreateComponent, reset_component_1.ResetComponent, table_loading_directive_1.TableLoadingDirective, file_component_1.FileComponent, translation_component_1.TranslateComponent, print_component_1.PrintComponent, clipboard_directive_1.ClipboardDirective, multiselect_dropdown_component_1.MultiselectDropdownComponent, multiselect_dropdown_enum_component_1.MultiselectDropdownEnumComponent, multiselect_dropdown_code_component_1.MultiselectDropdownCodeComponent]);
            exports_1("DATE_FORMAT", DATE_FORMAT = '{dd}.{MM}.{yyyy}');
            exports_1("DATE_REGEX", DATE_REGEX = '^[0-3][0-9]\.[0-1][0-9]\.[1-9][0-9]{3}$');
            exports_1("EMAIL_REGEX", EMAIL_REGEX = '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$');
            exports_1("DOMAIN_REGEX", DOMAIN_REGEX = '^[A-Za-z0-9\.]+\.[A-Za-z]{2,4}$');
            exports_1("ISIN_REGEX", ISIN_REGEX = '^([A-Za-z]{2})([a-zA-Z0-9]{9})([0-9])$');
            exports_1("FILE_EXTENSIONS", FILE_EXTENSIONS = '(csv|doc|docx|pdf|qdf|xsl|xlsx|xsd|xml|zip)');
            exports_1("MIN_PASSWORD_LEN", MIN_PASSWORD_LEN = 18);
            (function (Constants) {
                var Language;
                (function (Language) {
                    Language.de = "de";
                    Language.en = "en";
                    Language.fr = "fr";
                    Language.it = "it";
                    Language.codeLanguages = [Language.de, Language.en, Language.fr, Language.it];
                })(Language = Constants.Language || (Constants.Language = {}));
            })(Constants || exports_1("Constants", Constants = {}));
        }
    };
});

System.register("ags-client/gen/viewmodels/entity_view_model.js", ["ags-client/app/commons/lang.js"], function (exports_1, context_1) {
    "use strict";

    var lang_1, EntityViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (lang_1_1) {
            lang_1 = lang_1_1;
        }],
        execute: function () {
            EntityViewModel = /** @class */function () {
                function EntityViewModel() {}
                EntityViewModel.deserialize = function (object) {
                    var _result = new EntityViewModel();
                    return _result._deserialize(object);
                };
                EntityViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        if (lang_1.isPresent(object['id'])) {
                            this.id = object['id'];
                        }
                        if (lang_1.isPresent(object['deleted'])) {
                            this.deleted = object['deleted'];
                        }
                        if (lang_1.isPresent(object['complete'])) {
                            this.complete = object['complete'];
                        }
                        if (lang_1.isPresent(object['checked'])) {
                            this.checked = object['checked'];
                        }
                    }
                    return this;
                };
                EntityViewModel.prototype.serialize = function () {
                    var object = {};
                    if (lang_1.isPresent(this.id)) {
                        object['id'] = this.id;
                    }
                    if (lang_1.isPresent(this.deleted)) {
                        object['deleted'] = this.deleted;
                    }
                    if (lang_1.isPresent(this.complete)) {
                        object['complete'] = this.complete;
                    }
                    if (lang_1.isPresent(this.checked)) {
                        object['checked'] = this.checked;
                    }
                    return object;
                };
                EntityViewModel.ID_VALIDATORS = [];
                EntityViewModel.DELETED_VALIDATORS = [];
                EntityViewModel.COMPLETE_VALIDATORS = [];
                EntityViewModel.CHECKED_VALIDATORS = [];
                return EntityViewModel;
            }();
            exports_1("EntityViewModel", EntityViewModel);
        }
    };
});

System.register("ags-client/gen/viewmodels/domain_view_model.js", ["ags-client/app/commons/lang.js", "ags-client/gen/viewmodels/entity_view_model.js", "ags-client/app/validators.js", "ags-client/gen/enums.js", "ags-client/app/commons.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var lang_1, entity_view_model_1, Validators, enums_1, commons_1, DomainViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (lang_1_1) {
            lang_1 = lang_1_1;
        }, function (entity_view_model_1_1) {
            entity_view_model_1 = entity_view_model_1_1;
        }, function (Validators_1) {
            Validators = Validators_1;
        }, function (enums_1_1) {
            enums_1 = enums_1_1;
        }, function (commons_1_1) {
            commons_1 = commons_1_1;
        }],
        execute: function () {
            DomainViewModel = /** @class */function (_super) {
                __extends(DomainViewModel, _super);
                function DomainViewModel() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                DomainViewModel.deserialize = function (object) {
                    var _result = new DomainViewModel();
                    return _result._deserialize(object);
                };
                DomainViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        _super.prototype._deserialize.call(this, object);
                        if (lang_1.isPresent(object['institution'])) {
                            this.institution = object['institution'];
                        }
                        if (lang_1.isPresent(object['name'])) {
                            this.name = object['name'];
                        }
                        if (lang_1.isPresent(object['canton'])) {
                            this.canton = commons_1.enumNumberValue(enums_1.Canton, object['canton']);
                        }
                        if (lang_1.isPresent(object['active'])) {
                            this.active = object['active'];
                        }
                        if (lang_1.isPresent(object['blocked'])) {
                            this.blocked = object['blocked'];
                        }
                        if (lang_1.isPresent(object['generalRegistration'])) {
                            this.generalRegistration = object['generalRegistration'];
                        }
                        if (lang_1.isPresent(object['requestAllowed'])) {
                            this.requestAllowed = object['requestAllowed'];
                        }
                    }
                    return this;
                };
                DomainViewModel.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (lang_1.isPresent(this.institution)) {
                        object['institution'] = this.institution;
                    }
                    if (lang_1.isPresent(this.name)) {
                        object['name'] = this.name;
                    }
                    if (lang_1.isPresent(this.canton)) {
                        object['canton'] = enums_1.Canton[this.canton];
                    }
                    if (lang_1.isPresent(this.active)) {
                        object['active'] = this.active;
                    }
                    if (lang_1.isPresent(this.blocked)) {
                        object['blocked'] = this.blocked;
                    }
                    if (lang_1.isPresent(this.generalRegistration)) {
                        object['generalRegistration'] = this.generalRegistration;
                    }
                    if (lang_1.isPresent(this.requestAllowed)) {
                        object['requestAllowed'] = this.requestAllowed;
                    }
                    return object;
                };
                DomainViewModel.INSTITUTION_VALIDATORS = [Validators.max(120)];
                DomainViewModel.NAME_VALIDATORS = [Validators.required(), Validators.max(64)];
                DomainViewModel.CANTON_VALIDATORS = [];
                DomainViewModel.ACTIVE_VALIDATORS = [];
                DomainViewModel.BLOCKED_VALIDATORS = [];
                DomainViewModel.GENERAL_REGISTRATION_VALIDATORS = [];
                DomainViewModel.REQUEST_ALLOWED_VALIDATORS = [];
                return DomainViewModel;
            }(entity_view_model_1.EntityViewModel);
            exports_1("DomainViewModel", DomainViewModel);
        }
    };
});

System.register("ags-client/gen/services/abstract_domain_service.js", ["ags-client/app/models/json_response.js", "ags-client/gen/viewmodels/domain_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var json_response_1, domain_view_model_1, AbstractDomainService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (json_response_1_1) {
            json_response_1 = json_response_1_1;
        }, function (domain_view_model_1_1) {
            domain_view_model_1 = domain_view_model_1_1;
        }],
        execute: function () {
            AbstractDomainService = /** @class */function () {
                function AbstractDomainService(backendService) {
                    this.backendService = backendService;
                }
                AbstractDomainService.prototype.domain = function (request) {
                    return this.backendService.getJson('/domain/domain/' + request + '.json', function (response) {
                        return json_response_1.JsonResponse.deserialize(response, domain_view_model_1.DomainViewModel.deserialize(response.data));
                    });
                };
                AbstractDomainService.prototype.search = function (request) {
                    return this.backendService.postJson('/domain/search.json', request.serialize(), function (response) {
                        var data = Array();
                        response.data.forEach(function (item) {
                            data.push(domain_view_model_1.DomainViewModel.deserialize(item));
                        });
                        return json_response_1.JsonResponse.deserialize(response, data);
                    });
                };
                AbstractDomainService.prototype.get = function (request) {
                    return this.backendService.getJson('/domain/get/' + request + '.json', function (response) {
                        return json_response_1.JsonResponse.deserialize(response, domain_view_model_1.DomainViewModel.deserialize(response.data));
                    });
                };
                AbstractDomainService.prototype.store = function (request) {
                    return this.backendService.postJson('/domain/store.json', request.serialize(), function (response) {
                        return json_response_1.JsonResponse.deserialize(response, domain_view_model_1.DomainViewModel.deserialize(response.data));
                    });
                };
                AbstractDomainService.prototype.delete = function (request) {
                    return this.backendService.getJson('/domain/delete/' + request + '.json', function (response) {
                        return json_response_1.JsonResponse.deserialize(response);
                    });
                };
                AbstractDomainService.prototype.undelete = function (request) {
                    return this.backendService.getJson('/domain/undelete/' + request + '.json', function (response) {
                        return json_response_1.JsonResponse.deserialize(response);
                    });
                };
                return AbstractDomainService;
            }();
            exports_1("AbstractDomainService", AbstractDomainService);
        }
    };
});

System.registerDynamic("angular2/src/http/http.js", ["angular2/src/facade/lang.js", "angular2/src/facade/exceptions.js", "angular2/core.js", "angular2/src/http/interfaces.js", "angular2/src/http/static_request.js", "angular2/src/http/base_request_options.js", "angular2/src/http/enums.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var exceptions_1 = $__require("angular2/src/facade/exceptions.js");
    var core_1 = $__require("angular2/core.js");
    var interfaces_1 = $__require("angular2/src/http/interfaces.js");
    var static_request_1 = $__require("angular2/src/http/static_request.js");
    var base_request_options_1 = $__require("angular2/src/http/base_request_options.js");
    var enums_1 = $__require("angular2/src/http/enums.js");
    function httpRequest(backend, request) {
        return backend.createConnection(request).response;
    }
    function mergeOptions(defaultOpts, providedOpts, method, url) {
        var newOptions = defaultOpts;
        if (lang_1.isPresent(providedOpts)) {
            // Hack so Dart can used named parameters
            return newOptions.merge(new base_request_options_1.RequestOptions({
                method: providedOpts.method || method,
                url: providedOpts.url || url,
                search: providedOpts.search,
                headers: providedOpts.headers,
                body: providedOpts.body
            }));
        }
        if (lang_1.isPresent(method)) {
            return newOptions.merge(new base_request_options_1.RequestOptions({ method: method, url: url }));
        } else {
            return newOptions.merge(new base_request_options_1.RequestOptions({ url: url }));
        }
    }
    /**
     * Performs http requests using `XMLHttpRequest` as the default backend.
     *
     * `Http` is available as an injectable class, with methods to perform http requests. Calling
     * `request` returns an `Observable` which will emit a single {@link Response} when a
     * response is received.
     *
     * ### Example
     *
     * ```typescript
     * import {Http, HTTP_PROVIDERS} from 'angular2/http';
     * @Component({
     *   selector: 'http-app',
     *   viewProviders: [HTTP_PROVIDERS],
     *   templateUrl: 'people.html'
     * })
     * class PeopleComponent {
     *   constructor(http: Http) {
     *     http.get('people.json')
     *       // Call map on the response observable to get the parsed people object
     *       .map(res => res.json())
     *       // Subscribe to the observable to get the parsed people object and attach it to the
     *       // component
     *       .subscribe(people => this.people = people);
     *   }
     * }
     * ```
     *
     *
     * ### Example
     *
     * ```
     * http.get('people.json').observer({next: (value) => this.people = value});
     * ```
     *
     * The default construct used to perform requests, `XMLHttpRequest`, is abstracted as a "Backend" (
     * {@link XHRBackend} in this case), which could be mocked with dependency injection by replacing
     * the {@link XHRBackend} provider, as in the following example:
     *
     * ### Example
     *
     * ```typescript
     * import {BaseRequestOptions, Http} from 'angular2/http';
     * import {MockBackend} from 'angular2/http/testing';
     * var injector = Injector.resolveAndCreate([
     *   BaseRequestOptions,
     *   MockBackend,
     *   provide(Http, {useFactory:
     *       function(backend, defaultOptions) {
     *         return new Http(backend, defaultOptions);
     *       },
     *       deps: [MockBackend, BaseRequestOptions]})
     * ]);
     * var http = injector.get(Http);
     * http.get('request-from-mock-backend.json').subscribe((res:Response) => doSomething(res));
     * ```
     *
     **/
    var Http = function () {
        function Http(_backend, _defaultOptions) {
            this._backend = _backend;
            this._defaultOptions = _defaultOptions;
        }
        /**
         * Performs any type of http request. First argument is required, and can either be a url or
         * a {@link Request} instance. If the first argument is a url, an optional {@link RequestOptions}
         * object can be provided as the 2nd argument. The options object will be merged with the values
         * of {@link BaseRequestOptions} before performing the request.
         */
        Http.prototype.request = function (url, options) {
            var responseObservable;
            if (lang_1.isString(url)) {
                responseObservable = httpRequest(this._backend, new static_request_1.Request(mergeOptions(this._defaultOptions, options, enums_1.RequestMethod.Get, url)));
            } else if (url instanceof static_request_1.Request) {
                responseObservable = httpRequest(this._backend, url);
            } else {
                throw exceptions_1.makeTypeError('First argument must be a url string or Request instance.');
            }
            return responseObservable;
        };
        /**
         * Performs a request with `get` http method.
         */
        Http.prototype.get = function (url, options) {
            return httpRequest(this._backend, new static_request_1.Request(mergeOptions(this._defaultOptions, options, enums_1.RequestMethod.Get, url)));
        };
        /**
         * Performs a request with `post` http method.
         */
        Http.prototype.post = function (url, body, options) {
            return httpRequest(this._backend, new static_request_1.Request(mergeOptions(this._defaultOptions.merge(new base_request_options_1.RequestOptions({ body: body })), options, enums_1.RequestMethod.Post, url)));
        };
        /**
         * Performs a request with `put` http method.
         */
        Http.prototype.put = function (url, body, options) {
            return httpRequest(this._backend, new static_request_1.Request(mergeOptions(this._defaultOptions.merge(new base_request_options_1.RequestOptions({ body: body })), options, enums_1.RequestMethod.Put, url)));
        };
        /**
         * Performs a request with `delete` http method.
         */
        Http.prototype.delete = function (url, options) {
            return httpRequest(this._backend, new static_request_1.Request(mergeOptions(this._defaultOptions, options, enums_1.RequestMethod.Delete, url)));
        };
        /**
         * Performs a request with `patch` http method.
         */
        Http.prototype.patch = function (url, body, options) {
            return httpRequest(this._backend, new static_request_1.Request(mergeOptions(this._defaultOptions.merge(new base_request_options_1.RequestOptions({ body: body })), options, enums_1.RequestMethod.Patch, url)));
        };
        /**
         * Performs a request with `head` http method.
         */
        Http.prototype.head = function (url, options) {
            return httpRequest(this._backend, new static_request_1.Request(mergeOptions(this._defaultOptions, options, enums_1.RequestMethod.Head, url)));
        };
        Http = __decorate([core_1.Injectable(), __metadata('design:paramtypes', [interfaces_1.ConnectionBackend, base_request_options_1.RequestOptions])], Http);
        return Http;
    }();
    exports.Http = Http;
    var Jsonp = function (_super) {
        __extends(Jsonp, _super);
        function Jsonp(backend, defaultOptions) {
            _super.call(this, backend, defaultOptions);
        }
        /**
         * Performs any type of http request. First argument is required, and can either be a url or
         * a {@link Request} instance. If the first argument is a url, an optional {@link RequestOptions}
         * object can be provided as the 2nd argument. The options object will be merged with the values
         * of {@link BaseRequestOptions} before performing the request.
         */
        Jsonp.prototype.request = function (url, options) {
            var responseObservable;
            if (lang_1.isString(url)) {
                url = new static_request_1.Request(mergeOptions(this._defaultOptions, options, enums_1.RequestMethod.Get, url));
            }
            if (url instanceof static_request_1.Request) {
                if (url.method !== enums_1.RequestMethod.Get) {
                    exceptions_1.makeTypeError('JSONP requests must use GET request method.');
                }
                responseObservable = httpRequest(this._backend, url);
            } else {
                throw exceptions_1.makeTypeError('First argument must be a url string or Request instance.');
            }
            return responseObservable;
        };
        Jsonp = __decorate([core_1.Injectable(), __metadata('design:paramtypes', [interfaces_1.ConnectionBackend, base_request_options_1.RequestOptions])], Jsonp);
        return Jsonp;
    }(Http);
    exports.Jsonp = Jsonp;
});
System.registerDynamic("angular2/src/http/backends/xhr_backend.js", ["angular2/src/http/enums.js", "angular2/src/http/static_response.js", "angular2/src/http/headers.js", "angular2/src/http/base_response_options.js", "angular2/core.js", "angular2/src/http/backends/browser_xhr.js", "angular2/src/facade/lang.js", "rxjs/Observable.js", "angular2/src/http/http_utils.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var enums_1 = $__require("angular2/src/http/enums.js");
    var static_response_1 = $__require("angular2/src/http/static_response.js");
    var headers_1 = $__require("angular2/src/http/headers.js");
    var base_response_options_1 = $__require("angular2/src/http/base_response_options.js");
    var core_1 = $__require("angular2/core.js");
    var browser_xhr_1 = $__require("angular2/src/http/backends/browser_xhr.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var Observable_1 = $__require("rxjs/Observable.js");
    var http_utils_1 = $__require("angular2/src/http/http_utils.js");
    /**
    * Creates connections using `XMLHttpRequest`. Given a fully-qualified
    * request, an `XHRConnection` will immediately create an `XMLHttpRequest` object and send the
    * request.
    *
    * This class would typically not be created or interacted with directly inside applications, though
    * the {@link MockConnection} may be interacted with in tests.
    */
    var XHRConnection = function () {
        function XHRConnection(req, browserXHR, baseResponseOptions) {
            var _this = this;
            this.request = req;
            this.response = new Observable_1.Observable(function (responseObserver) {
                var _xhr = browserXHR.build();
                _xhr.open(enums_1.RequestMethod[req.method].toUpperCase(), req.url);
                // load event handler
                var onLoad = function () {
                    // responseText is the old-school way of retrieving response (supported by IE8 & 9)
                    // response/responseType properties were introduced in XHR Level2 spec (supported by
                    // IE10)
                    var body = lang_1.isPresent(_xhr.response) ? _xhr.response : _xhr.responseText;
                    var headers = headers_1.Headers.fromResponseHeaderString(_xhr.getAllResponseHeaders());
                    var url = http_utils_1.getResponseURL(_xhr);
                    // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
                    var status = _xhr.status === 1223 ? 204 : _xhr.status;
                    // fix status code when it is 0 (0 status is undocumented).
                    // Occurs when accessing file resources or on Android 4.1 stock browser
                    // while retrieving files from application cache.
                    if (status === 0) {
                        status = body ? 200 : 0;
                    }
                    var responseOptions = new base_response_options_1.ResponseOptions({ body: body, status: status, headers: headers, url: url });
                    if (lang_1.isPresent(baseResponseOptions)) {
                        responseOptions = baseResponseOptions.merge(responseOptions);
                    }
                    var response = new static_response_1.Response(responseOptions);
                    if (http_utils_1.isSuccess(status)) {
                        responseObserver.next(response);
                        // TODO(gdi2290): defer complete if array buffer until done
                        responseObserver.complete();
                        return;
                    }
                    responseObserver.error(response);
                };
                // error event handler
                var onError = function (err) {
                    var responseOptions = new base_response_options_1.ResponseOptions({ body: err, type: enums_1.ResponseType.Error });
                    if (lang_1.isPresent(baseResponseOptions)) {
                        responseOptions = baseResponseOptions.merge(responseOptions);
                    }
                    responseObserver.error(new static_response_1.Response(responseOptions));
                };
                if (lang_1.isPresent(req.headers)) {
                    req.headers.forEach(function (values, name) {
                        return _xhr.setRequestHeader(name, values.join(','));
                    });
                }
                _xhr.addEventListener('load', onLoad);
                _xhr.addEventListener('error', onError);
                _xhr.send(_this.request.text());
                return function () {
                    _xhr.removeEventListener('load', onLoad);
                    _xhr.removeEventListener('error', onError);
                    _xhr.abort();
                };
            });
        }
        return XHRConnection;
    }();
    exports.XHRConnection = XHRConnection;
    /**
     * Creates {@link XHRConnection} instances.
     *
     * This class would typically not be used by end users, but could be
     * overridden if a different backend implementation should be used,
     * such as in a node backend.
     *
     * ### Example
     *
     * ```
     * import {Http, MyNodeBackend, HTTP_PROVIDERS, BaseRequestOptions} from 'angular2/http';
     * @Component({
     *   viewProviders: [
     *     HTTP_PROVIDERS,
     *     provide(Http, {useFactory: (backend, options) => {
     *       return new Http(backend, options);
     *     }, deps: [MyNodeBackend, BaseRequestOptions]})]
     * })
     * class MyComponent {
     *   constructor(http:Http) {
     *     http.request('people.json').subscribe(res => this.people = res.json());
     *   }
     * }
     * ```
     *
     **/
    var XHRBackend = function () {
        function XHRBackend(_browserXHR, _baseResponseOptions) {
            this._browserXHR = _browserXHR;
            this._baseResponseOptions = _baseResponseOptions;
        }
        XHRBackend.prototype.createConnection = function (request) {
            return new XHRConnection(request, this._browserXHR, this._baseResponseOptions);
        };
        XHRBackend = __decorate([core_1.Injectable(), __metadata('design:paramtypes', [browser_xhr_1.BrowserXhr, base_response_options_1.ResponseOptions])], XHRBackend);
        return XHRBackend;
    }();
    exports.XHRBackend = XHRBackend;
});
System.registerDynamic("angular2/src/http/backends/jsonp_backend.js", ["angular2/src/http/interfaces.js", "angular2/src/http/enums.js", "angular2/src/http/static_response.js", "angular2/src/http/base_response_options.js", "angular2/core.js", "angular2/src/http/backends/browser_jsonp.js", "angular2/src/facade/exceptions.js", "angular2/src/facade/lang.js", "rxjs/Observable.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var interfaces_1 = $__require("angular2/src/http/interfaces.js");
    var enums_1 = $__require("angular2/src/http/enums.js");
    var static_response_1 = $__require("angular2/src/http/static_response.js");
    var base_response_options_1 = $__require("angular2/src/http/base_response_options.js");
    var core_1 = $__require("angular2/core.js");
    var browser_jsonp_1 = $__require("angular2/src/http/backends/browser_jsonp.js");
    var exceptions_1 = $__require("angular2/src/facade/exceptions.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var Observable_1 = $__require("rxjs/Observable.js");
    var JSONP_ERR_NO_CALLBACK = 'JSONP injected script did not invoke callback.';
    var JSONP_ERR_WRONG_METHOD = 'JSONP requests must use GET request method.';
    /**
     * Abstract base class for an in-flight JSONP request.
     */
    var JSONPConnection = function () {
        function JSONPConnection() {}
        return JSONPConnection;
    }();
    exports.JSONPConnection = JSONPConnection;
    var JSONPConnection_ = function (_super) {
        __extends(JSONPConnection_, _super);
        function JSONPConnection_(req, _dom, baseResponseOptions) {
            var _this = this;
            _super.call(this);
            this._dom = _dom;
            this.baseResponseOptions = baseResponseOptions;
            this._finished = false;
            if (req.method !== enums_1.RequestMethod.Get) {
                throw exceptions_1.makeTypeError(JSONP_ERR_WRONG_METHOD);
            }
            this.request = req;
            this.response = new Observable_1.Observable(function (responseObserver) {
                _this.readyState = enums_1.ReadyState.Loading;
                var id = _this._id = _dom.nextRequestID();
                _dom.exposeConnection(id, _this);
                // Workaround Dart
                // url = url.replace(/=JSONP_CALLBACK(&|$)/, `generated method`);
                var callback = _dom.requestCallback(_this._id);
                var url = req.url;
                if (url.indexOf('=JSONP_CALLBACK&') > -1) {
                    url = lang_1.StringWrapper.replace(url, '=JSONP_CALLBACK&', "=" + callback + "&");
                } else if (url.lastIndexOf('=JSONP_CALLBACK') === url.length - '=JSONP_CALLBACK'.length) {
                    url = url.substring(0, url.length - '=JSONP_CALLBACK'.length) + ("=" + callback);
                }
                var script = _this._script = _dom.build(url);
                var onLoad = function (event) {
                    if (_this.readyState === enums_1.ReadyState.Cancelled) return;
                    _this.readyState = enums_1.ReadyState.Done;
                    _dom.cleanup(script);
                    if (!_this._finished) {
                        var responseOptions_1 = new base_response_options_1.ResponseOptions({ body: JSONP_ERR_NO_CALLBACK, type: enums_1.ResponseType.Error, url: url });
                        if (lang_1.isPresent(baseResponseOptions)) {
                            responseOptions_1 = baseResponseOptions.merge(responseOptions_1);
                        }
                        responseObserver.error(new static_response_1.Response(responseOptions_1));
                        return;
                    }
                    var responseOptions = new base_response_options_1.ResponseOptions({ body: _this._responseData, url: url });
                    if (lang_1.isPresent(_this.baseResponseOptions)) {
                        responseOptions = _this.baseResponseOptions.merge(responseOptions);
                    }
                    responseObserver.next(new static_response_1.Response(responseOptions));
                    responseObserver.complete();
                };
                var onError = function (error) {
                    if (_this.readyState === enums_1.ReadyState.Cancelled) return;
                    _this.readyState = enums_1.ReadyState.Done;
                    _dom.cleanup(script);
                    var responseOptions = new base_response_options_1.ResponseOptions({ body: error.message, type: enums_1.ResponseType.Error });
                    if (lang_1.isPresent(baseResponseOptions)) {
                        responseOptions = baseResponseOptions.merge(responseOptions);
                    }
                    responseObserver.error(new static_response_1.Response(responseOptions));
                };
                script.addEventListener('load', onLoad);
                script.addEventListener('error', onError);
                _dom.send(script);
                return function () {
                    _this.readyState = enums_1.ReadyState.Cancelled;
                    script.removeEventListener('load', onLoad);
                    script.removeEventListener('error', onError);
                    if (lang_1.isPresent(script)) {
                        _this._dom.cleanup(script);
                    }
                };
            });
        }
        JSONPConnection_.prototype.finished = function (data) {
            // Don't leak connections
            this._finished = true;
            this._dom.removeConnection(this._id);
            if (this.readyState === enums_1.ReadyState.Cancelled) return;
            this._responseData = data;
        };
        return JSONPConnection_;
    }(JSONPConnection);
    exports.JSONPConnection_ = JSONPConnection_;
    /**
     * A {@link ConnectionBackend} that uses the JSONP strategy of making requests.
     */
    var JSONPBackend = function (_super) {
        __extends(JSONPBackend, _super);
        function JSONPBackend() {
            _super.apply(this, arguments);
        }
        return JSONPBackend;
    }(interfaces_1.ConnectionBackend);
    exports.JSONPBackend = JSONPBackend;
    var JSONPBackend_ = function (_super) {
        __extends(JSONPBackend_, _super);
        function JSONPBackend_(_browserJSONP, _baseResponseOptions) {
            _super.call(this);
            this._browserJSONP = _browserJSONP;
            this._baseResponseOptions = _baseResponseOptions;
        }
        JSONPBackend_.prototype.createConnection = function (request) {
            return new JSONPConnection_(request, this._browserJSONP, this._baseResponseOptions);
        };
        JSONPBackend_ = __decorate([core_1.Injectable(), __metadata('design:paramtypes', [browser_jsonp_1.BrowserJsonp, base_response_options_1.ResponseOptions])], JSONPBackend_);
        return JSONPBackend_;
    }(JSONPBackend);
    exports.JSONPBackend_ = JSONPBackend_;
});
System.registerDynamic("angular2/src/http/backends/browser_xhr.js", ["angular2/core.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1 = $__require("angular2/core.js");
    /**
     * A backend for http that uses the `XMLHttpRequest` browser API.
     *
     * Take care not to evaluate this in non-browser contexts.
     */
    var BrowserXhr = function () {
        function BrowserXhr() {}
        BrowserXhr.prototype.build = function () {
            return new XMLHttpRequest();
        };
        BrowserXhr = __decorate([core_1.Injectable(), __metadata('design:paramtypes', [])], BrowserXhr);
        return BrowserXhr;
    }();
    exports.BrowserXhr = BrowserXhr;
});
System.registerDynamic("angular2/src/http/backends/browser_jsonp.js", ["angular2/core.js", "angular2/src/facade/lang.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1 = $__require("angular2/core.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var _nextRequestId = 0;
    exports.JSONP_HOME = '__ng_jsonp__';
    var _jsonpConnections = null;
    function _getJsonpConnections() {
        if (_jsonpConnections === null) {
            _jsonpConnections = lang_1.global[exports.JSONP_HOME] = {};
        }
        return _jsonpConnections;
    }
    // Make sure not to evaluate this in a non-browser environment!
    var BrowserJsonp = function () {
        function BrowserJsonp() {}
        // Construct a <script> element with the specified URL
        BrowserJsonp.prototype.build = function (url) {
            var node = document.createElement('script');
            node.src = url;
            return node;
        };
        BrowserJsonp.prototype.nextRequestID = function () {
            return "__req" + _nextRequestId++;
        };
        BrowserJsonp.prototype.requestCallback = function (id) {
            return exports.JSONP_HOME + "." + id + ".finished";
        };
        BrowserJsonp.prototype.exposeConnection = function (id, connection) {
            var connections = _getJsonpConnections();
            connections[id] = connection;
        };
        BrowserJsonp.prototype.removeConnection = function (id) {
            var connections = _getJsonpConnections();
            connections[id] = null;
        };
        // Attach the <script> element to the DOM
        BrowserJsonp.prototype.send = function (node) {
            document.body.appendChild(node);
        };
        // Remove <script> element from the DOM
        BrowserJsonp.prototype.cleanup = function (node) {
            if (node.parentNode) {
                node.parentNode.removeChild(node);
            }
        };
        BrowserJsonp = __decorate([core_1.Injectable(), __metadata('design:paramtypes', [])], BrowserJsonp);
        return BrowserJsonp;
    }();
    exports.BrowserJsonp = BrowserJsonp;
});
System.registerDynamic("angular2/src/http/base_request_options.js", ["angular2/src/facade/lang.js", "angular2/src/http/headers.js", "angular2/src/http/enums.js", "angular2/core.js", "angular2/src/http/url_search_params.js", "angular2/src/http/http_utils.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var headers_1 = $__require("angular2/src/http/headers.js");
    var enums_1 = $__require("angular2/src/http/enums.js");
    var core_1 = $__require("angular2/core.js");
    var url_search_params_1 = $__require("angular2/src/http/url_search_params.js");
    var http_utils_1 = $__require("angular2/src/http/http_utils.js");
    /**
     * Creates a request options object to be optionally provided when instantiating a
     * {@link Request}.
     *
     * This class is based on the `RequestInit` description in the [Fetch
     * Spec](https://fetch.spec.whatwg.org/#requestinit).
     *
     * All values are null by default. Typical defaults can be found in the {@link BaseRequestOptions}
     * class, which sub-classes `RequestOptions`.
     *
     * ### Example ([live demo](http://plnkr.co/edit/7Wvi3lfLq41aQPKlxB4O?p=preview))
     *
     * ```typescript
     * import {RequestOptions, Request, RequestMethod} from 'angular2/http';
     *
     * var options = new RequestOptions({
     *   method: RequestMethod.Post,
     *   url: 'https://google.com'
     * });
     * var req = new Request(options);
     * console.log('req.method:', RequestMethod[req.method]); // Post
     * console.log('options.url:', options.url); // https://google.com
     * ```
     */
    var RequestOptions = function () {
        function RequestOptions(_a) {
            var _b = _a === void 0 ? {} : _a,
                method = _b.method,
                headers = _b.headers,
                body = _b.body,
                url = _b.url,
                search = _b.search;
            this.method = lang_1.isPresent(method) ? http_utils_1.normalizeMethodName(method) : null;
            this.headers = lang_1.isPresent(headers) ? headers : null;
            this.body = lang_1.isPresent(body) ? body : null;
            this.url = lang_1.isPresent(url) ? url : null;
            this.search = lang_1.isPresent(search) ? lang_1.isString(search) ? new url_search_params_1.URLSearchParams(search) : search : null;
        }
        /**
         * Creates a copy of the `RequestOptions` instance, using the optional input as values to override
         * existing values. This method will not change the values of the instance on which it is being
         * called.
         *
         * Note that `headers` and `search` will override existing values completely if present in
         * the `options` object. If these values should be merged, it should be done prior to calling
         * `merge` on the `RequestOptions` instance.
         *
         * ### Example ([live demo](http://plnkr.co/edit/6w8XA8YTkDRcPYpdB9dk?p=preview))
         *
         * ```typescript
         * import {RequestOptions, Request, RequestMethod} from 'angular2/http';
         *
         * var options = new RequestOptions({
         *   method: RequestMethod.Post
         * });
         * var req = new Request(options.merge({
         *   url: 'https://google.com'
         * }));
         * console.log('req.method:', RequestMethod[req.method]); // Post
         * console.log('options.url:', options.url); // null
         * console.log('req.url:', req.url); // https://google.com
         * ```
         */
        RequestOptions.prototype.merge = function (options) {
            return new RequestOptions({
                method: lang_1.isPresent(options) && lang_1.isPresent(options.method) ? options.method : this.method,
                headers: lang_1.isPresent(options) && lang_1.isPresent(options.headers) ? options.headers : this.headers,
                body: lang_1.isPresent(options) && lang_1.isPresent(options.body) ? options.body : this.body,
                url: lang_1.isPresent(options) && lang_1.isPresent(options.url) ? options.url : this.url,
                search: lang_1.isPresent(options) && lang_1.isPresent(options.search) ? lang_1.isString(options.search) ? new url_search_params_1.URLSearchParams(options.search) : options.search.clone() : this.search
            });
        };
        return RequestOptions;
    }();
    exports.RequestOptions = RequestOptions;
    /**
     * Subclass of {@link RequestOptions}, with default values.
     *
     * Default values:
     *  * method: {@link RequestMethod RequestMethod.Get}
     *  * headers: empty {@link Headers} object
     *
     * This class could be extended and bound to the {@link RequestOptions} class
     * when configuring an {@link Injector}, in order to override the default options
     * used by {@link Http} to create and send {@link Request Requests}.
     *
     * ### Example ([live demo](http://plnkr.co/edit/LEKVSx?p=preview))
     *
     * ```typescript
     * import {provide} from 'angular2/core';
     * import {bootstrap} from 'angular2/platform/browser';
     * import {HTTP_PROVIDERS, Http, BaseRequestOptions, RequestOptions} from 'angular2/http';
     * import {App} from './myapp';
     *
     * class MyOptions extends BaseRequestOptions {
     *   search: string = 'coreTeam=true';
     * }
     *
     * bootstrap(App, [HTTP_PROVIDERS, provide(RequestOptions, {useClass: MyOptions})]);
     * ```
     *
     * The options could also be extended when manually creating a {@link Request}
     * object.
     *
     * ### Example ([live demo](http://plnkr.co/edit/oyBoEvNtDhOSfi9YxaVb?p=preview))
     *
     * ```
     * import {BaseRequestOptions, Request, RequestMethod} from 'angular2/http';
     *
     * var options = new BaseRequestOptions();
     * var req = new Request(options.merge({
     *   method: RequestMethod.Post,
     *   url: 'https://google.com'
     * }));
     * console.log('req.method:', RequestMethod[req.method]); // Post
     * console.log('options.url:', options.url); // null
     * console.log('req.url:', req.url); // https://google.com
     * ```
     */
    var BaseRequestOptions = function (_super) {
        __extends(BaseRequestOptions, _super);
        function BaseRequestOptions() {
            _super.call(this, { method: enums_1.RequestMethod.Get, headers: new headers_1.Headers() });
        }
        BaseRequestOptions = __decorate([core_1.Injectable(), __metadata('design:paramtypes', [])], BaseRequestOptions);
        return BaseRequestOptions;
    }(RequestOptions);
    exports.BaseRequestOptions = BaseRequestOptions;
});
System.registerDynamic("angular2/src/http/base_response_options.js", ["angular2/core.js", "angular2/src/facade/lang.js", "angular2/src/http/headers.js", "angular2/src/http/enums.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1 = $__require("angular2/core.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var headers_1 = $__require("angular2/src/http/headers.js");
    var enums_1 = $__require("angular2/src/http/enums.js");
    /**
     * Creates a response options object to be optionally provided when instantiating a
     * {@link Response}.
     *
     * This class is based on the `ResponseInit` description in the [Fetch
     * Spec](https://fetch.spec.whatwg.org/#responseinit).
     *
     * All values are null by default. Typical defaults can be found in the
     * {@link BaseResponseOptions} class, which sub-classes `ResponseOptions`.
     *
     * This class may be used in tests to build {@link Response Responses} for
     * mock responses (see {@link MockBackend}).
     *
     * ### Example ([live demo](http://plnkr.co/edit/P9Jkk8e8cz6NVzbcxEsD?p=preview))
     *
     * ```typescript
     * import {ResponseOptions, Response} from 'angular2/http';
     *
     * var options = new ResponseOptions({
     *   body: '{"name":"Jeff"}'
     * });
     * var res = new Response(options);
     *
     * console.log('res.json():', res.json()); // Object {name: "Jeff"}
     * ```
     */
    var ResponseOptions = function () {
        function ResponseOptions(_a) {
            var _b = _a === void 0 ? {} : _a,
                body = _b.body,
                status = _b.status,
                headers = _b.headers,
                statusText = _b.statusText,
                type = _b.type,
                url = _b.url;
            this.body = lang_1.isPresent(body) ? body : null;
            this.status = lang_1.isPresent(status) ? status : null;
            this.headers = lang_1.isPresent(headers) ? headers : null;
            this.statusText = lang_1.isPresent(statusText) ? statusText : null;
            this.type = lang_1.isPresent(type) ? type : null;
            this.url = lang_1.isPresent(url) ? url : null;
        }
        /**
         * Creates a copy of the `ResponseOptions` instance, using the optional input as values to
         * override
         * existing values. This method will not change the values of the instance on which it is being
         * called.
         *
         * This may be useful when sharing a base `ResponseOptions` object inside tests,
         * where certain properties may change from test to test.
         *
         * ### Example ([live demo](http://plnkr.co/edit/1lXquqFfgduTFBWjNoRE?p=preview))
         *
         * ```typescript
         * import {ResponseOptions, Response} from 'angular2/http';
         *
         * var options = new ResponseOptions({
         *   body: {name: 'Jeff'}
         * });
         * var res = new Response(options.merge({
         *   url: 'https://google.com'
         * }));
         * console.log('options.url:', options.url); // null
         * console.log('res.json():', res.json()); // Object {name: "Jeff"}
         * console.log('res.url:', res.url); // https://google.com
         * ```
         */
        ResponseOptions.prototype.merge = function (options) {
            return new ResponseOptions({
                body: lang_1.isPresent(options) && lang_1.isPresent(options.body) ? options.body : this.body,
                status: lang_1.isPresent(options) && lang_1.isPresent(options.status) ? options.status : this.status,
                headers: lang_1.isPresent(options) && lang_1.isPresent(options.headers) ? options.headers : this.headers,
                statusText: lang_1.isPresent(options) && lang_1.isPresent(options.statusText) ? options.statusText : this.statusText,
                type: lang_1.isPresent(options) && lang_1.isPresent(options.type) ? options.type : this.type,
                url: lang_1.isPresent(options) && lang_1.isPresent(options.url) ? options.url : this.url
            });
        };
        return ResponseOptions;
    }();
    exports.ResponseOptions = ResponseOptions;
    /**
     * Subclass of {@link ResponseOptions}, with default values.
     *
     * Default values:
     *  * status: 200
     *  * headers: empty {@link Headers} object
     *
     * This class could be extended and bound to the {@link ResponseOptions} class
     * when configuring an {@link Injector}, in order to override the default options
     * used by {@link Http} to create {@link Response Responses}.
     *
     * ### Example ([live demo](http://plnkr.co/edit/qv8DLT?p=preview))
     *
     * ```typescript
     * import {provide} from 'angular2/core';
     * import {bootstrap} from 'angular2/platform/browser';
     * import {HTTP_PROVIDERS, Headers, Http, BaseResponseOptions, ResponseOptions} from
     * 'angular2/http';
     * import {App} from './myapp';
     *
     * class MyOptions extends BaseResponseOptions {
     *   headers:Headers = new Headers({network: 'github'});
     * }
     *
     * bootstrap(App, [HTTP_PROVIDERS, provide(ResponseOptions, {useClass: MyOptions})]);
     * ```
     *
     * The options could also be extended when manually creating a {@link Response}
     * object.
     *
     * ### Example ([live demo](http://plnkr.co/edit/VngosOWiaExEtbstDoix?p=preview))
     *
     * ```
     * import {BaseResponseOptions, Response} from 'angular2/http';
     *
     * var options = new BaseResponseOptions();
     * var res = new Response(options.merge({
     *   body: 'Angular2',
     *   headers: new Headers({framework: 'angular'})
     * }));
     * console.log('res.headers.get("framework"):', res.headers.get('framework')); // angular
     * console.log('res.text():', res.text()); // Angular2;
     * ```
     */
    var BaseResponseOptions = function (_super) {
        __extends(BaseResponseOptions, _super);
        function BaseResponseOptions() {
            _super.call(this, { status: 200, statusText: 'Ok', type: enums_1.ResponseType.Default, headers: new headers_1.Headers() });
        }
        BaseResponseOptions = __decorate([core_1.Injectable(), __metadata('design:paramtypes', [])], BaseResponseOptions);
        return BaseResponseOptions;
    }(ResponseOptions);
    exports.BaseResponseOptions = BaseResponseOptions;
});
System.registerDynamic('angular2/src/http/static_request.js', ['angular2/src/http/headers.js', 'angular2/src/http/http_utils.js', 'angular2/src/facade/lang.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var headers_1 = $__require('angular2/src/http/headers.js');
    var http_utils_1 = $__require('angular2/src/http/http_utils.js');
    var lang_1 = $__require('angular2/src/facade/lang.js');
    // TODO(jeffbcross): properly implement body accessors
    /**
     * Creates `Request` instances from provided values.
     *
     * The Request's interface is inspired by the Request constructor defined in the [Fetch
     * Spec](https://fetch.spec.whatwg.org/#request-class),
     * but is considered a static value whose body can be accessed many times. There are other
     * differences in the implementation, but this is the most significant.
     *
     * `Request` instances are typically created by higher-level classes, like {@link Http} and
     * {@link Jsonp}, but it may occasionally be useful to explicitly create `Request` instances.
     * One such example is when creating services that wrap higher-level services, like {@link Http},
     * where it may be useful to generate a `Request` with arbitrary headers and search params.
     *
     * ```typescript
     * import {Injectable, Injector} from 'angular2/core';
     * import {HTTP_PROVIDERS, Http, Request, RequestMethod} from 'angular2/http';
     *
     * @Injectable()
     * class AutoAuthenticator {
     *   constructor(public http:Http) {}
     *   request(url:string) {
     *     return this.http.request(new Request({
     *       method: RequestMethod.Get,
     *       url: url,
     *       search: 'password=123'
     *     }));
     *   }
     * }
     *
     * var injector = Injector.resolveAndCreate([HTTP_PROVIDERS, AutoAuthenticator]);
     * var authenticator = injector.get(AutoAuthenticator);
     * authenticator.request('people.json').subscribe(res => {
     *   //URL should have included '?password=123'
     *   console.log('people', res.json());
     * });
     * ```
     */
    var Request = function () {
        function Request(requestOptions) {
            // TODO: assert that url is present
            var url = requestOptions.url;
            this.url = requestOptions.url;
            if (lang_1.isPresent(requestOptions.search)) {
                var search = requestOptions.search.toString();
                if (search.length > 0) {
                    var prefix = '?';
                    if (lang_1.StringWrapper.contains(this.url, '?')) {
                        prefix = this.url[this.url.length - 1] == '&' ? '' : '&';
                    }
                    // TODO: just delete search-query-looking string in url?
                    this.url = url + prefix + search;
                }
            }
            this._body = requestOptions.body;
            this.method = http_utils_1.normalizeMethodName(requestOptions.method);
            // TODO(jeffbcross): implement behavior
            // Defaults to 'omit', consistent with browser
            // TODO(jeffbcross): implement behavior
            this.headers = new headers_1.Headers(requestOptions.headers);
        }
        /**
         * Returns the request's body as string, assuming that body exists. If body is undefined, return
         * empty
         * string.
         */
        Request.prototype.text = function () {
            return lang_1.isPresent(this._body) ? this._body.toString() : '';
        };
        return Request;
    }();
    exports.Request = Request;
});
System.registerDynamic('angular2/src/http/http_utils.js', ['angular2/src/facade/lang.js', 'angular2/src/http/enums.js', 'angular2/src/facade/exceptions.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var enums_1 = $__require('angular2/src/http/enums.js');
    var exceptions_1 = $__require('angular2/src/facade/exceptions.js');
    function normalizeMethodName(method) {
        if (lang_1.isString(method)) {
            var originalMethod = method;
            method = method.replace(/(\w)(\w*)/g, function (g0, g1, g2) {
                return g1.toUpperCase() + g2.toLowerCase();
            });
            method = enums_1.RequestMethod[method];
            if (typeof method !== 'number') throw exceptions_1.makeTypeError("Invalid request method. The method \"" + originalMethod + "\" is not supported.");
        }
        return method;
    }
    exports.normalizeMethodName = normalizeMethodName;
    exports.isSuccess = function (status) {
        return status >= 200 && status < 300;
    };
    function getResponseURL(xhr) {
        if ('responseURL' in xhr) {
            return xhr.responseURL;
        }
        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
            return xhr.getResponseHeader('X-Request-URL');
        }
        return;
    }
    exports.getResponseURL = getResponseURL;
    var lang_2 = $__require('angular2/src/facade/lang.js');
    exports.isJsObject = lang_2.isJsObject;
});
System.registerDynamic('angular2/src/http/static_response.js', ['angular2/src/facade/lang.js', 'angular2/src/facade/exceptions.js', 'angular2/src/http/http_utils.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var exceptions_1 = $__require('angular2/src/facade/exceptions.js');
    var http_utils_1 = $__require('angular2/src/http/http_utils.js');
    /**
     * Creates `Response` instances from provided values.
     *
     * Though this object isn't
     * usually instantiated by end-users, it is the primary object interacted with when it comes time to
     * add data to a view.
     *
     * ### Example
     *
     * ```
     * http.request('my-friends.txt').subscribe(response => this.friends = response.text());
     * ```
     *
     * The Response's interface is inspired by the Response constructor defined in the [Fetch
     * Spec](https://fetch.spec.whatwg.org/#response-class), but is considered a static value whose body
     * can be accessed many times. There are other differences in the implementation, but this is the
     * most significant.
     */
    var Response = function () {
        function Response(responseOptions) {
            this._body = responseOptions.body;
            this.status = responseOptions.status;
            this.statusText = responseOptions.statusText;
            this.headers = responseOptions.headers;
            this.type = responseOptions.type;
            this.url = responseOptions.url;
        }
        /**
         * Not yet implemented
         */
        // TODO: Blob return type
        Response.prototype.blob = function () {
            throw new exceptions_1.BaseException('"blob()" method not implemented on Response superclass');
        };
        /**
         * Attempts to return body as parsed `JSON` object, or raises an exception.
         */
        Response.prototype.json = function () {
            var jsonResponse;
            if (http_utils_1.isJsObject(this._body)) {
                jsonResponse = this._body;
            } else if (lang_1.isString(this._body)) {
                jsonResponse = lang_1.Json.parse(this._body);
            }
            return jsonResponse;
        };
        /**
         * Returns the body as a string, presuming `toString()` can be called on the response body.
         */
        Response.prototype.text = function () {
            return this._body.toString();
        };
        /**
         * Not yet implemented
         */
        // TODO: ArrayBuffer return type
        Response.prototype.arrayBuffer = function () {
            throw new exceptions_1.BaseException('"arrayBuffer()" method not implemented on Response superclass');
        };
        return Response;
    }();
    exports.Response = Response;
});
System.registerDynamic("angular2/src/http/interfaces.js", [], true, function ($__require, exports, module) {
  'use strict';"use strict";
  /**
   * Abstract class from which real backends are derived.
   *
   * The primary purpose of a `ConnectionBackend` is to create new connections to fulfill a given
   * {@link Request}.
   */

  var global = this || self,
      GLOBAL = global;
  var ConnectionBackend = function () {
    function ConnectionBackend() {}
    return ConnectionBackend;
  }();
  exports.ConnectionBackend = ConnectionBackend;
  /**
   * Abstract class from which real connections are derived.
   */
  var Connection = function () {
    function Connection() {}
    return Connection;
  }();
  exports.Connection = Connection;
});
System.registerDynamic('angular2/src/http/headers.js', ['angular2/src/facade/lang.js', 'angular2/src/facade/exceptions.js', 'angular2/src/facade/collection.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var exceptions_1 = $__require('angular2/src/facade/exceptions.js');
    var collection_1 = $__require('angular2/src/facade/collection.js');
    /**
     * Polyfill for [Headers](https://developer.mozilla.org/en-US/docs/Web/API/Headers/Headers), as
     * specified in the [Fetch Spec](https://fetch.spec.whatwg.org/#headers-class).
     *
     * The only known difference between this `Headers` implementation and the spec is the
     * lack of an `entries` method.
     *
     * ### Example ([live demo](http://plnkr.co/edit/MTdwT6?p=preview))
     *
     * ```
     * import {Headers} from 'angular2/http';
     *
     * var firstHeaders = new Headers();
     * firstHeaders.append('Content-Type', 'image/jpeg');
     * console.log(firstHeaders.get('Content-Type')) //'image/jpeg'
     *
     * // Create headers from Plain Old JavaScript Object
     * var secondHeaders = new Headers({
     *   'X-My-Custom-Header': 'Angular'
     * });
     * console.log(secondHeaders.get('X-My-Custom-Header')); //'Angular'
     *
     * var thirdHeaders = new Headers(secondHeaders);
     * console.log(thirdHeaders.get('X-My-Custom-Header')); //'Angular'
     * ```
     */
    var Headers = function () {
        function Headers(headers) {
            var _this = this;
            if (headers instanceof Headers) {
                this._headersMap = headers._headersMap;
                return;
            }
            this._headersMap = new collection_1.Map();
            if (lang_1.isBlank(headers)) {
                return;
            }
            // headers instanceof StringMap
            collection_1.StringMapWrapper.forEach(headers, function (v, k) {
                _this._headersMap.set(k, collection_1.isListLikeIterable(v) ? v : [v]);
            });
        }
        /**
         * Returns a new Headers instance from the given DOMString of Response Headers
         */
        Headers.fromResponseHeaderString = function (headersString) {
            return headersString.trim().split('\n').map(function (val) {
                return val.split(':');
            }).map(function (_a) {
                var key = _a[0],
                    parts = _a.slice(1);
                return [key.trim(), parts.join(':').trim()];
            }).reduce(function (headers, _a) {
                var key = _a[0],
                    value = _a[1];
                return !headers.set(key, value) && headers;
            }, new Headers());
        };
        /**
         * Appends a header to existing list of header values for a given header name.
         */
        Headers.prototype.append = function (name, value) {
            var mapName = this._headersMap.get(name);
            var list = collection_1.isListLikeIterable(mapName) ? mapName : [];
            list.push(value);
            this._headersMap.set(name, list);
        };
        /**
         * Deletes all header values for the given name.
         */
        Headers.prototype.delete = function (name) {
            this._headersMap.delete(name);
        };
        Headers.prototype.forEach = function (fn) {
            this._headersMap.forEach(fn);
        };
        /**
         * Returns first header that matches given name.
         */
        Headers.prototype.get = function (header) {
            return collection_1.ListWrapper.first(this._headersMap.get(header));
        };
        /**
         * Check for existence of header by given name.
         */
        Headers.prototype.has = function (header) {
            return this._headersMap.has(header);
        };
        /**
         * Provides names of set headers
         */
        Headers.prototype.keys = function () {
            return collection_1.MapWrapper.keys(this._headersMap);
        };
        /**
         * Sets or overrides header value for given name.
         */
        Headers.prototype.set = function (header, value) {
            var list = [];
            if (collection_1.isListLikeIterable(value)) {
                var pushValue = value.join(',');
                list.push(pushValue);
            } else {
                list.push(value);
            }
            this._headersMap.set(header, list);
        };
        /**
         * Returns values of all headers.
         */
        Headers.prototype.values = function () {
            return collection_1.MapWrapper.values(this._headersMap);
        };
        /**
         * Returns string of all headers.
         */
        Headers.prototype.toJSON = function () {
            var serializableHeaders = {};
            this._headersMap.forEach(function (values, name) {
                var list = [];
                collection_1.iterateListLike(values, function (val) {
                    return list = collection_1.ListWrapper.concat(list, val.split(','));
                });
                serializableHeaders[name] = list;
            });
            return serializableHeaders;
        };
        /**
         * Returns list of header values for a given name.
         */
        Headers.prototype.getAll = function (header) {
            var headers = this._headersMap.get(header);
            return collection_1.isListLikeIterable(headers) ? headers : [];
        };
        /**
         * This method is not implemented.
         */
        Headers.prototype.entries = function () {
            throw new exceptions_1.BaseException('"entries" method is not implemented on Headers class');
        };
        return Headers;
    }();
    exports.Headers = Headers;
});
System.registerDynamic("angular2/src/http/enums.js", [], true, function ($__require, exports, module) {
    'use strict';"use strict";
    /**
     * Supported http methods.
     */

    var global = this || self,
        GLOBAL = global;
    (function (RequestMethod) {
        RequestMethod[RequestMethod["Get"] = 0] = "Get";
        RequestMethod[RequestMethod["Post"] = 1] = "Post";
        RequestMethod[RequestMethod["Put"] = 2] = "Put";
        RequestMethod[RequestMethod["Delete"] = 3] = "Delete";
        RequestMethod[RequestMethod["Options"] = 4] = "Options";
        RequestMethod[RequestMethod["Head"] = 5] = "Head";
        RequestMethod[RequestMethod["Patch"] = 6] = "Patch";
    })(exports.RequestMethod || (exports.RequestMethod = {}));
    var RequestMethod = exports.RequestMethod;
    /**
     * All possible states in which a connection can be, based on
     * [States](http://www.w3.org/TR/XMLHttpRequest/#states) from the `XMLHttpRequest` spec, but with an
     * additional "CANCELLED" state.
     */
    (function (ReadyState) {
        ReadyState[ReadyState["Unsent"] = 0] = "Unsent";
        ReadyState[ReadyState["Open"] = 1] = "Open";
        ReadyState[ReadyState["HeadersReceived"] = 2] = "HeadersReceived";
        ReadyState[ReadyState["Loading"] = 3] = "Loading";
        ReadyState[ReadyState["Done"] = 4] = "Done";
        ReadyState[ReadyState["Cancelled"] = 5] = "Cancelled";
    })(exports.ReadyState || (exports.ReadyState = {}));
    var ReadyState = exports.ReadyState;
    /**
     * Acceptable response types to be associated with a {@link Response}, based on
     * [ResponseType](https://fetch.spec.whatwg.org/#responsetype) from the Fetch spec.
     */
    (function (ResponseType) {
        ResponseType[ResponseType["Basic"] = 0] = "Basic";
        ResponseType[ResponseType["Cors"] = 1] = "Cors";
        ResponseType[ResponseType["Default"] = 2] = "Default";
        ResponseType[ResponseType["Error"] = 3] = "Error";
        ResponseType[ResponseType["Opaque"] = 4] = "Opaque";
    })(exports.ResponseType || (exports.ResponseType = {}));
    var ResponseType = exports.ResponseType;
});
System.registerDynamic('angular2/src/http/url_search_params.js', ['angular2/src/facade/lang.js', 'angular2/src/facade/collection.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var collection_1 = $__require('angular2/src/facade/collection.js');
    function paramParser(rawParams) {
        if (rawParams === void 0) {
            rawParams = '';
        }
        var map = new collection_1.Map();
        if (rawParams.length > 0) {
            var params = rawParams.split('&');
            params.forEach(function (param) {
                var split = param.split('=');
                var key = split[0];
                var val = split[1];
                var list = lang_1.isPresent(map.get(key)) ? map.get(key) : [];
                list.push(val);
                map.set(key, list);
            });
        }
        return map;
    }
    /**
     * Map-like representation of url search parameters, based on
     * [URLSearchParams](https://url.spec.whatwg.org/#urlsearchparams) in the url living standard,
     * with several extensions for merging URLSearchParams objects:
     *   - setAll()
     *   - appendAll()
     *   - replaceAll()
     */
    var URLSearchParams = function () {
        function URLSearchParams(rawParams) {
            if (rawParams === void 0) {
                rawParams = '';
            }
            this.rawParams = rawParams;
            this.paramsMap = paramParser(rawParams);
        }
        URLSearchParams.prototype.clone = function () {
            var clone = new URLSearchParams();
            clone.appendAll(this);
            return clone;
        };
        URLSearchParams.prototype.has = function (param) {
            return this.paramsMap.has(param);
        };
        URLSearchParams.prototype.get = function (param) {
            var storedParam = this.paramsMap.get(param);
            if (collection_1.isListLikeIterable(storedParam)) {
                return collection_1.ListWrapper.first(storedParam);
            } else {
                return null;
            }
        };
        URLSearchParams.prototype.getAll = function (param) {
            var mapParam = this.paramsMap.get(param);
            return lang_1.isPresent(mapParam) ? mapParam : [];
        };
        URLSearchParams.prototype.set = function (param, val) {
            var mapParam = this.paramsMap.get(param);
            var list = lang_1.isPresent(mapParam) ? mapParam : [];
            collection_1.ListWrapper.clear(list);
            list.push(val);
            this.paramsMap.set(param, list);
        };
        // A merge operation
        // For each name-values pair in `searchParams`, perform `set(name, values[0])`
        //
        // E.g: "a=[1,2,3], c=[8]" + "a=[4,5,6], b=[7]" = "a=[4], c=[8], b=[7]"
        //
        // TODO(@caitp): document this better
        URLSearchParams.prototype.setAll = function (searchParams) {
            var _this = this;
            searchParams.paramsMap.forEach(function (value, param) {
                var mapParam = _this.paramsMap.get(param);
                var list = lang_1.isPresent(mapParam) ? mapParam : [];
                collection_1.ListWrapper.clear(list);
                list.push(value[0]);
                _this.paramsMap.set(param, list);
            });
        };
        URLSearchParams.prototype.append = function (param, val) {
            var mapParam = this.paramsMap.get(param);
            var list = lang_1.isPresent(mapParam) ? mapParam : [];
            list.push(val);
            this.paramsMap.set(param, list);
        };
        // A merge operation
        // For each name-values pair in `searchParams`, perform `append(name, value)`
        // for each value in `values`.
        //
        // E.g: "a=[1,2], c=[8]" + "a=[3,4], b=[7]" = "a=[1,2,3,4], c=[8], b=[7]"
        //
        // TODO(@caitp): document this better
        URLSearchParams.prototype.appendAll = function (searchParams) {
            var _this = this;
            searchParams.paramsMap.forEach(function (value, param) {
                var mapParam = _this.paramsMap.get(param);
                var list = lang_1.isPresent(mapParam) ? mapParam : [];
                for (var i = 0; i < value.length; ++i) {
                    list.push(value[i]);
                }
                _this.paramsMap.set(param, list);
            });
        };
        // A merge operation
        // For each name-values pair in `searchParams`, perform `delete(name)`,
        // followed by `set(name, values)`
        //
        // E.g: "a=[1,2,3], c=[8]" + "a=[4,5,6], b=[7]" = "a=[4,5,6], c=[8], b=[7]"
        //
        // TODO(@caitp): document this better
        URLSearchParams.prototype.replaceAll = function (searchParams) {
            var _this = this;
            searchParams.paramsMap.forEach(function (value, param) {
                var mapParam = _this.paramsMap.get(param);
                var list = lang_1.isPresent(mapParam) ? mapParam : [];
                collection_1.ListWrapper.clear(list);
                for (var i = 0; i < value.length; ++i) {
                    list.push(value[i]);
                }
                _this.paramsMap.set(param, list);
            });
        };
        URLSearchParams.prototype.toString = function () {
            var paramsList = [];
            this.paramsMap.forEach(function (values, k) {
                values.forEach(function (v) {
                    return paramsList.push(k + '=' + v);
                });
            });
            return paramsList.join('&');
        };
        URLSearchParams.prototype.delete = function (param) {
            this.paramsMap.delete(param);
        };
        return URLSearchParams;
    }();
    exports.URLSearchParams = URLSearchParams;
});
System.registerDynamic('angular2/http.js', ['angular2/core.js', 'angular2/src/http/http.js', 'angular2/src/http/backends/xhr_backend.js', 'angular2/src/http/backends/jsonp_backend.js', 'angular2/src/http/backends/browser_xhr.js', 'angular2/src/http/backends/browser_jsonp.js', 'angular2/src/http/base_request_options.js', 'angular2/src/http/base_response_options.js', 'angular2/src/http/static_request.js', 'angular2/src/http/static_response.js', 'angular2/src/http/interfaces.js', 'angular2/src/http/headers.js', 'angular2/src/http/enums.js', 'angular2/src/http/url_search_params.js'], true, function ($__require, exports, module) {
  'use strict';"use strict";
  /**
   * @module
   * @description
   * The http module provides services to perform http requests. To get started, see the {@link Http}
   * class.
   */

  var global = this || self,
      GLOBAL = global;
  var core_1 = $__require('angular2/core.js');
  var http_1 = $__require('angular2/src/http/http.js');
  var xhr_backend_1 = $__require('angular2/src/http/backends/xhr_backend.js');
  var jsonp_backend_1 = $__require('angular2/src/http/backends/jsonp_backend.js');
  var browser_xhr_1 = $__require('angular2/src/http/backends/browser_xhr.js');
  var browser_jsonp_1 = $__require('angular2/src/http/backends/browser_jsonp.js');
  var base_request_options_1 = $__require('angular2/src/http/base_request_options.js');
  var base_response_options_1 = $__require('angular2/src/http/base_response_options.js');
  var static_request_1 = $__require('angular2/src/http/static_request.js');
  exports.Request = static_request_1.Request;
  var static_response_1 = $__require('angular2/src/http/static_response.js');
  exports.Response = static_response_1.Response;
  var interfaces_1 = $__require('angular2/src/http/interfaces.js');
  exports.Connection = interfaces_1.Connection;
  exports.ConnectionBackend = interfaces_1.ConnectionBackend;
  var browser_xhr_2 = $__require('angular2/src/http/backends/browser_xhr.js');
  exports.BrowserXhr = browser_xhr_2.BrowserXhr;
  var base_request_options_2 = $__require('angular2/src/http/base_request_options.js');
  exports.BaseRequestOptions = base_request_options_2.BaseRequestOptions;
  exports.RequestOptions = base_request_options_2.RequestOptions;
  var base_response_options_2 = $__require('angular2/src/http/base_response_options.js');
  exports.BaseResponseOptions = base_response_options_2.BaseResponseOptions;
  exports.ResponseOptions = base_response_options_2.ResponseOptions;
  var xhr_backend_2 = $__require('angular2/src/http/backends/xhr_backend.js');
  exports.XHRBackend = xhr_backend_2.XHRBackend;
  exports.XHRConnection = xhr_backend_2.XHRConnection;
  var jsonp_backend_2 = $__require('angular2/src/http/backends/jsonp_backend.js');
  exports.JSONPBackend = jsonp_backend_2.JSONPBackend;
  exports.JSONPConnection = jsonp_backend_2.JSONPConnection;
  var http_2 = $__require('angular2/src/http/http.js');
  exports.Http = http_2.Http;
  exports.Jsonp = http_2.Jsonp;
  var headers_1 = $__require('angular2/src/http/headers.js');
  exports.Headers = headers_1.Headers;
  var enums_1 = $__require('angular2/src/http/enums.js');
  exports.ResponseType = enums_1.ResponseType;
  exports.ReadyState = enums_1.ReadyState;
  exports.RequestMethod = enums_1.RequestMethod;
  var url_search_params_1 = $__require('angular2/src/http/url_search_params.js');
  exports.URLSearchParams = url_search_params_1.URLSearchParams;
  /**
   * Provides a basic set of injectables to use the {@link Http} service in any application.
   *
   * The `HTTP_PROVIDERS` should be included either in a component's injector,
   * or in the root injector when bootstrapping an application.
   *
   * ### Example ([live demo](http://plnkr.co/edit/snj7Nv?p=preview))
   *
   * ```
   * import {Component} from 'angular2/core';
   * import {bootstrap} from 'angular2/platform/browser';
   * import {NgFor} from 'angular2/common';
   * import {HTTP_PROVIDERS, Http} from 'angular2/http';
   *
   * @Component({
   *   selector: 'app',
   *   providers: [HTTP_PROVIDERS],
   *   template: `
   *     <div>
   *       <h1>People</h1>
   *       <ul>
   *         <li *ngFor="#person of people">
   *           {{person.name}}
   *         </li>
   *       </ul>
   *     </div>
   *   `,
   *   directives: [NgFor]
   * })
   * export class App {
   *   people: Object[];
   *   constructor(http:Http) {
   *     http.get('people.json').subscribe(res => {
   *       this.people = res.json();
   *     });
   *   }
   *   active:boolean = false;
   *   toggleActiveState() {
   *     this.active = !this.active;
   *   }
   * }
   *
   * bootstrap(App)
   *   .catch(err => console.error(err));
   * ```
   *
   * The primary public API included in `HTTP_PROVIDERS` is the {@link Http} class.
   * However, other providers required by `Http` are included,
   * which may be beneficial to override in certain cases.
   *
   * The providers included in `HTTP_PROVIDERS` include:
   *  * {@link Http}
   *  * {@link XHRBackend}
   *  * `BrowserXHR` - Private factory to create `XMLHttpRequest` instances
   *  * {@link RequestOptions} - Bound to {@link BaseRequestOptions} class
   *  * {@link ResponseOptions} - Bound to {@link BaseResponseOptions} class
   *
   * There may be cases where it makes sense to extend the base request options,
   * such as to add a search string to be appended to all URLs.
   * To accomplish this, a new provider for {@link RequestOptions} should
   * be added in the same injector as `HTTP_PROVIDERS`.
   *
   * ### Example ([live demo](http://plnkr.co/edit/aCMEXi?p=preview))
   *
   * ```
   * import {provide} from 'angular2/core';
   * import {bootstrap} from 'angular2/platform/browser';
   * import {HTTP_PROVIDERS, BaseRequestOptions, RequestOptions} from 'angular2/http';
   *
   * class MyOptions extends BaseRequestOptions {
   *   search: string = 'coreTeam=true';
   * }
   *
   * bootstrap(App, [HTTP_PROVIDERS, provide(RequestOptions, {useClass: MyOptions})])
   *   .catch(err => console.error(err));
   * ```
   *
   * Likewise, to use a mock backend for unit tests, the {@link XHRBackend}
   * provider should be bound to {@link MockBackend}.
   *
   * ### Example ([live demo](http://plnkr.co/edit/7LWALD?p=preview))
   *
   * ```
   * import {provide} from 'angular2/core';
   * import {bootstrap} from 'angular2/platform/browser';
   * import {HTTP_PROVIDERS, Http, Response, XHRBackend} from 'angular2/http';
   * import {MockBackend} from 'angular2/http/testing';
   *
   * var people = [{name: 'Jeff'}, {name: 'Tobias'}];
   *
   * var injector = Injector.resolveAndCreate([
   *   HTTP_PROVIDERS,
   *   MockBackend,
   *   provide(XHRBackend, {useExisting: MockBackend})
   * ]);
   * var http = injector.get(Http);
   * var backend = injector.get(MockBackend);
   *
   * // Listen for any new requests
   * backend.connections.observer({
   *   next: connection => {
   *     var response = new Response({body: people});
   *     setTimeout(() => {
   *       // Send a response to the request
   *       connection.mockRespond(response);
   *     });
   *   }
   * });
   *
   * http.get('people.json').observer({
   *   next: res => {
   *     // Response came from mock backend
   *     console.log('first person', res.json()[0].name);
   *   }
   * });
   * ```
   */
  exports.HTTP_PROVIDERS = [
  // TODO(pascal): use factory type annotations once supported in DI
  // issue: https://github.com/angular/angular/issues/3183
  core_1.provide(http_1.Http, {
    useFactory: function (xhrBackend, requestOptions) {
      return new http_1.Http(xhrBackend, requestOptions);
    },
    deps: [xhr_backend_1.XHRBackend, base_request_options_1.RequestOptions]
  }), browser_xhr_1.BrowserXhr, core_1.provide(base_request_options_1.RequestOptions, { useClass: base_request_options_1.BaseRequestOptions }), core_1.provide(base_response_options_1.ResponseOptions, { useClass: base_response_options_1.BaseResponseOptions }), xhr_backend_1.XHRBackend];
  /**
   * See {@link HTTP_PROVIDERS} instead.
   *
   * @deprecated
   */
  exports.HTTP_BINDINGS = exports.HTTP_PROVIDERS;
  /**
   * Provides a basic set of providers to use the {@link Jsonp} service in any application.
   *
   * The `JSONP_PROVIDERS` should be included either in a component's injector,
   * or in the root injector when bootstrapping an application.
   *
   * ### Example ([live demo](http://plnkr.co/edit/vmeN4F?p=preview))
   *
   * ```
   * import {Component} from 'angular2/core';
   * import {NgFor} from 'angular2/common';
   * import {JSONP_PROVIDERS, Jsonp} from 'angular2/http';
   *
   * @Component({
   *   selector: 'app',
   *   providers: [JSONP_PROVIDERS],
   *   template: `
   *     <div>
   *       <h1>People</h1>
   *       <ul>
   *         <li *ngFor="#person of people">
   *           {{person.name}}
   *         </li>
   *       </ul>
   *     </div>
   *   `,
   *   directives: [NgFor]
   * })
   * export class App {
   *   people: Array<Object>;
   *   constructor(jsonp:Jsonp) {
   *     jsonp.request('people.json').subscribe(res => {
   *       this.people = res.json();
   *     })
   *   }
   * }
   * ```
   *
   * The primary public API included in `JSONP_PROVIDERS` is the {@link Jsonp} class.
   * However, other providers required by `Jsonp` are included,
   * which may be beneficial to override in certain cases.
   *
   * The providers included in `JSONP_PROVIDERS` include:
   *  * {@link Jsonp}
   *  * {@link JSONPBackend}
   *  * `BrowserJsonp` - Private factory
   *  * {@link RequestOptions} - Bound to {@link BaseRequestOptions} class
   *  * {@link ResponseOptions} - Bound to {@link BaseResponseOptions} class
   *
   * There may be cases where it makes sense to extend the base request options,
   * such as to add a search string to be appended to all URLs.
   * To accomplish this, a new provider for {@link RequestOptions} should
   * be added in the same injector as `JSONP_PROVIDERS`.
   *
   * ### Example ([live demo](http://plnkr.co/edit/TFug7x?p=preview))
   *
   * ```
   * import {provide} from 'angular2/core';
   * import {bootstrap} from 'angular2/platform/browser';
   * import {JSONP_PROVIDERS, BaseRequestOptions, RequestOptions} from 'angular2/http';
   *
   * class MyOptions extends BaseRequestOptions {
   *   search: string = 'coreTeam=true';
   * }
   *
   * bootstrap(App, [JSONP_PROVIDERS, provide(RequestOptions, {useClass: MyOptions})])
   *   .catch(err => console.error(err));
   * ```
   *
   * Likewise, to use a mock backend for unit tests, the {@link JSONPBackend}
   * provider should be bound to {@link MockBackend}.
   *
   * ### Example ([live demo](http://plnkr.co/edit/HDqZWL?p=preview))
   *
   * ```
   * import {provide, Injector} from 'angular2/core';
   * import {JSONP_PROVIDERS, Jsonp, Response, JSONPBackend} from 'angular2/http';
   * import {MockBackend} from 'angular2/http/testing';
   *
   * var people = [{name: 'Jeff'}, {name: 'Tobias'}];
   * var injector = Injector.resolveAndCreate([
   *   JSONP_PROVIDERS,
   *   MockBackend,
   *   provide(JSONPBackend, {useExisting: MockBackend})
   * ]);
   * var jsonp = injector.get(Jsonp);
   * var backend = injector.get(MockBackend);
   *
   * // Listen for any new requests
   * backend.connections.observer({
   *   next: connection => {
   *     var response = new Response({body: people});
   *     setTimeout(() => {
   *       // Send a response to the request
   *       connection.mockRespond(response);
   *     });
   *   }
   * });
  
   * jsonp.get('people.json').observer({
   *   next: res => {
   *     // Response came from mock backend
   *     console.log('first person', res.json()[0].name);
   *   }
   * });
   * ```
   */
  exports.JSONP_PROVIDERS = [
  // TODO(pascal): use factory type annotations once supported in DI
  // issue: https://github.com/angular/angular/issues/3183
  core_1.provide(http_1.Jsonp, {
    useFactory: function (jsonpBackend, requestOptions) {
      return new http_1.Jsonp(jsonpBackend, requestOptions);
    },
    deps: [jsonp_backend_1.JSONPBackend, base_request_options_1.RequestOptions]
  }), browser_jsonp_1.BrowserJsonp, core_1.provide(base_request_options_1.RequestOptions, { useClass: base_request_options_1.BaseRequestOptions }), core_1.provide(base_response_options_1.ResponseOptions, { useClass: base_response_options_1.BaseResponseOptions }), core_1.provide(jsonp_backend_1.JSONPBackend, { useClass: jsonp_backend_1.JSONPBackend_ })];
  /**
   * See {@link JSONP_PROVIDERS} instead.
   *
   * @deprecated
   */
  exports.JSON_BINDINGS = exports.JSONP_PROVIDERS;
});
System.register("ags-client/app/services/backend_service.js", ["angular2/core.js", "angular2/http.js", "ags-client/app/models/json_response.js", "rxjs/Observable.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, http_1, json_response_1, Observable_1, BackendService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (http_1_1) {
            http_1 = http_1_1;
        }, function (json_response_1_1) {
            json_response_1 = json_response_1_1;
        }, function (Observable_1_1) {
            Observable_1 = Observable_1_1;
        }],
        execute: function () {
            BackendService = /** @class */function () {
                function BackendService(_http) {
                    this._http = _http;
                }
                BackendService_1 = BackendService;
                BackendService.jsonRequestOptions = function () {
                    return {
                        headers: new http_1.Headers({
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'X-CSRF-TOKEN': BackendService_1.csrfToken
                        })
                    };
                };
                BackendService.prototype.getJson = function (url, deserializationCallback) {
                    var _this = this;
                    return new Observable_1.Observable(function (subscriber) {
                        _this._http.get(_this.serverApiBase + url, BackendService_1.jsonRequestOptions()).subscribe(function (response) {
                            subscriber.next(deserializationCallback(response.json()));
                            subscriber.complete();
                        }, function (error) {
                            if (error.status === 403) {
                                subscriber.next(json_response_1.JsonResponse.forbidden());
                            } else {
                                subscriber.next(json_response_1.JsonResponse.unknownError());
                            }
                            subscriber.complete();
                            console.log(error);
                        });
                    });
                };
                BackendService.prototype.postJson = function (url, data, deserializationCallback) {
                    var _this = this;
                    return new Observable_1.Observable(function (subscriber) {
                        _this._http.post(_this.serverApiBase + url, JSON.stringify(data), BackendService_1.jsonRequestOptions()).subscribe(function (response) {
                            subscriber.next(deserializationCallback(response.json()));
                            subscriber.complete();
                        }, function (error) {
                            if (error.status === 403) {
                                subscriber.next(json_response_1.JsonResponse.forbidden());
                            } else {
                                subscriber.next(json_response_1.JsonResponse.unknownError());
                            }
                            subscriber.complete();
                            console.log(error);
                        });
                    });
                };
                BackendService.prototype.uploadFile = function (url, file) {
                    var _this = this;
                    return new Observable_1.Observable(function (subscriber) {
                        var formData = new FormData();
                        formData.append('file', file, file.name);
                        var xhr = new XMLHttpRequest();
                        xhr.open('POST', _this.serverApiBase + url, true);
                        xhr.withCredentials = true;
                        xhr.setRequestHeader('X-CSRF-TOKEN', BackendService_1.csrfToken);
                        xhr.onload = function () {
                            if (xhr.status === 200) {
                                subscriber.next(json_response_1.JsonResponse.deserialize(JSON.parse(xhr.responseText)));
                            } else {
                                subscriber.next(json_response_1.JsonResponse.unknownError());
                            }
                            subscriber.complete();
                        };
                        xhr.send(formData);
                    });
                };
                var BackendService_1;
                BackendService = BackendService_1 = __decorate([core_1.Injectable(), core_1.Inject(http_1.Http), __metadata("design:paramtypes", [http_1.Http])], BackendService);
                return BackendService;
            }();
            exports_1("BackendService", BackendService);
        }
    };
});

System.register("ags-client/app/services/domain_service.js", ["angular2/core.js", "ags-client/gen/services/abstract_domain_service.js", "ags-client/app/services/backend_service.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, abstract_domain_service_1, backend_service_1, DomainService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (abstract_domain_service_1_1) {
            abstract_domain_service_1 = abstract_domain_service_1_1;
        }, function (backend_service_1_1) {
            backend_service_1 = backend_service_1_1;
        }],
        execute: function () {
            DomainService = /** @class */function (_super) {
                __extends(DomainService, _super);
                function DomainService(backendService) {
                    var _this = _super.call(this, backendService) || this;
                    DomainService_1._instance = _this;
                    return _this;
                }
                DomainService_1 = DomainService;
                Object.defineProperty(DomainService, "instance", {
                    get: function () {
                        return DomainService_1._instance;
                    },
                    enumerable: false,
                    configurable: true
                });
                var DomainService_1;
                DomainService = DomainService_1 = __decorate([core_1.Injectable(), core_1.Inject(backend_service_1.BackendService), __metadata("design:paramtypes", [backend_service_1.BackendService])], DomainService);
                return DomainService;
            }(abstract_domain_service_1.AbstractDomainService);
            exports_1("DomainService", DomainService);
        }
    };
});

/* tslint:disable */
System.register('ags-client/gen/i18n/translation_constants.js', [], function (exports_1, context_1) {
    "use strict";

    var TranslationConstants;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [],
        execute: function () {
            /* tslint:disable */
            TranslationConstants = /** @class */function () {
                function TranslationConstants() {}
                TranslationConstants.CODE_CODE_EXISTS = 'code:code_exists';
                TranslationConstants.ATTACHMENTS_MESSAGE = 'attachments:message';
                TranslationConstants.MAIL_ACCOUNT_ALREADY_REGISTERED = 'mail:account_already_registered';
                TranslationConstants.MAIL_ACCOUNT_CONFIRMATION = 'mail:account_confirmation';
                TranslationConstants.MAIL_NEW_PASSWORD = 'mail:new_password';
                TranslationConstants.MAIL_PASSWORD_REQUEST = 'mail:password_request';
                TranslationConstants.LOST_PASSWORD_TITLE = 'lost_password:title';
                TranslationConstants.LOST_PASSWORD_EMAIL = 'lost_password:email';
                TranslationConstants.LOST_PASSWORD_DESCRIPTION = 'lost_password:description';
                TranslationConstants.LOST_PASSWORD_CAPTCHA = 'lost_password:captcha';
                TranslationConstants.LOST_PASSWORD_SUCCESS_MESSAGE = 'lost_password:success_message';
                TranslationConstants.CONFIRMATION_DELETE_MESSAGE = 'confirmation:delete_message';
                TranslationConstants.CONFIRMATION_CANCEL_MESSAGE = 'confirmation:cancel_message';
                TranslationConstants.ERROR_FORBIDDEN = 'error:forbidden';
                TranslationConstants.ERROR_NOTFOUND = 'error:notfound';
                TranslationConstants.ERROR_INVALID_ACTIVATION_CODE = 'error:invalid_activation_code';
                TranslationConstants.ERROR_UNKNOWN = 'error:unknown';
                TranslationConstants.ERROR_FILE_TOO_LARGE = 'error:file_too_large';
                TranslationConstants.ERROR_MALWARE_FOUND = 'error:malware_found';
                TranslationConstants.ERROR_TOO_MANY_FILES = 'error:too_many_files';
                TranslationConstants.ERROR_UNSUPPORTED_MIMETYPE = 'error:unsupported_mimetype';
                TranslationConstants.LOGIN_DISABLED = 'login:disabled';
                TranslationConstants.LOGIN_ERROR = 'login:error';
                TranslationConstants.LOGIN_EXPIRED = 'login:expired';
                TranslationConstants.LOGIN_REGISTER = 'login:register';
                TranslationConstants.LOGIN_LOST_PASSWORD = 'login:lost_password';
                TranslationConstants.LOGIN_HELP = 'login:help';
                TranslationConstants.MENU_ACCOUNT = 'menu:account';
                TranslationConstants.MENU_LOGOUT = 'menu:logout';
                TranslationConstants.COMMONS_VALID_FROM = 'commons:valid_from';
                TranslationConstants.COMMONS_VALID_TO = 'commons:valid_to';
                TranslationConstants.COMMONS_YES = 'commons:yes';
                TranslationConstants.COMMONS_NO = 'commons:no';
                TranslationConstants.COMMONS_BACK = 'commons:back';
                TranslationConstants.COMMONS_DEFINITION = 'commons:definition';
                TranslationConstants.COMMONS_SEARCH = 'commons:search';
                TranslationConstants.COMMONS_EXTENDED_SEARCH = 'commons:extended_search';
                TranslationConstants.COMMONS_REFERENCE_DATE = 'commons:reference_date';
                TranslationConstants.COMMONS_PRINT = 'commons:print';
                TranslationConstants.COMMONS_RESET = 'commons:reset';
                TranslationConstants.COMMONS_REFRESH = 'commons:refresh';
                TranslationConstants.COMMONS_ATTACHMENTS = 'commons:attachments';
                TranslationConstants.COMMONS_ATTACHMENTS_INFO = 'commons:attachments_info';
                TranslationConstants.COMMONS_DELETED = 'commons:deleted';
                TranslationConstants.CHANGE_PASSWORD_OLD_PASSWORD = 'change_password:old_password';
                TranslationConstants.CHANGE_PASSWORD_PASSWORD_REPEAT = 'change_password:password_repeat';
                TranslationConstants.CHANGE_PASSWORD_DESCRIPTION = 'change_password:description';
                TranslationConstants.CHANGE_PASSWORD_NEW_PASSWORD = 'change_password:new_password';
                TranslationConstants.CHANGE_PASSWORD_ERROR_WRONG_PASSWORD = 'change_password:error_wrong_password';
                TranslationConstants.CHANGE_PASSWORD_ERROR_PASSWORD_REUSE = 'change_password:error_password_reuse';
                TranslationConstants.CHANGE_PASSWORD_TITLE = 'change_password:title';
                TranslationConstants.BUTTON_ACCEPT = 'button:accept';
                TranslationConstants.BUTTON_ADD = 'button:add';
                TranslationConstants.BUTTON_ADD_FILE = 'button:add_file';
                TranslationConstants.BUTTON_BACK = 'button:back';
                TranslationConstants.BUTTON_CALC = 'button:calc';
                TranslationConstants.BUTTON_CANCEL = 'button:cancel';
                TranslationConstants.BUTTON_CLOSE = 'button:close';
                TranslationConstants.BUTTON_DELETE = 'button:delete';
                TranslationConstants.BUTTON_DETAILS_OFF = 'button:details_off';
                TranslationConstants.BUTTON_DETAILS_ON = 'button:details_on';
                TranslationConstants.BUTTON_EDIT = 'button:edit';
                TranslationConstants.BUTTON_DISPLAY = 'button:display';
                TranslationConstants.BUTTON_HELP = 'button:help';
                TranslationConstants.BUTTON_LOGOUT = 'button:logout';
                TranslationConstants.BUTTON_NEXT = 'button:next';
                TranslationConstants.BUTTON_PRINT = 'button:print';
                TranslationConstants.BUTTON_SAVE = 'button:save';
                TranslationConstants.BUTTON_SEARCH = 'button:search';
                TranslationConstants.BUTTON_SEND = 'button:send';
                TranslationConstants.BUTTON_STATUS = 'button:status';
                TranslationConstants.BUTTON_LOGIN = 'button:login';
                TranslationConstants.BUTTON_CALCULATE = 'button:calculate';
                TranslationConstants.BUTTON_CREATE = 'button:create';
                TranslationConstants.BUTTON_REQUEST = 'button:request';
                TranslationConstants.BUTTON_GENERATE = 'button:generate';
                TranslationConstants.BUTTON_RESET = 'button:reset';
                TranslationConstants.BUTTON_IMPORT = 'button:import';
                TranslationConstants.FILEUPLOAD_MESSAGE = 'fileupload:message';
                TranslationConstants.SEARCH_NO_RESULT = 'search:no_result';
                TranslationConstants.MULTI_SELECT_UNSELECTED = 'multi_select:unselected';
                TranslationConstants.MULTI_SELECT_SELECTED = 'multi_select:selected';
                TranslationConstants.MULTI_SELECT_UNSELECT_ALL = 'multi_select:unselect_all';
                TranslationConstants.MULTI_SELECT_SELECT_ALL = 'multi_select:select_all';
                TranslationConstants.MULTI_SELECT_ALL = 'multi_select:all';
                TranslationConstants.MULTI_SELECT_NONE = 'multi_select:none';
                TranslationConstants.MULTI_SELECT_CLOSE = 'multi_select:close';
                TranslationConstants.MULTI_SELECT_PLACEHOLDER = 'multi_select:placeholder';
                TranslationConstants.MULTI_SELECT_STORED = 'multi_select:stored';
                TranslationConstants.FILE_SIZE = 'file:size';
                TranslationConstants.FILE_TYPE = 'file:type';
                TranslationConstants.FILE_CREATED = 'file:created';
                TranslationConstants.CAPTCHA_INVALID = 'captcha:invalid';
                TranslationConstants.CAPTCHA_DESCRIPTION = 'captcha:description';
                TranslationConstants.DOMAIN_DOMAIN_EXISTS = 'domain:domain_exists';
                TranslationConstants.VALIDATION_ERRORS_REQUIRED = 'validation_errors:required';
                TranslationConstants.VALIDATION_ERRORS_PASSWORD = 'validation_errors:password';
                TranslationConstants.VALIDATION_ERRORS_PASSWORD_REPEAT = 'validation_errors:password_repeat';
                TranslationConstants.VALIDATION_ERRORS_SAME_PASSWORD = 'validation_errors:same_password';
                TranslationConstants.VALIDATION_ERRORS_EMAIL_DOMAIN = 'validation_errors:email_domain';
                TranslationConstants.VALIDATION_ERRORS_EMAIL = 'validation_errors:email';
                TranslationConstants.VALIDATION_ERRORS_DOMAIN = 'validation_errors:domain';
                TranslationConstants.VALIDATION_ERRORS_DATE = 'validation_errors:date';
                TranslationConstants.VALIDATION_ERRORS_ISIN = 'validation_errors:isin';
                TranslationConstants.VALIDATION_ERRORS_VALOR = 'validation_errors:valor';
                TranslationConstants.VALIDATION_ERRORS_FILE_SIZE = 'validation_errors:file_size';
                TranslationConstants.VALIDATION_ERRORS_MINLENGTH = 'validation_errors:minlength';
                TranslationConstants.VALIDATION_ERRORS_MAXLENGTH = 'validation_errors:maxlength';
                TranslationConstants.REGISTRATION_ACCOUNT_CREATED = 'registration:account_created';
                TranslationConstants.REGISTRATION_CAPTCHA = 'registration:captcha';
                TranslationConstants.REGISTRATION_CITY = 'registration:city';
                TranslationConstants.REGISTRATION_COUNTRY = 'registration:country';
                TranslationConstants.REGISTRATION_DOMAIN_NOT_ALLOWED = 'registration:domain_not_allowed';
                TranslationConstants.REGISTRATION_EMAIL = 'registration:email';
                TranslationConstants.REGISTRATION_ERROR_MAIL_EXISTS = 'registration:error_mail_exists';
                TranslationConstants.REGISTRATION_FIRSTNAME = 'registration:firstname';
                TranslationConstants.REGISTRATION_INSTITUTION = 'registration:institution';
                TranslationConstants.REGISTRATION_LANGUAGE = 'registration:language';
                TranslationConstants.REGISTRATION_LASTNAME = 'registration:lastname';
                TranslationConstants.REGISTRATION_MAIL_DESCRIPTION = 'registration:mail_description';
                TranslationConstants.REGISTRATION_PASSWORD = 'registration:password';
                TranslationConstants.REGISTRATION_PASSWORD_REPEAT = 'registration:password_repeat';
                TranslationConstants.REGISTRATION_PHONE = 'registration:phone';
                TranslationConstants.REGISTRATION_SALUTATION = 'registration:salutation';
                TranslationConstants.REGISTRATION_ACCOUNT_ACTIVATED = 'registration:account_activated';
                TranslationConstants.REGISTRATION_MOBILE = 'registration:mobile';
                TranslationConstants.USER_NOT_FOUND = 'user:not_found';
                TranslationConstants.USER_DOMAIN_UNKNOWN = 'user:domain_unknown';
                TranslationConstants.USER_DUPLICATE_EMAIL = 'user:duplicate_email';
                TranslationConstants.USER_DUPLICATE_LOGIN_NAME = 'user:duplicate_login_name';
                TranslationConstants.USER_NEW_PASSWORD = 'user:new_password';
                TranslationConstants.USER_PASSWORD_REPEAT = 'user:password_repeat';
                TranslationConstants.USER_PASSWORD_HASH = 'user:password_hash';
                TranslationConstants.ACCOUNT_PASSWORD_ERROR = 'account:password_error';
                TranslationConstants.ACCOUNT_TITLE = 'account:title';
                TranslationConstants.ACCOUNT_CITY = 'account:city';
                TranslationConstants.ACCOUNT_CONTACT_TITLE = 'account:contact_title';
                TranslationConstants.ACCOUNT_COUNTRY = 'account:country';
                TranslationConstants.ACCOUNT_EMAIL = 'account:email';
                TranslationConstants.ACCOUNT_FAX = 'account:fax';
                TranslationConstants.ACCOUNT_FIRST_NAME = 'account:first_name';
                TranslationConstants.ACCOUNT_INSTITUTION = 'account:institution';
                TranslationConstants.ACCOUNT_LANGUAGE = 'account:language';
                TranslationConstants.ACCOUNT_LAST_NAME = 'account:last_name';
                TranslationConstants.ACCOUNT_NEWSLETTER = 'account:newsletter';
                TranslationConstants.ACCOUNT_PHONE = 'account:phone';
                TranslationConstants.ACCOUNT_RECEIVE_EMAIL = 'account:receive_email';
                TranslationConstants.ACCOUNT_RECEIVE_EMAIL_NO_PUBLICATION = 'account:receive_email_no_publication';
                TranslationConstants.ACCOUNT_SALUTATION = 'account:salutation';
                TranslationConstants.ACCOUNT_STREET = 'account:street';
                TranslationConstants.ACCOUNT_USER_TITLE = 'account:user_title';
                TranslationConstants.ACCOUNT_ZIP = 'account:zip';
                TranslationConstants.ACCOUNT_MOBILE = 'account:mobile';
                TranslationConstants.REGISTER_TITLE = 'register:title';
                TranslationConstants.INFO_SAVED = 'info:saved';
                TranslationConstants.AUTHENTICATION_TITLE = 'authentication:title';
                TranslationConstants.AUTHENTICATION_SESSION_EXPIRED = 'authentication:session_expired';
                TranslationConstants.AUTHENTICATION_PASSWORD = 'authentication:password';
                TranslationConstants.AUTHENTICATION_CAPTCHA = 'authentication:captcha';
                TranslationConstants.AUTHENTICATION_LOGIN = 'authentication:login';
                return TranslationConstants;
            }();
            exports_1("TranslationConstants", TranslationConstants);
        }
    };
});

System.register("ags-client/app/models/json_response.js", ["ags-client/gen/i18n/translation_constants.js", "ags-client/app/commons.js"], function (exports_1, context_1) {
    "use strict";

    var translation_constants_1, commons_1, JsonResponseStatus, JsonResponseList, JsonResponse;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (translation_constants_1_1) {
            translation_constants_1 = translation_constants_1_1;
        }, function (commons_1_1) {
            commons_1 = commons_1_1;
        }],
        execute: function () {
            (function (JsonResponseStatus) {
                JsonResponseStatus[JsonResponseStatus["SUCCESS"] = 0] = "SUCCESS";
                JsonResponseStatus[JsonResponseStatus["FORBIDDEN"] = 1] = "FORBIDDEN";
                JsonResponseStatus[JsonResponseStatus["ERROR"] = 2] = "ERROR";
                JsonResponseStatus[JsonResponseStatus["NOT_FOUND"] = 3] = "NOT_FOUND";
            })(JsonResponseStatus || exports_1("JsonResponseStatus", JsonResponseStatus = {}));
            JsonResponseList = /** @class */function () {
                function JsonResponseList() {
                    this.responses = new Array();
                }
                return JsonResponseList;
            }();
            exports_1("JsonResponseList", JsonResponseList);
            JsonResponse = /** @class */function () {
                function JsonResponse() {}
                JsonResponse.prototype.isSuccess = function () {
                    return this.status === JsonResponseStatus.SUCCESS;
                };
                JsonResponse.prototype.isForbidden = function () {
                    return this.status === JsonResponseStatus.FORBIDDEN;
                };
                JsonResponse.prototype.isError = function () {
                    return this.status === JsonResponseStatus.ERROR;
                };
                JsonResponse.unknownError = function () {
                    var response = new JsonResponse();
                    response.status = JsonResponseStatus.ERROR;
                    response.error = translation_constants_1.TranslationConstants.ERROR_UNKNOWN;
                    return response;
                };
                JsonResponse.forbidden = function () {
                    var response = new JsonResponse();
                    response.status = JsonResponseStatus.FORBIDDEN;
                    response.error = translation_constants_1.TranslationConstants.ERROR_FORBIDDEN;
                    return response;
                };
                JsonResponse.success = function (data) {
                    var response = new JsonResponse();
                    response.status = JsonResponseStatus.SUCCESS;
                    response.data = data;
                    return response;
                };
                JsonResponse.deserialize = function (object, data) {
                    var result = new JsonResponse();
                    result.data = data;
                    result.error = object.error;
                    result.status = commons_1.enumNumberValue(JsonResponseStatus, object.status);
                    result.totalItems = object.totalItems;
                    return result;
                };
                return JsonResponse;
            }();
            exports_1("JsonResponse", JsonResponse);
        }
    };
});

/// <reference types="sugar"/>
System.register("ags-client/app/validators.js", ["angular2/common.js", "ags-client/app/commons.js", "ags-client/app/constants.js", "ags-client/app/commons/lang.js", "ags-client/app/services/domain_service.js", "ags-client/app/models/json_response.js"], function (exports_1, context_1) {
    "use strict";

    var common_1, commons_1, Constants, lang_1, domain_service_1, json_response_1;
    var __moduleName = context_1 && context_1.id;
    function validateRegex(regex, value) {
        return new RegExp(regex).exec(value) != null;
    }
    function validators(validators) {
        return common_1.Validators.compose(validators);
    }
    exports_1("validators", validators);
    function required() {
        return function (control) {
            if (commons_1.isBlank(control.value)) {
                return { 'required': true };
            } else if (commons_1.isString(control.value) && control.value.trim() === '') {
                return { 'required': true };
            }
            return null;
        };
    }
    exports_1("required", required);
    function isValidEmail(value) {
        if (validateRegex(Constants.EMAIL_REGEX, value)) {
            return value.split('@')[1].split('.').length > 1;
        }
        return false;
    }
    exports_1("isValidEmail", isValidEmail);
    function email() {
        return function (control) {
            if (!commons_1.isBlank(control.value)) {
                var mails = control.value.split(';');
                for (var i = 0; i < mails.length; i++) {
                    if (!isValidEmail(mails[i])) {
                        return { 'email': { 'actual': control.value } };
                    }
                }
            }
            return null;
        };
    }
    exports_1("email", email);
    function isValidDomain(value) {
        return validateRegex(Constants.DOMAIN_REGEX, value);
    }
    exports_1("isValidDomain", isValidDomain);
    function domain() {
        return function (control) {
            if (!commons_1.isBlank(control.value)) {
                if (!isValidDomain(control.value)) {
                    return { 'domain': { 'actual': control.value } };
                }
            }
            return null;
        };
    }
    exports_1("domain", domain);
    function emailDomain() {
        return function (control) {
            var q = new Promise(function (resolve) {
                if (!commons_1.isBlank(control.value) && isValidEmail(control.value)) {
                    var domainString = control.value.split('@')[1];
                    domain_service_1.DomainService.instance.domain(domainString).subscribe(function (response) {
                        if (response.status === json_response_1.JsonResponseStatus.SUCCESS && response.data.active) {
                            resolve(null);
                        } else {
                            resolve({ 'email_domain': true });
                        }
                    });
                } else {
                    resolve(null);
                }
            });
            return q;
        };
    }
    exports_1("emailDomain", emailDomain);
    function getVerificationCode(isinPrefix) {
        if (isinPrefix.length !== 11) {
            return -1;
        }
        var v = [];
        for (var i = isinPrefix.length - 1; i >= 0; i--) {
            var c = isinPrefix.charAt(i);
            if (c < '0' || c > '9') {
                var letterCode = isinPrefix.charCodeAt(i) - 55;
                v.push(letterCode % 10);
                if (letterCode > 9) {
                    v.push(Math.floor(letterCode / 10));
                }
            } else {
                v.push(Number(c));
            }
        }
        var sum = 0;
        var l = v.length;
        for (var j = 0; j < l; j++) {
            if (j % 2 === 0) {
                var d = v[j] * 2;
                sum += Math.floor(d / 10);
                sum += d % 10;
            } else {
                sum += v[j];
            }
        }
        return (10 - sum % 10) % 10;
    }
    exports_1("getVerificationCode", getVerificationCode);
    function isValidIsin(isin) {
        // basic pattern
        var regex = new RegExp(Constants.ISIN_REGEX);
        var match = regex.exec(isin);
        if (!commons_1.isPresent(match) || match.length !== 4) {
            return false;
        }
        // validate the check digit
        return parseInt(match[3]) === getVerificationCode(match[1] + match[2]);
    }
    exports_1("isValidIsin", isValidIsin);
    function isValidIsin2(value) {
        return validateRegex(Constants.ISIN_REGEX, value);
    }
    exports_1("isValidIsin2", isValidIsin2);
    function isValidValor(value) {
        return value > 0 && value.toString().length < 14;
    }
    exports_1("isValidValor", isValidValor);
    function isin() {
        return function (control) {
            if (lang_1.isSomething(control.value)) {
                if (control.value.length === 12) {
                    if (!isValidIsin(control.value)) {
                        return { 'isin': { 'actual': control.value } };
                    }
                } else if (control.value.length > 12) {
                    return { 'isin': { 'actual': control.value } };
                }
            }
            return null;
        };
    }
    exports_1("isin", isin);
    function vn() {
        return function (control) {
            var valor = control.value;
            if (commons_1.isString(valor) && valor.length > 0) {
                valor = parseInt(valor);
            } else if (commons_1.isString(valor)) {
                valor = null;
            }
            if (commons_1.isPresent(valor)) {
                if (!isValidValor(control.value)) {
                    return { 'valor': { 'actual': control.value } };
                }
            }
            return null;
        };
    }
    exports_1("vn", vn);
    function isValidDate(value) {
        if (value != null && commons_1.isString(value) && value.length === 10) {
            var date = commons_1.parseDate(value);
            if (date) {
                return commons_1.formatDate(date) === value;
            }
            return false;
        }
        return true;
    }
    exports_1("isValidDate", isValidDate);
    function date() {
        return function (control) {
            if (commons_1.isPresent(control.value)) {
                if (commons_1.isDate(control.value)) {
                    var date = control.value;
                    if (!date.isValid()) {
                        return { 'date': true };
                    }
                }
            }
            return null;
        };
    }
    exports_1("date", date);
    function dateTime() {
        return date();
    }
    exports_1("dateTime", dateTime);
    function min(min) {
        return function (control) {
            if (commons_1.isPresent(control.value)) {
                if (commons_1.isString(control.value)) {
                    var minLength = parseInt(min);
                    var vs = control.value;
                    if (vs.length < minLength) {
                        return { 'min_length': { 'required': minLength, 'actual': vs.length } };
                    }
                } else if (commons_1.isNumber(control.value)) {
                    var minNumber = parseFloat(min);
                    var vn = control.value;
                    if (vn < minNumber) {
                        return { 'min_number': { 'required': minNumber, 'actual': vn } };
                    }
                } else if (commons_1.isDate(control.value)) {
                    var minDate = commons_1.parseDate(min);
                    var vd = control.value;
                    if (vd.isBefore(minDate)) {
                        return { 'min_date': { 'required': minDate, 'actual': vd } };
                    }
                }
            }
            return null;
        };
    }
    exports_1("min", min);
    function max(max) {
        return function (control) {
            if (commons_1.isPresent(control.value)) {
                if (commons_1.isString(control.value)) {
                    var vs = control.value;
                    if (vs.length > max) {
                        return { 'max_length': { 'required': max, 'actual': vs.length } };
                    }
                } else if (commons_1.isNumber(control.value)) {
                    var vn = control.value;
                    if (vn > max) {
                        return { 'max_number': { 'required': max, 'actual': vn } };
                    }
                } else if (commons_1.isDate(control.value)) {
                    var maxDate = commons_1.isDate(max) ? max : commons_1.parseDate(max);
                    var vd = control.value;
                    if (vd.isAfter(maxDate)) {
                        return { 'max_date': { 'required': commons_1.formatDate(maxDate), 'actual': vd } };
                    }
                }
            }
            return null;
        };
    }
    exports_1("max", max);
    function year() {
        return function (control) {
            if (commons_1.isPresent(control.value)) {
                if (control.value < 1900 || control.value > 9999) {
                    return { 'year': true };
                }
            }
            return null;
        };
    }
    exports_1("year", year);
    function digits(integer, fraction) {
        return function (control) {
            if (commons_1.isPresent(control.value)) {
                var strValue = control.value.toString();
                var _integer = 0;
                var _fraction = 0;
                if (strValue.indexOf('.') >= 0) {
                    _integer = strValue.split('.')[0].length;
                    _fraction = strValue.split('.')[1].length;
                } else {
                    _integer = strValue.length;
                }
                if (_integer > integer || _fraction > fraction) {
                    return { 'digits': { 'required': { integer: integer, fraction: fraction }, 'actual': control.value } };
                }
            }
            return null;
        };
    }
    exports_1("digits", digits);
    function password() {
        return function (control) {
            if (lang_1.isSomething(control.value)) {
                var password = control.value;
                if (password.length < Constants.MIN_PASSWORD_LEN || !password.match(/[a-zA-Z]/) || !password.match(/[0-9]/) || !password.match(/[$@#ç%&§+*"()_=?!\.]/)) {
                    return { 'password': true };
                }
            }
            return null;
        };
    }
    exports_1("password", password);
    // fake implementation in order to avoid compile errors.
    function gk() {
        return null;
    }
    exports_1("gk", gk);
    return {
        setters: [function (common_1_1) {
            common_1 = common_1_1;
        }, function (commons_1_1) {
            commons_1 = commons_1_1;
        }, function (Constants_1) {
            Constants = Constants_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }, function (domain_service_1_1) {
            domain_service_1 = domain_service_1_1;
        }, function (json_response_1_1) {
            json_response_1 = json_response_1_1;
        }],
        execute: function () {/// <reference types="sugar"/>
        }
    };
});

System.register("ags-client/app/commons/page_flow.js", [], function (exports_1, context_1) {
    "use strict";

    var _this, PAGE_FLOW, PageFlow;
    _this = this;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [],
        execute: function () {
            PAGE_FLOW = {};
            exports_1("PageFlow", PageFlow = function (key) {
                return function (target, propertyKey) {
                    var pageFlowKey = key + ':' + propertyKey;
                    var value = _this[propertyKey];
                    if (!value && PAGE_FLOW[pageFlowKey]) {
                        value = PAGE_FLOW[pageFlowKey];
                    }
                    var getter = function () {
                        return value;
                    };
                    var setter = function (newValue) {
                        PAGE_FLOW[pageFlowKey] = newValue;
                        value = newValue;
                    };
                    if (delete _this[propertyKey]) {
                        Object.defineProperty(target, propertyKey, {
                            get: getter,
                            set: setter,
                            enumerable: true,
                            configurable: true
                        });
                    }
                };
            });
        }
    };
});

System.registerDynamic('bowser/bowser.js', [], true, function ($__require, exports, module) {
  var global = this || self,
      GLOBAL = global;
  /*!
   * Bowser - a browser detector
   * https://github.com/ded/bowser
   * MIT License | (c) Dustin Diaz 2015
   */

  !function (root, name, definition) {
    if (typeof module != 'undefined' && module.exports) module.exports = definition();else if (typeof undefined == 'function' && define.amd) define(name, definition);else root[name] = definition();
  }(this, 'bowser', function () {
    /**
      * See useragents.js for examples of navigator.userAgent
      */

    var t = true;

    function detect(ua) {

      function getFirstMatch(regex) {
        var match = ua.match(regex);
        return match && match.length > 1 && match[1] || '';
      }

      function getSecondMatch(regex) {
        var match = ua.match(regex);
        return match && match.length > 1 && match[2] || '';
      }

      var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase(),
          likeAndroid = /like android/i.test(ua),
          android = !likeAndroid && /android/i.test(ua),
          nexusMobile = /nexus\s*[0-6]\s*/i.test(ua),
          nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua),
          chromeos = /CrOS/.test(ua),
          silk = /silk/i.test(ua),
          sailfish = /sailfish/i.test(ua),
          tizen = /tizen/i.test(ua),
          webos = /(web|hpw)(o|0)s/i.test(ua),
          windowsphone = /windows phone/i.test(ua),
          samsungBrowser = /SamsungBrowser/i.test(ua),
          windows = !windowsphone && /windows/i.test(ua),
          mac = !iosdevice && !silk && /macintosh/i.test(ua),
          linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua),
          edgeVersion = getSecondMatch(/edg([ea]|ios)\/(\d+(\.\d+)?)/i),
          versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i),
          tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua),
          mobile = !tablet && /[^-]mobi/i.test(ua),
          xbox = /xbox/i.test(ua),
          result;

      if (/opera/i.test(ua)) {
        //  an old Opera
        result = {
          name: 'Opera',
          opera: t,
          version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
        };
      } else if (/opr\/|opios/i.test(ua)) {
        // a new Opera
        result = {
          name: 'Opera',
          opera: t,
          version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
        };
      } else if (/SamsungBrowser/i.test(ua)) {
        result = {
          name: 'Samsung Internet for Android',
          samsungBrowser: t,
          version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
        };
      } else if (/Whale/i.test(ua)) {
        result = {
          name: 'NAVER Whale browser',
          whale: t,
          version: getFirstMatch(/(?:whale)[\s\/](\d+(?:\.\d+)+)/i)
        };
      } else if (/MZBrowser/i.test(ua)) {
        result = {
          name: 'MZ Browser',
          mzbrowser: t,
          version: getFirstMatch(/(?:MZBrowser)[\s\/](\d+(?:\.\d+)+)/i)
        };
      } else if (/coast/i.test(ua)) {
        result = {
          name: 'Opera Coast',
          coast: t,
          version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
        };
      } else if (/focus/i.test(ua)) {
        result = {
          name: 'Focus',
          focus: t,
          version: getFirstMatch(/(?:focus)[\s\/](\d+(?:\.\d+)+)/i)
        };
      } else if (/yabrowser/i.test(ua)) {
        result = {
          name: 'Yandex Browser',
          yandexbrowser: t,
          version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
        };
      } else if (/ucbrowser/i.test(ua)) {
        result = {
          name: 'UC Browser',
          ucbrowser: t,
          version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
        };
      } else if (/mxios/i.test(ua)) {
        result = {
          name: 'Maxthon',
          maxthon: t,
          version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
        };
      } else if (/epiphany/i.test(ua)) {
        result = {
          name: 'Epiphany',
          epiphany: t,
          version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
        };
      } else if (/puffin/i.test(ua)) {
        result = {
          name: 'Puffin',
          puffin: t,
          version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
        };
      } else if (/sleipnir/i.test(ua)) {
        result = {
          name: 'Sleipnir',
          sleipnir: t,
          version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
        };
      } else if (/k-meleon/i.test(ua)) {
        result = {
          name: 'K-Meleon',
          kMeleon: t,
          version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
        };
      } else if (windowsphone) {
        result = {
          name: 'Windows Phone',
          osname: 'Windows Phone',
          windowsphone: t
        };
        if (edgeVersion) {
          result.msedge = t;
          result.version = edgeVersion;
        } else {
          result.msie = t;
          result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i);
        }
      } else if (/msie|trident/i.test(ua)) {
        result = {
          name: 'Internet Explorer',
          msie: t,
          version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
        };
      } else if (chromeos) {
        result = {
          name: 'Chrome',
          osname: 'Chrome OS',
          chromeos: t,
          chromeBook: t,
          chrome: t,
          version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
        };
      } else if (/edg([ea]|ios)/i.test(ua)) {
        result = {
          name: 'Microsoft Edge',
          msedge: t,
          version: edgeVersion
        };
      } else if (/vivaldi/i.test(ua)) {
        result = {
          name: 'Vivaldi',
          vivaldi: t,
          version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
        };
      } else if (sailfish) {
        result = {
          name: 'Sailfish',
          osname: 'Sailfish OS',
          sailfish: t,
          version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
        };
      } else if (/seamonkey\//i.test(ua)) {
        result = {
          name: 'SeaMonkey',
          seamonkey: t,
          version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
        };
      } else if (/firefox|iceweasel|fxios/i.test(ua)) {
        result = {
          name: 'Firefox',
          firefox: t,
          version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
        };
        if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
          result.firefoxos = t;
          result.osname = 'Firefox OS';
        }
      } else if (silk) {
        result = {
          name: 'Amazon Silk',
          silk: t,
          version: getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
        };
      } else if (/phantom/i.test(ua)) {
        result = {
          name: 'PhantomJS',
          phantom: t,
          version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
        };
      } else if (/slimerjs/i.test(ua)) {
        result = {
          name: 'SlimerJS',
          slimer: t,
          version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
        };
      } else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
        result = {
          name: 'BlackBerry',
          osname: 'BlackBerry OS',
          blackberry: t,
          version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
        };
      } else if (webos) {
        result = {
          name: 'WebOS',
          osname: 'WebOS',
          webos: t,
          version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
        };
        /touchpad\//i.test(ua) && (result.touchpad = t);
      } else if (/bada/i.test(ua)) {
        result = {
          name: 'Bada',
          osname: 'Bada',
          bada: t,
          version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
        };
      } else if (tizen) {
        result = {
          name: 'Tizen',
          osname: 'Tizen',
          tizen: t,
          version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
        };
      } else if (/qupzilla/i.test(ua)) {
        result = {
          name: 'QupZilla',
          qupzilla: t,
          version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
        };
      } else if (/chromium/i.test(ua)) {
        result = {
          name: 'Chromium',
          chromium: t,
          version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
        };
      } else if (/chrome|crios|crmo/i.test(ua)) {
        result = {
          name: 'Chrome',
          chrome: t,
          version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
        };
      } else if (android) {
        result = {
          name: 'Android',
          version: versionIdentifier
        };
      } else if (/safari|applewebkit/i.test(ua)) {
        result = {
          name: 'Safari',
          safari: t
        };
        if (versionIdentifier) {
          result.version = versionIdentifier;
        }
      } else if (iosdevice) {
        result = {
          name: iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
          // WTF: version is not part of user agent in web apps
        };if (versionIdentifier) {
          result.version = versionIdentifier;
        }
      } else if (/googlebot/i.test(ua)) {
        result = {
          name: 'Googlebot',
          googlebot: t,
          version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
        };
      } else {
        result = {
          name: getFirstMatch(/^(.*)\/(.*) /),
          version: getSecondMatch(/^(.*)\/(.*) /)
        };
      }

      // set webkit or gecko flag for browsers based on these engines
      if (!result.msedge && /(apple)?webkit/i.test(ua)) {
        if (/(apple)?webkit\/537\.36/i.test(ua)) {
          result.name = result.name || "Blink";
          result.blink = t;
        } else {
          result.name = result.name || "Webkit";
          result.webkit = t;
        }
        if (!result.version && versionIdentifier) {
          result.version = versionIdentifier;
        }
      } else if (!result.opera && /gecko\//i.test(ua)) {
        result.name = result.name || "Gecko";
        result.gecko = t;
        result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i);
      }

      // set OS flags for platforms that have multiple browsers
      if (!result.windowsphone && (android || result.silk)) {
        result.android = t;
        result.osname = 'Android';
      } else if (!result.windowsphone && iosdevice) {
        result[iosdevice] = t;
        result.ios = t;
        result.osname = 'iOS';
      } else if (mac) {
        result.mac = t;
        result.osname = 'macOS';
      } else if (xbox) {
        result.xbox = t;
        result.osname = 'Xbox';
      } else if (windows) {
        result.windows = t;
        result.osname = 'Windows';
      } else if (linux) {
        result.linux = t;
        result.osname = 'Linux';
      }

      function getWindowsVersion(s) {
        switch (s) {
          case 'NT':
            return 'NT';
          case 'XP':
            return 'XP';
          case 'NT 5.0':
            return '2000';
          case 'NT 5.1':
            return 'XP';
          case 'NT 5.2':
            return '2003';
          case 'NT 6.0':
            return 'Vista';
          case 'NT 6.1':
            return '7';
          case 'NT 6.2':
            return '8';
          case 'NT 6.3':
            return '8.1';
          case 'NT 10.0':
            return '10';
          default:
            return undefined;
        }
      }

      // OS version extraction
      var osVersion = '';
      if (result.windows) {
        osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i));
      } else if (result.windowsphone) {
        osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
      } else if (result.mac) {
        osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);
        osVersion = osVersion.replace(/[_\s]/g, '.');
      } else if (iosdevice) {
        osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
        osVersion = osVersion.replace(/[_\s]/g, '.');
      } else if (android) {
        osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
      } else if (result.webos) {
        osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
      } else if (result.blackberry) {
        osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
      } else if (result.bada) {
        osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
      } else if (result.tizen) {
        osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
      }
      if (osVersion) {
        result.osversion = osVersion;
      }

      // device type extraction
      var osMajorVersion = !result.windows && osVersion.split('.')[0];
      if (tablet || nexusTablet || iosdevice == 'ipad' || android && (osMajorVersion == 3 || osMajorVersion >= 4 && !mobile) || result.silk) {
        result.tablet = t;
      } else if (mobile || iosdevice == 'iphone' || iosdevice == 'ipod' || android || nexusMobile || result.blackberry || result.webos || result.bada) {
        result.mobile = t;
      }

      // Graded Browser Support
      // http://developer.yahoo.com/yui/articles/gbs
      if (result.msedge || result.msie && result.version >= 10 || result.yandexbrowser && result.version >= 15 || result.vivaldi && result.version >= 1.0 || result.chrome && result.version >= 20 || result.samsungBrowser && result.version >= 4 || result.whale && compareVersions([result.version, '1.0']) === 1 || result.mzbrowser && compareVersions([result.version, '6.0']) === 1 || result.focus && compareVersions([result.version, '1.0']) === 1 || result.firefox && result.version >= 20.0 || result.safari && result.version >= 6 || result.opera && result.version >= 10.0 || result.ios && result.osversion && result.osversion.split(".")[0] >= 6 || result.blackberry && result.version >= 10.1 || result.chromium && result.version >= 20) {
        result.a = t;
      } else if (result.msie && result.version < 10 || result.chrome && result.version < 20 || result.firefox && result.version < 20.0 || result.safari && result.version < 6 || result.opera && result.version < 10.0 || result.ios && result.osversion && result.osversion.split(".")[0] < 6 || result.chromium && result.version < 20) {
        result.c = t;
      } else result.x = t;

      return result;
    }

    var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '');

    bowser.test = function (browserList) {
      for (var i = 0; i < browserList.length; ++i) {
        var browserItem = browserList[i];
        if (typeof browserItem === 'string') {
          if (browserItem in bowser) {
            return true;
          }
        }
      }
      return false;
    };

    /**
     * Get version precisions count
     *
     * @example
     *   getVersionPrecision("1.10.3") // 3
     *
     * @param  {string} version
     * @return {number}
     */
    function getVersionPrecision(version) {
      return version.split(".").length;
    }

    /**
     * Array::map polyfill
     *
     * @param  {Array} arr
     * @param  {Function} iterator
     * @return {Array}
     */
    function map(arr, iterator) {
      var result = [],
          i;
      if (Array.prototype.map) {
        return Array.prototype.map.call(arr, iterator);
      }
      for (i = 0; i < arr.length; i++) {
        result.push(iterator(arr[i]));
      }
      return result;
    }

    /**
     * Calculate browser version weight
     *
     * @example
     *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
     *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
     *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
     *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
     *
     * @param  {Array<String>} versions versions to compare
     * @return {Number} comparison result
     */
    function compareVersions(versions) {
      // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
      var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
      var chunks = map(versions, function (version) {
        var delta = precision - getVersionPrecision(version);

        // 2) "9" -> "9.0" (for precision = 2)
        version = version + new Array(delta + 1).join(".0");

        // 3) "9.0" -> ["000000000"", "000000009"]
        return map(version.split("."), function (chunk) {
          return new Array(20 - chunk.length).join("0") + chunk;
        }).reverse();
      });

      // iterate in reverse order by reversed chunks array
      while (--precision >= 0) {
        // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
        if (chunks[0][precision] > chunks[1][precision]) {
          return 1;
        } else if (chunks[0][precision] === chunks[1][precision]) {
          if (precision === 0) {
            // all version chunks are same
            return 0;
          }
        } else {
          return -1;
        }
      }
    }

    /**
     * Check if browser is unsupported
     *
     * @example
     *   bowser.isUnsupportedBrowser({
     *     msie: "10",
     *     firefox: "23",
     *     chrome: "29",
     *     safari: "5.1",
     *     opera: "16",
     *     phantom: "534"
     *   });
     *
     * @param  {Object}  minVersions map of minimal version to browser
     * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
     * @param  {String}  [ua] user agent string
     * @return {Boolean}
     */
    function isUnsupportedBrowser(minVersions, strictMode, ua) {
      var _bowser = bowser;

      // make strictMode param optional with ua param usage
      if (typeof strictMode === 'string') {
        ua = strictMode;
        strictMode = void 0;
      }

      if (strictMode === void 0) {
        strictMode = false;
      }
      if (ua) {
        _bowser = detect(ua);
      }

      var version = "" + _bowser.version;
      for (var browser in minVersions) {
        if (minVersions.hasOwnProperty(browser)) {
          if (_bowser[browser]) {
            if (typeof minVersions[browser] !== 'string') {
              throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
            }

            // browser version and min supported version.
            return compareVersions([version, minVersions[browser]]) < 0;
          }
        }
      }

      return strictMode; // not found
    }

    /**
     * Check if browser is supported
     *
     * @param  {Object} minVersions map of minimal version to browser
     * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
     * @param  {String}  [ua] user agent string
     * @return {Boolean}
     */
    function check(minVersions, strictMode, ua) {
      return !isUnsupportedBrowser(minVersions, strictMode, ua);
    }

    bowser.isUnsupportedBrowser = isUnsupportedBrowser;
    bowser.compareVersions = compareVersions;
    bowser.check = check;

    /*
     * Set our detect method to the main bowser object so we can
     * reuse it to test other user agents.
     * This is needed to implement future tests.
     */
    bowser._detect = detect;

    /*
     * Set our detect public method to the main bowser object
     * This is needed to implement bowser in server side
     */
    bowser.detect = detect;
    return bowser;
  });
});
System.register("ags-client/app/commons/browser_detection.js", ["bowser/bowser.js"], function (exports_1, context_1) {
    "use strict";

    var bowser_1, mac, BrowserDetection;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (bowser_1_1) {
            bowser_1 = bowser_1_1;
        }],
        execute: function () {
            mac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
            BrowserDetection = /** @class */function () {
                function BrowserDetection() {}
                BrowserDetection.mac = function () {
                    return mac;
                };
                Object.defineProperty(BrowserDetection, "firefox", {
                    get: function () {
                        return bowser_1.default.firefox;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(BrowserDetection, "opera", {
                    get: function () {
                        return bowser_1.default.firefox;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(BrowserDetection, "safari", {
                    get: function () {
                        return bowser_1.default.safari;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(BrowserDetection, "chrome", {
                    get: function () {
                        return bowser_1.default.chrome;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(BrowserDetection, "ie", {
                    get: function () {
                        return bowser_1.default.msie;
                    },
                    enumerable: false,
                    configurable: true
                });
                return BrowserDetection;
            }();
            exports_1("BrowserDetection", BrowserDetection);
        }
    };
});

System.register("ags-client/app/commons/key_stroke_manager.js", ["ags-client/app/commons/lang.js", "ags-client/app/commons/browser_detection.js"], function (exports_1, context_1) {
    "use strict";

    var lang_1, browser_detection_1, KeyCode, KeyStroke, KeyStrokeManager;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (lang_1_1) {
            lang_1 = lang_1_1;
        }, function (browser_detection_1_1) {
            browser_detection_1 = browser_detection_1_1;
        }],
        execute: function () {
            exports_1("KeyCode", KeyCode = {
                CANCEL: 3,
                HELP: 6,
                BACK_SPACE: 8,
                TAB: 9,
                CLEAR: 12,
                RETURN: 13,
                ENTER: 14,
                SHIFT: 16,
                CONTROL: 17,
                ALT: 18,
                PAUSE: 19,
                CAPS_LOCK: 20,
                ESCAPE: 27,
                SPACE: 32,
                PAGE_UP: 33,
                PAGE_DOWN: 34,
                END: 35,
                HOME: 36,
                LEFT: 37,
                UP: 38,
                RIGHT: 39,
                DOWN: 40,
                PRINTSCREEN: 44,
                INSERT: 45,
                DELETE: 46,
                0: 48,
                1: 49,
                2: 50,
                3: 51,
                4: 52,
                5: 53,
                6: 54,
                7: 55,
                8: 56,
                9: 57,
                SEMICOLON: 59,
                EQUALS: 61,
                A: 65,
                B: 66,
                C: 67,
                D: 68,
                E: 69,
                F: 70,
                G: 71,
                H: 72,
                I: 73,
                J: 74,
                K: 75,
                L: 76,
                M: 77,
                N: 78,
                O: 79,
                P: 80,
                Q: 81,
                R: 82,
                S: 83,
                T: 84,
                U: 85,
                V: 86,
                W: 87,
                X: 88,
                Y: 89,
                Z: 90,
                CONTEXT_MENU: 93,
                NUMPAD0: 96,
                NUMPAD1: 97,
                NUMPAD2: 98,
                NUMPAD3: 99,
                NUMPAD4: 100,
                NUMPAD5: 101,
                NUMPAD6: 102,
                NUMPAD7: 103,
                NUMPAD8: 104,
                NUMPAD9: 105,
                MULTIPLY: 106,
                ADD: 107,
                SEPARATOR: 108,
                SUBTRACT: 109,
                DECIMAL: 110,
                DIVIDE: 111,
                F1: 112,
                F2: 113,
                F3: 114,
                F4: 115,
                F5: 116,
                F6: 117,
                F7: 118,
                F8: 119,
                F9: 120,
                F10: 121,
                F11: 122,
                F12: 123,
                F13: 124,
                F14: 125,
                F15: 126,
                F16: 127,
                F17: 128,
                F18: 129,
                F19: 130,
                F20: 131,
                F21: 132,
                F22: 133,
                F23: 134,
                F24: 135,
                NUM_LOCK: 144,
                SCROLL_LOCK: 145,
                COMMA: 188,
                PERIOD: 190,
                SLASH: 191,
                BACK_QUOTE: 192,
                OPEN_BRACKET: 219,
                BACK_SLASH: 220,
                CLOSE_BRACKET: 221,
                QUOTE: 222,
                META: 224
            });
            (function (KeyStroke) {
                KeyStroke[KeyStroke["CANCEL"] = 0] = "CANCEL";
                KeyStroke[KeyStroke["SAVE"] = 1] = "SAVE";
                KeyStroke[KeyStroke["NEW"] = 2] = "NEW";
            })(KeyStroke || exports_1("KeyStroke", KeyStroke = {}));
            KeyStrokeManager = /** @class */function () {
                function KeyStrokeManager() {}
                KeyStrokeManager.register = function (keyStroke, callback) {
                    if (!KeyStrokeManager._registration) {
                        KeyStrokeManager._registration = {};
                        window.addEventListener('keydown', function (event) {
                            if (event.keyCode === KeyCode.ESCAPE && KeyStrokeManager._registration['CANCEL']) {
                                KeyStrokeManager._registration['CANCEL']();
                                event.preventDefault();
                            } else if (event.keyCode === KeyCode.S && KeyStrokeManager.isActionModifier(event) && KeyStrokeManager._registration['SAVE']) {
                                event.preventDefault();
                                KeyStrokeManager._registration['SAVE']();
                            } else if (event.keyCode === KeyCode.N && KeyStrokeManager.isActionModifier(event) && KeyStrokeManager._registration['NEW']) {
                                event.preventDefault();
                                KeyStrokeManager._registration['NEW']();
                            }
                        });
                    }
                    KeyStrokeManager._registration[lang_1.enumStringValue(KeyStroke, keyStroke)] = callback;
                };
                KeyStrokeManager.isActionModifier = function (event) {
                    if (browser_detection_1.BrowserDetection.mac) {
                        return event.metaKey || event.ctrlKey;
                    } else {
                        return event.ctrlKey;
                    }
                };
                return KeyStrokeManager;
            }();
            exports_1("KeyStrokeManager", KeyStrokeManager);
        }
    };
});

System.register("ags-client/app/commons.js", ["ags-client/app/commons/timer.js", "ags-client/app/commons/lang.js", "ags-client/app/commons/html.js", "ags-client/app/commons/code_registry.js", "ags-client/app/commons/enum_registry.js", "ags-client/app/commons/page_flow.js", "ags-client/app/commons/key_stroke_manager.js"], function (exports_1, context_1) {
    "use strict";

    var __moduleName = context_1 && context_1.id;
    var exportedNames_1 = {
        "Timer": true,
        "CodeRegistry": true,
        "EnumRegistry": true,
        "PageFlow": true,
        "KeyStrokeManager": true,
        "KeyStroke": true,
        "KeyCode": true
    };
    function exportStar_1(m) {
        var exports = {};
        for (var n in m) {
            if (n !== "default" && !exportedNames_1.hasOwnProperty(n)) exports[n] = m[n];
        }
        exports_1(exports);
    }
    return {
        setters: [function (timer_1_1) {
            exports_1({
                "Timer": timer_1_1["Timer"]
            });
        }, function (lang_1_1) {
            exportStar_1(lang_1_1);
        }, function (html_1_1) {
            exportStar_1(html_1_1);
        }, function (code_registry_1_1) {
            exports_1({
                "CodeRegistry": code_registry_1_1["CodeRegistry"]
            });
        }, function (enum_registry_1_1) {
            exports_1({
                "EnumRegistry": enum_registry_1_1["EnumRegistry"]
            });
        }, function (page_flow_1_1) {
            exports_1({
                "PageFlow": page_flow_1_1["PageFlow"]
            });
        }, function (key_stroke_manager_1_1) {
            exports_1({
                "KeyStrokeManager": key_stroke_manager_1_1["KeyStrokeManager"],
                "KeyStroke": key_stroke_manager_1_1["KeyStroke"],
                "KeyCode": key_stroke_manager_1_1["KeyCode"]
            });
        }],
        execute: function () {}
    };
});

System.register("ags-client/gen/viewmodels/user_view_model.js", ["ags-client/app/commons/lang.js", "ags-client/gen/viewmodels/entity_view_model.js", "ags-client/app/validators.js", "ags-client/gen/enums.js", "ags-client/app/commons.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var lang_1, entity_view_model_1, Validators, enums_1, commons_1, UserViewModel;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (lang_1_1) {
            lang_1 = lang_1_1;
        }, function (entity_view_model_1_1) {
            entity_view_model_1 = entity_view_model_1_1;
        }, function (Validators_1) {
            Validators = Validators_1;
        }, function (enums_1_1) {
            enums_1 = enums_1_1;
        }, function (commons_1_1) {
            commons_1 = commons_1_1;
        }],
        execute: function () {
            UserViewModel = /** @class */function (_super) {
                __extends(UserViewModel, _super);
                function UserViewModel() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                UserViewModel.deserialize = function (object) {
                    var _result = new UserViewModel();
                    return _result._deserialize(object);
                };
                UserViewModel.prototype._deserialize = function (object) {
                    if (object) {
                        _super.prototype._deserialize.call(this, object);
                        if (lang_1.isPresent(object['salutation'])) {
                            this.salutation = commons_1.enumNumberValue(enums_1.Salutation, object['salutation']);
                        }
                        if (lang_1.isPresent(object['institution'])) {
                            this.institution = object['institution'];
                        }
                        if (lang_1.isPresent(object['firstName'])) {
                            this.firstName = object['firstName'];
                        }
                        if (lang_1.isPresent(object['lastName'])) {
                            this.lastName = object['lastName'];
                        }
                        if (lang_1.isPresent(object['email'])) {
                            this.email = object['email'];
                        }
                    }
                    return this;
                };
                UserViewModel.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (lang_1.isPresent(this.salutation)) {
                        object['salutation'] = enums_1.Salutation[this.salutation];
                    }
                    if (lang_1.isPresent(this.institution)) {
                        object['institution'] = this.institution;
                    }
                    if (lang_1.isPresent(this.firstName)) {
                        object['firstName'] = this.firstName;
                    }
                    if (lang_1.isPresent(this.lastName)) {
                        object['lastName'] = this.lastName;
                    }
                    if (lang_1.isPresent(this.email)) {
                        object['email'] = this.email;
                    }
                    return object;
                };
                UserViewModel.SALUTATION_VALIDATORS = [];
                UserViewModel.INSTITUTION_VALIDATORS = [Validators.max(120)];
                UserViewModel.FIRST_NAME_VALIDATORS = [Validators.max(40)];
                UserViewModel.LAST_NAME_VALIDATORS = [Validators.max(40)];
                UserViewModel.EMAIL_VALIDATORS = [Validators.required(), Validators.email()];
                return UserViewModel;
            }(entity_view_model_1.EntityViewModel);
            exports_1("UserViewModel", UserViewModel);
        }
    };
});

System.register("ags-client/gen/viewmodels.js", ["ags-client/gen/viewmodels/entity_view_model.js", "ags-client/gen/viewmodels/scope_view_model.js", "ags-client/gen/viewmodels/search_entity_view_model.js", "ags-client/gen/viewmodels/application_information_view_model.js", "ags-client/gen/viewmodels/extended_application_information_view_model.js", "ags-client/gen/viewmodels/account_view_model.js", "ags-client/gen/viewmodels/authentication_view_model.js", "ags-client/gen/viewmodels/change_password_view_model.js", "ags-client/gen/viewmodels/session_view_model.js", "ags-client/gen/viewmodels/remote_translation_view_model.js", "ags-client/gen/viewmodels/remote_translation_request_view_model.js", "ags-client/gen/viewmodels/file_view_model.js", "ags-client/gen/viewmodels/category_view_model.js", "ags-client/gen/viewmodels/darate_view_model.js", "ags-client/gen/viewmodels/darate_scope_view_model.js", "ags-client/gen/viewmodels/domain_view_model.js", "ags-client/gen/viewmodels/registration_view_model.js", "ags-client/gen/viewmodels/registration_activation_view_model.js", "ags-client/gen/viewmodels/lost_password_view_model.js", "ags-client/gen/viewmodels/lost_password_activation_view_model.js", "ags-client/gen/viewmodels/message_view_model.js", "ags-client/gen/viewmodels/code_search_result_view_model.js", "ags-client/gen/viewmodels/code_view_model.js", "ags-client/gen/viewmodels/system_view_model.js", "ags-client/gen/viewmodels/role_search_result_view_model.js", "ags-client/gen/viewmodels/role_view_model.js", "ags-client/gen/viewmodels/user_view_model.js"], function (exports_1, context_1) {
    "use strict";

    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (entity_view_model_1_1) {
            exports_1({
                "EntityViewModel": entity_view_model_1_1["EntityViewModel"]
            });
        }, function (scope_view_model_1_1) {
            exports_1({
                "ScopeViewModel": scope_view_model_1_1["ScopeViewModel"]
            });
        }, function (search_entity_view_model_1_1) {
            exports_1({
                "SearchEntityViewModel": search_entity_view_model_1_1["SearchEntityViewModel"]
            });
        }, function (application_information_view_model_1_1) {
            exports_1({
                "ApplicationInformationViewModel": application_information_view_model_1_1["ApplicationInformationViewModel"]
            });
        }, function (extended_application_information_view_model_1_1) {
            exports_1({
                "ExtendedApplicationInformationViewModel": extended_application_information_view_model_1_1["ExtendedApplicationInformationViewModel"]
            });
        }, function (account_view_model_1_1) {
            exports_1({
                "AccountViewModel": account_view_model_1_1["AccountViewModel"]
            });
        }, function (authentication_view_model_1_1) {
            exports_1({
                "AuthenticationViewModel": authentication_view_model_1_1["AuthenticationViewModel"]
            });
        }, function (change_password_view_model_1_1) {
            exports_1({
                "ChangePasswordViewModel": change_password_view_model_1_1["ChangePasswordViewModel"]
            });
        }, function (session_view_model_1_1) {
            exports_1({
                "SessionViewModel": session_view_model_1_1["SessionViewModel"]
            });
        }, function (remote_translation_view_model_1_1) {
            exports_1({
                "RemoteTranslationViewModel": remote_translation_view_model_1_1["RemoteTranslationViewModel"]
            });
        }, function (remote_translation_request_view_model_1_1) {
            exports_1({
                "RemoteTranslationRequestViewModel": remote_translation_request_view_model_1_1["RemoteTranslationRequestViewModel"]
            });
        }, function (file_view_model_1_1) {
            exports_1({
                "FileViewModel": file_view_model_1_1["FileViewModel"]
            });
        }, function (category_view_model_1_1) {
            exports_1({
                "CategoryViewModel": category_view_model_1_1["CategoryViewModel"]
            });
        }, function (darate_view_model_1_1) {
            exports_1({
                "DarateViewModel": darate_view_model_1_1["DarateViewModel"]
            });
        }, function (darate_scope_view_model_1_1) {
            exports_1({
                "DarateScopeViewModel": darate_scope_view_model_1_1["DarateScopeViewModel"]
            });
        }, function (domain_view_model_1_1) {
            exports_1({
                "DomainViewModel": domain_view_model_1_1["DomainViewModel"]
            });
        }, function (registration_view_model_1_1) {
            exports_1({
                "RegistrationViewModel": registration_view_model_1_1["RegistrationViewModel"]
            });
        }, function (registration_activation_view_model_1_1) {
            exports_1({
                "RegistrationActivationViewModel": registration_activation_view_model_1_1["RegistrationActivationViewModel"]
            });
        }, function (lost_password_view_model_1_1) {
            exports_1({
                "LostPasswordViewModel": lost_password_view_model_1_1["LostPasswordViewModel"]
            });
        }, function (lost_password_activation_view_model_1_1) {
            exports_1({
                "LostPasswordActivationViewModel": lost_password_activation_view_model_1_1["LostPasswordActivationViewModel"]
            });
        }, function (message_view_model_1_1) {
            exports_1({
                "MessageViewModel": message_view_model_1_1["MessageViewModel"]
            });
        }, function (code_search_result_view_model_1_1) {
            exports_1({
                "CodeSearchResultViewModel": code_search_result_view_model_1_1["CodeSearchResultViewModel"]
            });
        }, function (code_view_model_1_1) {
            exports_1({
                "CodeViewModel": code_view_model_1_1["CodeViewModel"]
            });
        }, function (system_view_model_1_1) {
            exports_1({
                "SystemViewModel": system_view_model_1_1["SystemViewModel"]
            });
        }, function (role_search_result_view_model_1_1) {
            exports_1({
                "RoleSearchResultViewModel": role_search_result_view_model_1_1["RoleSearchResultViewModel"]
            });
        }, function (role_view_model_1_1) {
            exports_1({
                "RoleViewModel": role_view_model_1_1["RoleViewModel"]
            });
        }, function (user_view_model_1_1) {
            exports_1({
                "UserViewModel": user_view_model_1_1["UserViewModel"]
            });
        }],
        execute: function () {}
    };
});

System.register("ags-client/gen/viewsearch/category_search_criteria.js", ["ags-client/app/viewsearch.js", "ags-client/app/commons/lang.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var viewsearch_1, lang_1, CategorySearchCriteria;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (viewsearch_1_1) {
            viewsearch_1 = viewsearch_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }],
        execute: function () {
            CategorySearchCriteria = /** @class */function (_super) {
                __extends(CategorySearchCriteria, _super);
                function CategorySearchCriteria(from, size) {
                    return _super.call(this, from, size) || this;
                }
                CategorySearchCriteria.create = function (from, size) {
                    return new CategorySearchCriteria(from, size);
                };
                Object.defineProperty(CategorySearchCriteria.prototype, "shortName", {
                    get: function () {
                        return this._shortName;
                    },
                    set: function (shortName) {
                        if (this._shortName !== shortName) {
                            this._shortName = shortName;
                            this.attributeChanged(CategorySearchCriteria.SHORT_NAME, shortName);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(CategorySearchCriteria.prototype, "name", {
                    get: function () {
                        return this._name;
                    },
                    set: function (name) {
                        if (this._name !== name) {
                            this._name = name;
                            this.attributeChanged(CategorySearchCriteria.NAME, name);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(CategorySearchCriteria.prototype, "description", {
                    get: function () {
                        return this._description;
                    },
                    set: function (description) {
                        if (this._description !== description) {
                            this._description = description;
                            this.attributeChanged(CategorySearchCriteria.DESCRIPTION, description);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(CategorySearchCriteria.prototype, "statical", {
                    get: function () {
                        return this._statical;
                    },
                    set: function (statical) {
                        if (this._statical !== statical) {
                            this._statical = statical;
                            this.attributeChanged(CategorySearchCriteria.STATICAL, statical);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(CategorySearchCriteria.prototype, "deleted", {
                    get: function () {
                        return this._deleted;
                    },
                    set: function (deleted) {
                        if (this._deleted !== deleted) {
                            this._deleted = deleted;
                            this.attributeChanged(CategorySearchCriteria.DELETED, deleted);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                CategorySearchCriteria.prototype.reset = function () {
                    _super.prototype.reset.call(this);
                    this._shortName = null;
                    this._name = null;
                    this._description = null;
                    this._statical = null;
                    this._deleted = null;
                };
                CategorySearchCriteria.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (lang_1.isPresent(this.shortName)) {
                        object['shortName'] = this.shortName;
                    }
                    if (lang_1.isPresent(this.name)) {
                        object['name'] = this.name;
                    }
                    if (lang_1.isPresent(this.description)) {
                        object['description'] = this.description;
                    }
                    if (lang_1.isPresent(this.statical)) {
                        object['statical'] = this.statical;
                    }
                    if (lang_1.isPresent(this.deleted)) {
                        object['deleted'] = this.deleted;
                    }
                    return object;
                };
                CategorySearchCriteria.SHORT_NAME = 'shortName';
                CategorySearchCriteria.NAME = 'name';
                CategorySearchCriteria.DESCRIPTION = 'description';
                CategorySearchCriteria.STATICAL = 'statical';
                CategorySearchCriteria.DELETED = 'deleted';
                return CategorySearchCriteria;
            }(viewsearch_1.SearchCriteria);
            exports_1("CategorySearchCriteria", CategorySearchCriteria);
        }
    };
});

System.register("ags-client/gen/viewsearch/code_search_criteria.js", ["ags-client/app/viewsearch.js", "ags-client/app/commons/lang.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var viewsearch_1, lang_1, lang_2, CodeSearchCriteria;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (viewsearch_1_1) {
            viewsearch_1 = viewsearch_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
            lang_2 = lang_1_1;
        }],
        execute: function () {
            CodeSearchCriteria = /** @class */function (_super) {
                __extends(CodeSearchCriteria, _super);
                function CodeSearchCriteria(from, size) {
                    return _super.call(this, from, size) || this;
                }
                CodeSearchCriteria.create = function (from, size) {
                    return new CodeSearchCriteria(from, size);
                };
                Object.defineProperty(CodeSearchCriteria.prototype, "category", {
                    get: function () {
                        return this._category;
                    },
                    set: function (category) {
                        if (this._category !== category) {
                            this._category = category;
                            this.attributeChanged(CodeSearchCriteria.CATEGORY, category);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(CodeSearchCriteria.prototype, "name", {
                    get: function () {
                        return this._name;
                    },
                    set: function (name) {
                        if (this._name !== name) {
                            this._name = name;
                            this.attributeChanged(CodeSearchCriteria.NAME, name);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(CodeSearchCriteria.prototype, "description", {
                    get: function () {
                        return this._description;
                    },
                    set: function (description) {
                        if (this._description !== description) {
                            this._description = description;
                            this.attributeChanged(CodeSearchCriteria.DESCRIPTION, description);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(CodeSearchCriteria.prototype, "validFrom", {
                    get: function () {
                        return this._validFrom;
                    },
                    set: function (validFrom) {
                        if (this._validFrom !== validFrom) {
                            this._validFrom = validFrom;
                            this.attributeChanged(CodeSearchCriteria.VALID_FROM, validFrom);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(CodeSearchCriteria.prototype, "validTo", {
                    get: function () {
                        return this._validTo;
                    },
                    set: function (validTo) {
                        if (this._validTo !== validTo) {
                            this._validTo = validTo;
                            this.attributeChanged(CodeSearchCriteria.VALID_TO, validTo);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(CodeSearchCriteria.prototype, "deleted", {
                    get: function () {
                        return this._deleted;
                    },
                    set: function (deleted) {
                        if (this._deleted !== deleted) {
                            this._deleted = deleted;
                            this.attributeChanged(CodeSearchCriteria.DELETED, deleted);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                CodeSearchCriteria.prototype.reset = function () {
                    _super.prototype.reset.call(this);
                    this._category = null;
                    this._name = null;
                    this._description = null;
                    this._validFrom = null;
                    this._validTo = null;
                    this._deleted = null;
                };
                CodeSearchCriteria.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (lang_1.isPresent(this.category)) {
                        object['category'] = this.category.serialize();
                    }
                    if (lang_1.isPresent(this.name)) {
                        object['name'] = this.name;
                    }
                    if (lang_1.isPresent(this.description)) {
                        object['description'] = this.description;
                    }
                    if (lang_1.isPresent(this.validFrom)) {
                        object['validFrom'] = lang_2.serializeDate(this.validFrom);
                    }
                    if (lang_1.isPresent(this.validTo)) {
                        object['validTo'] = lang_2.serializeDate(this.validTo);
                    }
                    if (lang_1.isPresent(this.deleted)) {
                        object['deleted'] = this.deleted;
                    }
                    return object;
                };
                CodeSearchCriteria.CATEGORY = 'category';
                CodeSearchCriteria.NAME = 'name';
                CodeSearchCriteria.DESCRIPTION = 'description';
                CodeSearchCriteria.VALID_FROM = 'validFrom';
                CodeSearchCriteria.VALID_TO = 'validTo';
                CodeSearchCriteria.DELETED = 'deleted';
                return CodeSearchCriteria;
            }(viewsearch_1.SearchCriteria);
            exports_1("CodeSearchCriteria", CodeSearchCriteria);
        }
    };
});

System.register("ags-client/gen/viewsearch/darate_search_criteria.js", ["ags-client/app/viewsearch.js", "ags-client/app/commons/lang.js", "ags-client/gen/enums.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var viewsearch_1, lang_1, enums_1, enums_2, enums_3, DarateSearchCriteria;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (viewsearch_1_1) {
            viewsearch_1 = viewsearch_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }, function (enums_1_1) {
            enums_1 = enums_1_1;
            enums_2 = enums_1_1;
            enums_3 = enums_1_1;
        }],
        execute: function () {
            DarateSearchCriteria = /** @class */function (_super) {
                __extends(DarateSearchCriteria, _super);
                function DarateSearchCriteria(from, size) {
                    return _super.call(this, from, size) || this;
                }
                DarateSearchCriteria.create = function (from, size) {
                    return new DarateSearchCriteria(from, size);
                };
                Object.defineProperty(DarateSearchCriteria.prototype, "country", {
                    get: function () {
                        return this._country;
                    },
                    set: function (country) {
                        if (this._country !== country) {
                            this._country = country;
                            this.attributeChanged(DarateSearchCriteria.COUNTRY, country);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DarateSearchCriteria.prototype, "instrumentGroup", {
                    get: function () {
                        return this._instrumentGroup;
                    },
                    set: function (instrumentGroup) {
                        if (this._instrumentGroup !== instrumentGroup) {
                            this._instrumentGroup = instrumentGroup;
                            this.attributeChanged(DarateSearchCriteria.INSTRUMENT_GROUP, instrumentGroup);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DarateSearchCriteria.prototype, "instrumentType", {
                    get: function () {
                        return this._instrumentType;
                    },
                    set: function (instrumentType) {
                        if (this._instrumentType !== instrumentType) {
                            this._instrumentType = instrumentType;
                            this.attributeChanged(DarateSearchCriteria.INSTRUMENT_TYPE, instrumentType);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DarateSearchCriteria.prototype, "active", {
                    get: function () {
                        return this._active;
                    },
                    set: function (active) {
                        if (this._active !== active) {
                            this._active = active;
                            this.attributeChanged(DarateSearchCriteria.ACTIVE, active);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DarateSearchCriteria.prototype, "darateType", {
                    get: function () {
                        return this._darateType;
                    },
                    set: function (darateType) {
                        if (this._darateType !== darateType) {
                            this._darateType = darateType;
                            this.attributeChanged(DarateSearchCriteria.DARATE_TYPE, darateType);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DarateSearchCriteria.prototype, "deleted", {
                    get: function () {
                        return this._deleted;
                    },
                    set: function (deleted) {
                        if (this._deleted !== deleted) {
                            this._deleted = deleted;
                            this.attributeChanged(DarateSearchCriteria.DELETED, deleted);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DarateSearchCriteria.prototype, "rate", {
                    get: function () {
                        return this._rate;
                    },
                    set: function (rate) {
                        if (this._rate !== rate) {
                            this._rate = rate;
                            this.attributeChanged(DarateSearchCriteria.RATE, rate);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DarateSearchCriteria.prototype, "release", {
                    get: function () {
                        return this._release;
                    },
                    set: function (release) {
                        if (this._release !== release) {
                            this._release = release;
                            this.attributeChanged(DarateSearchCriteria.RELEASE, release);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DarateSearchCriteria.prototype, "nonRecoverable", {
                    get: function () {
                        return this._nonRecoverable;
                    },
                    set: function (nonRecoverable) {
                        if (this._nonRecoverable !== nonRecoverable) {
                            this._nonRecoverable = nonRecoverable;
                            this.attributeChanged(DarateSearchCriteria.NON_RECOVERABLE, nonRecoverable);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                DarateSearchCriteria.prototype.reset = function () {
                    _super.prototype.reset.call(this);
                    this._country = null;
                    this._instrumentGroup = null;
                    this._instrumentType = null;
                    this._active = null;
                    this._darateType = null;
                    this._deleted = null;
                    this._rate = null;
                    this._release = null;
                    this._nonRecoverable = null;
                };
                DarateSearchCriteria.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (lang_1.isPresent(this.country)) {
                        object['country'] = this.country;
                    }
                    if (lang_1.isPresent(this.instrumentGroup)) {
                        object['instrumentGroup'] = enums_1.InstrumentGroup[this.instrumentGroup];
                    }
                    if (lang_1.isPresent(this.instrumentType)) {
                        object['instrumentType'] = enums_2.InstrumentType[this.instrumentType];
                    }
                    if (lang_1.isPresent(this.active)) {
                        object['active'] = this.active;
                    }
                    if (lang_1.isPresent(this.darateType)) {
                        object['darateType'] = enums_3.DARateType[this.darateType];
                    }
                    if (lang_1.isPresent(this.deleted)) {
                        object['deleted'] = this.deleted;
                    }
                    if (lang_1.isPresent(this.rate)) {
                        object['rate'] = this.rate;
                    }
                    if (lang_1.isPresent(this.release)) {
                        object['release'] = this.release;
                    }
                    if (lang_1.isPresent(this.nonRecoverable)) {
                        object['nonRecoverable'] = this.nonRecoverable;
                    }
                    return object;
                };
                DarateSearchCriteria.COUNTRY = 'country';
                DarateSearchCriteria.INSTRUMENT_GROUP = 'instrumentGroup';
                DarateSearchCriteria.INSTRUMENT_TYPE = 'instrumentType';
                DarateSearchCriteria.ACTIVE = 'active';
                DarateSearchCriteria.DARATE_TYPE = 'darateType';
                DarateSearchCriteria.DELETED = 'deleted';
                DarateSearchCriteria.RATE = 'rate';
                DarateSearchCriteria.RELEASE = 'release';
                DarateSearchCriteria.NON_RECOVERABLE = 'nonRecoverable';
                return DarateSearchCriteria;
            }(viewsearch_1.SearchCriteria);
            exports_1("DarateSearchCriteria", DarateSearchCriteria);
        }
    };
});

System.register("ags-client/gen/viewsearch/domain_search_criteria.js", ["ags-client/app/viewsearch.js", "ags-client/app/commons/lang.js", "ags-client/gen/enums.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var viewsearch_1, lang_1, enums_1, DomainSearchCriteria;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (viewsearch_1_1) {
            viewsearch_1 = viewsearch_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }, function (enums_1_1) {
            enums_1 = enums_1_1;
        }],
        execute: function () {
            DomainSearchCriteria = /** @class */function (_super) {
                __extends(DomainSearchCriteria, _super);
                function DomainSearchCriteria(from, size) {
                    return _super.call(this, from, size) || this;
                }
                DomainSearchCriteria.create = function (from, size) {
                    return new DomainSearchCriteria(from, size);
                };
                Object.defineProperty(DomainSearchCriteria.prototype, "institution", {
                    get: function () {
                        return this._institution;
                    },
                    set: function (institution) {
                        if (this._institution !== institution) {
                            this._institution = institution;
                            this.attributeChanged(DomainSearchCriteria.INSTITUTION, institution);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DomainSearchCriteria.prototype, "name", {
                    get: function () {
                        return this._name;
                    },
                    set: function (name) {
                        if (this._name !== name) {
                            this._name = name;
                            this.attributeChanged(DomainSearchCriteria.NAME, name);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DomainSearchCriteria.prototype, "canton", {
                    get: function () {
                        return this._canton;
                    },
                    set: function (canton) {
                        if (this._canton !== canton) {
                            this._canton = canton;
                            this.attributeChanged(DomainSearchCriteria.CANTON, canton);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DomainSearchCriteria.prototype, "active", {
                    get: function () {
                        return this._active;
                    },
                    set: function (active) {
                        if (this._active !== active) {
                            this._active = active;
                            this.attributeChanged(DomainSearchCriteria.ACTIVE, active);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DomainSearchCriteria.prototype, "blocked", {
                    get: function () {
                        return this._blocked;
                    },
                    set: function (blocked) {
                        if (this._blocked !== blocked) {
                            this._blocked = blocked;
                            this.attributeChanged(DomainSearchCriteria.BLOCKED, blocked);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DomainSearchCriteria.prototype, "requestAllowed", {
                    get: function () {
                        return this._requestAllowed;
                    },
                    set: function (requestAllowed) {
                        if (this._requestAllowed !== requestAllowed) {
                            this._requestAllowed = requestAllowed;
                            this.attributeChanged(DomainSearchCriteria.REQUEST_ALLOWED, requestAllowed);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DomainSearchCriteria.prototype, "deleted", {
                    get: function () {
                        return this._deleted;
                    },
                    set: function (deleted) {
                        if (this._deleted !== deleted) {
                            this._deleted = deleted;
                            this.attributeChanged(DomainSearchCriteria.DELETED, deleted);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                DomainSearchCriteria.prototype.reset = function () {
                    _super.prototype.reset.call(this);
                    this._institution = null;
                    this._name = null;
                    this._canton = null;
                    this._active = null;
                    this._blocked = null;
                    this._requestAllowed = null;
                    this._deleted = null;
                };
                DomainSearchCriteria.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (lang_1.isPresent(this.institution)) {
                        object['institution'] = this.institution;
                    }
                    if (lang_1.isPresent(this.name)) {
                        object['name'] = this.name;
                    }
                    if (lang_1.isPresent(this.canton)) {
                        object['canton'] = enums_1.Canton[this.canton];
                    }
                    if (lang_1.isPresent(this.active)) {
                        object['active'] = this.active;
                    }
                    if (lang_1.isPresent(this.blocked)) {
                        object['blocked'] = this.blocked;
                    }
                    if (lang_1.isPresent(this.requestAllowed)) {
                        object['requestAllowed'] = this.requestAllowed;
                    }
                    if (lang_1.isPresent(this.deleted)) {
                        object['deleted'] = this.deleted;
                    }
                    return object;
                };
                DomainSearchCriteria.INSTITUTION = 'institution';
                DomainSearchCriteria.NAME = 'name';
                DomainSearchCriteria.CANTON = 'canton';
                DomainSearchCriteria.ACTIVE = 'active';
                DomainSearchCriteria.BLOCKED = 'blocked';
                DomainSearchCriteria.REQUEST_ALLOWED = 'requestAllowed';
                DomainSearchCriteria.DELETED = 'deleted';
                return DomainSearchCriteria;
            }(viewsearch_1.SearchCriteria);
            exports_1("DomainSearchCriteria", DomainSearchCriteria);
        }
    };
});

System.register("ags-client/gen/viewsearch/system_search_criteria.js", ["ags-client/app/viewsearch.js", "ags-client/app/commons/lang.js", "ags-client/gen/enums.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var viewsearch_1, lang_1, enums_1, SystemSearchCriteria;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (viewsearch_1_1) {
            viewsearch_1 = viewsearch_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }, function (enums_1_1) {
            enums_1 = enums_1_1;
        }],
        execute: function () {
            SystemSearchCriteria = /** @class */function (_super) {
                __extends(SystemSearchCriteria, _super);
                function SystemSearchCriteria(from, size) {
                    return _super.call(this, from, size) || this;
                }
                SystemSearchCriteria.create = function (from, size) {
                    return new SystemSearchCriteria(from, size);
                };
                Object.defineProperty(SystemSearchCriteria.prototype, "name", {
                    get: function () {
                        return this._name;
                    },
                    set: function (name) {
                        if (this._name !== name) {
                            this._name = name;
                            this.attributeChanged(SystemSearchCriteria.NAME, name);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SystemSearchCriteria.prototype, "description", {
                    get: function () {
                        return this._description;
                    },
                    set: function (description) {
                        if (this._description !== description) {
                            this._description = description;
                            this.attributeChanged(SystemSearchCriteria.DESCRIPTION, description);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SystemSearchCriteria.prototype, "valueType", {
                    get: function () {
                        return this._valueType;
                    },
                    set: function (valueType) {
                        if (this._valueType !== valueType) {
                            this._valueType = valueType;
                            this.attributeChanged(SystemSearchCriteria.VALUE_TYPE, valueType);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SystemSearchCriteria.prototype, "value", {
                    get: function () {
                        return this._value;
                    },
                    set: function (value) {
                        if (this._value !== value) {
                            this._value = value;
                            this.attributeChanged(SystemSearchCriteria.VALUE, value);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SystemSearchCriteria.prototype, "deleted", {
                    get: function () {
                        return this._deleted;
                    },
                    set: function (deleted) {
                        if (this._deleted !== deleted) {
                            this._deleted = deleted;
                            this.attributeChanged(SystemSearchCriteria.DELETED, deleted);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                SystemSearchCriteria.prototype.reset = function () {
                    _super.prototype.reset.call(this);
                    this._name = null;
                    this._description = null;
                    this._valueType = null;
                    this._value = null;
                    this._deleted = null;
                };
                SystemSearchCriteria.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (lang_1.isPresent(this.name)) {
                        object['name'] = this.name;
                    }
                    if (lang_1.isPresent(this.description)) {
                        object['description'] = this.description;
                    }
                    if (lang_1.isPresent(this.valueType)) {
                        object['valueType'] = enums_1.ValueType[this.valueType];
                    }
                    if (lang_1.isPresent(this.value)) {
                        object['value'] = this.value;
                    }
                    if (lang_1.isPresent(this.deleted)) {
                        object['deleted'] = this.deleted;
                    }
                    return object;
                };
                SystemSearchCriteria.NAME = 'name';
                SystemSearchCriteria.DESCRIPTION = 'description';
                SystemSearchCriteria.VALUE_TYPE = 'valueType';
                SystemSearchCriteria.VALUE = 'value';
                SystemSearchCriteria.DELETED = 'deleted';
                return SystemSearchCriteria;
            }(viewsearch_1.SearchCriteria);
            exports_1("SystemSearchCriteria", SystemSearchCriteria);
        }
    };
});

System.registerDynamic('angular2/src/core/util.js', ['angular2/src/core/util/decorators.js'], true, function ($__require, exports, module) {
  'use strict';"use strict";
  // Public API for util

  var global = this || self,
      GLOBAL = global;
  var decorators_1 = $__require('angular2/src/core/util/decorators.js');
  exports.Class = decorators_1.Class;
});
System.registerDynamic('angular2/src/core/prod_mode.js', ['angular2/src/facade/lang.js'], true, function ($__require, exports, module) {
  'use strict';"use strict";

  var global = this || self,
      GLOBAL = global;
  var lang_1 = $__require('angular2/src/facade/lang.js');
  exports.enableProdMode = lang_1.enableProdMode;
});
System.registerDynamic('angular2/src/facade/facade.js', ['angular2/src/facade/lang.js', 'angular2/src/facade/async.js', 'angular2/src/facade/exceptions.js', 'angular2/src/facade/exception_handler.js'], true, function ($__require, exports, module) {
  'use strict';"use strict";
  // Public API for Facade

  var global = this || self,
      GLOBAL = global;
  var lang_1 = $__require('angular2/src/facade/lang.js');
  exports.Type = lang_1.Type;
  var async_1 = $__require('angular2/src/facade/async.js');
  exports.EventEmitter = async_1.EventEmitter;
  var exceptions_1 = $__require('angular2/src/facade/exceptions.js');
  exports.WrappedException = exceptions_1.WrappedException;
  var exception_handler_1 = $__require('angular2/src/facade/exception_handler.js');
  exports.ExceptionHandler = exception_handler_1.ExceptionHandler;
});
System.registerDynamic('angular2/src/core/application_ref.js', ['angular2/src/core/zone/ng_zone.js', 'angular2/src/facade/lang.js', 'angular2/src/core/di.js', 'angular2/src/core/application_tokens.js', 'angular2/src/facade/async.js', 'angular2/src/facade/collection.js', 'angular2/src/core/testability/testability.js', 'angular2/src/core/linker/dynamic_component_loader.js', 'angular2/src/facade/exceptions.js', 'angular2/src/core/console.js', 'angular2/src/core/profile/profile.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var ng_zone_1 = $__require('angular2/src/core/zone/ng_zone.js');
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var di_1 = $__require('angular2/src/core/di.js');
    var application_tokens_1 = $__require('angular2/src/core/application_tokens.js');
    var async_1 = $__require('angular2/src/facade/async.js');
    var collection_1 = $__require('angular2/src/facade/collection.js');
    var testability_1 = $__require('angular2/src/core/testability/testability.js');
    var dynamic_component_loader_1 = $__require('angular2/src/core/linker/dynamic_component_loader.js');
    var exceptions_1 = $__require('angular2/src/facade/exceptions.js');
    var console_1 = $__require('angular2/src/core/console.js');
    var profile_1 = $__require('angular2/src/core/profile/profile.js');
    var lang_2 = $__require('angular2/src/facade/lang.js');
    /**
     * Construct providers specific to an individual root component.
     */
    function _componentProviders(appComponentType) {
        return [di_1.provide(application_tokens_1.APP_COMPONENT, { useValue: appComponentType }), di_1.provide(application_tokens_1.APP_COMPONENT_REF_PROMISE, {
            useFactory: function (dynamicComponentLoader, appRef, injector) {
                // Save the ComponentRef for disposal later.
                var ref;
                // TODO(rado): investigate whether to support providers on root component.
                return dynamicComponentLoader.loadAsRoot(appComponentType, null, injector, function () {
                    appRef._unloadComponent(ref);
                }).then(function (componentRef) {
                    ref = componentRef;
                    var testability = injector.getOptional(testability_1.Testability);
                    if (lang_1.isPresent(testability)) {
                        injector.get(testability_1.TestabilityRegistry).registerApplication(componentRef.location.nativeElement, testability);
                    }
                    return componentRef;
                });
            },
            deps: [dynamic_component_loader_1.DynamicComponentLoader, ApplicationRef, di_1.Injector]
        }), di_1.provide(appComponentType, {
            useFactory: function (p) {
                return p.then(function (ref) {
                    return ref.instance;
                });
            },
            deps: [application_tokens_1.APP_COMPONENT_REF_PROMISE]
        })];
    }
    /**
     * Create an Angular zone.
     */
    function createNgZone() {
        return new ng_zone_1.NgZone({ enableLongStackTrace: lang_1.assertionsEnabled() });
    }
    exports.createNgZone = createNgZone;
    var _platform;
    var _platformProviders;
    /**
     * Initialize the Angular 'platform' on the page.
     *
     * See {@link PlatformRef} for details on the Angular platform.
     *
     * It is also possible to specify providers to be made in the new platform. These providers
     * will be shared between all applications on the page. For example, an abstraction for
     * the browser cookie jar should be bound at the platform level, because there is only one
     * cookie jar regardless of how many applications on the page will be accessing it.
     *
     * The platform function can be called multiple times as long as the same list of providers
     * is passed into each call. If the platform function is called with a different set of
     * provides, Angular will throw an exception.
     */
    function platform(providers) {
        lang_2.lockMode();
        if (lang_1.isPresent(_platform)) {
            if (collection_1.ListWrapper.equals(_platformProviders, providers)) {
                return _platform;
            } else {
                throw new exceptions_1.BaseException("platform cannot be initialized with different sets of providers.");
            }
        } else {
            return _createPlatform(providers);
        }
    }
    exports.platform = platform;
    /**
     * Dispose the existing platform.
     */
    function disposePlatform() {
        if (lang_1.isPresent(_platform)) {
            _platform.dispose();
            _platform = null;
        }
    }
    exports.disposePlatform = disposePlatform;
    function _createPlatform(providers) {
        _platformProviders = providers;
        var injector = di_1.Injector.resolveAndCreate(providers);
        _platform = new PlatformRef_(injector, function () {
            _platform = null;
            _platformProviders = null;
        });
        _runPlatformInitializers(injector);
        return _platform;
    }
    function _runPlatformInitializers(injector) {
        var inits = injector.getOptional(application_tokens_1.PLATFORM_INITIALIZER);
        if (lang_1.isPresent(inits)) inits.forEach(function (init) {
            return init();
        });
    }
    /**
     * The Angular platform is the entry point for Angular on a web page. Each page
     * has exactly one platform, and services (such as reflection) which are common
     * to every Angular application running on the page are bound in its scope.
     *
     * A page's platform is initialized implicitly when {@link bootstrap}() is called, or
     * explicitly by calling {@link platform}().
     */
    var PlatformRef = function () {
        function PlatformRef() {}
        Object.defineProperty(PlatformRef.prototype, "injector", {
            /**
             * Retrieve the platform {@link Injector}, which is the parent injector for
             * every Angular application on the page and provides singleton providers.
             */
            get: function () {
                throw exceptions_1.unimplemented();
            },
            enumerable: true,
            configurable: true
        });
        ;
        return PlatformRef;
    }();
    exports.PlatformRef = PlatformRef;
    var PlatformRef_ = function (_super) {
        __extends(PlatformRef_, _super);
        function PlatformRef_(_injector, _dispose) {
            _super.call(this);
            this._injector = _injector;
            this._dispose = _dispose;
            /** @internal */
            this._applications = [];
            /** @internal */
            this._disposeListeners = [];
        }
        PlatformRef_.prototype.registerDisposeListener = function (dispose) {
            this._disposeListeners.push(dispose);
        };
        Object.defineProperty(PlatformRef_.prototype, "injector", {
            get: function () {
                return this._injector;
            },
            enumerable: true,
            configurable: true
        });
        PlatformRef_.prototype.application = function (providers) {
            var app = this._initApp(createNgZone(), providers);
            if (async_1.PromiseWrapper.isPromise(app)) {
                throw new exceptions_1.BaseException("Cannot use asyncronous app initializers with application. Use asyncApplication instead.");
            }
            return app;
        };
        PlatformRef_.prototype.asyncApplication = function (bindingFn, additionalProviders) {
            var _this = this;
            var zone = createNgZone();
            var completer = async_1.PromiseWrapper.completer();
            if (bindingFn === null) {
                completer.resolve(this._initApp(zone, additionalProviders));
            } else {
                zone.run(function () {
                    async_1.PromiseWrapper.then(bindingFn(zone), function (providers) {
                        if (lang_1.isPresent(additionalProviders)) {
                            providers = collection_1.ListWrapper.concat(providers, additionalProviders);
                        }
                        var promise = _this._initApp(zone, providers);
                        completer.resolve(promise);
                    });
                });
            }
            return completer.promise;
        };
        PlatformRef_.prototype._initApp = function (zone, providers) {
            var _this = this;
            var injector;
            var app;
            zone.run(function () {
                providers = collection_1.ListWrapper.concat(providers, [di_1.provide(ng_zone_1.NgZone, { useValue: zone }), di_1.provide(ApplicationRef, { useFactory: function () {
                        return app;
                    }, deps: [] })]);
                var exceptionHandler;
                try {
                    injector = _this.injector.resolveAndCreateChild(providers);
                    exceptionHandler = injector.get(exceptions_1.ExceptionHandler);
                    async_1.ObservableWrapper.subscribe(zone.onError, function (error) {
                        exceptionHandler.call(error.error, error.stackTrace);
                    });
                } catch (e) {
                    if (lang_1.isPresent(exceptionHandler)) {
                        exceptionHandler.call(e, e.stack);
                    } else {
                        lang_1.print(e.toString());
                    }
                }
            });
            app = new ApplicationRef_(this, zone, injector);
            this._applications.push(app);
            var promise = _runAppInitializers(injector);
            if (promise !== null) {
                return async_1.PromiseWrapper.then(promise, function (_) {
                    return app;
                });
            } else {
                return app;
            }
        };
        PlatformRef_.prototype.dispose = function () {
            collection_1.ListWrapper.clone(this._applications).forEach(function (app) {
                return app.dispose();
            });
            this._disposeListeners.forEach(function (dispose) {
                return dispose();
            });
            this._dispose();
        };
        /** @internal */
        PlatformRef_.prototype._applicationDisposed = function (app) {
            collection_1.ListWrapper.remove(this._applications, app);
        };
        return PlatformRef_;
    }(PlatformRef);
    exports.PlatformRef_ = PlatformRef_;
    function _runAppInitializers(injector) {
        var inits = injector.getOptional(application_tokens_1.APP_INITIALIZER);
        var promises = [];
        if (lang_1.isPresent(inits)) {
            inits.forEach(function (init) {
                var retVal = init();
                if (async_1.PromiseWrapper.isPromise(retVal)) {
                    promises.push(retVal);
                }
            });
        }
        if (promises.length > 0) {
            return async_1.PromiseWrapper.all(promises);
        } else {
            return null;
        }
    }
    /**
     * A reference to an Angular application running on a page.
     *
     * For more about Angular applications, see the documentation for {@link bootstrap}.
     */
    var ApplicationRef = function () {
        function ApplicationRef() {}
        Object.defineProperty(ApplicationRef.prototype, "injector", {
            /**
             * Retrieve the application {@link Injector}.
             */
            get: function () {
                return exceptions_1.unimplemented();
            },
            enumerable: true,
            configurable: true
        });
        ;
        Object.defineProperty(ApplicationRef.prototype, "zone", {
            /**
             * Retrieve the application {@link NgZone}.
             */
            get: function () {
                return exceptions_1.unimplemented();
            },
            enumerable: true,
            configurable: true
        });
        ;
        Object.defineProperty(ApplicationRef.prototype, "componentTypes", {
            /**
             * Get a list of component types registered to this application.
             */
            get: function () {
                return exceptions_1.unimplemented();
            },
            enumerable: true,
            configurable: true
        });
        ;
        return ApplicationRef;
    }();
    exports.ApplicationRef = ApplicationRef;
    var ApplicationRef_ = function (_super) {
        __extends(ApplicationRef_, _super);
        function ApplicationRef_(_platform, _zone, _injector) {
            var _this = this;
            _super.call(this);
            this._platform = _platform;
            this._zone = _zone;
            this._injector = _injector;
            /** @internal */
            this._bootstrapListeners = [];
            /** @internal */
            this._disposeListeners = [];
            /** @internal */
            this._rootComponents = [];
            /** @internal */
            this._rootComponentTypes = [];
            /** @internal */
            this._changeDetectorRefs = [];
            /** @internal */
            this._runningTick = false;
            /** @internal */
            this._enforceNoNewChanges = false;
            if (lang_1.isPresent(this._zone)) {
                async_1.ObservableWrapper.subscribe(this._zone.onMicrotaskEmpty, function (_) {
                    _this._zone.run(function () {
                        _this.tick();
                    });
                });
            }
            this._enforceNoNewChanges = lang_1.assertionsEnabled();
        }
        ApplicationRef_.prototype.registerBootstrapListener = function (listener) {
            this._bootstrapListeners.push(listener);
        };
        ApplicationRef_.prototype.registerDisposeListener = function (dispose) {
            this._disposeListeners.push(dispose);
        };
        ApplicationRef_.prototype.registerChangeDetector = function (changeDetector) {
            this._changeDetectorRefs.push(changeDetector);
        };
        ApplicationRef_.prototype.unregisterChangeDetector = function (changeDetector) {
            collection_1.ListWrapper.remove(this._changeDetectorRefs, changeDetector);
        };
        ApplicationRef_.prototype.bootstrap = function (componentType, providers) {
            var _this = this;
            var completer = async_1.PromiseWrapper.completer();
            this._zone.run(function () {
                var componentProviders = _componentProviders(componentType);
                if (lang_1.isPresent(providers)) {
                    componentProviders.push(providers);
                }
                var exceptionHandler = _this._injector.get(exceptions_1.ExceptionHandler);
                _this._rootComponentTypes.push(componentType);
                try {
                    var injector = _this._injector.resolveAndCreateChild(componentProviders);
                    var compRefToken = injector.get(application_tokens_1.APP_COMPONENT_REF_PROMISE);
                    var tick = function (componentRef) {
                        _this._loadComponent(componentRef);
                        completer.resolve(componentRef);
                    };
                    var tickResult = async_1.PromiseWrapper.then(compRefToken, tick);
                    async_1.PromiseWrapper.then(tickResult, null, function (err, stackTrace) {
                        completer.reject(err, stackTrace);
                        exceptionHandler.call(err, stackTrace);
                    });
                } catch (e) {
                    exceptionHandler.call(e, e.stack);
                    completer.reject(e, e.stack);
                }
            });
            return completer.promise.then(function (ref) {
                var c = _this._injector.get(console_1.Console);
                if (lang_1.assertionsEnabled()) {
                    c.log("Angular 2 is running in the development mode. Call enableProdMode() to enable the production mode.");
                }
                return ref;
            });
        };
        /** @internal */
        ApplicationRef_.prototype._loadComponent = function (componentRef) {
            var appChangeDetector = componentRef.location.internalElement.parentView.changeDetector;
            this._changeDetectorRefs.push(appChangeDetector.ref);
            this.tick();
            this._rootComponents.push(componentRef);
            this._bootstrapListeners.forEach(function (listener) {
                return listener(componentRef);
            });
        };
        /** @internal */
        ApplicationRef_.prototype._unloadComponent = function (componentRef) {
            if (!collection_1.ListWrapper.contains(this._rootComponents, componentRef)) {
                return;
            }
            this.unregisterChangeDetector(componentRef.location.internalElement.parentView.changeDetector.ref);
            collection_1.ListWrapper.remove(this._rootComponents, componentRef);
        };
        Object.defineProperty(ApplicationRef_.prototype, "injector", {
            get: function () {
                return this._injector;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ApplicationRef_.prototype, "zone", {
            get: function () {
                return this._zone;
            },
            enumerable: true,
            configurable: true
        });
        ApplicationRef_.prototype.tick = function () {
            if (this._runningTick) {
                throw new exceptions_1.BaseException("ApplicationRef.tick is called recursively");
            }
            var s = ApplicationRef_._tickScope();
            try {
                this._runningTick = true;
                this._changeDetectorRefs.forEach(function (detector) {
                    return detector.detectChanges();
                });
                if (this._enforceNoNewChanges) {
                    this._changeDetectorRefs.forEach(function (detector) {
                        return detector.checkNoChanges();
                    });
                }
            } finally {
                this._runningTick = false;
                profile_1.wtfLeave(s);
            }
        };
        ApplicationRef_.prototype.dispose = function () {
            // TODO(alxhub): Dispose of the NgZone.
            collection_1.ListWrapper.clone(this._rootComponents).forEach(function (ref) {
                return ref.dispose();
            });
            this._disposeListeners.forEach(function (dispose) {
                return dispose();
            });
            this._platform._applicationDisposed(this);
        };
        Object.defineProperty(ApplicationRef_.prototype, "componentTypes", {
            get: function () {
                return this._rootComponentTypes;
            },
            enumerable: true,
            configurable: true
        });
        /** @internal */
        ApplicationRef_._tickScope = profile_1.wtfCreateScope('ApplicationRef#tick()');
        return ApplicationRef_;
    }(ApplicationRef);
    exports.ApplicationRef_ = ApplicationRef_;
});
System.registerDynamic('angular2/src/core/zone.js', ['angular2/src/core/zone/ng_zone.js'], true, function ($__require, exports, module) {
  'use strict';"use strict";
  // Public API for Zone

  var global = this || self,
      GLOBAL = global;
  var ng_zone_1 = $__require('angular2/src/core/zone/ng_zone.js');
  exports.NgZone = ng_zone_1.NgZone;
  exports.NgZoneError = ng_zone_1.NgZoneError;
});
System.registerDynamic('angular2/src/core/render.js', ['angular2/src/core/render/api.js'], true, function ($__require, exports, module) {
  'use strict';"use strict";
  // Public API for render

  var global = this || self,
      GLOBAL = global;
  var api_1 = $__require('angular2/src/core/render/api.js');
  exports.RootRenderer = api_1.RootRenderer;
  exports.Renderer = api_1.Renderer;
  exports.RenderComponentType = api_1.RenderComponentType;
});
System.registerDynamic('angular2/src/core/linker.js', ['angular2/src/core/linker/directive_resolver.js', 'angular2/src/core/linker/view_resolver.js', 'angular2/src/core/linker/compiler.js', 'angular2/src/core/linker/view_manager.js', 'angular2/src/core/linker/query_list.js', 'angular2/src/core/linker/dynamic_component_loader.js', 'angular2/src/core/linker/element_ref.js', 'angular2/src/core/linker/template_ref.js', 'angular2/src/core/linker/view_ref.js', 'angular2/src/core/linker/view_container_ref.js'], true, function ($__require, exports, module) {
  'use strict';"use strict";
  // Public API for compiler

  var global = this || self,
      GLOBAL = global;
  var directive_resolver_1 = $__require('angular2/src/core/linker/directive_resolver.js');
  exports.DirectiveResolver = directive_resolver_1.DirectiveResolver;
  var view_resolver_1 = $__require('angular2/src/core/linker/view_resolver.js');
  exports.ViewResolver = view_resolver_1.ViewResolver;
  var compiler_1 = $__require('angular2/src/core/linker/compiler.js');
  exports.Compiler = compiler_1.Compiler;
  var view_manager_1 = $__require('angular2/src/core/linker/view_manager.js');
  exports.AppViewManager = view_manager_1.AppViewManager;
  var query_list_1 = $__require('angular2/src/core/linker/query_list.js');
  exports.QueryList = query_list_1.QueryList;
  var dynamic_component_loader_1 = $__require('angular2/src/core/linker/dynamic_component_loader.js');
  exports.DynamicComponentLoader = dynamic_component_loader_1.DynamicComponentLoader;
  var element_ref_1 = $__require('angular2/src/core/linker/element_ref.js');
  exports.ElementRef = element_ref_1.ElementRef;
  var template_ref_1 = $__require('angular2/src/core/linker/template_ref.js');
  exports.TemplateRef = template_ref_1.TemplateRef;
  var view_ref_1 = $__require('angular2/src/core/linker/view_ref.js');
  exports.EmbeddedViewRef = view_ref_1.EmbeddedViewRef;
  exports.HostViewRef = view_ref_1.HostViewRef;
  exports.ViewRef = view_ref_1.ViewRef;
  exports.HostViewFactoryRef = view_ref_1.HostViewFactoryRef;
  var view_container_ref_1 = $__require('angular2/src/core/linker/view_container_ref.js');
  exports.ViewContainerRef = view_container_ref_1.ViewContainerRef;
  var dynamic_component_loader_2 = $__require('angular2/src/core/linker/dynamic_component_loader.js');
  exports.ComponentRef = dynamic_component_loader_2.ComponentRef;
});
System.registerDynamic('angular2/src/core/debug/debug_node.js', ['angular2/src/facade/lang.js', 'angular2/src/facade/collection.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var collection_1 = $__require('angular2/src/facade/collection.js');
    var EventListener = function () {
        function EventListener(name, callback) {
            this.name = name;
            this.callback = callback;
        }
        ;
        return EventListener;
    }();
    exports.EventListener = EventListener;
    var DebugNode = function () {
        function DebugNode(nativeNode, parent) {
            this.nativeNode = nativeNode;
            if (lang_1.isPresent(parent) && parent instanceof DebugElement) {
                parent.addChild(this);
            } else {
                this.parent = null;
            }
            this.listeners = [];
            this.providerTokens = [];
        }
        DebugNode.prototype.setDebugInfo = function (info) {
            this.injector = info.injector;
            this.providerTokens = info.providerTokens;
            this.locals = info.locals;
            this.componentInstance = info.component;
        };
        DebugNode.prototype.inject = function (token) {
            return this.injector.get(token);
        };
        DebugNode.prototype.getLocal = function (name) {
            return this.locals.get(name);
        };
        return DebugNode;
    }();
    exports.DebugNode = DebugNode;
    var DebugElement = function (_super) {
        __extends(DebugElement, _super);
        function DebugElement(nativeNode, parent) {
            _super.call(this, nativeNode, parent);
            this.properties = new Map();
            this.attributes = new Map();
            this.childNodes = [];
            this.nativeElement = nativeNode;
        }
        DebugElement.prototype.addChild = function (child) {
            if (lang_1.isPresent(child)) {
                this.childNodes.push(child);
                child.parent = this;
            }
        };
        DebugElement.prototype.removeChild = function (child) {
            var childIndex = this.childNodes.indexOf(child);
            if (childIndex !== -1) {
                child.parent = null;
                this.childNodes.splice(childIndex, 1);
            }
        };
        DebugElement.prototype.insertChildrenAfter = function (child, newChildren) {
            var siblingIndex = this.childNodes.indexOf(child);
            if (siblingIndex !== -1) {
                var previousChildren = this.childNodes.slice(0, siblingIndex + 1);
                var nextChildren = this.childNodes.slice(siblingIndex + 1);
                this.childNodes = collection_1.ListWrapper.concat(collection_1.ListWrapper.concat(previousChildren, newChildren), nextChildren);
                for (var i = 0; i < newChildren.length; ++i) {
                    var newChild = newChildren[i];
                    if (lang_1.isPresent(newChild.parent)) {
                        newChild.parent.removeChild(newChild);
                    }
                    newChild.parent = this;
                }
            }
        };
        DebugElement.prototype.query = function (predicate) {
            var results = this.queryAll(predicate);
            return results.length > 0 ? results[0] : null;
        };
        DebugElement.prototype.queryAll = function (predicate) {
            var matches = [];
            _queryElementChildren(this, predicate, matches);
            return matches;
        };
        DebugElement.prototype.queryAllNodes = function (predicate) {
            var matches = [];
            _queryNodeChildren(this, predicate, matches);
            return matches;
        };
        Object.defineProperty(DebugElement.prototype, "children", {
            get: function () {
                var children = [];
                this.childNodes.forEach(function (node) {
                    if (node instanceof DebugElement) {
                        children.push(node);
                    }
                });
                return children;
            },
            enumerable: true,
            configurable: true
        });
        DebugElement.prototype.triggerEventHandler = function (eventName, eventObj) {
            this.listeners.forEach(function (listener) {
                if (listener.name == eventName) {
                    listener.callback(eventObj);
                }
            });
        };
        return DebugElement;
    }(DebugNode);
    exports.DebugElement = DebugElement;
    function asNativeElements(debugEls) {
        return debugEls.map(function (el) {
            return el.nativeElement;
        });
    }
    exports.asNativeElements = asNativeElements;
    function _queryElementChildren(element, predicate, matches) {
        element.childNodes.forEach(function (node) {
            if (node instanceof DebugElement) {
                if (predicate(node)) {
                    matches.push(node);
                }
                _queryElementChildren(node, predicate, matches);
            }
        });
    }
    function _queryNodeChildren(parentNode, predicate, matches) {
        if (parentNode instanceof DebugElement) {
            parentNode.childNodes.forEach(function (node) {
                if (predicate(node)) {
                    matches.push(node);
                }
                if (node instanceof DebugElement) {
                    _queryNodeChildren(node, predicate, matches);
                }
            });
        }
    }
    // Need to keep the nodes in a global Map so that multiple angular apps are supported.
    var _nativeNodeToDebugNode = new Map();
    function getDebugNode(nativeNode) {
        return _nativeNodeToDebugNode.get(nativeNode);
    }
    exports.getDebugNode = getDebugNode;
    function getAllDebugNodes() {
        return collection_1.MapWrapper.values(_nativeNodeToDebugNode);
    }
    exports.getAllDebugNodes = getAllDebugNodes;
    function indexDebugNode(node) {
        _nativeNodeToDebugNode.set(node.nativeNode, node);
    }
    exports.indexDebugNode = indexDebugNode;
    function removeDebugNodeFromIndex(node) {
        _nativeNodeToDebugNode.delete(node.nativeNode);
    }
    exports.removeDebugNodeFromIndex = removeDebugNodeFromIndex;
});
System.registerDynamic("angular2/src/core/platform_directives_and_pipes.js", ["angular2/src/core/di.js", "angular2/src/facade/lang.js"], true, function ($__require, exports, module) {
  'use strict';"use strict";

  var global = this || self,
      GLOBAL = global;
  var di_1 = $__require("angular2/src/core/di.js");
  var lang_1 = $__require("angular2/src/facade/lang.js");
  /**
   * A token that can be provided when bootstraping an application to make an array of directives
   * available in every component of the application.
   *
   * ### Example
   *
   * ```typescript
   * import {PLATFORM_DIRECTIVES} from 'angular2/core';
   * import {OtherDirective} from './myDirectives';
   *
   * @Component({
   *   selector: 'my-component',
   *   template: `
   *     <!-- can use other directive even though the component does not list it in `directives` -->
   *     <other-directive></other-directive>
   *   `
   * })
   * export class MyComponent {
   *   ...
   * }
   *
   * bootstrap(MyComponent, [provide(PLATFORM_DIRECTIVES, {useValue: [OtherDirective], multi:true})]);
   * ```
   */
  exports.PLATFORM_DIRECTIVES = lang_1.CONST_EXPR(new di_1.OpaqueToken("Platform Directives"));
  /**
   * A token that can be provided when bootstraping an application to make an array of pipes
   * available in every component of the application.
   *
   * ### Example
   *
   * ```typescript
   * import {PLATFORM_PIPES} from 'angular2/core';
   * import {OtherPipe} from './myPipe';
   *
   * @Component({
   *   selector: 'my-component',
   *   template: `
   *     {{123 | other-pipe}}
   *   `
   * })
   * export class MyComponent {
   *   ...
   * }
   *
   * bootstrap(MyComponent, [provide(PLATFORM_PIPES, {useValue: [OtherPipe], multi:true})]);
   * ```
   */
  exports.PLATFORM_PIPES = lang_1.CONST_EXPR(new di_1.OpaqueToken("Platform Pipes"));
});
System.registerDynamic("angular2/src/core/console.js", ["angular2/src/core/di.js", "angular2/src/facade/lang.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var di_1 = $__require("angular2/src/core/di.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var Console = function () {
        function Console() {}
        Console.prototype.log = function (message) {
            lang_1.print(message);
        };
        Console = __decorate([di_1.Injectable(), __metadata('design:paramtypes', [])], Console);
        return Console;
    }();
    exports.Console = Console;
});
System.registerDynamic('angular2/src/core/zone/ng_zone_impl.js', [], true, function ($__require, exports, module) {
    'use strict';"use strict";
    /**
     * Stores error information; delivered via [NgZone.onError] stream.
     */

    var global = this || self,
        GLOBAL = global;
    var NgZoneError = function () {
        function NgZoneError(error, stackTrace) {
            this.error = error;
            this.stackTrace = stackTrace;
        }
        return NgZoneError;
    }();
    exports.NgZoneError = NgZoneError;
    var NgZoneImpl = function () {
        function NgZoneImpl(_a) {
            var _this = this;
            var trace = _a.trace,
                onEnter = _a.onEnter,
                onLeave = _a.onLeave,
                setMicrotask = _a.setMicrotask,
                setMacrotask = _a.setMacrotask,
                onError = _a.onError;
            this.onEnter = onEnter;
            this.onLeave = onLeave;
            this.setMicrotask = setMicrotask;
            this.setMacrotask = setMacrotask;
            this.onError = onError;
            if (Zone) {
                this.outer = this.inner = Zone.current;
                if (Zone['wtfZoneSpec']) {
                    this.inner = this.inner.fork(Zone['wtfZoneSpec']);
                }
                if (trace && Zone['longStackTraceZoneSpec']) {
                    this.inner = this.inner.fork(Zone['longStackTraceZoneSpec']);
                }
                this.inner = this.inner.fork({
                    name: 'angular',
                    properties: { 'isAngularZone': true },
                    onInvokeTask: function (delegate, current, target, task, applyThis, applyArgs) {
                        try {
                            _this.onEnter();
                            return delegate.invokeTask(target, task, applyThis, applyArgs);
                        } finally {
                            _this.onLeave();
                        }
                    },
                    onInvoke: function (delegate, current, target, callback, applyThis, applyArgs, source) {
                        try {
                            _this.onEnter();
                            return delegate.invoke(target, callback, applyThis, applyArgs, source);
                        } finally {
                            _this.onLeave();
                        }
                    },
                    onHasTask: function (delegate, current, target, hasTaskState) {
                        delegate.hasTask(target, hasTaskState);
                        if (current == target) {
                            // We are only interested in hasTask events which originate from our zone
                            // (A child hasTask event is not interesting to us)
                            if (hasTaskState.change == 'microTask') {
                                _this.setMicrotask(hasTaskState.microTask);
                            } else if (hasTaskState.change == 'macroTask') {
                                _this.setMacrotask(hasTaskState.macroTask);
                            }
                        }
                    },
                    onHandleError: function (delegate, current, target, error) {
                        delegate.handleError(target, error);
                        _this.onError(new NgZoneError(error, error.stack));
                        return false;
                    }
                });
            } else {
                throw new Error('Angular2 needs to be run with Zone.js polyfill.');
            }
        }
        NgZoneImpl.isInAngularZone = function () {
            return Zone.current.get('isAngularZone') === true;
        };
        NgZoneImpl.prototype.runInner = function (fn) {
            return this.inner.runGuarded(fn);
        };
        ;
        NgZoneImpl.prototype.runOuter = function (fn) {
            return this.outer.run(fn);
        };
        ;
        return NgZoneImpl;
    }();
    exports.NgZoneImpl = NgZoneImpl;
});
System.registerDynamic('angular2/src/core/zone/ng_zone.js', ['angular2/src/facade/async.js', 'angular2/src/core/zone/ng_zone_impl.js', 'angular2/src/facade/exceptions.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var async_1 = $__require('angular2/src/facade/async.js');
    var ng_zone_impl_1 = $__require('angular2/src/core/zone/ng_zone_impl.js');
    var exceptions_1 = $__require('angular2/src/facade/exceptions.js');
    var ng_zone_impl_2 = $__require('angular2/src/core/zone/ng_zone_impl.js');
    exports.NgZoneError = ng_zone_impl_2.NgZoneError;
    /**
     * An injectable service for executing work inside or outside of the Angular zone.
     *
     * The most common use of this service is to optimize performance when starting a work consisting of
     * one or more asynchronous tasks that don't require UI updates or error handling to be handled by
     * Angular. Such tasks can be kicked off via {@link #runOutsideAngular} and if needed, these tasks
     * can reenter the Angular zone via {@link #run}.
     *
     * <!-- TODO: add/fix links to:
     *   - docs explaining zones and the use of zones in Angular and change-detection
     *   - link to runOutsideAngular/run (throughout this file!)
     *   -->
     *
     * ### Example ([live demo](http://plnkr.co/edit/lY9m8HLy7z06vDoUaSN2?p=preview))
     * ```
     * import {Component, View, NgZone} from 'angular2/core';
     * import {NgIf} from 'angular2/common';
     *
     * @Component({
     *   selector: 'ng-zone-demo'.
     *   template: `
     *     <h2>Demo: NgZone</h2>
     *
     *     <p>Progress: {{progress}}%</p>
     *     <p *ngIf="progress >= 100">Done processing {{label}} of Angular zone!</p>
     *
     *     <button (click)="processWithinAngularZone()">Process within Angular zone</button>
     *     <button (click)="processOutsideOfAngularZone()">Process outside of Angular zone</button>
     *   `,
     *   directives: [NgIf]
     * })
     * export class NgZoneDemo {
     *   progress: number = 0;
     *   label: string;
     *
     *   constructor(private _ngZone: NgZone) {}
     *
     *   // Loop inside the Angular zone
     *   // so the UI DOES refresh after each setTimeout cycle
     *   processWithinAngularZone() {
     *     this.label = 'inside';
     *     this.progress = 0;
     *     this._increaseProgress(() => console.log('Inside Done!'));
     *   }
     *
     *   // Loop outside of the Angular zone
     *   // so the UI DOES NOT refresh after each setTimeout cycle
     *   processOutsideOfAngularZone() {
     *     this.label = 'outside';
     *     this.progress = 0;
     *     this._ngZone.runOutsideAngular(() => {
     *       this._increaseProgress(() => {
     *       // reenter the Angular zone and display done
     *       this._ngZone.run(() => {console.log('Outside Done!') });
     *     }}));
     *   }
     *
     *
     *   _increaseProgress(doneCallback: () => void) {
     *     this.progress += 1;
     *     console.log(`Current progress: ${this.progress}%`);
     *
     *     if (this.progress < 100) {
     *       window.setTimeout(() => this._increaseProgress(doneCallback)), 10)
     *     } else {
     *       doneCallback();
     *     }
     *   }
     * }
     * ```
     */
    var NgZone = function () {
        /**
         * @param {bool} enableLongStackTrace whether to enable long stack trace. They should only be
         *               enabled in development mode as they significantly impact perf.
         */
        function NgZone(_a) {
            var _this = this;
            var _b = _a.enableLongStackTrace,
                enableLongStackTrace = _b === void 0 ? false : _b;
            this._hasPendingMicrotasks = false;
            this._hasPendingMacrotasks = false;
            /** @internal */
            this._isStable = true;
            /** @internal */
            this._nesting = 0;
            /** @internal */
            this._onUnstable = new async_1.EventEmitter(false);
            /** @internal */
            this._onMicrotaskEmpty = new async_1.EventEmitter(false);
            /** @internal */
            this._onStable = new async_1.EventEmitter(false);
            /** @internal */
            this._onErrorEvents = new async_1.EventEmitter(false);
            this._zoneImpl = new ng_zone_impl_1.NgZoneImpl({
                trace: enableLongStackTrace,
                onEnter: function () {
                    // console.log('ZONE.enter', this._nesting, this._isStable);
                    _this._nesting++;
                    if (_this._isStable) {
                        _this._isStable = false;
                        _this._onUnstable.emit(null);
                    }
                },
                onLeave: function () {
                    _this._nesting--;
                    // console.log('ZONE.leave', this._nesting, this._isStable);
                    _this._checkStable();
                },
                setMicrotask: function (hasMicrotasks) {
                    _this._hasPendingMicrotasks = hasMicrotasks;
                    _this._checkStable();
                },
                setMacrotask: function (hasMacrotasks) {
                    _this._hasPendingMacrotasks = hasMacrotasks;
                },
                onError: function (error) {
                    return _this._onErrorEvents.emit(error);
                }
            });
        }
        NgZone.isInAngularZone = function () {
            return ng_zone_impl_1.NgZoneImpl.isInAngularZone();
        };
        NgZone.assertInAngularZone = function () {
            if (!ng_zone_impl_1.NgZoneImpl.isInAngularZone()) {
                throw new exceptions_1.BaseException('Expected to be in Angular Zone, but it is not!');
            }
        };
        NgZone.assertNotInAngularZone = function () {
            if (ng_zone_impl_1.NgZoneImpl.isInAngularZone()) {
                throw new exceptions_1.BaseException('Expected to not be in Angular Zone, but it is!');
            }
        };
        NgZone.prototype._checkStable = function () {
            var _this = this;
            if (this._nesting == 0) {
                if (!this._hasPendingMicrotasks && !this._isStable) {
                    try {
                        // console.log('ZONE.microtaskEmpty');
                        this._nesting++;
                        this._onMicrotaskEmpty.emit(null);
                    } finally {
                        this._nesting--;
                        if (!this._hasPendingMicrotasks) {
                            try {
                                // console.log('ZONE.stable', this._nesting, this._isStable);
                                this.runOutsideAngular(function () {
                                    return _this._onStable.emit(null);
                                });
                            } finally {
                                this._isStable = true;
                            }
                        }
                    }
                }
            }
        };
        ;
        Object.defineProperty(NgZone.prototype, "onUnstable", {
            /**
             * Notifies when code enters Angular Zone. This gets fired first on VM Turn.
             */
            get: function () {
                return this._onUnstable;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgZone.prototype, "onMicrotaskEmpty", {
            /**
             * Notifies when there is no more microtasks enqueue in the current VM Turn.
             * This is a hint for Angular to do change detection, which may enqueue more microtasks.
             * For this reason this event can fire multiple times per VM Turn.
             */
            get: function () {
                return this._onMicrotaskEmpty;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgZone.prototype, "onStable", {
            /**
             * Notifies when the last `onMicrotaskEmpty` has run and there are no more microtasks, which
             * implies we are about to relinquish VM turn.
             * This event gets called just once.
             */
            get: function () {
                return this._onStable;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgZone.prototype, "onError", {
            /**
             * Notify that an error has been delivered.
             */
            get: function () {
                return this._onErrorEvents;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgZone.prototype, "hasPendingMicrotasks", {
            /**
             * Whether there are any outstanding microtasks.
             */
            get: function () {
                return this._hasPendingMicrotasks;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(NgZone.prototype, "hasPendingMacrotasks", {
            /**
             * Whether there are any outstanding microtasks.
             */
            get: function () {
                return this._hasPendingMacrotasks;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Executes the `fn` function synchronously within the Angular zone and returns value returned by
         * the function.
         *
         * Running functions via `run` allows you to reenter Angular zone from a task that was executed
         * outside of the Angular zone (typically started via {@link #runOutsideAngular}).
         *
         * Any future tasks or microtasks scheduled from within this function will continue executing from
         * within the Angular zone.
         */
        NgZone.prototype.run = function (fn) {
            return this._zoneImpl.runInner(fn);
        };
        /**
         * Executes the `fn` function synchronously in Angular's parent zone and returns value returned by
         * the function.
         *
         * Running functions via `runOutsideAngular` allows you to escape Angular's zone and do work that
         * doesn't trigger Angular change-detection or is subject to Angular's error handling.
         *
         * Any future tasks or microtasks scheduled from within this function will continue executing from
         * outside of the Angular zone.
         *
         * Use {@link #run} to reenter the Angular zone and do work that updates the application model.
         */
        NgZone.prototype.runOutsideAngular = function (fn) {
            return this._zoneImpl.runOuter(fn);
        };
        return NgZone;
    }();
    exports.NgZone = NgZone;
});
System.registerDynamic("angular2/src/core/testability/testability.js", ["angular2/src/core/di.js", "angular2/src/facade/collection.js", "angular2/src/facade/lang.js", "angular2/src/facade/exceptions.js", "angular2/src/core/zone/ng_zone.js", "angular2/src/facade/async.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var di_1 = $__require("angular2/src/core/di.js");
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var exceptions_1 = $__require("angular2/src/facade/exceptions.js");
    var ng_zone_1 = $__require("angular2/src/core/zone/ng_zone.js");
    var async_1 = $__require("angular2/src/facade/async.js");
    /**
     * The Testability service provides testing hooks that can be accessed from
     * the browser and by services such as Protractor. Each bootstrapped Angular
     * application on the page will have an instance of Testability.
     */
    var Testability = function () {
        function Testability(_ngZone) {
            this._ngZone = _ngZone;
            /** @internal */
            this._pendingCount = 0;
            /** @internal */
            this._isZoneStable = true;
            /**
             * Whether any work was done since the last 'whenStable' callback. This is
             * useful to detect if this could have potentially destabilized another
             * component while it is stabilizing.
             * @internal
             */
            this._didWork = false;
            /** @internal */
            this._callbacks = [];
            this._watchAngularEvents();
        }
        /** @internal */
        Testability.prototype._watchAngularEvents = function () {
            var _this = this;
            async_1.ObservableWrapper.subscribe(this._ngZone.onUnstable, function (_) {
                _this._didWork = true;
                _this._isZoneStable = false;
            });
            this._ngZone.runOutsideAngular(function () {
                async_1.ObservableWrapper.subscribe(_this._ngZone.onStable, function (_) {
                    ng_zone_1.NgZone.assertNotInAngularZone();
                    lang_1.scheduleMicroTask(function () {
                        _this._isZoneStable = true;
                        _this._runCallbacksIfReady();
                    });
                });
            });
        };
        Testability.prototype.increasePendingRequestCount = function () {
            this._pendingCount += 1;
            this._didWork = true;
            return this._pendingCount;
        };
        Testability.prototype.decreasePendingRequestCount = function () {
            this._pendingCount -= 1;
            if (this._pendingCount < 0) {
                throw new exceptions_1.BaseException('pending async requests below zero');
            }
            this._runCallbacksIfReady();
            return this._pendingCount;
        };
        Testability.prototype.isStable = function () {
            return this._isZoneStable && this._pendingCount == 0 && !this._ngZone.hasPendingMacrotasks;
        };
        /** @internal */
        Testability.prototype._runCallbacksIfReady = function () {
            var _this = this;
            if (this.isStable()) {
                // Schedules the call backs in a new frame so that it is always async.
                lang_1.scheduleMicroTask(function () {
                    while (_this._callbacks.length !== 0) {
                        _this._callbacks.pop()(_this._didWork);
                    }
                    _this._didWork = false;
                });
            } else {
                // Not Ready
                this._didWork = true;
            }
        };
        Testability.prototype.whenStable = function (callback) {
            this._callbacks.push(callback);
            this._runCallbacksIfReady();
        };
        Testability.prototype.getPendingRequestCount = function () {
            return this._pendingCount;
        };
        Testability.prototype.findBindings = function (using, provider, exactMatch) {
            // TODO(juliemr): implement.
            return [];
        };
        Testability.prototype.findProviders = function (using, provider, exactMatch) {
            // TODO(juliemr): implement.
            return [];
        };
        Testability = __decorate([di_1.Injectable(), __metadata('design:paramtypes', [ng_zone_1.NgZone])], Testability);
        return Testability;
    }();
    exports.Testability = Testability;
    /**
     * A global registry of {@link Testability} instances for specific elements.
     */
    var TestabilityRegistry = function () {
        function TestabilityRegistry() {
            /** @internal */
            this._applications = new collection_1.Map();
            _testabilityGetter.addToWindow(this);
        }
        TestabilityRegistry.prototype.registerApplication = function (token, testability) {
            this._applications.set(token, testability);
        };
        TestabilityRegistry.prototype.getTestability = function (elem) {
            return this._applications.get(elem);
        };
        TestabilityRegistry.prototype.getAllTestabilities = function () {
            return collection_1.MapWrapper.values(this._applications);
        };
        TestabilityRegistry.prototype.getAllRootElements = function () {
            return collection_1.MapWrapper.keys(this._applications);
        };
        TestabilityRegistry.prototype.findTestabilityInTree = function (elem, findInAncestors) {
            if (findInAncestors === void 0) {
                findInAncestors = true;
            }
            return _testabilityGetter.findTestabilityInTree(this, elem, findInAncestors);
        };
        TestabilityRegistry = __decorate([di_1.Injectable(), __metadata('design:paramtypes', [])], TestabilityRegistry);
        return TestabilityRegistry;
    }();
    exports.TestabilityRegistry = TestabilityRegistry;
    var _NoopGetTestability = function () {
        function _NoopGetTestability() {}
        _NoopGetTestability.prototype.addToWindow = function (registry) {};
        _NoopGetTestability.prototype.findTestabilityInTree = function (registry, elem, findInAncestors) {
            return null;
        };
        _NoopGetTestability = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [])], _NoopGetTestability);
        return _NoopGetTestability;
    }();
    /**
     * Set the {@link GetTestability} implementation used by the Angular testing framework.
     */
    function setTestabilityGetter(getter) {
        _testabilityGetter = getter;
    }
    exports.setTestabilityGetter = setTestabilityGetter;
    var _testabilityGetter = lang_1.CONST_EXPR(new _NoopGetTestability());
});
System.registerDynamic('angular2/src/core/platform_common_providers.js', ['angular2/src/facade/lang.js', 'angular2/src/core/di.js', 'angular2/src/core/console.js', 'angular2/src/core/reflection/reflection.js', 'angular2/src/core/reflection/reflector_reader.js', 'angular2/src/core/testability/testability.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var di_1 = $__require('angular2/src/core/di.js');
    var console_1 = $__require('angular2/src/core/console.js');
    var reflection_1 = $__require('angular2/src/core/reflection/reflection.js');
    var reflector_reader_1 = $__require('angular2/src/core/reflection/reflector_reader.js');
    var testability_1 = $__require('angular2/src/core/testability/testability.js');
    function _reflector() {
        return reflection_1.reflector;
    }
    /**
     * A default set of providers which should be included in any Angular platform.
     */
    exports.PLATFORM_COMMON_PROVIDERS = lang_1.CONST_EXPR([new di_1.Provider(reflection_1.Reflector, { useFactory: _reflector, deps: [] }), new di_1.Provider(reflector_reader_1.ReflectorReader, { useExisting: reflection_1.Reflector }), testability_1.TestabilityRegistry, console_1.Console]);
});
System.registerDynamic("angular2/src/core/linker/resolved_metadata_cache.js", ["angular2/src/core/di.js", "angular2/src/facade/lang.js", "angular2/src/core/linker/element.js", "angular2/src/core/linker/directive_resolver.js", "angular2/src/core/pipes/pipe_provider.js", "angular2/src/core/linker/pipe_resolver.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var di_1 = $__require("angular2/src/core/di.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var element_1 = $__require("angular2/src/core/linker/element.js");
    var directive_resolver_1 = $__require("angular2/src/core/linker/directive_resolver.js");
    var pipe_provider_1 = $__require("angular2/src/core/pipes/pipe_provider.js");
    var pipe_resolver_1 = $__require("angular2/src/core/linker/pipe_resolver.js");
    var ResolvedMetadataCache = function () {
        function ResolvedMetadataCache(_directiveResolver, _pipeResolver) {
            this._directiveResolver = _directiveResolver;
            this._pipeResolver = _pipeResolver;
            this._directiveCache = new Map();
            this._pipeCache = new Map();
        }
        ResolvedMetadataCache.prototype.getResolvedDirectiveMetadata = function (type) {
            var result = this._directiveCache.get(type);
            if (lang_1.isBlank(result)) {
                result = element_1.DirectiveProvider.createFromType(type, this._directiveResolver.resolve(type));
                this._directiveCache.set(type, result);
            }
            return result;
        };
        ResolvedMetadataCache.prototype.getResolvedPipeMetadata = function (type) {
            var result = this._pipeCache.get(type);
            if (lang_1.isBlank(result)) {
                result = pipe_provider_1.PipeProvider.createFromType(type, this._pipeResolver.resolve(type));
                this._pipeCache.set(type, result);
            }
            return result;
        };
        ResolvedMetadataCache = __decorate([di_1.Injectable(), __metadata('design:paramtypes', [directive_resolver_1.DirectiveResolver, pipe_resolver_1.PipeResolver])], ResolvedMetadataCache);
        return ResolvedMetadataCache;
    }();
    exports.ResolvedMetadataCache = ResolvedMetadataCache;
    exports.CODEGEN_RESOLVED_METADATA_CACHE = new ResolvedMetadataCache(directive_resolver_1.CODEGEN_DIRECTIVE_RESOLVER, pipe_resolver_1.CODEGEN_PIPE_RESOLVER);
});
System.registerDynamic("angular2/src/core/linker/view_resolver.js", ["angular2/src/core/di.js", "angular2/src/core/metadata/view.js", "angular2/src/core/metadata/directives.js", "angular2/src/facade/lang.js", "angular2/src/facade/exceptions.js", "angular2/src/facade/collection.js", "angular2/src/core/reflection/reflector_reader.js", "angular2/src/core/reflection/reflection.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var di_1 = $__require("angular2/src/core/di.js");
    var view_1 = $__require("angular2/src/core/metadata/view.js");
    var directives_1 = $__require("angular2/src/core/metadata/directives.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var exceptions_1 = $__require("angular2/src/facade/exceptions.js");
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var reflector_reader_1 = $__require("angular2/src/core/reflection/reflector_reader.js");
    var reflection_1 = $__require("angular2/src/core/reflection/reflection.js");
    /**
     * Resolves types to {@link ViewMetadata}.
     */
    var ViewResolver = function () {
        function ViewResolver(_reflector) {
            /** @internal */
            this._cache = new collection_1.Map();
            if (lang_1.isPresent(_reflector)) {
                this._reflector = _reflector;
            } else {
                this._reflector = reflection_1.reflector;
            }
        }
        ViewResolver.prototype.resolve = function (component) {
            var view = this._cache.get(component);
            if (lang_1.isBlank(view)) {
                view = this._resolve(component);
                this._cache.set(component, view);
            }
            return view;
        };
        /** @internal */
        ViewResolver.prototype._resolve = function (component) {
            var compMeta;
            var viewMeta;
            this._reflector.annotations(component).forEach(function (m) {
                if (m instanceof view_1.ViewMetadata) {
                    viewMeta = m;
                }
                if (m instanceof directives_1.ComponentMetadata) {
                    compMeta = m;
                }
            });
            if (lang_1.isPresent(compMeta)) {
                if (lang_1.isBlank(compMeta.template) && lang_1.isBlank(compMeta.templateUrl) && lang_1.isBlank(viewMeta)) {
                    throw new exceptions_1.BaseException("Component '" + lang_1.stringify(component) + "' must have either 'template' or 'templateUrl' set.");
                } else if (lang_1.isPresent(compMeta.template) && lang_1.isPresent(viewMeta)) {
                    this._throwMixingViewAndComponent("template", component);
                } else if (lang_1.isPresent(compMeta.templateUrl) && lang_1.isPresent(viewMeta)) {
                    this._throwMixingViewAndComponent("templateUrl", component);
                } else if (lang_1.isPresent(compMeta.directives) && lang_1.isPresent(viewMeta)) {
                    this._throwMixingViewAndComponent("directives", component);
                } else if (lang_1.isPresent(compMeta.pipes) && lang_1.isPresent(viewMeta)) {
                    this._throwMixingViewAndComponent("pipes", component);
                } else if (lang_1.isPresent(compMeta.encapsulation) && lang_1.isPresent(viewMeta)) {
                    this._throwMixingViewAndComponent("encapsulation", component);
                } else if (lang_1.isPresent(compMeta.styles) && lang_1.isPresent(viewMeta)) {
                    this._throwMixingViewAndComponent("styles", component);
                } else if (lang_1.isPresent(compMeta.styleUrls) && lang_1.isPresent(viewMeta)) {
                    this._throwMixingViewAndComponent("styleUrls", component);
                } else if (lang_1.isPresent(viewMeta)) {
                    return viewMeta;
                } else {
                    return new view_1.ViewMetadata({
                        templateUrl: compMeta.templateUrl,
                        template: compMeta.template,
                        directives: compMeta.directives,
                        pipes: compMeta.pipes,
                        encapsulation: compMeta.encapsulation,
                        styles: compMeta.styles,
                        styleUrls: compMeta.styleUrls
                    });
                }
            } else {
                if (lang_1.isBlank(viewMeta)) {
                    throw new exceptions_1.BaseException("Could not compile '" + lang_1.stringify(component) + "' because it is not a component.");
                } else {
                    return viewMeta;
                }
            }
            return null;
        };
        /** @internal */
        ViewResolver.prototype._throwMixingViewAndComponent = function (propertyName, component) {
            throw new exceptions_1.BaseException("Component '" + lang_1.stringify(component) + "' cannot have both '" + propertyName + "' and '@View' set at the same time\"");
        };
        ViewResolver = __decorate([di_1.Injectable(), __metadata('design:paramtypes', [reflector_reader_1.ReflectorReader])], ViewResolver);
        return ViewResolver;
    }();
    exports.ViewResolver = ViewResolver;
});
System.registerDynamic("angular2/src/core/linker/directive_resolver.js", ["angular2/src/core/di.js", "angular2/src/facade/lang.js", "angular2/src/facade/exceptions.js", "angular2/src/facade/collection.js", "angular2/src/core/metadata.js", "angular2/src/core/reflection/reflection.js", "angular2/src/core/reflection/reflector_reader.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var di_1 = $__require("angular2/src/core/di.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var exceptions_1 = $__require("angular2/src/facade/exceptions.js");
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var metadata_1 = $__require("angular2/src/core/metadata.js");
    var reflection_1 = $__require("angular2/src/core/reflection/reflection.js");
    var reflector_reader_1 = $__require("angular2/src/core/reflection/reflector_reader.js");
    function _isDirectiveMetadata(type) {
        return type instanceof metadata_1.DirectiveMetadata;
    }
    /*
     * Resolve a `Type` for {@link DirectiveMetadata}.
     *
     * This interface can be overridden by the application developer to create custom behavior.
     *
     * See {@link Compiler}
     */
    var DirectiveResolver = function () {
        function DirectiveResolver(_reflector) {
            if (lang_1.isPresent(_reflector)) {
                this._reflector = _reflector;
            } else {
                this._reflector = reflection_1.reflector;
            }
        }
        /**
         * Return {@link DirectiveMetadata} for a given `Type`.
         */
        DirectiveResolver.prototype.resolve = function (type) {
            var typeMetadata = this._reflector.annotations(di_1.resolveForwardRef(type));
            if (lang_1.isPresent(typeMetadata)) {
                var metadata = typeMetadata.find(_isDirectiveMetadata);
                if (lang_1.isPresent(metadata)) {
                    var propertyMetadata = this._reflector.propMetadata(type);
                    return this._mergeWithPropertyMetadata(metadata, propertyMetadata, type);
                }
            }
            throw new exceptions_1.BaseException("No Directive annotation found on " + lang_1.stringify(type));
        };
        DirectiveResolver.prototype._mergeWithPropertyMetadata = function (dm, propertyMetadata, directiveType) {
            var inputs = [];
            var outputs = [];
            var host = {};
            var queries = {};
            collection_1.StringMapWrapper.forEach(propertyMetadata, function (metadata, propName) {
                metadata.forEach(function (a) {
                    if (a instanceof metadata_1.InputMetadata) {
                        if (lang_1.isPresent(a.bindingPropertyName)) {
                            inputs.push(propName + ": " + a.bindingPropertyName);
                        } else {
                            inputs.push(propName);
                        }
                    }
                    if (a instanceof metadata_1.OutputMetadata) {
                        if (lang_1.isPresent(a.bindingPropertyName)) {
                            outputs.push(propName + ": " + a.bindingPropertyName);
                        } else {
                            outputs.push(propName);
                        }
                    }
                    if (a instanceof metadata_1.HostBindingMetadata) {
                        if (lang_1.isPresent(a.hostPropertyName)) {
                            host["[" + a.hostPropertyName + "]"] = propName;
                        } else {
                            host["[" + propName + "]"] = propName;
                        }
                    }
                    if (a instanceof metadata_1.HostListenerMetadata) {
                        var args = lang_1.isPresent(a.args) ? a.args.join(', ') : '';
                        host["(" + a.eventName + ")"] = propName + "(" + args + ")";
                    }
                    if (a instanceof metadata_1.ContentChildrenMetadata) {
                        queries[propName] = a;
                    }
                    if (a instanceof metadata_1.ViewChildrenMetadata) {
                        queries[propName] = a;
                    }
                    if (a instanceof metadata_1.ContentChildMetadata) {
                        queries[propName] = a;
                    }
                    if (a instanceof metadata_1.ViewChildMetadata) {
                        queries[propName] = a;
                    }
                });
            });
            return this._merge(dm, inputs, outputs, host, queries, directiveType);
        };
        DirectiveResolver.prototype._merge = function (dm, inputs, outputs, host, queries, directiveType) {
            var mergedInputs = lang_1.isPresent(dm.inputs) ? collection_1.ListWrapper.concat(dm.inputs, inputs) : inputs;
            var mergedOutputs;
            if (lang_1.isPresent(dm.outputs)) {
                dm.outputs.forEach(function (propName) {
                    if (collection_1.ListWrapper.contains(outputs, propName)) {
                        throw new exceptions_1.BaseException("Output event '" + propName + "' defined multiple times in '" + lang_1.stringify(directiveType) + "'");
                    }
                });
                mergedOutputs = collection_1.ListWrapper.concat(dm.outputs, outputs);
            } else {
                mergedOutputs = outputs;
            }
            var mergedHost = lang_1.isPresent(dm.host) ? collection_1.StringMapWrapper.merge(dm.host, host) : host;
            var mergedQueries = lang_1.isPresent(dm.queries) ? collection_1.StringMapWrapper.merge(dm.queries, queries) : queries;
            if (dm instanceof metadata_1.ComponentMetadata) {
                return new metadata_1.ComponentMetadata({
                    selector: dm.selector,
                    inputs: mergedInputs,
                    outputs: mergedOutputs,
                    host: mergedHost,
                    exportAs: dm.exportAs,
                    moduleId: dm.moduleId,
                    queries: mergedQueries,
                    changeDetection: dm.changeDetection,
                    providers: dm.providers,
                    viewProviders: dm.viewProviders
                });
            } else {
                return new metadata_1.DirectiveMetadata({
                    selector: dm.selector,
                    inputs: mergedInputs,
                    outputs: mergedOutputs,
                    host: mergedHost,
                    exportAs: dm.exportAs,
                    queries: mergedQueries,
                    providers: dm.providers
                });
            }
        };
        DirectiveResolver = __decorate([di_1.Injectable(), __metadata('design:paramtypes', [reflector_reader_1.ReflectorReader])], DirectiveResolver);
        return DirectiveResolver;
    }();
    exports.DirectiveResolver = DirectiveResolver;
    exports.CODEGEN_DIRECTIVE_RESOLVER = new DirectiveResolver(reflection_1.reflector);
});
System.registerDynamic("angular2/src/core/metadata/view.js", ["angular2/src/facade/lang.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var lang_1 = $__require("angular2/src/facade/lang.js");
    /**
     * Defines template and style encapsulation options available for Component's {@link View}.
     *
     * See {@link ViewMetadata#encapsulation}.
     */
    (function (ViewEncapsulation) {
        /**
         * Emulate `Native` scoping of styles by adding an attribute containing surrogate id to the Host
         * Element and pre-processing the style rules provided via
         * {@link ViewMetadata#styles} or {@link ViewMetadata#stylesUrls}, and adding the new Host Element
         * attribute to all selectors.
         *
         * This is the default option.
         */
        ViewEncapsulation[ViewEncapsulation["Emulated"] = 0] = "Emulated";
        /**
         * Use the native encapsulation mechanism of the renderer.
         *
         * For the DOM this means using [Shadow DOM](https://w3c.github.io/webcomponents/spec/shadow/) and
         * creating a ShadowRoot for Component's Host Element.
         */
        ViewEncapsulation[ViewEncapsulation["Native"] = 1] = "Native";
        /**
         * Don't provide any template or style encapsulation.
         */
        ViewEncapsulation[ViewEncapsulation["None"] = 2] = "None";
    })(exports.ViewEncapsulation || (exports.ViewEncapsulation = {}));
    var ViewEncapsulation = exports.ViewEncapsulation;
    exports.VIEW_ENCAPSULATION_VALUES = [ViewEncapsulation.Emulated, ViewEncapsulation.Native, ViewEncapsulation.None];
    /**
     * Metadata properties available for configuring Views.
     *
     * Each Angular component requires a single `@Component` and at least one `@View` annotation. The
     * `@View` annotation specifies the HTML template to use, and lists the directives that are active
     * within the template.
     *
     * When a component is instantiated, the template is loaded into the component's shadow root, and
     * the expressions and statements in the template are evaluated against the component.
     *
     * For details on the `@Component` annotation, see {@link ComponentMetadata}.
     *
     * ### Example
     *
     * ```
     * @Component({
     *   selector: 'greet',
     *   template: 'Hello {{name}}!',
     *   directives: [GreetUser, Bold]
     * })
     * class Greet {
     *   name: string;
     *
     *   constructor() {
     *     this.name = 'World';
     *   }
     * }
     * ```
     */
    var ViewMetadata = function () {
        function ViewMetadata(_a) {
            var _b = _a === void 0 ? {} : _a,
                templateUrl = _b.templateUrl,
                template = _b.template,
                directives = _b.directives,
                pipes = _b.pipes,
                encapsulation = _b.encapsulation,
                styles = _b.styles,
                styleUrls = _b.styleUrls;
            this.templateUrl = templateUrl;
            this.template = template;
            this.styleUrls = styleUrls;
            this.styles = styles;
            this.directives = directives;
            this.pipes = pipes;
            this.encapsulation = encapsulation;
        }
        ViewMetadata = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [Object])], ViewMetadata);
        return ViewMetadata;
    }();
    exports.ViewMetadata = ViewMetadata;
});
System.registerDynamic('angular2/src/core/metadata.js', ['angular2/src/core/metadata/di.js', 'angular2/src/core/metadata/directives.js', 'angular2/src/core/metadata/view.js', 'angular2/src/core/util/decorators.js'], true, function ($__require, exports, module) {
  'use strict'; /**
                * This indirection is needed to free up Component, etc symbols in the public API
                * to be used by the decorator versions of these annotations.
                */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var di_1 = $__require('angular2/src/core/metadata/di.js');
  exports.QueryMetadata = di_1.QueryMetadata;
  exports.ContentChildrenMetadata = di_1.ContentChildrenMetadata;
  exports.ContentChildMetadata = di_1.ContentChildMetadata;
  exports.ViewChildrenMetadata = di_1.ViewChildrenMetadata;
  exports.ViewQueryMetadata = di_1.ViewQueryMetadata;
  exports.ViewChildMetadata = di_1.ViewChildMetadata;
  exports.AttributeMetadata = di_1.AttributeMetadata;
  var directives_1 = $__require('angular2/src/core/metadata/directives.js');
  exports.ComponentMetadata = directives_1.ComponentMetadata;
  exports.DirectiveMetadata = directives_1.DirectiveMetadata;
  exports.PipeMetadata = directives_1.PipeMetadata;
  exports.InputMetadata = directives_1.InputMetadata;
  exports.OutputMetadata = directives_1.OutputMetadata;
  exports.HostBindingMetadata = directives_1.HostBindingMetadata;
  exports.HostListenerMetadata = directives_1.HostListenerMetadata;
  var view_1 = $__require('angular2/src/core/metadata/view.js');
  exports.ViewMetadata = view_1.ViewMetadata;
  exports.ViewEncapsulation = view_1.ViewEncapsulation;
  var di_2 = $__require('angular2/src/core/metadata/di.js');
  var directives_2 = $__require('angular2/src/core/metadata/directives.js');
  var view_2 = $__require('angular2/src/core/metadata/view.js');
  var decorators_1 = $__require('angular2/src/core/util/decorators.js');
  // TODO(alexeagle): remove the duplication of this doc. It is copied from ComponentMetadata.
  /**
   * Declare reusable UI building blocks for an application.
   *
   * Each Angular component requires a single `@Component` annotation. The `@Component`
   * annotation specifies when a component is instantiated, and which properties and hostListeners it
   * binds to.
   *
   * When a component is instantiated, Angular
   * - creates a shadow DOM for the component.
   * - loads the selected template into the shadow DOM.
   * - creates all the injectable objects configured with `providers` and `viewProviders`.
   *
   * All template expressions and statements are then evaluated against the component instance.
   *
   * ## Lifecycle hooks
   *
   * When the component class implements some {@link angular2/lifecycle_hooks} the callbacks are
   * called by the change detection at defined points in time during the life of the component.
   *
   * ### Example
   *
   * {@example core/ts/metadata/metadata.ts region='component'}
   */
  exports.Component = decorators_1.makeDecorator(directives_2.ComponentMetadata, function (fn) {
    return fn.View = View;
  });
  // TODO(alexeagle): remove the duplication of this doc. It is copied from DirectiveMetadata.
  /**
   * Directives allow you to attach behavior to elements in the DOM.
   *
   * {@link DirectiveMetadata}s with an embedded view are called {@link ComponentMetadata}s.
   *
   * A directive consists of a single directive annotation and a controller class. When the
   * directive's `selector` matches
   * elements in the DOM, the following steps occur:
   *
   * 1. For each directive, the `ElementInjector` attempts to resolve the directive's constructor
   * arguments.
   * 2. Angular instantiates directives for each matched element using `ElementInjector` in a
   * depth-first order,
   *    as declared in the HTML.
   *
   * ## Understanding How Injection Works
   *
   * There are three stages of injection resolution.
   * - *Pre-existing Injectors*:
   *   - The terminal {@link Injector} cannot resolve dependencies. It either throws an error or, if
   * the dependency was
   *     specified as `@Optional`, returns `null`.
   *   - The platform injector resolves browser singleton resources, such as: cookies, title,
   * location, and others.
   * - *Component Injectors*: Each component instance has its own {@link Injector}, and they follow
   * the same parent-child hierarchy
   *     as the component instances in the DOM.
   * - *Element Injectors*: Each component instance has a Shadow DOM. Within the Shadow DOM each
   * element has an `ElementInjector`
   *     which follow the same parent-child hierarchy as the DOM elements themselves.
   *
   * When a template is instantiated, it also must instantiate the corresponding directives in a
   * depth-first order. The
   * current `ElementInjector` resolves the constructor dependencies for each directive.
   *
   * Angular then resolves dependencies as follows, according to the order in which they appear in the
   * {@link ViewMetadata}:
   *
   * 1. Dependencies on the current element
   * 2. Dependencies on element injectors and their parents until it encounters a Shadow DOM boundary
   * 3. Dependencies on component injectors and their parents until it encounters the root component
   * 4. Dependencies on pre-existing injectors
   *
   *
   * The `ElementInjector` can inject other directives, element-specific special objects, or it can
   * delegate to the parent
   * injector.
   *
   * To inject other directives, declare the constructor parameter as:
   * - `directive:DirectiveType`: a directive on the current element only
   * - `@Host() directive:DirectiveType`: any directive that matches the type between the current
   * element and the
   *    Shadow DOM root.
   * - `@Query(DirectiveType) query:QueryList<DirectiveType>`: A live collection of direct child
   * directives.
   * - `@QueryDescendants(DirectiveType) query:QueryList<DirectiveType>`: A live collection of any
   * child directives.
   *
   * To inject element-specific special objects, declare the constructor parameter as:
   * - `element: ElementRef` to obtain a reference to logical element in the view.
   * - `viewContainer: ViewContainerRef` to control child template instantiation, for
   * {@link DirectiveMetadata} directives only
   * - `bindingPropagation: BindingPropagation` to control change detection in a more granular way.
   *
   * ### Example
   *
   * The following example demonstrates how dependency injection resolves constructor arguments in
   * practice.
   *
   *
   * Assume this HTML template:
   *
   * ```
   * <div dependency="1">
   *   <div dependency="2">
   *     <div dependency="3" my-directive>
   *       <div dependency="4">
   *         <div dependency="5"></div>
   *       </div>
   *       <div dependency="6"></div>
   *     </div>
   *   </div>
   * </div>
   * ```
   *
   * With the following `dependency` decorator and `SomeService` injectable class.
   *
   * ```
   * @Injectable()
   * class SomeService {
   * }
   *
   * @Directive({
   *   selector: '[dependency]',
   *   inputs: [
   *     'id: dependency'
   *   ]
   * })
   * class Dependency {
   *   id:string;
   * }
   * ```
   *
   * Let's step through the different ways in which `MyDirective` could be declared...
   *
   *
   * ### No injection
   *
   * Here the constructor is declared with no arguments, therefore nothing is injected into
   * `MyDirective`.
   *
   * ```
   * @Directive({ selector: '[my-directive]' })
   * class MyDirective {
   *   constructor() {
   *   }
   * }
   * ```
   *
   * This directive would be instantiated with no dependencies.
   *
   *
   * ### Component-level injection
   *
   * Directives can inject any injectable instance from the closest component injector or any of its
   * parents.
   *
   * Here, the constructor declares a parameter, `someService`, and injects the `SomeService` type
   * from the parent
   * component's injector.
   * ```
   * @Directive({ selector: '[my-directive]' })
   * class MyDirective {
   *   constructor(someService: SomeService) {
   *   }
   * }
   * ```
   *
   * This directive would be instantiated with a dependency on `SomeService`.
   *
   *
   * ### Injecting a directive from the current element
   *
   * Directives can inject other directives declared on the current element.
   *
   * ```
   * @Directive({ selector: '[my-directive]' })
   * class MyDirective {
   *   constructor(dependency: Dependency) {
   *     expect(dependency.id).toEqual(3);
   *   }
   * }
   * ```
   * This directive would be instantiated with `Dependency` declared at the same element, in this case
   * `dependency="3"`.
   *
   * ### Injecting a directive from any ancestor elements
   *
   * Directives can inject other directives declared on any ancestor element (in the current Shadow
   * DOM), i.e. on the current element, the
   * parent element, or its parents.
   * ```
   * @Directive({ selector: '[my-directive]' })
   * class MyDirective {
   *   constructor(@Host() dependency: Dependency) {
   *     expect(dependency.id).toEqual(2);
   *   }
   * }
   * ```
   *
   * `@Host` checks the current element, the parent, as well as its parents recursively. If
   * `dependency="2"` didn't
   * exist on the direct parent, this injection would
   * have returned
   * `dependency="1"`.
   *
   *
   * ### Injecting a live collection of direct child directives
   *
   *
   * A directive can also query for other child directives. Since parent directives are instantiated
   * before child directives, a directive can't simply inject the list of child directives. Instead,
   * the directive injects a {@link QueryList}, which updates its contents as children are added,
   * removed, or moved by a directive that uses a {@link ViewContainerRef} such as a `ngFor`, an
   * `ngIf`, or an `ngSwitch`.
   *
   * ```
   * @Directive({ selector: '[my-directive]' })
   * class MyDirective {
   *   constructor(@Query(Dependency) dependencies:QueryList<Dependency>) {
   *   }
   * }
   * ```
   *
   * This directive would be instantiated with a {@link QueryList} which contains `Dependency` 4 and
   * 6. Here, `Dependency` 5 would not be included, because it is not a direct child.
   *
   * ### Injecting a live collection of descendant directives
   *
   * By passing the descendant flag to `@Query` above, we can include the children of the child
   * elements.
   *
   * ```
   * @Directive({ selector: '[my-directive]' })
   * class MyDirective {
   *   constructor(@Query(Dependency, {descendants: true}) dependencies:QueryList<Dependency>) {
   *   }
   * }
   * ```
   *
   * This directive would be instantiated with a Query which would contain `Dependency` 4, 5 and 6.
   *
   * ### Optional injection
   *
   * The normal behavior of directives is to return an error when a specified dependency cannot be
   * resolved. If you
   * would like to inject `null` on unresolved dependency instead, you can annotate that dependency
   * with `@Optional()`.
   * This explicitly permits the author of a template to treat some of the surrounding directives as
   * optional.
   *
   * ```
   * @Directive({ selector: '[my-directive]' })
   * class MyDirective {
   *   constructor(@Optional() dependency:Dependency) {
   *   }
   * }
   * ```
   *
   * This directive would be instantiated with a `Dependency` directive found on the current element.
   * If none can be
   * found, the injector supplies `null` instead of throwing an error.
   *
   * ### Example
   *
   * Here we use a decorator directive to simply define basic tool-tip behavior.
   *
   * ```
   * @Directive({
   *   selector: '[tooltip]',
   *   inputs: [
   *     'text: tooltip'
   *   ],
   *   host: {
   *     '(mouseenter)': 'onMouseEnter()',
   *     '(mouseleave)': 'onMouseLeave()'
   *   }
   * })
   * class Tooltip{
   *   text:string;
   *   overlay:Overlay; // NOT YET IMPLEMENTED
   *   overlayManager:OverlayManager; // NOT YET IMPLEMENTED
   *
   *   constructor(overlayManager:OverlayManager) {
   *     this.overlay = overlay;
   *   }
   *
   *   onMouseEnter() {
   *     // exact signature to be determined
   *     this.overlay = this.overlayManager.open(text, ...);
   *   }
   *
   *   onMouseLeave() {
   *     this.overlay.close();
   *     this.overlay = null;
   *   }
   * }
   * ```
   * In our HTML template, we can then add this behavior to a `<div>` or any other element with the
   * `tooltip` selector,
   * like so:
   *
   * ```
   * <div tooltip="some text here"></div>
   * ```
   *
   * Directives can also control the instantiation, destruction, and positioning of inline template
   * elements:
   *
   * A directive uses a {@link ViewContainerRef} to instantiate, insert, move, and destroy views at
   * runtime.
   * The {@link ViewContainerRef} is created as a result of `<template>` element, and represents a
   * location in the current view
   * where these actions are performed.
   *
   * Views are always created as children of the current {@link ViewMetadata}, and as siblings of the
   * `<template>` element. Thus a
   * directive in a child view cannot inject the directive that created it.
   *
   * Since directives that create views via ViewContainers are common in Angular, and using the full
   * `<template>` element syntax is wordy, Angular
   * also supports a shorthand notation: `<li *foo="bar">` and `<li template="foo: bar">` are
   * equivalent.
   *
   * Thus,
   *
   * ```
   * <ul>
   *   <li *foo="bar" title="text"></li>
   * </ul>
   * ```
   *
   * Expands in use to:
   *
   * ```
   * <ul>
   *   <template [foo]="bar">
   *     <li title="text"></li>
   *   </template>
   * </ul>
   * ```
   *
   * Notice that although the shorthand places `*foo="bar"` within the `<li>` element, the binding for
   * the directive
   * controller is correctly instantiated on the `<template>` element rather than the `<li>` element.
   *
   * ## Lifecycle hooks
   *
   * When the directive class implements some {@link angular2/lifecycle_hooks} the callbacks are
   * called by the change detection at defined points in time during the life of the directive.
   *
   * ### Example
   *
   * Let's suppose we want to implement the `unless` behavior, to conditionally include a template.
   *
   * Here is a simple directive that triggers on an `unless` selector:
   *
   * ```
   * @Directive({
   *   selector: '[unless]',
   *   inputs: ['unless']
   * })
   * export class Unless {
   *   viewContainer: ViewContainerRef;
   *   templateRef: TemplateRef;
   *   prevCondition: boolean;
   *
   *   constructor(viewContainer: ViewContainerRef, templateRef: TemplateRef) {
   *     this.viewContainer = viewContainer;
   *     this.templateRef = templateRef;
   *     this.prevCondition = null;
   *   }
   *
   *   set unless(newCondition) {
   *     if (newCondition && (isBlank(this.prevCondition) || !this.prevCondition)) {
   *       this.prevCondition = true;
   *       this.viewContainer.clear();
   *     } else if (!newCondition && (isBlank(this.prevCondition) || this.prevCondition)) {
   *       this.prevCondition = false;
   *       this.viewContainer.create(this.templateRef);
   *     }
   *   }
   * }
   * ```
   *
   * We can then use this `unless` selector in a template:
   * ```
   * <ul>
   *   <li *unless="expr"></li>
   * </ul>
   * ```
   *
   * Once the directive instantiates the child view, the shorthand notation for the template expands
   * and the result is:
   *
   * ```
   * <ul>
   *   <template [unless]="exp">
   *     <li></li>
   *   </template>
   *   <li></li>
   * </ul>
   * ```
   *
   * Note also that although the `<li></li>` template still exists inside the `<template></template>`,
   * the instantiated
   * view occurs on the second `<li></li>` which is a sibling to the `<template>` element.
   */
  exports.Directive = decorators_1.makeDecorator(directives_2.DirectiveMetadata);
  // TODO(alexeagle): remove the duplication of this doc. It is copied from ViewMetadata.
  /**
   * Metadata properties available for configuring Views.
   *
   * Each Angular component requires a single `@Component` and at least one `@View` annotation. The
   * `@View` annotation specifies the HTML template to use, and lists the directives that are active
   * within the template.
   *
   * When a component is instantiated, the template is loaded into the component's shadow root, and
   * the expressions and statements in the template are evaluated against the component.
   *
   * For details on the `@Component` annotation, see {@link ComponentMetadata}.
   *
   * ### Example
   *
   * ```
   * @Component({
   *   selector: 'greet',
   *   template: 'Hello {{name}}!',
   *   directives: [GreetUser, Bold]
   * })
   * class Greet {
   *   name: string;
   *
   *   constructor() {
   *     this.name = 'World';
   *   }
   * }
   * ```
   */
  var View = decorators_1.makeDecorator(view_2.ViewMetadata, function (fn) {
    return fn.View = View;
  });
  /**
   * Specifies that a constant attribute value should be injected.
   *
   * The directive can inject constant string literals of host element attributes.
   *
   * ### Example
   *
   * Suppose we have an `<input>` element and want to know its `type`.
   *
   * ```html
   * <input type="text">
   * ```
   *
   * A decorator can inject string literal `text` like so:
   *
   * {@example core/ts/metadata/metadata.ts region='attributeMetadata'}
   */
  exports.Attribute = decorators_1.makeParamDecorator(di_2.AttributeMetadata);
  // TODO(alexeagle): remove the duplication of this doc. It is copied from QueryMetadata.
  /**
   * Declares an injectable parameter to be a live list of directives or variable
   * bindings from the content children of a directive.
   *
   * ### Example ([live demo](http://plnkr.co/edit/lY9m8HLy7z06vDoUaSN2?p=preview))
   *
   * Assume that `<tabs>` component would like to get a list its children `<pane>`
   * components as shown in this example:
   *
   * ```html
   * <tabs>
   *   <pane title="Overview">...</pane>
   *   <pane *ngFor="#o of objects" [title]="o.title">{{o.text}}</pane>
   * </tabs>
   * ```
   *
   * The preferred solution is to query for `Pane` directives using this decorator.
   *
   * ```javascript
   * @Component({
   *   selector: 'pane',
   *   inputs: ['title']
   * })
   * class Pane {
   *   title:string;
   * }
   *
   * @Component({
   *  selector: 'tabs',
   *  template: `
   *    <ul>
   *      <li *ngFor="#pane of panes">{{pane.title}}</li>
   *    </ul>
   *    <ng-content></ng-content>
   *  `
   * })
   * class Tabs {
   *   panes: QueryList<Pane>;
   *   constructor(@Query(Pane) panes:QueryList<Pane>) {
   *     this.panes = panes;
   *   }
   * }
   * ```
   *
   * A query can look for variable bindings by passing in a string with desired binding symbol.
   *
   * ### Example ([live demo](http://plnkr.co/edit/sT2j25cH1dURAyBRCKx1?p=preview))
   * ```html
   * <seeker>
   *   <div #findme>...</div>
   * </seeker>
   *
   * @Component({ selector: 'seeker' })
   * class seeker {
   *   constructor(@Query('findme') elList: QueryList<ElementRef>) {...}
   * }
   * ```
   *
   * In this case the object that is injected depend on the type of the variable
   * binding. It can be an ElementRef, a directive or a component.
   *
   * Passing in a comma separated list of variable bindings will query for all of them.
   *
   * ```html
   * <seeker>
   *   <div #findMe>...</div>
   *   <div #findMeToo>...</div>
   * </seeker>
   *
   *  @Component({
   *   selector: 'seeker'
   * })
   * class Seeker {
   *   constructor(@Query('findMe, findMeToo') elList: QueryList<ElementRef>) {...}
   * }
   * ```
   *
   * Configure whether query looks for direct children or all descendants
   * of the querying element, by using the `descendants` parameter.
   * It is set to `false` by default.
   *
   * ### Example ([live demo](http://plnkr.co/edit/wtGeB977bv7qvA5FTYl9?p=preview))
   * ```html
   * <container #first>
   *   <item>a</item>
   *   <item>b</item>
   *   <container #second>
   *     <item>c</item>
   *   </container>
   * </container>
   * ```
   *
   * When querying for items, the first container will see only `a` and `b` by default,
   * but with `Query(TextDirective, {descendants: true})` it will see `c` too.
   *
   * The queried directives are kept in a depth-first pre-order with respect to their
   * positions in the DOM.
   *
   * Query does not look deep into any subcomponent views.
   *
   * Query is updated as part of the change-detection cycle. Since change detection
   * happens after construction of a directive, QueryList will always be empty when observed in the
   * constructor.
   *
   * The injected object is an unmodifiable live list.
   * See {@link QueryList} for more details.
   */
  exports.Query = decorators_1.makeParamDecorator(di_2.QueryMetadata);
  // TODO(alexeagle): remove the duplication of this doc. It is copied from ContentChildrenMetadata.
  /**
   * Configures a content query.
   *
   * Content queries are set before the `ngAfterContentInit` callback is called.
   *
   * ### Example
   *
   * ```
   * @Directive({
   *   selector: 'someDir'
   * })
   * class SomeDir {
   *   @ContentChildren(ChildDirective) contentChildren: QueryList<ChildDirective>;
   *
   *   ngAfterContentInit() {
   *     // contentChildren is set
   *   }
   * }
   * ```
   */
  exports.ContentChildren = decorators_1.makePropDecorator(di_2.ContentChildrenMetadata);
  // TODO(alexeagle): remove the duplication of this doc. It is copied from ContentChildMetadata.
  /**
   * Configures a content query.
   *
   * Content queries are set before the `ngAfterContentInit` callback is called.
   *
   * ### Example
   *
   * ```
   * @Directive({
   *   selector: 'someDir'
   * })
   * class SomeDir {
   *   @ContentChild(ChildDirective) contentChild;
   *
   *   ngAfterContentInit() {
   *     // contentChild is set
   *   }
   * }
   * ```
   */
  exports.ContentChild = decorators_1.makePropDecorator(di_2.ContentChildMetadata);
  // TODO(alexeagle): remove the duplication of this doc. It is copied from ViewChildrenMetadata.
  /**
   * Configures a view query.
   *
   * View queries are set before the `ngAfterViewInit` callback is called.
   *
   * ### Example
   *
   * ```
   * @Component({
   *   selector: 'someDir',
   *   templateUrl: 'someTemplate',
   *   directives: [ItemDirective]
   * })
   * class SomeDir {
   *   @ViewChildren(ItemDirective) viewChildren: QueryList<ItemDirective>;
   *
   *   ngAfterViewInit() {
   *     // viewChildren is set
   *   }
   * }
   * ```
   */
  exports.ViewChildren = decorators_1.makePropDecorator(di_2.ViewChildrenMetadata);
  // TODO(alexeagle): remove the duplication of this doc. It is copied from ViewChildMetadata.
  /**
   * Configures a view query.
   *
   * View queries are set before the `ngAfterViewInit` callback is called.
   *
   * ### Example
   *
   * ```
   * @Component({
   *   selector: 'someDir',
   *   templateUrl: 'someTemplate',
   *   directives: [ItemDirective]
   * })
   * class SomeDir {
   *   @ViewChild(ItemDirective) viewChild:ItemDirective;
   *
   *   ngAfterViewInit() {
   *     // viewChild is set
   *   }
   * }
   * ```
   */
  exports.ViewChild = decorators_1.makePropDecorator(di_2.ViewChildMetadata);
  // TODO(alexeagle): remove the duplication of this doc. It is copied from ViewQueryMetadata.
  /**
   * Similar to {@link QueryMetadata}, but querying the component view, instead of
   * the content children.
   *
   * ### Example ([live demo](http://plnkr.co/edit/eNsFHDf7YjyM6IzKxM1j?p=preview))
   *
   * ```javascript
   * @Component({
   *   ...,
   *   template: `
   *     <item> a </item>
   *     <item> b </item>
   *     <item> c </item>
   *   `
   * })
   * class MyComponent {
   *   shown: boolean;
   *
   *   constructor(private @Query(Item) items:QueryList<Item>) {
   *     items.changes.subscribe(() => console.log(items.length));
   *   }
   * }
   * ```
   *
   * Supports the same querying parameters as {@link QueryMetadata}, except
   * `descendants`. This always queries the whole view.
   *
   * As `shown` is flipped between true and false, items will contain zero of one
   * items.
   *
   * Specifies that a {@link QueryList} should be injected.
   *
   * The injected object is an iterable and observable live list.
   * See {@link QueryList} for more details.
   */
  exports.ViewQuery = decorators_1.makeParamDecorator(di_2.ViewQueryMetadata);
  // TODO(alexeagle): remove the duplication of this doc. It is copied from PipeMetadata.
  /**
   * Declare reusable pipe function.
   *
   * ### Example
   *
   * {@example core/ts/metadata/metadata.ts region='pipe'}
   */
  exports.Pipe = decorators_1.makeDecorator(directives_2.PipeMetadata);
  // TODO(alexeagle): remove the duplication of this doc. It is copied from InputMetadata.
  /**
   * Declares a data-bound input property.
   *
   * Angular automatically updates data-bound properties during change detection.
   *
   * `InputMetadata` takes an optional parameter that specifies the name
   * used when instantiating a component in the template. When not provided,
   * the name of the decorated property is used.
   *
   * ### Example
   *
   * The following example creates a component with two input properties.
   *
   * ```typescript
   * @Component({
   *   selector: 'bank-account',
   *   template: `
   *     Bank Name: {{bankName}}
   *     Account Id: {{id}}
   *   `
   * })
   * class BankAccount {
   *   @Input() bankName: string;
   *   @Input('account-id') id: string;
   *
   *   // this property is not bound, and won't be automatically updated by Angular
   *   normalizedBankName: string;
   * }
   *
   * @Component({
   *   selector: 'app',
   *   template: `
   *     <bank-account bank-name="RBC" account-id="4747"></bank-account>
   *   `,
   *   directives: [BankAccount]
   * })
   * class App {}
   *
   * bootstrap(App);
   * ```
   */
  exports.Input = decorators_1.makePropDecorator(directives_2.InputMetadata);
  // TODO(alexeagle): remove the duplication of this doc. It is copied from OutputMetadata.
  /**
   * Declares an event-bound output property.
   *
   * When an output property emits an event, an event handler attached to that event
   * the template is invoked.
   *
   * `OutputMetadata` takes an optional parameter that specifies the name
   * used when instantiating a component in the template. When not provided,
   * the name of the decorated property is used.
   *
   * ### Example
   *
   * ```typescript
   * @Directive({
   *   selector: 'interval-dir',
   * })
   * class IntervalDir {
   *   @Output() everySecond = new EventEmitter();
   *   @Output('everyFiveSeconds') five5Secs = new EventEmitter();
   *
   *   constructor() {
   *     setInterval(() => this.everySecond.emit("event"), 1000);
   *     setInterval(() => this.five5Secs.emit("event"), 5000);
   *   }
   * }
   *
   * @Component({
   *   selector: 'app',
   *   template: `
   *     <interval-dir (everySecond)="everySecond()" (everyFiveSeconds)="everyFiveSeconds()">
   *     </interval-dir>
   *   `,
   *   directives: [IntervalDir]
   * })
   * class App {
   *   everySecond() { console.log('second'); }
   *   everyFiveSeconds() { console.log('five seconds'); }
   * }
   * bootstrap(App);
   * ```
   */
  exports.Output = decorators_1.makePropDecorator(directives_2.OutputMetadata);
  // TODO(alexeagle): remove the duplication of this doc. It is copied from HostBindingMetadata.
  /**
   * Declares a host property binding.
   *
   * Angular automatically checks host property bindings during change detection.
   * If a binding changes, it will update the host element of the directive.
   *
   * `HostBindingMetadata` takes an optional parameter that specifies the property
   * name of the host element that will be updated. When not provided,
   * the class property name is used.
   *
   * ### Example
   *
   * The following example creates a directive that sets the `valid` and `invalid` classes
   * on the DOM element that has ngModel directive on it.
   *
   * ```typescript
   * @Directive({selector: '[ngModel]'})
   * class NgModelStatus {
   *   constructor(public control:NgModel) {}
   *   @HostBinding('[class.valid]') get valid { return this.control.valid; }
   *   @HostBinding('[class.invalid]') get invalid { return this.control.invalid; }
   * }
   *
   * @Component({
   *   selector: 'app',
   *   template: `<input [(ngModel)]="prop">`,
   *   directives: [FORM_DIRECTIVES, NgModelStatus]
   * })
   * class App {
   *   prop;
   * }
   *
   * bootstrap(App);
   * ```
   */
  exports.HostBinding = decorators_1.makePropDecorator(directives_2.HostBindingMetadata);
  // TODO(alexeagle): remove the duplication of this doc. It is copied from HostListenerMetadata.
  /**
   * Declares a host listener.
   *
   * Angular will invoke the decorated method when the host element emits the specified event.
   *
   * If the decorated method returns `false`, then `preventDefault` is applied on the DOM
   * event.
   *
   * ### Example
   *
   * The following example declares a directive that attaches a click listener to the button and
   * counts clicks.
   *
   * ```typescript
   * @Directive({selector: 'button[counting]'})
   * class CountClicks {
   *   numberOfClicks = 0;
   *
   *   @HostListener('click', ['$event.target'])
   *   onClick(btn) {
   *     console.log("button", btn, "number of clicks:", this.numberOfClicks++);
   *   }
   * }
   *
   * @Component({
   *   selector: 'app',
   *   template: `<button counting>Increment</button>`,
   *   directives: [CountClicks]
   * })
   * class App {}
   *
   * bootstrap(App);
   * ```
   */
  exports.HostListener = decorators_1.makePropDecorator(directives_2.HostListenerMetadata);
});
System.registerDynamic("angular2/src/core/linker/pipe_resolver.js", ["angular2/src/core/di.js", "angular2/src/facade/lang.js", "angular2/src/facade/exceptions.js", "angular2/src/core/metadata.js", "angular2/src/core/reflection/reflector_reader.js", "angular2/src/core/reflection/reflection.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var di_1 = $__require("angular2/src/core/di.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var exceptions_1 = $__require("angular2/src/facade/exceptions.js");
    var metadata_1 = $__require("angular2/src/core/metadata.js");
    var reflector_reader_1 = $__require("angular2/src/core/reflection/reflector_reader.js");
    var reflection_1 = $__require("angular2/src/core/reflection/reflection.js");
    function _isPipeMetadata(type) {
        return type instanceof metadata_1.PipeMetadata;
    }
    /**
     * Resolve a `Type` for {@link PipeMetadata}.
     *
     * This interface can be overridden by the application developer to create custom behavior.
     *
     * See {@link Compiler}
     */
    var PipeResolver = function () {
        function PipeResolver(_reflector) {
            if (lang_1.isPresent(_reflector)) {
                this._reflector = _reflector;
            } else {
                this._reflector = reflection_1.reflector;
            }
        }
        /**
         * Return {@link PipeMetadata} for a given `Type`.
         */
        PipeResolver.prototype.resolve = function (type) {
            var metas = this._reflector.annotations(di_1.resolveForwardRef(type));
            if (lang_1.isPresent(metas)) {
                var annotation = metas.find(_isPipeMetadata);
                if (lang_1.isPresent(annotation)) {
                    return annotation;
                }
            }
            throw new exceptions_1.BaseException("No Pipe decorator found on " + lang_1.stringify(type));
        };
        PipeResolver = __decorate([di_1.Injectable(), __metadata('design:paramtypes', [reflector_reader_1.ReflectorReader])], PipeResolver);
        return PipeResolver;
    }();
    exports.PipeResolver = PipeResolver;
    exports.CODEGEN_PIPE_RESOLVER = new PipeResolver(reflection_1.reflector);
});
System.registerDynamic("angular2/src/core/linker/compiler.js", ["angular2/src/core/di.js", "angular2/src/facade/lang.js", "angular2/src/facade/exceptions.js", "angular2/src/facade/async.js", "angular2/src/core/reflection/reflection.js", "angular2/src/core/linker/view.js", "angular2/src/core/linker/view_ref.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var di_1 = $__require("angular2/src/core/di.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var exceptions_1 = $__require("angular2/src/facade/exceptions.js");
    var async_1 = $__require("angular2/src/facade/async.js");
    var reflection_1 = $__require("angular2/src/core/reflection/reflection.js");
    var view_1 = $__require("angular2/src/core/linker/view.js");
    var view_ref_1 = $__require("angular2/src/core/linker/view_ref.js");
    /**
     * Low-level service for compiling {@link Component}s into {@link ProtoViewRef ProtoViews}s, which
     * can later be used to create and render a Component instance.
     *
     * Most applications should instead use higher-level {@link DynamicComponentLoader} service, which
     * both compiles and instantiates a Component.
     */
    var Compiler = function () {
        function Compiler() {}
        return Compiler;
    }();
    exports.Compiler = Compiler;
    function isHostViewFactory(type) {
        return type instanceof view_1.HostViewFactory;
    }
    var Compiler_ = function (_super) {
        __extends(Compiler_, _super);
        function Compiler_() {
            _super.apply(this, arguments);
        }
        Compiler_.prototype.compileInHost = function (componentType) {
            var metadatas = reflection_1.reflector.annotations(componentType);
            var hostViewFactory = metadatas.find(isHostViewFactory);
            if (lang_1.isBlank(hostViewFactory)) {
                throw new exceptions_1.BaseException("No precompiled component " + lang_1.stringify(componentType) + " found");
            }
            return async_1.PromiseWrapper.resolve(new view_ref_1.HostViewFactoryRef_(hostViewFactory));
        };
        Compiler_.prototype.clearCache = function () {};
        Compiler_ = __decorate([di_1.Injectable(), __metadata('design:paramtypes', [])], Compiler_);
        return Compiler_;
    }(Compiler);
    exports.Compiler_ = Compiler_;
});
System.registerDynamic("angular2/src/core/metadata/di.js", ["angular2/src/facade/lang.js", "angular2/src/core/di.js", "angular2/src/core/di/metadata.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var di_1 = $__require("angular2/src/core/di.js");
    var metadata_1 = $__require("angular2/src/core/di/metadata.js");
    /**
     * Specifies that a constant attribute value should be injected.
     *
     * The directive can inject constant string literals of host element attributes.
     *
     * ### Example
     *
     * Suppose we have an `<input>` element and want to know its `type`.
     *
     * ```html
     * <input type="text">
     * ```
     *
     * A decorator can inject string literal `text` like so:
     *
     * {@example core/ts/metadata/metadata.ts region='attributeMetadata'}
     */
    var AttributeMetadata = function (_super) {
        __extends(AttributeMetadata, _super);
        function AttributeMetadata(attributeName) {
            _super.call(this);
            this.attributeName = attributeName;
        }
        Object.defineProperty(AttributeMetadata.prototype, "token", {
            get: function () {
                // Normally one would default a token to a type of an injected value but here
                // the type of a variable is "string" and we can't use primitive type as a return value
                // so we use instance of Attribute instead. This doesn't matter much in practice as arguments
                // with @Attribute annotation are injected by ElementInjector that doesn't take tokens into
                // account.
                return this;
            },
            enumerable: true,
            configurable: true
        });
        AttributeMetadata.prototype.toString = function () {
            return "@Attribute(" + lang_1.stringify(this.attributeName) + ")";
        };
        AttributeMetadata = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [String])], AttributeMetadata);
        return AttributeMetadata;
    }(metadata_1.DependencyMetadata);
    exports.AttributeMetadata = AttributeMetadata;
    /**
     * Declares an injectable parameter to be a live list of directives or variable
     * bindings from the content children of a directive.
     *
     * ### Example ([live demo](http://plnkr.co/edit/lY9m8HLy7z06vDoUaSN2?p=preview))
     *
     * Assume that `<tabs>` component would like to get a list its children `<pane>`
     * components as shown in this example:
     *
     * ```html
     * <tabs>
     *   <pane title="Overview">...</pane>
     *   <pane *ngFor="#o of objects" [title]="o.title">{{o.text}}</pane>
     * </tabs>
     * ```
     *
     * The preferred solution is to query for `Pane` directives using this decorator.
     *
     * ```javascript
     * @Component({
     *   selector: 'pane',
     *   inputs: ['title']
     * })
     * class Pane {
     *   title:string;
     * }
     *
     * @Component({
     *  selector: 'tabs',
     *  template: `
     *    <ul>
     *      <li *ngFor="#pane of panes">{{pane.title}}</li>
     *    </ul>
     *    <ng-content></ng-content>
     *  `
     * })
     * class Tabs {
     *   panes: QueryList<Pane>;
     *   constructor(@Query(Pane) panes:QueryList<Pane>) {
      *    this.panes = panes;
      *  }
     * }
     * ```
     *
     * A query can look for variable bindings by passing in a string with desired binding symbol.
     *
     * ### Example ([live demo](http://plnkr.co/edit/sT2j25cH1dURAyBRCKx1?p=preview))
     * ```html
     * <seeker>
     *   <div #findme>...</div>
     * </seeker>
     *
     * @Component({ selector: 'seeker' })
     * class Seeker {
     *   constructor(@Query('findme') elList: QueryList<ElementRef>) {...}
     * }
     * ```
     *
     * In this case the object that is injected depend on the type of the variable
     * binding. It can be an ElementRef, a directive or a component.
     *
     * Passing in a comma separated list of variable bindings will query for all of them.
     *
     * ```html
     * <seeker>
     *   <div #find-me>...</div>
     *   <div #find-me-too>...</div>
     * </seeker>
     *
     *  @Component({
     *   selector: 'seeker'
     * })
     * class Seeker {
     *   constructor(@Query('findMe, findMeToo') elList: QueryList<ElementRef>) {...}
     * }
     * ```
     *
     * Configure whether query looks for direct children or all descendants
     * of the querying element, by using the `descendants` parameter.
     * It is set to `false` by default.
     *
     * ### Example ([live demo](http://plnkr.co/edit/wtGeB977bv7qvA5FTYl9?p=preview))
     * ```html
     * <container #first>
     *   <item>a</item>
     *   <item>b</item>
     *   <container #second>
     *     <item>c</item>
     *   </container>
     * </container>
     * ```
     *
     * When querying for items, the first container will see only `a` and `b` by default,
     * but with `Query(TextDirective, {descendants: true})` it will see `c` too.
     *
     * The queried directives are kept in a depth-first pre-order with respect to their
     * positions in the DOM.
     *
     * Query does not look deep into any subcomponent views.
     *
     * Query is updated as part of the change-detection cycle. Since change detection
     * happens after construction of a directive, QueryList will always be empty when observed in the
     * constructor.
     *
     * The injected object is an unmodifiable live list.
     * See {@link QueryList} for more details.
     */
    var QueryMetadata = function (_super) {
        __extends(QueryMetadata, _super);
        function QueryMetadata(_selector, _a) {
            var _b = _a === void 0 ? {} : _a,
                _c = _b.descendants,
                descendants = _c === void 0 ? false : _c,
                _d = _b.first,
                first = _d === void 0 ? false : _d;
            _super.call(this);
            this._selector = _selector;
            this.descendants = descendants;
            this.first = first;
        }
        Object.defineProperty(QueryMetadata.prototype, "isViewQuery", {
            /**
             * always `false` to differentiate it with {@link ViewQueryMetadata}.
             */
            get: function () {
                return false;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(QueryMetadata.prototype, "selector", {
            /**
             * what this is querying for.
             */
            get: function () {
                return di_1.resolveForwardRef(this._selector);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(QueryMetadata.prototype, "isVarBindingQuery", {
            /**
             * whether this is querying for a variable binding or a directive.
             */
            get: function () {
                return lang_1.isString(this.selector);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(QueryMetadata.prototype, "varBindings", {
            /**
             * returns a list of variable bindings this is querying for.
             * Only applicable if this is a variable bindings query.
             */
            get: function () {
                return this.selector.split(',');
            },
            enumerable: true,
            configurable: true
        });
        QueryMetadata.prototype.toString = function () {
            return "@Query(" + lang_1.stringify(this.selector) + ")";
        };
        QueryMetadata = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [Object, Object])], QueryMetadata);
        return QueryMetadata;
    }(metadata_1.DependencyMetadata);
    exports.QueryMetadata = QueryMetadata;
    // TODO: add an example after ContentChildren and ViewChildren are in master
    /**
     * Configures a content query.
     *
     * Content queries are set before the `ngAfterContentInit` callback is called.
     *
     * ### Example
     *
     * ```
     * @Directive({
     *   selector: 'someDir'
     * })
     * class SomeDir {
     *   @ContentChildren(ChildDirective) contentChildren: QueryList<ChildDirective>;
     *
     *   ngAfterContentInit() {
     *     // contentChildren is set
     *   }
     * }
     * ```
     */
    var ContentChildrenMetadata = function (_super) {
        __extends(ContentChildrenMetadata, _super);
        function ContentChildrenMetadata(_selector, _a) {
            var _b = (_a === void 0 ? {} : _a).descendants,
                descendants = _b === void 0 ? false : _b;
            _super.call(this, _selector, { descendants: descendants });
        }
        ContentChildrenMetadata = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [Object, Object])], ContentChildrenMetadata);
        return ContentChildrenMetadata;
    }(QueryMetadata);
    exports.ContentChildrenMetadata = ContentChildrenMetadata;
    // TODO: add an example after ContentChild and ViewChild are in master
    /**
     * Configures a content query.
     *
     * Content queries are set before the `ngAfterContentInit` callback is called.
     *
     * ### Example
     *
     * ```
     * @Directive({
     *   selector: 'someDir'
     * })
     * class SomeDir {
     *   @ContentChild(ChildDirective) contentChild;
     *
     *   ngAfterContentInit() {
     *     // contentChild is set
     *   }
     * }
     * ```
     */
    var ContentChildMetadata = function (_super) {
        __extends(ContentChildMetadata, _super);
        function ContentChildMetadata(_selector) {
            _super.call(this, _selector, { descendants: true, first: true });
        }
        ContentChildMetadata = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [Object])], ContentChildMetadata);
        return ContentChildMetadata;
    }(QueryMetadata);
    exports.ContentChildMetadata = ContentChildMetadata;
    /**
     * Similar to {@link QueryMetadata}, but querying the component view, instead of
     * the content children.
     *
     * ### Example ([live demo](http://plnkr.co/edit/eNsFHDf7YjyM6IzKxM1j?p=preview))
     *
     * ```javascript
     * @Component({
     *   ...,
     *   template: `
     *     <item> a </item>
     *     <item> b </item>
     *     <item> c </item>
     *   `
     * })
     * class MyComponent {
     *   shown: boolean;
     *
     *   constructor(private @ViewQuery(Item) items:QueryList<Item>) {
     *     items.changes.subscribe(() => console.log(items.length));
     *   }
     * }
     * ```
     *
     * Supports the same querying parameters as {@link QueryMetadata}, except
     * `descendants`. This always queries the whole view.
     *
     * As `shown` is flipped between true and false, items will contain zero of one
     * items.
     *
     * Specifies that a {@link QueryList} should be injected.
     *
     * The injected object is an iterable and observable live list.
     * See {@link QueryList} for more details.
     */
    var ViewQueryMetadata = function (_super) {
        __extends(ViewQueryMetadata, _super);
        function ViewQueryMetadata(_selector, _a) {
            var _b = _a === void 0 ? {} : _a,
                _c = _b.descendants,
                descendants = _c === void 0 ? false : _c,
                _d = _b.first,
                first = _d === void 0 ? false : _d;
            _super.call(this, _selector, { descendants: descendants, first: first });
        }
        Object.defineProperty(ViewQueryMetadata.prototype, "isViewQuery", {
            /**
             * always `true` to differentiate it with {@link QueryMetadata}.
             */
            get: function () {
                return true;
            },
            enumerable: true,
            configurable: true
        });
        ViewQueryMetadata.prototype.toString = function () {
            return "@ViewQuery(" + lang_1.stringify(this.selector) + ")";
        };
        ViewQueryMetadata = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [Object, Object])], ViewQueryMetadata);
        return ViewQueryMetadata;
    }(QueryMetadata);
    exports.ViewQueryMetadata = ViewQueryMetadata;
    /**
     * Configures a view query.
     *
     * View queries are set before the `ngAfterViewInit` callback is called.
     *
     * ### Example
     *
     * ```
     * @Component({
     *   selector: 'someDir',
     *   templateUrl: 'someTemplate',
     *   directives: [ItemDirective]
     * })
     * class SomeDir {
     *   @ViewChildren(ItemDirective) viewChildren: QueryList<ItemDirective>;
     *
     *   ngAfterViewInit() {
     *     // viewChildren is set
     *   }
     * }
     * ```
     */
    var ViewChildrenMetadata = function (_super) {
        __extends(ViewChildrenMetadata, _super);
        function ViewChildrenMetadata(_selector) {
            _super.call(this, _selector, { descendants: true });
        }
        ViewChildrenMetadata = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [Object])], ViewChildrenMetadata);
        return ViewChildrenMetadata;
    }(ViewQueryMetadata);
    exports.ViewChildrenMetadata = ViewChildrenMetadata;
    /**
     * Configures a view query.
     *
     * View queries are set before the `ngAfterViewInit` callback is called.
     *
     * ### Example
     *
     * ```
     * @Component({
     *   selector: 'someDir',
     *   templateUrl: 'someTemplate',
     *   directives: [ItemDirective]
     * })
     * class SomeDir {
     *   @ViewChild(ItemDirective) viewChild:ItemDirective;
     *
     *   ngAfterViewInit() {
     *     // viewChild is set
     *   }
     * }
     * ```
     */
    var ViewChildMetadata = function (_super) {
        __extends(ViewChildMetadata, _super);
        function ViewChildMetadata(_selector) {
            _super.call(this, _selector, { descendants: true, first: true });
        }
        ViewChildMetadata = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [Object])], ViewChildMetadata);
        return ViewChildMetadata;
    }(ViewQueryMetadata);
    exports.ViewChildMetadata = ViewChildMetadata;
});
System.registerDynamic('angular2/src/core/linker/element_ref.js', ['angular2/src/facade/exceptions.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var exceptions_1 = $__require('angular2/src/facade/exceptions.js');
    /**
     * Represents a location in a View that has an injection, change-detection and render context
     * associated with it.
     *
     * An `ElementRef` is created for each element in the Template that contains a Directive, Component
     * or data-binding.
     *
     * An `ElementRef` is backed by a render-specific element. In the browser, this is usually a DOM
     * element.
     */
    var ElementRef = function () {
        function ElementRef() {}
        Object.defineProperty(ElementRef.prototype, "nativeElement", {
            /**
             * The underlying native element or `null` if direct access to native elements is not supported
             * (e.g. when the application runs in a web worker).
             *
             * <div class="callout is-critical">
             *   <header>Use with caution</header>
             *   <p>
             *    Use this API as the last resort when direct access to DOM is needed. Use templating and
             *    data-binding provided by Angular instead. Alternatively you take a look at {@link Renderer}
             *    which provides API that can safely be used even when direct access to native elements is not
             *    supported.
             *   </p>
             *   <p>
             *    Relying on direct DOM access creates tight coupling between your application and rendering
             *    layers which will make it impossible to separate the two and deploy your application into a
             *    web worker.
             *   </p>
             * </div>
             */
            get: function () {
                return exceptions_1.unimplemented();
            },
            enumerable: true,
            configurable: true
        });
        return ElementRef;
    }();
    exports.ElementRef = ElementRef;
    var ElementRef_ = function () {
        function ElementRef_(_appElement) {
            this._appElement = _appElement;
        }
        Object.defineProperty(ElementRef_.prototype, "internalElement", {
            get: function () {
                return this._appElement;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ElementRef_.prototype, "nativeElement", {
            get: function () {
                return this._appElement.nativeElement;
            },
            enumerable: true,
            configurable: true
        });
        return ElementRef_;
    }();
    exports.ElementRef_ = ElementRef_;
});
System.registerDynamic('angular2/src/core/linker/view_container_ref.js', ['angular2/src/facade/collection.js', 'angular2/src/facade/exceptions.js', 'angular2/src/facade/lang.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var collection_1 = $__require('angular2/src/facade/collection.js');
    var exceptions_1 = $__require('angular2/src/facade/exceptions.js');
    var lang_1 = $__require('angular2/src/facade/lang.js');
    /**
     * Represents a container where one or more Views can be attached.
     *
     * The container can contain two kinds of Views. Host Views, created by instantiating a
     * {@link Component} via {@link #createHostView}, and Embedded Views, created by instantiating an
     * {@link TemplateRef Embedded Template} via {@link #createEmbeddedView}.
     *
     * The location of the View Container within the containing View is specified by the Anchor
     * `element`. Each View Container can have only one Anchor Element and each Anchor Element can only
     * have a single View Container.
     *
     * Root elements of Views attached to this container become siblings of the Anchor Element in
     * the Rendered View.
     *
     * To access a `ViewContainerRef` of an Element, you can either place a {@link Directive} injected
     * with `ViewContainerRef` on the Element, or you obtain it via
     * {@link AppViewManager#getViewContainer}.
     *
     * <!-- TODO(i): we are also considering ElementRef#viewContainer api -->
     */
    var ViewContainerRef = function () {
        function ViewContainerRef() {}
        Object.defineProperty(ViewContainerRef.prototype, "element", {
            /**
             * Anchor element that specifies the location of this container in the containing View.
             * <!-- TODO: rename to anchorElement -->
             */
            get: function () {
                return exceptions_1.unimplemented();
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Destroys all Views in this container.
         */
        ViewContainerRef.prototype.clear = function () {
            for (var i = this.length - 1; i >= 0; i--) {
                this.remove(i);
            }
        };
        Object.defineProperty(ViewContainerRef.prototype, "length", {
            /**
             * Returns the number of Views currently attached to this container.
             */
            get: function () {
                return exceptions_1.unimplemented();
            },
            enumerable: true,
            configurable: true
        });
        ;
        return ViewContainerRef;
    }();
    exports.ViewContainerRef = ViewContainerRef;
    var ViewContainerRef_ = function (_super) {
        __extends(ViewContainerRef_, _super);
        function ViewContainerRef_(_element) {
            _super.call(this);
            this._element = _element;
        }
        ViewContainerRef_.prototype.get = function (index) {
            return this._element.nestedViews[index].ref;
        };
        Object.defineProperty(ViewContainerRef_.prototype, "length", {
            get: function () {
                var views = this._element.nestedViews;
                return lang_1.isPresent(views) ? views.length : 0;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ViewContainerRef_.prototype, "element", {
            get: function () {
                return this._element.ref;
            },
            enumerable: true,
            configurable: true
        });
        // TODO(rado): profile and decide whether bounds checks should be added
        // to the methods below.
        ViewContainerRef_.prototype.createEmbeddedView = function (templateRef, index) {
            if (index === void 0) {
                index = -1;
            }
            if (index == -1) index = this.length;
            var vm = this._element.parentView.viewManager;
            return vm.createEmbeddedViewInContainer(this._element.ref, index, templateRef);
        };
        ViewContainerRef_.prototype.createHostView = function (hostViewFactoryRef, index, dynamicallyCreatedProviders, projectableNodes) {
            if (index === void 0) {
                index = -1;
            }
            if (dynamicallyCreatedProviders === void 0) {
                dynamicallyCreatedProviders = null;
            }
            if (projectableNodes === void 0) {
                projectableNodes = null;
            }
            if (index == -1) index = this.length;
            var vm = this._element.parentView.viewManager;
            return vm.createHostViewInContainer(this._element.ref, index, hostViewFactoryRef, dynamicallyCreatedProviders, projectableNodes);
        };
        // TODO(i): refactor insert+remove into move
        ViewContainerRef_.prototype.insert = function (viewRef, index) {
            if (index === void 0) {
                index = -1;
            }
            if (index == -1) index = this.length;
            var vm = this._element.parentView.viewManager;
            return vm.attachViewInContainer(this._element.ref, index, viewRef);
        };
        ViewContainerRef_.prototype.indexOf = function (viewRef) {
            return collection_1.ListWrapper.indexOf(this._element.nestedViews, viewRef.internalView);
        };
        // TODO(i): rename to destroy
        ViewContainerRef_.prototype.remove = function (index) {
            if (index === void 0) {
                index = -1;
            }
            if (index == -1) index = this.length - 1;
            var vm = this._element.parentView.viewManager;
            return vm.destroyViewInContainer(this._element.ref, index);
            // view is intentionally not returned to the client.
        };
        // TODO(i): refactor insert+remove into move
        ViewContainerRef_.prototype.detach = function (index) {
            if (index === void 0) {
                index = -1;
            }
            if (index == -1) index = this.length - 1;
            var vm = this._element.parentView.viewManager;
            return vm.detachViewInContainer(this._element.ref, index);
        };
        return ViewContainerRef_;
    }(ViewContainerRef);
    exports.ViewContainerRef_ = ViewContainerRef_;
});
System.registerDynamic("angular2/src/core/linker/template_ref.js", [], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    /**
     * Represents an Embedded Template that can be used to instantiate Embedded Views.
     *
     * You can access a `TemplateRef`, in two ways. Via a directive placed on a `<template>` element (or
     * directive prefixed with `*`) and have the `TemplateRef` for this Embedded View injected into the
     * constructor of the directive using the `TemplateRef` Token. Alternatively you can query for the
     * `TemplateRef` from a Component or a Directive via {@link Query}.
     *
     * To instantiate Embedded Views based on a Template, use
     * {@link ViewContainerRef#createEmbeddedView}, which will create the View and attach it to the
     * View Container.
     */
    var TemplateRef = function () {
        function TemplateRef() {}
        Object.defineProperty(TemplateRef.prototype, "elementRef", {
            /**
             * The location in the View where the Embedded View logically belongs to.
             *
             * The data-binding and injection contexts of Embedded Views created from this `TemplateRef`
             * inherit from the contexts of this location.
             *
             * Typically new Embedded Views are attached to the View Container of this location, but in
             * advanced use-cases, the View can be attached to a different container while keeping the
             * data-binding and injection context from the original location.
             *
             */
            // TODO(i): rename to anchor or location
            get: function () {
                return null;
            },
            enumerable: true,
            configurable: true
        });
        return TemplateRef;
    }();
    exports.TemplateRef = TemplateRef;
    var TemplateRef_ = function (_super) {
        __extends(TemplateRef_, _super);
        function TemplateRef_(_elementRef) {
            _super.call(this);
            this._elementRef = _elementRef;
        }
        Object.defineProperty(TemplateRef_.prototype, "elementRef", {
            get: function () {
                return this._elementRef;
            },
            enumerable: true,
            configurable: true
        });
        return TemplateRef_;
    }(TemplateRef);
    exports.TemplateRef_ = TemplateRef_;
});
System.registerDynamic('angular2/src/core/change_detection.js', ['angular2/src/core/change_detection/change_detection.js'], true, function ($__require, exports, module) {
  'use strict'; /**
                * @module
                * @description
                * Change detection enables data binding in Angular.
                */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var change_detection_1 = $__require('angular2/src/core/change_detection/change_detection.js');
  exports.ChangeDetectionStrategy = change_detection_1.ChangeDetectionStrategy;
  exports.ExpressionChangedAfterItHasBeenCheckedException = change_detection_1.ExpressionChangedAfterItHasBeenCheckedException;
  exports.ChangeDetectionError = change_detection_1.ChangeDetectionError;
  exports.ChangeDetectorRef = change_detection_1.ChangeDetectorRef;
  exports.WrappedValue = change_detection_1.WrappedValue;
  exports.SimpleChange = change_detection_1.SimpleChange;
  exports.IterableDiffers = change_detection_1.IterableDiffers;
  exports.KeyValueDiffers = change_detection_1.KeyValueDiffers;
  exports.CollectionChangeRecord = change_detection_1.CollectionChangeRecord;
  exports.KeyValueChangeRecord = change_detection_1.KeyValueChangeRecord;
});
System.registerDynamic("angular2/src/core/metadata/directives.js", ["angular2/src/facade/lang.js", "angular2/src/core/di/metadata.js", "angular2/src/core/change_detection.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var metadata_1 = $__require("angular2/src/core/di/metadata.js");
    var change_detection_1 = $__require("angular2/src/core/change_detection.js");
    /**
     * Directives allow you to attach behavior to elements in the DOM.
     *
     * {@link DirectiveMetadata}s with an embedded view are called {@link ComponentMetadata}s.
     *
     * A directive consists of a single directive annotation and a controller class. When the
     * directive's `selector` matches
     * elements in the DOM, the following steps occur:
     *
     * 1. For each directive, the `ElementInjector` attempts to resolve the directive's constructor
     * arguments.
     * 2. Angular instantiates directives for each matched element using `ElementInjector` in a
     * depth-first order,
     *    as declared in the HTML.
     *
     * ## Understanding How Injection Works
     *
     * There are three stages of injection resolution.
     * - *Pre-existing Injectors*:
     *   - The terminal {@link Injector} cannot resolve dependencies. It either throws an error or, if
     * the dependency was
     *     specified as `@Optional`, returns `null`.
     *   - The platform injector resolves browser singleton resources, such as: cookies, title,
     * location, and others.
     * - *Component Injectors*: Each component instance has its own {@link Injector}, and they follow
     * the same parent-child hierarchy
     *     as the component instances in the DOM.
     * - *Element Injectors*: Each component instance has a Shadow DOM. Within the Shadow DOM each
     * element has an `ElementInjector`
     *     which follow the same parent-child hierarchy as the DOM elements themselves.
     *
     * When a template is instantiated, it also must instantiate the corresponding directives in a
     * depth-first order. The
     * current `ElementInjector` resolves the constructor dependencies for each directive.
     *
     * Angular then resolves dependencies as follows, according to the order in which they appear in the
     * {@link ViewMetadata}:
     *
     * 1. Dependencies on the current element
     * 2. Dependencies on element injectors and their parents until it encounters a Shadow DOM boundary
     * 3. Dependencies on component injectors and their parents until it encounters the root component
     * 4. Dependencies on pre-existing injectors
     *
     *
     * The `ElementInjector` can inject other directives, element-specific special objects, or it can
     * delegate to the parent
     * injector.
     *
     * To inject other directives, declare the constructor parameter as:
     * - `directive:DirectiveType`: a directive on the current element only
     * - `@Host() directive:DirectiveType`: any directive that matches the type between the current
     * element and the
     *    Shadow DOM root.
     * - `@Query(DirectiveType) query:QueryList<DirectiveType>`: A live collection of direct child
     * directives.
     * - `@QueryDescendants(DirectiveType) query:QueryList<DirectiveType>`: A live collection of any
     * child directives.
     *
     * To inject element-specific special objects, declare the constructor parameter as:
     * - `element: ElementRef` to obtain a reference to logical element in the view.
     * - `viewContainer: ViewContainerRef` to control child template instantiation, for
     * {@link DirectiveMetadata} directives only
     * - `bindingPropagation: BindingPropagation` to control change detection in a more granular way.
     *
     * ### Example
     *
     * The following example demonstrates how dependency injection resolves constructor arguments in
     * practice.
     *
     *
     * Assume this HTML template:
     *
     * ```
     * <div dependency="1">
     *   <div dependency="2">
     *     <div dependency="3" my-directive>
     *       <div dependency="4">
     *         <div dependency="5"></div>
     *       </div>
     *       <div dependency="6"></div>
     *     </div>
     *   </div>
     * </div>
     * ```
     *
     * With the following `dependency` decorator and `SomeService` injectable class.
     *
     * ```
     * @Injectable()
     * class SomeService {
     * }
     *
     * @Directive({
     *   selector: '[dependency]',
     *   inputs: [
     *     'id: dependency'
     *   ]
     * })
     * class Dependency {
     *   id:string;
     * }
     * ```
     *
     * Let's step through the different ways in which `MyDirective` could be declared...
     *
     *
     * ### No injection
     *
     * Here the constructor is declared with no arguments, therefore nothing is injected into
     * `MyDirective`.
     *
     * ```
     * @Directive({ selector: '[my-directive]' })
     * class MyDirective {
     *   constructor() {
     *   }
     * }
     * ```
     *
     * This directive would be instantiated with no dependencies.
     *
     *
     * ### Component-level injection
     *
     * Directives can inject any injectable instance from the closest component injector or any of its
     * parents.
     *
     * Here, the constructor declares a parameter, `someService`, and injects the `SomeService` type
     * from the parent
     * component's injector.
     * ```
     * @Directive({ selector: '[my-directive]' })
     * class MyDirective {
     *   constructor(someService: SomeService) {
     *   }
     * }
     * ```
     *
     * This directive would be instantiated with a dependency on `SomeService`.
     *
     *
     * ### Injecting a directive from the current element
     *
     * Directives can inject other directives declared on the current element.
     *
     * ```
     * @Directive({ selector: '[my-directive]' })
     * class MyDirective {
     *   constructor(dependency: Dependency) {
     *     expect(dependency.id).toEqual(3);
     *   }
     * }
     * ```
     * This directive would be instantiated with `Dependency` declared at the same element, in this case
     * `dependency="3"`.
     *
     * ### Injecting a directive from any ancestor elements
     *
     * Directives can inject other directives declared on any ancestor element (in the current Shadow
     * DOM), i.e. on the current element, the
     * parent element, or its parents.
     * ```
     * @Directive({ selector: '[my-directive]' })
     * class MyDirective {
     *   constructor(@Host() dependency: Dependency) {
     *     expect(dependency.id).toEqual(2);
     *   }
     * }
     * ```
     *
     * `@Host` checks the current element, the parent, as well as its parents recursively. If
     * `dependency="2"` didn't
     * exist on the direct parent, this injection would
     * have returned
     * `dependency="1"`.
     *
     *
     * ### Injecting a live collection of direct child directives
     *
     *
     * A directive can also query for other child directives. Since parent directives are instantiated
     * before child directives, a directive can't simply inject the list of child directives. Instead,
     * the directive injects a {@link QueryList}, which updates its contents as children are added,
     * removed, or moved by a directive that uses a {@link ViewContainerRef} such as a `ngFor`, an
     * `ngIf`, or an `ngSwitch`.
     *
     * ```
     * @Directive({ selector: '[my-directive]' })
     * class MyDirective {
     *   constructor(@Query(Dependency) dependencies:QueryList<Dependency>) {
     *   }
     * }
     * ```
     *
     * This directive would be instantiated with a {@link QueryList} which contains `Dependency` 4 and
     * `Dependency` 6. Here, `Dependency` 5 would not be included, because it is not a direct child.
     *
     * ### Injecting a live collection of descendant directives
     *
     * By passing the descendant flag to `@Query` above, we can include the children of the child
     * elements.
     *
     * ```
     * @Directive({ selector: '[my-directive]' })
     * class MyDirective {
     *   constructor(@Query(Dependency, {descendants: true}) dependencies:QueryList<Dependency>) {
     *   }
     * }
     * ```
     *
     * This directive would be instantiated with a Query which would contain `Dependency` 4, 5 and 6.
     *
     * ### Optional injection
     *
     * The normal behavior of directives is to return an error when a specified dependency cannot be
     * resolved. If you
     * would like to inject `null` on unresolved dependency instead, you can annotate that dependency
     * with `@Optional()`.
     * This explicitly permits the author of a template to treat some of the surrounding directives as
     * optional.
     *
     * ```
     * @Directive({ selector: '[my-directive]' })
     * class MyDirective {
     *   constructor(@Optional() dependency:Dependency) {
     *   }
     * }
     * ```
     *
     * This directive would be instantiated with a `Dependency` directive found on the current element.
     * If none can be
     * found, the injector supplies `null` instead of throwing an error.
     *
     * ### Example
     *
     * Here we use a decorator directive to simply define basic tool-tip behavior.
     *
     * ```
     * @Directive({
     *   selector: '[tooltip]',
     *   inputs: [
     *     'text: tooltip'
     *   ],
     *   host: {
     *     '(mouseenter)': 'onMouseEnter()',
     *     '(mouseleave)': 'onMouseLeave()'
     *   }
     * })
     * class Tooltip{
     *   text:string;
     *   overlay:Overlay; // NOT YET IMPLEMENTED
     *   overlayManager:OverlayManager; // NOT YET IMPLEMENTED
     *
     *   constructor(overlayManager:OverlayManager) {
     *     this.overlay = overlay;
     *   }
     *
     *   onMouseEnter() {
     *     // exact signature to be determined
     *     this.overlay = this.overlayManager.open(text, ...);
     *   }
     *
     *   onMouseLeave() {
     *     this.overlay.close();
     *     this.overlay = null;
     *   }
     * }
     * ```
     * In our HTML template, we can then add this behavior to a `<div>` or any other element with the
     * `tooltip` selector,
     * like so:
     *
     * ```
     * <div tooltip="some text here"></div>
     * ```
     *
     * Directives can also control the instantiation, destruction, and positioning of inline template
     * elements:
     *
     * A directive uses a {@link ViewContainerRef} to instantiate, insert, move, and destroy views at
     * runtime.
     * The {@link ViewContainerRef} is created as a result of `<template>` element, and represents a
     * location in the current view
     * where these actions are performed.
     *
     * Views are always created as children of the current {@link ViewMetadata}, and as siblings of the
     * `<template>` element. Thus a
     * directive in a child view cannot inject the directive that created it.
     *
     * Since directives that create views via ViewContainers are common in Angular, and using the full
     * `<template>` element syntax is wordy, Angular
     * also supports a shorthand notation: `<li *foo="bar">` and `<li template="foo: bar">` are
     * equivalent.
     *
     * Thus,
     *
     * ```
     * <ul>
     *   <li *foo="bar" title="text"></li>
     * </ul>
     * ```
     *
     * Expands in use to:
     *
     * ```
     * <ul>
     *   <template [foo]="bar">
     *     <li title="text"></li>
     *   </template>
     * </ul>
     * ```
     *
     * Notice that although the shorthand places `*foo="bar"` within the `<li>` element, the binding for
     * the directive
     * controller is correctly instantiated on the `<template>` element rather than the `<li>` element.
     *
     * ## Lifecycle hooks
     *
     * When the directive class implements some {@link angular2/lifecycle_hooks} the callbacks are
     * called by the change detection at defined points in time during the life of the directive.
     *
     * ### Example
     *
     * Let's suppose we want to implement the `unless` behavior, to conditionally include a template.
     *
     * Here is a simple directive that triggers on an `unless` selector:
     *
     * ```
     * @Directive({
     *   selector: '[unless]',
     *   inputs: ['unless']
     * })
     * export class Unless {
     *   viewContainer: ViewContainerRef;
     *   templateRef: TemplateRef;
     *   prevCondition: boolean;
     *
     *   constructor(viewContainer: ViewContainerRef, templateRef: TemplateRef) {
     *     this.viewContainer = viewContainer;
     *     this.templateRef = templateRef;
     *     this.prevCondition = null;
     *   }
     *
     *   set unless(newCondition) {
     *     if (newCondition && (isBlank(this.prevCondition) || !this.prevCondition)) {
     *       this.prevCondition = true;
     *       this.viewContainer.clear();
     *     } else if (!newCondition && (isBlank(this.prevCondition) || this.prevCondition)) {
     *       this.prevCondition = false;
     *       this.viewContainer.create(this.templateRef);
     *     }
     *   }
     * }
     * ```
     *
     * We can then use this `unless` selector in a template:
     * ```
     * <ul>
     *   <li *unless="expr"></li>
     * </ul>
     * ```
     *
     * Once the directive instantiates the child view, the shorthand notation for the template expands
     * and the result is:
     *
     * ```
     * <ul>
     *   <template [unless]="exp">
     *     <li></li>
     *   </template>
     *   <li></li>
     * </ul>
     * ```
     *
     * Note also that although the `<li></li>` template still exists inside the `<template></template>`,
     * the instantiated
     * view occurs on the second `<li></li>` which is a sibling to the `<template>` element.
     */
    var DirectiveMetadata = function (_super) {
        __extends(DirectiveMetadata, _super);
        function DirectiveMetadata(_a) {
            var _b = _a === void 0 ? {} : _a,
                selector = _b.selector,
                inputs = _b.inputs,
                outputs = _b.outputs,
                properties = _b.properties,
                events = _b.events,
                host = _b.host,
                bindings = _b.bindings,
                providers = _b.providers,
                exportAs = _b.exportAs,
                queries = _b.queries;
            _super.call(this);
            this.selector = selector;
            this._inputs = inputs;
            this._properties = properties;
            this._outputs = outputs;
            this._events = events;
            this.host = host;
            this.exportAs = exportAs;
            this.queries = queries;
            this._providers = providers;
            this._bindings = bindings;
        }
        Object.defineProperty(DirectiveMetadata.prototype, "inputs", {
            /**
             * Enumerates the set of data-bound input properties for a directive
             *
             * Angular automatically updates input properties during change detection.
             *
             * The `inputs` property defines a set of `directiveProperty` to `bindingProperty`
             * configuration:
             *
             * - `directiveProperty` specifies the component property where the value is written.
             * - `bindingProperty` specifies the DOM property where the value is read from.
             *
             * When `bindingProperty` is not provided, it is assumed to be equal to `directiveProperty`.
             *
             * ### Example ([live demo](http://plnkr.co/edit/ivhfXY?p=preview))
             *
             * The following example creates a component with two data-bound properties.
             *
             * ```typescript
             * @Component({
             *   selector: 'bank-account',
             *   inputs: ['bankName', 'id: account-id'],
             *   template: `
             *     Bank Name: {{bankName}}
             *     Account Id: {{id}}
             *   `
             * })
             * class BankAccount {
             *   bankName: string;
             *   id: string;
             *
             *   // this property is not bound, and won't be automatically updated by Angular
             *   normalizedBankName: string;
             * }
             *
             * @Component({
             *   selector: 'app',
             *   template: `
             *     <bank-account bank-name="RBC" account-id="4747"></bank-account>
             *   `,
             *   directives: [BankAccount]
             * })
             * class App {}
             *
             * bootstrap(App);
             * ```
             *
             */
            get: function () {
                return lang_1.isPresent(this._properties) && this._properties.length > 0 ? this._properties : this._inputs;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DirectiveMetadata.prototype, "properties", {
            get: function () {
                return this.inputs;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DirectiveMetadata.prototype, "outputs", {
            /**
             * Enumerates the set of event-bound output properties.
             *
             * When an output property emits an event, an event handler attached to that event
             * the template is invoked.
             *
             * The `outputs` property defines a set of `directiveProperty` to `bindingProperty`
             * configuration:
             *
             * - `directiveProperty` specifies the component property that emits events.
             * - `bindingProperty` specifies the DOM property the event handler is attached to.
             *
             * ### Example ([live demo](http://plnkr.co/edit/d5CNq7?p=preview))
             *
             * ```typescript
             * @Directive({
             *   selector: 'interval-dir',
             *   outputs: ['everySecond', 'five5Secs: everyFiveSeconds']
             * })
             * class IntervalDir {
             *   everySecond = new EventEmitter();
             *   five5Secs = new EventEmitter();
             *
             *   constructor() {
             *     setInterval(() => this.everySecond.emit("event"), 1000);
             *     setInterval(() => this.five5Secs.emit("event"), 5000);
             *   }
             * }
             *
             * @Component({
             *   selector: 'app',
             *   template: `
             *     <interval-dir (everySecond)="everySecond()" (everyFiveSeconds)="everyFiveSeconds()">
             *     </interval-dir>
             *   `,
             *   directives: [IntervalDir]
             * })
             * class App {
             *   everySecond() { console.log('second'); }
             *   everyFiveSeconds() { console.log('five seconds'); }
             * }
             * bootstrap(App);
             * ```
             *
             */
            get: function () {
                return lang_1.isPresent(this._events) && this._events.length > 0 ? this._events : this._outputs;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DirectiveMetadata.prototype, "events", {
            get: function () {
                return this.outputs;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DirectiveMetadata.prototype, "providers", {
            /**
             * Defines the set of injectable objects that are visible to a Directive and its light DOM
             * children.
             *
             * ## Simple Example
             *
             * Here is an example of a class that can be injected:
             *
             * ```
             * class Greeter {
             *    greet(name:string) {
             *      return 'Hello ' + name + '!';
             *    }
             * }
             *
             * @Directive({
             *   selector: 'greet',
             *   bindings: [
             *     Greeter
             *   ]
             * })
             * class HelloWorld {
             *   greeter:Greeter;
             *
             *   constructor(greeter:Greeter) {
             *     this.greeter = greeter;
             *   }
             * }
             * ```
             */
            get: function () {
                return lang_1.isPresent(this._bindings) && this._bindings.length > 0 ? this._bindings : this._providers;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DirectiveMetadata.prototype, "bindings", {
            /** @deprecated */
            get: function () {
                return this.providers;
            },
            enumerable: true,
            configurable: true
        });
        DirectiveMetadata = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [Object])], DirectiveMetadata);
        return DirectiveMetadata;
    }(metadata_1.InjectableMetadata);
    exports.DirectiveMetadata = DirectiveMetadata;
    /**
     * Declare reusable UI building blocks for an application.
     *
     * Each Angular component requires a single `@Component` annotation. The
     * `@Component`
     * annotation specifies when a component is instantiated, and which properties and hostListeners it
     * binds to.
     *
     * When a component is instantiated, Angular
     * - creates a shadow DOM for the component.
     * - loads the selected template into the shadow DOM.
     * - creates all the injectable objects configured with `providers` and `viewProviders`.
     *
     * All template expressions and statements are then evaluated against the component instance.
     *
     * For details on the `@View` annotation, see {@link ViewMetadata}.
     *
     * ## Lifecycle hooks
     *
     * When the component class implements some {@link angular2/lifecycle_hooks} the callbacks are
     * called by the change detection at defined points in time during the life of the component.
     *
     * ### Example
     *
     * {@example core/ts/metadata/metadata.ts region='component'}
     */
    var ComponentMetadata = function (_super) {
        __extends(ComponentMetadata, _super);
        function ComponentMetadata(_a) {
            var _b = _a === void 0 ? {} : _a,
                selector = _b.selector,
                inputs = _b.inputs,
                outputs = _b.outputs,
                properties = _b.properties,
                events = _b.events,
                host = _b.host,
                exportAs = _b.exportAs,
                moduleId = _b.moduleId,
                bindings = _b.bindings,
                providers = _b.providers,
                viewBindings = _b.viewBindings,
                viewProviders = _b.viewProviders,
                _c = _b.changeDetection,
                changeDetection = _c === void 0 ? change_detection_1.ChangeDetectionStrategy.Default : _c,
                queries = _b.queries,
                templateUrl = _b.templateUrl,
                template = _b.template,
                styleUrls = _b.styleUrls,
                styles = _b.styles,
                directives = _b.directives,
                pipes = _b.pipes,
                encapsulation = _b.encapsulation;
            _super.call(this, {
                selector: selector,
                inputs: inputs,
                outputs: outputs,
                properties: properties,
                events: events,
                host: host,
                exportAs: exportAs,
                bindings: bindings,
                providers: providers,
                queries: queries
            });
            this.changeDetection = changeDetection;
            this._viewProviders = viewProviders;
            this._viewBindings = viewBindings;
            this.templateUrl = templateUrl;
            this.template = template;
            this.styleUrls = styleUrls;
            this.styles = styles;
            this.directives = directives;
            this.pipes = pipes;
            this.encapsulation = encapsulation;
            this.moduleId = moduleId;
        }
        Object.defineProperty(ComponentMetadata.prototype, "viewProviders", {
            /**
             * Defines the set of injectable objects that are visible to its view DOM children.
             *
             * ## Simple Example
             *
             * Here is an example of a class that can be injected:
             *
             * ```
             * class Greeter {
             *    greet(name:string) {
             *      return 'Hello ' + name + '!';
             *    }
             * }
             *
             * @Directive({
             *   selector: 'needs-greeter'
             * })
             * class NeedsGreeter {
             *   greeter:Greeter;
             *
             *   constructor(greeter:Greeter) {
             *     this.greeter = greeter;
             *   }
             * }
             *
             * @Component({
             *   selector: 'greet',
             *   viewProviders: [
             *     Greeter
             *   ],
             *   template: `<needs-greeter></needs-greeter>`,
             *   directives: [NeedsGreeter]
             * })
             * class HelloWorld {
             * }
             *
             * ```
             */
            get: function () {
                return lang_1.isPresent(this._viewBindings) && this._viewBindings.length > 0 ? this._viewBindings : this._viewProviders;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ComponentMetadata.prototype, "viewBindings", {
            get: function () {
                return this.viewProviders;
            },
            enumerable: true,
            configurable: true
        });
        ComponentMetadata = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [Object])], ComponentMetadata);
        return ComponentMetadata;
    }(DirectiveMetadata);
    exports.ComponentMetadata = ComponentMetadata;
    /**
     * Declare reusable pipe function.
     *
     * A "pure" pipe is only re-evaluated when either the input or any of the arguments change.
     *
     * When not specified, pipes default to being pure.
     *
     * ### Example
     *
     * {@example core/ts/metadata/metadata.ts region='pipe'}
     */
    var PipeMetadata = function (_super) {
        __extends(PipeMetadata, _super);
        function PipeMetadata(_a) {
            var name = _a.name,
                pure = _a.pure;
            _super.call(this);
            this.name = name;
            this._pure = pure;
        }
        Object.defineProperty(PipeMetadata.prototype, "pure", {
            get: function () {
                return lang_1.isPresent(this._pure) ? this._pure : true;
            },
            enumerable: true,
            configurable: true
        });
        PipeMetadata = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [Object])], PipeMetadata);
        return PipeMetadata;
    }(metadata_1.InjectableMetadata);
    exports.PipeMetadata = PipeMetadata;
    /**
     * Declares a data-bound input property.
     *
     * Angular automatically updates data-bound properties during change detection.
     *
     * `InputMetadata` takes an optional parameter that specifies the name
     * used when instantiating a component in the template. When not provided,
     * the name of the decorated property is used.
     *
     * ### Example
     *
     * The following example creates a component with two input properties.
     *
     * ```typescript
     * @Component({
     *   selector: 'bank-account',
     *   template: `
     *     Bank Name: {{bankName}}
     *     Account Id: {{id}}
     *   `
     * })
     * class BankAccount {
     *   @Input() bankName: string;
     *   @Input('account-id') id: string;
     *
     *   // this property is not bound, and won't be automatically updated by Angular
     *   normalizedBankName: string;
     * }
     *
     * @Component({
     *   selector: 'app',
     *   template: `
     *     <bank-account bank-name="RBC" account-id="4747"></bank-account>
     *   `,
     *   directives: [BankAccount]
     * })
     * class App {}
     *
     * bootstrap(App);
     * ```
     */
    var InputMetadata = function () {
        function InputMetadata(
        /**
         * Name used when instantiating a component in the template.
         */
        bindingPropertyName) {
            this.bindingPropertyName = bindingPropertyName;
        }
        InputMetadata = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [String])], InputMetadata);
        return InputMetadata;
    }();
    exports.InputMetadata = InputMetadata;
    /**
     * Declares an event-bound output property.
     *
     * When an output property emits an event, an event handler attached to that event
     * the template is invoked.
     *
     * `OutputMetadata` takes an optional parameter that specifies the name
     * used when instantiating a component in the template. When not provided,
     * the name of the decorated property is used.
     *
     * ### Example
     *
     * ```typescript
     * @Directive({
     *   selector: 'interval-dir',
     * })
     * class IntervalDir {
     *   @Output() everySecond = new EventEmitter();
     *   @Output('everyFiveSeconds') five5Secs = new EventEmitter();
     *
     *   constructor() {
     *     setInterval(() => this.everySecond.emit("event"), 1000);
     *     setInterval(() => this.five5Secs.emit("event"), 5000);
     *   }
     * }
     *
     * @Component({
     *   selector: 'app',
     *   template: `
     *     <interval-dir (everySecond)="everySecond()" (everyFiveSeconds)="everyFiveSeconds()">
     *     </interval-dir>
     *   `,
     *   directives: [IntervalDir]
     * })
     * class App {
     *   everySecond() { console.log('second'); }
     *   everyFiveSeconds() { console.log('five seconds'); }
     * }
     * bootstrap(App);
     * ```
     */
    var OutputMetadata = function () {
        function OutputMetadata(bindingPropertyName) {
            this.bindingPropertyName = bindingPropertyName;
        }
        OutputMetadata = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [String])], OutputMetadata);
        return OutputMetadata;
    }();
    exports.OutputMetadata = OutputMetadata;
    /**
     * Declares a host property binding.
     *
     * Angular automatically checks host property bindings during change detection.
     * If a binding changes, it will update the host element of the directive.
     *
     * `HostBindingMetadata` takes an optional parameter that specifies the property
     * name of the host element that will be updated. When not provided,
     * the class property name is used.
     *
     * ### Example
     *
     * The following example creates a directive that sets the `valid` and `invalid` classes
     * on the DOM element that has ngModel directive on it.
     *
     * ```typescript
     * @Directive({selector: '[ngModel]'})
     * class NgModelStatus {
     *   constructor(public control:NgModel) {}
     *   @HostBinding('class.valid') get valid { return this.control.valid; }
     *   @HostBinding('class.invalid') get invalid { return this.control.invalid; }
     * }
     *
     * @Component({
     *   selector: 'app',
     *   template: `<input [(ngModel)]="prop">`,
     *   directives: [FORM_DIRECTIVES, NgModelStatus]
     * })
     * class App {
     *   prop;
     * }
     *
     * bootstrap(App);
     * ```
     */
    var HostBindingMetadata = function () {
        function HostBindingMetadata(hostPropertyName) {
            this.hostPropertyName = hostPropertyName;
        }
        HostBindingMetadata = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [String])], HostBindingMetadata);
        return HostBindingMetadata;
    }();
    exports.HostBindingMetadata = HostBindingMetadata;
    /**
     * Declares a host listener.
     *
     * Angular will invoke the decorated method when the host element emits the specified event.
     *
     * If the decorated method returns `false`, then `preventDefault` is applied on the DOM
     * event.
     *
     * ### Example
     *
     * The following example declares a directive that attaches a click listener to the button and
     * counts clicks.
     *
     * ```typescript
     * @Directive({selector: 'button[counting]'})
     * class CountClicks {
     *   numberOfClicks = 0;
     *
     *   @HostListener('click', ['$event.target'])
     *   onClick(btn) {
     *     console.log("button", btn, "number of clicks:", this.numberOfClicks++);
     *   }
     * }
     *
     * @Component({
     *   selector: 'app',
     *   template: `<button counting>Increment</button>`,
     *   directives: [CountClicks]
     * })
     * class App {}
     *
     * bootstrap(App);
     * ```
     */
    var HostListenerMetadata = function () {
        function HostListenerMetadata(eventName, args) {
            this.eventName = eventName;
            this.args = args;
        }
        HostListenerMetadata = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [String, Array])], HostListenerMetadata);
        return HostListenerMetadata;
    }();
    exports.HostListenerMetadata = HostListenerMetadata;
});
System.registerDynamic("angular2/src/core/change_detection/differs/iterable_differs.js", ["angular2/src/facade/lang.js", "angular2/src/facade/exceptions.js", "angular2/src/facade/collection.js", "angular2/src/core/di.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var exceptions_1 = $__require("angular2/src/facade/exceptions.js");
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var di_1 = $__require("angular2/src/core/di.js");
    /**
     * A repository of different iterable diffing strategies used by NgFor, NgClass, and others.
     */
    var IterableDiffers = function () {
        function IterableDiffers(factories) {
            this.factories = factories;
        }
        IterableDiffers.create = function (factories, parent) {
            if (lang_1.isPresent(parent)) {
                var copied = collection_1.ListWrapper.clone(parent.factories);
                factories = factories.concat(copied);
                return new IterableDiffers(factories);
            } else {
                return new IterableDiffers(factories);
            }
        };
        /**
         * Takes an array of {@link IterableDifferFactory} and returns a provider used to extend the
         * inherited {@link IterableDiffers} instance with the provided factories and return a new
         * {@link IterableDiffers} instance.
         *
         * The following example shows how to extend an existing list of factories,
               * which will only be applied to the injector for this component and its children.
               * This step is all that's required to make a new {@link IterableDiffer} available.
         *
         * ### Example
         *
         * ```
         * @Component({
         *   viewProviders: [
         *     IterableDiffers.extend([new ImmutableListDiffer()])
         *   ]
         * })
         * ```
         */
        IterableDiffers.extend = function (factories) {
            return new di_1.Provider(IterableDiffers, {
                useFactory: function (parent) {
                    if (lang_1.isBlank(parent)) {
                        // Typically would occur when calling IterableDiffers.extend inside of dependencies passed
                        // to
                        // bootstrap(), which would override default pipes instead of extending them.
                        throw new exceptions_1.BaseException('Cannot extend IterableDiffers without a parent injector');
                    }
                    return IterableDiffers.create(factories, parent);
                },
                // Dependency technically isn't optional, but we can provide a better error message this way.
                deps: [[IterableDiffers, new di_1.SkipSelfMetadata(), new di_1.OptionalMetadata()]]
            });
        };
        IterableDiffers.prototype.find = function (iterable) {
            var factory = this.factories.find(function (f) {
                return f.supports(iterable);
            });
            if (lang_1.isPresent(factory)) {
                return factory;
            } else {
                throw new exceptions_1.BaseException("Cannot find a differ supporting object '" + iterable + "' of type '" + lang_1.getTypeNameForDebugging(iterable) + "'");
            }
        };
        IterableDiffers = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [Array])], IterableDiffers);
        return IterableDiffers;
    }();
    exports.IterableDiffers = IterableDiffers;
});
System.registerDynamic("angular2/src/core/change_detection/differs/default_iterable_differ.js", ["angular2/src/facade/lang.js", "angular2/src/facade/exceptions.js", "angular2/src/facade/collection.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var exceptions_1 = $__require("angular2/src/facade/exceptions.js");
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var lang_2 = $__require("angular2/src/facade/lang.js");
    var DefaultIterableDifferFactory = function () {
        function DefaultIterableDifferFactory() {}
        DefaultIterableDifferFactory.prototype.supports = function (obj) {
            return collection_1.isListLikeIterable(obj);
        };
        DefaultIterableDifferFactory.prototype.create = function (cdRef, trackByFn) {
            return new DefaultIterableDiffer(trackByFn);
        };
        DefaultIterableDifferFactory = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [])], DefaultIterableDifferFactory);
        return DefaultIterableDifferFactory;
    }();
    exports.DefaultIterableDifferFactory = DefaultIterableDifferFactory;
    var trackByIdentity = function (index, item) {
        return item;
    };
    var DefaultIterableDiffer = function () {
        function DefaultIterableDiffer(_trackByFn) {
            this._trackByFn = _trackByFn;
            this._length = null;
            this._collection = null;
            // Keeps track of the used records at any point in time (during & across `_check()` calls)
            this._linkedRecords = null;
            // Keeps track of the removed records at any point in time during `_check()` calls.
            this._unlinkedRecords = null;
            this._previousItHead = null;
            this._itHead = null;
            this._itTail = null;
            this._additionsHead = null;
            this._additionsTail = null;
            this._movesHead = null;
            this._movesTail = null;
            this._removalsHead = null;
            this._removalsTail = null;
            // Keeps track of records where custom track by is the same, but item identity has changed
            this._identityChangesHead = null;
            this._identityChangesTail = null;
            this._trackByFn = lang_2.isPresent(this._trackByFn) ? this._trackByFn : trackByIdentity;
        }
        Object.defineProperty(DefaultIterableDiffer.prototype, "collection", {
            get: function () {
                return this._collection;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(DefaultIterableDiffer.prototype, "length", {
            get: function () {
                return this._length;
            },
            enumerable: true,
            configurable: true
        });
        DefaultIterableDiffer.prototype.forEachItem = function (fn) {
            var record;
            for (record = this._itHead; record !== null; record = record._next) {
                fn(record);
            }
        };
        DefaultIterableDiffer.prototype.forEachPreviousItem = function (fn) {
            var record;
            for (record = this._previousItHead; record !== null; record = record._nextPrevious) {
                fn(record);
            }
        };
        DefaultIterableDiffer.prototype.forEachAddedItem = function (fn) {
            var record;
            for (record = this._additionsHead; record !== null; record = record._nextAdded) {
                fn(record);
            }
        };
        DefaultIterableDiffer.prototype.forEachMovedItem = function (fn) {
            var record;
            for (record = this._movesHead; record !== null; record = record._nextMoved) {
                fn(record);
            }
        };
        DefaultIterableDiffer.prototype.forEachRemovedItem = function (fn) {
            var record;
            for (record = this._removalsHead; record !== null; record = record._nextRemoved) {
                fn(record);
            }
        };
        DefaultIterableDiffer.prototype.forEachIdentityChange = function (fn) {
            var record;
            for (record = this._identityChangesHead; record !== null; record = record._nextIdentityChange) {
                fn(record);
            }
        };
        DefaultIterableDiffer.prototype.diff = function (collection) {
            if (lang_2.isBlank(collection)) collection = [];
            if (!collection_1.isListLikeIterable(collection)) {
                throw new exceptions_1.BaseException("Error trying to diff '" + collection + "'");
            }
            if (this.check(collection)) {
                return this;
            } else {
                return null;
            }
        };
        DefaultIterableDiffer.prototype.onDestroy = function () {};
        // todo(vicb): optim for UnmodifiableListView (frozen arrays)
        DefaultIterableDiffer.prototype.check = function (collection) {
            var _this = this;
            this._reset();
            var record = this._itHead;
            var mayBeDirty = false;
            var index;
            var item;
            var itemTrackBy;
            if (lang_2.isArray(collection)) {
                var list = collection;
                this._length = collection.length;
                for (index = 0; index < this._length; index++) {
                    item = list[index];
                    itemTrackBy = this._trackByFn(index, item);
                    if (record === null || !lang_2.looseIdentical(record.trackById, itemTrackBy)) {
                        record = this._mismatch(record, item, itemTrackBy, index);
                        mayBeDirty = true;
                    } else {
                        if (mayBeDirty) {
                            // TODO(misko): can we limit this to duplicates only?
                            record = this._verifyReinsertion(record, item, itemTrackBy, index);
                        }
                        if (!lang_2.looseIdentical(record.item, item)) this._addIdentityChange(record, item);
                    }
                    record = record._next;
                }
            } else {
                index = 0;
                collection_1.iterateListLike(collection, function (item) {
                    itemTrackBy = _this._trackByFn(index, item);
                    if (record === null || !lang_2.looseIdentical(record.trackById, itemTrackBy)) {
                        record = _this._mismatch(record, item, itemTrackBy, index);
                        mayBeDirty = true;
                    } else {
                        if (mayBeDirty) {
                            // TODO(misko): can we limit this to duplicates only?
                            record = _this._verifyReinsertion(record, item, itemTrackBy, index);
                        }
                        if (!lang_2.looseIdentical(record.item, item)) _this._addIdentityChange(record, item);
                    }
                    record = record._next;
                    index++;
                });
                this._length = index;
            }
            this._truncate(record);
            this._collection = collection;
            return this.isDirty;
        };
        Object.defineProperty(DefaultIterableDiffer.prototype, "isDirty", {
            /* CollectionChanges is considered dirty if it has any additions, moves, removals, or identity
             * changes.
             */
            get: function () {
                return this._additionsHead !== null || this._movesHead !== null || this._removalsHead !== null || this._identityChangesHead !== null;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Reset the state of the change objects to show no changes. This means set previousKey to
         * currentKey, and clear all of the queues (additions, moves, removals).
         * Set the previousIndexes of moved and added items to their currentIndexes
         * Reset the list of additions, moves and removals
         *
         * @internal
         */
        DefaultIterableDiffer.prototype._reset = function () {
            if (this.isDirty) {
                var record;
                var nextRecord;
                for (record = this._previousItHead = this._itHead; record !== null; record = record._next) {
                    record._nextPrevious = record._next;
                }
                for (record = this._additionsHead; record !== null; record = record._nextAdded) {
                    record.previousIndex = record.currentIndex;
                }
                this._additionsHead = this._additionsTail = null;
                for (record = this._movesHead; record !== null; record = nextRecord) {
                    record.previousIndex = record.currentIndex;
                    nextRecord = record._nextMoved;
                }
                this._movesHead = this._movesTail = null;
                this._removalsHead = this._removalsTail = null;
                this._identityChangesHead = this._identityChangesTail = null;
            }
        };
        /**
         * This is the core function which handles differences between collections.
         *
         * - `record` is the record which we saw at this position last time. If null then it is a new
         *   item.
         * - `item` is the current item in the collection
         * - `index` is the position of the item in the collection
         *
         * @internal
         */
        DefaultIterableDiffer.prototype._mismatch = function (record, item, itemTrackBy, index) {
            // The previous record after which we will append the current one.
            var previousRecord;
            if (record === null) {
                previousRecord = this._itTail;
            } else {
                previousRecord = record._prev;
                // Remove the record from the collection since we know it does not match the item.
                this._remove(record);
            }
            // Attempt to see if we have seen the item before.
            record = this._linkedRecords === null ? null : this._linkedRecords.get(itemTrackBy, index);
            if (record !== null) {
                // We have seen this before, we need to move it forward in the collection.
                // But first we need to check if identity changed, so we can update in view if necessary
                if (!lang_2.looseIdentical(record.item, item)) this._addIdentityChange(record, item);
                this._moveAfter(record, previousRecord, index);
            } else {
                // Never seen it, check evicted list.
                record = this._unlinkedRecords === null ? null : this._unlinkedRecords.get(itemTrackBy);
                if (record !== null) {
                    // It is an item which we have evicted earlier: reinsert it back into the list.
                    // But first we need to check if identity changed, so we can update in view if necessary
                    if (!lang_2.looseIdentical(record.item, item)) this._addIdentityChange(record, item);
                    this._reinsertAfter(record, previousRecord, index);
                } else {
                    // It is a new item: add it.
                    record = this._addAfter(new CollectionChangeRecord(item, itemTrackBy), previousRecord, index);
                }
            }
            return record;
        };
        /**
         * This check is only needed if an array contains duplicates. (Short circuit of nothing dirty)
         *
         * Use case: `[a, a]` => `[b, a, a]`
         *
         * If we did not have this check then the insertion of `b` would:
         *   1) evict first `a`
         *   2) insert `b` at `0` index.
         *   3) leave `a` at index `1` as is. <-- this is wrong!
         *   3) reinsert `a` at index 2. <-- this is wrong!
         *
         * The correct behavior is:
         *   1) evict first `a`
         *   2) insert `b` at `0` index.
         *   3) reinsert `a` at index 1.
         *   3) move `a` at from `1` to `2`.
         *
         *
         * Double check that we have not evicted a duplicate item. We need to check if the item type may
         * have already been removed:
         * The insertion of b will evict the first 'a'. If we don't reinsert it now it will be reinserted
         * at the end. Which will show up as the two 'a's switching position. This is incorrect, since a
         * better way to think of it is as insert of 'b' rather then switch 'a' with 'b' and then add 'a'
         * at the end.
         *
         * @internal
         */
        DefaultIterableDiffer.prototype._verifyReinsertion = function (record, item, itemTrackBy, index) {
            var reinsertRecord = this._unlinkedRecords === null ? null : this._unlinkedRecords.get(itemTrackBy);
            if (reinsertRecord !== null) {
                record = this._reinsertAfter(reinsertRecord, record._prev, index);
            } else if (record.currentIndex != index) {
                record.currentIndex = index;
                this._addToMoves(record, index);
            }
            return record;
        };
        /**
         * Get rid of any excess {@link CollectionChangeRecord}s from the previous collection
         *
         * - `record` The first excess {@link CollectionChangeRecord}.
         *
         * @internal
         */
        DefaultIterableDiffer.prototype._truncate = function (record) {
            // Anything after that needs to be removed;
            while (record !== null) {
                var nextRecord = record._next;
                this._addToRemovals(this._unlink(record));
                record = nextRecord;
            }
            if (this._unlinkedRecords !== null) {
                this._unlinkedRecords.clear();
            }
            if (this._additionsTail !== null) {
                this._additionsTail._nextAdded = null;
            }
            if (this._movesTail !== null) {
                this._movesTail._nextMoved = null;
            }
            if (this._itTail !== null) {
                this._itTail._next = null;
            }
            if (this._removalsTail !== null) {
                this._removalsTail._nextRemoved = null;
            }
            if (this._identityChangesTail !== null) {
                this._identityChangesTail._nextIdentityChange = null;
            }
        };
        /** @internal */
        DefaultIterableDiffer.prototype._reinsertAfter = function (record, prevRecord, index) {
            if (this._unlinkedRecords !== null) {
                this._unlinkedRecords.remove(record);
            }
            var prev = record._prevRemoved;
            var next = record._nextRemoved;
            if (prev === null) {
                this._removalsHead = next;
            } else {
                prev._nextRemoved = next;
            }
            if (next === null) {
                this._removalsTail = prev;
            } else {
                next._prevRemoved = prev;
            }
            this._insertAfter(record, prevRecord, index);
            this._addToMoves(record, index);
            return record;
        };
        /** @internal */
        DefaultIterableDiffer.prototype._moveAfter = function (record, prevRecord, index) {
            this._unlink(record);
            this._insertAfter(record, prevRecord, index);
            this._addToMoves(record, index);
            return record;
        };
        /** @internal */
        DefaultIterableDiffer.prototype._addAfter = function (record, prevRecord, index) {
            this._insertAfter(record, prevRecord, index);
            if (this._additionsTail === null) {
                // todo(vicb)
                // assert(this._additionsHead === null);
                this._additionsTail = this._additionsHead = record;
            } else {
                // todo(vicb)
                // assert(_additionsTail._nextAdded === null);
                // assert(record._nextAdded === null);
                this._additionsTail = this._additionsTail._nextAdded = record;
            }
            return record;
        };
        /** @internal */
        DefaultIterableDiffer.prototype._insertAfter = function (record, prevRecord, index) {
            // todo(vicb)
            // assert(record != prevRecord);
            // assert(record._next === null);
            // assert(record._prev === null);
            var next = prevRecord === null ? this._itHead : prevRecord._next;
            // todo(vicb)
            // assert(next != record);
            // assert(prevRecord != record);
            record._next = next;
            record._prev = prevRecord;
            if (next === null) {
                this._itTail = record;
            } else {
                next._prev = record;
            }
            if (prevRecord === null) {
                this._itHead = record;
            } else {
                prevRecord._next = record;
            }
            if (this._linkedRecords === null) {
                this._linkedRecords = new _DuplicateMap();
            }
            this._linkedRecords.put(record);
            record.currentIndex = index;
            return record;
        };
        /** @internal */
        DefaultIterableDiffer.prototype._remove = function (record) {
            return this._addToRemovals(this._unlink(record));
        };
        /** @internal */
        DefaultIterableDiffer.prototype._unlink = function (record) {
            if (this._linkedRecords !== null) {
                this._linkedRecords.remove(record);
            }
            var prev = record._prev;
            var next = record._next;
            // todo(vicb)
            // assert((record._prev = null) === null);
            // assert((record._next = null) === null);
            if (prev === null) {
                this._itHead = next;
            } else {
                prev._next = next;
            }
            if (next === null) {
                this._itTail = prev;
            } else {
                next._prev = prev;
            }
            return record;
        };
        /** @internal */
        DefaultIterableDiffer.prototype._addToMoves = function (record, toIndex) {
            // todo(vicb)
            // assert(record._nextMoved === null);
            if (record.previousIndex === toIndex) {
                return record;
            }
            if (this._movesTail === null) {
                // todo(vicb)
                // assert(_movesHead === null);
                this._movesTail = this._movesHead = record;
            } else {
                // todo(vicb)
                // assert(_movesTail._nextMoved === null);
                this._movesTail = this._movesTail._nextMoved = record;
            }
            return record;
        };
        /** @internal */
        DefaultIterableDiffer.prototype._addToRemovals = function (record) {
            if (this._unlinkedRecords === null) {
                this._unlinkedRecords = new _DuplicateMap();
            }
            this._unlinkedRecords.put(record);
            record.currentIndex = null;
            record._nextRemoved = null;
            if (this._removalsTail === null) {
                // todo(vicb)
                // assert(_removalsHead === null);
                this._removalsTail = this._removalsHead = record;
                record._prevRemoved = null;
            } else {
                // todo(vicb)
                // assert(_removalsTail._nextRemoved === null);
                // assert(record._nextRemoved === null);
                record._prevRemoved = this._removalsTail;
                this._removalsTail = this._removalsTail._nextRemoved = record;
            }
            return record;
        };
        /** @internal */
        DefaultIterableDiffer.prototype._addIdentityChange = function (record, item) {
            record.item = item;
            if (this._identityChangesTail === null) {
                this._identityChangesTail = this._identityChangesHead = record;
            } else {
                this._identityChangesTail = this._identityChangesTail._nextIdentityChange = record;
            }
            return record;
        };
        DefaultIterableDiffer.prototype.toString = function () {
            var list = [];
            this.forEachItem(function (record) {
                return list.push(record);
            });
            var previous = [];
            this.forEachPreviousItem(function (record) {
                return previous.push(record);
            });
            var additions = [];
            this.forEachAddedItem(function (record) {
                return additions.push(record);
            });
            var moves = [];
            this.forEachMovedItem(function (record) {
                return moves.push(record);
            });
            var removals = [];
            this.forEachRemovedItem(function (record) {
                return removals.push(record);
            });
            var identityChanges = [];
            this.forEachIdentityChange(function (record) {
                return identityChanges.push(record);
            });
            return "collection: " + list.join(', ') + "\n" + "previous: " + previous.join(', ') + "\n" + "additions: " + additions.join(', ') + "\n" + "moves: " + moves.join(', ') + "\n" + "removals: " + removals.join(', ') + "\n" + "identityChanges: " + identityChanges.join(', ') + "\n";
        };
        return DefaultIterableDiffer;
    }();
    exports.DefaultIterableDiffer = DefaultIterableDiffer;
    var CollectionChangeRecord = function () {
        function CollectionChangeRecord(item, trackById) {
            this.item = item;
            this.trackById = trackById;
            this.currentIndex = null;
            this.previousIndex = null;
            /** @internal */
            this._nextPrevious = null;
            /** @internal */
            this._prev = null;
            /** @internal */
            this._next = null;
            /** @internal */
            this._prevDup = null;
            /** @internal */
            this._nextDup = null;
            /** @internal */
            this._prevRemoved = null;
            /** @internal */
            this._nextRemoved = null;
            /** @internal */
            this._nextAdded = null;
            /** @internal */
            this._nextMoved = null;
            /** @internal */
            this._nextIdentityChange = null;
        }
        CollectionChangeRecord.prototype.toString = function () {
            return this.previousIndex === this.currentIndex ? lang_2.stringify(this.item) : lang_2.stringify(this.item) + '[' + lang_2.stringify(this.previousIndex) + '->' + lang_2.stringify(this.currentIndex) + ']';
        };
        return CollectionChangeRecord;
    }();
    exports.CollectionChangeRecord = CollectionChangeRecord;
    // A linked list of CollectionChangeRecords with the same CollectionChangeRecord.item
    var _DuplicateItemRecordList = function () {
        function _DuplicateItemRecordList() {
            /** @internal */
            this._head = null;
            /** @internal */
            this._tail = null;
        }
        /**
         * Append the record to the list of duplicates.
         *
         * Note: by design all records in the list of duplicates hold the same value in record.item.
         */
        _DuplicateItemRecordList.prototype.add = function (record) {
            if (this._head === null) {
                this._head = this._tail = record;
                record._nextDup = null;
                record._prevDup = null;
            } else {
                // todo(vicb)
                // assert(record.item ==  _head.item ||
                //       record.item is num && record.item.isNaN && _head.item is num && _head.item.isNaN);
                this._tail._nextDup = record;
                record._prevDup = this._tail;
                record._nextDup = null;
                this._tail = record;
            }
        };
        // Returns a CollectionChangeRecord having CollectionChangeRecord.trackById == trackById and
        // CollectionChangeRecord.currentIndex >= afterIndex
        _DuplicateItemRecordList.prototype.get = function (trackById, afterIndex) {
            var record;
            for (record = this._head; record !== null; record = record._nextDup) {
                if ((afterIndex === null || afterIndex < record.currentIndex) && lang_2.looseIdentical(record.trackById, trackById)) {
                    return record;
                }
            }
            return null;
        };
        /**
         * Remove one {@link CollectionChangeRecord} from the list of duplicates.
         *
         * Returns whether the list of duplicates is empty.
         */
        _DuplicateItemRecordList.prototype.remove = function (record) {
            // todo(vicb)
            // assert(() {
            //  // verify that the record being removed is in the list.
            //  for (CollectionChangeRecord cursor = _head; cursor != null; cursor = cursor._nextDup) {
            //    if (identical(cursor, record)) return true;
            //  }
            //  return false;
            //});
            var prev = record._prevDup;
            var next = record._nextDup;
            if (prev === null) {
                this._head = next;
            } else {
                prev._nextDup = next;
            }
            if (next === null) {
                this._tail = prev;
            } else {
                next._prevDup = prev;
            }
            return this._head === null;
        };
        return _DuplicateItemRecordList;
    }();
    var _DuplicateMap = function () {
        function _DuplicateMap() {
            this.map = new Map();
        }
        _DuplicateMap.prototype.put = function (record) {
            // todo(vicb) handle corner cases
            var key = lang_2.getMapKey(record.trackById);
            var duplicates = this.map.get(key);
            if (!lang_2.isPresent(duplicates)) {
                duplicates = new _DuplicateItemRecordList();
                this.map.set(key, duplicates);
            }
            duplicates.add(record);
        };
        /**
         * Retrieve the `value` using key. Because the CollectionChangeRecord value may be one which we
         * have already iterated over, we use the afterIndex to pretend it is not there.
         *
         * Use case: `[a, b, c, a, a]` if we are at index `3` which is the second `a` then asking if we
         * have any more `a`s needs to return the last `a` not the first or second.
         */
        _DuplicateMap.prototype.get = function (trackById, afterIndex) {
            if (afterIndex === void 0) {
                afterIndex = null;
            }
            var key = lang_2.getMapKey(trackById);
            var recordList = this.map.get(key);
            return lang_2.isBlank(recordList) ? null : recordList.get(trackById, afterIndex);
        };
        /**
         * Removes a {@link CollectionChangeRecord} from the list of duplicates.
         *
         * The list of duplicates also is removed from the map if it gets empty.
         */
        _DuplicateMap.prototype.remove = function (record) {
            var key = lang_2.getMapKey(record.trackById);
            // todo(vicb)
            // assert(this.map.containsKey(key));
            var recordList = this.map.get(key);
            // Remove the list of duplicates when it gets empty
            if (recordList.remove(record)) {
                this.map.delete(key);
            }
            return record;
        };
        Object.defineProperty(_DuplicateMap.prototype, "isEmpty", {
            get: function () {
                return this.map.size === 0;
            },
            enumerable: true,
            configurable: true
        });
        _DuplicateMap.prototype.clear = function () {
            this.map.clear();
        };
        _DuplicateMap.prototype.toString = function () {
            return '_DuplicateMap(' + lang_2.stringify(this.map) + ')';
        };
        return _DuplicateMap;
    }();
});
System.registerDynamic("angular2/src/core/change_detection/differs/keyvalue_differs.js", ["angular2/src/facade/lang.js", "angular2/src/facade/exceptions.js", "angular2/src/facade/collection.js", "angular2/src/core/di.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var exceptions_1 = $__require("angular2/src/facade/exceptions.js");
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var di_1 = $__require("angular2/src/core/di.js");
    /**
     * A repository of different Map diffing strategies used by NgClass, NgStyle, and others.
     */
    var KeyValueDiffers = function () {
        function KeyValueDiffers(factories) {
            this.factories = factories;
        }
        KeyValueDiffers.create = function (factories, parent) {
            if (lang_1.isPresent(parent)) {
                var copied = collection_1.ListWrapper.clone(parent.factories);
                factories = factories.concat(copied);
                return new KeyValueDiffers(factories);
            } else {
                return new KeyValueDiffers(factories);
            }
        };
        /**
         * Takes an array of {@link KeyValueDifferFactory} and returns a provider used to extend the
         * inherited {@link KeyValueDiffers} instance with the provided factories and return a new
         * {@link KeyValueDiffers} instance.
         *
         * The following example shows how to extend an existing list of factories,
               * which will only be applied to the injector for this component and its children.
               * This step is all that's required to make a new {@link KeyValueDiffer} available.
         *
         * ### Example
         *
         * ```
         * @Component({
         *   viewProviders: [
         *     KeyValueDiffers.extend([new ImmutableMapDiffer()])
         *   ]
         * })
         * ```
         */
        KeyValueDiffers.extend = function (factories) {
            return new di_1.Provider(KeyValueDiffers, {
                useFactory: function (parent) {
                    if (lang_1.isBlank(parent)) {
                        // Typically would occur when calling KeyValueDiffers.extend inside of dependencies passed
                        // to
                        // bootstrap(), which would override default pipes instead of extending them.
                        throw new exceptions_1.BaseException('Cannot extend KeyValueDiffers without a parent injector');
                    }
                    return KeyValueDiffers.create(factories, parent);
                },
                // Dependency technically isn't optional, but we can provide a better error message this way.
                deps: [[KeyValueDiffers, new di_1.SkipSelfMetadata(), new di_1.OptionalMetadata()]]
            });
        };
        KeyValueDiffers.prototype.find = function (kv) {
            var factory = this.factories.find(function (f) {
                return f.supports(kv);
            });
            if (lang_1.isPresent(factory)) {
                return factory;
            } else {
                throw new exceptions_1.BaseException("Cannot find a differ supporting object '" + kv + "'");
            }
        };
        KeyValueDiffers = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [Array])], KeyValueDiffers);
        return KeyValueDiffers;
    }();
    exports.KeyValueDiffers = KeyValueDiffers;
});
System.registerDynamic("angular2/src/core/change_detection/differs/default_keyvalue_differ.js", ["angular2/src/facade/collection.js", "angular2/src/facade/lang.js", "angular2/src/facade/exceptions.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var exceptions_1 = $__require("angular2/src/facade/exceptions.js");
    var DefaultKeyValueDifferFactory = function () {
        function DefaultKeyValueDifferFactory() {}
        DefaultKeyValueDifferFactory.prototype.supports = function (obj) {
            return obj instanceof Map || lang_1.isJsObject(obj);
        };
        DefaultKeyValueDifferFactory.prototype.create = function (cdRef) {
            return new DefaultKeyValueDiffer();
        };
        DefaultKeyValueDifferFactory = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [])], DefaultKeyValueDifferFactory);
        return DefaultKeyValueDifferFactory;
    }();
    exports.DefaultKeyValueDifferFactory = DefaultKeyValueDifferFactory;
    var DefaultKeyValueDiffer = function () {
        function DefaultKeyValueDiffer() {
            this._records = new Map();
            this._mapHead = null;
            this._previousMapHead = null;
            this._changesHead = null;
            this._changesTail = null;
            this._additionsHead = null;
            this._additionsTail = null;
            this._removalsHead = null;
            this._removalsTail = null;
        }
        Object.defineProperty(DefaultKeyValueDiffer.prototype, "isDirty", {
            get: function () {
                return this._additionsHead !== null || this._changesHead !== null || this._removalsHead !== null;
            },
            enumerable: true,
            configurable: true
        });
        DefaultKeyValueDiffer.prototype.forEachItem = function (fn) {
            var record;
            for (record = this._mapHead; record !== null; record = record._next) {
                fn(record);
            }
        };
        DefaultKeyValueDiffer.prototype.forEachPreviousItem = function (fn) {
            var record;
            for (record = this._previousMapHead; record !== null; record = record._nextPrevious) {
                fn(record);
            }
        };
        DefaultKeyValueDiffer.prototype.forEachChangedItem = function (fn) {
            var record;
            for (record = this._changesHead; record !== null; record = record._nextChanged) {
                fn(record);
            }
        };
        DefaultKeyValueDiffer.prototype.forEachAddedItem = function (fn) {
            var record;
            for (record = this._additionsHead; record !== null; record = record._nextAdded) {
                fn(record);
            }
        };
        DefaultKeyValueDiffer.prototype.forEachRemovedItem = function (fn) {
            var record;
            for (record = this._removalsHead; record !== null; record = record._nextRemoved) {
                fn(record);
            }
        };
        DefaultKeyValueDiffer.prototype.diff = function (map) {
            if (lang_1.isBlank(map)) map = collection_1.MapWrapper.createFromPairs([]);
            if (!(map instanceof Map || lang_1.isJsObject(map))) {
                throw new exceptions_1.BaseException("Error trying to diff '" + map + "'");
            }
            if (this.check(map)) {
                return this;
            } else {
                return null;
            }
        };
        DefaultKeyValueDiffer.prototype.onDestroy = function () {};
        DefaultKeyValueDiffer.prototype.check = function (map) {
            var _this = this;
            this._reset();
            var records = this._records;
            var oldSeqRecord = this._mapHead;
            var lastOldSeqRecord = null;
            var lastNewSeqRecord = null;
            var seqChanged = false;
            this._forEach(map, function (value, key) {
                var newSeqRecord;
                if (oldSeqRecord !== null && key === oldSeqRecord.key) {
                    newSeqRecord = oldSeqRecord;
                    if (!lang_1.looseIdentical(value, oldSeqRecord.currentValue)) {
                        oldSeqRecord.previousValue = oldSeqRecord.currentValue;
                        oldSeqRecord.currentValue = value;
                        _this._addToChanges(oldSeqRecord);
                    }
                } else {
                    seqChanged = true;
                    if (oldSeqRecord !== null) {
                        oldSeqRecord._next = null;
                        _this._removeFromSeq(lastOldSeqRecord, oldSeqRecord);
                        _this._addToRemovals(oldSeqRecord);
                    }
                    if (records.has(key)) {
                        newSeqRecord = records.get(key);
                    } else {
                        newSeqRecord = new KeyValueChangeRecord(key);
                        records.set(key, newSeqRecord);
                        newSeqRecord.currentValue = value;
                        _this._addToAdditions(newSeqRecord);
                    }
                }
                if (seqChanged) {
                    if (_this._isInRemovals(newSeqRecord)) {
                        _this._removeFromRemovals(newSeqRecord);
                    }
                    if (lastNewSeqRecord == null) {
                        _this._mapHead = newSeqRecord;
                    } else {
                        lastNewSeqRecord._next = newSeqRecord;
                    }
                }
                lastOldSeqRecord = oldSeqRecord;
                lastNewSeqRecord = newSeqRecord;
                oldSeqRecord = oldSeqRecord === null ? null : oldSeqRecord._next;
            });
            this._truncate(lastOldSeqRecord, oldSeqRecord);
            return this.isDirty;
        };
        /** @internal */
        DefaultKeyValueDiffer.prototype._reset = function () {
            if (this.isDirty) {
                var record;
                // Record the state of the mapping
                for (record = this._previousMapHead = this._mapHead; record !== null; record = record._next) {
                    record._nextPrevious = record._next;
                }
                for (record = this._changesHead; record !== null; record = record._nextChanged) {
                    record.previousValue = record.currentValue;
                }
                for (record = this._additionsHead; record != null; record = record._nextAdded) {
                    record.previousValue = record.currentValue;
                }
                // todo(vicb) once assert is supported
                // assert(() {
                //  var r = _changesHead;
                //  while (r != null) {
                //    var nextRecord = r._nextChanged;
                //    r._nextChanged = null;
                //    r = nextRecord;
                //  }
                //
                //  r = _additionsHead;
                //  while (r != null) {
                //    var nextRecord = r._nextAdded;
                //    r._nextAdded = null;
                //    r = nextRecord;
                //  }
                //
                //  r = _removalsHead;
                //  while (r != null) {
                //    var nextRecord = r._nextRemoved;
                //    r._nextRemoved = null;
                //    r = nextRecord;
                //  }
                //
                //  return true;
                //});
                this._changesHead = this._changesTail = null;
                this._additionsHead = this._additionsTail = null;
                this._removalsHead = this._removalsTail = null;
            }
        };
        /** @internal */
        DefaultKeyValueDiffer.prototype._truncate = function (lastRecord, record) {
            while (record !== null) {
                if (lastRecord === null) {
                    this._mapHead = null;
                } else {
                    lastRecord._next = null;
                }
                var nextRecord = record._next;
                // todo(vicb) assert
                // assert((() {
                //  record._next = null;
                //  return true;
                //}));
                this._addToRemovals(record);
                lastRecord = record;
                record = nextRecord;
            }
            for (var rec = this._removalsHead; rec !== null; rec = rec._nextRemoved) {
                rec.previousValue = rec.currentValue;
                rec.currentValue = null;
                this._records.delete(rec.key);
            }
        };
        /** @internal */
        DefaultKeyValueDiffer.prototype._isInRemovals = function (record) {
            return record === this._removalsHead || record._nextRemoved !== null || record._prevRemoved !== null;
        };
        /** @internal */
        DefaultKeyValueDiffer.prototype._addToRemovals = function (record) {
            // todo(vicb) assert
            // assert(record._next == null);
            // assert(record._nextAdded == null);
            // assert(record._nextChanged == null);
            // assert(record._nextRemoved == null);
            // assert(record._prevRemoved == null);
            if (this._removalsHead === null) {
                this._removalsHead = this._removalsTail = record;
            } else {
                this._removalsTail._nextRemoved = record;
                record._prevRemoved = this._removalsTail;
                this._removalsTail = record;
            }
        };
        /** @internal */
        DefaultKeyValueDiffer.prototype._removeFromSeq = function (prev, record) {
            var next = record._next;
            if (prev === null) {
                this._mapHead = next;
            } else {
                prev._next = next;
            }
            // todo(vicb) assert
            // assert((() {
            //  record._next = null;
            //  return true;
            //})());
        };
        /** @internal */
        DefaultKeyValueDiffer.prototype._removeFromRemovals = function (record) {
            // todo(vicb) assert
            // assert(record._next == null);
            // assert(record._nextAdded == null);
            // assert(record._nextChanged == null);
            var prev = record._prevRemoved;
            var next = record._nextRemoved;
            if (prev === null) {
                this._removalsHead = next;
            } else {
                prev._nextRemoved = next;
            }
            if (next === null) {
                this._removalsTail = prev;
            } else {
                next._prevRemoved = prev;
            }
            record._prevRemoved = record._nextRemoved = null;
        };
        /** @internal */
        DefaultKeyValueDiffer.prototype._addToAdditions = function (record) {
            // todo(vicb): assert
            // assert(record._next == null);
            // assert(record._nextAdded == null);
            // assert(record._nextChanged == null);
            // assert(record._nextRemoved == null);
            // assert(record._prevRemoved == null);
            if (this._additionsHead === null) {
                this._additionsHead = this._additionsTail = record;
            } else {
                this._additionsTail._nextAdded = record;
                this._additionsTail = record;
            }
        };
        /** @internal */
        DefaultKeyValueDiffer.prototype._addToChanges = function (record) {
            // todo(vicb) assert
            // assert(record._nextAdded == null);
            // assert(record._nextChanged == null);
            // assert(record._nextRemoved == null);
            // assert(record._prevRemoved == null);
            if (this._changesHead === null) {
                this._changesHead = this._changesTail = record;
            } else {
                this._changesTail._nextChanged = record;
                this._changesTail = record;
            }
        };
        DefaultKeyValueDiffer.prototype.toString = function () {
            var items = [];
            var previous = [];
            var changes = [];
            var additions = [];
            var removals = [];
            var record;
            for (record = this._mapHead; record !== null; record = record._next) {
                items.push(lang_1.stringify(record));
            }
            for (record = this._previousMapHead; record !== null; record = record._nextPrevious) {
                previous.push(lang_1.stringify(record));
            }
            for (record = this._changesHead; record !== null; record = record._nextChanged) {
                changes.push(lang_1.stringify(record));
            }
            for (record = this._additionsHead; record !== null; record = record._nextAdded) {
                additions.push(lang_1.stringify(record));
            }
            for (record = this._removalsHead; record !== null; record = record._nextRemoved) {
                removals.push(lang_1.stringify(record));
            }
            return "map: " + items.join(', ') + "\n" + "previous: " + previous.join(', ') + "\n" + "additions: " + additions.join(', ') + "\n" + "changes: " + changes.join(', ') + "\n" + "removals: " + removals.join(', ') + "\n";
        };
        /** @internal */
        DefaultKeyValueDiffer.prototype._forEach = function (obj, fn) {
            if (obj instanceof Map) {
                obj.forEach(fn);
            } else {
                collection_1.StringMapWrapper.forEach(obj, fn);
            }
        };
        return DefaultKeyValueDiffer;
    }();
    exports.DefaultKeyValueDiffer = DefaultKeyValueDiffer;
    var KeyValueChangeRecord = function () {
        function KeyValueChangeRecord(key) {
            this.key = key;
            this.previousValue = null;
            this.currentValue = null;
            /** @internal */
            this._nextPrevious = null;
            /** @internal */
            this._next = null;
            /** @internal */
            this._nextAdded = null;
            /** @internal */
            this._nextRemoved = null;
            /** @internal */
            this._prevRemoved = null;
            /** @internal */
            this._nextChanged = null;
        }
        KeyValueChangeRecord.prototype.toString = function () {
            return lang_1.looseIdentical(this.previousValue, this.currentValue) ? lang_1.stringify(this.key) : lang_1.stringify(this.key) + '[' + lang_1.stringify(this.previousValue) + '->' + lang_1.stringify(this.currentValue) + ']';
        };
        return KeyValueChangeRecord;
    }();
    exports.KeyValueChangeRecord = KeyValueChangeRecord;
});
System.registerDynamic("angular2/src/core/change_detection/parser/lexer.js", ["angular2/src/core/di/decorators.js", "angular2/src/facade/collection.js", "angular2/src/facade/lang.js", "angular2/src/facade/exceptions.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var decorators_1 = $__require("angular2/src/core/di/decorators.js");
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var exceptions_1 = $__require("angular2/src/facade/exceptions.js");
    (function (TokenType) {
        TokenType[TokenType["Character"] = 0] = "Character";
        TokenType[TokenType["Identifier"] = 1] = "Identifier";
        TokenType[TokenType["Keyword"] = 2] = "Keyword";
        TokenType[TokenType["String"] = 3] = "String";
        TokenType[TokenType["Operator"] = 4] = "Operator";
        TokenType[TokenType["Number"] = 5] = "Number";
    })(exports.TokenType || (exports.TokenType = {}));
    var TokenType = exports.TokenType;
    var Lexer = function () {
        function Lexer() {}
        Lexer.prototype.tokenize = function (text) {
            var scanner = new _Scanner(text);
            var tokens = [];
            var token = scanner.scanToken();
            while (token != null) {
                tokens.push(token);
                token = scanner.scanToken();
            }
            return tokens;
        };
        Lexer = __decorate([decorators_1.Injectable(), __metadata('design:paramtypes', [])], Lexer);
        return Lexer;
    }();
    exports.Lexer = Lexer;
    var Token = function () {
        function Token(index, type, numValue, strValue) {
            this.index = index;
            this.type = type;
            this.numValue = numValue;
            this.strValue = strValue;
        }
        Token.prototype.isCharacter = function (code) {
            return this.type == TokenType.Character && this.numValue == code;
        };
        Token.prototype.isNumber = function () {
            return this.type == TokenType.Number;
        };
        Token.prototype.isString = function () {
            return this.type == TokenType.String;
        };
        Token.prototype.isOperator = function (operater) {
            return this.type == TokenType.Operator && this.strValue == operater;
        };
        Token.prototype.isIdentifier = function () {
            return this.type == TokenType.Identifier;
        };
        Token.prototype.isKeyword = function () {
            return this.type == TokenType.Keyword;
        };
        Token.prototype.isKeywordVar = function () {
            return this.type == TokenType.Keyword && this.strValue == "var";
        };
        Token.prototype.isKeywordNull = function () {
            return this.type == TokenType.Keyword && this.strValue == "null";
        };
        Token.prototype.isKeywordUndefined = function () {
            return this.type == TokenType.Keyword && this.strValue == "undefined";
        };
        Token.prototype.isKeywordTrue = function () {
            return this.type == TokenType.Keyword && this.strValue == "true";
        };
        Token.prototype.isKeywordFalse = function () {
            return this.type == TokenType.Keyword && this.strValue == "false";
        };
        Token.prototype.toNumber = function () {
            // -1 instead of NULL ok?
            return this.type == TokenType.Number ? this.numValue : -1;
        };
        Token.prototype.toString = function () {
            switch (this.type) {
                case TokenType.Character:
                case TokenType.Identifier:
                case TokenType.Keyword:
                case TokenType.Operator:
                case TokenType.String:
                    return this.strValue;
                case TokenType.Number:
                    return this.numValue.toString();
                default:
                    return null;
            }
        };
        return Token;
    }();
    exports.Token = Token;
    function newCharacterToken(index, code) {
        return new Token(index, TokenType.Character, code, lang_1.StringWrapper.fromCharCode(code));
    }
    function newIdentifierToken(index, text) {
        return new Token(index, TokenType.Identifier, 0, text);
    }
    function newKeywordToken(index, text) {
        return new Token(index, TokenType.Keyword, 0, text);
    }
    function newOperatorToken(index, text) {
        return new Token(index, TokenType.Operator, 0, text);
    }
    function newStringToken(index, text) {
        return new Token(index, TokenType.String, 0, text);
    }
    function newNumberToken(index, n) {
        return new Token(index, TokenType.Number, n, "");
    }
    exports.EOF = new Token(-1, TokenType.Character, 0, "");
    exports.$EOF = 0;
    exports.$TAB = 9;
    exports.$LF = 10;
    exports.$VTAB = 11;
    exports.$FF = 12;
    exports.$CR = 13;
    exports.$SPACE = 32;
    exports.$BANG = 33;
    exports.$DQ = 34;
    exports.$HASH = 35;
    exports.$$ = 36;
    exports.$PERCENT = 37;
    exports.$AMPERSAND = 38;
    exports.$SQ = 39;
    exports.$LPAREN = 40;
    exports.$RPAREN = 41;
    exports.$STAR = 42;
    exports.$PLUS = 43;
    exports.$COMMA = 44;
    exports.$MINUS = 45;
    exports.$PERIOD = 46;
    exports.$SLASH = 47;
    exports.$COLON = 58;
    exports.$SEMICOLON = 59;
    exports.$LT = 60;
    exports.$EQ = 61;
    exports.$GT = 62;
    exports.$QUESTION = 63;
    var $0 = 48;
    var $9 = 57;
    var $A = 65,
        $E = 69,
        $Z = 90;
    exports.$LBRACKET = 91;
    exports.$BACKSLASH = 92;
    exports.$RBRACKET = 93;
    var $CARET = 94;
    var $_ = 95;
    var $a = 97,
        $e = 101,
        $f = 102,
        $n = 110,
        $r = 114,
        $t = 116,
        $u = 117,
        $v = 118,
        $z = 122;
    exports.$LBRACE = 123;
    exports.$BAR = 124;
    exports.$RBRACE = 125;
    var $NBSP = 160;
    var ScannerError = function (_super) {
        __extends(ScannerError, _super);
        function ScannerError(message) {
            _super.call(this);
            this.message = message;
        }
        ScannerError.prototype.toString = function () {
            return this.message;
        };
        return ScannerError;
    }(exceptions_1.BaseException);
    exports.ScannerError = ScannerError;
    var _Scanner = function () {
        function _Scanner(input) {
            this.input = input;
            this.peek = 0;
            this.index = -1;
            this.length = input.length;
            this.advance();
        }
        _Scanner.prototype.advance = function () {
            this.peek = ++this.index >= this.length ? exports.$EOF : lang_1.StringWrapper.charCodeAt(this.input, this.index);
        };
        _Scanner.prototype.scanToken = function () {
            var input = this.input,
                length = this.length,
                peek = this.peek,
                index = this.index;
            // Skip whitespace.
            while (peek <= exports.$SPACE) {
                if (++index >= length) {
                    peek = exports.$EOF;
                    break;
                } else {
                    peek = lang_1.StringWrapper.charCodeAt(input, index);
                }
            }
            this.peek = peek;
            this.index = index;
            if (index >= length) {
                return null;
            }
            // Handle identifiers and numbers.
            if (isIdentifierStart(peek)) return this.scanIdentifier();
            if (isDigit(peek)) return this.scanNumber(index);
            var start = index;
            switch (peek) {
                case exports.$PERIOD:
                    this.advance();
                    return isDigit(this.peek) ? this.scanNumber(start) : newCharacterToken(start, exports.$PERIOD);
                case exports.$LPAREN:
                case exports.$RPAREN:
                case exports.$LBRACE:
                case exports.$RBRACE:
                case exports.$LBRACKET:
                case exports.$RBRACKET:
                case exports.$COMMA:
                case exports.$COLON:
                case exports.$SEMICOLON:
                    return this.scanCharacter(start, peek);
                case exports.$SQ:
                case exports.$DQ:
                    return this.scanString();
                case exports.$HASH:
                case exports.$PLUS:
                case exports.$MINUS:
                case exports.$STAR:
                case exports.$SLASH:
                case exports.$PERCENT:
                case $CARET:
                    return this.scanOperator(start, lang_1.StringWrapper.fromCharCode(peek));
                case exports.$QUESTION:
                    return this.scanComplexOperator(start, '?', exports.$PERIOD, '.');
                case exports.$LT:
                case exports.$GT:
                    return this.scanComplexOperator(start, lang_1.StringWrapper.fromCharCode(peek), exports.$EQ, '=');
                case exports.$BANG:
                case exports.$EQ:
                    return this.scanComplexOperator(start, lang_1.StringWrapper.fromCharCode(peek), exports.$EQ, '=', exports.$EQ, '=');
                case exports.$AMPERSAND:
                    return this.scanComplexOperator(start, '&', exports.$AMPERSAND, '&');
                case exports.$BAR:
                    return this.scanComplexOperator(start, '|', exports.$BAR, '|');
                case $NBSP:
                    while (isWhitespace(this.peek)) this.advance();
                    return this.scanToken();
            }
            this.error("Unexpected character [" + lang_1.StringWrapper.fromCharCode(peek) + "]", 0);
            return null;
        };
        _Scanner.prototype.scanCharacter = function (start, code) {
            this.advance();
            return newCharacterToken(start, code);
        };
        _Scanner.prototype.scanOperator = function (start, str) {
            this.advance();
            return newOperatorToken(start, str);
        };
        /**
         * Tokenize a 2/3 char long operator
         *
         * @param start start index in the expression
         * @param one first symbol (always part of the operator)
         * @param twoCode code point for the second symbol
         * @param two second symbol (part of the operator when the second code point matches)
         * @param threeCode code point for the third symbol
         * @param three third symbol (part of the operator when provided and matches source expression)
         * @returns {Token}
         */
        _Scanner.prototype.scanComplexOperator = function (start, one, twoCode, two, threeCode, three) {
            this.advance();
            var str = one;
            if (this.peek == twoCode) {
                this.advance();
                str += two;
            }
            if (lang_1.isPresent(threeCode) && this.peek == threeCode) {
                this.advance();
                str += three;
            }
            return newOperatorToken(start, str);
        };
        _Scanner.prototype.scanIdentifier = function () {
            var start = this.index;
            this.advance();
            while (isIdentifierPart(this.peek)) this.advance();
            var str = this.input.substring(start, this.index);
            if (collection_1.SetWrapper.has(KEYWORDS, str)) {
                return newKeywordToken(start, str);
            } else {
                return newIdentifierToken(start, str);
            }
        };
        _Scanner.prototype.scanNumber = function (start) {
            var simple = this.index === start;
            this.advance(); // Skip initial digit.
            while (true) {
                if (isDigit(this.peek)) {} else if (this.peek == exports.$PERIOD) {
                    simple = false;
                } else if (isExponentStart(this.peek)) {
                    this.advance();
                    if (isExponentSign(this.peek)) this.advance();
                    if (!isDigit(this.peek)) this.error('Invalid exponent', -1);
                    simple = false;
                } else {
                    break;
                }
                this.advance();
            }
            var str = this.input.substring(start, this.index);
            // TODO
            var value = simple ? lang_1.NumberWrapper.parseIntAutoRadix(str) : lang_1.NumberWrapper.parseFloat(str);
            return newNumberToken(start, value);
        };
        _Scanner.prototype.scanString = function () {
            var start = this.index;
            var quote = this.peek;
            this.advance(); // Skip initial quote.
            var buffer;
            var marker = this.index;
            var input = this.input;
            while (this.peek != quote) {
                if (this.peek == exports.$BACKSLASH) {
                    if (buffer == null) buffer = new lang_1.StringJoiner();
                    buffer.add(input.substring(marker, this.index));
                    this.advance();
                    var unescapedCode;
                    if (this.peek == $u) {
                        // 4 character hex code for unicode character.
                        var hex = input.substring(this.index + 1, this.index + 5);
                        try {
                            unescapedCode = lang_1.NumberWrapper.parseInt(hex, 16);
                        } catch (e) {
                            this.error("Invalid unicode escape [\\u" + hex + "]", 0);
                        }
                        for (var i = 0; i < 5; i++) {
                            this.advance();
                        }
                    } else {
                        unescapedCode = unescape(this.peek);
                        this.advance();
                    }
                    buffer.add(lang_1.StringWrapper.fromCharCode(unescapedCode));
                    marker = this.index;
                } else if (this.peek == exports.$EOF) {
                    this.error('Unterminated quote', 0);
                } else {
                    this.advance();
                }
            }
            var last = input.substring(marker, this.index);
            this.advance(); // Skip terminating quote.
            // Compute the unescaped string value.
            var unescaped = last;
            if (buffer != null) {
                buffer.add(last);
                unescaped = buffer.toString();
            }
            return newStringToken(start, unescaped);
        };
        _Scanner.prototype.error = function (message, offset) {
            var position = this.index + offset;
            throw new ScannerError("Lexer Error: " + message + " at column " + position + " in expression [" + this.input + "]");
        };
        return _Scanner;
    }();
    function isWhitespace(code) {
        return code >= exports.$TAB && code <= exports.$SPACE || code == $NBSP;
    }
    function isIdentifierStart(code) {
        return $a <= code && code <= $z || $A <= code && code <= $Z || code == $_ || code == exports.$$;
    }
    function isIdentifier(input) {
        if (input.length == 0) return false;
        var scanner = new _Scanner(input);
        if (!isIdentifierStart(scanner.peek)) return false;
        scanner.advance();
        while (scanner.peek !== exports.$EOF) {
            if (!isIdentifierPart(scanner.peek)) return false;
            scanner.advance();
        }
        return true;
    }
    exports.isIdentifier = isIdentifier;
    function isIdentifierPart(code) {
        return $a <= code && code <= $z || $A <= code && code <= $Z || $0 <= code && code <= $9 || code == $_ || code == exports.$$;
    }
    function isDigit(code) {
        return $0 <= code && code <= $9;
    }
    function isExponentStart(code) {
        return code == $e || code == $E;
    }
    function isExponentSign(code) {
        return code == exports.$MINUS || code == exports.$PLUS;
    }
    function unescape(code) {
        switch (code) {
            case $n:
                return exports.$LF;
            case $f:
                return exports.$FF;
            case $r:
                return exports.$CR;
            case $t:
                return exports.$TAB;
            case $v:
                return exports.$VTAB;
            default:
                return code;
        }
    }
    var OPERATORS = collection_1.SetWrapper.createFromList(['+', '-', '*', '/', '%', '^', '=', '==', '!=', '===', '!==', '<', '>', '<=', '>=', '&&', '||', '&', '|', '!', '?', '#', '?.']);
    var KEYWORDS = collection_1.SetWrapper.createFromList(['var', 'null', 'undefined', 'true', 'false', 'if', 'else']);
});
System.registerDynamic("angular2/src/core/change_detection/parser/parser.js", ["angular2/src/core/di/decorators.js", "angular2/src/facade/lang.js", "angular2/src/facade/exceptions.js", "angular2/src/facade/collection.js", "angular2/src/core/change_detection/parser/lexer.js", "angular2/src/core/reflection/reflection.js", "angular2/src/core/change_detection/parser/ast.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var decorators_1 = $__require("angular2/src/core/di/decorators.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var exceptions_1 = $__require("angular2/src/facade/exceptions.js");
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var lexer_1 = $__require("angular2/src/core/change_detection/parser/lexer.js");
    var reflection_1 = $__require("angular2/src/core/reflection/reflection.js");
    var ast_1 = $__require("angular2/src/core/change_detection/parser/ast.js");
    var _implicitReceiver = new ast_1.ImplicitReceiver();
    // TODO(tbosch): Cannot make this const/final right now because of the transpiler...
    var INTERPOLATION_REGEXP = /\{\{([\s\S]*?)\}\}/g;
    var ParseException = function (_super) {
        __extends(ParseException, _super);
        function ParseException(message, input, errLocation, ctxLocation) {
            _super.call(this, "Parser Error: " + message + " " + errLocation + " [" + input + "] in " + ctxLocation);
        }
        return ParseException;
    }(exceptions_1.BaseException);
    var SplitInterpolation = function () {
        function SplitInterpolation(strings, expressions) {
            this.strings = strings;
            this.expressions = expressions;
        }
        return SplitInterpolation;
    }();
    exports.SplitInterpolation = SplitInterpolation;
    var Parser = function () {
        function Parser( /** @internal */_lexer, providedReflector) {
            if (providedReflector === void 0) {
                providedReflector = null;
            }
            this._lexer = _lexer;
            this._reflector = lang_1.isPresent(providedReflector) ? providedReflector : reflection_1.reflector;
        }
        Parser.prototype.parseAction = function (input, location) {
            this._checkNoInterpolation(input, location);
            var tokens = this._lexer.tokenize(input);
            var ast = new _ParseAST(input, location, tokens, this._reflector, true).parseChain();
            return new ast_1.ASTWithSource(ast, input, location);
        };
        Parser.prototype.parseBinding = function (input, location) {
            var ast = this._parseBindingAst(input, location);
            return new ast_1.ASTWithSource(ast, input, location);
        };
        Parser.prototype.parseSimpleBinding = function (input, location) {
            var ast = this._parseBindingAst(input, location);
            if (!SimpleExpressionChecker.check(ast)) {
                throw new ParseException('Host binding expression can only contain field access and constants', input, location);
            }
            return new ast_1.ASTWithSource(ast, input, location);
        };
        Parser.prototype._parseBindingAst = function (input, location) {
            // Quotes expressions use 3rd-party expression language. We don't want to use
            // our lexer or parser for that, so we check for that ahead of time.
            var quote = this._parseQuote(input, location);
            if (lang_1.isPresent(quote)) {
                return quote;
            }
            this._checkNoInterpolation(input, location);
            var tokens = this._lexer.tokenize(input);
            return new _ParseAST(input, location, tokens, this._reflector, false).parseChain();
        };
        Parser.prototype._parseQuote = function (input, location) {
            if (lang_1.isBlank(input)) return null;
            var prefixSeparatorIndex = input.indexOf(':');
            if (prefixSeparatorIndex == -1) return null;
            var prefix = input.substring(0, prefixSeparatorIndex).trim();
            if (!lexer_1.isIdentifier(prefix)) return null;
            var uninterpretedExpression = input.substring(prefixSeparatorIndex + 1);
            return new ast_1.Quote(prefix, uninterpretedExpression, location);
        };
        Parser.prototype.parseTemplateBindings = function (input, location) {
            var tokens = this._lexer.tokenize(input);
            return new _ParseAST(input, location, tokens, this._reflector, false).parseTemplateBindings();
        };
        Parser.prototype.parseInterpolation = function (input, location) {
            var split = this.splitInterpolation(input, location);
            if (split == null) return null;
            var expressions = [];
            for (var i = 0; i < split.expressions.length; ++i) {
                var tokens = this._lexer.tokenize(split.expressions[i]);
                var ast = new _ParseAST(input, location, tokens, this._reflector, false).parseChain();
                expressions.push(ast);
            }
            return new ast_1.ASTWithSource(new ast_1.Interpolation(split.strings, expressions), input, location);
        };
        Parser.prototype.splitInterpolation = function (input, location) {
            var parts = lang_1.StringWrapper.split(input, INTERPOLATION_REGEXP);
            if (parts.length <= 1) {
                return null;
            }
            var strings = [];
            var expressions = [];
            for (var i = 0; i < parts.length; i++) {
                var part = parts[i];
                if (i % 2 === 0) {
                    // fixed string
                    strings.push(part);
                } else if (part.trim().length > 0) {
                    expressions.push(part);
                } else {
                    throw new ParseException('Blank expressions are not allowed in interpolated strings', input, "at column " + this._findInterpolationErrorColumn(parts, i) + " in", location);
                }
            }
            return new SplitInterpolation(strings, expressions);
        };
        Parser.prototype.wrapLiteralPrimitive = function (input, location) {
            return new ast_1.ASTWithSource(new ast_1.LiteralPrimitive(input), input, location);
        };
        Parser.prototype._checkNoInterpolation = function (input, location) {
            var parts = lang_1.StringWrapper.split(input, INTERPOLATION_REGEXP);
            if (parts.length > 1) {
                throw new ParseException('Got interpolation ({{}}) where expression was expected', input, "at column " + this._findInterpolationErrorColumn(parts, 1) + " in", location);
            }
        };
        Parser.prototype._findInterpolationErrorColumn = function (parts, partInErrIdx) {
            var errLocation = '';
            for (var j = 0; j < partInErrIdx; j++) {
                errLocation += j % 2 === 0 ? parts[j] : "{{" + parts[j] + "}}";
            }
            return errLocation.length;
        };
        Parser = __decorate([decorators_1.Injectable(), __metadata('design:paramtypes', [lexer_1.Lexer, reflection_1.Reflector])], Parser);
        return Parser;
    }();
    exports.Parser = Parser;
    var _ParseAST = function () {
        function _ParseAST(input, location, tokens, reflector, parseAction) {
            this.input = input;
            this.location = location;
            this.tokens = tokens;
            this.reflector = reflector;
            this.parseAction = parseAction;
            this.index = 0;
        }
        _ParseAST.prototype.peek = function (offset) {
            var i = this.index + offset;
            return i < this.tokens.length ? this.tokens[i] : lexer_1.EOF;
        };
        Object.defineProperty(_ParseAST.prototype, "next", {
            get: function () {
                return this.peek(0);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(_ParseAST.prototype, "inputIndex", {
            get: function () {
                return this.index < this.tokens.length ? this.next.index : this.input.length;
            },
            enumerable: true,
            configurable: true
        });
        _ParseAST.prototype.advance = function () {
            this.index++;
        };
        _ParseAST.prototype.optionalCharacter = function (code) {
            if (this.next.isCharacter(code)) {
                this.advance();
                return true;
            } else {
                return false;
            }
        };
        _ParseAST.prototype.optionalKeywordVar = function () {
            if (this.peekKeywordVar()) {
                this.advance();
                return true;
            } else {
                return false;
            }
        };
        _ParseAST.prototype.peekKeywordVar = function () {
            return this.next.isKeywordVar() || this.next.isOperator('#');
        };
        _ParseAST.prototype.expectCharacter = function (code) {
            if (this.optionalCharacter(code)) return;
            this.error("Missing expected " + lang_1.StringWrapper.fromCharCode(code));
        };
        _ParseAST.prototype.optionalOperator = function (op) {
            if (this.next.isOperator(op)) {
                this.advance();
                return true;
            } else {
                return false;
            }
        };
        _ParseAST.prototype.expectOperator = function (operator) {
            if (this.optionalOperator(operator)) return;
            this.error("Missing expected operator " + operator);
        };
        _ParseAST.prototype.expectIdentifierOrKeyword = function () {
            var n = this.next;
            if (!n.isIdentifier() && !n.isKeyword()) {
                this.error("Unexpected token " + n + ", expected identifier or keyword");
            }
            this.advance();
            return n.toString();
        };
        _ParseAST.prototype.expectIdentifierOrKeywordOrString = function () {
            var n = this.next;
            if (!n.isIdentifier() && !n.isKeyword() && !n.isString()) {
                this.error("Unexpected token " + n + ", expected identifier, keyword, or string");
            }
            this.advance();
            return n.toString();
        };
        _ParseAST.prototype.parseChain = function () {
            var exprs = [];
            while (this.index < this.tokens.length) {
                var expr = this.parsePipe();
                exprs.push(expr);
                if (this.optionalCharacter(lexer_1.$SEMICOLON)) {
                    if (!this.parseAction) {
                        this.error("Binding expression cannot contain chained expression");
                    }
                    while (this.optionalCharacter(lexer_1.$SEMICOLON)) {} // read all semicolons
                } else if (this.index < this.tokens.length) {
                    this.error("Unexpected token '" + this.next + "'");
                }
            }
            if (exprs.length == 0) return new ast_1.EmptyExpr();
            if (exprs.length == 1) return exprs[0];
            return new ast_1.Chain(exprs);
        };
        _ParseAST.prototype.parsePipe = function () {
            var result = this.parseExpression();
            if (this.optionalOperator("|")) {
                if (this.parseAction) {
                    this.error("Cannot have a pipe in an action expression");
                }
                do {
                    var name = this.expectIdentifierOrKeyword();
                    var args = [];
                    while (this.optionalCharacter(lexer_1.$COLON)) {
                        args.push(this.parseExpression());
                    }
                    result = new ast_1.BindingPipe(result, name, args);
                } while (this.optionalOperator("|"));
            }
            return result;
        };
        _ParseAST.prototype.parseExpression = function () {
            return this.parseConditional();
        };
        _ParseAST.prototype.parseConditional = function () {
            var start = this.inputIndex;
            var result = this.parseLogicalOr();
            if (this.optionalOperator('?')) {
                var yes = this.parsePipe();
                if (!this.optionalCharacter(lexer_1.$COLON)) {
                    var end = this.inputIndex;
                    var expression = this.input.substring(start, end);
                    this.error("Conditional expression " + expression + " requires all 3 expressions");
                }
                var no = this.parsePipe();
                return new ast_1.Conditional(result, yes, no);
            } else {
                return result;
            }
        };
        _ParseAST.prototype.parseLogicalOr = function () {
            // '||'
            var result = this.parseLogicalAnd();
            while (this.optionalOperator('||')) {
                result = new ast_1.Binary('||', result, this.parseLogicalAnd());
            }
            return result;
        };
        _ParseAST.prototype.parseLogicalAnd = function () {
            // '&&'
            var result = this.parseEquality();
            while (this.optionalOperator('&&')) {
                result = new ast_1.Binary('&&', result, this.parseEquality());
            }
            return result;
        };
        _ParseAST.prototype.parseEquality = function () {
            // '==','!=','===','!=='
            var result = this.parseRelational();
            while (true) {
                if (this.optionalOperator('==')) {
                    result = new ast_1.Binary('==', result, this.parseRelational());
                } else if (this.optionalOperator('===')) {
                    result = new ast_1.Binary('===', result, this.parseRelational());
                } else if (this.optionalOperator('!=')) {
                    result = new ast_1.Binary('!=', result, this.parseRelational());
                } else if (this.optionalOperator('!==')) {
                    result = new ast_1.Binary('!==', result, this.parseRelational());
                } else {
                    return result;
                }
            }
        };
        _ParseAST.prototype.parseRelational = function () {
            // '<', '>', '<=', '>='
            var result = this.parseAdditive();
            while (true) {
                if (this.optionalOperator('<')) {
                    result = new ast_1.Binary('<', result, this.parseAdditive());
                } else if (this.optionalOperator('>')) {
                    result = new ast_1.Binary('>', result, this.parseAdditive());
                } else if (this.optionalOperator('<=')) {
                    result = new ast_1.Binary('<=', result, this.parseAdditive());
                } else if (this.optionalOperator('>=')) {
                    result = new ast_1.Binary('>=', result, this.parseAdditive());
                } else {
                    return result;
                }
            }
        };
        _ParseAST.prototype.parseAdditive = function () {
            // '+', '-'
            var result = this.parseMultiplicative();
            while (true) {
                if (this.optionalOperator('+')) {
                    result = new ast_1.Binary('+', result, this.parseMultiplicative());
                } else if (this.optionalOperator('-')) {
                    result = new ast_1.Binary('-', result, this.parseMultiplicative());
                } else {
                    return result;
                }
            }
        };
        _ParseAST.prototype.parseMultiplicative = function () {
            // '*', '%', '/'
            var result = this.parsePrefix();
            while (true) {
                if (this.optionalOperator('*')) {
                    result = new ast_1.Binary('*', result, this.parsePrefix());
                } else if (this.optionalOperator('%')) {
                    result = new ast_1.Binary('%', result, this.parsePrefix());
                } else if (this.optionalOperator('/')) {
                    result = new ast_1.Binary('/', result, this.parsePrefix());
                } else {
                    return result;
                }
            }
        };
        _ParseAST.prototype.parsePrefix = function () {
            if (this.optionalOperator('+')) {
                return this.parsePrefix();
            } else if (this.optionalOperator('-')) {
                return new ast_1.Binary('-', new ast_1.LiteralPrimitive(0), this.parsePrefix());
            } else if (this.optionalOperator('!')) {
                return new ast_1.PrefixNot(this.parsePrefix());
            } else {
                return this.parseCallChain();
            }
        };
        _ParseAST.prototype.parseCallChain = function () {
            var result = this.parsePrimary();
            while (true) {
                if (this.optionalCharacter(lexer_1.$PERIOD)) {
                    result = this.parseAccessMemberOrMethodCall(result, false);
                } else if (this.optionalOperator('?.')) {
                    result = this.parseAccessMemberOrMethodCall(result, true);
                } else if (this.optionalCharacter(lexer_1.$LBRACKET)) {
                    var key = this.parsePipe();
                    this.expectCharacter(lexer_1.$RBRACKET);
                    if (this.optionalOperator("=")) {
                        var value = this.parseConditional();
                        result = new ast_1.KeyedWrite(result, key, value);
                    } else {
                        result = new ast_1.KeyedRead(result, key);
                    }
                } else if (this.optionalCharacter(lexer_1.$LPAREN)) {
                    var args = this.parseCallArguments();
                    this.expectCharacter(lexer_1.$RPAREN);
                    result = new ast_1.FunctionCall(result, args);
                } else {
                    return result;
                }
            }
        };
        _ParseAST.prototype.parsePrimary = function () {
            if (this.optionalCharacter(lexer_1.$LPAREN)) {
                var result = this.parsePipe();
                this.expectCharacter(lexer_1.$RPAREN);
                return result;
            } else if (this.next.isKeywordNull() || this.next.isKeywordUndefined()) {
                this.advance();
                return new ast_1.LiteralPrimitive(null);
            } else if (this.next.isKeywordTrue()) {
                this.advance();
                return new ast_1.LiteralPrimitive(true);
            } else if (this.next.isKeywordFalse()) {
                this.advance();
                return new ast_1.LiteralPrimitive(false);
            } else if (this.optionalCharacter(lexer_1.$LBRACKET)) {
                var elements = this.parseExpressionList(lexer_1.$RBRACKET);
                this.expectCharacter(lexer_1.$RBRACKET);
                return new ast_1.LiteralArray(elements);
            } else if (this.next.isCharacter(lexer_1.$LBRACE)) {
                return this.parseLiteralMap();
            } else if (this.next.isIdentifier()) {
                return this.parseAccessMemberOrMethodCall(_implicitReceiver, false);
            } else if (this.next.isNumber()) {
                var value = this.next.toNumber();
                this.advance();
                return new ast_1.LiteralPrimitive(value);
            } else if (this.next.isString()) {
                var literalValue = this.next.toString();
                this.advance();
                return new ast_1.LiteralPrimitive(literalValue);
            } else if (this.index >= this.tokens.length) {
                this.error("Unexpected end of expression: " + this.input);
            } else {
                this.error("Unexpected token " + this.next);
            }
            // error() throws, so we don't reach here.
            throw new exceptions_1.BaseException("Fell through all cases in parsePrimary");
        };
        _ParseAST.prototype.parseExpressionList = function (terminator) {
            var result = [];
            if (!this.next.isCharacter(terminator)) {
                do {
                    result.push(this.parsePipe());
                } while (this.optionalCharacter(lexer_1.$COMMA));
            }
            return result;
        };
        _ParseAST.prototype.parseLiteralMap = function () {
            var keys = [];
            var values = [];
            this.expectCharacter(lexer_1.$LBRACE);
            if (!this.optionalCharacter(lexer_1.$RBRACE)) {
                do {
                    var key = this.expectIdentifierOrKeywordOrString();
                    keys.push(key);
                    this.expectCharacter(lexer_1.$COLON);
                    values.push(this.parsePipe());
                } while (this.optionalCharacter(lexer_1.$COMMA));
                this.expectCharacter(lexer_1.$RBRACE);
            }
            return new ast_1.LiteralMap(keys, values);
        };
        _ParseAST.prototype.parseAccessMemberOrMethodCall = function (receiver, isSafe) {
            if (isSafe === void 0) {
                isSafe = false;
            }
            var id = this.expectIdentifierOrKeyword();
            if (this.optionalCharacter(lexer_1.$LPAREN)) {
                var args = this.parseCallArguments();
                this.expectCharacter(lexer_1.$RPAREN);
                var fn = this.reflector.method(id);
                return isSafe ? new ast_1.SafeMethodCall(receiver, id, fn, args) : new ast_1.MethodCall(receiver, id, fn, args);
            } else {
                if (isSafe) {
                    if (this.optionalOperator("=")) {
                        this.error("The '?.' operator cannot be used in the assignment");
                    } else {
                        return new ast_1.SafePropertyRead(receiver, id, this.reflector.getter(id));
                    }
                } else {
                    if (this.optionalOperator("=")) {
                        if (!this.parseAction) {
                            this.error("Bindings cannot contain assignments");
                        }
                        var value = this.parseConditional();
                        return new ast_1.PropertyWrite(receiver, id, this.reflector.setter(id), value);
                    } else {
                        return new ast_1.PropertyRead(receiver, id, this.reflector.getter(id));
                    }
                }
            }
            return null;
        };
        _ParseAST.prototype.parseCallArguments = function () {
            if (this.next.isCharacter(lexer_1.$RPAREN)) return [];
            var positionals = [];
            do {
                positionals.push(this.parsePipe());
            } while (this.optionalCharacter(lexer_1.$COMMA));
            return positionals;
        };
        _ParseAST.prototype.parseBlockContent = function () {
            if (!this.parseAction) {
                this.error("Binding expression cannot contain chained expression");
            }
            var exprs = [];
            while (this.index < this.tokens.length && !this.next.isCharacter(lexer_1.$RBRACE)) {
                var expr = this.parseExpression();
                exprs.push(expr);
                if (this.optionalCharacter(lexer_1.$SEMICOLON)) {
                    while (this.optionalCharacter(lexer_1.$SEMICOLON)) {} // read all semicolons
                }
            }
            if (exprs.length == 0) return new ast_1.EmptyExpr();
            if (exprs.length == 1) return exprs[0];
            return new ast_1.Chain(exprs);
        };
        /**
         * An identifier, a keyword, a string with an optional `-` inbetween.
         */
        _ParseAST.prototype.expectTemplateBindingKey = function () {
            var result = '';
            var operatorFound = false;
            do {
                result += this.expectIdentifierOrKeywordOrString();
                operatorFound = this.optionalOperator('-');
                if (operatorFound) {
                    result += '-';
                }
            } while (operatorFound);
            return result.toString();
        };
        _ParseAST.prototype.parseTemplateBindings = function () {
            var bindings = [];
            var prefix = null;
            while (this.index < this.tokens.length) {
                var keyIsVar = this.optionalKeywordVar();
                var key = this.expectTemplateBindingKey();
                if (!keyIsVar) {
                    if (prefix == null) {
                        prefix = key;
                    } else {
                        key = prefix + key[0].toUpperCase() + key.substring(1);
                    }
                }
                this.optionalCharacter(lexer_1.$COLON);
                var name = null;
                var expression = null;
                if (keyIsVar) {
                    if (this.optionalOperator("=")) {
                        name = this.expectTemplateBindingKey();
                    } else {
                        name = '\$implicit';
                    }
                } else if (this.next !== lexer_1.EOF && !this.peekKeywordVar()) {
                    var start = this.inputIndex;
                    var ast = this.parsePipe();
                    var source = this.input.substring(start, this.inputIndex);
                    expression = new ast_1.ASTWithSource(ast, source, this.location);
                }
                bindings.push(new ast_1.TemplateBinding(key, keyIsVar, name, expression));
                if (!this.optionalCharacter(lexer_1.$SEMICOLON)) {
                    this.optionalCharacter(lexer_1.$COMMA);
                }
            }
            return bindings;
        };
        _ParseAST.prototype.error = function (message, index) {
            if (index === void 0) {
                index = null;
            }
            if (lang_1.isBlank(index)) index = this.index;
            var location = index < this.tokens.length ? "at column " + (this.tokens[index].index + 1) + " in" : "at the end of the expression";
            throw new ParseException(message, this.input, location, this.location);
        };
        return _ParseAST;
    }();
    exports._ParseAST = _ParseAST;
    var SimpleExpressionChecker = function () {
        function SimpleExpressionChecker() {
            this.simple = true;
        }
        SimpleExpressionChecker.check = function (ast) {
            var s = new SimpleExpressionChecker();
            ast.visit(s);
            return s.simple;
        };
        SimpleExpressionChecker.prototype.visitImplicitReceiver = function (ast) {};
        SimpleExpressionChecker.prototype.visitInterpolation = function (ast) {
            this.simple = false;
        };
        SimpleExpressionChecker.prototype.visitLiteralPrimitive = function (ast) {};
        SimpleExpressionChecker.prototype.visitPropertyRead = function (ast) {};
        SimpleExpressionChecker.prototype.visitPropertyWrite = function (ast) {
            this.simple = false;
        };
        SimpleExpressionChecker.prototype.visitSafePropertyRead = function (ast) {
            this.simple = false;
        };
        SimpleExpressionChecker.prototype.visitMethodCall = function (ast) {
            this.simple = false;
        };
        SimpleExpressionChecker.prototype.visitSafeMethodCall = function (ast) {
            this.simple = false;
        };
        SimpleExpressionChecker.prototype.visitFunctionCall = function (ast) {
            this.simple = false;
        };
        SimpleExpressionChecker.prototype.visitLiteralArray = function (ast) {
            this.visitAll(ast.expressions);
        };
        SimpleExpressionChecker.prototype.visitLiteralMap = function (ast) {
            this.visitAll(ast.values);
        };
        SimpleExpressionChecker.prototype.visitBinary = function (ast) {
            this.simple = false;
        };
        SimpleExpressionChecker.prototype.visitPrefixNot = function (ast) {
            this.simple = false;
        };
        SimpleExpressionChecker.prototype.visitConditional = function (ast) {
            this.simple = false;
        };
        SimpleExpressionChecker.prototype.visitPipe = function (ast) {
            this.simple = false;
        };
        SimpleExpressionChecker.prototype.visitKeyedRead = function (ast) {
            this.simple = false;
        };
        SimpleExpressionChecker.prototype.visitKeyedWrite = function (ast) {
            this.simple = false;
        };
        SimpleExpressionChecker.prototype.visitAll = function (asts) {
            var res = collection_1.ListWrapper.createFixedSize(asts.length);
            for (var i = 0; i < asts.length; ++i) {
                res[i] = asts[i].visit(this);
            }
            return res;
        };
        SimpleExpressionChecker.prototype.visitChain = function (ast) {
            this.simple = false;
        };
        SimpleExpressionChecker.prototype.visitQuote = function (ast) {
            this.simple = false;
        };
        return SimpleExpressionChecker;
    }();
});
System.registerDynamic("angular2/src/core/change_detection/interfaces.js", [], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var DebugContext = function () {
        function DebugContext(element, componentElement, directive, context, locals, injector) {
            this.element = element;
            this.componentElement = componentElement;
            this.directive = directive;
            this.context = context;
            this.locals = locals;
            this.injector = injector;
        }
        return DebugContext;
    }();
    exports.DebugContext = DebugContext;
    var ChangeDetectorGenConfig = function () {
        function ChangeDetectorGenConfig(genDebugInfo, logBindingUpdate, useJit) {
            this.genDebugInfo = genDebugInfo;
            this.logBindingUpdate = logBindingUpdate;
            this.useJit = useJit;
        }
        return ChangeDetectorGenConfig;
    }();
    exports.ChangeDetectorGenConfig = ChangeDetectorGenConfig;
    var ChangeDetectorDefinition = function () {
        function ChangeDetectorDefinition(id, strategy, variableNames, bindingRecords, eventRecords, directiveRecords, genConfig) {
            this.id = id;
            this.strategy = strategy;
            this.variableNames = variableNames;
            this.bindingRecords = bindingRecords;
            this.eventRecords = eventRecords;
            this.directiveRecords = directiveRecords;
            this.genConfig = genConfig;
        }
        return ChangeDetectorDefinition;
    }();
    exports.ChangeDetectorDefinition = ChangeDetectorDefinition;
});
System.registerDynamic('angular2/src/core/change_detection/codegen_name_util.js', ['angular2/src/facade/lang.js', 'angular2/src/facade/collection.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var collection_1 = $__require('angular2/src/facade/collection.js');
    // The names of these fields must be kept in sync with abstract_change_detector.ts or change
    // detection will fail.
    var _STATE_ACCESSOR = "state";
    var _CONTEXT_ACCESSOR = "context";
    var _PROP_BINDING_INDEX = "propertyBindingIndex";
    var _DIRECTIVES_ACCESSOR = "directiveIndices";
    var _DISPATCHER_ACCESSOR = "dispatcher";
    var _LOCALS_ACCESSOR = "locals";
    var _MODE_ACCESSOR = "mode";
    var _PIPES_ACCESSOR = "pipes";
    var _PROTOS_ACCESSOR = "protos";
    exports.CONTEXT_ACCESSOR = "context";
    // `context` is always first.
    exports.CONTEXT_INDEX = 0;
    var _FIELD_PREFIX = 'this.';
    var _whiteSpaceRegExp = /\W/g;
    /**
     * Returns `s` with all non-identifier characters removed.
     */
    function sanitizeName(s) {
        return lang_1.StringWrapper.replaceAll(s, _whiteSpaceRegExp, '');
    }
    exports.sanitizeName = sanitizeName;
    /**
     * Class responsible for providing field and local variable names for change detector classes.
     * Also provides some convenience functions, for example, declaring variables, destroying pipes,
     * and dehydrating the detector.
     */
    var CodegenNameUtil = function () {
        function CodegenNameUtil(_records, _eventBindings, _directiveRecords, _utilName) {
            this._records = _records;
            this._eventBindings = _eventBindings;
            this._directiveRecords = _directiveRecords;
            this._utilName = _utilName;
            /** @internal */
            this._sanitizedEventNames = new collection_1.Map();
            this._sanitizedNames = collection_1.ListWrapper.createFixedSize(this._records.length + 1);
            this._sanitizedNames[exports.CONTEXT_INDEX] = exports.CONTEXT_ACCESSOR;
            for (var i = 0, iLen = this._records.length; i < iLen; ++i) {
                this._sanitizedNames[i + 1] = sanitizeName("" + this._records[i].name + i);
            }
            for (var ebIndex = 0; ebIndex < _eventBindings.length; ++ebIndex) {
                var eb = _eventBindings[ebIndex];
                var names = [exports.CONTEXT_ACCESSOR];
                for (var i = 0, iLen = eb.records.length; i < iLen; ++i) {
                    names.push(sanitizeName("" + eb.records[i].name + i + "_" + ebIndex));
                }
                this._sanitizedEventNames.set(eb, names);
            }
        }
        /** @internal */
        CodegenNameUtil.prototype._addFieldPrefix = function (name) {
            return "" + _FIELD_PREFIX + name;
        };
        CodegenNameUtil.prototype.getDispatcherName = function () {
            return this._addFieldPrefix(_DISPATCHER_ACCESSOR);
        };
        CodegenNameUtil.prototype.getPipesAccessorName = function () {
            return this._addFieldPrefix(_PIPES_ACCESSOR);
        };
        CodegenNameUtil.prototype.getProtosName = function () {
            return this._addFieldPrefix(_PROTOS_ACCESSOR);
        };
        CodegenNameUtil.prototype.getDirectivesAccessorName = function () {
            return this._addFieldPrefix(_DIRECTIVES_ACCESSOR);
        };
        CodegenNameUtil.prototype.getLocalsAccessorName = function () {
            return this._addFieldPrefix(_LOCALS_ACCESSOR);
        };
        CodegenNameUtil.prototype.getStateName = function () {
            return this._addFieldPrefix(_STATE_ACCESSOR);
        };
        CodegenNameUtil.prototype.getModeName = function () {
            return this._addFieldPrefix(_MODE_ACCESSOR);
        };
        CodegenNameUtil.prototype.getPropertyBindingIndex = function () {
            return this._addFieldPrefix(_PROP_BINDING_INDEX);
        };
        CodegenNameUtil.prototype.getLocalName = function (idx) {
            return "l_" + this._sanitizedNames[idx];
        };
        CodegenNameUtil.prototype.getEventLocalName = function (eb, idx) {
            return "l_" + this._sanitizedEventNames.get(eb)[idx];
        };
        CodegenNameUtil.prototype.getChangeName = function (idx) {
            return "c_" + this._sanitizedNames[idx];
        };
        /**
         * Generate a statement initializing local variables used when detecting changes.
         */
        CodegenNameUtil.prototype.genInitLocals = function () {
            var declarations = [];
            var assignments = [];
            for (var i = 0, iLen = this.getFieldCount(); i < iLen; ++i) {
                if (i == exports.CONTEXT_INDEX) {
                    declarations.push(this.getLocalName(i) + " = " + this.getFieldName(i));
                } else {
                    var rec = this._records[i - 1];
                    if (rec.argumentToPureFunction) {
                        var changeName = this.getChangeName(i);
                        declarations.push(this.getLocalName(i) + "," + changeName);
                        assignments.push(changeName);
                    } else {
                        declarations.push("" + this.getLocalName(i));
                    }
                }
            }
            var assignmentsCode = collection_1.ListWrapper.isEmpty(assignments) ? '' : assignments.join('=') + " = false;";
            return "var " + declarations.join(',') + ";" + assignmentsCode;
        };
        /**
         * Generate a statement initializing local variables for event handlers.
         */
        CodegenNameUtil.prototype.genInitEventLocals = function () {
            var _this = this;
            var res = [this.getLocalName(exports.CONTEXT_INDEX) + " = " + this.getFieldName(exports.CONTEXT_INDEX)];
            this._sanitizedEventNames.forEach(function (names, eb) {
                for (var i = 0; i < names.length; ++i) {
                    if (i !== exports.CONTEXT_INDEX) {
                        res.push("" + _this.getEventLocalName(eb, i));
                    }
                }
            });
            return res.length > 1 ? "var " + res.join(',') + ";" : '';
        };
        CodegenNameUtil.prototype.getPreventDefaultAccesor = function () {
            return "preventDefault";
        };
        CodegenNameUtil.prototype.getFieldCount = function () {
            return this._sanitizedNames.length;
        };
        CodegenNameUtil.prototype.getFieldName = function (idx) {
            return this._addFieldPrefix(this._sanitizedNames[idx]);
        };
        CodegenNameUtil.prototype.getAllFieldNames = function () {
            var fieldList = [];
            for (var k = 0, kLen = this.getFieldCount(); k < kLen; ++k) {
                if (k === 0 || this._records[k - 1].shouldBeChecked()) {
                    fieldList.push(this.getFieldName(k));
                }
            }
            for (var i = 0, iLen = this._records.length; i < iLen; ++i) {
                var rec = this._records[i];
                if (rec.isPipeRecord()) {
                    fieldList.push(this.getPipeName(rec.selfIndex));
                }
            }
            for (var j = 0, jLen = this._directiveRecords.length; j < jLen; ++j) {
                var dRec = this._directiveRecords[j];
                fieldList.push(this.getDirectiveName(dRec.directiveIndex));
                if (!dRec.isDefaultChangeDetection()) {
                    fieldList.push(this.getDetectorName(dRec.directiveIndex));
                }
            }
            return fieldList;
        };
        /**
         * Generates statements which clear all fields so that the change detector is dehydrated.
         */
        CodegenNameUtil.prototype.genDehydrateFields = function () {
            var fields = this.getAllFieldNames();
            collection_1.ListWrapper.removeAt(fields, exports.CONTEXT_INDEX);
            if (collection_1.ListWrapper.isEmpty(fields)) return '';
            // At least one assignment.
            fields.push(this._utilName + ".uninitialized;");
            return fields.join(' = ');
        };
        /**
         * Generates statements destroying all pipe variables.
         */
        CodegenNameUtil.prototype.genPipeOnDestroy = function () {
            var _this = this;
            return this._records.filter(function (r) {
                return r.isPipeRecord();
            }).map(function (r) {
                return _this._utilName + ".callPipeOnDestroy(" + _this.getPipeName(r.selfIndex) + ");";
            }).join('\n');
        };
        CodegenNameUtil.prototype.getPipeName = function (idx) {
            return this._addFieldPrefix(this._sanitizedNames[idx] + "_pipe");
        };
        CodegenNameUtil.prototype.getDirectiveName = function (d) {
            return this._addFieldPrefix("directive_" + d.name);
        };
        CodegenNameUtil.prototype.getDetectorName = function (d) {
            return this._addFieldPrefix("detector_" + d.name);
        };
        return CodegenNameUtil;
    }();
    exports.CodegenNameUtil = CodegenNameUtil;
});
System.registerDynamic('angular2/src/core/change_detection/codegen_logic_util.js', ['angular2/src/facade/lang.js', 'angular2/src/core/change_detection/codegen_facade.js', 'angular2/src/core/change_detection/proto_record.js', 'angular2/src/facade/exceptions.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var codegen_facade_1 = $__require('angular2/src/core/change_detection/codegen_facade.js');
    var proto_record_1 = $__require('angular2/src/core/change_detection/proto_record.js');
    var exceptions_1 = $__require('angular2/src/facade/exceptions.js');
    /**
     * Class responsible for providing change detection logic for change detector classes.
     */
    var CodegenLogicUtil = function () {
        function CodegenLogicUtil(_names, _utilName, _changeDetectorStateName) {
            this._names = _names;
            this._utilName = _utilName;
            this._changeDetectorStateName = _changeDetectorStateName;
        }
        /**
         * Generates a statement which updates the local variable representing `protoRec` with the current
         * value of the record. Used by property bindings.
         */
        CodegenLogicUtil.prototype.genPropertyBindingEvalValue = function (protoRec) {
            var _this = this;
            return this._genEvalValue(protoRec, function (idx) {
                return _this._names.getLocalName(idx);
            }, this._names.getLocalsAccessorName());
        };
        /**
         * Generates a statement which updates the local variable representing `protoRec` with the current
         * value of the record. Used by event bindings.
         */
        CodegenLogicUtil.prototype.genEventBindingEvalValue = function (eventRecord, protoRec) {
            var _this = this;
            return this._genEvalValue(protoRec, function (idx) {
                return _this._names.getEventLocalName(eventRecord, idx);
            }, "locals");
        };
        CodegenLogicUtil.prototype._genEvalValue = function (protoRec, getLocalName, localsAccessor) {
            var context = protoRec.contextIndex == -1 ? this._names.getDirectiveName(protoRec.directiveIndex) : getLocalName(protoRec.contextIndex);
            var argString = protoRec.args.map(function (arg) {
                return getLocalName(arg);
            }).join(", ");
            var rhs;
            switch (protoRec.mode) {
                case proto_record_1.RecordType.Self:
                    rhs = context;
                    break;
                case proto_record_1.RecordType.Const:
                    rhs = codegen_facade_1.codify(protoRec.funcOrValue);
                    break;
                case proto_record_1.RecordType.PropertyRead:
                    rhs = context + "." + protoRec.name;
                    break;
                case proto_record_1.RecordType.SafeProperty:
                    var read = context + "." + protoRec.name;
                    rhs = this._utilName + ".isValueBlank(" + context + ") ? null : " + read;
                    break;
                case proto_record_1.RecordType.PropertyWrite:
                    rhs = context + "." + protoRec.name + " = " + getLocalName(protoRec.args[0]);
                    break;
                case proto_record_1.RecordType.Local:
                    rhs = localsAccessor + ".get(" + codegen_facade_1.rawString(protoRec.name) + ")";
                    break;
                case proto_record_1.RecordType.InvokeMethod:
                    rhs = context + "." + protoRec.name + "(" + argString + ")";
                    break;
                case proto_record_1.RecordType.SafeMethodInvoke:
                    var invoke = context + "." + protoRec.name + "(" + argString + ")";
                    rhs = this._utilName + ".isValueBlank(" + context + ") ? null : " + invoke;
                    break;
                case proto_record_1.RecordType.InvokeClosure:
                    rhs = context + "(" + argString + ")";
                    break;
                case proto_record_1.RecordType.PrimitiveOp:
                    rhs = this._utilName + "." + protoRec.name + "(" + argString + ")";
                    break;
                case proto_record_1.RecordType.CollectionLiteral:
                    rhs = this._utilName + "." + protoRec.name + "(" + argString + ")";
                    break;
                case proto_record_1.RecordType.Interpolate:
                    rhs = this._genInterpolation(protoRec);
                    break;
                case proto_record_1.RecordType.KeyedRead:
                    rhs = context + "[" + getLocalName(protoRec.args[0]) + "]";
                    break;
                case proto_record_1.RecordType.KeyedWrite:
                    rhs = context + "[" + getLocalName(protoRec.args[0]) + "] = " + getLocalName(protoRec.args[1]);
                    break;
                case proto_record_1.RecordType.Chain:
                    rhs = "" + getLocalName(protoRec.args[protoRec.args.length - 1]);
                    break;
                default:
                    throw new exceptions_1.BaseException("Unknown operation " + protoRec.mode);
            }
            return getLocalName(protoRec.selfIndex) + " = " + rhs + ";";
        };
        CodegenLogicUtil.prototype.genPropertyBindingTargets = function (propertyBindingTargets, genDebugInfo) {
            var _this = this;
            var bs = propertyBindingTargets.map(function (b) {
                if (lang_1.isBlank(b)) return "null";
                var debug = genDebugInfo ? codegen_facade_1.codify(b.debug) : "null";
                return _this._utilName + ".bindingTarget(" + codegen_facade_1.codify(b.mode) + ", " + b.elementIndex + ", " + codegen_facade_1.codify(b.name) + ", " + codegen_facade_1.codify(b.unit) + ", " + debug + ")";
            });
            return "[" + bs.join(", ") + "]";
        };
        CodegenLogicUtil.prototype.genDirectiveIndices = function (directiveRecords) {
            var _this = this;
            var bs = directiveRecords.map(function (b) {
                return _this._utilName + ".directiveIndex(" + b.directiveIndex.elementIndex + ", " + b.directiveIndex.directiveIndex + ")";
            });
            return "[" + bs.join(", ") + "]";
        };
        /** @internal */
        CodegenLogicUtil.prototype._genInterpolation = function (protoRec) {
            var iVals = [];
            for (var i = 0; i < protoRec.args.length; ++i) {
                iVals.push(codegen_facade_1.codify(protoRec.fixedArgs[i]));
                iVals.push(this._utilName + ".s(" + this._names.getLocalName(protoRec.args[i]) + ")");
            }
            iVals.push(codegen_facade_1.codify(protoRec.fixedArgs[protoRec.args.length]));
            return codegen_facade_1.combineGeneratedStrings(iVals);
        };
        CodegenLogicUtil.prototype.genHydrateDirectives = function (directiveRecords) {
            var _this = this;
            var res = [];
            var outputCount = 0;
            for (var i = 0; i < directiveRecords.length; ++i) {
                var r = directiveRecords[i];
                var dirVarName = this._names.getDirectiveName(r.directiveIndex);
                res.push(dirVarName + " = " + this._genReadDirective(i) + ";");
                if (lang_1.isPresent(r.outputs)) {
                    r.outputs.forEach(function (output) {
                        var eventHandlerExpr = _this._genEventHandler(r.directiveIndex.elementIndex, output[1]);
                        var statementStart = "this.outputSubscriptions[" + outputCount++ + "] = " + dirVarName + "." + output[0];
                        if (lang_1.IS_DART) {
                            res.push(statementStart + ".listen(" + eventHandlerExpr + ");");
                        } else {
                            res.push(statementStart + ".subscribe({next: " + eventHandlerExpr + "});");
                        }
                    });
                }
            }
            if (outputCount > 0) {
                var statementStart = 'this.outputSubscriptions';
                if (lang_1.IS_DART) {
                    res.unshift(statementStart + " = new List(" + outputCount + ");");
                } else {
                    res.unshift(statementStart + " = new Array(" + outputCount + ");");
                }
            }
            return res.join("\n");
        };
        CodegenLogicUtil.prototype.genDirectivesOnDestroy = function (directiveRecords) {
            var res = [];
            for (var i = 0; i < directiveRecords.length; ++i) {
                var r = directiveRecords[i];
                if (r.callOnDestroy) {
                    var dirVarName = this._names.getDirectiveName(r.directiveIndex);
                    res.push(dirVarName + ".ngOnDestroy();");
                }
            }
            return res.join("\n");
        };
        CodegenLogicUtil.prototype._genEventHandler = function (boundElementIndex, eventName) {
            if (lang_1.IS_DART) {
                return "(event) => this.handleEvent('" + eventName + "', " + boundElementIndex + ", event)";
            } else {
                return "(function(event) { return this.handleEvent('" + eventName + "', " + boundElementIndex + ", event); }).bind(this)";
            }
        };
        CodegenLogicUtil.prototype._genReadDirective = function (index) {
            return "this.getDirectiveFor(directives, " + index + ")";
        };
        CodegenLogicUtil.prototype.genHydrateDetectors = function (directiveRecords) {
            var res = [];
            for (var i = 0; i < directiveRecords.length; ++i) {
                var r = directiveRecords[i];
                if (!r.isDefaultChangeDetection()) {
                    res.push(this._names.getDetectorName(r.directiveIndex) + " = this.getDetectorFor(directives, " + i + ");");
                }
            }
            return res.join("\n");
        };
        CodegenLogicUtil.prototype.genContentLifecycleCallbacks = function (directiveRecords) {
            var res = [];
            var eq = lang_1.IS_DART ? '==' : '===';
            // NOTE(kegluneq): Order is important!
            for (var i = directiveRecords.length - 1; i >= 0; --i) {
                var dir = directiveRecords[i];
                if (dir.callAfterContentInit) {
                    res.push("if(" + this._names.getStateName() + " " + eq + " " + this._changeDetectorStateName + ".NeverChecked) " + this._names.getDirectiveName(dir.directiveIndex) + ".ngAfterContentInit();");
                }
                if (dir.callAfterContentChecked) {
                    res.push(this._names.getDirectiveName(dir.directiveIndex) + ".ngAfterContentChecked();");
                }
            }
            return res;
        };
        CodegenLogicUtil.prototype.genViewLifecycleCallbacks = function (directiveRecords) {
            var res = [];
            var eq = lang_1.IS_DART ? '==' : '===';
            // NOTE(kegluneq): Order is important!
            for (var i = directiveRecords.length - 1; i >= 0; --i) {
                var dir = directiveRecords[i];
                if (dir.callAfterViewInit) {
                    res.push("if(" + this._names.getStateName() + " " + eq + " " + this._changeDetectorStateName + ".NeverChecked) " + this._names.getDirectiveName(dir.directiveIndex) + ".ngAfterViewInit();");
                }
                if (dir.callAfterViewChecked) {
                    res.push(this._names.getDirectiveName(dir.directiveIndex) + ".ngAfterViewChecked();");
                }
            }
            return res;
        };
        return CodegenLogicUtil;
    }();
    exports.CodegenLogicUtil = CodegenLogicUtil;
});
System.registerDynamic("angular2/src/core/change_detection/codegen_facade.js", [], true, function ($__require, exports, module) {
    'use strict';"use strict";
    /**
     * Converts `funcOrValue` to a string which can be used in generated code.
     */

    var global = this || self,
        GLOBAL = global;
    function codify(obj) {
        return JSON.stringify(obj);
    }
    exports.codify = codify;
    function rawString(str) {
        return "'" + str + "'";
    }
    exports.rawString = rawString;
    /**
     * Combine the strings of generated code into a single interpolated string.
     * Each element of `vals` is expected to be a string literal or a codegen'd
     * call to a method returning a string.
     */
    function combineGeneratedStrings(vals) {
        return vals.join(' + ');
    }
    exports.combineGeneratedStrings = combineGeneratedStrings;
});
System.registerDynamic("angular2/src/core/change_detection/parser/ast.js", ["angular2/src/facade/collection.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var AST = function () {
        function AST() {}
        AST.prototype.visit = function (visitor) {
            return null;
        };
        AST.prototype.toString = function () {
            return "AST";
        };
        return AST;
    }();
    exports.AST = AST;
    /**
     * Represents a quoted expression of the form:
     *
     * quote = prefix `:` uninterpretedExpression
     * prefix = identifier
     * uninterpretedExpression = arbitrary string
     *
     * A quoted expression is meant to be pre-processed by an AST transformer that
     * converts it into another AST that no longer contains quoted expressions.
     * It is meant to allow third-party developers to extend Angular template
     * expression language. The `uninterpretedExpression` part of the quote is
     * therefore not interpreted by the Angular's own expression parser.
     */
    var Quote = function (_super) {
        __extends(Quote, _super);
        function Quote(prefix, uninterpretedExpression, location) {
            _super.call(this);
            this.prefix = prefix;
            this.uninterpretedExpression = uninterpretedExpression;
            this.location = location;
        }
        Quote.prototype.visit = function (visitor) {
            return visitor.visitQuote(this);
        };
        Quote.prototype.toString = function () {
            return "Quote";
        };
        return Quote;
    }(AST);
    exports.Quote = Quote;
    var EmptyExpr = function (_super) {
        __extends(EmptyExpr, _super);
        function EmptyExpr() {
            _super.apply(this, arguments);
        }
        EmptyExpr.prototype.visit = function (visitor) {
            // do nothing
        };
        return EmptyExpr;
    }(AST);
    exports.EmptyExpr = EmptyExpr;
    var ImplicitReceiver = function (_super) {
        __extends(ImplicitReceiver, _super);
        function ImplicitReceiver() {
            _super.apply(this, arguments);
        }
        ImplicitReceiver.prototype.visit = function (visitor) {
            return visitor.visitImplicitReceiver(this);
        };
        return ImplicitReceiver;
    }(AST);
    exports.ImplicitReceiver = ImplicitReceiver;
    /**
     * Multiple expressions separated by a semicolon.
     */
    var Chain = function (_super) {
        __extends(Chain, _super);
        function Chain(expressions) {
            _super.call(this);
            this.expressions = expressions;
        }
        Chain.prototype.visit = function (visitor) {
            return visitor.visitChain(this);
        };
        return Chain;
    }(AST);
    exports.Chain = Chain;
    var Conditional = function (_super) {
        __extends(Conditional, _super);
        function Conditional(condition, trueExp, falseExp) {
            _super.call(this);
            this.condition = condition;
            this.trueExp = trueExp;
            this.falseExp = falseExp;
        }
        Conditional.prototype.visit = function (visitor) {
            return visitor.visitConditional(this);
        };
        return Conditional;
    }(AST);
    exports.Conditional = Conditional;
    var PropertyRead = function (_super) {
        __extends(PropertyRead, _super);
        function PropertyRead(receiver, name, getter) {
            _super.call(this);
            this.receiver = receiver;
            this.name = name;
            this.getter = getter;
        }
        PropertyRead.prototype.visit = function (visitor) {
            return visitor.visitPropertyRead(this);
        };
        return PropertyRead;
    }(AST);
    exports.PropertyRead = PropertyRead;
    var PropertyWrite = function (_super) {
        __extends(PropertyWrite, _super);
        function PropertyWrite(receiver, name, setter, value) {
            _super.call(this);
            this.receiver = receiver;
            this.name = name;
            this.setter = setter;
            this.value = value;
        }
        PropertyWrite.prototype.visit = function (visitor) {
            return visitor.visitPropertyWrite(this);
        };
        return PropertyWrite;
    }(AST);
    exports.PropertyWrite = PropertyWrite;
    var SafePropertyRead = function (_super) {
        __extends(SafePropertyRead, _super);
        function SafePropertyRead(receiver, name, getter) {
            _super.call(this);
            this.receiver = receiver;
            this.name = name;
            this.getter = getter;
        }
        SafePropertyRead.prototype.visit = function (visitor) {
            return visitor.visitSafePropertyRead(this);
        };
        return SafePropertyRead;
    }(AST);
    exports.SafePropertyRead = SafePropertyRead;
    var KeyedRead = function (_super) {
        __extends(KeyedRead, _super);
        function KeyedRead(obj, key) {
            _super.call(this);
            this.obj = obj;
            this.key = key;
        }
        KeyedRead.prototype.visit = function (visitor) {
            return visitor.visitKeyedRead(this);
        };
        return KeyedRead;
    }(AST);
    exports.KeyedRead = KeyedRead;
    var KeyedWrite = function (_super) {
        __extends(KeyedWrite, _super);
        function KeyedWrite(obj, key, value) {
            _super.call(this);
            this.obj = obj;
            this.key = key;
            this.value = value;
        }
        KeyedWrite.prototype.visit = function (visitor) {
            return visitor.visitKeyedWrite(this);
        };
        return KeyedWrite;
    }(AST);
    exports.KeyedWrite = KeyedWrite;
    var BindingPipe = function (_super) {
        __extends(BindingPipe, _super);
        function BindingPipe(exp, name, args) {
            _super.call(this);
            this.exp = exp;
            this.name = name;
            this.args = args;
        }
        BindingPipe.prototype.visit = function (visitor) {
            return visitor.visitPipe(this);
        };
        return BindingPipe;
    }(AST);
    exports.BindingPipe = BindingPipe;
    var LiteralPrimitive = function (_super) {
        __extends(LiteralPrimitive, _super);
        function LiteralPrimitive(value) {
            _super.call(this);
            this.value = value;
        }
        LiteralPrimitive.prototype.visit = function (visitor) {
            return visitor.visitLiteralPrimitive(this);
        };
        return LiteralPrimitive;
    }(AST);
    exports.LiteralPrimitive = LiteralPrimitive;
    var LiteralArray = function (_super) {
        __extends(LiteralArray, _super);
        function LiteralArray(expressions) {
            _super.call(this);
            this.expressions = expressions;
        }
        LiteralArray.prototype.visit = function (visitor) {
            return visitor.visitLiteralArray(this);
        };
        return LiteralArray;
    }(AST);
    exports.LiteralArray = LiteralArray;
    var LiteralMap = function (_super) {
        __extends(LiteralMap, _super);
        function LiteralMap(keys, values) {
            _super.call(this);
            this.keys = keys;
            this.values = values;
        }
        LiteralMap.prototype.visit = function (visitor) {
            return visitor.visitLiteralMap(this);
        };
        return LiteralMap;
    }(AST);
    exports.LiteralMap = LiteralMap;
    var Interpolation = function (_super) {
        __extends(Interpolation, _super);
        function Interpolation(strings, expressions) {
            _super.call(this);
            this.strings = strings;
            this.expressions = expressions;
        }
        Interpolation.prototype.visit = function (visitor) {
            return visitor.visitInterpolation(this);
        };
        return Interpolation;
    }(AST);
    exports.Interpolation = Interpolation;
    var Binary = function (_super) {
        __extends(Binary, _super);
        function Binary(operation, left, right) {
            _super.call(this);
            this.operation = operation;
            this.left = left;
            this.right = right;
        }
        Binary.prototype.visit = function (visitor) {
            return visitor.visitBinary(this);
        };
        return Binary;
    }(AST);
    exports.Binary = Binary;
    var PrefixNot = function (_super) {
        __extends(PrefixNot, _super);
        function PrefixNot(expression) {
            _super.call(this);
            this.expression = expression;
        }
        PrefixNot.prototype.visit = function (visitor) {
            return visitor.visitPrefixNot(this);
        };
        return PrefixNot;
    }(AST);
    exports.PrefixNot = PrefixNot;
    var MethodCall = function (_super) {
        __extends(MethodCall, _super);
        function MethodCall(receiver, name, fn, args) {
            _super.call(this);
            this.receiver = receiver;
            this.name = name;
            this.fn = fn;
            this.args = args;
        }
        MethodCall.prototype.visit = function (visitor) {
            return visitor.visitMethodCall(this);
        };
        return MethodCall;
    }(AST);
    exports.MethodCall = MethodCall;
    var SafeMethodCall = function (_super) {
        __extends(SafeMethodCall, _super);
        function SafeMethodCall(receiver, name, fn, args) {
            _super.call(this);
            this.receiver = receiver;
            this.name = name;
            this.fn = fn;
            this.args = args;
        }
        SafeMethodCall.prototype.visit = function (visitor) {
            return visitor.visitSafeMethodCall(this);
        };
        return SafeMethodCall;
    }(AST);
    exports.SafeMethodCall = SafeMethodCall;
    var FunctionCall = function (_super) {
        __extends(FunctionCall, _super);
        function FunctionCall(target, args) {
            _super.call(this);
            this.target = target;
            this.args = args;
        }
        FunctionCall.prototype.visit = function (visitor) {
            return visitor.visitFunctionCall(this);
        };
        return FunctionCall;
    }(AST);
    exports.FunctionCall = FunctionCall;
    var ASTWithSource = function (_super) {
        __extends(ASTWithSource, _super);
        function ASTWithSource(ast, source, location) {
            _super.call(this);
            this.ast = ast;
            this.source = source;
            this.location = location;
        }
        ASTWithSource.prototype.visit = function (visitor) {
            return this.ast.visit(visitor);
        };
        ASTWithSource.prototype.toString = function () {
            return this.source + " in " + this.location;
        };
        return ASTWithSource;
    }(AST);
    exports.ASTWithSource = ASTWithSource;
    var TemplateBinding = function () {
        function TemplateBinding(key, keyIsVar, name, expression) {
            this.key = key;
            this.keyIsVar = keyIsVar;
            this.name = name;
            this.expression = expression;
        }
        return TemplateBinding;
    }();
    exports.TemplateBinding = TemplateBinding;
    var RecursiveAstVisitor = function () {
        function RecursiveAstVisitor() {}
        RecursiveAstVisitor.prototype.visitBinary = function (ast) {
            ast.left.visit(this);
            ast.right.visit(this);
            return null;
        };
        RecursiveAstVisitor.prototype.visitChain = function (ast) {
            return this.visitAll(ast.expressions);
        };
        RecursiveAstVisitor.prototype.visitConditional = function (ast) {
            ast.condition.visit(this);
            ast.trueExp.visit(this);
            ast.falseExp.visit(this);
            return null;
        };
        RecursiveAstVisitor.prototype.visitPipe = function (ast) {
            ast.exp.visit(this);
            this.visitAll(ast.args);
            return null;
        };
        RecursiveAstVisitor.prototype.visitFunctionCall = function (ast) {
            ast.target.visit(this);
            this.visitAll(ast.args);
            return null;
        };
        RecursiveAstVisitor.prototype.visitImplicitReceiver = function (ast) {
            return null;
        };
        RecursiveAstVisitor.prototype.visitInterpolation = function (ast) {
            return this.visitAll(ast.expressions);
        };
        RecursiveAstVisitor.prototype.visitKeyedRead = function (ast) {
            ast.obj.visit(this);
            ast.key.visit(this);
            return null;
        };
        RecursiveAstVisitor.prototype.visitKeyedWrite = function (ast) {
            ast.obj.visit(this);
            ast.key.visit(this);
            ast.value.visit(this);
            return null;
        };
        RecursiveAstVisitor.prototype.visitLiteralArray = function (ast) {
            return this.visitAll(ast.expressions);
        };
        RecursiveAstVisitor.prototype.visitLiteralMap = function (ast) {
            return this.visitAll(ast.values);
        };
        RecursiveAstVisitor.prototype.visitLiteralPrimitive = function (ast) {
            return null;
        };
        RecursiveAstVisitor.prototype.visitMethodCall = function (ast) {
            ast.receiver.visit(this);
            return this.visitAll(ast.args);
        };
        RecursiveAstVisitor.prototype.visitPrefixNot = function (ast) {
            ast.expression.visit(this);
            return null;
        };
        RecursiveAstVisitor.prototype.visitPropertyRead = function (ast) {
            ast.receiver.visit(this);
            return null;
        };
        RecursiveAstVisitor.prototype.visitPropertyWrite = function (ast) {
            ast.receiver.visit(this);
            ast.value.visit(this);
            return null;
        };
        RecursiveAstVisitor.prototype.visitSafePropertyRead = function (ast) {
            ast.receiver.visit(this);
            return null;
        };
        RecursiveAstVisitor.prototype.visitSafeMethodCall = function (ast) {
            ast.receiver.visit(this);
            return this.visitAll(ast.args);
        };
        RecursiveAstVisitor.prototype.visitAll = function (asts) {
            var _this = this;
            asts.forEach(function (ast) {
                return ast.visit(_this);
            });
            return null;
        };
        RecursiveAstVisitor.prototype.visitQuote = function (ast) {
            return null;
        };
        return RecursiveAstVisitor;
    }();
    exports.RecursiveAstVisitor = RecursiveAstVisitor;
    var AstTransformer = function () {
        function AstTransformer() {}
        AstTransformer.prototype.visitImplicitReceiver = function (ast) {
            return ast;
        };
        AstTransformer.prototype.visitInterpolation = function (ast) {
            return new Interpolation(ast.strings, this.visitAll(ast.expressions));
        };
        AstTransformer.prototype.visitLiteralPrimitive = function (ast) {
            return new LiteralPrimitive(ast.value);
        };
        AstTransformer.prototype.visitPropertyRead = function (ast) {
            return new PropertyRead(ast.receiver.visit(this), ast.name, ast.getter);
        };
        AstTransformer.prototype.visitPropertyWrite = function (ast) {
            return new PropertyWrite(ast.receiver.visit(this), ast.name, ast.setter, ast.value);
        };
        AstTransformer.prototype.visitSafePropertyRead = function (ast) {
            return new SafePropertyRead(ast.receiver.visit(this), ast.name, ast.getter);
        };
        AstTransformer.prototype.visitMethodCall = function (ast) {
            return new MethodCall(ast.receiver.visit(this), ast.name, ast.fn, this.visitAll(ast.args));
        };
        AstTransformer.prototype.visitSafeMethodCall = function (ast) {
            return new SafeMethodCall(ast.receiver.visit(this), ast.name, ast.fn, this.visitAll(ast.args));
        };
        AstTransformer.prototype.visitFunctionCall = function (ast) {
            return new FunctionCall(ast.target.visit(this), this.visitAll(ast.args));
        };
        AstTransformer.prototype.visitLiteralArray = function (ast) {
            return new LiteralArray(this.visitAll(ast.expressions));
        };
        AstTransformer.prototype.visitLiteralMap = function (ast) {
            return new LiteralMap(ast.keys, this.visitAll(ast.values));
        };
        AstTransformer.prototype.visitBinary = function (ast) {
            return new Binary(ast.operation, ast.left.visit(this), ast.right.visit(this));
        };
        AstTransformer.prototype.visitPrefixNot = function (ast) {
            return new PrefixNot(ast.expression.visit(this));
        };
        AstTransformer.prototype.visitConditional = function (ast) {
            return new Conditional(ast.condition.visit(this), ast.trueExp.visit(this), ast.falseExp.visit(this));
        };
        AstTransformer.prototype.visitPipe = function (ast) {
            return new BindingPipe(ast.exp.visit(this), ast.name, this.visitAll(ast.args));
        };
        AstTransformer.prototype.visitKeyedRead = function (ast) {
            return new KeyedRead(ast.obj.visit(this), ast.key.visit(this));
        };
        AstTransformer.prototype.visitKeyedWrite = function (ast) {
            return new KeyedWrite(ast.obj.visit(this), ast.key.visit(this), ast.value.visit(this));
        };
        AstTransformer.prototype.visitAll = function (asts) {
            var res = collection_1.ListWrapper.createFixedSize(asts.length);
            for (var i = 0; i < asts.length; ++i) {
                res[i] = asts[i].visit(this);
            }
            return res;
        };
        AstTransformer.prototype.visitChain = function (ast) {
            return new Chain(this.visitAll(ast.expressions));
        };
        AstTransformer.prototype.visitQuote = function (ast) {
            return new Quote(ast.prefix, ast.uninterpretedExpression, ast.location);
        };
        return AstTransformer;
    }();
    exports.AstTransformer = AstTransformer;
});
System.registerDynamic("angular2/src/core/change_detection/event_binding.js", [], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var EventBinding = function () {
        function EventBinding(eventName, elIndex, dirIndex, records) {
            this.eventName = eventName;
            this.elIndex = elIndex;
            this.dirIndex = dirIndex;
            this.records = records;
        }
        return EventBinding;
    }();
    exports.EventBinding = EventBinding;
});
System.registerDynamic('angular2/src/core/change_detection/coalesce.js', ['angular2/src/facade/lang.js', 'angular2/src/facade/collection.js', 'angular2/src/core/change_detection/proto_record.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var collection_1 = $__require('angular2/src/facade/collection.js');
    var proto_record_1 = $__require('angular2/src/core/change_detection/proto_record.js');
    /**
     * Removes "duplicate" records. It assumes that record evaluation does not have side-effects.
     *
     * Records that are not last in bindings are removed and all the indices of the records that depend
     * on them are updated.
     *
     * Records that are last in bindings CANNOT be removed, and instead are replaced with very cheap
     * SELF records.
     *
     * @internal
     */
    function coalesce(srcRecords) {
        var dstRecords = [];
        var excludedIdxs = [];
        var indexMap = new collection_1.Map();
        var skipDepth = 0;
        var skipSources = collection_1.ListWrapper.createFixedSize(srcRecords.length);
        for (var protoIndex = 0; protoIndex < srcRecords.length; protoIndex++) {
            var skipRecord = skipSources[protoIndex];
            if (lang_1.isPresent(skipRecord)) {
                skipDepth--;
                skipRecord.fixedArgs[0] = dstRecords.length;
            }
            var src = srcRecords[protoIndex];
            var dst = _cloneAndUpdateIndexes(src, dstRecords, indexMap);
            if (dst.isSkipRecord()) {
                dstRecords.push(dst);
                skipDepth++;
                skipSources[dst.fixedArgs[0]] = dst;
            } else {
                var record = _mayBeAddRecord(dst, dstRecords, excludedIdxs, skipDepth > 0);
                indexMap.set(src.selfIndex, record.selfIndex);
            }
        }
        return _optimizeSkips(dstRecords);
    }
    exports.coalesce = coalesce;
    /**
     * - Conditional skip of 1 record followed by an unconditional skip of N are replaced by  a
     *   conditional skip of N with the negated condition,
     * - Skips of 0 records are removed
     */
    function _optimizeSkips(srcRecords) {
        var dstRecords = [];
        var skipSources = collection_1.ListWrapper.createFixedSize(srcRecords.length);
        var indexMap = new collection_1.Map();
        for (var protoIndex = 0; protoIndex < srcRecords.length; protoIndex++) {
            var skipRecord = skipSources[protoIndex];
            if (lang_1.isPresent(skipRecord)) {
                skipRecord.fixedArgs[0] = dstRecords.length;
            }
            var src = srcRecords[protoIndex];
            if (src.isSkipRecord()) {
                if (src.isConditionalSkipRecord() && src.fixedArgs[0] === protoIndex + 2 && protoIndex < srcRecords.length - 1 && srcRecords[protoIndex + 1].mode === proto_record_1.RecordType.SkipRecords) {
                    src.mode = src.mode === proto_record_1.RecordType.SkipRecordsIf ? proto_record_1.RecordType.SkipRecordsIfNot : proto_record_1.RecordType.SkipRecordsIf;
                    src.fixedArgs[0] = srcRecords[protoIndex + 1].fixedArgs[0];
                    protoIndex++;
                }
                if (src.fixedArgs[0] > protoIndex + 1) {
                    var dst = _cloneAndUpdateIndexes(src, dstRecords, indexMap);
                    dstRecords.push(dst);
                    skipSources[dst.fixedArgs[0]] = dst;
                }
            } else {
                var dst = _cloneAndUpdateIndexes(src, dstRecords, indexMap);
                dstRecords.push(dst);
                indexMap.set(src.selfIndex, dst.selfIndex);
            }
        }
        return dstRecords;
    }
    /**
     * Add a new record or re-use one of the existing records.
     */
    function _mayBeAddRecord(record, dstRecords, excludedIdxs, excluded) {
        var match = _findFirstMatch(record, dstRecords, excludedIdxs);
        if (lang_1.isPresent(match)) {
            if (record.lastInBinding) {
                dstRecords.push(_createSelfRecord(record, match.selfIndex, dstRecords.length + 1));
                match.referencedBySelf = true;
            } else {
                if (record.argumentToPureFunction) {
                    match.argumentToPureFunction = true;
                }
            }
            return match;
        }
        if (excluded) {
            excludedIdxs.push(record.selfIndex);
        }
        dstRecords.push(record);
        return record;
    }
    /**
     * Returns the first `ProtoRecord` that matches the record.
     */
    function _findFirstMatch(record, dstRecords, excludedIdxs) {
        return dstRecords.find(
        // TODO(vicb): optimize excludedIdxs.indexOf (sorted array)
        function (rr) {
            return excludedIdxs.indexOf(rr.selfIndex) == -1 && rr.mode !== proto_record_1.RecordType.DirectiveLifecycle && _haveSameDirIndex(rr, record) && rr.mode === record.mode && lang_1.looseIdentical(rr.funcOrValue, record.funcOrValue) && rr.contextIndex === record.contextIndex && lang_1.looseIdentical(rr.name, record.name) && collection_1.ListWrapper.equals(rr.args, record.args);
        });
    }
    /**
     * Clone the `ProtoRecord` and changes the indexes for the ones in the destination array for:
     * - the arguments,
     * - the context,
     * - self
     */
    function _cloneAndUpdateIndexes(record, dstRecords, indexMap) {
        var args = record.args.map(function (src) {
            return _srcToDstSelfIndex(indexMap, src);
        });
        var contextIndex = _srcToDstSelfIndex(indexMap, record.contextIndex);
        var selfIndex = dstRecords.length + 1;
        return new proto_record_1.ProtoRecord(record.mode, record.name, record.funcOrValue, args, record.fixedArgs, contextIndex, record.directiveIndex, selfIndex, record.bindingRecord, record.lastInBinding, record.lastInDirective, record.argumentToPureFunction, record.referencedBySelf, record.propertyBindingIndex);
    }
    /**
     * Returns the index in the destination array corresponding to the index in the src array.
     * When the element is not present in the destination array, return the source index.
     */
    function _srcToDstSelfIndex(indexMap, srcIdx) {
        var dstIdx = indexMap.get(srcIdx);
        return lang_1.isPresent(dstIdx) ? dstIdx : srcIdx;
    }
    function _createSelfRecord(r, contextIndex, selfIndex) {
        return new proto_record_1.ProtoRecord(proto_record_1.RecordType.Self, "self", null, [], r.fixedArgs, contextIndex, r.directiveIndex, selfIndex, r.bindingRecord, r.lastInBinding, r.lastInDirective, false, false, r.propertyBindingIndex);
    }
    function _haveSameDirIndex(a, b) {
        var di1 = lang_1.isBlank(a.directiveIndex) ? null : a.directiveIndex.directiveIndex;
        var ei1 = lang_1.isBlank(a.directiveIndex) ? null : a.directiveIndex.elementIndex;
        var di2 = lang_1.isBlank(b.directiveIndex) ? null : b.directiveIndex.directiveIndex;
        var ei2 = lang_1.isBlank(b.directiveIndex) ? null : b.directiveIndex.elementIndex;
        return di1 === di2 && ei1 === ei2;
    }
});
System.registerDynamic('angular2/src/core/change_detection/proto_change_detector.js', ['angular2/src/facade/lang.js', 'angular2/src/facade/exceptions.js', 'angular2/src/facade/collection.js', 'angular2/src/core/change_detection/parser/ast.js', 'angular2/src/core/change_detection/change_detection_util.js', 'angular2/src/core/change_detection/dynamic_change_detector.js', 'angular2/src/core/change_detection/directive_record.js', 'angular2/src/core/change_detection/event_binding.js', 'angular2/src/core/change_detection/coalesce.js', 'angular2/src/core/change_detection/proto_record.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var exceptions_1 = $__require('angular2/src/facade/exceptions.js');
    var collection_1 = $__require('angular2/src/facade/collection.js');
    var ast_1 = $__require('angular2/src/core/change_detection/parser/ast.js');
    var change_detection_util_1 = $__require('angular2/src/core/change_detection/change_detection_util.js');
    var dynamic_change_detector_1 = $__require('angular2/src/core/change_detection/dynamic_change_detector.js');
    var directive_record_1 = $__require('angular2/src/core/change_detection/directive_record.js');
    var event_binding_1 = $__require('angular2/src/core/change_detection/event_binding.js');
    var coalesce_1 = $__require('angular2/src/core/change_detection/coalesce.js');
    var proto_record_1 = $__require('angular2/src/core/change_detection/proto_record.js');
    var DynamicProtoChangeDetector = function () {
        function DynamicProtoChangeDetector(_definition) {
            this._definition = _definition;
            this._propertyBindingRecords = createPropertyRecords(_definition);
            this._eventBindingRecords = createEventRecords(_definition);
            this._propertyBindingTargets = this._definition.bindingRecords.map(function (b) {
                return b.target;
            });
            this._directiveIndices = this._definition.directiveRecords.map(function (d) {
                return d.directiveIndex;
            });
        }
        DynamicProtoChangeDetector.prototype.instantiate = function () {
            return new dynamic_change_detector_1.DynamicChangeDetector(this._definition.id, this._propertyBindingRecords.length, this._propertyBindingTargets, this._directiveIndices, this._definition.strategy, this._propertyBindingRecords, this._eventBindingRecords, this._definition.directiveRecords, this._definition.genConfig);
        };
        return DynamicProtoChangeDetector;
    }();
    exports.DynamicProtoChangeDetector = DynamicProtoChangeDetector;
    function createPropertyRecords(definition) {
        var recordBuilder = new ProtoRecordBuilder();
        collection_1.ListWrapper.forEachWithIndex(definition.bindingRecords, function (b, index) {
            return recordBuilder.add(b, definition.variableNames, index);
        });
        return coalesce_1.coalesce(recordBuilder.records);
    }
    exports.createPropertyRecords = createPropertyRecords;
    function createEventRecords(definition) {
        // TODO: vsavkin: remove $event when the compiler handles render-side variables properly
        var varNames = collection_1.ListWrapper.concat(['$event'], definition.variableNames);
        return definition.eventRecords.map(function (er) {
            var records = _ConvertAstIntoProtoRecords.create(er, varNames);
            var dirIndex = er.implicitReceiver instanceof directive_record_1.DirectiveIndex ? er.implicitReceiver : null;
            return new event_binding_1.EventBinding(er.target.name, er.target.elementIndex, dirIndex, records);
        });
    }
    exports.createEventRecords = createEventRecords;
    var ProtoRecordBuilder = function () {
        function ProtoRecordBuilder() {
            this.records = [];
        }
        ProtoRecordBuilder.prototype.add = function (b, variableNames, bindingIndex) {
            var oldLast = collection_1.ListWrapper.last(this.records);
            if (lang_1.isPresent(oldLast) && oldLast.bindingRecord.directiveRecord == b.directiveRecord) {
                oldLast.lastInDirective = false;
            }
            var numberOfRecordsBefore = this.records.length;
            this._appendRecords(b, variableNames, bindingIndex);
            var newLast = collection_1.ListWrapper.last(this.records);
            if (lang_1.isPresent(newLast) && newLast !== oldLast) {
                newLast.lastInBinding = true;
                newLast.lastInDirective = true;
                this._setArgumentToPureFunction(numberOfRecordsBefore);
            }
        };
        /** @internal */
        ProtoRecordBuilder.prototype._setArgumentToPureFunction = function (startIndex) {
            var _this = this;
            for (var i = startIndex; i < this.records.length; ++i) {
                var rec = this.records[i];
                if (rec.isPureFunction()) {
                    rec.args.forEach(function (recordIndex) {
                        return _this.records[recordIndex - 1].argumentToPureFunction = true;
                    });
                }
                if (rec.mode === proto_record_1.RecordType.Pipe) {
                    rec.args.forEach(function (recordIndex) {
                        return _this.records[recordIndex - 1].argumentToPureFunction = true;
                    });
                    this.records[rec.contextIndex - 1].argumentToPureFunction = true;
                }
            }
        };
        /** @internal */
        ProtoRecordBuilder.prototype._appendRecords = function (b, variableNames, bindingIndex) {
            if (b.isDirectiveLifecycle()) {
                this.records.push(new proto_record_1.ProtoRecord(proto_record_1.RecordType.DirectiveLifecycle, b.lifecycleEvent, null, [], [], -1, null, this.records.length + 1, b, false, false, false, false, null));
            } else {
                _ConvertAstIntoProtoRecords.append(this.records, b, variableNames, bindingIndex);
            }
        };
        return ProtoRecordBuilder;
    }();
    exports.ProtoRecordBuilder = ProtoRecordBuilder;
    var _ConvertAstIntoProtoRecords = function () {
        function _ConvertAstIntoProtoRecords(_records, _bindingRecord, _variableNames, _bindingIndex) {
            this._records = _records;
            this._bindingRecord = _bindingRecord;
            this._variableNames = _variableNames;
            this._bindingIndex = _bindingIndex;
        }
        _ConvertAstIntoProtoRecords.append = function (records, b, variableNames, bindingIndex) {
            var c = new _ConvertAstIntoProtoRecords(records, b, variableNames, bindingIndex);
            b.ast.visit(c);
        };
        _ConvertAstIntoProtoRecords.create = function (b, variableNames) {
            var rec = [];
            _ConvertAstIntoProtoRecords.append(rec, b, variableNames, null);
            rec[rec.length - 1].lastInBinding = true;
            return rec;
        };
        _ConvertAstIntoProtoRecords.prototype.visitImplicitReceiver = function (ast) {
            return this._bindingRecord.implicitReceiver;
        };
        _ConvertAstIntoProtoRecords.prototype.visitInterpolation = function (ast) {
            var args = this._visitAll(ast.expressions);
            return this._addRecord(proto_record_1.RecordType.Interpolate, "interpolate", _interpolationFn(ast.strings), args, ast.strings, 0);
        };
        _ConvertAstIntoProtoRecords.prototype.visitLiteralPrimitive = function (ast) {
            return this._addRecord(proto_record_1.RecordType.Const, "literal", ast.value, [], null, 0);
        };
        _ConvertAstIntoProtoRecords.prototype.visitPropertyRead = function (ast) {
            var receiver = ast.receiver.visit(this);
            if (lang_1.isPresent(this._variableNames) && collection_1.ListWrapper.contains(this._variableNames, ast.name) && ast.receiver instanceof ast_1.ImplicitReceiver) {
                return this._addRecord(proto_record_1.RecordType.Local, ast.name, ast.name, [], null, receiver);
            } else {
                return this._addRecord(proto_record_1.RecordType.PropertyRead, ast.name, ast.getter, [], null, receiver);
            }
        };
        _ConvertAstIntoProtoRecords.prototype.visitPropertyWrite = function (ast) {
            if (lang_1.isPresent(this._variableNames) && collection_1.ListWrapper.contains(this._variableNames, ast.name) && ast.receiver instanceof ast_1.ImplicitReceiver) {
                throw new exceptions_1.BaseException("Cannot reassign a variable binding " + ast.name);
            } else {
                var receiver = ast.receiver.visit(this);
                var value = ast.value.visit(this);
                return this._addRecord(proto_record_1.RecordType.PropertyWrite, ast.name, ast.setter, [value], null, receiver);
            }
        };
        _ConvertAstIntoProtoRecords.prototype.visitKeyedWrite = function (ast) {
            var obj = ast.obj.visit(this);
            var key = ast.key.visit(this);
            var value = ast.value.visit(this);
            return this._addRecord(proto_record_1.RecordType.KeyedWrite, null, null, [key, value], null, obj);
        };
        _ConvertAstIntoProtoRecords.prototype.visitSafePropertyRead = function (ast) {
            var receiver = ast.receiver.visit(this);
            return this._addRecord(proto_record_1.RecordType.SafeProperty, ast.name, ast.getter, [], null, receiver);
        };
        _ConvertAstIntoProtoRecords.prototype.visitMethodCall = function (ast) {
            var receiver = ast.receiver.visit(this);
            var args = this._visitAll(ast.args);
            if (lang_1.isPresent(this._variableNames) && collection_1.ListWrapper.contains(this._variableNames, ast.name)) {
                var target = this._addRecord(proto_record_1.RecordType.Local, ast.name, ast.name, [], null, receiver);
                return this._addRecord(proto_record_1.RecordType.InvokeClosure, "closure", null, args, null, target);
            } else {
                return this._addRecord(proto_record_1.RecordType.InvokeMethod, ast.name, ast.fn, args, null, receiver);
            }
        };
        _ConvertAstIntoProtoRecords.prototype.visitSafeMethodCall = function (ast) {
            var receiver = ast.receiver.visit(this);
            var args = this._visitAll(ast.args);
            return this._addRecord(proto_record_1.RecordType.SafeMethodInvoke, ast.name, ast.fn, args, null, receiver);
        };
        _ConvertAstIntoProtoRecords.prototype.visitFunctionCall = function (ast) {
            var target = ast.target.visit(this);
            var args = this._visitAll(ast.args);
            return this._addRecord(proto_record_1.RecordType.InvokeClosure, "closure", null, args, null, target);
        };
        _ConvertAstIntoProtoRecords.prototype.visitLiteralArray = function (ast) {
            var primitiveName = "arrayFn" + ast.expressions.length;
            return this._addRecord(proto_record_1.RecordType.CollectionLiteral, primitiveName, _arrayFn(ast.expressions.length), this._visitAll(ast.expressions), null, 0);
        };
        _ConvertAstIntoProtoRecords.prototype.visitLiteralMap = function (ast) {
            return this._addRecord(proto_record_1.RecordType.CollectionLiteral, _mapPrimitiveName(ast.keys), change_detection_util_1.ChangeDetectionUtil.mapFn(ast.keys), this._visitAll(ast.values), null, 0);
        };
        _ConvertAstIntoProtoRecords.prototype.visitBinary = function (ast) {
            var left = ast.left.visit(this);
            switch (ast.operation) {
                case '&&':
                    var branchEnd = [null];
                    this._addRecord(proto_record_1.RecordType.SkipRecordsIfNot, "SkipRecordsIfNot", null, [], branchEnd, left);
                    var right = ast.right.visit(this);
                    branchEnd[0] = right;
                    return this._addRecord(proto_record_1.RecordType.PrimitiveOp, "cond", change_detection_util_1.ChangeDetectionUtil.cond, [left, right, left], null, 0);
                case '||':
                    var branchEnd = [null];
                    this._addRecord(proto_record_1.RecordType.SkipRecordsIf, "SkipRecordsIf", null, [], branchEnd, left);
                    var right = ast.right.visit(this);
                    branchEnd[0] = right;
                    return this._addRecord(proto_record_1.RecordType.PrimitiveOp, "cond", change_detection_util_1.ChangeDetectionUtil.cond, [left, left, right], null, 0);
                default:
                    var right = ast.right.visit(this);
                    return this._addRecord(proto_record_1.RecordType.PrimitiveOp, _operationToPrimitiveName(ast.operation), _operationToFunction(ast.operation), [left, right], null, 0);
            }
        };
        _ConvertAstIntoProtoRecords.prototype.visitPrefixNot = function (ast) {
            var exp = ast.expression.visit(this);
            return this._addRecord(proto_record_1.RecordType.PrimitiveOp, "operation_negate", change_detection_util_1.ChangeDetectionUtil.operation_negate, [exp], null, 0);
        };
        _ConvertAstIntoProtoRecords.prototype.visitConditional = function (ast) {
            var condition = ast.condition.visit(this);
            var startOfFalseBranch = [null];
            var endOfFalseBranch = [null];
            this._addRecord(proto_record_1.RecordType.SkipRecordsIfNot, "SkipRecordsIfNot", null, [], startOfFalseBranch, condition);
            var whenTrue = ast.trueExp.visit(this);
            var skip = this._addRecord(proto_record_1.RecordType.SkipRecords, "SkipRecords", null, [], endOfFalseBranch, 0);
            var whenFalse = ast.falseExp.visit(this);
            startOfFalseBranch[0] = skip;
            endOfFalseBranch[0] = whenFalse;
            return this._addRecord(proto_record_1.RecordType.PrimitiveOp, "cond", change_detection_util_1.ChangeDetectionUtil.cond, [condition, whenTrue, whenFalse], null, 0);
        };
        _ConvertAstIntoProtoRecords.prototype.visitPipe = function (ast) {
            var value = ast.exp.visit(this);
            var args = this._visitAll(ast.args);
            return this._addRecord(proto_record_1.RecordType.Pipe, ast.name, ast.name, args, null, value);
        };
        _ConvertAstIntoProtoRecords.prototype.visitKeyedRead = function (ast) {
            var obj = ast.obj.visit(this);
            var key = ast.key.visit(this);
            return this._addRecord(proto_record_1.RecordType.KeyedRead, "keyedAccess", change_detection_util_1.ChangeDetectionUtil.keyedAccess, [key], null, obj);
        };
        _ConvertAstIntoProtoRecords.prototype.visitChain = function (ast) {
            var _this = this;
            var args = ast.expressions.map(function (e) {
                return e.visit(_this);
            });
            return this._addRecord(proto_record_1.RecordType.Chain, "chain", null, args, null, 0);
        };
        _ConvertAstIntoProtoRecords.prototype.visitQuote = function (ast) {
            throw new exceptions_1.BaseException("Caught uninterpreted expression at " + ast.location + ": " + ast.uninterpretedExpression + ". " + ("Expression prefix " + ast.prefix + " did not match a template transformer to interpret the expression."));
        };
        _ConvertAstIntoProtoRecords.prototype._visitAll = function (asts) {
            var res = collection_1.ListWrapper.createFixedSize(asts.length);
            for (var i = 0; i < asts.length; ++i) {
                res[i] = asts[i].visit(this);
            }
            return res;
        };
        /**
         * Adds a `ProtoRecord` and returns its selfIndex.
         */
        _ConvertAstIntoProtoRecords.prototype._addRecord = function (type, name, funcOrValue, args, fixedArgs, context) {
            var selfIndex = this._records.length + 1;
            if (context instanceof directive_record_1.DirectiveIndex) {
                this._records.push(new proto_record_1.ProtoRecord(type, name, funcOrValue, args, fixedArgs, -1, context, selfIndex, this._bindingRecord, false, false, false, false, this._bindingIndex));
            } else {
                this._records.push(new proto_record_1.ProtoRecord(type, name, funcOrValue, args, fixedArgs, context, null, selfIndex, this._bindingRecord, false, false, false, false, this._bindingIndex));
            }
            return selfIndex;
        };
        return _ConvertAstIntoProtoRecords;
    }();
    function _arrayFn(length) {
        switch (length) {
            case 0:
                return change_detection_util_1.ChangeDetectionUtil.arrayFn0;
            case 1:
                return change_detection_util_1.ChangeDetectionUtil.arrayFn1;
            case 2:
                return change_detection_util_1.ChangeDetectionUtil.arrayFn2;
            case 3:
                return change_detection_util_1.ChangeDetectionUtil.arrayFn3;
            case 4:
                return change_detection_util_1.ChangeDetectionUtil.arrayFn4;
            case 5:
                return change_detection_util_1.ChangeDetectionUtil.arrayFn5;
            case 6:
                return change_detection_util_1.ChangeDetectionUtil.arrayFn6;
            case 7:
                return change_detection_util_1.ChangeDetectionUtil.arrayFn7;
            case 8:
                return change_detection_util_1.ChangeDetectionUtil.arrayFn8;
            case 9:
                return change_detection_util_1.ChangeDetectionUtil.arrayFn9;
            default:
                throw new exceptions_1.BaseException("Does not support literal maps with more than 9 elements");
        }
    }
    function _mapPrimitiveName(keys) {
        var stringifiedKeys = keys.map(function (k) {
            return lang_1.isString(k) ? "\"" + k + "\"" : "" + k;
        }).join(', ');
        return "mapFn([" + stringifiedKeys + "])";
    }
    function _operationToPrimitiveName(operation) {
        switch (operation) {
            case '+':
                return "operation_add";
            case '-':
                return "operation_subtract";
            case '*':
                return "operation_multiply";
            case '/':
                return "operation_divide";
            case '%':
                return "operation_remainder";
            case '==':
                return "operation_equals";
            case '!=':
                return "operation_not_equals";
            case '===':
                return "operation_identical";
            case '!==':
                return "operation_not_identical";
            case '<':
                return "operation_less_then";
            case '>':
                return "operation_greater_then";
            case '<=':
                return "operation_less_or_equals_then";
            case '>=':
                return "operation_greater_or_equals_then";
            default:
                throw new exceptions_1.BaseException("Unsupported operation " + operation);
        }
    }
    function _operationToFunction(operation) {
        switch (operation) {
            case '+':
                return change_detection_util_1.ChangeDetectionUtil.operation_add;
            case '-':
                return change_detection_util_1.ChangeDetectionUtil.operation_subtract;
            case '*':
                return change_detection_util_1.ChangeDetectionUtil.operation_multiply;
            case '/':
                return change_detection_util_1.ChangeDetectionUtil.operation_divide;
            case '%':
                return change_detection_util_1.ChangeDetectionUtil.operation_remainder;
            case '==':
                return change_detection_util_1.ChangeDetectionUtil.operation_equals;
            case '!=':
                return change_detection_util_1.ChangeDetectionUtil.operation_not_equals;
            case '===':
                return change_detection_util_1.ChangeDetectionUtil.operation_identical;
            case '!==':
                return change_detection_util_1.ChangeDetectionUtil.operation_not_identical;
            case '<':
                return change_detection_util_1.ChangeDetectionUtil.operation_less_then;
            case '>':
                return change_detection_util_1.ChangeDetectionUtil.operation_greater_then;
            case '<=':
                return change_detection_util_1.ChangeDetectionUtil.operation_less_or_equals_then;
            case '>=':
                return change_detection_util_1.ChangeDetectionUtil.operation_greater_or_equals_then;
            default:
                throw new exceptions_1.BaseException("Unsupported operation " + operation);
        }
    }
    function s(v) {
        return lang_1.isPresent(v) ? "" + v : '';
    }
    function _interpolationFn(strings) {
        var length = strings.length;
        var c0 = length > 0 ? strings[0] : null;
        var c1 = length > 1 ? strings[1] : null;
        var c2 = length > 2 ? strings[2] : null;
        var c3 = length > 3 ? strings[3] : null;
        var c4 = length > 4 ? strings[4] : null;
        var c5 = length > 5 ? strings[5] : null;
        var c6 = length > 6 ? strings[6] : null;
        var c7 = length > 7 ? strings[7] : null;
        var c8 = length > 8 ? strings[8] : null;
        var c9 = length > 9 ? strings[9] : null;
        switch (length - 1) {
            case 1:
                return function (a1) {
                    return c0 + s(a1) + c1;
                };
            case 2:
                return function (a1, a2) {
                    return c0 + s(a1) + c1 + s(a2) + c2;
                };
            case 3:
                return function (a1, a2, a3) {
                    return c0 + s(a1) + c1 + s(a2) + c2 + s(a3) + c3;
                };
            case 4:
                return function (a1, a2, a3, a4) {
                    return c0 + s(a1) + c1 + s(a2) + c2 + s(a3) + c3 + s(a4) + c4;
                };
            case 5:
                return function (a1, a2, a3, a4, a5) {
                    return c0 + s(a1) + c1 + s(a2) + c2 + s(a3) + c3 + s(a4) + c4 + s(a5) + c5;
                };
            case 6:
                return function (a1, a2, a3, a4, a5, a6) {
                    return c0 + s(a1) + c1 + s(a2) + c2 + s(a3) + c3 + s(a4) + c4 + s(a5) + c5 + s(a6) + c6;
                };
            case 7:
                return function (a1, a2, a3, a4, a5, a6, a7) {
                    return c0 + s(a1) + c1 + s(a2) + c2 + s(a3) + c3 + s(a4) + c4 + s(a5) + c5 + s(a6) + c6 + s(a7) + c7;
                };
            case 8:
                return function (a1, a2, a3, a4, a5, a6, a7, a8) {
                    return c0 + s(a1) + c1 + s(a2) + c2 + s(a3) + c3 + s(a4) + c4 + s(a5) + c5 + s(a6) + c6 + s(a7) + c7 + s(a8) + c8;
                };
            case 9:
                return function (a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                    return c0 + s(a1) + c1 + s(a2) + c2 + s(a3) + c3 + s(a4) + c4 + s(a5) + c5 + s(a6) + c6 + s(a7) + c7 + s(a8) + c8 + s(a9) + c9;
                };
            default:
                throw new exceptions_1.BaseException("Does not support more than 9 expressions");
        }
    }
});
System.registerDynamic('angular2/src/core/change_detection/change_detection_jit_generator.js', ['angular2/src/facade/lang.js', 'angular2/src/facade/exceptions.js', 'angular2/src/facade/collection.js', 'angular2/src/core/change_detection/abstract_change_detector.js', 'angular2/src/core/change_detection/change_detection_util.js', 'angular2/src/core/change_detection/proto_record.js', 'angular2/src/core/change_detection/codegen_name_util.js', 'angular2/src/core/change_detection/codegen_logic_util.js', 'angular2/src/core/change_detection/codegen_facade.js', 'angular2/src/core/change_detection/constants.js', 'angular2/src/core/change_detection/proto_change_detector.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var exceptions_1 = $__require('angular2/src/facade/exceptions.js');
    var collection_1 = $__require('angular2/src/facade/collection.js');
    var abstract_change_detector_1 = $__require('angular2/src/core/change_detection/abstract_change_detector.js');
    var change_detection_util_1 = $__require('angular2/src/core/change_detection/change_detection_util.js');
    var proto_record_1 = $__require('angular2/src/core/change_detection/proto_record.js');
    var codegen_name_util_1 = $__require('angular2/src/core/change_detection/codegen_name_util.js');
    var codegen_logic_util_1 = $__require('angular2/src/core/change_detection/codegen_logic_util.js');
    var codegen_facade_1 = $__require('angular2/src/core/change_detection/codegen_facade.js');
    var constants_1 = $__require('angular2/src/core/change_detection/constants.js');
    var proto_change_detector_1 = $__require('angular2/src/core/change_detection/proto_change_detector.js');
    /**
     * The code generator takes a list of proto records and creates a function/class
     * that "emulates" what the developer would write by hand to implement the same
     * kind of behaviour.
     *
     * This code should be kept in sync with the Dart transformer's
     * `angular2.transform.template_compiler.change_detector_codegen` library. If you make updates
     * here, please make equivalent changes there.
    */
    var IS_CHANGED_LOCAL = "isChanged";
    var CHANGES_LOCAL = "changes";
    var ChangeDetectorJITGenerator = function () {
        function ChangeDetectorJITGenerator(definition, changeDetectionUtilVarName, abstractChangeDetectorVarName, changeDetectorStateVarName) {
            this.changeDetectionUtilVarName = changeDetectionUtilVarName;
            this.abstractChangeDetectorVarName = abstractChangeDetectorVarName;
            this.changeDetectorStateVarName = changeDetectorStateVarName;
            var propertyBindingRecords = proto_change_detector_1.createPropertyRecords(definition);
            var eventBindingRecords = proto_change_detector_1.createEventRecords(definition);
            var propertyBindingTargets = definition.bindingRecords.map(function (b) {
                return b.target;
            });
            this.id = definition.id;
            this.changeDetectionStrategy = definition.strategy;
            this.genConfig = definition.genConfig;
            this.records = propertyBindingRecords;
            this.propertyBindingTargets = propertyBindingTargets;
            this.eventBindings = eventBindingRecords;
            this.directiveRecords = definition.directiveRecords;
            this._names = new codegen_name_util_1.CodegenNameUtil(this.records, this.eventBindings, this.directiveRecords, this.changeDetectionUtilVarName);
            this._logic = new codegen_logic_util_1.CodegenLogicUtil(this._names, this.changeDetectionUtilVarName, this.changeDetectorStateVarName);
            this.typeName = codegen_name_util_1.sanitizeName("ChangeDetector_" + this.id);
        }
        ChangeDetectorJITGenerator.prototype.generate = function () {
            var factorySource = "\n      " + this.generateSource() + "\n      return function() {\n        return new " + this.typeName + "();\n      }\n    ";
            return new Function(this.abstractChangeDetectorVarName, this.changeDetectionUtilVarName, this.changeDetectorStateVarName, factorySource)(abstract_change_detector_1.AbstractChangeDetector, change_detection_util_1.ChangeDetectionUtil, constants_1.ChangeDetectorState);
        };
        ChangeDetectorJITGenerator.prototype.generateSource = function () {
            return "\n      var " + this.typeName + " = function " + this.typeName + "() {\n        " + this.abstractChangeDetectorVarName + ".call(\n            this, " + JSON.stringify(this.id) + ", " + this.records.length + ",\n            " + this.typeName + ".gen_propertyBindingTargets, " + this.typeName + ".gen_directiveIndices,\n            " + codegen_facade_1.codify(this.changeDetectionStrategy) + ");\n        this.dehydrateDirectives(false);\n      }\n\n      " + this.typeName + ".prototype = Object.create(" + this.abstractChangeDetectorVarName + ".prototype);\n\n      " + this.typeName + ".prototype.detectChangesInRecordsInternal = function(throwOnChange) {\n        " + this._names.genInitLocals() + "\n        var " + IS_CHANGED_LOCAL + " = false;\n        var " + CHANGES_LOCAL + " = null;\n\n        " + this._genAllRecords(this.records) + "\n      }\n\n      " + this._maybeGenHandleEventInternal() + "\n\n      " + this._maybeGenAfterContentLifecycleCallbacks() + "\n\n      " + this._maybeGenAfterViewLifecycleCallbacks() + "\n\n      " + this._maybeGenHydrateDirectives() + "\n\n      " + this._maybeGenDehydrateDirectives() + "\n\n      " + this._genPropertyBindingTargets() + "\n\n      " + this._genDirectiveIndices() + "\n    ";
        };
        /** @internal */
        ChangeDetectorJITGenerator.prototype._genPropertyBindingTargets = function () {
            var targets = this._logic.genPropertyBindingTargets(this.propertyBindingTargets, this.genConfig.genDebugInfo);
            return this.typeName + ".gen_propertyBindingTargets = " + targets + ";";
        };
        /** @internal */
        ChangeDetectorJITGenerator.prototype._genDirectiveIndices = function () {
            var indices = this._logic.genDirectiveIndices(this.directiveRecords);
            return this.typeName + ".gen_directiveIndices = " + indices + ";";
        };
        /** @internal */
        ChangeDetectorJITGenerator.prototype._maybeGenHandleEventInternal = function () {
            var _this = this;
            if (this.eventBindings.length > 0) {
                var handlers = this.eventBindings.map(function (eb) {
                    return _this._genEventBinding(eb);
                }).join("\n");
                return "\n        " + this.typeName + ".prototype.handleEventInternal = function(eventName, elIndex, locals) {\n          var " + this._names.getPreventDefaultAccesor() + " = false;\n          " + this._names.genInitEventLocals() + "\n          " + handlers + "\n          return " + this._names.getPreventDefaultAccesor() + ";\n        }\n      ";
            } else {
                return '';
            }
        };
        /** @internal */
        ChangeDetectorJITGenerator.prototype._genEventBinding = function (eb) {
            var _this = this;
            var codes = [];
            this._endOfBlockIdxs = [];
            collection_1.ListWrapper.forEachWithIndex(eb.records, function (r, i) {
                var code;
                if (r.isConditionalSkipRecord()) {
                    code = _this._genConditionalSkip(r, _this._names.getEventLocalName(eb, i));
                } else if (r.isUnconditionalSkipRecord()) {
                    code = _this._genUnconditionalSkip(r);
                } else {
                    code = _this._genEventBindingEval(eb, r);
                }
                code += _this._genEndOfSkipBlock(i);
                codes.push(code);
            });
            return "\n    if (eventName === \"" + eb.eventName + "\" && elIndex === " + eb.elIndex + ") {\n      " + codes.join("\n") + "\n    }";
        };
        /** @internal */
        ChangeDetectorJITGenerator.prototype._genEventBindingEval = function (eb, r) {
            if (r.lastInBinding) {
                var evalRecord = this._logic.genEventBindingEvalValue(eb, r);
                var markPath = this._genMarkPathToRootAsCheckOnce(r);
                var prevDefault = this._genUpdatePreventDefault(eb, r);
                return markPath + "\n" + evalRecord + "\n" + prevDefault;
            } else {
                return this._logic.genEventBindingEvalValue(eb, r);
            }
        };
        /** @internal */
        ChangeDetectorJITGenerator.prototype._genMarkPathToRootAsCheckOnce = function (r) {
            var br = r.bindingRecord;
            if (br.isDefaultChangeDetection()) {
                return "";
            } else {
                return this._names.getDetectorName(br.directiveRecord.directiveIndex) + ".markPathToRootAsCheckOnce();";
            }
        };
        /** @internal */
        ChangeDetectorJITGenerator.prototype._genUpdatePreventDefault = function (eb, r) {
            var local = this._names.getEventLocalName(eb, r.selfIndex);
            return "if (" + local + " === false) { " + this._names.getPreventDefaultAccesor() + " = true};";
        };
        /** @internal */
        ChangeDetectorJITGenerator.prototype._maybeGenDehydrateDirectives = function () {
            var destroyPipesCode = this._names.genPipeOnDestroy();
            var destroyDirectivesCode = this._logic.genDirectivesOnDestroy(this.directiveRecords);
            var dehydrateFieldsCode = this._names.genDehydrateFields();
            if (!destroyPipesCode && !destroyDirectivesCode && !dehydrateFieldsCode) return '';
            return this.typeName + ".prototype.dehydrateDirectives = function(destroyPipes) {\n        if (destroyPipes) {\n          " + destroyPipesCode + "\n          " + destroyDirectivesCode + "\n        }\n        " + dehydrateFieldsCode + "\n    }";
        };
        /** @internal */
        ChangeDetectorJITGenerator.prototype._maybeGenHydrateDirectives = function () {
            var hydrateDirectivesCode = this._logic.genHydrateDirectives(this.directiveRecords);
            var hydrateDetectorsCode = this._logic.genHydrateDetectors(this.directiveRecords);
            if (!hydrateDirectivesCode && !hydrateDetectorsCode) return '';
            return this.typeName + ".prototype.hydrateDirectives = function(directives) {\n      " + hydrateDirectivesCode + "\n      " + hydrateDetectorsCode + "\n    }";
        };
        /** @internal */
        ChangeDetectorJITGenerator.prototype._maybeGenAfterContentLifecycleCallbacks = function () {
            var notifications = this._logic.genContentLifecycleCallbacks(this.directiveRecords);
            if (notifications.length > 0) {
                var directiveNotifications = notifications.join("\n");
                return "\n        " + this.typeName + ".prototype.afterContentLifecycleCallbacksInternal = function() {\n          " + directiveNotifications + "\n        }\n      ";
            } else {
                return '';
            }
        };
        /** @internal */
        ChangeDetectorJITGenerator.prototype._maybeGenAfterViewLifecycleCallbacks = function () {
            var notifications = this._logic.genViewLifecycleCallbacks(this.directiveRecords);
            if (notifications.length > 0) {
                var directiveNotifications = notifications.join("\n");
                return "\n        " + this.typeName + ".prototype.afterViewLifecycleCallbacksInternal = function() {\n          " + directiveNotifications + "\n        }\n      ";
            } else {
                return '';
            }
        };
        /** @internal */
        ChangeDetectorJITGenerator.prototype._genAllRecords = function (rs) {
            var codes = [];
            this._endOfBlockIdxs = [];
            for (var i = 0; i < rs.length; i++) {
                var code = void 0;
                var r = rs[i];
                if (r.isLifeCycleRecord()) {
                    code = this._genDirectiveLifecycle(r);
                } else if (r.isPipeRecord()) {
                    code = this._genPipeCheck(r);
                } else if (r.isConditionalSkipRecord()) {
                    code = this._genConditionalSkip(r, this._names.getLocalName(r.contextIndex));
                } else if (r.isUnconditionalSkipRecord()) {
                    code = this._genUnconditionalSkip(r);
                } else {
                    code = this._genReferenceCheck(r);
                }
                code = "\n        " + this._maybeFirstInBinding(r) + "\n        " + code + "\n        " + this._maybeGenLastInDirective(r) + "\n        " + this._genEndOfSkipBlock(i) + "\n      ";
                codes.push(code);
            }
            return codes.join("\n");
        };
        /** @internal */
        ChangeDetectorJITGenerator.prototype._genConditionalSkip = function (r, condition) {
            var maybeNegate = r.mode === proto_record_1.RecordType.SkipRecordsIf ? '!' : '';
            this._endOfBlockIdxs.push(r.fixedArgs[0] - 1);
            return "if (" + maybeNegate + condition + ") {";
        };
        /** @internal */
        ChangeDetectorJITGenerator.prototype._genUnconditionalSkip = function (r) {
            this._endOfBlockIdxs.pop();
            this._endOfBlockIdxs.push(r.fixedArgs[0] - 1);
            return "} else {";
        };
        /** @internal */
        ChangeDetectorJITGenerator.prototype._genEndOfSkipBlock = function (protoIndex) {
            if (!collection_1.ListWrapper.isEmpty(this._endOfBlockIdxs)) {
                var endOfBlock = collection_1.ListWrapper.last(this._endOfBlockIdxs);
                if (protoIndex === endOfBlock) {
                    this._endOfBlockIdxs.pop();
                    return '}';
                }
            }
            return '';
        };
        /** @internal */
        ChangeDetectorJITGenerator.prototype._genDirectiveLifecycle = function (r) {
            if (r.name === "DoCheck") {
                return this._genOnCheck(r);
            } else if (r.name === "OnInit") {
                return this._genOnInit(r);
            } else if (r.name === "OnChanges") {
                return this._genOnChange(r);
            } else {
                throw new exceptions_1.BaseException("Unknown lifecycle event '" + r.name + "'");
            }
        };
        /** @internal */
        ChangeDetectorJITGenerator.prototype._genPipeCheck = function (r) {
            var _this = this;
            var context = this._names.getLocalName(r.contextIndex);
            var argString = r.args.map(function (arg) {
                return _this._names.getLocalName(arg);
            }).join(", ");
            var oldValue = this._names.getFieldName(r.selfIndex);
            var newValue = this._names.getLocalName(r.selfIndex);
            var pipe = this._names.getPipeName(r.selfIndex);
            var pipeName = r.name;
            var init = "\n      if (" + pipe + " === " + this.changeDetectionUtilVarName + ".uninitialized) {\n        " + pipe + " = " + this._names.getPipesAccessorName() + ".get('" + pipeName + "');\n      }\n    ";
            var read = newValue + " = " + pipe + ".pipe.transform(" + context + ", [" + argString + "]);";
            var contexOrArgCheck = r.args.map(function (a) {
                return _this._names.getChangeName(a);
            });
            contexOrArgCheck.push(this._names.getChangeName(r.contextIndex));
            var condition = "!" + pipe + ".pure || (" + contexOrArgCheck.join(" || ") + ")";
            var check = "\n      " + this._genThrowOnChangeCheck(oldValue, newValue) + "\n      if (" + this.changeDetectionUtilVarName + ".looseNotIdentical(" + oldValue + ", " + newValue + ")) {\n        " + newValue + " = " + this.changeDetectionUtilVarName + ".unwrapValue(" + newValue + ")\n        " + this._genChangeMarker(r) + "\n        " + this._genUpdateDirectiveOrElement(r) + "\n        " + this._genAddToChanges(r) + "\n        " + oldValue + " = " + newValue + ";\n      }\n    ";
            var genCode = r.shouldBeChecked() ? "" + read + check : read;
            if (r.isUsedByOtherRecord()) {
                return init + " if (" + condition + ") { " + genCode + " } else { " + newValue + " = " + oldValue + "; }";
            } else {
                return init + " if (" + condition + ") { " + genCode + " }";
            }
        };
        /** @internal */
        ChangeDetectorJITGenerator.prototype._genReferenceCheck = function (r) {
            var _this = this;
            var oldValue = this._names.getFieldName(r.selfIndex);
            var newValue = this._names.getLocalName(r.selfIndex);
            var read = "\n      " + this._logic.genPropertyBindingEvalValue(r) + "\n    ";
            var check = "\n      " + this._genThrowOnChangeCheck(oldValue, newValue) + "\n      if (" + this.changeDetectionUtilVarName + ".looseNotIdentical(" + oldValue + ", " + newValue + ")) {\n        " + this._genChangeMarker(r) + "\n        " + this._genUpdateDirectiveOrElement(r) + "\n        " + this._genAddToChanges(r) + "\n        " + oldValue + " = " + newValue + ";\n      }\n    ";
            var genCode = r.shouldBeChecked() ? "" + read + check : read;
            if (r.isPureFunction()) {
                var condition = r.args.map(function (a) {
                    return _this._names.getChangeName(a);
                }).join(" || ");
                if (r.isUsedByOtherRecord()) {
                    return "if (" + condition + ") { " + genCode + " } else { " + newValue + " = " + oldValue + "; }";
                } else {
                    return "if (" + condition + ") { " + genCode + " }";
                }
            } else {
                return genCode;
            }
        };
        /** @internal */
        ChangeDetectorJITGenerator.prototype._genChangeMarker = function (r) {
            return r.argumentToPureFunction ? this._names.getChangeName(r.selfIndex) + " = true" : "";
        };
        /** @internal */
        ChangeDetectorJITGenerator.prototype._genUpdateDirectiveOrElement = function (r) {
            if (!r.lastInBinding) return "";
            var newValue = this._names.getLocalName(r.selfIndex);
            var notifyDebug = this.genConfig.logBindingUpdate ? "this.logBindingUpdate(" + newValue + ");" : "";
            var br = r.bindingRecord;
            if (br.target.isDirective()) {
                var directiveProperty = this._names.getDirectiveName(br.directiveRecord.directiveIndex) + "." + br.target.name;
                return "\n        " + directiveProperty + " = " + newValue + ";\n        " + notifyDebug + "\n        " + IS_CHANGED_LOCAL + " = true;\n      ";
            } else {
                return "\n        this.notifyDispatcher(" + newValue + ");\n        " + notifyDebug + "\n      ";
            }
        };
        /** @internal */
        ChangeDetectorJITGenerator.prototype._genThrowOnChangeCheck = function (oldValue, newValue) {
            if (lang_1.assertionsEnabled()) {
                return "\n        if (throwOnChange && !" + this.changeDetectionUtilVarName + ".devModeEqual(" + oldValue + ", " + newValue + ")) {\n          this.throwOnChangeError(" + oldValue + ", " + newValue + ");\n        }\n        ";
            } else {
                return '';
            }
        };
        /** @internal */
        ChangeDetectorJITGenerator.prototype._genAddToChanges = function (r) {
            var newValue = this._names.getLocalName(r.selfIndex);
            var oldValue = this._names.getFieldName(r.selfIndex);
            if (!r.bindingRecord.callOnChanges()) return "";
            return CHANGES_LOCAL + " = this.addChange(" + CHANGES_LOCAL + ", " + oldValue + ", " + newValue + ");";
        };
        /** @internal */
        ChangeDetectorJITGenerator.prototype._maybeFirstInBinding = function (r) {
            var prev = change_detection_util_1.ChangeDetectionUtil.protoByIndex(this.records, r.selfIndex - 1);
            var firstInBinding = lang_1.isBlank(prev) || prev.bindingRecord !== r.bindingRecord;
            return firstInBinding && !r.bindingRecord.isDirectiveLifecycle() ? this._names.getPropertyBindingIndex() + " = " + r.propertyBindingIndex + ";" : '';
        };
        /** @internal */
        ChangeDetectorJITGenerator.prototype._maybeGenLastInDirective = function (r) {
            if (!r.lastInDirective) return "";
            return "\n      " + CHANGES_LOCAL + " = null;\n      " + this._genNotifyOnPushDetectors(r) + "\n      " + IS_CHANGED_LOCAL + " = false;\n    ";
        };
        /** @internal */
        ChangeDetectorJITGenerator.prototype._genOnCheck = function (r) {
            var br = r.bindingRecord;
            return "if (!throwOnChange) " + this._names.getDirectiveName(br.directiveRecord.directiveIndex) + ".ngDoCheck();";
        };
        /** @internal */
        ChangeDetectorJITGenerator.prototype._genOnInit = function (r) {
            var br = r.bindingRecord;
            return "if (!throwOnChange && " + this._names.getStateName() + " === " + this.changeDetectorStateVarName + ".NeverChecked) " + this._names.getDirectiveName(br.directiveRecord.directiveIndex) + ".ngOnInit();";
        };
        /** @internal */
        ChangeDetectorJITGenerator.prototype._genOnChange = function (r) {
            var br = r.bindingRecord;
            return "if (!throwOnChange && " + CHANGES_LOCAL + ") " + this._names.getDirectiveName(br.directiveRecord.directiveIndex) + ".ngOnChanges(" + CHANGES_LOCAL + ");";
        };
        /** @internal */
        ChangeDetectorJITGenerator.prototype._genNotifyOnPushDetectors = function (r) {
            var br = r.bindingRecord;
            if (!r.lastInDirective || br.isDefaultChangeDetection()) return "";
            var retVal = "\n      if(" + IS_CHANGED_LOCAL + ") {\n        " + this._names.getDetectorName(br.directiveRecord.directiveIndex) + ".markAsCheckOnce();\n      }\n    ";
            return retVal;
        };
        return ChangeDetectorJITGenerator;
    }();
    exports.ChangeDetectorJITGenerator = ChangeDetectorJITGenerator;
});
System.registerDynamic('angular2/src/core/change_detection/jit_proto_change_detector.js', ['angular2/src/core/change_detection/change_detection_jit_generator.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var change_detection_jit_generator_1 = $__require('angular2/src/core/change_detection/change_detection_jit_generator.js');
    var JitProtoChangeDetector = function () {
        function JitProtoChangeDetector(definition) {
            this.definition = definition;
            this._factory = this._createFactory(definition);
        }
        JitProtoChangeDetector.isSupported = function () {
            return true;
        };
        JitProtoChangeDetector.prototype.instantiate = function () {
            return this._factory();
        };
        /** @internal */
        JitProtoChangeDetector.prototype._createFactory = function (definition) {
            return new change_detection_jit_generator_1.ChangeDetectorJITGenerator(definition, 'util', 'AbstractChangeDetector', 'ChangeDetectorStatus').generate();
        };
        return JitProtoChangeDetector;
    }();
    exports.JitProtoChangeDetector = JitProtoChangeDetector;
});
System.registerDynamic("angular2/src/core/change_detection/exceptions.js", ["angular2/src/facade/exceptions.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var exceptions_1 = $__require("angular2/src/facade/exceptions.js");
    /**
     * An error thrown if application changes model breaking the top-down data flow.
     *
     * This exception is only thrown in dev mode.
     *
     * <!-- TODO: Add a link once the dev mode option is configurable -->
     *
     * ### Example
     *
     * ```typescript
     * @Component({
     *   selector: 'parent',
     *   template: `
     *     <child [prop]="parentProp"></child>
     *   `,
     *   directives: [forwardRef(() => Child)]
     * })
     * class Parent {
     *   parentProp = "init";
     * }
     *
     * @Directive({selector: 'child', inputs: ['prop']})
     * class Child {
     *   constructor(public parent: Parent) {}
     *
     *   set prop(v) {
     *     // this updates the parent property, which is disallowed during change detection
     *     // this will result in ExpressionChangedAfterItHasBeenCheckedException
     *     this.parent.parentProp = "updated";
     *   }
     * }
     * ```
     */
    var ExpressionChangedAfterItHasBeenCheckedException = function (_super) {
        __extends(ExpressionChangedAfterItHasBeenCheckedException, _super);
        function ExpressionChangedAfterItHasBeenCheckedException(exp, oldValue, currValue, context) {
            _super.call(this, "Expression '" + exp + "' has changed after it was checked. " + ("Previous value: '" + oldValue + "'. Current value: '" + currValue + "'"));
        }
        return ExpressionChangedAfterItHasBeenCheckedException;
    }(exceptions_1.BaseException);
    exports.ExpressionChangedAfterItHasBeenCheckedException = ExpressionChangedAfterItHasBeenCheckedException;
    /**
     * Thrown when an expression evaluation raises an exception.
     *
     * This error wraps the original exception to attach additional contextual information that can
     * be useful for debugging.
     *
     * ### Example ([live demo](http://plnkr.co/edit/2Kywoz?p=preview))
     *
     * ```typescript
     * @Directive({selector: 'child', inputs: ['prop']})
     * class Child {
     *   prop;
     * }
     *
     * @Component({
     *   selector: 'app',
     *   template: `
     *     <child [prop]="field.first"></child>
     *   `,
     *   directives: [Child]
     * })
     * class App {
     *   field = null;
     * }
     *
     * bootstrap(App);
     * ```
     *
     * You can access the original exception and stack through the `originalException` and
     * `originalStack` properties.
     */
    var ChangeDetectionError = function (_super) {
        __extends(ChangeDetectionError, _super);
        function ChangeDetectionError(exp, originalException, originalStack, context) {
            _super.call(this, originalException + " in [" + exp + "]", originalException, originalStack, context);
            this.location = exp;
        }
        return ChangeDetectionError;
    }(exceptions_1.WrappedException);
    exports.ChangeDetectionError = ChangeDetectionError;
    /**
     * Thrown when change detector executes on dehydrated view.
     *
     * This error indicates a bug in the framework.
     *
     * This is an internal Angular error.
     */
    var DehydratedException = function (_super) {
        __extends(DehydratedException, _super);
        function DehydratedException(details) {
            _super.call(this, "Attempt to use a dehydrated detector: " + details);
        }
        return DehydratedException;
    }(exceptions_1.BaseException);
    exports.DehydratedException = DehydratedException;
    /**
     * Wraps an exception thrown by an event handler.
     */
    var EventEvaluationError = function (_super) {
        __extends(EventEvaluationError, _super);
        function EventEvaluationError(eventName, originalException, originalStack, context) {
            _super.call(this, "Error during evaluation of \"" + eventName + "\"", originalException, originalStack, context);
        }
        return EventEvaluationError;
    }(exceptions_1.WrappedException);
    exports.EventEvaluationError = EventEvaluationError;
    /**
     * Error context included when an event handler throws an exception.
     */
    var EventEvaluationErrorContext = function () {
        function EventEvaluationErrorContext(element, componentElement, context, locals, injector) {
            this.element = element;
            this.componentElement = componentElement;
            this.context = context;
            this.locals = locals;
            this.injector = injector;
        }
        return EventEvaluationErrorContext;
    }();
    exports.EventEvaluationErrorContext = EventEvaluationErrorContext;
});
System.registerDynamic('angular2/src/core/change_detection/parser/locals.js', ['angular2/src/facade/lang.js', 'angular2/src/facade/exceptions.js', 'angular2/src/facade/collection.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var exceptions_1 = $__require('angular2/src/facade/exceptions.js');
    var collection_1 = $__require('angular2/src/facade/collection.js');
    var Locals = function () {
        function Locals(parent, current) {
            this.parent = parent;
            this.current = current;
        }
        Locals.prototype.contains = function (name) {
            if (this.current.has(name)) {
                return true;
            }
            if (lang_1.isPresent(this.parent)) {
                return this.parent.contains(name);
            }
            return false;
        };
        Locals.prototype.get = function (name) {
            if (this.current.has(name)) {
                return this.current.get(name);
            }
            if (lang_1.isPresent(this.parent)) {
                return this.parent.get(name);
            }
            throw new exceptions_1.BaseException("Cannot find '" + name + "'");
        };
        Locals.prototype.set = function (name, value) {
            // TODO(rado): consider removing this check if we can guarantee this is not
            // exposed to the public API.
            // TODO: vsavkin maybe it should check only the local map
            if (this.current.has(name)) {
                this.current.set(name, value);
            } else {
                throw new exceptions_1.BaseException("Setting of new keys post-construction is not supported. Key: " + name + ".");
            }
        };
        Locals.prototype.clearLocalValues = function () {
            collection_1.MapWrapper.clearValues(this.current);
        };
        return Locals;
    }();
    exports.Locals = Locals;
});
System.registerDynamic('angular2/src/core/change_detection/abstract_change_detector.js', ['angular2/src/facade/lang.js', 'angular2/src/facade/collection.js', 'angular2/src/core/change_detection/change_detection_util.js', 'angular2/src/core/change_detection/change_detector_ref.js', 'angular2/src/core/change_detection/exceptions.js', 'angular2/src/core/change_detection/parser/locals.js', 'angular2/src/core/change_detection/constants.js', 'angular2/src/core/profile/profile.js', 'angular2/src/facade/async.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var collection_1 = $__require('angular2/src/facade/collection.js');
    var change_detection_util_1 = $__require('angular2/src/core/change_detection/change_detection_util.js');
    var change_detector_ref_1 = $__require('angular2/src/core/change_detection/change_detector_ref.js');
    var exceptions_1 = $__require('angular2/src/core/change_detection/exceptions.js');
    var locals_1 = $__require('angular2/src/core/change_detection/parser/locals.js');
    var constants_1 = $__require('angular2/src/core/change_detection/constants.js');
    var profile_1 = $__require('angular2/src/core/profile/profile.js');
    var async_1 = $__require('angular2/src/facade/async.js');
    var _scope_check = profile_1.wtfCreateScope("ChangeDetector#check(ascii id, bool throwOnChange)");
    var _Context = function () {
        function _Context(element, componentElement, context, locals, injector, expression) {
            this.element = element;
            this.componentElement = componentElement;
            this.context = context;
            this.locals = locals;
            this.injector = injector;
            this.expression = expression;
        }
        return _Context;
    }();
    var AbstractChangeDetector = function () {
        function AbstractChangeDetector(id, numberOfPropertyProtoRecords, bindingTargets, directiveIndices, strategy) {
            this.id = id;
            this.numberOfPropertyProtoRecords = numberOfPropertyProtoRecords;
            this.bindingTargets = bindingTargets;
            this.directiveIndices = directiveIndices;
            this.strategy = strategy;
            this.contentChildren = [];
            this.viewChildren = [];
            // The names of the below fields must be kept in sync with codegen_name_util.ts or
            // change detection will fail.
            this.state = constants_1.ChangeDetectorState.NeverChecked;
            this.locals = null;
            this.mode = null;
            this.pipes = null;
            this.ref = new change_detector_ref_1.ChangeDetectorRef_(this);
        }
        AbstractChangeDetector.prototype.addContentChild = function (cd) {
            this.contentChildren.push(cd);
            cd.parent = this;
        };
        AbstractChangeDetector.prototype.removeContentChild = function (cd) {
            collection_1.ListWrapper.remove(this.contentChildren, cd);
        };
        AbstractChangeDetector.prototype.addViewChild = function (cd) {
            this.viewChildren.push(cd);
            cd.parent = this;
        };
        AbstractChangeDetector.prototype.removeViewChild = function (cd) {
            collection_1.ListWrapper.remove(this.viewChildren, cd);
        };
        AbstractChangeDetector.prototype.remove = function () {
            this.parent.removeContentChild(this);
        };
        AbstractChangeDetector.prototype.handleEvent = function (eventName, elIndex, event) {
            if (!this.hydrated()) {
                this.throwDehydratedError(this.id + " -> " + eventName);
            }
            try {
                var locals = new Map();
                locals.set('$event', event);
                var res = !this.handleEventInternal(eventName, elIndex, new locals_1.Locals(this.locals, locals));
                this.markPathToRootAsCheckOnce();
                return res;
            } catch (e) {
                var c = this.dispatcher.getDebugContext(null, elIndex, null);
                var context = lang_1.isPresent(c) ? new exceptions_1.EventEvaluationErrorContext(c.element, c.componentElement, c.context, c.locals, c.injector) : null;
                throw new exceptions_1.EventEvaluationError(eventName, e, e.stack, context);
            }
        };
        AbstractChangeDetector.prototype.handleEventInternal = function (eventName, elIndex, locals) {
            return false;
        };
        AbstractChangeDetector.prototype.detectChanges = function () {
            this.runDetectChanges(false);
        };
        AbstractChangeDetector.prototype.checkNoChanges = function () {
            if (lang_1.assertionsEnabled()) {
                this.runDetectChanges(true);
            }
        };
        AbstractChangeDetector.prototype.runDetectChanges = function (throwOnChange) {
            if (this.mode === constants_1.ChangeDetectionStrategy.Detached || this.mode === constants_1.ChangeDetectionStrategy.Checked || this.state === constants_1.ChangeDetectorState.Errored) return;
            var s = _scope_check(this.id, throwOnChange);
            this.detectChangesInRecords(throwOnChange);
            this._detectChangesContentChildren(throwOnChange);
            if (!throwOnChange) this.afterContentLifecycleCallbacks();
            this._detectChangesInViewChildren(throwOnChange);
            if (!throwOnChange) this.afterViewLifecycleCallbacks();
            if (this.mode === constants_1.ChangeDetectionStrategy.CheckOnce) this.mode = constants_1.ChangeDetectionStrategy.Checked;
            this.state = constants_1.ChangeDetectorState.CheckedBefore;
            profile_1.wtfLeave(s);
        };
        // This method is not intended to be overridden. Subclasses should instead provide an
        // implementation of `detectChangesInRecordsInternal` which does the work of detecting changes
        // and which this method will call.
        // This method expects that `detectChangesInRecordsInternal` will set the property
        // `this.propertyBindingIndex` to the propertyBindingIndex of the first proto record. This is to
        // facilitate error reporting.
        AbstractChangeDetector.prototype.detectChangesInRecords = function (throwOnChange) {
            if (!this.hydrated()) {
                this.throwDehydratedError(this.id);
            }
            try {
                this.detectChangesInRecordsInternal(throwOnChange);
            } catch (e) {
                // throwOnChange errors aren't counted as fatal errors.
                if (!(e instanceof exceptions_1.ExpressionChangedAfterItHasBeenCheckedException)) {
                    this.state = constants_1.ChangeDetectorState.Errored;
                }
                this._throwError(e, e.stack);
            }
        };
        // Subclasses should override this method to perform any work necessary to detect and report
        // changes. For example, changes should be reported via `ChangeDetectionUtil.addChange`, lifecycle
        // methods should be called, etc.
        // This implementation should also set `this.propertyBindingIndex` to the propertyBindingIndex of
        // the
        // first proto record to facilitate error reporting. See {@link #detectChangesInRecords}.
        AbstractChangeDetector.prototype.detectChangesInRecordsInternal = function (throwOnChange) {};
        // This method is not intended to be overridden. Subclasses should instead provide an
        // implementation of `hydrateDirectives`.
        AbstractChangeDetector.prototype.hydrate = function (context, locals, dispatcher, pipes) {
            this.dispatcher = dispatcher;
            this.mode = change_detection_util_1.ChangeDetectionUtil.changeDetectionMode(this.strategy);
            this.context = context;
            this.locals = locals;
            this.pipes = pipes;
            this.hydrateDirectives(dispatcher);
            this.state = constants_1.ChangeDetectorState.NeverChecked;
        };
        // Subclasses should override this method to hydrate any directives.
        AbstractChangeDetector.prototype.hydrateDirectives = function (dispatcher) {};
        // This method is not intended to be overridden. Subclasses should instead provide an
        // implementation of `dehydrateDirectives`.
        AbstractChangeDetector.prototype.dehydrate = function () {
            this.dehydrateDirectives(true);
            this._unsubscribeFromOutputs();
            this.dispatcher = null;
            this.context = null;
            this.locals = null;
            this.pipes = null;
        };
        // Subclasses should override this method to dehydrate any directives. This method should reverse
        // any work done in `hydrateDirectives`.
        AbstractChangeDetector.prototype.dehydrateDirectives = function (destroyPipes) {};
        AbstractChangeDetector.prototype.hydrated = function () {
            return lang_1.isPresent(this.context);
        };
        AbstractChangeDetector.prototype.destroyRecursive = function () {
            this.dispatcher.notifyOnDestroy();
            this.dehydrate();
            var children = this.contentChildren;
            for (var i = 0; i < children.length; i++) {
                children[i].destroyRecursive();
            }
            children = this.viewChildren;
            for (var i = 0; i < children.length; i++) {
                children[i].destroyRecursive();
            }
        };
        AbstractChangeDetector.prototype.afterContentLifecycleCallbacks = function () {
            this.dispatcher.notifyAfterContentChecked();
            this.afterContentLifecycleCallbacksInternal();
        };
        AbstractChangeDetector.prototype.afterContentLifecycleCallbacksInternal = function () {};
        AbstractChangeDetector.prototype.afterViewLifecycleCallbacks = function () {
            this.dispatcher.notifyAfterViewChecked();
            this.afterViewLifecycleCallbacksInternal();
        };
        AbstractChangeDetector.prototype.afterViewLifecycleCallbacksInternal = function () {};
        /** @internal */
        AbstractChangeDetector.prototype._detectChangesContentChildren = function (throwOnChange) {
            var c = this.contentChildren;
            for (var i = 0; i < c.length; ++i) {
                c[i].runDetectChanges(throwOnChange);
            }
        };
        /** @internal */
        AbstractChangeDetector.prototype._detectChangesInViewChildren = function (throwOnChange) {
            var c = this.viewChildren;
            for (var i = 0; i < c.length; ++i) {
                c[i].runDetectChanges(throwOnChange);
            }
        };
        AbstractChangeDetector.prototype.markAsCheckOnce = function () {
            this.mode = constants_1.ChangeDetectionStrategy.CheckOnce;
        };
        AbstractChangeDetector.prototype.markPathToRootAsCheckOnce = function () {
            var c = this;
            while (lang_1.isPresent(c) && c.mode !== constants_1.ChangeDetectionStrategy.Detached) {
                if (c.mode === constants_1.ChangeDetectionStrategy.Checked) c.mode = constants_1.ChangeDetectionStrategy.CheckOnce;
                c = c.parent;
            }
        };
        AbstractChangeDetector.prototype._unsubscribeFromOutputs = function () {
            if (lang_1.isPresent(this.outputSubscriptions)) {
                for (var i = 0; i < this.outputSubscriptions.length; ++i) {
                    async_1.ObservableWrapper.dispose(this.outputSubscriptions[i]);
                    this.outputSubscriptions[i] = null;
                }
            }
        };
        AbstractChangeDetector.prototype.getDirectiveFor = function (directives, index) {
            return directives.getDirectiveFor(this.directiveIndices[index]);
        };
        AbstractChangeDetector.prototype.getDetectorFor = function (directives, index) {
            return directives.getDetectorFor(this.directiveIndices[index]);
        };
        AbstractChangeDetector.prototype.notifyDispatcher = function (value) {
            this.dispatcher.notifyOnBinding(this._currentBinding(), value);
        };
        AbstractChangeDetector.prototype.logBindingUpdate = function (value) {
            this.dispatcher.logBindingUpdate(this._currentBinding(), value);
        };
        AbstractChangeDetector.prototype.addChange = function (changes, oldValue, newValue) {
            if (lang_1.isBlank(changes)) {
                changes = {};
            }
            changes[this._currentBinding().name] = change_detection_util_1.ChangeDetectionUtil.simpleChange(oldValue, newValue);
            return changes;
        };
        AbstractChangeDetector.prototype._throwError = function (exception, stack) {
            var error;
            try {
                var c = this.dispatcher.getDebugContext(null, this._currentBinding().elementIndex, null);
                var context = lang_1.isPresent(c) ? new _Context(c.element, c.componentElement, c.context, c.locals, c.injector, this._currentBinding().debug) : null;
                error = new exceptions_1.ChangeDetectionError(this._currentBinding().debug, exception, stack, context);
            } catch (e) {
                // if an error happens during getting the debug context, we throw a ChangeDetectionError
                // without the extra information.
                error = new exceptions_1.ChangeDetectionError(null, exception, stack, null);
            }
            throw error;
        };
        AbstractChangeDetector.prototype.throwOnChangeError = function (oldValue, newValue) {
            throw new exceptions_1.ExpressionChangedAfterItHasBeenCheckedException(this._currentBinding().debug, oldValue, newValue, null);
        };
        AbstractChangeDetector.prototype.throwDehydratedError = function (detail) {
            throw new exceptions_1.DehydratedException(detail);
        };
        AbstractChangeDetector.prototype._currentBinding = function () {
            return this.bindingTargets[this.propertyBindingIndex];
        };
        return AbstractChangeDetector;
    }();
    exports.AbstractChangeDetector = AbstractChangeDetector;
});
System.registerDynamic("angular2/src/core/change_detection/proto_record.js", [], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    (function (RecordType) {
        RecordType[RecordType["Self"] = 0] = "Self";
        RecordType[RecordType["Const"] = 1] = "Const";
        RecordType[RecordType["PrimitiveOp"] = 2] = "PrimitiveOp";
        RecordType[RecordType["PropertyRead"] = 3] = "PropertyRead";
        RecordType[RecordType["PropertyWrite"] = 4] = "PropertyWrite";
        RecordType[RecordType["Local"] = 5] = "Local";
        RecordType[RecordType["InvokeMethod"] = 6] = "InvokeMethod";
        RecordType[RecordType["InvokeClosure"] = 7] = "InvokeClosure";
        RecordType[RecordType["KeyedRead"] = 8] = "KeyedRead";
        RecordType[RecordType["KeyedWrite"] = 9] = "KeyedWrite";
        RecordType[RecordType["Pipe"] = 10] = "Pipe";
        RecordType[RecordType["Interpolate"] = 11] = "Interpolate";
        RecordType[RecordType["SafeProperty"] = 12] = "SafeProperty";
        RecordType[RecordType["CollectionLiteral"] = 13] = "CollectionLiteral";
        RecordType[RecordType["SafeMethodInvoke"] = 14] = "SafeMethodInvoke";
        RecordType[RecordType["DirectiveLifecycle"] = 15] = "DirectiveLifecycle";
        RecordType[RecordType["Chain"] = 16] = "Chain";
        RecordType[RecordType["SkipRecordsIf"] = 17] = "SkipRecordsIf";
        RecordType[RecordType["SkipRecordsIfNot"] = 18] = "SkipRecordsIfNot";
        RecordType[RecordType["SkipRecords"] = 19] = "SkipRecords"; // Skip records unconditionally
    })(exports.RecordType || (exports.RecordType = {}));
    var RecordType = exports.RecordType;
    var ProtoRecord = function () {
        function ProtoRecord(mode, name, funcOrValue, args, fixedArgs, contextIndex, directiveIndex, selfIndex, bindingRecord, lastInBinding, lastInDirective, argumentToPureFunction, referencedBySelf, propertyBindingIndex) {
            this.mode = mode;
            this.name = name;
            this.funcOrValue = funcOrValue;
            this.args = args;
            this.fixedArgs = fixedArgs;
            this.contextIndex = contextIndex;
            this.directiveIndex = directiveIndex;
            this.selfIndex = selfIndex;
            this.bindingRecord = bindingRecord;
            this.lastInBinding = lastInBinding;
            this.lastInDirective = lastInDirective;
            this.argumentToPureFunction = argumentToPureFunction;
            this.referencedBySelf = referencedBySelf;
            this.propertyBindingIndex = propertyBindingIndex;
        }
        ProtoRecord.prototype.isPureFunction = function () {
            return this.mode === RecordType.Interpolate || this.mode === RecordType.CollectionLiteral;
        };
        ProtoRecord.prototype.isUsedByOtherRecord = function () {
            return !this.lastInBinding || this.referencedBySelf;
        };
        ProtoRecord.prototype.shouldBeChecked = function () {
            return this.argumentToPureFunction || this.lastInBinding || this.isPureFunction() || this.isPipeRecord();
        };
        ProtoRecord.prototype.isPipeRecord = function () {
            return this.mode === RecordType.Pipe;
        };
        ProtoRecord.prototype.isConditionalSkipRecord = function () {
            return this.mode === RecordType.SkipRecordsIfNot || this.mode === RecordType.SkipRecordsIf;
        };
        ProtoRecord.prototype.isUnconditionalSkipRecord = function () {
            return this.mode === RecordType.SkipRecords;
        };
        ProtoRecord.prototype.isSkipRecord = function () {
            return this.isConditionalSkipRecord() || this.isUnconditionalSkipRecord();
        };
        ProtoRecord.prototype.isLifeCycleRecord = function () {
            return this.mode === RecordType.DirectiveLifecycle;
        };
        return ProtoRecord;
    }();
    exports.ProtoRecord = ProtoRecord;
});
System.registerDynamic('angular2/src/core/change_detection/dynamic_change_detector.js', ['angular2/src/facade/lang.js', 'angular2/src/facade/exceptions.js', 'angular2/src/facade/collection.js', 'angular2/src/core/change_detection/abstract_change_detector.js', 'angular2/src/core/change_detection/change_detection_util.js', 'angular2/src/core/change_detection/constants.js', 'angular2/src/core/change_detection/proto_record.js', 'angular2/src/core/reflection/reflection.js', 'angular2/src/facade/async.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var exceptions_1 = $__require('angular2/src/facade/exceptions.js');
    var collection_1 = $__require('angular2/src/facade/collection.js');
    var abstract_change_detector_1 = $__require('angular2/src/core/change_detection/abstract_change_detector.js');
    var change_detection_util_1 = $__require('angular2/src/core/change_detection/change_detection_util.js');
    var constants_1 = $__require('angular2/src/core/change_detection/constants.js');
    var proto_record_1 = $__require('angular2/src/core/change_detection/proto_record.js');
    var reflection_1 = $__require('angular2/src/core/reflection/reflection.js');
    var async_1 = $__require('angular2/src/facade/async.js');
    var DynamicChangeDetector = function (_super) {
        __extends(DynamicChangeDetector, _super);
        function DynamicChangeDetector(id, numberOfPropertyProtoRecords, propertyBindingTargets, directiveIndices, strategy, _records, _eventBindings, _directiveRecords, _genConfig) {
            _super.call(this, id, numberOfPropertyProtoRecords, propertyBindingTargets, directiveIndices, strategy);
            this._records = _records;
            this._eventBindings = _eventBindings;
            this._directiveRecords = _directiveRecords;
            this._genConfig = _genConfig;
            var len = _records.length + 1;
            this.values = collection_1.ListWrapper.createFixedSize(len);
            this.localPipes = collection_1.ListWrapper.createFixedSize(len);
            this.prevContexts = collection_1.ListWrapper.createFixedSize(len);
            this.changes = collection_1.ListWrapper.createFixedSize(len);
            this.dehydrateDirectives(false);
        }
        DynamicChangeDetector.prototype.handleEventInternal = function (eventName, elIndex, locals) {
            var _this = this;
            var preventDefault = false;
            this._matchingEventBindings(eventName, elIndex).forEach(function (rec) {
                var res = _this._processEventBinding(rec, locals);
                if (res === false) {
                    preventDefault = true;
                }
            });
            return preventDefault;
        };
        /** @internal */
        DynamicChangeDetector.prototype._processEventBinding = function (eb, locals) {
            var values = collection_1.ListWrapper.createFixedSize(eb.records.length);
            values[0] = this.values[0];
            for (var protoIdx = 0; protoIdx < eb.records.length; ++protoIdx) {
                var proto = eb.records[protoIdx];
                if (proto.isSkipRecord()) {
                    protoIdx += this._computeSkipLength(protoIdx, proto, values);
                } else {
                    if (proto.lastInBinding) {
                        this._markPathAsCheckOnce(proto);
                    }
                    var res = this._calculateCurrValue(proto, values, locals);
                    if (proto.lastInBinding) {
                        return res;
                    } else {
                        this._writeSelf(proto, res, values);
                    }
                }
            }
            throw new exceptions_1.BaseException("Cannot be reached");
        };
        DynamicChangeDetector.prototype._computeSkipLength = function (protoIndex, proto, values) {
            if (proto.mode === proto_record_1.RecordType.SkipRecords) {
                return proto.fixedArgs[0] - protoIndex - 1;
            }
            if (proto.mode === proto_record_1.RecordType.SkipRecordsIf) {
                var condition = this._readContext(proto, values);
                return condition ? proto.fixedArgs[0] - protoIndex - 1 : 0;
            }
            if (proto.mode === proto_record_1.RecordType.SkipRecordsIfNot) {
                var condition = this._readContext(proto, values);
                return condition ? 0 : proto.fixedArgs[0] - protoIndex - 1;
            }
            throw new exceptions_1.BaseException("Cannot be reached");
        };
        /** @internal */
        DynamicChangeDetector.prototype._markPathAsCheckOnce = function (proto) {
            if (!proto.bindingRecord.isDefaultChangeDetection()) {
                var dir = proto.bindingRecord.directiveRecord;
                this._getDetectorFor(dir.directiveIndex).markPathToRootAsCheckOnce();
            }
        };
        /** @internal */
        DynamicChangeDetector.prototype._matchingEventBindings = function (eventName, elIndex) {
            return this._eventBindings.filter(function (eb) {
                return eb.eventName == eventName && eb.elIndex === elIndex;
            });
        };
        DynamicChangeDetector.prototype.hydrateDirectives = function (dispatcher) {
            var _this = this;
            this.values[0] = this.context;
            this.dispatcher = dispatcher;
            this.outputSubscriptions = [];
            for (var i = 0; i < this._directiveRecords.length; ++i) {
                var r = this._directiveRecords[i];
                if (lang_1.isPresent(r.outputs)) {
                    r.outputs.forEach(function (output) {
                        var eventHandler = _this._createEventHandler(r.directiveIndex.elementIndex, output[1]);
                        var directive = _this._getDirectiveFor(r.directiveIndex);
                        var getter = reflection_1.reflector.getter(output[0]);
                        _this.outputSubscriptions.push(async_1.ObservableWrapper.subscribe(getter(directive), eventHandler));
                    });
                }
            }
        };
        DynamicChangeDetector.prototype._createEventHandler = function (boundElementIndex, eventName) {
            var _this = this;
            return function (event) {
                return _this.handleEvent(eventName, boundElementIndex, event);
            };
        };
        DynamicChangeDetector.prototype.dehydrateDirectives = function (destroyPipes) {
            if (destroyPipes) {
                this._destroyPipes();
                this._destroyDirectives();
            }
            this.values[0] = null;
            collection_1.ListWrapper.fill(this.values, change_detection_util_1.ChangeDetectionUtil.uninitialized, 1);
            collection_1.ListWrapper.fill(this.changes, false);
            collection_1.ListWrapper.fill(this.localPipes, null);
            collection_1.ListWrapper.fill(this.prevContexts, change_detection_util_1.ChangeDetectionUtil.uninitialized);
        };
        /** @internal */
        DynamicChangeDetector.prototype._destroyPipes = function () {
            for (var i = 0; i < this.localPipes.length; ++i) {
                if (lang_1.isPresent(this.localPipes[i])) {
                    change_detection_util_1.ChangeDetectionUtil.callPipeOnDestroy(this.localPipes[i]);
                }
            }
        };
        /** @internal */
        DynamicChangeDetector.prototype._destroyDirectives = function () {
            for (var i = 0; i < this._directiveRecords.length; ++i) {
                var record = this._directiveRecords[i];
                if (record.callOnDestroy) {
                    this._getDirectiveFor(record.directiveIndex).ngOnDestroy();
                }
            }
        };
        DynamicChangeDetector.prototype.checkNoChanges = function () {
            this.runDetectChanges(true);
        };
        DynamicChangeDetector.prototype.detectChangesInRecordsInternal = function (throwOnChange) {
            var protos = this._records;
            var changes = null;
            var isChanged = false;
            for (var protoIdx = 0; protoIdx < protos.length; ++protoIdx) {
                var proto = protos[protoIdx];
                var bindingRecord = proto.bindingRecord;
                var directiveRecord = bindingRecord.directiveRecord;
                if (this._firstInBinding(proto)) {
                    this.propertyBindingIndex = proto.propertyBindingIndex;
                }
                if (proto.isLifeCycleRecord()) {
                    if (proto.name === "DoCheck" && !throwOnChange) {
                        this._getDirectiveFor(directiveRecord.directiveIndex).ngDoCheck();
                    } else if (proto.name === "OnInit" && !throwOnChange && this.state == constants_1.ChangeDetectorState.NeverChecked) {
                        this._getDirectiveFor(directiveRecord.directiveIndex).ngOnInit();
                    } else if (proto.name === "OnChanges" && lang_1.isPresent(changes) && !throwOnChange) {
                        this._getDirectiveFor(directiveRecord.directiveIndex).ngOnChanges(changes);
                    }
                } else if (proto.isSkipRecord()) {
                    protoIdx += this._computeSkipLength(protoIdx, proto, this.values);
                } else {
                    var change = this._check(proto, throwOnChange, this.values, this.locals);
                    if (lang_1.isPresent(change)) {
                        this._updateDirectiveOrElement(change, bindingRecord);
                        isChanged = true;
                        changes = this._addChange(bindingRecord, change, changes);
                    }
                }
                if (proto.lastInDirective) {
                    changes = null;
                    if (isChanged && !bindingRecord.isDefaultChangeDetection()) {
                        this._getDetectorFor(directiveRecord.directiveIndex).markAsCheckOnce();
                    }
                    isChanged = false;
                }
            }
        };
        /** @internal */
        DynamicChangeDetector.prototype._firstInBinding = function (r) {
            var prev = change_detection_util_1.ChangeDetectionUtil.protoByIndex(this._records, r.selfIndex - 1);
            return lang_1.isBlank(prev) || prev.bindingRecord !== r.bindingRecord;
        };
        DynamicChangeDetector.prototype.afterContentLifecycleCallbacksInternal = function () {
            var dirs = this._directiveRecords;
            for (var i = dirs.length - 1; i >= 0; --i) {
                var dir = dirs[i];
                if (dir.callAfterContentInit && this.state == constants_1.ChangeDetectorState.NeverChecked) {
                    this._getDirectiveFor(dir.directiveIndex).ngAfterContentInit();
                }
                if (dir.callAfterContentChecked) {
                    this._getDirectiveFor(dir.directiveIndex).ngAfterContentChecked();
                }
            }
        };
        DynamicChangeDetector.prototype.afterViewLifecycleCallbacksInternal = function () {
            var dirs = this._directiveRecords;
            for (var i = dirs.length - 1; i >= 0; --i) {
                var dir = dirs[i];
                if (dir.callAfterViewInit && this.state == constants_1.ChangeDetectorState.NeverChecked) {
                    this._getDirectiveFor(dir.directiveIndex).ngAfterViewInit();
                }
                if (dir.callAfterViewChecked) {
                    this._getDirectiveFor(dir.directiveIndex).ngAfterViewChecked();
                }
            }
        };
        /** @internal */
        DynamicChangeDetector.prototype._updateDirectiveOrElement = function (change, bindingRecord) {
            if (lang_1.isBlank(bindingRecord.directiveRecord)) {
                _super.prototype.notifyDispatcher.call(this, change.currentValue);
            } else {
                var directiveIndex = bindingRecord.directiveRecord.directiveIndex;
                bindingRecord.setter(this._getDirectiveFor(directiveIndex), change.currentValue);
            }
            if (this._genConfig.logBindingUpdate) {
                _super.prototype.logBindingUpdate.call(this, change.currentValue);
            }
        };
        /** @internal */
        DynamicChangeDetector.prototype._addChange = function (bindingRecord, change, changes) {
            if (bindingRecord.callOnChanges()) {
                return _super.prototype.addChange.call(this, changes, change.previousValue, change.currentValue);
            } else {
                return changes;
            }
        };
        /** @internal */
        DynamicChangeDetector.prototype._getDirectiveFor = function (directiveIndex) {
            return this.dispatcher.getDirectiveFor(directiveIndex);
        };
        /** @internal */
        DynamicChangeDetector.prototype._getDetectorFor = function (directiveIndex) {
            return this.dispatcher.getDetectorFor(directiveIndex);
        };
        /** @internal */
        DynamicChangeDetector.prototype._check = function (proto, throwOnChange, values, locals) {
            if (proto.isPipeRecord()) {
                return this._pipeCheck(proto, throwOnChange, values);
            } else {
                return this._referenceCheck(proto, throwOnChange, values, locals);
            }
        };
        /** @internal */
        DynamicChangeDetector.prototype._referenceCheck = function (proto, throwOnChange, values, locals) {
            if (this._pureFuncAndArgsDidNotChange(proto)) {
                this._setChanged(proto, false);
                return null;
            }
            var currValue = this._calculateCurrValue(proto, values, locals);
            if (proto.shouldBeChecked()) {
                var prevValue = this._readSelf(proto, values);
                var detectedChange = throwOnChange ? !change_detection_util_1.ChangeDetectionUtil.devModeEqual(prevValue, currValue) : change_detection_util_1.ChangeDetectionUtil.looseNotIdentical(prevValue, currValue);
                if (detectedChange) {
                    if (proto.lastInBinding) {
                        var change = change_detection_util_1.ChangeDetectionUtil.simpleChange(prevValue, currValue);
                        if (throwOnChange) this.throwOnChangeError(prevValue, currValue);
                        this._writeSelf(proto, currValue, values);
                        this._setChanged(proto, true);
                        return change;
                    } else {
                        this._writeSelf(proto, currValue, values);
                        this._setChanged(proto, true);
                        return null;
                    }
                } else {
                    this._setChanged(proto, false);
                    return null;
                }
            } else {
                this._writeSelf(proto, currValue, values);
                this._setChanged(proto, true);
                return null;
            }
        };
        DynamicChangeDetector.prototype._calculateCurrValue = function (proto, values, locals) {
            switch (proto.mode) {
                case proto_record_1.RecordType.Self:
                    return this._readContext(proto, values);
                case proto_record_1.RecordType.Const:
                    return proto.funcOrValue;
                case proto_record_1.RecordType.PropertyRead:
                    var context = this._readContext(proto, values);
                    return proto.funcOrValue(context);
                case proto_record_1.RecordType.SafeProperty:
                    var context = this._readContext(proto, values);
                    return lang_1.isBlank(context) ? null : proto.funcOrValue(context);
                case proto_record_1.RecordType.PropertyWrite:
                    var context = this._readContext(proto, values);
                    var value = this._readArgs(proto, values)[0];
                    proto.funcOrValue(context, value);
                    return value;
                case proto_record_1.RecordType.KeyedWrite:
                    var context = this._readContext(proto, values);
                    var key = this._readArgs(proto, values)[0];
                    var value = this._readArgs(proto, values)[1];
                    context[key] = value;
                    return value;
                case proto_record_1.RecordType.Local:
                    return locals.get(proto.name);
                case proto_record_1.RecordType.InvokeMethod:
                    var context = this._readContext(proto, values);
                    var args = this._readArgs(proto, values);
                    return proto.funcOrValue(context, args);
                case proto_record_1.RecordType.SafeMethodInvoke:
                    var context = this._readContext(proto, values);
                    if (lang_1.isBlank(context)) {
                        return null;
                    }
                    var args = this._readArgs(proto, values);
                    return proto.funcOrValue(context, args);
                case proto_record_1.RecordType.KeyedRead:
                    var arg = this._readArgs(proto, values)[0];
                    return this._readContext(proto, values)[arg];
                case proto_record_1.RecordType.Chain:
                    var args = this._readArgs(proto, values);
                    return args[args.length - 1];
                case proto_record_1.RecordType.InvokeClosure:
                    return lang_1.FunctionWrapper.apply(this._readContext(proto, values), this._readArgs(proto, values));
                case proto_record_1.RecordType.Interpolate:
                case proto_record_1.RecordType.PrimitiveOp:
                case proto_record_1.RecordType.CollectionLiteral:
                    return lang_1.FunctionWrapper.apply(proto.funcOrValue, this._readArgs(proto, values));
                default:
                    throw new exceptions_1.BaseException("Unknown operation " + proto.mode);
            }
        };
        DynamicChangeDetector.prototype._pipeCheck = function (proto, throwOnChange, values) {
            var context = this._readContext(proto, values);
            var selectedPipe = this._pipeFor(proto, context);
            if (!selectedPipe.pure || this._argsOrContextChanged(proto)) {
                var args = this._readArgs(proto, values);
                var currValue = selectedPipe.pipe.transform(context, args);
                if (proto.shouldBeChecked()) {
                    var prevValue = this._readSelf(proto, values);
                    var detectedChange = throwOnChange ? !change_detection_util_1.ChangeDetectionUtil.devModeEqual(prevValue, currValue) : change_detection_util_1.ChangeDetectionUtil.looseNotIdentical(prevValue, currValue);
                    if (detectedChange) {
                        currValue = change_detection_util_1.ChangeDetectionUtil.unwrapValue(currValue);
                        if (proto.lastInBinding) {
                            var change = change_detection_util_1.ChangeDetectionUtil.simpleChange(prevValue, currValue);
                            if (throwOnChange) this.throwOnChangeError(prevValue, currValue);
                            this._writeSelf(proto, currValue, values);
                            this._setChanged(proto, true);
                            return change;
                        } else {
                            this._writeSelf(proto, currValue, values);
                            this._setChanged(proto, true);
                            return null;
                        }
                    } else {
                        this._setChanged(proto, false);
                        return null;
                    }
                } else {
                    this._writeSelf(proto, currValue, values);
                    this._setChanged(proto, true);
                    return null;
                }
            }
        };
        DynamicChangeDetector.prototype._pipeFor = function (proto, context) {
            var storedPipe = this._readPipe(proto);
            if (lang_1.isPresent(storedPipe)) return storedPipe;
            var pipe = this.pipes.get(proto.name);
            this._writePipe(proto, pipe);
            return pipe;
        };
        DynamicChangeDetector.prototype._readContext = function (proto, values) {
            if (proto.contextIndex == -1) {
                return this._getDirectiveFor(proto.directiveIndex);
            }
            return values[proto.contextIndex];
        };
        DynamicChangeDetector.prototype._readSelf = function (proto, values) {
            return values[proto.selfIndex];
        };
        DynamicChangeDetector.prototype._writeSelf = function (proto, value, values) {
            values[proto.selfIndex] = value;
        };
        DynamicChangeDetector.prototype._readPipe = function (proto) {
            return this.localPipes[proto.selfIndex];
        };
        DynamicChangeDetector.prototype._writePipe = function (proto, value) {
            this.localPipes[proto.selfIndex] = value;
        };
        DynamicChangeDetector.prototype._setChanged = function (proto, value) {
            if (proto.argumentToPureFunction) this.changes[proto.selfIndex] = value;
        };
        DynamicChangeDetector.prototype._pureFuncAndArgsDidNotChange = function (proto) {
            return proto.isPureFunction() && !this._argsChanged(proto);
        };
        DynamicChangeDetector.prototype._argsChanged = function (proto) {
            var args = proto.args;
            for (var i = 0; i < args.length; ++i) {
                if (this.changes[args[i]]) {
                    return true;
                }
            }
            return false;
        };
        DynamicChangeDetector.prototype._argsOrContextChanged = function (proto) {
            return this._argsChanged(proto) || this.changes[proto.contextIndex];
        };
        DynamicChangeDetector.prototype._readArgs = function (proto, values) {
            var res = collection_1.ListWrapper.createFixedSize(proto.args.length);
            var args = proto.args;
            for (var i = 0; i < args.length; ++i) {
                res[i] = values[args[i]];
            }
            return res;
        };
        return DynamicChangeDetector;
    }(abstract_change_detector_1.AbstractChangeDetector);
    exports.DynamicChangeDetector = DynamicChangeDetector;
});
System.registerDynamic('angular2/src/core/change_detection/change_detector_ref.js', ['angular2/src/core/change_detection/constants.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var constants_1 = $__require('angular2/src/core/change_detection/constants.js');
    var ChangeDetectorRef = function () {
        function ChangeDetectorRef() {}
        return ChangeDetectorRef;
    }();
    exports.ChangeDetectorRef = ChangeDetectorRef;
    var ChangeDetectorRef_ = function (_super) {
        __extends(ChangeDetectorRef_, _super);
        function ChangeDetectorRef_(_cd) {
            _super.call(this);
            this._cd = _cd;
        }
        ChangeDetectorRef_.prototype.markForCheck = function () {
            this._cd.markPathToRootAsCheckOnce();
        };
        ChangeDetectorRef_.prototype.detach = function () {
            this._cd.mode = constants_1.ChangeDetectionStrategy.Detached;
        };
        ChangeDetectorRef_.prototype.detectChanges = function () {
            this._cd.detectChanges();
        };
        ChangeDetectorRef_.prototype.checkNoChanges = function () {
            this._cd.checkNoChanges();
        };
        ChangeDetectorRef_.prototype.reattach = function () {
            this._cd.mode = constants_1.ChangeDetectionStrategy.CheckAlways;
            this.markForCheck();
        };
        return ChangeDetectorRef_;
    }(ChangeDetectorRef);
    exports.ChangeDetectorRef_ = ChangeDetectorRef_;
});
System.registerDynamic("angular2/src/core/change_detection/pipe_lifecycle_reflector.js", [], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    function implementsOnDestroy(pipe) {
        return pipe.constructor.prototype.ngOnDestroy;
    }
    exports.implementsOnDestroy = implementsOnDestroy;
});
System.registerDynamic('angular2/src/core/change_detection/binding_record.js', ['angular2/src/facade/lang.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var DIRECTIVE_LIFECYCLE = "directiveLifecycle";
    var BINDING = "native";
    var DIRECTIVE = "directive";
    var ELEMENT_PROPERTY = "elementProperty";
    var ELEMENT_ATTRIBUTE = "elementAttribute";
    var ELEMENT_CLASS = "elementClass";
    var ELEMENT_STYLE = "elementStyle";
    var TEXT_NODE = "textNode";
    var EVENT = "event";
    var HOST_EVENT = "hostEvent";
    var BindingTarget = function () {
        function BindingTarget(mode, elementIndex, name, unit, debug) {
            this.mode = mode;
            this.elementIndex = elementIndex;
            this.name = name;
            this.unit = unit;
            this.debug = debug;
        }
        BindingTarget.prototype.isDirective = function () {
            return this.mode === DIRECTIVE;
        };
        BindingTarget.prototype.isElementProperty = function () {
            return this.mode === ELEMENT_PROPERTY;
        };
        BindingTarget.prototype.isElementAttribute = function () {
            return this.mode === ELEMENT_ATTRIBUTE;
        };
        BindingTarget.prototype.isElementClass = function () {
            return this.mode === ELEMENT_CLASS;
        };
        BindingTarget.prototype.isElementStyle = function () {
            return this.mode === ELEMENT_STYLE;
        };
        BindingTarget.prototype.isTextNode = function () {
            return this.mode === TEXT_NODE;
        };
        return BindingTarget;
    }();
    exports.BindingTarget = BindingTarget;
    var BindingRecord = function () {
        function BindingRecord(mode, target, implicitReceiver, ast, setter, lifecycleEvent, directiveRecord) {
            this.mode = mode;
            this.target = target;
            this.implicitReceiver = implicitReceiver;
            this.ast = ast;
            this.setter = setter;
            this.lifecycleEvent = lifecycleEvent;
            this.directiveRecord = directiveRecord;
        }
        BindingRecord.prototype.isDirectiveLifecycle = function () {
            return this.mode === DIRECTIVE_LIFECYCLE;
        };
        BindingRecord.prototype.callOnChanges = function () {
            return lang_1.isPresent(this.directiveRecord) && this.directiveRecord.callOnChanges;
        };
        BindingRecord.prototype.isDefaultChangeDetection = function () {
            return lang_1.isBlank(this.directiveRecord) || this.directiveRecord.isDefaultChangeDetection();
        };
        BindingRecord.createDirectiveDoCheck = function (directiveRecord) {
            return new BindingRecord(DIRECTIVE_LIFECYCLE, null, 0, null, null, "DoCheck", directiveRecord);
        };
        BindingRecord.createDirectiveOnInit = function (directiveRecord) {
            return new BindingRecord(DIRECTIVE_LIFECYCLE, null, 0, null, null, "OnInit", directiveRecord);
        };
        BindingRecord.createDirectiveOnChanges = function (directiveRecord) {
            return new BindingRecord(DIRECTIVE_LIFECYCLE, null, 0, null, null, "OnChanges", directiveRecord);
        };
        BindingRecord.createForDirective = function (ast, propertyName, setter, directiveRecord) {
            var elementIndex = directiveRecord.directiveIndex.elementIndex;
            var t = new BindingTarget(DIRECTIVE, elementIndex, propertyName, null, ast.toString());
            return new BindingRecord(DIRECTIVE, t, 0, ast, setter, null, directiveRecord);
        };
        BindingRecord.createForElementProperty = function (ast, elementIndex, propertyName) {
            var t = new BindingTarget(ELEMENT_PROPERTY, elementIndex, propertyName, null, ast.toString());
            return new BindingRecord(BINDING, t, 0, ast, null, null, null);
        };
        BindingRecord.createForElementAttribute = function (ast, elementIndex, attributeName) {
            var t = new BindingTarget(ELEMENT_ATTRIBUTE, elementIndex, attributeName, null, ast.toString());
            return new BindingRecord(BINDING, t, 0, ast, null, null, null);
        };
        BindingRecord.createForElementClass = function (ast, elementIndex, className) {
            var t = new BindingTarget(ELEMENT_CLASS, elementIndex, className, null, ast.toString());
            return new BindingRecord(BINDING, t, 0, ast, null, null, null);
        };
        BindingRecord.createForElementStyle = function (ast, elementIndex, styleName, unit) {
            var t = new BindingTarget(ELEMENT_STYLE, elementIndex, styleName, unit, ast.toString());
            return new BindingRecord(BINDING, t, 0, ast, null, null, null);
        };
        BindingRecord.createForHostProperty = function (directiveIndex, ast, propertyName) {
            var t = new BindingTarget(ELEMENT_PROPERTY, directiveIndex.elementIndex, propertyName, null, ast.toString());
            return new BindingRecord(BINDING, t, directiveIndex, ast, null, null, null);
        };
        BindingRecord.createForHostAttribute = function (directiveIndex, ast, attributeName) {
            var t = new BindingTarget(ELEMENT_ATTRIBUTE, directiveIndex.elementIndex, attributeName, null, ast.toString());
            return new BindingRecord(BINDING, t, directiveIndex, ast, null, null, null);
        };
        BindingRecord.createForHostClass = function (directiveIndex, ast, className) {
            var t = new BindingTarget(ELEMENT_CLASS, directiveIndex.elementIndex, className, null, ast.toString());
            return new BindingRecord(BINDING, t, directiveIndex, ast, null, null, null);
        };
        BindingRecord.createForHostStyle = function (directiveIndex, ast, styleName, unit) {
            var t = new BindingTarget(ELEMENT_STYLE, directiveIndex.elementIndex, styleName, unit, ast.toString());
            return new BindingRecord(BINDING, t, directiveIndex, ast, null, null, null);
        };
        BindingRecord.createForTextNode = function (ast, elementIndex) {
            var t = new BindingTarget(TEXT_NODE, elementIndex, null, null, ast.toString());
            return new BindingRecord(BINDING, t, 0, ast, null, null, null);
        };
        BindingRecord.createForEvent = function (ast, eventName, elementIndex) {
            var t = new BindingTarget(EVENT, elementIndex, eventName, null, ast.toString());
            return new BindingRecord(EVENT, t, 0, ast, null, null, null);
        };
        BindingRecord.createForHostEvent = function (ast, eventName, directiveRecord) {
            var directiveIndex = directiveRecord.directiveIndex;
            var t = new BindingTarget(HOST_EVENT, directiveIndex.elementIndex, eventName, null, ast.toString());
            return new BindingRecord(HOST_EVENT, t, directiveIndex, ast, null, null, directiveRecord);
        };
        return BindingRecord;
    }();
    exports.BindingRecord = BindingRecord;
});
System.registerDynamic('angular2/src/core/change_detection/constants.js', ['angular2/src/facade/lang.js'], true, function ($__require, exports, module) {
  'use strict';"use strict";

  var global = this || self,
      GLOBAL = global;
  var lang_1 = $__require('angular2/src/facade/lang.js');
  /**
   * Describes the current state of the change detector.
   */
  (function (ChangeDetectorState) {
    /**
     * `NeverChecked` means that the change detector has not been checked yet, and
     * initialization methods should be called during detection.
     */
    ChangeDetectorState[ChangeDetectorState["NeverChecked"] = 0] = "NeverChecked";
    /**
     * `CheckedBefore` means that the change detector has successfully completed at least
     * one detection previously.
     */
    ChangeDetectorState[ChangeDetectorState["CheckedBefore"] = 1] = "CheckedBefore";
    /**
     * `Errored` means that the change detector encountered an error checking a binding
     * or calling a directive lifecycle method and is now in an inconsistent state. Change
     * detectors in this state will no longer detect changes.
     */
    ChangeDetectorState[ChangeDetectorState["Errored"] = 2] = "Errored";
  })(exports.ChangeDetectorState || (exports.ChangeDetectorState = {}));
  var ChangeDetectorState = exports.ChangeDetectorState;
  /**
   * Describes within the change detector which strategy will be used the next time change
   * detection is triggered.
   */
  (function (ChangeDetectionStrategy) {
    /**
     * `CheckedOnce` means that after calling detectChanges the mode of the change detector
     * will become `Checked`.
     */
    ChangeDetectionStrategy[ChangeDetectionStrategy["CheckOnce"] = 0] = "CheckOnce";
    /**
     * `Checked` means that the change detector should be skipped until its mode changes to
     * `CheckOnce`.
     */
    ChangeDetectionStrategy[ChangeDetectionStrategy["Checked"] = 1] = "Checked";
    /**
     * `CheckAlways` means that after calling detectChanges the mode of the change detector
     * will remain `CheckAlways`.
     */
    ChangeDetectionStrategy[ChangeDetectionStrategy["CheckAlways"] = 2] = "CheckAlways";
    /**
     * `Detached` means that the change detector sub tree is not a part of the main tree and
     * should be skipped.
     */
    ChangeDetectionStrategy[ChangeDetectionStrategy["Detached"] = 3] = "Detached";
    /**
     * `OnPush` means that the change detector's mode will be set to `CheckOnce` during hydration.
     */
    ChangeDetectionStrategy[ChangeDetectionStrategy["OnPush"] = 4] = "OnPush";
    /**
     * `Default` means that the change detector's mode will be set to `CheckAlways` during hydration.
     */
    ChangeDetectionStrategy[ChangeDetectionStrategy["Default"] = 5] = "Default";
  })(exports.ChangeDetectionStrategy || (exports.ChangeDetectionStrategy = {}));
  var ChangeDetectionStrategy = exports.ChangeDetectionStrategy;
  /**
   * List of possible {@link ChangeDetectionStrategy} values.
   */
  exports.CHANGE_DETECTION_STRATEGY_VALUES = [ChangeDetectionStrategy.CheckOnce, ChangeDetectionStrategy.Checked, ChangeDetectionStrategy.CheckAlways, ChangeDetectionStrategy.Detached, ChangeDetectionStrategy.OnPush, ChangeDetectionStrategy.Default];
  /**
   * List of possible {@link ChangeDetectorState} values.
   */
  exports.CHANGE_DETECTOR_STATE_VALUES = [ChangeDetectorState.NeverChecked, ChangeDetectorState.CheckedBefore, ChangeDetectorState.Errored];
  function isDefaultChangeDetectionStrategy(changeDetectionStrategy) {
    return lang_1.isBlank(changeDetectionStrategy) || changeDetectionStrategy === ChangeDetectionStrategy.Default;
  }
  exports.isDefaultChangeDetectionStrategy = isDefaultChangeDetectionStrategy;
});
System.registerDynamic('angular2/src/core/change_detection/directive_record.js', ['angular2/src/facade/lang.js', 'angular2/src/core/change_detection/constants.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var constants_1 = $__require('angular2/src/core/change_detection/constants.js');
    var DirectiveIndex = function () {
        function DirectiveIndex(elementIndex, directiveIndex) {
            this.elementIndex = elementIndex;
            this.directiveIndex = directiveIndex;
        }
        Object.defineProperty(DirectiveIndex.prototype, "name", {
            get: function () {
                return this.elementIndex + "_" + this.directiveIndex;
            },
            enumerable: true,
            configurable: true
        });
        return DirectiveIndex;
    }();
    exports.DirectiveIndex = DirectiveIndex;
    var DirectiveRecord = function () {
        function DirectiveRecord(_a) {
            var _b = _a === void 0 ? {} : _a,
                directiveIndex = _b.directiveIndex,
                callAfterContentInit = _b.callAfterContentInit,
                callAfterContentChecked = _b.callAfterContentChecked,
                callAfterViewInit = _b.callAfterViewInit,
                callAfterViewChecked = _b.callAfterViewChecked,
                callOnChanges = _b.callOnChanges,
                callDoCheck = _b.callDoCheck,
                callOnInit = _b.callOnInit,
                callOnDestroy = _b.callOnDestroy,
                changeDetection = _b.changeDetection,
                outputs = _b.outputs;
            this.directiveIndex = directiveIndex;
            this.callAfterContentInit = lang_1.normalizeBool(callAfterContentInit);
            this.callAfterContentChecked = lang_1.normalizeBool(callAfterContentChecked);
            this.callOnChanges = lang_1.normalizeBool(callOnChanges);
            this.callAfterViewInit = lang_1.normalizeBool(callAfterViewInit);
            this.callAfterViewChecked = lang_1.normalizeBool(callAfterViewChecked);
            this.callDoCheck = lang_1.normalizeBool(callDoCheck);
            this.callOnInit = lang_1.normalizeBool(callOnInit);
            this.callOnDestroy = lang_1.normalizeBool(callOnDestroy);
            this.changeDetection = changeDetection;
            this.outputs = outputs;
        }
        DirectiveRecord.prototype.isDefaultChangeDetection = function () {
            return constants_1.isDefaultChangeDetectionStrategy(this.changeDetection);
        };
        return DirectiveRecord;
    }();
    exports.DirectiveRecord = DirectiveRecord;
});
System.registerDynamic('angular2/src/core/change_detection/change_detection_util.js', ['angular2/src/facade/lang.js', 'angular2/src/facade/exceptions.js', 'angular2/src/facade/collection.js', 'angular2/src/core/change_detection/constants.js', 'angular2/src/core/change_detection/pipe_lifecycle_reflector.js', 'angular2/src/core/change_detection/binding_record.js', 'angular2/src/core/change_detection/directive_record.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var exceptions_1 = $__require('angular2/src/facade/exceptions.js');
    var collection_1 = $__require('angular2/src/facade/collection.js');
    var constants_1 = $__require('angular2/src/core/change_detection/constants.js');
    var pipe_lifecycle_reflector_1 = $__require('angular2/src/core/change_detection/pipe_lifecycle_reflector.js');
    var binding_record_1 = $__require('angular2/src/core/change_detection/binding_record.js');
    var directive_record_1 = $__require('angular2/src/core/change_detection/directive_record.js');
    /**
     * Indicates that the result of a {@link PipeMetadata} transformation has changed even though the
     * reference
     * has not changed.
     *
     * The wrapped value will be unwrapped by change detection, and the unwrapped value will be stored.
     *
     * Example:
     *
     * ```
     * if (this._latestValue === this._latestReturnedValue) {
     *    return this._latestReturnedValue;
     *  } else {
     *    this._latestReturnedValue = this._latestValue;
     *    return WrappedValue.wrap(this._latestValue); // this will force update
     *  }
     * ```
     */
    var WrappedValue = function () {
        function WrappedValue(wrapped) {
            this.wrapped = wrapped;
        }
        WrappedValue.wrap = function (value) {
            var w = _wrappedValues[_wrappedIndex++ % 5];
            w.wrapped = value;
            return w;
        };
        return WrappedValue;
    }();
    exports.WrappedValue = WrappedValue;
    var _wrappedValues = [new WrappedValue(null), new WrappedValue(null), new WrappedValue(null), new WrappedValue(null), new WrappedValue(null)];
    var _wrappedIndex = 0;
    /**
     * Represents a basic change from a previous to a new value.
     */
    var SimpleChange = function () {
        function SimpleChange(previousValue, currentValue) {
            this.previousValue = previousValue;
            this.currentValue = currentValue;
        }
        /**
         * Check whether the new value is the first value assigned.
         */
        SimpleChange.prototype.isFirstChange = function () {
            return this.previousValue === ChangeDetectionUtil.uninitialized;
        };
        return SimpleChange;
    }();
    exports.SimpleChange = SimpleChange;
    function _simpleChange(previousValue, currentValue) {
        return new SimpleChange(previousValue, currentValue);
    }
    /* tslint:disable:requireParameterType */
    var ChangeDetectionUtil = function () {
        function ChangeDetectionUtil() {}
        ChangeDetectionUtil.arrayFn0 = function () {
            return [];
        };
        ChangeDetectionUtil.arrayFn1 = function (a1) {
            return [a1];
        };
        ChangeDetectionUtil.arrayFn2 = function (a1, a2) {
            return [a1, a2];
        };
        ChangeDetectionUtil.arrayFn3 = function (a1, a2, a3) {
            return [a1, a2, a3];
        };
        ChangeDetectionUtil.arrayFn4 = function (a1, a2, a3, a4) {
            return [a1, a2, a3, a4];
        };
        ChangeDetectionUtil.arrayFn5 = function (a1, a2, a3, a4, a5) {
            return [a1, a2, a3, a4, a5];
        };
        ChangeDetectionUtil.arrayFn6 = function (a1, a2, a3, a4, a5, a6) {
            return [a1, a2, a3, a4, a5, a6];
        };
        ChangeDetectionUtil.arrayFn7 = function (a1, a2, a3, a4, a5, a6, a7) {
            return [a1, a2, a3, a4, a5, a6, a7];
        };
        ChangeDetectionUtil.arrayFn8 = function (a1, a2, a3, a4, a5, a6, a7, a8) {
            return [a1, a2, a3, a4, a5, a6, a7, a8];
        };
        ChangeDetectionUtil.arrayFn9 = function (a1, a2, a3, a4, a5, a6, a7, a8, a9) {
            return [a1, a2, a3, a4, a5, a6, a7, a8, a9];
        };
        ChangeDetectionUtil.operation_negate = function (value) {
            return !value;
        };
        ChangeDetectionUtil.operation_add = function (left, right) {
            return left + right;
        };
        ChangeDetectionUtil.operation_subtract = function (left, right) {
            return left - right;
        };
        ChangeDetectionUtil.operation_multiply = function (left, right) {
            return left * right;
        };
        ChangeDetectionUtil.operation_divide = function (left, right) {
            return left / right;
        };
        ChangeDetectionUtil.operation_remainder = function (left, right) {
            return left % right;
        };
        ChangeDetectionUtil.operation_equals = function (left, right) {
            return left == right;
        };
        ChangeDetectionUtil.operation_not_equals = function (left, right) {
            return left != right;
        };
        ChangeDetectionUtil.operation_identical = function (left, right) {
            return left === right;
        };
        ChangeDetectionUtil.operation_not_identical = function (left, right) {
            return left !== right;
        };
        ChangeDetectionUtil.operation_less_then = function (left, right) {
            return left < right;
        };
        ChangeDetectionUtil.operation_greater_then = function (left, right) {
            return left > right;
        };
        ChangeDetectionUtil.operation_less_or_equals_then = function (left, right) {
            return left <= right;
        };
        ChangeDetectionUtil.operation_greater_or_equals_then = function (left, right) {
            return left >= right;
        };
        ChangeDetectionUtil.cond = function (cond, trueVal, falseVal) {
            return cond ? trueVal : falseVal;
        };
        ChangeDetectionUtil.mapFn = function (keys) {
            function buildMap(values) {
                var res = collection_1.StringMapWrapper.create();
                for (var i = 0; i < keys.length; ++i) {
                    collection_1.StringMapWrapper.set(res, keys[i], values[i]);
                }
                return res;
            }
            switch (keys.length) {
                case 0:
                    return function () {
                        return [];
                    };
                case 1:
                    return function (a1) {
                        return buildMap([a1]);
                    };
                case 2:
                    return function (a1, a2) {
                        return buildMap([a1, a2]);
                    };
                case 3:
                    return function (a1, a2, a3) {
                        return buildMap([a1, a2, a3]);
                    };
                case 4:
                    return function (a1, a2, a3, a4) {
                        return buildMap([a1, a2, a3, a4]);
                    };
                case 5:
                    return function (a1, a2, a3, a4, a5) {
                        return buildMap([a1, a2, a3, a4, a5]);
                    };
                case 6:
                    return function (a1, a2, a3, a4, a5, a6) {
                        return buildMap([a1, a2, a3, a4, a5, a6]);
                    };
                case 7:
                    return function (a1, a2, a3, a4, a5, a6, a7) {
                        return buildMap([a1, a2, a3, a4, a5, a6, a7]);
                    };
                case 8:
                    return function (a1, a2, a3, a4, a5, a6, a7, a8) {
                        return buildMap([a1, a2, a3, a4, a5, a6, a7, a8]);
                    };
                case 9:
                    return function (a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                        return buildMap([a1, a2, a3, a4, a5, a6, a7, a8, a9]);
                    };
                default:
                    throw new exceptions_1.BaseException("Does not support literal maps with more than 9 elements");
            }
        };
        ChangeDetectionUtil.keyedAccess = function (obj, args) {
            return obj[args[0]];
        };
        ChangeDetectionUtil.unwrapValue = function (value) {
            if (value instanceof WrappedValue) {
                return value.wrapped;
            } else {
                return value;
            }
        };
        ChangeDetectionUtil.changeDetectionMode = function (strategy) {
            return constants_1.isDefaultChangeDetectionStrategy(strategy) ? constants_1.ChangeDetectionStrategy.CheckAlways : constants_1.ChangeDetectionStrategy.CheckOnce;
        };
        ChangeDetectionUtil.simpleChange = function (previousValue, currentValue) {
            return _simpleChange(previousValue, currentValue);
        };
        ChangeDetectionUtil.isValueBlank = function (value) {
            return lang_1.isBlank(value);
        };
        ChangeDetectionUtil.s = function (value) {
            return lang_1.isPresent(value) ? "" + value : '';
        };
        ChangeDetectionUtil.protoByIndex = function (protos, selfIndex) {
            return selfIndex < 1 ? null : protos[selfIndex - 1]; // self index is shifted by one because of context
        };
        ChangeDetectionUtil.callPipeOnDestroy = function (selectedPipe) {
            if (pipe_lifecycle_reflector_1.implementsOnDestroy(selectedPipe.pipe)) {
                selectedPipe.pipe.ngOnDestroy();
            }
        };
        ChangeDetectionUtil.bindingTarget = function (mode, elementIndex, name, unit, debug) {
            return new binding_record_1.BindingTarget(mode, elementIndex, name, unit, debug);
        };
        ChangeDetectionUtil.directiveIndex = function (elementIndex, directiveIndex) {
            return new directive_record_1.DirectiveIndex(elementIndex, directiveIndex);
        };
        ChangeDetectionUtil.looseNotIdentical = function (a, b) {
            return !lang_1.looseIdentical(a, b);
        };
        ChangeDetectionUtil.devModeEqual = function (a, b) {
            if (collection_1.isListLikeIterable(a) && collection_1.isListLikeIterable(b)) {
                return collection_1.areIterablesEqual(a, b, ChangeDetectionUtil.devModeEqual);
            } else if (!collection_1.isListLikeIterable(a) && !lang_1.isPrimitive(a) && !collection_1.isListLikeIterable(b) && !lang_1.isPrimitive(b)) {
                return true;
            } else {
                return lang_1.looseIdentical(a, b);
            }
        };
        ChangeDetectionUtil.uninitialized = lang_1.CONST_EXPR(new Object());
        return ChangeDetectionUtil;
    }();
    exports.ChangeDetectionUtil = ChangeDetectionUtil;
});
System.registerDynamic('angular2/src/core/change_detection/change_detection.js', ['angular2/src/core/change_detection/differs/iterable_differs.js', 'angular2/src/core/change_detection/differs/default_iterable_differ.js', 'angular2/src/core/change_detection/differs/keyvalue_differs.js', 'angular2/src/core/change_detection/differs/default_keyvalue_differ.js', 'angular2/src/facade/lang.js', 'angular2/src/core/change_detection/parser/ast.js', 'angular2/src/core/change_detection/parser/lexer.js', 'angular2/src/core/change_detection/parser/parser.js', 'angular2/src/core/change_detection/parser/locals.js', 'angular2/src/core/change_detection/exceptions.js', 'angular2/src/core/change_detection/interfaces.js', 'angular2/src/core/change_detection/constants.js', 'angular2/src/core/change_detection/proto_change_detector.js', 'angular2/src/core/change_detection/jit_proto_change_detector.js', 'angular2/src/core/change_detection/binding_record.js', 'angular2/src/core/change_detection/directive_record.js', 'angular2/src/core/change_detection/dynamic_change_detector.js', 'angular2/src/core/change_detection/change_detector_ref.js', 'angular2/src/core/change_detection/change_detection_util.js'], true, function ($__require, exports, module) {
  'use strict';"use strict";

  var global = this || self,
      GLOBAL = global;
  var iterable_differs_1 = $__require('angular2/src/core/change_detection/differs/iterable_differs.js');
  var default_iterable_differ_1 = $__require('angular2/src/core/change_detection/differs/default_iterable_differ.js');
  var keyvalue_differs_1 = $__require('angular2/src/core/change_detection/differs/keyvalue_differs.js');
  var default_keyvalue_differ_1 = $__require('angular2/src/core/change_detection/differs/default_keyvalue_differ.js');
  var lang_1 = $__require('angular2/src/facade/lang.js');
  var default_keyvalue_differ_2 = $__require('angular2/src/core/change_detection/differs/default_keyvalue_differ.js');
  exports.DefaultKeyValueDifferFactory = default_keyvalue_differ_2.DefaultKeyValueDifferFactory;
  exports.KeyValueChangeRecord = default_keyvalue_differ_2.KeyValueChangeRecord;
  var default_iterable_differ_2 = $__require('angular2/src/core/change_detection/differs/default_iterable_differ.js');
  exports.DefaultIterableDifferFactory = default_iterable_differ_2.DefaultIterableDifferFactory;
  exports.CollectionChangeRecord = default_iterable_differ_2.CollectionChangeRecord;
  var ast_1 = $__require('angular2/src/core/change_detection/parser/ast.js');
  exports.ASTWithSource = ast_1.ASTWithSource;
  exports.AST = ast_1.AST;
  exports.AstTransformer = ast_1.AstTransformer;
  exports.PropertyRead = ast_1.PropertyRead;
  exports.LiteralArray = ast_1.LiteralArray;
  exports.ImplicitReceiver = ast_1.ImplicitReceiver;
  var lexer_1 = $__require('angular2/src/core/change_detection/parser/lexer.js');
  exports.Lexer = lexer_1.Lexer;
  var parser_1 = $__require('angular2/src/core/change_detection/parser/parser.js');
  exports.Parser = parser_1.Parser;
  var locals_1 = $__require('angular2/src/core/change_detection/parser/locals.js');
  exports.Locals = locals_1.Locals;
  var exceptions_1 = $__require('angular2/src/core/change_detection/exceptions.js');
  exports.DehydratedException = exceptions_1.DehydratedException;
  exports.ExpressionChangedAfterItHasBeenCheckedException = exceptions_1.ExpressionChangedAfterItHasBeenCheckedException;
  exports.ChangeDetectionError = exceptions_1.ChangeDetectionError;
  var interfaces_1 = $__require('angular2/src/core/change_detection/interfaces.js');
  exports.ChangeDetectorDefinition = interfaces_1.ChangeDetectorDefinition;
  exports.DebugContext = interfaces_1.DebugContext;
  exports.ChangeDetectorGenConfig = interfaces_1.ChangeDetectorGenConfig;
  var constants_1 = $__require('angular2/src/core/change_detection/constants.js');
  exports.ChangeDetectionStrategy = constants_1.ChangeDetectionStrategy;
  exports.CHANGE_DETECTION_STRATEGY_VALUES = constants_1.CHANGE_DETECTION_STRATEGY_VALUES;
  var proto_change_detector_1 = $__require('angular2/src/core/change_detection/proto_change_detector.js');
  exports.DynamicProtoChangeDetector = proto_change_detector_1.DynamicProtoChangeDetector;
  var jit_proto_change_detector_1 = $__require('angular2/src/core/change_detection/jit_proto_change_detector.js');
  exports.JitProtoChangeDetector = jit_proto_change_detector_1.JitProtoChangeDetector;
  var binding_record_1 = $__require('angular2/src/core/change_detection/binding_record.js');
  exports.BindingRecord = binding_record_1.BindingRecord;
  exports.BindingTarget = binding_record_1.BindingTarget;
  var directive_record_1 = $__require('angular2/src/core/change_detection/directive_record.js');
  exports.DirectiveIndex = directive_record_1.DirectiveIndex;
  exports.DirectiveRecord = directive_record_1.DirectiveRecord;
  var dynamic_change_detector_1 = $__require('angular2/src/core/change_detection/dynamic_change_detector.js');
  exports.DynamicChangeDetector = dynamic_change_detector_1.DynamicChangeDetector;
  var change_detector_ref_1 = $__require('angular2/src/core/change_detection/change_detector_ref.js');
  exports.ChangeDetectorRef = change_detector_ref_1.ChangeDetectorRef;
  var iterable_differs_2 = $__require('angular2/src/core/change_detection/differs/iterable_differs.js');
  exports.IterableDiffers = iterable_differs_2.IterableDiffers;
  var keyvalue_differs_2 = $__require('angular2/src/core/change_detection/differs/keyvalue_differs.js');
  exports.KeyValueDiffers = keyvalue_differs_2.KeyValueDiffers;
  var change_detection_util_1 = $__require('angular2/src/core/change_detection/change_detection_util.js');
  exports.WrappedValue = change_detection_util_1.WrappedValue;
  exports.SimpleChange = change_detection_util_1.SimpleChange;
  /**
   * Structural diffing for `Object`s and `Map`s.
   */
  exports.keyValDiff = lang_1.CONST_EXPR([lang_1.CONST_EXPR(new default_keyvalue_differ_1.DefaultKeyValueDifferFactory())]);
  /**
   * Structural diffing for `Iterable` types such as `Array`s.
   */
  exports.iterableDiff = lang_1.CONST_EXPR([lang_1.CONST_EXPR(new default_iterable_differ_1.DefaultIterableDifferFactory())]);
  exports.defaultIterableDiffers = lang_1.CONST_EXPR(new iterable_differs_1.IterableDiffers(exports.iterableDiff));
  exports.defaultKeyValueDiffers = lang_1.CONST_EXPR(new keyvalue_differs_1.KeyValueDiffers(exports.keyValDiff));
});
System.registerDynamic("angular2/src/facade/promise.js", [], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var PromiseCompleter = function () {
        function PromiseCompleter() {
            var _this = this;
            this.promise = new Promise(function (res, rej) {
                _this.resolve = res;
                _this.reject = rej;
            });
        }
        return PromiseCompleter;
    }();
    exports.PromiseCompleter = PromiseCompleter;
    var PromiseWrapper = function () {
        function PromiseWrapper() {}
        PromiseWrapper.resolve = function (obj) {
            return Promise.resolve(obj);
        };
        PromiseWrapper.reject = function (obj, _) {
            return Promise.reject(obj);
        };
        // Note: We can't rename this method into `catch`, as this is not a valid
        // method name in Dart.
        PromiseWrapper.catchError = function (promise, onError) {
            return promise.catch(onError);
        };
        PromiseWrapper.all = function (promises) {
            if (promises.length == 0) return Promise.resolve([]);
            return Promise.all(promises);
        };
        PromiseWrapper.then = function (promise, success, rejection) {
            return promise.then(success, rejection);
        };
        PromiseWrapper.wrap = function (computation) {
            return new Promise(function (res, rej) {
                try {
                    res(computation());
                } catch (e) {
                    rej(e);
                }
            });
        };
        PromiseWrapper.scheduleMicrotask = function (computation) {
            PromiseWrapper.then(PromiseWrapper.resolve(null), computation, function (_) {});
        };
        PromiseWrapper.isPromise = function (obj) {
            return obj instanceof Promise;
        };
        PromiseWrapper.completer = function () {
            return new PromiseCompleter();
        };
        return PromiseWrapper;
    }();
    exports.PromiseWrapper = PromiseWrapper;
});
System.registerDynamic('rxjs/util/ObjectUnsubscribedError.js', [], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    /**
     * An error thrown when an action is invalid because the object has been
     * unsubscribed.
     *
     * @see {@link Subject}
     * @see {@link BehaviorSubject}
     *
     * @class ObjectUnsubscribedError
     */
    var ObjectUnsubscribedError = function (_super) {
        __extends(ObjectUnsubscribedError, _super);
        function ObjectUnsubscribedError() {
            var err = _super.call(this, 'object unsubscribed');
            this.name = err.name = 'ObjectUnsubscribedError';
            this.stack = err.stack;
            this.message = err.message;
        }
        return ObjectUnsubscribedError;
    }(Error);
    exports.ObjectUnsubscribedError = ObjectUnsubscribedError;
    
});
System.registerDynamic("rxjs/SubjectSubscription.js", ["rxjs/Subscription.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Subscription_1 = $__require("rxjs/Subscription.js");
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var SubjectSubscription = function (_super) {
        __extends(SubjectSubscription, _super);
        function SubjectSubscription(subject, subscriber) {
            _super.call(this);
            this.subject = subject;
            this.subscriber = subscriber;
            this.closed = false;
        }
        SubjectSubscription.prototype.unsubscribe = function () {
            if (this.closed) {
                return;
            }
            this.closed = true;
            var subject = this.subject;
            var observers = subject.observers;
            this.subject = null;
            if (!observers || observers.length === 0 || subject.isStopped || subject.closed) {
                return;
            }
            var subscriberIndex = observers.indexOf(this.subscriber);
            if (subscriberIndex !== -1) {
                observers.splice(subscriberIndex, 1);
            }
        };
        return SubjectSubscription;
    }(Subscription_1.Subscription);
    exports.SubjectSubscription = SubjectSubscription;
    
});
System.registerDynamic('rxjs/Subject.js', ['rxjs/Observable.js', 'rxjs/Subscriber.js', 'rxjs/Subscription.js', 'rxjs/util/ObjectUnsubscribedError.js', 'rxjs/SubjectSubscription.js', 'rxjs/symbol/rxSubscriber.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var Observable_1 = $__require('rxjs/Observable.js');
    var Subscriber_1 = $__require('rxjs/Subscriber.js');
    var Subscription_1 = $__require('rxjs/Subscription.js');
    var ObjectUnsubscribedError_1 = $__require('rxjs/util/ObjectUnsubscribedError.js');
    var SubjectSubscription_1 = $__require('rxjs/SubjectSubscription.js');
    var rxSubscriber_1 = $__require('rxjs/symbol/rxSubscriber.js');
    /**
     * @class SubjectSubscriber<T>
     */
    var SubjectSubscriber = function (_super) {
        __extends(SubjectSubscriber, _super);
        function SubjectSubscriber(destination) {
            _super.call(this, destination);
            this.destination = destination;
        }
        return SubjectSubscriber;
    }(Subscriber_1.Subscriber);
    exports.SubjectSubscriber = SubjectSubscriber;
    /**
     * @class Subject<T>
     */
    var Subject = function (_super) {
        __extends(Subject, _super);
        function Subject() {
            _super.call(this);
            this.observers = [];
            this.closed = false;
            this.isStopped = false;
            this.hasError = false;
            this.thrownError = null;
        }
        Subject.prototype[rxSubscriber_1.rxSubscriber] = function () {
            return new SubjectSubscriber(this);
        };
        Subject.prototype.lift = function (operator) {
            var subject = new AnonymousSubject(this, this);
            subject.operator = operator;
            return subject;
        };
        Subject.prototype.next = function (value) {
            if (this.closed) {
                throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
            }
            if (!this.isStopped) {
                var observers = this.observers;
                var len = observers.length;
                var copy = observers.slice();
                for (var i = 0; i < len; i++) {
                    copy[i].next(value);
                }
            }
        };
        Subject.prototype.error = function (err) {
            if (this.closed) {
                throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
            }
            this.hasError = true;
            this.thrownError = err;
            this.isStopped = true;
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for (var i = 0; i < len; i++) {
                copy[i].error(err);
            }
            this.observers.length = 0;
        };
        Subject.prototype.complete = function () {
            if (this.closed) {
                throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
            }
            this.isStopped = true;
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for (var i = 0; i < len; i++) {
                copy[i].complete();
            }
            this.observers.length = 0;
        };
        Subject.prototype.unsubscribe = function () {
            this.isStopped = true;
            this.closed = true;
            this.observers = null;
        };
        Subject.prototype._trySubscribe = function (subscriber) {
            if (this.closed) {
                throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
            } else {
                return _super.prototype._trySubscribe.call(this, subscriber);
            }
        };
        /** @deprecated internal use only */Subject.prototype._subscribe = function (subscriber) {
            if (this.closed) {
                throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
            } else if (this.hasError) {
                subscriber.error(this.thrownError);
                return Subscription_1.Subscription.EMPTY;
            } else if (this.isStopped) {
                subscriber.complete();
                return Subscription_1.Subscription.EMPTY;
            } else {
                this.observers.push(subscriber);
                return new SubjectSubscription_1.SubjectSubscription(this, subscriber);
            }
        };
        Subject.prototype.asObservable = function () {
            var observable = new Observable_1.Observable();
            observable.source = this;
            return observable;
        };
        Subject.create = function (destination, source) {
            return new AnonymousSubject(destination, source);
        };
        return Subject;
    }(Observable_1.Observable);
    exports.Subject = Subject;
    /**
     * @class AnonymousSubject<T>
     */
    var AnonymousSubject = function (_super) {
        __extends(AnonymousSubject, _super);
        function AnonymousSubject(destination, source) {
            _super.call(this);
            this.destination = destination;
            this.source = source;
        }
        AnonymousSubject.prototype.next = function (value) {
            var destination = this.destination;
            if (destination && destination.next) {
                destination.next(value);
            }
        };
        AnonymousSubject.prototype.error = function (err) {
            var destination = this.destination;
            if (destination && destination.error) {
                this.destination.error(err);
            }
        };
        AnonymousSubject.prototype.complete = function () {
            var destination = this.destination;
            if (destination && destination.complete) {
                this.destination.complete();
            }
        };
        /** @deprecated internal use only */AnonymousSubject.prototype._subscribe = function (subscriber) {
            var source = this.source;
            if (source) {
                return this.source.subscribe(subscriber);
            } else {
                return Subscription_1.Subscription.EMPTY;
            }
        };
        return AnonymousSubject;
    }(Subject);
    exports.AnonymousSubject = AnonymousSubject;
    
});
System.registerDynamic('rxjs/observable/PromiseObservable.js', ['rxjs/util/root.js', 'rxjs/Observable.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var root_1 = $__require('rxjs/util/root.js');
    var Observable_1 = $__require('rxjs/Observable.js');
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @extends {Ignored}
     * @hide true
     */
    var PromiseObservable = function (_super) {
        __extends(PromiseObservable, _super);
        function PromiseObservable(promise, scheduler) {
            _super.call(this);
            this.promise = promise;
            this.scheduler = scheduler;
        }
        /**
         * Converts a Promise to an Observable.
         *
         * <span class="informal">Returns an Observable that just emits the Promise's
         * resolved value, then completes.</span>
         *
         * Converts an ES2015 Promise or a Promises/A+ spec compliant Promise to an
         * Observable. If the Promise resolves with a value, the output Observable
         * emits that resolved value as a `next`, and then completes. If the Promise
         * is rejected, then the output Observable emits the corresponding Error.
         *
         * @example <caption>Convert the Promise returned by Fetch to an Observable</caption>
         * var result = Rx.Observable.fromPromise(fetch('http://myserver.com/'));
         * result.subscribe(x => console.log(x), e => console.error(e));
         *
         * @see {@link bindCallback}
         * @see {@link from}
         *
         * @param {PromiseLike<T>} promise The promise to be converted.
         * @param {Scheduler} [scheduler] An optional IScheduler to use for scheduling
         * the delivery of the resolved value (or the rejection).
         * @return {Observable<T>} An Observable which wraps the Promise.
         * @static true
         * @name fromPromise
         * @owner Observable
         */
        PromiseObservable.create = function (promise, scheduler) {
            return new PromiseObservable(promise, scheduler);
        };
        /** @deprecated internal use only */PromiseObservable.prototype._subscribe = function (subscriber) {
            var _this = this;
            var promise = this.promise;
            var scheduler = this.scheduler;
            if (scheduler == null) {
                if (this._isScalar) {
                    if (!subscriber.closed) {
                        subscriber.next(this.value);
                        subscriber.complete();
                    }
                } else {
                    promise.then(function (value) {
                        _this.value = value;
                        _this._isScalar = true;
                        if (!subscriber.closed) {
                            subscriber.next(value);
                            subscriber.complete();
                        }
                    }, function (err) {
                        if (!subscriber.closed) {
                            subscriber.error(err);
                        }
                    }).then(null, function (err) {
                        // escape the promise trap, throw unhandled errors
                        root_1.root.setTimeout(function () {
                            throw err;
                        });
                    });
                }
            } else {
                if (this._isScalar) {
                    if (!subscriber.closed) {
                        return scheduler.schedule(dispatchNext, 0, { value: this.value, subscriber: subscriber });
                    }
                } else {
                    promise.then(function (value) {
                        _this.value = value;
                        _this._isScalar = true;
                        if (!subscriber.closed) {
                            subscriber.add(scheduler.schedule(dispatchNext, 0, { value: value, subscriber: subscriber }));
                        }
                    }, function (err) {
                        if (!subscriber.closed) {
                            subscriber.add(scheduler.schedule(dispatchError, 0, { err: err, subscriber: subscriber }));
                        }
                    }).then(null, function (err) {
                        // escape the promise trap, throw unhandled errors
                        root_1.root.setTimeout(function () {
                            throw err;
                        });
                    });
                }
            }
        };
        return PromiseObservable;
    }(Observable_1.Observable);
    exports.PromiseObservable = PromiseObservable;
    function dispatchNext(arg) {
        var value = arg.value,
            subscriber = arg.subscriber;
        if (!subscriber.closed) {
            subscriber.next(value);
            subscriber.complete();
        }
    }
    function dispatchError(arg) {
        var err = arg.err,
            subscriber = arg.subscriber;
        if (!subscriber.closed) {
            subscriber.error(err);
        }
    }
    
});
System.registerDynamic("rxjs/operator/toPromise.js", ["rxjs/Observable.js"], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var Observable_1 = $__require("rxjs/Observable.js");
  // HACK: this is here for backward compatability
  // TODO(benlesh): remove this in v6.
  exports.toPromise = Observable_1.Observable.prototype.toPromise;
  
});
System.registerDynamic("rxjs/util/isArray.js", [], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  exports.isArray = Array.isArray || function (x) {
    return x && typeof x.length === 'number';
  };
  
});
System.registerDynamic("rxjs/util/isObject.js", [], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    function isObject(x) {
        return x != null && typeof x === 'object';
    }
    exports.isObject = isObject;
    
});
System.registerDynamic("rxjs/util/isFunction.js", [], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    function isFunction(x) {
        return typeof x === 'function';
    }
    exports.isFunction = isFunction;
    
});
System.registerDynamic("rxjs/util/tryCatch.js", ["rxjs/util/errorObject.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var errorObject_1 = $__require("rxjs/util/errorObject.js");
    var tryCatchTarget;
    function tryCatcher() {
        try {
            return tryCatchTarget.apply(this, arguments);
        } catch (e) {
            errorObject_1.errorObject.e = e;
            return errorObject_1.errorObject;
        }
    }
    function tryCatch(fn) {
        tryCatchTarget = fn;
        return tryCatcher;
    }
    exports.tryCatch = tryCatch;
    ;
    
});
System.registerDynamic("rxjs/util/errorObject.js", [], true, function ($__require, exports, module) {
  "use strict";
  // typeof any so that it we don't have to cast when comparing a result to the error object

  var global = this || self,
      GLOBAL = global;
  exports.errorObject = { e: {} };
  
});
System.registerDynamic("rxjs/util/UnsubscriptionError.js", [], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    /**
     * An error thrown when one or more errors have occurred during the
     * `unsubscribe` of a {@link Subscription}.
     */
    var UnsubscriptionError = function (_super) {
        __extends(UnsubscriptionError, _super);
        function UnsubscriptionError(errors) {
            _super.call(this);
            this.errors = errors;
            var err = Error.call(this, errors ? errors.length + " errors occurred during unsubscription:\n  " + errors.map(function (err, i) {
                return i + 1 + ") " + err.toString();
            }).join('\n  ') : '');
            this.name = err.name = 'UnsubscriptionError';
            this.stack = err.stack;
            this.message = err.message;
        }
        return UnsubscriptionError;
    }(Error);
    exports.UnsubscriptionError = UnsubscriptionError;
    
});
System.registerDynamic('rxjs/Subscription.js', ['rxjs/util/isArray.js', 'rxjs/util/isObject.js', 'rxjs/util/isFunction.js', 'rxjs/util/tryCatch.js', 'rxjs/util/errorObject.js', 'rxjs/util/UnsubscriptionError.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var isArray_1 = $__require('rxjs/util/isArray.js');
    var isObject_1 = $__require('rxjs/util/isObject.js');
    var isFunction_1 = $__require('rxjs/util/isFunction.js');
    var tryCatch_1 = $__require('rxjs/util/tryCatch.js');
    var errorObject_1 = $__require('rxjs/util/errorObject.js');
    var UnsubscriptionError_1 = $__require('rxjs/util/UnsubscriptionError.js');
    /**
     * Represents a disposable resource, such as the execution of an Observable. A
     * Subscription has one important method, `unsubscribe`, that takes no argument
     * and just disposes the resource held by the subscription.
     *
     * Additionally, subscriptions may be grouped together through the `add()`
     * method, which will attach a child Subscription to the current Subscription.
     * When a Subscription is unsubscribed, all its children (and its grandchildren)
     * will be unsubscribed as well.
     *
     * @class Subscription
     */
    var Subscription = function () {
        /**
         * @param {function(): void} [unsubscribe] A function describing how to
         * perform the disposal of resources when the `unsubscribe` method is called.
         */
        function Subscription(unsubscribe) {
            /**
             * A flag to indicate whether this Subscription has already been unsubscribed.
             * @type {boolean}
             */
            this.closed = false;
            this._parent = null;
            this._parents = null;
            this._subscriptions = null;
            if (unsubscribe) {
                this._unsubscribe = unsubscribe;
            }
        }
        /**
         * Disposes the resources held by the subscription. May, for instance, cancel
         * an ongoing Observable execution or cancel any other type of work that
         * started when the Subscription was created.
         * @return {void}
         */
        Subscription.prototype.unsubscribe = function () {
            var hasErrors = false;
            var errors;
            if (this.closed) {
                return;
            }
            var _a = this,
                _parent = _a._parent,
                _parents = _a._parents,
                _unsubscribe = _a._unsubscribe,
                _subscriptions = _a._subscriptions;
            this.closed = true;
            this._parent = null;
            this._parents = null;
            // null out _subscriptions first so any child subscriptions that attempt
            // to remove themselves from this subscription will noop
            this._subscriptions = null;
            var index = -1;
            var len = _parents ? _parents.length : 0;
            // if this._parent is null, then so is this._parents, and we
            // don't have to remove ourselves from any parent subscriptions.
            while (_parent) {
                _parent.remove(this);
                // if this._parents is null or index >= len,
                // then _parent is set to null, and the loop exits
                _parent = ++index < len && _parents[index] || null;
            }
            if (isFunction_1.isFunction(_unsubscribe)) {
                var trial = tryCatch_1.tryCatch(_unsubscribe).call(this);
                if (trial === errorObject_1.errorObject) {
                    hasErrors = true;
                    errors = errors || (errorObject_1.errorObject.e instanceof UnsubscriptionError_1.UnsubscriptionError ? flattenUnsubscriptionErrors(errorObject_1.errorObject.e.errors) : [errorObject_1.errorObject.e]);
                }
            }
            if (isArray_1.isArray(_subscriptions)) {
                index = -1;
                len = _subscriptions.length;
                while (++index < len) {
                    var sub = _subscriptions[index];
                    if (isObject_1.isObject(sub)) {
                        var trial = tryCatch_1.tryCatch(sub.unsubscribe).call(sub);
                        if (trial === errorObject_1.errorObject) {
                            hasErrors = true;
                            errors = errors || [];
                            var err = errorObject_1.errorObject.e;
                            if (err instanceof UnsubscriptionError_1.UnsubscriptionError) {
                                errors = errors.concat(flattenUnsubscriptionErrors(err.errors));
                            } else {
                                errors.push(err);
                            }
                        }
                    }
                }
            }
            if (hasErrors) {
                throw new UnsubscriptionError_1.UnsubscriptionError(errors);
            }
        };
        /**
         * Adds a tear down to be called during the unsubscribe() of this
         * Subscription.
         *
         * If the tear down being added is a subscription that is already
         * unsubscribed, is the same reference `add` is being called on, or is
         * `Subscription.EMPTY`, it will not be added.
         *
         * If this subscription is already in an `closed` state, the passed
         * tear down logic will be executed immediately.
         *
         * @param {TeardownLogic} teardown The additional logic to execute on
         * teardown.
         * @return {Subscription} Returns the Subscription used or created to be
         * added to the inner subscriptions list. This Subscription can be used with
         * `remove()` to remove the passed teardown logic from the inner subscriptions
         * list.
         */
        Subscription.prototype.add = function (teardown) {
            if (!teardown || teardown === Subscription.EMPTY) {
                return Subscription.EMPTY;
            }
            if (teardown === this) {
                return this;
            }
            var subscription = teardown;
            switch (typeof teardown) {
                case 'function':
                    subscription = new Subscription(teardown);
                case 'object':
                    if (subscription.closed || typeof subscription.unsubscribe !== 'function') {
                        return subscription;
                    } else if (this.closed) {
                        subscription.unsubscribe();
                        return subscription;
                    } else if (typeof subscription._addParent !== 'function' /* quack quack */) {
                            var tmp = subscription;
                            subscription = new Subscription();
                            subscription._subscriptions = [tmp];
                        }
                    break;
                default:
                    throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
            }
            var subscriptions = this._subscriptions || (this._subscriptions = []);
            subscriptions.push(subscription);
            subscription._addParent(this);
            return subscription;
        };
        /**
         * Removes a Subscription from the internal list of subscriptions that will
         * unsubscribe during the unsubscribe process of this Subscription.
         * @param {Subscription} subscription The subscription to remove.
         * @return {void}
         */
        Subscription.prototype.remove = function (subscription) {
            var subscriptions = this._subscriptions;
            if (subscriptions) {
                var subscriptionIndex = subscriptions.indexOf(subscription);
                if (subscriptionIndex !== -1) {
                    subscriptions.splice(subscriptionIndex, 1);
                }
            }
        };
        Subscription.prototype._addParent = function (parent) {
            var _a = this,
                _parent = _a._parent,
                _parents = _a._parents;
            if (!_parent || _parent === parent) {
                // If we don't have a parent, or the new parent is the same as the
                // current parent, then set this._parent to the new parent.
                this._parent = parent;
            } else if (!_parents) {
                // If there's already one parent, but not multiple, allocate an Array to
                // store the rest of the parent Subscriptions.
                this._parents = [parent];
            } else if (_parents.indexOf(parent) === -1) {
                // Only add the new parent to the _parents list if it's not already there.
                _parents.push(parent);
            }
        };
        Subscription.EMPTY = function (empty) {
            empty.closed = true;
            return empty;
        }(new Subscription());
        return Subscription;
    }();
    exports.Subscription = Subscription;
    function flattenUnsubscriptionErrors(errors) {
        return errors.reduce(function (errs, err) {
            return errs.concat(err instanceof UnsubscriptionError_1.UnsubscriptionError ? err.errors : err);
        }, []);
    }
    
});
System.registerDynamic('rxjs/Subscriber.js', ['rxjs/util/isFunction.js', 'rxjs/Subscription.js', 'rxjs/Observer.js', 'rxjs/symbol/rxSubscriber.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var isFunction_1 = $__require('rxjs/util/isFunction.js');
    var Subscription_1 = $__require('rxjs/Subscription.js');
    var Observer_1 = $__require('rxjs/Observer.js');
    var rxSubscriber_1 = $__require('rxjs/symbol/rxSubscriber.js');
    /**
     * Implements the {@link Observer} interface and extends the
     * {@link Subscription} class. While the {@link Observer} is the public API for
     * consuming the values of an {@link Observable}, all Observers get converted to
     * a Subscriber, in order to provide Subscription-like capabilities such as
     * `unsubscribe`. Subscriber is a common type in RxJS, and crucial for
     * implementing operators, but it is rarely used as a public API.
     *
     * @class Subscriber<T>
     */
    var Subscriber = function (_super) {
        __extends(Subscriber, _super);
        /**
         * @param {Observer|function(value: T): void} [destinationOrNext] A partially
         * defined Observer or a `next` callback function.
         * @param {function(e: ?any): void} [error] The `error` callback of an
         * Observer.
         * @param {function(): void} [complete] The `complete` callback of an
         * Observer.
         */
        function Subscriber(destinationOrNext, error, complete) {
            _super.call(this);
            this.syncErrorValue = null;
            this.syncErrorThrown = false;
            this.syncErrorThrowable = false;
            this.isStopped = false;
            switch (arguments.length) {
                case 0:
                    this.destination = Observer_1.empty;
                    break;
                case 1:
                    if (!destinationOrNext) {
                        this.destination = Observer_1.empty;
                        break;
                    }
                    if (typeof destinationOrNext === 'object') {
                        // HACK(benlesh): To resolve an issue where Node users may have multiple
                        // copies of rxjs in their node_modules directory.
                        if (isTrustedSubscriber(destinationOrNext)) {
                            var trustedSubscriber = destinationOrNext[rxSubscriber_1.rxSubscriber]();
                            this.syncErrorThrowable = trustedSubscriber.syncErrorThrowable;
                            this.destination = trustedSubscriber;
                            trustedSubscriber.add(this);
                        } else {
                            this.syncErrorThrowable = true;
                            this.destination = new SafeSubscriber(this, destinationOrNext);
                        }
                        break;
                    }
                default:
                    this.syncErrorThrowable = true;
                    this.destination = new SafeSubscriber(this, destinationOrNext, error, complete);
                    break;
            }
        }
        Subscriber.prototype[rxSubscriber_1.rxSubscriber] = function () {
            return this;
        };
        /**
         * A static factory for a Subscriber, given a (potentially partial) definition
         * of an Observer.
         * @param {function(x: ?T): void} [next] The `next` callback of an Observer.
         * @param {function(e: ?any): void} [error] The `error` callback of an
         * Observer.
         * @param {function(): void} [complete] The `complete` callback of an
         * Observer.
         * @return {Subscriber<T>} A Subscriber wrapping the (partially defined)
         * Observer represented by the given arguments.
         */
        Subscriber.create = function (next, error, complete) {
            var subscriber = new Subscriber(next, error, complete);
            subscriber.syncErrorThrowable = false;
            return subscriber;
        };
        /**
         * The {@link Observer} callback to receive notifications of type `next` from
         * the Observable, with a value. The Observable may call this method 0 or more
         * times.
         * @param {T} [value] The `next` value.
         * @return {void}
         */
        Subscriber.prototype.next = function (value) {
            if (!this.isStopped) {
                this._next(value);
            }
        };
        /**
         * The {@link Observer} callback to receive notifications of type `error` from
         * the Observable, with an attached {@link Error}. Notifies the Observer that
         * the Observable has experienced an error condition.
         * @param {any} [err] The `error` exception.
         * @return {void}
         */
        Subscriber.prototype.error = function (err) {
            if (!this.isStopped) {
                this.isStopped = true;
                this._error(err);
            }
        };
        /**
         * The {@link Observer} callback to receive a valueless notification of type
         * `complete` from the Observable. Notifies the Observer that the Observable
         * has finished sending push-based notifications.
         * @return {void}
         */
        Subscriber.prototype.complete = function () {
            if (!this.isStopped) {
                this.isStopped = true;
                this._complete();
            }
        };
        Subscriber.prototype.unsubscribe = function () {
            if (this.closed) {
                return;
            }
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
        };
        Subscriber.prototype._next = function (value) {
            this.destination.next(value);
        };
        Subscriber.prototype._error = function (err) {
            this.destination.error(err);
            this.unsubscribe();
        };
        Subscriber.prototype._complete = function () {
            this.destination.complete();
            this.unsubscribe();
        };
        /** @deprecated internal use only */Subscriber.prototype._unsubscribeAndRecycle = function () {
            var _a = this,
                _parent = _a._parent,
                _parents = _a._parents;
            this._parent = null;
            this._parents = null;
            this.unsubscribe();
            this.closed = false;
            this.isStopped = false;
            this._parent = _parent;
            this._parents = _parents;
            return this;
        };
        return Subscriber;
    }(Subscription_1.Subscription);
    exports.Subscriber = Subscriber;
    /**
     * We need this JSDoc comment for affecting ESDoc.
     * @ignore
     * @extends {Ignored}
     */
    var SafeSubscriber = function (_super) {
        __extends(SafeSubscriber, _super);
        function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
            _super.call(this);
            this._parentSubscriber = _parentSubscriber;
            var next;
            var context = this;
            if (isFunction_1.isFunction(observerOrNext)) {
                next = observerOrNext;
            } else if (observerOrNext) {
                next = observerOrNext.next;
                error = observerOrNext.error;
                complete = observerOrNext.complete;
                if (observerOrNext !== Observer_1.empty) {
                    context = Object.create(observerOrNext);
                    if (isFunction_1.isFunction(context.unsubscribe)) {
                        this.add(context.unsubscribe.bind(context));
                    }
                    context.unsubscribe = this.unsubscribe.bind(this);
                }
            }
            this._context = context;
            this._next = next;
            this._error = error;
            this._complete = complete;
        }
        SafeSubscriber.prototype.next = function (value) {
            if (!this.isStopped && this._next) {
                var _parentSubscriber = this._parentSubscriber;
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._next, value);
                } else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
                    this.unsubscribe();
                }
            }
        };
        SafeSubscriber.prototype.error = function (err) {
            if (!this.isStopped) {
                var _parentSubscriber = this._parentSubscriber;
                if (this._error) {
                    if (!_parentSubscriber.syncErrorThrowable) {
                        this.__tryOrUnsub(this._error, err);
                        this.unsubscribe();
                    } else {
                        this.__tryOrSetError(_parentSubscriber, this._error, err);
                        this.unsubscribe();
                    }
                } else if (!_parentSubscriber.syncErrorThrowable) {
                    this.unsubscribe();
                    throw err;
                } else {
                    _parentSubscriber.syncErrorValue = err;
                    _parentSubscriber.syncErrorThrown = true;
                    this.unsubscribe();
                }
            }
        };
        SafeSubscriber.prototype.complete = function () {
            var _this = this;
            if (!this.isStopped) {
                var _parentSubscriber = this._parentSubscriber;
                if (this._complete) {
                    var wrappedComplete = function () {
                        return _this._complete.call(_this._context);
                    };
                    if (!_parentSubscriber.syncErrorThrowable) {
                        this.__tryOrUnsub(wrappedComplete);
                        this.unsubscribe();
                    } else {
                        this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                        this.unsubscribe();
                    }
                } else {
                    this.unsubscribe();
                }
            }
        };
        SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
            try {
                fn.call(this._context, value);
            } catch (err) {
                this.unsubscribe();
                throw err;
            }
        };
        SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
            try {
                fn.call(this._context, value);
            } catch (err) {
                parent.syncErrorValue = err;
                parent.syncErrorThrown = true;
                return true;
            }
            return false;
        };
        /** @deprecated internal use only */SafeSubscriber.prototype._unsubscribe = function () {
            var _parentSubscriber = this._parentSubscriber;
            this._context = null;
            this._parentSubscriber = null;
            _parentSubscriber.unsubscribe();
        };
        return SafeSubscriber;
    }(Subscriber);
    function isTrustedSubscriber(obj) {
        return obj instanceof Subscriber || 'syncErrorThrowable' in obj && obj[rxSubscriber_1.rxSubscriber];
    }
    
});
System.registerDynamic('rxjs/symbol/rxSubscriber.js', ['rxjs/util/root.js'], true, function ($__require, exports, module) {
  "use strict";

  var global = this || self,
      GLOBAL = global;
  var root_1 = $__require('rxjs/util/root.js');
  var Symbol = root_1.root.Symbol;
  exports.rxSubscriber = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('rxSubscriber') : '@@rxSubscriber';
  /**
   * @deprecated use rxSubscriber instead
   */
  exports.$$rxSubscriber = exports.rxSubscriber;
  
});
System.registerDynamic("rxjs/Observer.js", [], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    exports.empty = {
        closed: true,
        next: function (value) {},
        error: function (err) {
            throw err;
        },
        complete: function () {}
    };
    
});
System.registerDynamic('rxjs/util/toSubscriber.js', ['rxjs/Subscriber.js', 'rxjs/symbol/rxSubscriber.js', 'rxjs/Observer.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var Subscriber_1 = $__require('rxjs/Subscriber.js');
    var rxSubscriber_1 = $__require('rxjs/symbol/rxSubscriber.js');
    var Observer_1 = $__require('rxjs/Observer.js');
    function toSubscriber(nextOrObserver, error, complete) {
        if (nextOrObserver) {
            if (nextOrObserver instanceof Subscriber_1.Subscriber) {
                return nextOrObserver;
            }
            if (nextOrObserver[rxSubscriber_1.rxSubscriber]) {
                return nextOrObserver[rxSubscriber_1.rxSubscriber]();
            }
        }
        if (!nextOrObserver && !error && !complete) {
            return new Subscriber_1.Subscriber(Observer_1.empty);
        }
        return new Subscriber_1.Subscriber(nextOrObserver, error, complete);
    }
    exports.toSubscriber = toSubscriber;
    
});
System.registerDynamic('rxjs/util/root.js', [], true, function ($__require, exports, module) {
    "use strict";
    // CommonJS / Node have global context exposed as "global" variable.
    // We don't want to include the whole node.d.ts this this compilation unit so we'll just fake
    // the global "global" var for now.

    var global = this || self,
        GLOBAL = global;
    var __window = typeof window !== 'undefined' && window;
    var __self = typeof self !== 'undefined' && typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope && self;
    var __global = typeof global !== 'undefined' && global;
    var _root = __window || __global || __self;
    exports.root = _root;
    // Workaround Closure Compiler restriction: The body of a goog.module cannot use throw.
    // This is needed when used with angular/tsickle which inserts a goog.module statement.
    // Wrap in IIFE
    (function () {
        if (!_root) {
            throw new Error('RxJS could not find any global context (window, self, global)');
        }
    })();
    
});
System.registerDynamic('rxjs/symbol/observable.js', ['rxjs/util/root.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var root_1 = $__require('rxjs/util/root.js');
    function getSymbolObservable(context) {
        var $$observable;
        var Symbol = context.Symbol;
        if (typeof Symbol === 'function') {
            if (Symbol.observable) {
                $$observable = Symbol.observable;
            } else {
                $$observable = Symbol('observable');
                Symbol.observable = $$observable;
            }
        } else {
            $$observable = '@@observable';
        }
        return $$observable;
    }
    exports.getSymbolObservable = getSymbolObservable;
    exports.observable = getSymbolObservable(root_1.root);
    /**
     * @deprecated use observable instead
     */
    exports.$$observable = exports.observable;
    
});
System.registerDynamic("rxjs/util/noop.js", [], true, function ($__require, exports, module) {
  "use strict";
  /* tslint:disable:no-empty */

  var global = this || self,
      GLOBAL = global;
  function noop() {}
  exports.noop = noop;
  
});
System.registerDynamic("rxjs/util/pipe.js", ["rxjs/util/noop.js"], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var noop_1 = $__require("rxjs/util/noop.js");
    /* tslint:enable:max-line-length */
    function pipe() {
        var fns = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            fns[_i - 0] = arguments[_i];
        }
        return pipeFromArray(fns);
    }
    exports.pipe = pipe;
    /* @internal */
    function pipeFromArray(fns) {
        if (!fns) {
            return noop_1.noop;
        }
        if (fns.length === 1) {
            return fns[0];
        }
        return function piped(input) {
            return fns.reduce(function (prev, fn) {
                return fn(prev);
            }, input);
        };
    }
    exports.pipeFromArray = pipeFromArray;
    
});
System.registerDynamic('rxjs/Observable.js', ['rxjs/util/root.js', 'rxjs/util/toSubscriber.js', 'rxjs/symbol/observable.js', 'rxjs/util/pipe.js'], true, function ($__require, exports, module) {
    "use strict";

    var global = this || self,
        GLOBAL = global;
    var root_1 = $__require('rxjs/util/root.js');
    var toSubscriber_1 = $__require('rxjs/util/toSubscriber.js');
    var observable_1 = $__require('rxjs/symbol/observable.js');
    var pipe_1 = $__require('rxjs/util/pipe.js');
    /**
     * A representation of any set of values over any amount of time. This is the most basic building block
     * of RxJS.
     *
     * @class Observable<T>
     */
    var Observable = function () {
        /**
         * @constructor
         * @param {Function} subscribe the function that is called when the Observable is
         * initially subscribed to. This function is given a Subscriber, to which new values
         * can be `next`ed, or an `error` method can be called to raise an error, or
         * `complete` can be called to notify of a successful completion.
         */
        function Observable(subscribe) {
            this._isScalar = false;
            if (subscribe) {
                this._subscribe = subscribe;
            }
        }
        /**
         * Creates a new Observable, with this Observable as the source, and the passed
         * operator defined as the new observable's operator.
         * @method lift
         * @param {Operator} operator the operator defining the operation to take on the observable
         * @return {Observable} a new observable with the Operator applied
         */
        Observable.prototype.lift = function (operator) {
            var observable = new Observable();
            observable.source = this;
            observable.operator = operator;
            return observable;
        };
        /**
         * Invokes an execution of an Observable and registers Observer handlers for notifications it will emit.
         *
         * <span class="informal">Use it when you have all these Observables, but still nothing is happening.</span>
         *
         * `subscribe` is not a regular operator, but a method that calls Observable's internal `subscribe` function. It
         * might be for example a function that you passed to a {@link create} static factory, but most of the time it is
         * a library implementation, which defines what and when will be emitted by an Observable. This means that calling
         * `subscribe` is actually the moment when Observable starts its work, not when it is created, as it is often
         * thought.
         *
         * Apart from starting the execution of an Observable, this method allows you to listen for values
         * that an Observable emits, as well as for when it completes or errors. You can achieve this in two
         * following ways.
         *
         * The first way is creating an object that implements {@link Observer} interface. It should have methods
         * defined by that interface, but note that it should be just a regular JavaScript object, which you can create
         * yourself in any way you want (ES6 class, classic function constructor, object literal etc.). In particular do
         * not attempt to use any RxJS implementation details to create Observers - you don't need them. Remember also
         * that your object does not have to implement all methods. If you find yourself creating a method that doesn't
         * do anything, you can simply omit it. Note however, that if `error` method is not provided, all errors will
         * be left uncaught.
         *
         * The second way is to give up on Observer object altogether and simply provide callback functions in place of its methods.
         * This means you can provide three functions as arguments to `subscribe`, where first function is equivalent
         * of a `next` method, second of an `error` method and third of a `complete` method. Just as in case of Observer,
         * if you do not need to listen for something, you can omit a function, preferably by passing `undefined` or `null`,
         * since `subscribe` recognizes these functions by where they were placed in function call. When it comes
         * to `error` function, just as before, if not provided, errors emitted by an Observable will be thrown.
         *
         * Whatever style of calling `subscribe` you use, in both cases it returns a Subscription object.
         * This object allows you to call `unsubscribe` on it, which in turn will stop work that an Observable does and will clean
         * up all resources that an Observable used. Note that cancelling a subscription will not call `complete` callback
         * provided to `subscribe` function, which is reserved for a regular completion signal that comes from an Observable.
         *
         * Remember that callbacks provided to `subscribe` are not guaranteed to be called asynchronously.
         * It is an Observable itself that decides when these functions will be called. For example {@link of}
         * by default emits all its values synchronously. Always check documentation for how given Observable
         * will behave when subscribed and if its default behavior can be modified with a {@link Scheduler}.
         *
         * @example <caption>Subscribe with an Observer</caption>
         * const sumObserver = {
         *   sum: 0,
         *   next(value) {
         *     console.log('Adding: ' + value);
         *     this.sum = this.sum + value;
         *   },
         *   error() { // We actually could just remove this method,
         *   },        // since we do not really care about errors right now.
         *   complete() {
         *     console.log('Sum equals: ' + this.sum);
         *   }
         * };
         *
         * Rx.Observable.of(1, 2, 3) // Synchronously emits 1, 2, 3 and then completes.
         * .subscribe(sumObserver);
         *
         * // Logs:
         * // "Adding: 1"
         * // "Adding: 2"
         * // "Adding: 3"
         * // "Sum equals: 6"
         *
         *
         * @example <caption>Subscribe with functions</caption>
         * let sum = 0;
         *
         * Rx.Observable.of(1, 2, 3)
         * .subscribe(
         *   function(value) {
         *     console.log('Adding: ' + value);
         *     sum = sum + value;
         *   },
         *   undefined,
         *   function() {
         *     console.log('Sum equals: ' + sum);
         *   }
         * );
         *
         * // Logs:
         * // "Adding: 1"
         * // "Adding: 2"
         * // "Adding: 3"
         * // "Sum equals: 6"
         *
         *
         * @example <caption>Cancel a subscription</caption>
         * const subscription = Rx.Observable.interval(1000).subscribe(
         *   num => console.log(num),
         *   undefined,
         *   () => console.log('completed!') // Will not be called, even
         * );                                // when cancelling subscription
         *
         *
         * setTimeout(() => {
         *   subscription.unsubscribe();
         *   console.log('unsubscribed!');
         * }, 2500);
         *
         * // Logs:
         * // 0 after 1s
         * // 1 after 2s
         * // "unsubscribed!" after 2.5s
         *
         *
         * @param {Observer|Function} observerOrNext (optional) Either an observer with methods to be called,
         *  or the first of three possible handlers, which is the handler for each value emitted from the subscribed
         *  Observable.
         * @param {Function} error (optional) A handler for a terminal event resulting from an error. If no error handler is provided,
         *  the error will be thrown as unhandled.
         * @param {Function} complete (optional) A handler for a terminal event resulting from successful completion.
         * @return {ISubscription} a subscription reference to the registered handlers
         * @method subscribe
         */
        Observable.prototype.subscribe = function (observerOrNext, error, complete) {
            var operator = this.operator;
            var sink = toSubscriber_1.toSubscriber(observerOrNext, error, complete);
            if (operator) {
                operator.call(sink, this.source);
            } else {
                sink.add(this.source || !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
            }
            if (sink.syncErrorThrowable) {
                sink.syncErrorThrowable = false;
                if (sink.syncErrorThrown) {
                    throw sink.syncErrorValue;
                }
            }
            return sink;
        };
        Observable.prototype._trySubscribe = function (sink) {
            try {
                return this._subscribe(sink);
            } catch (err) {
                sink.syncErrorThrown = true;
                sink.syncErrorValue = err;
                sink.error(err);
            }
        };
        /**
         * @method forEach
         * @param {Function} next a handler for each value emitted by the observable
         * @param {PromiseConstructor} [PromiseCtor] a constructor function used to instantiate the Promise
         * @return {Promise} a promise that either resolves on observable completion or
         *  rejects with the handled error
         */
        Observable.prototype.forEach = function (next, PromiseCtor) {
            var _this = this;
            if (!PromiseCtor) {
                if (root_1.root.Rx && root_1.root.Rx.config && root_1.root.Rx.config.Promise) {
                    PromiseCtor = root_1.root.Rx.config.Promise;
                } else if (root_1.root.Promise) {
                    PromiseCtor = root_1.root.Promise;
                }
            }
            if (!PromiseCtor) {
                throw new Error('no Promise impl found');
            }
            return new PromiseCtor(function (resolve, reject) {
                // Must be declared in a separate statement to avoid a RefernceError when
                // accessing subscription below in the closure due to Temporal Dead Zone.
                var subscription;
                subscription = _this.subscribe(function (value) {
                    if (subscription) {
                        // if there is a subscription, then we can surmise
                        // the next handling is asynchronous. Any errors thrown
                        // need to be rejected explicitly and unsubscribe must be
                        // called manually
                        try {
                            next(value);
                        } catch (err) {
                            reject(err);
                            subscription.unsubscribe();
                        }
                    } else {
                        // if there is NO subscription, then we're getting a nexted
                        // value synchronously during subscription. We can just call it.
                        // If it errors, Observable's `subscribe` will ensure the
                        // unsubscription logic is called, then synchronously rethrow the error.
                        // After that, Promise will trap the error and send it
                        // down the rejection path.
                        next(value);
                    }
                }, reject, resolve);
            });
        };
        /** @deprecated internal use only */Observable.prototype._subscribe = function (subscriber) {
            return this.source.subscribe(subscriber);
        };
        /**
         * An interop point defined by the es7-observable spec https://github.com/zenparsing/es-observable
         * @method Symbol.observable
         * @return {Observable} this instance of the observable
         */
        Observable.prototype[observable_1.observable] = function () {
            return this;
        };
        /* tslint:enable:max-line-length */
        /**
         * Used to stitch together functional operators into a chain.
         * @method pipe
         * @return {Observable} the Observable result of all of the operators having
         * been called in the order they were passed in.
         *
         * @example
         *
         * import { map, filter, scan } from 'rxjs/operators';
         *
         * Rx.Observable.interval(1000)
         *   .pipe(
         *     filter(x => x % 2 === 0),
         *     map(x => x + x),
         *     scan((acc, x) => acc + x)
         *   )
         *   .subscribe(x => console.log(x))
         */
        Observable.prototype.pipe = function () {
            var operations = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                operations[_i - 0] = arguments[_i];
            }
            if (operations.length === 0) {
                return this;
            }
            return pipe_1.pipeFromArray(operations)(this);
        };
        /* tslint:enable:max-line-length */
        Observable.prototype.toPromise = function (PromiseCtor) {
            var _this = this;
            if (!PromiseCtor) {
                if (root_1.root.Rx && root_1.root.Rx.config && root_1.root.Rx.config.Promise) {
                    PromiseCtor = root_1.root.Rx.config.Promise;
                } else if (root_1.root.Promise) {
                    PromiseCtor = root_1.root.Promise;
                }
            }
            if (!PromiseCtor) {
                throw new Error('no Promise impl found');
            }
            return new PromiseCtor(function (resolve, reject) {
                var value;
                _this.subscribe(function (x) {
                    return value = x;
                }, function (err) {
                    return reject(err);
                }, function () {
                    return resolve(value);
                });
            });
        };
        // HACK: Since TypeScript inherits static properties too, we have to
        // fight against TypeScript here so Subject can have a different static create signature
        /**
         * Creates a new cold Observable by calling the Observable constructor
         * @static true
         * @owner Observable
         * @method create
         * @param {Function} subscribe? the subscriber function to be passed to the Observable constructor
         * @return {Observable} a new cold observable
         */
        Observable.create = function (subscribe) {
            return new Observable(subscribe);
        };
        return Observable;
    }();
    exports.Observable = Observable;
    
});
System.registerDynamic('angular2/src/facade/async.js', ['angular2/src/facade/lang.js', 'angular2/src/facade/promise.js', 'rxjs/Subject.js', 'rxjs/observable/PromiseObservable.js', 'rxjs/operator/toPromise.js', 'rxjs/Observable.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var promise_1 = $__require('angular2/src/facade/promise.js');
    exports.PromiseWrapper = promise_1.PromiseWrapper;
    exports.PromiseCompleter = promise_1.PromiseCompleter;
    var Subject_1 = $__require('rxjs/Subject.js');
    var PromiseObservable_1 = $__require('rxjs/observable/PromiseObservable.js');
    var toPromise_1 = $__require('rxjs/operator/toPromise.js');
    var Observable_1 = $__require('rxjs/Observable.js');
    exports.Observable = Observable_1.Observable;
    var Subject_2 = $__require('rxjs/Subject.js');
    exports.Subject = Subject_2.Subject;
    var TimerWrapper = function () {
        function TimerWrapper() {}
        TimerWrapper.setTimeout = function (fn, millis) {
            return lang_1.global.setTimeout(fn, millis);
        };
        TimerWrapper.clearTimeout = function (id) {
            lang_1.global.clearTimeout(id);
        };
        TimerWrapper.setInterval = function (fn, millis) {
            return lang_1.global.setInterval(fn, millis);
        };
        TimerWrapper.clearInterval = function (id) {
            lang_1.global.clearInterval(id);
        };
        return TimerWrapper;
    }();
    exports.TimerWrapper = TimerWrapper;
    var ObservableWrapper = function () {
        function ObservableWrapper() {}
        // TODO(vsavkin): when we use rxnext, try inferring the generic type from the first arg
        ObservableWrapper.subscribe = function (emitter, onNext, onError, onComplete) {
            if (onComplete === void 0) {
                onComplete = function () {};
            }
            onError = typeof onError === "function" && onError || lang_1.noop;
            onComplete = typeof onComplete === "function" && onComplete || lang_1.noop;
            return emitter.subscribe({ next: onNext, error: onError, complete: onComplete });
        };
        ObservableWrapper.isObservable = function (obs) {
            return !!obs.subscribe;
        };
        /**
         * Returns whether `obs` has any subscribers listening to events.
         */
        ObservableWrapper.hasSubscribers = function (obs) {
            return obs.observers.length > 0;
        };
        ObservableWrapper.dispose = function (subscription) {
            subscription.unsubscribe();
        };
        /**
         * @deprecated - use callEmit() instead
         */
        ObservableWrapper.callNext = function (emitter, value) {
            emitter.next(value);
        };
        ObservableWrapper.callEmit = function (emitter, value) {
            emitter.emit(value);
        };
        ObservableWrapper.callError = function (emitter, error) {
            emitter.error(error);
        };
        ObservableWrapper.callComplete = function (emitter) {
            emitter.complete();
        };
        ObservableWrapper.fromPromise = function (promise) {
            return PromiseObservable_1.PromiseObservable.create(promise);
        };
        ObservableWrapper.toPromise = function (obj) {
            return toPromise_1.toPromise.call(obj);
        };
        return ObservableWrapper;
    }();
    exports.ObservableWrapper = ObservableWrapper;
    /**
     * Use by directives and components to emit custom Events.
     *
     * ### Examples
     *
     * In the following example, `Zippy` alternatively emits `open` and `close` events when its
     * title gets clicked:
     *
     * ```
     * @Component({
     *   selector: 'zippy',
     *   template: `
     *   <div class="zippy">
     *     <div (click)="toggle()">Toggle</div>
     *     <div [hidden]="!visible">
     *       <ng-content></ng-content>
     *     </div>
     *  </div>`})
     * export class Zippy {
     *   visible: boolean = true;
     *   @Output() open: EventEmitter<any> = new EventEmitter();
     *   @Output() close: EventEmitter<any> = new EventEmitter();
     *
     *   toggle() {
     *     this.visible = !this.visible;
     *     if (this.visible) {
     *       this.open.emit(null);
     *     } else {
     *       this.close.emit(null);
     *     }
     *   }
     * }
     * ```
     *
     * Use Rx.Observable but provides an adapter to make it work as specified here:
     * https://github.com/jhusain/observable-spec
     *
     * Once a reference implementation of the spec is available, switch to it.
     */
    var EventEmitter = function (_super) {
        __extends(EventEmitter, _super);
        /**
         * Creates an instance of [EventEmitter], which depending on [isAsync],
         * delivers events synchronously or asynchronously.
         */
        function EventEmitter(isAsync) {
            if (isAsync === void 0) {
                isAsync = true;
            }
            _super.call(this);
            this._isAsync = isAsync;
        }
        EventEmitter.prototype.emit = function (value) {
            _super.prototype.next.call(this, value);
        };
        /**
         * @deprecated - use .emit(value) instead
         */
        EventEmitter.prototype.next = function (value) {
            _super.prototype.next.call(this, value);
        };
        EventEmitter.prototype.subscribe = function (generatorOrNext, error, complete) {
            var schedulerFn;
            var errorFn = function (err) {
                return null;
            };
            var completeFn = function () {
                return null;
            };
            if (generatorOrNext && typeof generatorOrNext === 'object') {
                schedulerFn = this._isAsync ? function (value) {
                    setTimeout(function () {
                        return generatorOrNext.next(value);
                    });
                } : function (value) {
                    generatorOrNext.next(value);
                };
                if (generatorOrNext.error) {
                    errorFn = this._isAsync ? function (err) {
                        setTimeout(function () {
                            return generatorOrNext.error(err);
                        });
                    } : function (err) {
                        generatorOrNext.error(err);
                    };
                }
                if (generatorOrNext.complete) {
                    completeFn = this._isAsync ? function () {
                        setTimeout(function () {
                            return generatorOrNext.complete();
                        });
                    } : function () {
                        generatorOrNext.complete();
                    };
                }
            } else {
                schedulerFn = this._isAsync ? function (value) {
                    setTimeout(function () {
                        return generatorOrNext(value);
                    });
                } : function (value) {
                    generatorOrNext(value);
                };
                if (error) {
                    errorFn = this._isAsync ? function (err) {
                        setTimeout(function () {
                            return error(err);
                        });
                    } : function (err) {
                        error(err);
                    };
                }
                if (complete) {
                    completeFn = this._isAsync ? function () {
                        setTimeout(function () {
                            return complete();
                        });
                    } : function () {
                        complete();
                    };
                }
            }
            return _super.prototype.subscribe.call(this, schedulerFn, errorFn, completeFn);
        };
        return EventEmitter;
    }(Subject_1.Subject);
    exports.EventEmitter = EventEmitter;
});
System.registerDynamic('angular2/src/core/linker/query_list.js', ['angular2/src/facade/collection.js', 'angular2/src/facade/lang.js', 'angular2/src/facade/async.js'], true, function ($__require, exports, module) {
  'use strict';"use strict";

  var global = this || self,
      GLOBAL = global;
  var collection_1 = $__require('angular2/src/facade/collection.js');
  var lang_1 = $__require('angular2/src/facade/lang.js');
  var async_1 = $__require('angular2/src/facade/async.js');
  /**
   * An unmodifiable list of items that Angular keeps up to date when the state
   * of the application changes.
   *
   * The type of object that {@link QueryMetadata} and {@link ViewQueryMetadata} provide.
   *
   * Implements an iterable interface, therefore it can be used in both ES6
   * javascript `for (var i of items)` loops as well as in Angular templates with
   * `*ngFor="#i of myList"`.
   *
   * Changes can be observed by subscribing to the changes `Observable`.
   *
   * NOTE: In the future this class will implement an `Observable` interface.
   *
   * ### Example ([live demo](http://plnkr.co/edit/RX8sJnQYl9FWuSCWme5z?p=preview))
   * ```typescript
   * @Component({...})
   * class Container {
   *   constructor(@Query(Item) items: QueryList<Item>) {
   *     items.changes.subscribe(_ => console.log(items.length));
   *   }
   * }
   * ```
   */
  var QueryList = function () {
    function QueryList() {
      this._results = [];
      this._emitter = new async_1.EventEmitter();
    }
    Object.defineProperty(QueryList.prototype, "changes", {
      get: function () {
        return this._emitter;
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(QueryList.prototype, "length", {
      get: function () {
        return this._results.length;
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(QueryList.prototype, "first", {
      get: function () {
        return collection_1.ListWrapper.first(this._results);
      },
      enumerable: true,
      configurable: true
    });
    Object.defineProperty(QueryList.prototype, "last", {
      get: function () {
        return collection_1.ListWrapper.last(this._results);
      },
      enumerable: true,
      configurable: true
    });
    /**
     * returns a new array with the passed in function applied to each element.
     */
    QueryList.prototype.map = function (fn) {
      return this._results.map(fn);
    };
    /**
     * returns a filtered array.
     */
    QueryList.prototype.filter = function (fn) {
      return this._results.filter(fn);
    };
    /**
     * returns a reduced value.
     */
    QueryList.prototype.reduce = function (fn, init) {
      return this._results.reduce(fn, init);
    };
    /**
     * executes function for each element in a query.
     */
    QueryList.prototype.forEach = function (fn) {
      this._results.forEach(fn);
    };
    /**
     * converts QueryList into an array
     */
    QueryList.prototype.toArray = function () {
      return collection_1.ListWrapper.clone(this._results);
    };
    QueryList.prototype[lang_1.getSymbolIterator()] = function () {
      return this._results[lang_1.getSymbolIterator()]();
    };
    QueryList.prototype.toString = function () {
      return this._results.toString();
    };
    /**
     * @internal
     */
    QueryList.prototype.reset = function (res) {
      this._results = res;
    };
    /** @internal */
    QueryList.prototype.notifyOnChanges = function () {
      this._emitter.emit(this);
    };
    return QueryList;
  }();
  exports.QueryList = QueryList;
});
System.registerDynamic('angular2/src/core/pipes/pipe_provider.js', ['angular2/src/core/di/provider.js', 'angular2/src/core/di.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var provider_1 = $__require('angular2/src/core/di/provider.js');
    var di_1 = $__require('angular2/src/core/di.js');
    var PipeProvider = function (_super) {
        __extends(PipeProvider, _super);
        function PipeProvider(name, pure, key, resolvedFactories, multiBinding) {
            _super.call(this, key, resolvedFactories, multiBinding);
            this.name = name;
            this.pure = pure;
        }
        PipeProvider.createFromType = function (type, metadata) {
            var provider = new di_1.Provider(type, { useClass: type });
            var rb = provider_1.resolveProvider(provider);
            return new PipeProvider(metadata.name, metadata.pure, rb.key, rb.resolvedFactories, rb.multiProvider);
        };
        return PipeProvider;
    }(provider_1.ResolvedProvider_);
    exports.PipeProvider = PipeProvider;
});
System.registerDynamic('angular2/src/core/linker/element.js', ['angular2/src/facade/lang.js', 'angular2/src/facade/exceptions.js', 'angular2/src/facade/collection.js', 'angular2/src/core/di.js', 'angular2/src/core/di/provider.js', 'angular2/src/core/di/injector.js', 'angular2/src/core/metadata/di.js', 'angular2/src/core/linker/view_type.js', 'angular2/src/core/linker/element_ref.js', 'angular2/src/core/linker/view_container_ref.js', 'angular2/src/core/render/api.js', 'angular2/src/core/linker/template_ref.js', 'angular2/src/core/metadata/directives.js', 'angular2/src/core/change_detection/change_detection.js', 'angular2/src/core/linker/query_list.js', 'angular2/src/core/reflection/reflection.js', 'angular2/src/core/pipes/pipe_provider.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var exceptions_1 = $__require('angular2/src/facade/exceptions.js');
    var collection_1 = $__require('angular2/src/facade/collection.js');
    var di_1 = $__require('angular2/src/core/di.js');
    var provider_1 = $__require('angular2/src/core/di/provider.js');
    var injector_1 = $__require('angular2/src/core/di/injector.js');
    var provider_2 = $__require('angular2/src/core/di/provider.js');
    var di_2 = $__require('angular2/src/core/metadata/di.js');
    var view_type_1 = $__require('angular2/src/core/linker/view_type.js');
    var element_ref_1 = $__require('angular2/src/core/linker/element_ref.js');
    var view_container_ref_1 = $__require('angular2/src/core/linker/view_container_ref.js');
    var element_ref_2 = $__require('angular2/src/core/linker/element_ref.js');
    var api_1 = $__require('angular2/src/core/render/api.js');
    var template_ref_1 = $__require('angular2/src/core/linker/template_ref.js');
    var directives_1 = $__require('angular2/src/core/metadata/directives.js');
    var change_detection_1 = $__require('angular2/src/core/change_detection/change_detection.js');
    var query_list_1 = $__require('angular2/src/core/linker/query_list.js');
    var reflection_1 = $__require('angular2/src/core/reflection/reflection.js');
    var pipe_provider_1 = $__require('angular2/src/core/pipes/pipe_provider.js');
    var view_container_ref_2 = $__require('angular2/src/core/linker/view_container_ref.js');
    var _staticKeys;
    var StaticKeys = function () {
        function StaticKeys() {
            this.templateRefId = di_1.Key.get(template_ref_1.TemplateRef).id;
            this.viewContainerId = di_1.Key.get(view_container_ref_1.ViewContainerRef).id;
            this.changeDetectorRefId = di_1.Key.get(change_detection_1.ChangeDetectorRef).id;
            this.elementRefId = di_1.Key.get(element_ref_2.ElementRef).id;
            this.rendererId = di_1.Key.get(api_1.Renderer).id;
        }
        StaticKeys.instance = function () {
            if (lang_1.isBlank(_staticKeys)) _staticKeys = new StaticKeys();
            return _staticKeys;
        };
        return StaticKeys;
    }();
    exports.StaticKeys = StaticKeys;
    var DirectiveDependency = function (_super) {
        __extends(DirectiveDependency, _super);
        function DirectiveDependency(key, optional, lowerBoundVisibility, upperBoundVisibility, properties, attributeName, queryDecorator) {
            _super.call(this, key, optional, lowerBoundVisibility, upperBoundVisibility, properties);
            this.attributeName = attributeName;
            this.queryDecorator = queryDecorator;
            this._verify();
        }
        /** @internal */
        DirectiveDependency.prototype._verify = function () {
            var count = 0;
            if (lang_1.isPresent(this.queryDecorator)) count++;
            if (lang_1.isPresent(this.attributeName)) count++;
            if (count > 1) throw new exceptions_1.BaseException('A directive injectable can contain only one of the following @Attribute or @Query.');
        };
        DirectiveDependency.createFrom = function (d) {
            return new DirectiveDependency(d.key, d.optional, d.lowerBoundVisibility, d.upperBoundVisibility, d.properties, DirectiveDependency._attributeName(d.properties), DirectiveDependency._query(d.properties));
        };
        /** @internal */
        DirectiveDependency._attributeName = function (properties) {
            var p = properties.find(function (p) {
                return p instanceof di_2.AttributeMetadata;
            });
            return lang_1.isPresent(p) ? p.attributeName : null;
        };
        /** @internal */
        DirectiveDependency._query = function (properties) {
            return properties.find(function (p) {
                return p instanceof di_2.QueryMetadata;
            });
        };
        return DirectiveDependency;
    }(di_1.Dependency);
    exports.DirectiveDependency = DirectiveDependency;
    var DirectiveProvider = function (_super) {
        __extends(DirectiveProvider, _super);
        function DirectiveProvider(key, factory, deps, isComponent, providers, viewProviders, queries) {
            _super.call(this, key, [new provider_2.ResolvedFactory(factory, deps)], false);
            this.isComponent = isComponent;
            this.providers = providers;
            this.viewProviders = viewProviders;
            this.queries = queries;
        }
        Object.defineProperty(DirectiveProvider.prototype, "displayName", {
            get: function () {
                return this.key.displayName;
            },
            enumerable: true,
            configurable: true
        });
        DirectiveProvider.createFromType = function (type, meta) {
            var provider = new di_1.Provider(type, { useClass: type });
            if (lang_1.isBlank(meta)) {
                meta = new directives_1.DirectiveMetadata();
            }
            var rb = provider_2.resolveProvider(provider);
            var rf = rb.resolvedFactories[0];
            var deps = rf.dependencies.map(DirectiveDependency.createFrom);
            var isComponent = meta instanceof directives_1.ComponentMetadata;
            var resolvedProviders = lang_1.isPresent(meta.providers) ? di_1.Injector.resolve(meta.providers) : null;
            var resolvedViewProviders = meta instanceof directives_1.ComponentMetadata && lang_1.isPresent(meta.viewProviders) ? di_1.Injector.resolve(meta.viewProviders) : null;
            var queries = [];
            if (lang_1.isPresent(meta.queries)) {
                collection_1.StringMapWrapper.forEach(meta.queries, function (meta, fieldName) {
                    var setter = reflection_1.reflector.setter(fieldName);
                    queries.push(new QueryMetadataWithSetter(setter, meta));
                });
            }
            // queries passed into the constructor.
            // TODO: remove this after constructor queries are no longer supported
            deps.forEach(function (d) {
                if (lang_1.isPresent(d.queryDecorator)) {
                    queries.push(new QueryMetadataWithSetter(null, d.queryDecorator));
                }
            });
            return new DirectiveProvider(rb.key, rf.factory, deps, isComponent, resolvedProviders, resolvedViewProviders, queries);
        };
        return DirectiveProvider;
    }(provider_2.ResolvedProvider_);
    exports.DirectiveProvider = DirectiveProvider;
    var QueryMetadataWithSetter = function () {
        function QueryMetadataWithSetter(setter, metadata) {
            this.setter = setter;
            this.metadata = metadata;
        }
        return QueryMetadataWithSetter;
    }();
    exports.QueryMetadataWithSetter = QueryMetadataWithSetter;
    function setProvidersVisibility(providers, visibility, result) {
        for (var i = 0; i < providers.length; i++) {
            result.set(providers[i].key.id, visibility);
        }
    }
    var AppProtoElement = function () {
        function AppProtoElement(firstProviderIsComponent, index, attributes, pwvs, protoQueryRefs, directiveVariableBindings) {
            this.firstProviderIsComponent = firstProviderIsComponent;
            this.index = index;
            this.attributes = attributes;
            this.protoQueryRefs = protoQueryRefs;
            this.directiveVariableBindings = directiveVariableBindings;
            var length = pwvs.length;
            if (length > 0) {
                this.protoInjector = new injector_1.ProtoInjector(pwvs);
            } else {
                this.protoInjector = null;
                this.protoQueryRefs = [];
            }
        }
        AppProtoElement.create = function (metadataCache, index, attributes, directiveTypes, directiveVariableBindings) {
            var componentDirProvider = null;
            var mergedProvidersMap = new Map();
            var providerVisibilityMap = new Map();
            var providers = collection_1.ListWrapper.createGrowableSize(directiveTypes.length);
            var protoQueryRefs = [];
            for (var i = 0; i < directiveTypes.length; i++) {
                var dirProvider = metadataCache.getResolvedDirectiveMetadata(directiveTypes[i]);
                providers[i] = new injector_1.ProviderWithVisibility(dirProvider, dirProvider.isComponent ? injector_1.Visibility.PublicAndPrivate : injector_1.Visibility.Public);
                if (dirProvider.isComponent) {
                    componentDirProvider = dirProvider;
                } else {
                    if (lang_1.isPresent(dirProvider.providers)) {
                        provider_1.mergeResolvedProviders(dirProvider.providers, mergedProvidersMap);
                        setProvidersVisibility(dirProvider.providers, injector_1.Visibility.Public, providerVisibilityMap);
                    }
                }
                if (lang_1.isPresent(dirProvider.viewProviders)) {
                    provider_1.mergeResolvedProviders(dirProvider.viewProviders, mergedProvidersMap);
                    setProvidersVisibility(dirProvider.viewProviders, injector_1.Visibility.Private, providerVisibilityMap);
                }
                for (var queryIdx = 0; queryIdx < dirProvider.queries.length; queryIdx++) {
                    var q = dirProvider.queries[queryIdx];
                    protoQueryRefs.push(new ProtoQueryRef(i, q.setter, q.metadata));
                }
            }
            if (lang_1.isPresent(componentDirProvider) && lang_1.isPresent(componentDirProvider.providers)) {
                // directive providers need to be prioritized over component providers
                provider_1.mergeResolvedProviders(componentDirProvider.providers, mergedProvidersMap);
                setProvidersVisibility(componentDirProvider.providers, injector_1.Visibility.Public, providerVisibilityMap);
            }
            mergedProvidersMap.forEach(function (provider, _) {
                providers.push(new injector_1.ProviderWithVisibility(provider, providerVisibilityMap.get(provider.key.id)));
            });
            return new AppProtoElement(lang_1.isPresent(componentDirProvider), index, attributes, providers, protoQueryRefs, directiveVariableBindings);
        };
        AppProtoElement.prototype.getProviderAtIndex = function (index) {
            return this.protoInjector.getProviderAtIndex(index);
        };
        return AppProtoElement;
    }();
    exports.AppProtoElement = AppProtoElement;
    var _Context = function () {
        function _Context(element, componentElement, injector) {
            this.element = element;
            this.componentElement = componentElement;
            this.injector = injector;
        }
        return _Context;
    }();
    var InjectorWithHostBoundary = function () {
        function InjectorWithHostBoundary(injector, hostInjectorBoundary) {
            this.injector = injector;
            this.hostInjectorBoundary = hostInjectorBoundary;
        }
        return InjectorWithHostBoundary;
    }();
    exports.InjectorWithHostBoundary = InjectorWithHostBoundary;
    var AppElement = function () {
        function AppElement(proto, parentView, parent, nativeElement, embeddedViewFactory) {
            var _this = this;
            this.proto = proto;
            this.parentView = parentView;
            this.parent = parent;
            this.nativeElement = nativeElement;
            this.embeddedViewFactory = embeddedViewFactory;
            this.nestedViews = null;
            this.componentView = null;
            this.ref = new element_ref_1.ElementRef_(this);
            var parentInjector = lang_1.isPresent(parent) ? parent._injector : parentView.parentInjector;
            if (lang_1.isPresent(this.proto.protoInjector)) {
                var isBoundary;
                if (lang_1.isPresent(parent) && lang_1.isPresent(parent.proto.protoInjector)) {
                    isBoundary = false;
                } else {
                    isBoundary = parentView.hostInjectorBoundary;
                }
                this._queryStrategy = this._buildQueryStrategy();
                this._injector = new di_1.Injector(this.proto.protoInjector, parentInjector, isBoundary, this, function () {
                    return _this._debugContext();
                });
                // we couple ourselves to the injector strategy to avoid polymorphic calls
                var injectorStrategy = this._injector.internalStrategy;
                this._strategy = injectorStrategy instanceof injector_1.InjectorInlineStrategy ? new ElementDirectiveInlineStrategy(injectorStrategy, this) : new ElementDirectiveDynamicStrategy(injectorStrategy, this);
                this._strategy.init();
            } else {
                this._queryStrategy = null;
                this._injector = parentInjector;
                this._strategy = null;
            }
        }
        AppElement.getViewParentInjector = function (parentViewType, containerAppElement, imperativelyCreatedProviders, rootInjector) {
            var parentInjector;
            var hostInjectorBoundary;
            switch (parentViewType) {
                case view_type_1.ViewType.COMPONENT:
                    parentInjector = containerAppElement._injector;
                    hostInjectorBoundary = true;
                    break;
                case view_type_1.ViewType.EMBEDDED:
                    parentInjector = lang_1.isPresent(containerAppElement.proto.protoInjector) ? containerAppElement._injector.parent : containerAppElement._injector;
                    hostInjectorBoundary = containerAppElement._injector.hostBoundary;
                    break;
                case view_type_1.ViewType.HOST:
                    if (lang_1.isPresent(containerAppElement)) {
                        // host view is attached to a container
                        parentInjector = lang_1.isPresent(containerAppElement.proto.protoInjector) ? containerAppElement._injector.parent : containerAppElement._injector;
                        if (lang_1.isPresent(imperativelyCreatedProviders)) {
                            var imperativeProvidersWithVisibility = imperativelyCreatedProviders.map(function (p) {
                                return new injector_1.ProviderWithVisibility(p, injector_1.Visibility.Public);
                            });
                            // The imperative injector is similar to having an element between
                            // the dynamic-loaded component and its parent => no boundary between
                            // the component and imperativelyCreatedInjector.
                            parentInjector = new di_1.Injector(new injector_1.ProtoInjector(imperativeProvidersWithVisibility), parentInjector, true, null, null);
                            hostInjectorBoundary = false;
                        } else {
                            hostInjectorBoundary = containerAppElement._injector.hostBoundary;
                        }
                    } else {
                        // bootstrap
                        parentInjector = rootInjector;
                        hostInjectorBoundary = true;
                    }
                    break;
            }
            return new InjectorWithHostBoundary(parentInjector, hostInjectorBoundary);
        };
        AppElement.prototype.attachComponentView = function (componentView) {
            this.componentView = componentView;
        };
        AppElement.prototype._debugContext = function () {
            var c = this.parentView.getDebugContext(this, null, null);
            return lang_1.isPresent(c) ? new _Context(c.element, c.componentElement, c.injector) : null;
        };
        AppElement.prototype.hasVariableBinding = function (name) {
            var vb = this.proto.directiveVariableBindings;
            return lang_1.isPresent(vb) && collection_1.StringMapWrapper.contains(vb, name);
        };
        AppElement.prototype.getVariableBinding = function (name) {
            var index = this.proto.directiveVariableBindings[name];
            return lang_1.isPresent(index) ? this.getDirectiveAtIndex(index) : this.getElementRef();
        };
        AppElement.prototype.get = function (token) {
            return this._injector.get(token);
        };
        AppElement.prototype.hasDirective = function (type) {
            return lang_1.isPresent(this._injector.getOptional(type));
        };
        AppElement.prototype.getComponent = function () {
            return lang_1.isPresent(this._strategy) ? this._strategy.getComponent() : null;
        };
        AppElement.prototype.getInjector = function () {
            return this._injector;
        };
        AppElement.prototype.getElementRef = function () {
            return this.ref;
        };
        AppElement.prototype.getViewContainerRef = function () {
            return new view_container_ref_2.ViewContainerRef_(this);
        };
        AppElement.prototype.getTemplateRef = function () {
            if (lang_1.isPresent(this.embeddedViewFactory)) {
                return new template_ref_1.TemplateRef_(this.ref);
            }
            return null;
        };
        AppElement.prototype.getDependency = function (injector, provider, dep) {
            if (provider instanceof DirectiveProvider) {
                var dirDep = dep;
                if (lang_1.isPresent(dirDep.attributeName)) return this._buildAttribute(dirDep);
                if (lang_1.isPresent(dirDep.queryDecorator)) return this._queryStrategy.findQuery(dirDep.queryDecorator).list;
                if (dirDep.key.id === StaticKeys.instance().changeDetectorRefId) {
                    // We provide the component's view change detector to components and
                    // the surrounding component's change detector to directives.
                    if (this.proto.firstProviderIsComponent) {
                        // Note: The component view is not yet created when
                        // this method is called!
                        return new _ComponentViewChangeDetectorRef(this);
                    } else {
                        return this.parentView.changeDetector.ref;
                    }
                }
                if (dirDep.key.id === StaticKeys.instance().elementRefId) {
                    return this.getElementRef();
                }
                if (dirDep.key.id === StaticKeys.instance().viewContainerId) {
                    return this.getViewContainerRef();
                }
                if (dirDep.key.id === StaticKeys.instance().templateRefId) {
                    var tr = this.getTemplateRef();
                    if (lang_1.isBlank(tr) && !dirDep.optional) {
                        throw new di_1.NoProviderError(null, dirDep.key);
                    }
                    return tr;
                }
                if (dirDep.key.id === StaticKeys.instance().rendererId) {
                    return this.parentView.renderer;
                }
            } else if (provider instanceof pipe_provider_1.PipeProvider) {
                if (dep.key.id === StaticKeys.instance().changeDetectorRefId) {
                    // We provide the component's view change detector to components and
                    // the surrounding component's change detector to directives.
                    if (this.proto.firstProviderIsComponent) {
                        // Note: The component view is not yet created when
                        // this method is called!
                        return new _ComponentViewChangeDetectorRef(this);
                    } else {
                        return this.parentView.changeDetector;
                    }
                }
            }
            return injector_1.UNDEFINED;
        };
        AppElement.prototype._buildAttribute = function (dep) {
            var attributes = this.proto.attributes;
            if (lang_1.isPresent(attributes) && collection_1.StringMapWrapper.contains(attributes, dep.attributeName)) {
                return attributes[dep.attributeName];
            } else {
                return null;
            }
        };
        AppElement.prototype.addDirectivesMatchingQuery = function (query, list) {
            var templateRef = this.getTemplateRef();
            if (query.selector === template_ref_1.TemplateRef && lang_1.isPresent(templateRef)) {
                list.push(templateRef);
            }
            if (this._strategy != null) {
                this._strategy.addDirectivesMatchingQuery(query, list);
            }
        };
        AppElement.prototype._buildQueryStrategy = function () {
            if (this.proto.protoQueryRefs.length === 0) {
                return _emptyQueryStrategy;
            } else if (this.proto.protoQueryRefs.length <= InlineQueryStrategy.NUMBER_OF_SUPPORTED_QUERIES) {
                return new InlineQueryStrategy(this);
            } else {
                return new DynamicQueryStrategy(this);
            }
        };
        AppElement.prototype.getDirectiveAtIndex = function (index) {
            return this._injector.getAt(index);
        };
        AppElement.prototype.ngAfterViewChecked = function () {
            if (lang_1.isPresent(this._queryStrategy)) this._queryStrategy.updateViewQueries();
        };
        AppElement.prototype.ngAfterContentChecked = function () {
            if (lang_1.isPresent(this._queryStrategy)) this._queryStrategy.updateContentQueries();
        };
        AppElement.prototype.traverseAndSetQueriesAsDirty = function () {
            var inj = this;
            while (lang_1.isPresent(inj)) {
                inj._setQueriesAsDirty();
                if (lang_1.isBlank(inj.parent) && inj.parentView.proto.type === view_type_1.ViewType.EMBEDDED) {
                    inj = inj.parentView.containerAppElement;
                } else {
                    inj = inj.parent;
                }
            }
        };
        AppElement.prototype._setQueriesAsDirty = function () {
            if (lang_1.isPresent(this._queryStrategy)) {
                this._queryStrategy.setContentQueriesAsDirty();
            }
            if (this.parentView.proto.type === view_type_1.ViewType.COMPONENT) {
                this.parentView.containerAppElement._queryStrategy.setViewQueriesAsDirty();
            }
        };
        return AppElement;
    }();
    exports.AppElement = AppElement;
    var _EmptyQueryStrategy = function () {
        function _EmptyQueryStrategy() {}
        _EmptyQueryStrategy.prototype.setContentQueriesAsDirty = function () {};
        _EmptyQueryStrategy.prototype.setViewQueriesAsDirty = function () {};
        _EmptyQueryStrategy.prototype.updateContentQueries = function () {};
        _EmptyQueryStrategy.prototype.updateViewQueries = function () {};
        _EmptyQueryStrategy.prototype.findQuery = function (query) {
            throw new exceptions_1.BaseException("Cannot find query for directive " + query + ".");
        };
        return _EmptyQueryStrategy;
    }();
    var _emptyQueryStrategy = new _EmptyQueryStrategy();
    var InlineQueryStrategy = function () {
        function InlineQueryStrategy(ei) {
            var protoRefs = ei.proto.protoQueryRefs;
            if (protoRefs.length > 0) this.query0 = new QueryRef(protoRefs[0], ei);
            if (protoRefs.length > 1) this.query1 = new QueryRef(protoRefs[1], ei);
            if (protoRefs.length > 2) this.query2 = new QueryRef(protoRefs[2], ei);
        }
        InlineQueryStrategy.prototype.setContentQueriesAsDirty = function () {
            if (lang_1.isPresent(this.query0) && !this.query0.isViewQuery) this.query0.dirty = true;
            if (lang_1.isPresent(this.query1) && !this.query1.isViewQuery) this.query1.dirty = true;
            if (lang_1.isPresent(this.query2) && !this.query2.isViewQuery) this.query2.dirty = true;
        };
        InlineQueryStrategy.prototype.setViewQueriesAsDirty = function () {
            if (lang_1.isPresent(this.query0) && this.query0.isViewQuery) this.query0.dirty = true;
            if (lang_1.isPresent(this.query1) && this.query1.isViewQuery) this.query1.dirty = true;
            if (lang_1.isPresent(this.query2) && this.query2.isViewQuery) this.query2.dirty = true;
        };
        InlineQueryStrategy.prototype.updateContentQueries = function () {
            if (lang_1.isPresent(this.query0) && !this.query0.isViewQuery) {
                this.query0.update();
            }
            if (lang_1.isPresent(this.query1) && !this.query1.isViewQuery) {
                this.query1.update();
            }
            if (lang_1.isPresent(this.query2) && !this.query2.isViewQuery) {
                this.query2.update();
            }
        };
        InlineQueryStrategy.prototype.updateViewQueries = function () {
            if (lang_1.isPresent(this.query0) && this.query0.isViewQuery) {
                this.query0.update();
            }
            if (lang_1.isPresent(this.query1) && this.query1.isViewQuery) {
                this.query1.update();
            }
            if (lang_1.isPresent(this.query2) && this.query2.isViewQuery) {
                this.query2.update();
            }
        };
        InlineQueryStrategy.prototype.findQuery = function (query) {
            if (lang_1.isPresent(this.query0) && this.query0.protoQueryRef.query === query) {
                return this.query0;
            }
            if (lang_1.isPresent(this.query1) && this.query1.protoQueryRef.query === query) {
                return this.query1;
            }
            if (lang_1.isPresent(this.query2) && this.query2.protoQueryRef.query === query) {
                return this.query2;
            }
            throw new exceptions_1.BaseException("Cannot find query for directive " + query + ".");
        };
        InlineQueryStrategy.NUMBER_OF_SUPPORTED_QUERIES = 3;
        return InlineQueryStrategy;
    }();
    var DynamicQueryStrategy = function () {
        function DynamicQueryStrategy(ei) {
            this.queries = ei.proto.protoQueryRefs.map(function (p) {
                return new QueryRef(p, ei);
            });
        }
        DynamicQueryStrategy.prototype.setContentQueriesAsDirty = function () {
            for (var i = 0; i < this.queries.length; ++i) {
                var q = this.queries[i];
                if (!q.isViewQuery) q.dirty = true;
            }
        };
        DynamicQueryStrategy.prototype.setViewQueriesAsDirty = function () {
            for (var i = 0; i < this.queries.length; ++i) {
                var q = this.queries[i];
                if (q.isViewQuery) q.dirty = true;
            }
        };
        DynamicQueryStrategy.prototype.updateContentQueries = function () {
            for (var i = 0; i < this.queries.length; ++i) {
                var q = this.queries[i];
                if (!q.isViewQuery) {
                    q.update();
                }
            }
        };
        DynamicQueryStrategy.prototype.updateViewQueries = function () {
            for (var i = 0; i < this.queries.length; ++i) {
                var q = this.queries[i];
                if (q.isViewQuery) {
                    q.update();
                }
            }
        };
        DynamicQueryStrategy.prototype.findQuery = function (query) {
            for (var i = 0; i < this.queries.length; ++i) {
                var q = this.queries[i];
                if (q.protoQueryRef.query === query) {
                    return q;
                }
            }
            throw new exceptions_1.BaseException("Cannot find query for directive " + query + ".");
        };
        return DynamicQueryStrategy;
    }();
    /**
     * Strategy used by the `ElementInjector` when the number of providers is 10 or less.
     * In such a case, inlining fields is beneficial for performances.
     */
    var ElementDirectiveInlineStrategy = function () {
        function ElementDirectiveInlineStrategy(injectorStrategy, _ei) {
            this.injectorStrategy = injectorStrategy;
            this._ei = _ei;
        }
        ElementDirectiveInlineStrategy.prototype.init = function () {
            var i = this.injectorStrategy;
            var p = i.protoStrategy;
            i.resetConstructionCounter();
            if (p.provider0 instanceof DirectiveProvider && lang_1.isPresent(p.keyId0) && i.obj0 === injector_1.UNDEFINED) i.obj0 = i.instantiateProvider(p.provider0, p.visibility0);
            if (p.provider1 instanceof DirectiveProvider && lang_1.isPresent(p.keyId1) && i.obj1 === injector_1.UNDEFINED) i.obj1 = i.instantiateProvider(p.provider1, p.visibility1);
            if (p.provider2 instanceof DirectiveProvider && lang_1.isPresent(p.keyId2) && i.obj2 === injector_1.UNDEFINED) i.obj2 = i.instantiateProvider(p.provider2, p.visibility2);
            if (p.provider3 instanceof DirectiveProvider && lang_1.isPresent(p.keyId3) && i.obj3 === injector_1.UNDEFINED) i.obj3 = i.instantiateProvider(p.provider3, p.visibility3);
            if (p.provider4 instanceof DirectiveProvider && lang_1.isPresent(p.keyId4) && i.obj4 === injector_1.UNDEFINED) i.obj4 = i.instantiateProvider(p.provider4, p.visibility4);
            if (p.provider5 instanceof DirectiveProvider && lang_1.isPresent(p.keyId5) && i.obj5 === injector_1.UNDEFINED) i.obj5 = i.instantiateProvider(p.provider5, p.visibility5);
            if (p.provider6 instanceof DirectiveProvider && lang_1.isPresent(p.keyId6) && i.obj6 === injector_1.UNDEFINED) i.obj6 = i.instantiateProvider(p.provider6, p.visibility6);
            if (p.provider7 instanceof DirectiveProvider && lang_1.isPresent(p.keyId7) && i.obj7 === injector_1.UNDEFINED) i.obj7 = i.instantiateProvider(p.provider7, p.visibility7);
            if (p.provider8 instanceof DirectiveProvider && lang_1.isPresent(p.keyId8) && i.obj8 === injector_1.UNDEFINED) i.obj8 = i.instantiateProvider(p.provider8, p.visibility8);
            if (p.provider9 instanceof DirectiveProvider && lang_1.isPresent(p.keyId9) && i.obj9 === injector_1.UNDEFINED) i.obj9 = i.instantiateProvider(p.provider9, p.visibility9);
        };
        ElementDirectiveInlineStrategy.prototype.getComponent = function () {
            return this.injectorStrategy.obj0;
        };
        ElementDirectiveInlineStrategy.prototype.isComponentKey = function (key) {
            return this._ei.proto.firstProviderIsComponent && lang_1.isPresent(key) && key.id === this.injectorStrategy.protoStrategy.keyId0;
        };
        ElementDirectiveInlineStrategy.prototype.addDirectivesMatchingQuery = function (query, list) {
            var i = this.injectorStrategy;
            var p = i.protoStrategy;
            if (lang_1.isPresent(p.provider0) && p.provider0.key.token === query.selector) {
                if (i.obj0 === injector_1.UNDEFINED) i.obj0 = i.instantiateProvider(p.provider0, p.visibility0);
                list.push(i.obj0);
            }
            if (lang_1.isPresent(p.provider1) && p.provider1.key.token === query.selector) {
                if (i.obj1 === injector_1.UNDEFINED) i.obj1 = i.instantiateProvider(p.provider1, p.visibility1);
                list.push(i.obj1);
            }
            if (lang_1.isPresent(p.provider2) && p.provider2.key.token === query.selector) {
                if (i.obj2 === injector_1.UNDEFINED) i.obj2 = i.instantiateProvider(p.provider2, p.visibility2);
                list.push(i.obj2);
            }
            if (lang_1.isPresent(p.provider3) && p.provider3.key.token === query.selector) {
                if (i.obj3 === injector_1.UNDEFINED) i.obj3 = i.instantiateProvider(p.provider3, p.visibility3);
                list.push(i.obj3);
            }
            if (lang_1.isPresent(p.provider4) && p.provider4.key.token === query.selector) {
                if (i.obj4 === injector_1.UNDEFINED) i.obj4 = i.instantiateProvider(p.provider4, p.visibility4);
                list.push(i.obj4);
            }
            if (lang_1.isPresent(p.provider5) && p.provider5.key.token === query.selector) {
                if (i.obj5 === injector_1.UNDEFINED) i.obj5 = i.instantiateProvider(p.provider5, p.visibility5);
                list.push(i.obj5);
            }
            if (lang_1.isPresent(p.provider6) && p.provider6.key.token === query.selector) {
                if (i.obj6 === injector_1.UNDEFINED) i.obj6 = i.instantiateProvider(p.provider6, p.visibility6);
                list.push(i.obj6);
            }
            if (lang_1.isPresent(p.provider7) && p.provider7.key.token === query.selector) {
                if (i.obj7 === injector_1.UNDEFINED) i.obj7 = i.instantiateProvider(p.provider7, p.visibility7);
                list.push(i.obj7);
            }
            if (lang_1.isPresent(p.provider8) && p.provider8.key.token === query.selector) {
                if (i.obj8 === injector_1.UNDEFINED) i.obj8 = i.instantiateProvider(p.provider8, p.visibility8);
                list.push(i.obj8);
            }
            if (lang_1.isPresent(p.provider9) && p.provider9.key.token === query.selector) {
                if (i.obj9 === injector_1.UNDEFINED) i.obj9 = i.instantiateProvider(p.provider9, p.visibility9);
                list.push(i.obj9);
            }
        };
        return ElementDirectiveInlineStrategy;
    }();
    /**
     * Strategy used by the `ElementInjector` when the number of bindings is 11 or more.
     * In such a case, there are too many fields to inline (see ElementInjectorInlineStrategy).
     */
    var ElementDirectiveDynamicStrategy = function () {
        function ElementDirectiveDynamicStrategy(injectorStrategy, _ei) {
            this.injectorStrategy = injectorStrategy;
            this._ei = _ei;
        }
        ElementDirectiveDynamicStrategy.prototype.init = function () {
            var inj = this.injectorStrategy;
            var p = inj.protoStrategy;
            inj.resetConstructionCounter();
            for (var i = 0; i < p.keyIds.length; i++) {
                if (p.providers[i] instanceof DirectiveProvider && lang_1.isPresent(p.keyIds[i]) && inj.objs[i] === injector_1.UNDEFINED) {
                    inj.objs[i] = inj.instantiateProvider(p.providers[i], p.visibilities[i]);
                }
            }
        };
        ElementDirectiveDynamicStrategy.prototype.getComponent = function () {
            return this.injectorStrategy.objs[0];
        };
        ElementDirectiveDynamicStrategy.prototype.isComponentKey = function (key) {
            var p = this.injectorStrategy.protoStrategy;
            return this._ei.proto.firstProviderIsComponent && lang_1.isPresent(key) && key.id === p.keyIds[0];
        };
        ElementDirectiveDynamicStrategy.prototype.addDirectivesMatchingQuery = function (query, list) {
            var ist = this.injectorStrategy;
            var p = ist.protoStrategy;
            for (var i = 0; i < p.providers.length; i++) {
                if (p.providers[i].key.token === query.selector) {
                    if (ist.objs[i] === injector_1.UNDEFINED) {
                        ist.objs[i] = ist.instantiateProvider(p.providers[i], p.visibilities[i]);
                    }
                    list.push(ist.objs[i]);
                }
            }
        };
        return ElementDirectiveDynamicStrategy;
    }();
    var ProtoQueryRef = function () {
        function ProtoQueryRef(dirIndex, setter, query) {
            this.dirIndex = dirIndex;
            this.setter = setter;
            this.query = query;
        }
        Object.defineProperty(ProtoQueryRef.prototype, "usesPropertySyntax", {
            get: function () {
                return lang_1.isPresent(this.setter);
            },
            enumerable: true,
            configurable: true
        });
        return ProtoQueryRef;
    }();
    exports.ProtoQueryRef = ProtoQueryRef;
    var QueryRef = function () {
        function QueryRef(protoQueryRef, originator) {
            this.protoQueryRef = protoQueryRef;
            this.originator = originator;
            this.list = new query_list_1.QueryList();
            this.dirty = true;
        }
        Object.defineProperty(QueryRef.prototype, "isViewQuery", {
            get: function () {
                return this.protoQueryRef.query.isViewQuery;
            },
            enumerable: true,
            configurable: true
        });
        QueryRef.prototype.update = function () {
            if (!this.dirty) return;
            this._update();
            this.dirty = false;
            // TODO delete the check once only field queries are supported
            if (this.protoQueryRef.usesPropertySyntax) {
                var dir = this.originator.getDirectiveAtIndex(this.protoQueryRef.dirIndex);
                if (this.protoQueryRef.query.first) {
                    this.protoQueryRef.setter(dir, this.list.length > 0 ? this.list.first : null);
                } else {
                    this.protoQueryRef.setter(dir, this.list);
                }
            }
            this.list.notifyOnChanges();
        };
        QueryRef.prototype._update = function () {
            var aggregator = [];
            if (this.protoQueryRef.query.isViewQuery) {
                // intentionally skipping originator for view queries.
                var nestedView = this.originator.componentView;
                if (lang_1.isPresent(nestedView)) this._visitView(nestedView, aggregator);
            } else {
                this._visit(this.originator, aggregator);
            }
            this.list.reset(aggregator);
        };
        ;
        QueryRef.prototype._visit = function (inj, aggregator) {
            var view = inj.parentView;
            var startIdx = inj.proto.index;
            for (var i = startIdx; i < view.appElements.length; i++) {
                var curInj = view.appElements[i];
                // The first injector after inj, that is outside the subtree rooted at
                // inj has to have a null parent or a parent that is an ancestor of inj.
                if (i > startIdx && (lang_1.isBlank(curInj.parent) || curInj.parent.proto.index < startIdx)) {
                    break;
                }
                if (!this.protoQueryRef.query.descendants && !(curInj.parent == this.originator || curInj == this.originator)) continue;
                // We visit the view container(VC) views right after the injector that contains
                // the VC. Theoretically, that might not be the right order if there are
                // child injectors of said injector. Not clear whether if such case can
                // even be constructed with the current apis.
                this._visitInjector(curInj, aggregator);
                this._visitViewContainerViews(curInj.nestedViews, aggregator);
            }
        };
        QueryRef.prototype._visitInjector = function (inj, aggregator) {
            if (this.protoQueryRef.query.isVarBindingQuery) {
                this._aggregateVariableBinding(inj, aggregator);
            } else {
                this._aggregateDirective(inj, aggregator);
            }
        };
        QueryRef.prototype._visitViewContainerViews = function (views, aggregator) {
            if (lang_1.isPresent(views)) {
                for (var j = 0; j < views.length; j++) {
                    this._visitView(views[j], aggregator);
                }
            }
        };
        QueryRef.prototype._visitView = function (view, aggregator) {
            for (var i = 0; i < view.appElements.length; i++) {
                var inj = view.appElements[i];
                this._visitInjector(inj, aggregator);
                this._visitViewContainerViews(inj.nestedViews, aggregator);
            }
        };
        QueryRef.prototype._aggregateVariableBinding = function (inj, aggregator) {
            var vb = this.protoQueryRef.query.varBindings;
            for (var i = 0; i < vb.length; ++i) {
                if (inj.hasVariableBinding(vb[i])) {
                    aggregator.push(inj.getVariableBinding(vb[i]));
                }
            }
        };
        QueryRef.prototype._aggregateDirective = function (inj, aggregator) {
            inj.addDirectivesMatchingQuery(this.protoQueryRef.query, aggregator);
        };
        return QueryRef;
    }();
    exports.QueryRef = QueryRef;
    var _ComponentViewChangeDetectorRef = function (_super) {
        __extends(_ComponentViewChangeDetectorRef, _super);
        function _ComponentViewChangeDetectorRef(_appElement) {
            _super.call(this);
            this._appElement = _appElement;
        }
        _ComponentViewChangeDetectorRef.prototype.markForCheck = function () {
            this._appElement.componentView.changeDetector.ref.markForCheck();
        };
        _ComponentViewChangeDetectorRef.prototype.detach = function () {
            this._appElement.componentView.changeDetector.ref.detach();
        };
        _ComponentViewChangeDetectorRef.prototype.detectChanges = function () {
            this._appElement.componentView.changeDetector.ref.detectChanges();
        };
        _ComponentViewChangeDetectorRef.prototype.checkNoChanges = function () {
            this._appElement.componentView.changeDetector.ref.checkNoChanges();
        };
        _ComponentViewChangeDetectorRef.prototype.reattach = function () {
            this._appElement.componentView.changeDetector.ref.reattach();
        };
        return _ComponentViewChangeDetectorRef;
    }(change_detection_1.ChangeDetectorRef);
});
System.registerDynamic('angular2/src/core/linker/view_ref.js', ['angular2/src/facade/exceptions.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var exceptions_1 = $__require('angular2/src/facade/exceptions.js');
    var ViewRef = function () {
        function ViewRef() {}
        Object.defineProperty(ViewRef.prototype, "changeDetectorRef", {
            /**
             * @internal
             */
            get: function () {
                return exceptions_1.unimplemented();
            },
            enumerable: true,
            configurable: true
        });
        ;
        Object.defineProperty(ViewRef.prototype, "destroyed", {
            get: function () {
                return exceptions_1.unimplemented();
            },
            enumerable: true,
            configurable: true
        });
        return ViewRef;
    }();
    exports.ViewRef = ViewRef;
    /**
     * Represents a View containing a single Element that is the Host Element of a {@link Component}
     * instance.
     *
     * A Host View is created for every dynamically created Component that was compiled on its own (as
     * opposed to as a part of another Component's Template) via {@link Compiler#compileInHost} or one
     * of the higher-level APIs: {@link AppViewManager#createRootHostView},
     * {@link AppViewManager#createHostViewInContainer}, {@link ViewContainerRef#createHostView}.
     */
    var HostViewRef = function (_super) {
        __extends(HostViewRef, _super);
        function HostViewRef() {
            _super.apply(this, arguments);
        }
        Object.defineProperty(HostViewRef.prototype, "rootNodes", {
            get: function () {
                return exceptions_1.unimplemented();
            },
            enumerable: true,
            configurable: true
        });
        ;
        return HostViewRef;
    }(ViewRef);
    exports.HostViewRef = HostViewRef;
    /**
     * Represents an Angular View.
     *
     * <!-- TODO: move the next two paragraphs to the dev guide -->
     * A View is a fundamental building block of the application UI. It is the smallest grouping of
     * Elements which are created and destroyed together.
     *
     * Properties of elements in a View can change, but the structure (number and order) of elements in
     * a View cannot. Changing the structure of Elements can only be done by inserting, moving or
     * removing nested Views via a {@link ViewContainerRef}. Each View can contain many View Containers.
     * <!-- /TODO -->
     *
     * ### Example
     *
     * Given this template...
     *
     * ```
     * Count: {{items.length}}
     * <ul>
     *   <li *ngFor="var item of items">{{item}}</li>
     * </ul>
     * ```
     *
     * ... we have two {@link ProtoViewRef}s:
     *
     * Outer {@link ProtoViewRef}:
     * ```
     * Count: {{items.length}}
     * <ul>
     *   <template ngFor var-item [ngForOf]="items"></template>
     * </ul>
     * ```
     *
     * Inner {@link ProtoViewRef}:
     * ```
     *   <li>{{item}}</li>
     * ```
     *
     * Notice that the original template is broken down into two separate {@link ProtoViewRef}s.
     *
     * The outer/inner {@link ProtoViewRef}s are then assembled into views like so:
     *
     * ```
     * <!-- ViewRef: outer-0 -->
     * Count: 2
     * <ul>
     *   <template view-container-ref></template>
     *   <!-- ViewRef: inner-1 --><li>first</li><!-- /ViewRef: inner-1 -->
     *   <!-- ViewRef: inner-2 --><li>second</li><!-- /ViewRef: inner-2 -->
     * </ul>
     * <!-- /ViewRef: outer-0 -->
     * ```
     */
    var EmbeddedViewRef = function (_super) {
        __extends(EmbeddedViewRef, _super);
        function EmbeddedViewRef() {
            _super.apply(this, arguments);
        }
        Object.defineProperty(EmbeddedViewRef.prototype, "rootNodes", {
            get: function () {
                return exceptions_1.unimplemented();
            },
            enumerable: true,
            configurable: true
        });
        ;
        return EmbeddedViewRef;
    }(ViewRef);
    exports.EmbeddedViewRef = EmbeddedViewRef;
    var ViewRef_ = function () {
        function ViewRef_(_view) {
            this._view = _view;
            this._view = _view;
        }
        Object.defineProperty(ViewRef_.prototype, "internalView", {
            get: function () {
                return this._view;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ViewRef_.prototype, "changeDetectorRef", {
            /**
             * Return `ChangeDetectorRef`
             */
            get: function () {
                return this._view.changeDetector.ref;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ViewRef_.prototype, "rootNodes", {
            get: function () {
                return this._view.flatRootNodes;
            },
            enumerable: true,
            configurable: true
        });
        ViewRef_.prototype.setLocal = function (variableName, value) {
            this._view.setLocal(variableName, value);
        };
        ViewRef_.prototype.hasLocal = function (variableName) {
            return this._view.hasLocal(variableName);
        };
        Object.defineProperty(ViewRef_.prototype, "destroyed", {
            get: function () {
                return this._view.destroyed;
            },
            enumerable: true,
            configurable: true
        });
        return ViewRef_;
    }();
    exports.ViewRef_ = ViewRef_;
    var HostViewFactoryRef = function () {
        function HostViewFactoryRef() {}
        return HostViewFactoryRef;
    }();
    exports.HostViewFactoryRef = HostViewFactoryRef;
    var HostViewFactoryRef_ = function () {
        function HostViewFactoryRef_(_hostViewFactory) {
            this._hostViewFactory = _hostViewFactory;
        }
        Object.defineProperty(HostViewFactoryRef_.prototype, "internalHostViewFactory", {
            get: function () {
                return this._hostViewFactory;
            },
            enumerable: true,
            configurable: true
        });
        return HostViewFactoryRef_;
    }();
    exports.HostViewFactoryRef_ = HostViewFactoryRef_;
});
System.registerDynamic("angular2/src/core/change_detection/pipes.js", [], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var SelectedPipe = function () {
        function SelectedPipe(pipe, pure) {
            this.pipe = pipe;
            this.pure = pure;
        }
        return SelectedPipe;
    }();
    exports.SelectedPipe = SelectedPipe;
});
System.registerDynamic('angular2/src/core/pipes/pipes.js', ['angular2/src/facade/lang.js', 'angular2/src/facade/exceptions.js', 'angular2/src/facade/collection.js', 'angular2/src/core/change_detection/pipes.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var exceptions_1 = $__require('angular2/src/facade/exceptions.js');
    var collection_1 = $__require('angular2/src/facade/collection.js');
    var cd = $__require('angular2/src/core/change_detection/pipes.js');
    var ProtoPipes = function () {
        function ProtoPipes(
        /**
        * Map of {@link PipeMetadata} names to {@link PipeMetadata} implementations.
        */
        config) {
            this.config = config;
            this.config = config;
        }
        ProtoPipes.fromProviders = function (providers) {
            var config = {};
            providers.forEach(function (b) {
                return config[b.name] = b;
            });
            return new ProtoPipes(config);
        };
        ProtoPipes.prototype.get = function (name) {
            var provider = this.config[name];
            if (lang_1.isBlank(provider)) throw new exceptions_1.BaseException("Cannot find pipe '" + name + "'.");
            return provider;
        };
        return ProtoPipes;
    }();
    exports.ProtoPipes = ProtoPipes;
    var Pipes = function () {
        function Pipes(proto, injector) {
            this.proto = proto;
            this.injector = injector;
            /** @internal */
            this._config = {};
        }
        Pipes.prototype.get = function (name) {
            var cached = collection_1.StringMapWrapper.get(this._config, name);
            if (lang_1.isPresent(cached)) return cached;
            var p = this.proto.get(name);
            var transform = this.injector.instantiateResolved(p);
            var res = new cd.SelectedPipe(transform, p.pure);
            if (p.pure) {
                collection_1.StringMapWrapper.set(this._config, name, res);
            }
            return res;
        };
        return Pipes;
    }();
    exports.Pipes = Pipes;
});
System.registerDynamic('angular2/src/core/render/util.js', ['angular2/src/facade/lang.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var CAMEL_CASE_REGEXP = /([A-Z])/g;
    var DASH_CASE_REGEXP = /-([a-z])/g;
    function camelCaseToDashCase(input) {
        return lang_1.StringWrapper.replaceAllMapped(input, CAMEL_CASE_REGEXP, function (m) {
            return '-' + m[1].toLowerCase();
        });
    }
    exports.camelCaseToDashCase = camelCaseToDashCase;
    function dashCaseToCamelCase(input) {
        return lang_1.StringWrapper.replaceAllMapped(input, DASH_CASE_REGEXP, function (m) {
            return m[1].toUpperCase();
        });
    }
    exports.dashCaseToCamelCase = dashCaseToCamelCase;
});
System.registerDynamic("angular2/src/core/linker/view.js", ["angular2/src/facade/collection.js", "angular2/src/core/change_detection/change_detection.js", "angular2/src/core/change_detection/interfaces.js", "angular2/src/core/linker/element.js", "angular2/src/facade/lang.js", "angular2/src/facade/exceptions.js", "angular2/src/core/render/api.js", "angular2/src/core/linker/view_ref.js", "angular2/src/core/pipes/pipes.js", "angular2/src/core/render/util.js", "angular2/src/core/linker/view_type.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var change_detection_1 = $__require("angular2/src/core/change_detection/change_detection.js");
    var interfaces_1 = $__require("angular2/src/core/change_detection/interfaces.js");
    var element_1 = $__require("angular2/src/core/linker/element.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var exceptions_1 = $__require("angular2/src/facade/exceptions.js");
    var api_1 = $__require("angular2/src/core/render/api.js");
    var view_ref_1 = $__require("angular2/src/core/linker/view_ref.js");
    var pipes_1 = $__require("angular2/src/core/pipes/pipes.js");
    var util_1 = $__require("angular2/src/core/render/util.js");
    var interfaces_2 = $__require("angular2/src/core/change_detection/interfaces.js");
    exports.DebugContext = interfaces_2.DebugContext;
    var pipes_2 = $__require("angular2/src/core/pipes/pipes.js");
    var view_type_1 = $__require("angular2/src/core/linker/view_type.js");
    var REFLECT_PREFIX = 'ng-reflect-';
    var EMPTY_CONTEXT = lang_1.CONST_EXPR(new Object());
    /**
     * Cost of making objects: http://jsperf.com/instantiate-size-of-object
     *
     */
    var AppView = function () {
        function AppView(proto, renderer, viewManager, projectableNodes, containerAppElement, imperativelyCreatedProviders, rootInjector, changeDetector) {
            this.proto = proto;
            this.renderer = renderer;
            this.viewManager = viewManager;
            this.projectableNodes = projectableNodes;
            this.containerAppElement = containerAppElement;
            this.changeDetector = changeDetector;
            /**
             * The context against which data-binding expressions in this view are evaluated against.
             * This is always a component instance.
             */
            this.context = null;
            this.destroyed = false;
            this.ref = new view_ref_1.ViewRef_(this);
            var injectorWithHostBoundary = element_1.AppElement.getViewParentInjector(this.proto.type, containerAppElement, imperativelyCreatedProviders, rootInjector);
            this.parentInjector = injectorWithHostBoundary.injector;
            this.hostInjectorBoundary = injectorWithHostBoundary.hostInjectorBoundary;
            var pipes;
            var context;
            switch (proto.type) {
                case view_type_1.ViewType.COMPONENT:
                    pipes = new pipes_2.Pipes(proto.protoPipes, containerAppElement.getInjector());
                    context = containerAppElement.getComponent();
                    break;
                case view_type_1.ViewType.EMBEDDED:
                    pipes = containerAppElement.parentView.pipes;
                    context = containerAppElement.parentView.context;
                    break;
                case view_type_1.ViewType.HOST:
                    pipes = null;
                    context = EMPTY_CONTEXT;
                    break;
            }
            this.pipes = pipes;
            this.context = context;
        }
        AppView.prototype.init = function (rootNodesOrAppElements, allNodes, disposables, appElements) {
            this.rootNodesOrAppElements = rootNodesOrAppElements;
            this.allNodes = allNodes;
            this.disposables = disposables;
            this.appElements = appElements;
            var localsMap = new collection_1.Map();
            collection_1.StringMapWrapper.forEach(this.proto.templateVariableBindings, function (templateName, _) {
                localsMap.set(templateName, null);
            });
            for (var i = 0; i < appElements.length; i++) {
                var appEl = appElements[i];
                var providerTokens = [];
                if (lang_1.isPresent(appEl.proto.protoInjector)) {
                    for (var j = 0; j < appEl.proto.protoInjector.numberOfProviders; j++) {
                        providerTokens.push(appEl.proto.protoInjector.getProviderAtIndex(j).key.token);
                    }
                }
                collection_1.StringMapWrapper.forEach(appEl.proto.directiveVariableBindings, function (directiveIndex, name) {
                    if (lang_1.isBlank(directiveIndex)) {
                        localsMap.set(name, appEl.nativeElement);
                    } else {
                        localsMap.set(name, appEl.getDirectiveAtIndex(directiveIndex));
                    }
                });
                this.renderer.setElementDebugInfo(appEl.nativeElement, new api_1.RenderDebugInfo(appEl.getInjector(), appEl.getComponent(), providerTokens, localsMap));
            }
            var parentLocals = null;
            if (this.proto.type !== view_type_1.ViewType.COMPONENT) {
                parentLocals = lang_1.isPresent(this.containerAppElement) ? this.containerAppElement.parentView.locals : null;
            }
            if (this.proto.type === view_type_1.ViewType.COMPONENT) {
                // Note: the render nodes have been attached to their host element
                // in the ViewFactory already.
                this.containerAppElement.attachComponentView(this);
                this.containerAppElement.parentView.changeDetector.addViewChild(this.changeDetector);
            }
            this.locals = new change_detection_1.Locals(parentLocals, localsMap);
            this.changeDetector.hydrate(this.context, this.locals, this, this.pipes);
            this.viewManager.onViewCreated(this);
        };
        AppView.prototype.destroy = function () {
            if (this.destroyed) {
                throw new exceptions_1.BaseException('This view has already been destroyed!');
            }
            this.changeDetector.destroyRecursive();
        };
        AppView.prototype.notifyOnDestroy = function () {
            this.destroyed = true;
            var hostElement = this.proto.type === view_type_1.ViewType.COMPONENT ? this.containerAppElement.nativeElement : null;
            this.renderer.destroyView(hostElement, this.allNodes);
            for (var i = 0; i < this.disposables.length; i++) {
                this.disposables[i]();
            }
            this.viewManager.onViewDestroyed(this);
        };
        Object.defineProperty(AppView.prototype, "changeDetectorRef", {
            get: function () {
                return this.changeDetector.ref;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AppView.prototype, "flatRootNodes", {
            get: function () {
                return flattenNestedViewRenderNodes(this.rootNodesOrAppElements);
            },
            enumerable: true,
            configurable: true
        });
        AppView.prototype.hasLocal = function (contextName) {
            return collection_1.StringMapWrapper.contains(this.proto.templateVariableBindings, contextName);
        };
        AppView.prototype.setLocal = function (contextName, value) {
            if (!this.hasLocal(contextName)) {
                return;
            }
            var templateName = this.proto.templateVariableBindings[contextName];
            this.locals.set(templateName, value);
        };
        // dispatch to element injector or text nodes based on context
        AppView.prototype.notifyOnBinding = function (b, currentValue) {
            if (b.isTextNode()) {
                this.renderer.setText(this.allNodes[b.elementIndex], currentValue);
            } else {
                var nativeElement = this.appElements[b.elementIndex].nativeElement;
                if (b.isElementProperty()) {
                    this.renderer.setElementProperty(nativeElement, b.name, currentValue);
                } else if (b.isElementAttribute()) {
                    this.renderer.setElementAttribute(nativeElement, b.name, lang_1.isPresent(currentValue) ? "" + currentValue : null);
                } else if (b.isElementClass()) {
                    this.renderer.setElementClass(nativeElement, b.name, currentValue);
                } else if (b.isElementStyle()) {
                    var unit = lang_1.isPresent(b.unit) ? b.unit : '';
                    this.renderer.setElementStyle(nativeElement, b.name, lang_1.isPresent(currentValue) ? "" + currentValue + unit : null);
                } else {
                    throw new exceptions_1.BaseException('Unsupported directive record');
                }
            }
        };
        AppView.prototype.logBindingUpdate = function (b, value) {
            if (b.isDirective() || b.isElementProperty()) {
                var nativeElement = this.appElements[b.elementIndex].nativeElement;
                this.renderer.setBindingDebugInfo(nativeElement, "" + REFLECT_PREFIX + util_1.camelCaseToDashCase(b.name), "" + value);
            }
        };
        AppView.prototype.notifyAfterContentChecked = function () {
            var count = this.appElements.length;
            for (var i = count - 1; i >= 0; i--) {
                this.appElements[i].ngAfterContentChecked();
            }
        };
        AppView.prototype.notifyAfterViewChecked = function () {
            var count = this.appElements.length;
            for (var i = count - 1; i >= 0; i--) {
                this.appElements[i].ngAfterViewChecked();
            }
        };
        AppView.prototype.getDebugContext = function (appElement, elementIndex, directiveIndex) {
            try {
                if (lang_1.isBlank(appElement) && elementIndex < this.appElements.length) {
                    appElement = this.appElements[elementIndex];
                }
                var container = this.containerAppElement;
                var element = lang_1.isPresent(appElement) ? appElement.nativeElement : null;
                var componentElement = lang_1.isPresent(container) ? container.nativeElement : null;
                var directive = lang_1.isPresent(directiveIndex) ? appElement.getDirectiveAtIndex(directiveIndex) : null;
                var injector = lang_1.isPresent(appElement) ? appElement.getInjector() : null;
                return new interfaces_1.DebugContext(element, componentElement, directive, this.context, _localsToStringMap(this.locals), injector);
            } catch (e) {
                // TODO: vsavkin log the exception once we have a good way to log errors and warnings
                // if an error happens during getting the debug context, we return null.
                return null;
            }
        };
        AppView.prototype.getDirectiveFor = function (directive) {
            return this.appElements[directive.elementIndex].getDirectiveAtIndex(directive.directiveIndex);
        };
        AppView.prototype.getDetectorFor = function (directive) {
            var componentView = this.appElements[directive.elementIndex].componentView;
            return lang_1.isPresent(componentView) ? componentView.changeDetector : null;
        };
        /**
         * Triggers the event handlers for the element and the directives.
         *
         * This method is intended to be called from directive EventEmitters.
         *
         * @param {string} eventName
         * @param {*} eventObj
         * @param {number} boundElementIndex
         * @return false if preventDefault must be applied to the DOM event
         */
        AppView.prototype.triggerEventHandlers = function (eventName, eventObj, boundElementIndex) {
            return this.changeDetector.handleEvent(eventName, boundElementIndex, eventObj);
        };
        return AppView;
    }();
    exports.AppView = AppView;
    function _localsToStringMap(locals) {
        var res = {};
        var c = locals;
        while (lang_1.isPresent(c)) {
            res = collection_1.StringMapWrapper.merge(res, collection_1.MapWrapper.toStringMap(c.current));
            c = c.parent;
        }
        return res;
    }
    /**
     *
     */
    var AppProtoView = function () {
        function AppProtoView(type, protoPipes, templateVariableBindings) {
            this.type = type;
            this.protoPipes = protoPipes;
            this.templateVariableBindings = templateVariableBindings;
        }
        AppProtoView.create = function (metadataCache, type, pipes, templateVariableBindings) {
            var protoPipes = null;
            if (lang_1.isPresent(pipes) && pipes.length > 0) {
                var boundPipes = collection_1.ListWrapper.createFixedSize(pipes.length);
                for (var i = 0; i < pipes.length; i++) {
                    boundPipes[i] = metadataCache.getResolvedPipeMetadata(pipes[i]);
                }
                protoPipes = pipes_1.ProtoPipes.fromProviders(boundPipes);
            }
            return new AppProtoView(type, protoPipes, templateVariableBindings);
        };
        return AppProtoView;
    }();
    exports.AppProtoView = AppProtoView;
    var HostViewFactory = function () {
        function HostViewFactory(selector, viewFactory) {
            this.selector = selector;
            this.viewFactory = viewFactory;
        }
        HostViewFactory = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [String, Function])], HostViewFactory);
        return HostViewFactory;
    }();
    exports.HostViewFactory = HostViewFactory;
    function flattenNestedViewRenderNodes(nodes) {
        return _flattenNestedViewRenderNodes(nodes, []);
    }
    exports.flattenNestedViewRenderNodes = flattenNestedViewRenderNodes;
    function _flattenNestedViewRenderNodes(nodes, renderNodes) {
        for (var i = 0; i < nodes.length; i++) {
            var node = nodes[i];
            if (node instanceof element_1.AppElement) {
                var appEl = node;
                renderNodes.push(appEl.nativeElement);
                if (lang_1.isPresent(appEl.nestedViews)) {
                    for (var k = 0; k < appEl.nestedViews.length; k++) {
                        _flattenNestedViewRenderNodes(appEl.nestedViews[k].rootNodesOrAppElements, renderNodes);
                    }
                }
            } else {
                renderNodes.push(node);
            }
        }
        return renderNodes;
    }
    function findLastRenderNode(node) {
        var lastNode;
        if (node instanceof element_1.AppElement) {
            var appEl = node;
            lastNode = appEl.nativeElement;
            if (lang_1.isPresent(appEl.nestedViews)) {
                // Note: Views might have no root nodes at all!
                for (var i = appEl.nestedViews.length - 1; i >= 0; i--) {
                    var nestedView = appEl.nestedViews[i];
                    if (nestedView.rootNodesOrAppElements.length > 0) {
                        lastNode = findLastRenderNode(nestedView.rootNodesOrAppElements[nestedView.rootNodesOrAppElements.length - 1]);
                    }
                }
            }
        } else {
            lastNode = node;
        }
        return lastNode;
    }
    exports.findLastRenderNode = findLastRenderNode;
    function checkSlotCount(componentName, expectedSlotCount, projectableNodes) {
        var givenSlotCount = lang_1.isPresent(projectableNodes) ? projectableNodes.length : 0;
        if (givenSlotCount < expectedSlotCount) {
            throw new exceptions_1.BaseException("The component " + componentName + " has " + expectedSlotCount + " <ng-content> elements," + (" but only " + givenSlotCount + " slots were provided."));
        }
    }
    exports.checkSlotCount = checkSlotCount;
});
System.registerDynamic("angular2/src/core/render/api.js", [], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var RenderComponentType = function () {
        function RenderComponentType(id, encapsulation, styles) {
            this.id = id;
            this.encapsulation = encapsulation;
            this.styles = styles;
        }
        return RenderComponentType;
    }();
    exports.RenderComponentType = RenderComponentType;
    var RenderDebugInfo = function () {
        function RenderDebugInfo(injector, component, providerTokens, locals) {
            this.injector = injector;
            this.component = component;
            this.providerTokens = providerTokens;
            this.locals = locals;
        }
        return RenderDebugInfo;
    }();
    exports.RenderDebugInfo = RenderDebugInfo;
    var Renderer = function () {
        function Renderer() {}
        return Renderer;
    }();
    exports.Renderer = Renderer;
    /**
     * Injectable service that provides a low-level interface for modifying the UI.
     *
     * Use this service to bypass Angular's templating and make custom UI changes that can't be
     * expressed declaratively. For example if you need to set a property or an attribute whose name is
     * not statically known, use {@link #setElementProperty} or {@link #setElementAttribute}
     * respectively.
     *
     * If you are implementing a custom renderer, you must implement this interface.
     *
     * The default Renderer implementation is `DomRenderer`. Also available is `WebWorkerRenderer`.
     */
    var RootRenderer = function () {
        function RootRenderer() {}
        return RootRenderer;
    }();
    exports.RootRenderer = RootRenderer;
});
System.registerDynamic('angular2/src/core/profile/wtf_impl.js', ['angular2/src/facade/lang.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var trace;
    var events;
    function detectWTF() {
        var wtf = lang_1.global['wtf'];
        if (wtf) {
            trace = wtf['trace'];
            if (trace) {
                events = trace['events'];
                return true;
            }
        }
        return false;
    }
    exports.detectWTF = detectWTF;
    function createScope(signature, flags) {
        if (flags === void 0) {
            flags = null;
        }
        return events.createScope(signature, flags);
    }
    exports.createScope = createScope;
    function leave(scope, returnValue) {
        trace.leaveScope(scope, returnValue);
        return returnValue;
    }
    exports.leave = leave;
    function startTimeRange(rangeType, action) {
        return trace.beginTimeRange(rangeType, action);
    }
    exports.startTimeRange = startTimeRange;
    function endTimeRange(range) {
        trace.endTimeRange(range);
    }
    exports.endTimeRange = endTimeRange;
});
System.registerDynamic("angular2/src/core/profile/profile.js", ["angular2/src/core/profile/wtf_impl.js"], true, function ($__require, exports, module) {
  'use strict';"use strict";

  var global = this || self,
      GLOBAL = global;
  var impl = $__require("angular2/src/core/profile/wtf_impl.js");
  // Change exports to const once https://github.com/angular/ts2dart/issues/150
  /**
   * True if WTF is enabled.
   */
  exports.wtfEnabled = impl.detectWTF();
  function noopScope(arg0, arg1) {
    return null;
  }
  /**
   * Create trace scope.
   *
   * Scopes must be strictly nested and are analogous to stack frames, but
   * do not have to follow the stack frames. Instead it is recommended that they follow logical
   * nesting. You may want to use
   * [Event
   * Signatures](http://google.github.io/tracing-framework/instrumenting-code.html#custom-events)
   * as they are defined in WTF.
   *
   * Used to mark scope entry. The return value is used to leave the scope.
   *
   *     var myScope = wtfCreateScope('MyClass#myMethod(ascii someVal)');
   *
   *     someMethod() {
   *        var s = myScope('Foo'); // 'Foo' gets stored in tracing UI
   *        // DO SOME WORK HERE
   *        return wtfLeave(s, 123); // Return value 123
   *     }
   *
   * Note, adding try-finally block around the work to ensure that `wtfLeave` gets called can
   * negatively impact the performance of your application. For this reason we recommend that
   * you don't add them to ensure that `wtfLeave` gets called. In production `wtfLeave` is a noop and
   * so try-finally block has no value. When debugging perf issues, skipping `wtfLeave`, do to
   * exception, will produce incorrect trace, but presence of exception signifies logic error which
   * needs to be fixed before the app should be profiled. Add try-finally only when you expect that
   * an exception is expected during normal execution while profiling.
   *
   */
  exports.wtfCreateScope = exports.wtfEnabled ? impl.createScope : function (signature, flags) {
    return noopScope;
  };
  /**
   * Used to mark end of Scope.
   *
   * - `scope` to end.
   * - `returnValue` (optional) to be passed to the WTF.
   *
   * Returns the `returnValue for easy chaining.
   */
  exports.wtfLeave = exports.wtfEnabled ? impl.leave : function (s, r) {
    return r;
  };
  /**
   * Used to mark Async start. Async are similar to scope but they don't have to be strictly nested.
   * The return value is used in the call to [endAsync]. Async ranges only work if WTF has been
   * enabled.
   *
   *     someMethod() {
   *        var s = wtfStartTimeRange('HTTP:GET', 'some.url');
   *        var future = new Future.delay(5).then((_) {
   *          wtfEndTimeRange(s);
   *        });
   *     }
   */
  exports.wtfStartTimeRange = exports.wtfEnabled ? impl.startTimeRange : function (rangeType, action) {
    return null;
  };
  /**
   * Ends a async time range operation.
   * [range] is the return value from [wtfStartTimeRange] Async ranges only work if WTF has been
   * enabled.
   */
  exports.wtfEndTimeRange = exports.wtfEnabled ? impl.endTimeRange : function (r) {
    return null;
  };
});
System.registerDynamic('angular2/src/core/util/decorators.js', ['angular2/src/facade/lang.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var _nextClassId = 0;
    function extractAnnotation(annotation) {
        if (lang_1.isFunction(annotation) && annotation.hasOwnProperty('annotation')) {
            // it is a decorator, extract annotation
            annotation = annotation.annotation;
        }
        return annotation;
    }
    function applyParams(fnOrArray, key) {
        if (fnOrArray === Object || fnOrArray === String || fnOrArray === Function || fnOrArray === Number || fnOrArray === Array) {
            throw new Error("Can not use native " + lang_1.stringify(fnOrArray) + " as constructor");
        }
        if (lang_1.isFunction(fnOrArray)) {
            return fnOrArray;
        } else if (fnOrArray instanceof Array) {
            var annotations = fnOrArray;
            var fn = fnOrArray[fnOrArray.length - 1];
            if (!lang_1.isFunction(fn)) {
                throw new Error("Last position of Class method array must be Function in key " + key + " was '" + lang_1.stringify(fn) + "'");
            }
            var annoLength = annotations.length - 1;
            if (annoLength != fn.length) {
                throw new Error("Number of annotations (" + annoLength + ") does not match number of arguments (" + fn.length + ") in the function: " + lang_1.stringify(fn));
            }
            var paramsAnnotations = [];
            for (var i = 0, ii = annotations.length - 1; i < ii; i++) {
                var paramAnnotations = [];
                paramsAnnotations.push(paramAnnotations);
                var annotation = annotations[i];
                if (annotation instanceof Array) {
                    for (var j = 0; j < annotation.length; j++) {
                        paramAnnotations.push(extractAnnotation(annotation[j]));
                    }
                } else if (lang_1.isFunction(annotation)) {
                    paramAnnotations.push(extractAnnotation(annotation));
                } else {
                    paramAnnotations.push(annotation);
                }
            }
            Reflect.defineMetadata('parameters', paramsAnnotations, fn);
            return fn;
        } else {
            throw new Error("Only Function or Array is supported in Class definition for key '" + key + "' is '" + lang_1.stringify(fnOrArray) + "'");
        }
    }
    /**
     * Provides a way for expressing ES6 classes with parameter annotations in ES5.
     *
     * ## Basic Example
     *
     * ```
     * var Greeter = ng.Class({
     *   constructor: function(name) {
     *     this.name = name;
     *   },
     *
     *   greet: function() {
     *     alert('Hello ' + this.name + '!');
     *   }
     * });
     * ```
     *
     * is equivalent to ES6:
     *
     * ```
     * class Greeter {
     *   constructor(name) {
     *     this.name = name;
     *   }
     *
     *   greet() {
     *     alert('Hello ' + this.name + '!');
     *   }
     * }
     * ```
     *
     * or equivalent to ES5:
     *
     * ```
     * var Greeter = function (name) {
     *   this.name = name;
     * }
     *
     * Greeter.prototype.greet = function () {
     *   alert('Hello ' + this.name + '!');
     * }
     * ```
     *
     * ### Example with parameter annotations
     *
     * ```
     * var MyService = ng.Class({
     *   constructor: [String, [new Query(), QueryList], function(name, queryList) {
     *     ...
     *   }]
     * });
     * ```
     *
     * is equivalent to ES6:
     *
     * ```
     * class MyService {
     *   constructor(name: string, @Query() queryList: QueryList) {
     *     ...
     *   }
     * }
     * ```
     *
     * ### Example with inheritance
     *
     * ```
     * var Shape = ng.Class({
     *   constructor: (color) {
     *     this.color = color;
     *   }
     * });
     *
     * var Square = ng.Class({
     *   extends: Shape,
     *   constructor: function(color, size) {
     *     Shape.call(this, color);
     *     this.size = size;
     *   }
     * });
     * ```
     */
    function Class(clsDef) {
        var constructor = applyParams(clsDef.hasOwnProperty('constructor') ? clsDef.constructor : undefined, 'constructor');
        var proto = constructor.prototype;
        if (clsDef.hasOwnProperty('extends')) {
            if (lang_1.isFunction(clsDef.extends)) {
                constructor.prototype = proto = Object.create(clsDef.extends.prototype);
            } else {
                throw new Error("Class definition 'extends' property must be a constructor function was: " + lang_1.stringify(clsDef.extends));
            }
        }
        for (var key in clsDef) {
            if (key != 'extends' && key != 'prototype' && clsDef.hasOwnProperty(key)) {
                proto[key] = applyParams(clsDef[key], key);
            }
        }
        if (this && this.annotations instanceof Array) {
            Reflect.defineMetadata('annotations', this.annotations, constructor);
        }
        if (!constructor['name']) {
            constructor['overriddenName'] = "class" + _nextClassId++;
        }
        return constructor;
    }
    exports.Class = Class;
    var Reflect = lang_1.global.Reflect;
    // Throw statement at top-level is disallowed by closure compiler in ES6 input.
    // Wrap in an IIFE as a work-around.
    (function checkReflect() {
        if (!(Reflect && Reflect.getMetadata)) {
            throw 'reflect-metadata shim is required when using class decorators';
        }
    })();
    function makeDecorator(annotationCls, chainFn) {
        if (chainFn === void 0) {
            chainFn = null;
        }
        function DecoratorFactory(objOrType) {
            var annotationInstance = new annotationCls(objOrType);
            if (this instanceof annotationCls) {
                return annotationInstance;
            } else {
                var chainAnnotation = lang_1.isFunction(this) && this.annotations instanceof Array ? this.annotations : [];
                chainAnnotation.push(annotationInstance);
                var TypeDecorator = function TypeDecorator(cls) {
                    var annotations = Reflect.getOwnMetadata('annotations', cls);
                    annotations = annotations || [];
                    annotations.push(annotationInstance);
                    Reflect.defineMetadata('annotations', annotations, cls);
                    return cls;
                };
                TypeDecorator.annotations = chainAnnotation;
                TypeDecorator.Class = Class;
                if (chainFn) chainFn(TypeDecorator);
                return TypeDecorator;
            }
        }
        DecoratorFactory.prototype = Object.create(annotationCls.prototype);
        return DecoratorFactory;
    }
    exports.makeDecorator = makeDecorator;
    function makeParamDecorator(annotationCls) {
        function ParamDecoratorFactory() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i - 0] = arguments[_i];
            }
            var annotationInstance = Object.create(annotationCls.prototype);
            annotationCls.apply(annotationInstance, args);
            if (this instanceof annotationCls) {
                return annotationInstance;
            } else {
                ParamDecorator.annotation = annotationInstance;
                return ParamDecorator;
            }
            function ParamDecorator(cls, unusedKey, index) {
                var parameters = Reflect.getMetadata('parameters', cls);
                parameters = parameters || [];
                // there might be gaps if some in between parameters do not have annotations.
                // we pad with nulls.
                while (parameters.length <= index) {
                    parameters.push(null);
                }
                parameters[index] = parameters[index] || [];
                var annotationsForParam = parameters[index];
                annotationsForParam.push(annotationInstance);
                Reflect.defineMetadata('parameters', parameters, cls);
                return cls;
            }
        }
        ParamDecoratorFactory.prototype = Object.create(annotationCls.prototype);
        return ParamDecoratorFactory;
    }
    exports.makeParamDecorator = makeParamDecorator;
    function makePropDecorator(decoratorCls) {
        function PropDecoratorFactory() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i - 0] = arguments[_i];
            }
            var decoratorInstance = Object.create(decoratorCls.prototype);
            decoratorCls.apply(decoratorInstance, args);
            if (this instanceof decoratorCls) {
                return decoratorInstance;
            } else {
                return function PropDecorator(target, name) {
                    var meta = Reflect.getOwnMetadata('propMetadata', target.constructor);
                    meta = meta || {};
                    meta[name] = meta[name] || [];
                    meta[name].unshift(decoratorInstance);
                    Reflect.defineMetadata('propMetadata', meta, target.constructor);
                };
            }
        }
        PropDecoratorFactory.prototype = Object.create(decoratorCls.prototype);
        return PropDecoratorFactory;
    }
    exports.makePropDecorator = makePropDecorator;
});
System.registerDynamic('angular2/src/core/di/decorators.js', ['angular2/src/core/di/metadata.js', 'angular2/src/core/util/decorators.js'], true, function ($__require, exports, module) {
  'use strict';"use strict";

  var global = this || self,
      GLOBAL = global;
  var metadata_1 = $__require('angular2/src/core/di/metadata.js');
  var decorators_1 = $__require('angular2/src/core/util/decorators.js');
  /**
   * Factory for creating {@link InjectMetadata}.
   */
  exports.Inject = decorators_1.makeParamDecorator(metadata_1.InjectMetadata);
  /**
   * Factory for creating {@link OptionalMetadata}.
   */
  exports.Optional = decorators_1.makeParamDecorator(metadata_1.OptionalMetadata);
  /**
   * Factory for creating {@link InjectableMetadata}.
   */
  exports.Injectable = decorators_1.makeDecorator(metadata_1.InjectableMetadata);
  /**
   * Factory for creating {@link SelfMetadata}.
   */
  exports.Self = decorators_1.makeParamDecorator(metadata_1.SelfMetadata);
  /**
   * Factory for creating {@link HostMetadata}.
   */
  exports.Host = decorators_1.makeParamDecorator(metadata_1.HostMetadata);
  /**
   * Factory for creating {@link SkipSelfMetadata}.
   */
  exports.SkipSelf = decorators_1.makeParamDecorator(metadata_1.SkipSelfMetadata);
});
System.registerDynamic('angular2/src/core/di/injector.js', ['angular2/src/facade/collection.js', 'angular2/src/core/di/provider.js', 'angular2/src/core/di/exceptions.js', 'angular2/src/facade/lang.js', 'angular2/src/facade/exceptions.js', 'angular2/src/core/di/key.js', 'angular2/src/core/di/metadata.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var collection_1 = $__require('angular2/src/facade/collection.js');
    var provider_1 = $__require('angular2/src/core/di/provider.js');
    var exceptions_1 = $__require('angular2/src/core/di/exceptions.js');
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var exceptions_2 = $__require('angular2/src/facade/exceptions.js');
    var key_1 = $__require('angular2/src/core/di/key.js');
    var metadata_1 = $__require('angular2/src/core/di/metadata.js');
    // Threshold for the dynamic version
    var _MAX_CONSTRUCTION_COUNTER = 10;
    exports.UNDEFINED = lang_1.CONST_EXPR(new Object());
    /**
     * Visibility of a {@link Provider}.
     */
    (function (Visibility) {
        /**
         * A `Public` {@link Provider} is only visible to regular (as opposed to host) child injectors.
         */
        Visibility[Visibility["Public"] = 0] = "Public";
        /**
         * A `Private` {@link Provider} is only visible to host (as opposed to regular) child injectors.
         */
        Visibility[Visibility["Private"] = 1] = "Private";
        /**
         * A `PublicAndPrivate` {@link Provider} is visible to both host and regular child injectors.
         */
        Visibility[Visibility["PublicAndPrivate"] = 2] = "PublicAndPrivate";
    })(exports.Visibility || (exports.Visibility = {}));
    var Visibility = exports.Visibility;
    function canSee(src, dst) {
        return src === dst || dst === Visibility.PublicAndPrivate || src === Visibility.PublicAndPrivate;
    }
    var ProtoInjectorInlineStrategy = function () {
        function ProtoInjectorInlineStrategy(protoEI, bwv) {
            this.provider0 = null;
            this.provider1 = null;
            this.provider2 = null;
            this.provider3 = null;
            this.provider4 = null;
            this.provider5 = null;
            this.provider6 = null;
            this.provider7 = null;
            this.provider8 = null;
            this.provider9 = null;
            this.keyId0 = null;
            this.keyId1 = null;
            this.keyId2 = null;
            this.keyId3 = null;
            this.keyId4 = null;
            this.keyId5 = null;
            this.keyId6 = null;
            this.keyId7 = null;
            this.keyId8 = null;
            this.keyId9 = null;
            this.visibility0 = null;
            this.visibility1 = null;
            this.visibility2 = null;
            this.visibility3 = null;
            this.visibility4 = null;
            this.visibility5 = null;
            this.visibility6 = null;
            this.visibility7 = null;
            this.visibility8 = null;
            this.visibility9 = null;
            var length = bwv.length;
            if (length > 0) {
                this.provider0 = bwv[0].provider;
                this.keyId0 = bwv[0].getKeyId();
                this.visibility0 = bwv[0].visibility;
            }
            if (length > 1) {
                this.provider1 = bwv[1].provider;
                this.keyId1 = bwv[1].getKeyId();
                this.visibility1 = bwv[1].visibility;
            }
            if (length > 2) {
                this.provider2 = bwv[2].provider;
                this.keyId2 = bwv[2].getKeyId();
                this.visibility2 = bwv[2].visibility;
            }
            if (length > 3) {
                this.provider3 = bwv[3].provider;
                this.keyId3 = bwv[3].getKeyId();
                this.visibility3 = bwv[3].visibility;
            }
            if (length > 4) {
                this.provider4 = bwv[4].provider;
                this.keyId4 = bwv[4].getKeyId();
                this.visibility4 = bwv[4].visibility;
            }
            if (length > 5) {
                this.provider5 = bwv[5].provider;
                this.keyId5 = bwv[5].getKeyId();
                this.visibility5 = bwv[5].visibility;
            }
            if (length > 6) {
                this.provider6 = bwv[6].provider;
                this.keyId6 = bwv[6].getKeyId();
                this.visibility6 = bwv[6].visibility;
            }
            if (length > 7) {
                this.provider7 = bwv[7].provider;
                this.keyId7 = bwv[7].getKeyId();
                this.visibility7 = bwv[7].visibility;
            }
            if (length > 8) {
                this.provider8 = bwv[8].provider;
                this.keyId8 = bwv[8].getKeyId();
                this.visibility8 = bwv[8].visibility;
            }
            if (length > 9) {
                this.provider9 = bwv[9].provider;
                this.keyId9 = bwv[9].getKeyId();
                this.visibility9 = bwv[9].visibility;
            }
        }
        ProtoInjectorInlineStrategy.prototype.getProviderAtIndex = function (index) {
            if (index == 0) return this.provider0;
            if (index == 1) return this.provider1;
            if (index == 2) return this.provider2;
            if (index == 3) return this.provider3;
            if (index == 4) return this.provider4;
            if (index == 5) return this.provider5;
            if (index == 6) return this.provider6;
            if (index == 7) return this.provider7;
            if (index == 8) return this.provider8;
            if (index == 9) return this.provider9;
            throw new exceptions_1.OutOfBoundsError(index);
        };
        ProtoInjectorInlineStrategy.prototype.createInjectorStrategy = function (injector) {
            return new InjectorInlineStrategy(injector, this);
        };
        return ProtoInjectorInlineStrategy;
    }();
    exports.ProtoInjectorInlineStrategy = ProtoInjectorInlineStrategy;
    var ProtoInjectorDynamicStrategy = function () {
        function ProtoInjectorDynamicStrategy(protoInj, bwv) {
            var len = bwv.length;
            this.providers = collection_1.ListWrapper.createFixedSize(len);
            this.keyIds = collection_1.ListWrapper.createFixedSize(len);
            this.visibilities = collection_1.ListWrapper.createFixedSize(len);
            for (var i = 0; i < len; i++) {
                this.providers[i] = bwv[i].provider;
                this.keyIds[i] = bwv[i].getKeyId();
                this.visibilities[i] = bwv[i].visibility;
            }
        }
        ProtoInjectorDynamicStrategy.prototype.getProviderAtIndex = function (index) {
            if (index < 0 || index >= this.providers.length) {
                throw new exceptions_1.OutOfBoundsError(index);
            }
            return this.providers[index];
        };
        ProtoInjectorDynamicStrategy.prototype.createInjectorStrategy = function (ei) {
            return new InjectorDynamicStrategy(this, ei);
        };
        return ProtoInjectorDynamicStrategy;
    }();
    exports.ProtoInjectorDynamicStrategy = ProtoInjectorDynamicStrategy;
    var ProtoInjector = function () {
        function ProtoInjector(bwv) {
            this.numberOfProviders = bwv.length;
            this._strategy = bwv.length > _MAX_CONSTRUCTION_COUNTER ? new ProtoInjectorDynamicStrategy(this, bwv) : new ProtoInjectorInlineStrategy(this, bwv);
        }
        ProtoInjector.fromResolvedProviders = function (providers) {
            var bd = providers.map(function (b) {
                return new ProviderWithVisibility(b, Visibility.Public);
            });
            return new ProtoInjector(bd);
        };
        ProtoInjector.prototype.getProviderAtIndex = function (index) {
            return this._strategy.getProviderAtIndex(index);
        };
        return ProtoInjector;
    }();
    exports.ProtoInjector = ProtoInjector;
    var InjectorInlineStrategy = function () {
        function InjectorInlineStrategy(injector, protoStrategy) {
            this.injector = injector;
            this.protoStrategy = protoStrategy;
            this.obj0 = exports.UNDEFINED;
            this.obj1 = exports.UNDEFINED;
            this.obj2 = exports.UNDEFINED;
            this.obj3 = exports.UNDEFINED;
            this.obj4 = exports.UNDEFINED;
            this.obj5 = exports.UNDEFINED;
            this.obj6 = exports.UNDEFINED;
            this.obj7 = exports.UNDEFINED;
            this.obj8 = exports.UNDEFINED;
            this.obj9 = exports.UNDEFINED;
        }
        InjectorInlineStrategy.prototype.resetConstructionCounter = function () {
            this.injector._constructionCounter = 0;
        };
        InjectorInlineStrategy.prototype.instantiateProvider = function (provider, visibility) {
            return this.injector._new(provider, visibility);
        };
        InjectorInlineStrategy.prototype.getObjByKeyId = function (keyId, visibility) {
            var p = this.protoStrategy;
            var inj = this.injector;
            if (p.keyId0 === keyId && canSee(p.visibility0, visibility)) {
                if (this.obj0 === exports.UNDEFINED) {
                    this.obj0 = inj._new(p.provider0, p.visibility0);
                }
                return this.obj0;
            }
            if (p.keyId1 === keyId && canSee(p.visibility1, visibility)) {
                if (this.obj1 === exports.UNDEFINED) {
                    this.obj1 = inj._new(p.provider1, p.visibility1);
                }
                return this.obj1;
            }
            if (p.keyId2 === keyId && canSee(p.visibility2, visibility)) {
                if (this.obj2 === exports.UNDEFINED) {
                    this.obj2 = inj._new(p.provider2, p.visibility2);
                }
                return this.obj2;
            }
            if (p.keyId3 === keyId && canSee(p.visibility3, visibility)) {
                if (this.obj3 === exports.UNDEFINED) {
                    this.obj3 = inj._new(p.provider3, p.visibility3);
                }
                return this.obj3;
            }
            if (p.keyId4 === keyId && canSee(p.visibility4, visibility)) {
                if (this.obj4 === exports.UNDEFINED) {
                    this.obj4 = inj._new(p.provider4, p.visibility4);
                }
                return this.obj4;
            }
            if (p.keyId5 === keyId && canSee(p.visibility5, visibility)) {
                if (this.obj5 === exports.UNDEFINED) {
                    this.obj5 = inj._new(p.provider5, p.visibility5);
                }
                return this.obj5;
            }
            if (p.keyId6 === keyId && canSee(p.visibility6, visibility)) {
                if (this.obj6 === exports.UNDEFINED) {
                    this.obj6 = inj._new(p.provider6, p.visibility6);
                }
                return this.obj6;
            }
            if (p.keyId7 === keyId && canSee(p.visibility7, visibility)) {
                if (this.obj7 === exports.UNDEFINED) {
                    this.obj7 = inj._new(p.provider7, p.visibility7);
                }
                return this.obj7;
            }
            if (p.keyId8 === keyId && canSee(p.visibility8, visibility)) {
                if (this.obj8 === exports.UNDEFINED) {
                    this.obj8 = inj._new(p.provider8, p.visibility8);
                }
                return this.obj8;
            }
            if (p.keyId9 === keyId && canSee(p.visibility9, visibility)) {
                if (this.obj9 === exports.UNDEFINED) {
                    this.obj9 = inj._new(p.provider9, p.visibility9);
                }
                return this.obj9;
            }
            return exports.UNDEFINED;
        };
        InjectorInlineStrategy.prototype.getObjAtIndex = function (index) {
            if (index == 0) return this.obj0;
            if (index == 1) return this.obj1;
            if (index == 2) return this.obj2;
            if (index == 3) return this.obj3;
            if (index == 4) return this.obj4;
            if (index == 5) return this.obj5;
            if (index == 6) return this.obj6;
            if (index == 7) return this.obj7;
            if (index == 8) return this.obj8;
            if (index == 9) return this.obj9;
            throw new exceptions_1.OutOfBoundsError(index);
        };
        InjectorInlineStrategy.prototype.getMaxNumberOfObjects = function () {
            return _MAX_CONSTRUCTION_COUNTER;
        };
        return InjectorInlineStrategy;
    }();
    exports.InjectorInlineStrategy = InjectorInlineStrategy;
    var InjectorDynamicStrategy = function () {
        function InjectorDynamicStrategy(protoStrategy, injector) {
            this.protoStrategy = protoStrategy;
            this.injector = injector;
            this.objs = collection_1.ListWrapper.createFixedSize(protoStrategy.providers.length);
            collection_1.ListWrapper.fill(this.objs, exports.UNDEFINED);
        }
        InjectorDynamicStrategy.prototype.resetConstructionCounter = function () {
            this.injector._constructionCounter = 0;
        };
        InjectorDynamicStrategy.prototype.instantiateProvider = function (provider, visibility) {
            return this.injector._new(provider, visibility);
        };
        InjectorDynamicStrategy.prototype.getObjByKeyId = function (keyId, visibility) {
            var p = this.protoStrategy;
            for (var i = 0; i < p.keyIds.length; i++) {
                if (p.keyIds[i] === keyId && canSee(p.visibilities[i], visibility)) {
                    if (this.objs[i] === exports.UNDEFINED) {
                        this.objs[i] = this.injector._new(p.providers[i], p.visibilities[i]);
                    }
                    return this.objs[i];
                }
            }
            return exports.UNDEFINED;
        };
        InjectorDynamicStrategy.prototype.getObjAtIndex = function (index) {
            if (index < 0 || index >= this.objs.length) {
                throw new exceptions_1.OutOfBoundsError(index);
            }
            return this.objs[index];
        };
        InjectorDynamicStrategy.prototype.getMaxNumberOfObjects = function () {
            return this.objs.length;
        };
        return InjectorDynamicStrategy;
    }();
    exports.InjectorDynamicStrategy = InjectorDynamicStrategy;
    var ProviderWithVisibility = function () {
        function ProviderWithVisibility(provider, visibility) {
            this.provider = provider;
            this.visibility = visibility;
        }
        ;
        ProviderWithVisibility.prototype.getKeyId = function () {
            return this.provider.key.id;
        };
        return ProviderWithVisibility;
    }();
    exports.ProviderWithVisibility = ProviderWithVisibility;
    /**
     * A dependency injection container used for instantiating objects and resolving dependencies.
     *
     * An `Injector` is a replacement for a `new` operator, which can automatically resolve the
     * constructor dependencies.
     *
     * In typical use, application code asks for the dependencies in the constructor and they are
     * resolved by the `Injector`.
     *
     * ### Example ([live demo](http://plnkr.co/edit/jzjec0?p=preview))
     *
     * The following example creates an `Injector` configured to create `Engine` and `Car`.
     *
     * ```typescript
     * @Injectable()
     * class Engine {
     * }
     *
     * @Injectable()
     * class Car {
     *   constructor(public engine:Engine) {}
     * }
     *
     * var injector = Injector.resolveAndCreate([Car, Engine]);
     * var car = injector.get(Car);
     * expect(car instanceof Car).toBe(true);
     * expect(car.engine instanceof Engine).toBe(true);
     * ```
     *
     * Notice, we don't use the `new` operator because we explicitly want to have the `Injector`
     * resolve all of the object's dependencies automatically.
     */
    var Injector = function () {
        /**
         * Private
         */
        function Injector(_proto /* ProtoInjector */, _parent, _isHostBoundary, _depProvider, _debugContext) {
            if (_parent === void 0) {
                _parent = null;
            }
            if (_isHostBoundary === void 0) {
                _isHostBoundary = false;
            }
            if (_depProvider === void 0) {
                _depProvider = null;
            }
            if (_debugContext === void 0) {
                _debugContext = null;
            }
            this._isHostBoundary = _isHostBoundary;
            this._depProvider = _depProvider;
            this._debugContext = _debugContext;
            /** @internal */
            this._constructionCounter = 0;
            this._proto = _proto;
            this._parent = _parent;
            this._strategy = _proto._strategy.createInjectorStrategy(this);
        }
        /**
         * Turns an array of provider definitions into an array of resolved providers.
         *
         * A resolution is a process of flattening multiple nested arrays and converting individual
         * providers into an array of {@link ResolvedProvider}s.
         *
         * ### Example ([live demo](http://plnkr.co/edit/AiXTHi?p=preview))
         *
         * ```typescript
         * @Injectable()
         * class Engine {
         * }
         *
         * @Injectable()
         * class Car {
         *   constructor(public engine:Engine) {}
         * }
         *
         * var providers = Injector.resolve([Car, [[Engine]]]);
         *
         * expect(providers.length).toEqual(2);
         *
         * expect(providers[0] instanceof ResolvedProvider).toBe(true);
         * expect(providers[0].key.displayName).toBe("Car");
         * expect(providers[0].dependencies.length).toEqual(1);
         * expect(providers[0].factory).toBeDefined();
         *
         * expect(providers[1].key.displayName).toBe("Engine");
         * });
         * ```
         *
         * See {@link Injector#fromResolvedProviders} for more info.
         */
        Injector.resolve = function (providers) {
            return provider_1.resolveProviders(providers);
        };
        /**
         * Resolves an array of providers and creates an injector from those providers.
         *
         * The passed-in providers can be an array of `Type`, {@link Provider},
         * or a recursive array of more providers.
         *
         * ### Example ([live demo](http://plnkr.co/edit/ePOccA?p=preview))
         *
         * ```typescript
         * @Injectable()
         * class Engine {
         * }
         *
         * @Injectable()
         * class Car {
         *   constructor(public engine:Engine) {}
         * }
         *
         * var injector = Injector.resolveAndCreate([Car, Engine]);
         * expect(injector.get(Car) instanceof Car).toBe(true);
         * ```
         *
         * This function is slower than the corresponding `fromResolvedProviders`
         * because it needs to resolve the passed-in providers first.
         * See {@link Injector#resolve} and {@link Injector#fromResolvedProviders}.
         */
        Injector.resolveAndCreate = function (providers) {
            var resolvedProviders = Injector.resolve(providers);
            return Injector.fromResolvedProviders(resolvedProviders);
        };
        /**
         * Creates an injector from previously resolved providers.
         *
         * This API is the recommended way to construct injectors in performance-sensitive parts.
         *
         * ### Example ([live demo](http://plnkr.co/edit/KrSMci?p=preview))
         *
         * ```typescript
         * @Injectable()
         * class Engine {
         * }
         *
         * @Injectable()
         * class Car {
         *   constructor(public engine:Engine) {}
         * }
         *
         * var providers = Injector.resolve([Car, Engine]);
         * var injector = Injector.fromResolvedProviders(providers);
         * expect(injector.get(Car) instanceof Car).toBe(true);
         * ```
         */
        Injector.fromResolvedProviders = function (providers) {
            return new Injector(ProtoInjector.fromResolvedProviders(providers));
        };
        /**
         * @deprecated
         */
        Injector.fromResolvedBindings = function (providers) {
            return Injector.fromResolvedProviders(providers);
        };
        Object.defineProperty(Injector.prototype, "hostBoundary", {
            /**
             * Whether this injector is a boundary to a host.
             * @internal
             */
            get: function () {
                return this._isHostBoundary;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @internal
         */
        Injector.prototype.debugContext = function () {
            return this._debugContext();
        };
        /**
         * Retrieves an instance from the injector based on the provided token.
         * Throws {@link NoProviderError} if not found.
         *
         * ### Example ([live demo](http://plnkr.co/edit/HeXSHg?p=preview))
         *
         * ```typescript
         * var injector = Injector.resolveAndCreate([
         *   provide("validToken", {useValue: "Value"})
         * ]);
         * expect(injector.get("validToken")).toEqual("Value");
         * expect(() => injector.get("invalidToken")).toThrowError();
         * ```
         *
         * `Injector` returns itself when given `Injector` as a token.
         *
         * ```typescript
         * var injector = Injector.resolveAndCreate([]);
         * expect(injector.get(Injector)).toBe(injector);
         * ```
         */
        Injector.prototype.get = function (token) {
            return this._getByKey(key_1.Key.get(token), null, null, false, Visibility.PublicAndPrivate);
        };
        /**
         * Retrieves an instance from the injector based on the provided token.
         * Returns null if not found.
         *
         * ### Example ([live demo](http://plnkr.co/edit/tpEbEy?p=preview))
         *
         * ```typescript
         * var injector = Injector.resolveAndCreate([
         *   provide("validToken", {useValue: "Value"})
         * ]);
         * expect(injector.getOptional("validToken")).toEqual("Value");
         * expect(injector.getOptional("invalidToken")).toBe(null);
         * ```
         *
         * `Injector` returns itself when given `Injector` as a token.
         *
         * ```typescript
         * var injector = Injector.resolveAndCreate([]);
         * expect(injector.getOptional(Injector)).toBe(injector);
         * ```
         */
        Injector.prototype.getOptional = function (token) {
            return this._getByKey(key_1.Key.get(token), null, null, true, Visibility.PublicAndPrivate);
        };
        /**
         * @internal
         */
        Injector.prototype.getAt = function (index) {
            return this._strategy.getObjAtIndex(index);
        };
        Object.defineProperty(Injector.prototype, "parent", {
            /**
             * Parent of this injector.
             *
             * <!-- TODO: Add a link to the section of the user guide talking about hierarchical injection.
             * -->
             *
             * ### Example ([live demo](http://plnkr.co/edit/eosMGo?p=preview))
             *
             * ```typescript
             * var parent = Injector.resolveAndCreate([]);
             * var child = parent.resolveAndCreateChild([]);
             * expect(child.parent).toBe(parent);
             * ```
             */
            get: function () {
                return this._parent;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Injector.prototype, "internalStrategy", {
            /**
             * @internal
             * Internal. Do not use.
             * We return `any` not to export the InjectorStrategy type.
             */
            get: function () {
                return this._strategy;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Resolves an array of providers and creates a child injector from those providers.
         *
         * <!-- TODO: Add a link to the section of the user guide talking about hierarchical injection.
         * -->
         *
         * The passed-in providers can be an array of `Type`, {@link Provider},
         * or a recursive array of more providers.
         *
         * ### Example ([live demo](http://plnkr.co/edit/opB3T4?p=preview))
         *
         * ```typescript
         * class ParentProvider {}
         * class ChildProvider {}
         *
         * var parent = Injector.resolveAndCreate([ParentProvider]);
         * var child = parent.resolveAndCreateChild([ChildProvider]);
         *
         * expect(child.get(ParentProvider) instanceof ParentProvider).toBe(true);
         * expect(child.get(ChildProvider) instanceof ChildProvider).toBe(true);
         * expect(child.get(ParentProvider)).toBe(parent.get(ParentProvider));
         * ```
         *
         * This function is slower than the corresponding `createChildFromResolved`
         * because it needs to resolve the passed-in providers first.
         * See {@link Injector#resolve} and {@link Injector#createChildFromResolved}.
         */
        Injector.prototype.resolveAndCreateChild = function (providers) {
            var resolvedProviders = Injector.resolve(providers);
            return this.createChildFromResolved(resolvedProviders);
        };
        /**
         * Creates a child injector from previously resolved providers.
         *
         * <!-- TODO: Add a link to the section of the user guide talking about hierarchical injection.
         * -->
         *
         * This API is the recommended way to construct injectors in performance-sensitive parts.
         *
         * ### Example ([live demo](http://plnkr.co/edit/VhyfjN?p=preview))
         *
         * ```typescript
         * class ParentProvider {}
         * class ChildProvider {}
         *
         * var parentProviders = Injector.resolve([ParentProvider]);
         * var childProviders = Injector.resolve([ChildProvider]);
         *
         * var parent = Injector.fromResolvedProviders(parentProviders);
         * var child = parent.createChildFromResolved(childProviders);
         *
         * expect(child.get(ParentProvider) instanceof ParentProvider).toBe(true);
         * expect(child.get(ChildProvider) instanceof ChildProvider).toBe(true);
         * expect(child.get(ParentProvider)).toBe(parent.get(ParentProvider));
         * ```
         */
        Injector.prototype.createChildFromResolved = function (providers) {
            var bd = providers.map(function (b) {
                return new ProviderWithVisibility(b, Visibility.Public);
            });
            var proto = new ProtoInjector(bd);
            var inj = new Injector(proto);
            inj._parent = this;
            return inj;
        };
        /**
         * Resolves a provider and instantiates an object in the context of the injector.
         *
         * The created object does not get cached by the injector.
         *
         * ### Example ([live demo](http://plnkr.co/edit/yvVXoB?p=preview))
         *
         * ```typescript
         * @Injectable()
         * class Engine {
         * }
         *
         * @Injectable()
         * class Car {
         *   constructor(public engine:Engine) {}
         * }
         *
         * var injector = Injector.resolveAndCreate([Engine]);
         *
         * var car = injector.resolveAndInstantiate(Car);
         * expect(car.engine).toBe(injector.get(Engine));
         * expect(car).not.toBe(injector.resolveAndInstantiate(Car));
         * ```
         */
        Injector.prototype.resolveAndInstantiate = function (provider) {
            return this.instantiateResolved(Injector.resolve([provider])[0]);
        };
        /**
         * Instantiates an object using a resolved provider in the context of the injector.
         *
         * The created object does not get cached by the injector.
         *
         * ### Example ([live demo](http://plnkr.co/edit/ptCImQ?p=preview))
         *
         * ```typescript
         * @Injectable()
         * class Engine {
         * }
         *
         * @Injectable()
         * class Car {
         *   constructor(public engine:Engine) {}
         * }
         *
         * var injector = Injector.resolveAndCreate([Engine]);
         * var carProvider = Injector.resolve([Car])[0];
         * var car = injector.instantiateResolved(carProvider);
         * expect(car.engine).toBe(injector.get(Engine));
         * expect(car).not.toBe(injector.instantiateResolved(carProvider));
         * ```
         */
        Injector.prototype.instantiateResolved = function (provider) {
            return this._instantiateProvider(provider, Visibility.PublicAndPrivate);
        };
        /** @internal */
        Injector.prototype._new = function (provider, visibility) {
            if (this._constructionCounter++ > this._strategy.getMaxNumberOfObjects()) {
                throw new exceptions_1.CyclicDependencyError(this, provider.key);
            }
            return this._instantiateProvider(provider, visibility);
        };
        Injector.prototype._instantiateProvider = function (provider, visibility) {
            if (provider.multiProvider) {
                var res = collection_1.ListWrapper.createFixedSize(provider.resolvedFactories.length);
                for (var i = 0; i < provider.resolvedFactories.length; ++i) {
                    res[i] = this._instantiate(provider, provider.resolvedFactories[i], visibility);
                }
                return res;
            } else {
                return this._instantiate(provider, provider.resolvedFactories[0], visibility);
            }
        };
        Injector.prototype._instantiate = function (provider, resolvedFactory, visibility) {
            var factory = resolvedFactory.factory;
            var deps = resolvedFactory.dependencies;
            var length = deps.length;
            var d0;
            var d1;
            var d2;
            var d3;
            var d4;
            var d5;
            var d6;
            var d7;
            var d8;
            var d9;
            var d10;
            var d11;
            var d12;
            var d13;
            var d14;
            var d15;
            var d16;
            var d17;
            var d18;
            var d19;
            try {
                d0 = length > 0 ? this._getByDependency(provider, deps[0], visibility) : null;
                d1 = length > 1 ? this._getByDependency(provider, deps[1], visibility) : null;
                d2 = length > 2 ? this._getByDependency(provider, deps[2], visibility) : null;
                d3 = length > 3 ? this._getByDependency(provider, deps[3], visibility) : null;
                d4 = length > 4 ? this._getByDependency(provider, deps[4], visibility) : null;
                d5 = length > 5 ? this._getByDependency(provider, deps[5], visibility) : null;
                d6 = length > 6 ? this._getByDependency(provider, deps[6], visibility) : null;
                d7 = length > 7 ? this._getByDependency(provider, deps[7], visibility) : null;
                d8 = length > 8 ? this._getByDependency(provider, deps[8], visibility) : null;
                d9 = length > 9 ? this._getByDependency(provider, deps[9], visibility) : null;
                d10 = length > 10 ? this._getByDependency(provider, deps[10], visibility) : null;
                d11 = length > 11 ? this._getByDependency(provider, deps[11], visibility) : null;
                d12 = length > 12 ? this._getByDependency(provider, deps[12], visibility) : null;
                d13 = length > 13 ? this._getByDependency(provider, deps[13], visibility) : null;
                d14 = length > 14 ? this._getByDependency(provider, deps[14], visibility) : null;
                d15 = length > 15 ? this._getByDependency(provider, deps[15], visibility) : null;
                d16 = length > 16 ? this._getByDependency(provider, deps[16], visibility) : null;
                d17 = length > 17 ? this._getByDependency(provider, deps[17], visibility) : null;
                d18 = length > 18 ? this._getByDependency(provider, deps[18], visibility) : null;
                d19 = length > 19 ? this._getByDependency(provider, deps[19], visibility) : null;
            } catch (e) {
                if (e instanceof exceptions_1.AbstractProviderError || e instanceof exceptions_1.InstantiationError) {
                    e.addKey(this, provider.key);
                }
                throw e;
            }
            var obj;
            try {
                switch (length) {
                    case 0:
                        obj = factory();
                        break;
                    case 1:
                        obj = factory(d0);
                        break;
                    case 2:
                        obj = factory(d0, d1);
                        break;
                    case 3:
                        obj = factory(d0, d1, d2);
                        break;
                    case 4:
                        obj = factory(d0, d1, d2, d3);
                        break;
                    case 5:
                        obj = factory(d0, d1, d2, d3, d4);
                        break;
                    case 6:
                        obj = factory(d0, d1, d2, d3, d4, d5);
                        break;
                    case 7:
                        obj = factory(d0, d1, d2, d3, d4, d5, d6);
                        break;
                    case 8:
                        obj = factory(d0, d1, d2, d3, d4, d5, d6, d7);
                        break;
                    case 9:
                        obj = factory(d0, d1, d2, d3, d4, d5, d6, d7, d8);
                        break;
                    case 10:
                        obj = factory(d0, d1, d2, d3, d4, d5, d6, d7, d8, d9);
                        break;
                    case 11:
                        obj = factory(d0, d1, d2, d3, d4, d5, d6, d7, d8, d9, d10);
                        break;
                    case 12:
                        obj = factory(d0, d1, d2, d3, d4, d5, d6, d7, d8, d9, d10, d11);
                        break;
                    case 13:
                        obj = factory(d0, d1, d2, d3, d4, d5, d6, d7, d8, d9, d10, d11, d12);
                        break;
                    case 14:
                        obj = factory(d0, d1, d2, d3, d4, d5, d6, d7, d8, d9, d10, d11, d12, d13);
                        break;
                    case 15:
                        obj = factory(d0, d1, d2, d3, d4, d5, d6, d7, d8, d9, d10, d11, d12, d13, d14);
                        break;
                    case 16:
                        obj = factory(d0, d1, d2, d3, d4, d5, d6, d7, d8, d9, d10, d11, d12, d13, d14, d15);
                        break;
                    case 17:
                        obj = factory(d0, d1, d2, d3, d4, d5, d6, d7, d8, d9, d10, d11, d12, d13, d14, d15, d16);
                        break;
                    case 18:
                        obj = factory(d0, d1, d2, d3, d4, d5, d6, d7, d8, d9, d10, d11, d12, d13, d14, d15, d16, d17);
                        break;
                    case 19:
                        obj = factory(d0, d1, d2, d3, d4, d5, d6, d7, d8, d9, d10, d11, d12, d13, d14, d15, d16, d17, d18);
                        break;
                    case 20:
                        obj = factory(d0, d1, d2, d3, d4, d5, d6, d7, d8, d9, d10, d11, d12, d13, d14, d15, d16, d17, d18, d19);
                        break;
                    default:
                        throw new exceptions_2.BaseException("Cannot instantiate '" + provider.key.displayName + "' because it has more than 20 dependencies");
                }
            } catch (e) {
                throw new exceptions_1.InstantiationError(this, e, e.stack, provider.key);
            }
            return obj;
        };
        Injector.prototype._getByDependency = function (provider, dep, providerVisibility) {
            var special = lang_1.isPresent(this._depProvider) ? this._depProvider.getDependency(this, provider, dep) : exports.UNDEFINED;
            if (special !== exports.UNDEFINED) {
                return special;
            } else {
                return this._getByKey(dep.key, dep.lowerBoundVisibility, dep.upperBoundVisibility, dep.optional, providerVisibility);
            }
        };
        Injector.prototype._getByKey = function (key, lowerBoundVisibility, upperBoundVisibility, optional, providerVisibility) {
            if (key === INJECTOR_KEY) {
                return this;
            }
            if (upperBoundVisibility instanceof metadata_1.SelfMetadata) {
                return this._getByKeySelf(key, optional, providerVisibility);
            } else if (upperBoundVisibility instanceof metadata_1.HostMetadata) {
                return this._getByKeyHost(key, optional, providerVisibility, lowerBoundVisibility);
            } else {
                return this._getByKeyDefault(key, optional, providerVisibility, lowerBoundVisibility);
            }
        };
        /** @internal */
        Injector.prototype._throwOrNull = function (key, optional) {
            if (optional) {
                return null;
            } else {
                throw new exceptions_1.NoProviderError(this, key);
            }
        };
        /** @internal */
        Injector.prototype._getByKeySelf = function (key, optional, providerVisibility) {
            var obj = this._strategy.getObjByKeyId(key.id, providerVisibility);
            return obj !== exports.UNDEFINED ? obj : this._throwOrNull(key, optional);
        };
        /** @internal */
        Injector.prototype._getByKeyHost = function (key, optional, providerVisibility, lowerBoundVisibility) {
            var inj = this;
            if (lowerBoundVisibility instanceof metadata_1.SkipSelfMetadata) {
                if (inj._isHostBoundary) {
                    return this._getPrivateDependency(key, optional, inj);
                } else {
                    inj = inj._parent;
                }
            }
            while (inj != null) {
                var obj = inj._strategy.getObjByKeyId(key.id, providerVisibility);
                if (obj !== exports.UNDEFINED) return obj;
                if (lang_1.isPresent(inj._parent) && inj._isHostBoundary) {
                    return this._getPrivateDependency(key, optional, inj);
                } else {
                    inj = inj._parent;
                }
            }
            return this._throwOrNull(key, optional);
        };
        /** @internal */
        Injector.prototype._getPrivateDependency = function (key, optional, inj) {
            var obj = inj._parent._strategy.getObjByKeyId(key.id, Visibility.Private);
            return obj !== exports.UNDEFINED ? obj : this._throwOrNull(key, optional);
        };
        /** @internal */
        Injector.prototype._getByKeyDefault = function (key, optional, providerVisibility, lowerBoundVisibility) {
            var inj = this;
            if (lowerBoundVisibility instanceof metadata_1.SkipSelfMetadata) {
                providerVisibility = inj._isHostBoundary ? Visibility.PublicAndPrivate : Visibility.Public;
                inj = inj._parent;
            }
            while (inj != null) {
                var obj = inj._strategy.getObjByKeyId(key.id, providerVisibility);
                if (obj !== exports.UNDEFINED) return obj;
                providerVisibility = inj._isHostBoundary ? Visibility.PublicAndPrivate : Visibility.Public;
                inj = inj._parent;
            }
            return this._throwOrNull(key, optional);
        };
        Object.defineProperty(Injector.prototype, "displayName", {
            get: function () {
                return "Injector(providers: [" + _mapProviders(this, function (b) {
                    return " \"" + b.key.displayName + "\" ";
                }).join(", ") + "])";
            },
            enumerable: true,
            configurable: true
        });
        Injector.prototype.toString = function () {
            return this.displayName;
        };
        return Injector;
    }();
    exports.Injector = Injector;
    var INJECTOR_KEY = key_1.Key.get(Injector);
    function _mapProviders(injector, fn) {
        var res = [];
        for (var i = 0; i < injector._proto.numberOfProviders; ++i) {
            res.push(fn(injector._proto.getProviderAtIndex(i)));
        }
        return res;
    }
});
System.registerDynamic("angular2/src/core/di/metadata.js", ["angular2/src/facade/lang.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var lang_1 = $__require("angular2/src/facade/lang.js");
    /**
     * A parameter metadata that specifies a dependency.
     *
     * ### Example ([live demo](http://plnkr.co/edit/6uHYJK?p=preview))
     *
     * ```typescript
     * class Engine {}
     *
     * @Injectable()
     * class Car {
     *   engine;
     *   constructor(@Inject("MyEngine") engine:Engine) {
     *     this.engine = engine;
     *   }
     * }
     *
     * var injector = Injector.resolveAndCreate([
     *  provide("MyEngine", {useClass: Engine}),
     *  Car
     * ]);
     *
     * expect(injector.get(Car).engine instanceof Engine).toBe(true);
     * ```
     *
     * When `@Inject()` is not present, {@link Injector} will use the type annotation of the parameter.
     *
     * ### Example
     *
     * ```typescript
     * class Engine {}
     *
     * @Injectable()
     * class Car {
     *   constructor(public engine: Engine) {} //same as constructor(@Inject(Engine) engine:Engine)
     * }
     *
     * var injector = Injector.resolveAndCreate([Engine, Car]);
     * expect(injector.get(Car).engine instanceof Engine).toBe(true);
     * ```
     */
    var InjectMetadata = function () {
        function InjectMetadata(token) {
            this.token = token;
        }
        InjectMetadata.prototype.toString = function () {
            return "@Inject(" + lang_1.stringify(this.token) + ")";
        };
        InjectMetadata = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [Object])], InjectMetadata);
        return InjectMetadata;
    }();
    exports.InjectMetadata = InjectMetadata;
    /**
     * A parameter metadata that marks a dependency as optional. {@link Injector} provides `null` if
     * the dependency is not found.
     *
     * ### Example ([live demo](http://plnkr.co/edit/AsryOm?p=preview))
     *
     * ```typescript
     * class Engine {}
     *
     * @Injectable()
     * class Car {
     *   engine;
     *   constructor(@Optional() engine:Engine) {
     *     this.engine = engine;
     *   }
     * }
     *
     * var injector = Injector.resolveAndCreate([Car]);
     * expect(injector.get(Car).engine).toBeNull();
     * ```
     */
    var OptionalMetadata = function () {
        function OptionalMetadata() {}
        OptionalMetadata.prototype.toString = function () {
            return "@Optional()";
        };
        OptionalMetadata = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [])], OptionalMetadata);
        return OptionalMetadata;
    }();
    exports.OptionalMetadata = OptionalMetadata;
    /**
     * `DependencyMetadata` is used by the framework to extend DI.
     * This is internal to Angular and should not be used directly.
     */
    var DependencyMetadata = function () {
        function DependencyMetadata() {}
        Object.defineProperty(DependencyMetadata.prototype, "token", {
            get: function () {
                return null;
            },
            enumerable: true,
            configurable: true
        });
        DependencyMetadata = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [])], DependencyMetadata);
        return DependencyMetadata;
    }();
    exports.DependencyMetadata = DependencyMetadata;
    /**
     * A marker metadata that marks a class as available to {@link Injector} for creation.
     *
     * ### Example ([live demo](http://plnkr.co/edit/Wk4DMQ?p=preview))
     *
     * ```typescript
     * @Injectable()
     * class UsefulService {}
     *
     * @Injectable()
     * class NeedsService {
     *   constructor(public service:UsefulService) {}
     * }
     *
     * var injector = Injector.resolveAndCreate([NeedsService, UsefulService]);
     * expect(injector.get(NeedsService).service instanceof UsefulService).toBe(true);
     * ```
     * {@link Injector} will throw {@link NoAnnotationError} when trying to instantiate a class that
     * does not have `@Injectable` marker, as shown in the example below.
     *
     * ```typescript
     * class UsefulService {}
     *
     * class NeedsService {
     *   constructor(public service:UsefulService) {}
     * }
     *
     * var injector = Injector.resolveAndCreate([NeedsService, UsefulService]);
     * expect(() => injector.get(NeedsService)).toThrowError();
     * ```
     */
    var InjectableMetadata = function () {
        function InjectableMetadata() {}
        InjectableMetadata = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [])], InjectableMetadata);
        return InjectableMetadata;
    }();
    exports.InjectableMetadata = InjectableMetadata;
    /**
     * Specifies that an {@link Injector} should retrieve a dependency only from itself.
     *
     * ### Example ([live demo](http://plnkr.co/edit/NeagAg?p=preview))
     *
     * ```typescript
     * class Dependency {
     * }
     *
     * @Injectable()
     * class NeedsDependency {
     *   dependency;
     *   constructor(@Self() dependency:Dependency) {
     *     this.dependency = dependency;
     *   }
     * }
     *
     * var inj = Injector.resolveAndCreate([Dependency, NeedsDependency]);
     * var nd = inj.get(NeedsDependency);
     *
     * expect(nd.dependency instanceof Dependency).toBe(true);
     *
     * var inj = Injector.resolveAndCreate([Dependency]);
     * var child = inj.resolveAndCreateChild([NeedsDependency]);
     * expect(() => child.get(NeedsDependency)).toThrowError();
     * ```
     */
    var SelfMetadata = function () {
        function SelfMetadata() {}
        SelfMetadata.prototype.toString = function () {
            return "@Self()";
        };
        SelfMetadata = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [])], SelfMetadata);
        return SelfMetadata;
    }();
    exports.SelfMetadata = SelfMetadata;
    /**
     * Specifies that the dependency resolution should start from the parent injector.
     *
     * ### Example ([live demo](http://plnkr.co/edit/Wchdzb?p=preview))
     *
     * ```typescript
     * class Dependency {
     * }
     *
     * @Injectable()
     * class NeedsDependency {
     *   dependency;
     *   constructor(@SkipSelf() dependency:Dependency) {
     *     this.dependency = dependency;
     *   }
     * }
     *
     * var parent = Injector.resolveAndCreate([Dependency]);
     * var child = parent.resolveAndCreateChild([NeedsDependency]);
     * expect(child.get(NeedsDependency).dependency instanceof Depedency).toBe(true);
     *
     * var inj = Injector.resolveAndCreate([Dependency, NeedsDependency]);
     * expect(() => inj.get(NeedsDependency)).toThrowError();
     * ```
     */
    var SkipSelfMetadata = function () {
        function SkipSelfMetadata() {}
        SkipSelfMetadata.prototype.toString = function () {
            return "@SkipSelf()";
        };
        SkipSelfMetadata = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [])], SkipSelfMetadata);
        return SkipSelfMetadata;
    }();
    exports.SkipSelfMetadata = SkipSelfMetadata;
    /**
     * Specifies that an injector should retrieve a dependency from any injector until reaching the
     * closest host.
     *
     * In Angular, a component element is automatically declared as a host for all the injectors in
     * its view.
     *
     * ### Example ([live demo](http://plnkr.co/edit/GX79pV?p=preview))
     *
     * In the following example `App` contains `ParentCmp`, which contains `ChildDirective`.
     * So `ParentCmp` is the host of `ChildDirective`.
     *
     * `ChildDirective` depends on two services: `HostService` and `OtherService`.
     * `HostService` is defined at `ParentCmp`, and `OtherService` is defined at `App`.
     *
     *```typescript
     * class OtherService {}
     * class HostService {}
     *
     * @Directive({
     *   selector: 'child-directive'
     * })
     * class ChildDirective {
     *   constructor(@Optional() @Host() os:OtherService, @Optional() @Host() hs:HostService){
     *     console.log("os is null", os);
     *     console.log("hs is NOT null", hs);
     *   }
     * }
     *
     * @Component({
     *   selector: 'parent-cmp',
     *   providers: [HostService],
     *   template: `
     *     Dir: <child-directive></child-directive>
     *   `,
     *   directives: [ChildDirective]
     * })
     * class ParentCmp {
     * }
     *
     * @Component({
     *   selector: 'app',
     *   providers: [OtherService],
     *   template: `
     *     Parent: <parent-cmp></parent-cmp>
     *   `,
     *   directives: [ParentCmp]
     * })
     * class App {
     * }
     *
     * bootstrap(App);
     *```
     */
    var HostMetadata = function () {
        function HostMetadata() {}
        HostMetadata.prototype.toString = function () {
            return "@Host()";
        };
        HostMetadata = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [])], HostMetadata);
        return HostMetadata;
    }();
    exports.HostMetadata = HostMetadata;
});
System.registerDynamic("angular2/src/core/di/provider.js", ["angular2/src/facade/lang.js", "angular2/src/facade/exceptions.js", "angular2/src/facade/collection.js", "angular2/src/core/reflection/reflection.js", "angular2/src/core/di/key.js", "angular2/src/core/di/metadata.js", "angular2/src/core/di/exceptions.js", "angular2/src/core/di/forward_ref.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var exceptions_1 = $__require("angular2/src/facade/exceptions.js");
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var reflection_1 = $__require("angular2/src/core/reflection/reflection.js");
    var key_1 = $__require("angular2/src/core/di/key.js");
    var metadata_1 = $__require("angular2/src/core/di/metadata.js");
    var exceptions_2 = $__require("angular2/src/core/di/exceptions.js");
    var forward_ref_1 = $__require("angular2/src/core/di/forward_ref.js");
    /**
     * `Dependency` is used by the framework to extend DI.
     * This is internal to Angular and should not be used directly.
     */
    var Dependency = function () {
        function Dependency(key, optional, lowerBoundVisibility, upperBoundVisibility, properties) {
            this.key = key;
            this.optional = optional;
            this.lowerBoundVisibility = lowerBoundVisibility;
            this.upperBoundVisibility = upperBoundVisibility;
            this.properties = properties;
        }
        Dependency.fromKey = function (key) {
            return new Dependency(key, false, null, null, []);
        };
        return Dependency;
    }();
    exports.Dependency = Dependency;
    var _EMPTY_LIST = lang_1.CONST_EXPR([]);
    /**
     * Describes how the {@link Injector} should instantiate a given token.
     *
     * See {@link provide}.
     *
     * ### Example ([live demo](http://plnkr.co/edit/GNAyj6K6PfYg2NBzgwZ5?p%3Dpreview&p=preview))
     *
     * ```javascript
     * var injector = Injector.resolveAndCreate([
     *   new Provider("message", { useValue: 'Hello' })
     * ]);
     *
     * expect(injector.get("message")).toEqual('Hello');
     * ```
     */
    var Provider = function () {
        function Provider(token, _a) {
            var useClass = _a.useClass,
                useValue = _a.useValue,
                useExisting = _a.useExisting,
                useFactory = _a.useFactory,
                deps = _a.deps,
                multi = _a.multi;
            this.token = token;
            this.useClass = useClass;
            this.useValue = useValue;
            this.useExisting = useExisting;
            this.useFactory = useFactory;
            this.dependencies = deps;
            this._multi = multi;
        }
        Object.defineProperty(Provider.prototype, "multi", {
            // TODO: Provide a full working example after alpha38 is released.
            /**
             * Creates multiple providers matching the same token (a multi-provider).
             *
             * Multi-providers are used for creating pluggable service, where the system comes
             * with some default providers, and the user can register additional providers.
             * The combination of the default providers and the additional providers will be
             * used to drive the behavior of the system.
             *
             * ### Example
             *
             * ```typescript
             * var injector = Injector.resolveAndCreate([
             *   new Provider("Strings", { useValue: "String1", multi: true}),
             *   new Provider("Strings", { useValue: "String2", multi: true})
             * ]);
             *
             * expect(injector.get("Strings")).toEqual(["String1", "String2"]);
             * ```
             *
             * Multi-providers and regular providers cannot be mixed. The following
             * will throw an exception:
             *
             * ```typescript
             * var injector = Injector.resolveAndCreate([
             *   new Provider("Strings", { useValue: "String1", multi: true }),
             *   new Provider("Strings", { useValue: "String2"})
             * ]);
             * ```
             */
            get: function () {
                return lang_1.normalizeBool(this._multi);
            },
            enumerable: true,
            configurable: true
        });
        Provider = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [Object, Object])], Provider);
        return Provider;
    }();
    exports.Provider = Provider;
    /**
     * See {@link Provider} instead.
     *
     * @deprecated
     */
    var Binding = function (_super) {
        __extends(Binding, _super);
        function Binding(token, _a) {
            var toClass = _a.toClass,
                toValue = _a.toValue,
                toAlias = _a.toAlias,
                toFactory = _a.toFactory,
                deps = _a.deps,
                multi = _a.multi;
            _super.call(this, token, {
                useClass: toClass,
                useValue: toValue,
                useExisting: toAlias,
                useFactory: toFactory,
                deps: deps,
                multi: multi
            });
        }
        Object.defineProperty(Binding.prototype, "toClass", {
            /**
             * @deprecated
             */
            get: function () {
                return this.useClass;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Binding.prototype, "toAlias", {
            /**
             * @deprecated
             */
            get: function () {
                return this.useExisting;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Binding.prototype, "toFactory", {
            /**
             * @deprecated
             */
            get: function () {
                return this.useFactory;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Binding.prototype, "toValue", {
            /**
             * @deprecated
             */
            get: function () {
                return this.useValue;
            },
            enumerable: true,
            configurable: true
        });
        Binding = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [Object, Object])], Binding);
        return Binding;
    }(Provider);
    exports.Binding = Binding;
    var ResolvedProvider_ = function () {
        function ResolvedProvider_(key, resolvedFactories, multiProvider) {
            this.key = key;
            this.resolvedFactories = resolvedFactories;
            this.multiProvider = multiProvider;
        }
        Object.defineProperty(ResolvedProvider_.prototype, "resolvedFactory", {
            get: function () {
                return this.resolvedFactories[0];
            },
            enumerable: true,
            configurable: true
        });
        return ResolvedProvider_;
    }();
    exports.ResolvedProvider_ = ResolvedProvider_;
    /**
     * An internal resolved representation of a factory function created by resolving {@link Provider}.
     */
    var ResolvedFactory = function () {
        function ResolvedFactory(
        /**
         * Factory function which can return an instance of an object represented by a key.
         */
        factory,
        /**
         * Arguments (dependencies) to the `factory` function.
         */
        dependencies) {
            this.factory = factory;
            this.dependencies = dependencies;
        }
        return ResolvedFactory;
    }();
    exports.ResolvedFactory = ResolvedFactory;
    /**
     * Creates a {@link Provider}.
     *
     * To construct a {@link Provider}, bind a `token` to either a class, a value, a factory function,
     * or
     * to an existing `token`.
     * See {@link ProviderBuilder} for more details.
     *
     * The `token` is most commonly a class or {@link angular2/di/OpaqueToken}.
     *
     * @deprecated
     */
    function bind(token) {
        return new ProviderBuilder(token);
    }
    exports.bind = bind;
    /**
     * Creates a {@link Provider}.
     *
     * See {@link Provider} for more details.
     *
     * <!-- TODO: improve the docs -->
     */
    function provide(token, _a) {
        var useClass = _a.useClass,
            useValue = _a.useValue,
            useExisting = _a.useExisting,
            useFactory = _a.useFactory,
            deps = _a.deps,
            multi = _a.multi;
        return new Provider(token, {
            useClass: useClass,
            useValue: useValue,
            useExisting: useExisting,
            useFactory: useFactory,
            deps: deps,
            multi: multi
        });
    }
    exports.provide = provide;
    /**
     * Helper class for the {@link bind} function.
     */
    var ProviderBuilder = function () {
        function ProviderBuilder(token) {
            this.token = token;
        }
        /**
         * Binds a DI token to a class.
         *
         * ### Example ([live demo](http://plnkr.co/edit/ZpBCSYqv6e2ud5KXLdxQ?p=preview))
         *
         * Because `toAlias` and `toClass` are often confused, the example contains
         * both use cases for easy comparison.
         *
         * ```typescript
         * class Vehicle {}
         *
         * class Car extends Vehicle {}
         *
         * var injectorClass = Injector.resolveAndCreate([
         *   Car,
         *   provide(Vehicle, {useClass: Car})
         * ]);
         * var injectorAlias = Injector.resolveAndCreate([
         *   Car,
         *   provide(Vehicle, {useExisting: Car})
         * ]);
         *
         * expect(injectorClass.get(Vehicle)).not.toBe(injectorClass.get(Car));
         * expect(injectorClass.get(Vehicle) instanceof Car).toBe(true);
         *
         * expect(injectorAlias.get(Vehicle)).toBe(injectorAlias.get(Car));
         * expect(injectorAlias.get(Vehicle) instanceof Car).toBe(true);
         * ```
         */
        ProviderBuilder.prototype.toClass = function (type) {
            if (!lang_1.isType(type)) {
                throw new exceptions_1.BaseException("Trying to create a class provider but \"" + lang_1.stringify(type) + "\" is not a class!");
            }
            return new Provider(this.token, { useClass: type });
        };
        /**
         * Binds a DI token to a value.
         *
         * ### Example ([live demo](http://plnkr.co/edit/G024PFHmDL0cJFgfZK8O?p=preview))
         *
         * ```typescript
         * var injector = Injector.resolveAndCreate([
         *   provide('message', {useValue: 'Hello'})
         * ]);
         *
         * expect(injector.get('message')).toEqual('Hello');
         * ```
         */
        ProviderBuilder.prototype.toValue = function (value) {
            return new Provider(this.token, { useValue: value });
        };
        /**
         * Binds a DI token to an existing token.
         *
         * Angular will return the same instance as if the provided token was used. (This is
         * in contrast to `useClass` where a separate instance of `useClass` will be returned.)
         *
         * ### Example ([live demo](http://plnkr.co/edit/uBaoF2pN5cfc5AfZapNw?p=preview))
         *
         * Because `toAlias` and `toClass` are often confused, the example contains
         * both use cases for easy comparison.
         *
         * ```typescript
         * class Vehicle {}
         *
         * class Car extends Vehicle {}
         *
         * var injectorAlias = Injector.resolveAndCreate([
         *   Car,
         *   provide(Vehicle, {useExisting: Car})
         * ]);
         * var injectorClass = Injector.resolveAndCreate([
         *   Car,
         *   provide(Vehicle, {useClass: Car})
         * ]);
         *
         * expect(injectorAlias.get(Vehicle)).toBe(injectorAlias.get(Car));
         * expect(injectorAlias.get(Vehicle) instanceof Car).toBe(true);
         *
         * expect(injectorClass.get(Vehicle)).not.toBe(injectorClass.get(Car));
         * expect(injectorClass.get(Vehicle) instanceof Car).toBe(true);
         * ```
         */
        ProviderBuilder.prototype.toAlias = function (aliasToken) {
            if (lang_1.isBlank(aliasToken)) {
                throw new exceptions_1.BaseException("Can not alias " + lang_1.stringify(this.token) + " to a blank value!");
            }
            return new Provider(this.token, { useExisting: aliasToken });
        };
        /**
         * Binds a DI token to a function which computes the value.
         *
         * ### Example ([live demo](http://plnkr.co/edit/OejNIfTT3zb1iBxaIYOb?p=preview))
         *
         * ```typescript
         * var injector = Injector.resolveAndCreate([
         *   provide(Number, {useFactory: () => { return 1+2; }}),
         *   provide(String, {useFactory: (v) => { return "Value: " + v; }, deps: [Number]})
         * ]);
         *
         * expect(injector.get(Number)).toEqual(3);
         * expect(injector.get(String)).toEqual('Value: 3');
         * ```
         */
        ProviderBuilder.prototype.toFactory = function (factory, dependencies) {
            if (!lang_1.isFunction(factory)) {
                throw new exceptions_1.BaseException("Trying to create a factory provider but \"" + lang_1.stringify(factory) + "\" is not a function!");
            }
            return new Provider(this.token, { useFactory: factory, deps: dependencies });
        };
        return ProviderBuilder;
    }();
    exports.ProviderBuilder = ProviderBuilder;
    /**
     * Resolve a single provider.
     */
    function resolveFactory(provider) {
        var factoryFn;
        var resolvedDeps;
        if (lang_1.isPresent(provider.useClass)) {
            var useClass = forward_ref_1.resolveForwardRef(provider.useClass);
            factoryFn = reflection_1.reflector.factory(useClass);
            resolvedDeps = _dependenciesFor(useClass);
        } else if (lang_1.isPresent(provider.useExisting)) {
            factoryFn = function (aliasInstance) {
                return aliasInstance;
            };
            resolvedDeps = [Dependency.fromKey(key_1.Key.get(provider.useExisting))];
        } else if (lang_1.isPresent(provider.useFactory)) {
            factoryFn = provider.useFactory;
            resolvedDeps = _constructDependencies(provider.useFactory, provider.dependencies);
        } else {
            factoryFn = function () {
                return provider.useValue;
            };
            resolvedDeps = _EMPTY_LIST;
        }
        return new ResolvedFactory(factoryFn, resolvedDeps);
    }
    exports.resolveFactory = resolveFactory;
    /**
     * Converts the {@link Provider} into {@link ResolvedProvider}.
     *
     * {@link Injector} internally only uses {@link ResolvedProvider}, {@link Provider} contains
     * convenience provider syntax.
     */
    function resolveProvider(provider) {
        return new ResolvedProvider_(key_1.Key.get(provider.token), [resolveFactory(provider)], provider.multi);
    }
    exports.resolveProvider = resolveProvider;
    /**
     * Resolve a list of Providers.
     */
    function resolveProviders(providers) {
        var normalized = _normalizeProviders(providers, []);
        var resolved = normalized.map(resolveProvider);
        return collection_1.MapWrapper.values(mergeResolvedProviders(resolved, new Map()));
    }
    exports.resolveProviders = resolveProviders;
    /**
     * Merges a list of ResolvedProviders into a list where
     * each key is contained exactly once and multi providers
     * have been merged.
     */
    function mergeResolvedProviders(providers, normalizedProvidersMap) {
        for (var i = 0; i < providers.length; i++) {
            var provider = providers[i];
            var existing = normalizedProvidersMap.get(provider.key.id);
            if (lang_1.isPresent(existing)) {
                if (provider.multiProvider !== existing.multiProvider) {
                    throw new exceptions_2.MixingMultiProvidersWithRegularProvidersError(existing, provider);
                }
                if (provider.multiProvider) {
                    for (var j = 0; j < provider.resolvedFactories.length; j++) {
                        existing.resolvedFactories.push(provider.resolvedFactories[j]);
                    }
                } else {
                    normalizedProvidersMap.set(provider.key.id, provider);
                }
            } else {
                var resolvedProvider;
                if (provider.multiProvider) {
                    resolvedProvider = new ResolvedProvider_(provider.key, collection_1.ListWrapper.clone(provider.resolvedFactories), provider.multiProvider);
                } else {
                    resolvedProvider = provider;
                }
                normalizedProvidersMap.set(provider.key.id, resolvedProvider);
            }
        }
        return normalizedProvidersMap;
    }
    exports.mergeResolvedProviders = mergeResolvedProviders;
    function _normalizeProviders(providers, res) {
        providers.forEach(function (b) {
            if (b instanceof lang_1.Type) {
                res.push(provide(b, { useClass: b }));
            } else if (b instanceof Provider) {
                res.push(b);
            } else if (b instanceof Array) {
                _normalizeProviders(b, res);
            } else if (b instanceof ProviderBuilder) {
                throw new exceptions_2.InvalidProviderError(b.token);
            } else {
                throw new exceptions_2.InvalidProviderError(b);
            }
        });
        return res;
    }
    function _constructDependencies(factoryFunction, dependencies) {
        if (lang_1.isBlank(dependencies)) {
            return _dependenciesFor(factoryFunction);
        } else {
            var params = dependencies.map(function (t) {
                return [t];
            });
            return dependencies.map(function (t) {
                return _extractToken(factoryFunction, t, params);
            });
        }
    }
    function _dependenciesFor(typeOrFunc) {
        var params = reflection_1.reflector.parameters(typeOrFunc);
        if (lang_1.isBlank(params)) return [];
        if (params.some(lang_1.isBlank)) {
            throw new exceptions_2.NoAnnotationError(typeOrFunc, params);
        }
        return params.map(function (p) {
            return _extractToken(typeOrFunc, p, params);
        });
    }
    function _extractToken(typeOrFunc, metadata /*any[] | any*/, params) {
        var depProps = [];
        var token = null;
        var optional = false;
        if (!lang_1.isArray(metadata)) {
            if (metadata instanceof metadata_1.InjectMetadata) {
                return _createDependency(metadata.token, optional, null, null, depProps);
            } else {
                return _createDependency(metadata, optional, null, null, depProps);
            }
        }
        var lowerBoundVisibility = null;
        var upperBoundVisibility = null;
        for (var i = 0; i < metadata.length; ++i) {
            var paramMetadata = metadata[i];
            if (paramMetadata instanceof lang_1.Type) {
                token = paramMetadata;
            } else if (paramMetadata instanceof metadata_1.InjectMetadata) {
                token = paramMetadata.token;
            } else if (paramMetadata instanceof metadata_1.OptionalMetadata) {
                optional = true;
            } else if (paramMetadata instanceof metadata_1.SelfMetadata) {
                upperBoundVisibility = paramMetadata;
            } else if (paramMetadata instanceof metadata_1.HostMetadata) {
                upperBoundVisibility = paramMetadata;
            } else if (paramMetadata instanceof metadata_1.SkipSelfMetadata) {
                lowerBoundVisibility = paramMetadata;
            } else if (paramMetadata instanceof metadata_1.DependencyMetadata) {
                if (lang_1.isPresent(paramMetadata.token)) {
                    token = paramMetadata.token;
                }
                depProps.push(paramMetadata);
            }
        }
        token = forward_ref_1.resolveForwardRef(token);
        if (lang_1.isPresent(token)) {
            return _createDependency(token, optional, lowerBoundVisibility, upperBoundVisibility, depProps);
        } else {
            throw new exceptions_2.NoAnnotationError(typeOrFunc, params);
        }
    }
    function _createDependency(token, optional, lowerBoundVisibility, upperBoundVisibility, depProps) {
        return new Dependency(key_1.Key.get(token), optional, lowerBoundVisibility, upperBoundVisibility, depProps);
    }
});
System.registerDynamic('angular2/src/core/di/forward_ref.js', ['angular2/src/facade/lang.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    /**
     * Allows to refer to references which are not yet defined.
     *
     * For instance, `forwardRef` is used when the `token` which we need to refer to for the purposes of
     * DI is declared,
     * but not yet defined. It is also used when the `token` which we use when creating a query is not
     * yet defined.
     *
     * ### Example
     * {@example core/di/ts/forward_ref/forward_ref.ts region='forward_ref'}
     */
    function forwardRef(forwardRefFn) {
        forwardRefFn.__forward_ref__ = forwardRef;
        forwardRefFn.toString = function () {
            return lang_1.stringify(this());
        };
        return forwardRefFn;
    }
    exports.forwardRef = forwardRef;
    /**
     * Lazily retrieves the reference value from a forwardRef.
     *
     * Acts as the identity function when given a non-forward-ref value.
     *
     * ### Example ([live demo](http://plnkr.co/edit/GU72mJrk1fiodChcmiDR?p=preview))
     *
     * ```typescript
     * var ref = forwardRef(() => "refValue");
     * expect(resolveForwardRef(ref)).toEqual("refValue");
     * expect(resolveForwardRef("regularValue")).toEqual("regularValue");
     * ```
     *
     * See: {@link forwardRef}
     */
    function resolveForwardRef(type) {
        if (lang_1.isFunction(type) && type.hasOwnProperty('__forward_ref__') && type.__forward_ref__ === forwardRef) {
            return type();
        } else {
            return type;
        }
    }
    exports.resolveForwardRef = resolveForwardRef;
});
System.registerDynamic('angular2/src/core/di/key.js', ['angular2/src/facade/lang.js', 'angular2/src/facade/exceptions.js', 'angular2/src/core/di/forward_ref.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var exceptions_1 = $__require('angular2/src/facade/exceptions.js');
    var forward_ref_1 = $__require('angular2/src/core/di/forward_ref.js');
    /**
     * A unique object used for retrieving items from the {@link Injector}.
     *
     * Keys have:
     * - a system-wide unique `id`.
     * - a `token`.
     *
     * `Key` is used internally by {@link Injector} because its system-wide unique `id` allows the
     * injector to store created objects in a more efficient way.
     *
     * `Key` should not be created directly. {@link Injector} creates keys automatically when resolving
     * providers.
     */
    var Key = function () {
        /**
         * Private
         */
        function Key(token, id) {
            this.token = token;
            this.id = id;
            if (lang_1.isBlank(token)) {
                throw new exceptions_1.BaseException('Token must be defined!');
            }
        }
        Object.defineProperty(Key.prototype, "displayName", {
            /**
             * Returns a stringified token.
             */
            get: function () {
                return lang_1.stringify(this.token);
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Retrieves a `Key` for a token.
         */
        Key.get = function (token) {
            return _globalKeyRegistry.get(forward_ref_1.resolveForwardRef(token));
        };
        Object.defineProperty(Key, "numberOfKeys", {
            /**
             * @returns the number of keys registered in the system.
             */
            get: function () {
                return _globalKeyRegistry.numberOfKeys;
            },
            enumerable: true,
            configurable: true
        });
        return Key;
    }();
    exports.Key = Key;
    /**
     * @internal
     */
    var KeyRegistry = function () {
        function KeyRegistry() {
            this._allKeys = new Map();
        }
        KeyRegistry.prototype.get = function (token) {
            if (token instanceof Key) return token;
            if (this._allKeys.has(token)) {
                return this._allKeys.get(token);
            }
            var newKey = new Key(token, Key.numberOfKeys);
            this._allKeys.set(token, newKey);
            return newKey;
        };
        Object.defineProperty(KeyRegistry.prototype, "numberOfKeys", {
            get: function () {
                return this._allKeys.size;
            },
            enumerable: true,
            configurable: true
        });
        return KeyRegistry;
    }();
    exports.KeyRegistry = KeyRegistry;
    var _globalKeyRegistry = new KeyRegistry();
});
System.registerDynamic('angular2/src/core/di/exceptions.js', ['angular2/src/facade/collection.js', 'angular2/src/facade/lang.js', 'angular2/src/facade/exceptions.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var collection_1 = $__require('angular2/src/facade/collection.js');
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var exceptions_1 = $__require('angular2/src/facade/exceptions.js');
    function findFirstClosedCycle(keys) {
        var res = [];
        for (var i = 0; i < keys.length; ++i) {
            if (collection_1.ListWrapper.contains(res, keys[i])) {
                res.push(keys[i]);
                return res;
            } else {
                res.push(keys[i]);
            }
        }
        return res;
    }
    function constructResolvingPath(keys) {
        if (keys.length > 1) {
            var reversed = findFirstClosedCycle(collection_1.ListWrapper.reversed(keys));
            var tokenStrs = reversed.map(function (k) {
                return lang_1.stringify(k.token);
            });
            return " (" + tokenStrs.join(' -> ') + ")";
        } else {
            return "";
        }
    }
    /**
     * Base class for all errors arising from misconfigured providers.
     */
    var AbstractProviderError = function (_super) {
        __extends(AbstractProviderError, _super);
        function AbstractProviderError(injector, key, constructResolvingMessage) {
            _super.call(this, "DI Exception");
            this.keys = [key];
            this.injectors = [injector];
            this.constructResolvingMessage = constructResolvingMessage;
            this.message = this.constructResolvingMessage(this.keys);
        }
        AbstractProviderError.prototype.addKey = function (injector, key) {
            this.injectors.push(injector);
            this.keys.push(key);
            this.message = this.constructResolvingMessage(this.keys);
        };
        Object.defineProperty(AbstractProviderError.prototype, "context", {
            get: function () {
                return this.injectors[this.injectors.length - 1].debugContext();
            },
            enumerable: true,
            configurable: true
        });
        return AbstractProviderError;
    }(exceptions_1.BaseException);
    exports.AbstractProviderError = AbstractProviderError;
    /**
     * Thrown when trying to retrieve a dependency by `Key` from {@link Injector}, but the
     * {@link Injector} does not have a {@link Provider} for {@link Key}.
     *
     * ### Example ([live demo](http://plnkr.co/edit/vq8D3FRB9aGbnWJqtEPE?p=preview))
     *
     * ```typescript
     * class A {
     *   constructor(b:B) {}
     * }
     *
     * expect(() => Injector.resolveAndCreate([A])).toThrowError();
     * ```
     */
    var NoProviderError = function (_super) {
        __extends(NoProviderError, _super);
        function NoProviderError(injector, key) {
            _super.call(this, injector, key, function (keys) {
                var first = lang_1.stringify(collection_1.ListWrapper.first(keys).token);
                return "No provider for " + first + "!" + constructResolvingPath(keys);
            });
        }
        return NoProviderError;
    }(AbstractProviderError);
    exports.NoProviderError = NoProviderError;
    /**
     * Thrown when dependencies form a cycle.
     *
     * ### Example ([live demo](http://plnkr.co/edit/wYQdNos0Tzql3ei1EV9j?p=info))
     *
     * ```typescript
     * var injector = Injector.resolveAndCreate([
     *   provide("one", {useFactory: (two) => "two", deps: [[new Inject("two")]]}),
     *   provide("two", {useFactory: (one) => "one", deps: [[new Inject("one")]]})
     * ]);
     *
     * expect(() => injector.get("one")).toThrowError();
     * ```
     *
     * Retrieving `A` or `B` throws a `CyclicDependencyError` as the graph above cannot be constructed.
     */
    var CyclicDependencyError = function (_super) {
        __extends(CyclicDependencyError, _super);
        function CyclicDependencyError(injector, key) {
            _super.call(this, injector, key, function (keys) {
                return "Cannot instantiate cyclic dependency!" + constructResolvingPath(keys);
            });
        }
        return CyclicDependencyError;
    }(AbstractProviderError);
    exports.CyclicDependencyError = CyclicDependencyError;
    /**
     * Thrown when a constructing type returns with an Error.
     *
     * The `InstantiationError` class contains the original error plus the dependency graph which caused
     * this object to be instantiated.
     *
     * ### Example ([live demo](http://plnkr.co/edit/7aWYdcqTQsP0eNqEdUAf?p=preview))
     *
     * ```typescript
     * class A {
     *   constructor() {
     *     throw new Error('message');
     *   }
     * }
     *
     * var injector = Injector.resolveAndCreate([A]);
    
     * try {
     *   injector.get(A);
     * } catch (e) {
     *   expect(e instanceof InstantiationError).toBe(true);
     *   expect(e.originalException.message).toEqual("message");
     *   expect(e.originalStack).toBeDefined();
     * }
     * ```
     */
    var InstantiationError = function (_super) {
        __extends(InstantiationError, _super);
        function InstantiationError(injector, originalException, originalStack, key) {
            _super.call(this, "DI Exception", originalException, originalStack, null);
            this.keys = [key];
            this.injectors = [injector];
        }
        InstantiationError.prototype.addKey = function (injector, key) {
            this.injectors.push(injector);
            this.keys.push(key);
        };
        Object.defineProperty(InstantiationError.prototype, "wrapperMessage", {
            get: function () {
                var first = lang_1.stringify(collection_1.ListWrapper.first(this.keys).token);
                return "Error during instantiation of " + first + "!" + constructResolvingPath(this.keys) + ".";
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(InstantiationError.prototype, "causeKey", {
            get: function () {
                return this.keys[0];
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(InstantiationError.prototype, "context", {
            get: function () {
                return this.injectors[this.injectors.length - 1].debugContext();
            },
            enumerable: true,
            configurable: true
        });
        return InstantiationError;
    }(exceptions_1.WrappedException);
    exports.InstantiationError = InstantiationError;
    /**
     * Thrown when an object other then {@link Provider} (or `Type`) is passed to {@link Injector}
     * creation.
     *
     * ### Example ([live demo](http://plnkr.co/edit/YatCFbPAMCL0JSSQ4mvH?p=preview))
     *
     * ```typescript
     * expect(() => Injector.resolveAndCreate(["not a type"])).toThrowError();
     * ```
     */
    var InvalidProviderError = function (_super) {
        __extends(InvalidProviderError, _super);
        function InvalidProviderError(provider) {
            _super.call(this, "Invalid provider - only instances of Provider and Type are allowed, got: " + provider.toString());
        }
        return InvalidProviderError;
    }(exceptions_1.BaseException);
    exports.InvalidProviderError = InvalidProviderError;
    /**
     * Thrown when the class has no annotation information.
     *
     * Lack of annotation information prevents the {@link Injector} from determining which dependencies
     * need to be injected into the constructor.
     *
     * ### Example ([live demo](http://plnkr.co/edit/rHnZtlNS7vJOPQ6pcVkm?p=preview))
     *
     * ```typescript
     * class A {
     *   constructor(b) {}
     * }
     *
     * expect(() => Injector.resolveAndCreate([A])).toThrowError();
     * ```
     *
     * This error is also thrown when the class not marked with {@link Injectable} has parameter types.
     *
     * ```typescript
     * class B {}
     *
     * class A {
     *   constructor(b:B) {} // no information about the parameter types of A is available at runtime.
     * }
     *
     * expect(() => Injector.resolveAndCreate([A,B])).toThrowError();
     * ```
     */
    var NoAnnotationError = function (_super) {
        __extends(NoAnnotationError, _super);
        function NoAnnotationError(typeOrFunc, params) {
            _super.call(this, NoAnnotationError._genMessage(typeOrFunc, params));
        }
        NoAnnotationError._genMessage = function (typeOrFunc, params) {
            var signature = [];
            for (var i = 0, ii = params.length; i < ii; i++) {
                var parameter = params[i];
                if (lang_1.isBlank(parameter) || parameter.length == 0) {
                    signature.push('?');
                } else {
                    signature.push(parameter.map(lang_1.stringify).join(' '));
                }
            }
            return "Cannot resolve all parameters for '" + lang_1.stringify(typeOrFunc) + "'(" + signature.join(', ') + "). " + "Make sure that all the parameters are decorated with Inject or have valid type annotations and that '" + lang_1.stringify(typeOrFunc) + "' is decorated with Injectable.";
        };
        return NoAnnotationError;
    }(exceptions_1.BaseException);
    exports.NoAnnotationError = NoAnnotationError;
    /**
     * Thrown when getting an object by index.
     *
     * ### Example ([live demo](http://plnkr.co/edit/bRs0SX2OTQiJzqvjgl8P?p=preview))
     *
     * ```typescript
     * class A {}
     *
     * var injector = Injector.resolveAndCreate([A]);
     *
     * expect(() => injector.getAt(100)).toThrowError();
     * ```
     */
    var OutOfBoundsError = function (_super) {
        __extends(OutOfBoundsError, _super);
        function OutOfBoundsError(index) {
            _super.call(this, "Index " + index + " is out-of-bounds.");
        }
        return OutOfBoundsError;
    }(exceptions_1.BaseException);
    exports.OutOfBoundsError = OutOfBoundsError;
    // TODO: add a working example after alpha38 is released
    /**
     * Thrown when a multi provider and a regular provider are bound to the same token.
     *
     * ### Example
     *
     * ```typescript
     * expect(() => Injector.resolveAndCreate([
     *   new Provider("Strings", {useValue: "string1", multi: true}),
     *   new Provider("Strings", {useValue: "string2", multi: false})
     * ])).toThrowError();
     * ```
     */
    var MixingMultiProvidersWithRegularProvidersError = function (_super) {
        __extends(MixingMultiProvidersWithRegularProvidersError, _super);
        function MixingMultiProvidersWithRegularProvidersError(provider1, provider2) {
            _super.call(this, "Cannot mix multi providers and regular providers, got: " + provider1.toString() + " " + provider2.toString());
        }
        return MixingMultiProvidersWithRegularProvidersError;
    }(exceptions_1.BaseException);
    exports.MixingMultiProvidersWithRegularProvidersError = MixingMultiProvidersWithRegularProvidersError;
});
System.registerDynamic("angular2/src/core/di/opaque_token.js", ["angular2/src/facade/lang.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var lang_1 = $__require("angular2/src/facade/lang.js");
    /**
     * Creates a token that can be used in a DI Provider.
     *
     * ### Example ([live demo](http://plnkr.co/edit/Ys9ezXpj2Mnoy3Uc8KBp?p=preview))
     *
     * ```typescript
     * var t = new OpaqueToken("value");
     *
     * var injector = Injector.resolveAndCreate([
     *   provide(t, {useValue: "bindingValue"})
     * ]);
     *
     * expect(injector.get(t)).toEqual("bindingValue");
     * ```
     *
     * Using an `OpaqueToken` is preferable to using strings as tokens because of possible collisions
     * caused by multiple providers using the same string as two different tokens.
     *
     * Using an `OpaqueToken` is preferable to using an `Object` as tokens because it provides better
     * error messages.
     */
    var OpaqueToken = function () {
        function OpaqueToken(_desc) {
            this._desc = _desc;
        }
        OpaqueToken.prototype.toString = function () {
            return "Token " + this._desc;
        };
        OpaqueToken = __decorate([lang_1.CONST(), __metadata('design:paramtypes', [String])], OpaqueToken);
        return OpaqueToken;
    }();
    exports.OpaqueToken = OpaqueToken;
});
System.registerDynamic('angular2/src/core/di.js', ['angular2/src/core/di/metadata.js', 'angular2/src/core/di/decorators.js', 'angular2/src/core/di/forward_ref.js', 'angular2/src/core/di/injector.js', 'angular2/src/core/di/provider.js', 'angular2/src/core/di/key.js', 'angular2/src/core/di/exceptions.js', 'angular2/src/core/di/opaque_token.js'], true, function ($__require, exports, module) {
  'use strict'; /**
                * @module
                * @description
                * The `di` module provides dependency injection container services.
                */
  "use strict";

  var global = this || self,
      GLOBAL = global;
  function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
  var metadata_1 = $__require('angular2/src/core/di/metadata.js');
  exports.InjectMetadata = metadata_1.InjectMetadata;
  exports.OptionalMetadata = metadata_1.OptionalMetadata;
  exports.InjectableMetadata = metadata_1.InjectableMetadata;
  exports.SelfMetadata = metadata_1.SelfMetadata;
  exports.HostMetadata = metadata_1.HostMetadata;
  exports.SkipSelfMetadata = metadata_1.SkipSelfMetadata;
  exports.DependencyMetadata = metadata_1.DependencyMetadata;
  // we have to reexport * because Dart and TS export two different sets of types
  __export($__require('angular2/src/core/di/decorators.js'));
  var forward_ref_1 = $__require('angular2/src/core/di/forward_ref.js');
  exports.forwardRef = forward_ref_1.forwardRef;
  exports.resolveForwardRef = forward_ref_1.resolveForwardRef;
  var injector_1 = $__require('angular2/src/core/di/injector.js');
  exports.Injector = injector_1.Injector;
  var provider_1 = $__require('angular2/src/core/di/provider.js');
  exports.Binding = provider_1.Binding;
  exports.ProviderBuilder = provider_1.ProviderBuilder;
  exports.ResolvedFactory = provider_1.ResolvedFactory;
  exports.Dependency = provider_1.Dependency;
  exports.bind = provider_1.bind;
  exports.Provider = provider_1.Provider;
  exports.provide = provider_1.provide;
  var key_1 = $__require('angular2/src/core/di/key.js');
  exports.Key = key_1.Key;
  var exceptions_1 = $__require('angular2/src/core/di/exceptions.js');
  exports.NoProviderError = exceptions_1.NoProviderError;
  exports.AbstractProviderError = exceptions_1.AbstractProviderError;
  exports.CyclicDependencyError = exceptions_1.CyclicDependencyError;
  exports.InstantiationError = exceptions_1.InstantiationError;
  exports.InvalidProviderError = exceptions_1.InvalidProviderError;
  exports.NoAnnotationError = exceptions_1.NoAnnotationError;
  exports.OutOfBoundsError = exceptions_1.OutOfBoundsError;
  var opaque_token_1 = $__require('angular2/src/core/di/opaque_token.js');
  exports.OpaqueToken = opaque_token_1.OpaqueToken;
});
System.registerDynamic('angular2/src/core/application_tokens.js', ['angular2/src/core/di.js', 'angular2/src/facade/lang.js'], true, function ($__require, exports, module) {
  'use strict';"use strict";

  var global = this || self,
      GLOBAL = global;
  var di_1 = $__require('angular2/src/core/di.js');
  var lang_1 = $__require('angular2/src/facade/lang.js');
  /**
   *  @internal
   */
  exports.APP_COMPONENT_REF_PROMISE = lang_1.CONST_EXPR(new di_1.OpaqueToken('Promise<ComponentRef>'));
  /**
   * An {@link angular2/di/OpaqueToken} representing the application root type in the {@link
   * Injector}.
   *
   * ```
   * @Component(...)
   * class MyApp {
   *   ...
   * }
   *
   * bootstrap(MyApp).then((appRef:ApplicationRef) {
   *   expect(appRef.injector.get(appComponentTypeToken)).toEqual(MyApp);
   * });
   *
   * ```
   */
  exports.APP_COMPONENT = lang_1.CONST_EXPR(new di_1.OpaqueToken('AppComponent'));
  /**
   * A DI Token representing a unique string id assigned to the application by Angular and used
   * primarily for prefixing application attributes and CSS styles when
   * {@link ViewEncapsulation#Emulated} is being used.
   *
   * If you need to avoid randomly generated value to be used as an application id, you can provide
   * a custom value via a DI provider <!-- TODO: provider --> configuring the root {@link Injector}
   * using this token.
   */
  exports.APP_ID = lang_1.CONST_EXPR(new di_1.OpaqueToken('AppId'));
  function _appIdRandomProviderFactory() {
    return "" + _randomChar() + _randomChar() + _randomChar();
  }
  /**
   * Providers that will generate a random APP_ID_TOKEN.
   */
  exports.APP_ID_RANDOM_PROVIDER = lang_1.CONST_EXPR(new di_1.Provider(exports.APP_ID, { useFactory: _appIdRandomProviderFactory, deps: [] }));
  function _randomChar() {
    return lang_1.StringWrapper.fromCharCode(97 + lang_1.Math.floor(lang_1.Math.random() * 25));
  }
  /**
   * A function that will be executed when a platform is initialized.
   */
  exports.PLATFORM_INITIALIZER = lang_1.CONST_EXPR(new di_1.OpaqueToken("Platform Initializer"));
  /**
   * A function that will be executed when an application is initialized.
   */
  exports.APP_INITIALIZER = lang_1.CONST_EXPR(new di_1.OpaqueToken("Application Initializer"));
  /**
   * A token which indicates the root directory of the application
   */
  exports.PACKAGE_ROOT_URL = lang_1.CONST_EXPR(new di_1.OpaqueToken("Application Packages Root URL"));
});
System.registerDynamic("angular2/src/core/linker/view_type.js", [], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    (function (ViewType) {
        // A view that contains the host element with bound component directive.
        // Contains a COMPONENT view
        ViewType[ViewType["HOST"] = 0] = "HOST";
        // The view of the component
        // Can contain 0 to n EMBEDDED views
        ViewType[ViewType["COMPONENT"] = 1] = "COMPONENT";
        // A view that is embedded into another View via a <template> element
        // inside of a COMPONENT view
        ViewType[ViewType["EMBEDDED"] = 2] = "EMBEDDED";
    })(exports.ViewType || (exports.ViewType = {}));
    var ViewType = exports.ViewType;
});
System.registerDynamic("angular2/src/core/linker/view_manager.js", ["angular2/src/core/di.js", "angular2/src/facade/lang.js", "angular2/src/facade/collection.js", "angular2/src/facade/exceptions.js", "angular2/src/core/linker/view.js", "angular2/src/core/render/api.js", "angular2/src/core/profile/profile.js", "angular2/src/core/application_tokens.js", "angular2/src/core/linker/view_type.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var __param = this && this.__param || function (paramIndex, decorator) {
        return function (target, key) {
            decorator(target, key, paramIndex);
        };
    };
    var di_1 = $__require("angular2/src/core/di.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var collection_1 = $__require("angular2/src/facade/collection.js");
    var exceptions_1 = $__require("angular2/src/facade/exceptions.js");
    var view_1 = $__require("angular2/src/core/linker/view.js");
    var api_1 = $__require("angular2/src/core/render/api.js");
    var profile_1 = $__require("angular2/src/core/profile/profile.js");
    var application_tokens_1 = $__require("angular2/src/core/application_tokens.js");
    var view_type_1 = $__require("angular2/src/core/linker/view_type.js");
    /**
     * Service exposing low level API for creating, moving and destroying Views.
     *
     * Most applications should use higher-level abstractions like {@link DynamicComponentLoader} and
     * {@link ViewContainerRef} instead.
     */
    var AppViewManager = function () {
        function AppViewManager() {}
        return AppViewManager;
    }();
    exports.AppViewManager = AppViewManager;
    var AppViewManager_ = function (_super) {
        __extends(AppViewManager_, _super);
        function AppViewManager_(_renderer, _appId) {
            _super.call(this);
            this._renderer = _renderer;
            this._appId = _appId;
            this._nextCompTypeId = 0;
            /** @internal */
            this._createRootHostViewScope = profile_1.wtfCreateScope('AppViewManager#createRootHostView()');
            /** @internal */
            this._destroyRootHostViewScope = profile_1.wtfCreateScope('AppViewManager#destroyRootHostView()');
            /** @internal */
            this._createEmbeddedViewInContainerScope = profile_1.wtfCreateScope('AppViewManager#createEmbeddedViewInContainer()');
            /** @internal */
            this._createHostViewInContainerScope = profile_1.wtfCreateScope('AppViewManager#createHostViewInContainer()');
            /** @internal */
            this._destroyViewInContainerScope = profile_1.wtfCreateScope('AppViewMananger#destroyViewInContainer()');
            /** @internal */
            this._attachViewInContainerScope = profile_1.wtfCreateScope('AppViewMananger#attachViewInContainer()');
            /** @internal */
            this._detachViewInContainerScope = profile_1.wtfCreateScope('AppViewMananger#detachViewInContainer()');
        }
        AppViewManager_.prototype.getViewContainer = function (location) {
            return location.internalElement.getViewContainerRef();
        };
        AppViewManager_.prototype.getHostElement = function (hostViewRef) {
            var hostView = hostViewRef.internalView;
            if (hostView.proto.type !== view_type_1.ViewType.HOST) {
                throw new exceptions_1.BaseException('This operation is only allowed on host views');
            }
            return hostView.appElements[0].ref;
        };
        AppViewManager_.prototype.getNamedElementInComponentView = function (hostLocation, variableName) {
            var appEl = hostLocation.internalElement;
            var componentView = appEl.componentView;
            if (lang_1.isBlank(componentView)) {
                throw new exceptions_1.BaseException("There is no component directive at element " + hostLocation);
            }
            for (var i = 0; i < componentView.appElements.length; i++) {
                var compAppEl = componentView.appElements[i];
                if (collection_1.StringMapWrapper.contains(compAppEl.proto.directiveVariableBindings, variableName)) {
                    return compAppEl.ref;
                }
            }
            throw new exceptions_1.BaseException("Could not find variable " + variableName);
        };
        AppViewManager_.prototype.getComponent = function (hostLocation) {
            return hostLocation.internalElement.getComponent();
        };
        AppViewManager_.prototype.createRootHostView = function (hostViewFactoryRef, overrideSelector, injector, projectableNodes) {
            if (projectableNodes === void 0) {
                projectableNodes = null;
            }
            var s = this._createRootHostViewScope();
            var hostViewFactory = hostViewFactoryRef.internalHostViewFactory;
            var selector = lang_1.isPresent(overrideSelector) ? overrideSelector : hostViewFactory.selector;
            var view = hostViewFactory.viewFactory(this._renderer, this, null, projectableNodes, selector, null, injector);
            return profile_1.wtfLeave(s, view.ref);
        };
        AppViewManager_.prototype.destroyRootHostView = function (hostViewRef) {
            var s = this._destroyRootHostViewScope();
            var hostView = hostViewRef.internalView;
            hostView.renderer.detachView(view_1.flattenNestedViewRenderNodes(hostView.rootNodesOrAppElements));
            hostView.destroy();
            profile_1.wtfLeave(s);
        };
        AppViewManager_.prototype.createEmbeddedViewInContainer = function (viewContainerLocation, index, templateRef) {
            var s = this._createEmbeddedViewInContainerScope();
            var contextEl = templateRef.elementRef.internalElement;
            var view = contextEl.embeddedViewFactory(contextEl.parentView.renderer, this, contextEl, contextEl.parentView.projectableNodes, null, null, null);
            this._attachViewToContainer(view, viewContainerLocation.internalElement, index);
            return profile_1.wtfLeave(s, view.ref);
        };
        AppViewManager_.prototype.createHostViewInContainer = function (viewContainerLocation, index, hostViewFactoryRef, dynamicallyCreatedProviders, projectableNodes) {
            var s = this._createHostViewInContainerScope();
            // TODO(tbosch): This should be specifiable via an additional argument!
            var viewContainerLocation_ = viewContainerLocation;
            var contextEl = viewContainerLocation_.internalElement;
            var hostViewFactory = hostViewFactoryRef.internalHostViewFactory;
            var view = hostViewFactory.viewFactory(contextEl.parentView.renderer, contextEl.parentView.viewManager, contextEl, projectableNodes, null, dynamicallyCreatedProviders, null);
            this._attachViewToContainer(view, viewContainerLocation_.internalElement, index);
            return profile_1.wtfLeave(s, view.ref);
        };
        AppViewManager_.prototype.destroyViewInContainer = function (viewContainerLocation, index) {
            var s = this._destroyViewInContainerScope();
            var view = this._detachViewInContainer(viewContainerLocation.internalElement, index);
            view.destroy();
            profile_1.wtfLeave(s);
        };
        // TODO(i): refactor detachViewInContainer+attachViewInContainer to moveViewInContainer
        AppViewManager_.prototype.attachViewInContainer = function (viewContainerLocation, index, viewRef) {
            var viewRef_ = viewRef;
            var s = this._attachViewInContainerScope();
            this._attachViewToContainer(viewRef_.internalView, viewContainerLocation.internalElement, index);
            return profile_1.wtfLeave(s, viewRef_);
        };
        // TODO(i): refactor detachViewInContainer+attachViewInContainer to moveViewInContainer
        AppViewManager_.prototype.detachViewInContainer = function (viewContainerLocation, index) {
            var s = this._detachViewInContainerScope();
            var view = this._detachViewInContainer(viewContainerLocation.internalElement, index);
            return profile_1.wtfLeave(s, view.ref);
        };
        /** @internal */
        AppViewManager_.prototype.onViewCreated = function (view) {};
        /** @internal */
        AppViewManager_.prototype.onViewDestroyed = function (view) {};
        /** @internal */
        AppViewManager_.prototype.createRenderComponentType = function (encapsulation, styles) {
            return new api_1.RenderComponentType(this._appId + "-" + this._nextCompTypeId++, encapsulation, styles);
        };
        AppViewManager_.prototype._attachViewToContainer = function (view, vcAppElement, viewIndex) {
            if (view.proto.type === view_type_1.ViewType.COMPONENT) {
                throw new exceptions_1.BaseException("Component views can't be moved!");
            }
            var nestedViews = vcAppElement.nestedViews;
            if (nestedViews == null) {
                nestedViews = [];
                vcAppElement.nestedViews = nestedViews;
            }
            collection_1.ListWrapper.insert(nestedViews, viewIndex, view);
            var refNode;
            if (viewIndex > 0) {
                var prevView = nestedViews[viewIndex - 1];
                refNode = prevView.rootNodesOrAppElements.length > 0 ? prevView.rootNodesOrAppElements[prevView.rootNodesOrAppElements.length - 1] : null;
            } else {
                refNode = vcAppElement.nativeElement;
            }
            if (lang_1.isPresent(refNode)) {
                var refRenderNode = view_1.findLastRenderNode(refNode);
                view.renderer.attachViewAfter(refRenderNode, view_1.flattenNestedViewRenderNodes(view.rootNodesOrAppElements));
            }
            // TODO: This is only needed when a view is destroyed,
            // not when it is detached for reordering with ng-for...
            vcAppElement.parentView.changeDetector.addContentChild(view.changeDetector);
            vcAppElement.traverseAndSetQueriesAsDirty();
        };
        AppViewManager_.prototype._detachViewInContainer = function (vcAppElement, viewIndex) {
            var view = collection_1.ListWrapper.removeAt(vcAppElement.nestedViews, viewIndex);
            if (view.proto.type === view_type_1.ViewType.COMPONENT) {
                throw new exceptions_1.BaseException("Component views can't be moved!");
            }
            vcAppElement.traverseAndSetQueriesAsDirty();
            view.renderer.detachView(view_1.flattenNestedViewRenderNodes(view.rootNodesOrAppElements));
            // TODO: This is only needed when a view is destroyed,
            // not when it is detached for reordering with ng-for...
            view.changeDetector.remove();
            return view;
        };
        AppViewManager_ = __decorate([di_1.Injectable(), __param(1, di_1.Inject(application_tokens_1.APP_ID)), __metadata('design:paramtypes', [api_1.RootRenderer, String])], AppViewManager_);
        return AppViewManager_;
    }(AppViewManager);
    exports.AppViewManager_ = AppViewManager_;
});
System.registerDynamic("angular2/src/core/linker/dynamic_component_loader.js", ["angular2/src/core/di.js", "angular2/src/core/linker/compiler.js", "angular2/src/facade/lang.js", "angular2/src/core/linker/view_manager.js"], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var di_1 = $__require("angular2/src/core/di.js");
    var compiler_1 = $__require("angular2/src/core/linker/compiler.js");
    var lang_1 = $__require("angular2/src/facade/lang.js");
    var view_manager_1 = $__require("angular2/src/core/linker/view_manager.js");
    /**
     * Represents an instance of a Component created via {@link DynamicComponentLoader}.
     *
     * `ComponentRef` provides access to the Component Instance as well other objects related to this
     * Component Instance and allows you to destroy the Component Instance via the {@link #dispose}
     * method.
     */
    var ComponentRef = function () {
        function ComponentRef() {}
        Object.defineProperty(ComponentRef.prototype, "hostView", {
            /**
             * The {@link ViewRef} of the Host View of this Component instance.
             */
            get: function () {
                return this.location.internalElement.parentView.ref;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ComponentRef.prototype, "hostComponent", {
            /**
             * @internal
             *
             * The instance of the component.
             *
             * TODO(i): this api should be removed
             */
            get: function () {
                return this.instance;
            },
            enumerable: true,
            configurable: true
        });
        return ComponentRef;
    }();
    exports.ComponentRef = ComponentRef;
    var ComponentRef_ = function (_super) {
        __extends(ComponentRef_, _super);
        /**
         * TODO(i): refactor into public/private fields
         */
        function ComponentRef_(location, instance, componentType, injector, _dispose) {
            _super.call(this);
            this._dispose = _dispose;
            this.location = location;
            this.instance = instance;
            this.componentType = componentType;
            this.injector = injector;
        }
        Object.defineProperty(ComponentRef_.prototype, "hostComponentType", {
            /**
             * @internal
             *
             * Returns the type of this Component instance.
             *
             * TODO(i): this api should be removed
             */
            get: function () {
                return this.componentType;
            },
            enumerable: true,
            configurable: true
        });
        ComponentRef_.prototype.dispose = function () {
            this._dispose();
        };
        return ComponentRef_;
    }(ComponentRef);
    exports.ComponentRef_ = ComponentRef_;
    /**
     * Service for instantiating a Component and attaching it to a View at a specified location.
     */
    var DynamicComponentLoader = function () {
        function DynamicComponentLoader() {}
        return DynamicComponentLoader;
    }();
    exports.DynamicComponentLoader = DynamicComponentLoader;
    var DynamicComponentLoader_ = function (_super) {
        __extends(DynamicComponentLoader_, _super);
        function DynamicComponentLoader_(_compiler, _viewManager) {
            _super.call(this);
            this._compiler = _compiler;
            this._viewManager = _viewManager;
        }
        DynamicComponentLoader_.prototype.loadAsRoot = function (type, overrideSelector, injector, onDispose, projectableNodes) {
            var _this = this;
            return this._compiler.compileInHost(type).then(function (hostProtoViewRef) {
                var hostViewRef = _this._viewManager.createRootHostView(hostProtoViewRef, overrideSelector, injector, projectableNodes);
                var newLocation = _this._viewManager.getHostElement(hostViewRef);
                var component = _this._viewManager.getComponent(newLocation);
                var dispose = function () {
                    if (lang_1.isPresent(onDispose)) {
                        onDispose();
                    }
                    _this._viewManager.destroyRootHostView(hostViewRef);
                };
                return new ComponentRef_(newLocation, component, type, injector, dispose);
            });
        };
        DynamicComponentLoader_.prototype.loadIntoLocation = function (type, hostLocation, anchorName, providers, projectableNodes) {
            if (providers === void 0) {
                providers = null;
            }
            if (projectableNodes === void 0) {
                projectableNodes = null;
            }
            return this.loadNextToLocation(type, this._viewManager.getNamedElementInComponentView(hostLocation, anchorName), providers, projectableNodes);
        };
        DynamicComponentLoader_.prototype.loadNextToLocation = function (type, location, providers, projectableNodes) {
            var _this = this;
            if (providers === void 0) {
                providers = null;
            }
            if (projectableNodes === void 0) {
                projectableNodes = null;
            }
            return this._compiler.compileInHost(type).then(function (hostProtoViewRef) {
                var viewContainer = _this._viewManager.getViewContainer(location);
                var hostViewRef = viewContainer.createHostView(hostProtoViewRef, viewContainer.length, providers, projectableNodes);
                var newLocation = _this._viewManager.getHostElement(hostViewRef);
                var component = _this._viewManager.getComponent(newLocation);
                var dispose = function () {
                    var index = viewContainer.indexOf(hostViewRef);
                    if (!hostViewRef.destroyed && index !== -1) {
                        viewContainer.remove(index);
                    }
                };
                return new ComponentRef_(newLocation, component, type, null, dispose);
            });
        };
        DynamicComponentLoader_ = __decorate([di_1.Injectable(), __metadata('design:paramtypes', [compiler_1.Compiler, view_manager_1.AppViewManager])], DynamicComponentLoader_);
        return DynamicComponentLoader_;
    }(DynamicComponentLoader);
    exports.DynamicComponentLoader_ = DynamicComponentLoader_;
});
System.registerDynamic('angular2/src/core/application_common_providers.js', ['angular2/src/facade/lang.js', 'angular2/src/core/di.js', 'angular2/src/core/application_tokens.js', 'angular2/src/core/change_detection/change_detection.js', 'angular2/src/core/linker/resolved_metadata_cache.js', 'angular2/src/core/linker/view_manager.js', 'angular2/src/core/linker/view_resolver.js', 'angular2/src/core/linker/directive_resolver.js', 'angular2/src/core/linker/pipe_resolver.js', 'angular2/src/core/linker/compiler.js', 'angular2/src/core/linker/dynamic_component_loader.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var di_1 = $__require('angular2/src/core/di.js');
    var application_tokens_1 = $__require('angular2/src/core/application_tokens.js');
    var change_detection_1 = $__require('angular2/src/core/change_detection/change_detection.js');
    var resolved_metadata_cache_1 = $__require('angular2/src/core/linker/resolved_metadata_cache.js');
    var view_manager_1 = $__require('angular2/src/core/linker/view_manager.js');
    var view_manager_2 = $__require('angular2/src/core/linker/view_manager.js');
    var view_resolver_1 = $__require('angular2/src/core/linker/view_resolver.js');
    var directive_resolver_1 = $__require('angular2/src/core/linker/directive_resolver.js');
    var pipe_resolver_1 = $__require('angular2/src/core/linker/pipe_resolver.js');
    var compiler_1 = $__require('angular2/src/core/linker/compiler.js');
    var compiler_2 = $__require('angular2/src/core/linker/compiler.js');
    var dynamic_component_loader_1 = $__require('angular2/src/core/linker/dynamic_component_loader.js');
    var dynamic_component_loader_2 = $__require('angular2/src/core/linker/dynamic_component_loader.js');
    /**
     * A default set of providers which should be included in any Angular
     * application, regardless of the platform it runs onto.
     */
    exports.APPLICATION_COMMON_PROVIDERS = lang_1.CONST_EXPR([new di_1.Provider(compiler_1.Compiler, { useClass: compiler_2.Compiler_ }), application_tokens_1.APP_ID_RANDOM_PROVIDER, resolved_metadata_cache_1.ResolvedMetadataCache, new di_1.Provider(view_manager_1.AppViewManager, { useClass: view_manager_2.AppViewManager_ }), view_resolver_1.ViewResolver, new di_1.Provider(change_detection_1.IterableDiffers, { useValue: change_detection_1.defaultIterableDiffers }), new di_1.Provider(change_detection_1.KeyValueDiffers, { useValue: change_detection_1.defaultKeyValueDiffers }), directive_resolver_1.DirectiveResolver, pipe_resolver_1.PipeResolver, new di_1.Provider(dynamic_component_loader_1.DynamicComponentLoader, { useClass: dynamic_component_loader_2.DynamicComponentLoader_ })]);
});
System.registerDynamic("angular2/src/core/reflection/reflector_reader.js", [], true, function ($__require, exports, module) {
  'use strict';"use strict";
  /**
   * Provides read-only access to reflection data about symbols. Used internally by Angular
   * to power dependency injection and compilation.
   */

  var global = this || self,
      GLOBAL = global;
  var ReflectorReader = function () {
    function ReflectorReader() {}
    return ReflectorReader;
  }();
  exports.ReflectorReader = ReflectorReader;
});
System.registerDynamic('angular2/src/core/reflection/reflector.js', ['angular2/src/facade/lang.js', 'angular2/src/facade/exceptions.js', 'angular2/src/facade/collection.js', 'angular2/src/core/reflection/reflector_reader.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var exceptions_1 = $__require('angular2/src/facade/exceptions.js');
    var collection_1 = $__require('angular2/src/facade/collection.js');
    var reflector_reader_1 = $__require('angular2/src/core/reflection/reflector_reader.js');
    /**
     * Reflective information about a symbol, including annotations, interfaces, and other metadata.
     */
    var ReflectionInfo = function () {
        function ReflectionInfo(annotations, parameters, factory, interfaces, propMetadata) {
            this.annotations = annotations;
            this.parameters = parameters;
            this.factory = factory;
            this.interfaces = interfaces;
            this.propMetadata = propMetadata;
        }
        return ReflectionInfo;
    }();
    exports.ReflectionInfo = ReflectionInfo;
    /**
     * Provides access to reflection data about symbols. Used internally by Angular
     * to power dependency injection and compilation.
     */
    var Reflector = function (_super) {
        __extends(Reflector, _super);
        function Reflector(reflectionCapabilities) {
            _super.call(this);
            /** @internal */
            this._injectableInfo = new collection_1.Map();
            /** @internal */
            this._getters = new collection_1.Map();
            /** @internal */
            this._setters = new collection_1.Map();
            /** @internal */
            this._methods = new collection_1.Map();
            this._usedKeys = null;
            this.reflectionCapabilities = reflectionCapabilities;
        }
        Reflector.prototype.isReflectionEnabled = function () {
            return this.reflectionCapabilities.isReflectionEnabled();
        };
        /**
         * Causes `this` reflector to track keys used to access
         * {@link ReflectionInfo} objects.
         */
        Reflector.prototype.trackUsage = function () {
            this._usedKeys = new collection_1.Set();
        };
        /**
         * Lists types for which reflection information was not requested since
         * {@link #trackUsage} was called. This list could later be audited as
         * potential dead code.
         */
        Reflector.prototype.listUnusedKeys = function () {
            var _this = this;
            if (this._usedKeys == null) {
                throw new exceptions_1.BaseException('Usage tracking is disabled');
            }
            var allTypes = collection_1.MapWrapper.keys(this._injectableInfo);
            return allTypes.filter(function (key) {
                return !collection_1.SetWrapper.has(_this._usedKeys, key);
            });
        };
        Reflector.prototype.registerFunction = function (func, funcInfo) {
            this._injectableInfo.set(func, funcInfo);
        };
        Reflector.prototype.registerType = function (type, typeInfo) {
            this._injectableInfo.set(type, typeInfo);
        };
        Reflector.prototype.registerGetters = function (getters) {
            _mergeMaps(this._getters, getters);
        };
        Reflector.prototype.registerSetters = function (setters) {
            _mergeMaps(this._setters, setters);
        };
        Reflector.prototype.registerMethods = function (methods) {
            _mergeMaps(this._methods, methods);
        };
        Reflector.prototype.factory = function (type) {
            if (this._containsReflectionInfo(type)) {
                var res = this._getReflectionInfo(type).factory;
                return lang_1.isPresent(res) ? res : null;
            } else {
                return this.reflectionCapabilities.factory(type);
            }
        };
        Reflector.prototype.parameters = function (typeOrFunc) {
            if (this._injectableInfo.has(typeOrFunc)) {
                var res = this._getReflectionInfo(typeOrFunc).parameters;
                return lang_1.isPresent(res) ? res : [];
            } else {
                return this.reflectionCapabilities.parameters(typeOrFunc);
            }
        };
        Reflector.prototype.annotations = function (typeOrFunc) {
            if (this._injectableInfo.has(typeOrFunc)) {
                var res = this._getReflectionInfo(typeOrFunc).annotations;
                return lang_1.isPresent(res) ? res : [];
            } else {
                return this.reflectionCapabilities.annotations(typeOrFunc);
            }
        };
        Reflector.prototype.propMetadata = function (typeOrFunc) {
            if (this._injectableInfo.has(typeOrFunc)) {
                var res = this._getReflectionInfo(typeOrFunc).propMetadata;
                return lang_1.isPresent(res) ? res : {};
            } else {
                return this.reflectionCapabilities.propMetadata(typeOrFunc);
            }
        };
        Reflector.prototype.interfaces = function (type) {
            if (this._injectableInfo.has(type)) {
                var res = this._getReflectionInfo(type).interfaces;
                return lang_1.isPresent(res) ? res : [];
            } else {
                return this.reflectionCapabilities.interfaces(type);
            }
        };
        Reflector.prototype.getter = function (name) {
            if (this._getters.has(name)) {
                return this._getters.get(name);
            } else {
                return this.reflectionCapabilities.getter(name);
            }
        };
        Reflector.prototype.setter = function (name) {
            if (this._setters.has(name)) {
                return this._setters.get(name);
            } else {
                return this.reflectionCapabilities.setter(name);
            }
        };
        Reflector.prototype.method = function (name) {
            if (this._methods.has(name)) {
                return this._methods.get(name);
            } else {
                return this.reflectionCapabilities.method(name);
            }
        };
        /** @internal */
        Reflector.prototype._getReflectionInfo = function (typeOrFunc) {
            if (lang_1.isPresent(this._usedKeys)) {
                this._usedKeys.add(typeOrFunc);
            }
            return this._injectableInfo.get(typeOrFunc);
        };
        /** @internal */
        Reflector.prototype._containsReflectionInfo = function (typeOrFunc) {
            return this._injectableInfo.has(typeOrFunc);
        };
        Reflector.prototype.importUri = function (type) {
            return this.reflectionCapabilities.importUri(type);
        };
        return Reflector;
    }(reflector_reader_1.ReflectorReader);
    exports.Reflector = Reflector;
    function _mergeMaps(target, config) {
        collection_1.StringMapWrapper.forEach(config, function (v, k) {
            return target.set(k, v);
        });
    }
});
System.registerDynamic("angular2/src/facade/base_wrapped_exception.js", [], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    /**
     * A base class for the WrappedException that can be used to identify
     * a WrappedException from ExceptionHandler without adding circular
     * dependency.
     */
    var BaseWrappedException = function (_super) {
        __extends(BaseWrappedException, _super);
        function BaseWrappedException(message) {
            _super.call(this, message);
        }
        Object.defineProperty(BaseWrappedException.prototype, "wrapperMessage", {
            get: function () {
                return '';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BaseWrappedException.prototype, "wrapperStack", {
            get: function () {
                return null;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BaseWrappedException.prototype, "originalException", {
            get: function () {
                return null;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BaseWrappedException.prototype, "originalStack", {
            get: function () {
                return null;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BaseWrappedException.prototype, "context", {
            get: function () {
                return null;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BaseWrappedException.prototype, "message", {
            get: function () {
                return '';
            },
            enumerable: true,
            configurable: true
        });
        return BaseWrappedException;
    }(Error);
    exports.BaseWrappedException = BaseWrappedException;
});
System.registerDynamic('angular2/src/facade/lang.js', [], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var globalScope;
    if (typeof window === 'undefined') {
        if (typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope) {
            // TODO: Replace any with WorkerGlobalScope from lib.webworker.d.ts #3492
            globalScope = self;
        } else {
            globalScope = global;
        }
    } else {
        globalScope = window;
    }
    function scheduleMicroTask(fn) {
        Zone.current.scheduleMicroTask('scheduleMicrotask', fn);
    }
    exports.scheduleMicroTask = scheduleMicroTask;
    exports.IS_DART = false;
    // Need to declare a new variable for global here since TypeScript
    // exports the original value of the symbol.
    var _global = globalScope;
    exports.global = _global;
    exports.Type = Function;
    function getTypeNameForDebugging(type) {
        if (type['name']) {
            return type['name'];
        }
        return typeof type;
    }
    exports.getTypeNameForDebugging = getTypeNameForDebugging;
    exports.Math = _global.Math;
    exports.Date = _global.Date;
    var _devMode = true;
    var _modeLocked = false;
    function lockMode() {
        _modeLocked = true;
    }
    exports.lockMode = lockMode;
    /**
     * Disable Angular's development mode, which turns off assertions and other
     * checks within the framework.
     *
     * One important assertion this disables verifies that a change detection pass
     * does not result in additional changes to any bindings (also known as
     * unidirectional data flow).
     */
    function enableProdMode() {
        if (_modeLocked) {
            // Cannot use BaseException as that ends up importing from facade/lang.
            throw 'Cannot enable prod mode after platform setup.';
        }
        _devMode = false;
    }
    exports.enableProdMode = enableProdMode;
    function assertionsEnabled() {
        return _devMode;
    }
    exports.assertionsEnabled = assertionsEnabled;
    // TODO: remove calls to assert in production environment
    // Note: Can't just export this and import in in other files
    // as `assert` is a reserved keyword in Dart
    _global.assert = function assert(condition) {
        // TODO: to be fixed properly via #2830, noop for now
    };
    // This function is needed only to properly support Dart's const expressions
    // see https://github.com/angular/ts2dart/pull/151 for more info
    function CONST_EXPR(expr) {
        return expr;
    }
    exports.CONST_EXPR = CONST_EXPR;
    function CONST() {
        return function (target) {
            return target;
        };
    }
    exports.CONST = CONST;
    function isPresent(obj) {
        return obj !== undefined && obj !== null;
    }
    exports.isPresent = isPresent;
    function isBlank(obj) {
        return obj === undefined || obj === null;
    }
    exports.isBlank = isBlank;
    function isBoolean(obj) {
        return typeof obj === "boolean";
    }
    exports.isBoolean = isBoolean;
    function isNumber(obj) {
        return typeof obj === "number";
    }
    exports.isNumber = isNumber;
    function isString(obj) {
        return typeof obj === "string";
    }
    exports.isString = isString;
    function isFunction(obj) {
        return typeof obj === "function";
    }
    exports.isFunction = isFunction;
    function isType(obj) {
        return isFunction(obj);
    }
    exports.isType = isType;
    function isStringMap(obj) {
        return typeof obj === 'object' && obj !== null;
    }
    exports.isStringMap = isStringMap;
    function isPromise(obj) {
        return obj instanceof _global.Promise;
    }
    exports.isPromise = isPromise;
    function isArray(obj) {
        return Array.isArray(obj);
    }
    exports.isArray = isArray;
    function isDate(obj) {
        return obj instanceof exports.Date && !isNaN(obj.valueOf());
    }
    exports.isDate = isDate;
    function noop() {}
    exports.noop = noop;
    function stringify(token) {
        if (typeof token === 'string') {
            return token;
        }
        if (token === undefined || token === null) {
            return '' + token;
        }
        if (token.name) {
            return token.name;
        }
        if (token.overriddenName) {
            return token.overriddenName;
        }
        var res = token.toString();
        var newLineIndex = res.indexOf("\n");
        return newLineIndex === -1 ? res : res.substring(0, newLineIndex);
    }
    exports.stringify = stringify;
    // serialize / deserialize enum exist only for consistency with dart API
    // enums in typescript don't need to be serialized
    function serializeEnum(val) {
        return val;
    }
    exports.serializeEnum = serializeEnum;
    function deserializeEnum(val, values) {
        return val;
    }
    exports.deserializeEnum = deserializeEnum;
    function resolveEnumToken(enumValue, val) {
        return enumValue[val];
    }
    exports.resolveEnumToken = resolveEnumToken;
    var StringWrapper = function () {
        function StringWrapper() {}
        StringWrapper.fromCharCode = function (code) {
            return String.fromCharCode(code);
        };
        StringWrapper.charCodeAt = function (s, index) {
            return s.charCodeAt(index);
        };
        StringWrapper.split = function (s, regExp) {
            return s.split(regExp);
        };
        StringWrapper.equals = function (s, s2) {
            return s === s2;
        };
        StringWrapper.stripLeft = function (s, charVal) {
            if (s && s.length) {
                var pos = 0;
                for (var i = 0; i < s.length; i++) {
                    if (s[i] != charVal) break;
                    pos++;
                }
                s = s.substring(pos);
            }
            return s;
        };
        StringWrapper.stripRight = function (s, charVal) {
            if (s && s.length) {
                var pos = s.length;
                for (var i = s.length - 1; i >= 0; i--) {
                    if (s[i] != charVal) break;
                    pos--;
                }
                s = s.substring(0, pos);
            }
            return s;
        };
        StringWrapper.replace = function (s, from, replace) {
            return s.replace(from, replace);
        };
        StringWrapper.replaceAll = function (s, from, replace) {
            return s.replace(from, replace);
        };
        StringWrapper.slice = function (s, from, to) {
            if (from === void 0) {
                from = 0;
            }
            if (to === void 0) {
                to = null;
            }
            return s.slice(from, to === null ? undefined : to);
        };
        StringWrapper.replaceAllMapped = function (s, from, cb) {
            return s.replace(from, function () {
                var matches = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    matches[_i - 0] = arguments[_i];
                }
                // Remove offset & string from the result array
                matches.splice(-2, 2);
                // The callback receives match, p1, ..., pn
                return cb(matches);
            });
        };
        StringWrapper.contains = function (s, substr) {
            return s.indexOf(substr) != -1;
        };
        StringWrapper.compare = function (a, b) {
            if (a < b) {
                return -1;
            } else if (a > b) {
                return 1;
            } else {
                return 0;
            }
        };
        return StringWrapper;
    }();
    exports.StringWrapper = StringWrapper;
    var StringJoiner = function () {
        function StringJoiner(parts) {
            if (parts === void 0) {
                parts = [];
            }
            this.parts = parts;
        }
        StringJoiner.prototype.add = function (part) {
            this.parts.push(part);
        };
        StringJoiner.prototype.toString = function () {
            return this.parts.join("");
        };
        return StringJoiner;
    }();
    exports.StringJoiner = StringJoiner;
    var NumberParseError = function (_super) {
        __extends(NumberParseError, _super);
        function NumberParseError(message) {
            _super.call(this);
            this.message = message;
        }
        NumberParseError.prototype.toString = function () {
            return this.message;
        };
        return NumberParseError;
    }(Error);
    exports.NumberParseError = NumberParseError;
    var NumberWrapper = function () {
        function NumberWrapper() {}
        NumberWrapper.toFixed = function (n, fractionDigits) {
            return n.toFixed(fractionDigits);
        };
        NumberWrapper.equal = function (a, b) {
            return a === b;
        };
        NumberWrapper.parseIntAutoRadix = function (text) {
            var result = parseInt(text);
            if (isNaN(result)) {
                throw new NumberParseError("Invalid integer literal when parsing " + text);
            }
            return result;
        };
        NumberWrapper.parseInt = function (text, radix) {
            if (radix == 10) {
                if (/^(\-|\+)?[0-9]+$/.test(text)) {
                    return parseInt(text, radix);
                }
            } else if (radix == 16) {
                if (/^(\-|\+)?[0-9ABCDEFabcdef]+$/.test(text)) {
                    return parseInt(text, radix);
                }
            } else {
                var result = parseInt(text, radix);
                if (!isNaN(result)) {
                    return result;
                }
            }
            throw new NumberParseError("Invalid integer literal when parsing " + text + " in base " + radix);
        };
        // TODO: NaN is a valid literal but is returned by parseFloat to indicate an error.
        NumberWrapper.parseFloat = function (text) {
            return parseFloat(text);
        };
        Object.defineProperty(NumberWrapper, "NaN", {
            get: function () {
                return NaN;
            },
            enumerable: true,
            configurable: true
        });
        NumberWrapper.isNaN = function (value) {
            return isNaN(value);
        };
        NumberWrapper.isInteger = function (value) {
            return Number.isInteger(value);
        };
        return NumberWrapper;
    }();
    exports.NumberWrapper = NumberWrapper;
    exports.RegExp = _global.RegExp;
    var RegExpWrapper = function () {
        function RegExpWrapper() {}
        RegExpWrapper.create = function (regExpStr, flags) {
            if (flags === void 0) {
                flags = '';
            }
            flags = flags.replace(/g/g, '');
            return new _global.RegExp(regExpStr, flags + 'g');
        };
        RegExpWrapper.firstMatch = function (regExp, input) {
            // Reset multimatch regex state
            regExp.lastIndex = 0;
            return regExp.exec(input);
        };
        RegExpWrapper.test = function (regExp, input) {
            regExp.lastIndex = 0;
            return regExp.test(input);
        };
        RegExpWrapper.matcher = function (regExp, input) {
            // Reset regex state for the case
            // someone did not loop over all matches
            // last time.
            regExp.lastIndex = 0;
            return { re: regExp, input: input };
        };
        RegExpWrapper.replaceAll = function (regExp, input, replace) {
            var c = regExp.exec(input);
            var res = '';
            regExp.lastIndex = 0;
            var prev = 0;
            while (c) {
                res += input.substring(prev, c.index);
                res += replace(c);
                prev = c.index + c[0].length;
                regExp.lastIndex = prev;
                c = regExp.exec(input);
            }
            res += input.substring(prev);
            return res;
        };
        return RegExpWrapper;
    }();
    exports.RegExpWrapper = RegExpWrapper;
    var RegExpMatcherWrapper = function () {
        function RegExpMatcherWrapper() {}
        RegExpMatcherWrapper.next = function (matcher) {
            return matcher.re.exec(matcher.input);
        };
        return RegExpMatcherWrapper;
    }();
    exports.RegExpMatcherWrapper = RegExpMatcherWrapper;
    var FunctionWrapper = function () {
        function FunctionWrapper() {}
        FunctionWrapper.apply = function (fn, posArgs) {
            return fn.apply(null, posArgs);
        };
        return FunctionWrapper;
    }();
    exports.FunctionWrapper = FunctionWrapper;
    // JS has NaN !== NaN
    function looseIdentical(a, b) {
        return a === b || typeof a === "number" && typeof b === "number" && isNaN(a) && isNaN(b);
    }
    exports.looseIdentical = looseIdentical;
    // JS considers NaN is the same as NaN for map Key (while NaN !== NaN otherwise)
    // see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map
    function getMapKey(value) {
        return value;
    }
    exports.getMapKey = getMapKey;
    function normalizeBlank(obj) {
        return isBlank(obj) ? null : obj;
    }
    exports.normalizeBlank = normalizeBlank;
    function normalizeBool(obj) {
        return isBlank(obj) ? false : obj;
    }
    exports.normalizeBool = normalizeBool;
    function isJsObject(o) {
        return o !== null && (typeof o === "function" || typeof o === "object");
    }
    exports.isJsObject = isJsObject;
    function print(obj) {
        console.log(obj);
    }
    exports.print = print;
    // Can't be all uppercase as our transpiler would think it is a special directive...
    var Json = function () {
        function Json() {}
        Json.parse = function (s) {
            return _global.JSON.parse(s);
        };
        Json.stringify = function (data) {
            // Dart doesn't take 3 arguments
            return _global.JSON.stringify(data, null, 2);
        };
        return Json;
    }();
    exports.Json = Json;
    var DateWrapper = function () {
        function DateWrapper() {}
        DateWrapper.create = function (year, month, day, hour, minutes, seconds, milliseconds) {
            if (month === void 0) {
                month = 1;
            }
            if (day === void 0) {
                day = 1;
            }
            if (hour === void 0) {
                hour = 0;
            }
            if (minutes === void 0) {
                minutes = 0;
            }
            if (seconds === void 0) {
                seconds = 0;
            }
            if (milliseconds === void 0) {
                milliseconds = 0;
            }
            return new exports.Date(year, month - 1, day, hour, minutes, seconds, milliseconds);
        };
        DateWrapper.fromISOString = function (str) {
            return new exports.Date(str);
        };
        DateWrapper.fromMillis = function (ms) {
            return new exports.Date(ms);
        };
        DateWrapper.toMillis = function (date) {
            return date.getTime();
        };
        DateWrapper.now = function () {
            return new exports.Date();
        };
        DateWrapper.toJson = function (date) {
            return date.toJSON();
        };
        return DateWrapper;
    }();
    exports.DateWrapper = DateWrapper;
    function setValueOnPath(global, path, value) {
        var parts = path.split('.');
        var obj = global;
        while (parts.length > 1) {
            var name = parts.shift();
            if (obj.hasOwnProperty(name) && isPresent(obj[name])) {
                obj = obj[name];
            } else {
                obj = obj[name] = {};
            }
        }
        if (obj === undefined || obj === null) {
            obj = {};
        }
        obj[parts.shift()] = value;
    }
    exports.setValueOnPath = setValueOnPath;
    var _symbolIterator = null;
    function getSymbolIterator() {
        if (isBlank(_symbolIterator)) {
            if (isPresent(Symbol) && isPresent(Symbol.iterator)) {
                _symbolIterator = Symbol.iterator;
            } else {
                // es6-shim specific logic
                var keys = Object.getOwnPropertyNames(Map.prototype);
                for (var i = 0; i < keys.length; ++i) {
                    var key = keys[i];
                    if (key !== 'entries' && key !== 'size' && Map.prototype[key] === Map.prototype['entries']) {
                        _symbolIterator = key;
                    }
                }
            }
        }
        return _symbolIterator;
    }
    exports.getSymbolIterator = getSymbolIterator;
    function evalExpression(sourceUrl, expr, declarations, vars) {
        var fnBody = declarations + "\nreturn " + expr + "\n//# sourceURL=" + sourceUrl;
        var fnArgNames = [];
        var fnArgValues = [];
        for (var argName in vars) {
            fnArgNames.push(argName);
            fnArgValues.push(vars[argName]);
        }
        return new (Function.bind.apply(Function, [void 0].concat(fnArgNames.concat(fnBody))))().apply(void 0, fnArgValues);
    }
    exports.evalExpression = evalExpression;
    function isPrimitive(obj) {
        return !isJsObject(obj);
    }
    exports.isPrimitive = isPrimitive;
    function hasConstructor(value, type) {
        return value.constructor === type;
    }
    exports.hasConstructor = hasConstructor;
    function bitWiseOr(values) {
        return values.reduce(function (a, b) {
            return a | b;
        });
    }
    exports.bitWiseOr = bitWiseOr;
    function bitWiseAnd(values) {
        return values.reduce(function (a, b) {
            return a & b;
        });
    }
    exports.bitWiseAnd = bitWiseAnd;
    function escape(s) {
        return _global.encodeURI(s);
    }
    exports.escape = escape;
});
System.registerDynamic('angular2/src/facade/collection.js', ['angular2/src/facade/lang.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    exports.Map = lang_1.global.Map;
    exports.Set = lang_1.global.Set;
    // Safari and Internet Explorer do not support the iterable parameter to the
    // Map constructor.  We work around that by manually adding the items.
    var createMapFromPairs = function () {
        try {
            if (new exports.Map([[1, 2]]).size === 1) {
                return function createMapFromPairs(pairs) {
                    return new exports.Map(pairs);
                };
            }
        } catch (e) {}
        return function createMapAndPopulateFromPairs(pairs) {
            var map = new exports.Map();
            for (var i = 0; i < pairs.length; i++) {
                var pair = pairs[i];
                map.set(pair[0], pair[1]);
            }
            return map;
        };
    }();
    var createMapFromMap = function () {
        try {
            if (new exports.Map(new exports.Map())) {
                return function createMapFromMap(m) {
                    return new exports.Map(m);
                };
            }
        } catch (e) {}
        return function createMapAndPopulateFromMap(m) {
            var map = new exports.Map();
            m.forEach(function (v, k) {
                map.set(k, v);
            });
            return map;
        };
    }();
    var _clearValues = function () {
        if (new exports.Map().keys().next) {
            return function _clearValues(m) {
                var keyIterator = m.keys();
                var k;
                while (!(k = keyIterator.next()).done) {
                    m.set(k.value, null);
                }
            };
        } else {
            return function _clearValuesWithForeEach(m) {
                m.forEach(function (v, k) {
                    m.set(k, null);
                });
            };
        }
    }();
    // Safari doesn't implement MapIterator.next(), which is used is Traceur's polyfill of Array.from
    // TODO(mlaval): remove the work around once we have a working polyfill of Array.from
    var _arrayFromMap = function () {
        try {
            if (new exports.Map().values().next) {
                return function createArrayFromMap(m, getValues) {
                    return getValues ? Array.from(m.values()) : Array.from(m.keys());
                };
            }
        } catch (e) {}
        return function createArrayFromMapWithForeach(m, getValues) {
            var res = ListWrapper.createFixedSize(m.size),
                i = 0;
            m.forEach(function (v, k) {
                res[i] = getValues ? v : k;
                i++;
            });
            return res;
        };
    }();
    var MapWrapper = function () {
        function MapWrapper() {}
        MapWrapper.clone = function (m) {
            return createMapFromMap(m);
        };
        MapWrapper.createFromStringMap = function (stringMap) {
            var result = new exports.Map();
            for (var prop in stringMap) {
                result.set(prop, stringMap[prop]);
            }
            return result;
        };
        MapWrapper.toStringMap = function (m) {
            var r = {};
            m.forEach(function (v, k) {
                return r[k] = v;
            });
            return r;
        };
        MapWrapper.createFromPairs = function (pairs) {
            return createMapFromPairs(pairs);
        };
        MapWrapper.clearValues = function (m) {
            _clearValues(m);
        };
        MapWrapper.iterable = function (m) {
            return m;
        };
        MapWrapper.keys = function (m) {
            return _arrayFromMap(m, false);
        };
        MapWrapper.values = function (m) {
            return _arrayFromMap(m, true);
        };
        return MapWrapper;
    }();
    exports.MapWrapper = MapWrapper;
    /**
     * Wraps Javascript Objects
     */
    var StringMapWrapper = function () {
        function StringMapWrapper() {}
        StringMapWrapper.create = function () {
            // Note: We are not using Object.create(null) here due to
            // performance!
            // http://jsperf.com/ng2-object-create-null
            return {};
        };
        StringMapWrapper.contains = function (map, key) {
            return map.hasOwnProperty(key);
        };
        StringMapWrapper.get = function (map, key) {
            return map.hasOwnProperty(key) ? map[key] : undefined;
        };
        StringMapWrapper.set = function (map, key, value) {
            map[key] = value;
        };
        StringMapWrapper.keys = function (map) {
            return Object.keys(map);
        };
        StringMapWrapper.values = function (map) {
            return Object.keys(map).reduce(function (r, a) {
                r.push(map[a]);
                return r;
            }, []);
        };
        StringMapWrapper.isEmpty = function (map) {
            for (var prop in map) {
                return false;
            }
            return true;
        };
        StringMapWrapper.delete = function (map, key) {
            delete map[key];
        };
        StringMapWrapper.forEach = function (map, callback) {
            for (var prop in map) {
                if (map.hasOwnProperty(prop)) {
                    callback(map[prop], prop);
                }
            }
        };
        StringMapWrapper.merge = function (m1, m2) {
            var m = {};
            for (var attr in m1) {
                if (m1.hasOwnProperty(attr)) {
                    m[attr] = m1[attr];
                }
            }
            for (var attr in m2) {
                if (m2.hasOwnProperty(attr)) {
                    m[attr] = m2[attr];
                }
            }
            return m;
        };
        StringMapWrapper.equals = function (m1, m2) {
            var k1 = Object.keys(m1);
            var k2 = Object.keys(m2);
            if (k1.length != k2.length) {
                return false;
            }
            var key;
            for (var i = 0; i < k1.length; i++) {
                key = k1[i];
                if (m1[key] !== m2[key]) {
                    return false;
                }
            }
            return true;
        };
        return StringMapWrapper;
    }();
    exports.StringMapWrapper = StringMapWrapper;
    var ListWrapper = function () {
        function ListWrapper() {}
        // JS has no way to express a statically fixed size list, but dart does so we
        // keep both methods.
        ListWrapper.createFixedSize = function (size) {
            return new Array(size);
        };
        ListWrapper.createGrowableSize = function (size) {
            return new Array(size);
        };
        ListWrapper.clone = function (array) {
            return array.slice(0);
        };
        ListWrapper.forEachWithIndex = function (array, fn) {
            for (var i = 0; i < array.length; i++) {
                fn(array[i], i);
            }
        };
        ListWrapper.first = function (array) {
            if (!array) return null;
            return array[0];
        };
        ListWrapper.last = function (array) {
            if (!array || array.length == 0) return null;
            return array[array.length - 1];
        };
        ListWrapper.indexOf = function (array, value, startIndex) {
            if (startIndex === void 0) {
                startIndex = 0;
            }
            return array.indexOf(value, startIndex);
        };
        ListWrapper.contains = function (list, el) {
            return list.indexOf(el) !== -1;
        };
        ListWrapper.reversed = function (array) {
            var a = ListWrapper.clone(array);
            return a.reverse();
        };
        ListWrapper.concat = function (a, b) {
            return a.concat(b);
        };
        ListWrapper.insert = function (list, index, value) {
            list.splice(index, 0, value);
        };
        ListWrapper.removeAt = function (list, index) {
            var res = list[index];
            list.splice(index, 1);
            return res;
        };
        ListWrapper.removeAll = function (list, items) {
            for (var i = 0; i < items.length; ++i) {
                var index = list.indexOf(items[i]);
                list.splice(index, 1);
            }
        };
        ListWrapper.remove = function (list, el) {
            var index = list.indexOf(el);
            if (index > -1) {
                list.splice(index, 1);
                return true;
            }
            return false;
        };
        ListWrapper.clear = function (list) {
            list.length = 0;
        };
        ListWrapper.isEmpty = function (list) {
            return list.length == 0;
        };
        ListWrapper.fill = function (list, value, start, end) {
            if (start === void 0) {
                start = 0;
            }
            if (end === void 0) {
                end = null;
            }
            list.fill(value, start, end === null ? list.length : end);
        };
        ListWrapper.equals = function (a, b) {
            if (a.length != b.length) return false;
            for (var i = 0; i < a.length; ++i) {
                if (a[i] !== b[i]) return false;
            }
            return true;
        };
        ListWrapper.slice = function (l, from, to) {
            if (from === void 0) {
                from = 0;
            }
            if (to === void 0) {
                to = null;
            }
            return l.slice(from, to === null ? undefined : to);
        };
        ListWrapper.splice = function (l, from, length) {
            return l.splice(from, length);
        };
        ListWrapper.sort = function (l, compareFn) {
            if (lang_1.isPresent(compareFn)) {
                l.sort(compareFn);
            } else {
                l.sort();
            }
        };
        ListWrapper.toString = function (l) {
            return l.toString();
        };
        ListWrapper.toJSON = function (l) {
            return JSON.stringify(l);
        };
        ListWrapper.maximum = function (list, predicate) {
            if (list.length == 0) {
                return null;
            }
            var solution = null;
            var maxValue = -Infinity;
            for (var index = 0; index < list.length; index++) {
                var candidate = list[index];
                if (lang_1.isBlank(candidate)) {
                    continue;
                }
                var candidateValue = predicate(candidate);
                if (candidateValue > maxValue) {
                    solution = candidate;
                    maxValue = candidateValue;
                }
            }
            return solution;
        };
        ListWrapper.flatten = function (array) {
            var res = [];
            array.forEach(function (a) {
                return res = res.concat(a);
            });
            return res;
        };
        return ListWrapper;
    }();
    exports.ListWrapper = ListWrapper;
    function isListLikeIterable(obj) {
        if (!lang_1.isJsObject(obj)) return false;
        return lang_1.isArray(obj) || !(obj instanceof exports.Map) && lang_1.getSymbolIterator() in obj; // JS Iterable have a Symbol.iterator prop
    }
    exports.isListLikeIterable = isListLikeIterable;
    function areIterablesEqual(a, b, comparator) {
        var iterator1 = a[lang_1.getSymbolIterator()]();
        var iterator2 = b[lang_1.getSymbolIterator()]();
        while (true) {
            var item1 = iterator1.next();
            var item2 = iterator2.next();
            if (item1.done && item2.done) return true;
            if (item1.done || item2.done) return false;
            if (!comparator(item1.value, item2.value)) return false;
        }
    }
    exports.areIterablesEqual = areIterablesEqual;
    function iterateListLike(obj, fn) {
        if (lang_1.isArray(obj)) {
            for (var i = 0; i < obj.length; i++) {
                fn(obj[i]);
            }
        } else {
            var iterator = obj[lang_1.getSymbolIterator()]();
            var item;
            while (!(item = iterator.next()).done) {
                fn(item.value);
            }
        }
    }
    exports.iterateListLike = iterateListLike;
    // Safari and Internet Explorer do not support the iterable parameter to the
    // Set constructor.  We work around that by manually adding the items.
    var createSetFromList = function () {
        var test = new exports.Set([1, 2, 3]);
        if (test.size === 3) {
            return function createSetFromList(lst) {
                return new exports.Set(lst);
            };
        } else {
            return function createSetAndPopulateFromList(lst) {
                var res = new exports.Set(lst);
                if (res.size !== lst.length) {
                    for (var i = 0; i < lst.length; i++) {
                        res.add(lst[i]);
                    }
                }
                return res;
            };
        }
    }();
    var SetWrapper = function () {
        function SetWrapper() {}
        SetWrapper.createFromList = function (lst) {
            return createSetFromList(lst);
        };
        SetWrapper.has = function (s, key) {
            return s.has(key);
        };
        SetWrapper.delete = function (m, k) {
            m.delete(k);
        };
        return SetWrapper;
    }();
    exports.SetWrapper = SetWrapper;
});
System.registerDynamic('angular2/src/facade/exception_handler.js', ['angular2/src/facade/lang.js', 'angular2/src/facade/base_wrapped_exception.js', 'angular2/src/facade/collection.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var base_wrapped_exception_1 = $__require('angular2/src/facade/base_wrapped_exception.js');
    var collection_1 = $__require('angular2/src/facade/collection.js');
    var _ArrayLogger = function () {
        function _ArrayLogger() {
            this.res = [];
        }
        _ArrayLogger.prototype.log = function (s) {
            this.res.push(s);
        };
        _ArrayLogger.prototype.logError = function (s) {
            this.res.push(s);
        };
        _ArrayLogger.prototype.logGroup = function (s) {
            this.res.push(s);
        };
        _ArrayLogger.prototype.logGroupEnd = function () {};
        ;
        return _ArrayLogger;
    }();
    /**
     * Provides a hook for centralized exception handling.
     *
     * The default implementation of `ExceptionHandler` prints error messages to the `Console`. To
     * intercept error handling,
     * write a custom exception handler that replaces this default as appropriate for your app.
     *
     * ### Example
     *
     * ```javascript
     *
     * class MyExceptionHandler implements ExceptionHandler {
     *   call(error, stackTrace = null, reason = null) {
     *     // do something with the exception
     *   }
     * }
     *
     * bootstrap(MyApp, [provide(ExceptionHandler, {useClass: MyExceptionHandler})])
     *
     * ```
     */
    var ExceptionHandler = function () {
        function ExceptionHandler(_logger, _rethrowException) {
            if (_rethrowException === void 0) {
                _rethrowException = true;
            }
            this._logger = _logger;
            this._rethrowException = _rethrowException;
        }
        ExceptionHandler.exceptionToString = function (exception, stackTrace, reason) {
            if (stackTrace === void 0) {
                stackTrace = null;
            }
            if (reason === void 0) {
                reason = null;
            }
            var l = new _ArrayLogger();
            var e = new ExceptionHandler(l, false);
            e.call(exception, stackTrace, reason);
            return l.res.join("\n");
        };
        ExceptionHandler.prototype.call = function (exception, stackTrace, reason) {
            if (stackTrace === void 0) {
                stackTrace = null;
            }
            if (reason === void 0) {
                reason = null;
            }
            var originalException = this._findOriginalException(exception);
            var originalStack = this._findOriginalStack(exception);
            var context = this._findContext(exception);
            this._logger.logGroup("EXCEPTION: " + this._extractMessage(exception));
            if (lang_1.isPresent(stackTrace) && lang_1.isBlank(originalStack)) {
                this._logger.logError("STACKTRACE:");
                this._logger.logError(this._longStackTrace(stackTrace));
            }
            if (lang_1.isPresent(reason)) {
                this._logger.logError("REASON: " + reason);
            }
            if (lang_1.isPresent(originalException)) {
                this._logger.logError("ORIGINAL EXCEPTION: " + this._extractMessage(originalException));
            }
            if (lang_1.isPresent(originalStack)) {
                this._logger.logError("ORIGINAL STACKTRACE:");
                this._logger.logError(this._longStackTrace(originalStack));
            }
            if (lang_1.isPresent(context)) {
                this._logger.logError("ERROR CONTEXT:");
                this._logger.logError(context);
            }
            this._logger.logGroupEnd();
            // We rethrow exceptions, so operations like 'bootstrap' will result in an error
            // when an exception happens. If we do not rethrow, bootstrap will always succeed.
            if (this._rethrowException) throw exception;
        };
        /** @internal */
        ExceptionHandler.prototype._extractMessage = function (exception) {
            return exception instanceof base_wrapped_exception_1.BaseWrappedException ? exception.wrapperMessage : exception.toString();
        };
        /** @internal */
        ExceptionHandler.prototype._longStackTrace = function (stackTrace) {
            return collection_1.isListLikeIterable(stackTrace) ? stackTrace.join("\n\n-----async gap-----\n") : stackTrace.toString();
        };
        /** @internal */
        ExceptionHandler.prototype._findContext = function (exception) {
            try {
                if (!(exception instanceof base_wrapped_exception_1.BaseWrappedException)) return null;
                return lang_1.isPresent(exception.context) ? exception.context : this._findContext(exception.originalException);
            } catch (e) {
                // exception.context can throw an exception. if it happens, we ignore the context.
                return null;
            }
        };
        /** @internal */
        ExceptionHandler.prototype._findOriginalException = function (exception) {
            if (!(exception instanceof base_wrapped_exception_1.BaseWrappedException)) return null;
            var e = exception.originalException;
            while (e instanceof base_wrapped_exception_1.BaseWrappedException && lang_1.isPresent(e.originalException)) {
                e = e.originalException;
            }
            return e;
        };
        /** @internal */
        ExceptionHandler.prototype._findOriginalStack = function (exception) {
            if (!(exception instanceof base_wrapped_exception_1.BaseWrappedException)) return null;
            var e = exception;
            var stack = exception.originalStack;
            while (e instanceof base_wrapped_exception_1.BaseWrappedException && lang_1.isPresent(e.originalException)) {
                e = e.originalException;
                if (e instanceof base_wrapped_exception_1.BaseWrappedException && lang_1.isPresent(e.originalException)) {
                    stack = e.originalStack;
                }
            }
            return stack;
        };
        return ExceptionHandler;
    }();
    exports.ExceptionHandler = ExceptionHandler;
});
System.registerDynamic('angular2/src/facade/exceptions.js', ['angular2/src/facade/base_wrapped_exception.js', 'angular2/src/facade/exception_handler.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var __extends = this && this.__extends || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var base_wrapped_exception_1 = $__require('angular2/src/facade/base_wrapped_exception.js');
    var exception_handler_1 = $__require('angular2/src/facade/exception_handler.js');
    var exception_handler_2 = $__require('angular2/src/facade/exception_handler.js');
    exports.ExceptionHandler = exception_handler_2.ExceptionHandler;
    var BaseException = function (_super) {
        __extends(BaseException, _super);
        function BaseException(message) {
            if (message === void 0) {
                message = "--";
            }
            _super.call(this, message);
            this.message = message;
            this.stack = new Error(message).stack;
        }
        BaseException.prototype.toString = function () {
            return this.message;
        };
        return BaseException;
    }(Error);
    exports.BaseException = BaseException;
    /**
     * Wraps an exception and provides additional context or information.
     */
    var WrappedException = function (_super) {
        __extends(WrappedException, _super);
        function WrappedException(_wrapperMessage, _originalException, _originalStack, _context) {
            _super.call(this, _wrapperMessage);
            this._wrapperMessage = _wrapperMessage;
            this._originalException = _originalException;
            this._originalStack = _originalStack;
            this._context = _context;
            this._wrapperStack = new Error(_wrapperMessage).stack;
        }
        Object.defineProperty(WrappedException.prototype, "wrapperMessage", {
            get: function () {
                return this._wrapperMessage;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(WrappedException.prototype, "wrapperStack", {
            get: function () {
                return this._wrapperStack;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(WrappedException.prototype, "originalException", {
            get: function () {
                return this._originalException;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(WrappedException.prototype, "originalStack", {
            get: function () {
                return this._originalStack;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(WrappedException.prototype, "context", {
            get: function () {
                return this._context;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(WrappedException.prototype, "message", {
            get: function () {
                return exception_handler_1.ExceptionHandler.exceptionToString(this);
            },
            enumerable: true,
            configurable: true
        });
        WrappedException.prototype.toString = function () {
            return this.message;
        };
        return WrappedException;
    }(base_wrapped_exception_1.BaseWrappedException);
    exports.WrappedException = WrappedException;
    function makeTypeError(message) {
        return new TypeError(message);
    }
    exports.makeTypeError = makeTypeError;
    function unimplemented() {
        throw new BaseException('unimplemented');
    }
    exports.unimplemented = unimplemented;
});
System.registerDynamic('angular2/src/core/reflection/reflection_capabilities.js', ['angular2/src/facade/lang.js', 'angular2/src/facade/exceptions.js'], true, function ($__require, exports, module) {
    'use strict';"use strict";

    var global = this || self,
        GLOBAL = global;
    var lang_1 = $__require('angular2/src/facade/lang.js');
    var exceptions_1 = $__require('angular2/src/facade/exceptions.js');
    var ReflectionCapabilities = function () {
        function ReflectionCapabilities(reflect) {
            this._reflect = lang_1.isPresent(reflect) ? reflect : lang_1.global.Reflect;
        }
        ReflectionCapabilities.prototype.isReflectionEnabled = function () {
            return true;
        };
        ReflectionCapabilities.prototype.factory = function (t) {
            switch (t.length) {
                case 0:
                    return function () {
                        return new t();
                    };
                case 1:
                    return function (a1) {
                        return new t(a1);
                    };
                case 2:
                    return function (a1, a2) {
                        return new t(a1, a2);
                    };
                case 3:
                    return function (a1, a2, a3) {
                        return new t(a1, a2, a3);
                    };
                case 4:
                    return function (a1, a2, a3, a4) {
                        return new t(a1, a2, a3, a4);
                    };
                case 5:
                    return function (a1, a2, a3, a4, a5) {
                        return new t(a1, a2, a3, a4, a5);
                    };
                case 6:
                    return function (a1, a2, a3, a4, a5, a6) {
                        return new t(a1, a2, a3, a4, a5, a6);
                    };
                case 7:
                    return function (a1, a2, a3, a4, a5, a6, a7) {
                        return new t(a1, a2, a3, a4, a5, a6, a7);
                    };
                case 8:
                    return function (a1, a2, a3, a4, a5, a6, a7, a8) {
                        return new t(a1, a2, a3, a4, a5, a6, a7, a8);
                    };
                case 9:
                    return function (a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                        return new t(a1, a2, a3, a4, a5, a6, a7, a8, a9);
                    };
                case 10:
                    return function (a1, a2, a3, a4, a5, a6, a7, a8, a9, a10) {
                        return new t(a1, a2, a3, a4, a5, a6, a7, a8, a9, a10);
                    };
                case 11:
                    return function (a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11) {
                        return new t(a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11);
                    };
                case 12:
                    return function (a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12) {
                        return new t(a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12);
                    };
                case 13:
                    return function (a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13) {
                        return new t(a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13);
                    };
                case 14:
                    return function (a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14) {
                        return new t(a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14);
                    };
                case 15:
                    return function (a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15) {
                        return new t(a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15);
                    };
                case 16:
                    return function (a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15, a16) {
                        return new t(a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15, a16);
                    };
                case 17:
                    return function (a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15, a16, a17) {
                        return new t(a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15, a16, a17);
                    };
                case 18:
                    return function (a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15, a16, a17, a18) {
                        return new t(a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15, a16, a17, a18);
                    };
                case 19:
                    return function (a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15, a16, a17, a18, a19) {
                        return new t(a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15, a16, a17, a18, a19);
                    };
                case 20:
                    return function (a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15, a16, a17, a18, a19, a20) {
                        return new t(a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15, a16, a17, a18, a19, a20);
                    };
            }
            ;
            throw new Error("Cannot create a factory for '" + lang_1.stringify(t) + "' because its constructor has more than 20 arguments");
        };
        /** @internal */
        ReflectionCapabilities.prototype._zipTypesAndAnnotations = function (paramTypes, paramAnnotations) {
            var result;
            if (typeof paramTypes === 'undefined') {
                result = new Array(paramAnnotations.length);
            } else {
                result = new Array(paramTypes.length);
            }
            for (var i = 0; i < result.length; i++) {
                // TS outputs Object for parameters without types, while Traceur omits
                // the annotations. For now we preserve the Traceur behavior to aid
                // migration, but this can be revisited.
                if (typeof paramTypes === 'undefined') {
                    result[i] = [];
                } else if (paramTypes[i] != Object) {
                    result[i] = [paramTypes[i]];
                } else {
                    result[i] = [];
                }
                if (lang_1.isPresent(paramAnnotations) && lang_1.isPresent(paramAnnotations[i])) {
                    result[i] = result[i].concat(paramAnnotations[i]);
                }
            }
            return result;
        };
        ReflectionCapabilities.prototype.parameters = function (typeOrFunc) {
            // Prefer the direct API.
            if (lang_1.isPresent(typeOrFunc.parameters)) {
                return typeOrFunc.parameters;
            }
            if (lang_1.isPresent(this._reflect) && lang_1.isPresent(this._reflect.getMetadata)) {
                var paramAnnotations = this._reflect.getMetadata('parameters', typeOrFunc);
                var paramTypes = this._reflect.getMetadata('design:paramtypes', typeOrFunc);
                if (lang_1.isPresent(paramTypes) || lang_1.isPresent(paramAnnotations)) {
                    return this._zipTypesAndAnnotations(paramTypes, paramAnnotations);
                }
            }
            // The array has to be filled with `undefined` because holes would be skipped by `some`
            var parameters = new Array(typeOrFunc.length);
            parameters.fill(undefined);
            return parameters;
        };
        ReflectionCapabilities.prototype.annotations = function (typeOrFunc) {
            // Prefer the direct API.
            if (lang_1.isPresent(typeOrFunc.annotations)) {
                var annotations = typeOrFunc.annotations;
                if (lang_1.isFunction(annotations) && annotations.annotations) {
                    annotations = annotations.annotations;
                }
                return annotations;
            }
            if (lang_1.isPresent(this._reflect) && lang_1.isPresent(this._reflect.getMetadata)) {
                var annotations = this._reflect.getMetadata('annotations', typeOrFunc);
                if (lang_1.isPresent(annotations)) return annotations;
            }
            return [];
        };
        ReflectionCapabilities.prototype.propMetadata = function (typeOrFunc) {
            // Prefer the direct API.
            if (lang_1.isPresent(typeOrFunc.propMetadata)) {
                var propMetadata = typeOrFunc.propMetadata;
                if (lang_1.isFunction(propMetadata) && propMetadata.propMetadata) {
                    propMetadata = propMetadata.propMetadata;
                }
                return propMetadata;
            }
            if (lang_1.isPresent(this._reflect) && lang_1.isPresent(this._reflect.getMetadata)) {
                var propMetadata = this._reflect.getMetadata('propMetadata', typeOrFunc);
                if (lang_1.isPresent(propMetadata)) return propMetadata;
            }
            return {};
        };
        ReflectionCapabilities.prototype.interfaces = function (type) {
            throw new exceptions_1.BaseException("JavaScript does not support interfaces");
        };
        ReflectionCapabilities.prototype.getter = function (name) {
            return new Function('o', 'return o.' + name + ';');
        };
        ReflectionCapabilities.prototype.setter = function (name) {
            return new Function('o', 'v', 'return o.' + name + ' = v;');
        };
        ReflectionCapabilities.prototype.method = function (name) {
            var functionBody = "if (!o." + name + ") throw new Error('\"" + name + "\" is undefined');\n        return o." + name + ".apply(o, args);";
            return new Function('o', 'args', functionBody);
        };
        // There is not a concept of import uri in Js, but this is useful in developing Dart applications.
        ReflectionCapabilities.prototype.importUri = function (type) {
            return './';
        };
        return ReflectionCapabilities;
    }();
    exports.ReflectionCapabilities = ReflectionCapabilities;
});
System.registerDynamic('angular2/src/core/reflection/reflection.js', ['angular2/src/core/reflection/reflector.js', 'angular2/src/core/reflection/reflection_capabilities.js'], true, function ($__require, exports, module) {
  'use strict';"use strict";

  var global = this || self,
      GLOBAL = global;
  var reflector_1 = $__require('angular2/src/core/reflection/reflector.js');
  var reflector_2 = $__require('angular2/src/core/reflection/reflector.js');
  exports.Reflector = reflector_2.Reflector;
  exports.ReflectionInfo = reflector_2.ReflectionInfo;
  var reflection_capabilities_1 = $__require('angular2/src/core/reflection/reflection_capabilities.js');
  /**
   * The {@link Reflector} used internally in Angular to access metadata
   * about symbols.
   */
  exports.reflector = new reflector_1.Reflector(new reflection_capabilities_1.ReflectionCapabilities());
});
System.registerDynamic('angular2/core.js', ['angular2/src/core/metadata.js', 'angular2/src/core/util.js', 'angular2/src/core/prod_mode.js', 'angular2/src/core/di.js', 'angular2/src/facade/facade.js', 'angular2/src/facade/lang.js', 'angular2/src/core/application_ref.js', 'angular2/src/core/application_tokens.js', 'angular2/src/core/zone.js', 'angular2/src/core/render.js', 'angular2/src/core/linker.js', 'angular2/src/core/debug/debug_node.js', 'angular2/src/core/testability/testability.js', 'angular2/src/core/change_detection.js', 'angular2/src/core/platform_directives_and_pipes.js', 'angular2/src/core/platform_common_providers.js', 'angular2/src/core/application_common_providers.js', 'angular2/src/core/reflection/reflection.js'], true, function ($__require, exports, module) {
  'use strict';"use strict";

  var global = this || self,
      GLOBAL = global;
  function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
  /**
   * @module
   * @description
   * Starting point to import all public core APIs.
   */
  __export($__require('angular2/src/core/metadata.js'));
  __export($__require('angular2/src/core/util.js'));
  __export($__require('angular2/src/core/prod_mode.js'));
  __export($__require('angular2/src/core/di.js'));
  __export($__require('angular2/src/facade/facade.js'));
  var lang_1 = $__require('angular2/src/facade/lang.js');
  exports.enableProdMode = lang_1.enableProdMode;
  var application_ref_1 = $__require('angular2/src/core/application_ref.js');
  exports.platform = application_ref_1.platform;
  exports.createNgZone = application_ref_1.createNgZone;
  exports.PlatformRef = application_ref_1.PlatformRef;
  exports.ApplicationRef = application_ref_1.ApplicationRef;
  var application_tokens_1 = $__require('angular2/src/core/application_tokens.js');
  exports.APP_ID = application_tokens_1.APP_ID;
  exports.APP_COMPONENT = application_tokens_1.APP_COMPONENT;
  exports.APP_INITIALIZER = application_tokens_1.APP_INITIALIZER;
  exports.PACKAGE_ROOT_URL = application_tokens_1.PACKAGE_ROOT_URL;
  exports.PLATFORM_INITIALIZER = application_tokens_1.PLATFORM_INITIALIZER;
  __export($__require('angular2/src/core/zone.js'));
  __export($__require('angular2/src/core/render.js'));
  __export($__require('angular2/src/core/linker.js'));
  var debug_node_1 = $__require('angular2/src/core/debug/debug_node.js');
  exports.DebugElement = debug_node_1.DebugElement;
  exports.DebugNode = debug_node_1.DebugNode;
  exports.asNativeElements = debug_node_1.asNativeElements;
  __export($__require('angular2/src/core/testability/testability.js'));
  __export($__require('angular2/src/core/change_detection.js'));
  __export($__require('angular2/src/core/platform_directives_and_pipes.js'));
  __export($__require('angular2/src/core/platform_common_providers.js'));
  __export($__require('angular2/src/core/application_common_providers.js'));
  __export($__require('angular2/src/core/reflection/reflection.js'));
});
System.register("ags-client/app/commons/timer.js", [], function (exports_1, context_1) {
    "use strict";

    var Timer;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [],
        execute: function () {
            Timer = /** @class */function () {
                function Timer() {
                    this._cancelled = false;
                }
                Timer.later = function (delay, callback) {
                    var timer = new Timer();
                    timer._later(delay, callback);
                    return timer;
                };
                Timer.repeat = function (interval, callback) {
                    var timer = new Timer();
                    timer._repeat(interval, callback);
                    return timer;
                };
                Timer.prototype.cancel = function () {
                    if (this._timeout) {
                        window.clearTimeout(this._timeout);
                    }
                    this._cancelled = true;
                };
                Timer.prototype._later = function (delay, callback) {
                    var _this = this;
                    this._timeout = setTimeout(function () {
                        if (!_this._cancelled) {
                            callback();
                        }
                    }, delay);
                };
                Timer.prototype._repeat = function (interval, callback) {
                    var _this = this;
                    this._timeout = setTimeout(function () {
                        if (!_this._cancelled) {
                            callback();
                            _this._repeat(interval, callback);
                        }
                    }, interval);
                };
                return Timer;
            }();
            exports_1("Timer", Timer);
        }
    };
});

System.register("ags-client/app/viewsearch/search_criteria.js", ["angular2/core.js", "ags-client/app/commons/timer.js"], function (exports_1, context_1) {
    "use strict";

    var core_1, timer_1, SortDirection, SearchSort, SearchCriteria;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (timer_1_1) {
            timer_1 = timer_1_1;
        }],
        execute: function () {
            (function (SortDirection) {
                SortDirection[SortDirection["ASCENDING"] = 0] = "ASCENDING";
                SortDirection[SortDirection["DESCENDING"] = 1] = "DESCENDING";
            })(SortDirection || exports_1("SortDirection", SortDirection = {}));
            SearchSort = /** @class */function () {
                function SearchSort(attribute, direction) {
                    this.attribute = attribute;
                    this.direction = direction;
                }
                return SearchSort;
            }();
            exports_1("SearchSort", SearchSort);
            SearchCriteria = /** @class */function () {
                function SearchCriteria(from, size) {
                    this._searchEmitter = new core_1.EventEmitter();
                    this._resultEmitter = new core_1.EventEmitter();
                    this._from = from;
                    this._size = size;
                }
                SearchCriteria.prototype.sortBy = function (attribute) {
                    if (this._sort && this.sort.attribute === attribute) {
                        if (this._sort.direction === SortDirection.ASCENDING) {
                            this._sort.direction = SortDirection.DESCENDING;
                        } else {
                            this.resetSort();
                        }
                    } else {
                        this._sort = new SearchSort(attribute, SortDirection.ASCENDING);
                    }
                    this._notify();
                    return this;
                };
                SearchCriteria.prototype.removeSort = function (attribute) {
                    this._sort = null;
                    this._notify();
                };
                SearchCriteria.prototype.subscribeSearch = function (subscriber) {
                    this._searchEmitter.subscribe(subscriber);
                };
                SearchCriteria.prototype.subscribeResult = function (subscriber) {
                    this._resultEmitter.subscribe(subscriber);
                };
                SearchCriteria.prototype.attributeChanged = function (attribute, value) {
                    if (this._notificationTimer != null) {
                        this._notificationTimer.cancel();
                    }
                    this._from = 0;
                    if (value == null || value instanceof Date) {
                        this._notify();
                    } else {
                        this._notifyLater();
                    }
                };
                SearchCriteria.prototype._notifyLater = function () {
                    var _this = this;
                    this._notificationTimer = timer_1.Timer.later(500, function () {
                        _this._notify();
                    });
                };
                SearchCriteria.prototype._notify = function () {
                    this._searchEmitter.emit(null);
                };
                SearchCriteria.prototype.resetSort = function () {
                    this._resetSort();
                    this._notify();
                };
                SearchCriteria.prototype._resetSort = function () {
                    this._sort = null;
                };
                SearchCriteria.prototype.reset = function () {
                    this._from = 0;
                    ;
                    this._resetSort();
                    this._notify();
                    this.total = 0;
                };
                Object.defineProperty(SearchCriteria.prototype, "from", {
                    get: function () {
                        return this._from;
                    },
                    set: function (from) {
                        this._from = from;
                        this._notify();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchCriteria.prototype, "sortLanguage", {
                    get: function () {
                        return this._sortLanguage;
                    },
                    set: function (sortLanguage) {
                        this._sortLanguage = sortLanguage;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchCriteria.prototype, "size", {
                    get: function () {
                        return this._size;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchCriteria.prototype, "sort", {
                    get: function () {
                        return this._sort;
                    },
                    set: function (sort) {
                        this._sort = sort;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SearchCriteria.prototype, "total", {
                    get: function () {
                        return this._total;
                    },
                    set: function (total) {
                        this._total = total;
                        this._resultEmitter.emit(null);
                    },
                    enumerable: false,
                    configurable: true
                });
                SearchCriteria.prototype.serialize = function () {
                    var sort = new Array();
                    if (this._sort) {
                        sort.push(this._sort);
                    }
                    return {
                        from: this._from,
                        size: this._size,
                        sortLanguage: this._sortLanguage,
                        sort: sort
                    };
                };
                return SearchCriteria;
            }();
            exports_1("SearchCriteria", SearchCriteria);
        }
    };
});

System.register("ags-client/app/viewsearch.js", ["ags-client/app/viewsearch/search_criteria.js"], function (exports_1, context_1) {
    "use strict";

    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (search_criteria_1_1) {
            exports_1({
                "SearchCriteria": search_criteria_1_1["SearchCriteria"],
                "SortDirection": search_criteria_1_1["SortDirection"],
                "SearchSort": search_criteria_1_1["SearchSort"]
            });
        }],
        execute: function () {}
    };
});

System.register("ags-client/gen/viewsearch/role_search_criteria.js", ["ags-client/app/viewsearch.js", "ags-client/app/commons/lang.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var viewsearch_1, lang_1, RoleSearchCriteria;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (viewsearch_1_1) {
            viewsearch_1 = viewsearch_1_1;
        }, function (lang_1_1) {
            lang_1 = lang_1_1;
        }],
        execute: function () {
            RoleSearchCriteria = /** @class */function (_super) {
                __extends(RoleSearchCriteria, _super);
                function RoleSearchCriteria(from, size) {
                    return _super.call(this, from, size) || this;
                }
                RoleSearchCriteria.create = function (from, size) {
                    return new RoleSearchCriteria(from, size);
                };
                Object.defineProperty(RoleSearchCriteria.prototype, "roleName", {
                    get: function () {
                        return this._roleName;
                    },
                    set: function (roleName) {
                        if (this._roleName !== roleName) {
                            this._roleName = roleName;
                            this.attributeChanged(RoleSearchCriteria.ROLE_NAME, roleName);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(RoleSearchCriteria.prototype, "roleDescription", {
                    get: function () {
                        return this._roleDescription;
                    },
                    set: function (roleDescription) {
                        if (this._roleDescription !== roleDescription) {
                            this._roleDescription = roleDescription;
                            this.attributeChanged(RoleSearchCriteria.ROLE_DESCRIPTION, roleDescription);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(RoleSearchCriteria.prototype, "roleAssigned", {
                    get: function () {
                        return this._roleAssigned;
                    },
                    set: function (roleAssigned) {
                        if (this._roleAssigned !== roleAssigned) {
                            this._roleAssigned = roleAssigned;
                            this.attributeChanged(RoleSearchCriteria.ROLE_ASSIGNED, roleAssigned);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(RoleSearchCriteria.prototype, "rule", {
                    get: function () {
                        return this._rule;
                    },
                    set: function (rule) {
                        if (this._rule !== rule) {
                            this._rule = rule;
                            this.attributeChanged(RoleSearchCriteria.RULE, rule);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(RoleSearchCriteria.prototype, "deleted", {
                    get: function () {
                        return this._deleted;
                    },
                    set: function (deleted) {
                        if (this._deleted !== deleted) {
                            this._deleted = deleted;
                            this.attributeChanged(RoleSearchCriteria.DELETED, deleted);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                RoleSearchCriteria.prototype.reset = function () {
                    _super.prototype.reset.call(this);
                    this._roleName = null;
                    this._roleDescription = null;
                    this._roleAssigned = null;
                    this._rule = null;
                    this._deleted = null;
                };
                RoleSearchCriteria.prototype.serialize = function () {
                    var object = _super.prototype.serialize.call(this);
                    if (lang_1.isPresent(this.roleName)) {
                        object['roleName'] = this.roleName;
                    }
                    if (lang_1.isPresent(this.roleDescription)) {
                        object['roleDescription'] = this.roleDescription;
                    }
                    if (lang_1.isPresent(this.roleAssigned)) {
                        object['roleAssigned'] = this.roleAssigned;
                    }
                    if (lang_1.isPresent(this.rule)) {
                        object['rule'] = this.rule;
                    }
                    if (lang_1.isPresent(this.deleted)) {
                        object['deleted'] = this.deleted;
                    }
                    return object;
                };
                RoleSearchCriteria.ROLE_NAME = 'roleName';
                RoleSearchCriteria.ROLE_DESCRIPTION = 'roleDescription';
                RoleSearchCriteria.ROLE_ASSIGNED = 'roleAssigned';
                RoleSearchCriteria.RULE = 'rule';
                RoleSearchCriteria.DELETED = 'deleted';
                return RoleSearchCriteria;
            }(viewsearch_1.SearchCriteria);
            exports_1("RoleSearchCriteria", RoleSearchCriteria);
        }
    };
});

System.register("ags-client/gen/viewsearch.js", ["ags-client/gen/viewsearch/category_search_criteria.js", "ags-client/gen/viewsearch/code_search_criteria.js", "ags-client/gen/viewsearch/darate_search_criteria.js", "ags-client/gen/viewsearch/domain_search_criteria.js", "ags-client/gen/viewsearch/system_search_criteria.js", "ags-client/gen/viewsearch/role_search_criteria.js"], function (exports_1, context_1) {
    "use strict";

    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (category_search_criteria_1_1) {
            exports_1({
                "CategorySearchCriteria": category_search_criteria_1_1["CategorySearchCriteria"]
            });
        }, function (code_search_criteria_1_1) {
            exports_1({
                "CodeSearchCriteria": code_search_criteria_1_1["CodeSearchCriteria"]
            });
        }, function (darate_search_criteria_1_1) {
            exports_1({
                "DarateSearchCriteria": darate_search_criteria_1_1["DarateSearchCriteria"]
            });
        }, function (domain_search_criteria_1_1) {
            exports_1({
                "DomainSearchCriteria": domain_search_criteria_1_1["DomainSearchCriteria"]
            });
        }, function (system_search_criteria_1_1) {
            exports_1({
                "SystemSearchCriteria": system_search_criteria_1_1["SystemSearchCriteria"]
            });
        }, function (role_search_criteria_1_1) {
            exports_1({
                "RoleSearchCriteria": role_search_criteria_1_1["RoleSearchCriteria"]
            });
        }],
        execute: function () {}
    };
});

System.register("ags-client/app/commons/enum_registry.js", [], function (exports_1, context_1) {
    "use strict";

    var EnumRegistry;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [],
        execute: function () {
            EnumRegistry = /** @class */function () {
                function EnumRegistry() {}
                EnumRegistry.register = function (key, value) {
                    EnumRegistry.enums[key] = value;
                };
                EnumRegistry.enum = function (key) {
                    return EnumRegistry.enums[key];
                };
                EnumRegistry.enums = {};
                return EnumRegistry;
            }();
            exports_1("EnumRegistry", EnumRegistry);
        }
    };
});

System.register("ags-client/app/commons/code_registry.js", [], function (exports_1, context_1) {
    "use strict";

    var CodeRegistry;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [],
        execute: function () {
            CodeRegistry = /** @class */function () {
                function CodeRegistry() {}
                CodeRegistry.register = function (key, value) {
                    CodeRegistry.codes[key] = value;
                };
                CodeRegistry.code = function (key) {
                    return CodeRegistry.codes[key];
                };
                CodeRegistry.codes = {};
                return CodeRegistry;
            }();
            exports_1("CodeRegistry", CodeRegistry);
        }
    };
});

// <reference path="../../../../node_modules/angular2/typings/browser.d.ts"/>
/// <reference types="sugar" />
/// <reference types="jasmine" />
System.register("ags-client/app/commons/lang.js", [], function (exports_1, context_1) {
    "use strict";

    var __moduleName = context_1 && context_1.id;
    function isPresent(obj) {
        return obj !== undefined && obj !== null;
    }
    exports_1("isPresent", isPresent);
    function isBlank(obj) {
        return obj === undefined || obj === null;
    }
    exports_1("isBlank", isBlank);
    function isString(obj) {
        return typeof obj === 'string';
    }
    exports_1("isString", isString);
    // TODO: quick hack for ArrayStatic
    function isArray(obj) {
        return Array.isArray(obj);
    }
    exports_1("isArray", isArray);
    function isNumber(obj) {
        return typeof obj === 'number';
    }
    exports_1("isNumber", isNumber);
    function isDate(obj) {
        return obj instanceof Date;
    }
    exports_1("isDate", isDate);
    function isSomething(value) {
        return isPresent(value) && value !== '';
    }
    exports_1("isSomething", isSomething);
    function isObject(value) {
        if (value === null || isArray(value)) {
            return false;
        }
        return typeof value === 'function' || typeof value === 'object';
    }
    exports_1("isObject", isObject);
    function areEqual(a, b) {
        if (a === b) {
            return true;
        } else if (!isPresent(a) && !isPresent(b)) {
            return true;
        } else if (a == null || b == null) {
            return false;
        } else if (isObject(a) && isObject(b)) {
            for (var key in a) {
                if (!areEqual(a[key], b[key])) {
                    return false;
                }
            }
            return true;
        } else if (isArray(a) && isArray(b)) {
            if (a.length === b.length) {
                for (var i = 0; i < a.length; i++) {
                    if (!areEqual(a[i], b[i])) {
                        return false;
                    }
                }
                return true;
            }
        }
        return false;
    }
    exports_1("areEqual", areEqual);
    function clone(value) {
        if (isPresent(value)) {
            var _clone = null;
            if (isObject(value)) {
                _clone = new value.constructor();
                for (var key in value) {
                    _clone[key] = clone(value[key]);
                }
                return _clone;
            } else if (isArray(value)) {
                var array = value;
                _clone = [];
                array.forEach(function (item) {
                    _clone.push(clone(item));
                });
                return _clone;
            } else {
                return value;
            }
        }
        return null;
    }
    exports_1("clone", clone);
    function tick(delay) {
        if (delay === void 0) {
            delay = 50;
        }
        return function () {
            return new Promise(function (resolve, reject) {
                setTimeout(function () {
                    resolve(null);
                }, delay);
            });
        };
    }
    exports_1("tick", tick);
    function enumStringValues(e) {
        return Object.keys(e).filter(function (v) {
            return isNaN(parseInt(v, 10));
        });
    }
    exports_1("enumStringValues", enumStringValues);
    function enumStringValue(e, value) {
        return e[value];
    }
    exports_1("enumStringValue", enumStringValue);
    function enumNumberValues(e) {
        return Object.keys(e).filter(function (v) {
            return !isNaN(parseInt(v, 10));
        });
    }
    exports_1("enumNumberValues", enumNumberValues);
    function enumNumberValue(e, value) {
        return e[value];
    }
    exports_1("enumNumberValue", enumNumberValue);
    function sortByKey(object) {
        var values = [];
        Object.keys(object).forEach(function (key) {
            values.push({ k: key, v: object[key] });
        });
        var result = {};
        sortBy(values, 'k').forEach(function (entry) {
            result[entry.k] = entry.v;
        });
        return result;
    }
    exports_1("sortByKey", sortByKey);
    function sortByValue(object) {
        var values = [];
        Object.keys(object).forEach(function (key) {
            values.push({ k: key, v: object[key] });
        });
        var result = {};
        sortBy(values, 'v').forEach(function (entry) {
            result[entry.k] = entry.v;
        });
        return result;
    }
    exports_1("sortByValue", sortByValue);
    function sortBy(array, attribute) {
        return array.sort(function (a, b) {
            if (a.attribute < b.attribute) {
                return -1;
            } else if (a.attribute === b.attribute) {
                return 0;
            } else {
                return 1;
            }
        });
    }
    exports_1("sortBy", sortBy);
    function serializeDate(date) {
        if (isPresent(date)) {
            if (date.getHours() === 0 && date.getMinutes() === 0 && date.getSeconds() === 0) {
                return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
            } else {
                return date.getTime();
            }
        }
        return null;
    }
    exports_1("serializeDate", serializeDate);
    function deserializeDate(timestamp) {
        if (isPresent(timestamp)) {
            var date = new Date(timestamp);
            if (date.getUTCHours() === 0 && date.getUTCMinutes() === 0 && date.getUTCSeconds() === 0) {
                return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
            } else {
                return date;
            }
        }
        return null;
    }
    exports_1("deserializeDate", deserializeDate);
    function formatDateTime(value) {
        if (value) {
            if (isString(value)) {
                value = parseDate(value);
            }
            if (value) {
                var hour = value.getHours() < 10 ? '0' + value.getHours().toString() : value.getHours().toString();
                var minute = value.getMinutes() < 10 ? '0' + value.getMinutes().toString() : value.getMinutes().toString();
                var second = value.getSeconds() < 10 ? '0' + value.getSeconds().toString() : value.getSeconds().toString();
                return formatDate(value) + ' ' + hour + ':' + minute + ':' + second;
            }
        }
        return null;
    }
    exports_1("formatDateTime", formatDateTime);
    function formatDate(value) {
        var delimiter = '.';
        if (value) {
            if (isString(value)) {
                value = parseDate(value);
            }
            if (value) {
                var day = value.getDate() < 10 ? '0' + value.getDate().toString() : value.getDate().toString();
                var month = value.getMonth() < 9 ? '0' + (value.getMonth() + 1).toString() : (value.getMonth() + 1).toString();
                var year = value.getFullYear().toString();
                return day + delimiter + month + delimiter + year;
            }
        }
        return null;
    }
    exports_1("formatDate", formatDate);
    function formatDateForLink(value) {
        if (value) {
            if (isString(value)) {
                value = parseDate(value);
            }
            if (value) {
                var day = value.getDate() < 10 ? '0' + value.getDate().toString() : value.getDate().toString();
                var month = value.getMonth() < 9 ? '0' + (value.getMonth() + 1).toString() : (value.getMonth() + 1).toString();
                var year = value.getFullYear().toString();
                return year + month + day;
            }
        }
        return null;
    }
    exports_1("formatDateForLink", formatDateForLink);
    function createDate(year, month, day) {
        return new Date(year, month - 1, day);
    }
    exports_1("createDate", createDate);
    function parseDate(value) {
        if (isSomething(value)) {
            var matches = /^([0-3][0-9])\.([0-1][0-9])\.([1-9][0-9]{3})/.exec(value);
            if (matches) {
                return createDate(parseInt(matches[3]), parseInt(matches[2]), parseInt(matches[1]));
            } else {
                matches = /^([1-9][0-9]{3})\-([0-1][0-9])\-([0-3][0-9])/.exec(value);
                if (matches) {
                    return createDate(parseInt(matches[1]), parseInt(matches[2]), parseInt(matches[3]));
                } else {
                    matches = /^([1-9][0-9]{3})([0-1][0-9])([0-3][0-9])/.exec(value);
                    if (matches) {
                        return createDate(parseInt(matches[1]), parseInt(matches[2]), parseInt(matches[3]));
                    }
                }
            }
        }
        return null;
    }
    exports_1("parseDate", parseDate);
    function formatFileSize(size) {
        if (isPresent(size)) {
            var i = -1;
            var byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
            do {
                size = Math.round(size / 1024);
                i++;
            } while (size > 1024);
            return Math.round(Math.max(size, 0.1)).toString() + byteUnits[i];
        }
        return null;
    }
    exports_1("formatFileSize", formatFileSize);
    function fileExtension(fileName) {
        if (fileName && fileName.indexOf('\.') >= 0) {
            return fileName.substring(fileName.lastIndexOf('\.') + 1).toLowerCase();
        }
        return null;
    }
    exports_1("fileExtension", fileExtension);
    function removeFromArray(array, value) {
        var result = [];
        array.forEach(function (entry) {
            if (entry !== value) {
                result.push(entry);
            }
        });
        return result;
    }
    exports_1("removeFromArray", removeFromArray);
    // Calculates the last workday for the current year.
    // For previous years returns 31. December
    // @see exchange_rates_component
    function getLastWorkingDay(year) {
        var lastWorkingDay = new Date();
        if (!isPresent(year) || year === lastWorkingDay.getFullYear()) {
            lastWorkingDay.setDate(lastWorkingDay.getDate() - 1);
            if (lastWorkingDay.getDay() === 0) {
                lastWorkingDay.setDate(lastWorkingDay.getDate() - 2);
            } else if (lastWorkingDay.getDay() === 6) {
                lastWorkingDay.setDate(lastWorkingDay.getDate() - 1);
            }
            // go a week back for localhost
            if (location.hostname.indexOf('localhost') > -1) {
                lastWorkingDay.setDate(lastWorkingDay.getDate() - 7);
            }
            lastWorkingDay.setHours(0, 0, 0);
        } else {
            lastWorkingDay = createDate(year, 12, 31);
        }
        return lastWorkingDay;
    }
    exports_1("getLastWorkingDay", getLastWorkingDay);
    function lastDayOfMonth(year, month) {
        var lastDayOfMonth = 28;
        var testDate = createDate(year, month, lastDayOfMonth);
        while (testDate.getMonth() + 1 === month) {
            lastDayOfMonth++;
            testDate.setDate(testDate.getDate() + 1);
        }
        return lastDayOfMonth - 1;
    }
    exports_1("lastDayOfMonth", lastDayOfMonth);
    function getThisYear() {
        var today = new Date();
        return today.getFullYear();
    }
    exports_1("getThisYear", getThisYear);
    return {
        setters: [],
        execute: function () {// <reference path="../../../../node_modules/angular2/typings/browser.d.ts"/>
            /// <reference types="sugar" />
            /// <reference types="jasmine" />
        }
    };
});

System.register("ags-client/app/commons/html.js", ["ags-client/app/commons/lang.js"], function (exports_1, context_1) {
    "use strict";

    var lang_1;
    var __moduleName = context_1 && context_1.id;
    function appendClass(element, className) {
        if (!hasClass(element, className)) {
            if (element.getAttribute('class') === null) {
                setClasses(element, [className]);
            } else {
                var array = element.getAttribute('class').split(' ');
                array.push(className);
                setClasses(element, array);
            }
        }
    }
    exports_1("appendClass", appendClass);
    function removeClass(element, className) {
        if (hasClass(element, className)) {
            var classes = element.getAttribute('class').split(' ');
            setClasses(element, lang_1.removeFromArray(classes, className));
        }
    }
    exports_1("removeClass", removeClass);
    function findParentElementByClassName(element, className) {
        if (element.parentElement != null) {
            if (hasClass(element.parentElement, className)) {
                return element.parentElement;
            } else {
                return findParentElementByClassName(element.parentElement, className);
            }
        }
        return null;
    }
    exports_1("findParentElementByClassName", findParentElementByClassName);
    function setClasses(element, classes) {
        if (classes != null && classes.length > 0) {
            var classesString = '';
            classes.forEach(function (className) {
                if (classesString.length > 0) {
                    classesString = classesString.concat(' ');
                }
                classesString = classesString.concat(className);
            });
            element.setAttribute('class', classesString);
        } else {
            element.removeAttribute('class');
        }
    }
    exports_1("setClasses", setClasses);
    function hasClass(element, className) {
        if (element.getAttribute('class') != null) {
            var classes = element.getAttribute('class').split(' ');
            for (var i = 0; i < classes.length; i++) {
                if (classes[i] === className) {
                    return true;
                }
            }
        }
        return false;
    }
    exports_1("hasClass", hasClass);
    function setAttribute(element, attribute, value, overwrite) {
        if (overwrite === void 0) {
            overwrite = true;
        }
        if (!lang_1.isSomething(element.getAttribute(attribute)) || overwrite) {
            element.setAttribute(attribute, value);
        }
    }
    exports_1("setAttribute", setAttribute);
    function dispatchChangeEvent(element) {
        return dispatchEvent(element, 'change');
    }
    exports_1("dispatchChangeEvent", dispatchChangeEvent);
    function dispatchEvent(element, eventType) {
        element.dispatchEvent(new Event(eventType));
    }
    exports_1("dispatchEvent", dispatchEvent);
    function removeChilds(element) {
        if (element) {
            while (element.hasChildNodes()) {
                element.removeChild(element.lastChild);
            }
        }
    }
    exports_1("removeChilds", removeChilds);
    function screenWidth() {
        var w = window,
            d = document,
            e = d.documentElement,
            g = d.getElementsByTagName('body')[0];
        return w.innerWidth || e.clientWidth || g.clientWidth;
    }
    exports_1("screenWidth", screenWidth);
    return {
        setters: [function (lang_1_1) {
            lang_1 = lang_1_1;
        }],
        execute: function () {}
    };
});

System.register("ags-client/gen/enums.js", [], function (exports_1, context_1) {
    "use strict";

    var AccessAuthorizationType, AnnualReportRequested, AuthenticationType, BLOBMimeType, Canton, CLOBMimeType, DARateType, InstrumentGroup, InstrumentStatus, InstrumentType, InterestType, LabelApplication, LabelCategory, LegalForm, LOBType, MimeType, ProcessingStatus, QuotationType, RequestReason, RequestStatus, Salutation, ScanStatus, Sector, ValueType;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [],
        execute: function () {
            /**
             * generated by AGS
             */
            (function (AccessAuthorizationType) {
                AccessAuthorizationType[AccessAuthorizationType["DOMAIN"] = 0] = "DOMAIN";
                AccessAuthorizationType[AccessAuthorizationType["GROUP"] = 1] = "GROUP";
                AccessAuthorizationType[AccessAuthorizationType["OWN"] = 2] = "OWN";
            })(AccessAuthorizationType || exports_1("AccessAuthorizationType", AccessAuthorizationType = {}));
            (function (AnnualReportRequested) {
                AnnualReportRequested[AnnualReportRequested["ESTV"] = 0] = "ESTV";
                AnnualReportRequested[AnnualReportRequested["REQUESTER"] = 1] = "REQUESTER";
            })(AnnualReportRequested || exports_1("AnnualReportRequested", AnnualReportRequested = {}));
            (function (AuthenticationType) {
                AuthenticationType[AuthenticationType["BOTH"] = 0] = "BOTH";
                AuthenticationType[AuthenticationType["CERTIFICATE"] = 1] = "CERTIFICATE";
                AuthenticationType[AuthenticationType["NONE"] = 2] = "NONE";
                AuthenticationType[AuthenticationType["PASSWORD"] = 3] = "PASSWORD";
            })(AuthenticationType || exports_1("AuthenticationType", AuthenticationType = {}));
            (function (BLOBMimeType) {
                BLOBMimeType[BLOBMimeType["APPLICATION_ENVOY"] = 0] = "APPLICATION_ENVOY";
                BLOBMimeType[BLOBMimeType["APPLICATION_FRACTALS"] = 1] = "APPLICATION_FRACTALS";
                BLOBMimeType[BLOBMimeType["APPLICATION_FUTURESPLASH"] = 2] = "APPLICATION_FUTURESPLASH";
                BLOBMimeType[BLOBMimeType["APPLICATION_HTA"] = 3] = "APPLICATION_HTA";
                BLOBMimeType[BLOBMimeType["APPLICATION_INTERNET_PROPERTY_STREAM"] = 4] = "APPLICATION_INTERNET_PROPERTY_STREAM";
                BLOBMimeType[BLOBMimeType["APPLICATION_MAC_BINHEX40"] = 5] = "APPLICATION_MAC_BINHEX40";
                BLOBMimeType[BLOBMimeType["APPLICATION_MSWORD"] = 6] = "APPLICATION_MSWORD";
                BLOBMimeType[BLOBMimeType["APPLICATION_OCTET_STREAM"] = 7] = "APPLICATION_OCTET_STREAM";
                BLOBMimeType[BLOBMimeType["APPLICATION_ODA"] = 8] = "APPLICATION_ODA";
                BLOBMimeType[BLOBMimeType["APPLICATION_OLESCRIPT"] = 9] = "APPLICATION_OLESCRIPT";
                BLOBMimeType[BLOBMimeType["APPLICATION_PDF"] = 10] = "APPLICATION_PDF";
                BLOBMimeType[BLOBMimeType["APPLICATION_PICS_RULES"] = 11] = "APPLICATION_PICS_RULES";
                BLOBMimeType[BLOBMimeType["APPLICATION_PKCS10"] = 12] = "APPLICATION_PKCS10";
                BLOBMimeType[BLOBMimeType["APPLICATION_PKIX_CRL"] = 13] = "APPLICATION_PKIX_CRL";
                BLOBMimeType[BLOBMimeType["APPLICATION_POSTSCRIPT"] = 14] = "APPLICATION_POSTSCRIPT";
                BLOBMimeType[BLOBMimeType["APPLICATION_RTF"] = 15] = "APPLICATION_RTF";
                BLOBMimeType[BLOBMimeType["APPLICATION_SET_PAYMENT_INITIATION"] = 16] = "APPLICATION_SET_PAYMENT_INITIATION";
                BLOBMimeType[BLOBMimeType["APPLICATION_SET_REGISTRATION_INITIATION"] = 17] = "APPLICATION_SET_REGISTRATION_INITIATION";
                BLOBMimeType[BLOBMimeType["APPLICATION_VND_MS_EXCEL"] = 18] = "APPLICATION_VND_MS_EXCEL";
                BLOBMimeType[BLOBMimeType["APPLICATION_VND_MS_EXCEL_ADDIN_MACROENABLED_12"] = 19] = "APPLICATION_VND_MS_EXCEL_ADDIN_MACROENABLED_12";
                BLOBMimeType[BLOBMimeType["APPLICATION_VND_MS_EXCEL_SHEET_BINARY_MACROENABLED_12"] = 20] = "APPLICATION_VND_MS_EXCEL_SHEET_BINARY_MACROENABLED_12";
                BLOBMimeType[BLOBMimeType["APPLICATION_VND_MS_EXCEL_SHEET_MACROENABLED_12"] = 21] = "APPLICATION_VND_MS_EXCEL_SHEET_MACROENABLED_12";
                BLOBMimeType[BLOBMimeType["APPLICATION_VND_MS_EXCEL_TEMPLATE_MACROENABLED_12"] = 22] = "APPLICATION_VND_MS_EXCEL_TEMPLATE_MACROENABLED_12";
                BLOBMimeType[BLOBMimeType["APPLICATION_VND_MS_OUTLOOK"] = 23] = "APPLICATION_VND_MS_OUTLOOK";
                BLOBMimeType[BLOBMimeType["APPLICATION_VND_MS_PKICERTSTORE"] = 24] = "APPLICATION_VND_MS_PKICERTSTORE";
                BLOBMimeType[BLOBMimeType["APPLICATION_VND_MS_PKISECCAT"] = 25] = "APPLICATION_VND_MS_PKISECCAT";
                BLOBMimeType[BLOBMimeType["APPLICATION_VND_MS_PKISTL"] = 26] = "APPLICATION_VND_MS_PKISTL";
                BLOBMimeType[BLOBMimeType["APPLICATION_VND_MS_POWERPOINT"] = 27] = "APPLICATION_VND_MS_POWERPOINT";
                BLOBMimeType[BLOBMimeType["APPLICATION_VND_MS_POWERPOINT_ADDIN_MACROENABLED_12"] = 28] = "APPLICATION_VND_MS_POWERPOINT_ADDIN_MACROENABLED_12";
                BLOBMimeType[BLOBMimeType["APPLICATION_VND_MS_POWERPOINT_PRESENTATION_MACROENABLED_12"] = 29] = "APPLICATION_VND_MS_POWERPOINT_PRESENTATION_MACROENABLED_12";
                BLOBMimeType[BLOBMimeType["APPLICATION_VND_MS_POWERPOINT_SLIDESHOW_MACROENABLED_12"] = 30] = "APPLICATION_VND_MS_POWERPOINT_SLIDESHOW_MACROENABLED_12";
                BLOBMimeType[BLOBMimeType["APPLICATION_VND_MS_POWERPOINT_TEMPLATE_MACROENABLED_12"] = 31] = "APPLICATION_VND_MS_POWERPOINT_TEMPLATE_MACROENABLED_12";
                BLOBMimeType[BLOBMimeType["APPLICATION_VND_MS_PROJECT"] = 32] = "APPLICATION_VND_MS_PROJECT";
                BLOBMimeType[BLOBMimeType["APPLICATION_VND_MS_WORD_DOCUMENT_MACROENABLED_12"] = 33] = "APPLICATION_VND_MS_WORD_DOCUMENT_MACROENABLED_12";
                BLOBMimeType[BLOBMimeType["APPLICATION_VND_MS_WORKS"] = 34] = "APPLICATION_VND_MS_WORKS";
                BLOBMimeType[BLOBMimeType["APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_PRESENTATION"] = 35] = "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_PRESENTATION";
                BLOBMimeType[BLOBMimeType["APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_SLIDESHOW"] = 36] = "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_SLIDESHOW";
                BLOBMimeType[BLOBMimeType["APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_TEMPLATE"] = 37] = "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_TEMPLATE";
                BLOBMimeType[BLOBMimeType["APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_SPREADSHEETML_SHEET"] = 38] = "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_SPREADSHEETML_SHEET";
                BLOBMimeType[BLOBMimeType["APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_SPREADSHEETML_TEMPLATE"] = 39] = "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_SPREADSHEETML_TEMPLATE";
                BLOBMimeType[BLOBMimeType["APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_WORDPROCESSINGML_DOCUMENT"] = 40] = "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_WORDPROCESSINGML_DOCUMENT";
                BLOBMimeType[BLOBMimeType["APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_WORDPROCESSINGML_TEMPLATE"] = 41] = "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_WORDPROCESSINGML_TEMPLATE";
                BLOBMimeType[BLOBMimeType["APPLICATION_WINHLP"] = 42] = "APPLICATION_WINHLP";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_BCPIO"] = 43] = "APPLICATION_X_BCPIO";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_BZIP2"] = 44] = "APPLICATION_X_BZIP2";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_CDF"] = 45] = "APPLICATION_X_CDF";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_COMPRESS"] = 46] = "APPLICATION_X_COMPRESS";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_COMPRESSED"] = 47] = "APPLICATION_X_COMPRESSED";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_CPIO"] = 48] = "APPLICATION_X_CPIO";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_CSH"] = 49] = "APPLICATION_X_CSH";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_DIRECTOR"] = 50] = "APPLICATION_X_DIRECTOR";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_DVI"] = 51] = "APPLICATION_X_DVI";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_GTAR"] = 52] = "APPLICATION_X_GTAR";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_GZIP"] = 53] = "APPLICATION_X_GZIP";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_HDF"] = 54] = "APPLICATION_X_HDF";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_INTERNET_SIGNUP"] = 55] = "APPLICATION_X_INTERNET_SIGNUP";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_IPHONE"] = 56] = "APPLICATION_X_IPHONE";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_JAVASCRIPT"] = 57] = "APPLICATION_X_JAVASCRIPT";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_LATEX"] = 58] = "APPLICATION_X_LATEX";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_MSACCESS"] = 59] = "APPLICATION_X_MSACCESS";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_MSCARDFILE"] = 60] = "APPLICATION_X_MSCARDFILE";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_MSCLIP"] = 61] = "APPLICATION_X_MSCLIP";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_MSDOWNLOAD"] = 62] = "APPLICATION_X_MSDOWNLOAD";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_MSMEDIAVIEW"] = 63] = "APPLICATION_X_MSMEDIAVIEW";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_MSMETAFILE"] = 64] = "APPLICATION_X_MSMETAFILE";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_MSMONEY"] = 65] = "APPLICATION_X_MSMONEY";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_MSPUBLISHER"] = 66] = "APPLICATION_X_MSPUBLISHER";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_MSSCHEDULE"] = 67] = "APPLICATION_X_MSSCHEDULE";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_MSTERMINAL"] = 68] = "APPLICATION_X_MSTERMINAL";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_MSWRITE"] = 69] = "APPLICATION_X_MSWRITE";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_PERFMON"] = 70] = "APPLICATION_X_PERFMON";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_PKCS12"] = 71] = "APPLICATION_X_PKCS12";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_PKCS7_CERTIFICATES"] = 72] = "APPLICATION_X_PKCS7_CERTIFICATES";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_PKCS7_CERTREQRESP"] = 73] = "APPLICATION_X_PKCS7_CERTREQRESP";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_PKCS7_MIME"] = 74] = "APPLICATION_X_PKCS7_MIME";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_PKCS7_SIGNATURE"] = 75] = "APPLICATION_X_PKCS7_SIGNATURE";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_SH"] = 76] = "APPLICATION_X_SH";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_SHAR"] = 77] = "APPLICATION_X_SHAR";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_STUFFIT"] = 78] = "APPLICATION_X_STUFFIT";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_SV4CPIO"] = 79] = "APPLICATION_X_SV4CPIO";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_SV4CRC"] = 80] = "APPLICATION_X_SV4CRC";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_TAR"] = 81] = "APPLICATION_X_TAR";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_TCL"] = 82] = "APPLICATION_X_TCL";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_TEX"] = 83] = "APPLICATION_X_TEX";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_TEXINFO"] = 84] = "APPLICATION_X_TEXINFO";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_TROFF"] = 85] = "APPLICATION_X_TROFF";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_TROFF_MAN"] = 86] = "APPLICATION_X_TROFF_MAN";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_TROFF_ME"] = 87] = "APPLICATION_X_TROFF_ME";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_TROFF_MS"] = 88] = "APPLICATION_X_TROFF_MS";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_USTAR"] = 89] = "APPLICATION_X_USTAR";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_WAIS_SOURCE"] = 90] = "APPLICATION_X_WAIS_SOURCE";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_X509_CA_CERT"] = 91] = "APPLICATION_X_X509_CA_CERT";
                BLOBMimeType[BLOBMimeType["APPLICATION_X_ZIP_COMPRESSED"] = 92] = "APPLICATION_X_ZIP_COMPRESSED";
                BLOBMimeType[BLOBMimeType["APPLICATION_YND_MS_PKIPKO"] = 93] = "APPLICATION_YND_MS_PKIPKO";
                BLOBMimeType[BLOBMimeType["APPLICATION_ZIP"] = 94] = "APPLICATION_ZIP";
                BLOBMimeType[BLOBMimeType["AUDIO_BASIC"] = 95] = "AUDIO_BASIC";
                BLOBMimeType[BLOBMimeType["AUDIO_MID"] = 96] = "AUDIO_MID";
                BLOBMimeType[BLOBMimeType["AUDIO_MPEG"] = 97] = "AUDIO_MPEG";
                BLOBMimeType[BLOBMimeType["AUDIO_X_AIFF"] = 98] = "AUDIO_X_AIFF";
                BLOBMimeType[BLOBMimeType["AUDIO_X_MPEGURL"] = 99] = "AUDIO_X_MPEGURL";
                BLOBMimeType[BLOBMimeType["AUDIO_X_PN_REALAUDIO"] = 100] = "AUDIO_X_PN_REALAUDIO";
                BLOBMimeType[BLOBMimeType["AUDIO_X_WAV"] = 101] = "AUDIO_X_WAV";
                BLOBMimeType[BLOBMimeType["IMAGE_BMP"] = 102] = "IMAGE_BMP";
                BLOBMimeType[BLOBMimeType["IMAGE_CIS_COD"] = 103] = "IMAGE_CIS_COD";
                BLOBMimeType[BLOBMimeType["IMAGE_GIF"] = 104] = "IMAGE_GIF";
                BLOBMimeType[BLOBMimeType["IMAGE_IEF"] = 105] = "IMAGE_IEF";
                BLOBMimeType[BLOBMimeType["IMAGE_JPEG"] = 106] = "IMAGE_JPEG";
                BLOBMimeType[BLOBMimeType["IMAGE_PIPEG"] = 107] = "IMAGE_PIPEG";
                BLOBMimeType[BLOBMimeType["IMAGE_PNG"] = 108] = "IMAGE_PNG";
                BLOBMimeType[BLOBMimeType["IMAGE_TIFF"] = 109] = "IMAGE_TIFF";
                BLOBMimeType[BLOBMimeType["IMAGE_X_CMU_RASTER"] = 110] = "IMAGE_X_CMU_RASTER";
                BLOBMimeType[BLOBMimeType["IMAGE_X_CMX"] = 111] = "IMAGE_X_CMX";
                BLOBMimeType[BLOBMimeType["IMAGE_X_ICON"] = 112] = "IMAGE_X_ICON";
                BLOBMimeType[BLOBMimeType["IMAGE_X_PORTABLE_ANYMAP"] = 113] = "IMAGE_X_PORTABLE_ANYMAP";
                BLOBMimeType[BLOBMimeType["IMAGE_X_PORTABLE_BITMAP"] = 114] = "IMAGE_X_PORTABLE_BITMAP";
                BLOBMimeType[BLOBMimeType["IMAGE_X_PORTABLE_GRAYMAP"] = 115] = "IMAGE_X_PORTABLE_GRAYMAP";
                BLOBMimeType[BLOBMimeType["IMAGE_X_PORTABLE_PIXMAP"] = 116] = "IMAGE_X_PORTABLE_PIXMAP";
                BLOBMimeType[BLOBMimeType["IMAGE_X_RGB"] = 117] = "IMAGE_X_RGB";
                BLOBMimeType[BLOBMimeType["IMAGE_X_XBITMAP"] = 118] = "IMAGE_X_XBITMAP";
                BLOBMimeType[BLOBMimeType["IMAGE_X_XPIXMAP"] = 119] = "IMAGE_X_XPIXMAP";
                BLOBMimeType[BLOBMimeType["IMAGE_X_XWINDOWDUMP"] = 120] = "IMAGE_X_XWINDOWDUMP";
                BLOBMimeType[BLOBMimeType["MESSAGE_RFC822"] = 121] = "MESSAGE_RFC822";
                BLOBMimeType[BLOBMimeType["VIDEO_MPEG"] = 122] = "VIDEO_MPEG";
                BLOBMimeType[BLOBMimeType["VIDEO_QUICKTIME"] = 123] = "VIDEO_QUICKTIME";
                BLOBMimeType[BLOBMimeType["VIDEO_X_LA_ASF"] = 124] = "VIDEO_X_LA_ASF";
                BLOBMimeType[BLOBMimeType["VIDEO_X_MS_ASF"] = 125] = "VIDEO_X_MS_ASF";
                BLOBMimeType[BLOBMimeType["VIDEO_X_MSVIDEO"] = 126] = "VIDEO_X_MSVIDEO";
                BLOBMimeType[BLOBMimeType["VIDEO_X_SGI_MOVIE"] = 127] = "VIDEO_X_SGI_MOVIE";
                BLOBMimeType[BLOBMimeType["X_WORLD_X_VRML"] = 128] = "X_WORLD_X_VRML";
            })(BLOBMimeType || exports_1("BLOBMimeType", BLOBMimeType = {}));
            (function (Canton) {
                Canton[Canton["AG"] = 0] = "AG";
                Canton[Canton["AI"] = 1] = "AI";
                Canton[Canton["AR"] = 2] = "AR";
                Canton[Canton["BE"] = 3] = "BE";
                Canton[Canton["BL"] = 4] = "BL";
                Canton[Canton["BS"] = 5] = "BS";
                Canton[Canton["FR"] = 6] = "FR";
                Canton[Canton["GE"] = 7] = "GE";
                Canton[Canton["GL"] = 8] = "GL";
                Canton[Canton["GR"] = 9] = "GR";
                Canton[Canton["JU"] = 10] = "JU";
                Canton[Canton["LU"] = 11] = "LU";
                Canton[Canton["NE"] = 12] = "NE";
                Canton[Canton["NW"] = 13] = "NW";
                Canton[Canton["OW"] = 14] = "OW";
                Canton[Canton["SG"] = 15] = "SG";
                Canton[Canton["SH"] = 16] = "SH";
                Canton[Canton["SO"] = 17] = "SO";
                Canton[Canton["SZ"] = 18] = "SZ";
                Canton[Canton["TG"] = 19] = "TG";
                Canton[Canton["TI"] = 20] = "TI";
                Canton[Canton["UR"] = 21] = "UR";
                Canton[Canton["VD"] = 22] = "VD";
                Canton[Canton["VS"] = 23] = "VS";
                Canton[Canton["ZG"] = 24] = "ZG";
                Canton[Canton["ZH"] = 25] = "ZH";
            })(Canton || exports_1("Canton", Canton = {}));
            (function (CLOBMimeType) {
                CLOBMimeType[CLOBMimeType["TEXT_CSS"] = 0] = "TEXT_CSS";
                CLOBMimeType[CLOBMimeType["TEXT_CSV"] = 1] = "TEXT_CSV";
                CLOBMimeType[CLOBMimeType["TEXT_H323"] = 2] = "TEXT_H323";
                CLOBMimeType[CLOBMimeType["TEXT_HTML"] = 3] = "TEXT_HTML";
                CLOBMimeType[CLOBMimeType["TEXT_IULS"] = 4] = "TEXT_IULS";
                CLOBMimeType[CLOBMimeType["TEXT_PLAIN"] = 5] = "TEXT_PLAIN";
                CLOBMimeType[CLOBMimeType["TEXT_RICHTEXT"] = 6] = "TEXT_RICHTEXT";
                CLOBMimeType[CLOBMimeType["TEXT_SCRIPTLET"] = 7] = "TEXT_SCRIPTLET";
                CLOBMimeType[CLOBMimeType["TEXT_TAB_SEPARATED_VALUES"] = 8] = "TEXT_TAB_SEPARATED_VALUES";
                CLOBMimeType[CLOBMimeType["TEXT_WEBVIEWHTML"] = 9] = "TEXT_WEBVIEWHTML";
                CLOBMimeType[CLOBMimeType["TEXT_X_COMMA_SEPARATED_VALUES"] = 10] = "TEXT_X_COMMA_SEPARATED_VALUES";
                CLOBMimeType[CLOBMimeType["TEXT_X_COMPONENT"] = 11] = "TEXT_X_COMPONENT";
                CLOBMimeType[CLOBMimeType["TEXT_X_SETEXT"] = 12] = "TEXT_X_SETEXT";
                CLOBMimeType[CLOBMimeType["TEXT_X_VCARD"] = 13] = "TEXT_X_VCARD";
                CLOBMimeType[CLOBMimeType["TEXT_XML"] = 14] = "TEXT_XML";
            })(CLOBMimeType || exports_1("CLOBMimeType", CLOBMimeType = {}));
            (function (DARateType) {
                DARateType[DARateType["_10_PERCENT_POS"] = 0] = "_10_PERCENT_POS";
                DARateType[DARateType["_10_PERCENT_POS_1Y"] = 1] = "_10_PERCENT_POS_1Y";
                DARateType[DARateType["_10_PERCENT_POS_2Y"] = 2] = "_10_PERCENT_POS_2Y";
                DARateType[DARateType["_20_PERCENT_POS"] = 3] = "_20_PERCENT_POS";
                DARateType[DARateType["_20_PERCENT_POS_1Y"] = 4] = "_20_PERCENT_POS_1Y";
                DARateType[DARateType["_20_PERCENT_POS_2Y"] = 5] = "_20_PERCENT_POS_2Y";
                DARateType[DARateType["_25_PERCENT_POS"] = 6] = "_25_PERCENT_POS";
                DARateType[DARateType["_25_PERCENT_POS_1Y"] = 7] = "_25_PERCENT_POS_1Y";
                DARateType[DARateType["_25_PERCENT_POS_2Y"] = 8] = "_25_PERCENT_POS_2Y";
                DARateType[DARateType["_50_PERCENT_POS"] = 9] = "_50_PERCENT_POS";
                DARateType[DARateType["_50_PERCENT_POS_1Y"] = 10] = "_50_PERCENT_POS_1Y";
                DARateType[DARateType["_50_PERCENT_POS_2Y"] = 11] = "_50_PERCENT_POS_2Y";
                DARateType[DARateType["LP"] = 12] = "LP";
                DARateType[DARateType["LP_10_PERCENT_POS"] = 13] = "LP_10_PERCENT_POS";
                DARateType[DARateType["LP_20_PERCENT_POS"] = 14] = "LP_20_PERCENT_POS";
                DARateType[DARateType["LP_25_PERCENT_POS"] = 15] = "LP_25_PERCENT_POS";
                DARateType[DARateType["LP_50_PERCENT_POS"] = 16] = "LP_50_PERCENT_POS";
                DARateType[DARateType["OTHER"] = 17] = "OTHER";
                DARateType[DARateType["RPF"] = 18] = "RPF";
                DARateType[DARateType["RPF_10_PERCENT_POS"] = 19] = "RPF_10_PERCENT_POS";
                DARateType[DARateType["RPF_20_PERCENT_POS"] = 20] = "RPF_20_PERCENT_POS";
                DARateType[DARateType["RPF_25_PERCENT_POS"] = 21] = "RPF_25_PERCENT_POS";
                DARateType[DARateType["RPF_50_PERCENT_POS"] = 22] = "RPF_50_PERCENT_POS";
            })(DARateType || exports_1("DARateType", DARateType = {}));
            (function (InstrumentGroup) {
                InstrumentGroup[InstrumentGroup["BOND"] = 0] = "BOND";
                InstrumentGroup[InstrumentGroup["COINBULL"] = 1] = "COINBULL";
                InstrumentGroup[InstrumentGroup["CURRNOTE"] = 2] = "CURRNOTE";
                InstrumentGroup[InstrumentGroup["DEVT"] = 3] = "DEVT";
                InstrumentGroup[InstrumentGroup["FUND"] = 4] = "FUND";
                InstrumentGroup[InstrumentGroup["LIBOSWAP"] = 5] = "LIBOSWAP";
                InstrumentGroup[InstrumentGroup["OPTION"] = 6] = "OPTION";
                InstrumentGroup[InstrumentGroup["SHARE"] = 7] = "SHARE";
            })(InstrumentGroup || exports_1("InstrumentGroup", InstrumentGroup = {}));
            (function (InstrumentStatus) {
                InstrumentStatus[InstrumentStatus["ACTIVE"] = 0] = "ACTIVE";
                InstrumentStatus[InstrumentStatus["INACTIVE"] = 1] = "INACTIVE";
                InstrumentStatus[InstrumentStatus["INDEFAULT"] = 2] = "INDEFAULT";
                InstrumentStatus[InstrumentStatus["INLIQUIDATION"] = 3] = "INLIQUIDATION";
            })(InstrumentStatus || exports_1("InstrumentStatus", InstrumentStatus = {}));
            (function (InstrumentType) {
                InstrumentType[InstrumentType["BOND_BOND"] = 0] = "BOND_BOND";
                InstrumentType[InstrumentType["BOND_CONVERTABLE"] = 1] = "BOND_CONVERTABLE";
                InstrumentType[InstrumentType["BOND_OPTION"] = 2] = "BOND_OPTION";
                InstrumentType[InstrumentType["COINBULL_COINGOLD"] = 3] = "COINBULL_COINGOLD";
                InstrumentType[InstrumentType["COINBULL_GOLD"] = 4] = "COINBULL_GOLD";
                InstrumentType[InstrumentType["COINBULL_PALLADIUM"] = 5] = "COINBULL_PALLADIUM";
                InstrumentType[InstrumentType["COINBULL_PLATINUM"] = 6] = "COINBULL_PLATINUM";
                InstrumentType[InstrumentType["COINBULL_SILVER"] = 7] = "COINBULL_SILVER";
                InstrumentType[InstrumentType["CURRNOTE_CURRENCY"] = 8] = "CURRNOTE_CURRENCY";
                InstrumentType[InstrumentType["CURRNOTE_CURRYEAR"] = 9] = "CURRNOTE_CURRYEAR";
                InstrumentType[InstrumentType["CURRNOTE_TOKEN"] = 10] = "CURRNOTE_TOKEN";
                InstrumentType[InstrumentType["DEVT_COMBINEDPRODUCT"] = 11] = "DEVT_COMBINEDPRODUCT";
                InstrumentType[InstrumentType["DEVT_FUNDSIMILARASSET"] = 12] = "DEVT_FUNDSIMILARASSET";
                InstrumentType[InstrumentType["DEVT_INDEXBASKET"] = 13] = "DEVT_INDEXBASKET";
                InstrumentType[InstrumentType["FUND_ACCUMULATION"] = 14] = "FUND_ACCUMULATION";
                InstrumentType[InstrumentType["FUND_DISTRIBUTION"] = 15] = "FUND_DISTRIBUTION";
                InstrumentType[InstrumentType["FUND_REALESTATE"] = 16] = "FUND_REALESTATE";
                InstrumentType[InstrumentType["LIBOSWAP_LIBOR"] = 17] = "LIBOSWAP_LIBOR";
                InstrumentType[InstrumentType["LIBOSWAP_SWAP"] = 18] = "LIBOSWAP_SWAP";
                InstrumentType[InstrumentType["OPTION_CALL"] = 19] = "OPTION_CALL";
                InstrumentType[InstrumentType["OPTION_PHANTOM"] = 20] = "OPTION_PHANTOM";
                InstrumentType[InstrumentType["OPTION_PUT"] = 21] = "OPTION_PUT";
                InstrumentType[InstrumentType["SHARE_BEARERCERT"] = 22] = "SHARE_BEARERCERT";
                InstrumentType[InstrumentType["SHARE_BONUS"] = 23] = "SHARE_BONUS";
                InstrumentType[InstrumentType["SHARE_COMMON"] = 24] = "SHARE_COMMON";
                InstrumentType[InstrumentType["SHARE_COOP"] = 25] = "SHARE_COOP";
                InstrumentType[InstrumentType["SHARE_LIMITED"] = 26] = "SHARE_LIMITED";
                InstrumentType[InstrumentType["SHARE_LIMITEDOLD"] = 27] = "SHARE_LIMITEDOLD";
                InstrumentType[InstrumentType["SHARE_NOMINAL"] = 28] = "SHARE_NOMINAL";
                InstrumentType[InstrumentType["SHARE_PARTCERT"] = 29] = "SHARE_PARTCERT";
                InstrumentType[InstrumentType["SHARE_PREFERRED"] = 30] = "SHARE_PREFERRED";
                InstrumentType[InstrumentType["SHARE_TRANSFERABLE"] = 31] = "SHARE_TRANSFERABLE";
            })(InstrumentType || exports_1("InstrumentType", InstrumentType = {}));
            (function (InterestType) {
                InterestType[InterestType["FIX"] = 0] = "FIX";
                InterestType[InterestType["VAR"] = 1] = "VAR";
            })(InterestType || exports_1("InterestType", InterestType = {}));
            (function (LabelApplication) {
                LabelApplication[LabelApplication["AGS"] = 0] = "AGS";
                LabelApplication[LabelApplication["EWS"] = 1] = "EWS";
                LabelApplication[LabelApplication["EWS_MAILS"] = 2] = "EWS_MAILS";
                LabelApplication[LabelApplication["ICT_CORE"] = 3] = "ICT_CORE";
                LabelApplication[LabelApplication["ICT_EXTERN"] = 4] = "ICT_EXTERN";
                LabelApplication[LabelApplication["ICT_INTERN"] = 5] = "ICT_INTERN";
                LabelApplication[LabelApplication["ICT_MAILS"] = 6] = "ICT_MAILS";
            })(LabelApplication || exports_1("LabelApplication", LabelApplication = {}));
            (function (LabelCategory) {
                LabelCategory[LabelCategory["ACCOUNT"] = 0] = "ACCOUNT";
                LabelCategory[LabelCategory["ATTACHMENTS"] = 1] = "ATTACHMENTS";
                LabelCategory[LabelCategory["AUTHENTICATION"] = 2] = "AUTHENTICATION";
                LabelCategory[LabelCategory["BUTTON"] = 3] = "BUTTON";
                LabelCategory[LabelCategory["CALCULATION"] = 4] = "CALCULATION";
                LabelCategory[LabelCategory["CAPTCHA"] = 5] = "CAPTCHA";
                LabelCategory[LabelCategory["CHANGE_PASSWORD"] = 6] = "CHANGE_PASSWORD";
                LabelCategory[LabelCategory["CODE"] = 7] = "CODE";
                LabelCategory[LabelCategory["CODES"] = 8] = "CODES";
                LabelCategory[LabelCategory["COMMONS"] = 9] = "COMMONS";
                LabelCategory[LabelCategory["CONFIRMATION"] = 10] = "CONFIRMATION";
                LabelCategory[LabelCategory["DASHBOARD"] = 11] = "DASHBOARD";
                LabelCategory[LabelCategory["DOMAIN"] = 12] = "DOMAIN";
                LabelCategory[LabelCategory["DOMAINS"] = 13] = "DOMAINS";
                LabelCategory[LabelCategory["EARNING"] = 14] = "EARNING";
                LabelCategory[LabelCategory["EARNING_DECLARE"] = 15] = "EARNING_DECLARE";
                LabelCategory[LabelCategory["EARNING_SECURITY"] = 16] = "EARNING_SECURITY";
                LabelCategory[LabelCategory["EARNINGS"] = 17] = "EARNINGS";
                LabelCategory[LabelCategory["EDIT_ONLINE_MESSAGES"] = 18] = "EDIT_ONLINE_MESSAGES";
                LabelCategory[LabelCategory["ENCODE_PASSWORD"] = 19] = "ENCODE_PASSWORD";
                LabelCategory[LabelCategory["ERROR"] = 20] = "ERROR";
                LabelCategory[LabelCategory["EXPORT"] = 21] = "EXPORT";
                LabelCategory[LabelCategory["FILE"] = 22] = "FILE";
                LabelCategory[LabelCategory["FILEUPLOAD"] = 23] = "FILEUPLOAD";
                LabelCategory[LabelCategory["GADGETS"] = 24] = "GADGETS";
                LabelCategory[LabelCategory["IMPORT"] = 25] = "IMPORT";
                LabelCategory[LabelCategory["INFO"] = 26] = "INFO";
                LabelCategory[LabelCategory["INSTRUMENT"] = 27] = "INSTRUMENT";
                LabelCategory[LabelCategory["LABEL"] = 28] = "LABEL";
                LabelCategory[LabelCategory["LOGIN"] = 29] = "LOGIN";
                LabelCategory[LabelCategory["LOST_PASSWORD"] = 30] = "LOST_PASSWORD";
                LabelCategory[LabelCategory["MAIL"] = 31] = "MAIL";
                LabelCategory[LabelCategory["MENU"] = 32] = "MENU";
                LabelCategory[LabelCategory["MULTI_SELECT"] = 33] = "MULTI_SELECT";
                LabelCategory[LabelCategory["NEWSLETTER"] = 34] = "NEWSLETTER";
                LabelCategory[LabelCategory["PRINT"] = 35] = "PRINT";
                LabelCategory[LabelCategory["RATELIST"] = 36] = "RATELIST";
                LabelCategory[LabelCategory["REGISTER"] = 37] = "REGISTER";
                LabelCategory[LabelCategory["REGISTRATION"] = 38] = "REGISTRATION";
                LabelCategory[LabelCategory["REPORT"] = 39] = "REPORT";
                LabelCategory[LabelCategory["REQUEST"] = 40] = "REQUEST";
                LabelCategory[LabelCategory["REQUEST_DUMP_LOG"] = 41] = "REQUEST_DUMP_LOG";
                LabelCategory[LabelCategory["REQUEST_DUMP_LOGS"] = 42] = "REQUEST_DUMP_LOGS";
                LabelCategory[LabelCategory["REQUESTS"] = 43] = "REQUESTS";
                LabelCategory[LabelCategory["ROLE"] = 44] = "ROLE";
                LabelCategory[LabelCategory["ROLES"] = 45] = "ROLES";
                LabelCategory[LabelCategory["SEARCH"] = 46] = "SEARCH";
                LabelCategory[LabelCategory["SECURITY"] = 47] = "SECURITY";
                LabelCategory[LabelCategory["SECURITY_SEARCH"] = 48] = "SECURITY_SEARCH";
                LabelCategory[LabelCategory["SYSTEM"] = 49] = "SYSTEM";
                LabelCategory[LabelCategory["SYSTEMS"] = 50] = "SYSTEMS";
                LabelCategory[LabelCategory["UNDER_CONSTRUCTION"] = 51] = "UNDER_CONSTRUCTION";
                LabelCategory[LabelCategory["USER"] = 52] = "USER";
                LabelCategory[LabelCategory["USERS"] = 53] = "USERS";
                LabelCategory[LabelCategory["VALIDATION_ERRORS"] = 54] = "VALIDATION_ERRORS";
                LabelCategory[LabelCategory["WORK_ORDER"] = 55] = "WORK_ORDER";
                LabelCategory[LabelCategory["XML"] = 56] = "XML";
            })(LabelCategory || exports_1("LabelCategory", LabelCategory = {}));
            (function (LegalForm) {
                LegalForm[LegalForm["_01"] = 0] = "_01";
                LegalForm[LegalForm["_02"] = 1] = "_02";
                LegalForm[LegalForm["_03"] = 2] = "_03";
                LegalForm[LegalForm["_04"] = 3] = "_04";
                LegalForm[LegalForm["_05"] = 4] = "_05";
                LegalForm[LegalForm["_06"] = 5] = "_06";
                LegalForm[LegalForm["_07"] = 6] = "_07";
                LegalForm[LegalForm["_08"] = 7] = "_08";
                LegalForm[LegalForm["_09"] = 8] = "_09";
                LegalForm[LegalForm["_10"] = 9] = "_10";
                LegalForm[LegalForm["_11"] = 10] = "_11";
                LegalForm[LegalForm["_12"] = 11] = "_12";
                LegalForm[LegalForm["_13"] = 12] = "_13";
                LegalForm[LegalForm["_20"] = 13] = "_20";
                LegalForm[LegalForm["_21"] = 14] = "_21";
                LegalForm[LegalForm["_22"] = 15] = "_22";
                LegalForm[LegalForm["_23"] = 16] = "_23";
                LegalForm[LegalForm["_24"] = 17] = "_24";
                LegalForm[LegalForm["_25"] = 18] = "_25";
                LegalForm[LegalForm["_27"] = 19] = "_27";
                LegalForm[LegalForm["_28"] = 20] = "_28";
                LegalForm[LegalForm["_29"] = 21] = "_29";
                LegalForm[LegalForm["_30"] = 22] = "_30";
                LegalForm[LegalForm["_31"] = 23] = "_31";
                LegalForm[LegalForm["_32"] = 24] = "_32";
                LegalForm[LegalForm["_33"] = 25] = "_33";
                LegalForm[LegalForm["_34"] = 26] = "_34";
            })(LegalForm || exports_1("LegalForm", LegalForm = {}));
            (function (LOBType) {
                LOBType[LOBType["BLOB"] = 0] = "BLOB";
                LOBType[LOBType["CLOB"] = 1] = "CLOB";
                LOBType[LOBType["URL"] = 2] = "URL";
            })(LOBType || exports_1("LOBType", LOBType = {}));
            (function (MimeType) {
                MimeType[MimeType["APPLICATION_ENVOY"] = 0] = "APPLICATION_ENVOY";
                MimeType[MimeType["APPLICATION_FRACTALS"] = 1] = "APPLICATION_FRACTALS";
                MimeType[MimeType["APPLICATION_FUTURESPLASH"] = 2] = "APPLICATION_FUTURESPLASH";
                MimeType[MimeType["APPLICATION_HTA"] = 3] = "APPLICATION_HTA";
                MimeType[MimeType["APPLICATION_INTERNET_PROPERTY_STREAM"] = 4] = "APPLICATION_INTERNET_PROPERTY_STREAM";
                MimeType[MimeType["APPLICATION_MAC_BINHEX40"] = 5] = "APPLICATION_MAC_BINHEX40";
                MimeType[MimeType["APPLICATION_MSWORD"] = 6] = "APPLICATION_MSWORD";
                MimeType[MimeType["APPLICATION_OCTET_STREAM"] = 7] = "APPLICATION_OCTET_STREAM";
                MimeType[MimeType["APPLICATION_ODA"] = 8] = "APPLICATION_ODA";
                MimeType[MimeType["APPLICATION_OLESCRIPT"] = 9] = "APPLICATION_OLESCRIPT";
                MimeType[MimeType["APPLICATION_PDF"] = 10] = "APPLICATION_PDF";
                MimeType[MimeType["APPLICATION_PICS_RULES"] = 11] = "APPLICATION_PICS_RULES";
                MimeType[MimeType["APPLICATION_PKCS10"] = 12] = "APPLICATION_PKCS10";
                MimeType[MimeType["APPLICATION_PKIX_CRL"] = 13] = "APPLICATION_PKIX_CRL";
                MimeType[MimeType["APPLICATION_POSTSCRIPT"] = 14] = "APPLICATION_POSTSCRIPT";
                MimeType[MimeType["APPLICATION_RTF"] = 15] = "APPLICATION_RTF";
                MimeType[MimeType["APPLICATION_SET_PAYMENT_INITIATION"] = 16] = "APPLICATION_SET_PAYMENT_INITIATION";
                MimeType[MimeType["APPLICATION_SET_REGISTRATION_INITIATION"] = 17] = "APPLICATION_SET_REGISTRATION_INITIATION";
                MimeType[MimeType["APPLICATION_VND_MS_EXCEL"] = 18] = "APPLICATION_VND_MS_EXCEL";
                MimeType[MimeType["APPLICATION_VND_MS_EXCEL_ADDIN_MACROENABLED_12"] = 19] = "APPLICATION_VND_MS_EXCEL_ADDIN_MACROENABLED_12";
                MimeType[MimeType["APPLICATION_VND_MS_EXCEL_SHEET_BINARY_MACROENABLED_12"] = 20] = "APPLICATION_VND_MS_EXCEL_SHEET_BINARY_MACROENABLED_12";
                MimeType[MimeType["APPLICATION_VND_MS_EXCEL_SHEET_MACROENABLED_12"] = 21] = "APPLICATION_VND_MS_EXCEL_SHEET_MACROENABLED_12";
                MimeType[MimeType["APPLICATION_VND_MS_EXCEL_TEMPLATE_MACROENABLED_12"] = 22] = "APPLICATION_VND_MS_EXCEL_TEMPLATE_MACROENABLED_12";
                MimeType[MimeType["APPLICATION_VND_MS_OUTLOOK"] = 23] = "APPLICATION_VND_MS_OUTLOOK";
                MimeType[MimeType["APPLICATION_VND_MS_PKICERTSTORE"] = 24] = "APPLICATION_VND_MS_PKICERTSTORE";
                MimeType[MimeType["APPLICATION_VND_MS_PKISECCAT"] = 25] = "APPLICATION_VND_MS_PKISECCAT";
                MimeType[MimeType["APPLICATION_VND_MS_PKISTL"] = 26] = "APPLICATION_VND_MS_PKISTL";
                MimeType[MimeType["APPLICATION_VND_MS_POWERPOINT"] = 27] = "APPLICATION_VND_MS_POWERPOINT";
                MimeType[MimeType["APPLICATION_VND_MS_POWERPOINT_ADDIN_MACROENABLED_12"] = 28] = "APPLICATION_VND_MS_POWERPOINT_ADDIN_MACROENABLED_12";
                MimeType[MimeType["APPLICATION_VND_MS_POWERPOINT_PRESENTATION_MACROENABLED_12"] = 29] = "APPLICATION_VND_MS_POWERPOINT_PRESENTATION_MACROENABLED_12";
                MimeType[MimeType["APPLICATION_VND_MS_POWERPOINT_SLIDESHOW_MACROENABLED_12"] = 30] = "APPLICATION_VND_MS_POWERPOINT_SLIDESHOW_MACROENABLED_12";
                MimeType[MimeType["APPLICATION_VND_MS_POWERPOINT_TEMPLATE_MACROENABLED_12"] = 31] = "APPLICATION_VND_MS_POWERPOINT_TEMPLATE_MACROENABLED_12";
                MimeType[MimeType["APPLICATION_VND_MS_PROJECT"] = 32] = "APPLICATION_VND_MS_PROJECT";
                MimeType[MimeType["APPLICATION_VND_MS_WORD_DOCUMENT_MACROENABLED_12"] = 33] = "APPLICATION_VND_MS_WORD_DOCUMENT_MACROENABLED_12";
                MimeType[MimeType["APPLICATION_VND_MS_WORKS"] = 34] = "APPLICATION_VND_MS_WORKS";
                MimeType[MimeType["APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_PRESENTATION"] = 35] = "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_PRESENTATION";
                MimeType[MimeType["APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_SLIDESHOW"] = 36] = "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_SLIDESHOW";
                MimeType[MimeType["APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_TEMPLATE"] = 37] = "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_TEMPLATE";
                MimeType[MimeType["APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_SPREADSHEETML_SHEET"] = 38] = "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_SPREADSHEETML_SHEET";
                MimeType[MimeType["APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_SPREADSHEETML_TEMPLATE"] = 39] = "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_SPREADSHEETML_TEMPLATE";
                MimeType[MimeType["APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_WORDPROCESSINGML_DOCUMENT"] = 40] = "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_WORDPROCESSINGML_DOCUMENT";
                MimeType[MimeType["APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_WORDPROCESSINGML_TEMPLATE"] = 41] = "APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_WORDPROCESSINGML_TEMPLATE";
                MimeType[MimeType["APPLICATION_WINHLP"] = 42] = "APPLICATION_WINHLP";
                MimeType[MimeType["APPLICATION_X_BCPIO"] = 43] = "APPLICATION_X_BCPIO";
                MimeType[MimeType["APPLICATION_X_BZIP2"] = 44] = "APPLICATION_X_BZIP2";
                MimeType[MimeType["APPLICATION_X_CDF"] = 45] = "APPLICATION_X_CDF";
                MimeType[MimeType["APPLICATION_X_COMPRESS"] = 46] = "APPLICATION_X_COMPRESS";
                MimeType[MimeType["APPLICATION_X_COMPRESSED"] = 47] = "APPLICATION_X_COMPRESSED";
                MimeType[MimeType["APPLICATION_X_CPIO"] = 48] = "APPLICATION_X_CPIO";
                MimeType[MimeType["APPLICATION_X_CSH"] = 49] = "APPLICATION_X_CSH";
                MimeType[MimeType["APPLICATION_X_DIRECTOR"] = 50] = "APPLICATION_X_DIRECTOR";
                MimeType[MimeType["APPLICATION_X_DVI"] = 51] = "APPLICATION_X_DVI";
                MimeType[MimeType["APPLICATION_X_GTAR"] = 52] = "APPLICATION_X_GTAR";
                MimeType[MimeType["APPLICATION_X_GZIP"] = 53] = "APPLICATION_X_GZIP";
                MimeType[MimeType["APPLICATION_X_HDF"] = 54] = "APPLICATION_X_HDF";
                MimeType[MimeType["APPLICATION_X_INTERNET_SIGNUP"] = 55] = "APPLICATION_X_INTERNET_SIGNUP";
                MimeType[MimeType["APPLICATION_X_IPHONE"] = 56] = "APPLICATION_X_IPHONE";
                MimeType[MimeType["APPLICATION_X_JAVASCRIPT"] = 57] = "APPLICATION_X_JAVASCRIPT";
                MimeType[MimeType["APPLICATION_X_LATEX"] = 58] = "APPLICATION_X_LATEX";
                MimeType[MimeType["APPLICATION_X_MSACCESS"] = 59] = "APPLICATION_X_MSACCESS";
                MimeType[MimeType["APPLICATION_X_MSCARDFILE"] = 60] = "APPLICATION_X_MSCARDFILE";
                MimeType[MimeType["APPLICATION_X_MSCLIP"] = 61] = "APPLICATION_X_MSCLIP";
                MimeType[MimeType["APPLICATION_X_MSDOWNLOAD"] = 62] = "APPLICATION_X_MSDOWNLOAD";
                MimeType[MimeType["APPLICATION_X_MSMEDIAVIEW"] = 63] = "APPLICATION_X_MSMEDIAVIEW";
                MimeType[MimeType["APPLICATION_X_MSMETAFILE"] = 64] = "APPLICATION_X_MSMETAFILE";
                MimeType[MimeType["APPLICATION_X_MSMONEY"] = 65] = "APPLICATION_X_MSMONEY";
                MimeType[MimeType["APPLICATION_X_MSPUBLISHER"] = 66] = "APPLICATION_X_MSPUBLISHER";
                MimeType[MimeType["APPLICATION_X_MSSCHEDULE"] = 67] = "APPLICATION_X_MSSCHEDULE";
                MimeType[MimeType["APPLICATION_X_MSTERMINAL"] = 68] = "APPLICATION_X_MSTERMINAL";
                MimeType[MimeType["APPLICATION_X_MSWRITE"] = 69] = "APPLICATION_X_MSWRITE";
                MimeType[MimeType["APPLICATION_X_PERFMON"] = 70] = "APPLICATION_X_PERFMON";
                MimeType[MimeType["APPLICATION_X_PKCS12"] = 71] = "APPLICATION_X_PKCS12";
                MimeType[MimeType["APPLICATION_X_PKCS7_CERTIFICATES"] = 72] = "APPLICATION_X_PKCS7_CERTIFICATES";
                MimeType[MimeType["APPLICATION_X_PKCS7_CERTREQRESP"] = 73] = "APPLICATION_X_PKCS7_CERTREQRESP";
                MimeType[MimeType["APPLICATION_X_PKCS7_MIME"] = 74] = "APPLICATION_X_PKCS7_MIME";
                MimeType[MimeType["APPLICATION_X_PKCS7_SIGNATURE"] = 75] = "APPLICATION_X_PKCS7_SIGNATURE";
                MimeType[MimeType["APPLICATION_X_SH"] = 76] = "APPLICATION_X_SH";
                MimeType[MimeType["APPLICATION_X_SHAR"] = 77] = "APPLICATION_X_SHAR";
                MimeType[MimeType["APPLICATION_X_STUFFIT"] = 78] = "APPLICATION_X_STUFFIT";
                MimeType[MimeType["APPLICATION_X_SV4CPIO"] = 79] = "APPLICATION_X_SV4CPIO";
                MimeType[MimeType["APPLICATION_X_SV4CRC"] = 80] = "APPLICATION_X_SV4CRC";
                MimeType[MimeType["APPLICATION_X_TAR"] = 81] = "APPLICATION_X_TAR";
                MimeType[MimeType["APPLICATION_X_TCL"] = 82] = "APPLICATION_X_TCL";
                MimeType[MimeType["APPLICATION_X_TEX"] = 83] = "APPLICATION_X_TEX";
                MimeType[MimeType["APPLICATION_X_TEXINFO"] = 84] = "APPLICATION_X_TEXINFO";
                MimeType[MimeType["APPLICATION_X_TROFF"] = 85] = "APPLICATION_X_TROFF";
                MimeType[MimeType["APPLICATION_X_TROFF_MAN"] = 86] = "APPLICATION_X_TROFF_MAN";
                MimeType[MimeType["APPLICATION_X_TROFF_ME"] = 87] = "APPLICATION_X_TROFF_ME";
                MimeType[MimeType["APPLICATION_X_TROFF_MS"] = 88] = "APPLICATION_X_TROFF_MS";
                MimeType[MimeType["APPLICATION_X_USTAR"] = 89] = "APPLICATION_X_USTAR";
                MimeType[MimeType["APPLICATION_X_WAIS_SOURCE"] = 90] = "APPLICATION_X_WAIS_SOURCE";
                MimeType[MimeType["APPLICATION_X_X509_CA_CERT"] = 91] = "APPLICATION_X_X509_CA_CERT";
                MimeType[MimeType["APPLICATION_X_ZIP_COMPRESSED"] = 92] = "APPLICATION_X_ZIP_COMPRESSED";
                MimeType[MimeType["APPLICATION_YND_MS_PKIPKO"] = 93] = "APPLICATION_YND_MS_PKIPKO";
                MimeType[MimeType["APPLICATION_ZIP"] = 94] = "APPLICATION_ZIP";
                MimeType[MimeType["AUDIO_BASIC"] = 95] = "AUDIO_BASIC";
                MimeType[MimeType["AUDIO_MID"] = 96] = "AUDIO_MID";
                MimeType[MimeType["AUDIO_MPEG"] = 97] = "AUDIO_MPEG";
                MimeType[MimeType["AUDIO_X_AIFF"] = 98] = "AUDIO_X_AIFF";
                MimeType[MimeType["AUDIO_X_MPEGURL"] = 99] = "AUDIO_X_MPEGURL";
                MimeType[MimeType["AUDIO_X_PN_REALAUDIO"] = 100] = "AUDIO_X_PN_REALAUDIO";
                MimeType[MimeType["AUDIO_X_WAV"] = 101] = "AUDIO_X_WAV";
                MimeType[MimeType["IMAGE_BMP"] = 102] = "IMAGE_BMP";
                MimeType[MimeType["IMAGE_CIS_COD"] = 103] = "IMAGE_CIS_COD";
                MimeType[MimeType["IMAGE_GIF"] = 104] = "IMAGE_GIF";
                MimeType[MimeType["IMAGE_IEF"] = 105] = "IMAGE_IEF";
                MimeType[MimeType["IMAGE_JPEG"] = 106] = "IMAGE_JPEG";
                MimeType[MimeType["IMAGE_PIPEG"] = 107] = "IMAGE_PIPEG";
                MimeType[MimeType["IMAGE_PNG"] = 108] = "IMAGE_PNG";
                MimeType[MimeType["IMAGE_TIFF"] = 109] = "IMAGE_TIFF";
                MimeType[MimeType["IMAGE_X_CMU_RASTER"] = 110] = "IMAGE_X_CMU_RASTER";
                MimeType[MimeType["IMAGE_X_CMX"] = 111] = "IMAGE_X_CMX";
                MimeType[MimeType["IMAGE_X_ICON"] = 112] = "IMAGE_X_ICON";
                MimeType[MimeType["IMAGE_X_PORTABLE_ANYMAP"] = 113] = "IMAGE_X_PORTABLE_ANYMAP";
                MimeType[MimeType["IMAGE_X_PORTABLE_BITMAP"] = 114] = "IMAGE_X_PORTABLE_BITMAP";
                MimeType[MimeType["IMAGE_X_PORTABLE_GRAYMAP"] = 115] = "IMAGE_X_PORTABLE_GRAYMAP";
                MimeType[MimeType["IMAGE_X_PORTABLE_PIXMAP"] = 116] = "IMAGE_X_PORTABLE_PIXMAP";
                MimeType[MimeType["IMAGE_X_RGB"] = 117] = "IMAGE_X_RGB";
                MimeType[MimeType["IMAGE_X_XBITMAP"] = 118] = "IMAGE_X_XBITMAP";
                MimeType[MimeType["IMAGE_X_XPIXMAP"] = 119] = "IMAGE_X_XPIXMAP";
                MimeType[MimeType["IMAGE_X_XWINDOWDUMP"] = 120] = "IMAGE_X_XWINDOWDUMP";
                MimeType[MimeType["MESSAGE_RFC822"] = 121] = "MESSAGE_RFC822";
                MimeType[MimeType["TEXT_CSS"] = 122] = "TEXT_CSS";
                MimeType[MimeType["TEXT_CSV"] = 123] = "TEXT_CSV";
                MimeType[MimeType["TEXT_H323"] = 124] = "TEXT_H323";
                MimeType[MimeType["TEXT_HTML"] = 125] = "TEXT_HTML";
                MimeType[MimeType["TEXT_IULS"] = 126] = "TEXT_IULS";
                MimeType[MimeType["TEXT_PLAIN"] = 127] = "TEXT_PLAIN";
                MimeType[MimeType["TEXT_RICHTEXT"] = 128] = "TEXT_RICHTEXT";
                MimeType[MimeType["TEXT_SCRIPTLET"] = 129] = "TEXT_SCRIPTLET";
                MimeType[MimeType["TEXT_TAB_SEPARATED_VALUES"] = 130] = "TEXT_TAB_SEPARATED_VALUES";
                MimeType[MimeType["TEXT_WEBVIEWHTML"] = 131] = "TEXT_WEBVIEWHTML";
                MimeType[MimeType["TEXT_X_COMMA_SEPARATED_VALUES"] = 132] = "TEXT_X_COMMA_SEPARATED_VALUES";
                MimeType[MimeType["TEXT_X_COMPONENT"] = 133] = "TEXT_X_COMPONENT";
                MimeType[MimeType["TEXT_X_SETEXT"] = 134] = "TEXT_X_SETEXT";
                MimeType[MimeType["TEXT_X_VCARD"] = 135] = "TEXT_X_VCARD";
                MimeType[MimeType["TEXT_XML"] = 136] = "TEXT_XML";
                MimeType[MimeType["VIDEO_MPEG"] = 137] = "VIDEO_MPEG";
                MimeType[MimeType["VIDEO_QUICKTIME"] = 138] = "VIDEO_QUICKTIME";
                MimeType[MimeType["VIDEO_X_LA_ASF"] = 139] = "VIDEO_X_LA_ASF";
                MimeType[MimeType["VIDEO_X_MS_ASF"] = 140] = "VIDEO_X_MS_ASF";
                MimeType[MimeType["VIDEO_X_MSVIDEO"] = 141] = "VIDEO_X_MSVIDEO";
                MimeType[MimeType["VIDEO_X_SGI_MOVIE"] = 142] = "VIDEO_X_SGI_MOVIE";
                MimeType[MimeType["X_WORLD_X_VRML"] = 143] = "X_WORLD_X_VRML";
            })(MimeType || exports_1("MimeType", MimeType = {}));
            (function (ProcessingStatus) {
                ProcessingStatus[ProcessingStatus["APPROVED"] = 0] = "APPROVED";
                ProcessingStatus[ProcessingStatus["DEFERRED"] = 1] = "DEFERRED";
                ProcessingStatus[ProcessingStatus["NOTAPPROVED"] = 2] = "NOTAPPROVED";
                ProcessingStatus[ProcessingStatus["REJECTED"] = 3] = "REJECTED";
            })(ProcessingStatus || exports_1("ProcessingStatus", ProcessingStatus = {}));
            (function (QuotationType) {
                QuotationType[QuotationType["PERCENT"] = 0] = "PERCENT";
                QuotationType[QuotationType["PIECE"] = 1] = "PIECE";
            })(QuotationType || exports_1("QuotationType", QuotationType = {}));
            (function (RequestReason) {
                RequestReason[RequestReason["DAILY"] = 0] = "DAILY";
                RequestReason[RequestReason["EARNING"] = 1] = "EARNING";
                RequestReason[RequestReason["EARNINGWITHDOC"] = 2] = "EARNINGWITHDOC";
                RequestReason[RequestReason["OTHER"] = 3] = "OTHER";
                RequestReason[RequestReason["PUBLICATION"] = 4] = "PUBLICATION";
                RequestReason[RequestReason["REORGANIZATION"] = 5] = "REORGANIZATION";
            })(RequestReason || exports_1("RequestReason", RequestReason = {}));
            (function (RequestStatus) {
                RequestStatus[RequestStatus["CLOSED"] = 0] = "CLOSED";
                RequestStatus[RequestStatus["DENIED"] = 1] = "DENIED";
                RequestStatus[RequestStatus["INQUIRY"] = 2] = "INQUIRY";
                RequestStatus[RequestStatus["OPEN"] = 3] = "OPEN";
            })(RequestStatus || exports_1("RequestStatus", RequestStatus = {}));
            (function (Salutation) {
                Salutation[Salutation["FEMALE"] = 0] = "FEMALE";
                Salutation[Salutation["MALE"] = 1] = "MALE";
            })(Salutation || exports_1("Salutation", Salutation = {}));
            (function (ScanStatus) {
                ScanStatus[ScanStatus["APPROVED"] = 0] = "APPROVED";
                ScanStatus[ScanStatus["INFECTED"] = 1] = "INFECTED";
                ScanStatus[ScanStatus["NOTAPPROVED"] = 2] = "NOTAPPROVED";
                ScanStatus[ScanStatus["UNNECESSARY"] = 3] = "UNNECESSARY";
            })(ScanStatus || exports_1("ScanStatus", ScanStatus = {}));
            (function (Sector) {
                Sector[Sector["A"] = 0] = "A";
                Sector[Sector["B"] = 1] = "B";
                Sector[Sector["C"] = 2] = "C";
                Sector[Sector["D"] = 3] = "D";
                Sector[Sector["E"] = 4] = "E";
                Sector[Sector["F"] = 5] = "F";
                Sector[Sector["G"] = 6] = "G";
                Sector[Sector["H"] = 7] = "H";
                Sector[Sector["I"] = 8] = "I";
                Sector[Sector["J"] = 9] = "J";
            })(Sector || exports_1("Sector", Sector = {}));
            (function (ValueType) {
                ValueType[ValueType["ARRAY"] = 0] = "ARRAY";
                ValueType[ValueType["BOOLEAN"] = 1] = "BOOLEAN";
                ValueType[ValueType["DATE"] = 2] = "DATE";
                ValueType[ValueType["DATETIME"] = 3] = "DATETIME";
                ValueType[ValueType["DOUBLE"] = 4] = "DOUBLE";
                ValueType[ValueType["INTEGER"] = 5] = "INTEGER";
                ValueType[ValueType["LONG"] = 6] = "LONG";
                ValueType[ValueType["PASSWORD"] = 7] = "PASSWORD";
                ValueType[ValueType["PERCENT"] = 8] = "PERCENT";
                ValueType[ValueType["STRING"] = 9] = "STRING";
            })(ValueType || exports_1("ValueType", ValueType = {}));
        }
    };
});

System.register("ags-client/app/models/code.js", [], function (exports_1, context_1) {
    "use strict";

    var Code;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [],
        execute: function () {
            Code = /** @class */function () {
                function Code(categoryShortName, shortName) {
                    this.categoryShortName = categoryShortName;
                    this.shortName = shortName;
                }
                Code.create = function (shortName) {
                    // this one is only for the compiler, don't use it!
                    return null;
                };
                return Code;
            }();
            exports_1("Code", Code);
        }
    };
});

System.register("ags-client/gen/codes.js", ["ags-client/app/models/code.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var code_1, Country, Currency, ExternalLinks, Language, Role, Rule;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (code_1_1) {
            code_1 = code_1_1;
        }],
        execute: function () {
            Country = /** @class */function (_super) {
                __extends(Country, _super);
                function Country(name) {
                    return _super.call(this, 'COUNTR', name) || this;
                }
                Country.create = function (name) {
                    return new Country(name);
                };
                return Country;
            }(code_1.Code);
            exports_1("Country", Country);
            Currency = /** @class */function (_super) {
                __extends(Currency, _super);
                function Currency(name) {
                    return _super.call(this, 'CURREN', name) || this;
                }
                Currency.create = function (name) {
                    return new Currency(name);
                };
                return Currency;
            }(code_1.Code);
            exports_1("Currency", Currency);
            ExternalLinks = /** @class */function (_super) {
                __extends(ExternalLinks, _super);
                function ExternalLinks(name) {
                    return _super.call(this, 'EXTLNK', name) || this;
                }
                ExternalLinks.create = function (name) {
                    return new ExternalLinks(name);
                };
                return ExternalLinks;
            }(code_1.Code);
            exports_1("ExternalLinks", ExternalLinks);
            Language = /** @class */function (_super) {
                __extends(Language, _super);
                function Language(name) {
                    return _super.call(this, 'LANGUA', name) || this;
                }
                Language.create = function (name) {
                    return new Language(name);
                };
                return Language;
            }(code_1.Code);
            exports_1("Language", Language);
            Role = /** @class */function (_super) {
                __extends(Role, _super);
                function Role(name) {
                    return _super.call(this, 'ROLE', name) || this;
                }
                Role.create = function (name) {
                    return new Role(name);
                };
                return Role;
            }(code_1.Code);
            exports_1("Role", Role);
            Rule = /** @class */function (_super) {
                __extends(Rule, _super);
                function Rule(name) {
                    return _super.call(this, 'RULE', name) || this;
                }
                Rule.create = function (name) {
                    return new Rule(name);
                };
                return Rule;
            }(code_1.Code);
            exports_1("Rule", Rule);
        }
    };
});

System.register("ags-client/ags-client.js", ["ags-client/app/constants.js", "ags-client/app/commons.js", "ags-client/app/components.js", "ags-client/app/directives.js", "ags-client/app/models.js", "ags-client/app/pipes.js", "ags-client/app/services.js", "ags-client/app/validators.js", "ags-client/app/views.js", "ags-client/app/viewsearch.js", "ags-client/gen/codes.js", "ags-client/gen/i18n/translation_constants.js", "ags-client/gen/services.js", "ags-client/gen/enums.js", "ags-client/gen/components.js", "ags-client/gen/viewmodels.js", "ags-client/gen/viewsearch.js", "ags-client/app/commons/enum_registry.js", "ags-client/app/commons/code_registry.js", "ags-client/app/commons/html.js", "ags-client/gen/enums.js", "ags-client/gen/codes.js"], function (exports_1, context_1) {
    "use strict";

    var enum_registry_1, code_registry_1, html_1, AgsEnums, AgsCodes, AgsClientConfiguration, AgsClient;
    var __moduleName = context_1 && context_1.id;
    var exportedNames_1 = {
        "AgsClientConfiguration": true,
        "AgsClient": true
    };
    function exportStar_1(m) {
        var exports = {};
        for (var n in m) {
            if (n !== "default" && !exportedNames_1.hasOwnProperty(n)) exports[n] = m[n];
        }
        exports_1(exports);
    }
    return {
        setters: [function (constants_1_1) {
            exportStar_1(constants_1_1);
        }, function (commons_1_1) {
            exportStar_1(commons_1_1);
        }, function (components_1_1) {
            exportStar_1(components_1_1);
        }, function (directives_1_1) {
            exportStar_1(directives_1_1);
        }, function (models_1_1) {
            exportStar_1(models_1_1);
        }, function (pipes_1_1) {
            exportStar_1(pipes_1_1);
        }, function (services_1_1) {
            exportStar_1(services_1_1);
        }, function (validators_1_1) {
            exportStar_1(validators_1_1);
        }, function (views_1_1) {
            exportStar_1(views_1_1);
        }, function (viewsearch_1_1) {
            exportStar_1(viewsearch_1_1);
        }, function (codes_1_1) {
            exportStar_1(codes_1_1);
        }, function (translation_constants_1_1) {
            exportStar_1(translation_constants_1_1);
        }, function (services_2_1) {
            exportStar_1(services_2_1);
        }, function (enums_1_1) {
            exportStar_1(enums_1_1);
        }, function (components_2_1) {
            exportStar_1(components_2_1);
        }, function (viewmodels_1_1) {
            exportStar_1(viewmodels_1_1);
        }, function (viewsearch_2_1) {
            exportStar_1(viewsearch_2_1);
        }, function (enum_registry_1_1) {
            enum_registry_1 = enum_registry_1_1;
        }, function (code_registry_1_1) {
            code_registry_1 = code_registry_1_1;
        }, function (html_1_1) {
            html_1 = html_1_1;
        }, function (AgsEnums_1) {
            AgsEnums = AgsEnums_1;
        }, function (AgsCodes_1) {
            AgsCodes = AgsCodes_1;
        }],
        execute: function () {
            AgsClientConfiguration = /** @class */function () {
                function AgsClientConfiguration() {}
                return AgsClientConfiguration;
            }();
            exports_1("AgsClientConfiguration", AgsClientConfiguration);
            AgsClient = /** @class */function () {
                function AgsClient(_configuration, _backendService, _translationService, _navigationService, _authenticationService) {
                    this._configuration = _configuration;
                    this._backendService = _backendService;
                    this._translationService = _translationService;
                    this._navigationService = _navigationService;
                    this._authenticationService = _authenticationService;
                }
                AgsClient.prototype._init = function () {
                    var _this = this;
                    this._backendService.serverApiBase = this._configuration.serviceApiBase;
                    this._authenticationService.afterLoginView = this._configuration.afterLoginView;
                    this._authenticationService.afterLogoutView = this._configuration.afterLogoutView;
                    this._authenticationService.initialize().then(function (a) {
                        _this._registerEnums();
                        _this._registerCodes();
                        _this._initializeTranslations();
                    });
                    window.addEventListener('resize', function () {
                        _this.screenSizeChanged(html_1.screenWidth());
                    });
                };
                AgsClient.prototype.screenSizeChanged = function (width) {};
                AgsClient.prototype._resolveLanguage = function () {
                    var location = window.location.href;
                    return location.match(/\/(de|fr|it|en)\.html/)[1];
                };
                AgsClient.prototype._registerEnums = function () {
                    enum_registry_1.EnumRegistry.register('Salutation', AgsEnums.Salutation);
                    enum_registry_1.EnumRegistry.register('InstrumentGroup', AgsEnums.InstrumentGroup);
                    enum_registry_1.EnumRegistry.register('InstrumentType', AgsEnums.InstrumentType);
                    enum_registry_1.EnumRegistry.register('Canton', AgsEnums.Canton);
                };
                AgsClient.prototype._registerCodes = function () {
                    code_registry_1.CodeRegistry.register('Language', AgsCodes.Language);
                    code_registry_1.CodeRegistry.register('Country', AgsCodes.Country);
                    code_registry_1.CodeRegistry.register('Currency', AgsCodes.Currency);
                };
                AgsClient.prototype._initializeTranslations = function () {
                    var _this = this;
                    var language = this._resolveLanguage();
                    this._translationService.initialize(language, [this._configuration.name + '/gen/i18n/messages_' + language + '.json']).then(function () {
                        _this._authenticationService.initialize().then(function () {
                            _this._initializeNavigation(function (model) {
                                _this._navigationService.model = model;
                            });
                        });
                    });
                };
                AgsClient.prototype._initializeNavigation = function (callback) {
                    return callback(null);
                };
                Object.defineProperty(AgsClient.prototype, "translationService", {
                    get: function () {
                        return this._translationService;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AgsClient.prototype, "navigationService", {
                    get: function () {
                        return this._navigationService;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AgsClient.prototype, "navigationHidden", {
                    get: function () {
                        return this._navigationService.model === null || this._navigationService.hidden;
                    },
                    enumerable: false,
                    configurable: true
                });
                return AgsClient;
            }();
            exports_1("AgsClient", AgsClient);
        }
    };
});

System.register("ict-external-client/app/services/application_service.js", ["angular2/core.js", "ict-external-client/gen/services/abstract_application_service.js", "ags-client/ags-client.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var core_1, abstract_application_service_1, ags_client_1, ags_client_2, ApplicationService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (abstract_application_service_1_1) {
            abstract_application_service_1 = abstract_application_service_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
            ags_client_2 = ags_client_1_1;
        }],
        execute: function () {
            ApplicationService = /** @class */function (_super) {
                __extends(ApplicationService, _super);
                function ApplicationService(backendService) {
                    return _super.call(this, backendService) || this;
                }
                ApplicationService.prototype.cachedSystemParameters = function () {
                    var _this = this;
                    if (!this._systemParameters) {
                        this._systemParameters = new Promise(function (resolve) {
                            _this.systemParameters().subscribe(function (response) {
                                if (response.status === ags_client_2.JsonResponseStatus.SUCCESS) {
                                    resolve(response.data);
                                }
                            });
                        });
                    }
                    return this._systemParameters;
                };
                ApplicationService = __decorate([core_1.Injectable(), core_1.Inject(ags_client_1.BackendService), __metadata("design:paramtypes", [ags_client_1.BackendService])], ApplicationService);
                return ApplicationService;
            }(abstract_application_service_1.AbstractApplicationService);
            exports_1("ApplicationService", ApplicationService);
        }
    };
});

System.register("ict-external-client/app/services/security_search_service.js", ["angular2/core.js", "angular2/http.js", "rxjs/Observable.js", "ags-client/ags-client.js", "ict-external-client/gen/viewmodels/security_search_result_view_model.js", "ict-external-client/app/services/application_service.js"], function (exports_1, context_1) {
    "use strict";

    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function (resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
    var __generator = this && this.__generator || function (thisArg, body) {
        var _ = { label: 0, sent: function () {
                if (t[0] & 1) throw t[1];return t[1];
            }, trys: [], ops: [] },
            f,
            y,
            t,
            g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
            return this;
        }), g;
        function verb(n) {
            return function (v) {
                return step([n, v]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (g && (g = 0, op[0] && (_ = 0)), _) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:case 1:
                        t = op;break;
                    case 4:
                        _.label++;return { value: op[1], done: false };
                    case 5:
                        _.label++;y = op[1];op = [0];continue;
                    case 7:
                        op = _.ops.pop();_.trys.pop();continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];t = op;break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];_.ops.push(op);break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [6, e];y = 0;
            } finally {
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];return { value: op[0] ? op[1] : void 0, done: true };
        }
    };
    var core_1, http_1, Observable_1, ags_client_1, security_search_result_view_model_1, application_service_1, SecuritySearchService;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (core_1_1) {
            core_1 = core_1_1;
        }, function (http_1_1) {
            http_1 = http_1_1;
        }, function (Observable_1_1) {
            Observable_1 = Observable_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }, function (security_search_result_view_model_1_1) {
            security_search_result_view_model_1 = security_search_result_view_model_1_1;
        }, function (application_service_1_1) {
            application_service_1 = application_service_1_1;
        }],
        execute: function () {
            SecuritySearchService = /** @class */function () {
                function SecuritySearchService(http, applicationService) {
                    this.http = http;
                    this.applicationService = applicationService;
                    this.baseUrl = "/lsi/api";
                    this.maxResults = 100;
                    this.countryIds = {
                        CH: 169,
                        DE: 183,
                        FR: 202,
                        GB: 204,
                        IT: 237,
                        JP: 241,
                        LU: 261,
                        US: 357
                    };
                    this.currencyIds = {
                        CHF: 432,
                        EUR: 461,
                        GBP: 466,
                        JPY: 499,
                        USD: 611
                    };
                    // XXX It would be good if the generated enums.ts included the id
                    this.categoryIds = {
                        BOND: 646,
                        COINBULL: 647,
                        CURRNOTE: 648,
                        DEVT: 649,
                        FUND: 650,
                        LIBOSWAP: 651,
                        OPTION: 652,
                        SHARE: 653
                    };
                    this.typeIds = {
                        BOND_BOND: 680,
                        BOND_CONVERTABLE: 681,
                        BOND_OPTION: 682,
                        COINBULL_COINGOLD: 700,
                        COINBULL_GOLD: 701,
                        COINBULL_PALLADIUM: 702,
                        COINBULL_PLATINUM: 703,
                        COINBULL_SILVER: 704,
                        CURRNOTE_CURRENCY: 697,
                        CURRNOTE_CURRYEAR: 696,
                        CURRNOTE_TOKEN: 5164,
                        DEVT_COMBINEDPRODUCT: 693,
                        DEVT_FUNDSIMILARASSET: 694,
                        DEVT_INDEXBASKET: 695,
                        FUND_ACCUMULATION: 690,
                        FUND_DISTRIBUTION: 691,
                        FUND_REALESTATE: 692,
                        LIBOSWAP_LIBOR: 698,
                        LIBOSWAP_SWAP: 699,
                        OPTION_CALL: 705,
                        OPTION_PHANTOM: 706,
                        OPTION_PUT: 707,
                        SHARE_BEARERCERT: 683,
                        SHARE_BONUS: 684,
                        SHARE_COMMON: 685,
                        SHARE_COOP: 3689,
                        SHARE_LIMITED: 3688,
                        SHARE_LIMITEDOLD: 4701,
                        SHARE_NOMINAL: 686,
                        SHARE_PARTCERT: 687,
                        SHARE_PREFERRED: 688,
                        SHARE_TRANSFERABLE: 689
                    };
                }
                SecuritySearchService_1 = SecuritySearchService;
                SecuritySearchService.requestOptions = function () {
                    return {
                        headers: new http_1.Headers({
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        })
                    };
                };
                SecuritySearchService.prototype.postJson = function (url, data, deserializationCallback) {
                    var _this = this;
                    return new Observable_1.Observable(function (subscriber) {
                        _this.http.post(_this.baseUrl + url, JSON.stringify(data), SecuritySearchService_1.requestOptions()).subscribe(function (response) {
                            subscriber.next(deserializationCallback(response.json()));
                            subscriber.complete();
                        }, function (error) {
                            if (error.status === 403) {
                                subscriber.next(ags_client_1.JsonResponse.forbidden());
                            } else {
                                subscriber.next(ags_client_1.JsonResponse.unknownError());
                            }
                            subscriber.complete();
                            console.log(error);
                        });
                    });
                };
                SecuritySearchService.prototype.searchCriteriaOf = function (request) {
                    var res = {
                        max: this.maxResults,
                        fetch: request.size,
                        offset: request.from
                    };
                    if (ags_client_1.isPresent(request.valorNumber)) {
                        res['vn'] = request.valorNumber;
                    }
                    if (ags_client_1.isPresent(request.isin)) {
                        res['isin'] = request.isin;
                    }
                    if (ags_client_1.isPresent(request.nsin)) {
                        res['nsin'] = request.nsin;
                    }
                    if (ags_client_1.isPresent(request.name)) {
                        res['text'] = request.name;
                    }
                    if (ags_client_1.isPresent(request.institution)) {
                        res['institution'] = request.institution;
                    }
                    if (ags_client_1.isPresent(request.instrument)) {
                        res['name'] = request.instrument;
                    }
                    if (ags_client_1.isPresent(request.instrumentGroup)) {
                        var name_1 = ags_client_1.InstrumentGroup[request.instrumentGroup];
                        if (ags_client_1.isPresent(this.categoryIds[name_1])) {
                            res['categoryId'] = this.categoryIds[name_1];
                        } else {
                            res['categoryId'] = 0;
                        }
                    }
                    if (ags_client_1.isPresent(request.instrumentType)) {
                        var name_2 = ags_client_1.InstrumentType[request.instrumentType];
                        if (ags_client_1.isPresent(this.typeIds[name_2])) {
                            res['typeId'] = this.typeIds[name_2];
                        } else {
                            res['typeId'] = 0;
                        }
                    }
                    if (ags_client_1.isPresent(request.country)) {
                        var name_3 = request.country.shortName;
                        if (ags_client_1.isPresent(this.countryIds[name_3])) {
                            res['countryId'] = this.countryIds[name_3];
                        } else {
                            res['countryId'] = 0;
                        }
                    }
                    if (ags_client_1.isPresent(request.currency)) {
                        var name_4 = request.currency.shortName;
                        if (ags_client_1.isPresent(this.currencyIds[name_4])) {
                            res['currencyId'] = this.currencyIds[name_4];
                        } else {
                            res['currencyId'] = 0;
                        }
                    }
                    if (ags_client_1.isPresent(request.issueYear)) {
                        res['issueYear'] = request.issueYear;
                    }
                    if (ags_client_1.isPresent(request.interestRate)) {
                        res['interestRate'] = request.interestRate;
                    }
                    if (ags_client_1.isPresent(request.redemptionYear)) {
                        res['redemptionYear'] = request.redemptionYear;
                    }
                    if (ags_client_1.isPresent(request.iup)) {
                        res['iup'] = request.iup;
                    }
                    if (ags_client_1.isPresent(request.bfp)) {
                        res['bfp'] = request.bfp;
                    }
                    if (ags_client_1.isPresent(request.variableInterestRate)) {
                        res['variableInterestRate'] = request.variableInterestRate;
                    }
                    if (ags_client_1.isPresent(request.year)) {
                        res['year'] = request.year;
                    }
                    if (ags_client_1.isPresent(request.referenceDate)) {
                        res['referenceDate'] = request.referenceDate.toISOString();
                    }
                    if (ags_client_1.isPresent(request.language)) {
                        res['lang'] = request.language;
                    }
                    // Note: the following fields available in /lsi/api/security are not
                    // available in SearchSecuritySearchCriteria:
                    //
                    // * "schema"
                    // * "id"
                    // * "gk"
                    // * "published"
                    // * "quoted"
                    // * "searchId"
                    // * "sin"
                    return res;
                };
                SecuritySearchService.prototype.searchResultItemOf = function (item) {
                    var res = new security_search_result_view_model_1.SecuritySearchResultViewModel();
                    if (ags_client_1.isPresent(item['id'])) {
                        res.id = item['id'];
                    }
                    if (ags_client_1.isPresent(item['vn'])) {
                        res.valorNumber = item['vn'];
                    }
                    if (ags_client_1.isPresent(item['isin'])) {
                        res.isin = item['isin'];
                    }
                    if (ags_client_1.isPresent(item['nsin'])) {
                        res.nsin = item['nsin'];
                    }
                    if (ags_client_1.isPresent(item['institution'])) {
                        res.institution = item['institution'];
                    }
                    if (ags_client_1.isPresent(item['name'])) {
                        res.instrument = item['name'];
                    }
                    if (ags_client_1.isPresent(item['categoryName'])) {
                        res.instrumentGroup = ags_client_1.enumNumberValue(ags_client_1.InstrumentGroup, item['categoryName']);
                    }
                    if (ags_client_1.isPresent(item['typeName'])) {
                        res.instrumentType = ags_client_1.enumNumberValue(ags_client_1.InstrumentType, item['typeName'].replaceAll('.', '_'));
                    }
                    if (ags_client_1.isPresent(item['countryName'])) {
                        res.country = new ags_client_1.Country(item['countryName']);
                    }
                    if (ags_client_1.isPresent(item['currencyName'])) {
                        res.currency = new ags_client_1.Currency(item['currencyName']);
                    }
                    return res;
                    // Note: the items in the response include a lot of unused overhead:
                    //
                    // * "schema"
                    // * "id"
                    // * "gk"
                    // * "countryId"
                    // * "countryDescription"
                    // * "currencyId"
                    // * "currencyDescription"
                    // * "categoryId"
                    // * "categoryDescription"
                    // * "typeId"
                    // * "typeDescription"
                    // * "quoted"
                    // * "published"
                };
                SecuritySearchService.prototype.search = function (request) {
                    var _this = this;
                    return this.postJson('/security', this.searchCriteriaOf(request), function (response) {
                        var data = Array();
                        if (ags_client_1.isPresent(response.security)) {
                            response.security.forEach(function (item) {
                                data.push(_this.searchResultItemOf(item));
                            });
                        }
                        return ags_client_1.JsonResponse.deserialize({ error: "", status: "", totalItems: response.total }, data);
                    });
                };
                SecuritySearchService.prototype.init = function () {
                    var _this = this;
                    this.loadCountries();
                    this.loadCurrencies();
                    this.applicationService.cachedSystemParameters().then(function (systemParameters) {
                        _this.maxResults = systemParameters.maxSearchResults;
                    });
                };
                SecuritySearchService.prototype.loadCountries = function () {
                    return __awaiter(this, void 0, void 0, function () {
                        var handle;
                        var _this = this;
                        return __generator(this, function (_a) {
                            handle = function (response) {
                                var map = {};
                                response.country.forEach(function (item) {
                                    map[item.name] = item.id;
                                });
                                _this.countryIds = map;
                            };
                            this.http.post(this.baseUrl + '/country', '{}', SecuritySearchService_1.requestOptions()).subscribe(function (response) {
                                handle(response.json());
                            }, function (error) {
                                console.log(error);
                            });
                            return [2 /*return*/];
                        });
                    });
                };
                SecuritySearchService.prototype.loadCurrencies = function () {
                    return __awaiter(this, void 0, void 0, function () {
                        var handle;
                        var _this = this;
                        return __generator(this, function (_a) {
                            handle = function (response) {
                                var map = {};
                                response.currency.forEach(function (item) {
                                    map[item.name] = item.id;
                                });
                                _this.currencyIds = map;
                            };
                            this.http.post(this.baseUrl + '/currency', '{}', SecuritySearchService_1.requestOptions()).subscribe(function (response) {
                                handle(response.json());
                            }, function (error) {
                                console.log(error);
                            });
                            return [2 /*return*/];
                        });
                    });
                };
                var SecuritySearchService_1;
                SecuritySearchService = SecuritySearchService_1 = __decorate([core_1.Injectable(), core_1.Inject(http_1.Http), __metadata("design:paramtypes", [http_1.Http, application_service_1.ApplicationService])], SecuritySearchService);
                return SecuritySearchService;
            }();
            exports_1("SecuritySearchService", SecuritySearchService);
        }
    };
});

System.register("ict-external-client/ict-external-client.js", ["ts-polyfill/lib/es2015-symbol.js", "ts-polyfill/lib/es2015-symbol-wellknown.js", "angular2/platform/browser.js", "angular2/core.js", "angular2/http.js", "angular2/router.js", "ags-client/ags-client.js", "ict-core-client/ict-core-client.js", "ict-external-client/app/services/application_service.js", "ict-external-client/app/services/publication_service.js", "ict-external-client/app/services/security_service.js", "ict-external-client/app/services/newsletter_service.js", "ict-external-client/app/services/request_service.js", "ict-external-client/app/services/earning_declares_service.js", "ict-external-client/app/services/encode_password_service.js", "ict-external-client/app/services/xml_service.js", "ict-external-client/app/services/report_service.js", "ict-external-client/app/services/request_dump_service.js", "ict-external-client/gen/i18n/translation_constants.js", "ict-external-client/gen/views.js", "ict-external-client/app/services/security_search_service.js"], function (exports_1, context_1) {
    "use strict";

    var __extends = this && this.__extends || function () {
        var extendStatics = function (d, b) {
            extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
                d.__proto__ = b;
            } || function (d, b) {
                for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
            d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var __metadata = this && this.__metadata || function (k, v) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
    };
    var browser_1, core_1, core_2, http_1, router_1, ags_client_1, ict_core_client_1, application_service_1, publication_service_1, security_service_1, newsletter_service_1, request_service_1, earning_declares_service_1, encode_password_service_1, xml_service_1, report_service_1, request_dump_service_1, translation_constants_1, Views, ict_core_client_2, security_search_service_1, IctExternalClient;
    var __moduleName = context_1 && context_1.id;
    return {
        setters: [function (_1) {}, function (_2) {}, function (browser_1_1) {
            browser_1 = browser_1_1;
        }, function (core_1_1) {
            core_1 = core_1_1;
            core_2 = core_1_1;
        }, function (http_1_1) {
            http_1 = http_1_1;
        }, function (router_1_1) {
            router_1 = router_1_1;
        }, function (ags_client_1_1) {
            ags_client_1 = ags_client_1_1;
        }, function (ict_core_client_1_1) {
            ict_core_client_1 = ict_core_client_1_1;
            ict_core_client_2 = ict_core_client_1_1;
        }, function (application_service_1_1) {
            application_service_1 = application_service_1_1;
        }, function (publication_service_1_1) {
            publication_service_1 = publication_service_1_1;
        }, function (security_service_1_1) {
            security_service_1 = security_service_1_1;
        }, function (newsletter_service_1_1) {
            newsletter_service_1 = newsletter_service_1_1;
        }, function (request_service_1_1) {
            request_service_1 = request_service_1_1;
        }, function (earning_declares_service_1_1) {
            earning_declares_service_1 = earning_declares_service_1_1;
        }, function (encode_password_service_1_1) {
            encode_password_service_1 = encode_password_service_1_1;
        }, function (xml_service_1_1) {
            xml_service_1 = xml_service_1_1;
        }, function (report_service_1_1) {
            report_service_1 = report_service_1_1;
        }, function (request_dump_service_1_1) {
            request_dump_service_1 = request_dump_service_1_1;
        }, function (translation_constants_1_1) {
            translation_constants_1 = translation_constants_1_1;
        }, function (Views_1) {
            Views = Views_1;
        }, function (security_search_service_1_1) {
            security_search_service_1 = security_search_service_1_1;
        }],
        execute: function () {
            eval('new Clipboard(".clipboard")');
            IctExternalClient = /** @class */function (_super) {
                __extends(IctExternalClient, _super);
                function IctExternalClient(backendService, translationService, navigationService, authenticationService, securitySearchService, _applicationService, _applicationRef, _router) {
                    var _this = _super.call(this, {
                        name: 'ict-external-client',
                        serviceApiBase: '/extern/api',
                        afterLoginView: Views.REQUEST_VIEW,
                        afterLogoutView: Views.LOGIN_VIEW
                    }, backendService, translationService, navigationService, authenticationService) || this;
                    _this._applicationService = _applicationService;
                    _this._applicationRef = _applicationRef;
                    _this._router = _router;
                    _router.subscribe(function () {
                        _this._applicationRef.tick();
                        setTimeout(function () {
                            _this._applicationRef.tick();
                        }, 100);
                    });
                    _this._init();
                    var self = _this;
                    var mobileMenuElement = document.querySelector('a.nav-mobile-menu');
                    if (mobileMenuElement) {
                        mobileMenuElement.addEventListener('click', function (event) {
                            setTimeout(function () {
                                if (mobileMenuElement.getAttribute('aria-expanded') === 'true') {
                                    self.navigationService.show();
                                } else {
                                    self.navigationService.hide();
                                }
                            }, 100);
                        });
                    }
                    securitySearchService.init();
                    return _this;
                }
                IctExternalClient.prototype.screenSizeChanged = function (width) {
                    this.navigationService.widthChanged(width);
                };
                IctExternalClient.prototype._registerEnums = function () {
                    _super.prototype._registerEnums.call(this);
                    ags_client_1.EnumRegistry.register('RequestReason', ict_core_client_2.RequestReason);
                    ags_client_1.EnumRegistry.register('RequestStatus', ict_core_client_2.RequestStatus);
                    ags_client_1.EnumRegistry.register('EarningDeclareStatus', ict_core_client_2.EarningDeclareStatus);
                    ags_client_1.EnumRegistry.register('PublicationType', ict_core_client_2.PublicationType);
                    ags_client_1.EnumRegistry.register('PublicationCategory', ict_core_client_2.PublicationCategory);
                    ags_client_1.EnumRegistry.register('AnnualReportRequested', ict_core_client_2.AnnualReportRequested);
                    ags_client_1.EnumRegistry.register('ImportStatus', ict_core_client_2.ImportStatus);
                    ags_client_1.EnumRegistry.register('LogLevel', ict_core_client_2.LogLevel);
                };
                IctExternalClient.prototype._registerCodes = function () {
                    _super.prototype._registerCodes.call(this);
                    ags_client_1.CodeRegistry.register('ExportType', ict_core_client_2.ExportType);
                    ags_client_1.CodeRegistry.register('XSDType', ict_core_client_2.XSDType);
                    ags_client_1.CodeRegistry.register('ImportType', ict_core_client_2.ImportType);
                    ags_client_1.CodeRegistry.register('ImportSource', ict_core_client_2.ImportSource);
                    ags_client_1.CodeRegistry.register('Token', ict_core_client_2.Token);
                };
                IctExternalClient.prototype._initializeNavigation = function (callback) {
                    var _this = this;
                    this._applicationService.cachedSystemParameters().then(function (systemParameters) {
                        var navigation = new ags_client_1.NavigationModel();
                        navigation.hidden = ags_client_1.screenWidth() < 768;
                        var ratelist = {
                            name: _this.translationService.translate(translation_constants_1.TranslationConstants.MENU_RATELIST),
                            target: Views.RATELIST_VIEW,
                            childs: []
                        };
                        navigation.entries = [ratelist, {
                            name: _this.translationService.translate(translation_constants_1.TranslationConstants.MENU_REQUESTS),
                            target: Views.REQUEST_VIEW,
                            security: Views.VIEW_SECURITY[Views.REQUEST_VIEW]
                        }, {
                            name: _this.translationService.translate(translation_constants_1.TranslationConstants.MENU_REQUEST),
                            target: Views.REQUEST_CREATE_VIEW,
                            security: Views.VIEW_SECURITY[Views.REQUEST_CREATE_VIEW]
                        }, {
                            name: _this.translationService.translate(translation_constants_1.TranslationConstants.MENU_EARNINGS),
                            target: Views.EARNING_VIEW,
                            security: Views.VIEW_SECURITY[Views.EARNING_VIEW]
                        }, {
                            name: _this.translationService.translate(translation_constants_1.TranslationConstants.MENU_EARNING),
                            target: Views.EARNING_CREATE_VIEW,
                            security: Views.VIEW_SECURITY[Views.EARNING_CREATE_VIEW]
                        }, {
                            name: _this.translationService.translate(translation_constants_1.TranslationConstants.MENU_ACCOUNT),
                            target: Views.ACCOUNT_VIEW,
                            security: Views.VIEW_SECURITY[Views.ACCOUNT_VIEW]
                        }, {
                            name: _this.translationService.translate(translation_constants_1.TranslationConstants.MENU_SEARCH),
                            target: Views.SEARCH_VIEW
                        }, {
                            name: _this.translationService.translate(translation_constants_1.TranslationConstants.MENU_NEWSLETTER),
                            target: Views.NEWSLETTER_VIEW
                        }, {
                            name: _this.translationService.translate(translation_constants_1.TranslationConstants.MENU_REPORT),
                            target: Views.REPORT_VIEW,
                            security: Views.VIEW_SECURITY[Views.REPORT_VIEW]
                        }, {
                            name: _this.translationService.translate(translation_constants_1.TranslationConstants.MENU_XML),
                            target: Views.XML_VIEW
                        }, {
                            name: _this.translationService.translate(translation_constants_1.TranslationConstants.MENU_EWS_REQUEST_DUMP),
                            target: Views.REQUEST_DUMP_VIEW,
                            security: Views.VIEW_SECURITY[Views.REQUEST_DUMP_VIEW]
                        }];
                        var currentYear = new Date().getFullYear();
                        var firstYear = currentYear - systemParameters.archiveYearsInactive;
                        for (var i = currentYear; i > firstYear; i--) {
                            ratelist.childs.push({
                                name: _this.translationService.translate(translation_constants_1.TranslationConstants.MENU_RATELIST_YEAR, { year: i.toString() }),
                                target: Views.RATELIST_YEAR_VIEW,
                                params: { year: i }
                            });
                        }
                        callback(navigation);
                    });
                };
                IctExternalClient = __decorate([core_2.Component({
                    selector: 'ict-external-client',
                    templateUrl: 'ict-external-client/ict-external-client.html',
                    directives: [ags_client_1.AGS_DIRECTIVES, router_1.ROUTER_DIRECTIVES, ags_client_1.NavigationComponent, ags_client_1.ConfirmationDialogComponent]
                }), router_1.RouteConfig(Views.ROUTES.concat([{ path: 'activate/:login/:code', component: Views.LoginView, as: 'LoginViewActivate' }, { path: 'lost/:login/:code', component: Views.LoginView, as: 'LoginViewLost' }])), __metadata("design:paramtypes", [ags_client_1.BackendService, ags_client_1.TranslationService, ags_client_1.NavigationService, ags_client_1.AuthenticationService, security_search_service_1.SecuritySearchService, application_service_1.ApplicationService, core_2.ApplicationRef, router_1.Router])], IctExternalClient);
                return IctExternalClient;
            }(ags_client_1.AgsClient);
            exports_1("IctExternalClient", IctExternalClient);
            core_1.enableProdMode();
            browser_1.bootstrap(IctExternalClient, [router_1.ROUTER_PROVIDERS, http_1.HTTP_PROVIDERS, core_2.provide(router_1.LocationStrategy, { useClass: router_1.HashLocationStrategy }), ags_client_1.AccountService, ags_client_1.AlertService, application_service_1.ApplicationService, ags_client_1.AuthenticationService, ags_client_1.BackendService, ags_client_1.CodeService, ags_client_1.ConfirmationService, ict_core_client_1.CoreGadgetService, earning_declares_service_1.EarningDeclaresService, encode_password_service_1.EncodePasswordService, ags_client_1.LostPasswordService, ags_client_1.NavigationService, newsletter_service_1.NewsletterService, publication_service_1.PublicationService, ags_client_1.RegistrationService, report_service_1.ReportService, request_dump_service_1.RequestDumpService, request_service_1.RequestService, security_search_service_1.SecuritySearchService, security_service_1.SecurityService, ags_client_1.TranslationService, xml_service_1.XmlService]);
        }
    };
});
